(function(scope){
'use strict';

function F(arity, fun, wrapper) {
  wrapper.a = arity;
  wrapper.f = fun;
  return wrapper;
}

function F2(fun) {
  return F(2, fun, function(a) { return function(b) { return fun(a,b); }; })
}
function F3(fun) {
  return F(3, fun, function(a) {
    return function(b) { return function(c) { return fun(a, b, c); }; };
  });
}
function F4(fun) {
  return F(4, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return fun(a, b, c, d); }; }; };
  });
}
function F5(fun) {
  return F(5, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return fun(a, b, c, d, e); }; }; }; };
  });
}
function F6(fun) {
  return F(6, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return fun(a, b, c, d, e, f); }; }; }; }; };
  });
}
function F7(fun) {
  return F(7, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return fun(a, b, c, d, e, f, g); }; }; }; }; }; };
  });
}
function F8(fun) {
  return F(8, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return function(h) {
    return fun(a, b, c, d, e, f, g, h); }; }; }; }; }; }; };
  });
}
function F9(fun) {
  return F(9, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return function(h) { return function(i) {
    return fun(a, b, c, d, e, f, g, h, i); }; }; }; }; }; }; }; };
  });
}

function A2(fun, a, b) {
  return fun.a === 2 ? fun.f(a, b) : fun(a)(b);
}
function A3(fun, a, b, c) {
  return fun.a === 3 ? fun.f(a, b, c) : fun(a)(b)(c);
}
function A4(fun, a, b, c, d) {
  return fun.a === 4 ? fun.f(a, b, c, d) : fun(a)(b)(c)(d);
}
function A5(fun, a, b, c, d, e) {
  return fun.a === 5 ? fun.f(a, b, c, d, e) : fun(a)(b)(c)(d)(e);
}
function A6(fun, a, b, c, d, e, f) {
  return fun.a === 6 ? fun.f(a, b, c, d, e, f) : fun(a)(b)(c)(d)(e)(f);
}
function A7(fun, a, b, c, d, e, f, g) {
  return fun.a === 7 ? fun.f(a, b, c, d, e, f, g) : fun(a)(b)(c)(d)(e)(f)(g);
}
function A8(fun, a, b, c, d, e, f, g, h) {
  return fun.a === 8 ? fun.f(a, b, c, d, e, f, g, h) : fun(a)(b)(c)(d)(e)(f)(g)(h);
}
function A9(fun, a, b, c, d, e, f, g, h, i) {
  return fun.a === 9 ? fun.f(a, b, c, d, e, f, g, h, i) : fun(a)(b)(c)(d)(e)(f)(g)(h)(i);
}

console.warn('Compiled in DEV mode. Follow the advice at https://elm-lang.org/0.19.1/optimize for better performance and smaller assets.');


var _JsArray_empty = [];

function _JsArray_singleton(value)
{
    return [value];
}

function _JsArray_length(array)
{
    return array.length;
}

var _JsArray_initialize = F3(function(size, offset, func)
{
    var result = new Array(size);

    for (var i = 0; i < size; i++)
    {
        result[i] = func(offset + i);
    }

    return result;
});

var _JsArray_initializeFromList = F2(function (max, ls)
{
    var result = new Array(max);

    for (var i = 0; i < max && ls.b; i++)
    {
        result[i] = ls.a;
        ls = ls.b;
    }

    result.length = i;
    return _Utils_Tuple2(result, ls);
});

var _JsArray_unsafeGet = F2(function(index, array)
{
    return array[index];
});

var _JsArray_unsafeSet = F3(function(index, value, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = array[i];
    }

    result[index] = value;
    return result;
});

var _JsArray_push = F2(function(value, array)
{
    var length = array.length;
    var result = new Array(length + 1);

    for (var i = 0; i < length; i++)
    {
        result[i] = array[i];
    }

    result[length] = value;
    return result;
});

var _JsArray_foldl = F3(function(func, acc, array)
{
    var length = array.length;

    for (var i = 0; i < length; i++)
    {
        acc = A2(func, array[i], acc);
    }

    return acc;
});

var _JsArray_foldr = F3(function(func, acc, array)
{
    for (var i = array.length - 1; i >= 0; i--)
    {
        acc = A2(func, array[i], acc);
    }

    return acc;
});

var _JsArray_map = F2(function(func, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = func(array[i]);
    }

    return result;
});

var _JsArray_indexedMap = F3(function(func, offset, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = A2(func, offset + i, array[i]);
    }

    return result;
});

var _JsArray_slice = F3(function(from, to, array)
{
    return array.slice(from, to);
});

var _JsArray_appendN = F3(function(n, dest, source)
{
    var destLen = dest.length;
    var itemsToCopy = n - destLen;

    if (itemsToCopy > source.length)
    {
        itemsToCopy = source.length;
    }

    var size = destLen + itemsToCopy;
    var result = new Array(size);

    for (var i = 0; i < destLen; i++)
    {
        result[i] = dest[i];
    }

    for (var i = 0; i < itemsToCopy; i++)
    {
        result[i + destLen] = source[i];
    }

    return result;
});



// LOG

var _Debug_log_UNUSED = F2(function(tag, value)
{
	return value;
});

var _Debug_log = F2(function(tag, value)
{
	console.log(tag + ': ' + _Debug_toString(value));
	return value;
});


// TODOS

function _Debug_todo(moduleName, region)
{
	return function(message) {
		_Debug_crash(8, moduleName, region, message);
	};
}

function _Debug_todoCase(moduleName, region, value)
{
	return function(message) {
		_Debug_crash(9, moduleName, region, value, message);
	};
}


// TO STRING

function _Debug_toString_UNUSED(value)
{
	return '<internals>';
}

function _Debug_toString(value)
{
	return _Debug_toAnsiString(false, value);
}

function _Debug_toAnsiString(ansi, value)
{
	if (typeof value === 'function')
	{
		return _Debug_internalColor(ansi, '<function>');
	}

	if (typeof value === 'boolean')
	{
		return _Debug_ctorColor(ansi, value ? 'True' : 'False');
	}

	if (typeof value === 'number')
	{
		return _Debug_numberColor(ansi, value + '');
	}

	if (value instanceof String)
	{
		return _Debug_charColor(ansi, "'" + _Debug_addSlashes(value, true) + "'");
	}

	if (typeof value === 'string')
	{
		return _Debug_stringColor(ansi, '"' + _Debug_addSlashes(value, false) + '"');
	}

	if (typeof value === 'object' && '$' in value)
	{
		var tag = value.$;

		if (typeof tag === 'number')
		{
			return _Debug_internalColor(ansi, '<internals>');
		}

		if (tag[0] === '#')
		{
			var output = [];
			for (var k in value)
			{
				if (k === '$') continue;
				output.push(_Debug_toAnsiString(ansi, value[k]));
			}
			return '(' + output.join(',') + ')';
		}

		if (tag === 'Set_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Set')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Set$toList(value));
		}

		if (tag === 'RBNode_elm_builtin' || tag === 'RBEmpty_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Dict')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Dict$toList(value));
		}

		if (tag === 'Array_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Array')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Array$toList(value));
		}

		if (tag === '::' || tag === '[]')
		{
			var output = '[';

			value.b && (output += _Debug_toAnsiString(ansi, value.a), value = value.b)

			for (; value.b; value = value.b) // WHILE_CONS
			{
				output += ',' + _Debug_toAnsiString(ansi, value.a);
			}
			return output + ']';
		}

		var output = '';
		for (var i in value)
		{
			if (i === '$') continue;
			var str = _Debug_toAnsiString(ansi, value[i]);
			var c0 = str[0];
			var parenless = c0 === '{' || c0 === '(' || c0 === '[' || c0 === '<' || c0 === '"' || str.indexOf(' ') < 0;
			output += ' ' + (parenless ? str : '(' + str + ')');
		}
		return _Debug_ctorColor(ansi, tag) + output;
	}

	if (typeof DataView === 'function' && value instanceof DataView)
	{
		return _Debug_stringColor(ansi, '<' + value.byteLength + ' bytes>');
	}

	if (typeof File !== 'undefined' && value instanceof File)
	{
		return _Debug_internalColor(ansi, '<' + value.name + '>');
	}

	if (typeof value === 'object')
	{
		var output = [];
		for (var key in value)
		{
			var field = key[0] === '_' ? key.slice(1) : key;
			output.push(_Debug_fadeColor(ansi, field) + ' = ' + _Debug_toAnsiString(ansi, value[key]));
		}
		if (output.length === 0)
		{
			return '{}';
		}
		return '{ ' + output.join(', ') + ' }';
	}

	return _Debug_internalColor(ansi, '<internals>');
}

function _Debug_addSlashes(str, isChar)
{
	var s = str
		.replace(/\\/g, '\\\\')
		.replace(/\n/g, '\\n')
		.replace(/\t/g, '\\t')
		.replace(/\r/g, '\\r')
		.replace(/\v/g, '\\v')
		.replace(/\0/g, '\\0');

	if (isChar)
	{
		return s.replace(/\'/g, '\\\'');
	}
	else
	{
		return s.replace(/\"/g, '\\"');
	}
}

function _Debug_ctorColor(ansi, string)
{
	return ansi ? '\x1b[96m' + string + '\x1b[0m' : string;
}

function _Debug_numberColor(ansi, string)
{
	return ansi ? '\x1b[95m' + string + '\x1b[0m' : string;
}

function _Debug_stringColor(ansi, string)
{
	return ansi ? '\x1b[93m' + string + '\x1b[0m' : string;
}

function _Debug_charColor(ansi, string)
{
	return ansi ? '\x1b[92m' + string + '\x1b[0m' : string;
}

function _Debug_fadeColor(ansi, string)
{
	return ansi ? '\x1b[37m' + string + '\x1b[0m' : string;
}

function _Debug_internalColor(ansi, string)
{
	return ansi ? '\x1b[36m' + string + '\x1b[0m' : string;
}

function _Debug_toHexDigit(n)
{
	return String.fromCharCode(n < 10 ? 48 + n : 55 + n);
}


// CRASH


function _Debug_crash_UNUSED(identifier)
{
	throw new Error('https://github.com/elm/core/blob/1.0.0/hints/' + identifier + '.md');
}


function _Debug_crash(identifier, fact1, fact2, fact3, fact4)
{
	switch(identifier)
	{
		case 0:
			throw new Error('What node should I take over? In JavaScript I need something like:\n\n    Elm.Main.init({\n        node: document.getElementById("elm-node")\n    })\n\nYou need to do this with any Browser.sandbox or Browser.element program.');

		case 1:
			throw new Error('Browser.application programs cannot handle URLs like this:\n\n    ' + document.location.href + '\n\nWhat is the root? The root of your file system? Try looking at this program with `elm reactor` or some other server.');

		case 2:
			var jsonErrorString = fact1;
			throw new Error('Problem with the flags given to your Elm program on initialization.\n\n' + jsonErrorString);

		case 3:
			var portName = fact1;
			throw new Error('There can only be one port named `' + portName + '`, but your program has multiple.');

		case 4:
			var portName = fact1;
			var problem = fact2;
			throw new Error('Trying to send an unexpected type of value through port `' + portName + '`:\n' + problem);

		case 5:
			throw new Error('Trying to use `(==)` on functions.\nThere is no way to know if functions are "the same" in the Elm sense.\nRead more about this at https://package.elm-lang.org/packages/elm/core/latest/Basics#== which describes why it is this way and what the better version will look like.');

		case 6:
			var moduleName = fact1;
			throw new Error('Your page is loading multiple Elm scripts with a module named ' + moduleName + '. Maybe a duplicate script is getting loaded accidentally? If not, rename one of them so I know which is which!');

		case 8:
			var moduleName = fact1;
			var region = fact2;
			var message = fact3;
			throw new Error('TODO in module `' + moduleName + '` ' + _Debug_regionToString(region) + '\n\n' + message);

		case 9:
			var moduleName = fact1;
			var region = fact2;
			var value = fact3;
			var message = fact4;
			throw new Error(
				'TODO in module `' + moduleName + '` from the `case` expression '
				+ _Debug_regionToString(region) + '\n\nIt received the following value:\n\n    '
				+ _Debug_toString(value).replace('\n', '\n    ')
				+ '\n\nBut the branch that handles it says:\n\n    ' + message.replace('\n', '\n    ')
			);

		case 10:
			throw new Error('Bug in https://github.com/elm/virtual-dom/issues');

		case 11:
			throw new Error('Cannot perform mod 0. Division by zero error.');
	}
}

function _Debug_regionToString(region)
{
	if (region.start.line === region.end.line)
	{
		return 'on line ' + region.start.line;
	}
	return 'on lines ' + region.start.line + ' through ' + region.end.line;
}



// EQUALITY

function _Utils_eq(x, y)
{
	for (
		var pair, stack = [], isEqual = _Utils_eqHelp(x, y, 0, stack);
		isEqual && (pair = stack.pop());
		isEqual = _Utils_eqHelp(pair.a, pair.b, 0, stack)
		)
	{}

	return isEqual;
}

function _Utils_eqHelp(x, y, depth, stack)
{
	if (x === y)
	{
		return true;
	}

	if (typeof x !== 'object' || x === null || y === null)
	{
		typeof x === 'function' && _Debug_crash(5);
		return false;
	}

	if (depth > 100)
	{
		stack.push(_Utils_Tuple2(x,y));
		return true;
	}

	/**/
	if (x.$ === 'Set_elm_builtin')
	{
		x = $elm$core$Set$toList(x);
		y = $elm$core$Set$toList(y);
	}
	if (x.$ === 'RBNode_elm_builtin' || x.$ === 'RBEmpty_elm_builtin')
	{
		x = $elm$core$Dict$toList(x);
		y = $elm$core$Dict$toList(y);
	}
	//*/

	/**_UNUSED/
	if (x.$ < 0)
	{
		x = $elm$core$Dict$toList(x);
		y = $elm$core$Dict$toList(y);
	}
	//*/

	for (var key in x)
	{
		if (!_Utils_eqHelp(x[key], y[key], depth + 1, stack))
		{
			return false;
		}
	}
	return true;
}

var _Utils_equal = F2(_Utils_eq);
var _Utils_notEqual = F2(function(a, b) { return !_Utils_eq(a,b); });



// COMPARISONS

// Code in Generate/JavaScript.hs, Basics.js, and List.js depends on
// the particular integer values assigned to LT, EQ, and GT.

function _Utils_cmp(x, y, ord)
{
	if (typeof x !== 'object')
	{
		return x === y ? /*EQ*/ 0 : x < y ? /*LT*/ -1 : /*GT*/ 1;
	}

	/**/
	if (x instanceof String)
	{
		var a = x.valueOf();
		var b = y.valueOf();
		return a === b ? 0 : a < b ? -1 : 1;
	}
	//*/

	/**_UNUSED/
	if (typeof x.$ === 'undefined')
	//*/
	/**/
	if (x.$[0] === '#')
	//*/
	{
		return (ord = _Utils_cmp(x.a, y.a))
			? ord
			: (ord = _Utils_cmp(x.b, y.b))
				? ord
				: _Utils_cmp(x.c, y.c);
	}

	// traverse conses until end of a list or a mismatch
	for (; x.b && y.b && !(ord = _Utils_cmp(x.a, y.a)); x = x.b, y = y.b) {} // WHILE_CONSES
	return ord || (x.b ? /*GT*/ 1 : y.b ? /*LT*/ -1 : /*EQ*/ 0);
}

var _Utils_lt = F2(function(a, b) { return _Utils_cmp(a, b) < 0; });
var _Utils_le = F2(function(a, b) { return _Utils_cmp(a, b) < 1; });
var _Utils_gt = F2(function(a, b) { return _Utils_cmp(a, b) > 0; });
var _Utils_ge = F2(function(a, b) { return _Utils_cmp(a, b) >= 0; });

var _Utils_compare = F2(function(x, y)
{
	var n = _Utils_cmp(x, y);
	return n < 0 ? $elm$core$Basics$LT : n ? $elm$core$Basics$GT : $elm$core$Basics$EQ;
});


// COMMON VALUES

var _Utils_Tuple0_UNUSED = 0;
var _Utils_Tuple0 = { $: '#0' };

function _Utils_Tuple2_UNUSED(a, b) { return { a: a, b: b }; }
function _Utils_Tuple2(a, b) { return { $: '#2', a: a, b: b }; }

function _Utils_Tuple3_UNUSED(a, b, c) { return { a: a, b: b, c: c }; }
function _Utils_Tuple3(a, b, c) { return { $: '#3', a: a, b: b, c: c }; }

function _Utils_chr_UNUSED(c) { return c; }
function _Utils_chr(c) { return new String(c); }


// RECORDS

function _Utils_update(oldRecord, updatedFields)
{
	var newRecord = {};

	for (var key in oldRecord)
	{
		newRecord[key] = oldRecord[key];
	}

	for (var key in updatedFields)
	{
		newRecord[key] = updatedFields[key];
	}

	return newRecord;
}


// APPEND

var _Utils_append = F2(_Utils_ap);

function _Utils_ap(xs, ys)
{
	// append Strings
	if (typeof xs === 'string')
	{
		return xs + ys;
	}

	// append Lists
	if (!xs.b)
	{
		return ys;
	}
	var root = _List_Cons(xs.a, ys);
	xs = xs.b
	for (var curr = root; xs.b; xs = xs.b) // WHILE_CONS
	{
		curr = curr.b = _List_Cons(xs.a, ys);
	}
	return root;
}



var _List_Nil_UNUSED = { $: 0 };
var _List_Nil = { $: '[]' };

function _List_Cons_UNUSED(hd, tl) { return { $: 1, a: hd, b: tl }; }
function _List_Cons(hd, tl) { return { $: '::', a: hd, b: tl }; }


var _List_cons = F2(_List_Cons);

function _List_fromArray(arr)
{
	var out = _List_Nil;
	for (var i = arr.length; i--; )
	{
		out = _List_Cons(arr[i], out);
	}
	return out;
}

function _List_toArray(xs)
{
	for (var out = []; xs.b; xs = xs.b) // WHILE_CONS
	{
		out.push(xs.a);
	}
	return out;
}

var _List_map2 = F3(function(f, xs, ys)
{
	for (var arr = []; xs.b && ys.b; xs = xs.b, ys = ys.b) // WHILE_CONSES
	{
		arr.push(A2(f, xs.a, ys.a));
	}
	return _List_fromArray(arr);
});

var _List_map3 = F4(function(f, xs, ys, zs)
{
	for (var arr = []; xs.b && ys.b && zs.b; xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A3(f, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_map4 = F5(function(f, ws, xs, ys, zs)
{
	for (var arr = []; ws.b && xs.b && ys.b && zs.b; ws = ws.b, xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A4(f, ws.a, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_map5 = F6(function(f, vs, ws, xs, ys, zs)
{
	for (var arr = []; vs.b && ws.b && xs.b && ys.b && zs.b; vs = vs.b, ws = ws.b, xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A5(f, vs.a, ws.a, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_sortBy = F2(function(f, xs)
{
	return _List_fromArray(_List_toArray(xs).sort(function(a, b) {
		return _Utils_cmp(f(a), f(b));
	}));
});

var _List_sortWith = F2(function(f, xs)
{
	return _List_fromArray(_List_toArray(xs).sort(function(a, b) {
		var ord = A2(f, a, b);
		return ord === $elm$core$Basics$EQ ? 0 : ord === $elm$core$Basics$LT ? -1 : 1;
	}));
});



// MATH

var _Basics_add = F2(function(a, b) { return a + b; });
var _Basics_sub = F2(function(a, b) { return a - b; });
var _Basics_mul = F2(function(a, b) { return a * b; });
var _Basics_fdiv = F2(function(a, b) { return a / b; });
var _Basics_idiv = F2(function(a, b) { return (a / b) | 0; });
var _Basics_pow = F2(Math.pow);

var _Basics_remainderBy = F2(function(b, a) { return a % b; });

// https://www.microsoft.com/en-us/research/wp-content/uploads/2016/02/divmodnote-letter.pdf
var _Basics_modBy = F2(function(modulus, x)
{
	var answer = x % modulus;
	return modulus === 0
		? _Debug_crash(11)
		:
	((answer > 0 && modulus < 0) || (answer < 0 && modulus > 0))
		? answer + modulus
		: answer;
});


// TRIGONOMETRY

var _Basics_pi = Math.PI;
var _Basics_e = Math.E;
var _Basics_cos = Math.cos;
var _Basics_sin = Math.sin;
var _Basics_tan = Math.tan;
var _Basics_acos = Math.acos;
var _Basics_asin = Math.asin;
var _Basics_atan = Math.atan;
var _Basics_atan2 = F2(Math.atan2);


// MORE MATH

function _Basics_toFloat(x) { return x; }
function _Basics_truncate(n) { return n | 0; }
function _Basics_isInfinite(n) { return n === Infinity || n === -Infinity; }

var _Basics_ceiling = Math.ceil;
var _Basics_floor = Math.floor;
var _Basics_round = Math.round;
var _Basics_sqrt = Math.sqrt;
var _Basics_log = Math.log;
var _Basics_isNaN = isNaN;


// BOOLEANS

function _Basics_not(bool) { return !bool; }
var _Basics_and = F2(function(a, b) { return a && b; });
var _Basics_or  = F2(function(a, b) { return a || b; });
var _Basics_xor = F2(function(a, b) { return a !== b; });



var _String_cons = F2(function(chr, str)
{
	return chr + str;
});

function _String_uncons(string)
{
	var word = string.charCodeAt(0);
	return !isNaN(word)
		? $elm$core$Maybe$Just(
			0xD800 <= word && word <= 0xDBFF
				? _Utils_Tuple2(_Utils_chr(string[0] + string[1]), string.slice(2))
				: _Utils_Tuple2(_Utils_chr(string[0]), string.slice(1))
		)
		: $elm$core$Maybe$Nothing;
}

var _String_append = F2(function(a, b)
{
	return a + b;
});

function _String_length(str)
{
	return str.length;
}

var _String_map = F2(function(func, string)
{
	var len = string.length;
	var array = new Array(len);
	var i = 0;
	while (i < len)
	{
		var word = string.charCodeAt(i);
		if (0xD800 <= word && word <= 0xDBFF)
		{
			array[i] = func(_Utils_chr(string[i] + string[i+1]));
			i += 2;
			continue;
		}
		array[i] = func(_Utils_chr(string[i]));
		i++;
	}
	return array.join('');
});

var _String_filter = F2(function(isGood, str)
{
	var arr = [];
	var len = str.length;
	var i = 0;
	while (i < len)
	{
		var char = str[i];
		var word = str.charCodeAt(i);
		i++;
		if (0xD800 <= word && word <= 0xDBFF)
		{
			char += str[i];
			i++;
		}

		if (isGood(_Utils_chr(char)))
		{
			arr.push(char);
		}
	}
	return arr.join('');
});

function _String_reverse(str)
{
	var len = str.length;
	var arr = new Array(len);
	var i = 0;
	while (i < len)
	{
		var word = str.charCodeAt(i);
		if (0xD800 <= word && word <= 0xDBFF)
		{
			arr[len - i] = str[i + 1];
			i++;
			arr[len - i] = str[i - 1];
			i++;
		}
		else
		{
			arr[len - i] = str[i];
			i++;
		}
	}
	return arr.join('');
}

var _String_foldl = F3(function(func, state, string)
{
	var len = string.length;
	var i = 0;
	while (i < len)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		i++;
		if (0xD800 <= word && word <= 0xDBFF)
		{
			char += string[i];
			i++;
		}
		state = A2(func, _Utils_chr(char), state);
	}
	return state;
});

var _String_foldr = F3(function(func, state, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		state = A2(func, _Utils_chr(char), state);
	}
	return state;
});

var _String_split = F2(function(sep, str)
{
	return str.split(sep);
});

var _String_join = F2(function(sep, strs)
{
	return strs.join(sep);
});

var _String_slice = F3(function(start, end, str) {
	return str.slice(start, end);
});

function _String_trim(str)
{
	return str.trim();
}

function _String_trimLeft(str)
{
	return str.replace(/^\s+/, '');
}

function _String_trimRight(str)
{
	return str.replace(/\s+$/, '');
}

function _String_words(str)
{
	return _List_fromArray(str.trim().split(/\s+/g));
}

function _String_lines(str)
{
	return _List_fromArray(str.split(/\r\n|\r|\n/g));
}

function _String_toUpper(str)
{
	return str.toUpperCase();
}

function _String_toLower(str)
{
	return str.toLowerCase();
}

var _String_any = F2(function(isGood, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		if (isGood(_Utils_chr(char)))
		{
			return true;
		}
	}
	return false;
});

var _String_all = F2(function(isGood, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		if (!isGood(_Utils_chr(char)))
		{
			return false;
		}
	}
	return true;
});

var _String_contains = F2(function(sub, str)
{
	return str.indexOf(sub) > -1;
});

var _String_startsWith = F2(function(sub, str)
{
	return str.indexOf(sub) === 0;
});

var _String_endsWith = F2(function(sub, str)
{
	return str.length >= sub.length &&
		str.lastIndexOf(sub) === str.length - sub.length;
});

var _String_indexes = F2(function(sub, str)
{
	var subLen = sub.length;

	if (subLen < 1)
	{
		return _List_Nil;
	}

	var i = 0;
	var is = [];

	while ((i = str.indexOf(sub, i)) > -1)
	{
		is.push(i);
		i = i + subLen;
	}

	return _List_fromArray(is);
});


// TO STRING

function _String_fromNumber(number)
{
	return number + '';
}


// INT CONVERSIONS

function _String_toInt(str)
{
	var total = 0;
	var code0 = str.charCodeAt(0);
	var start = code0 == 0x2B /* + */ || code0 == 0x2D /* - */ ? 1 : 0;

	for (var i = start; i < str.length; ++i)
	{
		var code = str.charCodeAt(i);
		if (code < 0x30 || 0x39 < code)
		{
			return $elm$core$Maybe$Nothing;
		}
		total = 10 * total + code - 0x30;
	}

	return i == start
		? $elm$core$Maybe$Nothing
		: $elm$core$Maybe$Just(code0 == 0x2D ? -total : total);
}


// FLOAT CONVERSIONS

function _String_toFloat(s)
{
	// check if it is a hex, octal, or binary number
	if (s.length === 0 || /[\sxbo]/.test(s))
	{
		return $elm$core$Maybe$Nothing;
	}
	var n = +s;
	// faster isNaN check
	return n === n ? $elm$core$Maybe$Just(n) : $elm$core$Maybe$Nothing;
}

function _String_fromList(chars)
{
	return _List_toArray(chars).join('');
}




function _Char_toCode(char)
{
	var code = char.charCodeAt(0);
	if (0xD800 <= code && code <= 0xDBFF)
	{
		return (code - 0xD800) * 0x400 + char.charCodeAt(1) - 0xDC00 + 0x10000
	}
	return code;
}

function _Char_fromCode(code)
{
	return _Utils_chr(
		(code < 0 || 0x10FFFF < code)
			? '\uFFFD'
			:
		(code <= 0xFFFF)
			? String.fromCharCode(code)
			:
		(code -= 0x10000,
			String.fromCharCode(Math.floor(code / 0x400) + 0xD800, code % 0x400 + 0xDC00)
		)
	);
}

function _Char_toUpper(char)
{
	return _Utils_chr(char.toUpperCase());
}

function _Char_toLower(char)
{
	return _Utils_chr(char.toLowerCase());
}

function _Char_toLocaleUpper(char)
{
	return _Utils_chr(char.toLocaleUpperCase());
}

function _Char_toLocaleLower(char)
{
	return _Utils_chr(char.toLocaleLowerCase());
}



/**/
function _Json_errorToString(error)
{
	return $elm$json$Json$Decode$errorToString(error);
}
//*/


// CORE DECODERS

function _Json_succeed(msg)
{
	return {
		$: 0,
		a: msg
	};
}

function _Json_fail(msg)
{
	return {
		$: 1,
		a: msg
	};
}

function _Json_decodePrim(decoder)
{
	return { $: 2, b: decoder };
}

var _Json_decodeInt = _Json_decodePrim(function(value) {
	return (typeof value !== 'number')
		? _Json_expecting('an INT', value)
		:
	(-2147483647 < value && value < 2147483647 && (value | 0) === value)
		? $elm$core$Result$Ok(value)
		:
	(isFinite(value) && !(value % 1))
		? $elm$core$Result$Ok(value)
		: _Json_expecting('an INT', value);
});

var _Json_decodeBool = _Json_decodePrim(function(value) {
	return (typeof value === 'boolean')
		? $elm$core$Result$Ok(value)
		: _Json_expecting('a BOOL', value);
});

var _Json_decodeFloat = _Json_decodePrim(function(value) {
	return (typeof value === 'number')
		? $elm$core$Result$Ok(value)
		: _Json_expecting('a FLOAT', value);
});

var _Json_decodeValue = _Json_decodePrim(function(value) {
	return $elm$core$Result$Ok(_Json_wrap(value));
});

var _Json_decodeString = _Json_decodePrim(function(value) {
	return (typeof value === 'string')
		? $elm$core$Result$Ok(value)
		: (value instanceof String)
			? $elm$core$Result$Ok(value + '')
			: _Json_expecting('a STRING', value);
});

function _Json_decodeList(decoder) { return { $: 3, b: decoder }; }
function _Json_decodeArray(decoder) { return { $: 4, b: decoder }; }

function _Json_decodeNull(value) { return { $: 5, c: value }; }

var _Json_decodeField = F2(function(field, decoder)
{
	return {
		$: 6,
		d: field,
		b: decoder
	};
});

var _Json_decodeIndex = F2(function(index, decoder)
{
	return {
		$: 7,
		e: index,
		b: decoder
	};
});

function _Json_decodeKeyValuePairs(decoder)
{
	return {
		$: 8,
		b: decoder
	};
}

function _Json_mapMany(f, decoders)
{
	return {
		$: 9,
		f: f,
		g: decoders
	};
}

var _Json_andThen = F2(function(callback, decoder)
{
	return {
		$: 10,
		b: decoder,
		h: callback
	};
});

function _Json_oneOf(decoders)
{
	return {
		$: 11,
		g: decoders
	};
}


// DECODING OBJECTS

var _Json_map1 = F2(function(f, d1)
{
	return _Json_mapMany(f, [d1]);
});

var _Json_map2 = F3(function(f, d1, d2)
{
	return _Json_mapMany(f, [d1, d2]);
});

var _Json_map3 = F4(function(f, d1, d2, d3)
{
	return _Json_mapMany(f, [d1, d2, d3]);
});

var _Json_map4 = F5(function(f, d1, d2, d3, d4)
{
	return _Json_mapMany(f, [d1, d2, d3, d4]);
});

var _Json_map5 = F6(function(f, d1, d2, d3, d4, d5)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5]);
});

var _Json_map6 = F7(function(f, d1, d2, d3, d4, d5, d6)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6]);
});

var _Json_map7 = F8(function(f, d1, d2, d3, d4, d5, d6, d7)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6, d7]);
});

var _Json_map8 = F9(function(f, d1, d2, d3, d4, d5, d6, d7, d8)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6, d7, d8]);
});


// DECODE

var _Json_runOnString = F2(function(decoder, string)
{
	try
	{
		var value = JSON.parse(string);
		return _Json_runHelp(decoder, value);
	}
	catch (e)
	{
		return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, 'This is not valid JSON! ' + e.message, _Json_wrap(string)));
	}
});

var _Json_run = F2(function(decoder, value)
{
	return _Json_runHelp(decoder, _Json_unwrap(value));
});

function _Json_runHelp(decoder, value)
{
	switch (decoder.$)
	{
		case 2:
			return decoder.b(value);

		case 5:
			return (value === null)
				? $elm$core$Result$Ok(decoder.c)
				: _Json_expecting('null', value);

		case 3:
			if (!_Json_isArray(value))
			{
				return _Json_expecting('a LIST', value);
			}
			return _Json_runArrayDecoder(decoder.b, value, _List_fromArray);

		case 4:
			if (!_Json_isArray(value))
			{
				return _Json_expecting('an ARRAY', value);
			}
			return _Json_runArrayDecoder(decoder.b, value, _Json_toElmArray);

		case 6:
			var field = decoder.d;
			if (typeof value !== 'object' || value === null || !(field in value))
			{
				return _Json_expecting('an OBJECT with a field named `' + field + '`', value);
			}
			var result = _Json_runHelp(decoder.b, value[field]);
			return ($elm$core$Result$isOk(result)) ? result : $elm$core$Result$Err(A2($elm$json$Json$Decode$Field, field, result.a));

		case 7:
			var index = decoder.e;
			if (!_Json_isArray(value))
			{
				return _Json_expecting('an ARRAY', value);
			}
			if (index >= value.length)
			{
				return _Json_expecting('a LONGER array. Need index ' + index + ' but only see ' + value.length + ' entries', value);
			}
			var result = _Json_runHelp(decoder.b, value[index]);
			return ($elm$core$Result$isOk(result)) ? result : $elm$core$Result$Err(A2($elm$json$Json$Decode$Index, index, result.a));

		case 8:
			if (typeof value !== 'object' || value === null || _Json_isArray(value))
			{
				return _Json_expecting('an OBJECT', value);
			}

			var keyValuePairs = _List_Nil;
			// TODO test perf of Object.keys and switch when support is good enough
			for (var key in value)
			{
				if (value.hasOwnProperty(key))
				{
					var result = _Json_runHelp(decoder.b, value[key]);
					if (!$elm$core$Result$isOk(result))
					{
						return $elm$core$Result$Err(A2($elm$json$Json$Decode$Field, key, result.a));
					}
					keyValuePairs = _List_Cons(_Utils_Tuple2(key, result.a), keyValuePairs);
				}
			}
			return $elm$core$Result$Ok($elm$core$List$reverse(keyValuePairs));

		case 9:
			var answer = decoder.f;
			var decoders = decoder.g;
			for (var i = 0; i < decoders.length; i++)
			{
				var result = _Json_runHelp(decoders[i], value);
				if (!$elm$core$Result$isOk(result))
				{
					return result;
				}
				answer = answer(result.a);
			}
			return $elm$core$Result$Ok(answer);

		case 10:
			var result = _Json_runHelp(decoder.b, value);
			return (!$elm$core$Result$isOk(result))
				? result
				: _Json_runHelp(decoder.h(result.a), value);

		case 11:
			var errors = _List_Nil;
			for (var temp = decoder.g; temp.b; temp = temp.b) // WHILE_CONS
			{
				var result = _Json_runHelp(temp.a, value);
				if ($elm$core$Result$isOk(result))
				{
					return result;
				}
				errors = _List_Cons(result.a, errors);
			}
			return $elm$core$Result$Err($elm$json$Json$Decode$OneOf($elm$core$List$reverse(errors)));

		case 1:
			return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, decoder.a, _Json_wrap(value)));

		case 0:
			return $elm$core$Result$Ok(decoder.a);
	}
}

function _Json_runArrayDecoder(decoder, value, toElmValue)
{
	var len = value.length;
	var array = new Array(len);
	for (var i = 0; i < len; i++)
	{
		var result = _Json_runHelp(decoder, value[i]);
		if (!$elm$core$Result$isOk(result))
		{
			return $elm$core$Result$Err(A2($elm$json$Json$Decode$Index, i, result.a));
		}
		array[i] = result.a;
	}
	return $elm$core$Result$Ok(toElmValue(array));
}

function _Json_isArray(value)
{
	return Array.isArray(value) || (typeof FileList !== 'undefined' && value instanceof FileList);
}

function _Json_toElmArray(array)
{
	return A2($elm$core$Array$initialize, array.length, function(i) { return array[i]; });
}

function _Json_expecting(type, value)
{
	return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, 'Expecting ' + type, _Json_wrap(value)));
}


// EQUALITY

function _Json_equality(x, y)
{
	if (x === y)
	{
		return true;
	}

	if (x.$ !== y.$)
	{
		return false;
	}

	switch (x.$)
	{
		case 0:
		case 1:
			return x.a === y.a;

		case 2:
			return x.b === y.b;

		case 5:
			return x.c === y.c;

		case 3:
		case 4:
		case 8:
			return _Json_equality(x.b, y.b);

		case 6:
			return x.d === y.d && _Json_equality(x.b, y.b);

		case 7:
			return x.e === y.e && _Json_equality(x.b, y.b);

		case 9:
			return x.f === y.f && _Json_listEquality(x.g, y.g);

		case 10:
			return x.h === y.h && _Json_equality(x.b, y.b);

		case 11:
			return _Json_listEquality(x.g, y.g);
	}
}

function _Json_listEquality(aDecoders, bDecoders)
{
	var len = aDecoders.length;
	if (len !== bDecoders.length)
	{
		return false;
	}
	for (var i = 0; i < len; i++)
	{
		if (!_Json_equality(aDecoders[i], bDecoders[i]))
		{
			return false;
		}
	}
	return true;
}


// ENCODE

var _Json_encode = F2(function(indentLevel, value)
{
	return JSON.stringify(_Json_unwrap(value), null, indentLevel) + '';
});

function _Json_wrap(value) { return { $: 0, a: value }; }
function _Json_unwrap(value) { return value.a; }

function _Json_wrap_UNUSED(value) { return value; }
function _Json_unwrap_UNUSED(value) { return value; }

function _Json_emptyArray() { return []; }
function _Json_emptyObject() { return {}; }

var _Json_addField = F3(function(key, value, object)
{
	object[key] = _Json_unwrap(value);
	return object;
});

function _Json_addEntry(func)
{
	return F2(function(entry, array)
	{
		array.push(_Json_unwrap(func(entry)));
		return array;
	});
}

var _Json_encodeNull = _Json_wrap(null);



// TASKS

function _Scheduler_succeed(value)
{
	return {
		$: 0,
		a: value
	};
}

function _Scheduler_fail(error)
{
	return {
		$: 1,
		a: error
	};
}

function _Scheduler_binding(callback)
{
	return {
		$: 2,
		b: callback,
		c: null
	};
}

var _Scheduler_andThen = F2(function(callback, task)
{
	return {
		$: 3,
		b: callback,
		d: task
	};
});

var _Scheduler_onError = F2(function(callback, task)
{
	return {
		$: 4,
		b: callback,
		d: task
	};
});

function _Scheduler_receive(callback)
{
	return {
		$: 5,
		b: callback
	};
}


// PROCESSES

var _Scheduler_guid = 0;

function _Scheduler_rawSpawn(task)
{
	var proc = {
		$: 0,
		e: _Scheduler_guid++,
		f: task,
		g: null,
		h: []
	};

	_Scheduler_enqueue(proc);

	return proc;
}

function _Scheduler_spawn(task)
{
	return _Scheduler_binding(function(callback) {
		callback(_Scheduler_succeed(_Scheduler_rawSpawn(task)));
	});
}

function _Scheduler_rawSend(proc, msg)
{
	proc.h.push(msg);
	_Scheduler_enqueue(proc);
}

var _Scheduler_send = F2(function(proc, msg)
{
	return _Scheduler_binding(function(callback) {
		_Scheduler_rawSend(proc, msg);
		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
});

function _Scheduler_kill(proc)
{
	return _Scheduler_binding(function(callback) {
		var task = proc.f;
		if (task.$ === 2 && task.c)
		{
			task.c();
		}

		proc.f = null;

		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
}


/* STEP PROCESSES

type alias Process =
  { $ : tag
  , id : unique_id
  , root : Task
  , stack : null | { $: SUCCEED | FAIL, a: callback, b: stack }
  , mailbox : [msg]
  }

*/


var _Scheduler_working = false;
var _Scheduler_queue = [];


function _Scheduler_enqueue(proc)
{
	_Scheduler_queue.push(proc);
	if (_Scheduler_working)
	{
		return;
	}
	_Scheduler_working = true;
	while (proc = _Scheduler_queue.shift())
	{
		_Scheduler_step(proc);
	}
	_Scheduler_working = false;
}


function _Scheduler_step(proc)
{
	while (proc.f)
	{
		var rootTag = proc.f.$;
		if (rootTag === 0 || rootTag === 1)
		{
			while (proc.g && proc.g.$ !== rootTag)
			{
				proc.g = proc.g.i;
			}
			if (!proc.g)
			{
				return;
			}
			proc.f = proc.g.b(proc.f.a);
			proc.g = proc.g.i;
		}
		else if (rootTag === 2)
		{
			proc.f.c = proc.f.b(function(newRoot) {
				proc.f = newRoot;
				_Scheduler_enqueue(proc);
			});
			return;
		}
		else if (rootTag === 5)
		{
			if (proc.h.length === 0)
			{
				return;
			}
			proc.f = proc.f.b(proc.h.shift());
		}
		else // if (rootTag === 3 || rootTag === 4)
		{
			proc.g = {
				$: rootTag === 3 ? 0 : 1,
				b: proc.f.b,
				i: proc.g
			};
			proc.f = proc.f.d;
		}
	}
}



function _Process_sleep(time)
{
	return _Scheduler_binding(function(callback) {
		var id = setTimeout(function() {
			callback(_Scheduler_succeed(_Utils_Tuple0));
		}, time);

		return function() { clearTimeout(id); };
	});
}




// PROGRAMS


var _Platform_worker = F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.init,
		impl.update,
		impl.subscriptions,
		function() { return function() {} }
	);
});



// INITIALIZE A PROGRAM


function _Platform_initialize(flagDecoder, args, init, update, subscriptions, stepperBuilder)
{
	var result = A2(_Json_run, flagDecoder, _Json_wrap(args ? args['flags'] : undefined));
	$elm$core$Result$isOk(result) || _Debug_crash(2 /**/, _Json_errorToString(result.a) /**/);
	var managers = {};
	var initPair = init(result.a);
	var model = initPair.a;
	var stepper = stepperBuilder(sendToApp, model);
	var ports = _Platform_setupEffects(managers, sendToApp);

	function sendToApp(msg, viewMetadata)
	{
		var pair = A2(update, msg, model);
		stepper(model = pair.a, viewMetadata);
		_Platform_enqueueEffects(managers, pair.b, subscriptions(model));
	}

	_Platform_enqueueEffects(managers, initPair.b, subscriptions(model));

	return ports ? { ports: ports } : {};
}



// TRACK PRELOADS
//
// This is used by code in elm/browser and elm/http
// to register any HTTP requests that are triggered by init.
//


var _Platform_preload;


function _Platform_registerPreload(url)
{
	_Platform_preload.add(url);
}



// EFFECT MANAGERS


var _Platform_effectManagers = {};


function _Platform_setupEffects(managers, sendToApp)
{
	var ports;

	// setup all necessary effect managers
	for (var key in _Platform_effectManagers)
	{
		var manager = _Platform_effectManagers[key];

		if (manager.a)
		{
			ports = ports || {};
			ports[key] = manager.a(key, sendToApp);
		}

		managers[key] = _Platform_instantiateManager(manager, sendToApp);
	}

	return ports;
}


function _Platform_createManager(init, onEffects, onSelfMsg, cmdMap, subMap)
{
	return {
		b: init,
		c: onEffects,
		d: onSelfMsg,
		e: cmdMap,
		f: subMap
	};
}


function _Platform_instantiateManager(info, sendToApp)
{
	var router = {
		g: sendToApp,
		h: undefined
	};

	var onEffects = info.c;
	var onSelfMsg = info.d;
	var cmdMap = info.e;
	var subMap = info.f;

	function loop(state)
	{
		return A2(_Scheduler_andThen, loop, _Scheduler_receive(function(msg)
		{
			var value = msg.a;

			if (msg.$ === 0)
			{
				return A3(onSelfMsg, router, value, state);
			}

			return cmdMap && subMap
				? A4(onEffects, router, value.i, value.j, state)
				: A3(onEffects, router, cmdMap ? value.i : value.j, state);
		}));
	}

	return router.h = _Scheduler_rawSpawn(A2(_Scheduler_andThen, loop, info.b));
}



// ROUTING


var _Platform_sendToApp = F2(function(router, msg)
{
	return _Scheduler_binding(function(callback)
	{
		router.g(msg);
		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
});


var _Platform_sendToSelf = F2(function(router, msg)
{
	return A2(_Scheduler_send, router.h, {
		$: 0,
		a: msg
	});
});



// BAGS


function _Platform_leaf(home)
{
	return function(value)
	{
		return {
			$: 1,
			k: home,
			l: value
		};
	};
}


function _Platform_batch(list)
{
	return {
		$: 2,
		m: list
	};
}


var _Platform_map = F2(function(tagger, bag)
{
	return {
		$: 3,
		n: tagger,
		o: bag
	}
});



// PIPE BAGS INTO EFFECT MANAGERS
//
// Effects must be queued!
//
// Say your init contains a synchronous command, like Time.now or Time.here
//
//   - This will produce a batch of effects (FX_1)
//   - The synchronous task triggers the subsequent `update` call
//   - This will produce a batch of effects (FX_2)
//
// If we just start dispatching FX_2, subscriptions from FX_2 can be processed
// before subscriptions from FX_1. No good! Earlier versions of this code had
// this problem, leading to these reports:
//
//   https://github.com/elm/core/issues/980
//   https://github.com/elm/core/pull/981
//   https://github.com/elm/compiler/issues/1776
//
// The queue is necessary to avoid ordering issues for synchronous commands.


// Why use true/false here? Why not just check the length of the queue?
// The goal is to detect "are we currently dispatching effects?" If we
// are, we need to bail and let the ongoing while loop handle things.
//
// Now say the queue has 1 element. When we dequeue the final element,
// the queue will be empty, but we are still actively dispatching effects.
// So you could get queue jumping in a really tricky category of cases.
//
var _Platform_effectsQueue = [];
var _Platform_effectsActive = false;


function _Platform_enqueueEffects(managers, cmdBag, subBag)
{
	_Platform_effectsQueue.push({ p: managers, q: cmdBag, r: subBag });

	if (_Platform_effectsActive) return;

	_Platform_effectsActive = true;
	for (var fx; fx = _Platform_effectsQueue.shift(); )
	{
		_Platform_dispatchEffects(fx.p, fx.q, fx.r);
	}
	_Platform_effectsActive = false;
}


function _Platform_dispatchEffects(managers, cmdBag, subBag)
{
	var effectsDict = {};
	_Platform_gatherEffects(true, cmdBag, effectsDict, null);
	_Platform_gatherEffects(false, subBag, effectsDict, null);

	for (var home in managers)
	{
		_Scheduler_rawSend(managers[home], {
			$: 'fx',
			a: effectsDict[home] || { i: _List_Nil, j: _List_Nil }
		});
	}
}


function _Platform_gatherEffects(isCmd, bag, effectsDict, taggers)
{
	switch (bag.$)
	{
		case 1:
			var home = bag.k;
			var effect = _Platform_toEffect(isCmd, home, taggers, bag.l);
			effectsDict[home] = _Platform_insert(isCmd, effect, effectsDict[home]);
			return;

		case 2:
			for (var list = bag.m; list.b; list = list.b) // WHILE_CONS
			{
				_Platform_gatherEffects(isCmd, list.a, effectsDict, taggers);
			}
			return;

		case 3:
			_Platform_gatherEffects(isCmd, bag.o, effectsDict, {
				s: bag.n,
				t: taggers
			});
			return;
	}
}


function _Platform_toEffect(isCmd, home, taggers, value)
{
	function applyTaggers(x)
	{
		for (var temp = taggers; temp; temp = temp.t)
		{
			x = temp.s(x);
		}
		return x;
	}

	var map = isCmd
		? _Platform_effectManagers[home].e
		: _Platform_effectManagers[home].f;

	return A2(map, applyTaggers, value)
}


function _Platform_insert(isCmd, newEffect, effects)
{
	effects = effects || { i: _List_Nil, j: _List_Nil };

	isCmd
		? (effects.i = _List_Cons(newEffect, effects.i))
		: (effects.j = _List_Cons(newEffect, effects.j));

	return effects;
}



// PORTS


function _Platform_checkPortName(name)
{
	if (_Platform_effectManagers[name])
	{
		_Debug_crash(3, name)
	}
}



// OUTGOING PORTS


function _Platform_outgoingPort(name, converter)
{
	_Platform_checkPortName(name);
	_Platform_effectManagers[name] = {
		e: _Platform_outgoingPortMap,
		u: converter,
		a: _Platform_setupOutgoingPort
	};
	return _Platform_leaf(name);
}


var _Platform_outgoingPortMap = F2(function(tagger, value) { return value; });


function _Platform_setupOutgoingPort(name)
{
	var subs = [];
	var converter = _Platform_effectManagers[name].u;

	// CREATE MANAGER

	var init = _Process_sleep(0);

	_Platform_effectManagers[name].b = init;
	_Platform_effectManagers[name].c = F3(function(router, cmdList, state)
	{
		for ( ; cmdList.b; cmdList = cmdList.b) // WHILE_CONS
		{
			// grab a separate reference to subs in case unsubscribe is called
			var currentSubs = subs;
			var value = _Json_unwrap(converter(cmdList.a));
			for (var i = 0; i < currentSubs.length; i++)
			{
				currentSubs[i](value);
			}
		}
		return init;
	});

	// PUBLIC API

	function subscribe(callback)
	{
		subs.push(callback);
	}

	function unsubscribe(callback)
	{
		// copy subs into a new array in case unsubscribe is called within a
		// subscribed callback
		subs = subs.slice();
		var index = subs.indexOf(callback);
		if (index >= 0)
		{
			subs.splice(index, 1);
		}
	}

	return {
		subscribe: subscribe,
		unsubscribe: unsubscribe
	};
}



// INCOMING PORTS


function _Platform_incomingPort(name, converter)
{
	_Platform_checkPortName(name);
	_Platform_effectManagers[name] = {
		f: _Platform_incomingPortMap,
		u: converter,
		a: _Platform_setupIncomingPort
	};
	return _Platform_leaf(name);
}


var _Platform_incomingPortMap = F2(function(tagger, finalTagger)
{
	return function(value)
	{
		return tagger(finalTagger(value));
	};
});


function _Platform_setupIncomingPort(name, sendToApp)
{
	var subs = _List_Nil;
	var converter = _Platform_effectManagers[name].u;

	// CREATE MANAGER

	var init = _Scheduler_succeed(null);

	_Platform_effectManagers[name].b = init;
	_Platform_effectManagers[name].c = F3(function(router, subList, state)
	{
		subs = subList;
		return init;
	});

	// PUBLIC API

	function send(incomingValue)
	{
		var result = A2(_Json_run, converter, _Json_wrap(incomingValue));

		$elm$core$Result$isOk(result) || _Debug_crash(4, name, result.a);

		var value = result.a;
		for (var temp = subs; temp.b; temp = temp.b) // WHILE_CONS
		{
			sendToApp(temp.a(value));
		}
	}

	return { send: send };
}



// EXPORT ELM MODULES
//
// Have DEBUG and PROD versions so that we can (1) give nicer errors in
// debug mode and (2) not pay for the bits needed for that in prod mode.
//


function _Platform_export_UNUSED(exports)
{
	scope['Elm']
		? _Platform_mergeExportsProd(scope['Elm'], exports)
		: scope['Elm'] = exports;
}


function _Platform_mergeExportsProd(obj, exports)
{
	for (var name in exports)
	{
		(name in obj)
			? (name == 'init')
				? _Debug_crash(6)
				: _Platform_mergeExportsProd(obj[name], exports[name])
			: (obj[name] = exports[name]);
	}
}


function _Platform_export(exports)
{
	scope['Elm']
		? _Platform_mergeExportsDebug('Elm', scope['Elm'], exports)
		: scope['Elm'] = exports;
}


function _Platform_mergeExportsDebug(moduleName, obj, exports)
{
	for (var name in exports)
	{
		(name in obj)
			? (name == 'init')
				? _Debug_crash(6, moduleName)
				: _Platform_mergeExportsDebug(moduleName + '.' + name, obj[name], exports[name])
			: (obj[name] = exports[name]);
	}
}




// HELPERS


var _VirtualDom_divertHrefToApp;

var _VirtualDom_doc = typeof document !== 'undefined' ? document : {};


function _VirtualDom_appendChild(parent, child)
{
	parent.appendChild(child);
}

var _VirtualDom_init = F4(function(virtualNode, flagDecoder, debugMetadata, args)
{
	// NOTE: this function needs _Platform_export available to work

	/**_UNUSED/
	var node = args['node'];
	//*/
	/**/
	var node = args && args['node'] ? args['node'] : _Debug_crash(0);
	//*/

	node.parentNode.replaceChild(
		_VirtualDom_render(virtualNode, function() {}),
		node
	);

	return {};
});



// TEXT


function _VirtualDom_text(string)
{
	return {
		$: 0,
		a: string
	};
}



// NODE


var _VirtualDom_nodeNS = F2(function(namespace, tag)
{
	return F2(function(factList, kidList)
	{
		for (var kids = [], descendantsCount = 0; kidList.b; kidList = kidList.b) // WHILE_CONS
		{
			var kid = kidList.a;
			descendantsCount += (kid.b || 0);
			kids.push(kid);
		}
		descendantsCount += kids.length;

		return {
			$: 1,
			c: tag,
			d: _VirtualDom_organizeFacts(factList),
			e: kids,
			f: namespace,
			b: descendantsCount
		};
	});
});


var _VirtualDom_node = _VirtualDom_nodeNS(undefined);



// KEYED NODE


var _VirtualDom_keyedNodeNS = F2(function(namespace, tag)
{
	return F2(function(factList, kidList)
	{
		for (var kids = [], descendantsCount = 0; kidList.b; kidList = kidList.b) // WHILE_CONS
		{
			var kid = kidList.a;
			descendantsCount += (kid.b.b || 0);
			kids.push(kid);
		}
		descendantsCount += kids.length;

		return {
			$: 2,
			c: tag,
			d: _VirtualDom_organizeFacts(factList),
			e: kids,
			f: namespace,
			b: descendantsCount
		};
	});
});


var _VirtualDom_keyedNode = _VirtualDom_keyedNodeNS(undefined);



// CUSTOM


function _VirtualDom_custom(factList, model, render, diff)
{
	return {
		$: 3,
		d: _VirtualDom_organizeFacts(factList),
		g: model,
		h: render,
		i: diff
	};
}



// MAP


var _VirtualDom_map = F2(function(tagger, node)
{
	return {
		$: 4,
		j: tagger,
		k: node,
		b: 1 + (node.b || 0)
	};
});



// LAZY


function _VirtualDom_thunk(refs, thunk)
{
	return {
		$: 5,
		l: refs,
		m: thunk,
		k: undefined
	};
}

var _VirtualDom_lazy = F2(function(func, a)
{
	return _VirtualDom_thunk([func, a], function() {
		return func(a);
	});
});

var _VirtualDom_lazy2 = F3(function(func, a, b)
{
	return _VirtualDom_thunk([func, a, b], function() {
		return A2(func, a, b);
	});
});

var _VirtualDom_lazy3 = F4(function(func, a, b, c)
{
	return _VirtualDom_thunk([func, a, b, c], function() {
		return A3(func, a, b, c);
	});
});

var _VirtualDom_lazy4 = F5(function(func, a, b, c, d)
{
	return _VirtualDom_thunk([func, a, b, c, d], function() {
		return A4(func, a, b, c, d);
	});
});

var _VirtualDom_lazy5 = F6(function(func, a, b, c, d, e)
{
	return _VirtualDom_thunk([func, a, b, c, d, e], function() {
		return A5(func, a, b, c, d, e);
	});
});

var _VirtualDom_lazy6 = F7(function(func, a, b, c, d, e, f)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f], function() {
		return A6(func, a, b, c, d, e, f);
	});
});

var _VirtualDom_lazy7 = F8(function(func, a, b, c, d, e, f, g)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f, g], function() {
		return A7(func, a, b, c, d, e, f, g);
	});
});

var _VirtualDom_lazy8 = F9(function(func, a, b, c, d, e, f, g, h)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f, g, h], function() {
		return A8(func, a, b, c, d, e, f, g, h);
	});
});



// FACTS


var _VirtualDom_on = F2(function(key, handler)
{
	return {
		$: 'a0',
		n: key,
		o: handler
	};
});
var _VirtualDom_style = F2(function(key, value)
{
	return {
		$: 'a1',
		n: key,
		o: value
	};
});
var _VirtualDom_property = F2(function(key, value)
{
	return {
		$: 'a2',
		n: key,
		o: value
	};
});
var _VirtualDom_attribute = F2(function(key, value)
{
	return {
		$: 'a3',
		n: key,
		o: value
	};
});
var _VirtualDom_attributeNS = F3(function(namespace, key, value)
{
	return {
		$: 'a4',
		n: key,
		o: { f: namespace, o: value }
	};
});



// XSS ATTACK VECTOR CHECKS


function _VirtualDom_noScript(tag)
{
	return tag == 'script' ? 'p' : tag;
}

function _VirtualDom_noOnOrFormAction(key)
{
	return /^(on|formAction$)/i.test(key) ? 'data-' + key : key;
}

function _VirtualDom_noInnerHtmlOrFormAction(key)
{
	return key == 'innerHTML' || key == 'formAction' ? 'data-' + key : key;
}

function _VirtualDom_noJavaScriptUri_UNUSED(value)
{
	return /^javascript:/i.test(value.replace(/\s/g,'')) ? '' : value;
}

function _VirtualDom_noJavaScriptUri(value)
{
	return /^javascript:/i.test(value.replace(/\s/g,''))
		? 'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'
		: value;
}

function _VirtualDom_noJavaScriptOrHtmlUri_UNUSED(value)
{
	return /^\s*(javascript:|data:text\/html)/i.test(value) ? '' : value;
}

function _VirtualDom_noJavaScriptOrHtmlUri(value)
{
	return /^\s*(javascript:|data:text\/html)/i.test(value)
		? 'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'
		: value;
}



// MAP FACTS


var _VirtualDom_mapAttribute = F2(function(func, attr)
{
	return (attr.$ === 'a0')
		? A2(_VirtualDom_on, attr.n, _VirtualDom_mapHandler(func, attr.o))
		: attr;
});

function _VirtualDom_mapHandler(func, handler)
{
	var tag = $elm$virtual_dom$VirtualDom$toHandlerInt(handler);

	// 0 = Normal
	// 1 = MayStopPropagation
	// 2 = MayPreventDefault
	// 3 = Custom

	return {
		$: handler.$,
		a:
			!tag
				? A2($elm$json$Json$Decode$map, func, handler.a)
				:
			A3($elm$json$Json$Decode$map2,
				tag < 3
					? _VirtualDom_mapEventTuple
					: _VirtualDom_mapEventRecord,
				$elm$json$Json$Decode$succeed(func),
				handler.a
			)
	};
}

var _VirtualDom_mapEventTuple = F2(function(func, tuple)
{
	return _Utils_Tuple2(func(tuple.a), tuple.b);
});

var _VirtualDom_mapEventRecord = F2(function(func, record)
{
	return {
		message: func(record.message),
		stopPropagation: record.stopPropagation,
		preventDefault: record.preventDefault
	}
});



// ORGANIZE FACTS


function _VirtualDom_organizeFacts(factList)
{
	for (var facts = {}; factList.b; factList = factList.b) // WHILE_CONS
	{
		var entry = factList.a;

		var tag = entry.$;
		var key = entry.n;
		var value = entry.o;

		if (tag === 'a2')
		{
			(key === 'className')
				? _VirtualDom_addClass(facts, key, _Json_unwrap(value))
				: facts[key] = _Json_unwrap(value);

			continue;
		}

		var subFacts = facts[tag] || (facts[tag] = {});
		(tag === 'a3' && key === 'class')
			? _VirtualDom_addClass(subFacts, key, value)
			: subFacts[key] = value;
	}

	return facts;
}

function _VirtualDom_addClass(object, key, newClass)
{
	var classes = object[key];
	object[key] = classes ? classes + ' ' + newClass : newClass;
}



// RENDER


function _VirtualDom_render(vNode, eventNode)
{
	var tag = vNode.$;

	if (tag === 5)
	{
		return _VirtualDom_render(vNode.k || (vNode.k = vNode.m()), eventNode);
	}

	if (tag === 0)
	{
		return _VirtualDom_doc.createTextNode(vNode.a);
	}

	if (tag === 4)
	{
		var subNode = vNode.k;
		var tagger = vNode.j;

		while (subNode.$ === 4)
		{
			typeof tagger !== 'object'
				? tagger = [tagger, subNode.j]
				: tagger.push(subNode.j);

			subNode = subNode.k;
		}

		var subEventRoot = { j: tagger, p: eventNode };
		var domNode = _VirtualDom_render(subNode, subEventRoot);
		domNode.elm_event_node_ref = subEventRoot;
		return domNode;
	}

	if (tag === 3)
	{
		var domNode = vNode.h(vNode.g);
		_VirtualDom_applyFacts(domNode, eventNode, vNode.d);
		return domNode;
	}

	// at this point `tag` must be 1 or 2

	var domNode = vNode.f
		? _VirtualDom_doc.createElementNS(vNode.f, vNode.c)
		: _VirtualDom_doc.createElement(vNode.c);

	if (_VirtualDom_divertHrefToApp && vNode.c == 'a')
	{
		domNode.addEventListener('click', _VirtualDom_divertHrefToApp(domNode));
	}

	_VirtualDom_applyFacts(domNode, eventNode, vNode.d);

	for (var kids = vNode.e, i = 0; i < kids.length; i++)
	{
		_VirtualDom_appendChild(domNode, _VirtualDom_render(tag === 1 ? kids[i] : kids[i].b, eventNode));
	}

	return domNode;
}



// APPLY FACTS


function _VirtualDom_applyFacts(domNode, eventNode, facts)
{
	for (var key in facts)
	{
		var value = facts[key];

		key === 'a1'
			? _VirtualDom_applyStyles(domNode, value)
			:
		key === 'a0'
			? _VirtualDom_applyEvents(domNode, eventNode, value)
			:
		key === 'a3'
			? _VirtualDom_applyAttrs(domNode, value)
			:
		key === 'a4'
			? _VirtualDom_applyAttrsNS(domNode, value)
			:
		((key !== 'value' && key !== 'checked') || domNode[key] !== value) && (domNode[key] = value);
	}
}



// APPLY STYLES


function _VirtualDom_applyStyles(domNode, styles)
{
	var domNodeStyle = domNode.style;

	for (var key in styles)
	{
		domNodeStyle[key] = styles[key];
	}
}



// APPLY ATTRS


function _VirtualDom_applyAttrs(domNode, attrs)
{
	for (var key in attrs)
	{
		var value = attrs[key];
		typeof value !== 'undefined'
			? domNode.setAttribute(key, value)
			: domNode.removeAttribute(key);
	}
}



// APPLY NAMESPACED ATTRS


function _VirtualDom_applyAttrsNS(domNode, nsAttrs)
{
	for (var key in nsAttrs)
	{
		var pair = nsAttrs[key];
		var namespace = pair.f;
		var value = pair.o;

		typeof value !== 'undefined'
			? domNode.setAttributeNS(namespace, key, value)
			: domNode.removeAttributeNS(namespace, key);
	}
}



// APPLY EVENTS


function _VirtualDom_applyEvents(domNode, eventNode, events)
{
	var allCallbacks = domNode.elmFs || (domNode.elmFs = {});

	for (var key in events)
	{
		var newHandler = events[key];
		var oldCallback = allCallbacks[key];

		if (!newHandler)
		{
			domNode.removeEventListener(key, oldCallback);
			allCallbacks[key] = undefined;
			continue;
		}

		if (oldCallback)
		{
			var oldHandler = oldCallback.q;
			if (oldHandler.$ === newHandler.$)
			{
				oldCallback.q = newHandler;
				continue;
			}
			domNode.removeEventListener(key, oldCallback);
		}

		oldCallback = _VirtualDom_makeCallback(eventNode, newHandler);
		domNode.addEventListener(key, oldCallback,
			_VirtualDom_passiveSupported
			&& { passive: $elm$virtual_dom$VirtualDom$toHandlerInt(newHandler) < 2 }
		);
		allCallbacks[key] = oldCallback;
	}
}



// PASSIVE EVENTS


var _VirtualDom_passiveSupported;

try
{
	window.addEventListener('t', null, Object.defineProperty({}, 'passive', {
		get: function() { _VirtualDom_passiveSupported = true; }
	}));
}
catch(e) {}



// EVENT HANDLERS


function _VirtualDom_makeCallback(eventNode, initialHandler)
{
	function callback(event)
	{
		var handler = callback.q;
		var result = _Json_runHelp(handler.a, event);

		if (!$elm$core$Result$isOk(result))
		{
			return;
		}

		var tag = $elm$virtual_dom$VirtualDom$toHandlerInt(handler);

		// 0 = Normal
		// 1 = MayStopPropagation
		// 2 = MayPreventDefault
		// 3 = Custom

		var value = result.a;
		var message = !tag ? value : tag < 3 ? value.a : value.message;
		var stopPropagation = tag == 1 ? value.b : tag == 3 && value.stopPropagation;
		var currentEventNode = (
			stopPropagation && event.stopPropagation(),
			(tag == 2 ? value.b : tag == 3 && value.preventDefault) && event.preventDefault(),
			eventNode
		);
		var tagger;
		var i;
		while (tagger = currentEventNode.j)
		{
			if (typeof tagger == 'function')
			{
				message = tagger(message);
			}
			else
			{
				for (var i = tagger.length; i--; )
				{
					message = tagger[i](message);
				}
			}
			currentEventNode = currentEventNode.p;
		}
		currentEventNode(message, stopPropagation); // stopPropagation implies isSync
	}

	callback.q = initialHandler;

	return callback;
}

function _VirtualDom_equalEvents(x, y)
{
	return x.$ == y.$ && _Json_equality(x.a, y.a);
}



// DIFF


// TODO: Should we do patches like in iOS?
//
// type Patch
//   = At Int Patch
//   | Batch (List Patch)
//   | Change ...
//
// How could it not be better?
//
function _VirtualDom_diff(x, y)
{
	var patches = [];
	_VirtualDom_diffHelp(x, y, patches, 0);
	return patches;
}


function _VirtualDom_pushPatch(patches, type, index, data)
{
	var patch = {
		$: type,
		r: index,
		s: data,
		t: undefined,
		u: undefined
	};
	patches.push(patch);
	return patch;
}


function _VirtualDom_diffHelp(x, y, patches, index)
{
	if (x === y)
	{
		return;
	}

	var xType = x.$;
	var yType = y.$;

	// Bail if you run into different types of nodes. Implies that the
	// structure has changed significantly and it's not worth a diff.
	if (xType !== yType)
	{
		if (xType === 1 && yType === 2)
		{
			y = _VirtualDom_dekey(y);
			yType = 1;
		}
		else
		{
			_VirtualDom_pushPatch(patches, 0, index, y);
			return;
		}
	}

	// Now we know that both nodes are the same $.
	switch (yType)
	{
		case 5:
			var xRefs = x.l;
			var yRefs = y.l;
			var i = xRefs.length;
			var same = i === yRefs.length;
			while (same && i--)
			{
				same = xRefs[i] === yRefs[i];
			}
			if (same)
			{
				y.k = x.k;
				return;
			}
			y.k = y.m();
			var subPatches = [];
			_VirtualDom_diffHelp(x.k, y.k, subPatches, 0);
			subPatches.length > 0 && _VirtualDom_pushPatch(patches, 1, index, subPatches);
			return;

		case 4:
			// gather nested taggers
			var xTaggers = x.j;
			var yTaggers = y.j;
			var nesting = false;

			var xSubNode = x.k;
			while (xSubNode.$ === 4)
			{
				nesting = true;

				typeof xTaggers !== 'object'
					? xTaggers = [xTaggers, xSubNode.j]
					: xTaggers.push(xSubNode.j);

				xSubNode = xSubNode.k;
			}

			var ySubNode = y.k;
			while (ySubNode.$ === 4)
			{
				nesting = true;

				typeof yTaggers !== 'object'
					? yTaggers = [yTaggers, ySubNode.j]
					: yTaggers.push(ySubNode.j);

				ySubNode = ySubNode.k;
			}

			// Just bail if different numbers of taggers. This implies the
			// structure of the virtual DOM has changed.
			if (nesting && xTaggers.length !== yTaggers.length)
			{
				_VirtualDom_pushPatch(patches, 0, index, y);
				return;
			}

			// check if taggers are "the same"
			if (nesting ? !_VirtualDom_pairwiseRefEqual(xTaggers, yTaggers) : xTaggers !== yTaggers)
			{
				_VirtualDom_pushPatch(patches, 2, index, yTaggers);
			}

			// diff everything below the taggers
			_VirtualDom_diffHelp(xSubNode, ySubNode, patches, index + 1);
			return;

		case 0:
			if (x.a !== y.a)
			{
				_VirtualDom_pushPatch(patches, 3, index, y.a);
			}
			return;

		case 1:
			_VirtualDom_diffNodes(x, y, patches, index, _VirtualDom_diffKids);
			return;

		case 2:
			_VirtualDom_diffNodes(x, y, patches, index, _VirtualDom_diffKeyedKids);
			return;

		case 3:
			if (x.h !== y.h)
			{
				_VirtualDom_pushPatch(patches, 0, index, y);
				return;
			}

			var factsDiff = _VirtualDom_diffFacts(x.d, y.d);
			factsDiff && _VirtualDom_pushPatch(patches, 4, index, factsDiff);

			var patch = y.i(x.g, y.g);
			patch && _VirtualDom_pushPatch(patches, 5, index, patch);

			return;
	}
}

// assumes the incoming arrays are the same length
function _VirtualDom_pairwiseRefEqual(as, bs)
{
	for (var i = 0; i < as.length; i++)
	{
		if (as[i] !== bs[i])
		{
			return false;
		}
	}

	return true;
}

function _VirtualDom_diffNodes(x, y, patches, index, diffKids)
{
	// Bail if obvious indicators have changed. Implies more serious
	// structural changes such that it's not worth it to diff.
	if (x.c !== y.c || x.f !== y.f)
	{
		_VirtualDom_pushPatch(patches, 0, index, y);
		return;
	}

	var factsDiff = _VirtualDom_diffFacts(x.d, y.d);
	factsDiff && _VirtualDom_pushPatch(patches, 4, index, factsDiff);

	diffKids(x, y, patches, index);
}



// DIFF FACTS


// TODO Instead of creating a new diff object, it's possible to just test if
// there *is* a diff. During the actual patch, do the diff again and make the
// modifications directly. This way, there's no new allocations. Worth it?
function _VirtualDom_diffFacts(x, y, category)
{
	var diff;

	// look for changes and removals
	for (var xKey in x)
	{
		if (xKey === 'a1' || xKey === 'a0' || xKey === 'a3' || xKey === 'a4')
		{
			var subDiff = _VirtualDom_diffFacts(x[xKey], y[xKey] || {}, xKey);
			if (subDiff)
			{
				diff = diff || {};
				diff[xKey] = subDiff;
			}
			continue;
		}

		// remove if not in the new facts
		if (!(xKey in y))
		{
			diff = diff || {};
			diff[xKey] =
				!category
					? (typeof x[xKey] === 'string' ? '' : null)
					:
				(category === 'a1')
					? ''
					:
				(category === 'a0' || category === 'a3')
					? undefined
					:
				{ f: x[xKey].f, o: undefined };

			continue;
		}

		var xValue = x[xKey];
		var yValue = y[xKey];

		// reference equal, so don't worry about it
		if (xValue === yValue && xKey !== 'value' && xKey !== 'checked'
			|| category === 'a0' && _VirtualDom_equalEvents(xValue, yValue))
		{
			continue;
		}

		diff = diff || {};
		diff[xKey] = yValue;
	}

	// add new stuff
	for (var yKey in y)
	{
		if (!(yKey in x))
		{
			diff = diff || {};
			diff[yKey] = y[yKey];
		}
	}

	return diff;
}



// DIFF KIDS


function _VirtualDom_diffKids(xParent, yParent, patches, index)
{
	var xKids = xParent.e;
	var yKids = yParent.e;

	var xLen = xKids.length;
	var yLen = yKids.length;

	// FIGURE OUT IF THERE ARE INSERTS OR REMOVALS

	if (xLen > yLen)
	{
		_VirtualDom_pushPatch(patches, 6, index, {
			v: yLen,
			i: xLen - yLen
		});
	}
	else if (xLen < yLen)
	{
		_VirtualDom_pushPatch(patches, 7, index, {
			v: xLen,
			e: yKids
		});
	}

	// PAIRWISE DIFF EVERYTHING ELSE

	for (var minLen = xLen < yLen ? xLen : yLen, i = 0; i < minLen; i++)
	{
		var xKid = xKids[i];
		_VirtualDom_diffHelp(xKid, yKids[i], patches, ++index);
		index += xKid.b || 0;
	}
}



// KEYED DIFF


function _VirtualDom_diffKeyedKids(xParent, yParent, patches, rootIndex)
{
	var localPatches = [];

	var changes = {}; // Dict String Entry
	var inserts = []; // Array { index : Int, entry : Entry }
	// type Entry = { tag : String, vnode : VNode, index : Int, data : _ }

	var xKids = xParent.e;
	var yKids = yParent.e;
	var xLen = xKids.length;
	var yLen = yKids.length;
	var xIndex = 0;
	var yIndex = 0;

	var index = rootIndex;

	while (xIndex < xLen && yIndex < yLen)
	{
		var x = xKids[xIndex];
		var y = yKids[yIndex];

		var xKey = x.a;
		var yKey = y.a;
		var xNode = x.b;
		var yNode = y.b;

		var newMatch = undefined;
		var oldMatch = undefined;

		// check if keys match

		if (xKey === yKey)
		{
			index++;
			_VirtualDom_diffHelp(xNode, yNode, localPatches, index);
			index += xNode.b || 0;

			xIndex++;
			yIndex++;
			continue;
		}

		// look ahead 1 to detect insertions and removals.

		var xNext = xKids[xIndex + 1];
		var yNext = yKids[yIndex + 1];

		if (xNext)
		{
			var xNextKey = xNext.a;
			var xNextNode = xNext.b;
			oldMatch = yKey === xNextKey;
		}

		if (yNext)
		{
			var yNextKey = yNext.a;
			var yNextNode = yNext.b;
			newMatch = xKey === yNextKey;
		}


		// swap x and y
		if (newMatch && oldMatch)
		{
			index++;
			_VirtualDom_diffHelp(xNode, yNextNode, localPatches, index);
			_VirtualDom_insertNode(changes, localPatches, xKey, yNode, yIndex, inserts);
			index += xNode.b || 0;

			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNextNode, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 2;
			continue;
		}

		// insert y
		if (newMatch)
		{
			index++;
			_VirtualDom_insertNode(changes, localPatches, yKey, yNode, yIndex, inserts);
			_VirtualDom_diffHelp(xNode, yNextNode, localPatches, index);
			index += xNode.b || 0;

			xIndex += 1;
			yIndex += 2;
			continue;
		}

		// remove x
		if (oldMatch)
		{
			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNode, index);
			index += xNode.b || 0;

			index++;
			_VirtualDom_diffHelp(xNextNode, yNode, localPatches, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 1;
			continue;
		}

		// remove x, insert y
		if (xNext && xNextKey === yNextKey)
		{
			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNode, index);
			_VirtualDom_insertNode(changes, localPatches, yKey, yNode, yIndex, inserts);
			index += xNode.b || 0;

			index++;
			_VirtualDom_diffHelp(xNextNode, yNextNode, localPatches, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 2;
			continue;
		}

		break;
	}

	// eat up any remaining nodes with removeNode and insertNode

	while (xIndex < xLen)
	{
		index++;
		var x = xKids[xIndex];
		var xNode = x.b;
		_VirtualDom_removeNode(changes, localPatches, x.a, xNode, index);
		index += xNode.b || 0;
		xIndex++;
	}

	while (yIndex < yLen)
	{
		var endInserts = endInserts || [];
		var y = yKids[yIndex];
		_VirtualDom_insertNode(changes, localPatches, y.a, y.b, undefined, endInserts);
		yIndex++;
	}

	if (localPatches.length > 0 || inserts.length > 0 || endInserts)
	{
		_VirtualDom_pushPatch(patches, 8, rootIndex, {
			w: localPatches,
			x: inserts,
			y: endInserts
		});
	}
}



// CHANGES FROM KEYED DIFF


var _VirtualDom_POSTFIX = '_elmW6BL';


function _VirtualDom_insertNode(changes, localPatches, key, vnode, yIndex, inserts)
{
	var entry = changes[key];

	// never seen this key before
	if (!entry)
	{
		entry = {
			c: 0,
			z: vnode,
			r: yIndex,
			s: undefined
		};

		inserts.push({ r: yIndex, A: entry });
		changes[key] = entry;

		return;
	}

	// this key was removed earlier, a match!
	if (entry.c === 1)
	{
		inserts.push({ r: yIndex, A: entry });

		entry.c = 2;
		var subPatches = [];
		_VirtualDom_diffHelp(entry.z, vnode, subPatches, entry.r);
		entry.r = yIndex;
		entry.s.s = {
			w: subPatches,
			A: entry
		};

		return;
	}

	// this key has already been inserted or moved, a duplicate!
	_VirtualDom_insertNode(changes, localPatches, key + _VirtualDom_POSTFIX, vnode, yIndex, inserts);
}


function _VirtualDom_removeNode(changes, localPatches, key, vnode, index)
{
	var entry = changes[key];

	// never seen this key before
	if (!entry)
	{
		var patch = _VirtualDom_pushPatch(localPatches, 9, index, undefined);

		changes[key] = {
			c: 1,
			z: vnode,
			r: index,
			s: patch
		};

		return;
	}

	// this key was inserted earlier, a match!
	if (entry.c === 0)
	{
		entry.c = 2;
		var subPatches = [];
		_VirtualDom_diffHelp(vnode, entry.z, subPatches, index);

		_VirtualDom_pushPatch(localPatches, 9, index, {
			w: subPatches,
			A: entry
		});

		return;
	}

	// this key has already been removed or moved, a duplicate!
	_VirtualDom_removeNode(changes, localPatches, key + _VirtualDom_POSTFIX, vnode, index);
}



// ADD DOM NODES
//
// Each DOM node has an "index" assigned in order of traversal. It is important
// to minimize our crawl over the actual DOM, so these indexes (along with the
// descendantsCount of virtual nodes) let us skip touching entire subtrees of
// the DOM if we know there are no patches there.


function _VirtualDom_addDomNodes(domNode, vNode, patches, eventNode)
{
	_VirtualDom_addDomNodesHelp(domNode, vNode, patches, 0, 0, vNode.b, eventNode);
}


// assumes `patches` is non-empty and indexes increase monotonically.
function _VirtualDom_addDomNodesHelp(domNode, vNode, patches, i, low, high, eventNode)
{
	var patch = patches[i];
	var index = patch.r;

	while (index === low)
	{
		var patchType = patch.$;

		if (patchType === 1)
		{
			_VirtualDom_addDomNodes(domNode, vNode.k, patch.s, eventNode);
		}
		else if (patchType === 8)
		{
			patch.t = domNode;
			patch.u = eventNode;

			var subPatches = patch.s.w;
			if (subPatches.length > 0)
			{
				_VirtualDom_addDomNodesHelp(domNode, vNode, subPatches, 0, low, high, eventNode);
			}
		}
		else if (patchType === 9)
		{
			patch.t = domNode;
			patch.u = eventNode;

			var data = patch.s;
			if (data)
			{
				data.A.s = domNode;
				var subPatches = data.w;
				if (subPatches.length > 0)
				{
					_VirtualDom_addDomNodesHelp(domNode, vNode, subPatches, 0, low, high, eventNode);
				}
			}
		}
		else
		{
			patch.t = domNode;
			patch.u = eventNode;
		}

		i++;

		if (!(patch = patches[i]) || (index = patch.r) > high)
		{
			return i;
		}
	}

	var tag = vNode.$;

	if (tag === 4)
	{
		var subNode = vNode.k;

		while (subNode.$ === 4)
		{
			subNode = subNode.k;
		}

		return _VirtualDom_addDomNodesHelp(domNode, subNode, patches, i, low + 1, high, domNode.elm_event_node_ref);
	}

	// tag must be 1 or 2 at this point

	var vKids = vNode.e;
	var childNodes = domNode.childNodes;
	for (var j = 0; j < vKids.length; j++)
	{
		low++;
		var vKid = tag === 1 ? vKids[j] : vKids[j].b;
		var nextLow = low + (vKid.b || 0);
		if (low <= index && index <= nextLow)
		{
			i = _VirtualDom_addDomNodesHelp(childNodes[j], vKid, patches, i, low, nextLow, eventNode);
			if (!(patch = patches[i]) || (index = patch.r) > high)
			{
				return i;
			}
		}
		low = nextLow;
	}
	return i;
}



// APPLY PATCHES


function _VirtualDom_applyPatches(rootDomNode, oldVirtualNode, patches, eventNode)
{
	if (patches.length === 0)
	{
		return rootDomNode;
	}

	_VirtualDom_addDomNodes(rootDomNode, oldVirtualNode, patches, eventNode);
	return _VirtualDom_applyPatchesHelp(rootDomNode, patches);
}

function _VirtualDom_applyPatchesHelp(rootDomNode, patches)
{
	for (var i = 0; i < patches.length; i++)
	{
		var patch = patches[i];
		var localDomNode = patch.t
		var newNode = _VirtualDom_applyPatch(localDomNode, patch);
		if (localDomNode === rootDomNode)
		{
			rootDomNode = newNode;
		}
	}
	return rootDomNode;
}

function _VirtualDom_applyPatch(domNode, patch)
{
	switch (patch.$)
	{
		case 0:
			return _VirtualDom_applyPatchRedraw(domNode, patch.s, patch.u);

		case 4:
			_VirtualDom_applyFacts(domNode, patch.u, patch.s);
			return domNode;

		case 3:
			domNode.replaceData(0, domNode.length, patch.s);
			return domNode;

		case 1:
			return _VirtualDom_applyPatchesHelp(domNode, patch.s);

		case 2:
			if (domNode.elm_event_node_ref)
			{
				domNode.elm_event_node_ref.j = patch.s;
			}
			else
			{
				domNode.elm_event_node_ref = { j: patch.s, p: patch.u };
			}
			return domNode;

		case 6:
			var data = patch.s;
			for (var i = 0; i < data.i; i++)
			{
				domNode.removeChild(domNode.childNodes[data.v]);
			}
			return domNode;

		case 7:
			var data = patch.s;
			var kids = data.e;
			var i = data.v;
			var theEnd = domNode.childNodes[i];
			for (; i < kids.length; i++)
			{
				domNode.insertBefore(_VirtualDom_render(kids[i], patch.u), theEnd);
			}
			return domNode;

		case 9:
			var data = patch.s;
			if (!data)
			{
				domNode.parentNode.removeChild(domNode);
				return domNode;
			}
			var entry = data.A;
			if (typeof entry.r !== 'undefined')
			{
				domNode.parentNode.removeChild(domNode);
			}
			entry.s = _VirtualDom_applyPatchesHelp(domNode, data.w);
			return domNode;

		case 8:
			return _VirtualDom_applyPatchReorder(domNode, patch);

		case 5:
			return patch.s(domNode);

		default:
			_Debug_crash(10); // 'Ran into an unknown patch!'
	}
}


function _VirtualDom_applyPatchRedraw(domNode, vNode, eventNode)
{
	var parentNode = domNode.parentNode;
	var newNode = _VirtualDom_render(vNode, eventNode);

	if (!newNode.elm_event_node_ref)
	{
		newNode.elm_event_node_ref = domNode.elm_event_node_ref;
	}

	if (parentNode && newNode !== domNode)
	{
		parentNode.replaceChild(newNode, domNode);
	}
	return newNode;
}


function _VirtualDom_applyPatchReorder(domNode, patch)
{
	var data = patch.s;

	// remove end inserts
	var frag = _VirtualDom_applyPatchReorderEndInsertsHelp(data.y, patch);

	// removals
	domNode = _VirtualDom_applyPatchesHelp(domNode, data.w);

	// inserts
	var inserts = data.x;
	for (var i = 0; i < inserts.length; i++)
	{
		var insert = inserts[i];
		var entry = insert.A;
		var node = entry.c === 2
			? entry.s
			: _VirtualDom_render(entry.z, patch.u);
		domNode.insertBefore(node, domNode.childNodes[insert.r]);
	}

	// add end inserts
	if (frag)
	{
		_VirtualDom_appendChild(domNode, frag);
	}

	return domNode;
}


function _VirtualDom_applyPatchReorderEndInsertsHelp(endInserts, patch)
{
	if (!endInserts)
	{
		return;
	}

	var frag = _VirtualDom_doc.createDocumentFragment();
	for (var i = 0; i < endInserts.length; i++)
	{
		var insert = endInserts[i];
		var entry = insert.A;
		_VirtualDom_appendChild(frag, entry.c === 2
			? entry.s
			: _VirtualDom_render(entry.z, patch.u)
		);
	}
	return frag;
}


function _VirtualDom_virtualize(node)
{
	// TEXT NODES

	if (node.nodeType === 3)
	{
		return _VirtualDom_text(node.textContent);
	}


	// WEIRD NODES

	if (node.nodeType !== 1)
	{
		return _VirtualDom_text('');
	}


	// ELEMENT NODES

	var attrList = _List_Nil;
	var attrs = node.attributes;
	for (var i = attrs.length; i--; )
	{
		var attr = attrs[i];
		var name = attr.name;
		var value = attr.value;
		attrList = _List_Cons( A2(_VirtualDom_attribute, name, value), attrList );
	}

	var tag = node.tagName.toLowerCase();
	var kidList = _List_Nil;
	var kids = node.childNodes;

	for (var i = kids.length; i--; )
	{
		kidList = _List_Cons(_VirtualDom_virtualize(kids[i]), kidList);
	}
	return A3(_VirtualDom_node, tag, attrList, kidList);
}

function _VirtualDom_dekey(keyedNode)
{
	var keyedKids = keyedNode.e;
	var len = keyedKids.length;
	var kids = new Array(len);
	for (var i = 0; i < len; i++)
	{
		kids[i] = keyedKids[i].b;
	}

	return {
		$: 1,
		c: keyedNode.c,
		d: keyedNode.d,
		e: kids,
		f: keyedNode.f,
		b: keyedNode.b
	};
}




// ELEMENT


var _Debugger_element;

var _Browser_element = _Debugger_element || F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.init,
		impl.update,
		impl.subscriptions,
		function(sendToApp, initialModel) {
			var view = impl.view;
			/**_UNUSED/
			var domNode = args['node'];
			//*/
			/**/
			var domNode = args && args['node'] ? args['node'] : _Debug_crash(0);
			//*/
			var currNode = _VirtualDom_virtualize(domNode);

			return _Browser_makeAnimator(initialModel, function(model)
			{
				var nextNode = view(model);
				var patches = _VirtualDom_diff(currNode, nextNode);
				domNode = _VirtualDom_applyPatches(domNode, currNode, patches, sendToApp);
				currNode = nextNode;
			});
		}
	);
});



// DOCUMENT


var _Debugger_document;

var _Browser_document = _Debugger_document || F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.init,
		impl.update,
		impl.subscriptions,
		function(sendToApp, initialModel) {
			var divertHrefToApp = impl.setup && impl.setup(sendToApp)
			var view = impl.view;
			var title = _VirtualDom_doc.title;
			var bodyNode = _VirtualDom_doc.body;
			var currNode = _VirtualDom_virtualize(bodyNode);
			return _Browser_makeAnimator(initialModel, function(model)
			{
				_VirtualDom_divertHrefToApp = divertHrefToApp;
				var doc = view(model);
				var nextNode = _VirtualDom_node('body')(_List_Nil)(doc.body);
				var patches = _VirtualDom_diff(currNode, nextNode);
				bodyNode = _VirtualDom_applyPatches(bodyNode, currNode, patches, sendToApp);
				currNode = nextNode;
				_VirtualDom_divertHrefToApp = 0;
				(title !== doc.title) && (_VirtualDom_doc.title = title = doc.title);
			});
		}
	);
});



// ANIMATION


var _Browser_cancelAnimationFrame =
	typeof cancelAnimationFrame !== 'undefined'
		? cancelAnimationFrame
		: function(id) { clearTimeout(id); };

var _Browser_requestAnimationFrame =
	typeof requestAnimationFrame !== 'undefined'
		? requestAnimationFrame
		: function(callback) { return setTimeout(callback, 1000 / 60); };


function _Browser_makeAnimator(model, draw)
{
	draw(model);

	var state = 0;

	function updateIfNeeded()
	{
		state = state === 1
			? 0
			: ( _Browser_requestAnimationFrame(updateIfNeeded), draw(model), 1 );
	}

	return function(nextModel, isSync)
	{
		model = nextModel;

		isSync
			? ( draw(model),
				state === 2 && (state = 1)
				)
			: ( state === 0 && _Browser_requestAnimationFrame(updateIfNeeded),
				state = 2
				);
	};
}



// APPLICATION


function _Browser_application(impl)
{
	var onUrlChange = impl.onUrlChange;
	var onUrlRequest = impl.onUrlRequest;
	var key = function() { key.a(onUrlChange(_Browser_getUrl())); };
key['elm-hot-nav-key'] = true

	return _Browser_document({
		setup: function(sendToApp)
		{
			key.a = sendToApp;
			_Browser_window.addEventListener('popstate', key);
			_Browser_window.navigator.userAgent.indexOf('Trident') < 0 || _Browser_window.addEventListener('hashchange', key);

			return F2(function(domNode, event)
			{
				if (!event.ctrlKey && !event.metaKey && !event.shiftKey && event.button < 1 && !domNode.target && !domNode.hasAttribute('download'))
				{
					event.preventDefault();
					var href = domNode.href;
					var curr = _Browser_getUrl();
					var next = $elm$url$Url$fromString(href).a;
					sendToApp(onUrlRequest(
						(next
							&& curr.protocol === next.protocol
							&& curr.host === next.host
							&& curr.port_.a === next.port_.a
						)
							? $elm$browser$Browser$Internal(next)
							: $elm$browser$Browser$External(href)
					));
				}
			});
		},
		init: function(flags)
		{
			return A3(impl.init, flags, _Browser_getUrl(), key);
		},
		view: impl.view,
		update: impl.update,
		subscriptions: impl.subscriptions
	});
}

function _Browser_getUrl()
{
	return $elm$url$Url$fromString(_VirtualDom_doc.location.href).a || _Debug_crash(1);
}

var _Browser_go = F2(function(key, n)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		n && history.go(n);
		key();
	}));
});

var _Browser_pushUrl = F2(function(key, url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		history.pushState({}, '', url);
		key();
	}));
});

var _Browser_replaceUrl = F2(function(key, url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		history.replaceState({}, '', url);
		key();
	}));
});



// GLOBAL EVENTS


var _Browser_fakeNode = { addEventListener: function() {}, removeEventListener: function() {} };
var _Browser_doc = typeof document !== 'undefined' ? document : _Browser_fakeNode;
var _Browser_window = typeof window !== 'undefined' ? window : _Browser_fakeNode;

var _Browser_on = F3(function(node, eventName, sendToSelf)
{
	return _Scheduler_spawn(_Scheduler_binding(function(callback)
	{
		function handler(event)	{ _Scheduler_rawSpawn(sendToSelf(event)); }
		node.addEventListener(eventName, handler, _VirtualDom_passiveSupported && { passive: true });
		return function() { node.removeEventListener(eventName, handler); };
	}));
});

var _Browser_decodeEvent = F2(function(decoder, event)
{
	var result = _Json_runHelp(decoder, event);
	return $elm$core$Result$isOk(result) ? $elm$core$Maybe$Just(result.a) : $elm$core$Maybe$Nothing;
});



// PAGE VISIBILITY


function _Browser_visibilityInfo()
{
	return (typeof _VirtualDom_doc.hidden !== 'undefined')
		? { hidden: 'hidden', change: 'visibilitychange' }
		:
	(typeof _VirtualDom_doc.mozHidden !== 'undefined')
		? { hidden: 'mozHidden', change: 'mozvisibilitychange' }
		:
	(typeof _VirtualDom_doc.msHidden !== 'undefined')
		? { hidden: 'msHidden', change: 'msvisibilitychange' }
		:
	(typeof _VirtualDom_doc.webkitHidden !== 'undefined')
		? { hidden: 'webkitHidden', change: 'webkitvisibilitychange' }
		: { hidden: 'hidden', change: 'visibilitychange' };
}



// ANIMATION FRAMES


function _Browser_rAF()
{
	return _Scheduler_binding(function(callback)
	{
		var id = _Browser_requestAnimationFrame(function() {
			callback(_Scheduler_succeed(Date.now()));
		});

		return function() {
			_Browser_cancelAnimationFrame(id);
		};
	});
}


function _Browser_now()
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(Date.now()));
	});
}



// DOM STUFF


function _Browser_withNode(id, doStuff)
{
	return _Scheduler_binding(function(callback)
	{
		_Browser_requestAnimationFrame(function() {
			var node = document.getElementById(id);
			callback(node
				? _Scheduler_succeed(doStuff(node))
				: _Scheduler_fail($elm$browser$Browser$Dom$NotFound(id))
			);
		});
	});
}


function _Browser_withWindow(doStuff)
{
	return _Scheduler_binding(function(callback)
	{
		_Browser_requestAnimationFrame(function() {
			callback(_Scheduler_succeed(doStuff()));
		});
	});
}


// FOCUS and BLUR


var _Browser_call = F2(function(functionName, id)
{
	return _Browser_withNode(id, function(node) {
		node[functionName]();
		return _Utils_Tuple0;
	});
});



// WINDOW VIEWPORT


function _Browser_getViewport()
{
	return {
		scene: _Browser_getScene(),
		viewport: {
			x: _Browser_window.pageXOffset,
			y: _Browser_window.pageYOffset,
			width: _Browser_doc.documentElement.clientWidth,
			height: _Browser_doc.documentElement.clientHeight
		}
	};
}

function _Browser_getScene()
{
	var body = _Browser_doc.body;
	var elem = _Browser_doc.documentElement;
	return {
		width: Math.max(body.scrollWidth, body.offsetWidth, elem.scrollWidth, elem.offsetWidth, elem.clientWidth),
		height: Math.max(body.scrollHeight, body.offsetHeight, elem.scrollHeight, elem.offsetHeight, elem.clientHeight)
	};
}

var _Browser_setViewport = F2(function(x, y)
{
	return _Browser_withWindow(function()
	{
		_Browser_window.scroll(x, y);
		return _Utils_Tuple0;
	});
});



// ELEMENT VIEWPORT


function _Browser_getViewportOf(id)
{
	return _Browser_withNode(id, function(node)
	{
		return {
			scene: {
				width: node.scrollWidth,
				height: node.scrollHeight
			},
			viewport: {
				x: node.scrollLeft,
				y: node.scrollTop,
				width: node.clientWidth,
				height: node.clientHeight
			}
		};
	});
}


var _Browser_setViewportOf = F3(function(id, x, y)
{
	return _Browser_withNode(id, function(node)
	{
		node.scrollLeft = x;
		node.scrollTop = y;
		return _Utils_Tuple0;
	});
});



// ELEMENT


function _Browser_getElement(id)
{
	return _Browser_withNode(id, function(node)
	{
		var rect = node.getBoundingClientRect();
		var x = _Browser_window.pageXOffset;
		var y = _Browser_window.pageYOffset;
		return {
			scene: _Browser_getScene(),
			viewport: {
				x: x,
				y: y,
				width: _Browser_doc.documentElement.clientWidth,
				height: _Browser_doc.documentElement.clientHeight
			},
			element: {
				x: x + rect.left,
				y: y + rect.top,
				width: rect.width,
				height: rect.height
			}
		};
	});
}



// LOAD and RELOAD


function _Browser_reload(skipCache)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function(callback)
	{
		_VirtualDom_doc.location.reload(skipCache);
	}));
}

function _Browser_load(url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function(callback)
	{
		try
		{
			_Browser_window.location = url;
		}
		catch(err)
		{
			// Only Firefox can throw a NS_ERROR_MALFORMED_URI exception here.
			// Other browsers reload the page, so let's be consistent about that.
			_VirtualDom_doc.location.reload(false);
		}
	}));
}


function _Url_percentEncode(string)
{
	return encodeURIComponent(string);
}

function _Url_percentDecode(string)
{
	try
	{
		return $elm$core$Maybe$Just(decodeURIComponent(string));
	}
	catch (e)
	{
		return $elm$core$Maybe$Nothing;
	}
}


function _Time_now(millisToPosix)
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(millisToPosix(Date.now())));
	});
}

var _Time_setInterval = F2(function(interval, task)
{
	return _Scheduler_binding(function(callback)
	{
		var id = setInterval(function() { _Scheduler_rawSpawn(task); }, interval);
		return function() { clearInterval(id); };
	});
});

function _Time_here()
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(
			A2($elm$time$Time$customZone, -(new Date().getTimezoneOffset()), _List_Nil)
		));
	});
}


function _Time_getZoneName()
{
	return _Scheduler_binding(function(callback)
	{
		try
		{
			var name = $elm$time$Time$Name(Intl.DateTimeFormat().resolvedOptions().timeZone);
		}
		catch (e)
		{
			var name = $elm$time$Time$Offset(new Date().getTimezoneOffset());
		}
		callback(_Scheduler_succeed(name));
	});
}



// SEND REQUEST

var _Http_toTask = F3(function(router, toTask, request)
{
	return _Scheduler_binding(function(callback)
	{
		function done(response) {
			callback(toTask(request.expect.a(response)));
		}

		var xhr = new XMLHttpRequest();
		xhr.addEventListener('error', function() { done($elm$http$Http$NetworkError_); });
		xhr.addEventListener('timeout', function() { done($elm$http$Http$Timeout_); });
		xhr.addEventListener('load', function() { done(_Http_toResponse(request.expect.b, xhr)); });
		$elm$core$Maybe$isJust(request.tracker) && _Http_track(router, xhr, request.tracker.a);

		try {
			xhr.open(request.method, request.url, true);
		} catch (e) {
			return done($elm$http$Http$BadUrl_(request.url));
		}

		_Http_configureRequest(xhr, request);

		request.body.a && xhr.setRequestHeader('Content-Type', request.body.a);
		xhr.send(request.body.b);

		return function() { xhr.c = true; xhr.abort(); };
	});
});


// CONFIGURE

function _Http_configureRequest(xhr, request)
{
	for (var headers = request.headers; headers.b; headers = headers.b) // WHILE_CONS
	{
		xhr.setRequestHeader(headers.a.a, headers.a.b);
	}
	xhr.timeout = request.timeout.a || 0;
	xhr.responseType = request.expect.d;
	xhr.withCredentials = request.allowCookiesFromOtherDomains;
}


// RESPONSES

function _Http_toResponse(toBody, xhr)
{
	return A2(
		200 <= xhr.status && xhr.status < 300 ? $elm$http$Http$GoodStatus_ : $elm$http$Http$BadStatus_,
		_Http_toMetadata(xhr),
		toBody(xhr.response)
	);
}


// METADATA

function _Http_toMetadata(xhr)
{
	return {
		url: xhr.responseURL,
		statusCode: xhr.status,
		statusText: xhr.statusText,
		headers: _Http_parseHeaders(xhr.getAllResponseHeaders())
	};
}


// HEADERS

function _Http_parseHeaders(rawHeaders)
{
	if (!rawHeaders)
	{
		return $elm$core$Dict$empty;
	}

	var headers = $elm$core$Dict$empty;
	var headerPairs = rawHeaders.split('\r\n');
	for (var i = headerPairs.length; i--; )
	{
		var headerPair = headerPairs[i];
		var index = headerPair.indexOf(': ');
		if (index > 0)
		{
			var key = headerPair.substring(0, index);
			var value = headerPair.substring(index + 2);

			headers = A3($elm$core$Dict$update, key, function(oldValue) {
				return $elm$core$Maybe$Just($elm$core$Maybe$isJust(oldValue)
					? value + ', ' + oldValue.a
					: value
				);
			}, headers);
		}
	}
	return headers;
}


// EXPECT

var _Http_expect = F3(function(type, toBody, toValue)
{
	return {
		$: 0,
		d: type,
		b: toBody,
		a: toValue
	};
});

var _Http_mapExpect = F2(function(func, expect)
{
	return {
		$: 0,
		d: expect.d,
		b: expect.b,
		a: function(x) { return func(expect.a(x)); }
	};
});

function _Http_toDataView(arrayBuffer)
{
	return new DataView(arrayBuffer);
}


// BODY and PARTS

var _Http_emptyBody = { $: 0 };
var _Http_pair = F2(function(a, b) { return { $: 0, a: a, b: b }; });

function _Http_toFormData(parts)
{
	for (var formData = new FormData(); parts.b; parts = parts.b) // WHILE_CONS
	{
		var part = parts.a;
		formData.append(part.a, part.b);
	}
	return formData;
}

var _Http_bytesToBlob = F2(function(mime, bytes)
{
	return new Blob([bytes], { type: mime });
});


// PROGRESS

function _Http_track(router, xhr, tracker)
{
	// TODO check out lengthComputable on loadstart event

	xhr.upload.addEventListener('progress', function(event) {
		if (xhr.c) { return; }
		_Scheduler_rawSpawn(A2($elm$core$Platform$sendToSelf, router, _Utils_Tuple2(tracker, $elm$http$Http$Sending({
			sent: event.loaded,
			size: event.total
		}))));
	});
	xhr.addEventListener('progress', function(event) {
		if (xhr.c) { return; }
		_Scheduler_rawSpawn(A2($elm$core$Platform$sendToSelf, router, _Utils_Tuple2(tracker, $elm$http$Http$Receiving({
			received: event.loaded,
			size: event.lengthComputable ? $elm$core$Maybe$Just(event.total) : $elm$core$Maybe$Nothing
		}))));
	});
}


// DECODER

var _File_decoder = _Json_decodePrim(function(value) {
	// NOTE: checks if `File` exists in case this is run on node
	return (typeof File !== 'undefined' && value instanceof File)
		? $elm$core$Result$Ok(value)
		: _Json_expecting('a FILE', value);
});


// METADATA

function _File_name(file) { return file.name; }
function _File_mime(file) { return file.type; }
function _File_size(file) { return file.size; }

function _File_lastModified(file)
{
	return $elm$time$Time$millisToPosix(file.lastModified);
}


// DOWNLOAD

var _File_downloadNode;

function _File_getDownloadNode()
{
	return _File_downloadNode || (_File_downloadNode = document.createElement('a'));
}

var _File_download = F3(function(name, mime, content)
{
	return _Scheduler_binding(function(callback)
	{
		var blob = new Blob([content], {type: mime});

		// for IE10+
		if (navigator.msSaveOrOpenBlob)
		{
			navigator.msSaveOrOpenBlob(blob, name);
			return;
		}

		// for HTML5
		var node = _File_getDownloadNode();
		var objectUrl = URL.createObjectURL(blob);
		node.href = objectUrl;
		node.download = name;
		_File_click(node);
		URL.revokeObjectURL(objectUrl);
	});
});

function _File_downloadUrl(href)
{
	return _Scheduler_binding(function(callback)
	{
		var node = _File_getDownloadNode();
		node.href = href;
		node.download = '';
		node.origin === location.origin || (node.target = '_blank');
		_File_click(node);
	});
}


// IE COMPATIBILITY

function _File_makeBytesSafeForInternetExplorer(bytes)
{
	// only needed by IE10 and IE11 to fix https://github.com/elm/file/issues/10
	// all other browsers can just run `new Blob([bytes])` directly with no problem
	//
	return new Uint8Array(bytes.buffer, bytes.byteOffset, bytes.byteLength);
}

function _File_click(node)
{
	// only needed by IE10 and IE11 to fix https://github.com/elm/file/issues/11
	// all other browsers have MouseEvent and do not need this conditional stuff
	//
	if (typeof MouseEvent === 'function')
	{
		node.dispatchEvent(new MouseEvent('click'));
	}
	else
	{
		var event = document.createEvent('MouseEvents');
		event.initMouseEvent('click', true, true, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
		document.body.appendChild(node);
		node.dispatchEvent(event);
		document.body.removeChild(node);
	}
}


// UPLOAD

var _File_node;

function _File_uploadOne(mimes)
{
	return _Scheduler_binding(function(callback)
	{
		_File_node = document.createElement('input');
		_File_node.type = 'file';
		_File_node.accept = A2($elm$core$String$join, ',', mimes);
		_File_node.addEventListener('change', function(event)
		{
			callback(_Scheduler_succeed(event.target.files[0]));
		});
		_File_click(_File_node);
	});
}

function _File_uploadOneOrMore(mimes)
{
	return _Scheduler_binding(function(callback)
	{
		_File_node = document.createElement('input');
		_File_node.type = 'file';
		_File_node.multiple = true;
		_File_node.accept = A2($elm$core$String$join, ',', mimes);
		_File_node.addEventListener('change', function(event)
		{
			var elmFiles = _List_fromArray(event.target.files);
			callback(_Scheduler_succeed(_Utils_Tuple2(elmFiles.a, elmFiles.b)));
		});
		_File_click(_File_node);
	});
}


// CONTENT

function _File_toString(blob)
{
	return _Scheduler_binding(function(callback)
	{
		var reader = new FileReader();
		reader.addEventListener('loadend', function() {
			callback(_Scheduler_succeed(reader.result));
		});
		reader.readAsText(blob);
		return function() { reader.abort(); };
	});
}

function _File_toBytes(blob)
{
	return _Scheduler_binding(function(callback)
	{
		var reader = new FileReader();
		reader.addEventListener('loadend', function() {
			callback(_Scheduler_succeed(new DataView(reader.result)));
		});
		reader.readAsArrayBuffer(blob);
		return function() { reader.abort(); };
	});
}

function _File_toUrl(blob)
{
	return _Scheduler_binding(function(callback)
	{
		var reader = new FileReader();
		reader.addEventListener('loadend', function() {
			callback(_Scheduler_succeed(reader.result));
		});
		reader.readAsDataURL(blob);
		return function() { reader.abort(); };
	});
}



// CREATE

var _Regex_never = /.^/;

var _Regex_fromStringWith = F2(function(options, string)
{
	var flags = 'g';
	if (options.multiline) { flags += 'm'; }
	if (options.caseInsensitive) { flags += 'i'; }

	try
	{
		return $elm$core$Maybe$Just(new RegExp(string, flags));
	}
	catch(error)
	{
		return $elm$core$Maybe$Nothing;
	}
});


// USE

var _Regex_contains = F2(function(re, string)
{
	return string.match(re) !== null;
});


var _Regex_findAtMost = F3(function(n, re, str)
{
	var out = [];
	var number = 0;
	var string = str;
	var lastIndex = re.lastIndex;
	var prevLastIndex = -1;
	var result;
	while (number++ < n && (result = re.exec(string)))
	{
		if (prevLastIndex == re.lastIndex) break;
		var i = result.length - 1;
		var subs = new Array(i);
		while (i > 0)
		{
			var submatch = result[i];
			subs[--i] = submatch
				? $elm$core$Maybe$Just(submatch)
				: $elm$core$Maybe$Nothing;
		}
		out.push(A4($elm$regex$Regex$Match, result[0], result.index, number, _List_fromArray(subs)));
		prevLastIndex = re.lastIndex;
	}
	re.lastIndex = lastIndex;
	return _List_fromArray(out);
});


var _Regex_replaceAtMost = F4(function(n, re, replacer, string)
{
	var count = 0;
	function jsReplacer(match)
	{
		if (count++ >= n)
		{
			return match;
		}
		var i = arguments.length - 3;
		var submatches = new Array(i);
		while (i > 0)
		{
			var submatch = arguments[i];
			submatches[--i] = submatch
				? $elm$core$Maybe$Just(submatch)
				: $elm$core$Maybe$Nothing;
		}
		return replacer(A4($elm$regex$Regex$Match, match, arguments[arguments.length - 2], count, _List_fromArray(submatches)));
	}
	return string.replace(re, jsReplacer);
});

var _Regex_splitAtMost = F3(function(n, re, str)
{
	var string = str;
	var out = [];
	var start = re.lastIndex;
	var restoreLastIndex = re.lastIndex;
	while (n--)
	{
		var result = re.exec(string);
		if (!result) break;
		out.push(string.slice(start, result.index));
		start = re.lastIndex;
	}
	out.push(string.slice(start));
	re.lastIndex = restoreLastIndex;
	return _List_fromArray(out);
});

var _Regex_infinity = Infinity;



var _Bitwise_and = F2(function(a, b)
{
	return a & b;
});

var _Bitwise_or = F2(function(a, b)
{
	return a | b;
});

var _Bitwise_xor = F2(function(a, b)
{
	return a ^ b;
});

function _Bitwise_complement(a)
{
	return ~a;
};

var _Bitwise_shiftLeftBy = F2(function(offset, a)
{
	return a << offset;
});

var _Bitwise_shiftRightBy = F2(function(offset, a)
{
	return a >> offset;
});

var _Bitwise_shiftRightZfBy = F2(function(offset, a)
{
	return a >>> offset;
});


// BYTES

function _Bytes_width(bytes)
{
	return bytes.byteLength;
}

var _Bytes_getHostEndianness = F2(function(le, be)
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(new Uint8Array(new Uint32Array([1]))[0] === 1 ? le : be));
	});
});


// ENCODERS

function _Bytes_encode(encoder)
{
	var mutableBytes = new DataView(new ArrayBuffer($elm$bytes$Bytes$Encode$getWidth(encoder)));
	$elm$bytes$Bytes$Encode$write(encoder)(mutableBytes)(0);
	return mutableBytes;
}


// SIGNED INTEGERS

var _Bytes_write_i8  = F3(function(mb, i, n) { mb.setInt8(i, n); return i + 1; });
var _Bytes_write_i16 = F4(function(mb, i, n, isLE) { mb.setInt16(i, n, isLE); return i + 2; });
var _Bytes_write_i32 = F4(function(mb, i, n, isLE) { mb.setInt32(i, n, isLE); return i + 4; });


// UNSIGNED INTEGERS

var _Bytes_write_u8  = F3(function(mb, i, n) { mb.setUint8(i, n); return i + 1 ;});
var _Bytes_write_u16 = F4(function(mb, i, n, isLE) { mb.setUint16(i, n, isLE); return i + 2; });
var _Bytes_write_u32 = F4(function(mb, i, n, isLE) { mb.setUint32(i, n, isLE); return i + 4; });


// FLOATS

var _Bytes_write_f32 = F4(function(mb, i, n, isLE) { mb.setFloat32(i, n, isLE); return i + 4; });
var _Bytes_write_f64 = F4(function(mb, i, n, isLE) { mb.setFloat64(i, n, isLE); return i + 8; });


// BYTES

var _Bytes_write_bytes = F3(function(mb, offset, bytes)
{
	for (var i = 0, len = bytes.byteLength, limit = len - 4; i <= limit; i += 4)
	{
		mb.setUint32(offset + i, bytes.getUint32(i));
	}
	for (; i < len; i++)
	{
		mb.setUint8(offset + i, bytes.getUint8(i));
	}
	return offset + len;
});


// STRINGS

function _Bytes_getStringWidth(string)
{
	for (var width = 0, i = 0; i < string.length; i++)
	{
		var code = string.charCodeAt(i);
		width +=
			(code < 0x80) ? 1 :
			(code < 0x800) ? 2 :
			(code < 0xD800 || 0xDBFF < code) ? 3 : (i++, 4);
	}
	return width;
}

var _Bytes_write_string = F3(function(mb, offset, string)
{
	for (var i = 0; i < string.length; i++)
	{
		var code = string.charCodeAt(i);
		offset +=
			(code < 0x80)
				? (mb.setUint8(offset, code)
				, 1
				)
				:
			(code < 0x800)
				? (mb.setUint16(offset, 0xC080 /* 0b1100000010000000 */
					| (code >>> 6 & 0x1F /* 0b00011111 */) << 8
					| code & 0x3F /* 0b00111111 */)
				, 2
				)
				:
			(code < 0xD800 || 0xDBFF < code)
				? (mb.setUint16(offset, 0xE080 /* 0b1110000010000000 */
					| (code >>> 12 & 0xF /* 0b00001111 */) << 8
					| code >>> 6 & 0x3F /* 0b00111111 */)
				, mb.setUint8(offset + 2, 0x80 /* 0b10000000 */
					| code & 0x3F /* 0b00111111 */)
				, 3
				)
				:
			(code = (code - 0xD800) * 0x400 + string.charCodeAt(++i) - 0xDC00 + 0x10000
			, mb.setUint32(offset, 0xF0808080 /* 0b11110000100000001000000010000000 */
				| (code >>> 18 & 0x7 /* 0b00000111 */) << 24
				| (code >>> 12 & 0x3F /* 0b00111111 */) << 16
				| (code >>> 6 & 0x3F /* 0b00111111 */) << 8
				| code & 0x3F /* 0b00111111 */)
			, 4
			);
	}
	return offset;
});


// DECODER

var _Bytes_decode = F2(function(decoder, bytes)
{
	try {
		return $elm$core$Maybe$Just(A2(decoder, bytes, 0).b);
	} catch(e) {
		return $elm$core$Maybe$Nothing;
	}
});

var _Bytes_read_i8  = F2(function(      bytes, offset) { return _Utils_Tuple2(offset + 1, bytes.getInt8(offset)); });
var _Bytes_read_i16 = F3(function(isLE, bytes, offset) { return _Utils_Tuple2(offset + 2, bytes.getInt16(offset, isLE)); });
var _Bytes_read_i32 = F3(function(isLE, bytes, offset) { return _Utils_Tuple2(offset + 4, bytes.getInt32(offset, isLE)); });
var _Bytes_read_u8  = F2(function(      bytes, offset) { return _Utils_Tuple2(offset + 1, bytes.getUint8(offset)); });
var _Bytes_read_u16 = F3(function(isLE, bytes, offset) { return _Utils_Tuple2(offset + 2, bytes.getUint16(offset, isLE)); });
var _Bytes_read_u32 = F3(function(isLE, bytes, offset) { return _Utils_Tuple2(offset + 4, bytes.getUint32(offset, isLE)); });
var _Bytes_read_f32 = F3(function(isLE, bytes, offset) { return _Utils_Tuple2(offset + 4, bytes.getFloat32(offset, isLE)); });
var _Bytes_read_f64 = F3(function(isLE, bytes, offset) { return _Utils_Tuple2(offset + 8, bytes.getFloat64(offset, isLE)); });

var _Bytes_read_bytes = F3(function(len, bytes, offset)
{
	return _Utils_Tuple2(offset + len, new DataView(bytes.buffer, bytes.byteOffset + offset, len));
});

var _Bytes_read_string = F3(function(len, bytes, offset)
{
	var string = '';
	var end = offset + len;
	for (; offset < end;)
	{
		var byte = bytes.getUint8(offset++);
		string +=
			(byte < 128)
				? String.fromCharCode(byte)
				:
			((byte & 0xE0 /* 0b11100000 */) === 0xC0 /* 0b11000000 */)
				? String.fromCharCode((byte & 0x1F /* 0b00011111 */) << 6 | bytes.getUint8(offset++) & 0x3F /* 0b00111111 */)
				:
			((byte & 0xF0 /* 0b11110000 */) === 0xE0 /* 0b11100000 */)
				? String.fromCharCode(
					(byte & 0xF /* 0b00001111 */) << 12
					| (bytes.getUint8(offset++) & 0x3F /* 0b00111111 */) << 6
					| bytes.getUint8(offset++) & 0x3F /* 0b00111111 */
				)
				:
				(byte =
					((byte & 0x7 /* 0b00000111 */) << 18
						| (bytes.getUint8(offset++) & 0x3F /* 0b00111111 */) << 12
						| (bytes.getUint8(offset++) & 0x3F /* 0b00111111 */) << 6
						| bytes.getUint8(offset++) & 0x3F /* 0b00111111 */
					) - 0x10000
				, String.fromCharCode(Math.floor(byte / 0x400) + 0xD800, byte % 0x400 + 0xDC00)
				);
	}
	return _Utils_Tuple2(offset, string);
});

var _Bytes_decodeFailure = F2(function() { throw 0; });
var $elm$core$Maybe$Just = function (a) {
	return {$: 'Just', a: a};
};
var $elm$core$Maybe$Nothing = {$: 'Nothing'};
var $author$project$Types$OnUrlChange = function (a) {
	return {$: 'OnUrlChange', a: a};
};
var $author$project$Types$OnUrlRequest = function (a) {
	return {$: 'OnUrlRequest', a: a};
};
var $elm$core$List$cons = _List_cons;
var $elm$core$Elm$JsArray$foldr = _JsArray_foldr;
var $elm$core$Array$foldr = F3(
	function (func, baseCase, _v0) {
		var tree = _v0.c;
		var tail = _v0.d;
		var helper = F2(
			function (node, acc) {
				if (node.$ === 'SubTree') {
					var subTree = node.a;
					return A3($elm$core$Elm$JsArray$foldr, helper, acc, subTree);
				} else {
					var values = node.a;
					return A3($elm$core$Elm$JsArray$foldr, func, acc, values);
				}
			});
		return A3(
			$elm$core$Elm$JsArray$foldr,
			helper,
			A3($elm$core$Elm$JsArray$foldr, func, baseCase, tail),
			tree);
	});
var $elm$core$Array$toList = function (array) {
	return A3($elm$core$Array$foldr, $elm$core$List$cons, _List_Nil, array);
};
var $elm$core$Dict$foldr = F3(
	function (func, acc, t) {
		foldr:
		while (true) {
			if (t.$ === 'RBEmpty_elm_builtin') {
				return acc;
			} else {
				var key = t.b;
				var value = t.c;
				var left = t.d;
				var right = t.e;
				var $temp$func = func,
					$temp$acc = A3(
					func,
					key,
					value,
					A3($elm$core$Dict$foldr, func, acc, right)),
					$temp$t = left;
				func = $temp$func;
				acc = $temp$acc;
				t = $temp$t;
				continue foldr;
			}
		}
	});
var $elm$core$Dict$toList = function (dict) {
	return A3(
		$elm$core$Dict$foldr,
		F3(
			function (key, value, list) {
				return A2(
					$elm$core$List$cons,
					_Utils_Tuple2(key, value),
					list);
			}),
		_List_Nil,
		dict);
};
var $elm$core$Dict$keys = function (dict) {
	return A3(
		$elm$core$Dict$foldr,
		F3(
			function (key, value, keyList) {
				return A2($elm$core$List$cons, key, keyList);
			}),
		_List_Nil,
		dict);
};
var $elm$core$Set$toList = function (_v0) {
	var dict = _v0.a;
	return $elm$core$Dict$keys(dict);
};
var $elm$core$Basics$EQ = {$: 'EQ'};
var $elm$core$Basics$GT = {$: 'GT'};
var $elm$core$Basics$LT = {$: 'LT'};
var $elm$core$Result$Err = function (a) {
	return {$: 'Err', a: a};
};
var $elm$json$Json$Decode$Failure = F2(
	function (a, b) {
		return {$: 'Failure', a: a, b: b};
	});
var $elm$json$Json$Decode$Field = F2(
	function (a, b) {
		return {$: 'Field', a: a, b: b};
	});
var $elm$json$Json$Decode$Index = F2(
	function (a, b) {
		return {$: 'Index', a: a, b: b};
	});
var $elm$core$Result$Ok = function (a) {
	return {$: 'Ok', a: a};
};
var $elm$json$Json$Decode$OneOf = function (a) {
	return {$: 'OneOf', a: a};
};
var $elm$core$Basics$False = {$: 'False'};
var $elm$core$Basics$add = _Basics_add;
var $elm$core$String$all = _String_all;
var $elm$core$Basics$and = _Basics_and;
var $elm$core$Basics$append = _Utils_append;
var $elm$json$Json$Encode$encode = _Json_encode;
var $elm$core$String$fromInt = _String_fromNumber;
var $elm$core$String$join = F2(
	function (sep, chunks) {
		return A2(
			_String_join,
			sep,
			_List_toArray(chunks));
	});
var $elm$core$String$split = F2(
	function (sep, string) {
		return _List_fromArray(
			A2(_String_split, sep, string));
	});
var $elm$json$Json$Decode$indent = function (str) {
	return A2(
		$elm$core$String$join,
		'\n    ',
		A2($elm$core$String$split, '\n', str));
};
var $elm$core$List$foldl = F3(
	function (func, acc, list) {
		foldl:
		while (true) {
			if (!list.b) {
				return acc;
			} else {
				var x = list.a;
				var xs = list.b;
				var $temp$func = func,
					$temp$acc = A2(func, x, acc),
					$temp$list = xs;
				func = $temp$func;
				acc = $temp$acc;
				list = $temp$list;
				continue foldl;
			}
		}
	});
var $elm$core$List$length = function (xs) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (_v0, i) {
				return i + 1;
			}),
		0,
		xs);
};
var $elm$core$List$map2 = _List_map2;
var $elm$core$Basics$le = _Utils_le;
var $elm$core$Basics$sub = _Basics_sub;
var $elm$core$List$rangeHelp = F3(
	function (lo, hi, list) {
		rangeHelp:
		while (true) {
			if (_Utils_cmp(lo, hi) < 1) {
				var $temp$lo = lo,
					$temp$hi = hi - 1,
					$temp$list = A2($elm$core$List$cons, hi, list);
				lo = $temp$lo;
				hi = $temp$hi;
				list = $temp$list;
				continue rangeHelp;
			} else {
				return list;
			}
		}
	});
var $elm$core$List$range = F2(
	function (lo, hi) {
		return A3($elm$core$List$rangeHelp, lo, hi, _List_Nil);
	});
var $elm$core$List$indexedMap = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$map2,
			f,
			A2(
				$elm$core$List$range,
				0,
				$elm$core$List$length(xs) - 1),
			xs);
	});
var $elm$core$Char$toCode = _Char_toCode;
var $elm$core$Char$isLower = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (97 <= code) && (code <= 122);
};
var $elm$core$Char$isUpper = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (code <= 90) && (65 <= code);
};
var $elm$core$Basics$or = _Basics_or;
var $elm$core$Char$isAlpha = function (_char) {
	return $elm$core$Char$isLower(_char) || $elm$core$Char$isUpper(_char);
};
var $elm$core$Char$isDigit = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (code <= 57) && (48 <= code);
};
var $elm$core$Char$isAlphaNum = function (_char) {
	return $elm$core$Char$isLower(_char) || ($elm$core$Char$isUpper(_char) || $elm$core$Char$isDigit(_char));
};
var $elm$core$List$reverse = function (list) {
	return A3($elm$core$List$foldl, $elm$core$List$cons, _List_Nil, list);
};
var $elm$core$String$uncons = _String_uncons;
var $elm$json$Json$Decode$errorOneOf = F2(
	function (i, error) {
		return '\n\n(' + ($elm$core$String$fromInt(i + 1) + (') ' + $elm$json$Json$Decode$indent(
			$elm$json$Json$Decode$errorToString(error))));
	});
var $elm$json$Json$Decode$errorToString = function (error) {
	return A2($elm$json$Json$Decode$errorToStringHelp, error, _List_Nil);
};
var $elm$json$Json$Decode$errorToStringHelp = F2(
	function (error, context) {
		errorToStringHelp:
		while (true) {
			switch (error.$) {
				case 'Field':
					var f = error.a;
					var err = error.b;
					var isSimple = function () {
						var _v1 = $elm$core$String$uncons(f);
						if (_v1.$ === 'Nothing') {
							return false;
						} else {
							var _v2 = _v1.a;
							var _char = _v2.a;
							var rest = _v2.b;
							return $elm$core$Char$isAlpha(_char) && A2($elm$core$String$all, $elm$core$Char$isAlphaNum, rest);
						}
					}();
					var fieldName = isSimple ? ('.' + f) : ('[\'' + (f + '\']'));
					var $temp$error = err,
						$temp$context = A2($elm$core$List$cons, fieldName, context);
					error = $temp$error;
					context = $temp$context;
					continue errorToStringHelp;
				case 'Index':
					var i = error.a;
					var err = error.b;
					var indexName = '[' + ($elm$core$String$fromInt(i) + ']');
					var $temp$error = err,
						$temp$context = A2($elm$core$List$cons, indexName, context);
					error = $temp$error;
					context = $temp$context;
					continue errorToStringHelp;
				case 'OneOf':
					var errors = error.a;
					if (!errors.b) {
						return 'Ran into a Json.Decode.oneOf with no possibilities' + function () {
							if (!context.b) {
								return '!';
							} else {
								return ' at json' + A2(
									$elm$core$String$join,
									'',
									$elm$core$List$reverse(context));
							}
						}();
					} else {
						if (!errors.b.b) {
							var err = errors.a;
							var $temp$error = err,
								$temp$context = context;
							error = $temp$error;
							context = $temp$context;
							continue errorToStringHelp;
						} else {
							var starter = function () {
								if (!context.b) {
									return 'Json.Decode.oneOf';
								} else {
									return 'The Json.Decode.oneOf at json' + A2(
										$elm$core$String$join,
										'',
										$elm$core$List$reverse(context));
								}
							}();
							var introduction = starter + (' failed in the following ' + ($elm$core$String$fromInt(
								$elm$core$List$length(errors)) + ' ways:'));
							return A2(
								$elm$core$String$join,
								'\n\n',
								A2(
									$elm$core$List$cons,
									introduction,
									A2($elm$core$List$indexedMap, $elm$json$Json$Decode$errorOneOf, errors)));
						}
					}
				default:
					var msg = error.a;
					var json = error.b;
					var introduction = function () {
						if (!context.b) {
							return 'Problem with the given value:\n\n';
						} else {
							return 'Problem with the value at json' + (A2(
								$elm$core$String$join,
								'',
								$elm$core$List$reverse(context)) + ':\n\n    ');
						}
					}();
					return introduction + ($elm$json$Json$Decode$indent(
						A2($elm$json$Json$Encode$encode, 4, json)) + ('\n\n' + msg));
			}
		}
	});
var $elm$core$Array$branchFactor = 32;
var $elm$core$Array$Array_elm_builtin = F4(
	function (a, b, c, d) {
		return {$: 'Array_elm_builtin', a: a, b: b, c: c, d: d};
	});
var $elm$core$Elm$JsArray$empty = _JsArray_empty;
var $elm$core$Basics$ceiling = _Basics_ceiling;
var $elm$core$Basics$fdiv = _Basics_fdiv;
var $elm$core$Basics$logBase = F2(
	function (base, number) {
		return _Basics_log(number) / _Basics_log(base);
	});
var $elm$core$Basics$toFloat = _Basics_toFloat;
var $elm$core$Array$shiftStep = $elm$core$Basics$ceiling(
	A2($elm$core$Basics$logBase, 2, $elm$core$Array$branchFactor));
var $elm$core$Array$empty = A4($elm$core$Array$Array_elm_builtin, 0, $elm$core$Array$shiftStep, $elm$core$Elm$JsArray$empty, $elm$core$Elm$JsArray$empty);
var $elm$core$Elm$JsArray$initialize = _JsArray_initialize;
var $elm$core$Array$Leaf = function (a) {
	return {$: 'Leaf', a: a};
};
var $elm$core$Basics$apL = F2(
	function (f, x) {
		return f(x);
	});
var $elm$core$Basics$apR = F2(
	function (x, f) {
		return f(x);
	});
var $elm$core$Basics$eq = _Utils_equal;
var $elm$core$Basics$floor = _Basics_floor;
var $elm$core$Elm$JsArray$length = _JsArray_length;
var $elm$core$Basics$gt = _Utils_gt;
var $elm$core$Basics$max = F2(
	function (x, y) {
		return (_Utils_cmp(x, y) > 0) ? x : y;
	});
var $elm$core$Basics$mul = _Basics_mul;
var $elm$core$Array$SubTree = function (a) {
	return {$: 'SubTree', a: a};
};
var $elm$core$Elm$JsArray$initializeFromList = _JsArray_initializeFromList;
var $elm$core$Array$compressNodes = F2(
	function (nodes, acc) {
		compressNodes:
		while (true) {
			var _v0 = A2($elm$core$Elm$JsArray$initializeFromList, $elm$core$Array$branchFactor, nodes);
			var node = _v0.a;
			var remainingNodes = _v0.b;
			var newAcc = A2(
				$elm$core$List$cons,
				$elm$core$Array$SubTree(node),
				acc);
			if (!remainingNodes.b) {
				return $elm$core$List$reverse(newAcc);
			} else {
				var $temp$nodes = remainingNodes,
					$temp$acc = newAcc;
				nodes = $temp$nodes;
				acc = $temp$acc;
				continue compressNodes;
			}
		}
	});
var $elm$core$Tuple$first = function (_v0) {
	var x = _v0.a;
	return x;
};
var $elm$core$Array$treeFromBuilder = F2(
	function (nodeList, nodeListSize) {
		treeFromBuilder:
		while (true) {
			var newNodeSize = $elm$core$Basics$ceiling(nodeListSize / $elm$core$Array$branchFactor);
			if (newNodeSize === 1) {
				return A2($elm$core$Elm$JsArray$initializeFromList, $elm$core$Array$branchFactor, nodeList).a;
			} else {
				var $temp$nodeList = A2($elm$core$Array$compressNodes, nodeList, _List_Nil),
					$temp$nodeListSize = newNodeSize;
				nodeList = $temp$nodeList;
				nodeListSize = $temp$nodeListSize;
				continue treeFromBuilder;
			}
		}
	});
var $elm$core$Array$builderToArray = F2(
	function (reverseNodeList, builder) {
		if (!builder.nodeListSize) {
			return A4(
				$elm$core$Array$Array_elm_builtin,
				$elm$core$Elm$JsArray$length(builder.tail),
				$elm$core$Array$shiftStep,
				$elm$core$Elm$JsArray$empty,
				builder.tail);
		} else {
			var treeLen = builder.nodeListSize * $elm$core$Array$branchFactor;
			var depth = $elm$core$Basics$floor(
				A2($elm$core$Basics$logBase, $elm$core$Array$branchFactor, treeLen - 1));
			var correctNodeList = reverseNodeList ? $elm$core$List$reverse(builder.nodeList) : builder.nodeList;
			var tree = A2($elm$core$Array$treeFromBuilder, correctNodeList, builder.nodeListSize);
			return A4(
				$elm$core$Array$Array_elm_builtin,
				$elm$core$Elm$JsArray$length(builder.tail) + treeLen,
				A2($elm$core$Basics$max, 5, depth * $elm$core$Array$shiftStep),
				tree,
				builder.tail);
		}
	});
var $elm$core$Basics$idiv = _Basics_idiv;
var $elm$core$Basics$lt = _Utils_lt;
var $elm$core$Array$initializeHelp = F5(
	function (fn, fromIndex, len, nodeList, tail) {
		initializeHelp:
		while (true) {
			if (fromIndex < 0) {
				return A2(
					$elm$core$Array$builderToArray,
					false,
					{nodeList: nodeList, nodeListSize: (len / $elm$core$Array$branchFactor) | 0, tail: tail});
			} else {
				var leaf = $elm$core$Array$Leaf(
					A3($elm$core$Elm$JsArray$initialize, $elm$core$Array$branchFactor, fromIndex, fn));
				var $temp$fn = fn,
					$temp$fromIndex = fromIndex - $elm$core$Array$branchFactor,
					$temp$len = len,
					$temp$nodeList = A2($elm$core$List$cons, leaf, nodeList),
					$temp$tail = tail;
				fn = $temp$fn;
				fromIndex = $temp$fromIndex;
				len = $temp$len;
				nodeList = $temp$nodeList;
				tail = $temp$tail;
				continue initializeHelp;
			}
		}
	});
var $elm$core$Basics$remainderBy = _Basics_remainderBy;
var $elm$core$Array$initialize = F2(
	function (len, fn) {
		if (len <= 0) {
			return $elm$core$Array$empty;
		} else {
			var tailLen = len % $elm$core$Array$branchFactor;
			var tail = A3($elm$core$Elm$JsArray$initialize, tailLen, len - tailLen, fn);
			var initialFromIndex = (len - tailLen) - $elm$core$Array$branchFactor;
			return A5($elm$core$Array$initializeHelp, fn, initialFromIndex, len, _List_Nil, tail);
		}
	});
var $elm$core$Basics$True = {$: 'True'};
var $elm$core$Result$isOk = function (result) {
	if (result.$ === 'Ok') {
		return true;
	} else {
		return false;
	}
};
var $elm$json$Json$Decode$andThen = _Json_andThen;
var $elm$json$Json$Decode$map = _Json_map1;
var $elm$json$Json$Decode$map2 = _Json_map2;
var $elm$json$Json$Decode$succeed = _Json_succeed;
var $elm$virtual_dom$VirtualDom$toHandlerInt = function (handler) {
	switch (handler.$) {
		case 'Normal':
			return 0;
		case 'MayStopPropagation':
			return 1;
		case 'MayPreventDefault':
			return 2;
		default:
			return 3;
	}
};
var $elm$browser$Browser$External = function (a) {
	return {$: 'External', a: a};
};
var $elm$browser$Browser$Internal = function (a) {
	return {$: 'Internal', a: a};
};
var $elm$core$Basics$identity = function (x) {
	return x;
};
var $elm$browser$Browser$Dom$NotFound = function (a) {
	return {$: 'NotFound', a: a};
};
var $elm$url$Url$Http = {$: 'Http'};
var $elm$url$Url$Https = {$: 'Https'};
var $elm$url$Url$Url = F6(
	function (protocol, host, port_, path, query, fragment) {
		return {fragment: fragment, host: host, path: path, port_: port_, protocol: protocol, query: query};
	});
var $elm$core$String$contains = _String_contains;
var $elm$core$String$length = _String_length;
var $elm$core$String$slice = _String_slice;
var $elm$core$String$dropLeft = F2(
	function (n, string) {
		return (n < 1) ? string : A3(
			$elm$core$String$slice,
			n,
			$elm$core$String$length(string),
			string);
	});
var $elm$core$String$indexes = _String_indexes;
var $elm$core$String$isEmpty = function (string) {
	return string === '';
};
var $elm$core$String$left = F2(
	function (n, string) {
		return (n < 1) ? '' : A3($elm$core$String$slice, 0, n, string);
	});
var $elm$core$String$toInt = _String_toInt;
var $elm$url$Url$chompBeforePath = F5(
	function (protocol, path, params, frag, str) {
		if ($elm$core$String$isEmpty(str) || A2($elm$core$String$contains, '@', str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, ':', str);
			if (!_v0.b) {
				return $elm$core$Maybe$Just(
					A6($elm$url$Url$Url, protocol, str, $elm$core$Maybe$Nothing, path, params, frag));
			} else {
				if (!_v0.b.b) {
					var i = _v0.a;
					var _v1 = $elm$core$String$toInt(
						A2($elm$core$String$dropLeft, i + 1, str));
					if (_v1.$ === 'Nothing') {
						return $elm$core$Maybe$Nothing;
					} else {
						var port_ = _v1;
						return $elm$core$Maybe$Just(
							A6(
								$elm$url$Url$Url,
								protocol,
								A2($elm$core$String$left, i, str),
								port_,
								path,
								params,
								frag));
					}
				} else {
					return $elm$core$Maybe$Nothing;
				}
			}
		}
	});
var $elm$url$Url$chompBeforeQuery = F4(
	function (protocol, params, frag, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '/', str);
			if (!_v0.b) {
				return A5($elm$url$Url$chompBeforePath, protocol, '/', params, frag, str);
			} else {
				var i = _v0.a;
				return A5(
					$elm$url$Url$chompBeforePath,
					protocol,
					A2($elm$core$String$dropLeft, i, str),
					params,
					frag,
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$url$Url$chompBeforeFragment = F3(
	function (protocol, frag, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '?', str);
			if (!_v0.b) {
				return A4($elm$url$Url$chompBeforeQuery, protocol, $elm$core$Maybe$Nothing, frag, str);
			} else {
				var i = _v0.a;
				return A4(
					$elm$url$Url$chompBeforeQuery,
					protocol,
					$elm$core$Maybe$Just(
						A2($elm$core$String$dropLeft, i + 1, str)),
					frag,
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$url$Url$chompAfterProtocol = F2(
	function (protocol, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '#', str);
			if (!_v0.b) {
				return A3($elm$url$Url$chompBeforeFragment, protocol, $elm$core$Maybe$Nothing, str);
			} else {
				var i = _v0.a;
				return A3(
					$elm$url$Url$chompBeforeFragment,
					protocol,
					$elm$core$Maybe$Just(
						A2($elm$core$String$dropLeft, i + 1, str)),
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$core$String$startsWith = _String_startsWith;
var $elm$url$Url$fromString = function (str) {
	return A2($elm$core$String$startsWith, 'http://', str) ? A2(
		$elm$url$Url$chompAfterProtocol,
		$elm$url$Url$Http,
		A2($elm$core$String$dropLeft, 7, str)) : (A2($elm$core$String$startsWith, 'https://', str) ? A2(
		$elm$url$Url$chompAfterProtocol,
		$elm$url$Url$Https,
		A2($elm$core$String$dropLeft, 8, str)) : $elm$core$Maybe$Nothing);
};
var $elm$core$Basics$never = function (_v0) {
	never:
	while (true) {
		var nvr = _v0.a;
		var $temp$_v0 = nvr;
		_v0 = $temp$_v0;
		continue never;
	}
};
var $elm$core$Task$Perform = function (a) {
	return {$: 'Perform', a: a};
};
var $elm$core$Task$succeed = _Scheduler_succeed;
var $elm$core$Task$init = $elm$core$Task$succeed(_Utils_Tuple0);
var $elm$core$List$foldrHelper = F4(
	function (fn, acc, ctr, ls) {
		if (!ls.b) {
			return acc;
		} else {
			var a = ls.a;
			var r1 = ls.b;
			if (!r1.b) {
				return A2(fn, a, acc);
			} else {
				var b = r1.a;
				var r2 = r1.b;
				if (!r2.b) {
					return A2(
						fn,
						a,
						A2(fn, b, acc));
				} else {
					var c = r2.a;
					var r3 = r2.b;
					if (!r3.b) {
						return A2(
							fn,
							a,
							A2(
								fn,
								b,
								A2(fn, c, acc)));
					} else {
						var d = r3.a;
						var r4 = r3.b;
						var res = (ctr > 500) ? A3(
							$elm$core$List$foldl,
							fn,
							acc,
							$elm$core$List$reverse(r4)) : A4($elm$core$List$foldrHelper, fn, acc, ctr + 1, r4);
						return A2(
							fn,
							a,
							A2(
								fn,
								b,
								A2(
									fn,
									c,
									A2(fn, d, res))));
					}
				}
			}
		}
	});
var $elm$core$List$foldr = F3(
	function (fn, acc, ls) {
		return A4($elm$core$List$foldrHelper, fn, acc, 0, ls);
	});
var $elm$core$List$map = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$foldr,
			F2(
				function (x, acc) {
					return A2(
						$elm$core$List$cons,
						f(x),
						acc);
				}),
			_List_Nil,
			xs);
	});
var $elm$core$Task$andThen = _Scheduler_andThen;
var $elm$core$Task$map = F2(
	function (func, taskA) {
		return A2(
			$elm$core$Task$andThen,
			function (a) {
				return $elm$core$Task$succeed(
					func(a));
			},
			taskA);
	});
var $elm$core$Task$map2 = F3(
	function (func, taskA, taskB) {
		return A2(
			$elm$core$Task$andThen,
			function (a) {
				return A2(
					$elm$core$Task$andThen,
					function (b) {
						return $elm$core$Task$succeed(
							A2(func, a, b));
					},
					taskB);
			},
			taskA);
	});
var $elm$core$Task$sequence = function (tasks) {
	return A3(
		$elm$core$List$foldr,
		$elm$core$Task$map2($elm$core$List$cons),
		$elm$core$Task$succeed(_List_Nil),
		tasks);
};
var $elm$core$Platform$sendToApp = _Platform_sendToApp;
var $elm$core$Task$spawnCmd = F2(
	function (router, _v0) {
		var task = _v0.a;
		return _Scheduler_spawn(
			A2(
				$elm$core$Task$andThen,
				$elm$core$Platform$sendToApp(router),
				task));
	});
var $elm$core$Task$onEffects = F3(
	function (router, commands, state) {
		return A2(
			$elm$core$Task$map,
			function (_v0) {
				return _Utils_Tuple0;
			},
			$elm$core$Task$sequence(
				A2(
					$elm$core$List$map,
					$elm$core$Task$spawnCmd(router),
					commands)));
	});
var $elm$core$Task$onSelfMsg = F3(
	function (_v0, _v1, _v2) {
		return $elm$core$Task$succeed(_Utils_Tuple0);
	});
var $elm$core$Task$cmdMap = F2(
	function (tagger, _v0) {
		var task = _v0.a;
		return $elm$core$Task$Perform(
			A2($elm$core$Task$map, tagger, task));
	});
_Platform_effectManagers['Task'] = _Platform_createManager($elm$core$Task$init, $elm$core$Task$onEffects, $elm$core$Task$onSelfMsg, $elm$core$Task$cmdMap);
var $elm$core$Task$command = _Platform_leaf('Task');
var $elm$core$Task$perform = F2(
	function (toMessage, task) {
		return $elm$core$Task$command(
			$elm$core$Task$Perform(
				A2($elm$core$Task$map, toMessage, task)));
	});
var $elm$browser$Browser$application = _Browser_application;
var $elm$json$Json$Decode$field = _Json_decodeField;
var $author$project$Types$Auth = function (a) {
	return {$: 'Auth', a: a};
};
var $author$project$Types$GetTimezone = function (a) {
	return {$: 'GetTimezone', a: a};
};
var $author$project$Types$GetZoneName = function (a) {
	return {$: 'GetZoneName', a: a};
};
var $author$project$Types$NoAuth = {$: 'NoAuth'};
var $author$project$Data$Domain$all = function (_v0) {
	var domains = _v0.b;
	return domains;
};
var $elm$core$Platform$Cmd$batch = _Platform_batch;
var $author$project$Data$Route$Auth = function (a) {
	return {$: 'Auth', a: a};
};
var $author$project$Data$Route$DashboardRoute = {$: 'DashboardRoute'};
var $author$project$Type$FillTemplate$GetTokenOrSlug = function (a) {
	return {$: 'GetTokenOrSlug', a: a};
};
var $author$project$Type$FillTemplate$GetTokenOrSlugViewTemplateInfo = function (a) {
	return {$: 'GetTokenOrSlugViewTemplateInfo', a: a};
};
var $author$project$Types$OnAddressBook = function (a) {
	return {$: 'OnAddressBook', a: a};
};
var $author$project$Types$OnAuth = function (a) {
	return {$: 'OnAuth', a: a};
};
var $author$project$Types$OnBusinessProfile = function (a) {
	return {$: 'OnBusinessProfile', a: a};
};
var $author$project$Types$OnBusinessUser = function (a) {
	return {$: 'OnBusinessUser', a: a};
};
var $author$project$Types$OnDashboard = function (a) {
	return {$: 'OnDashboard', a: a};
};
var $author$project$Types$OnFillTemplate = function (a) {
	return {$: 'OnFillTemplate', a: a};
};
var $author$project$Type$NewTemplate$OnGetTemplateQuota = {$: 'OnGetTemplateQuota'};
var $author$project$Type$PersonalRegister$OnLoad = function (a) {
	return {$: 'OnLoad', a: a};
};
var $author$project$Type$Setting$OnLoad = function (a) {
	return {$: 'OnLoad', a: a};
};
var $author$project$Type$BusinessUser$OnLoadUsers = {$: 'OnLoadUsers'};
var $author$project$Types$OnMultipleDocUpload = function (a) {
	return {$: 'OnMultipleDocUpload', a: a};
};
var $author$project$Types$OnNewTemplate = function (a) {
	return {$: 'OnNewTemplate', a: a};
};
var $author$project$Type$BusinessProfile$OnPageEnter = F2(
	function (a, b) {
		return {$: 'OnPageEnter', a: a, b: b};
	});
var $author$project$Type$Dashboard$OnPageEnter = {$: 'OnPageEnter'};
var $author$project$Type$PointTransaction$OnPageEnter = function (a) {
	return {$: 'OnPageEnter', a: a};
};
var $author$project$Type$PointTransactionHistory$OnPageEnter = {$: 'OnPageEnter'};
var $author$project$Type$PointWithdrawal$OnPageEnter = {$: 'OnPageEnter'};
var $author$project$Type$RedeemRewardList$OnPageEnter = {$: 'OnPageEnter'};
var $author$project$Type$TokenManagement$OnPageEnter = {$: 'OnPageEnter'};
var $author$project$Type$TrustScore$OnPageEnter = {$: 'OnPageEnter'};
var $author$project$Type$UploadMultipleDocument$OnPageEnter = {$: 'OnPageEnter'};
var $author$project$Type$ViewNotarisationInfo$OnPageEnter = {$: 'OnPageEnter'};
var $author$project$Types$OnPointTransaction = function (a) {
	return {$: 'OnPointTransaction', a: a};
};
var $author$project$Types$OnPointTransactionHistory = function (a) {
	return {$: 'OnPointTransactionHistory', a: a};
};
var $author$project$Types$OnPointWithdrawal = function (a) {
	return {$: 'OnPointWithdrawal', a: a};
};
var $author$project$Types$OnRedeemRewardList = function (a) {
	return {$: 'OnRedeemRewardList', a: a};
};
var $author$project$Types$OnRegister = function (a) {
	return {$: 'OnRegister', a: a};
};
var $author$project$Types$OnSetting = function (a) {
	return {$: 'OnSetting', a: a};
};
var $author$project$Types$OnSignature = function (a) {
	return {$: 'OnSignature', a: a};
};
var $author$project$Types$OnTokenConfirmation = function (a) {
	return {$: 'OnTokenConfirmation', a: a};
};
var $author$project$Types$OnTokenManagement = function (a) {
	return {$: 'OnTokenManagement', a: a};
};
var $author$project$Type$TokenConfirmation$OnTokenVerification = function (a) {
	return {$: 'OnTokenVerification', a: a};
};
var $author$project$Types$OnTrustScore = function (a) {
	return {$: 'OnTrustScore', a: a};
};
var $author$project$Types$OnViewDoc = function (a) {
	return {$: 'OnViewDoc', a: a};
};
var $author$project$Types$OnViewNotarisationInfo = function (a) {
	return {$: 'OnViewNotarisationInfo', a: a};
};
var $author$project$Type$Signature$OnViewRendered = {$: 'OnViewRendered'};
var $author$project$Type$AddressBook$Refresh = {$: 'Refresh'};
var $author$project$Type$ViewDocument$ValidateDocumentToken = function (a) {
	return {$: 'ValidateDocumentToken', a: a};
};
var $elm$json$Json$Encode$null = _Json_encodeNull;
var $author$project$Model$Route$affliateScript = _Platform_outgoingPort(
	'affliateScript',
	function ($) {
		return $elm$json$Json$Encode$null;
	});
var $author$project$Data$Domain$equal = F2(
	function (_v0, _v1) {
		var d1 = _v0.a;
		var d2 = _v1.a;
		return _Utils_eq(d1, d2);
	});
var $author$project$Type$ListDocument$LoadDocument = function (a) {
	return {$: 'LoadDocument', a: a};
};
var $author$project$Types$OnListDoc = function (a) {
	return {$: 'OnListDoc', a: a};
};
var $author$project$Type$ListDocument$Received = {$: 'Received'};
var $author$project$Type$ListDocument$Completed = {$: 'Completed'};
var $author$project$Type$ListDocument$Sent = {$: 'Sent'};
var $author$project$Type$ListDocument$Submission = {$: 'Submission'};
var $author$project$Type$ListDocument$Template = {$: 'Template'};
var $elm$core$String$toLower = _String_toLower;
var $elm$core$String$trim = _String_trim;
var $author$project$Type$ListDocument$getDocumentType = function (docType) {
	var formattedString = $elm$core$String$toLower(
		$elm$core$String$trim(docType));
	switch (formattedString) {
		case 'sent':
			return $elm$core$Maybe$Just($author$project$Type$ListDocument$Sent);
		case 'received':
			return $elm$core$Maybe$Just($author$project$Type$ListDocument$Received);
		case 'completed':
			return $elm$core$Maybe$Just($author$project$Type$ListDocument$Completed);
		case 'template':
			return $elm$core$Maybe$Just($author$project$Type$ListDocument$Template);
		case 'submission':
			return $elm$core$Maybe$Just($author$project$Type$ListDocument$Submission);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $elm$core$Maybe$withDefault = F2(
	function (_default, maybe) {
		if (maybe.$ === 'Just') {
			var value = maybe.a;
			return value;
		} else {
			return _default;
		}
	});
var $author$project$Model$ListDocument$loadDocument = function (docType) {
	return A2(
		$elm$core$Task$perform,
		$author$project$Types$OnAuth,
		$elm$core$Task$succeed(
			$author$project$Types$OnListDoc(
				$author$project$Type$ListDocument$LoadDocument(
					A2(
						$elm$core$Maybe$withDefault,
						$author$project$Type$ListDocument$Received,
						$author$project$Type$ListDocument$getDocumentType(docType))))));
};
var $elm$core$Platform$Cmd$none = $elm$core$Platform$Cmd$batch(_List_Nil);
var $elm$browser$Browser$Navigation$replaceUrl = _Browser_replaceUrl;
var $author$project$Data$Route$routeUrl = {addressBook: '/addressbook', businessAcceptInvite: '/business/invitation', businessProfile: '/business/profile', businessProfileView: '/business/view', businessRegister: '/register/business', businessRegisterSuccess: '/register/business/success', completedDoc: '/documents/completed', confirmDeleteDocument: '/confirm-delete-document', confirmDeleteTemplate: '/confirm-delete-template', createTemplate: '/create-template', dashboard: '/dashboard', fillTemplate: '/form', fourZeroFour: '/404', login: '/login', logout: '/logout', newMultipleDoc: '/new-document/multiple-upload', newTemplate: '/new-template', personalRegister: '/register/personal', receievedDoc: '/documents/received', redeemReward: '/redeem-reward-list', registerSuccess: '/register/success', resendActivation: '/resend-activation', resendActivationEmailSent: '/resend-activation/email-sent', resetPassword: '/reset-password', resetPasswordEmailSent: '/reset-password/email-sent', resetPasswordSuccess: '/reset-password/success', sentDoc: '/documents/sent', setPassword: '/set-password', setting: '/settings', signUp: '/sign-up', submissionDoc: '/documents/submission', templateDoc: '/documents/template', tokenComfirmation: '/confirm-transfer', tokenManagement: '/pointsManagement', transaction: 'transaction', transactionHistory: '/points-activities', trustScore: '/trust-score', uploadDocument: '/upload-document', uploadMultiDoc: '/upload-document/multiple', verifyDocument: '/verifyDocument', verifyTransaction: '/verifyTransaction', viewDocument: '/document/', viewNotarisationInfo: '/viewNotarisationInfo', viewTemplate: '/template', withdrawal: '/withdrawal', withdrawalConfirmation: '/confirm-withdrawal'};
var $author$project$Data$Domain$selected = function (_v0) {
	var domain = _v0.a;
	return domain;
};
var $author$project$Model$Route$calculate = F5(
	function (endPoint, appDomain, navKey, sessionModel, route) {
		_v0$26:
		while (true) {
			switch (route.$) {
				case 'NotFoundRoute':
					return _Utils_Tuple2(
						route,
						A2($elm$browser$Browser$Navigation$replaceUrl, navKey, $author$project$Data$Route$routeUrl.fourZeroFour));
				case 'Auth':
					switch (route.a.$) {
						case 'NoAccessToPublicRoute':
							var _v1 = route.a;
							return _Utils_Tuple2(
								$author$project$Data$Route$Auth($author$project$Data$Route$DashboardRoute),
								A2($elm$browser$Browser$Navigation$replaceUrl, navKey, $author$project$Data$Route$routeUrl.dashboard));
						case 'SettingRoute':
							var code = route.a.a;
							return _Utils_Tuple2(
								route,
								$elm$core$Platform$Cmd$batch(
									_List_fromArray(
										[
											A2(
											$elm$core$Task$perform,
											$author$project$Types$OnSignature,
											$elm$core$Task$succeed($author$project$Type$Signature$OnViewRendered)),
											A2(
											$elm$core$Task$perform,
											$author$project$Types$OnAuth,
											$elm$core$Task$succeed(
												$author$project$Types$OnSetting(
													$author$project$Type$Setting$OnLoad(code))))
										])));
						case 'NewTemplateRoute':
							var _v2 = route.a;
							return _Utils_Tuple2(
								route,
								A2(
									$elm$core$Task$perform,
									$author$project$Types$OnAuth,
									$elm$core$Task$succeed(
										$author$project$Types$OnNewTemplate($author$project$Type$NewTemplate$OnGetTemplateQuota))));
						case 'UploadMultipleDocRoute':
							var _v3 = route.a;
							switch (sessionModel.$) {
								case 'Auth':
									var authModel = sessionModel.a;
									var _v5 = authModel.uploadMultipleDocModel;
									if (_v5.$ === 'NotLoaded') {
										return _Utils_Tuple2(
											route,
											A2($elm$browser$Browser$Navigation$replaceUrl, navKey, $author$project$Data$Route$routeUrl.newMultipleDoc));
									} else {
										return _Utils_Tuple2(
											route,
											$elm$core$Platform$Cmd$batch(
												_List_fromArray(
													[
														A2(
														$elm$core$Task$perform,
														$author$project$Types$OnSignature,
														$elm$core$Task$succeed($author$project$Type$Signature$OnViewRendered)),
														A2(
														$elm$core$Task$perform,
														$author$project$Types$OnAuth,
														$elm$core$Task$succeed(
															$author$project$Types$OnMultipleDocUpload($author$project$Type$UploadMultipleDocument$OnPageEnter)))
													])));
									}
								case 'Anonymous':
									return _Utils_Tuple2(route, $elm$core$Platform$Cmd$none);
								case 'NoAuth':
									return _Utils_Tuple2(route, $elm$core$Platform$Cmd$none);
								default:
									return _Utils_Tuple2(route, $elm$core$Platform$Cmd$none);
							}
						case 'CreateTemplateRoute':
							var _v6 = route.a;
							switch (sessionModel.$) {
								case 'Auth':
									var authModel = sessionModel.a;
									var _v8 = authModel.createTemplateModel;
									if (_v8.$ === 'NotLoaded') {
										return _Utils_Tuple2(
											route,
											A2($elm$browser$Browser$Navigation$replaceUrl, navKey, $author$project$Data$Route$routeUrl.newTemplate));
									} else {
										return _Utils_Tuple2(
											route,
											A2(
												$elm$core$Task$perform,
												$author$project$Types$OnSignature,
												$elm$core$Task$succeed($author$project$Type$Signature$OnViewRendered)));
									}
								case 'Anonymous':
									return _Utils_Tuple2(route, $elm$core$Platform$Cmd$none);
								case 'NoAuth':
									return _Utils_Tuple2(route, $elm$core$Platform$Cmd$none);
								default:
									return _Utils_Tuple2(route, $elm$core$Platform$Cmd$none);
							}
						case 'AddressBookRoute':
							var _v9 = route.a;
							return _Utils_Tuple2(
								route,
								A2(
									$elm$core$Task$perform,
									$author$project$Types$OnAuth,
									$elm$core$Task$succeed(
										$author$project$Types$OnAddressBook($author$project$Type$AddressBook$Refresh))));
						case 'ListDocumentRoute':
							var docType = route.a.a;
							return _Utils_Tuple2(
								route,
								$author$project$Model$ListDocument$loadDocument(docType));
						case 'DashboardRoute':
							var _v10 = route.a;
							return _Utils_Tuple2(
								route,
								A2(
									$elm$core$Task$perform,
									$author$project$Types$OnAuth,
									$elm$core$Task$succeed(
										$author$project$Types$OnDashboard($author$project$Type$Dashboard$OnPageEnter))));
						case 'BusinessProfile':
							var _v11 = route.a;
							switch (sessionModel.$) {
								case 'Auth':
									var user = sessionModel.a.user;
									return A2(
										$author$project$Data$Domain$equal,
										$author$project$Data$Domain$selected(user.domains),
										appDomain) ? _Utils_Tuple2(
										route,
										A2($elm$browser$Browser$Navigation$replaceUrl, navKey, $author$project$Data$Route$routeUrl.dashboard)) : _Utils_Tuple2(
										route,
										A2(
											$elm$core$Task$perform,
											$author$project$Types$OnAuth,
											$elm$core$Task$succeed(
												$author$project$Types$OnBusinessUser($author$project$Type$BusinessUser$OnLoadUsers))));
								case 'Anonymous':
									return _Utils_Tuple2(route, $elm$core$Platform$Cmd$none);
								case 'NoAuth':
									return _Utils_Tuple2(route, $elm$core$Platform$Cmd$none);
								default:
									return _Utils_Tuple2(route, $elm$core$Platform$Cmd$none);
							}
						case 'TokenManagementRoute':
							var _v13 = route.a;
							return _Utils_Tuple2(
								route,
								A2(
									$elm$core$Task$perform,
									$author$project$Types$OnAuth,
									$elm$core$Task$succeed(
										$author$project$Types$OnTokenManagement($author$project$Type$TokenManagement$OnPageEnter))));
						case 'PointTransactionHistory':
							var _v14 = route.a;
							return _Utils_Tuple2(
								route,
								A2(
									$elm$core$Task$perform,
									$author$project$Types$OnAuth,
									$elm$core$Task$succeed(
										$author$project$Types$OnPointTransactionHistory($author$project$Type$PointTransactionHistory$OnPageEnter))));
						case 'PointTransaction':
							var transactionID = route.a.a;
							return _Utils_Tuple2(
								route,
								A2(
									$elm$core$Task$perform,
									$author$project$Types$OnAuth,
									$elm$core$Task$succeed(
										$author$project$Types$OnPointTransaction(
											$author$project$Type$PointTransaction$OnPageEnter(transactionID)))));
						case 'PointWithdrawal':
							var _v15 = route.a;
							return _Utils_Tuple2(
								route,
								A2(
									$elm$core$Task$perform,
									$author$project$Types$OnAuth,
									$elm$core$Task$succeed(
										$author$project$Types$OnPointWithdrawal($author$project$Type$PointWithdrawal$OnPageEnter))));
						case 'TrustScoreRoute':
							var _v16 = route.a;
							return _Utils_Tuple2(
								route,
								A2(
									$elm$core$Task$perform,
									$author$project$Types$OnAuth,
									$elm$core$Task$succeed(
										$author$project$Types$OnTrustScore($author$project$Type$TrustScore$OnPageEnter))));
						case 'RedeemRewardList':
							var _v17 = route.a;
							return _Utils_Tuple2(
								route,
								A2(
									$elm$core$Task$perform,
									$author$project$Types$OnAuth,
									$elm$core$Task$succeed(
										$author$project$Types$OnRedeemRewardList($author$project$Type$RedeemRewardList$OnPageEnter))));
						case 'ViewNotarisationInfo':
							var _v18 = route.a;
							return _Utils_Tuple2(
								route,
								A2(
									$elm$core$Task$perform,
									$author$project$Types$OnAuth,
									$elm$core$Task$succeed(
										$author$project$Types$OnViewNotarisationInfo($author$project$Type$ViewNotarisationInfo$OnPageEnter))));
						default:
							break _v0$26;
					}
				case 'Public':
					switch (route.a.$) {
						case 'LoginRoute':
							var _v19 = route.a;
							return _Utils_Tuple2(
								route,
								$author$project$Model$Route$affliateScript(_Utils_Tuple0));
						case 'PersonalRegisterRoute':
							var registerParams = route.a.a;
							return _Utils_Tuple2(
								route,
								$elm$core$Platform$Cmd$batch(
									_List_fromArray(
										[
											$author$project$Model$Route$affliateScript(_Utils_Tuple0),
											A2(
											$elm$core$Task$perform,
											$author$project$Types$OnRegister,
											$elm$core$Task$succeed(
												$author$project$Type$PersonalRegister$OnLoad(registerParams)))
										])));
						case 'OrganizationUserRegisterRoute':
							var registerParams = route.a.a;
							return _Utils_Tuple2(
								route,
								$elm$core$Platform$Cmd$batch(
									_List_fromArray(
										[
											$author$project$Model$Route$affliateScript(_Utils_Tuple0),
											A2(
											$elm$core$Task$perform,
											$author$project$Types$OnRegister,
											$elm$core$Task$succeed(
												$author$project$Type$PersonalRegister$OnLoad(registerParams)))
										])));
						case 'BusinessRegisterRoute':
							return _Utils_Tuple2(
								route,
								$elm$core$Platform$Cmd$batch(
									_List_fromArray(
										[
											$author$project$Model$Route$affliateScript(_Utils_Tuple0)
										])));
						default:
							break _v0$26;
					}
				case 'PublicOrAuth':
					switch (route.a.$) {
						case 'ViewDocumentRoute':
							var docID = route.a.a;
							return _Utils_Tuple2(
								route,
								A2(
									$elm$core$Task$perform,
									$author$project$Types$OnViewDoc,
									$elm$core$Task$succeed(
										$author$project$Type$ViewDocument$ValidateDocumentToken(docID))));
						case 'FillTemplateRoute':
							var slug = route.a.a;
							return _Utils_Tuple2(
								route,
								A2(
									$elm$core$Task$perform,
									$author$project$Types$OnFillTemplate,
									$elm$core$Task$succeed(
										$author$project$Type$FillTemplate$GetTokenOrSlug(slug))));
						case 'ViewTemplateRoute':
							var slug = route.a.a;
							return _Utils_Tuple2(
								route,
								A2(
									$elm$core$Task$perform,
									$author$project$Types$OnFillTemplate,
									$elm$core$Task$succeed(
										$author$project$Type$FillTemplate$GetTokenOrSlugViewTemplateInfo(slug))));
						case 'TokenConfirmationRoute':
							var token = route.a.a;
							return _Utils_Tuple2(
								route,
								A2(
									$elm$core$Task$perform,
									$author$project$Types$OnTokenConfirmation,
									$elm$core$Task$succeed(
										$author$project$Type$TokenConfirmation$OnTokenVerification(token))));
						case 'ViewBusinessProfile':
							var domain = route.a.a;
							return _Utils_Tuple2(
								route,
								A2(
									$elm$core$Task$perform,
									$author$project$Types$OnBusinessProfile,
									$elm$core$Task$succeed(
										A2($author$project$Type$BusinessProfile$OnPageEnter, endPoint, domain))));
						default:
							break _v0$26;
					}
				default:
					break _v0$26;
			}
		}
		return _Utils_Tuple2(route, $elm$core$Platform$Cmd$none);
	});
var $elm$time$Time$Zone = F2(
	function (a, b) {
		return {$: 'Zone', a: a, b: b};
	});
var $elm$time$Time$customZone = $elm$time$Time$Zone;
var $elm$json$Json$Decode$decodeString = _Json_runOnString;
var $author$project$Data$User$User = function (id) {
	return function (domains) {
		return function (firstName) {
			return function (lastName) {
				return function (email) {
					return function (createdAt) {
						return function (updatedAt) {
							return function (identificationNumber) {
								return function (phoneNumber) {
									return function (nationality) {
										return function (dateOfBirth) {
											return function (address) {
												return function (jwt) {
													return function (notification) {
														return function (trustScore) {
															return function (avatarUrl) {
																return function (eSignDisclaimer) {
																	return function (eSignDisclaimerTimestamp) {
																		return function (metaMaskWalletAddress) {
																			return function (shareReferralCode) {
																				return function (updateNameConfirmation) {
																					return function (notarisationNetwork) {
																						return function (paymentMethod) {
																							return function (algorandWalletAddress) {
																								return function (notariseByDefault) {
																									return function (showAds) {
																										return {address: address, algorandWalletAddress: algorandWalletAddress, avatarUrl: avatarUrl, createdAt: createdAt, dateOfBirth: dateOfBirth, domains: domains, eSignDisclaimer: eSignDisclaimer, eSignDisclaimerTimestamp: eSignDisclaimerTimestamp, email: email, firstName: firstName, id: id, identificationNumber: identificationNumber, jwt: jwt, lastName: lastName, metaMaskWalletAddress: metaMaskWalletAddress, nationality: nationality, notarisationNetwork: notarisationNetwork, notariseByDefault: notariseByDefault, notification: notification, paymentMethod: paymentMethod, phoneNumber: phoneNumber, shareReferralCode: shareReferralCode, showAds: showAds, trustScore: trustScore, updateNameConfirmation: updateNameConfirmation, updatedAt: updatedAt};
																									};
																								};
																							};
																						};
																					};
																				};
																			};
																		};
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $elm$json$Json$Decode$bool = _Json_decodeBool;
var $author$project$Data$Domain$Domains = F2(
	function (a, b) {
		return {$: 'Domains', a: a, b: b};
	});
var $author$project$Data$Domain$Domain = function (a) {
	return {$: 'Domain', a: a};
};
var $elm$json$Json$Decode$string = _Json_decodeString;
var $author$project$Data$Domain$domainDecoder = A2($elm$json$Json$Decode$map, $author$project$Data$Domain$Domain, $elm$json$Json$Decode$string);
var $elm$json$Json$Decode$list = _Json_decodeList;
var $author$project$Data$Domain$domainsDecoder = A3(
	$elm$json$Json$Decode$map2,
	$author$project$Data$Domain$Domains,
	A2($elm$json$Json$Decode$field, 'selected', $author$project$Data$Domain$domainDecoder),
	A2(
		$elm$json$Json$Decode$field,
		'domains',
		$elm$json$Json$Decode$list($author$project$Data$Domain$domainDecoder)));
var $elm$json$Json$Decode$int = _Json_decodeInt;
var $elm$time$Time$Posix = function (a) {
	return {$: 'Posix', a: a};
};
var $elm$time$Time$millisToPosix = $elm$time$Time$Posix;
var $author$project$Data$User$Notification = function (email) {
	return {email: email};
};
var $author$project$Data$User$notificationDecoder = A2(
	$elm$json$Json$Decode$map,
	$author$project$Data$User$Notification,
	A2($elm$json$Json$Decode$field, 'email', $elm$json$Json$Decode$bool));
var $elm$json$Json$Decode$null = _Json_decodeNull;
var $elm$json$Json$Decode$oneOf = _Json_oneOf;
var $elm$json$Json$Decode$nullable = function (decoder) {
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				$elm$json$Json$Decode$null($elm$core$Maybe$Nothing),
				A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, decoder)
			]));
};
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom = $elm$json$Json$Decode$map2($elm$core$Basics$apR);
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required = F3(
	function (key, valDecoder, decoder) {
		return A2(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
			A2($elm$json$Json$Decode$field, key, valDecoder),
			decoder);
	});
var $author$project$Data$User$TrustScore = F7(
	function (passbase, shuftiPro, myInfo, corporate, stripe, mobilePhone, wallet) {
		return {corporate: corporate, mobilePhone: mobilePhone, myInfo: myInfo, passbase: passbase, shuftiPro: shuftiPro, stripe: stripe, wallet: wallet};
	});
var $elm$json$Json$Decode$map7 = _Json_map7;
var $author$project$Data$User$trustScoreDecoder = A8(
	$elm$json$Json$Decode$map7,
	$author$project$Data$User$TrustScore,
	A2($elm$json$Json$Decode$field, 'passbase', $elm$json$Json$Decode$bool),
	A2($elm$json$Json$Decode$field, 'shuftiPro', $elm$json$Json$Decode$bool),
	A2($elm$json$Json$Decode$field, 'myInfo', $elm$json$Json$Decode$bool),
	A2($elm$json$Json$Decode$field, 'corporate', $elm$json$Json$Decode$bool),
	A2($elm$json$Json$Decode$field, 'stripe', $elm$json$Json$Decode$bool),
	A2($elm$json$Json$Decode$field, 'mobilePhone', $elm$json$Json$Decode$bool),
	A2($elm$json$Json$Decode$field, 'wallet', $elm$json$Json$Decode$bool));
var $author$project$Data$User$decoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'showAds',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'notariseByDefault',
		$elm$json$Json$Decode$bool,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'algorandWalletAddress',
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'paymentMethod',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'notarisationNetwork',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'updateNameConfirmation',
						$elm$json$Json$Decode$bool,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'shareReferralCode',
							$elm$json$Json$Decode$string,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'metaMaskWalletAddress',
								$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'eSignDisclaimerTimestamp',
									$elm$json$Json$Decode$nullable(
										A2($elm$json$Json$Decode$map, $elm$time$Time$millisToPosix, $elm$json$Json$Decode$int)),
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'eSignDisclaimer',
										$elm$json$Json$Decode$bool,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'avatarUrl',
											$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'trustScore',
												$author$project$Data$User$trustScoreDecoder,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'notification',
													$author$project$Data$User$notificationDecoder,
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'jwt',
														$elm$json$Json$Decode$string,
														A3(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
															'address',
															$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
															A3(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																'dateOfBirth',
																$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
																A3(
																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																	'nationality',
																	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
																	A3(
																		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																		'phoneNumber',
																		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
																		A3(
																			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																			'identificationNumber',
																			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
																			A3(
																				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																				'updatedAt',
																				A2($elm$json$Json$Decode$map, $elm$time$Time$millisToPosix, $elm$json$Json$Decode$int),
																				A3(
																					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																					'createdAt',
																					A2($elm$json$Json$Decode$map, $elm$time$Time$millisToPosix, $elm$json$Json$Decode$int),
																					A3(
																						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																						'email',
																						$elm$json$Json$Decode$string,
																						A3(
																							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																							'lastName',
																							$elm$json$Json$Decode$string,
																							A3(
																								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																								'firstName',
																								$elm$json$Json$Decode$string,
																								A3(
																									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																									'domains',
																									$author$project$Data$Domain$domainsDecoder,
																									A3(
																										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																										'id',
																										$elm$json$Json$Decode$string,
																										$elm$json$Json$Decode$succeed($author$project$Data$User$User)))))))))))))))))))))))))));
var $author$project$Data$Api$endPoint = F6(
	function (apiHost, passbaseUrl, affliateUrl, affliateParams, bscScanApi, bscScanContractAddr) {
		return {activate: apiHost + '/activate', addressBookAccept: apiHost + '/address-book/accept', addressBookAutocomplete: apiHost + '/autocomplete-addressbook', addressBookDecline: apiHost + '/address-book/decline', addressBookDelete: apiHost + '/address-book/delete', addressBookEdit: apiHost + '/address-book/edit', addressBookInvite: apiHost + '/address-book/invite', addressBookList: apiHost + '/address-book/list', affliateParams: affliateParams, affliateUrl: affliateUrl, appsumoRegister: apiHost + '/appsumo/register', bscScanAccountBalanceApi: bscScanApi + ('?module=account&action=tokenbalance&contractaddress=' + bscScanContractAddr), businessAcceptInvite: apiHost + '/business/invite/accept', businessCreate: apiHost + '/business/create', businessInviteUser: apiHost + '/business/invite-user', businessListUsers: apiHost + '/business/list-users', businessProfile: apiHost + '/business/profile', businessTheme: apiHost + '/business/theme', cancelNotarisation: apiHost + '/pdf/cancelNotarisation', checkIsSingleRoleTemplate: apiHost + '/checkIsSingleRoleTemplate', confirmDeleteDocument: apiHost + '/confirm-delete-pdf', confirmDeleteTemplate: apiHost + '/confirm-delete-template', dashboardCompletedDocs: apiHost + '/dashboard/completed-documents', dashboardIncomingDocs: apiHost + '/dashboard/incoming-documents', dashboardOutgoingDocs: apiHost + '/dashboard/outgoing-documents', dashboardPoints: apiHost + '/dashboard/points', deleteDocument: apiHost + '/delete-pdf', deleteTemplate: apiHost + '/delete-template', docDeadlineExt: apiHost + '/update-doc-deadline', downloadCompletedCert: apiHost + '/downloadDocumentCert/', downloadCredentialFile: apiHost + '/getVerifiableCredential/', downloadFile: apiHost + '/completed-file/', downloadTemplateReport: apiHost + '/downloadTemplateReport/', downloadWrappedFile: apiHost + '/pdf/getWrappedDocument/', generateCredentialCost: apiHost + '/pdf/generateCredentialCost', generateCredentials: apiHost + '/verifiableCredentials/generateCredentials', getAlgorandNotarisationDetails: apiHost + '/notariseAlgorandWallet', getCredentialData: apiHost + '/verifiableCredentials/listCredentials', getNotarisationInfo: apiHost + '/pdf/getNotarisationInfo', getOptInStatus: apiHost + '/checkOptInStatus', getOptinDetails: apiHost + '/getOptInData', getUserApiKey: apiHost + '/userApiKey/get', issueAnonymousTemplateToken: apiHost + '/issue-template-token', listAllTemplate: apiHost + '/list-all-templates', listCompleted: apiHost + '/pdf-list-completed', listReceived: apiHost + '/pdf-list-received', listSent: apiHost + '/pdf-list-sent', listSigningEventData: apiHost + '/listSigningEvents', listSubmission: apiHost + '/list-template-submissions', listTemplate: apiHost + '/list-templates', login: apiHost + '/login', logout: apiHost + '/logout', myInfo: apiHost + '/myinfo', myInfoEnv: apiHost + '/myinfo-env', newfoldRegister: apiHost + '/newfold/register', notariseCompletedDocument: apiHost + '/pdf/notariseCompletedDocument', notariseDocumentAlgorandNetwork: apiHost + '/notariseDocumentAlgorand', notariseDocumentCost: apiHost + '/pdf/notarisationCost', passbaseUrl: passbaseUrl, pdfFile: apiHost + '/file', pointsDashboard: apiHost + '/points-dashboard', pointsTopUp: apiHost + '/stripe/topup', pointsTransaction: apiHost + '/points-transaction', pointsTransactionHistory: apiHost + '/points-transaction-history', pointsWalletRegistration: apiHost + '/points-wallet', pointsWithdraw: apiHost + '/points-withdrawal', pointsWithdrawConfirmation: apiHost + '/points-withdrawal-confirm', redeemCouponCode: apiHost + '/redeemCouponCode', redeemReward: apiHost + '/redeem-reward', redeemRewardList: apiHost + '/redeem-reward-list', registerAlgorandWallet: apiHost + '/updateAlgorandWallet', registerBusiness: apiHost + '/stripe/session', registerPersonal: apiHost + '/register', resendActivation: apiHost + '/resend-activation-email', resetPassword: apiHost + '/password/reset', retryNotarisation: apiHost + '/retryNotarisation', sendEmailReminder: apiHost + '/emailReminder', sendTemplateAsDocument: apiHost + '/sendTemplateAsDocument', setPassword: apiHost + '/password/update', signatureDelete: apiHost + '/signature/delete', signatureFile: apiHost + '/signature/file', signatureList: apiHost + '/signature/list', signatureTimestamping: apiHost + '/signatureTimestamping', signatureUpload: apiHost + '/signature/upload', sse: apiHost + '/sse', stampDelete: apiHost + '/stamp/delete', stampFile: apiHost + '/stamp/file', stampList: apiHost + '/stamp/list', stampUpload: apiHost + '/stamp/upload', submissionDownload: apiHost + '/template-file-download', submitTemplate: apiHost + '/submit-template', templateFile: apiHost + '/template-file', templateQuota: apiHost + '/getTemplateQuota', tokenConfirmation: apiHost + '/token-transfer-confirm', tokenTransaction: apiHost + '/token-transfer', twilioConfirm: apiHost + '/twilio/confirm', twilioStart: apiHost + '/twilio/start', updateBusinessProfile: apiHost + '/business/update-profile', updateBusinessTheme: apiHost + '/business/update-theme', updateESignatureDisclaimer: apiHost + '/update-esignature-disclaimer', updateNotarisationNetwork: apiHost + '/update-notarisationNetwork', updateNotification: apiHost + '/update-notification', updatePassword: apiHost + '/update-password', updatePdf: apiHost + '/update-pdf', updateProfile: apiHost + '/update-profile', updateShowAds: apiHost + '/updateUserShowAdsOption', updateUserFirstNameLastName: apiHost + '/update-userFirstNameLastName', uploadAvatar: apiHost + '/upload-avatar', uploadPdf: apiHost + '/upload-pdf', uploadTemplate: apiHost + '/upload-template', validateDocumentToken: apiHost + '/validate-document-token', validateDomain: apiHost + '/validate-domain', validatePasscode: apiHost + '/validate-passcode', validateTemplateToken: apiHost + '/validate-template-token', verifyDocument: apiHost + '/verify-document', viewPdf: apiHost + '/view-pdf', viewTemplate: apiHost + '/view-template'};
	});
var $author$project$Data$Domain$fromString = function (domain) {
	return $author$project$Data$Domain$Domain(domain);
};
var $author$project$Data$Domain$fromUrl = function (url) {
	return $author$project$Data$Domain$Domain(url.host);
};
var $author$project$Data$Route$getAcceptBusinessInviteToken = function (route) {
	if ((route.$ === 'PublicOrAuth') && (route.a.$ === 'AcceptBusinessInviteRoute')) {
		var token = route.a.a;
		return token;
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Data$Route$getActivateToken = function (route) {
	if ((route.$ === 'Public') && (route.a.$ === 'ActivateRoute')) {
		var token = route.a.a;
		return token;
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Data$Route$getConfirmDeleteDocumentToken = function (route) {
	if ((route.$ === 'PublicOrAuth') && (route.a.$ === 'ConfirmDeleteDocumentRoute')) {
		var token = route.a.a;
		return token;
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Data$Route$getConfirmDeleteTemplateToken = function (route) {
	if ((route.$ === 'PublicOrAuth') && (route.a.$ === 'ConfirmDeleteTemplateRoute')) {
		var token = route.a.a;
		return token;
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Data$Route$getConfirmWithdrawalToken = function (route) {
	if ((route.$ === 'PublicOrAuth') && (route.a.$ === 'PointWithdrawalConfirmation')) {
		var token = route.a.a;
		return token;
	} else {
		return '';
	}
};
var $author$project$Data$Route$NoAccessToPublicRoute = {$: 'NoAccessToPublicRoute'};
var $author$project$Data$Route$NotAuthorizedRoute = function (a) {
	return {$: 'NotAuthorizedRoute', a: a};
};
var $author$project$Data$Route$NotFoundRoute = {$: 'NotFoundRoute'};
var $author$project$Data$Route$Public = function (a) {
	return {$: 'Public', a: a};
};
var $elm$core$Basics$always = F2(
	function (a, _v0) {
		return a;
	});
var $author$project$Data$Route$AddressBookRoute = {$: 'AddressBookRoute'};
var $author$project$Data$Route$BusinessCreateSuccessRoute = {$: 'BusinessCreateSuccessRoute'};
var $author$project$Data$Route$BusinessProfile = {$: 'BusinessProfile'};
var $author$project$Data$Route$CreateTemplateRoute = {$: 'CreateTemplateRoute'};
var $author$project$Data$Route$ListDocumentRoute = function (a) {
	return {$: 'ListDocumentRoute', a: a};
};
var $author$project$Data$Route$LogoutRoute = {$: 'LogoutRoute'};
var $author$project$Data$Route$NewMultipleDocumentRoute = {$: 'NewMultipleDocumentRoute'};
var $author$project$Data$Route$NewTemplateRoute = {$: 'NewTemplateRoute'};
var $author$project$Data$Route$PointTransaction = function (a) {
	return {$: 'PointTransaction', a: a};
};
var $author$project$Data$Route$PointTransactionHistory = {$: 'PointTransactionHistory'};
var $author$project$Data$Route$RedeemRewardList = {$: 'RedeemRewardList'};
var $author$project$Data$Route$SettingRoute = function (a) {
	return {$: 'SettingRoute', a: a};
};
var $author$project$Data$Route$TokenManagementRoute = {$: 'TokenManagementRoute'};
var $author$project$Data$Route$TopUpSuccess = {$: 'TopUpSuccess'};
var $author$project$Data$Route$TrustScoreRoute = {$: 'TrustScoreRoute'};
var $author$project$Data$Route$UploadMultipleDocRoute = {$: 'UploadMultipleDocRoute'};
var $author$project$Data$Route$VerifyDocument = {$: 'VerifyDocument'};
var $author$project$Data$Route$VerifyTransaction = {$: 'VerifyTransaction'};
var $author$project$Data$Route$ViewNotarisationInfo = {$: 'ViewNotarisationInfo'};
var $elm$url$Url$Parser$Parser = function (a) {
	return {$: 'Parser', a: a};
};
var $elm$url$Url$Parser$State = F5(
	function (visited, unvisited, params, frag, value) {
		return {frag: frag, params: params, unvisited: unvisited, value: value, visited: visited};
	});
var $elm$url$Url$Parser$mapState = F2(
	function (func, _v0) {
		var visited = _v0.visited;
		var unvisited = _v0.unvisited;
		var params = _v0.params;
		var frag = _v0.frag;
		var value = _v0.value;
		return A5(
			$elm$url$Url$Parser$State,
			visited,
			unvisited,
			params,
			frag,
			func(value));
	});
var $elm$url$Url$Parser$map = F2(
	function (subValue, _v0) {
		var parseArg = _v0.a;
		return $elm$url$Url$Parser$Parser(
			function (_v1) {
				var visited = _v1.visited;
				var unvisited = _v1.unvisited;
				var params = _v1.params;
				var frag = _v1.frag;
				var value = _v1.value;
				return A2(
					$elm$core$List$map,
					$elm$url$Url$Parser$mapState(value),
					parseArg(
						A5($elm$url$Url$Parser$State, visited, unvisited, params, frag, subValue)));
			});
	});
var $elm$core$List$append = F2(
	function (xs, ys) {
		if (!ys.b) {
			return xs;
		} else {
			return A3($elm$core$List$foldr, $elm$core$List$cons, ys, xs);
		}
	});
var $elm$core$List$concat = function (lists) {
	return A3($elm$core$List$foldr, $elm$core$List$append, _List_Nil, lists);
};
var $elm$core$List$concatMap = F2(
	function (f, list) {
		return $elm$core$List$concat(
			A2($elm$core$List$map, f, list));
	});
var $elm$url$Url$Parser$oneOf = function (parsers) {
	return $elm$url$Url$Parser$Parser(
		function (state) {
			return A2(
				$elm$core$List$concatMap,
				function (_v0) {
					var parser = _v0.a;
					return parser(state);
				},
				parsers);
		});
};
var $elm$url$Url$Parser$query = function (_v0) {
	var queryParser = _v0.a;
	return $elm$url$Url$Parser$Parser(
		function (_v1) {
			var visited = _v1.visited;
			var unvisited = _v1.unvisited;
			var params = _v1.params;
			var frag = _v1.frag;
			var value = _v1.value;
			return _List_fromArray(
				[
					A5(
					$elm$url$Url$Parser$State,
					visited,
					unvisited,
					params,
					frag,
					value(
						queryParser(params)))
				]);
		});
};
var $elm$url$Url$Parser$slash = F2(
	function (_v0, _v1) {
		var parseBefore = _v0.a;
		var parseAfter = _v1.a;
		return $elm$url$Url$Parser$Parser(
			function (state) {
				return A2(
					$elm$core$List$concatMap,
					parseAfter,
					parseBefore(state));
			});
	});
var $elm$url$Url$Parser$questionMark = F2(
	function (parser, queryParser) {
		return A2(
			$elm$url$Url$Parser$slash,
			parser,
			$elm$url$Url$Parser$query(queryParser));
	});
var $elm$url$Url$Parser$s = function (str) {
	return $elm$url$Url$Parser$Parser(
		function (_v0) {
			var visited = _v0.visited;
			var unvisited = _v0.unvisited;
			var params = _v0.params;
			var frag = _v0.frag;
			var value = _v0.value;
			if (!unvisited.b) {
				return _List_Nil;
			} else {
				var next = unvisited.a;
				var rest = unvisited.b;
				return _Utils_eq(next, str) ? _List_fromArray(
					[
						A5(
						$elm$url$Url$Parser$State,
						A2($elm$core$List$cons, next, visited),
						rest,
						params,
						frag,
						value)
					]) : _List_Nil;
			}
		});
};
var $elm$url$Url$Parser$custom = F2(
	function (tipe, stringToSomething) {
		return $elm$url$Url$Parser$Parser(
			function (_v0) {
				var visited = _v0.visited;
				var unvisited = _v0.unvisited;
				var params = _v0.params;
				var frag = _v0.frag;
				var value = _v0.value;
				if (!unvisited.b) {
					return _List_Nil;
				} else {
					var next = unvisited.a;
					var rest = unvisited.b;
					var _v2 = stringToSomething(next);
					if (_v2.$ === 'Just') {
						var nextValue = _v2.a;
						return _List_fromArray(
							[
								A5(
								$elm$url$Url$Parser$State,
								A2($elm$core$List$cons, next, visited),
								rest,
								params,
								frag,
								value(nextValue))
							]);
					} else {
						return _List_Nil;
					}
				}
			});
	});
var $elm$url$Url$Parser$string = A2($elm$url$Url$Parser$custom, 'STRING', $elm$core$Maybe$Just);
var $elm$url$Url$Parser$Internal$Parser = function (a) {
	return {$: 'Parser', a: a};
};
var $elm$core$Basics$compare = _Utils_compare;
var $elm$core$Dict$get = F2(
	function (targetKey, dict) {
		get:
		while (true) {
			if (dict.$ === 'RBEmpty_elm_builtin') {
				return $elm$core$Maybe$Nothing;
			} else {
				var key = dict.b;
				var value = dict.c;
				var left = dict.d;
				var right = dict.e;
				var _v1 = A2($elm$core$Basics$compare, targetKey, key);
				switch (_v1.$) {
					case 'LT':
						var $temp$targetKey = targetKey,
							$temp$dict = left;
						targetKey = $temp$targetKey;
						dict = $temp$dict;
						continue get;
					case 'EQ':
						return $elm$core$Maybe$Just(value);
					default:
						var $temp$targetKey = targetKey,
							$temp$dict = right;
						targetKey = $temp$targetKey;
						dict = $temp$dict;
						continue get;
				}
			}
		}
	});
var $elm$url$Url$Parser$Query$custom = F2(
	function (key, func) {
		return $elm$url$Url$Parser$Internal$Parser(
			function (dict) {
				return func(
					A2(
						$elm$core$Maybe$withDefault,
						_List_Nil,
						A2($elm$core$Dict$get, key, dict)));
			});
	});
var $elm$url$Url$Parser$Query$string = function (key) {
	return A2(
		$elm$url$Url$Parser$Query$custom,
		key,
		function (stringList) {
			if (stringList.b && (!stringList.b.b)) {
				var str = stringList.a;
				return $elm$core$Maybe$Just(str);
			} else {
				return $elm$core$Maybe$Nothing;
			}
		});
};
var $elm$url$Url$Parser$top = $elm$url$Url$Parser$Parser(
	function (state) {
		return _List_fromArray(
			[state]);
	});
var $author$project$Data$Route$authRouteParser = $elm$url$Url$Parser$oneOf(
	_List_fromArray(
		[
			A2($elm$url$Url$Parser$map, $author$project$Data$Route$DashboardRoute, $elm$url$Url$Parser$top),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Data$Route$DashboardRoute,
			$elm$url$Url$Parser$s('dashboard')),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Data$Route$LogoutRoute,
			$elm$url$Url$Parser$s('logout')),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Data$Route$AddressBookRoute,
			$elm$url$Url$Parser$s('addressbook')),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Data$Route$SettingRoute,
			A2(
				$elm$url$Url$Parser$questionMark,
				$elm$url$Url$Parser$s('settings'),
				$elm$url$Url$Parser$Query$string('code'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Data$Route$BusinessProfile,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('business'),
				$elm$url$Url$Parser$s('profile'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Data$Route$BusinessCreateSuccessRoute,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('business'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('create'),
					$elm$url$Url$Parser$s('success')))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Data$Route$TopUpSuccess,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('topup'),
				$elm$url$Url$Parser$s('success'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Data$Route$CreateTemplateRoute,
			$elm$url$Url$Parser$s('create-template')),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Data$Route$NewTemplateRoute,
			$elm$url$Url$Parser$s('new-template')),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Data$Route$TrustScoreRoute,
			$elm$url$Url$Parser$s('trust-score')),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Data$Route$ListDocumentRoute,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('documents'),
				$elm$url$Url$Parser$string)),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Data$Route$TokenManagementRoute,
			$elm$url$Url$Parser$s('pointsManagement')),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Data$Route$PointTransactionHistory,
			$elm$url$Url$Parser$s('points-activities')),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Data$Route$PointTransaction,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('transaction'),
				$elm$url$Url$Parser$string)),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Data$Route$VerifyTransaction,
			$elm$url$Url$Parser$s('verifyTransaction')),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Data$Route$VerifyDocument,
			$elm$url$Url$Parser$s('verifyDocument')),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Data$Route$RedeemRewardList,
			$elm$url$Url$Parser$s('redeem-reward-list')),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Data$Route$NewMultipleDocumentRoute,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('new-document'),
				$elm$url$Url$Parser$s('multiple-upload'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Data$Route$UploadMultipleDocRoute,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('upload-document'),
				$elm$url$Url$Parser$s('multiple'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Data$Route$ViewNotarisationInfo,
			$elm$url$Url$Parser$s('viewNotarisationInfo'))
		]));
var $author$project$Data$Route$PublicOrAuth = function (a) {
	return {$: 'PublicOrAuth', a: a};
};
var $author$project$Data$Route$RedirectRoute = function (a) {
	return {$: 'RedirectRoute', a: a};
};
var $elm$core$Maybe$map = F2(
	function (f, maybe) {
		if (maybe.$ === 'Just') {
			var value = maybe.a;
			return $elm$core$Maybe$Just(
				f(value));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Data$Route$getPublicOrAuthRoute = F3(
	function (publicOrAuthRoute, maybeAuthModel, url) {
		switch (publicOrAuthRoute.$) {
			case 'ViewDocumentRoute':
				var idOrToken = publicOrAuthRoute.a;
				var checkDocIdOrToken = A2($elm$core$String$contains, '.', idOrToken) ? $elm$core$Maybe$Just(
					$author$project$Data$Route$PublicOrAuth(publicOrAuthRoute)) : $elm$core$Maybe$Just(
					A2(
						$elm$core$Maybe$withDefault,
						$author$project$Data$Route$PublicOrAuth(
							$author$project$Data$Route$RedirectRoute(url.path)),
						A2(
							$elm$core$Maybe$map,
							function (_v1) {
								return $author$project$Data$Route$PublicOrAuth(publicOrAuthRoute);
							},
							maybeAuthModel)));
				return checkDocIdOrToken;
			case 'FillTemplateRoute':
				return $elm$core$Maybe$Just(
					$author$project$Data$Route$PublicOrAuth(publicOrAuthRoute));
			case 'AcceptBusinessInviteRoute':
				return $elm$core$Maybe$Just(
					$author$project$Data$Route$PublicOrAuth(publicOrAuthRoute));
			case 'ViewBusinessProfile':
				return $elm$core$Maybe$Just(
					$author$project$Data$Route$PublicOrAuth(publicOrAuthRoute));
			case 'RedirectRoute':
				return $elm$core$Maybe$Just(
					$author$project$Data$Route$PublicOrAuth(publicOrAuthRoute));
			case 'TokenConfirmationRoute':
				return $elm$core$Maybe$Just(
					$author$project$Data$Route$PublicOrAuth(publicOrAuthRoute));
			case 'PointWithdrawalConfirmation':
				return $elm$core$Maybe$Just(
					$author$project$Data$Route$PublicOrAuth(publicOrAuthRoute));
			case 'ConfirmDeleteDocumentRoute':
				return $elm$core$Maybe$Just(
					$author$project$Data$Route$PublicOrAuth(publicOrAuthRoute));
			case 'ConfirmDeleteTemplateRoute':
				return $elm$core$Maybe$Just(
					$author$project$Data$Route$PublicOrAuth(publicOrAuthRoute));
			default:
				return $elm$core$Maybe$Just(
					$author$project$Data$Route$PublicOrAuth(publicOrAuthRoute));
		}
	});
var $elm$url$Url$Parser$getFirstMatch = function (states) {
	getFirstMatch:
	while (true) {
		if (!states.b) {
			return $elm$core$Maybe$Nothing;
		} else {
			var state = states.a;
			var rest = states.b;
			var _v1 = state.unvisited;
			if (!_v1.b) {
				return $elm$core$Maybe$Just(state.value);
			} else {
				if ((_v1.a === '') && (!_v1.b.b)) {
					return $elm$core$Maybe$Just(state.value);
				} else {
					var $temp$states = rest;
					states = $temp$states;
					continue getFirstMatch;
				}
			}
		}
	}
};
var $elm$url$Url$Parser$removeFinalEmpty = function (segments) {
	if (!segments.b) {
		return _List_Nil;
	} else {
		if ((segments.a === '') && (!segments.b.b)) {
			return _List_Nil;
		} else {
			var segment = segments.a;
			var rest = segments.b;
			return A2(
				$elm$core$List$cons,
				segment,
				$elm$url$Url$Parser$removeFinalEmpty(rest));
		}
	}
};
var $elm$url$Url$Parser$preparePath = function (path) {
	var _v0 = A2($elm$core$String$split, '/', path);
	if (_v0.b && (_v0.a === '')) {
		var segments = _v0.b;
		return $elm$url$Url$Parser$removeFinalEmpty(segments);
	} else {
		var segments = _v0;
		return $elm$url$Url$Parser$removeFinalEmpty(segments);
	}
};
var $elm$url$Url$Parser$addToParametersHelp = F2(
	function (value, maybeList) {
		if (maybeList.$ === 'Nothing') {
			return $elm$core$Maybe$Just(
				_List_fromArray(
					[value]));
		} else {
			var list = maybeList.a;
			return $elm$core$Maybe$Just(
				A2($elm$core$List$cons, value, list));
		}
	});
var $elm$url$Url$percentDecode = _Url_percentDecode;
var $elm$core$Dict$Black = {$: 'Black'};
var $elm$core$Dict$RBNode_elm_builtin = F5(
	function (a, b, c, d, e) {
		return {$: 'RBNode_elm_builtin', a: a, b: b, c: c, d: d, e: e};
	});
var $elm$core$Dict$RBEmpty_elm_builtin = {$: 'RBEmpty_elm_builtin'};
var $elm$core$Dict$Red = {$: 'Red'};
var $elm$core$Dict$balance = F5(
	function (color, key, value, left, right) {
		if ((right.$ === 'RBNode_elm_builtin') && (right.a.$ === 'Red')) {
			var _v1 = right.a;
			var rK = right.b;
			var rV = right.c;
			var rLeft = right.d;
			var rRight = right.e;
			if ((left.$ === 'RBNode_elm_builtin') && (left.a.$ === 'Red')) {
				var _v3 = left.a;
				var lK = left.b;
				var lV = left.c;
				var lLeft = left.d;
				var lRight = left.e;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					$elm$core$Dict$Red,
					key,
					value,
					A5($elm$core$Dict$RBNode_elm_builtin, $elm$core$Dict$Black, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, $elm$core$Dict$Black, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					color,
					rK,
					rV,
					A5($elm$core$Dict$RBNode_elm_builtin, $elm$core$Dict$Red, key, value, left, rLeft),
					rRight);
			}
		} else {
			if ((((left.$ === 'RBNode_elm_builtin') && (left.a.$ === 'Red')) && (left.d.$ === 'RBNode_elm_builtin')) && (left.d.a.$ === 'Red')) {
				var _v5 = left.a;
				var lK = left.b;
				var lV = left.c;
				var _v6 = left.d;
				var _v7 = _v6.a;
				var llK = _v6.b;
				var llV = _v6.c;
				var llLeft = _v6.d;
				var llRight = _v6.e;
				var lRight = left.e;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					$elm$core$Dict$Red,
					lK,
					lV,
					A5($elm$core$Dict$RBNode_elm_builtin, $elm$core$Dict$Black, llK, llV, llLeft, llRight),
					A5($elm$core$Dict$RBNode_elm_builtin, $elm$core$Dict$Black, key, value, lRight, right));
			} else {
				return A5($elm$core$Dict$RBNode_elm_builtin, color, key, value, left, right);
			}
		}
	});
var $elm$core$Dict$insertHelp = F3(
	function (key, value, dict) {
		if (dict.$ === 'RBEmpty_elm_builtin') {
			return A5($elm$core$Dict$RBNode_elm_builtin, $elm$core$Dict$Red, key, value, $elm$core$Dict$RBEmpty_elm_builtin, $elm$core$Dict$RBEmpty_elm_builtin);
		} else {
			var nColor = dict.a;
			var nKey = dict.b;
			var nValue = dict.c;
			var nLeft = dict.d;
			var nRight = dict.e;
			var _v1 = A2($elm$core$Basics$compare, key, nKey);
			switch (_v1.$) {
				case 'LT':
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						A3($elm$core$Dict$insertHelp, key, value, nLeft),
						nRight);
				case 'EQ':
					return A5($elm$core$Dict$RBNode_elm_builtin, nColor, nKey, value, nLeft, nRight);
				default:
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						nLeft,
						A3($elm$core$Dict$insertHelp, key, value, nRight));
			}
		}
	});
var $elm$core$Dict$insert = F3(
	function (key, value, dict) {
		var _v0 = A3($elm$core$Dict$insertHelp, key, value, dict);
		if ((_v0.$ === 'RBNode_elm_builtin') && (_v0.a.$ === 'Red')) {
			var _v1 = _v0.a;
			var k = _v0.b;
			var v = _v0.c;
			var l = _v0.d;
			var r = _v0.e;
			return A5($elm$core$Dict$RBNode_elm_builtin, $elm$core$Dict$Black, k, v, l, r);
		} else {
			var x = _v0;
			return x;
		}
	});
var $elm$core$Dict$getMin = function (dict) {
	getMin:
	while (true) {
		if ((dict.$ === 'RBNode_elm_builtin') && (dict.d.$ === 'RBNode_elm_builtin')) {
			var left = dict.d;
			var $temp$dict = left;
			dict = $temp$dict;
			continue getMin;
		} else {
			return dict;
		}
	}
};
var $elm$core$Dict$moveRedLeft = function (dict) {
	if (((dict.$ === 'RBNode_elm_builtin') && (dict.d.$ === 'RBNode_elm_builtin')) && (dict.e.$ === 'RBNode_elm_builtin')) {
		if ((dict.e.d.$ === 'RBNode_elm_builtin') && (dict.e.d.a.$ === 'Red')) {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v1 = dict.d;
			var lClr = _v1.a;
			var lK = _v1.b;
			var lV = _v1.c;
			var lLeft = _v1.d;
			var lRight = _v1.e;
			var _v2 = dict.e;
			var rClr = _v2.a;
			var rK = _v2.b;
			var rV = _v2.c;
			var rLeft = _v2.d;
			var _v3 = rLeft.a;
			var rlK = rLeft.b;
			var rlV = rLeft.c;
			var rlL = rLeft.d;
			var rlR = rLeft.e;
			var rRight = _v2.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				$elm$core$Dict$Red,
				rlK,
				rlV,
				A5(
					$elm$core$Dict$RBNode_elm_builtin,
					$elm$core$Dict$Black,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, $elm$core$Dict$Red, lK, lV, lLeft, lRight),
					rlL),
				A5($elm$core$Dict$RBNode_elm_builtin, $elm$core$Dict$Black, rK, rV, rlR, rRight));
		} else {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v4 = dict.d;
			var lClr = _v4.a;
			var lK = _v4.b;
			var lV = _v4.c;
			var lLeft = _v4.d;
			var lRight = _v4.e;
			var _v5 = dict.e;
			var rClr = _v5.a;
			var rK = _v5.b;
			var rV = _v5.c;
			var rLeft = _v5.d;
			var rRight = _v5.e;
			if (clr.$ === 'Black') {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					$elm$core$Dict$Black,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, $elm$core$Dict$Red, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, $elm$core$Dict$Red, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					$elm$core$Dict$Black,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, $elm$core$Dict$Red, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, $elm$core$Dict$Red, rK, rV, rLeft, rRight));
			}
		}
	} else {
		return dict;
	}
};
var $elm$core$Dict$moveRedRight = function (dict) {
	if (((dict.$ === 'RBNode_elm_builtin') && (dict.d.$ === 'RBNode_elm_builtin')) && (dict.e.$ === 'RBNode_elm_builtin')) {
		if ((dict.d.d.$ === 'RBNode_elm_builtin') && (dict.d.d.a.$ === 'Red')) {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v1 = dict.d;
			var lClr = _v1.a;
			var lK = _v1.b;
			var lV = _v1.c;
			var _v2 = _v1.d;
			var _v3 = _v2.a;
			var llK = _v2.b;
			var llV = _v2.c;
			var llLeft = _v2.d;
			var llRight = _v2.e;
			var lRight = _v1.e;
			var _v4 = dict.e;
			var rClr = _v4.a;
			var rK = _v4.b;
			var rV = _v4.c;
			var rLeft = _v4.d;
			var rRight = _v4.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				$elm$core$Dict$Red,
				lK,
				lV,
				A5($elm$core$Dict$RBNode_elm_builtin, $elm$core$Dict$Black, llK, llV, llLeft, llRight),
				A5(
					$elm$core$Dict$RBNode_elm_builtin,
					$elm$core$Dict$Black,
					k,
					v,
					lRight,
					A5($elm$core$Dict$RBNode_elm_builtin, $elm$core$Dict$Red, rK, rV, rLeft, rRight)));
		} else {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v5 = dict.d;
			var lClr = _v5.a;
			var lK = _v5.b;
			var lV = _v5.c;
			var lLeft = _v5.d;
			var lRight = _v5.e;
			var _v6 = dict.e;
			var rClr = _v6.a;
			var rK = _v6.b;
			var rV = _v6.c;
			var rLeft = _v6.d;
			var rRight = _v6.e;
			if (clr.$ === 'Black') {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					$elm$core$Dict$Black,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, $elm$core$Dict$Red, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, $elm$core$Dict$Red, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					$elm$core$Dict$Black,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, $elm$core$Dict$Red, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, $elm$core$Dict$Red, rK, rV, rLeft, rRight));
			}
		}
	} else {
		return dict;
	}
};
var $elm$core$Dict$removeHelpPrepEQGT = F7(
	function (targetKey, dict, color, key, value, left, right) {
		if ((left.$ === 'RBNode_elm_builtin') && (left.a.$ === 'Red')) {
			var _v1 = left.a;
			var lK = left.b;
			var lV = left.c;
			var lLeft = left.d;
			var lRight = left.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				color,
				lK,
				lV,
				lLeft,
				A5($elm$core$Dict$RBNode_elm_builtin, $elm$core$Dict$Red, key, value, lRight, right));
		} else {
			_v2$2:
			while (true) {
				if ((right.$ === 'RBNode_elm_builtin') && (right.a.$ === 'Black')) {
					if (right.d.$ === 'RBNode_elm_builtin') {
						if (right.d.a.$ === 'Black') {
							var _v3 = right.a;
							var _v4 = right.d;
							var _v5 = _v4.a;
							return $elm$core$Dict$moveRedRight(dict);
						} else {
							break _v2$2;
						}
					} else {
						var _v6 = right.a;
						var _v7 = right.d;
						return $elm$core$Dict$moveRedRight(dict);
					}
				} else {
					break _v2$2;
				}
			}
			return dict;
		}
	});
var $elm$core$Dict$removeMin = function (dict) {
	if ((dict.$ === 'RBNode_elm_builtin') && (dict.d.$ === 'RBNode_elm_builtin')) {
		var color = dict.a;
		var key = dict.b;
		var value = dict.c;
		var left = dict.d;
		var lColor = left.a;
		var lLeft = left.d;
		var right = dict.e;
		if (lColor.$ === 'Black') {
			if ((lLeft.$ === 'RBNode_elm_builtin') && (lLeft.a.$ === 'Red')) {
				var _v3 = lLeft.a;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					color,
					key,
					value,
					$elm$core$Dict$removeMin(left),
					right);
			} else {
				var _v4 = $elm$core$Dict$moveRedLeft(dict);
				if (_v4.$ === 'RBNode_elm_builtin') {
					var nColor = _v4.a;
					var nKey = _v4.b;
					var nValue = _v4.c;
					var nLeft = _v4.d;
					var nRight = _v4.e;
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						$elm$core$Dict$removeMin(nLeft),
						nRight);
				} else {
					return $elm$core$Dict$RBEmpty_elm_builtin;
				}
			}
		} else {
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				color,
				key,
				value,
				$elm$core$Dict$removeMin(left),
				right);
		}
	} else {
		return $elm$core$Dict$RBEmpty_elm_builtin;
	}
};
var $elm$core$Dict$removeHelp = F2(
	function (targetKey, dict) {
		if (dict.$ === 'RBEmpty_elm_builtin') {
			return $elm$core$Dict$RBEmpty_elm_builtin;
		} else {
			var color = dict.a;
			var key = dict.b;
			var value = dict.c;
			var left = dict.d;
			var right = dict.e;
			if (_Utils_cmp(targetKey, key) < 0) {
				if ((left.$ === 'RBNode_elm_builtin') && (left.a.$ === 'Black')) {
					var _v4 = left.a;
					var lLeft = left.d;
					if ((lLeft.$ === 'RBNode_elm_builtin') && (lLeft.a.$ === 'Red')) {
						var _v6 = lLeft.a;
						return A5(
							$elm$core$Dict$RBNode_elm_builtin,
							color,
							key,
							value,
							A2($elm$core$Dict$removeHelp, targetKey, left),
							right);
					} else {
						var _v7 = $elm$core$Dict$moveRedLeft(dict);
						if (_v7.$ === 'RBNode_elm_builtin') {
							var nColor = _v7.a;
							var nKey = _v7.b;
							var nValue = _v7.c;
							var nLeft = _v7.d;
							var nRight = _v7.e;
							return A5(
								$elm$core$Dict$balance,
								nColor,
								nKey,
								nValue,
								A2($elm$core$Dict$removeHelp, targetKey, nLeft),
								nRight);
						} else {
							return $elm$core$Dict$RBEmpty_elm_builtin;
						}
					}
				} else {
					return A5(
						$elm$core$Dict$RBNode_elm_builtin,
						color,
						key,
						value,
						A2($elm$core$Dict$removeHelp, targetKey, left),
						right);
				}
			} else {
				return A2(
					$elm$core$Dict$removeHelpEQGT,
					targetKey,
					A7($elm$core$Dict$removeHelpPrepEQGT, targetKey, dict, color, key, value, left, right));
			}
		}
	});
var $elm$core$Dict$removeHelpEQGT = F2(
	function (targetKey, dict) {
		if (dict.$ === 'RBNode_elm_builtin') {
			var color = dict.a;
			var key = dict.b;
			var value = dict.c;
			var left = dict.d;
			var right = dict.e;
			if (_Utils_eq(targetKey, key)) {
				var _v1 = $elm$core$Dict$getMin(right);
				if (_v1.$ === 'RBNode_elm_builtin') {
					var minKey = _v1.b;
					var minValue = _v1.c;
					return A5(
						$elm$core$Dict$balance,
						color,
						minKey,
						minValue,
						left,
						$elm$core$Dict$removeMin(right));
				} else {
					return $elm$core$Dict$RBEmpty_elm_builtin;
				}
			} else {
				return A5(
					$elm$core$Dict$balance,
					color,
					key,
					value,
					left,
					A2($elm$core$Dict$removeHelp, targetKey, right));
			}
		} else {
			return $elm$core$Dict$RBEmpty_elm_builtin;
		}
	});
var $elm$core$Dict$remove = F2(
	function (key, dict) {
		var _v0 = A2($elm$core$Dict$removeHelp, key, dict);
		if ((_v0.$ === 'RBNode_elm_builtin') && (_v0.a.$ === 'Red')) {
			var _v1 = _v0.a;
			var k = _v0.b;
			var v = _v0.c;
			var l = _v0.d;
			var r = _v0.e;
			return A5($elm$core$Dict$RBNode_elm_builtin, $elm$core$Dict$Black, k, v, l, r);
		} else {
			var x = _v0;
			return x;
		}
	});
var $elm$core$Dict$update = F3(
	function (targetKey, alter, dictionary) {
		var _v0 = alter(
			A2($elm$core$Dict$get, targetKey, dictionary));
		if (_v0.$ === 'Just') {
			var value = _v0.a;
			return A3($elm$core$Dict$insert, targetKey, value, dictionary);
		} else {
			return A2($elm$core$Dict$remove, targetKey, dictionary);
		}
	});
var $elm$url$Url$Parser$addParam = F2(
	function (segment, dict) {
		var _v0 = A2($elm$core$String$split, '=', segment);
		if ((_v0.b && _v0.b.b) && (!_v0.b.b.b)) {
			var rawKey = _v0.a;
			var _v1 = _v0.b;
			var rawValue = _v1.a;
			var _v2 = $elm$url$Url$percentDecode(rawKey);
			if (_v2.$ === 'Nothing') {
				return dict;
			} else {
				var key = _v2.a;
				var _v3 = $elm$url$Url$percentDecode(rawValue);
				if (_v3.$ === 'Nothing') {
					return dict;
				} else {
					var value = _v3.a;
					return A3(
						$elm$core$Dict$update,
						key,
						$elm$url$Url$Parser$addToParametersHelp(value),
						dict);
				}
			}
		} else {
			return dict;
		}
	});
var $elm$core$Dict$empty = $elm$core$Dict$RBEmpty_elm_builtin;
var $elm$url$Url$Parser$prepareQuery = function (maybeQuery) {
	if (maybeQuery.$ === 'Nothing') {
		return $elm$core$Dict$empty;
	} else {
		var qry = maybeQuery.a;
		return A3(
			$elm$core$List$foldr,
			$elm$url$Url$Parser$addParam,
			$elm$core$Dict$empty,
			A2($elm$core$String$split, '&', qry));
	}
};
var $elm$url$Url$Parser$parse = F2(
	function (_v0, url) {
		var parser = _v0.a;
		return $elm$url$Url$Parser$getFirstMatch(
			parser(
				A5(
					$elm$url$Url$Parser$State,
					_List_Nil,
					$elm$url$Url$Parser$preparePath(url.path),
					$elm$url$Url$Parser$prepareQuery(url.query),
					url.fragment,
					$elm$core$Basics$identity)));
	});
var $author$project$Data$Route$AcceptBusinessInviteRoute = function (a) {
	return {$: 'AcceptBusinessInviteRoute', a: a};
};
var $author$project$Data$Route$ConfirmDeleteDocumentRoute = function (a) {
	return {$: 'ConfirmDeleteDocumentRoute', a: a};
};
var $author$project$Data$Route$ConfirmDeleteTemplateRoute = function (a) {
	return {$: 'ConfirmDeleteTemplateRoute', a: a};
};
var $author$project$Data$Route$FillTemplateRoute = function (a) {
	return {$: 'FillTemplateRoute', a: a};
};
var $author$project$Data$Route$TokenConfirmationRoute = function (a) {
	return {$: 'TokenConfirmationRoute', a: a};
};
var $author$project$Data$Route$ViewBusinessProfile = function (a) {
	return {$: 'ViewBusinessProfile', a: a};
};
var $author$project$Data$Route$ViewDocumentRoute = function (a) {
	return {$: 'ViewDocumentRoute', a: a};
};
var $author$project$Data$Route$ViewTemplateRoute = function (a) {
	return {$: 'ViewTemplateRoute', a: a};
};
var $author$project$Data$Route$publicOrAuthRouteParser = F2(
	function (appDomain, url) {
		var domain = $author$project$Data$Domain$fromUrl(url);
		return $elm$url$Url$Parser$oneOf(
			_Utils_ap(
				_List_fromArray(
					[
						A2(
						$elm$url$Url$Parser$map,
						$author$project$Data$Route$AcceptBusinessInviteRoute,
						A2(
							$elm$url$Url$Parser$slash,
							$elm$url$Url$Parser$s('business'),
							A2(
								$elm$url$Url$Parser$questionMark,
								$elm$url$Url$Parser$s('invitation'),
								$elm$url$Url$Parser$Query$string('token')))),
						A2(
						$elm$url$Url$Parser$map,
						$author$project$Data$Route$ViewBusinessProfile(domain),
						A2(
							$elm$url$Url$Parser$slash,
							$elm$url$Url$Parser$s('business'),
							$elm$url$Url$Parser$s('view'))),
						A2(
						$elm$url$Url$Parser$map,
						$author$project$Data$Route$ViewDocumentRoute,
						A2(
							$elm$url$Url$Parser$slash,
							$elm$url$Url$Parser$s('document'),
							$elm$url$Url$Parser$string)),
						A2(
						$elm$url$Url$Parser$map,
						$author$project$Data$Route$FillTemplateRoute,
						A2(
							$elm$url$Url$Parser$slash,
							$elm$url$Url$Parser$s('form'),
							$elm$url$Url$Parser$string)),
						A2(
						$elm$url$Url$Parser$map,
						$author$project$Data$Route$TokenConfirmationRoute,
						A2(
							$elm$url$Url$Parser$slash,
							$elm$url$Url$Parser$s('confirm-transfer'),
							$elm$url$Url$Parser$string)),
						A2(
						$elm$url$Url$Parser$map,
						$author$project$Data$Route$ConfirmDeleteDocumentRoute,
						A2(
							$elm$url$Url$Parser$questionMark,
							$elm$url$Url$Parser$s('confirm-delete-document'),
							$elm$url$Url$Parser$Query$string('token'))),
						A2(
						$elm$url$Url$Parser$map,
						$author$project$Data$Route$ConfirmDeleteTemplateRoute,
						A2(
							$elm$url$Url$Parser$questionMark,
							$elm$url$Url$Parser$s('confirm-delete-template'),
							$elm$url$Url$Parser$Query$string('token'))),
						A2(
						$elm$url$Url$Parser$map,
						$author$project$Data$Route$ViewTemplateRoute,
						A2(
							$elm$url$Url$Parser$slash,
							$elm$url$Url$Parser$s('template'),
							$elm$url$Url$Parser$string))
					]),
				A2($author$project$Data$Domain$equal, domain, appDomain) ? _List_Nil : _List_fromArray(
					[
						A2(
						$elm$url$Url$Parser$map,
						$author$project$Data$Route$ViewBusinessProfile(domain),
						$elm$url$Url$Parser$top)
					])));
	});
var $author$project$Data$Route$ActivateRoute = function (a) {
	return {$: 'ActivateRoute', a: a};
};
var $author$project$Data$Route$AppsumoRegisterRoute = function (a) {
	return {$: 'AppsumoRegisterRoute', a: a};
};
var $author$project$Data$Route$BusinessRegisterRoute = function (a) {
	return {$: 'BusinessRegisterRoute', a: a};
};
var $author$project$Data$Route$BusinessRegisterSuccessRoute = {$: 'BusinessRegisterSuccessRoute'};
var $author$project$Data$Route$LoginRoute = {$: 'LoginRoute'};
var $author$project$Data$Route$NewfoldRegisterRoute = F2(
	function (a, b) {
		return {$: 'NewfoldRegisterRoute', a: a, b: b};
	});
var $author$project$Data$Route$OrganizationUserRegisterRoute = function (a) {
	return {$: 'OrganizationUserRegisterRoute', a: a};
};
var $author$project$Data$Route$PersonalRegisterRoute = function (a) {
	return {$: 'PersonalRegisterRoute', a: a};
};
var $author$project$Data$Route$RegisterParams = F3(
	function (email, redirect, ref) {
		return {email: email, redirect: redirect, ref: ref};
	});
var $author$project$Data$Route$RegisterSuccessRoute = {$: 'RegisterSuccessRoute'};
var $author$project$Data$Route$ResendActivationEmailSentRoute = {$: 'ResendActivationEmailSentRoute'};
var $author$project$Data$Route$ResendActivationRoute = {$: 'ResendActivationRoute'};
var $author$project$Data$Route$ResetPasswordEmailSentRoute = {$: 'ResetPasswordEmailSentRoute'};
var $author$project$Data$Route$ResetPasswordRoute = {$: 'ResetPasswordRoute'};
var $author$project$Data$Route$ResetPasswordSuccessRoute = {$: 'ResetPasswordSuccessRoute'};
var $author$project$Data$Route$ResetPasswordUpdateRoute = function (a) {
	return {$: 'ResetPasswordUpdateRoute', a: a};
};
var $author$project$Data$Route$SignUpRoute = {$: 'SignUpRoute'};
var $author$project$Data$Route$publicRouteParser = $elm$url$Url$Parser$oneOf(
	_List_fromArray(
		[
			A2($elm$url$Url$Parser$map, $author$project$Data$Route$LoginRoute, $elm$url$Url$Parser$top),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Data$Route$LoginRoute,
			$elm$url$Url$Parser$s('login')),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Data$Route$SignUpRoute,
			$elm$url$Url$Parser$s('sign-up')),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Data$Route$PersonalRegisterRoute,
			A2(
				$elm$url$Url$Parser$map,
				$author$project$Data$Route$RegisterParams,
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('register'),
					A2(
						$elm$url$Url$Parser$questionMark,
						A2(
							$elm$url$Url$Parser$questionMark,
							A2(
								$elm$url$Url$Parser$questionMark,
								$elm$url$Url$Parser$s('personal'),
								$elm$url$Url$Parser$Query$string('email')),
							$elm$url$Url$Parser$Query$string('redirect')),
						$elm$url$Url$Parser$Query$string('ref'))))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Data$Route$OrganizationUserRegisterRoute,
			A2(
				$elm$url$Url$Parser$map,
				$author$project$Data$Route$RegisterParams,
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('register'),
					A2(
						$elm$url$Url$Parser$questionMark,
						A2(
							$elm$url$Url$Parser$questionMark,
							A2(
								$elm$url$Url$Parser$questionMark,
								$elm$url$Url$Parser$s('organization-user'),
								$elm$url$Url$Parser$Query$string('email')),
							$elm$url$Url$Parser$Query$string('redirect')),
						$elm$url$Url$Parser$Query$string('ref'))))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Data$Route$BusinessRegisterRoute,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('register'),
				A2(
					$elm$url$Url$Parser$questionMark,
					$elm$url$Url$Parser$s('business'),
					$elm$url$Url$Parser$Query$string('ref')))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Data$Route$AppsumoRegisterRoute,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('register'),
				A2(
					$elm$url$Url$Parser$questionMark,
					$elm$url$Url$Parser$s('sumobusiness'),
					$elm$url$Url$Parser$Query$string('ref')))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Data$Route$NewfoldRegisterRoute,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('register'),
				A2(
					$elm$url$Url$Parser$questionMark,
					A2(
						$elm$url$Url$Parser$questionMark,
						$elm$url$Url$Parser$s('crazydomainsspecial'),
						$elm$url$Url$Parser$Query$string('plan')),
					$elm$url$Url$Parser$Query$string('ref')))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Data$Route$BusinessRegisterSuccessRoute,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('register'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('business'),
					$elm$url$Url$Parser$s('success')))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Data$Route$RegisterSuccessRoute,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('register'),
				$elm$url$Url$Parser$s('success'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Data$Route$ActivateRoute,
			A2(
				$elm$url$Url$Parser$questionMark,
				$elm$url$Url$Parser$s('activate'),
				$elm$url$Url$Parser$Query$string('token'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Data$Route$ResendActivationEmailSentRoute,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('resend-activation'),
				$elm$url$Url$Parser$s('email-sent'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Data$Route$ResendActivationRoute,
			$elm$url$Url$Parser$s('resend-activation')),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Data$Route$ResetPasswordSuccessRoute,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('reset-password'),
				$elm$url$Url$Parser$s('success'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Data$Route$ResetPasswordEmailSentRoute,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('reset-password'),
				$elm$url$Url$Parser$s('email-sent'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Data$Route$ResetPasswordRoute,
			$elm$url$Url$Parser$s('reset-password')),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Data$Route$ResetPasswordUpdateRoute,
			A2(
				$elm$url$Url$Parser$questionMark,
				$elm$url$Url$Parser$s('set-password'),
				$elm$url$Url$Parser$Query$string('token')))
		]));
var $author$project$Data$Route$getRoute = F3(
	function (appDomain, maybeAuthModel, url) {
		return A2(
			$elm$core$Maybe$withDefault,
			$author$project$Data$Route$NotFoundRoute,
			function () {
				var _v0 = A2(
					$elm$url$Url$Parser$parse,
					A2($author$project$Data$Route$publicOrAuthRouteParser, appDomain, url),
					url);
				if (_v0.$ === 'Just') {
					var publicOrAuthRoute = _v0.a;
					return A3($author$project$Data$Route$getPublicOrAuthRoute, publicOrAuthRoute, maybeAuthModel, url);
				} else {
					if (maybeAuthModel.$ === 'Just') {
						var _v2 = A2($elm$url$Url$Parser$parse, $author$project$Data$Route$authRouteParser, url);
						if (_v2.$ === 'Just') {
							var authRoute = _v2.a;
							return $elm$core$Maybe$Just(
								$author$project$Data$Route$Auth(authRoute));
						} else {
							return A2(
								$elm$core$Maybe$map,
								$elm$core$Basics$always(
									$author$project$Data$Route$Auth($author$project$Data$Route$NoAccessToPublicRoute)),
								A2($elm$url$Url$Parser$parse, $author$project$Data$Route$publicRouteParser, url));
						}
					} else {
						var _v3 = A2($elm$url$Url$Parser$parse, $author$project$Data$Route$publicRouteParser, url);
						if (_v3.$ === 'Just') {
							var publicRoute = _v3.a;
							return $elm$core$Maybe$Just(
								$author$project$Data$Route$Public(publicRoute));
						} else {
							return A2(
								$elm$core$Maybe$map,
								$elm$core$Basics$always(
									$author$project$Data$Route$Public(
										$author$project$Data$Route$NotAuthorizedRoute(url.path))),
								A2($elm$url$Url$Parser$parse, $author$project$Data$Route$authRouteParser, url));
						}
					}
				}
			}());
	});
var $elm$time$Time$Name = function (a) {
	return {$: 'Name', a: a};
};
var $elm$time$Time$Offset = function (a) {
	return {$: 'Offset', a: a};
};
var $elm$time$Time$getZoneName = _Time_getZoneName(_Utils_Tuple0);
var $elm$time$Time$here = _Time_here(_Utils_Tuple0);
var $author$project$Types$OnActivate = function (a) {
	return {$: 'OnActivate', a: a};
};
var $author$project$Type$Activate$OnEnter = {$: 'OnEnter'};
var $author$project$Type$Activate$Submitting = {$: 'Submitting'};
var $author$project$Model$Activate$init = function (maybeToken) {
	return _Utils_Tuple2(
		{status: $author$project$Type$Activate$Submitting, token: maybeToken},
		A2(
			$elm$core$Task$perform,
			$author$project$Types$OnActivate,
			$elm$core$Task$succeed($author$project$Type$Activate$OnEnter)));
};
var $author$project$Type$AppsumoRegister$Loaded = {$: 'Loaded'};
var $author$project$Type$AppsumoRegister$Ready = {$: 'Ready'};
var $author$project$Model$AppsumoRegister$getReferralCodeFromRoute = function (route) {
	if (route.$ === 'Public') {
		var publicRoute = route.a;
		if (publicRoute.$ === 'AppsumoRegisterRoute') {
			var refCode = publicRoute.a;
			if (refCode.$ === 'Just') {
				var string = refCode.a;
				return string;
			} else {
				return '';
			}
		} else {
			return '';
		}
	} else {
		return '';
	}
};
var $author$project$Model$AppsumoRegister$init = function (route) {
	return {
		companyName: '',
		companyNameError: $elm$core$Maybe$Nothing,
		email: '',
		emailError: $elm$core$Maybe$Nothing,
		firstName: '',
		firstNameError: $elm$core$Maybe$Nothing,
		formStatus: $author$project$Type$AppsumoRegister$Ready,
		hasAgreedTerms: false,
		hasAgreedTermsError: $elm$core$Maybe$Nothing,
		lastName: '',
		lastNameError: $elm$core$Maybe$Nothing,
		password: '',
		passwordAgain: '',
		passwordAgainError: $elm$core$Maybe$Nothing,
		passwordError: $elm$core$Maybe$Nothing,
		redirectError: $elm$core$Maybe$Nothing,
		referralCode: $author$project$Model$AppsumoRegister$getReferralCodeFromRoute(route),
		referralCodeError: $elm$core$Maybe$Nothing,
		subdomain: '',
		subdomainError: $elm$core$Maybe$Nothing,
		subdomainStatus: $elm$core$Maybe$Nothing,
		validationStatus: $author$project$Type$AppsumoRegister$Loaded
	};
};
var $author$project$Type$BusinessAcceptInvite$AcceptResponse = function (a) {
	return {$: 'AcceptResponse', a: a};
};
var $author$project$Type$BusinessAcceptInvite$HasToken = F2(
	function (a, b) {
		return {$: 'HasToken', a: a, b: b};
	});
var $author$project$Type$BusinessAcceptInvite$NoToken = {$: 'NoToken'};
var $author$project$Types$OnBusinessAcceptInvite = function (a) {
	return {$: 'OnBusinessAcceptInvite', a: a};
};
var $author$project$Type$BusinessAcceptInvite$Submitting = {$: 'Submitting'};
var $elm$core$Basics$composeL = F3(
	function (g, f, x) {
		return g(
			f(x));
	});
var $elm$core$Task$onError = _Scheduler_onError;
var $elm$core$Task$attempt = F2(
	function (resultToMessage, task) {
		return $elm$core$Task$command(
			$elm$core$Task$Perform(
				A2(
					$elm$core$Task$onError,
					A2(
						$elm$core$Basics$composeL,
						A2($elm$core$Basics$composeL, $elm$core$Task$succeed, resultToMessage),
						$elm$core$Result$Err),
					A2(
						$elm$core$Task$andThen,
						A2(
							$elm$core$Basics$composeL,
							A2($elm$core$Basics$composeL, $elm$core$Task$succeed, resultToMessage),
							$elm$core$Result$Ok),
						task))));
	});
var $author$project$Data$Api$BusinessAcceptInvite$Payload = function (message) {
	return {message: message};
};
var $author$project$Data$Api$BusinessAcceptInvite$dataDecoder = A2(
	$elm$json$Json$Decode$map,
	$author$project$Data$Api$BusinessAcceptInvite$Payload,
	A2($elm$json$Json$Decode$field, 'message', $elm$json$Json$Decode$string));
var $elm$json$Json$Encode$object = function (pairs) {
	return _Json_wrap(
		A3(
			$elm$core$List$foldl,
			F2(
				function (_v0, obj) {
					var k = _v0.a;
					var v = _v0.b;
					return A3(_Json_addField, k, v, obj);
				}),
			_Json_emptyObject(_Utils_Tuple0),
			pairs));
};
var $elm$json$Json$Encode$string = _Json_wrap;
var $author$project$Data$Api$BusinessAcceptInvite$encode = function (_v0) {
	var token = _v0.token;
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'token',
				$elm$json$Json$Encode$string(token))
			]));
};
var $author$project$Data$Api$BusinessAcceptInvite$DOMAIN_NOT_FOUND = {$: 'DOMAIN_NOT_FOUND'};
var $author$project$Data$Api$BusinessAcceptInvite$INVALID_TOKEN = {$: 'INVALID_TOKEN'};
var $author$project$Data$Api$BusinessAcceptInvite$TOKEN_EXPIRED = {$: 'TOKEN_EXPIRED'};
var $author$project$Data$Api$BusinessAcceptInvite$USER_NOT_FOUND = {$: 'USER_NOT_FOUND'};
var $elm$json$Json$Decode$fail = _Json_fail;
var $author$project$Data$Api$BusinessAcceptInvite$errorDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (errorCode) {
		switch (errorCode) {
			case 'INVALID_TOKEN':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$BusinessAcceptInvite$INVALID_TOKEN);
			case 'TOKEN_EXPIRED':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$BusinessAcceptInvite$TOKEN_EXPIRED);
			case 'USER_NOT_FOUND':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$BusinessAcceptInvite$USER_NOT_FOUND);
			case 'DOMAIN_NOT_FOUND':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$BusinessAcceptInvite$DOMAIN_NOT_FOUND);
			default:
				return $elm$json$Json$Decode$fail('Invalid error code: ' + errorCode);
		}
	},
	$elm$json$Json$Decode$string);
var $elm$http$Http$BadStatus_ = F2(
	function (a, b) {
		return {$: 'BadStatus_', a: a, b: b};
	});
var $elm$http$Http$BadUrl_ = function (a) {
	return {$: 'BadUrl_', a: a};
};
var $elm$http$Http$GoodStatus_ = F2(
	function (a, b) {
		return {$: 'GoodStatus_', a: a, b: b};
	});
var $elm$http$Http$NetworkError_ = {$: 'NetworkError_'};
var $elm$http$Http$Receiving = function (a) {
	return {$: 'Receiving', a: a};
};
var $elm$http$Http$Sending = function (a) {
	return {$: 'Sending', a: a};
};
var $elm$http$Http$Timeout_ = {$: 'Timeout_'};
var $elm$core$Maybe$isJust = function (maybe) {
	if (maybe.$ === 'Just') {
		return true;
	} else {
		return false;
	}
};
var $elm$core$Platform$sendToSelf = _Platform_sendToSelf;
var $elm$http$Http$jsonBody = function (value) {
	return A2(
		_Http_pair,
		'application/json',
		A2($elm$json$Json$Encode$encode, 0, value));
};
var $author$project$Data$Api$BadStatus = F2(
	function (a, b) {
		return {$: 'BadStatus', a: a, b: b};
	});
var $author$project$Data$Api$BadUrl = function (a) {
	return {$: 'BadUrl', a: a};
};
var $author$project$Data$Api$DataDecodeError = function (a) {
	return {$: 'DataDecodeError', a: a};
};
var $author$project$Data$Api$Fail = function (a) {
	return {$: 'Fail', a: a};
};
var $author$project$Data$Api$NetworkError = {$: 'NetworkError'};
var $author$project$Data$Api$NonStandardApiError = function (a) {
	return {$: 'NonStandardApiError', a: a};
};
var $author$project$Data$Api$ServerInternalError = {$: 'ServerInternalError'};
var $author$project$Data$Api$Timeout = {$: 'Timeout'};
var $author$project$Data$Api$Failure = F3(
	function (status, code, message) {
		return {code: code, message: message, status: status};
	});
var $elm$json$Json$Decode$at = F2(
	function (fields, decoder) {
		return A3($elm$core$List$foldr, $elm$json$Json$Decode$field, decoder, fields);
	});
var $elm$json$Json$Decode$map3 = _Json_map3;
var $author$project$Data$Api$statusDecoder = function (expectedStatus) {
	return A2(
		$elm$json$Json$Decode$andThen,
		function (decodedStatus) {
			return _Utils_eq(expectedStatus, decodedStatus) ? $elm$json$Json$Decode$succeed(decodedStatus) : $elm$json$Json$Decode$fail('Expecting ' + (expectedStatus + (' but received ' + decodedStatus)));
		},
		$elm$json$Json$Decode$string);
};
var $author$project$Data$Api$failureDecoder = function (errorDecoder) {
	return A4(
		$elm$json$Json$Decode$map3,
		$author$project$Data$Api$Failure,
		A2(
			$elm$json$Json$Decode$field,
			'status',
			$author$project$Data$Api$statusDecoder('Err')),
		A2(
			$elm$json$Json$Decode$at,
			_List_fromArray(
				['error', 'code']),
			errorDecoder),
		A2(
			$elm$json$Json$Decode$at,
			_List_fromArray(
				['error', 'message']),
			$elm$json$Json$Decode$string));
};
var $author$project$Data$Api$Success = F2(
	function (status, data) {
		return {data: data, status: status};
	});
var $author$project$Data$Api$successDecoder = function (dataDecoder) {
	return A3(
		$elm$json$Json$Decode$map2,
		$author$project$Data$Api$Success,
		A2(
			$elm$json$Json$Decode$field,
			'status',
			$author$project$Data$Api$statusDecoder('OK')),
		A2($elm$json$Json$Decode$field, 'data', dataDecoder));
};
var $author$project$Data$Api$responseResolver = F3(
	function (errorDecoder, dataDecoder, response) {
		switch (response.$) {
			case 'BadUrl_':
				var url = response.a;
				return $elm$core$Result$Err(
					$author$project$Data$Api$BadUrl(url));
			case 'Timeout_':
				return $elm$core$Result$Err($author$project$Data$Api$Timeout);
			case 'NetworkError_':
				return $elm$core$Result$Err($author$project$Data$Api$NetworkError);
			case 'BadStatus_':
				var metadata = response.a;
				var body = response.b;
				if (metadata.statusCode === 500) {
					return $elm$core$Result$Err($author$project$Data$Api$ServerInternalError);
				} else {
					if (metadata.statusCode === 400) {
						var _v1 = A2(
							$elm$json$Json$Decode$decodeString,
							$author$project$Data$Api$failureDecoder(errorDecoder),
							body);
						if (_v1.$ === 'Ok') {
							var failure = _v1.a;
							return $elm$core$Result$Err(
								$author$project$Data$Api$Fail(failure.code));
						} else {
							var error = _v1.a;
							return $elm$core$Result$Err(
								$author$project$Data$Api$NonStandardApiError(
									$elm$json$Json$Decode$errorToString(error)));
						}
					} else {
						return $elm$core$Result$Err(
							A2($author$project$Data$Api$BadStatus, metadata, body));
					}
				}
			default:
				var body = response.b;
				var _v2 = A2(
					$elm$json$Json$Decode$decodeString,
					$author$project$Data$Api$successDecoder(dataDecoder),
					body);
				if (_v2.$ === 'Ok') {
					var success = _v2.a;
					return $elm$core$Result$Ok(success.data);
				} else {
					var error = _v2.a;
					return $elm$core$Result$Err(
						$author$project$Data$Api$DataDecodeError(
							$elm$json$Json$Decode$errorToString(error)));
				}
		}
	});
var $elm$http$Http$stringResolver = A2(_Http_expect, '', $elm$core$Basics$identity);
var $elm$core$Task$fail = _Scheduler_fail;
var $elm$http$Http$resultToTask = function (result) {
	if (result.$ === 'Ok') {
		var a = result.a;
		return $elm$core$Task$succeed(a);
	} else {
		var x = result.a;
		return $elm$core$Task$fail(x);
	}
};
var $elm$http$Http$task = function (r) {
	return A3(
		_Http_toTask,
		_Utils_Tuple0,
		$elm$http$Http$resultToTask,
		{allowCookiesFromOtherDomains: false, body: r.body, expect: r.resolver, headers: r.headers, method: r.method, timeout: r.timeout, tracker: $elm$core$Maybe$Nothing, url: r.url});
};
var $author$project$Data$Api$httpTask = F4(
	function (url, errorDecoder, dataDecoder, jsonBody) {
		return $elm$http$Http$task(
			{
				body: $elm$http$Http$jsonBody(jsonBody),
				headers: _List_Nil,
				method: 'POST',
				resolver: $elm$http$Http$stringResolver(
					A2($author$project$Data$Api$responseResolver, errorDecoder, dataDecoder)),
				timeout: $elm$core$Maybe$Just(30000),
				url: url
			});
	});
var $author$project$Data$Api$BusinessAcceptInvite$call = F2(
	function (endPoint, params) {
		return A4(
			$author$project$Data$Api$httpTask,
			endPoint,
			$author$project$Data$Api$BusinessAcceptInvite$errorDecoder,
			$author$project$Data$Api$BusinessAcceptInvite$dataDecoder,
			$author$project$Data$Api$BusinessAcceptInvite$encode(params));
	});
var $author$project$Model$BusinessAcceptInvite$init = F2(
	function (endPoint, maybeToken) {
		if (maybeToken.$ === 'Just') {
			var token = maybeToken.a;
			return _Utils_Tuple2(
				A2($author$project$Type$BusinessAcceptInvite$HasToken, token, $author$project$Type$BusinessAcceptInvite$Submitting),
				A2(
					$elm$core$Task$attempt,
					A2($elm$core$Basics$composeL, $author$project$Types$OnBusinessAcceptInvite, $author$project$Type$BusinessAcceptInvite$AcceptResponse),
					A2(
						$author$project$Data$Api$BusinessAcceptInvite$call,
						endPoint.businessAcceptInvite,
						{token: token})));
		} else {
			return _Utils_Tuple2($author$project$Type$BusinessAcceptInvite$NoToken, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Type$BusinessProfile$Close = {$: 'Close'};
var $author$project$Type$BusinessProfile$Closed = {$: 'Closed'};
var $author$project$Material$Styled$Snackbar$Hide = {$: 'Hide'};
var $author$project$Type$BusinessProfile$LoadProfile = function (a) {
	return {$: 'LoadProfile', a: a};
};
var $author$project$Type$BusinessProfile$LoadTemplate = function (a) {
	return {$: 'LoadTemplate', a: a};
};
var $author$project$Type$BusinessProfile$Loading = {$: 'Loading'};
var $author$project$Data$Api$Business$Profile$Normal = {$: 'Normal'};
var $author$project$Type$BusinessProfile$Ready = function (a) {
	return {$: 'Ready', a: a};
};
var $author$project$Data$Api$Business$Profile$Payload = function (business) {
	return {business: business};
};
var $author$project$Data$Api$Business$Profile$BusinessData = function (domain) {
	return function (name) {
		return function (title) {
			return function (description) {
				return function (contactName) {
					return function (contactEmail) {
						return function (contactPhone) {
							return function (ownerId) {
								return function (createdAt) {
									return function (updatedAt) {
										return function (isDeleted) {
											return function (shareReferralCode) {
												return function (plan) {
													return {contactEmail: contactEmail, contactName: contactName, contactPhone: contactPhone, createdAt: createdAt, description: description, domain: domain, isDeleted: isDeleted, name: name, ownerId: ownerId, plan: plan, shareReferralCode: shareReferralCode, title: title, updatedAt: updatedAt};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $elm$json$Json$Decode$decodeValue = _Json_run;
var $elm$json$Json$Decode$value = _Json_decodeValue;
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalDecoder = F3(
	function (pathDecoder, valDecoder, fallback) {
		var nullOr = function (decoder) {
			return $elm$json$Json$Decode$oneOf(
				_List_fromArray(
					[
						decoder,
						$elm$json$Json$Decode$null(fallback)
					]));
		};
		var handleResult = function (input) {
			var _v0 = A2($elm$json$Json$Decode$decodeValue, pathDecoder, input);
			if (_v0.$ === 'Ok') {
				var rawValue = _v0.a;
				var _v1 = A2(
					$elm$json$Json$Decode$decodeValue,
					nullOr(valDecoder),
					rawValue);
				if (_v1.$ === 'Ok') {
					var finalResult = _v1.a;
					return $elm$json$Json$Decode$succeed(finalResult);
				} else {
					var finalErr = _v1.a;
					return $elm$json$Json$Decode$fail(
						$elm$json$Json$Decode$errorToString(finalErr));
				}
			} else {
				return $elm$json$Json$Decode$succeed(fallback);
			}
		};
		return A2($elm$json$Json$Decode$andThen, handleResult, $elm$json$Json$Decode$value);
	});
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional = F4(
	function (key, valDecoder, fallback, decoder) {
		return A2(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalDecoder,
				A2($elm$json$Json$Decode$field, key, $elm$json$Json$Decode$value),
				valDecoder,
				fallback),
			decoder);
	});
var $author$project$Data$Api$Business$Profile$AppSumo = {$: 'AppSumo'};
var $author$project$Data$Api$Business$Profile$AppsumoPlan2 = {$: 'AppsumoPlan2'};
var $author$project$Data$Api$Business$Profile$planDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (plan) {
		switch (plan) {
			case 'Normal':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$Business$Profile$Normal);
			case 'Appsumo':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$Business$Profile$AppSumo);
			case 'AppsumoPlan2':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$Business$Profile$AppsumoPlan2);
			default:
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$Business$Profile$Normal);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Data$Api$Business$Profile$businessDataDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'plan',
	$author$project$Data$Api$Business$Profile$planDecoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'shareReferralCode',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'isDeleted',
			$elm$json$Json$Decode$bool,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'updatedAt',
				A2($elm$json$Json$Decode$map, $elm$time$Time$millisToPosix, $elm$json$Json$Decode$int),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'createdAt',
					A2($elm$json$Json$Decode$map, $elm$time$Time$millisToPosix, $elm$json$Json$Decode$int),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'ownerId',
						$elm$json$Json$Decode$string,
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'contactPhone',
							A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
							$elm$core$Maybe$Nothing,
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'contactEmail',
								A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
								$elm$core$Maybe$Nothing,
								A4(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
									'contactName',
									A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
									$elm$core$Maybe$Nothing,
									A4(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
										'description',
										A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
										$elm$core$Maybe$Nothing,
										A4(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
											'title',
											A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
											$elm$core$Maybe$Nothing,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'name',
												$elm$json$Json$Decode$string,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'domain',
													$elm$json$Json$Decode$string,
													$elm$json$Json$Decode$succeed($author$project$Data$Api$Business$Profile$BusinessData))))))))))))));
var $author$project$Data$Api$Business$Profile$dataDecoder = A2(
	$elm$json$Json$Decode$map,
	$author$project$Data$Api$Business$Profile$Payload,
	A2($elm$json$Json$Decode$field, 'business', $author$project$Data$Api$Business$Profile$businessDataDecoder));
var $author$project$Data$Api$Business$Profile$DOMAIN_NOT_FOUND = {$: 'DOMAIN_NOT_FOUND'};
var $author$project$Data$Api$Business$Profile$errorDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (errorCode) {
		if (errorCode === 'DOMAIN_NOT_FOUND') {
			return $elm$json$Json$Decode$succeed($author$project$Data$Api$Business$Profile$DOMAIN_NOT_FOUND);
		} else {
			return $elm$json$Json$Decode$fail('Invalid error code: ' + errorCode);
		}
	},
	$elm$json$Json$Decode$string);
var $elm$http$Http$emptyBody = _Http_emptyBody;
var $author$project$Data$Api$get = F3(
	function (url, errorDecoder, dataDecoder) {
		return $elm$http$Http$task(
			{
				body: $elm$http$Http$emptyBody,
				headers: _List_Nil,
				method: 'GET',
				resolver: $elm$http$Http$stringResolver(
					A2($author$project$Data$Api$responseResolver, errorDecoder, dataDecoder)),
				timeout: $elm$core$Maybe$Just(30000),
				url: url
			});
	});
var $author$project$Data$Domain$toString = function (_v0) {
	var domain = _v0.a;
	return domain;
};
var $author$project$Data$Api$Business$Profile$call = F2(
	function (endPoint, params) {
		return A3(
			$author$project$Data$Api$get,
			endPoint + ('/' + $author$project$Data$Domain$toString(params.domain)),
			$author$project$Data$Api$Business$Profile$errorDecoder,
			$author$project$Data$Api$Business$Profile$dataDecoder);
	});
var $author$project$Data$Api$ListTemplate$Payload = F2(
	function (templates, templateCount) {
		return {templateCount: templateCount, templates: templates};
	});
var $author$project$Data$Api$ListTemplate$Template = function (id) {
	return function (owner) {
		return function (title) {
			return function (slug) {
				return function (createdAt) {
					return function (updatedAt) {
						return function (isDocumentEncrypted) {
							return function (domain) {
								return function (filledAnnots) {
									return function (fieldAnnots) {
										return function (version) {
											return function (noOfRoles) {
												return {createdAt: createdAt, domain: domain, fieldAnnots: fieldAnnots, filledAnnots: filledAnnots, id: id, isDocumentEncrypted: isDocumentEncrypted, noOfRoles: noOfRoles, owner: owner, slug: slug, title: title, updatedAt: updatedAt, version: version};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Data$Api$ListTemplate$Owner = F5(
	function (id, firstName, lastName, email, trustScore) {
		return {email: email, firstName: firstName, id: id, lastName: lastName, trustScore: trustScore};
	});
var $author$project$Data$Api$ListTemplate$TrustScore = F6(
	function (passbase, shuftiPro, myInfo, corporate, stripe, mobilePhone) {
		return {corporate: corporate, mobilePhone: mobilePhone, myInfo: myInfo, passbase: passbase, shuftiPro: shuftiPro, stripe: stripe};
	});
var $author$project$Data$Api$ListTemplate$trustScoreDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'mobilePhone',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'stripe',
		$elm$json$Json$Decode$bool,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'corporate',
			$elm$json$Json$Decode$bool,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'myInfo',
				$elm$json$Json$Decode$bool,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'shuftiPro',
					$elm$json$Json$Decode$bool,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'passbase',
						$elm$json$Json$Decode$bool,
						$elm$json$Json$Decode$succeed($author$project$Data$Api$ListTemplate$TrustScore)))))));
var $author$project$Data$Api$ListTemplate$ownerDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'trustScore',
	$author$project$Data$Api$ListTemplate$trustScoreDecoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'email',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'lastName',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'firstName',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'id',
					$elm$json$Json$Decode$string,
					$elm$json$Json$Decode$succeed($author$project$Data$Api$ListTemplate$Owner))))));
var $author$project$Data$Api$ListTemplate$decodeTemplateList = $elm$json$Json$Decode$list(
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'noOfRoles',
		$elm$json$Json$Decode$int,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'version',
			$elm$json$Json$Decode$int,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'fieldAnnots',
				$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'filledAnnots',
					$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'domain',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'isDocumentEncrypted',
							$elm$json$Json$Decode$bool,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'updatedAt',
								A2($elm$json$Json$Decode$map, $elm$time$Time$millisToPosix, $elm$json$Json$Decode$int),
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'createdAt',
									A2($elm$json$Json$Decode$map, $elm$time$Time$millisToPosix, $elm$json$Json$Decode$int),
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'slug',
										$elm$json$Json$Decode$string,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'title',
											$elm$json$Json$Decode$string,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'owner',
												$author$project$Data$Api$ListTemplate$ownerDecoder,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'id',
													$elm$json$Json$Decode$string,
													$elm$json$Json$Decode$succeed($author$project$Data$Api$ListTemplate$Template))))))))))))));
var $author$project$Data$Api$ListTemplate$dataDecoder = A3(
	$elm$json$Json$Decode$map2,
	$author$project$Data$Api$ListTemplate$Payload,
	A2($elm$json$Json$Decode$field, 'templates', $author$project$Data$Api$ListTemplate$decodeTemplateList),
	A2($elm$json$Json$Decode$field, 'templateCount', $elm$json$Json$Decode$int));
var $author$project$Data$Domain$encode = function (_v0) {
	var domain = _v0.a;
	return $elm$json$Json$Encode$string(domain);
};
var $author$project$Data$Api$ListTemplate$errorDecoder = $elm$json$Json$Decode$succeed(_Utils_Tuple0);
var $author$project$Data$Api$ListTemplate$call = F2(
	function (endPoint, domain) {
		return A4(
			$author$project$Data$Api$httpTask,
			endPoint,
			$author$project$Data$Api$ListTemplate$errorDecoder,
			$author$project$Data$Api$ListTemplate$dataDecoder,
			$elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'domain',
						$author$project$Data$Domain$encode(domain))
					])));
	});
var $author$project$Model$BusinessProfile$init = F2(
	function (endPoint, domain) {
		return _Utils_Tuple2(
			{
				contact: '',
				description: '',
				descriptionError: $elm$core$Maybe$Nothing,
				email: '',
				emailError: $elm$core$Maybe$Nothing,
				formStatus: $author$project$Type$BusinessProfile$Ready($author$project$Type$BusinessProfile$Close),
				loadStatus: $author$project$Type$BusinessProfile$Loading,
				modal: $author$project$Type$BusinessProfile$Closed,
				name: '',
				phone: '',
				phoneError: $elm$core$Maybe$Nothing,
				plan: $author$project$Data$Api$Business$Profile$Normal,
				referralCodeSnackBarStatus: $author$project$Material$Styled$Snackbar$Hide,
				shareReferralCode: '',
				templates: _List_Nil,
				title: '',
				titleError: $elm$core$Maybe$Nothing
			},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Task$attempt,
						A2($elm$core$Basics$composeL, $author$project$Types$OnBusinessProfile, $author$project$Type$BusinessProfile$LoadProfile),
						A2(
							$author$project$Data$Api$Business$Profile$call,
							endPoint.businessProfile,
							{domain: domain})),
						A2(
						$elm$core$Task$attempt,
						A2($elm$core$Basics$composeL, $author$project$Types$OnBusinessProfile, $author$project$Type$BusinessProfile$LoadTemplate),
						A2($author$project$Data$Api$ListTemplate$call, endPoint.listTemplate, domain))
					])));
	});
var $author$project$Type$BusinessRegister$Loaded = {$: 'Loaded'};
var $author$project$Type$BusinessRegister$Ready = {$: 'Ready'};
var $author$project$Model$BusinessRegister$getReferralCodeFromRoute = function (route) {
	if (route.$ === 'Public') {
		var publicRoute = route.a;
		if (publicRoute.$ === 'BusinessRegisterRoute') {
			var refCode = publicRoute.a;
			if (refCode.$ === 'Just') {
				var string = refCode.a;
				return string;
			} else {
				return '';
			}
		} else {
			return '';
		}
	} else {
		return '';
	}
};
var $author$project$Model$BusinessRegister$init = function (route) {
	return {
		companyName: '',
		companyNameError: $elm$core$Maybe$Nothing,
		email: '',
		emailError: $elm$core$Maybe$Nothing,
		firstName: '',
		firstNameError: $elm$core$Maybe$Nothing,
		formStatus: $author$project$Type$BusinessRegister$Ready,
		hasAgreedTerms: false,
		hasAgreedTermsError: $elm$core$Maybe$Nothing,
		lastName: '',
		lastNameError: $elm$core$Maybe$Nothing,
		password: '',
		passwordAgain: '',
		passwordAgainError: $elm$core$Maybe$Nothing,
		passwordError: $elm$core$Maybe$Nothing,
		redirectError: $elm$core$Maybe$Nothing,
		referralCode: $author$project$Model$BusinessRegister$getReferralCodeFromRoute(route),
		subdomain: '',
		subdomainError: $elm$core$Maybe$Nothing,
		subdomainStatus: $elm$core$Maybe$Nothing,
		validationStatus: $author$project$Type$BusinessRegister$Loaded
	};
};
var $author$project$Type$ConfirmDeleteDocument$ConfirmDeleteDocumentResponse = function (a) {
	return {$: 'ConfirmDeleteDocumentResponse', a: a};
};
var $author$project$Type$ConfirmDeleteDocument$HasToken = function (a) {
	return {$: 'HasToken', a: a};
};
var $author$project$Type$ConfirmDeleteDocument$NoToken = {$: 'NoToken'};
var $author$project$Types$OnConfirmDeleteDocument = function (a) {
	return {$: 'OnConfirmDeleteDocument', a: a};
};
var $author$project$Type$ConfirmDeleteDocument$Submitting = {$: 'Submitting'};
var $author$project$Data$Api$ConfirmDeleteDocument$Payload = function (message) {
	return {message: message};
};
var $author$project$Data$Api$ConfirmDeleteDocument$dataDecoder = A2(
	$elm$json$Json$Decode$map,
	$author$project$Data$Api$ConfirmDeleteDocument$Payload,
	A2($elm$json$Json$Decode$field, 'message', $elm$json$Json$Decode$string));
var $author$project$Data$Api$ConfirmDeleteDocument$encode = function (_v0) {
	var token = _v0.token;
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'token',
				$elm$json$Json$Encode$string(token))
			]));
};
var $author$project$Data$Api$ConfirmDeleteDocument$INVALID_DELETION_CODE = {$: 'INVALID_DELETION_CODE'};
var $author$project$Data$Api$ConfirmDeleteDocument$INVALID_DOCUMENT = {$: 'INVALID_DOCUMENT'};
var $author$project$Data$Api$ConfirmDeleteDocument$errorDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (errorCode) {
		switch (errorCode) {
			case 'INVALID_DOCUMENT':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$ConfirmDeleteDocument$INVALID_DOCUMENT);
			case 'INVALID_DELETION_CODE':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$ConfirmDeleteDocument$INVALID_DELETION_CODE);
			default:
				return $elm$json$Json$Decode$fail('Invalid error code: ' + errorCode);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Data$Api$ConfirmDeleteDocument$call = F2(
	function (endPoint, params) {
		return A4(
			$author$project$Data$Api$httpTask,
			endPoint,
			$author$project$Data$Api$ConfirmDeleteDocument$errorDecoder,
			$author$project$Data$Api$ConfirmDeleteDocument$dataDecoder,
			$author$project$Data$Api$ConfirmDeleteDocument$encode(params));
	});
var $author$project$Model$ConfirmDeleteDocument$init = F2(
	function (_v0, maybeToken) {
		var confirmDeleteDocument = _v0.confirmDeleteDocument;
		if (maybeToken.$ === 'Just') {
			var token = maybeToken.a;
			return _Utils_Tuple2(
				$author$project$Type$ConfirmDeleteDocument$HasToken($author$project$Type$ConfirmDeleteDocument$Submitting),
				A2(
					$elm$core$Task$attempt,
					A2($elm$core$Basics$composeL, $author$project$Types$OnConfirmDeleteDocument, $author$project$Type$ConfirmDeleteDocument$ConfirmDeleteDocumentResponse),
					A2(
						$author$project$Data$Api$ConfirmDeleteDocument$call,
						confirmDeleteDocument,
						{token: token})));
		} else {
			return _Utils_Tuple2($author$project$Type$ConfirmDeleteDocument$NoToken, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Type$ConfirmDeleteTemplate$ConfirmDeleteTemplateResponse = function (a) {
	return {$: 'ConfirmDeleteTemplateResponse', a: a};
};
var $author$project$Type$ConfirmDeleteTemplate$HasToken = function (a) {
	return {$: 'HasToken', a: a};
};
var $author$project$Type$ConfirmDeleteTemplate$NoToken = {$: 'NoToken'};
var $author$project$Types$OnConfirmDeleteTemplate = function (a) {
	return {$: 'OnConfirmDeleteTemplate', a: a};
};
var $author$project$Type$ConfirmDeleteTemplate$Submitting = {$: 'Submitting'};
var $author$project$Data$Api$ConfirmDeleteTemplate$Payload = function (message) {
	return {message: message};
};
var $author$project$Data$Api$ConfirmDeleteTemplate$dataDecoder = A2(
	$elm$json$Json$Decode$map,
	$author$project$Data$Api$ConfirmDeleteTemplate$Payload,
	A2($elm$json$Json$Decode$field, 'message', $elm$json$Json$Decode$string));
var $author$project$Data$Api$ConfirmDeleteTemplate$encode = function (_v0) {
	var token = _v0.token;
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'token',
				$elm$json$Json$Encode$string(token))
			]));
};
var $author$project$Data$Api$ConfirmDeleteTemplate$INVALID_DELETION_CODE = {$: 'INVALID_DELETION_CODE'};
var $author$project$Data$Api$ConfirmDeleteTemplate$INVALID_TEMPLATE = {$: 'INVALID_TEMPLATE'};
var $author$project$Data$Api$ConfirmDeleteTemplate$errorDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (errorCode) {
		switch (errorCode) {
			case 'INVALID_TEMPLATE':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$ConfirmDeleteTemplate$INVALID_TEMPLATE);
			case 'INVALID_DELETION_CODE':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$ConfirmDeleteTemplate$INVALID_DELETION_CODE);
			default:
				return $elm$json$Json$Decode$fail('Invalid error code: ' + errorCode);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Data$Api$ConfirmDeleteTemplate$call = F2(
	function (endPoint, params) {
		return A4(
			$author$project$Data$Api$httpTask,
			endPoint,
			$author$project$Data$Api$ConfirmDeleteTemplate$errorDecoder,
			$author$project$Data$Api$ConfirmDeleteTemplate$dataDecoder,
			$author$project$Data$Api$ConfirmDeleteTemplate$encode(params));
	});
var $author$project$Model$ConfirmDeleteTemplate$init = F2(
	function (_v0, maybeToken) {
		var confirmDeleteTemplate = _v0.confirmDeleteTemplate;
		if (maybeToken.$ === 'Just') {
			var token = maybeToken.a;
			return _Utils_Tuple2(
				$author$project$Type$ConfirmDeleteTemplate$HasToken($author$project$Type$ConfirmDeleteTemplate$Submitting),
				A2(
					$elm$core$Task$attempt,
					A2($elm$core$Basics$composeL, $author$project$Types$OnConfirmDeleteTemplate, $author$project$Type$ConfirmDeleteTemplate$ConfirmDeleteTemplateResponse),
					A2(
						$author$project$Data$Api$ConfirmDeleteTemplate$call,
						confirmDeleteTemplate,
						{token: token})));
		} else {
			return _Utils_Tuple2($author$project$Type$ConfirmDeleteTemplate$NoToken, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Type$FillTemplate$NotLoaded = {$: 'NotLoaded'};
var $author$project$Model$FillTemplate$init = $author$project$Type$FillTemplate$NotLoaded;
var $author$project$Model$LanguageSwitch$init = function () {
	var englishLanguageData = {
		location: {
			accountSettingsPage: {accountSettings: 'Account Settings', addABusinessPlan: 'Bedrijfsplan toevoegen', addOrganisationUser: 'Add Organisation users', address: 'Address', apiKeysHeader: 'API Keys', businessAccount: 'Business Account', businessPlan: 'Business Plan', cancelAnytime: 'Cancel anytime', changePassword: 'Change Password', changePicture: 'Change Picture', confirmPassword: 'Confirm Password', currentChosenNetwork: 'Current chosen network', currentPassword: 'Current Password', currentPaymentMethod: 'Current payment Method', dateOfBirth: 'Date Of Birth', documentNotarisationNetwork: 'Document Notarisation network', emailAddress: 'Email Address', firstName: 'First Name', lastName: 'Last Name', month: 'month', myAccount: 'My Account', myPersonalStamps: 'My Personal Stamps', nationality: 'nationality', newPassword: 'New Password', notariseByDefault: 'Notarise documents by default', notariseByDefaultTooltipText: 'Documents will be notarise upon completion, this applies for algorand network and payment through system balance.', paymentMethod: 'Payment Method', personalAccount: 'Personal Account', personalApiKey: 'Personal API Key', phoneNumber: 'Phone Number', referralCode: 'Referral Code', saveChanges: 'Save Changes', sendPDFforms: 'Send PDF Forms', sendUnlimtedDocs: 'end unlimited documents', signSecurely: 'Sign securely with anyone', signatures: 'Signatures', stampsTooltipText: 'Please upload an image file in .jpg, .jpeg, .png, .svg or .gif format, up to maximum size of 3MB. You may select only 1 stamp for each document.', trialDays: '45 days trial'},
			addressBookPage: {addFriend: 'Add Friend', addNewContact: 'Add New Contact', addressBook: 'Address Book', allContacts: 'All Contacts', cancelBtn: 'Cancel', contactEmailFieldLabel: 'Please enter contact email', deleteContact: 'Delete Contact', deleteContactConfirmation: 'Do you want to delete this contact?', pendingRequest: 'Pending Request', rowsPerPage: 'Rows Per Page', saveAlias: 'Save new alias', sendRequestBtnText: 'Send Request'},
			businessRegister: {agreeToTerms: 'I agree to the terms of service and privacy policy published here.', agreementProcess: 'the agreement process', anytimeAnyehere: 'anytime, anywhere', closeDeals: 'Close deals', companyName: 'Company Name', confirmPassword: 'Confirm Password', customDomainText: 'Custom Domain for your Organisation', customerExperience: 'your customer experience', documentWorkflow: 'Document Workflow Templates Automate ', effcientSecureWorkflow: 'Efficient and secure workflows', emailAddress: 'Email Address', enhance: 'Enhance', firstName: 'First Name', granularPermission: 'Granular permissions for documents', lastName: 'Last Name', modernise: 'Modernise', organisationManagement: 'Organisation Management', organisationRepo: 'Organisation Document Repository', password: 'Password', passwordRequirements: 'Password must contain at least 8 characters, a lowercase letter, an uppercase letter and a number', referralCode: 'Referral Code(Optional)', returnToLogin: 'Return to Login', signUp: 'Sign up', signingRequest: 'Signing Requests through PDF Forms', subdomain: 'Subdomain', suiteOfFeatures: 'A Comprehensive Suite of Features to Automate your Workflow Processes', userPermission: 'User Permissions and Corporate Representation'},
			createTemplatePage: {addFields: 'Step 3: Add Fields', addNewRole: 'Step 2: Add New Role', addRole: 'Add Role', addToDocument: 'Add to Document', assignRecipientToRole: 'Assign Recipient to Role', assignRecipientToRoleTooltipText: 'A recipient assigned to a role here will be added to all documents that are created from this template.', assignRecipientToViewer: 'Assign a viewer to template', assignRecipientToViewerTooltipText: 'A viewer will be added to all documents that are created from this template.', checkboxField: 'Checkbox', createButtonText: 'Create', dateSigned: 'Date of Signing', editableText: 'Text', emailField: 'Email', nameField: 'Name', newRole: 'New Role', nextStep: 'NEXT STEP', optionalSettings: 'optional Settings', referToTerms: 'refer to the terms of use', sharingUrlText: 'Allow sharing of single-signer document with URL', signOrder: 'Signing Order', signatureField: 'Signature', stampField: 'Stamp', submit: 'Submit', templateTitle: 'Step 1: Template Title', templateUploadSuccess: 'Your template has been uploaded successfully', title: 'Title', uploadTemplate: 'Upload Template', uploadTemplateText: '*Do note that our Service should only be used for certain categories of documents. For more information, refer to the terms of use'},
			dashboard: {completedDocuments: 'Completed Documents', date: 'Date', document: 'Document', incomingDocuments: 'Incoming documents', outgoingDocuments: 'Outgoing documents', pendingDocuments: 'PENDING DOCUMENTS', recipient: 'Recipient', sender: 'Sender', sentDocuments: 'SENT DOCUMENTS', submission: 'Submission', systemRewardsPoints: 'SIGN.NET REWARD POINT(S)', template: 'Template', uploadDocsDescription: 'Now you can upload multiple documents in PDF, DOCx, PPTx, XLSx files up to 25MB in size.', uploadDocsStep1: 'STEP 1: DRAG & DROP', uploadDocsStep1Part2: 'or browse through your computer', uploadDocsTitle: 'UPLOAD DOCUMENTS', verification: 'VERIFICATION', viewAll: 'VIEW ALL'},
			fillTemplatePage: {additionalMessage: 'Add a Message', algorandNetwork: 'Algorand Network', binanceNetwork: 'Binance Network', dueDate: 'Due Date', next: 'Next', notariseDocument: 'Notarise Document', notariseTooltipText1: 'This action costs', notariseTooltipText2: 'SIGN points. You have', notariseTooltipText3: 'SIGN points available. Toggle between the 2 networks in the account settings page. Find out more', optionalSettings: 'optional Settings', owner: 'Owner', passcode: 'Signing Request Passcode', passcodeTooltipText: 'Add another verification layer to your document with a Passcode. You will need to send this Passcode to your recipients via a separate device. Recipients will only be able to access this document with the Passcode.', proceedToSend: 'Proceed To Send', sendButtonText: 'Send', sendTemplateTermsOfUse: 'Do note that our Service should only be used for certain categories of documents. For more information, refer to the terms of use', sender: 'Sender', signOrder: 'Signing Order', step2: 'Step 2 =  Add Recipients'},
			listDocumentsPage: {dateCompleted: 'Date Completed', dateSent: 'Date Sent', page: 'Page', searchDocument: 'Search Document', sender: 'Sender', signers: 'Signers', viewers: 'Viewers'},
			login: {accountSignUp: 'Account Sign Up', emailAddress: 'Email Address', emailError: 'Email is invalid', incorrectPassword: 'Incorrect email or password. Click Forgot Password to reset your password or Sign up for an Account.', password: 'Password', resetPassword: 'Reset Password', signIn: 'Sign In'},
			menuItem: {addressBook: 'Address Book', contactUs: 'Contact Us', dashboard: 'Dashboard', documents: 'Documents', faq: 'FAQ', gettingStarted: 'Getting Started', myAccount: 'My Account', myOrganisation: 'My Organisation', newDocuments: 'New Documents', newTemplate: 'New Template', signNetRewardsPoints: 'Sign.net Reward Points', trustScore: 'Trust Score', viewNotarisedInformation: 'View Notarised Information'},
			myOrganisationPage: {bannerBackground: 'Banner Background', bannerLogo: 'Banner Logo', businessProfile: 'Business Profile', companyDescription: 'Company Description', companyName: 'Company Name', companySlogan: 'Company Slogan', customizeLandingPage: 'Customise Landing Page', _delete: 'delete', headerBackgroundColour: 'Header Background Color', headerBackgroundDescription: 'The color of the top header', headerLogo: 'Header Logo', lessThan300KB: 'Must be less than 300KB', lessThan500KB: 'Must be less than 500KB', manageUsers: 'Manage Users', organisationReferralCode: 'Organisation Referral Code', organisationStamps: 'Organisation Stamps', shareLinkBusinessAccount: 'Share Link to sign up for Business account', shareLinkPersonalAccount: 'Share Link to sign up for Personal account', update: 'Update'},
			personalRegisterPage: {activateAccount: 'Activate Account', agreeToTerms: 'I agree to the terms of service and privacy policy published here.', confirmPassword: 'Confirm Password', createFreeAccount: 'Create Free Personal Account', digitalSigning: 'Digital Signing', easySafeAndFree: 'Easy, Safe & Free for Everyone', emailActivateText: 'Your sign up is not yet complete until you click on the email activation link sent to your registered email at .', emailActivateText2: 'If you still do not receive an email from us within the next two minutes, please check the spam, junk, or promotion sections of your email.', emailAddress: 'Email Address', firstName: 'First Name', freeTrialText: 'Try it out with a 45-Day Free Trial', haveAnAccount: 'Have an Account?', identityVerification: 'Identity Verification capabilities', lastName: 'Last Name', needHelp: 'If you face further issues, please drop us an email at', needHelp2: 'and we will get in touch with you.', notariseDocs: 'Notarise documents [blockchain powered]', password: 'Password', passwordRequirements: 'Password must contain at least 8 characters, a lowercase letter, an uppercase letter and a number', referralCode: 'Referral Code(Optional)', returnToLogin: 'Return to Login', sendUnlimtedDocs: 'Send and receive unlimited documents', signUp: 'Sign up', suiteOfFeatures: 'A Comprehensive Suite of Features to automate your workflows at scale.', supportFormats: 'Support for leading document formats', thankYouMsg: 'Thank you for creating an account with Sign.net.', useForBusiness: 'Using Sign.net for Your Business?'},
			pointsManagement: {addOrganisationUser: 'Add Organisation User', amazonGiftCard: '$50 Amazon Gift Card', amount: 'Amount', available: 'Available', completedStatus: 'Completed', currentNetwork: 'Current Network', currentPaymentMethod: 'Current payment method', externalWallet: 'External Wallet', externalWalletTooltipText: 'Link an external Metamask wallet to your Sign.net account so that points can be withdrawn. Find out more', findOutMore: 'Find out more.', from: 'From', headerDescription: 'With your Sign.net reward points you can redeem for Sign.net subscription and add-ons, send them to your friends or transfer them out onto your personal external wallet. Find out more', headerText: 'Get rewarded simply by using Sign.net', inText: 'In', out: 'Out', pendingStatus: 'Pending', pointsManagement: 'Points Management', recipientEmail: 'Recipient Email', redeemForServices: 'Redeem for Services', redeemServicesTooltipText: 'Redemption Vouchers are available for users in certain countries, depending on local KYC regulations.', remarks: 'Remarks (optional)', safepalWallet: 'SafePal S1 Hardware Wallet', sendButton: 'Send', sendPoints: 'Send Points', status: 'Status', systemBalance: 'System Balance', systemBalanceTooltipText: 'These are your Sign.net reward points on the Sign.net platform. Available tokens are immediately available for use while Pending tokens require a bit more time to be processed. Find out more', time: 'Time', to: 'To', togglePaymentNotarisationMethods: 'Toggle Notarisation Network & Payment Method', transactionHistory: 'Transaction History (Last 5 Transactions)', transactionHistoryHeader: 'Transaction History', viewAllButton: 'View All', viewAllRewards: 'View All Rewards'},
			resetPasswordPage: {backToLogin: 'Back to Login', backToLoginPage: 'Back to Login Page', emailAddress: 'Email Address', emailExistsText: 'If an account exists that matches the email ', emailExistsText2: 'an email with instructions to activate the account will be sent to that account. Please ensure you keyed in the right email address.', emailExistsText3: 'If you still do not receive an email from us within the next five minutes, please also check your email spam folder and drop us an email at help@sign.net', emailSent: 'Email Sent', resetPassword: 'Reset Password', resetPasswordInstructions: 'In order to trigger a password reset request, please provide us with the email account you used when signing up. A password reset email will then be sent with further instructions. '},
			signupPage: {addOrganisationUser: 'Add Organisation users', businessPlan: 'Business Plan', cancelAnytime: 'Cancel anytime', forBusiness: 'For Business', forEveryone: 'For everyone', month: 'month', personalPlan: 'Personal Plan', sendPDFforms: 'Send PDF Forms', sendUnlimtedDocs: 'Send unlimited documents', signSecurely: 'Sign securely with anyone', signUp: 'Sign up', trialDays: '45 days trial'},
			templateDashboard: {createdBy: 'Created By', lastEdited: 'Last Edited', selectTemplate: 'Select a Template', selectTemplateDescription: 'Select a template below to send as document', selectTemplateFromDashboard: 'Click to select a template', sendFromTemplate: 'Send From Template', sendFromTemplateDescription: 'Send out documents for signing from organisation', templateName: 'Template Name'},
			transactionDetailsPage: {approved: 'Approved', by: 'By', created: 'Created', ipAddress: 'IP Address', remarks: 'Remarks', returnToPointsActivities: 'Return To Points Activities', transactionDetails: 'Transaction Details', transactionId: 'Transaction Id'},
			updateUploadDocErrors: {fileSizeExceeded: 'Size of file cannot exceed 25MB.', invalidData: 'Invalid data provided. Please refresh and try again.', invalidPDFformat: 'Invalid PDF. Please upload a valid PDF file instead.', notAnnotationFound: 'No annotation found for the document.', notInSigningOrder: 'Unable to update the annotations,there are signers that are before your signing order have yet to sign.', notPermission: 'You do not have the permission to update the document annotations.', passcodeRequirements: 'Passcode entered can only be of 4 to 8 numeric characters.', passwordProvidedError: 'Password provided is incorrect.', pdfDocOnly: 'PDF document only (for sending).', pdfNotEditable: 'PDF is not editable.', unableToAppend: 'Unable to append annotation(s) to the file.', unableToUpdate: ' Unable to update the annotations.'},
			uploadDocument: {add: 'Add', addNewRecipient: 'Add New Recipient', addToDocument: 'Add to Document', additionalMessage: 'Add a Message', algorandNetwork: 'Algorand Network', backToDashboard: 'Back to Dashboard', binanceNetwork: 'Binance Network', checkboxField: 'Checkbox', clear: 'clear', confirm: 'Confirm', dateSigned: 'Date Signed', doNotSaveDocument: 'Do Not Save Document', documentsUploaded: 'Documents Uploaded', dueDate: 'Due Date', editableText: 'Editable Text', email: 'Email', emailField: 'Email', emptyName: 'Name cannot be empty', faqText: 'Recipients will not be able to change the text inputs upon receiving the document. For more information, refer to the frequently asked questions', firstName: 'First Name', invalidEmail: 'Email is invalid', lastName: 'Last Name', nameField: 'Name', nextDocument: 'Next Document', nextStep: 'NEXT STEP', nonEditableText: 'Non Editable Text', notariseDocument: 'Notarise Document', notariseTooltipText1: 'This action costs', notariseTooltipText2: 'SIGN points. You have', notariseTooltipText3: 'SIGN points available. Toggle between the 2 networks in the account settings page. Find out more', onlySigner: 'I AM THE ONLY SIGNER', optionalSettings: 'optional Settings', owner: 'Owner', passcode: 'Signing Request Passcode', passcodeTooltipText: 'Add another verification layer to your document with a Passcode. You will need to send this Passcode to your recipients via a separate device. Recipients will only be able to access this document with the Passcode.', previousDocument: 'Previous Document', proceed: 'proceed', searchAddressBook: 'Search Address Book', sendButtonText: 'Send', sendDocument: 'Send Document', sender: 'Sender', sendingYourDocs: 'Sending your document', signOrder: 'Signing Order', signatureField: 'Signature', signatures: 'Signatures', signer: 'Signer', stampField: 'Stamp', stampTooltipText: 'Please upload an image file in .jpg, .jpeg, .png, .svg or .gif format, up to maximum size of 3MB. You may select only 1 stamp for each document.', stamps: 'Stamps', step1: 'Step 1:', step2: 'Step 2: Add Recipients', step3: 'Step 3: Add Fields', success: 'Success', successText: 'Your document has been sent out successfully.', termsOfUse: 'Do note that our Service should only be used for certain categories of documents. For more information, refer to the terms of use', viewer: 'Viewer'},
			uploadTemplatePage: {available: 'Available', createNewTemplate: 'Create New Template', createTemplateDescription: 'Templates are accessible by all users under your organisation. Users will be able to send out documents to Recipients from this template.', newTemplate: 'New Template', numberOfTemplates: 'Number of templates available in your organisation', used: 'Used'},
			verificationPage: {acknowledgementText: 'I understand and am ready to proceed', comingSoon: 'Coming Soon', creditCard: 'Credit Card', creditCardDescriptionText: 'Having your credit card details verified is part of your overall identity verification, and increases your trust score as it provides a basic level of certification that you have good financial standing to be extended credit by a financial institution.', creditCardVerificationText: 'Verifying your credit card with us involves keying in a valid card so that we can authenticate it against our payment processor. Nothing will be charged to your card during this process.', goToAccount: 'Go to Account', governmentId: 'Government ID', governmentIdDescriptionText: 'We will redirect you to the Passbase verification portal, which will involve completing a liveness check in addition to taking a picture of your official government issued document. The system will automatically process your request and in most situations provide an immediate approval. We will also require access to a camera in order to take pictures of the government ID you are providing for the validation process.', governmentIdDescriptionText2: 'Only one concurrent government ID verification attempt is allowed per person. If you need help restarting the process, please reach out to help@sign.net or contact us here so we can reset it’s status.', governmentIdVerificationText: 'Verify your identity using a variety of official government issued documents such as passport, driver\'s license & identity card. Verification requests are directly handled by Passbase using their secure and GDPR compliant systems.', mobilePhone: 'Mobile Phone', mobilePhoneDescriptionText: 'Ensure you have your mobile phone with you before you click verify. You wil receive an SMS to your registered mobile phone number which you will be asked to input to determine that the mobile number is yours.', mobilePhoneVerificationText: 'Mobile phone verification allows you to validate your phone number in our systems. We will send a unique number to your number listed in the user profile records in order to validate it.', notVerified: 'NOT VERIFIED', redirectToPointManagementPage: 'Redirect to points management page', verificationMethods: 'verification Methods', verified: 'VERIFIED', verify: 'verify', wallet: 'Wallet', walletDescription: 'You can verify your wallet on the Sign.net rewards points page through Metamask. Click the button below to be redirected to the rewards points page'},
			viewDocumentPage: {action: 'Action', activities: 'Activities', awaitingSignature: 'Awaiting Signature', backToDocuments: 'Back To Documents', certificateOfCompletion: 'Certificate Of Completion', confirm: 'Confirm', deleteDocument: 'Delete Document', deleteDocumentText: 'Do you want to delete this document?', documentChecksum: 'Document Checksum', documentCompleted: 'Document Completed', documentId: 'Document ID', documentInformation: 'Document Information', documentSummaryEvents: 'Document Summary Events', documentTitle: 'Document Title', downloadCertificate: 'Download Certificate', downloadCompletedDocument: 'Download Completed Document', downloadDocument: 'Download Document', downloadDocumentText: 'You are downloading a partially completed document that is pending signatures from recipients.', downloadDocumentText2: 'The recipients will still be able to sign and complete this document on Sign.net.', downloadPartiallyCompletedDocument: 'Download Partially Completed Document', downloadVerifiableCredentials: 'Download Verifiable Credential', expired: 'Expired', helpDesk: 'HelpDesk', notVerifiedWith: 'Not verified with', notarisationCost: 'This action costs ', notarisationCost2: ' SIGN points, are you sure you want to notarise this document?', notarisationStatus: 'Notarisation Status', notariseDocument: 'Notarise Document', pendingSignature: 'Pending Your Signature', proceed: 'Proceed', recipients: 'Recipients', resendEmailNotification: 'Resend Email Notification', role: 'Role', sentReminder: 'Sent Reminder', sign: 'Sign', signatureAndStamps: 'Your Signature and Stamps', signatureTimeStamping: 'Signature Time Stamping (Algorand network)', signerDetails: 'Signer Details', status: 'Status', submit: 'Submit', templateId: 'Template ID', time: 'Time', timeOfNotarisation: 'Time Of Notarisation', timeStamp: 'Time Stamp', verifiedWith: 'Verified with', view: 'View', viewCertificate: 'View Certificate', viewSigningEvents: 'View Signing Events', yourSignatures: 'Your Signatures', yourStamps: 'Your Stamps'},
			viewNotarisedInformation: {browseYourPC: 'or browse through your computer', checksum: 'checksum', docNotarisationDetails: 'Document Notarisation Details', dragAndDrop: 'DRAG & DROP', pleaseUploadFile: 'Please upload your completed signed PDF to begin.', timeOfNotarisation: 'Time of Notarisation', transactionId: 'Transaction Id', verificationDone: 'Verification Done', viewNotarisedDocumentInformation: 'View Notarised Document Information', viewNotarisedInfoText: 'View your notarised document information here by dropping in your completed PDF file that has been notarised with Algorand Blockchain.'},
			viewTemplatePage: {back: 'Back', backToDashboard: 'Back to Dashboard', close: 'Close', confirm: 'Confirm', createDocumentFromTemplate: 'Create document from template', createdBy: 'Created By', dateCreated: 'Date Created', deleteTemplate: 'Delete template', downloadTemplateReport: 'Download template report', fillTemplateRequest: 'Fill Template Request', fillTemplateRequestText: 'This template is a single role template, please confirm if you are requesting to fill this template.', lastEdited: 'Last Edited', lastViewed: 'Last Viewed', nameOfTemplate: 'Name of Template', noOfDocumentsGeneratedFromTemplate: 'No of documents generated from this template', requestToFillTemplate: 'Request to fill template', templateUrl: 'Template URL', version: 'Version', viewTemplateActivity: 'View template Activity'}
		}
	};
	return {allLanguageData: englishLanguageData};
}();
var $author$project$Type$Login$Ready = {$: 'Ready'};
var $author$project$Model$Login$init = {email: '', emailError: $elm$core$Maybe$Nothing, formStatus: $author$project$Type$Login$Ready, password: '', passwordError: $elm$core$Maybe$Nothing, redirect: $elm$core$Maybe$Nothing};
var $author$project$Type$NewfoldRegister$Loaded = {$: 'Loaded'};
var $author$project$Type$NewfoldRegister$Ready = {$: 'Ready'};
var $author$project$Model$NewfoldRegister$getPlanFromReferralCode = F2(
	function (plan, ref) {
		var getPlan = function (planString) {
			switch (planString) {
				case 'small':
					return 'thankscrazydomains-Small';
				case 'medium':
					return 'thankscrazydomains-Medium';
				case 'large':
					return 'thankscrazydomains-Large';
				default:
					return '';
			}
		};
		if (ref.$ === 'Just') {
			var refCode = ref.a;
			return refCode;
		} else {
			if (plan.$ === 'Just') {
				var planType = plan.a;
				return getPlan(planType);
			} else {
				return '';
			}
		}
	});
var $author$project$Model$NewfoldRegister$getReferralCodeFromRoute = function (route) {
	if (route.$ === 'Public') {
		var publicRoute = route.a;
		if (publicRoute.$ === 'NewfoldRegisterRoute') {
			var plan = publicRoute.a;
			var ref = publicRoute.b;
			return A2($author$project$Model$NewfoldRegister$getPlanFromReferralCode, plan, ref);
		} else {
			return '';
		}
	} else {
		return '';
	}
};
var $author$project$Model$NewfoldRegister$init = function (route) {
	return {
		companyName: '',
		companyNameError: $elm$core$Maybe$Nothing,
		email: '',
		emailError: $elm$core$Maybe$Nothing,
		firstName: '',
		firstNameError: $elm$core$Maybe$Nothing,
		formStatus: $author$project$Type$NewfoldRegister$Ready,
		hasAgreedTerms: false,
		hasAgreedTermsError: $elm$core$Maybe$Nothing,
		lastName: '',
		lastNameError: $elm$core$Maybe$Nothing,
		password: '',
		passwordAgain: '',
		passwordAgainError: $elm$core$Maybe$Nothing,
		passwordError: $elm$core$Maybe$Nothing,
		redirectError: $elm$core$Maybe$Nothing,
		referralCode: $author$project$Model$NewfoldRegister$getReferralCodeFromRoute(route),
		subdomain: '',
		subdomainError: $elm$core$Maybe$Nothing,
		subdomainStatus: $elm$core$Maybe$Nothing,
		validationStatus: $author$project$Type$NewfoldRegister$Loaded
	};
};
var $author$project$Type$PersonalRegister$NotQueryParam = function (a) {
	return {$: 'NotQueryParam', a: a};
};
var $author$project$Type$PersonalRegister$Ready = {$: 'Ready'};
var $author$project$Model$PersonalRegister$init = {
	email: $author$project$Type$PersonalRegister$NotQueryParam(''),
	emailError: $elm$core$Maybe$Nothing,
	firstName: '',
	firstNameError: $elm$core$Maybe$Nothing,
	formStatus: $author$project$Type$PersonalRegister$Ready,
	hasAgreedTerms: false,
	hasAgreedTermsError: $elm$core$Maybe$Nothing,
	lastName: '',
	lastNameError: $elm$core$Maybe$Nothing,
	password: '',
	passwordAgain: '',
	passwordAgainError: $elm$core$Maybe$Nothing,
	passwordError: $elm$core$Maybe$Nothing,
	redirect: $elm$core$Maybe$Nothing,
	referralCode: $author$project$Type$PersonalRegister$NotQueryParam('')
};
var $author$project$Type$PointWithdrawalConfirm$Loading = {$: 'Loading'};
var $author$project$Type$PointWithdrawalConfirm$OnConfirmationResponse = function (a) {
	return {$: 'OnConfirmationResponse', a: a};
};
var $author$project$Types$OnPointWithdrawalConfirmation = function (a) {
	return {$: 'OnPointWithdrawalConfirmation', a: a};
};
var $author$project$Data$Api$ApiError = function (a) {
	return {$: 'ApiError', a: a};
};
var $author$project$Data$Api$JWTError = function (a) {
	return {$: 'JWTError', a: a};
};
var $author$project$Data$Api$INACTIVE_TOKEN = {$: 'INACTIVE_TOKEN'};
var $author$project$Data$Api$INVALID_SESSION = {$: 'INVALID_SESSION'};
var $author$project$Data$Api$JSON_WEB_TOKEN_ERROR = {$: 'JSON_WEB_TOKEN_ERROR'};
var $author$project$Data$Api$TOKEN_EXPIRED = {$: 'TOKEN_EXPIRED'};
var $author$project$Data$Api$UNEXPECTED_ERROR = {$: 'UNEXPECTED_ERROR'};
var $author$project$Data$Api$jwtErrorDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (errorCode) {
		switch (errorCode) {
			case 'TOKEN_EXPIRED':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$TOKEN_EXPIRED);
			case 'JSON_WEB_TOKEN_ERROR':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$JSON_WEB_TOKEN_ERROR);
			case 'INACTIVE_TOKEN':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$INACTIVE_TOKEN);
			case 'UNEXPECTED_ERROR':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$UNEXPECTED_ERROR);
			case 'INVALID_SESSION':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$INVALID_SESSION);
			default:
				return $elm$json$Json$Decode$fail('Invalid error code: ' + errorCode);
		}
	},
	A2(
		$elm$json$Json$Decode$at,
		_List_fromArray(
			['error', 'code']),
		$elm$json$Json$Decode$string));
var $elm$core$Result$mapError = F2(
	function (f, result) {
		if (result.$ === 'Ok') {
			var v = result.a;
			return $elm$core$Result$Ok(v);
		} else {
			var e = result.a;
			return $elm$core$Result$Err(
				f(e));
		}
	});
var $author$project$Data$Api$authResponseResolver = F3(
	function (errorDecoder, dataDecoder, response) {
		var resolveDefault = function (response_) {
			return A2(
				$elm$core$Result$mapError,
				$author$project$Data$Api$ApiError,
				A3($author$project$Data$Api$responseResolver, errorDecoder, dataDecoder, response_));
		};
		if (response.$ === 'BadStatus_') {
			var metadata = response.a;
			var body = response.b;
			if (metadata.statusCode === 400) {
				var _v1 = A2($elm$json$Json$Decode$decodeString, $author$project$Data$Api$jwtErrorDecoder, body);
				if (_v1.$ === 'Ok') {
					var tokenError = _v1.a;
					return $elm$core$Result$Err(
						$author$project$Data$Api$JWTError(tokenError));
				} else {
					return resolveDefault(response);
				}
			} else {
				return resolveDefault(response);
			}
		} else {
			return resolveDefault(response);
		}
	});
var $elm$http$Http$Header = F2(
	function (a, b) {
		return {$: 'Header', a: a, b: b};
	});
var $elm$http$Http$header = $elm$http$Http$Header;
var $author$project$Data$Api$authCall = F5(
	function (jwt, url, errorDecoder, dataDecoder, jsonBody) {
		return $elm$http$Http$task(
			{
				body: $elm$http$Http$jsonBody(jsonBody),
				headers: _List_fromArray(
					[
						A2($elm$http$Http$header, 'Authorization', 'Bearer ' + jwt)
					]),
				method: 'POST',
				resolver: $elm$http$Http$stringResolver(
					A2($author$project$Data$Api$authResponseResolver, errorDecoder, dataDecoder)),
				timeout: $elm$core$Maybe$Just(30000),
				url: url
			});
	});
var $author$project$Data$Api$Points$PointWithdrawalConfirmation$Payload = function (message) {
	return {message: message};
};
var $author$project$Data$Api$Points$PointWithdrawalConfirmation$dataDecoder = A2(
	$elm$json$Json$Decode$map,
	$author$project$Data$Api$Points$PointWithdrawalConfirmation$Payload,
	A2($elm$json$Json$Decode$field, 'message', $elm$json$Json$Decode$string));
var $author$project$Data$Api$Points$PointWithdrawalConfirmation$INSUFFICIENT_BALANCE = {$: 'INSUFFICIENT_BALANCE'};
var $author$project$Data$Api$Points$PointWithdrawalConfirmation$INVALID_TRANSACTION = {$: 'INVALID_TRANSACTION'};
var $author$project$Data$Api$Points$PointWithdrawalConfirmation$INVALID_USER = {$: 'INVALID_USER'};
var $author$project$Data$Api$Points$PointWithdrawalConfirmation$errorDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (errorCode) {
		switch (errorCode) {
			case 'INVALID_USER':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$Points$PointWithdrawalConfirmation$INVALID_USER);
			case 'INSUFFICIENT_BALANCE':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$Points$PointWithdrawalConfirmation$INSUFFICIENT_BALANCE);
			case 'INVALID_TRANSACTION':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$Points$PointWithdrawalConfirmation$INVALID_TRANSACTION);
			default:
				return $elm$json$Json$Decode$fail('Invalid error code: ' + errorCode);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Data$Api$Points$PointWithdrawalConfirmation$authCall = F2(
	function (jwt, endPoint) {
		return A5(
			$author$project$Data$Api$authCall,
			jwt,
			endPoint,
			$author$project$Data$Api$Points$PointWithdrawalConfirmation$errorDecoder,
			$author$project$Data$Api$Points$PointWithdrawalConfirmation$dataDecoder,
			$elm$json$Json$Encode$object(_List_Nil));
	});
var $author$project$Model$PointWithdrawalConfirm$init = F2(
	function (apiEndPoint, token) {
		return _Utils_Tuple2(
			{error: $elm$core$Maybe$Nothing, status: $author$project$Type$PointWithdrawalConfirm$Loading},
			A2(
				$elm$core$Task$attempt,
				A2($elm$core$Basics$composeL, $author$project$Types$OnPointWithdrawalConfirmation, $author$project$Type$PointWithdrawalConfirm$OnConfirmationResponse),
				A2($author$project$Data$Api$Points$PointWithdrawalConfirmation$authCall, token, apiEndPoint.pointsWithdrawConfirmation)));
	});
var $author$project$Type$ResendActivation$Ready = {$: 'Ready'};
var $author$project$Model$ResendActivation$init = {email: '', emailError: $elm$core$Maybe$Nothing, formStatus: $author$project$Type$ResendActivation$Ready};
var $author$project$Type$ResetPassword$Ready = {$: 'Ready'};
var $author$project$Model$ResetPassword$init = {email: '', emailError: $elm$core$Maybe$Nothing, formStatus: $author$project$Type$ResetPassword$Ready};
var $author$project$Type$SetPassword$Ready = {$: 'Ready'};
var $author$project$Model$SetPassword$init = {formStatus: $author$project$Type$SetPassword$Ready, password: '', passwordAgain: '', passwordAgainError: $elm$core$Maybe$Nothing, passwordError: $elm$core$Maybe$Nothing};
var $author$project$Type$Theme$Loading = {$: 'Loading'};
var $author$project$Type$Theme$LoadTheme = function (a) {
	return {$: 'LoadTheme', a: a};
};
var $author$project$Types$OnTheme = function (a) {
	return {$: 'OnTheme', a: a};
};
var $author$project$Type$Theme$OnThemeResult = function (a) {
	return {$: 'OnThemeResult', a: a};
};
var $author$project$Data$BusinessTheme$BusinessTheme = F4(
	function (logo, appBarBackgroundColor, bannerLogo, bannerBackground) {
		return {appBarBackgroundColor: appBarBackgroundColor, bannerBackground: bannerBackground, bannerLogo: bannerLogo, logo: logo};
	});
var $elm$json$Json$Decode$map4 = _Json_map4;
var $author$project$Data$BusinessTheme$decoder = A5(
	$elm$json$Json$Decode$map4,
	$author$project$Data$BusinessTheme$BusinessTheme,
	A2($elm$json$Json$Decode$field, 'logo', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'appBarBackgroundColor', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'bannerLogo', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'bannerBackground', $elm$json$Json$Decode$string));
var $author$project$Data$BusinessTheme$default = {appBarBackgroundColor: '#2979FF', bannerBackground: '/images/signnetBannerBackground.png', bannerLogo: '/images/signnetBannerLogo.png', logo: '/images/signnet2.svg'};
var $elm$core$Basics$composeR = F3(
	function (f, g, x) {
		return g(
			f(x));
	});
var $elm$http$Http$expectStringResponse = F2(
	function (toMsg, toResult) {
		return A3(
			_Http_expect,
			'',
			$elm$core$Basics$identity,
			A2($elm$core$Basics$composeR, toResult, toMsg));
	});
var $elm$http$Http$BadBody = function (a) {
	return {$: 'BadBody', a: a};
};
var $elm$http$Http$BadStatus = function (a) {
	return {$: 'BadStatus', a: a};
};
var $elm$http$Http$BadUrl = function (a) {
	return {$: 'BadUrl', a: a};
};
var $elm$http$Http$NetworkError = {$: 'NetworkError'};
var $elm$http$Http$Timeout = {$: 'Timeout'};
var $elm$http$Http$resolve = F2(
	function (toResult, response) {
		switch (response.$) {
			case 'BadUrl_':
				var url = response.a;
				return $elm$core$Result$Err(
					$elm$http$Http$BadUrl(url));
			case 'Timeout_':
				return $elm$core$Result$Err($elm$http$Http$Timeout);
			case 'NetworkError_':
				return $elm$core$Result$Err($elm$http$Http$NetworkError);
			case 'BadStatus_':
				var metadata = response.a;
				return $elm$core$Result$Err(
					$elm$http$Http$BadStatus(metadata.statusCode));
			default:
				var body = response.b;
				return A2(
					$elm$core$Result$mapError,
					$elm$http$Http$BadBody,
					toResult(body));
		}
	});
var $elm$http$Http$expectJson = F2(
	function (toMsg, decoder) {
		return A2(
			$elm$http$Http$expectStringResponse,
			toMsg,
			$elm$http$Http$resolve(
				function (string) {
					return A2(
						$elm$core$Result$mapError,
						$elm$json$Json$Decode$errorToString,
						A2($elm$json$Json$Decode$decodeString, decoder, string));
				}));
	});
var $elm$http$Http$Request = function (a) {
	return {$: 'Request', a: a};
};
var $elm$http$Http$State = F2(
	function (reqs, subs) {
		return {reqs: reqs, subs: subs};
	});
var $elm$http$Http$init = $elm$core$Task$succeed(
	A2($elm$http$Http$State, $elm$core$Dict$empty, _List_Nil));
var $elm$core$Process$kill = _Scheduler_kill;
var $elm$core$Process$spawn = _Scheduler_spawn;
var $elm$http$Http$updateReqs = F3(
	function (router, cmds, reqs) {
		updateReqs:
		while (true) {
			if (!cmds.b) {
				return $elm$core$Task$succeed(reqs);
			} else {
				var cmd = cmds.a;
				var otherCmds = cmds.b;
				if (cmd.$ === 'Cancel') {
					var tracker = cmd.a;
					var _v2 = A2($elm$core$Dict$get, tracker, reqs);
					if (_v2.$ === 'Nothing') {
						var $temp$router = router,
							$temp$cmds = otherCmds,
							$temp$reqs = reqs;
						router = $temp$router;
						cmds = $temp$cmds;
						reqs = $temp$reqs;
						continue updateReqs;
					} else {
						var pid = _v2.a;
						return A2(
							$elm$core$Task$andThen,
							function (_v3) {
								return A3(
									$elm$http$Http$updateReqs,
									router,
									otherCmds,
									A2($elm$core$Dict$remove, tracker, reqs));
							},
							$elm$core$Process$kill(pid));
					}
				} else {
					var req = cmd.a;
					return A2(
						$elm$core$Task$andThen,
						function (pid) {
							var _v4 = req.tracker;
							if (_v4.$ === 'Nothing') {
								return A3($elm$http$Http$updateReqs, router, otherCmds, reqs);
							} else {
								var tracker = _v4.a;
								return A3(
									$elm$http$Http$updateReqs,
									router,
									otherCmds,
									A3($elm$core$Dict$insert, tracker, pid, reqs));
							}
						},
						$elm$core$Process$spawn(
							A3(
								_Http_toTask,
								router,
								$elm$core$Platform$sendToApp(router),
								req)));
				}
			}
		}
	});
var $elm$http$Http$onEffects = F4(
	function (router, cmds, subs, state) {
		return A2(
			$elm$core$Task$andThen,
			function (reqs) {
				return $elm$core$Task$succeed(
					A2($elm$http$Http$State, reqs, subs));
			},
			A3($elm$http$Http$updateReqs, router, cmds, state.reqs));
	});
var $elm$core$List$maybeCons = F3(
	function (f, mx, xs) {
		var _v0 = f(mx);
		if (_v0.$ === 'Just') {
			var x = _v0.a;
			return A2($elm$core$List$cons, x, xs);
		} else {
			return xs;
		}
	});
var $elm$core$List$filterMap = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$foldr,
			$elm$core$List$maybeCons(f),
			_List_Nil,
			xs);
	});
var $elm$http$Http$maybeSend = F4(
	function (router, desiredTracker, progress, _v0) {
		var actualTracker = _v0.a;
		var toMsg = _v0.b;
		return _Utils_eq(desiredTracker, actualTracker) ? $elm$core$Maybe$Just(
			A2(
				$elm$core$Platform$sendToApp,
				router,
				toMsg(progress))) : $elm$core$Maybe$Nothing;
	});
var $elm$http$Http$onSelfMsg = F3(
	function (router, _v0, state) {
		var tracker = _v0.a;
		var progress = _v0.b;
		return A2(
			$elm$core$Task$andThen,
			function (_v1) {
				return $elm$core$Task$succeed(state);
			},
			$elm$core$Task$sequence(
				A2(
					$elm$core$List$filterMap,
					A3($elm$http$Http$maybeSend, router, tracker, progress),
					state.subs)));
	});
var $elm$http$Http$Cancel = function (a) {
	return {$: 'Cancel', a: a};
};
var $elm$http$Http$cmdMap = F2(
	function (func, cmd) {
		if (cmd.$ === 'Cancel') {
			var tracker = cmd.a;
			return $elm$http$Http$Cancel(tracker);
		} else {
			var r = cmd.a;
			return $elm$http$Http$Request(
				{
					allowCookiesFromOtherDomains: r.allowCookiesFromOtherDomains,
					body: r.body,
					expect: A2(_Http_mapExpect, func, r.expect),
					headers: r.headers,
					method: r.method,
					timeout: r.timeout,
					tracker: r.tracker,
					url: r.url
				});
		}
	});
var $elm$http$Http$MySub = F2(
	function (a, b) {
		return {$: 'MySub', a: a, b: b};
	});
var $elm$http$Http$subMap = F2(
	function (func, _v0) {
		var tracker = _v0.a;
		var toMsg = _v0.b;
		return A2(
			$elm$http$Http$MySub,
			tracker,
			A2($elm$core$Basics$composeR, toMsg, func));
	});
_Platform_effectManagers['Http'] = _Platform_createManager($elm$http$Http$init, $elm$http$Http$onEffects, $elm$http$Http$onSelfMsg, $elm$http$Http$cmdMap, $elm$http$Http$subMap);
var $elm$http$Http$command = _Platform_leaf('Http');
var $elm$http$Http$subscription = _Platform_leaf('Http');
var $elm$http$Http$request = function (r) {
	return $elm$http$Http$command(
		$elm$http$Http$Request(
			{allowCookiesFromOtherDomains: false, body: r.body, expect: r.expect, headers: r.headers, method: r.method, timeout: r.timeout, tracker: r.tracker, url: r.url}));
};
var $elm$http$Http$get = function (r) {
	return $elm$http$Http$request(
		{body: $elm$http$Http$emptyBody, expect: r.expect, headers: _List_Nil, method: 'GET', timeout: $elm$core$Maybe$Nothing, tracker: $elm$core$Maybe$Nothing, url: r.url});
};
var $elm$core$Basics$not = _Basics_not;
var $author$project$Model$Theme$loadDomainTheme = F4(
	function (appDomain, themeHost, domain, baseHost) {
		return (A2($author$project$Data$Domain$equal, appDomain, domain) || (!A2(
			$elm$core$String$contains,
			baseHost,
			$author$project$Data$Domain$toString(domain)))) ? A2(
			$elm$core$Task$perform,
			$author$project$Types$OnTheme,
			$elm$core$Task$succeed(
				$author$project$Type$Theme$LoadTheme($author$project$Data$BusinessTheme$default))) : $elm$http$Http$get(
			{
				expect: A2(
					$elm$http$Http$expectJson,
					A2($elm$core$Basics$composeL, $author$project$Types$OnTheme, $author$project$Type$Theme$OnThemeResult),
					$author$project$Data$BusinessTheme$decoder),
				url: themeHost + ('/business/' + ($author$project$Data$Domain$toString(domain) + '/theme.json'))
			});
	});
var $author$project$Model$Theme$init = F4(
	function (appDomain, themeHost, domain, baseHost) {
		return _Utils_Tuple2(
			{theme: $author$project$Type$Theme$Loading, themeHost: themeHost},
			A4($author$project$Model$Theme$loadDomainTheme, appDomain, themeHost, domain, baseHost));
	});
var $author$project$Type$TokenConfirmation$Loading = {$: 'Loading'};
var $author$project$Model$TokenConfirmation$init = {error: $elm$core$Maybe$Nothing, status: $author$project$Type$TokenConfirmation$Loading};
var $author$project$Types$ClosedMenu = {$: 'ClosedMenu'};
var $author$project$Type$ActionButton$AllClose = {$: 'AllClose'};
var $author$project$Model$ActionButton$init = {status: $author$project$Type$ActionButton$AllClose, templateQuota: 0, templatesUsed: 0};
var $author$project$Type$AddressBook$LoadingModel = {$: 'LoadingModel'};
var $author$project$Model$AddressBook$init = $author$project$Type$AddressBook$LoadingModel;
var $author$project$Type$BusinessCreate$Loaded = {$: 'Loaded'};
var $author$project$Type$BusinessCreate$Ready = {$: 'Ready'};
var $author$project$Model$BusinessCreate$init = {companyName: '', companyNameError: $elm$core$Maybe$Nothing, formStatus: $author$project$Type$BusinessCreate$Ready, isModalOpen: false, redirectError: $elm$core$Maybe$Nothing, subdomain: '', subdomainError: $elm$core$Maybe$Nothing, subdomainStatus: $elm$core$Maybe$Nothing, validationStatus: $author$project$Type$BusinessCreate$Loaded};
var $author$project$Type$BusinessTheme$Closed = {$: 'Closed'};
var $author$project$Type$BusinessTheme$Ready = {$: 'Ready'};
var $author$project$Model$BusinessTheme$init = function (businessTheme) {
	return {
		bannerBackground: _Utils_Tuple2(businessTheme.bannerBackground, $author$project$Type$BusinessTheme$Ready),
		bannerLogo: _Utils_Tuple2(businessTheme.bannerLogo, $author$project$Type$BusinessTheme$Ready),
		headerColor: _Utils_Tuple2(businessTheme.appBarBackgroundColor, $author$project$Type$BusinessTheme$Ready),
		headerLogo: _Utils_Tuple2(businessTheme.logo, $author$project$Type$BusinessTheme$Ready),
		imageEditorState: $author$project$Type$BusinessTheme$Closed
	};
};
var $author$project$Type$BusinessUser$Closed = {$: 'Closed'};
var $author$project$Type$BusinessUser$Hide = {$: 'Hide'};
var $author$project$Type$BusinessUser$NotLoaded = {$: 'NotLoaded'};
var $author$project$Model$BusinessUser$init = {
	couponBanner: $author$project$Type$BusinessUser$Hide,
	couponCodes: _List_fromArray(
		[
			{error: $elm$core$Maybe$Nothing, input: '', successMessage: $elm$core$Maybe$Nothing}
		]),
	email: '',
	emailError: $elm$core$Maybe$Nothing,
	firstName: '',
	firstNameError: $elm$core$Maybe$Nothing,
	formModal: $author$project$Type$BusinessUser$Closed,
	lastName: '',
	lastNameError: $elm$core$Maybe$Nothing,
	users: $author$project$Type$BusinessUser$NotLoaded
};
var $author$project$Type$CreateTemplate$NotLoaded = {$: 'NotLoaded'};
var $author$project$Model$CreateTemplate$init = $author$project$Type$CreateTemplate$NotLoaded;
var $author$project$Type$Dashboard$Loading = {$: 'Loading'};
var $author$project$Type$Dashboard$NoHover = {$: 'NoHover'};
var $author$project$Model$Dashboard$init = {
	completedDocsStatus: $author$project$Type$Dashboard$Loading,
	completedDocuments: _List_Nil,
	incomingDocsStatus: $author$project$Type$Dashboard$Loading,
	incomingDocuments: _List_Nil,
	incomingPendingNum: 0,
	newDoc: {base64File: $elm$core$Maybe$Nothing, error: $elm$core$Maybe$Nothing, file: $elm$core$Maybe$Nothing, fileHover: false},
	outgoingDocsStatus: $author$project$Type$Dashboard$Loading,
	outgoingDocuments: _List_Nil,
	points: 0,
	pointsStatus: $author$project$Type$Dashboard$Loading,
	toolTip: $author$project$Type$Dashboard$NoHover,
	totalNoOfPages: 0,
	totalSent: 0
};
var $author$project$Type$LanguageChange$Dutch = {$: 'Dutch'};
var $author$project$Type$LanguageChange$English = {$: 'English'};
var $author$project$View$Menu$convertStringToLanguage = function (languageString) {
	switch (languageString) {
		case 'English':
			return $author$project$Type$LanguageChange$English;
		case 'Dutch':
			return $author$project$Type$LanguageChange$Dutch;
		default:
			return $author$project$Type$LanguageChange$English;
	}
};
var $author$project$Model$LanguageChange$languageSwitcher = _Platform_outgoingPort('languageSwitcher', $elm$core$Basics$identity);
var $author$project$Model$LanguageChange$init = function (defaultLanguage) {
	return _Utils_Tuple2(
		{
			listOfLanguages: _List_fromArray(
				[$author$project$Type$LanguageChange$English, $author$project$Type$LanguageChange$Dutch]),
			onLanguageSelectMenu: false,
			selectedLanguage: $author$project$View$Menu$convertStringToLanguage(defaultLanguage)
		},
		$author$project$Model$LanguageChange$languageSwitcher(
			$elm$json$Json$Encode$string(defaultLanguage)));
};
var $author$project$Type$ListDocument$Loading = {$: 'Loading'};
var $author$project$Model$ListDocument$init = {banner: $elm$core$Maybe$Nothing, completed: _List_Nil, docsCount: 0, modal: $elm$core$Maybe$Nothing, pageNumber: 0, received: _List_Nil, searchFromDate: '', searchQuery: '', searchToDate: '', selectedType: $author$project$Type$ListDocument$Received, sent: _List_Nil, snackBar: $author$project$Material$Styled$Snackbar$Hide, status: $author$project$Type$ListDocument$Loading, submission: _List_Nil, template: _List_Nil};
var $author$project$Model$ListTemplateDashboard$init = {modal: $elm$core$Maybe$Nothing, pageNumber: 0, templateCount: 0, templates: _List_Nil};
var $author$project$Type$Logout$Ready = {$: 'Ready'};
var $author$project$Model$Logout$init = $author$project$Type$Logout$Ready;
var $author$project$Model$NewDocument$init = {base64File: $elm$core$Maybe$Nothing, error: $elm$core$Maybe$Nothing, file: $elm$core$Maybe$Nothing, fileHover: false, files: _List_Nil, numberOfFiles: $elm$core$Maybe$Nothing};
var $author$project$Model$NewMultipleDocument$init = {base64File: $elm$core$Maybe$Nothing, error: $elm$core$Maybe$Nothing, file: $elm$core$Maybe$Nothing, fileHover: false, files: _List_Nil, showModal: false};
var $author$project$Model$NewTemplate$init = {base64File: $elm$core$Maybe$Nothing, error: $elm$core$Maybe$Nothing, file: $elm$core$Maybe$Nothing, fileHover: false, templateQuota: 0, templatesUsed: 0, toolTipHover: false};
var $author$project$Model$PointTopUp$init = {amount: 1};
var $author$project$Model$PointTransaction$init = {error: false, transaction: $elm$core$Maybe$Nothing, transactionID: $elm$core$Maybe$Nothing};
var $author$project$Model$PointTransactionHistory$init = {entryCount: 0, pageNumber: 0, pageSize: 10, transactions: _List_Nil};
var $author$project$Type$PointWithdrawal$Inactive = {$: 'Inactive'};
var $author$project$Type$PointWithdrawal$Loading = {$: 'Loading'};
var $author$project$Model$PointWithdrawal$init = {
	amount: '',
	available: 0,
	modal: $author$project$Type$PointWithdrawal$Inactive,
	pending: 0,
	sendToken: {amount: '', amountError: $elm$core$Maybe$Nothing},
	status: $author$project$Type$PointWithdrawal$Loading
};
var $author$project$Type$RedeemRewardList$Inactive = {$: 'Inactive'};
var $author$project$Type$RedeemRewardList$Loading = {$: 'Loading'};
var $author$project$Model$RedeemRewardList$init = {available: 0, modal: $author$project$Type$RedeemRewardList$Inactive, pending: 0, quantity: '1', quantityError: $elm$core$Maybe$Nothing, rewards: _List_Nil, status: $author$project$Type$RedeemRewardList$Loading};
var $author$project$Type$Setting$Closed = {$: 'Closed'};
var $author$project$Type$Setting$NoCode = {$: 'NoCode'};
var $author$project$Type$Setting$Ready = {$: 'Ready'};
var $author$project$Type$Setting$Algorand = {$: 'Algorand'};
var $author$project$Type$Setting$Binance = {$: 'Binance'};
var $author$project$Model$Settings$convertStringToNetwork = function (currentUserNotarisationNetwork) {
	switch (currentUserNotarisationNetwork) {
		case 'Binance':
			return $author$project$Type$Setting$Binance;
		case 'Algorand':
			return $author$project$Type$Setting$Algorand;
		default:
			return $author$project$Type$Setting$Binance;
	}
};
var $author$project$Type$Setting$AlgoWallet = {$: 'AlgoWallet'};
var $author$project$Type$Setting$SystemBalance = {$: 'SystemBalance'};
var $author$project$Type$Setting$WalletConnect = {$: 'WalletConnect'};
var $author$project$Model$Settings$convertStringToPayment = function (currentUserPaymentMethod) {
	switch (currentUserPaymentMethod) {
		case 'systemBalance':
			return $author$project$Type$Setting$SystemBalance;
		case 'algoWallet':
			return $author$project$Type$Setting$AlgoWallet;
		case 'walletConnect':
			return $author$project$Type$Setting$WalletConnect;
		default:
			return $author$project$Type$Setting$SystemBalance;
	}
};
var $author$project$Model$Settings$init = function (user) {
	return {
		apiKeys: _List_Nil,
		image: {formStatus: $author$project$Type$Setting$Ready, imageEditor: $author$project$Type$Setting$Closed, imageUrl: user.avatarUrl},
		notarisationNetworkInfo: {
			currentNetwork: $author$project$Model$Settings$convertStringToNetwork(user.notarisationNetwork),
			defaultNotarisation: user.notariseByDefault,
			notariseToolTipHover: false,
			paymentMethod: $author$project$Model$Settings$convertStringToPayment(user.paymentMethod),
			updateDefaultNotarisation: $author$project$Type$Setting$Ready,
			updateNetworkError: $elm$core$Maybe$Nothing,
			updatePayment: $author$project$Type$Setting$Ready,
			updateStatus: $author$project$Type$Setting$Ready
		},
		notification: {email: user.notification.email, formStatus: $author$project$Type$Setting$Ready},
		profile: {
			data: {address: user.address, dateOfBirth: user.dateOfBirth, firstName: user.firstName, identificationNumber: user.identificationNumber, lastName: user.lastName, nationality: user.nationality, phoneNumber: user.phoneNumber, shareReferralCode: user.shareReferralCode},
			email: user.email,
			firstNameError: $elm$core$Maybe$Nothing,
			formStatus: $author$project$Type$Setting$Ready,
			identificationNumError: $elm$core$Maybe$Nothing,
			lastNameError: $elm$core$Maybe$Nothing,
			myInfoStatus: $author$project$Type$Setting$NoCode,
			phoneNumError: $elm$core$Maybe$Nothing,
			referralCodeSnackbarStatus: $author$project$Material$Styled$Snackbar$Hide,
			showAdError: $elm$core$Maybe$Nothing,
			showAds: user.showAds,
			stampsHover: false
		},
		security: {confirmNewPassword: '', confirmNewPasswordError: $elm$core$Maybe$Nothing, currentPassword: '', currentPasswordError: $elm$core$Maybe$Nothing, formStatus: $author$project$Type$Setting$Ready, newPassword: '', newPasswordError: $elm$core$Maybe$Nothing}
	};
};
var $author$project$Type$Signature$LoadSignature = function (a) {
	return {$: 'LoadSignature', a: a};
};
var $author$project$Type$Signature$Ready = {$: 'Ready'};
var $author$project$Type$Signature$Typed = {$: 'Typed'};
var $author$project$Data$Api$Signature$List$Payload = function (signatures) {
	return {signatures: signatures};
};
var $author$project$Data$Api$Signature$List$Signature = F3(
	function (id, name, data) {
		return {data: data, id: id, name: name};
	});
var $author$project$Data$Api$Signature$List$signatureDecoder = A4(
	$elm$json$Json$Decode$map3,
	$author$project$Data$Api$Signature$List$Signature,
	A2($elm$json$Json$Decode$field, 'id', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'name', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'data', $elm$json$Json$Decode$string));
var $author$project$Data$Api$Signature$List$dataDecoder = A2(
	$elm$json$Json$Decode$map,
	$author$project$Data$Api$Signature$List$Payload,
	A2(
		$elm$json$Json$Decode$field,
		'signatures',
		$elm$json$Json$Decode$list($author$project$Data$Api$Signature$List$signatureDecoder)));
var $author$project$Data$Api$Signature$List$NOT_FOUND = {$: 'NOT_FOUND'};
var $author$project$Data$Api$Signature$List$errorDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (errorCode) {
		if (errorCode === 'NOT_FOUND') {
			return $elm$json$Json$Decode$succeed($author$project$Data$Api$Signature$List$NOT_FOUND);
		} else {
			return $elm$json$Json$Decode$fail('Invalid error code: ' + errorCode);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Data$Api$Signature$List$authCall = F2(
	function (jwt, endPoint) {
		return A5(
			$author$project$Data$Api$authCall,
			jwt,
			endPoint,
			$author$project$Data$Api$Signature$List$errorDecoder,
			$author$project$Data$Api$Signature$List$dataDecoder,
			$elm$json$Json$Encode$object(_List_Nil));
	});
var $author$project$Model$Signature$init = F2(
	function (endPoint, user) {
		return _Utils_Tuple2(
			{formStatus: $author$project$Type$Signature$Ready, listError: $elm$core$Maybe$Nothing, name: '', nameError: $elm$core$Maybe$Nothing, newSignature: $elm$core$Maybe$Nothing, open: false, signatureText: '', signatureType: $author$project$Type$Signature$Typed, signatures: _List_Nil, textError: $elm$core$Maybe$Nothing, uploadError: $elm$core$Maybe$Nothing},
			A2(
				$elm$core$Task$attempt,
				A2($elm$core$Basics$composeL, $author$project$Types$OnSignature, $author$project$Type$Signature$LoadSignature),
				A2($author$project$Data$Api$Signature$List$authCall, user.jwt, endPoint.signatureList)));
	});
var $author$project$Type$Stamp$Closed = {$: 'Closed'};
var $author$project$Type$Stamp$LoadStampsResult = F2(
	function (a, b) {
		return {$: 'LoadStampsResult', a: a, b: b};
	});
var $author$project$Type$Stamp$Loading = {$: 'Loading'};
var $author$project$Types$OnStamp = function (a) {
	return {$: 'OnStamp', a: a};
};
var $author$project$Type$Stamp$Ready = {$: 'Ready'};
var $author$project$Data$Api$Stamp$List$Payload = function (stamps) {
	return {stamps: stamps};
};
var $author$project$Data$PDF$Stamp$Stamp = function (a) {
	return {$: 'Stamp', a: a};
};
var $author$project$Data$PDF$Stamp$StampRecord = F8(
	function (id, name, userID, domain, fileType, createdAt, isDeleted, data) {
		return {createdAt: createdAt, data: data, domain: domain, fileType: fileType, id: id, isDeleted: isDeleted, name: name, userID: userID};
	});
var $author$project$Data$PDF$Stamp$Loaded = function (a) {
	return {$: 'Loaded', a: a};
};
var $author$project$Data$PDF$Stamp$NotLoaded = {$: 'NotLoaded'};
var $author$project$Data$PDF$Stamp$GIF = {$: 'GIF'};
var $author$project$Data$PDF$Stamp$JPEG = {$: 'JPEG'};
var $author$project$Data$PDF$Stamp$JPG = {$: 'JPG'};
var $author$project$Data$PDF$Stamp$PNG = {$: 'PNG'};
var $author$project$Data$PDF$Stamp$SVG = {$: 'SVG'};
var $author$project$Data$PDF$Stamp$fileTypeDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (value) {
		switch (value) {
			case 'jpg':
				return $elm$json$Json$Decode$succeed($author$project$Data$PDF$Stamp$JPG);
			case 'jpeg':
				return $elm$json$Json$Decode$succeed($author$project$Data$PDF$Stamp$JPEG);
			case 'png':
				return $elm$json$Json$Decode$succeed($author$project$Data$PDF$Stamp$PNG);
			case 'svg':
				return $elm$json$Json$Decode$succeed($author$project$Data$PDF$Stamp$SVG);
			case 'gif':
				return $elm$json$Json$Decode$succeed($author$project$Data$PDF$Stamp$GIF);
			default:
				return $elm$json$Json$Decode$fail('Invalid file type: ' + value);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Data$PDF$Stamp$makeBase64ImageData = F2(
	function (fileType, dataString) {
		switch (fileType.$) {
			case 'JPG':
				return 'data:image/jpg;base64,' + dataString;
			case 'JPEG':
				return 'data:image/jpeg;base64,' + dataString;
			case 'PNG':
				return 'data:image/png;base64,' + dataString;
			case 'SVG':
				return 'data:image/svg;base64,' + dataString;
			default:
				return 'data:image/gif;base64,' + dataString;
		}
	});
var $elm$json$Json$Decode$maybe = function (decoder) {
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, decoder),
				$elm$json$Json$Decode$succeed($elm$core$Maybe$Nothing)
			]));
};
var $author$project$Data$PDF$Stamp$dataDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (_v0) {
		var fileType = _v0.a;
		var dataString = _v0.b;
		if (dataString.$ === 'Nothing') {
			return $elm$json$Json$Decode$succeed($author$project$Data$PDF$Stamp$NotLoaded);
		} else {
			var data_ = dataString.a;
			return $elm$json$Json$Decode$succeed(
				$author$project$Data$PDF$Stamp$Loaded(
					A2($author$project$Data$PDF$Stamp$makeBase64ImageData, fileType, data_)));
		}
	},
	A3(
		$elm$json$Json$Decode$map2,
		F2(
			function (fileType, dataString) {
				return _Utils_Tuple2(fileType, dataString);
			}),
		A2($elm$json$Json$Decode$field, 'fileType', $author$project$Data$PDF$Stamp$fileTypeDecoder),
		$elm$json$Json$Decode$maybe(
			A2($elm$json$Json$Decode$field, 'base64DataString', $elm$json$Json$Decode$string))));
var $elm$json$Json$Decode$map8 = _Json_map8;
var $author$project$Data$PDF$Stamp$decoder = A2(
	$elm$json$Json$Decode$map,
	$author$project$Data$PDF$Stamp$Stamp,
	A9(
		$elm$json$Json$Decode$map8,
		$author$project$Data$PDF$Stamp$StampRecord,
		A2($elm$json$Json$Decode$field, 'id', $elm$json$Json$Decode$string),
		A2($elm$json$Json$Decode$field, 'name', $elm$json$Json$Decode$string),
		A2($elm$json$Json$Decode$field, 'userID', $elm$json$Json$Decode$string),
		A2($elm$json$Json$Decode$field, 'domain', $author$project$Data$Domain$domainDecoder),
		A2($elm$json$Json$Decode$field, 'fileType', $author$project$Data$PDF$Stamp$fileTypeDecoder),
		A2(
			$elm$json$Json$Decode$field,
			'createdAt',
			A2($elm$json$Json$Decode$map, $elm$time$Time$millisToPosix, $elm$json$Json$Decode$int)),
		A2($elm$json$Json$Decode$field, 'isDeleted', $elm$json$Json$Decode$bool),
		$author$project$Data$PDF$Stamp$dataDecoder));
var $author$project$Data$Api$Stamp$List$dataDecoder = A2(
	$elm$json$Json$Decode$map,
	$author$project$Data$Api$Stamp$List$Payload,
	A2(
		$elm$json$Json$Decode$field,
		'stamps',
		$elm$json$Json$Decode$list($author$project$Data$PDF$Stamp$decoder)));
var $author$project$Data$Api$Stamp$List$USER_NOT_IN_DOMAIN = {$: 'USER_NOT_IN_DOMAIN'};
var $author$project$Data$Api$Stamp$List$errorDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (errorCode) {
		if (errorCode === 'USER_NOT_IN_DOMAIN') {
			return $elm$json$Json$Decode$succeed($author$project$Data$Api$Stamp$List$USER_NOT_IN_DOMAIN);
		} else {
			return $elm$json$Json$Decode$fail('Invalid error code: ' + errorCode);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Data$Api$Stamp$List$authCall = F3(
	function (jwt, endPoint, domain) {
		return A5(
			$author$project$Data$Api$authCall,
			jwt,
			endPoint,
			$author$project$Data$Api$Stamp$List$errorDecoder,
			$author$project$Data$Api$Stamp$List$dataDecoder,
			$elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'domain',
						$author$project$Data$Domain$encode(domain))
					])));
	});
var $elm$core$Dict$fromList = function (assocs) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (_v0, dict) {
				var key = _v0.a;
				var value = _v0.b;
				return A3($elm$core$Dict$insert, key, value, dict);
			}),
		$elm$core$Dict$empty,
		assocs);
};
var $author$project$Model$Stamp$init = F2(
	function (user, endPoint) {
		return _Utils_Tuple2(
			{
				formStampDomain: $elm$core$Maybe$Nothing,
				formStatus: $author$project$Type$Stamp$Ready,
				imageEditor: $author$project$Type$Stamp$Closed,
				name: '',
				nameError: $elm$core$Maybe$Nothing,
				stamps: $elm$core$Dict$fromList(
					A2(
						$elm$core$List$map,
						function (domain) {
							return _Utils_Tuple2(domain, $author$project$Type$Stamp$Loading);
						},
						A2(
							$elm$core$List$map,
							$author$project$Data$Domain$toString,
							$author$project$Data$Domain$all(user.domains))))
			},
			$elm$core$Platform$Cmd$batch(
				A2(
					$elm$core$List$map,
					function (domain) {
						return A2(
							$elm$core$Task$attempt,
							A2(
								$elm$core$Basics$composeL,
								$author$project$Types$OnStamp,
								$author$project$Type$Stamp$LoadStampsResult(domain)),
							A3($author$project$Data$Api$Stamp$List$authCall, user.jwt, endPoint.stampList, domain));
					},
					$author$project$Data$Domain$all(user.domains))));
	});
var $author$project$Type$TokenManagement$AllClosed = {$: 'AllClosed'};
var $author$project$Type$TokenManagement$Closed = {$: 'Closed'};
var $author$project$Type$TokenManagement$RetrievingBalance = {$: 'RetrievingBalance'};
var $author$project$Type$TokenManagement$Algorand = {$: 'Algorand'};
var $author$project$Type$TokenManagement$Binance = {$: 'Binance'};
var $author$project$Model$TokenManagement$convertStringToNetwork = function (currentUserNotarisationNetwork) {
	switch (currentUserNotarisationNetwork) {
		case 'Binance':
			return $author$project$Type$TokenManagement$Binance;
		case 'Algorand':
			return $author$project$Type$TokenManagement$Algorand;
		default:
			return $author$project$Type$TokenManagement$Binance;
	}
};
var $author$project$Type$TokenManagement$AlgoWallet = {$: 'AlgoWallet'};
var $author$project$Type$TokenManagement$SystemPointsBalance = {$: 'SystemPointsBalance'};
var $author$project$Type$TokenManagement$WalletConnect = {$: 'WalletConnect'};
var $author$project$Model$TokenManagement$convertStringToPayment = function (currentUserPaymentMethod) {
	switch (currentUserPaymentMethod) {
		case 'systemBalance':
			return $author$project$Type$TokenManagement$SystemPointsBalance;
		case 'algoWallet':
			return $author$project$Type$TokenManagement$AlgoWallet;
		case 'walletConnect':
			return $author$project$Type$TokenManagement$WalletConnect;
		default:
			return $author$project$Type$TokenManagement$SystemPointsBalance;
	}
};
var $author$project$Model$TokenManagement$init = function (user) {
	return {
		algorandWallet: user.algorandWalletAddress,
		available: 0,
		currentNetwork: $author$project$Model$TokenManagement$convertStringToNetwork(user.notarisationNetwork),
		modal: $author$project$Type$TokenManagement$AllClosed,
		paymentMethod: $author$project$Model$TokenManagement$convertStringToPayment(user.paymentMethod),
		pending: 0,
		redeemRewardHover: false,
		sendToken: {amount: '', amountError: $elm$core$Maybe$Nothing, banner: $author$project$Type$TokenManagement$Closed, email: '', emailError: $elm$core$Maybe$Nothing, remarks: ''},
		systemHover: false,
		tokenBalance: $elm$core$Maybe$Nothing,
		transactions: _List_Nil,
		updateNetworkError: $elm$core$Maybe$Nothing,
		updateStatus: $author$project$Type$TokenManagement$Closed,
		usdToPoints: 0,
		walletError: $elm$core$Maybe$Nothing,
		walletHover: false,
		walletStatus: $author$project$Type$TokenManagement$RetrievingBalance
	};
};
var $author$project$Type$TrustScore$Close = {$: 'Close'};
var $author$project$Data$Badge$Corporate = function (a) {
	return {$: 'Corporate', a: a};
};
var $author$project$Data$Badge$CreditCard = function (a) {
	return {$: 'CreditCard', a: a};
};
var $author$project$Data$Badge$MobilePhone = function (a) {
	return {$: 'MobilePhone', a: a};
};
var $author$project$Data$Badge$MyInfo = function (a) {
	return {$: 'MyInfo', a: a};
};
var $author$project$Data$Badge$Wallet = function (a) {
	return {$: 'Wallet', a: a};
};
var $author$project$Data$Badge$NotVerified = {$: 'NotVerified'};
var $author$project$Data$Badge$Verified = {$: 'Verified'};
var $author$project$Model$TrustScore$getStatus = function (verified) {
	return verified ? $author$project$Data$Badge$Verified : $author$project$Data$Badge$NotVerified;
};
var $author$project$Model$TrustScore$init = function (user) {
	var _v0 = user.trustScore;
	var myInfo = _v0.myInfo;
	var corporate = _v0.corporate;
	var stripe = _v0.stripe;
	var mobilePhone = _v0.mobilePhone;
	var wallet = _v0.wallet;
	return {
		corporate: $author$project$Data$Badge$Corporate(
			$author$project$Model$TrustScore$getStatus(corporate)),
		creditCard: $author$project$Data$Badge$CreditCard(
			$author$project$Model$TrustScore$getStatus(stripe)),
		error: $elm$core$Maybe$Nothing,
		mobilePhone: $author$project$Data$Badge$MobilePhone(
			$author$project$Model$TrustScore$getStatus(mobilePhone)),
		modal: $author$project$Type$TrustScore$Close,
		myInfo: $author$project$Data$Badge$MyInfo(
			$author$project$Model$TrustScore$getStatus(myInfo)),
		passbaseError: $elm$core$Maybe$Nothing,
		passbaseModal: false,
		twilioError: $elm$core$Maybe$Nothing,
		verifyCode: '',
		wallet: $author$project$Data$Badge$Wallet(
			$author$project$Model$TrustScore$getStatus(wallet))
	};
};
var $author$project$Type$UploadMultipleDocument$NotLoaded = {$: 'NotLoaded'};
var $author$project$Model$UploadMultipleDocument$init = $author$project$Type$UploadMultipleDocument$NotLoaded;
var $author$project$Type$VerifyDocument$NoFile = {$: 'NoFile'};
var $author$project$Model$VerifyDocument$init = {base64File: $elm$core$Maybe$Nothing, file: $elm$core$Maybe$Nothing, fileHover: false, status: $author$project$Type$VerifyDocument$NoFile};
var $author$project$Type$ViewDocument$NotLoaded = {$: 'NotLoaded'};
var $author$project$Model$ViewDocument$init = $author$project$Type$ViewDocument$NotLoaded;
var $author$project$Type$ViewNotarisationInfo$NoFile = {$: 'NoFile'};
var $author$project$Model$ViewNotarisationInfo$init = {base64File: $elm$core$Maybe$Nothing, checksum: $elm$core$Maybe$Nothing, file: $elm$core$Maybe$Nothing, fileHover: false, status: $author$project$Type$ViewNotarisationInfo$NoFile};
var $author$project$Data$SSE$startServerEvents = _Platform_outgoingPort('startServerEvents', $elm$core$Basics$identity);
var $author$project$Data$SSE$start = F2(
	function (apiEndpoint, jwt) {
		return $author$project$Data$SSE$startServerEvents(
			$elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'apiEndpoint',
						$elm$json$Json$Encode$string(apiEndpoint)),
						_Utils_Tuple2(
						'jwt',
						$elm$json$Json$Encode$string(jwt))
					])));
	});
var $author$project$Model$initAuthModel = F4(
	function (defaultLanguage, endpoint, themeModel, user) {
		var businessTheme = function () {
			var _v3 = A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.theme;
				},
				themeModel);
			if ((_v3.$ === 'Just') && (_v3.a.$ === 'Loaded')) {
				var theme = _v3.a.a;
				return theme;
			} else {
				return $author$project$Data$BusinessTheme$default;
			}
		}();
		var _v0 = A2($author$project$Model$Stamp$init, user, endpoint);
		var stampModel = _v0.a;
		var stampCmd = _v0.b;
		var _v1 = A2($author$project$Model$Signature$init, endpoint, user);
		var signatureModel = _v1.a;
		var signatureCmd = _v1.b;
		var _v2 = $author$project$Model$LanguageChange$init(defaultLanguage);
		var languageChangeModel = _v2.a;
		var languageChangeCmd = _v2.b;
		return _Utils_Tuple2(
			{
				actionButton: $author$project$Model$ActionButton$init,
				addressBookModel: $author$project$Model$AddressBook$init,
				businessCreateModel: $author$project$Model$BusinessCreate$init,
				businessThemeForm: $author$project$Model$BusinessTheme$init(businessTheme),
				businessUserModel: $author$project$Model$BusinessUser$init,
				createTemplateModel: $author$project$Model$CreateTemplate$init,
				dashboardModel: $author$project$Model$Dashboard$init,
				fillTemplateModel: $author$project$Model$FillTemplate$init,
				languageChangeModel: languageChangeModel,
				listDocModel: $author$project$Model$ListDocument$init,
				listTemplateDashboardModel: $author$project$Model$ListTemplateDashboard$init,
				logout: $author$project$Model$Logout$init,
				menu: $author$project$Types$ClosedMenu,
				newDocModel: $author$project$Model$NewDocument$init,
				newMultipleDocModel: $author$project$Model$NewMultipleDocument$init,
				newTemplateModel: $author$project$Model$NewTemplate$init,
				pointsTopUpModel: $author$project$Model$PointTopUp$init,
				redeemRewardList: $author$project$Model$RedeemRewardList$init,
				settingModel: $author$project$Model$Settings$init(user),
				signatureModel: signatureModel,
				stampModel: stampModel,
				tokenManagementModel: $author$project$Model$TokenManagement$init(user),
				transactionHistoryModel: $author$project$Model$PointTransactionHistory$init,
				transactionModel: $author$project$Model$PointTransaction$init,
				trustScoreModel: $author$project$Model$TrustScore$init(user),
				uploadMultipleDocModel: $author$project$Model$UploadMultipleDocument$init,
				user: user,
				verifyDocumentModel: $author$project$Model$VerifyDocument$init,
				viewDocModel: $author$project$Model$ViewDocument$init,
				viewNotarisationInfoModel: $author$project$Model$ViewNotarisationInfo$init,
				withdrawalModel: $author$project$Model$PointWithdrawal$init
			},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						signatureCmd,
						stampCmd,
						languageChangeCmd,
						A2($author$project$Data$SSE$start, endpoint.sse, user.jwt)
					])));
	});
var $elm$core$Tuple$mapFirst = F2(
	function (func, _v0) {
		var x = _v0.a;
		var y = _v0.b;
		return _Utils_Tuple2(
			func(x),
			y);
	});
var $elm$core$List$any = F2(
	function (isOkay, list) {
		any:
		while (true) {
			if (!list.b) {
				return false;
			} else {
				var x = list.a;
				var xs = list.b;
				if (isOkay(x)) {
					return true;
				} else {
					var $temp$isOkay = isOkay,
						$temp$list = xs;
					isOkay = $temp$isOkay;
					list = $temp$list;
					continue any;
				}
			}
		}
	});
var $elm$core$List$member = F2(
	function (x, xs) {
		return A2(
			$elm$core$List$any,
			function (a) {
				return _Utils_eq(a, x);
			},
			xs);
	});
var $author$project$Data$Domain$select = F2(
	function (domain, _v0) {
		var domains = _v0.b;
		return A2($author$project$Data$Domain$Domains, domain, domains);
	});
var $author$project$Model$init = F3(
	function (flags, url, navKey) {
		var domainHost = $author$project$Data$Domain$fromUrl(url);
		var _v0 = flags;
		var bscScanExplorerUrl = _v0.bscScanExplorerUrl;
		var algorandExplorerUrl = _v0.algorandExplorerUrl;
		var affliateParams = _v0.affliateParams;
		var affliateUrl = _v0.affliateUrl;
		var apiUrl = _v0.apiUrl;
		var user = _v0.user;
		var localJsBundle = _v0.localJsBundle;
		var currentTime = _v0.currentTime;
		var timezoneOffset = _v0.timezoneOffset;
		var staticUrl = _v0.staticUrl;
		var selectedBanner = _v0.selectedBanner;
		var baseHost = _v0.baseHost;
		var webHost = _v0.webHost;
		var passbaseUrl = _v0.passbaseUrl;
		var bscScanApiUrl = _v0.bscScanApiUrl;
		var bscScanApiKey = _v0.bscScanApiKey;
		var bscScanApiTokenAddress = _v0.bscScanApiTokenAddress;
		var defaultLanguage = _v0.defaultLanguage;
		var apiEndPoint = A6($author$project$Data$Api$endPoint, apiUrl, passbaseUrl, affliateUrl, affliateParams, bscScanApiUrl, bscScanApiTokenAddress);
		var appDomain = $author$project$Data$Domain$fromString(webHost);
		var _v1 = A4($author$project$Model$Theme$init, appDomain, apiUrl, domainHost, baseHost);
		var themeModel = _v1.a;
		var themeCmd = _v1.b;
		var _v2 = A2($author$project$Model$BusinessProfile$init, apiEndPoint, domainHost);
		var businessProfileModel = _v2.a;
		var businessProfileCmd = _v2.b;
		var _v3 = A2(
			$elm$core$Maybe$withDefault,
			_Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none),
			A2(
				$elm$core$Maybe$map,
				function (u) {
					var _v4 = A2($elm$json$Json$Decode$decodeString, $author$project$Data$User$decoder, u);
					if (_v4.$ === 'Ok') {
						var okUser = _v4.a;
						var isDomainHostInUserDomain = A2(
							$elm$core$List$member,
							domainHost,
							$author$project$Data$Domain$all(okUser.domains));
						var selectedDomain = isDomainHostInUserDomain ? domainHost : appDomain;
						return A2(
							$elm$core$Tuple$mapFirst,
							$elm$core$Maybe$Just,
							A4(
								$author$project$Model$initAuthModel,
								defaultLanguage,
								apiEndPoint,
								$elm$core$Maybe$Nothing,
								_Utils_update(
									okUser,
									{
										domains: A2($author$project$Data$Domain$select, selectedDomain, okUser.domains)
									})));
					} else {
						return _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none);
					}
				},
				user));
		var authModel = _v3.a;
		var authCmd = _v3.b;
		var sessionModel = A2(
			$elm$core$Maybe$withDefault,
			$author$project$Types$NoAuth,
			A2(
				$elm$core$Maybe$map,
				function (model) {
					return $author$project$Types$Auth(model);
				},
				authModel));
		var _v5 = A5(
			$author$project$Model$Route$calculate,
			apiEndPoint,
			appDomain,
			navKey,
			sessionModel,
			A3($author$project$Data$Route$getRoute, appDomain, authModel, url));
		var route = _v5.a;
		var routeCmd = _v5.b;
		var _v6 = A2(
			$author$project$Model$BusinessAcceptInvite$init,
			apiEndPoint,
			$author$project$Data$Route$getAcceptBusinessInviteToken(route));
		var businessAcceptInviteModel = _v6.a;
		var businessAcceptInviteCmd = _v6.b;
		var _v7 = A2(
			$author$project$Model$ConfirmDeleteDocument$init,
			apiEndPoint,
			$author$project$Data$Route$getConfirmDeleteDocumentToken(route));
		var confirmDeleteDocumentModel = _v7.a;
		var confirmDeleteDocumentCmd = _v7.b;
		var _v8 = A2(
			$author$project$Model$ConfirmDeleteTemplate$init,
			apiEndPoint,
			$author$project$Data$Route$getConfirmDeleteTemplateToken(route));
		var confirmDeleteTemplateModel = _v8.a;
		var confirmDeleteTemplateCmd = _v8.b;
		var _v9 = A2(
			$author$project$Model$PointWithdrawalConfirm$init,
			apiEndPoint,
			$author$project$Data$Route$getConfirmWithdrawalToken(route));
		var pointWithdrawalConfirmModel = _v9.a;
		var pointWithdrawalConfirmCmd = _v9.b;
		var _v10 = $author$project$Model$Activate$init(
			$author$project$Data$Route$getActivateToken(route));
		var activateModel = _v10.a;
		var activateCmd = _v10.b;
		return _Utils_Tuple2(
			{
				activateModel: activateModel,
				algorandExplorerUrl: algorandExplorerUrl,
				apiEndPoint: apiEndPoint,
				appDomain: appDomain,
				appsumoRegisterModel: $author$project$Model$AppsumoRegister$init(route),
				baseHost: baseHost,
				bscScanApiKey: bscScanApiKey,
				bscScanExplorerUrl: bscScanExplorerUrl,
				businessAcceptInviteModel: businessAcceptInviteModel,
				businessProfileModel: businessProfileModel,
				businessRegisterModel: $author$project$Model$BusinessRegister$init(route),
				confirmDeleteDocumentModel: confirmDeleteDocumentModel,
				confirmDeleteTemplateModel: confirmDeleteTemplateModel,
				currentTime: $elm$time$Time$millisToPosix(currentTime),
				defaultLanguage: defaultLanguage,
				domainHost: domainHost,
				fillTemplateModel: $author$project$Model$FillTemplate$init,
				languageSwitchModel: $author$project$Model$LanguageSwitch$init,
				localJsBundle: localJsBundle,
				loginModel: $author$project$Model$Login$init,
				navKey: navKey,
				newfoldRegisterModel: $author$project$Model$NewfoldRegister$init(route),
				pointWithdrawalConfirm: pointWithdrawalConfirmModel,
				registerModel: $author$project$Model$PersonalRegister$init,
				resendActivationModel: $author$project$Model$ResendActivation$init,
				resetPasswordModel: $author$project$Model$ResetPassword$init,
				route: route,
				selectedBanner: selectedBanner,
				sessionModel: sessionModel,
				setPasswordModel: $author$project$Model$SetPassword$init,
				theme: themeModel,
				timezone: A2($elm$time$Time$customZone, timezoneOffset, _List_Nil),
				timezoneName: $elm$core$Maybe$Nothing,
				timezoneOffset: timezoneOffset,
				tokenConfirmationModel: $author$project$Model$TokenConfirmation$init,
				url: url
			},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						authCmd,
						activateCmd,
						businessAcceptInviteCmd,
						themeCmd,
						businessProfileCmd,
						routeCmd,
						A2($elm$core$Task$perform, $author$project$Types$GetTimezone, $elm$time$Time$here),
						A2($elm$core$Task$perform, $author$project$Types$GetZoneName, $elm$time$Time$getZoneName),
						pointWithdrawalConfirmCmd,
						confirmDeleteDocumentCmd,
						confirmDeleteTemplateCmd
					])));
	});
var $author$project$Type$FillTemplate$AlgorandWalletError = function (a) {
	return {$: 'AlgorandWalletError', a: a};
};
var $author$project$Type$UploadMultipleDocument$AlgorandWalletError = function (a) {
	return {$: 'AlgorandWalletError', a: a};
};
var $author$project$Type$ViewDocument$AlgorandWalletError = function (a) {
	return {$: 'AlgorandWalletError', a: a};
};
var $author$project$Type$FillTemplate$GetAlgorandWalletAddress = function (a) {
	return {$: 'GetAlgorandWalletAddress', a: a};
};
var $author$project$Type$UploadMultipleDocument$GetAlgorandWalletAddress = function (a) {
	return {$: 'GetAlgorandWalletAddress', a: a};
};
var $author$project$Type$FillTemplate$GetOptInDetails = function (a) {
	return {$: 'GetOptInDetails', a: a};
};
var $author$project$Type$UploadMultipleDocument$GetOptInDetails = function (a) {
	return {$: 'GetOptInDetails', a: a};
};
var $author$project$Type$ViewDocument$GetOptInDetails = function (a) {
	return {$: 'GetOptInDetails', a: a};
};
var $author$project$Type$Signature$NewSignature = function (a) {
	return {$: 'NewSignature', a: a};
};
var $author$project$Type$TokenManagement$OnAlgorandWalletError = function (a) {
	return {$: 'OnAlgorandWalletError', a: a};
};
var $author$project$Type$FillTemplate$OnAuth = function (a) {
	return {$: 'OnAuth', a: a};
};
var $author$project$Type$ViewDocument$OnAuth = function (a) {
	return {$: 'OnAuth', a: a};
};
var $author$project$Types$OnBusinessCreate = function (a) {
	return {$: 'OnBusinessCreate', a: a};
};
var $author$project$Types$OnBusinessRegister = function (a) {
	return {$: 'OnBusinessRegister', a: a};
};
var $author$project$Type$CreateTemplate$OnCompletedOfficeConversion = function (a) {
	return {$: 'OnCompletedOfficeConversion', a: a};
};
var $author$project$Type$UploadMultipleDocument$OnCompletedOfficeConversion = function (a) {
	return {$: 'OnCompletedOfficeConversion', a: a};
};
var $author$project$Types$OnCreateTemplate = function (a) {
	return {$: 'OnCreateTemplate', a: a};
};
var $author$project$Type$CreateTemplate$OnDeselectedTemplateAnnotData = function (a) {
	return {$: 'OnDeselectedTemplateAnnotData', a: a};
};
var $author$project$Type$CreateTemplate$OnDocLoaded = function (a) {
	return {$: 'OnDocLoaded', a: a};
};
var $author$project$Type$UploadMultipleDocument$OnDocLoaded = function (a) {
	return {$: 'OnDocLoaded', a: a};
};
var $author$project$Type$TokenManagement$OnExternalWalletAddress = function (a) {
	return {$: 'OnExternalWalletAddress', a: a};
};
var $author$project$Type$TokenManagement$OnExternalWalletError = function (a) {
	return {$: 'OnExternalWalletError', a: a};
};
var $author$project$Type$TokenManagement$OnGetAlgorandWalletAddress = function (a) {
	return {$: 'OnGetAlgorandWalletAddress', a: a};
};
var $author$project$Type$ViewDocument$OnGetAlgorandWalletAddress = function (a) {
	return {$: 'OnGetAlgorandWalletAddress', a: a};
};
var $author$project$Types$OnLanguageChange = function (a) {
	return {$: 'OnLanguageChange', a: a};
};
var $author$project$Type$FillTemplate$OnLoaded = function (a) {
	return {$: 'OnLoaded', a: a};
};
var $author$project$Type$ViewDocument$OnLoaded = function (a) {
	return {$: 'OnLoaded', a: a};
};
var $author$project$Type$ViewDocument$OnNotarizationStart = function (a) {
	return {$: 'OnNotarizationStart', a: a};
};
var $author$project$Type$FillTemplate$OnOptInStart = function (a) {
	return {$: 'OnOptInStart', a: a};
};
var $author$project$Type$UploadMultipleDocument$OnOptInStart = function (a) {
	return {$: 'OnOptInStart', a: a};
};
var $author$project$Type$UploadMultipleDocument$OnPDFRotationAlert = function (a) {
	return {$: 'OnPDFRotationAlert', a: a};
};
var $author$project$Type$ViewDocument$OnReceiveCheckboxClickData = function (a) {
	return {$: 'OnReceiveCheckboxClickData', a: a};
};
var $author$project$Type$CreateTemplate$OnReceiveClickAnnotData = function (a) {
	return {$: 'OnReceiveClickAnnotData', a: a};
};
var $author$project$Type$UploadMultipleDocument$OnReceiveClickAnnotData = function (a) {
	return {$: 'OnReceiveClickAnnotData', a: a};
};
var $author$project$Type$CreateTemplate$OnReceiveDeleteAnnotsData = function (a) {
	return {$: 'OnReceiveDeleteAnnotsData', a: a};
};
var $author$project$Type$UploadMultipleDocument$OnReceiveDeleteAnnotsData = function (a) {
	return {$: 'OnReceiveDeleteAnnotsData', a: a};
};
var $author$project$Type$CreateTemplate$OnReceiveDeleteSelectedAnnot = function (a) {
	return {$: 'OnReceiveDeleteSelectedAnnot', a: a};
};
var $author$project$Type$UploadMultipleDocument$OnReceiveDeleteSelectedAnnot = function (a) {
	return {$: 'OnReceiveDeleteSelectedAnnot', a: a};
};
var $author$project$Type$UploadMultipleDocument$OnReceiveDeselectedClick = function (a) {
	return {$: 'OnReceiveDeselectedClick', a: a};
};
var $author$project$Type$ViewDocument$OnReceiveDocumentLoaded = function (a) {
	return {$: 'OnReceiveDocumentLoaded', a: a};
};
var $author$project$Type$CreateTemplate$OnReceiveEncryptionError = function (a) {
	return {$: 'OnReceiveEncryptionError', a: a};
};
var $author$project$Type$FillTemplate$OnReceiveEncryptionError = function (a) {
	return {$: 'OnReceiveEncryptionError', a: a};
};
var $author$project$Type$ViewDocument$OnReceiveEncryptionError = function (a) {
	return {$: 'OnReceiveEncryptionError', a: a};
};
var $author$project$Type$LanguageChange$OnReceiveLanguageData = function (a) {
	return {$: 'OnReceiveLanguageData', a: a};
};
var $author$project$Type$CreateTemplate$OnReceiveModifiedAnnotData = function (a) {
	return {$: 'OnReceiveModifiedAnnotData', a: a};
};
var $author$project$Type$UploadMultipleDocument$OnReceiveModifiedAnnotData = function (a) {
	return {$: 'OnReceiveModifiedAnnotData', a: a};
};
var $author$project$Type$UploadMultipleDocument$OnReceiveSelectedAnnotClickData = function (a) {
	return {$: 'OnReceiveSelectedAnnotClickData', a: a};
};
var $author$project$Type$ViewDocument$OnReceiveSelectedAnnotsData = function (a) {
	return {$: 'OnReceiveSelectedAnnotsData', a: a};
};
var $author$project$Type$CreateTemplate$OnReceiveSelectedTemplateAnnotClickData = function (a) {
	return {$: 'OnReceiveSelectedTemplateAnnotClickData', a: a};
};
var $author$project$Type$ViewDocument$OnReceiveUpdatedSignatureWidth = function (a) {
	return {$: 'OnReceiveUpdatedSignatureWidth', a: a};
};
var $author$project$Type$TokenManagement$OnReceiveWalletConnetAddresses = function (a) {
	return {$: 'OnReceiveWalletConnetAddresses', a: a};
};
var $author$project$Type$TokenManagement$OnReceiveWalletConnetAmount = function (a) {
	return {$: 'OnReceiveWalletConnetAmount', a: a};
};
var $author$project$Type$BusinessCreate$OnRedirectError = function (a) {
	return {$: 'OnRedirectError', a: a};
};
var $author$project$Type$BusinessRegister$OnRedirectError = function (a) {
	return {$: 'OnRedirectError', a: a};
};
var $author$project$Type$TokenManagement$OnRestartWalletConnect = function (a) {
	return {$: 'OnRestartWalletConnect', a: a};
};
var $author$project$Type$ViewDocument$OnRestartWalletConnectInit = function (a) {
	return {$: 'OnRestartWalletConnectInit', a: a};
};
var $author$project$Type$ViewDocument$OnRestartWalletConnectNotarization = function (a) {
	return {$: 'OnRestartWalletConnectNotarization', a: a};
};
var $author$project$Type$FillTemplate$OnReturnTemplatePDF = function (a) {
	return {$: 'OnReturnTemplatePDF', a: a};
};
var $author$project$Type$CreateTemplate$OnSearchDebounce = function (a) {
	return {$: 'OnSearchDebounce', a: a};
};
var $author$project$Type$FillTemplate$OnSearchDebounce = function (a) {
	return {$: 'OnSearchDebounce', a: a};
};
var $author$project$Type$UploadMultipleDocument$OnSearchDebounce = function (a) {
	return {$: 'OnSearchDebounce', a: a};
};
var $author$project$Type$CreateTemplate$OnSearchFieldBlur = function (a) {
	return {$: 'OnSearchFieldBlur', a: a};
};
var $author$project$Type$FillTemplate$OnSearchFieldBlur = function (a) {
	return {$: 'OnSearchFieldBlur', a: a};
};
var $author$project$Type$UploadMultipleDocument$OnSearchFieldBlur = function (a) {
	return {$: 'OnSearchFieldBlur', a: a};
};
var $author$project$Types$OnServerEvent = function (a) {
	return {$: 'OnServerEvent', a: a};
};
var $author$project$Type$Signature$OnTextExtraction = function (a) {
	return {$: 'OnTextExtraction', a: a};
};
var $author$project$Type$UploadMultipleDocument$OnUneditableDoc = function (a) {
	return {$: 'OnUneditableDoc', a: a};
};
var $author$project$Type$ViewNotarisationInfo$OnVerifyChecksum = function (a) {
	return {$: 'OnVerifyChecksum', a: a};
};
var $author$project$Types$OnVerifyDocument = function (a) {
	return {$: 'OnVerifyDocument', a: a};
};
var $author$project$Type$VerifyDocument$OnVerifySubmit = function (a) {
	return {$: 'OnVerifySubmit', a: a};
};
var $author$project$Type$ViewDocument$OnWalletConnectAddressesReceive = function (a) {
	return {$: 'OnWalletConnectAddressesReceive', a: a};
};
var $author$project$Type$ViewDocument$OnWalletConnectError = function (a) {
	return {$: 'OnWalletConnectError', a: a};
};
var $author$project$Type$FillTemplate$OnWalletConnectNotarizationCompleted = function (a) {
	return {$: 'OnWalletConnectNotarizationCompleted', a: a};
};
var $author$project$Type$ViewDocument$OnWalletConnectNotarizationCompleted = function (a) {
	return {$: 'OnWalletConnectNotarizationCompleted', a: a};
};
var $author$project$Type$TokenManagement$OnWalletConnectOptInCompleted = function (a) {
	return {$: 'OnWalletConnectOptInCompleted', a: a};
};
var $author$project$Type$ViewDocument$OnWalletConnectOptInCompleted = function (a) {
	return {$: 'OnWalletConnectOptInCompleted', a: a};
};
var $author$project$Type$FillTemplate$OnWalletConnectStart = function (a) {
	return {$: 'OnWalletConnectStart', a: a};
};
var $author$project$Type$UploadMultipleDocument$OnWalletConnectStart = function (a) {
	return {$: 'OnWalletConnectStart', a: a};
};
var $author$project$Type$FillTemplate$OnWalletConnectWalletOptInCompleted = function (a) {
	return {$: 'OnWalletConnectWalletOptInCompleted', a: a};
};
var $author$project$Type$UploadMultipleDocument$OnWalletConnectWalletOptInCompleted = function (a) {
	return {$: 'OnWalletConnectWalletOptInCompleted', a: a};
};
var $author$project$Type$FillTemplate$OnWalletConnectWalletRecieve = function (a) {
	return {$: 'OnWalletConnectWalletRecieve', a: a};
};
var $author$project$Type$UploadMultipleDocument$OnWalletConnectWalletRecieve = function (a) {
	return {$: 'OnWalletConnectWalletRecieve', a: a};
};
var $author$project$Type$FillTemplate$OptInError = function (a) {
	return {$: 'OptInError', a: a};
};
var $author$project$Type$UploadMultipleDocument$OptInError = function (a) {
	return {$: 'OptInError', a: a};
};
var $author$project$Type$ViewDocument$OptInError = function (a) {
	return {$: 'OptInError', a: a};
};
var $author$project$Type$FillTemplate$OptInStatusResult = function (a) {
	return {$: 'OptInStatusResult', a: a};
};
var $author$project$Type$UploadMultipleDocument$OptInStatusResult = function (a) {
	return {$: 'OptInStatusResult', a: a};
};
var $author$project$Type$ViewDocument$OptInStatusResult = function (a) {
	return {$: 'OptInStatusResult', a: a};
};
var $author$project$Type$FillTemplate$PaymentTransactionError = function (a) {
	return {$: 'PaymentTransactionError', a: a};
};
var $author$project$Type$UploadMultipleDocument$PaymentTransactionError = function (a) {
	return {$: 'PaymentTransactionError', a: a};
};
var $author$project$Type$ViewDocument$PaymentTransactionError = function (a) {
	return {$: 'PaymentTransactionError', a: a};
};
var $author$project$Type$FillTemplate$SendNotarisationDetails = function (a) {
	return {$: 'SendNotarisationDetails', a: a};
};
var $author$project$Type$UploadMultipleDocument$SendNotarisationDetails = function (a) {
	return {$: 'SendNotarisationDetails', a: a};
};
var $author$project$Type$ViewDocument$SendNotarisationDetails = function (a) {
	return {$: 'SendNotarisationDetails', a: a};
};
var $elm$core$Platform$Sub$batch = _Platform_batch;
var $author$project$Model$CreateTemplate$createTemplateTriggerBlur = _Platform_incomingPort('createTemplateTriggerBlur', $elm$json$Json$Decode$value);
var $author$project$Model$FillTemplate$fillTemplateTriggerBlur = _Platform_incomingPort('fillTemplateTriggerBlur', $elm$json$Json$Decode$value);
var $author$project$Type$BusinessTheme$ImageReceivedData = function (a) {
	return {$: 'ImageReceivedData', a: a};
};
var $author$project$Type$Setting$ImageReceivedData = function (a) {
	return {$: 'ImageReceivedData', a: a};
};
var $author$project$Type$Stamp$ImageReceivedData = function (a) {
	return {$: 'ImageReceivedData', a: a};
};
var $author$project$Types$OnBusinessChangeTheme = function (a) {
	return {$: 'OnBusinessChangeTheme', a: a};
};
var $author$project$Type$BusinessTheme$OnImageAction = F2(
	function (a, b) {
		return {$: 'OnImageAction', a: a, b: b};
	});
var $author$project$Type$Setting$OnImageUpload = function (a) {
	return {$: 'OnImageUpload', a: a};
};
var $author$project$Type$Stamp$OnImageUpload = function (a) {
	return {$: 'OnImageUpload', a: a};
};
var $elm$core$Basics$neq = _Utils_notEqual;
var $elm$core$Platform$Sub$none = $elm$core$Platform$Sub$batch(_List_Nil);
var $elm$file$File$decoder = _File_decoder;
var $elm$core$Tuple$pair = F2(
	function (a, b) {
		return _Utils_Tuple2(a, b);
	});
var $author$project$ImageEditor$receiveImageEditorData = _Platform_incomingPort('receiveImageEditorData', $elm$json$Json$Decode$value);
var $author$project$ImageEditor$receiveImageData = function (handler) {
	return $author$project$ImageEditor$receiveImageEditorData(
		A2(
			$elm$core$Basics$composeR,
			$elm$json$Json$Decode$decodeValue(
				A3(
					$elm$json$Json$Decode$map2,
					$elm$core$Tuple$pair,
					A2($elm$json$Json$Decode$field, 'localUrl', $elm$json$Json$Decode$string),
					A2($elm$json$Json$Decode$field, 'file', $elm$file$File$decoder))),
			handler));
};
var $author$project$Subscriptions$imageEditorSub = function (sessionModel) {
	switch (sessionModel.$) {
		case 'Auth':
			var authModel = sessionModel.a;
			var _v1 = authModel;
			var settingModel = _v1.settingModel;
			var businessThemeForm = _v1.businessThemeForm;
			var stampModel = _v1.stampModel;
			if (!_Utils_eq(settingModel.image.imageEditor, $author$project$Type$Setting$Closed)) {
				return $author$project$ImageEditor$receiveImageData(
					A2(
						$elm$core$Basics$composeL,
						A2(
							$elm$core$Basics$composeL,
							A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnSetting),
							$author$project$Type$Setting$OnImageUpload),
						$author$project$Type$Setting$ImageReceivedData));
			} else {
				if (!_Utils_eq(businessThemeForm.imageEditorState, $author$project$Type$BusinessTheme$Closed)) {
					var _v2 = businessThemeForm.imageEditorState;
					switch (_v2.$) {
						case 'Processing':
							var field = _v2.a;
							return $author$project$ImageEditor$receiveImageData(
								A2(
									$elm$core$Basics$composeL,
									A2(
										$elm$core$Basics$composeL,
										A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnBusinessChangeTheme),
										$author$project$Type$BusinessTheme$OnImageAction(field)),
									$author$project$Type$BusinessTheme$ImageReceivedData));
						case 'Closed':
							return $elm$core$Platform$Sub$none;
						default:
							return $elm$core$Platform$Sub$none;
					}
				} else {
					if (!_Utils_eq(stampModel.imageEditor, $author$project$Type$Stamp$Closed)) {
						return $author$project$ImageEditor$receiveImageData(
							A2(
								$elm$core$Basics$composeL,
								A2($elm$core$Basics$composeL, $author$project$Types$OnStamp, $author$project$Type$Stamp$OnImageUpload),
								$author$project$Type$Stamp$ImageReceivedData));
					} else {
						return $elm$core$Platform$Sub$none;
					}
				}
			}
		case 'Anonymous':
			var anonymousModel = sessionModel.a;
			return (!_Utils_eq(anonymousModel.stampModel.imageEditor, $author$project$Type$Stamp$Closed)) ? $author$project$ImageEditor$receiveImageData(
				A2(
					$elm$core$Basics$composeL,
					A2($elm$core$Basics$composeL, $author$project$Types$OnStamp, $author$project$Type$Stamp$OnImageUpload),
					$author$project$Type$Stamp$ImageReceivedData)) : $elm$core$Platform$Sub$none;
		case 'NoAuth':
			return $elm$core$Platform$Sub$none;
		default:
			return $elm$core$Platform$Sub$none;
	}
};
var $author$project$Data$SSE$onServerEvents = _Platform_incomingPort('onServerEvents', $elm$json$Json$Decode$value);
var $author$project$Data$SSE$DataDecodeError = function (a) {
	return {$: 'DataDecodeError', a: a};
};
var $author$project$Data$SSE$Error = function (a) {
	return {$: 'Error', a: a};
};
var $author$project$Data$SSE$Message = function (a) {
	return {$: 'Message', a: a};
};
var $author$project$Data$SSE$NotSupported = {$: 'NotSupported'};
var $author$project$Data$SSE$Opened = {$: 'Opened'};
var $author$project$Data$SSE$OnJsBundle = function (a) {
	return {$: 'OnJsBundle', a: a};
};
var $author$project$Data$SSE$OnUser = function (a) {
	return {$: 'OnUser', a: a};
};
var $elm$core$List$head = function (list) {
	if (list.b) {
		var x = list.a;
		var xs = list.b;
		return $elm$core$Maybe$Just(x);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Data$Domain$domainListDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (domains) {
		var _v0 = $elm$core$List$head(domains);
		if (_v0.$ === 'Just') {
			var domain = _v0.a;
			return $elm$json$Json$Decode$succeed(
				A2($author$project$Data$Domain$Domains, domain, domains));
		} else {
			return $elm$json$Json$Decode$fail('No domains associated with user.');
		}
	},
	$elm$json$Json$Decode$list($author$project$Data$Domain$domainDecoder));
var $author$project$Data$Domain$domainListWithSelected = function (domain) {
	return A2(
		$elm$json$Json$Decode$andThen,
		function (domains) {
			return A2(
				$elm$core$List$member,
				domain,
				$author$project$Data$Domain$all(domains)) ? $elm$json$Json$Decode$succeed(
				A2($author$project$Data$Domain$select, domain, domains)) : $elm$json$Json$Decode$succeed(domains);
		},
		$author$project$Data$Domain$domainListDecoder);
};
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded = A2($elm$core$Basics$composeR, $elm$json$Json$Decode$succeed, $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom);
var $author$project$Data$User$decoderWithDomainAndJwt = F2(
	function (selectedDomain, jwt) {
		return A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'showAds',
			$elm$json$Json$Decode$bool,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'notariseByDefault',
				$elm$json$Json$Decode$bool,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'algorandWalletAddress',
					$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'paymentMethod',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'notarisationNetwork',
							$elm$json$Json$Decode$string,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'updateNameConfirmation',
								$elm$json$Json$Decode$bool,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'shareReferralCode',
									$elm$json$Json$Decode$string,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'metaMaskWalletAddress',
										$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'eSignDisclaimerTimestamp',
											$elm$json$Json$Decode$nullable(
												A2($elm$json$Json$Decode$map, $elm$time$Time$millisToPosix, $elm$json$Json$Decode$int)),
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'eSignDisclaimer',
												$elm$json$Json$Decode$bool,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'avatarUrl',
													$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'trustScore',
														$author$project$Data$User$trustScoreDecoder,
														A3(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
															'notification',
															$author$project$Data$User$notificationDecoder,
															A2(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
																jwt,
																A3(
																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																	'address',
																	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
																	A3(
																		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																		'dateOfBirth',
																		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
																		A3(
																			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																			'nationality',
																			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
																			A3(
																				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																				'phoneNumber',
																				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
																				A3(
																					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																					'identificationNumber',
																					$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
																					A3(
																						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																						'updatedAt',
																						A2($elm$json$Json$Decode$map, $elm$time$Time$millisToPosix, $elm$json$Json$Decode$int),
																						A3(
																							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																							'createdAt',
																							A2($elm$json$Json$Decode$map, $elm$time$Time$millisToPosix, $elm$json$Json$Decode$int),
																							A3(
																								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																								'email',
																								$elm$json$Json$Decode$string,
																								A3(
																									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																									'lastName',
																									$elm$json$Json$Decode$string,
																									A3(
																										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																										'firstName',
																										$elm$json$Json$Decode$string,
																										A3(
																											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																											'domains',
																											$author$project$Data$Domain$domainListWithSelected(selectedDomain),
																											A3(
																												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																												'id',
																												$elm$json$Json$Decode$string,
																												$elm$json$Json$Decode$succeed($author$project$Data$User$User)))))))))))))))))))))))))));
	});
var $elm$core$Result$map = F2(
	function (func, ra) {
		if (ra.$ === 'Ok') {
			var a = ra.a;
			return $elm$core$Result$Ok(
				func(a));
		} else {
			var e = ra.a;
			return $elm$core$Result$Err(e);
		}
	});
var $author$project$Data$SSE$decodeData = F3(
	function (domain, jwt, value) {
		var _v0 = A2(
			$elm$json$Json$Decode$decodeValue,
			A2(
				$elm$json$Json$Decode$at,
				_List_fromArray(
					['data', 'kind']),
				$elm$json$Json$Decode$string),
			value);
		if (_v0.$ === 'Err') {
			var error = _v0.a;
			return $elm$core$Result$Err(error);
		} else {
			var kind = _v0.a;
			switch (kind) {
				case 'User':
					return A2(
						$elm$core$Result$map,
						$author$project$Data$SSE$OnUser,
						A2(
							$elm$json$Json$Decode$decodeValue,
							A2(
								$elm$json$Json$Decode$at,
								_List_fromArray(
									['data', 'data']),
								A2($author$project$Data$User$decoderWithDomainAndJwt, domain, jwt)),
							value));
				case 'JsBundleUpdate':
					return A2(
						$elm$core$Result$map,
						$author$project$Data$SSE$OnJsBundle,
						A2(
							$elm$json$Json$Decode$decodeValue,
							A2(
								$elm$json$Json$Decode$at,
								_List_fromArray(
									['data', 'data', 'jsBundle']),
								$elm$json$Json$Decode$string),
							value));
				default:
					return $elm$core$Result$Err(
						A2($elm$json$Json$Decode$Failure, 'Unknown kind: ' + kind, value));
			}
		}
	});
var $author$project$Data$SSE$InvalidJSON = {$: 'InvalidJSON'};
var $author$project$Data$SSE$JwtError = {$: 'JwtError'};
var $author$project$Data$SSE$NetworkError = {$: 'NetworkError'};
var $author$project$Data$SSE$UserNotFoundError = {$: 'UserNotFoundError'};
var $author$project$Data$SSE$decodeError = function (value) {
	var _v0 = A2(
		$elm$json$Json$Decode$decodeValue,
		A2(
			$elm$json$Json$Decode$at,
			_List_fromArray(
				['error', 'code']),
			$elm$json$Json$Decode$string),
		value);
	if (_v0.$ === 'Err') {
		var error = _v0.a;
		return $elm$core$Result$Err(error);
	} else {
		var code = _v0.a;
		switch (code) {
			case 'NetworkError':
				return $elm$core$Result$Ok($author$project$Data$SSE$NetworkError);
			case 'InvalidJSON':
				return $elm$core$Result$Ok($author$project$Data$SSE$InvalidJSON);
			case 'USER_NOT_FOUND':
				return $elm$core$Result$Ok($author$project$Data$SSE$UserNotFoundError);
			case 'TOKEN_EXPIRED':
				return $elm$core$Result$Ok($author$project$Data$SSE$JwtError);
			case 'JSON_WEB_TOKEN_ERROR':
				return $elm$core$Result$Ok($author$project$Data$SSE$JwtError);
			case 'INACTIVE_TOKEN':
				return $elm$core$Result$Ok($author$project$Data$SSE$JwtError);
			case 'UNEXPECTED_ERROR':
				return $elm$core$Result$Ok($author$project$Data$SSE$JwtError);
			case 'INVALID_SESSION':
				return $elm$core$Result$Ok($author$project$Data$SSE$JwtError);
			default:
				return $elm$core$Result$Err(
					A2($elm$json$Json$Decode$Failure, 'Unknown Error Code: ' + code, value));
		}
	}
};
var $author$project$Data$SSE$decodeEvent = F3(
	function (domain, jwt, value) {
		var _v0 = A2(
			$elm$json$Json$Decode$decodeValue,
			A2($elm$json$Json$Decode$field, 'event', $elm$json$Json$Decode$string),
			value);
		if (_v0.$ === 'Err') {
			var error = _v0.a;
			return $elm$core$Result$Err(error);
		} else {
			var event = _v0.a;
			switch (event) {
				case 'NotSupported':
					return $elm$core$Result$Ok($author$project$Data$SSE$NotSupported);
				case 'Opened':
					return $elm$core$Result$Ok($author$project$Data$SSE$Opened);
				case 'Error':
					return A2(
						$elm$core$Result$map,
						$author$project$Data$SSE$Error,
						$author$project$Data$SSE$decodeError(value));
				case 'Message':
					return A2(
						$elm$core$Result$map,
						$author$project$Data$SSE$Message,
						A3($author$project$Data$SSE$decodeData, domain, jwt, value));
				default:
					return $elm$core$Result$Err(
						A2($elm$json$Json$Decode$Failure, 'Unknown event: ' + event, value));
			}
		}
	});
var $author$project$Data$SSE$toEvent = F3(
	function (domain, jwt, value) {
		var _v0 = A3($author$project$Data$SSE$decodeEvent, domain, jwt, value);
		if (_v0.$ === 'Ok') {
			var event = _v0.a;
			return event;
		} else {
			var error = _v0.a;
			return $author$project$Data$SSE$Error(
				$author$project$Data$SSE$DataDecodeError(
					$elm$json$Json$Decode$errorToString(error)));
		}
	});
var $author$project$Data$SSE$listen = F3(
	function (domain, jwt, handler) {
		return $author$project$Data$SSE$onServerEvents(
			A2(
				$elm$core$Basics$composeR,
				A2($author$project$Data$SSE$toEvent, domain, jwt),
				handler));
	});
var $author$project$Model$UploadMultipleDocument$multipleDocTriggerBlur = _Platform_incomingPort('multipleDocTriggerBlur', $elm$json$Json$Decode$value);
var $author$project$Model$FillTemplate$notarizationSendFillTemplateStart = _Platform_incomingPort('notarizationSendFillTemplateStart', $elm$json$Json$Decode$value);
var $author$project$Model$UploadMultipleDocument$notarizationSendUploadDocStart = _Platform_incomingPort('notarizationSendUploadDocStart', $elm$json$Json$Decode$value);
var $author$project$Model$ViewDocument$notarizationSendViewDocStart = _Platform_incomingPort('notarizationSendViewDocStart', $elm$json$Json$Decode$value);
var $author$project$Model$FillTemplate$optInFillTemplateStart = _Platform_incomingPort('optInFillTemplateStart', $elm$json$Json$Decode$value);
var $author$project$Model$UploadMultipleDocument$optInUploadDocStart = _Platform_incomingPort('optInUploadDocStart', $elm$json$Json$Decode$value);
var $author$project$Data$PDF$Port$receiveCheckboxClickData = _Platform_incomingPort('receiveCheckboxClickData', $elm$json$Json$Decode$value);
var $author$project$Data$PDF$Port$receiveDeselecedAnnotClickData = _Platform_incomingPort('receiveDeselecedAnnotClickData', $elm$json$Json$Decode$value);
var $author$project$Data$PDF$Port$receiveDocumentLoadEncryptionError = _Platform_incomingPort('receiveDocumentLoadEncryptionError', $elm$json$Json$Decode$value);
var $author$project$Data$PDF$Port$receiveDocumentLoaded = _Platform_incomingPort('receiveDocumentLoaded', $elm$json$Json$Decode$value);
var $author$project$Data$PDF$Port$receiveExportedPDF = _Platform_incomingPort('receiveExportedPDF', $elm$json$Json$Decode$value);
var $author$project$Data$PDF$Port$receiveMultipleDocumentAnnotData = _Platform_incomingPort('receiveMultipleDocumentAnnotData', $elm$json$Json$Decode$value);
var $author$project$Data$PDF$Port$receiveMultipleDocumentClickAnnotData = _Platform_incomingPort('receiveMultipleDocumentClickAnnotData', $elm$json$Json$Decode$value);
var $author$project$Data$PDF$Port$receiveMultipleDocumentDeleteAnnotData = _Platform_incomingPort('receiveMultipleDocumentDeleteAnnotData', $elm$json$Json$Decode$value);
var $author$project$Data$PDF$Port$receiveSelectedAnnotClickData = _Platform_incomingPort('receiveSelectedAnnotClickData', $elm$json$Json$Decode$value);
var $author$project$Data$PDF$Port$receiveSelectedAnnotsData = _Platform_incomingPort('receiveSelectedAnnotsData', $elm$json$Json$Decode$value);
var $author$project$Data$PDF$Port$receiveSelectedTemplateAnnotClickData = _Platform_incomingPort('receiveSelectedTemplateAnnotClickData', $elm$json$Json$Decode$value);
var $author$project$Model$BusinessRegister$receiveStripeError = _Platform_incomingPort('receiveStripeError', $elm$json$Json$Decode$value);
var $author$project$Model$BusinessCreate$receiveStripeErrorCreateBusiness = _Platform_incomingPort('receiveStripeErrorCreateBusiness', $elm$json$Json$Decode$value);
var $author$project$Data$PDF$Port$receiveTemplateAnnotData = _Platform_incomingPort('receiveTemplateAnnotData', $elm$json$Json$Decode$value);
var $author$project$Data$PDF$Port$receiveTemplateClickAnnotData = _Platform_incomingPort('receiveTemplateClickAnnotData', $elm$json$Json$Decode$value);
var $author$project$Data$PDF$Port$receiveTemplateDeleteAnnotData = _Platform_incomingPort('receiveTemplateDeleteAnnotData', $elm$json$Json$Decode$value);
var $author$project$Data$PDF$Port$receiveTemplateDeselecedAnnot = _Platform_incomingPort('receiveTemplateDeselecedAnnot', $elm$json$Json$Decode$value);
var $author$project$Data$PDF$Port$receiveTemplateLoadEncryptionError = _Platform_incomingPort('receiveTemplateLoadEncryptionError', $elm$json$Json$Decode$value);
var $author$project$Data$PDF$Port$receiveTemplateLoadNewEncryptionError = _Platform_incomingPort('receiveTemplateLoadNewEncryptionError', $elm$json$Json$Decode$value);
var $author$project$Data$PDF$Port$receiveUpdatedSignatureWidth = _Platform_incomingPort('receiveUpdatedSignatureWidth', $elm$json$Json$Decode$value);
var $author$project$Model$TokenManagement$restartWalletConnect = _Platform_incomingPort('restartWalletConnect', $elm$json$Json$Decode$value);
var $author$project$Model$ViewDocument$restartWalletConnectNotarization = _Platform_incomingPort('restartWalletConnectNotarization', $elm$json$Json$Decode$value);
var $author$project$Model$ViewDocument$restartWalletConnectViewDoc = _Platform_incomingPort('restartWalletConnectViewDoc', $elm$json$Json$Decode$value);
var $author$project$Data$PDF$Port$returnConvertedPDFTemplate = _Platform_incomingPort('returnConvertedPDFTemplate', $elm$json$Json$Decode$value);
var $author$project$Data$PDF$Port$returnDeleteSelectedAnnotMsg = _Platform_incomingPort('returnDeleteSelectedAnnotMsg', $elm$json$Json$Decode$value);
var $author$project$Data$PDF$Port$returnDeleteSelectedTemplateAnnotMsg = _Platform_incomingPort('returnDeleteSelectedTemplateAnnotMsg', $elm$json$Json$Decode$value);
var $author$project$Model$ViewNotarisationInfo$returnFileChecksum = _Platform_incomingPort('returnFileChecksum', $elm$json$Json$Decode$value);
var $author$project$Data$JsonReader$returnJsonFileData = _Platform_incomingPort('returnJsonFileData', $elm$json$Json$Decode$value);
var $author$project$Data$PDF$Port$returnMultipleDocLoadedMsg = _Platform_incomingPort('returnMultipleDocLoadedMsg', $elm$json$Json$Decode$value);
var $author$project$Data$PDF$Port$returnNonEditableDocError = _Platform_incomingPort('returnNonEditableDocError', $elm$json$Json$Decode$value);
var $author$project$Data$PDF$Port$returnRotationAlert = _Platform_incomingPort('returnRotationAlert', $elm$json$Json$Decode$value);
var $author$project$Data$PDF$Port$returnTemplateLoadedMsg = _Platform_incomingPort('returnTemplateLoadedMsg', $elm$json$Json$Decode$value);
var $author$project$Data$PDF$Port$returnTemplatePDF = _Platform_incomingPort('returnTemplatePDF', $elm$json$Json$Decode$value);
var $author$project$Model$TokenManagement$returnWalletAmount = _Platform_incomingPort('returnWalletAmount', $elm$json$Json$Decode$value);
var $author$project$Model$TokenManagement$sendAlgorandWalletAddressTokenManagementRoute = _Platform_incomingPort('sendAlgorandWalletAddressTokenManagementRoute', $elm$json$Json$Decode$value);
var $author$project$Model$FillTemplate$sendAlgorandWalletAddressesFillTemplateRoute = _Platform_incomingPort('sendAlgorandWalletAddressesFillTemplateRoute', $elm$json$Json$Decode$value);
var $author$project$Model$UploadMultipleDocument$sendAlgorandWalletAddressesUploadRoute = _Platform_incomingPort('sendAlgorandWalletAddressesUploadRoute', $elm$json$Json$Decode$value);
var $author$project$Model$ViewDocument$sendAlgorandWalletAddressesViewDocRoute = _Platform_incomingPort('sendAlgorandWalletAddressesViewDocRoute', $elm$json$Json$Decode$value);
var $author$project$Model$FillTemplate$sendAlgorandWalletErrorFillTemplateRoute = _Platform_incomingPort('sendAlgorandWalletErrorFillTemplateRoute', $elm$json$Json$Decode$value);
var $author$project$Model$TokenManagement$sendAlgorandWalletErrorTokenManagementRoute = _Platform_incomingPort('sendAlgorandWalletErrorTokenManagementRoute', $elm$json$Json$Decode$value);
var $author$project$Model$UploadMultipleDocument$sendAlgorandWalletErrorUploadRoute = _Platform_incomingPort('sendAlgorandWalletErrorUploadRoute', $elm$json$Json$Decode$value);
var $author$project$Model$ViewDocument$sendAlgorandWalletErrorViewDocRoute = _Platform_incomingPort('sendAlgorandWalletErrorViewDocRoute', $elm$json$Json$Decode$value);
var $author$project$Model$LanguageChange$sendLanguageData = _Platform_incomingPort('sendLanguageData', $elm$json$Json$Decode$value);
var $author$project$Model$FillTemplate$sendNotarisationDetailsFillTemplateRoute = _Platform_incomingPort('sendNotarisationDetailsFillTemplateRoute', $elm$json$Json$Decode$value);
var $author$project$Model$UploadMultipleDocument$sendNotarisationDetailsUploadRoute = _Platform_incomingPort('sendNotarisationDetailsUploadRoute', $elm$json$Json$Decode$value);
var $author$project$Model$ViewDocument$sendNotarisationDetailsViewDocRoute = _Platform_incomingPort('sendNotarisationDetailsViewDocRoute', $elm$json$Json$Decode$value);
var $author$project$Model$FillTemplate$sendNotarisationPaymentFillTemplateRoute = _Platform_incomingPort('sendNotarisationPaymentFillTemplateRoute', $elm$json$Json$Decode$value);
var $author$project$Model$FillTemplate$sendOptInErrorFillTemplateRoute = _Platform_incomingPort('sendOptInErrorFillTemplateRoute', $elm$json$Json$Decode$value);
var $author$project$Model$UploadMultipleDocument$sendOptInErrorUploadRoute = _Platform_incomingPort('sendOptInErrorUploadRoute', $elm$json$Json$Decode$value);
var $author$project$Model$ViewDocument$sendOptInErrorViewDocRoute = _Platform_incomingPort('sendOptInErrorViewDocRoute', $elm$json$Json$Decode$value);
var $author$project$Model$FillTemplate$sendOptInResultFillTemplateRoute = _Platform_incomingPort('sendOptInResultFillTemplateRoute', $elm$json$Json$Decode$value);
var $author$project$Model$UploadMultipleDocument$sendOptInResultUploadRoute = _Platform_incomingPort('sendOptInResultUploadRoute', $elm$json$Json$Decode$value);
var $author$project$Model$ViewDocument$sendOptInResultViewDocRoute = _Platform_incomingPort('sendOptInResultViewDocRoute', $elm$json$Json$Decode$value);
var $author$project$Model$FillTemplate$sendOptInStatusFillTemplateRoute = _Platform_incomingPort('sendOptInStatusFillTemplateRoute', $elm$json$Json$Decode$value);
var $author$project$Model$UploadMultipleDocument$sendOptInStatusUploadRoute = _Platform_incomingPort('sendOptInStatusUploadRoute', $elm$json$Json$Decode$value);
var $author$project$Model$ViewDocument$sendOptInStatusViewDocRoute = _Platform_incomingPort('sendOptInStatusViewDocRoute', $elm$json$Json$Decode$value);
var $author$project$Model$FillTemplate$sendPaymentTransactionErrorFillTemplateRoute = _Platform_incomingPort('sendPaymentTransactionErrorFillTemplateRoute', $elm$json$Json$Decode$value);
var $author$project$Model$UploadMultipleDocument$sendPaymentTransactionErrorUploadRoute = _Platform_incomingPort('sendPaymentTransactionErrorUploadRoute', $elm$json$Json$Decode$value);
var $author$project$Model$ViewDocument$sendPaymentTransactionErrorViewDocRoute = _Platform_incomingPort('sendPaymentTransactionErrorViewDocRoute', $elm$json$Json$Decode$value);
var $author$project$Model$Signature$sendSignatureData = _Platform_incomingPort('sendSignatureData', $elm$json$Json$Decode$value);
var $author$project$Model$Signature$sendTextSignatureData = _Platform_incomingPort('sendTextSignatureData', $elm$json$Json$Decode$value);
var $author$project$Model$TokenManagement$sendWalletAddress = _Platform_incomingPort('sendWalletAddress', $elm$json$Json$Decode$value);
var $author$project$Model$TokenManagement$sendWalletConnectAddresses = _Platform_incomingPort('sendWalletConnectAddresses', $elm$json$Json$Decode$value);
var $author$project$Model$FillTemplate$sendWalletConnectAddressesFillTemplate = _Platform_incomingPort('sendWalletConnectAddressesFillTemplate', $elm$json$Json$Decode$value);
var $author$project$Model$UploadMultipleDocument$sendWalletConnectAddressesUploadDoc = _Platform_incomingPort('sendWalletConnectAddressesUploadDoc', $elm$json$Json$Decode$value);
var $author$project$Model$ViewDocument$sendWalletConnectAddressesViewDoc = _Platform_incomingPort('sendWalletConnectAddressesViewDoc', $elm$json$Json$Decode$value);
var $author$project$Model$TokenManagement$sendWalletError = _Platform_incomingPort('sendWalletError', $elm$json$Json$Decode$value);
var $author$project$Model$CreateTemplate$triggerCreateTemplateDebounce = _Platform_incomingPort('triggerCreateTemplateDebounce', $elm$json$Json$Decode$value);
var $author$project$Model$FillTemplate$triggerFillTemplateDebounce = _Platform_incomingPort('triggerFillTemplateDebounce', $elm$json$Json$Decode$value);
var $author$project$Model$UploadMultipleDocument$triggerMultipleDocDebounce = _Platform_incomingPort('triggerMultipleDocDebounce', $elm$json$Json$Decode$value);
var $author$project$Model$ViewDocument$walletConnectErrorViewDoc = _Platform_incomingPort('walletConnectErrorViewDoc', $elm$json$Json$Decode$value);
var $author$project$Model$ViewDocument$walletConnectNotarizationCompleted = _Platform_incomingPort('walletConnectNotarizationCompleted', $elm$json$Json$Decode$value);
var $author$project$Model$TokenManagement$walletConnectOptInCompleted = _Platform_incomingPort('walletConnectOptInCompleted', $elm$json$Json$Decode$value);
var $author$project$Model$FillTemplate$walletConnectOptInCompletedFillTemplate = _Platform_incomingPort('walletConnectOptInCompletedFillTemplate', $elm$json$Json$Decode$value);
var $author$project$Model$UploadMultipleDocument$walletConnectOptInCompletedUploadDoc = _Platform_incomingPort('walletConnectOptInCompletedUploadDoc', $elm$json$Json$Decode$value);
var $author$project$Model$ViewDocument$walletConnectOptInCompletedViewDoc = _Platform_incomingPort('walletConnectOptInCompletedViewDoc', $elm$json$Json$Decode$value);
var $author$project$Subscriptions$subscriptions = function (model) {
	var _v0 = model.sessionModel;
	switch (_v0.$) {
		case 'Auth':
			var authModel = _v0.a;
			return $elm$core$Platform$Sub$batch(
				_List_fromArray(
					[
						$author$project$Data$PDF$Port$receiveDocumentLoaded(
						A2(
							$elm$core$Basics$composeL,
							A2(
								$elm$core$Basics$composeL,
								A2($elm$core$Basics$composeL, $author$project$Types$OnViewDoc, $author$project$Type$ViewDocument$OnAuth),
								$author$project$Type$ViewDocument$OnLoaded),
							$author$project$Type$ViewDocument$OnReceiveDocumentLoaded)),
						$author$project$Data$PDF$Port$receiveSelectedAnnotsData(
						A2(
							$elm$core$Basics$composeL,
							A2(
								$elm$core$Basics$composeL,
								A2($elm$core$Basics$composeL, $author$project$Types$OnViewDoc, $author$project$Type$ViewDocument$OnAuth),
								$author$project$Type$ViewDocument$OnLoaded),
							$author$project$Type$ViewDocument$OnReceiveSelectedAnnotsData)),
						$author$project$Data$PDF$Port$receiveCheckboxClickData(
						A2(
							$elm$core$Basics$composeL,
							A2(
								$elm$core$Basics$composeL,
								A2($elm$core$Basics$composeL, $author$project$Types$OnViewDoc, $author$project$Type$ViewDocument$OnAuth),
								$author$project$Type$ViewDocument$OnLoaded),
							$author$project$Type$ViewDocument$OnReceiveCheckboxClickData)),
						$author$project$Data$PDF$Port$receiveDocumentLoadEncryptionError(
						A2(
							$elm$core$Basics$composeL,
							A2(
								$elm$core$Basics$composeL,
								A2($elm$core$Basics$composeL, $author$project$Types$OnViewDoc, $author$project$Type$ViewDocument$OnAuth),
								$author$project$Type$ViewDocument$OnLoaded),
							$author$project$Type$ViewDocument$OnReceiveEncryptionError)),
						$author$project$Data$PDF$Port$receiveTemplateLoadEncryptionError(
						A2(
							$elm$core$Basics$composeL,
							A2(
								$elm$core$Basics$composeL,
								A2($elm$core$Basics$composeL, $author$project$Types$OnFillTemplate, $author$project$Type$FillTemplate$OnAuth),
								$author$project$Type$FillTemplate$OnLoaded),
							$author$project$Type$FillTemplate$OnReceiveEncryptionError)),
						$author$project$Data$PDF$Port$receiveTemplateLoadNewEncryptionError(
						A2(
							$elm$core$Basics$composeL,
							A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnCreateTemplate),
							$author$project$Type$CreateTemplate$OnReceiveEncryptionError)),
						$author$project$Data$PDF$Port$receiveMultipleDocumentClickAnnotData(
						A2(
							$elm$core$Basics$composeL,
							A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnMultipleDocUpload),
							$author$project$Type$UploadMultipleDocument$OnReceiveClickAnnotData)),
						$author$project$Data$PDF$Port$receiveTemplateClickAnnotData(
						A2(
							$elm$core$Basics$composeL,
							A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnCreateTemplate),
							$author$project$Type$CreateTemplate$OnReceiveClickAnnotData)),
						$author$project$Data$PDF$Port$receiveMultipleDocumentAnnotData(
						A2(
							$elm$core$Basics$composeL,
							A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnMultipleDocUpload),
							$author$project$Type$UploadMultipleDocument$OnReceiveModifiedAnnotData)),
						$author$project$Data$PDF$Port$receiveTemplateAnnotData(
						A2(
							$elm$core$Basics$composeL,
							A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnCreateTemplate),
							$author$project$Type$CreateTemplate$OnReceiveModifiedAnnotData)),
						$author$project$Data$PDF$Port$receiveMultipleDocumentDeleteAnnotData(
						A2(
							$elm$core$Basics$composeL,
							A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnMultipleDocUpload),
							$author$project$Type$UploadMultipleDocument$OnReceiveDeleteAnnotsData)),
						$author$project$Data$PDF$Port$receiveExportedPDF(
						A2(
							$elm$core$Basics$composeL,
							A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnMultipleDocUpload),
							$author$project$Type$UploadMultipleDocument$OnCompletedOfficeConversion)),
						$author$project$Data$PDF$Port$receiveTemplateDeleteAnnotData(
						A2(
							$elm$core$Basics$composeL,
							A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnCreateTemplate),
							$author$project$Type$CreateTemplate$OnReceiveDeleteAnnotsData)),
						$author$project$Model$Signature$sendSignatureData(
						A2($elm$core$Basics$composeL, $author$project$Types$OnSignature, $author$project$Type$Signature$NewSignature)),
						$author$project$Model$Signature$sendTextSignatureData(
						A2($elm$core$Basics$composeL, $author$project$Types$OnSignature, $author$project$Type$Signature$OnTextExtraction)),
						A3(
						$author$project$Data$SSE$listen,
						$author$project$Data$Domain$selected(authModel.user.domains),
						authModel.user.jwt,
						A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnServerEvent)),
						$author$project$Subscriptions$imageEditorSub(model.sessionModel),
						$author$project$Model$BusinessCreate$receiveStripeErrorCreateBusiness(
						A2(
							$elm$core$Basics$composeL,
							A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnBusinessCreate),
							$author$project$Type$BusinessCreate$OnRedirectError)),
						$author$project$Model$UploadMultipleDocument$triggerMultipleDocDebounce(
						A2(
							$elm$core$Basics$composeL,
							A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnMultipleDocUpload),
							$author$project$Type$UploadMultipleDocument$OnSearchDebounce)),
						$author$project$Model$UploadMultipleDocument$multipleDocTriggerBlur(
						A2(
							$elm$core$Basics$composeL,
							A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnMultipleDocUpload),
							$author$project$Type$UploadMultipleDocument$OnSearchFieldBlur)),
						$author$project$Model$FillTemplate$triggerFillTemplateDebounce(
						A2(
							$elm$core$Basics$composeL,
							A2(
								$elm$core$Basics$composeL,
								A2($elm$core$Basics$composeL, $author$project$Types$OnFillTemplate, $author$project$Type$FillTemplate$OnAuth),
								$author$project$Type$FillTemplate$OnLoaded),
							$author$project$Type$FillTemplate$OnSearchDebounce)),
						$author$project$Model$FillTemplate$fillTemplateTriggerBlur(
						A2(
							$elm$core$Basics$composeL,
							A2(
								$elm$core$Basics$composeL,
								A2($elm$core$Basics$composeL, $author$project$Types$OnFillTemplate, $author$project$Type$FillTemplate$OnAuth),
								$author$project$Type$FillTemplate$OnLoaded),
							$author$project$Type$FillTemplate$OnSearchFieldBlur)),
						$author$project$Model$CreateTemplate$triggerCreateTemplateDebounce(
						A2(
							$elm$core$Basics$composeL,
							A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnCreateTemplate),
							$author$project$Type$CreateTemplate$OnSearchDebounce)),
						$author$project$Model$CreateTemplate$createTemplateTriggerBlur(
						A2(
							$elm$core$Basics$composeL,
							A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnCreateTemplate),
							$author$project$Type$CreateTemplate$OnSearchFieldBlur)),
						$author$project$Data$PDF$Port$returnConvertedPDFTemplate(
						A2(
							$elm$core$Basics$composeL,
							A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnCreateTemplate),
							$author$project$Type$CreateTemplate$OnCompletedOfficeConversion)),
						$author$project$Data$PDF$Port$returnMultipleDocLoadedMsg(
						A2(
							$elm$core$Basics$composeL,
							A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnMultipleDocUpload),
							$author$project$Type$UploadMultipleDocument$OnDocLoaded)),
						$author$project$Data$PDF$Port$returnNonEditableDocError(
						A2(
							$elm$core$Basics$composeL,
							A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnMultipleDocUpload),
							$author$project$Type$UploadMultipleDocument$OnUneditableDoc)),
						$author$project$Data$PDF$Port$returnRotationAlert(
						A2(
							$elm$core$Basics$composeL,
							A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnMultipleDocUpload),
							$author$project$Type$UploadMultipleDocument$OnPDFRotationAlert)),
						$author$project$Data$PDF$Port$returnTemplateLoadedMsg(
						A2(
							$elm$core$Basics$composeL,
							A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnCreateTemplate),
							$author$project$Type$CreateTemplate$OnDocLoaded)),
						$author$project$Model$TokenManagement$sendWalletAddress(
						A2(
							$elm$core$Basics$composeL,
							A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnTokenManagement),
							$author$project$Type$TokenManagement$OnExternalWalletAddress)),
						$author$project$Model$TokenManagement$sendWalletError(
						A2(
							$elm$core$Basics$composeL,
							A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnTokenManagement),
							$author$project$Type$TokenManagement$OnExternalWalletError)),
						$author$project$Data$JsonReader$returnJsonFileData(
						A2(
							$elm$core$Basics$composeL,
							A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnVerifyDocument),
							$author$project$Type$VerifyDocument$OnVerifySubmit)),
						$author$project$Model$ViewDocument$sendAlgorandWalletErrorViewDocRoute(
						A2(
							$elm$core$Basics$composeL,
							A2(
								$elm$core$Basics$composeL,
								A2($elm$core$Basics$composeL, $author$project$Types$OnViewDoc, $author$project$Type$ViewDocument$OnAuth),
								$author$project$Type$ViewDocument$OnLoaded),
							$author$project$Type$ViewDocument$AlgorandWalletError)),
						$author$project$Model$ViewDocument$sendAlgorandWalletAddressesViewDocRoute(
						A2(
							$elm$core$Basics$composeL,
							A2(
								$elm$core$Basics$composeL,
								A2($elm$core$Basics$composeL, $author$project$Types$OnViewDoc, $author$project$Type$ViewDocument$OnAuth),
								$author$project$Type$ViewDocument$OnLoaded),
							$author$project$Type$ViewDocument$OnGetAlgorandWalletAddress)),
						$author$project$Model$ViewDocument$sendOptInErrorViewDocRoute(
						A2(
							$elm$core$Basics$composeL,
							A2(
								$elm$core$Basics$composeL,
								A2($elm$core$Basics$composeL, $author$project$Types$OnViewDoc, $author$project$Type$ViewDocument$OnAuth),
								$author$project$Type$ViewDocument$OnLoaded),
							$author$project$Type$ViewDocument$OptInError)),
						$author$project$Model$ViewDocument$sendOptInResultViewDocRoute(
						A2(
							$elm$core$Basics$composeL,
							A2(
								$elm$core$Basics$composeL,
								A2($elm$core$Basics$composeL, $author$project$Types$OnViewDoc, $author$project$Type$ViewDocument$OnAuth),
								$author$project$Type$ViewDocument$OnLoaded),
							$author$project$Type$ViewDocument$GetOptInDetails)),
						$author$project$Model$ViewDocument$sendNotarisationDetailsViewDocRoute(
						A2(
							$elm$core$Basics$composeL,
							A2(
								$elm$core$Basics$composeL,
								A2($elm$core$Basics$composeL, $author$project$Types$OnViewDoc, $author$project$Type$ViewDocument$OnAuth),
								$author$project$Type$ViewDocument$OnLoaded),
							$author$project$Type$ViewDocument$SendNotarisationDetails)),
						$author$project$Model$ViewDocument$sendPaymentTransactionErrorViewDocRoute(
						A2(
							$elm$core$Basics$composeL,
							A2(
								$elm$core$Basics$composeL,
								A2($elm$core$Basics$composeL, $author$project$Types$OnViewDoc, $author$project$Type$ViewDocument$OnAuth),
								$author$project$Type$ViewDocument$OnLoaded),
							$author$project$Type$ViewDocument$PaymentTransactionError)),
						$author$project$Model$UploadMultipleDocument$sendAlgorandWalletAddressesUploadRoute(
						A2(
							$elm$core$Basics$composeL,
							A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnMultipleDocUpload),
							$author$project$Type$UploadMultipleDocument$GetAlgorandWalletAddress)),
						$author$project$Model$UploadMultipleDocument$sendAlgorandWalletErrorUploadRoute(
						A2(
							$elm$core$Basics$composeL,
							A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnMultipleDocUpload),
							$author$project$Type$UploadMultipleDocument$AlgorandWalletError)),
						$author$project$Model$UploadMultipleDocument$sendOptInErrorUploadRoute(
						A2(
							$elm$core$Basics$composeL,
							A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnMultipleDocUpload),
							$author$project$Type$UploadMultipleDocument$OptInError)),
						$author$project$Model$UploadMultipleDocument$sendOptInResultUploadRoute(
						A2(
							$elm$core$Basics$composeL,
							A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnMultipleDocUpload),
							$author$project$Type$UploadMultipleDocument$GetOptInDetails)),
						$author$project$Model$UploadMultipleDocument$sendPaymentTransactionErrorUploadRoute(
						A2(
							$elm$core$Basics$composeL,
							A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnMultipleDocUpload),
							$author$project$Type$UploadMultipleDocument$PaymentTransactionError)),
						$author$project$Model$UploadMultipleDocument$sendNotarisationDetailsUploadRoute(
						A2(
							$elm$core$Basics$composeL,
							A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnMultipleDocUpload),
							$author$project$Type$UploadMultipleDocument$SendNotarisationDetails)),
						$author$project$Model$TokenManagement$sendAlgorandWalletErrorTokenManagementRoute(
						A2(
							$elm$core$Basics$composeL,
							A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnTokenManagement),
							$author$project$Type$TokenManagement$OnAlgorandWalletError)),
						$author$project$Model$TokenManagement$sendAlgorandWalletAddressTokenManagementRoute(
						A2(
							$elm$core$Basics$composeL,
							A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnTokenManagement),
							$author$project$Type$TokenManagement$OnGetAlgorandWalletAddress)),
						$author$project$Model$TokenManagement$sendWalletConnectAddresses(
						A2(
							$elm$core$Basics$composeL,
							A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnTokenManagement),
							$author$project$Type$TokenManagement$OnReceiveWalletConnetAddresses)),
						$author$project$Model$TokenManagement$walletConnectOptInCompleted(
						A2(
							$elm$core$Basics$composeL,
							A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnTokenManagement),
							$author$project$Type$TokenManagement$OnWalletConnectOptInCompleted)),
						$author$project$Model$TokenManagement$returnWalletAmount(
						A2(
							$elm$core$Basics$composeL,
							A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnTokenManagement),
							$author$project$Type$TokenManagement$OnReceiveWalletConnetAmount)),
						$author$project$Model$TokenManagement$restartWalletConnect(
						A2(
							$elm$core$Basics$composeL,
							A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnTokenManagement),
							$author$project$Type$TokenManagement$OnRestartWalletConnect)),
						$author$project$Model$ViewDocument$sendWalletConnectAddressesViewDoc(
						A2(
							$elm$core$Basics$composeL,
							A2(
								$elm$core$Basics$composeL,
								A2($elm$core$Basics$composeL, $author$project$Types$OnViewDoc, $author$project$Type$ViewDocument$OnAuth),
								$author$project$Type$ViewDocument$OnLoaded),
							$author$project$Type$ViewDocument$OnWalletConnectAddressesReceive)),
						$author$project$Model$ViewDocument$walletConnectOptInCompletedViewDoc(
						A2(
							$elm$core$Basics$composeL,
							A2(
								$elm$core$Basics$composeL,
								A2($elm$core$Basics$composeL, $author$project$Types$OnViewDoc, $author$project$Type$ViewDocument$OnAuth),
								$author$project$Type$ViewDocument$OnLoaded),
							$author$project$Type$ViewDocument$OnWalletConnectOptInCompleted)),
						$author$project$Model$ViewDocument$walletConnectNotarizationCompleted(
						A2(
							$elm$core$Basics$composeL,
							A2(
								$elm$core$Basics$composeL,
								A2($elm$core$Basics$composeL, $author$project$Types$OnViewDoc, $author$project$Type$ViewDocument$OnAuth),
								$author$project$Type$ViewDocument$OnLoaded),
							$author$project$Type$ViewDocument$OnWalletConnectNotarizationCompleted)),
						$author$project$Model$ViewDocument$restartWalletConnectViewDoc(
						A2(
							$elm$core$Basics$composeL,
							A2(
								$elm$core$Basics$composeL,
								A2($elm$core$Basics$composeL, $author$project$Types$OnViewDoc, $author$project$Type$ViewDocument$OnAuth),
								$author$project$Type$ViewDocument$OnLoaded),
							$author$project$Type$ViewDocument$OnRestartWalletConnectInit)),
						$author$project$Model$ViewDocument$restartWalletConnectNotarization(
						A2(
							$elm$core$Basics$composeL,
							A2(
								$elm$core$Basics$composeL,
								A2($elm$core$Basics$composeL, $author$project$Types$OnViewDoc, $author$project$Type$ViewDocument$OnAuth),
								$author$project$Type$ViewDocument$OnLoaded),
							$author$project$Type$ViewDocument$OnRestartWalletConnectNotarization)),
						$author$project$Model$ViewDocument$walletConnectErrorViewDoc(
						A2(
							$elm$core$Basics$composeL,
							A2(
								$elm$core$Basics$composeL,
								A2($elm$core$Basics$composeL, $author$project$Types$OnViewDoc, $author$project$Type$ViewDocument$OnAuth),
								$author$project$Type$ViewDocument$OnLoaded),
							$author$project$Type$ViewDocument$OnWalletConnectError)),
						$author$project$Model$ViewDocument$sendOptInStatusViewDocRoute(
						A2(
							$elm$core$Basics$composeL,
							A2(
								$elm$core$Basics$composeL,
								A2($elm$core$Basics$composeL, $author$project$Types$OnViewDoc, $author$project$Type$ViewDocument$OnAuth),
								$author$project$Type$ViewDocument$OnLoaded),
							$author$project$Type$ViewDocument$OptInStatusResult)),
						$author$project$Model$UploadMultipleDocument$sendOptInStatusUploadRoute(
						A2(
							$elm$core$Basics$composeL,
							A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnMultipleDocUpload),
							$author$project$Type$UploadMultipleDocument$OptInStatusResult)),
						$author$project$Model$UploadMultipleDocument$notarizationSendUploadDocStart(
						A2(
							$elm$core$Basics$composeL,
							A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnMultipleDocUpload),
							$author$project$Type$UploadMultipleDocument$OnWalletConnectStart)),
						$author$project$Model$UploadMultipleDocument$walletConnectOptInCompletedUploadDoc(
						A2(
							$elm$core$Basics$composeL,
							A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnMultipleDocUpload),
							$author$project$Type$UploadMultipleDocument$OnWalletConnectWalletOptInCompleted)),
						$author$project$Model$UploadMultipleDocument$sendWalletConnectAddressesUploadDoc(
						A2(
							$elm$core$Basics$composeL,
							A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnMultipleDocUpload),
							$author$project$Type$UploadMultipleDocument$OnWalletConnectWalletRecieve)),
						$author$project$Model$UploadMultipleDocument$optInUploadDocStart(
						A2(
							$elm$core$Basics$composeL,
							A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnMultipleDocUpload),
							$author$project$Type$UploadMultipleDocument$OnOptInStart)),
						$author$project$Model$ViewDocument$notarizationSendViewDocStart(
						A2(
							$elm$core$Basics$composeL,
							A2(
								$elm$core$Basics$composeL,
								A2($elm$core$Basics$composeL, $author$project$Types$OnViewDoc, $author$project$Type$ViewDocument$OnAuth),
								$author$project$Type$ViewDocument$OnLoaded),
							$author$project$Type$ViewDocument$OnNotarizationStart)),
						$author$project$Model$FillTemplate$sendAlgorandWalletErrorFillTemplateRoute(
						A2(
							$elm$core$Basics$composeL,
							A2(
								$elm$core$Basics$composeL,
								A2($elm$core$Basics$composeL, $author$project$Types$OnFillTemplate, $author$project$Type$FillTemplate$OnAuth),
								$author$project$Type$FillTemplate$OnLoaded),
							$author$project$Type$FillTemplate$AlgorandWalletError)),
						$author$project$Model$FillTemplate$sendAlgorandWalletAddressesFillTemplateRoute(
						A2(
							$elm$core$Basics$composeL,
							A2(
								$elm$core$Basics$composeL,
								A2($elm$core$Basics$composeL, $author$project$Types$OnFillTemplate, $author$project$Type$FillTemplate$OnAuth),
								$author$project$Type$FillTemplate$OnLoaded),
							$author$project$Type$FillTemplate$GetAlgorandWalletAddress)),
						$author$project$Model$FillTemplate$sendOptInStatusFillTemplateRoute(
						A2(
							$elm$core$Basics$composeL,
							A2(
								$elm$core$Basics$composeL,
								A2($elm$core$Basics$composeL, $author$project$Types$OnFillTemplate, $author$project$Type$FillTemplate$OnAuth),
								$author$project$Type$FillTemplate$OnLoaded),
							$author$project$Type$FillTemplate$OptInStatusResult)),
						$author$project$Model$FillTemplate$sendOptInResultFillTemplateRoute(
						A2(
							$elm$core$Basics$composeL,
							A2(
								$elm$core$Basics$composeL,
								A2($elm$core$Basics$composeL, $author$project$Types$OnFillTemplate, $author$project$Type$FillTemplate$OnAuth),
								$author$project$Type$FillTemplate$OnLoaded),
							$author$project$Type$FillTemplate$GetOptInDetails)),
						$author$project$Model$FillTemplate$sendOptInErrorFillTemplateRoute(
						A2(
							$elm$core$Basics$composeL,
							A2(
								$elm$core$Basics$composeL,
								A2($elm$core$Basics$composeL, $author$project$Types$OnFillTemplate, $author$project$Type$FillTemplate$OnAuth),
								$author$project$Type$FillTemplate$OnLoaded),
							$author$project$Type$FillTemplate$OptInError)),
						$author$project$Model$FillTemplate$sendNotarisationDetailsFillTemplateRoute(
						A2(
							$elm$core$Basics$composeL,
							A2(
								$elm$core$Basics$composeL,
								A2($elm$core$Basics$composeL, $author$project$Types$OnFillTemplate, $author$project$Type$FillTemplate$OnAuth),
								$author$project$Type$FillTemplate$OnLoaded),
							$author$project$Type$FillTemplate$SendNotarisationDetails)),
						$author$project$Model$FillTemplate$sendPaymentTransactionErrorFillTemplateRoute(
						A2(
							$elm$core$Basics$composeL,
							A2(
								$elm$core$Basics$composeL,
								A2($elm$core$Basics$composeL, $author$project$Types$OnFillTemplate, $author$project$Type$FillTemplate$OnAuth),
								$author$project$Type$FillTemplate$OnLoaded),
							$author$project$Type$FillTemplate$PaymentTransactionError)),
						$author$project$Model$FillTemplate$sendWalletConnectAddressesFillTemplate(
						A2(
							$elm$core$Basics$composeL,
							A2(
								$elm$core$Basics$composeL,
								A2($elm$core$Basics$composeL, $author$project$Types$OnFillTemplate, $author$project$Type$FillTemplate$OnAuth),
								$author$project$Type$FillTemplate$OnLoaded),
							$author$project$Type$FillTemplate$OnWalletConnectWalletRecieve)),
						$author$project$Model$FillTemplate$optInFillTemplateStart(
						A2(
							$elm$core$Basics$composeL,
							A2(
								$elm$core$Basics$composeL,
								A2($elm$core$Basics$composeL, $author$project$Types$OnFillTemplate, $author$project$Type$FillTemplate$OnAuth),
								$author$project$Type$FillTemplate$OnLoaded),
							$author$project$Type$FillTemplate$OnOptInStart)),
						$author$project$Model$FillTemplate$walletConnectOptInCompletedFillTemplate(
						A2(
							$elm$core$Basics$composeL,
							A2(
								$elm$core$Basics$composeL,
								A2($elm$core$Basics$composeL, $author$project$Types$OnFillTemplate, $author$project$Type$FillTemplate$OnAuth),
								$author$project$Type$FillTemplate$OnLoaded),
							$author$project$Type$FillTemplate$OnWalletConnectWalletOptInCompleted)),
						$author$project$Model$FillTemplate$sendNotarisationPaymentFillTemplateRoute(
						A2(
							$elm$core$Basics$composeL,
							A2(
								$elm$core$Basics$composeL,
								A2($elm$core$Basics$composeL, $author$project$Types$OnFillTemplate, $author$project$Type$FillTemplate$OnAuth),
								$author$project$Type$FillTemplate$OnLoaded),
							$author$project$Type$FillTemplate$OnWalletConnectNotarizationCompleted)),
						$author$project$Model$FillTemplate$notarizationSendFillTemplateStart(
						A2(
							$elm$core$Basics$composeL,
							A2(
								$elm$core$Basics$composeL,
								A2($elm$core$Basics$composeL, $author$project$Types$OnFillTemplate, $author$project$Type$FillTemplate$OnAuth),
								$author$project$Type$FillTemplate$OnLoaded),
							$author$project$Type$FillTemplate$OnWalletConnectStart)),
						$author$project$Data$PDF$Port$receiveSelectedAnnotClickData(
						A2(
							$elm$core$Basics$composeL,
							A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnMultipleDocUpload),
							$author$project$Type$UploadMultipleDocument$OnReceiveSelectedAnnotClickData)),
						$author$project$Data$PDF$Port$receiveDeselecedAnnotClickData(
						A2(
							$elm$core$Basics$composeL,
							A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnMultipleDocUpload),
							$author$project$Type$UploadMultipleDocument$OnReceiveDeselectedClick)),
						$author$project$Data$PDF$Port$returnDeleteSelectedAnnotMsg(
						A2(
							$elm$core$Basics$composeL,
							A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnMultipleDocUpload),
							$author$project$Type$UploadMultipleDocument$OnReceiveDeleteSelectedAnnot)),
						$author$project$Data$PDF$Port$receiveSelectedTemplateAnnotClickData(
						A2(
							$elm$core$Basics$composeL,
							A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnCreateTemplate),
							$author$project$Type$CreateTemplate$OnReceiveSelectedTemplateAnnotClickData)),
						$author$project$Data$PDF$Port$receiveTemplateDeselecedAnnot(
						A2(
							$elm$core$Basics$composeL,
							A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnCreateTemplate),
							$author$project$Type$CreateTemplate$OnDeselectedTemplateAnnotData)),
						$author$project$Data$PDF$Port$returnDeleteSelectedTemplateAnnotMsg(
						A2(
							$elm$core$Basics$composeL,
							A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnCreateTemplate),
							$author$project$Type$CreateTemplate$OnReceiveDeleteSelectedAnnot)),
						$author$project$Data$PDF$Port$returnTemplatePDF(
						A2(
							$elm$core$Basics$composeL,
							A2(
								$elm$core$Basics$composeL,
								A2($elm$core$Basics$composeL, $author$project$Types$OnFillTemplate, $author$project$Type$FillTemplate$OnAuth),
								$author$project$Type$FillTemplate$OnLoaded),
							$author$project$Type$FillTemplate$OnReturnTemplatePDF)),
						$author$project$Model$ViewNotarisationInfo$returnFileChecksum(
						A2(
							$elm$core$Basics$composeL,
							A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnViewNotarisationInfo),
							$author$project$Type$ViewNotarisationInfo$OnVerifyChecksum)),
						$author$project$Data$PDF$Port$receiveUpdatedSignatureWidth(
						A2(
							$elm$core$Basics$composeL,
							A2(
								$elm$core$Basics$composeL,
								A2($elm$core$Basics$composeL, $author$project$Types$OnViewDoc, $author$project$Type$ViewDocument$OnAuth),
								$author$project$Type$ViewDocument$OnLoaded),
							$author$project$Type$ViewDocument$OnReceiveUpdatedSignatureWidth)),
						$author$project$Model$LanguageChange$sendLanguageData(
						A2(
							$elm$core$Basics$composeL,
							A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnLanguageChange),
							$author$project$Type$LanguageChange$OnReceiveLanguageData))
					]));
		case 'NoAuth':
			return $author$project$Model$BusinessRegister$receiveStripeError(
				A2($elm$core$Basics$composeL, $author$project$Types$OnBusinessRegister, $author$project$Type$BusinessRegister$OnRedirectError));
		case 'InvalidAuth':
			return $author$project$Model$BusinessRegister$receiveStripeError(
				A2($elm$core$Basics$composeL, $author$project$Types$OnBusinessRegister, $author$project$Type$BusinessRegister$OnRedirectError));
		default:
			return $elm$core$Platform$Sub$batch(
				_List_fromArray(
					[
						$author$project$Model$BusinessRegister$receiveStripeError(
						A2($elm$core$Basics$composeL, $author$project$Types$OnBusinessRegister, $author$project$Type$BusinessRegister$OnRedirectError)),
						$author$project$Model$Signature$sendSignatureData(
						A2($elm$core$Basics$composeL, $author$project$Types$OnSignature, $author$project$Type$Signature$NewSignature)),
						$author$project$Data$PDF$Port$receiveDocumentLoaded(
						A2(
							$elm$core$Basics$composeL,
							A2(
								$elm$core$Basics$composeL,
								A2($elm$core$Basics$composeL, $author$project$Types$OnViewDoc, $author$project$Type$ViewDocument$OnAuth),
								$author$project$Type$ViewDocument$OnLoaded),
							$author$project$Type$ViewDocument$OnReceiveDocumentLoaded)),
						$author$project$Data$PDF$Port$receiveUpdatedSignatureWidth(
						A2(
							$elm$core$Basics$composeL,
							A2(
								$elm$core$Basics$composeL,
								A2($elm$core$Basics$composeL, $author$project$Types$OnViewDoc, $author$project$Type$ViewDocument$OnAuth),
								$author$project$Type$ViewDocument$OnLoaded),
							$author$project$Type$ViewDocument$OnReceiveUpdatedSignatureWidth)),
						$author$project$Data$PDF$Port$receiveSelectedAnnotsData(
						A2(
							$elm$core$Basics$composeL,
							A2(
								$elm$core$Basics$composeL,
								A2($elm$core$Basics$composeL, $author$project$Types$OnViewDoc, $author$project$Type$ViewDocument$OnAuth),
								$author$project$Type$ViewDocument$OnLoaded),
							$author$project$Type$ViewDocument$OnReceiveSelectedAnnotsData)),
						$author$project$Data$PDF$Port$receiveCheckboxClickData(
						A2(
							$elm$core$Basics$composeL,
							A2(
								$elm$core$Basics$composeL,
								A2($elm$core$Basics$composeL, $author$project$Types$OnViewDoc, $author$project$Type$ViewDocument$OnAuth),
								$author$project$Type$ViewDocument$OnLoaded),
							$author$project$Type$ViewDocument$OnReceiveCheckboxClickData)),
						$author$project$Data$PDF$Port$receiveDocumentLoadEncryptionError(
						A2(
							$elm$core$Basics$composeL,
							A2(
								$elm$core$Basics$composeL,
								A2($elm$core$Basics$composeL, $author$project$Types$OnViewDoc, $author$project$Type$ViewDocument$OnAuth),
								$author$project$Type$ViewDocument$OnLoaded),
							$author$project$Type$ViewDocument$OnReceiveEncryptionError)),
						$author$project$Subscriptions$imageEditorSub(model.sessionModel),
						$author$project$Model$Signature$sendTextSignatureData(
						A2($elm$core$Basics$composeL, $author$project$Types$OnSignature, $author$project$Type$Signature$OnTextExtraction))
					]));
	}
};
var $author$project$Data$Route$InvalidJWTRoute = {$: 'InvalidJWTRoute'};
var $author$project$Data$SSE$closeServerEvents = _Platform_outgoingPort(
	'closeServerEvents',
	function ($) {
		return $elm$json$Json$Encode$null;
	});
var $author$project$Data$SSE$close = function (_v0) {
	return $author$project$Data$SSE$closeServerEvents(_Utils_Tuple0);
};
var $author$project$Data$User$deleteUser = _Platform_outgoingPort(
	'deleteUser',
	function ($) {
		return $elm$json$Json$Encode$null;
	});
var $author$project$Data$User$delete = function (_v0) {
	return $author$project$Data$User$deleteUser(_Utils_Tuple0);
};
var $author$project$Model$Logout$forceLogout = function (model) {
	return _Utils_Tuple2(
		_Utils_update(
			model,
			{route: $author$project$Data$Route$InvalidJWTRoute, sessionModel: $author$project$Types$NoAuth}),
		$elm$core$Platform$Cmd$batch(
			_List_fromArray(
				[
					$author$project$Data$User$delete(_Utils_Tuple0),
					$author$project$Data$SSE$close(_Utils_Tuple0)
				])));
};
var $author$project$Model$initAnonymousModel = F3(
	function (endpoint, themeModel, user) {
		var businessTheme = function () {
			var _v2 = A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.theme;
				},
				themeModel);
			if ((_v2.$ === 'Just') && (_v2.a.$ === 'Loaded')) {
				var theme = _v2.a.a;
				return theme;
			} else {
				return $author$project$Data$BusinessTheme$default;
			}
		}();
		var _v0 = A2($author$project$Model$Stamp$init, user, endpoint);
		var stampModel = _v0.a;
		var stampCmd = _v0.b;
		var _v1 = A2($author$project$Model$Signature$init, endpoint, user);
		var signatureModel = _v1.a;
		var signatureCmd = _v1.b;
		return _Utils_Tuple2(
			{
				businessThemeForm: $author$project$Model$BusinessTheme$init(businessTheme),
				fillTemplateModel: $author$project$Model$FillTemplate$init,
				signatureModel: signatureModel,
				stampModel: stampModel,
				user: user,
				viewDocModel: $author$project$Model$ViewDocument$init
			},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[signatureCmd, stampCmd])));
	});
var $author$project$Types$Noop = {$: 'Noop'};
var $author$project$Type$CreateTemplate$OnUnload = {$: 'OnUnload'};
var $author$project$Type$FillTemplate$OnUnload = {$: 'OnUnload'};
var $author$project$Type$UploadMultipleDocument$OnUnload = {$: 'OnUnload'};
var $author$project$Type$ViewDocument$OnUnload = {$: 'OnUnload'};
var $elm$browser$Browser$Dom$setViewport = _Browser_setViewport;
var $author$project$Model$Route$onUrlChange = F2(
	function (url, model) {
		var previousRoute = model.route;
		var nextRoute = function () {
			var _v14 = model.sessionModel;
			switch (_v14.$) {
				case 'Auth':
					var authModel = _v14.a;
					return A3(
						$author$project$Data$Route$getRoute,
						model.appDomain,
						$elm$core$Maybe$Just(authModel),
						url);
				case 'Anonymous':
					return A3($author$project$Data$Route$getRoute, model.appDomain, $elm$core$Maybe$Nothing, url);
				case 'NoAuth':
					return A3($author$project$Data$Route$getRoute, model.appDomain, $elm$core$Maybe$Nothing, url);
				default:
					return A3($author$project$Data$Route$getRoute, model.appDomain, $elm$core$Maybe$Nothing, url);
			}
		}();
		var _v0 = A5($author$project$Model$Route$calculate, model.apiEndPoint, model.appDomain, model.navKey, model.sessionModel, nextRoute);
		var finalRoute = _v0.a;
		var routeCmd = _v0.b;
		var cmdMsg = function () {
			_v1$5:
			while (true) {
				switch (previousRoute.$) {
					case 'Auth':
						switch (previousRoute.a.$) {
							case 'UploadMultipleDocRoute':
								var _v2 = previousRoute.a;
								return $elm$core$Platform$Cmd$batch(
									_List_fromArray(
										[
											routeCmd,
											A2(
											$elm$core$Task$perform,
											function (_v3) {
												return $author$project$Types$Noop;
											},
											A2($elm$browser$Browser$Dom$setViewport, 0, 0)),
											A2(
											$elm$core$Task$perform,
											$author$project$Types$OnAuth,
											$elm$core$Task$succeed(
												$author$project$Types$OnMultipleDocUpload($author$project$Type$UploadMultipleDocument$OnUnload)))
										]));
							case 'CreateTemplateRoute':
								var _v4 = previousRoute.a;
								return $elm$core$Platform$Cmd$batch(
									_List_fromArray(
										[
											routeCmd,
											A2(
											$elm$core$Task$perform,
											function (_v5) {
												return $author$project$Types$Noop;
											},
											A2($elm$browser$Browser$Dom$setViewport, 0, 0)),
											A2(
											$elm$core$Task$perform,
											$author$project$Types$OnAuth,
											$elm$core$Task$succeed(
												$author$project$Types$OnCreateTemplate($author$project$Type$CreateTemplate$OnUnload)))
										]));
							default:
								break _v1$5;
						}
					case 'PublicOrAuth':
						switch (previousRoute.a.$) {
							case 'FillTemplateRoute':
								return $elm$core$Platform$Cmd$batch(
									_List_fromArray(
										[
											routeCmd,
											A2(
											$elm$core$Task$perform,
											function (_v6) {
												return $author$project$Types$Noop;
											},
											A2($elm$browser$Browser$Dom$setViewport, 0, 0)),
											A2(
											$elm$core$Task$perform,
											$author$project$Types$OnFillTemplate,
											$elm$core$Task$succeed(
												$author$project$Type$FillTemplate$OnAuth($author$project$Type$FillTemplate$OnUnload)))
										]));
							case 'ViewTemplateRoute':
								return $elm$core$Platform$Cmd$batch(
									_List_fromArray(
										[
											routeCmd,
											A2(
											$elm$core$Task$perform,
											function (_v7) {
												return $author$project$Types$Noop;
											},
											A2($elm$browser$Browser$Dom$setViewport, 0, 0)),
											A2(
											$elm$core$Task$perform,
											$author$project$Types$OnFillTemplate,
											$elm$core$Task$succeed(
												$author$project$Type$FillTemplate$OnAuth($author$project$Type$FillTemplate$OnUnload)))
										]));
							case 'ViewDocumentRoute':
								var _v8 = model.sessionModel;
								switch (_v8.$) {
									case 'NoAuth':
										return $elm$core$Platform$Cmd$batch(
											_List_fromArray(
												[
													routeCmd,
													A2(
													$elm$core$Task$perform,
													function (_v9) {
														return $author$project$Types$Noop;
													},
													A2($elm$browser$Browser$Dom$setViewport, 0, 0))
												]));
									case 'InvalidAuth':
										return $elm$core$Platform$Cmd$batch(
											_List_fromArray(
												[
													routeCmd,
													A2(
													$elm$core$Task$perform,
													function (_v10) {
														return $author$project$Types$Noop;
													},
													A2($elm$browser$Browser$Dom$setViewport, 0, 0))
												]));
									case 'Anonymous':
										return $elm$core$Platform$Cmd$batch(
											_List_fromArray(
												[
													routeCmd,
													A2(
													$elm$core$Task$perform,
													$author$project$Types$OnViewDoc,
													$elm$core$Task$succeed(
														$author$project$Type$ViewDocument$OnAuth($author$project$Type$ViewDocument$OnUnload))),
													A2(
													$elm$core$Task$perform,
													function (_v11) {
														return $author$project$Types$Noop;
													},
													A2($elm$browser$Browser$Dom$setViewport, 0, 0))
												]));
									default:
										return $elm$core$Platform$Cmd$batch(
											_List_fromArray(
												[
													routeCmd,
													A2(
													$elm$core$Task$perform,
													$author$project$Types$OnViewDoc,
													$elm$core$Task$succeed(
														$author$project$Type$ViewDocument$OnAuth($author$project$Type$ViewDocument$OnUnload))),
													A2(
													$elm$core$Task$perform,
													function (_v12) {
														return $author$project$Types$Noop;
													},
													A2($elm$browser$Browser$Dom$setViewport, 0, 0))
												]));
								}
							default:
								break _v1$5;
						}
					default:
						break _v1$5;
				}
			}
			return $elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						routeCmd,
						A2(
						$elm$core$Task$perform,
						function (_v13) {
							return $author$project$Types$Noop;
						},
						A2($elm$browser$Browser$Dom$setViewport, 0, 0))
					]));
		}();
		return _Utils_eq(url.path, $author$project$Data$Route$routeUrl.fourZeroFour) ? _Utils_Tuple2(
			_Utils_update(
				model,
				{route: finalRoute}),
			$elm$core$Platform$Cmd$none) : _Utils_Tuple2(
			_Utils_update(
				model,
				{route: finalRoute}),
			cmdMsg);
	});
var $elm$browser$Browser$Navigation$load = _Browser_load;
var $elm$browser$Browser$Navigation$pushUrl = _Browser_pushUrl;
var $elm$url$Url$addPort = F2(
	function (maybePort, starter) {
		if (maybePort.$ === 'Nothing') {
			return starter;
		} else {
			var port_ = maybePort.a;
			return starter + (':' + $elm$core$String$fromInt(port_));
		}
	});
var $elm$url$Url$addPrefixed = F3(
	function (prefix, maybeSegment, starter) {
		if (maybeSegment.$ === 'Nothing') {
			return starter;
		} else {
			var segment = maybeSegment.a;
			return _Utils_ap(
				starter,
				_Utils_ap(prefix, segment));
		}
	});
var $elm$url$Url$toString = function (url) {
	var http = function () {
		var _v0 = url.protocol;
		if (_v0.$ === 'Http') {
			return 'http://';
		} else {
			return 'https://';
		}
	}();
	return A3(
		$elm$url$Url$addPrefixed,
		'#',
		url.fragment,
		A3(
			$elm$url$Url$addPrefixed,
			'?',
			url.query,
			_Utils_ap(
				A2(
					$elm$url$Url$addPort,
					url.port_,
					_Utils_ap(http, url.host)),
				url.path)));
};
var $author$project$Model$Route$onUrlRequest = F2(
	function (urlRequest, model) {
		if (urlRequest.$ === 'Internal') {
			var url = urlRequest.a;
			return _Utils_Tuple2(
				model,
				A2(
					$elm$browser$Browser$Navigation$pushUrl,
					model.navKey,
					$elm$url$Url$toString(url)));
		} else {
			var url = urlRequest.a;
			return _Utils_Tuple2(
				model,
				$elm$browser$Browser$Navigation$load(url));
		}
	});
var $author$project$Type$ActionButton$MenuOpen = {$: 'MenuOpen'};
var $author$project$Type$ActionButton$ModalOpen = function (a) {
	return {$: 'ModalOpen', a: a};
};
var $author$project$Model$ActionButton$update = F3(
	function (msg, authModel, model) {
		var _v0 = authModel;
		var actionButton = _v0.actionButton;
		var user = _v0.user;
		switch (msg.$) {
			case 'OpenMenu':
				var newAuth = _Utils_update(
					authModel,
					{
						actionButton: _Utils_update(
							actionButton,
							{status: $author$project$Type$ActionButton$MenuOpen})
					});
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							sessionModel: $author$project$Types$Auth(newAuth)
						}),
					$elm$core$Platform$Cmd$none);
			case 'OpenModal':
				var modalType = msg.a;
				var newAuthCloseActionButton = _Utils_update(
					authModel,
					{
						actionButton: _Utils_update(
							actionButton,
							{status: $author$project$Type$ActionButton$AllClose})
					});
				var newAuth = _Utils_update(
					authModel,
					{
						actionButton: _Utils_update(
							actionButton,
							{
								status: $author$project$Type$ActionButton$ModalOpen(modalType)
							})
					});
				if (modalType.$ === 'Document') {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								sessionModel: $author$project$Types$Auth(newAuth)
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								sessionModel: $author$project$Types$Auth(newAuthCloseActionButton)
							}),
						A2($elm$browser$Browser$Navigation$pushUrl, model.navKey, $author$project$Data$Route$routeUrl.createTemplate));
				}
			case 'CloseAll':
				var newAuth = _Utils_update(
					authModel,
					{
						actionButton: _Utils_update(
							actionButton,
							{status: $author$project$Type$ActionButton$AllClose})
					});
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							sessionModel: $author$project$Types$Auth(newAuth)
						}),
					$elm$core$Platform$Cmd$none);
			case 'RedirectToDocPage':
				var newAuth = _Utils_update(
					authModel,
					{
						actionButton: _Utils_update(
							actionButton,
							{status: $author$project$Type$ActionButton$AllClose})
					});
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							sessionModel: $author$project$Types$Auth(newAuth)
						}),
					A2($elm$browser$Browser$Navigation$pushUrl, model.navKey, $author$project$Data$Route$routeUrl.completedDoc));
			default:
				var payload = msg.a;
				if (payload.$ === 'Ok') {
					var result = payload.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								sessionModel: $author$project$Types$Auth(
									_Utils_update(
										authModel,
										{
											actionButton: _Utils_update(
												actionButton,
												{templateQuota: result.templateQuota, templatesUsed: result.templateNumbers})
										}))
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
		}
	});
var $author$project$Type$Activate$ActivateResponse = function (a) {
	return {$: 'ActivateResponse', a: a};
};
var $author$project$Type$Activate$Error = function (a) {
	return {$: 'Error', a: a};
};
var $author$project$Type$Activate$RedirectToDashboard = F2(
	function (a, b) {
		return {$: 'RedirectToDashboard', a: a, b: b};
	});
var $author$project$Type$Activate$Success = function (a) {
	return {$: 'Success', a: a};
};
var $author$project$Data$Api$Activate$Payload = function (user) {
	return {user: user};
};
var $author$project$Data$User$decoderWithJwt = function (jwt) {
	return A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'showAds',
		$elm$json$Json$Decode$bool,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'notariseByDefault',
			$elm$json$Json$Decode$bool,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'algorandWalletAddress',
				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'paymentMethod',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'notarisationNetwork',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'updateNameConfirmation',
							$elm$json$Json$Decode$bool,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'shareReferralCode',
								$elm$json$Json$Decode$string,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'metaMaskWalletAddress',
									$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'eSignDisclaimerTimestamp',
										$elm$json$Json$Decode$nullable(
											A2($elm$json$Json$Decode$map, $elm$time$Time$millisToPosix, $elm$json$Json$Decode$int)),
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'eSignDisclaimer',
											$elm$json$Json$Decode$bool,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'avatarUrl',
												$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'trustScore',
													$author$project$Data$User$trustScoreDecoder,
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'notification',
														$author$project$Data$User$notificationDecoder,
														A2(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
															jwt,
															A3(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																'address',
																$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
																A3(
																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																	'dateOfBirth',
																	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
																	A3(
																		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																		'nationality',
																		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
																		A3(
																			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																			'phoneNumber',
																			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
																			A3(
																				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																				'identificationNumber',
																				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
																				A3(
																					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																					'updatedAt',
																					A2($elm$json$Json$Decode$map, $elm$time$Time$millisToPosix, $elm$json$Json$Decode$int),
																					A3(
																						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																						'createdAt',
																						A2($elm$json$Json$Decode$map, $elm$time$Time$millisToPosix, $elm$json$Json$Decode$int),
																						A3(
																							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																							'email',
																							$elm$json$Json$Decode$string,
																							A3(
																								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																								'lastName',
																								$elm$json$Json$Decode$string,
																								A3(
																									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																									'firstName',
																									$elm$json$Json$Decode$string,
																									A3(
																										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																										'domains',
																										$author$project$Data$Domain$domainListDecoder,
																										A3(
																											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																											'id',
																											$elm$json$Json$Decode$string,
																											$elm$json$Json$Decode$succeed($author$project$Data$User$User)))))))))))))))))))))))))));
};
var $author$project$Data$Api$Activate$dataDecoder = A2(
	$elm$json$Json$Decode$map,
	$author$project$Data$Api$Activate$Payload,
	A2(
		$elm$json$Json$Decode$andThen,
		function (jwt) {
			return A2(
				$elm$json$Json$Decode$field,
				'user',
				$author$project$Data$User$decoderWithJwt(jwt));
		},
		A2($elm$json$Json$Decode$field, 'jwt', $elm$json$Json$Decode$string)));
var $author$project$Data$Api$Activate$encode = function (token) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'token',
				$elm$json$Json$Encode$string(token))
			]));
};
var $author$project$Data$Api$Activate$INVALID_ACTIVATE_CODE = {$: 'INVALID_ACTIVATE_CODE'};
var $author$project$Data$Api$Activate$errorDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (errorCode) {
		if (errorCode === 'INVALID_ACTIVATE_CODE') {
			return $elm$json$Json$Decode$succeed($author$project$Data$Api$Activate$INVALID_ACTIVATE_CODE);
		} else {
			return $elm$json$Json$Decode$fail('Invalid error code: ' + errorCode);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Data$Api$Activate$call = F2(
	function (endPoint, token) {
		return A4(
			$author$project$Data$Api$httpTask,
			endPoint,
			$author$project$Data$Api$Activate$errorDecoder,
			$author$project$Data$Api$Activate$dataDecoder,
			$author$project$Data$Api$Activate$encode(token));
	});
var $elm$core$Process$sleep = _Process_sleep;
var $elm$json$Json$Encode$bool = _Json_wrap;
var $elm$json$Json$Encode$list = F2(
	function (func, entries) {
		return _Json_wrap(
			A3(
				$elm$core$List$foldl,
				_Json_addEntry(func),
				_Json_emptyArray(_Utils_Tuple0),
				entries));
	});
var $author$project$Data$Domain$encodeDomains = function (_v0) {
	var domain = _v0.a;
	var domains = _v0.b;
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'selected',
				$author$project$Data$Domain$encode(domain)),
				_Utils_Tuple2(
				'domains',
				A2($elm$json$Json$Encode$list, $author$project$Data$Domain$encode, domains))
			]));
};
var $elm$json$Json$Encode$int = _Json_wrap;
var $elm$time$Time$posixToMillis = function (_v0) {
	var millis = _v0.a;
	return millis;
};
var $author$project$Data$User$encoder = function (user) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'id',
				$elm$json$Json$Encode$string(user.id)),
				_Utils_Tuple2(
				'domains',
				$author$project$Data$Domain$encodeDomains(user.domains)),
				_Utils_Tuple2(
				'firstName',
				$elm$json$Json$Encode$string(user.firstName)),
				_Utils_Tuple2(
				'lastName',
				$elm$json$Json$Encode$string(user.lastName)),
				_Utils_Tuple2(
				'email',
				$elm$json$Json$Encode$string(user.email)),
				_Utils_Tuple2(
				'createdAt',
				$elm$json$Json$Encode$int(
					$elm$time$Time$posixToMillis(user.createdAt))),
				_Utils_Tuple2(
				'updatedAt',
				$elm$json$Json$Encode$int(
					$elm$time$Time$posixToMillis(user.updatedAt))),
				_Utils_Tuple2(
				'identificationNumber',
				A2(
					$elm$core$Maybe$withDefault,
					$elm$json$Json$Encode$null,
					A2($elm$core$Maybe$map, $elm$json$Json$Encode$string, user.identificationNumber))),
				_Utils_Tuple2(
				'phoneNumber',
				A2(
					$elm$core$Maybe$withDefault,
					$elm$json$Json$Encode$null,
					A2($elm$core$Maybe$map, $elm$json$Json$Encode$string, user.phoneNumber))),
				_Utils_Tuple2(
				'nationality',
				A2(
					$elm$core$Maybe$withDefault,
					$elm$json$Json$Encode$null,
					A2($elm$core$Maybe$map, $elm$json$Json$Encode$string, user.nationality))),
				_Utils_Tuple2(
				'dateOfBirth',
				A2(
					$elm$core$Maybe$withDefault,
					$elm$json$Json$Encode$null,
					A2($elm$core$Maybe$map, $elm$json$Json$Encode$string, user.dateOfBirth))),
				_Utils_Tuple2(
				'address',
				A2(
					$elm$core$Maybe$withDefault,
					$elm$json$Json$Encode$null,
					A2($elm$core$Maybe$map, $elm$json$Json$Encode$string, user.address))),
				_Utils_Tuple2(
				'jwt',
				$elm$json$Json$Encode$string(user.jwt)),
				_Utils_Tuple2(
				'notification',
				$elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'email',
							$elm$json$Json$Encode$bool(user.notification.email))
						]))),
				_Utils_Tuple2(
				'trustScore',
				$elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'passbase',
							$elm$json$Json$Encode$bool(user.trustScore.passbase)),
							_Utils_Tuple2(
							'shuftiPro',
							$elm$json$Json$Encode$bool(user.trustScore.shuftiPro)),
							_Utils_Tuple2(
							'myInfo',
							$elm$json$Json$Encode$bool(user.trustScore.myInfo)),
							_Utils_Tuple2(
							'corporate',
							$elm$json$Json$Encode$bool(user.trustScore.corporate)),
							_Utils_Tuple2(
							'stripe',
							$elm$json$Json$Encode$bool(user.trustScore.stripe)),
							_Utils_Tuple2(
							'mobilePhone',
							$elm$json$Json$Encode$bool(user.trustScore.mobilePhone)),
							_Utils_Tuple2(
							'wallet',
							$elm$json$Json$Encode$bool(user.trustScore.wallet))
						]))),
				_Utils_Tuple2(
				'avatarUrl',
				A2(
					$elm$core$Maybe$withDefault,
					$elm$json$Json$Encode$null,
					A2($elm$core$Maybe$map, $elm$json$Json$Encode$string, user.avatarUrl))),
				_Utils_Tuple2(
				'eSignDisclaimer',
				$elm$json$Json$Encode$bool(user.eSignDisclaimer)),
				_Utils_Tuple2(
				'eSignDisclaimerTimestamp',
				$elm$json$Json$Encode$int(
					$elm$time$Time$posixToMillis(
						A2(
							$elm$core$Maybe$withDefault,
							$elm$time$Time$millisToPosix(0),
							user.eSignDisclaimerTimestamp)))),
				_Utils_Tuple2(
				'metaMaskWalletAddress',
				A2(
					$elm$core$Maybe$withDefault,
					$elm$json$Json$Encode$null,
					A2($elm$core$Maybe$map, $elm$json$Json$Encode$string, user.metaMaskWalletAddress))),
				_Utils_Tuple2(
				'shareReferralCode',
				$elm$json$Json$Encode$string(user.shareReferralCode)),
				_Utils_Tuple2(
				'updateNameConfirmation',
				$elm$json$Json$Encode$bool(user.updateNameConfirmation)),
				_Utils_Tuple2(
				'notarisationNetwork',
				$elm$json$Json$Encode$string(user.notarisationNetwork)),
				_Utils_Tuple2(
				'paymentMethod',
				$elm$json$Json$Encode$string(user.paymentMethod)),
				_Utils_Tuple2(
				'algorandWalletAddress',
				A2(
					$elm$core$Maybe$withDefault,
					$elm$json$Json$Encode$null,
					A2($elm$core$Maybe$map, $elm$json$Json$Encode$string, user.algorandWalletAddress))),
				_Utils_Tuple2(
				'notariseByDefault',
				$elm$json$Json$Encode$bool(user.notariseByDefault)),
				_Utils_Tuple2(
				'showAds',
				$elm$json$Json$Encode$bool(user.showAds))
			]));
};
var $author$project$Data$User$storeUser = _Platform_outgoingPort('storeUser', $elm$json$Json$Encode$string);
var $author$project$Data$User$store = function (user) {
	return $author$project$Data$User$storeUser(
		A2(
			$elm$json$Json$Encode$encode,
			0,
			$author$project$Data$User$encoder(user)));
};
var $author$project$Model$Activate$update = F3(
	function (initAuthModel, msg, model) {
		var _v0 = model;
		var activateModel = _v0.activateModel;
		var _v1 = activateModel.token;
		if (_v1.$ === 'Nothing') {
			return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		} else {
			var token = _v1.a;
			switch (msg.$) {
				case 'OnEnter':
					return _Utils_Tuple2(
						model,
						A2(
							$elm$core$Task$attempt,
							A2($elm$core$Basics$composeL, $author$project$Types$OnActivate, $author$project$Type$Activate$ActivateResponse),
							A2($author$project$Data$Api$Activate$call, model.apiEndPoint.activate, token)));
				case 'ActivateResponse':
					var result = msg.a;
					if (result.$ === 'Ok') {
						var payload = result.a;
						var _v4 = payload;
						var user = _v4.user;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									activateModel: _Utils_update(
										activateModel,
										{
											status: $author$project$Type$Activate$Success(user.id)
										})
								}),
							A2(
								$elm$core$Task$perform,
								A2(
									$elm$core$Basics$composeL,
									$author$project$Types$OnActivate,
									$author$project$Type$Activate$RedirectToDashboard(user)),
								$elm$core$Process$sleep(3000)));
					} else {
						var error = result.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									activateModel: _Utils_update(
										activateModel,
										{
											status: $author$project$Type$Activate$Error(error)
										})
								}),
							$elm$core$Platform$Cmd$none);
					}
				default:
					var user = msg.a;
					var _v5 = model;
					var loginModel = _v5.loginModel;
					var _v6 = initAuthModel(
						_Utils_update(
							user,
							{
								domains: A2($author$project$Data$Domain$select, model.domainHost, user.domains)
							}));
					var authModel = _v6.a;
					var authCmdMsg = _v6.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								sessionModel: $author$project$Types$Auth(authModel)
							}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									$author$project$Data$User$store(user),
									authCmdMsg,
									A2($elm$browser$Browser$Navigation$pushUrl, model.navKey, $author$project$Data$Route$routeUrl.dashboard)
								])));
			}
		}
	});
var $author$project$Type$AddressBook$AddFriend = function (a) {
	return {$: 'AddFriend', a: a};
};
var $author$project$Type$AddressBook$AllClose = {$: 'AllClose'};
var $author$project$Type$AddressBook$Closed = {$: 'Closed'};
var $author$project$Type$AddressBook$Hover = F2(
	function (a, b) {
		return {$: 'Hover', a: a, b: b};
	});
var $author$project$Type$AddressBook$Loaded = function (a) {
	return {$: 'Loaded', a: a};
};
var $author$project$Type$AddressBook$Loading = {$: 'Loading'};
var $author$project$Type$AddressBook$NoHover = {$: 'NoHover'};
var $author$project$Type$AddressBook$Open = {$: 'Open'};
var $author$project$Type$AddressBook$AcceptResponse = F2(
	function (a, b) {
		return {$: 'AcceptResponse', a: a, b: b};
	});
var $author$project$Data$Api$AddressBook$Accept$Payload = function (message) {
	return {message: message};
};
var $author$project$Data$Api$AddressBook$Accept$dataDecoder = A2(
	$elm$json$Json$Decode$map,
	$author$project$Data$Api$AddressBook$Accept$Payload,
	A2($elm$json$Json$Decode$field, 'message', $elm$json$Json$Decode$string));
var $author$project$Data$Api$AddressBook$Accept$encode = function (email) {
	var formattedEmail = $elm$core$String$toLower(
		$elm$core$String$trim(email));
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'friend',
				$elm$json$Json$Encode$string(formattedEmail))
			]));
};
var $author$project$Data$Api$AddressBook$Accept$INVALID_EMAIL = {$: 'INVALID_EMAIL'};
var $author$project$Data$Api$AddressBook$Accept$INVALID_USER = {$: 'INVALID_USER'};
var $author$project$Data$Api$AddressBook$Accept$SAME_EMAIL = {$: 'SAME_EMAIL'};
var $author$project$Data$Api$AddressBook$Accept$errorDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (errorCode) {
		switch (errorCode) {
			case 'INVALID_EMAIL':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$AddressBook$Accept$INVALID_EMAIL);
			case 'SAME_EMAIL':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$AddressBook$Accept$SAME_EMAIL);
			case 'INVALID_USER':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$AddressBook$Accept$INVALID_USER);
			default:
				return $elm$json$Json$Decode$fail('Invalid error code: ' + errorCode);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Data$Api$AddressBook$Accept$authCall = F3(
	function (jwt, endPoint, email) {
		return A5(
			$author$project$Data$Api$authCall,
			jwt,
			endPoint,
			$author$project$Data$Api$AddressBook$Accept$errorDecoder,
			$author$project$Data$Api$AddressBook$Accept$dataDecoder,
			$author$project$Data$Api$AddressBook$Accept$encode(email));
	});
var $author$project$Model$AddressBook$acceptCmd = F3(
	function (endpoint, user, contact) {
		return A2(
			$elm$core$Task$attempt,
			A2(
				$elm$core$Basics$composeL,
				A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnAddressBook),
				$author$project$Type$AddressBook$AcceptResponse(contact)),
			A3($author$project$Data$Api$AddressBook$Accept$authCall, user.jwt, endpoint, contact.friend));
	});
var $author$project$Data$Api$errorToString = F2(
	function (customErrorToString, error) {
		switch (error.$) {
			case 'BadUrl':
				var url = error.a;
				return 'Url ' + (url + ' is malformed.');
			case 'Timeout':
				return 'Connection timeout. Please try again.';
			case 'NetworkError':
				return 'There is a network error. Please try again.';
			case 'BadStatus':
				var metadata = error.a;
				var info = error.b;
				return 'Network error: ' + ($elm$core$String$fromInt(metadata.statusCode) + (' (' + (info + ')')));
			case 'ServerInternalError':
				return 'An unknown error has occurred. Please try again.';
			case 'NonStandardApiError':
				var decoderErrorString = error.a;
				return 'Something failed here: ' + decoderErrorString;
			case 'DataDecodeError':
				var decoderErrorString = error.a;
				return 'Something went wrong here: ' + decoderErrorString;
			default:
				var customError = error.a;
				return customErrorToString(customError);
		}
	});
var $author$project$Data$Api$authErrorToString = F2(
	function (customErrorToString, error) {
		if (error.$ === 'JWTError') {
			return 'Session has expired. Please sign in again.';
		} else {
			var apiError = error.a;
			return A2($author$project$Data$Api$errorToString, customErrorToString, apiError);
		}
	});
var $author$project$Data$AddressBook$Pending = {$: 'Pending'};
var $author$project$Data$AddressBook$createNewContact = F2(
	function (userEmail, friendEmail) {
		return {alias: $elm$core$Maybe$Nothing, friend: friendEmail, friendName: friendEmail, inviter: userEmail, status: $author$project$Data$AddressBook$Pending, user: userEmail, verifyMobilePhone: false, verifyMyInfo: false, verifyPassbase: false, verifyStripe: false, verifyWallet: false};
	});
var $author$project$Type$AddressBook$DeclineResponse = F2(
	function (a, b) {
		return {$: 'DeclineResponse', a: a, b: b};
	});
var $author$project$Data$Api$AddressBook$Decline$Payload = function (message) {
	return {message: message};
};
var $author$project$Data$Api$AddressBook$Decline$dataDecoder = A2(
	$elm$json$Json$Decode$map,
	$author$project$Data$Api$AddressBook$Decline$Payload,
	A2($elm$json$Json$Decode$field, 'message', $elm$json$Json$Decode$string));
var $author$project$Data$Api$AddressBook$Decline$encode = function (email) {
	var formattedEmail = $elm$core$String$toLower(
		$elm$core$String$trim(email));
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'friend',
				$elm$json$Json$Encode$string(formattedEmail))
			]));
};
var $author$project$Data$Api$AddressBook$Decline$INVALID_EMAIL = {$: 'INVALID_EMAIL'};
var $author$project$Data$Api$AddressBook$Decline$INVALID_USER = {$: 'INVALID_USER'};
var $author$project$Data$Api$AddressBook$Decline$errorDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (errorCode) {
		switch (errorCode) {
			case 'INVALID_EMAIL':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$AddressBook$Decline$INVALID_EMAIL);
			case 'INVALID_USER':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$AddressBook$Decline$INVALID_USER);
			default:
				return $elm$json$Json$Decode$fail('Invalid error code: ' + errorCode);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Data$Api$AddressBook$Decline$authCall = F3(
	function (jwt, endPoint, email) {
		return A5(
			$author$project$Data$Api$authCall,
			jwt,
			endPoint,
			$author$project$Data$Api$AddressBook$Decline$errorDecoder,
			$author$project$Data$Api$AddressBook$Decline$dataDecoder,
			$author$project$Data$Api$AddressBook$Decline$encode(email));
	});
var $author$project$Model$AddressBook$declineCmd = F3(
	function (endpoint, user, contact) {
		return A2(
			$elm$core$Task$attempt,
			A2(
				$elm$core$Basics$composeL,
				A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnAddressBook),
				$author$project$Type$AddressBook$DeclineResponse(contact)),
			A3($author$project$Data$Api$AddressBook$Decline$authCall, user.jwt, endpoint, contact.friend));
	});
var $author$project$Type$AddressBook$DeleteResponse = F2(
	function (a, b) {
		return {$: 'DeleteResponse', a: a, b: b};
	});
var $author$project$Data$Api$AddressBook$Delete$Payload = function (message) {
	return {message: message};
};
var $author$project$Data$Api$AddressBook$Delete$dataDecoder = A2(
	$elm$json$Json$Decode$map,
	$author$project$Data$Api$AddressBook$Delete$Payload,
	A2($elm$json$Json$Decode$field, 'message', $elm$json$Json$Decode$string));
var $author$project$Data$Api$AddressBook$Delete$encode = function (email) {
	var formattedEmail = $elm$core$String$toLower(
		$elm$core$String$trim(email));
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'friend',
				$elm$json$Json$Encode$string(formattedEmail))
			]));
};
var $author$project$Data$Api$AddressBook$Delete$INVALID_EMAIL = {$: 'INVALID_EMAIL'};
var $author$project$Data$Api$AddressBook$Delete$INVALID_USER = {$: 'INVALID_USER'};
var $author$project$Data$Api$AddressBook$Delete$errorDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (errorCode) {
		switch (errorCode) {
			case 'INVALID_EMAIL':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$AddressBook$Delete$INVALID_EMAIL);
			case 'INVALID_USER':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$AddressBook$Delete$INVALID_USER);
			default:
				return $elm$json$Json$Decode$fail('Invalid error code: ' + errorCode);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Data$Api$AddressBook$Delete$authCall = F3(
	function (jwt, endPoint, email) {
		return A5(
			$author$project$Data$Api$authCall,
			jwt,
			endPoint,
			$author$project$Data$Api$AddressBook$Delete$errorDecoder,
			$author$project$Data$Api$AddressBook$Delete$dataDecoder,
			$author$project$Data$Api$AddressBook$Delete$encode(email));
	});
var $author$project$Model$AddressBook$deleteCmd = F3(
	function (endpoint, user, contact) {
		return A2(
			$elm$core$Task$attempt,
			A2(
				$elm$core$Basics$composeL,
				A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnAddressBook),
				$author$project$Type$AddressBook$DeleteResponse(contact)),
			A3($author$project$Data$Api$AddressBook$Delete$authCall, user.jwt, endpoint, contact.friend));
	});
var $author$project$Type$AddressBook$EditResponse = F2(
	function (a, b) {
		return {$: 'EditResponse', a: a, b: b};
	});
var $author$project$Data$Api$AddressBook$Edit$Payload = function (message) {
	return {message: message};
};
var $author$project$Data$Api$AddressBook$Edit$dataDecoder = A2(
	$elm$json$Json$Decode$map,
	$author$project$Data$Api$AddressBook$Edit$Payload,
	A2($elm$json$Json$Decode$field, 'message', $elm$json$Json$Decode$string));
var $author$project$Data$Api$AddressBook$Edit$encode = F2(
	function (email, alias) {
		var newAlias = (alias === '') ? $elm$json$Json$Encode$null : $elm$json$Json$Encode$string(alias);
		var formattedEmail = $elm$core$String$toLower(
			$elm$core$String$trim(email));
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'friend',
					$elm$json$Json$Encode$string(formattedEmail)),
					_Utils_Tuple2('newFriendAlias', newAlias)
				]));
	});
var $author$project$Data$Api$AddressBook$Edit$INVALID_EMAIL = {$: 'INVALID_EMAIL'};
var $author$project$Data$Api$AddressBook$Edit$errorDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (errorCode) {
		if (errorCode === 'INVALID_EMAIL') {
			return $elm$json$Json$Decode$succeed($author$project$Data$Api$AddressBook$Edit$INVALID_EMAIL);
		} else {
			return $elm$json$Json$Decode$fail('Invalid error code: ' + errorCode);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Data$Api$AddressBook$Edit$authCall = F4(
	function (jwt, endPoint, email, alias) {
		return A5(
			$author$project$Data$Api$authCall,
			jwt,
			endPoint,
			$author$project$Data$Api$AddressBook$Edit$errorDecoder,
			$author$project$Data$Api$AddressBook$Edit$dataDecoder,
			A2($author$project$Data$Api$AddressBook$Edit$encode, email, alias));
	});
var $author$project$Model$AddressBook$editCmd = F4(
	function (endpoint, user, contact, newAlias) {
		return A2(
			$elm$core$Task$attempt,
			A2(
				$elm$core$Basics$composeL,
				A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnAddressBook),
				$author$project$Type$AddressBook$EditResponse(contact)),
			A4($author$project$Data$Api$AddressBook$Edit$authCall, user.jwt, endpoint, contact.friend, newAlias));
	});
var $author$project$Data$Api$AddressBook$Invite$errorToString = function (error) {
	if (error.$ === 'INVITE_EXIST') {
		return 'Invitation already exists.';
	} else {
		return 'Email format is incorrect.';
	}
};
var $elm$core$List$filter = F2(
	function (isGood, list) {
		return A3(
			$elm$core$List$foldr,
			F2(
				function (x, xs) {
					return isGood(x) ? A2($elm$core$List$cons, x, xs) : xs;
				}),
			_List_Nil,
			list);
	});
var $author$project$Model$AddressBook$filterAcceptedAddress = F2(
	function (contact, addressBookContacts) {
		return A2(
			$elm$core$List$filter,
			function (acceptedContact) {
				return !_Utils_eq(contact.friend, acceptedContact.data.friend);
			},
			addressBookContacts);
	});
var $author$project$Data$AddressBook$filterAddressBook = F2(
	function (contact, addressBookContacts) {
		return A2(
			$elm$core$List$filter,
			function (entry) {
				return !_Utils_eq(contact.friend, entry.friend);
			},
			addressBookContacts);
	});
var $author$project$Type$AddressBook$InviteResponse = function (a) {
	return {$: 'InviteResponse', a: a};
};
var $author$project$Data$Api$AddressBook$Invite$Payload = function (message) {
	return {message: message};
};
var $author$project$Data$Api$AddressBook$Invite$dataDecoder = A2(
	$elm$json$Json$Decode$map,
	$author$project$Data$Api$AddressBook$Invite$Payload,
	A2($elm$json$Json$Decode$field, 'message', $elm$json$Json$Decode$string));
var $author$project$Data$Api$AddressBook$Invite$encode = function (email) {
	var formattedEmail = $elm$core$String$toLower(
		$elm$core$String$trim(email));
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'friend',
				$elm$json$Json$Encode$string(formattedEmail))
			]));
};
var $author$project$Data$Api$AddressBook$Invite$INCORRECT_EMAIL_FORMAT = {$: 'INCORRECT_EMAIL_FORMAT'};
var $author$project$Data$Api$AddressBook$Invite$INVITE_EXIST = {$: 'INVITE_EXIST'};
var $author$project$Data$Api$AddressBook$Invite$errorDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (errorCode) {
		switch (errorCode) {
			case 'INVITE_EXIST':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$AddressBook$Invite$INVITE_EXIST);
			case 'INVALID_EMAIL':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$AddressBook$Invite$INCORRECT_EMAIL_FORMAT);
			default:
				return $elm$json$Json$Decode$fail('Invalid error code: ' + errorCode);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Data$Api$AddressBook$Invite$authCall = F3(
	function (jwt, endPoint, email) {
		return A5(
			$author$project$Data$Api$authCall,
			jwt,
			endPoint,
			$author$project$Data$Api$AddressBook$Invite$errorDecoder,
			$author$project$Data$Api$AddressBook$Invite$dataDecoder,
			$author$project$Data$Api$AddressBook$Invite$encode(email));
	});
var $author$project$Model$AddressBook$invitationCmd = F3(
	function (endpoint, user, friendEmail) {
		return A2(
			$elm$core$Task$attempt,
			A2(
				$elm$core$Basics$composeL,
				A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnAddressBook),
				$author$project$Type$AddressBook$InviteResponse),
			A3($author$project$Data$Api$AddressBook$Invite$authCall, user.jwt, endpoint, friendEmail));
	});
var $author$project$Type$AddressBook$ListResponse = function (a) {
	return {$: 'ListResponse', a: a};
};
var $author$project$Data$Api$AddressBook$List$Payload = F4(
	function (pendingContacts, acceptedContacts, numberOfPending, numberOfAccepted) {
		return {acceptedContacts: acceptedContacts, numberOfAccepted: numberOfAccepted, numberOfPending: numberOfPending, pendingContacts: pendingContacts};
	});
var $author$project$Data$AddressBook$AddressBook = function (user) {
	return function (friend) {
		return function (status) {
			return function (alias) {
				return function (inviter) {
					return function (friendName) {
						return function (verifyPassbase) {
							return function (verifyMyInfo) {
								return function (verifyMobilePhone) {
									return function (verifyStripe) {
										return function (verifyWallet) {
											return {alias: alias, friend: friend, friendName: friendName, inviter: inviter, status: status, user: user, verifyMobilePhone: verifyMobilePhone, verifyMyInfo: verifyMyInfo, verifyPassbase: verifyPassbase, verifyStripe: verifyStripe, verifyWallet: verifyWallet};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Data$AddressBook$Accept = {$: 'Accept'};
var $author$project$Data$AddressBook$Decline = {$: 'Decline'};
var $author$project$Data$Api$AddressBook$List$decodeStatus = A2(
	$elm$json$Json$Decode$andThen,
	function (status) {
		switch (status) {
			case 'accept':
				return $elm$json$Json$Decode$succeed($author$project$Data$AddressBook$Accept);
			case 'decline':
				return $elm$json$Json$Decode$succeed($author$project$Data$AddressBook$Decline);
			case 'pending':
				return $elm$json$Json$Decode$succeed($author$project$Data$AddressBook$Pending);
			default:
				return $elm$json$Json$Decode$fail('Invalid Status');
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Data$Api$AddressBook$List$decoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'verifyWallet',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'verifyStripe',
		$elm$json$Json$Decode$bool,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'verifyMobilePhone',
			$elm$json$Json$Decode$bool,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'verifyMyInfo',
				$elm$json$Json$Decode$bool,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'verifyPassbase',
					$elm$json$Json$Decode$bool,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'friendName',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'inviter',
							$elm$json$Json$Decode$string,
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'alias',
								$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
								$elm$core$Maybe$Nothing,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'status',
									$author$project$Data$Api$AddressBook$List$decodeStatus,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'friend',
										$elm$json$Json$Decode$string,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'user',
											$elm$json$Json$Decode$string,
											$elm$json$Json$Decode$succeed($author$project$Data$AddressBook$AddressBook))))))))))));
var $author$project$Data$Api$AddressBook$List$dataDecoder = A5(
	$elm$json$Json$Decode$map4,
	$author$project$Data$Api$AddressBook$List$Payload,
	A2(
		$elm$json$Json$Decode$field,
		'pendingContacts',
		$elm$json$Json$Decode$list($author$project$Data$Api$AddressBook$List$decoder)),
	A2(
		$elm$json$Json$Decode$field,
		'acceptedContacts',
		$elm$json$Json$Decode$list($author$project$Data$Api$AddressBook$List$decoder)),
	A2($elm$json$Json$Decode$field, 'numberOfPending', $elm$json$Json$Decode$int),
	A2($elm$json$Json$Decode$field, 'numberOfAccepted', $elm$json$Json$Decode$int));
var $author$project$Data$Api$AddressBook$List$encode = F4(
	function (pendingPage, pendingPageSize, acceptedPage, acceptedPageSize) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'pendingPage',
					$elm$json$Json$Encode$int(pendingPage)),
					_Utils_Tuple2(
					'pendingPageSize',
					$elm$json$Json$Encode$int(pendingPageSize)),
					_Utils_Tuple2(
					'acceptedPage',
					$elm$json$Json$Encode$int(acceptedPage)),
					_Utils_Tuple2(
					'acceptedPageSize',
					$elm$json$Json$Encode$int(acceptedPageSize))
				]));
	});
var $author$project$Data$Api$AddressBook$List$errorDecoder = $elm$json$Json$Decode$succeed(_Utils_Tuple0);
var $author$project$Data$Api$AddressBook$List$authCall = F6(
	function (jwt, endPoint, pendingPage, pendingPageSize, acceptedPage, acceptedPageSize) {
		return A5(
			$author$project$Data$Api$authCall,
			jwt,
			endPoint,
			$author$project$Data$Api$AddressBook$List$errorDecoder,
			$author$project$Data$Api$AddressBook$List$dataDecoder,
			A4($author$project$Data$Api$AddressBook$List$encode, pendingPage, pendingPageSize, acceptedPage, acceptedPageSize));
	});
var $author$project$Model$AddressBook$listCmd = F6(
	function (endpoint, user, pendingPage, pendingPageSize, acceptedPage, acceptedPageSize) {
		return A2(
			$elm$core$Task$attempt,
			A2(
				$elm$core$Basics$composeL,
				A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnAddressBook),
				$author$project$Type$AddressBook$ListResponse),
			A6($author$project$Data$Api$AddressBook$List$authCall, user.jwt, endpoint, pendingPage, pendingPageSize, acceptedPage, acceptedPageSize));
	});
var $elm$core$String$toFloat = _String_toFloat;
var $author$project$Model$AddressBook$updateIsOpen = F2(
	function (_v0, acceptedAddress) {
		var email = _v0.a;
		var isOpen = _v0.b;
		return _Utils_eq(email, acceptedAddress.data.friend) ? {data: acceptedAddress.data, expandStatus: isOpen, newAlias: acceptedAddress.newAlias} : acceptedAddress;
	});
var $elm$regex$Regex$Match = F4(
	function (match, index, number, submatches) {
		return {index: index, match: match, number: number, submatches: submatches};
	});
var $elm$regex$Regex$contains = _Regex_contains;
var $elm$regex$Regex$fromStringWith = _Regex_fromStringWith;
var $elm$regex$Regex$fromString = function (string) {
	return A2(
		$elm$regex$Regex$fromStringWith,
		{caseInsensitive: false, multiline: false},
		string);
};
var $elm$regex$Regex$never = _Regex_never;
var $author$project$Data$Validator$validateEmail = function (value) {
	return A2(
		$elm$regex$Regex$contains,
		A2(
			$elm$core$Maybe$withDefault,
			$elm$regex$Regex$never,
			$elm$regex$Regex$fromString('\\S+@\\S+\\.\\S+')),
		value) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just('Email is invalid.');
};
var $author$project$Model$AddressBook$updateAddressBook = F4(
	function (msg, addressBookModel, model, authModel) {
		if (addressBookModel.$ === 'LoadingModel') {
			switch (msg.$) {
				case 'ListResponse':
					var result = msg.a;
					var newAddressBookModel = {acceptedAddress: _List_Nil, acceptedPage: 0, acceptedPageSize: 10, modal: $author$project$Type$AddressBook$AllClose, newContactEmail: '', newContactEmailError: $elm$core$Maybe$Nothing, numberOfAccepted: 0, numberOfPending: 0, pendingAddress: _List_Nil, pendingPage: 0, pendingPageSize: 10, toolTip: $author$project$Type$AddressBook$NoHover};
					if (result.$ === 'Ok') {
						var responseResult = result.a;
						var formattedAccepted = A2(
							$elm$core$List$map,
							function (contact) {
								return {
									data: contact,
									expandStatus: $author$project$Type$AddressBook$Closed,
									newAlias: A2($elm$core$Maybe$withDefault, '', contact.alias)
								};
							},
							responseResult.acceptedContacts);
						return _Utils_Tuple2(
							$author$project$Type$AddressBook$Loaded(
								_Utils_update(
									newAddressBookModel,
									{acceptedAddress: formattedAccepted, numberOfAccepted: responseResult.numberOfAccepted, numberOfPending: responseResult.numberOfPending, pendingAddress: responseResult.pendingContacts, toolTip: $author$project$Type$AddressBook$NoHover})),
							$elm$core$Platform$Cmd$none);
					} else {
						return _Utils_Tuple2(
							$author$project$Type$AddressBook$Loaded(newAddressBookModel),
							$elm$core$Platform$Cmd$none);
					}
				case 'Refresh':
					return _Utils_Tuple2(
						$author$project$Type$AddressBook$LoadingModel,
						A6($author$project$Model$AddressBook$listCmd, model.apiEndPoint.addressBookList, authModel.user, 0, 10, 0, 10));
				default:
					return _Utils_Tuple2(addressBookModel, $elm$core$Platform$Cmd$none);
			}
		} else {
			var loadedModel = addressBookModel.a;
			switch (msg.$) {
				case 'OnExpandOrCollapse':
					var _v4 = msg.a;
					var id = _v4.a;
					var isOpen = _v4.b;
					var newContactList = A2(
						$elm$core$List$map,
						$author$project$Model$AddressBook$updateIsOpen(
							_Utils_Tuple2(id, isOpen)),
						loadedModel.acceptedAddress);
					return _Utils_Tuple2(
						$author$project$Type$AddressBook$Loaded(
							_Utils_update(
								loadedModel,
								{acceptedAddress: newContactList})),
						$elm$core$Platform$Cmd$none);
				case 'OnModalAction':
					var modal = msg.a;
					return _Utils_Tuple2(
						$author$project$Type$AddressBook$Loaded(
							_Utils_update(
								loadedModel,
								{modal: modal})),
						$elm$core$Platform$Cmd$none);
				case 'OnEmailInput':
					var newContactEmail = msg.a;
					return _Utils_Tuple2(
						$author$project$Type$AddressBook$Loaded(
							_Utils_update(
								loadedModel,
								{newContactEmail: newContactEmail, newContactEmailError: $elm$core$Maybe$Nothing})),
						$elm$core$Platform$Cmd$none);
				case 'OnSubmit':
					var emailError = _Utils_eq(loadedModel.newContactEmail, authModel.user.email) ? $elm$core$Maybe$Just('Your email cannot be added to the address book.') : (A2(
						$elm$core$List$any,
						function (address) {
							return _Utils_eq(address.data.friend, loadedModel.newContactEmail);
						},
						loadedModel.acceptedAddress) ? $elm$core$Maybe$Just('Invite already exists.') : $author$project$Data$Validator$validateEmail(loadedModel.newContactEmail));
					if (emailError.$ === 'Nothing') {
						return _Utils_Tuple2(
							$author$project$Type$AddressBook$Loaded(
								_Utils_update(
									loadedModel,
									{
										modal: $author$project$Type$AddressBook$AddFriend($author$project$Type$AddressBook$Loading)
									})),
							A3($author$project$Model$AddressBook$invitationCmd, model.apiEndPoint.addressBookInvite, authModel.user, loadedModel.newContactEmail));
					} else {
						var error = emailError.a;
						return _Utils_Tuple2(
							$author$project$Type$AddressBook$Loaded(
								_Utils_update(
									loadedModel,
									{
										newContactEmailError: $elm$core$Maybe$Just(error)
									})),
							$elm$core$Platform$Cmd$none);
					}
				case 'InviteResponse':
					var result = msg.a;
					if (result.$ === 'Ok') {
						var newContact = A2(
							$author$project$Data$AddressBook$createNewContact,
							authModel.user.email,
							$elm$core$String$toLower(
								$elm$core$String$trim(loadedModel.newContactEmail)));
						var newModel = A2(
							$elm$core$List$any,
							function (address) {
								return _Utils_eq(address.friend, loadedModel.newContactEmail);
							},
							loadedModel.pendingAddress) ? _Utils_update(
							loadedModel,
							{modal: $author$project$Type$AddressBook$AllClose, newContactEmail: ''}) : _Utils_update(
							loadedModel,
							{
								modal: $author$project$Type$AddressBook$AllClose,
								newContactEmail: '',
								pendingAddress: A2($elm$core$List$cons, newContact, loadedModel.pendingAddress)
							});
						return _Utils_Tuple2(
							$author$project$Type$AddressBook$Loaded(newModel),
							$elm$core$Platform$Cmd$none);
					} else {
						var error = result.a;
						return _Utils_Tuple2(
							$author$project$Type$AddressBook$Loaded(
								_Utils_update(
									loadedModel,
									{
										modal: $author$project$Type$AddressBook$AddFriend($author$project$Type$AddressBook$Open),
										newContactEmailError: $elm$core$Maybe$Just(
											A2($author$project$Data$Api$authErrorToString, $author$project$Data$Api$AddressBook$Invite$errorToString, error))
									})),
							$elm$core$Platform$Cmd$none);
					}
				case 'OnAccept':
					var contact = msg.a;
					return _Utils_Tuple2(
						addressBookModel,
						A3($author$project$Model$AddressBook$acceptCmd, model.apiEndPoint.addressBookAccept, authModel.user, contact));
				case 'AcceptResponse':
					var contact = msg.a;
					var result = msg.b;
					if (result.$ === 'Ok') {
						return _Utils_Tuple2(
							$author$project$Type$AddressBook$Loaded(
								_Utils_update(
									loadedModel,
									{
										acceptedAddress: A2(
											$elm$core$List$cons,
											{data: contact, expandStatus: $author$project$Type$AddressBook$Closed, newAlias: ''},
											loadedModel.acceptedAddress),
										pendingAddress: A2($author$project$Data$AddressBook$filterAddressBook, contact, loadedModel.pendingAddress)
									})),
							$elm$core$Platform$Cmd$none);
					} else {
						return _Utils_Tuple2(addressBookModel, $elm$core$Platform$Cmd$none);
					}
				case 'ListResponse':
					var result = msg.a;
					if (result.$ === 'Ok') {
						var responseResult = result.a;
						var formattedAccepted = A2(
							$elm$core$List$map,
							function (contact) {
								return {
									data: contact,
									expandStatus: $author$project$Type$AddressBook$Closed,
									newAlias: A2($elm$core$Maybe$withDefault, '', contact.alias)
								};
							},
							responseResult.acceptedContacts);
						return _Utils_Tuple2(
							$author$project$Type$AddressBook$Loaded(
								_Utils_update(
									loadedModel,
									{acceptedAddress: formattedAccepted, pendingAddress: responseResult.pendingContacts})),
							$elm$core$Platform$Cmd$none);
					} else {
						return _Utils_Tuple2(addressBookModel, $elm$core$Platform$Cmd$none);
					}
				case 'OnDecline':
					var contact = msg.a;
					return _Utils_Tuple2(
						addressBookModel,
						A3($author$project$Model$AddressBook$declineCmd, model.apiEndPoint.addressBookDecline, authModel.user, contact));
				case 'DeclineResponse':
					var contact = msg.a;
					var result = msg.b;
					if (result.$ === 'Ok') {
						return _Utils_Tuple2(
							$author$project$Type$AddressBook$Loaded(
								_Utils_update(
									loadedModel,
									{
										pendingAddress: A2($author$project$Data$AddressBook$filterAddressBook, contact, loadedModel.pendingAddress)
									})),
							$elm$core$Platform$Cmd$none);
					} else {
						return _Utils_Tuple2(addressBookModel, $elm$core$Platform$Cmd$none);
					}
				case 'OnDelete':
					var contact = msg.a;
					return _Utils_Tuple2(
						addressBookModel,
						A3($author$project$Model$AddressBook$deleteCmd, model.apiEndPoint.addressBookDelete, authModel.user, contact));
				case 'DeleteResponse':
					var contact = msg.a;
					var result = msg.b;
					if (result.$ === 'Ok') {
						return _Utils_Tuple2(
							$author$project$Type$AddressBook$Loaded(
								_Utils_update(
									loadedModel,
									{
										acceptedAddress: A2($author$project$Model$AddressBook$filterAcceptedAddress, contact, loadedModel.acceptedAddress),
										modal: $author$project$Type$AddressBook$AllClose,
										pendingAddress: A2($author$project$Data$AddressBook$filterAddressBook, contact, loadedModel.pendingAddress)
									})),
							$elm$core$Platform$Cmd$none);
					} else {
						return _Utils_Tuple2(addressBookModel, $elm$core$Platform$Cmd$none);
					}
				case 'Refresh':
					return _Utils_Tuple2(
						$author$project$Type$AddressBook$LoadingModel,
						A6($author$project$Model$AddressBook$listCmd, model.apiEndPoint.addressBookList, authModel.user, loadedModel.pendingPage, loadedModel.acceptedPageSize, loadedModel.acceptedPage, loadedModel.acceptedPageSize));
				case 'OnAliasInput':
					var acceptedAddress = msg.a;
					var newAlias = msg.b;
					var newAcceptedList = A2(
						$elm$core$List$map,
						function (address) {
							return _Utils_eq(address.data.friend, acceptedAddress.data.friend) ? _Utils_update(
								address,
								{newAlias: newAlias}) : address;
						},
						loadedModel.acceptedAddress);
					return _Utils_Tuple2(
						$author$project$Type$AddressBook$Loaded(
							_Utils_update(
								loadedModel,
								{acceptedAddress: newAcceptedList})),
						$elm$core$Platform$Cmd$none);
				case 'OnEditAlias':
					var acceptedAddress = msg.a;
					return _Utils_Tuple2(
						addressBookModel,
						A4($author$project$Model$AddressBook$editCmd, model.apiEndPoint.addressBookEdit, authModel.user, acceptedAddress.data, acceptedAddress.newAlias));
				case 'EditResponse':
					var acceptedAddress = msg.a;
					var result = msg.b;
					if (result.$ === 'Ok') {
						var updatedList = A2(
							$elm$core$List$map,
							function (address) {
								if (_Utils_eq(address.data.friend, acceptedAddress.friend)) {
									var newAlias = $elm$core$String$isEmpty(address.newAlias) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(address.newAlias);
									var _v12 = address;
									var data = _v12.data;
									return _Utils_update(
										address,
										{
											data: _Utils_update(
												data,
												{alias: newAlias})
										});
								} else {
									return address;
								}
							},
							loadedModel.acceptedAddress);
						return _Utils_Tuple2(
							$author$project$Type$AddressBook$Loaded(
								_Utils_update(
									loadedModel,
									{acceptedAddress: updatedList})),
							$elm$core$Platform$Cmd$none);
					} else {
						return _Utils_Tuple2(addressBookModel, $elm$core$Platform$Cmd$none);
					}
				case 'NextPage':
					var table = msg.a;
					var _v13 = function () {
						if (table.$ === 'Accepted') {
							return {numberOfContacts: loadedModel.numberOfAccepted, page: loadedModel.acceptedPage, pageSize: loadedModel.acceptedPageSize};
						} else {
							return {numberOfContacts: loadedModel.numberOfPending, page: loadedModel.pendingPage, pageSize: loadedModel.pendingPageSize};
						}
					}();
					var numberOfContacts = _v13.numberOfContacts;
					var pageSize = _v13.pageSize;
					var page = _v13.page;
					if (_Utils_cmp(
						$elm$core$Basics$ceiling(numberOfContacts / pageSize),
						page + 1) > 0) {
						if (table.$ === 'Accepted') {
							return _Utils_Tuple2(
								$author$project$Type$AddressBook$Loaded(
									_Utils_update(
										loadedModel,
										{acceptedPage: page + 1})),
								A6($author$project$Model$AddressBook$listCmd, model.apiEndPoint.addressBookList, authModel.user, loadedModel.pendingPage, loadedModel.pendingPageSize, page + 1, loadedModel.acceptedPageSize));
						} else {
							return _Utils_Tuple2(
								$author$project$Type$AddressBook$Loaded(
									_Utils_update(
										loadedModel,
										{pendingPage: page + 1})),
								A6($author$project$Model$AddressBook$listCmd, model.apiEndPoint.addressBookList, authModel.user, page + 1, loadedModel.pendingPageSize, loadedModel.acceptedPage, loadedModel.acceptedPageSize));
						}
					} else {
						return _Utils_Tuple2(addressBookModel, $elm$core$Platform$Cmd$none);
					}
				case 'PreviousPage':
					var table = msg.a;
					var page = function () {
						if (table.$ === 'Accepted') {
							return loadedModel.acceptedPage;
						} else {
							return loadedModel.pendingPage;
						}
					}();
					if (!page) {
						return _Utils_Tuple2(addressBookModel, $elm$core$Platform$Cmd$none);
					} else {
						if (table.$ === 'Accepted') {
							return _Utils_Tuple2(
								$author$project$Type$AddressBook$Loaded(
									_Utils_update(
										loadedModel,
										{acceptedPage: page - 1})),
								A6($author$project$Model$AddressBook$listCmd, model.apiEndPoint.addressBookList, authModel.user, loadedModel.pendingPage, loadedModel.pendingPageSize, page - 1, loadedModel.acceptedPageSize));
						} else {
							return _Utils_Tuple2(
								$author$project$Type$AddressBook$Loaded(
									_Utils_update(
										loadedModel,
										{pendingPage: page - 1})),
								A6($author$project$Model$AddressBook$listCmd, model.apiEndPoint.addressBookList, authModel.user, page - 1, loadedModel.pendingPageSize, loadedModel.acceptedPage, loadedModel.acceptedPageSize));
						}
					}
				case 'OnPageSizeChange':
					var table = msg.a;
					var pageSize = msg.b;
					var formattedPageSize = A2(
						$elm$core$Maybe$withDefault,
						10,
						$elm$core$String$toInt(pageSize));
					var _v18 = function () {
						if (table.$ === 'Accepted') {
							return {
								lastPage: $elm$core$Basics$ceiling(
									loadedModel.numberOfAccepted / A2(
										$elm$core$Maybe$withDefault,
										0,
										$elm$core$String$toFloat(pageSize))) - 1,
								page: loadedModel.acceptedPage
							};
						} else {
							return {
								lastPage: $elm$core$Basics$ceiling(
									loadedModel.numberOfPending / A2(
										$elm$core$Maybe$withDefault,
										0,
										$elm$core$String$toFloat(pageSize))) - 1,
								page: loadedModel.pendingPage
							};
						}
					}();
					var lastPage = _v18.lastPage;
					var page = _v18.page;
					if (_Utils_cmp(page, lastPage) > 0) {
						if (table.$ === 'Accepted') {
							return _Utils_Tuple2(
								$author$project$Type$AddressBook$Loaded(
									_Utils_update(
										loadedModel,
										{acceptedPage: lastPage, acceptedPageSize: formattedPageSize})),
								A6($author$project$Model$AddressBook$listCmd, model.apiEndPoint.addressBookList, authModel.user, loadedModel.pendingPage, loadedModel.pendingPageSize, lastPage, formattedPageSize));
						} else {
							return _Utils_Tuple2(
								$author$project$Type$AddressBook$Loaded(
									_Utils_update(
										loadedModel,
										{pendingPage: lastPage, pendingPageSize: formattedPageSize})),
								A6($author$project$Model$AddressBook$listCmd, model.apiEndPoint.addressBookList, authModel.user, lastPage, formattedPageSize, loadedModel.acceptedPage, loadedModel.acceptedPageSize));
						}
					} else {
						if (table.$ === 'Accepted') {
							return _Utils_Tuple2(
								$author$project$Type$AddressBook$Loaded(
									_Utils_update(
										loadedModel,
										{acceptedPageSize: formattedPageSize})),
								A6($author$project$Model$AddressBook$listCmd, model.apiEndPoint.addressBookList, authModel.user, loadedModel.pendingPage, loadedModel.pendingPageSize, loadedModel.acceptedPage, formattedPageSize));
						} else {
							return _Utils_Tuple2(
								$author$project$Type$AddressBook$Loaded(
									_Utils_update(
										loadedModel,
										{pendingPageSize: formattedPageSize})),
								A6($author$project$Model$AddressBook$listCmd, model.apiEndPoint.addressBookList, authModel.user, loadedModel.pendingPage, formattedPageSize, loadedModel.acceptedPage, loadedModel.acceptedPageSize));
						}
					}
				default:
					var placement = msg.a;
					var action = msg.b;
					var email = msg.c;
					if (action.$ === 'Leaves') {
						return _Utils_Tuple2(
							$author$project$Type$AddressBook$Loaded(
								_Utils_update(
									loadedModel,
									{toolTip: $author$project$Type$AddressBook$NoHover})),
							$elm$core$Platform$Cmd$none);
					} else {
						return _Utils_Tuple2(
							$author$project$Type$AddressBook$Loaded(
								_Utils_update(
									loadedModel,
									{
										toolTip: A2($author$project$Type$AddressBook$Hover, placement, email)
									})),
							$elm$core$Platform$Cmd$none);
					}
			}
		}
	});
var $author$project$Model$AddressBook$update = F3(
	function (msg, authModel, model) {
		var _v0 = A4($author$project$Model$AddressBook$updateAddressBook, msg, authModel.addressBookModel, model, authModel);
		var addressBookModel = _v0.a;
		var addressBookCmd = _v0.b;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					sessionModel: $author$project$Types$Auth(
						_Utils_update(
							authModel,
							{addressBookModel: addressBookModel}))
				}),
			addressBookCmd);
	});
var $author$project$Type$AppsumoRegister$Error = function (a) {
	return {$: 'Error', a: a};
};
var $author$project$Data$Api$Register$ValidateDomain$NotUse = {$: 'NotUse'};
var $author$project$Types$OnAppsumoRegister = function (a) {
	return {$: 'OnAppsumoRegister', a: a};
};
var $author$project$Type$AppsumoRegister$OnValidateDomain = {$: 'OnValidateDomain'};
var $author$project$Type$AppsumoRegister$Retry = {$: 'Retry'};
var $author$project$Type$AppsumoRegister$Submitting = {$: 'Submitting'};
var $author$project$Type$AppsumoRegister$Validating = {$: 'Validating'};
var $elm$core$List$all = F2(
	function (isOkay, list) {
		return !A2(
			$elm$core$List$any,
			A2($elm$core$Basics$composeL, $elm$core$Basics$not, isOkay),
			list);
	});
var $author$project$Type$AppsumoRegister$OnSubmitResponse = function (a) {
	return {$: 'OnSubmitResponse', a: a};
};
var $author$project$Data$Api$Register$Appsumo$Payload = function (message) {
	return {message: message};
};
var $author$project$Data$Api$Register$Appsumo$dataDecoder = A2(
	$elm$json$Json$Decode$map,
	$author$project$Data$Api$Register$Appsumo$Payload,
	A2($elm$json$Json$Decode$field, 'message', $elm$json$Json$Decode$string));
var $author$project$Data$Api$Register$Appsumo$encode = function (params) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'subdomain',
				$elm$json$Json$Encode$string(params.subdomain)),
				_Utils_Tuple2(
				'companyName',
				$elm$json$Json$Encode$string(params.companyName)),
				_Utils_Tuple2(
				'firstName',
				$elm$json$Json$Encode$string(params.firstName)),
				_Utils_Tuple2(
				'lastName',
				$elm$json$Json$Encode$string(params.lastName)),
				_Utils_Tuple2(
				'email',
				$elm$json$Json$Encode$string(params.email)),
				_Utils_Tuple2(
				'password',
				$elm$json$Json$Encode$string(params.password)),
				_Utils_Tuple2(
				'referralCode',
				$elm$json$Json$Encode$string(params.referralCode))
			]));
};
var $author$project$Data$Api$Register$Appsumo$EMPTY_NAME = {$: 'EMPTY_NAME'};
var $author$project$Data$Api$Register$Appsumo$INVALID_CODE = {$: 'INVALID_CODE'};
var $author$project$Data$Api$Register$Appsumo$INVALID_COMPANYNAME = {$: 'INVALID_COMPANYNAME'};
var $author$project$Data$Api$Register$Appsumo$INVALID_EMAIL = {$: 'INVALID_EMAIL'};
var $author$project$Data$Api$Register$Appsumo$INVALID_SUBDOMAIN = {$: 'INVALID_SUBDOMAIN'};
var $author$project$Data$Api$Register$Appsumo$PASSWORD_REQUIREMENT = {$: 'PASSWORD_REQUIREMENT'};
var $author$project$Data$Api$Register$Appsumo$UPDATE_ANONYMOUS = {$: 'UPDATE_ANONYMOUS'};
var $author$project$Data$Api$Register$Appsumo$USER_EXIST = {$: 'USER_EXIST'};
var $author$project$Data$Api$Register$Appsumo$errorDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (errorCode) {
		switch (errorCode) {
			case 'INVALID_SUBDOMAIN':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$Register$Appsumo$INVALID_SUBDOMAIN);
			case 'INVALID_COMPANYNAME':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$Register$Appsumo$INVALID_COMPANYNAME);
			case 'EMPTY_NAME':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$Register$Appsumo$EMPTY_NAME);
			case 'PASSWORD_REQUIREMENT':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$Register$Appsumo$PASSWORD_REQUIREMENT);
			case 'USER_EXIST':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$Register$Appsumo$USER_EXIST);
			case 'INVALID_EMAIL':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$Register$Appsumo$INVALID_EMAIL);
			case 'UPDATE_ANONYMOUS':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$Register$Appsumo$UPDATE_ANONYMOUS);
			case 'INVALID_CODE':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$Register$Appsumo$INVALID_CODE);
			default:
				return $elm$json$Json$Decode$fail('Invalid error code: ' + errorCode);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Data$Api$Register$Appsumo$call = F2(
	function (endPoint, params) {
		return A4(
			$author$project$Data$Api$httpTask,
			endPoint,
			$author$project$Data$Api$Register$Appsumo$errorDecoder,
			$author$project$Data$Api$Register$Appsumo$dataDecoder,
			$author$project$Data$Api$Register$Appsumo$encode(params));
	});
var $author$project$Model$AppsumoRegister$submitCmd = F2(
	function (endpoint, params) {
		return A2(
			$elm$core$Task$attempt,
			A2($elm$core$Basics$composeL, $author$project$Types$OnAppsumoRegister, $author$project$Type$AppsumoRegister$OnSubmitResponse),
			A2($author$project$Data$Api$Register$Appsumo$call, endpoint, params));
	});
var $elm$core$String$replace = F3(
	function (before, after, string) {
		return A2(
			$elm$core$String$join,
			after,
			A2($elm$core$String$split, before, string));
	});
var $author$project$Model$AppsumoRegister$trimRemoveSpace = function (str) {
	return A3(
		$elm$core$String$replace,
		' ',
		'',
		$elm$core$String$trim(str));
};
var $author$project$Model$AppsumoRegister$validateHasAgreedTerms = function (hasAgreed) {
	return hasAgreed ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just('You must agree to the terms of service and privacy policy to sign up.');
};
var $author$project$Model$AppsumoRegister$validateNotEmpty = F2(
	function (fieldName, value) {
		return $elm$core$String$isEmpty(value) ? $elm$core$Maybe$Just(fieldName + ' is required.') : $elm$core$Maybe$Nothing;
	});
var $elm$core$Basics$ge = _Utils_ge;
var $author$project$Data$Validator$validatePassword = function (value) {
	var hasUppercase = A2(
		$elm$regex$Regex$contains,
		A2(
			$elm$core$Maybe$withDefault,
			$elm$regex$Regex$never,
			$elm$regex$Regex$fromString('[A-Z]')),
		value);
	var hasNumber = A2(
		$elm$regex$Regex$contains,
		A2(
			$elm$core$Maybe$withDefault,
			$elm$regex$Regex$never,
			$elm$regex$Regex$fromString('[0-9]')),
		value);
	var hasLowercase = A2(
		$elm$regex$Regex$contains,
		A2(
			$elm$core$Maybe$withDefault,
			$elm$regex$Regex$never,
			$elm$regex$Regex$fromString('[a-z]')),
		value);
	var atLeastEightChars = $elm$core$String$length(value) >= 8;
	return A2(
		$elm$core$List$all,
		$elm$core$Basics$identity,
		_List_fromArray(
			[hasNumber, hasLowercase, hasUppercase, atLeastEightChars])) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just('Password must contain at least 8 characters, a lowercase letter, an uppercase letter and a number');
};
var $author$project$Data$Validator$validatePasswordAgain = F2(
	function (s1, s2) {
		return _Utils_eq(s1, s2) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just('Passwords do not match.');
	});
var $author$project$Type$AppsumoRegister$OnValidateDomainResponse = function (a) {
	return {$: 'OnValidateDomainResponse', a: a};
};
var $author$project$Data$Api$Register$ValidateDomain$Payload = function (status) {
	return {status: status};
};
var $author$project$Data$Api$Register$ValidateDomain$Invalid = {$: 'Invalid'};
var $author$project$Data$Api$Register$ValidateDomain$Reserved = {$: 'Reserved'};
var $author$project$Data$Api$Register$ValidateDomain$Used = {$: 'Used'};
var $author$project$Data$Api$Register$ValidateDomain$decodeStatusType = A2(
	$elm$json$Json$Decode$andThen,
	function (annotType) {
		switch (annotType) {
			case 'Used':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$Register$ValidateDomain$Used);
			case 'NotUse':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$Register$ValidateDomain$NotUse);
			case 'Reserved':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$Register$ValidateDomain$Reserved);
			case 'Invalid':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$Register$ValidateDomain$Invalid);
			default:
				return $elm$json$Json$Decode$fail('Invalid status type.');
		}
	},
	A2($elm$json$Json$Decode$field, 'status', $elm$json$Json$Decode$string));
var $author$project$Data$Api$Register$ValidateDomain$dataDecoder = A2($elm$json$Json$Decode$map, $author$project$Data$Api$Register$ValidateDomain$Payload, $author$project$Data$Api$Register$ValidateDomain$decodeStatusType);
var $author$project$Data$Api$Register$ValidateDomain$encode = function (params) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'subdomain',
				$elm$json$Json$Encode$string(params.subdomain))
			]));
};
var $author$project$Data$Api$Register$ValidateDomain$errorDecoder = $elm$json$Json$Decode$succeed(_Utils_Tuple0);
var $author$project$Data$Api$Register$ValidateDomain$call = F2(
	function (endPoint, params) {
		return A4(
			$author$project$Data$Api$httpTask,
			endPoint,
			$author$project$Data$Api$Register$ValidateDomain$errorDecoder,
			$author$project$Data$Api$Register$ValidateDomain$dataDecoder,
			$author$project$Data$Api$Register$ValidateDomain$encode(params));
	});
var $author$project$Model$AppsumoRegister$validateSubDomain = F2(
	function (endpoint, subDomain) {
		return A2(
			$elm$core$Task$attempt,
			A2($elm$core$Basics$composeL, $author$project$Types$OnAppsumoRegister, $author$project$Type$AppsumoRegister$OnValidateDomainResponse),
			A2(
				$author$project$Data$Api$Register$ValidateDomain$call,
				endpoint,
				{subdomain: subDomain}));
	});
var $author$project$Model$AppsumoRegister$validateSubDomainErrorString = function (status) {
	switch (status.$) {
		case 'Used':
			return $elm$core$Maybe$Just('This domain name is already in use.');
		case 'Reserved':
			return $elm$core$Maybe$Just('This domain name is reserved.');
		case 'Invalid':
			return $elm$core$Maybe$Just('This domain name contain invalid characters.');
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Model$AppsumoRegister$update = F2(
	function (msg, model) {
		var _v0 = model;
		var appsumoRegisterModel = _v0.appsumoRegisterModel;
		var apiEndPoint = _v0.apiEndPoint;
		switch (msg.$) {
			case 'OnInput':
				var field = msg.a;
				var value = msg.b;
				switch (field.$) {
					case 'SubDomain':
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									appsumoRegisterModel: _Utils_update(
										appsumoRegisterModel,
										{
											subdomain: $author$project$Model$AppsumoRegister$trimRemoveSpace(value),
											subdomainStatus: $elm$core$Maybe$Nothing
										})
								}),
							$elm$core$Platform$Cmd$none);
					case 'CompanyName':
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									appsumoRegisterModel: _Utils_update(
										appsumoRegisterModel,
										{companyName: value})
								}),
							$elm$core$Platform$Cmd$none);
					case 'FirstName':
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									appsumoRegisterModel: _Utils_update(
										appsumoRegisterModel,
										{firstName: value})
								}),
							$elm$core$Platform$Cmd$none);
					case 'LastName':
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									appsumoRegisterModel: _Utils_update(
										appsumoRegisterModel,
										{lastName: value})
								}),
							$elm$core$Platform$Cmd$none);
					case 'Email':
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									appsumoRegisterModel: _Utils_update(
										appsumoRegisterModel,
										{email: value})
								}),
							$elm$core$Platform$Cmd$none);
					case 'Password':
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									appsumoRegisterModel: _Utils_update(
										appsumoRegisterModel,
										{password: value})
								}),
							$elm$core$Platform$Cmd$none);
					case 'PasswordAgain':
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									appsumoRegisterModel: _Utils_update(
										appsumoRegisterModel,
										{passwordAgain: value})
								}),
							$elm$core$Platform$Cmd$none);
					default:
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									appsumoRegisterModel: _Utils_update(
										appsumoRegisterModel,
										{referralCode: value})
								}),
							$elm$core$Platform$Cmd$none);
				}
			case 'OnBlur':
				var field = msg.a;
				switch (field.$) {
					case 'SubDomain':
						return _Utils_Tuple2(
							model,
							A2(
								$elm$core$Task$perform,
								$author$project$Types$OnAppsumoRegister,
								$elm$core$Task$succeed($author$project$Type$AppsumoRegister$OnValidateDomain)));
					case 'CompanyName':
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									appsumoRegisterModel: _Utils_update(
										appsumoRegisterModel,
										{
											companyNameError: A2($author$project$Model$AppsumoRegister$validateNotEmpty, 'Company name', appsumoRegisterModel.companyName)
										})
								}),
							$elm$core$Platform$Cmd$none);
					case 'FirstName':
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									appsumoRegisterModel: _Utils_update(
										appsumoRegisterModel,
										{
											firstNameError: A2($author$project$Model$AppsumoRegister$validateNotEmpty, 'First name', appsumoRegisterModel.firstName)
										})
								}),
							$elm$core$Platform$Cmd$none);
					case 'LastName':
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									appsumoRegisterModel: _Utils_update(
										appsumoRegisterModel,
										{
											lastNameError: A2($author$project$Model$AppsumoRegister$validateNotEmpty, 'Last name', appsumoRegisterModel.lastName)
										})
								}),
							$elm$core$Platform$Cmd$none);
					case 'Email':
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									appsumoRegisterModel: _Utils_update(
										appsumoRegisterModel,
										{
											emailError: $author$project$Data$Validator$validateEmail(appsumoRegisterModel.email)
										})
								}),
							$elm$core$Platform$Cmd$none);
					case 'Password':
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									appsumoRegisterModel: _Utils_update(
										appsumoRegisterModel,
										{
											passwordError: $author$project$Data$Validator$validatePassword(appsumoRegisterModel.password)
										})
								}),
							$elm$core$Platform$Cmd$none);
					case 'PasswordAgain':
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									appsumoRegisterModel: _Utils_update(
										appsumoRegisterModel,
										{
											passwordAgainError: A2($author$project$Data$Validator$validatePasswordAgain, appsumoRegisterModel.password, appsumoRegisterModel.passwordAgain)
										})
								}),
							$elm$core$Platform$Cmd$none);
					default:
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									appsumoRegisterModel: _Utils_update(
										appsumoRegisterModel,
										{
											referralCodeError: A2($author$project$Model$AppsumoRegister$validateNotEmpty, 'Coupon Code', appsumoRegisterModel.referralCode)
										})
								}),
							$elm$core$Platform$Cmd$none);
				}
			case 'OnAgreeTerms':
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							appsumoRegisterModel: _Utils_update(
								appsumoRegisterModel,
								{hasAgreedTerms: !appsumoRegisterModel.hasAgreedTerms, hasAgreedTermsError: $elm$core$Maybe$Nothing})
						}),
					$elm$core$Platform$Cmd$none);
			case 'OnValidateDomain':
				var domainLength = $elm$core$String$length(
					$elm$core$String$trim(appsumoRegisterModel.subdomain));
				return ((domainLength > 0) && (domainLength <= 63)) ? _Utils_Tuple2(
					_Utils_update(
						model,
						{
							appsumoRegisterModel: _Utils_update(
								appsumoRegisterModel,
								{subdomainError: $elm$core$Maybe$Nothing, validationStatus: $author$project$Type$AppsumoRegister$Validating})
						}),
					A2(
						$author$project$Model$AppsumoRegister$validateSubDomain,
						apiEndPoint.validateDomain,
						$elm$core$String$toLower(
							$author$project$Model$AppsumoRegister$trimRemoveSpace(appsumoRegisterModel.subdomain)))) : ((domainLength > 63) ? _Utils_Tuple2(
					_Utils_update(
						model,
						{
							appsumoRegisterModel: _Utils_update(
								appsumoRegisterModel,
								{
									subdomainError: $elm$core$Maybe$Just('Subdomain cannot exceed 63 characters.'),
									subdomainStatus: $elm$core$Maybe$Nothing
								})
						}),
					$elm$core$Platform$Cmd$none) : _Utils_Tuple2(
					_Utils_update(
						model,
						{
							appsumoRegisterModel: _Utils_update(
								appsumoRegisterModel,
								{
									subdomainError: $elm$core$Maybe$Just('Subdomain cannot be empty.'),
									subdomainStatus: $elm$core$Maybe$Nothing
								})
						}),
					$elm$core$Platform$Cmd$none));
			case 'OnValidateDomainResponse':
				var result = msg.a;
				if (result.$ === 'Ok') {
					var status = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								appsumoRegisterModel: _Utils_update(
									appsumoRegisterModel,
									{
										subdomainError: $author$project$Model$AppsumoRegister$validateSubDomainErrorString(status.status),
										subdomainStatus: $elm$core$Maybe$Just(status.status),
										validationStatus: $author$project$Type$AppsumoRegister$Loaded
									})
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								appsumoRegisterModel: _Utils_update(
									appsumoRegisterModel,
									{validationStatus: $author$project$Type$AppsumoRegister$Retry})
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 'OnSubmit':
				var _v6 = appsumoRegisterModel;
				var companyName = _v6.companyName;
				var firstName = _v6.firstName;
				var lastName = _v6.lastName;
				var email = _v6.email;
				var password = _v6.password;
				var passwordAgain = _v6.passwordAgain;
				var hasAgreedTerms = _v6.hasAgreedTerms;
				var subdomain = _v6.subdomain;
				var referralCode = _v6.referralCode;
				var updatedRegisterModel = function (m) {
					return _Utils_update(
						m,
						{
							hasAgreedTermsError: $author$project$Model$AppsumoRegister$validateHasAgreedTerms(hasAgreedTerms)
						});
				}(
					function (m) {
						return _Utils_update(
							m,
							{
								passwordAgainError: A2($author$project$Data$Validator$validatePasswordAgain, password, passwordAgain)
							});
					}(
						function (m) {
							return _Utils_update(
								m,
								{
									passwordError: $author$project$Data$Validator$validatePassword(password)
								});
						}(
							function (m) {
								return _Utils_update(
									m,
									{
										emailError: $author$project$Data$Validator$validateEmail(email)
									});
							}(
								function (m) {
									return _Utils_update(
										m,
										{
											lastNameError: A2($author$project$Model$AppsumoRegister$validateNotEmpty, 'Last name', lastName)
										});
								}(
									function (m) {
										return _Utils_update(
											m,
											{
												firstNameError: A2($author$project$Model$AppsumoRegister$validateNotEmpty, 'First name', firstName)
											});
									}(
										_Utils_update(
											appsumoRegisterModel,
											{
												companyNameError: A2($author$project$Model$AppsumoRegister$validateNotEmpty, 'Company name', companyName)
											})))))));
				var allPassed = A2(
					$elm$core$List$all,
					$elm$core$Basics$eq($elm$core$Maybe$Nothing),
					_List_fromArray(
						[updatedRegisterModel.companyNameError, updatedRegisterModel.firstNameError, updatedRegisterModel.lastNameError, updatedRegisterModel.emailError, updatedRegisterModel.passwordError, updatedRegisterModel.passwordAgainError, updatedRegisterModel.hasAgreedTermsError]));
				var validStatus = A2(
					$elm$core$Maybe$withDefault,
					false,
					A2(
						$elm$core$Maybe$map,
						function (status) {
							return _Utils_eq(status, $author$project$Data$Api$Register$ValidateDomain$NotUse);
						},
						updatedRegisterModel.subdomainStatus));
				if (allPassed && validStatus) {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								appsumoRegisterModel: _Utils_update(
									updatedRegisterModel,
									{formStatus: $author$project$Type$AppsumoRegister$Submitting})
							}),
						A2(
							$author$project$Model$AppsumoRegister$submitCmd,
							model.apiEndPoint.appsumoRegister,
							{
								companyName: companyName,
								email: email,
								firstName: firstName,
								lastName: lastName,
								password: password,
								referralCode: referralCode,
								subdomain: $elm$core$String$toLower(
									$author$project$Model$AppsumoRegister$trimRemoveSpace(subdomain))
							}));
				} else {
					if (!validStatus) {
						var _v7 = updatedRegisterModel.subdomainStatus;
						if (_v7.$ === 'Nothing') {
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{
										appsumoRegisterModel: _Utils_update(
											updatedRegisterModel,
											{
												formStatus: $author$project$Type$AppsumoRegister$Ready,
												subdomainError: $elm$core$Maybe$Just('Domain name cannot be empty')
											})
									}),
								$elm$core$Platform$Cmd$none);
						} else {
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{
										appsumoRegisterModel: _Utils_update(
											updatedRegisterModel,
											{formStatus: $author$project$Type$AppsumoRegister$Ready})
									}),
								$elm$core$Platform$Cmd$none);
						}
					} else {
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									appsumoRegisterModel: _Utils_update(
										updatedRegisterModel,
										{formStatus: $author$project$Type$AppsumoRegister$Ready})
								}),
							$elm$core$Platform$Cmd$none);
					}
				}
			case 'OnSubmitResponse':
				var result = msg.a;
				if (result.$ === 'Ok') {
					return _Utils_Tuple2(
						model,
						$elm$browser$Browser$Navigation$load($author$project$Data$Route$routeUrl.registerSuccess));
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								appsumoRegisterModel: _Utils_update(
									appsumoRegisterModel,
									{
										formStatus: $author$project$Type$AppsumoRegister$Error(error)
									})
							}),
						$elm$core$Platform$Cmd$none);
				}
			default:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Type$BusinessAcceptInvite$Error = function (a) {
	return {$: 'Error', a: a};
};
var $author$project$Type$BusinessAcceptInvite$Success = {$: 'Success'};
var $author$project$Model$BusinessAcceptInvite$update = F2(
	function (msg, model) {
		var _v0 = model;
		var businessAcceptInviteModel = _v0.businessAcceptInviteModel;
		if (businessAcceptInviteModel.$ === 'NoToken') {
			return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		} else {
			var token = businessAcceptInviteModel.a;
			var result = msg.a;
			if (result.$ === 'Ok') {
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							businessAcceptInviteModel: A2($author$project$Type$BusinessAcceptInvite$HasToken, token, $author$project$Type$BusinessAcceptInvite$Success)
						}),
					$elm$core$Platform$Cmd$none);
			} else {
				var error = result.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							businessAcceptInviteModel: A2(
								$author$project$Type$BusinessAcceptInvite$HasToken,
								token,
								$author$project$Type$BusinessAcceptInvite$Error(error))
						}),
					$elm$core$Platform$Cmd$none);
			}
		}
	});
var $author$project$Type$BusinessCreate$Error = function (a) {
	return {$: 'Error', a: a};
};
var $author$project$Type$BusinessCreate$OnSubmitResponse = function (a) {
	return {$: 'OnSubmitResponse', a: a};
};
var $author$project$Type$BusinessCreate$OnValidateDomain = {$: 'OnValidateDomain'};
var $author$project$Type$BusinessCreate$Retry = {$: 'Retry'};
var $author$project$Type$BusinessCreate$Submitting = {$: 'Submitting'};
var $author$project$Type$BusinessCreate$Validating = {$: 'Validating'};
var $author$project$Data$Api$Business$Create$Payload = function (sessionId) {
	return {sessionId: sessionId};
};
var $author$project$Data$Api$Business$Create$dataDecoder = A2(
	$elm$json$Json$Decode$map,
	$author$project$Data$Api$Business$Create$Payload,
	A2($elm$json$Json$Decode$field, 'sessionId', $elm$json$Json$Decode$string));
var $author$project$Data$Api$Business$Create$encode = function (params) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'subdomain',
				$elm$json$Json$Encode$string(params.subdomain)),
				_Utils_Tuple2(
				'companyName',
				$elm$json$Json$Encode$string(params.companyName))
			]));
};
var $author$project$Data$Api$Business$Create$INVALID_COMPANYNAME = {$: 'INVALID_COMPANYNAME'};
var $author$project$Data$Api$Business$Create$INVALID_SUBDOMAIN = {$: 'INVALID_SUBDOMAIN'};
var $author$project$Data$Api$Business$Create$errorDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (errorCode) {
		switch (errorCode) {
			case 'INVALID_SUBDOMAIN':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$Business$Create$INVALID_SUBDOMAIN);
			case 'INVALID_COMPANYNAME':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$Business$Create$INVALID_COMPANYNAME);
			default:
				return $elm$json$Json$Decode$fail('Invalid error code: ' + errorCode);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Data$Api$Business$Create$authCall = F3(
	function (jwt, endPoint, params) {
		return A5(
			$author$project$Data$Api$authCall,
			jwt,
			endPoint,
			$author$project$Data$Api$Business$Create$errorDecoder,
			$author$project$Data$Api$Business$Create$dataDecoder,
			$author$project$Data$Api$Business$Create$encode(params));
	});
var $author$project$Model$BusinessCreate$checkoutToStripeCreateBusiness = _Platform_outgoingPort('checkoutToStripeCreateBusiness', $elm$core$Basics$identity);
var $author$project$Model$BusinessCreate$trimRemoveSpace = function (str) {
	return A3(
		$elm$core$String$replace,
		' ',
		'',
		$elm$core$String$trim(str));
};
var $author$project$Model$BusinessCreate$validateNotEmpty = F2(
	function (fieldName, value) {
		return $elm$core$String$isEmpty(value) ? $elm$core$Maybe$Just(fieldName + ' is required.') : $elm$core$Maybe$Nothing;
	});
var $author$project$Type$BusinessCreate$OnValidateDomainResponse = function (a) {
	return {$: 'OnValidateDomainResponse', a: a};
};
var $author$project$Model$BusinessCreate$validateSubDomain = F2(
	function (endpoint, subDomain) {
		return A2(
			$elm$core$Task$attempt,
			A2(
				$elm$core$Basics$composeL,
				A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnBusinessCreate),
				$author$project$Type$BusinessCreate$OnValidateDomainResponse),
			A2(
				$author$project$Data$Api$Register$ValidateDomain$call,
				endpoint,
				{subdomain: subDomain}));
	});
var $author$project$Model$BusinessCreate$validateSubDomainErrorString = function (status) {
	switch (status.$) {
		case 'Used':
			return $elm$core$Maybe$Just('This domain name is already in use.');
		case 'Reserved':
			return $elm$core$Maybe$Just('This domain name is reserved.');
		case 'Invalid':
			return $elm$core$Maybe$Just('This domain name contain invalid characters.');
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Model$BusinessCreate$update = F3(
	function (msg, authModel, model) {
		var updateModel = function (updatedModel) {
			return _Utils_update(
				model,
				{
					sessionModel: $author$project$Types$Auth(
						_Utils_update(
							authModel,
							{businessCreateModel: updatedModel}))
				});
		};
		var _v0 = authModel;
		var businessCreateModel = _v0.businessCreateModel;
		var _v1 = model;
		var apiEndPoint = _v1.apiEndPoint;
		switch (msg.$) {
			case 'OnOpen':
				return _Utils_Tuple2(
					updateModel(
						_Utils_update(
							businessCreateModel,
							{isModalOpen: true})),
					$elm$core$Platform$Cmd$none);
			case 'OnClose':
				return _Utils_Tuple2(
					updateModel(
						_Utils_update(
							businessCreateModel,
							{isModalOpen: false})),
					$elm$core$Platform$Cmd$none);
			case 'OnInput':
				var field = msg.a;
				var string = msg.b;
				if (field.$ === 'CompanyName') {
					return _Utils_Tuple2(
						updateModel(
							_Utils_update(
								businessCreateModel,
								{companyName: string})),
						$elm$core$Platform$Cmd$none);
				} else {
					return _Utils_Tuple2(
						updateModel(
							_Utils_update(
								businessCreateModel,
								{subdomain: string})),
						$elm$core$Platform$Cmd$none);
				}
			case 'OnBlur':
				var field = msg.a;
				if (field.$ === 'Subdomain') {
					return _Utils_Tuple2(
						model,
						A2(
							$elm$core$Task$perform,
							A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnBusinessCreate),
							$elm$core$Task$succeed($author$project$Type$BusinessCreate$OnValidateDomain)));
				} else {
					return _Utils_Tuple2(
						updateModel(
							_Utils_update(
								businessCreateModel,
								{
									companyNameError: A2($author$project$Model$BusinessCreate$validateNotEmpty, 'Company name', businessCreateModel.companyName)
								})),
						$elm$core$Platform$Cmd$none);
				}
			case 'OnValidateDomain':
				var domainLength = $elm$core$String$length(
					$elm$core$String$trim(businessCreateModel.subdomain));
				return ((domainLength > 0) && (domainLength <= 63)) ? _Utils_Tuple2(
					updateModel(
						_Utils_update(
							businessCreateModel,
							{subdomainError: $elm$core$Maybe$Nothing, validationStatus: $author$project$Type$BusinessCreate$Validating})),
					A2(
						$author$project$Model$BusinessCreate$validateSubDomain,
						apiEndPoint.validateDomain,
						$elm$core$String$toLower(
							$author$project$Model$BusinessCreate$trimRemoveSpace(businessCreateModel.subdomain)))) : ((domainLength > 63) ? _Utils_Tuple2(
					updateModel(
						_Utils_update(
							businessCreateModel,
							{
								subdomainError: $elm$core$Maybe$Just('Subdomain cannot exceed 63 characters.'),
								subdomainStatus: $elm$core$Maybe$Nothing
							})),
					$elm$core$Platform$Cmd$none) : _Utils_Tuple2(
					updateModel(
						_Utils_update(
							businessCreateModel,
							{
								subdomainError: $elm$core$Maybe$Just('Subdomain cannot be empty.'),
								subdomainStatus: $elm$core$Maybe$Nothing
							})),
					$elm$core$Platform$Cmd$none));
			case 'OnValidateDomainResponse':
				var result = msg.a;
				if (result.$ === 'Ok') {
					var status = result.a;
					return _Utils_Tuple2(
						updateModel(
							_Utils_update(
								businessCreateModel,
								{
									subdomainError: $author$project$Model$BusinessCreate$validateSubDomainErrorString(status.status),
									subdomainStatus: $elm$core$Maybe$Just(status.status),
									validationStatus: $author$project$Type$BusinessCreate$Loaded
								})),
						$elm$core$Platform$Cmd$none);
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						updateModel(
							_Utils_update(
								businessCreateModel,
								{validationStatus: $author$project$Type$BusinessCreate$Retry})),
						$elm$core$Platform$Cmd$none);
				}
			case 'OnSubmit':
				var _v7 = businessCreateModel;
				var subdomain = _v7.subdomain;
				var companyName = _v7.companyName;
				var updatedBusinessCreateModel = _Utils_update(
					businessCreateModel,
					{
						companyNameError: A2($author$project$Model$BusinessCreate$validateNotEmpty, 'Company name', companyName)
					});
				var allPassed = _Utils_eq(updatedBusinessCreateModel.companyNameError, $elm$core$Maybe$Nothing);
				var validStatus = A2(
					$elm$core$Maybe$withDefault,
					false,
					A2(
						$elm$core$Maybe$map,
						function (status) {
							return _Utils_eq(status, $author$project$Data$Api$Register$ValidateDomain$NotUse);
						},
						updatedBusinessCreateModel.subdomainStatus));
				if (allPassed && validStatus) {
					return _Utils_Tuple2(
						updateModel(
							_Utils_update(
								updatedBusinessCreateModel,
								{formStatus: $author$project$Type$BusinessCreate$Submitting})),
						A2(
							$elm$core$Task$attempt,
							A2(
								$elm$core$Basics$composeL,
								A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnBusinessCreate),
								$author$project$Type$BusinessCreate$OnSubmitResponse),
							A3(
								$author$project$Data$Api$Business$Create$authCall,
								authModel.user.jwt,
								apiEndPoint.businessCreate,
								{
									companyName: companyName,
									subdomain: $elm$core$String$toLower(
										$author$project$Model$BusinessCreate$trimRemoveSpace(subdomain))
								})));
				} else {
					if (!validStatus) {
						var _v8 = updatedBusinessCreateModel.subdomainStatus;
						if (_v8.$ === 'Nothing') {
							return _Utils_Tuple2(
								updateModel(
									_Utils_update(
										updatedBusinessCreateModel,
										{
											formStatus: $author$project$Type$BusinessCreate$Ready,
											subdomainError: $elm$core$Maybe$Just('Domain name cannot be empty')
										})),
								$elm$core$Platform$Cmd$none);
						} else {
							return _Utils_Tuple2(
								updateModel(
									_Utils_update(
										updatedBusinessCreateModel,
										{formStatus: $author$project$Type$BusinessCreate$Ready})),
								$elm$core$Platform$Cmd$none);
						}
					} else {
						return _Utils_Tuple2(
							updateModel(
								_Utils_update(
									updatedBusinessCreateModel,
									{formStatus: $author$project$Type$BusinessCreate$Ready})),
							$elm$core$Platform$Cmd$none);
					}
				}
			case 'OnSubmitResponse':
				var result = msg.a;
				if (result.$ === 'Ok') {
					var value = result.a;
					return _Utils_Tuple2(
						model,
						$author$project$Model$BusinessCreate$checkoutToStripeCreateBusiness(
							$elm$json$Json$Encode$string(value.sessionId)));
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						updateModel(
							_Utils_update(
								businessCreateModel,
								{
									formStatus: $author$project$Type$BusinessCreate$Error(error)
								})),
						$elm$core$Platform$Cmd$none);
				}
			default:
				return _Utils_Tuple2(
					updateModel(
						_Utils_update(
							businessCreateModel,
							{
								formStatus: $author$project$Type$BusinessCreate$Ready,
								redirectError: $elm$core$Maybe$Just('Unable to redirect to stripe, please try again.')
							})),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Type$BusinessProfile$CloseSnackBar = function (a) {
	return {$: 'CloseSnackBar', a: a};
};
var $author$project$Type$BusinessProfile$Error = function (a) {
	return {$: 'Error', a: a};
};
var $author$project$Type$BusinessProfile$LoadError = {$: 'LoadError'};
var $author$project$Type$BusinessProfile$LoadingState = {$: 'LoadingState'};
var $author$project$Type$BusinessProfile$OnRequestTemplateResult = function (a) {
	return {$: 'OnRequestTemplateResult', a: a};
};
var $author$project$Type$BusinessProfile$OnSubmitResponse = function (a) {
	return {$: 'OnSubmitResponse', a: a};
};
var $author$project$Type$BusinessProfile$RequestTemplate = function (a) {
	return {$: 'RequestTemplate', a: a};
};
var $author$project$Type$BusinessProfile$RequestTemplateSuccess = function (a) {
	return {$: 'RequestTemplateSuccess', a: a};
};
var $author$project$Material$Styled$Snackbar$Show = {$: 'Show'};
var $author$project$Type$BusinessProfile$Submitting = {$: 'Submitting'};
var $author$project$Type$BusinessProfile$Success = {$: 'Success'};
var $author$project$Data$Api$BusinessProfile$Payload = function (message) {
	return {message: message};
};
var $author$project$Data$Api$BusinessProfile$dataDecoder = A2(
	$elm$json$Json$Decode$map,
	$author$project$Data$Api$BusinessProfile$Payload,
	A2($elm$json$Json$Decode$field, 'message', $elm$json$Json$Decode$string));
var $author$project$Data$Api$BusinessProfile$encodeOptionalField = function (field) {
	return $elm$core$String$isEmpty(field) ? $elm$json$Json$Encode$null : $elm$json$Json$Encode$string(field);
};
var $author$project$Data$Api$BusinessProfile$encode = function (data) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'title',
				$elm$json$Json$Encode$string(data.title)),
				_Utils_Tuple2(
				'description',
				$elm$json$Json$Encode$string(data.description)),
				_Utils_Tuple2(
				'contactName',
				$author$project$Data$Api$BusinessProfile$encodeOptionalField(data.contactName)),
				_Utils_Tuple2(
				'contactEmail',
				$author$project$Data$Api$BusinessProfile$encodeOptionalField(data.contactEmail)),
				_Utils_Tuple2(
				'contactPhone',
				$author$project$Data$Api$BusinessProfile$encodeOptionalField(data.contactPhone)),
				_Utils_Tuple2(
				'domain',
				$elm$json$Json$Encode$string(
					$author$project$Data$Domain$toString(data.domain)))
			]));
};
var $author$project$Data$Api$BusinessProfile$DOMAIN_NOT_FOUND = {$: 'DOMAIN_NOT_FOUND'};
var $author$project$Data$Api$BusinessProfile$EMPTY_TITLE = {$: 'EMPTY_TITLE'};
var $author$project$Data$Api$BusinessProfile$INVALID_DESCRIPTION = {$: 'INVALID_DESCRIPTION'};
var $author$project$Data$Api$BusinessProfile$INVALID_EMAIL = {$: 'INVALID_EMAIL'};
var $author$project$Data$Api$BusinessProfile$INVALID_PHONE = {$: 'INVALID_PHONE'};
var $author$project$Data$Api$BusinessProfile$NOT_OWNER = {$: 'NOT_OWNER'};
var $author$project$Data$Api$BusinessProfile$errorDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (errorCode) {
		switch (errorCode) {
			case 'EMPTY_TITLE':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$BusinessProfile$EMPTY_TITLE);
			case 'INVALID_DESCRIPTION':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$BusinessProfile$INVALID_DESCRIPTION);
			case 'INVALID_EMAIL':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$BusinessProfile$INVALID_EMAIL);
			case 'INVALID_PHONE':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$BusinessProfile$INVALID_PHONE);
			case 'DOMAIN_NOT_FOUND':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$BusinessProfile$DOMAIN_NOT_FOUND);
			case 'NOT_OWNER':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$BusinessProfile$NOT_OWNER);
			default:
				return $elm$json$Json$Decode$fail('Invalid error code: ' + errorCode);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Data$Api$BusinessProfile$authCall = F3(
	function (jwt, endPoint, params) {
		return A5(
			$author$project$Data$Api$authCall,
			jwt,
			endPoint,
			$author$project$Data$Api$BusinessProfile$errorDecoder,
			$author$project$Data$Api$BusinessProfile$dataDecoder,
			$author$project$Data$Api$BusinessProfile$encode(params));
	});
var $author$project$Data$Api$PDF$IssueAnonymous$Payload = F2(
	function (message, docId) {
		return {docId: docId, message: message};
	});
var $author$project$Data$Api$PDF$IssueAnonymous$dataDecoder = A3(
	$elm$json$Json$Decode$map2,
	$author$project$Data$Api$PDF$IssueAnonymous$Payload,
	A2($elm$json$Json$Decode$field, 'message', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'docId', $elm$json$Json$Decode$string));
var $author$project$Data$Api$PDF$IssueAnonymous$encode = function (_v0) {
	var slug = _v0.slug;
	var email = _v0.email;
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'slug',
				$elm$json$Json$Encode$string(slug)),
				_Utils_Tuple2(
				'email',
				$elm$json$Json$Encode$string(email))
			]));
};
var $author$project$Data$Api$PDF$IssueAnonymous$INVALID_EMAIL = {$: 'INVALID_EMAIL'};
var $author$project$Data$Api$PDF$IssueAnonymous$INVALID_TEMPLATE = {$: 'INVALID_TEMPLATE'};
var $author$project$Data$Api$PDF$IssueAnonymous$REQUIRED_LOGIN = {$: 'REQUIRED_LOGIN'};
var $author$project$Data$Api$PDF$IssueAnonymous$errorDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (errorCode) {
		switch (errorCode) {
			case 'INVALID_EMAIL':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$PDF$IssueAnonymous$INVALID_EMAIL);
			case 'REQUIRED_LOGIN':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$PDF$IssueAnonymous$REQUIRED_LOGIN);
			case 'INVALID_TEMPLATE':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$PDF$IssueAnonymous$INVALID_TEMPLATE);
			default:
				return $elm$json$Json$Decode$fail('Invalid error code: ' + errorCode);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Data$Api$PDF$IssueAnonymous$call = F2(
	function (endPoint, params) {
		return A4(
			$author$project$Data$Api$httpTask,
			endPoint,
			$author$project$Data$Api$PDF$IssueAnonymous$errorDecoder,
			$author$project$Data$Api$PDF$IssueAnonymous$dataDecoder,
			$author$project$Data$Api$PDF$IssueAnonymous$encode(params));
	});
var $author$project$Model$BusinessProfile$checkEmail = function (email) {
	return $elm$core$String$isEmpty(email) ? $elm$core$Maybe$Nothing : $author$project$Data$Validator$validateEmail(email);
};
var $author$project$Model$BusinessProfile$checkPhoneNum = function (value) {
	var phoneNum = A3($elm$core$String$replace, ' ', '', value);
	return $elm$core$String$isEmpty(phoneNum) ? $elm$core$Maybe$Nothing : (A2(
		$elm$regex$Regex$contains,
		A2(
			$elm$core$Maybe$withDefault,
			$elm$regex$Regex$never,
			$elm$regex$Regex$fromString('^\\+\\d{8,30}$')),
		phoneNum) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just('Invalid Phone Number'));
};
var $author$project$Data$Clipboard$copyToClipboard = _Platform_outgoingPort('copyToClipboard', $elm$core$Basics$identity);
var $author$project$Data$Clipboard$encodeAndCopy = function (value) {
	return $author$project$Data$Clipboard$copyToClipboard(
		$elm$json$Json$Encode$string(value));
};
var $author$project$Data$Api$BusinessProfile$errorToString = function (error) {
	switch (error.$) {
		case 'EMPTY_TITLE':
			return 'Title cannot be empty.';
		case 'INVALID_DESCRIPTION':
			return 'Description cannot exceed more than 1000 characters.';
		case 'INVALID_EMAIL':
			return 'Email provided is invalid.';
		case 'INVALID_PHONE':
			return 'Phone number is invalid.';
		case 'DOMAIN_NOT_FOUND':
			return 'Domain not found.';
		default:
			return 'Only business owner can update business profile.';
	}
};
var $author$project$Type$BusinessProfile$Loaded = {$: 'Loaded'};
var $author$project$Model$BusinessProfile$fillModelWithLoadProfilePayload = F2(
	function (_v0, model) {
		var business = _v0.business;
		return _Utils_update(
			model,
			{
				contact: A2($elm$core$Maybe$withDefault, '', business.contactName),
				description: A2($elm$core$Maybe$withDefault, '', business.description),
				email: A2($elm$core$Maybe$withDefault, '', business.contactEmail),
				loadStatus: $author$project$Type$BusinessProfile$Loaded,
				name: business.name,
				phone: A2($elm$core$Maybe$withDefault, '', business.contactPhone),
				plan: business.plan,
				shareReferralCode: business.shareReferralCode,
				title: A2($elm$core$Maybe$withDefault, '', business.title)
			});
	});
var $author$project$Material$Styled$Snackbar$hide = F2(
	function (timeout, msgFunc) {
		return A2(
			$elm$core$Task$perform,
			msgFunc,
			$elm$core$Process$sleep(timeout * 1000));
	});
var $author$project$Model$BusinessProfile$validateNotEmpty = F2(
	function (fieldName, value) {
		return $elm$core$String$isEmpty(value) ? $elm$core$Maybe$Just(fieldName + ' is required.') : $elm$core$Maybe$Nothing;
	});
var $author$project$Model$BusinessProfile$validateDescription = F2(
	function (fieldName, value) {
		var _v0 = A2($author$project$Model$BusinessProfile$validateNotEmpty, fieldName, value);
		if (_v0.$ === 'Nothing') {
			return ($elm$core$String$length(value) > 1000) ? $elm$core$Maybe$Just('Description cannot exceed 1000 characters.') : $elm$core$Maybe$Nothing;
		} else {
			var error = _v0.a;
			return $elm$core$Maybe$Just(error);
		}
	});
var $author$project$Model$BusinessProfile$update = F2(
	function (msg, model) {
		var _v0 = model;
		var apiEndPoint = _v0.apiEndPoint;
		var businessProfileModel = _v0.businessProfileModel;
		var appDomain = _v0.appDomain;
		var theme = _v0.theme;
		var loadTemplate = function (result) {
			if (result.$ === 'Ok') {
				var payload = result.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							businessProfileModel: _Utils_update(
								businessProfileModel,
								{templates: payload.templates})
						}),
					$elm$core$Platform$Cmd$none);
			} else {
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			}
		};
		var nonAuthMsg = function (msg_) {
			switch (msg_.$) {
				case 'LoadProfile':
					var result = msg_.a;
					if (result.$ === 'Ok') {
						var payload = result.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									businessProfileModel: A2($author$project$Model$BusinessProfile$fillModelWithLoadProfilePayload, payload, businessProfileModel),
									domainHost: $author$project$Data$Domain$fromString(payload.business.domain)
								}),
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										A4(
										$author$project$Model$Theme$loadDomainTheme,
										appDomain,
										theme.themeHost,
										$author$project$Data$Domain$fromString(payload.business.domain),
										model.baseHost),
										A2(
										$elm$core$Task$attempt,
										A2($elm$core$Basics$composeL, $author$project$Types$OnBusinessProfile, $author$project$Type$BusinessProfile$LoadTemplate),
										A2(
											$author$project$Data$Api$ListTemplate$call,
											apiEndPoint.listTemplate,
											$author$project$Data$Domain$fromString(payload.business.domain)))
									])));
					} else {
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									businessProfileModel: _Utils_update(
										businessProfileModel,
										{loadStatus: $author$project$Type$BusinessProfile$LoadError})
								}),
							$elm$core$Platform$Cmd$none);
					}
				case 'LoadTemplate':
					var result = msg_.a;
					return loadTemplate(result);
				case 'OnCloseModal':
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								businessProfileModel: _Utils_update(
									businessProfileModel,
									{modal: $author$project$Type$BusinessProfile$Closed})
							}),
						$elm$core$Platform$Cmd$none);
				case 'OnShowModal':
					var newModal = msg_.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								businessProfileModel: _Utils_update(
									businessProfileModel,
									{modal: newModal})
							}),
						$elm$core$Platform$Cmd$none);
				case 'OnRequestTemplateClick':
					var slug = msg_.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								businessProfileModel: _Utils_update(
									businessProfileModel,
									{modal: $author$project$Type$BusinessProfile$Closed})
							}),
						A2($elm$browser$Browser$Navigation$pushUrl, model.navKey, $author$project$Data$Route$routeUrl.fillTemplate + ('/' + slug)));
				default:
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			}
		};
		var _v1 = model.sessionModel;
		switch (_v1.$) {
			case 'Auth':
				var authModel = _v1.a;
				var _v2 = authModel;
				var user = _v2.user;
				switch (msg.$) {
					case 'LoadProfile':
						var result = msg.a;
						if (result.$ === 'Ok') {
							var payload = result.a;
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{
										businessProfileModel: A2($author$project$Model$BusinessProfile$fillModelWithLoadProfilePayload, payload, businessProfileModel),
										domainHost: $author$project$Data$Domain$fromString(payload.business.domain),
										sessionModel: $author$project$Types$Auth(
											_Utils_update(
												authModel,
												{
													user: _Utils_update(
														user,
														{
															domains: A2(
																$author$project$Data$Domain$select,
																$author$project$Data$Domain$fromString(payload.business.domain),
																user.domains)
														})
												}))
									}),
								$elm$core$Platform$Cmd$batch(
									_List_fromArray(
										[
											A4(
											$author$project$Model$Theme$loadDomainTheme,
											appDomain,
											theme.themeHost,
											$author$project$Data$Domain$fromString(payload.business.domain),
											model.baseHost),
											A2(
											$elm$core$Task$attempt,
											A2($elm$core$Basics$composeL, $author$project$Types$OnBusinessProfile, $author$project$Type$BusinessProfile$LoadTemplate),
											A2(
												$author$project$Data$Api$ListTemplate$call,
												apiEndPoint.listTemplate,
												$author$project$Data$Domain$fromString(payload.business.domain)))
										])));
						} else {
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{
										businessProfileModel: _Utils_update(
											businessProfileModel,
											{loadStatus: $author$project$Type$BusinessProfile$LoadError})
									}),
								$elm$core$Platform$Cmd$none);
						}
					case 'LoadTemplate':
						var result = msg.a;
						return loadTemplate(result);
					case 'OnInput':
						var field = msg.a;
						var value = msg.b;
						switch (field.$) {
							case 'Title':
								return _Utils_Tuple2(
									_Utils_update(
										model,
										{
											businessProfileModel: _Utils_update(
												businessProfileModel,
												{title: value})
										}),
									$elm$core$Platform$Cmd$none);
							case 'Description':
								return _Utils_Tuple2(
									_Utils_update(
										model,
										{
											businessProfileModel: _Utils_update(
												businessProfileModel,
												{description: value})
										}),
									$elm$core$Platform$Cmd$none);
							case 'Contact':
								return _Utils_Tuple2(
									_Utils_update(
										model,
										{
											businessProfileModel: _Utils_update(
												businessProfileModel,
												{contact: value})
										}),
									$elm$core$Platform$Cmd$none);
							case 'Email':
								return _Utils_Tuple2(
									_Utils_update(
										model,
										{
											businessProfileModel: _Utils_update(
												businessProfileModel,
												{email: value})
										}),
									$elm$core$Platform$Cmd$none);
							default:
								return _Utils_Tuple2(
									_Utils_update(
										model,
										{
											businessProfileModel: _Utils_update(
												businessProfileModel,
												{phone: value})
										}),
									$elm$core$Platform$Cmd$none);
						}
					case 'OnBlur':
						var field = msg.a;
						switch (field.$) {
							case 'Title':
								return _Utils_Tuple2(
									_Utils_update(
										model,
										{
											businessProfileModel: _Utils_update(
												businessProfileModel,
												{
													titleError: A2($author$project$Model$BusinessProfile$validateNotEmpty, 'Title', businessProfileModel.title)
												})
										}),
									$elm$core$Platform$Cmd$none);
							case 'Description':
								return _Utils_Tuple2(
									_Utils_update(
										model,
										{
											businessProfileModel: _Utils_update(
												businessProfileModel,
												{
													descriptionError: A2($author$project$Model$BusinessProfile$validateDescription, 'Description', businessProfileModel.description)
												})
										}),
									$elm$core$Platform$Cmd$none);
							case 'Contact':
								return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
							case 'Email':
								return _Utils_Tuple2(
									_Utils_update(
										model,
										{
											businessProfileModel: _Utils_update(
												businessProfileModel,
												{
													emailError: $author$project$Model$BusinessProfile$checkEmail(businessProfileModel.email)
												})
										}),
									$elm$core$Platform$Cmd$none);
							default:
								return _Utils_Tuple2(
									_Utils_update(
										model,
										{
											businessProfileModel: _Utils_update(
												businessProfileModel,
												{
													phoneError: $author$project$Model$BusinessProfile$checkPhoneNum(businessProfileModel.phone)
												})
										}),
									$elm$core$Platform$Cmd$none);
						}
					case 'OnSubmit':
						var updatedBusinessProfileModel = function (m) {
							return _Utils_update(
								m,
								{
									phoneError: $author$project$Model$BusinessProfile$checkPhoneNum(businessProfileModel.phone)
								});
						}(
							function (m) {
								return _Utils_update(
									m,
									{
										emailError: $author$project$Model$BusinessProfile$checkEmail(businessProfileModel.email)
									});
							}(
								function (m) {
									return _Utils_update(
										m,
										{
											descriptionError: A2($author$project$Model$BusinessProfile$validateDescription, 'Description', businessProfileModel.description)
										});
								}(
									_Utils_update(
										businessProfileModel,
										{
											titleError: A2($author$project$Model$BusinessProfile$validateNotEmpty, 'Title', businessProfileModel.title)
										}))));
						var allPassed = A2(
							$elm$core$List$all,
							$elm$core$Basics$eq($elm$core$Maybe$Nothing),
							_List_fromArray(
								[updatedBusinessProfileModel.titleError, updatedBusinessProfileModel.descriptionError, updatedBusinessProfileModel.emailError, updatedBusinessProfileModel.phoneError]));
						return allPassed ? _Utils_Tuple2(
							_Utils_update(
								model,
								{
									businessProfileModel: _Utils_update(
										updatedBusinessProfileModel,
										{formStatus: $author$project$Type$BusinessProfile$Submitting})
								}),
							A2(
								$elm$core$Task$attempt,
								A2($elm$core$Basics$composeL, $author$project$Types$OnBusinessProfile, $author$project$Type$BusinessProfile$OnSubmitResponse),
								A3(
									$author$project$Data$Api$BusinessProfile$authCall,
									user.jwt,
									apiEndPoint.updateBusinessProfile,
									{
										contactEmail: businessProfileModel.email,
										contactName: businessProfileModel.contact,
										contactPhone: businessProfileModel.phone,
										description: businessProfileModel.description,
										domain: $author$project$Data$Domain$selected(user.domains),
										title: businessProfileModel.title
									}))) : _Utils_Tuple2(
							_Utils_update(
								model,
								{businessProfileModel: updatedBusinessProfileModel}),
							$elm$core$Platform$Cmd$none);
					case 'OnSubmitResponse':
						var payload = msg.a;
						if (payload.$ === 'Ok') {
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{
										businessProfileModel: _Utils_update(
											businessProfileModel,
											{
												formStatus: $author$project$Type$BusinessProfile$Ready($author$project$Type$BusinessProfile$Success)
											})
									}),
								$elm$core$Platform$Cmd$none);
						} else {
							var error = payload.a;
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{
										businessProfileModel: _Utils_update(
											businessProfileModel,
											{
												formStatus: $author$project$Type$BusinessProfile$Error(
													A2($author$project$Data$Api$authErrorToString, $author$project$Data$Api$BusinessProfile$errorToString, error))
											})
									}),
								$elm$core$Platform$Cmd$none);
						}
					case 'OnBannerClose':
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									businessProfileModel: _Utils_update(
										businessProfileModel,
										{
											formStatus: $author$project$Type$BusinessProfile$Ready($author$project$Type$BusinessProfile$Close)
										})
								}),
							$elm$core$Platform$Cmd$none);
					case 'OnCopyOrgReferralCodeClick':
						var orgReferralCode = msg.a;
						var timeout = msg.b;
						var newModel = _Utils_update(
							model,
							{
								businessProfileModel: _Utils_update(
									businessProfileModel,
									{referralCodeSnackBarStatus: $author$project$Material$Styled$Snackbar$Show})
							});
						return _Utils_Tuple2(
							newModel,
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										$author$project$Data$Clipboard$encodeAndCopy(orgReferralCode),
										A2(
										$author$project$Material$Styled$Snackbar$hide,
										timeout,
										A2($elm$core$Basics$composeL, $author$project$Types$OnBusinessProfile, $author$project$Type$BusinessProfile$CloseSnackBar))
									])));
					case 'CloseSnackBar':
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									businessProfileModel: _Utils_update(
										businessProfileModel,
										{referralCodeSnackBarStatus: $author$project$Material$Styled$Snackbar$Hide})
								}),
							$elm$core$Platform$Cmd$none);
					case 'OnPageEnter':
						var endPoint = msg.a;
						var domain = msg.b;
						return _Utils_Tuple2(
							model,
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										A2(
										$elm$core$Task$attempt,
										A2($elm$core$Basics$composeL, $author$project$Types$OnBusinessProfile, $author$project$Type$BusinessProfile$LoadProfile),
										A2(
											$author$project$Data$Api$Business$Profile$call,
											endPoint.businessProfile,
											{domain: domain})),
										A2(
										$elm$core$Task$attempt,
										A2($elm$core$Basics$composeL, $author$project$Types$OnBusinessProfile, $author$project$Type$BusinessProfile$LoadTemplate),
										A2($author$project$Data$Api$ListTemplate$call, endPoint.listTemplate, domain))
									])));
					case 'OnCloseModal':
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									businessProfileModel: _Utils_update(
										businessProfileModel,
										{modal: $author$project$Type$BusinessProfile$Closed})
								}),
							$elm$core$Platform$Cmd$none);
					case 'OnShowModal':
						var newModal = msg.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									businessProfileModel: _Utils_update(
										businessProfileModel,
										{modal: newModal})
								}),
							$elm$core$Platform$Cmd$none);
					case 'OnRequestTemplateClick':
						var slug = msg.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									businessProfileModel: _Utils_update(
										businessProfileModel,
										{
											modal: $author$project$Type$BusinessProfile$RequestTemplate(slug)
										})
								}),
							$elm$core$Platform$Cmd$none);
					case 'OnRequestTemplateConfirm':
						var slug = msg.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									businessProfileModel: _Utils_update(
										businessProfileModel,
										{modal: $author$project$Type$BusinessProfile$LoadingState})
								}),
							A2(
								$elm$core$Task$attempt,
								A2($elm$core$Basics$composeL, $author$project$Types$OnBusinessProfile, $author$project$Type$BusinessProfile$OnRequestTemplateResult),
								A2(
									$author$project$Data$Api$PDF$IssueAnonymous$call,
									apiEndPoint.issueAnonymousTemplateToken,
									{email: user.email, slug: slug})));
					case 'OnRequestTemplateResult':
						var result = msg.a;
						if (result.$ === 'Ok') {
							var value = result.a;
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{
										businessProfileModel: _Utils_update(
											businessProfileModel,
											{
												modal: $author$project$Type$BusinessProfile$RequestTemplateSuccess(value.docId)
											})
									}),
								$elm$core$Platform$Cmd$none);
						} else {
							return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
						}
					case 'OnNavigateToDashboard':
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									businessProfileModel: _Utils_update(
										businessProfileModel,
										{modal: $author$project$Type$BusinessProfile$Closed})
								}),
							A2($elm$browser$Browser$Navigation$pushUrl, model.navKey, $author$project$Data$Route$routeUrl.dashboard));
					default:
						var docId = msg.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									businessProfileModel: _Utils_update(
										businessProfileModel,
										{modal: $author$project$Type$BusinessProfile$Closed})
								}),
							A2(
								$elm$browser$Browser$Navigation$pushUrl,
								model.navKey,
								_Utils_ap($author$project$Data$Route$routeUrl.viewDocument, docId)));
				}
			case 'Anonymous':
				return nonAuthMsg(msg);
			case 'NoAuth':
				return nonAuthMsg(msg);
			default:
				return nonAuthMsg(msg);
		}
	});
var $author$project$Type$BusinessRegister$Error = function (a) {
	return {$: 'Error', a: a};
};
var $author$project$Type$BusinessRegister$OnValidateDomain = {$: 'OnValidateDomain'};
var $author$project$Type$BusinessRegister$Retry = {$: 'Retry'};
var $author$project$Type$BusinessRegister$Submitting = {$: 'Submitting'};
var $author$project$Type$BusinessRegister$Validating = {$: 'Validating'};
var $author$project$Model$BusinessRegister$checkoutToStripe = _Platform_outgoingPort('checkoutToStripe', $elm$core$Basics$identity);
var $elm$browser$Browser$Dom$getElement = _Browser_getElement;
var $author$project$Model$BusinessRegister$jumpToForm = function (id) {
	return A2(
		$elm$core$Task$attempt,
		function (_v0) {
			return $author$project$Types$Noop;
		},
		A2(
			$elm$core$Task$andThen,
			function (info) {
				return A2($elm$browser$Browser$Dom$setViewport, info.element.x, info.element.y);
			},
			$elm$browser$Browser$Dom$getElement(id)));
};
var $author$project$Type$BusinessRegister$OnSubmitResponse = function (a) {
	return {$: 'OnSubmitResponse', a: a};
};
var $author$project$Data$Api$Register$Business$Payload = function (sessionId) {
	return {sessionId: sessionId};
};
var $author$project$Data$Api$Register$Business$dataDecoder = A2(
	$elm$json$Json$Decode$map,
	$author$project$Data$Api$Register$Business$Payload,
	A2($elm$json$Json$Decode$field, 'sessionId', $elm$json$Json$Decode$string));
var $author$project$Data$Api$Register$Business$encode = function (params) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'subdomain',
				$elm$json$Json$Encode$string(params.subdomain)),
				_Utils_Tuple2(
				'companyName',
				$elm$json$Json$Encode$string(params.companyName)),
				_Utils_Tuple2(
				'firstName',
				$elm$json$Json$Encode$string(params.firstName)),
				_Utils_Tuple2(
				'lastName',
				$elm$json$Json$Encode$string(params.lastName)),
				_Utils_Tuple2(
				'email',
				$elm$json$Json$Encode$string(params.email)),
				_Utils_Tuple2(
				'password',
				$elm$json$Json$Encode$string(params.password)),
				_Utils_Tuple2(
				'referralCode',
				$elm$json$Json$Encode$string(params.referralCode))
			]));
};
var $author$project$Data$Api$Register$Business$EMPTY_NAME = {$: 'EMPTY_NAME'};
var $author$project$Data$Api$Register$Business$INVALID_COMPANYNAME = {$: 'INVALID_COMPANYNAME'};
var $author$project$Data$Api$Register$Business$INVALID_EMAIL = {$: 'INVALID_EMAIL'};
var $author$project$Data$Api$Register$Business$INVALID_SUBDOMAIN = {$: 'INVALID_SUBDOMAIN'};
var $author$project$Data$Api$Register$Business$PASSWORD_REQUIREMENT = {$: 'PASSWORD_REQUIREMENT'};
var $author$project$Data$Api$Register$Business$UPDATE_ANONYMOUS = {$: 'UPDATE_ANONYMOUS'};
var $author$project$Data$Api$Register$Business$USER_EXIST = {$: 'USER_EXIST'};
var $author$project$Data$Api$Register$Business$errorDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (errorCode) {
		switch (errorCode) {
			case 'INVALID_SUBDOMAIN':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$Register$Business$INVALID_SUBDOMAIN);
			case 'INVALID_COMPANYNAME':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$Register$Business$INVALID_COMPANYNAME);
			case 'EMPTY_NAME':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$Register$Business$EMPTY_NAME);
			case 'PASSWORD_REQUIREMENT':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$Register$Business$PASSWORD_REQUIREMENT);
			case 'USER_EXIST':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$Register$Business$USER_EXIST);
			case 'INVALID_EMAIL':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$Register$Business$INVALID_EMAIL);
			case 'UPDATE_ANONYMOUS':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$Register$Business$UPDATE_ANONYMOUS);
			default:
				return $elm$json$Json$Decode$fail('Invalid error code: ' + errorCode);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Data$Api$Register$Business$call = F2(
	function (endPoint, params) {
		return A4(
			$author$project$Data$Api$httpTask,
			endPoint,
			$author$project$Data$Api$Register$Business$errorDecoder,
			$author$project$Data$Api$Register$Business$dataDecoder,
			$author$project$Data$Api$Register$Business$encode(params));
	});
var $author$project$Model$BusinessRegister$submitCmd = F2(
	function (endpoint, params) {
		return A2(
			$elm$core$Task$attempt,
			A2($elm$core$Basics$composeL, $author$project$Types$OnBusinessRegister, $author$project$Type$BusinessRegister$OnSubmitResponse),
			A2($author$project$Data$Api$Register$Business$call, endpoint, params));
	});
var $author$project$Model$BusinessRegister$trimRemoveSpace = function (str) {
	return A3(
		$elm$core$String$replace,
		' ',
		'',
		$elm$core$String$trim(str));
};
var $author$project$Model$BusinessRegister$validateHasAgreedTerms = function (hasAgreed) {
	return hasAgreed ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just('You must agree to the terms of service and privacy policy to sign up.');
};
var $author$project$Model$BusinessRegister$validateNotEmpty = F2(
	function (fieldName, value) {
		return $elm$core$String$isEmpty(value) ? $elm$core$Maybe$Just(fieldName + ' is required.') : $elm$core$Maybe$Nothing;
	});
var $author$project$Type$BusinessRegister$OnValidateDomainResponse = function (a) {
	return {$: 'OnValidateDomainResponse', a: a};
};
var $author$project$Model$BusinessRegister$validateSubDomain = F2(
	function (endpoint, subDomain) {
		return A2(
			$elm$core$Task$attempt,
			A2($elm$core$Basics$composeL, $author$project$Types$OnBusinessRegister, $author$project$Type$BusinessRegister$OnValidateDomainResponse),
			A2(
				$author$project$Data$Api$Register$ValidateDomain$call,
				endpoint,
				{subdomain: subDomain}));
	});
var $author$project$Model$BusinessRegister$validateSubDomainErrorString = function (status) {
	switch (status.$) {
		case 'Used':
			return $elm$core$Maybe$Just('This domain name is already in use.');
		case 'Reserved':
			return $elm$core$Maybe$Just('This domain name is reserved.');
		case 'Invalid':
			return $elm$core$Maybe$Just('This domain name contain invalid characters.');
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Model$BusinessRegister$update = F2(
	function (msg, model) {
		var _v0 = model;
		var businessRegisterModel = _v0.businessRegisterModel;
		var apiEndPoint = _v0.apiEndPoint;
		switch (msg.$) {
			case 'OnInput':
				var field = msg.a;
				var value = msg.b;
				switch (field.$) {
					case 'SubDomain':
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									businessRegisterModel: _Utils_update(
										businessRegisterModel,
										{
											subdomain: $author$project$Model$BusinessRegister$trimRemoveSpace(value),
											subdomainStatus: $elm$core$Maybe$Nothing
										})
								}),
							$elm$core$Platform$Cmd$none);
					case 'CompanyName':
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									businessRegisterModel: _Utils_update(
										businessRegisterModel,
										{companyName: value})
								}),
							$elm$core$Platform$Cmd$none);
					case 'FirstName':
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									businessRegisterModel: _Utils_update(
										businessRegisterModel,
										{firstName: value})
								}),
							$elm$core$Platform$Cmd$none);
					case 'LastName':
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									businessRegisterModel: _Utils_update(
										businessRegisterModel,
										{lastName: value})
								}),
							$elm$core$Platform$Cmd$none);
					case 'Email':
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									businessRegisterModel: _Utils_update(
										businessRegisterModel,
										{email: value})
								}),
							$elm$core$Platform$Cmd$none);
					case 'Password':
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									businessRegisterModel: _Utils_update(
										businessRegisterModel,
										{password: value})
								}),
							$elm$core$Platform$Cmd$none);
					case 'PasswordAgain':
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									businessRegisterModel: _Utils_update(
										businessRegisterModel,
										{passwordAgain: value})
								}),
							$elm$core$Platform$Cmd$none);
					default:
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									businessRegisterModel: _Utils_update(
										businessRegisterModel,
										{referralCode: value})
								}),
							$elm$core$Platform$Cmd$none);
				}
			case 'OnBlur':
				var field = msg.a;
				switch (field.$) {
					case 'SubDomain':
						return _Utils_Tuple2(
							model,
							A2(
								$elm$core$Task$perform,
								$author$project$Types$OnBusinessRegister,
								$elm$core$Task$succeed($author$project$Type$BusinessRegister$OnValidateDomain)));
					case 'CompanyName':
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									businessRegisterModel: _Utils_update(
										businessRegisterModel,
										{
											companyNameError: A2($author$project$Model$BusinessRegister$validateNotEmpty, 'Company name', businessRegisterModel.companyName)
										})
								}),
							$elm$core$Platform$Cmd$none);
					case 'FirstName':
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									businessRegisterModel: _Utils_update(
										businessRegisterModel,
										{
											firstNameError: A2($author$project$Model$BusinessRegister$validateNotEmpty, 'First name', businessRegisterModel.firstName)
										})
								}),
							$elm$core$Platform$Cmd$none);
					case 'LastName':
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									businessRegisterModel: _Utils_update(
										businessRegisterModel,
										{
											lastNameError: A2($author$project$Model$BusinessRegister$validateNotEmpty, 'Last name', businessRegisterModel.lastName)
										})
								}),
							$elm$core$Platform$Cmd$none);
					case 'Email':
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									businessRegisterModel: _Utils_update(
										businessRegisterModel,
										{
											emailError: $author$project$Data$Validator$validateEmail(businessRegisterModel.email)
										})
								}),
							$elm$core$Platform$Cmd$none);
					case 'Password':
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									businessRegisterModel: _Utils_update(
										businessRegisterModel,
										{
											passwordError: $author$project$Data$Validator$validatePassword(businessRegisterModel.password)
										})
								}),
							$elm$core$Platform$Cmd$none);
					case 'PasswordAgain':
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									businessRegisterModel: _Utils_update(
										businessRegisterModel,
										{
											passwordAgainError: A2($author$project$Data$Validator$validatePasswordAgain, businessRegisterModel.password, businessRegisterModel.passwordAgain)
										})
								}),
							$elm$core$Platform$Cmd$none);
					default:
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 'OnAgreeTerms':
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							businessRegisterModel: _Utils_update(
								businessRegisterModel,
								{hasAgreedTerms: !businessRegisterModel.hasAgreedTerms, hasAgreedTermsError: $elm$core$Maybe$Nothing})
						}),
					$elm$core$Platform$Cmd$none);
			case 'OnValidateDomain':
				var domainLength = $elm$core$String$length(
					$elm$core$String$trim(businessRegisterModel.subdomain));
				return ((domainLength > 0) && (domainLength <= 63)) ? _Utils_Tuple2(
					_Utils_update(
						model,
						{
							businessRegisterModel: _Utils_update(
								businessRegisterModel,
								{subdomainError: $elm$core$Maybe$Nothing, validationStatus: $author$project$Type$BusinessRegister$Validating})
						}),
					A2(
						$author$project$Model$BusinessRegister$validateSubDomain,
						apiEndPoint.validateDomain,
						$elm$core$String$toLower(
							$author$project$Model$BusinessRegister$trimRemoveSpace(businessRegisterModel.subdomain)))) : ((domainLength > 63) ? _Utils_Tuple2(
					_Utils_update(
						model,
						{
							businessRegisterModel: _Utils_update(
								businessRegisterModel,
								{
									subdomainError: $elm$core$Maybe$Just('Subdomain cannot exceed 63 characters.'),
									subdomainStatus: $elm$core$Maybe$Nothing
								})
						}),
					$elm$core$Platform$Cmd$none) : _Utils_Tuple2(
					_Utils_update(
						model,
						{
							businessRegisterModel: _Utils_update(
								businessRegisterModel,
								{
									subdomainError: $elm$core$Maybe$Just('Subdomain cannot be empty.'),
									subdomainStatus: $elm$core$Maybe$Nothing
								})
						}),
					$elm$core$Platform$Cmd$none));
			case 'OnValidateDomainResponse':
				var result = msg.a;
				if (result.$ === 'Ok') {
					var status = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								businessRegisterModel: _Utils_update(
									businessRegisterModel,
									{
										subdomainError: $author$project$Model$BusinessRegister$validateSubDomainErrorString(status.status),
										subdomainStatus: $elm$core$Maybe$Just(status.status),
										validationStatus: $author$project$Type$BusinessRegister$Loaded
									})
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								businessRegisterModel: _Utils_update(
									businessRegisterModel,
									{validationStatus: $author$project$Type$BusinessRegister$Retry})
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 'OnSubmit':
				var _v6 = businessRegisterModel;
				var subdomain = _v6.subdomain;
				var companyName = _v6.companyName;
				var firstName = _v6.firstName;
				var lastName = _v6.lastName;
				var email = _v6.email;
				var password = _v6.password;
				var passwordAgain = _v6.passwordAgain;
				var hasAgreedTerms = _v6.hasAgreedTerms;
				var referralCode = _v6.referralCode;
				var updatedRegisterModel = function (m) {
					return _Utils_update(
						m,
						{
							hasAgreedTermsError: $author$project$Model$BusinessRegister$validateHasAgreedTerms(hasAgreedTerms)
						});
				}(
					function (m) {
						return _Utils_update(
							m,
							{
								passwordAgainError: A2($author$project$Data$Validator$validatePasswordAgain, password, passwordAgain)
							});
					}(
						function (m) {
							return _Utils_update(
								m,
								{
									passwordError: $author$project$Data$Validator$validatePassword(password)
								});
						}(
							function (m) {
								return _Utils_update(
									m,
									{
										emailError: $author$project$Data$Validator$validateEmail(email)
									});
							}(
								function (m) {
									return _Utils_update(
										m,
										{
											lastNameError: A2($author$project$Model$BusinessRegister$validateNotEmpty, 'Last name', lastName)
										});
								}(
									function (m) {
										return _Utils_update(
											m,
											{
												firstNameError: A2($author$project$Model$BusinessRegister$validateNotEmpty, 'First name', firstName)
											});
									}(
										_Utils_update(
											businessRegisterModel,
											{
												companyNameError: A2($author$project$Model$BusinessRegister$validateNotEmpty, 'Company name', companyName)
											})))))));
				var allPassed = A2(
					$elm$core$List$all,
					$elm$core$Basics$eq($elm$core$Maybe$Nothing),
					_List_fromArray(
						[updatedRegisterModel.companyNameError, updatedRegisterModel.firstNameError, updatedRegisterModel.lastNameError, updatedRegisterModel.emailError, updatedRegisterModel.passwordError, updatedRegisterModel.passwordAgainError, updatedRegisterModel.hasAgreedTermsError]));
				var validStatus = A2(
					$elm$core$Maybe$withDefault,
					false,
					A2(
						$elm$core$Maybe$map,
						function (status) {
							return _Utils_eq(status, $author$project$Data$Api$Register$ValidateDomain$NotUse);
						},
						updatedRegisterModel.subdomainStatus));
				if (allPassed && validStatus) {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								businessRegisterModel: _Utils_update(
									updatedRegisterModel,
									{formStatus: $author$project$Type$BusinessRegister$Submitting})
							}),
						A2(
							$author$project$Model$BusinessRegister$submitCmd,
							model.apiEndPoint.registerBusiness,
							{
								companyName: companyName,
								email: email,
								firstName: firstName,
								lastName: lastName,
								password: password,
								referralCode: referralCode,
								subdomain: $elm$core$String$toLower(
									$author$project$Model$BusinessRegister$trimRemoveSpace(subdomain))
							}));
				} else {
					if (!validStatus) {
						var _v7 = updatedRegisterModel.subdomainStatus;
						if (_v7.$ === 'Nothing') {
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{
										businessRegisterModel: _Utils_update(
											updatedRegisterModel,
											{
												formStatus: $author$project$Type$BusinessRegister$Ready,
												subdomainError: $elm$core$Maybe$Just('Domain name cannot be empty')
											})
									}),
								$elm$core$Platform$Cmd$none);
						} else {
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{
										businessRegisterModel: _Utils_update(
											updatedRegisterModel,
											{formStatus: $author$project$Type$BusinessRegister$Ready})
									}),
								$elm$core$Platform$Cmd$none);
						}
					} else {
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									businessRegisterModel: _Utils_update(
										updatedRegisterModel,
										{formStatus: $author$project$Type$BusinessRegister$Ready})
								}),
							$elm$core$Platform$Cmd$none);
					}
				}
			case 'OnSubmitResponse':
				var result = msg.a;
				if (result.$ === 'Ok') {
					var value = result.a;
					return _Utils_Tuple2(
						model,
						$author$project$Model$BusinessRegister$checkoutToStripe(
							$elm$json$Json$Encode$string(value.sessionId)));
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								businessRegisterModel: _Utils_update(
									businessRegisterModel,
									{
										formStatus: $author$project$Type$BusinessRegister$Error(error)
									})
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 'OnRedirectError':
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							businessRegisterModel: _Utils_update(
								businessRegisterModel,
								{
									formStatus: $author$project$Type$BusinessRegister$Ready,
									redirectError: $elm$core$Maybe$Just('Unable to redirect to stripe, please try again.')
								})
						}),
					$elm$core$Platform$Cmd$none);
			default:
				return _Utils_Tuple2(
					model,
					$author$project$Model$BusinessRegister$jumpToForm('businessRegister'));
		}
	});
var $author$project$Type$BusinessTheme$BannerBackground = {$: 'BannerBackground'};
var $author$project$Type$BusinessTheme$BannerLogo = {$: 'BannerLogo'};
var $author$project$Type$BusinessTheme$Error = function (a) {
	return {$: 'Error', a: a};
};
var $author$project$Type$BusinessTheme$HeaderColor = {$: 'HeaderColor'};
var $author$project$Type$BusinessTheme$HeaderLogo = {$: 'HeaderLogo'};
var $author$project$Type$BusinessTheme$ImageLoaded = function (a) {
	return {$: 'ImageLoaded', a: a};
};
var $author$project$Type$BusinessTheme$ImageUrl = function (a) {
	return {$: 'ImageUrl', a: a};
};
var $author$project$Type$Theme$Loaded = function (a) {
	return {$: 'Loaded', a: a};
};
var $author$project$Type$BusinessTheme$Loading = function (a) {
	return {$: 'Loading', a: a};
};
var $author$project$Type$BusinessTheme$OnSubmitImageResponse = F2(
	function (a, b) {
		return {$: 'OnSubmitImageResponse', a: a, b: b};
	});
var $author$project$Type$BusinessTheme$OnSubmitResponse = F2(
	function (a, b) {
		return {$: 'OnSubmitResponse', a: a, b: b};
	});
var $author$project$Type$BusinessTheme$Opened = F2(
	function (a, b) {
		return {$: 'Opened', a: a, b: b};
	});
var $author$project$Type$BusinessTheme$Processing = F2(
	function (a, b) {
		return {$: 'Processing', a: a, b: b};
	});
var $author$project$Data$Api$Business$HeaderColor$Payload = function (message) {
	return {message: message};
};
var $author$project$Data$Api$Business$HeaderColor$dataDecoder = A2(
	$elm$json$Json$Decode$map,
	$author$project$Data$Api$Business$HeaderColor$Payload,
	A2($elm$json$Json$Decode$field, 'message', $elm$json$Json$Decode$string));
var $author$project$Data$Api$Business$HeaderColor$encode = function (_v0) {
	var domain = _v0.domain;
	var color = _v0.color;
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'domain',
				$author$project$Data$Domain$encode(domain)),
				_Utils_Tuple2(
				'color',
				$elm$json$Json$Encode$string(color))
			]));
};
var $author$project$Data$Api$Business$HeaderColor$DOMAIN_EMPTY = {$: 'DOMAIN_EMPTY'};
var $author$project$Data$Api$Business$HeaderColor$FAILED_TO_UPLOAD = {$: 'FAILED_TO_UPLOAD'};
var $author$project$Data$Api$Business$HeaderColor$PERMISSION_DENIED = {$: 'PERMISSION_DENIED'};
var $author$project$Data$Api$Business$HeaderColor$errorDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (errorCode) {
		switch (errorCode) {
			case 'PERMISSION_DENIED':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$Business$HeaderColor$PERMISSION_DENIED);
			case 'DOMAIN_EMPTY':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$Business$HeaderColor$DOMAIN_EMPTY);
			case 'FAILED_TO_UPLOAD':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$Business$HeaderColor$FAILED_TO_UPLOAD);
			default:
				return $elm$json$Json$Decode$fail('Invalid error code: ' + errorCode);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Data$Api$Business$HeaderColor$authCall = F3(
	function (jwt, endPoint, params) {
		return A5(
			$author$project$Data$Api$authCall,
			jwt,
			endPoint,
			$author$project$Data$Api$Business$HeaderColor$errorDecoder,
			$author$project$Data$Api$Business$HeaderColor$dataDecoder,
			$author$project$Data$Api$Business$HeaderColor$encode(params));
	});
var $elm$file$File$Select$file = F2(
	function (mimes, toMsg) {
		return A2(
			$elm$core$Task$perform,
			toMsg,
			_File_uploadOne(mimes));
	});
var $author$project$ImageEditor$getImageEditorDataAndDestroy = _Platform_outgoingPort(
	'getImageEditorDataAndDestroy',
	function ($) {
		return $elm$json$Json$Encode$null;
	});
var $author$project$ImageEditor$getImageDataAndDestroy = function (_v0) {
	return $author$project$ImageEditor$getImageEditorDataAndDestroy(_Utils_Tuple0);
};
var $author$project$ImageEditor$loadImageEditor = _Platform_outgoingPort('loadImageEditor', $elm$core$Basics$identity);
var $author$project$ImageEditor$load = function (_v0) {
	var cropWidth = _v0.cropWidth;
	var cropHeight = _v0.cropHeight;
	return $author$project$ImageEditor$loadImageEditor(
		$elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'cropWidth',
					$elm$json$Json$Encode$int(cropWidth)),
					_Utils_Tuple2(
					'cropHeight',
					$elm$json$Json$Encode$int(cropHeight))
				])));
};
var $elm$core$Tuple$mapSecond = F2(
	function (func, _v0) {
		var x = _v0.a;
		var y = _v0.b;
		return _Utils_Tuple2(
			x,
			func(y));
	});
var $elm$file$File$mime = _File_mime;
var $elm$core$Tuple$second = function (_v0) {
	var y = _v0.b;
	return y;
};
var $elm$file$File$size = _File_size;
var $elm$file$File$toUrl = _File_toUrl;
var $author$project$ImageEditor$updateImageEditor = _Platform_outgoingPort('updateImageEditor', $elm$json$Json$Encode$string);
var $author$project$ImageEditor$update = function (action) {
	switch (action.$) {
		case 'ZoomIn':
			return $author$project$ImageEditor$updateImageEditor('ZoomIn');
		case 'ZoomOut':
			return $author$project$ImageEditor$updateImageEditor('ZoomOut');
		case 'RotateCW':
			return $author$project$ImageEditor$updateImageEditor('RotateCW');
		default:
			return $author$project$ImageEditor$updateImageEditor('RotateCCW');
	}
};
var $elm$http$Http$multipartBody = function (parts) {
	return A2(
		_Http_pair,
		'',
		_Http_toFormData(parts));
};
var $author$project$Data$Api$authUpload = F5(
	function (jwt, url, errorDecoder, dataDecoder, bodyParts) {
		return $elm$http$Http$task(
			{
				body: $elm$http$Http$multipartBody(bodyParts),
				headers: _List_fromArray(
					[
						A2($elm$http$Http$header, 'Authorization', 'Bearer ' + jwt)
					]),
				method: 'POST',
				resolver: $elm$http$Http$stringResolver(
					A2($author$project$Data$Api$authResponseResolver, errorDecoder, dataDecoder)),
				timeout: $elm$core$Maybe$Just(180000),
				url: url
			});
	});
var $author$project$Data$Api$Business$Theme$Payload = function (message) {
	return {message: message};
};
var $author$project$Data$Api$Business$Theme$dataDecoder = A2(
	$elm$json$Json$Decode$map,
	$author$project$Data$Api$Business$Theme$Payload,
	A2($elm$json$Json$Decode$field, 'message', $elm$json$Json$Decode$string));
var $author$project$Data$Api$Business$Theme$encodeToString = function (_v0) {
	var domain = _v0.domain;
	return A2(
		$elm$json$Json$Encode$encode,
		0,
		$elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'domain',
					$elm$json$Json$Encode$string(
						$author$project$Data$Domain$toString(domain)))
				])));
};
var $author$project$Data$Api$Business$Theme$DOMAIN_EMPTY = {$: 'DOMAIN_EMPTY'};
var $author$project$Data$Api$Business$Theme$FAILED_TO_UPLOAD = {$: 'FAILED_TO_UPLOAD'};
var $author$project$Data$Api$Business$Theme$LIMIT_FIELD_COUNT = {$: 'LIMIT_FIELD_COUNT'};
var $author$project$Data$Api$Business$Theme$LIMIT_FIELD_KEY = {$: 'LIMIT_FIELD_KEY'};
var $author$project$Data$Api$Business$Theme$LIMIT_FIELD_VALUE = {$: 'LIMIT_FIELD_VALUE'};
var $author$project$Data$Api$Business$Theme$LIMIT_FILE_COUNT = {$: 'LIMIT_FILE_COUNT'};
var $author$project$Data$Api$Business$Theme$LIMIT_FILE_SIZE = {$: 'LIMIT_FILE_SIZE'};
var $author$project$Data$Api$Business$Theme$LIMIT_PART_COUNT = {$: 'LIMIT_PART_COUNT'};
var $author$project$Data$Api$Business$Theme$LIMIT_UNEXPECTED_FILE = {$: 'LIMIT_UNEXPECTED_FILE'};
var $author$project$Data$Api$Business$Theme$PERMISSION_DENIED = {$: 'PERMISSION_DENIED'};
var $author$project$Data$Api$Business$Theme$errorDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (errorCode) {
		switch (errorCode) {
			case 'PERMISSION_DENIED':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$Business$Theme$PERMISSION_DENIED);
			case 'DOMAIN_EMPTY':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$Business$Theme$DOMAIN_EMPTY);
			case 'FAILED_TO_UPLOAD':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$Business$Theme$FAILED_TO_UPLOAD);
			case 'LIMIT_PART_COUNT':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$Business$Theme$LIMIT_PART_COUNT);
			case 'LIMIT_FILE_SIZE':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$Business$Theme$LIMIT_FILE_SIZE);
			case 'LIMIT_FILE_COUNT':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$Business$Theme$LIMIT_FILE_COUNT);
			case 'LIMIT_FIELD_KEY':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$Business$Theme$LIMIT_FIELD_KEY);
			case 'LIMIT_FIELD_VALUE':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$Business$Theme$LIMIT_FIELD_VALUE);
			case 'LIMIT_FIELD_COUNT':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$Business$Theme$LIMIT_FIELD_COUNT);
			case 'LIMIT_UNEXPECTED_FILE':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$Business$Theme$LIMIT_UNEXPECTED_FILE);
			default:
				return $elm$json$Json$Decode$fail('Invalid error code: ' + errorCode);
		}
	},
	$elm$json$Json$Decode$string);
var $elm$http$Http$filePart = _Http_pair;
var $elm$http$Http$stringPart = _Http_pair;
var $author$project$Data$Api$Business$Theme$upload = F5(
	function (jwt, endPoint, params, file, field) {
		return A5(
			$author$project$Data$Api$authUpload,
			jwt,
			endPoint,
			$author$project$Data$Api$Business$Theme$errorDecoder,
			$author$project$Data$Api$Business$Theme$dataDecoder,
			_List_fromArray(
				[
					A2(
					$elm$http$Http$stringPart,
					'data',
					$author$project$Data$Api$Business$Theme$encodeToString(params)),
					A2($elm$http$Http$filePart, field, file)
				]));
	});
var $author$project$Model$BusinessTheme$update = F3(
	function (themeMsg, authModel, appModel) {
		var _v0 = authModel;
		var businessThemeForm = _v0.businessThemeForm;
		var user = _v0.user;
		var updateFormModel = function (updateFunction) {
			return _Utils_update(
				appModel,
				{
					sessionModel: $author$project$Types$Auth(
						_Utils_update(
							authModel,
							{
								businessThemeForm: updateFunction(businessThemeForm)
							}))
				});
		};
		var _v1 = appModel;
		var apiEndPoint = _v1.apiEndPoint;
		var theme = _v1.theme;
		var themeStatus = theme.theme;
		var themeState = function () {
			if (themeStatus.$ === 'Loaded') {
				var status = themeStatus.a;
				return status;
			} else {
				return $author$project$Data$BusinessTheme$default;
			}
		}();
		var _v2 = businessThemeForm;
		var headerColor = _v2.headerColor;
		var headerLogo = _v2.headerLogo;
		var bannerLogo = _v2.bannerLogo;
		var bannerBackground = _v2.bannerBackground;
		var imageEditorState = _v2.imageEditorState;
		var updateTextField = F2(
			function (field, updateFunction) {
				return updateFormModel(
					function (model) {
						return _Utils_update(
							model,
							{
								headerColor: updateFunction(headerColor)
							});
					});
			});
		var updateImageField = F2(
			function (field, updateFunction) {
				switch (field.$) {
					case 'HeaderLogo':
						return updateFormModel(
							function (model) {
								return _Utils_update(
									model,
									{
										headerLogo: updateFunction(headerLogo)
									});
							});
					case 'BannerLogo':
						return updateFormModel(
							function (model) {
								return _Utils_update(
									model,
									{
										bannerLogo: updateFunction(bannerLogo)
									});
							});
					default:
						return updateFormModel(
							function (model) {
								return _Utils_update(
									model,
									{
										bannerBackground: updateFunction(bannerBackground)
									});
							});
				}
			});
		var updateImageEditor = function (updateFunction) {
			return updateFormModel(
				function (model) {
					return _Utils_update(
						model,
						{
							imageEditorState: updateFunction(imageEditorState)
						});
				});
		};
		switch (themeMsg.$) {
			case 'OnImageAction':
				var field = themeMsg.a;
				var action = themeMsg.b;
				switch (action.$) {
					case 'ImageRequested':
						return _Utils_Tuple2(
							appModel,
							A2(
								$elm$file$File$Select$file,
								_List_fromArray(
									['image/*']),
								A2(
									$elm$core$Basics$composeL,
									A2(
										$elm$core$Basics$composeL,
										A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnBusinessChangeTheme),
										$author$project$Type$BusinessTheme$OnImageAction(field)),
									$author$project$Type$BusinessTheme$ImageLoaded)));
					case 'ImageLoaded':
						var file = action.a;
						return (!A2(
							$elm$core$List$member,
							$elm$file$File$mime(file),
							_List_fromArray(
								['image/jpg', 'image/jpeg', 'image/gif', 'image/png']))) ? _Utils_Tuple2(
							A2(
								updateImageField,
								field,
								$elm$core$Tuple$mapSecond(
									function (_v5) {
										return $author$project$Type$BusinessTheme$Error('Invalid file type.');
									})),
							$elm$core$Platform$Cmd$none) : ((_Utils_eq(field, $author$project$Type$BusinessTheme$HeaderLogo) && ($elm$file$File$size(file) > 300000)) ? _Utils_Tuple2(
							A2(
								updateImageField,
								field,
								$elm$core$Tuple$mapSecond(
									function (_v6) {
										return $author$project$Type$BusinessTheme$Error('File size cannot exceed 300kb.');
									})),
							$elm$core$Platform$Cmd$none) : (((_Utils_eq(field, $author$project$Type$BusinessTheme$BannerLogo) || _Utils_eq(field, $author$project$Type$BusinessTheme$BannerBackground)) && ($elm$file$File$size(file) > 500000)) ? _Utils_Tuple2(
							A2(
								updateImageField,
								field,
								$elm$core$Tuple$mapSecond(
									function (_v7) {
										return $author$project$Type$BusinessTheme$Error('File size cannot exceed 500kb.');
									})),
							$elm$core$Platform$Cmd$none) : _Utils_Tuple2(
							appModel,
							A2(
								$elm$core$Task$perform,
								A2(
									$elm$core$Basics$composeL,
									A2(
										$elm$core$Basics$composeL,
										A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnBusinessChangeTheme),
										$author$project$Type$BusinessTheme$OnImageAction(field)),
									$author$project$Type$BusinessTheme$ImageUrl),
								$elm$file$File$toUrl(file)))));
					case 'ImageUrl':
						var base64ImageData = action.a;
						return _Utils_Tuple2(
							updateImageEditor(
								function (_v8) {
									return A2($author$project$Type$BusinessTheme$Opened, field, base64ImageData);
								}),
							function () {
								switch (field.$) {
									case 'HeaderLogo':
										return $author$project$ImageEditor$load(
											{cropHeight: 90, cropWidth: 270});
									case 'BannerLogo':
										return $author$project$ImageEditor$load(
											{cropHeight: 500, cropWidth: 500});
									default:
										return $author$project$ImageEditor$load(
											{cropHeight: 500, cropWidth: 500});
								}
							}());
					case 'ImageAction':
						var editorAction = action.a;
						return _Utils_Tuple2(
							appModel,
							$author$project$ImageEditor$update(editorAction));
					case 'ImageCancel':
						return _Utils_Tuple2(
							updateImageEditor(
								function (_v10) {
									return $author$project$Type$BusinessTheme$Closed;
								}),
							$elm$core$Platform$Cmd$none);
					case 'ImageSubmit':
						var base64ImageData = action.a;
						return _Utils_Tuple2(
							updateImageEditor(
								function (_v11) {
									return A2($author$project$Type$BusinessTheme$Processing, field, base64ImageData);
								}),
							$author$project$ImageEditor$getImageDataAndDestroy(_Utils_Tuple0));
					default:
						var result = action.a;
						if (result.$ === 'Err') {
							return _Utils_Tuple2(
								A2(
									updateImageField,
									field,
									$elm$core$Tuple$mapSecond(
										function (_v13) {
											return $author$project$Type$BusinessTheme$Error('Unable to process your image file.');
										})),
								$elm$core$Platform$Cmd$none);
						} else {
							var _v14 = result.a;
							var localUrl = _v14.a;
							var file = _v14.b;
							return _Utils_Tuple2(
								updateFormModel(
									function (model) {
										switch (field.$) {
											case 'HeaderLogo':
												return _Utils_update(
													model,
													{
														headerLogo: A2(
															$elm$core$Tuple$mapSecond,
															function (_v16) {
																return $author$project$Type$BusinessTheme$Loading(localUrl);
															},
															headerLogo),
														imageEditorState: $author$project$Type$BusinessTheme$Closed
													});
											case 'BannerLogo':
												return _Utils_update(
													model,
													{
														bannerLogo: A2(
															$elm$core$Tuple$mapSecond,
															function (_v17) {
																return $author$project$Type$BusinessTheme$Loading(localUrl);
															},
															bannerLogo),
														imageEditorState: $author$project$Type$BusinessTheme$Closed
													});
											default:
												return _Utils_update(
													model,
													{
														bannerBackground: A2(
															$elm$core$Tuple$mapSecond,
															function (_v18) {
																return $author$project$Type$BusinessTheme$Loading(localUrl);
															},
															bannerBackground),
														imageEditorState: $author$project$Type$BusinessTheme$Closed
													});
										}
									}),
								function () {
									switch (field.$) {
										case 'HeaderLogo':
											return A2(
												$elm$core$Task$attempt,
												A2(
													$elm$core$Basics$composeL,
													A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnBusinessChangeTheme),
													$author$project$Type$BusinessTheme$OnSubmitImageResponse(field)),
												A5(
													$author$project$Data$Api$Business$Theme$upload,
													user.jwt,
													apiEndPoint.businessTheme + '/header-logo',
													{
														domain: $author$project$Data$Domain$selected(user.domains)
													},
													file,
													'headerLogo'));
										case 'BannerLogo':
											return A2(
												$elm$core$Task$attempt,
												A2(
													$elm$core$Basics$composeL,
													A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnBusinessChangeTheme),
													$author$project$Type$BusinessTheme$OnSubmitImageResponse(field)),
												A5(
													$author$project$Data$Api$Business$Theme$upload,
													user.jwt,
													apiEndPoint.businessTheme + '/banner-logo',
													{
														domain: $author$project$Data$Domain$selected(user.domains)
													},
													file,
													'bannerLogo'));
										default:
											return A2(
												$elm$core$Task$attempt,
												A2(
													$elm$core$Basics$composeL,
													A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnBusinessChangeTheme),
													$author$project$Type$BusinessTheme$OnSubmitImageResponse(field)),
												A5(
													$author$project$Data$Api$Business$Theme$upload,
													user.jwt,
													apiEndPoint.businessTheme + '/banner-background',
													{
														domain: $author$project$Data$Domain$selected(user.domains)
													},
													file,
													'bannerBackground'));
									}
								}());
						}
				}
			case 'OnSubmitImageResponse':
				var field = themeMsg.a;
				var result = themeMsg.b;
				var newImageUrl = function () {
					switch (field.$) {
						case 'HeaderLogo':
							var _v24 = headerLogo.b;
							if (_v24.$ === 'Loading') {
								var imageUrl = _v24.a;
								return imageUrl;
							} else {
								return $author$project$Data$BusinessTheme$default.logo;
							}
						case 'BannerLogo':
							var _v25 = bannerLogo.b;
							if (_v25.$ === 'Loading') {
								var imageUrl = _v25.a;
								return imageUrl;
							} else {
								return $author$project$Data$BusinessTheme$default.bannerLogo;
							}
						default:
							var _v26 = bannerBackground.b;
							if (_v26.$ === 'Loading') {
								var imageUrl = _v26.a;
								return imageUrl;
							} else {
								return $author$project$Data$BusinessTheme$default.bannerBackground;
							}
					}
				}();
				if (result.$ === 'Ok') {
					switch (field.$) {
						case 'HeaderLogo':
							return _Utils_Tuple2(
								_Utils_update(
									appModel,
									{
										sessionModel: $author$project$Types$Auth(
											_Utils_update(
												authModel,
												{
													businessThemeForm: _Utils_update(
														businessThemeForm,
														{
															headerLogo: _Utils_Tuple2(newImageUrl, $author$project$Type$BusinessTheme$Ready)
														})
												})),
										theme: _Utils_update(
											theme,
											{
												theme: $author$project$Type$Theme$Loaded(
													_Utils_update(
														themeState,
														{logo: newImageUrl}))
											})
									}),
								$elm$core$Platform$Cmd$none);
						case 'BannerLogo':
							return _Utils_Tuple2(
								_Utils_update(
									appModel,
									{
										sessionModel: $author$project$Types$Auth(
											_Utils_update(
												authModel,
												{
													businessThemeForm: _Utils_update(
														businessThemeForm,
														{
															bannerLogo: _Utils_Tuple2(newImageUrl, $author$project$Type$BusinessTheme$Ready)
														})
												})),
										theme: _Utils_update(
											theme,
											{
												theme: $author$project$Type$Theme$Loaded(
													_Utils_update(
														themeState,
														{bannerLogo: newImageUrl}))
											})
									}),
								$elm$core$Platform$Cmd$none);
						default:
							return _Utils_Tuple2(
								_Utils_update(
									appModel,
									{
										sessionModel: $author$project$Types$Auth(
											_Utils_update(
												authModel,
												{
													businessThemeForm: _Utils_update(
														businessThemeForm,
														{
															bannerBackground: _Utils_Tuple2(newImageUrl, $author$project$Type$BusinessTheme$Ready)
														})
												})),
										theme: _Utils_update(
											theme,
											{
												theme: $author$project$Type$Theme$Loaded(
													_Utils_update(
														themeState,
														{bannerBackground: newImageUrl}))
											})
									}),
								$elm$core$Platform$Cmd$none);
					}
				} else {
					return _Utils_Tuple2(
						A2(
							updateImageField,
							field,
							$elm$core$Tuple$mapSecond(
								function (_v22) {
									return $author$project$Type$BusinessTheme$Ready;
								})),
						$elm$core$Platform$Cmd$none);
				}
			case 'OnChange':
				var field = themeMsg.a;
				var string = themeMsg.b;
				return _Utils_Tuple2(
					updateFormModel(
						function (model) {
							return _Utils_update(
								model,
								{
									headerColor: A2(
										$elm$core$Tuple$mapSecond,
										function (_v28) {
											return $author$project$Type$BusinessTheme$Loading(string);
										},
										headerColor)
								});
						}),
					$elm$core$Platform$Cmd$none);
			case 'OnBlur':
				var field = themeMsg.a;
				return _Utils_Tuple2(
					appModel,
					A2(
						$elm$core$Task$attempt,
						A2(
							$elm$core$Basics$composeL,
							A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnBusinessChangeTheme),
							$author$project$Type$BusinessTheme$OnSubmitResponse($author$project$Type$BusinessTheme$HeaderColor)),
						A3(
							$author$project$Data$Api$Business$HeaderColor$authCall,
							user.jwt,
							apiEndPoint.businessTheme + '/header-color',
							{
								color: function () {
									var _v30 = headerColor.b;
									if (_v30.$ === 'Loading') {
										var string = _v30.a;
										return string;
									} else {
										return '#2979FF';
									}
								}(),
								domain: $author$project$Data$Domain$selected(user.domains)
							})));
			default:
				var field = themeMsg.a;
				var result = themeMsg.b;
				var newHeaderColor = function () {
					var _v34 = headerColor.b;
					if (_v34.$ === 'Loading') {
						var string = _v34.a;
						return string;
					} else {
						return '#2979FF';
					}
				}();
				if (result.$ === 'Err') {
					return _Utils_Tuple2(
						A2(
							updateTextField,
							$author$project$Type$BusinessTheme$HeaderColor,
							$elm$core$Tuple$mapSecond(
								function (_v33) {
									return $author$project$Type$BusinessTheme$Ready;
								})),
						$elm$core$Platform$Cmd$none);
				} else {
					return _Utils_Tuple2(
						_Utils_update(
							appModel,
							{
								sessionModel: $author$project$Types$Auth(
									_Utils_update(
										authModel,
										{
											businessThemeForm: _Utils_update(
												businessThemeForm,
												{
													headerColor: _Utils_Tuple2(newHeaderColor, $author$project$Type$BusinessTheme$Ready)
												})
										})),
								theme: _Utils_update(
									theme,
									{
										theme: $author$project$Type$Theme$Loaded(
											_Utils_update(
												themeState,
												{appBarBackgroundColor: newHeaderColor}))
									})
							}),
						$elm$core$Platform$Cmd$none);
				}
		}
	});
var $author$project$Type$BusinessUser$Error = function (a) {
	return {$: 'Error', a: a};
};
var $author$project$Type$BusinessUser$Fail = function (a) {
	return {$: 'Fail', a: a};
};
var $author$project$Type$BusinessUser$LoadError = function (a) {
	return {$: 'LoadError', a: a};
};
var $author$project$Type$BusinessUser$Loaded = function (a) {
	return {$: 'Loaded', a: a};
};
var $author$project$Type$BusinessUser$OnAddUserSubmitResponse = function (a) {
	return {$: 'OnAddUserSubmitResponse', a: a};
};
var $author$project$Type$BusinessUser$OnCouponRedeemResult = function (a) {
	return {$: 'OnCouponRedeemResult', a: a};
};
var $author$project$Type$BusinessUser$OnLoadUsersResult = function (a) {
	return {$: 'OnLoadUsersResult', a: a};
};
var $author$project$Type$BusinessUser$Opened = function (a) {
	return {$: 'Opened', a: a};
};
var $author$project$Type$BusinessUser$Pass = {$: 'Pass'};
var $author$project$Type$BusinessUser$Ready = {$: 'Ready'};
var $author$project$Type$BusinessUser$Submitting = {$: 'Submitting'};
var $author$project$Type$BusinessUser$Success = function (a) {
	return {$: 'Success', a: a};
};
var $author$project$Data$Api$Business$InviteUser$Payload = function (message) {
	return {message: message};
};
var $author$project$Data$Api$Business$InviteUser$dataDecoder = A2(
	$elm$json$Json$Decode$map,
	$author$project$Data$Api$Business$InviteUser$Payload,
	A2($elm$json$Json$Decode$field, 'message', $elm$json$Json$Decode$string));
var $author$project$Data$Api$Business$InviteUser$encode = function (_v0) {
	var firstName = _v0.firstName;
	var lastName = _v0.lastName;
	var email = _v0.email;
	var domain = _v0.domain;
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'firstName',
				$elm$json$Json$Encode$string(firstName)),
				_Utils_Tuple2(
				'lastName',
				$elm$json$Json$Encode$string(lastName)),
				_Utils_Tuple2(
				'email',
				$elm$json$Json$Encode$string(email)),
				_Utils_Tuple2(
				'domain',
				$author$project$Data$Domain$encode(domain))
			]));
};
var $author$project$Data$Api$Business$InviteUser$DOMAIN_NOT_FOUND = {$: 'DOMAIN_NOT_FOUND'};
var $author$project$Data$Api$Business$InviteUser$INVALID_EMAIL = {$: 'INVALID_EMAIL'};
var $author$project$Data$Api$Business$InviteUser$INVALID_FIRST_NAME = {$: 'INVALID_FIRST_NAME'};
var $author$project$Data$Api$Business$InviteUser$INVALID_LAST_NAME = {$: 'INVALID_LAST_NAME'};
var $author$project$Data$Api$Business$InviteUser$LIMIT_REACHED = {$: 'LIMIT_REACHED'};
var $author$project$Data$Api$Business$InviteUser$USER_ALREADY_ACCEPTED = {$: 'USER_ALREADY_ACCEPTED'};
var $author$project$Data$Api$Business$InviteUser$errorDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (errorCode) {
		switch (errorCode) {
			case 'INVALID_FIRST_NAME':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$Business$InviteUser$INVALID_FIRST_NAME);
			case 'INVALID_LAST_NAME':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$Business$InviteUser$INVALID_LAST_NAME);
			case 'INVALID_EMAIL':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$Business$InviteUser$INVALID_EMAIL);
			case 'DOMAIN_NOT_FOUND':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$Business$InviteUser$DOMAIN_NOT_FOUND);
			case 'USER_ALREADY_ACCEPTED':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$Business$InviteUser$USER_ALREADY_ACCEPTED);
			case 'LIMIT_REACHED':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$Business$InviteUser$LIMIT_REACHED);
			default:
				return $elm$json$Json$Decode$fail('Invalid error code: ' + errorCode);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Data$Api$Business$InviteUser$authCall = F3(
	function (jwt, endPoint, params) {
		return A5(
			$author$project$Data$Api$authCall,
			jwt,
			endPoint,
			$author$project$Data$Api$Business$InviteUser$errorDecoder,
			$author$project$Data$Api$Business$InviteUser$dataDecoder,
			$author$project$Data$Api$Business$InviteUser$encode(params));
	});
var $author$project$Data$Api$Business$ListUsers$Payload = function (users) {
	return {users: users};
};
var $author$project$Data$BusinessUser$BusinessUser = F7(
	function (firstName, lastName, email, status, updatedAt, createdAt, shareReferralCode) {
		return {createdAt: createdAt, email: email, firstName: firstName, lastName: lastName, shareReferralCode: shareReferralCode, status: status, updatedAt: updatedAt};
	});
var $author$project$Data$BusinessUser$Accepted = {$: 'Accepted'};
var $author$project$Data$BusinessUser$Declined = {$: 'Declined'};
var $author$project$Data$BusinessUser$Pending = {$: 'Pending'};
var $author$project$Data$BusinessUser$statusDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (value) {
		switch (value) {
			case 'Accepted':
				return $elm$json$Json$Decode$succeed($author$project$Data$BusinessUser$Accepted);
			case 'Pending':
				return $elm$json$Json$Decode$succeed($author$project$Data$BusinessUser$Pending);
			case 'Declined':
				return $elm$json$Json$Decode$succeed($author$project$Data$BusinessUser$Declined);
			default:
				return $elm$json$Json$Decode$fail('Invalid status: ' + value);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Data$BusinessUser$decoder = A8(
	$elm$json$Json$Decode$map7,
	$author$project$Data$BusinessUser$BusinessUser,
	A2($elm$json$Json$Decode$field, 'firstName', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'lastName', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'email', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'status', $author$project$Data$BusinessUser$statusDecoder),
	A2(
		$elm$json$Json$Decode$field,
		'updatedAt',
		A2($elm$json$Json$Decode$map, $elm$time$Time$millisToPosix, $elm$json$Json$Decode$int)),
	A2(
		$elm$json$Json$Decode$field,
		'createdAt',
		A2($elm$json$Json$Decode$map, $elm$time$Time$millisToPosix, $elm$json$Json$Decode$int)),
	A2($elm$json$Json$Decode$field, 'shareReferralCode', $elm$json$Json$Decode$string));
var $author$project$Data$Api$Business$ListUsers$dataDecoder = A2(
	$elm$json$Json$Decode$map,
	$author$project$Data$Api$Business$ListUsers$Payload,
	A2(
		$elm$json$Json$Decode$field,
		'users',
		$elm$json$Json$Decode$list($author$project$Data$BusinessUser$decoder)));
var $author$project$Data$Api$Business$ListUsers$encode = function (_v0) {
	var domain = _v0.domain;
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'domain',
				$author$project$Data$Domain$encode(domain))
			]));
};
var $author$project$Data$Api$Business$ListUsers$PERMISSION_DENIED = {$: 'PERMISSION_DENIED'};
var $author$project$Data$Api$Business$ListUsers$errorDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (errorCode) {
		if (errorCode === 'PERMISSION_DENIED') {
			return $elm$json$Json$Decode$succeed($author$project$Data$Api$Business$ListUsers$PERMISSION_DENIED);
		} else {
			return $elm$json$Json$Decode$fail('Invalid error code: ' + errorCode);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Data$Api$Business$ListUsers$authCall = F3(
	function (jwt, endPoint, params) {
		return A5(
			$author$project$Data$Api$authCall,
			jwt,
			endPoint,
			$author$project$Data$Api$Business$ListUsers$errorDecoder,
			$author$project$Data$Api$Business$ListUsers$dataDecoder,
			$author$project$Data$Api$Business$ListUsers$encode(params));
	});
var $author$project$Data$Api$Business$RedeemCode$Payload = function (redemptionResult) {
	return {redemptionResult: redemptionResult};
};
var $author$project$Data$Api$Business$RedeemCode$RedeemResult = F2(
	function (couponCode, redeemSuccess) {
		return {couponCode: couponCode, redeemSuccess: redeemSuccess};
	});
var $author$project$Data$Api$Business$RedeemCode$decodeRedeemResult = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'redeemSuccess',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'couponCode',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Data$Api$Business$RedeemCode$RedeemResult)));
var $author$project$Data$Api$Business$RedeemCode$dataDecoder = A2(
	$elm$json$Json$Decode$map,
	$author$project$Data$Api$Business$RedeemCode$Payload,
	A2(
		$elm$json$Json$Decode$field,
		'redemptionResult',
		$elm$json$Json$Decode$list($author$project$Data$Api$Business$RedeemCode$decodeRedeemResult)));
var $author$project$Data$Api$Business$RedeemCode$encode = function (data) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'couponCodes',
				A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, data.couponCodes)),
				_Utils_Tuple2(
				'domain',
				$elm$json$Json$Encode$string(
					$author$project$Data$Domain$toString(data.domain)))
			]));
};
var $author$project$Data$Api$Business$RedeemCode$COUPON_REDEMPTION_LIMIT_REACHED = {$: 'COUPON_REDEMPTION_LIMIT_REACHED'};
var $author$project$Data$Api$Business$RedeemCode$UNAUTHORISED_USER = {$: 'UNAUTHORISED_USER'};
var $author$project$Data$Api$Business$RedeemCode$UNLIMITED_TEMPLATES_QUOTA = {$: 'UNLIMITED_TEMPLATES_QUOTA'};
var $author$project$Data$Api$Business$RedeemCode$errorDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (errorCode) {
		switch (errorCode) {
			case 'UNAUTHORISED_USER':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$Business$RedeemCode$UNAUTHORISED_USER);
			case 'COUPON_REDEMPTION_LIMIT_REACHED':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$Business$RedeemCode$COUPON_REDEMPTION_LIMIT_REACHED);
			case 'UNLIMITED_TEMPLATES_QUOTA':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$Business$RedeemCode$UNLIMITED_TEMPLATES_QUOTA);
			default:
				return $elm$json$Json$Decode$fail('Invalid error code: ' + errorCode);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Data$Api$Business$RedeemCode$authCall = F3(
	function (jwt, endPoint, params) {
		return A5(
			$author$project$Data$Api$authCall,
			jwt,
			endPoint,
			$author$project$Data$Api$Business$RedeemCode$errorDecoder,
			$author$project$Data$Api$Business$RedeemCode$dataDecoder,
			$author$project$Data$Api$Business$RedeemCode$encode(params));
	});
var $author$project$Data$Api$Business$RedeemCode$errorToString = function (error) {
	switch (error.$) {
		case 'UNAUTHORISED_USER':
			return 'You are not allow to perform this action';
		case 'COUPON_REDEMPTION_LIMIT_REACHED':
			return 'Only 9 coupons can be redeemed at one time';
		default:
			return 'Your organisation already has unlimited templates';
	}
};
var $elm$core$List$isEmpty = function (xs) {
	if (!xs.b) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Model$BusinessUser$validateNotEmpty = F2(
	function (fieldName, value) {
		return $elm$core$String$isEmpty(value) ? $elm$core$Maybe$Just(fieldName + ' is required.') : $elm$core$Maybe$Nothing;
	});
var $author$project$Model$BusinessUser$update = F3(
	function (msg, authModel, appModel) {
		var updateModel = function (updatedModel) {
			return _Utils_update(
				appModel,
				{
					sessionModel: $author$project$Types$Auth(
						_Utils_update(
							authModel,
							{businessUserModel: updatedModel}))
				});
		};
		var model = authModel.businessUserModel;
		switch (msg.$) {
			case 'OnLoadUsers':
				return _Utils_Tuple2(
					appModel,
					A2(
						$elm$core$Task$attempt,
						A2(
							$elm$core$Basics$composeL,
							A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnBusinessUser),
							$author$project$Type$BusinessUser$OnLoadUsersResult),
						A3(
							$author$project$Data$Api$Business$ListUsers$authCall,
							authModel.user.jwt,
							appModel.apiEndPoint.businessListUsers,
							{
								domain: $author$project$Data$Domain$selected(authModel.user.domains)
							})));
			case 'OnLoadUsersResult':
				var result = msg.a;
				var isBaseDomain = $elm$core$String$isEmpty(appModel.businessProfileModel.name);
				var _v1 = _Utils_Tuple2(result, isBaseDomain);
				if (_v1.a.$ === 'Ok') {
					if (!_v1.b) {
						var users = _v1.a.a.users;
						return _Utils_Tuple2(
							updateModel(
								_Utils_update(
									model,
									{
										couponBanner: $author$project$Type$BusinessUser$Hide,
										couponCodes: _List_fromArray(
											[
												{error: $elm$core$Maybe$Nothing, input: '', successMessage: $elm$core$Maybe$Nothing}
											]),
										users: $author$project$Type$BusinessUser$Loaded(users)
									})),
							$elm$core$Platform$Cmd$none);
					} else {
						return _Utils_Tuple2(
							updateModel(
								_Utils_update(
									model,
									{users: $author$project$Type$BusinessUser$NotLoaded})),
							A2($elm$browser$Browser$Navigation$pushUrl, appModel.navKey, $author$project$Data$Route$routeUrl.dashboard));
					}
				} else {
					var error = _v1.a.a;
					return _Utils_Tuple2(
						updateModel(
							_Utils_update(
								model,
								{
									users: $author$project$Type$BusinessUser$LoadError(error)
								})),
						$elm$core$Platform$Cmd$none);
				}
			case 'OnAddUser':
				return _Utils_Tuple2(
					updateModel(
						_Utils_update(
							model,
							{
								formModal: $author$project$Type$BusinessUser$Opened($author$project$Type$BusinessUser$Ready)
							})),
					$elm$core$Platform$Cmd$none);
			case 'OnAddUserSubmit':
				var _v2 = model;
				var firstName = _v2.firstName;
				var lastName = _v2.lastName;
				var email = _v2.email;
				var updatedModel = function (m) {
					return _Utils_update(
						m,
						{
							emailError: $author$project$Data$Validator$validateEmail(email)
						});
				}(
					function (m) {
						return _Utils_update(
							m,
							{
								lastNameError: A2($author$project$Model$BusinessUser$validateNotEmpty, 'Last name', lastName)
							});
					}(
						_Utils_update(
							model,
							{
								firstNameError: A2($author$project$Model$BusinessUser$validateNotEmpty, 'First name', firstName)
							})));
				var allPassed = A2(
					$elm$core$List$all,
					$elm$core$Basics$eq($elm$core$Maybe$Nothing),
					_List_fromArray(
						[updatedModel.firstNameError, updatedModel.lastNameError, updatedModel.emailError]));
				return allPassed ? _Utils_Tuple2(
					updateModel(
						_Utils_update(
							updatedModel,
							{
								formModal: $author$project$Type$BusinessUser$Opened($author$project$Type$BusinessUser$Submitting)
							})),
					A2(
						$elm$core$Task$attempt,
						A2(
							$elm$core$Basics$composeL,
							A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnBusinessUser),
							$author$project$Type$BusinessUser$OnAddUserSubmitResponse),
						A3(
							$author$project$Data$Api$Business$InviteUser$authCall,
							authModel.user.jwt,
							appModel.apiEndPoint.businessInviteUser,
							{
								domain: $author$project$Data$Domain$selected(authModel.user.domains),
								email: email,
								firstName: firstName,
								lastName: lastName
							}))) : _Utils_Tuple2(
					updateModel(
						_Utils_update(
							updatedModel,
							{
								formModal: $author$project$Type$BusinessUser$Opened($author$project$Type$BusinessUser$Ready)
							})),
					$elm$core$Platform$Cmd$none);
			case 'OnAddUserSubmitResponse':
				var result = msg.a;
				if (result.$ === 'Err') {
					var error = result.a;
					return _Utils_Tuple2(
						updateModel(
							_Utils_update(
								model,
								{
									formModal: $author$project$Type$BusinessUser$Opened(
										$author$project$Type$BusinessUser$Error(error))
								})),
						$elm$core$Platform$Cmd$none);
				} else {
					return _Utils_Tuple2(
						updateModel(
							_Utils_update(
								$author$project$Model$BusinessUser$init,
								{
									formModal: $author$project$Type$BusinessUser$Success(model.email),
									users: model.users
								})),
						$elm$core$Platform$Cmd$none);
				}
			case 'OnAddUserCancel':
				return _Utils_Tuple2(
					updateModel(
						_Utils_update(
							model,
							{formModal: $author$project$Type$BusinessUser$Closed})),
					$elm$core$Platform$Cmd$none);
			case 'OnInput':
				var field = msg.a;
				var value = msg.b;
				switch (field.$) {
					case 'FirstName':
						return _Utils_Tuple2(
							updateModel(
								_Utils_update(
									model,
									{
										firstName: value,
										formModal: $author$project$Type$BusinessUser$Opened($author$project$Type$BusinessUser$Ready)
									})),
							$elm$core$Platform$Cmd$none);
					case 'LastName':
						return _Utils_Tuple2(
							updateModel(
								_Utils_update(
									model,
									{
										formModal: $author$project$Type$BusinessUser$Opened($author$project$Type$BusinessUser$Ready),
										lastName: value
									})),
							$elm$core$Platform$Cmd$none);
					default:
						return _Utils_Tuple2(
							updateModel(
								_Utils_update(
									model,
									{
										email: value,
										formModal: $author$project$Type$BusinessUser$Opened($author$project$Type$BusinessUser$Ready)
									})),
							$elm$core$Platform$Cmd$none);
				}
			case 'OnBlur':
				var field = msg.a;
				switch (field.$) {
					case 'FirstName':
						return _Utils_Tuple2(
							updateModel(
								_Utils_update(
									model,
									{
										firstNameError: A2($author$project$Model$BusinessUser$validateNotEmpty, 'First name', model.firstName)
									})),
							$elm$core$Platform$Cmd$none);
					case 'LastName':
						return _Utils_Tuple2(
							updateModel(
								_Utils_update(
									model,
									{
										lastNameError: A2($author$project$Model$BusinessUser$validateNotEmpty, 'Last name', model.lastName)
									})),
							$elm$core$Platform$Cmd$none);
					default:
						return _Utils_Tuple2(
							updateModel(
								_Utils_update(
									model,
									{
										emailError: $author$project$Data$Validator$validateEmail(model.email)
									})),
							$elm$core$Platform$Cmd$none);
				}
			case 'OnAddButtonClick':
				var newCouponCodes = ($elm$core$List$length(model.couponCodes) < 9) ? _Utils_ap(
					model.couponCodes,
					_List_fromArray(
						[
							{error: $elm$core$Maybe$Nothing, input: '', successMessage: $elm$core$Maybe$Nothing}
						])) : model.couponCodes;
				return _Utils_Tuple2(
					updateModel(
						_Utils_update(
							model,
							{couponCodes: newCouponCodes})),
					$elm$core$Platform$Cmd$none);
			case 'OnCouponCodeInput':
				var index = msg.a;
				var value = msg.b;
				var newCouponList = A2(
					$elm$core$List$indexedMap,
					F2(
						function (couponIndex, coupon) {
							return _Utils_eq(couponIndex, index) ? _Utils_update(
								coupon,
								{
									error: $elm$core$Maybe$Nothing,
									input: $elm$core$String$trim(value)
								}) : coupon;
						}),
					model.couponCodes);
				return _Utils_Tuple2(
					updateModel(
						_Utils_update(
							model,
							{couponBanner: $author$project$Type$BusinessUser$Hide, couponCodes: newCouponList})),
					$elm$core$Platform$Cmd$none);
			case 'OnCouponRedeemSubmit':
				var uppdatedCouponCode = A3(
					$elm$core$List$foldl,
					F2(
						function (coupon, couponList) {
							var hasRepeatedCode = A2(
								$elm$core$List$any,
								function (code) {
									return _Utils_eq(code.input, coupon.input);
								},
								couponList);
							return (hasRepeatedCode || $elm$core$String$isEmpty(coupon.input)) ? couponList : _Utils_ap(
								couponList,
								_List_fromArray(
									[
										_Utils_update(
										coupon,
										{error: $elm$core$Maybe$Nothing})
									]));
						}),
					_List_Nil,
					model.couponCodes);
				var couponCodes = A2(
					$elm$core$List$map,
					function (coupon) {
						return coupon.input;
					},
					uppdatedCouponCode);
				return _Utils_Tuple2(
					updateModel(
						_Utils_update(
							model,
							{couponCodes: uppdatedCouponCode})),
					A2(
						$elm$core$Task$attempt,
						A2(
							$elm$core$Basics$composeL,
							A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnBusinessUser),
							$author$project$Type$BusinessUser$OnCouponRedeemResult),
						A3(
							$author$project$Data$Api$Business$RedeemCode$authCall,
							authModel.user.jwt,
							appModel.apiEndPoint.redeemCouponCode,
							{
								couponCodes: couponCodes,
								domain: $author$project$Data$Domain$selected(authModel.user.domains)
							})));
			case 'OnCouponRedeemResult':
				var result = msg.a;
				if (result.$ === 'Ok') {
					var value = result.a;
					var failedCouponCodes = A2(
						$elm$core$List$filterMap,
						function (coupon) {
							return coupon.redeemSuccess ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(coupon.couponCode);
						},
						value.redemptionResult);
					var updatedCouponList = A2(
						$elm$core$List$map,
						function (coupon) {
							return A2($elm$core$List$member, coupon.input, failedCouponCodes) ? _Utils_update(
								coupon,
								{
									error: $elm$core$Maybe$Just('Redemption Failed')
								}) : _Utils_update(
								coupon,
								{
									successMessage: $elm$core$Maybe$Just('Redemption Successful')
								});
						},
						model.couponCodes);
					var banner = $elm$core$List$isEmpty(failedCouponCodes) ? $author$project$Type$BusinessUser$Pass : $author$project$Type$BusinessUser$Hide;
					return _Utils_Tuple2(
						updateModel(
							_Utils_update(
								model,
								{couponBanner: banner, couponCodes: updatedCouponList})),
						$elm$core$Platform$Cmd$none);
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						updateModel(
							_Utils_update(
								model,
								{
									couponBanner: $author$project$Type$BusinessUser$Fail(
										A2($author$project$Data$Api$authErrorToString, $author$project$Data$Api$Business$RedeemCode$errorToString, error))
								})),
						$elm$core$Platform$Cmd$none);
				}
			case 'OnCouponCodeBannerClose':
				return _Utils_Tuple2(
					updateModel(
						_Utils_update(
							model,
							{couponBanner: $author$project$Type$BusinessUser$Hide})),
					$elm$core$Platform$Cmd$none);
			case 'OnClearCouponCode':
				return _Utils_Tuple2(
					updateModel(
						_Utils_update(
							model,
							{
								couponBanner: $author$project$Type$BusinessUser$Hide,
								couponCodes: _List_fromArray(
									[
										{error: $elm$core$Maybe$Nothing, input: '', successMessage: $elm$core$Maybe$Nothing}
									])
							})),
					$elm$core$Platform$Cmd$none);
			default:
				var index = msg.a;
				var updatedCouponCodes = ($elm$core$List$length(model.couponCodes) === 1) ? A2(
					$elm$core$List$map,
					function (coupon) {
						return _Utils_update(
							coupon,
							{error: $elm$core$Maybe$Nothing, input: '', successMessage: $elm$core$Maybe$Nothing});
					},
					model.couponCodes) : A2(
					$elm$core$List$filterMap,
					function (_v7) {
						var couponIndex = _v7.a;
						var coupon = _v7.b;
						return _Utils_eq(index, couponIndex) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(coupon);
					},
					A2($elm$core$List$indexedMap, $elm$core$Tuple$pair, model.couponCodes));
				return _Utils_Tuple2(
					updateModel(
						_Utils_update(
							model,
							{couponBanner: $author$project$Type$BusinessUser$Hide, couponCodes: updatedCouponCodes})),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Type$ConfirmDeleteDocument$Error = function (a) {
	return {$: 'Error', a: a};
};
var $author$project$Type$ConfirmDeleteDocument$RedirectToDashboard = function (a) {
	return {$: 'RedirectToDashboard', a: a};
};
var $author$project$Type$ConfirmDeleteDocument$Success = {$: 'Success'};
var $author$project$Model$ConfirmDeleteDocument$update = F2(
	function (msg, model) {
		var _v0 = model;
		var confirmDeleteDocumentModel = _v0.confirmDeleteDocumentModel;
		if (confirmDeleteDocumentModel.$ === 'NoToken') {
			return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		} else {
			var token = confirmDeleteDocumentModel.a;
			if (msg.$ === 'ConfirmDeleteDocumentResponse') {
				var result = msg.a;
				if (result.$ === 'Ok') {
					var payload = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								confirmDeleteDocumentModel: $author$project$Type$ConfirmDeleteDocument$HasToken($author$project$Type$ConfirmDeleteDocument$Success)
							}),
						A2(
							$elm$core$Task$perform,
							A2($elm$core$Basics$composeL, $author$project$Types$OnConfirmDeleteDocument, $author$project$Type$ConfirmDeleteDocument$RedirectToDashboard),
							$elm$core$Process$sleep(3000)));
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								confirmDeleteDocumentModel: $author$project$Type$ConfirmDeleteDocument$HasToken(
									$author$project$Type$ConfirmDeleteDocument$Error(error))
							}),
						$elm$core$Platform$Cmd$none);
				}
			} else {
				return _Utils_Tuple2(
					model,
					A2($elm$browser$Browser$Navigation$pushUrl, model.navKey, $author$project$Data$Route$routeUrl.dashboard));
			}
		}
	});
var $author$project$Type$ConfirmDeleteTemplate$Error = function (a) {
	return {$: 'Error', a: a};
};
var $author$project$Type$ConfirmDeleteTemplate$RedirectToDashboard = function (a) {
	return {$: 'RedirectToDashboard', a: a};
};
var $author$project$Type$ConfirmDeleteTemplate$Success = {$: 'Success'};
var $author$project$Model$ConfirmDeleteTemplate$update = F2(
	function (msg, model) {
		var _v0 = model;
		var confirmDeleteTemplateModel = _v0.confirmDeleteTemplateModel;
		if (confirmDeleteTemplateModel.$ === 'NoToken') {
			return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		} else {
			var token = confirmDeleteTemplateModel.a;
			if (msg.$ === 'ConfirmDeleteTemplateResponse') {
				var result = msg.a;
				if (result.$ === 'Ok') {
					var payload = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								confirmDeleteTemplateModel: $author$project$Type$ConfirmDeleteTemplate$HasToken($author$project$Type$ConfirmDeleteTemplate$Success)
							}),
						A2(
							$elm$core$Task$perform,
							A2($elm$core$Basics$composeL, $author$project$Types$OnConfirmDeleteTemplate, $author$project$Type$ConfirmDeleteTemplate$RedirectToDashboard),
							$elm$core$Process$sleep(3000)));
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								confirmDeleteTemplateModel: $author$project$Type$ConfirmDeleteTemplate$HasToken(
									$author$project$Type$ConfirmDeleteTemplate$Error(error))
							}),
						$elm$core$Platform$Cmd$none);
				}
			} else {
				return _Utils_Tuple2(
					model,
					A2($elm$browser$Browser$Navigation$pushUrl, model.navKey, $author$project$Data$Route$routeUrl.dashboard));
			}
		}
	});
var $author$project$Type$CreateTemplate$CheckboxFieldForm = {$: 'CheckboxFieldForm'};
var $author$project$Type$CreateTemplate$ConversionError = {$: 'ConversionError'};
var $author$project$Type$CreateTemplate$Disabled = {$: 'Disabled'};
var $author$project$Type$CreateTemplate$Editing = {$: 'Editing'};
var $author$project$Type$CreateTemplate$Enabled = {$: 'Enabled'};
var $author$project$Type$CreateTemplate$Error = function (a) {
	return {$: 'Error', a: a};
};
var $author$project$Type$CreateTemplate$FilledFieldForm = {$: 'FilledFieldForm'};
var $author$project$Type$CreateTemplate$Loaded = function (a) {
	return {$: 'Loaded', a: a};
};
var $author$project$Type$CreateTemplate$NeedPassword = {$: 'NeedPassword'};
var $author$project$Type$CreateTemplate$NoSelectedFieldAnnot = {$: 'NoSelectedFieldAnnot'};
var $author$project$Type$CreateTemplate$None = {$: 'None'};
var $author$project$Type$CreateTemplate$OnSearchApiResult = function (a) {
	return {$: 'OnSearchApiResult', a: a};
};
var $author$project$Type$CreateTemplate$OnTemplateSubmitUploadResult = function (a) {
	return {$: 'OnTemplateSubmitUploadResult', a: a};
};
var $author$project$Type$CreateTemplate$PendingFieldForm = {$: 'PendingFieldForm'};
var $author$project$Type$CreateTemplate$Ready = F2(
	function (a, b) {
		return {$: 'Ready', a: a, b: b};
	});
var $author$project$Type$CreateTemplate$Role = {$: 'Role'};
var $author$project$Type$CreateTemplate$SetDateToAnnot = function (a) {
	return {$: 'SetDateToAnnot', a: a};
};
var $author$project$Type$CreateTemplate$Success = {$: 'Success'};
var $author$project$Type$CreateTemplate$Uploading = F2(
	function (a, b) {
		return {$: 'Uploading', a: a, b: b};
	});
var $author$project$Type$CreateTemplate$Viewer = {$: 'Viewer'};
var $author$project$Data$PDF$CreateTemplate$Template = function (a) {
	return {$: 'Template', a: a};
};
var $author$project$Data$PDF$Port$Position = F3(
	function (x, y, page) {
		return {page: page, x: x, y: y};
	});
var $elm$json$Json$Decode$float = _Json_decodeFloat;
var $author$project$Data$PDF$Port$positionDecoder = A4(
	$elm$json$Json$Decode$map3,
	$author$project$Data$PDF$Port$Position,
	A2($elm$json$Json$Decode$field, 'x', $elm$json$Json$Decode$float),
	A2($elm$json$Json$Decode$field, 'y', $elm$json$Json$Decode$float),
	A2($elm$json$Json$Decode$field, 'page', $elm$json$Json$Decode$int));
var $author$project$Data$PDF$Port$decodePosition = function (value) {
	var _v0 = A2($elm$json$Json$Decode$decodeValue, $author$project$Data$PDF$Port$positionDecoder, value);
	if (_v0.$ === 'Ok') {
		var result = _v0.a;
		return $elm$core$Result$Ok(result);
	} else {
		return $elm$core$Result$Err('Unable to capture click position.');
	}
};
var $author$project$Data$PDF$User$toStringStatus = function (user) {
	if (user.$ === 'Registered') {
		return 'Registered';
	} else {
		return 'Unregistered';
	}
};
var $author$project$Data$PDF$User$userInfo = function (user) {
	if (user.$ === 'Registered') {
		var info_ = user.a;
		return info_;
	} else {
		var info_ = user.a;
		return info_;
	}
};
var $author$project$Data$PDF$Port$encodePDFUser = function (user) {
	var info = $author$project$Data$PDF$User$userInfo(user);
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'email',
				$elm$json$Json$Encode$string(info.email)),
				_Utils_Tuple2(
				'firstName',
				$elm$json$Json$Encode$string(info.firstName)),
				_Utils_Tuple2(
				'status',
				$elm$json$Json$Encode$string(
					$author$project$Data$PDF$User$toStringStatus(user)))
			]));
};
var $author$project$Data$PDF$User$Transparent = {$: 'Transparent'};
var $author$project$Data$PDF$Annotation$annotFieldData = function (annotField) {
	return _Utils_Tuple2(annotField.required, annotField.name);
};
var $author$project$Data$PDF$Annotation$checkBoxField = function (_v0) {
	var annotField = _v0.a;
	var checkbox = _v0.b;
	return _Utils_Tuple2(annotField, checkbox);
};
var $author$project$Data$PDF$Annotation$dateField = function (_v0) {
	var annotField = _v0.a;
	var dateTxt_ = _v0.b;
	return _Utils_Tuple2(annotField, dateTxt_);
};
var $author$project$Data$PDF$Annotation$dateTxtDate = function (_v0) {
	var dateTxt_ = _v0.a;
	return dateTxt_.date;
};
var $author$project$Data$PDF$Annotation$checkboxId = function (_v0) {
	var checkbox = _v0.a;
	return checkbox.id;
};
var $author$project$Data$PDF$Annotation$checkboxStyle = function (_v0) {
	var checkbox = _v0.a;
	return checkbox.style;
};
var $elm$json$Json$Encode$float = _Json_wrap;
var $author$project$Data$PDF$Port$encodeBgRGB = function (rgba) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'r',
				$elm$json$Json$Encode$int(rgba.r)),
				_Utils_Tuple2(
				'g',
				$elm$json$Json$Encode$int(rgba.g)),
				_Utils_Tuple2(
				'b',
				$elm$json$Json$Encode$int(rgba.b)),
				_Utils_Tuple2(
				'a',
				$elm$json$Json$Encode$float(rgba.a))
			]));
};
var $author$project$Data$PDF$Port$encodeStyle = function (style) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'width',
				$elm$json$Json$Encode$float(style.width)),
				_Utils_Tuple2(
				'height',
				$elm$json$Json$Encode$float(style.height)),
				_Utils_Tuple2(
				'fontSize',
				$elm$json$Json$Encode$string(style.fontSize)),
				_Utils_Tuple2(
				'x',
				$elm$json$Json$Encode$float(style.x)),
				_Utils_Tuple2(
				'y',
				$elm$json$Json$Encode$float(style.y)),
				_Utils_Tuple2(
				'page',
				$elm$json$Json$Encode$int(style.page))
			]));
};
var $author$project$Data$PDF$Port$encodeCheckBox = F3(
	function (bgRGBA, content, checkbox) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'id',
					$elm$json$Json$Encode$string(
						$author$project$Data$PDF$Annotation$checkboxId(checkbox))),
					_Utils_Tuple2(
					'content',
					$elm$json$Json$Encode$string(content)),
					_Utils_Tuple2(
					'style',
					$author$project$Data$PDF$Port$encodeStyle(
						$author$project$Data$PDF$Annotation$checkboxStyle(checkbox))),
					_Utils_Tuple2(
					'status',
					$elm$json$Json$Encode$string('Verified')),
					_Utils_Tuple2(
					'color',
					$author$project$Data$PDF$Port$encodeBgRGB(bgRGBA))
				]));
	});
var $author$project$Data$PDF$Annotation$dateTxtId = function (_v0) {
	var dateTxt_ = _v0.a;
	return dateTxt_.id;
};
var $author$project$Data$PDF$Annotation$dateTxtStatus = function (_v0) {
	var dateTxt_ = _v0.a;
	return dateTxt_.status;
};
var $author$project$Data$PDF$Annotation$dateTxtStyle = function (_v0) {
	var dateTxt_ = _v0.a;
	return dateTxt_.style;
};
var $author$project$Data$PDF$Port$encodeStatus = function (txtStatus) {
	if (txtStatus.$ === 'Verified') {
		return $elm$json$Json$Encode$string('Verified');
	} else {
		return $elm$json$Json$Encode$string('Unverified');
	}
};
var $author$project$Data$PDF$Port$encodeDateText = F3(
	function (bgRGBA, content, dateTxt) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'id',
					$elm$json$Json$Encode$string(
						$author$project$Data$PDF$Annotation$dateTxtId(dateTxt))),
					_Utils_Tuple2(
					'content',
					$elm$json$Json$Encode$string(content)),
					_Utils_Tuple2(
					'style',
					$author$project$Data$PDF$Port$encodeStyle(
						$author$project$Data$PDF$Annotation$dateTxtStyle(dateTxt))),
					_Utils_Tuple2(
					'status',
					$author$project$Data$PDF$Port$encodeStatus(
						$author$project$Data$PDF$Annotation$dateTxtStatus(dateTxt))),
					_Utils_Tuple2(
					'color',
					$author$project$Data$PDF$Port$encodeBgRGB(bgRGBA))
				]));
	});
var $author$project$Data$PDF$Annotation$txtId = function (_v0) {
	var txt = _v0.a;
	return txt.id;
};
var $author$project$Data$PDF$Annotation$txtStatus = function (_v0) {
	var txt = _v0.a;
	return txt.status;
};
var $author$project$Data$PDF$Annotation$txtStyle = function (_v0) {
	var txt = _v0.a;
	return txt.style;
};
var $author$project$Data$PDF$Port$encodeFreeText = F3(
	function (bgRGBA, content, txt) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'id',
					$elm$json$Json$Encode$string(
						$author$project$Data$PDF$Annotation$txtId(txt))),
					_Utils_Tuple2(
					'content',
					$elm$json$Json$Encode$string(content)),
					_Utils_Tuple2(
					'style',
					$author$project$Data$PDF$Port$encodeStyle(
						$author$project$Data$PDF$Annotation$txtStyle(txt))),
					_Utils_Tuple2(
					'status',
					$author$project$Data$PDF$Port$encodeStatus(
						$author$project$Data$PDF$Annotation$txtStatus(txt))),
					_Utils_Tuple2(
					'color',
					$author$project$Data$PDF$Port$encodeBgRGB(bgRGBA))
				]));
	});
var $author$project$Data$PDF$Annotation$numberTxtId = function (_v0) {
	var numTxt = _v0.a;
	return numTxt.id;
};
var $author$project$Data$PDF$Annotation$numberTxtStatus = function (_v0) {
	var numTxt = _v0.a;
	return numTxt.status;
};
var $author$project$Data$PDF$Annotation$numberTxtStyle = function (_v0) {
	var numTxt = _v0.a;
	return numTxt.style;
};
var $author$project$Data$PDF$Port$encodeNumberText = F3(
	function (bgRGBA, content, numberTxt) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'id',
					$elm$json$Json$Encode$string(
						$author$project$Data$PDF$Annotation$numberTxtId(numberTxt))),
					_Utils_Tuple2(
					'content',
					$elm$json$Json$Encode$string(content)),
					_Utils_Tuple2(
					'style',
					$author$project$Data$PDF$Port$encodeStyle(
						$author$project$Data$PDF$Annotation$numberTxtStyle(numberTxt))),
					_Utils_Tuple2(
					'status',
					$author$project$Data$PDF$Port$encodeStatus(
						$author$project$Data$PDF$Annotation$numberTxtStatus(numberTxt))),
					_Utils_Tuple2(
					'color',
					$author$project$Data$PDF$Port$encodeBgRGB(bgRGBA))
				]));
	});
var $elm$core$String$fromFloat = _String_fromNumber;
var $author$project$Data$PDF$User$materialColorRGB = function (color) {
	switch (color.$) {
		case 'Purple':
			return {a: 0.1, b: 188, g: 71, r: 171};
		case 'Indigo':
			return {a: 0.1, b: 192, g: 107, r: 92};
		case 'Cyan':
			return {a: 0.1, b: 218, g: 198, r: 38};
		case 'Teal':
			return {a: 0.1, b: 154, g: 166, r: 38};
		case 'Brown':
			return {a: 0.1, b: 99, g: 110, r: 141};
		case 'Orange':
			return {a: 0.1, b: 38, g: 167, r: 255};
		case 'Blue':
			return {a: 0.1, b: 245, g: 165, r: 66};
		default:
			return {a: 0, b: 255, g: 255, r: 255};
	}
};
var $author$project$Data$PDF$Annotation$numberField = function (_v0) {
	var annotField = _v0.a;
	var numberTxt = _v0.b;
	return _Utils_Tuple2(annotField, numberTxt);
};
var $author$project$Data$PDF$Annotation$numberTxtContent = function (_v0) {
	var numTxt = _v0.a;
	return numTxt.content;
};
var $author$project$Data$PDF$Annotation$signatureField = function (_v0) {
	var annotField = _v0.a;
	var unsignedSig = _v0.b;
	return _Utils_Tuple2(annotField, unsignedSig);
};
var $author$project$Data$PDF$Annotation$stampField = function (_v0) {
	var annotField = _v0.a;
	var stamp = _v0.b;
	return _Utils_Tuple2(annotField, stamp);
};
var $author$project$Data$PDF$Annotation$stampFieldsStyle = function (_v0) {
	var stamp = _v0.a;
	return _Utils_Tuple2(stamp.id, stamp.style);
};
var $author$project$Data$PDF$Annotation$textField = function (_v0) {
	var annotField = _v0.a;
	var txt = _v0.b;
	return _Utils_Tuple2(annotField, txt);
};
var $author$project$Data$PDF$Annotation$toStringPosix = function (posix) {
	return $elm$core$String$fromInt(
		$elm$time$Time$posixToMillis(posix));
};
var $author$project$Data$PDF$Annotation$txtText = function (_v0) {
	var txt = _v0.a;
	return txt.text;
};
var $author$project$Data$PDF$Annotation$unsignedSignatureFields = function (_v0) {
	var signature = _v0.a;
	return _Utils_Tuple2(signature.id, signature.style);
};
var $author$project$Data$PDF$Annotation$unsignedSignatureText = function (_v0) {
	var unsignedSig = _v0.a;
	return unsignedSig.text;
};
var $author$project$Data$PDF$Annotation$Txt = function (a) {
	return {$: 'Txt', a: a};
};
var $author$project$Data$PDF$Annotation$Unverified = {$: 'Unverified'};
var $author$project$Data$PDF$Annotation$unsignedTxtSignature = F2(
	function (sigId, style) {
		return $author$project$Data$PDF$Annotation$Txt(
			{dbId: sigId, id: sigId, status: $author$project$Data$PDF$Annotation$Unverified, style: style, text: 'Signature Here'});
	});
var $author$project$Data$PDF$CreateTemplate$encodeTemplateAnnotations = F2(
	function (annots, encodeSignature) {
		return A2(
			$elm$json$Json$Encode$list,
			function (_v0) {
				var a = _v0.a;
				var roleColour = _v0.b;
				var ownerBgRGBA = $author$project$Data$PDF$User$materialColorRGB($author$project$Data$PDF$User$Transparent);
				var annotFieldBgRGBA = $author$project$Data$PDF$User$materialColorRGB(roleColour);
				switch (a.$) {
					case 'IsName':
						var txt = a.a;
						return $elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'kind',
									$elm$json$Json$Encode$string('Name')),
									_Utils_Tuple2(
									'data',
									A3(
										$author$project$Data$PDF$Port$encodeFreeText,
										ownerBgRGBA,
										$author$project$Data$PDF$Annotation$txtText(txt),
										txt))
								]));
					case 'IsDate':
						var dateTxt = a.a;
						var content = $elm$core$String$fromInt(
							$elm$time$Time$posixToMillis(
								$author$project$Data$PDF$Annotation$dateTxtDate(dateTxt)));
						return $elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'kind',
									$elm$json$Json$Encode$string('Date')),
									_Utils_Tuple2(
									'data',
									A3($author$project$Data$PDF$Port$encodeDateText, ownerBgRGBA, content, dateTxt))
								]));
					case 'IsFreeText':
						var txt = a.a;
						return $elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'kind',
									$elm$json$Json$Encode$string('FreeText')),
									_Utils_Tuple2(
									'data',
									A3(
										$author$project$Data$PDF$Port$encodeFreeText,
										ownerBgRGBA,
										$author$project$Data$PDF$Annotation$txtText(txt),
										txt))
								]));
					case 'IsSignature':
						var signedSig = a.a;
						return encodeSignature(signedSig);
					case 'IsTextField':
						var txtField = a.a;
						var _v2 = $author$project$Data$PDF$Annotation$textField(txtField);
						var annotField = _v2.a;
						var txt = _v2.b;
						var _v3 = $author$project$Data$PDF$Annotation$annotFieldData(annotField);
						var required = _v3.a;
						var name = _v3.b;
						return $elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'kind',
									$elm$json$Json$Encode$string('TextField')),
									_Utils_Tuple2(
									'name',
									$elm$json$Json$Encode$string(name)),
									_Utils_Tuple2(
									'required',
									$elm$json$Json$Encode$bool(required)),
									_Utils_Tuple2(
									'data',
									A3(
										$author$project$Data$PDF$Port$encodeFreeText,
										annotFieldBgRGBA,
										$author$project$Data$PDF$Annotation$txtText(txt),
										txt))
								]));
					case 'IsDateField':
						var dateField_ = a.a;
						var _v4 = $author$project$Data$PDF$Annotation$dateField(dateField_);
						var annotField = _v4.a;
						var dateTxt = _v4.b;
						var _v5 = $author$project$Data$PDF$Annotation$annotFieldData(annotField);
						var required = _v5.a;
						var name = _v5.b;
						return $elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'kind',
									$elm$json$Json$Encode$string('DateField')),
									_Utils_Tuple2(
									'name',
									$elm$json$Json$Encode$string(name)),
									_Utils_Tuple2(
									'required',
									$elm$json$Json$Encode$bool(required)),
									_Utils_Tuple2(
									'data',
									A3(
										$author$project$Data$PDF$Port$encodeDateText,
										annotFieldBgRGBA,
										$author$project$Data$PDF$Annotation$toStringPosix(
											$author$project$Data$PDF$Annotation$dateTxtDate(dateTxt)),
										dateTxt))
								]));
					case 'IsSignatureField':
						var unsignedSigField = a.a;
						var _v6 = $author$project$Data$PDF$Annotation$signatureField(unsignedSigField);
						var annotField = _v6.a;
						var unsignedSig = _v6.b;
						var _v7 = $author$project$Data$PDF$Annotation$unsignedSignatureFields(unsignedSig);
						var id = _v7.a;
						var style = _v7.b;
						var unsignedTxt = A2($author$project$Data$PDF$Annotation$unsignedTxtSignature, id, style);
						var _v8 = $author$project$Data$PDF$Annotation$annotFieldData(annotField);
						var required = _v8.a;
						var name = _v8.b;
						return $elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'kind',
									$elm$json$Json$Encode$string('SignatureField')),
									_Utils_Tuple2(
									'name',
									$elm$json$Json$Encode$string(name)),
									_Utils_Tuple2(
									'required',
									$elm$json$Json$Encode$bool(required)),
									_Utils_Tuple2(
									'data',
									A3(
										$author$project$Data$PDF$Port$encodeFreeText,
										annotFieldBgRGBA,
										$author$project$Data$PDF$Annotation$unsignedSignatureText(unsignedSig),
										unsignedTxt))
								]));
					case 'IsNumberField':
						var numField = a.a;
						var _v9 = $author$project$Data$PDF$Annotation$numberField(numField);
						var annotField = _v9.a;
						var numberTxt = _v9.b;
						var _v10 = $author$project$Data$PDF$Annotation$annotFieldData(annotField);
						var required = _v10.a;
						var name = _v10.b;
						return $elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'kind',
									$elm$json$Json$Encode$string('NumberField')),
									_Utils_Tuple2(
									'name',
									$elm$json$Json$Encode$string(name)),
									_Utils_Tuple2(
									'required',
									$elm$json$Json$Encode$bool(required)),
									_Utils_Tuple2(
									'data',
									A3(
										$author$project$Data$PDF$Port$encodeNumberText,
										annotFieldBgRGBA,
										$elm$core$String$fromFloat(
											$author$project$Data$PDF$Annotation$numberTxtContent(numberTxt)),
										numberTxt))
								]));
					case 'IsStampField':
						var stampFieldData = a.a;
						var _v11 = $author$project$Data$PDF$Annotation$stampField(stampFieldData);
						var annotField = _v11.a;
						var stamp = _v11.b;
						var _v12 = $author$project$Data$PDF$Annotation$stampFieldsStyle(stamp);
						var id = _v12.a;
						var style = _v12.b;
						var unsignedTxt = A2($author$project$Data$PDF$Annotation$unsignedTxtSignature, id, style);
						var _v13 = $author$project$Data$PDF$Annotation$annotFieldData(annotField);
						var required = _v13.a;
						var name = _v13.b;
						return $elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'kind',
									$elm$json$Json$Encode$string('StampField')),
									_Utils_Tuple2(
									'name',
									$elm$json$Json$Encode$string(name)),
									_Utils_Tuple2(
									'required',
									$elm$json$Json$Encode$bool(required)),
									_Utils_Tuple2(
									'data',
									A3($author$project$Data$PDF$Port$encodeFreeText, annotFieldBgRGBA, 'Stamp', unsignedTxt))
								]));
					case 'IsNameField':
						var nameFieldData = a.a;
						var _v14 = $author$project$Data$PDF$Annotation$textField(nameFieldData);
						var annotField = _v14.a;
						var txt = _v14.b;
						var _v15 = $author$project$Data$PDF$Annotation$annotFieldData(annotField);
						var required = _v15.a;
						var name = _v15.b;
						return $elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'kind',
									$elm$json$Json$Encode$string('NameField')),
									_Utils_Tuple2(
									'name',
									$elm$json$Json$Encode$string(name)),
									_Utils_Tuple2(
									'required',
									$elm$json$Json$Encode$bool(required)),
									_Utils_Tuple2(
									'data',
									A3(
										$author$project$Data$PDF$Port$encodeFreeText,
										annotFieldBgRGBA,
										$author$project$Data$PDF$Annotation$txtText(txt),
										txt))
								]));
					case 'IsEmailField':
						var emailFieldData = a.a;
						var _v16 = $author$project$Data$PDF$Annotation$textField(emailFieldData);
						var annotField = _v16.a;
						var txt = _v16.b;
						var _v17 = $author$project$Data$PDF$Annotation$annotFieldData(annotField);
						var required = _v17.a;
						var name = _v17.b;
						return $elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'kind',
									$elm$json$Json$Encode$string('EmailField')),
									_Utils_Tuple2(
									'name',
									$elm$json$Json$Encode$string(name)),
									_Utils_Tuple2(
									'required',
									$elm$json$Json$Encode$bool(required)),
									_Utils_Tuple2(
									'data',
									A3(
										$author$project$Data$PDF$Port$encodeFreeText,
										annotFieldBgRGBA,
										$author$project$Data$PDF$Annotation$txtText(txt),
										txt))
								]));
					default:
						var checkboxData = a.a;
						var _v18 = $author$project$Data$PDF$Annotation$checkBoxField(checkboxData);
						var annotField = _v18.a;
						var checkbox = _v18.b;
						var _v19 = $author$project$Data$PDF$Annotation$annotFieldData(annotField);
						var required = _v19.a;
						var name = _v19.b;
						return $elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'kind',
									$elm$json$Json$Encode$string('CheckboxField')),
									_Utils_Tuple2(
									'name',
									$elm$json$Json$Encode$string(name)),
									_Utils_Tuple2(
									'required',
									$elm$json$Json$Encode$bool(required)),
									_Utils_Tuple2(
									'data',
									A3($author$project$Data$PDF$Port$encodeCheckBox, annotFieldBgRGBA, 'Unchecked', checkbox))
								]));
				}
			},
			annots);
	});
var $author$project$Data$PDF$Port$encodeSignedSignature = F4(
	function (id, dbId, imageData, style) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'id',
					$elm$json$Json$Encode$string(id)),
					_Utils_Tuple2(
					'dbId',
					$elm$json$Json$Encode$string(dbId)),
					_Utils_Tuple2(
					'imageData',
					$elm$json$Json$Encode$string(imageData)),
					_Utils_Tuple2(
					'style',
					$author$project$Data$PDF$Port$encodeStyle(style))
				]));
	});
var $author$project$Data$PDF$Signature$data = function (_v0) {
	var signature = _v0.a;
	return signature.data;
};
var $author$project$Data$PDF$Annotation$signedSignatureData = function (_v0) {
	var signature = _v0.a;
	return $author$project$Data$PDF$Signature$data(signature.content);
};
var $author$project$Data$PDF$Annotation$signedSignatureFields = function (_v0) {
	var signature = _v0.a;
	return _Utils_Tuple3(signature.id, signature.dbId, signature.style);
};
var $author$project$Data$PDF$CreateTemplate$encodeViewerSignature = function (signedSig) {
	var _v0 = $author$project$Data$PDF$Annotation$signedSignatureFields(signedSig);
	var id = _v0.a;
	var dbId = _v0.b;
	var style = _v0.c;
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'kind',
				$elm$json$Json$Encode$string('Signature')),
				_Utils_Tuple2(
				'data',
				A4(
					$author$project$Data$PDF$Port$encodeSignedSignature,
					id,
					dbId,
					$author$project$Data$PDF$Annotation$signedSignatureData(signedSig),
					style))
			]));
};
var $author$project$Data$PDF$CreateTemplate$encodeUpdateTemplate = F4(
	function (pdfUser, annots, base64FileData, pagesWithDeletedAnnot) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'owner',
					$author$project$Data$PDF$Port$encodePDFUser(pdfUser)),
					_Utils_Tuple2(
					'annotations',
					A2($author$project$Data$PDF$CreateTemplate$encodeTemplateAnnotations, annots, $author$project$Data$PDF$CreateTemplate$encodeViewerSignature)),
					_Utils_Tuple2(
					'base64FileData',
					$elm$json$Json$Encode$string(base64FileData)),
					_Utils_Tuple2(
					'pagesWithDeletedAnnot',
					A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$int, pagesWithDeletedAnnot))
				]));
	});
var $author$project$Data$PDF$CreateTemplate$getOwner = function (_v0) {
	var owner = _v0.a.owner;
	return owner;
};
var $author$project$Data$PDF$CreateTemplate$IsCheckBoxField = function (a) {
	return {$: 'IsCheckBoxField', a: a};
};
var $author$project$Data$PDF$CreateTemplate$IsDate = function (a) {
	return {$: 'IsDate', a: a};
};
var $author$project$Data$PDF$CreateTemplate$IsDateField = function (a) {
	return {$: 'IsDateField', a: a};
};
var $author$project$Data$PDF$CreateTemplate$IsEmailField = function (a) {
	return {$: 'IsEmailField', a: a};
};
var $author$project$Data$PDF$CreateTemplate$IsFreeText = function (a) {
	return {$: 'IsFreeText', a: a};
};
var $author$project$Data$PDF$CreateTemplate$IsName = function (a) {
	return {$: 'IsName', a: a};
};
var $author$project$Data$PDF$CreateTemplate$IsNameField = function (a) {
	return {$: 'IsNameField', a: a};
};
var $author$project$Data$PDF$CreateTemplate$IsNumberField = function (a) {
	return {$: 'IsNumberField', a: a};
};
var $author$project$Data$PDF$CreateTemplate$IsSignature = function (a) {
	return {$: 'IsSignature', a: a};
};
var $author$project$Data$PDF$CreateTemplate$IsSignatureField = function (a) {
	return {$: 'IsSignatureField', a: a};
};
var $author$project$Data$PDF$CreateTemplate$IsStampField = function (a) {
	return {$: 'IsStampField', a: a};
};
var $author$project$Data$PDF$CreateTemplate$IsTextField = function (a) {
	return {$: 'IsTextField', a: a};
};
var $author$project$Data$PDF$Annotation$CheckBoxField = F2(
	function (a, b) {
		return {$: 'CheckBoxField', a: a, b: b};
	});
var $author$project$Data$PDF$Annotation$Checkbox = function (a) {
	return {$: 'Checkbox', a: a};
};
var $elm$core$Bitwise$and = _Bitwise_and;
var $elm$core$Array$repeat = F2(
	function (n, e) {
		return A2(
			$elm$core$Array$initialize,
			n,
			function (_v0) {
				return e;
			});
	});
var $truqu$elm_md5$MD5$emptyWords = A2($elm$core$Array$repeat, 16, 0);
var $truqu$elm_md5$MD5$addUnsigned = F2(
	function (x, y) {
		return 4294967295 & (x + y);
	});
var $elm$core$Bitwise$or = _Bitwise_or;
var $elm$core$Bitwise$shiftLeftBy = _Bitwise_shiftLeftBy;
var $elm$core$Bitwise$shiftRightZfBy = _Bitwise_shiftRightZfBy;
var $truqu$elm_md5$MD5$rotateLeft = F2(
	function (bits, input) {
		return (input << bits) | (input >>> (32 - bits));
	});
var $truqu$elm_md5$MD5$cmn = F8(
	function (fun, a, b, c, d, x, s, ac) {
		return A2(
			$truqu$elm_md5$MD5$addUnsigned,
			b,
			A2(
				$truqu$elm_md5$MD5$rotateLeft,
				s,
				A2(
					$truqu$elm_md5$MD5$addUnsigned,
					a,
					A2(
						$truqu$elm_md5$MD5$addUnsigned,
						ac,
						A2(
							$truqu$elm_md5$MD5$addUnsigned,
							A3(fun, b, c, d),
							x)))));
	});
var $elm$core$Bitwise$xor = _Bitwise_xor;
var $truqu$elm_md5$MD5$f = F3(
	function (x, y, z) {
		return z ^ (x & (y ^ z));
	});
var $truqu$elm_md5$MD5$ff = F7(
	function (a, b, c, d, x, s, ac) {
		return A8($truqu$elm_md5$MD5$cmn, $truqu$elm_md5$MD5$f, a, b, c, d, x, s, ac);
	});
var $truqu$elm_md5$MD5$g = F3(
	function (x, y, z) {
		return y ^ (z & (x ^ y));
	});
var $truqu$elm_md5$MD5$gg = F7(
	function (a, b, c, d, x, s, ac) {
		return A8($truqu$elm_md5$MD5$cmn, $truqu$elm_md5$MD5$g, a, b, c, d, x, s, ac);
	});
var $truqu$elm_md5$MD5$h = F3(
	function (x, y, z) {
		return z ^ (x ^ y);
	});
var $truqu$elm_md5$MD5$hh = F7(
	function (a, b, c, d, x, s, ac) {
		return A8($truqu$elm_md5$MD5$cmn, $truqu$elm_md5$MD5$h, a, b, c, d, x, s, ac);
	});
var $elm$core$Bitwise$complement = _Bitwise_complement;
var $truqu$elm_md5$MD5$i = F3(
	function (x, y, z) {
		return y ^ (x | (~z));
	});
var $truqu$elm_md5$MD5$ii = F7(
	function (a, b, c, d, x, s, ac) {
		return A8($truqu$elm_md5$MD5$cmn, $truqu$elm_md5$MD5$i, a, b, c, d, x, s, ac);
	});
var $truqu$elm_md5$MD5$hex_ = F2(
	function (xs, acc) {
		var a = acc.a;
		var b = acc.b;
		var c = acc.c;
		var d = acc.d;
		if ((((((((((((((((xs.b && xs.b.b) && xs.b.b.b) && xs.b.b.b.b) && xs.b.b.b.b.b) && xs.b.b.b.b.b.b) && xs.b.b.b.b.b.b.b) && xs.b.b.b.b.b.b.b.b) && xs.b.b.b.b.b.b.b.b.b) && xs.b.b.b.b.b.b.b.b.b.b) && xs.b.b.b.b.b.b.b.b.b.b.b) && xs.b.b.b.b.b.b.b.b.b.b.b.b) && xs.b.b.b.b.b.b.b.b.b.b.b.b.b) && xs.b.b.b.b.b.b.b.b.b.b.b.b.b.b) && xs.b.b.b.b.b.b.b.b.b.b.b.b.b.b.b) && xs.b.b.b.b.b.b.b.b.b.b.b.b.b.b.b.b) && (!xs.b.b.b.b.b.b.b.b.b.b.b.b.b.b.b.b.b)) {
			var x0 = xs.a;
			var _v1 = xs.b;
			var x1 = _v1.a;
			var _v2 = _v1.b;
			var x2 = _v2.a;
			var _v3 = _v2.b;
			var x3 = _v3.a;
			var _v4 = _v3.b;
			var x4 = _v4.a;
			var _v5 = _v4.b;
			var x5 = _v5.a;
			var _v6 = _v5.b;
			var x6 = _v6.a;
			var _v7 = _v6.b;
			var x7 = _v7.a;
			var _v8 = _v7.b;
			var x8 = _v8.a;
			var _v9 = _v8.b;
			var x9 = _v9.a;
			var _v10 = _v9.b;
			var x10 = _v10.a;
			var _v11 = _v10.b;
			var x11 = _v11.a;
			var _v12 = _v11.b;
			var x12 = _v12.a;
			var _v13 = _v12.b;
			var x13 = _v13.a;
			var _v14 = _v13.b;
			var x14 = _v14.a;
			var _v15 = _v14.b;
			var x15 = _v15.a;
			var s44 = 21;
			var s43 = 15;
			var s42 = 10;
			var s41 = 6;
			var s34 = 23;
			var s33 = 16;
			var s32 = 11;
			var s31 = 4;
			var s24 = 20;
			var s23 = 14;
			var s22 = 9;
			var s21 = 5;
			var s14 = 22;
			var s13 = 17;
			var s12 = 12;
			var s11 = 7;
			var d00 = d;
			var c00 = c;
			var b00 = b;
			var a00 = a;
			var a01 = A7($truqu$elm_md5$MD5$ff, a00, b00, c00, d00, x0, s11, 3614090360);
			var d01 = A7($truqu$elm_md5$MD5$ff, d00, a01, b00, c00, x1, s12, 3905402710);
			var c01 = A7($truqu$elm_md5$MD5$ff, c00, d01, a01, b00, x2, s13, 606105819);
			var b01 = A7($truqu$elm_md5$MD5$ff, b00, c01, d01, a01, x3, s14, 3250441966);
			var a02 = A7($truqu$elm_md5$MD5$ff, a01, b01, c01, d01, x4, s11, 4118548399);
			var d02 = A7($truqu$elm_md5$MD5$ff, d01, a02, b01, c01, x5, s12, 1200080426);
			var c02 = A7($truqu$elm_md5$MD5$ff, c01, d02, a02, b01, x6, s13, 2821735955);
			var b02 = A7($truqu$elm_md5$MD5$ff, b01, c02, d02, a02, x7, s14, 4249261313);
			var a03 = A7($truqu$elm_md5$MD5$ff, a02, b02, c02, d02, x8, s11, 1770035416);
			var d03 = A7($truqu$elm_md5$MD5$ff, d02, a03, b02, c02, x9, s12, 2336552879);
			var c03 = A7($truqu$elm_md5$MD5$ff, c02, d03, a03, b02, x10, s13, 4294925233);
			var b03 = A7($truqu$elm_md5$MD5$ff, b02, c03, d03, a03, x11, s14, 2304563134);
			var a04 = A7($truqu$elm_md5$MD5$ff, a03, b03, c03, d03, x12, s11, 1804603682);
			var d04 = A7($truqu$elm_md5$MD5$ff, d03, a04, b03, c03, x13, s12, 4254626195);
			var c04 = A7($truqu$elm_md5$MD5$ff, c03, d04, a04, b03, x14, s13, 2792965006);
			var b04 = A7($truqu$elm_md5$MD5$ff, b03, c04, d04, a04, x15, s14, 1236535329);
			var a05 = A7($truqu$elm_md5$MD5$gg, a04, b04, c04, d04, x1, s21, 4129170786);
			var d05 = A7($truqu$elm_md5$MD5$gg, d04, a05, b04, c04, x6, s22, 3225465664);
			var c05 = A7($truqu$elm_md5$MD5$gg, c04, d05, a05, b04, x11, s23, 643717713);
			var b05 = A7($truqu$elm_md5$MD5$gg, b04, c05, d05, a05, x0, s24, 3921069994);
			var a06 = A7($truqu$elm_md5$MD5$gg, a05, b05, c05, d05, x5, s21, 3593408605);
			var d06 = A7($truqu$elm_md5$MD5$gg, d05, a06, b05, c05, x10, s22, 38016083);
			var c06 = A7($truqu$elm_md5$MD5$gg, c05, d06, a06, b05, x15, s23, 3634488961);
			var b06 = A7($truqu$elm_md5$MD5$gg, b05, c06, d06, a06, x4, s24, 3889429448);
			var a07 = A7($truqu$elm_md5$MD5$gg, a06, b06, c06, d06, x9, s21, 568446438);
			var d07 = A7($truqu$elm_md5$MD5$gg, d06, a07, b06, c06, x14, s22, 3275163606);
			var c07 = A7($truqu$elm_md5$MD5$gg, c06, d07, a07, b06, x3, s23, 4107603335);
			var b07 = A7($truqu$elm_md5$MD5$gg, b06, c07, d07, a07, x8, s24, 1163531501);
			var a08 = A7($truqu$elm_md5$MD5$gg, a07, b07, c07, d07, x13, s21, 2850285829);
			var d08 = A7($truqu$elm_md5$MD5$gg, d07, a08, b07, c07, x2, s22, 4243563512);
			var c08 = A7($truqu$elm_md5$MD5$gg, c07, d08, a08, b07, x7, s23, 1735328473);
			var b08 = A7($truqu$elm_md5$MD5$gg, b07, c08, d08, a08, x12, s24, 2368359562);
			var a09 = A7($truqu$elm_md5$MD5$hh, a08, b08, c08, d08, x5, s31, 4294588738);
			var d09 = A7($truqu$elm_md5$MD5$hh, d08, a09, b08, c08, x8, s32, 2272392833);
			var c09 = A7($truqu$elm_md5$MD5$hh, c08, d09, a09, b08, x11, s33, 1839030562);
			var b09 = A7($truqu$elm_md5$MD5$hh, b08, c09, d09, a09, x14, s34, 4259657740);
			var a10 = A7($truqu$elm_md5$MD5$hh, a09, b09, c09, d09, x1, s31, 2763975236);
			var d10 = A7($truqu$elm_md5$MD5$hh, d09, a10, b09, c09, x4, s32, 1272893353);
			var c10 = A7($truqu$elm_md5$MD5$hh, c09, d10, a10, b09, x7, s33, 4139469664);
			var b10 = A7($truqu$elm_md5$MD5$hh, b09, c10, d10, a10, x10, s34, 3200236656);
			var a11 = A7($truqu$elm_md5$MD5$hh, a10, b10, c10, d10, x13, s31, 681279174);
			var d11 = A7($truqu$elm_md5$MD5$hh, d10, a11, b10, c10, x0, s32, 3936430074);
			var c11 = A7($truqu$elm_md5$MD5$hh, c10, d11, a11, b10, x3, s33, 3572445317);
			var b11 = A7($truqu$elm_md5$MD5$hh, b10, c11, d11, a11, x6, s34, 76029189);
			var a12 = A7($truqu$elm_md5$MD5$hh, a11, b11, c11, d11, x9, s31, 3654602809);
			var d12 = A7($truqu$elm_md5$MD5$hh, d11, a12, b11, c11, x12, s32, 3873151461);
			var c12 = A7($truqu$elm_md5$MD5$hh, c11, d12, a12, b11, x15, s33, 530742520);
			var b12 = A7($truqu$elm_md5$MD5$hh, b11, c12, d12, a12, x2, s34, 3299628645);
			var a13 = A7($truqu$elm_md5$MD5$ii, a12, b12, c12, d12, x0, s41, 4096336452);
			var d13 = A7($truqu$elm_md5$MD5$ii, d12, a13, b12, c12, x7, s42, 1126891415);
			var c13 = A7($truqu$elm_md5$MD5$ii, c12, d13, a13, b12, x14, s43, 2878612391);
			var b13 = A7($truqu$elm_md5$MD5$ii, b12, c13, d13, a13, x5, s44, 4237533241);
			var a14 = A7($truqu$elm_md5$MD5$ii, a13, b13, c13, d13, x12, s41, 1700485571);
			var d14 = A7($truqu$elm_md5$MD5$ii, d13, a14, b13, c13, x3, s42, 2399980690);
			var c14 = A7($truqu$elm_md5$MD5$ii, c13, d14, a14, b13, x10, s43, 4293915773);
			var b14 = A7($truqu$elm_md5$MD5$ii, b13, c14, d14, a14, x1, s44, 2240044497);
			var a15 = A7($truqu$elm_md5$MD5$ii, a14, b14, c14, d14, x8, s41, 1873313359);
			var d15 = A7($truqu$elm_md5$MD5$ii, d14, a15, b14, c14, x15, s42, 4264355552);
			var c15 = A7($truqu$elm_md5$MD5$ii, c14, d15, a15, b14, x6, s43, 2734768916);
			var b15 = A7($truqu$elm_md5$MD5$ii, b14, c15, d15, a15, x13, s44, 1309151649);
			var a16 = A7($truqu$elm_md5$MD5$ii, a15, b15, c15, d15, x4, s41, 4149444226);
			var d16 = A7($truqu$elm_md5$MD5$ii, d15, a16, b15, c15, x11, s42, 3174756917);
			var c16 = A7($truqu$elm_md5$MD5$ii, c15, d16, a16, b15, x2, s43, 718787259);
			var b16 = A7($truqu$elm_md5$MD5$ii, b15, c16, d16, a16, x9, s44, 3951481745);
			var b17 = A2($truqu$elm_md5$MD5$addUnsigned, b00, b16);
			var c17 = A2($truqu$elm_md5$MD5$addUnsigned, c00, c16);
			var d17 = A2($truqu$elm_md5$MD5$addUnsigned, d00, d16);
			var a17 = A2($truqu$elm_md5$MD5$addUnsigned, a00, a16);
			return {a: a17, b: b17, c: c17, d: d17};
		} else {
			return acc;
		}
	});
var $elm$core$Array$bitMask = 4294967295 >>> (32 - $elm$core$Array$shiftStep);
var $elm$core$Elm$JsArray$unsafeGet = _JsArray_unsafeGet;
var $elm$core$Array$getHelp = F3(
	function (shift, index, tree) {
		getHelp:
		while (true) {
			var pos = $elm$core$Array$bitMask & (index >>> shift);
			var _v0 = A2($elm$core$Elm$JsArray$unsafeGet, pos, tree);
			if (_v0.$ === 'SubTree') {
				var subTree = _v0.a;
				var $temp$shift = shift - $elm$core$Array$shiftStep,
					$temp$index = index,
					$temp$tree = subTree;
				shift = $temp$shift;
				index = $temp$index;
				tree = $temp$tree;
				continue getHelp;
			} else {
				var values = _v0.a;
				return A2($elm$core$Elm$JsArray$unsafeGet, $elm$core$Array$bitMask & index, values);
			}
		}
	});
var $elm$core$Array$tailIndex = function (len) {
	return (len >>> 5) << 5;
};
var $elm$core$Array$get = F2(
	function (index, _v0) {
		var len = _v0.a;
		var startShift = _v0.b;
		var tree = _v0.c;
		var tail = _v0.d;
		return ((index < 0) || (_Utils_cmp(index, len) > -1)) ? $elm$core$Maybe$Nothing : ((_Utils_cmp(
			index,
			$elm$core$Array$tailIndex(len)) > -1) ? $elm$core$Maybe$Just(
			A2($elm$core$Elm$JsArray$unsafeGet, $elm$core$Array$bitMask & index, tail)) : $elm$core$Maybe$Just(
			A3($elm$core$Array$getHelp, startShift, index, tree)));
	});
var $truqu$elm_md5$MD5$iget = F2(
	function (index, array) {
		return A2(
			$elm$core$Maybe$withDefault,
			0,
			A2($elm$core$Array$get, index, array));
	});
var $elm$core$Elm$JsArray$unsafeSet = _JsArray_unsafeSet;
var $elm$core$Array$setHelp = F4(
	function (shift, index, value, tree) {
		var pos = $elm$core$Array$bitMask & (index >>> shift);
		var _v0 = A2($elm$core$Elm$JsArray$unsafeGet, pos, tree);
		if (_v0.$ === 'SubTree') {
			var subTree = _v0.a;
			var newSub = A4($elm$core$Array$setHelp, shift - $elm$core$Array$shiftStep, index, value, subTree);
			return A3(
				$elm$core$Elm$JsArray$unsafeSet,
				pos,
				$elm$core$Array$SubTree(newSub),
				tree);
		} else {
			var values = _v0.a;
			var newLeaf = A3($elm$core$Elm$JsArray$unsafeSet, $elm$core$Array$bitMask & index, value, values);
			return A3(
				$elm$core$Elm$JsArray$unsafeSet,
				pos,
				$elm$core$Array$Leaf(newLeaf),
				tree);
		}
	});
var $elm$core$Array$set = F3(
	function (index, value, array) {
		var len = array.a;
		var startShift = array.b;
		var tree = array.c;
		var tail = array.d;
		return ((index < 0) || (_Utils_cmp(index, len) > -1)) ? array : ((_Utils_cmp(
			index,
			$elm$core$Array$tailIndex(len)) > -1) ? A4(
			$elm$core$Array$Array_elm_builtin,
			len,
			startShift,
			tree,
			A3($elm$core$Elm$JsArray$unsafeSet, $elm$core$Array$bitMask & index, value, tail)) : A4(
			$elm$core$Array$Array_elm_builtin,
			len,
			startShift,
			A4($elm$core$Array$setHelp, startShift, index, value, tree),
			tail));
	});
var $truqu$elm_md5$MD5$consume = F2(
	function (_char, _v0) {
		var hashState = _v0.a;
		var _v1 = _v0.b;
		var byteCount = _v1.a;
		var words = _v1.b;
		var totalByteCount = _v0.c;
		var wordCount = (byteCount / 4) | 0;
		var oldWord = A2($truqu$elm_md5$MD5$iget, wordCount, words);
		var bytePosition = 8 * (byteCount % 4);
		var code = _char << bytePosition;
		var newWord = oldWord | code;
		var newWords = A3($elm$core$Array$set, wordCount, newWord, words);
		return (byteCount === 63) ? _Utils_Tuple3(
			A2(
				$truqu$elm_md5$MD5$hex_,
				$elm$core$Array$toList(newWords),
				hashState),
			_Utils_Tuple2(0, $truqu$elm_md5$MD5$emptyWords),
			totalByteCount + 1) : _Utils_Tuple3(
			hashState,
			_Utils_Tuple2(byteCount + 1, newWords),
			totalByteCount + 1);
	});
var $truqu$elm_md5$MD5$finishUp = function (_v0) {
	var hashState = _v0.a;
	var _v1 = _v0.b;
	var byteCount = _v1.a;
	var words = _v1.b;
	var totalByteCount = _v0.c;
	var wordCount = (byteCount / 4) | 0;
	var oldWord = A2($truqu$elm_md5$MD5$iget, wordCount, words);
	var bytePosition = 8 * (byteCount % 4);
	var code = 128 << bytePosition;
	var newWord = oldWord | code;
	var newWords = A3($elm$core$Array$set, wordCount, newWord, words);
	return (wordCount < 14) ? function (x) {
		return A2($truqu$elm_md5$MD5$hex_, x, hashState);
	}(
		$elm$core$Array$toList(
			A3(
				$elm$core$Array$set,
				15,
				totalByteCount >>> 29,
				A3($elm$core$Array$set, 14, totalByteCount << 3, newWords)))) : function (x) {
		return A2(
			$truqu$elm_md5$MD5$hex_,
			x,
			A2(
				$truqu$elm_md5$MD5$hex_,
				$elm$core$Array$toList(newWords),
				hashState));
	}(
		$elm$core$Array$toList(
			A3(
				$elm$core$Array$set,
				15,
				totalByteCount >>> 29,
				A3($elm$core$Array$set, 14, totalByteCount << 3, $truqu$elm_md5$MD5$emptyWords))));
};
var $elm$core$String$foldl = _String_foldl;
var $zwilias$elm_utf_tools$String$UTF8$utf32ToUtf8 = F3(
	function (add, _char, acc) {
		return (_char < 128) ? A2(add, _char, acc) : ((_char < 2048) ? A2(
			add,
			128 | (63 & _char),
			A2(add, 192 | (_char >>> 6), acc)) : ((_char < 65536) ? A2(
			add,
			128 | (63 & _char),
			A2(
				add,
				128 | (63 & (_char >>> 6)),
				A2(add, 224 | (_char >>> 12), acc))) : A2(
			add,
			128 | (63 & _char),
			A2(
				add,
				128 | (63 & (_char >>> 6)),
				A2(
					add,
					128 | (63 & (_char >>> 12)),
					A2(add, 240 | (_char >>> 18), acc))))));
	});
var $zwilias$elm_utf_tools$String$UTF8$foldl = F3(
	function (op, initialAcc, input) {
		return A3(
			$elm$core$String$foldl,
			F2(
				function (_char, acc) {
					return A3(
						$zwilias$elm_utf_tools$String$UTF8$utf32ToUtf8,
						op,
						$elm$core$Char$toCode(_char),
						acc);
				}),
			initialAcc,
			input);
	});
var $truqu$elm_md5$MD5$State = F4(
	function (a, b, c, d) {
		return {a: a, b: b, c: c, d: d};
	});
var $truqu$elm_md5$MD5$initialHashState = A4($truqu$elm_md5$MD5$State, 1732584193, 4023233417, 2562383102, 271733878);
var $truqu$elm_md5$MD5$hash = function (input) {
	return $truqu$elm_md5$MD5$finishUp(
		A3(
			$zwilias$elm_utf_tools$String$UTF8$foldl,
			$truqu$elm_md5$MD5$consume,
			_Utils_Tuple3(
				$truqu$elm_md5$MD5$initialHashState,
				_Utils_Tuple2(0, $truqu$elm_md5$MD5$emptyWords),
				0),
			input));
};
var $truqu$elm_md5$MD5$bytes = function (string) {
	var _v0 = $truqu$elm_md5$MD5$hash(string);
	var a = _v0.a;
	var b = _v0.b;
	var c = _v0.c;
	var d = _v0.d;
	return _List_fromArray(
		[a & 255, (a >>> 8) & 255, (a >>> 16) & 255, (a >>> 24) & 255, b & 255, (b >>> 8) & 255, (b >>> 16) & 255, (b >>> 24) & 255, c & 255, (c >>> 8) & 255, (c >>> 16) & 255, (c >>> 24) & 255, d & 255, (d >>> 8) & 255, (d >>> 16) & 255, (d >>> 24) & 255]);
};
var $elm$core$String$cons = _String_cons;
var $elm$core$String$fromChar = function (_char) {
	return A2($elm$core$String$cons, _char, '');
};
var $elm$core$Bitwise$shiftRightBy = _Bitwise_shiftRightBy;
var $elm$core$String$repeatHelp = F3(
	function (n, chunk, result) {
		return (n <= 0) ? result : A3(
			$elm$core$String$repeatHelp,
			n >> 1,
			_Utils_ap(chunk, chunk),
			(!(n & 1)) ? result : _Utils_ap(result, chunk));
	});
var $elm$core$String$repeat = F2(
	function (n, chunk) {
		return A3($elm$core$String$repeatHelp, n, chunk, '');
	});
var $elm$core$String$padLeft = F3(
	function (n, _char, string) {
		return _Utils_ap(
			A2(
				$elm$core$String$repeat,
				n - $elm$core$String$length(string),
				$elm$core$String$fromChar(_char)),
			string);
	});
var $truqu$elm_md5$MD5$toHex = function (_byte) {
	switch (_byte) {
		case 0:
			return '0';
		case 1:
			return '1';
		case 2:
			return '2';
		case 3:
			return '3';
		case 4:
			return '4';
		case 5:
			return '5';
		case 6:
			return '6';
		case 7:
			return '7';
		case 8:
			return '8';
		case 9:
			return '9';
		case 10:
			return 'a';
		case 11:
			return 'b';
		case 12:
			return 'c';
		case 13:
			return 'd';
		case 14:
			return 'e';
		case 15:
			return 'f';
		default:
			return _Utils_ap(
				$truqu$elm_md5$MD5$toHex((_byte / 16) | 0),
				$truqu$elm_md5$MD5$toHex(_byte % 16));
	}
};
var $truqu$elm_md5$MD5$hex = function (s) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (b, acc) {
				return _Utils_ap(
					acc,
					A3(
						$elm$core$String$padLeft,
						2,
						_Utils_chr('0'),
						$truqu$elm_md5$MD5$toHex(b)));
			}),
		'',
		$truqu$elm_md5$MD5$bytes(s));
};
var $author$project$Data$PDF$Annotation$generateId = F3(
	function (content, status, style) {
		return $truqu$elm_md5$MD5$hex(
			_Utils_ap(
				content,
				_Utils_ap(
					status,
					_Utils_ap(
						style.fontSize,
						_Utils_ap(
							$elm$core$String$fromFloat(style.height),
							_Utils_ap(
								$elm$core$String$fromFloat(style.width),
								_Utils_ap(
									$elm$core$String$fromInt(style.page),
									_Utils_ap(
										$elm$core$String$fromFloat(style.x),
										$elm$core$String$fromFloat(style.y)))))))));
	});
var $author$project$Data$PDF$Annotation$toCheckBoxStatusString = function (status) {
	switch (status.$) {
		case 'Checked':
			return 'Checked';
		case 'Unchecked':
			return 'Unchecked';
		default:
			return 'PlaceHolder';
	}
};
var $author$project$Data$PDF$Annotation$updatePositionStyle = F2(
	function (_v0, style) {
		var x = _v0.x;
		var y = _v0.y;
		var page = _v0.page;
		return {fontSize: style.fontSize, height: style.height, page: page, width: style.width, x: x, y: y};
	});
var $author$project$Data$PDF$Annotation$updateCheckboxPositionStyle = F2(
	function (position, _v0) {
		var checkbox = _v0.a;
		var updatedStyle = A2($author$project$Data$PDF$Annotation$updatePositionStyle, position, checkbox.style);
		return $author$project$Data$PDF$Annotation$Checkbox(
			_Utils_update(
				checkbox,
				{
					id: A3(
						$author$project$Data$PDF$Annotation$generateId,
						$author$project$Data$PDF$Annotation$toCheckBoxStatusString(checkbox.status),
						$author$project$Data$PDF$Annotation$toCheckBoxStatusString(checkbox.status),
						updatedStyle),
					style: updatedStyle
				}));
	});
var $author$project$Data$PDF$Annotation$updateCheckBoxFieldPosiitonStyle = F2(
	function (position, _v0) {
		var annotField = _v0.a;
		var checkbox = _v0.b;
		return A2(
			$author$project$Data$PDF$Annotation$CheckBoxField,
			annotField,
			A2($author$project$Data$PDF$Annotation$updateCheckboxPositionStyle, position, checkbox));
	});
var $author$project$Data$PDF$Annotation$DateField = F2(
	function (a, b) {
		return {$: 'DateField', a: a, b: b};
	});
var $author$project$Data$PDF$Annotation$DateTxt = function (a) {
	return {$: 'DateTxt', a: a};
};
var $author$project$Data$PDF$Annotation$toStatusString = function (status) {
	if (status.$ === 'Verified') {
		return 'Verified';
	} else {
		return 'Unverified';
	}
};
var $author$project$Data$PDF$Annotation$updateDateTxtPositionStyle = F2(
	function (position, _v0) {
		var dateTxt_ = _v0.a;
		var updatedStyle = A2($author$project$Data$PDF$Annotation$updatePositionStyle, position, dateTxt_.style);
		return $author$project$Data$PDF$Annotation$DateTxt(
			_Utils_update(
				dateTxt_,
				{
					id: A3(
						$author$project$Data$PDF$Annotation$generateId,
						$author$project$Data$PDF$Annotation$toStringPosix(dateTxt_.date),
						$author$project$Data$PDF$Annotation$toStatusString(dateTxt_.status),
						updatedStyle),
					style: updatedStyle
				}));
	});
var $author$project$Data$PDF$Annotation$updateDateFieldPositionStyle = F2(
	function (position, _v0) {
		var annotField = _v0.a;
		var dateTxt_ = _v0.b;
		return A2(
			$author$project$Data$PDF$Annotation$DateField,
			annotField,
			A2($author$project$Data$PDF$Annotation$updateDateTxtPositionStyle, position, dateTxt_));
	});
var $author$project$Data$PDF$Annotation$NumberField = F2(
	function (a, b) {
		return {$: 'NumberField', a: a, b: b};
	});
var $author$project$Data$PDF$Annotation$NumberTxt = function (a) {
	return {$: 'NumberTxt', a: a};
};
var $author$project$Data$PDF$Annotation$updateNumberFieldPositionStyle = F2(
	function (position, _v0) {
		var annotField = _v0.a;
		var numberTxt = _v0.b.a;
		var updatedStyle = A2($author$project$Data$PDF$Annotation$updatePositionStyle, position, numberTxt.style);
		var newId = A3(
			$author$project$Data$PDF$Annotation$generateId,
			$elm$core$String$fromFloat(numberTxt.content),
			$author$project$Data$PDF$Annotation$toStatusString(numberTxt.status),
			updatedStyle);
		var updatedNumberTxt = $author$project$Data$PDF$Annotation$NumberTxt(
			_Utils_update(
				numberTxt,
				{id: newId, style: updatedStyle}));
		return A2($author$project$Data$PDF$Annotation$NumberField, annotField, updatedNumberTxt);
	});
var $author$project$Data$PDF$Annotation$SignatureField = F2(
	function (a, b) {
		return {$: 'SignatureField', a: a, b: b};
	});
var $author$project$Data$PDF$Annotation$UnsignedSignature = function (a) {
	return {$: 'UnsignedSignature', a: a};
};
var $author$project$Data$PDF$Annotation$updateUnsignedSignaturePositionStyle = F2(
	function (position, _v0) {
		var unsignedSig = _v0.a;
		var updatedStyle = A2($author$project$Data$PDF$Annotation$updatePositionStyle, position, unsignedSig.style);
		return $author$project$Data$PDF$Annotation$UnsignedSignature(
			_Utils_update(
				unsignedSig,
				{
					id: A3($author$project$Data$PDF$Annotation$generateId, '', 'Unsigned', updatedStyle),
					style: updatedStyle
				}));
	});
var $author$project$Data$PDF$Annotation$updateSignatureFieldPositionStyle = F2(
	function (position, _v0) {
		var annotField = _v0.a;
		var unsignedSig = _v0.b;
		return A2(
			$author$project$Data$PDF$Annotation$SignatureField,
			annotField,
			A2($author$project$Data$PDF$Annotation$updateUnsignedSignaturePositionStyle, position, unsignedSig));
	});
var $author$project$Data$PDF$Annotation$SignedSignature = function (a) {
	return {$: 'SignedSignature', a: a};
};
var $author$project$Data$PDF$Annotation$updateSignedSignaturePositionStyle = F2(
	function (position, _v0) {
		var signedSig = _v0.a;
		var updatedStyle = A2($author$project$Data$PDF$Annotation$updatePositionStyle, position, signedSig.style);
		var content = $author$project$Data$PDF$Signature$data(signedSig.content);
		return $author$project$Data$PDF$Annotation$SignedSignature(
			_Utils_update(
				signedSig,
				{
					id: A3($author$project$Data$PDF$Annotation$generateId, content, 'Signed', updatedStyle),
					style: updatedStyle
				}));
	});
var $author$project$Data$PDF$Annotation$StampField = F2(
	function (a, b) {
		return {$: 'StampField', a: a, b: b};
	});
var $author$project$Data$PDF$Annotation$Stamp = function (a) {
	return {$: 'Stamp', a: a};
};
var $author$project$Data$PDF$Annotation$toStampStatusString = function (status) {
	if (status.$ === 'Unstamped') {
		return 'Unstamped';
	} else {
		return 'Stamped';
	}
};
var $author$project$Data$PDF$Annotation$updateStampPositionStyle = F2(
	function (position, _v0) {
		var stamp = _v0.a;
		var updatedStyle = A2($author$project$Data$PDF$Annotation$updatePositionStyle, position, stamp.style);
		return $author$project$Data$PDF$Annotation$Stamp(
			_Utils_update(
				stamp,
				{
					id: A3(
						$author$project$Data$PDF$Annotation$generateId,
						'',
						$author$project$Data$PDF$Annotation$toStampStatusString(stamp.status),
						updatedStyle),
					style: updatedStyle
				}));
	});
var $author$project$Data$PDF$Annotation$updateStampFieldPositionStyle = F2(
	function (position, _v0) {
		var annotField = _v0.a;
		var stamp = _v0.b;
		return A2(
			$author$project$Data$PDF$Annotation$StampField,
			annotField,
			A2($author$project$Data$PDF$Annotation$updateStampPositionStyle, position, stamp));
	});
var $author$project$Data$PDF$Annotation$TextField = F2(
	function (a, b) {
		return {$: 'TextField', a: a, b: b};
	});
var $author$project$Data$PDF$Annotation$updateTxtPositionStyle = F2(
	function (position, _v0) {
		var txt = _v0.a;
		var updatedStyle = A2($author$project$Data$PDF$Annotation$updatePositionStyle, position, txt.style);
		return $author$project$Data$PDF$Annotation$Txt(
			_Utils_update(
				txt,
				{
					id: A3(
						$author$project$Data$PDF$Annotation$generateId,
						txt.text,
						$author$project$Data$PDF$Annotation$toStatusString(txt.status),
						updatedStyle),
					style: updatedStyle
				}));
	});
var $author$project$Data$PDF$Annotation$updateTextFieldPositionStyle = F2(
	function (position, _v0) {
		var annotField = _v0.a;
		var txt = _v0.b;
		return A2(
			$author$project$Data$PDF$Annotation$TextField,
			annotField,
			A2($author$project$Data$PDF$Annotation$updateTxtPositionStyle, position, txt));
	});
var $author$project$Data$PDF$CreateTemplate$updateAnnotPosition = F2(
	function (position, annotation) {
		switch (annotation.$) {
			case 'IsName':
				var txt = annotation.a;
				return $author$project$Data$PDF$CreateTemplate$IsName(
					A2($author$project$Data$PDF$Annotation$updateTxtPositionStyle, position, txt));
			case 'IsDate':
				var dateTxt = annotation.a;
				return $author$project$Data$PDF$CreateTemplate$IsDate(
					A2($author$project$Data$PDF$Annotation$updateDateTxtPositionStyle, position, dateTxt));
			case 'IsFreeText':
				var txt = annotation.a;
				return $author$project$Data$PDF$CreateTemplate$IsFreeText(
					A2($author$project$Data$PDF$Annotation$updateTxtPositionStyle, position, txt));
			case 'IsSignature':
				var signedSig = annotation.a;
				return $author$project$Data$PDF$CreateTemplate$IsSignature(
					A2($author$project$Data$PDF$Annotation$updateSignedSignaturePositionStyle, position, signedSig));
			case 'IsTextField':
				var txtField = annotation.a;
				return $author$project$Data$PDF$CreateTemplate$IsTextField(
					A2($author$project$Data$PDF$Annotation$updateTextFieldPositionStyle, position, txtField));
			case 'IsDateField':
				var dateField = annotation.a;
				return $author$project$Data$PDF$CreateTemplate$IsDateField(
					A2($author$project$Data$PDF$Annotation$updateDateFieldPositionStyle, position, dateField));
			case 'IsSignatureField':
				var unsignedSig = annotation.a;
				return $author$project$Data$PDF$CreateTemplate$IsSignatureField(
					A2($author$project$Data$PDF$Annotation$updateSignatureFieldPositionStyle, position, unsignedSig));
			case 'IsNumberField':
				var numTxt = annotation.a;
				return $author$project$Data$PDF$CreateTemplate$IsNumberField(
					A2($author$project$Data$PDF$Annotation$updateNumberFieldPositionStyle, position, numTxt));
			case 'IsStampField':
				var stamp = annotation.a;
				return $author$project$Data$PDF$CreateTemplate$IsStampField(
					A2($author$project$Data$PDF$Annotation$updateStampFieldPositionStyle, position, stamp));
			case 'IsNameField':
				var nameField = annotation.a;
				return $author$project$Data$PDF$CreateTemplate$IsNameField(
					A2($author$project$Data$PDF$Annotation$updateTextFieldPositionStyle, position, nameField));
			case 'IsEmailField':
				var email = annotation.a;
				return $author$project$Data$PDF$CreateTemplate$IsEmailField(
					A2($author$project$Data$PDF$Annotation$updateTextFieldPositionStyle, position, email));
			default:
				var checkbox = annotation.a;
				return $author$project$Data$PDF$CreateTemplate$IsCheckBoxField(
					A2($author$project$Data$PDF$Annotation$updateCheckBoxFieldPosiitonStyle, position, checkbox));
		}
	});
var $author$project$Data$PDF$Port$updateTemplate = _Platform_outgoingPort('updateTemplate', $elm$core$Basics$identity);
var $elm$core$Dict$values = function (dict) {
	return A3(
		$elm$core$Dict$foldr,
		F3(
			function (key, value, valueList) {
				return A2($elm$core$List$cons, value, valueList);
			}),
		_List_Nil,
		dict);
};
var $author$project$Data$PDF$CreateTemplate$addAnnotation = F4(
	function (value, annotation, _v0, role) {
		var template = _v0.a;
		var _v1 = $author$project$Data$PDF$Port$decodePosition(value);
		if (_v1.$ === 'Ok') {
			var position = _v1.a;
			var updatedAnnot = A2($author$project$Data$PDF$CreateTemplate$updateAnnotPosition, position, annotation);
			var updatedRoles = A3(
				$elm$core$Dict$update,
				role,
				$elm$core$Maybe$map(
					function (roleData) {
						return _Utils_update(
							roleData,
							{
								annotations: A2($elm$core$List$cons, updatedAnnot, roleData.annotations)
							});
					}),
				template.roles);
			var updatedAnnots = A3(
				$elm$core$List$foldl,
				F2(
					function (currentRole, accumulator) {
						var annotationsList = A2(
							$elm$core$List$map,
							function (annot) {
								return _Utils_Tuple2(annot, currentRole.color);
							},
							currentRole.annotations);
						return _Utils_ap(accumulator, annotationsList);
					}),
				_List_Nil,
				$elm$core$Dict$values(updatedRoles));
			var updatedTemplate = $author$project$Data$PDF$CreateTemplate$Template(
				_Utils_update(
					template,
					{roles: updatedRoles}));
			var owner = $author$project$Data$PDF$CreateTemplate$getOwner(
				$author$project$Data$PDF$CreateTemplate$Template(template));
			return $elm$core$Result$Ok(
				_Utils_Tuple2(
					updatedTemplate,
					$author$project$Data$PDF$Port$updateTemplate(
						A4($author$project$Data$PDF$CreateTemplate$encodeUpdateTemplate, owner, updatedAnnots, template.base64FileData, _List_Nil))));
		} else {
			var err = _v1.a;
			return $elm$core$Result$Err(err);
		}
	});
var $elm$core$Basics$negate = function (n) {
	return -n;
};
var $author$project$Data$PDF$CreateTemplate$addNewSignOrder = function (_v0) {
	var template = _v0.a;
	var rolesList = $elm$core$Dict$toList(template.roles);
	var updatedRoles = $elm$core$Dict$fromList(
		A2(
			$elm$core$List$map,
			function (_v1) {
				var role = _v1.a;
				var roleData = _v1.b;
				return _Utils_eq(roleData.signOrder, -1) ? _Utils_Tuple2(
					role,
					_Utils_update(
						roleData,
						{signOrder: -1})) : _Utils_Tuple2(
					role,
					_Utils_update(
						roleData,
						{signOrder: 1}));
			},
			rolesList));
	return $author$project$Data$PDF$CreateTemplate$Template(
		_Utils_update(
			template,
			{roles: updatedRoles}));
};
var $author$project$Data$PDF$CreateTemplate$addRecipientTemplate = F2(
	function (role, _v0) {
		var template = _v0.a;
		return $author$project$Data$PDF$CreateTemplate$Template(
			_Utils_update(
				template,
				{
					roles: A3($elm$core$Dict$insert, role.role, role, template.roles)
				}));
	});
var $author$project$Data$PDF$User$Blue = {$: 'Blue'};
var $author$project$Data$PDF$User$Brown = {$: 'Brown'};
var $author$project$Data$PDF$User$Cyan = {$: 'Cyan'};
var $author$project$Data$PDF$User$Indigo = {$: 'Indigo'};
var $author$project$Data$PDF$User$Orange = {$: 'Orange'};
var $author$project$Data$PDF$User$Purple = {$: 'Purple'};
var $author$project$Data$PDF$User$Teal = {$: 'Teal'};
var $elm$core$Array$fromListHelp = F3(
	function (list, nodeList, nodeListSize) {
		fromListHelp:
		while (true) {
			var _v0 = A2($elm$core$Elm$JsArray$initializeFromList, $elm$core$Array$branchFactor, list);
			var jsArray = _v0.a;
			var remainingItems = _v0.b;
			if (_Utils_cmp(
				$elm$core$Elm$JsArray$length(jsArray),
				$elm$core$Array$branchFactor) < 0) {
				return A2(
					$elm$core$Array$builderToArray,
					true,
					{nodeList: nodeList, nodeListSize: nodeListSize, tail: jsArray});
			} else {
				var $temp$list = remainingItems,
					$temp$nodeList = A2(
					$elm$core$List$cons,
					$elm$core$Array$Leaf(jsArray),
					nodeList),
					$temp$nodeListSize = nodeListSize + 1;
				list = $temp$list;
				nodeList = $temp$nodeList;
				nodeListSize = $temp$nodeListSize;
				continue fromListHelp;
			}
		}
	});
var $elm$core$Array$fromList = function (list) {
	if (!list.b) {
		return $elm$core$Array$empty;
	} else {
		return A3($elm$core$Array$fromListHelp, list, _List_Nil, 0);
	}
};
var $elm$core$Array$length = function (_v0) {
	var len = _v0.a;
	return len;
};
var $elm$core$Basics$modBy = _Basics_modBy;
var $author$project$Data$PDF$User$nextUserColor = function (size) {
	var colors = $elm$core$Array$fromList(
		_List_fromArray(
			[$author$project$Data$PDF$User$Purple, $author$project$Data$PDF$User$Indigo, $author$project$Data$PDF$User$Cyan, $author$project$Data$PDF$User$Teal, $author$project$Data$PDF$User$Brown, $author$project$Data$PDF$User$Orange, $author$project$Data$PDF$User$Blue]));
	var length = $elm$core$Array$length(colors);
	return A2(
		$elm$core$Maybe$withDefault,
		$author$project$Data$PDF$User$Teal,
		A2(
			$elm$core$Array$get,
			A2($elm$core$Basics$modBy, length, size),
			colors));
};
var $elm$core$Dict$sizeHelp = F2(
	function (n, dict) {
		sizeHelp:
		while (true) {
			if (dict.$ === 'RBEmpty_elm_builtin') {
				return n;
			} else {
				var left = dict.d;
				var right = dict.e;
				var $temp$n = A2($elm$core$Dict$sizeHelp, n + 1, right),
					$temp$dict = left;
				n = $temp$n;
				dict = $temp$dict;
				continue sizeHelp;
			}
		}
	});
var $elm$core$Dict$size = function (dict) {
	return A2($elm$core$Dict$sizeHelp, 0, dict);
};
var $author$project$Data$PDF$CreateTemplate$addRecipient = F6(
	function (email, firstName, lastName, role, _v0, isViewer) {
		var template = _v0.a;
		var size = $elm$core$Dict$size(template.roles);
		var signOrderNumber = isViewer ? (-1) : 0;
		var roleName = isViewer ? $truqu$elm_md5$MD5$hex(
			_Utils_ap(
				A2($elm$core$Maybe$withDefault, '', email),
				_Utils_ap(
					A2($elm$core$Maybe$withDefault, '', firstName),
					A2($elm$core$Maybe$withDefault, '', lastName)))) : role;
		var recipient = {
			annotations: _List_Nil,
			color: $author$project$Data$PDF$User$nextUserColor(size),
			email: email,
			firstName: firstName,
			lastName: lastName,
			role: roleName,
			signOrder: signOrderNumber
		};
		return A2(
			$author$project$Data$PDF$CreateTemplate$addRecipientTemplate,
			recipient,
			$author$project$Data$PDF$CreateTemplate$Template(template));
	});
var $author$project$Data$Api$AddressBookAutocomplete$Payload = function (contacts) {
	return {contacts: contacts};
};
var $author$project$Data$AddressBook$SearchContact = function (alias) {
	return function (firstName) {
		return function (lastName) {
			return function (email) {
				return function (label) {
					return function (id) {
						return function (verifyPassbase) {
							return function (verifyMyInfo) {
								return function (verifyMobilePhone) {
									return function (verifyStripe) {
										return function (verifyWallet) {
											return {alias: alias, email: email, firstName: firstName, id: id, label: label, lastName: lastName, verifyMobilePhone: verifyMobilePhone, verifyMyInfo: verifyMyInfo, verifyPassbase: verifyPassbase, verifyStripe: verifyStripe, verifyWallet: verifyWallet};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Data$Api$AddressBookAutocomplete$decoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'verifyWallet',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'verifyStripe',
		$elm$json$Json$Decode$bool,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'verifyMobilePhone',
			$elm$json$Json$Decode$bool,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'verifyMyInfo',
				$elm$json$Json$Decode$bool,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'verifyPassbase',
					$elm$json$Json$Decode$bool,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'id',
						$elm$json$Json$Decode$string,
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'label',
							$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
							$elm$core$Maybe$Nothing,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'email',
								$elm$json$Json$Decode$string,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'lastName',
									$elm$json$Json$Decode$string,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'firstName',
										$elm$json$Json$Decode$string,
										A4(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
											'alias',
											$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
											$elm$core$Maybe$Nothing,
											$elm$json$Json$Decode$succeed($author$project$Data$AddressBook$SearchContact))))))))))));
var $author$project$Data$Api$AddressBookAutocomplete$dataDecoder = A2(
	$elm$json$Json$Decode$map,
	$author$project$Data$Api$AddressBookAutocomplete$Payload,
	A2(
		$elm$json$Json$Decode$field,
		'contacts',
		$elm$json$Json$Decode$list($author$project$Data$Api$AddressBookAutocomplete$decoder)));
var $author$project$Data$Api$AddressBookAutocomplete$encode = function (searchTerm) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'searchTerms',
				$elm$json$Json$Encode$string(
					$elm$core$String$trim(
						$elm$core$String$toLower(searchTerm))))
			]));
};
var $author$project$Data$Api$AddressBookAutocomplete$INVALID_USER = {$: 'INVALID_USER'};
var $author$project$Data$Api$AddressBookAutocomplete$errorDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (errorCode) {
		if (errorCode === 'INVALID_USER') {
			return $elm$json$Json$Decode$succeed($author$project$Data$Api$AddressBookAutocomplete$INVALID_USER);
		} else {
			return $elm$json$Json$Decode$fail('Invalid error code: ' + errorCode);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Data$Api$AddressBookAutocomplete$authCall = F3(
	function (jwt, endPoint, searchTerm) {
		return A5(
			$author$project$Data$Api$authCall,
			jwt,
			endPoint,
			$author$project$Data$Api$AddressBookAutocomplete$errorDecoder,
			$author$project$Data$Api$AddressBookAutocomplete$dataDecoder,
			$author$project$Data$Api$AddressBookAutocomplete$encode(searchTerm));
	});
var $author$project$Data$PDF$Encryption$IsEncrypted = {$: 'IsEncrypted'};
var $author$project$Data$PDF$Encryption$PasswordFail = {$: 'PasswordFail'};
var $author$project$Data$PDF$Encryption$decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (value) {
		switch (value) {
			case 'PasswordFail':
				return $elm$json$Json$Decode$succeed($author$project$Data$PDF$Encryption$PasswordFail);
			case 'IsEncrypted':
				return $elm$json$Json$Decode$succeed($author$project$Data$PDF$Encryption$IsEncrypted);
			default:
				return $elm$json$Json$Decode$fail('Unknown encryption error: ' + value);
		}
	},
	A2($elm$json$Json$Decode$field, 'error', $elm$json$Json$Decode$string));
var $author$project$Data$PDF$Encryption$decode = function (value) {
	return A2(
		$elm$core$Result$mapError,
		$elm$json$Json$Decode$errorToString,
		A2($elm$json$Json$Decode$decodeValue, $author$project$Data$PDF$Encryption$decoder, value));
};
var $author$project$Data$PDF$CreateTemplate$AnnotData = F5(
	function (id, kind, content, status, style) {
		return {content: content, id: id, kind: kind, status: status, style: style};
	});
var $author$project$Data$PDF$CreateTemplate$DecodedAnnot = function (a) {
	return {$: 'DecodedAnnot', a: a};
};
var $author$project$Data$PDF$CreateTemplate$CheckBoxFieldKind = {$: 'CheckBoxFieldKind'};
var $author$project$Data$PDF$CreateTemplate$DateFieldKind = {$: 'DateFieldKind'};
var $author$project$Data$PDF$CreateTemplate$DateKind = {$: 'DateKind'};
var $author$project$Data$PDF$CreateTemplate$EmailFieldKind = {$: 'EmailFieldKind'};
var $author$project$Data$PDF$CreateTemplate$NameFieldKind = {$: 'NameFieldKind'};
var $author$project$Data$PDF$CreateTemplate$NameKind = {$: 'NameKind'};
var $author$project$Data$PDF$CreateTemplate$NumberFieldKind = {$: 'NumberFieldKind'};
var $author$project$Data$PDF$CreateTemplate$SignatureFieldKind = {$: 'SignatureFieldKind'};
var $author$project$Data$PDF$CreateTemplate$SignatureKind = {$: 'SignatureKind'};
var $author$project$Data$PDF$CreateTemplate$StampFieldKind = {$: 'StampFieldKind'};
var $author$project$Data$PDF$CreateTemplate$TextFieldKind = {$: 'TextFieldKind'};
var $author$project$Data$PDF$CreateTemplate$TextKind = {$: 'TextKind'};
var $author$project$Data$PDF$CreateTemplate$annotationKindDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (value) {
		switch (value) {
			case 'Name':
				return $elm$json$Json$Decode$succeed($author$project$Data$PDF$CreateTemplate$NameKind);
			case 'Date':
				return $elm$json$Json$Decode$succeed($author$project$Data$PDF$CreateTemplate$DateKind);
			case 'FreeText':
				return $elm$json$Json$Decode$succeed($author$project$Data$PDF$CreateTemplate$TextKind);
			case 'Signature':
				return $elm$json$Json$Decode$succeed($author$project$Data$PDF$CreateTemplate$SignatureKind);
			case 'TextField':
				return $elm$json$Json$Decode$succeed($author$project$Data$PDF$CreateTemplate$TextFieldKind);
			case 'DateField':
				return $elm$json$Json$Decode$succeed($author$project$Data$PDF$CreateTemplate$DateFieldKind);
			case 'SignatureField':
				return $elm$json$Json$Decode$succeed($author$project$Data$PDF$CreateTemplate$SignatureFieldKind);
			case 'NumberField':
				return $elm$json$Json$Decode$succeed($author$project$Data$PDF$CreateTemplate$NumberFieldKind);
			case 'StampField':
				return $elm$json$Json$Decode$succeed($author$project$Data$PDF$CreateTemplate$StampFieldKind);
			case 'EmailField':
				return $elm$json$Json$Decode$succeed($author$project$Data$PDF$CreateTemplate$EmailFieldKind);
			case 'NameField':
				return $elm$json$Json$Decode$succeed($author$project$Data$PDF$CreateTemplate$NameFieldKind);
			case 'CheckboxField':
				return $elm$json$Json$Decode$succeed($author$project$Data$PDF$CreateTemplate$CheckBoxFieldKind);
			default:
				return $elm$json$Json$Decode$fail('Unknown Annotation Kind: ' + value);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Data$PDF$Annotation$Verified = {$: 'Verified'};
var $author$project$Data$PDF$Port$decodeStatus = A2(
	$elm$json$Json$Decode$andThen,
	function (txtStatus) {
		switch (txtStatus) {
			case 'Verified':
				return $elm$json$Json$Decode$succeed($author$project$Data$PDF$Annotation$Verified);
			case 'Unverified':
				return $elm$json$Json$Decode$succeed($author$project$Data$PDF$Annotation$Unverified);
			default:
				return $elm$json$Json$Decode$fail('Invalid annotation\'s status');
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Data$PDF$Annotation$Style = F6(
	function (width, height, fontSize, x, y, page) {
		return {fontSize: fontSize, height: height, page: page, width: width, x: x, y: y};
	});
var $elm$json$Json$Decode$map6 = _Json_map6;
var $author$project$Data$PDF$Port$decodeStyle = A7(
	$elm$json$Json$Decode$map6,
	$author$project$Data$PDF$Annotation$Style,
	A2($elm$json$Json$Decode$field, 'width', $elm$json$Json$Decode$float),
	A2($elm$json$Json$Decode$field, 'height', $elm$json$Json$Decode$float),
	A2($elm$json$Json$Decode$field, 'fontSize', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'x', $elm$json$Json$Decode$float),
	A2($elm$json$Json$Decode$field, 'y', $elm$json$Json$Decode$float),
	A2($elm$json$Json$Decode$field, 'page', $elm$json$Json$Decode$int));
var $elm$json$Json$Decode$map5 = _Json_map5;
var $author$project$Data$PDF$CreateTemplate$decodeOneAnnotData = A2(
	$elm$json$Json$Decode$map,
	$author$project$Data$PDF$CreateTemplate$DecodedAnnot,
	A6(
		$elm$json$Json$Decode$map5,
		$author$project$Data$PDF$CreateTemplate$AnnotData,
		A2($elm$json$Json$Decode$field, 'id', $elm$json$Json$Decode$string),
		A2($elm$json$Json$Decode$field, 'kind', $author$project$Data$PDF$CreateTemplate$annotationKindDecoder),
		A2($elm$json$Json$Decode$field, 'content', $elm$json$Json$Decode$string),
		A2($elm$json$Json$Decode$field, 'status', $author$project$Data$PDF$Port$decodeStatus),
		A2($elm$json$Json$Decode$field, 'style', $author$project$Data$PDF$Port$decodeStyle)));
var $author$project$Data$PDF$CreateTemplate$decodeAnnotData = $elm$json$Json$Decode$list($author$project$Data$PDF$CreateTemplate$decodeOneAnnotData);
var $author$project$Data$PDF$CreateTemplate$decodeAnnotDataResult = function (value) {
	var _v0 = A2($elm$json$Json$Decode$decodeValue, $author$project$Data$PDF$CreateTemplate$decodeAnnotData, value);
	if (_v0.$ === 'Ok') {
		var results = _v0.a;
		return $elm$core$Result$Ok(results);
	} else {
		return $elm$core$Result$Err('Unable to update selected annotations.');
	}
};
var $author$project$Data$PDF$Port$ClickedAnnotation = F2(
	function (id, page) {
		return {id: id, page: page};
	});
var $author$project$Data$PDF$Port$selectedAnnotClickDataDecoder = A3(
	$elm$json$Json$Decode$map2,
	$author$project$Data$PDF$Port$ClickedAnnotation,
	A2($elm$json$Json$Decode$field, 'id', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'page', $elm$json$Json$Decode$int));
var $author$project$Data$PDF$Port$decodeClickedAnnotData = function (value) {
	var _v0 = A2($elm$json$Json$Decode$decodeValue, $author$project$Data$PDF$Port$selectedAnnotClickDataDecoder, value);
	if (_v0.$ === 'Ok') {
		var result = _v0.a;
		return $elm$core$Result$Ok(result);
	} else {
		return $elm$core$Result$Err('Unable to capture annotation data.');
	}
};
var $author$project$Data$PDF$ConvertedOfficePDF = F2(
	function (base64data, file) {
		return {base64data: base64data, file: file};
	});
var $author$project$Data$PDF$dataDecoder = A3(
	$elm$json$Json$Decode$map2,
	$author$project$Data$PDF$ConvertedOfficePDF,
	A2($elm$json$Json$Decode$field, 'base64data', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'file', $elm$file$File$decoder));
var $author$project$Data$PDF$decodeConvertedPDF = function (base64Data) {
	var _v0 = A2($elm$json$Json$Decode$decodeValue, $author$project$Data$PDF$dataDecoder, base64Data);
	if (_v0.$ === 'Ok') {
		var results = _v0.a;
		return $elm$core$Result$Ok(results);
	} else {
		return $elm$core$Result$Err('Error Converting File.');
	}
};
var $author$project$Data$PDF$Annotation$signedSignatureId = function (_v0) {
	var signedSig = _v0.a;
	return signedSig.id;
};
var $author$project$Data$PDF$Annotation$stampId = function (_v0) {
	var stamp = _v0.a;
	return stamp.id;
};
var $author$project$Data$PDF$Annotation$unsignedSignatureId = function (_v0) {
	var unsignedSig = _v0.a;
	return unsignedSig.id;
};
var $author$project$Data$PDF$CreateTemplate$isSameAnnotWithID = F2(
	function (id, annot) {
		switch (annot.$) {
			case 'IsName':
				var txt = annot.a;
				return _Utils_eq(
					$author$project$Data$PDF$Annotation$txtId(txt),
					id);
			case 'IsDate':
				var dateTxt = annot.a;
				return _Utils_eq(
					$author$project$Data$PDF$Annotation$dateTxtId(dateTxt),
					id);
			case 'IsFreeText':
				var txt = annot.a;
				return _Utils_eq(
					$author$project$Data$PDF$Annotation$txtId(txt),
					id);
			case 'IsSignature':
				var signedSig = annot.a;
				return _Utils_eq(
					$author$project$Data$PDF$Annotation$signedSignatureId(signedSig),
					id);
			case 'IsTextField':
				var txtField = annot.a;
				var _v1 = $author$project$Data$PDF$Annotation$textField(txtField);
				var txt = _v1.b;
				return _Utils_eq(
					$author$project$Data$PDF$Annotation$txtId(txt),
					id);
			case 'IsDateField':
				var dateField_ = annot.a;
				var _v2 = $author$project$Data$PDF$Annotation$dateField(dateField_);
				var dateTxt = _v2.b;
				return _Utils_eq(
					$author$project$Data$PDF$Annotation$dateTxtId(dateTxt),
					id);
			case 'IsSignatureField':
				var unsignedSigField = annot.a;
				var _v3 = $author$project$Data$PDF$Annotation$signatureField(unsignedSigField);
				var unsignedSig = _v3.b;
				return _Utils_eq(
					$author$project$Data$PDF$Annotation$unsignedSignatureId(unsignedSig),
					id);
			case 'IsNumberField':
				var numField = annot.a;
				var _v4 = $author$project$Data$PDF$Annotation$numberField(numField);
				var numberTxt = _v4.b;
				return _Utils_eq(
					$author$project$Data$PDF$Annotation$numberTxtId(numberTxt),
					id);
			case 'IsStampField':
				var stampFieldData = annot.a;
				var _v5 = $author$project$Data$PDF$Annotation$stampField(stampFieldData);
				var stamp = _v5.b;
				return _Utils_eq(
					$author$project$Data$PDF$Annotation$stampId(stamp),
					id);
			case 'IsNameField':
				var nameField = annot.a;
				var _v6 = $author$project$Data$PDF$Annotation$textField(nameField);
				var txt = _v6.b;
				return _Utils_eq(
					$author$project$Data$PDF$Annotation$txtId(txt),
					id);
			case 'IsEmailField':
				var emailField = annot.a;
				var _v7 = $author$project$Data$PDF$Annotation$textField(emailField);
				var txt = _v7.b;
				return _Utils_eq(
					$author$project$Data$PDF$Annotation$txtId(txt),
					id);
			default:
				var checkboxData = annot.a;
				var _v8 = $author$project$Data$PDF$Annotation$checkBoxField(checkboxData);
				var checkbox = _v8.b;
				return _Utils_eq(
					$author$project$Data$PDF$Annotation$checkboxId(checkbox),
					id);
		}
	});
var $elm$core$List$partition = F2(
	function (pred, list) {
		var step = F2(
			function (x, _v0) {
				var trues = _v0.a;
				var falses = _v0.b;
				return pred(x) ? _Utils_Tuple2(
					A2($elm$core$List$cons, x, trues),
					falses) : _Utils_Tuple2(
					trues,
					A2($elm$core$List$cons, x, falses));
			});
		return A3(
			$elm$core$List$foldr,
			step,
			_Utils_Tuple2(_List_Nil, _List_Nil),
			list);
	});
var $author$project$Data$PDF$CreateTemplate$deleteAnnotsWithDecodedAnnots = F2(
	function (annotID, annotList) {
		return A2(
			$elm$core$List$partition,
			function (annot) {
				return !A2($author$project$Data$PDF$CreateTemplate$isSameAnnotWithID, annotID, annot);
			},
			annotList);
	});
var $author$project$Data$PDF$CreateTemplate$getId = function (annot) {
	switch (annot.$) {
		case 'IsName':
			var txt = annot.a;
			return $author$project$Data$PDF$Annotation$txtId(txt);
		case 'IsDate':
			var dateTxt = annot.a;
			return $author$project$Data$PDF$Annotation$dateTxtId(dateTxt);
		case 'IsFreeText':
			var txt = annot.a;
			return $author$project$Data$PDF$Annotation$txtId(txt);
		case 'IsSignature':
			var sig = annot.a;
			return $author$project$Data$PDF$Annotation$signedSignatureId(sig);
		case 'IsTextField':
			var txt = annot.a;
			var _v1 = $author$project$Data$PDF$Annotation$textField(txt);
			var txtField = _v1.b;
			return $author$project$Data$PDF$Annotation$txtId(txtField);
		case 'IsDateField':
			var date = annot.a;
			var _v2 = $author$project$Data$PDF$Annotation$dateField(date);
			var dateAnnot = _v2.b;
			return $author$project$Data$PDF$Annotation$dateTxtId(dateAnnot);
		case 'IsSignatureField':
			var sig = annot.a;
			var _v3 = $author$project$Data$PDF$Annotation$signatureField(sig);
			var sigAnnot = _v3.b;
			return $author$project$Data$PDF$Annotation$unsignedSignatureId(sigAnnot);
		case 'IsNumberField':
			var numTxt = annot.a;
			var _v4 = $author$project$Data$PDF$Annotation$numberField(numTxt);
			var numAnnot = _v4.b;
			return $author$project$Data$PDF$Annotation$numberTxtId(numAnnot);
		case 'IsStampField':
			var stamp = annot.a;
			var _v5 = $author$project$Data$PDF$Annotation$stampField(stamp);
			var stampAnnot = _v5.b;
			return $author$project$Data$PDF$Annotation$stampId(stampAnnot);
		case 'IsNameField':
			var nameField = annot.a;
			var _v6 = $author$project$Data$PDF$Annotation$textField(nameField);
			var txtField = _v6.b;
			return $author$project$Data$PDF$Annotation$txtId(txtField);
		case 'IsEmailField':
			var emailField = annot.a;
			var _v7 = $author$project$Data$PDF$Annotation$textField(emailField);
			var txtField = _v7.b;
			return $author$project$Data$PDF$Annotation$txtId(txtField);
		default:
			var checkbox = annot.a;
			var _v8 = $author$project$Data$PDF$Annotation$checkBoxField(checkbox);
			var checkboxAnnot = _v8.b;
			return $author$project$Data$PDF$Annotation$checkboxId(checkboxAnnot);
	}
};
var $author$project$Data$PDF$Annotation$signedSignatureStyle = function (_v0) {
	var signature = _v0.a;
	return signature.style;
};
var $author$project$Data$PDF$Annotation$unsignedSignatureStyle = function (_v0) {
	var signature = _v0.a;
	return signature.style;
};
var $author$project$Data$PDF$CreateTemplate$getStyle = function (annot) {
	switch (annot.$) {
		case 'IsName':
			var txt = annot.a;
			return $author$project$Data$PDF$Annotation$txtStyle(txt);
		case 'IsDate':
			var dateTxt = annot.a;
			return $author$project$Data$PDF$Annotation$dateTxtStyle(dateTxt);
		case 'IsFreeText':
			var txt = annot.a;
			return $author$project$Data$PDF$Annotation$txtStyle(txt);
		case 'IsSignature':
			var sig = annot.a;
			return $author$project$Data$PDF$Annotation$signedSignatureStyle(sig);
		case 'IsTextField':
			var txt = annot.a;
			var _v1 = $author$project$Data$PDF$Annotation$textField(txt);
			var txtField = _v1.b;
			return $author$project$Data$PDF$Annotation$txtStyle(txtField);
		case 'IsDateField':
			var date = annot.a;
			var _v2 = $author$project$Data$PDF$Annotation$dateField(date);
			var dateAnnot = _v2.b;
			return $author$project$Data$PDF$Annotation$dateTxtStyle(dateAnnot);
		case 'IsSignatureField':
			var sig = annot.a;
			var _v3 = $author$project$Data$PDF$Annotation$signatureField(sig);
			var sigAnnot = _v3.b;
			return $author$project$Data$PDF$Annotation$unsignedSignatureStyle(sigAnnot);
		case 'IsNumberField':
			var numTxt = annot.a;
			var _v4 = $author$project$Data$PDF$Annotation$numberField(numTxt);
			var numAnnot = _v4.b;
			return $author$project$Data$PDF$Annotation$numberTxtStyle(numAnnot);
		case 'IsStampField':
			var stamp = annot.a;
			var _v5 = $author$project$Data$PDF$Annotation$stampField(stamp);
			var stampAnnot = _v5.b;
			var _v6 = $author$project$Data$PDF$Annotation$stampFieldsStyle(stampAnnot);
			var stampStyle = _v6.b;
			return stampStyle;
		case 'IsNameField':
			var nameField = annot.a;
			var _v7 = $author$project$Data$PDF$Annotation$textField(nameField);
			var txtField = _v7.b;
			return $author$project$Data$PDF$Annotation$txtStyle(txtField);
		case 'IsEmailField':
			var emailField = annot.a;
			var _v8 = $author$project$Data$PDF$Annotation$textField(emailField);
			var txtField = _v8.b;
			return $author$project$Data$PDF$Annotation$txtStyle(txtField);
		default:
			var checkbox = annot.a;
			var _v9 = $author$project$Data$PDF$Annotation$checkBoxField(checkbox);
			var checkboxAnnot = _v9.b;
			return $author$project$Data$PDF$Annotation$checkboxStyle(checkboxAnnot);
	}
};
var $author$project$Data$PDF$CreateTemplate$getAnnotationPageFromList = F2(
	function (annotList, annotID) {
		return A3(
			$elm$core$List$foldl,
			F2(
				function (annot, _v0) {
					if (_Utils_eq(
						$author$project$Data$PDF$CreateTemplate$getId(annot),
						annotID)) {
						var style = $author$project$Data$PDF$CreateTemplate$getStyle(annot);
						return _List_fromArray(
							[style.page]);
					} else {
						return _List_Nil;
					}
				}),
			_List_Nil,
			annotList);
	});
var $author$project$Data$PDF$CreateTemplate$deleteAnnotation = F2(
	function (annotID, _v0) {
		var template = _v0.a;
		var rolesList = $elm$core$Dict$values(template.roles);
		var updatedRole = $elm$core$List$head(
			A2(
				$elm$core$List$filterMap,
				function (roleData) {
					var _v3 = A2($author$project$Data$PDF$CreateTemplate$deleteAnnotsWithDecodedAnnots, annotID, roleData.annotations);
					var updatedRoleAnnot = _v3.a;
					var deletedAnnots = _v3.b;
					return (!$elm$core$List$isEmpty(deletedAnnots)) ? $elm$core$Maybe$Just(
						_Utils_Tuple2(updatedRoleAnnot, roleData)) : $elm$core$Maybe$Nothing;
				},
				rolesList));
		var updatedRoles = function () {
			if (updatedRole.$ === 'Just') {
				var _v2 = updatedRole.a;
				var updatedRoleAnnots = _v2.a;
				var role = _v2.b.role;
				return A3(
					$elm$core$Dict$update,
					role,
					$elm$core$Maybe$map(
						function (roleData) {
							return _Utils_update(
								roleData,
								{annotations: updatedRoleAnnots});
						}),
					template.roles);
			} else {
				return template.roles;
			}
		}();
		var updatedAnnots = A3(
			$elm$core$List$foldl,
			F2(
				function (currentRole, accumulator) {
					var annotationsList = A2(
						$elm$core$List$map,
						function (annot) {
							return _Utils_Tuple2(annot, currentRole.color);
						},
						currentRole.annotations);
					return _Utils_ap(accumulator, annotationsList);
				}),
			_List_Nil,
			$elm$core$Dict$values(updatedRoles));
		var updatedTemplate = $author$project$Data$PDF$CreateTemplate$Template(
			_Utils_update(
				template,
				{roles: updatedRoles}));
		var pageOfDeletedRecipientAnnot = A3(
			$elm$core$List$foldl,
			F2(
				function (userData, accumulator) {
					var annotPageList = A2($author$project$Data$PDF$CreateTemplate$getAnnotationPageFromList, userData.annotations, annotID);
					return $elm$core$List$isEmpty(annotPageList) ? accumulator : annotPageList;
				}),
			_List_Nil,
			rolesList);
		var owner = $author$project$Data$PDF$CreateTemplate$getOwner(
			$author$project$Data$PDF$CreateTemplate$Template(template));
		return _Utils_Tuple2(
			updatedTemplate,
			$author$project$Data$PDF$Port$updateTemplate(
				A4($author$project$Data$PDF$CreateTemplate$encodeUpdateTemplate, owner, updatedAnnots, template.base64FileData, pageOfDeletedRecipientAnnot)));
	});
var $author$project$Data$Api$PDF$UploadTemplate$errorToString = function (error) {
	switch (error.$) {
		case 'FILE_TOO_BIG':
			return 'Size of file cannot exceed 25MB.';
		case 'SLUG_ALREADY_EXIST':
			return 'Document URL has been taken.';
		case 'WRONG_FILE_FORMAT':
			return 'PDF document only (for sending).';
		case 'INVALID_SLUG':
			return 'Slug contain disallowed characters.';
		case 'INVALID_DOMAIN':
			return '\'Invalid data provided. Please refresh and try again.';
		case 'INVALID_DATA':
			return 'Invalid data provided. Please refresh and try again.';
		case 'INVALID_PDF':
			return 'PDF is not a valid pdf. Please try another file.';
		case 'INCORRECT_PASSWORD':
			return 'Password provided is incorrect.';
		case 'APPEND_ERROR':
			return 'Unable to append annotation(s) to the file.';
		case 'ENCRYPTION_ERROR':
			return 'Unable to encrypt and store uploaded file.';
		case 'INVALID_CERTIFICATE':
			return 'Invalid digital certificate.';
		case 'UNEDITABLE_PDF':
			return 'PDF is not editable.';
		case 'LOADING_ERROR':
			return 'Invalid PDF. Please upload a valid PDF file instead.';
		case 'SIGNATURE_HASH_ERROR':
			return 'Invalid digital signature hash received.';
		case 'FILE_NOT_FOUND':
			return 'An error has occur. Please try again later.';
		case 'TEMP_FILE_NOT_FOUND':
			return 'An error has occur. Please try again later.';
		case 'UNKNOWN':
			return 'An error has occur. Please try again later.';
		default:
			return 'You have reached your template quota.';
	}
};
var $author$project$Data$PDF$CreateTemplate$file = function (_v0) {
	var template = _v0.a;
	return template.file;
};
var $elm$browser$Browser$Dom$focus = _Browser_call('focus');
var $author$project$Model$CreateTemplate$formFieldError = 'Please fill and submit the field form first.';
var $author$project$Data$PDF$CreateTemplate$getRoles = function (_v0) {
	var roles = _v0.a.roles;
	return $elm$core$Dict$values(roles);
};
var $author$project$Data$PDF$CreateTemplate$getRolesWithoutSignatureField = function (_v0) {
	var template = _v0.a;
	return A2(
		$elm$core$List$filterMap,
		function (roleData) {
			var hasSignatureField = A2(
				$elm$core$List$any,
				function (annot) {
					if (annot.$ === 'IsSignatureField') {
						return true;
					} else {
						return false;
					}
				},
				roleData.annotations);
			return (hasSignatureField || _Utils_eq(roleData.signOrder, -1)) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(roleData.role);
		},
		$elm$core$Dict$values(template.roles));
};
var $author$project$Data$PDF$CreateTemplate$isACheckboxField = function (annot) {
	if (annot.$ === 'IsCheckBoxField') {
		return true;
	} else {
		return false;
	}
};
var $author$project$Data$PDF$CreateTemplate$isATextField = function (annot) {
	if (annot.$ === 'IsTextField') {
		return true;
	} else {
		return false;
	}
};
var $author$project$Type$File$PDF = {$: 'PDF'};
var $author$project$Type$File$fileTypeToString = function (fileType) {
	switch (fileType.$) {
		case 'PDF':
			return 'pdf';
		case 'Docx':
			return 'docx';
		case 'Pptx':
			return 'pptx';
		case 'Xlsx':
			return 'xlsx';
		default:
			return '';
	}
};
var $author$project$Data$PDF$Port$encodeFile = F5(
	function (password, data, fileType, fileName, location) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'data',
					$elm$json$Json$Encode$string(data)),
					_Utils_Tuple2(
					'ext',
					$elm$json$Json$Encode$string(
						$author$project$Type$File$fileTypeToString(fileType))),
					_Utils_Tuple2(
					'password',
					A2(
						$elm$core$Maybe$withDefault,
						$elm$json$Json$Encode$null,
						A2($elm$core$Maybe$map, $elm$json$Json$Encode$string, password))),
					_Utils_Tuple2(
					'fileName',
					$elm$json$Json$Encode$string(fileName)),
					_Utils_Tuple2(
					'location',
					$elm$json$Json$Encode$string(location))
				]));
	});
var $author$project$Data$PDF$Port$loadNewTemplate = _Platform_outgoingPort('loadNewTemplate', $elm$core$Basics$identity);
var $author$project$Data$PDF$Port$newTemplate = F4(
	function (password, base64Pdf, fileType, fileName) {
		return $author$project$Data$PDF$Port$loadNewTemplate(
			A5($author$project$Data$PDF$Port$encodeFile, password, base64Pdf, fileType, fileName, 'Document'));
	});
var $author$project$Data$PDF$CreateTemplate$loadWithPassword = F2(
	function (password_, _v0) {
		var template = _v0.a;
		return _Utils_Tuple2(
			$author$project$Data$PDF$CreateTemplate$Template(
				_Utils_update(
					template,
					{
						password: $elm$core$Maybe$Just(password_)
					})),
			A4(
				$author$project$Data$PDF$Port$newTemplate,
				$elm$core$Maybe$Just(password_),
				template.base64FileData,
				$author$project$Type$File$PDF,
				template.title));
	});
var $elm$time$Time$now = _Time_now($elm$time$Time$millisToPosix);
var $author$project$Data$PDF$CreateTemplate$removeRecipient = F2(
	function (role, _v0) {
		var template = _v0.a;
		var updatedRoles = A2($elm$core$Dict$remove, role, template.roles);
		var updatedTemplate = $author$project$Data$PDF$CreateTemplate$Template(
			_Utils_update(
				template,
				{roles: updatedRoles}));
		var updatedAnnots = A3(
			$elm$core$List$foldl,
			F2(
				function (currentRole, accumulator) {
					var annotationsList = A2(
						$elm$core$List$map,
						function (annot) {
							return _Utils_Tuple2(annot, currentRole.color);
						},
						currentRole.annotations);
					return _Utils_ap(accumulator, annotationsList);
				}),
			_List_Nil,
			$elm$core$Dict$values(updatedRoles));
		var removedRole = A2($elm$core$Dict$get, role, template.roles);
		var removedAnnotationsPages = function () {
			if (removedRole.$ === 'Just') {
				var recipient = removedRole.a;
				var annotations = A2(
					$elm$core$List$map,
					function (annot) {
						var style = $author$project$Data$PDF$CreateTemplate$getStyle(annot);
						return style.page;
					},
					recipient.annotations);
				var uniqueAnnots = A3(
					$elm$core$List$foldl,
					F2(
						function (annot, accumlator) {
							return A2($elm$core$List$member, annot, accumlator) ? accumlator : A2($elm$core$List$cons, annot, accumlator);
						}),
					_List_Nil,
					annotations);
				return uniqueAnnots;
			} else {
				return _List_Nil;
			}
		}();
		var owner = $author$project$Data$PDF$CreateTemplate$getOwner(
			$author$project$Data$PDF$CreateTemplate$Template(template));
		return _Utils_Tuple2(
			updatedTemplate,
			$author$project$Data$PDF$Port$updateTemplate(
				A4($author$project$Data$PDF$CreateTemplate$encodeUpdateTemplate, owner, updatedAnnots, template.base64FileData, removedAnnotationsPages)));
	});
var $author$project$Data$PDF$CreateTemplate$removeSignOrder = function (_v0) {
	var template = _v0.a;
	var rolesList = $elm$core$Dict$toList(template.roles);
	var updatedRoles = $elm$core$Dict$fromList(
		A2(
			$elm$core$List$map,
			function (_v1) {
				var role = _v1.a;
				var roleData = _v1.b;
				return _Utils_eq(roleData.signOrder, -1) ? _Utils_Tuple2(
					role,
					_Utils_update(
						roleData,
						{signOrder: -1})) : _Utils_Tuple2(
					role,
					_Utils_update(
						roleData,
						{signOrder: 0}));
			},
			rolesList));
	return $author$project$Data$PDF$CreateTemplate$Template(
		_Utils_update(
			template,
			{roles: updatedRoles}));
};
var $author$project$Data$PDF$CreateTemplate$setBase64FileData = F3(
	function (base64Data, fileData, _v0) {
		var template = _v0.a;
		return $author$project$Data$PDF$CreateTemplate$Template(
			_Utils_update(
				template,
				{base64FileData: base64Data, file: fileData}));
	});
var $author$project$Data$PDF$CreateTemplate$setIsPrivate = F2(
	function (isPrivateValue, _v0) {
		var template = _v0.a;
		return $author$project$Data$PDF$CreateTemplate$Template(
			_Utils_update(
				template,
				{isPrivate: isPrivateValue}));
	});
var $author$project$Data$PDF$CreateTemplate$setSlug = F2(
	function (newSLug, _v0) {
		var template = _v0.a;
		return $author$project$Data$PDF$CreateTemplate$Template(
			_Utils_update(
				template,
				{slug: newSLug}));
	});
var $author$project$Data$PDF$CreateTemplate$setTitle = F2(
	function (newTitle, _v0) {
		var template = _v0.a;
		return $author$project$Data$PDF$CreateTemplate$Template(
			_Utils_update(
				template,
				{title: newTitle}));
	});
var $author$project$Model$UploadMultipleDocument$startBlurTime = _Platform_outgoingPort('startBlurTime', $elm$core$Basics$identity);
var $author$project$Model$UploadMultipleDocument$startDebounceTime = _Platform_outgoingPort('startDebounceTime', $elm$core$Basics$identity);
var $author$project$Data$PDF$Port$closeDocument2 = _Platform_outgoingPort(
	'closeDocument2',
	function ($) {
		return $elm$json$Json$Encode$null;
	});
var $author$project$Data$PDF$CreateTemplate$unload = $author$project$Data$PDF$Port$closeDocument2;
var $author$project$Data$PDF$Annotation$toCheckboxField = F2(
	function (annotField, checkbox) {
		return A2($author$project$Data$PDF$Annotation$CheckBoxField, annotField, checkbox);
	});
var $author$project$Data$PDF$Annotation$toDateField = F2(
	function (annotField, dateTxt_) {
		return A2($author$project$Data$PDF$Annotation$DateField, annotField, dateTxt_);
	});
var $author$project$Data$PDF$Annotation$toNumberField = F2(
	function (annotField, numberTxt) {
		return A2($author$project$Data$PDF$Annotation$NumberField, annotField, numberTxt);
	});
var $author$project$Data$PDF$Annotation$toSignatureField = F2(
	function (annotField, unsignedSig) {
		return A2($author$project$Data$PDF$Annotation$SignatureField, annotField, unsignedSig);
	});
var $author$project$Data$PDF$Annotation$toStampField = F2(
	function (annotField, stamp) {
		return A2($author$project$Data$PDF$Annotation$StampField, annotField, stamp);
	});
var $author$project$Data$PDF$Annotation$toTextField = F2(
	function (annotField, txt) {
		return A2($author$project$Data$PDF$Annotation$TextField, annotField, txt);
	});
var $author$project$Data$PDF$Annotation$updateTxt = F4(
	function (text, status, style, _v0) {
		var txt = _v0.a;
		return $author$project$Data$PDF$Annotation$Txt(
			_Utils_update(
				txt,
				{
					id: A3(
						$author$project$Data$PDF$Annotation$generateId,
						text,
						$author$project$Data$PDF$Annotation$toStatusString(status),
						style),
					status: status,
					style: style,
					text: text
				}));
	});
var $author$project$Data$PDF$Annotation$toUpdatedUnverifiedTxt = F2(
	function (_v0, newText) {
		var txt = _v0.a;
		var _v1 = txt;
		var style = _v1.style;
		return A4(
			$author$project$Data$PDF$Annotation$updateTxt,
			newText,
			$author$project$Data$PDF$Annotation$Unverified,
			style,
			$author$project$Data$PDF$Annotation$Txt(txt));
	});
var $author$project$Data$PDF$Annotation$updateAnnotationField = F3(
	function (name, required, annotField) {
		return _Utils_update(
			annotField,
			{name: name, required: required});
	});
var $author$project$Data$PDF$CreateTemplate$updateAnnotField = F3(
	function (name, required, annot) {
		switch (annot.$) {
			case 'IsName':
				return annot;
			case 'IsDate':
				return annot;
			case 'IsFreeText':
				return annot;
			case 'IsSignature':
				return annot;
			case 'IsTextField':
				var txtField = annot.a;
				var _v1 = $author$project$Data$PDF$Annotation$textField(txtField);
				var annotField = _v1.a;
				var txt = _v1.b;
				var newTxt = A2($author$project$Data$PDF$Annotation$toUpdatedUnverifiedTxt, txt, name);
				return $author$project$Data$PDF$CreateTemplate$IsTextField(
					A2(
						$author$project$Data$PDF$Annotation$toTextField,
						A3($author$project$Data$PDF$Annotation$updateAnnotationField, name, required, annotField),
						newTxt));
			case 'IsDateField':
				var dateField_ = annot.a;
				var _v2 = $author$project$Data$PDF$Annotation$dateField(dateField_);
				var annotField = _v2.a;
				var dateTxt = _v2.b;
				return $author$project$Data$PDF$CreateTemplate$IsDateField(
					A2(
						$author$project$Data$PDF$Annotation$toDateField,
						A3($author$project$Data$PDF$Annotation$updateAnnotationField, name, true, annotField),
						dateTxt));
			case 'IsSignatureField':
				var unsigedSigField = annot.a;
				var _v3 = $author$project$Data$PDF$Annotation$signatureField(unsigedSigField);
				var annotField = _v3.a;
				var unsigedSig = _v3.b;
				return $author$project$Data$PDF$CreateTemplate$IsSignatureField(
					A2(
						$author$project$Data$PDF$Annotation$toSignatureField,
						A3($author$project$Data$PDF$Annotation$updateAnnotationField, name, true, annotField),
						unsigedSig));
			case 'IsNumberField':
				var numField = annot.a;
				var _v4 = $author$project$Data$PDF$Annotation$numberField(numField);
				var annotField = _v4.a;
				var numTxt = _v4.b;
				return $author$project$Data$PDF$CreateTemplate$IsNumberField(
					A2(
						$author$project$Data$PDF$Annotation$toNumberField,
						A3($author$project$Data$PDF$Annotation$updateAnnotationField, name, required, annotField),
						numTxt));
			case 'IsStampField':
				var stamp = annot.a;
				var _v5 = $author$project$Data$PDF$Annotation$stampField(stamp);
				var annotField = _v5.a;
				var stampAnnot = _v5.b;
				return $author$project$Data$PDF$CreateTemplate$IsStampField(
					A2(
						$author$project$Data$PDF$Annotation$toStampField,
						A3($author$project$Data$PDF$Annotation$updateAnnotationField, name, required, annotField),
						stampAnnot));
			case 'IsNameField':
				var nameField = annot.a;
				var _v6 = $author$project$Data$PDF$Annotation$textField(nameField);
				var annotField = _v6.a;
				var txt = _v6.b;
				var newTxt = A2($author$project$Data$PDF$Annotation$toUpdatedUnverifiedTxt, txt, name);
				return $author$project$Data$PDF$CreateTemplate$IsNameField(
					A2(
						$author$project$Data$PDF$Annotation$toTextField,
						A3($author$project$Data$PDF$Annotation$updateAnnotationField, name, required, annotField),
						newTxt));
			case 'IsEmailField':
				var emailField = annot.a;
				var _v7 = $author$project$Data$PDF$Annotation$textField(emailField);
				var annotField = _v7.a;
				var txt = _v7.b;
				var newTxt = A2($author$project$Data$PDF$Annotation$toUpdatedUnverifiedTxt, txt, name);
				return $author$project$Data$PDF$CreateTemplate$IsEmailField(
					A2(
						$author$project$Data$PDF$Annotation$toTextField,
						A3($author$project$Data$PDF$Annotation$updateAnnotationField, name, required, annotField),
						newTxt));
			default:
				var checkboxField = annot.a;
				var _v8 = $author$project$Data$PDF$Annotation$checkBoxField(checkboxField);
				var annotField = _v8.a;
				var checkboxAnnot = _v8.b;
				return $author$project$Data$PDF$CreateTemplate$IsCheckBoxField(
					A2(
						$author$project$Data$PDF$Annotation$toCheckboxField,
						A3($author$project$Data$PDF$Annotation$updateAnnotationField, name, required, annotField),
						checkboxAnnot));
		}
	});
var $author$project$Data$PDF$Annotation$updateDateTxt = F4(
	function (timeNow, status, style, _v0) {
		var dateTxt_ = _v0.a;
		return $author$project$Data$PDF$Annotation$DateTxt(
			_Utils_update(
				dateTxt_,
				{
					date: timeNow,
					id: A3(
						$author$project$Data$PDF$Annotation$generateId,
						$author$project$Data$PDF$Annotation$toStringPosix(timeNow),
						$author$project$Data$PDF$Annotation$toStatusString(status),
						style),
					status: status,
					style: style
				}));
	});
var $author$project$Data$PDF$Annotation$updateNumberTxt = F4(
	function (content, status, style, _v0) {
		var numberTxt = _v0.a;
		return $author$project$Data$PDF$Annotation$NumberTxt(
			_Utils_update(
				numberTxt,
				{
					content: content,
					id: A3(
						$author$project$Data$PDF$Annotation$generateId,
						$elm$core$String$fromFloat(content),
						$author$project$Data$PDF$Annotation$toStatusString(status),
						style),
					status: status,
					style: style
				}));
	});
var $author$project$Data$PDF$CreateTemplate$updateAnnotationFontSize = F2(
	function (updatedFontSize, _v0) {
		var template = _v0.a;
		var updateTxtFontSize = function (txt) {
			var style = $author$project$Data$PDF$Annotation$txtStyle(txt);
			return _Utils_update(
				style,
				{fontSize: updatedFontSize});
		};
		var updateDateTxtFontSize = function (dateTxt) {
			var style = $author$project$Data$PDF$Annotation$dateTxtStyle(dateTxt);
			return _Utils_update(
				style,
				{fontSize: updatedFontSize});
		};
		var owner = $author$project$Data$PDF$CreateTemplate$getOwner(
			$author$project$Data$PDF$CreateTemplate$Template(template));
		var annotsList = A2(
			$elm$core$List$map,
			function (_v1) {
				var annot = _v1.a;
				var color = _v1.b;
				switch (annot.$) {
					case 'IsName':
						var txt = annot.a;
						return _Utils_Tuple2(
							$author$project$Data$PDF$CreateTemplate$IsName(
								A4(
									$author$project$Data$PDF$Annotation$updateTxt,
									$author$project$Data$PDF$Annotation$txtText(txt),
									$author$project$Data$PDF$Annotation$txtStatus(txt),
									updateTxtFontSize(txt),
									txt)),
							color);
					case 'IsDate':
						var dateTxt = annot.a;
						return _Utils_Tuple2(
							$author$project$Data$PDF$CreateTemplate$IsDate(
								A4(
									$author$project$Data$PDF$Annotation$updateDateTxt,
									$author$project$Data$PDF$Annotation$dateTxtDate(dateTxt),
									$author$project$Data$PDF$Annotation$dateTxtStatus(dateTxt),
									updateDateTxtFontSize(dateTxt),
									dateTxt)),
							color);
					case 'IsFreeText':
						var txt = annot.a;
						return _Utils_Tuple2(
							$author$project$Data$PDF$CreateTemplate$IsFreeText(
								A4(
									$author$project$Data$PDF$Annotation$updateTxt,
									$author$project$Data$PDF$Annotation$txtText(txt),
									$author$project$Data$PDF$Annotation$txtStatus(txt),
									updateTxtFontSize(txt),
									txt)),
							color);
					case 'IsSignature':
						return _Utils_Tuple2(annot, color);
					case 'IsTextField':
						var textfield = annot.a;
						var _v3 = $author$project$Data$PDF$Annotation$textField(textfield);
						var annotField = _v3.a;
						var txt = _v3.b;
						var updatedTxt = A4(
							$author$project$Data$PDF$Annotation$updateTxt,
							$author$project$Data$PDF$Annotation$txtText(txt),
							$author$project$Data$PDF$Annotation$txtStatus(txt),
							updateTxtFontSize(txt),
							txt);
						return _Utils_Tuple2(
							$author$project$Data$PDF$CreateTemplate$IsTextField(
								A2($author$project$Data$PDF$Annotation$toTextField, annotField, updatedTxt)),
							color);
					case 'IsDateField':
						var datefield = annot.a;
						var _v4 = $author$project$Data$PDF$Annotation$dateField(datefield);
						var annotField = _v4.a;
						var dateTxt = _v4.b;
						var updatedDateTxt = A4(
							$author$project$Data$PDF$Annotation$updateDateTxt,
							$author$project$Data$PDF$Annotation$dateTxtDate(dateTxt),
							$author$project$Data$PDF$Annotation$dateTxtStatus(dateTxt),
							updateDateTxtFontSize(dateTxt),
							dateTxt);
						return _Utils_Tuple2(
							$author$project$Data$PDF$CreateTemplate$IsDateField(
								A2($author$project$Data$PDF$Annotation$toDateField, annotField, updatedDateTxt)),
							color);
					case 'IsSignatureField':
						return _Utils_Tuple2(annot, color);
					case 'IsNumberField':
						var numberfield = annot.a;
						var _v5 = $author$project$Data$PDF$Annotation$numberField(numberfield);
						var annotField = _v5.a;
						var numberTxt = _v5.b;
						var style = $author$project$Data$PDF$Annotation$numberTxtStyle(numberTxt);
						var updatedStyle = _Utils_update(
							style,
							{fontSize: updatedFontSize});
						var updatedNumberTxt = A4(
							$author$project$Data$PDF$Annotation$updateNumberTxt,
							$author$project$Data$PDF$Annotation$numberTxtContent(numberTxt),
							$author$project$Data$PDF$Annotation$numberTxtStatus(numberTxt),
							updatedStyle,
							numberTxt);
						return _Utils_Tuple2(
							$author$project$Data$PDF$CreateTemplate$IsNumberField(
								A2($author$project$Data$PDF$Annotation$toNumberField, annotField, updatedNumberTxt)),
							color);
					case 'IsStampField':
						return _Utils_Tuple2(annot, color);
					case 'IsNameField':
						var textfield = annot.a;
						var _v6 = $author$project$Data$PDF$Annotation$textField(textfield);
						var annotField = _v6.a;
						var txt = _v6.b;
						var updatedTxt = A4(
							$author$project$Data$PDF$Annotation$updateTxt,
							$author$project$Data$PDF$Annotation$txtText(txt),
							$author$project$Data$PDF$Annotation$txtStatus(txt),
							updateTxtFontSize(txt),
							txt);
						return _Utils_Tuple2(
							$author$project$Data$PDF$CreateTemplate$IsNameField(
								A2($author$project$Data$PDF$Annotation$toTextField, annotField, updatedTxt)),
							color);
					case 'IsEmailField':
						var textfield = annot.a;
						var _v7 = $author$project$Data$PDF$Annotation$textField(textfield);
						var annotField = _v7.a;
						var txt = _v7.b;
						var updatedTxt = A4(
							$author$project$Data$PDF$Annotation$updateTxt,
							$author$project$Data$PDF$Annotation$txtText(txt),
							$author$project$Data$PDF$Annotation$txtStatus(txt),
							updateTxtFontSize(txt),
							txt);
						return _Utils_Tuple2(
							$author$project$Data$PDF$CreateTemplate$IsEmailField(
								A2($author$project$Data$PDF$Annotation$toTextField, annotField, updatedTxt)),
							color);
					default:
						return _Utils_Tuple2(annot, color);
				}
			},
			A3(
				$elm$core$List$foldl,
				F2(
					function (currentRole, accumulator) {
						var annotationsList = A2(
							$elm$core$List$map,
							function (annot) {
								return _Utils_Tuple2(annot, currentRole.color);
							},
							currentRole.annotations);
						return _Utils_ap(accumulator, annotationsList);
					}),
				_List_Nil,
				$elm$core$Dict$values(template.roles)));
		return $author$project$Data$PDF$Port$updateTemplate(
			A4($author$project$Data$PDF$CreateTemplate$encodeUpdateTemplate, owner, annotsList, template.base64FileData, _List_Nil));
	});
var $elm$core$List$unzip = function (pairs) {
	var step = F2(
		function (_v0, _v1) {
			var x = _v0.a;
			var y = _v0.b;
			var xs = _v1.a;
			var ys = _v1.b;
			return _Utils_Tuple2(
				A2($elm$core$List$cons, x, xs),
				A2($elm$core$List$cons, y, ys));
		});
	return A3(
		$elm$core$List$foldr,
		step,
		_Utils_Tuple2(_List_Nil, _List_Nil),
		pairs);
};
var $author$project$Data$PDF$CreateTemplate$isSameAnnot = F2(
	function (_v0, annot) {
		var id = _v0.a.id;
		switch (annot.$) {
			case 'IsName':
				var txt = annot.a;
				return _Utils_eq(
					$author$project$Data$PDF$Annotation$txtId(txt),
					id);
			case 'IsDate':
				var dateTxt = annot.a;
				return _Utils_eq(
					$author$project$Data$PDF$Annotation$dateTxtId(dateTxt),
					id);
			case 'IsFreeText':
				var txt = annot.a;
				return _Utils_eq(
					$author$project$Data$PDF$Annotation$txtId(txt),
					id);
			case 'IsSignature':
				var signedSig = annot.a;
				return _Utils_eq(
					$author$project$Data$PDF$Annotation$signedSignatureId(signedSig),
					id);
			case 'IsTextField':
				var txtField = annot.a;
				var _v2 = $author$project$Data$PDF$Annotation$textField(txtField);
				var txt = _v2.b;
				return _Utils_eq(
					$author$project$Data$PDF$Annotation$txtId(txt),
					id);
			case 'IsDateField':
				var dateField_ = annot.a;
				var _v3 = $author$project$Data$PDF$Annotation$dateField(dateField_);
				var dateTxt = _v3.b;
				return _Utils_eq(
					$author$project$Data$PDF$Annotation$dateTxtId(dateTxt),
					id);
			case 'IsSignatureField':
				var unsignedSigField = annot.a;
				var _v4 = $author$project$Data$PDF$Annotation$signatureField(unsignedSigField);
				var unsignedSig = _v4.b;
				return _Utils_eq(
					$author$project$Data$PDF$Annotation$unsignedSignatureId(unsignedSig),
					id);
			case 'IsNumberField':
				var numField = annot.a;
				var _v5 = $author$project$Data$PDF$Annotation$numberField(numField);
				var numberTxt = _v5.b;
				return _Utils_eq(
					$author$project$Data$PDF$Annotation$numberTxtId(numberTxt),
					id);
			case 'IsStampField':
				var stampFieldData = annot.a;
				var _v6 = $author$project$Data$PDF$Annotation$stampField(stampFieldData);
				var stamp = _v6.b;
				return _Utils_eq(
					$author$project$Data$PDF$Annotation$stampId(stamp),
					id);
			case 'IsNameField':
				var nameField = annot.a;
				var _v7 = $author$project$Data$PDF$Annotation$textField(nameField);
				var txt = _v7.b;
				return _Utils_eq(
					$author$project$Data$PDF$Annotation$txtId(txt),
					id);
			case 'IsEmailField':
				var emailField = annot.a;
				var _v8 = $author$project$Data$PDF$Annotation$textField(emailField);
				var txt = _v8.b;
				return _Utils_eq(
					$author$project$Data$PDF$Annotation$txtId(txt),
					id);
			default:
				var checkboxData = annot.a;
				var _v9 = $author$project$Data$PDF$Annotation$checkBoxField(checkboxData);
				var checkbox = _v9.b;
				return _Utils_eq(
					$author$project$Data$PDF$Annotation$checkboxId(checkbox),
					id);
		}
	});
var $author$project$Data$PDF$Annotation$Unchecked = {$: 'Unchecked'};
var $author$project$Data$PDF$Annotation$updateCheckBox = F3(
	function (status, style, _v0) {
		var txt = _v0.a;
		return $author$project$Data$PDF$Annotation$Checkbox(
			_Utils_update(
				txt,
				{
					id: A3(
						$author$project$Data$PDF$Annotation$generateId,
						$author$project$Data$PDF$Annotation$toCheckBoxStatusString(status),
						$author$project$Data$PDF$Annotation$toCheckBoxStatusString(status),
						style),
					status: status,
					style: style
				}));
	});
var $author$project$Data$PDF$Annotation$updateSignedSignature = F3(
	function (content, style, _v0) {
		var signedSig = _v0.a;
		return $author$project$Data$PDF$Annotation$SignedSignature(
			_Utils_update(
				signedSig,
				{
					id: A3($author$project$Data$PDF$Annotation$generateId, content, 'Signed', style),
					style: style
				}));
	});
var $author$project$Data$PDF$Annotation$updateStampStyle = F2(
	function (style, _v0) {
		var stamp = _v0.a;
		return $author$project$Data$PDF$Annotation$Stamp(
			_Utils_update(
				stamp,
				{
					id: A3(
						$author$project$Data$PDF$Annotation$generateId,
						'',
						$author$project$Data$PDF$Annotation$toStampStatusString(stamp.status),
						style),
					style: style
				}));
	});
var $author$project$Data$PDF$Annotation$updateUnsigedSignature = F2(
	function (style, _v0) {
		var unsignedSig = _v0.a;
		return $author$project$Data$PDF$Annotation$UnsignedSignature(
			_Utils_update(
				unsignedSig,
				{
					id: A3($author$project$Data$PDF$Annotation$generateId, '', 'Unsigned', style),
					style: style
				}));
	});
var $author$project$Data$PDF$CreateTemplate$updateAnnotWithDecodedAnnot = F2(
	function (_v0, annot) {
		var content = _v0.a.content;
		var status = _v0.a.status;
		var style = _v0.a.style;
		switch (annot.$) {
			case 'IsName':
				var txt = annot.a;
				return $author$project$Data$PDF$CreateTemplate$IsName(
					A4($author$project$Data$PDF$Annotation$updateTxt, content, status, style, txt));
			case 'IsDate':
				var dateTxt = annot.a;
				return $author$project$Data$PDF$CreateTemplate$IsDate(
					A4(
						$author$project$Data$PDF$Annotation$updateDateTxt,
						$author$project$Data$PDF$Annotation$dateTxtDate(dateTxt),
						status,
						style,
						dateTxt));
			case 'IsFreeText':
				var txt = annot.a;
				return $author$project$Data$PDF$CreateTemplate$IsFreeText(
					A4($author$project$Data$PDF$Annotation$updateTxt, content, status, style, txt));
			case 'IsSignature':
				var signedSig = annot.a;
				return $author$project$Data$PDF$CreateTemplate$IsSignature(
					A3($author$project$Data$PDF$Annotation$updateSignedSignature, content, style, signedSig));
			case 'IsTextField':
				var txtField = annot.a;
				var _v2 = $author$project$Data$PDF$Annotation$textField(txtField);
				var annotField = _v2.a;
				var txt = _v2.b;
				return $author$project$Data$PDF$CreateTemplate$IsTextField(
					A2(
						$author$project$Data$PDF$Annotation$toTextField,
						annotField,
						A4($author$project$Data$PDF$Annotation$updateTxt, content, status, style, txt)));
			case 'IsDateField':
				var dateField_ = annot.a;
				var _v3 = $author$project$Data$PDF$Annotation$dateField(dateField_);
				var annotField = _v3.a;
				var dateTxt = _v3.b;
				return $author$project$Data$PDF$CreateTemplate$IsDateField(
					A2(
						$author$project$Data$PDF$Annotation$toDateField,
						annotField,
						A4(
							$author$project$Data$PDF$Annotation$updateDateTxt,
							$author$project$Data$PDF$Annotation$dateTxtDate(dateTxt),
							status,
							style,
							dateTxt)));
			case 'IsSignatureField':
				var unsignedSigField = annot.a;
				var _v4 = $author$project$Data$PDF$Annotation$signatureField(unsignedSigField);
				var annotField = _v4.a;
				var unsignedSig = _v4.b;
				return $author$project$Data$PDF$CreateTemplate$IsSignatureField(
					A2(
						$author$project$Data$PDF$Annotation$toSignatureField,
						annotField,
						A2($author$project$Data$PDF$Annotation$updateUnsigedSignature, style, unsignedSig)));
			case 'IsNumberField':
				var numField = annot.a;
				var numberContent = A2(
					$elm$core$Maybe$withDefault,
					0,
					$elm$core$String$toFloat(content));
				var _v5 = $author$project$Data$PDF$Annotation$numberField(numField);
				var annotField = _v5.a;
				var numberTxt = _v5.b;
				return $author$project$Data$PDF$CreateTemplate$IsNumberField(
					A2(
						$author$project$Data$PDF$Annotation$toNumberField,
						annotField,
						A4($author$project$Data$PDF$Annotation$updateNumberTxt, numberContent, status, style, numberTxt)));
			case 'IsStampField':
				var stampFieldData = annot.a;
				var _v6 = $author$project$Data$PDF$Annotation$stampField(stampFieldData);
				var annotField = _v6.a;
				var stamp = _v6.b;
				return $author$project$Data$PDF$CreateTemplate$IsStampField(
					A2(
						$author$project$Data$PDF$Annotation$toStampField,
						annotField,
						A2($author$project$Data$PDF$Annotation$updateStampStyle, style, stamp)));
			case 'IsNameField':
				var nameField = annot.a;
				var _v7 = $author$project$Data$PDF$Annotation$textField(nameField);
				var annotField = _v7.a;
				var txt = _v7.b;
				return $author$project$Data$PDF$CreateTemplate$IsNameField(
					A2(
						$author$project$Data$PDF$Annotation$toTextField,
						annotField,
						A4($author$project$Data$PDF$Annotation$updateTxt, content, status, style, txt)));
			case 'IsEmailField':
				var emailField = annot.a;
				var _v8 = $author$project$Data$PDF$Annotation$textField(emailField);
				var annotField = _v8.a;
				var txt = _v8.b;
				return $author$project$Data$PDF$CreateTemplate$IsEmailField(
					A2(
						$author$project$Data$PDF$Annotation$toTextField,
						annotField,
						A4($author$project$Data$PDF$Annotation$updateTxt, content, status, style, txt)));
			default:
				var checkboxField = annot.a;
				var _v9 = $author$project$Data$PDF$Annotation$checkBoxField(checkboxField);
				var annotField = _v9.a;
				var checkbox = _v9.b;
				return $author$project$Data$PDF$CreateTemplate$IsCheckBoxField(
					A2(
						$author$project$Data$PDF$Annotation$toCheckboxField,
						annotField,
						A3($author$project$Data$PDF$Annotation$updateCheckBox, $author$project$Data$PDF$Annotation$Unchecked, style, checkbox)));
		}
	});
var $author$project$Data$PDF$CreateTemplate$updateAnnotsWithDecodedAnnots = F2(
	function (decodedAnnotList, annotList) {
		return A2(
			$elm$core$List$map,
			function (annot) {
				var maybeDecodedAnnot = $elm$core$List$head(
					A2(
						$elm$core$List$filter,
						function (decodedAnnot) {
							return A2($author$project$Data$PDF$CreateTemplate$isSameAnnot, decodedAnnot, annot);
						},
						decodedAnnotList));
				if (maybeDecodedAnnot.$ === 'Nothing') {
					return _Utils_Tuple2(annot, false);
				} else {
					var decodedAnnot = maybeDecodedAnnot.a;
					return _Utils_Tuple2(
						A2($author$project$Data$PDF$CreateTemplate$updateAnnotWithDecodedAnnot, decodedAnnot, annot),
						true);
				}
			},
			annotList);
	});
var $author$project$Data$PDF$CreateTemplate$updateAnnotations = F2(
	function (decodedAnnotList, _v0) {
		var template = _v0.a;
		var rolesList = $elm$core$Dict$values(template.roles);
		var updatedRole = $elm$core$List$head(
			A2(
				$elm$core$List$filterMap,
				function (roleData) {
					var _v3 = $elm$core$List$unzip(
						A2($author$project$Data$PDF$CreateTemplate$updateAnnotsWithDecodedAnnots, decodedAnnotList, roleData.annotations));
					var updatedRoleAnnot = _v3.a;
					var results = _v3.b;
					return A2(
						$elm$core$List$any,
						$elm$core$Basics$eq(true),
						results) ? $elm$core$Maybe$Just(
						_Utils_Tuple2(updatedRoleAnnot, roleData)) : $elm$core$Maybe$Nothing;
				},
				rolesList));
		var updatedRoles = function () {
			if (updatedRole.$ === 'Just') {
				var _v2 = updatedRole.a;
				var updatedRoleAnnots = _v2.a;
				var role = _v2.b.role;
				return A3(
					$elm$core$Dict$update,
					role,
					$elm$core$Maybe$map(
						function (roleData) {
							return _Utils_update(
								roleData,
								{annotations: updatedRoleAnnots});
						}),
					template.roles);
			} else {
				return template.roles;
			}
		}();
		var updatedAnnots = A3(
			$elm$core$List$foldl,
			F2(
				function (currentRole, accumulator) {
					var annotationsList = A2(
						$elm$core$List$map,
						function (annot) {
							return _Utils_Tuple2(annot, currentRole.color);
						},
						currentRole.annotations);
					return _Utils_ap(accumulator, annotationsList);
				}),
			_List_Nil,
			$elm$core$Dict$values(updatedRoles));
		var updatedTemplate = $author$project$Data$PDF$CreateTemplate$Template(
			_Utils_update(
				template,
				{roles: updatedRoles}));
		var owner = $author$project$Data$PDF$CreateTemplate$getOwner(
			$author$project$Data$PDF$CreateTemplate$Template(template));
		return _Utils_Tuple2(
			updatedTemplate,
			$author$project$Data$PDF$Port$updateTemplate(
				A4($author$project$Data$PDF$CreateTemplate$encodeUpdateTemplate, owner, updatedAnnots, template.base64FileData, _List_Nil)));
	});
var $author$project$Data$PDF$Annotation$updatePosixDateField = F2(
	function (dateNow, _v0) {
		var annotField = _v0.a;
		var dateTxt_ = _v0.b.a;
		return A2(
			$author$project$Data$PDF$Annotation$DateField,
			annotField,
			$author$project$Data$PDF$Annotation$DateTxt(
				_Utils_update(
					dateTxt_,
					{date: dateNow})));
	});
var $author$project$Data$PDF$Annotation$updatePosixDateTxt = F2(
	function (dateNow, _v0) {
		var dateTxt_ = _v0.a;
		return $author$project$Data$PDF$Annotation$DateTxt(
			_Utils_update(
				dateTxt_,
				{date: dateNow}));
	});
var $author$project$Data$PDF$CreateTemplate$updateDateAnnot = F2(
	function (time, annot) {
		switch (annot.$) {
			case 'IsName':
				var txt = annot.a;
				return $author$project$Data$PDF$CreateTemplate$IsName(txt);
			case 'IsDate':
				var dateTxt = annot.a;
				return $author$project$Data$PDF$CreateTemplate$IsDate(
					A2($author$project$Data$PDF$Annotation$updatePosixDateTxt, time, dateTxt));
			case 'IsFreeText':
				var txt = annot.a;
				return $author$project$Data$PDF$CreateTemplate$IsFreeText(txt);
			case 'IsSignature':
				var sig = annot.a;
				return $author$project$Data$PDF$CreateTemplate$IsSignature(sig);
			case 'IsTextField':
				var txt = annot.a;
				return $author$project$Data$PDF$CreateTemplate$IsTextField(txt);
			case 'IsDateField':
				var dateField = annot.a;
				return $author$project$Data$PDF$CreateTemplate$IsDateField(
					A2($author$project$Data$PDF$Annotation$updatePosixDateField, time, dateField));
			case 'IsSignatureField':
				var sig = annot.a;
				return $author$project$Data$PDF$CreateTemplate$IsSignatureField(sig);
			case 'IsNumberField':
				var numTxt = annot.a;
				return $author$project$Data$PDF$CreateTemplate$IsNumberField(numTxt);
			case 'IsStampField':
				var stamp = annot.a;
				return $author$project$Data$PDF$CreateTemplate$IsStampField(stamp);
			case 'IsNameField':
				var nameField = annot.a;
				return $author$project$Data$PDF$CreateTemplate$IsNameField(nameField);
			case 'IsEmailField':
				var emailField = annot.a;
				return $author$project$Data$PDF$CreateTemplate$IsEmailField(emailField);
			default:
				var checkboxField = annot.a;
				return $author$project$Data$PDF$CreateTemplate$IsCheckBoxField(checkboxField);
		}
	});
var $author$project$Data$PDF$CreateTemplate$decodedAnnotKind = function (_v0) {
	var kind = _v0.a.kind;
	return kind;
};
var $author$project$Data$PDF$CreateTemplate$decodedAnnotStyle = function (_v0) {
	var style = _v0.a.style;
	return style;
};
var $author$project$Model$CreateTemplate$updateLastStyle = F2(
	function (annotationDataList, previousLastStyle) {
		return A3(
			$elm$core$List$foldl,
			F2(
				function (data, lastStyle) {
					var _v0 = $author$project$Data$PDF$CreateTemplate$decodedAnnotStyle(data);
					var width = _v0.width;
					var height = _v0.height;
					var fontSize = _v0.fontSize;
					var _v1 = lastStyle;
					var name = _v1.name;
					var date = _v1.date;
					var freeText = _v1.freeText;
					var textField = _v1.textField;
					var dateField = _v1.dateField;
					var numberField = _v1.numberField;
					var nameField = _v1.nameField;
					var emailField = _v1.emailField;
					var _v2 = $author$project$Data$PDF$CreateTemplate$decodedAnnotKind(data);
					switch (_v2.$) {
						case 'NameKind':
							return _Utils_update(
								lastStyle,
								{
									date: _Utils_update(
										date,
										{fontSize: fontSize}),
									dateField: _Utils_update(
										dateField,
										{fontSize: fontSize}),
									freeText: _Utils_update(
										freeText,
										{fontSize: fontSize}),
									name: {fontSize: fontSize, height: height, width: width},
									numberField: _Utils_update(
										numberField,
										{fontSize: fontSize}),
									textField: _Utils_update(
										textField,
										{fontSize: fontSize})
								});
						case 'DateKind':
							return _Utils_update(
								lastStyle,
								{
									date: {fontSize: fontSize, height: height, width: width},
									dateField: _Utils_update(
										dateField,
										{fontSize: fontSize}),
									freeText: _Utils_update(
										freeText,
										{fontSize: fontSize}),
									name: _Utils_update(
										name,
										{fontSize: fontSize}),
									numberField: _Utils_update(
										numberField,
										{fontSize: fontSize}),
									textField: _Utils_update(
										textField,
										{fontSize: fontSize})
								});
						case 'TextKind':
							return _Utils_update(
								lastStyle,
								{
									date: _Utils_update(
										date,
										{fontSize: fontSize}),
									dateField: _Utils_update(
										dateField,
										{fontSize: fontSize}),
									freeText: {fontSize: fontSize, height: height, width: width},
									name: _Utils_update(
										name,
										{fontSize: fontSize}),
									numberField: _Utils_update(
										numberField,
										{fontSize: fontSize}),
									textField: _Utils_update(
										textField,
										{fontSize: fontSize})
								});
						case 'SignatureKind':
							return _Utils_update(
								lastStyle,
								{
									signature: {height: height, width: width}
								});
						case 'TextFieldKind':
							return _Utils_update(
								lastStyle,
								{
									date: _Utils_update(
										date,
										{fontSize: fontSize}),
									dateField: _Utils_update(
										dateField,
										{fontSize: fontSize}),
									freeText: _Utils_update(
										textField,
										{fontSize: fontSize}),
									name: _Utils_update(
										name,
										{fontSize: fontSize}),
									numberField: _Utils_update(
										numberField,
										{fontSize: fontSize}),
									textField: {fontSize: fontSize, height: height, width: width}
								});
						case 'DateFieldKind':
							return _Utils_update(
								lastStyle,
								{
									date: _Utils_update(
										date,
										{fontSize: fontSize}),
									dateField: {fontSize: fontSize, height: height, width: width},
									freeText: _Utils_update(
										dateField,
										{fontSize: fontSize}),
									name: _Utils_update(
										name,
										{fontSize: fontSize}),
									numberField: _Utils_update(
										numberField,
										{fontSize: fontSize}),
									textField: _Utils_update(
										textField,
										{fontSize: fontSize})
								});
						case 'SignatureFieldKind':
							return _Utils_update(
								lastStyle,
								{
									signatureField: {height: height, width: width}
								});
						case 'StampFieldKind':
							return _Utils_update(
								lastStyle,
								{
									stampField: {height: height, width: width}
								});
						case 'NumberFieldKind':
							return _Utils_update(
								lastStyle,
								{
									date: _Utils_update(
										date,
										{fontSize: fontSize}),
									dateField: _Utils_update(
										dateField,
										{fontSize: fontSize}),
									freeText: _Utils_update(
										numberField,
										{fontSize: fontSize}),
									name: _Utils_update(
										name,
										{fontSize: fontSize}),
									numberField: {fontSize: fontSize, height: height, width: width},
									textField: _Utils_update(
										textField,
										{fontSize: fontSize})
								});
						case 'EmailFieldKind':
							return _Utils_update(
								lastStyle,
								{
									date: _Utils_update(
										date,
										{fontSize: fontSize}),
									dateField: _Utils_update(
										dateField,
										{fontSize: fontSize}),
									emailField: {fontSize: fontSize, height: height, width: width},
									freeText: _Utils_update(
										numberField,
										{fontSize: fontSize}),
									name: _Utils_update(
										name,
										{fontSize: fontSize}),
									nameField: _Utils_update(
										nameField,
										{fontSize: fontSize}),
									numberField: _Utils_update(
										numberField,
										{fontSize: fontSize}),
									textField: _Utils_update(
										textField,
										{fontSize: fontSize})
								});
						case 'NameFieldKind':
							return _Utils_update(
								lastStyle,
								{
									date: _Utils_update(
										date,
										{fontSize: fontSize}),
									dateField: _Utils_update(
										dateField,
										{fontSize: fontSize}),
									emailField: _Utils_update(
										emailField,
										{fontSize: fontSize}),
									freeText: _Utils_update(
										numberField,
										{fontSize: fontSize}),
									name: _Utils_update(
										name,
										{fontSize: fontSize}),
									nameField: {fontSize: fontSize, height: height, width: width},
									numberField: _Utils_update(
										numberField,
										{fontSize: fontSize}),
									textField: _Utils_update(
										textField,
										{fontSize: fontSize})
								});
						default:
							return _Utils_update(
								lastStyle,
								{
									checkbox: {fontSize: fontSize, height: height, width: width},
									date: _Utils_update(
										date,
										{fontSize: fontSize}),
									dateField: _Utils_update(
										dateField,
										{fontSize: fontSize}),
									emailField: _Utils_update(
										emailField,
										{fontSize: fontSize}),
									freeText: _Utils_update(
										textField,
										{fontSize: fontSize}),
									name: _Utils_update(
										name,
										{fontSize: fontSize}),
									numberField: _Utils_update(
										numberField,
										{fontSize: fontSize}),
									textField: _Utils_update(
										textField,
										{fontSize: fontSize})
								});
					}
				}),
			previousLastStyle,
			annotationDataList);
	});
var $author$project$Data$PDF$CreateTemplate$updateSignOrder = F3(
	function (role, newSignOrder, _v0) {
		var template = _v0.a;
		return $author$project$Data$PDF$CreateTemplate$Template(
			_Utils_update(
				template,
				{
					roles: A3(
						$elm$core$Dict$update,
						role,
						$elm$core$Maybe$map(
							function (roleData) {
								return _Utils_update(
									roleData,
									{signOrder: newSignOrder});
							}),
						template.roles)
				}));
	});
var $author$project$Data$Api$PDF$UploadTemplate$Payload = function (result) {
	return {result: result};
};
var $author$project$Data$Api$PDF$UploadTemplate$dataDecoder = A2(
	$elm$json$Json$Decode$map,
	$author$project$Data$Api$PDF$UploadTemplate$Payload,
	A2($elm$json$Json$Decode$field, 'result', $elm$json$Json$Decode$string));
var $author$project$Data$PDF$CreateTemplate$isPrivate = function (_v0) {
	var template = _v0.a;
	return template.isPrivate;
};
var $author$project$Data$PDF$CreateTemplate$password = function (_v0) {
	var template = _v0.a;
	return template.password;
};
var $author$project$Data$PDF$CreateTemplate$encodeAnnotationList = F3(
	function (annots, encodeSignature, colour) {
		return A2(
			$elm$json$Json$Encode$list,
			function (a) {
				var ownerBgRGBA = $author$project$Data$PDF$User$materialColorRGB($author$project$Data$PDF$User$Transparent);
				var annotFieldBgRGBA = function () {
					if (colour.$ === 'Just') {
						var roleColour = colour.a;
						return $author$project$Data$PDF$User$materialColorRGB(roleColour);
					} else {
						return $author$project$Data$PDF$User$materialColorRGB($author$project$Data$PDF$User$Blue);
					}
				}();
				switch (a.$) {
					case 'IsName':
						var txt = a.a;
						return $elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'kind',
									$elm$json$Json$Encode$string('Name')),
									_Utils_Tuple2(
									'data',
									A3(
										$author$project$Data$PDF$Port$encodeFreeText,
										ownerBgRGBA,
										$author$project$Data$PDF$Annotation$txtText(txt),
										txt))
								]));
					case 'IsDate':
						var dateTxt = a.a;
						var content = $elm$core$String$fromInt(
							$elm$time$Time$posixToMillis(
								$author$project$Data$PDF$Annotation$dateTxtDate(dateTxt)));
						return $elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'kind',
									$elm$json$Json$Encode$string('Date')),
									_Utils_Tuple2(
									'data',
									A3($author$project$Data$PDF$Port$encodeDateText, ownerBgRGBA, content, dateTxt))
								]));
					case 'IsFreeText':
						var txt = a.a;
						return $elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'kind',
									$elm$json$Json$Encode$string('FreeText')),
									_Utils_Tuple2(
									'data',
									A3(
										$author$project$Data$PDF$Port$encodeFreeText,
										ownerBgRGBA,
										$author$project$Data$PDF$Annotation$txtText(txt),
										txt))
								]));
					case 'IsSignature':
						var signedSig = a.a;
						return encodeSignature(signedSig);
					case 'IsTextField':
						var txtField = a.a;
						var _v1 = $author$project$Data$PDF$Annotation$textField(txtField);
						var annotField = _v1.a;
						var txt = _v1.b;
						var _v2 = $author$project$Data$PDF$Annotation$annotFieldData(annotField);
						var required = _v2.a;
						var name = _v2.b;
						return $elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'kind',
									$elm$json$Json$Encode$string('TextField')),
									_Utils_Tuple2(
									'name',
									$elm$json$Json$Encode$string(name)),
									_Utils_Tuple2(
									'required',
									$elm$json$Json$Encode$bool(required)),
									_Utils_Tuple2(
									'data',
									A3(
										$author$project$Data$PDF$Port$encodeFreeText,
										annotFieldBgRGBA,
										$author$project$Data$PDF$Annotation$txtText(txt),
										txt))
								]));
					case 'IsDateField':
						var dateField_ = a.a;
						var _v3 = $author$project$Data$PDF$Annotation$dateField(dateField_);
						var annotField = _v3.a;
						var dateTxt = _v3.b;
						var _v4 = $author$project$Data$PDF$Annotation$annotFieldData(annotField);
						var required = _v4.a;
						var name = _v4.b;
						return $elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'kind',
									$elm$json$Json$Encode$string('DateField')),
									_Utils_Tuple2(
									'name',
									$elm$json$Json$Encode$string(name)),
									_Utils_Tuple2(
									'required',
									$elm$json$Json$Encode$bool(required)),
									_Utils_Tuple2(
									'data',
									A3(
										$author$project$Data$PDF$Port$encodeDateText,
										annotFieldBgRGBA,
										$author$project$Data$PDF$Annotation$toStringPosix(
											$author$project$Data$PDF$Annotation$dateTxtDate(dateTxt)),
										dateTxt))
								]));
					case 'IsSignatureField':
						var unsignedSigField = a.a;
						var _v5 = $author$project$Data$PDF$Annotation$signatureField(unsignedSigField);
						var annotField = _v5.a;
						var unsignedSig = _v5.b;
						var _v6 = $author$project$Data$PDF$Annotation$unsignedSignatureFields(unsignedSig);
						var id = _v6.a;
						var style = _v6.b;
						var unsignedTxt = A2($author$project$Data$PDF$Annotation$unsignedTxtSignature, id, style);
						var _v7 = $author$project$Data$PDF$Annotation$annotFieldData(annotField);
						var required = _v7.a;
						var name = _v7.b;
						return $elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'kind',
									$elm$json$Json$Encode$string('SignatureField')),
									_Utils_Tuple2(
									'name',
									$elm$json$Json$Encode$string(name)),
									_Utils_Tuple2(
									'required',
									$elm$json$Json$Encode$bool(required)),
									_Utils_Tuple2(
									'data',
									A3(
										$author$project$Data$PDF$Port$encodeFreeText,
										annotFieldBgRGBA,
										$author$project$Data$PDF$Annotation$unsignedSignatureText(unsignedSig),
										unsignedTxt))
								]));
					case 'IsNumberField':
						var numField = a.a;
						var _v8 = $author$project$Data$PDF$Annotation$numberField(numField);
						var annotField = _v8.a;
						var numberTxt = _v8.b;
						var _v9 = $author$project$Data$PDF$Annotation$annotFieldData(annotField);
						var required = _v9.a;
						var name = _v9.b;
						return $elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'kind',
									$elm$json$Json$Encode$string('NumberField')),
									_Utils_Tuple2(
									'name',
									$elm$json$Json$Encode$string(name)),
									_Utils_Tuple2(
									'required',
									$elm$json$Json$Encode$bool(required)),
									_Utils_Tuple2(
									'data',
									A3(
										$author$project$Data$PDF$Port$encodeNumberText,
										annotFieldBgRGBA,
										$elm$core$String$fromFloat(
											$author$project$Data$PDF$Annotation$numberTxtContent(numberTxt)),
										numberTxt))
								]));
					case 'IsStampField':
						var stampFieldData = a.a;
						var _v10 = $author$project$Data$PDF$Annotation$stampField(stampFieldData);
						var annotField = _v10.a;
						var stamp = _v10.b;
						var _v11 = $author$project$Data$PDF$Annotation$stampFieldsStyle(stamp);
						var id = _v11.a;
						var style = _v11.b;
						var unsignedTxt = A2($author$project$Data$PDF$Annotation$unsignedTxtSignature, id, style);
						var _v12 = $author$project$Data$PDF$Annotation$annotFieldData(annotField);
						var required = _v12.a;
						var name = _v12.b;
						return $elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'kind',
									$elm$json$Json$Encode$string('StampField')),
									_Utils_Tuple2(
									'name',
									$elm$json$Json$Encode$string(name)),
									_Utils_Tuple2(
									'required',
									$elm$json$Json$Encode$bool(required)),
									_Utils_Tuple2(
									'data',
									A3($author$project$Data$PDF$Port$encodeFreeText, annotFieldBgRGBA, 'Stamp', unsignedTxt))
								]));
					case 'IsNameField':
						var nameFieldData = a.a;
						var _v13 = $author$project$Data$PDF$Annotation$textField(nameFieldData);
						var annotField = _v13.a;
						var txt = _v13.b;
						var _v14 = $author$project$Data$PDF$Annotation$annotFieldData(annotField);
						var required = _v14.a;
						var name = _v14.b;
						return $elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'kind',
									$elm$json$Json$Encode$string('NameField')),
									_Utils_Tuple2(
									'name',
									$elm$json$Json$Encode$string(name)),
									_Utils_Tuple2(
									'required',
									$elm$json$Json$Encode$bool(required)),
									_Utils_Tuple2(
									'data',
									A3(
										$author$project$Data$PDF$Port$encodeFreeText,
										annotFieldBgRGBA,
										$author$project$Data$PDF$Annotation$txtText(txt),
										txt))
								]));
					case 'IsEmailField':
						var emailFieldData = a.a;
						var _v15 = $author$project$Data$PDF$Annotation$textField(emailFieldData);
						var annotField = _v15.a;
						var txt = _v15.b;
						var _v16 = $author$project$Data$PDF$Annotation$annotFieldData(annotField);
						var required = _v16.a;
						var name = _v16.b;
						return $elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'kind',
									$elm$json$Json$Encode$string('EmailField')),
									_Utils_Tuple2(
									'name',
									$elm$json$Json$Encode$string(name)),
									_Utils_Tuple2(
									'required',
									$elm$json$Json$Encode$bool(required)),
									_Utils_Tuple2(
									'data',
									A3(
										$author$project$Data$PDF$Port$encodeFreeText,
										annotFieldBgRGBA,
										$author$project$Data$PDF$Annotation$txtText(txt),
										txt))
								]));
					default:
						var checkboxData = a.a;
						var _v17 = $author$project$Data$PDF$Annotation$checkBoxField(checkboxData);
						var annotField = _v17.a;
						var checkbox = _v17.b;
						var _v18 = $author$project$Data$PDF$Annotation$annotFieldData(annotField);
						var required = _v18.a;
						var name = _v18.b;
						return $elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'kind',
									$elm$json$Json$Encode$string('CheckboxField')),
									_Utils_Tuple2(
									'name',
									$elm$json$Json$Encode$string(name)),
									_Utils_Tuple2(
									'required',
									$elm$json$Json$Encode$bool(required)),
									_Utils_Tuple2(
									'data',
									A3($author$project$Data$PDF$Port$encodeCheckBox, annotFieldBgRGBA, 'Unchecked', checkbox))
								]));
				}
			},
			annots);
	});
var $author$project$Data$PDF$Port$encodeApiSignedSignature = F3(
	function (id, dbId, style) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'id',
					$elm$json$Json$Encode$string(id)),
					_Utils_Tuple2(
					'dbId',
					$elm$json$Json$Encode$string(dbId)),
					_Utils_Tuple2(
					'style',
					$author$project$Data$PDF$Port$encodeStyle(style))
				]));
	});
var $author$project$Data$PDF$CreateTemplate$encodeApiSignature = function (signedSig) {
	var _v0 = $author$project$Data$PDF$Annotation$signedSignatureFields(signedSig);
	var id = _v0.a;
	var dbId = _v0.b;
	var style = _v0.c;
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'kind',
				$elm$json$Json$Encode$string('Signature')),
				_Utils_Tuple2(
				'data',
				A3($author$project$Data$PDF$Port$encodeApiSignedSignature, id, dbId, style))
			]));
};
var $author$project$Data$Api$PDF$UploadTemplate$rolesEncoder = function (role) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'role',
				$elm$json$Json$Encode$string(role.role)),
				_Utils_Tuple2(
				'email',
				A2(
					$elm$core$Maybe$withDefault,
					$elm$json$Json$Encode$null,
					A2($elm$core$Maybe$map, $elm$json$Json$Encode$string, role.email))),
				_Utils_Tuple2(
				'firstName',
				A2(
					$elm$core$Maybe$withDefault,
					$elm$json$Json$Encode$null,
					A2($elm$core$Maybe$map, $elm$json$Json$Encode$string, role.firstName))),
				_Utils_Tuple2(
				'lastName',
				A2(
					$elm$core$Maybe$withDefault,
					$elm$json$Json$Encode$null,
					A2($elm$core$Maybe$map, $elm$json$Json$Encode$string, role.lastName))),
				_Utils_Tuple2(
				'annotations',
				A3($author$project$Data$PDF$CreateTemplate$encodeAnnotationList, role.annotations, $author$project$Data$PDF$CreateTemplate$encodeApiSignature, $elm$core$Maybe$Nothing)),
				_Utils_Tuple2(
				'signOrder',
				$elm$json$Json$Encode$int(role.signOrder))
			]));
};
var $author$project$Data$PDF$CreateTemplate$slug = function (_v0) {
	var template = _v0.a;
	return template.slug;
};
var $author$project$Data$PDF$CreateTemplate$title = function (_v0) {
	var template = _v0.a;
	return template.title;
};
var $author$project$Data$Api$PDF$UploadTemplate$encode = F2(
	function (domain, template) {
		var roles = $author$project$Data$PDF$CreateTemplate$getRoles(template);
		var ownerEmail = $author$project$Data$PDF$User$userInfo(
			$author$project$Data$PDF$CreateTemplate$getOwner(template)).email;
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'ownerEmail',
					$elm$json$Json$Encode$string(ownerEmail)),
					_Utils_Tuple2(
					'title',
					$elm$json$Json$Encode$string(
						$author$project$Data$PDF$CreateTemplate$title(template))),
					_Utils_Tuple2(
					'slug',
					$elm$json$Json$Encode$string(
						$author$project$Data$PDF$CreateTemplate$slug(template))),
					_Utils_Tuple2(
					'password',
					A2(
						$elm$core$Maybe$withDefault,
						$elm$json$Json$Encode$null,
						A2(
							$elm$core$Maybe$map,
							$elm$json$Json$Encode$string,
							$author$project$Data$PDF$CreateTemplate$password(template)))),
					_Utils_Tuple2(
					'domain',
					$elm$json$Json$Encode$string(domain)),
					_Utils_Tuple2(
					'isPrivate',
					$elm$json$Json$Encode$bool(
						$author$project$Data$PDF$CreateTemplate$isPrivate(template))),
					_Utils_Tuple2(
					'roles',
					A2($elm$json$Json$Encode$list, $author$project$Data$Api$PDF$UploadTemplate$rolesEncoder, roles))
				]));
	});
var $author$project$Data$Api$PDF$UploadTemplate$encodeToString = F2(
	function (domain, template) {
		return A2(
			$elm$json$Json$Encode$encode,
			0,
			A2($author$project$Data$Api$PDF$UploadTemplate$encode, domain, template));
	});
var $author$project$Data$Api$PDF$UploadTemplate$APPEND_ERROR = {$: 'APPEND_ERROR'};
var $author$project$Data$Api$PDF$UploadTemplate$FILE_NOT_FOUND = {$: 'FILE_NOT_FOUND'};
var $author$project$Data$Api$PDF$UploadTemplate$FILE_TOO_BIG = {$: 'FILE_TOO_BIG'};
var $author$project$Data$Api$PDF$UploadTemplate$INCORRECT_PASSWORD = {$: 'INCORRECT_PASSWORD'};
var $author$project$Data$Api$PDF$UploadTemplate$INVALID_CERTIFICATE = {$: 'INVALID_CERTIFICATE'};
var $author$project$Data$Api$PDF$UploadTemplate$INVALID_DATA = {$: 'INVALID_DATA'};
var $author$project$Data$Api$PDF$UploadTemplate$INVALID_DOMAIN = {$: 'INVALID_DOMAIN'};
var $author$project$Data$Api$PDF$UploadTemplate$INVALID_PDF = {$: 'INVALID_PDF'};
var $author$project$Data$Api$PDF$UploadTemplate$INVALID_SLUG = {$: 'INVALID_SLUG'};
var $author$project$Data$Api$PDF$UploadTemplate$LOADING_ERROR = {$: 'LOADING_ERROR'};
var $author$project$Data$Api$PDF$UploadTemplate$QUOTA_REACHED = {$: 'QUOTA_REACHED'};
var $author$project$Data$Api$PDF$UploadTemplate$SIGNATURE_HASH_ERROR = {$: 'SIGNATURE_HASH_ERROR'};
var $author$project$Data$Api$PDF$UploadTemplate$SLUG_ALREADY_EXIST = {$: 'SLUG_ALREADY_EXIST'};
var $author$project$Data$Api$PDF$UploadTemplate$TEMP_FILE_NOT_FOUND = {$: 'TEMP_FILE_NOT_FOUND'};
var $author$project$Data$Api$PDF$UploadTemplate$UNEDITABLE_PDF = {$: 'UNEDITABLE_PDF'};
var $author$project$Data$Api$PDF$UploadTemplate$UNKNOWN = {$: 'UNKNOWN'};
var $author$project$Data$Api$PDF$UploadTemplate$WRONG_FILE_FORMAT = {$: 'WRONG_FILE_FORMAT'};
var $author$project$Data$Api$PDF$UploadTemplate$errorDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (errorCode) {
		switch (errorCode) {
			case 'FILE_TOO_BIG':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$PDF$UploadTemplate$FILE_TOO_BIG);
			case 'SLUG_ALREADY_EXIST':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$PDF$UploadTemplate$SLUG_ALREADY_EXIST);
			case 'WRONG_FILE_FORMAT':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$PDF$UploadTemplate$WRONG_FILE_FORMAT);
			case 'INVALID_DATA':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$PDF$UploadTemplate$INVALID_DATA);
			case 'INVALID_SLUG':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$PDF$UploadTemplate$INVALID_SLUG);
			case 'INVALID_DOMAIN':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$PDF$UploadTemplate$INVALID_DOMAIN);
			case 'INVALID_PDF':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$PDF$UploadTemplate$INVALID_PDF);
			case 'INCORRECT_PASSWORD':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$PDF$UploadTemplate$INCORRECT_PASSWORD);
			case 'APPEND_ERROR':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$PDF$UploadTemplate$APPEND_ERROR);
			case 'INVALID_CERTIFICATE':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$PDF$UploadTemplate$INVALID_CERTIFICATE);
			case 'UNEDITABLE_PDF':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$PDF$UploadTemplate$UNEDITABLE_PDF);
			case 'LOADING_ERROR':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$PDF$UploadTemplate$LOADING_ERROR);
			case 'SIGNATURE_HASH_ERROR':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$PDF$UploadTemplate$SIGNATURE_HASH_ERROR);
			case 'FILE_NOT_FOUND':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$PDF$UploadTemplate$FILE_NOT_FOUND);
			case 'TEMP_FILE_NOT_FOUND':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$PDF$UploadTemplate$TEMP_FILE_NOT_FOUND);
			case 'UNKNOWN':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$PDF$UploadTemplate$UNKNOWN);
			case 'QUOTA_REACHED':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$PDF$UploadTemplate$QUOTA_REACHED);
			default:
				return $elm$json$Json$Decode$fail('Invalid error code: ' + errorCode);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Data$Api$PDF$UploadTemplate$upload = F5(
	function (jwt, endPoint, domain, template, file) {
		return A5(
			$author$project$Data$Api$authUpload,
			jwt,
			endPoint,
			$author$project$Data$Api$PDF$UploadTemplate$errorDecoder,
			$author$project$Data$Api$PDF$UploadTemplate$dataDecoder,
			_List_fromArray(
				[
					A2(
					$elm$http$Http$stringPart,
					'data',
					A2($author$project$Data$Api$PDF$UploadTemplate$encodeToString, domain, template)),
					A2($elm$http$Http$filePart, 'file', file)
				]));
	});
var $author$project$Model$CreateTemplate$validateFieldFormName = function (formName) {
	return (!$elm$core$String$isEmpty(formName)) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just('Field name cannot be empty.');
};
var $author$project$Model$CreateTemplate$validateName = function (title) {
	return (!$elm$core$String$isEmpty(title)) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just('Name cannot be empty.');
};
var $author$project$Model$CreateTemplate$validateRole = function (title) {
	return (!$elm$core$String$isEmpty(title)) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just('Role name cannot be empty.');
};
var $author$project$Model$CreateTemplate$validateSlug = function (slug) {
	var isValid = A2(
		$elm$regex$Regex$contains,
		A2(
			$elm$core$Maybe$withDefault,
			$elm$regex$Regex$never,
			$elm$regex$Regex$fromString('^[A-Za-z0-9]+(?:-[A-Za-z0-9]+)*$')),
		A2($elm$core$Maybe$withDefault, '', slug));
	var _v0 = _Utils_Tuple2(slug, isValid);
	if ((_v0.a.$ === 'Just') && (!_v0.b)) {
		return $elm$core$Maybe$Just('Slug contains invalid characters.');
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Model$CreateTemplate$validateTitle = function (title) {
	return (!$elm$core$String$isEmpty(title)) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just('Title cannot be empty.');
};
var $author$project$Model$CreateTemplate$update = F3(
	function (msg, authModel, model) {
		var _v0 = authModel.createTemplateModel;
		if (_v0.$ === 'NotLoaded') {
			return _Utils_Tuple2(
				model,
				A2($elm$browser$Browser$Navigation$replaceUrl, model.navKey, $author$project$Data$Route$routeUrl.newTemplate));
		} else {
			var loadedModel = _v0.a;
			var updateCurrentModel = function (m) {
				return _Utils_update(
					model,
					{
						sessionModel: $author$project$Types$Auth(
							_Utils_update(
								authModel,
								{
									createTemplateModel: $author$project$Type$CreateTemplate$Loaded(m)
								}))
					});
			};
			var updateAddRole = function (m) {
				return updateCurrentModel(
					_Utils_update(
						loadedModel,
						{addRole: m}));
			};
			var _v1 = loadedModel;
			var annotFieldForm = _v1.annotFieldForm;
			var addRole = _v1.addRole;
			var updateAddRoleDetails = function (m) {
				return updateAddRole(
					_Utils_update(
						addRole,
						{roleDetails: m}));
			};
			switch (msg.$) {
				case 'OnUnload':
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								sessionModel: $author$project$Types$Auth(
									_Utils_update(
										authModel,
										{createTemplateModel: $author$project$Type$CreateTemplate$NotLoaded}))
							}),
						$author$project$Data$PDF$CreateTemplate$unload(_Utils_Tuple0));
				case 'OnReceiveEncryptionError':
					var value = msg.a;
					var _v3 = $author$project$Data$PDF$Encryption$decode(value);
					if (_v3.$ === 'Ok') {
						var encryptionError = _v3.a;
						if (encryptionError.$ === 'PasswordFail') {
							return _Utils_Tuple2(
								updateCurrentModel(
									_Utils_update(
										loadedModel,
										{
											passwordError: $elm$core$Maybe$Just('Password failed.'),
											status: $author$project$Type$CreateTemplate$NeedPassword
										})),
								$elm$core$Platform$Cmd$none);
						} else {
							return _Utils_Tuple2(
								updateCurrentModel(
									_Utils_update(
										loadedModel,
										{passwordError: $elm$core$Maybe$Nothing, status: $author$project$Type$CreateTemplate$NeedPassword})),
								$elm$core$Platform$Cmd$none);
						}
					} else {
						var decodeErrorMessage = _v3.a;
						return _Utils_Tuple2(
							updateCurrentModel(
								_Utils_update(
									loadedModel,
									{
										status: $author$project$Type$CreateTemplate$Error(decodeErrorMessage)
									})),
							$elm$core$Platform$Cmd$none);
					}
				case 'OnPasswordInput':
					var value = msg.a;
					return $elm$core$String$isEmpty(value) ? _Utils_Tuple2(
						updateCurrentModel(
							_Utils_update(
								loadedModel,
								{password: $elm$core$Maybe$Nothing, passwordError: $elm$core$Maybe$Nothing})),
						$elm$core$Platform$Cmd$none) : _Utils_Tuple2(
						updateCurrentModel(
							_Utils_update(
								loadedModel,
								{
									password: $elm$core$Maybe$Just(value),
									passwordError: $elm$core$Maybe$Nothing
								})),
						$elm$core$Platform$Cmd$none);
				case 'OnPasswordSubmit':
					var _v5 = A2(
						$author$project$Data$PDF$CreateTemplate$loadWithPassword,
						A2($elm$core$Maybe$withDefault, '', loadedModel.password),
						loadedModel.template);
					var template = _v5.a;
					var templateCmd = _v5.b;
					return _Utils_Tuple2(
						updateCurrentModel(
							_Utils_update(
								loadedModel,
								{status: $author$project$Type$CreateTemplate$Editing, template: template})),
						templateCmd);
				case 'OnDocInput':
					var field = msg.a;
					var value = msg.b;
					if (field.$ === 'Title') {
						return _Utils_Tuple2(
							updateCurrentModel(
								_Utils_update(
									loadedModel,
									{title: value})),
							$elm$core$Platform$Cmd$none);
					} else {
						return _Utils_Tuple2(
							updateCurrentModel(
								_Utils_update(
									loadedModel,
									{
										slug: $elm$core$Maybe$Just(value)
									})),
							$elm$core$Platform$Cmd$none);
					}
				case 'OnDocBlur':
					var field = msg.a;
					if (field.$ === 'Title') {
						return _Utils_Tuple2(
							updateCurrentModel(
								_Utils_update(
									loadedModel,
									{
										titleError: $author$project$Model$CreateTemplate$validateTitle(loadedModel.title)
									})),
							$elm$core$Platform$Cmd$none);
					} else {
						return _Utils_Tuple2(
							updateCurrentModel(
								_Utils_update(
									loadedModel,
									{
										slugError: $author$project$Model$CreateTemplate$validateSlug(loadedModel.slug)
									})),
							$elm$core$Platform$Cmd$none);
					}
				case 'OnURLSharingCheck':
					var _v8 = _Utils_Tuple2(
						loadedModel.slug,
						$elm$core$List$length(
							A2(
								$elm$core$List$filter,
								function (r) {
									return !_Utils_eq(r.signOrder, -1);
								},
								$author$project$Data$PDF$CreateTemplate$getRoles(loadedModel.template))) > 1);
					if (_v8.a.$ === 'Nothing') {
						if (!_v8.b) {
							var _v9 = _v8.a;
							return _Utils_Tuple2(
								updateCurrentModel(
									_Utils_update(
										loadedModel,
										{
											documentTitleError: $elm$core$Maybe$Nothing,
											slug: $elm$core$Maybe$Just('')
										})),
								$elm$core$Platform$Cmd$none);
						} else {
							var _v10 = _v8.a;
							return _Utils_Tuple2(
								updateCurrentModel(
									_Utils_update(
										loadedModel,
										{
											documentTitleError: $elm$core$Maybe$Just('Unable to enable URL sharing with multiple roles'),
											slug: $elm$core$Maybe$Nothing,
											slugError: $elm$core$Maybe$Nothing
										})),
								$elm$core$Platform$Cmd$none);
						}
					} else {
						return _Utils_Tuple2(
							updateCurrentModel(
								_Utils_update(
									loadedModel,
									{slug: $elm$core$Maybe$Nothing, slugError: $elm$core$Maybe$Nothing})),
							$elm$core$Platform$Cmd$none);
					}
				case 'OnErrorClose':
					return _Utils_Tuple2(
						updateCurrentModel(
							_Utils_update(
								loadedModel,
								{status: $author$project$Type$CreateTemplate$Editing})),
						$elm$core$Platform$Cmd$none);
				case 'OnAnnotClick':
					var annot = msg.a;
					var role = msg.b;
					var annotFieldFormStatus = $author$project$Data$PDF$CreateTemplate$isATextField(annot) ? $author$project$Type$CreateTemplate$PendingFieldForm : ($author$project$Data$PDF$CreateTemplate$isACheckboxField(annot) ? $author$project$Type$CreateTemplate$CheckboxFieldForm : $author$project$Type$CreateTemplate$NoSelectedFieldAnnot);
					var updatedModel = updateCurrentModel(
						_Utils_update(
							loadedModel,
							{
								annotFieldForm: _Utils_update(
									annotFieldForm,
									{status: annotFieldFormStatus}),
								selectedAnnot: $elm$core$Maybe$Just(
									_Utils_Tuple2(annot, role))
							}));
					switch (annot.$) {
						case 'IsDate':
							return _Utils_Tuple2(
								updatedModel,
								A2(
									$elm$core$Task$attempt,
									A2(
										$elm$core$Basics$composeL,
										A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnCreateTemplate),
										$author$project$Type$CreateTemplate$SetDateToAnnot),
									$elm$time$Time$now));
						case 'IsDateField':
							return _Utils_Tuple2(
								updatedModel,
								A2(
									$elm$core$Task$attempt,
									A2(
										$elm$core$Basics$composeL,
										A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnCreateTemplate),
										$author$project$Type$CreateTemplate$SetDateToAnnot),
									$elm$time$Time$now));
						default:
							return _Utils_Tuple2(updatedModel, $elm$core$Platform$Cmd$none);
					}
				case 'SetDateToAnnot':
					var value = msg.a;
					if (value.$ === 'Ok') {
						var time = value.a;
						var _v13 = loadedModel.selectedAnnot;
						if (_v13.$ === 'Just') {
							var _v14 = _v13.a;
							var annotation = _v14.a;
							var role = _v14.b;
							return _Utils_Tuple2(
								updateCurrentModel(
									_Utils_update(
										loadedModel,
										{
											selectedAnnot: $elm$core$Maybe$Just(
												_Utils_Tuple2(
													A2($author$project$Data$PDF$CreateTemplate$updateDateAnnot, time, annotation),
													role))
										})),
								$elm$core$Platform$Cmd$none);
						} else {
							return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
						}
					} else {
						return _Utils_Tuple2(
							updateCurrentModel(
								_Utils_update(
									loadedModel,
									{
										selectedAnnot: $elm$core$Maybe$Nothing,
										status: $author$project$Type$CreateTemplate$Error('Unable to the get current time.')
									})),
							$elm$core$Platform$Cmd$none);
					}
				case 'OnReceiveClickAnnotData':
					var value = msg.a;
					var _v15 = loadedModel.selectedAnnot;
					if (_v15.$ === 'Just') {
						var _v16 = _v15.a;
						var annotation = _v16.a;
						var role = _v16.b;
						var result = A4($author$project$Data$PDF$CreateTemplate$addAnnotation, value, annotation, loadedModel.template, role);
						if (result.$ === 'Ok') {
							var _v18 = result.a;
							var updatedTemplate = _v18.a;
							var templateCmd = _v18.b;
							var updateModelAndCmd = _Utils_Tuple2(
								updateCurrentModel(
									_Utils_update(
										loadedModel,
										{
											annotFieldForm: _Utils_update(
												annotFieldForm,
												{status: $author$project$Type$CreateTemplate$NoSelectedFieldAnnot}),
											fieldError: $elm$core$Maybe$Nothing,
											selectedAnnot: $elm$core$Maybe$Nothing,
											template: updatedTemplate
										})),
								templateCmd);
							var _v19 = annotFieldForm.status;
							switch (_v19.$) {
								case 'PendingFieldForm':
									return _Utils_Tuple2(
										updateCurrentModel(
											_Utils_update(
												loadedModel,
												{
													status: $author$project$Type$CreateTemplate$Error($author$project$Model$CreateTemplate$formFieldError)
												})),
										$elm$core$Platform$Cmd$none);
								case 'FilledFieldForm':
									return updateModelAndCmd;
								case 'NoSelectedFieldAnnot':
									return updateModelAndCmd;
								default:
									return updateModelAndCmd;
							}
						} else {
							var err = result.a;
							return _Utils_Tuple2(
								updateCurrentModel(
									_Utils_update(
										loadedModel,
										{
											status: $author$project$Type$CreateTemplate$Error(err)
										})),
								$elm$core$Platform$Cmd$none);
						}
					} else {
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					}
				case 'OnReceiveModifiedAnnotData':
					var value = msg.a;
					var _v20 = $author$project$Data$PDF$CreateTemplate$decodeAnnotDataResult(value);
					if (_v20.$ === 'Ok') {
						var decodedAnnotList = _v20.a;
						var _v21 = A2($author$project$Data$PDF$CreateTemplate$updateAnnotations, decodedAnnotList, loadedModel.template);
						var updatedTemplate = _v21.a;
						var templateCmd = _v21.b;
						return _Utils_Tuple2(
							updateCurrentModel(
								_Utils_update(
									loadedModel,
									{
										lastStyle: A2($author$project$Model$CreateTemplate$updateLastStyle, decodedAnnotList, loadedModel.lastStyle),
										template: updatedTemplate
									})),
							templateCmd);
					} else {
						var err = _v20.a;
						return _Utils_Tuple2(
							updateCurrentModel(
								_Utils_update(
									loadedModel,
									{
										status: $author$project$Type$CreateTemplate$Error(err)
									})),
							$elm$core$Platform$Cmd$none);
					}
				case 'OnReceiveDeleteAnnotsData':
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				case 'OnFormNameInput':
					var value = msg.a;
					return _Utils_Tuple2(
						updateCurrentModel(
							_Utils_update(
								loadedModel,
								{
									annotFieldForm: _Utils_update(
										annotFieldForm,
										{name: value, nameError: $elm$core$Maybe$Nothing})
								})),
						$elm$core$Platform$Cmd$none);
				case 'OnFormNameBlur':
					return _Utils_Tuple2(
						updateCurrentModel(
							_Utils_update(
								loadedModel,
								{
									annotFieldForm: _Utils_update(
										annotFieldForm,
										{
											nameError: $author$project$Model$CreateTemplate$validateFieldFormName(annotFieldForm.name)
										})
								})),
						$elm$core$Platform$Cmd$none);
				case 'OnFormRequiredClick':
					return annotFieldForm.required ? _Utils_Tuple2(
						updateCurrentModel(
							_Utils_update(
								loadedModel,
								{
									annotFieldForm: _Utils_update(
										annotFieldForm,
										{required: false})
								})),
						$elm$core$Platform$Cmd$none) : _Utils_Tuple2(
						updateCurrentModel(
							_Utils_update(
								loadedModel,
								{
									annotFieldForm: _Utils_update(
										annotFieldForm,
										{required: true})
								})),
						$elm$core$Platform$Cmd$none);
				case 'OnFormSubmit':
					var _v22 = $author$project$Model$CreateTemplate$validateFieldFormName(annotFieldForm.name);
					if (_v22.$ === 'Just') {
						var error = _v22.a;
						return _Utils_Tuple2(
							updateCurrentModel(
								_Utils_update(
									loadedModel,
									{
										annotFieldForm: _Utils_update(
											annotFieldForm,
											{
												nameError: $elm$core$Maybe$Just(error)
											})
									})),
							$elm$core$Platform$Cmd$none);
					} else {
						var _v23 = loadedModel.selectedAnnot;
						if (_v23.$ === 'Just') {
							var _v24 = _v23.a;
							var annotation = _v24.a;
							var role = _v24.b;
							var updatedFieldAnnot = A3($author$project$Data$PDF$CreateTemplate$updateAnnotField, annotFieldForm.name, annotFieldForm.required, annotation);
							return _Utils_Tuple2(
								updateCurrentModel(
									_Utils_update(
										loadedModel,
										{
											annotFieldForm: _Utils_update(
												annotFieldForm,
												{name: '', status: $author$project$Type$CreateTemplate$FilledFieldForm}),
											selectedAnnot: $elm$core$Maybe$Just(
												_Utils_Tuple2(updatedFieldAnnot, role))
										})),
								$elm$core$Platform$Cmd$none);
						} else {
							return _Utils_Tuple2(
								updateCurrentModel(
									_Utils_update(
										loadedModel,
										{
											annotFieldForm: _Utils_update(
												annotFieldForm,
												{status: $author$project$Type$CreateTemplate$NoSelectedFieldAnnot})
										})),
								$elm$core$Platform$Cmd$none);
						}
					}
				case 'OnFormCancel':
					return _Utils_Tuple2(
						updateCurrentModel(
							_Utils_update(
								loadedModel,
								{
									annotFieldForm: _Utils_update(
										annotFieldForm,
										{name: '', nameError: $elm$core$Maybe$Nothing, required: true, status: $author$project$Type$CreateTemplate$NoSelectedFieldAnnot}),
									selectedAnnot: $elm$core$Maybe$Nothing
								})),
						$elm$core$Platform$Cmd$none);
				case 'OnTemplateSubmit':
					var _v25 = loadedModel;
					var title = _v25.title;
					var slug = _v25.slug;
					var template = _v25.template;
					var isPrivate = _v25.isPrivate;
					var numberOfRoles = $elm$core$List$length(
						A2(
							$elm$core$List$filter,
							function (r) {
								return !_Utils_eq(r.signOrder, -1);
							},
							$author$project$Data$PDF$CreateTemplate$getRoles(template)));
					var hasZeroRoleError = (!numberOfRoles) ? $elm$core$Maybe$Just('You must have at least 1 role for your template') : $elm$core$Maybe$Nothing;
					var urlSharingRoleError = function () {
						var _v27 = _Utils_Tuple2(slug, numberOfRoles > 1);
						if ((_v27.a.$ === 'Just') && _v27.b) {
							return $elm$core$Maybe$Just('You can only have 1 role when URL sharing is enabled');
						} else {
							return $elm$core$Maybe$Nothing;
						}
					}();
					var updatedLoadedModel = _Utils_update(
						loadedModel,
						{
							slugError: $author$project$Model$CreateTemplate$validateSlug(slug),
							template: A2(
								$author$project$Data$PDF$CreateTemplate$setIsPrivate,
								isPrivate,
								A2(
									$author$project$Data$PDF$CreateTemplate$setSlug,
									A2($elm$core$Maybe$withDefault, '', slug),
									A2($author$project$Data$PDF$CreateTemplate$setTitle, title, template))),
							titleError: $author$project$Model$CreateTemplate$validateTitle(title)
						});
					var errorList = _List_fromArray(
						[urlSharingRoleError, updatedLoadedModel.titleError, updatedLoadedModel.slugError, hasZeroRoleError]);
					var allFormPassed = A2(
						$elm$core$List$all,
						$elm$core$Basics$eq($elm$core$Maybe$Nothing),
						errorList);
					var rolesWithdoutSignature = $author$project$Data$PDF$CreateTemplate$getRolesWithoutSignatureField(updatedLoadedModel.template);
					var allRolesHaveSignature = $elm$core$List$isEmpty(rolesWithdoutSignature);
					var updatedTemplate = updatedLoadedModel.template;
					if (allFormPassed && allRolesHaveSignature) {
						return _Utils_Tuple2(
							updateCurrentModel(
								_Utils_update(
									loadedModel,
									{
										status: A2(
											$author$project$Type$CreateTemplate$Ready,
											updatedTemplate,
											$author$project$Data$PDF$CreateTemplate$file(updatedTemplate)),
										template: updatedTemplate
									})),
							$elm$core$Platform$Cmd$none);
					} else {
						if (!allRolesHaveSignature) {
							var errorText = 'Role(s) ' + (A2($elm$core$String$join, ', ', rolesWithdoutSignature) + ' are missing signature fields');
							return _Utils_Tuple2(
								updateCurrentModel(
									_Utils_update(
										loadedModel,
										{
											status: $author$project$Type$CreateTemplate$Error(errorText)
										})),
								$elm$core$Platform$Cmd$none);
						} else {
							var firstError = A2(
								$elm$core$Maybe$map,
								function (error) {
									if (error.$ === 'Just') {
										var errorString = error.a;
										return errorString;
									} else {
										return '';
									}
								},
								$elm$core$List$head(
									A2(
										$elm$core$List$filter,
										$elm$core$Basics$neq($elm$core$Maybe$Nothing),
										errorList)));
							return _Utils_Tuple2(
								updateCurrentModel(
									_Utils_update(
										loadedModel,
										{
											status: $author$project$Type$CreateTemplate$Error(
												A2($elm$core$Maybe$withDefault, 'There are errors with your template.', firstError))
										})),
								$elm$core$Platform$Cmd$none);
						}
					}
				case 'OnTemplateSubmitUpload':
					var template = msg.a;
					var file = msg.b;
					return _Utils_Tuple2(
						updateCurrentModel(
							_Utils_update(
								loadedModel,
								{
									status: A2($author$project$Type$CreateTemplate$Uploading, template, file)
								})),
						A2(
							$elm$core$Task$attempt,
							A2(
								$elm$core$Basics$composeL,
								A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnCreateTemplate),
								$author$project$Type$CreateTemplate$OnTemplateSubmitUploadResult),
							A5(
								$author$project$Data$Api$PDF$UploadTemplate$upload,
								authModel.user.jwt,
								model.apiEndPoint.uploadTemplate,
								$author$project$Data$Domain$toString(
									$author$project$Data$Domain$selected(authModel.user.domains)),
								template,
								file)));
				case 'OnTemplateSubmitUploadResult':
					var result = msg.a;
					if (result.$ === 'Ok') {
						return _Utils_Tuple2(
							updateCurrentModel(
								_Utils_update(
									loadedModel,
									{status: $author$project$Type$CreateTemplate$Success})),
							$elm$core$Platform$Cmd$none);
					} else {
						var err = result.a;
						return _Utils_Tuple2(
							updateCurrentModel(
								_Utils_update(
									loadedModel,
									{
										status: $author$project$Type$CreateTemplate$Error(
											A2($author$project$Data$Api$authErrorToString, $author$project$Data$Api$PDF$UploadTemplate$errorToString, err))
									})),
							$elm$core$Platform$Cmd$none);
					}
				case 'OnTemplateSubmitClose':
					return _Utils_Tuple2(
						updateCurrentModel(
							_Utils_update(
								loadedModel,
								{status: $author$project$Type$CreateTemplate$Editing})),
						$elm$core$Platform$Cmd$none);
				case 'OnTemplateSuccessClose':
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								sessionModel: $author$project$Types$Auth(
									_Utils_update(
										authModel,
										{
											newTemplateModel: {base64File: $elm$core$Maybe$Nothing, error: $elm$core$Maybe$Nothing, file: $elm$core$Maybe$Nothing, fileHover: false, templateQuota: 0, templatesUsed: 0, toolTipHover: false}
										}))
							}),
						A2($elm$browser$Browser$Navigation$replaceUrl, model.navKey, $author$project$Data$Route$routeUrl.dashboard));
				case 'OnCompletedOfficeConversion':
					var doc = msg.a;
					var _v29 = $author$project$Data$PDF$decodeConvertedPDF(doc);
					if (_v29.$ === 'Ok') {
						var result = _v29.a;
						return _Utils_Tuple2(
							updateCurrentModel(
								_Utils_update(
									loadedModel,
									{
										template: A3($author$project$Data$PDF$CreateTemplate$setBase64FileData, result.base64data, result.file, loadedModel.template)
									})),
							$elm$core$Platform$Cmd$none);
					} else {
						return _Utils_Tuple2(
							updateCurrentModel(
								_Utils_update(
									loadedModel,
									{status: $author$project$Type$CreateTemplate$ConversionError})),
							$elm$core$Platform$Cmd$none);
					}
				case 'OnDocLoaded':
					return _Utils_Tuple2(
						updateCurrentModel(
							_Utils_update(
								loadedModel,
								{status: $author$project$Type$CreateTemplate$Editing})),
						$elm$core$Platform$Cmd$none);
				case 'OnDocConversionErrorRedirect':
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								sessionModel: $author$project$Types$Auth(
									_Utils_update(
										authModel,
										{
											newTemplateModel: {base64File: $elm$core$Maybe$Nothing, error: $elm$core$Maybe$Nothing, file: $elm$core$Maybe$Nothing, fileHover: false, templateQuota: 0, templatesUsed: 0, toolTipHover: false}
										}))
							}),
						A2($elm$browser$Browser$Navigation$replaceUrl, model.navKey, $author$project$Data$Route$routeUrl.dashboard));
				case 'OnUpdateRoleDetails':
					var inputType = msg.a;
					var value = msg.b;
					var _v30 = _Utils_Tuple2(addRole.roleDetails, inputType);
					_v30$0:
					while (true) {
						if (_v30.a.$ === 'Just') {
							switch (_v30.b.$) {
								case 'Name':
									break _v30$0;
								case 'Email':
									var roleDetails = _v30.a.a;
									var _v32 = _v30.b;
									return _Utils_Tuple2(
										updateAddRoleDetails(
											$elm$core$Maybe$Just(
												_Utils_update(
													roleDetails,
													{email: value}))),
										$elm$core$Platform$Cmd$none);
								case 'FirstName':
									var roleDetails = _v30.a.a;
									var _v33 = _v30.b;
									return _Utils_Tuple2(
										updateAddRoleDetails(
											$elm$core$Maybe$Just(
												_Utils_update(
													roleDetails,
													{firstName: value}))),
										$elm$core$Platform$Cmd$none);
								case 'LastName':
									var roleDetails = _v30.a.a;
									var _v34 = _v30.b;
									return _Utils_Tuple2(
										updateAddRoleDetails(
											$elm$core$Maybe$Just(
												_Utils_update(
													roleDetails,
													{lastName: value}))),
										$elm$core$Platform$Cmd$none);
								default:
									var roleDetails = _v30.a.a;
									var _v35 = _v30.b;
									return _Utils_Tuple2(
										updateAddRoleDetails(
											$elm$core$Maybe$Just(
												_Utils_update(
													roleDetails,
													{search: value}))),
										$author$project$Model$UploadMultipleDocument$startDebounceTime(
											$elm$json$Json$Encode$string('CreateTemplate')));
							}
						} else {
							if (_v30.b.$ === 'Name') {
								break _v30$0;
							} else {
								var _v36 = _v30.a;
								return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
							}
						}
					}
					var _v31 = _v30.b;
					return ($elm$core$String$length(value) > 50) ? _Utils_Tuple2(model, $elm$core$Platform$Cmd$none) : _Utils_Tuple2(
						updateAddRole(
							_Utils_update(
								addRole,
								{name: value})),
						$elm$core$Platform$Cmd$none);
				case 'GoToStage':
					var stage = msg.a;
					var _v37 = loadedModel.stage;
					switch (_v37.$) {
						case 'DocumentTitle':
							return A2(
								$elm$core$List$all,
								$elm$core$Basics$eq($elm$core$Maybe$Nothing),
								_List_fromArray(
									[
										loadedModel.titleError,
										loadedModel.slugError,
										$author$project$Model$CreateTemplate$validateSlug(loadedModel.slug)
									])) ? _Utils_Tuple2(
								updateCurrentModel(
									_Utils_update(
										loadedModel,
										{stage: stage})),
								$elm$core$Platform$Cmd$none) : _Utils_Tuple2(
								updateCurrentModel(
									_Utils_update(
										loadedModel,
										{
											slugError: $author$project$Model$CreateTemplate$validateSlug(loadedModel.slug)
										})),
								$elm$core$Platform$Cmd$none);
						case 'Roles':
							var roleNumberError = function () {
								var _v38 = _Utils_Tuple2(
									loadedModel.slug,
									$elm$core$List$isEmpty(
										A2(
											$elm$core$List$filter,
											function (r) {
												return !_Utils_eq(r.signOrder, -1);
											},
											$author$project$Data$PDF$CreateTemplate$getRoles(loadedModel.template))));
								if (!_v38.b) {
									if (_v38.a.$ === 'Just') {
										return ($elm$core$List$length(
											A2(
												$elm$core$List$filter,
												function (r) {
													return !_Utils_eq(r.signOrder, -1);
												},
												$author$project$Data$PDF$CreateTemplate$getRoles(loadedModel.template))) > 1) ? $elm$core$Maybe$Just('You can only have 1 role when URL sharing is enabled') : $elm$core$Maybe$Nothing;
									} else {
										return $elm$core$Maybe$Nothing;
									}
								} else {
									return $elm$core$Maybe$Just('Must have at least 1 role');
								}
							}();
							return _Utils_eq(roleNumberError, $elm$core$Maybe$Nothing) ? _Utils_Tuple2(
								updateCurrentModel(
									_Utils_update(
										loadedModel,
										{
											addRole: _Utils_update(
												addRole,
												{addRoleError: roleNumberError}),
											stage: stage
										})),
								$elm$core$Platform$Cmd$none) : _Utils_Tuple2(
								updateCurrentModel(
									_Utils_update(
										loadedModel,
										{
											addRole: _Utils_update(
												addRole,
												{addRoleError: roleNumberError})
										})),
								$elm$core$Platform$Cmd$none);
						case 'Fields':
							var rolesWithdoutSignature = $author$project$Data$PDF$CreateTemplate$getRolesWithoutSignatureField(loadedModel.template);
							var allRolesHaveSignature = $elm$core$List$isEmpty(rolesWithdoutSignature);
							if (allRolesHaveSignature) {
								return _Utils_Tuple2(
									updateCurrentModel(
										_Utils_update(
											loadedModel,
											{fieldError: $elm$core$Maybe$Nothing, stage: stage})),
									$elm$core$Platform$Cmd$none);
							} else {
								var errorText = 'Role(s) ' + (A2($elm$core$String$join, ', ', rolesWithdoutSignature) + ' are missing signature fields');
								return _Utils_Tuple2(
									updateCurrentModel(
										_Utils_update(
											loadedModel,
											{
												fieldError: $elm$core$Maybe$Just(errorText)
											})),
									$elm$core$Platform$Cmd$none);
							}
						default:
							return _Utils_Tuple2(
								updateCurrentModel(
									_Utils_update(
										loadedModel,
										{stage: stage})),
								$elm$core$Platform$Cmd$none);
					}
				case 'OnCheckBoxClick':
					var location = msg.a;
					switch (location.$) {
						case 'Role':
							return (_Utils_eq(loadedModel.addRole.roleDetails, $elm$core$Maybe$Nothing) && _Utils_eq(location, $author$project$Type$CreateTemplate$Role)) ? _Utils_Tuple2(
								updateCurrentModel(
									_Utils_update(
										loadedModel,
										{
											addRole: _Utils_update(
												addRole,
												{
													name: addRole.name,
													nameError: $elm$core$Maybe$Nothing,
													roleDetails: $elm$core$Maybe$Just(
														{email: '', emailError: $elm$core$Maybe$Nothing, firstName: '', firstNameError: $elm$core$Maybe$Nothing, lastName: '', lastNameError: $elm$core$Maybe$Nothing, search: '', searchResult: $elm$core$Maybe$Nothing})
												}),
											checkboxLocation: location
										})),
								$elm$core$Platform$Cmd$none) : _Utils_Tuple2(
								updateCurrentModel(
									_Utils_update(
										loadedModel,
										{
											addRole: _Utils_update(
												addRole,
												{name: addRole.name, nameError: $elm$core$Maybe$Nothing, roleDetails: $elm$core$Maybe$Nothing}),
											checkboxLocation: $author$project$Type$CreateTemplate$None
										})),
								$elm$core$Platform$Cmd$none);
						case 'Viewer':
							return (_Utils_eq(loadedModel.addRole.roleDetails, $elm$core$Maybe$Nothing) && _Utils_eq(location, $author$project$Type$CreateTemplate$Viewer)) ? _Utils_Tuple2(
								updateCurrentModel(
									_Utils_update(
										loadedModel,
										{
											addRole: _Utils_update(
												addRole,
												{
													name: 'Viewer',
													nameError: $elm$core$Maybe$Nothing,
													roleDetails: $elm$core$Maybe$Just(
														{email: '', emailError: $elm$core$Maybe$Nothing, firstName: '', firstNameError: $elm$core$Maybe$Nothing, lastName: '', lastNameError: $elm$core$Maybe$Nothing, search: '', searchResult: $elm$core$Maybe$Nothing})
												}),
											checkboxLocation: location
										})),
								$elm$core$Platform$Cmd$none) : _Utils_Tuple2(
								updateCurrentModel(
									_Utils_update(
										loadedModel,
										{
											addRole: _Utils_update(
												addRole,
												{name: '', nameError: $elm$core$Maybe$Nothing, roleDetails: $elm$core$Maybe$Nothing}),
											checkboxLocation: $author$project$Type$CreateTemplate$None
										})),
								$elm$core$Platform$Cmd$none);
						default:
							return _Utils_Tuple2(
								updateCurrentModel(
									_Utils_update(
										loadedModel,
										{
											addRole: _Utils_update(
												addRole,
												{name: '', nameError: $elm$core$Maybe$Nothing, roleDetails: $elm$core$Maybe$Nothing}),
											checkboxLocation: $author$project$Type$CreateTemplate$None
										})),
								$elm$core$Platform$Cmd$none);
					}
				case 'OnClearRecipientFields':
					return _Utils_Tuple2(
						updateCurrentModel(
							_Utils_update(
								loadedModel,
								{
									addRole: _Utils_update(
										addRole,
										{name: '', nameError: $elm$core$Maybe$Nothing, roleDetails: $elm$core$Maybe$Nothing})
								})),
						$elm$core$Platform$Cmd$none);
				case 'OnRecipientAddSubmit':
					var sharingURLError = function () {
						var numberOfRoles = $elm$core$List$length(
							A2(
								$elm$core$List$filter,
								function (r) {
									return !_Utils_eq(r.signOrder, -1);
								},
								$author$project$Data$PDF$CreateTemplate$getRoles(loadedModel.template)));
						var _v43 = _Utils_Tuple2(
							loadedModel.slug,
							(numberOfRoles >= 1) && (!_Utils_eq(loadedModel.checkboxLocation, $author$project$Type$CreateTemplate$Viewer)));
						if ((_v43.a.$ === 'Just') && _v43.b) {
							return $elm$core$Maybe$Just('For URL sharing, you can only have 1 role');
						} else {
							return $elm$core$Maybe$Nothing;
						}
					}();
					var addingViewer = _Utils_eq(loadedModel.checkboxLocation, $author$project$Type$CreateTemplate$Viewer);
					var addedRole = addingViewer ? 'Viewer' : loadedModel.addRole.name;
					var isRoleNameEmpty = $elm$core$String$isEmpty(
						$elm$core$String$trim(addedRole)) ? $elm$core$Maybe$Just('Role name cannot be empty') : $elm$core$Maybe$Nothing;
					var _v40 = function () {
						var _v41 = loadedModel.addRole.roleDetails;
						if (_v41.$ === 'Just') {
							var email = _v41.a.email;
							var firstName = _v41.a.firstName;
							var lastName = _v41.a.lastName;
							var emailError = _v41.a.emailError;
							var firstNameError = _v41.a.firstNameError;
							var lastNameError = _v41.a.lastNameError;
							return _Utils_Tuple2(
								A6(
									$author$project$Data$PDF$CreateTemplate$addRecipient,
									$elm$core$Maybe$Just(email),
									$elm$core$Maybe$Just(firstName),
									$elm$core$Maybe$Just(lastName),
									addedRole,
									loadedModel.template,
									addingViewer),
								_List_fromArray(
									[emailError, firstNameError, lastNameError, loadedModel.addRole.nameError]));
						} else {
							return _Utils_Tuple2(
								A6($author$project$Data$PDF$CreateTemplate$addRecipient, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing, loadedModel.addRole.name, loadedModel.template, false),
								_List_fromArray(
									[loadedModel.addRole.nameError]));
						}
					}();
					var newTemplate = _v40.a;
					var roleErrors = _v40.b;
					var allPassed = A2(
						$elm$core$List$all,
						$elm$core$Basics$eq($elm$core$Maybe$Nothing),
						_Utils_ap(
							_List_fromArray(
								[sharingURLError, isRoleNameEmpty]),
							roleErrors));
					var firstError = A2(
						$elm$core$Maybe$map,
						function (error) {
							if (error.$ === 'Just') {
								var errorString = error.a;
								return errorString;
							} else {
								return '';
							}
						},
						$elm$core$List$head(
							A2(
								$elm$core$List$filter,
								$elm$core$Basics$neq($elm$core$Maybe$Nothing),
								A2($elm$core$List$cons, sharingURLError, roleErrors))));
					return allPassed ? _Utils_Tuple2(
						updateCurrentModel(
							_Utils_update(
								loadedModel,
								{
									addRole: {addRoleError: $elm$core$Maybe$Nothing, name: '', nameError: $elm$core$Maybe$Nothing, roleDetails: $elm$core$Maybe$Nothing},
									checkboxLocation: $author$project$Type$CreateTemplate$None,
									template: newTemplate
								})),
						$elm$core$Platform$Cmd$none) : _Utils_Tuple2(
						updateCurrentModel(
							_Utils_update(
								loadedModel,
								{
									addRole: _Utils_update(
										addRole,
										{addRoleError: firstError})
								})),
						$elm$core$Platform$Cmd$none);
				case 'OnAddRecipientBlur':
					var location = msg.a;
					var roleList = $author$project$Data$PDF$CreateTemplate$getRoles(loadedModel.template);
					var isEmailDuplicate = function (value) {
						return A2(
							$elm$core$List$any,
							function (r) {
								return _Utils_eq(
									r.email,
									$elm$core$Maybe$Just(value));
							},
							roleList);
					};
					var duplicateError = function (value) {
						return isEmailDuplicate(value) ? $elm$core$Maybe$Just('Email already added as recipient or viewer.') : $elm$core$Maybe$Nothing;
					};
					var _v44 = _Utils_Tuple2(addRole.roleDetails, location);
					_v44$0:
					while (true) {
						if (_v44.a.$ === 'Just') {
							switch (_v44.b.$) {
								case 'Name':
									break _v44$0;
								case 'Email':
									var roleDetails = _v44.a.a;
									var _v46 = _v44.b;
									return isEmailDuplicate(roleDetails.email) ? _Utils_Tuple2(
										updateAddRoleDetails(
											$elm$core$Maybe$Just(
												_Utils_update(
													roleDetails,
													{
														emailError: duplicateError(roleDetails.email)
													}))),
										$elm$core$Platform$Cmd$none) : _Utils_Tuple2(
										updateAddRoleDetails(
											$elm$core$Maybe$Just(
												_Utils_update(
													roleDetails,
													{
														emailError: $author$project$Data$Validator$validateEmail(roleDetails.email)
													}))),
										$elm$core$Platform$Cmd$none);
								case 'FirstName':
									var roleDetails = _v44.a.a;
									var _v47 = _v44.b;
									return _Utils_Tuple2(
										updateAddRoleDetails(
											$elm$core$Maybe$Just(
												_Utils_update(
													roleDetails,
													{
														firstNameError: $author$project$Model$CreateTemplate$validateName(roleDetails.firstName)
													}))),
										$elm$core$Platform$Cmd$none);
								case 'LastName':
									var roleDetails = _v44.a.a;
									var _v48 = _v44.b;
									return _Utils_Tuple2(
										updateAddRoleDetails(
											$elm$core$Maybe$Just(
												_Utils_update(
													roleDetails,
													{
														lastNameError: $author$project$Model$CreateTemplate$validateName(roleDetails.lastName)
													}))),
										$elm$core$Platform$Cmd$none);
								default:
									var _v49 = _v44.b;
									return _Utils_Tuple2(
										model,
										$author$project$Model$UploadMultipleDocument$startBlurTime(
											$elm$json$Json$Encode$string('CreateTemplate')));
							}
						} else {
							if (_v44.b.$ === 'Name') {
								break _v44$0;
							} else {
								var _v50 = _v44.a;
								return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
							}
						}
					}
					var _v45 = _v44.b;
					return _Utils_Tuple2(
						updateAddRole(
							_Utils_update(
								addRole,
								{
									nameError: $author$project$Model$CreateTemplate$validateRole(addRole.name)
								})),
						$elm$core$Platform$Cmd$none);
				case 'OnRemoveRecipient':
					var role = msg.a;
					var _v51 = A2($author$project$Data$PDF$CreateTemplate$removeRecipient, role, loadedModel.template);
					var newTemplate = _v51.a;
					var cmdMsg = _v51.b;
					return _Utils_Tuple2(
						updateCurrentModel(
							_Utils_update(
								loadedModel,
								{
									addRole: _Utils_update(
										addRole,
										{addRoleError: $elm$core$Maybe$Nothing}),
									template: newTemplate
								})),
						cmdMsg);
				case 'OnSignOrderClick':
					var _v52 = loadedModel.signOrder;
					if (_v52.$ === 'Enabled') {
						return _Utils_Tuple2(
							updateCurrentModel(
								_Utils_update(
									loadedModel,
									{
										signOrder: $author$project$Type$CreateTemplate$Disabled,
										template: $author$project$Data$PDF$CreateTemplate$removeSignOrder(loadedModel.template)
									})),
							$elm$core$Platform$Cmd$none);
					} else {
						return _Utils_Tuple2(
							updateCurrentModel(
								_Utils_update(
									loadedModel,
									{
										signOrder: $author$project$Type$CreateTemplate$Enabled,
										template: $author$project$Data$PDF$CreateTemplate$addNewSignOrder(loadedModel.template)
									})),
							$elm$core$Platform$Cmd$none);
					}
				case 'OnSigningOrderInput':
					var role = msg.a;
					var value = msg.b;
					var _v53 = loadedModel.signOrder;
					if (_v53.$ === 'Enabled') {
						return _Utils_Tuple2(
							updateCurrentModel(
								_Utils_update(
									loadedModel,
									{
										template: A3(
											$author$project$Data$PDF$CreateTemplate$updateSignOrder,
											role,
											A2(
												$elm$core$Maybe$withDefault,
												1,
												$elm$core$String$toInt(value)),
											loadedModel.template)
									})),
							A2(
								$elm$core$Task$attempt,
								function (_v54) {
									return $author$project$Types$Noop;
								},
								$elm$browser$Browser$Dom$focus('signOrder' + role)));
					} else {
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					}
				case 'OnToolTipHover':
					var location = msg.a;
					return _Utils_Tuple2(
						updateCurrentModel(
							_Utils_update(
								loadedModel,
								{toolTipActiveHover: location})),
						$elm$core$Platform$Cmd$none);
				case 'OnSearchDebounce':
					var _v55 = addRole.roleDetails;
					if (_v55.$ === 'Just') {
						var roleDetails = _v55.a;
						return $elm$core$String$isEmpty(roleDetails.search) ? _Utils_Tuple2(
							updateAddRoleDetails(
								$elm$core$Maybe$Just(
									_Utils_update(
										roleDetails,
										{searchResult: $elm$core$Maybe$Nothing}))),
							$elm$core$Platform$Cmd$none) : _Utils_Tuple2(
							model,
							A2(
								$elm$core$Task$attempt,
								A2(
									$elm$core$Basics$composeL,
									A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnCreateTemplate),
									$author$project$Type$CreateTemplate$OnSearchApiResult),
								A3($author$project$Data$Api$AddressBookAutocomplete$authCall, authModel.user.jwt, model.apiEndPoint.addressBookAutocomplete, roleDetails.search)));
					} else {
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					}
				case 'OnSearchApiResult':
					var response = msg.a;
					var _v56 = _Utils_Tuple2(response, addRole.roleDetails);
					if ((_v56.a.$ === 'Ok') && (_v56.b.$ === 'Just')) {
						var result = _v56.a.a;
						var roleDetails = _v56.b.a;
						var searchResult = $elm$core$List$isEmpty(result.contacts) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(result.contacts);
						return _Utils_Tuple2(
							updateAddRoleDetails(
								$elm$core$Maybe$Just(
									_Utils_update(
										roleDetails,
										{searchResult: searchResult}))),
							$elm$core$Platform$Cmd$none);
					} else {
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					}
				case 'OnAutocompleteClick':
					var contact = msg.a;
					var roleList = $author$project$Data$PDF$CreateTemplate$getRoles(loadedModel.template);
					var isEmailDuplicate = function (value) {
						return A2(
							$elm$core$List$any,
							function (r) {
								return _Utils_eq(
									r.email,
									$elm$core$Maybe$Just(value));
							},
							roleList);
					};
					var duplicateError = function (value) {
						return isEmailDuplicate(value) ? $elm$core$Maybe$Just('Email already added as recipient or viewer.') : $elm$core$Maybe$Nothing;
					};
					var _v57 = addRole.roleDetails;
					if (_v57.$ === 'Just') {
						var roleDetails = _v57.a;
						return _Utils_Tuple2(
							updateAddRoleDetails(
								$elm$core$Maybe$Just(
									_Utils_update(
										roleDetails,
										{
											email: contact.email,
											emailError: duplicateError(contact.email),
											firstName: contact.firstName,
											firstNameError: $elm$core$Maybe$Nothing,
											lastName: contact.lastName,
											lastNameError: $elm$core$Maybe$Nothing,
											searchResult: $elm$core$Maybe$Nothing
										}))),
							$elm$core$Platform$Cmd$none);
					} else {
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					}
				case 'OnSearchFieldBlur':
					var _v58 = addRole.roleDetails;
					if (_v58.$ === 'Just') {
						var roleDetails = _v58.a;
						return _Utils_Tuple2(
							updateAddRoleDetails(
								$elm$core$Maybe$Just(
									_Utils_update(
										roleDetails,
										{searchResult: $elm$core$Maybe$Nothing}))),
							$elm$core$Platform$Cmd$none);
					} else {
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					}
				case 'OnReceiveSelectedTemplateAnnotClickData':
					var value = msg.a;
					var _v59 = $author$project$Data$PDF$Port$decodeClickedAnnotData(value);
					if (_v59.$ === 'Ok') {
						var result = _v59.a;
						return _Utils_Tuple2(
							updateCurrentModel(
								_Utils_update(
									loadedModel,
									{
										selectedAnnotForDeletion: $elm$core$Maybe$Just(result.id)
									})),
							$elm$core$Platform$Cmd$none);
					} else {
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					}
				case 'OnDeselectedTemplateAnnotData':
					return _Utils_Tuple2(
						updateCurrentModel(
							_Utils_update(
								loadedModel,
								{selectedAnnotForDeletion: $elm$core$Maybe$Nothing})),
						$elm$core$Platform$Cmd$none);
				case 'OnReceiveDeleteSelectedAnnot':
					var _v60 = A2(
						$author$project$Data$PDF$CreateTemplate$deleteAnnotation,
						A2($elm$core$Maybe$withDefault, '', loadedModel.selectedAnnotForDeletion),
						loadedModel.template);
					var updatedTemplate = _v60.a;
					var cmdMsg = _v60.b;
					return _Utils_Tuple2(
						updateCurrentModel(
							_Utils_update(
								loadedModel,
								{template: updatedTemplate})),
						cmdMsg);
				case 'OnDeleteAnnotClick':
					var _v61 = A2(
						$author$project$Data$PDF$CreateTemplate$deleteAnnotation,
						A2($elm$core$Maybe$withDefault, '', loadedModel.selectedAnnotForDeletion),
						loadedModel.template);
					var updatedTemplate = _v61.a;
					var cmdMsg = _v61.b;
					return _Utils_Tuple2(
						updateCurrentModel(
							_Utils_update(
								loadedModel,
								{template: updatedTemplate})),
						cmdMsg);
				default:
					var updatedFontSize = msg.a;
					return _Utils_Tuple2(
						updateCurrentModel(
							_Utils_update(
								loadedModel,
								{fontSize: updatedFontSize})),
						A2($author$project$Data$PDF$CreateTemplate$updateAnnotationFontSize, loadedModel.fontSize, loadedModel.template));
			}
		}
	});
var $author$project$Type$Dashboard$Error = {$: 'Error'};
var $author$project$Type$Dashboard$Hover = function (a) {
	return {$: 'Hover', a: a};
};
var $author$project$Type$Dashboard$Loaded = {$: 'Loaded'};
var $author$project$Type$Dashboard$OnCompletedDocsResponse = function (a) {
	return {$: 'OnCompletedDocsResponse', a: a};
};
var $author$project$Type$Dashboard$OnIncomingDocsResponse = function (a) {
	return {$: 'OnIncomingDocsResponse', a: a};
};
var $author$project$Type$Dashboard$OnOutgoingDocsResponse = function (a) {
	return {$: 'OnOutgoingDocsResponse', a: a};
};
var $author$project$Type$Dashboard$OnPointsResponse = function (a) {
	return {$: 'OnPointsResponse', a: a};
};
var $author$project$Type$Dashboard$OnRewardsClick = {$: 'OnRewardsClick'};
var $author$project$Type$Dashboard$OnTrustScoreClick = {$: 'OnTrustScoreClick'};
var $author$project$Data$Api$Dashboard$CompletedDocument$Payload = F2(
	function (completedDocs, totalNoOfPages) {
		return {completedDocs: completedDocs, totalNoOfPages: totalNoOfPages};
	});
var $author$project$Data$Api$Dashboard$CompletedDocument$Document = F6(
	function (id, title, ownerName, createdAt, updatedAt, recipients) {
		return {createdAt: createdAt, id: id, ownerName: ownerName, recipients: recipients, title: title, updatedAt: updatedAt};
	});
var $author$project$Data$Api$Dashboard$CompletedDocument$decodeDocument = A7(
	$elm$json$Json$Decode$map6,
	$author$project$Data$Api$Dashboard$CompletedDocument$Document,
	A2($elm$json$Json$Decode$field, 'id', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'title', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'ownerName', $elm$json$Json$Decode$string),
	A2(
		$elm$json$Json$Decode$field,
		'createdAt',
		A2($elm$json$Json$Decode$map, $elm$time$Time$millisToPosix, $elm$json$Json$Decode$int)),
	A2(
		$elm$json$Json$Decode$field,
		'updatedAt',
		A2($elm$json$Json$Decode$map, $elm$time$Time$millisToPosix, $elm$json$Json$Decode$int)),
	A2($elm$json$Json$Decode$field, 'recipients', $elm$json$Json$Decode$string));
var $author$project$Data$Api$Dashboard$CompletedDocument$dataDecoder = A3(
	$elm$json$Json$Decode$map2,
	$author$project$Data$Api$Dashboard$CompletedDocument$Payload,
	A2(
		$elm$json$Json$Decode$field,
		'completedDocs',
		$elm$json$Json$Decode$list($author$project$Data$Api$Dashboard$CompletedDocument$decodeDocument)),
	A2($elm$json$Json$Decode$field, 'totalNoOfPages', $elm$json$Json$Decode$int));
var $author$project$Data$Api$Dashboard$CompletedDocument$errorDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (errorCode) {
		return $elm$json$Json$Decode$fail('Error ' + errorCode);
	},
	$elm$json$Json$Decode$string);
var $author$project$Data$Api$Dashboard$CompletedDocument$authCall = F3(
	function (jwt, endPoint, domain) {
		return A5(
			$author$project$Data$Api$authCall,
			jwt,
			endPoint,
			$author$project$Data$Api$Dashboard$CompletedDocument$errorDecoder,
			$author$project$Data$Api$Dashboard$CompletedDocument$dataDecoder,
			$elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'domain',
						$elm$json$Json$Encode$string(
							$author$project$Data$Domain$toString(domain)))
					])));
	});
var $author$project$Data$Api$Dashboard$IncomingDocuments$Payload = F2(
	function (incomingDocs, incomingDocsNum) {
		return {incomingDocs: incomingDocs, incomingDocsNum: incomingDocsNum};
	});
var $author$project$Data$Api$Dashboard$IncomingDocuments$Document = F5(
	function (id, title, ownerName, recipients, createdAt) {
		return {createdAt: createdAt, id: id, ownerName: ownerName, recipients: recipients, title: title};
	});
var $author$project$Data$Api$Dashboard$IncomingDocuments$decodeDocument = A6(
	$elm$json$Json$Decode$map5,
	$author$project$Data$Api$Dashboard$IncomingDocuments$Document,
	A2($elm$json$Json$Decode$field, 'id', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'title', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'ownerName', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'recipients', $elm$json$Json$Decode$string),
	A2(
		$elm$json$Json$Decode$field,
		'createdAt',
		A2($elm$json$Json$Decode$map, $elm$time$Time$millisToPosix, $elm$json$Json$Decode$int)));
var $author$project$Data$Api$Dashboard$IncomingDocuments$dataDecoder = A3(
	$elm$json$Json$Decode$map2,
	$author$project$Data$Api$Dashboard$IncomingDocuments$Payload,
	A2(
		$elm$json$Json$Decode$field,
		'incomingDocs',
		$elm$json$Json$Decode$list($author$project$Data$Api$Dashboard$IncomingDocuments$decodeDocument)),
	A2($elm$json$Json$Decode$field, 'incomingDocsNum', $elm$json$Json$Decode$int));
var $author$project$Data$Api$Dashboard$IncomingDocuments$errorDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (errorCode) {
		return $elm$json$Json$Decode$fail('Error ' + errorCode);
	},
	$elm$json$Json$Decode$string);
var $author$project$Data$Api$Dashboard$IncomingDocuments$authCall = F3(
	function (jwt, endPoint, domain) {
		return A5(
			$author$project$Data$Api$authCall,
			jwt,
			endPoint,
			$author$project$Data$Api$Dashboard$IncomingDocuments$errorDecoder,
			$author$project$Data$Api$Dashboard$IncomingDocuments$dataDecoder,
			$elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'domain',
						$elm$json$Json$Encode$string(
							$author$project$Data$Domain$toString(domain)))
					])));
	});
var $author$project$Data$Api$Dashboard$OutgoingDocuments$Payload = F2(
	function (outgoingDocs, totalDocsSent) {
		return {outgoingDocs: outgoingDocs, totalDocsSent: totalDocsSent};
	});
var $author$project$Data$Api$Dashboard$OutgoingDocuments$Document = F5(
	function (id, title, ownerName, recipients, createdAt) {
		return {createdAt: createdAt, id: id, ownerName: ownerName, recipients: recipients, title: title};
	});
var $author$project$Data$Api$Dashboard$OutgoingDocuments$decodeDocument = A6(
	$elm$json$Json$Decode$map5,
	$author$project$Data$Api$Dashboard$OutgoingDocuments$Document,
	A2($elm$json$Json$Decode$field, 'id', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'title', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'ownerName', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'recipients', $elm$json$Json$Decode$string),
	A2(
		$elm$json$Json$Decode$field,
		'createdAt',
		A2($elm$json$Json$Decode$map, $elm$time$Time$millisToPosix, $elm$json$Json$Decode$int)));
var $author$project$Data$Api$Dashboard$OutgoingDocuments$dataDecoder = A3(
	$elm$json$Json$Decode$map2,
	$author$project$Data$Api$Dashboard$OutgoingDocuments$Payload,
	A2(
		$elm$json$Json$Decode$field,
		'outgoingDocs',
		$elm$json$Json$Decode$list($author$project$Data$Api$Dashboard$OutgoingDocuments$decodeDocument)),
	A2($elm$json$Json$Decode$field, 'totalDocsSent', $elm$json$Json$Decode$int));
var $author$project$Data$Api$Dashboard$OutgoingDocuments$errorDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (errorCode) {
		return $elm$json$Json$Decode$fail('Error ' + errorCode);
	},
	$elm$json$Json$Decode$string);
var $author$project$Data$Api$Dashboard$OutgoingDocuments$authCall = F3(
	function (jwt, endPoint, domain) {
		return A5(
			$author$project$Data$Api$authCall,
			jwt,
			endPoint,
			$author$project$Data$Api$Dashboard$OutgoingDocuments$errorDecoder,
			$author$project$Data$Api$Dashboard$OutgoingDocuments$dataDecoder,
			$elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'domain',
						$elm$json$Json$Encode$string(
							$author$project$Data$Domain$toString(domain)))
					])));
	});
var $author$project$Data$Api$Dashboard$Points$Payload = function (points) {
	return {points: points};
};
var $author$project$Data$Api$Dashboard$Points$dataDecoder = A2(
	$elm$json$Json$Decode$map,
	$author$project$Data$Api$Dashboard$Points$Payload,
	A2($elm$json$Json$Decode$field, 'points', $elm$json$Json$Decode$float));
var $author$project$Data$Api$Dashboard$Points$errorDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (errorCode) {
		return $elm$json$Json$Decode$fail('Error ' + errorCode);
	},
	$elm$json$Json$Decode$string);
var $author$project$Data$Api$Dashboard$Points$authCall = F3(
	function (jwt, endPoint, domain) {
		return A5(
			$author$project$Data$Api$authCall,
			jwt,
			endPoint,
			$author$project$Data$Api$Dashboard$Points$errorDecoder,
			$author$project$Data$Api$Dashboard$Points$dataDecoder,
			$elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'domain',
						$elm$json$Json$Encode$string(
							$author$project$Data$Domain$toString(domain)))
					])));
	});
var $author$project$Model$Dashboard$displayDashboardAdsContent = _Platform_outgoingPort('displayDashboardAdsContent', $elm$core$Basics$identity);
var $author$project$Model$Dashboard$update = F3(
	function (msg, authModel, model) {
		var _v0 = authModel;
		var dashboardModel = _v0.dashboardModel;
		var user = _v0.user;
		var _v1 = model;
		var apiEndPoint = _v1.apiEndPoint;
		switch (msg.$) {
			case 'OnDocClick':
				var id = msg.a;
				return _Utils_Tuple2(
					model,
					A2(
						$elm$browser$Browser$Navigation$pushUrl,
						model.navKey,
						_Utils_ap($author$project$Data$Route$routeUrl.viewDocument, id)));
			case 'OnPageEnter':
				return _Utils_Tuple2(
					model,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2(
								$elm$core$Task$attempt,
								A2(
									$elm$core$Basics$composeL,
									A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnDashboard),
									$author$project$Type$Dashboard$OnIncomingDocsResponse),
								A3(
									$author$project$Data$Api$Dashboard$IncomingDocuments$authCall,
									user.jwt,
									apiEndPoint.dashboardIncomingDocs,
									$author$project$Data$Domain$selected(user.domains))),
								A2(
								$elm$core$Task$attempt,
								A2(
									$elm$core$Basics$composeL,
									A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnDashboard),
									$author$project$Type$Dashboard$OnOutgoingDocsResponse),
								A3(
									$author$project$Data$Api$Dashboard$OutgoingDocuments$authCall,
									user.jwt,
									apiEndPoint.dashboardOutgoingDocs,
									$author$project$Data$Domain$selected(user.domains))),
								A2(
								$elm$core$Task$attempt,
								A2(
									$elm$core$Basics$composeL,
									A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnDashboard),
									$author$project$Type$Dashboard$OnCompletedDocsResponse),
								A3(
									$author$project$Data$Api$Dashboard$CompletedDocument$authCall,
									user.jwt,
									apiEndPoint.dashboardCompletedDocs,
									$author$project$Data$Domain$selected(user.domains))),
								A2(
								$elm$core$Task$attempt,
								A2(
									$elm$core$Basics$composeL,
									A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnDashboard),
									$author$project$Type$Dashboard$OnPointsResponse),
								A3(
									$author$project$Data$Api$Dashboard$Points$authCall,
									user.jwt,
									apiEndPoint.dashboardPoints,
									$author$project$Data$Domain$selected(user.domains))),
								$author$project$Model$Dashboard$displayDashboardAdsContent(
								$elm$json$Json$Encode$bool(user.showAds))
							])));
			case 'OnIncomingDocsResponse':
				var result = msg.a;
				if (result.$ === 'Ok') {
					var response = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								sessionModel: $author$project$Types$Auth(
									_Utils_update(
										authModel,
										{
											dashboardModel: _Utils_update(
												dashboardModel,
												{incomingDocsStatus: $author$project$Type$Dashboard$Loaded, incomingDocuments: response.incomingDocs, incomingPendingNum: response.incomingDocsNum})
										}))
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								sessionModel: $author$project$Types$Auth(
									_Utils_update(
										authModel,
										{
											dashboardModel: _Utils_update(
												dashboardModel,
												{incomingDocsStatus: $author$project$Type$Dashboard$Error})
										}))
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 'OnOutgoingDocsResponse':
				var result = msg.a;
				if (result.$ === 'Ok') {
					var response = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								sessionModel: $author$project$Types$Auth(
									_Utils_update(
										authModel,
										{
											dashboardModel: _Utils_update(
												dashboardModel,
												{outgoingDocsStatus: $author$project$Type$Dashboard$Loaded, outgoingDocuments: response.outgoingDocs, totalSent: response.totalDocsSent})
										}))
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								sessionModel: $author$project$Types$Auth(
									_Utils_update(
										authModel,
										{
											dashboardModel: _Utils_update(
												dashboardModel,
												{outgoingDocsStatus: $author$project$Type$Dashboard$Error})
										}))
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 'OnCompletedDocsResponse':
				var result = msg.a;
				if (result.$ === 'Ok') {
					var response = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								sessionModel: $author$project$Types$Auth(
									_Utils_update(
										authModel,
										{
											dashboardModel: _Utils_update(
												dashboardModel,
												{completedDocsStatus: $author$project$Type$Dashboard$Loaded, completedDocuments: response.completedDocs, totalNoOfPages: response.totalNoOfPages})
										}))
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								sessionModel: $author$project$Types$Auth(
									_Utils_update(
										authModel,
										{
											dashboardModel: _Utils_update(
												dashboardModel,
												{completedDocsStatus: $author$project$Type$Dashboard$Error})
										}))
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 'OnPointsResponse':
				var result = msg.a;
				if (result.$ === 'Ok') {
					var response = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								sessionModel: $author$project$Types$Auth(
									_Utils_update(
										authModel,
										{
											dashboardModel: _Utils_update(
												dashboardModel,
												{points: response.points, pointsStatus: $author$project$Type$Dashboard$Loaded})
										}))
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								sessionModel: $author$project$Types$Auth(
									_Utils_update(
										authModel,
										{
											dashboardModel: _Utils_update(
												dashboardModel,
												{pointsStatus: $author$project$Type$Dashboard$Error})
										}))
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 'OnViewAllClick':
				var docType = msg.a;
				switch (docType.$) {
					case 'Incoming':
						return _Utils_Tuple2(
							model,
							A2($elm$browser$Browser$Navigation$pushUrl, model.navKey, $author$project$Data$Route$routeUrl.receievedDoc));
					case 'Outgoing':
						return _Utils_Tuple2(
							model,
							A2($elm$browser$Browser$Navigation$pushUrl, model.navKey, $author$project$Data$Route$routeUrl.sentDoc));
					default:
						return _Utils_Tuple2(
							model,
							A2($elm$browser$Browser$Navigation$pushUrl, model.navKey, $author$project$Data$Route$routeUrl.completedDoc));
				}
			case 'OnTrustScoreClick':
				return _Utils_Tuple2(
					model,
					A2($elm$browser$Browser$Navigation$pushUrl, model.navKey, $author$project$Data$Route$routeUrl.trustScore));
			case 'OnRewardsClick':
				return _Utils_Tuple2(
					model,
					A2($elm$browser$Browser$Navigation$pushUrl, model.navKey, $author$project$Data$Route$routeUrl.tokenManagement));
			case 'OnRedirect':
				var page = msg.a;
				var location = function () {
					if (page.$ === 'TrustScorePage') {
						return $author$project$Type$Dashboard$OnTrustScoreClick;
					} else {
						return $author$project$Type$Dashboard$OnRewardsClick;
					}
				}();
				return _Utils_Tuple2(
					model,
					A2(
						$elm$core$Task$perform,
						function (_v8) {
							return $author$project$Types$OnAuth(
								$author$project$Types$OnDashboard(location));
						},
						A2($elm$browser$Browser$Dom$setViewport, 0, 0)));
			default:
				var placement = msg.a;
				var action = msg.b;
				var toolTipPlacement = function () {
					if (action.$ === 'Enters') {
						return $author$project$Type$Dashboard$Hover(placement);
					} else {
						return $author$project$Type$Dashboard$NoHover;
					}
				}();
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							sessionModel: $author$project$Types$Auth(
								_Utils_update(
									authModel,
									{
										dashboardModel: _Utils_update(
											dashboardModel,
											{toolTip: toolTipPlacement})
									}))
						}),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Type$Login$AddRedirectPath = function (a) {
	return {$: 'AddRedirectPath', a: a};
};
var $author$project$Types$Anonymous = function (a) {
	return {$: 'Anonymous', a: a};
};
var $author$project$Type$FillTemplate$InvalidToken = {$: 'InvalidToken'};
var $author$project$Type$FillTemplate$LoadTemplate = function (a) {
	return {$: 'LoadTemplate', a: a};
};
var $author$project$Type$FillTemplate$Loading = {$: 'Loading'};
var $author$project$Type$FillTemplate$NoAuthLoaded = function (a) {
	return {$: 'NoAuthLoaded', a: a};
};
var $author$project$Type$FillTemplate$NotTokenUser = {$: 'NotTokenUser'};
var $author$project$Type$FillTemplate$OnCheckSingleRoleFillTemplateResult = F2(
	function (a, b) {
		return {$: 'OnCheckSingleRoleFillTemplateResult', a: a, b: b};
	});
var $author$project$Types$OnLogin = function (a) {
	return {$: 'OnLogin', a: a};
};
var $author$project$Type$FillTemplate$ValidateTokenResult = function (a) {
	return {$: 'ValidateTokenResult', a: a};
};
var $author$project$Type$FillTemplate$ValidateTokenResultViewTemplateInfo = function (a) {
	return {$: 'ValidateTokenResultViewTemplateInfo', a: a};
};
var $author$project$Type$FillTemplate$VerificationError = function (a) {
	return {$: 'VerificationError', a: a};
};
var $author$project$Type$FillTemplate$ViewTemplateInfo = function (a) {
	return {$: 'ViewTemplateInfo', a: a};
};
var $author$project$Data$Api$PDF$CheckSingleRoleTemplate$Payload = function (isSingleRole) {
	return {isSingleRole: isSingleRole};
};
var $author$project$Data$Api$PDF$CheckSingleRoleTemplate$dataDecoder = A2(
	$elm$json$Json$Decode$map,
	$author$project$Data$Api$PDF$CheckSingleRoleTemplate$Payload,
	A2($elm$json$Json$Decode$field, 'isSingleRole', $elm$json$Json$Decode$bool));
var $author$project$Data$Api$PDF$CheckSingleRoleTemplate$encode = function (_v0) {
	var slug = _v0.slug;
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'slug',
				$elm$json$Json$Encode$string(slug))
			]));
};
var $author$project$Data$Api$PDF$CheckSingleRoleTemplate$INVALID_DATA = {$: 'INVALID_DATA'};
var $author$project$Data$Api$PDF$CheckSingleRoleTemplate$INVALID_VERSION = {$: 'INVALID_VERSION'};
var $author$project$Data$Api$PDF$CheckSingleRoleTemplate$NOT_FOUND = {$: 'NOT_FOUND'};
var $author$project$Data$Api$PDF$CheckSingleRoleTemplate$errorDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (errorCode) {
		switch (errorCode) {
			case 'INVALID_DATA':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$PDF$CheckSingleRoleTemplate$INVALID_DATA);
			case 'NOT_FOUND':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$PDF$CheckSingleRoleTemplate$NOT_FOUND);
			case 'INVALID_VERSION':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$PDF$CheckSingleRoleTemplate$INVALID_VERSION);
			default:
				return $elm$json$Json$Decode$fail('Invalid error code: ' + errorCode);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Data$Api$PDF$CheckSingleRoleTemplate$call = F2(
	function (endPoint, params) {
		return A4(
			$author$project$Data$Api$httpTask,
			endPoint,
			$author$project$Data$Api$PDF$CheckSingleRoleTemplate$errorDecoder,
			$author$project$Data$Api$PDF$CheckSingleRoleTemplate$dataDecoder,
			$author$project$Data$Api$PDF$CheckSingleRoleTemplate$encode(params));
	});
var $author$project$Data$Api$PDF$ValidateTemplateToken$Payload = F2(
	function (user, slug) {
		return {slug: slug, user: user};
	});
var $author$project$Data$Api$PDF$ValidateTemplateToken$dataDecoder = A3(
	$elm$json$Json$Decode$map2,
	$author$project$Data$Api$PDF$ValidateTemplateToken$Payload,
	A2(
		$elm$json$Json$Decode$andThen,
		function (jwt) {
			return A2(
				$elm$json$Json$Decode$field,
				'user',
				$author$project$Data$User$decoderWithJwt(jwt));
		},
		A2($elm$json$Json$Decode$field, 'jwt', $elm$json$Json$Decode$string)),
	A2($elm$json$Json$Decode$field, 'slug', $elm$json$Json$Decode$string));
var $author$project$Data$Api$PDF$ValidateTemplateToken$INVALID_TOKEN_PROVIDED = {$: 'INVALID_TOKEN_PROVIDED'};
var $author$project$Data$Api$PDF$ValidateTemplateToken$USER_NOT_EXIST = {$: 'USER_NOT_EXIST'};
var $author$project$Data$Api$PDF$ValidateTemplateToken$errorDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (errorCode) {
		switch (errorCode) {
			case 'USER_NOT_EXIST':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$PDF$ValidateTemplateToken$USER_NOT_EXIST);
			case 'INVALID_TOKEN_PROVIDED':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$PDF$ValidateTemplateToken$INVALID_TOKEN_PROVIDED);
			default:
				return $elm$json$Json$Decode$fail('Invalid error code: ' + errorCode);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Data$Api$PDF$ValidateTemplateToken$call = F2(
	function (token, endPoint) {
		return A5(
			$author$project$Data$Api$authCall,
			token,
			endPoint,
			$author$project$Data$Api$PDF$ValidateTemplateToken$errorDecoder,
			$author$project$Data$Api$PDF$ValidateTemplateToken$dataDecoder,
			$elm$json$Json$Encode$object(_List_Nil));
	});
var $author$project$Type$FillTemplate$Ready = {$: 'Ready'};
var $author$project$Model$FillTemplate$initNoAuth = F2(
	function (slug, isSingleRole) {
		return {email: $elm$core$Maybe$Nothing, emailError: $elm$core$Maybe$Nothing, formStatus: $author$project$Type$FillTemplate$Ready, isSingleRole: isSingleRole, slug: slug};
	});
var $author$project$Type$FillTemplate$Closed = {$: 'Closed'};
var $author$project$Type$FillTemplate$LoadTemplateResult = function (a) {
	return {$: 'LoadTemplateResult', a: a};
};
var $author$project$Type$FillTemplate$Loaded = function (a) {
	return {$: 'Loaded', a: a};
};
var $author$project$Type$FillTemplate$LoadingApiError = function (a) {
	return {$: 'LoadingApiError', a: a};
};
var $author$project$Type$FillTemplate$LoadingDecodeError = function (a) {
	return {$: 'LoadingDecodeError', a: a};
};
var $author$project$Type$FillTemplate$LoadingSignatureError = {$: 'LoadingSignatureError'};
var $author$project$Type$FillTemplate$NoSigningOrder = {$: 'NoSigningOrder'};
var $author$project$Type$FillTemplate$Recipients = {$: 'Recipients'};
var $author$project$Type$FillTemplate$SignedSignatureResult = F2(
	function (a, b) {
		return {$: 'SignedSignatureResult', a: a, b: b};
	});
var $author$project$Data$Api$PDF$ViewTemplate$Payload = function (id) {
	return function (owner) {
		return function (title) {
			return function (slug) {
				return function (createdAt) {
					return function (updatedAt) {
						return function (isDocumentEncrypted) {
							return function (domain) {
								return function (filledAnnots) {
									return function (fieldAnnots) {
										return function (version) {
											return function (signPointsBalance) {
												return function (binanceNotarisationCost) {
													return function (algorandNotarisationCost) {
														return function (noOfGeneratedDocumentsfromTemplate) {
															return function (templateLogData) {
																return function (viewers) {
																	return {algorandNotarisationCost: algorandNotarisationCost, binanceNotarisationCost: binanceNotarisationCost, createdAt: createdAt, domain: domain, fieldAnnots: fieldAnnots, filledAnnots: filledAnnots, id: id, isDocumentEncrypted: isDocumentEncrypted, noOfGeneratedDocumentsfromTemplate: noOfGeneratedDocumentsfromTemplate, owner: owner, signPointsBalance: signPointsBalance, slug: slug, templateLogData: templateLogData, title: title, updatedAt: updatedAt, version: version, viewers: viewers};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Data$Api$PDF$ViewTemplate$FieldAnnot = function (id) {
	return function (type_) {
		return function (name) {
			return function (required) {
				return function (width) {
					return function (height) {
						return function (x) {
							return function (y) {
								return function (fontSize) {
									return function (page) {
										return function (templateId) {
											return function (version) {
												return function (roleId) {
													return function (roleName) {
														return function (signOrder) {
															return function (email) {
																return function (firstName) {
																	return function (lastName) {
																		return {email: email, firstName: firstName, fontSize: fontSize, height: height, id: id, lastName: lastName, name: name, page: page, required: required, roleId: roleId, roleName: roleName, signOrder: signOrder, templateId: templateId, type_: type_, version: version, width: width, x: x, y: y};
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Data$Api$PDF$ViewTemplate$CheckboxField = {$: 'CheckboxField'};
var $author$project$Data$Api$PDF$ViewTemplate$DateField = {$: 'DateField'};
var $author$project$Data$Api$PDF$ViewTemplate$EmailField = {$: 'EmailField'};
var $author$project$Data$Api$PDF$ViewTemplate$NameField = {$: 'NameField'};
var $author$project$Data$Api$PDF$ViewTemplate$NumberField = {$: 'NumberField'};
var $author$project$Data$Api$PDF$ViewTemplate$SignatureField = {$: 'SignatureField'};
var $author$project$Data$Api$PDF$ViewTemplate$StampField = {$: 'StampField'};
var $author$project$Data$Api$PDF$ViewTemplate$TextField = {$: 'TextField'};
var $author$project$Data$Api$PDF$ViewTemplate$decodeFieldAnnotType = A2(
	$elm$json$Json$Decode$andThen,
	function (filledAnnotType) {
		switch (filledAnnotType) {
			case 'TextField':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$PDF$ViewTemplate$TextField);
			case 'DateField':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$PDF$ViewTemplate$DateField);
			case 'SignatureField':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$PDF$ViewTemplate$SignatureField);
			case 'NumberField':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$PDF$ViewTemplate$NumberField);
			case 'StampField':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$PDF$ViewTemplate$StampField);
			case 'EmailField':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$PDF$ViewTemplate$EmailField);
			case 'NameField':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$PDF$ViewTemplate$NameField);
			case 'CheckboxField':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$PDF$ViewTemplate$CheckboxField);
			default:
				return $elm$json$Json$Decode$fail('Invalid annotation field type.');
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Data$Api$PDF$ViewTemplate$decodeFieldAnnot = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'lastName',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
	$elm$core$Maybe$Nothing,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'firstName',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
		$elm$core$Maybe$Nothing,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'email',
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
			$elm$core$Maybe$Nothing,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'signOrder',
				$elm$json$Json$Decode$int,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'roleName',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'roleId',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'version',
							$elm$json$Json$Decode$int,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'templateId',
								$elm$json$Json$Decode$string,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'page',
									$elm$json$Json$Decode$int,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'fontSize',
										$elm$json$Json$Decode$string,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'y',
											$elm$json$Json$Decode$float,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'x',
												$elm$json$Json$Decode$float,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'height',
													$elm$json$Json$Decode$float,
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'width',
														$elm$json$Json$Decode$float,
														A3(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
															'required',
															$elm$json$Json$Decode$bool,
															A3(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																'name',
																$elm$json$Json$Decode$string,
																A3(
																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																	'type',
																	$author$project$Data$Api$PDF$ViewTemplate$decodeFieldAnnotType,
																	A3(
																		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																		'id',
																		$elm$json$Json$Decode$string,
																		$elm$json$Json$Decode$succeed($author$project$Data$Api$PDF$ViewTemplate$FieldAnnot)))))))))))))))))));
var $author$project$Data$Api$PDF$ViewTemplate$decodeFieldAnnotList = $elm$json$Json$Decode$list($author$project$Data$Api$PDF$ViewTemplate$decodeFieldAnnot);
var $author$project$Data$Api$PDF$ViewTemplate$FilledAnnot = function (id) {
	return function (type_) {
		return function (width) {
			return function (height) {
				return function (fontSize) {
					return function (x) {
						return function (y) {
							return function (page) {
								return function (templateId) {
									return function (version) {
										return {fontSize: fontSize, height: height, id: id, page: page, templateId: templateId, type_: type_, version: version, width: width, x: x, y: y};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Data$Api$PDF$ViewTemplate$Date = function (a) {
	return {$: 'Date', a: a};
};
var $author$project$Data$Api$PDF$ViewTemplate$FreeText = function (a) {
	return {$: 'FreeText', a: a};
};
var $author$project$Data$Api$PDF$ViewTemplate$Name = function (a) {
	return {$: 'Name', a: a};
};
var $author$project$Data$Api$PDF$ViewTemplate$Signature = function (a) {
	return {$: 'Signature', a: a};
};
var $author$project$Data$Api$PDF$ViewTemplate$decodeFilledAnnotContent = A2(
	$elm$json$Json$Decode$andThen,
	function (annotType) {
		switch (annotType) {
			case 'Name':
				return A2(
					$elm$json$Json$Decode$map,
					$author$project$Data$Api$PDF$ViewTemplate$Name,
					A2($elm$json$Json$Decode$field, 'data', $elm$json$Json$Decode$string));
			case 'Date':
				return A2(
					$elm$json$Json$Decode$map,
					$author$project$Data$Api$PDF$ViewTemplate$Date,
					A2(
						$elm$json$Json$Decode$map,
						$elm$time$Time$millisToPosix,
						A2($elm$json$Json$Decode$field, 'posix', $elm$json$Json$Decode$int)));
			case 'Signature':
				return A2(
					$elm$json$Json$Decode$map,
					$author$project$Data$Api$PDF$ViewTemplate$Signature,
					A2($elm$json$Json$Decode$field, 'filePath', $elm$json$Json$Decode$string));
			case 'FreeText':
				return A2(
					$elm$json$Json$Decode$map,
					$author$project$Data$Api$PDF$ViewTemplate$FreeText,
					A2($elm$json$Json$Decode$field, 'data', $elm$json$Json$Decode$string));
			default:
				return $elm$json$Json$Decode$fail('Invalid annotation type.');
		}
	},
	A2($elm$json$Json$Decode$field, 'type', $elm$json$Json$Decode$string));
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt = F3(
	function (path, valDecoder, decoder) {
		return A2(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
			A2($elm$json$Json$Decode$at, path, valDecoder),
			decoder);
	});
var $author$project$Data$Api$PDF$ViewTemplate$decodeFilledAnnot = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'version',
	$elm$json$Json$Decode$int,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'templateId',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'page',
			$elm$json$Json$Decode$int,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'y',
				$elm$json$Json$Decode$float,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'x',
					$elm$json$Json$Decode$float,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'fontSize',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'height',
							$elm$json$Json$Decode$float,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'width',
								$elm$json$Json$Decode$float,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
									_List_fromArray(
										['type']),
									$author$project$Data$Api$PDF$ViewTemplate$decodeFilledAnnotContent,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'id',
										$elm$json$Json$Decode$string,
										$elm$json$Json$Decode$succeed($author$project$Data$Api$PDF$ViewTemplate$FilledAnnot)))))))))));
var $author$project$Data$Api$PDF$ViewTemplate$decodeFilledAnnotList = $elm$json$Json$Decode$list($author$project$Data$Api$PDF$ViewTemplate$decodeFilledAnnot);
var $author$project$Data$Api$PDF$ViewTemplate$Owner = F5(
	function (id, firstName, lastName, email, trustScore) {
		return {email: email, firstName: firstName, id: id, lastName: lastName, trustScore: trustScore};
	});
var $author$project$Data$Api$PDF$ViewTemplate$TrustScore = F6(
	function (passbase, shuftiPro, myInfo, corporate, stripe, mobilePhone) {
		return {corporate: corporate, mobilePhone: mobilePhone, myInfo: myInfo, passbase: passbase, shuftiPro: shuftiPro, stripe: stripe};
	});
var $author$project$Data$Api$PDF$ViewTemplate$decodeTrustScore = A7(
	$elm$json$Json$Decode$map6,
	$author$project$Data$Api$PDF$ViewTemplate$TrustScore,
	A2($elm$json$Json$Decode$field, 'passbase', $elm$json$Json$Decode$bool),
	A2($elm$json$Json$Decode$field, 'shuftiPro', $elm$json$Json$Decode$bool),
	A2($elm$json$Json$Decode$field, 'myInfo', $elm$json$Json$Decode$bool),
	A2($elm$json$Json$Decode$field, 'corporate', $elm$json$Json$Decode$bool),
	A2($elm$json$Json$Decode$field, 'stripe', $elm$json$Json$Decode$bool),
	A2($elm$json$Json$Decode$field, 'mobilePhone', $elm$json$Json$Decode$bool));
var $author$project$Data$Api$PDF$ViewTemplate$decodeOwner = A6(
	$elm$json$Json$Decode$map5,
	$author$project$Data$Api$PDF$ViewTemplate$Owner,
	A2($elm$json$Json$Decode$field, 'id', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'firstName', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'lastName', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'email', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'trustScore', $author$project$Data$Api$PDF$ViewTemplate$decodeTrustScore));
var $author$project$Data$Api$PDF$ViewTemplate$TemplateLog = F6(
	function (firstName, lastName, action, createdAt, ipAddr, documentId) {
		return {action: action, createdAt: createdAt, documentId: documentId, firstName: firstName, ipAddr: ipAddr, lastName: lastName};
	});
var $author$project$Data$Api$PDF$ViewTemplate$CompleteDocument = {$: 'CompleteDocument'};
var $author$project$Data$Api$PDF$ViewTemplate$CreateDocument = {$: 'CreateDocument'};
var $author$project$Data$Api$PDF$ViewTemplate$EditTemplate = {$: 'EditTemplate'};
var $author$project$Data$Api$PDF$ViewTemplate$TemplateCreation = {$: 'TemplateCreation'};
var $author$project$Data$Api$PDF$ViewTemplate$View = {$: 'View'};
var $author$project$Data$Api$PDF$ViewTemplate$decodeLogAction = function (action) {
	switch (action) {
		case 'EditTemplate':
			return $elm$json$Json$Decode$succeed($author$project$Data$Api$PDF$ViewTemplate$EditTemplate);
		case 'CreateDocument':
			return $elm$json$Json$Decode$succeed($author$project$Data$Api$PDF$ViewTemplate$CreateDocument);
		case 'CompleteDocument':
			return $elm$json$Json$Decode$succeed($author$project$Data$Api$PDF$ViewTemplate$CompleteDocument);
		case 'View':
			return $elm$json$Json$Decode$succeed($author$project$Data$Api$PDF$ViewTemplate$View);
		case 'TemplateCreation':
			return $elm$json$Json$Decode$succeed($author$project$Data$Api$PDF$ViewTemplate$TemplateCreation);
		default:
			return $elm$json$Json$Decode$fail('Invalid action type.');
	}
};
var $author$project$Data$Api$PDF$ViewTemplate$decodeTemplateLog = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'documentId',
	A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
	$elm$core$Maybe$Nothing,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'ipAddr',
		A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
		$elm$core$Maybe$Nothing,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'createdAt',
			A2($elm$json$Json$Decode$map, $elm$time$Time$millisToPosix, $elm$json$Json$Decode$int),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'action',
				A2(
					$elm$json$Json$Decode$andThen,
					function (action) {
						return $author$project$Data$Api$PDF$ViewTemplate$decodeLogAction(action);
					},
					$elm$json$Json$Decode$string),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'lastName',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'firstName',
						$elm$json$Json$Decode$string,
						$elm$json$Json$Decode$succeed($author$project$Data$Api$PDF$ViewTemplate$TemplateLog)))))));
var $author$project$Data$Api$PDF$ViewTemplate$decodeTemplateLogList = $elm$json$Json$Decode$list($author$project$Data$Api$PDF$ViewTemplate$decodeTemplateLog);
var $author$project$Data$Api$PDF$ViewTemplate$RoleData = F6(
	function (role, roleId, email, firstName, lastName, signOrder) {
		return {email: email, firstName: firstName, lastName: lastName, role: role, roleId: roleId, signOrder: signOrder};
	});
var $author$project$Data$Api$PDF$ViewTemplate$decodeViewersData = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'signOrder',
	$elm$json$Json$Decode$int,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'lastName',
		A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
		$elm$core$Maybe$Nothing,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'firstName',
			A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
			$elm$core$Maybe$Nothing,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'email',
				A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
				$elm$core$Maybe$Nothing,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'roleId',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'role',
						$elm$json$Json$Decode$string,
						$elm$json$Json$Decode$succeed($author$project$Data$Api$PDF$ViewTemplate$RoleData)))))));
var $author$project$Data$Api$PDF$ViewTemplate$decodeViewerDataList = $elm$json$Json$Decode$list($author$project$Data$Api$PDF$ViewTemplate$decodeViewersData);
var $author$project$Data$Api$PDF$ViewTemplate$dataDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'viewers',
	$author$project$Data$Api$PDF$ViewTemplate$decodeViewerDataList,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'templateLogData',
		$author$project$Data$Api$PDF$ViewTemplate$decodeTemplateLogList,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'noOfGeneratedDocumentsfromTemplate',
			$elm$json$Json$Decode$int,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'algorandNotarisationCost',
				$elm$json$Json$Decode$int,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'binanceNotarisationCost',
					$elm$json$Json$Decode$int,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'signPointsBalance',
						$elm$json$Json$Decode$int,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'version',
							$elm$json$Json$Decode$int,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'fieldAnnots',
								$author$project$Data$Api$PDF$ViewTemplate$decodeFieldAnnotList,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'filledAnnots',
									$author$project$Data$Api$PDF$ViewTemplate$decodeFilledAnnotList,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'domain',
										$elm$json$Json$Decode$string,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'isDocumentEncrypted',
											$elm$json$Json$Decode$bool,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'updatedAt',
												A2($elm$json$Json$Decode$map, $elm$time$Time$millisToPosix, $elm$json$Json$Decode$int),
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'createdAt',
													A2($elm$json$Json$Decode$map, $elm$time$Time$millisToPosix, $elm$json$Json$Decode$int),
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'slug',
														$elm$json$Json$Decode$string,
														A3(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
															'title',
															$elm$json$Json$Decode$string,
															A3(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																'owner',
																$author$project$Data$Api$PDF$ViewTemplate$decodeOwner,
																A3(
																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																	'id',
																	$elm$json$Json$Decode$string,
																	$elm$json$Json$Decode$succeed($author$project$Data$Api$PDF$ViewTemplate$Payload))))))))))))))))));
var $author$project$Data$Api$PDF$ViewTemplate$encode = F2(
	function (domain, slug) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'domain',
					$elm$json$Json$Encode$string(domain)),
					_Utils_Tuple2(
					'slug',
					$elm$json$Json$Encode$string(slug))
				]));
	});
var $author$project$Data$Api$PDF$ViewTemplate$INVALID_DATA = {$: 'INVALID_DATA'};
var $author$project$Data$Api$PDF$ViewTemplate$INVALID_DOMAIN = {$: 'INVALID_DOMAIN'};
var $author$project$Data$Api$PDF$ViewTemplate$INVALID_SLUG = {$: 'INVALID_SLUG'};
var $author$project$Data$Api$PDF$ViewTemplate$INVALID_VERSION = {$: 'INVALID_VERSION'};
var $author$project$Data$Api$PDF$ViewTemplate$NOT_FOUND = {$: 'NOT_FOUND'};
var $author$project$Data$Api$PDF$ViewTemplate$errorDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (errorCode) {
		switch (errorCode) {
			case 'INVALID_DOMAIN':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$PDF$ViewTemplate$INVALID_DOMAIN);
			case 'INVALID_SLUG':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$PDF$ViewTemplate$INVALID_SLUG);
			case 'INVALID_DATA':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$PDF$ViewTemplate$INVALID_DATA);
			case 'NOT_FOUND':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$PDF$ViewTemplate$NOT_FOUND);
			case 'INVALID_VERSION':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$PDF$ViewTemplate$INVALID_VERSION);
			default:
				return $elm$json$Json$Decode$fail('Invalid error code: ' + errorCode);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Data$Api$PDF$ViewTemplate$authCall = F3(
	function (jwt, endPoint, _v0) {
		var domain = _v0.a;
		var slug = _v0.b;
		return A5(
			$author$project$Data$Api$authCall,
			jwt,
			endPoint,
			$author$project$Data$Api$PDF$ViewTemplate$errorDecoder,
			$author$project$Data$Api$PDF$ViewTemplate$dataDecoder,
			A2($author$project$Data$Api$PDF$ViewTemplate$encode, domain, slug));
	});
var $author$project$Data$Api$Signature$File$Payload = function (signature) {
	return {signature: signature};
};
var $author$project$Data$Api$Signature$File$Signature = F3(
	function (id, name, data) {
		return {data: data, id: id, name: name};
	});
var $author$project$Data$Api$Signature$File$signatureDecoder = A4(
	$elm$json$Json$Decode$map3,
	$author$project$Data$Api$Signature$File$Signature,
	A2($elm$json$Json$Decode$field, 'id', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'name', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'data', $elm$json$Json$Decode$string));
var $author$project$Data$Api$Signature$File$dataDecoder = A2(
	$elm$json$Json$Decode$map,
	$author$project$Data$Api$Signature$File$Payload,
	A2($elm$json$Json$Decode$field, 'signature', $author$project$Data$Api$Signature$File$signatureDecoder));
var $author$project$Data$Api$Signature$File$INVALID_ID = {$: 'INVALID_ID'};
var $author$project$Data$Api$Signature$File$NOT_FOUND = {$: 'NOT_FOUND'};
var $author$project$Data$Api$Signature$File$errorDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (errorCode) {
		switch (errorCode) {
			case 'NOT_FOUND':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$Signature$File$NOT_FOUND);
			case 'INVALID_ID':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$Signature$File$INVALID_ID);
			default:
				return $elm$json$Json$Decode$fail('Invalid error code: ' + errorCode);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Data$Api$Signature$File$authCall = F3(
	function (jwt, endPoint, id) {
		return A5(
			$author$project$Data$Api$authCall,
			jwt,
			endPoint,
			$author$project$Data$Api$Signature$File$errorDecoder,
			$author$project$Data$Api$Signature$File$dataDecoder,
			$elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'id',
						$elm$json$Json$Encode$string(id))
					])));
	});
var $author$project$Data$PDF$Signature$Signature = function (a) {
	return {$: 'Signature', a: a};
};
var $author$project$Data$PDF$Signature$create = F3(
	function (sigID, sigName, sigData) {
		return $author$project$Data$PDF$Signature$Signature(
			{data: sigData, id: sigID, name: sigName});
	});
var $elm$core$Maybe$andThen = F2(
	function (callback, maybeValue) {
		if (maybeValue.$ === 'Just') {
			var value = maybeValue.a;
			return callback(value);
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Type$Signature$firstSignature = function (signatures) {
	return A2(
		$elm$core$Maybe$andThen,
		function (_v0) {
			var id = _v0.id;
			var name = _v0.name;
			var data = _v0.data;
			return $elm$core$Maybe$Just(
				A3($author$project$Data$PDF$Signature$create, id, name, data));
		},
		$elm$core$List$head(signatures));
};
var $author$project$Data$PDF$FillTemplate$Template = function (a) {
	return {$: 'Template', a: a};
};
var $author$project$Data$PDF$FillTemplate$IsCheckboxField = function (a) {
	return {$: 'IsCheckboxField', a: a};
};
var $author$project$Data$PDF$FillTemplate$IsDateField = function (a) {
	return {$: 'IsDateField', a: a};
};
var $author$project$Data$PDF$FillTemplate$IsEmailField = function (a) {
	return {$: 'IsEmailField', a: a};
};
var $author$project$Data$PDF$FillTemplate$IsNameField = function (a) {
	return {$: 'IsNameField', a: a};
};
var $author$project$Data$PDF$FillTemplate$IsNumberField = F2(
	function (a, b) {
		return {$: 'IsNumberField', a: a, b: b};
	});
var $author$project$Data$PDF$FillTemplate$IsSignatureField = function (a) {
	return {$: 'IsSignatureField', a: a};
};
var $author$project$Data$PDF$FillTemplate$IsStampField = function (a) {
	return {$: 'IsStampField', a: a};
};
var $author$project$Data$PDF$FillTemplate$IsTextField = F2(
	function (a, b) {
		return {$: 'IsTextField', a: a, b: b};
	});
var $author$project$Data$PDF$Annotation$annotationField = F2(
	function (required, name) {
		return {name: name, required: required};
	});
var $author$project$Data$PDF$Annotation$createFilledNumberTxt = F4(
	function (dbId, content, status, style) {
		return $author$project$Data$PDF$Annotation$NumberTxt(
			{
				content: content,
				dbId: dbId,
				id: A3(
					$author$project$Data$PDF$Annotation$generateId,
					$elm$core$String$fromFloat(content),
					$author$project$Data$PDF$Annotation$toStatusString(status),
					style),
				status: status,
				style: style
			});
	});
var $author$project$Data$PDF$Annotation$filledDateTxt = F4(
	function (dbId, timeNow, isVerified, style) {
		var txtStatus_ = isVerified ? $author$project$Data$PDF$Annotation$Verified : $author$project$Data$PDF$Annotation$Unverified;
		var generatedId = A3(
			$author$project$Data$PDF$Annotation$generateId,
			$author$project$Data$PDF$Annotation$toStringPosix(timeNow),
			$author$project$Data$PDF$Annotation$toStatusString(txtStatus_),
			style);
		return $author$project$Data$PDF$Annotation$DateTxt(
			{date: timeNow, dbId: dbId, id: generatedId, status: txtStatus_, style: style});
	});
var $author$project$Data$PDF$Annotation$Signature = function (a) {
	return {$: 'Signature', a: a};
};
var $author$project$Data$PDF$Annotation$Signed = function (a) {
	return {$: 'Signed', a: a};
};
var $author$project$Data$PDF$Annotation$Unsigned = {$: 'Unsigned'};
var $author$project$Data$PDF$Annotation$toSignatureStatusString = function (status) {
	if (status.$ === 'Unsigned') {
		return 'Unsigned';
	} else {
		return 'Signed';
	}
};
var $author$project$Data$PDF$Annotation$filledSignature = F4(
	function (dbId, content, isVerified, style) {
		var sigStatus = isVerified ? $author$project$Data$PDF$Annotation$Signed(
			A3($author$project$Data$PDF$Signature$create, content, 'Signature', '')) : $author$project$Data$PDF$Annotation$Unsigned;
		var generatedId = A3(
			$author$project$Data$PDF$Annotation$generateId,
			content,
			$author$project$Data$PDF$Annotation$toSignatureStatusString(sigStatus),
			style);
		return $author$project$Data$PDF$Annotation$Signature(
			{dbId: dbId, id: generatedId, status: sigStatus, style: style});
	});
var $author$project$Data$PDF$Annotation$Stamped = function (a) {
	return {$: 'Stamped', a: a};
};
var $author$project$Data$PDF$Annotation$Unstamped = {$: 'Unstamped'};
var $author$project$Data$PDF$Stamp$createFakeLoadingStamp = function (stampID) {
	return $author$project$Data$PDF$Stamp$Stamp(
		{
			createdAt: $elm$time$Time$millisToPosix(0),
			data: $author$project$Data$PDF$Stamp$NotLoaded,
			domain: $author$project$Data$Domain$fromString('fakeStampDomain'),
			fileType: $author$project$Data$PDF$Stamp$PNG,
			id: stampID,
			isDeleted: false,
			name: '',
			userID: ''
		});
};
var $author$project$Data$PDF$Annotation$filledStamp = F4(
	function (dbId, content, isVerified, style) {
		var stampStatus = isVerified ? $author$project$Data$PDF$Annotation$Stamped(
			$author$project$Data$PDF$Stamp$createFakeLoadingStamp(content)) : $author$project$Data$PDF$Annotation$Unstamped;
		var generatedId = A3(
			$author$project$Data$PDF$Annotation$generateId,
			content,
			$author$project$Data$PDF$Annotation$toStampStatusString(stampStatus),
			style);
		return $author$project$Data$PDF$Annotation$Stamp(
			{dbId: dbId, id: generatedId, status: stampStatus, style: style});
	});
var $author$project$Data$PDF$Annotation$filledTxt = F4(
	function (dbId, content, isVerified, style) {
		var txtStatus_ = isVerified ? $author$project$Data$PDF$Annotation$Verified : $author$project$Data$PDF$Annotation$Unverified;
		var generatedId = A3(
			$author$project$Data$PDF$Annotation$generateId,
			content,
			$author$project$Data$PDF$Annotation$toStatusString(txtStatus_),
			style);
		return $author$project$Data$PDF$Annotation$Txt(
			{dbId: dbId, id: generatedId, status: txtStatus_, style: style, text: content});
	});
var $author$project$Data$PDF$Annotation$ViewSignatureField = F2(
	function (a, b) {
		return {$: 'ViewSignatureField', a: a, b: b};
	});
var $author$project$Data$PDF$Annotation$toViewSignatureField = F2(
	function (annotField, signature) {
		return A2($author$project$Data$PDF$Annotation$ViewSignatureField, annotField, signature);
	});
var $author$project$Data$PDF$FillTemplate$fromFieldAnnotsToAnnot = F3(
	function (timeNow, maybeCurrentUserSig, fieldAnnots) {
		return A2(
			$elm$core$List$map,
			function (fieldAnnot) {
				var style = {fontSize: fieldAnnot.fontSize, height: fieldAnnot.height, page: fieldAnnot.page, width: fieldAnnot.width, x: fieldAnnot.x, y: fieldAnnot.y};
				var annotField = A2($author$project$Data$PDF$Annotation$annotationField, fieldAnnot.required, fieldAnnot.name);
				var _v0 = fieldAnnot.type_;
				switch (_v0.$) {
					case 'TextField':
						return A2(
							$author$project$Data$PDF$FillTemplate$IsTextField,
							A2(
								$author$project$Data$PDF$Annotation$toTextField,
								annotField,
								A4($author$project$Data$PDF$Annotation$filledTxt, fieldAnnot.id, fieldAnnot.name, false, style)),
							true);
					case 'DateField':
						return $author$project$Data$PDF$FillTemplate$IsDateField(
							A2(
								$author$project$Data$PDF$Annotation$toDateField,
								annotField,
								A4($author$project$Data$PDF$Annotation$filledDateTxt, fieldAnnot.id, timeNow, false, style)));
					case 'SignatureField':
						if (maybeCurrentUserSig.$ === 'Nothing') {
							return $author$project$Data$PDF$FillTemplate$IsSignatureField(
								A2(
									$author$project$Data$PDF$Annotation$toViewSignatureField,
									annotField,
									A4($author$project$Data$PDF$Annotation$filledSignature, fieldAnnot.id, 'Sign', false, style)));
						} else {
							return $author$project$Data$PDF$FillTemplate$IsSignatureField(
								A2(
									$author$project$Data$PDF$Annotation$toViewSignatureField,
									annotField,
									A4($author$project$Data$PDF$Annotation$filledSignature, fieldAnnot.id, 'Sign', false, style)));
						}
					case 'NumberField':
						return A2(
							$author$project$Data$PDF$FillTemplate$IsNumberField,
							A2(
								$author$project$Data$PDF$Annotation$toNumberField,
								annotField,
								A4($author$project$Data$PDF$Annotation$createFilledNumberTxt, fieldAnnot.id, 0.0, $author$project$Data$PDF$Annotation$Unverified, style)),
							true);
					case 'StampField':
						return $author$project$Data$PDF$FillTemplate$IsStampField(
							A2(
								$author$project$Data$PDF$Annotation$toStampField,
								annotField,
								A4($author$project$Data$PDF$Annotation$filledStamp, fieldAnnot.id, 'Stamp', false, style)));
					case 'EmailField':
						return $author$project$Data$PDF$FillTemplate$IsEmailField(
							A2(
								$author$project$Data$PDF$Annotation$toTextField,
								annotField,
								A4($author$project$Data$PDF$Annotation$filledTxt, fieldAnnot.id, 'Email', false, style)));
					case 'NameField':
						return $author$project$Data$PDF$FillTemplate$IsNameField(
							A2(
								$author$project$Data$PDF$Annotation$toTextField,
								annotField,
								A4($author$project$Data$PDF$Annotation$filledTxt, fieldAnnot.id, 'Name', false, style)));
					default:
						return $author$project$Data$PDF$FillTemplate$IsCheckboxField(
							A2(
								$author$project$Data$PDF$Annotation$toTextField,
								annotField,
								A4($author$project$Data$PDF$Annotation$filledTxt, fieldAnnot.id, 'CheckboxField', false, style)));
				}
			},
			fieldAnnots);
	});
var $author$project$Data$PDF$FillTemplate$IsDate = function (a) {
	return {$: 'IsDate', a: a};
};
var $author$project$Data$PDF$FillTemplate$IsFreeText = function (a) {
	return {$: 'IsFreeText', a: a};
};
var $author$project$Data$PDF$FillTemplate$IsName = function (a) {
	return {$: 'IsName', a: a};
};
var $author$project$Data$PDF$FillTemplate$IsSignature = function (a) {
	return {$: 'IsSignature', a: a};
};
var $author$project$Data$PDF$Signature$id = function (_v0) {
	var signature = _v0.a;
	return signature.id;
};
var $author$project$Data$PDF$Annotation$filledSignedSignature = F2(
	function (style, signature) {
		return $author$project$Data$PDF$Annotation$SignedSignature(
			{
				content: signature,
				dbId: $author$project$Data$PDF$Signature$id(signature),
				id: A3(
					$author$project$Data$PDF$Annotation$generateId,
					$author$project$Data$PDF$Signature$data(signature),
					'Signed',
					style),
				style: style
			});
	});
var $author$project$Data$PDF$FillTemplate$fromFilledAnnotsToAnnot = F2(
	function (maybeOwnerSig, filledAnnots) {
		return A3(
			$elm$core$List$foldl,
			F2(
				function (filledAnnot, accumlator) {
					var style = {fontSize: filledAnnot.fontSize, height: filledAnnot.height, page: filledAnnot.page, width: filledAnnot.width, x: filledAnnot.x, y: filledAnnot.y};
					if (accumlator.$ === 'Ok') {
						var arr = accumlator.a;
						var _v1 = filledAnnot.type_;
						switch (_v1.$) {
							case 'Name':
								var content = _v1.a;
								return $elm$core$Result$Ok(
									A2(
										$elm$core$List$cons,
										$author$project$Data$PDF$FillTemplate$IsName(
											A4($author$project$Data$PDF$Annotation$filledTxt, filledAnnot.id, content, true, style)),
										arr));
							case 'Date':
								var posix = _v1.a;
								return $elm$core$Result$Ok(
									A2(
										$elm$core$List$cons,
										$author$project$Data$PDF$FillTemplate$IsDate(
											A4($author$project$Data$PDF$Annotation$filledDateTxt, filledAnnot.id, posix, true, style)),
										arr));
							case 'FreeText':
								var content = _v1.a;
								return $elm$core$Result$Ok(
									A2(
										$elm$core$List$cons,
										$author$project$Data$PDF$FillTemplate$IsFreeText(
											A4($author$project$Data$PDF$Annotation$filledTxt, filledAnnot.id, content, true, style)),
										arr));
							default:
								if (maybeOwnerSig.$ === 'Nothing') {
									return $elm$core$Result$Err('Signature cannot be loaded.');
								} else {
									var sig = maybeOwnerSig.a;
									return $elm$core$Result$Ok(
										A2(
											$elm$core$List$cons,
											$author$project$Data$PDF$FillTemplate$IsSignature(
												A2($author$project$Data$PDF$Annotation$filledSignedSignature, style, sig)),
											arr));
								}
						}
					} else {
						var err = accumlator.a;
						return $elm$core$Result$Err(err);
					}
				}),
			$elm$core$Result$Ok(_List_Nil),
			filledAnnots);
	});
var $author$project$Data$PDF$FillTemplate$removeDuplicates = F2(
	function (el, list) {
		return A2($elm$core$List$member, el, list) ? list : A2($elm$core$List$cons, el, list);
	});
var $author$project$Data$PDF$FillTemplate$initWithPayload = F4(
	function (timeNow, maybeCurrentUserSig, maybeOwnerSig, payload) {
		var viewerData = payload.viewers;
		var formattedFilledAnnots = A2($author$project$Data$PDF$FillTemplate$fromFilledAnnotsToAnnot, maybeOwnerSig, payload.filledAnnots);
		var formattedFieldAnnots = A3($author$project$Data$PDF$FillTemplate$fromFieldAnnotsToAnnot, timeNow, maybeCurrentUserSig, payload.fieldAnnots);
		var allTemplateFieldsAnnots = payload.fieldAnnots;
		var roleData = A3(
			$elm$core$List$foldl,
			$author$project$Data$PDF$FillTemplate$removeDuplicates,
			_List_Nil,
			A2(
				$elm$core$List$map,
				function (r) {
					return {email: r.email, firstName: r.firstName, lastName: r.lastName, role: r.roleName, roleId: r.roleId, signOrder: r.signOrder};
				},
				allTemplateFieldsAnnots));
		var signerAndViewerRoleData = A2($elm$core$List$append, viewerData, roleData);
		var roleDataWithColour = A2(
			$elm$core$List$indexedMap,
			F2(
				function (index, x) {
					return {
						color: $author$project$Data$PDF$User$nextUserColor(index),
						email: x.email,
						firstName: x.firstName,
						id: x.roleId,
						lastName: x.lastName,
						role: x.role,
						signOrder: x.signOrder
					};
				}),
			signerAndViewerRoleData);
		if (formattedFilledAnnots.$ === 'Ok') {
			var annots = formattedFilledAnnots.a;
			return $elm$core$Result$Ok(
				$author$project$Data$PDF$FillTemplate$Template(
					{
						annotations: _Utils_ap(annots, formattedFieldAnnots),
						createdAt: payload.createdAt,
						domain: payload.domain,
						fieldAnnots: allTemplateFieldsAnnots,
						id: payload.id,
						isDocumentEncrypted: payload.isDocumentEncrypted,
						owner: payload.owner,
						password: $elm$core$Maybe$Nothing,
						roles: roleDataWithColour,
						slug: payload.slug,
						title: payload.title,
						updatedAt: payload.updatedAt,
						version: payload.version
					}));
		} else {
			var err = formattedFilledAnnots.a;
			return $elm$core$Result$Err(err);
		}
	});
var $author$project$Data$PDF$Annotation$dateTxtDbId = function (_v0) {
	var dateTxt_ = _v0.a;
	return dateTxt_.dbId;
};
var $author$project$Data$PDF$Annotation$numberFieldDbId = function (_v0) {
	var number = _v0.a;
	return number.dbId;
};
var $author$project$Data$PDF$Annotation$signatureDbId = function (_v0) {
	var signature = _v0.a;
	return signature.dbId;
};
var $author$project$Data$PDF$Annotation$signatureFields = function (_v0) {
	var signature = _v0.a;
	return _Utils_Tuple3(signature.id, signature.status, signature.style);
};
var $author$project$Data$PDF$Annotation$stampDbId = function (_v0) {
	var stamp = _v0.a;
	return stamp.dbId;
};
var $author$project$Data$PDF$Annotation$txtDbId = function (_v0) {
	var txt = _v0.a;
	return txt.dbId;
};
var $author$project$Data$PDF$Annotation$viewSignatureField = function (_v0) {
	var annotField = _v0.a;
	var signature = _v0.b;
	return _Utils_Tuple2(annotField, signature);
};
var $author$project$Data$PDF$FillTemplate$encodeAnnotation = F3(
	function (roleList, fieldAnnots, annot) {
		var ownerBgRGBA = $author$project$Data$PDF$User$materialColorRGB($author$project$Data$PDF$User$Transparent);
		var fieldAnnotsWithColour = A2(
			$elm$core$List$map,
			function (r) {
				return {
					colour: A2(
						$elm$core$Maybe$withDefault,
						$author$project$Data$PDF$User$Blue,
						$elm$core$List$head(
							A2(
								$elm$core$List$filterMap,
								function (row) {
									return _Utils_eq(row.id, r.roleId) ? $elm$core$Maybe$Just(row.color) : $elm$core$Maybe$Nothing;
								},
								roleList))),
					id: r.id,
					roleId: r.roleId,
					roleName: r.roleName,
					type_: r.type_
				};
			},
			fieldAnnots);
		var rgbColourCode = function (id) {
			return $author$project$Data$PDF$User$materialColorRGB(
				A2(
					$elm$core$Maybe$withDefault,
					$author$project$Data$PDF$User$Blue,
					$elm$core$List$head(
						A2(
							$elm$core$List$map,
							function (r) {
								return r.colour;
							},
							A2(
								$elm$core$List$filter,
								function (r) {
									return _Utils_eq(r.id, id);
								},
								fieldAnnotsWithColour)))));
		};
		switch (annot.$) {
			case 'IsName':
				var txt = annot.a;
				return $elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'kind',
							$elm$json$Json$Encode$string('Name')),
							_Utils_Tuple2(
							'data',
							A3(
								$author$project$Data$PDF$Port$encodeFreeText,
								ownerBgRGBA,
								$author$project$Data$PDF$Annotation$txtText(txt),
								txt))
						]));
			case 'IsDate':
				var dateTxt = annot.a;
				var content = $elm$core$String$fromInt(
					$elm$time$Time$posixToMillis(
						$author$project$Data$PDF$Annotation$dateTxtDate(dateTxt)));
				return $elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'kind',
							$elm$json$Json$Encode$string('Date')),
							_Utils_Tuple2(
							'data',
							A3($author$project$Data$PDF$Port$encodeDateText, ownerBgRGBA, content, dateTxt))
						]));
			case 'IsFreeText':
				var txt = annot.a;
				return $elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'kind',
							$elm$json$Json$Encode$string('FreeText')),
							_Utils_Tuple2(
							'data',
							A3(
								$author$project$Data$PDF$Port$encodeFreeText,
								ownerBgRGBA,
								$author$project$Data$PDF$Annotation$txtText(txt),
								txt))
						]));
			case 'IsSignature':
				var signedSig = annot.a;
				var _v1 = $author$project$Data$PDF$Annotation$signedSignatureFields(signedSig);
				var id = _v1.a;
				var dbId = _v1.b;
				var style = _v1.c;
				return $elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'kind',
							$elm$json$Json$Encode$string('Signature')),
							_Utils_Tuple2(
							'data',
							A4(
								$author$project$Data$PDF$Port$encodeSignedSignature,
								id,
								dbId,
								$author$project$Data$PDF$Annotation$signedSignatureData(signedSig),
								style))
						]));
			case 'IsTextField':
				var txtField = annot.a;
				var isFilling = annot.b;
				if (isFilling) {
					var _v2 = $author$project$Data$PDF$Annotation$textField(txtField);
					var txt = _v2.b;
					var textfieldDbId = $author$project$Data$PDF$Annotation$txtDbId(txt);
					return $elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'kind',
								$elm$json$Json$Encode$string('TextField')),
								_Utils_Tuple2(
								'data',
								A3(
									$author$project$Data$PDF$Port$encodeFreeText,
									rgbColourCode(textfieldDbId),
									$author$project$Data$PDF$Annotation$txtText(txt),
									txt))
							]));
				} else {
					return $elm$json$Json$Encode$null;
				}
			case 'IsDateField':
				var dateField_ = annot.a;
				var _v3 = $author$project$Data$PDF$Annotation$dateField(dateField_);
				var annotField = _v3.a;
				var dateTxt = _v3.b;
				var _v4 = $author$project$Data$PDF$Annotation$annotFieldData(annotField);
				var required = _v4.a;
				var name = _v4.b;
				var dataFieldDBId = $author$project$Data$PDF$Annotation$dateTxtDbId(dateTxt);
				return $elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'kind',
							$elm$json$Json$Encode$string('DateField')),
							_Utils_Tuple2(
							'name',
							$elm$json$Json$Encode$string(name)),
							_Utils_Tuple2(
							'required',
							$elm$json$Json$Encode$bool(required)),
							_Utils_Tuple2(
							'data',
							A3(
								$author$project$Data$PDF$Port$encodeDateText,
								rgbColourCode(dataFieldDBId),
								$author$project$Data$PDF$Annotation$toStringPosix(
									$author$project$Data$PDF$Annotation$dateTxtDate(dateTxt)),
								dateTxt))
						]));
			case 'IsSignatureField':
				var viewSigField = annot.a;
				var _v5 = $author$project$Data$PDF$Annotation$viewSignatureField(viewSigField);
				var signature = _v5.b;
				var _v6 = $author$project$Data$PDF$Annotation$signatureFields(signature);
				var id = _v6.a;
				var status = _v6.b;
				var style = _v6.c;
				var signatureFieldDbId = $author$project$Data$PDF$Annotation$signatureDbId(signature);
				if (status.$ === 'Unsigned') {
					var unsignedTxt = A2($author$project$Data$PDF$Annotation$unsignedTxtSignature, id, style);
					return $elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'kind',
								$elm$json$Json$Encode$string('UnsignedSignatureField')),
								_Utils_Tuple2(
								'data',
								A3(
									$author$project$Data$PDF$Port$encodeFreeText,
									rgbColourCode(signatureFieldDbId),
									$author$project$Data$PDF$Annotation$txtText(unsignedTxt),
									unsignedTxt))
							]));
				} else {
					var sig = status.a;
					return $elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'kind',
								$elm$json$Json$Encode$string('SignedSignatureField')),
								_Utils_Tuple2(
								'data',
								A4(
									$author$project$Data$PDF$Port$encodeSignedSignature,
									id,
									$author$project$Data$PDF$Signature$id(sig),
									$author$project$Data$PDF$Signature$data(sig),
									style))
							]));
				}
			case 'IsNumberField':
				var numField = annot.a;
				var isFilling = annot.b;
				if (isFilling) {
					var _v8 = $author$project$Data$PDF$Annotation$numberField(numField);
					var numberTxt = _v8.b;
					var numberDbId = $author$project$Data$PDF$Annotation$numberFieldDbId(numberTxt);
					return $elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'kind',
								$elm$json$Json$Encode$string('NumberField')),
								_Utils_Tuple2(
								'data',
								A3(
									$author$project$Data$PDF$Port$encodeNumberText,
									rgbColourCode(numberDbId),
									$elm$core$String$fromFloat(
										$author$project$Data$PDF$Annotation$numberTxtContent(numberTxt)),
									numberTxt))
							]));
				} else {
					return $elm$json$Json$Encode$null;
				}
			case 'IsStampField':
				var stampFieldData = annot.a;
				var _v9 = $author$project$Data$PDF$Annotation$stampField(stampFieldData);
				var annotField = _v9.a;
				var stamp = _v9.b;
				var _v10 = $author$project$Data$PDF$Annotation$stampFieldsStyle(stamp);
				var id = _v10.a;
				var style = _v10.b;
				var unsignedTxt = A2($author$project$Data$PDF$Annotation$unsignedTxtSignature, id, style);
				var stampFieldDbId = $author$project$Data$PDF$Annotation$stampDbId(stamp);
				var _v11 = $author$project$Data$PDF$Annotation$annotFieldData(annotField);
				var required = _v11.a;
				var name = _v11.b;
				return $elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'kind',
							$elm$json$Json$Encode$string('StampField')),
							_Utils_Tuple2(
							'name',
							$elm$json$Json$Encode$string(name)),
							_Utils_Tuple2(
							'required',
							$elm$json$Json$Encode$bool(required)),
							_Utils_Tuple2(
							'data',
							A3(
								$author$project$Data$PDF$Port$encodeFreeText,
								rgbColourCode(stampFieldDbId),
								'Stamp',
								unsignedTxt))
						]));
			case 'IsEmailField':
				var emailField = annot.a;
				var _v12 = $author$project$Data$PDF$Annotation$textField(emailField);
				var txt = _v12.b;
				var textfieldDbId = $author$project$Data$PDF$Annotation$txtDbId(txt);
				return $elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'kind',
							$elm$json$Json$Encode$string('EmailField')),
							_Utils_Tuple2(
							'data',
							A3(
								$author$project$Data$PDF$Port$encodeFreeText,
								rgbColourCode(textfieldDbId),
								$author$project$Data$PDF$Annotation$txtText(txt),
								txt))
						]));
			case 'IsNameField':
				var nameField = annot.a;
				var _v13 = $author$project$Data$PDF$Annotation$textField(nameField);
				var txt = _v13.b;
				var textfieldDbId = $author$project$Data$PDF$Annotation$txtDbId(txt);
				return $elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'kind',
							$elm$json$Json$Encode$string('NameField')),
							_Utils_Tuple2(
							'data',
							A3(
								$author$project$Data$PDF$Port$encodeFreeText,
								rgbColourCode(textfieldDbId),
								$author$project$Data$PDF$Annotation$txtText(txt),
								txt))
						]));
			default:
				var checkboxField = annot.a;
				var _v14 = $author$project$Data$PDF$Annotation$textField(checkboxField);
				var txt = _v14.b;
				var textfieldDbId = $author$project$Data$PDF$Annotation$txtDbId(txt);
				return $elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'kind',
							$elm$json$Json$Encode$string('CheckboxField')),
							_Utils_Tuple2(
							'data',
							A3(
								$author$project$Data$PDF$Port$encodeFreeText,
								rgbColourCode(textfieldDbId),
								$author$project$Data$PDF$Annotation$txtText(txt),
								txt))
						]));
		}
	});
var $author$project$Data$PDF$FillTemplate$encodeAnnotations = F3(
	function (annotList, rolesList, annotfieldsList) {
		return A2(
			$elm$json$Json$Encode$list,
			A2($author$project$Data$PDF$FillTemplate$encodeAnnotation, rolesList, annotfieldsList),
			annotList);
	});
var $author$project$Data$PDF$FillTemplate$encodeTemplate = F3(
	function (endpoint, jwt, _v0) {
		var template = _v0.a;
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'id',
					$elm$json$Json$Encode$string(template.id)),
					_Utils_Tuple2(
					'fileUrl',
					$elm$json$Json$Encode$string(endpoint + ('/' + (template.domain + ('/' + template.slug))))),
					_Utils_Tuple2(
					'jwt',
					$elm$json$Json$Encode$string(jwt)),
					_Utils_Tuple2(
					'email',
					$elm$json$Json$Encode$string(template.owner.email)),
					_Utils_Tuple2(
					'password',
					A2(
						$elm$core$Maybe$withDefault,
						$elm$json$Json$Encode$null,
						A2($elm$core$Maybe$map, $elm$json$Json$Encode$string, template.password))),
					_Utils_Tuple2(
					'version',
					$elm$json$Json$Encode$int(template.version)),
					_Utils_Tuple2(
					'annotations',
					A3($author$project$Data$PDF$FillTemplate$encodeAnnotations, template.annotations, template.roles, template.fieldAnnots))
				]));
	});
var $author$project$Data$PDF$Port$loadFillTemplate = _Platform_outgoingPort('loadFillTemplate', $elm$core$Basics$identity);
var $author$project$Data$PDF$FillTemplate$load = F3(
	function (endpoint, jwt, template) {
		return $author$project$Data$PDF$Port$loadFillTemplate(
			A3($author$project$Data$PDF$FillTemplate$encodeTemplate, endpoint, jwt, template));
	});
var $elm$browser$Browser$Navigation$reload = _Browser_reload(false);
var $author$project$Data$Api$PDF$ViewTemplate$signedSignatureId = function (annots) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (annot, accumlator) {
				var _v0 = annot.type_;
				if (_v0.$ === 'Signature') {
					var fileName = _v0.a;
					if (accumlator.$ === 'Just') {
						return accumlator;
					} else {
						return $elm$core$Maybe$Just(fileName);
					}
				} else {
					return accumlator;
				}
			}),
		$elm$core$Maybe$Nothing,
		annots);
};
var $author$project$Data$PDF$FillTemplate$unload = $author$project$Data$PDF$Port$closeDocument2;
var $author$project$Type$FillTemplate$EncryptionDecodeError = function (a) {
	return {$: 'EncryptionDecodeError', a: a};
};
var $author$project$Type$FillTemplate$Fill = {$: 'Fill'};
var $author$project$Type$FillTemplate$Filling = {$: 'Filling'};
var $author$project$Type$FillTemplate$NeedPassword = {$: 'NeedPassword'};
var $author$project$Type$FillTemplate$SubmitTemplateError = function (a) {
	return {$: 'SubmitTemplateError', a: a};
};
var $author$project$Type$FillTemplate$Success = {$: 'Success'};
var $author$project$Type$FillTemplate$TemplateValidation = function (a) {
	return {$: 'TemplateValidation', a: a};
};
var $author$project$Data$Api$PDF$SubmitFillTemplate$errorToString = function (error) {
	switch (error.$) {
		case 'TEMPLATE_NOT_FOUND':
			return 'Template does not exist.';
		case 'INCORRECT_PASSWORD_PROVIDED':
			return 'Password provided for pdf is incorrect.';
		case 'INVALID_ANNOTATION':
			return 'Unable to create pdf with the fields provided.';
		case 'FAIL_TO_UPDATE_ANNOTATION':
			return 'Unable to update template fields';
		case 'INVALID_DATA':
			return 'Invalid data provided. Please refresh and try again.';
		case 'INCORRECT_PASSWORD':
			return 'Password provided is incorrect.';
		case 'APPEND_ERROR':
			return 'Unable to append annotation(s) to the file.';
		case 'ENCRYPTION_ERROR':
			return 'Unable to encrypt and store uploaded file.';
		case 'INVALID_CERTIFICATE':
			return 'Invalid digital certificate.';
		case 'UNEDITABLE_PDF':
			return 'PDF is not editable.';
		case 'LOADING_ERROR':
			return 'Invalid PDF. Please upload a valid PDF file instead.';
		case 'SIGNATURE_HASH_ERROR':
			return 'Invalid digital signature hash received.';
		case 'FILE_NOT_FOUND':
			return 'An error has occur. Please try again later.';
		case 'TEMP_FILE_NOT_FOUND':
			return 'An error has occur. Please try again later.';
		default:
			return 'An error has occur. Please try again later.';
	}
};
var $author$project$Data$PDF$FillTemplate$loadWithPassword = F4(
	function (endpoint, jwt, password, _v0) {
		var template = _v0.a;
		var updatedTemplate = $author$project$Data$PDF$FillTemplate$Template(
			_Utils_update(
				template,
				{
					password: $elm$core$Maybe$Just(password)
				}));
		return _Utils_Tuple2(
			updatedTemplate,
			$author$project$Data$PDF$Port$loadFillTemplate(
				A3($author$project$Data$PDF$FillTemplate$encodeTemplate, endpoint, jwt, updatedTemplate)));
	});
var $author$project$Data$PDF$Annotation$numberTxtDbId = function (_v0) {
	var numTxt = _v0.a;
	return numTxt.dbId;
};
var $author$project$Data$PDF$Port$updateFillTemplate = _Platform_outgoingPort('updateFillTemplate', $elm$core$Basics$identity);
var $author$project$Data$PDF$FillTemplate$updateFillableField = F4(
	function (isFilling, dbId, value, _v0) {
		var template = _v0.a;
		var updatedAnnots = A2(
			$elm$core$List$map,
			function (annot) {
				switch (annot.$) {
					case 'IsTextField':
						var txtField = annot.a;
						var currentIsFilling = annot.b;
						var _v2 = $author$project$Data$PDF$Annotation$textField(txtField);
						var annotField = _v2.a;
						var txt = _v2.b;
						return _Utils_eq(
							$author$project$Data$PDF$Annotation$txtDbId(txt),
							dbId) ? A2(
							$author$project$Data$PDF$FillTemplate$IsTextField,
							A2(
								$author$project$Data$PDF$Annotation$toTextField,
								annotField,
								A4(
									$author$project$Data$PDF$Annotation$updateTxt,
									value,
									$author$project$Data$PDF$Annotation$Verified,
									$author$project$Data$PDF$Annotation$txtStyle(txt),
									txt)),
							isFilling) : A2($author$project$Data$PDF$FillTemplate$IsTextField, txtField, currentIsFilling);
					case 'IsNumberField':
						var numField = annot.a;
						var currentIsFilling = annot.b;
						var floatValue = function () {
							var _v4 = $elm$core$String$toFloat(value);
							if (_v4.$ === 'Nothing') {
								return 0.0;
							} else {
								var _float = _v4.a;
								return _float;
							}
						}();
						var _v3 = $author$project$Data$PDF$Annotation$numberField(numField);
						var annotField = _v3.a;
						var numberTxt = _v3.b;
						return _Utils_eq(
							$author$project$Data$PDF$Annotation$numberTxtDbId(numberTxt),
							dbId) ? A2(
							$author$project$Data$PDF$FillTemplate$IsNumberField,
							A2(
								$author$project$Data$PDF$Annotation$toNumberField,
								annotField,
								A4(
									$author$project$Data$PDF$Annotation$updateNumberTxt,
									floatValue,
									$author$project$Data$PDF$Annotation$Verified,
									$author$project$Data$PDF$Annotation$numberTxtStyle(numberTxt),
									numberTxt)),
							isFilling) : A2($author$project$Data$PDF$FillTemplate$IsNumberField, numField, currentIsFilling);
					default:
						return annot;
				}
			},
			template.annotations);
		var updatedTemplate = _Utils_update(
			template,
			{annotations: updatedAnnots});
		return _Utils_Tuple2(
			$author$project$Data$PDF$FillTemplate$Template(updatedTemplate),
			$author$project$Data$PDF$Port$updateFillTemplate(
				A3($author$project$Data$PDF$FillTemplate$encodeAnnotations, updatedAnnots, template.roles, template.fieldAnnots)));
	});
var $author$project$Data$PDF$Annotation$updatedSignedSignature = F2(
	function (dataSignature, _v0) {
		var signature = _v0.a;
		var generatedId = A3(
			$author$project$Data$PDF$Annotation$generateId,
			$author$project$Data$PDF$Signature$data(dataSignature),
			$author$project$Data$PDF$Annotation$toSignatureStatusString(signature.status),
			signature.style);
		return $author$project$Data$PDF$Annotation$Signature(
			_Utils_update(
				signature,
				{
					id: generatedId,
					status: $author$project$Data$PDF$Annotation$Signed(dataSignature)
				}));
	});
var $author$project$Data$PDF$FillTemplate$updateSignatureFields = F2(
	function (dataSig, _v0) {
		var template = _v0.a;
		var updatedAnnotations = A2(
			$elm$core$List$map,
			function (annot) {
				if (annot.$ === 'IsSignatureField') {
					var viewSigField = annot.a;
					var _v2 = $author$project$Data$PDF$Annotation$viewSignatureField(viewSigField);
					var annotField = _v2.a;
					var signature = _v2.b;
					return $author$project$Data$PDF$FillTemplate$IsSignatureField(
						A2(
							$author$project$Data$PDF$Annotation$toViewSignatureField,
							annotField,
							A2($author$project$Data$PDF$Annotation$updatedSignedSignature, dataSig, signature)));
				} else {
					return annot;
				}
			},
			template.annotations);
		var updatedTemplate = _Utils_update(
			template,
			{annotations: updatedAnnotations});
		return _Utils_Tuple2(
			$author$project$Data$PDF$FillTemplate$Template(updatedTemplate),
			$author$project$Data$PDF$Port$updateFillTemplate(
				A3($author$project$Data$PDF$FillTemplate$encodeAnnotations, updatedAnnotations, template.roles, template.fieldAnnots)));
	});
var $author$project$Data$PDF$Annotation$signatureStatus = function (_v0) {
	var status = _v0.a.status;
	return status;
};
var $author$project$Data$PDF$FillTemplate$validateTemplate = function (_v0) {
	var template = _v0.a;
	return A3(
		$elm$core$List$foldl,
		F2(
			function (annot, accumlator) {
				if (accumlator.$ === 'Nothing') {
					switch (annot.$) {
						case 'IsTextField':
							var txtField = annot.a;
							var isFilling = annot.b;
							var _v3 = $author$project$Data$PDF$Annotation$textField(txtField);
							var annotField = _v3.a;
							var txt = _v3.b;
							var _v4 = $author$project$Data$PDF$Annotation$annotFieldData(annotField);
							var name = _v4.b;
							return (isFilling && $elm$core$String$isEmpty(
								$author$project$Data$PDF$Annotation$txtText(txt))) ? $elm$core$Maybe$Just(name + ' field cannot be empty.') : $elm$core$Maybe$Nothing;
						case 'IsNumberField':
							var numField = annot.a;
							var isFilling = annot.b;
							var _v5 = $author$project$Data$PDF$Annotation$numberField(numField);
							var annotField = _v5.a;
							var numTxt = _v5.b;
							var _v6 = $author$project$Data$PDF$Annotation$annotFieldData(annotField);
							var name = _v6.b;
							return (isFilling && $elm$core$String$isEmpty(
								$elm$core$String$fromFloat(
									$author$project$Data$PDF$Annotation$numberTxtContent(numTxt)))) ? $elm$core$Maybe$Just(name + ' field cannot be empty.') : $elm$core$Maybe$Nothing;
						case 'IsSignatureField':
							var viewSigField = annot.a;
							var _v7 = $author$project$Data$PDF$Annotation$viewSignatureField(viewSigField);
							var signature = _v7.b;
							var status = $author$project$Data$PDF$Annotation$signatureStatus(signature);
							if (status.$ === 'Unsigned') {
								return $elm$core$Maybe$Just('Please select a signature to be filled in the template');
							} else {
								return $elm$core$Maybe$Nothing;
							}
						default:
							return $elm$core$Maybe$Nothing;
					}
				} else {
					var err = accumlator.a;
					return $elm$core$Maybe$Just(err);
				}
			}),
		$elm$core$Maybe$Nothing,
		template.annotations);
};
var $author$project$Model$FillTemplate$updateAnonymousLoadedModel = F4(
	function (msg, model, anonymousModel, appModel) {
		var updateAppModel = function (m) {
			return _Utils_update(
				appModel,
				{
					sessionModel: $author$project$Types$Anonymous(
						_Utils_update(
							anonymousModel,
							{
								fillTemplateModel: $author$project$Type$FillTemplate$Loaded(m)
							}))
				});
		};
		var _v0 = anonymousModel;
		var user = _v0.user;
		switch (msg.$) {
			case 'OnReceiveEncryptionError':
				var value = msg.a;
				var _v2 = $author$project$Data$PDF$Encryption$decode(value);
				if (_v2.$ === 'Ok') {
					var encryptionError = _v2.a;
					if (encryptionError.$ === 'PasswordFail') {
						return _Utils_Tuple2(
							updateAppModel(
								_Utils_update(
									model,
									{
										modal: $elm$core$Maybe$Just($author$project$Type$FillTemplate$NeedPassword),
										passwordError: $elm$core$Maybe$Just('Password failed.')
									})),
							$elm$core$Platform$Cmd$none);
					} else {
						return _Utils_Tuple2(
							updateAppModel(
								_Utils_update(
									model,
									{
										modal: $elm$core$Maybe$Just($author$project$Type$FillTemplate$NeedPassword),
										passwordError: $elm$core$Maybe$Nothing
									})),
							$elm$core$Platform$Cmd$none);
					}
				} else {
					var decodeErrorMessage = _v2.a;
					return _Utils_Tuple2(
						updateAppModel(
							_Utils_update(
								model,
								{
									error: $elm$core$Maybe$Just(
										$author$project$Type$FillTemplate$EncryptionDecodeError(decodeErrorMessage))
								})),
						$elm$core$Platform$Cmd$none);
				}
			case 'OnPasswordInput':
				var value = msg.a;
				return $elm$core$String$isEmpty(value) ? _Utils_Tuple2(
					updateAppModel(
						_Utils_update(
							model,
							{password: $elm$core$Maybe$Nothing, passwordError: $elm$core$Maybe$Nothing})),
					$elm$core$Platform$Cmd$none) : _Utils_Tuple2(
					updateAppModel(
						_Utils_update(
							model,
							{
								password: $elm$core$Maybe$Just(value),
								passwordError: $elm$core$Maybe$Nothing
							})),
					$elm$core$Platform$Cmd$none);
			case 'OnPasswordSubmit':
				var _v4 = A4(
					$author$project$Data$PDF$FillTemplate$loadWithPassword,
					appModel.apiEndPoint.templateFile,
					user.jwt,
					A2($elm$core$Maybe$withDefault, '', model.password),
					model.template);
				var updatedTemplate = _v4.a;
				var templateCmd = _v4.b;
				return _Utils_Tuple2(
					updateAppModel(
						_Utils_update(
							model,
							{modal: $elm$core$Maybe$Nothing, template: updatedTemplate})),
					templateCmd);
			case 'OnSignatureClick':
				var filledSignature = msg.a;
				var _v5 = A2($author$project$Data$PDF$FillTemplate$updateSignatureFields, filledSignature, model.template);
				var updatedTemplate = _v5.a;
				var templateCmd = _v5.b;
				return _Utils_Tuple2(
					updateAppModel(
						_Utils_update(
							model,
							{
								selectedSignature: $elm$core$Maybe$Just(filledSignature),
								template: updatedTemplate
							})),
					templateCmd);
			case 'OnFieldInput':
				var isFilling = msg.a;
				var dbId = msg.b;
				var value = msg.c;
				var _v6 = A4($author$project$Data$PDF$FillTemplate$updateFillableField, isFilling, dbId, value, model.template);
				var updatedTemplate = _v6.a;
				var templateCmd = _v6.b;
				return _Utils_Tuple2(
					updateAppModel(
						_Utils_update(
							model,
							{template: updatedTemplate})),
					templateCmd);
			case 'OnFieldChecked':
				var isFilling = msg.a;
				var dbId = msg.b;
				var value = msg.c;
				var _v7 = A4($author$project$Data$PDF$FillTemplate$updateFillableField, isFilling, dbId, value, model.template);
				var updatedTemplate = _v7.a;
				var templateCmd = _v7.b;
				return _Utils_Tuple2(
					updateAppModel(
						_Utils_update(
							model,
							{template: updatedTemplate})),
					templateCmd);
			case 'OnErrorClose':
				return _Utils_Tuple2(
					updateAppModel(
						_Utils_update(
							model,
							{error: $elm$core$Maybe$Nothing})),
					$elm$core$Platform$Cmd$none);
			case 'OnCloseModal':
				return _Utils_Tuple2(
					updateAppModel(
						_Utils_update(
							model,
							{modal: $elm$core$Maybe$Nothing})),
					$elm$core$Platform$Cmd$none);
			case 'OnTemplateSubmit':
				var isValid = $author$project$Data$PDF$FillTemplate$validateTemplate(model.template);
				if (isValid.$ === 'Nothing') {
					return _Utils_Tuple2(
						updateAppModel(
							_Utils_update(
								model,
								{
									modal: $elm$core$Maybe$Just($author$project$Type$FillTemplate$Fill)
								})),
						$elm$core$Platform$Cmd$none);
				} else {
					var err = isValid.a;
					return _Utils_Tuple2(
						updateAppModel(
							_Utils_update(
								model,
								{
									error: $elm$core$Maybe$Just(
										$author$project$Type$FillTemplate$TemplateValidation(err))
								})),
						$elm$core$Platform$Cmd$none);
				}
			case 'OnConfirmedTemplateSubmit':
				return _Utils_Tuple2(
					updateAppModel(
						_Utils_update(
							model,
							{
								modal: $elm$core$Maybe$Just($author$project$Type$FillTemplate$Filling)
							})),
					$elm$core$Platform$Cmd$none);
			case 'OnConfirmedTemplateSubmitResult':
				var result = msg.a;
				if (result.$ === 'Ok') {
					return _Utils_Tuple2(
						updateAppModel(
							_Utils_update(
								model,
								{
									modal: $elm$core$Maybe$Just($author$project$Type$FillTemplate$Success)
								})),
						$elm$core$Platform$Cmd$none);
				} else {
					var err = result.a;
					return _Utils_Tuple2(
						updateAppModel(
							_Utils_update(
								model,
								{
									error: $elm$core$Maybe$Just(
										$author$project$Type$FillTemplate$SubmitTemplateError(
											A2($author$project$Data$Api$authErrorToString, $author$project$Data$Api$PDF$SubmitFillTemplate$errorToString, err))),
									modal: $elm$core$Maybe$Nothing
								})),
						$elm$core$Platform$Cmd$none);
				}
			default:
				return _Utils_Tuple2(appModel, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Model$FillTemplate$updateAnonymousModel = F3(
	function (msg, anonymousModel, model) {
		var updateCurrentModel = function (currentModel) {
			return _Utils_update(
				model,
				{
					sessionModel: $author$project$Types$Anonymous(
						_Utils_update(
							anonymousModel,
							{fillTemplateModel: currentModel}))
				});
		};
		var _v0 = anonymousModel;
		var fillTemplateModel = _v0.fillTemplateModel;
		var user = _v0.user;
		var signatureModel = _v0.signatureModel;
		var maybeCurrentUserSig = $author$project$Type$Signature$firstSignature(signatureModel.signatures);
		switch (msg.$) {
			case 'OnUnload':
				return _Utils_Tuple2(
					updateCurrentModel($author$project$Type$FillTemplate$NotLoaded),
					$author$project$Data$PDF$FillTemplate$unload(_Utils_Tuple0));
			case 'LoadTemplate':
				var slug = msg.a;
				return _Utils_Tuple2(
					updateCurrentModel($author$project$Type$FillTemplate$Loading),
					A2(
						$elm$core$Task$attempt,
						A2(
							$elm$core$Basics$composeL,
							A2($elm$core$Basics$composeL, $author$project$Types$OnFillTemplate, $author$project$Type$FillTemplate$OnAuth),
							$author$project$Type$FillTemplate$LoadTemplateResult),
						A3(
							$author$project$Data$Api$PDF$ViewTemplate$authCall,
							user.jwt,
							model.apiEndPoint.viewTemplate,
							_Utils_Tuple2(
								$author$project$Data$Domain$toString(
									$author$project$Data$Domain$selected(anonymousModel.user.domains)),
								slug))));
			case 'LoadTemplateResult':
				var result = msg.a;
				if (result.$ === 'Ok') {
					var templatePayload = result.a;
					var maybeSignatureID = $author$project$Data$Api$PDF$ViewTemplate$signedSignatureId(templatePayload.filledAnnots);
					if (maybeSignatureID.$ === 'Just') {
						var sigId = maybeSignatureID.a;
						return _Utils_Tuple2(
							model,
							A2(
								$elm$core$Task$attempt,
								A2(
									$elm$core$Basics$composeL,
									A2($elm$core$Basics$composeL, $author$project$Types$OnFillTemplate, $author$project$Type$FillTemplate$OnAuth),
									$author$project$Type$FillTemplate$SignedSignatureResult(templatePayload)),
								A3($author$project$Data$Api$Signature$File$authCall, user.jwt, model.apiEndPoint.signatureFile, sigId)));
					} else {
						var templateResult = A4($author$project$Data$PDF$FillTemplate$initWithPayload, model.currentTime, maybeCurrentUserSig, $elm$core$Maybe$Nothing, templatePayload);
						if (templateResult.$ === 'Ok') {
							var templateData = templateResult.a;
							return _Utils_Tuple2(
								updateCurrentModel(
									$author$project$Type$FillTemplate$Loaded(
										{additionalMsg: $elm$core$Maybe$Nothing, algorandNotarisationCost: 0, algorandWalletAddresses: _List_Nil, base64FileData: $elm$core$Maybe$Nothing, binanceNotarisationCost: 0, createdDocumentId: '', currentRoleId: '', dueDate: $elm$core$Maybe$Nothing, dueDateError: $elm$core$Maybe$Nothing, error: $elm$core$Maybe$Nothing, modal: $elm$core$Maybe$Nothing, needOptIn: false, optInError: $elm$core$Maybe$Nothing, optInStatusCode: $elm$core$Maybe$Nothing, passcode: $elm$core$Maybe$Nothing, passcodeError: $elm$core$Maybe$Nothing, password: $elm$core$Maybe$Nothing, passwordError: $elm$core$Maybe$Nothing, payload: templatePayload, recipients: _List_Nil, requireNotarisation: false, searchTerm: '', selectedSignature: maybeCurrentUserSig, selectedWallet: $elm$core$Maybe$Nothing, showAdditionalMsg: false, showDueDate: false, showPasscodeInput: false, signPointsBalance: 0, signingOrderAssigned: false, signingType: $author$project$Type$FillTemplate$NoSigningOrder, stage: $author$project$Type$FillTemplate$Recipients, template: templateData, toolTipActiveHover: $author$project$Type$FillTemplate$Closed, walletError: $elm$core$Maybe$Nothing})),
								A3($author$project$Data$PDF$FillTemplate$load, model.apiEndPoint.templateFile, user.jwt, templateData));
						} else {
							var error = templateResult.a;
							return _Utils_Tuple2(
								updateCurrentModel(
									$author$project$Type$FillTemplate$LoadingDecodeError(error)),
								$elm$core$Platform$Cmd$none);
						}
					}
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						updateCurrentModel(
							$author$project$Type$FillTemplate$LoadingApiError(error)),
						$elm$core$Platform$Cmd$none);
				}
			case 'SignedSignatureResult':
				var templatePayload = msg.a;
				var result = msg.b;
				if (result.$ === 'Ok') {
					var payload = result.a;
					var _v6 = payload.signature;
					var id = _v6.id;
					var name = _v6.name;
					var data = _v6.data;
					var filledSignature = A3($author$project$Data$PDF$Signature$create, id, name, data);
					var templateResult = A4(
						$author$project$Data$PDF$FillTemplate$initWithPayload,
						model.currentTime,
						maybeCurrentUserSig,
						$elm$core$Maybe$Just(filledSignature),
						templatePayload);
					if (templateResult.$ === 'Ok') {
						var templateData = templateResult.a;
						return _Utils_Tuple2(
							updateCurrentModel(
								$author$project$Type$FillTemplate$Loaded(
									{additionalMsg: $elm$core$Maybe$Nothing, algorandNotarisationCost: 0, algorandWalletAddresses: _List_Nil, base64FileData: $elm$core$Maybe$Nothing, binanceNotarisationCost: 0, createdDocumentId: '', currentRoleId: '', dueDate: $elm$core$Maybe$Nothing, dueDateError: $elm$core$Maybe$Nothing, error: $elm$core$Maybe$Nothing, modal: $elm$core$Maybe$Nothing, needOptIn: false, optInError: $elm$core$Maybe$Nothing, optInStatusCode: $elm$core$Maybe$Nothing, passcode: $elm$core$Maybe$Nothing, passcodeError: $elm$core$Maybe$Nothing, password: $elm$core$Maybe$Nothing, passwordError: $elm$core$Maybe$Nothing, payload: templatePayload, recipients: _List_Nil, requireNotarisation: false, searchTerm: '', selectedSignature: maybeCurrentUserSig, selectedWallet: $elm$core$Maybe$Nothing, showAdditionalMsg: false, showDueDate: false, showPasscodeInput: false, signPointsBalance: 0, signingOrderAssigned: false, signingType: $author$project$Type$FillTemplate$NoSigningOrder, stage: $author$project$Type$FillTemplate$Recipients, template: templateData, toolTipActiveHover: $author$project$Type$FillTemplate$Closed, walletError: $elm$core$Maybe$Nothing})),
							A3($author$project$Data$PDF$FillTemplate$load, model.apiEndPoint.templateFile, user.jwt, templateData));
					} else {
						var error = templateResult.a;
						return _Utils_Tuple2(
							updateCurrentModel(
								$author$project$Type$FillTemplate$LoadingDecodeError(error)),
							$elm$core$Platform$Cmd$none);
					}
				} else {
					return _Utils_Tuple2(
						updateCurrentModel($author$project$Type$FillTemplate$LoadingSignatureError),
						$elm$core$Platform$Cmd$none);
				}
			case 'OnRefreshClick':
				return _Utils_Tuple2(model, $elm$browser$Browser$Navigation$reload);
			case 'OnNavigateToDashboard':
				return _Utils_Tuple2(
					model,
					A2($elm$browser$Browser$Navigation$pushUrl, model.navKey, $author$project$Data$Route$routeUrl.dashboard));
			case 'OnLoaded':
				var loadedMsg = msg.a;
				if (fillTemplateModel.$ === 'Loaded') {
					var loadedModel = fillTemplateModel.a;
					return A4($author$project$Model$FillTemplate$updateAnonymousLoadedModel, loadedMsg, loadedModel, anonymousModel, model);
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 'OnNavigateToRegister':
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{sessionModel: $author$project$Types$NoAuth}),
					A2($elm$browser$Browser$Navigation$pushUrl, model.navKey, $author$project$Data$Route$routeUrl.personalRegister + ('?email=' + anonymousModel.user.email)));
			case 'ViewTemplateInfo':
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 'ViewTemplateInfoResult':
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 'ViewTemplatesignedSignatureResult':
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			default:
				var loadedMsg = msg.a;
				if (fillTemplateModel.$ === 'ViewTemplate') {
					var loadedModel = fillTemplateModel.a;
					return A4($author$project$Model$FillTemplate$updateAnonymousLoadedModel, loadedMsg, loadedModel, anonymousModel, model);
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
		}
	});
var $author$project$Type$FillTemplate$SigningOrder = {$: 'SigningOrder'};
var $author$project$Type$FillTemplate$ViewTemplate = function (a) {
	return {$: 'ViewTemplate', a: a};
};
var $author$project$Type$FillTemplate$ViewTemplateInfoResult = function (a) {
	return {$: 'ViewTemplateInfoResult', a: a};
};
var $author$project$Type$FillTemplate$ViewTemplatesignedSignatureResult = F2(
	function (a, b) {
		return {$: 'ViewTemplatesignedSignatureResult', a: a, b: b};
	});
var $elm$core$Basics$min = F2(
	function (x, y) {
		return (_Utils_cmp(x, y) < 0) ? x : y;
	});
var $elm$core$List$minimum = function (list) {
	if (list.b) {
		var x = list.a;
		var xs = list.b;
		return $elm$core$Maybe$Just(
			A3($elm$core$List$foldl, $elm$core$Basics$min, x, xs));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Model$FillTemplate$removeDuplicates = F2(
	function (el, list) {
		return A2($elm$core$List$member, el, list) ? list : A2($elm$core$List$cons, el, list);
	});
var $author$project$Type$FillTemplate$CancelNotarisation = {$: 'CancelNotarisation'};
var $author$project$Type$FillTemplate$CancelNotarisationSuccess = {$: 'CancelNotarisationSuccess'};
var $author$project$Type$FillTemplate$CheckWalletOptIn = {$: 'CheckWalletOptIn'};
var $author$project$Type$FillTemplate$DeleteTemplateSuccess = {$: 'DeleteTemplateSuccess'};
var $author$project$Type$FillTemplate$DisplayWallet = function (a) {
	return {$: 'DisplayWallet', a: a};
};
var $author$project$Type$FillTemplate$DisplayWalletAddress = function (a) {
	return {$: 'DisplayWalletAddress', a: a};
};
var $author$project$Type$FillTemplate$Email = {$: 'Email'};
var $author$project$Type$FillTemplate$FirstName = {$: 'FirstName'};
var $author$project$Type$FillTemplate$GetWallet = {$: 'GetWallet'};
var $author$project$Type$FillTemplate$LastName = {$: 'LastName'};
var $author$project$Type$FillTemplate$LoadingStatus = function (a) {
	return {$: 'LoadingStatus', a: a};
};
var $author$project$Type$FillTemplate$MakePayment = {$: 'MakePayment'};
var $author$project$Type$FillTemplate$NotariseSuccess = function (a) {
	return {$: 'NotariseSuccess', a: a};
};
var $author$project$Type$FillTemplate$Notarize = {$: 'Notarize'};
var $author$project$Type$FillTemplate$NotarizingDocument = function (a) {
	return {$: 'NotarizingDocument', a: a};
};
var $author$project$Type$FillTemplate$OnCancelNotarisationResult = function (a) {
	return {$: 'OnCancelNotarisationResult', a: a};
};
var $author$project$Type$FillTemplate$OnDeleteTemplateResult = function (a) {
	return {$: 'OnDeleteTemplateResult', a: a};
};
var $author$project$Type$FillTemplate$OnDownloadTemplateReportResult = function (a) {
	return {$: 'OnDownloadTemplateReportResult', a: a};
};
var $author$project$Type$FillTemplate$OnGetNotarisationDetailsResult = function (a) {
	return {$: 'OnGetNotarisationDetailsResult', a: a};
};
var $author$project$Type$FillTemplate$OnGetOptInDetailsResult = function (a) {
	return {$: 'OnGetOptInDetailsResult', a: a};
};
var $author$project$Type$FillTemplate$OnRequestTemplateResult = function (a) {
	return {$: 'OnRequestTemplateResult', a: a};
};
var $author$project$Type$FillTemplate$OnSearchApiResult = function (a) {
	return {$: 'OnSearchApiResult', a: a};
};
var $author$project$Type$FillTemplate$OnSubmitTemplateAsDocumentResult = function (a) {
	return {$: 'OnSubmitTemplateAsDocumentResult', a: a};
};
var $author$project$Type$FillTemplate$OnViewTemplateInfo = function (a) {
	return {$: 'OnViewTemplateInfo', a: a};
};
var $author$project$Type$FillTemplate$OnWalletConnectNotarizationResponse = function (a) {
	return {$: 'OnWalletConnectNotarizationResponse', a: a};
};
var $author$project$Type$FillTemplate$OnWalletConnectOptInResponse = function (a) {
	return {$: 'OnWalletConnectOptInResponse', a: a};
};
var $author$project$Type$FillTemplate$OnWalletConnectRegisterApiResponse = function (a) {
	return {$: 'OnWalletConnectRegisterApiResponse', a: a};
};
var $author$project$Type$FillTemplate$OptIn = {$: 'OptIn'};
var $author$project$Type$FillTemplate$Options = {$: 'Options'};
var $author$project$Type$FillTemplate$Passcode = {$: 'Passcode'};
var $author$project$Type$FillTemplate$Payment = {$: 'Payment'};
var $author$project$Type$FillTemplate$RegisterWallet = {$: 'RegisterWallet'};
var $author$project$Type$FillTemplate$RequestDelete = {$: 'RequestDelete'};
var $author$project$Type$FillTemplate$RequestFillTemplateLink = {$: 'RequestFillTemplateLink'};
var $author$project$Type$FillTemplate$RequestTemplateSuccess = function (a) {
	return {$: 'RequestTemplateSuccess', a: a};
};
var $author$project$Type$FillTemplate$Search = {$: 'Search'};
var $author$project$Data$Api$PDF$CancelNotarisation$Payload = function (message) {
	return {message: message};
};
var $author$project$Data$Api$PDF$CancelNotarisation$dataDecoder = A2(
	$elm$json$Json$Decode$map,
	$author$project$Data$Api$PDF$CancelNotarisation$Payload,
	A2($elm$json$Json$Decode$field, 'message', $elm$json$Json$Decode$string));
var $author$project$Data$Api$PDF$CancelNotarisation$encode = function (documentId) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'id',
				$elm$json$Json$Encode$string(documentId))
			]));
};
var $author$project$Data$Api$PDF$CancelNotarisation$INVALID_DOCUMENT = {$: 'INVALID_DOCUMENT'};
var $author$project$Data$Api$PDF$CancelNotarisation$JWT_ERROR = {$: 'JWT_ERROR'};
var $author$project$Data$Api$PDF$CancelNotarisation$UNAUTHORISED_USER = {$: 'UNAUTHORISED_USER'};
var $author$project$Data$Api$PDF$CancelNotarisation$errorDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (errorCode) {
		switch (errorCode) {
			case 'UNAUTHORISED_USER':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$PDF$CancelNotarisation$UNAUTHORISED_USER);
			case 'INVALID_DOCUMENT':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$PDF$CancelNotarisation$INVALID_DOCUMENT);
			case 'JWT_ERROR':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$PDF$CancelNotarisation$JWT_ERROR);
			default:
				return $elm$json$Json$Decode$fail('Invalid error code: ' + errorCode);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Data$Api$PDF$CancelNotarisation$authCall = F3(
	function (jwt, endPoint, documentId) {
		return A5(
			$author$project$Data$Api$authCall,
			jwt,
			endPoint,
			$author$project$Data$Api$PDF$CancelNotarisation$errorDecoder,
			$author$project$Data$Api$PDF$CancelNotarisation$dataDecoder,
			$author$project$Data$Api$PDF$CancelNotarisation$encode(documentId));
	});
var $author$project$Data$Api$PDF$DeleteTemplate$Payload = function (message) {
	return {message: message};
};
var $author$project$Data$Api$PDF$DeleteTemplate$dataDecoder = A2(
	$elm$json$Json$Decode$map,
	$author$project$Data$Api$PDF$DeleteTemplate$Payload,
	A2($elm$json$Json$Decode$field, 'message', $elm$json$Json$Decode$string));
var $author$project$Data$Api$PDF$DeleteTemplate$encode = F2(
	function (templateId, domain) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'templateId',
					$elm$json$Json$Encode$string(templateId)),
					_Utils_Tuple2(
					'domain',
					$elm$json$Json$Encode$string(
						$author$project$Data$Domain$toString(domain)))
				]));
	});
var $author$project$Data$Api$PDF$DeleteTemplate$NOT_FOUND = {$: 'NOT_FOUND'};
var $author$project$Data$Api$PDF$DeleteTemplate$UNAUTHORISED_USER = {$: 'UNAUTHORISED_USER'};
var $author$project$Data$Api$PDF$DeleteTemplate$errorDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (errorCode) {
		switch (errorCode) {
			case 'UNAUTHORISED_USER':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$PDF$DeleteTemplate$UNAUTHORISED_USER);
			case 'NOT_FOUND':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$PDF$DeleteTemplate$NOT_FOUND);
			default:
				return $elm$json$Json$Decode$fail('Invalid error code: ' + errorCode);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Data$Api$PDF$DeleteTemplate$authCall = F4(
	function (jwt, endPoint, templateId, domain) {
		return A5(
			$author$project$Data$Api$authCall,
			jwt,
			endPoint,
			$author$project$Data$Api$PDF$DeleteTemplate$errorDecoder,
			$author$project$Data$Api$PDF$DeleteTemplate$dataDecoder,
			A2($author$project$Data$Api$PDF$DeleteTemplate$encode, templateId, domain));
	});
var $elm$bytes$Bytes$Encode$getWidth = function (builder) {
	switch (builder.$) {
		case 'I8':
			return 1;
		case 'I16':
			return 2;
		case 'I32':
			return 4;
		case 'U8':
			return 1;
		case 'U16':
			return 2;
		case 'U32':
			return 4;
		case 'F32':
			return 4;
		case 'F64':
			return 8;
		case 'Seq':
			var w = builder.a;
			return w;
		case 'Utf8':
			var w = builder.a;
			return w;
		default:
			var bs = builder.a;
			return _Bytes_width(bs);
	}
};
var $elm$bytes$Bytes$LE = {$: 'LE'};
var $elm$bytes$Bytes$Encode$write = F3(
	function (builder, mb, offset) {
		switch (builder.$) {
			case 'I8':
				var n = builder.a;
				return A3(_Bytes_write_i8, mb, offset, n);
			case 'I16':
				var e = builder.a;
				var n = builder.b;
				return A4(
					_Bytes_write_i16,
					mb,
					offset,
					n,
					_Utils_eq(e, $elm$bytes$Bytes$LE));
			case 'I32':
				var e = builder.a;
				var n = builder.b;
				return A4(
					_Bytes_write_i32,
					mb,
					offset,
					n,
					_Utils_eq(e, $elm$bytes$Bytes$LE));
			case 'U8':
				var n = builder.a;
				return A3(_Bytes_write_u8, mb, offset, n);
			case 'U16':
				var e = builder.a;
				var n = builder.b;
				return A4(
					_Bytes_write_u16,
					mb,
					offset,
					n,
					_Utils_eq(e, $elm$bytes$Bytes$LE));
			case 'U32':
				var e = builder.a;
				var n = builder.b;
				return A4(
					_Bytes_write_u32,
					mb,
					offset,
					n,
					_Utils_eq(e, $elm$bytes$Bytes$LE));
			case 'F32':
				var e = builder.a;
				var n = builder.b;
				return A4(
					_Bytes_write_f32,
					mb,
					offset,
					n,
					_Utils_eq(e, $elm$bytes$Bytes$LE));
			case 'F64':
				var e = builder.a;
				var n = builder.b;
				return A4(
					_Bytes_write_f64,
					mb,
					offset,
					n,
					_Utils_eq(e, $elm$bytes$Bytes$LE));
			case 'Seq':
				var bs = builder.b;
				return A3($elm$bytes$Bytes$Encode$writeSequence, bs, mb, offset);
			case 'Utf8':
				var s = builder.b;
				return A3(_Bytes_write_string, mb, offset, s);
			default:
				var bs = builder.a;
				return A3(_Bytes_write_bytes, mb, offset, bs);
		}
	});
var $elm$bytes$Bytes$Encode$writeSequence = F3(
	function (builders, mb, offset) {
		writeSequence:
		while (true) {
			if (!builders.b) {
				return offset;
			} else {
				var b = builders.a;
				var bs = builders.b;
				var $temp$builders = bs,
					$temp$mb = mb,
					$temp$offset = A3($elm$bytes$Bytes$Encode$write, b, mb, offset);
				builders = $temp$builders;
				mb = $temp$mb;
				offset = $temp$offset;
				continue writeSequence;
			}
		}
	});
var $elm$bytes$Bytes$Decode$decode = F2(
	function (_v0, bs) {
		var decoder = _v0.a;
		return A2(_Bytes_decode, decoder, bs);
	});
var $elm$bytes$Bytes$Decode$Decoder = function (a) {
	return {$: 'Decoder', a: a};
};
var $elm$bytes$Bytes$Decode$string = function (n) {
	return $elm$bytes$Bytes$Decode$Decoder(
		_Bytes_read_string(n));
};
var $elm$bytes$Bytes$width = _Bytes_width;
var $author$project$Data$Api$authFileResponseResolver = F2(
	function (errorDecoder, response) {
		switch (response.$) {
			case 'BadUrl_':
				var url = response.a;
				return $elm$core$Result$Err(
					$author$project$Data$Api$ApiError(
						$author$project$Data$Api$BadUrl(url)));
			case 'Timeout_':
				return $elm$core$Result$Err(
					$author$project$Data$Api$ApiError($author$project$Data$Api$Timeout));
			case 'NetworkError_':
				return $elm$core$Result$Err(
					$author$project$Data$Api$ApiError($author$project$Data$Api$NetworkError));
			case 'BadStatus_':
				var metadata = response.a;
				var body = response.b;
				var error = A2(
					$elm$core$Maybe$withDefault,
					'',
					A2(
						$elm$bytes$Bytes$Decode$decode,
						$elm$bytes$Bytes$Decode$string(
							$elm$bytes$Bytes$width(body)),
						body));
				if (metadata.statusCode === 500) {
					return $elm$core$Result$Err(
						$author$project$Data$Api$ApiError($author$project$Data$Api$ServerInternalError));
				} else {
					if (metadata.statusCode === 400) {
						var _v1 = A2($elm$json$Json$Decode$decodeString, $author$project$Data$Api$jwtErrorDecoder, error);
						if (_v1.$ === 'Ok') {
							var tokenError = _v1.a;
							return $elm$core$Result$Err(
								$author$project$Data$Api$JWTError(tokenError));
						} else {
							var _v2 = A2(
								$elm$json$Json$Decode$decodeString,
								$author$project$Data$Api$failureDecoder(errorDecoder),
								error);
							if (_v2.$ === 'Ok') {
								var failure = _v2.a;
								return $elm$core$Result$Err(
									$author$project$Data$Api$ApiError(
										$author$project$Data$Api$Fail(failure.code)));
							} else {
								var err = _v2.a;
								return $elm$core$Result$Err(
									$author$project$Data$Api$ApiError(
										$author$project$Data$Api$NonStandardApiError(
											$elm$json$Json$Decode$errorToString(err))));
							}
						}
					} else {
						return $elm$core$Result$Err(
							$author$project$Data$Api$ApiError(
								A2($author$project$Data$Api$BadStatus, metadata, error)));
					}
				}
			default:
				var body = response.b;
				return $elm$core$Result$Ok(body);
		}
	});
var $elm$http$Http$bytesResolver = A2(_Http_expect, 'arraybuffer', _Http_toDataView);
var $author$project$Data$Api$authGetFile = F3(
	function (jwt, url, errorDecoder) {
		return $elm$http$Http$task(
			{
				body: $elm$http$Http$emptyBody,
				headers: _List_fromArray(
					[
						A2($elm$http$Http$header, 'Authorization', 'Bearer ' + jwt)
					]),
				method: 'GET',
				resolver: $elm$http$Http$bytesResolver(
					$author$project$Data$Api$authFileResponseResolver(errorDecoder)),
				timeout: $elm$core$Maybe$Just(180000),
				url: url
			});
	});
var $author$project$Data$Api$PDF$DownloadTemplateReport$FILE_NOT_FOUND = {$: 'FILE_NOT_FOUND'};
var $author$project$Data$Api$PDF$DownloadTemplateReport$TEMPLATE_NOT_FOUND = {$: 'TEMPLATE_NOT_FOUND'};
var $author$project$Data$Api$PDF$DownloadTemplateReport$UNAUTHORISED_USER = {$: 'UNAUTHORISED_USER'};
var $author$project$Data$Api$PDF$DownloadTemplateReport$errorDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (errorCode) {
		switch (errorCode) {
			case 'TEMPLATE_NOT_FOUND':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$PDF$DownloadTemplateReport$TEMPLATE_NOT_FOUND);
			case 'FILE_NOT_FOUND':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$PDF$DownloadTemplateReport$FILE_NOT_FOUND);
			case 'UNAUTHORISED_USER':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$PDF$DownloadTemplateReport$UNAUTHORISED_USER);
			default:
				return $elm$json$Json$Decode$fail('Invalid error code: ' + errorCode);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Data$Api$PDF$DownloadTemplateReport$authCall = F4(
	function (jwt, endPoint, templateId, offset) {
		return A3(
			$author$project$Data$Api$authGetFile,
			jwt,
			endPoint + (templateId + ('/' + $elm$core$String$fromFloat(offset))),
			$author$project$Data$Api$PDF$DownloadTemplateReport$errorDecoder);
	});
var $author$project$Data$Api$PDF$GetOptInDetails$Payload = function (message) {
	return {message: message};
};
var $author$project$Data$Api$PDF$GetOptInDetails$dataDecoder = A2(
	$elm$json$Json$Decode$map,
	$author$project$Data$Api$PDF$GetOptInDetails$Payload,
	A2($elm$json$Json$Decode$field, 'message', $elm$json$Json$Decode$string));
var $author$project$Data$Api$PDF$GetOptInDetails$encode = F4(
	function (documentId, transactionHash, blockNumber, walletAddress) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'id',
					$elm$json$Json$Encode$string(documentId)),
					_Utils_Tuple2(
					'transactionHash',
					$elm$json$Json$Encode$string(transactionHash)),
					_Utils_Tuple2(
					'blockNumber',
					$elm$json$Json$Encode$int(blockNumber)),
					_Utils_Tuple2(
					'walletAddress',
					$elm$json$Json$Encode$string(walletAddress))
				]));
	});
var $author$project$Data$Api$PDF$GetOptInDetails$INVALID_NETWORK_TYPE = {$: 'INVALID_NETWORK_TYPE'};
var $author$project$Data$Api$PDF$GetOptInDetails$JWT_ERROR = {$: 'JWT_ERROR'};
var $author$project$Data$Api$PDF$GetOptInDetails$UNAUTHORISED_USER = {$: 'UNAUTHORISED_USER'};
var $author$project$Data$Api$PDF$GetOptInDetails$errorDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (errorCode) {
		switch (errorCode) {
			case 'UNAUTHORISED_USER':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$PDF$GetOptInDetails$UNAUTHORISED_USER);
			case 'INVALID_NETWORK_TYPE':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$PDF$GetOptInDetails$INVALID_NETWORK_TYPE);
			case 'JWT_ERROR':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$PDF$GetOptInDetails$JWT_ERROR);
			default:
				return $elm$json$Json$Decode$fail('Invalid error code: ' + errorCode);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Data$Api$PDF$GetOptInDetails$authCall = F6(
	function (jwt, endPoint, documentId, transactionHash, blockNumber, walletAddress) {
		return A5(
			$author$project$Data$Api$authCall,
			jwt,
			endPoint,
			$author$project$Data$Api$PDF$GetOptInDetails$errorDecoder,
			$author$project$Data$Api$PDF$GetOptInDetails$dataDecoder,
			A4($author$project$Data$Api$PDF$GetOptInDetails$encode, documentId, transactionHash, blockNumber, walletAddress));
	});
var $author$project$Data$Api$PDF$NotariseWithAlgorandWallet$Payload = function (message) {
	return {message: message};
};
var $author$project$Data$Api$PDF$NotariseWithAlgorandWallet$dataDecoder = A2(
	$elm$json$Json$Decode$map,
	$author$project$Data$Api$PDF$NotariseWithAlgorandWallet$Payload,
	A2($elm$json$Json$Decode$field, 'message', $elm$json$Json$Decode$string));
var $author$project$Data$Api$PDF$NotariseWithAlgorandWallet$encode = F6(
	function (documentId, transactionHash, blockNumber, notarisationTimeStamp, walletAddress, isCompleted) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'id',
					$elm$json$Json$Encode$string(documentId)),
					_Utils_Tuple2(
					'transactionHash',
					$elm$json$Json$Encode$string(transactionHash)),
					_Utils_Tuple2(
					'blockNumber',
					$elm$json$Json$Encode$int(blockNumber)),
					_Utils_Tuple2(
					'notarisationTimeStamp',
					$elm$json$Json$Encode$int(notarisationTimeStamp)),
					_Utils_Tuple2(
					'walletAddress',
					$elm$json$Json$Encode$string(walletAddress)),
					_Utils_Tuple2(
					'isCompleted',
					$elm$json$Json$Encode$bool(isCompleted))
				]));
	});
var $author$project$Data$Api$PDF$NotariseWithAlgorandWallet$INVALID_NETWORK_TYPE = {$: 'INVALID_NETWORK_TYPE'};
var $author$project$Data$Api$PDF$NotariseWithAlgorandWallet$JWT_ERROR = {$: 'JWT_ERROR'};
var $author$project$Data$Api$PDF$NotariseWithAlgorandWallet$UNAUTHORISED_USER = {$: 'UNAUTHORISED_USER'};
var $author$project$Data$Api$PDF$NotariseWithAlgorandWallet$UNCOMPLETED_DOCUMENT = {$: 'UNCOMPLETED_DOCUMENT'};
var $author$project$Data$Api$PDF$NotariseWithAlgorandWallet$errorDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (errorCode) {
		switch (errorCode) {
			case 'UNAUTHORISED_USER':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$PDF$NotariseWithAlgorandWallet$UNAUTHORISED_USER);
			case 'UNCOMPLETED_DOCUMENT':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$PDF$NotariseWithAlgorandWallet$UNCOMPLETED_DOCUMENT);
			case 'INVALID_NETWORK_TYPE':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$PDF$NotariseWithAlgorandWallet$INVALID_NETWORK_TYPE);
			case 'JWT_ERROR':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$PDF$NotariseWithAlgorandWallet$JWT_ERROR);
			default:
				return $elm$json$Json$Decode$fail('Invalid error code: ' + errorCode);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Data$Api$PDF$NotariseWithAlgorandWallet$authCall = F8(
	function (jwt, endPoint, documentId, transactionHash, blockNumber, notarisationTimeStamp, walletAddress, isCompleted) {
		return A5(
			$author$project$Data$Api$authCall,
			jwt,
			endPoint,
			$author$project$Data$Api$PDF$NotariseWithAlgorandWallet$errorDecoder,
			$author$project$Data$Api$PDF$NotariseWithAlgorandWallet$dataDecoder,
			A6($author$project$Data$Api$PDF$NotariseWithAlgorandWallet$encode, documentId, transactionHash, blockNumber, notarisationTimeStamp, walletAddress, isCompleted));
	});
var $author$project$Data$Api$PDF$SendTemplateAsDocument$Payload = F2(
	function (message, docId) {
		return {docId: docId, message: message};
	});
var $author$project$Data$Api$PDF$SendTemplateAsDocument$dataDecoder = A3(
	$elm$json$Json$Decode$map2,
	$author$project$Data$Api$PDF$SendTemplateAsDocument$Payload,
	A2($elm$json$Json$Decode$field, 'message', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'docId', $elm$json$Json$Decode$string));
var $author$project$Data$Api$PDF$SendTemplateAsDocument$encodeDocumentDetails = function (documentDetails) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'dueDate',
				A2(
					$elm$core$Maybe$withDefault,
					$elm$json$Json$Encode$null,
					A2($elm$core$Maybe$map, $elm$json$Json$Encode$string, documentDetails.dueDate))),
				_Utils_Tuple2(
				'additionalMsg',
				A2(
					$elm$core$Maybe$withDefault,
					$elm$json$Json$Encode$null,
					A2($elm$core$Maybe$map, $elm$json$Json$Encode$string, documentDetails.additionalMsg))),
				_Utils_Tuple2(
				'requireNotarisation',
				$elm$json$Json$Encode$bool(documentDetails.requireNotarisation)),
				_Utils_Tuple2(
				'passcode',
				A2(
					$elm$core$Maybe$withDefault,
					$elm$json$Json$Encode$null,
					A2($elm$core$Maybe$map, $elm$json$Json$Encode$string, documentDetails.passcode)))
			]));
};
var $author$project$Data$Api$PDF$SendTemplateAsDocument$encodeSigners = function (signers) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'email',
				$elm$json$Json$Encode$string(signers.email)),
				_Utils_Tuple2(
				'firstName',
				$elm$json$Json$Encode$string(signers.firstName)),
				_Utils_Tuple2(
				'lastName',
				$elm$json$Json$Encode$string(signers.lastName)),
				_Utils_Tuple2(
				'role',
				$elm$json$Json$Encode$string(signers.role)),
				_Utils_Tuple2(
				'roleId',
				$elm$json$Json$Encode$string(signers.roleId)),
				_Utils_Tuple2(
				'signOrder',
				$elm$json$Json$Encode$int(signers.signOrder))
			]));
};
var $author$project$Data$Api$PDF$SendTemplateAsDocument$encode = F4(
	function (templateId, version, documentDetails, signers) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'templateId',
					$elm$json$Json$Encode$string(templateId)),
					_Utils_Tuple2(
					'version',
					$elm$json$Json$Encode$int(version)),
					_Utils_Tuple2(
					'documentDetails',
					$author$project$Data$Api$PDF$SendTemplateAsDocument$encodeDocumentDetails(documentDetails)),
					_Utils_Tuple2(
					'signers',
					A2($elm$json$Json$Encode$list, $author$project$Data$Api$PDF$SendTemplateAsDocument$encodeSigners, signers))
				]));
	});
var $author$project$Data$Api$PDF$SendTemplateAsDocument$INVALID_PASSCODE_FORMAT = {$: 'INVALID_PASSCODE_FORMAT'};
var $author$project$Data$Api$PDF$SendTemplateAsDocument$JWT_ERROR = {$: 'JWT_ERROR'};
var $author$project$Data$Api$PDF$SendTemplateAsDocument$TEMPLATE_NOT_FOUND = {$: 'TEMPLATE_NOT_FOUND'};
var $author$project$Data$Api$PDF$SendTemplateAsDocument$UNAUTHORISED_USER = {$: 'UNAUTHORISED_USER'};
var $author$project$Data$Api$PDF$SendTemplateAsDocument$errorDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (errorCode) {
		switch (errorCode) {
			case 'TEMPLATE_NOT_FOUND':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$PDF$SendTemplateAsDocument$TEMPLATE_NOT_FOUND);
			case 'INVALID_PASSCODE_FORMAT':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$PDF$SendTemplateAsDocument$INVALID_PASSCODE_FORMAT);
			case 'JWT_ERROR':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$PDF$SendTemplateAsDocument$JWT_ERROR);
			case 'UNAUTHORISED_USER':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$PDF$SendTemplateAsDocument$UNAUTHORISED_USER);
			default:
				return $elm$json$Json$Decode$fail('Invalid error code: ' + errorCode);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Data$Api$PDF$SendTemplateAsDocument$authCall = F6(
	function (jwt, endPoint, templateId, version, documentDetails, signers) {
		return A5(
			$author$project$Data$Api$authCall,
			jwt,
			endPoint,
			$author$project$Data$Api$PDF$SendTemplateAsDocument$errorDecoder,
			$author$project$Data$Api$PDF$SendTemplateAsDocument$dataDecoder,
			A4($author$project$Data$Api$PDF$SendTemplateAsDocument$encode, templateId, version, documentDetails, signers));
	});
var $author$project$Data$Api$Points$WalletRegistration$Payload = function (message) {
	return {message: message};
};
var $author$project$Data$Api$Points$WalletRegistration$dataDecoder = A2(
	$elm$json$Json$Decode$map,
	$author$project$Data$Api$Points$WalletRegistration$Payload,
	A2($elm$json$Json$Decode$field, 'message', $elm$json$Json$Decode$string));
var $author$project$Data$Api$Points$WalletRegistration$encode = F2(
	function (walletID, network) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'walletID',
					$elm$json$Json$Encode$string(walletID)),
					_Utils_Tuple2(
					'network',
					$elm$json$Json$Encode$string(network))
				]));
	});
var $author$project$Data$Api$Points$WalletRegistration$errorDecoder = $elm$json$Json$Decode$succeed(_Utils_Tuple0);
var $author$project$Data$Api$Points$WalletRegistration$authCall = F4(
	function (jwt, endPoint, walletID, network) {
		return A5(
			$author$project$Data$Api$authCall,
			jwt,
			endPoint,
			$author$project$Data$Api$Points$WalletRegistration$errorDecoder,
			$author$project$Data$Api$Points$WalletRegistration$dataDecoder,
			A2($author$project$Data$Api$Points$WalletRegistration$encode, walletID, network));
	});
var $elm$file$File$Download$bytes = F3(
	function (name, mime, content) {
		return A2(
			$elm$core$Task$perform,
			$elm$core$Basics$never,
			A3(
				_File_download,
				name,
				mime,
				_File_makeBytesSafeForInternetExplorer(content)));
	});
var $author$project$Model$FillTemplate$checkDuplicateRecipientEmail = F2(
	function (value, recipients) {
		var noOfDuplicateEmail = $elm$core$List$length(
			A2(
				$elm$core$List$filter,
				function (s) {
					return _Utils_eq(s.email, value);
				},
				recipients));
		return (A2(
			$elm$regex$Regex$contains,
			A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('\\S+@\\S+\\.\\S+')),
			value) && (noOfDuplicateEmail === 1)) ? $elm$core$Maybe$Nothing : ((noOfDuplicateEmail > 1) ? $elm$core$Maybe$Just('This email has already been added as a recipient') : $elm$core$Maybe$Just('Email is invalid.'));
	});
var $author$project$Model$ViewDocument$checkOptIn = _Platform_outgoingPort(
	'checkOptIn',
	function ($) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'location',
					$elm$json$Json$Encode$string($.location)),
					_Utils_Tuple2(
					'selectedWallet',
					$elm$json$Json$Encode$string($.selectedWallet))
				]));
	});
var $author$project$Type$FillTemplate$Algorand = {$: 'Algorand'};
var $author$project$Type$FillTemplate$Binance = {$: 'Binance'};
var $author$project$Model$FillTemplate$convertStringToNetwork = function (currentUserNotarisationNetwork) {
	switch (currentUserNotarisationNetwork) {
		case 'Binance':
			return $author$project$Type$FillTemplate$Binance;
		case 'Algorand':
			return $author$project$Type$FillTemplate$Algorand;
		default:
			return $author$project$Type$FillTemplate$Binance;
	}
};
var $author$project$Data$PDF$Port$decodeBase64String = function (value) {
	var _v0 = A2($elm$json$Json$Decode$decodeValue, $elm$json$Json$Decode$string, value);
	if (_v0.$ === 'Ok') {
		var result = _v0.a;
		return $elm$core$Result$Ok(result);
	} else {
		return $elm$core$Result$Err('Unable to base64 data.');
	}
};
var $author$project$Data$AlgorandWallet$NotarisationResult = F3(
	function (transactionHash, blockNumber, notarisationTimeStamp) {
		return {blockNumber: blockNumber, notarisationTimeStamp: notarisationTimeStamp, transactionHash: transactionHash};
	});
var $author$project$Data$AlgorandWallet$decodeNotarisation = A4(
	$elm$json$Json$Decode$map3,
	$author$project$Data$AlgorandWallet$NotarisationResult,
	A2($elm$json$Json$Decode$field, 'transactionHash', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'blockNumber', $elm$json$Json$Decode$int),
	A2($elm$json$Json$Decode$field, 'notarisationTimeStamp', $elm$json$Json$Decode$int));
var $author$project$Data$AlgorandWallet$decodeNotarisationResult = function (value) {
	var _v0 = A2($elm$json$Json$Decode$decodeValue, $author$project$Data$AlgorandWallet$decodeNotarisation, value);
	if (_v0.$ === 'Ok') {
		var results = _v0.a;
		return $elm$core$Result$Ok(results);
	} else {
		return $elm$core$Result$Err('Unable to retrieve notarisation result.');
	}
};
var $author$project$Data$AlgorandWallet$Error = function (error) {
	return {error: error};
};
var $author$project$Data$AlgorandWallet$decodeError = A2(
	$elm$json$Json$Decode$map,
	$author$project$Data$AlgorandWallet$Error,
	A2($elm$json$Json$Decode$field, 'error', $elm$json$Json$Decode$string));
var $author$project$Data$AlgorandWallet$decodeOptInError = function (value) {
	var _v0 = A2($elm$json$Json$Decode$decodeValue, $author$project$Data$AlgorandWallet$decodeError, value);
	if (_v0.$ === 'Ok') {
		var results = _v0.a;
		return $elm$core$Result$Ok(results);
	} else {
		return $elm$core$Result$Err('Unable to opt-in.');
	}
};
var $author$project$Data$AlgorandWallet$OptInStatus = function (needOptIn) {
	return {needOptIn: needOptIn};
};
var $author$project$Data$AlgorandWallet$decodeOptInStatus = A2(
	$elm$json$Json$Decode$map,
	$author$project$Data$AlgorandWallet$OptInStatus,
	A2($elm$json$Json$Decode$field, 'needOptIn', $elm$json$Json$Decode$bool));
var $author$project$Data$AlgorandWallet$decodeOptInStatusResult = function (value) {
	var _v0 = A2($elm$json$Json$Decode$decodeValue, $author$project$Data$AlgorandWallet$decodeOptInStatus, value);
	if (_v0.$ === 'Ok') {
		var results = _v0.a;
		return $elm$core$Result$Ok(results);
	} else {
		return $elm$core$Result$Err('Unable to retrieve Opt In status.');
	}
};
var $author$project$Data$AlgorandWallet$decodePaymentTransactionError = function (value) {
	var _v0 = A2($elm$json$Json$Decode$decodeValue, $author$project$Data$AlgorandWallet$decodeError, value);
	if (_v0.$ === 'Ok') {
		var results = _v0.a;
		return $elm$core$Result$Ok(results);
	} else {
		return $elm$core$Result$Err('Unable to opt-in.');
	}
};
var $author$project$Data$AlgorandWallet$Status = F3(
	function (status, transactionHash, blockNumber) {
		return {blockNumber: blockNumber, status: status, transactionHash: transactionHash};
	});
var $author$project$Data$AlgorandWallet$decodeStatus = A4(
	$elm$json$Json$Decode$map3,
	$author$project$Data$AlgorandWallet$Status,
	A2($elm$json$Json$Decode$field, 'status', $elm$json$Json$Decode$int),
	A2($elm$json$Json$Decode$field, 'transactionHash', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'blockNumber', $elm$json$Json$Decode$int));
var $author$project$Data$AlgorandWallet$decodeStatusResult = function (value) {
	var _v0 = A2($elm$json$Json$Decode$decodeValue, $author$project$Data$AlgorandWallet$decodeStatus, value);
	if (_v0.$ === 'Ok') {
		var results = _v0.a;
		return $elm$core$Result$Ok(results);
	} else {
		return $elm$core$Result$Err('Unable to retrieve opt-in result.');
	}
};
var $author$project$Data$Wallet$TransactionDetails = F3(
	function (address, id, block) {
		return {address: address, block: block, id: id};
	});
var $author$project$Data$Wallet$decodeTransactionDetails = A4(
	$elm$json$Json$Decode$map3,
	$author$project$Data$Wallet$TransactionDetails,
	A2($elm$json$Json$Decode$field, 'address', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'id', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'block', $elm$json$Json$Decode$int));
var $author$project$Data$Wallet$decodeWalletAddress = function (value) {
	var _v0 = A2($elm$json$Json$Decode$decodeValue, $author$project$Data$Wallet$decodeTransactionDetails, value);
	if (_v0.$ === 'Ok') {
		var results = _v0.a;
		return $elm$core$Result$Ok(results);
	} else {
		return $elm$core$Result$Err('Unable to retrieve wallet details.');
	}
};
var $author$project$Data$Wallet$WalletConnect = F2(
	function (address, needOptIn) {
		return {address: address, needOptIn: needOptIn};
	});
var $author$project$Data$Wallet$decodeWalletList = $elm$json$Json$Decode$list(
	A3(
		$elm$json$Json$Decode$map2,
		$author$project$Data$Wallet$WalletConnect,
		A2($elm$json$Json$Decode$field, 'address', $elm$json$Json$Decode$string),
		A2($elm$json$Json$Decode$field, 'needOptIn', $elm$json$Json$Decode$bool)));
var $author$project$Data$Wallet$decodeWalletConnectResult = function (value) {
	var _v0 = A2($elm$json$Json$Decode$decodeValue, $author$project$Data$Wallet$decodeWalletList, value);
	if (_v0.$ === 'Ok') {
		var results = _v0.a;
		return $elm$core$Result$Ok(results);
	} else {
		return $elm$core$Result$Err('Unable to retrieve wallet details.');
	}
};
var $author$project$Data$AlgorandWallet$decodeWalletError = function (value) {
	var _v0 = A2($elm$json$Json$Decode$decodeValue, $author$project$Data$AlgorandWallet$decodeError, value);
	if (_v0.$ === 'Ok') {
		var results = _v0.a;
		return $elm$core$Result$Ok(results);
	} else {
		return $elm$core$Result$Err('Unable to retrieve wallet details.');
	}
};
var $author$project$Data$AlgorandWallet$Wallet = function (wallet) {
	return {wallet: wallet};
};
var $author$project$Data$AlgorandWallet$decodeWallet = A2(
	$elm$json$Json$Decode$map,
	$author$project$Data$AlgorandWallet$Wallet,
	A2(
		$elm$json$Json$Decode$field,
		'wallet',
		$elm$json$Json$Decode$list($elm$json$Json$Decode$string)));
var $author$project$Data$AlgorandWallet$decodeWalletResult = function (value) {
	var _v0 = A2($elm$json$Json$Decode$decodeValue, $author$project$Data$AlgorandWallet$decodeWallet, value);
	if (_v0.$ === 'Ok') {
		var results = _v0.a;
		return $elm$core$Result$Ok(results);
	} else {
		return $elm$core$Result$Err('Unable to retrieve wallet details.');
	}
};
var $author$project$Data$Api$PDF$CancelNotarisation$errorToString = function (error) {
	switch (error.$) {
		case 'UNAUTHORISED_USER':
			return 'You are not authorised to cancel notarisation for this document.';
		case 'INVALID_DOCUMENT':
			return 'Document has been deleted or does not exist.';
		default:
			return 'Invalid JWT, unauthorised user.';
	}
};
var $author$project$Data$Api$PDF$DeleteTemplate$errorToString = function (error) {
	if (error.$ === 'UNAUTHORISED_USER') {
		return 'You are not the owner of this template.';
	} else {
		return 'Template Id does not exist.';
	}
};
var $author$project$Data$Api$PDF$DownloadTemplateReport$errorToString = function (error) {
	switch (error.$) {
		case 'TEMPLATE_NOT_FOUND':
			return 'Invalid Template, template not found.';
		case 'FILE_NOT_FOUND':
			return 'File not found in directory.';
		default:
			return 'Only template owner and domain owner can perform this action.';
	}
};
var $author$project$Data$Api$PDF$GetOptInDetails$errorToString = function (error) {
	switch (error.$) {
		case 'UNAUTHORISED_USER':
			return 'You are not authorised to perform this action.';
		case 'INVALID_NETWORK_TYPE':
			return 'Wrong notarisation network type choosen.';
		default:
			return 'Invalid JWT, unauthorised user.';
	}
};
var $author$project$Data$Api$PDF$IssueAnonymous$errorToString = function (error) {
	switch (error.$) {
		case 'INVALID_EMAIL':
			return 'Invalid email provided.';
		case 'REQUIRED_LOGIN':
			return 'This email has an existing account. Please login instead.';
		case 'INVALID_TEMPLATE':
			return 'Template does not exist.';
		case 'INVALID_TEMPLATE_FORMAT':
			return 'Request can only be made for templates with one roles.';
		default:
			return 'User does not exist.';
	}
};
var $author$project$Data$Api$PDF$NotariseWithAlgorandWallet$errorToString = function (error) {
	switch (error.$) {
		case 'UNAUTHORISED_USER':
			return 'You are not authorised to notarise document.';
		case 'UNCOMPLETED_DOCUMENT':
			return 'Current Document is uncompleted.';
		case 'INVALID_NETWORK_TYPE':
			return 'Wrong notarisation network type choosen.';
		default:
			return 'Invalid JWT, unauthorised user.';
	}
};
var $author$project$Data$Api$PDF$SendTemplateAsDocument$errorToString = function (error) {
	switch (error.$) {
		case 'TEMPLATE_NOT_FOUND':
			return 'Template does not exist.';
		case 'INVALID_PASSCODE_FORMAT':
			return 'Passcode entered does not meet requirement.';
		case 'JWT_ERROR':
			return 'Invalid JWT, unauthorised user.';
		case 'UNAUTHORISED_USER':
			return 'You are not allowed to perform this action.';
		case 'USER_NOT_FOUND':
			return 'Invalid user.';
		default:
			return 'Insufficient sign points.';
	}
};
var $author$project$Model$ViewDocument$getAlgorandWalletAddress = _Platform_outgoingPort('getAlgorandWalletAddress', $elm$json$Json$Encode$string);
var $author$project$Data$WalletConnect$walletConnectNotarisePayment = _Platform_outgoingPort('walletConnectNotarisePayment', $elm$core$Basics$identity);
var $author$project$Data$WalletConnect$initWalletConnectNotarization = F8(
	function (address, checksum, docId, ownerId, recipients, isNewInit, location, lastPayment) {
		return $author$project$Data$WalletConnect$walletConnectNotarisePayment(
			$elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'address',
						$elm$json$Json$Encode$string(address)),
						_Utils_Tuple2(
						'notarizationDetails',
						$elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'checksum',
									A2(
										$elm$core$Maybe$withDefault,
										$elm$json$Json$Encode$null,
										A2($elm$core$Maybe$map, $elm$json$Json$Encode$string, checksum))),
									_Utils_Tuple2(
									'docId',
									$elm$json$Json$Encode$string(docId)),
									_Utils_Tuple2(
									'ownerId',
									$elm$json$Json$Encode$string(ownerId)),
									_Utils_Tuple2(
									'recipients',
									A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, recipients))
								]))),
						_Utils_Tuple2(
						'isNewInit',
						$elm$json$Json$Encode$bool(isNewInit)),
						_Utils_Tuple2(
						'location',
						$elm$json$Json$Encode$string(location)),
						_Utils_Tuple2(
						'lastPayment',
						$elm$json$Json$Encode$bool(lastPayment))
					])));
	});
var $author$project$Model$ViewDocument$optInAsset = _Platform_outgoingPort(
	'optInAsset',
	function ($) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'location',
					$elm$json$Json$Encode$string($.location)),
					_Utils_Tuple2(
					'userWalletAddress',
					$elm$json$Json$Encode$string($.userWalletAddress))
				]));
	});
var $author$project$Model$ViewDocument$paymentTransaction = _Platform_outgoingPort(
	'paymentTransaction',
	function ($) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'checksum',
					$elm$json$Json$Encode$string($.checksum)),
					_Utils_Tuple2(
					'docId',
					$elm$json$Json$Encode$string($.docId)),
					_Utils_Tuple2(
					'isCompleted',
					$elm$json$Json$Encode$bool($.isCompleted)),
					_Utils_Tuple2(
					'noOfDocuments',
					$elm$json$Json$Encode$int($.noOfDocuments)),
					_Utils_Tuple2(
					'ownerId',
					$elm$json$Json$Encode$string($.ownerId)),
					_Utils_Tuple2(
					'recipients',
					$elm$json$Json$Encode$list($elm$json$Json$Encode$string)($.recipients)),
					_Utils_Tuple2(
					'route',
					$elm$json$Json$Encode$string($.route)),
					_Utils_Tuple2(
					'userWalletAddress',
					$elm$json$Json$Encode$string($.userWalletAddress))
				]));
	});
var $author$project$Data$WalletConnect$walletConnectoptIn = _Platform_outgoingPort('walletConnectoptIn', $elm$core$Basics$identity);
var $author$project$Data$WalletConnect$startWalletConnectOptin = F2(
	function (address, location) {
		return $author$project$Data$WalletConnect$walletConnectoptIn(
			$elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'address',
						$elm$json$Json$Encode$string(address)),
						_Utils_Tuple2(
						'location',
						$elm$json$Json$Encode$string(location))
					])));
	});
var $ryannhg$date_format$DateFormat$DayOfMonthFixed = {$: 'DayOfMonthFixed'};
var $ryannhg$date_format$DateFormat$dayOfMonthFixed = $ryannhg$date_format$DateFormat$DayOfMonthFixed;
var $ryannhg$date_format$DateFormat$Language$Language = F6(
	function (toMonthName, toMonthAbbreviation, toWeekdayName, toWeekdayAbbreviation, toAmPm, toOrdinalSuffix) {
		return {toAmPm: toAmPm, toMonthAbbreviation: toMonthAbbreviation, toMonthName: toMonthName, toOrdinalSuffix: toOrdinalSuffix, toWeekdayAbbreviation: toWeekdayAbbreviation, toWeekdayName: toWeekdayName};
	});
var $ryannhg$date_format$DateFormat$Language$toEnglishAmPm = function (hour) {
	return (hour > 11) ? 'pm' : 'am';
};
var $ryannhg$date_format$DateFormat$Language$toEnglishMonthName = function (month) {
	switch (month.$) {
		case 'Jan':
			return 'January';
		case 'Feb':
			return 'February';
		case 'Mar':
			return 'March';
		case 'Apr':
			return 'April';
		case 'May':
			return 'May';
		case 'Jun':
			return 'June';
		case 'Jul':
			return 'July';
		case 'Aug':
			return 'August';
		case 'Sep':
			return 'September';
		case 'Oct':
			return 'October';
		case 'Nov':
			return 'November';
		default:
			return 'December';
	}
};
var $ryannhg$date_format$DateFormat$Language$toEnglishSuffix = function (num) {
	var _v0 = A2($elm$core$Basics$modBy, 100, num);
	switch (_v0) {
		case 11:
			return 'th';
		case 12:
			return 'th';
		case 13:
			return 'th';
		default:
			var _v1 = A2($elm$core$Basics$modBy, 10, num);
			switch (_v1) {
				case 1:
					return 'st';
				case 2:
					return 'nd';
				case 3:
					return 'rd';
				default:
					return 'th';
			}
	}
};
var $ryannhg$date_format$DateFormat$Language$toEnglishWeekdayName = function (weekday) {
	switch (weekday.$) {
		case 'Mon':
			return 'Monday';
		case 'Tue':
			return 'Tuesday';
		case 'Wed':
			return 'Wednesday';
		case 'Thu':
			return 'Thursday';
		case 'Fri':
			return 'Friday';
		case 'Sat':
			return 'Saturday';
		default:
			return 'Sunday';
	}
};
var $ryannhg$date_format$DateFormat$Language$english = A6(
	$ryannhg$date_format$DateFormat$Language$Language,
	$ryannhg$date_format$DateFormat$Language$toEnglishMonthName,
	A2(
		$elm$core$Basics$composeR,
		$ryannhg$date_format$DateFormat$Language$toEnglishMonthName,
		$elm$core$String$left(3)),
	$ryannhg$date_format$DateFormat$Language$toEnglishWeekdayName,
	A2(
		$elm$core$Basics$composeR,
		$ryannhg$date_format$DateFormat$Language$toEnglishWeekdayName,
		$elm$core$String$left(3)),
	$ryannhg$date_format$DateFormat$Language$toEnglishAmPm,
	$ryannhg$date_format$DateFormat$Language$toEnglishSuffix);
var $elm$time$Time$flooredDiv = F2(
	function (numerator, denominator) {
		return $elm$core$Basics$floor(numerator / denominator);
	});
var $elm$time$Time$toAdjustedMinutesHelp = F3(
	function (defaultOffset, posixMinutes, eras) {
		toAdjustedMinutesHelp:
		while (true) {
			if (!eras.b) {
				return posixMinutes + defaultOffset;
			} else {
				var era = eras.a;
				var olderEras = eras.b;
				if (_Utils_cmp(era.start, posixMinutes) < 0) {
					return posixMinutes + era.offset;
				} else {
					var $temp$defaultOffset = defaultOffset,
						$temp$posixMinutes = posixMinutes,
						$temp$eras = olderEras;
					defaultOffset = $temp$defaultOffset;
					posixMinutes = $temp$posixMinutes;
					eras = $temp$eras;
					continue toAdjustedMinutesHelp;
				}
			}
		}
	});
var $elm$time$Time$toAdjustedMinutes = F2(
	function (_v0, time) {
		var defaultOffset = _v0.a;
		var eras = _v0.b;
		return A3(
			$elm$time$Time$toAdjustedMinutesHelp,
			defaultOffset,
			A2(
				$elm$time$Time$flooredDiv,
				$elm$time$Time$posixToMillis(time),
				60000),
			eras);
	});
var $elm$time$Time$toHour = F2(
	function (zone, time) {
		return A2(
			$elm$core$Basics$modBy,
			24,
			A2(
				$elm$time$Time$flooredDiv,
				A2($elm$time$Time$toAdjustedMinutes, zone, time),
				60));
	});
var $ryannhg$date_format$DateFormat$amPm = F3(
	function (language, zone, posix) {
		return language.toAmPm(
			A2($elm$time$Time$toHour, zone, posix));
	});
var $elm$time$Time$toCivil = function (minutes) {
	var rawDay = A2($elm$time$Time$flooredDiv, minutes, 60 * 24) + 719468;
	var era = (((rawDay >= 0) ? rawDay : (rawDay - 146096)) / 146097) | 0;
	var dayOfEra = rawDay - (era * 146097);
	var yearOfEra = ((((dayOfEra - ((dayOfEra / 1460) | 0)) + ((dayOfEra / 36524) | 0)) - ((dayOfEra / 146096) | 0)) / 365) | 0;
	var dayOfYear = dayOfEra - (((365 * yearOfEra) + ((yearOfEra / 4) | 0)) - ((yearOfEra / 100) | 0));
	var mp = (((5 * dayOfYear) + 2) / 153) | 0;
	var month = mp + ((mp < 10) ? 3 : (-9));
	var year = yearOfEra + (era * 400);
	return {
		day: (dayOfYear - ((((153 * mp) + 2) / 5) | 0)) + 1,
		month: month,
		year: year + ((month <= 2) ? 1 : 0)
	};
};
var $elm$time$Time$toDay = F2(
	function (zone, time) {
		return $elm$time$Time$toCivil(
			A2($elm$time$Time$toAdjustedMinutes, zone, time)).day;
	});
var $ryannhg$date_format$DateFormat$dayOfMonth = $elm$time$Time$toDay;
var $elm$time$Time$Sun = {$: 'Sun'};
var $elm$time$Time$Fri = {$: 'Fri'};
var $elm$time$Time$Mon = {$: 'Mon'};
var $elm$time$Time$Sat = {$: 'Sat'};
var $elm$time$Time$Thu = {$: 'Thu'};
var $elm$time$Time$Tue = {$: 'Tue'};
var $elm$time$Time$Wed = {$: 'Wed'};
var $ryannhg$date_format$DateFormat$days = _List_fromArray(
	[$elm$time$Time$Sun, $elm$time$Time$Mon, $elm$time$Time$Tue, $elm$time$Time$Wed, $elm$time$Time$Thu, $elm$time$Time$Fri, $elm$time$Time$Sat]);
var $elm$time$Time$toWeekday = F2(
	function (zone, time) {
		var _v0 = A2(
			$elm$core$Basics$modBy,
			7,
			A2(
				$elm$time$Time$flooredDiv,
				A2($elm$time$Time$toAdjustedMinutes, zone, time),
				60 * 24));
		switch (_v0) {
			case 0:
				return $elm$time$Time$Thu;
			case 1:
				return $elm$time$Time$Fri;
			case 2:
				return $elm$time$Time$Sat;
			case 3:
				return $elm$time$Time$Sun;
			case 4:
				return $elm$time$Time$Mon;
			case 5:
				return $elm$time$Time$Tue;
			default:
				return $elm$time$Time$Wed;
		}
	});
var $ryannhg$date_format$DateFormat$dayOfWeek = F2(
	function (zone, posix) {
		return function (_v1) {
			var i = _v1.a;
			return i;
		}(
			A2(
				$elm$core$Maybe$withDefault,
				_Utils_Tuple2(0, $elm$time$Time$Sun),
				$elm$core$List$head(
					A2(
						$elm$core$List$filter,
						function (_v0) {
							var day = _v0.b;
							return _Utils_eq(
								day,
								A2($elm$time$Time$toWeekday, zone, posix));
						},
						A2(
							$elm$core$List$indexedMap,
							F2(
								function (i, day) {
									return _Utils_Tuple2(i, day);
								}),
							$ryannhg$date_format$DateFormat$days)))));
	});
var $ryannhg$date_format$DateFormat$isLeapYear = function (year_) {
	return (!(!A2($elm$core$Basics$modBy, 4, year_))) ? false : ((!(!A2($elm$core$Basics$modBy, 100, year_))) ? true : ((!(!A2($elm$core$Basics$modBy, 400, year_))) ? false : true));
};
var $ryannhg$date_format$DateFormat$daysInMonth = F2(
	function (year_, month) {
		switch (month.$) {
			case 'Jan':
				return 31;
			case 'Feb':
				return $ryannhg$date_format$DateFormat$isLeapYear(year_) ? 29 : 28;
			case 'Mar':
				return 31;
			case 'Apr':
				return 30;
			case 'May':
				return 31;
			case 'Jun':
				return 30;
			case 'Jul':
				return 31;
			case 'Aug':
				return 31;
			case 'Sep':
				return 30;
			case 'Oct':
				return 31;
			case 'Nov':
				return 30;
			default:
				return 31;
		}
	});
var $elm$time$Time$Jan = {$: 'Jan'};
var $elm$time$Time$Apr = {$: 'Apr'};
var $elm$time$Time$Aug = {$: 'Aug'};
var $elm$time$Time$Dec = {$: 'Dec'};
var $elm$time$Time$Feb = {$: 'Feb'};
var $elm$time$Time$Jul = {$: 'Jul'};
var $elm$time$Time$Jun = {$: 'Jun'};
var $elm$time$Time$Mar = {$: 'Mar'};
var $elm$time$Time$May = {$: 'May'};
var $elm$time$Time$Nov = {$: 'Nov'};
var $elm$time$Time$Oct = {$: 'Oct'};
var $elm$time$Time$Sep = {$: 'Sep'};
var $ryannhg$date_format$DateFormat$months = _List_fromArray(
	[$elm$time$Time$Jan, $elm$time$Time$Feb, $elm$time$Time$Mar, $elm$time$Time$Apr, $elm$time$Time$May, $elm$time$Time$Jun, $elm$time$Time$Jul, $elm$time$Time$Aug, $elm$time$Time$Sep, $elm$time$Time$Oct, $elm$time$Time$Nov, $elm$time$Time$Dec]);
var $elm$time$Time$toMonth = F2(
	function (zone, time) {
		var _v0 = $elm$time$Time$toCivil(
			A2($elm$time$Time$toAdjustedMinutes, zone, time)).month;
		switch (_v0) {
			case 1:
				return $elm$time$Time$Jan;
			case 2:
				return $elm$time$Time$Feb;
			case 3:
				return $elm$time$Time$Mar;
			case 4:
				return $elm$time$Time$Apr;
			case 5:
				return $elm$time$Time$May;
			case 6:
				return $elm$time$Time$Jun;
			case 7:
				return $elm$time$Time$Jul;
			case 8:
				return $elm$time$Time$Aug;
			case 9:
				return $elm$time$Time$Sep;
			case 10:
				return $elm$time$Time$Oct;
			case 11:
				return $elm$time$Time$Nov;
			default:
				return $elm$time$Time$Dec;
		}
	});
var $ryannhg$date_format$DateFormat$monthPair = F2(
	function (zone, posix) {
		return A2(
			$elm$core$Maybe$withDefault,
			_Utils_Tuple2(0, $elm$time$Time$Jan),
			$elm$core$List$head(
				A2(
					$elm$core$List$filter,
					function (_v0) {
						var i = _v0.a;
						var m = _v0.b;
						return _Utils_eq(
							m,
							A2($elm$time$Time$toMonth, zone, posix));
					},
					A2(
						$elm$core$List$indexedMap,
						F2(
							function (a, b) {
								return _Utils_Tuple2(a, b);
							}),
						$ryannhg$date_format$DateFormat$months))));
	});
var $ryannhg$date_format$DateFormat$monthNumber_ = F2(
	function (zone, posix) {
		return 1 + function (_v0) {
			var i = _v0.a;
			var m = _v0.b;
			return i;
		}(
			A2($ryannhg$date_format$DateFormat$monthPair, zone, posix));
	});
var $elm$core$List$sum = function (numbers) {
	return A3($elm$core$List$foldl, $elm$core$Basics$add, 0, numbers);
};
var $elm$core$List$takeReverse = F3(
	function (n, list, kept) {
		takeReverse:
		while (true) {
			if (n <= 0) {
				return kept;
			} else {
				if (!list.b) {
					return kept;
				} else {
					var x = list.a;
					var xs = list.b;
					var $temp$n = n - 1,
						$temp$list = xs,
						$temp$kept = A2($elm$core$List$cons, x, kept);
					n = $temp$n;
					list = $temp$list;
					kept = $temp$kept;
					continue takeReverse;
				}
			}
		}
	});
var $elm$core$List$takeTailRec = F2(
	function (n, list) {
		return $elm$core$List$reverse(
			A3($elm$core$List$takeReverse, n, list, _List_Nil));
	});
var $elm$core$List$takeFast = F3(
	function (ctr, n, list) {
		if (n <= 0) {
			return _List_Nil;
		} else {
			var _v0 = _Utils_Tuple2(n, list);
			_v0$1:
			while (true) {
				_v0$5:
				while (true) {
					if (!_v0.b.b) {
						return list;
					} else {
						if (_v0.b.b.b) {
							switch (_v0.a) {
								case 1:
									break _v0$1;
								case 2:
									var _v2 = _v0.b;
									var x = _v2.a;
									var _v3 = _v2.b;
									var y = _v3.a;
									return _List_fromArray(
										[x, y]);
								case 3:
									if (_v0.b.b.b.b) {
										var _v4 = _v0.b;
										var x = _v4.a;
										var _v5 = _v4.b;
										var y = _v5.a;
										var _v6 = _v5.b;
										var z = _v6.a;
										return _List_fromArray(
											[x, y, z]);
									} else {
										break _v0$5;
									}
								default:
									if (_v0.b.b.b.b && _v0.b.b.b.b.b) {
										var _v7 = _v0.b;
										var x = _v7.a;
										var _v8 = _v7.b;
										var y = _v8.a;
										var _v9 = _v8.b;
										var z = _v9.a;
										var _v10 = _v9.b;
										var w = _v10.a;
										var tl = _v10.b;
										return (ctr > 1000) ? A2(
											$elm$core$List$cons,
											x,
											A2(
												$elm$core$List$cons,
												y,
												A2(
													$elm$core$List$cons,
													z,
													A2(
														$elm$core$List$cons,
														w,
														A2($elm$core$List$takeTailRec, n - 4, tl))))) : A2(
											$elm$core$List$cons,
											x,
											A2(
												$elm$core$List$cons,
												y,
												A2(
													$elm$core$List$cons,
													z,
													A2(
														$elm$core$List$cons,
														w,
														A3($elm$core$List$takeFast, ctr + 1, n - 4, tl)))));
									} else {
										break _v0$5;
									}
							}
						} else {
							if (_v0.a === 1) {
								break _v0$1;
							} else {
								break _v0$5;
							}
						}
					}
				}
				return list;
			}
			var _v1 = _v0.b;
			var x = _v1.a;
			return _List_fromArray(
				[x]);
		}
	});
var $elm$core$List$take = F2(
	function (n, list) {
		return A3($elm$core$List$takeFast, 0, n, list);
	});
var $elm$time$Time$toYear = F2(
	function (zone, time) {
		return $elm$time$Time$toCivil(
			A2($elm$time$Time$toAdjustedMinutes, zone, time)).year;
	});
var $ryannhg$date_format$DateFormat$dayOfYear = F2(
	function (zone, posix) {
		var monthsBeforeThisOne = A2(
			$elm$core$List$take,
			A2($ryannhg$date_format$DateFormat$monthNumber_, zone, posix) - 1,
			$ryannhg$date_format$DateFormat$months);
		var daysBeforeThisMonth = $elm$core$List$sum(
			A2(
				$elm$core$List$map,
				$ryannhg$date_format$DateFormat$daysInMonth(
					A2($elm$time$Time$toYear, zone, posix)),
				monthsBeforeThisOne));
		return daysBeforeThisMonth + A2($ryannhg$date_format$DateFormat$dayOfMonth, zone, posix);
	});
var $ryannhg$date_format$DateFormat$quarter = F2(
	function (zone, posix) {
		return (A2($ryannhg$date_format$DateFormat$monthNumber_, zone, posix) / 4) | 0;
	});
var $elm$core$String$right = F2(
	function (n, string) {
		return (n < 1) ? '' : A3(
			$elm$core$String$slice,
			-n,
			$elm$core$String$length(string),
			string);
	});
var $ryannhg$date_format$DateFormat$toFixedLength = F2(
	function (totalChars, num) {
		var numStr = $elm$core$String$fromInt(num);
		var numZerosNeeded = totalChars - $elm$core$String$length(numStr);
		var zeros = A2(
			$elm$core$String$join,
			'',
			A2(
				$elm$core$List$map,
				function (_v0) {
					return '0';
				},
				A2($elm$core$List$range, 1, numZerosNeeded)));
		return _Utils_ap(zeros, numStr);
	});
var $elm$time$Time$toMillis = F2(
	function (_v0, time) {
		return A2(
			$elm$core$Basics$modBy,
			1000,
			$elm$time$Time$posixToMillis(time));
	});
var $elm$time$Time$toMinute = F2(
	function (zone, time) {
		return A2(
			$elm$core$Basics$modBy,
			60,
			A2($elm$time$Time$toAdjustedMinutes, zone, time));
	});
var $ryannhg$date_format$DateFormat$toNonMilitary = function (num) {
	return (!num) ? 12 : ((num <= 12) ? num : (num - 12));
};
var $elm$time$Time$toSecond = F2(
	function (_v0, time) {
		return A2(
			$elm$core$Basics$modBy,
			60,
			A2(
				$elm$time$Time$flooredDiv,
				$elm$time$Time$posixToMillis(time),
				1000));
	});
var $elm$core$String$toUpper = _String_toUpper;
var $elm$core$Basics$round = _Basics_round;
var $ryannhg$date_format$DateFormat$millisecondsPerYear = $elm$core$Basics$round((((1000 * 60) * 60) * 24) * 365.25);
var $ryannhg$date_format$DateFormat$firstDayOfYear = F2(
	function (zone, time) {
		return $elm$time$Time$millisToPosix(
			$ryannhg$date_format$DateFormat$millisecondsPerYear * A2($elm$time$Time$toYear, zone, time));
	});
var $ryannhg$date_format$DateFormat$weekOfYear = F2(
	function (zone, posix) {
		var firstDay = A2($ryannhg$date_format$DateFormat$firstDayOfYear, zone, posix);
		var firstDayOffset = A2($ryannhg$date_format$DateFormat$dayOfWeek, zone, firstDay);
		var daysSoFar = A2($ryannhg$date_format$DateFormat$dayOfYear, zone, posix);
		return (((daysSoFar + firstDayOffset) / 7) | 0) + 1;
	});
var $ryannhg$date_format$DateFormat$year = F2(
	function (zone, time) {
		return $elm$core$String$fromInt(
			A2($elm$time$Time$toYear, zone, time));
	});
var $ryannhg$date_format$DateFormat$piece = F4(
	function (language, zone, posix, token) {
		switch (token.$) {
			case 'MonthNumber':
				return $elm$core$String$fromInt(
					A2($ryannhg$date_format$DateFormat$monthNumber_, zone, posix));
			case 'MonthSuffix':
				return function (num) {
					return _Utils_ap(
						$elm$core$String$fromInt(num),
						language.toOrdinalSuffix(num));
				}(
					A2($ryannhg$date_format$DateFormat$monthNumber_, zone, posix));
			case 'MonthFixed':
				return A2(
					$ryannhg$date_format$DateFormat$toFixedLength,
					2,
					A2($ryannhg$date_format$DateFormat$monthNumber_, zone, posix));
			case 'MonthNameAbbreviated':
				return language.toMonthAbbreviation(
					A2($elm$time$Time$toMonth, zone, posix));
			case 'MonthNameFull':
				return language.toMonthName(
					A2($elm$time$Time$toMonth, zone, posix));
			case 'QuarterNumber':
				return $elm$core$String$fromInt(
					1 + A2($ryannhg$date_format$DateFormat$quarter, zone, posix));
			case 'QuarterSuffix':
				return function (num) {
					return _Utils_ap(
						$elm$core$String$fromInt(num),
						language.toOrdinalSuffix(num));
				}(
					1 + A2($ryannhg$date_format$DateFormat$quarter, zone, posix));
			case 'DayOfMonthNumber':
				return $elm$core$String$fromInt(
					A2($ryannhg$date_format$DateFormat$dayOfMonth, zone, posix));
			case 'DayOfMonthSuffix':
				return function (num) {
					return _Utils_ap(
						$elm$core$String$fromInt(num),
						language.toOrdinalSuffix(num));
				}(
					A2($ryannhg$date_format$DateFormat$dayOfMonth, zone, posix));
			case 'DayOfMonthFixed':
				return A2(
					$ryannhg$date_format$DateFormat$toFixedLength,
					2,
					A2($ryannhg$date_format$DateFormat$dayOfMonth, zone, posix));
			case 'DayOfYearNumber':
				return $elm$core$String$fromInt(
					A2($ryannhg$date_format$DateFormat$dayOfYear, zone, posix));
			case 'DayOfYearSuffix':
				return function (num) {
					return _Utils_ap(
						$elm$core$String$fromInt(num),
						language.toOrdinalSuffix(num));
				}(
					A2($ryannhg$date_format$DateFormat$dayOfYear, zone, posix));
			case 'DayOfYearFixed':
				return A2(
					$ryannhg$date_format$DateFormat$toFixedLength,
					3,
					A2($ryannhg$date_format$DateFormat$dayOfYear, zone, posix));
			case 'DayOfWeekNumber':
				return $elm$core$String$fromInt(
					A2($ryannhg$date_format$DateFormat$dayOfWeek, zone, posix));
			case 'DayOfWeekSuffix':
				return function (num) {
					return _Utils_ap(
						$elm$core$String$fromInt(num),
						language.toOrdinalSuffix(num));
				}(
					A2($ryannhg$date_format$DateFormat$dayOfWeek, zone, posix));
			case 'DayOfWeekNameAbbreviated':
				return language.toWeekdayAbbreviation(
					A2($elm$time$Time$toWeekday, zone, posix));
			case 'DayOfWeekNameFull':
				return language.toWeekdayName(
					A2($elm$time$Time$toWeekday, zone, posix));
			case 'WeekOfYearNumber':
				return $elm$core$String$fromInt(
					A2($ryannhg$date_format$DateFormat$weekOfYear, zone, posix));
			case 'WeekOfYearSuffix':
				return function (num) {
					return _Utils_ap(
						$elm$core$String$fromInt(num),
						language.toOrdinalSuffix(num));
				}(
					A2($ryannhg$date_format$DateFormat$weekOfYear, zone, posix));
			case 'WeekOfYearFixed':
				return A2(
					$ryannhg$date_format$DateFormat$toFixedLength,
					2,
					A2($ryannhg$date_format$DateFormat$weekOfYear, zone, posix));
			case 'YearNumberLastTwo':
				return A2(
					$elm$core$String$right,
					2,
					A2($ryannhg$date_format$DateFormat$year, zone, posix));
			case 'YearNumber':
				return A2($ryannhg$date_format$DateFormat$year, zone, posix);
			case 'AmPmUppercase':
				return $elm$core$String$toUpper(
					A3($ryannhg$date_format$DateFormat$amPm, language, zone, posix));
			case 'AmPmLowercase':
				return $elm$core$String$toLower(
					A3($ryannhg$date_format$DateFormat$amPm, language, zone, posix));
			case 'HourMilitaryNumber':
				return $elm$core$String$fromInt(
					A2($elm$time$Time$toHour, zone, posix));
			case 'HourMilitaryFixed':
				return A2(
					$ryannhg$date_format$DateFormat$toFixedLength,
					2,
					A2($elm$time$Time$toHour, zone, posix));
			case 'HourNumber':
				return $elm$core$String$fromInt(
					$ryannhg$date_format$DateFormat$toNonMilitary(
						A2($elm$time$Time$toHour, zone, posix)));
			case 'HourFixed':
				return A2(
					$ryannhg$date_format$DateFormat$toFixedLength,
					2,
					$ryannhg$date_format$DateFormat$toNonMilitary(
						A2($elm$time$Time$toHour, zone, posix)));
			case 'HourMilitaryFromOneNumber':
				return $elm$core$String$fromInt(
					1 + A2($elm$time$Time$toHour, zone, posix));
			case 'HourMilitaryFromOneFixed':
				return A2(
					$ryannhg$date_format$DateFormat$toFixedLength,
					2,
					1 + A2($elm$time$Time$toHour, zone, posix));
			case 'MinuteNumber':
				return $elm$core$String$fromInt(
					A2($elm$time$Time$toMinute, zone, posix));
			case 'MinuteFixed':
				return A2(
					$ryannhg$date_format$DateFormat$toFixedLength,
					2,
					A2($elm$time$Time$toMinute, zone, posix));
			case 'SecondNumber':
				return $elm$core$String$fromInt(
					A2($elm$time$Time$toSecond, zone, posix));
			case 'SecondFixed':
				return A2(
					$ryannhg$date_format$DateFormat$toFixedLength,
					2,
					A2($elm$time$Time$toSecond, zone, posix));
			case 'MillisecondNumber':
				return $elm$core$String$fromInt(
					A2($elm$time$Time$toMillis, zone, posix));
			case 'MillisecondFixed':
				return A2(
					$ryannhg$date_format$DateFormat$toFixedLength,
					3,
					A2($elm$time$Time$toMillis, zone, posix));
			default:
				var string = token.a;
				return string;
		}
	});
var $ryannhg$date_format$DateFormat$formatWithLanguage = F4(
	function (language, tokens, zone, time) {
		return A2(
			$elm$core$String$join,
			'',
			A2(
				$elm$core$List$map,
				A3($ryannhg$date_format$DateFormat$piece, language, zone, time),
				tokens));
	});
var $ryannhg$date_format$DateFormat$format = $ryannhg$date_format$DateFormat$formatWithLanguage($ryannhg$date_format$DateFormat$Language$english);
var $ryannhg$date_format$DateFormat$MonthFixed = {$: 'MonthFixed'};
var $ryannhg$date_format$DateFormat$monthFixed = $ryannhg$date_format$DateFormat$MonthFixed;
var $ryannhg$date_format$DateFormat$Text = function (a) {
	return {$: 'Text', a: a};
};
var $ryannhg$date_format$DateFormat$text = $ryannhg$date_format$DateFormat$Text;
var $ryannhg$date_format$DateFormat$YearNumber = {$: 'YearNumber'};
var $ryannhg$date_format$DateFormat$yearNumber = $ryannhg$date_format$DateFormat$YearNumber;
var $author$project$Model$FillTemplate$validateDueDate = F3(
	function (timezone, currentTime, dueDate) {
		return A2(
			$elm$core$Maybe$andThen,
			function (date) {
				var currentDate = A3(
					$ryannhg$date_format$DateFormat$format,
					_List_fromArray(
						[
							$ryannhg$date_format$DateFormat$yearNumber,
							$ryannhg$date_format$DateFormat$text('-'),
							$ryannhg$date_format$DateFormat$monthFixed,
							$ryannhg$date_format$DateFormat$text('-'),
							$ryannhg$date_format$DateFormat$dayOfMonthFixed
						]),
					timezone,
					currentTime);
				var correctFormat = A2(
					$elm$regex$Regex$contains,
					A2(
						$elm$core$Maybe$withDefault,
						$elm$regex$Regex$never,
						$elm$regex$Regex$fromString('^\\d{4}-\\d{2}-\\d{2}$')),
					date);
				return ((!correctFormat) || (_Utils_cmp(date, currentDate) < 0)) ? $elm$core$Maybe$Just('Invalid Due Date') : $elm$core$Maybe$Nothing;
			},
			dueDate);
	});
var $author$project$Model$FillTemplate$validateName = function (name) {
	return (!$elm$core$String$isEmpty(name)) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just('Name cannot be empty');
};
var $author$project$Model$FillTemplate$validatePasscode = F2(
	function (passcode, showPasscodeInput) {
		var correctFormat = A2(
			$elm$regex$Regex$contains,
			A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('^[0-9]{4,8}$')),
			A2($elm$core$Maybe$withDefault, '', passcode));
		return ((!correctFormat) && showPasscodeInput) ? $elm$core$Maybe$Just('Passcode can only be of 4-8 numeric characters.') : $elm$core$Maybe$Nothing;
	});
var $author$project$Model$FillTemplate$validateTemplateSend = function (recipients) {
	var valid = $elm$core$List$length(
		A2(
			$elm$core$List$filter,
			function (r) {
				return (!r.displayAll) && (_Utils_eq(r.firstNameError, $elm$core$Maybe$Nothing) && (_Utils_eq(r.lastNameError, $elm$core$Maybe$Nothing) && _Utils_eq(r.emailError, $elm$core$Maybe$Nothing)));
			},
			recipients));
	return _Utils_eq(
		valid,
		$elm$core$List$length(recipients)) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just('Please add and fill in all recipients Info.');
};
var $author$project$Data$WalletConnect$walletConnectInit = _Platform_outgoingPort('walletConnectInit', $elm$core$Basics$identity);
var $author$project$Model$FillTemplate$updateLoadedModel = F4(
	function (msg, model, authModel, appModel) {
		var updateAppModel = function (m) {
			var _v51 = authModel.fillTemplateModel;
			switch (_v51.$) {
				case 'Loaded':
					return _Utils_update(
						appModel,
						{
							sessionModel: $author$project$Types$Auth(
								_Utils_update(
									authModel,
									{
										fillTemplateModel: $author$project$Type$FillTemplate$Loaded(m)
									}))
						});
				case 'ViewTemplate':
					return _Utils_update(
						appModel,
						{
							sessionModel: $author$project$Types$Auth(
								_Utils_update(
									authModel,
									{
										fillTemplateModel: $author$project$Type$FillTemplate$ViewTemplate(m)
									}))
						});
				default:
					return _Utils_update(
						appModel,
						{
							sessionModel: $author$project$Types$Auth(
								_Utils_update(
									authModel,
									{
										fillTemplateModel: $author$project$Type$FillTemplate$Loaded(m)
									}))
						});
			}
		};
		var _v0 = authModel;
		var user = _v0.user;
		switch (msg.$) {
			case 'OnReceiveEncryptionError':
				var value = msg.a;
				var _v2 = $author$project$Data$PDF$Encryption$decode(value);
				if (_v2.$ === 'Ok') {
					var encryptionError = _v2.a;
					if (encryptionError.$ === 'PasswordFail') {
						return _Utils_Tuple2(
							updateAppModel(
								_Utils_update(
									model,
									{
										modal: $elm$core$Maybe$Just($author$project$Type$FillTemplate$NeedPassword),
										passwordError: $elm$core$Maybe$Just('Password failed.')
									})),
							$elm$core$Platform$Cmd$none);
					} else {
						return _Utils_Tuple2(
							updateAppModel(
								_Utils_update(
									model,
									{
										modal: $elm$core$Maybe$Just($author$project$Type$FillTemplate$NeedPassword),
										passwordError: $elm$core$Maybe$Nothing
									})),
							$elm$core$Platform$Cmd$none);
					}
				} else {
					var decodeErrorMessage = _v2.a;
					return _Utils_Tuple2(
						updateAppModel(
							_Utils_update(
								model,
								{
									error: $elm$core$Maybe$Just(
										$author$project$Type$FillTemplate$EncryptionDecodeError(decodeErrorMessage))
								})),
						$elm$core$Platform$Cmd$none);
				}
			case 'OnPasswordInput':
				var value = msg.a;
				return $elm$core$String$isEmpty(value) ? _Utils_Tuple2(
					updateAppModel(
						_Utils_update(
							model,
							{password: $elm$core$Maybe$Nothing, passwordError: $elm$core$Maybe$Nothing})),
					$elm$core$Platform$Cmd$none) : _Utils_Tuple2(
					updateAppModel(
						_Utils_update(
							model,
							{
								password: $elm$core$Maybe$Just(value),
								passwordError: $elm$core$Maybe$Nothing
							})),
					$elm$core$Platform$Cmd$none);
			case 'OnPasswordSubmit':
				var _v4 = A4(
					$author$project$Data$PDF$FillTemplate$loadWithPassword,
					appModel.apiEndPoint.templateFile,
					user.jwt,
					A2($elm$core$Maybe$withDefault, '', model.password),
					model.template);
				var updatedTemplate = _v4.a;
				var templateCmd = _v4.b;
				return _Utils_Tuple2(
					updateAppModel(
						_Utils_update(
							model,
							{modal: $elm$core$Maybe$Nothing, template: updatedTemplate})),
					templateCmd);
			case 'OnSignatureClick':
				var filledSignature = msg.a;
				var _v5 = A2($author$project$Data$PDF$FillTemplate$updateSignatureFields, filledSignature, model.template);
				var updatedTemplate = _v5.a;
				var templateCmd = _v5.b;
				return _Utils_Tuple2(
					updateAppModel(
						_Utils_update(
							model,
							{
								selectedSignature: $elm$core$Maybe$Just(filledSignature),
								template: updatedTemplate
							})),
					templateCmd);
			case 'OnFieldInput':
				var isFilling = msg.a;
				var dbId = msg.b;
				var value = msg.c;
				var _v6 = A4($author$project$Data$PDF$FillTemplate$updateFillableField, isFilling, dbId, value, model.template);
				var updatedTemplate = _v6.a;
				var templateCmd = _v6.b;
				return _Utils_Tuple2(
					updateAppModel(
						_Utils_update(
							model,
							{template: updatedTemplate})),
					templateCmd);
			case 'OnFieldChecked':
				var isFilling = msg.a;
				var dbId = msg.b;
				var value = msg.c;
				var _v7 = A4($author$project$Data$PDF$FillTemplate$updateFillableField, isFilling, dbId, value, model.template);
				var updatedTemplate = _v7.a;
				var templateCmd = _v7.b;
				return _Utils_Tuple2(
					updateAppModel(
						_Utils_update(
							model,
							{template: updatedTemplate})),
					templateCmd);
			case 'OnErrorClose':
				return _Utils_Tuple2(
					updateAppModel(
						_Utils_update(
							model,
							{error: $elm$core$Maybe$Nothing})),
					$elm$core$Platform$Cmd$none);
			case 'OnCloseModal':
				return _Utils_Tuple2(
					updateAppModel(
						_Utils_update(
							model,
							{modal: $elm$core$Maybe$Nothing})),
					$elm$core$Platform$Cmd$none);
			case 'OnTemplateSubmit':
				var isValid = $author$project$Model$FillTemplate$validateTemplateSend(model.recipients);
				if (isValid.$ === 'Nothing') {
					return _Utils_Tuple2(
						updateAppModel(
							_Utils_update(
								model,
								{
									modal: $elm$core$Maybe$Just($author$project$Type$FillTemplate$Fill)
								})),
						$elm$core$Platform$Cmd$none);
				} else {
					var err = isValid.a;
					return _Utils_Tuple2(
						updateAppModel(
							_Utils_update(
								model,
								{
									error: $elm$core$Maybe$Just(
										$author$project$Type$FillTemplate$TemplateValidation(err))
								})),
						$elm$core$Platform$Cmd$none);
				}
			case 'OnConfirmedTemplateSubmit':
				var documentDetails = {additionalMsg: model.additionalMsg, dueDate: model.dueDate, passcode: model.passcode, requireNotarisation: model.requireNotarisation};
				var _v9 = model;
				var recipients = _v9.recipients;
				var signerDetails = A2(
					$elm$core$List$map,
					function (r) {
						return {email: r.email, firstName: r.firstName, lastName: r.lastName, role: r.role, roleId: r.roleId, signOrder: r.signOrder};
					},
					recipients);
				return _Utils_Tuple2(
					updateAppModel(
						_Utils_update(
							model,
							{
								modal: $elm$core$Maybe$Just($author$project$Type$FillTemplate$Filling)
							})),
					A2(
						$elm$core$Task$attempt,
						A2(
							$elm$core$Basics$composeL,
							A2(
								$elm$core$Basics$composeL,
								A2($elm$core$Basics$composeL, $author$project$Types$OnFillTemplate, $author$project$Type$FillTemplate$OnAuth),
								$author$project$Type$FillTemplate$OnLoaded),
							$author$project$Type$FillTemplate$OnSubmitTemplateAsDocumentResult),
						A6($author$project$Data$Api$PDF$SendTemplateAsDocument$authCall, authModel.user.jwt, appModel.apiEndPoint.sendTemplateAsDocument, model.payload.id, model.payload.version, documentDetails, signerDetails)));
			case 'OnConfirmedTemplateSubmitResult':
				var result = msg.a;
				if (result.$ === 'Ok') {
					return _Utils_Tuple2(
						updateAppModel(
							_Utils_update(
								model,
								{
									modal: $elm$core$Maybe$Just($author$project$Type$FillTemplate$Success)
								})),
						$elm$core$Platform$Cmd$none);
				} else {
					var err = result.a;
					return _Utils_Tuple2(
						updateAppModel(
							_Utils_update(
								model,
								{
									error: $elm$core$Maybe$Just(
										$author$project$Type$FillTemplate$SubmitTemplateError(
											A2($author$project$Data$Api$authErrorToString, $author$project$Data$Api$PDF$SubmitFillTemplate$errorToString, err))),
									modal: $elm$core$Maybe$Nothing
								})),
						$elm$core$Platform$Cmd$none);
				}
			case 'NextStage':
				return _Utils_Tuple2(
					updateAppModel(
						_Utils_update(
							model,
							{stage: $author$project$Type$FillTemplate$Options})),
					$elm$core$Platform$Cmd$none);
			case 'GoToStage':
				var newStage = msg.a;
				return _Utils_Tuple2(
					updateAppModel(
						_Utils_update(
							model,
							{stage: newStage})),
					$elm$core$Platform$Cmd$none);
			case 'OnAdditionalMsgToggle':
				return _Utils_Tuple2(
					updateAppModel(
						_Utils_update(
							model,
							{additionalMsg: $elm$core$Maybe$Nothing, showAdditionalMsg: !model.showAdditionalMsg})),
					$elm$core$Platform$Cmd$none);
			case 'OnAdditionalMsgInput':
				var addMsg = msg.a;
				return _Utils_Tuple2(
					updateAppModel(
						_Utils_update(
							model,
							{
								additionalMsg: $elm$core$Maybe$Just(addMsg)
							})),
					$elm$core$Platform$Cmd$none);
			case 'OnPasscodeToggle':
				return _Utils_Tuple2(
					updateAppModel(
						_Utils_update(
							model,
							{passcode: $elm$core$Maybe$Nothing, passcodeError: $elm$core$Maybe$Nothing, showPasscodeInput: !model.showPasscodeInput})),
					$elm$core$Platform$Cmd$none);
			case 'OnPasscodeInput':
				var value = msg.a;
				return _Utils_Tuple2(
					updateAppModel(
						_Utils_update(
							model,
							{
								passcode: $elm$core$Maybe$Just(value)
							})),
					$elm$core$Platform$Cmd$none);
			case 'OnPasscodeBlur':
				return _Utils_Tuple2(
					updateAppModel(
						_Utils_update(
							model,
							{
								passcodeError: A2($author$project$Model$FillTemplate$validatePasscode, model.passcode, model.showPasscodeInput)
							})),
					$elm$core$Platform$Cmd$none);
			case 'OnDueDateToggle':
				return _Utils_Tuple2(
					updateAppModel(
						_Utils_update(
							model,
							{dueDate: $elm$core$Maybe$Nothing, dueDateError: $elm$core$Maybe$Nothing, showDueDate: !model.showDueDate})),
					$elm$core$Platform$Cmd$none);
			case 'OnDueDateInput':
				var value = msg.a;
				return $elm$core$String$isEmpty(value) ? _Utils_Tuple2(
					updateAppModel(
						_Utils_update(
							model,
							{dueDate: $elm$core$Maybe$Nothing, dueDateError: $elm$core$Maybe$Nothing})),
					$elm$core$Platform$Cmd$none) : _Utils_Tuple2(
					updateAppModel(
						_Utils_update(
							model,
							{
								dueDate: $elm$core$Maybe$Just(value)
							})),
					$elm$core$Platform$Cmd$none);
			case 'OnDueDateBlur':
				return _Utils_Tuple2(
					updateAppModel(
						_Utils_update(
							model,
							{
								dueDateError: A3($author$project$Model$FillTemplate$validateDueDate, appModel.timezone, appModel.currentTime, model.dueDate)
							})),
					$elm$core$Platform$Cmd$none);
			case 'OnHover':
				var action = msg.a;
				var location = msg.b;
				var _v11 = _Utils_Tuple2(action, location);
				switch (_v11.b.$) {
					case 'Notarize':
						if (_v11.a.$ === 'Enters') {
							var _v12 = _v11.a;
							var _v13 = _v11.b;
							return _Utils_Tuple2(
								updateAppModel(
									_Utils_update(
										model,
										{toolTipActiveHover: $author$project$Type$FillTemplate$Notarize})),
								$elm$core$Platform$Cmd$none);
						} else {
							var _v14 = _v11.a;
							var _v15 = _v11.b;
							return _Utils_Tuple2(
								updateAppModel(
									_Utils_update(
										model,
										{toolTipActiveHover: $author$project$Type$FillTemplate$Closed})),
								$elm$core$Platform$Cmd$none);
						}
					case 'Passcode':
						if (_v11.a.$ === 'Enters') {
							var _v16 = _v11.a;
							var _v17 = _v11.b;
							return _Utils_Tuple2(
								updateAppModel(
									_Utils_update(
										model,
										{toolTipActiveHover: $author$project$Type$FillTemplate$Passcode})),
								$elm$core$Platform$Cmd$none);
						} else {
							var _v18 = _v11.a;
							var _v19 = _v11.b;
							return _Utils_Tuple2(
								updateAppModel(
									_Utils_update(
										model,
										{toolTipActiveHover: $author$project$Type$FillTemplate$Closed})),
								$elm$core$Platform$Cmd$none);
						}
					default:
						var _v20 = _v11.b;
						return _Utils_Tuple2(appModel, $elm$core$Platform$Cmd$none);
				}
			case 'OnRequireNotarisationToggle':
				var notarisationNetwork = msg.a;
				var newModel = function () {
					if (notarisationNetwork.$ === 'Binance') {
						return (_Utils_cmp(model.signPointsBalance, model.binanceNotarisationCost) > -1) ? _Utils_update(
							model,
							{requireNotarisation: !model.requireNotarisation}) : _Utils_update(
							model,
							{requireNotarisation: false});
					} else {
						var _v22 = authModel.user.paymentMethod;
						if (_v22 === 'systemBalance') {
							return (_Utils_cmp(model.signPointsBalance, model.algorandNotarisationCost) > -1) ? _Utils_update(
								model,
								{requireNotarisation: !model.requireNotarisation}) : _Utils_update(
								model,
								{requireNotarisation: false});
						} else {
							return _Utils_update(
								model,
								{requireNotarisation: !model.requireNotarisation});
						}
					}
				}();
				return _Utils_Tuple2(
					updateAppModel(newModel),
					$elm$core$Platform$Cmd$none);
			case 'OnSigningOrderChecked':
				var noSignOrder = A2(
					$elm$core$List$map,
					function (r) {
						return {
							colour: r.colour,
							displayAll: r.displayAll,
							email: r.email,
							emailError: r.emailError,
							firstName: r.firstName,
							firstNameError: r.firstNameError,
							index: r.index,
							isRecipientAssigned: r.isRecipientAssigned,
							lastName: r.lastName,
							lastNameError: r.lastNameError,
							role: r.role,
							roleId: r.roleId,
							search: r.search,
							searchResult: r.searchResult,
							signOrder: _Utils_eq(r.signOrder, -1) ? (-1) : 0
						};
					},
					model.recipients);
				var allSignOrderSetToOne = A2(
					$elm$core$List$map,
					function (r) {
						return {
							colour: r.colour,
							displayAll: r.displayAll,
							email: r.email,
							emailError: r.emailError,
							firstName: r.firstName,
							firstNameError: r.firstNameError,
							index: r.index,
							isRecipientAssigned: r.isRecipientAssigned,
							lastName: r.lastName,
							lastNameError: r.lastNameError,
							role: r.role,
							roleId: r.roleId,
							search: r.search,
							searchResult: r.searchResult,
							signOrder: _Utils_eq(r.signOrder, -1) ? (-1) : 1
						};
					},
					model.recipients);
				var _v23 = model.signingType;
				if (_v23.$ === 'NoSigningOrder') {
					return _Utils_Tuple2(
						updateAppModel(
							_Utils_update(
								model,
								{recipients: allSignOrderSetToOne, signingType: $author$project$Type$FillTemplate$SigningOrder})),
						$elm$core$Platform$Cmd$none);
				} else {
					return model.signingOrderAssigned ? _Utils_Tuple2(
						updateAppModel(
							_Utils_update(
								model,
								{signingType: $author$project$Type$FillTemplate$SigningOrder})),
						$elm$core$Platform$Cmd$none) : _Utils_Tuple2(
						updateAppModel(
							_Utils_update(
								model,
								{recipients: noSignOrder, signingType: $author$project$Type$FillTemplate$NoSigningOrder})),
						$elm$core$Platform$Cmd$none);
				}
			case 'OnAddRecipientInput':
				var field = msg.a;
				var roleId = msg.b;
				var value = msg.c;
				var updatedSignerData = A2(
					$elm$core$List$map,
					function (r) {
						return {
							colour: r.colour,
							displayAll: r.displayAll,
							email: (_Utils_eq(r.roleId, roleId) && _Utils_eq(field, $author$project$Type$FillTemplate$Email)) ? value : r.email,
							emailError: r.emailError,
							firstName: (_Utils_eq(r.roleId, roleId) && _Utils_eq(field, $author$project$Type$FillTemplate$FirstName)) ? value : r.firstName,
							firstNameError: r.firstNameError,
							index: r.index,
							isRecipientAssigned: r.isRecipientAssigned,
							lastName: (_Utils_eq(r.roleId, roleId) && _Utils_eq(field, $author$project$Type$FillTemplate$LastName)) ? value : r.lastName,
							lastNameError: r.lastNameError,
							role: r.role,
							roleId: r.roleId,
							search: (_Utils_eq(r.roleId, roleId) && _Utils_eq(field, $author$project$Type$FillTemplate$Search)) ? value : r.search,
							searchResult: $elm$core$Maybe$Nothing,
							signOrder: r.signOrder
						};
					},
					model.recipients);
				switch (field.$) {
					case 'FirstName':
						return _Utils_Tuple2(
							updateAppModel(
								_Utils_update(
									model,
									{recipients: updatedSignerData})),
							$elm$core$Platform$Cmd$none);
					case 'LastName':
						return _Utils_Tuple2(
							updateAppModel(
								_Utils_update(
									model,
									{recipients: updatedSignerData})),
							$elm$core$Platform$Cmd$none);
					case 'Email':
						return _Utils_Tuple2(
							updateAppModel(
								_Utils_update(
									model,
									{recipients: updatedSignerData})),
							$elm$core$Platform$Cmd$none);
					default:
						return _Utils_Tuple2(
							updateAppModel(
								_Utils_update(
									model,
									{currentRoleId: roleId, recipients: updatedSignerData, searchTerm: value})),
							$author$project$Model$UploadMultipleDocument$startDebounceTime(
								$elm$json$Json$Encode$string('FillTemplate')));
				}
			case 'OnAddRecipientBlur':
				var field = msg.a;
				var roleId = msg.b;
				var updatedSignerData = A2(
					$elm$core$List$map,
					function (r) {
						return {
							colour: r.colour,
							displayAll: r.displayAll,
							email: r.email,
							emailError: (_Utils_eq(r.roleId, roleId) && _Utils_eq(field, $author$project$Type$FillTemplate$Email)) ? A2($author$project$Model$FillTemplate$checkDuplicateRecipientEmail, r.email, model.recipients) : r.emailError,
							firstName: r.firstName,
							firstNameError: (_Utils_eq(r.roleId, roleId) && _Utils_eq(field, $author$project$Type$FillTemplate$FirstName)) ? $author$project$Model$FillTemplate$validateName(r.firstName) : r.firstNameError,
							index: r.index,
							isRecipientAssigned: r.isRecipientAssigned,
							lastName: r.lastName,
							lastNameError: (_Utils_eq(r.roleId, roleId) && _Utils_eq(field, $author$project$Type$FillTemplate$LastName)) ? $author$project$Model$FillTemplate$validateName(r.lastName) : r.lastNameError,
							role: r.role,
							roleId: r.roleId,
							search: r.search,
							searchResult: $elm$core$Maybe$Nothing,
							signOrder: r.signOrder
						};
					},
					model.recipients);
				switch (field.$) {
					case 'FirstName':
						return _Utils_Tuple2(
							updateAppModel(
								_Utils_update(
									model,
									{recipients: updatedSignerData})),
							$elm$core$Platform$Cmd$none);
					case 'LastName':
						return _Utils_Tuple2(
							updateAppModel(
								_Utils_update(
									model,
									{recipients: updatedSignerData})),
							$elm$core$Platform$Cmd$none);
					case 'Email':
						return _Utils_Tuple2(
							updateAppModel(
								_Utils_update(
									model,
									{recipients: updatedSignerData})),
							$elm$core$Platform$Cmd$none);
					default:
						return _Utils_Tuple2(
							appModel,
							$author$project$Model$UploadMultipleDocument$startBlurTime(
								$elm$json$Json$Encode$string('FillTemplate')));
				}
			case 'OnAddRecipientSubmit':
				var roleId = msg.a;
				var nextSmallestUnassignedIndex = $elm$core$List$minimum(
					A2(
						$elm$core$List$map,
						function (r) {
							return r.index;
						},
						A2(
							$elm$core$List$filter,
							function (r) {
								return (!r.isRecipientAssigned) && $elm$core$String$isEmpty(r.email);
							},
							model.recipients)));
				var updatedSignerData = A2(
					$elm$core$List$map,
					function (r) {
						return {
							colour: r.colour,
							displayAll: (_Utils_eq(r.roleId, roleId) && (_Utils_eq(r.emailError, $elm$core$Maybe$Nothing) && (_Utils_eq(r.firstNameError, $elm$core$Maybe$Nothing) && _Utils_eq(r.lastNameError, $elm$core$Maybe$Nothing)))) ? false : (r.isRecipientAssigned ? false : (((_Utils_eq(
								r.index,
								A2($elm$core$Maybe$withDefault, 0, nextSmallestUnassignedIndex)) && ((!r.isRecipientAssigned) && $elm$core$String$isEmpty(r.email))) || (!_Utils_eq(r.emailError, $elm$core$Maybe$Nothing))) ? true : false)),
							email: r.email,
							emailError: r.emailError,
							firstName: r.firstName,
							firstNameError: r.firstNameError,
							index: r.index,
							isRecipientAssigned: r.isRecipientAssigned,
							lastName: r.lastName,
							lastNameError: r.lastNameError,
							role: r.role,
							roleId: r.roleId,
							search: r.search,
							searchResult: $elm$core$Maybe$Nothing,
							signOrder: r.signOrder
						};
					},
					model.recipients);
				return _Utils_Tuple2(
					updateAppModel(
						_Utils_update(
							model,
							{recipients: updatedSignerData})),
					$elm$core$Platform$Cmd$none);
			case 'OnRecipientBoxClick':
				var roleId = msg.a;
				var updatedSignerData = A2(
					$elm$core$List$map,
					function (r) {
						return {
							colour: r.colour,
							displayAll: (_Utils_eq(r.roleId, roleId) && (!r.isRecipientAssigned)) ? true : r.displayAll,
							email: r.email,
							emailError: r.emailError,
							firstName: r.firstName,
							firstNameError: r.firstNameError,
							index: r.index,
							isRecipientAssigned: r.isRecipientAssigned,
							lastName: r.lastName,
							lastNameError: r.lastNameError,
							role: r.role,
							roleId: r.roleId,
							search: r.search,
							searchResult: $elm$core$Maybe$Nothing,
							signOrder: r.signOrder
						};
					},
					model.recipients);
				return _Utils_Tuple2(
					updateAppModel(
						_Utils_update(
							model,
							{recipients: updatedSignerData})),
					$elm$core$Platform$Cmd$none);
			case 'OnClearAddRecipientFields':
				var roleId = msg.a;
				var updatedSignerData = A2(
					$elm$core$List$map,
					function (r) {
						return {
							colour: r.colour,
							displayAll: _Utils_eq(r.roleId, roleId) ? true : r.displayAll,
							email: _Utils_eq(r.roleId, roleId) ? '' : r.email,
							emailError: _Utils_eq(r.roleId, roleId) ? $elm$core$Maybe$Nothing : r.emailError,
							firstName: _Utils_eq(r.roleId, roleId) ? '' : r.firstName,
							firstNameError: _Utils_eq(r.roleId, roleId) ? $elm$core$Maybe$Nothing : r.firstNameError,
							index: r.index,
							isRecipientAssigned: r.isRecipientAssigned,
							lastName: _Utils_eq(r.roleId, roleId) ? '' : r.lastName,
							lastNameError: _Utils_eq(r.roleId, roleId) ? $elm$core$Maybe$Nothing : r.lastNameError,
							role: r.role,
							roleId: r.roleId,
							search: r.search,
							searchResult: $elm$core$Maybe$Nothing,
							signOrder: r.signOrder
						};
					},
					model.recipients);
				return _Utils_Tuple2(
					updateAppModel(
						_Utils_update(
							model,
							{recipients: updatedSignerData})),
					$elm$core$Platform$Cmd$none);
			case 'OnSigningOrderInput':
				var roleId = msg.a;
				var signOrderValue = msg.b;
				var signOrder = $elm$core$String$toInt(signOrderValue);
				if (signOrder.$ === 'Just') {
					var value = signOrder.a;
					var updatedSignerData = A2(
						$elm$core$List$map,
						function (r) {
							return {
								colour: r.colour,
								displayAll: r.displayAll,
								email: r.email,
								emailError: r.emailError,
								firstName: r.firstName,
								firstNameError: r.firstNameError,
								index: r.index,
								isRecipientAssigned: r.isRecipientAssigned,
								lastName: r.lastName,
								lastNameError: r.lastNameError,
								role: r.role,
								roleId: r.roleId,
								search: r.search,
								searchResult: $elm$core$Maybe$Nothing,
								signOrder: (_Utils_eq(r.roleId, roleId) && ((!model.signingOrderAssigned) && ((value >= 1) && (value < 100)))) ? value : r.signOrder
							};
						},
						model.recipients);
					return _Utils_Tuple2(
						updateAppModel(
							_Utils_update(
								model,
								{recipients: updatedSignerData})),
						$elm$core$Platform$Cmd$none);
				} else {
					return _Utils_Tuple2(appModel, $elm$core$Platform$Cmd$none);
				}
			case 'OnSearchDebounce':
				return _Utils_Tuple2(
					appModel,
					A2(
						$elm$core$Task$attempt,
						A2(
							$elm$core$Basics$composeL,
							A2(
								$elm$core$Basics$composeL,
								A2($elm$core$Basics$composeL, $author$project$Types$OnFillTemplate, $author$project$Type$FillTemplate$OnAuth),
								$author$project$Type$FillTemplate$OnLoaded),
							$author$project$Type$FillTemplate$OnSearchApiResult),
						A3($author$project$Data$Api$AddressBookAutocomplete$authCall, authModel.user.jwt, appModel.apiEndPoint.addressBookAutocomplete, model.searchTerm)));
			case 'OnSearchApiResult':
				var response = msg.a;
				if (response.$ === 'Ok') {
					var result = response.a;
					var updatedSignerData = A2(
						$elm$core$List$map,
						function (r) {
							return {
								colour: r.colour,
								displayAll: r.displayAll,
								email: r.email,
								emailError: r.emailError,
								firstName: r.firstName,
								firstNameError: r.firstNameError,
								index: r.index,
								isRecipientAssigned: r.isRecipientAssigned,
								lastName: r.lastName,
								lastNameError: r.lastNameError,
								role: r.role,
								roleId: r.roleId,
								search: r.search,
								searchResult: _Utils_eq(r.roleId, model.currentRoleId) ? $elm$core$Maybe$Just(result.contacts) : $elm$core$Maybe$Nothing,
								signOrder: r.signOrder
							};
						},
						model.recipients);
					var emptySearchResult = A2(
						$elm$core$List$map,
						function (r) {
							return {colour: r.colour, displayAll: r.displayAll, email: r.email, emailError: r.emailError, firstName: r.firstName, firstNameError: r.firstNameError, index: r.index, isRecipientAssigned: r.isRecipientAssigned, lastName: r.lastName, lastNameError: r.lastNameError, role: r.role, roleId: r.roleId, search: r.search, searchResult: $elm$core$Maybe$Nothing, signOrder: r.signOrder};
						},
						model.recipients);
					return $elm$core$List$isEmpty(result.contacts) ? _Utils_Tuple2(
						updateAppModel(
							_Utils_update(
								model,
								{recipients: emptySearchResult})),
						$elm$core$Platform$Cmd$none) : _Utils_Tuple2(
						updateAppModel(
							_Utils_update(
								model,
								{recipients: updatedSignerData})),
						$elm$core$Platform$Cmd$none);
				} else {
					return _Utils_Tuple2(appModel, $elm$core$Platform$Cmd$none);
				}
			case 'OnAutocompleteClick':
				var contact = msg.a;
				var roleId = msg.b;
				var updatedSignerData = A2(
					$elm$core$List$map,
					function (r) {
						return {
							colour: r.colour,
							displayAll: r.displayAll,
							email: _Utils_eq(r.roleId, roleId) ? contact.email : r.email,
							emailError: r.emailError,
							firstName: _Utils_eq(r.roleId, roleId) ? contact.firstName : r.firstName,
							firstNameError: $elm$core$Maybe$Nothing,
							index: r.index,
							isRecipientAssigned: r.isRecipientAssigned,
							lastName: _Utils_eq(r.roleId, roleId) ? contact.lastName : r.lastName,
							lastNameError: $elm$core$Maybe$Nothing,
							role: r.role,
							roleId: r.roleId,
							search: '',
							searchResult: $elm$core$Maybe$Nothing,
							signOrder: r.signOrder
						};
					},
					model.recipients);
				var recipientListWithCheck = A2(
					$elm$core$List$map,
					function (r) {
						return {
							colour: r.colour,
							displayAll: r.displayAll,
							email: r.email,
							emailError: _Utils_eq(r.roleId, roleId) ? A2($author$project$Model$FillTemplate$checkDuplicateRecipientEmail, r.email, updatedSignerData) : r.emailError,
							firstName: r.firstName,
							firstNameError: $elm$core$Maybe$Nothing,
							index: r.index,
							isRecipientAssigned: r.isRecipientAssigned,
							lastName: r.lastName,
							lastNameError: $elm$core$Maybe$Nothing,
							role: r.role,
							roleId: r.roleId,
							search: '',
							searchResult: $elm$core$Maybe$Nothing,
							signOrder: r.signOrder
						};
					},
					updatedSignerData);
				return _Utils_Tuple2(
					updateAppModel(
						_Utils_update(
							model,
							{recipients: recipientListWithCheck})),
					$elm$core$Platform$Cmd$none);
			case 'OnSearchFieldBlur':
				var emptySearchResult = A2(
					$elm$core$List$map,
					function (r) {
						return {colour: r.colour, displayAll: r.displayAll, email: r.email, emailError: r.emailError, firstName: r.firstName, firstNameError: r.firstNameError, index: r.index, isRecipientAssigned: r.isRecipientAssigned, lastName: r.lastName, lastNameError: r.lastNameError, role: r.role, roleId: r.roleId, search: r.search, searchResult: $elm$core$Maybe$Nothing, signOrder: r.signOrder};
					},
					model.recipients);
				return _Utils_Tuple2(
					updateAppModel(
						_Utils_update(
							model,
							{recipients: emptySearchResult})),
					$elm$core$Platform$Cmd$none);
			case 'OnSubmitTemplateAsDocumentResult':
				var result = msg.a;
				if (result.$ === 'Ok') {
					var value = result.a;
					return _Utils_Tuple2(
						updateAppModel(
							_Utils_update(
								model,
								{
									createdDocumentId: value.docId,
									modal: $elm$core$Maybe$Just($author$project$Type$FillTemplate$Success)
								})),
						$elm$core$Platform$Cmd$none);
				} else {
					var err = result.a;
					return _Utils_Tuple2(
						updateAppModel(
							_Utils_update(
								model,
								{
									error: $elm$core$Maybe$Just(
										$author$project$Type$FillTemplate$SubmitTemplateError(
											A2($author$project$Data$Api$authErrorToString, $author$project$Data$Api$PDF$SendTemplateAsDocument$errorToString, err))),
									modal: $elm$core$Maybe$Nothing
								})),
						$elm$core$Platform$Cmd$none);
				}
			case 'AlgorandWalletConnectClick':
				var _v29 = $author$project$Model$Settings$convertStringToPayment(authModel.user.paymentMethod);
				switch (_v29.$) {
					case 'AlgoWallet':
						return _Utils_Tuple2(
							updateAppModel(
								_Utils_update(
									model,
									{
										modal: $elm$core$Maybe$Just(
											$author$project$Type$FillTemplate$LoadingStatus($author$project$Type$FillTemplate$GetWallet))
									})),
							$author$project$Model$ViewDocument$getAlgorandWalletAddress('FillTemplate'));
					case 'WalletConnect':
						return _Utils_Tuple2(
							appModel,
							$author$project$Data$WalletConnect$walletConnectInit(
								$elm$json$Json$Encode$string('FillTemplate')));
					default:
						return _Utils_Tuple2(appModel, $elm$core$Platform$Cmd$none);
				}
			case 'AlgorandWalletError':
				var result = msg.a;
				var decodedMsg = function () {
					var _v30 = $author$project$Data$AlgorandWallet$decodeWalletError(result);
					if (_v30.$ === 'Ok') {
						var message = _v30.a;
						return message.error;
					} else {
						return 'Error getting wallet Addresses. Please try again.';
					}
				}();
				return _Utils_Tuple2(
					updateAppModel(
						_Utils_update(
							model,
							{
								modal: $elm$core$Maybe$Just($author$project$Type$FillTemplate$Success),
								walletError: $elm$core$Maybe$Just(decodedMsg)
							})),
					$elm$core$Platform$Cmd$none);
			case 'GetAlgorandWalletAddress':
				var result = msg.a;
				var _v31 = $author$project$Data$AlgorandWallet$decodeWalletResult(result);
				if (_v31.$ === 'Ok') {
					var value = _v31.a;
					return _Utils_Tuple2(
						updateAppModel(
							_Utils_update(
								model,
								{
									algorandWalletAddresses: value.wallet,
									modal: $elm$core$Maybe$Just(
										$author$project$Type$FillTemplate$DisplayWallet(value.wallet)),
									selectedWallet: $elm$core$Maybe$Nothing
								})),
						$elm$core$Platform$Cmd$none);
				} else {
					return _Utils_Tuple2(
						updateAppModel(model),
						$elm$core$Platform$Cmd$none);
				}
			case 'OnSelectWallet':
				var address = msg.a;
				return _Utils_Tuple2(
					updateAppModel(
						_Utils_update(
							model,
							{
								modal: $elm$core$Maybe$Just(
									$author$project$Type$FillTemplate$LoadingStatus($author$project$Type$FillTemplate$CheckWalletOptIn)),
								selectedWallet: $elm$core$Maybe$Just(address)
							})),
					$author$project$Model$ViewDocument$checkOptIn(
						{location: 'FillTemplate', selectedWallet: address}));
			case 'OptInStatusResult':
				var result = msg.a;
				var _v32 = $author$project$Data$AlgorandWallet$decodeOptInStatusResult(result);
				if (_v32.$ === 'Ok') {
					var value = _v32.a;
					return _Utils_Tuple2(
						updateAppModel(
							_Utils_update(
								model,
								{
									modal: $elm$core$Maybe$Just(
										$author$project$Type$FillTemplate$DisplayWallet(model.algorandWalletAddresses)),
									needOptIn: value.needOptIn
								})),
						$elm$core$Platform$Cmd$none);
				} else {
					return _Utils_Tuple2(
						updateAppModel(model),
						$elm$core$Platform$Cmd$none);
				}
			case 'OptInAssetClick':
				return _Utils_Tuple2(
					updateAppModel(
						_Utils_update(
							model,
							{
								modal: $elm$core$Maybe$Just(
									$author$project$Type$FillTemplate$LoadingStatus($author$project$Type$FillTemplate$OptIn))
							})),
					$author$project$Model$ViewDocument$optInAsset(
						{
							location: 'FillTemplate',
							userWalletAddress: A2($elm$core$Maybe$withDefault, '', model.selectedWallet)
						}));
			case 'OptInError':
				var result = msg.a;
				var userWallets = model.algorandWalletAddresses;
				var decodedMsg = function () {
					var _v33 = $author$project$Data$AlgorandWallet$decodeOptInError(result);
					if (_v33.$ === 'Ok') {
						var message = _v33.a;
						return message.error;
					} else {
						return 'Error opting-in. Please try again.';
					}
				}();
				return _Utils_Tuple2(
					updateAppModel(
						_Utils_update(
							model,
							{
								modal: $elm$core$Maybe$Just(
									$author$project$Type$FillTemplate$DisplayWallet(userWallets)),
								optInError: $elm$core$Maybe$Just(decodedMsg)
							})),
					$elm$core$Platform$Cmd$none);
			case 'GetOptInDetails':
				var result = msg.a;
				var _v34 = $author$project$Data$AlgorandWallet$decodeStatusResult(result);
				if (_v34.$ === 'Ok') {
					var value = _v34.a;
					return _Utils_Tuple2(
						updateAppModel(
							_Utils_update(
								model,
								{
									optInError: $elm$core$Maybe$Nothing,
									optInStatusCode: $elm$core$Maybe$Just(value.status)
								})),
						A2(
							$elm$core$Task$attempt,
							A2(
								$elm$core$Basics$composeL,
								A2(
									$elm$core$Basics$composeL,
									A2($elm$core$Basics$composeL, $author$project$Types$OnFillTemplate, $author$project$Type$FillTemplate$OnAuth),
									$author$project$Type$FillTemplate$OnLoaded),
								$author$project$Type$FillTemplate$OnGetOptInDetailsResult),
							A6(
								$author$project$Data$Api$PDF$GetOptInDetails$authCall,
								authModel.user.jwt,
								appModel.apiEndPoint.getOptinDetails,
								model.createdDocumentId,
								value.transactionHash,
								value.blockNumber,
								A2($elm$core$Maybe$withDefault, '', model.selectedWallet))));
				} else {
					return _Utils_Tuple2(
						updateAppModel(model),
						$elm$core$Platform$Cmd$none);
				}
			case 'OnGetOptInDetailsResult':
				var result = msg.a;
				if (result.$ === 'Ok') {
					return _Utils_Tuple2(
						updateAppModel(
							_Utils_update(
								model,
								{
									modal: $elm$core$Maybe$Just($author$project$Type$FillTemplate$MakePayment)
								})),
						$elm$core$Platform$Cmd$none);
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						updateAppModel(
							_Utils_update(
								model,
								{
									error: $elm$core$Maybe$Just(
										$author$project$Type$FillTemplate$SubmitTemplateError(
											A2($author$project$Data$Api$authErrorToString, $author$project$Data$Api$PDF$GetOptInDetails$errorToString, error)))
								})),
						$elm$core$Platform$Cmd$none);
				}
			case 'PaymentTransactionClick':
				var walletAddr = ($elm$core$String$isEmpty(
					A2($elm$core$Maybe$withDefault, '', model.selectedWallet)) && (!_Utils_eq(authModel.user.algorandWalletAddress, $elm$core$Maybe$Nothing))) ? A2($elm$core$Maybe$withDefault, '', authModel.user.algorandWalletAddress) : A2($elm$core$Maybe$withDefault, '', model.selectedWallet);
				var cmdMsg = function () {
					var _v36 = $author$project$Model$Settings$convertStringToPayment(authModel.user.paymentMethod);
					switch (_v36.$) {
						case 'AlgoWallet':
							return $author$project$Model$ViewDocument$paymentTransaction(
								{checksum: '', docId: model.createdDocumentId, isCompleted: false, noOfDocuments: 1, ownerId: authModel.user.id, recipients: _List_Nil, route: 'FillTemplate', userWalletAddress: walletAddr});
						case 'WalletConnect':
							return A8(
								$author$project$Data$WalletConnect$initWalletConnectNotarization,
								A2($elm$core$Maybe$withDefault, '', authModel.user.algorandWalletAddress),
								$elm$core$Maybe$Nothing,
								model.createdDocumentId,
								authModel.user.id,
								_List_Nil,
								true,
								'FillTemplate',
								false);
						default:
							return $elm$core$Platform$Cmd$none;
					}
				}();
				return _Utils_Tuple2(
					updateAppModel(
						_Utils_update(
							model,
							{
								modal: $elm$core$Maybe$Just(
									$author$project$Type$FillTemplate$LoadingStatus($author$project$Type$FillTemplate$Payment))
							})),
					cmdMsg);
			case 'PaymentTransactionError':
				var result = msg.a;
				var walletAddr = ($elm$core$String$isEmpty(
					A2($elm$core$Maybe$withDefault, '', model.selectedWallet)) && (!_Utils_eq(authModel.user.algorandWalletAddress, $elm$core$Maybe$Nothing))) ? _List_fromArray(
					[
						A2($elm$core$Maybe$withDefault, '', authModel.user.algorandWalletAddress)
					]) : model.algorandWalletAddresses;
				var decodedMsg = function () {
					var _v37 = $author$project$Data$AlgorandWallet$decodePaymentTransactionError(result);
					if (_v37.$ === 'Ok') {
						var message = _v37.a;
						return message.error;
					} else {
						return 'Error paying ASA. Please try again.';
					}
				}();
				return _Utils_Tuple2(
					updateAppModel(
						_Utils_update(
							model,
							{
								modal: $elm$core$Maybe$Just(
									$author$project$Type$FillTemplate$DisplayWallet(walletAddr)),
								optInError: $elm$core$Maybe$Just(decodedMsg)
							})),
					$elm$core$Platform$Cmd$none);
			case 'SendNotarisationDetails':
				var result = msg.a;
				var _v38 = $author$project$Data$AlgorandWallet$decodeNotarisationResult(result);
				if (_v38.$ === 'Ok') {
					var value = _v38.a;
					return _Utils_Tuple2(
						updateAppModel(model),
						A2(
							$elm$core$Task$attempt,
							A2(
								$elm$core$Basics$composeL,
								A2(
									$elm$core$Basics$composeL,
									A2($elm$core$Basics$composeL, $author$project$Types$OnFillTemplate, $author$project$Type$FillTemplate$OnAuth),
									$author$project$Type$FillTemplate$OnLoaded),
								$author$project$Type$FillTemplate$OnGetNotarisationDetailsResult),
							A8(
								$author$project$Data$Api$PDF$NotariseWithAlgorandWallet$authCall,
								user.jwt,
								appModel.apiEndPoint.getAlgorandNotarisationDetails,
								model.createdDocumentId,
								value.transactionHash,
								value.blockNumber,
								value.notarisationTimeStamp,
								A2($elm$core$Maybe$withDefault, '', model.selectedWallet),
								false)));
				} else {
					return _Utils_Tuple2(
						updateAppModel(model),
						$elm$core$Platform$Cmd$none);
				}
			case 'OnGetNotarisationDetailsResult':
				var result = msg.a;
				if (result.$ === 'Ok') {
					return _Utils_Tuple2(
						updateAppModel(
							_Utils_update(
								model,
								{
									modal: $elm$core$Maybe$Just(
										$author$project$Type$FillTemplate$NotariseSuccess(
											$author$project$Model$FillTemplate$convertStringToNetwork(authModel.user.notarisationNetwork)))
								})),
						$elm$core$Platform$Cmd$none);
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						updateAppModel(
							_Utils_update(
								model,
								{
									error: $elm$core$Maybe$Just(
										$author$project$Type$FillTemplate$SubmitTemplateError(
											A2($author$project$Data$Api$authErrorToString, $author$project$Data$Api$PDF$NotariseWithAlgorandWallet$errorToString, error))),
									modal: $elm$core$Maybe$Nothing
								})),
						$elm$core$Platform$Cmd$none);
				}
			case 'OnCancelNotarisationClick':
				return _Utils_Tuple2(
					updateAppModel(
						_Utils_update(
							model,
							{
								modal: $elm$core$Maybe$Just(
									$author$project$Type$FillTemplate$LoadingStatus($author$project$Type$FillTemplate$CancelNotarisation))
							})),
					A2(
						$elm$core$Task$attempt,
						A2(
							$elm$core$Basics$composeL,
							A2(
								$elm$core$Basics$composeL,
								A2($elm$core$Basics$composeL, $author$project$Types$OnFillTemplate, $author$project$Type$FillTemplate$OnAuth),
								$author$project$Type$FillTemplate$OnLoaded),
							$author$project$Type$FillTemplate$OnCancelNotarisationResult),
						A3($author$project$Data$Api$PDF$CancelNotarisation$authCall, authModel.user.jwt, appModel.apiEndPoint.cancelNotarisation, model.createdDocumentId)));
			case 'OnCancelNotarisationResult':
				var result = msg.a;
				if (result.$ === 'Ok') {
					return _Utils_Tuple2(
						updateAppModel(
							_Utils_update(
								model,
								{
									modal: $elm$core$Maybe$Just($author$project$Type$FillTemplate$CancelNotarisationSuccess)
								})),
						$elm$core$Platform$Cmd$none);
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						updateAppModel(
							_Utils_update(
								model,
								{
									error: $elm$core$Maybe$Just(
										$author$project$Type$FillTemplate$SubmitTemplateError(
											A2($author$project$Data$Api$authErrorToString, $author$project$Data$Api$PDF$CancelNotarisation$errorToString, error)))
								})),
						$elm$core$Platform$Cmd$none);
				}
			case 'OnOptInStart':
				return _Utils_Tuple2(
					updateAppModel(
						_Utils_update(
							model,
							{
								modal: $elm$core$Maybe$Just(
									$author$project$Type$FillTemplate$LoadingStatus($author$project$Type$FillTemplate$GetWallet))
							})),
					$elm$core$Platform$Cmd$none);
			case 'OnWalletConnectWalletRecieve':
				var response = msg.a;
				var _v41 = $author$project$Data$Wallet$decodeWalletConnectResult(response);
				if (_v41.$ === 'Ok') {
					var result = _v41.a;
					return _Utils_Tuple2(
						updateAppModel(
							_Utils_update(
								model,
								{
									modal: $elm$core$Maybe$Just(
										$author$project$Type$FillTemplate$DisplayWalletAddress(result))
								})),
						$elm$core$Platform$Cmd$none);
				} else {
					return _Utils_Tuple2(
						updateAppModel(
							_Utils_update(
								model,
								{
									walletError: $elm$core$Maybe$Just('Error retrieving wallet addresses')
								})),
						$elm$core$Platform$Cmd$none);
				}
			case 'OnWalletConnectWalletSelect':
				var walletData = msg.a;
				var updatedModel = updateAppModel(
					_Utils_update(
						model,
						{
							modal: $elm$core$Maybe$Just(
								$author$project$Type$FillTemplate$LoadingStatus($author$project$Type$FillTemplate$RegisterWallet))
						}));
				var cmdMsg = walletData.needOptIn ? A2($author$project$Data$WalletConnect$startWalletConnectOptin, walletData.address, 'FillTemplate') : A2(
					$elm$core$Task$attempt,
					A2(
						$elm$core$Basics$composeL,
						A2(
							$elm$core$Basics$composeL,
							A2($elm$core$Basics$composeL, $author$project$Types$OnFillTemplate, $author$project$Type$FillTemplate$OnAuth),
							$author$project$Type$FillTemplate$OnLoaded),
						$author$project$Type$FillTemplate$OnWalletConnectRegisterApiResponse),
					A4($author$project$Data$Api$Points$WalletRegistration$authCall, authModel.user.jwt, appModel.apiEndPoint.pointsWalletRegistration, walletData.address, 'Algorand'));
				return _Utils_Tuple2(updatedModel, cmdMsg);
			case 'OnWalletConnectRegisterApiResponse':
				var response = msg.a;
				var newModel = function () {
					if (response.$ === 'Ok') {
						return model;
					} else {
						return _Utils_update(
							model,
							{
								walletError: $elm$core$Maybe$Just('Error with wallet Registration. Please try again')
							});
					}
				}();
				return _Utils_Tuple2(
					updateAppModel(
						_Utils_update(
							newModel,
							{
								modal: $elm$core$Maybe$Just($author$project$Type$FillTemplate$Success)
							})),
					$elm$core$Platform$Cmd$none);
			case 'OnWalletConnectWalletOptInCompleted':
				var result = msg.a;
				var _v43 = $author$project$Data$Wallet$decodeWalletAddress(result);
				if (_v43.$ === 'Ok') {
					var transactionDetails = _v43.a;
					return _Utils_Tuple2(
						appModel,
						A2(
							$elm$core$Task$attempt,
							A2(
								$elm$core$Basics$composeL,
								A2(
									$elm$core$Basics$composeL,
									A2($elm$core$Basics$composeL, $author$project$Types$OnFillTemplate, $author$project$Type$FillTemplate$OnAuth),
									$author$project$Type$FillTemplate$OnLoaded),
								$author$project$Type$FillTemplate$OnWalletConnectOptInResponse),
							A6($author$project$Data$Api$PDF$GetOptInDetails$authCall, authModel.user.jwt, appModel.apiEndPoint.getOptinDetails, 'docId', transactionDetails.id, transactionDetails.block, transactionDetails.address)));
				} else {
					return _Utils_Tuple2(
						updateAppModel(model),
						$elm$core$Platform$Cmd$none);
				}
			case 'OnWalletConnectOptInResponse':
				var response = msg.a;
				var newModel = function () {
					if (response.$ === 'Ok') {
						return model;
					} else {
						return _Utils_update(
							model,
							{
								walletError: $elm$core$Maybe$Just('Error with wallet Registration. Please try again')
							});
					}
				}();
				return _Utils_Tuple2(
					updateAppModel(
						_Utils_update(
							newModel,
							{
								modal: $elm$core$Maybe$Just($author$project$Type$FillTemplate$Success)
							})),
					$elm$core$Platform$Cmd$none);
			case 'OnWalletConnectNotarizationCompleted':
				var result = msg.a;
				var _v45 = $author$project$Data$AlgorandWallet$decodeNotarisationResult(result);
				if (_v45.$ === 'Ok') {
					var data = _v45.a;
					return _Utils_Tuple2(
						updateAppModel(model),
						A2(
							$elm$core$Task$attempt,
							A2(
								$elm$core$Basics$composeL,
								A2(
									$elm$core$Basics$composeL,
									A2($elm$core$Basics$composeL, $author$project$Types$OnFillTemplate, $author$project$Type$FillTemplate$OnAuth),
									$author$project$Type$FillTemplate$OnLoaded),
								$author$project$Type$FillTemplate$OnWalletConnectNotarizationResponse),
							A8(
								$author$project$Data$Api$PDF$NotariseWithAlgorandWallet$authCall,
								user.jwt,
								appModel.apiEndPoint.getAlgorandNotarisationDetails,
								model.createdDocumentId,
								data.transactionHash,
								data.blockNumber,
								data.notarisationTimeStamp,
								A2($elm$core$Maybe$withDefault, '', authModel.user.algorandWalletAddress),
								false)));
				} else {
					var error = _v45.a;
					return _Utils_Tuple2(
						updateAppModel(
							_Utils_update(
								model,
								{
									walletError: $elm$core$Maybe$Just(error)
								})),
						$elm$core$Platform$Cmd$none);
				}
			case 'OnWalletConnectStart':
				return _Utils_Tuple2(
					updateAppModel(
						_Utils_update(
							model,
							{
								modal: $elm$core$Maybe$Just(
									$author$project$Type$FillTemplate$NotarizingDocument(model.payload.title))
							})),
					$elm$core$Platform$Cmd$none);
			case 'OnWalletConnectNotarizationResponse':
				var result = msg.a;
				if (result.$ === 'Ok') {
					return _Utils_Tuple2(
						updateAppModel(
							_Utils_update(
								model,
								{
									modal: $elm$core$Maybe$Just(
										$author$project$Type$FillTemplate$NotariseSuccess(
											$author$project$Model$FillTemplate$convertStringToNetwork(authModel.user.notarisationNetwork)))
								})),
						$elm$core$Platform$Cmd$none);
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						updateAppModel(
							_Utils_update(
								model,
								{
									error: $elm$core$Maybe$Just(
										$author$project$Type$FillTemplate$SubmitTemplateError(
											A2($author$project$Data$Api$authErrorToString, $author$project$Data$Api$PDF$NotariseWithAlgorandWallet$errorToString, error))),
									modal: $elm$core$Maybe$Nothing
								})),
						$elm$core$Platform$Cmd$none);
				}
			case 'OnCreateDocumentFromTemplate':
				var slug = msg.a;
				return _Utils_Tuple2(
					appModel,
					A2($elm$browser$Browser$Navigation$pushUrl, appModel.navKey, $author$project$Data$Route$routeUrl.fillTemplate + ('/' + slug)));
			case 'OnShowModal':
				var newModal = msg.a;
				return _Utils_Tuple2(
					updateAppModel(
						_Utils_update(
							model,
							{
								modal: $elm$core$Maybe$Just(newModal)
							})),
					$elm$core$Platform$Cmd$none);
			case 'OnDeleteTemplate':
				var templateId = msg.a;
				return _Utils_Tuple2(
					updateAppModel(
						_Utils_update(
							model,
							{
								modal: $elm$core$Maybe$Just(
									$author$project$Type$FillTemplate$LoadingStatus($author$project$Type$FillTemplate$RequestDelete))
							})),
					A2(
						$elm$core$Task$attempt,
						A2(
							$elm$core$Basics$composeL,
							A2(
								$elm$core$Basics$composeL,
								A2($elm$core$Basics$composeL, $author$project$Types$OnFillTemplate, $author$project$Type$FillTemplate$OnAuth),
								$author$project$Type$FillTemplate$OnViewTemplateInfo),
							$author$project$Type$FillTemplate$OnDeleteTemplateResult),
						A4(
							$author$project$Data$Api$PDF$DeleteTemplate$authCall,
							user.jwt,
							appModel.apiEndPoint.deleteTemplate,
							templateId,
							$author$project$Data$Domain$selected(user.domains))));
			case 'OnDeleteTemplateResult':
				var result = msg.a;
				if (result.$ === 'Ok') {
					return _Utils_Tuple2(
						updateAppModel(
							_Utils_update(
								model,
								{
									modal: $elm$core$Maybe$Just($author$project$Type$FillTemplate$DeleteTemplateSuccess)
								})),
						$elm$core$Platform$Cmd$none);
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						updateAppModel(
							_Utils_update(
								model,
								{
									error: $elm$core$Maybe$Just(
										$author$project$Type$FillTemplate$SubmitTemplateError(
											A2($author$project$Data$Api$authErrorToString, $author$project$Data$Api$PDF$DeleteTemplate$errorToString, error))),
									modal: $elm$core$Maybe$Nothing
								})),
						$elm$core$Platform$Cmd$none);
				}
			case 'OnRequestTemplateClick':
				var slug = msg.a;
				return _Utils_Tuple2(
					updateAppModel(
						_Utils_update(
							model,
							{
								modal: $elm$core$Maybe$Just(
									$author$project$Type$FillTemplate$LoadingStatus($author$project$Type$FillTemplate$RequestFillTemplateLink))
							})),
					A2(
						$elm$core$Task$attempt,
						A2(
							$elm$core$Basics$composeL,
							A2(
								$elm$core$Basics$composeL,
								A2($elm$core$Basics$composeL, $author$project$Types$OnFillTemplate, $author$project$Type$FillTemplate$OnAuth),
								$author$project$Type$FillTemplate$OnViewTemplateInfo),
							$author$project$Type$FillTemplate$OnRequestTemplateResult),
						A2(
							$author$project$Data$Api$PDF$IssueAnonymous$call,
							appModel.apiEndPoint.issueAnonymousTemplateToken,
							{email: user.email, slug: slug})));
			case 'OnRequestTemplateResult':
				var result = msg.a;
				if (result.$ === 'Ok') {
					var value = result.a;
					return _Utils_Tuple2(
						updateAppModel(
							_Utils_update(
								model,
								{
									modal: $elm$core$Maybe$Just(
										$author$project$Type$FillTemplate$RequestTemplateSuccess(value.docId))
								})),
						$elm$core$Platform$Cmd$none);
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						updateAppModel(
							_Utils_update(
								model,
								{
									error: $elm$core$Maybe$Just(
										$author$project$Type$FillTemplate$SubmitTemplateError(
											A2($author$project$Data$Api$errorToString, $author$project$Data$Api$PDF$IssueAnonymous$errorToString, error))),
									modal: $elm$core$Maybe$Nothing
								})),
						$elm$core$Platform$Cmd$none);
				}
			case 'OnRouteToViewDocument':
				var docId = msg.a;
				return _Utils_Tuple2(
					appModel,
					A2(
						$elm$browser$Browser$Navigation$pushUrl,
						appModel.navKey,
						_Utils_ap($author$project$Data$Route$routeUrl.viewDocument, docId)));
			case 'OnDownloadTemplateReport':
				var templateId = msg.a;
				return _Utils_Tuple2(
					appModel,
					A2(
						$elm$core$Task$attempt,
						A2(
							$elm$core$Basics$composeL,
							A2(
								$elm$core$Basics$composeL,
								A2($elm$core$Basics$composeL, $author$project$Types$OnFillTemplate, $author$project$Type$FillTemplate$OnAuth),
								$author$project$Type$FillTemplate$OnViewTemplateInfo),
							$author$project$Type$FillTemplate$OnDownloadTemplateReportResult),
						A4($author$project$Data$Api$PDF$DownloadTemplateReport$authCall, user.jwt, appModel.apiEndPoint.downloadTemplateReport, templateId, appModel.timezoneOffset / 60)));
			case 'OnDownloadTemplateReportResult':
				var result = msg.a;
				var templateId = model.payload.id;
				if (result.$ === 'Ok') {
					var value = result.a;
					return _Utils_Tuple2(
						appModel,
						A3($elm$file$File$Download$bytes, templateId + '-report.xlsx', 'application/xlsx', value));
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						updateAppModel(
							_Utils_update(
								model,
								{
									error: $elm$core$Maybe$Just(
										$author$project$Type$FillTemplate$SubmitTemplateError(
											A2($author$project$Data$Api$authErrorToString, $author$project$Data$Api$PDF$DownloadTemplateReport$errorToString, error))),
									modal: $elm$core$Maybe$Nothing
								})),
						$elm$core$Platform$Cmd$none);
				}
			default:
				var value = msg.a;
				var base64PDF = function () {
					var _v50 = $author$project$Data$PDF$Port$decodeBase64String(value);
					if (_v50.$ === 'Ok') {
						var result = _v50.a;
						return result;
					} else {
						return '';
					}
				}();
				return _Utils_Tuple2(
					updateAppModel(
						_Utils_update(
							model,
							{
								base64FileData: $elm$core$Maybe$Just(base64PDF)
							})),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Model$FillTemplate$updateAuthModel = F3(
	function (msg, authModel, model) {
		var updateCurrentModel = function (currentModel) {
			return _Utils_update(
				model,
				{
					sessionModel: $author$project$Types$Auth(
						_Utils_update(
							authModel,
							{fillTemplateModel: currentModel}))
				});
		};
		var _v0 = authModel;
		var fillTemplateModel = _v0.fillTemplateModel;
		var user = _v0.user;
		var signatureModel = _v0.signatureModel;
		var maybeCurrentUserSig = $author$project$Type$Signature$firstSignature(signatureModel.signatures);
		switch (msg.$) {
			case 'OnUnload':
				return _Utils_Tuple2(
					updateCurrentModel($author$project$Type$FillTemplate$NotLoaded),
					$author$project$Data$PDF$FillTemplate$unload(_Utils_Tuple0));
			case 'LoadTemplate':
				var slug = msg.a;
				return _Utils_Tuple2(
					updateCurrentModel($author$project$Type$FillTemplate$Loading),
					A2(
						$elm$core$Task$attempt,
						A2(
							$elm$core$Basics$composeL,
							A2($elm$core$Basics$composeL, $author$project$Types$OnFillTemplate, $author$project$Type$FillTemplate$OnAuth),
							$author$project$Type$FillTemplate$LoadTemplateResult),
						A3(
							$author$project$Data$Api$PDF$ViewTemplate$authCall,
							user.jwt,
							model.apiEndPoint.viewTemplate,
							_Utils_Tuple2(
								$author$project$Data$Domain$toString(
									$author$project$Data$Domain$selected(authModel.user.domains)),
								slug))));
			case 'LoadTemplateResult':
				var result = msg.a;
				if (result.$ === 'Ok') {
					var templatePayload = result.a;
					var viewerData = A2(
						$elm$core$List$map,
						function (r) {
							return {
								displayAll: true,
								email: A2($elm$core$Maybe$withDefault, '', r.email),
								emailError: $elm$core$Maybe$Nothing,
								firstName: A2($elm$core$Maybe$withDefault, '', r.firstName),
								firstNameError: $elm$core$Maybe$Nothing,
								isRecipientAssigned: true,
								lastName: A2($elm$core$Maybe$withDefault, '', r.lastName),
								lastNameError: $elm$core$Maybe$Nothing,
								role: r.role,
								roleId: r.roleId,
								search: '',
								searchResult: $elm$core$Maybe$Nothing,
								signOrder: r.signOrder
							};
						},
						templatePayload.viewers);
					var maybeSignatureID = $author$project$Data$Api$PDF$ViewTemplate$signedSignatureId(templatePayload.filledAnnots);
					var allTemplateFieldsAnnots = templatePayload.fieldAnnots;
					var recipientInfo = A3(
						$elm$core$List$foldl,
						$author$project$Model$FillTemplate$removeDuplicates,
						_List_Nil,
						A2(
							$elm$core$List$map,
							function (r) {
								return {
									displayAll: $elm$core$String$isEmpty(
										A2($elm$core$Maybe$withDefault, '', r.email)),
									email: A2($elm$core$Maybe$withDefault, '', r.email),
									emailError: $elm$core$Maybe$Nothing,
									firstName: A2($elm$core$Maybe$withDefault, '', r.firstName),
									firstNameError: $elm$core$Maybe$Nothing,
									isRecipientAssigned: !($elm$core$String$isEmpty(
										A2($elm$core$Maybe$withDefault, '', r.email)) && ($elm$core$String$isEmpty(
										A2($elm$core$Maybe$withDefault, '', r.firstName)) && $elm$core$String$isEmpty(
										A2($elm$core$Maybe$withDefault, '', r.lastName)))),
									lastName: A2($elm$core$Maybe$withDefault, '', r.lastName),
									lastNameError: $elm$core$Maybe$Nothing,
									role: r.roleName,
									roleId: r.roleId,
									search: '',
									searchResult: $elm$core$Maybe$Nothing,
									signOrder: r.signOrder
								};
							},
							allTemplateFieldsAnnots));
					var signerAndViewerRoleData = A2($elm$core$List$append, viewerData, recipientInfo);
					var recipientDetails = A2(
						$elm$core$List$indexedMap,
						F2(
							function (index, r) {
								return {
									colour: $author$project$Data$PDF$User$nextUserColor(index),
									displayAll: r.displayAll,
									email: r.email,
									emailError: r.emailError,
									firstName: r.firstName,
									firstNameError: r.firstNameError,
									index: index,
									isRecipientAssigned: r.isRecipientAssigned,
									lastName: r.lastName,
									lastNameError: r.lastNameError,
									role: r.role,
									roleId: r.roleId,
									search: r.search,
									searchResult: r.searchResult,
									signOrder: r.signOrder
								};
							}),
						signerAndViewerRoleData);
					var nextSmallestUnassignedIndex = $elm$core$List$minimum(
						A2(
							$elm$core$List$map,
							function (r) {
								return r.index;
							},
							A2(
								$elm$core$List$filter,
								function (r) {
									return !r.isRecipientAssigned;
								},
								recipientDetails)));
					var finalRecipientList = A2(
						$elm$core$List$map,
						function (r) {
							return {
								colour: r.colour,
								displayAll: r.isRecipientAssigned ? false : ((_Utils_eq(
									r.index,
									A2($elm$core$Maybe$withDefault, 0, nextSmallestUnassignedIndex)) && (!r.isRecipientAssigned)) ? true : false),
								email: r.email,
								emailError: r.emailError,
								firstName: r.firstName,
								firstNameError: r.firstNameError,
								index: r.index,
								isRecipientAssigned: r.isRecipientAssigned,
								lastName: r.lastName,
								lastNameError: r.lastNameError,
								role: r.role,
								roleId: r.roleId,
								search: r.search,
								searchResult: r.searchResult,
								signOrder: r.signOrder
							};
						},
						recipientDetails);
					var signOrderAssigned = A2(
						$elm$core$List$all,
						function (r) {
							return !(!r.signOrder);
						},
						allTemplateFieldsAnnots);
					if (maybeSignatureID.$ === 'Just') {
						var sigId = maybeSignatureID.a;
						return _Utils_Tuple2(
							model,
							A2(
								$elm$core$Task$attempt,
								A2(
									$elm$core$Basics$composeL,
									A2($elm$core$Basics$composeL, $author$project$Types$OnFillTemplate, $author$project$Type$FillTemplate$OnAuth),
									$author$project$Type$FillTemplate$SignedSignatureResult(templatePayload)),
								A3($author$project$Data$Api$Signature$File$authCall, user.jwt, model.apiEndPoint.signatureFile, sigId)));
					} else {
						var templateResult = A4($author$project$Data$PDF$FillTemplate$initWithPayload, model.currentTime, maybeCurrentUserSig, $elm$core$Maybe$Nothing, templatePayload);
						if (templateResult.$ === 'Ok') {
							var templateData = templateResult.a;
							return _Utils_Tuple2(
								updateCurrentModel(
									$author$project$Type$FillTemplate$Loaded(
										{
											additionalMsg: $elm$core$Maybe$Nothing,
											algorandNotarisationCost: templatePayload.algorandNotarisationCost,
											algorandWalletAddresses: _List_Nil,
											base64FileData: $elm$core$Maybe$Nothing,
											binanceNotarisationCost: templatePayload.binanceNotarisationCost,
											createdDocumentId: '',
											currentRoleId: '',
											dueDate: $elm$core$Maybe$Nothing,
											dueDateError: $elm$core$Maybe$Nothing,
											error: $elm$core$Maybe$Nothing,
											modal: $elm$core$Maybe$Nothing,
											needOptIn: false,
											optInError: $elm$core$Maybe$Nothing,
											optInStatusCode: $elm$core$Maybe$Nothing,
											passcode: $elm$core$Maybe$Nothing,
											passcodeError: $elm$core$Maybe$Nothing,
											password: $elm$core$Maybe$Nothing,
											passwordError: $elm$core$Maybe$Nothing,
											payload: templatePayload,
											recipients: finalRecipientList,
											requireNotarisation: false,
											searchTerm: '',
											selectedSignature: maybeCurrentUserSig,
											selectedWallet: $elm$core$Maybe$Nothing,
											showAdditionalMsg: false,
											showDueDate: false,
											showPasscodeInput: false,
											signPointsBalance: templatePayload.signPointsBalance,
											signingOrderAssigned: signOrderAssigned,
											signingType: signOrderAssigned ? $author$project$Type$FillTemplate$SigningOrder : $author$project$Type$FillTemplate$NoSigningOrder,
											stage: $author$project$Type$FillTemplate$Recipients,
											template: templateData,
											toolTipActiveHover: $author$project$Type$FillTemplate$Closed,
											walletError: $elm$core$Maybe$Nothing
										})),
								A3($author$project$Data$PDF$FillTemplate$load, model.apiEndPoint.templateFile, user.jwt, templateData));
						} else {
							var error = templateResult.a;
							return _Utils_Tuple2(
								updateCurrentModel(
									$author$project$Type$FillTemplate$LoadingDecodeError(error)),
								$elm$core$Platform$Cmd$none);
						}
					}
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						updateCurrentModel(
							$author$project$Type$FillTemplate$LoadingApiError(error)),
						$elm$core$Platform$Cmd$none);
				}
			case 'SignedSignatureResult':
				var templatePayload = msg.a;
				var result = msg.b;
				if (result.$ === 'Ok') {
					var payload = result.a;
					var allTemplateFieldsAnnots = templatePayload.fieldAnnots;
					var recipientInfo = A3(
						$elm$core$List$foldl,
						$author$project$Model$FillTemplate$removeDuplicates,
						_List_Nil,
						A2(
							$elm$core$List$map,
							function (r) {
								return {
									displayAll: $elm$core$String$isEmpty(
										A2($elm$core$Maybe$withDefault, '', r.email)),
									email: A2($elm$core$Maybe$withDefault, '', r.email),
									emailError: $elm$core$Maybe$Nothing,
									firstName: A2($elm$core$Maybe$withDefault, '', r.firstName),
									firstNameError: $elm$core$Maybe$Nothing,
									isRecipientAssigned: !($elm$core$String$isEmpty(
										A2($elm$core$Maybe$withDefault, '', r.email)) && ($elm$core$String$isEmpty(
										A2($elm$core$Maybe$withDefault, '', r.firstName)) && $elm$core$String$isEmpty(
										A2($elm$core$Maybe$withDefault, '', r.lastName)))),
									lastName: A2($elm$core$Maybe$withDefault, '', r.lastName),
									lastNameError: $elm$core$Maybe$Nothing,
									role: r.roleName,
									roleId: r.roleId,
									search: '',
									searchResult: $elm$core$Maybe$Nothing,
									signOrder: r.signOrder
								};
							},
							allTemplateFieldsAnnots));
					var recipientDetails = A2(
						$elm$core$List$indexedMap,
						F2(
							function (index, r) {
								return {
									colour: $author$project$Data$PDF$User$nextUserColor(index),
									displayAll: r.displayAll,
									email: r.email,
									emailError: r.emailError,
									firstName: r.firstName,
									firstNameError: r.firstNameError,
									index: index,
									isRecipientAssigned: r.isRecipientAssigned,
									lastName: r.lastName,
									lastNameError: r.lastNameError,
									role: r.role,
									roleId: r.roleId,
									search: r.search,
									searchResult: r.searchResult,
									signOrder: r.signOrder
								};
							}),
						recipientInfo);
					var nextSmallestUnassignedIndex = $elm$core$List$minimum(
						A2(
							$elm$core$List$map,
							function (r) {
								return r.index;
							},
							A2(
								$elm$core$List$filter,
								function (r) {
									return !r.isRecipientAssigned;
								},
								recipientDetails)));
					var finalRecipientList = A2(
						$elm$core$List$map,
						function (r) {
							return {
								colour: r.colour,
								displayAll: r.isRecipientAssigned ? false : ((_Utils_eq(
									r.index,
									A2($elm$core$Maybe$withDefault, 0, nextSmallestUnassignedIndex)) && (!r.isRecipientAssigned)) ? true : false),
								email: r.email,
								emailError: r.emailError,
								firstName: r.firstName,
								firstNameError: r.firstNameError,
								index: r.index,
								isRecipientAssigned: r.isRecipientAssigned,
								lastName: r.lastName,
								lastNameError: r.lastNameError,
								role: r.role,
								roleId: r.roleId,
								search: r.search,
								searchResult: r.searchResult,
								signOrder: r.signOrder
							};
						},
						recipientDetails);
					var signOrderAssigned = A2(
						$elm$core$List$all,
						function (r) {
							return !(!r.signOrder);
						},
						allTemplateFieldsAnnots);
					var _v6 = payload.signature;
					var id = _v6.id;
					var name = _v6.name;
					var data = _v6.data;
					var filledSignature = A3($author$project$Data$PDF$Signature$create, id, name, data);
					var templateResult = A4(
						$author$project$Data$PDF$FillTemplate$initWithPayload,
						model.currentTime,
						maybeCurrentUserSig,
						$elm$core$Maybe$Just(filledSignature),
						templatePayload);
					if (templateResult.$ === 'Ok') {
						var templateData = templateResult.a;
						return _Utils_Tuple2(
							updateCurrentModel(
								$author$project$Type$FillTemplate$Loaded(
									{
										additionalMsg: $elm$core$Maybe$Nothing,
										algorandNotarisationCost: templatePayload.algorandNotarisationCost,
										algorandWalletAddresses: _List_Nil,
										base64FileData: $elm$core$Maybe$Nothing,
										binanceNotarisationCost: templatePayload.binanceNotarisationCost,
										createdDocumentId: '',
										currentRoleId: '',
										dueDate: $elm$core$Maybe$Nothing,
										dueDateError: $elm$core$Maybe$Nothing,
										error: $elm$core$Maybe$Nothing,
										modal: $elm$core$Maybe$Nothing,
										needOptIn: false,
										optInError: $elm$core$Maybe$Nothing,
										optInStatusCode: $elm$core$Maybe$Nothing,
										passcode: $elm$core$Maybe$Nothing,
										passcodeError: $elm$core$Maybe$Nothing,
										password: $elm$core$Maybe$Nothing,
										passwordError: $elm$core$Maybe$Nothing,
										payload: templatePayload,
										recipients: finalRecipientList,
										requireNotarisation: false,
										searchTerm: '',
										selectedSignature: maybeCurrentUserSig,
										selectedWallet: $elm$core$Maybe$Nothing,
										showAdditionalMsg: false,
										showDueDate: false,
										showPasscodeInput: false,
										signPointsBalance: templatePayload.signPointsBalance,
										signingOrderAssigned: signOrderAssigned,
										signingType: signOrderAssigned ? $author$project$Type$FillTemplate$SigningOrder : $author$project$Type$FillTemplate$NoSigningOrder,
										stage: $author$project$Type$FillTemplate$Recipients,
										template: templateData,
										toolTipActiveHover: $author$project$Type$FillTemplate$Closed,
										walletError: $elm$core$Maybe$Nothing
									})),
							A3($author$project$Data$PDF$FillTemplate$load, model.apiEndPoint.templateFile, user.jwt, templateData));
					} else {
						var error = templateResult.a;
						return _Utils_Tuple2(
							updateCurrentModel(
								$author$project$Type$FillTemplate$LoadingDecodeError(error)),
							$elm$core$Platform$Cmd$none);
					}
				} else {
					return _Utils_Tuple2(
						updateCurrentModel($author$project$Type$FillTemplate$LoadingSignatureError),
						$elm$core$Platform$Cmd$none);
				}
			case 'OnRefreshClick':
				return _Utils_Tuple2(model, $elm$browser$Browser$Navigation$reload);
			case 'OnNavigateToDashboard':
				return _Utils_Tuple2(
					model,
					A2($elm$browser$Browser$Navigation$pushUrl, model.navKey, $author$project$Data$Route$routeUrl.dashboard));
			case 'OnLoaded':
				var loadedMsg = msg.a;
				switch (fillTemplateModel.$) {
					case 'Loaded':
						var loadedModel = fillTemplateModel.a;
						return A4($author$project$Model$FillTemplate$updateLoadedModel, loadedMsg, loadedModel, authModel, model);
					case 'ViewTemplate':
						var loadedModel = fillTemplateModel.a;
						return A4($author$project$Model$FillTemplate$updateLoadedModel, loadedMsg, loadedModel, authModel, model);
					default:
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 'OnNavigateToRegister':
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 'OnViewTemplateInfo':
				var loadedMsg = msg.a;
				if (fillTemplateModel.$ === 'ViewTemplate') {
					var loadedModel = fillTemplateModel.a;
					return A4($author$project$Model$FillTemplate$updateLoadedModel, loadedMsg, loadedModel, authModel, model);
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 'ViewTemplateInfo':
				var slug = msg.a;
				var isDomainHostInUserDomain = A2(
					$elm$core$List$member,
					model.domainHost,
					$author$project$Data$Domain$all(user.domains));
				var cmdMsg = isDomainHostInUserDomain ? A2(
					$elm$core$Task$attempt,
					A2(
						$elm$core$Basics$composeL,
						A2($elm$core$Basics$composeL, $author$project$Types$OnFillTemplate, $author$project$Type$FillTemplate$OnAuth),
						$author$project$Type$FillTemplate$ViewTemplateInfoResult),
					A3(
						$author$project$Data$Api$PDF$ViewTemplate$authCall,
						user.jwt,
						model.apiEndPoint.viewTemplate,
						_Utils_Tuple2(
							$author$project$Data$Domain$toString(
								$author$project$Data$Domain$selected(authModel.user.domains)),
							slug))) : A2($elm$browser$Browser$Navigation$pushUrl, model.navKey, $author$project$Data$Route$routeUrl.dashboard);
				return _Utils_Tuple2(
					updateCurrentModel($author$project$Type$FillTemplate$Loading),
					cmdMsg);
			case 'ViewTemplateInfoResult':
				var result = msg.a;
				if (result.$ === 'Ok') {
					var templatePayload = result.a;
					var maybeSignatureID = $author$project$Data$Api$PDF$ViewTemplate$signedSignatureId(templatePayload.filledAnnots);
					var allTemplateFieldsAnnots = templatePayload.fieldAnnots;
					var recipientInfo = A3(
						$elm$core$List$foldl,
						$author$project$Model$FillTemplate$removeDuplicates,
						_List_Nil,
						A2(
							$elm$core$List$map,
							function (r) {
								return {
									displayAll: $elm$core$String$isEmpty(
										A2($elm$core$Maybe$withDefault, '', r.email)),
									email: A2($elm$core$Maybe$withDefault, '', r.email),
									emailError: $elm$core$Maybe$Nothing,
									firstName: A2($elm$core$Maybe$withDefault, '', r.firstName),
									firstNameError: $elm$core$Maybe$Nothing,
									isRecipientAssigned: !($elm$core$String$isEmpty(
										A2($elm$core$Maybe$withDefault, '', r.email)) && ($elm$core$String$isEmpty(
										A2($elm$core$Maybe$withDefault, '', r.firstName)) && $elm$core$String$isEmpty(
										A2($elm$core$Maybe$withDefault, '', r.lastName)))),
									lastName: A2($elm$core$Maybe$withDefault, '', r.lastName),
									lastNameError: $elm$core$Maybe$Nothing,
									role: r.roleName,
									roleId: r.roleId,
									search: '',
									searchResult: $elm$core$Maybe$Nothing,
									signOrder: r.signOrder
								};
							},
							allTemplateFieldsAnnots));
					var recipientDetails = A2(
						$elm$core$List$indexedMap,
						F2(
							function (index, r) {
								return {
									colour: $author$project$Data$PDF$User$nextUserColor(index),
									displayAll: r.displayAll,
									email: r.email,
									emailError: r.emailError,
									firstName: r.firstName,
									firstNameError: r.firstNameError,
									index: index,
									isRecipientAssigned: r.isRecipientAssigned,
									lastName: r.lastName,
									lastNameError: r.lastNameError,
									role: r.role,
									roleId: r.roleId,
									search: r.search,
									searchResult: r.searchResult,
									signOrder: r.signOrder
								};
							}),
						recipientInfo);
					var nextSmallestUnassignedIndex = $elm$core$List$minimum(
						A2(
							$elm$core$List$map,
							function (r) {
								return r.index;
							},
							A2(
								$elm$core$List$filter,
								function (r) {
									return !r.isRecipientAssigned;
								},
								recipientDetails)));
					var finalRecipientList = A2(
						$elm$core$List$map,
						function (r) {
							return {
								colour: r.colour,
								displayAll: r.isRecipientAssigned ? false : ((_Utils_eq(
									r.index,
									A2($elm$core$Maybe$withDefault, 0, nextSmallestUnassignedIndex)) && (!r.isRecipientAssigned)) ? true : false),
								email: r.email,
								emailError: r.emailError,
								firstName: r.firstName,
								firstNameError: r.firstNameError,
								index: r.index,
								isRecipientAssigned: r.isRecipientAssigned,
								lastName: r.lastName,
								lastNameError: r.lastNameError,
								role: r.role,
								roleId: r.roleId,
								search: r.search,
								searchResult: r.searchResult,
								signOrder: r.signOrder
							};
						},
						recipientDetails);
					var signOrderAssigned = A2(
						$elm$core$List$all,
						function (r) {
							return !(!r.signOrder);
						},
						allTemplateFieldsAnnots);
					if (maybeSignatureID.$ === 'Just') {
						var sigId = maybeSignatureID.a;
						return _Utils_Tuple2(
							model,
							A2(
								$elm$core$Task$attempt,
								A2(
									$elm$core$Basics$composeL,
									A2($elm$core$Basics$composeL, $author$project$Types$OnFillTemplate, $author$project$Type$FillTemplate$OnAuth),
									$author$project$Type$FillTemplate$ViewTemplatesignedSignatureResult(templatePayload)),
								A3($author$project$Data$Api$Signature$File$authCall, user.jwt, model.apiEndPoint.signatureFile, sigId)));
					} else {
						var templateResult = A4($author$project$Data$PDF$FillTemplate$initWithPayload, model.currentTime, maybeCurrentUserSig, $elm$core$Maybe$Nothing, templatePayload);
						if (templateResult.$ === 'Ok') {
							var templateData = templateResult.a;
							return _Utils_Tuple2(
								updateCurrentModel(
									$author$project$Type$FillTemplate$ViewTemplate(
										{
											additionalMsg: $elm$core$Maybe$Nothing,
											algorandNotarisationCost: templatePayload.algorandNotarisationCost,
											algorandWalletAddresses: _List_Nil,
											base64FileData: $elm$core$Maybe$Nothing,
											binanceNotarisationCost: templatePayload.binanceNotarisationCost,
											createdDocumentId: '',
											currentRoleId: '',
											dueDate: $elm$core$Maybe$Nothing,
											dueDateError: $elm$core$Maybe$Nothing,
											error: $elm$core$Maybe$Nothing,
											modal: $elm$core$Maybe$Nothing,
											needOptIn: false,
											optInError: $elm$core$Maybe$Nothing,
											optInStatusCode: $elm$core$Maybe$Nothing,
											passcode: $elm$core$Maybe$Nothing,
											passcodeError: $elm$core$Maybe$Nothing,
											password: $elm$core$Maybe$Nothing,
											passwordError: $elm$core$Maybe$Nothing,
											payload: templatePayload,
											recipients: finalRecipientList,
											requireNotarisation: false,
											searchTerm: '',
											selectedSignature: maybeCurrentUserSig,
											selectedWallet: $elm$core$Maybe$Nothing,
											showAdditionalMsg: false,
											showDueDate: false,
											showPasscodeInput: false,
											signPointsBalance: templatePayload.signPointsBalance,
											signingOrderAssigned: signOrderAssigned,
											signingType: signOrderAssigned ? $author$project$Type$FillTemplate$SigningOrder : $author$project$Type$FillTemplate$NoSigningOrder,
											stage: $author$project$Type$FillTemplate$Recipients,
											template: templateData,
											toolTipActiveHover: $author$project$Type$FillTemplate$Closed,
											walletError: $elm$core$Maybe$Nothing
										})),
								A3($author$project$Data$PDF$FillTemplate$load, model.apiEndPoint.templateFile, user.jwt, templateData));
						} else {
							var error = templateResult.a;
							return _Utils_Tuple2(
								updateCurrentModel(
									$author$project$Type$FillTemplate$LoadingDecodeError(error)),
								$elm$core$Platform$Cmd$none);
						}
					}
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						updateCurrentModel(
							$author$project$Type$FillTemplate$LoadingApiError(error)),
						$elm$core$Platform$Cmd$none);
				}
			default:
				var templatePayload = msg.a;
				var result = msg.b;
				if (result.$ === 'Ok') {
					var payload = result.a;
					var _v14 = payload.signature;
					var id = _v14.id;
					var name = _v14.name;
					var data = _v14.data;
					var filledSignature = A3($author$project$Data$PDF$Signature$create, id, name, data);
					var templateResult = A4(
						$author$project$Data$PDF$FillTemplate$initWithPayload,
						model.currentTime,
						maybeCurrentUserSig,
						$elm$core$Maybe$Just(filledSignature),
						templatePayload);
					if (templateResult.$ === 'Ok') {
						var templateData = templateResult.a;
						return _Utils_Tuple2(
							updateCurrentModel(
								$author$project$Type$FillTemplate$ViewTemplate(
									{additionalMsg: $elm$core$Maybe$Nothing, algorandNotarisationCost: 0, algorandWalletAddresses: _List_Nil, base64FileData: $elm$core$Maybe$Nothing, binanceNotarisationCost: 0, createdDocumentId: '', currentRoleId: '', dueDate: $elm$core$Maybe$Nothing, dueDateError: $elm$core$Maybe$Nothing, error: $elm$core$Maybe$Nothing, modal: $elm$core$Maybe$Nothing, needOptIn: false, optInError: $elm$core$Maybe$Nothing, optInStatusCode: $elm$core$Maybe$Nothing, passcode: $elm$core$Maybe$Nothing, passcodeError: $elm$core$Maybe$Nothing, password: $elm$core$Maybe$Nothing, passwordError: $elm$core$Maybe$Nothing, payload: templatePayload, recipients: _List_Nil, requireNotarisation: false, searchTerm: '', selectedSignature: maybeCurrentUserSig, selectedWallet: $elm$core$Maybe$Nothing, showAdditionalMsg: false, showDueDate: false, showPasscodeInput: false, signPointsBalance: 0, signingOrderAssigned: false, signingType: $author$project$Type$FillTemplate$NoSigningOrder, stage: $author$project$Type$FillTemplate$Recipients, template: templateData, toolTipActiveHover: $author$project$Type$FillTemplate$Closed, walletError: $elm$core$Maybe$Nothing})),
							A3($author$project$Data$PDF$FillTemplate$load, model.apiEndPoint.templateFile, user.jwt, templateData));
					} else {
						var error = templateResult.a;
						return _Utils_Tuple2(
							updateCurrentModel(
								$author$project$Type$FillTemplate$LoadingDecodeError(error)),
							$elm$core$Platform$Cmd$none);
					}
				} else {
					return _Utils_Tuple2(
						updateCurrentModel($author$project$Type$FillTemplate$LoadingSignatureError),
						$elm$core$Platform$Cmd$none);
				}
		}
	});
var $author$project$Type$FillTemplate$Error = function (a) {
	return {$: 'Error', a: a};
};
var $author$project$Type$FillTemplate$IssueAnonymousResult = function (a) {
	return {$: 'IssueAnonymousResult', a: a};
};
var $author$project$Type$FillTemplate$NoAuth = function (a) {
	return {$: 'NoAuth', a: a};
};
var $author$project$Type$FillTemplate$Submitting = {$: 'Submitting'};
var $author$project$Type$FillTemplate$Succeed = function (a) {
	return {$: 'Succeed', a: a};
};
var $author$project$Model$FillTemplate$updateNoAuthModel = F3(
	function (msg, fillTemplateModel, model) {
		var updateModel = function (m) {
			return _Utils_update(
				model,
				{
					fillTemplateModel: $author$project$Type$FillTemplate$NoAuthLoaded(m)
				});
		};
		switch (msg.$) {
			case 'OnEmailInput':
				var value = msg.a;
				return _Utils_Tuple2(
					updateModel(
						_Utils_update(
							fillTemplateModel,
							{
								email: $elm$core$Maybe$Just(value)
							})),
					$elm$core$Platform$Cmd$none);
			case 'OnEmailBlur':
				var value = msg.a;
				return _Utils_Tuple2(
					updateModel(
						_Utils_update(
							fillTemplateModel,
							{
								emailError: $author$project$Data$Validator$validateEmail(value)
							})),
					$elm$core$Platform$Cmd$none);
			case 'OnSubmit':
				var updatedModel = _Utils_update(
					fillTemplateModel,
					{
						emailError: $author$project$Data$Validator$validateEmail(
							A2($elm$core$Maybe$withDefault, '', fillTemplateModel.email))
					});
				if (_Utils_eq(updatedModel.emailError, $elm$core$Maybe$Nothing)) {
					var withDefaultField = function (value) {
						return A2($elm$core$Maybe$withDefault, '', value);
					};
					var _v1 = updatedModel;
					var email = _v1.email;
					var slug = _v1.slug;
					return _Utils_Tuple2(
						updateModel(
							_Utils_update(
								updatedModel,
								{formStatus: $author$project$Type$FillTemplate$Submitting})),
						A2(
							$elm$core$Task$attempt,
							A2(
								$elm$core$Basics$composeL,
								A2($elm$core$Basics$composeL, $author$project$Types$OnFillTemplate, $author$project$Type$FillTemplate$NoAuth),
								$author$project$Type$FillTemplate$IssueAnonymousResult),
							A2(
								$author$project$Data$Api$PDF$IssueAnonymous$call,
								model.apiEndPoint.issueAnonymousTemplateToken,
								{
									email: withDefaultField(email),
									slug: slug
								})));
				} else {
					return _Utils_Tuple2(
						updateModel(updatedModel),
						$elm$core$Platform$Cmd$none);
				}
			case 'OnCancel':
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 'IssueAnonymousResult':
				var payload = msg.a;
				if (payload.$ === 'Ok') {
					var value = payload.a;
					return _Utils_Tuple2(
						updateModel(
							_Utils_update(
								fillTemplateModel,
								{
									formStatus: $author$project$Type$FillTemplate$Succeed(value.docId)
								})),
						$elm$core$Platform$Cmd$none);
				} else {
					var err = payload.a;
					return _Utils_Tuple2(
						updateModel(
							_Utils_update(
								fillTemplateModel,
								{
									formStatus: $author$project$Type$FillTemplate$Error(
										A2($author$project$Data$Api$errorToString, $author$project$Data$Api$PDF$IssueAnonymous$errorToString, err))
								})),
						$elm$core$Platform$Cmd$none);
				}
			case 'OnNavigateToLogin':
				return _Utils_Tuple2(
					model,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$browser$Browser$Navigation$pushUrl, model.navKey, $author$project$Data$Route$routeUrl.login),
								A2(
								$elm$core$Task$perform,
								$author$project$Types$OnLogin,
								$elm$core$Task$succeed(
									$author$project$Type$Login$AddRedirectPath($author$project$Data$Route$routeUrl.viewTemplate + ('/' + fillTemplateModel.slug))))
							])));
			default:
				var docId = msg.a;
				return _Utils_Tuple2(
					model,
					A2(
						$elm$browser$Browser$Navigation$pushUrl,
						model.navKey,
						_Utils_ap($author$project$Data$Route$routeUrl.viewDocument, docId)));
		}
	});
var $author$project$Model$FillTemplate$update = F4(
	function (initAnonymousModel, msg, sessionModel, model) {
		var loadSignaturePad = A2(
			$elm$core$Task$perform,
			$author$project$Types$OnSignature,
			$elm$core$Task$succeed($author$project$Type$Signature$OnViewRendered));
		switch (msg.$) {
			case 'GetTokenOrSlug':
				var slugOrToken = msg.a;
				if (A2($elm$core$String$contains, '.', slugOrToken)) {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{fillTemplateModel: $author$project$Type$FillTemplate$Loading}),
						A2(
							$elm$core$Task$attempt,
							A2($elm$core$Basics$composeL, $author$project$Types$OnFillTemplate, $author$project$Type$FillTemplate$ValidateTokenResult),
							A2($author$project$Data$Api$PDF$ValidateTemplateToken$call, slugOrToken, model.apiEndPoint.validateTemplateToken)));
				} else {
					switch (sessionModel.$) {
						case 'Anonymous':
							return _Utils_Tuple2(
								model,
								$elm$core$Platform$Cmd$batch(
									_List_fromArray(
										[
											A2(
											$elm$core$Task$perform,
											$author$project$Types$OnFillTemplate,
											$elm$core$Task$succeed(
												$author$project$Type$FillTemplate$OnAuth(
													$author$project$Type$FillTemplate$LoadTemplate(slugOrToken)))),
											loadSignaturePad
										])));
						case 'Auth':
							return _Utils_Tuple2(
								model,
								$elm$core$Platform$Cmd$batch(
									_List_fromArray(
										[
											A2(
											$elm$core$Task$perform,
											$author$project$Types$OnFillTemplate,
											$elm$core$Task$succeed(
												$author$project$Type$FillTemplate$OnAuth(
													$author$project$Type$FillTemplate$LoadTemplate(slugOrToken)))),
											loadSignaturePad
										])));
						case 'NoAuth':
							return _Utils_Tuple2(
								model,
								A2(
									$elm$core$Task$attempt,
									A2(
										$elm$core$Basics$composeL,
										$author$project$Types$OnFillTemplate,
										$author$project$Type$FillTemplate$OnCheckSingleRoleFillTemplateResult(slugOrToken)),
									A2(
										$author$project$Data$Api$PDF$CheckSingleRoleTemplate$call,
										model.apiEndPoint.checkIsSingleRoleTemplate,
										{slug: slugOrToken})));
						default:
							return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					}
				}
			case 'OnCheckSingleRoleFillTemplateResult':
				var slugOrToken = msg.a;
				var payload = msg.b;
				if (payload.$ === 'Ok') {
					var result = payload.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								fillTemplateModel: $author$project$Type$FillTemplate$NoAuthLoaded(
									A2($author$project$Model$FillTemplate$initNoAuth, slugOrToken, result.isSingleRole))
							}),
						result.isSingleRole ? $elm$core$Platform$Cmd$none : $elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($elm$browser$Browser$Navigation$pushUrl, model.navKey, $author$project$Data$Route$routeUrl.login),
									A2(
									$elm$core$Task$perform,
									$author$project$Types$OnLogin,
									$elm$core$Task$succeed(
										$author$project$Type$Login$AddRedirectPath($author$project$Data$Route$routeUrl.fillTemplate + ('/' + slugOrToken))))
								])));
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 'ValidateTokenResult':
				var payload = msg.a;
				if (payload.$ === 'Ok') {
					var result = payload.a;
					var initializeAnonymousSession = function () {
						var _v5 = initAnonymousModel(result.user);
						var anonymousModel = _v5.a;
						var anonymousCmd = _v5.b;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									fillTemplateModel: $author$project$Type$FillTemplate$NotLoaded,
									sessionModel: $author$project$Types$Anonymous(anonymousModel)
								}),
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										anonymousCmd,
										A2(
										$elm$core$Task$perform,
										$author$project$Types$OnFillTemplate,
										$elm$core$Task$succeed(
											$author$project$Type$FillTemplate$OnAuth(
												$author$project$Type$FillTemplate$LoadTemplate(result.slug)))),
										loadSignaturePad
									])));
					}();
					switch (sessionModel.$) {
						case 'Auth':
							var authModel = sessionModel.a;
							return (!_Utils_eq(authModel.user.id, result.user.id)) ? _Utils_Tuple2(
								_Utils_update(
									model,
									{
										sessionModel: $author$project$Types$Auth(
											_Utils_update(
												authModel,
												{
													fillTemplateModel: $author$project$Type$FillTemplate$VerificationError($author$project$Type$FillTemplate$NotTokenUser)
												}))
									}),
								$elm$core$Platform$Cmd$none) : _Utils_Tuple2(
								model,
								$elm$core$Platform$Cmd$batch(
									_List_fromArray(
										[
											A2(
											$elm$core$Task$perform,
											$author$project$Types$OnFillTemplate,
											$elm$core$Task$succeed(
												$author$project$Type$FillTemplate$OnAuth(
													$author$project$Type$FillTemplate$LoadTemplate(result.slug)))),
											loadSignaturePad
										])));
						case 'Anonymous':
							return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
						case 'NoAuth':
							return initializeAnonymousSession;
						default:
							return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					}
				} else {
					switch (sessionModel.$) {
						case 'Auth':
							var authModel = sessionModel.a;
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{
										sessionModel: $author$project$Types$Auth(
											_Utils_update(
												authModel,
												{
													fillTemplateModel: $author$project$Type$FillTemplate$VerificationError($author$project$Type$FillTemplate$InvalidToken)
												}))
									}),
								$elm$core$Platform$Cmd$none);
						case 'Anonymous':
							var anonymousModel = sessionModel.a;
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{
										sessionModel: $author$project$Types$Anonymous(
											_Utils_update(
												anonymousModel,
												{
													fillTemplateModel: $author$project$Type$FillTemplate$VerificationError($author$project$Type$FillTemplate$InvalidToken)
												}))
									}),
								$elm$core$Platform$Cmd$none);
						case 'NoAuth':
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{
										fillTemplateModel: $author$project$Type$FillTemplate$VerificationError($author$project$Type$FillTemplate$InvalidToken)
									}),
								$elm$core$Platform$Cmd$none);
						default:
							return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					}
				}
			case 'OnNavigateToHomepage':
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{fillTemplateModel: $author$project$Type$FillTemplate$NotLoaded}),
					A2($elm$browser$Browser$Navigation$pushUrl, model.navKey, '/'));
			case 'NoAuth':
				var noAuthMsg = msg.a;
				var _v7 = model.fillTemplateModel;
				if (_v7.$ === 'NoAuthLoaded') {
					var noAuthModel = _v7.a;
					return A3($author$project$Model$FillTemplate$updateNoAuthModel, noAuthMsg, noAuthModel, model);
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 'OnAuth':
				var authMsg = msg.a;
				switch (sessionModel.$) {
					case 'Auth':
						var authModel = sessionModel.a;
						return A3($author$project$Model$FillTemplate$updateAuthModel, authMsg, authModel, model);
					case 'Anonymous':
						var anonymousModel = sessionModel.a;
						return A3($author$project$Model$FillTemplate$updateAnonymousModel, authMsg, anonymousModel, model);
					case 'NoAuth':
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					default:
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 'GetTokenOrSlugViewTemplateInfo':
				var slugOrToken = msg.a;
				if (A2($elm$core$String$contains, '.', slugOrToken)) {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{fillTemplateModel: $author$project$Type$FillTemplate$Loading}),
						A2(
							$elm$core$Task$attempt,
							A2($elm$core$Basics$composeL, $author$project$Types$OnFillTemplate, $author$project$Type$FillTemplate$ValidateTokenResultViewTemplateInfo),
							A2($author$project$Data$Api$PDF$ValidateTemplateToken$call, slugOrToken, model.apiEndPoint.validateTemplateToken)));
				} else {
					switch (sessionModel.$) {
						case 'Anonymous':
							return _Utils_Tuple2(
								model,
								$elm$core$Platform$Cmd$batch(
									_List_fromArray(
										[
											A2(
											$elm$core$Task$perform,
											$author$project$Types$OnFillTemplate,
											$elm$core$Task$succeed(
												$author$project$Type$FillTemplate$OnAuth(
													$author$project$Type$FillTemplate$ViewTemplateInfo(slugOrToken)))),
											loadSignaturePad
										])));
						case 'Auth':
							return _Utils_Tuple2(
								model,
								$elm$core$Platform$Cmd$batch(
									_List_fromArray(
										[
											A2(
											$elm$core$Task$perform,
											$author$project$Types$OnFillTemplate,
											$elm$core$Task$succeed(
												$author$project$Type$FillTemplate$OnAuth(
													$author$project$Type$FillTemplate$ViewTemplateInfo(slugOrToken)))),
											loadSignaturePad
										])));
						case 'NoAuth':
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{
										fillTemplateModel: $author$project$Type$FillTemplate$NoAuthLoaded(
											A2($author$project$Model$FillTemplate$initNoAuth, slugOrToken, false))
									}),
								$elm$core$Platform$Cmd$batch(
									_List_fromArray(
										[
											A2($elm$browser$Browser$Navigation$pushUrl, model.navKey, $author$project$Data$Route$routeUrl.login),
											A2(
											$elm$core$Task$perform,
											$author$project$Types$OnLogin,
											$elm$core$Task$succeed(
												$author$project$Type$Login$AddRedirectPath($author$project$Data$Route$routeUrl.viewTemplate + ('/' + slugOrToken))))
										])));
						default:
							return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					}
				}
			default:
				var payload = msg.a;
				if (payload.$ === 'Ok') {
					var result = payload.a;
					var initializeAnonymousSession = function () {
						var _v12 = initAnonymousModel(result.user);
						var anonymousModel = _v12.a;
						var anonymousCmd = _v12.b;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									fillTemplateModel: $author$project$Type$FillTemplate$NotLoaded,
									sessionModel: $author$project$Types$Anonymous(anonymousModel)
								}),
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										anonymousCmd,
										A2(
										$elm$core$Task$perform,
										$author$project$Types$OnFillTemplate,
										$elm$core$Task$succeed(
											$author$project$Type$FillTemplate$OnAuth(
												$author$project$Type$FillTemplate$ViewTemplateInfo(result.slug)))),
										loadSignaturePad
									])));
					}();
					switch (sessionModel.$) {
						case 'Auth':
							var authModel = sessionModel.a;
							return (!_Utils_eq(authModel.user.id, result.user.id)) ? _Utils_Tuple2(
								_Utils_update(
									model,
									{
										sessionModel: $author$project$Types$Auth(
											_Utils_update(
												authModel,
												{
													fillTemplateModel: $author$project$Type$FillTemplate$VerificationError($author$project$Type$FillTemplate$NotTokenUser)
												}))
									}),
								$elm$core$Platform$Cmd$none) : _Utils_Tuple2(
								model,
								$elm$core$Platform$Cmd$batch(
									_List_fromArray(
										[
											A2(
											$elm$core$Task$perform,
											$author$project$Types$OnFillTemplate,
											$elm$core$Task$succeed(
												$author$project$Type$FillTemplate$OnAuth(
													$author$project$Type$FillTemplate$ViewTemplateInfo(result.slug)))),
											loadSignaturePad
										])));
						case 'Anonymous':
							return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
						case 'NoAuth':
							return initializeAnonymousSession;
						default:
							return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					}
				} else {
					switch (sessionModel.$) {
						case 'Auth':
							var authModel = sessionModel.a;
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{
										sessionModel: $author$project$Types$Auth(
											_Utils_update(
												authModel,
												{
													fillTemplateModel: $author$project$Type$FillTemplate$VerificationError($author$project$Type$FillTemplate$InvalidToken)
												}))
									}),
								$elm$core$Platform$Cmd$none);
						case 'Anonymous':
							var anonymousModel = sessionModel.a;
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{
										sessionModel: $author$project$Types$Anonymous(
											_Utils_update(
												anonymousModel,
												{
													fillTemplateModel: $author$project$Type$FillTemplate$VerificationError($author$project$Type$FillTemplate$InvalidToken)
												}))
									}),
								$elm$core$Platform$Cmd$none);
						case 'NoAuth':
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{
										fillTemplateModel: $author$project$Type$FillTemplate$VerificationError($author$project$Type$FillTemplate$InvalidToken)
									}),
								$elm$core$Platform$Cmd$none);
						default:
							return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					}
				}
		}
	});
var $author$project$Type$LanguageChange$OnLanguageMenuItemClick = function (a) {
	return {$: 'OnLanguageMenuItemClick', a: a};
};
var $author$project$Types$OnMenu = function (a) {
	return {$: 'OnMenu', a: a};
};
var $author$project$View$Menu$convertLanguageToString = function (language) {
	if (language.$ === 'English') {
		return 'English';
	} else {
		return 'Dutch';
	}
};
var $author$project$Data$LanguageSwitcher$LanguageData = function (location) {
	return {location: location};
};
var $author$project$Data$LanguageSwitcher$LanguageDataLocation = function (login) {
	return function (resetPasswordPage) {
		return function (signupPage) {
			return function (personalRegisterPage) {
				return function (businessRegister) {
					return function (updateUploadDocErrors) {
						return function (menuItem) {
							return function (dashboard) {
								return function (uploadDocument) {
									return function (verificationPage) {
										return function (pointsManagement) {
											return function (transactionDetailsPage) {
												return function (viewDocumentPage) {
													return function (listDocumentsPage) {
														return function (viewNotarisedInformation) {
															return function (addressBookPage) {
																return function (accountSettingsPage) {
																	return function (templateDashboard) {
																		return function (fillTemplatePage) {
																			return function (uploadTemplatePage) {
																				return function (createTemplatePage) {
																					return function (myOrganisationPage) {
																						return function (viewTemplatePage) {
																							return {accountSettingsPage: accountSettingsPage, addressBookPage: addressBookPage, businessRegister: businessRegister, createTemplatePage: createTemplatePage, dashboard: dashboard, fillTemplatePage: fillTemplatePage, listDocumentsPage: listDocumentsPage, login: login, menuItem: menuItem, myOrganisationPage: myOrganisationPage, personalRegisterPage: personalRegisterPage, pointsManagement: pointsManagement, resetPasswordPage: resetPasswordPage, signupPage: signupPage, templateDashboard: templateDashboard, transactionDetailsPage: transactionDetailsPage, updateUploadDocErrors: updateUploadDocErrors, uploadDocument: uploadDocument, uploadTemplatePage: uploadTemplatePage, verificationPage: verificationPage, viewDocumentPage: viewDocumentPage, viewNotarisedInformation: viewNotarisedInformation, viewTemplatePage: viewTemplatePage};
																						};
																					};
																				};
																			};
																		};
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Data$LanguageSwitcher$LanguageDataAccountSettingsPage = function (myAccount) {
	return function (accountSettings) {
		return function (changePicture) {
			return function (firstName) {
				return function (lastName) {
					return function (phoneNumber) {
						return function (emailAddress) {
							return function (nationality) {
								return function (address) {
									return function (dateOfBirth) {
										return function (saveChanges) {
											return function (referralCode) {
												return function (personalAccount) {
													return function (businessAccount) {
														return function (documentNotarisationNetwork) {
															return function (currentChosenNetwork) {
																return function (notariseByDefault) {
																	return function (notariseByDefaultTooltipText) {
																		return function (paymentMethod) {
																			return function (currentPaymentMethod) {
																				return function (signatures) {
																					return function (myPersonalStamps) {
																						return function (stampsTooltipText) {
																							return function (changePassword) {
																								return function (currentPassword) {
																									return function (newPassword) {
																										return function (confirmPassword) {
																											return function (apiKeysHeader) {
																												return function (personalApiKey) {
																													return function (addABusinessPlan) {
																														return function (month) {
																															return function (trialDays) {
																																return function (cancelAnytime) {
																																	return function (signSecurely) {
																																		return function (sendUnlimtedDocs) {
																																			return function (sendPDFforms) {
																																				return function (addOrganisationUser) {
																																					return function (businessPlan) {
																																						return {accountSettings: accountSettings, addABusinessPlan: addABusinessPlan, addOrganisationUser: addOrganisationUser, address: address, apiKeysHeader: apiKeysHeader, businessAccount: businessAccount, businessPlan: businessPlan, cancelAnytime: cancelAnytime, changePassword: changePassword, changePicture: changePicture, confirmPassword: confirmPassword, currentChosenNetwork: currentChosenNetwork, currentPassword: currentPassword, currentPaymentMethod: currentPaymentMethod, dateOfBirth: dateOfBirth, documentNotarisationNetwork: documentNotarisationNetwork, emailAddress: emailAddress, firstName: firstName, lastName: lastName, month: month, myAccount: myAccount, myPersonalStamps: myPersonalStamps, nationality: nationality, newPassword: newPassword, notariseByDefault: notariseByDefault, notariseByDefaultTooltipText: notariseByDefaultTooltipText, paymentMethod: paymentMethod, personalAccount: personalAccount, personalApiKey: personalApiKey, phoneNumber: phoneNumber, referralCode: referralCode, saveChanges: saveChanges, sendPDFforms: sendPDFforms, sendUnlimtedDocs: sendUnlimtedDocs, signSecurely: signSecurely, signatures: signatures, stampsTooltipText: stampsTooltipText, trialDays: trialDays};
																																					};
																																				};
																																			};
																																		};
																																	};
																																};
																															};
																														};
																													};
																												};
																											};
																										};
																									};
																								};
																							};
																						};
																					};
																				};
																			};
																		};
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Data$LanguageSwitcher$decodeLanguageDataAccountSettingsPage = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'businessPlan',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'addOrganisationUser',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'sendPDFforms',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'sendUnlimtedDocs',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'signSecurely',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'cancelAnytime',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'trialDays',
							$elm$json$Json$Decode$string,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'month',
								$elm$json$Json$Decode$string,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'addABusinessPlan',
									$elm$json$Json$Decode$string,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'personalApiKey',
										$elm$json$Json$Decode$string,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'apiKeysHeader',
											$elm$json$Json$Decode$string,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'confirmPassword',
												$elm$json$Json$Decode$string,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'newPassword',
													$elm$json$Json$Decode$string,
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'currentPassword',
														$elm$json$Json$Decode$string,
														A3(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
															'changePassword',
															$elm$json$Json$Decode$string,
															A3(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																'stampsTooltipText',
																$elm$json$Json$Decode$string,
																A3(
																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																	'myPersonalStamps',
																	$elm$json$Json$Decode$string,
																	A3(
																		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																		'signatures',
																		$elm$json$Json$Decode$string,
																		A3(
																			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																			'currentPaymentMethod',
																			$elm$json$Json$Decode$string,
																			A3(
																				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																				'paymentMethod',
																				$elm$json$Json$Decode$string,
																				A3(
																					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																					'notariseByDefaultTooltipText',
																					$elm$json$Json$Decode$string,
																					A3(
																						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																						'notariseByDefault',
																						$elm$json$Json$Decode$string,
																						A3(
																							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																							'currentChosenNetwork',
																							$elm$json$Json$Decode$string,
																							A3(
																								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																								'documentNotarisationNetwork',
																								$elm$json$Json$Decode$string,
																								A3(
																									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																									'businessAccount',
																									$elm$json$Json$Decode$string,
																									A3(
																										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																										'personalAccount',
																										$elm$json$Json$Decode$string,
																										A3(
																											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																											'referralCode',
																											$elm$json$Json$Decode$string,
																											A3(
																												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																												'saveChanges',
																												$elm$json$Json$Decode$string,
																												A3(
																													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																													'dateOfBirth',
																													$elm$json$Json$Decode$string,
																													A3(
																														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																														'address',
																														$elm$json$Json$Decode$string,
																														A3(
																															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																															'nationality',
																															$elm$json$Json$Decode$string,
																															A3(
																																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																'emailAddress',
																																$elm$json$Json$Decode$string,
																																A3(
																																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																	'phoneNumber',
																																	$elm$json$Json$Decode$string,
																																	A3(
																																		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																		'lastName',
																																		$elm$json$Json$Decode$string,
																																		A3(
																																			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																			'firstName',
																																			$elm$json$Json$Decode$string,
																																			A3(
																																				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																				'changePicture',
																																				$elm$json$Json$Decode$string,
																																				A3(
																																					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																					'accountSettings',
																																					$elm$json$Json$Decode$string,
																																					A3(
																																						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																						'myAccount',
																																						$elm$json$Json$Decode$string,
																																						$elm$json$Json$Decode$succeed($author$project$Data$LanguageSwitcher$LanguageDataAccountSettingsPage)))))))))))))))))))))))))))))))))))))));
var $author$project$Data$LanguageSwitcher$LanguageDataAddressBookPage = function (addressBook) {
	return function (pendingRequest) {
		return function (allContacts) {
			return function (addFriend) {
				return function (addNewContact) {
					return function (contactEmailFieldLabel) {
						return function (sendRequestBtnText) {
							return function (cancelBtn) {
								return function (deleteContact) {
									return function (deleteContactConfirmation) {
										return function (rowsPerPage) {
											return function (saveAlias) {
												return {addFriend: addFriend, addNewContact: addNewContact, addressBook: addressBook, allContacts: allContacts, cancelBtn: cancelBtn, contactEmailFieldLabel: contactEmailFieldLabel, deleteContact: deleteContact, deleteContactConfirmation: deleteContactConfirmation, pendingRequest: pendingRequest, rowsPerPage: rowsPerPage, saveAlias: saveAlias, sendRequestBtnText: sendRequestBtnText};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Data$LanguageSwitcher$decodeLanguageDataAddressBookPage = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'saveAlias',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'rowsPerPage',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'deleteContactConfirmation',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'deleteContact',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'cancelBtn',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'sendRequestBtnText',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'contactEmailFieldLabel',
							$elm$json$Json$Decode$string,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'addNewContact',
								$elm$json$Json$Decode$string,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'addFriend',
									$elm$json$Json$Decode$string,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'allContacts',
										$elm$json$Json$Decode$string,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'pendingRequest',
											$elm$json$Json$Decode$string,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'addressBook',
												$elm$json$Json$Decode$string,
												$elm$json$Json$Decode$succeed($author$project$Data$LanguageSwitcher$LanguageDataAddressBookPage)))))))))))));
var $author$project$Data$LanguageSwitcher$LanguageDataBusinessRegister = function (subdomain) {
	return function (companyName) {
		return function (firstName) {
			return function (lastName) {
				return function (emailAddress) {
					return function (password) {
						return function (confirmPassword) {
							return function (referralCode) {
								return function (agreeToTerms) {
									return function (signUp) {
										return function (returnToLogin) {
											return function (passwordRequirements) {
												return function (enhance) {
													return function (customerExperience) {
														return function (closeDeals) {
															return function (anytimeAnyehere) {
																return function (modernise) {
																	return function (agreementProcess) {
																		return function (effcientSecureWorkflow) {
																			return function (suiteOfFeatures) {
																				return function (customDomainText) {
																					return function (organisationManagement) {
																						return function (userPermission) {
																							return function (documentWorkflow) {
																								return function (signingRequest) {
																									return function (organisationRepo) {
																										return function (granularPermission) {
																											return {agreeToTerms: agreeToTerms, agreementProcess: agreementProcess, anytimeAnyehere: anytimeAnyehere, closeDeals: closeDeals, companyName: companyName, confirmPassword: confirmPassword, customDomainText: customDomainText, customerExperience: customerExperience, documentWorkflow: documentWorkflow, effcientSecureWorkflow: effcientSecureWorkflow, emailAddress: emailAddress, enhance: enhance, firstName: firstName, granularPermission: granularPermission, lastName: lastName, modernise: modernise, organisationManagement: organisationManagement, organisationRepo: organisationRepo, password: password, passwordRequirements: passwordRequirements, referralCode: referralCode, returnToLogin: returnToLogin, signUp: signUp, signingRequest: signingRequest, subdomain: subdomain, suiteOfFeatures: suiteOfFeatures, userPermission: userPermission};
																										};
																									};
																								};
																							};
																						};
																					};
																				};
																			};
																		};
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Data$LanguageSwitcher$decodeLanguageDataBusinessRegister = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'granularPermission',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'organisationRepo',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'signingRequest',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'documentWorkflow',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'userPermission',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'organisationManagement',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'customDomainText',
							$elm$json$Json$Decode$string,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'suiteOfFeatures',
								$elm$json$Json$Decode$string,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'effcientSecureWorkflow',
									$elm$json$Json$Decode$string,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'agreementProcess',
										$elm$json$Json$Decode$string,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'modernise',
											$elm$json$Json$Decode$string,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'anytimeAnyehere',
												$elm$json$Json$Decode$string,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'closeDeals',
													$elm$json$Json$Decode$string,
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'customerExperience',
														$elm$json$Json$Decode$string,
														A3(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
															'enhance',
															$elm$json$Json$Decode$string,
															A3(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																'passwordRequirements',
																$elm$json$Json$Decode$string,
																A3(
																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																	'returnToLogin',
																	$elm$json$Json$Decode$string,
																	A3(
																		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																		'signUp',
																		$elm$json$Json$Decode$string,
																		A3(
																			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																			'agreeToTerms',
																			$elm$json$Json$Decode$string,
																			A3(
																				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																				'referralCode',
																				$elm$json$Json$Decode$string,
																				A3(
																					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																					'confirmPassword',
																					$elm$json$Json$Decode$string,
																					A3(
																						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																						'password',
																						$elm$json$Json$Decode$string,
																						A3(
																							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																							'emailAddress',
																							$elm$json$Json$Decode$string,
																							A3(
																								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																								'lastName',
																								$elm$json$Json$Decode$string,
																								A3(
																									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																									'firstName',
																									$elm$json$Json$Decode$string,
																									A3(
																										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																										'companyName',
																										$elm$json$Json$Decode$string,
																										A3(
																											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																											'subdomain',
																											$elm$json$Json$Decode$string,
																											$elm$json$Json$Decode$succeed($author$project$Data$LanguageSwitcher$LanguageDataBusinessRegister))))))))))))))))))))))))))));
var $author$project$Data$LanguageSwitcher$LanguageDataCreateTemplatePage = function (templateTitle) {
	return function (title) {
		return function (sharingUrlText) {
			return function (nextStep) {
				return function (addRole) {
					return function (addNewRole) {
						return function (addFields) {
							return function (assignRecipientToRole) {
								return function (assignRecipientToRoleTooltipText) {
									return function (assignRecipientToViewer) {
										return function (assignRecipientToViewerTooltipText) {
											return function (newRole) {
												return function (addToDocument) {
													return function (signatureField) {
														return function (stampField) {
															return function (dateSigned) {
																return function (editableText) {
																	return function (nameField) {
																		return function (emailField) {
																			return function (checkboxField) {
																				return function (optionalSettings) {
																					return function (signOrder) {
																						return function (submit) {
																							return function (uploadTemplate) {
																								return function (uploadTemplateText) {
																									return function (referToTerms) {
																										return function (createButtonText) {
																											return function (templateUploadSuccess) {
																												return {addFields: addFields, addNewRole: addNewRole, addRole: addRole, addToDocument: addToDocument, assignRecipientToRole: assignRecipientToRole, assignRecipientToRoleTooltipText: assignRecipientToRoleTooltipText, assignRecipientToViewer: assignRecipientToViewer, assignRecipientToViewerTooltipText: assignRecipientToViewerTooltipText, checkboxField: checkboxField, createButtonText: createButtonText, dateSigned: dateSigned, editableText: editableText, emailField: emailField, nameField: nameField, newRole: newRole, nextStep: nextStep, optionalSettings: optionalSettings, referToTerms: referToTerms, sharingUrlText: sharingUrlText, signOrder: signOrder, signatureField: signatureField, stampField: stampField, submit: submit, templateTitle: templateTitle, templateUploadSuccess: templateUploadSuccess, title: title, uploadTemplate: uploadTemplate, uploadTemplateText: uploadTemplateText};
																											};
																										};
																									};
																								};
																							};
																						};
																					};
																				};
																			};
																		};
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Data$LanguageSwitcher$decodeLanguageDataCreateTemplatePage = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'templateUploadSuccess',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'createButtonText',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'referToTerms',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'uploadTemplateText',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'uploadTemplate',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'submit',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'signOrder',
							$elm$json$Json$Decode$string,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'optionalSettings',
								$elm$json$Json$Decode$string,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'checkboxField',
									$elm$json$Json$Decode$string,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'emailField',
										$elm$json$Json$Decode$string,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'nameField',
											$elm$json$Json$Decode$string,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'editableText',
												$elm$json$Json$Decode$string,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'dateSigned',
													$elm$json$Json$Decode$string,
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'stampField',
														$elm$json$Json$Decode$string,
														A3(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
															'signatureField',
															$elm$json$Json$Decode$string,
															A3(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																'addToDocument',
																$elm$json$Json$Decode$string,
																A3(
																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																	'newRole',
																	$elm$json$Json$Decode$string,
																	A3(
																		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																		'assignRecipientToViewerTooltipText',
																		$elm$json$Json$Decode$string,
																		A3(
																			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																			'assignRecipientToViewer',
																			$elm$json$Json$Decode$string,
																			A3(
																				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																				'assignRecipientToRoleTooltipText',
																				$elm$json$Json$Decode$string,
																				A3(
																					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																					'assignRecipientToRole',
																					$elm$json$Json$Decode$string,
																					A3(
																						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																						'addFields',
																						$elm$json$Json$Decode$string,
																						A3(
																							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																							'addNewRole',
																							$elm$json$Json$Decode$string,
																							A3(
																								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																								'addRole',
																								$elm$json$Json$Decode$string,
																								A3(
																									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																									'nextStep',
																									$elm$json$Json$Decode$string,
																									A3(
																										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																										'sharingUrlText',
																										$elm$json$Json$Decode$string,
																										A3(
																											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																											'title',
																											$elm$json$Json$Decode$string,
																											A3(
																												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																												'templateTitle',
																												$elm$json$Json$Decode$string,
																												$elm$json$Json$Decode$succeed($author$project$Data$LanguageSwitcher$LanguageDataCreateTemplatePage)))))))))))))))))))))))))))));
var $author$project$Data$LanguageSwitcher$LanguageDataDashboard = function (uploadDocsTitle) {
	return function (uploadDocsDescription) {
		return function (uploadDocsStep1) {
			return function (uploadDocsStep1Part2) {
				return function (pendingDocuments) {
					return function (sentDocuments) {
						return function (verification) {
							return function (systemRewardsPoints) {
								return function (incomingDocuments) {
									return function (outgoingDocuments) {
										return function (document) {
											return function (sender) {
												return function (recipient) {
													return function (date) {
														return function (viewAll) {
															return function (completedDocuments) {
																return function (template) {
																	return function (submission) {
																		return {completedDocuments: completedDocuments, date: date, document: document, incomingDocuments: incomingDocuments, outgoingDocuments: outgoingDocuments, pendingDocuments: pendingDocuments, recipient: recipient, sender: sender, sentDocuments: sentDocuments, submission: submission, systemRewardsPoints: systemRewardsPoints, template: template, uploadDocsDescription: uploadDocsDescription, uploadDocsStep1: uploadDocsStep1, uploadDocsStep1Part2: uploadDocsStep1Part2, uploadDocsTitle: uploadDocsTitle, verification: verification, viewAll: viewAll};
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Data$LanguageSwitcher$decodeLanguageDataDashboard = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'submission',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'template',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'completedDocuments',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'viewAll',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'date',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'recipient',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'sender',
							$elm$json$Json$Decode$string,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'document',
								$elm$json$Json$Decode$string,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'outgoingDocuments',
									$elm$json$Json$Decode$string,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'incomingDocuments',
										$elm$json$Json$Decode$string,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'systemRewardsPoints',
											$elm$json$Json$Decode$string,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'verification',
												$elm$json$Json$Decode$string,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'sentDocuments',
													$elm$json$Json$Decode$string,
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'pendingDocuments',
														$elm$json$Json$Decode$string,
														A3(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
															'uploadDocsStep1Part2',
															$elm$json$Json$Decode$string,
															A3(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																'uploadDocsStep1',
																$elm$json$Json$Decode$string,
																A3(
																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																	'uploadDocsDescription',
																	$elm$json$Json$Decode$string,
																	A3(
																		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																		'uploadDocsTitle',
																		$elm$json$Json$Decode$string,
																		$elm$json$Json$Decode$succeed($author$project$Data$LanguageSwitcher$LanguageDataDashboard)))))))))))))))))));
var $author$project$Data$LanguageSwitcher$LanguageDataFillTemplatePage = function (step2) {
	return function (owner) {
		return function (sender) {
			return function (next) {
				return function (optionalSettings) {
					return function (signOrder) {
						return function (dueDate) {
							return function (additionalMessage) {
								return function (passcode) {
									return function (passcodeTooltipText) {
										return function (notariseDocument) {
											return function (algorandNetwork) {
												return function (binanceNetwork) {
													return function (notariseTooltipText1) {
														return function (notariseTooltipText2) {
															return function (notariseTooltipText3) {
																return function (sendButtonText) {
																	return function (proceedToSend) {
																		return function (sendTemplateTermsOfUse) {
																			return {additionalMessage: additionalMessage, algorandNetwork: algorandNetwork, binanceNetwork: binanceNetwork, dueDate: dueDate, next: next, notariseDocument: notariseDocument, notariseTooltipText1: notariseTooltipText1, notariseTooltipText2: notariseTooltipText2, notariseTooltipText3: notariseTooltipText3, optionalSettings: optionalSettings, owner: owner, passcode: passcode, passcodeTooltipText: passcodeTooltipText, proceedToSend: proceedToSend, sendButtonText: sendButtonText, sendTemplateTermsOfUse: sendTemplateTermsOfUse, sender: sender, signOrder: signOrder, step2: step2};
																		};
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Data$LanguageSwitcher$decodeLanguageDataFillTemplatePage = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'sendTemplateTermsOfUse',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'proceedToSend',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'sendButtonText',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'notariseTooltipText3',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'notariseTooltipText2',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'notariseTooltipText1',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'binanceNetwork',
							$elm$json$Json$Decode$string,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'algorandNetwork',
								$elm$json$Json$Decode$string,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'notariseDocument',
									$elm$json$Json$Decode$string,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'passcodeTooltipText',
										$elm$json$Json$Decode$string,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'passcode',
											$elm$json$Json$Decode$string,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'additionalMessage',
												$elm$json$Json$Decode$string,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'dueDate',
													$elm$json$Json$Decode$string,
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'signOrder',
														$elm$json$Json$Decode$string,
														A3(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
															'optionalSettings',
															$elm$json$Json$Decode$string,
															A3(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																'next',
																$elm$json$Json$Decode$string,
																A3(
																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																	'sender',
																	$elm$json$Json$Decode$string,
																	A3(
																		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																		'owner',
																		$elm$json$Json$Decode$string,
																		A3(
																			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																			'step2',
																			$elm$json$Json$Decode$string,
																			$elm$json$Json$Decode$succeed($author$project$Data$LanguageSwitcher$LanguageDataFillTemplatePage))))))))))))))))))));
var $author$project$Data$LanguageSwitcher$LanguageDataListDocumentsPage = F7(
	function (sender, signers, viewers, dateCompleted, page, dateSent, searchDocument) {
		return {dateCompleted: dateCompleted, dateSent: dateSent, page: page, searchDocument: searchDocument, sender: sender, signers: signers, viewers: viewers};
	});
var $author$project$Data$LanguageSwitcher$decodeLanguageDataListDocumentsPage = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'searchDocument',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'dateSent',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'page',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'dateCompleted',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'viewers',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'signers',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'sender',
							$elm$json$Json$Decode$string,
							$elm$json$Json$Decode$succeed($author$project$Data$LanguageSwitcher$LanguageDataListDocumentsPage))))))));
var $author$project$Data$LanguageSwitcher$LanguageDataLogin = F7(
	function (signIn, emailAddress, emailError, password, incorrectPassword, accountSignUp, resetPassword) {
		return {accountSignUp: accountSignUp, emailAddress: emailAddress, emailError: emailError, incorrectPassword: incorrectPassword, password: password, resetPassword: resetPassword, signIn: signIn};
	});
var $author$project$Data$LanguageSwitcher$decodeLanguageDataLogin = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'resetPassword',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'accountSignUp',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'incorrectPassword',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'password',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'emailError',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'emailAddress',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'signIn',
							$elm$json$Json$Decode$string,
							$elm$json$Json$Decode$succeed($author$project$Data$LanguageSwitcher$LanguageDataLogin))))))));
var $author$project$Data$LanguageSwitcher$LanguageDataMenuItem = function (newDocuments) {
	return function (newTemplate) {
		return function (dashboard) {
			return function (trustScore) {
				return function (documents) {
					return function (viewNotarisedInformation) {
						return function (addressBook) {
							return function (myAccount) {
								return function (myOrganisation) {
									return function (signNetRewardsPoints) {
										return function (gettingStarted) {
											return function (contactUs) {
												return function (faq) {
													return {addressBook: addressBook, contactUs: contactUs, dashboard: dashboard, documents: documents, faq: faq, gettingStarted: gettingStarted, myAccount: myAccount, myOrganisation: myOrganisation, newDocuments: newDocuments, newTemplate: newTemplate, signNetRewardsPoints: signNetRewardsPoints, trustScore: trustScore, viewNotarisedInformation: viewNotarisedInformation};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Data$LanguageSwitcher$decodeLanguageDataMenuItem = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'faq',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'contactUs',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'gettingStarted',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'signNetRewardsPoints',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'myOrganisation',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'myAccount',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'addressBook',
							$elm$json$Json$Decode$string,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'viewNotarisedInformation',
								$elm$json$Json$Decode$string,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'documents',
									$elm$json$Json$Decode$string,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'trustScore',
										$elm$json$Json$Decode$string,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'dashboard',
											$elm$json$Json$Decode$string,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'newTemplate',
												$elm$json$Json$Decode$string,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'newDocuments',
													$elm$json$Json$Decode$string,
													$elm$json$Json$Decode$succeed($author$project$Data$LanguageSwitcher$LanguageDataMenuItem))))))))))))));
var $author$project$Data$LanguageSwitcher$LanguageDataMyOrganisationPage = function (manageUsers) {
	return function (organisationReferralCode) {
		return function (shareLinkBusinessAccount) {
			return function (shareLinkPersonalAccount) {
				return function (customizeLandingPage) {
					return function (headerLogo) {
						return function (lessThan300KB) {
							return function (headerBackgroundColour) {
								return function (headerBackgroundDescription) {
									return function (bannerLogo) {
										return function (lessThan500KB) {
											return function (bannerBackground) {
												return function (organisationStamps) {
													return function (_delete) {
														return function (businessProfile) {
															return function (companyName) {
																return function (companySlogan) {
																	return function (companyDescription) {
																		return function (update) {
																			return {bannerBackground: bannerBackground, bannerLogo: bannerLogo, businessProfile: businessProfile, companyDescription: companyDescription, companyName: companyName, companySlogan: companySlogan, customizeLandingPage: customizeLandingPage, _delete: _delete, headerBackgroundColour: headerBackgroundColour, headerBackgroundDescription: headerBackgroundDescription, headerLogo: headerLogo, lessThan300KB: lessThan300KB, lessThan500KB: lessThan500KB, manageUsers: manageUsers, organisationReferralCode: organisationReferralCode, organisationStamps: organisationStamps, shareLinkBusinessAccount: shareLinkBusinessAccount, shareLinkPersonalAccount: shareLinkPersonalAccount, update: update};
																		};
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Data$LanguageSwitcher$decodeLanguageDataMyOrganisationPage = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'update',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'companyDescription',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'companySlogan',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'companyName',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'businessProfile',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'delete',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'organisationStamps',
							$elm$json$Json$Decode$string,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'bannerBackground',
								$elm$json$Json$Decode$string,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'lessThan500KB',
									$elm$json$Json$Decode$string,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'bannerLogo',
										$elm$json$Json$Decode$string,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'headerBackgroundDescription',
											$elm$json$Json$Decode$string,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'headerBackgroundColour',
												$elm$json$Json$Decode$string,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'lessThan300KB',
													$elm$json$Json$Decode$string,
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'headerLogo',
														$elm$json$Json$Decode$string,
														A3(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
															'customizeLandingPage',
															$elm$json$Json$Decode$string,
															A3(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																'shareLinkPersonalAccount',
																$elm$json$Json$Decode$string,
																A3(
																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																	'shareLinkBusinessAccount',
																	$elm$json$Json$Decode$string,
																	A3(
																		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																		'organisationReferralCode',
																		$elm$json$Json$Decode$string,
																		A3(
																			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																			'manageUsers',
																			$elm$json$Json$Decode$string,
																			$elm$json$Json$Decode$succeed($author$project$Data$LanguageSwitcher$LanguageDataMyOrganisationPage))))))))))))))))))));
var $author$project$Data$LanguageSwitcher$LanguageDataPersonalRegisterPage = function (createFreeAccount) {
	return function (firstName) {
		return function (lastName) {
			return function (emailAddress) {
				return function (password) {
					return function (confirmPassword) {
						return function (referralCode) {
							return function (agreeToTerms) {
								return function (signUp) {
									return function (returnToLogin) {
										return function (passwordRequirements) {
											return function (activateAccount) {
												return function (thankYouMsg) {
													return function (emailActivateText) {
														return function (emailActivateText2) {
															return function (needHelp) {
																return function (needHelp2) {
																	return function (haveAnAccount) {
																		return function (digitalSigning) {
																			return function (easySafeAndFree) {
																				return function (sendUnlimtedDocs) {
																					return function (supportFormats) {
																						return function (identityVerification) {
																							return function (notariseDocs) {
																								return function (useForBusiness) {
																									return function (suiteOfFeatures) {
																										return function (freeTrialText) {
																											return {activateAccount: activateAccount, agreeToTerms: agreeToTerms, confirmPassword: confirmPassword, createFreeAccount: createFreeAccount, digitalSigning: digitalSigning, easySafeAndFree: easySafeAndFree, emailActivateText: emailActivateText, emailActivateText2: emailActivateText2, emailAddress: emailAddress, firstName: firstName, freeTrialText: freeTrialText, haveAnAccount: haveAnAccount, identityVerification: identityVerification, lastName: lastName, needHelp: needHelp, needHelp2: needHelp2, notariseDocs: notariseDocs, password: password, passwordRequirements: passwordRequirements, referralCode: referralCode, returnToLogin: returnToLogin, sendUnlimtedDocs: sendUnlimtedDocs, signUp: signUp, suiteOfFeatures: suiteOfFeatures, supportFormats: supportFormats, thankYouMsg: thankYouMsg, useForBusiness: useForBusiness};
																										};
																									};
																								};
																							};
																						};
																					};
																				};
																			};
																		};
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Data$LanguageSwitcher$decodeLanguageDataPersonalRegisterPage = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'freeTrialText',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'suiteOfFeatures',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'useForBusiness',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'notariseDocs',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'identityVerification',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'supportFormats',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'sendUnlimtedDocs',
							$elm$json$Json$Decode$string,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'easySafeAndFree',
								$elm$json$Json$Decode$string,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'digitalSigning',
									$elm$json$Json$Decode$string,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'haveAnAccount',
										$elm$json$Json$Decode$string,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'needHelp2',
											$elm$json$Json$Decode$string,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'needHelp',
												$elm$json$Json$Decode$string,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'emailActivateText2',
													$elm$json$Json$Decode$string,
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'emailActivateText',
														$elm$json$Json$Decode$string,
														A3(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
															'thankYouMsg',
															$elm$json$Json$Decode$string,
															A3(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																'activateAccount',
																$elm$json$Json$Decode$string,
																A3(
																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																	'passwordRequirements',
																	$elm$json$Json$Decode$string,
																	A3(
																		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																		'returnToLogin',
																		$elm$json$Json$Decode$string,
																		A3(
																			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																			'signUp',
																			$elm$json$Json$Decode$string,
																			A3(
																				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																				'agreeToTerms',
																				$elm$json$Json$Decode$string,
																				A3(
																					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																					'referralCode',
																					$elm$json$Json$Decode$string,
																					A3(
																						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																						'confirmPassword',
																						$elm$json$Json$Decode$string,
																						A3(
																							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																							'password',
																							$elm$json$Json$Decode$string,
																							A3(
																								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																								'emailAddress',
																								$elm$json$Json$Decode$string,
																								A3(
																									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																									'lastName',
																									$elm$json$Json$Decode$string,
																									A3(
																										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																										'firstName',
																										$elm$json$Json$Decode$string,
																										A3(
																											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																											'createFreeAccount',
																											$elm$json$Json$Decode$string,
																											$elm$json$Json$Decode$succeed($author$project$Data$LanguageSwitcher$LanguageDataPersonalRegisterPage))))))))))))))))))))))))))));
var $author$project$Data$LanguageSwitcher$LanguageDataPointsManagement = function (headerText) {
	return function (headerDescription) {
		return function (systemBalance) {
			return function (systemBalanceTooltipText) {
				return function (externalWallet) {
					return function (externalWalletTooltipText) {
						return function (togglePaymentNotarisationMethods) {
							return function (currentNetwork) {
								return function (currentPaymentMethod) {
									return function (redeemForServices) {
										return function (redeemServicesTooltipText) {
											return function (viewAllRewards) {
												return function (addOrganisationUser) {
													return function (safepalWallet) {
														return function (amazonGiftCard) {
															return function (sendPoints) {
																return function (recipientEmail) {
																	return function (amount) {
																		return function (remarks) {
																			return function (sendButton) {
																				return function (transactionHistory) {
																					return function (from) {
																						return function (to) {
																							return function (time) {
																								return function (status) {
																									return function (completedStatus) {
																										return function (pendingStatus) {
																											return function (inText) {
																												return function (out) {
																													return function (viewAllButton) {
																														return function (pointsManagement) {
																															return function (findOutMore) {
																																return function (available) {
																																	return function (transactionHistoryHeader) {
																																		return {addOrganisationUser: addOrganisationUser, amazonGiftCard: amazonGiftCard, amount: amount, available: available, completedStatus: completedStatus, currentNetwork: currentNetwork, currentPaymentMethod: currentPaymentMethod, externalWallet: externalWallet, externalWalletTooltipText: externalWalletTooltipText, findOutMore: findOutMore, from: from, headerDescription: headerDescription, headerText: headerText, inText: inText, out: out, pendingStatus: pendingStatus, pointsManagement: pointsManagement, recipientEmail: recipientEmail, redeemForServices: redeemForServices, redeemServicesTooltipText: redeemServicesTooltipText, remarks: remarks, safepalWallet: safepalWallet, sendButton: sendButton, sendPoints: sendPoints, status: status, systemBalance: systemBalance, systemBalanceTooltipText: systemBalanceTooltipText, time: time, to: to, togglePaymentNotarisationMethods: togglePaymentNotarisationMethods, transactionHistory: transactionHistory, transactionHistoryHeader: transactionHistoryHeader, viewAllButton: viewAllButton, viewAllRewards: viewAllRewards};
																																	};
																																};
																															};
																														};
																													};
																												};
																											};
																										};
																									};
																								};
																							};
																						};
																					};
																				};
																			};
																		};
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Data$LanguageSwitcher$decodeLanguageDataPointsManagement = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'transactionHistoryHeader',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'available',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'findOutMore',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'pointsManagement',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'viewAllButton',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'out',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'inText',
							$elm$json$Json$Decode$string,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'pendingStatus',
								$elm$json$Json$Decode$string,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'completedStatus',
									$elm$json$Json$Decode$string,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'status',
										$elm$json$Json$Decode$string,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'time',
											$elm$json$Json$Decode$string,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'to',
												$elm$json$Json$Decode$string,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'from',
													$elm$json$Json$Decode$string,
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'transactionHistory',
														$elm$json$Json$Decode$string,
														A3(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
															'sendButton',
															$elm$json$Json$Decode$string,
															A3(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																'remarks',
																$elm$json$Json$Decode$string,
																A3(
																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																	'amount',
																	$elm$json$Json$Decode$string,
																	A3(
																		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																		'recipientEmail',
																		$elm$json$Json$Decode$string,
																		A3(
																			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																			'sendPoints',
																			$elm$json$Json$Decode$string,
																			A3(
																				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																				'amazonGiftCard',
																				$elm$json$Json$Decode$string,
																				A3(
																					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																					'safepalWallet',
																					$elm$json$Json$Decode$string,
																					A3(
																						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																						'addOrganisationUser',
																						$elm$json$Json$Decode$string,
																						A3(
																							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																							'viewAllRewards',
																							$elm$json$Json$Decode$string,
																							A3(
																								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																								'redeemServicesTooltipText',
																								$elm$json$Json$Decode$string,
																								A3(
																									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																									'redeemForServices',
																									$elm$json$Json$Decode$string,
																									A3(
																										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																										'currentPaymentMethod',
																										$elm$json$Json$Decode$string,
																										A3(
																											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																											'currentNetwork',
																											$elm$json$Json$Decode$string,
																											A3(
																												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																												'togglePaymentNotarisationMethods',
																												$elm$json$Json$Decode$string,
																												A3(
																													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																													'externalWalletTooltipText',
																													$elm$json$Json$Decode$string,
																													A3(
																														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																														'externalWallet',
																														$elm$json$Json$Decode$string,
																														A3(
																															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																															'systemBalanceTooltipText',
																															$elm$json$Json$Decode$string,
																															A3(
																																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																'systemBalance',
																																$elm$json$Json$Decode$string,
																																A3(
																																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																	'headerDescription',
																																	$elm$json$Json$Decode$string,
																																	A3(
																																		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																		'headerText',
																																		$elm$json$Json$Decode$string,
																																		$elm$json$Json$Decode$succeed($author$project$Data$LanguageSwitcher$LanguageDataPointsManagement)))))))))))))))))))))))))))))))))));
var $author$project$Data$LanguageSwitcher$LanguageDataResetPasswordPage = F9(
	function (resetPassword, resetPasswordInstructions, emailAddress, backToLogin, emailSent, emailExistsText, emailExistsText2, emailExistsText3, backToLoginPage) {
		return {backToLogin: backToLogin, backToLoginPage: backToLoginPage, emailAddress: emailAddress, emailExistsText: emailExistsText, emailExistsText2: emailExistsText2, emailExistsText3: emailExistsText3, emailSent: emailSent, resetPassword: resetPassword, resetPasswordInstructions: resetPasswordInstructions};
	});
var $author$project$Data$LanguageSwitcher$decodeLanguageDataResetPasswordPage = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'backToLoginPage',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'emailExistsText3',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'emailExistsText2',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'emailExistsText',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'emailSent',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'backToLogin',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'emailAddress',
							$elm$json$Json$Decode$string,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'resetPasswordInstructions',
								$elm$json$Json$Decode$string,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'resetPassword',
									$elm$json$Json$Decode$string,
									$elm$json$Json$Decode$succeed($author$project$Data$LanguageSwitcher$LanguageDataResetPasswordPage))))))))));
var $author$project$Data$LanguageSwitcher$LanguageDataSignupPage = function (businessPlan) {
	return function (personalPlan) {
		return function (signUp) {
			return function (forEveryone) {
				return function (forBusiness) {
					return function (month) {
						return function (trialDays) {
							return function (cancelAnytime) {
								return function (signSecurely) {
									return function (sendUnlimtedDocs) {
										return function (sendPDFforms) {
											return function (addOrganisationUser) {
												return {addOrganisationUser: addOrganisationUser, businessPlan: businessPlan, cancelAnytime: cancelAnytime, forBusiness: forBusiness, forEveryone: forEveryone, month: month, personalPlan: personalPlan, sendPDFforms: sendPDFforms, sendUnlimtedDocs: sendUnlimtedDocs, signSecurely: signSecurely, signUp: signUp, trialDays: trialDays};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Data$LanguageSwitcher$decodeLanguageDataSignupPage = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'addOrganisationUser',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'sendPDFforms',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'sendUnlimtedDocs',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'signSecurely',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'cancelAnytime',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'trialDays',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'month',
							$elm$json$Json$Decode$string,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'forBusiness',
								$elm$json$Json$Decode$string,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'forEveryone',
									$elm$json$Json$Decode$string,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'signUp',
										$elm$json$Json$Decode$string,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'personalPlan',
											$elm$json$Json$Decode$string,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'businessPlan',
												$elm$json$Json$Decode$string,
												$elm$json$Json$Decode$succeed($author$project$Data$LanguageSwitcher$LanguageDataSignupPage)))))))))))));
var $author$project$Data$LanguageSwitcher$LanguageDataTemplateDashboard = F8(
	function (sendFromTemplate, sendFromTemplateDescription, selectTemplateFromDashboard, selectTemplate, selectTemplateDescription, templateName, createdBy, lastEdited) {
		return {createdBy: createdBy, lastEdited: lastEdited, selectTemplate: selectTemplate, selectTemplateDescription: selectTemplateDescription, selectTemplateFromDashboard: selectTemplateFromDashboard, sendFromTemplate: sendFromTemplate, sendFromTemplateDescription: sendFromTemplateDescription, templateName: templateName};
	});
var $author$project$Data$LanguageSwitcher$decodeLanguageDataTemplateDashboard = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'lastEdited',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'createdBy',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'templateName',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'selectTemplateDescription',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'selectTemplate',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'selectTemplateFromDashboard',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'sendFromTemplateDescription',
							$elm$json$Json$Decode$string,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'sendFromTemplate',
								$elm$json$Json$Decode$string,
								$elm$json$Json$Decode$succeed($author$project$Data$LanguageSwitcher$LanguageDataTemplateDashboard)))))))));
var $author$project$Data$LanguageSwitcher$LanguageDataTransactionDetailsPage = F8(
	function (transactionDetails, transactionId, created, approved, by, ipAddress, remarks, returnToPointsActivities) {
		return {approved: approved, by: by, created: created, ipAddress: ipAddress, remarks: remarks, returnToPointsActivities: returnToPointsActivities, transactionDetails: transactionDetails, transactionId: transactionId};
	});
var $author$project$Data$LanguageSwitcher$decodeLanguageDataTransactionDetailsPage = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'returnToPointsActivities',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'remarks',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'ipAddress',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'by',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'approved',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'created',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'transactionId',
							$elm$json$Json$Decode$string,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'transactionDetails',
								$elm$json$Json$Decode$string,
								$elm$json$Json$Decode$succeed($author$project$Data$LanguageSwitcher$LanguageDataTransactionDetailsPage)))))))));
var $author$project$Data$LanguageSwitcher$LanguageDataUpdateUploadDocErrors = function (notAnnotationFound) {
	return function (unableToUpdate) {
		return function (notInSigningOrder) {
			return function (notPermission) {
				return function (passwordProvidedError) {
					return function (unableToAppend) {
						return function (pdfNotEditable) {
							return function (invalidPDFformat) {
								return function (fileSizeExceeded) {
									return function (pdfDocOnly) {
										return function (invalidData) {
											return function (passcodeRequirements) {
												return {fileSizeExceeded: fileSizeExceeded, invalidData: invalidData, invalidPDFformat: invalidPDFformat, notAnnotationFound: notAnnotationFound, notInSigningOrder: notInSigningOrder, notPermission: notPermission, passcodeRequirements: passcodeRequirements, passwordProvidedError: passwordProvidedError, pdfDocOnly: pdfDocOnly, pdfNotEditable: pdfNotEditable, unableToAppend: unableToAppend, unableToUpdate: unableToUpdate};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Data$LanguageSwitcher$decodeLanguageDataUpdateUploadDocErrors = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'passcodeRequirements',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'invalidData',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'pdfDocOnly',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'fileSizeExceeded',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'invalidPDFformat',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'pdfNotEditable',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'unableToAppend',
							$elm$json$Json$Decode$string,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'passwordProvidedError',
								$elm$json$Json$Decode$string,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'notPermission',
									$elm$json$Json$Decode$string,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'notInSigningOrder',
										$elm$json$Json$Decode$string,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'unableToUpdate',
											$elm$json$Json$Decode$string,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'notAnnotationFound',
												$elm$json$Json$Decode$string,
												$elm$json$Json$Decode$succeed($author$project$Data$LanguageSwitcher$LanguageDataUpdateUploadDocErrors)))))))))))));
var $author$project$Data$LanguageSwitcher$LanguageDataUploadDocument = function (step1) {
	return function (documentsUploaded) {
		return function (step2) {
			return function (addNewRecipient) {
				return function (searchAddressBook) {
					return function (firstName) {
						return function (lastName) {
							return function (email) {
								return function (add) {
									return function (nextStep) {
										return function (viewer) {
											return function (owner) {
												return function (sender) {
													return function (signer) {
														return function (emptyName) {
															return function (invalidEmail) {
																return function (clear) {
																	return function (onlySigner) {
																		return function (step3) {
																			return function (signatures) {
																				return function (stamps) {
																					return function (stampTooltipText) {
																						return function (addToDocument) {
																							return function (previousDocument) {
																								return function (nextDocument) {
																									return function (signatureField) {
																										return function (nameField) {
																											return function (stampField) {
																												return function (dateSigned) {
																													return function (editableText) {
																														return function (nonEditableText) {
																															return function (emailField) {
																																return function (checkboxField) {
																																	return function (optionalSettings) {
																																		return function (signOrder) {
																																			return function (dueDate) {
																																				return function (additionalMessage) {
																																					return function (passcode) {
																																						return function (passcodeTooltipText) {
																																							return function (doNotSaveDocument) {
																																								return function (notariseDocument) {
																																									return function (algorandNetwork) {
																																										return function (binanceNetwork) {
																																											return function (notariseTooltipText1) {
																																												return function (notariseTooltipText2) {
																																													return function (notariseTooltipText3) {
																																														return function (sendButtonText) {
																																															return function (sendDocument) {
																																																return function (faqText) {
																																																	return function (termsOfUse) {
																																																		return function (confirm) {
																																																			return function (sendingYourDocs) {
																																																				return function (success) {
																																																					return function (successText) {
																																																						return function (backToDashboard) {
																																																							return function (proceed) {
																																																								return {add: add, addNewRecipient: addNewRecipient, addToDocument: addToDocument, additionalMessage: additionalMessage, algorandNetwork: algorandNetwork, backToDashboard: backToDashboard, binanceNetwork: binanceNetwork, checkboxField: checkboxField, clear: clear, confirm: confirm, dateSigned: dateSigned, doNotSaveDocument: doNotSaveDocument, documentsUploaded: documentsUploaded, dueDate: dueDate, editableText: editableText, email: email, emailField: emailField, emptyName: emptyName, faqText: faqText, firstName: firstName, invalidEmail: invalidEmail, lastName: lastName, nameField: nameField, nextDocument: nextDocument, nextStep: nextStep, nonEditableText: nonEditableText, notariseDocument: notariseDocument, notariseTooltipText1: notariseTooltipText1, notariseTooltipText2: notariseTooltipText2, notariseTooltipText3: notariseTooltipText3, onlySigner: onlySigner, optionalSettings: optionalSettings, owner: owner, passcode: passcode, passcodeTooltipText: passcodeTooltipText, previousDocument: previousDocument, proceed: proceed, searchAddressBook: searchAddressBook, sendButtonText: sendButtonText, sendDocument: sendDocument, sender: sender, sendingYourDocs: sendingYourDocs, signOrder: signOrder, signatureField: signatureField, signatures: signatures, signer: signer, stampField: stampField, stampTooltipText: stampTooltipText, stamps: stamps, step1: step1, step2: step2, step3: step3, success: success, successText: successText, termsOfUse: termsOfUse, viewer: viewer};
																																																							};
																																																						};
																																																					};
																																																				};
																																																			};
																																																		};
																																																	};
																																																};
																																															};
																																														};
																																													};
																																												};
																																											};
																																										};
																																									};
																																								};
																																							};
																																						};
																																					};
																																				};
																																			};
																																		};
																																	};
																																};
																															};
																														};
																													};
																												};
																											};
																										};
																									};
																								};
																							};
																						};
																					};
																				};
																			};
																		};
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Data$LanguageSwitcher$decodeLanguageDataUploadDocument = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'proceed',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'backToDashboard',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'successText',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'success',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'sendingYourDocs',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'confirm',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'termsOfUse',
							$elm$json$Json$Decode$string,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'faqText',
								$elm$json$Json$Decode$string,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'sendDocument',
									$elm$json$Json$Decode$string,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'sendButtonText',
										$elm$json$Json$Decode$string,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'notariseTooltipText3',
											$elm$json$Json$Decode$string,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'notariseTooltipText2',
												$elm$json$Json$Decode$string,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'notariseTooltipText1',
													$elm$json$Json$Decode$string,
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'binanceNetwork',
														$elm$json$Json$Decode$string,
														A3(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
															'algorandNetwork',
															$elm$json$Json$Decode$string,
															A3(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																'notariseDocument',
																$elm$json$Json$Decode$string,
																A3(
																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																	'doNotSaveDocument',
																	$elm$json$Json$Decode$string,
																	A3(
																		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																		'passcodeTooltipText',
																		$elm$json$Json$Decode$string,
																		A3(
																			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																			'passcode',
																			$elm$json$Json$Decode$string,
																			A3(
																				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																				'additionalMessage',
																				$elm$json$Json$Decode$string,
																				A3(
																					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																					'dueDate',
																					$elm$json$Json$Decode$string,
																					A3(
																						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																						'signOrder',
																						$elm$json$Json$Decode$string,
																						A3(
																							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																							'optionalSettings',
																							$elm$json$Json$Decode$string,
																							A3(
																								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																								'checkboxField',
																								$elm$json$Json$Decode$string,
																								A3(
																									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																									'emailField',
																									$elm$json$Json$Decode$string,
																									A3(
																										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																										'nonEditableText',
																										$elm$json$Json$Decode$string,
																										A3(
																											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																											'editableText',
																											$elm$json$Json$Decode$string,
																											A3(
																												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																												'dateSigned',
																												$elm$json$Json$Decode$string,
																												A3(
																													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																													'stampField',
																													$elm$json$Json$Decode$string,
																													A3(
																														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																														'nameField',
																														$elm$json$Json$Decode$string,
																														A3(
																															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																															'signatureField',
																															$elm$json$Json$Decode$string,
																															A3(
																																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																'nextDocument',
																																$elm$json$Json$Decode$string,
																																A3(
																																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																	'previousDocument',
																																	$elm$json$Json$Decode$string,
																																	A3(
																																		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																		'addToDocument',
																																		$elm$json$Json$Decode$string,
																																		A3(
																																			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																			'stampTooltipText',
																																			$elm$json$Json$Decode$string,
																																			A3(
																																				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																				'stamps',
																																				$elm$json$Json$Decode$string,
																																				A3(
																																					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																					'signatures',
																																					$elm$json$Json$Decode$string,
																																					A3(
																																						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																						'step3',
																																						$elm$json$Json$Decode$string,
																																						A3(
																																							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																							'onlySigner',
																																							$elm$json$Json$Decode$string,
																																							A3(
																																								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																								'clear',
																																								$elm$json$Json$Decode$string,
																																								A3(
																																									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																									'invalidEmail',
																																									$elm$json$Json$Decode$string,
																																									A3(
																																										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																										'emptyName',
																																										$elm$json$Json$Decode$string,
																																										A3(
																																											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																											'signer',
																																											$elm$json$Json$Decode$string,
																																											A3(
																																												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																												'sender',
																																												$elm$json$Json$Decode$string,
																																												A3(
																																													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																													'owner',
																																													$elm$json$Json$Decode$string,
																																													A3(
																																														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																														'viewer',
																																														$elm$json$Json$Decode$string,
																																														A3(
																																															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																															'nextStep',
																																															$elm$json$Json$Decode$string,
																																															A3(
																																																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																																'add',
																																																$elm$json$Json$Decode$string,
																																																A3(
																																																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																																	'email',
																																																	$elm$json$Json$Decode$string,
																																																	A3(
																																																		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																																		'lastName',
																																																		$elm$json$Json$Decode$string,
																																																		A3(
																																																			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																																			'firstName',
																																																			$elm$json$Json$Decode$string,
																																																			A3(
																																																				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																																				'searchAddressBook',
																																																				$elm$json$Json$Decode$string,
																																																				A3(
																																																					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																																					'addNewRecipient',
																																																					$elm$json$Json$Decode$string,
																																																					A3(
																																																						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																																						'step2',
																																																						$elm$json$Json$Decode$string,
																																																						A3(
																																																							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																																							'documentsUploaded',
																																																							$elm$json$Json$Decode$string,
																																																							A3(
																																																								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																																								'step1',
																																																								$elm$json$Json$Decode$string,
																																																								$elm$json$Json$Decode$succeed($author$project$Data$LanguageSwitcher$LanguageDataUploadDocument)))))))))))))))))))))))))))))))))))))))))))))))))))))))));
var $author$project$Data$LanguageSwitcher$LanguageDataUploadTemplatePage = F6(
	function (newTemplate, numberOfTemplates, available, used, createNewTemplate, createTemplateDescription) {
		return {available: available, createNewTemplate: createNewTemplate, createTemplateDescription: createTemplateDescription, newTemplate: newTemplate, numberOfTemplates: numberOfTemplates, used: used};
	});
var $author$project$Data$LanguageSwitcher$decodeLanguageDataUploadTemplatePage = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'createTemplateDescription',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'createNewTemplate',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'used',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'available',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'numberOfTemplates',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'newTemplate',
						$elm$json$Json$Decode$string,
						$elm$json$Json$Decode$succeed($author$project$Data$LanguageSwitcher$LanguageDataUploadTemplatePage)))))));
var $author$project$Data$LanguageSwitcher$LanguageDataVerificationPage = function (verificationMethods) {
	return function (verified) {
		return function (notVerified) {
			return function (creditCard) {
				return function (creditCardVerificationText) {
					return function (governmentId) {
						return function (governmentIdVerificationText) {
							return function (mobilePhone) {
								return function (mobilePhoneVerificationText) {
									return function (wallet) {
										return function (creditCardDescriptionText) {
											return function (governmentIdDescriptionText) {
												return function (governmentIdDescriptionText2) {
													return function (acknowledgementText) {
														return function (comingSoon) {
															return function (mobilePhoneDescriptionText) {
																return function (goToAccount) {
																	return function (walletDescription) {
																		return function (redirectToPointManagementPage) {
																			return function (verify) {
																				return {acknowledgementText: acknowledgementText, comingSoon: comingSoon, creditCard: creditCard, creditCardDescriptionText: creditCardDescriptionText, creditCardVerificationText: creditCardVerificationText, goToAccount: goToAccount, governmentId: governmentId, governmentIdDescriptionText: governmentIdDescriptionText, governmentIdDescriptionText2: governmentIdDescriptionText2, governmentIdVerificationText: governmentIdVerificationText, mobilePhone: mobilePhone, mobilePhoneDescriptionText: mobilePhoneDescriptionText, mobilePhoneVerificationText: mobilePhoneVerificationText, notVerified: notVerified, redirectToPointManagementPage: redirectToPointManagementPage, verificationMethods: verificationMethods, verified: verified, verify: verify, wallet: wallet, walletDescription: walletDescription};
																			};
																		};
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Data$LanguageSwitcher$decodeLanguageDataVerificationPage = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'verify',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'redirectToPointManagementPage',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'walletDescription',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'goToAccount',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'mobilePhoneDescriptionText',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'comingSoon',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'acknowledgementText',
							$elm$json$Json$Decode$string,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'governmentIdDescriptionText2',
								$elm$json$Json$Decode$string,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'governmentIdDescriptionText',
									$elm$json$Json$Decode$string,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'creditCardDescriptionText',
										$elm$json$Json$Decode$string,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'wallet',
											$elm$json$Json$Decode$string,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'mobilePhoneVerificationText',
												$elm$json$Json$Decode$string,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'mobilePhone',
													$elm$json$Json$Decode$string,
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'governmentIdVerificationText',
														$elm$json$Json$Decode$string,
														A3(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
															'governmentId',
															$elm$json$Json$Decode$string,
															A3(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																'creditCardVerificationText',
																$elm$json$Json$Decode$string,
																A3(
																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																	'creditCard',
																	$elm$json$Json$Decode$string,
																	A3(
																		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																		'notVerified',
																		$elm$json$Json$Decode$string,
																		A3(
																			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																			'verified',
																			$elm$json$Json$Decode$string,
																			A3(
																				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																				'verificationMethods',
																				$elm$json$Json$Decode$string,
																				$elm$json$Json$Decode$succeed($author$project$Data$LanguageSwitcher$LanguageDataVerificationPage)))))))))))))))))))));
var $author$project$Data$LanguageSwitcher$LanguageDataViewDocumentPage = function (documentInformation) {
	return function (documentId) {
		return function (templateId) {
			return function (documentTitle) {
				return function (status) {
					return function (pendingSignature) {
						return function (documentCompleted) {
							return function (awaitingSignature) {
								return function (expired) {
									return function (role) {
										return function (verifiedWith) {
											return function (notVerifiedWith) {
												return function (yourSignatures) {
													return function (yourStamps) {
														return function (downloadDocument) {
															return function (downloadPartiallyCompletedDocument) {
																return function (downloadDocumentText) {
																	return function (downloadDocumentText2) {
																		return function (proceed) {
																			return function (submit) {
																				return function (viewCertificate) {
																					return function (certificateOfCompletion) {
																						return function (signerDetails) {
																							return function (documentSummaryEvents) {
																								return function (downloadCertificate) {
																									return function (notariseDocument) {
																										return function (notarisationCost) {
																											return function (notarisationCost2) {
																												return function (confirm) {
																													return function (backToDocuments) {
																														return function (notarisationStatus) {
																															return function (documentChecksum) {
																																return function (timeOfNotarisation) {
																																	return function (signatureTimeStamping) {
																																		return function (timeStamp) {
																																			return function (activities) {
																																				return function (action) {
																																					return function (sign) {
																																						return function (view) {
																																							return function (downloadCompletedDocument) {
																																								return function (downloadVerifiableCredentials) {
																																									return function (sentReminder) {
																																										return function (time) {
																																											return function (deleteDocument) {
																																												return function (deleteDocumentText) {
																																													return function (viewSigningEvents) {
																																														return function (resendEmailNotification) {
																																															return function (recipients) {
																																																return function (signatureAndStamps) {
																																																	return function (helpDesk) {
																																																		return {action: action, activities: activities, awaitingSignature: awaitingSignature, backToDocuments: backToDocuments, certificateOfCompletion: certificateOfCompletion, confirm: confirm, deleteDocument: deleteDocument, deleteDocumentText: deleteDocumentText, documentChecksum: documentChecksum, documentCompleted: documentCompleted, documentId: documentId, documentInformation: documentInformation, documentSummaryEvents: documentSummaryEvents, documentTitle: documentTitle, downloadCertificate: downloadCertificate, downloadCompletedDocument: downloadCompletedDocument, downloadDocument: downloadDocument, downloadDocumentText: downloadDocumentText, downloadDocumentText2: downloadDocumentText2, downloadPartiallyCompletedDocument: downloadPartiallyCompletedDocument, downloadVerifiableCredentials: downloadVerifiableCredentials, expired: expired, helpDesk: helpDesk, notVerifiedWith: notVerifiedWith, notarisationCost: notarisationCost, notarisationCost2: notarisationCost2, notarisationStatus: notarisationStatus, notariseDocument: notariseDocument, pendingSignature: pendingSignature, proceed: proceed, recipients: recipients, resendEmailNotification: resendEmailNotification, role: role, sentReminder: sentReminder, sign: sign, signatureAndStamps: signatureAndStamps, signatureTimeStamping: signatureTimeStamping, signerDetails: signerDetails, status: status, submit: submit, templateId: templateId, time: time, timeOfNotarisation: timeOfNotarisation, timeStamp: timeStamp, verifiedWith: verifiedWith, view: view, viewCertificate: viewCertificate, viewSigningEvents: viewSigningEvents, yourSignatures: yourSignatures, yourStamps: yourStamps};
																																																	};
																																																};
																																															};
																																														};
																																													};
																																												};
																																											};
																																										};
																																									};
																																								};
																																							};
																																						};
																																					};
																																				};
																																			};
																																		};
																																	};
																																};
																															};
																														};
																													};
																												};
																											};
																										};
																									};
																								};
																							};
																						};
																					};
																				};
																			};
																		};
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Data$LanguageSwitcher$decodeLanguageDataViewDocumentPage = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'helpDesk',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'signatureAndStamps',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'recipients',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'resendEmailNotification',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'viewSigningEvents',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'deleteDocumentText',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'deleteDocument',
							$elm$json$Json$Decode$string,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'time',
								$elm$json$Json$Decode$string,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'sentReminder',
									$elm$json$Json$Decode$string,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'downloadVerifiableCredentials',
										$elm$json$Json$Decode$string,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'downloadCompletedDocument',
											$elm$json$Json$Decode$string,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'view',
												$elm$json$Json$Decode$string,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'sign',
													$elm$json$Json$Decode$string,
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'action',
														$elm$json$Json$Decode$string,
														A3(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
															'activities',
															$elm$json$Json$Decode$string,
															A3(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																'timeStamp',
																$elm$json$Json$Decode$string,
																A3(
																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																	'signatureTimeStamping',
																	$elm$json$Json$Decode$string,
																	A3(
																		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																		'timeOfNotarisation',
																		$elm$json$Json$Decode$string,
																		A3(
																			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																			'documentChecksum',
																			$elm$json$Json$Decode$string,
																			A3(
																				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																				'notarisationStatus',
																				$elm$json$Json$Decode$string,
																				A3(
																					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																					'backToDocuments',
																					$elm$json$Json$Decode$string,
																					A3(
																						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																						'confirm',
																						$elm$json$Json$Decode$string,
																						A3(
																							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																							'notarisationCost2',
																							$elm$json$Json$Decode$string,
																							A3(
																								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																								'notarisationCost',
																								$elm$json$Json$Decode$string,
																								A3(
																									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																									'notariseDocument',
																									$elm$json$Json$Decode$string,
																									A3(
																										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																										'downloadCertificate',
																										$elm$json$Json$Decode$string,
																										A3(
																											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																											'documentSummaryEvents',
																											$elm$json$Json$Decode$string,
																											A3(
																												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																												'signerDetails',
																												$elm$json$Json$Decode$string,
																												A3(
																													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																													'certificateOfCompletion',
																													$elm$json$Json$Decode$string,
																													A3(
																														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																														'viewCertificate',
																														$elm$json$Json$Decode$string,
																														A3(
																															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																															'submit',
																															$elm$json$Json$Decode$string,
																															A3(
																																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																'proceed',
																																$elm$json$Json$Decode$string,
																																A3(
																																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																	'downloadDocumentText2',
																																	$elm$json$Json$Decode$string,
																																	A3(
																																		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																		'downloadDocumentText',
																																		$elm$json$Json$Decode$string,
																																		A3(
																																			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																			'downloadPartiallyCompletedDocument',
																																			$elm$json$Json$Decode$string,
																																			A3(
																																				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																				'downloadDocument',
																																				$elm$json$Json$Decode$string,
																																				A3(
																																					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																					'yourStamps',
																																					$elm$json$Json$Decode$string,
																																					A3(
																																						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																						'yourSignatures',
																																						$elm$json$Json$Decode$string,
																																						A3(
																																							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																							'notVerifiedWith',
																																							$elm$json$Json$Decode$string,
																																							A3(
																																								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																								'verifiedWith',
																																								$elm$json$Json$Decode$string,
																																								A3(
																																									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																									'role',
																																									$elm$json$Json$Decode$string,
																																									A3(
																																										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																										'expired',
																																										$elm$json$Json$Decode$string,
																																										A3(
																																											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																											'awaitingSignature',
																																											$elm$json$Json$Decode$string,
																																											A3(
																																												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																												'documentCompleted',
																																												$elm$json$Json$Decode$string,
																																												A3(
																																													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																													'pendingSignature',
																																													$elm$json$Json$Decode$string,
																																													A3(
																																														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																														'status',
																																														$elm$json$Json$Decode$string,
																																														A3(
																																															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																															'documentTitle',
																																															$elm$json$Json$Decode$string,
																																															A3(
																																																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																																'templateId',
																																																$elm$json$Json$Decode$string,
																																																A3(
																																																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																																	'documentId',
																																																	$elm$json$Json$Decode$string,
																																																	A3(
																																																		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																																		'documentInformation',
																																																		$elm$json$Json$Decode$string,
																																																		$elm$json$Json$Decode$succeed($author$project$Data$LanguageSwitcher$LanguageDataViewDocumentPage)))))))))))))))))))))))))))))))))))))))))))))))))));
var $author$project$Data$LanguageSwitcher$LanguageDataViewNotarisedInformation = function (viewNotarisedDocumentInformation) {
	return function (viewNotarisedInfoText) {
		return function (pleaseUploadFile) {
			return function (dragAndDrop) {
				return function (browseYourPC) {
					return function (verificationDone) {
						return function (transactionId) {
							return function (checksum) {
								return function (timeOfNotarisation) {
									return function (docNotarisationDetails) {
										return {browseYourPC: browseYourPC, checksum: checksum, docNotarisationDetails: docNotarisationDetails, dragAndDrop: dragAndDrop, pleaseUploadFile: pleaseUploadFile, timeOfNotarisation: timeOfNotarisation, transactionId: transactionId, verificationDone: verificationDone, viewNotarisedDocumentInformation: viewNotarisedDocumentInformation, viewNotarisedInfoText: viewNotarisedInfoText};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Data$LanguageSwitcher$decodeLanguageDataViewNotarisedInformation = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'docNotarisationDetails',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'timeOfNotarisation',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'checksum',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'transactionId',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'verificationDone',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'browseYourPC',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'dragAndDrop',
							$elm$json$Json$Decode$string,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'pleaseUploadFile',
								$elm$json$Json$Decode$string,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'viewNotarisedInfoText',
									$elm$json$Json$Decode$string,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'viewNotarisedDocumentInformation',
										$elm$json$Json$Decode$string,
										$elm$json$Json$Decode$succeed($author$project$Data$LanguageSwitcher$LanguageDataViewNotarisedInformation)))))))))));
var $author$project$Data$LanguageSwitcher$LanguageDataViewTemplatePage = function (nameOfTemplate) {
	return function (createdBy) {
		return function (dateCreated) {
			return function (version) {
				return function (lastEdited) {
					return function (lastViewed) {
						return function (noOfDocumentsGeneratedFromTemplate) {
							return function (templateUrl) {
								return function (downloadTemplateReport) {
									return function (requestToFillTemplate) {
										return function (fillTemplateRequest) {
											return function (fillTemplateRequestText) {
												return function (confirm) {
													return function (back) {
														return function (viewTemplateActivity) {
															return function (deleteTemplate) {
																return function (createDocumentFromTemplate) {
																	return function (backToDashboard) {
																		return function (close) {
																			return {back: back, backToDashboard: backToDashboard, close: close, confirm: confirm, createDocumentFromTemplate: createDocumentFromTemplate, createdBy: createdBy, dateCreated: dateCreated, deleteTemplate: deleteTemplate, downloadTemplateReport: downloadTemplateReport, fillTemplateRequest: fillTemplateRequest, fillTemplateRequestText: fillTemplateRequestText, lastEdited: lastEdited, lastViewed: lastViewed, nameOfTemplate: nameOfTemplate, noOfDocumentsGeneratedFromTemplate: noOfDocumentsGeneratedFromTemplate, requestToFillTemplate: requestToFillTemplate, templateUrl: templateUrl, version: version, viewTemplateActivity: viewTemplateActivity};
																		};
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Data$LanguageSwitcher$decodeLanguageDataViewTemplatePage = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'close',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'backToDashboard',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'createDocumentFromTemplate',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'deleteTemplate',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'viewTemplateActivity',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'back',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'confirm',
							$elm$json$Json$Decode$string,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'fillTemplateRequestText',
								$elm$json$Json$Decode$string,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'fillTemplateRequest',
									$elm$json$Json$Decode$string,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'requestToFillTemplate',
										$elm$json$Json$Decode$string,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'downloadTemplateReport',
											$elm$json$Json$Decode$string,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'templateUrl',
												$elm$json$Json$Decode$string,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'noOfDocumentsGeneratedFromTemplate',
													$elm$json$Json$Decode$string,
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'lastViewed',
														$elm$json$Json$Decode$string,
														A3(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
															'lastEdited',
															$elm$json$Json$Decode$string,
															A3(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																'version',
																$elm$json$Json$Decode$string,
																A3(
																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																	'dateCreated',
																	$elm$json$Json$Decode$string,
																	A3(
																		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																		'createdBy',
																		$elm$json$Json$Decode$string,
																		A3(
																			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																			'nameOfTemplate',
																			$elm$json$Json$Decode$string,
																			$elm$json$Json$Decode$succeed($author$project$Data$LanguageSwitcher$LanguageDataViewTemplatePage))))))))))))))))))));
var $author$project$Data$LanguageSwitcher$decodeLanguageDataLocation = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'viewTemplatePage',
	$author$project$Data$LanguageSwitcher$decodeLanguageDataViewTemplatePage,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'myOrganisationPage',
		$author$project$Data$LanguageSwitcher$decodeLanguageDataMyOrganisationPage,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'createTemplatePage',
			$author$project$Data$LanguageSwitcher$decodeLanguageDataCreateTemplatePage,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'uploadTemplatePage',
				$author$project$Data$LanguageSwitcher$decodeLanguageDataUploadTemplatePage,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'fillTemplatePage',
					$author$project$Data$LanguageSwitcher$decodeLanguageDataFillTemplatePage,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'templateDashboard',
						$author$project$Data$LanguageSwitcher$decodeLanguageDataTemplateDashboard,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'accountSettingsPage',
							$author$project$Data$LanguageSwitcher$decodeLanguageDataAccountSettingsPage,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'addressBookPage',
								$author$project$Data$LanguageSwitcher$decodeLanguageDataAddressBookPage,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'viewNotarisedInformation',
									$author$project$Data$LanguageSwitcher$decodeLanguageDataViewNotarisedInformation,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'listDocumentsPage',
										$author$project$Data$LanguageSwitcher$decodeLanguageDataListDocumentsPage,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'viewDocumentPage',
											$author$project$Data$LanguageSwitcher$decodeLanguageDataViewDocumentPage,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'transactionDetailsPage',
												$author$project$Data$LanguageSwitcher$decodeLanguageDataTransactionDetailsPage,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'pointsManagement',
													$author$project$Data$LanguageSwitcher$decodeLanguageDataPointsManagement,
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'verificationPage',
														$author$project$Data$LanguageSwitcher$decodeLanguageDataVerificationPage,
														A3(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
															'uploadDocument',
															$author$project$Data$LanguageSwitcher$decodeLanguageDataUploadDocument,
															A3(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																'dashboard',
																$author$project$Data$LanguageSwitcher$decodeLanguageDataDashboard,
																A3(
																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																	'menuItem',
																	$author$project$Data$LanguageSwitcher$decodeLanguageDataMenuItem,
																	A3(
																		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																		'updateUploadDocErrors',
																		$author$project$Data$LanguageSwitcher$decodeLanguageDataUpdateUploadDocErrors,
																		A3(
																			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																			'businessRegister',
																			$author$project$Data$LanguageSwitcher$decodeLanguageDataBusinessRegister,
																			A3(
																				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																				'personalRegisterPage',
																				$author$project$Data$LanguageSwitcher$decodeLanguageDataPersonalRegisterPage,
																				A3(
																					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																					'signupPage',
																					$author$project$Data$LanguageSwitcher$decodeLanguageDataSignupPage,
																					A3(
																						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																						'resetPasswordPage',
																						$author$project$Data$LanguageSwitcher$decodeLanguageDataResetPasswordPage,
																						A3(
																							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																							'login',
																							$author$project$Data$LanguageSwitcher$decodeLanguageDataLogin,
																							$elm$json$Json$Decode$succeed($author$project$Data$LanguageSwitcher$LanguageDataLocation))))))))))))))))))))))));
var $author$project$Data$LanguageSwitcher$decodeLanguageData = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'location',
	$author$project$Data$LanguageSwitcher$decodeLanguageDataLocation,
	$elm$json$Json$Decode$succeed($author$project$Data$LanguageSwitcher$LanguageData));
var $author$project$Data$LanguageSwitcher$decodeJsonData = function (base64Data) {
	var _v0 = A2($elm$json$Json$Decode$decodeValue, $author$project$Data$LanguageSwitcher$decodeLanguageData, base64Data);
	if (_v0.$ === 'Ok') {
		var results = _v0.a;
		return $elm$core$Result$Ok(results);
	} else {
		return $elm$core$Result$Err('Err getting Language JSON data');
	}
};
var $author$project$Model$LanguageChange$update = F3(
	function (msg, authModel, model) {
		var languageChangeModel = authModel.languageChangeModel;
		var _v0 = model;
		var languageSwitchModel = _v0.languageSwitchModel;
		switch (msg.$) {
			case 'OnLanguageSelect':
				var userSelectedLanguage = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							sessionModel: $author$project$Types$Auth(
								_Utils_update(
									authModel,
									{
										languageChangeModel: _Utils_update(
											languageChangeModel,
											{selectedLanguage: userSelectedLanguage})
									}))
						}),
					$author$project$Model$LanguageChange$languageSwitcher(
						$elm$json$Json$Encode$string(
							$author$project$View$Menu$convertLanguageToString(userSelectedLanguage))));
			case 'OnLanguageMenuItemClick':
				var showSubMenu = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							sessionModel: $author$project$Types$Auth(
								_Utils_update(
									authModel,
									{
										languageChangeModel: _Utils_update(
											languageChangeModel,
											{onLanguageSelectMenu: showSubMenu})
									}))
						}),
					$elm$core$Platform$Cmd$none);
			default:
				var jsonData = msg.a;
				var _v2 = $author$project$Data$LanguageSwitcher$decodeJsonData(jsonData);
				if (_v2.$ === 'Ok') {
					var data = _v2.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								languageSwitchModel: _Utils_update(
									languageSwitchModel,
									{allLanguageData: data})
							}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2(
									$elm$core$Task$perform,
									$author$project$Types$OnAuth,
									$elm$core$Task$succeed(
										$author$project$Types$OnMenu($author$project$Types$ClosedMenu))),
									A2(
									$elm$core$Task$perform,
									$author$project$Types$OnAuth,
									$elm$core$Task$succeed(
										$author$project$Types$OnLanguageChange(
											$author$project$Type$LanguageChange$OnLanguageMenuItemClick(false))))
								])));
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
		}
	});
var $elm$core$Platform$Cmd$map = _Platform_map;
var $author$project$Type$ListDocument$DeleteDocumentError = function (a) {
	return {$: 'DeleteDocumentError', a: a};
};
var $author$project$Type$ListDocument$DeleteSuccess = {$: 'DeleteSuccess'};
var $author$project$Type$ListDocument$DeleteTemplateError = function (a) {
	return {$: 'DeleteTemplateError', a: a};
};
var $author$project$Type$ListDocument$DeleteTemplateSuccess = {$: 'DeleteTemplateSuccess'};
var $author$project$Type$ListDocument$Error = function (a) {
	return {$: 'Error', a: a};
};
var $author$project$Type$ListDocument$ListCompletedDocuments = F3(
	function (a, b, c) {
		return {$: 'ListCompletedDocuments', a: a, b: b, c: c};
	});
var $author$project$Type$ListDocument$ListReceivedDocuments = F3(
	function (a, b, c) {
		return {$: 'ListReceivedDocuments', a: a, b: b, c: c};
	});
var $author$project$Type$ListDocument$ListSentDocuments = F3(
	function (a, b, c) {
		return {$: 'ListSentDocuments', a: a, b: b, c: c};
	});
var $author$project$Type$ListDocument$ListSubmission = F2(
	function (a, b) {
		return {$: 'ListSubmission', a: a, b: b};
	});
var $author$project$Type$ListDocument$ListTemplate = F2(
	function (a, b) {
		return {$: 'ListTemplate', a: a, b: b};
	});
var $author$project$Type$ListDocument$Loaded = {$: 'Loaded'};
var $author$project$Type$ListDocument$LoadingState = {$: 'LoadingState'};
var $author$project$Type$ListDocument$OnDeleteDocumentResult = function (a) {
	return {$: 'OnDeleteDocumentResult', a: a};
};
var $author$project$Type$ListDocument$OnDeleteTemplateResult = function (a) {
	return {$: 'OnDeleteTemplateResult', a: a};
};
var $author$project$Type$ListDocument$OnRequestTemplateResult = function (a) {
	return {$: 'OnRequestTemplateResult', a: a};
};
var $author$project$Type$ListDocument$OnTypeChange = function (a) {
	return {$: 'OnTypeChange', a: a};
};
var $author$project$Type$ListDocument$RequestTemplateSuccess = {$: 'RequestTemplateSuccess'};
var $author$project$Data$Api$ListDocument$Payload = F2(
	function (listDocument, documentCount) {
		return {documentCount: documentCount, listDocument: listDocument};
	});
var $author$project$Data$Api$ListDocument$Document = F8(
	function (id, title, ownerName, createdAt, updatedAt, signers, viewers, ownerId) {
		return {createdAt: createdAt, id: id, ownerId: ownerId, ownerName: ownerName, signers: signers, title: title, updatedAt: updatedAt, viewers: viewers};
	});
var $author$project$Data$Api$ListDocument$decodeDocumentList = $elm$json$Json$Decode$list(
	A9(
		$elm$json$Json$Decode$map8,
		$author$project$Data$Api$ListDocument$Document,
		A2($elm$json$Json$Decode$field, 'id', $elm$json$Json$Decode$string),
		A2($elm$json$Json$Decode$field, 'title', $elm$json$Json$Decode$string),
		A2($elm$json$Json$Decode$field, 'ownerName', $elm$json$Json$Decode$string),
		A2(
			$elm$json$Json$Decode$field,
			'createdAt',
			A2($elm$json$Json$Decode$map, $elm$time$Time$millisToPosix, $elm$json$Json$Decode$int)),
		A2(
			$elm$json$Json$Decode$field,
			'updatedAt',
			A2($elm$json$Json$Decode$map, $elm$time$Time$millisToPosix, $elm$json$Json$Decode$int)),
		A2(
			$elm$json$Json$Decode$field,
			'signers',
			$elm$json$Json$Decode$list($elm$json$Json$Decode$string)),
		A2(
			$elm$json$Json$Decode$field,
			'viewers',
			$elm$json$Json$Decode$list($elm$json$Json$Decode$string)),
		A2($elm$json$Json$Decode$field, 'ownerId', $elm$json$Json$Decode$string)));
var $author$project$Data$Api$ListDocument$dataDecoder = A3(
	$elm$json$Json$Decode$map2,
	$author$project$Data$Api$ListDocument$Payload,
	A2($elm$json$Json$Decode$field, 'listDocument', $author$project$Data$Api$ListDocument$decodeDocumentList),
	A2($elm$json$Json$Decode$field, 'documentCount', $elm$json$Json$Decode$int));
var $author$project$Data$Api$ListDocument$errorDecoder = $elm$json$Json$Decode$succeed(_Utils_Tuple0);
var $author$project$Data$Api$ListDocument$authCall = F5(
	function (jwt, endPoint, pageNumber, searchTerm, domain) {
		return A5(
			$author$project$Data$Api$authCall,
			jwt,
			endPoint,
			$author$project$Data$Api$ListDocument$errorDecoder,
			$author$project$Data$Api$ListDocument$dataDecoder,
			$elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'domain',
						$elm$json$Json$Encode$string(
							$author$project$Data$Domain$toString(domain))),
						_Utils_Tuple2(
						'pageNumber',
						$elm$json$Json$Encode$int(pageNumber)),
						_Utils_Tuple2(
						'searchTerm',
						$elm$json$Json$Encode$string(searchTerm))
					])));
	});
var $author$project$Data$Api$ListSubmission$Payload = F2(
	function (submissions, allSubmissionsCount) {
		return {allSubmissionsCount: allSubmissionsCount, submissions: submissions};
	});
var $author$project$Data$Api$ListSubmission$Submissions = F9(
	function (id, ownerId, templateId, createdAt, domain, email, firstName, lastName, title) {
		return {createdAt: createdAt, domain: domain, email: email, firstName: firstName, id: id, lastName: lastName, ownerId: ownerId, templateId: templateId, title: title};
	});
var $author$project$Data$Api$ListSubmission$decodeSubmissionList = $elm$json$Json$Decode$list(
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'title',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'lastName',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'firstName',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'email',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'domain',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'createdAt',
							A2($elm$json$Json$Decode$map, $elm$time$Time$millisToPosix, $elm$json$Json$Decode$int),
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'templateId',
								$elm$json$Json$Decode$string,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'ownerId',
									$elm$json$Json$Decode$string,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'id',
										$elm$json$Json$Decode$string,
										$elm$json$Json$Decode$succeed($author$project$Data$Api$ListSubmission$Submissions)))))))))));
var $author$project$Data$Api$ListSubmission$dataDecoder = A3(
	$elm$json$Json$Decode$map2,
	$author$project$Data$Api$ListSubmission$Payload,
	A2($elm$json$Json$Decode$field, 'submissions', $author$project$Data$Api$ListSubmission$decodeSubmissionList),
	A2($elm$json$Json$Decode$field, 'allSubmissionsCount', $elm$json$Json$Decode$int));
var $author$project$Data$Api$ListSubmission$PERMISSION_DENIED = {$: 'PERMISSION_DENIED'};
var $author$project$Data$Api$ListSubmission$errorDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (errorCode) {
		if (errorCode === 'PERMISSION_DENIED') {
			return $elm$json$Json$Decode$succeed($author$project$Data$Api$ListSubmission$PERMISSION_DENIED);
		} else {
			return $elm$json$Json$Decode$fail('Invalid error code: ' + errorCode);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Data$Api$ListSubmission$authCall = F4(
	function (jwt, endPoint, pageNumber, domain) {
		return A5(
			$author$project$Data$Api$authCall,
			jwt,
			endPoint,
			$author$project$Data$Api$ListSubmission$errorDecoder,
			$author$project$Data$Api$ListSubmission$dataDecoder,
			$elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'domain',
						$elm$json$Json$Encode$string(domain)),
						_Utils_Tuple2(
						'pageNumber',
						$elm$json$Json$Encode$int(pageNumber))
					])));
	});
var $author$project$Data$Api$ListTemplate$authCall = F5(
	function (jwt, endPoint, pageNumber, searchTerm, domain) {
		return A5(
			$author$project$Data$Api$authCall,
			jwt,
			endPoint,
			$author$project$Data$Api$ListTemplate$errorDecoder,
			$author$project$Data$Api$ListTemplate$dataDecoder,
			$elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'domain',
						$author$project$Data$Domain$encode(domain)),
						_Utils_Tuple2(
						'pageNumber',
						$elm$json$Json$Encode$int(pageNumber)),
						_Utils_Tuple2(
						'searchTerm',
						$elm$json$Json$Encode$string(searchTerm))
					])));
	});
var $author$project$Data$Api$PDF$Delete$Payload = function (message) {
	return {message: message};
};
var $author$project$Data$Api$PDF$Delete$dataDecoder = A2(
	$elm$json$Json$Decode$map,
	$author$project$Data$Api$PDF$Delete$Payload,
	A2($elm$json$Json$Decode$field, 'message', $elm$json$Json$Decode$string));
var $author$project$Data$Api$PDF$Delete$encode = function (documentId) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'documentId',
				$elm$json$Json$Encode$string(documentId))
			]));
};
var $author$project$Data$Api$PDF$Delete$UNAUTHORISED_USER = {$: 'UNAUTHORISED_USER'};
var $author$project$Data$Api$PDF$Delete$errorDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (errorCode) {
		if (errorCode === 'UNAUTHORISED_USER') {
			return $elm$json$Json$Decode$succeed($author$project$Data$Api$PDF$Delete$UNAUTHORISED_USER);
		} else {
			return $elm$json$Json$Decode$fail('Invalid error code: ' + errorCode);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Data$Api$PDF$Delete$authCall = F3(
	function (jwt, endPoint, documentId) {
		return A5(
			$author$project$Data$Api$authCall,
			jwt,
			endPoint,
			$author$project$Data$Api$PDF$Delete$errorDecoder,
			$author$project$Data$Api$PDF$Delete$dataDecoder,
			$author$project$Data$Api$PDF$Delete$encode(documentId));
	});
var $author$project$Model$ListDocument$displayDocumentListingAdsContent = _Platform_outgoingPort('displayDocumentListingAdsContent', $elm$core$Basics$identity);
var $author$project$Type$ListDocument$docTypeToString = function (docType) {
	switch (docType.$) {
		case 'Sent':
			return $author$project$Data$Route$routeUrl.sentDoc;
		case 'Received':
			return $author$project$Data$Route$routeUrl.receievedDoc;
		case 'Completed':
			return $author$project$Data$Route$routeUrl.completedDoc;
		case 'Template':
			return $author$project$Data$Route$routeUrl.templateDoc;
		default:
			return $author$project$Data$Route$routeUrl.submissionDoc;
	}
};
var $author$project$Data$Api$PDF$Delete$errorToString = function (error) {
	return 'You are not the owner of this document.';
};
var $elm$core$List$sortBy = _List_sortBy;
var $author$project$Model$ListDocument$toTemplateDetails = function (payload) {
	return A2(
		$elm$core$List$map,
		function (details) {
			return {createdAt: details.createdAt, id: details.id, noOfRoles: details.noOfRoles, ownerId: details.owner.id, ownerName: details.owner.firstName + (' ' + details.owner.lastName), slug: details.slug, title: details.title, updatedAt: details.updatedAt, version: details.version};
		},
		payload.templates);
};
var $author$project$Model$ListDocument$updateList = F4(
	function (msg, listDocModel, authModel, model) {
		var _v0 = authModel;
		var user = _v0.user;
		var domain = $author$project$Data$Domain$selected(user.domains);
		var _v1 = listDocModel;
		var pageNumber = _v1.pageNumber;
		var searchQuery = _v1.searchQuery;
		var _v2 = model;
		var apiEndPoint = _v2.apiEndPoint;
		switch (msg.$) {
			case 'LoadDocument':
				var docType = msg.a;
				switch (docType.$) {
					case 'Received':
						return _Utils_Tuple2(
							_Utils_update(
								listDocModel,
								{searchQuery: '', selectedType: docType, status: $author$project$Type$ListDocument$Loading}),
							A2(
								$elm$core$Task$attempt,
								A2($author$project$Type$ListDocument$ListReceivedDocuments, 0, true),
								A5($author$project$Data$Api$ListDocument$authCall, user.jwt, apiEndPoint.listReceived, 0, searchQuery, domain)));
					case 'Sent':
						return _Utils_Tuple2(
							_Utils_update(
								listDocModel,
								{searchQuery: '', selectedType: docType, status: $author$project$Type$ListDocument$Loading}),
							A2(
								$elm$core$Task$attempt,
								A2($author$project$Type$ListDocument$ListSentDocuments, 0, true),
								A5($author$project$Data$Api$ListDocument$authCall, user.jwt, apiEndPoint.listSent, 0, searchQuery, domain)));
					case 'Completed':
						return _Utils_Tuple2(
							_Utils_update(
								listDocModel,
								{searchQuery: '', selectedType: docType, status: $author$project$Type$ListDocument$Loading}),
							A2(
								$elm$core$Task$attempt,
								A2($author$project$Type$ListDocument$ListCompletedDocuments, 0, true),
								A5($author$project$Data$Api$ListDocument$authCall, user.jwt, apiEndPoint.listCompleted, 0, searchQuery, domain)));
					case 'Template':
						return _Utils_Tuple2(
							_Utils_update(
								listDocModel,
								{searchQuery: '', selectedType: docType, status: $author$project$Type$ListDocument$Loading}),
							A2(
								$elm$core$Task$attempt,
								$author$project$Type$ListDocument$ListTemplate(0),
								A5(
									$author$project$Data$Api$ListTemplate$authCall,
									user.jwt,
									apiEndPoint.listAllTemplate,
									0,
									searchQuery,
									$author$project$Data$Domain$selected(user.domains))));
					default:
						return _Utils_Tuple2(
							_Utils_update(
								listDocModel,
								{selectedType: docType, status: $author$project$Type$ListDocument$Loading}),
							A2(
								$elm$core$Task$attempt,
								$author$project$Type$ListDocument$ListSubmission(0),
								A4(
									$author$project$Data$Api$ListSubmission$authCall,
									user.jwt,
									apiEndPoint.listSubmission,
									0,
									$author$project$Data$Domain$toString(
										$author$project$Data$Domain$selected(user.domains)))));
				}
			case 'OnTypeChange':
				var docType = msg.a;
				return _Utils_Tuple2(
					listDocModel,
					A2(
						$elm$browser$Browser$Navigation$pushUrl,
						model.navKey,
						$author$project$Type$ListDocument$docTypeToString(docType)));
			case 'OnDocumentClick':
				var docId = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						listDocModel,
						{searchQuery: ''}),
					A2(
						$elm$browser$Browser$Navigation$pushUrl,
						model.navKey,
						_Utils_ap($author$project$Data$Route$routeUrl.viewDocument, docId)));
			case 'ListSentDocuments':
				var newPageNumber = msg.a;
				var toLoadAds = msg.b;
				var payload = msg.c;
				if (payload.$ === 'Ok') {
					var result = payload.a;
					return _Utils_Tuple2(
						_Utils_update(
							listDocModel,
							{
								docsCount: result.documentCount,
								pageNumber: newPageNumber,
								sent: $elm$core$List$reverse(
									A2(
										$elm$core$List$sortBy,
										function (document) {
											return $elm$time$Time$posixToMillis(document.createdAt);
										},
										result.listDocument)),
								status: $author$project$Type$ListDocument$Loaded
							}),
						toLoadAds ? $author$project$Model$ListDocument$displayDocumentListingAdsContent(
							$elm$json$Json$Encode$bool(authModel.user.showAds)) : $elm$core$Platform$Cmd$none);
				} else {
					return _Utils_Tuple2(listDocModel, $elm$core$Platform$Cmd$none);
				}
			case 'ListReceivedDocuments':
				var newPageNumber = msg.a;
				var toLoadAds = msg.b;
				var payload = msg.c;
				if (payload.$ === 'Ok') {
					var result = payload.a;
					return _Utils_Tuple2(
						_Utils_update(
							listDocModel,
							{
								docsCount: result.documentCount,
								pageNumber: newPageNumber,
								received: $elm$core$List$reverse(
									A2(
										$elm$core$List$sortBy,
										function (document) {
											return $elm$time$Time$posixToMillis(document.createdAt);
										},
										result.listDocument)),
								status: $author$project$Type$ListDocument$Loaded
							}),
						toLoadAds ? $author$project$Model$ListDocument$displayDocumentListingAdsContent(
							$elm$json$Json$Encode$bool(authModel.user.showAds)) : $elm$core$Platform$Cmd$none);
				} else {
					return _Utils_Tuple2(listDocModel, $elm$core$Platform$Cmd$none);
				}
			case 'ListCompletedDocuments':
				var newPageNumber = msg.a;
				var toLoadAds = msg.b;
				var payload = msg.c;
				if (payload.$ === 'Ok') {
					var result = payload.a;
					return _Utils_Tuple2(
						_Utils_update(
							listDocModel,
							{
								completed: $elm$core$List$reverse(
									A2(
										$elm$core$List$sortBy,
										function (document) {
											return $elm$time$Time$posixToMillis(document.updatedAt);
										},
										result.listDocument)),
								docsCount: result.documentCount,
								pageNumber: newPageNumber,
								status: $author$project$Type$ListDocument$Loaded
							}),
						toLoadAds ? $author$project$Model$ListDocument$displayDocumentListingAdsContent(
							$elm$json$Json$Encode$bool(authModel.user.showAds)) : $elm$core$Platform$Cmd$none);
				} else {
					return _Utils_Tuple2(listDocModel, $elm$core$Platform$Cmd$none);
				}
			case 'ListTemplate':
				var newPageNumber = msg.a;
				var payload = msg.b;
				if (payload.$ === 'Ok') {
					var result = payload.a;
					return _Utils_Tuple2(
						_Utils_update(
							listDocModel,
							{
								docsCount: result.templateCount,
								pageNumber: newPageNumber,
								status: $author$project$Type$ListDocument$Loaded,
								template: $elm$core$List$reverse(
									A2(
										$elm$core$List$sortBy,
										function (template) {
											return $elm$time$Time$posixToMillis(template.updatedAt);
										},
										$author$project$Model$ListDocument$toTemplateDetails(result)))
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					return _Utils_Tuple2(listDocModel, $elm$core$Platform$Cmd$none);
				}
			case 'ListSubmission':
				var newPageNumber = msg.a;
				var payload = msg.b;
				if (payload.$ === 'Ok') {
					var result = payload.a;
					var submissions = $elm$core$List$reverse(
						A2(
							$elm$core$List$sortBy,
							function (submission) {
								return $elm$time$Time$posixToMillis(submission.createdAt);
							},
							A2(
								$elm$core$List$map,
								function (submission) {
									return {createdAt: submission.createdAt, domain: submission.domain, email: submission.email, firstName: submission.firstName, id: submission.id, lastName: submission.lastName, ownerId: submission.ownerId, templateId: submission.templateId, title: submission.title};
								},
								result.submissions)));
					return _Utils_Tuple2(
						_Utils_update(
							listDocModel,
							{docsCount: result.allSubmissionsCount, pageNumber: newPageNumber, status: $author$project$Type$ListDocument$Loaded, submission: submissions}),
						$elm$core$Platform$Cmd$none);
				} else {
					return _Utils_Tuple2(listDocModel, $elm$core$Platform$Cmd$none);
				}
			case 'OnTemplateClick':
				var slug = msg.a;
				return _Utils_Tuple2(
					listDocModel,
					A2($elm$browser$Browser$Navigation$pushUrl, model.navKey, $author$project$Data$Route$routeUrl.fillTemplate + ('/' + slug)));
			case 'OnDashboardEnter':
				var documentType = msg.a;
				return _Utils_Tuple2(
					listDocModel,
					A2(
						$elm$core$Task$perform,
						$author$project$Type$ListDocument$OnTypeChange,
						$elm$core$Task$succeed(documentType)));
			case 'OnSubmissionClick':
				var docId = msg.a;
				return _Utils_Tuple2(
					listDocModel,
					A2(
						$elm$browser$Browser$Navigation$pushUrl,
						model.navKey,
						_Utils_ap($author$project$Data$Route$routeUrl.viewDocument, docId)));
			case 'CloseSnackBar':
				return _Utils_Tuple2(
					_Utils_update(
						listDocModel,
						{modal: $elm$core$Maybe$Nothing, snackBar: $author$project$Material$Styled$Snackbar$Hide}),
					$elm$core$Platform$Cmd$none);
			case 'OnSearchQueryChange':
				var query = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						listDocModel,
						{searchQuery: query}),
					$elm$core$Platform$Cmd$none);
			case 'OnSearchDateChange':
				var searchDate = msg.a;
				if (searchDate.$ === 'FromDate') {
					var date = searchDate.a;
					return _Utils_Tuple2(
						_Utils_update(
							listDocModel,
							{searchFromDate: date}),
						$elm$core$Platform$Cmd$none);
				} else {
					var date = searchDate.a;
					return _Utils_Tuple2(
						_Utils_update(
							listDocModel,
							{searchToDate: date}),
						$elm$core$Platform$Cmd$none);
				}
			case 'ResetDateSearch':
				return _Utils_Tuple2(
					_Utils_update(
						listDocModel,
						{searchFromDate: '', searchToDate: ''}),
					$elm$core$Platform$Cmd$none);
			case 'OnErrorClose':
				return _Utils_Tuple2(
					_Utils_update(
						listDocModel,
						{banner: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none);
			case 'OnDeleteDocument':
				var docId = msg.a;
				return _Utils_Tuple2(
					listDocModel,
					A2(
						$elm$core$Task$attempt,
						$author$project$Type$ListDocument$OnDeleteDocumentResult,
						A3($author$project$Data$Api$PDF$Delete$authCall, user.jwt, apiEndPoint.deleteDocument, docId)));
			case 'OnDeleteDocumentResult':
				var result = msg.a;
				if (result.$ === 'Ok') {
					return _Utils_Tuple2(
						_Utils_update(
							listDocModel,
							{
								modal: $elm$core$Maybe$Just($author$project$Type$ListDocument$DeleteSuccess)
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							listDocModel,
							{
								banner: $elm$core$Maybe$Just(
									$author$project$Type$ListDocument$Error(
										$author$project$Type$ListDocument$DeleteDocumentError(
											A2($author$project$Data$Api$authErrorToString, $author$project$Data$Api$PDF$Delete$errorToString, error)))),
								modal: $elm$core$Maybe$Nothing
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 'OnShowModal':
				var modal = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						listDocModel,
						{
							modal: $elm$core$Maybe$Just(modal)
						}),
					$elm$core$Platform$Cmd$none);
			case 'OnCloseModal':
				return _Utils_Tuple2(
					_Utils_update(
						listDocModel,
						{modal: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none);
			case 'OnNavigateToDashboard':
				return _Utils_Tuple2(
					_Utils_update(
						listDocModel,
						{modal: $elm$core$Maybe$Nothing}),
					A2($elm$browser$Browser$Navigation$pushUrl, model.navKey, $author$project$Data$Route$routeUrl.dashboard));
			case 'OnDeleteTemplate':
				var templateId = msg.a;
				return _Utils_Tuple2(
					listDocModel,
					A2(
						$elm$core$Task$attempt,
						$author$project$Type$ListDocument$OnDeleteTemplateResult,
						A4(
							$author$project$Data$Api$PDF$DeleteTemplate$authCall,
							user.jwt,
							apiEndPoint.deleteTemplate,
							templateId,
							$author$project$Data$Domain$selected(user.domains))));
			case 'OnDeleteTemplateResult':
				var result = msg.a;
				if (result.$ === 'Ok') {
					return _Utils_Tuple2(
						_Utils_update(
							listDocModel,
							{
								modal: $elm$core$Maybe$Just($author$project$Type$ListDocument$DeleteTemplateSuccess)
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							listDocModel,
							{
								banner: $elm$core$Maybe$Just(
									$author$project$Type$ListDocument$Error(
										$author$project$Type$ListDocument$DeleteTemplateError(
											A2($author$project$Data$Api$authErrorToString, $author$project$Data$Api$PDF$DeleteTemplate$errorToString, error)))),
								modal: $elm$core$Maybe$Nothing
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 'OnRequestTemplateClick':
				var slug = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						listDocModel,
						{
							modal: $elm$core$Maybe$Just($author$project$Type$ListDocument$LoadingState)
						}),
					A2(
						$elm$core$Task$attempt,
						$author$project$Type$ListDocument$OnRequestTemplateResult,
						A2(
							$author$project$Data$Api$PDF$IssueAnonymous$call,
							apiEndPoint.issueAnonymousTemplateToken,
							{email: user.email, slug: slug})));
			case 'OnRequestTemplateResult':
				var result = msg.a;
				if (result.$ === 'Ok') {
					return _Utils_Tuple2(
						_Utils_update(
							listDocModel,
							{
								modal: $elm$core$Maybe$Just($author$project$Type$ListDocument$RequestTemplateSuccess)
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							listDocModel,
							{
								banner: $elm$core$Maybe$Just(
									$author$project$Type$ListDocument$Error(
										$author$project$Type$ListDocument$DeleteTemplateError(
											A2($author$project$Data$Api$errorToString, $author$project$Data$Api$PDF$IssueAnonymous$errorToString, error)))),
								modal: $elm$core$Maybe$Nothing
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 'OnNextPage':
				var documentType = msg.a;
				var notEndOfPage = _Utils_cmp(
					$elm$core$Basics$ceiling(listDocModel.docsCount / 10.0),
					listDocModel.pageNumber + 1) > 0;
				switch (documentType.$) {
					case 'Received':
						return notEndOfPage ? _Utils_Tuple2(
							listDocModel,
							A2(
								$elm$core$Task$attempt,
								A2($author$project$Type$ListDocument$ListReceivedDocuments, listDocModel.pageNumber + 1, false),
								A5($author$project$Data$Api$ListDocument$authCall, user.jwt, apiEndPoint.listReceived, listDocModel.pageNumber + 1, searchQuery, domain))) : _Utils_Tuple2(listDocModel, $elm$core$Platform$Cmd$none);
					case 'Sent':
						return notEndOfPage ? _Utils_Tuple2(
							listDocModel,
							A2(
								$elm$core$Task$attempt,
								A2($author$project$Type$ListDocument$ListSentDocuments, listDocModel.pageNumber + 1, false),
								A5($author$project$Data$Api$ListDocument$authCall, user.jwt, apiEndPoint.listSent, listDocModel.pageNumber + 1, searchQuery, domain))) : _Utils_Tuple2(listDocModel, $elm$core$Platform$Cmd$none);
					case 'Completed':
						return notEndOfPage ? _Utils_Tuple2(
							listDocModel,
							A2(
								$elm$core$Task$attempt,
								A2($author$project$Type$ListDocument$ListCompletedDocuments, listDocModel.pageNumber + 1, false),
								A5($author$project$Data$Api$ListDocument$authCall, user.jwt, apiEndPoint.listCompleted, listDocModel.pageNumber + 1, searchQuery, domain))) : _Utils_Tuple2(listDocModel, $elm$core$Platform$Cmd$none);
					case 'Template':
						return notEndOfPage ? _Utils_Tuple2(
							listDocModel,
							A2(
								$elm$core$Task$attempt,
								$author$project$Type$ListDocument$ListTemplate(listDocModel.pageNumber + 1),
								A5(
									$author$project$Data$Api$ListTemplate$authCall,
									user.jwt,
									apiEndPoint.listAllTemplate,
									listDocModel.pageNumber + 1,
									searchQuery,
									$author$project$Data$Domain$selected(user.domains)))) : _Utils_Tuple2(listDocModel, $elm$core$Platform$Cmd$none);
					default:
						return notEndOfPage ? _Utils_Tuple2(
							listDocModel,
							A2(
								$elm$core$Task$attempt,
								$author$project$Type$ListDocument$ListSubmission(listDocModel.pageNumber + 1),
								A4(
									$author$project$Data$Api$ListSubmission$authCall,
									user.jwt,
									apiEndPoint.listSubmission,
									listDocModel.pageNumber + 1,
									$author$project$Data$Domain$toString(
										$author$project$Data$Domain$selected(user.domains))))) : _Utils_Tuple2(listDocModel, $elm$core$Platform$Cmd$none);
				}
			case 'OnPreviousPage':
				var documentType = msg.a;
				var onFirstPage = !listDocModel.pageNumber;
				switch (documentType.$) {
					case 'Received':
						return onFirstPage ? _Utils_Tuple2(listDocModel, $elm$core$Platform$Cmd$none) : _Utils_Tuple2(
							listDocModel,
							A2(
								$elm$core$Task$attempt,
								A2($author$project$Type$ListDocument$ListReceivedDocuments, listDocModel.pageNumber - 1, false),
								A5($author$project$Data$Api$ListDocument$authCall, user.jwt, apiEndPoint.listReceived, listDocModel.pageNumber - 1, searchQuery, domain)));
					case 'Sent':
						return onFirstPage ? _Utils_Tuple2(listDocModel, $elm$core$Platform$Cmd$none) : _Utils_Tuple2(
							listDocModel,
							A2(
								$elm$core$Task$attempt,
								A2($author$project$Type$ListDocument$ListSentDocuments, listDocModel.pageNumber - 1, false),
								A5($author$project$Data$Api$ListDocument$authCall, user.jwt, apiEndPoint.listSent, listDocModel.pageNumber - 1, searchQuery, domain)));
					case 'Completed':
						return onFirstPage ? _Utils_Tuple2(listDocModel, $elm$core$Platform$Cmd$none) : _Utils_Tuple2(
							listDocModel,
							A2(
								$elm$core$Task$attempt,
								A2($author$project$Type$ListDocument$ListCompletedDocuments, listDocModel.pageNumber - 1, false),
								A5($author$project$Data$Api$ListDocument$authCall, user.jwt, apiEndPoint.listCompleted, listDocModel.pageNumber - 1, searchQuery, domain)));
					case 'Template':
						return onFirstPage ? _Utils_Tuple2(listDocModel, $elm$core$Platform$Cmd$none) : _Utils_Tuple2(
							listDocModel,
							A2(
								$elm$core$Task$attempt,
								$author$project$Type$ListDocument$ListTemplate(listDocModel.pageNumber - 1),
								A5(
									$author$project$Data$Api$ListTemplate$authCall,
									user.jwt,
									apiEndPoint.listAllTemplate,
									listDocModel.pageNumber - 1,
									searchQuery,
									$author$project$Data$Domain$selected(user.domains))));
					default:
						return onFirstPage ? _Utils_Tuple2(listDocModel, $elm$core$Platform$Cmd$none) : _Utils_Tuple2(
							listDocModel,
							A2(
								$elm$core$Task$attempt,
								$author$project$Type$ListDocument$ListSubmission(listDocModel.pageNumber - 1),
								A4(
									$author$project$Data$Api$ListSubmission$authCall,
									user.jwt,
									apiEndPoint.listSubmission,
									listDocModel.pageNumber - 1,
									$author$project$Data$Domain$toString(
										$author$project$Data$Domain$selected(user.domains)))));
				}
			case 'OnSearchDocument':
				var documentType = msg.a;
				switch (documentType.$) {
					case 'Completed':
						return _Utils_Tuple2(
							listDocModel,
							A2(
								$elm$core$Task$attempt,
								A2($author$project$Type$ListDocument$ListCompletedDocuments, 0, true),
								A5($author$project$Data$Api$ListDocument$authCall, user.jwt, apiEndPoint.listCompleted, 0, searchQuery, domain)));
					case 'Sent':
						return _Utils_Tuple2(
							listDocModel,
							A2(
								$elm$core$Task$attempt,
								A2($author$project$Type$ListDocument$ListSentDocuments, 0, true),
								A5($author$project$Data$Api$ListDocument$authCall, user.jwt, apiEndPoint.listSent, 0, searchQuery, domain)));
					case 'Received':
						return _Utils_Tuple2(
							listDocModel,
							A2(
								$elm$core$Task$attempt,
								A2($author$project$Type$ListDocument$ListReceivedDocuments, 0, true),
								A5($author$project$Data$Api$ListDocument$authCall, user.jwt, apiEndPoint.listReceived, 0, searchQuery, domain)));
					case 'Template':
						return _Utils_Tuple2(
							listDocModel,
							A2(
								$elm$core$Task$attempt,
								$author$project$Type$ListDocument$ListTemplate(0),
								A5(
									$author$project$Data$Api$ListTemplate$authCall,
									user.jwt,
									apiEndPoint.listAllTemplate,
									0,
									searchQuery,
									$author$project$Data$Domain$selected(user.domains))));
					default:
						return _Utils_Tuple2(
							listDocModel,
							A2(
								$elm$core$Task$attempt,
								$author$project$Type$ListDocument$ListSubmission(listDocModel.pageNumber),
								A4(
									$author$project$Data$Api$ListSubmission$authCall,
									user.jwt,
									apiEndPoint.listSubmission,
									listDocModel.pageNumber,
									$author$project$Data$Domain$toString(
										$author$project$Data$Domain$selected(user.domains)))));
				}
			default:
				var documentType = msg.a;
				switch (documentType.$) {
					case 'Completed':
						return _Utils_Tuple2(
							_Utils_update(
								listDocModel,
								{searchQuery: ''}),
							A2(
								$elm$core$Task$attempt,
								A2($author$project$Type$ListDocument$ListCompletedDocuments, 0, true),
								A5($author$project$Data$Api$ListDocument$authCall, user.jwt, apiEndPoint.listCompleted, 0, '', domain)));
					case 'Sent':
						return _Utils_Tuple2(
							_Utils_update(
								listDocModel,
								{searchQuery: ''}),
							A2(
								$elm$core$Task$attempt,
								A2($author$project$Type$ListDocument$ListSentDocuments, 0, true),
								A5($author$project$Data$Api$ListDocument$authCall, user.jwt, apiEndPoint.listSent, 0, '', domain)));
					case 'Received':
						return _Utils_Tuple2(
							_Utils_update(
								listDocModel,
								{searchQuery: ''}),
							A2(
								$elm$core$Task$attempt,
								A2($author$project$Type$ListDocument$ListReceivedDocuments, 0, true),
								A5($author$project$Data$Api$ListDocument$authCall, user.jwt, apiEndPoint.listReceived, 0, '', domain)));
					case 'Template':
						return _Utils_Tuple2(
							_Utils_update(
								listDocModel,
								{searchQuery: ''}),
							A2(
								$elm$core$Task$attempt,
								$author$project$Type$ListDocument$ListTemplate(0),
								A5(
									$author$project$Data$Api$ListTemplate$authCall,
									user.jwt,
									apiEndPoint.listAllTemplate,
									0,
									'',
									$author$project$Data$Domain$selected(user.domains))));
					default:
						return _Utils_Tuple2(
							_Utils_update(
								listDocModel,
								{searchQuery: ''}),
							A2(
								$elm$core$Task$attempt,
								$author$project$Type$ListDocument$ListSubmission(listDocModel.pageNumber),
								A4(
									$author$project$Data$Api$ListSubmission$authCall,
									user.jwt,
									apiEndPoint.listSubmission,
									listDocModel.pageNumber,
									$author$project$Data$Domain$toString(
										$author$project$Data$Domain$selected(user.domains)))));
				}
		}
	});
var $author$project$Model$ListDocument$update = F3(
	function (msg, authModel, model) {
		var _v0 = A4($author$project$Model$ListDocument$updateList, msg, authModel.listDocModel, authModel, model);
		var listDocModel = _v0.a;
		var listDocCmd = _v0.b;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					sessionModel: $author$project$Types$Auth(
						_Utils_update(
							authModel,
							{listDocModel: listDocModel}))
				}),
			A2(
				$elm$core$Platform$Cmd$map,
				A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnListDoc),
				listDocCmd));
	});
var $author$project$Type$ListTemplateDashboard$ListTemplate = {$: 'ListTemplate'};
var $author$project$Type$ListTemplateDashboard$ListTemplateResult = F2(
	function (a, b) {
		return {$: 'ListTemplateResult', a: a, b: b};
	});
var $author$project$Type$ListTemplateDashboard$Loading = function (a) {
	return {$: 'Loading', a: a};
};
var $author$project$Types$OnListTemplateDashBoard = function (a) {
	return {$: 'OnListTemplateDashBoard', a: a};
};
var $author$project$Type$ListTemplateDashboard$OnRequestTemplateResult = function (a) {
	return {$: 'OnRequestTemplateResult', a: a};
};
var $author$project$Type$ListTemplateDashboard$RequestTemplateSuccess = function (a) {
	return {$: 'RequestTemplateSuccess', a: a};
};
var $author$project$Type$ListTemplateDashboard$RequestingTemplate = {$: 'RequestingTemplate'};
var $author$project$Type$ListTemplateDashboard$Templates = {$: 'Templates'};
var $author$project$Model$ListTemplateDashboard$update = F3(
	function (msg, authModel, model) {
		var updateModel = function (newModel) {
			return _Utils_update(
				model,
				{
					sessionModel: $author$project$Types$Auth(
						_Utils_update(
							authModel,
							{listTemplateDashboardModel: newModel}))
				});
		};
		var listTemplateDashboardModel = authModel.listTemplateDashboardModel;
		var _v0 = authModel;
		var user = _v0.user;
		var _v1 = model;
		var apiEndPoint = _v1.apiEndPoint;
		switch (msg.$) {
			case 'OnListTemplateClick':
				return _Utils_Tuple2(
					updateModel(
						_Utils_update(
							listTemplateDashboardModel,
							{
								modal: $elm$core$Maybe$Just(
									$author$project$Type$ListTemplateDashboard$Loading($author$project$Type$ListTemplateDashboard$ListTemplate))
							})),
					A2(
						$elm$core$Task$attempt,
						A2(
							$elm$core$Basics$composeL,
							A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnListTemplateDashBoard),
							$author$project$Type$ListTemplateDashboard$ListTemplateResult(0)),
						A5(
							$author$project$Data$Api$ListTemplate$authCall,
							user.jwt,
							apiEndPoint.listAllTemplate,
							0,
							'',
							$author$project$Data$Domain$selected(user.domains))));
			case 'ListTemplateResult':
				var newPageNumber = msg.a;
				var payload = msg.b;
				if (payload.$ === 'Ok') {
					var result = payload.a;
					return _Utils_Tuple2(
						updateModel(
							_Utils_update(
								listTemplateDashboardModel,
								{
									modal: $elm$core$Maybe$Just($author$project$Type$ListTemplateDashboard$Templates),
									pageNumber: newPageNumber,
									templateCount: result.templateCount,
									templates: $elm$core$List$reverse(
										A2(
											$elm$core$List$sortBy,
											function (document) {
												return $elm$time$Time$posixToMillis(document.updatedAt);
											},
											result.templates))
								})),
						$elm$core$Platform$Cmd$none);
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 'OnCloseModal':
				return _Utils_Tuple2(
					updateModel(
						_Utils_update(
							listTemplateDashboardModel,
							{modal: $elm$core$Maybe$Nothing})),
					$elm$core$Platform$Cmd$none);
			case 'OnShowModal':
				var newModal = msg.a;
				return _Utils_Tuple2(
					updateModel(
						_Utils_update(
							listTemplateDashboardModel,
							{
								modal: $elm$core$Maybe$Just(newModal)
							})),
					$elm$core$Platform$Cmd$none);
			case 'OnRequestTemplateClick':
				var slug = msg.a;
				return _Utils_Tuple2(
					updateModel(
						_Utils_update(
							listTemplateDashboardModel,
							{
								modal: $elm$core$Maybe$Just(
									$author$project$Type$ListTemplateDashboard$Loading($author$project$Type$ListTemplateDashboard$RequestingTemplate))
							})),
					A2(
						$elm$core$Task$attempt,
						A2(
							$elm$core$Basics$composeL,
							A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnListTemplateDashBoard),
							$author$project$Type$ListTemplateDashboard$OnRequestTemplateResult),
						A2(
							$author$project$Data$Api$PDF$IssueAnonymous$call,
							apiEndPoint.issueAnonymousTemplateToken,
							{email: user.email, slug: slug})));
			case 'OnRequestTemplateResult':
				var payload = msg.a;
				if (payload.$ === 'Ok') {
					var value = payload.a;
					return _Utils_Tuple2(
						updateModel(
							_Utils_update(
								listTemplateDashboardModel,
								{
									modal: $elm$core$Maybe$Just(
										$author$project$Type$ListTemplateDashboard$RequestTemplateSuccess(value.docId))
								})),
						$elm$core$Platform$Cmd$none);
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 'OnNavigateToDashboard':
				return _Utils_Tuple2(
					updateModel(
						_Utils_update(
							listTemplateDashboardModel,
							{modal: $elm$core$Maybe$Nothing})),
					A2($elm$browser$Browser$Navigation$pushUrl, model.navKey, $author$project$Data$Route$routeUrl.dashboard));
			case 'OnNavigateToDocument':
				var docId = msg.a;
				return _Utils_Tuple2(
					updateModel(
						_Utils_update(
							listTemplateDashboardModel,
							{modal: $elm$core$Maybe$Nothing})),
					A2(
						$elm$browser$Browser$Navigation$pushUrl,
						model.navKey,
						_Utils_ap($author$project$Data$Route$routeUrl.viewDocument, docId)));
			case 'OnNextPage':
				var notEndOfPage = _Utils_cmp(
					$elm$core$Basics$ceiling(listTemplateDashboardModel.templateCount / 10.0),
					listTemplateDashboardModel.pageNumber + 1) > 0;
				return notEndOfPage ? _Utils_Tuple2(
					model,
					A2(
						$elm$core$Task$attempt,
						A2(
							$elm$core$Basics$composeL,
							A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnListTemplateDashBoard),
							$author$project$Type$ListTemplateDashboard$ListTemplateResult(listTemplateDashboardModel.pageNumber + 1)),
						A5(
							$author$project$Data$Api$ListTemplate$authCall,
							user.jwt,
							apiEndPoint.listAllTemplate,
							listTemplateDashboardModel.pageNumber + 1,
							'',
							$author$project$Data$Domain$selected(user.domains)))) : _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			default:
				var onFirstPage = !listTemplateDashboardModel.pageNumber;
				return onFirstPage ? _Utils_Tuple2(model, $elm$core$Platform$Cmd$none) : _Utils_Tuple2(
					model,
					A2(
						$elm$core$Task$attempt,
						A2(
							$elm$core$Basics$composeL,
							A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnListTemplateDashBoard),
							$author$project$Type$ListTemplateDashboard$ListTemplateResult(listTemplateDashboardModel.pageNumber - 1)),
						A5(
							$author$project$Data$Api$ListTemplate$authCall,
							user.jwt,
							apiEndPoint.listAllTemplate,
							listTemplateDashboardModel.pageNumber - 1,
							'',
							$author$project$Data$Domain$selected(user.domains))));
		}
	});
var $author$project$Type$Login$Error = function (a) {
	return {$: 'Error', a: a};
};
var $author$project$Type$Login$LoginResponse = function (a) {
	return {$: 'LoginResponse', a: a};
};
var $author$project$Type$Login$Submitting = {$: 'Submitting'};
var $author$project$Data$Api$Login$Payload = function (user) {
	return {user: user};
};
var $author$project$Data$Api$Login$dataDecoder = A2(
	$elm$json$Json$Decode$map,
	$author$project$Data$Api$Login$Payload,
	A2(
		$elm$json$Json$Decode$andThen,
		function (jwt) {
			return A2(
				$elm$json$Json$Decode$field,
				'user',
				$author$project$Data$User$decoderWithJwt(jwt));
		},
		A2($elm$json$Json$Decode$field, 'jwt', $elm$json$Json$Decode$string)));
var $author$project$Data$Api$Login$encode = F2(
	function (email, password) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'email',
					$elm$json$Json$Encode$string(email)),
					_Utils_Tuple2(
					'password',
					$elm$json$Json$Encode$string(password))
				]));
	});
var $author$project$Data$Api$Login$USER_NOT_ACTIVATED = {$: 'USER_NOT_ACTIVATED'};
var $author$project$Data$Api$Login$USER_NOT_FOUND = {$: 'USER_NOT_FOUND'};
var $author$project$Data$Api$Login$errorDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (errorCode) {
		switch (errorCode) {
			case 'USER_NOT_FOUND':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$Login$USER_NOT_FOUND);
			case 'USER_NOT_ACTIVATED':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$Login$USER_NOT_ACTIVATED);
			default:
				return $elm$json$Json$Decode$fail('Invalid error code: ' + errorCode);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Data$Api$Login$call = F3(
	function (endPoint, email, password) {
		return A4(
			$author$project$Data$Api$httpTask,
			endPoint,
			$author$project$Data$Api$Login$errorDecoder,
			$author$project$Data$Api$Login$dataDecoder,
			A2($author$project$Data$Api$Login$encode, email, password));
	});
var $author$project$Model$Login$validatePassword = function (value) {
	return $elm$core$String$isEmpty(value) ? $elm$core$Maybe$Just('Password cannot be empty.') : $elm$core$Maybe$Nothing;
};
var $author$project$Model$Login$update = F3(
	function (initAuthModel, msg, model) {
		var _v0 = model;
		var apiEndPoint = _v0.apiEndPoint;
		var loginModel = _v0.loginModel;
		var route = _v0.route;
		var _v1 = loginModel;
		var email = _v1.email;
		var password = _v1.password;
		switch (msg.$) {
			case 'AddRedirectPath':
				var path = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							loginModel: _Utils_update(
								loginModel,
								{
									redirect: $elm$core$Maybe$Just(path)
								})
						}),
					$elm$core$Platform$Cmd$none);
			case 'OnInput':
				var field = msg.a;
				var value = msg.b;
				if (field.$ === 'Email') {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								loginModel: _Utils_update(
									loginModel,
									{email: value, emailError: $elm$core$Maybe$Nothing, formStatus: $author$project$Type$Login$Ready})
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								loginModel: _Utils_update(
									loginModel,
									{formStatus: $author$project$Type$Login$Ready, password: value, passwordError: $elm$core$Maybe$Nothing})
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 'OnBlur':
				var field = msg.a;
				if (field.$ === 'Email') {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								loginModel: _Utils_update(
									loginModel,
									{
										emailError: $author$project$Data$Validator$validateEmail(email)
									})
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								loginModel: _Utils_update(
									loginModel,
									{
										passwordError: $author$project$Model$Login$validatePassword(password)
									})
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 'OnSubmit':
				var updatedLoginModel = function (m) {
					return _Utils_update(
						m,
						{
							passwordError: $author$project$Model$Login$validatePassword(password)
						});
				}(
					_Utils_update(
						loginModel,
						{
							emailError: $author$project$Data$Validator$validateEmail(email)
						}));
				var allPassed = A2(
					$elm$core$List$all,
					$elm$core$Basics$eq($elm$core$Maybe$Nothing),
					_List_fromArray(
						[updatedLoginModel.emailError, updatedLoginModel.passwordError]));
				return allPassed ? _Utils_Tuple2(
					_Utils_update(
						model,
						{
							loginModel: _Utils_update(
								updatedLoginModel,
								{formStatus: $author$project$Type$Login$Submitting})
						}),
					A2(
						$elm$core$Platform$Cmd$map,
						$author$project$Types$OnLogin,
						A2(
							$elm$core$Task$attempt,
							$author$project$Type$Login$LoginResponse,
							A3($author$project$Data$Api$Login$call, apiEndPoint.login, email, password)))) : _Utils_Tuple2(
					_Utils_update(
						model,
						{
							loginModel: _Utils_update(
								updatedLoginModel,
								{formStatus: $author$project$Type$Login$Ready})
						}),
					$elm$core$Platform$Cmd$none);
			default:
				var result = msg.a;
				if (result.$ === 'Ok') {
					var payload = result.a;
					var newRoute = A2(
						$elm$core$Maybe$withDefault,
						function () {
							_v8$2:
							while (true) {
								switch (route.$) {
									case 'Public':
										if (route.a.$ === 'NotAuthorizedRoute') {
											var redirectRoute = route.a.a;
											return redirectRoute;
										} else {
											break _v8$2;
										}
									case 'PublicOrAuth':
										if (route.a.$ === 'RedirectRoute') {
											var redirectRoute = route.a.a;
											return redirectRoute;
										} else {
											break _v8$2;
										}
									default:
										break _v8$2;
								}
							}
							return $author$project$Data$Route$routeUrl.dashboard;
						}(),
						loginModel.redirect);
					var _v6 = payload;
					var user = _v6.user;
					var isDomainHostInUserDomain = A2(
						$elm$core$List$member,
						model.domainHost,
						$author$project$Data$Domain$all(user.domains));
					var selectedDomain = isDomainHostInUserDomain ? model.domainHost : model.appDomain;
					var _v7 = initAuthModel(
						_Utils_update(
							user,
							{
								domains: A2($author$project$Data$Domain$select, selectedDomain, user.domains)
							}));
					var authModel = _v7.a;
					var authCmdMsg = _v7.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								loginModel: _Utils_update(
									loginModel,
									{formStatus: $author$project$Type$Login$Ready, redirect: $elm$core$Maybe$Nothing}),
								sessionModel: $author$project$Types$Auth(authModel)
							}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									$author$project$Data$User$store(user),
									authCmdMsg,
									A2($elm$browser$Browser$Navigation$pushUrl, model.navKey, newRoute)
								])));
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								loginModel: _Utils_update(
									loginModel,
									{
										formStatus: $author$project$Type$Login$Error(error)
									})
							}),
						$elm$core$Platform$Cmd$none);
				}
		}
	});
var $author$project$Type$Logout$Fail = {$: 'Fail'};
var $author$project$Type$Logout$LogoutResponse = function (a) {
	return {$: 'LogoutResponse', a: a};
};
var $author$project$Types$OnLogout = function (a) {
	return {$: 'OnLogout', a: a};
};
var $author$project$Type$Logout$Submitting = {$: 'Submitting'};
var $author$project$Data$Api$Logout$dataDecoder = $elm$json$Json$Decode$succeed(_Utils_Tuple0);
var $author$project$Data$Api$Logout$errorDecoder = $elm$json$Json$Decode$succeed(_Utils_Tuple0);
var $author$project$Data$Api$Logout$authCall = F2(
	function (jwt, endPoint) {
		return A5(
			$author$project$Data$Api$authCall,
			jwt,
			endPoint,
			$author$project$Data$Api$Logout$errorDecoder,
			$author$project$Data$Api$Logout$dataDecoder,
			$elm$json$Json$Encode$object(_List_Nil));
	});
var $author$project$Model$Logout$logout = function (model) {
	return _Utils_Tuple2(
		_Utils_update(
			model,
			{sessionModel: $author$project$Types$NoAuth}),
		$elm$core$Platform$Cmd$batch(
			_List_fromArray(
				[
					$author$project$Data$User$delete(_Utils_Tuple0),
					A2($elm$browser$Browser$Navigation$pushUrl, model.navKey, $author$project$Data$Route$routeUrl.login)
				])));
};
var $author$project$Model$Logout$update = F3(
	function (msg, authModel, model) {
		if (msg.$ === 'Logout') {
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						sessionModel: $author$project$Types$Auth(
							_Utils_update(
								authModel,
								{logout: $author$project$Type$Logout$Submitting}))
					}),
				$elm$core$Platform$Cmd$batch(
					_List_fromArray(
						[
							A2(
							$elm$core$Task$attempt,
							A2(
								$elm$core$Basics$composeL,
								A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnLogout),
								$author$project$Type$Logout$LogoutResponse),
							A2($author$project$Data$Api$Logout$authCall, authModel.user.jwt, model.apiEndPoint.logout)),
							A2($elm$browser$Browser$Navigation$pushUrl, model.navKey, $author$project$Data$Route$routeUrl.logout),
							$author$project$Data$SSE$close(_Utils_Tuple0)
						])));
		} else {
			var result = msg.a;
			if (result.$ === 'Ok') {
				return $author$project$Model$Logout$logout(model);
			} else {
				var error = result.a;
				_v2$2:
				while (true) {
					if (error.$ === 'ApiError') {
						switch (error.a.$) {
							case 'Timeout':
								var _v3 = error.a;
								return _Utils_Tuple2(
									_Utils_update(
										model,
										{
											sessionModel: $author$project$Types$Auth(
												_Utils_update(
													authModel,
													{logout: $author$project$Type$Logout$Fail}))
										}),
									$elm$core$Platform$Cmd$none);
							case 'NetworkError':
								var _v4 = error.a;
								return _Utils_Tuple2(
									_Utils_update(
										model,
										{
											sessionModel: $author$project$Types$Auth(
												_Utils_update(
													authModel,
													{logout: $author$project$Type$Logout$Fail}))
										}),
									$elm$core$Platform$Cmd$none);
							default:
								break _v2$2;
						}
					} else {
						break _v2$2;
					}
				}
				return $author$project$Model$Logout$logout(model);
			}
		}
	});
var $author$project$Type$NewDocument$GotFiles = F2(
	function (a, b) {
		return {$: 'GotFiles', a: a, b: b};
	});
var $author$project$Type$NewDocument$OnAddFile = F3(
	function (a, b, c) {
		return {$: 'OnAddFile', a: a, b: b, c: c};
	});
var $author$project$Types$OnNewDoc = function (a) {
	return {$: 'OnNewDoc', a: a};
};
var $author$project$Type$NewDocument$OnSubmitDoc = {$: 'OnSubmitDoc'};
var $author$project$Type$NewDocument$OnSubmitDocResult = function (a) {
	return {$: 'OnSubmitDocResult', a: a};
};
var $author$project$Type$File$WrongFormat = {$: 'WrongFormat'};
var $author$project$Data$Api$PDF$NotarisationPoints$Payload = F3(
	function (signPointsBalance, binanceNotarisationCost, algorandNotarisationCost) {
		return {algorandNotarisationCost: algorandNotarisationCost, binanceNotarisationCost: binanceNotarisationCost, signPointsBalance: signPointsBalance};
	});
var $author$project$Data$Api$PDF$NotarisationPoints$dataDecoder = A4(
	$elm$json$Json$Decode$map3,
	$author$project$Data$Api$PDF$NotarisationPoints$Payload,
	A2($elm$json$Json$Decode$field, 'signPointsBalance', $elm$json$Json$Decode$int),
	A2($elm$json$Json$Decode$field, 'binanceNotarisationCost', $elm$json$Json$Decode$int),
	A2($elm$json$Json$Decode$field, 'algorandNotarisationCost', $elm$json$Json$Decode$int));
var $author$project$Data$Api$PDF$NotarisationPoints$JWT_ERROR = {$: 'JWT_ERROR'};
var $author$project$Data$Api$PDF$NotarisationPoints$errorDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (_v0) {
		return $elm$json$Json$Decode$succeed($author$project$Data$Api$PDF$NotarisationPoints$JWT_ERROR);
	},
	$elm$json$Json$Decode$string);
var $author$project$Data$Api$PDF$NotarisationPoints$authCall = F2(
	function (jwt, endPoint) {
		return A5(
			$author$project$Data$Api$authCall,
			jwt,
			endPoint,
			$author$project$Data$Api$PDF$NotarisationPoints$errorDecoder,
			$author$project$Data$Api$PDF$NotarisationPoints$dataDecoder,
			$elm$json$Json$Encode$object(_List_Nil));
	});
var $author$project$Data$Api$PDF$NotarisationPoints$errorToString = function (error) {
	return 'Unauthorised user.';
};
var $elm$file$File$Select$files = F2(
	function (mimes, toMsg) {
		return A2(
			$elm$core$Task$perform,
			function (_v0) {
				var f = _v0.a;
				var fs = _v0.b;
				return A2(toMsg, f, fs);
			},
			_File_uploadOneOrMore(mimes));
	});
var $author$project$Type$UploadMultipleDocument$Closed = {$: 'Closed'};
var $author$project$Type$UploadMultipleDocument$Document = {$: 'Document'};
var $author$project$Type$UploadMultipleDocument$Loaded = function (a) {
	return {$: 'Loaded', a: a};
};
var $author$project$Type$UploadMultipleDocument$Loading = function (a) {
	return {$: 'Loading', a: a};
};
var $author$project$Data$PDF$Create$MultipleDocument = {$: 'MultipleDocument'};
var $author$project$Type$UploadMultipleDocument$NoSigningOrder = {$: 'NoSigningOrder'};
var $author$project$Type$UploadMultipleDocument$NotNotified = {$: 'NotNotified'};
var $author$project$Type$UploadMultipleDocument$Recipients = {$: 'Recipients'};
var $author$project$Type$UploadMultipleDocument$Save = {$: 'Save'};
var $author$project$Data$PDF$Create$Signer = {$: 'Signer'};
var $author$project$Type$UploadMultipleDocument$StandBy = {$: 'StandBy'};
var $author$project$Type$UploadMultipleDocument$Algorand = {$: 'Algorand'};
var $author$project$Type$UploadMultipleDocument$Binance = {$: 'Binance'};
var $author$project$Model$UploadMultipleDocument$convertStringToNetwork = function (currentUserNotarisationNetwork) {
	switch (currentUserNotarisationNetwork) {
		case 'Binance':
			return $author$project$Type$UploadMultipleDocument$Binance;
		case 'Algorand':
			return $author$project$Type$UploadMultipleDocument$Algorand;
		default:
			return $author$project$Type$UploadMultipleDocument$Binance;
	}
};
var $author$project$Model$UploadMultipleDocument$convertStringToPayment = function (currentUserPaymentMethod) {
	switch (currentUserPaymentMethod) {
		case 'systemBalance':
			return $author$project$Type$Setting$SystemBalance;
		case 'algoWallet':
			return $author$project$Type$Setting$AlgoWallet;
		case 'walletConnect':
			return $author$project$Type$Setting$WalletConnect;
		default:
			return $author$project$Type$Setting$SystemBalance;
	}
};
var $author$project$Data$PDF$Create$Viewer = {$: 'Viewer'};
var $author$project$Data$PDF$Create$createRecipient = F2(
	function (role, user) {
		return {annotations: _List_Nil, role: role, signOrder: 1, user: user};
	});
var $author$project$Data$PDF$User$info = F9(
	function (emailStr, firstName, lastName, verifyStripe, verifyPassbase, verifyMobilePhone, verifyWallet, verifyMyInfo, color) {
		return {color: color, email: emailStr, firstName: firstName, lastName: lastName, verifyMobilePhone: verifyMobilePhone, verifyMyInfo: verifyMyInfo, verifyPassbase: verifyPassbase, verifyStripe: verifyStripe, verifyWallet: verifyWallet};
	});
var $author$project$Data$PDF$User$Registered = F2(
	function (a, b) {
		return {$: 'Registered', a: a, b: b};
	});
var $author$project$Data$PDF$User$registered = F2(
	function (avatar, info_) {
		return A2($author$project$Data$PDF$User$Registered, info_, avatar);
	});
var $author$project$Model$UploadMultipleDocument$createOwner = function (user) {
	return A2(
		$author$project$Data$PDF$Create$createRecipient,
		$author$project$Data$PDF$Create$Viewer,
		A2(
			$author$project$Data$PDF$User$registered,
			$elm$core$Maybe$Nothing,
			A9($author$project$Data$PDF$User$info, user.email, user.firstName, user.lastName, user.trustScore.stripe, user.trustScore.passbase, user.trustScore.mobilePhone, user.trustScore.wallet, user.trustScore.myInfo, $author$project$Data$PDF$User$Transparent)));
};
var $author$project$Model$UploadMultipleDocument$defaultLastStyle = {
	checkbox: {fontSize: '0pt', height: 15, width: 15},
	date: {fontSize: '16pt', height: 25, width: 150},
	email: {fontSize: '16pt', height: 50, width: 150},
	name: {fontSize: '16pt', height: 50, width: 150},
	signedSignature: {height: 100, width: 150},
	stamped: {height: 150, width: 150},
	text: {fontSize: '16pt', height: 50, width: 150},
	unsignedSignature: {height: 50, width: 275},
	unstamped: {fontSize: '50pt', height: 150, width: 150}
};
var $elm$core$List$drop = F2(
	function (n, list) {
		drop:
		while (true) {
			if (n <= 0) {
				return list;
			} else {
				if (!list.b) {
					return list;
				} else {
					var x = list.a;
					var xs = list.b;
					var $temp$n = n - 1,
						$temp$list = xs;
					n = $temp$n;
					list = $temp$list;
					continue drop;
				}
			}
		}
	});
var $elm$file$File$name = _File_name;
var $author$project$Data$PDF$Create$getTitleFromFilename = function (pdfFile) {
	return A2(
		$elm$core$String$join,
		' ',
		$elm$core$List$reverse(
			A2(
				$elm$core$List$drop,
				1,
				$elm$core$List$reverse(
					A2(
						$elm$core$String$split,
						'.',
						$elm$file$File$name(pdfFile))))));
};
var $author$project$Data$PDF$Create$PDF = function (a) {
	return {$: 'PDF', a: a};
};
var $author$project$Data$PDF$Port$loadNewDocument = _Platform_outgoingPort('loadNewDocument', $elm$core$Basics$identity);
var $author$project$Data$PDF$Port$loadNewDocument2 = _Platform_outgoingPort('loadNewDocument2', $elm$core$Basics$identity);
var $author$project$Data$PDF$Port$loadNewDoc = F5(
	function (password, base64Pdf, fileType, fileName, location) {
		return $elm$core$Platform$Cmd$batch(
			_List_fromArray(
				[
					$author$project$Data$PDF$Port$loadNewDocument(
					A5($author$project$Data$PDF$Port$encodeFile, password, base64Pdf, fileType, fileName, location)),
					$author$project$Data$PDF$Port$loadNewDocument2(
					A5($author$project$Data$PDF$Port$encodeFile, password, base64Pdf, fileType, fileName, location))
				]));
	});
var $author$project$Data$PDF$Create$locationToString = function (location) {
	if (location.$ === 'Document') {
		return 'Document';
	} else {
		return 'MultipleDocument';
	}
};
var $author$project$Data$PDF$Create$init = F5(
	function (_v0, domain_, fileType, location, owner) {
		var pdfFile = _v0.a;
		var base64PDFFileData = _v0.b;
		return _Utils_Tuple2(
			$author$project$Data$PDF$Create$PDF(
				{
					additionalMsg: $elm$core$Maybe$Nothing,
					base64FileData: base64PDFFileData,
					domain: domain_,
					dueDate: $elm$core$Maybe$Nothing,
					file: pdfFile,
					owner: owner,
					password: $elm$core$Maybe$Nothing,
					recipients: $elm$core$Dict$empty,
					requireNotarisation: false,
					title: $author$project$Data$PDF$Create$getTitleFromFilename(pdfFile)
				}),
			A5(
				$author$project$Data$PDF$Port$loadNewDoc,
				$elm$core$Maybe$Nothing,
				base64PDFFileData,
				fileType,
				$author$project$Data$PDF$Create$getTitleFromFilename(pdfFile),
				$author$project$Data$PDF$Create$locationToString(location)));
	});
var $author$project$Data$PDF$Create$initDoc = F3(
	function (fileData, domain_, owner) {
		return $author$project$Data$PDF$Create$PDF(
			{
				additionalMsg: $elm$core$Maybe$Nothing,
				base64FileData: fileData.base64String,
				domain: domain_,
				dueDate: $elm$core$Maybe$Nothing,
				file: fileData.file,
				owner: owner,
				password: $elm$core$Maybe$Nothing,
				recipients: $elm$core$Dict$empty,
				requireNotarisation: false,
				title: $author$project$Data$PDF$Create$getTitleFromFilename(fileData.file)
			});
	});
var $author$project$Data$PDF$Create$title = function (_v0) {
	var pdf = _v0.a;
	return pdf.title;
};
var $author$project$Data$WalletConnect$walletConnectKillSession = _Platform_outgoingPort(
	'walletConnectKillSession',
	function ($) {
		return $elm$json$Json$Encode$null;
	});
var $author$project$Model$UploadMultipleDocument$initWithFile = F3(
	function (user, files, _v0) {
		var signPointsBalance = _v0.signPointsBalance;
		var binanceNotarisationCost = _v0.binanceNotarisationCost;
		var algorandNotarisationCost = _v0.algorandNotarisationCost;
		var requireNotarisation = function (pdfList) {
			var _v4 = $author$project$Model$UploadMultipleDocument$convertStringToNetwork(user.notarisationNetwork);
			if (_v4.$ === 'Binance') {
				return false;
			} else {
				var _v5 = $author$project$Model$UploadMultipleDocument$convertStringToPayment(user.paymentMethod);
				if (_v5.$ === 'SystemBalance') {
					return (_Utils_cmp(
						signPointsBalance,
						algorandNotarisationCost * $elm$core$List$length(pdfList)) > -1) ? true : false;
				} else {
					return false;
				}
			}
		};
		var owner = $author$project$Model$UploadMultipleDocument$createOwner(user);
		var pdfListAndCmd = function () {
			if (files.b) {
				var first = files.a;
				var rest = files.b;
				var pdfList = A2(
					$elm$core$List$map,
					function (pdfData) {
						var pdfDoc = A3(
							$author$project$Data$PDF$Create$initDoc,
							pdfData,
							$author$project$Data$Domain$selected(user.domains),
							$author$project$Model$UploadMultipleDocument$createOwner(user));
						var docId = $truqu$elm_md5$MD5$hex(
							_Utils_ap(
								pdfData.base64String,
								$author$project$Data$PDF$Create$title(pdfDoc)));
						return {
							checksum: $elm$core$Maybe$Nothing,
							docId: $elm$core$Maybe$Nothing,
							fileType: pdfData.fileType,
							id: docId,
							isPDF: _Utils_eq(pdfData.fileType, $author$project$Type$File$PDF),
							isSent: false,
							notarizationStatus: $author$project$Type$UploadMultipleDocument$StandBy,
							ownerId: '',
							pdf: pdfDoc,
							recipient: _List_Nil
						};
					},
					rest);
				var _v3 = A5(
					$author$project$Data$PDF$Create$init,
					_Utils_Tuple2(first.file, first.base64String),
					$author$project$Data$Domain$selected(user.domains),
					first.fileType,
					$author$project$Data$PDF$Create$MultipleDocument,
					owner);
				var firstpdf = _v3.a;
				var firstpdfCmd = _v3.b;
				var id = $truqu$elm_md5$MD5$hex(
					_Utils_ap(
						first.base64String,
						$author$project$Data$PDF$Create$title(firstpdf)));
				var formattedFirstPDF = {
					checksum: $elm$core$Maybe$Nothing,
					docId: $elm$core$Maybe$Nothing,
					fileType: first.fileType,
					id: id,
					isPDF: _Utils_eq(first.fileType, $author$project$Type$File$PDF),
					isSent: false,
					notarizationStatus: $author$project$Type$UploadMultipleDocument$StandBy,
					ownerId: '',
					pdf: firstpdf,
					recipient: _List_Nil
				};
				return $elm$core$Maybe$Just(
					{
						firstFileName: $author$project$Data$PDF$Create$getTitleFromFilename(first.file),
						pdfCmd: firstpdfCmd,
						pdfList: A2($elm$core$List$cons, formattedFirstPDF, pdfList),
						selectedId: id,
						selectedPdf: firstpdf
					});
			} else {
				return $elm$core$Maybe$Nothing;
			}
		}();
		if (pdfListAndCmd.$ === 'Just') {
			var pdfList = pdfListAndCmd.a.pdfList;
			var pdfCmd = pdfListAndCmd.a.pdfCmd;
			var firstFileName = pdfListAndCmd.a.firstFileName;
			var selectedPdf = pdfListAndCmd.a.selectedPdf;
			var selectedId = pdfListAndCmd.a.selectedId;
			return _Utils_Tuple2(
				$author$project$Type$UploadMultipleDocument$Loaded(
					{
						addRecipient: {display: false, email: '', emailError: $elm$core$Maybe$Nothing, firstName: '', firstNameError: $elm$core$Maybe$Nothing, lastName: '', lastNameError: $elm$core$Maybe$Nothing, role: $author$project$Data$PDF$Create$Signer, search: '', searchResult: $elm$core$Maybe$Nothing},
						additionalMsg: $elm$core$Maybe$Nothing,
						algorandNotarisationCost: algorandNotarisationCost,
						algorandWalletAddresses: _List_Nil,
						binanceNotarisationCost: binanceNotarisationCost,
						cancelNotarization: false,
						checkboxNotificationStatus: $author$project$Type$UploadMultipleDocument$NotNotified,
						clickedAnnot: $elm$core$Maybe$Nothing,
						completed: $elm$core$Maybe$Nothing,
						convertedPDFList: _List_Nil,
						dueDate: $elm$core$Maybe$Nothing,
						dueDateError: $elm$core$Maybe$Nothing,
						lastStyle: $author$project$Model$UploadMultipleDocument$defaultLastStyle,
						needOptIn: false,
						optInError: $elm$core$Maybe$Nothing,
						optInStatusCode: $elm$core$Maybe$Nothing,
						organisationStampsHover: false,
						passcode: $elm$core$Maybe$Nothing,
						passcodeError: $elm$core$Maybe$Nothing,
						password: $elm$core$Maybe$Nothing,
						passwordError: $elm$core$Maybe$Nothing,
						pdf: selectedPdf,
						pdfList: pdfList,
						personalStampsHover: false,
						requireNotarisation: requireNotarisation(pdfList),
						saveDocumentStatus: $author$project$Type$UploadMultipleDocument$Save,
						selectedAnnot: $elm$core$Maybe$Nothing,
						selectedPDF: selectedId,
						selectedWallet: $elm$core$Maybe$Nothing,
						showAdditionalMsg: false,
						showDueDate: false,
						showPasscodeInput: false,
						signOrderData: _List_fromArray(
							[
								{signOrder: owner.signOrder, user: owner.user}
							]),
						signPointsBalance: signPointsBalance,
						signingCost: 0,
						signingType: $author$project$Type$UploadMultipleDocument$NoSigningOrder,
						stage: $author$project$Type$UploadMultipleDocument$Recipients,
						status: $author$project$Type$UploadMultipleDocument$Loading($author$project$Type$UploadMultipleDocument$Document),
						textAnnotationTitle: '',
						textAnnotationTitleError: $elm$core$Maybe$Nothing,
						textFontSize: '16',
						title: firstFileName,
						titleError: $elm$core$Maybe$Nothing,
						toolTipActiveHover: $author$project$Type$UploadMultipleDocument$Closed,
						walletError: $elm$core$Maybe$Nothing
					}),
				$elm$core$Platform$Cmd$batch(
					_List_fromArray(
						[
							pdfCmd,
							$author$project$Data$WalletConnect$walletConnectKillSession(_Utils_Tuple0)
						])));
		} else {
			return _Utils_Tuple2($author$project$Type$UploadMultipleDocument$NotLoaded, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Data$PDF$Port$listOfAcceptedFiles = _List_fromArray(
	['application/pdf', '.docx', '.pptx', '.xlsx']);
var $author$project$Type$File$mimeToFileType = function (file) {
	if (file === 'application/pdf') {
		return $author$project$Type$File$PDF;
	} else {
		return $author$project$Type$File$WrongFormat;
	}
};
var $author$project$Model$NewDocument$update = F3(
	function (msg, authModel, model) {
		var updateModel = function (newModel) {
			return _Utils_update(
				model,
				{
					sessionModel: $author$project$Types$Auth(
						_Utils_update(
							authModel,
							{newDocModel: newModel}))
				});
		};
		var newDocModel = authModel.newDocModel;
		switch (msg.$) {
			case 'PickFile':
				return _Utils_Tuple2(
					model,
					A2(
						$elm$core$Platform$Cmd$map,
						$author$project$Types$OnAuth,
						A2(
							$elm$core$Platform$Cmd$map,
							$author$project$Types$OnNewDoc,
							A2($elm$file$File$Select$files, $author$project$Data$PDF$Port$listOfAcceptedFiles, $author$project$Type$NewDocument$GotFiles))));
			case 'GotFiles':
				var file = msg.a;
				var files = msg.b;
				var errorList = A2(
					$elm$core$List$map,
					function (fileData) {
						return _Utils_eq(
							$author$project$Type$File$mimeToFileType(
								$elm$file$File$mime(fileData)),
							$author$project$Type$File$WrongFormat) ? $elm$core$Maybe$Just(
							'Incorrect File Format: ' + $elm$file$File$name(fileData)) : (($elm$file$File$size(fileData) >= 26214400) ? $elm$core$Maybe$Just(
							'File Too Big: ' + $elm$file$File$name(fileData)) : $elm$core$Maybe$Nothing);
					},
					A2($elm$core$List$cons, file, files));
				var updatedSuccessModel = function () {
					var newModel = _Utils_update(
						newDocModel,
						{
							fileHover: false,
							numberOfFiles: $elm$core$Maybe$Just(
								$elm$core$List$length(files) + 1)
						});
					var filteredErrorList = A2(
						$elm$core$List$filter,
						function (error) {
							return !_Utils_eq(error, $elm$core$Maybe$Nothing);
						},
						errorList);
					return $elm$core$List$isEmpty(filteredErrorList) ? _Utils_update(
						newModel,
						{error: $elm$core$Maybe$Nothing}) : _Utils_update(
						newModel,
						{
							error: A2(
								$elm$core$Maybe$withDefault,
								$elm$core$Maybe$Just('Unknown Error.'),
								$elm$core$List$head(filteredErrorList))
						});
				}();
				var cmdMsgList = A2(
					$elm$core$List$map,
					function (fileData) {
						var fileType = $author$project$Type$File$mimeToFileType(
							$elm$file$File$mime(fileData));
						return ((!_Utils_eq(
							$author$project$Type$File$mimeToFileType(
								$elm$file$File$mime(fileData)),
							$author$project$Type$File$WrongFormat)) && ($elm$file$File$size(fileData) < 26214400)) ? A2(
							$elm$core$Task$perform,
							A2(
								$elm$core$Basics$composeL,
								A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnNewDoc),
								A2($author$project$Type$NewDocument$OnAddFile, fileType, fileData)),
							$elm$file$File$toUrl(fileData)) : $elm$core$Platform$Cmd$none;
					},
					A2($elm$core$List$cons, file, files));
				return _Utils_Tuple2(
					updateModel(updatedSuccessModel),
					$elm$core$Platform$Cmd$batch(cmdMsgList));
			case 'OnDragEnter':
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							sessionModel: $author$project$Types$Auth(
								_Utils_update(
									authModel,
									{
										newDocModel: _Utils_update(
											newDocModel,
											{fileHover: true})
									}))
						}),
					$elm$core$Platform$Cmd$none);
			case 'OnDragLeave':
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							sessionModel: $author$project$Types$Auth(
								_Utils_update(
									authModel,
									{
										newDocModel: _Utils_update(
											newDocModel,
											{fileHover: false})
									}))
						}),
					$elm$core$Platform$Cmd$none);
			case 'OnRemoveFile':
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							sessionModel: $author$project$Types$Auth(
								_Utils_update(
									authModel,
									{
										newDocModel: _Utils_update(
											newDocModel,
											{base64File: $elm$core$Maybe$Nothing, file: $elm$core$Maybe$Nothing})
									}))
						}),
					$elm$core$Platform$Cmd$none);
			case 'OnSubmitDoc':
				return _Utils_Tuple2(
					model,
					A2(
						$elm$core$Task$attempt,
						A2(
							$elm$core$Basics$composeL,
							A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnNewDoc),
							$author$project$Type$NewDocument$OnSubmitDocResult),
						A2($author$project$Data$Api$PDF$NotarisationPoints$authCall, authModel.user.jwt, model.apiEndPoint.notariseDocumentCost)));
			case 'OnSubmitDocResult':
				var notarisationPointsResult = msg.a;
				if (notarisationPointsResult.$ === 'Ok') {
					var notarisationPoints = notarisationPointsResult.a;
					var _v2 = function () {
						if (!$elm$core$List$isEmpty(newDocModel.files)) {
							var _v3 = A3($author$project$Model$UploadMultipleDocument$initWithFile, authModel.user, newDocModel.files, notarisationPoints);
							var updatedModel = _v3.a;
							var cmdMsg = _v3.b;
							return _Utils_Tuple2(
								updatedModel,
								$elm$core$Platform$Cmd$batch(
									_List_fromArray(
										[
											cmdMsg,
											A2($elm$browser$Browser$Navigation$pushUrl, model.navKey, $author$project$Data$Route$routeUrl.uploadMultiDoc)
										])));
						} else {
							return _Utils_Tuple2(authModel.uploadMultipleDocModel, $elm$core$Platform$Cmd$none);
						}
					}();
					var uploadDocumentModel = _v2.a;
					var uploadDocumentCmd = _v2.b;
					var _v4 = authModel;
					var actionButton = _v4.actionButton;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								sessionModel: $author$project$Types$Auth(
									_Utils_update(
										authModel,
										{
											actionButton: _Utils_update(
												actionButton,
												{status: $author$project$Type$ActionButton$AllClose}),
											newDocModel: $author$project$Model$NewDocument$init,
											uploadMultipleDocModel: uploadDocumentModel
										}))
							}),
						uploadDocumentCmd);
				} else {
					var error = notarisationPointsResult.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								sessionModel: $author$project$Types$Auth(
									_Utils_update(
										authModel,
										{
											newDocModel: _Utils_update(
												newDocModel,
												{
													error: $elm$core$Maybe$Just(
														A2($author$project$Data$Api$authErrorToString, $author$project$Data$Api$PDF$NotarisationPoints$errorToString, error)),
													fileHover: false
												})
										}))
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 'OnCloseBanner':
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							sessionModel: $author$project$Types$Auth(
								_Utils_update(
									authModel,
									{
										newDocModel: _Utils_update(
											newDocModel,
											{error: $elm$core$Maybe$Nothing, file: $elm$core$Maybe$Nothing, fileHover: false})
									}))
						}),
					$elm$core$Platform$Cmd$none);
			default:
				var fileType = msg.a;
				var file = msg.b;
				var base64Data = msg.c;
				var isInList = A2(
					$elm$core$List$any,
					function (fileData) {
						return _Utils_eq(base64Data, fileData.base64String);
					},
					newDocModel.files);
				var _v5 = isInList ? _Utils_Tuple2(
					model,
					$elm$core$List$length(newDocModel.files)) : _Utils_Tuple2(
					updateModel(
						_Utils_update(
							newDocModel,
							{
								files: A2(
									$elm$core$List$cons,
									{base64String: base64Data, file: file, fileType: fileType},
									newDocModel.files)
							})),
					$elm$core$List$length(newDocModel.files) + 1);
				var newModel = _v5.a;
				var fileNumbers = _v5.b;
				var newCmdMsg = _Utils_eq(
					fileNumbers,
					A2($elm$core$Maybe$withDefault, 0, newDocModel.numberOfFiles)) ? A2(
					$elm$core$Task$perform,
					$author$project$Types$OnAuth,
					$elm$core$Task$succeed(
						$author$project$Types$OnNewDoc($author$project$Type$NewDocument$OnSubmitDoc))) : $elm$core$Platform$Cmd$none;
				return _Utils_Tuple2(newModel, newCmdMsg);
		}
	});
var $author$project$Type$NewMultipleDocument$GotFiles = F2(
	function (a, b) {
		return {$: 'GotFiles', a: a, b: b};
	});
var $author$project$Type$NewMultipleDocument$OnAddFile = F3(
	function (a, b, c) {
		return {$: 'OnAddFile', a: a, b: b, c: c};
	});
var $author$project$Types$OnNewMultipleDoc = function (a) {
	return {$: 'OnNewMultipleDoc', a: a};
};
var $author$project$Type$NewMultipleDocument$OnSubmitDocResult = function (a) {
	return {$: 'OnSubmitDocResult', a: a};
};
var $author$project$Model$NewMultipleDocument$update = F3(
	function (msg, authModel, model) {
		var updateModel = function (newModel) {
			return _Utils_update(
				model,
				{
					sessionModel: $author$project$Types$Auth(
						_Utils_update(
							authModel,
							{newMultipleDocModel: newModel}))
				});
		};
		var newMultipleDocModel = authModel.newMultipleDocModel;
		switch (msg.$) {
			case 'PickFile':
				return _Utils_Tuple2(
					model,
					A2(
						$elm$core$Platform$Cmd$map,
						$author$project$Types$OnAuth,
						A2(
							$elm$core$Platform$Cmd$map,
							$author$project$Types$OnNewMultipleDoc,
							A2($elm$file$File$Select$files, $author$project$Data$PDF$Port$listOfAcceptedFiles, $author$project$Type$NewMultipleDocument$GotFiles))));
			case 'GotFiles':
				var file = msg.a;
				var files = msg.b;
				var errorList = A2(
					$elm$core$List$map,
					function (fileData) {
						return _Utils_eq(
							$author$project$Type$File$mimeToFileType(
								$elm$file$File$mime(fileData)),
							$author$project$Type$File$WrongFormat) ? $elm$core$Maybe$Just(
							'Incorrect File Format: ' + $elm$file$File$name(fileData)) : (($elm$file$File$size(fileData) >= 26214400) ? $elm$core$Maybe$Just(
							'File Too Big: ' + $elm$file$File$name(fileData)) : $elm$core$Maybe$Nothing);
					},
					A2($elm$core$List$cons, file, files));
				var updatedSuccessModel = function () {
					var filteredErrorList = A2(
						$elm$core$List$filter,
						function (error) {
							return !_Utils_eq(error, $elm$core$Maybe$Nothing);
						},
						errorList);
					return $elm$core$List$isEmpty(filteredErrorList) ? _Utils_update(
						newMultipleDocModel,
						{error: $elm$core$Maybe$Nothing, fileHover: false}) : _Utils_update(
						newMultipleDocModel,
						{
							error: A2(
								$elm$core$Maybe$withDefault,
								$elm$core$Maybe$Just('Unknown Error.'),
								$elm$core$List$head(filteredErrorList)),
							fileHover: false
						});
				}();
				var cmdMsgList = A2(
					$elm$core$List$map,
					function (fileData) {
						var fileType = $author$project$Type$File$mimeToFileType(
							$elm$file$File$mime(fileData));
						return ((!_Utils_eq(
							$author$project$Type$File$mimeToFileType(
								$elm$file$File$mime(fileData)),
							$author$project$Type$File$WrongFormat)) && ($elm$file$File$size(fileData) < 26214400)) ? A2(
							$elm$core$Task$perform,
							A2(
								$elm$core$Basics$composeL,
								A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnNewMultipleDoc),
								A2($author$project$Type$NewMultipleDocument$OnAddFile, fileType, fileData)),
							$elm$file$File$toUrl(fileData)) : $elm$core$Platform$Cmd$none;
					},
					A2($elm$core$List$cons, file, files));
				return _Utils_Tuple2(
					updateModel(updatedSuccessModel),
					$elm$core$Platform$Cmd$batch(cmdMsgList));
			case 'OnDragEnter':
				return _Utils_Tuple2(
					updateModel(
						_Utils_update(
							newMultipleDocModel,
							{fileHover: true})),
					$elm$core$Platform$Cmd$none);
			case 'OnDragLeave':
				return _Utils_Tuple2(
					updateModel(
						_Utils_update(
							newMultipleDocModel,
							{fileHover: false})),
					$elm$core$Platform$Cmd$none);
			case 'OnRemoveFile':
				return _Utils_Tuple2(
					updateModel(
						_Utils_update(
							newMultipleDocModel,
							{base64File: $elm$core$Maybe$Nothing, file: $elm$core$Maybe$Nothing})),
					$elm$core$Platform$Cmd$none);
			case 'OnAddFile':
				var fileType = msg.a;
				var file = msg.b;
				var base64Data = msg.c;
				var isInList = A2(
					$elm$core$List$any,
					function (fileData) {
						return _Utils_eq(base64Data, fileData.base64String);
					},
					newMultipleDocModel.files);
				var newModel = isInList ? model : updateModel(
					_Utils_update(
						newMultipleDocModel,
						{
							files: A2(
								$elm$core$List$cons,
								{base64String: base64Data, file: file, fileType: fileType},
								newMultipleDocModel.files)
						}));
				return _Utils_Tuple2(newModel, $elm$core$Platform$Cmd$none);
			case 'OnSubmitDoc':
				return _Utils_Tuple2(
					updateModel(
						_Utils_update(
							newMultipleDocModel,
							{showModal: true})),
					A2(
						$elm$core$Task$attempt,
						A2(
							$elm$core$Basics$composeL,
							A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnNewMultipleDoc),
							$author$project$Type$NewMultipleDocument$OnSubmitDocResult),
						A2($author$project$Data$Api$PDF$NotarisationPoints$authCall, authModel.user.jwt, model.apiEndPoint.notariseDocumentCost)));
			case 'OnSubmitDocResult':
				var notarisationPointsResult = msg.a;
				if (notarisationPointsResult.$ === 'Ok') {
					var notarisationPoints = notarisationPointsResult.a;
					var _v2 = function () {
						if (!$elm$core$List$isEmpty(newMultipleDocModel.files)) {
							var _v3 = A3($author$project$Model$UploadMultipleDocument$initWithFile, authModel.user, newMultipleDocModel.files, notarisationPoints);
							var updatedModel = _v3.a;
							var cmdMsg = _v3.b;
							return _Utils_Tuple2(
								updatedModel,
								$elm$core$Platform$Cmd$batch(
									_List_fromArray(
										[
											cmdMsg,
											A2($elm$browser$Browser$Navigation$pushUrl, model.navKey, $author$project$Data$Route$routeUrl.uploadMultiDoc)
										])));
						} else {
							return _Utils_Tuple2(authModel.uploadMultipleDocModel, $elm$core$Platform$Cmd$none);
						}
					}();
					var uploadDocumentModel = _v2.a;
					var uploadDocumentCmd = _v2.b;
					var _v4 = authModel;
					var actionButton = _v4.actionButton;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								sessionModel: $author$project$Types$Auth(
									_Utils_update(
										authModel,
										{
											actionButton: _Utils_update(
												actionButton,
												{status: $author$project$Type$ActionButton$AllClose}),
											newMultipleDocModel: $author$project$Model$NewMultipleDocument$init,
											uploadMultipleDocModel: uploadDocumentModel
										}))
							}),
						uploadDocumentCmd);
				} else {
					var error = notarisationPointsResult.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								sessionModel: $author$project$Types$Auth(
									_Utils_update(
										authModel,
										{
											newMultipleDocModel: _Utils_update(
												newMultipleDocModel,
												{
													error: $elm$core$Maybe$Just(
														A2($author$project$Data$Api$authErrorToString, $author$project$Data$Api$PDF$NotarisationPoints$errorToString, error)),
													fileHover: false
												})
										}))
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 'OnCloseBanner':
				return _Utils_Tuple2(
					updateModel(
						_Utils_update(
							newMultipleDocModel,
							{error: $elm$core$Maybe$Nothing, file: $elm$core$Maybe$Nothing, fileHover: false})),
					$elm$core$Platform$Cmd$none);
			default:
				var deleteFilebase64 = msg.a;
				var newModel = A2(
					$elm$core$List$filter,
					function (fileData) {
						return !_Utils_eq(fileData.base64String, deleteFilebase64);
					},
					newMultipleDocModel.files);
				return _Utils_Tuple2(
					updateModel(
						_Utils_update(
							newMultipleDocModel,
							{files: newModel})),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Type$File$Docx = {$: 'Docx'};
var $author$project$Type$NewTemplate$Enter = {$: 'Enter'};
var $author$project$Type$NewTemplate$GotFiles = F2(
	function (a, b) {
		return {$: 'GotFiles', a: a, b: b};
	});
var $author$project$Type$NewTemplate$OnGetTemplateQuotaResult = function (a) {
	return {$: 'OnGetTemplateQuotaResult', a: a};
};
var $author$project$Type$NewTemplate$OnSubmitDoc = F2(
	function (a, b) {
		return {$: 'OnSubmitDoc', a: a, b: b};
	});
var $author$project$Type$File$Pptx = {$: 'Pptx'};
var $author$project$Type$File$Xlsx = {$: 'Xlsx'};
var $author$project$Data$Api$PDF$TemplateQuota$Payload = F2(
	function (templateQuota, templateNumbers) {
		return {templateNumbers: templateNumbers, templateQuota: templateQuota};
	});
var $author$project$Data$Api$PDF$TemplateQuota$dataDecoder = A3(
	$elm$json$Json$Decode$map2,
	$author$project$Data$Api$PDF$TemplateQuota$Payload,
	A2($elm$json$Json$Decode$field, 'templateQuota', $elm$json$Json$Decode$int),
	A2($elm$json$Json$Decode$field, 'templateNumbers', $elm$json$Json$Decode$int));
var $author$project$Data$Api$PDF$TemplateQuota$INVALID_DOMAIN = {$: 'INVALID_DOMAIN'};
var $author$project$Data$Api$PDF$TemplateQuota$JWT_ERROR = {$: 'JWT_ERROR'};
var $author$project$Data$Api$PDF$TemplateQuota$errorDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (errorCode) {
		switch (errorCode) {
			case 'JWT_ERROR':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$PDF$TemplateQuota$JWT_ERROR);
			case 'INVALID_DATA':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$PDF$TemplateQuota$INVALID_DOMAIN);
			default:
				return $elm$json$Json$Decode$fail('Invalid error code: ' + errorCode);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Data$Api$PDF$TemplateQuota$authCall = F3(
	function (jwt, endPoint, domain) {
		return A5(
			$author$project$Data$Api$authCall,
			jwt,
			endPoint,
			$author$project$Data$Api$PDF$TemplateQuota$errorDecoder,
			$author$project$Data$Api$PDF$TemplateQuota$dataDecoder,
			$elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'domain',
						$author$project$Data$Domain$encode(domain))
					])));
	});
var $author$project$Type$CreateTemplate$Closed = {$: 'Closed'};
var $author$project$Type$CreateTemplate$DocumentTitle = {$: 'DocumentTitle'};
var $author$project$Type$CreateTemplate$Loading = {$: 'Loading'};
var $author$project$Model$CreateTemplate$createOwner = function (user) {
	return A2(
		$author$project$Data$PDF$User$registered,
		$elm$core$Maybe$Nothing,
		A9($author$project$Data$PDF$User$info, user.email, user.firstName, user.lastName, user.trustScore.stripe, user.trustScore.passbase, user.trustScore.mobilePhone, user.trustScore.wallet, user.trustScore.myInfo, $author$project$Data$PDF$User$Transparent));
};
var $author$project$Data$PDF$CreateTemplate$getTitleFromFilename = function (pdfFile) {
	return A2(
		$elm$core$String$join,
		' ',
		$elm$core$List$reverse(
			A2(
				$elm$core$List$drop,
				1,
				$elm$core$List$reverse(
					A2(
						$elm$core$String$split,
						'.',
						$elm$file$File$name(pdfFile))))));
};
var $author$project$Data$PDF$CreateTemplate$init = F3(
	function (_v0, fileType, owner) {
		var pdfFile = _v0.a;
		var base64PDFFileData = _v0.b;
		return _Utils_Tuple2(
			$author$project$Data$PDF$CreateTemplate$Template(
				{
					base64FileData: base64PDFFileData,
					file: pdfFile,
					isPrivate: false,
					owner: owner,
					password: $elm$core$Maybe$Nothing,
					roles: $elm$core$Dict$empty,
					slug: '',
					title: $author$project$Data$PDF$CreateTemplate$getTitleFromFilename(pdfFile)
				}),
			A4(
				$author$project$Data$PDF$Port$newTemplate,
				$elm$core$Maybe$Nothing,
				base64PDFFileData,
				fileType,
				$author$project$Data$PDF$CreateTemplate$getTitleFromFilename(pdfFile)));
	});
var $author$project$Model$CreateTemplate$initWithFile = F3(
	function (user, _v0, fileType) {
		var file = _v0.a;
		var base64Data = _v0.b;
		var _v1 = A3(
			$author$project$Data$PDF$CreateTemplate$init,
			_Utils_Tuple2(file, base64Data),
			fileType,
			$author$project$Model$CreateTemplate$createOwner(user));
		var template = _v1.a;
		var templateLoadCmd = _v1.b;
		return _Utils_Tuple2(
			$author$project$Type$CreateTemplate$Loaded(
				{
					addRole: {addRoleError: $elm$core$Maybe$Nothing, name: '', nameError: $elm$core$Maybe$Nothing, roleDetails: $elm$core$Maybe$Nothing},
					annotFieldForm: {name: '', nameError: $elm$core$Maybe$Nothing, required: true, status: $author$project$Type$CreateTemplate$NoSelectedFieldAnnot},
					checkboxLocation: $author$project$Type$CreateTemplate$None,
					documentTitleError: $elm$core$Maybe$Nothing,
					fieldError: $elm$core$Maybe$Nothing,
					fontSize: '16',
					isPrivate: false,
					lastStyle: {
						checkbox: {fontSize: '0pt', height: 15, width: 15},
						date: {fontSize: '16pt', height: 25, width: 150},
						dateField: {fontSize: '16pt', height: 50, width: 150},
						emailField: {fontSize: '16pt', height: 50, width: 150},
						freeText: {fontSize: '16pt', height: 50, width: 150},
						name: {fontSize: '16pt', height: 50, width: 150},
						nameField: {fontSize: '16pt', height: 50, width: 150},
						numberField: {fontSize: '16pt', height: 50, width: 150},
						signature: {height: 100, width: 150},
						signatureField: {height: 50, width: 275},
						stampField: {height: 150, width: 150},
						textField: {fontSize: '16pt', height: 50, width: 150}
					},
					password: $elm$core$Maybe$Nothing,
					passwordError: $elm$core$Maybe$Nothing,
					selectedAnnot: $elm$core$Maybe$Nothing,
					selectedAnnotForDeletion: $elm$core$Maybe$Nothing,
					signOrder: $author$project$Type$CreateTemplate$Disabled,
					slug: $elm$core$Maybe$Nothing,
					slugError: $elm$core$Maybe$Nothing,
					stage: $author$project$Type$CreateTemplate$DocumentTitle,
					status: $author$project$Type$CreateTemplate$Loading,
					template: template,
					title: $author$project$Data$PDF$CreateTemplate$getTitleFromFilename(file),
					titleError: $elm$core$Maybe$Nothing,
					toolTipActiveHover: $author$project$Type$CreateTemplate$Closed
				}),
			templateLoadCmd);
	});
var $author$project$Model$NewTemplate$update = F3(
	function (msg, authModel, model) {
		var newTemplateModel = authModel.newTemplateModel;
		var _v0 = authModel;
		var user = _v0.user;
		switch (msg.$) {
			case 'PickFile':
				return _Utils_Tuple2(
					model,
					A2(
						$elm$core$Platform$Cmd$map,
						$author$project$Types$OnAuth,
						A2(
							$elm$core$Platform$Cmd$map,
							$author$project$Types$OnNewTemplate,
							A2($elm$file$File$Select$files, $author$project$Data$PDF$Port$listOfAcceptedFiles, $author$project$Type$NewTemplate$GotFiles))));
			case 'GotFiles':
				var file = msg.a;
				var updatedSuccessModel = _Utils_update(
					model,
					{
						sessionModel: $author$project$Types$Auth(
							_Utils_update(
								authModel,
								{
									newTemplateModel: _Utils_update(
										newTemplateModel,
										{
											error: $elm$core$Maybe$Nothing,
											file: $elm$core$Maybe$Just(file),
											fileHover: false
										})
								}))
					});
				var newCmdMsg = function (fileType) {
					return A2(
						$elm$core$Task$perform,
						A2(
							$elm$core$Basics$composeL,
							A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnNewTemplate),
							$author$project$Type$NewTemplate$OnSubmitDoc(fileType)),
						$elm$file$File$toUrl(file));
				};
				var _v2 = _Utils_Tuple2(
					$author$project$Type$File$mimeToFileType(
						$elm$file$File$mime(file)),
					$elm$file$File$size(file) < 26214400);
				if (!_v2.b) {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								sessionModel: $author$project$Types$Auth(
									_Utils_update(
										authModel,
										{
											newTemplateModel: _Utils_update(
												newTemplateModel,
												{
													error: $elm$core$Maybe$Just('File Too Big.'),
													fileHover: false
												})
										}))
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					switch (_v2.a.$) {
						case 'PDF':
							var _v3 = _v2.a;
							return _Utils_Tuple2(
								updatedSuccessModel,
								newCmdMsg($author$project$Type$File$PDF));
						case 'Docx':
							var _v4 = _v2.a;
							return _Utils_Tuple2(
								updatedSuccessModel,
								newCmdMsg($author$project$Type$File$Docx));
						case 'Pptx':
							var _v5 = _v2.a;
							return _Utils_Tuple2(
								updatedSuccessModel,
								newCmdMsg($author$project$Type$File$Pptx));
						case 'Xlsx':
							var _v6 = _v2.a;
							return _Utils_Tuple2(
								updatedSuccessModel,
								newCmdMsg($author$project$Type$File$Xlsx));
						default:
							var _v7 = _v2.a;
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{
										sessionModel: $author$project$Types$Auth(
											_Utils_update(
												authModel,
												{
													newTemplateModel: _Utils_update(
														newTemplateModel,
														{
															error: $elm$core$Maybe$Just('Wrong File Format.'),
															fileHover: false
														})
												}))
									}),
								$elm$core$Platform$Cmd$none);
					}
				}
			case 'OnDragEnter':
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							sessionModel: $author$project$Types$Auth(
								_Utils_update(
									authModel,
									{
										newTemplateModel: _Utils_update(
											newTemplateModel,
											{fileHover: true})
									}))
						}),
					$elm$core$Platform$Cmd$none);
			case 'OnDragLeave':
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							sessionModel: $author$project$Types$Auth(
								_Utils_update(
									authModel,
									{
										newTemplateModel: _Utils_update(
											newTemplateModel,
											{fileHover: false})
									}))
						}),
					$elm$core$Platform$Cmd$none);
			case 'OnRemoveFile':
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							sessionModel: $author$project$Types$Auth(
								_Utils_update(
									authModel,
									{
										newTemplateModel: _Utils_update(
											newTemplateModel,
											{base64File: $elm$core$Maybe$Nothing, file: $elm$core$Maybe$Nothing})
									}))
						}),
					$elm$core$Platform$Cmd$none);
			case 'OnSubmitDoc':
				var fileType = msg.a;
				var base64Data = msg.b;
				var _v8 = function () {
					var _v9 = newTemplateModel.file;
					if (_v9.$ === 'Just') {
						var file = _v9.a;
						return A3(
							$author$project$Model$CreateTemplate$initWithFile,
							authModel.user,
							_Utils_Tuple2(file, base64Data),
							fileType);
					} else {
						return _Utils_Tuple2(authModel.createTemplateModel, $elm$core$Platform$Cmd$none);
					}
				}();
				var createTemplateModel = _v8.a;
				var createTemplateCmd = _v8.b;
				var _v10 = authModel;
				var actionButton = _v10.actionButton;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							sessionModel: $author$project$Types$Auth(
								_Utils_update(
									authModel,
									{
										actionButton: _Utils_update(
											actionButton,
											{status: $author$project$Type$ActionButton$AllClose}),
										createTemplateModel: createTemplateModel,
										newTemplateModel: $author$project$Model$NewTemplate$init
									}))
						}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								createTemplateCmd,
								A2($elm$browser$Browser$Navigation$pushUrl, model.navKey, $author$project$Data$Route$routeUrl.createTemplate)
							])));
			case 'OnCloseBanner':
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							sessionModel: $author$project$Types$Auth(
								_Utils_update(
									authModel,
									{
										newTemplateModel: _Utils_update(
											newTemplateModel,
											{error: $elm$core$Maybe$Nothing, file: $elm$core$Maybe$Nothing, fileHover: false})
									}))
						}),
					$elm$core$Platform$Cmd$none);
			case 'OnGetTemplateQuota':
				return _Utils_Tuple2(
					model,
					A2(
						$elm$core$Task$attempt,
						A2(
							$elm$core$Basics$composeL,
							A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnNewTemplate),
							$author$project$Type$NewTemplate$OnGetTemplateQuotaResult),
						A3(
							$author$project$Data$Api$PDF$TemplateQuota$authCall,
							user.jwt,
							model.apiEndPoint.templateQuota,
							$author$project$Data$Domain$selected(user.domains))));
			case 'OnGetTemplateQuotaResult':
				var payload = msg.a;
				var isInOrgDomain = !A2(
					$author$project$Data$Domain$equal,
					$author$project$Data$Domain$selected(authModel.user.domains),
					model.appDomain);
				var _v11 = _Utils_Tuple2(isInOrgDomain, payload);
				if (_v11.a && (_v11.b.$ === 'Ok')) {
					var result = _v11.b.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								sessionModel: $author$project$Types$Auth(
									_Utils_update(
										authModel,
										{
											newTemplateModel: _Utils_update(
												newTemplateModel,
												{error: $elm$core$Maybe$Nothing, file: $elm$core$Maybe$Nothing, fileHover: false, templateQuota: result.templateQuota, templatesUsed: result.templateNumbers})
										}))
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					return _Utils_Tuple2(
						model,
						A2($elm$browser$Browser$Navigation$pushUrl, model.navKey, $author$project$Data$Route$routeUrl.dashboard));
				}
			default:
				var action = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							sessionModel: $author$project$Types$Auth(
								_Utils_update(
									authModel,
									{
										newTemplateModel: _Utils_update(
											newTemplateModel,
											{
												toolTipHover: _Utils_eq(action, $author$project$Type$NewTemplate$Enter)
											})
									}))
						}),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Type$NewfoldRegister$Error = function (a) {
	return {$: 'Error', a: a};
};
var $author$project$Types$OnNewfoldRegister = function (a) {
	return {$: 'OnNewfoldRegister', a: a};
};
var $author$project$Type$NewfoldRegister$OnValidateDomain = {$: 'OnValidateDomain'};
var $author$project$Type$NewfoldRegister$Retry = {$: 'Retry'};
var $author$project$Type$NewfoldRegister$Submitting = {$: 'Submitting'};
var $author$project$Type$NewfoldRegister$Validating = {$: 'Validating'};
var $author$project$Model$NewfoldRegister$jumpToForm = function (id) {
	return A2(
		$elm$core$Task$attempt,
		function (_v0) {
			return $author$project$Types$Noop;
		},
		A2(
			$elm$core$Task$andThen,
			function (info) {
				return A2($elm$browser$Browser$Dom$setViewport, info.element.x, info.element.y);
			},
			$elm$browser$Browser$Dom$getElement(id)));
};
var $author$project$Type$NewfoldRegister$OnSubmitResponse = function (a) {
	return {$: 'OnSubmitResponse', a: a};
};
var $author$project$Data$Api$Register$Newfold$Payload = function (message) {
	return {message: message};
};
var $author$project$Data$Api$Register$Newfold$dataDecoder = A2(
	$elm$json$Json$Decode$map,
	$author$project$Data$Api$Register$Newfold$Payload,
	A2($elm$json$Json$Decode$field, 'message', $elm$json$Json$Decode$string));
var $author$project$Data$Api$Register$Newfold$encode = function (params) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'subdomain',
				$elm$json$Json$Encode$string(params.subdomain)),
				_Utils_Tuple2(
				'companyName',
				$elm$json$Json$Encode$string(params.companyName)),
				_Utils_Tuple2(
				'firstName',
				$elm$json$Json$Encode$string(params.firstName)),
				_Utils_Tuple2(
				'lastName',
				$elm$json$Json$Encode$string(params.lastName)),
				_Utils_Tuple2(
				'email',
				$elm$json$Json$Encode$string(params.email)),
				_Utils_Tuple2(
				'password',
				$elm$json$Json$Encode$string(params.password)),
				_Utils_Tuple2(
				'referralCode',
				$elm$json$Json$Encode$string(params.referralCode))
			]));
};
var $author$project$Data$Api$Register$Newfold$EMPTY_NAME = {$: 'EMPTY_NAME'};
var $author$project$Data$Api$Register$Newfold$INVALID_CODE = {$: 'INVALID_CODE'};
var $author$project$Data$Api$Register$Newfold$INVALID_COMPANYNAME = {$: 'INVALID_COMPANYNAME'};
var $author$project$Data$Api$Register$Newfold$INVALID_EMAIL = {$: 'INVALID_EMAIL'};
var $author$project$Data$Api$Register$Newfold$INVALID_SUBDOMAIN = {$: 'INVALID_SUBDOMAIN'};
var $author$project$Data$Api$Register$Newfold$PASSWORD_REQUIREMENT = {$: 'PASSWORD_REQUIREMENT'};
var $author$project$Data$Api$Register$Newfold$UPDATE_ANONYMOUS = {$: 'UPDATE_ANONYMOUS'};
var $author$project$Data$Api$Register$Newfold$USER_EXIST = {$: 'USER_EXIST'};
var $author$project$Data$Api$Register$Newfold$errorDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (errorCode) {
		switch (errorCode) {
			case 'INVALID_SUBDOMAIN':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$Register$Newfold$INVALID_SUBDOMAIN);
			case 'INVALID_COMPANYNAME':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$Register$Newfold$INVALID_COMPANYNAME);
			case 'EMPTY_NAME':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$Register$Newfold$EMPTY_NAME);
			case 'PASSWORD_REQUIREMENT':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$Register$Newfold$PASSWORD_REQUIREMENT);
			case 'USER_EXIST':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$Register$Newfold$USER_EXIST);
			case 'INVALID_EMAIL':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$Register$Newfold$INVALID_EMAIL);
			case 'UPDATE_ANONYMOUS':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$Register$Newfold$UPDATE_ANONYMOUS);
			case 'INVALID_CODE':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$Register$Newfold$INVALID_CODE);
			default:
				return $elm$json$Json$Decode$fail('Invalid error code: ' + errorCode);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Data$Api$Register$Newfold$call = F2(
	function (endPoint, params) {
		return A4(
			$author$project$Data$Api$httpTask,
			endPoint,
			$author$project$Data$Api$Register$Newfold$errorDecoder,
			$author$project$Data$Api$Register$Newfold$dataDecoder,
			$author$project$Data$Api$Register$Newfold$encode(params));
	});
var $author$project$Model$NewfoldRegister$submitCmd = F2(
	function (endpoint, params) {
		return A2(
			$elm$core$Task$attempt,
			A2($elm$core$Basics$composeL, $author$project$Types$OnNewfoldRegister, $author$project$Type$NewfoldRegister$OnSubmitResponse),
			A2($author$project$Data$Api$Register$Newfold$call, endpoint, params));
	});
var $author$project$Model$NewfoldRegister$trimRemoveSpace = function (str) {
	return A3(
		$elm$core$String$replace,
		' ',
		'',
		$elm$core$String$trim(str));
};
var $author$project$Model$NewfoldRegister$validateHasAgreedTerms = function (hasAgreed) {
	return hasAgreed ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just('You must agree to the terms of service and privacy policy to sign up.');
};
var $author$project$Model$NewfoldRegister$validateNotEmpty = F2(
	function (fieldName, value) {
		return $elm$core$String$isEmpty(value) ? $elm$core$Maybe$Just(fieldName + ' is required.') : $elm$core$Maybe$Nothing;
	});
var $author$project$Type$NewfoldRegister$OnValidateDomainResponse = function (a) {
	return {$: 'OnValidateDomainResponse', a: a};
};
var $author$project$Model$NewfoldRegister$validateSubDomain = F2(
	function (endpoint, subDomain) {
		return A2(
			$elm$core$Task$attempt,
			A2($elm$core$Basics$composeL, $author$project$Types$OnNewfoldRegister, $author$project$Type$NewfoldRegister$OnValidateDomainResponse),
			A2(
				$author$project$Data$Api$Register$ValidateDomain$call,
				endpoint,
				{subdomain: subDomain}));
	});
var $author$project$Model$NewfoldRegister$validateSubDomainErrorString = function (status) {
	switch (status.$) {
		case 'Used':
			return $elm$core$Maybe$Just('This domain name is already in use.');
		case 'Reserved':
			return $elm$core$Maybe$Just('This domain name is reserved.');
		case 'Invalid':
			return $elm$core$Maybe$Just('This domain name contain invalid characters.');
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Model$NewfoldRegister$update = F2(
	function (msg, model) {
		var _v0 = model;
		var newfoldRegisterModel = _v0.newfoldRegisterModel;
		var apiEndPoint = _v0.apiEndPoint;
		switch (msg.$) {
			case 'OnInput':
				var field = msg.a;
				var value = msg.b;
				switch (field.$) {
					case 'SubDomain':
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									newfoldRegisterModel: _Utils_update(
										newfoldRegisterModel,
										{
											subdomain: $author$project$Model$NewfoldRegister$trimRemoveSpace(value),
											subdomainStatus: $elm$core$Maybe$Nothing
										})
								}),
							$elm$core$Platform$Cmd$none);
					case 'CompanyName':
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									newfoldRegisterModel: _Utils_update(
										newfoldRegisterModel,
										{companyName: value})
								}),
							$elm$core$Platform$Cmd$none);
					case 'FirstName':
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									newfoldRegisterModel: _Utils_update(
										newfoldRegisterModel,
										{firstName: value})
								}),
							$elm$core$Platform$Cmd$none);
					case 'LastName':
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									newfoldRegisterModel: _Utils_update(
										newfoldRegisterModel,
										{lastName: value})
								}),
							$elm$core$Platform$Cmd$none);
					case 'Email':
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									newfoldRegisterModel: _Utils_update(
										newfoldRegisterModel,
										{email: value})
								}),
							$elm$core$Platform$Cmd$none);
					case 'Password':
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									newfoldRegisterModel: _Utils_update(
										newfoldRegisterModel,
										{password: value})
								}),
							$elm$core$Platform$Cmd$none);
					case 'PasswordAgain':
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									newfoldRegisterModel: _Utils_update(
										newfoldRegisterModel,
										{passwordAgain: value})
								}),
							$elm$core$Platform$Cmd$none);
					default:
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									newfoldRegisterModel: _Utils_update(
										newfoldRegisterModel,
										{referralCode: value})
								}),
							$elm$core$Platform$Cmd$none);
				}
			case 'OnBlur':
				var field = msg.a;
				switch (field.$) {
					case 'SubDomain':
						return _Utils_Tuple2(
							model,
							A2(
								$elm$core$Task$perform,
								$author$project$Types$OnNewfoldRegister,
								$elm$core$Task$succeed($author$project$Type$NewfoldRegister$OnValidateDomain)));
					case 'CompanyName':
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									newfoldRegisterModel: _Utils_update(
										newfoldRegisterModel,
										{
											companyNameError: A2($author$project$Model$NewfoldRegister$validateNotEmpty, 'Company name', newfoldRegisterModel.companyName)
										})
								}),
							$elm$core$Platform$Cmd$none);
					case 'FirstName':
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									newfoldRegisterModel: _Utils_update(
										newfoldRegisterModel,
										{
											firstNameError: A2($author$project$Model$NewfoldRegister$validateNotEmpty, 'First name', newfoldRegisterModel.firstName)
										})
								}),
							$elm$core$Platform$Cmd$none);
					case 'LastName':
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									newfoldRegisterModel: _Utils_update(
										newfoldRegisterModel,
										{
											lastNameError: A2($author$project$Model$NewfoldRegister$validateNotEmpty, 'Last name', newfoldRegisterModel.lastName)
										})
								}),
							$elm$core$Platform$Cmd$none);
					case 'Email':
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									newfoldRegisterModel: _Utils_update(
										newfoldRegisterModel,
										{
											emailError: $author$project$Data$Validator$validateEmail(newfoldRegisterModel.email)
										})
								}),
							$elm$core$Platform$Cmd$none);
					case 'Password':
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									newfoldRegisterModel: _Utils_update(
										newfoldRegisterModel,
										{
											passwordError: $author$project$Data$Validator$validatePassword(newfoldRegisterModel.password)
										})
								}),
							$elm$core$Platform$Cmd$none);
					case 'PasswordAgain':
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									newfoldRegisterModel: _Utils_update(
										newfoldRegisterModel,
										{
											passwordAgainError: A2($author$project$Data$Validator$validatePasswordAgain, newfoldRegisterModel.password, newfoldRegisterModel.passwordAgain)
										})
								}),
							$elm$core$Platform$Cmd$none);
					default:
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 'OnAgreeTerms':
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							newfoldRegisterModel: _Utils_update(
								newfoldRegisterModel,
								{hasAgreedTerms: !newfoldRegisterModel.hasAgreedTerms, hasAgreedTermsError: $elm$core$Maybe$Nothing})
						}),
					$elm$core$Platform$Cmd$none);
			case 'OnValidateDomain':
				var domainLength = $elm$core$String$length(
					$elm$core$String$trim(newfoldRegisterModel.subdomain));
				return ((domainLength > 0) && (domainLength <= 63)) ? _Utils_Tuple2(
					_Utils_update(
						model,
						{
							newfoldRegisterModel: _Utils_update(
								newfoldRegisterModel,
								{subdomainError: $elm$core$Maybe$Nothing, validationStatus: $author$project$Type$NewfoldRegister$Validating})
						}),
					A2(
						$author$project$Model$NewfoldRegister$validateSubDomain,
						apiEndPoint.validateDomain,
						$elm$core$String$toLower(
							$author$project$Model$NewfoldRegister$trimRemoveSpace(newfoldRegisterModel.subdomain)))) : ((domainLength > 63) ? _Utils_Tuple2(
					_Utils_update(
						model,
						{
							newfoldRegisterModel: _Utils_update(
								newfoldRegisterModel,
								{
									subdomainError: $elm$core$Maybe$Just('Subdomain cannot exceed 63 characters.'),
									subdomainStatus: $elm$core$Maybe$Nothing
								})
						}),
					$elm$core$Platform$Cmd$none) : _Utils_Tuple2(
					_Utils_update(
						model,
						{
							newfoldRegisterModel: _Utils_update(
								newfoldRegisterModel,
								{
									subdomainError: $elm$core$Maybe$Just('Subdomain cannot be empty.'),
									subdomainStatus: $elm$core$Maybe$Nothing
								})
						}),
					$elm$core$Platform$Cmd$none));
			case 'OnValidateDomainResponse':
				var result = msg.a;
				if (result.$ === 'Ok') {
					var status = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								newfoldRegisterModel: _Utils_update(
									newfoldRegisterModel,
									{
										subdomainError: $author$project$Model$NewfoldRegister$validateSubDomainErrorString(status.status),
										subdomainStatus: $elm$core$Maybe$Just(status.status),
										validationStatus: $author$project$Type$NewfoldRegister$Loaded
									})
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								newfoldRegisterModel: _Utils_update(
									newfoldRegisterModel,
									{validationStatus: $author$project$Type$NewfoldRegister$Retry})
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 'OnSubmit':
				var _v6 = newfoldRegisterModel;
				var subdomain = _v6.subdomain;
				var companyName = _v6.companyName;
				var firstName = _v6.firstName;
				var lastName = _v6.lastName;
				var email = _v6.email;
				var password = _v6.password;
				var passwordAgain = _v6.passwordAgain;
				var hasAgreedTerms = _v6.hasAgreedTerms;
				var referralCode = _v6.referralCode;
				var updatedRegisterModel = function (m) {
					return _Utils_update(
						m,
						{
							hasAgreedTermsError: $author$project$Model$NewfoldRegister$validateHasAgreedTerms(hasAgreedTerms)
						});
				}(
					function (m) {
						return _Utils_update(
							m,
							{
								passwordAgainError: A2($author$project$Data$Validator$validatePasswordAgain, password, passwordAgain)
							});
					}(
						function (m) {
							return _Utils_update(
								m,
								{
									passwordError: $author$project$Data$Validator$validatePassword(password)
								});
						}(
							function (m) {
								return _Utils_update(
									m,
									{
										emailError: $author$project$Data$Validator$validateEmail(email)
									});
							}(
								function (m) {
									return _Utils_update(
										m,
										{
											lastNameError: A2($author$project$Model$NewfoldRegister$validateNotEmpty, 'Last name', lastName)
										});
								}(
									function (m) {
										return _Utils_update(
											m,
											{
												firstNameError: A2($author$project$Model$NewfoldRegister$validateNotEmpty, 'First name', firstName)
											});
									}(
										_Utils_update(
											newfoldRegisterModel,
											{
												companyNameError: A2($author$project$Model$NewfoldRegister$validateNotEmpty, 'Company name', companyName)
											})))))));
				var allPassed = A2(
					$elm$core$List$all,
					$elm$core$Basics$eq($elm$core$Maybe$Nothing),
					_List_fromArray(
						[updatedRegisterModel.companyNameError, updatedRegisterModel.firstNameError, updatedRegisterModel.lastNameError, updatedRegisterModel.emailError, updatedRegisterModel.passwordError, updatedRegisterModel.passwordAgainError, updatedRegisterModel.hasAgreedTermsError]));
				var validStatus = A2(
					$elm$core$Maybe$withDefault,
					false,
					A2(
						$elm$core$Maybe$map,
						function (status) {
							return _Utils_eq(status, $author$project$Data$Api$Register$ValidateDomain$NotUse);
						},
						updatedRegisterModel.subdomainStatus));
				if (allPassed && validStatus) {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								newfoldRegisterModel: _Utils_update(
									updatedRegisterModel,
									{formStatus: $author$project$Type$NewfoldRegister$Submitting})
							}),
						A2(
							$author$project$Model$NewfoldRegister$submitCmd,
							model.apiEndPoint.newfoldRegister,
							{
								companyName: companyName,
								email: email,
								firstName: firstName,
								lastName: lastName,
								password: password,
								referralCode: referralCode,
								subdomain: $elm$core$String$toLower(
									$author$project$Model$NewfoldRegister$trimRemoveSpace(subdomain))
							}));
				} else {
					if (!validStatus) {
						var _v7 = updatedRegisterModel.subdomainStatus;
						if (_v7.$ === 'Nothing') {
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{
										newfoldRegisterModel: _Utils_update(
											updatedRegisterModel,
											{
												formStatus: $author$project$Type$NewfoldRegister$Ready,
												subdomainError: $elm$core$Maybe$Just('Domain name cannot be empty')
											})
									}),
								$elm$core$Platform$Cmd$none);
						} else {
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{
										newfoldRegisterModel: _Utils_update(
											updatedRegisterModel,
											{formStatus: $author$project$Type$NewfoldRegister$Ready})
									}),
								$elm$core$Platform$Cmd$none);
						}
					} else {
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									newfoldRegisterModel: _Utils_update(
										updatedRegisterModel,
										{formStatus: $author$project$Type$NewfoldRegister$Ready})
								}),
							$elm$core$Platform$Cmd$none);
					}
				}
			case 'OnSubmitResponse':
				var result = msg.a;
				if (result.$ === 'Ok') {
					return _Utils_Tuple2(
						model,
						$elm$browser$Browser$Navigation$load($author$project$Data$Route$routeUrl.registerSuccess));
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								newfoldRegisterModel: _Utils_update(
									newfoldRegisterModel,
									{
										formStatus: $author$project$Type$NewfoldRegister$Error(error)
									})
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 'OnRedirectError':
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							newfoldRegisterModel: _Utils_update(
								newfoldRegisterModel,
								{
									formStatus: $author$project$Type$NewfoldRegister$Ready,
									redirectError: $elm$core$Maybe$Just('Unable to redirect to stripe, please try again.')
								})
						}),
					$elm$core$Platform$Cmd$none);
			default:
				return _Utils_Tuple2(
					model,
					$author$project$Model$NewfoldRegister$jumpToForm('businessRegister'));
		}
	});
var $author$project$Type$PersonalRegister$Error = function (a) {
	return {$: 'Error', a: a};
};
var $author$project$Type$PersonalRegister$IsQueryParam = function (a) {
	return {$: 'IsQueryParam', a: a};
};
var $author$project$Type$PersonalRegister$SubmitResponse = F2(
	function (a, b) {
		return {$: 'SubmitResponse', a: a, b: b};
	});
var $author$project$Type$PersonalRegister$Submitting = {$: 'Submitting'};
var $author$project$Data$Api$Register$Personal$Payload = F6(
	function (id, firstName, lastName, email, createdAt, updatedAt) {
		return {createdAt: createdAt, email: email, firstName: firstName, id: id, lastName: lastName, updatedAt: updatedAt};
	});
var $author$project$Data$Api$Register$Personal$dataDecoder = A2(
	$elm$json$Json$Decode$field,
	'user',
	A7(
		$elm$json$Json$Decode$map6,
		$author$project$Data$Api$Register$Personal$Payload,
		A2($elm$json$Json$Decode$field, 'id', $elm$json$Json$Decode$string),
		A2($elm$json$Json$Decode$field, 'firstName', $elm$json$Json$Decode$string),
		A2($elm$json$Json$Decode$field, 'lastName', $elm$json$Json$Decode$string),
		A2($elm$json$Json$Decode$field, 'email', $elm$json$Json$Decode$string),
		A2(
			$elm$json$Json$Decode$map,
			$elm$time$Time$millisToPosix,
			A2($elm$json$Json$Decode$field, 'createdAt', $elm$json$Json$Decode$int)),
		A2(
			$elm$json$Json$Decode$map,
			$elm$time$Time$millisToPosix,
			A2($elm$json$Json$Decode$field, 'updatedAt', $elm$json$Json$Decode$int))));
var $author$project$Data$Api$Register$Personal$maybeStringEncoder = function (maybeString) {
	if (maybeString.$ === 'Just') {
		var string = maybeString.a;
		return $elm$json$Json$Encode$string(string);
	} else {
		return $elm$json$Json$Encode$null;
	}
};
var $author$project$Data$Api$Register$Personal$encode = function (params) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'firstName',
				$elm$json$Json$Encode$string(params.firstName)),
				_Utils_Tuple2(
				'lastName',
				$elm$json$Json$Encode$string(params.lastName)),
				_Utils_Tuple2(
				'email',
				$elm$json$Json$Encode$string(params.email)),
				_Utils_Tuple2(
				'password',
				$elm$json$Json$Encode$string(params.password)),
				_Utils_Tuple2(
				'referralCode',
				$author$project$Data$Api$Register$Personal$maybeStringEncoder(params.referralCode))
			]));
};
var $author$project$Data$Api$Register$Personal$EMPTY_NAME = {$: 'EMPTY_NAME'};
var $author$project$Data$Api$Register$Personal$INVALID_EMAIL = {$: 'INVALID_EMAIL'};
var $author$project$Data$Api$Register$Personal$LIMIT_REACHED = {$: 'LIMIT_REACHED'};
var $author$project$Data$Api$Register$Personal$PASSWORD_REQUIREMENT = {$: 'PASSWORD_REQUIREMENT'};
var $author$project$Data$Api$Register$Personal$UPDATE_ANONYMOUS = {$: 'UPDATE_ANONYMOUS'};
var $author$project$Data$Api$Register$Personal$USER_EXIST = {$: 'USER_EXIST'};
var $author$project$Data$Api$Register$Personal$errorDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (errorCode) {
		switch (errorCode) {
			case 'USER_EXIST':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$Register$Personal$USER_EXIST);
			case 'PASSWORD_REQUIREMENT':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$Register$Personal$PASSWORD_REQUIREMENT);
			case 'INVALID_EMAIL':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$Register$Personal$INVALID_EMAIL);
			case 'EMPTY_NAME':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$Register$Personal$EMPTY_NAME);
			case 'UPDATE_ANONYMOUS':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$Register$Personal$UPDATE_ANONYMOUS);
			case 'LIMIT_REACHED':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$Register$Personal$LIMIT_REACHED);
			default:
				return $elm$json$Json$Decode$fail('Invalid error code: ' + errorCode);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Data$Api$Register$Personal$call = F2(
	function (endPoint, params) {
		return A4(
			$author$project$Data$Api$httpTask,
			endPoint,
			$author$project$Data$Api$Register$Personal$errorDecoder,
			$author$project$Data$Api$Register$Personal$dataDecoder,
			$author$project$Data$Api$Register$Personal$encode(params));
	});
var $author$project$Model$PersonalRegister$getQueryParamValue = function (field) {
	if (field.$ === 'IsQueryParam') {
		var value = field.a;
		return value;
	} else {
		var value = field.a;
		return value;
	}
};
var $author$project$Model$PersonalRegister$validateHasAgreedTerms = function (hasAgreed) {
	return hasAgreed ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just('You must agree to the terms of service and privacy policy to sign up.');
};
var $author$project$Model$PersonalRegister$validateNotEmpty = F2(
	function (fieldName, value) {
		return $elm$core$String$isEmpty(value) ? $elm$core$Maybe$Just(fieldName + ' is required.') : $elm$core$Maybe$Nothing;
	});
var $author$project$Model$PersonalRegister$update = F2(
	function (msg, model) {
		var setParamField = F2(
			function (currentValue, newValue) {
				if (currentValue.$ === 'IsQueryParam') {
					return $author$project$Type$PersonalRegister$IsQueryParam(newValue);
				} else {
					return $author$project$Type$PersonalRegister$NotQueryParam(newValue);
				}
			});
		var _v0 = model;
		var registerModel = _v0.registerModel;
		switch (msg.$) {
			case 'OnLoad':
				var email = msg.a.email;
				var ref = msg.a.ref;
				var redirect = msg.a.redirect;
				var emptyField = $author$project$Type$PersonalRegister$NotQueryParam('');
				var formatQueryParam = function (value) {
					return A2(
						$elm$core$Maybe$withDefault,
						emptyField,
						A2($elm$core$Maybe$map, $author$project$Type$PersonalRegister$IsQueryParam, value));
				};
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							registerModel: _Utils_update(
								registerModel,
								{
									email: formatQueryParam(email),
									redirect: redirect,
									referralCode: formatQueryParam(ref)
								})
						}),
					$elm$core$Platform$Cmd$none);
			case 'OnInput':
				var field = msg.a;
				var value = msg.b;
				switch (field.$) {
					case 'FirstName':
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									registerModel: _Utils_update(
										registerModel,
										{firstName: value})
								}),
							$elm$core$Platform$Cmd$none);
					case 'LastName':
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									registerModel: _Utils_update(
										registerModel,
										{lastName: value})
								}),
							$elm$core$Platform$Cmd$none);
					case 'Email':
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									registerModel: _Utils_update(
										registerModel,
										{
											email: A2(setParamField, registerModel.email, value)
										})
								}),
							$elm$core$Platform$Cmd$none);
					case 'Password':
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									registerModel: _Utils_update(
										registerModel,
										{password: value})
								}),
							$elm$core$Platform$Cmd$none);
					case 'PasswordAgain':
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									registerModel: _Utils_update(
										registerModel,
										{passwordAgain: value})
								}),
							$elm$core$Platform$Cmd$none);
					default:
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									registerModel: _Utils_update(
										registerModel,
										{
											referralCode: A2(setParamField, registerModel.referralCode, value)
										})
								}),
							$elm$core$Platform$Cmd$none);
				}
			case 'OnBlur':
				var field = msg.a;
				switch (field.$) {
					case 'FirstName':
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									registerModel: _Utils_update(
										registerModel,
										{
											firstNameError: A2($author$project$Model$PersonalRegister$validateNotEmpty, 'First name', registerModel.firstName)
										})
								}),
							$elm$core$Platform$Cmd$none);
					case 'LastName':
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									registerModel: _Utils_update(
										registerModel,
										{
											lastNameError: A2($author$project$Model$PersonalRegister$validateNotEmpty, 'Last name', registerModel.lastName)
										})
								}),
							$elm$core$Platform$Cmd$none);
					case 'Email':
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									registerModel: _Utils_update(
										registerModel,
										{
											emailError: $author$project$Data$Validator$validateEmail(
												$author$project$Model$PersonalRegister$getQueryParamValue(registerModel.email))
										})
								}),
							$elm$core$Platform$Cmd$none);
					case 'Password':
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									registerModel: _Utils_update(
										registerModel,
										{
											passwordError: $author$project$Data$Validator$validatePassword(registerModel.password)
										})
								}),
							$elm$core$Platform$Cmd$none);
					case 'PasswordAgain':
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									registerModel: _Utils_update(
										registerModel,
										{
											passwordAgainError: A2($author$project$Data$Validator$validatePasswordAgain, registerModel.password, registerModel.passwordAgain)
										})
								}),
							$elm$core$Platform$Cmd$none);
					default:
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 'OnAgreeTerms':
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							registerModel: _Utils_update(
								registerModel,
								{hasAgreedTerms: !registerModel.hasAgreedTerms, hasAgreedTermsError: $elm$core$Maybe$Nothing})
						}),
					$elm$core$Platform$Cmd$none);
			case 'OnSubmit':
				var referralCode = function (code) {
					return $elm$core$String$isEmpty(code) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(code);
				}(
					$elm$core$String$trim(
						$author$project$Model$PersonalRegister$getQueryParamValue(registerModel.referralCode)));
				var _v4 = registerModel;
				var firstName = _v4.firstName;
				var lastName = _v4.lastName;
				var email = _v4.email;
				var password = _v4.password;
				var passwordAgain = _v4.passwordAgain;
				var hasAgreedTerms = _v4.hasAgreedTerms;
				var redirect = _v4.redirect;
				var updatedRegisterModel = function (m) {
					return _Utils_update(
						m,
						{
							hasAgreedTermsError: $author$project$Model$PersonalRegister$validateHasAgreedTerms(hasAgreedTerms)
						});
				}(
					function (m) {
						return _Utils_update(
							m,
							{
								passwordAgainError: A2($author$project$Data$Validator$validatePasswordAgain, password, passwordAgain)
							});
					}(
						function (m) {
							return _Utils_update(
								m,
								{
									passwordError: $author$project$Data$Validator$validatePassword(password)
								});
						}(
							function (m) {
								return _Utils_update(
									m,
									{
										emailError: $author$project$Data$Validator$validateEmail(
											$author$project$Model$PersonalRegister$getQueryParamValue(email))
									});
							}(
								function (m) {
									return _Utils_update(
										m,
										{
											lastNameError: A2($author$project$Model$PersonalRegister$validateNotEmpty, 'Last name', lastName)
										});
								}(
									_Utils_update(
										registerModel,
										{
											firstNameError: A2($author$project$Model$PersonalRegister$validateNotEmpty, 'First name', firstName)
										}))))));
				var allPassed = A2(
					$elm$core$List$all,
					$elm$core$Basics$eq($elm$core$Maybe$Nothing),
					_List_fromArray(
						[updatedRegisterModel.firstNameError, updatedRegisterModel.lastNameError, updatedRegisterModel.emailError, updatedRegisterModel.passwordError, updatedRegisterModel.passwordAgainError, updatedRegisterModel.hasAgreedTermsError]));
				return allPassed ? _Utils_Tuple2(
					_Utils_update(
						model,
						{
							registerModel: _Utils_update(
								updatedRegisterModel,
								{formStatus: $author$project$Type$PersonalRegister$Submitting})
						}),
					A2(
						$elm$core$Task$attempt,
						A2(
							$elm$core$Basics$composeL,
							$author$project$Types$OnRegister,
							$author$project$Type$PersonalRegister$SubmitResponse(redirect)),
						A2(
							$author$project$Data$Api$Register$Personal$call,
							model.apiEndPoint.registerPersonal,
							{
								email: $author$project$Model$PersonalRegister$getQueryParamValue(email),
								firstName: firstName,
								lastName: lastName,
								password: password,
								referralCode: referralCode
							}))) : _Utils_Tuple2(
					_Utils_update(
						model,
						{
							registerModel: _Utils_update(
								updatedRegisterModel,
								{formStatus: $author$project$Type$PersonalRegister$Ready})
						}),
					$elm$core$Platform$Cmd$none);
			default:
				var redirectUrl = msg.a;
				var result = msg.b;
				if (result.$ === 'Ok') {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								registerModel: _Utils_update(
									registerModel,
									{formStatus: $author$project$Type$PersonalRegister$Ready})
							}),
						$elm$browser$Browser$Navigation$load(
							A2($elm$core$Maybe$withDefault, $author$project$Data$Route$routeUrl.registerSuccess, redirectUrl)));
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								registerModel: _Utils_update(
									registerModel,
									{
										formStatus: $author$project$Type$PersonalRegister$Error(error)
									})
							}),
						$elm$core$Platform$Cmd$none);
				}
		}
	});
var $author$project$Types$OnPointsTopUp = function (a) {
	return {$: 'OnPointsTopUp', a: a};
};
var $author$project$Type$PointsTopUp$OnSubmitResponse = function (a) {
	return {$: 'OnSubmitResponse', a: a};
};
var $author$project$Data$Api$TopUpPoints$Payload = function (sessionId) {
	return {sessionId: sessionId};
};
var $author$project$Data$Api$TopUpPoints$dataDecoder = A2(
	$elm$json$Json$Decode$map,
	$author$project$Data$Api$TopUpPoints$Payload,
	A2($elm$json$Json$Decode$field, 'sessionId', $elm$json$Json$Decode$string));
var $author$project$Data$Api$TopUpPoints$encode = function (params) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'amount',
				$elm$json$Json$Encode$int(params.amount))
			]));
};
var $author$project$Data$Api$TopUpPoints$INVALID_COMPANYNAME = {$: 'INVALID_COMPANYNAME'};
var $author$project$Data$Api$TopUpPoints$INVALID_SUBDOMAIN = {$: 'INVALID_SUBDOMAIN'};
var $author$project$Data$Api$TopUpPoints$errorDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (errorCode) {
		switch (errorCode) {
			case 'INVALID_SUBDOMAIN':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$TopUpPoints$INVALID_SUBDOMAIN);
			case 'INVALID_COMPANYNAME':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$TopUpPoints$INVALID_COMPANYNAME);
			default:
				return $elm$json$Json$Decode$fail('Invalid error code: ' + errorCode);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Data$Api$TopUpPoints$authCall = F3(
	function (jwt, endPoint, params) {
		return A5(
			$author$project$Data$Api$authCall,
			jwt,
			endPoint,
			$author$project$Data$Api$TopUpPoints$errorDecoder,
			$author$project$Data$Api$TopUpPoints$dataDecoder,
			$author$project$Data$Api$TopUpPoints$encode(params));
	});
var $author$project$Model$PointTopUp$update = F3(
	function (msg, authModel, model) {
		var updateModel = function (updatedModel) {
			return _Utils_update(
				model,
				{
					sessionModel: $author$project$Types$Auth(
						_Utils_update(
							authModel,
							{pointsTopUpModel: updatedModel}))
				});
		};
		var _v0 = authModel;
		var pointsTopUpModel = _v0.pointsTopUpModel;
		var _v1 = model;
		var apiEndPoint = _v1.apiEndPoint;
		var _v2 = pointsTopUpModel;
		var amount = _v2.amount;
		switch (msg.$) {
			case 'OnSubmit':
				return _Utils_Tuple2(
					model,
					A2(
						$elm$core$Task$attempt,
						A2(
							$elm$core$Basics$composeL,
							A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnPointsTopUp),
							$author$project$Type$PointsTopUp$OnSubmitResponse),
						A3(
							$author$project$Data$Api$TopUpPoints$authCall,
							authModel.user.jwt,
							apiEndPoint.pointsTopUp,
							{amount: amount})));
			case 'OnSubmitResponse':
				var result = msg.a;
				if (result.$ === 'Ok') {
					var value = result.a;
					return _Utils_Tuple2(
						model,
						$author$project$Model$BusinessCreate$checkoutToStripeCreateBusiness(
							$elm$json$Json$Encode$string(value.sessionId)));
				} else {
					var error = result.a;
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 'OnRedirectError':
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			default:
				var newValue = msg.a;
				var intValue = A2(
					$elm$core$Maybe$withDefault,
					1,
					$elm$core$String$toInt(newValue));
				return _Utils_Tuple2(
					updateModel(
						_Utils_update(
							pointsTopUpModel,
							{amount: intValue})),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Type$PointTransaction$OnApiResponse = function (a) {
	return {$: 'OnApiResponse', a: a};
};
var $author$project$Data$Api$Points$PointsTransaction$Payload = function (transactionData) {
	return {transactionData: transactionData};
};
var $author$project$Data$Api$Points$PointsTransaction$TransactionData = function (id) {
	return function (sender) {
		return function (receiver) {
			return function (amount) {
				return function (status) {
					return function (createdAt) {
						return function (confirmAt) {
							return function (ipAddr) {
								return function (remarks) {
									return function (senderRole) {
										return {amount: amount, confirmAt: confirmAt, createdAt: createdAt, id: id, ipAddr: ipAddr, receiver: receiver, remarks: remarks, sender: sender, senderRole: senderRole, status: status};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Data$Api$Points$PointsTransaction$decodeTransaction = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'senderRole',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'remarks',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'ipAddr',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'confirmAt',
				A2(
					$elm$json$Json$Decode$map,
					function (confirmAt) {
						return A2($elm$core$Maybe$map, $elm$time$Time$millisToPosix, confirmAt);
					},
					$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int)),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'createdAt',
					A2($elm$json$Json$Decode$map, $elm$time$Time$millisToPosix, $elm$json$Json$Decode$int),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'status',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'amount',
							$elm$json$Json$Decode$float,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'receiver',
								$elm$json$Json$Decode$string,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'sender',
									$elm$json$Json$Decode$string,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'id',
										$elm$json$Json$Decode$string,
										$elm$json$Json$Decode$succeed($author$project$Data$Api$Points$PointsTransaction$TransactionData)))))))))));
var $author$project$Data$Api$Points$PointsTransaction$dataDecoder = A2(
	$elm$json$Json$Decode$map,
	$author$project$Data$Api$Points$PointsTransaction$Payload,
	A2($elm$json$Json$Decode$field, 'transactionData', $author$project$Data$Api$Points$PointsTransaction$decodeTransaction));
var $author$project$Data$Api$Points$PointsTransaction$encode = function (transactionID) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'transactionID',
				$elm$json$Json$Encode$string(transactionID))
			]));
};
var $author$project$Data$Api$Points$PointsTransaction$INVALID_ID = {$: 'INVALID_ID'};
var $author$project$Data$Api$Points$PointsTransaction$INVALID_USER = {$: 'INVALID_USER'};
var $author$project$Data$Api$Points$PointsTransaction$errorDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (errorCode) {
		switch (errorCode) {
			case 'INVALID_ID':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$Points$PointsTransaction$INVALID_ID);
			case 'INVALID_USER':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$Points$PointsTransaction$INVALID_USER);
			default:
				return $elm$json$Json$Decode$fail('Invalid error code: ' + errorCode);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Data$Api$Points$PointsTransaction$authCall = F3(
	function (jwt, endPoint, transactionID) {
		return A5(
			$author$project$Data$Api$authCall,
			jwt,
			endPoint,
			$author$project$Data$Api$Points$PointsTransaction$errorDecoder,
			$author$project$Data$Api$Points$PointsTransaction$dataDecoder,
			$author$project$Data$Api$Points$PointsTransaction$encode(transactionID));
	});
var $author$project$Type$PointTransactionTable$Completed = {$: 'Completed'};
var $author$project$Type$PointTransactionTable$Declined = {$: 'Declined'};
var $author$project$Type$PointTransactionTable$Expired = {$: 'Expired'};
var $author$project$Type$PointTransactionTable$Pending = {$: 'Pending'};
var $author$project$Type$PointTransactionTable$Processing = {$: 'Processing'};
var $author$project$Type$PointTransactionTable$textToStatus = function (status) {
	switch (status) {
		case 'Completed':
			return $author$project$Type$PointTransactionTable$Completed;
		case 'Pending':
			return $author$project$Type$PointTransactionTable$Pending;
		case 'Expired':
			return $author$project$Type$PointTransactionTable$Expired;
		case 'Processing':
			return $author$project$Type$PointTransactionTable$Processing;
		case 'Declined':
			return $author$project$Type$PointTransactionTable$Declined;
		default:
			return $author$project$Type$PointTransactionTable$Pending;
	}
};
var $author$project$Type$PointTransactionTable$Admin = {$: 'Admin'};
var $author$project$Type$PointTransactionTable$System = {$: 'System'};
var $author$project$Type$PointTransactionTable$User = {$: 'User'};
var $author$project$Type$PointTransactionTable$textToTransactionType = function (transactionType) {
	switch (transactionType) {
		case 'User':
			return $author$project$Type$PointTransactionTable$User;
		case 'System':
			return $author$project$Type$PointTransactionTable$System;
		case 'Admin':
			return $author$project$Type$PointTransactionTable$Admin;
		default:
			return $author$project$Type$PointTransactionTable$User;
	}
};
var $author$project$Model$PointTransaction$update = F3(
	function (msg, model, authModel) {
		var updateCurrentModel = function (currentModel) {
			return _Utils_update(
				model,
				{
					sessionModel: $author$project$Types$Auth(
						_Utils_update(
							authModel,
							{transactionModel: currentModel}))
				});
		};
		var _v0 = authModel;
		var transactionModel = _v0.transactionModel;
		switch (msg.$) {
			case 'OnPageEnter':
				var transactionID = msg.a;
				return _Utils_Tuple2(
					updateCurrentModel(
						_Utils_update(
							transactionModel,
							{
								transactionID: $elm$core$Maybe$Just(transactionID)
							})),
					A2(
						$elm$core$Task$attempt,
						A2(
							$elm$core$Basics$composeL,
							A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnPointTransaction),
							$author$project$Type$PointTransaction$OnApiResponse),
						A3($author$project$Data$Api$Points$PointsTransaction$authCall, authModel.user.jwt, model.apiEndPoint.pointsTransaction, transactionID)));
			case 'OnApiResponse':
				var response = msg.a;
				if (response.$ === 'Ok') {
					var transactionData = response.a.transactionData;
					var newTransactionData = {
						amount: transactionData.amount,
						confirmAt: transactionData.confirmAt,
						createdAt: transactionData.createdAt,
						from: transactionData.sender,
						id: transactionData.id,
						ipAddr: transactionData.ipAddr,
						remarks: transactionData.remarks,
						status: $author$project$Type$PointTransactionTable$textToStatus(transactionData.status),
						to: transactionData.receiver,
						transaction: $author$project$Type$PointTransactionTable$textToTransactionType(transactionData.senderRole)
					};
					return _Utils_Tuple2(
						updateCurrentModel(
							_Utils_update(
								transactionModel,
								{
									error: false,
									transaction: $elm$core$Maybe$Just(newTransactionData)
								})),
						$elm$core$Platform$Cmd$none);
				} else {
					return _Utils_Tuple2(
						updateCurrentModel(
							_Utils_update(
								transactionModel,
								{error: true})),
						$elm$core$Platform$Cmd$none);
				}
			default:
				var _v3 = transactionModel.transactionID;
				if (_v3.$ === 'Just') {
					var id = _v3.a;
					return _Utils_Tuple2(
						model,
						A2(
							$elm$core$Task$attempt,
							A2(
								$elm$core$Basics$composeL,
								A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnPointTransaction),
								$author$project$Type$PointTransaction$OnApiResponse),
							A3($author$project$Data$Api$Points$PointsTransaction$authCall, authModel.user.jwt, model.apiEndPoint.pointsTransaction, id)));
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
		}
	});
var $author$project$Type$PointTransactionTable$In = {$: 'In'};
var $author$project$Type$PointTransactionHistory$OnApiResponse = F3(
	function (a, b, c) {
		return {$: 'OnApiResponse', a: a, b: b, c: c};
	});
var $author$project$Type$PointTransactionTable$Out = {$: 'Out'};
var $author$project$Data$Api$Points$PointsTransactionHistory$Payload = F2(
	function (transactionHistory, transactionCount) {
		return {transactionCount: transactionCount, transactionHistory: transactionHistory};
	});
var $author$project$Data$Api$Points$PointsTransactionHistory$TransactionData = F8(
	function (id, sender, receiver, amount, status, createdAt, confirmAt, senderRole) {
		return {amount: amount, confirmAt: confirmAt, createdAt: createdAt, id: id, receiver: receiver, sender: sender, senderRole: senderRole, status: status};
	});
var $author$project$Data$Api$Points$PointsTransactionHistory$decodeTransaction = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'senderRole',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'confirmAt',
		A2(
			$elm$json$Json$Decode$map,
			function (confirmAt) {
				return A2($elm$core$Maybe$map, $elm$time$Time$millisToPosix, confirmAt);
			},
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int)),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'createdAt',
			A2($elm$json$Json$Decode$map, $elm$time$Time$millisToPosix, $elm$json$Json$Decode$int),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'status',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'amount',
					$elm$json$Json$Decode$float,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'receiver',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'sender',
							$elm$json$Json$Decode$string,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'id',
								$elm$json$Json$Decode$string,
								$elm$json$Json$Decode$succeed($author$project$Data$Api$Points$PointsTransactionHistory$TransactionData)))))))));
var $author$project$Data$Api$Points$PointsTransactionHistory$dataDecoder = A3(
	$elm$json$Json$Decode$map2,
	$author$project$Data$Api$Points$PointsTransactionHistory$Payload,
	A2(
		$elm$json$Json$Decode$field,
		'transactionHistory',
		$elm$json$Json$Decode$list($author$project$Data$Api$Points$PointsTransactionHistory$decodeTransaction)),
	A2($elm$json$Json$Decode$field, 'transactionCount', $elm$json$Json$Decode$int));
var $author$project$Data$Api$Points$PointsTransactionHistory$encode = F2(
	function (page, pageSize) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'page',
					$elm$json$Json$Encode$int(page)),
					_Utils_Tuple2(
					'pageSize',
					$elm$json$Json$Encode$int(pageSize))
				]));
	});
var $author$project$Data$Api$Points$PointsTransactionHistory$errorDecoder = $elm$json$Json$Decode$succeed(_Utils_Tuple0);
var $author$project$Data$Api$Points$PointsTransactionHistory$authCall = F4(
	function (jwt, endPoint, page, pageSize) {
		return A5(
			$author$project$Data$Api$authCall,
			jwt,
			endPoint,
			$author$project$Data$Api$Points$PointsTransactionHistory$errorDecoder,
			$author$project$Data$Api$Points$PointsTransactionHistory$dataDecoder,
			A2($author$project$Data$Api$Points$PointsTransactionHistory$encode, page, pageSize));
	});
var $author$project$Model$PointTransactionHistory$update = F3(
	function (msg, model, authModel) {
		var updateCurrentModel = function (currentModel) {
			return _Utils_update(
				model,
				{
					sessionModel: $author$project$Types$Auth(
						_Utils_update(
							authModel,
							{transactionHistoryModel: currentModel}))
				});
		};
		var _v0 = authModel;
		var transactionHistoryModel = _v0.transactionHistoryModel;
		var user = _v0.user;
		switch (msg.$) {
			case 'OnPageEnter':
				return _Utils_Tuple2(
					model,
					A2(
						$elm$core$Task$attempt,
						A2(
							$elm$core$Basics$composeL,
							A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnPointTransactionHistory),
							A2($author$project$Type$PointTransactionHistory$OnApiResponse, 0, 10)),
						A4($author$project$Data$Api$Points$PointsTransactionHistory$authCall, authModel.user.jwt, model.apiEndPoint.pointsTransactionHistory, 0, 10)));
			case 'OnApiResponse':
				var newPage = msg.a;
				var pageSize = msg.b;
				var response = msg.c;
				if (response.$ === 'Ok') {
					var result = response.a;
					var transactionHistory = A2(
						$elm$core$List$map,
						function (transaction) {
							var inOut = _Utils_eq(user.email, transaction.sender) ? $author$project$Type$PointTransactionTable$Out : $author$project$Type$PointTransactionTable$In;
							return {
								amount: transaction.amount,
								from: transaction.sender,
								id: transaction.id,
								inOut: inOut,
								status: $author$project$Type$PointTransactionTable$textToStatus(transaction.status),
								timeStamp: transaction.createdAt,
								to: transaction.receiver,
								transaction: $author$project$Type$PointTransactionTable$textToTransactionType(transaction.senderRole)
							};
						},
						result.transactionHistory);
					var newModel = _Utils_update(
						transactionHistoryModel,
						{entryCount: result.transactionCount, pageNumber: newPage, pageSize: pageSize, transactions: transactionHistory});
					return _Utils_Tuple2(
						updateCurrentModel(newModel),
						$elm$core$Platform$Cmd$none);
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 'OnPreviousPage':
				return (!transactionHistoryModel.pageNumber) ? _Utils_Tuple2(model, $elm$core$Platform$Cmd$none) : _Utils_Tuple2(
					model,
					A2(
						$elm$core$Task$attempt,
						A2(
							$elm$core$Basics$composeL,
							A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnPointTransactionHistory),
							A2($author$project$Type$PointTransactionHistory$OnApiResponse, transactionHistoryModel.pageNumber - 1, transactionHistoryModel.pageSize)),
						A4($author$project$Data$Api$Points$PointsTransactionHistory$authCall, authModel.user.jwt, model.apiEndPoint.pointsTransactionHistory, transactionHistoryModel.pageNumber - 1, transactionHistoryModel.pageSize)));
			case 'OnNextPage':
				return (_Utils_cmp(
					$elm$core$Basics$ceiling(transactionHistoryModel.entryCount / transactionHistoryModel.pageSize),
					transactionHistoryModel.pageNumber + 1) > 0) ? _Utils_Tuple2(
					model,
					A2(
						$elm$core$Task$attempt,
						A2(
							$elm$core$Basics$composeL,
							A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnPointTransactionHistory),
							A2($author$project$Type$PointTransactionHistory$OnApiResponse, transactionHistoryModel.pageNumber + 1, transactionHistoryModel.pageSize)),
						A4($author$project$Data$Api$Points$PointsTransactionHistory$authCall, authModel.user.jwt, model.apiEndPoint.pointsTransactionHistory, transactionHistoryModel.pageNumber + 1, transactionHistoryModel.pageSize))) : _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 'OnPageSizeChange':
				var pageSize = msg.a;
				var lastPage = $elm$core$Basics$ceiling(
					transactionHistoryModel.entryCount / A2(
						$elm$core$Maybe$withDefault,
						0,
						$elm$core$String$toFloat(pageSize))) - 1;
				var formattedPageSize = A2(
					$elm$core$Maybe$withDefault,
					10,
					$elm$core$String$toInt(pageSize));
				return (_Utils_cmp(transactionHistoryModel.pageNumber, lastPage) > 0) ? _Utils_Tuple2(
					model,
					A2(
						$elm$core$Task$attempt,
						A2(
							$elm$core$Basics$composeL,
							A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnPointTransactionHistory),
							A2($author$project$Type$PointTransactionHistory$OnApiResponse, lastPage, formattedPageSize)),
						A4($author$project$Data$Api$Points$PointsTransactionHistory$authCall, authModel.user.jwt, model.apiEndPoint.pointsTransactionHistory, lastPage, formattedPageSize))) : _Utils_Tuple2(
					model,
					A2(
						$elm$core$Task$attempt,
						A2(
							$elm$core$Basics$composeL,
							A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnPointTransactionHistory),
							A2($author$project$Type$PointTransactionHistory$OnApiResponse, transactionHistoryModel.pageNumber, formattedPageSize)),
						A4($author$project$Data$Api$Points$PointsTransactionHistory$authCall, authModel.user.jwt, model.apiEndPoint.pointsTransactionHistory, transactionHistoryModel.pageNumber, formattedPageSize)));
			default:
				var transactionID = msg.a;
				return _Utils_Tuple2(
					model,
					A2($elm$browser$Browser$Navigation$pushUrl, model.navKey, $author$project$Data$Route$routeUrl.transaction + ('/' + transactionID)));
		}
	});
var $author$project$Model$PointTransactionTable$update = F2(
	function (msg, model) {
		var transactionID = msg.a;
		return _Utils_Tuple2(
			model,
			A2($elm$browser$Browser$Navigation$pushUrl, model.navKey, $author$project$Data$Route$routeUrl.transaction + ('/' + transactionID)));
	});
var $author$project$Type$PointWithdrawal$Fail = function (a) {
	return {$: 'Fail', a: a};
};
var $author$project$Type$PointWithdrawal$MaxWithdrawAmount = {$: 'MaxWithdrawAmount'};
var $author$project$Type$PointWithdrawal$OnApiResponse = function (a) {
	return {$: 'OnApiResponse', a: a};
};
var $author$project$Type$PointWithdrawal$OnDashboardApiResponse = function (a) {
	return {$: 'OnDashboardApiResponse', a: a};
};
var $author$project$Type$PointWithdrawal$Success = {$: 'Success'};
var $author$project$Type$PointWithdrawal$VerifyToWithdraw = {$: 'VerifyToWithdraw'};
var $author$project$Data$Api$Points$PointWithdrawal$Payload = function (message) {
	return {message: message};
};
var $author$project$Data$Api$Points$PointWithdrawal$dataDecoder = A2(
	$elm$json$Json$Decode$map,
	$author$project$Data$Api$Points$PointWithdrawal$Payload,
	A2($elm$json$Json$Decode$field, 'message', $elm$json$Json$Decode$string));
var $author$project$Data$Api$Points$PointWithdrawal$encode = function (amount) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'amount',
				$elm$json$Json$Encode$int(amount))
			]));
};
var $author$project$Data$Api$Points$PointWithdrawal$INSUFFICIENT_BALANCE = {$: 'INSUFFICIENT_BALANCE'};
var $author$project$Data$Api$Points$PointWithdrawal$INVALID_USER = {$: 'INVALID_USER'};
var $author$project$Data$Api$Points$PointWithdrawal$errorDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (errorCode) {
		switch (errorCode) {
			case 'INVALID_USER':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$Points$PointWithdrawal$INVALID_USER);
			case 'INSUFFICIENT_BALANCE':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$Points$PointWithdrawal$INSUFFICIENT_BALANCE);
			default:
				return $elm$json$Json$Decode$fail('Invalid error code: ' + errorCode);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Data$Api$Points$PointWithdrawal$authCall = F3(
	function (jwt, endPoint, amount) {
		return A5(
			$author$project$Data$Api$authCall,
			jwt,
			endPoint,
			$author$project$Data$Api$Points$PointWithdrawal$errorDecoder,
			$author$project$Data$Api$Points$PointWithdrawal$dataDecoder,
			$author$project$Data$Api$Points$PointWithdrawal$encode(amount));
	});
var $author$project$Data$Api$Points$PointsDashboard$Payload = F4(
	function (transactionHistory, available, pending, usdToPoints) {
		return {available: available, pending: pending, transactionHistory: transactionHistory, usdToPoints: usdToPoints};
	});
var $author$project$Data$Api$Points$PointsDashboard$TransactionData = F8(
	function (id, sender, receiver, amount, status, createdAt, confirmAt, senderRole) {
		return {amount: amount, confirmAt: confirmAt, createdAt: createdAt, id: id, receiver: receiver, sender: sender, senderRole: senderRole, status: status};
	});
var $author$project$Data$Api$Points$PointsDashboard$decodeTransaction = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'senderRole',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'confirmAt',
		A2(
			$elm$json$Json$Decode$map,
			function (confirmAt) {
				return A2($elm$core$Maybe$map, $elm$time$Time$millisToPosix, confirmAt);
			},
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int)),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'createdAt',
			A2($elm$json$Json$Decode$map, $elm$time$Time$millisToPosix, $elm$json$Json$Decode$int),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'status',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'amount',
					$elm$json$Json$Decode$float,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'receiver',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'sender',
							$elm$json$Json$Decode$string,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'id',
								$elm$json$Json$Decode$string,
								$elm$json$Json$Decode$succeed($author$project$Data$Api$Points$PointsDashboard$TransactionData)))))))));
var $author$project$Data$Api$Points$PointsDashboard$dataDecoder = A5(
	$elm$json$Json$Decode$map4,
	$author$project$Data$Api$Points$PointsDashboard$Payload,
	A2(
		$elm$json$Json$Decode$field,
		'transactionHistory',
		$elm$json$Json$Decode$list($author$project$Data$Api$Points$PointsDashboard$decodeTransaction)),
	A2($elm$json$Json$Decode$field, 'available', $elm$json$Json$Decode$float),
	A2($elm$json$Json$Decode$field, 'pending', $elm$json$Json$Decode$float),
	A2($elm$json$Json$Decode$field, 'usdToPoints', $elm$json$Json$Decode$float));
var $author$project$Data$Api$Points$PointsDashboard$errorDecoder = $elm$json$Json$Decode$succeed(_Utils_Tuple0);
var $author$project$Data$Api$Points$PointsDashboard$authCall = F2(
	function (jwt, endPoint) {
		return A5(
			$author$project$Data$Api$authCall,
			jwt,
			endPoint,
			$author$project$Data$Api$Points$PointsDashboard$errorDecoder,
			$author$project$Data$Api$Points$PointsDashboard$dataDecoder,
			$elm$json$Json$Encode$object(_List_Nil));
	});
var $author$project$Model$PointWithdrawal$checkAmount = F2(
	function (amount, balance) {
		var convertedBal = A2(
			$elm$core$Maybe$withDefault,
			0,
			$elm$core$String$toFloat(balance));
		var convertedAmt = $elm$core$String$toFloat(amount);
		if (convertedAmt.$ === 'Just') {
			var amt = convertedAmt.a;
			return (amt <= 0) ? $elm$core$Maybe$Just('Amount cannot be zero or negative.') : ((_Utils_cmp(amt, convertedBal) > 0) ? $elm$core$Maybe$Just('Amount cannot exceed available balance.') : $elm$core$Maybe$Nothing);
		} else {
			return $elm$core$Maybe$Just('Invalid Number.');
		}
	});
var $author$project$Data$Api$Points$PointWithdrawal$errorToString = function (error) {
	if (error.$ === 'INVALID_USER') {
		return 'Invalid user';
	} else {
		return 'Insufficient balance in account.';
	}
};
var $author$project$Model$PointWithdrawal$update = F4(
	function (user, msg, model, authModel) {
		var updateCurrentModel = function (currentModel) {
			return _Utils_update(
				model,
				{
					sessionModel: $author$project$Types$Auth(
						_Utils_update(
							authModel,
							{withdrawalModel: currentModel}))
				});
		};
		var _v0 = authModel;
		var withdrawalModel = _v0.withdrawalModel;
		var _v1 = withdrawalModel;
		var sendToken = _v1.sendToken;
		var _v2 = user.trustScore;
		var passbase = _v2.passbase;
		var shuftiPro = _v2.shuftiPro;
		var myInfo = _v2.myInfo;
		switch (msg.$) {
			case 'OnPageEnter':
				return _Utils_Tuple2(
					model,
					A2(
						$elm$core$Task$attempt,
						A2(
							$elm$core$Basics$composeL,
							A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnPointWithdrawal),
							$author$project$Type$PointWithdrawal$OnDashboardApiResponse),
						A2($author$project$Data$Api$Points$PointsDashboard$authCall, authModel.user.jwt, model.apiEndPoint.pointsDashboard)));
			case 'OnDashboardApiResponse':
				var response = msg.a;
				if (response.$ === 'Ok') {
					var result = response.a;
					var balance = _Utils_update(
						withdrawalModel,
						{available: result.available, pending: result.pending});
					return _Utils_Tuple2(
						updateCurrentModel(balance),
						$elm$core$Platform$Cmd$none);
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 'OnApiResponse':
				var result = msg.a;
				if (result.$ === 'Ok') {
					var newTokenManagement = _Utils_update(
						withdrawalModel,
						{
							sendToken: _Utils_update(
								sendToken,
								{amount: withdrawalModel.amount, amountError: $elm$core$Maybe$Nothing}),
							status: $author$project$Type$PointWithdrawal$Success
						});
					return _Utils_Tuple2(
						updateCurrentModel(newTokenManagement),
						A2($elm$browser$Browser$Navigation$pushUrl, model.navKey, $author$project$Data$Route$routeUrl.verifyTransaction));
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						updateCurrentModel(
							_Utils_update(
								withdrawalModel,
								{
									status: $author$project$Type$PointWithdrawal$Fail(
										A2($author$project$Data$Api$authErrorToString, $author$project$Data$Api$Points$PointWithdrawal$errorToString, error))
								})),
						$elm$core$Platform$Cmd$none);
				}
			case 'OnVerifyClick':
				return _Utils_Tuple2(
					updateCurrentModel(
						_Utils_update(
							withdrawalModel,
							{modal: $author$project$Type$PointWithdrawal$Inactive})),
					A2($elm$browser$Browser$Navigation$pushUrl, model.navKey, $author$project$Data$Route$routeUrl.trustScore));
			case 'OnWithdrawalAmount':
				var inputType = msg.a;
				if (inputType.$ === 'Input') {
					var amount = inputType.a;
					return _Utils_Tuple2(
						updateCurrentModel(
							_Utils_update(
								withdrawalModel,
								{amount: amount})),
						$elm$core$Platform$Cmd$none);
				} else {
					var balance = inputType.a;
					return $elm$core$String$isEmpty(withdrawalModel.amount) ? _Utils_Tuple2(
						updateCurrentModel(
							_Utils_update(
								withdrawalModel,
								{
									sendToken: _Utils_update(
										sendToken,
										{
											amountError: $elm$core$Maybe$Just('Amount cannot be empty.')
										})
								})),
						$elm$core$Platform$Cmd$none) : _Utils_Tuple2(
						updateCurrentModel(
							_Utils_update(
								withdrawalModel,
								{
									sendToken: _Utils_update(
										sendToken,
										{
											amountError: A2($author$project$Model$PointWithdrawal$checkAmount, withdrawalModel.amount, balance)
										})
								})),
						$elm$core$Platform$Cmd$none);
				}
			case 'OnMaxAmount':
				var balance = msg.a;
				return _Utils_Tuple2(
					updateCurrentModel(
						_Utils_update(
							withdrawalModel,
							{amount: balance})),
					$elm$core$Platform$Cmd$none);
			case 'OnWithdraw':
				var withdrawAmount = A2(
					$elm$core$Maybe$withDefault,
					0,
					$elm$core$String$toFloat(withdrawalModel.amount));
				var cmdMsg = ((!$elm$core$String$isEmpty(withdrawalModel.amount)) && _Utils_eq(sendToken.amountError, $elm$core$Maybe$Nothing)) ? A2(
					$elm$core$Task$attempt,
					A2(
						$elm$core$Basics$composeL,
						A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnPointWithdrawal),
						$author$project$Type$PointWithdrawal$OnApiResponse),
					A3(
						$author$project$Data$Api$Points$PointWithdrawal$authCall,
						authModel.user.jwt,
						model.apiEndPoint.pointsWithdraw,
						$elm$core$Basics$round(withdrawAmount * 100))) : $elm$core$Platform$Cmd$none;
				return (_Utils_eq(
					$author$project$Model$TrustScore$getStatus(passbase || shuftiPro),
					$author$project$Data$Badge$NotVerified) && _Utils_eq(
					$author$project$Model$TrustScore$getStatus(myInfo),
					$author$project$Data$Badge$NotVerified)) ? _Utils_Tuple2(
					updateCurrentModel(
						_Utils_update(
							withdrawalModel,
							{modal: $author$project$Type$PointWithdrawal$VerifyToWithdraw})),
					$elm$core$Platform$Cmd$none) : _Utils_Tuple2(model, cmdMsg);
			case 'OnModalOpen':
				var modal = msg.a;
				switch (modal.$) {
					case 'MaxWithdrawAmount':
						return _Utils_Tuple2(
							updateCurrentModel(
								_Utils_update(
									withdrawalModel,
									{modal: $author$project$Type$PointWithdrawal$MaxWithdrawAmount})),
							$elm$core$Platform$Cmd$none);
					case 'VerifyToWithdraw':
						return _Utils_Tuple2(
							updateCurrentModel(
								_Utils_update(
									withdrawalModel,
									{modal: $author$project$Type$PointWithdrawal$VerifyToWithdraw})),
							$elm$core$Platform$Cmd$none);
					default:
						return _Utils_Tuple2(
							updateCurrentModel(
								_Utils_update(
									withdrawalModel,
									{modal: $author$project$Type$PointWithdrawal$Inactive})),
							$elm$core$Platform$Cmd$none);
				}
			default:
				return _Utils_Tuple2(
					updateCurrentModel(
						_Utils_update(
							withdrawalModel,
							{modal: $author$project$Type$PointWithdrawal$Inactive})),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Type$PointWithdrawalConfirm$Fail = {$: 'Fail'};
var $author$project$Type$PointWithdrawalConfirm$Success = {$: 'Success'};
var $author$project$Data$Api$Points$PointWithdrawalConfirmation$errorToString = function (error) {
	switch (error.$) {
		case 'INVALID_USER':
			return 'Invalid user';
		case 'INSUFFICIENT_BALANCE':
			return 'Insufficient balance in account.';
		default:
			return 'Invalid transaction.';
	}
};
var $author$project$Model$PointWithdrawalConfirm$update = F2(
	function (msg, model) {
		var result = msg.a;
		if (result.$ === 'Ok') {
			var _v2 = model;
			var pointWithdrawalConfirm = _v2.pointWithdrawalConfirm;
			var newModel = _Utils_update(
				pointWithdrawalConfirm,
				{status: $author$project$Type$PointWithdrawalConfirm$Success});
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{pointWithdrawalConfirm: newModel}),
				$elm$core$Platform$Cmd$none);
		} else {
			var error = result.a;
			var _v3 = model;
			var pointWithdrawalConfirm = _v3.pointWithdrawalConfirm;
			var newModel = _Utils_update(
				pointWithdrawalConfirm,
				{
					error: $elm$core$Maybe$Just(
						A2($author$project$Data$Api$authErrorToString, $author$project$Data$Api$Points$PointWithdrawalConfirmation$errorToString, error)),
					status: $author$project$Type$PointWithdrawalConfirm$Fail
				});
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{pointWithdrawalConfirm: newModel}),
				$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Type$RedeemRewardList$BlockChainNotarisation = function (a) {
	return {$: 'BlockChainNotarisation', a: a};
};
var $author$project$Type$RedeemRewardList$Fail = function (a) {
	return {$: 'Fail', a: a};
};
var $author$project$Type$RedeemRewardList$GenerateCred = {$: 'GenerateCred'};
var $author$project$Type$TokenManagement$OnDashboardApiResponse = function (a) {
	return {$: 'OnDashboardApiResponse', a: a};
};
var $author$project$Type$RedeemRewardList$OnRedeemRewardResponse = function (a) {
	return {$: 'OnRedeemRewardResponse', a: a};
};
var $author$project$Type$RedeemRewardList$OnRetrieveBalanceResponse = function (a) {
	return {$: 'OnRetrieveBalanceResponse', a: a};
};
var $author$project$Type$RedeemRewardList$RewardRedeemed = {$: 'RewardRedeemed'};
var $author$project$Type$RedeemRewardList$SelectRewardQuantity = function (a) {
	return {$: 'SelectRewardQuantity', a: a};
};
var $author$project$Type$RedeemRewardList$Success = {$: 'Success'};
var $author$project$Type$RedeemRewardList$VerifyCred = {$: 'VerifyCred'};
var $author$project$Data$Api$Points$RedeemReward$Payload = function (message) {
	return {message: message};
};
var $author$project$Data$Api$Points$RedeemReward$dataDecoder = A2(
	$elm$json$Json$Decode$map,
	$author$project$Data$Api$Points$RedeemReward$Payload,
	A2($elm$json$Json$Decode$field, 'message', $elm$json$Json$Decode$string));
var $author$project$Data$Api$Points$RedeemReward$encodeRewardName = function (rewardName) {
	switch (rewardName.$) {
		case 'BusinessSubscription':
			return $elm$json$Json$Encode$string('businessSubscription');
		case 'OrganisationUser':
			return $elm$json$Json$Encode$string('organisationUser');
		case 'NotariseBsc':
			return $elm$json$Json$Encode$string('notariseBsc');
		case 'NotariseAlgorand':
			return $elm$json$Json$Encode$string('notariseAlgorand');
		case 'GenerateCredentials':
			return $elm$json$Json$Encode$string('generateCredentials');
		case 'VerifyCredentials':
			return $elm$json$Json$Encode$string('verifyCredentials');
		case 'Amazon50Dollar':
			return $elm$json$Json$Encode$string('amazon50Dollar');
		case 'Grab50Dollar':
			return $elm$json$Json$Encode$string('grab50Dollar');
		default:
			return $elm$json$Json$Encode$string('safePalS1HardwareWallet');
	}
};
var $author$project$Data$Api$Points$RedeemReward$encode = F2(
	function (rewardName, quantity) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'rewardName',
					$author$project$Data$Api$Points$RedeemReward$encodeRewardName(rewardName)),
					_Utils_Tuple2(
					'quantity',
					$elm$json$Json$Encode$int(quantity))
				]));
	});
var $author$project$Data$Api$Points$RedeemReward$INSUFFICIENT_BALANCE = {$: 'INSUFFICIENT_BALANCE'};
var $author$project$Data$Api$Points$RedeemReward$INVALID_USER = {$: 'INVALID_USER'};
var $author$project$Data$Api$Points$RedeemReward$errorDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (errorCode) {
		switch (errorCode) {
			case 'INVALID_USER':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$Points$RedeemReward$INVALID_USER);
			case 'INSUFFICIENT_BALANCE':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$Points$RedeemReward$INSUFFICIENT_BALANCE);
			default:
				return $elm$json$Json$Decode$fail('Invalid error code: ' + errorCode);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Data$Api$Points$RedeemReward$authCall = F4(
	function (jwt, endPoint, rewardName, quantity) {
		return A5(
			$author$project$Data$Api$authCall,
			jwt,
			endPoint,
			$author$project$Data$Api$Points$RedeemReward$errorDecoder,
			$author$project$Data$Api$Points$RedeemReward$dataDecoder,
			A2($author$project$Data$Api$Points$RedeemReward$encode, rewardName, quantity));
	});
var $author$project$Model$RedeemRewardList$checkQuantity = F3(
	function (quantity, availBal, cost) {
		var convertedQty = $elm$core$String$toFloat(quantity);
		if (convertedQty.$ === 'Just') {
			var qty = convertedQty.a;
			return (qty < 1) ? $elm$core$Maybe$Just('Quantity cannot be less than one.') : ((_Utils_cmp(cost * qty, availBal) > 0) ? $elm$core$Maybe$Just('Total cost cannot exceed available balance.') : $elm$core$Maybe$Nothing);
		} else {
			return $elm$core$Maybe$Just('Invalid Number.');
		}
	});
var $author$project$Data$Api$Points$RedeemReward$errorToString = function (error) {
	if (error.$ === 'INVALID_USER') {
		return 'Invalid user';
	} else {
		return 'Insufficient balance in account.';
	}
};
var $author$project$Type$RedeemRewardList$OnApiResponse = function (a) {
	return {$: 'OnApiResponse', a: a};
};
var $author$project$Data$Api$Points$RedeemRewardList$Payload = function (rewards) {
	return {rewards: rewards};
};
var $author$project$Data$RedeemRewards$Rewards = F4(
	function (rewardName, cost, rewardType, isActive) {
		return {cost: cost, isActive: isActive, rewardName: rewardName, rewardType: rewardType};
	});
var $author$project$Data$RedeemRewards$Amazon50Dollar = {$: 'Amazon50Dollar'};
var $author$project$Data$RedeemRewards$BusinessSubscription = {$: 'BusinessSubscription'};
var $author$project$Data$RedeemRewards$GenerateCredentials = {$: 'GenerateCredentials'};
var $author$project$Data$RedeemRewards$Grab50Dollar = {$: 'Grab50Dollar'};
var $author$project$Data$RedeemRewards$NotariseAlgorand = {$: 'NotariseAlgorand'};
var $author$project$Data$RedeemRewards$NotariseBsc = {$: 'NotariseBsc'};
var $author$project$Data$RedeemRewards$OrganisationUser = {$: 'OrganisationUser'};
var $author$project$Data$RedeemRewards$SafePalS1HardwareWallet = {$: 'SafePalS1HardwareWallet'};
var $author$project$Data$RedeemRewards$VerifyCredentials = {$: 'VerifyCredentials'};
var $author$project$Data$Api$Points$RedeemRewardList$decodeRewardName = A2(
	$elm$json$Json$Decode$andThen,
	function (rewardName) {
		switch (rewardName) {
			case 'businessSubscription':
				return $elm$json$Json$Decode$succeed($author$project$Data$RedeemRewards$BusinessSubscription);
			case 'organisationUser':
				return $elm$json$Json$Decode$succeed($author$project$Data$RedeemRewards$OrganisationUser);
			case 'notariseBsc':
				return $elm$json$Json$Decode$succeed($author$project$Data$RedeemRewards$NotariseBsc);
			case 'notariseAlgorand':
				return $elm$json$Json$Decode$succeed($author$project$Data$RedeemRewards$NotariseAlgorand);
			case 'generateCredentials':
				return $elm$json$Json$Decode$succeed($author$project$Data$RedeemRewards$GenerateCredentials);
			case 'verifyCredentials':
				return $elm$json$Json$Decode$succeed($author$project$Data$RedeemRewards$VerifyCredentials);
			case 'amazon50Dollar':
				return $elm$json$Json$Decode$succeed($author$project$Data$RedeemRewards$Amazon50Dollar);
			case 'grab50Dollar':
				return $elm$json$Json$Decode$succeed($author$project$Data$RedeemRewards$Grab50Dollar);
			case 'safePalS1HardwareWallet':
				return $elm$json$Json$Decode$succeed($author$project$Data$RedeemRewards$SafePalS1HardwareWallet);
			default:
				return $elm$json$Json$Decode$fail('Invalid Reward Name');
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Data$RedeemRewards$Product = {$: 'Product'};
var $author$project$Data$RedeemRewards$Service = {$: 'Service'};
var $author$project$Data$RedeemRewards$Voucher = {$: 'Voucher'};
var $author$project$Data$Api$Points$RedeemRewardList$decodeRewardType = A2(
	$elm$json$Json$Decode$andThen,
	function (rewardName) {
		switch (rewardName) {
			case 'Service':
				return $elm$json$Json$Decode$succeed($author$project$Data$RedeemRewards$Service);
			case 'Voucher':
				return $elm$json$Json$Decode$succeed($author$project$Data$RedeemRewards$Voucher);
			case 'Product':
				return $elm$json$Json$Decode$succeed($author$project$Data$RedeemRewards$Product);
			default:
				return $elm$json$Json$Decode$fail('Invalid Reward Type');
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Data$Api$Points$RedeemRewardList$decoder = A5(
	$elm$json$Json$Decode$map4,
	$author$project$Data$RedeemRewards$Rewards,
	A2($elm$json$Json$Decode$field, 'rewardName', $author$project$Data$Api$Points$RedeemRewardList$decodeRewardName),
	A2($elm$json$Json$Decode$field, 'cost', $elm$json$Json$Decode$float),
	A2($elm$json$Json$Decode$field, 'rewardType', $author$project$Data$Api$Points$RedeemRewardList$decodeRewardType),
	A2($elm$json$Json$Decode$field, 'isActive', $elm$json$Json$Decode$bool));
var $author$project$Data$Api$Points$RedeemRewardList$dataDecoder = A2(
	$elm$json$Json$Decode$map,
	$author$project$Data$Api$Points$RedeemRewardList$Payload,
	A2(
		$elm$json$Json$Decode$field,
		'rewards',
		$elm$json$Json$Decode$list($author$project$Data$Api$Points$RedeemRewardList$decoder)));
var $author$project$Data$Api$Points$RedeemRewardList$errorDecoder = $elm$json$Json$Decode$succeed(_Utils_Tuple0);
var $author$project$Data$Api$Points$RedeemRewardList$authCall = F2(
	function (jwt, endPoint) {
		return A5(
			$author$project$Data$Api$authCall,
			jwt,
			endPoint,
			$author$project$Data$Api$Points$RedeemRewardList$errorDecoder,
			$author$project$Data$Api$Points$RedeemRewardList$dataDecoder,
			$elm$json$Json$Encode$object(_List_Nil));
	});
var $author$project$Model$RedeemRewardList$listCmd = F2(
	function (endpoint, user) {
		return A2(
			$elm$core$Task$attempt,
			A2(
				$elm$core$Basics$composeL,
				A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnRedeemRewardList),
				$author$project$Type$RedeemRewardList$OnApiResponse),
			A2($author$project$Data$Api$Points$RedeemRewardList$authCall, user.jwt, endpoint));
	});
var $author$project$Model$RedeemRewardList$update = F3(
	function (msg, model, authModel) {
		var updateCurrentModel = function (currentModel) {
			return _Utils_update(
				model,
				{
					sessionModel: $author$project$Types$Auth(
						_Utils_update(
							authModel,
							{redeemRewardList: currentModel}))
				});
		};
		var _v0 = authModel;
		var redeemRewardList = _v0.redeemRewardList;
		var _v1 = redeemRewardList;
		var quantity = _v1.quantity;
		var quantityError = _v1.quantityError;
		switch (msg.$) {
			case 'OnPageEnter':
				return _Utils_Tuple2(
					model,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($author$project$Model$RedeemRewardList$listCmd, model.apiEndPoint.redeemRewardList, authModel.user),
								A2(
								$elm$core$Task$attempt,
								A2(
									$elm$core$Basics$composeL,
									A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnRedeemRewardList),
									$author$project$Type$RedeemRewardList$OnRetrieveBalanceResponse),
								A2($author$project$Data$Api$Points$PointsDashboard$authCall, authModel.user.jwt, model.apiEndPoint.pointsDashboard))
							])));
			case 'OnApiResponse':
				var result = msg.a;
				if (result.$ === 'Ok') {
					var response = result.a;
					var newRedeemRewardList = _Utils_update(
						redeemRewardList,
						{rewards: response.rewards});
					return _Utils_Tuple2(
						updateCurrentModel(newRedeemRewardList),
						$elm$core$Platform$Cmd$none);
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 'OnRewardSubmit':
				var reward = msg.a;
				var balance = msg.b;
				var cost = msg.c;
				var qty = A2(
					$elm$core$Maybe$withDefault,
					0,
					$elm$core$String$toInt(quantity));
				var errorCheck = _Utils_update(
					redeemRewardList,
					{
						quantityError: A3($author$project$Model$RedeemRewardList$checkQuantity, quantity, balance, cost)
					});
				return ((!$elm$core$String$isEmpty(quantity)) && _Utils_eq(quantityError, $elm$core$Maybe$Nothing)) ? _Utils_Tuple2(
					updateCurrentModel(errorCheck),
					A2(
						$elm$core$Task$attempt,
						A2(
							$elm$core$Basics$composeL,
							A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnRedeemRewardList),
							$author$project$Type$RedeemRewardList$OnRedeemRewardResponse),
						A4($author$project$Data$Api$Points$RedeemReward$authCall, authModel.user.jwt, model.apiEndPoint.redeemReward, reward.rewardName, qty))) : _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 'BackToRewardPoints':
				return _Utils_Tuple2(
					updateCurrentModel(
						_Utils_update(
							redeemRewardList,
							{modal: $author$project$Type$RedeemRewardList$Inactive})),
					A2($elm$browser$Browser$Navigation$pushUrl, model.navKey, $author$project$Data$Route$routeUrl.tokenManagement));
			case 'GoToAccount':
				return _Utils_Tuple2(
					updateCurrentModel(
						_Utils_update(
							redeemRewardList,
							{modal: $author$project$Type$RedeemRewardList$Inactive})),
					A2($elm$browser$Browser$Navigation$pushUrl, model.navKey, $author$project$Data$Route$routeUrl.setting));
			case 'GoToDocuments':
				return _Utils_Tuple2(
					updateCurrentModel(
						_Utils_update(
							redeemRewardList,
							{modal: $author$project$Type$RedeemRewardList$Inactive})),
					A2($elm$browser$Browser$Navigation$pushUrl, model.navKey, $author$project$Data$Route$routeUrl.receievedDoc));
			case 'OnModalOpen':
				var modal = msg.a;
				switch (modal.$) {
					case 'SelectRewardQuantity':
						var reward = modal.a;
						return _Utils_Tuple2(
							updateCurrentModel(
								_Utils_update(
									redeemRewardList,
									{
										modal: $author$project$Type$RedeemRewardList$SelectRewardQuantity(reward)
									})),
							$elm$core$Platform$Cmd$none);
					case 'RewardRedeemed':
						return _Utils_Tuple2(
							updateCurrentModel(
								_Utils_update(
									redeemRewardList,
									{modal: $author$project$Type$RedeemRewardList$RewardRedeemed})),
							$elm$core$Platform$Cmd$none);
					case 'BlockChainNotarisation':
						var reward = modal.a;
						return _Utils_Tuple2(
							updateCurrentModel(
								_Utils_update(
									redeemRewardList,
									{
										modal: $author$project$Type$RedeemRewardList$BlockChainNotarisation(reward)
									})),
							$elm$core$Platform$Cmd$none);
					case 'GenerateCred':
						return _Utils_Tuple2(
							updateCurrentModel(
								_Utils_update(
									redeemRewardList,
									{modal: $author$project$Type$RedeemRewardList$GenerateCred})),
							$elm$core$Platform$Cmd$none);
					case 'VerifyCred':
						return _Utils_Tuple2(
							updateCurrentModel(
								_Utils_update(
									redeemRewardList,
									{modal: $author$project$Type$RedeemRewardList$VerifyCred})),
							$elm$core$Platform$Cmd$none);
					default:
						return _Utils_Tuple2(
							updateCurrentModel(
								_Utils_update(
									redeemRewardList,
									{modal: $author$project$Type$RedeemRewardList$Inactive})),
							$elm$core$Platform$Cmd$none);
				}
			case 'OnModalClose':
				return _Utils_Tuple2(
					updateCurrentModel(
						_Utils_update(
							redeemRewardList,
							{modal: $author$project$Type$RedeemRewardList$Inactive, quantity: '1', quantityError: $elm$core$Maybe$Nothing})),
					$elm$core$Platform$Cmd$none);
			case 'OnRewardClick':
				var rewardName = msg.a;
				var reward = msg.b;
				switch (rewardName.$) {
					case 'NotariseBsc':
						return _Utils_Tuple2(
							updateCurrentModel(
								_Utils_update(
									redeemRewardList,
									{
										modal: $author$project$Type$RedeemRewardList$BlockChainNotarisation(reward)
									})),
							$elm$core$Platform$Cmd$none);
					case 'NotariseAlgorand':
						return _Utils_Tuple2(
							updateCurrentModel(
								_Utils_update(
									redeemRewardList,
									{
										modal: $author$project$Type$RedeemRewardList$BlockChainNotarisation(reward)
									})),
							$elm$core$Platform$Cmd$none);
					case 'GenerateCredentials':
						return _Utils_Tuple2(
							updateCurrentModel(
								_Utils_update(
									redeemRewardList,
									{modal: $author$project$Type$RedeemRewardList$GenerateCred})),
							$elm$core$Platform$Cmd$none);
					case 'VerifyCredentials':
						return _Utils_Tuple2(
							updateCurrentModel(
								_Utils_update(
									redeemRewardList,
									{modal: $author$project$Type$RedeemRewardList$VerifyCred})),
							$elm$core$Platform$Cmd$none);
					default:
						return _Utils_Tuple2(
							updateCurrentModel(
								_Utils_update(
									redeemRewardList,
									{
										modal: $author$project$Type$RedeemRewardList$SelectRewardQuantity(reward)
									})),
							$elm$core$Platform$Cmd$none);
				}
			case 'OnRedeemRewardResponse':
				var result = msg.a;
				if (result.$ === 'Ok') {
					var newTokenManagement = _Utils_update(
						redeemRewardList,
						{modal: $author$project$Type$RedeemRewardList$RewardRedeemed, quantity: quantity, quantityError: $elm$core$Maybe$Nothing, status: $author$project$Type$RedeemRewardList$Success});
					return _Utils_Tuple2(
						updateCurrentModel(newTokenManagement),
						A2(
							$elm$core$Task$attempt,
							A2(
								$elm$core$Basics$composeL,
								A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnTokenManagement),
								$author$project$Type$TokenManagement$OnDashboardApiResponse),
							A2($author$project$Data$Api$Points$PointsDashboard$authCall, authModel.user.jwt, model.apiEndPoint.pointsDashboard)));
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						updateCurrentModel(
							_Utils_update(
								redeemRewardList,
								{
									status: $author$project$Type$RedeemRewardList$Fail(
										A2($author$project$Data$Api$authErrorToString, $author$project$Data$Api$Points$RedeemReward$errorToString, error))
								})),
						$elm$core$Platform$Cmd$none);
				}
			case 'OnRetrieveBalanceResponse':
				var result = msg.a;
				if (result.$ === 'Ok') {
					var response = result.a;
					var balance = _Utils_update(
						redeemRewardList,
						{available: response.available, pending: response.pending});
					return _Utils_Tuple2(
						updateCurrentModel(balance),
						$elm$core$Platform$Cmd$none);
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			default:
				var inputType = msg.a;
				if (inputType.$ === 'Input') {
					var qty = inputType.a;
					return _Utils_Tuple2(
						updateCurrentModel(
							_Utils_update(
								redeemRewardList,
								{quantity: qty})),
						$elm$core$Platform$Cmd$none);
				} else {
					var balance = inputType.a;
					var cost = inputType.b;
					return $elm$core$String$isEmpty(quantity) ? _Utils_Tuple2(
						updateCurrentModel(
							_Utils_update(
								redeemRewardList,
								{quantity: '1'})),
						$elm$core$Platform$Cmd$none) : _Utils_Tuple2(
						updateCurrentModel(
							_Utils_update(
								redeemRewardList,
								{
									quantityError: A3($author$project$Model$RedeemRewardList$checkQuantity, quantity, balance, cost)
								})),
						$elm$core$Platform$Cmd$none);
				}
		}
	});
var $author$project$Type$ResendActivation$Error = function (a) {
	return {$: 'Error', a: a};
};
var $author$project$Types$OnResendActivation = function (a) {
	return {$: 'OnResendActivation', a: a};
};
var $author$project$Type$ResendActivation$ResendResponse = function (a) {
	return {$: 'ResendResponse', a: a};
};
var $author$project$Type$ResendActivation$Submitting = {$: 'Submitting'};
var $author$project$Data$Api$ResendActivation$dataDecoder = $elm$json$Json$Decode$succeed(_Utils_Tuple0);
var $author$project$Data$Api$ResendActivation$encode = function (email) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'email',
				$elm$json$Json$Encode$string(email))
			]));
};
var $author$project$Data$Api$ResendActivation$TOO_FREQUENT_REQUEST = {$: 'TOO_FREQUENT_REQUEST'};
var $author$project$Data$Api$ResendActivation$errorDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (errorCode) {
		if (errorCode === 'TOO_FREQUENT_REQUEST') {
			return $elm$json$Json$Decode$succeed($author$project$Data$Api$ResendActivation$TOO_FREQUENT_REQUEST);
		} else {
			return $elm$json$Json$Decode$fail('Invalid error code: ' + errorCode);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Data$Api$ResendActivation$call = F2(
	function (endPoint, email) {
		return A4(
			$author$project$Data$Api$httpTask,
			endPoint,
			$author$project$Data$Api$ResendActivation$errorDecoder,
			$author$project$Data$Api$ResendActivation$dataDecoder,
			$author$project$Data$Api$ResendActivation$encode(email));
	});
var $author$project$Model$ResendActivation$update = F2(
	function (msg, model) {
		var _v0 = model;
		var apiEndPoint = _v0.apiEndPoint;
		var resendActivationModel = _v0.resendActivationModel;
		var _v1 = resendActivationModel;
		var email = _v1.email;
		switch (msg.$) {
			case 'OnEmailInput':
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							resendActivationModel: _Utils_update(
								resendActivationModel,
								{email: value, emailError: $elm$core$Maybe$Nothing, formStatus: $author$project$Type$ResendActivation$Ready})
						}),
					$elm$core$Platform$Cmd$none);
			case 'OnEmailBlur':
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							resendActivationModel: _Utils_update(
								resendActivationModel,
								{
									emailError: $author$project$Data$Validator$validateEmail(email)
								})
						}),
					$elm$core$Platform$Cmd$none);
			case 'OnSubmit':
				var updatedModel = _Utils_update(
					resendActivationModel,
					{
						emailError: $author$project$Data$Validator$validateEmail(email)
					});
				return _Utils_eq(updatedModel.emailError, $elm$core$Maybe$Nothing) ? _Utils_Tuple2(
					_Utils_update(
						model,
						{
							resendActivationModel: _Utils_update(
								updatedModel,
								{formStatus: $author$project$Type$ResendActivation$Submitting})
						}),
					A2(
						$elm$core$Task$attempt,
						A2($elm$core$Basics$composeL, $author$project$Types$OnResendActivation, $author$project$Type$ResendActivation$ResendResponse),
						A2($author$project$Data$Api$ResendActivation$call, apiEndPoint.resendActivation, email))) : _Utils_Tuple2(
					_Utils_update(
						model,
						{resendActivationModel: updatedModel}),
					$elm$core$Platform$Cmd$none);
			default:
				var result = msg.a;
				if (result.$ === 'Ok') {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								resendActivationModel: _Utils_update(
									resendActivationModel,
									{formStatus: $author$project$Type$ResendActivation$Ready})
							}),
						A2($elm$browser$Browser$Navigation$pushUrl, model.navKey, $author$project$Data$Route$routeUrl.resendActivationEmailSent));
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								resendActivationModel: _Utils_update(
									resendActivationModel,
									{
										formStatus: $author$project$Type$ResendActivation$Error(error)
									})
							}),
						$elm$core$Platform$Cmd$none);
				}
		}
	});
var $author$project$Type$ResetPassword$Error = function (a) {
	return {$: 'Error', a: a};
};
var $author$project$Types$OnResetPassword = function (a) {
	return {$: 'OnResetPassword', a: a};
};
var $author$project$Type$ResetPassword$ResetResponse = function (a) {
	return {$: 'ResetResponse', a: a};
};
var $author$project$Type$ResetPassword$Submitting = {$: 'Submitting'};
var $author$project$Data$Api$ResetPassword$dataDecoder = $elm$json$Json$Decode$succeed(_Utils_Tuple0);
var $author$project$Data$Api$ResetPassword$encode = function (email) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'email',
				$elm$json$Json$Encode$string(email))
			]));
};
var $author$project$Data$Api$ResetPassword$TOO_FREQUENT_REQUEST = {$: 'TOO_FREQUENT_REQUEST'};
var $author$project$Data$Api$ResetPassword$errorDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (errorCode) {
		if (errorCode === 'TOO_FREQUENT_REQUEST') {
			return $elm$json$Json$Decode$succeed($author$project$Data$Api$ResetPassword$TOO_FREQUENT_REQUEST);
		} else {
			return $elm$json$Json$Decode$fail('Invalid error code: ' + errorCode);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Data$Api$ResetPassword$call = F2(
	function (endPoint, email) {
		return A4(
			$author$project$Data$Api$httpTask,
			endPoint,
			$author$project$Data$Api$ResetPassword$errorDecoder,
			$author$project$Data$Api$ResetPassword$dataDecoder,
			$author$project$Data$Api$ResetPassword$encode(email));
	});
var $author$project$Model$ResetPassword$update = F2(
	function (msg, model) {
		var _v0 = model;
		var apiEndPoint = _v0.apiEndPoint;
		var resetPasswordModel = _v0.resetPasswordModel;
		var _v1 = resetPasswordModel;
		var email = _v1.email;
		switch (msg.$) {
			case 'OnEmailInput':
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							resetPasswordModel: _Utils_update(
								resetPasswordModel,
								{email: value, emailError: $elm$core$Maybe$Nothing, formStatus: $author$project$Type$ResetPassword$Ready})
						}),
					$elm$core$Platform$Cmd$none);
			case 'OnEmailBlur':
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							resetPasswordModel: _Utils_update(
								resetPasswordModel,
								{
									emailError: $author$project$Data$Validator$validateEmail(email)
								})
						}),
					$elm$core$Platform$Cmd$none);
			case 'OnSubmit':
				var updatedModel = _Utils_update(
					resetPasswordModel,
					{
						emailError: $author$project$Data$Validator$validateEmail(email)
					});
				return _Utils_eq(updatedModel.emailError, $elm$core$Maybe$Nothing) ? _Utils_Tuple2(
					_Utils_update(
						model,
						{
							resetPasswordModel: _Utils_update(
								updatedModel,
								{formStatus: $author$project$Type$ResetPassword$Submitting})
						}),
					A2(
						$elm$core$Task$attempt,
						A2($elm$core$Basics$composeL, $author$project$Types$OnResetPassword, $author$project$Type$ResetPassword$ResetResponse),
						A2($author$project$Data$Api$ResetPassword$call, apiEndPoint.resetPassword, email))) : _Utils_Tuple2(
					_Utils_update(
						model,
						{resetPasswordModel: updatedModel}),
					$elm$core$Platform$Cmd$none);
			default:
				var result = msg.a;
				if (result.$ === 'Ok') {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								resetPasswordModel: _Utils_update(
									resetPasswordModel,
									{formStatus: $author$project$Type$ResetPassword$Ready})
							}),
						A2($elm$browser$Browser$Navigation$pushUrl, model.navKey, $author$project$Data$Route$routeUrl.resetPasswordEmailSent));
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								resetPasswordModel: _Utils_update(
									resetPasswordModel,
									{
										formStatus: $author$project$Type$ResetPassword$Error(error)
									})
							}),
						$elm$core$Platform$Cmd$none);
				}
		}
	});
var $author$project$Model$SSE$updateJsBundle = F2(
	function (model, newJsBundle) {
		var _v0 = model.localJsBundle;
		if (_v0.$ === 'Nothing') {
			return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		} else {
			var localJsBundle = _v0.a;
			return _Utils_eq(localJsBundle, newJsBundle) ? _Utils_Tuple2(model, $elm$core$Platform$Cmd$none) : _Utils_Tuple2(
				model,
				$elm$browser$Browser$Navigation$load(model.url.path + ('/?bustCache=' + newJsBundle)));
		}
	});
var $author$project$Model$SSE$update = F3(
	function (event, authModel, model) {
		switch (event.$) {
			case 'NotSupported':
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 'Opened':
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 'Error':
				var errorCode = event.a;
				switch (errorCode.$) {
					case 'NetworkError':
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					case 'InvalidJSON':
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					case 'DataDecodeError':
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					case 'JwtError':
						return $author$project$Model$Logout$forceLogout(model);
					default:
						return $author$project$Model$Logout$forceLogout(model);
				}
			default:
				var data = event.a;
				if (data.$ === 'OnUser') {
					var user = data.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								sessionModel: $author$project$Types$Auth(
									_Utils_update(
										authModel,
										{user: user}))
							}),
						$author$project$Data$User$store(user));
				} else {
					var jsBundle = data.a;
					return A2($author$project$Model$SSE$updateJsBundle, model, jsBundle);
				}
		}
	});
var $author$project$Type$SetPassword$Error = function (a) {
	return {$: 'Error', a: a};
};
var $author$project$Types$OnSetPassword = function (a) {
	return {$: 'OnSetPassword', a: a};
};
var $author$project$Type$SetPassword$SubmitResponse = function (a) {
	return {$: 'SubmitResponse', a: a};
};
var $author$project$Type$SetPassword$Submitting = {$: 'Submitting'};
var $author$project$Data$Api$SetPassword$dataDecoder = $elm$json$Json$Decode$succeed(_Utils_Tuple0);
var $author$project$Data$Api$SetPassword$encode = F2(
	function (token, password) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'token',
					$elm$json$Json$Encode$string(token)),
					_Utils_Tuple2(
					'password',
					$elm$json$Json$Encode$string(password))
				]));
	});
var $author$project$Data$Api$SetPassword$PASSWORD_REQUIREMENT = {$: 'PASSWORD_REQUIREMENT'};
var $author$project$Data$Api$SetPassword$TOKEN_EXPIRED = {$: 'TOKEN_EXPIRED'};
var $author$project$Data$Api$SetPassword$TOKEN_INVALID = {$: 'TOKEN_INVALID'};
var $author$project$Data$Api$SetPassword$errorDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (errorCode) {
		switch (errorCode) {
			case 'PASSWORD_REQUIREMENT':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$SetPassword$PASSWORD_REQUIREMENT);
			case 'TOKEN_EXPIRED':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$SetPassword$TOKEN_EXPIRED);
			case 'TOKEN_INVALID':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$SetPassword$TOKEN_INVALID);
			default:
				return $elm$json$Json$Decode$fail('Invalid error code: ' + errorCode);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Data$Api$SetPassword$call = F3(
	function (endPoint, token, password) {
		return A4(
			$author$project$Data$Api$httpTask,
			endPoint,
			$author$project$Data$Api$SetPassword$errorDecoder,
			$author$project$Data$Api$SetPassword$dataDecoder,
			A2($author$project$Data$Api$SetPassword$encode, token, password));
	});
var $author$project$Model$SetPassword$update = F2(
	function (msg, model) {
		var _v0 = model;
		var setPasswordModel = _v0.setPasswordModel;
		switch (msg.$) {
			case 'OnInput':
				var field = msg.a;
				var value = msg.b;
				if (field.$ === 'Password') {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								setPasswordModel: _Utils_update(
									setPasswordModel,
									{password: value})
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								setPasswordModel: _Utils_update(
									setPasswordModel,
									{passwordAgain: value})
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 'OnBlur':
				var field = msg.a;
				if (field.$ === 'Password') {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								setPasswordModel: _Utils_update(
									setPasswordModel,
									{
										passwordError: $author$project$Data$Validator$validatePassword(setPasswordModel.password)
									})
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								setPasswordModel: _Utils_update(
									setPasswordModel,
									{
										passwordAgainError: A2($author$project$Data$Validator$validatePasswordAgain, setPasswordModel.password, setPasswordModel.passwordAgain)
									})
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 'OnSubmit':
				var token = msg.a;
				var _v4 = setPasswordModel;
				var password = _v4.password;
				var passwordAgain = _v4.passwordAgain;
				var updatedModel = _Utils_update(
					setPasswordModel,
					{
						passwordAgainError: A2($author$project$Data$Validator$validatePasswordAgain, password, passwordAgain),
						passwordError: $author$project$Data$Validator$validatePassword(password)
					});
				var allPassed = A2(
					$elm$core$List$all,
					$elm$core$Basics$eq($elm$core$Maybe$Nothing),
					_List_fromArray(
						[updatedModel.passwordError, updatedModel.passwordAgainError]));
				return allPassed ? _Utils_Tuple2(
					_Utils_update(
						model,
						{
							setPasswordModel: _Utils_update(
								updatedModel,
								{formStatus: $author$project$Type$SetPassword$Submitting})
						}),
					A2(
						$elm$core$Task$attempt,
						A2($elm$core$Basics$composeL, $author$project$Types$OnSetPassword, $author$project$Type$SetPassword$SubmitResponse),
						A3($author$project$Data$Api$SetPassword$call, model.apiEndPoint.setPassword, token, password))) : _Utils_Tuple2(
					_Utils_update(
						model,
						{
							setPasswordModel: _Utils_update(
								updatedModel,
								{formStatus: $author$project$Type$SetPassword$Ready})
						}),
					$elm$core$Platform$Cmd$none);
			default:
				var result = msg.a;
				if (result.$ === 'Ok') {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								setPasswordModel: _Utils_update(
									setPasswordModel,
									{formStatus: $author$project$Type$SetPassword$Ready})
							}),
						A2($elm$browser$Browser$Navigation$pushUrl, model.navKey, $author$project$Data$Route$routeUrl.resetPasswordSuccess));
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								setPasswordModel: _Utils_update(
									setPasswordModel,
									{
										formStatus: $author$project$Type$SetPassword$Error(error)
									})
							}),
						$elm$core$Platform$Cmd$none);
				}
		}
	});
var $author$project$Type$Setting$CloseSnackBar = function (a) {
	return {$: 'CloseSnackBar', a: a};
};
var $author$project$Type$Setting$Enter = {$: 'Enter'};
var $author$project$Type$Setting$ErrData = {$: 'ErrData'};
var $author$project$Type$Setting$Error = function (a) {
	return {$: 'Error', a: a};
};
var $author$project$Type$Setting$ImageLoaded = function (a) {
	return {$: 'ImageLoaded', a: a};
};
var $author$project$Type$Setting$ImageReceivedDataBytes = F2(
	function (a, b) {
		return {$: 'ImageReceivedDataBytes', a: a, b: b};
	});
var $author$project$Type$Setting$ImageSubmitResult = function (a) {
	return {$: 'ImageSubmitResult', a: a};
};
var $author$project$Type$Setting$OkData = {$: 'OkData'};
var $author$project$Type$Setting$OnApiKeyResult = function (a) {
	return {$: 'OnApiKeyResult', a: a};
};
var $author$project$Type$Setting$OnDefaultNotarisationSubmitResponse = function (a) {
	return {$: 'OnDefaultNotarisationSubmitResponse', a: a};
};
var $author$project$Type$Setting$OnMyInfoResult = function (a) {
	return {$: 'OnMyInfoResult', a: a};
};
var $author$project$Type$Setting$OnPaymentMethodSubmitResponse = function (a) {
	return {$: 'OnPaymentMethodSubmitResponse', a: a};
};
var $author$project$Type$Setting$OnShowAdsSubmitResponse = function (a) {
	return {$: 'OnShowAdsSubmitResponse', a: a};
};
var $author$project$Type$Setting$OnUpdateNotarisationNetworkResponse = function (a) {
	return {$: 'OnUpdateNotarisationNetworkResponse', a: a};
};
var $author$project$Type$Setting$Opened = function (a) {
	return {$: 'Opened', a: a};
};
var $author$project$Type$Setting$Processing = function (a) {
	return {$: 'Processing', a: a};
};
var $author$project$Type$Setting$Retrieving = {$: 'Retrieving'};
var $author$project$Type$Setting$Submitted = {$: 'Submitted'};
var $author$project$Type$Setting$Submitting = {$: 'Submitting'};
var $author$project$Data$Api$ApiKey$Payload = function (apiKeys) {
	return {apiKeys: apiKeys};
};
var $author$project$Data$Api$ApiKey$dataDecoder = A2(
	$elm$json$Json$Decode$map,
	$author$project$Data$Api$ApiKey$Payload,
	A2(
		$elm$json$Json$Decode$field,
		'apiKeys',
		$elm$json$Json$Decode$list($elm$json$Json$Decode$string)));
var $author$project$Data$Api$ApiKey$errorDecoder = $elm$json$Json$Decode$succeed(_Utils_Tuple0);
var $author$project$Data$Api$ApiKey$authCall = F2(
	function (jwt, endPoint) {
		return A5(
			$author$project$Data$Api$authCall,
			jwt,
			endPoint,
			$author$project$Data$Api$ApiKey$errorDecoder,
			$author$project$Data$Api$ApiKey$dataDecoder,
			$elm$json$Json$Encode$object(_List_Nil));
	});
var $author$project$Data$Api$MyInfo$MyInfo$Payload = F5(
	function (identificationNumber, phoneNumber, dateOfBirth, address, createdAt) {
		return {address: address, createdAt: createdAt, dateOfBirth: dateOfBirth, identificationNumber: identificationNumber, phoneNumber: phoneNumber};
	});
var $author$project$Data$Api$MyInfo$MyInfo$dataDecoder = A6(
	$elm$json$Json$Decode$map5,
	$author$project$Data$Api$MyInfo$MyInfo$Payload,
	A2($elm$json$Json$Decode$field, 'identificationNumber', $elm$json$Json$Decode$string),
	A2(
		$elm$json$Json$Decode$field,
		'phoneNumber',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string)),
	A2($elm$json$Json$Decode$field, 'dateOfBirth', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'address', $elm$json$Json$Decode$string),
	A2(
		$elm$json$Json$Decode$field,
		'createdAt',
		A2($elm$json$Json$Decode$map, $elm$time$Time$millisToPosix, $elm$json$Json$Decode$int)));
var $author$project$Data$Api$MyInfo$MyInfo$encodeMyInfo = F2(
	function (code, userId) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'code',
					$elm$json$Json$Encode$string(code)),
					_Utils_Tuple2(
					'userId',
					$elm$json$Json$Encode$string(userId))
				]));
	});
var $author$project$Data$Api$MyInfo$MyInfo$errorDecoder = $elm$json$Json$Decode$succeed(_Utils_Tuple0);
var $author$project$Data$Api$MyInfo$MyInfo$authCall = F4(
	function (jwt, endPoint, code, userId) {
		return A5(
			$author$project$Data$Api$authCall,
			jwt,
			endPoint,
			$author$project$Data$Api$MyInfo$MyInfo$errorDecoder,
			$author$project$Data$Api$MyInfo$MyInfo$dataDecoder,
			A2($author$project$Data$Api$MyInfo$MyInfo$encodeMyInfo, code, userId));
	});
var $author$project$Data$Api$UpdateNotarisationNetwork$Payload = function (message) {
	return {message: message};
};
var $author$project$Data$Api$UpdateNotarisationNetwork$dataDecoder = A2(
	$elm$json$Json$Decode$map,
	$author$project$Data$Api$UpdateNotarisationNetwork$Payload,
	A2($elm$json$Json$Decode$field, 'message', $elm$json$Json$Decode$string));
var $author$project$Data$Api$UpdateNotarisationNetwork$encode = F3(
	function (notarisationNetwork, paymentMethod, notariseByDefault) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'notarisationNetwork',
					$elm$json$Json$Encode$string(notarisationNetwork)),
					_Utils_Tuple2(
					'paymentMethod',
					$elm$json$Json$Encode$string(paymentMethod)),
					_Utils_Tuple2(
					'notariseByDefault',
					$elm$json$Json$Encode$bool(notariseByDefault))
				]));
	});
var $author$project$Data$Api$UpdateNotarisationNetwork$INVALID_NETWORK_TYPE = {$: 'INVALID_NETWORK_TYPE'};
var $author$project$Data$Api$UpdateNotarisationNetwork$INVALID_NOTARISATION_OPTION = {$: 'INVALID_NOTARISATION_OPTION'};
var $author$project$Data$Api$UpdateNotarisationNetwork$INVALID_PAYMENT_METHOD = {$: 'INVALID_PAYMENT_METHOD'};
var $author$project$Data$Api$UpdateNotarisationNetwork$UNAUTHORISED_USER = {$: 'UNAUTHORISED_USER'};
var $author$project$Data$Api$UpdateNotarisationNetwork$errorDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (errorCode) {
		switch (errorCode) {
			case 'INVALID_NETWORK_TYPE':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$UpdateNotarisationNetwork$INVALID_NETWORK_TYPE);
			case 'UNAUTHORISED_USER':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$UpdateNotarisationNetwork$UNAUTHORISED_USER);
			case 'INVALID_PAYMENT_METHOD':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$UpdateNotarisationNetwork$INVALID_PAYMENT_METHOD);
			case 'INVALID_NOTARISATION_OPTION':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$UpdateNotarisationNetwork$INVALID_NOTARISATION_OPTION);
			default:
				return $elm$json$Json$Decode$fail('Invalid error code: ' + errorCode);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Data$Api$UpdateNotarisationNetwork$authCall = F5(
	function (jwt, endPoint, network, paymentMethod, notariseByDefault) {
		return A5(
			$author$project$Data$Api$authCall,
			jwt,
			endPoint,
			$author$project$Data$Api$UpdateNotarisationNetwork$errorDecoder,
			$author$project$Data$Api$UpdateNotarisationNetwork$dataDecoder,
			A3($author$project$Data$Api$UpdateNotarisationNetwork$encode, network, paymentMethod, notariseByDefault));
	});
var $author$project$Data$Api$UpdateShowAds$Payload = function (message) {
	return {message: message};
};
var $author$project$Data$Api$UpdateShowAds$dataDecoder = A2(
	$elm$json$Json$Decode$map,
	$author$project$Data$Api$UpdateShowAds$Payload,
	A2($elm$json$Json$Decode$field, 'message', $elm$json$Json$Decode$string));
var $author$project$Data$Api$UpdateShowAds$encode = function (showAds) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'showAds',
				$elm$json$Json$Encode$bool(showAds))
			]));
};
var $author$project$Data$Api$UpdateShowAds$JWT_Error = {$: 'JWT_Error'};
var $author$project$Data$Api$UpdateShowAds$UNAUTHORISED_USER = {$: 'UNAUTHORISED_USER'};
var $author$project$Data$Api$UpdateShowAds$errorDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (errorCode) {
		switch (errorCode) {
			case 'UNAUTHORISED_USER':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$UpdateShowAds$UNAUTHORISED_USER);
			case 'JWT_Error':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$UpdateShowAds$JWT_Error);
			default:
				return $elm$json$Json$Decode$fail('Invalid error code: ' + errorCode);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Data$Api$UpdateShowAds$authCall = F3(
	function (jwt, endPoint, showAds) {
		return A5(
			$author$project$Data$Api$authCall,
			jwt,
			endPoint,
			$author$project$Data$Api$UpdateShowAds$errorDecoder,
			$author$project$Data$Api$UpdateShowAds$dataDecoder,
			$author$project$Data$Api$UpdateShowAds$encode(showAds));
	});
var $elm$http$Http$bytesPart = F3(
	function (key, mime, bytes) {
		return A2(
			_Http_pair,
			key,
			A2(_Http_bytesToBlob, mime, bytes));
	});
var $author$project$Data$Api$UploadAvatar$Payload = function (avatarUrl) {
	return {avatarUrl: avatarUrl};
};
var $author$project$Data$Api$UploadAvatar$dataDecoder = A2(
	$elm$json$Json$Decode$map,
	$author$project$Data$Api$UploadAvatar$Payload,
	A2($elm$json$Json$Decode$field, 'avatarUrl', $elm$json$Json$Decode$string));
var $author$project$Data$Api$UploadAvatar$FAIL_TO_UPLOAD = {$: 'FAIL_TO_UPLOAD'};
var $author$project$Data$Api$UploadAvatar$INVALID_FILE = {$: 'INVALID_FILE'};
var $author$project$Data$Api$UploadAvatar$LIMIT_FILE_SIZE = {$: 'LIMIT_FILE_SIZE'};
var $author$project$Data$Api$UploadAvatar$LIMIT_UNEXPECTED_FILE = {$: 'LIMIT_UNEXPECTED_FILE'};
var $author$project$Data$Api$UploadAvatar$errorDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (errorCode) {
		switch (errorCode) {
			case 'INVALID_FILE':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$UploadAvatar$INVALID_FILE);
			case 'LIMIT_FILE_SIZE':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$UploadAvatar$LIMIT_FILE_SIZE);
			case 'LIMIT_UNEXPECTED_FILE':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$UploadAvatar$LIMIT_UNEXPECTED_FILE);
			case 'FAIL_TO_UPLOAD':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$UploadAvatar$FAIL_TO_UPLOAD);
			default:
				return $elm$json$Json$Decode$fail('Invalid error code: ' + errorCode);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Data$Api$UploadAvatar$authCall = F3(
	function (jwt, endPoint, avatarFileData) {
		return A5(
			$author$project$Data$Api$authUpload,
			jwt,
			endPoint,
			$author$project$Data$Api$UploadAvatar$errorDecoder,
			$author$project$Data$Api$UploadAvatar$dataDecoder,
			_List_fromArray(
				[
					A3($elm$http$Http$bytesPart, 'avatar', 'image/png', avatarFileData)
				]));
	});
var $author$project$Type$Setting$ImageUrl = function (a) {
	return {$: 'ImageUrl', a: a};
};
var $author$project$Model$Settings$checkImage = F2(
	function (model, file) {
		var imgType = _List_fromArray(
			['image/jpg', 'image/jpeg', 'image/gif', 'image/png']);
		var _v0 = model;
		var image = _v0.image;
		return (!A2(
			$elm$core$List$member,
			$elm$file$File$mime(file),
			imgType)) ? _Utils_Tuple2(
			_Utils_update(
				model,
				{
					image: _Utils_update(
						image,
						{
							formStatus: $author$project$Type$Setting$Error('Invalid File Type')
						})
				}),
			$elm$core$Platform$Cmd$none) : (($elm$file$File$size(file) > 3145728) ? _Utils_Tuple2(
			_Utils_update(
				model,
				{
					image: _Utils_update(
						image,
						{
							formStatus: $author$project$Type$Setting$Error('File cannot be larger than 3MB.')
						})
				}),
			$elm$core$Platform$Cmd$none) : _Utils_Tuple2(
			model,
			A2(
				$elm$core$Platform$Cmd$map,
				$author$project$Type$Setting$OnImageUpload,
				A2(
					$elm$core$Task$perform,
					$author$project$Type$Setting$ImageUrl,
					$elm$file$File$toUrl(file)))));
	});
var $author$project$Model$Settings$convertNetworkToString = function (currentUserNotarisationNetwork) {
	if (currentUserNotarisationNetwork.$ === 'Binance') {
		return 'Binance';
	} else {
		return 'Algorand';
	}
};
var $author$project$Model$Settings$convertPaymentToString = function (currentUserNotarisationNetwork) {
	switch (currentUserNotarisationNetwork.$) {
		case 'SystemBalance':
			return 'systemBalance';
		case 'AlgoWallet':
			return 'algoWallet';
		default:
			return 'walletConnect';
	}
};
var $author$project$Data$Api$UpdateNotarisationNetwork$errorToString = function (error) {
	switch (error.$) {
		case 'INVALID_NETWORK_TYPE':
			return 'Invalid network type selected.';
		case 'UNAUTHORISED_USER':
			return 'You are not allowed to perform this action';
		case 'INVALID_PAYMENT_METHOD':
			return 'Invalid payment type selected.';
		default:
			return 'Invalid notarisation option chosen.';
	}
};
var $author$project$Data$Api$UpdateNotification$errorToString = function (error) {
	return 'User not found.';
};
var $author$project$Data$Api$UpdatePassword$errorToString = function (error) {
	switch (error.$) {
		case 'USER_NOT_FOUND':
			return 'User not found.';
		case 'PASSWORD_REQUIREMENT':
			return 'Password did not meet the minimum requirement.';
		default:
			return 'Invalid current password.';
	}
};
var $author$project$Data$Api$UpdateProfile$errorToString = function (error) {
	switch (error.$) {
		case 'EMPTY_NAME':
			return 'Name cannot be empty.';
		case 'INVALID_PHONE':
			return 'Phone number is invalid.';
		case 'INVALID_DATE':
			return 'Invalid date.';
		default:
			return 'User not found.';
	}
};
var $author$project$Data$Api$UpdateShowAds$errorToString = function (error) {
	if (error.$ === 'UNAUTHORISED_USER') {
		return 'You are not allowed to perform this action';
	} else {
		return 'Invalid JWT token.';
	}
};
var $author$project$Data$Api$UploadAvatar$errorToString = function (error) {
	switch (error.$) {
		case 'INVALID_FILE':
			return 'Image file is invalid.';
		case 'LIMIT_FILE_SIZE':
			return 'Image file size exceeded required limit.';
		case 'LIMIT_UNEXPECTED_FILE':
			return 'Image file is an invalid file type.';
		default:
			return 'Network error. Please try again.';
	}
};
var $author$project$Model$Settings$checkIdentification = function (value) {
	return $elm$core$String$isEmpty(value) ? $elm$core$Maybe$Nothing : (($elm$core$String$length(value) > 5) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just('Invalid Identification Number'));
};
var $author$project$Model$Settings$checkIfOldNewPasswordIsSame = F3(
	function (currentPassword, newPassword, error) {
		return _Utils_eq(error, $elm$core$Maybe$Nothing) ? (_Utils_eq(currentPassword, newPassword) ? $elm$core$Maybe$Just('New password cannot be the same as the old password') : $elm$core$Maybe$Nothing) : error;
	});
var $author$project$Model$Settings$checkPasswordLength = function (password) {
	return ($elm$core$String$length(password) > 0) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just('Password cannot be empty');
};
var $author$project$Model$Settings$validatePasswordCriteria = F2(
	function (password, error) {
		return _Utils_eq(error, $elm$core$Maybe$Nothing) ? (A2(
			$elm$regex$Regex$contains,
			A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9]).{8,}$')),
			password) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just('Password did not match the requirement')) : error;
	});
var $author$project$Model$Settings$checkPassword = function (password) {
	return A2(
		$author$project$Model$Settings$validatePasswordCriteria,
		password,
		$author$project$Model$Settings$checkPasswordLength(password));
};
var $author$project$Model$Settings$checkPhoneNum = function (value) {
	var phoneNum = A3($elm$core$String$replace, ' ', '', value);
	return $elm$core$String$isEmpty(phoneNum) ? $elm$core$Maybe$Nothing : (A2(
		$elm$regex$Regex$contains,
		A2(
			$elm$core$Maybe$withDefault,
			$elm$regex$Regex$never,
			$elm$regex$Regex$fromString('^\\+\\d{8,30}$')),
		phoneNum) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just('Invalid Phone Number'));
};
var $author$project$Model$Settings$validateName = function (name) {
	return (!$elm$core$String$isEmpty(name)) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just('Name cannot be empty');
};
var $author$project$Model$Settings$validatePasswordIsSame = F3(
	function (newPassword, cfmNewPassword, error) {
		return _Utils_eq(error, $elm$core$Maybe$Nothing) ? ((($elm$core$String$length(newPassword) > 0) && ($elm$core$String$length(cfmNewPassword) > 0)) ? (_Utils_eq(newPassword, cfmNewPassword) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just('Confirm Password must match New Password')) : error) : error;
	});
var $author$project$Model$Settings$onBlur = F2(
	function (settingModel, field) {
		var _v0 = settingModel;
		var profile = _v0.profile;
		var security = _v0.security;
		switch (field.$) {
			case 'LastName':
				var updatedProfile = _Utils_update(
					profile,
					{
						lastNameError: $author$project$Model$Settings$validateName(profile.data.lastName)
					});
				return _Utils_Tuple2(
					_Utils_update(
						settingModel,
						{profile: updatedProfile}),
					$elm$core$Platform$Cmd$none);
			case 'FirstName':
				var updatedProfile = _Utils_update(
					profile,
					{
						firstNameError: $author$project$Model$Settings$validateName(profile.data.firstName)
					});
				return _Utils_Tuple2(
					_Utils_update(
						settingModel,
						{profile: updatedProfile}),
					$elm$core$Platform$Cmd$none);
			case 'IdentificationNum':
				var updatedProfile = _Utils_update(
					profile,
					{
						identificationNumError: A2($elm$core$Maybe$andThen, $author$project$Model$Settings$checkIdentification, profile.data.identificationNumber)
					});
				return _Utils_Tuple2(
					_Utils_update(
						settingModel,
						{profile: updatedProfile}),
					$elm$core$Platform$Cmd$none);
			case 'PhoneNum':
				var _v2 = function () {
					var _v3 = profile.data.phoneNumber;
					if (_v3.$ === 'Just') {
						var phoneNumber = _v3.a;
						var formattedNumber = $elm$core$Maybe$Just(
							A3($elm$core$String$replace, ' ', '', phoneNumber));
						return _Utils_Tuple2(
							A2($elm$core$Maybe$andThen, $author$project$Model$Settings$checkPhoneNum, formattedNumber),
							formattedNumber);
					} else {
						return _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing);
					}
				}();
				var error = _v2.a;
				var phoneNum = _v2.b;
				var _v4 = profile;
				var data = _v4.data;
				var updatedProfile = _Utils_update(
					profile,
					{
						data: _Utils_update(
							data,
							{phoneNumber: phoneNum}),
						phoneNumError: error
					});
				return _Utils_Tuple2(
					_Utils_update(
						settingModel,
						{profile: updatedProfile}),
					$elm$core$Platform$Cmd$none);
			case 'Nationality':
				return _Utils_Tuple2(settingModel, $elm$core$Platform$Cmd$none);
			case 'DOB':
				return _Utils_Tuple2(settingModel, $elm$core$Platform$Cmd$none);
			case 'Address':
				return _Utils_Tuple2(settingModel, $elm$core$Platform$Cmd$none);
			case 'CurrentPassword':
				return _Utils_Tuple2(
					_Utils_update(
						settingModel,
						{
							security: _Utils_update(
								security,
								{
									currentPasswordError: $author$project$Model$Settings$checkPasswordLength(security.currentPassword)
								})
						}),
					$elm$core$Platform$Cmd$none);
			case 'NewPassword':
				return _Utils_Tuple2(
					_Utils_update(
						settingModel,
						{
							security: _Utils_update(
								security,
								{
									newPasswordError: A3(
										$author$project$Model$Settings$checkIfOldNewPasswordIsSame,
										security.currentPassword,
										security.newPassword,
										$author$project$Model$Settings$checkPassword(security.newPassword))
								})
						}),
					$elm$core$Platform$Cmd$none);
			default:
				return _Utils_Tuple2(
					_Utils_update(
						settingModel,
						{
							security: _Utils_update(
								security,
								{
									confirmNewPasswordError: A3(
										$author$project$Model$Settings$validatePasswordIsSame,
										security.newPassword,
										security.confirmNewPassword,
										$author$project$Model$Settings$checkPassword(security.confirmNewPassword))
								})
						}),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Model$Settings$onInput = F3(
	function (settingModel, field, value) {
		var _v0 = settingModel;
		var profile = _v0.profile;
		var security = _v0.security;
		var _v1 = profile;
		var data = _v1.data;
		switch (field.$) {
			case 'LastName':
				var updatedProfile = _Utils_update(
					profile,
					{
						data: _Utils_update(
							data,
							{lastName: value}),
						formStatus: $author$project$Type$Setting$Ready,
						lastNameError: $elm$core$Maybe$Nothing
					});
				return _Utils_Tuple2(
					_Utils_update(
						settingModel,
						{profile: updatedProfile}),
					$elm$core$Platform$Cmd$none);
			case 'FirstName':
				var updatedProfile = _Utils_update(
					profile,
					{
						data: _Utils_update(
							data,
							{firstName: value}),
						firstNameError: $elm$core$Maybe$Nothing,
						formStatus: $author$project$Type$Setting$Ready
					});
				return _Utils_Tuple2(
					_Utils_update(
						settingModel,
						{profile: updatedProfile}),
					$elm$core$Platform$Cmd$none);
			case 'IdentificationNum':
				var updatedProfile = _Utils_update(
					profile,
					{
						data: _Utils_update(
							data,
							{
								identificationNumber: $elm$core$Maybe$Just(value)
							}),
						formStatus: $author$project$Type$Setting$Ready,
						identificationNumError: $elm$core$Maybe$Nothing
					});
				return _Utils_Tuple2(
					_Utils_update(
						settingModel,
						{profile: updatedProfile}),
					$elm$core$Platform$Cmd$none);
			case 'PhoneNum':
				var updatedProfile = _Utils_update(
					profile,
					{
						data: _Utils_update(
							data,
							{
								phoneNumber: $elm$core$Maybe$Just(value)
							}),
						formStatus: $author$project$Type$Setting$Ready,
						phoneNumError: $elm$core$Maybe$Nothing
					});
				return _Utils_Tuple2(
					_Utils_update(
						settingModel,
						{profile: updatedProfile}),
					$elm$core$Platform$Cmd$none);
			case 'Nationality':
				var updatedProfile = _Utils_update(
					profile,
					{
						data: _Utils_update(
							data,
							{
								nationality: $elm$core$Maybe$Just(value)
							}),
						formStatus: $author$project$Type$Setting$Ready
					});
				return _Utils_Tuple2(
					_Utils_update(
						settingModel,
						{profile: updatedProfile}),
					$elm$core$Platform$Cmd$none);
			case 'DOB':
				var updatedProfile = _Utils_update(
					profile,
					{
						data: _Utils_update(
							data,
							{
								dateOfBirth: $elm$core$Maybe$Just(value)
							}),
						formStatus: $author$project$Type$Setting$Ready
					});
				return _Utils_Tuple2(
					_Utils_update(
						settingModel,
						{profile: updatedProfile}),
					$elm$core$Platform$Cmd$none);
			case 'Address':
				var updatedProfile = _Utils_update(
					profile,
					{
						data: _Utils_update(
							data,
							{
								address: $elm$core$Maybe$Just(value)
							}),
						formStatus: $author$project$Type$Setting$Ready
					});
				return _Utils_Tuple2(
					_Utils_update(
						settingModel,
						{profile: updatedProfile}),
					$elm$core$Platform$Cmd$none);
			case 'CurrentPassword':
				return _Utils_Tuple2(
					_Utils_update(
						settingModel,
						{
							security: _Utils_update(
								security,
								{currentPassword: value, currentPasswordError: $elm$core$Maybe$Nothing, formStatus: $author$project$Type$Setting$Ready})
						}),
					$elm$core$Platform$Cmd$none);
			case 'NewPassword':
				return _Utils_Tuple2(
					_Utils_update(
						settingModel,
						{
							security: _Utils_update(
								security,
								{formStatus: $author$project$Type$Setting$Ready, newPassword: value, newPasswordError: $elm$core$Maybe$Nothing})
						}),
					$elm$core$Platform$Cmd$none);
			default:
				return _Utils_Tuple2(
					_Utils_update(
						settingModel,
						{
							security: _Utils_update(
								security,
								{confirmNewPassword: value, confirmNewPasswordError: $elm$core$Maybe$Nothing, formStatus: $author$project$Type$Setting$Ready})
						}),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Type$Setting$NotificationResponse = function (a) {
	return {$: 'NotificationResponse', a: a};
};
var $author$project$Type$Setting$PasswordResponse = function (a) {
	return {$: 'PasswordResponse', a: a};
};
var $author$project$Type$Setting$ProfileResponse = function (a) {
	return {$: 'ProfileResponse', a: a};
};
var $author$project$Data$Api$UpdateNotification$Payload = function (message) {
	return {message: message};
};
var $author$project$Data$Api$UpdateNotification$dataDecoder = A2(
	$elm$json$Json$Decode$map,
	$author$project$Data$Api$UpdateNotification$Payload,
	A2($elm$json$Json$Decode$field, 'message', $elm$json$Json$Decode$string));
var $author$project$Data$Api$UpdateNotification$encode = function (data) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'email',
				$elm$json$Json$Encode$bool(data.email))
			]));
};
var $author$project$Data$Api$UpdateNotification$USER_NOT_FOUND = {$: 'USER_NOT_FOUND'};
var $author$project$Data$Api$UpdateNotification$errorDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (errorCode) {
		if (errorCode === 'USER_NOT_FOUND') {
			return $elm$json$Json$Decode$succeed($author$project$Data$Api$UpdateNotification$USER_NOT_FOUND);
		} else {
			return $elm$json$Json$Decode$fail('Invalid error code: ' + errorCode);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Data$Api$UpdateNotification$authCall = F3(
	function (jwt, endPoint, data) {
		return A5(
			$author$project$Data$Api$authCall,
			jwt,
			endPoint,
			$author$project$Data$Api$UpdateNotification$errorDecoder,
			$author$project$Data$Api$UpdateNotification$dataDecoder,
			$author$project$Data$Api$UpdateNotification$encode(data));
	});
var $author$project$Data$Api$UpdatePassword$Payload = function (message) {
	return {message: message};
};
var $author$project$Data$Api$UpdatePassword$dataDecoder = A2(
	$elm$json$Json$Decode$map,
	$author$project$Data$Api$UpdatePassword$Payload,
	A2($elm$json$Json$Decode$field, 'message', $elm$json$Json$Decode$string));
var $author$project$Data$Api$UpdatePassword$encode = function (data) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'currentPassword',
				$elm$json$Json$Encode$string(data.currentPassword)),
				_Utils_Tuple2(
				'newPassword',
				$elm$json$Json$Encode$string(data.newPassword))
			]));
};
var $author$project$Data$Api$UpdatePassword$INVALID_PASSWORD = {$: 'INVALID_PASSWORD'};
var $author$project$Data$Api$UpdatePassword$PASSWORD_REQUIREMENT = {$: 'PASSWORD_REQUIREMENT'};
var $author$project$Data$Api$UpdatePassword$USER_NOT_FOUND = {$: 'USER_NOT_FOUND'};
var $author$project$Data$Api$UpdatePassword$errorDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (errorCode) {
		switch (errorCode) {
			case 'USER_NOT_FOUND':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$UpdatePassword$USER_NOT_FOUND);
			case 'PASSWORD_REQUIREMENT':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$UpdatePassword$PASSWORD_REQUIREMENT);
			case 'INVALID_PASSWORD':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$UpdatePassword$INVALID_PASSWORD);
			default:
				return $elm$json$Json$Decode$fail('Invalid error code: ' + errorCode);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Data$Api$UpdatePassword$authCall = F3(
	function (jwt, endPoint, data) {
		return A5(
			$author$project$Data$Api$authCall,
			jwt,
			endPoint,
			$author$project$Data$Api$UpdatePassword$errorDecoder,
			$author$project$Data$Api$UpdatePassword$dataDecoder,
			$author$project$Data$Api$UpdatePassword$encode(data));
	});
var $author$project$Data$Api$UpdateProfile$dataDecoder = $elm$json$Json$Decode$succeed(_Utils_Tuple0);
var $author$project$Data$Api$UpdateProfile$encodeMaybeValue = function (value) {
	if (value.$ === 'Just') {
		var valueString = value.a;
		return $elm$json$Json$Encode$string(valueString);
	} else {
		return $elm$json$Json$Encode$null;
	}
};
var $author$project$Data$Api$UpdateProfile$encode = function (data) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'firstName',
				$elm$json$Json$Encode$string(data.firstName)),
				_Utils_Tuple2(
				'lastName',
				$elm$json$Json$Encode$string(data.lastName)),
				_Utils_Tuple2(
				'identificationNumber',
				$author$project$Data$Api$UpdateProfile$encodeMaybeValue(data.identificationNumber)),
				_Utils_Tuple2(
				'phoneNumber',
				$author$project$Data$Api$UpdateProfile$encodeMaybeValue(data.phoneNumber)),
				_Utils_Tuple2(
				'nationality',
				$author$project$Data$Api$UpdateProfile$encodeMaybeValue(data.nationality)),
				_Utils_Tuple2(
				'dateOfBirth',
				$author$project$Data$Api$UpdateProfile$encodeMaybeValue(data.dateOfBirth)),
				_Utils_Tuple2(
				'address',
				$author$project$Data$Api$UpdateProfile$encodeMaybeValue(data.address)),
				_Utils_Tuple2(
				'shareReferralCode',
				$elm$json$Json$Encode$string(data.shareReferralCode))
			]));
};
var $author$project$Data$Api$UpdateProfile$EMPTY_NAME = {$: 'EMPTY_NAME'};
var $author$project$Data$Api$UpdateProfile$INVALID_DATE = {$: 'INVALID_DATE'};
var $author$project$Data$Api$UpdateProfile$INVALID_PHONE = {$: 'INVALID_PHONE'};
var $author$project$Data$Api$UpdateProfile$USER_NOT_FOUND = {$: 'USER_NOT_FOUND'};
var $author$project$Data$Api$UpdateProfile$errorDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (errorCode) {
		switch (errorCode) {
			case 'EMPTY_NAME':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$UpdateProfile$EMPTY_NAME);
			case 'INVALID_PHONE':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$UpdateProfile$INVALID_PHONE);
			case 'INVALID_DATE':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$UpdateProfile$INVALID_DATE);
			case 'USER_NOT_FOUND':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$UpdateProfile$USER_NOT_FOUND);
			default:
				return $elm$json$Json$Decode$fail('Invalid error code: ' + errorCode);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Data$Api$UpdateProfile$authCall = F3(
	function (jwt, endPoint, data) {
		return A5(
			$author$project$Data$Api$authCall,
			jwt,
			endPoint,
			$author$project$Data$Api$UpdateProfile$errorDecoder,
			$author$project$Data$Api$UpdateProfile$dataDecoder,
			$author$project$Data$Api$UpdateProfile$encode(data));
	});
var $author$project$Model$Settings$onSubmit = F4(
	function (settingModel, submitType, endPoint, user) {
		var _v0 = settingModel;
		var profile = _v0.profile;
		var security = _v0.security;
		var notification = _v0.notification;
		switch (submitType.$) {
			case 'SubmitProfile':
				var updatedProfile = function (model) {
					return _Utils_update(
						model,
						{
							phoneNumError: A2($elm$core$Maybe$andThen, $author$project$Model$Settings$checkPhoneNum, profile.data.phoneNumber)
						});
				}(
					function (model) {
						return _Utils_update(
							model,
							{
								identificationNumError: A2($elm$core$Maybe$andThen, $author$project$Model$Settings$checkIdentification, profile.data.identificationNumber)
							});
					}(
						function (model) {
							return _Utils_update(
								model,
								{
									lastNameError: $author$project$Model$Settings$validateName(profile.data.lastName)
								});
						}(
							_Utils_update(
								profile,
								{
									firstNameError: $author$project$Model$Settings$validateName(profile.data.firstName)
								}))));
				var allPassed = A2(
					$elm$core$List$all,
					$elm$core$Basics$eq($elm$core$Maybe$Nothing),
					_List_fromArray(
						[updatedProfile.firstNameError, updatedProfile.lastNameError, updatedProfile.identificationNumError, updatedProfile.phoneNumError]));
				return allPassed ? _Utils_Tuple2(
					_Utils_update(
						settingModel,
						{
							profile: _Utils_update(
								updatedProfile,
								{formStatus: $author$project$Type$Setting$Submitting})
						}),
					A2(
						$elm$core$Task$attempt,
						$author$project$Type$Setting$ProfileResponse,
						A3($author$project$Data$Api$UpdateProfile$authCall, user.jwt, endPoint.updateProfile, updatedProfile.data))) : _Utils_Tuple2(
					_Utils_update(
						settingModel,
						{profile: updatedProfile}),
					$elm$core$Platform$Cmd$none);
			case 'SubmitNotification':
				return _Utils_Tuple2(
					_Utils_update(
						settingModel,
						{
							notification: _Utils_update(
								notification,
								{formStatus: $author$project$Type$Setting$Submitting})
						}),
					A2(
						$elm$core$Task$attempt,
						$author$project$Type$Setting$NotificationResponse,
						A3(
							$author$project$Data$Api$UpdateNotification$authCall,
							user.jwt,
							endPoint.updateNotification,
							{email: settingModel.notification.email})));
			default:
				var updatedSecurity = function (model) {
					return _Utils_update(
						model,
						{
							confirmNewPasswordError: A3(
								$author$project$Model$Settings$validatePasswordIsSame,
								security.newPassword,
								security.confirmNewPassword,
								$author$project$Model$Settings$checkPassword(security.confirmNewPassword))
						});
				}(
					function (model) {
						return _Utils_update(
							model,
							{
								newPasswordError: A3(
									$author$project$Model$Settings$checkIfOldNewPasswordIsSame,
									security.currentPassword,
									security.newPassword,
									A3(
										$author$project$Model$Settings$validatePasswordIsSame,
										security.newPassword,
										security.confirmNewPassword,
										$author$project$Model$Settings$checkPassword(security.newPassword)))
							});
					}(
						_Utils_update(
							security,
							{
								currentPasswordError: $author$project$Model$Settings$checkPasswordLength(security.currentPassword)
							})));
				var allPassed = A2(
					$elm$core$List$all,
					$elm$core$Basics$eq($elm$core$Maybe$Nothing),
					_List_fromArray(
						[updatedSecurity.currentPasswordError, updatedSecurity.newPasswordError, updatedSecurity.confirmNewPasswordError]));
				return allPassed ? _Utils_Tuple2(
					_Utils_update(
						settingModel,
						{
							security: _Utils_update(
								updatedSecurity,
								{formStatus: $author$project$Type$Setting$Submitting})
						}),
					A2(
						$elm$core$Task$attempt,
						$author$project$Type$Setting$PasswordResponse,
						A3(
							$author$project$Data$Api$UpdatePassword$authCall,
							user.jwt,
							endPoint.updatePassword,
							{currentPassword: settingModel.security.currentPassword, newPassword: settingModel.security.newPassword}))) : _Utils_Tuple2(
					_Utils_update(
						settingModel,
						{security: updatedSecurity}),
					$elm$core$Platform$Cmd$none);
		}
	});
var $elm$file$File$toBytes = _File_toBytes;
var $author$project$Model$Settings$updateUserNotification = F2(
	function (data, user) {
		var _v0 = user;
		var notification = _v0.notification;
		return _Utils_update(
			user,
			{
				notification: _Utils_update(
					notification,
					{email: data})
			});
	});
var $author$project$Model$Settings$updateSetting = F3(
	function (msg, authModel, endPoint) {
		var _v0 = authModel;
		var settingModel = _v0.settingModel;
		var user = _v0.user;
		var _v1 = settingModel;
		var image = _v1.image;
		var notification = _v1.notification;
		var profile = _v1.profile;
		var security = _v1.security;
		var notarisationNetworkInfo = _v1.notarisationNetworkInfo;
		var _v2 = settingModel.profile;
		var data = _v2.data;
		switch (msg.$) {
			case 'OnLoad':
				var maybeCode = msg.a;
				if (maybeCode.$ === 'Just') {
					var code = maybeCode.a;
					return _Utils_Tuple2(
						_Utils_update(
							authModel,
							{
								settingModel: _Utils_update(
									settingModel,
									{
										profile: _Utils_update(
											profile,
											{myInfoStatus: $author$project$Type$Setting$Retrieving})
									})
							}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2(
									$elm$core$Task$attempt,
									A2(
										$elm$core$Basics$composeL,
										A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnSetting),
										$author$project$Type$Setting$OnMyInfoResult),
									A4($author$project$Data$Api$MyInfo$MyInfo$authCall, user.jwt, endPoint.myInfo, code, user.id)),
									A2(
									$elm$core$Task$attempt,
									A2(
										$elm$core$Basics$composeL,
										A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnSetting),
										$author$project$Type$Setting$OnApiKeyResult),
									A2($author$project$Data$Api$ApiKey$authCall, user.jwt, endPoint.getUserApiKey))
								])));
				} else {
					return _Utils_Tuple2(
						_Utils_update(
							authModel,
							{
								settingModel: $author$project$Model$Settings$init(authModel.user)
							}),
						A2(
							$elm$core$Task$attempt,
							A2(
								$elm$core$Basics$composeL,
								A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnSetting),
								$author$project$Type$Setting$OnApiKeyResult),
							A2($author$project$Data$Api$ApiKey$authCall, user.jwt, endPoint.getUserApiKey)));
				}
			case 'OnMyInfoResult':
				var result = msg.a;
				if (result.$ === 'Err') {
					return _Utils_Tuple2(
						_Utils_update(
							authModel,
							{
								settingModel: _Utils_update(
									settingModel,
									{
										profile: _Utils_update(
											profile,
											{
												formStatus: $author$project$Type$Setting$Error('Erroring retriving MyInfo Data. Please try again later.'),
												myInfoStatus: $author$project$Type$Setting$ErrData
											})
									})
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var identificationNumber = result.a.identificationNumber;
					var phoneNumber = result.a.phoneNumber;
					var dateOfBirth = result.a.dateOfBirth;
					var address = result.a.address;
					return _Utils_Tuple2(
						_Utils_update(
							authModel,
							{
								settingModel: _Utils_update(
									settingModel,
									{
										profile: _Utils_update(
											profile,
											{
												data: _Utils_update(
													data,
													{
														address: $elm$core$Maybe$Just(address),
														dateOfBirth: $elm$core$Maybe$Just(dateOfBirth),
														identificationNumber: $elm$core$Maybe$Just(identificationNumber),
														phoneNumber: phoneNumber
													}),
												myInfoStatus: $author$project$Type$Setting$OkData
											})
									})
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 'OnApiKeyResult':
				var result = msg.a;
				if (result.$ === 'Err') {
					return _Utils_Tuple2(authModel, $elm$core$Platform$Cmd$none);
				} else {
					var apiKeys = result.a.apiKeys;
					return _Utils_Tuple2(
						_Utils_update(
							authModel,
							{
								settingModel: _Utils_update(
									settingModel,
									{apiKeys: apiKeys})
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 'OnInput':
				var field = msg.a;
				var value = msg.b;
				var _v7 = A3($author$project$Model$Settings$onInput, settingModel, field, value);
				var newSettingModel = _v7.a;
				var settingCmd = _v7.b;
				return _Utils_Tuple2(
					_Utils_update(
						authModel,
						{settingModel: newSettingModel}),
					A2(
						$elm$core$Platform$Cmd$map,
						A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnSetting),
						settingCmd));
			case 'OnBlur':
				var field = msg.a;
				var _v8 = A2($author$project$Model$Settings$onBlur, settingModel, field);
				var newSettingModel = _v8.a;
				var settingCmd = _v8.b;
				return _Utils_Tuple2(
					_Utils_update(
						authModel,
						{settingModel: newSettingModel}),
					A2(
						$elm$core$Platform$Cmd$map,
						A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnSetting),
						settingCmd));
			case 'OnImageUpload':
				var imageUpload = msg.a;
				switch (imageUpload.$) {
					case 'ImageRequested':
						return _Utils_Tuple2(
							authModel,
							A2(
								$elm$core$Platform$Cmd$map,
								A2(
									$elm$core$Basics$composeL,
									A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnSetting),
									$author$project$Type$Setting$OnImageUpload),
								A2(
									$elm$file$File$Select$file,
									_List_fromArray(
										['image/*']),
									$author$project$Type$Setting$ImageLoaded)));
					case 'ImageLoaded':
						var file = imageUpload.a;
						var _v10 = A2($author$project$Model$Settings$checkImage, settingModel, file);
						var newSettingModel = _v10.a;
						var settingCmd = _v10.b;
						return _Utils_Tuple2(
							_Utils_update(
								authModel,
								{settingModel: newSettingModel}),
							A2(
								$elm$core$Platform$Cmd$map,
								A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnSetting),
								settingCmd));
					case 'ImageUrl':
						var base64ImageData = imageUpload.a;
						return _Utils_Tuple2(
							_Utils_update(
								authModel,
								{
									settingModel: _Utils_update(
										settingModel,
										{
											image: _Utils_update(
												image,
												{
													formStatus: $author$project$Type$Setting$Ready,
													imageEditor: $author$project$Type$Setting$Opened(base64ImageData)
												})
										})
								}),
							$author$project$ImageEditor$load(
								{cropHeight: 160, cropWidth: 160}));
					case 'ImageAction':
						var action = imageUpload.a;
						return _Utils_Tuple2(
							authModel,
							$author$project$ImageEditor$update(action));
					case 'ImageCancel':
						return _Utils_Tuple2(
							_Utils_update(
								authModel,
								{
									settingModel: _Utils_update(
										settingModel,
										{
											image: _Utils_update(
												image,
												{formStatus: $author$project$Type$Setting$Ready, imageEditor: $author$project$Type$Setting$Closed})
										})
								}),
							$elm$core$Platform$Cmd$none);
					case 'ImageSubmit':
						var base64ImageData = imageUpload.a;
						return _Utils_Tuple2(
							_Utils_update(
								authModel,
								{
									settingModel: _Utils_update(
										settingModel,
										{
											image: _Utils_update(
												image,
												{
													formStatus: $author$project$Type$Setting$Submitting,
													imageEditor: $author$project$Type$Setting$Processing(base64ImageData)
												})
										})
								}),
							$author$project$ImageEditor$getImageDataAndDestroy(_Utils_Tuple0));
					case 'ImageReceivedData':
						var result = imageUpload.a;
						if (result.$ === 'Err') {
							return _Utils_Tuple2(
								_Utils_update(
									authModel,
									{
										settingModel: _Utils_update(
											settingModel,
											{
												image: _Utils_update(
													image,
													{
														formStatus: $author$project$Type$Setting$Error('Invalid image data.'),
														imageEditor: $author$project$Type$Setting$Closed
													})
											})
									}),
								$elm$core$Platform$Cmd$none);
						} else {
							var _v12 = result.a;
							var localUrl = _v12.a;
							var file = _v12.b;
							return _Utils_Tuple2(
								authModel,
								A2(
									$elm$core$Task$perform,
									A2(
										$elm$core$Basics$composeL,
										A2(
											$elm$core$Basics$composeL,
											A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnSetting),
											$author$project$Type$Setting$OnImageUpload),
										$author$project$Type$Setting$ImageReceivedDataBytes(localUrl)),
									$elm$file$File$toBytes(file)));
						}
					case 'ImageReceivedDataBytes':
						var localUrl = imageUpload.a;
						var bytes = imageUpload.b;
						return _Utils_Tuple2(
							_Utils_update(
								authModel,
								{
									settingModel: _Utils_update(
										settingModel,
										{
											image: _Utils_update(
												image,
												{
													formStatus: $author$project$Type$Setting$Submitting,
													imageEditor: $author$project$Type$Setting$Closed,
													imageUrl: $elm$core$Maybe$Just(localUrl)
												})
										})
								}),
							A2(
								$elm$core$Task$attempt,
								A2(
									$elm$core$Basics$composeL,
									A2(
										$elm$core$Basics$composeL,
										A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnSetting),
										$author$project$Type$Setting$OnImageUpload),
									$author$project$Type$Setting$ImageSubmitResult),
								A3($author$project$Data$Api$UploadAvatar$authCall, user.jwt, endPoint.uploadAvatar, bytes)));
					default:
						var result = imageUpload.a;
						if (result.$ === 'Err') {
							var error = result.a;
							return _Utils_Tuple2(
								_Utils_update(
									authModel,
									{
										settingModel: _Utils_update(
											settingModel,
											{
												image: _Utils_update(
													image,
													{
														formStatus: $author$project$Type$Setting$Error(
															A2($author$project$Data$Api$authErrorToString, $author$project$Data$Api$UploadAvatar$errorToString, error))
													})
											})
									}),
								$elm$core$Platform$Cmd$none);
						} else {
							return _Utils_Tuple2(
								_Utils_update(
									authModel,
									{
										settingModel: _Utils_update(
											settingModel,
											{
												image: _Utils_update(
													image,
													{formStatus: $author$project$Type$Setting$Submitted, imageEditor: $author$project$Type$Setting$Closed})
											}),
										user: _Utils_update(
											user,
											{avatarUrl: image.imageUrl})
									}),
								$elm$core$Platform$Cmd$none);
						}
				}
			case 'OnSubmit':
				var submitType = msg.a;
				var _v14 = A4($author$project$Model$Settings$onSubmit, settingModel, submitType, endPoint, user);
				var newSettingModel = _v14.a;
				var settingCmd = _v14.b;
				return _Utils_Tuple2(
					_Utils_update(
						authModel,
						{settingModel: newSettingModel}),
					A2(
						$elm$core$Platform$Cmd$map,
						A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnSetting),
						settingCmd));
			case 'OnEmailNotification':
				var bool = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						authModel,
						{
							settingModel: _Utils_update(
								settingModel,
								{
									notification: _Utils_update(
										notification,
										{email: bool})
								})
						}),
					$elm$core$Platform$Cmd$none);
			case 'OnCopyReferralCodeClick':
				var referralCode = msg.a;
				var timeout = msg.b;
				return _Utils_Tuple2(
					_Utils_update(
						authModel,
						{
							settingModel: _Utils_update(
								settingModel,
								{
									profile: _Utils_update(
										profile,
										{referralCodeSnackbarStatus: $author$project$Material$Styled$Snackbar$Show})
								})
						}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$Data$Clipboard$encodeAndCopy(referralCode),
								A2(
								$author$project$Material$Styled$Snackbar$hide,
								timeout,
								A2(
									$elm$core$Basics$composeL,
									A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnSetting),
									$author$project$Type$Setting$CloseSnackBar))
							])));
			case 'CloseSnackBar':
				return _Utils_Tuple2(
					_Utils_update(
						authModel,
						{
							settingModel: _Utils_update(
								settingModel,
								{
									profile: _Utils_update(
										profile,
										{referralCodeSnackbarStatus: $author$project$Material$Styled$Snackbar$Hide})
								})
						}),
					$elm$core$Platform$Cmd$none);
			case 'OnStampsHover':
				var action = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						authModel,
						{
							settingModel: _Utils_update(
								settingModel,
								{
									profile: _Utils_update(
										profile,
										{
											stampsHover: _Utils_eq(action, $author$project$Type$Setting$Enter)
										})
								})
						}),
					$elm$core$Platform$Cmd$none);
			case 'ProfileResponse':
				var result = msg.a;
				if (result.$ === 'Ok') {
					var newUser = _Utils_update(
						user,
						{address: settingModel.profile.data.address, dateOfBirth: settingModel.profile.data.dateOfBirth, firstName: settingModel.profile.data.firstName, identificationNumber: settingModel.profile.data.identificationNumber, lastName: settingModel.profile.data.lastName, nationality: settingModel.profile.data.nationality, phoneNumber: settingModel.profile.data.phoneNumber, shareReferralCode: settingModel.profile.data.shareReferralCode});
					return _Utils_Tuple2(
						_Utils_update(
							authModel,
							{
								settingModel: _Utils_update(
									settingModel,
									{
										profile: _Utils_update(
											profile,
											{formStatus: $author$project$Type$Setting$Submitted})
									}),
								user: newUser
							}),
						$author$project$Data$User$store(newUser));
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							authModel,
							{
								settingModel: _Utils_update(
									settingModel,
									{
										profile: _Utils_update(
											profile,
											{
												formStatus: $author$project$Type$Setting$Error(
													A2($author$project$Data$Api$authErrorToString, $author$project$Data$Api$UpdateProfile$errorToString, error))
											})
									})
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 'PasswordResponse':
				var result = msg.a;
				if (result.$ === 'Ok') {
					return _Utils_Tuple2(
						_Utils_update(
							authModel,
							{
								settingModel: _Utils_update(
									settingModel,
									{
										security: {confirmNewPassword: '', confirmNewPasswordError: $elm$core$Maybe$Nothing, currentPassword: '', currentPasswordError: $elm$core$Maybe$Nothing, formStatus: $author$project$Type$Setting$Submitted, newPassword: '', newPasswordError: $elm$core$Maybe$Nothing}
									})
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							authModel,
							{
								settingModel: _Utils_update(
									settingModel,
									{
										security: _Utils_update(
											security,
											{
												formStatus: $author$project$Type$Setting$Error(
													A2($author$project$Data$Api$authErrorToString, $author$project$Data$Api$UpdatePassword$errorToString, error))
											})
									})
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 'NotificationResponse':
				var result = msg.a;
				if (result.$ === 'Ok') {
					var newUser = A2($author$project$Model$Settings$updateUserNotification, settingModel.notification.email, user);
					return _Utils_Tuple2(
						_Utils_update(
							authModel,
							{
								settingModel: _Utils_update(
									settingModel,
									{
										notification: _Utils_update(
											notification,
											{formStatus: $author$project$Type$Setting$Submitted})
									}),
								user: newUser
							}),
						$author$project$Data$User$store(newUser));
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							authModel,
							{
								settingModel: _Utils_update(
									settingModel,
									{
										notification: _Utils_update(
											notification,
											{
												formStatus: $author$project$Type$Setting$Error(
													A2($author$project$Data$Api$authErrorToString, $author$project$Data$Api$UpdateNotification$errorToString, error))
											})
									})
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 'CloseBanner':
				var banner = msg.a;
				switch (banner.$) {
					case 'NotificationBanner':
						return _Utils_Tuple2(
							_Utils_update(
								authModel,
								{
									settingModel: _Utils_update(
										settingModel,
										{
											notification: _Utils_update(
												notification,
												{formStatus: $author$project$Type$Setting$Ready})
										})
								}),
							$elm$core$Platform$Cmd$none);
					case 'PasswordBanner':
						return _Utils_Tuple2(
							_Utils_update(
								authModel,
								{
									settingModel: _Utils_update(
										settingModel,
										{
											security: _Utils_update(
												security,
												{formStatus: $author$project$Type$Setting$Ready})
										})
								}),
							$elm$core$Platform$Cmd$none);
					case 'ProfileBanner':
						return _Utils_Tuple2(
							_Utils_update(
								authModel,
								{
									settingModel: _Utils_update(
										settingModel,
										{
											profile: _Utils_update(
												profile,
												{formStatus: $author$project$Type$Setting$Ready})
										})
								}),
							$elm$core$Platform$Cmd$none);
					case 'NotarisationNetworkBanner':
						return _Utils_Tuple2(
							_Utils_update(
								authModel,
								{
									settingModel: _Utils_update(
										settingModel,
										{
											notarisationNetworkInfo: _Utils_update(
												notarisationNetworkInfo,
												{updateStatus: $author$project$Type$Setting$Ready})
										})
								}),
							$elm$core$Platform$Cmd$none);
					case 'PaymentMethodBanner':
						return _Utils_Tuple2(
							_Utils_update(
								authModel,
								{
									settingModel: _Utils_update(
										settingModel,
										{
											notarisationNetworkInfo: _Utils_update(
												notarisationNetworkInfo,
												{updatePayment: $author$project$Type$Setting$Ready})
										})
								}),
							$elm$core$Platform$Cmd$none);
					case 'DefaultNotarisationBanner':
						return _Utils_Tuple2(
							_Utils_update(
								authModel,
								{
									settingModel: _Utils_update(
										settingModel,
										{
											notarisationNetworkInfo: _Utils_update(
												notarisationNetworkInfo,
												{updateDefaultNotarisation: $author$project$Type$Setting$Ready})
										})
								}),
							$elm$core$Platform$Cmd$none);
					default:
						return _Utils_Tuple2(
							_Utils_update(
								authModel,
								{
									settingModel: _Utils_update(
										settingModel,
										{
											profile: _Utils_update(
												profile,
												{formStatus: $author$project$Type$Setting$Ready})
										})
								}),
							$elm$core$Platform$Cmd$none);
				}
			case 'RadioBtnClick':
				var radiobutton = msg.a;
				switch (radiobutton.$) {
					case 'BinanceRadioBtn':
						return _Utils_Tuple2(
							_Utils_update(
								authModel,
								{
									settingModel: _Utils_update(
										settingModel,
										{
											notarisationNetworkInfo: _Utils_update(
												notarisationNetworkInfo,
												{currentNetwork: $author$project$Type$Setting$Binance, paymentMethod: $author$project$Type$Setting$SystemBalance})
										})
								}),
							$elm$core$Platform$Cmd$none);
					case 'AlgorandRadioBtn':
						return _Utils_Tuple2(
							_Utils_update(
								authModel,
								{
									settingModel: _Utils_update(
										settingModel,
										{
											notarisationNetworkInfo: _Utils_update(
												notarisationNetworkInfo,
												{currentNetwork: $author$project$Type$Setting$Algorand})
										})
								}),
							$elm$core$Platform$Cmd$none);
					case 'SystemSignPointsBalance':
						return _Utils_Tuple2(
							_Utils_update(
								authModel,
								{
									settingModel: _Utils_update(
										settingModel,
										{
											notarisationNetworkInfo: _Utils_update(
												notarisationNetworkInfo,
												{paymentMethod: $author$project$Type$Setting$SystemBalance})
										})
								}),
							$elm$core$Platform$Cmd$none);
					case 'UserWallet':
						return _Utils_Tuple2(
							_Utils_update(
								authModel,
								{
									settingModel: _Utils_update(
										settingModel,
										{
											notarisationNetworkInfo: _Utils_update(
												notarisationNetworkInfo,
												{paymentMethod: $author$project$Type$Setting$AlgoWallet})
										})
								}),
							$elm$core$Platform$Cmd$none);
					case 'WalletConnectBtn':
						return _Utils_Tuple2(
							_Utils_update(
								authModel,
								{
									settingModel: _Utils_update(
										settingModel,
										{
											notarisationNetworkInfo: _Utils_update(
												notarisationNetworkInfo,
												{paymentMethod: $author$project$Type$Setting$WalletConnect})
										})
								}),
							$elm$core$Platform$Cmd$none);
					case 'DefaultNotariseOn':
						return _Utils_Tuple2(
							_Utils_update(
								authModel,
								{
									settingModel: _Utils_update(
										settingModel,
										{
											notarisationNetworkInfo: _Utils_update(
												notarisationNetworkInfo,
												{defaultNotarisation: true})
										})
								}),
							$elm$core$Platform$Cmd$none);
					case 'DefaultNotariseOff':
						return _Utils_Tuple2(
							_Utils_update(
								authModel,
								{
									settingModel: _Utils_update(
										settingModel,
										{
											notarisationNetworkInfo: _Utils_update(
												notarisationNetworkInfo,
												{defaultNotarisation: false})
										})
								}),
							$elm$core$Platform$Cmd$none);
					case 'ShowAdsOn':
						return _Utils_Tuple2(
							_Utils_update(
								authModel,
								{
									settingModel: _Utils_update(
										settingModel,
										{
											profile: _Utils_update(
												profile,
												{showAds: true})
										})
								}),
							$elm$core$Platform$Cmd$none);
					default:
						return _Utils_Tuple2(
							_Utils_update(
								authModel,
								{
									settingModel: _Utils_update(
										settingModel,
										{
											profile: _Utils_update(
												profile,
												{showAds: false})
										})
								}),
							$elm$core$Platform$Cmd$none);
				}
			case 'OnUpdateNotarisationNetworkResponse':
				var result = msg.a;
				if (result.$ === 'Ok') {
					return _Utils_Tuple2(
						_Utils_update(
							authModel,
							{
								settingModel: _Utils_update(
									settingModel,
									{
										notarisationNetworkInfo: _Utils_update(
											notarisationNetworkInfo,
											{updateStatus: $author$project$Type$Setting$Submitted})
									})
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							authModel,
							{
								settingModel: _Utils_update(
									settingModel,
									{
										notarisationNetworkInfo: _Utils_update(
											notarisationNetworkInfo,
											{
												updateNetworkError: $elm$core$Maybe$Just(
													A2($author$project$Data$Api$authErrorToString, $author$project$Data$Api$UpdateNotarisationNetwork$errorToString, error))
											})
									})
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 'OnNetworkChangeSubmit':
				return _Utils_Tuple2(
					authModel,
					A2(
						$elm$core$Task$attempt,
						A2(
							$elm$core$Basics$composeL,
							A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnSetting),
							$author$project$Type$Setting$OnUpdateNotarisationNetworkResponse),
						A5(
							$author$project$Data$Api$UpdateNotarisationNetwork$authCall,
							user.jwt,
							endPoint.updateNotarisationNetwork,
							$author$project$Model$Settings$convertNetworkToString(settingModel.notarisationNetworkInfo.currentNetwork),
							$author$project$Model$Settings$convertPaymentToString(settingModel.notarisationNetworkInfo.paymentMethod),
							user.notariseByDefault)));
			case 'OnPaymentMethodSubmit':
				return _Utils_Tuple2(
					authModel,
					A2(
						$elm$core$Task$attempt,
						A2(
							$elm$core$Basics$composeL,
							A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnSetting),
							$author$project$Type$Setting$OnPaymentMethodSubmitResponse),
						A5(
							$author$project$Data$Api$UpdateNotarisationNetwork$authCall,
							user.jwt,
							endPoint.updateNotarisationNetwork,
							$author$project$Model$Settings$convertNetworkToString(settingModel.notarisationNetworkInfo.currentNetwork),
							$author$project$Model$Settings$convertPaymentToString(settingModel.notarisationNetworkInfo.paymentMethod),
							user.notariseByDefault)));
			case 'OnPaymentMethodSubmitResponse':
				var result = msg.a;
				if (result.$ === 'Ok') {
					return _Utils_Tuple2(
						_Utils_update(
							authModel,
							{
								settingModel: _Utils_update(
									settingModel,
									{
										notarisationNetworkInfo: _Utils_update(
											notarisationNetworkInfo,
											{updatePayment: $author$project$Type$Setting$Submitted})
									})
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							authModel,
							{
								settingModel: _Utils_update(
									settingModel,
									{
										notarisationNetworkInfo: _Utils_update(
											notarisationNetworkInfo,
											{
												updateNetworkError: $elm$core$Maybe$Just(
													A2($author$project$Data$Api$authErrorToString, $author$project$Data$Api$UpdateNotarisationNetwork$errorToString, error))
											})
									})
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 'OnDefaultNotarisationSubmit':
				return _Utils_Tuple2(
					authModel,
					A2(
						$elm$core$Task$attempt,
						A2(
							$elm$core$Basics$composeL,
							A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnSetting),
							$author$project$Type$Setting$OnDefaultNotarisationSubmitResponse),
						A5($author$project$Data$Api$UpdateNotarisationNetwork$authCall, user.jwt, endPoint.updateNotarisationNetwork, user.notarisationNetwork, user.paymentMethod, settingModel.notarisationNetworkInfo.defaultNotarisation)));
			case 'OnDefaultNotarisationSubmitResponse':
				var result = msg.a;
				if (result.$ === 'Ok') {
					return _Utils_Tuple2(
						_Utils_update(
							authModel,
							{
								settingModel: _Utils_update(
									settingModel,
									{
										notarisationNetworkInfo: _Utils_update(
											notarisationNetworkInfo,
											{updateDefaultNotarisation: $author$project$Type$Setting$Submitted})
									})
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							authModel,
							{
								settingModel: _Utils_update(
									settingModel,
									{
										notarisationNetworkInfo: _Utils_update(
											notarisationNetworkInfo,
											{
												updateNetworkError: $elm$core$Maybe$Just(
													A2($author$project$Data$Api$authErrorToString, $author$project$Data$Api$UpdateNotarisationNetwork$errorToString, error))
											})
									})
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 'OnDefaultNotariseHover':
				var action = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						authModel,
						{
							settingModel: _Utils_update(
								settingModel,
								{
									notarisationNetworkInfo: _Utils_update(
										notarisationNetworkInfo,
										{
											notariseToolTipHover: _Utils_eq(action, $author$project$Type$Setting$Enter)
										})
								})
						}),
					$elm$core$Platform$Cmd$none);
			case 'OnShowsAdsSubmit':
				return _Utils_Tuple2(
					authModel,
					A2(
						$elm$core$Task$attempt,
						A2(
							$elm$core$Basics$composeL,
							A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnSetting),
							$author$project$Type$Setting$OnShowAdsSubmitResponse),
						A3($author$project$Data$Api$UpdateShowAds$authCall, user.jwt, endPoint.updateShowAds, settingModel.profile.showAds)));
			default:
				var result = msg.a;
				if (result.$ === 'Ok') {
					return _Utils_Tuple2(
						_Utils_update(
							authModel,
							{
								settingModel: _Utils_update(
									settingModel,
									{
										profile: _Utils_update(
											profile,
											{formStatus: $author$project$Type$Setting$Submitted})
									})
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							authModel,
							{
								settingModel: _Utils_update(
									settingModel,
									{
										profile: _Utils_update(
											profile,
											{
												showAdError: $elm$core$Maybe$Just(
													A2($author$project$Data$Api$authErrorToString, $author$project$Data$Api$UpdateShowAds$errorToString, error))
											})
									})
							}),
						$elm$core$Platform$Cmd$none);
				}
		}
	});
var $author$project$Model$Settings$update = F3(
	function (msg, authModel, model) {
		var _v0 = A3($author$project$Model$Settings$updateSetting, msg, authModel, model.apiEndPoint);
		var newAuthModel = _v0.a;
		var settingCmd = _v0.b;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					sessionModel: $author$project$Types$Auth(newAuthModel)
				}),
			settingCmd);
	});
var $author$project$Type$ViewDocument$OnCloseModal = {$: 'OnCloseModal'};
var $author$project$Type$ViewDocument$OnNewSignatureAddition = {$: 'OnNewSignatureAddition'};
var $elm$core$Tuple$mapBoth = F3(
	function (funcA, funcB, _v0) {
		var x = _v0.a;
		var y = _v0.b;
		return _Utils_Tuple2(
			funcA(x),
			funcB(y));
	});
var $author$project$Type$Signature$DeleteReponse = function (a) {
	return {$: 'DeleteReponse', a: a};
};
var $author$project$Type$Signature$Signature = F3(
	function (id, name, data) {
		return {data: data, id: id, name: name};
	});
var $author$project$Type$Signature$UploadResponse = function (a) {
	return {$: 'UploadResponse', a: a};
};
var $author$project$Data$Api$Signature$Delete$Payload = function (message) {
	return {message: message};
};
var $author$project$Data$Api$Signature$Delete$dataDecoder = A2(
	$elm$json$Json$Decode$map,
	$author$project$Data$Api$Signature$Delete$Payload,
	A2($elm$json$Json$Decode$field, 'message', $elm$json$Json$Decode$string));
var $author$project$Data$Api$Signature$Delete$INVALID_SIGNATURE = {$: 'INVALID_SIGNATURE'};
var $author$project$Data$Api$Signature$Delete$errorDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (errorCode) {
		if (errorCode === 'INVALID_SIGNATURE') {
			return $elm$json$Json$Decode$succeed($author$project$Data$Api$Signature$Delete$INVALID_SIGNATURE);
		} else {
			return $elm$json$Json$Decode$fail('Invalid error code: ' + errorCode);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Data$Api$Signature$Delete$authCall = F3(
	function (jwt, endPoint, imageID) {
		return A5(
			$author$project$Data$Api$authCall,
			jwt,
			endPoint,
			$author$project$Data$Api$Signature$Delete$errorDecoder,
			$author$project$Data$Api$Signature$Delete$dataDecoder,
			$elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'id',
						$elm$json$Json$Encode$string(imageID))
					])));
	});
var $author$project$Data$Api$Signature$Upload$Payload = function (fileName) {
	return {fileName: fileName};
};
var $author$project$Data$Api$Signature$Upload$dataDecoder = A2(
	$elm$json$Json$Decode$map,
	$author$project$Data$Api$Signature$Upload$Payload,
	A2($elm$json$Json$Decode$field, 'fileName', $elm$json$Json$Decode$string));
var $author$project$Data$Api$Signature$Upload$EMPTY_NAME = {$: 'EMPTY_NAME'};
var $author$project$Data$Api$Signature$Upload$INVALID_FILE = {$: 'INVALID_FILE'};
var $author$project$Data$Api$Signature$Upload$INVALID_LENGTH_NAME = {$: 'INVALID_LENGTH_NAME'};
var $author$project$Data$Api$Signature$Upload$LIMIT_FILE_SIZE = {$: 'LIMIT_FILE_SIZE'};
var $author$project$Data$Api$Signature$Upload$LIMIT_UNEXPECTED_FILE = {$: 'LIMIT_UNEXPECTED_FILE'};
var $author$project$Data$Api$Signature$Upload$MAXIMUM_LIMIT = {$: 'MAXIMUM_LIMIT'};
var $author$project$Data$Api$Signature$Upload$errorDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (errorCode) {
		switch (errorCode) {
			case 'EMPTY_NAME':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$Signature$Upload$EMPTY_NAME);
			case 'INVALID_LENGTH_NAME':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$Signature$Upload$INVALID_LENGTH_NAME);
			case 'MAXIMUM_LIMIT':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$Signature$Upload$MAXIMUM_LIMIT);
			case 'INVALID_FILE':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$Signature$Upload$INVALID_FILE);
			case 'LIMIT_FILE_SIZE':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$Signature$Upload$LIMIT_FILE_SIZE);
			case 'LIMIT_UNEXPECTED_FILE':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$Signature$Upload$LIMIT_UNEXPECTED_FILE);
			default:
				return $elm$json$Json$Decode$fail('Invalid error code: ' + errorCode);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Data$Api$Signature$Upload$authCall = F3(
	function (jwt, endPoint, file) {
		return A5(
			$author$project$Data$Api$authUpload,
			jwt,
			endPoint,
			$author$project$Data$Api$Signature$Upload$errorDecoder,
			$author$project$Data$Api$Signature$Upload$dataDecoder,
			_List_fromArray(
				[
					A3($elm$http$Http$bytesPart, 'signature', 'image/png', file)
				]));
	});
var $chelovek0v$bbase64$Base64$Decode$Decoder = function (a) {
	return {$: 'Decoder', a: a};
};
var $elm$bytes$Bytes$Encode$encode = _Bytes_encode;
var $elm$bytes$Bytes$Encode$Seq = F2(
	function (a, b) {
		return {$: 'Seq', a: a, b: b};
	});
var $elm$bytes$Bytes$Encode$getWidths = F2(
	function (width, builders) {
		getWidths:
		while (true) {
			if (!builders.b) {
				return width;
			} else {
				var b = builders.a;
				var bs = builders.b;
				var $temp$width = width + $elm$bytes$Bytes$Encode$getWidth(b),
					$temp$builders = bs;
				width = $temp$width;
				builders = $temp$builders;
				continue getWidths;
			}
		}
	});
var $elm$bytes$Bytes$Encode$sequence = function (builders) {
	return A2(
		$elm$bytes$Bytes$Encode$Seq,
		A2($elm$bytes$Bytes$Encode$getWidths, 0, builders),
		builders);
};
var $chelovek0v$bbase64$Base64$Decode$encodeBytes = function (encoders) {
	return $elm$bytes$Bytes$Encode$encode(
		$elm$bytes$Bytes$Encode$sequence(
			$elm$core$List$reverse(encoders)));
};
var $elm$core$Result$andThen = F2(
	function (callback, result) {
		if (result.$ === 'Ok') {
			var value = result.a;
			return callback(value);
		} else {
			var msg = result.a;
			return $elm$core$Result$Err(msg);
		}
	});
var $chelovek0v$bbase64$Base64$Table$charToCodeMap = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2('A', 0),
			_Utils_Tuple2('B', 1),
			_Utils_Tuple2('C', 2),
			_Utils_Tuple2('D', 3),
			_Utils_Tuple2('E', 4),
			_Utils_Tuple2('F', 5),
			_Utils_Tuple2('G', 6),
			_Utils_Tuple2('H', 7),
			_Utils_Tuple2('I', 8),
			_Utils_Tuple2('J', 9),
			_Utils_Tuple2('K', 10),
			_Utils_Tuple2('L', 11),
			_Utils_Tuple2('M', 12),
			_Utils_Tuple2('N', 13),
			_Utils_Tuple2('O', 14),
			_Utils_Tuple2('P', 15),
			_Utils_Tuple2('Q', 16),
			_Utils_Tuple2('R', 17),
			_Utils_Tuple2('S', 18),
			_Utils_Tuple2('T', 19),
			_Utils_Tuple2('U', 20),
			_Utils_Tuple2('V', 21),
			_Utils_Tuple2('W', 22),
			_Utils_Tuple2('X', 23),
			_Utils_Tuple2('Y', 24),
			_Utils_Tuple2('Z', 25),
			_Utils_Tuple2('a', 26),
			_Utils_Tuple2('b', 27),
			_Utils_Tuple2('c', 28),
			_Utils_Tuple2('d', 29),
			_Utils_Tuple2('e', 30),
			_Utils_Tuple2('f', 31),
			_Utils_Tuple2('g', 32),
			_Utils_Tuple2('h', 33),
			_Utils_Tuple2('i', 34),
			_Utils_Tuple2('j', 35),
			_Utils_Tuple2('k', 36),
			_Utils_Tuple2('l', 37),
			_Utils_Tuple2('m', 38),
			_Utils_Tuple2('n', 39),
			_Utils_Tuple2('o', 40),
			_Utils_Tuple2('p', 41),
			_Utils_Tuple2('q', 42),
			_Utils_Tuple2('r', 43),
			_Utils_Tuple2('s', 44),
			_Utils_Tuple2('t', 45),
			_Utils_Tuple2('u', 46),
			_Utils_Tuple2('v', 47),
			_Utils_Tuple2('w', 48),
			_Utils_Tuple2('x', 49),
			_Utils_Tuple2('y', 50),
			_Utils_Tuple2('z', 51),
			_Utils_Tuple2('0', 52),
			_Utils_Tuple2('1', 53),
			_Utils_Tuple2('2', 54),
			_Utils_Tuple2('3', 55),
			_Utils_Tuple2('4', 56),
			_Utils_Tuple2('5', 57),
			_Utils_Tuple2('6', 58),
			_Utils_Tuple2('7', 59),
			_Utils_Tuple2('8', 60),
			_Utils_Tuple2('9', 61),
			_Utils_Tuple2('+', 62),
			_Utils_Tuple2('/', 63)
		]));
var $chelovek0v$bbase64$Base64$Table$decode = function (_char) {
	return A2(
		$elm$core$Dict$get,
		$elm$core$String$fromChar(_char),
		$chelovek0v$bbase64$Base64$Table$charToCodeMap);
};
var $chelovek0v$bbase64$Base64$Shift$Shift2 = {$: 'Shift2'};
var $chelovek0v$bbase64$Base64$Shift$Shift4 = {$: 'Shift4'};
var $chelovek0v$bbase64$Base64$Shift$Shift6 = {$: 'Shift6'};
var $chelovek0v$bbase64$Base64$Shift$Shift0 = {$: 'Shift0'};
var $chelovek0v$bbase64$Base64$Shift$decodeNext = function (shift) {
	switch (shift.$) {
		case 'Shift0':
			return $chelovek0v$bbase64$Base64$Shift$Shift2;
		case 'Shift2':
			return $chelovek0v$bbase64$Base64$Shift$Shift4;
		case 'Shift4':
			return $chelovek0v$bbase64$Base64$Shift$Shift6;
		default:
			return $chelovek0v$bbase64$Base64$Shift$Shift0;
	}
};
var $chelovek0v$bbase64$Base64$Shift$toInt = function (shift) {
	switch (shift.$) {
		case 'Shift0':
			return 0;
		case 'Shift2':
			return 2;
		case 'Shift4':
			return 4;
		default:
			return 6;
	}
};
var $chelovek0v$bbase64$Base64$Shift$shiftRightZfBy = F2(
	function (shift, value) {
		return value >>> $chelovek0v$bbase64$Base64$Shift$toInt(shift);
	});
var $chelovek0v$bbase64$Base64$Decode$finishPartialByte = F3(
	function (shift, sextet, partialByte) {
		return partialByte | A2($chelovek0v$bbase64$Base64$Shift$shiftRightZfBy, shift, sextet);
	});
var $chelovek0v$bbase64$Base64$Shift$shiftLeftBy = F2(
	function (shift, value) {
		return value << $chelovek0v$bbase64$Base64$Shift$toInt(shift);
	});
var $elm$bytes$Bytes$Encode$U8 = function (a) {
	return {$: 'U8', a: a};
};
var $elm$bytes$Bytes$Encode$unsignedInt8 = $elm$bytes$Bytes$Encode$U8;
var $chelovek0v$bbase64$Base64$Decode$decodeStep = F2(
	function (sextet, _v0) {
		var shift = _v0.a;
		var partialByte = _v0.b;
		var deferredEncoders = _v0.c;
		var nextBlankByte = function () {
			switch (shift.$) {
				case 'Shift0':
					return A2($chelovek0v$bbase64$Base64$Shift$shiftLeftBy, $chelovek0v$bbase64$Base64$Shift$Shift2, sextet);
				case 'Shift2':
					return A2($chelovek0v$bbase64$Base64$Shift$shiftLeftBy, $chelovek0v$bbase64$Base64$Shift$Shift4, sextet);
				case 'Shift4':
					return A2($chelovek0v$bbase64$Base64$Shift$shiftLeftBy, $chelovek0v$bbase64$Base64$Shift$Shift6, sextet);
				default:
					return 0;
			}
		}();
		var finishedByte = function () {
			switch (shift.$) {
				case 'Shift0':
					return $elm$core$Maybe$Nothing;
				case 'Shift2':
					return $elm$core$Maybe$Just(
						A3($chelovek0v$bbase64$Base64$Decode$finishPartialByte, $chelovek0v$bbase64$Base64$Shift$Shift4, sextet, partialByte));
				case 'Shift4':
					return $elm$core$Maybe$Just(
						A3($chelovek0v$bbase64$Base64$Decode$finishPartialByte, $chelovek0v$bbase64$Base64$Shift$Shift2, sextet, partialByte));
				default:
					return $elm$core$Maybe$Just(partialByte | sextet);
			}
		}();
		var nextDeferredDecoders = function () {
			if (finishedByte.$ === 'Just') {
				var byte_ = finishedByte.a;
				return A2(
					$elm$core$List$cons,
					$elm$bytes$Bytes$Encode$unsignedInt8(byte_),
					deferredEncoders);
			} else {
				return deferredEncoders;
			}
		}();
		return _Utils_Tuple3(
			$chelovek0v$bbase64$Base64$Shift$decodeNext(shift),
			nextBlankByte,
			nextDeferredDecoders);
	});
var $chelovek0v$bbase64$Base64$Decode$initialState = _Utils_Tuple3($chelovek0v$bbase64$Base64$Shift$Shift0, 0, _List_Nil);
var $elm$core$String$dropRight = F2(
	function (n, string) {
		return (n < 1) ? string : A3($elm$core$String$slice, 0, -n, string);
	});
var $elm$core$String$endsWith = _String_endsWith;
var $chelovek0v$bbase64$Base64$Decode$strip = function (input) {
	return A2($elm$core$String$endsWith, '==', input) ? $elm$core$Result$Ok(
		A2($elm$core$String$dropRight, 2, input)) : (A2($elm$core$String$endsWith, '=', input) ? $elm$core$Result$Ok(
		A2($elm$core$String$dropRight, 1, input)) : $elm$core$Result$Ok(input));
};
var $chelovek0v$bbase64$Base64$Decode$ValidationError = {$: 'ValidationError'};
var $chelovek0v$bbase64$Base64$Decode$validate = function (input) {
	var regex = A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('^[A-Za-z0-9\\/+]*$'));
	return A2($elm$regex$Regex$contains, regex, input) ? $elm$core$Result$Ok(input) : $elm$core$Result$Err($chelovek0v$bbase64$Base64$Decode$ValidationError);
};
var $chelovek0v$bbase64$Base64$Decode$tryDecode = function (input) {
	return A2(
		$elm$core$Result$map,
		A2(
			$elm$core$String$foldl,
			F2(
				function (_char, state) {
					return A2(
						$elm$core$Maybe$withDefault,
						state,
						A2(
							$elm$core$Maybe$map,
							function (sextet) {
								return A2($chelovek0v$bbase64$Base64$Decode$decodeStep, sextet, state);
							},
							$chelovek0v$bbase64$Base64$Table$decode(_char)));
				}),
			$chelovek0v$bbase64$Base64$Decode$initialState),
		A2(
			$elm$core$Result$andThen,
			$chelovek0v$bbase64$Base64$Decode$validate,
			$chelovek0v$bbase64$Base64$Decode$strip(input)));
};
var $chelovek0v$bbase64$Base64$Decode$bytes = $chelovek0v$bbase64$Base64$Decode$Decoder(
	function (input) {
		var _v0 = $chelovek0v$bbase64$Base64$Decode$tryDecode(input);
		if (_v0.$ === 'Ok') {
			var _v1 = _v0.a;
			var deferredEncoders = _v1.c;
			return $elm$core$Result$Ok(
				$chelovek0v$bbase64$Base64$Decode$encodeBytes(deferredEncoders));
		} else {
			var e = _v0.a;
			return $elm$core$Result$Err(e);
		}
	});
var $author$project$Model$Signature$clearSignature = _Platform_outgoingPort(
	'clearSignature',
	function ($) {
		return $elm$json$Json$Encode$null;
	});
var $chelovek0v$bbase64$Base64$Decode$decode = F2(
	function (_v0, input) {
		var decoder = _v0.a;
		return decoder(input);
	});
var $author$project$Model$Signature$decode = function (value) {
	return A2($elm$json$Json$Decode$decodeValue, $elm$json$Json$Decode$string, value);
};
var $author$project$Data$Api$Signature$List$errorToString = function (error) {
	return 'Signature cannot be found, please try again.';
};
var $author$project$Data$Api$Signature$Upload$errorToString = function (error) {
	switch (error.$) {
		case 'EMPTY_NAME':
			return 'Signature name cannot be empty.';
		case 'INVALID_LENGTH_NAME':
			return 'Signature name cannot have more than 50 characters.';
		case 'MAXIMUM_LIMIT':
			return 'A maximum of 5 signature can be uploaded only.';
		case 'LIMIT_UNEXPECTED_FILE':
			return 'File uploaded is not a png/jpg/gif/svg type.';
		case 'LIMIT_FILE_SIZE':
			return 'File size has exceeded 100kb.';
		default:
			return 'File uploaded is not a png/jpg/gif/svg type.';
	}
};
var $author$project$Model$Signature$extractSvgSignature = _Platform_outgoingPort(
	'extractSvgSignature',
	function ($) {
		return $elm$json$Json$Encode$null;
	});
var $author$project$Model$Signature$loadSignature = _Platform_outgoingPort(
	'loadSignature',
	function ($) {
		return $elm$json$Json$Encode$null;
	});
var $author$project$Model$Signature$saveSignature = _Platform_outgoingPort(
	'saveSignature',
	function ($) {
		return $elm$json$Json$Encode$null;
	});
var $author$project$Model$Signature$validateName = function (name) {
	return (!$elm$core$String$isEmpty(name)) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just('Signature name cannot be empty');
};
var $author$project$Model$Signature$updateSignature = F4(
	function (msg, signatureModel, user, model) {
		var defaultText = user.firstName + (' ' + user.lastName);
		var defaultName = 'Signature ' + $elm$core$String$fromInt(
			$elm$core$List$length(signatureModel.signatures) + 1);
		switch (msg.$) {
			case 'OnViewRendered':
				return _Utils_Tuple2(
					signatureModel,
					$author$project$Model$Signature$loadSignature(_Utils_Tuple0));
			case 'OnNameInput':
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						signatureModel,
						{name: value, nameError: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none);
			case 'OnNameBlur':
				return _Utils_Tuple2(
					_Utils_update(
						signatureModel,
						{
							nameError: $author$project$Model$Signature$validateName(signatureModel.name)
						}),
					$elm$core$Platform$Cmd$none);
			case 'OnOpen':
				return _Utils_Tuple2(
					_Utils_update(
						signatureModel,
						{name: defaultName, open: true, signatureText: defaultText}),
					$elm$core$Platform$Cmd$none);
			case 'OnClose':
				return _Utils_Tuple2(
					_Utils_update(
						signatureModel,
						{name: '', nameError: $elm$core$Maybe$Nothing, newSignature: $elm$core$Maybe$Nothing, open: false, signatureText: '', uploadError: $elm$core$Maybe$Nothing}),
					$author$project$Model$Signature$clearSignature(_Utils_Tuple0));
			case 'OnClear':
				return _Utils_Tuple2(
					_Utils_update(
						signatureModel,
						{name: '', signatureText: ''}),
					$author$project$Model$Signature$clearSignature(_Utils_Tuple0));
			case 'OnDelete':
				var imageID = msg.a;
				var updatedSignatures = A2(
					$elm$core$List$filter,
					function (element) {
						return !_Utils_eq(element.id, imageID);
					},
					signatureModel.signatures);
				var _v1 = model.apiEndPoint;
				var signatureDelete = _v1.signatureDelete;
				return _Utils_Tuple2(
					_Utils_update(
						signatureModel,
						{signatures: updatedSignatures}),
					A2(
						$elm$core$Task$attempt,
						$author$project$Type$Signature$DeleteReponse,
						A3($author$project$Data$Api$Signature$Delete$authCall, user.jwt, signatureDelete, imageID)));
			case 'OnSubmit':
				var _v2 = signatureModel.signatureType;
				if (_v2.$ === 'Drawn') {
					var updatedSignatureModel = _Utils_update(
						signatureModel,
						{uploadError: $elm$core$Maybe$Nothing});
					return _Utils_Tuple2(
						updatedSignatureModel,
						$author$project$Model$Signature$saveSignature(_Utils_Tuple0));
				} else {
					return _Utils_Tuple2(
						signatureModel,
						$author$project$Model$Signature$extractSvgSignature(_Utils_Tuple0));
				}
			case 'NewSignature':
				var value = msg.a;
				var result = $author$project$Model$Signature$decode(value);
				if (result.$ === 'Err') {
					return _Utils_Tuple2(signatureModel, $elm$core$Platform$Cmd$none);
				} else {
					var sig = result.a;
					var _v4 = A2($chelovek0v$bbase64$Base64$Decode$decode, $chelovek0v$bbase64$Base64$Decode$bytes, sig);
					if (_v4.$ === 'Err') {
						return _Utils_Tuple2(signatureModel, $elm$core$Platform$Cmd$none);
					} else {
						var sigResult = _v4.a;
						var _v5 = model.apiEndPoint;
						var signatureUpload = _v5.signatureUpload;
						return _Utils_Tuple2(
							_Utils_update(
								signatureModel,
								{
									newSignature: $elm$core$Maybe$Just('data:image/png;base64,' + sig)
								}),
							A2(
								$elm$core$Task$attempt,
								$author$project$Type$Signature$UploadResponse,
								A3($author$project$Data$Api$Signature$Upload$authCall, user.jwt, signatureUpload, sigResult)));
					}
				}
			case 'UploadResponse':
				var result = msg.a;
				if (result.$ === 'Err') {
					var error = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							signatureModel,
							{
								uploadError: $elm$core$Maybe$Just(
									A2($author$project$Data$Api$authErrorToString, $author$project$Data$Api$Signature$Upload$errorToString, error))
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var value = result.a;
					var newSignature = A2(
						$elm$core$Maybe$map,
						function (newSig) {
							return A3($author$project$Type$Signature$Signature, value.fileName, signatureModel.name, newSig);
						},
						signatureModel.newSignature);
					var updatedSignature = A2(
						$elm$core$Maybe$withDefault,
						signatureModel.signatures,
						A2(
							$elm$core$Maybe$map,
							function (newSig) {
								return _Utils_ap(
									signatureModel.signatures,
									_List_fromArray(
										[newSig]));
							},
							newSignature));
					return _Utils_Tuple2(
						_Utils_update(
							signatureModel,
							{name: '', nameError: $elm$core$Maybe$Nothing, newSignature: $elm$core$Maybe$Nothing, open: false, signatures: updatedSignature, uploadError: $elm$core$Maybe$Nothing}),
						$author$project$Model$Signature$clearSignature(_Utils_Tuple0));
				}
			case 'DeleteReponse':
				var result = msg.a;
				if (result.$ === 'Err') {
					return _Utils_Tuple2(signatureModel, $elm$core$Platform$Cmd$none);
				} else {
					return _Utils_Tuple2(signatureModel, $elm$core$Platform$Cmd$none);
				}
			case 'LoadSignature':
				var result = msg.a;
				if (result.$ === 'Err') {
					var error = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							signatureModel,
							{
								listError: $elm$core$Maybe$Just(
									A2($author$project$Data$Api$authErrorToString, $author$project$Data$Api$Signature$List$errorToString, error))
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var value = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							signatureModel,
							{newSignature: $elm$core$Maybe$Nothing, signatures: value.signatures}),
						$elm$core$Platform$Cmd$none);
				}
			case 'ReloadList':
				return _Utils_Tuple2(
					_Utils_update(
						signatureModel,
						{listError: $elm$core$Maybe$Nothing}),
					A2(
						$elm$core$Task$attempt,
						$author$project$Type$Signature$LoadSignature,
						A2($author$project$Data$Api$Signature$List$authCall, user.jwt, model.apiEndPoint.signatureList)));
			case 'ChangeSignatureType':
				var signatureType = msg.a;
				var _v9 = function () {
					if (signatureType.$ === 'Drawn') {
						return _Utils_Tuple2(
							'',
							$author$project$Model$Signature$loadSignature(_Utils_Tuple0));
					} else {
						return _Utils_Tuple2(defaultText, $elm$core$Platform$Cmd$none);
					}
				}();
				var signatureText = _v9.a;
				var command = _v9.b;
				return _Utils_Tuple2(
					_Utils_update(
						signatureModel,
						{name: defaultName, signatureText: signatureText, signatureType: signatureType}),
					command);
			case 'OnTextInput':
				var signatureText = msg.a;
				var updatedSignatureModel = ($elm$core$String$length(signatureText) <= 15) ? _Utils_update(
					signatureModel,
					{signatureText: signatureText}) : signatureModel;
				return _Utils_Tuple2(updatedSignatureModel, $elm$core$Platform$Cmd$none);
			case 'OnTextBlur':
				return _Utils_Tuple2(
					_Utils_update(
						signatureModel,
						{
							textError: $author$project$Model$Signature$validateName(signatureModel.signatureText)
						}),
					$elm$core$Platform$Cmd$none);
			default:
				var value = msg.a;
				var result = $author$project$Model$Signature$decode(value);
				if (result.$ === 'Err') {
					return _Utils_Tuple2(signatureModel, $elm$core$Platform$Cmd$none);
				} else {
					var sig = result.a;
					var _v12 = A2($chelovek0v$bbase64$Base64$Decode$decode, $chelovek0v$bbase64$Base64$Decode$bytes, sig);
					if (_v12.$ === 'Err') {
						return _Utils_Tuple2(signatureModel, $elm$core$Platform$Cmd$none);
					} else {
						var sigResult = _v12.a;
						var _v13 = model.apiEndPoint;
						var signatureUpload = _v13.signatureUpload;
						return _Utils_Tuple2(
							_Utils_update(
								signatureModel,
								{
									newSignature: $elm$core$Maybe$Just('data:image/png;base64,' + sig),
									signatureText: ''
								}),
							A2(
								$elm$core$Task$attempt,
								$author$project$Type$Signature$UploadResponse,
								A3($author$project$Data$Api$Signature$Upload$authCall, user.jwt, signatureUpload, sigResult)));
					}
				}
		}
	});
var $author$project$Model$Signature$update = F2(
	function (msg, model) {
		var _v0 = model.sessionModel;
		switch (_v0.$) {
			case 'Anonymous':
				var anonymousModel = _v0.a;
				return A3(
					$elm$core$Tuple$mapBoth,
					function (newModel) {
						return _Utils_update(
							model,
							{
								sessionModel: $author$project$Types$Anonymous(
									_Utils_update(
										anonymousModel,
										{signatureModel: newModel}))
							});
					},
					function (cmdMsg) {
						switch (msg.$) {
							case 'UploadResponse':
								return $elm$core$Platform$Cmd$batch(
									_List_fromArray(
										[
											A2($elm$core$Platform$Cmd$map, $author$project$Types$OnSignature, cmdMsg),
											A2(
											$elm$core$Task$perform,
											$author$project$Types$OnViewDoc,
											$elm$core$Task$succeed(
												$author$project$Type$ViewDocument$OnAuth(
													$author$project$Type$ViewDocument$OnLoaded($author$project$Type$ViewDocument$OnNewSignatureAddition))))
										]));
							case 'OnOpen':
								return $elm$core$Platform$Cmd$batch(
									_List_fromArray(
										[
											A2($elm$core$Platform$Cmd$map, $author$project$Types$OnSignature, cmdMsg),
											A2(
											$elm$core$Task$perform,
											$author$project$Types$OnViewDoc,
											$elm$core$Task$succeed(
												$author$project$Type$ViewDocument$OnAuth(
													$author$project$Type$ViewDocument$OnLoaded($author$project$Type$ViewDocument$OnCloseModal))))
										]));
							default:
								return A2($elm$core$Platform$Cmd$map, $author$project$Types$OnSignature, cmdMsg);
						}
					},
					A4($author$project$Model$Signature$updateSignature, msg, anonymousModel.signatureModel, anonymousModel.user, model));
			case 'Auth':
				var authModel = _v0.a;
				return A3(
					$elm$core$Tuple$mapBoth,
					function (newModel) {
						return _Utils_update(
							model,
							{
								sessionModel: $author$project$Types$Auth(
									_Utils_update(
										authModel,
										{signatureModel: newModel}))
							});
					},
					function (cmdMsg) {
						switch (msg.$) {
							case 'UploadResponse':
								return $elm$core$Platform$Cmd$batch(
									_List_fromArray(
										[
											A2($elm$core$Platform$Cmd$map, $author$project$Types$OnSignature, cmdMsg),
											A2(
											$elm$core$Task$perform,
											$author$project$Types$OnViewDoc,
											$elm$core$Task$succeed(
												$author$project$Type$ViewDocument$OnAuth(
													$author$project$Type$ViewDocument$OnLoaded($author$project$Type$ViewDocument$OnNewSignatureAddition))))
										]));
							case 'OnOpen':
								return $elm$core$Platform$Cmd$batch(
									_List_fromArray(
										[
											A2($elm$core$Platform$Cmd$map, $author$project$Types$OnSignature, cmdMsg),
											A2(
											$elm$core$Task$perform,
											$author$project$Types$OnViewDoc,
											$elm$core$Task$succeed(
												$author$project$Type$ViewDocument$OnAuth(
													$author$project$Type$ViewDocument$OnLoaded($author$project$Type$ViewDocument$OnCloseModal))))
										]));
							default:
								return A2($elm$core$Platform$Cmd$map, $author$project$Types$OnSignature, cmdMsg);
						}
					},
					A4($author$project$Model$Signature$updateSignature, msg, authModel.signatureModel, authModel.user, model));
			case 'NoAuth':
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			default:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Type$Stamp$CreateStampError = function (a) {
	return {$: 'CreateStampError', a: a};
};
var $author$project$Type$Stamp$CreateSuccess = F2(
	function (a, b) {
		return {$: 'CreateSuccess', a: a, b: b};
	});
var $author$project$Type$Stamp$DeleteResult = F3(
	function (a, b, c) {
		return {$: 'DeleteResult', a: a, b: b, c: c};
	});
var $author$project$Type$Stamp$DeleteStampError = function (a) {
	return {$: 'DeleteStampError', a: a};
};
var $author$project$Type$Stamp$DeleteSuccess = F2(
	function (a, b) {
		return {$: 'DeleteSuccess', a: a, b: b};
	});
var $author$project$Type$Stamp$DomainNotSet = {$: 'DomainNotSet'};
var $author$project$Type$Stamp$Error = function (a) {
	return {$: 'Error', a: a};
};
var $author$project$Data$Api$Stamp$Upload$FILE_TOO_BIG = {$: 'FILE_TOO_BIG'};
var $author$project$Data$Api$Stamp$Upload$INVALID_FILE = {$: 'INVALID_FILE'};
var $author$project$Data$Api$Stamp$Upload$INVALID_FILE_TYPE = {$: 'INVALID_FILE_TYPE'};
var $author$project$Type$Stamp$ImageError = function (a) {
	return {$: 'ImageError', a: a};
};
var $author$project$Type$Stamp$ImageLoaded = function (a) {
	return {$: 'ImageLoaded', a: a};
};
var $author$project$Type$Stamp$ImageUrl = function (a) {
	return {$: 'ImageUrl', a: a};
};
var $author$project$Type$Stamp$LoadError = function (a) {
	return {$: 'LoadError', a: a};
};
var $author$project$Type$Stamp$LoadStampData = F2(
	function (a, b) {
		return {$: 'LoadStampData', a: a, b: b};
	});
var $author$project$Type$Stamp$Loaded = function (a) {
	return {$: 'Loaded', a: a};
};
var $author$project$Type$ViewDocument$LoadedUserStamp = function (a) {
	return {$: 'LoadedUserStamp', a: a};
};
var $author$project$Type$ViewDocument$OnShowModal = function (a) {
	return {$: 'OnShowModal', a: a};
};
var $author$project$Type$Stamp$Opened = function (a) {
	return {$: 'Opened', a: a};
};
var $author$project$Type$Stamp$Processed = function (a) {
	return {$: 'Processed', a: a};
};
var $author$project$Type$Stamp$Processing = function (a) {
	return {$: 'Processing', a: a};
};
var $author$project$Type$ViewDocument$SignatureStampModal = {$: 'SignatureStampModal'};
var $author$project$Type$Stamp$Submit = F2(
	function (a, b) {
		return {$: 'Submit', a: a, b: b};
	});
var $author$project$Type$Stamp$SubmitResult = F3(
	function (a, b, c) {
		return {$: 'SubmitResult', a: a, b: b, c: c};
	});
var $author$project$Type$Stamp$Submitting = function (a) {
	return {$: 'Submitting', a: a};
};
var $author$project$Data$Api$Stamp$Delete$Payload = function (message) {
	return {message: message};
};
var $author$project$Data$Api$Stamp$Delete$dataDecoder = A2(
	$elm$json$Json$Decode$map,
	$author$project$Data$Api$Stamp$Delete$Payload,
	A2($elm$json$Json$Decode$field, 'message', $elm$json$Json$Decode$string));
var $author$project$Data$Api$Stamp$Delete$USER_NOT_IN_DOMAIN = {$: 'USER_NOT_IN_DOMAIN'};
var $author$project$Data$Api$Stamp$Delete$errorDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (errorCode) {
		if (errorCode === 'USER_NOT_IN_DOMAIN') {
			return $elm$json$Json$Decode$succeed($author$project$Data$Api$Stamp$Delete$USER_NOT_IN_DOMAIN);
		} else {
			return $elm$json$Json$Decode$fail('Invalid error code: ' + errorCode);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Data$Api$Stamp$Delete$authCall = F3(
	function (jwt, endPoint, stampID) {
		return A5(
			$author$project$Data$Api$authCall,
			jwt,
			endPoint,
			$author$project$Data$Api$Stamp$Delete$errorDecoder,
			$author$project$Data$Api$Stamp$Delete$dataDecoder,
			$elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'id',
						$elm$json$Json$Encode$string(stampID))
					])));
	});
var $author$project$Data$Api$Stamp$File$Payload = function (stamp) {
	return {stamp: stamp};
};
var $author$project$Data$Api$Stamp$File$dataDecoder = A2(
	$elm$json$Json$Decode$map,
	$author$project$Data$Api$Stamp$File$Payload,
	A2($elm$json$Json$Decode$field, 'stamp', $author$project$Data$PDF$Stamp$decoder));
var $author$project$Data$Api$Stamp$File$STAMP_NOT_FOUND = {$: 'STAMP_NOT_FOUND'};
var $author$project$Data$Api$Stamp$File$errorDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (errorCode) {
		if (errorCode === 'STAMP_NOT_FOUND') {
			return $elm$json$Json$Decode$succeed($author$project$Data$Api$Stamp$File$STAMP_NOT_FOUND);
		} else {
			return $elm$json$Json$Decode$fail('Invalid error code: ' + errorCode);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Data$Api$Stamp$File$authCall = F3(
	function (jwt, endPoint, id) {
		return A5(
			$author$project$Data$Api$authCall,
			jwt,
			endPoint,
			$author$project$Data$Api$Stamp$File$errorDecoder,
			$author$project$Data$Api$Stamp$File$dataDecoder,
			$elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'id',
						$elm$json$Json$Encode$string(id))
					])));
	});
var $author$project$Data$Api$Stamp$Upload$Payload = function (stamp) {
	return {stamp: stamp};
};
var $author$project$Data$Api$Stamp$Upload$dataDecoder = A2(
	$elm$json$Json$Decode$map,
	$author$project$Data$Api$Stamp$Upload$Payload,
	A2($elm$json$Json$Decode$field, 'stamp', $author$project$Data$PDF$Stamp$decoder));
var $author$project$Data$Api$Stamp$Upload$EMPTY_NAME = {$: 'EMPTY_NAME'};
var $author$project$Data$Api$Stamp$Upload$INVALID_DOMAIN = {$: 'INVALID_DOMAIN'};
var $author$project$Data$Api$Stamp$Upload$INVALID_LENGTH_NAME = {$: 'INVALID_LENGTH_NAME'};
var $author$project$Data$Api$Stamp$Upload$INVALID_USERID = {$: 'INVALID_USERID'};
var $author$project$Data$Api$Stamp$Upload$USER_NOT_IN_DOMAIN = {$: 'USER_NOT_IN_DOMAIN'};
var $author$project$Data$Api$Stamp$Upload$errorDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (errorCode) {
		switch (errorCode) {
			case 'EMPTY_NAME':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$Stamp$Upload$EMPTY_NAME);
			case 'INVALID_USERID':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$Stamp$Upload$INVALID_USERID);
			case 'INVALID_DOMAIN':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$Stamp$Upload$INVALID_DOMAIN);
			case 'INVALID_LENGTH_NAME':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$Stamp$Upload$INVALID_LENGTH_NAME);
			case 'INVALID_FILE':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$Stamp$Upload$INVALID_FILE);
			case 'INVALID_FILE_TYPE':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$Stamp$Upload$INVALID_FILE_TYPE);
			case 'FILE_TOO_BIG':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$Stamp$Upload$FILE_TOO_BIG);
			case 'USER_NOT_IN_DOMAIN':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$Stamp$Upload$USER_NOT_IN_DOMAIN);
			default:
				return $elm$json$Json$Decode$fail('Invalid error code: ' + errorCode);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Data$Api$Stamp$Upload$authCall = F3(
	function (jwt, endPoint, _v0) {
		var domain = _v0.domain;
		var file = _v0.file;
		return A5(
			$author$project$Data$Api$authUpload,
			jwt,
			endPoint,
			$author$project$Data$Api$Stamp$Upload$errorDecoder,
			$author$project$Data$Api$Stamp$Upload$dataDecoder,
			_List_fromArray(
				[
					A2(
					$elm$http$Http$stringPart,
					'domain',
					$author$project$Data$Domain$toString(domain)),
					A2($elm$http$Http$filePart, 'stamp', file)
				]));
	});
var $author$project$Type$Stamp$OnBannerClose = {$: 'OnBannerClose'};
var $author$project$Model$Stamp$closeBannerLater = A2(
	$elm$core$Task$perform,
	$elm$core$Basics$always(
		$author$project$Types$OnStamp($author$project$Type$Stamp$OnBannerClose)),
	$elm$core$Process$sleep(5000));
var $author$project$Data$PDF$Stamp$id = function (_v0) {
	var stamp = _v0.a;
	return stamp.id;
};
var $author$project$Data$PDF$Stamp$domain = function (_v0) {
	var stamp = _v0.a;
	return stamp.domain;
};
var $author$project$Model$Stamp$insertStamp = F2(
	function (stamp, modelStamps) {
		var domainString = $author$project$Data$Domain$toString(
			$author$project$Data$PDF$Stamp$domain(stamp));
		var _v0 = A2($elm$core$Dict$get, domainString, modelStamps);
		if (_v0.$ === 'Nothing') {
			return modelStamps;
		} else {
			switch (_v0.a.$) {
				case 'Loading':
					var _v1 = _v0.a;
					return modelStamps;
				case 'LoadError':
					return modelStamps;
				default:
					var loadedStamps = _v0.a.a;
					return function (stamps) {
						return A3(
							$elm$core$Dict$insert,
							domainString,
							$author$project$Type$Stamp$Loaded(stamps),
							modelStamps);
					}(
						A3(
							$elm$core$Dict$insert,
							$author$project$Data$PDF$Stamp$id(stamp),
							stamp,
							loadedStamps));
			}
		}
	});
var $author$project$Data$PDF$Stamp$loadData = F2(
	function (base64Data, _v0) {
		var stamp = _v0.a;
		return $author$project$Data$PDF$Stamp$Stamp(
			_Utils_update(
				stamp,
				{
					data: $author$project$Data$PDF$Stamp$Loaded(base64Data)
				}));
	});
var $author$project$Model$Stamp$removeStamp = F2(
	function (stamp, modelStamps) {
		var domainString = $author$project$Data$Domain$toString(
			$author$project$Data$PDF$Stamp$domain(stamp));
		var _v0 = A2($elm$core$Dict$get, domainString, modelStamps);
		if (_v0.$ === 'Nothing') {
			return modelStamps;
		} else {
			switch (_v0.a.$) {
				case 'Loading':
					var _v1 = _v0.a;
					return modelStamps;
				case 'LoadError':
					return modelStamps;
				default:
					var loadedStamps = _v0.a.a;
					return function (stamps) {
						return A3(
							$elm$core$Dict$insert,
							domainString,
							$author$project$Type$Stamp$Loaded(stamps),
							modelStamps);
					}(
						A2(
							$elm$core$Dict$remove,
							$author$project$Data$PDF$Stamp$id(stamp),
							loadedStamps));
			}
		}
	});
var $author$project$Type$Stamp$DomainFormError = F2(
	function (a, b) {
		return {$: 'DomainFormError', a: a, b: b};
	});
var $author$project$Model$Stamp$setFormError = F2(
	function (domain, error) {
		if (domain.$ === 'Nothing') {
			return $author$project$Type$Stamp$Error($author$project$Type$Stamp$DomainNotSet);
		} else {
			var domain_ = domain.a;
			switch (error.$) {
				case 'DeleteStampError':
					var err = error.a;
					return $author$project$Type$Stamp$Error(
						A2(
							$author$project$Type$Stamp$DomainFormError,
							domain_,
							$author$project$Type$Stamp$DeleteStampError(err)));
				case 'CreateStampError':
					var err = error.a;
					return $author$project$Type$Stamp$Error(
						A2(
							$author$project$Type$Stamp$DomainFormError,
							domain_,
							$author$project$Type$Stamp$CreateStampError(err)));
				default:
					var err = error.a;
					return $author$project$Type$Stamp$Error(
						A2(
							$author$project$Type$Stamp$DomainFormError,
							domain_,
							$author$project$Type$Stamp$ImageError(err)));
			}
		}
	});
var $author$project$Data$PDF$Stamp$validFileTypeMime = _List_fromArray(
	['image/jpg', 'image/jpeg', 'image/png', 'image/svg', 'image/gif']);
var $author$project$Model$Stamp$validateName = function (name) {
	return $elm$core$String$isEmpty(name) ? $elm$core$Maybe$Just('Name cannot be empty.') : (($elm$core$String$length(name) > 50) ? $elm$core$Maybe$Just('Name cannot be more than 50 characters.') : $elm$core$Maybe$Nothing);
};
var $author$project$Model$Stamp$updateStampModel = F4(
	function (msg, model, user, appModel) {
		switch (msg.$) {
			case 'LoadStamps':
				var domain = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							stamps: A3(
								$elm$core$Dict$insert,
								$author$project$Data$Domain$toString(domain),
								$author$project$Type$Stamp$Loading,
								model.stamps)
						}),
					A2(
						$elm$core$Task$attempt,
						A2(
							$elm$core$Basics$composeL,
							$author$project$Types$OnStamp,
							$author$project$Type$Stamp$LoadStampsResult(domain)),
						A3($author$project$Data$Api$Stamp$List$authCall, user.jwt, appModel.apiEndPoint.stampList, domain)));
			case 'LoadStampsResult':
				var domain = msg.a;
				var result = msg.b;
				if (result.$ === 'Err') {
					var error = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								stamps: A3(
									$elm$core$Dict$insert,
									$author$project$Data$Domain$toString(domain),
									$author$project$Type$Stamp$LoadError(error),
									model.stamps)
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var stamps = result.a.stamps;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								stamps: A3(
									$elm$core$List$foldl,
									$author$project$Model$Stamp$insertStamp,
									A3(
										$elm$core$Dict$insert,
										$author$project$Data$Domain$toString(domain),
										$author$project$Type$Stamp$Loaded($elm$core$Dict$empty),
										model.stamps),
									stamps)
							}),
						$elm$core$Platform$Cmd$batch(
							A2(
								$elm$core$List$map,
								function (stamp) {
									return A2(
										$elm$core$Task$attempt,
										A2(
											$elm$core$Basics$composeL,
											$author$project$Types$OnStamp,
											$author$project$Type$Stamp$LoadStampData(stamp)),
										A3(
											$author$project$Data$Api$Stamp$File$authCall,
											user.jwt,
											appModel.apiEndPoint.stampFile,
											$author$project$Data$PDF$Stamp$id(stamp)));
								},
								stamps)));
				}
			case 'LoadStampData':
				var stamp = msg.a;
				var result = msg.b;
				if (result.$ === 'Err') {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								stamps: A2($author$project$Model$Stamp$removeStamp, stamp, model.stamps)
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var payload = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								stamps: A2($author$project$Model$Stamp$insertStamp, payload.stamp, model.stamps)
							}),
						A2(
							$elm$core$Task$perform,
							A2(
								$elm$core$Basics$composeL,
								A2($elm$core$Basics$composeL, $author$project$Types$OnViewDoc, $author$project$Type$ViewDocument$OnAuth),
								$author$project$Type$ViewDocument$OnLoaded),
							$elm$core$Task$succeed(
								$author$project$Type$ViewDocument$LoadedUserStamp(payload.stamp))));
				}
			case 'Delete':
				var domain = msg.a;
				var stamp = msg.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							formStatus: $author$project$Type$Stamp$Ready,
							stamps: A2($author$project$Model$Stamp$removeStamp, stamp, model.stamps)
						}),
					A2(
						$elm$core$Task$attempt,
						A2(
							$elm$core$Basics$composeL,
							$author$project$Types$OnStamp,
							A2($author$project$Type$Stamp$DeleteResult, stamp, domain)),
						A3(
							$author$project$Data$Api$Stamp$Delete$authCall,
							user.jwt,
							appModel.apiEndPoint.stampDelete,
							$author$project$Data$PDF$Stamp$id(stamp))));
			case 'DeleteResult':
				var stamp = msg.a;
				var domain = msg.b;
				var result = msg.c;
				if (result.$ === 'Err') {
					var error = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								formStatus: A2(
									$author$project$Model$Stamp$setFormError,
									model.formStampDomain,
									$author$project$Type$Stamp$DeleteStampError(error))
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								formStatus: A2($author$project$Type$Stamp$DeleteSuccess, domain, stamp)
							}),
						$author$project$Model$Stamp$closeBannerLater);
				}
			case 'OnImageUpload':
				var imageUpload = msg.a;
				switch (imageUpload.$) {
					case 'ImageRequested':
						var domain = imageUpload.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									formStampDomain: $elm$core$Maybe$Just(domain),
									formStatus: $author$project$Type$Stamp$Ready
								}),
							A2(
								$elm$file$File$Select$file,
								$author$project$Data$PDF$Stamp$validFileTypeMime,
								A2(
									$elm$core$Basics$composeL,
									A2($elm$core$Basics$composeL, $author$project$Types$OnStamp, $author$project$Type$Stamp$OnImageUpload),
									$author$project$Type$Stamp$ImageLoaded)));
					case 'ImageLoaded':
						var file = imageUpload.a;
						return (!A2(
							$elm$core$List$member,
							$elm$file$File$mime(file),
							$author$project$Data$PDF$Stamp$validFileTypeMime)) ? _Utils_Tuple2(
							_Utils_update(
								model,
								{
									formStatus: A2(
										$author$project$Model$Stamp$setFormError,
										model.formStampDomain,
										$author$project$Type$Stamp$ImageError($author$project$Data$Api$Stamp$Upload$INVALID_FILE_TYPE))
								}),
							$elm$core$Platform$Cmd$none) : (($elm$file$File$size(file) > 300000) ? _Utils_Tuple2(
							_Utils_update(
								model,
								{
									formStatus: A2(
										$author$project$Model$Stamp$setFormError,
										model.formStampDomain,
										$author$project$Type$Stamp$ImageError($author$project$Data$Api$Stamp$Upload$FILE_TOO_BIG))
								}),
							$elm$core$Platform$Cmd$none) : _Utils_Tuple2(
							model,
							A2(
								$elm$core$Task$perform,
								A2(
									$elm$core$Basics$composeL,
									A2($elm$core$Basics$composeL, $author$project$Types$OnStamp, $author$project$Type$Stamp$OnImageUpload),
									$author$project$Type$Stamp$ImageUrl),
								$elm$file$File$toUrl(file))));
					case 'ImageUrl':
						var base64ImageData = imageUpload.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									formStatus: $author$project$Type$Stamp$Ready,
									imageEditor: $author$project$Type$Stamp$Opened(base64ImageData)
								}),
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										$author$project$ImageEditor$load(
										{cropHeight: 300, cropWidth: 300}),
										A2(
										$elm$core$Task$perform,
										$author$project$Types$OnViewDoc,
										$elm$core$Task$succeed(
											$author$project$Type$ViewDocument$OnAuth(
												$author$project$Type$ViewDocument$OnLoaded($author$project$Type$ViewDocument$OnCloseModal))))
									])));
					case 'ImageAction':
						var action = imageUpload.a;
						return _Utils_Tuple2(
							model,
							$author$project$ImageEditor$update(action));
					case 'ImageCancel':
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{imageEditor: $author$project$Type$Stamp$Closed}),
							$elm$core$Platform$Cmd$none);
					case 'ImageSubmit':
						var base64ImageData = imageUpload.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									imageEditor: $author$project$Type$Stamp$Processing(base64ImageData)
								}),
							$author$project$ImageEditor$getImageDataAndDestroy(_Utils_Tuple0));
					default:
						var result = imageUpload.a;
						if (result.$ === 'Err') {
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{
										formStatus: A2(
											$author$project$Model$Stamp$setFormError,
											model.formStampDomain,
											$author$project$Type$Stamp$ImageError($author$project$Data$Api$Stamp$Upload$INVALID_FILE)),
										imageEditor: $author$project$Type$Stamp$Closed
									}),
								$elm$core$Platform$Cmd$none);
						} else {
							var _v6 = result.a;
							var localUrl = _v6.a;
							var file = _v6.b;
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{
										imageEditor: $author$project$Type$Stamp$Processed(
											_Utils_Tuple2(localUrl, file))
									}),
								A2(
									$elm$core$Task$perform,
									A2(
										$elm$core$Basics$composeL,
										$author$project$Types$OnStamp,
										$author$project$Type$Stamp$Submit(localUrl)),
									$elm$core$Task$succeed(file)));
						}
				}
			case 'OnNameInput':
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{name: value}),
					$elm$core$Platform$Cmd$none);
			case 'OnNameBlur':
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							nameError: $author$project$Model$Stamp$validateName(model.name)
						}),
					$elm$core$Platform$Cmd$none);
			case 'Submit':
				var localUrl = msg.a;
				var file = msg.b;
				var _v7 = model.formStampDomain;
				if (_v7.$ === 'Nothing') {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								formStatus: $author$project$Type$Stamp$Error($author$project$Type$Stamp$DomainNotSet)
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var domain = _v7.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								formStatus: $author$project$Type$Stamp$Submitting(domain)
							}),
						A2(
							$elm$core$Task$attempt,
							A2(
								$elm$core$Basics$composeL,
								$author$project$Types$OnStamp,
								A2($author$project$Type$Stamp$SubmitResult, localUrl, domain)),
							A3(
								$author$project$Data$Api$Stamp$Upload$authCall,
								user.jwt,
								appModel.apiEndPoint.stampUpload,
								{domain: domain, file: file})));
				}
			case 'SubmitResult':
				var localUrl = msg.a;
				var domain = msg.b;
				var result = msg.c;
				if (result.$ === 'Err') {
					var error = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								formStatus: A2(
									$author$project$Model$Stamp$setFormError,
									model.formStampDomain,
									$author$project$Type$Stamp$CreateStampError(error))
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var stamp = result.a.stamp;
					var loadedStamp = A2($author$project$Data$PDF$Stamp$loadData, localUrl, stamp);
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								formStampDomain: $elm$core$Maybe$Nothing,
								formStatus: A2($author$project$Type$Stamp$CreateSuccess, domain, loadedStamp),
								name: '',
								stamps: A2($author$project$Model$Stamp$insertStamp, loadedStamp, model.stamps)
							}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									$author$project$Model$Stamp$closeBannerLater,
									A2(
									$elm$core$Task$perform,
									$author$project$Types$OnViewDoc,
									$elm$core$Task$succeed(
										$author$project$Type$ViewDocument$OnAuth(
											$author$project$Type$ViewDocument$OnLoaded(
												$author$project$Type$ViewDocument$OnShowModal($author$project$Type$ViewDocument$SignatureStampModal)))))
								])));
				}
			default:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{formStatus: $author$project$Type$Stamp$Ready}),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Model$Stamp$update = F2(
	function (msg, appModel) {
		var _v0 = appModel.sessionModel;
		switch (_v0.$) {
			case 'Auth':
				var authModel = _v0.a;
				return A2(
					$elm$core$Tuple$mapFirst,
					function (newModel) {
						return _Utils_update(
							appModel,
							{
								sessionModel: $author$project$Types$Auth(
									_Utils_update(
										authModel,
										{stampModel: newModel}))
							});
					},
					A4($author$project$Model$Stamp$updateStampModel, msg, authModel.stampModel, authModel.user, appModel));
			case 'Anonymous':
				var anonymousModel = _v0.a;
				return A2(
					$elm$core$Tuple$mapFirst,
					function (newModel) {
						return _Utils_update(
							appModel,
							{
								sessionModel: $author$project$Types$Anonymous(
									_Utils_update(
										anonymousModel,
										{stampModel: newModel}))
							});
					},
					A4($author$project$Model$Stamp$updateStampModel, msg, anonymousModel.stampModel, anonymousModel.user, appModel));
			case 'NoAuth':
				return _Utils_Tuple2(appModel, $elm$core$Platform$Cmd$none);
			default:
				return _Utils_Tuple2(appModel, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Types$InvalidAuth = {$: 'InvalidAuth'};
var $author$project$Model$Theme$update = F2(
	function (msg, appModel) {
		var model = appModel.theme;
		if (msg.$ === 'LoadTheme') {
			var businessTheme = msg.a;
			return _Utils_Tuple2(
				_Utils_update(
					appModel,
					{
						theme: _Utils_update(
							model,
							{
								theme: $author$project$Type$Theme$Loaded(businessTheme)
							})
					}),
				$elm$core$Platform$Cmd$none);
		} else {
			var result = msg.a;
			if (result.$ === 'Ok') {
				var businessTheme = result.a;
				return _Utils_Tuple2(
					_Utils_update(
						appModel,
						{
							sessionModel: function () {
								var _v2 = appModel.sessionModel;
								switch (_v2.$) {
									case 'Auth':
										var authModel = _v2.a;
										return $author$project$Types$Auth(
											_Utils_update(
												authModel,
												{
													businessThemeForm: $author$project$Model$BusinessTheme$init(businessTheme)
												}));
									case 'Anonymous':
										var anonymousModel = _v2.a;
										return $author$project$Types$Anonymous(anonymousModel);
									case 'NoAuth':
										return $author$project$Types$NoAuth;
									default:
										return $author$project$Types$InvalidAuth;
								}
							}(),
							theme: _Utils_update(
								model,
								{
									theme: $author$project$Type$Theme$Loaded(businessTheme)
								})
						}),
					$elm$core$Platform$Cmd$none);
			} else {
				return _Utils_Tuple2(
					_Utils_update(
						appModel,
						{
							theme: _Utils_update(
								model,
								{
									theme: $author$project$Type$Theme$Loaded($author$project$Data$BusinessTheme$default)
								})
						}),
					$elm$core$Platform$Cmd$none);
			}
		}
	});
var $author$project$Type$TokenConfirmation$Fail = {$: 'Fail'};
var $author$project$Type$TokenConfirmation$OnConfirmationResponse = function (a) {
	return {$: 'OnConfirmationResponse', a: a};
};
var $author$project$Type$TokenConfirmation$Success = {$: 'Success'};
var $author$project$Data$Api$TokenConfirmation$Payload = function (message) {
	return {message: message};
};
var $author$project$Data$Api$TokenConfirmation$dataDecoder = A2(
	$elm$json$Json$Decode$map,
	$author$project$Data$Api$TokenConfirmation$Payload,
	A2($elm$json$Json$Decode$field, 'message', $elm$json$Json$Decode$string));
var $author$project$Data$Api$TokenConfirmation$INSUFFICIENT_BALANCE = {$: 'INSUFFICIENT_BALANCE'};
var $author$project$Data$Api$TokenConfirmation$INVALID_EMAIL = {$: 'INVALID_EMAIL'};
var $author$project$Data$Api$TokenConfirmation$INVALID_TRANSACTION = {$: 'INVALID_TRANSACTION'};
var $author$project$Data$Api$TokenConfirmation$INVALID_USER = {$: 'INVALID_USER'};
var $author$project$Data$Api$TokenConfirmation$errorDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (errorCode) {
		switch (errorCode) {
			case 'INVALID_EMAIL':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$TokenConfirmation$INVALID_EMAIL);
			case 'INVALID_USER':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$TokenConfirmation$INVALID_USER);
			case 'INSUFFICIENT_BALANCE':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$TokenConfirmation$INSUFFICIENT_BALANCE);
			case 'INVALID_TRANSACTION':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$TokenConfirmation$INVALID_TRANSACTION);
			default:
				return $elm$json$Json$Decode$fail('Invalid error code: ' + errorCode);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Data$Api$TokenConfirmation$authCall = F2(
	function (jwt, endPoint) {
		return A5(
			$author$project$Data$Api$authCall,
			jwt,
			endPoint,
			$author$project$Data$Api$TokenConfirmation$errorDecoder,
			$author$project$Data$Api$TokenConfirmation$dataDecoder,
			$elm$json$Json$Encode$object(_List_Nil));
	});
var $author$project$Data$Api$TokenConfirmation$errorToString = function (error) {
	switch (error.$) {
		case 'INVALID_EMAIL':
			return 'Invalid email.';
		case 'INVALID_USER':
			return 'Invalid user';
		case 'INSUFFICIENT_BALANCE':
			return 'Insufficient balance in account.';
		default:
			return 'Invalid transaction.';
	}
};
var $author$project$Model$TokenConfirmation$update = F2(
	function (msg, model) {
		if (msg.$ === 'OnTokenVerification') {
			var token = msg.a;
			return _Utils_Tuple2(
				model,
				A2(
					$elm$core$Task$attempt,
					A2($elm$core$Basics$composeL, $author$project$Types$OnTokenConfirmation, $author$project$Type$TokenConfirmation$OnConfirmationResponse),
					A2($author$project$Data$Api$TokenConfirmation$authCall, token, model.apiEndPoint.tokenConfirmation)));
		} else {
			var result = msg.a;
			if (result.$ === 'Ok') {
				var _v2 = model;
				var tokenConfirmationModel = _v2.tokenConfirmationModel;
				var newModel = _Utils_update(
					tokenConfirmationModel,
					{status: $author$project$Type$TokenConfirmation$Success});
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{tokenConfirmationModel: newModel}),
					$elm$core$Platform$Cmd$none);
			} else {
				var error = result.a;
				var _v3 = model;
				var tokenConfirmationModel = _v3.tokenConfirmationModel;
				var newModel = _Utils_update(
					tokenConfirmationModel,
					{
						error: $elm$core$Maybe$Just(
							A2($author$project$Data$Api$authErrorToString, $author$project$Data$Api$TokenConfirmation$errorToString, error)),
						status: $author$project$Type$TokenConfirmation$Fail
					});
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{tokenConfirmationModel: newModel}),
					$elm$core$Platform$Cmd$none);
			}
		}
	});
var $author$project$Type$TokenManagement$AwaitConfirmation = {$: 'AwaitConfirmation'};
var $author$project$Type$TokenManagement$Enter = {$: 'Enter'};
var $author$project$Type$TokenManagement$Error = function (a) {
	return {$: 'Error', a: a};
};
var $author$project$Type$TokenManagement$Loaded = {$: 'Loaded'};
var $author$project$Type$TokenManagement$Loading = {$: 'Loading'};
var $author$project$Type$TokenManagement$OnBSCScanApiResponse = function (a) {
	return {$: 'OnBSCScanApiResponse', a: a};
};
var $author$project$Type$TokenManagement$OnGetAlgorandWalletAddressResponse = function (a) {
	return {$: 'OnGetAlgorandWalletAddressResponse', a: a};
};
var $author$project$Type$TokenManagement$OnTransactionApiResponse = function (a) {
	return {$: 'OnTransactionApiResponse', a: a};
};
var $author$project$Type$TokenManagement$OnUpdateNotarisationNetworkResponse = function (a) {
	return {$: 'OnUpdateNotarisationNetworkResponse', a: a};
};
var $author$project$Type$TokenManagement$OnWalletConnectRegisterApiResponse = F2(
	function (a, b) {
		return {$: 'OnWalletConnectRegisterApiResponse', a: a, b: b};
	});
var $author$project$Type$TokenManagement$OnWalletOptInApiResponse = F2(
	function (a, b) {
		return {$: 'OnWalletOptInApiResponse', a: a, b: b};
	});
var $author$project$Type$TokenManagement$OnWalletRegisterApiResponse = F2(
	function (a, b) {
		return {$: 'OnWalletRegisterApiResponse', a: a, b: b};
	});
var $author$project$Type$TokenManagement$RegisteringWallet = {$: 'RegisteringWallet'};
var $author$project$Type$TokenManagement$RetriveInformation = {$: 'RetriveInformation'};
var $author$project$Type$TokenManagement$Selection = function (a) {
	return {$: 'Selection', a: a};
};
var $author$project$Type$TokenManagement$Success = {$: 'Success'};
var $author$project$Type$TokenManagement$WalletConnectSelection = function (a) {
	return {$: 'WalletConnectSelection', a: a};
};
var $author$project$Data$Api$RegisterAlgorandWallet$Payload = function (message) {
	return {message: message};
};
var $author$project$Data$Api$RegisterAlgorandWallet$dataDecoder = A2(
	$elm$json$Json$Decode$map,
	$author$project$Data$Api$RegisterAlgorandWallet$Payload,
	A2($elm$json$Json$Decode$field, 'message', $elm$json$Json$Decode$string));
var $author$project$Data$Api$RegisterAlgorandWallet$encode = function (walletAddress) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'walletAddress',
				$elm$json$Json$Encode$string(walletAddress))
			]));
};
var $author$project$Data$Api$RegisterAlgorandWallet$errorDecoder = $elm$json$Json$Decode$succeed(_Utils_Tuple0);
var $author$project$Data$Api$RegisterAlgorandWallet$authCall = F3(
	function (jwt, endPoint, walletAddress) {
		return A5(
			$author$project$Data$Api$authCall,
			jwt,
			endPoint,
			$author$project$Data$Api$RegisterAlgorandWallet$errorDecoder,
			$author$project$Data$Api$RegisterAlgorandWallet$dataDecoder,
			$author$project$Data$Api$RegisterAlgorandWallet$encode(walletAddress));
	});
var $author$project$Data$Api$TokenTransaction$Payload = F2(
	function (transactionID, createdAt) {
		return {createdAt: createdAt, transactionID: transactionID};
	});
var $author$project$Data$Api$TokenTransaction$dataDecoder = A3(
	$elm$json$Json$Decode$map2,
	$author$project$Data$Api$TokenTransaction$Payload,
	A2($elm$json$Json$Decode$field, 'transactionID', $elm$json$Json$Decode$string),
	A2(
		$elm$json$Json$Decode$map,
		$elm$time$Time$millisToPosix,
		A2($elm$json$Json$Decode$field, 'createdAt', $elm$json$Json$Decode$int)));
var $author$project$Data$Api$TokenTransaction$encode = F3(
	function (email, amount, remarks) {
		var formattedEmail = $elm$core$String$toLower(
			$elm$core$String$trim(email));
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'recipient',
					$elm$json$Json$Encode$string(formattedEmail)),
					_Utils_Tuple2(
					'amount',
					$elm$json$Json$Encode$int(amount)),
					_Utils_Tuple2(
					'remarks',
					$elm$json$Json$Encode$string(remarks))
				]));
	});
var $author$project$Data$Api$TokenTransaction$INSUFFICIENT_BALANCE = {$: 'INSUFFICIENT_BALANCE'};
var $author$project$Data$Api$TokenTransaction$INVALID_EMAIL = {$: 'INVALID_EMAIL'};
var $author$project$Data$Api$TokenTransaction$INVALID_USER = {$: 'INVALID_USER'};
var $author$project$Data$Api$TokenTransaction$errorDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (errorCode) {
		switch (errorCode) {
			case 'INVALID_EMAIL':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$TokenTransaction$INVALID_EMAIL);
			case 'INVALID_USER':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$TokenTransaction$INVALID_USER);
			case 'INSUFFICIENT_BALANCE':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$TokenTransaction$INSUFFICIENT_BALANCE);
			default:
				return $elm$json$Json$Decode$fail('Invalid error code: ' + errorCode);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Data$Api$TokenTransaction$authCall = F5(
	function (jwt, endPoint, email, amount, remarks) {
		return A5(
			$author$project$Data$Api$authCall,
			jwt,
			endPoint,
			$author$project$Data$Api$TokenTransaction$errorDecoder,
			$author$project$Data$Api$TokenTransaction$dataDecoder,
			A3($author$project$Data$Api$TokenTransaction$encode, email, amount, remarks));
	});
var $author$project$Data$BscScanApi$BadStatus = F2(
	function (a, b) {
		return {$: 'BadStatus', a: a, b: b};
	});
var $author$project$Data$BscScanApi$BadUrl = function (a) {
	return {$: 'BadUrl', a: a};
};
var $author$project$Data$BscScanApi$DataDecodeError = function (a) {
	return {$: 'DataDecodeError', a: a};
};
var $author$project$Data$BscScanApi$Fail = function (a) {
	return {$: 'Fail', a: a};
};
var $author$project$Data$BscScanApi$NetworkError = {$: 'NetworkError'};
var $author$project$Data$BscScanApi$NonStandardApiError = function (a) {
	return {$: 'NonStandardApiError', a: a};
};
var $author$project$Data$BscScanApi$ServerInternalError = {$: 'ServerInternalError'};
var $author$project$Data$BscScanApi$Timeout = {$: 'Timeout'};
var $author$project$Data$BscScanApi$Failure = F3(
	function (status, result, message) {
		return {message: message, result: result, status: status};
	});
var $author$project$Data$BscScanApi$statusDecoder = function (expectedStatus) {
	return A2(
		$elm$json$Json$Decode$andThen,
		function (decodedStatus) {
			return _Utils_eq(expectedStatus, decodedStatus) ? $elm$json$Json$Decode$succeed(decodedStatus) : $elm$json$Json$Decode$fail('Expecting ' + (expectedStatus + (' but received ' + decodedStatus)));
		},
		$elm$json$Json$Decode$string);
};
var $author$project$Data$BscScanApi$failureDecoder = A4(
	$elm$json$Json$Decode$map3,
	$author$project$Data$BscScanApi$Failure,
	A2(
		$elm$json$Json$Decode$field,
		'message',
		$author$project$Data$BscScanApi$statusDecoder('NOTOK')),
	A2($elm$json$Json$Decode$field, 'status', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'result', $elm$json$Json$Decode$string));
var $author$project$Data$BscScanApi$Success = F3(
	function (status, message, result) {
		return {message: message, result: result, status: status};
	});
var $author$project$Data$BscScanApi$successDecoder = A4(
	$elm$json$Json$Decode$map3,
	$author$project$Data$BscScanApi$Success,
	A2(
		$elm$json$Json$Decode$field,
		'message',
		$author$project$Data$BscScanApi$statusDecoder('OK')),
	A2($elm$json$Json$Decode$field, 'status', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'result', $elm$json$Json$Decode$string));
var $author$project$Data$BscScanApi$responseResolver = function (response) {
	switch (response.$) {
		case 'BadUrl_':
			var url = response.a;
			return $elm$core$Result$Err(
				$author$project$Data$BscScanApi$BadUrl(url));
		case 'Timeout_':
			return $elm$core$Result$Err($author$project$Data$BscScanApi$Timeout);
		case 'NetworkError_':
			return $elm$core$Result$Err($author$project$Data$BscScanApi$NetworkError);
		case 'BadStatus_':
			var metadata = response.a;
			var body = response.b;
			if (metadata.statusCode === 500) {
				return $elm$core$Result$Err($author$project$Data$BscScanApi$ServerInternalError);
			} else {
				if (metadata.statusCode === 400) {
					var _v1 = A2($elm$json$Json$Decode$decodeString, $author$project$Data$BscScanApi$failureDecoder, body);
					if (_v1.$ === 'Ok') {
						var failure = _v1.a;
						return $elm$core$Result$Err(
							$author$project$Data$BscScanApi$Fail(failure.result));
					} else {
						var error = _v1.a;
						return $elm$core$Result$Err(
							$author$project$Data$BscScanApi$NonStandardApiError(
								$elm$json$Json$Decode$errorToString(error)));
					}
				} else {
					return $elm$core$Result$Err(
						A2($author$project$Data$BscScanApi$BadStatus, metadata, body));
				}
			}
		default:
			var body = response.b;
			var _v2 = A2($elm$json$Json$Decode$decodeString, $author$project$Data$BscScanApi$successDecoder, body);
			if (_v2.$ === 'Ok') {
				var success = _v2.a;
				return $elm$core$Result$Ok(success.result);
			} else {
				var error = _v2.a;
				return $elm$core$Result$Err(
					$author$project$Data$BscScanApi$DataDecodeError(
						$elm$json$Json$Decode$errorToString(error)));
			}
	}
};
var $author$project$Data$BscScanApi$httpTask = F2(
	function (url, jsonBody) {
		return $elm$http$Http$task(
			{
				body: $elm$http$Http$jsonBody(jsonBody),
				headers: _List_Nil,
				method: 'POST',
				resolver: $elm$http$Http$stringResolver($author$project$Data$BscScanApi$responseResolver),
				timeout: $elm$core$Maybe$Just(30000),
				url: url
			});
	});
var $author$project$Data$Api$BscScanAccountBalance$call = function (endPoint) {
	return A2(
		$author$project$Data$BscScanApi$httpTask,
		endPoint,
		$elm$json$Json$Encode$object(_List_Nil));
};
var $author$project$Model$TokenManagement$checkAmount = function (amount) {
	var convertedAmt = $elm$core$String$toFloat(amount);
	if (convertedAmt.$ === 'Just') {
		var amt = convertedAmt.a;
		return (amt > 0) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just('Amount cannot be zero or negative.');
	} else {
		return $elm$core$Maybe$Just('Invalid Number.');
	}
};
var $author$project$Model$TokenManagement$checkEmail = function (email) {
	return $elm$core$String$isEmpty(email) ? $elm$core$Maybe$Just('Email cannot be empty.') : $author$project$Data$Validator$validateEmail(email);
};
var $author$project$Model$TokenManagement$checkIfWith2DP = function (amount) {
	return A2($elm$core$String$contains, '.', amount) ? function (result) {
		if (result.$ === 'Just') {
			var dp = result.a;
			return $elm$core$String$length(dp) < 3;
		} else {
			return false;
		}
	}(
		$elm$core$List$head(
			$elm$core$List$reverse(
				A2($elm$core$String$split, '.', amount)))) : true;
};
var $author$project$Model$TokenManagement$convertNetworkToString = function (currentUserNotarisationNetwork) {
	if (currentUserNotarisationNetwork.$ === 'Binance') {
		return 'Binance';
	} else {
		return 'Algorand';
	}
};
var $author$project$Model$TokenManagement$convertPaymentToString = function (currentUserNotarisationNetwork) {
	switch (currentUserNotarisationNetwork.$) {
		case 'SystemPointsBalance':
			return 'systemBalance';
		case 'AlgoWallet':
			return 'algoWallet';
		default:
			return 'walletConnect';
	}
};
var $author$project$Data$AlgorandWallet$SingleWallet = function (wallet) {
	return {wallet: wallet};
};
var $author$project$Data$AlgorandWallet$decodeSingleWallet = A2(
	$elm$json$Json$Decode$map,
	$author$project$Data$AlgorandWallet$SingleWallet,
	A2($elm$json$Json$Decode$field, 'wallet', $elm$json$Json$Decode$string));
var $author$project$Data$AlgorandWallet$decodeSingleWalletResult = function (value) {
	var _v0 = A2($elm$json$Json$Decode$decodeValue, $author$project$Data$AlgorandWallet$decodeSingleWallet, value);
	if (_v0.$ === 'Ok') {
		var results = _v0.a;
		return $elm$core$Result$Ok(results);
	} else {
		return $elm$core$Result$Err('Unable to retrieve wallet details.');
	}
};
var $author$project$Data$Wallet$decodeWalletAmount = function (value) {
	var _v0 = A2($elm$json$Json$Decode$decodeValue, $elm$json$Json$Decode$string, value);
	if (_v0.$ === 'Ok') {
		var results = _v0.a;
		return $elm$core$Result$Ok(results);
	} else {
		return $elm$core$Result$Err('Unable to retrieve wallet details.');
	}
};
var $author$project$Data$Wallet$Error = function (error) {
	return {error: error};
};
var $author$project$Data$Wallet$decodeError = A2(
	$elm$json$Json$Decode$map,
	$author$project$Data$Wallet$Error,
	A2($elm$json$Json$Decode$field, 'error', $elm$json$Json$Decode$string));
var $author$project$Data$Wallet$decodeWalletError = function (value) {
	var _v0 = A2($elm$json$Json$Decode$decodeValue, $author$project$Data$Wallet$decodeError, value);
	if (_v0.$ === 'Ok') {
		var results = _v0.a;
		return $elm$core$Result$Ok(results);
	} else {
		return $elm$core$Result$Err('Unable to retrieve wallet details.');
	}
};
var $author$project$Data$Wallet$Wallet = F2(
	function (wallet, date) {
		return {date: date, wallet: wallet};
	});
var $author$project$Data$Wallet$decodeWallet = A3(
	$elm$json$Json$Decode$map2,
	$author$project$Data$Wallet$Wallet,
	A2($elm$json$Json$Decode$field, 'wallet', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'date', $elm$json$Json$Decode$int));
var $author$project$Data$Wallet$decodeWalletResult = function (value) {
	var _v0 = A2($elm$json$Json$Decode$decodeValue, $author$project$Data$Wallet$decodeWallet, value);
	if (_v0.$ === 'Ok') {
		var results = _v0.a;
		return $elm$core$Result$Ok(results);
	} else {
		return $elm$core$Result$Err('Unable to retrieve wallet details.');
	}
};
var $author$project$Data$Api$TokenTransaction$errorToString = function (error) {
	switch (error.$) {
		case 'INVALID_EMAIL':
			return 'Invalid email.';
		case 'INVALID_USER':
			return 'Invalid user';
		default:
			return 'Insufficient balance in account.';
	}
};
var $author$project$Model$TokenManagement$getWalletAddress = _Platform_outgoingPort(
	'getWalletAddress',
	function ($) {
		return $elm$json$Json$Encode$null;
	});
var $author$project$Model$TokenManagement$getWalletAmount = _Platform_outgoingPort('getWalletAmount', $elm$core$Basics$identity);
var $author$project$Model$TokenManagement$update = F3(
	function (msg, model, authModel) {
		var updateCurrentModel = function (currentModel) {
			return _Utils_update(
				model,
				{
					sessionModel: $author$project$Types$Auth(
						_Utils_update(
							authModel,
							{tokenManagementModel: currentModel}))
				});
		};
		var _v0 = authModel;
		var tokenManagementModel = _v0.tokenManagementModel;
		var user = _v0.user;
		var redeemRewardList = _v0.redeemRewardList;
		var _v1 = tokenManagementModel;
		var sendToken = _v1.sendToken;
		switch (msg.$) {
			case 'OnTransactionSubmit':
				var inputChecks = A2(
					$elm$core$List$all,
					$elm$core$Basics$eq(false),
					_List_fromArray(
						[
							$elm$core$String$isEmpty(sendToken.email),
							$elm$core$String$isEmpty(sendToken.amount)
						]));
				var errorchecks = A2(
					$elm$core$List$all,
					$elm$core$Basics$eq($elm$core$Maybe$Nothing),
					_List_fromArray(
						[sendToken.emailError, sendToken.amountError]));
				return (errorchecks && inputChecks) ? _Utils_Tuple2(
					model,
					A2(
						$elm$core$Task$attempt,
						A2(
							$elm$core$Basics$composeL,
							A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnTokenManagement),
							$author$project$Type$TokenManagement$OnTransactionApiResponse),
						A5(
							$author$project$Data$Api$TokenTransaction$authCall,
							authModel.user.jwt,
							model.apiEndPoint.tokenTransaction,
							sendToken.email,
							$elm$core$Basics$round(
								A2(
									$elm$core$Maybe$withDefault,
									0,
									$elm$core$String$toFloat(sendToken.amount)) * 100),
							sendToken.remarks))) : _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 'OnRecipientEmail':
				var inputType = msg.a;
				if (inputType.$ === 'Input') {
					var email = inputType.a;
					return _Utils_Tuple2(
						updateCurrentModel(
							_Utils_update(
								tokenManagementModel,
								{
									sendToken: _Utils_update(
										sendToken,
										{banner: $author$project$Type$TokenManagement$Closed, email: email})
								})),
						$elm$core$Platform$Cmd$none);
				} else {
					return _Utils_Tuple2(
						updateCurrentModel(
							_Utils_update(
								tokenManagementModel,
								{
									sendToken: _Utils_update(
										sendToken,
										{
											emailError: $author$project$Model$TokenManagement$checkEmail(sendToken.email)
										})
								})),
						$elm$core$Platform$Cmd$none);
				}
			case 'OnRecipientAmount':
				var inputType = msg.a;
				if (inputType.$ === 'Input') {
					var amount = inputType.a;
					var newTokenManagement = _Utils_update(
						tokenManagementModel,
						{
							sendToken: _Utils_update(
								sendToken,
								{amount: amount, banner: $author$project$Type$TokenManagement$Closed})
						});
					return $elm$core$String$isEmpty(amount) ? _Utils_Tuple2(
						updateCurrentModel(newTokenManagement),
						$elm$core$Platform$Cmd$none) : (((!_Utils_eq(
						$elm$core$String$toFloat(amount),
						$elm$core$Maybe$Nothing)) && $author$project$Model$TokenManagement$checkIfWith2DP(amount)) ? _Utils_Tuple2(
						updateCurrentModel(newTokenManagement),
						$elm$core$Platform$Cmd$none) : _Utils_Tuple2(model, $elm$core$Platform$Cmd$none));
				} else {
					return $elm$core$String$isEmpty(sendToken.amount) ? _Utils_Tuple2(
						updateCurrentModel(
							_Utils_update(
								tokenManagementModel,
								{
									sendToken: _Utils_update(
										sendToken,
										{
											amountError: $elm$core$Maybe$Just('Amount cannot be empty.')
										})
								})),
						$elm$core$Platform$Cmd$none) : _Utils_Tuple2(
						updateCurrentModel(
							_Utils_update(
								tokenManagementModel,
								{
									sendToken: _Utils_update(
										sendToken,
										{
											amountError: $author$project$Model$TokenManagement$checkAmount(sendToken.amount)
										})
								})),
						$elm$core$Platform$Cmd$none);
				}
			case 'OnRecipientRemarks':
				var remarks = msg.a;
				return _Utils_Tuple2(
					updateCurrentModel(
						_Utils_update(
							tokenManagementModel,
							{
								sendToken: _Utils_update(
									sendToken,
									{remarks: remarks})
							})),
					$elm$core$Platform$Cmd$none);
			case 'OnTransactionApiResponse':
				var result = msg.a;
				if (result.$ === 'Ok') {
					var response = result.a;
					var newTransactionHistory = A2(
						$elm$core$List$take,
						5,
						A2(
							$elm$core$List$cons,
							{
								amount: A2(
									$elm$core$Maybe$withDefault,
									0,
									$elm$core$String$toFloat(sendToken.amount)) * 100,
								from: user.email,
								id: response.transactionID,
								inOut: $author$project$Type$PointTransactionTable$Out,
								status: $author$project$Type$PointTransactionTable$Pending,
								timeStamp: response.createdAt,
								to: tokenManagementModel.sendToken.email,
								transaction: $author$project$Type$PointTransactionTable$User
							},
							tokenManagementModel.transactions));
					var newTokenManagement = _Utils_update(
						tokenManagementModel,
						{
							available: tokenManagementModel.available - (A2(
								$elm$core$Maybe$withDefault,
								0,
								$elm$core$String$toFloat(sendToken.amount)) * 100),
							pending: tokenManagementModel.pending - (A2(
								$elm$core$Maybe$withDefault,
								0,
								$elm$core$String$toFloat(sendToken.amount)) * 100),
							sendToken: _Utils_update(
								sendToken,
								{amount: '', amountError: $elm$core$Maybe$Nothing, banner: $author$project$Type$TokenManagement$Success, email: '', emailError: $elm$core$Maybe$Nothing, remarks: ''}),
							transactions: newTransactionHistory
						});
					return _Utils_Tuple2(
						updateCurrentModel(newTokenManagement),
						$elm$core$Platform$Cmd$none);
				} else {
					var error = result.a;
					var newTokenManagement = _Utils_update(
						tokenManagementModel,
						{
							sendToken: _Utils_update(
								sendToken,
								{
									banner: $author$project$Type$TokenManagement$Error(
										A2($author$project$Data$Api$authErrorToString, $author$project$Data$Api$TokenTransaction$errorToString, error))
								})
						});
					return _Utils_Tuple2(
						updateCurrentModel(newTokenManagement),
						$elm$core$Platform$Cmd$none);
				}
			case 'OnBannerClose':
				var banner = msg.a;
				var newTokenManagement = _Utils_update(
					tokenManagementModel,
					{
						sendToken: _Utils_update(
							sendToken,
							{banner: $author$project$Type$TokenManagement$Closed})
					});
				if (banner.$ === 'SendTokenBanner') {
					return _Utils_Tuple2(
						updateCurrentModel(newTokenManagement),
						$elm$core$Platform$Cmd$none);
				} else {
					return _Utils_Tuple2(
						updateCurrentModel(
							_Utils_update(
								tokenManagementModel,
								{updateStatus: $author$project$Type$TokenManagement$Closed})),
						$elm$core$Platform$Cmd$none);
				}
			case 'OnPageEnter':
				var _v7 = function () {
					var _v8 = _Utils_Tuple2(
						user.notarisationNetwork,
						_Utils_Tuple2(user.metaMaskWalletAddress, user.algorandWalletAddress));
					switch (_v8.a) {
						case 'Binance':
							if (_v8.b.a.$ === 'Just') {
								var _v9 = _v8.b;
								var address = _v9.a.a;
								return _Utils_Tuple2(
									_List_fromArray(
										[
											A2(
											$elm$core$Task$attempt,
											A2(
												$elm$core$Basics$composeL,
												A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnTokenManagement),
												$author$project$Type$TokenManagement$OnDashboardApiResponse),
											A2($author$project$Data$Api$Points$PointsDashboard$authCall, authModel.user.jwt, model.apiEndPoint.pointsDashboard)),
											A2(
											$elm$core$Task$attempt,
											A2(
												$elm$core$Basics$composeL,
												A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnTokenManagement),
												$author$project$Type$TokenManagement$OnBSCScanApiResponse),
											$author$project$Data$Api$BscScanAccountBalance$call(model.apiEndPoint.bscScanAccountBalanceApi + ('&address=' + (address + ('&tag=latest&apikey=' + model.bscScanApiKey))))),
											A2($author$project$Model$RedeemRewardList$listCmd, model.apiEndPoint.redeemRewardList, authModel.user)
										]),
									updateCurrentModel(
										_Utils_update(
											tokenManagementModel,
											{
												currentNetwork: $author$project$Model$TokenManagement$convertStringToNetwork(user.notarisationNetwork),
												paymentMethod: $author$project$Model$TokenManagement$convertStringToPayment(user.paymentMethod)
											})));
							} else {
								var _v10 = _v8.b;
								var _v11 = _v10.a;
								return _Utils_Tuple2(
									_List_fromArray(
										[
											A2(
											$elm$core$Task$attempt,
											A2(
												$elm$core$Basics$composeL,
												A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnTokenManagement),
												$author$project$Type$TokenManagement$OnDashboardApiResponse),
											A2($author$project$Data$Api$Points$PointsDashboard$authCall, authModel.user.jwt, model.apiEndPoint.pointsDashboard)),
											A2($author$project$Model$RedeemRewardList$listCmd, model.apiEndPoint.redeemRewardList, authModel.user)
										]),
									updateCurrentModel(
										_Utils_update(
											tokenManagementModel,
											{
												currentNetwork: $author$project$Model$TokenManagement$convertStringToNetwork(user.notarisationNetwork),
												paymentMethod: $author$project$Model$TokenManagement$convertStringToPayment(user.paymentMethod),
												walletStatus: $author$project$Type$TokenManagement$Loaded
											})));
							}
						case 'Algorand':
							if (_v8.b.b.$ === 'Just') {
								var _v12 = _v8.b;
								var address = _v12.b.a;
								return _Utils_Tuple2(
									_List_fromArray(
										[
											A2(
											$elm$core$Task$attempt,
											A2(
												$elm$core$Basics$composeL,
												A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnTokenManagement),
												$author$project$Type$TokenManagement$OnDashboardApiResponse),
											A2($author$project$Data$Api$Points$PointsDashboard$authCall, authModel.user.jwt, model.apiEndPoint.pointsDashboard)),
											$author$project$Model$TokenManagement$getWalletAmount(
											$elm$json$Json$Encode$string(address)),
											A2($author$project$Model$RedeemRewardList$listCmd, model.apiEndPoint.redeemRewardList, authModel.user)
										]),
									updateCurrentModel(
										_Utils_update(
											tokenManagementModel,
											{
												currentNetwork: $author$project$Model$TokenManagement$convertStringToNetwork(user.notarisationNetwork),
												paymentMethod: $author$project$Model$TokenManagement$convertStringToPayment(user.paymentMethod)
											})));
							} else {
								var _v13 = _v8.b;
								var _v14 = _v13.b;
								return _Utils_Tuple2(
									_List_fromArray(
										[
											A2(
											$elm$core$Task$attempt,
											A2(
												$elm$core$Basics$composeL,
												A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnTokenManagement),
												$author$project$Type$TokenManagement$OnDashboardApiResponse),
											A2($author$project$Data$Api$Points$PointsDashboard$authCall, authModel.user.jwt, model.apiEndPoint.pointsDashboard)),
											A2($author$project$Model$RedeemRewardList$listCmd, model.apiEndPoint.redeemRewardList, authModel.user)
										]),
									updateCurrentModel(
										_Utils_update(
											tokenManagementModel,
											{
												currentNetwork: $author$project$Model$TokenManagement$convertStringToNetwork(user.notarisationNetwork),
												paymentMethod: $author$project$Model$TokenManagement$convertStringToPayment(user.paymentMethod),
												walletStatus: $author$project$Type$TokenManagement$Loaded
											})));
							}
						default:
							var _v15 = _v8.b;
							return _Utils_Tuple2(
								_List_fromArray(
									[
										A2(
										$elm$core$Task$attempt,
										A2(
											$elm$core$Basics$composeL,
											A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnTokenManagement),
											$author$project$Type$TokenManagement$OnDashboardApiResponse),
										A2($author$project$Data$Api$Points$PointsDashboard$authCall, authModel.user.jwt, model.apiEndPoint.pointsDashboard)),
										A2($author$project$Model$RedeemRewardList$listCmd, model.apiEndPoint.redeemRewardList, authModel.user)
									]),
								updateCurrentModel(
									_Utils_update(
										tokenManagementModel,
										{walletStatus: $author$project$Type$TokenManagement$Loaded})));
					}
				}();
				var commands = _v7.a;
				var newModel = _v7.b;
				return _Utils_Tuple2(
					newModel,
					$elm$core$Platform$Cmd$batch(commands));
			case 'OnDashboardApiResponse':
				var response = msg.a;
				if (response.$ === 'Ok') {
					var result = response.a;
					var transactionHistory = A2(
						$elm$core$List$map,
						function (transaction) {
							var inOut = _Utils_eq(user.email, transaction.sender) ? $author$project$Type$PointTransactionTable$Out : $author$project$Type$PointTransactionTable$In;
							return {
								amount: transaction.amount,
								from: transaction.sender,
								id: transaction.id,
								inOut: inOut,
								status: $author$project$Type$PointTransactionTable$textToStatus(transaction.status),
								timeStamp: transaction.createdAt,
								to: transaction.receiver,
								transaction: $author$project$Type$PointTransactionTable$textToTransactionType(transaction.senderRole)
							};
						},
						result.transactionHistory);
					var newTokenManagement = _Utils_update(
						tokenManagementModel,
						{available: result.available, pending: result.pending, transactions: transactionHistory, usdToPoints: result.usdToPoints});
					var newRedeemRewardList = _Utils_update(
						redeemRewardList,
						{available: result.available, pending: result.pending});
					var updateTwoModels = _Utils_update(
						model,
						{
							sessionModel: $author$project$Types$Auth(
								_Utils_update(
									authModel,
									{redeemRewardList: newRedeemRewardList, tokenManagementModel: newTokenManagement}))
						});
					return _Utils_Tuple2(updateTwoModels, $elm$core$Platform$Cmd$none);
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 'OnViewAllClick':
				return _Utils_Tuple2(
					model,
					A2($elm$browser$Browser$Navigation$pushUrl, model.navKey, $author$project$Data$Route$routeUrl.transactionHistory));
			case 'OnTransactionClick':
				var transactionID = msg.a;
				return _Utils_Tuple2(
					model,
					A2($elm$browser$Browser$Navigation$pushUrl, model.navKey, $author$project$Data$Route$routeUrl.transaction + ('/' + transactionID)));
			case 'OnWithdrawClick':
				return _Utils_Tuple2(
					model,
					A2($elm$browser$Browser$Navigation$pushUrl, model.navKey, $author$project$Data$Route$routeUrl.withdrawal));
			case 'OnExternalWalletClick':
				var newTokenManagement = _Utils_update(
					tokenManagementModel,
					{walletError: $elm$core$Maybe$Nothing, walletStatus: $author$project$Type$TokenManagement$Loading});
				var _v17 = _Utils_Tuple2(tokenManagementModel.currentNetwork, tokenManagementModel.paymentMethod);
				if (_v17.a.$ === 'Algorand') {
					switch (_v17.b.$) {
						case 'WalletConnect':
							var _v18 = _v17.a;
							var _v19 = _v17.b;
							return _Utils_Tuple2(
								updateCurrentModel(
									_Utils_update(
										tokenManagementModel,
										{
											modal: $author$project$Type$TokenManagement$WalletConnectSelection($author$project$Type$TokenManagement$RetriveInformation)
										})),
								$author$project$Data$WalletConnect$walletConnectInit(
									$elm$json$Json$Encode$string('Points')));
						case 'AlgoWallet':
							var _v20 = _v17.a;
							var _v21 = _v17.b;
							return _Utils_Tuple2(
								updateCurrentModel(
									_Utils_update(
										tokenManagementModel,
										{walletError: $elm$core$Maybe$Nothing, walletStatus: $author$project$Type$TokenManagement$Loading})),
								$author$project$Model$ViewDocument$getAlgorandWalletAddress('tokenManagement'));
						default:
							var _v22 = _v17.a;
							var _v23 = _v17.b;
							return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					}
				} else {
					var _v24 = _v17.a;
					return _Utils_Tuple2(
						updateCurrentModel(newTokenManagement),
						$author$project$Model$TokenManagement$getWalletAddress(_Utils_Tuple0));
				}
			case 'OnExternalWalletAddress':
				var result = msg.a;
				var _v25 = $author$project$Data$Wallet$decodeWalletResult(result);
				if (_v25.$ === 'Ok') {
					var value = _v25.a;
					return _Utils_eq(tokenManagementModel.walletStatus, $author$project$Type$TokenManagement$Loading) ? _Utils_Tuple2(
						model,
						A2(
							$elm$core$Task$attempt,
							A2(
								$elm$core$Basics$composeL,
								A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnTokenManagement),
								$author$project$Type$TokenManagement$OnWalletRegisterApiResponse(value.wallet)),
							A4($author$project$Data$Api$Points$WalletRegistration$authCall, authModel.user.jwt, model.apiEndPoint.pointsWalletRegistration, value.wallet, 'Binance'))) : _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				} else {
					return _Utils_Tuple2(
						updateCurrentModel(
							_Utils_update(
								tokenManagementModel,
								{
									walletError: $elm$core$Maybe$Just('There is an error with registering your wallet. Please try again.'),
									walletStatus: $author$project$Type$TokenManagement$Loaded
								})),
						$elm$core$Platform$Cmd$none);
				}
			case 'OnWalletRegisterApiResponse':
				var wallet = msg.a;
				var response = msg.b;
				if (response.$ === 'Ok') {
					return _Utils_Tuple2(
						updateCurrentModel(
							_Utils_update(
								tokenManagementModel,
								{walletStatus: $author$project$Type$TokenManagement$Loaded})),
						A2(
							$elm$core$Task$attempt,
							A2(
								$elm$core$Basics$composeL,
								A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnTokenManagement),
								$author$project$Type$TokenManagement$OnBSCScanApiResponse),
							$author$project$Data$Api$BscScanAccountBalance$call(model.apiEndPoint.bscScanAccountBalanceApi + ('&address=' + (wallet + ('&tag=latest&apikey=' + model.bscScanApiKey))))));
				} else {
					return _Utils_Tuple2(
						updateCurrentModel(
							_Utils_update(
								tokenManagementModel,
								{
									walletError: $elm$core$Maybe$Just('There is an error with registering your wallet. Please try again.'),
									walletStatus: $author$project$Type$TokenManagement$Loaded
								})),
						$elm$core$Platform$Cmd$none);
				}
			case 'OnExternalWalletError':
				var result = msg.a;
				var decodedMsg = function () {
					var _v27 = $author$project$Data$Wallet$decodeWalletError(result);
					if (_v27.$ === 'Ok') {
						var message = _v27.a;
						return message.error;
					} else {
						return 'Error getting wallet Address. Please try again.';
					}
				}();
				var newTokenManagement = _Utils_update(
					tokenManagementModel,
					{
						walletError: $elm$core$Maybe$Just(decodedMsg),
						walletStatus: $author$project$Type$TokenManagement$Loaded
					});
				return _Utils_Tuple2(
					updateCurrentModel(newTokenManagement),
					$elm$core$Platform$Cmd$none);
			case 'OnExternalWalletCancel':
				var newTokenManagement = _Utils_update(
					tokenManagementModel,
					{walletStatus: $author$project$Type$TokenManagement$Loaded});
				return _Utils_Tuple2(
					updateCurrentModel(newTokenManagement),
					$elm$core$Platform$Cmd$none);
			case 'OnBSCScanApiResponse':
				var response = msg.a;
				if (response.$ === 'Ok') {
					var result = response.a;
					return _Utils_Tuple2(
						updateCurrentModel(
							_Utils_update(
								tokenManagementModel,
								{
									tokenBalance: $elm$core$Maybe$Just(result),
									walletStatus: $author$project$Type$TokenManagement$Loaded
								})),
						$elm$core$Platform$Cmd$none);
				} else {
					return _Utils_Tuple2(
						updateCurrentModel(
							_Utils_update(
								tokenManagementModel,
								{tokenBalance: $elm$core$Maybe$Nothing, walletStatus: $author$project$Type$TokenManagement$Loaded})),
						$elm$core$Platform$Cmd$none);
				}
			case 'OnHover':
				var placement = msg.a;
				var action = msg.b;
				switch (placement.$) {
					case 'SystemBalance':
						return _Utils_Tuple2(
							updateCurrentModel(
								_Utils_update(
									tokenManagementModel,
									{
										systemHover: _Utils_eq(action, $author$project$Type$TokenManagement$Enter)
									})),
							$elm$core$Platform$Cmd$none);
					case 'ExternalWallet':
						return _Utils_Tuple2(
							updateCurrentModel(
								_Utils_update(
									tokenManagementModel,
									{
										walletHover: _Utils_eq(action, $author$project$Type$TokenManagement$Enter)
									})),
							$elm$core$Platform$Cmd$none);
					default:
						return _Utils_Tuple2(
							updateCurrentModel(
								_Utils_update(
									tokenManagementModel,
									{
										redeemRewardHover: _Utils_eq(action, $author$project$Type$TokenManagement$Enter)
									})),
							$elm$core$Platform$Cmd$none);
				}
			case 'RadioBtnClick':
				var radiobutton = msg.a;
				switch (radiobutton.$) {
					case 'BinanceRadioBtn':
						return _Utils_Tuple2(
							updateCurrentModel(
								_Utils_update(
									tokenManagementModel,
									{currentNetwork: $author$project$Type$TokenManagement$Binance, paymentMethod: $author$project$Type$TokenManagement$SystemPointsBalance})),
							$elm$core$Platform$Cmd$none);
					case 'AlgorandRadioBtn':
						return _Utils_Tuple2(
							updateCurrentModel(
								_Utils_update(
									tokenManagementModel,
									{currentNetwork: $author$project$Type$TokenManagement$Algorand})),
							$elm$core$Platform$Cmd$none);
					case 'SystemBalanceBtn':
						return _Utils_Tuple2(
							updateCurrentModel(
								_Utils_update(
									tokenManagementModel,
									{paymentMethod: $author$project$Type$TokenManagement$SystemPointsBalance})),
							$elm$core$Platform$Cmd$none);
					case 'UserWalletBtn':
						return _Utils_Tuple2(
							updateCurrentModel(
								_Utils_update(
									tokenManagementModel,
									{paymentMethod: $author$project$Type$TokenManagement$AlgoWallet})),
							$elm$core$Platform$Cmd$none);
					default:
						return _Utils_Tuple2(
							updateCurrentModel(
								_Utils_update(
									tokenManagementModel,
									{paymentMethod: $author$project$Type$TokenManagement$WalletConnect})),
							$elm$core$Platform$Cmd$none);
				}
			case 'OnUpdateNotarisationNetworkResponse':
				var result = msg.a;
				if (result.$ === 'Ok') {
					return _Utils_Tuple2(
						updateCurrentModel(
							_Utils_update(
								tokenManagementModel,
								{updateStatus: $author$project$Type$TokenManagement$Success})),
						_Utils_eq(authModel.user.algorandWalletAddress, $elm$core$Maybe$Nothing) ? $elm$core$Platform$Cmd$none : $author$project$Model$TokenManagement$getWalletAmount(
							$elm$json$Json$Encode$string(
								A2($elm$core$Maybe$withDefault, '', authModel.user.algorandWalletAddress))));
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						updateCurrentModel(
							_Utils_update(
								tokenManagementModel,
								{
									updateStatus: $author$project$Type$TokenManagement$Error(
										A2($author$project$Data$Api$authErrorToString, $author$project$Data$Api$UpdateNotarisationNetwork$errorToString, error))
								})),
						$elm$core$Platform$Cmd$none);
				}
			case 'OnModalClose':
				return _Utils_Tuple2(
					updateCurrentModel(
						_Utils_update(
							tokenManagementModel,
							{modal: $author$project$Type$TokenManagement$AllClosed})),
					$elm$core$Platform$Cmd$none);
			case 'OnReceiveWalletConnetAddresses':
				var addresses = msg.a;
				var _v32 = $author$project$Data$Wallet$decodeWalletConnectResult(addresses);
				if (_v32.$ === 'Ok') {
					var result = _v32.a;
					return _Utils_Tuple2(
						updateCurrentModel(
							_Utils_update(
								tokenManagementModel,
								{
									modal: $author$project$Type$TokenManagement$WalletConnectSelection(
										$author$project$Type$TokenManagement$Selection(result)),
									walletStatus: $author$project$Type$TokenManagement$Loading
								})),
						$elm$core$Platform$Cmd$none);
				} else {
					var error = _v32.a;
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 'OnSelectWallet':
				var walletData = msg.a;
				return walletData.needOptIn ? _Utils_Tuple2(
					updateCurrentModel(
						_Utils_update(
							tokenManagementModel,
							{
								modal: $author$project$Type$TokenManagement$WalletConnectSelection($author$project$Type$TokenManagement$AwaitConfirmation)
							})),
					A2($author$project$Data$WalletConnect$startWalletConnectOptin, walletData.address, 'Points')) : _Utils_Tuple2(
					updateCurrentModel(
						_Utils_update(
							tokenManagementModel,
							{
								modal: $author$project$Type$TokenManagement$WalletConnectSelection($author$project$Type$TokenManagement$RegisteringWallet),
								walletStatus: $author$project$Type$TokenManagement$Loading
							})),
					A2(
						$elm$core$Task$attempt,
						A2(
							$elm$core$Basics$composeL,
							A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnTokenManagement),
							$author$project$Type$TokenManagement$OnWalletConnectRegisterApiResponse(walletData.address)),
						A4($author$project$Data$Api$Points$WalletRegistration$authCall, authModel.user.jwt, model.apiEndPoint.pointsWalletRegistration, walletData.address, 'Algorand')));
			case 'OnWalletConnectRegisterApiResponse':
				var address = msg.a;
				var response = msg.b;
				if (response.$ === 'Ok') {
					return _Utils_Tuple2(
						updateCurrentModel(
							_Utils_update(
								tokenManagementModel,
								{modal: $author$project$Type$TokenManagement$AllClosed, walletStatus: $author$project$Type$TokenManagement$Loaded})),
						$author$project$Model$TokenManagement$getWalletAmount(
							$elm$json$Json$Encode$string(address)));
				} else {
					return _Utils_Tuple2(
						updateCurrentModel(
							_Utils_update(
								tokenManagementModel,
								{
									walletError: $elm$core$Maybe$Just('There is an error with registering your wallet. Please try again.'),
									walletStatus: $author$project$Type$TokenManagement$Loaded
								})),
						$elm$core$Platform$Cmd$none);
				}
			case 'OnNetworkChangeSubmit':
				return _Utils_Tuple2(
					model,
					A2(
						$elm$core$Task$attempt,
						A2(
							$elm$core$Basics$composeL,
							A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnTokenManagement),
							$author$project$Type$TokenManagement$OnUpdateNotarisationNetworkResponse),
						A5(
							$author$project$Data$Api$UpdateNotarisationNetwork$authCall,
							user.jwt,
							model.apiEndPoint.updateNotarisationNetwork,
							$author$project$Model$TokenManagement$convertNetworkToString(tokenManagementModel.currentNetwork),
							$author$project$Model$TokenManagement$convertPaymentToString(tokenManagementModel.paymentMethod),
							user.notariseByDefault)));
			case 'OnAlgorandConnectClick':
				return _Utils_Tuple2(
					updateCurrentModel(
						_Utils_update(
							tokenManagementModel,
							{walletError: $elm$core$Maybe$Nothing, walletStatus: $author$project$Type$TokenManagement$Loading})),
					$author$project$Model$ViewDocument$getAlgorandWalletAddress('tokenManagement'));
			case 'OnAlgorandWalletError':
				var result = msg.a;
				var decodedMsg = function () {
					var _v34 = $author$project$Data$AlgorandWallet$decodeWalletError(result);
					if (_v34.$ === 'Ok') {
						var message = _v34.a;
						return message.error;
					} else {
						return 'Error getting wallet Addresses. Please try again.';
					}
				}();
				return _Utils_Tuple2(
					updateCurrentModel(
						_Utils_update(
							tokenManagementModel,
							{
								walletError: $elm$core$Maybe$Just(decodedMsg),
								walletStatus: $author$project$Type$TokenManagement$Loaded
							})),
					$elm$core$Platform$Cmd$none);
			case 'OnGetAlgorandWalletAddress':
				var result = msg.a;
				var _v35 = $author$project$Data$AlgorandWallet$decodeSingleWalletResult(result);
				if (_v35.$ === 'Ok') {
					var value = _v35.a;
					return _Utils_eq(tokenManagementModel.walletStatus, $author$project$Type$TokenManagement$Loading) ? _Utils_Tuple2(
						updateCurrentModel(
							_Utils_update(
								tokenManagementModel,
								{
									algorandWallet: $elm$core$Maybe$Just(value.wallet),
									walletStatus: $author$project$Type$TokenManagement$RetrievingBalance
								})),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2(
									$elm$core$Task$attempt,
									A2(
										$elm$core$Basics$composeL,
										A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnTokenManagement),
										$author$project$Type$TokenManagement$OnGetAlgorandWalletAddressResponse),
									A3($author$project$Data$Api$RegisterAlgorandWallet$authCall, authModel.user.jwt, model.apiEndPoint.registerAlgorandWallet, value.wallet)),
									$author$project$Model$TokenManagement$getWalletAmount(
									$elm$json$Json$Encode$string(value.wallet))
								]))) : _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 'OnGetAlgorandWalletAddressResponse':
				var result = msg.a;
				if (result.$ === 'Ok') {
					return _Utils_Tuple2(
						updateCurrentModel(
							_Utils_update(
								tokenManagementModel,
								{walletStatus: $author$project$Type$TokenManagement$Loaded})),
						$elm$core$Platform$Cmd$none);
				} else {
					return _Utils_Tuple2(
						updateCurrentModel(
							_Utils_update(
								tokenManagementModel,
								{
									walletError: $elm$core$Maybe$Just('There is an error with registering your wallet. Please try again.'),
									walletStatus: $author$project$Type$TokenManagement$Loaded
								})),
						$elm$core$Platform$Cmd$none);
				}
			case 'OnWalletConnectOptInCompleted':
				var result = msg.a;
				var _v37 = $author$project$Data$Wallet$decodeWalletAddress(result);
				if (_v37.$ === 'Ok') {
					var transactionDetails = _v37.a;
					return _Utils_Tuple2(
						model,
						A2(
							$elm$core$Task$attempt,
							A2(
								$elm$core$Basics$composeL,
								A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnTokenManagement),
								$author$project$Type$TokenManagement$OnWalletOptInApiResponse(transactionDetails.address)),
							A6($author$project$Data$Api$PDF$GetOptInDetails$authCall, authModel.user.jwt, model.apiEndPoint.getOptinDetails, '', transactionDetails.id, transactionDetails.block, transactionDetails.address)));
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 'OnReceiveWalletConnetAmount':
				var result = msg.a;
				var _v38 = $author$project$Data$Wallet$decodeWalletAmount(result);
				if (_v38.$ === 'Ok') {
					var amount = _v38.a;
					return _Utils_Tuple2(
						updateCurrentModel(
							_Utils_update(
								tokenManagementModel,
								{
									tokenBalance: $elm$core$Maybe$Just(amount),
									walletStatus: $author$project$Type$TokenManagement$Loaded
								})),
						$elm$core$Platform$Cmd$none);
				} else {
					return _Utils_Tuple2(
						updateCurrentModel(
							_Utils_update(
								tokenManagementModel,
								{
									tokenBalance: $elm$core$Maybe$Nothing,
									walletError: $elm$core$Maybe$Just('Error'),
									walletStatus: $author$project$Type$TokenManagement$Loaded
								})),
						$elm$core$Platform$Cmd$none);
				}
			case 'OnRestartWalletConnect':
				return _Utils_Tuple2(
					model,
					$author$project$Data$WalletConnect$walletConnectInit(
						$elm$json$Json$Encode$string('Points')));
			default:
				var address = msg.a;
				var response = msg.b;
				if (response.$ === 'Ok') {
					return _Utils_Tuple2(
						updateCurrentModel(
							_Utils_update(
								tokenManagementModel,
								{
									algorandWallet: $elm$core$Maybe$Just(address),
									modal: $author$project$Type$TokenManagement$AllClosed,
									walletStatus: $author$project$Type$TokenManagement$Loaded
								})),
						$author$project$Model$TokenManagement$getWalletAmount(
							$elm$json$Json$Encode$string(address)));
				} else {
					return _Utils_Tuple2(
						updateCurrentModel(
							_Utils_update(
								tokenManagementModel,
								{
									walletError: $elm$core$Maybe$Just('There is an error with registering your wallet. Please try again.'),
									walletStatus: $author$project$Type$TokenManagement$Loaded
								})),
						$elm$core$Platform$Cmd$none);
				}
		}
	});
var $author$project$Data$Badge$AgreeToVerify = {$: 'AgreeToVerify'};
var $author$project$Type$TrustScore$Success = {$: 'Success'};
var $author$project$Type$TrustScore$TwilioConfirmResult = function (a) {
	return {$: 'TwilioConfirmResult', a: a};
};
var $author$project$Type$TrustScore$TwilioStartResult = function (a) {
	return {$: 'TwilioStartResult', a: a};
};
var $author$project$Type$TrustScore$Verify = {$: 'Verify'};
var $author$project$Data$Api$Twilio$ConfirmVerification$Payload = function (message) {
	return {message: message};
};
var $author$project$Data$Api$Twilio$ConfirmVerification$dataDecoder = A2(
	$elm$json$Json$Decode$map,
	$author$project$Data$Api$Twilio$ConfirmVerification$Payload,
	A2($elm$json$Json$Decode$field, 'message', $elm$json$Json$Decode$string));
var $author$project$Data$Api$Twilio$ConfirmVerification$encode = function (code) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'code',
				$elm$json$Json$Encode$string(code))
			]));
};
var $author$project$Data$Api$Twilio$ConfirmVerification$VERIFICATION_FAIL = {$: 'VERIFICATION_FAIL'};
var $author$project$Data$Api$Twilio$ConfirmVerification$errorDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (errorCode) {
		if (errorCode === 'VERIFICATION_FAIL') {
			return $elm$json$Json$Decode$succeed($author$project$Data$Api$Twilio$ConfirmVerification$VERIFICATION_FAIL);
		} else {
			return $elm$json$Json$Decode$fail('Invalid error code: ' + errorCode);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Data$Api$Twilio$ConfirmVerification$authCall = F3(
	function (jwt, endPoint, code) {
		return A5(
			$author$project$Data$Api$authCall,
			jwt,
			endPoint,
			$author$project$Data$Api$Twilio$ConfirmVerification$errorDecoder,
			$author$project$Data$Api$Twilio$ConfirmVerification$dataDecoder,
			$author$project$Data$Api$Twilio$ConfirmVerification$encode(code));
	});
var $author$project$Data$Api$Twilio$StartVerification$Payload = function (message) {
	return {message: message};
};
var $author$project$Data$Api$Twilio$StartVerification$dataDecoder = A2(
	$elm$json$Json$Decode$map,
	$author$project$Data$Api$Twilio$StartVerification$Payload,
	A2($elm$json$Json$Decode$field, 'message', $elm$json$Json$Decode$string));
var $author$project$Data$Api$Twilio$StartVerification$errorDecoder = $elm$json$Json$Decode$succeed(_Utils_Tuple0);
var $author$project$Data$Api$Twilio$StartVerification$authCall = F2(
	function (jwt, endPoint) {
		return A5(
			$author$project$Data$Api$authCall,
			jwt,
			endPoint,
			$author$project$Data$Api$Twilio$StartVerification$errorDecoder,
			$author$project$Data$Api$Twilio$StartVerification$dataDecoder,
			$elm$json$Json$Encode$object(_List_Nil));
	});
var $author$project$Data$Api$Twilio$ConfirmVerification$errorToString = function (error) {
	return 'Invalid Code.';
};
var $author$project$Data$Badge$getStatus = function (badge) {
	switch (badge.$) {
		case 'MyInfo':
			var status = badge.a;
			return status;
		case 'MobilePhone':
			var status = badge.a;
			return status;
		case 'Corporate':
			var status = badge.a;
			return status;
		case 'CreditCard':
			var status = badge.a;
			return status;
		default:
			var status = badge.a;
			return status;
	}
};
var $author$project$Type$TrustScore$MyInfoEnvResult = function (a) {
	return {$: 'MyInfoEnvResult', a: a};
};
var $author$project$Data$Api$MyInfo$Env$dataDecoder = $elm$json$Json$Decode$string;
var $author$project$Data$Api$MyInfo$Env$errorDecoder = $elm$json$Json$Decode$succeed(_Utils_Tuple0);
var $author$project$Data$Api$MyInfo$Env$authCall = F2(
	function (jwt, endPoint) {
		return A5(
			$author$project$Data$Api$authCall,
			jwt,
			endPoint,
			$author$project$Data$Api$MyInfo$Env$errorDecoder,
			$author$project$Data$Api$MyInfo$Env$dataDecoder,
			$elm$json$Json$Encode$object(_List_Nil));
	});
var $author$project$Model$TrustScore$myInfoEnvCmd = F2(
	function (endPoint, jwt) {
		return A2(
			$elm$core$Task$attempt,
			A2(
				$elm$core$Basics$composeL,
				A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnTrustScore),
				$author$project$Type$TrustScore$MyInfoEnvResult),
			A2($author$project$Data$Api$MyInfo$Env$authCall, jwt, endPoint));
	});
var $author$project$Model$TrustScore$update = F3(
	function (msg, authModel, model) {
		var updateCurrentModel = function (currentModel) {
			return _Utils_update(
				model,
				{
					sessionModel: $author$project$Types$Auth(
						_Utils_update(
							authModel,
							{trustScoreModel: currentModel}))
				});
		};
		var _v0 = authModel;
		var trustScoreModel = _v0.trustScoreModel;
		var user = _v0.user;
		var _v1 = model.apiEndPoint;
		var myInfoEnv = _v1.myInfoEnv;
		var twilioStart = _v1.twilioStart;
		var twilioConfirm = _v1.twilioConfirm;
		switch (msg.$) {
			case 'VerifyClick':
				var badge = msg.a;
				switch (badge.$) {
					case 'MyInfo':
						return _Utils_Tuple2(
							model,
							A2($author$project$Model$TrustScore$myInfoEnvCmd, myInfoEnv, user.jwt));
					case 'MobilePhone':
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					case 'Corporate':
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					case 'CreditCard':
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					default:
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 'MyInfoEnvResult':
				var result = msg.a;
				if (result.$ === 'Err') {
					return _Utils_Tuple2(
						updateCurrentModel(
							_Utils_update(
								trustScoreModel,
								{
									error: $elm$core$Maybe$Just('Unable to get MyInfo data.')
								})),
						$elm$core$Platform$Cmd$none);
				} else {
					var myInfoEnvUrl = result.a;
					return _Utils_Tuple2(
						model,
						$elm$browser$Browser$Navigation$load(myInfoEnvUrl));
				}
			case 'AcceptTerms':
				var badge = msg.a;
				var _v5 = _Utils_Tuple2(
					badge,
					$author$project$Data$Badge$getStatus(badge));
				switch (_v5.b.$) {
					case 'Verified':
						var _v6 = _v5.b;
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					case 'AgreeToVerify':
						var _v7 = _v5.b;
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					default:
						switch (_v5.a.$) {
							case 'MyInfo':
								var _v8 = _v5.b;
								return _Utils_Tuple2(
									updateCurrentModel(
										_Utils_update(
											trustScoreModel,
											{
												myInfo: $author$project$Data$Badge$MyInfo($author$project$Data$Badge$AgreeToVerify)
											})),
									$elm$core$Platform$Cmd$none);
							case 'MobilePhone':
								var _v9 = _v5.b;
								return _Utils_Tuple2(
									updateCurrentModel(
										_Utils_update(
											trustScoreModel,
											{
												mobilePhone: $author$project$Data$Badge$MobilePhone($author$project$Data$Badge$AgreeToVerify)
											})),
									$elm$core$Platform$Cmd$none);
							case 'Corporate':
								var _v10 = _v5.b;
								return _Utils_Tuple2(
									updateCurrentModel(
										_Utils_update(
											trustScoreModel,
											{
												corporate: $author$project$Data$Badge$Corporate($author$project$Data$Badge$AgreeToVerify)
											})),
									$elm$core$Platform$Cmd$none);
							case 'CreditCard':
								var _v11 = _v5.b;
								return _Utils_Tuple2(
									updateCurrentModel(
										_Utils_update(
											trustScoreModel,
											{
												creditCard: $author$project$Data$Badge$CreditCard($author$project$Data$Badge$AgreeToVerify)
											})),
									$elm$core$Platform$Cmd$none);
							default:
								var _v12 = _v5.b;
								return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
						}
				}
			case 'DeclineTerms':
				var badge = msg.a;
				var _v13 = _Utils_Tuple2(
					badge,
					$author$project$Data$Badge$getStatus(badge));
				switch (_v13.b.$) {
					case 'Verified':
						var _v14 = _v13.b;
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					case 'NotVerified':
						var _v15 = _v13.b;
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					default:
						switch (_v13.a.$) {
							case 'MyInfo':
								var _v16 = _v13.b;
								return _Utils_Tuple2(
									updateCurrentModel(
										_Utils_update(
											trustScoreModel,
											{
												myInfo: $author$project$Data$Badge$MyInfo($author$project$Data$Badge$NotVerified)
											})),
									$elm$core$Platform$Cmd$none);
							case 'MobilePhone':
								var _v17 = _v13.b;
								return _Utils_Tuple2(
									updateCurrentModel(
										_Utils_update(
											trustScoreModel,
											{
												mobilePhone: $author$project$Data$Badge$MobilePhone($author$project$Data$Badge$NotVerified)
											})),
									$elm$core$Platform$Cmd$none);
							case 'Corporate':
								var _v18 = _v13.b;
								return _Utils_Tuple2(
									updateCurrentModel(
										_Utils_update(
											trustScoreModel,
											{
												corporate: $author$project$Data$Badge$Corporate($author$project$Data$Badge$NotVerified)
											})),
									$elm$core$Platform$Cmd$none);
							case 'CreditCard':
								var _v19 = _v13.b;
								return _Utils_Tuple2(
									updateCurrentModel(
										_Utils_update(
											trustScoreModel,
											{
												creditCard: $author$project$Data$Badge$CreditCard($author$project$Data$Badge$NotVerified)
											})),
									$elm$core$Platform$Cmd$none);
							default:
								var _v20 = _v13.b;
								return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
						}
				}
			case 'MobileModal':
				var status = msg.a;
				switch (status.$) {
					case 'Open':
						return _Utils_Tuple2(
							updateCurrentModel(
								_Utils_update(
									trustScoreModel,
									{modal: status})),
							A2(
								$elm$core$Task$attempt,
								A2(
									$elm$core$Basics$composeL,
									A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnTrustScore),
									$author$project$Type$TrustScore$TwilioStartResult),
								A2($author$project$Data$Api$Twilio$StartVerification$authCall, user.jwt, twilioStart)));
					case 'PendingVerify':
						return _Utils_Tuple2(
							updateCurrentModel(
								_Utils_update(
									trustScoreModel,
									{modal: status})),
							A2(
								$elm$core$Task$attempt,
								A2(
									$elm$core$Basics$composeL,
									A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnTrustScore),
									$author$project$Type$TrustScore$TwilioConfirmResult),
								A3($author$project$Data$Api$Twilio$ConfirmVerification$authCall, user.jwt, twilioConfirm, trustScoreModel.verifyCode)));
					default:
						return _Utils_Tuple2(
							updateCurrentModel(
								_Utils_update(
									trustScoreModel,
									{modal: status})),
							$elm$core$Platform$Cmd$none);
				}
			case 'TwilioStartResult':
				var result = msg.a;
				if (result.$ === 'Ok') {
					return _Utils_Tuple2(
						updateCurrentModel(
							_Utils_update(
								trustScoreModel,
								{modal: $author$project$Type$TrustScore$Verify})),
						$elm$core$Platform$Cmd$none);
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 'OnVerifyCodeInput':
				var code = msg.a;
				return _Utils_Tuple2(
					updateCurrentModel(
						_Utils_update(
							trustScoreModel,
							{verifyCode: code})),
					$elm$core$Platform$Cmd$none);
			case 'TwilioConfirmResult':
				var result = msg.a;
				if (result.$ === 'Ok') {
					return _Utils_Tuple2(
						updateCurrentModel(
							_Utils_update(
								trustScoreModel,
								{
									mobilePhone: $author$project$Data$Badge$MobilePhone($author$project$Data$Badge$Verified),
									modal: $author$project$Type$TrustScore$Success
								})),
						$elm$core$Platform$Cmd$none);
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						updateCurrentModel(
							_Utils_update(
								trustScoreModel,
								{
									modal: $author$project$Type$TrustScore$Verify,
									twilioError: $elm$core$Maybe$Just(
										A2($author$project$Data$Api$authErrorToString, $author$project$Data$Api$Twilio$ConfirmVerification$errorToString, error))
								})),
						$elm$core$Platform$Cmd$none);
				}
			case 'RedirectTo':
				var location = msg.a;
				switch (location.$) {
					case 'Account':
						return _Utils_Tuple2(
							model,
							A2($elm$browser$Browser$Navigation$pushUrl, model.navKey, $author$project$Data$Route$routeUrl.setting));
					case 'PointsManagement':
						return _Utils_Tuple2(
							model,
							A2($elm$browser$Browser$Navigation$pushUrl, model.navKey, $author$project$Data$Route$routeUrl.tokenManagement));
					default:
						return _Utils_Tuple2(
							updateCurrentModel(
								_Utils_update(
									trustScoreModel,
									{passbaseModal: false})),
							A2($elm$browser$Browser$Navigation$pushUrl, model.navKey, $author$project$Data$Route$routeUrl.dashboard));
				}
			default:
				var _v25 = user.trustScore;
				var myInfo = _v25.myInfo;
				var corporate = _v25.corporate;
				var stripe = _v25.stripe;
				var mobilePhone = _v25.mobilePhone;
				var wallet = _v25.wallet;
				return _Utils_Tuple2(
					updateCurrentModel(
						_Utils_update(
							trustScoreModel,
							{
								corporate: $author$project$Data$Badge$Corporate(
									$author$project$Model$TrustScore$getStatus(corporate)),
								creditCard: $author$project$Data$Badge$CreditCard(
									$author$project$Model$TrustScore$getStatus(stripe)),
								error: $elm$core$Maybe$Nothing,
								mobilePhone: $author$project$Data$Badge$MobilePhone(
									$author$project$Model$TrustScore$getStatus(mobilePhone)),
								modal: $author$project$Type$TrustScore$Close,
								myInfo: $author$project$Data$Badge$MyInfo(
									$author$project$Model$TrustScore$getStatus(myInfo)),
								twilioError: $elm$core$Maybe$Nothing,
								verifyCode: '',
								wallet: $author$project$Data$Badge$Wallet(
									$author$project$Model$TrustScore$getStatus(wallet))
							})),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Type$UploadMultipleDocument$Annotations = {$: 'Annotations'};
var $author$project$Type$UploadMultipleDocument$CancelNotarisation = {$: 'CancelNotarisation'};
var $author$project$Type$UploadMultipleDocument$CancelNotarisationSuccess = {$: 'CancelNotarisationSuccess'};
var $author$project$Type$UploadMultipleDocument$CheckWalletOptIn = {$: 'CheckWalletOptIn'};
var $author$project$Type$UploadMultipleDocument$Completed = {$: 'Completed'};
var $author$project$Type$UploadMultipleDocument$ConfirmCheckboxNotification = F2(
	function (a, b) {
		return {$: 'ConfirmCheckboxNotification', a: a, b: b};
	});
var $author$project$Type$UploadMultipleDocument$ConfirmTextAnnotTitle = F2(
	function (a, b) {
		return {$: 'ConfirmTextAnnotTitle', a: a, b: b};
	});
var $author$project$Type$UploadMultipleDocument$ConversionError = {$: 'ConversionError'};
var $author$project$Type$UploadMultipleDocument$DisplayWallet = function (a) {
	return {$: 'DisplayWallet', a: a};
};
var $author$project$Type$UploadMultipleDocument$DisplayWalletAddress = function (a) {
	return {$: 'DisplayWalletAddress', a: a};
};
var $author$project$Type$UploadMultipleDocument$DoNotSave = {$: 'DoNotSave'};
var $author$project$Data$PDF$Annotation$EditableText = function (a) {
	return {$: 'EditableText', a: a};
};
var $author$project$Type$UploadMultipleDocument$Editing = {$: 'Editing'};
var $author$project$Type$UploadMultipleDocument$Enter = {$: 'Enter'};
var $author$project$Type$UploadMultipleDocument$Error = function (a) {
	return {$: 'Error', a: a};
};
var $author$project$Type$UploadMultipleDocument$Failed = function (a) {
	return {$: 'Failed', a: a};
};
var $author$project$Type$UploadMultipleDocument$GetWallet = {$: 'GetWallet'};
var $author$project$Type$UploadMultipleDocument$MakePayment = {$: 'MakePayment'};
var $author$project$Type$UploadMultipleDocument$NeedPassword = {$: 'NeedPassword'};
var $author$project$Data$PDF$Annotation$NonEditableText = function (a) {
	return {$: 'NonEditableText', a: a};
};
var $author$project$Type$UploadMultipleDocument$NotariseSuccess = function (a) {
	return {$: 'NotariseSuccess', a: a};
};
var $author$project$Type$UploadMultipleDocument$Notarize = {$: 'Notarize'};
var $author$project$Type$UploadMultipleDocument$NotarizeDocument = {$: 'NotarizeDocument'};
var $author$project$Type$UploadMultipleDocument$NotarizingDocument = function (a) {
	return {$: 'NotarizingDocument', a: a};
};
var $author$project$Type$UploadMultipleDocument$Notified = {$: 'Notified'};
var $author$project$Type$UploadMultipleDocument$OnCancelNotarisationResponse = function (a) {
	return {$: 'OnCancelNotarisationResponse', a: a};
};
var $author$project$Type$UploadMultipleDocument$OnCancelNotarisationResult = function (a) {
	return {$: 'OnCancelNotarisationResult', a: a};
};
var $author$project$Type$UploadMultipleDocument$OnDashboardApiResponse = function (a) {
	return {$: 'OnDashboardApiResponse', a: a};
};
var $author$project$Type$UploadMultipleDocument$OnDocSubmitUploadResult = F2(
	function (a, b) {
		return {$: 'OnDocSubmitUploadResult', a: a, b: b};
	});
var $author$project$Type$UploadMultipleDocument$OnGetNotarisationDetailsResult = function (a) {
	return {$: 'OnGetNotarisationDetailsResult', a: a};
};
var $author$project$Type$UploadMultipleDocument$OnGetOptInDetailsResult = function (a) {
	return {$: 'OnGetOptInDetailsResult', a: a};
};
var $author$project$Type$UploadMultipleDocument$OnNotarizationStartClick = function (a) {
	return {$: 'OnNotarizationStartClick', a: a};
};
var $author$project$Type$UploadMultipleDocument$OnSearchApiResult = function (a) {
	return {$: 'OnSearchApiResult', a: a};
};
var $author$project$Type$UploadMultipleDocument$OnSignatureTimestampingAlgorand = F2(
	function (a, b) {
		return {$: 'OnSignatureTimestampingAlgorand', a: a, b: b};
	});
var $author$project$Type$UploadMultipleDocument$OnSignatureTimestampingAlgorandResult = function (a) {
	return {$: 'OnSignatureTimestampingAlgorandResult', a: a};
};
var $author$project$Type$UploadMultipleDocument$OnWalletConnectOptInResponse = function (a) {
	return {$: 'OnWalletConnectOptInResponse', a: a};
};
var $author$project$Type$UploadMultipleDocument$OnWalletConnectRegisterApiResponse = function (a) {
	return {$: 'OnWalletConnectRegisterApiResponse', a: a};
};
var $author$project$Type$UploadMultipleDocument$OptIn = {$: 'OptIn'};
var $author$project$Type$UploadMultipleDocument$Options = {$: 'Options'};
var $author$project$Type$UploadMultipleDocument$Passcode = {$: 'Passcode'};
var $author$project$Type$UploadMultipleDocument$Payment = {$: 'Payment'};
var $author$project$Type$UploadMultipleDocument$Processing = {$: 'Processing'};
var $author$project$Type$UploadMultipleDocument$Ready = {$: 'Ready'};
var $author$project$Type$UploadMultipleDocument$RegisterWallet = {$: 'RegisterWallet'};
var $author$project$Type$UploadMultipleDocument$RotationAlert = {$: 'RotationAlert'};
var $author$project$Type$UploadMultipleDocument$SetDateToAnnot = function (a) {
	return {$: 'SetDateToAnnot', a: a};
};
var $author$project$Type$UploadMultipleDocument$SigningOrder = {$: 'SigningOrder'};
var $author$project$Type$UploadMultipleDocument$Success = F4(
	function (a, b, c, d) {
		return {$: 'Success', a: a, b: b, c: c, d: d};
	});
var $author$project$Data$PDF$User$UnRegistered = function (a) {
	return {$: 'UnRegistered', a: a};
};
var $author$project$Type$UploadMultipleDocument$UneditablePDF = {$: 'UneditablePDF'};
var $author$project$Type$UploadMultipleDocument$Uploading = {$: 'Uploading'};
var $author$project$Data$PDF$User$emailFromUser = function (user) {
	return $author$project$Data$PDF$User$userInfo(user).email;
};
var $author$project$Data$PDF$Create$addRecipientAnnotation = F3(
	function (_v0, recipientDict, signOrder) {
		var annotation = _v0.annotation;
		var user = _v0.user;
		return A3(
			$elm$core$Dict$update,
			$author$project$Data$PDF$User$emailFromUser(user),
			function (r) {
				if (r.$ === 'Just') {
					var recipient = r.a;
					return $elm$core$Maybe$Just(
						_Utils_update(
							recipient,
							{
								annotations: A2($elm$core$List$cons, annotation, recipient.annotations),
								role: $author$project$Data$PDF$Create$Signer,
								signOrder: signOrder
							}));
				} else {
					return $elm$core$Maybe$Just(
						{
							annotations: _List_fromArray(
								[annotation]),
							role: $author$project$Data$PDF$Create$Signer,
							signOrder: 0,
							user: user
						});
				}
			},
			recipientDict);
	});
var $author$project$Data$PDF$Create$toUpdateAnnotList = function (_v0) {
	var recipients = _v0.a.recipients;
	var owner = _v0.a.owner;
	var mapToData = F2(
		function (user, annotation) {
			return {annotation: annotation, user: user};
		});
	return A2(
		$elm$core$List$concatMap,
		function (r) {
			return A2(
				$elm$core$List$map,
				mapToData(r.user),
				r.annotations);
		},
		A2(
			$elm$core$List$cons,
			owner,
			$elm$core$Dict$values(recipients)));
};
var $author$project$Data$PDF$Annotation$IsSignature = function (a) {
	return {$: 'IsSignature', a: a};
};
var $author$project$Data$PDF$Annotation$getSignedSignature = function (annot) {
	switch (annot.$) {
		case 'IsSignature':
			var sig = annot.a.a;
			var _v1 = sig.status;
			if (_v1.$ === 'Signed') {
				var dataSig = _v1.a;
				return $elm$core$Maybe$Just(dataSig);
			} else {
				return $elm$core$Maybe$Nothing;
			}
		case 'Name':
			return $elm$core$Maybe$Nothing;
		case 'Date':
			return $elm$core$Maybe$Nothing;
		case 'EditableText':
			return $elm$core$Maybe$Nothing;
		case 'NonEditableText':
			return $elm$core$Maybe$Nothing;
		case 'IsStamp':
			return $elm$core$Maybe$Nothing;
		case 'IsEmail':
			return $elm$core$Maybe$Nothing;
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Data$PDF$Annotation$updateSignedSigsWithSelectedSignedSig = F2(
	function (selectedAnnot, annotList) {
		var _v0 = $author$project$Data$PDF$Annotation$getSignedSignature(selectedAnnot);
		if (_v0.$ === 'Just') {
			var selectedDataSignature = _v0.a;
			return A2(
				$elm$core$List$map,
				function (annot) {
					if (annot.$ === 'IsSignature') {
						var signature = annot.a.a;
						var _v2 = signature.status;
						if (_v2.$ === 'Signed') {
							return $author$project$Data$PDF$Annotation$IsSignature(
								A2(
									$author$project$Data$PDF$Annotation$updatedSignedSignature,
									selectedDataSignature,
									$author$project$Data$PDF$Annotation$Signature(signature)));
						} else {
							return annot;
						}
					} else {
						return annot;
					}
				},
				annotList);
		} else {
			return annotList;
		}
	});
var $author$project$Data$PDF$Annotation$IsStamp = function (a) {
	return {$: 'IsStamp', a: a};
};
var $author$project$Data$PDF$Stamp$data = function (_v0) {
	var stamp = _v0.a;
	return stamp.data;
};
var $author$project$Data$PDF$Annotation$stampContent = function (_v0) {
	var stamp = _v0.a;
	var _v1 = stamp.status;
	if (_v1.$ === 'Stamped') {
		var stamp_ = _v1.a;
		var _v2 = $author$project$Data$PDF$Stamp$data(stamp_);
		if (_v2.$ === 'NotLoaded') {
			return '...';
		} else {
			var data = _v2.a;
			return data;
		}
	} else {
		return '';
	}
};
var $author$project$Data$PDF$Annotation$updateStampsWithSelectedStamp = F2(
	function (selectedAnnot, annotList) {
		if (selectedAnnot.$ === 'IsStamp') {
			var stamp = selectedAnnot.a.a;
			var _v1 = stamp.status;
			if (_v1.$ === 'Unstamped') {
				return annotList;
			} else {
				var selectedStamp = _v1.a;
				return A2(
					$elm$core$List$map,
					function (annot) {
						if (annot.$ === 'IsStamp') {
							var otherStamp = annot.a.a;
							var _v3 = otherStamp.status;
							if (_v3.$ === 'Stamped') {
								return $author$project$Data$PDF$Annotation$IsStamp(
									$author$project$Data$PDF$Annotation$Stamp(
										_Utils_update(
											otherStamp,
											{
												id: A3(
													$author$project$Data$PDF$Annotation$generateId,
													$author$project$Data$PDF$Annotation$stampContent(
														$author$project$Data$PDF$Annotation$Stamp(stamp)),
													$author$project$Data$PDF$Annotation$toStampStatusString(otherStamp.status),
													otherStamp.style),
												status: $author$project$Data$PDF$Annotation$Stamped(selectedStamp)
											})));
							} else {
								return annot;
							}
						} else {
							return annot;
						}
					},
					annotList);
			}
		} else {
			return annotList;
		}
	});
var $author$project$Data$PDF$Annotation$getStyle = function (annotation) {
	switch (annotation.$) {
		case 'Name':
			var style = annotation.a.a.style;
			return style;
		case 'Date':
			var style = annotation.a.a.style;
			return style;
		case 'EditableText':
			var style = annotation.a.a.style;
			return style;
		case 'NonEditableText':
			var style = annotation.a.a.style;
			return style;
		case 'IsSignature':
			var style = annotation.a.a.style;
			return style;
		case 'IsStamp':
			var style = annotation.a.a.style;
			return style;
		case 'IsEmail':
			var style = annotation.a.a.style;
			return style;
		default:
			var style = annotation.a.a.style;
			return style;
	}
};
var $author$project$Data$PDF$Annotation$Date = function (a) {
	return {$: 'Date', a: a};
};
var $author$project$Data$PDF$Annotation$IsCheckbox = function (a) {
	return {$: 'IsCheckbox', a: a};
};
var $author$project$Data$PDF$Annotation$IsEmail = function (a) {
	return {$: 'IsEmail', a: a};
};
var $author$project$Data$PDF$Annotation$Name = function (a) {
	return {$: 'Name', a: a};
};
var $author$project$Data$PDF$Annotation$updateStyleAndId = F2(
	function (style, annot) {
		var updatedTxt = function (txt) {
			return $author$project$Data$PDF$Annotation$Txt(
				_Utils_update(
					txt,
					{
						id: A3(
							$author$project$Data$PDF$Annotation$generateId,
							txt.text,
							$author$project$Data$PDF$Annotation$toStatusString(txt.status),
							style),
						style: style
					}));
		};
		var updatedDateTxt = function (dateTxt_) {
			return $author$project$Data$PDF$Annotation$DateTxt(
				_Utils_update(
					dateTxt_,
					{
						id: A3(
							$author$project$Data$PDF$Annotation$generateId,
							$author$project$Data$PDF$Annotation$toStringPosix(dateTxt_.date),
							$author$project$Data$PDF$Annotation$toStatusString(dateTxt_.status),
							style),
						style: style
					}));
		};
		var updatedCheckbox = function (checkbox) {
			return $author$project$Data$PDF$Annotation$Checkbox(
				_Utils_update(
					checkbox,
					{
						id: A3(
							$author$project$Data$PDF$Annotation$generateId,
							$author$project$Data$PDF$Annotation$toCheckBoxStatusString(checkbox.status),
							$author$project$Data$PDF$Annotation$toCheckBoxStatusString(checkbox.status),
							style),
						style: style
					}));
		};
		switch (annot.$) {
			case 'Name':
				var txt = annot.a.a;
				return $author$project$Data$PDF$Annotation$Name(
					updatedTxt(txt));
			case 'Date':
				var dateTxt_ = annot.a.a;
				return $author$project$Data$PDF$Annotation$Date(
					updatedDateTxt(dateTxt_));
			case 'EditableText':
				var txt = annot.a.a;
				return $author$project$Data$PDF$Annotation$EditableText(
					updatedTxt(txt));
			case 'NonEditableText':
				var txt = annot.a.a;
				return $author$project$Data$PDF$Annotation$NonEditableText(
					updatedTxt(txt));
			case 'IsSignature':
				var signature = annot.a.a;
				return $author$project$Data$PDF$Annotation$IsSignature(
					$author$project$Data$PDF$Annotation$Signature(
						_Utils_update(
							signature,
							{
								id: A3(
									$author$project$Data$PDF$Annotation$generateId,
									'',
									$author$project$Data$PDF$Annotation$toSignatureStatusString(signature.status),
									style),
								style: style
							})));
			case 'IsStamp':
				var stamp = annot.a.a;
				return $author$project$Data$PDF$Annotation$IsStamp(
					$author$project$Data$PDF$Annotation$Stamp(
						_Utils_update(
							stamp,
							{
								id: A3(
									$author$project$Data$PDF$Annotation$generateId,
									'',
									$author$project$Data$PDF$Annotation$toStampStatusString(stamp.status),
									style),
								style: style
							})));
			case 'IsEmail':
				var txt = annot.a.a;
				return $author$project$Data$PDF$Annotation$IsEmail(
					updatedTxt(txt));
			default:
				var checkbox = annot.a.a;
				return $author$project$Data$PDF$Annotation$IsCheckbox(
					updatedCheckbox(checkbox));
		}
	});
var $author$project$Data$PDF$Annotation$updateStyleWithPosition = F2(
	function (_v0, annotation) {
		var x = _v0.x;
		var y = _v0.y;
		var page = _v0.page;
		var style = $author$project$Data$PDF$Annotation$getStyle(annotation);
		return A2(
			$author$project$Data$PDF$Annotation$updateStyleAndId,
			{fontSize: style.fontSize, height: style.height, page: page, width: style.width, x: x, y: y},
			annotation);
	});
var $author$project$Data$PDF$Annotation$isVerifiedAnnot = function (annot) {
	var isTxtVerified = function (txt) {
		var _v3 = txt.status;
		if (_v3.$ === 'Verified') {
			return true;
		} else {
			return false;
		}
	};
	switch (annot.$) {
		case 'Name':
			var txt = annot.a.a;
			return isTxtVerified(txt);
		case 'Date':
			var dateTxt_ = annot.a.a;
			return isTxtVerified(dateTxt_);
		case 'EditableText':
			var txt = annot.a.a;
			return isTxtVerified(txt);
		case 'NonEditableText':
			var txt = annot.a.a;
			return isTxtVerified(txt);
		case 'IsSignature':
			var signature = annot.a.a;
			var _v1 = signature.status;
			if (_v1.$ === 'Signed') {
				return true;
			} else {
				return false;
			}
		case 'IsStamp':
			var signature = annot.a.a;
			var _v2 = signature.status;
			if (_v2.$ === 'Stamped') {
				return true;
			} else {
				return false;
			}
		case 'IsEmail':
			var txt = annot.a.a;
			return isTxtVerified(txt);
		default:
			return true;
	}
};
var $author$project$Data$PDF$User$annotBgColor = F2(
	function (annot, user) {
		var checkIfCheckbox = function (a) {
			if (a.$ === 'IsCheckbox') {
				return true;
			} else {
				return false;
			}
		};
		if ($author$project$Data$PDF$Annotation$isVerifiedAnnot(annot) && (!checkIfCheckbox(annot))) {
			return $author$project$Data$PDF$User$materialColorRGB($author$project$Data$PDF$User$Transparent);
		} else {
			var color = $author$project$Data$PDF$User$userInfo(user).color;
			return $author$project$Data$PDF$User$materialColorRGB(color);
		}
	});
var $author$project$Data$PDF$Annotation$PlaceHolder = {$: 'PlaceHolder'};
var $author$project$Data$PDF$Annotation$checkboxStatus = function (_v0) {
	var checkbox = _v0.a;
	return checkbox.status;
};
var $author$project$Data$PDF$Port$encodeStampedStamp = F4(
	function (id, dbId, imageData, style) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'id',
					$elm$json$Json$Encode$string(id)),
					_Utils_Tuple2(
					'dbId',
					$elm$json$Json$Encode$string(dbId)),
					_Utils_Tuple2(
					'imageData',
					$elm$json$Json$Encode$string(imageData)),
					_Utils_Tuple2(
					'style',
					$author$project$Data$PDF$Port$encodeStyle(style))
				]));
	});
var $author$project$Data$PDF$Annotation$stampFields = function (_v0) {
	var stamp = _v0.a;
	return _Utils_Tuple3(stamp.id, stamp.status, stamp.style);
};
var $author$project$Data$PDF$Annotation$unstampedTxtStamp = F2(
	function (stampID, style) {
		return $author$project$Data$PDF$Annotation$Txt(
			{dbId: stampID, id: stampID, status: $author$project$Data$PDF$Annotation$Unverified, style: style, text: 'Stamp'});
	});
var $author$project$Data$PDF$Port$encodeDocumentAnnotation = F2(
	function (bgRGBA, annot) {
		switch (annot.$) {
			case 'Name':
				var txt = annot.a;
				return $elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'kind',
							$elm$json$Json$Encode$string('Name')),
							_Utils_Tuple2(
							'data',
							A3(
								$author$project$Data$PDF$Port$encodeFreeText,
								bgRGBA,
								$author$project$Data$PDF$Annotation$txtText(txt),
								txt))
						]));
			case 'Date':
				var dateTxt = annot.a;
				var content = $author$project$Data$PDF$Annotation$isVerifiedAnnot(annot) ? $elm$core$String$fromInt(
					$elm$time$Time$posixToMillis(
						$author$project$Data$PDF$Annotation$dateTxtDate(dateTxt))) : 'Date';
				return $elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'kind',
							$elm$json$Json$Encode$string('Date')),
							_Utils_Tuple2(
							'data',
							A3($author$project$Data$PDF$Port$encodeDateText, bgRGBA, content, dateTxt))
						]));
			case 'EditableText':
				var txt = annot.a;
				return $elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'kind',
							$elm$json$Json$Encode$string('EditableText')),
							_Utils_Tuple2(
							'data',
							A3(
								$author$project$Data$PDF$Port$encodeFreeText,
								bgRGBA,
								$author$project$Data$PDF$Annotation$txtText(txt),
								txt))
						]));
			case 'NonEditableText':
				var txt = annot.a;
				return $elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'kind',
							$elm$json$Json$Encode$string('NonEditableText')),
							_Utils_Tuple2(
							'data',
							A3(
								$author$project$Data$PDF$Port$encodeFreeText,
								bgRGBA,
								$author$project$Data$PDF$Annotation$txtText(txt),
								txt))
						]));
			case 'IsSignature':
				var signature = annot.a;
				var _v1 = $author$project$Data$PDF$Annotation$signatureFields(signature);
				var id = _v1.a;
				var status = _v1.b;
				var style = _v1.c;
				if (status.$ === 'Unsigned') {
					var unsignedTxt = A2($author$project$Data$PDF$Annotation$unsignedTxtSignature, id, style);
					return $elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'kind',
								$elm$json$Json$Encode$string('UnsignedSignature')),
								_Utils_Tuple2(
								'data',
								A3(
									$author$project$Data$PDF$Port$encodeFreeText,
									bgRGBA,
									$author$project$Data$PDF$Annotation$txtText(unsignedTxt),
									unsignedTxt))
							]));
				} else {
					var sig = status.a;
					return $elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'kind',
								$elm$json$Json$Encode$string('SignedSignature')),
								_Utils_Tuple2(
								'data',
								A4(
									$author$project$Data$PDF$Port$encodeSignedSignature,
									id,
									$author$project$Data$PDF$Signature$id(sig),
									$author$project$Data$PDF$Signature$data(sig),
									style))
							]));
				}
			case 'IsStamp':
				var stamp = annot.a;
				var _v3 = $author$project$Data$PDF$Annotation$stampFields(stamp);
				var id = _v3.a;
				var status = _v3.b;
				var style = _v3.c;
				if (status.$ === 'Unstamped') {
					var unstampedTxt = A2($author$project$Data$PDF$Annotation$unstampedTxtStamp, id, style);
					return $elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'kind',
								$elm$json$Json$Encode$string('UnstampedStamp')),
								_Utils_Tuple2(
								'data',
								A3(
									$author$project$Data$PDF$Port$encodeFreeText,
									bgRGBA,
									$author$project$Data$PDF$Annotation$txtText(unstampedTxt),
									unstampedTxt))
							]));
				} else {
					var stamp_ = status.a;
					var _v5 = $author$project$Data$PDF$Stamp$data(stamp_);
					if (_v5.$ === 'NotLoaded') {
						return $elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'kind',
									$elm$json$Json$Encode$string('StampedStamp')),
									_Utils_Tuple2(
									'data',
									A4(
										$author$project$Data$PDF$Port$encodeStampedStamp,
										id,
										$author$project$Data$PDF$Stamp$id(stamp_),
										'',
										style))
								]));
					} else {
						var data = _v5.a;
						return $elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'kind',
									$elm$json$Json$Encode$string('StampedStamp')),
									_Utils_Tuple2(
									'data',
									A4(
										$author$project$Data$PDF$Port$encodeStampedStamp,
										id,
										$author$project$Data$PDF$Stamp$id(stamp_),
										data,
										style))
								]));
					}
				}
			case 'IsEmail':
				var txt = annot.a;
				return $elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'kind',
							$elm$json$Json$Encode$string('Email')),
							_Utils_Tuple2(
							'data',
							A3(
								$author$project$Data$PDF$Port$encodeFreeText,
								bgRGBA,
								$author$project$Data$PDF$Annotation$txtText(txt),
								txt))
						]));
			default:
				var checkbox = annot.a;
				var checkboxKind = _Utils_eq(
					$author$project$Data$PDF$Annotation$checkboxStatus(checkbox),
					$author$project$Data$PDF$Annotation$PlaceHolder) ? 'PlaceHolderCheckbox' : 'Checkbox';
				return $elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'kind',
							$elm$json$Json$Encode$string(checkboxKind)),
							_Utils_Tuple2(
							'data',
							A3(
								$author$project$Data$PDF$Port$encodeCheckBox,
								bgRGBA,
								$author$project$Data$PDF$Annotation$toCheckBoxStatusString(
									$author$project$Data$PDF$Annotation$checkboxStatus(checkbox)),
								checkbox))
						]));
		}
	});
var $author$project$Data$PDF$Port$encodeOneDocumentData = function (_v0) {
	var user = _v0.user;
	var annotation = _v0.annotation;
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'user',
				$author$project$Data$PDF$Port$encodePDFUser(user)),
				_Utils_Tuple2(
				'annotation',
				A2(
					$author$project$Data$PDF$Port$encodeDocumentAnnotation,
					A2($author$project$Data$PDF$User$annotBgColor, annotation, user),
					annotation))
			]));
};
var $author$project$Data$PDF$Port$encodeDocumentData = F4(
	function (data, documentStatus, base64Data, pagesWithDeletedAnnot) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'dataList',
					A2($elm$json$Json$Encode$list, $author$project$Data$PDF$Port$encodeOneDocumentData, data)),
					_Utils_Tuple2(
					'status',
					$elm$json$Json$Encode$string(documentStatus)),
					_Utils_Tuple2(
					'base64Data',
					$elm$json$Json$Encode$string(base64Data)),
					_Utils_Tuple2(
					'pagesWithDeletedAnnot',
					A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$int, pagesWithDeletedAnnot))
				]));
	});
var $author$project$Data$PDF$Port$updateDocument = _Platform_outgoingPort('updateDocument', $elm$core$Basics$identity);
var $author$project$Data$PDF$Port$updateView = F4(
	function (dataList, documentStatus, base64Data, pagesWithDeletedAnnot) {
		return $author$project$Data$PDF$Port$updateDocument(
			A4($author$project$Data$PDF$Port$encodeDocumentData, dataList, documentStatus, base64Data, pagesWithDeletedAnnot));
	});
var $author$project$Data$PDF$Create$addAnnotation = F4(
	function (value, _v0, _v1, signOrder) {
		var annotation = _v0.annotation;
		var user = _v0.user;
		var pdf = _v1.a;
		var _v2 = $author$project$Data$PDF$Port$decodePosition(value);
		if (_v2.$ === 'Ok') {
			var position = _v2.a;
			var updatedAnnotation = A2($author$project$Data$PDF$Annotation$updateStyleWithPosition, position, annotation);
			var _v3 = pdf;
			var recipients = _v3.recipients;
			var owner = _v3.owner;
			var updatedOwnerAnnots = A2(
				$author$project$Data$PDF$Annotation$updateStampsWithSelectedStamp,
				updatedAnnotation,
				A2($author$project$Data$PDF$Annotation$updateSignedSigsWithSelectedSignedSig, updatedAnnotation, owner.annotations));
			var updatedOwnerPDF = $author$project$Data$PDF$Create$PDF(
				_Utils_update(
					pdf,
					{
						owner: _Utils_update(
							owner,
							{
								annotations: A2($elm$core$List$cons, updatedAnnotation, updatedOwnerAnnots),
								role: $author$project$Data$PDF$Create$Signer,
								signOrder: signOrder
							})
					}));
			var updatedRecipientPDF = $author$project$Data$PDF$Create$PDF(
				_Utils_update(
					pdf,
					{
						recipients: A3(
							$author$project$Data$PDF$Create$addRecipientAnnotation,
							{annotation: updatedAnnotation, user: user},
							recipients,
							signOrder)
					}));
			return _Utils_eq(
				$author$project$Data$PDF$User$emailFromUser(user),
				$author$project$Data$PDF$User$emailFromUser(owner.user)) ? $elm$core$Result$Ok(
				_Utils_Tuple2(
					updatedOwnerPDF,
					A4(
						$author$project$Data$PDF$Port$updateView,
						$author$project$Data$PDF$Create$toUpdateAnnotList(updatedOwnerPDF),
						'Upload',
						pdf.base64FileData,
						_List_Nil))) : $elm$core$Result$Ok(
				_Utils_Tuple2(
					updatedRecipientPDF,
					A4(
						$author$project$Data$PDF$Port$updateView,
						$author$project$Data$PDF$Create$toUpdateAnnotList(updatedRecipientPDF),
						'Upload',
						pdf.base64FileData,
						_List_Nil)));
		} else {
			var err = _v2.a;
			return $elm$core$Result$Err(err);
		}
	});
var $author$project$Data$PDF$Create$addRecipientPDF = F2(
	function (recipient, _v0) {
		var pdf = _v0.a;
		return $author$project$Data$PDF$Create$PDF(
			_Utils_update(
				pdf,
				{
					recipients: A3(
						$elm$core$Dict$insert,
						$author$project$Data$PDF$User$emailFromUser(recipient.user),
						recipient,
						pdf.recipients)
				}));
	});
var $author$project$Data$PDF$Create$recipientsWithoutOwner = function (_v0) {
	var recipients = _v0.a.recipients;
	return recipients;
};
var $author$project$Data$PDF$User$unregistered = function (info_) {
	return $author$project$Data$PDF$User$UnRegistered(info_);
};
var $author$project$Data$PDF$Create$addRecipient = F5(
	function (email, firstName, lastName, role, _v0) {
		var pdf = _v0.a;
		var size = $elm$core$Dict$size(
			$author$project$Data$PDF$Create$recipientsWithoutOwner(
				$author$project$Data$PDF$Create$PDF(pdf)));
		var recipient = A2(
			$author$project$Data$PDF$Create$createRecipient,
			role,
			$author$project$Data$PDF$User$unregistered(
				A9(
					$author$project$Data$PDF$User$info,
					email,
					firstName,
					lastName,
					false,
					false,
					false,
					false,
					false,
					$author$project$Data$PDF$User$nextUserColor(size))));
		var updatedPDF = A2(
			$author$project$Data$PDF$Create$addRecipientPDF,
			recipient,
			$author$project$Data$PDF$Create$PDF(pdf));
		return {
			pdfMsg: A4(
				$author$project$Data$PDF$Port$updateView,
				$author$project$Data$PDF$Create$toUpdateAnnotList(updatedPDF),
				'Upload',
				pdf.base64FileData,
				_List_Nil),
			recipient: recipient,
			updatedPDF: updatedPDF
		};
	});
var $author$project$Data$PDF$Create$addRecipientWithoutMsg = F5(
	function (email, firstName, lastName, role, _v0) {
		var pdf = _v0.a;
		var size = $elm$core$Dict$size(
			$author$project$Data$PDF$Create$recipientsWithoutOwner(
				$author$project$Data$PDF$Create$PDF(pdf)));
		var recipient = A2(
			$author$project$Data$PDF$Create$createRecipient,
			role,
			$author$project$Data$PDF$User$unregistered(
				A9(
					$author$project$Data$PDF$User$info,
					email,
					firstName,
					lastName,
					false,
					false,
					false,
					false,
					false,
					$author$project$Data$PDF$User$nextUserColor(size))));
		var updatedPDF = A2(
			$author$project$Data$PDF$Create$addRecipientPDF,
			recipient,
			$author$project$Data$PDF$Create$PDF(pdf));
		return updatedPDF;
	});
var $author$project$Data$Api$PDF$SignatureTimestamping$Payload = function (message) {
	return {message: message};
};
var $author$project$Data$Api$PDF$SignatureTimestamping$dataDecoder = A2(
	$elm$json$Json$Decode$map,
	$author$project$Data$Api$PDF$SignatureTimestamping$Payload,
	A2($elm$json$Json$Decode$field, 'message', $elm$json$Json$Decode$string));
var $author$project$Data$Api$PDF$SignatureTimestamping$encode = F2(
	function (documentId, requireSignatureTimeStamping) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'docId',
					$elm$json$Json$Encode$string(documentId)),
					_Utils_Tuple2(
					'requireSignatureTimeStamping',
					$elm$json$Json$Encode$bool(requireSignatureTimeStamping))
				]));
	});
var $author$project$Data$Api$PDF$SignatureTimestamping$INVALID_DOCUMENT = {$: 'INVALID_DOCUMENT'};
var $author$project$Data$Api$PDF$SignatureTimestamping$JWT_ERROR = {$: 'JWT_ERROR'};
var $author$project$Data$Api$PDF$SignatureTimestamping$errorDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (errorCode) {
		switch (errorCode) {
			case 'INVALID_DOCUMENT':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$PDF$SignatureTimestamping$INVALID_DOCUMENT);
			case 'JWT_ERROR':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$PDF$SignatureTimestamping$JWT_ERROR);
			default:
				return $elm$json$Json$Decode$fail('Invalid error code: ' + errorCode);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Data$Api$PDF$SignatureTimestamping$authCall = F4(
	function (jwt, endPoint, documentId, requireSignatureTimeStamping) {
		return A5(
			$author$project$Data$Api$authCall,
			jwt,
			endPoint,
			$author$project$Data$Api$PDF$SignatureTimestamping$errorDecoder,
			$author$project$Data$Api$PDF$SignatureTimestamping$dataDecoder,
			A2($author$project$Data$Api$PDF$SignatureTimestamping$encode, documentId, requireSignatureTimeStamping));
	});
var $author$project$Data$PDF$Viewer = function (a) {
	return {$: 'Viewer', a: a};
};
var $author$project$Data$PDF$PDF = function (a) {
	return {$: 'PDF', a: a};
};
var $author$project$Data$PDF$Signer = function (a) {
	return {$: 'Signer', a: a};
};
var $author$project$Data$PDF$addSigner = F2(
	function (_v0, _v1) {
		var signer = _v0.a;
		var pdf = _v1.a;
		return $author$project$Data$PDF$PDF(
			_Utils_update(
				pdf,
				{
					signers: A3(
						$elm$core$Dict$insert,
						$author$project$Data$PDF$User$emailFromUser(signer.user),
						$author$project$Data$PDF$Signer(signer),
						pdf.signers)
				}));
	});
var $author$project$Data$PDF$addViewers = F2(
	function (viewerList, _v0) {
		var pdf = _v0.a;
		return $author$project$Data$PDF$PDF(
			_Utils_update(
				pdf,
				{
					viewers: _Utils_ap(viewerList, pdf.viewers)
				}));
	});
var $author$project$Data$PDF$Create$additionalMsg = function (_v0) {
	var pdf = _v0.a;
	return pdf.additionalMsg;
};
var $author$project$Data$PDF$Create$domain = function (_v0) {
	var pdf = _v0.a;
	return pdf.domain;
};
var $author$project$Data$PDF$Create$dueDate = function (_v0) {
	var pdf = _v0.a;
	return pdf.dueDate;
};
var $author$project$Data$PDF$Create$getOwner = function (_v0) {
	var owner = _v0.a.owner;
	return owner;
};
var $author$project$Data$PDF$Viewing = function (a) {
	return {$: 'Viewing', a: a};
};
var $author$project$Data$PDF$init = F7(
	function (title_, dueDate_, password, domain_, user, additionalMsg_, requireNotarisation_) {
		return $author$project$Data$PDF$PDF(
			{
				additionalMsg: additionalMsg_,
				checksum: $elm$core$Maybe$Nothing,
				createdAt: $elm$time$Time$millisToPosix(0),
				domain: domain_,
				dueDate: dueDate_,
				id: '',
				merkleRoot: $elm$core$Maybe$Nothing,
				notarisationNetwork: $elm$core$Maybe$Nothing,
				notarisationStatus: $elm$core$Maybe$Nothing,
				notarisationTimeStamp: $elm$core$Maybe$Nothing,
				owner: user,
				password: password,
				requireNotarisation: requireNotarisation_,
				signers: $elm$core$Dict$empty,
				status: $author$project$Data$PDF$Viewing($elm$core$Maybe$Nothing),
				templateId: $elm$core$Maybe$Nothing,
				title: title_,
				transactionHash: $elm$core$Maybe$Nothing,
				updatedAt: $elm$time$Time$millisToPosix(0),
				viewers: _List_Nil
			});
	});
var $author$project$Data$PDF$Create$password = function (_v0) {
	var pdf = _v0.a;
	return pdf.password;
};
var $author$project$Data$PDF$Create$requireNotarisation = function (_v0) {
	var pdf = _v0.a;
	return pdf.requireNotarisation;
};
var $author$project$Data$PDF$Create$updateSigningOrder = F2(
	function (isSigningOrderEnabled, recipients) {
		return $elm$core$Dict$fromList(
			A2(
				$elm$core$List$map,
				function (_v0) {
					var email = _v0.a;
					var recipient = _v0.b;
					return isSigningOrderEnabled ? _Utils_Tuple2(email, recipient) : _Utils_Tuple2(
						email,
						_Utils_update(
							recipient,
							{signOrder: 0}));
				},
				$elm$core$Dict$toList(recipients)));
	});
var $author$project$Data$PDF$Create$signersAndViewer = F2(
	function (pdf, isSigningOrderEnabled) {
		var seperate = function (dict) {
			return A2(
				$elm$core$List$partition,
				function (r) {
					return _Utils_eq(r.role, $author$project$Data$PDF$Create$Signer);
				},
				$elm$core$Dict$values(dict));
		};
		var recipientDict = $author$project$Data$PDF$Create$recipientsWithoutOwner(pdf);
		var owner = $author$project$Data$PDF$Create$getOwner(pdf);
		var _v0 = owner.role;
		if (_v0.$ === 'Viewer') {
			return seperate(recipientDict);
		} else {
			return seperate(
				A2(
					$author$project$Data$PDF$Create$updateSigningOrder,
					isSigningOrderEnabled,
					A3(
						$elm$core$Dict$insert,
						$author$project$Data$PDF$User$emailFromUser(owner.user),
						owner,
						recipientDict)));
		}
	});
var $author$project$Data$PDF$User$formatName = function (user) {
	return $author$project$Data$PDF$User$userInfo(user).firstName + (' ' + $author$project$Data$PDF$User$userInfo(user).lastName);
};
var $author$project$Data$PDF$Annotation$signatureAndAnnots = function (annotations) {
	var _v0 = A2(
		$elm$core$List$partition,
		function (annot) {
			if (annot.$ === 'IsSignature') {
				return true;
			} else {
				return false;
			}
		},
		annotations);
	var signatures = _v0.a;
	var rest = _v0.b;
	return A2(
		$elm$core$Maybe$andThen,
		function (annot) {
			if (annot.$ === 'IsSignature') {
				var signature = annot.a;
				return $elm$core$Maybe$Just(
					_Utils_Tuple2(
						signature,
						_Utils_ap(
							rest,
							A2($elm$core$List$drop, 1, signatures))));
			} else {
				return $elm$core$Maybe$Nothing;
			}
		},
		$elm$core$List$head(signatures));
};
var $author$project$Data$PDF$toSigner = function (recipient) {
	var _v0 = $author$project$Data$PDF$Annotation$signatureAndAnnots(recipient.annotations);
	if (_v0.$ === 'Nothing') {
		return $elm$core$Result$Err(
			$author$project$Data$PDF$User$formatName(recipient.user) + ' does not have a signature field inserted. Please check whether they should be listed as a signatory.');
	} else {
		var _v1 = _v0.a;
		var signature = _v1.a;
		var filteredList = _v1.b;
		return $elm$core$Result$Ok(
			$author$project$Data$PDF$Signer(
				{annotations: filteredList, signOrder: recipient.signOrder, signature: signature, stamp: $elm$core$Maybe$Nothing, user: recipient.user}));
	}
};
var $author$project$Data$PDF$convert = F2(
	function (createPDF, isSigningOrderEnabled) {
		var _v0 = A2($author$project$Data$PDF$Create$signersAndViewer, createPDF, isSigningOrderEnabled);
		var signerRecipients = _v0.a;
		var viewerRecipients = _v0.b;
		var errorsPDF = A3(
			$elm$core$List$foldl,
			F2(
				function (signer, _v2) {
					var errorList = _v2.a;
					var pdf_ = _v2.b;
					var _v3 = $author$project$Data$PDF$toSigner(signer);
					if (_v3.$ === 'Err') {
						var err = _v3.a;
						return _Utils_Tuple2(
							A2($elm$core$List$cons, err, errorList),
							pdf_);
					} else {
						var validSigner = _v3.a;
						return _Utils_Tuple2(
							errorList,
							A2($author$project$Data$PDF$addSigner, validSigner, pdf_));
					}
				}),
			_Utils_Tuple2(
				_List_Nil,
				A7(
					$author$project$Data$PDF$init,
					$author$project$Data$PDF$Create$title(createPDF),
					$author$project$Data$PDF$Create$dueDate(createPDF),
					$author$project$Data$PDF$Create$password(createPDF),
					$author$project$Data$PDF$Create$domain(createPDF),
					$author$project$Data$PDF$Create$getOwner(createPDF).user,
					$author$project$Data$PDF$Create$additionalMsg(createPDF),
					$author$project$Data$PDF$Create$requireNotarisation(createPDF))),
			signerRecipients);
		var _v1 = errorsPDF;
		var errors = _v1.a;
		var pdf = _v1.b;
		if ($elm$core$List$isEmpty(errors)) {
			var viewerList = A2(
				$elm$core$List$map,
				function (r) {
					return $author$project$Data$PDF$Viewer(r.user);
				},
				viewerRecipients);
			return $elm$core$Result$Ok(
				A2($author$project$Data$PDF$addViewers, viewerList, pdf));
		} else {
			return $elm$core$Result$Err(errors);
		}
	});
var $author$project$Data$PDF$Port$DecodedDocumentAnnot = function (a) {
	return {$: 'DecodedDocumentAnnot', a: a};
};
var $author$project$Data$PDF$Port$DocumentAnnotData = F5(
	function (id, kind, content, status, style) {
		return {content: content, id: id, kind: kind, status: status, style: style};
	});
var $author$project$Data$PDF$Port$CheckboxKind = {$: 'CheckboxKind'};
var $author$project$Data$PDF$Port$DateKind = {$: 'DateKind'};
var $author$project$Data$PDF$Port$EditableTextKind = {$: 'EditableTextKind'};
var $author$project$Data$PDF$Port$EmailKind = {$: 'EmailKind'};
var $author$project$Data$PDF$Port$NameKind = {$: 'NameKind'};
var $author$project$Data$PDF$Port$NonEditableTextKind = {$: 'NonEditableTextKind'};
var $author$project$Data$PDF$Port$PlaceHolderCheckboxKind = {$: 'PlaceHolderCheckboxKind'};
var $author$project$Data$PDF$Port$SignedSignatureKind = {$: 'SignedSignatureKind'};
var $author$project$Data$PDF$Port$StampedStampKind = {$: 'StampedStampKind'};
var $author$project$Data$PDF$Port$UnsignedSignatureKind = {$: 'UnsignedSignatureKind'};
var $author$project$Data$PDF$Port$UnstampedStampKind = {$: 'UnstampedStampKind'};
var $author$project$Data$PDF$Port$annotationKindDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (value) {
		switch (value) {
			case 'Name':
				return $elm$json$Json$Decode$succeed($author$project$Data$PDF$Port$NameKind);
			case 'Date':
				return $elm$json$Json$Decode$succeed($author$project$Data$PDF$Port$DateKind);
			case 'EditableText':
				return $elm$json$Json$Decode$succeed($author$project$Data$PDF$Port$EditableTextKind);
			case 'NonEditableText':
				return $elm$json$Json$Decode$succeed($author$project$Data$PDF$Port$NonEditableTextKind);
			case 'UnsignedSignature':
				return $elm$json$Json$Decode$succeed($author$project$Data$PDF$Port$UnsignedSignatureKind);
			case 'SignedSignature':
				return $elm$json$Json$Decode$succeed($author$project$Data$PDF$Port$SignedSignatureKind);
			case 'UnstampedStamp':
				return $elm$json$Json$Decode$succeed($author$project$Data$PDF$Port$UnstampedStampKind);
			case 'StampedStamp':
				return $elm$json$Json$Decode$succeed($author$project$Data$PDF$Port$StampedStampKind);
			case 'Email':
				return $elm$json$Json$Decode$succeed($author$project$Data$PDF$Port$EmailKind);
			case 'PlaceHolderCheckbox':
				return $elm$json$Json$Decode$succeed($author$project$Data$PDF$Port$PlaceHolderCheckboxKind);
			case 'Checkbox':
				return $elm$json$Json$Decode$succeed($author$project$Data$PDF$Port$CheckboxKind);
			default:
				return $elm$json$Json$Decode$fail('Unknown Annotation Kind: ' + value);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Data$PDF$Port$decodeOneAnnotData = A2(
	$elm$json$Json$Decode$map,
	$author$project$Data$PDF$Port$DecodedDocumentAnnot,
	A6(
		$elm$json$Json$Decode$map5,
		$author$project$Data$PDF$Port$DocumentAnnotData,
		A2($elm$json$Json$Decode$field, 'id', $elm$json$Json$Decode$string),
		A2($elm$json$Json$Decode$field, 'kind', $author$project$Data$PDF$Port$annotationKindDecoder),
		A2($elm$json$Json$Decode$field, 'content', $elm$json$Json$Decode$string),
		A2($elm$json$Json$Decode$field, 'status', $author$project$Data$PDF$Port$decodeStatus),
		A2($elm$json$Json$Decode$field, 'style', $author$project$Data$PDF$Port$decodeStyle)));
var $author$project$Data$PDF$Port$decodeAnnotData = $elm$json$Json$Decode$list($author$project$Data$PDF$Port$decodeOneAnnotData);
var $author$project$Data$PDF$Port$decodeAnnotDataResult = function (value) {
	var _v0 = A2($elm$json$Json$Decode$decodeValue, $author$project$Data$PDF$Port$decodeAnnotData, value);
	if (_v0.$ === 'Ok') {
		var results = _v0.a;
		return $elm$core$Result$Ok(results);
	} else {
		return $elm$core$Result$Err('Unable to update selected annotations.');
	}
};
var $elm$core$Dict$foldl = F3(
	function (func, acc, dict) {
		foldl:
		while (true) {
			if (dict.$ === 'RBEmpty_elm_builtin') {
				return acc;
			} else {
				var key = dict.b;
				var value = dict.c;
				var left = dict.d;
				var right = dict.e;
				var $temp$func = func,
					$temp$acc = A3(
					func,
					key,
					value,
					A3($elm$core$Dict$foldl, func, acc, left)),
					$temp$dict = right;
				func = $temp$func;
				acc = $temp$acc;
				dict = $temp$dict;
				continue foldl;
			}
		}
	});
var $author$project$Data$PDF$Annotation$id = function (annot) {
	switch (annot.$) {
		case 'Name':
			var txt = annot.a.a;
			return txt.id;
		case 'Date':
			var dateTxt_ = annot.a.a;
			return dateTxt_.id;
		case 'EditableText':
			var txt = annot.a.a;
			return txt.id;
		case 'NonEditableText':
			var txt = annot.a.a;
			return txt.id;
		case 'IsSignature':
			var signature = annot.a.a;
			return signature.id;
		case 'IsStamp':
			var stamp = annot.a.a;
			return stamp.id;
		case 'IsEmail':
			var txt = annot.a.a;
			return txt.id;
		default:
			var checkbox = annot.a.a;
			return checkbox.id;
	}
};
var $author$project$Data$PDF$Create$getAnnotationPageFromList = F2(
	function (annotList, annotID) {
		return A3(
			$elm$core$List$foldl,
			F2(
				function (annot, _v0) {
					if (_Utils_eq(
						$author$project$Data$PDF$Annotation$id(annot),
						annotID)) {
						var style = $author$project$Data$PDF$Annotation$getStyle(annot);
						return _List_fromArray(
							[style.page]);
					} else {
						return _List_Nil;
					}
				}),
			_List_Nil,
			annotList);
	});
var $author$project$Data$PDF$Create$removeAnnotFromList = F2(
	function (annotId, annotations) {
		return A2(
			$elm$core$List$filter,
			function (annot) {
				return !_Utils_eq(
					$author$project$Data$PDF$Annotation$id(annot),
					annotId);
			},
			annotations);
	});
var $elm$core$Dict$map = F2(
	function (func, dict) {
		if (dict.$ === 'RBEmpty_elm_builtin') {
			return $elm$core$Dict$RBEmpty_elm_builtin;
		} else {
			var color = dict.a;
			var key = dict.b;
			var value = dict.c;
			var left = dict.d;
			var right = dict.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				color,
				key,
				A2(func, key, value),
				A2($elm$core$Dict$map, func, left),
				A2($elm$core$Dict$map, func, right));
		}
	});
var $author$project$Data$PDF$Create$removeAnnotFromRecipients = F2(
	function (annotId, recipientDict) {
		return A2(
			$elm$core$Dict$map,
			F2(
				function (_v0, r) {
					var updatedRecipientData = _Utils_update(
						r,
						{
							annotations: A2($author$project$Data$PDF$Create$removeAnnotFromList, annotId, r.annotations)
						});
					var newRole = $elm$core$List$isEmpty(updatedRecipientData.annotations) ? $author$project$Data$PDF$Create$Viewer : $author$project$Data$PDF$Create$Signer;
					return _Utils_update(
						updatedRecipientData,
						{role: newRole});
				}),
			recipientDict);
	});
var $author$project$Data$PDF$Create$deleteAnnotation = F2(
	function (deleteAnnotId, _v0) {
		var pdf = _v0.a;
		var _v1 = pdf;
		var recipients = _v1.recipients;
		var owner = _v1.owner;
		var ownerAnnots = _Utils_update(
			owner,
			{
				annotations: A2($author$project$Data$PDF$Create$removeAnnotFromList, deleteAnnotId, owner.annotations)
			});
		var updatedOwner = $elm$core$List$isEmpty(ownerAnnots.annotations) ? _Utils_update(
			ownerAnnots,
			{role: $author$project$Data$PDF$Create$Viewer}) : _Utils_update(
			ownerAnnots,
			{role: $author$project$Data$PDF$Create$Signer});
		var pageOfDeletedOwnerAnnot = A2($author$project$Data$PDF$Create$getAnnotationPageFromList, owner.annotations, deleteAnnotId);
		var pageOfDeletedRecipientAnnot = A3(
			$elm$core$Dict$foldl,
			F3(
				function (_v2, userData, accumulator) {
					var annotPageList = A2($author$project$Data$PDF$Create$getAnnotationPageFromList, userData.annotations, deleteAnnotId);
					return $elm$core$List$isEmpty(annotPageList) ? accumulator : annotPageList;
				}),
			_List_Nil,
			recipients);
		var pageOFDeletedAnnot = _Utils_ap(pageOfDeletedOwnerAnnot, pageOfDeletedRecipientAnnot);
		var updatedPDF = $author$project$Data$PDF$Create$PDF(
			_Utils_update(
				pdf,
				{
					owner: updatedOwner,
					recipients: A2($author$project$Data$PDF$Create$removeAnnotFromRecipients, deleteAnnotId, recipients)
				}));
		return _Utils_Tuple2(
			updatedPDF,
			A4(
				$author$project$Data$PDF$Port$updateView,
				$author$project$Data$PDF$Create$toUpdateAnnotList(updatedPDF),
				'Upload',
				pdf.base64FileData,
				pageOFDeletedAnnot));
	});
var $author$project$Model$UploadMultipleDocument$displaySendDocumentAdsContent = _Platform_outgoingPort('displaySendDocumentAdsContent', $elm$core$Basics$identity);
var $author$project$Data$Api$PDF$Upload$errorToString = function (error) {
	switch (error.$) {
		case 'FILE_TOO_BIG':
			return 'Size of file cannot exceed 25MB.';
		case 'WRONG_FILE_FORMAT':
			return 'PDF document only (for sending).';
		case 'INVALID_DATA':
			return 'Invalid data provided. Please refresh and try again.';
		case 'INCORRECT_PASSWORD':
			return 'Password provided is incorrect.';
		case 'APPEND_ERROR':
			return 'Unable to append annotation(s) to the file.';
		case 'ENCRYPTION_ERROR':
			return 'Unable to encrypt and store uploaded file.';
		case 'INVALID_CERTIFICATE':
			return 'Invalid digital certificate.';
		case 'UNEDITABLE_PDF':
			return 'PDF is not editable.';
		case 'LOADING_ERROR':
			return 'Invalid PDF. Please upload a valid PDF file instead.';
		case 'SIGNATURE_HASH_ERROR':
			return 'Invalid digital signature hash received.';
		case 'FILE_NOT_FOUND':
			return 'An error has occur. Please try again later.';
		case 'TEMP_FILE_NOT_FOUND':
			return 'An error has occur. Please try again later.';
		case 'UNKNOWN':
			return 'An error has occur. Please try again later.';
		case 'INVALID_PASSCODE_FORMAT':
			return 'Passcode entered can only be of 4 to 8 numeric characters.';
		case 'INSUFFICIENT_POINTS_SIGNING':
			return 'Insufficient Points to sign document. Please ensure that you have enough points and try again later';
		default:
			return 'Insufficient Points to notariza document';
	}
};
var $author$project$Data$PDF$Create$file = function (_v0) {
	var pdf = _v0.a;
	return pdf.file;
};
var $author$project$Data$PDF$Create$getBase64Data = function (_v0) {
	var base64FileData = _v0.a.base64FileData;
	return base64FileData;
};
var $author$project$Data$PDF$Annotation$isCheckboxAnnot = function (annot) {
	if (annot.$ === 'IsCheckbox') {
		return true;
	} else {
		return false;
	}
};
var $author$project$Data$PDF$Annotation$isDate = function (annot) {
	if (annot.$ === 'Date') {
		return true;
	} else {
		return false;
	}
};
var $author$project$Data$PDF$Annotation$isTextAnnot = function (annot) {
	switch (annot.$) {
		case 'EditableText':
			return true;
		case 'NonEditableText':
			return true;
		default:
			return false;
	}
};
var $author$project$Data$PDF$Port$encodeFilledDocumentAnnot = function (_v0) {
	var user = _v0.user;
	var annotations = _v0.annotations;
	var encodedUser = $author$project$Data$PDF$Port$encodePDFUser(user);
	var encodedAnnots = A2(
		$elm$json$Json$Encode$list,
		function (annot) {
			return A2(
				$author$project$Data$PDF$Port$encodeDocumentAnnotation,
				A2($author$project$Data$PDF$User$annotBgColor, annot, user),
				annot);
		},
		annotations);
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2('user', encodedUser),
				_Utils_Tuple2('annotations', encodedAnnots)
			]));
};
var $author$project$Data$PDF$Port$encodeFilledDocumentAnnots = function (annotList) {
	return A2($elm$json$Json$Encode$list, $author$project$Data$PDF$Port$encodeFilledDocumentAnnot, annotList);
};
var $author$project$Data$PDF$Port$loadswitchedDocAnnot = _Platform_outgoingPort('loadswitchedDocAnnot', $elm$core$Basics$identity);
var $author$project$Data$PDF$Port$loadDocAnnots = function (documentAnnots) {
	return $author$project$Data$PDF$Port$loadswitchedDocAnnot(
		$author$project$Data$PDF$Port$encodeFilledDocumentAnnots(documentAnnots));
};
var $author$project$Data$PDF$Create$loadWithPassword = F4(
	function (password_, _v0, fileType, location) {
		var pdf = _v0.a;
		return _Utils_Tuple2(
			$author$project$Data$PDF$Create$PDF(
				_Utils_update(
					pdf,
					{
						password: $elm$core$Maybe$Just(password_)
					})),
			A5(
				$author$project$Data$PDF$Port$loadNewDoc,
				$elm$core$Maybe$Just(password_),
				pdf.base64FileData,
				fileType,
				pdf.title,
				$author$project$Data$PDF$Create$locationToString(location)));
	});
var $author$project$Model$UploadMultipleDocument$modifyAnnotation = F3(
	function (currentModel, updateCurrentModel, _v0) {
		var updatedPDF = _v0.a;
		var pdfCmd = _v0.b;
		var updatedList = A2(
			$elm$core$List$map,
			function (pdfData) {
				return _Utils_eq(
					$author$project$Data$PDF$Create$getBase64Data(pdfData.pdf),
					$author$project$Data$PDF$Create$getBase64Data(updatedPDF)) ? _Utils_update(
					pdfData,
					{pdf: updatedPDF}) : pdfData;
			},
			currentModel.pdfList);
		return _Utils_Tuple2(
			updateCurrentModel(
				_Utils_update(
					currentModel,
					{pdf: updatedPDF, pdfList: updatedList})),
			pdfCmd);
	});
var $author$project$Data$PDF$Create$removeRecipient = F2(
	function (email, _v0) {
		var pdf = _v0.a;
		var updatedPDF = $author$project$Data$PDF$Create$PDF(
			_Utils_update(
				pdf,
				{
					recipients: A2($elm$core$Dict$remove, email, pdf.recipients)
				}));
		var removedRecipient = A2($elm$core$Dict$get, email, pdf.recipients);
		var removedAnnotationsPages = function () {
			if (removedRecipient.$ === 'Just') {
				var recipient = removedRecipient.a;
				var annotations = A2(
					$elm$core$List$map,
					function (annot) {
						var style = $author$project$Data$PDF$Annotation$getStyle(annot);
						return style.page;
					},
					recipient.annotations);
				var uniqueAnnots = A3(
					$elm$core$List$foldl,
					F2(
						function (annot, accumlator) {
							return A2($elm$core$List$member, annot, accumlator) ? accumlator : A2($elm$core$List$cons, annot, accumlator);
						}),
					_List_Nil,
					annotations);
				return uniqueAnnots;
			} else {
				return _List_Nil;
			}
		}();
		return _Utils_Tuple2(
			updatedPDF,
			A4(
				$author$project$Data$PDF$Port$updateView,
				$author$project$Data$PDF$Create$toUpdateAnnotList(updatedPDF),
				'Upload',
				pdf.base64FileData,
				removedAnnotationsPages));
	});
var $author$project$Data$PDF$Create$removeRecipientWithoutMsg = F2(
	function (email, _v0) {
		var pdf = _v0.a;
		var updatedPDF = $author$project$Data$PDF$Create$PDF(
			_Utils_update(
				pdf,
				{
					recipients: A2($elm$core$Dict$remove, email, pdf.recipients)
				}));
		return updatedPDF;
	});
var $author$project$Data$PDF$Create$setAdditionalMsg = F2(
	function (newAdditionalMsg, _v0) {
		var pdf = _v0.a;
		return $author$project$Data$PDF$Create$PDF(
			_Utils_update(
				pdf,
				{additionalMsg: newAdditionalMsg}));
	});
var $author$project$Data$PDF$Create$setBase64FileData = F3(
	function (base64Data, fileData, _v0) {
		var pdf = _v0.a;
		return $author$project$Data$PDF$Create$PDF(
			_Utils_update(
				pdf,
				{base64FileData: base64Data, file: fileData}));
	});
var $author$project$Data$PDF$Create$setDueDate = F2(
	function (newDueDate, _v0) {
		var pdf = _v0.a;
		return $author$project$Data$PDF$Create$PDF(
			_Utils_update(
				pdf,
				{dueDate: newDueDate}));
	});
var $author$project$Data$PDF$Create$setRequireNotarisation = F2(
	function (requireNotarisation_, _v0) {
		var pdf = _v0.a;
		return $author$project$Data$PDF$Create$PDF(
			_Utils_update(
				pdf,
				{requireNotarisation: requireNotarisation_}));
	});
var $author$project$Data$PDF$Create$setTitle = F2(
	function (newTitle, _v0) {
		var pdf = _v0.a;
		return $author$project$Data$PDF$Create$PDF(
			_Utils_update(
				pdf,
				{title: newTitle}));
	});
var $author$project$Data$PDF$Port$encodeSwitchFile = F5(
	function (password, data, fileType, fileName, filledAnnots) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'data',
					$elm$json$Json$Encode$string(data)),
					_Utils_Tuple2(
					'ext',
					$elm$json$Json$Encode$string(
						$author$project$Type$File$fileTypeToString(fileType))),
					_Utils_Tuple2(
					'password',
					A2(
						$elm$core$Maybe$withDefault,
						$elm$json$Json$Encode$null,
						A2($elm$core$Maybe$map, $elm$json$Json$Encode$string, password))),
					_Utils_Tuple2(
					'fileName',
					$elm$json$Json$Encode$string(fileName)),
					_Utils_Tuple2(
					'filledAnnots',
					$author$project$Data$PDF$Port$encodeFilledDocumentAnnots(filledAnnots))
				]));
	});
var $author$project$Data$PDF$Port$switchNewDocument = _Platform_outgoingPort('switchNewDocument', $elm$core$Basics$identity);
var $author$project$Data$PDF$Port$switchDoc = F5(
	function (password, base64Pdf, fileType, fileName, documentAnnots) {
		return $author$project$Data$PDF$Port$switchNewDocument(
			A5($author$project$Data$PDF$Port$encodeSwitchFile, password, base64Pdf, fileType, fileName, documentAnnots));
	});
var $author$project$Data$PDF$Create$toRole = function (role) {
	switch (role) {
		case 'Viewer':
			return $author$project$Data$PDF$Create$Viewer;
		case 'Signer':
			return $author$project$Data$PDF$Create$Signer;
		default:
			return $author$project$Data$PDF$Create$Signer;
	}
};
var $author$project$Data$PDF$Create$unload = $author$project$Data$PDF$Port$closeDocument2;
var $author$project$Data$PDF$Port$filterDecodedAnnots = F2(
	function (annotation, annotDataList) {
		return $elm$core$List$head(
			A2(
				$elm$core$List$filter,
				function (_v0) {
					var annotData = _v0.a;
					return _Utils_eq(
						annotData.id,
						$author$project$Data$PDF$Annotation$id(annotation));
				},
				annotDataList));
	});
var $author$project$Data$PDF$Annotation$signatureContent = function (_v0) {
	var signature = _v0.a;
	var _v1 = signature.status;
	if (_v1.$ === 'Signed') {
		var signatureData = _v1.a;
		return $author$project$Data$PDF$Signature$data(signatureData);
	} else {
		return '';
	}
};
var $author$project$Data$PDF$Annotation$Checked = {$: 'Checked'};
var $author$project$Data$PDF$Annotation$stringToCheckboxStatus = function (status) {
	switch (status) {
		case 'Checked':
			return $author$project$Data$PDF$Annotation$Checked;
		case 'Unchecked':
			return $author$project$Data$PDF$Annotation$Unchecked;
		case 'PlaceHolder':
			return $author$project$Data$PDF$Annotation$PlaceHolder;
		default:
			return $author$project$Data$PDF$Annotation$PlaceHolder;
	}
};
var $author$project$Data$PDF$Annotation$updateSignature = F3(
	function (content, style, _v0) {
		var signature = _v0.a;
		var _v1 = signature.status;
		if (_v1.$ === 'Signed') {
			return $author$project$Data$PDF$Annotation$Signature(
				_Utils_update(
					signature,
					{
						id: A3(
							$author$project$Data$PDF$Annotation$generateId,
							content,
							$author$project$Data$PDF$Annotation$toSignatureStatusString(signature.status),
							style),
						style: style
					}));
		} else {
			return $author$project$Data$PDF$Annotation$Signature(
				_Utils_update(
					signature,
					{
						id: A3(
							$author$project$Data$PDF$Annotation$generateId,
							'',
							$author$project$Data$PDF$Annotation$toSignatureStatusString(signature.status),
							style),
						style: style
					}));
		}
	});
var $author$project$Data$PDF$Annotation$updateStamp = F3(
	function (content, style, _v0) {
		var stamp = _v0.a;
		var _v1 = stamp.status;
		if (_v1.$ === 'Stamped') {
			return $author$project$Data$PDF$Annotation$Stamp(
				_Utils_update(
					stamp,
					{
						id: A3(
							$author$project$Data$PDF$Annotation$generateId,
							content,
							$author$project$Data$PDF$Annotation$toStampStatusString(stamp.status),
							style),
						style: style
					}));
		} else {
			return $author$project$Data$PDF$Annotation$Stamp(
				_Utils_update(
					stamp,
					{
						id: A3(
							$author$project$Data$PDF$Annotation$generateId,
							'',
							$author$project$Data$PDF$Annotation$toStampStatusString(stamp.status),
							style),
						style: style
					}));
		}
	});
var $author$project$Data$PDF$Port$updateAnnot = F2(
	function (_v0, annot) {
		var style = _v0.a.style;
		var content = _v0.a.content;
		var status = _v0.a.status;
		switch (annot.$) {
			case 'Name':
				var txt = annot.a;
				return $author$project$Data$PDF$Annotation$Name(
					A4(
						$author$project$Data$PDF$Annotation$updateTxt,
						$author$project$Data$PDF$Annotation$txtText(txt),
						status,
						style,
						txt));
			case 'Date':
				var txt = annot.a;
				return $author$project$Data$PDF$Annotation$Date(
					A4(
						$author$project$Data$PDF$Annotation$updateDateTxt,
						$author$project$Data$PDF$Annotation$dateTxtDate(txt),
						status,
						style,
						txt));
			case 'EditableText':
				var txt = annot.a;
				return $author$project$Data$PDF$Annotation$EditableText(
					A4($author$project$Data$PDF$Annotation$updateTxt, content, status, style, txt));
			case 'NonEditableText':
				var txt = annot.a;
				return $author$project$Data$PDF$Annotation$NonEditableText(
					A4($author$project$Data$PDF$Annotation$updateTxt, content, status, style, txt));
			case 'IsSignature':
				var signature = annot.a;
				return $author$project$Data$PDF$Annotation$IsSignature(
					A3(
						$author$project$Data$PDF$Annotation$updateSignature,
						$author$project$Data$PDF$Annotation$signatureContent(signature),
						style,
						signature));
			case 'IsStamp':
				var stamp = annot.a;
				return $author$project$Data$PDF$Annotation$IsStamp(
					A3(
						$author$project$Data$PDF$Annotation$updateStamp,
						$author$project$Data$PDF$Annotation$stampContent(stamp),
						style,
						stamp));
			case 'IsEmail':
				var txt = annot.a;
				return $author$project$Data$PDF$Annotation$IsEmail(
					A4(
						$author$project$Data$PDF$Annotation$updateTxt,
						$author$project$Data$PDF$Annotation$txtText(txt),
						status,
						style,
						txt));
			default:
				var checkbox = annot.a;
				return $author$project$Data$PDF$Annotation$IsCheckbox(
					A3(
						$author$project$Data$PDF$Annotation$updateCheckBox,
						$author$project$Data$PDF$Annotation$stringToCheckboxStatus(content),
						style,
						checkbox));
		}
	});
var $author$project$Data$PDF$Port$updateAnnotList = F2(
	function (annotDataList, annotations) {
		return A2(
			$elm$core$List$map,
			function (annot) {
				var maybeAnnotData = A2($author$project$Data$PDF$Port$filterDecodedAnnots, annot, annotDataList);
				if (maybeAnnotData.$ === 'Nothing') {
					return annot;
				} else {
					var annotData = maybeAnnotData.a;
					return A2($author$project$Data$PDF$Port$updateAnnot, annotData, annot);
				}
			},
			annotations);
	});
var $author$project$Data$PDF$Create$updateRecipientsAnnots = F2(
	function (annotDataList, recipientDict) {
		return A2(
			$elm$core$Dict$map,
			F2(
				function (_v0, r) {
					return _Utils_update(
						r,
						{
							annotations: A2($author$project$Data$PDF$Port$updateAnnotList, annotDataList, r.annotations)
						});
				}),
			recipientDict);
	});
var $author$project$Data$PDF$Create$updateAnnotations = F2(
	function (annotDataList, _v0) {
		var pdf = _v0.a;
		var _v1 = pdf;
		var recipients = _v1.recipients;
		var owner = _v1.owner;
		var ownerAnnots = _Utils_update(
			owner,
			{
				annotations: A2($author$project$Data$PDF$Port$updateAnnotList, annotDataList, owner.annotations)
			});
		var updatedPDF = $author$project$Data$PDF$Create$PDF(
			_Utils_update(
				pdf,
				{
					owner: ownerAnnots,
					recipients: A2($author$project$Data$PDF$Create$updateRecipientsAnnots, annotDataList, recipients)
				}));
		return _Utils_Tuple2(
			updatedPDF,
			A4(
				$author$project$Data$PDF$Port$updateView,
				$author$project$Data$PDF$Create$toUpdateAnnotList(updatedPDF),
				'Upload',
				pdf.base64FileData,
				_List_Nil));
	});
var $author$project$Data$PDF$Annotation$updateDateAnnot = F2(
	function (dateNow, annot) {
		if (annot.$ === 'Date') {
			var dateTxt_ = annot.a.a;
			return $author$project$Data$PDF$Annotation$Date(
				$author$project$Data$PDF$Annotation$DateTxt(
					_Utils_update(
						dateTxt_,
						{date: dateNow})));
		} else {
			return annot;
		}
	});
var $author$project$Data$PDF$Port$getStyle = function (_v0) {
	var data = _v0.a;
	return data.style;
};
var $author$project$Data$PDF$Port$kind = function (_v0) {
	var data = _v0.a;
	return data.kind;
};
var $author$project$Model$UploadMultipleDocument$updateLastStyle = F2(
	function (annotationDataList, previousLastStyle) {
		return A3(
			$elm$core$List$foldl,
			F2(
				function (data, lastStyle) {
					var _v0 = lastStyle;
					var name = _v0.name;
					var date = _v0.date;
					var text = _v0.text;
					var _v1 = $author$project$Data$PDF$Port$getStyle(data);
					var width = _v1.width;
					var height = _v1.height;
					var fontSize = _v1.fontSize;
					var _v2 = $author$project$Data$PDF$Port$kind(data);
					switch (_v2.$) {
						case 'NameKind':
							return _Utils_update(
								lastStyle,
								{
									date: _Utils_update(
										date,
										{fontSize: fontSize}),
									email: _Utils_update(
										text,
										{fontSize: fontSize}),
									name: {fontSize: fontSize, height: height, width: width},
									text: _Utils_update(
										text,
										{fontSize: fontSize})
								});
						case 'DateKind':
							return _Utils_update(
								lastStyle,
								{
									date: {fontSize: fontSize, height: height, width: width},
									email: _Utils_update(
										text,
										{fontSize: fontSize}),
									name: _Utils_update(
										name,
										{fontSize: fontSize}),
									text: _Utils_update(
										text,
										{fontSize: fontSize})
								});
						case 'EditableTextKind':
							return _Utils_update(
								lastStyle,
								{
									date: _Utils_update(
										date,
										{fontSize: fontSize}),
									email: _Utils_update(
										text,
										{fontSize: fontSize}),
									name: _Utils_update(
										name,
										{fontSize: fontSize}),
									text: {fontSize: fontSize, height: height, width: width}
								});
						case 'NonEditableTextKind':
							return _Utils_update(
								lastStyle,
								{
									date: _Utils_update(
										date,
										{fontSize: fontSize}),
									email: _Utils_update(
										text,
										{fontSize: fontSize}),
									name: _Utils_update(
										name,
										{fontSize: fontSize}),
									text: {fontSize: fontSize, height: height, width: width}
								});
						case 'UnsignedSignatureKind':
							return _Utils_update(
								lastStyle,
								{
									unsignedSignature: {height: height, width: width}
								});
						case 'SignedSignatureKind':
							return _Utils_update(
								lastStyle,
								{
									signedSignature: {height: height, width: width}
								});
						case 'UnstampedStampKind':
							return _Utils_update(
								lastStyle,
								{
									unstamped: {fontSize: fontSize, height: height, width: width}
								});
						case 'StampedStampKind':
							return _Utils_update(
								lastStyle,
								{
									stamped: {height: height, width: width}
								});
						case 'EmailKind':
							return _Utils_update(
								lastStyle,
								{
									date: _Utils_update(
										date,
										{fontSize: fontSize}),
									email: {fontSize: fontSize, height: height, width: width},
									name: _Utils_update(
										name,
										{fontSize: fontSize}),
									text: _Utils_update(
										text,
										{fontSize: fontSize})
								});
						case 'CheckboxKind':
							return _Utils_update(
								lastStyle,
								{
									checkbox: {fontSize: fontSize, height: 15, width: 15}
								});
						default:
							return _Utils_update(
								lastStyle,
								{
									checkbox: {fontSize: fontSize, height: height, width: height}
								});
					}
				}),
			previousLastStyle,
			annotationDataList);
	});
var $author$project$Data$PDF$Create$updateOwnerRole = F2(
	function (_v0, role) {
		var pdf = _v0.a;
		var owner = pdf.owner;
		var updatedPDF = $author$project$Data$PDF$Create$PDF(
			_Utils_update(
				pdf,
				{
					owner: _Utils_update(
						owner,
						{annotations: _List_Nil, role: role})
				}));
		return _Utils_Tuple2(
			updatedPDF,
			A4(
				$author$project$Data$PDF$Port$updateView,
				$author$project$Data$PDF$Create$toUpdateAnnotList(updatedPDF),
				'Upload',
				pdf.base64FileData,
				_List_Nil));
	});
var $author$project$Data$PDF$Create$updateOwnerSigningOrder = F2(
	function (signOrder, _v0) {
		var pdf = _v0.a;
		var _v1 = pdf;
		var owner = _v1.owner;
		return $author$project$Data$PDF$Create$PDF(
			_Utils_update(
				pdf,
				{
					owner: _Utils_update(
						owner,
						{signOrder: signOrder})
				}));
	});
var $author$project$Data$PDF$Create$updateRecipientSigningOrder = F3(
	function (email, signOrder, _v0) {
		var pdf = _v0.a;
		var recipients = $author$project$Data$PDF$Create$recipientsWithoutOwner(
			$author$project$Data$PDF$Create$PDF(pdf));
		var updatedSigningOrder = A3(
			$elm$core$Dict$update,
			email,
			$elm$core$Maybe$map(
				function (recipient) {
					return _Utils_update(
						recipient,
						{signOrder: signOrder});
				}),
			recipients);
		var updatedPDF = _Utils_update(
			pdf,
			{recipients: updatedSigningOrder});
		return $author$project$Data$PDF$Create$PDF(updatedPDF);
	});
var $author$project$Data$PDF$Annotation$updateFontSize = F2(
	function (newFontSize, annotation) {
		var style = $author$project$Data$PDF$Annotation$getStyle(annotation);
		var updatedAnnotation = A2(
			$author$project$Data$PDF$Annotation$updateStyleAndId,
			_Utils_update(
				style,
				{fontSize: newFontSize}),
			annotation);
		switch (annotation.$) {
			case 'Name':
				return updatedAnnotation;
			case 'Date':
				return updatedAnnotation;
			case 'EditableText':
				return updatedAnnotation;
			case 'NonEditableText':
				return updatedAnnotation;
			case 'IsSignature':
				return annotation;
			case 'IsStamp':
				return annotation;
			case 'IsEmail':
				return updatedAnnotation;
			default:
				return annotation;
		}
	});
var $author$project$Data$PDF$Create$updateTextAnnotationFontSize = F2(
	function (newFontSize, _v0) {
		var pdf = _v0.a;
		var _v1 = pdf;
		var recipients = _v1.recipients;
		var owner = _v1.owner;
		var updatedOwnerAnnotations = A2(
			$elm$core$List$map,
			function (annot) {
				return A2($author$project$Data$PDF$Annotation$updateFontSize, newFontSize, annot);
			},
			owner.annotations);
		var updatedRecipients = A2(
			$elm$core$Dict$map,
			F2(
				function (_v2, r) {
					var updatedAnnotions = A2(
						$elm$core$List$map,
						function (annot) {
							return A2($author$project$Data$PDF$Annotation$updateFontSize, newFontSize, annot);
						},
						r.annotations);
					return _Utils_update(
						r,
						{annotations: updatedAnnotions});
				}),
			recipients);
		var updatedPDF = $author$project$Data$PDF$Create$PDF(
			_Utils_update(
				pdf,
				{
					owner: _Utils_update(
						owner,
						{annotations: updatedOwnerAnnotations}),
					recipients: updatedRecipients
				}));
		return _Utils_Tuple2(
			updatedPDF,
			A4(
				$author$project$Data$PDF$Port$updateView,
				$author$project$Data$PDF$Create$toUpdateAnnotList(updatedPDF),
				'Upload',
				pdf.base64FileData,
				_List_Nil));
	});
var $author$project$Data$Api$PDF$Upload$Payload = F6(
	function (result, documentId, checksum, recipient, ownerId, requireSignatureTimeStamping) {
		return {checksum: checksum, documentId: documentId, ownerId: ownerId, recipient: recipient, requireSignatureTimeStamping: requireSignatureTimeStamping, result: result};
	});
var $author$project$Data$Api$PDF$Upload$dataDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'requireSignatureTimeStamping',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'ownerId',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'recipient',
			$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'checksum',
				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
				$elm$core$Maybe$Nothing,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'documentId',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'result',
						$elm$json$Json$Decode$string,
						$elm$json$Json$Decode$succeed($author$project$Data$Api$PDF$Upload$Payload)))))));
var $author$project$Data$PDF$additionalMsg = function (_v0) {
	var pdf = _v0.a;
	return pdf.additionalMsg;
};
var $author$project$Data$PDF$docPassword = function (_v0) {
	var password = _v0.a.password;
	return password;
};
var $author$project$Data$PDF$domain = function (_v0) {
	var pdf = _v0.a;
	return pdf.domain;
};
var $author$project$Data$PDF$dueDate = function (_v0) {
	var pdf = _v0.a;
	return pdf.dueDate;
};
var $author$project$Data$PDF$annotations = function (_v0) {
	var info = _v0.a;
	return info.annotations;
};
var $author$project$Data$Api$PDF$Upload$encodeCheckbox = function (checkbox) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'type',
				$elm$json$Json$Encode$string('Checkbox')),
				_Utils_Tuple2(
				'isVerified',
				$elm$json$Json$Encode$bool(true)),
				_Utils_Tuple2(
				'content',
				$elm$json$Json$Encode$string('Unchecked')),
				_Utils_Tuple2(
				'style',
				$author$project$Data$PDF$Port$encodeStyle(
					$author$project$Data$PDF$Annotation$checkboxStyle(checkbox)))
			]));
};
var $author$project$Data$Api$PDF$Upload$encodeDateTxt = function (dateTxt) {
	var posixString = $author$project$Data$PDF$Annotation$toStringPosix(
		$author$project$Data$PDF$Annotation$dateTxtDate(dateTxt));
	var isVerified = function () {
		var _v0 = $author$project$Data$PDF$Annotation$dateTxtStatus(dateTxt);
		if (_v0.$ === 'Verified') {
			return $elm$json$Json$Encode$bool(true);
		} else {
			return $elm$json$Json$Encode$bool(false);
		}
	}();
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2('isVerified', isVerified),
				_Utils_Tuple2(
				'type',
				$elm$json$Json$Encode$string('Date')),
				_Utils_Tuple2(
				'content',
				$elm$json$Json$Encode$string(posixString)),
				_Utils_Tuple2(
				'style',
				$author$project$Data$PDF$Port$encodeStyle(
					$author$project$Data$PDF$Annotation$dateTxtStyle(dateTxt)))
			]));
};
var $author$project$Data$Api$PDF$Upload$encodeSignature = F2(
	function (status, style) {
		var _v0 = function () {
			if (status.$ === 'Unsigned') {
				return _Utils_Tuple2(
					$elm$json$Json$Encode$bool(false),
					$elm$json$Json$Encode$string('Signature'));
			} else {
				var sig = status.a;
				return _Utils_Tuple2(
					$elm$json$Json$Encode$bool(true),
					$elm$json$Json$Encode$string(
						$author$project$Data$PDF$Signature$id(sig)));
			}
		}();
		var isVerified = _v0.a;
		var content = _v0.b;
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'type',
					$elm$json$Json$Encode$string('Signature')),
					_Utils_Tuple2('isVerified', isVerified),
					_Utils_Tuple2('content', content),
					_Utils_Tuple2(
					'style',
					$author$project$Data$PDF$Port$encodeStyle(style))
				]));
	});
var $author$project$Data$PDF$Stamp$fileTypeString = function (fileType) {
	switch (fileType.$) {
		case 'JPG':
			return 'jpg';
		case 'JPEG':
			return 'jpeg';
		case 'PNG':
			return 'png';
		case 'SVG':
			return 'svg';
		default:
			return 'gif';
	}
};
var $author$project$Data$PDF$Stamp$pathInBackend = function (_v0) {
	var stamp = _v0.a;
	return $author$project$Data$Domain$toString(stamp.domain) + ('/' + (stamp.id + ('.' + $author$project$Data$PDF$Stamp$fileTypeString(stamp.fileType))));
};
var $author$project$Data$Api$PDF$Upload$encodeStamp = F2(
	function (status, style) {
		var _v0 = function () {
			if (status.$ === 'Unstamped') {
				return _Utils_Tuple2(
					$elm$json$Json$Encode$bool(false),
					$elm$json$Json$Encode$string('Stamp'));
			} else {
				var stamp = status.a;
				return _Utils_Tuple2(
					$elm$json$Json$Encode$bool(true),
					$elm$json$Json$Encode$string(
						$author$project$Data$PDF$Stamp$pathInBackend(stamp)));
			}
		}();
		var isVerified = _v0.a;
		var content = _v0.b;
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'type',
					$elm$json$Json$Encode$string('Stamp')),
					_Utils_Tuple2('isVerified', isVerified),
					_Utils_Tuple2('content', content),
					_Utils_Tuple2(
					'style',
					$author$project$Data$PDF$Port$encodeStyle(style))
				]));
	});
var $author$project$Data$Api$PDF$Upload$encodeTxt = F2(
	function (txtType, txt) {
		var isVerified = function () {
			var _v0 = $author$project$Data$PDF$Annotation$txtStatus(txt);
			if (_v0.$ === 'Verified') {
				return $elm$json$Json$Encode$bool(true);
			} else {
				return $elm$json$Json$Encode$bool(false);
			}
		}();
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2('isVerified', isVerified),
					_Utils_Tuple2(
					'type',
					$elm$json$Json$Encode$string(txtType)),
					_Utils_Tuple2(
					'content',
					$elm$json$Json$Encode$string(
						$author$project$Data$PDF$Annotation$txtText(txt))),
					_Utils_Tuple2(
					'style',
					$author$project$Data$PDF$Port$encodeStyle(
						$author$project$Data$PDF$Annotation$txtStyle(txt)))
				]));
	});
var $author$project$Data$Api$PDF$Upload$encodeAnnotation = function (annot) {
	switch (annot.$) {
		case 'Name':
			var txt = annot.a;
			return A2($author$project$Data$Api$PDF$Upload$encodeTxt, 'Name', txt);
		case 'Date':
			var dateTxt = annot.a;
			return $author$project$Data$Api$PDF$Upload$encodeDateTxt(dateTxt);
		case 'EditableText':
			var txt = annot.a;
			return A2($author$project$Data$Api$PDF$Upload$encodeTxt, 'EditableText', txt);
		case 'NonEditableText':
			var txt = annot.a;
			return A2($author$project$Data$Api$PDF$Upload$encodeTxt, 'NonEditableText', txt);
		case 'IsSignature':
			var signature = annot.a;
			var _v1 = $author$project$Data$PDF$Annotation$signatureFields(signature);
			var signatureStatus = _v1.b;
			var style = _v1.c;
			return A2($author$project$Data$Api$PDF$Upload$encodeSignature, signatureStatus, style);
		case 'IsStamp':
			var stamp = annot.a;
			var _v2 = $author$project$Data$PDF$Annotation$stampFields(stamp);
			var stampStatus = _v2.b;
			var style = _v2.c;
			return A2($author$project$Data$Api$PDF$Upload$encodeStamp, stampStatus, style);
		case 'IsEmail':
			var txt = annot.a;
			return A2($author$project$Data$Api$PDF$Upload$encodeTxt, 'Email', txt);
		default:
			var checkbox = annot.a;
			return $author$project$Data$Api$PDF$Upload$encodeCheckbox(checkbox);
	}
};
var $author$project$Data$Api$PDF$Upload$encodeAnnotList = function (annotations) {
	return A2($elm$json$Json$Encode$list, $author$project$Data$Api$PDF$Upload$encodeAnnotation, annotations);
};
var $author$project$Data$PDF$signOrder = function (_v0) {
	var info = _v0.a;
	return info.signOrder;
};
var $author$project$Data$PDF$signerSignature = function (_v0) {
	var info = _v0.a;
	return info.signature;
};
var $author$project$Data$PDF$signerUser = function (_v0) {
	var info = _v0.a;
	return info.user;
};
var $author$project$Data$Api$PDF$Upload$userEncodedList = function (user) {
	return _List_fromArray(
		[
			_Utils_Tuple2(
			'email',
			$elm$json$Json$Encode$string(
				$author$project$Data$PDF$User$emailFromUser(user))),
			_Utils_Tuple2(
			'firstName',
			$elm$json$Json$Encode$string(
				$author$project$Data$PDF$User$userInfo(user).firstName)),
			_Utils_Tuple2(
			'lastName',
			$elm$json$Json$Encode$string(
				$author$project$Data$PDF$User$userInfo(user).lastName))
		]);
};
var $author$project$Data$Api$PDF$Upload$encodeSigner = function (signer) {
	var signature = $author$project$Data$PDF$Annotation$IsSignature(
		$author$project$Data$PDF$signerSignature(signer));
	return $elm$json$Json$Encode$object(
		_Utils_ap(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'signOrder',
					$elm$json$Json$Encode$int(
						$author$project$Data$PDF$signOrder(signer))),
					_Utils_Tuple2(
					'annotations',
					$author$project$Data$Api$PDF$Upload$encodeAnnotList(
						A2(
							$elm$core$List$cons,
							signature,
							$author$project$Data$PDF$annotations(signer)))),
					_Utils_Tuple2('domain', $elm$json$Json$Encode$null)
				]),
			$author$project$Data$Api$PDF$Upload$userEncodedList(
				$author$project$Data$PDF$signerUser(signer))));
};
var $author$project$Data$Api$PDF$Upload$encodeSignerList = function (signers) {
	return A2($elm$json$Json$Encode$list, $author$project$Data$Api$PDF$Upload$encodeSigner, signers);
};
var $author$project$Data$PDF$viewerUser = function (_v0) {
	var user = _v0.a;
	return user;
};
var $author$project$Data$Api$PDF$Upload$encodeViewer = function (viewer) {
	return $elm$json$Json$Encode$object(
		$author$project$Data$Api$PDF$Upload$userEncodedList(
			$author$project$Data$PDF$viewerUser(viewer)));
};
var $author$project$Data$Api$PDF$Upload$encodeViewerList = function (viewers) {
	return A2($elm$json$Json$Encode$list, $author$project$Data$Api$PDF$Upload$encodeViewer, viewers);
};
var $author$project$Data$PDF$owner = function (_v0) {
	var pdf = _v0.a;
	return pdf.owner;
};
var $author$project$Data$PDF$requireNotarisation = function (_v0) {
	var pdf = _v0.a;
	return pdf.requireNotarisation;
};
var $author$project$Data$PDF$signers = function (_v0) {
	var pdf = _v0.a;
	return pdf.signers;
};
var $author$project$Data$PDF$title = function (_v0) {
	var pdf = _v0.a;
	return pdf.title;
};
var $author$project$Data$PDF$viewers = function (_v0) {
	var pdf = _v0.a;
	return pdf.viewers;
};
var $author$project$Data$Api$PDF$Upload$encode = F4(
	function (pdf, passcode, saveDocument, offset) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'signers',
					$author$project$Data$Api$PDF$Upload$encodeSignerList(
						$elm$core$Dict$values(
							$author$project$Data$PDF$signers(pdf)))),
					_Utils_Tuple2(
					'viewers',
					$author$project$Data$Api$PDF$Upload$encodeViewerList(
						$author$project$Data$PDF$viewers(pdf))),
					_Utils_Tuple2(
					'domain',
					$author$project$Data$Domain$encode(
						$author$project$Data$PDF$domain(pdf))),
					_Utils_Tuple2(
					'ownerEmail',
					$elm$json$Json$Encode$string(
						$author$project$Data$PDF$User$emailFromUser(
							$author$project$Data$PDF$owner(pdf)))),
					_Utils_Tuple2(
					'title',
					$elm$json$Json$Encode$string(
						$author$project$Data$PDF$title(pdf))),
					_Utils_Tuple2(
					'fileName',
					$elm$json$Json$Encode$string(
						$author$project$Data$PDF$title(pdf))),
					_Utils_Tuple2(
					'docPassword',
					A2(
						$elm$core$Maybe$withDefault,
						$elm$json$Json$Encode$null,
						A2(
							$elm$core$Maybe$map,
							$elm$json$Json$Encode$string,
							$author$project$Data$PDF$docPassword(pdf)))),
					_Utils_Tuple2(
					'dueDate',
					A2(
						$elm$core$Maybe$withDefault,
						$elm$json$Json$Encode$null,
						A2(
							$elm$core$Maybe$map,
							$elm$json$Json$Encode$string,
							$author$project$Data$PDF$dueDate(pdf)))),
					_Utils_Tuple2(
					'additionalMsg',
					A2(
						$elm$core$Maybe$withDefault,
						$elm$json$Json$Encode$null,
						A2(
							$elm$core$Maybe$map,
							$elm$json$Json$Encode$string,
							$author$project$Data$PDF$additionalMsg(pdf)))),
					_Utils_Tuple2(
					'requireNotarisation',
					$elm$json$Json$Encode$bool(
						$author$project$Data$PDF$requireNotarisation(pdf))),
					_Utils_Tuple2(
					'passcode',
					A2(
						$elm$core$Maybe$withDefault,
						$elm$json$Json$Encode$null,
						A2($elm$core$Maybe$map, $elm$json$Json$Encode$string, passcode))),
					_Utils_Tuple2(
					'saveDocument',
					$elm$json$Json$Encode$bool(saveDocument)),
					_Utils_Tuple2(
					'offset',
					$elm$json$Json$Encode$string(offset))
				]));
	});
var $author$project$Data$Api$PDF$Upload$encodeToString = F4(
	function (pdf, passcode, saveDocument, offset) {
		return A2(
			$elm$json$Json$Encode$encode,
			0,
			A4($author$project$Data$Api$PDF$Upload$encode, pdf, passcode, saveDocument, offset));
	});
var $author$project$Data$Api$PDF$Upload$APPEND_ERROR = {$: 'APPEND_ERROR'};
var $author$project$Data$Api$PDF$Upload$FILE_NOT_FOUND = {$: 'FILE_NOT_FOUND'};
var $author$project$Data$Api$PDF$Upload$FILE_TOO_BIG = {$: 'FILE_TOO_BIG'};
var $author$project$Data$Api$PDF$Upload$INCORRECT_PASSWORD = {$: 'INCORRECT_PASSWORD'};
var $author$project$Data$Api$PDF$Upload$INSUFFICIENT_POINTS = {$: 'INSUFFICIENT_POINTS'};
var $author$project$Data$Api$PDF$Upload$INSUFFICIENT_POINTS_SIGNING = {$: 'INSUFFICIENT_POINTS_SIGNING'};
var $author$project$Data$Api$PDF$Upload$INVALID_CERTIFICATE = {$: 'INVALID_CERTIFICATE'};
var $author$project$Data$Api$PDF$Upload$INVALID_DATA = {$: 'INVALID_DATA'};
var $author$project$Data$Api$PDF$Upload$INVALID_PASSCODE_FORMAT = {$: 'INVALID_PASSCODE_FORMAT'};
var $author$project$Data$Api$PDF$Upload$LOADING_ERROR = {$: 'LOADING_ERROR'};
var $author$project$Data$Api$PDF$Upload$SIGNATURE_HASH_ERROR = {$: 'SIGNATURE_HASH_ERROR'};
var $author$project$Data$Api$PDF$Upload$TEMP_FILE_NOT_FOUND = {$: 'TEMP_FILE_NOT_FOUND'};
var $author$project$Data$Api$PDF$Upload$UNEDITABLE_PDF = {$: 'UNEDITABLE_PDF'};
var $author$project$Data$Api$PDF$Upload$UNKNOWN = {$: 'UNKNOWN'};
var $author$project$Data$Api$PDF$Upload$WRONG_FILE_FORMAT = {$: 'WRONG_FILE_FORMAT'};
var $author$project$Data$Api$PDF$Upload$errorDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (errorCode) {
		switch (errorCode) {
			case 'FILE_TOO_BIG':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$PDF$Upload$FILE_TOO_BIG);
			case 'WRONG_FILE_FORMAT':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$PDF$Upload$WRONG_FILE_FORMAT);
			case 'INVALID_DATA':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$PDF$Upload$INVALID_DATA);
			case 'INCORRECT_PASSWORD':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$PDF$Upload$INCORRECT_PASSWORD);
			case 'APPEND_ERROR':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$PDF$Upload$APPEND_ERROR);
			case 'INVALID_CERTIFICATE':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$PDF$Upload$INVALID_CERTIFICATE);
			case 'UNEDITABLE_PDF':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$PDF$Upload$UNEDITABLE_PDF);
			case 'LOADING_ERROR':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$PDF$Upload$LOADING_ERROR);
			case 'SIGNATURE_HASH_ERROR':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$PDF$Upload$SIGNATURE_HASH_ERROR);
			case 'FILE_NOT_FOUND':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$PDF$Upload$FILE_NOT_FOUND);
			case 'TEMP_FILE_NOT_FOUND':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$PDF$Upload$TEMP_FILE_NOT_FOUND);
			case 'INVALID_PASSCODE_FORMAT':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$PDF$Upload$INVALID_PASSCODE_FORMAT);
			case 'UNKNOWN':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$PDF$Upload$UNKNOWN);
			case 'INSUFFICIENT_POINTS_SIGNING':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$PDF$Upload$INSUFFICIENT_POINTS_SIGNING);
			case 'INSUFFICIENT_POINTS':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$PDF$Upload$INSUFFICIENT_POINTS);
			default:
				return $elm$json$Json$Decode$fail('Invalid error code: ' + errorCode);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Data$Api$PDF$Upload$upload = F7(
	function (jwt, endPoint, passcode, pdf, file, saveDocument, offset) {
		return A5(
			$author$project$Data$Api$authUpload,
			jwt,
			endPoint,
			$author$project$Data$Api$PDF$Upload$errorDecoder,
			$author$project$Data$Api$PDF$Upload$dataDecoder,
			_List_fromArray(
				[
					A2(
					$elm$http$Http$stringPart,
					'data',
					A4(
						$author$project$Data$Api$PDF$Upload$encodeToString,
						pdf,
						passcode,
						saveDocument,
						$elm$core$String$fromFloat(offset))),
					A2($elm$http$Http$filePart, 'file', file)
				]));
	});
var $author$project$Model$UploadMultipleDocument$validateName = function (name) {
	return (!$elm$core$String$isEmpty(name)) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just('Name cannot be empty');
};
var $author$project$Model$UploadMultipleDocument$validateRecipientNotOwner = F3(
	function (recipientEmail, ownerEmail, maybeError) {
		if (maybeError.$ === 'Just') {
			var value = maybeError.a;
			return $elm$core$Maybe$Just(value);
		} else {
			return _Utils_eq(recipientEmail, ownerEmail) ? $elm$core$Maybe$Just('Unable to add yourself as a signer.') : $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Model$UploadMultipleDocument$validateAll = F2(
	function (addRecipient, ownerEmail) {
		var _v0 = addRecipient;
		var firstName = _v0.firstName;
		var lastName = _v0.lastName;
		var email = _v0.email;
		var updatedAddRecipient = _Utils_update(
			addRecipient,
			{
				emailError: A3(
					$author$project$Model$UploadMultipleDocument$validateRecipientNotOwner,
					email,
					ownerEmail,
					$author$project$Data$Validator$validateEmail(email)),
				firstNameError: $author$project$Model$UploadMultipleDocument$validateName(firstName),
				lastNameError: $author$project$Model$UploadMultipleDocument$validateName(lastName)
			});
		return _Utils_Tuple2(
			A2(
				$elm$core$List$all,
				$elm$core$Basics$eq($elm$core$Maybe$Nothing),
				_List_fromArray(
					[updatedAddRecipient.emailError, updatedAddRecipient.firstNameError, updatedAddRecipient.lastNameError])),
			updatedAddRecipient);
	});
var $author$project$Model$UploadMultipleDocument$validateDueDate = F3(
	function (timezone, currentTime, dueDate) {
		return A2(
			$elm$core$Maybe$andThen,
			function (date) {
				var currentDate = A3(
					$ryannhg$date_format$DateFormat$format,
					_List_fromArray(
						[
							$ryannhg$date_format$DateFormat$yearNumber,
							$ryannhg$date_format$DateFormat$text('-'),
							$ryannhg$date_format$DateFormat$monthFixed,
							$ryannhg$date_format$DateFormat$text('-'),
							$ryannhg$date_format$DateFormat$dayOfMonthFixed
						]),
					timezone,
					currentTime);
				var correctFormat = A2(
					$elm$regex$Regex$contains,
					A2(
						$elm$core$Maybe$withDefault,
						$elm$regex$Regex$never,
						$elm$regex$Regex$fromString('^\\d{4}-\\d{2}-\\d{2}$')),
					date);
				return ((!correctFormat) || (_Utils_cmp(date, currentDate) < 0)) ? $elm$core$Maybe$Just('Invalid Due Date') : $elm$core$Maybe$Nothing;
			},
			dueDate);
	});
var $author$project$Model$UploadMultipleDocument$validatePasscode = F2(
	function (passcode, showPasscodeInput) {
		var correctFormat = A2(
			$elm$regex$Regex$contains,
			A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('^[0-9]{4,8}$')),
			A2($elm$core$Maybe$withDefault, '', passcode));
		return ((!correctFormat) && showPasscodeInput) ? $elm$core$Maybe$Just('Passcode can only be of 4-8 numeric characters.') : $elm$core$Maybe$Nothing;
	});
var $author$project$Model$UploadMultipleDocument$validateTitle = function (title) {
	return (!$elm$core$String$isEmpty(title)) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just('Title cannot be empty');
};
var $author$project$Model$UploadMultipleDocument$update = F3(
	function (msg, authModel, model) {
		var _v0 = authModel.uploadMultipleDocModel;
		if (_v0.$ === 'NotLoaded') {
			if (msg.$ === 'OnSignatureTimestampingAlgorandResult') {
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			} else {
				return _Utils_Tuple2(
					model,
					A2($elm$browser$Browser$Navigation$replaceUrl, model.navKey, $author$project$Data$Route$routeUrl.newMultipleDoc));
			}
		} else {
			var loadedModel = _v0.a;
			var updateCurrentModel = function (m) {
				return _Utils_update(
					model,
					{
						sessionModel: $author$project$Types$Auth(
							_Utils_update(
								authModel,
								{
									uploadMultipleDocModel: $author$project$Type$UploadMultipleDocument$Loaded(m)
								}))
					});
			};
			var _v2 = loadedModel;
			var addRecipient = _v2.addRecipient;
			var lastStyle = _v2.lastStyle;
			switch (msg.$) {
				case 'OnUnload':
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								sessionModel: $author$project$Types$Auth(
									_Utils_update(
										authModel,
										{uploadMultipleDocModel: $author$project$Type$UploadMultipleDocument$NotLoaded}))
							}),
						$author$project$Data$PDF$Create$unload(_Utils_Tuple0));
				case 'OnOwnerRoleChange':
					var role = msg.a;
					var _v4 = loadedModel.pdfList;
					if (_v4.b) {
						var first = _v4.a;
						var rest = _v4.b;
						var remainingPDF = A2(
							$elm$core$List$map,
							function (pdfData) {
								return _Utils_update(
									pdfData,
									{
										pdf: A2($author$project$Data$PDF$Create$updateOwnerRole, pdfData.pdf, role).a
									});
							},
							rest);
						var _v5 = A2($author$project$Data$PDF$Create$updateOwnerRole, first.pdf, role);
						var firstPDF = _v5.a;
						var pdfMsg = _v5.b;
						var updatedFirstPDF = _Utils_update(
							first,
							{pdf: firstPDF});
						return _Utils_Tuple2(
							updateCurrentModel(
								_Utils_update(
									loadedModel,
									{
										pdf: firstPDF,
										pdfList: A2($elm$core$List$cons, updatedFirstPDF, remainingPDF)
									})),
							pdfMsg);
					} else {
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					}
				case 'OnReceiveEncryptionError':
					var value = msg.a;
					var _v6 = $author$project$Data$PDF$Encryption$decode(value);
					if (_v6.$ === 'Ok') {
						var encryptionError = _v6.a;
						if (encryptionError.$ === 'PasswordFail') {
							return _Utils_Tuple2(
								updateCurrentModel(
									_Utils_update(
										loadedModel,
										{
											passwordError: $elm$core$Maybe$Just('Password failed.'),
											status: $author$project$Type$UploadMultipleDocument$NeedPassword
										})),
								$elm$core$Platform$Cmd$none);
						} else {
							return _Utils_Tuple2(
								updateCurrentModel(
									_Utils_update(
										loadedModel,
										{passwordError: $elm$core$Maybe$Nothing, status: $author$project$Type$UploadMultipleDocument$NeedPassword})),
								$elm$core$Platform$Cmd$none);
						}
					} else {
						var decodeErrorMessage = _v6.a;
						return _Utils_Tuple2(
							updateCurrentModel(
								_Utils_update(
									loadedModel,
									{
										status: $author$project$Type$UploadMultipleDocument$Error(decodeErrorMessage)
									})),
							$elm$core$Platform$Cmd$none);
					}
				case 'OnPasswordInput':
					var value = msg.a;
					return $elm$core$String$isEmpty(value) ? _Utils_Tuple2(
						updateCurrentModel(
							_Utils_update(
								loadedModel,
								{password: $elm$core$Maybe$Nothing, passwordError: $elm$core$Maybe$Nothing})),
						$elm$core$Platform$Cmd$none) : _Utils_Tuple2(
						updateCurrentModel(
							_Utils_update(
								loadedModel,
								{
									password: $elm$core$Maybe$Just(value),
									passwordError: $elm$core$Maybe$Nothing
								})),
						$elm$core$Platform$Cmd$none);
				case 'OnPasswordSubmit':
					var _v8 = A4(
						$author$project$Data$PDF$Create$loadWithPassword,
						A2($elm$core$Maybe$withDefault, '', loadedModel.password),
						loadedModel.pdf,
						$author$project$Type$File$PDF,
						$author$project$Data$PDF$Create$MultipleDocument);
					var pdf = _v8.a;
					var pdfCmd = _v8.b;
					return _Utils_Tuple2(
						updateCurrentModel(
							_Utils_update(
								loadedModel,
								{pdf: pdf, status: $author$project$Type$UploadMultipleDocument$Editing})),
						pdfCmd);
				case 'OnAnnotClick':
					var user = msg.a;
					var annot = msg.b;
					var updatedModel = updateCurrentModel(
						_Utils_update(
							loadedModel,
							{
								selectedAnnot: $elm$core$Maybe$Just(
									{annotation: annot, user: user})
							}));
					var pdfOwnerEmail = $author$project$Data$PDF$User$emailFromUser(
						$author$project$Data$PDF$Create$getOwner(loadedModel.pdf).user);
					var isOwnerAnnot = _Utils_eq(
						$author$project$Data$PDF$User$emailFromUser(user),
						pdfOwnerEmail);
					return ($author$project$Data$PDF$Annotation$isDate(annot) && isOwnerAnnot) ? _Utils_Tuple2(
						updatedModel,
						A2(
							$elm$core$Task$attempt,
							A2(
								$elm$core$Basics$composeL,
								A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnMultipleDocUpload),
								$author$project$Type$UploadMultipleDocument$SetDateToAnnot),
							$elm$time$Time$now)) : (($author$project$Data$PDF$Annotation$isTextAnnot(annot) && (!isOwnerAnnot)) ? _Utils_Tuple2(
						updateCurrentModel(
							_Utils_update(
								loadedModel,
								{
									status: A2($author$project$Type$UploadMultipleDocument$ConfirmTextAnnotTitle, user, annot)
								})),
						A2(
							$elm$core$Task$attempt,
							function (_v9) {
								return $author$project$Types$Noop;
							},
							$elm$browser$Browser$Dom$focus('recipientAnnot'))) : (($author$project$Data$PDF$Annotation$isCheckboxAnnot(annot) && (isOwnerAnnot && _Utils_eq(loadedModel.checkboxNotificationStatus, $author$project$Type$UploadMultipleDocument$NotNotified))) ? _Utils_Tuple2(
						updateCurrentModel(
							_Utils_update(
								loadedModel,
								{
									checkboxNotificationStatus: $author$project$Type$UploadMultipleDocument$Notified,
									status: A2($author$project$Type$UploadMultipleDocument$ConfirmCheckboxNotification, user, annot)
								})),
						$elm$core$Platform$Cmd$none) : _Utils_Tuple2(updatedModel, $elm$core$Platform$Cmd$none)));
				case 'OnReceiveClickAnnotData':
					var value = msg.a;
					var _v10 = loadedModel.selectedAnnot;
					if (_v10.$ === 'Just') {
						var selected = _v10.a;
						var selectedPDF = $elm$core$List$head(
							A2(
								$elm$core$List$filter,
								function (pdfData) {
									return _Utils_eq(pdfData.id, loadedModel.selectedPDF);
								},
								loadedModel.pdfList));
						var currentSignOrder = A2(
							$elm$core$Maybe$withDefault,
							0,
							$elm$core$List$head(
								A2(
									$elm$core$List$filterMap,
									function (signData) {
										return _Utils_eq(
											$author$project$Data$PDF$User$emailFromUser(signData.user),
											$author$project$Data$PDF$User$emailFromUser(selected.user)) ? $elm$core$Maybe$Just(signData.signOrder) : $elm$core$Maybe$Nothing;
									},
									loadedModel.signOrderData)));
						var result = function () {
							if (selectedPDF.$ === 'Just') {
								var pdfData = selectedPDF.a;
								return A4($author$project$Data$PDF$Create$addAnnotation, value, selected, pdfData.pdf, currentSignOrder);
							} else {
								return $elm$core$Result$Err('File not found');
							}
						}();
						if (result.$ === 'Ok') {
							var _v12 = result.a;
							var updatedPDF = _v12.a;
							var pdfCmd = _v12.b;
							var updatedList = A2(
								$elm$core$List$map,
								function (pdfData) {
									return _Utils_eq(
										$author$project$Data$PDF$Create$getBase64Data(pdfData.pdf),
										$author$project$Data$PDF$Create$getBase64Data(updatedPDF)) ? _Utils_update(
										pdfData,
										{pdf: updatedPDF}) : pdfData;
								},
								loadedModel.pdfList);
							return _Utils_Tuple2(
								updateCurrentModel(
									_Utils_update(
										loadedModel,
										{pdf: updatedPDF, pdfList: updatedList, selectedAnnot: $elm$core$Maybe$Nothing})),
								pdfCmd);
						} else {
							var err = result.a;
							return _Utils_Tuple2(
								updateCurrentModel(
									_Utils_update(
										loadedModel,
										{
											status: $author$project$Type$UploadMultipleDocument$Error(err)
										})),
								$elm$core$Platform$Cmd$none);
						}
					} else {
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					}
				case 'OnReceiveModifiedAnnotData':
					var value = msg.a;
					var _v14 = $author$project$Data$PDF$Port$decodeAnnotDataResult(value);
					if (_v14.$ === 'Ok') {
						var annotationDataList = _v14.a;
						var _v15 = A2($author$project$Data$PDF$Create$updateAnnotations, annotationDataList, loadedModel.pdf);
						var updatedPDF = _v15.a;
						var pdfCmd = _v15.b;
						var updatedList = A2(
							$elm$core$List$map,
							function (pdfData) {
								return _Utils_eq(
									$author$project$Data$PDF$Create$getBase64Data(pdfData.pdf),
									$author$project$Data$PDF$Create$getBase64Data(updatedPDF)) ? _Utils_update(
									pdfData,
									{pdf: updatedPDF}) : pdfData;
							},
							loadedModel.pdfList);
						return _Utils_Tuple2(
							updateCurrentModel(
								_Utils_update(
									loadedModel,
									{
										lastStyle: A2($author$project$Model$UploadMultipleDocument$updateLastStyle, annotationDataList, loadedModel.lastStyle),
										pdf: updatedPDF,
										pdfList: updatedList
									})),
							pdfCmd);
					} else {
						var err = _v14.a;
						return _Utils_Tuple2(
							updateCurrentModel(
								_Utils_update(
									loadedModel,
									{
										status: $author$project$Type$UploadMultipleDocument$Error(err)
									})),
							$elm$core$Platform$Cmd$none);
					}
				case 'OnReceiveDeleteAnnotsData':
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				case 'SetDateToAnnot':
					var value = msg.a;
					if (value.$ === 'Ok') {
						var time = value.a;
						var _v17 = loadedModel.selectedAnnot;
						if (_v17.$ === 'Just') {
							var selected = _v17.a;
							var updatedDateSelected = function (selectedDateAnnot) {
								return _Utils_update(
									selectedDateAnnot,
									{
										annotation: A2($author$project$Data$PDF$Annotation$updateDateAnnot, time, selected.annotation)
									});
							};
							return _Utils_Tuple2(
								updateCurrentModel(
									_Utils_update(
										loadedModel,
										{
											selectedAnnot: $elm$core$Maybe$Just(
												updatedDateSelected(selected))
										})),
								$elm$core$Platform$Cmd$none);
						} else {
							return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
						}
					} else {
						return _Utils_Tuple2(
							updateCurrentModel(
								_Utils_update(
									loadedModel,
									{
										selectedAnnot: $elm$core$Maybe$Nothing,
										status: $author$project$Type$UploadMultipleDocument$Error('Unable to the get current time.')
									})),
							$elm$core$Platform$Cmd$none);
					}
				case 'OnRemoveRecipientClick':
					var email = msg.a;
					var updatedPDFList = A2(
						$elm$core$List$map,
						function (pdfData) {
							var newData = A2($author$project$Data$PDF$Create$removeRecipientWithoutMsg, email, pdfData.pdf);
							return _Utils_update(
								pdfData,
								{pdf: newData});
						},
						loadedModel.pdfList);
					var _v18 = A2($author$project$Data$PDF$Create$removeRecipient, email, loadedModel.pdf);
					var updatedPDF = _v18.a;
					var pdfMsg = _v18.b;
					return _Utils_Tuple2(
						updateCurrentModel(
							_Utils_update(
								loadedModel,
								{pdf: updatedPDF, pdfList: updatedPDFList})),
						pdfMsg);
				case 'OnAddRecipientInput':
					var field = msg.a;
					var value = msg.b;
					switch (field.$) {
						case 'Role':
							return _Utils_Tuple2(
								updateCurrentModel(
									_Utils_update(
										loadedModel,
										{
											addRecipient: _Utils_update(
												addRecipient,
												{
													role: $author$project$Data$PDF$Create$toRole(value)
												})
										})),
								$elm$core$Platform$Cmd$none);
						case 'FirstName':
							return _Utils_Tuple2(
								updateCurrentModel(
									_Utils_update(
										loadedModel,
										{
											addRecipient: _Utils_update(
												addRecipient,
												{firstName: value})
										})),
								$elm$core$Platform$Cmd$none);
						case 'LastName':
							return _Utils_Tuple2(
								updateCurrentModel(
									_Utils_update(
										loadedModel,
										{
											addRecipient: _Utils_update(
												addRecipient,
												{lastName: value})
										})),
								$elm$core$Platform$Cmd$none);
						case 'Email':
							return _Utils_Tuple2(
								updateCurrentModel(
									_Utils_update(
										loadedModel,
										{
											addRecipient: _Utils_update(
												addRecipient,
												{email: value})
										})),
								$elm$core$Platform$Cmd$none);
						default:
							return _Utils_Tuple2(
								updateCurrentModel(
									_Utils_update(
										loadedModel,
										{
											addRecipient: _Utils_update(
												addRecipient,
												{search: value})
										})),
								$author$project$Model$UploadMultipleDocument$startDebounceTime(
									$elm$json$Json$Encode$string('MultipleDocument')));
					}
				case 'OnAddRecipientBlur':
					var field = msg.a;
					switch (field.$) {
						case 'Email':
							return _Utils_Tuple2(
								updateCurrentModel(
									_Utils_update(
										loadedModel,
										{
											addRecipient: _Utils_update(
												addRecipient,
												{
													emailError: $author$project$Data$Validator$validateEmail(addRecipient.email)
												})
										})),
								$elm$core$Platform$Cmd$none);
						case 'FirstName':
							return _Utils_Tuple2(
								updateCurrentModel(
									_Utils_update(
										loadedModel,
										{
											addRecipient: _Utils_update(
												addRecipient,
												{
													firstNameError: $author$project$Model$UploadMultipleDocument$validateName(addRecipient.firstName)
												})
										})),
								$elm$core$Platform$Cmd$none);
						case 'LastName':
							return _Utils_Tuple2(
								updateCurrentModel(
									_Utils_update(
										loadedModel,
										{
											addRecipient: _Utils_update(
												addRecipient,
												{
													lastNameError: $author$project$Model$UploadMultipleDocument$validateName(addRecipient.lastName)
												})
										})),
								$elm$core$Platform$Cmd$none);
						case 'Role':
							return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
						default:
							return _Utils_Tuple2(
								model,
								$author$project$Model$UploadMultipleDocument$startBlurTime(
									$elm$json$Json$Encode$string('MultipleDocument')));
					}
				case 'OnAddRecipientSubmit':
					var pdfOwnerEmail = $author$project$Data$PDF$User$emailFromUser(
						$author$project$Data$PDF$Create$getOwner(loadedModel.pdf).user);
					var _v21 = A2($author$project$Model$UploadMultipleDocument$validateAll, addRecipient, pdfOwnerEmail);
					var allPassed = _v21.a;
					var updatedAddRecipient = _v21.b;
					var emptyAddRecipient = _Utils_update(
						updatedAddRecipient,
						{display: false, email: '', firstName: '', lastName: '', role: $author$project$Data$PDF$Create$Viewer, search: ''});
					var _v22 = addRecipient;
					var firstName = _v22.firstName;
					var lastName = _v22.lastName;
					var email = _v22.email;
					var role = _v22.role;
					if (allPassed) {
						var updatedPDFList = A2(
							$elm$core$List$map,
							function (pdfData) {
								var newData = A5($author$project$Data$PDF$Create$addRecipientWithoutMsg, email, firstName, lastName, $author$project$Data$PDF$Create$Viewer, pdfData.pdf);
								return _Utils_update(
									pdfData,
									{pdf: newData});
							},
							loadedModel.pdfList);
						var isExistingRecipient = A2(
							$elm$core$List$any,
							function (signData) {
								return _Utils_eq(
									$author$project$Data$PDF$User$emailFromUser(signData.user),
									email);
							},
							loadedModel.signOrderData);
						var _v23 = A5($author$project$Data$PDF$Create$addRecipient, email, firstName, lastName, $author$project$Data$PDF$Create$Viewer, loadedModel.pdf);
						var updatedPDF = _v23.updatedPDF;
						var pdfMsg = _v23.pdfMsg;
						var recipient = _v23.recipient;
						var updatedSigningOrder = isExistingRecipient ? A2(
							$elm$core$List$map,
							function (signData) {
								return _Utils_eq(
									$author$project$Data$PDF$User$emailFromUser(signData.user),
									email) ? _Utils_update(
									signData,
									{signOrder: recipient.signOrder, user: recipient.user}) : signData;
							},
							loadedModel.signOrderData) : A2(
							$elm$core$List$cons,
							{signOrder: recipient.signOrder, user: recipient.user},
							loadedModel.signOrderData);
						return _Utils_Tuple2(
							updateCurrentModel(
								_Utils_update(
									loadedModel,
									{addRecipient: emptyAddRecipient, pdf: updatedPDF, pdfList: updatedPDFList, signOrderData: updatedSigningOrder})),
							pdfMsg);
					} else {
						return _Utils_Tuple2(
							updateCurrentModel(
								_Utils_update(
									loadedModel,
									{addRecipient: updatedAddRecipient})),
							$elm$core$Platform$Cmd$none);
					}
				case 'OnErrorClose':
					return _Utils_Tuple2(
						updateCurrentModel(
							_Utils_update(
								loadedModel,
								{status: $author$project$Type$UploadMultipleDocument$Editing})),
						$elm$core$Platform$Cmd$none);
				case 'OnDocSubmit':
					var getFirstError = function (errors) {
						if (errors.$ === 'Ok') {
							return 'An error has occured. Please try again later.';
						} else {
							var error = errors.a;
							return A2(
								$elm$core$Maybe$withDefault,
								'An error has occured. Please try again later.',
								$elm$core$List$head(error));
						}
					};
					var getFirstErrorMsg = function (errorsList) {
						var _v29 = $elm$core$List$head(errorsList);
						if (_v29.$ === 'Just') {
							var errors = _v29.a;
							return getFirstError(errors);
						} else {
							return 'An error has occured. Please try again later.';
						}
					};
					var _v24 = loadedModel;
					var title = _v24.title;
					var dueDate = _v24.dueDate;
					var additionalMsg = _v24.additionalMsg;
					var requireNotarisation = _v24.requireNotarisation;
					var passcode = _v24.passcode;
					var showPasscodeInput = _v24.showPasscodeInput;
					var updatedPDFList = A2(
						$elm$core$List$map,
						function (pdfData) {
							return _Utils_update(
								pdfData,
								{
									pdf: A2(
										$author$project$Data$PDF$Create$setRequireNotarisation,
										requireNotarisation,
										A2(
											$author$project$Data$PDF$Create$setAdditionalMsg,
											additionalMsg,
											A2($author$project$Data$PDF$Create$setDueDate, dueDate, pdfData.pdf)))
								});
						},
						loadedModel.pdfList);
					var updatedLoadedModel = _Utils_update(
						loadedModel,
						{
							dueDateError: A3($author$project$Model$UploadMultipleDocument$validateDueDate, model.timezone, model.currentTime, dueDate),
							passcodeError: A2($author$project$Model$UploadMultipleDocument$validatePasscode, passcode, showPasscodeInput),
							pdfList: updatedPDFList,
							titleError: $author$project$Model$UploadMultipleDocument$validateTitle(title)
						});
					var _v25 = $elm$core$List$unzip(
						A2(
							$elm$core$List$map,
							function (pdfData) {
								return _Utils_Tuple2(
									$author$project$Model$UploadMultipleDocument$validateTitle(
										$author$project$Data$PDF$Create$title(pdfData.pdf)),
									A2(
										$author$project$Data$PDF$convert,
										pdfData.pdf,
										_Utils_eq(updatedLoadedModel.signingType, $author$project$Type$UploadMultipleDocument$SigningOrder)));
							},
							updatedPDFList));
					var docTitleError = _v25.a;
					var convertedPDFs = _v25.b;
					var _v26 = A2(
						$elm$core$List$partition,
						function (convertedPDF) {
							if (convertedPDF.$ === 'Err') {
								return false;
							} else {
								return true;
							}
						},
						convertedPDFs);
					var convertedList = _v26.a;
					var pdfErrors = _v26.b;
					var formattedList = A2(
						$elm$core$List$map,
						function (convertedPDF) {
							if (convertedPDF.$ === 'Err') {
								return A7(
									$author$project$Data$PDF$init,
									'',
									$elm$core$Maybe$Nothing,
									$elm$core$Maybe$Nothing,
									$author$project$Data$Domain$selected(authModel.user.domains),
									$author$project$Data$PDF$User$UnRegistered(
										{color: $author$project$Data$PDF$User$Transparent, email: 'Dummy_Email@example.com', firstName: 'It is Fake', lastName: 'This is fake', verifyMobilePhone: false, verifyMyInfo: false, verifyPassbase: false, verifyStripe: false, verifyWallet: false}),
									$elm$core$Maybe$Nothing,
									false);
							} else {
								var pdf = convertedPDF.a;
								return pdf;
							}
						},
						convertedList);
					var allPassed = A2(
						$elm$core$List$all,
						$elm$core$Basics$eq($elm$core$Maybe$Nothing),
						_Utils_ap(
							_List_fromArray(
								[updatedLoadedModel.dueDateError, updatedLoadedModel.passcodeError]),
							docTitleError));
					return (allPassed && (!$elm$core$List$isEmpty(pdfErrors))) ? _Utils_Tuple2(
						updateCurrentModel(
							_Utils_update(
								loadedModel,
								{
									convertedPDFList: _List_Nil,
									status: $author$project$Type$UploadMultipleDocument$Error(
										getFirstErrorMsg(pdfErrors))
								})),
						$elm$core$Platform$Cmd$none) : ((allPassed && $elm$core$List$isEmpty(pdfErrors)) ? _Utils_Tuple2(
						updateCurrentModel(
							_Utils_update(
								loadedModel,
								{convertedPDFList: formattedList, status: $author$project$Type$UploadMultipleDocument$Ready})),
						$author$project$Model$UploadMultipleDocument$displaySendDocumentAdsContent(
							$elm$json$Json$Encode$bool(authModel.user.showAds))) : ((showPasscodeInput && $elm$core$String$isEmpty(
						A2($elm$core$Maybe$withDefault, '', passcode))) ? _Utils_Tuple2(
						updateCurrentModel(
							_Utils_update(
								loadedModel,
								{
									convertedPDFList: _List_Nil,
									status: $author$project$Type$UploadMultipleDocument$Error('Passcode cannot be empty if signing request checkcode is checked.')
								})),
						$elm$core$Platform$Cmd$none) : _Utils_Tuple2(
						updateCurrentModel(
							_Utils_update(
								loadedModel,
								{
									convertedPDFList: _List_Nil,
									status: $author$project$Type$UploadMultipleDocument$Error('There are errors with your document.')
								})),
						$elm$core$Platform$Cmd$none)));
				case 'OnDocSubmitUpload':
					var cmdMsgList = _Utils_eq(
						$elm$core$List$length(loadedModel.convertedPDFList),
						$elm$core$List$length(loadedModel.pdfList)) ? A3(
						$elm$core$List$map2,
						F2(
							function (convertedPDF, pdfData) {
								return A2(
									$elm$core$Task$attempt,
									A2(
										$elm$core$Basics$composeL,
										A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnMultipleDocUpload),
										$author$project$Type$UploadMultipleDocument$OnDocSubmitUploadResult(pdfData.id)),
									A7(
										$author$project$Data$Api$PDF$Upload$upload,
										authModel.user.jwt,
										model.apiEndPoint.uploadPdf,
										loadedModel.passcode,
										convertedPDF,
										$author$project$Data$PDF$Create$file(pdfData.pdf),
										_Utils_eq(loadedModel.saveDocumentStatus, $author$project$Type$UploadMultipleDocument$Save),
										model.timezoneOffset / 60));
							}),
						loadedModel.convertedPDFList,
						loadedModel.pdfList) : _List_fromArray(
						[$elm$core$Platform$Cmd$none]);
					return _Utils_Tuple2(
						updateCurrentModel(
							_Utils_update(
								loadedModel,
								{status: $author$project$Type$UploadMultipleDocument$Uploading})),
						$elm$core$Platform$Cmd$batch(cmdMsgList));
				case 'OnDocSubmitUploadResult':
					var pdfID = msg.a;
					var result = msg.b;
					if (result.$ === 'Ok') {
						var value = result.a;
						var updatedList = A2(
							$elm$core$List$map,
							function (pdfData) {
								return _Utils_eq(pdfData.id, pdfID) ? _Utils_update(
									pdfData,
									{
										checksum: value.checksum,
										docId: $elm$core$Maybe$Just(value.documentId),
										isSent: true,
										ownerId: value.ownerId,
										recipient: value.recipient
									}) : pdfData;
							},
							loadedModel.pdfList);
						var isAllSent = A2(
							$elm$core$List$all,
							function ($) {
								return $.isSent;
							},
							updatedList);
						var updatedModel = isAllSent ? updateCurrentModel(
							_Utils_update(
								loadedModel,
								{
									pdfList: updatedList,
									status: A4(
										$author$project$Type$UploadMultipleDocument$Success,
										loadedModel.requireNotarisation,
										authModel.user.paymentMethod,
										A2($elm$core$Maybe$withDefault, '', loadedModel.walletError),
										false)
								})) : updateCurrentModel(
							_Utils_update(
								loadedModel,
								{pdfList: updatedList}));
						return (loadedModel.requireNotarisation && (_Utils_eq(
							$author$project$Model$UploadMultipleDocument$convertStringToPayment(authModel.user.paymentMethod),
							$author$project$Type$Setting$SystemBalance) && _Utils_eq(
							$author$project$Model$UploadMultipleDocument$convertStringToNetwork(authModel.user.notarisationNetwork),
							$author$project$Type$UploadMultipleDocument$Algorand))) ? _Utils_Tuple2(
							updatedModel,
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										A2(
										$elm$core$Task$perform,
										$author$project$Types$OnAuth,
										$elm$core$Task$succeed(
											$author$project$Types$OnMultipleDocUpload(
												A2($author$project$Type$UploadMultipleDocument$OnSignatureTimestampingAlgorand, value.documentId, value.requireSignatureTimeStamping)))),
										$author$project$Model$UploadMultipleDocument$displaySendDocumentAdsContent(
										$elm$json$Json$Encode$bool(authModel.user.showAds))
									]))) : _Utils_Tuple2(
							updatedModel,
							$author$project$Model$UploadMultipleDocument$displaySendDocumentAdsContent(
								$elm$json$Json$Encode$bool(authModel.user.showAds)));
					} else {
						var err = result.a;
						return _Utils_Tuple2(
							updateCurrentModel(
								_Utils_update(
									loadedModel,
									{
										status: $author$project$Type$UploadMultipleDocument$Error(
											A2($author$project$Data$Api$authErrorToString, $author$project$Data$Api$PDF$Upload$errorToString, err))
									})),
							$elm$core$Platform$Cmd$none);
					}
				case 'OnDocSuccessClose':
					var cmdMsg = _Utils_ap(
						_List_fromArray(
							[
								A2($elm$browser$Browser$Navigation$replaceUrl, model.navKey, $author$project$Data$Route$routeUrl.dashboard),
								$author$project$Data$WalletConnect$walletConnectKillSession(_Utils_Tuple0)
							]),
						A2(
							$elm$core$List$filterMap,
							function (pdfData) {
								return ((!_Utils_eq(pdfData.notarizationStatus, $author$project$Type$UploadMultipleDocument$Completed)) && (loadedModel.requireNotarisation && (!_Utils_eq(
									$author$project$Model$UploadMultipleDocument$convertStringToPayment(authModel.user.paymentMethod),
									$author$project$Type$Setting$SystemBalance)))) ? $elm$core$Maybe$Just(
									A2(
										$elm$core$Task$attempt,
										A2(
											$elm$core$Basics$composeL,
											A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnMultipleDocUpload),
											$author$project$Type$UploadMultipleDocument$OnCancelNotarisationResult),
										A3(
											$author$project$Data$Api$PDF$CancelNotarisation$authCall,
											authModel.user.jwt,
											model.apiEndPoint.cancelNotarisation,
											A2($elm$core$Maybe$withDefault, '', pdfData.docId)))) : $elm$core$Maybe$Nothing;
							},
							loadedModel.pdfList));
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								sessionModel: $author$project$Types$Auth(
									_Utils_update(
										authModel,
										{
											newMultipleDocModel: {base64File: $elm$core$Maybe$Nothing, error: $elm$core$Maybe$Nothing, file: $elm$core$Maybe$Nothing, fileHover: false, files: _List_Nil, showModal: false}
										}))
							}),
						$elm$core$Platform$Cmd$batch(cmdMsg));
				case 'OnDocSubmitClose':
					return _Utils_Tuple2(
						updateCurrentModel(
							_Utils_update(
								loadedModel,
								{status: $author$project$Type$UploadMultipleDocument$Editing})),
						$elm$core$Platform$Cmd$none);
				case 'OnDocInput':
					var field = msg.a;
					var value = msg.b;
					switch (field.$) {
						case 'Title':
							return _Utils_Tuple2(
								updateCurrentModel(
									_Utils_update(
										loadedModel,
										{title: value})),
								$elm$core$Platform$Cmd$none);
						case 'DueDate':
							return $elm$core$String$isEmpty(value) ? _Utils_Tuple2(
								updateCurrentModel(
									_Utils_update(
										loadedModel,
										{dueDate: $elm$core$Maybe$Nothing, dueDateError: $elm$core$Maybe$Nothing})),
								$elm$core$Platform$Cmd$none) : _Utils_Tuple2(
								updateCurrentModel(
									_Utils_update(
										loadedModel,
										{
											dueDate: $elm$core$Maybe$Just(value)
										})),
								$elm$core$Platform$Cmd$none);
						default:
							return _Utils_Tuple2(
								updateCurrentModel(
									_Utils_update(
										loadedModel,
										{textAnnotationTitle: value})),
								$elm$core$Platform$Cmd$none);
					}
				case 'OnDocBlur':
					var field = msg.a;
					switch (field.$) {
						case 'Title':
							var updatedPDFList = A2(
								$elm$core$List$map,
								function (pdfData) {
									return _Utils_eq(pdfData.id, loadedModel.selectedPDF) ? _Utils_update(
										pdfData,
										{
											pdf: A2($author$project$Data$PDF$Create$setTitle, loadedModel.title, pdfData.pdf)
										}) : pdfData;
								},
								loadedModel.pdfList);
							return _Utils_Tuple2(
								updateCurrentModel(
									_Utils_update(
										loadedModel,
										{
											pdfList: updatedPDFList,
											titleError: $author$project$Model$UploadMultipleDocument$validateTitle(loadedModel.title)
										})),
								$elm$core$Platform$Cmd$none);
						case 'DueDate':
							return _Utils_Tuple2(
								updateCurrentModel(
									_Utils_update(
										loadedModel,
										{
											dueDateError: A3($author$project$Model$UploadMultipleDocument$validateDueDate, model.timezone, model.currentTime, loadedModel.dueDate)
										})),
								$elm$core$Platform$Cmd$none);
						default:
							return _Utils_Tuple2(
								updateCurrentModel(
									_Utils_update(
										loadedModel,
										{
											textAnnotationTitleError: $author$project$Model$UploadMultipleDocument$validateTitle(loadedModel.textAnnotationTitle)
										})),
								$elm$core$Platform$Cmd$none);
					}
				case 'OnSigningOrderChecked':
					var _v34 = loadedModel.signingType;
					if (_v34.$ === 'NoSigningOrder') {
						return _Utils_Tuple2(
							updateCurrentModel(
								_Utils_update(
									loadedModel,
									{signingType: $author$project$Type$UploadMultipleDocument$SigningOrder})),
							$elm$core$Platform$Cmd$none);
					} else {
						return _Utils_Tuple2(
							updateCurrentModel(
								_Utils_update(
									loadedModel,
									{signingType: $author$project$Type$UploadMultipleDocument$NoSigningOrder})),
							$elm$core$Platform$Cmd$none);
					}
				case 'OnSigningOrderInput':
					var email = msg.a;
					var signOrderValue = msg.b;
					var signOrder = $elm$core$String$toInt(signOrderValue);
					if (signOrder.$ === 'Just') {
						var value = signOrder.a;
						if ((value >= 1) && (value < 100)) {
							var updatedSignOrderData = A2(
								$elm$core$List$map,
								function (data) {
									return _Utils_eq(
										$author$project$Data$PDF$User$emailFromUser(data.user),
										email) ? _Utils_update(
										data,
										{signOrder: value}) : data;
								},
								loadedModel.signOrderData);
							var updatedPDFList = A2(
								$elm$core$List$map,
								function (pdfData) {
									var newData = A3($author$project$Data$PDF$Create$updateRecipientSigningOrder, email, value, pdfData.pdf);
									return _Utils_update(
										pdfData,
										{pdf: newData});
								},
								loadedModel.pdfList);
							return _Utils_Tuple2(
								updateCurrentModel(
									_Utils_update(
										loadedModel,
										{
											pdf: A3($author$project$Data$PDF$Create$updateRecipientSigningOrder, email, value, loadedModel.pdf),
											pdfList: updatedPDFList,
											signOrderData: updatedSignOrderData
										})),
								A2(
									$elm$core$Task$attempt,
									function (_v36) {
										return $author$project$Types$Noop;
									},
									$elm$browser$Browser$Dom$focus('signOrder' + email)));
						} else {
							return _Utils_Tuple2(
								updateCurrentModel(loadedModel),
								$elm$core$Platform$Cmd$none);
						}
					} else {
						return _Utils_Tuple2(
							updateCurrentModel(loadedModel),
							$elm$core$Platform$Cmd$none);
					}
				case 'OnOwnerSigningOrderInput':
					var signOrderValue = msg.a;
					var signOrder = $elm$core$String$toInt(signOrderValue);
					if (signOrder.$ === 'Just') {
						var value = signOrder.a;
						if ((value >= 1) && (value < 100)) {
							var updatedPDFList = A2(
								$elm$core$List$map,
								function (pdfData) {
									var newData = A2($author$project$Data$PDF$Create$updateOwnerSigningOrder, value, pdfData.pdf);
									return _Utils_update(
										pdfData,
										{pdf: newData});
								},
								loadedModel.pdfList);
							return _Utils_Tuple2(
								updateCurrentModel(
									_Utils_update(
										loadedModel,
										{
											pdf: A2($author$project$Data$PDF$Create$updateOwnerSigningOrder, value, loadedModel.pdf),
											pdfList: updatedPDFList
										})),
								$elm$core$Platform$Cmd$none);
						} else {
							return _Utils_Tuple2(
								updateCurrentModel(loadedModel),
								$elm$core$Platform$Cmd$none);
						}
					} else {
						return _Utils_Tuple2(
							updateCurrentModel(loadedModel),
							$elm$core$Platform$Cmd$none);
					}
				case 'OnDueDateToggle':
					return _Utils_Tuple2(
						updateCurrentModel(
							_Utils_update(
								loadedModel,
								{dueDate: $elm$core$Maybe$Nothing, dueDateError: $elm$core$Maybe$Nothing, showDueDate: !loadedModel.showDueDate})),
						$elm$core$Platform$Cmd$none);
				case 'OnSearchDebounce':
					return $elm$core$String$isEmpty(loadedModel.addRecipient.search) ? _Utils_Tuple2(
						updateCurrentModel(
							_Utils_update(
								loadedModel,
								{
									addRecipient: _Utils_update(
										addRecipient,
										{searchResult: $elm$core$Maybe$Nothing})
								})),
						$elm$core$Platform$Cmd$none) : _Utils_Tuple2(
						model,
						A2(
							$elm$core$Task$attempt,
							A2(
								$elm$core$Basics$composeL,
								A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnMultipleDocUpload),
								$author$project$Type$UploadMultipleDocument$OnSearchApiResult),
							A3($author$project$Data$Api$AddressBookAutocomplete$authCall, authModel.user.jwt, model.apiEndPoint.addressBookAutocomplete, loadedModel.addRecipient.search)));
				case 'OnSearchApiResult':
					var response = msg.a;
					if (response.$ === 'Ok') {
						var result = response.a;
						return $elm$core$List$isEmpty(result.contacts) ? _Utils_Tuple2(
							updateCurrentModel(
								_Utils_update(
									loadedModel,
									{
										addRecipient: _Utils_update(
											addRecipient,
											{searchResult: $elm$core$Maybe$Nothing})
									})),
							$elm$core$Platform$Cmd$none) : _Utils_Tuple2(
							updateCurrentModel(
								_Utils_update(
									loadedModel,
									{
										addRecipient: _Utils_update(
											addRecipient,
											{
												searchResult: $elm$core$Maybe$Just(result.contacts)
											})
									})),
							$elm$core$Platform$Cmd$none);
					} else {
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					}
				case 'OnAutocompleteClick':
					var contact = msg.a;
					return _Utils_Tuple2(
						updateCurrentModel(
							_Utils_update(
								loadedModel,
								{
									addRecipient: _Utils_update(
										addRecipient,
										{email: contact.email, emailError: $elm$core$Maybe$Nothing, firstName: contact.firstName, firstNameError: $elm$core$Maybe$Nothing, lastName: contact.lastName, lastNameError: $elm$core$Maybe$Nothing, searchResult: $elm$core$Maybe$Nothing})
								})),
						$elm$core$Platform$Cmd$none);
				case 'OnSearchFieldBlur':
					return _Utils_Tuple2(
						updateCurrentModel(
							_Utils_update(
								loadedModel,
								{
									addRecipient: _Utils_update(
										addRecipient,
										{searchResult: $elm$core$Maybe$Nothing})
								})),
						$elm$core$Platform$Cmd$none);
				case 'OnAdditionalMsgInput':
					var addMsg = msg.a;
					return _Utils_Tuple2(
						updateCurrentModel(
							_Utils_update(
								loadedModel,
								{
									additionalMsg: $elm$core$Maybe$Just(addMsg)
								})),
						$elm$core$Platform$Cmd$none);
				case 'OnCompletedOfficeConversion':
					var doc = msg.a;
					var _v39 = $author$project$Data$PDF$decodeConvertedPDF(doc);
					if (_v39.$ === 'Ok') {
						var result = _v39.a;
						var updatedList = A2(
							$elm$core$List$map,
							function (pdfData) {
								return _Utils_eq(pdfData.id, loadedModel.selectedPDF) ? _Utils_update(
									pdfData,
									{
										fileType: $author$project$Type$File$PDF,
										isPDF: true,
										pdf: A3($author$project$Data$PDF$Create$setBase64FileData, result.base64data, result.file, pdfData.pdf)
									}) : pdfData;
							},
							loadedModel.pdfList);
						return _Utils_Tuple2(
							updateCurrentModel(
								_Utils_update(
									loadedModel,
									{
										pdf: A3($author$project$Data$PDF$Create$setBase64FileData, result.base64data, result.file, loadedModel.pdf),
										pdfList: updatedList
									})),
							$elm$core$Platform$Cmd$none);
					} else {
						return _Utils_Tuple2(
							updateCurrentModel(
								_Utils_update(
									loadedModel,
									{status: $author$project$Type$UploadMultipleDocument$ConversionError})),
							$elm$core$Platform$Cmd$none);
					}
				case 'OnDocLoaded':
					var selectedFile = $elm$core$List$head(
						A2(
							$elm$core$List$filter,
							function (pdfData) {
								return _Utils_eq(pdfData.id, loadedModel.selectedPDF);
							},
							loadedModel.pdfList));
					var cmdMsg = function () {
						if (selectedFile.$ === 'Just') {
							var fileSelected = selectedFile.a;
							var recipientsAnnots = A2(
								$elm$core$List$map,
								function (_v41) {
									var recipient = _v41.b;
									return {annotations: recipient.annotations, user: recipient.user};
								},
								$elm$core$Dict$toList(
									$author$project$Data$PDF$Create$recipientsWithoutOwner(fileSelected.pdf)));
							var owner = $author$project$Data$PDF$Create$getOwner(fileSelected.pdf);
							var allAnnots = _Utils_eq(owner.role, $author$project$Data$PDF$Create$Signer) ? A2(
								$elm$core$List$cons,
								{annotations: owner.annotations, user: owner.user},
								recipientsAnnots) : recipientsAnnots;
							var newCmdMsg = fileSelected.isPDF ? $author$project$Data$PDF$Port$loadDocAnnots(allAnnots) : $elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										$author$project$Data$PDF$Port$loadDocAnnots(allAnnots)
									]));
							return newCmdMsg;
						} else {
							return $elm$core$Platform$Cmd$none;
						}
					}();
					return _Utils_Tuple2(
						updateCurrentModel(
							_Utils_update(
								loadedModel,
								{status: $author$project$Type$UploadMultipleDocument$Editing})),
						cmdMsg);
				case 'OnDocConversionErrorRedirect':
					var cmdMsg = _Utils_ap(
						_List_fromArray(
							[
								A2($elm$browser$Browser$Navigation$replaceUrl, model.navKey, $author$project$Data$Route$routeUrl.dashboard),
								$author$project$Data$WalletConnect$walletConnectKillSession(_Utils_Tuple0)
							]),
						A2(
							$elm$core$List$filterMap,
							function (pdfData) {
								return ((!_Utils_eq(pdfData.notarizationStatus, $author$project$Type$UploadMultipleDocument$Completed)) && (loadedModel.requireNotarisation && (!_Utils_eq(
									$author$project$Model$UploadMultipleDocument$convertStringToPayment(authModel.user.paymentMethod),
									$author$project$Type$Setting$SystemBalance)))) ? $elm$core$Maybe$Just(
									A2(
										$elm$core$Task$attempt,
										A2(
											$elm$core$Basics$composeL,
											A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnMultipleDocUpload),
											$author$project$Type$UploadMultipleDocument$OnCancelNotarisationResult),
										A3(
											$author$project$Data$Api$PDF$CancelNotarisation$authCall,
											authModel.user.jwt,
											model.apiEndPoint.cancelNotarisation,
											A2($elm$core$Maybe$withDefault, '', pdfData.docId)))) : $elm$core$Maybe$Nothing;
							},
							loadedModel.pdfList));
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								sessionModel: $author$project$Types$Auth(
									_Utils_update(
										authModel,
										{
											newMultipleDocModel: {base64File: $elm$core$Maybe$Nothing, error: $elm$core$Maybe$Nothing, file: $elm$core$Maybe$Nothing, fileHover: false, files: _List_Nil, showModal: false}
										}))
							}),
						$elm$core$Platform$Cmd$batch(cmdMsg));
				case 'OnAdditionalMsgToggle':
					return _Utils_Tuple2(
						updateCurrentModel(
							_Utils_update(
								loadedModel,
								{additionalMsg: $elm$core$Maybe$Nothing, showAdditionalMsg: !loadedModel.showAdditionalMsg})),
						$elm$core$Platform$Cmd$none);
				case 'OnRequireNotarisationToggle':
					var notarisationNetwork = msg.a;
					var newModel = function () {
						if (notarisationNetwork.$ === 'Binance') {
							return (_Utils_cmp(
								loadedModel.signPointsBalance,
								loadedModel.binanceNotarisationCost * $elm$core$List$length(loadedModel.pdfList)) > -1) ? _Utils_update(
								loadedModel,
								{requireNotarisation: !loadedModel.requireNotarisation}) : _Utils_update(
								loadedModel,
								{requireNotarisation: false});
						} else {
							var _v43 = authModel.user.paymentMethod;
							if (_v43 === 'systemBalance') {
								return (_Utils_cmp(
									loadedModel.signPointsBalance,
									loadedModel.algorandNotarisationCost * $elm$core$List$length(loadedModel.pdfList)) > -1) ? _Utils_update(
									loadedModel,
									{requireNotarisation: !loadedModel.requireNotarisation}) : _Utils_update(
									loadedModel,
									{requireNotarisation: false});
							} else {
								return _Utils_update(
									loadedModel,
									{requireNotarisation: !loadedModel.requireNotarisation});
							}
						}
					}();
					return _Utils_Tuple2(
						updateCurrentModel(newModel),
						$elm$core$Platform$Cmd$none);
				case 'OnStampsHover':
					var toolTipType = msg.a;
					var status = msg.b;
					if (toolTipType.$ === 'Organisation') {
						return _Utils_Tuple2(
							updateCurrentModel(
								_Utils_update(
									loadedModel,
									{
										organisationStampsHover: _Utils_eq(status, $author$project$Type$UploadMultipleDocument$Enter)
									})),
							$elm$core$Platform$Cmd$none);
					} else {
						return _Utils_Tuple2(
							updateCurrentModel(
								_Utils_update(
									loadedModel,
									{
										personalStampsHover: _Utils_eq(status, $author$project$Type$UploadMultipleDocument$Enter)
									})),
							$elm$core$Platform$Cmd$none);
					}
				case 'OnHover':
					var action = msg.a;
					var location = msg.b;
					var _v45 = _Utils_Tuple2(action, location);
					switch (_v45.b.$) {
						case 'Notarize':
							if (_v45.a.$ === 'Enters') {
								var _v46 = _v45.a;
								var _v47 = _v45.b;
								return _Utils_Tuple2(
									updateCurrentModel(
										_Utils_update(
											loadedModel,
											{toolTipActiveHover: $author$project$Type$UploadMultipleDocument$Notarize})),
									$elm$core$Platform$Cmd$none);
							} else {
								var _v48 = _v45.a;
								var _v49 = _v45.b;
								return _Utils_Tuple2(
									updateCurrentModel(
										_Utils_update(
											loadedModel,
											{toolTipActiveHover: $author$project$Type$UploadMultipleDocument$Closed})),
									$elm$core$Platform$Cmd$none);
							}
						case 'Passcode':
							if (_v45.a.$ === 'Enters') {
								var _v50 = _v45.a;
								var _v51 = _v45.b;
								return _Utils_Tuple2(
									updateCurrentModel(
										_Utils_update(
											loadedModel,
											{toolTipActiveHover: $author$project$Type$UploadMultipleDocument$Passcode})),
									$elm$core$Platform$Cmd$none);
							} else {
								var _v52 = _v45.a;
								var _v53 = _v45.b;
								return _Utils_Tuple2(
									updateCurrentModel(
										_Utils_update(
											loadedModel,
											{toolTipActiveHover: $author$project$Type$UploadMultipleDocument$Closed})),
									$elm$core$Platform$Cmd$none);
							}
						default:
							var _v54 = _v45.b;
							return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					}
				case 'OnPasscodeToggle':
					return _Utils_Tuple2(
						updateCurrentModel(
							_Utils_update(
								loadedModel,
								{passcode: $elm$core$Maybe$Nothing, passcodeError: $elm$core$Maybe$Nothing, showPasscodeInput: !loadedModel.showPasscodeInput})),
						$elm$core$Platform$Cmd$none);
				case 'OnPasscodeInput':
					var value = msg.a;
					return _Utils_Tuple2(
						updateCurrentModel(
							_Utils_update(
								loadedModel,
								{
									passcode: $elm$core$Maybe$Just(value)
								})),
						$elm$core$Platform$Cmd$none);
				case 'OnPasscodeBlur':
					return _Utils_Tuple2(
						updateCurrentModel(
							_Utils_update(
								loadedModel,
								{
									passcodeError: A2($author$project$Model$UploadMultipleDocument$validatePasscode, loadedModel.passcode, loadedModel.showPasscodeInput)
								})),
						$elm$core$Platform$Cmd$none);
				case 'NextStage':
					var newStage = function () {
						var _v55 = loadedModel.stage;
						switch (_v55.$) {
							case 'Recipients':
								return $author$project$Type$UploadMultipleDocument$Options;
							case 'Options':
								return $author$project$Type$UploadMultipleDocument$Annotations;
							case 'Annotations':
								return $author$project$Type$UploadMultipleDocument$Annotations;
							default:
								return $author$project$Type$UploadMultipleDocument$Annotations;
						}
					}();
					return _Utils_Tuple2(
						updateCurrentModel(
							_Utils_update(
								loadedModel,
								{stage: newStage})),
						$elm$core$Platform$Cmd$none);
				case 'GoToStage':
					var stage = msg.a;
					return _Utils_Tuple2(
						updateCurrentModel(
							_Utils_update(
								loadedModel,
								{stage: stage})),
						$elm$core$Platform$Cmd$none);
				case 'OnFileSwitch':
					var file = msg.a;
					var selectedFile = $elm$core$List$head(
						A2(
							$elm$core$List$filter,
							function (pdfData) {
								return _Utils_eq(pdfData.id, file);
							},
							loadedModel.pdfList));
					if (selectedFile.$ === 'Just') {
						var fileSelected = selectedFile.a;
						var recipientsAnnots = A2(
							$elm$core$List$map,
							function (_v57) {
								var recipient = _v57.b;
								return {annotations: recipient.annotations, user: recipient.user};
							},
							$elm$core$Dict$toList(
								$author$project$Data$PDF$Create$recipientsWithoutOwner(fileSelected.pdf)));
						var owner = $author$project$Data$PDF$Create$getOwner(fileSelected.pdf);
						var allAnnots = _Utils_eq(owner.role, $author$project$Data$PDF$Create$Signer) ? A2(
							$elm$core$List$cons,
							{annotations: owner.annotations, user: owner.user},
							recipientsAnnots) : recipientsAnnots;
						return _Utils_Tuple2(
							updateCurrentModel(
								_Utils_update(
									loadedModel,
									{
										pdf: fileSelected.pdf,
										selectedPDF: file,
										title: $author$project$Data$PDF$Create$title(fileSelected.pdf)
									})),
							A5(
								$author$project$Data$PDF$Port$switchDoc,
								$elm$core$Maybe$Nothing,
								$author$project$Data$PDF$Create$getBase64Data(fileSelected.pdf),
								fileSelected.fileType,
								$author$project$Data$PDF$Create$title(fileSelected.pdf),
								allAnnots));
					} else {
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					}
				case 'OnClearInsertAnnot':
					return _Utils_Tuple2(
						updateCurrentModel(
							_Utils_update(
								loadedModel,
								{selectedAnnot: $elm$core$Maybe$Nothing})),
						$elm$core$Platform$Cmd$none);
				case 'OnClearAddRecipientFields':
					return _Utils_Tuple2(
						updateCurrentModel(
							_Utils_update(
								loadedModel,
								{
									addRecipient: _Utils_update(
										addRecipient,
										{display: false, email: '', emailError: $elm$core$Maybe$Nothing, firstName: '', firstNameError: $elm$core$Maybe$Nothing, lastName: '', lastNameError: $elm$core$Maybe$Nothing, role: $author$project$Data$PDF$Create$Signer, search: ''})
								})),
						$elm$core$Platform$Cmd$none);
				case 'OnCancelNotarisationClick':
					var cmdMsg = A2(
						$elm$core$List$map,
						function (pdfData) {
							return A2(
								$elm$core$Task$attempt,
								A2(
									$elm$core$Basics$composeL,
									A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnMultipleDocUpload),
									$author$project$Type$UploadMultipleDocument$OnCancelNotarisationResult),
								A3(
									$author$project$Data$Api$PDF$CancelNotarisation$authCall,
									authModel.user.jwt,
									model.apiEndPoint.cancelNotarisation,
									A2($elm$core$Maybe$withDefault, '', pdfData.docId)));
						},
						loadedModel.pdfList);
					return _Utils_Tuple2(
						updateCurrentModel(
							_Utils_update(
								loadedModel,
								{
									status: $author$project$Type$UploadMultipleDocument$Loading($author$project$Type$UploadMultipleDocument$CancelNotarisation)
								})),
						$elm$core$Platform$Cmd$batch(cmdMsg));
				case 'OnCancelNotarisationResult':
					var result = msg.a;
					if (result.$ === 'Ok') {
						return _Utils_Tuple2(
							updateCurrentModel(
								_Utils_update(
									loadedModel,
									{status: $author$project$Type$UploadMultipleDocument$CancelNotarisationSuccess})),
							$elm$core$Platform$Cmd$none);
					} else {
						var error = result.a;
						return _Utils_Tuple2(
							updateCurrentModel(
								_Utils_update(
									loadedModel,
									{
										status: $author$project$Type$UploadMultipleDocument$Error(
											A2($author$project$Data$Api$authErrorToString, $author$project$Data$Api$PDF$CancelNotarisation$errorToString, error))
									})),
							$elm$core$Platform$Cmd$none);
					}
				case 'AlgorandWalletConnectClick':
					var _v59 = $author$project$Model$UploadMultipleDocument$convertStringToPayment(authModel.user.paymentMethod);
					switch (_v59.$) {
						case 'AlgoWallet':
							return _Utils_Tuple2(
								updateCurrentModel(
									_Utils_update(
										loadedModel,
										{
											status: $author$project$Type$UploadMultipleDocument$Loading($author$project$Type$UploadMultipleDocument$GetWallet)
										})),
								$author$project$Model$ViewDocument$getAlgorandWalletAddress('uploadDocument'));
						case 'WalletConnect':
							return _Utils_Tuple2(
								model,
								$author$project$Data$WalletConnect$walletConnectInit(
									$elm$json$Json$Encode$string('UploadDoc')));
						default:
							return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					}
				case 'AlgorandWalletError':
					var result = msg.a;
					var decodedMsg = function () {
						var _v60 = $author$project$Data$AlgorandWallet$decodeWalletError(result);
						if (_v60.$ === 'Ok') {
							var message = _v60.a;
							return message.error;
						} else {
							return 'Error getting wallet Addresses. Please try again.';
						}
					}();
					return _Utils_Tuple2(
						updateCurrentModel(
							_Utils_update(
								loadedModel,
								{
									status: A4($author$project$Type$UploadMultipleDocument$Success, loadedModel.requireNotarisation, authModel.user.paymentMethod, decodedMsg, false),
									walletError: $elm$core$Maybe$Just(decodedMsg)
								})),
						$elm$core$Platform$Cmd$none);
				case 'GetAlgorandWalletAddress':
					var result = msg.a;
					var _v61 = $author$project$Data$AlgorandWallet$decodeWalletResult(result);
					if (_v61.$ === 'Ok') {
						var value = _v61.a;
						return _Utils_Tuple2(
							updateCurrentModel(
								_Utils_update(
									loadedModel,
									{
										algorandWalletAddresses: value.wallet,
										selectedWallet: $elm$core$Maybe$Nothing,
										status: $author$project$Type$UploadMultipleDocument$DisplayWallet(value.wallet)
									})),
							$elm$core$Platform$Cmd$none);
					} else {
						return _Utils_Tuple2(
							updateCurrentModel(loadedModel),
							$elm$core$Platform$Cmd$none);
					}
				case 'OnSelectWallet':
					var address = msg.a;
					return _Utils_Tuple2(
						updateCurrentModel(
							_Utils_update(
								loadedModel,
								{
									selectedWallet: $elm$core$Maybe$Just(address),
									status: $author$project$Type$UploadMultipleDocument$Loading($author$project$Type$UploadMultipleDocument$CheckWalletOptIn)
								})),
						$author$project$Model$ViewDocument$checkOptIn(
							{location: 'uploadDocument', selectedWallet: address}));
				case 'OptInStatusResult':
					var result = msg.a;
					var _v62 = $author$project$Data$AlgorandWallet$decodeOptInStatusResult(result);
					if (_v62.$ === 'Ok') {
						var value = _v62.a;
						return _Utils_Tuple2(
							updateCurrentModel(
								_Utils_update(
									loadedModel,
									{
										needOptIn: value.needOptIn,
										status: $author$project$Type$UploadMultipleDocument$DisplayWallet(loadedModel.algorandWalletAddresses)
									})),
							$elm$core$Platform$Cmd$none);
					} else {
						return _Utils_Tuple2(
							updateCurrentModel(loadedModel),
							$elm$core$Platform$Cmd$none);
					}
				case 'OptInAssetClick':
					return _Utils_Tuple2(
						updateCurrentModel(
							_Utils_update(
								loadedModel,
								{
									status: $author$project$Type$UploadMultipleDocument$Loading($author$project$Type$UploadMultipleDocument$OptIn)
								})),
						$author$project$Model$ViewDocument$optInAsset(
							{
								location: 'uploadDocument',
								userWalletAddress: A2($elm$core$Maybe$withDefault, '', loadedModel.selectedWallet)
							}));
				case 'OptInError':
					var result = msg.a;
					var userWallets = loadedModel.algorandWalletAddresses;
					var decodedMsg = function () {
						var _v63 = $author$project$Data$AlgorandWallet$decodeOptInError(result);
						if (_v63.$ === 'Ok') {
							var message = _v63.a;
							return message.error;
						} else {
							return 'Error opting-in. Please try again.';
						}
					}();
					return _Utils_Tuple2(
						updateCurrentModel(
							_Utils_update(
								loadedModel,
								{
									optInError: $elm$core$Maybe$Just(decodedMsg),
									status: $author$project$Type$UploadMultipleDocument$DisplayWallet(userWallets)
								})),
						$elm$core$Platform$Cmd$none);
				case 'GetOptInDetails':
					var result = msg.a;
					var pdfList = loadedModel.pdfList;
					var docId = $elm$core$List$head(
						A2(
							$elm$core$List$map,
							function (r) {
								return A2($elm$core$Maybe$withDefault, '', r.docId);
							},
							pdfList));
					var _v64 = $author$project$Data$AlgorandWallet$decodeStatusResult(result);
					if (_v64.$ === 'Ok') {
						var value = _v64.a;
						return _Utils_Tuple2(
							updateCurrentModel(
								_Utils_update(
									loadedModel,
									{
										optInError: $elm$core$Maybe$Nothing,
										optInStatusCode: $elm$core$Maybe$Just(value.status)
									})),
							A2(
								$elm$core$Task$attempt,
								A2(
									$elm$core$Basics$composeL,
									A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnMultipleDocUpload),
									$author$project$Type$UploadMultipleDocument$OnGetOptInDetailsResult),
								A6(
									$author$project$Data$Api$PDF$GetOptInDetails$authCall,
									authModel.user.jwt,
									model.apiEndPoint.getOptinDetails,
									A2($elm$core$Maybe$withDefault, '', docId),
									value.transactionHash,
									value.blockNumber,
									A2($elm$core$Maybe$withDefault, '', loadedModel.selectedWallet))));
					} else {
						return _Utils_Tuple2(
							updateCurrentModel(loadedModel),
							$elm$core$Platform$Cmd$none);
					}
				case 'OnGetOptInDetailsResult':
					var result = msg.a;
					if (result.$ === 'Ok') {
						return _Utils_Tuple2(
							updateCurrentModel(
								_Utils_update(
									loadedModel,
									{status: $author$project$Type$UploadMultipleDocument$MakePayment})),
							$elm$core$Platform$Cmd$none);
					} else {
						var error = result.a;
						return _Utils_Tuple2(
							updateCurrentModel(
								_Utils_update(
									loadedModel,
									{
										status: $author$project$Type$UploadMultipleDocument$Error(
											A2($author$project$Data$Api$authErrorToString, $author$project$Data$Api$PDF$GetOptInDetails$errorToString, error))
									})),
							$elm$core$Platform$Cmd$none);
					}
				case 'PaymentTransactionClick':
					var pdfList = loadedModel.pdfList;
					var recipients = $elm$core$List$head(
						A2(
							$elm$core$List$map,
							function (r) {
								return r.recipient;
							},
							pdfList));
					var docId = $elm$core$List$head(
						A2(
							$elm$core$List$map,
							function (r) {
								return A2($elm$core$Maybe$withDefault, '', r.docId);
							},
							pdfList));
					var checksum = $elm$core$List$head(
						A2(
							$elm$core$List$map,
							function (r) {
								return A2($elm$core$Maybe$withDefault, '', r.checksum);
							},
							pdfList));
					var isCompleted = !(_Utils_eq(checksum, $elm$core$Maybe$Nothing) || _Utils_eq(
						checksum,
						$elm$core$Maybe$Just('')));
					var cmdMsg = function () {
						var _v66 = $author$project$Model$UploadMultipleDocument$convertStringToPayment(authModel.user.paymentMethod);
						switch (_v66.$) {
							case 'AlgoWallet':
								return $author$project$Model$ViewDocument$paymentTransaction(
									{
										checksum: A2($elm$core$Maybe$withDefault, '', checksum),
										docId: A2($elm$core$Maybe$withDefault, '', docId),
										isCompleted: isCompleted,
										noOfDocuments: $elm$core$List$length(loadedModel.pdfList),
										ownerId: authModel.user.id,
										recipients: A2($elm$core$Maybe$withDefault, _List_Nil, recipients),
										route: 'uploadDocument',
										userWalletAddress: A2($elm$core$Maybe$withDefault, '', loadedModel.selectedWallet)
									});
							case 'WalletConnect':
								return A8(
									$author$project$Data$WalletConnect$initWalletConnectNotarization,
									A2($elm$core$Maybe$withDefault, '', authModel.user.algorandWalletAddress),
									checksum,
									A2($elm$core$Maybe$withDefault, '', docId),
									authModel.user.id,
									A2($elm$core$Maybe$withDefault, _List_Nil, recipients),
									true,
									'UploadDoc',
									true);
							default:
								return $elm$core$Platform$Cmd$none;
						}
					}();
					return _Utils_Tuple2(
						updateCurrentModel(
							_Utils_update(
								loadedModel,
								{
									completed: checksum,
									status: $author$project$Type$UploadMultipleDocument$Loading($author$project$Type$UploadMultipleDocument$Payment)
								})),
						cmdMsg);
				case 'PaymentTransactionError':
					var result = msg.a;
					var remainingDocs = A2(
						$elm$core$List$filterMap,
						function (pdfData) {
							return _Utils_eq(pdfData.notarizationStatus, $author$project$Type$UploadMultipleDocument$StandBy) ? $elm$core$Maybe$Just(
								{
									checksum: pdfData.checksum,
									docId: pdfData.docId,
									recipient: pdfData.recipient,
									title: $author$project$Data$PDF$Create$title(pdfData.pdf)
								}) : $elm$core$Maybe$Nothing;
						},
						loadedModel.pdfList);
					var nextNotarizationTarget = $elm$core$List$head(remainingDocs);
					var nextTargetID = A2(
						$elm$core$Maybe$withDefault,
						'',
						A2(
							$elm$core$Maybe$withDefault,
							{checksum: $elm$core$Maybe$Nothing, docId: $elm$core$Maybe$Nothing, recipient: _List_Nil, title: ''},
							nextNotarizationTarget).docId);
					var isLastDoc = $elm$core$List$length(remainingDocs) === 1;
					var decodedMsg = function () {
						var _v71 = $author$project$Data$AlgorandWallet$decodePaymentTransactionError(result);
						if (_v71.$ === 'Ok') {
							var message = _v71.a;
							return message.error;
						} else {
							return 'Error paying ASA. Please try again.';
						}
					}();
					var updatedPDFList = A2(
						$elm$core$List$map,
						function (pdfData) {
							return _Utils_eq(pdfData.notarizationStatus, $author$project$Type$UploadMultipleDocument$Processing) ? _Utils_update(
								pdfData,
								{
									notarizationStatus: $author$project$Type$UploadMultipleDocument$Failed(decodedMsg)
								}) : ((_Utils_eq(
								A2($elm$core$Maybe$withDefault, '', pdfData.docId),
								nextTargetID) && (!$elm$core$String$isEmpty(nextTargetID))) ? _Utils_update(
								pdfData,
								{notarizationStatus: $author$project$Type$UploadMultipleDocument$Processing}) : pdfData);
						},
						loadedModel.pdfList);
					var newModel = function () {
						if (nextNotarizationTarget.$ === 'Just') {
							return _Utils_update(
								loadedModel,
								{pdfList: updatedPDFList});
						} else {
							return _Utils_update(
								loadedModel,
								{
									pdfList: updatedPDFList,
									status: $author$project$Type$UploadMultipleDocument$NotariseSuccess(true)
								});
						}
					}();
					var cmdMsg = function () {
						var _v67 = _Utils_Tuple2(
							$author$project$Model$UploadMultipleDocument$convertStringToPayment(authModel.user.paymentMethod),
							nextNotarizationTarget);
						_v67$2:
						while (true) {
							if (_v67.b.$ === 'Just') {
								switch (_v67.a.$) {
									case 'AlgoWallet':
										var _v68 = _v67.a;
										var nextTarget = _v67.b.a;
										return $author$project$Model$ViewDocument$paymentTransaction(
											{
												checksum: A2($elm$core$Maybe$withDefault, '', nextTarget.checksum),
												docId: A2($elm$core$Maybe$withDefault, '', nextTarget.docId),
												isCompleted: !(_Utils_eq(nextTarget.checksum, $elm$core$Maybe$Nothing) || _Utils_eq(
													nextTarget.checksum,
													$elm$core$Maybe$Just(''))),
												noOfDocuments: $elm$core$List$length(loadedModel.pdfList),
												ownerId: authModel.user.id,
												recipients: nextTarget.recipient,
												route: 'uploadDocument',
												userWalletAddress: A2($elm$core$Maybe$withDefault, '', loadedModel.selectedWallet)
											});
									case 'WalletConnect':
										var _v69 = _v67.a;
										var nextTarget = _v67.b.a;
										return A8(
											$author$project$Data$WalletConnect$initWalletConnectNotarization,
											A2($elm$core$Maybe$withDefault, '', authModel.user.algorandWalletAddress),
											nextTarget.checksum,
											A2($elm$core$Maybe$withDefault, '', nextTarget.docId),
											authModel.user.id,
											nextTarget.recipient,
											false,
											'UploadDoc',
											isLastDoc);
									default:
										break _v67$2;
								}
							} else {
								break _v67$2;
							}
						}
						return $elm$core$Platform$Cmd$none;
					}();
					return _Utils_Tuple2(
						updateCurrentModel(newModel),
						cmdMsg);
				case 'SendNotarisationDetails':
					var result = msg.a;
					var pdfList = loadedModel.pdfList;
					var _v72 = A2(
						$elm$core$Maybe$withDefault,
						_Utils_Tuple2('', $elm$core$Maybe$Nothing),
						$elm$core$List$head(
							A2(
								$elm$core$List$filterMap,
								function (pdfData) {
									return _Utils_eq(pdfData.notarizationStatus, $author$project$Type$UploadMultipleDocument$Processing) ? $elm$core$Maybe$Just(
										_Utils_Tuple2(
											A2($elm$core$Maybe$withDefault, '', pdfData.docId),
											pdfData.checksum)) : $elm$core$Maybe$Nothing;
								},
								pdfList)));
					var docId = _v72.a;
					var checksum = _v72.b;
					var isCompleted = !(_Utils_eq(checksum, $elm$core$Maybe$Nothing) || _Utils_eq(
						checksum,
						$elm$core$Maybe$Just('')));
					var _v73 = $author$project$Data$AlgorandWallet$decodeNotarisationResult(result);
					if (_v73.$ === 'Ok') {
						var value = _v73.a;
						return _Utils_Tuple2(
							updateCurrentModel(loadedModel),
							A2(
								$elm$core$Task$attempt,
								A2(
									$elm$core$Basics$composeL,
									A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnMultipleDocUpload),
									$author$project$Type$UploadMultipleDocument$OnGetNotarisationDetailsResult),
								A8(
									$author$project$Data$Api$PDF$NotariseWithAlgorandWallet$authCall,
									authModel.user.jwt,
									model.apiEndPoint.getAlgorandNotarisationDetails,
									docId,
									value.transactionHash,
									value.blockNumber,
									value.notarisationTimeStamp,
									A2($elm$core$Maybe$withDefault, '', loadedModel.selectedWallet),
									isCompleted)));
					} else {
						return _Utils_Tuple2(
							updateCurrentModel(loadedModel),
							$elm$core$Platform$Cmd$none);
					}
				case 'OnGetNotarisationDetailsResult':
					var result = msg.a;
					var remainingDocs = A2(
						$elm$core$List$filterMap,
						function (pdfData) {
							return _Utils_eq(pdfData.notarizationStatus, $author$project$Type$UploadMultipleDocument$StandBy) ? $elm$core$Maybe$Just(
								{
									checksum: pdfData.checksum,
									docId: pdfData.docId,
									recipient: pdfData.recipient,
									title: $author$project$Data$PDF$Create$title(pdfData.pdf)
								}) : $elm$core$Maybe$Nothing;
						},
						loadedModel.pdfList);
					var nextNotarizationTarget = $elm$core$List$head(remainingDocs);
					var isLastDoc = $elm$core$List$length(remainingDocs) === 1;
					var _v74 = _Utils_Tuple2(result, nextNotarizationTarget);
					if (_v74.a.$ === 'Ok') {
						if (_v74.b.$ === 'Nothing') {
							var _v75 = _v74.b;
							var updatedPDFList = A2(
								$elm$core$List$map,
								function (pdfData) {
									return _Utils_eq(pdfData.notarizationStatus, $author$project$Type$UploadMultipleDocument$Processing) ? _Utils_update(
										pdfData,
										{notarizationStatus: $author$project$Type$UploadMultipleDocument$Completed}) : pdfData;
								},
								loadedModel.pdfList);
							return _Utils_Tuple2(
								updateCurrentModel(
									_Utils_update(
										loadedModel,
										{
											pdfList: updatedPDFList,
											status: $author$project$Type$UploadMultipleDocument$NotariseSuccess(true)
										})),
								$author$project$Data$WalletConnect$walletConnectKillSession(_Utils_Tuple0));
						} else {
							var nextTarget = _v74.b.a;
							var updatedPDFList = A2(
								$elm$core$List$map,
								function (pdfData) {
									return _Utils_eq(pdfData.notarizationStatus, $author$project$Type$UploadMultipleDocument$Processing) ? _Utils_update(
										pdfData,
										{notarizationStatus: $author$project$Type$UploadMultipleDocument$Completed}) : (_Utils_eq(pdfData.docId, nextTarget.docId) ? _Utils_update(
										pdfData,
										{notarizationStatus: $author$project$Type$UploadMultipleDocument$Processing}) : pdfData);
								},
								loadedModel.pdfList);
							var isCompleted = !(_Utils_eq(nextTarget.checksum, $elm$core$Maybe$Nothing) || _Utils_eq(
								nextTarget.checksum,
								$elm$core$Maybe$Just('')));
							var cmdMsg = function () {
								var _v76 = $author$project$Model$UploadMultipleDocument$convertStringToPayment(authModel.user.paymentMethod);
								switch (_v76.$) {
									case 'AlgoWallet':
										return $author$project$Model$ViewDocument$paymentTransaction(
											{
												checksum: A2($elm$core$Maybe$withDefault, '', nextTarget.checksum),
												docId: A2($elm$core$Maybe$withDefault, '', nextTarget.docId),
												isCompleted: isCompleted,
												noOfDocuments: $elm$core$List$length(loadedModel.pdfList),
												ownerId: authModel.user.id,
												recipients: nextTarget.recipient,
												route: 'uploadDocument',
												userWalletAddress: A2($elm$core$Maybe$withDefault, '', loadedModel.selectedWallet)
											});
									case 'WalletConnect':
										return A8(
											$author$project$Data$WalletConnect$initWalletConnectNotarization,
											A2($elm$core$Maybe$withDefault, '', authModel.user.algorandWalletAddress),
											nextTarget.checksum,
											A2($elm$core$Maybe$withDefault, '', nextTarget.docId),
											authModel.user.id,
											nextTarget.recipient,
											false,
											'UploadDoc',
											isLastDoc);
									default:
										return $elm$core$Platform$Cmd$none;
								}
							}();
							return _Utils_Tuple2(
								updateCurrentModel(
									_Utils_update(
										loadedModel,
										{pdfList: updatedPDFList})),
								cmdMsg);
						}
					} else {
						if (_v74.b.$ === 'Nothing') {
							var error = _v74.a.a;
							var _v77 = _v74.b;
							var updatedPDFList = A2(
								$elm$core$List$map,
								function (pdfData) {
									return _Utils_eq(pdfData.notarizationStatus, $author$project$Type$UploadMultipleDocument$Processing) ? _Utils_update(
										pdfData,
										{
											notarizationStatus: $author$project$Type$UploadMultipleDocument$Failed(
												A2($author$project$Data$Api$authErrorToString, $author$project$Data$Api$PDF$NotariseWithAlgorandWallet$errorToString, error))
										}) : pdfData;
								},
								loadedModel.pdfList);
							return _Utils_Tuple2(
								updateCurrentModel(
									_Utils_update(
										loadedModel,
										{
											pdfList: updatedPDFList,
											status: $author$project$Type$UploadMultipleDocument$NotariseSuccess(true)
										})),
								$elm$core$Platform$Cmd$none);
						} else {
							var error = _v74.a.a;
							var nextTarget = _v74.b.a;
							var updatedPDFList = A2(
								$elm$core$List$map,
								function (pdfData) {
									return _Utils_eq(pdfData.notarizationStatus, $author$project$Type$UploadMultipleDocument$Processing) ? _Utils_update(
										pdfData,
										{
											notarizationStatus: $author$project$Type$UploadMultipleDocument$Failed(
												A2($author$project$Data$Api$authErrorToString, $author$project$Data$Api$PDF$NotariseWithAlgorandWallet$errorToString, error))
										}) : (_Utils_eq(pdfData.docId, nextTarget.docId) ? _Utils_update(
										pdfData,
										{notarizationStatus: $author$project$Type$UploadMultipleDocument$Processing}) : pdfData);
								},
								loadedModel.pdfList);
							var isCompleted = !(_Utils_eq(nextTarget.checksum, $elm$core$Maybe$Nothing) || _Utils_eq(
								nextTarget.checksum,
								$elm$core$Maybe$Just('')));
							var cmdMsg = function () {
								var _v78 = $author$project$Model$UploadMultipleDocument$convertStringToPayment(authModel.user.paymentMethod);
								switch (_v78.$) {
									case 'AlgoWallet':
										return $author$project$Model$ViewDocument$paymentTransaction(
											{
												checksum: A2($elm$core$Maybe$withDefault, '', nextTarget.checksum),
												docId: A2($elm$core$Maybe$withDefault, '', nextTarget.docId),
												isCompleted: isCompleted,
												noOfDocuments: $elm$core$List$length(loadedModel.pdfList),
												ownerId: authModel.user.id,
												recipients: nextTarget.recipient,
												route: 'uploadDocument',
												userWalletAddress: A2($elm$core$Maybe$withDefault, '', loadedModel.selectedWallet)
											});
									case 'WalletConnect':
										return A8(
											$author$project$Data$WalletConnect$initWalletConnectNotarization,
											A2($elm$core$Maybe$withDefault, '', authModel.user.algorandWalletAddress),
											nextTarget.checksum,
											A2($elm$core$Maybe$withDefault, '', nextTarget.docId),
											authModel.user.id,
											nextTarget.recipient,
											false,
											'UploadDoc',
											isLastDoc);
									default:
										return $elm$core$Platform$Cmd$none;
								}
							}();
							return _Utils_Tuple2(
								updateCurrentModel(
									_Utils_update(
										loadedModel,
										{pdfList: updatedPDFList})),
								cmdMsg);
						}
					}
				case 'RetrieveUserAlgorandWallet':
					var walletList = msg.a;
					return _Utils_Tuple2(
						updateCurrentModel(
							_Utils_update(
								loadedModel,
								{
									algorandWalletAddresses: walletList,
									selectedWallet: $elm$core$Maybe$Nothing,
									status: $author$project$Type$UploadMultipleDocument$DisplayWallet(walletList)
								})),
						$elm$core$Platform$Cmd$none);
				case 'OnNotarizationStartClick':
					var isNewInit = msg.a;
					var updatedModel = function () {
						var _v82 = $author$project$Model$UploadMultipleDocument$convertStringToPayment(authModel.user.paymentMethod);
						if (_v82.$ === 'AlgoWallet') {
							return _Utils_update(
								loadedModel,
								{
									status: $author$project$Type$UploadMultipleDocument$Loading($author$project$Type$UploadMultipleDocument$Payment)
								});
						} else {
							return loadedModel;
						}
					}();
					var pdfList = loadedModel.pdfList;
					var isLastDoc = 1 === $elm$core$List$length(
						A2(
							$elm$core$List$filter,
							function (pdfData) {
								return _Utils_eq(pdfData.notarizationStatus, $author$project$Type$UploadMultipleDocument$StandBy);
							},
							pdfList));
					var _v79 = A2(
						$elm$core$Maybe$withDefault,
						{checksum: $elm$core$Maybe$Nothing, docId: '', recipients: _List_Nil},
						$elm$core$List$head(
							A2(
								$elm$core$List$map,
								function (pdfData) {
									return {
										checksum: pdfData.checksum,
										docId: A2($elm$core$Maybe$withDefault, '', pdfData.docId),
										recipients: pdfData.recipient
									};
								},
								pdfList)));
					var checksum = _v79.checksum;
					var docId = _v79.docId;
					var recipients = _v79.recipients;
					var isCompleted = function () {
						if (checksum.$ === 'Just') {
							var result = checksum.a;
							return !$elm$core$String$isEmpty(result);
						} else {
							return false;
						}
					}();
					var updatedPDFList = A2(
						$elm$core$List$map,
						function (pdfData) {
							return _Utils_eq(
								A2($elm$core$Maybe$withDefault, '', pdfData.docId),
								docId) ? _Utils_update(
								pdfData,
								{notarizationStatus: $author$project$Type$UploadMultipleDocument$Processing}) : pdfData;
						},
						loadedModel.pdfList);
					var cmdMsg = function () {
						var _v80 = $author$project$Model$UploadMultipleDocument$convertStringToPayment(authModel.user.paymentMethod);
						switch (_v80.$) {
							case 'AlgoWallet':
								return $author$project$Model$ViewDocument$paymentTransaction(
									{
										checksum: A2($elm$core$Maybe$withDefault, '', checksum),
										docId: docId,
										isCompleted: isCompleted,
										noOfDocuments: $elm$core$List$length(loadedModel.pdfList),
										ownerId: authModel.user.id,
										recipients: recipients,
										route: 'uploadDocument',
										userWalletAddress: A2($elm$core$Maybe$withDefault, '', authModel.user.algorandWalletAddress)
									});
							case 'WalletConnect':
								return A8(
									$author$project$Data$WalletConnect$initWalletConnectNotarization,
									A2($elm$core$Maybe$withDefault, '', authModel.user.algorandWalletAddress),
									checksum,
									docId,
									authModel.user.id,
									recipients,
									isNewInit,
									'UploadDoc',
									isLastDoc);
							default:
								return $elm$core$Platform$Cmd$none;
						}
					}();
					return _Utils_Tuple2(
						updateCurrentModel(
							_Utils_update(
								updatedModel,
								{
									algorandWalletAddresses: _List_fromArray(
										[
											A2($elm$core$Maybe$withDefault, '', authModel.user.algorandWalletAddress)
										]),
									pdfList: updatedPDFList
								})),
						cmdMsg);
				case 'OnNotarizationCancelClick':
					var updatedPDF = A2(
						$elm$core$List$map,
						function (pdfData) {
							var _v84 = pdfData.notarizationStatus;
							switch (_v84.$) {
								case 'Failed':
									return _Utils_update(
										pdfData,
										{notarizationStatus: $author$project$Type$UploadMultipleDocument$Completed});
								case 'StandBy':
									return _Utils_update(
										pdfData,
										{notarizationStatus: $author$project$Type$UploadMultipleDocument$Completed});
								default:
									return pdfData;
							}
						},
						loadedModel.pdfList);
					var cmdMsg = A2(
						$elm$core$List$filterMap,
						function (pdfData) {
							var _v83 = pdfData.notarizationStatus;
							switch (_v83.$) {
								case 'Failed':
									return $elm$core$Maybe$Just(
										A2(
											$elm$core$Task$attempt,
											A2(
												$elm$core$Basics$composeL,
												A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnMultipleDocUpload),
												$author$project$Type$UploadMultipleDocument$OnCancelNotarisationResponse),
											A3(
												$author$project$Data$Api$PDF$CancelNotarisation$authCall,
												authModel.user.jwt,
												model.apiEndPoint.cancelNotarisation,
												A2($elm$core$Maybe$withDefault, '', pdfData.docId))));
								case 'StandBy':
									return $elm$core$Maybe$Just(
										A2(
											$elm$core$Task$attempt,
											A2(
												$elm$core$Basics$composeL,
												A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnMultipleDocUpload),
												$author$project$Type$UploadMultipleDocument$OnCancelNotarisationResponse),
											A3(
												$author$project$Data$Api$PDF$CancelNotarisation$authCall,
												authModel.user.jwt,
												model.apiEndPoint.cancelNotarisation,
												A2($elm$core$Maybe$withDefault, '', pdfData.docId))));
								default:
									return $elm$core$Maybe$Nothing;
							}
						},
						loadedModel.pdfList);
					return _Utils_Tuple2(
						updateCurrentModel(
							_Utils_update(
								loadedModel,
								{cancelNotarization: true, pdfList: updatedPDF})),
						$elm$core$Platform$Cmd$batch(cmdMsg));
				case 'OnCancelNotarisationResponse':
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				case 'OnWalletConnectStart':
					var docTitle = A2(
						$elm$core$Maybe$withDefault,
						'',
						$elm$core$List$head(
							A2(
								$elm$core$List$filterMap,
								function (pdfData) {
									return _Utils_eq(pdfData.notarizationStatus, $author$project$Type$UploadMultipleDocument$Processing) ? $elm$core$Maybe$Just(
										$author$project$Data$PDF$Create$title(pdfData.pdf)) : $elm$core$Maybe$Nothing;
								},
								loadedModel.pdfList)));
					return _Utils_Tuple2(
						updateCurrentModel(
							_Utils_update(
								loadedModel,
								{
									status: $author$project$Type$UploadMultipleDocument$NotarizingDocument(docTitle)
								})),
						$elm$core$Platform$Cmd$none);
				case 'OnWalletConnectWalletRecieve':
					var response = msg.a;
					var _v85 = $author$project$Data$Wallet$decodeWalletConnectResult(response);
					if (_v85.$ === 'Ok') {
						var result = _v85.a;
						return _Utils_Tuple2(
							updateCurrentModel(
								_Utils_update(
									loadedModel,
									{
										status: $author$project$Type$UploadMultipleDocument$DisplayWalletAddress(result)
									})),
							$elm$core$Platform$Cmd$none);
					} else {
						return _Utils_Tuple2(
							updateCurrentModel(
								_Utils_update(
									loadedModel,
									{
										walletError: $elm$core$Maybe$Just('Error retrieving wallet addresses')
									})),
							$elm$core$Platform$Cmd$none);
					}
				case 'OnWalletConnectWalletOptInCompleted':
					var result = msg.a;
					var _v86 = $author$project$Data$Wallet$decodeWalletAddress(result);
					if (_v86.$ === 'Ok') {
						var transactionDetails = _v86.a;
						return _Utils_Tuple2(
							model,
							A2(
								$elm$core$Task$attempt,
								A2(
									$elm$core$Basics$composeL,
									A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnMultipleDocUpload),
									$author$project$Type$UploadMultipleDocument$OnWalletConnectOptInResponse),
								A6($author$project$Data$Api$PDF$GetOptInDetails$authCall, authModel.user.jwt, model.apiEndPoint.getOptinDetails, 'docId', transactionDetails.id, transactionDetails.block, transactionDetails.address)));
					} else {
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					}
				case 'OnWalletConnectWalletSelect':
					var walletData = msg.a;
					var updatedModel = updateCurrentModel(
						_Utils_update(
							loadedModel,
							{
								status: $author$project$Type$UploadMultipleDocument$Loading($author$project$Type$UploadMultipleDocument$RegisterWallet)
							}));
					var cmdMsg = walletData.needOptIn ? A2($author$project$Data$WalletConnect$startWalletConnectOptin, walletData.address, 'UploadDoc') : A2(
						$elm$core$Task$attempt,
						A2(
							$elm$core$Basics$composeL,
							A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnMultipleDocUpload),
							$author$project$Type$UploadMultipleDocument$OnWalletConnectRegisterApiResponse),
						A4($author$project$Data$Api$Points$WalletRegistration$authCall, authModel.user.jwt, model.apiEndPoint.pointsWalletRegistration, walletData.address, 'Algorand'));
					return _Utils_Tuple2(updatedModel, cmdMsg);
				case 'OnWalletConnectRegisterApiResponse':
					var response = msg.a;
					var newModel = function () {
						if (response.$ === 'Ok') {
							return loadedModel;
						} else {
							return _Utils_update(
								loadedModel,
								{
									walletError: $elm$core$Maybe$Just('Error with wallet Registration. Please try again')
								});
						}
					}();
					return _Utils_Tuple2(
						updateCurrentModel(
							_Utils_update(
								newModel,
								{
									status: A4(
										$author$project$Type$UploadMultipleDocument$Success,
										newModel.requireNotarisation,
										authModel.user.paymentMethod,
										A2($elm$core$Maybe$withDefault, '', newModel.walletError),
										true)
								})),
						$elm$core$Platform$Cmd$none);
				case 'OnWalletConnectOptInResponse':
					var response = msg.a;
					var newModel = function () {
						if (response.$ === 'Ok') {
							return loadedModel;
						} else {
							return _Utils_update(
								loadedModel,
								{
									walletError: $elm$core$Maybe$Just('Error with wallet Registration. Please try again')
								});
						}
					}();
					return _Utils_Tuple2(
						updateCurrentModel(
							_Utils_update(
								newModel,
								{
									status: A4(
										$author$project$Type$UploadMultipleDocument$Success,
										newModel.requireNotarisation,
										authModel.user.paymentMethod,
										A2($elm$core$Maybe$withDefault, '', newModel.walletError),
										true)
								})),
						$elm$core$Platform$Cmd$none);
				case 'OnNotarizationRetry':
					var updatedPDFList = A2(
						$elm$core$List$map,
						function (pdfData) {
							var _v89 = pdfData.notarizationStatus;
							if (_v89.$ === 'Failed') {
								return _Utils_update(
									pdfData,
									{notarizationStatus: $author$project$Type$UploadMultipleDocument$StandBy});
							} else {
								return pdfData;
							}
						},
						loadedModel.pdfList);
					return _Utils_Tuple2(
						updateCurrentModel(
							_Utils_update(
								loadedModel,
								{
									pdfList: updatedPDFList,
									status: $author$project$Type$UploadMultipleDocument$Loading($author$project$Type$UploadMultipleDocument$NotarizeDocument)
								})),
						A2(
							$elm$core$Task$perform,
							$author$project$Types$OnAuth,
							$elm$core$Task$succeed(
								$author$project$Types$OnMultipleDocUpload(
									$author$project$Type$UploadMultipleDocument$OnNotarizationStartClick(false)))));
				case 'OnOptInStart':
					return _Utils_Tuple2(
						updateCurrentModel(
							_Utils_update(
								loadedModel,
								{
									status: $author$project$Type$UploadMultipleDocument$Loading($author$project$Type$UploadMultipleDocument$GetWallet)
								})),
						$elm$core$Platform$Cmd$none);
				case 'OnRecipientTextAnnotClick':
					var user = msg.a;
					var annot = msg.b;
					var updatedAnnot = function () {
						switch (annot.$) {
							case 'EditableText':
								var textAnnot = annot.a;
								return $author$project$Data$PDF$Annotation$EditableText(
									A4(
										$author$project$Data$PDF$Annotation$updateTxt,
										loadedModel.textAnnotationTitle,
										$author$project$Data$PDF$Annotation$Unverified,
										$author$project$Data$PDF$Annotation$txtStyle(textAnnot),
										textAnnot));
							case 'NonEditableText':
								var textAnnot = annot.a;
								return $author$project$Data$PDF$Annotation$NonEditableText(
									A4(
										$author$project$Data$PDF$Annotation$updateTxt,
										loadedModel.textAnnotationTitle,
										$author$project$Data$PDF$Annotation$Unverified,
										$author$project$Data$PDF$Annotation$txtStyle(textAnnot),
										textAnnot));
							default:
								return annot;
						}
					}();
					var updatedModel = updateCurrentModel(
						_Utils_update(
							loadedModel,
							{
								selectedAnnot: $elm$core$Maybe$Just(
									{annotation: updatedAnnot, user: user}),
								status: $author$project$Type$UploadMultipleDocument$Editing,
								textAnnotationTitle: '',
								textAnnotationTitleError: $elm$core$Maybe$Nothing
							}));
					var _v90 = loadedModel.textAnnotationTitleError;
					if (_v90.$ === 'Nothing') {
						return _Utils_Tuple2(updatedModel, $elm$core$Platform$Cmd$none);
					} else {
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					}
				case 'OnRecipientTextCancelClick':
					return _Utils_Tuple2(
						updateCurrentModel(
							_Utils_update(
								loadedModel,
								{status: $author$project$Type$UploadMultipleDocument$Editing, textAnnotationTitle: '', textAnnotationTitleError: $elm$core$Maybe$Nothing})),
						$elm$core$Platform$Cmd$none);
				case 'OnSignatureTimestampingAlgorand':
					var docId = msg.a;
					var requireSignatureTimeStamping = msg.b;
					return _Utils_Tuple2(
						model,
						A2(
							$elm$core$Task$attempt,
							A2(
								$elm$core$Basics$composeL,
								A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnMultipleDocUpload),
								$author$project$Type$UploadMultipleDocument$OnSignatureTimestampingAlgorandResult),
							A4($author$project$Data$Api$PDF$SignatureTimestamping$authCall, authModel.user.jwt, model.apiEndPoint.signatureTimestamping, docId, requireSignatureTimeStamping)));
				case 'OnSignatureTimestampingAlgorandResult':
					var result = msg.a;
					if (result.$ === 'Ok') {
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					} else {
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					}
				case 'OnCheckboxConfirmationClick':
					var user = msg.a;
					var annot = msg.b;
					return _Utils_Tuple2(
						updateCurrentModel(
							_Utils_update(
								loadedModel,
								{
									selectedAnnot: $elm$core$Maybe$Just(
										{annotation: annot, user: user}),
									status: $author$project$Type$UploadMultipleDocument$Editing
								})),
						$elm$core$Platform$Cmd$none);
				case 'OnDoNotSaveDocumentClick':
					var newStatus = function () {
						var _v93 = loadedModel.saveDocumentStatus;
						if (_v93.$ === 'Save') {
							return $author$project$Type$UploadMultipleDocument$DoNotSave;
						} else {
							return $author$project$Type$UploadMultipleDocument$Save;
						}
					}();
					return _Utils_Tuple2(
						updateCurrentModel(
							_Utils_update(
								loadedModel,
								{saveDocumentStatus: newStatus})),
						$elm$core$Platform$Cmd$none);
				case 'OnReceiveSelectedAnnotClickData':
					var value = msg.a;
					var _v94 = $author$project$Data$PDF$Port$decodeClickedAnnotData(value);
					if (_v94.$ === 'Ok') {
						var result = _v94.a;
						return _Utils_Tuple2(
							updateCurrentModel(
								_Utils_update(
									loadedModel,
									{
										clickedAnnot: $elm$core$Maybe$Just(result)
									})),
							$elm$core$Platform$Cmd$none);
					} else {
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					}
				case 'OnReceiveDeselectedClick':
					return _Utils_Tuple2(
						updateCurrentModel(
							_Utils_update(
								loadedModel,
								{clickedAnnot: $elm$core$Maybe$Nothing})),
						$elm$core$Platform$Cmd$none);
				case 'OnReceiveDeleteSelectedAnnot':
					var _v95 = loadedModel.clickedAnnot;
					if (_v95.$ === 'Just') {
						var annot = _v95.a;
						return A3(
							$author$project$Model$UploadMultipleDocument$modifyAnnotation,
							loadedModel,
							updateCurrentModel,
							A2($author$project$Data$PDF$Create$deleteAnnotation, annot.id, loadedModel.pdf));
					} else {
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					}
				case 'OnReceiveDeleteAnnotClick':
					var _v96 = loadedModel.clickedAnnot;
					if (_v96.$ === 'Just') {
						var annot = _v96.a;
						return A3(
							$author$project$Model$UploadMultipleDocument$modifyAnnotation,
							loadedModel,
							updateCurrentModel,
							A2($author$project$Data$PDF$Create$deleteAnnotation, annot.id, loadedModel.pdf));
					} else {
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					}
				case 'OnFontSizeUpdate':
					var newValue = msg.a;
					var fontSize = $elm$core$String$toInt(newValue);
					var _v97 = function () {
						if (fontSize.$ === 'Just') {
							var value = fontSize.a;
							return (value > 0) ? _Utils_Tuple2(
								A2($author$project$Data$PDF$Create$updateTextAnnotationFontSize, newValue, loadedModel.pdf),
								newValue) : _Utils_Tuple2(
								_Utils_Tuple2(loadedModel.pdf, $elm$core$Platform$Cmd$none),
								loadedModel.textFontSize);
						} else {
							return $elm$core$String$isEmpty(loadedModel.textFontSize) ? _Utils_Tuple2(
								_Utils_Tuple2(loadedModel.pdf, $elm$core$Platform$Cmd$none),
								newValue) : _Utils_Tuple2(
								_Utils_Tuple2(loadedModel.pdf, $elm$core$Platform$Cmd$none),
								loadedModel.textFontSize);
						}
					}();
					var _v98 = _v97.a;
					var pdf = _v98.a;
					var newCmd = _v98.b;
					var updatedFontSize = _v97.b;
					var _v100 = lastStyle;
					var name = _v100.name;
					var date = _v100.date;
					var text = _v100.text;
					var email = _v100.email;
					return _Utils_Tuple2(
						updateCurrentModel(
							_Utils_update(
								loadedModel,
								{
									lastStyle: _Utils_update(
										lastStyle,
										{
											date: _Utils_update(
												date,
												{fontSize: updatedFontSize}),
											email: _Utils_update(
												email,
												{fontSize: updatedFontSize}),
											name: _Utils_update(
												name,
												{fontSize: updatedFontSize}),
											text: _Utils_update(
												text,
												{fontSize: updatedFontSize})
										}),
									pdf: pdf,
									textFontSize: updatedFontSize
								})),
						newCmd);
				case 'OnUneditableDoc':
					return _Utils_Tuple2(
						updateCurrentModel(
							_Utils_update(
								loadedModel,
								{status: $author$project$Type$UploadMultipleDocument$UneditablePDF})),
						$elm$core$Platform$Cmd$none);
				case 'OnPDFRotationAlert':
					return _Utils_Tuple2(
						updateCurrentModel(
							_Utils_update(
								loadedModel,
								{status: $author$project$Type$UploadMultipleDocument$RotationAlert})),
						$elm$core$Platform$Cmd$none);
				case 'BackToDashboard':
					return _Utils_Tuple2(
						model,
						A2($elm$browser$Browser$Navigation$replaceUrl, model.navKey, $author$project$Data$Route$routeUrl.dashboard));
				case 'CloseAlert':
					return _Utils_Tuple2(
						updateCurrentModel(
							_Utils_update(
								loadedModel,
								{status: $author$project$Type$UploadMultipleDocument$Editing})),
						$elm$core$Platform$Cmd$none);
				case 'OnPageEnter':
					return _Utils_Tuple2(
						model,
						A2(
							$elm$core$Task$attempt,
							A2(
								$elm$core$Basics$composeL,
								A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnMultipleDocUpload),
								$author$project$Type$UploadMultipleDocument$OnDashboardApiResponse),
							A2($author$project$Data$Api$Points$PointsDashboard$authCall, authModel.user.jwt, model.apiEndPoint.pointsDashboard)));
				default:
					var response = msg.a;
					if (response.$ === 'Ok') {
						var result = response.a;
						return _Utils_Tuple2(
							updateCurrentModel(
								_Utils_update(
									loadedModel,
									{
										signingCost: $elm$core$Basics$ceiling(result.usdToPoints)
									})),
							$elm$core$Platform$Cmd$none);
					} else {
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					}
			}
		}
	});
var $author$project$Type$VerifyDocument$CheckingVerification = {$: 'CheckingVerification'};
var $author$project$Type$VerifyDocument$Error = function (a) {
	return {$: 'Error', a: a};
};
var $author$project$Type$VerifyDocument$GotFiles = F2(
	function (a, b) {
		return {$: 'GotFiles', a: a, b: b};
	});
var $author$project$Type$VerifyDocument$OnJsonDataExtraction = function (a) {
	return {$: 'OnJsonDataExtraction', a: a};
};
var $author$project$Type$VerifyDocument$OnVerifyResult = function (a) {
	return {$: 'OnVerifyResult', a: a};
};
var $author$project$Type$VerifyDocument$VerificationSuccess = function (a) {
	return {$: 'VerificationSuccess', a: a};
};
var $author$project$Data$JsonReader$VerifiableCredential = function (docId) {
	return function (issuer) {
		return function (annotations) {
			return function (ownerId) {
				return function (firstName) {
					return function (lastName) {
						return function (title) {
							return function (createdAt) {
								return function (completedAt) {
									return function (domain) {
										return function (additionalMsg) {
											return function (dueDate) {
												return function (initializeVectorMerged) {
													return {additionalMsg: additionalMsg, annotations: annotations, completedAt: completedAt, createdAt: createdAt, docId: docId, domain: domain, dueDate: dueDate, firstName: firstName, initializeVectorMerged: initializeVectorMerged, issuer: issuer, lastName: lastName, ownerId: ownerId, title: title};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Data$JsonReader$Annotation = F9(
	function (content, type_, width, height, x, y, userId, page, fontSize) {
		return {content: content, fontSize: fontSize, height: height, page: page, type_: type_, userId: userId, width: width, x: x, y: y};
	});
var $author$project$Data$JsonReader$decodeAnnotation = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'fontSize',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'page',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'userId',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'y',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'x',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'height',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'width',
							$elm$json$Json$Decode$string,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'type',
								$elm$json$Json$Decode$string,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'content',
									$elm$json$Json$Decode$string,
									$elm$json$Json$Decode$succeed($author$project$Data$JsonReader$Annotation))))))))));
var $author$project$Data$JsonReader$decodeAnnotList = $elm$json$Json$Decode$list($author$project$Data$JsonReader$decodeAnnotation);
var $author$project$Data$JsonReader$Issuer = F3(
	function (documentStore, name, identityProof) {
		return {documentStore: documentStore, identityProof: identityProof, name: name};
	});
var $author$project$Data$JsonReader$IdentityProof = F2(
	function (location, type_) {
		return {location: location, type_: type_};
	});
var $author$project$Data$JsonReader$decodeIdentityProof = A3(
	$elm$json$Json$Decode$map2,
	$author$project$Data$JsonReader$IdentityProof,
	A2($elm$json$Json$Decode$field, 'location', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'type', $elm$json$Json$Decode$string));
var $author$project$Data$JsonReader$decodeIssuer = A4(
	$elm$json$Json$Decode$map3,
	$author$project$Data$JsonReader$Issuer,
	A2($elm$json$Json$Decode$field, 'documentStore', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'name', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'identityProof', $author$project$Data$JsonReader$decodeIdentityProof));
var $author$project$Data$JsonReader$dataDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'initializeVectorMerged',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'dueDate',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'additionalMsg',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'domain',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'completedAt',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'createdAt',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'title',
							$elm$json$Json$Decode$string,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'lastName',
								$elm$json$Json$Decode$string,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'firstName',
									$elm$json$Json$Decode$string,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'ownerId',
										$elm$json$Json$Decode$string,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'annotations',
											$author$project$Data$JsonReader$decodeAnnotList,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'issuer',
												$author$project$Data$JsonReader$decodeIssuer,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'docId',
													$elm$json$Json$Decode$string,
													$elm$json$Json$Decode$succeed($author$project$Data$JsonReader$VerifiableCredential))))))))))))));
var $author$project$Data$JsonReader$decodeJsonData = function (base64Data) {
	var _v0 = A2($elm$json$Json$Decode$decodeValue, $author$project$Data$JsonReader$dataDecoder, base64Data);
	if (_v0.$ === 'Ok') {
		var results = _v0.a;
		return $elm$core$Result$Ok(results);
	} else {
		return $elm$core$Result$Err('Error Converting File.');
	}
};
var $author$project$Data$Api$PDF$VerifyDocument$errorToString = function (error) {
	if (error.$ === 'WRONG_FILE_FORMAT') {
		return 'JSON file only.';
	} else {
		return 'Document Credentials are invalid.';
	}
};
var $author$project$Model$VerifyDocument$readJsonFile = _Platform_outgoingPort('readJsonFile', $elm$json$Json$Encode$string);
var $author$project$Data$Api$PDF$VerifyDocument$Payload = F4(
	function (annotations, docId, transactionId, inputData) {
		return {annotations: annotations, docId: docId, inputData: inputData, transactionId: transactionId};
	});
var $author$project$Data$Api$PDF$VerifyDocument$AnnotationData = F3(
	function (content, userName, type_) {
		return {content: content, type_: type_, userName: userName};
	});
var $author$project$Data$Api$PDF$VerifyDocument$annotationDataDecoder = A4(
	$elm$json$Json$Decode$map3,
	$author$project$Data$Api$PDF$VerifyDocument$AnnotationData,
	A2($elm$json$Json$Decode$field, 'content', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'userName', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'type', $elm$json$Json$Decode$string));
var $author$project$Data$Api$PDF$VerifyDocument$dataDecoder = A5(
	$elm$json$Json$Decode$map4,
	$author$project$Data$Api$PDF$VerifyDocument$Payload,
	A2(
		$elm$json$Json$Decode$field,
		'annotations',
		$elm$json$Json$Decode$list($author$project$Data$Api$PDF$VerifyDocument$annotationDataDecoder)),
	A2($elm$json$Json$Decode$field, 'docId', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'transactionId', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'inputData', $elm$json$Json$Decode$string));
var $author$project$Data$Api$PDF$VerifyDocument$encodeAnnotation = function (annot) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'content',
				$elm$json$Json$Encode$string(annot.content)),
				_Utils_Tuple2(
				'type',
				$elm$json$Json$Encode$string(annot.type_)),
				_Utils_Tuple2(
				'width',
				$elm$json$Json$Encode$string(annot.width)),
				_Utils_Tuple2(
				'height',
				$elm$json$Json$Encode$string(annot.height)),
				_Utils_Tuple2(
				'x',
				$elm$json$Json$Encode$string(annot.x)),
				_Utils_Tuple2(
				'y',
				$elm$json$Json$Encode$string(annot.y)),
				_Utils_Tuple2(
				'userId',
				$elm$json$Json$Encode$string(annot.userId)),
				_Utils_Tuple2(
				'page',
				$elm$json$Json$Encode$string(annot.page)),
				_Utils_Tuple2(
				'fontSize',
				$elm$json$Json$Encode$string(annot.fontSize))
			]));
};
var $author$project$Data$Api$PDF$VerifyDocument$encodeAnnotationList = function (annotations) {
	return A2($elm$json$Json$Encode$list, $author$project$Data$Api$PDF$VerifyDocument$encodeAnnotation, annotations);
};
var $author$project$Data$Api$PDF$VerifyDocument$encodeIdentityProof = function (identityProof) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'location',
				$elm$json$Json$Encode$string(identityProof.location)),
				_Utils_Tuple2(
				'type',
				$elm$json$Json$Encode$string(identityProof.type_))
			]));
};
var $author$project$Data$Api$PDF$VerifyDocument$encodeIssuer = function (issuer) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'documentStore',
				$elm$json$Json$Encode$string(issuer.documentStore)),
				_Utils_Tuple2(
				'name',
				$elm$json$Json$Encode$string(issuer.name)),
				_Utils_Tuple2(
				'identityProof',
				$author$project$Data$Api$PDF$VerifyDocument$encodeIdentityProof(issuer.identityProof))
			]));
};
var $author$project$Data$Api$PDF$VerifyDocument$encode = function (data) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'docId',
				$elm$json$Json$Encode$string(data.docId)),
				_Utils_Tuple2(
				'issuer',
				$author$project$Data$Api$PDF$VerifyDocument$encodeIssuer(data.issuer)),
				_Utils_Tuple2(
				'annotations',
				$author$project$Data$Api$PDF$VerifyDocument$encodeAnnotationList(data.annotations)),
				_Utils_Tuple2(
				'ownerId',
				$elm$json$Json$Encode$string(data.ownerId)),
				_Utils_Tuple2(
				'firstName',
				$elm$json$Json$Encode$string(data.firstName)),
				_Utils_Tuple2(
				'lastName',
				$elm$json$Json$Encode$string(data.lastName)),
				_Utils_Tuple2(
				'title',
				$elm$json$Json$Encode$string(data.title)),
				_Utils_Tuple2(
				'createdAt',
				$elm$json$Json$Encode$string(data.createdAt)),
				_Utils_Tuple2(
				'completedAt',
				$elm$json$Json$Encode$string(data.completedAt)),
				_Utils_Tuple2(
				'domain',
				$elm$json$Json$Encode$string(data.domain)),
				_Utils_Tuple2(
				'additionalMsg',
				$elm$json$Json$Encode$string(data.additionalMsg)),
				_Utils_Tuple2(
				'dueDate',
				$elm$json$Json$Encode$string(data.dueDate)),
				_Utils_Tuple2(
				'initializeVectorMerged',
				$elm$json$Json$Encode$string(data.initializeVectorMerged))
			]));
};
var $author$project$Data$Api$PDF$VerifyDocument$INVALID_CREDENTIALS = {$: 'INVALID_CREDENTIALS'};
var $author$project$Data$Api$PDF$VerifyDocument$WRONG_FILE_FORMAT = {$: 'WRONG_FILE_FORMAT'};
var $author$project$Data$Api$PDF$VerifyDocument$errorDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (errorCode) {
		switch (errorCode) {
			case 'WRONG_FILE_FORMAT':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$PDF$VerifyDocument$WRONG_FILE_FORMAT);
			case 'INVALID_CREDENTIALS':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$PDF$VerifyDocument$INVALID_CREDENTIALS);
			default:
				return $elm$json$Json$Decode$fail('Invalid error code: ' + errorCode);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Data$Api$PDF$VerifyDocument$upload = F3(
	function (jwt, endPoint, file) {
		return A5(
			$author$project$Data$Api$authCall,
			jwt,
			endPoint,
			$author$project$Data$Api$PDF$VerifyDocument$errorDecoder,
			$author$project$Data$Api$PDF$VerifyDocument$dataDecoder,
			$author$project$Data$Api$PDF$VerifyDocument$encode(file));
	});
var $author$project$Model$VerifyDocument$update = F3(
	function (msg, authModel, model) {
		var verifyDocumentModel = authModel.verifyDocumentModel;
		switch (msg.$) {
			case 'PickFile':
				return _Utils_Tuple2(
					model,
					A2(
						$elm$core$Platform$Cmd$map,
						$author$project$Types$OnAuth,
						A2(
							$elm$core$Platform$Cmd$map,
							$author$project$Types$OnVerifyDocument,
							A2(
								$elm$file$File$Select$files,
								_List_fromArray(
									['application/json']),
								$author$project$Type$VerifyDocument$GotFiles))));
			case 'GotFiles':
				var file = msg.a;
				var _v1 = _Utils_Tuple2(
					$elm$file$File$mime(file) === 'application/json',
					$elm$file$File$size(file) < 26214400);
				if (!_v1.b) {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								sessionModel: $author$project$Types$Auth(
									_Utils_update(
										authModel,
										{
											verifyDocumentModel: _Utils_update(
												verifyDocumentModel,
												{
													fileHover: false,
													status: $author$project$Type$VerifyDocument$Error('File Too Big.')
												})
										}))
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					if (_v1.a) {
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									sessionModel: $author$project$Types$Auth(
										_Utils_update(
											authModel,
											{
												verifyDocumentModel: _Utils_update(
													verifyDocumentModel,
													{status: $author$project$Type$VerifyDocument$CheckingVerification})
											}))
								}),
							A2(
								$elm$core$Task$perform,
								A2(
									$elm$core$Basics$composeL,
									A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnVerifyDocument),
									$author$project$Type$VerifyDocument$OnJsonDataExtraction),
								$elm$file$File$toUrl(file)));
					} else {
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									sessionModel: $author$project$Types$Auth(
										_Utils_update(
											authModel,
											{
												verifyDocumentModel: _Utils_update(
													verifyDocumentModel,
													{
														fileHover: false,
														status: $author$project$Type$VerifyDocument$Error('Incorrect File Format')
													})
											}))
								}),
							$elm$core$Platform$Cmd$none);
					}
				}
			case 'OnDragEnter':
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							sessionModel: $author$project$Types$Auth(
								_Utils_update(
									authModel,
									{
										verifyDocumentModel: _Utils_update(
											verifyDocumentModel,
											{fileHover: true})
									}))
						}),
					$elm$core$Platform$Cmd$none);
			case 'OnDragLeave':
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							sessionModel: $author$project$Types$Auth(
								_Utils_update(
									authModel,
									{
										verifyDocumentModel: _Utils_update(
											verifyDocumentModel,
											{fileHover: false})
									}))
						}),
					$elm$core$Platform$Cmd$none);
			case 'OnRemoveFile':
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							sessionModel: $author$project$Types$Auth(
								_Utils_update(
									authModel,
									{
										verifyDocumentModel: _Utils_update(
											verifyDocumentModel,
											{base64File: $elm$core$Maybe$Nothing, file: $elm$core$Maybe$Nothing})
									}))
						}),
					$elm$core$Platform$Cmd$none);
			case 'OnVerifyResult':
				var response = msg.a;
				if (response.$ === 'Ok') {
					var result = response.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								sessionModel: $author$project$Types$Auth(
									_Utils_update(
										authModel,
										{
											verifyDocumentModel: _Utils_update(
												verifyDocumentModel,
												{
													status: $author$project$Type$VerifyDocument$VerificationSuccess(result)
												})
										}))
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var error = response.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								sessionModel: $author$project$Types$Auth(
									_Utils_update(
										authModel,
										{
											verifyDocumentModel: _Utils_update(
												verifyDocumentModel,
												{
													status: $author$project$Type$VerifyDocument$Error(
														A2($author$project$Data$Api$authErrorToString, $author$project$Data$Api$PDF$VerifyDocument$errorToString, error))
												})
										}))
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 'OnJsonDataExtraction':
				var base64Data = msg.a;
				return _Utils_Tuple2(
					model,
					$author$project$Model$VerifyDocument$readJsonFile(base64Data));
			default:
				var jsonData = msg.a;
				var _v3 = $author$project$Data$JsonReader$decodeJsonData(jsonData);
				if (_v3.$ === 'Ok') {
					var data = _v3.a;
					return _Utils_Tuple2(
						model,
						A2(
							$elm$core$Task$attempt,
							A2(
								$elm$core$Basics$composeL,
								A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnVerifyDocument),
								$author$project$Type$VerifyDocument$OnVerifyResult),
							A3($author$project$Data$Api$PDF$VerifyDocument$upload, authModel.user.jwt, model.apiEndPoint.verifyDocument, data)));
				} else {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								sessionModel: $author$project$Types$Auth(
									_Utils_update(
										authModel,
										{
											verifyDocumentModel: _Utils_update(
												verifyDocumentModel,
												{
													status: $author$project$Type$VerifyDocument$Error('Invalid Json File.')
												})
										}))
							}),
						$elm$core$Platform$Cmd$none);
				}
		}
	});
var $author$project$Type$ViewDocument$CheckUserUpdatedName = function (a) {
	return {$: 'CheckUserUpdatedName', a: a};
};
var $author$project$Type$ViewDocument$NotTokenUser = {$: 'NotTokenUser'};
var $author$project$Type$ViewDocument$TokenDoesNotExist = {$: 'TokenDoesNotExist'};
var $author$project$Type$ViewDocument$ValidateDocumentTokenResult = function (a) {
	return {$: 'ValidateDocumentTokenResult', a: a};
};
var $author$project$Type$ViewDocument$VerificationError = function (a) {
	return {$: 'VerificationError', a: a};
};
var $author$project$Data$Api$PDF$ValidateDocumentToken$Payload = F2(
	function (user, docId) {
		return {docId: docId, user: user};
	});
var $author$project$Data$Api$PDF$ValidateDocumentToken$dataDecoder = A3(
	$elm$json$Json$Decode$map2,
	$author$project$Data$Api$PDF$ValidateDocumentToken$Payload,
	A2(
		$elm$json$Json$Decode$andThen,
		function (jwt) {
			return A2(
				$elm$json$Json$Decode$field,
				'user',
				$author$project$Data$User$decoderWithJwt(jwt));
		},
		A2($elm$json$Json$Decode$field, 'jwt', $elm$json$Json$Decode$string)),
	A2($elm$json$Json$Decode$field, 'docId', $elm$json$Json$Decode$string));
var $author$project$Data$Api$PDF$ValidateDocumentToken$UNAUTHOURIZED_ACCESS = {$: 'UNAUTHOURIZED_ACCESS'};
var $author$project$Data$Api$PDF$ValidateDocumentToken$errorDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (errorCode) {
		if (errorCode === 'UNAUTHOURIZED_ACCESS') {
			return $elm$json$Json$Decode$succeed($author$project$Data$Api$PDF$ValidateDocumentToken$UNAUTHOURIZED_ACCESS);
		} else {
			return $elm$json$Json$Decode$fail('Invalid error code: ' + errorCode);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Data$Api$PDF$ValidateDocumentToken$call = F2(
	function (token, endPoint) {
		return A5(
			$author$project$Data$Api$authCall,
			token,
			endPoint,
			$author$project$Data$Api$PDF$ValidateDocumentToken$errorDecoder,
			$author$project$Data$Api$PDF$ValidateDocumentToken$dataDecoder,
			$elm$json$Json$Encode$object(_List_Nil));
	});
var $author$project$Type$ViewDocument$Document = {$: 'Document'};
var $author$project$Type$ViewDocument$LoadDocument = function (a) {
	return {$: 'LoadDocument', a: a};
};
var $author$project$Type$ViewDocument$LoadDocumentResult = function (a) {
	return {$: 'LoadDocumentResult', a: a};
};
var $author$project$Type$ViewDocument$LoadWithESignatureDisclaimer = F2(
	function (a, b) {
		return {$: 'LoadWithESignatureDisclaimer', a: a, b: b};
	});
var $author$project$Type$ViewDocument$Loaded = function (a) {
	return {$: 'Loaded', a: a};
};
var $author$project$Type$ViewDocument$Loading = {$: 'Loading'};
var $author$project$Type$ViewDocument$LoadingApiError = function (a) {
	return {$: 'LoadingApiError', a: a};
};
var $author$project$Type$ViewDocument$LoadingDecodeError = function (a) {
	return {$: 'LoadingDecodeError', a: a};
};
var $author$project$Type$ViewDocument$LoadingState = function (a) {
	return {$: 'LoadingState', a: a};
};
var $author$project$Type$ViewDocument$NoDownload = {$: 'NoDownload'};
var $author$project$Type$ViewDocument$NoHover = {$: 'NoHover'};
var $author$project$Type$ViewDocument$NotAccepted = {$: 'NotAccepted'};
var $author$project$Type$ViewDocument$OnAcceptESignDisclaimerResult = F2(
	function (a, b) {
		return {$: 'OnAcceptESignDisclaimerResult', a: a, b: b};
	});
var $author$project$Type$ViewDocument$OnNameSubmitResult = F2(
	function (a, b) {
		return {$: 'OnNameSubmitResult', a: a, b: b};
	});
var $author$project$Type$ViewDocument$UpdateUserCurrentName = F2(
	function (a, b) {
		return {$: 'UpdateUserCurrentName', a: a, b: b};
	});
var $author$project$Data$Api$PDF$View$Payload = F6(
	function (document, recipients, annotations, logs, domainOwners, ownerShareReferralCode) {
		return {annotations: annotations, document: document, domainOwners: domainOwners, logs: logs, ownerShareReferralCode: ownerShareReferralCode, recipients: recipients};
	});
var $author$project$Data$Api$PDF$View$Annotation = function (id) {
	return function (type_) {
		return function (isVerified) {
			return function (width) {
				return function (height) {
					return function (fontSize) {
						return function (x) {
							return function (y) {
								return function (page) {
									return function (userId) {
										return function (email) {
											return {email: email, fontSize: fontSize, height: height, id: id, isVerified: isVerified, page: page, type_: type_, userId: userId, width: width, x: x, y: y};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Data$Api$PDF$View$Checkbox = function (a) {
	return {$: 'Checkbox', a: a};
};
var $author$project$Data$Api$PDF$View$Date = function (a) {
	return {$: 'Date', a: a};
};
var $author$project$Data$Api$PDF$View$EditableText = function (a) {
	return {$: 'EditableText', a: a};
};
var $author$project$Data$Api$PDF$View$Email = function (a) {
	return {$: 'Email', a: a};
};
var $author$project$Data$Api$PDF$View$Name = function (a) {
	return {$: 'Name', a: a};
};
var $author$project$Data$Api$PDF$View$NonEditableText = function (a) {
	return {$: 'NonEditableText', a: a};
};
var $author$project$Data$Api$PDF$View$Signature = function (a) {
	return {$: 'Signature', a: a};
};
var $author$project$Data$Api$PDF$View$Stamp = function (a) {
	return {$: 'Stamp', a: a};
};
var $author$project$Data$PDF$Stamp$idFromPathInBackendDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (pathInBackendString) {
		return A2(
			$elm$core$Maybe$withDefault,
			$elm$json$Json$Decode$fail('Invalid stamp filePath: ' + pathInBackendString),
			A2(
				$elm$core$Maybe$map,
				$elm$json$Json$Decode$succeed,
				A2(
					$elm$core$Maybe$andThen,
					$elm$core$List$head,
					A2(
						$elm$core$Maybe$map,
						$elm$core$String$split('.'),
						$elm$core$List$head(
							$elm$core$List$reverse(
								A2($elm$core$String$split, '/', pathInBackendString)))))));
	},
	$elm$json$Json$Decode$string);
var $author$project$Data$Api$PDF$View$decodeAnnotContent = A2(
	$elm$json$Json$Decode$andThen,
	function (annotType) {
		switch (annotType) {
			case 'Name':
				return A2(
					$elm$json$Json$Decode$map,
					$author$project$Data$Api$PDF$View$Name,
					A2($elm$json$Json$Decode$field, 'data', $elm$json$Json$Decode$string));
			case 'Date':
				return A2(
					$elm$json$Json$Decode$map,
					$author$project$Data$Api$PDF$View$Date,
					A2(
						$elm$json$Json$Decode$map,
						$elm$time$Time$millisToPosix,
						A2($elm$json$Json$Decode$field, 'posix', $elm$json$Json$Decode$int)));
			case 'Stamp':
				return A2(
					$elm$json$Json$Decode$map,
					$author$project$Data$Api$PDF$View$Stamp,
					A2($elm$json$Json$Decode$field, 'filePath', $author$project$Data$PDF$Stamp$idFromPathInBackendDecoder));
			case 'Signature':
				return A2(
					$elm$json$Json$Decode$map,
					$author$project$Data$Api$PDF$View$Signature,
					A2($elm$json$Json$Decode$field, 'filePath', $elm$json$Json$Decode$string));
			case 'EditableText':
				return A2(
					$elm$json$Json$Decode$map,
					$author$project$Data$Api$PDF$View$EditableText,
					A2($elm$json$Json$Decode$field, 'data', $elm$json$Json$Decode$string));
			case 'NonEditableText':
				return A2(
					$elm$json$Json$Decode$map,
					$author$project$Data$Api$PDF$View$NonEditableText,
					A2($elm$json$Json$Decode$field, 'data', $elm$json$Json$Decode$string));
			case 'Email':
				return A2(
					$elm$json$Json$Decode$map,
					$author$project$Data$Api$PDF$View$Email,
					A2($elm$json$Json$Decode$field, 'data', $elm$json$Json$Decode$string));
			case 'Checkbox':
				return A2(
					$elm$json$Json$Decode$map,
					$author$project$Data$Api$PDF$View$Checkbox,
					A2($elm$json$Json$Decode$field, 'data', $elm$json$Json$Decode$string));
			default:
				return $elm$json$Json$Decode$fail('Invalid annotation type.');
		}
	},
	A2($elm$json$Json$Decode$field, 'type', $elm$json$Json$Decode$string));
var $author$project$Data$Api$PDF$View$decodeAnnotation = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'email',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'userId',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'page',
			$elm$json$Json$Decode$int,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'y',
				$elm$json$Json$Decode$float,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'x',
					$elm$json$Json$Decode$float,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'fontSize',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'height',
							$elm$json$Json$Decode$float,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'width',
								$elm$json$Json$Decode$float,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'isVerified',
									$elm$json$Json$Decode$bool,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
										_List_fromArray(
											['type']),
										$author$project$Data$Api$PDF$View$decodeAnnotContent,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'id',
											$elm$json$Json$Decode$string,
											$elm$json$Json$Decode$succeed($author$project$Data$Api$PDF$View$Annotation))))))))))));
var $author$project$Data$Api$PDF$View$decodeAnnotList = $elm$json$Json$Decode$list($author$project$Data$Api$PDF$View$decodeAnnotation);
var $author$project$Data$Api$PDF$View$Document = function (id) {
	return function (title) {
		return function (ownerId) {
			return function (createdAt) {
				return function (updatedAt) {
					return function (firstName) {
						return function (lastName) {
							return function (email) {
								return function (isDocumentEncrypted) {
									return function (dueDate) {
										return function (password) {
											return function (additionalMsg) {
												return function (requireNotarisation) {
													return function (notarisationStatus) {
														return function (transactionHash) {
															return function (merkleRoot) {
																return function (notarisationTimeStamp) {
																	return function (verifyPassbase) {
																		return function (verifyMyInfo) {
																			return function (verifyMobilePhone) {
																				return function (verifyStripe) {
																					return function (verifyWallet) {
																						return function (passcode) {
																							return function (checksum) {
																								return function (notarisationNetwork) {
																									return function (templateId) {
																										return function (saveDocument) {
																											return function (noOfPages) {
																												return {additionalMsg: additionalMsg, checksum: checksum, createdAt: createdAt, dueDate: dueDate, email: email, firstName: firstName, id: id, isDocumentEncrypted: isDocumentEncrypted, lastName: lastName, merkleRoot: merkleRoot, noOfPages: noOfPages, notarisationNetwork: notarisationNetwork, notarisationStatus: notarisationStatus, notarisationTimeStamp: notarisationTimeStamp, ownerId: ownerId, passcode: passcode, password: password, requireNotarisation: requireNotarisation, saveDocument: saveDocument, templateId: templateId, title: title, transactionHash: transactionHash, updatedAt: updatedAt, verifyMobilePhone: verifyMobilePhone, verifyMyInfo: verifyMyInfo, verifyPassbase: verifyPassbase, verifyStripe: verifyStripe, verifyWallet: verifyWallet};
																											};
																										};
																									};
																								};
																							};
																						};
																					};
																				};
																			};
																		};
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Data$Api$PDF$View$decodeDocument = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'noOfPages',
	$elm$json$Json$Decode$int,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'saveDocument',
		$elm$json$Json$Decode$bool,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'templateId',
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
			$elm$core$Maybe$Nothing,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'notarisationNetwork',
				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
				$elm$core$Maybe$Nothing,
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'checksum',
					$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
					$elm$core$Maybe$Nothing,
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'passcode',
						$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
						$elm$core$Maybe$Nothing,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'verifyWallet',
							$elm$json$Json$Decode$bool,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'verifyStripe',
								$elm$json$Json$Decode$bool,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'verifyMobilePhone',
									$elm$json$Json$Decode$bool,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'verifyMyInfo',
										$elm$json$Json$Decode$bool,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'verifyPassbase',
											$elm$json$Json$Decode$bool,
											A4(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
												'notarisationTimeStamp',
												$elm$json$Json$Decode$nullable(
													A2($elm$json$Json$Decode$map, $elm$time$Time$millisToPosix, $elm$json$Json$Decode$int)),
												$elm$core$Maybe$Nothing,
												A4(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
													'merkleRoot',
													$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
													$elm$core$Maybe$Nothing,
													A4(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
														'transactionHash',
														$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
														$elm$core$Maybe$Nothing,
														A4(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
															'notarisationStatus',
															$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
															$elm$core$Maybe$Nothing,
															A3(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																'requireNotarisation',
																$elm$json$Json$Decode$bool,
																A4(
																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																	'additionalMsg',
																	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
																	$elm$core$Maybe$Nothing,
																	A4(
																		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																		'password',
																		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
																		$elm$core$Maybe$Nothing,
																		A4(
																			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																			'dueDate',
																			A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
																			$elm$core$Maybe$Nothing,
																			A3(
																				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																				'isDocumentEncrypted',
																				$elm$json$Json$Decode$bool,
																				A3(
																					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																					'email',
																					$elm$json$Json$Decode$string,
																					A3(
																						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																						'lastName',
																						$elm$json$Json$Decode$string,
																						A3(
																							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																							'firstName',
																							$elm$json$Json$Decode$string,
																							A3(
																								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																								'updatedAt',
																								A2($elm$json$Json$Decode$map, $elm$time$Time$millisToPosix, $elm$json$Json$Decode$int),
																								A3(
																									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																									'createdAt',
																									A2($elm$json$Json$Decode$map, $elm$time$Time$millisToPosix, $elm$json$Json$Decode$int),
																									A3(
																										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																										'ownerId',
																										$elm$json$Json$Decode$string,
																										A3(
																											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																											'title',
																											$elm$json$Json$Decode$string,
																											A3(
																												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																												'id',
																												$elm$json$Json$Decode$string,
																												$elm$json$Json$Decode$succeed($author$project$Data$Api$PDF$View$Document)))))))))))))))))))))))))))));
var $author$project$Data$Api$PDF$View$DomainOwner = F4(
	function (userId, firstName, lastName, email) {
		return {email: email, firstName: firstName, lastName: lastName, userId: userId};
	});
var $author$project$Data$Api$PDF$View$decodeDomainOwner = $elm$json$Json$Decode$list(
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'email',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'lastName',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'firstName',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'userId',
					$elm$json$Json$Decode$string,
					$elm$json$Json$Decode$succeed($author$project$Data$Api$PDF$View$DomainOwner))))));
var $author$project$Data$Api$PDF$View$Log = F5(
	function (userId, action, createdAt, ipAddr, credentialName) {
		return {action: action, createdAt: createdAt, credentialName: credentialName, ipAddr: ipAddr, userId: userId};
	});
var $author$project$Data$Api$PDF$View$DownloadIncompletePDF = {$: 'DownloadIncompletePDF'};
var $author$project$Data$Api$PDF$View$DownloadPDF = {$: 'DownloadPDF'};
var $author$project$Data$Api$PDF$View$DownloadVerifiableCredential = {$: 'DownloadVerifiableCredential'};
var $author$project$Data$Api$PDF$View$DownloadWrappedDocument = {$: 'DownloadWrappedDocument'};
var $author$project$Data$Api$PDF$View$GenerateVerifiableCredential = {$: 'GenerateVerifiableCredential'};
var $author$project$Data$Api$PDF$View$Reminder = {$: 'Reminder'};
var $author$project$Data$Api$PDF$View$Security = {$: 'Security'};
var $author$project$Data$Api$PDF$View$Send = {$: 'Send'};
var $author$project$Data$Api$PDF$View$Sign = {$: 'Sign'};
var $author$project$Data$Api$PDF$View$View = {$: 'View'};
var $author$project$Data$Api$PDF$View$decodeLogAction = function (action) {
	switch (action) {
		case 'Send':
			return $elm$json$Json$Decode$succeed($author$project$Data$Api$PDF$View$Send);
		case 'Sign':
			return $elm$json$Json$Decode$succeed($author$project$Data$Api$PDF$View$Sign);
		case 'View':
			return $elm$json$Json$Decode$succeed($author$project$Data$Api$PDF$View$View);
		case 'DownloadPDF':
			return $elm$json$Json$Decode$succeed($author$project$Data$Api$PDF$View$DownloadPDF);
		case 'DownloadWrappedDocument':
			return $elm$json$Json$Decode$succeed($author$project$Data$Api$PDF$View$DownloadWrappedDocument);
		case 'DownloadVerifiableCredential':
			return $elm$json$Json$Decode$succeed($author$project$Data$Api$PDF$View$DownloadVerifiableCredential);
		case 'Reminder':
			return $elm$json$Json$Decode$succeed($author$project$Data$Api$PDF$View$Reminder);
		case 'Security':
			return $elm$json$Json$Decode$succeed($author$project$Data$Api$PDF$View$Security);
		case 'GenerateVerifiableCredential':
			return $elm$json$Json$Decode$succeed($author$project$Data$Api$PDF$View$GenerateVerifiableCredential);
		case 'DownloadIncompletePDF':
			return $elm$json$Json$Decode$succeed($author$project$Data$Api$PDF$View$DownloadIncompletePDF);
		default:
			return $elm$json$Json$Decode$fail('Invalid action type.');
	}
};
var $author$project$Data$Api$PDF$View$decodeLog = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'credentialName',
	A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
	$elm$core$Maybe$Nothing,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'ipAddr',
		A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
		$elm$core$Maybe$Nothing,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'createdAt',
			A2($elm$json$Json$Decode$map, $elm$time$Time$millisToPosix, $elm$json$Json$Decode$int),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'action',
				A2(
					$elm$json$Json$Decode$andThen,
					function (action) {
						return $author$project$Data$Api$PDF$View$decodeLogAction(action);
					},
					$elm$json$Json$Decode$string),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'userId',
					$elm$json$Json$Decode$string,
					$elm$json$Json$Decode$succeed($author$project$Data$Api$PDF$View$Log))))));
var $author$project$Data$Api$PDF$View$decodeLogList = $elm$json$Json$Decode$list($author$project$Data$Api$PDF$View$decodeLog);
var $author$project$Data$Api$PDF$View$Recipient = function (userId) {
	return function (firstName) {
		return function (lastName) {
			return function (signOrder) {
				return function (status) {
					return function (email) {
						return function (verifyPassbase) {
							return function (verifyMyInfo) {
								return function (verifyMobilePhone) {
									return function (verifyStripe) {
										return function (verifyWallet) {
											return function (role) {
												return {email: email, firstName: firstName, lastName: lastName, role: role, signOrder: signOrder, status: status, userId: userId, verifyMobilePhone: verifyMobilePhone, verifyMyInfo: verifyMyInfo, verifyPassbase: verifyPassbase, verifyStripe: verifyStripe, verifyWallet: verifyWallet};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Data$Api$PDF$View$Active = {$: 'Active'};
var $author$project$Data$Api$PDF$View$Anonymous = {$: 'Anonymous'};
var $author$project$Data$Api$PDF$View$Unverified = {$: 'Unverified'};
var $author$project$Data$Api$PDF$View$decodeRecipientStatus = A2(
	$elm$json$Json$Decode$andThen,
	function (status) {
		switch (status) {
			case 'Active':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$PDF$View$Active);
			case 'Anonymous':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$PDF$View$Anonymous);
			case 'Unverified':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$PDF$View$Unverified);
			default:
				return $elm$json$Json$Decode$fail('Not a valid user.');
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Data$Api$PDF$View$decodeRecipient = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'role',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
	$elm$core$Maybe$Nothing,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'verifyWallet',
		$elm$json$Json$Decode$bool,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'verifyStripe',
			$elm$json$Json$Decode$bool,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'verifyMobilePhone',
				$elm$json$Json$Decode$bool,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'verifyMyInfo',
					$elm$json$Json$Decode$bool,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'verifyPassbase',
						$elm$json$Json$Decode$bool,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'email',
							$elm$json$Json$Decode$string,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'status',
								$author$project$Data$Api$PDF$View$decodeRecipientStatus,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'signOrder',
									$elm$json$Json$Decode$int,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'lastName',
										$elm$json$Json$Decode$string,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'firstName',
											$elm$json$Json$Decode$string,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'userId',
												$elm$json$Json$Decode$string,
												$elm$json$Json$Decode$succeed($author$project$Data$Api$PDF$View$Recipient)))))))))))));
var $author$project$Data$Api$PDF$View$decodeRecipientList = $elm$json$Json$Decode$list($author$project$Data$Api$PDF$View$decodeRecipient);
var $author$project$Data$Api$PDF$View$dataDecoder = A7(
	$elm$json$Json$Decode$map6,
	$author$project$Data$Api$PDF$View$Payload,
	A2($elm$json$Json$Decode$field, 'document', $author$project$Data$Api$PDF$View$decodeDocument),
	A2($elm$json$Json$Decode$field, 'recipients', $author$project$Data$Api$PDF$View$decodeRecipientList),
	A2($elm$json$Json$Decode$field, 'annotations', $author$project$Data$Api$PDF$View$decodeAnnotList),
	A2($elm$json$Json$Decode$field, 'logs', $author$project$Data$Api$PDF$View$decodeLogList),
	A2($elm$json$Json$Decode$field, 'domainOwners', $author$project$Data$Api$PDF$View$decodeDomainOwner),
	A2($elm$json$Json$Decode$field, 'ownerShareReferralCode', $elm$json$Json$Decode$string));
var $author$project$Data$Api$PDF$View$encodeDocId = F2(
	function (docId, domain) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'docId',
					$elm$json$Json$Encode$string(docId)),
					_Utils_Tuple2(
					'domain',
					$elm$json$Json$Encode$string(
						$author$project$Data$Domain$toString(domain)))
				]));
	});
var $author$project$Data$Api$PDF$View$DELETED_DOCUMENT = {$: 'DELETED_DOCUMENT'};
var $author$project$Data$Api$PDF$View$INVALID_DOC_ID = {$: 'INVALID_DOC_ID'};
var $author$project$Data$Api$PDF$View$UNAUTHORISED_USER = {$: 'UNAUTHORISED_USER'};
var $author$project$Data$Api$PDF$View$errorDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (errorCode) {
		switch (errorCode) {
			case 'INVALID_DOC_ID':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$PDF$View$INVALID_DOC_ID);
			case 'UNAUTHORISED_USER':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$PDF$View$UNAUTHORISED_USER);
			case 'DELETED_DOCUMENT':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$PDF$View$DELETED_DOCUMENT);
			default:
				return $elm$json$Json$Decode$fail('Invalid error code: ' + errorCode);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Data$Api$PDF$View$authCall = F4(
	function (jwt, endPoint, docId, domain) {
		return A5(
			$author$project$Data$Api$authCall,
			jwt,
			endPoint,
			$author$project$Data$Api$PDF$View$errorDecoder,
			$author$project$Data$Api$PDF$View$dataDecoder,
			A2($author$project$Data$Api$PDF$View$encodeDocId, docId, domain));
	});
var $author$project$Data$Api$UpdateESignatureDisclaimer$Payload = function (message) {
	return {message: message};
};
var $author$project$Data$Api$UpdateESignatureDisclaimer$dataDecoder = A2(
	$elm$json$Json$Decode$map,
	$author$project$Data$Api$UpdateESignatureDisclaimer$Payload,
	A2($elm$json$Json$Decode$field, 'userID', $elm$json$Json$Decode$string));
var $author$project$Data$Api$UpdateESignatureDisclaimer$JSON_WEB_TOKEN_ERROR = {$: 'JSON_WEB_TOKEN_ERROR'};
var $author$project$Data$Api$UpdateESignatureDisclaimer$errorDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (errorCode) {
		if (errorCode === 'INVALID_ACTIVATE_CODE') {
			return $elm$json$Json$Decode$succeed($author$project$Data$Api$UpdateESignatureDisclaimer$JSON_WEB_TOKEN_ERROR);
		} else {
			return $elm$json$Json$Decode$fail('Invalid error code: ' + errorCode);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Data$Api$UpdateESignatureDisclaimer$authCall = F2(
	function (jwt, endPoint) {
		return A5(
			$author$project$Data$Api$authCall,
			jwt,
			endPoint,
			$author$project$Data$Api$UpdateESignatureDisclaimer$errorDecoder,
			$author$project$Data$Api$UpdateESignatureDisclaimer$dataDecoder,
			$elm$json$Json$Encode$object(_List_Nil));
	});
var $author$project$Data$Api$UpdateUserName$Payload = function (message) {
	return {message: message};
};
var $author$project$Data$Api$UpdateUserName$dataDecoder = A2(
	$elm$json$Json$Decode$map,
	$author$project$Data$Api$UpdateUserName$Payload,
	A2($elm$json$Json$Decode$field, 'message', $elm$json$Json$Decode$string));
var $author$project$Data$Api$UpdateUserName$encode = F2(
	function (firstName, lastName) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'firstName',
					$elm$json$Json$Encode$string(firstName)),
					_Utils_Tuple2(
					'lastName',
					$elm$json$Json$Encode$string(lastName))
				]));
	});
var $author$project$Data$Api$UpdateUserName$EMPTY_NAME = {$: 'EMPTY_NAME'};
var $author$project$Data$Api$UpdateUserName$UNAUTHORISED_USER = {$: 'UNAUTHORISED_USER'};
var $author$project$Data$Api$UpdateUserName$errorDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (errorCode) {
		switch (errorCode) {
			case 'UNAUTHORISED_USER':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$UpdateUserName$UNAUTHORISED_USER);
			case 'EMPTY_NAME':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$UpdateUserName$EMPTY_NAME);
			default:
				return $elm$json$Json$Decode$fail('Invalid error code: ' + errorCode);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Data$Api$UpdateUserName$authCall = F4(
	function (jwt, endPoint, firstName, lastName) {
		return A5(
			$author$project$Data$Api$authCall,
			jwt,
			endPoint,
			$author$project$Data$Api$UpdateUserName$errorDecoder,
			$author$project$Data$Api$UpdateUserName$dataDecoder,
			A2($author$project$Data$Api$UpdateUserName$encode, firstName, lastName));
	});
var $author$project$Model$ViewDocument$displayViewDocumentMenuAdsContent = _Platform_outgoingPort('displayViewDocumentMenuAdsContent', $elm$core$Basics$identity);
var $author$project$Type$ViewDocument$NotSigned = {$: 'NotSigned'};
var $author$project$Type$ViewDocument$Signed = {$: 'Signed'};
var $author$project$Type$ViewDocument$Viewer = {$: 'Viewer'};
var $author$project$Model$ViewDocument$getRecipientWithStatus = F2(
	function (annotations, _v0) {
		var name = _v0.name;
		var signOrder = _v0.signOrder;
		var email = _v0.email;
		var verifyPassbase = _v0.verifyPassbase;
		var verifyMyInfo = _v0.verifyMyInfo;
		var verifyMobilePhone = _v0.verifyMobilePhone;
		var verifyStripe = _v0.verifyStripe;
		var verifyWallet = _v0.verifyWallet;
		var userId = _v0.userId;
		var role = _v0.role;
		return (signOrder >= 0) ? function (nonVerified) {
			var getStatus = nonVerified ? $author$project$Type$ViewDocument$NotSigned : $author$project$Type$ViewDocument$Signed;
			return {email: email, name: name, role: role, signOrder: signOrder, status: getStatus, userId: userId, verifyMobilePhone: verifyMobilePhone, verifyMyInfo: verifyMyInfo, verifyPassbase: verifyPassbase, verifyStripe: verifyStripe, verifyWallet: verifyWallet};
		}(
			A2(
				$elm$core$List$any,
				function (r) {
					return !r.isVerified;
				},
				A2(
					$elm$core$List$filter,
					function (annotation) {
						return _Utils_eq(annotation.email, email);
					},
					annotations))) : {email: email, name: name, role: role, signOrder: signOrder, status: $author$project$Type$ViewDocument$Viewer, userId: userId, verifyMobilePhone: verifyMobilePhone, verifyMyInfo: verifyMyInfo, verifyPassbase: verifyPassbase, verifyStripe: verifyStripe, verifyWallet: verifyWallet};
	});
var $author$project$Data$PDF$Complete = {$: 'Complete'};
var $author$project$Data$PDF$Pending = {$: 'Pending'};
var $author$project$Data$PDF$convertToNotarisationStatusType = function (notarisationString) {
	var _v0 = A2($elm$core$Maybe$withDefault, '', notarisationString);
	switch (_v0) {
		case 'Pending':
			return $elm$core$Maybe$Just($author$project$Data$PDF$Pending);
		case 'Completed':
			return $elm$core$Maybe$Just($author$project$Data$PDF$Complete);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Data$PDF$User$currentUserColor = F2(
	function (currentUserEmail, email) {
		return _Utils_eq(currentUserEmail, email) ? $author$project$Data$PDF$User$Blue : $author$project$Data$PDF$User$Transparent;
	});
var $author$project$Data$PDF$getSmallerSigningOrder = F2(
	function (recipients, emails) {
		return $elm$core$List$minimum(
			A2(
				$elm$core$List$map,
				function (r) {
					return r.signOrder;
				},
				A2(
					$elm$core$List$filter,
					function (recipient) {
						return A2($elm$core$List$member, recipient.email, emails);
					},
					recipients)));
	});
var $author$project$Data$PDF$removeDuplicates = F2(
	function (el, list) {
		return A2($elm$core$List$member, el, list) ? list : A2($elm$core$List$cons, el, list);
	});
var $author$project$Data$PDF$getCurrentSigningOrder = F2(
	function (annotation, recipient) {
		return A2(
			$author$project$Data$PDF$getSmallerSigningOrder,
			recipient,
			A3(
				$elm$core$List$foldl,
				$author$project$Data$PDF$removeDuplicates,
				_List_Nil,
				A2(
					$elm$core$List$map,
					function (a) {
						return a.email;
					},
					A2(
						$elm$core$List$filter,
						function (annot) {
							return !annot.isVerified;
						},
						annotation))));
	});
var $author$project$Data$PDF$Awaiting = function (a) {
	return {$: 'Awaiting', a: a};
};
var $author$project$Data$PDF$Completed = {$: 'Completed'};
var $author$project$Data$PDF$Expired = {$: 'Expired'};
var $author$project$Data$PDF$Signing = {$: 'Signing'};
var $elm$time$Time$utc = A2($elm$time$Time$Zone, 0, _List_Nil);
var $author$project$Data$PDF$isExpired = F2(
	function (currentTime, _v0) {
		var pdf = _v0.a;
		var currentDate = A3(
			$ryannhg$date_format$DateFormat$format,
			_List_fromArray(
				[
					$ryannhg$date_format$DateFormat$yearNumber,
					$ryannhg$date_format$DateFormat$text('-'),
					$ryannhg$date_format$DateFormat$monthFixed,
					$ryannhg$date_format$DateFormat$text('-'),
					$ryannhg$date_format$DateFormat$dayOfMonthFixed
				]),
			$elm$time$Time$utc,
			currentTime);
		var _v1 = pdf.dueDate;
		if (_v1.$ === 'Nothing') {
			return false;
		} else {
			var dueDate_ = _v1.a;
			return _Utils_cmp(currentDate, dueDate_) > 0;
		}
	});
var $author$project$Data$PDF$pdfStatus = F6(
	function (currentUserEmail, annotList, recipients, currentSigningOrder, currentTime, pdf) {
		var isCompleted = A2(
			$elm$core$List$all,
			function (a) {
				return a.isVerified;
			},
			annotList);
		if (isCompleted) {
			return $author$project$Data$PDF$Completed;
		} else {
			var isDocExpired = A2($author$project$Data$PDF$isExpired, currentTime, pdf);
			if (isDocExpired) {
				return $author$project$Data$PDF$Expired;
			} else {
				var isSigning = A2(
					$elm$core$List$any,
					function (a) {
						return (!a.isVerified) && _Utils_eq(a.email, currentUserEmail);
					},
					annotList);
				if (isSigning) {
					var isCurrentSigner = A2(
						$elm$core$Maybe$withDefault,
						false,
						A2(
							$elm$core$Maybe$map,
							function (signNumber) {
								return _Utils_eq(signNumber, currentSigningOrder);
							},
							$elm$core$List$minimum(
								A2(
									$elm$core$List$map,
									function (r) {
										return r.signOrder;
									},
									A2(
										$elm$core$List$filter,
										function (recipient) {
											return _Utils_eq(recipient.email, currentUserEmail);
										},
										recipients)))));
					if (isCurrentSigner) {
						return $author$project$Data$PDF$Signing;
					} else {
						var currentSigner = A2(
							$elm$core$String$join,
							', ',
							A2(
								$elm$core$List$map,
								function (r) {
									return r.firstName + (' ' + r.lastName);
								},
								A2(
									$elm$core$List$filter,
									function (recipient) {
										return _Utils_eq(recipient.signOrder, currentSigningOrder);
									},
									recipients)));
						return $author$project$Data$PDF$Awaiting('Awaiting ' + (currentSigner + ' signature(s)'));
					}
				} else {
					var uncompletedAnnots = A2(
						$elm$core$List$map,
						function (a) {
							return a.userId;
						},
						A2(
							$elm$core$List$filter,
							function (annots) {
								return !annots.isVerified;
							},
							annotList));
					var recipientsNotSigned = A2(
						$elm$core$List$filterMap,
						function (recipient) {
							return A2($elm$core$List$member, recipient.userId, uncompletedAnnots) ? $elm$core$Maybe$Just(recipient.firstName + (' ' + recipient.lastName)) : $elm$core$Maybe$Nothing;
						},
						recipients);
					var recipientNames = 'Awaiting ' + (A2($elm$core$String$join, ', ', recipientsNotSigned) + ' signature(s)');
					return $author$project$Data$PDF$Viewing(
						$elm$core$Maybe$Just(recipientNames));
				}
			}
		}
	});
var $author$project$Data$Api$PDF$View$splitRecipients = function (recipients) {
	return A2(
		$elm$core$List$partition,
		function (r) {
			return _Utils_eq(r.signOrder, -1);
		},
		recipients);
};
var $author$project$Data$PDF$createSigner = F4(
	function (user, signOrder_, signature, annotations_) {
		return $author$project$Data$PDF$Signer(
			{annotations: annotations_, signOrder: signOrder_, signature: signature, stamp: $elm$core$Maybe$Nothing, user: user});
	});
var $author$project$Data$PDF$Annotation$loadedCheckbox = F3(
	function (content, dbId, style) {
		var checkStatus = function () {
			switch (content) {
				case 'Checked':
					return $author$project$Data$PDF$Annotation$Checked;
				case 'Unchecked':
					return $author$project$Data$PDF$Annotation$Unchecked;
				case 'PlaceHolder':
					return $author$project$Data$PDF$Annotation$PlaceHolder;
				default:
					return $author$project$Data$PDF$Annotation$PlaceHolder;
			}
		}();
		return $author$project$Data$PDF$Annotation$Checkbox(
			{
				dbId: dbId,
				id: A3($author$project$Data$PDF$Annotation$generateId, content, 'Verified', style),
				status: checkStatus,
				style: style
			});
	});
var $author$project$Data$PDF$Annotation$toPDFAnnot = function (annot) {
	var style = {fontSize: annot.fontSize, height: annot.height, page: annot.page, width: annot.width, x: annot.x, y: annot.y};
	var _v0 = annot;
	var isVerified = _v0.isVerified;
	var type_ = _v0.type_;
	var dateTxt_ = function (content) {
		return A4($author$project$Data$PDF$Annotation$filledDateTxt, annot.id, content, isVerified, style);
	};
	var txt = function (content) {
		return A4($author$project$Data$PDF$Annotation$filledTxt, annot.id, content, isVerified, style);
	};
	switch (type_.$) {
		case 'Name':
			var content = type_.a;
			return $author$project$Data$PDF$Annotation$Name(
				txt(content));
		case 'Date':
			var content = type_.a;
			return $author$project$Data$PDF$Annotation$Date(
				dateTxt_(content));
		case 'NonEditableText':
			var content = type_.a;
			return $author$project$Data$PDF$Annotation$NonEditableText(
				txt(content));
		case 'EditableText':
			var content = type_.a;
			return $author$project$Data$PDF$Annotation$EditableText(
				txt(content));
		case 'Stamp':
			var content = type_.a;
			return $author$project$Data$PDF$Annotation$IsStamp(
				A4($author$project$Data$PDF$Annotation$filledStamp, annot.id, content, isVerified, style));
		case 'Signature':
			var content = type_.a;
			return $author$project$Data$PDF$Annotation$IsSignature(
				A4($author$project$Data$PDF$Annotation$filledSignature, annot.id, content, isVerified, style));
		case 'Email':
			var content = type_.a;
			return $author$project$Data$PDF$Annotation$IsEmail(
				txt(content));
		default:
			var content = type_.a;
			return $author$project$Data$PDF$Annotation$IsCheckbox(
				A3($author$project$Data$PDF$Annotation$loadedCheckbox, content, annot.id, style));
	}
};
var $author$project$Data$PDF$Annotation$toSignerAnnots = F2(
	function (recipient, annotations) {
		return $author$project$Data$PDF$Annotation$signatureAndAnnots(
			A2(
				$elm$core$List$filterMap,
				function (a) {
					return _Utils_eq(recipient.email, a.email) ? $elm$core$Maybe$Just(
						$author$project$Data$PDF$Annotation$toPDFAnnot(a)) : $elm$core$Maybe$Nothing;
				},
				annotations));
	});
var $author$project$Data$PDF$User$toUser = F2(
	function (currentUserEmail, recipient) {
		var _v0 = recipient;
		var email = _v0.email;
		var firstName = _v0.firstName;
		var lastName = _v0.lastName;
		var status = _v0.status;
		var verifyStripe = _v0.verifyStripe;
		var verifyPassbase = _v0.verifyPassbase;
		var verifyMobilePhone = _v0.verifyMobilePhone;
		var verifyWallet = _v0.verifyWallet;
		var verifyMyInfo = _v0.verifyMyInfo;
		var info_ = A9(
			$author$project$Data$PDF$User$info,
			email,
			firstName,
			lastName,
			verifyStripe,
			verifyPassbase,
			verifyMobilePhone,
			verifyWallet,
			verifyMyInfo,
			A2($author$project$Data$PDF$User$currentUserColor, currentUserEmail, email));
		switch (status.$) {
			case 'Active':
				return A2($author$project$Data$PDF$User$registered, $elm$core$Maybe$Nothing, info_);
			case 'Anonymous':
				return $author$project$Data$PDF$User$unregistered(info_);
			default:
				return $author$project$Data$PDF$User$unregistered(info_);
		}
	});
var $author$project$Data$PDF$toSigners = F3(
	function (currentUserEmail, annotations_, signers_) {
		return A3(
			$elm$core$List$foldl,
			F2(
				function (signer, accumulator) {
					if (accumulator.$ === 'Err') {
						return accumulator;
					} else {
						var dict = accumulator.a;
						var signerAnnots = A2($author$project$Data$PDF$Annotation$toSignerAnnots, signer, annotations_);
						if (signerAnnots.$ === 'Nothing') {
							return $elm$core$Result$Err('Unable to load annotations of ' + signer.firstName);
						} else {
							var _v2 = signerAnnots.a;
							var signature = _v2.a;
							var restAnnots = _v2.b;
							return $elm$core$Result$Ok(
								A3(
									$elm$core$Dict$insert,
									signer.email,
									A4(
										$author$project$Data$PDF$createSigner,
										A2($author$project$Data$PDF$User$toUser, currentUserEmail, signer),
										signer.signOrder,
										signature,
										restAnnots),
									dict));
						}
					}
				}),
			$elm$core$Result$Ok($elm$core$Dict$empty),
			signers_);
	});
var $author$project$Data$PDF$toViewers = F2(
	function (currentUserEmail, recipients) {
		return A2(
			$elm$core$List$map,
			function (r) {
				return $author$project$Data$PDF$Viewer(
					A2($author$project$Data$PDF$User$toUser, currentUserEmail, r));
			},
			recipients);
	});
var $author$project$Data$PDF$initFilledPDF = F4(
	function (user, domain_, currentTime, payload) {
		var currentSigningOrder = A2(
			$elm$core$Maybe$withDefault,
			0,
			A2($author$project$Data$PDF$getCurrentSigningOrder, payload.annotations, payload.recipients));
		var _v0 = $author$project$Data$Api$PDF$View$splitRecipients(payload.recipients);
		var viewApiViewers = _v0.a;
		var viewApiSigners = _v0.b;
		var pdfSignersResult = A3($author$project$Data$PDF$toSigners, user.email, payload.annotations, viewApiSigners);
		var pdfViewers = A2($author$project$Data$PDF$toViewers, user.email, viewApiViewers);
		var _v1 = payload.document;
		var createdAt = _v1.createdAt;
		var updatedAt = _v1.updatedAt;
		var firstName = _v1.firstName;
		var lastName = _v1.lastName;
		var email = _v1.email;
		var password = _v1.password;
		var verifyMobilePhone = _v1.verifyMobilePhone;
		var verifyMyInfo = _v1.verifyMyInfo;
		var verifyPassbase = _v1.verifyPassbase;
		var verifyStripe = _v1.verifyStripe;
		var verifyWallet = _v1.verifyWallet;
		var pdfOwner = A2(
			$author$project$Data$PDF$User$registered,
			$elm$core$Maybe$Nothing,
			A9(
				$author$project$Data$PDF$User$info,
				email,
				firstName,
				lastName,
				verifyStripe,
				verifyPassbase,
				verifyMobilePhone,
				verifyWallet,
				verifyMyInfo,
				A2($author$project$Data$PDF$User$currentUserColor, user.email, email)));
		if (pdfSignersResult.$ === 'Err') {
			var err = pdfSignersResult.a;
			return $elm$core$Result$Err(err);
		} else {
			var pdfSigners = pdfSignersResult.a;
			var status_ = A6(
				$author$project$Data$PDF$pdfStatus,
				user.email,
				payload.annotations,
				payload.recipients,
				currentSigningOrder,
				currentTime,
				$author$project$Data$PDF$PDF(
					{
						additionalMsg: payload.document.additionalMsg,
						checksum: payload.document.checksum,
						createdAt: createdAt,
						domain: domain_,
						dueDate: payload.document.dueDate,
						id: payload.document.id,
						merkleRoot: payload.document.merkleRoot,
						notarisationNetwork: payload.document.notarisationNetwork,
						notarisationStatus: $author$project$Data$PDF$convertToNotarisationStatusType(payload.document.notarisationStatus),
						notarisationTimeStamp: payload.document.notarisationTimeStamp,
						owner: pdfOwner,
						password: password,
						requireNotarisation: payload.document.requireNotarisation,
						signers: pdfSigners,
						status: $author$project$Data$PDF$Viewing($elm$core$Maybe$Nothing),
						templateId: payload.document.templateId,
						title: payload.document.title,
						transactionHash: payload.document.transactionHash,
						updatedAt: updatedAt,
						viewers: pdfViewers
					}));
			return $elm$core$Result$Ok(
				$author$project$Data$PDF$PDF(
					{
						additionalMsg: payload.document.additionalMsg,
						checksum: payload.document.checksum,
						createdAt: createdAt,
						domain: domain_,
						dueDate: payload.document.dueDate,
						id: payload.document.id,
						merkleRoot: payload.document.merkleRoot,
						notarisationNetwork: payload.document.notarisationNetwork,
						notarisationStatus: $author$project$Data$PDF$convertToNotarisationStatusType(payload.document.notarisationStatus),
						notarisationTimeStamp: payload.document.notarisationTimeStamp,
						owner: pdfOwner,
						password: password,
						requireNotarisation: payload.document.requireNotarisation,
						signers: pdfSigners,
						status: status_,
						templateId: payload.document.templateId,
						title: payload.document.title,
						transactionHash: payload.document.transactionHash,
						updatedAt: updatedAt,
						viewers: pdfViewers
					}));
		}
	});
var $author$project$Data$PDF$Port$encodePDFData = function (_v0) {
	var id = _v0.id;
	var status = _v0.status;
	var fileUrl = _v0.fileUrl;
	var jwt = _v0.jwt;
	var owner = _v0.owner;
	var currentUser = _v0.currentUser;
	var filledAnnots = _v0.filledAnnots;
	var password = _v0.password;
	var isExpired = _v0.isExpired;
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'id',
				$elm$json$Json$Encode$string(id)),
				_Utils_Tuple2(
				'status',
				$elm$json$Json$Encode$string(status)),
				_Utils_Tuple2(
				'fileUrl',
				$elm$json$Json$Encode$string(fileUrl)),
				_Utils_Tuple2(
				'jwt',
				$elm$json$Json$Encode$string(jwt)),
				_Utils_Tuple2(
				'owner',
				$author$project$Data$PDF$Port$encodePDFUser(owner)),
				_Utils_Tuple2(
				'currentUser',
				$author$project$Data$PDF$Port$encodePDFUser(currentUser)),
				_Utils_Tuple2(
				'filledAnnots',
				$author$project$Data$PDF$Port$encodeFilledDocumentAnnots(filledAnnots)),
				_Utils_Tuple2(
				'password',
				A2(
					$elm$core$Maybe$withDefault,
					$elm$json$Json$Encode$null,
					A2($elm$core$Maybe$map, $elm$json$Json$Encode$string, password))),
				_Utils_Tuple2(
				'isExpired',
				$elm$json$Json$Encode$bool(isExpired))
			]));
};
var $author$project$Data$PDF$Port$loadDocument = _Platform_outgoingPort('loadDocument', $elm$core$Basics$identity);
var $author$project$Data$PDF$Port$load = function (pdf) {
	return $author$project$Data$PDF$Port$loadDocument(
		$author$project$Data$PDF$Port$encodePDFData(pdf));
};
var $author$project$Data$PDF$Annotation$filterUnverifiedAnnots = F3(
	function (currentUserEmail, signerEmail, annotations) {
		return A2(
			$elm$core$List$filter,
			function (annot) {
				return _Utils_eq(currentUserEmail, signerEmail) || $author$project$Data$PDF$Annotation$isVerifiedAnnot(annot);
			},
			annotations);
	});
var $author$project$Data$PDF$Annotation$removeSignedSignatures = function (annotations) {
	return A2(
		$elm$core$List$filter,
		function (annot) {
			if (annot.$ === 'IsSignature') {
				var signature = annot.a.a;
				var _v1 = signature.status;
				if (_v1.$ === 'Signed') {
					return false;
				} else {
					return true;
				}
			} else {
				return true;
			}
		},
		annotations);
};
var $author$project$Data$PDF$Annotation$toSignatureAnnot = function (signature) {
	return $author$project$Data$PDF$Annotation$IsSignature(signature);
};
var $author$project$Data$PDF$toStringStatus = function (status_) {
	switch (status_.$) {
		case 'Signing':
			return 'Signing';
		case 'Viewing':
			var text = status_.a;
			return 'Viewing' + A2($elm$core$Maybe$withDefault, '', text);
		case 'Completed':
			return 'Completed';
		case 'Expired':
			return 'Expired';
		default:
			var signerText = status_.a;
			return signerText;
	}
};
var $author$project$Data$PDF$toPortLoadPDF = F5(
	function (endPoint, jwt, currentTime, currentUser, _v0) {
		var pdf = _v0.a;
		var currentUserEmail = $author$project$Data$PDF$User$emailFromUser(currentUser);
		var filledAnnots = function (dictSigners) {
			return A3(
				$elm$core$Dict$foldl,
				F3(
					function (_v1, _v2, accumulator) {
						var v = _v2.a;
						var updatedAnnots = $author$project$Data$PDF$Annotation$removeSignedSignatures(
							A3(
								$author$project$Data$PDF$Annotation$filterUnverifiedAnnots,
								currentUserEmail,
								$author$project$Data$PDF$User$emailFromUser(v.user),
								_Utils_ap(
									v.annotations,
									_List_fromArray(
										[
											$author$project$Data$PDF$Annotation$toSignatureAnnot(v.signature)
										]))));
						return A2(
							$elm$core$List$cons,
							{annotations: updatedAnnots, user: v.user},
							accumulator);
					}),
				_List_Nil,
				dictSigners);
		};
		return {
			currentUser: currentUser,
			fileUrl: endPoint + ('/' + (pdf.id + ('/' + $author$project$Data$Domain$toString(pdf.domain)))),
			filledAnnots: filledAnnots(pdf.signers),
			id: pdf.id,
			isExpired: A2(
				$author$project$Data$PDF$isExpired,
				currentTime,
				$author$project$Data$PDF$PDF(pdf)),
			jwt: jwt,
			owner: pdf.owner,
			password: pdf.password,
			status: $author$project$Data$PDF$toStringStatus(pdf.status)
		};
	});
var $author$project$Data$PDF$loadPDF = F5(
	function (endpoint, jwt, currentTime, currentUser, pdf) {
		return $author$project$Data$PDF$Port$load(
			A5($author$project$Data$PDF$toPortLoadPDF, endpoint, jwt, currentTime, currentUser, pdf));
	});
var $author$project$Data$PDF$status = function (_v0) {
	var pdf = _v0.a;
	return pdf.status;
};
var $author$project$Model$ViewDocument$getNameFromDomainOwners = F3(
	function (domainOwners, log, ownerName) {
		return A2(
			$elm$core$Maybe$withDefault,
			ownerName,
			A2(
				$elm$core$Maybe$map,
				function (user) {
					return user.firstName + (' ' + user.lastName);
				},
				$elm$core$List$head(
					A2(
						$elm$core$List$filter,
						function (domainOwner) {
							return _Utils_eq(domainOwner.userId, log.userId);
						},
						domainOwners))));
	});
var $author$project$Model$ViewDocument$getNameFromRecipients = F4(
	function (recipients, domainOwners, ownerName, log) {
		return A2(
			$elm$core$Maybe$withDefault,
			A3($author$project$Model$ViewDocument$getNameFromDomainOwners, domainOwners, log, ownerName),
			A2(
				$elm$core$Maybe$map,
				function (user) {
					return user.firstName + (' ' + user.lastName);
				},
				$elm$core$List$head(
					A2(
						$elm$core$List$filter,
						function (recipient) {
							return _Utils_eq(recipient.userId, log.userId);
						},
						recipients))));
	});
var $author$project$Model$ViewDocument$toLogModel = F4(
	function (recipients, domainOwners, ownerName, log) {
		var name = A4($author$project$Model$ViewDocument$getNameFromRecipients, recipients, domainOwners, ownerName, log);
		var email = A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				function (x) {
					return x.email;
				},
				$elm$core$List$head(
					A2(
						$elm$core$List$filter,
						function (r) {
							return _Utils_eq(r.userId, log.userId);
						},
						recipients))));
		return {
			action: log.action,
			credentialName: log.credentialName,
			dateTime: log.createdAt,
			email: email,
			ipAddr: A2($elm$core$Maybe$withDefault, '-', log.ipAddr),
			name: name
		};
	});
var $author$project$Type$ViewDocument$Accepted = {$: 'Accepted'};
var $author$project$Model$ViewDocument$toggleESignDisclaimerStatus = function (model) {
	if (model.$ === 'LoadWithESignatureDisclaimer') {
		var docId = model.a;
		var status = model.b;
		if (status.$ === 'Accepted') {
			return A2($author$project$Type$ViewDocument$LoadWithESignatureDisclaimer, docId, $author$project$Type$ViewDocument$NotAccepted);
		} else {
			return A2($author$project$Type$ViewDocument$LoadWithESignatureDisclaimer, docId, $author$project$Type$ViewDocument$Accepted);
		}
	} else {
		return model;
	}
};
var $author$project$Data$PDF$Port$unload = $author$project$Data$PDF$Port$closeDocument2;
var $author$project$Data$PDF$unloadPDF = $author$project$Data$PDF$Port$unload;
var $author$project$Type$ViewDocument$Algorand = {$: 'Algorand'};
var $author$project$Type$ViewDocument$DownloadError = function (a) {
	return {$: 'DownloadError', a: a};
};
var $author$project$Type$ViewDocument$DownloadResult = function (a) {
	return {$: 'DownloadResult', a: a};
};
var $author$project$Type$ViewDocument$Downloading = {$: 'Downloading'};
var $author$project$Type$ViewDocument$EncryptionDecodeError = function (a) {
	return {$: 'EncryptionDecodeError', a: a};
};
var $author$project$Type$ViewDocument$Error = function (a) {
	return {$: 'Error', a: a};
};
var $author$project$Type$ViewDocument$HasUnverifiedAnnotation = function (a) {
	return {$: 'HasUnverifiedAnnotation', a: a};
};
var $author$project$Type$ViewDocument$Hover = F2(
	function (a, b) {
		return {$: 'Hover', a: a, b: b};
	});
var $author$project$Type$ViewDocument$LoadSignature = {$: 'LoadSignature'};
var $author$project$Type$ViewDocument$LoadStamp = {$: 'LoadStamp'};
var $author$project$Type$ViewDocument$LoadStampResult = function (a) {
	return {$: 'LoadStampResult', a: a};
};
var $author$project$Type$ViewDocument$NeedPassword = {$: 'NeedPassword'};
var $author$project$Type$ViewDocument$OnAcceptESignDisclaimerUserResult = function (a) {
	return {$: 'OnAcceptESignDisclaimerUserResult', a: a};
};
var $author$project$Type$ViewDocument$OnDocSubmitResult = function (a) {
	return {$: 'OnDocSubmitResult', a: a};
};
var $author$project$Type$ViewDocument$OnPasscodeSubmitResult = function (a) {
	return {$: 'OnPasscodeSubmitResult', a: a};
};
var $author$project$Type$ViewDocument$OnSignatureTimestampingAlgorand = function (a) {
	return {$: 'OnSignatureTimestampingAlgorand', a: a};
};
var $author$project$Type$ViewDocument$OnSignatureTimestampingAlgorandResult = function (a) {
	return {$: 'OnSignatureTimestampingAlgorandResult', a: a};
};
var $author$project$Type$ViewDocument$Passcode = {$: 'Passcode'};
var $author$project$Type$ViewDocument$RequiredPasscode = {$: 'RequiredPasscode'};
var $author$project$Type$ViewDocument$SignApi = function (a) {
	return {$: 'SignApi', a: a};
};
var $author$project$Type$ViewDocument$SignedSignatureResult = function (a) {
	return {$: 'SignedSignatureResult', a: a};
};
var $author$project$Type$ViewDocument$Signing = {$: 'Signing'};
var $author$project$Type$ViewDocument$SnackbarClose = function (a) {
	return {$: 'SnackbarClose', a: a};
};
var $author$project$Type$ViewDocument$Success = {$: 'Success'};
var $author$project$Type$ViewDocument$UpdateAnnotName = F2(
	function (a, b) {
		return {$: 'UpdateAnnotName', a: a, b: b};
	});
var $author$project$Type$ViewDocument$UpdateAnnotations = function (a) {
	return {$: 'UpdateAnnotations', a: a};
};
var $author$project$Data$Api$PDF$Download$INCOMPLETE_DOC = {$: 'INCOMPLETE_DOC'};
var $author$project$Data$Api$PDF$Download$INVALID_DOC_ID = {$: 'INVALID_DOC_ID'};
var $author$project$Data$Api$PDF$Download$UNAUTHORIZED_USER = {$: 'UNAUTHORIZED_USER'};
var $author$project$Data$Api$PDF$Download$errorDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (errorCode) {
		switch (errorCode) {
			case 'INVALID_DOC_ID':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$PDF$Download$INVALID_DOC_ID);
			case 'UNAUTHORIZED_USER':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$PDF$Download$UNAUTHORIZED_USER);
			case 'INCOMPLETE_DOC':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$PDF$Download$INCOMPLETE_DOC);
			default:
				return $elm$json$Json$Decode$fail('Invalid error code: ' + errorCode);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Data$Api$PDF$Download$authCall = F5(
	function (jwt, endPoint, domain, docId, utcOffset) {
		return A3(
			$author$project$Data$Api$authGetFile,
			jwt,
			endPoint + (docId + ('/' + ($author$project$Data$Domain$toString(domain) + ('/' + $elm$core$String$fromFloat(utcOffset))))),
			$author$project$Data$Api$PDF$Download$errorDecoder);
	});
var $author$project$Data$Api$PDF$Update$Payload = F2(
	function (message, requireSignatureTimeStamping) {
		return {message: message, requireSignatureTimeStamping: requireSignatureTimeStamping};
	});
var $author$project$Data$Api$PDF$Update$dataDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'requireSignatureTimeStamping',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'message',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Data$Api$PDF$Update$Payload)));
var $author$project$Data$Api$PDF$Update$encodeAnnotations = function (annotation) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'id',
				$elm$json$Json$Encode$string(annotation.id)),
				_Utils_Tuple2(
				'content',
				$elm$json$Json$Encode$string(annotation.content)),
				_Utils_Tuple2(
				'updatedWidth',
				$elm$json$Json$Encode$float(annotation.updatedWidth))
			]));
};
var $author$project$Data$PDF$id = function (_v0) {
	var pdf = _v0.a;
	return pdf.id;
};
var $elm$core$List$singleton = function (value) {
	return _List_fromArray(
		[value]);
};
var $author$project$Data$PDF$Annotation$annotContent = function (annot) {
	switch (annot.$) {
		case 'Name':
			var txt = annot.a.a;
			return $elm$core$Maybe$Just(txt.text);
		case 'Date':
			var dateTxt_ = annot.a.a;
			return $elm$core$Maybe$Just(
				$author$project$Data$PDF$Annotation$toStringPosix(dateTxt_.date));
		case 'EditableText':
			var txt = annot.a.a;
			return $elm$core$Maybe$Just(txt.text);
		case 'NonEditableText':
			var txt = annot.a.a;
			return $elm$core$Maybe$Just(txt.text);
		case 'IsSignature':
			var signature = annot.a.a;
			var _v1 = signature.status;
			if (_v1.$ === 'Signed') {
				var sig = _v1.a;
				return $elm$core$Maybe$Just(
					$author$project$Data$PDF$Signature$id(sig));
			} else {
				return $elm$core$Maybe$Nothing;
			}
		case 'IsStamp':
			var stamp = annot.a.a;
			var _v2 = stamp.status;
			if (_v2.$ === 'Stamped') {
				var stamp_ = _v2.a;
				return $elm$core$Maybe$Just(
					$author$project$Data$PDF$Stamp$id(stamp_));
			} else {
				return $elm$core$Maybe$Nothing;
			}
		case 'IsEmail':
			var txt = annot.a.a;
			return $elm$core$Maybe$Just(txt.text);
		default:
			var checkbox = annot.a.a;
			return $elm$core$Maybe$Just(
				$author$project$Data$PDF$Annotation$toCheckBoxStatusString(checkbox.status));
	}
};
var $author$project$Data$PDF$Annotation$annotWidth = function (annot) {
	if (annot.$ === 'IsSignature') {
		var signature = annot.a.a;
		return signature.style.width;
	} else {
		return 0;
	}
};
var $author$project$Data$PDF$Annotation$annotdbId = function (annot) {
	switch (annot.$) {
		case 'Name':
			var txt = annot.a.a;
			return txt.dbId;
		case 'Date':
			var dateTxt_ = annot.a.a;
			return dateTxt_.dbId;
		case 'EditableText':
			var txt = annot.a.a;
			return txt.dbId;
		case 'NonEditableText':
			var txt = annot.a.a;
			return txt.dbId;
		case 'IsSignature':
			var signature = annot.a.a;
			return signature.dbId;
		case 'IsStamp':
			var stamp = annot.a.a;
			return stamp.dbId;
		case 'IsEmail':
			var txt = annot.a.a;
			return txt.dbId;
		default:
			var checkbox = annot.a.a;
			return checkbox.dbId;
	}
};
var $author$project$Data$Api$PDF$Update$toAnnotation = function (annot) {
	var width = $author$project$Data$PDF$Annotation$annotWidth(annot);
	var dbId = $author$project$Data$PDF$Annotation$annotdbId(annot);
	var content = A2(
		$elm$core$Maybe$withDefault,
		'',
		$author$project$Data$PDF$Annotation$annotContent(annot));
	return {content: content, id: dbId, updatedWidth: width};
};
var $author$project$Data$PDF$Annotation$dataSignatureId = function (_v0) {
	var signature = _v0.a;
	var _v1 = signature.status;
	if (_v1.$ === 'Signed') {
		var sig = _v1.a;
		return $elm$core$Maybe$Just(
			$author$project$Data$PDF$Signature$id(sig));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Data$PDF$Annotation$signatureStyle = function (_v0) {
	var signature = _v0.a;
	return signature.style;
};
var $author$project$Data$Api$PDF$Update$toSignature = function (signature) {
	var style = $author$project$Data$PDF$Annotation$signatureStyle(signature);
	var dbId = $author$project$Data$PDF$Annotation$signatureDbId(signature);
	var content = A2(
		$elm$core$Maybe$withDefault,
		'',
		$author$project$Data$PDF$Annotation$dataSignatureId(signature));
	return {content: content, id: dbId, updatedWidth: style.width};
};
var $author$project$Data$Api$PDF$Update$encode = F5(
	function (domain, email, docPassword, pdf, offset) {
		var signatureList = A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				function (signer) {
					return $elm$core$List$singleton(
						$author$project$Data$Api$PDF$Update$toSignature(
							$author$project$Data$PDF$signerSignature(signer)));
				},
				A2(
					$elm$core$Dict$get,
					email,
					$author$project$Data$PDF$signers(pdf))));
		var annotationList = A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				function (signer) {
					return A2(
						$elm$core$List$map,
						$author$project$Data$Api$PDF$Update$toAnnotation,
						$author$project$Data$PDF$annotations(signer));
				},
				A2(
					$elm$core$Dict$get,
					email,
					$author$project$Data$PDF$signers(pdf))));
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'docId',
					$elm$json$Json$Encode$string(
						$author$project$Data$PDF$id(pdf))),
					_Utils_Tuple2(
					'domain',
					$author$project$Data$Domain$encode(domain)),
					_Utils_Tuple2(
					'annotations',
					A2(
						$elm$json$Json$Encode$list,
						$author$project$Data$Api$PDF$Update$encodeAnnotations,
						_Utils_ap(annotationList, signatureList))),
					_Utils_Tuple2(
					'docPassword',
					A2(
						$elm$core$Maybe$withDefault,
						$elm$json$Json$Encode$null,
						A2($elm$core$Maybe$map, $elm$json$Json$Encode$string, docPassword))),
					_Utils_Tuple2(
					'offset',
					$elm$json$Json$Encode$string(offset))
				]));
	});
var $author$project$Data$Api$PDF$Update$ANNOTATION_NOT_FOUND = {$: 'ANNOTATION_NOT_FOUND'};
var $author$project$Data$Api$PDF$Update$APPEND_ERROR = {$: 'APPEND_ERROR'};
var $author$project$Data$Api$PDF$Update$FAIL_TO_UPDATE_ANNOTATION = {$: 'FAIL_TO_UPDATE_ANNOTATION'};
var $author$project$Data$Api$PDF$Update$FAIL_TO_UPDATE_DOCUMENT = {$: 'FAIL_TO_UPDATE_DOCUMENT'};
var $author$project$Data$Api$PDF$Update$FILE_NOT_FOUND = {$: 'FILE_NOT_FOUND'};
var $author$project$Data$Api$PDF$Update$INCORRECT_PASSWORD = {$: 'INCORRECT_PASSWORD'};
var $author$project$Data$Api$PDF$Update$INVALID_CERTIFICATE = {$: 'INVALID_CERTIFICATE'};
var $author$project$Data$Api$PDF$Update$LOADING_ERROR = {$: 'LOADING_ERROR'};
var $author$project$Data$Api$PDF$Update$NOT_CURRENT_SIGNING_ORDER = {$: 'NOT_CURRENT_SIGNING_ORDER'};
var $author$project$Data$Api$PDF$Update$NOT_IN_SIGNING_ORDER = {$: 'NOT_IN_SIGNING_ORDER'};
var $author$project$Data$Api$PDF$Update$SIGNATURE_HASH_ERROR = {$: 'SIGNATURE_HASH_ERROR'};
var $author$project$Data$Api$PDF$Update$TEMP_FILE_NOT_FOUND = {$: 'TEMP_FILE_NOT_FOUND'};
var $author$project$Data$Api$PDF$Update$UNEDITABLE_PDF = {$: 'UNEDITABLE_PDF'};
var $author$project$Data$Api$PDF$Update$UNKNOWN = {$: 'UNKNOWN'};
var $author$project$Data$Api$PDF$Update$errorDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (errorCode) {
		switch (errorCode) {
			case 'ANNOTATION_NOT_FOUND':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$PDF$Update$ANNOTATION_NOT_FOUND);
			case 'FAIL_TO_UPDATE_ANNOTATION':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$PDF$Update$FAIL_TO_UPDATE_ANNOTATION);
			case 'FAIL_TO_UPDATE_DOCUMENT':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$PDF$Update$FAIL_TO_UPDATE_DOCUMENT);
			case 'NOT_CURRENT_SIGNING_ORDER':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$PDF$Update$NOT_CURRENT_SIGNING_ORDER);
			case 'NOT_IN_SIGNING_ORDER':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$PDF$Update$NOT_IN_SIGNING_ORDER);
			case 'INCORRECT_PASSWORD':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$PDF$Update$INCORRECT_PASSWORD);
			case 'APPEND_ERROR':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$PDF$Update$APPEND_ERROR);
			case 'INVALID_CERTIFICATE':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$PDF$Update$INVALID_CERTIFICATE);
			case 'UNEDITABLE_PDF':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$PDF$Update$UNEDITABLE_PDF);
			case 'LOADING_ERROR':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$PDF$Update$LOADING_ERROR);
			case 'SIGNATURE_HASH_ERROR':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$PDF$Update$SIGNATURE_HASH_ERROR);
			case 'FILE_NOT_FOUND':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$PDF$Update$FILE_NOT_FOUND);
			case 'TEMP_FILE_NOT_FOUND':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$PDF$Update$TEMP_FILE_NOT_FOUND);
			case 'UNKNOWN':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$PDF$Update$UNKNOWN);
			default:
				return $elm$json$Json$Decode$fail('Invalid error code: ' + errorCode);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Data$Api$PDF$Update$authCall = F7(
	function (jwt, endPoint, email, domain, pdf, password, offset) {
		return A5(
			$author$project$Data$Api$authCall,
			jwt,
			endPoint,
			$author$project$Data$Api$PDF$Update$errorDecoder,
			$author$project$Data$Api$PDF$Update$dataDecoder,
			A5(
				$author$project$Data$Api$PDF$Update$encode,
				domain,
				email,
				password,
				pdf,
				$elm$core$String$fromFloat(offset)));
	});
var $author$project$Data$Api$PDF$ValidatePasscode$Payload = function (message) {
	return {message: message};
};
var $author$project$Data$Api$PDF$ValidatePasscode$dataDecoder = A2(
	$elm$json$Json$Decode$map,
	$author$project$Data$Api$PDF$ValidatePasscode$Payload,
	A2($elm$json$Json$Decode$field, 'message', $elm$json$Json$Decode$string));
var $author$project$Data$Api$PDF$ValidatePasscode$encode = F2(
	function (documentId, passcode) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'id',
					$elm$json$Json$Encode$string(documentId)),
					_Utils_Tuple2(
					'passcode',
					$elm$json$Json$Encode$string(passcode))
				]));
	});
var $author$project$Data$Api$PDF$ValidatePasscode$INVALID_DOCUMENT = {$: 'INVALID_DOCUMENT'};
var $author$project$Data$Api$PDF$ValidatePasscode$INVALID_PASSCODE = {$: 'INVALID_PASSCODE'};
var $author$project$Data$Api$PDF$ValidatePasscode$UNAUTHORISED_USER = {$: 'UNAUTHORISED_USER'};
var $author$project$Data$Api$PDF$ValidatePasscode$errorDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (errorCode) {
		switch (errorCode) {
			case 'UNAUTHORISED_USER':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$PDF$ValidatePasscode$UNAUTHORISED_USER);
			case 'INVALID_PASSCODE':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$PDF$ValidatePasscode$INVALID_PASSCODE);
			case 'INVALID_DOCUMENT':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$PDF$ValidatePasscode$INVALID_DOCUMENT);
			default:
				return $elm$json$Json$Decode$fail('Invalid error code: ' + errorCode);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Data$Api$PDF$ValidatePasscode$authCall = F4(
	function (jwt, endPoint, documentId, passcode) {
		return A5(
			$author$project$Data$Api$authCall,
			jwt,
			endPoint,
			$author$project$Data$Api$PDF$ValidatePasscode$errorDecoder,
			$author$project$Data$Api$PDF$ValidatePasscode$dataDecoder,
			A2($author$project$Data$Api$PDF$ValidatePasscode$encode, documentId, passcode));
	});
var $elm$core$String$concat = function (strings) {
	return A2($elm$core$String$join, '', strings);
};
var $author$project$Type$ViewDocument$Binance = {$: 'Binance'};
var $author$project$Model$ViewDocument$convertStringToNetwork = function (currentUserNotarisationNetwork) {
	switch (currentUserNotarisationNetwork) {
		case 'Binance':
			return $author$project$Type$ViewDocument$Binance;
		case 'Algorand':
			return $author$project$Type$ViewDocument$Algorand;
		default:
			return $author$project$Type$ViewDocument$Binance;
	}
};
var $author$project$Model$ViewDocument$CheckboxData = F2(
	function (id, value) {
		return {id: id, value: value};
	});
var $author$project$Model$ViewDocument$checkboxClickDecoder = A3(
	$elm$json$Json$Decode$map2,
	$author$project$Model$ViewDocument$CheckboxData,
	A2($elm$json$Json$Decode$field, 'id', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'value', $elm$json$Json$Decode$string));
var $author$project$Model$ViewDocument$decodeCheckboxClickData = function (value) {
	var _v0 = A2($elm$json$Json$Decode$decodeValue, $author$project$Model$ViewDocument$checkboxClickDecoder, value);
	if (_v0.$ === 'Ok') {
		var results = _v0.a;
		return $elm$core$Result$Ok(results);
	} else {
		return $elm$core$Result$Err('Error decoding checkbox data.');
	}
};
var $author$project$Data$Api$PDF$Download$errorToString = function (error) {
	switch (error.$) {
		case 'INVALID_DOC_ID':
			return 'Invalid document id.';
		case 'UNAUTHORIZED_USER':
			return 'Invalid data provided. Please refresh and try again.';
		default:
			return 'Document is not yet completed. Please try again after document is completed.';
	}
};
var $author$project$Data$Api$PDF$Update$errorToString = function (error) {
	switch (error.$) {
		case 'ANNOTATION_NOT_FOUND':
			return 'No annotation found for the document.';
		case 'FAIL_TO_UPDATE_ANNOTATION':
			return 'Unable to update the annotations.';
		case 'FAIL_TO_UPDATE_DOCUMENT':
			return 'Unable to update document.';
		case 'NOT_CURRENT_SIGNING_ORDER':
			return 'Unable to update the annotations,there are signers that are before your signing order have yet to sign.';
		case 'NOT_IN_SIGNING_ORDER':
			return 'You do not have the permission to update the document annotations.';
		case 'INCORRECT_PASSWORD':
			return 'Password provided is incorrect.';
		case 'APPEND_ERROR':
			return 'Unable to append annotation(s) to the file.';
		case 'ENCRYPTION_ERROR':
			return 'Unable to encrypt and store uploaded file.';
		case 'INVALID_CERTIFICATE':
			return 'Invalid digital certificate.';
		case 'UNEDITABLE_PDF':
			return 'PDF is not editable.';
		case 'LOADING_ERROR':
			return 'Invalid PDF. Please upload a valid PDF file instead.';
		case 'SIGNATURE_HASH_ERROR':
			return 'Invalid digital signature hash received.';
		case 'FILE_NOT_FOUND':
			return 'An error has occur. Please try again later.';
		case 'TEMP_FILE_NOT_FOUND':
			return 'An error has occur. Please try again later.';
		default:
			return 'An error has occur. Please try again later.';
	}
};
var $author$project$Data$Api$PDF$ValidatePasscode$errorToString = function (error) {
	switch (error.$) {
		case 'UNAUTHORISED_USER':
			return 'You are not the owner or recipient of this document.';
		case 'INVALID_PASSCODE':
			return 'Wrong passcode entered. Please try again.';
		default:
			return 'Document does not exist or does not have passcode.';
	}
};
var $author$project$Model$ViewDocument$firstStamp = F2(
	function (user, stampModel) {
		return A2(
			$elm$core$Maybe$andThen,
			function (stampStatus) {
				if (stampStatus.$ === 'Loaded') {
					var stamps = stampStatus.a;
					return $elm$core$List$head(
						$elm$core$Dict$values(stamps));
				} else {
					return $elm$core$Maybe$Nothing;
				}
			},
			A2(
				$elm$core$Dict$get,
				$author$project$Data$Domain$toString(
					$author$project$Data$Domain$selected(user.domains)),
				stampModel.stamps));
	});
var $elm$core$Set$Set_elm_builtin = function (a) {
	return {$: 'Set_elm_builtin', a: a};
};
var $elm$core$Set$empty = $elm$core$Set$Set_elm_builtin($elm$core$Dict$empty);
var $elm$core$Set$insert = F2(
	function (key, _v0) {
		var dict = _v0.a;
		return $elm$core$Set$Set_elm_builtin(
			A3($elm$core$Dict$insert, key, _Utils_Tuple0, dict));
	});
var $author$project$Data$PDF$Annotation$getNotLoadedStampIDs = function (annotations) {
	getNotLoadedStampIDs:
	while (true) {
		if (!annotations.b) {
			return $elm$core$Set$empty;
		} else {
			var annotation = annotations.a;
			var rest = annotations.b;
			if (annotation.$ === 'IsStamp') {
				var status = annotation.a.a.status;
				if (status.$ === 'Stamped') {
					var stamp = status.a;
					if (_Utils_eq(
						$author$project$Data$PDF$Stamp$data(stamp),
						$author$project$Data$PDF$Stamp$NotLoaded)) {
						return A2(
							$elm$core$Set$insert,
							$author$project$Data$PDF$Stamp$id(stamp),
							$author$project$Data$PDF$Annotation$getNotLoadedStampIDs(rest));
					} else {
						var $temp$annotations = rest;
						annotations = $temp$annotations;
						continue getNotLoadedStampIDs;
					}
				} else {
					var $temp$annotations = rest;
					annotations = $temp$annotations;
					continue getNotLoadedStampIDs;
				}
			} else {
				var $temp$annotations = rest;
				annotations = $temp$annotations;
				continue getNotLoadedStampIDs;
			}
		}
	}
};
var $author$project$Data$PDF$getNotLoadedStampIDs = function (_v0) {
	var pdf = _v0.a;
	return $author$project$Data$PDF$Annotation$getNotLoadedStampIDs(
		$elm$core$List$concat(
			A2(
				$elm$core$List$map,
				function (_v1) {
					var signerInfo = _v1.a;
					return signerInfo.annotations;
				},
				$elm$core$Dict$values(pdf.signers))));
};
var $author$project$Data$PDF$ownerVerifiedSignature = F2(
	function (user, _v0) {
		var pdf = _v0.a;
		return A3(
			$elm$core$Dict$foldl,
			F3(
				function (k, _v1, a) {
					var info = _v1.a;
					return _Utils_eq(user.email, k) ? A3(
						$elm$core$List$foldl,
						F2(
							function (annot, acc) {
								if (acc.$ === 'Nothing') {
									return $author$project$Data$PDF$Annotation$getSignedSignature(annot);
								} else {
									var signature = acc.a;
									return $elm$core$Maybe$Just(signature);
								}
							}),
						$elm$core$Maybe$Nothing,
						A2(
							$elm$core$List$cons,
							$author$project$Data$PDF$Annotation$toSignatureAnnot(info.signature),
							info.annotations)) : $elm$core$Maybe$Nothing;
				}),
			$elm$core$Maybe$Nothing,
			pdf.signers);
	});
var $author$project$Model$ViewDocument$getSelectedSignature = F3(
	function (user, signatureModel, pdf) {
		var _v0 = A2($author$project$Data$PDF$ownerVerifiedSignature, user, pdf);
		if (_v0.$ === 'Nothing') {
			return $author$project$Type$Signature$firstSignature(signatureModel.signatures);
		} else {
			var dataSig = _v0.a;
			return $elm$core$Maybe$Just(dataSig);
		}
	});
var $author$project$Data$PDF$Annotation$getFilledDataStamp = function (annot) {
	switch (annot.$) {
		case 'IsSignature':
			return $elm$core$Maybe$Nothing;
		case 'Name':
			return $elm$core$Maybe$Nothing;
		case 'Date':
			return $elm$core$Maybe$Nothing;
		case 'EditableText':
			return $elm$core$Maybe$Nothing;
		case 'NonEditableText':
			return $elm$core$Maybe$Nothing;
		case 'IsStamp':
			var stamp = annot.a.a;
			var _v1 = stamp.status;
			if (_v1.$ === 'Stamped') {
				var isFilledStamp = _v1.a;
				return $elm$core$Maybe$Just(isFilledStamp);
			} else {
				return $elm$core$Maybe$Nothing;
			}
		case 'IsEmail':
			return $elm$core$Maybe$Nothing;
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Data$PDF$ownerVerifiedStamp = F2(
	function (user, _v0) {
		var pdf = _v0.a;
		return A3(
			$elm$core$Dict$foldl,
			F3(
				function (k, _v1, a) {
					var info = _v1.a;
					return _Utils_eq(user.email, k) ? A3(
						$elm$core$List$foldl,
						F2(
							function (annot, acc) {
								if (acc.$ === 'Nothing') {
									return $author$project$Data$PDF$Annotation$getFilledDataStamp(annot);
								} else {
									var stamp = acc.a;
									return $elm$core$Maybe$Just(stamp);
								}
							}),
						$elm$core$Maybe$Nothing,
						info.annotations) : $elm$core$Maybe$Nothing;
				}),
			$elm$core$Maybe$Nothing,
			pdf.signers);
	});
var $author$project$Model$ViewDocument$getSelectedStamp = F3(
	function (user, stampModel, pdf) {
		var _v0 = A2($author$project$Data$PDF$ownerVerifiedStamp, user, pdf);
		if (_v0.$ === 'Nothing') {
			return A2($author$project$Model$ViewDocument$firstStamp, user, stampModel);
		} else {
			var stamp = _v0.a;
			return $elm$core$Maybe$Just(stamp);
		}
	});
var $author$project$Data$PDF$Annotation$hasUnverifiedAnnotation = function (annots) {
	return $elm$core$List$head(
		A2(
			$elm$core$List$filter,
			function (a) {
				return !$author$project$Data$PDF$Annotation$isVerifiedAnnot(a);
			},
			annots));
};
var $author$project$Data$PDF$Port$toUnverifiedAnnotPage = _Platform_outgoingPort('toUnverifiedAnnotPage', $elm$core$Basics$identity);
var $author$project$Data$PDF$Port$scrollToUnverifiedAnnot = F2(
	function (user, annotation) {
		return $author$project$Data$PDF$Port$toUnverifiedAnnotPage(
			A2(
				$author$project$Data$PDF$Port$encodeDocumentAnnotation,
				A2($author$project$Data$PDF$User$annotBgColor, annotation, user),
				annotation));
	});
var $author$project$Data$PDF$hasVerifyAllAnnotations = F2(
	function (currentUserEmail, _v0) {
		var pdf = _v0.a;
		var unverifiedAnnot = function (pdfSigners) {
			return A3(
				$elm$core$Dict$foldl,
				F3(
					function (_v3, _v4, accumulator) {
						var v = _v4.a;
						return _Utils_eq(
							$author$project$Data$PDF$User$emailFromUser(v.user),
							currentUserEmail) ? A2(
							$elm$core$Maybe$andThen,
							function (annot) {
								return $elm$core$Maybe$Just(
									_Utils_Tuple2(v.user, annot));
							},
							$author$project$Data$PDF$Annotation$hasUnverifiedAnnotation(
								_Utils_ap(
									v.annotations,
									_List_fromArray(
										[
											$author$project$Data$PDF$Annotation$toSignatureAnnot(v.signature)
										])))) : accumulator;
					}),
				$elm$core$Maybe$Nothing,
				pdfSigners);
		};
		var _v1 = unverifiedAnnot(pdf.signers);
		if (_v1.$ === 'Nothing') {
			return $elm$core$Result$Ok(
				$author$project$Data$PDF$PDF(pdf));
		} else {
			var _v2 = _v1.a;
			var user = _v2.a;
			var annot = _v2.b;
			return $elm$core$Result$Err(
				_Utils_Tuple2(
					annot,
					A2($author$project$Data$PDF$Port$scrollToUnverifiedAnnot, user, annot)));
		}
	});
var $author$project$Data$PDF$loadWithPassword = F6(
	function (endPoint, jwt, currentTime, currentUser, password, _v0) {
		var pdf = _v0.a;
		var updatedPDF = $author$project$Data$PDF$PDF(
			_Utils_update(
				pdf,
				{
					password: $elm$core$Maybe$Just(password)
				}));
		return _Utils_Tuple2(
			updatedPDF,
			$author$project$Data$PDF$Port$load(
				A5($author$project$Data$PDF$toPortLoadPDF, endPoint, jwt, currentTime, currentUser, updatedPDF)));
	});
var $author$project$Data$PDF$toUpdateAnnotData = F2(
	function (currentUserEmail, pdfSigners) {
		return A3(
			$elm$core$Dict$foldl,
			F3(
				function (_v0, _v1, accumulator) {
					var v = _v1.a;
					return A2(
						$elm$core$List$append,
						accumulator,
						A2(
							$elm$core$List$map,
							function (annot) {
								return {annotation: annot, user: v.user};
							},
							A3(
								$author$project$Data$PDF$Annotation$filterUnverifiedAnnots,
								currentUserEmail,
								$author$project$Data$PDF$User$emailFromUser(v.user),
								_Utils_ap(
									v.annotations,
									_List_fromArray(
										[
											$author$project$Data$PDF$Annotation$toSignatureAnnot(v.signature)
										])))));
				}),
			_List_Nil,
			pdfSigners);
	});
var $author$project$Data$PDF$Annotation$updateCurrentUserStampedStamp = F2(
	function (dataStamp, _v0) {
		var stamp = _v0.a;
		var _v1 = stamp.status;
		if (_v1.$ === 'Stamped') {
			var stampStatus = $author$project$Data$PDF$Annotation$Stamped(dataStamp);
			return $author$project$Data$PDF$Annotation$Stamp(
				_Utils_update(
					stamp,
					{
						id: A3(
							$author$project$Data$PDF$Annotation$generateId,
							$author$project$Data$PDF$Annotation$stampContent(
								$author$project$Data$PDF$Annotation$Stamp(stamp)),
							$author$project$Data$PDF$Annotation$toStampStatusString(stampStatus),
							stamp.style),
						status: stampStatus
					}));
		} else {
			return $author$project$Data$PDF$Annotation$Stamp(stamp);
		}
	});
var $author$project$Data$PDF$Annotation$updateCurrentUserStampedStamps = F2(
	function (dataStamp, annotations) {
		return A2(
			$elm$core$List$map,
			function (annot) {
				if (annot.$ === 'IsStamp') {
					var stamp = annot.a;
					return $author$project$Data$PDF$Annotation$IsStamp(
						A2($author$project$Data$PDF$Annotation$updateCurrentUserStampedStamp, dataStamp, stamp));
				} else {
					return annot;
				}
			},
			annotations);
	});
var $author$project$Data$PDF$updateCurrentUserStampedStamp = F4(
	function (currentUserEmail, dataStamp, _v0, base64Data) {
		var pdf = _v0.a;
		var updatedSigners = A2(
			$elm$core$Dict$map,
			F2(
				function (_v1, _v2) {
					var v = _v2.a;
					if (_Utils_eq(
						$author$project$Data$PDF$User$emailFromUser(v.user),
						currentUserEmail)) {
						var updatedAnnots = A2($author$project$Data$PDF$Annotation$updateCurrentUserStampedStamps, dataStamp, v.annotations);
						return $author$project$Data$PDF$Signer(
							_Utils_update(
								v,
								{
									annotations: updatedAnnots,
									stamp: $elm$core$Maybe$Just(dataStamp)
								}));
					} else {
						return $author$project$Data$PDF$Signer(v);
					}
				}),
			pdf.signers);
		return _Utils_Tuple2(
			$author$project$Data$PDF$PDF(
				_Utils_update(
					pdf,
					{signers: updatedSigners})),
			A4(
				$author$project$Data$PDF$Port$updateView,
				A2($author$project$Data$PDF$toUpdateAnnotData, currentUserEmail, updatedSigners),
				$author$project$Data$PDF$toStringStatus(
					$author$project$Data$PDF$status(
						$author$project$Data$PDF$PDF(pdf))),
				base64Data,
				_List_Nil));
	});
var $author$project$Model$ViewDocument$setSelectedStampAndUpdatePDF = F4(
	function (stamp, model, user, appModel) {
		var _v0 = A4(
			$author$project$Data$PDF$updateCurrentUserStampedStamp,
			user.email,
			stamp,
			model.pdf,
			A2($elm$core$Maybe$withDefault, '', model.pdfBase64));
		var updatedPdf = _v0.a;
		var cmdMsg = _v0.b;
		var _v1 = appModel.sessionModel;
		switch (_v1.$) {
			case 'Auth':
				var authModel = _v1.a;
				return _Utils_Tuple2(
					_Utils_update(
						appModel,
						{
							sessionModel: $author$project$Types$Auth(
								_Utils_update(
									authModel,
									{
										viewDocModel: $author$project$Type$ViewDocument$Loaded(
											_Utils_update(
												model,
												{
													pdf: updatedPdf,
													selectedStamp: $elm$core$Maybe$Just(stamp)
												}))
									}))
						}),
					cmdMsg);
			case 'Anonymous':
				var anonymousModel = _v1.a;
				return _Utils_Tuple2(
					_Utils_update(
						appModel,
						{
							sessionModel: $author$project$Types$Anonymous(
								_Utils_update(
									anonymousModel,
									{
										viewDocModel: $author$project$Type$ViewDocument$Loaded(
											_Utils_update(
												model,
												{
													pdf: updatedPdf,
													selectedStamp: $elm$core$Maybe$Just(stamp)
												}))
									}))
						}),
					cmdMsg);
			case 'NoAuth':
				return _Utils_Tuple2(appModel, $elm$core$Platform$Cmd$none);
			default:
				return _Utils_Tuple2(appModel, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Data$PDF$Annotation$updateSignedSignatureById = F2(
	function (dataSignature, _v0) {
		var signature = _v0.a;
		var _v1 = signature.status;
		if (_v1.$ === 'Signed') {
			var info_ = _v1.a;
			return _Utils_eq(
				$author$project$Data$PDF$Signature$id(info_),
				$author$project$Data$PDF$Signature$id(dataSignature)) ? A2(
				$author$project$Data$PDF$Annotation$updatedSignedSignature,
				dataSignature,
				$author$project$Data$PDF$Annotation$Signature(signature)) : $author$project$Data$PDF$Annotation$Signature(signature);
		} else {
			return $author$project$Data$PDF$Annotation$Signature(signature);
		}
	});
var $author$project$Data$PDF$Annotation$updateSignedSignatures = F2(
	function (dataSignature, annotations) {
		return A2(
			$elm$core$List$map,
			function (annot) {
				if (annot.$ === 'IsSignature') {
					var signature = annot.a;
					return $author$project$Data$PDF$Annotation$IsSignature(
						A2($author$project$Data$PDF$Annotation$updateSignedSignatureById, dataSignature, signature));
				} else {
					return annot;
				}
			},
			annotations);
	});
var $author$project$Data$PDF$showSignedSignatures = F4(
	function (currentUserEmail, dataSignature, _v0, base64Data) {
		var pdf = _v0.a;
		var updatedSigners = A2(
			$elm$core$Dict$map,
			F2(
				function (_v1, _v2) {
					var v = _v2.a;
					var updatedAnnots = A2($author$project$Data$PDF$Annotation$updateSignedSignatures, dataSignature, v.annotations);
					return $author$project$Data$PDF$Signer(
						_Utils_update(
							v,
							{
								annotations: updatedAnnots,
								signature: A2($author$project$Data$PDF$Annotation$updateSignedSignatureById, dataSignature, v.signature)
							}));
				}),
			pdf.signers);
		var docStatus = $author$project$Data$PDF$toStringStatus(
			$author$project$Data$PDF$status(
				$author$project$Data$PDF$PDF(pdf)));
		return _Utils_Tuple2(
			$author$project$Data$PDF$PDF(
				_Utils_update(
					pdf,
					{signers: updatedSigners})),
			A4(
				$author$project$Data$PDF$Port$updateView,
				A2($author$project$Data$PDF$toUpdateAnnotData, currentUserEmail, updatedSigners),
				docStatus,
				base64Data,
				_List_Nil));
	});
var $author$project$Data$Api$PDF$View$signedSignatureIds = function (annotations) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (annot, accumlator) {
				if (annot.isVerified) {
					var _v0 = annot.type_;
					if (_v0.$ === 'Signature') {
						var annotContent = _v0.a;
						return A2(
							$elm$core$List$any,
							function (content) {
								return _Utils_eq(content, annotContent);
							},
							accumlator) ? accumlator : A2($elm$core$List$cons, annotContent, accumlator);
					} else {
						return accumlator;
					}
				} else {
					return accumlator;
				}
			}),
		_List_Nil,
		annotations);
};
var $author$project$Data$PDF$Annotation$updateCheckboxStatus = F2(
	function (status, _v0) {
		var checkbox = _v0.a;
		return $author$project$Data$PDF$Annotation$Checkbox(
			_Utils_update(
				checkbox,
				{status: status}));
	});
var $author$project$Data$PDF$Annotation$updateCheckboxContent = F2(
	function (_v0, status) {
		var checkbox = _v0.a;
		return A2(
			$author$project$Data$PDF$Annotation$updateCheckboxStatus,
			status,
			$author$project$Data$PDF$Annotation$Checkbox(checkbox));
	});
var $author$project$Data$PDF$updateCheckboxAnnotation = F4(
	function (email, annotId, newStatus, _v0) {
		var pdf = _v0.a;
		var updatedSigners = A3(
			$elm$core$Dict$update,
			email,
			$elm$core$Maybe$map(
				function (_v1) {
					var signer = _v1.a;
					var updatedAnnots = A2(
						$elm$core$List$map,
						function (annot) {
							if (annot.$ === 'IsCheckbox') {
								var checkbox = annot.a;
								return _Utils_eq(
									$author$project$Data$PDF$Annotation$checkboxId(checkbox),
									annotId) ? $author$project$Data$PDF$Annotation$IsCheckbox(
									A2(
										$author$project$Data$PDF$Annotation$updateCheckboxContent,
										checkbox,
										$author$project$Data$PDF$Annotation$stringToCheckboxStatus(newStatus))) : annot;
							} else {
								return annot;
							}
						},
						signer.annotations);
					return $author$project$Data$PDF$Signer(
						_Utils_update(
							signer,
							{annotations: updatedAnnots}));
				}),
			pdf.signers);
		return $author$project$Data$PDF$PDF(
			_Utils_update(
				pdf,
				{signers: updatedSigners}));
	});
var $author$project$Data$PDF$Annotation$updateCurrentUserSignedSignature = F2(
	function (dataSignature, _v0) {
		var signature = _v0.a;
		var _v1 = signature.status;
		if (_v1.$ === 'Signed') {
			var generatedId = A3(
				$author$project$Data$PDF$Annotation$generateId,
				$author$project$Data$PDF$Signature$data(dataSignature),
				$author$project$Data$PDF$Annotation$toSignatureStatusString(signature.status),
				signature.style);
			return $author$project$Data$PDF$Annotation$Signature(
				_Utils_update(
					signature,
					{
						id: generatedId,
						status: $author$project$Data$PDF$Annotation$Signed(dataSignature)
					}));
		} else {
			return $author$project$Data$PDF$Annotation$Signature(signature);
		}
	});
var $author$project$Data$PDF$Annotation$updateCurrentUserSignedSignatures = F2(
	function (dataSignature, annotations) {
		return A2(
			$elm$core$List$map,
			function (annot) {
				if (annot.$ === 'IsSignature') {
					var signature = annot.a;
					return $author$project$Data$PDF$Annotation$IsSignature(
						A2($author$project$Data$PDF$Annotation$updateCurrentUserSignedSignature, dataSignature, signature));
				} else {
					return annot;
				}
			},
			annotations);
	});
var $author$project$Data$PDF$updateCurrentUserSignedSignatures = F4(
	function (currentUserEmail, dataSignature, _v0, base64Data) {
		var pdf = _v0.a;
		var updatedSigners = A2(
			$elm$core$Dict$map,
			F2(
				function (_v1, _v2) {
					var v = _v2.a;
					if (_Utils_eq(
						$author$project$Data$PDF$User$emailFromUser(v.user),
						currentUserEmail)) {
						var updatedAnnots = A2($author$project$Data$PDF$Annotation$updateCurrentUserSignedSignatures, dataSignature, v.annotations);
						return $author$project$Data$PDF$Signer(
							_Utils_update(
								v,
								{
									annotations: updatedAnnots,
									signature: A2($author$project$Data$PDF$Annotation$updateCurrentUserSignedSignature, dataSignature, v.signature)
								}));
					} else {
						return $author$project$Data$PDF$Signer(v);
					}
				}),
			pdf.signers);
		return _Utils_Tuple2(
			$author$project$Data$PDF$PDF(
				_Utils_update(
					pdf,
					{signers: updatedSigners})),
			A4(
				$author$project$Data$PDF$Port$updateView,
				A2($author$project$Data$PDF$toUpdateAnnotData, currentUserEmail, updatedSigners),
				$author$project$Data$PDF$toStringStatus(
					$author$project$Data$PDF$status(
						$author$project$Data$PDF$PDF(pdf))),
				base64Data,
				_List_Nil));
	});
var $author$project$Data$PDF$Port$updatePlaceholderAnnotations = _Platform_outgoingPort('updatePlaceholderAnnotations', $elm$core$Basics$identity);
var $author$project$Data$PDF$Port$updatePlaceholderAnnot = F2(
	function (annotId, status) {
		return $author$project$Data$PDF$Port$updatePlaceholderAnnotations(
			$elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'annotId',
						$elm$json$Json$Encode$string(annotId)),
						_Utils_Tuple2(
						'status',
						$elm$json$Json$Encode$string(status))
					])));
	});
var $author$project$Data$PDF$Port$NewWidthData = F2(
	function (id, width) {
		return {id: id, width: width};
	});
var $author$project$Data$PDF$Port$decodeWidthData = A3(
	$elm$json$Json$Decode$map2,
	$author$project$Data$PDF$Port$NewWidthData,
	A2($elm$json$Json$Decode$field, 'id', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'width', $elm$json$Json$Decode$float));
var $author$project$Data$PDF$Port$decodeNewWidthData = function (value) {
	var _v0 = A2($elm$json$Json$Decode$decodeValue, $author$project$Data$PDF$Port$decodeWidthData, value);
	if (_v0.$ === 'Ok') {
		var results = _v0.a;
		return $elm$core$Result$Ok(results);
	} else {
		return $elm$core$Result$Err('Error getting new width');
	}
};
var $author$project$Data$PDF$Annotation$signatureId = function (_v0) {
	var signature = _v0.a;
	return signature.id;
};
var $author$project$Data$PDF$Annotation$updateSignatureWidth = F2(
	function (newWdith, _v0) {
		var signature = _v0.a;
		var _v1 = signature;
		var style = _v1.style;
		return $author$project$Data$PDF$Annotation$Signature(
			_Utils_update(
				signature,
				{
					style: _Utils_update(
						style,
						{width: newWdith})
				}));
	});
var $author$project$Data$PDF$updateSignatureWidth = F3(
	function (value, email, _v0) {
		var pdf = _v0.a;
		var _v1 = $author$project$Data$PDF$Port$decodeNewWidthData(value);
		if (_v1.$ === 'Ok') {
			var result = _v1.a;
			var updatedSigners = A3(
				$elm$core$Dict$update,
				email,
				$elm$core$Maybe$map(
					function (_v2) {
						var signer = _v2.a;
						var updatedSignature = _Utils_eq(
							$author$project$Data$PDF$Annotation$signatureId(signer.signature),
							result.id) ? A2($author$project$Data$PDF$Annotation$updateSignatureWidth, result.width, signer.signature) : signer.signature;
						var updatedAnnots = A2(
							$elm$core$List$map,
							function (annot) {
								if (annot.$ === 'IsSignature') {
									var signature = annot.a;
									return _Utils_eq(
										$author$project$Data$PDF$Annotation$signatureId(signature),
										result.id) ? $author$project$Data$PDF$Annotation$IsSignature(
										A2($author$project$Data$PDF$Annotation$updateSignatureWidth, result.width, signature)) : annot;
								} else {
									return annot;
								}
							},
							signer.annotations);
						return $author$project$Data$PDF$Signer(
							_Utils_update(
								signer,
								{annotations: updatedAnnots, signature: updatedSignature}));
					}),
				pdf.signers);
			return $author$project$Data$PDF$PDF(
				_Utils_update(
					pdf,
					{signers: updatedSigners}));
		} else {
			return $author$project$Data$PDF$PDF(pdf);
		}
	});
var $author$project$Data$PDF$Annotation$updateStampsIfFound = F2(
	function (dataStamp, annotations) {
		return A2(
			$elm$core$List$map,
			function (annotation) {
				if (annotation.$ === 'IsStamp') {
					var stamp = annotation.a.a;
					var _v1 = stamp.status;
					if (_v1.$ === 'Unstamped') {
						return annotation;
					} else {
						var dataStamp_ = _v1.a;
						if (_Utils_eq(
							$author$project$Data$PDF$Stamp$id(dataStamp_),
							$author$project$Data$PDF$Stamp$id(dataStamp))) {
							var _v2 = $author$project$Data$PDF$Stamp$data(dataStamp);
							if (_v2.$ === 'NotLoaded') {
								return annotation;
							} else {
								var data = _v2.a;
								return $author$project$Data$PDF$Annotation$IsStamp(
									$author$project$Data$PDF$Annotation$Stamp(
										_Utils_update(
											stamp,
											{
												id: A3(
													$author$project$Data$PDF$Annotation$generateId,
													data,
													$author$project$Data$PDF$Annotation$toStampStatusString(stamp.status),
													stamp.style),
												status: $author$project$Data$PDF$Annotation$Stamped(dataStamp)
											})));
							}
						} else {
							return annotation;
						}
					}
				} else {
					return annotation;
				}
			},
			annotations);
	});
var $author$project$Data$PDF$updateStamp = F4(
	function (currentUserEmail, stamp, _v0, base64Data) {
		var pdf = _v0.a;
		var updatedSigners = A2(
			$elm$core$Dict$map,
			F2(
				function (_v1, _v2) {
					var v = _v2.a;
					return $author$project$Data$PDF$Signer(
						_Utils_update(
							v,
							{
								annotations: A2($author$project$Data$PDF$Annotation$updateStampsIfFound, stamp, v.annotations)
							}));
				}),
			pdf.signers);
		return _Utils_Tuple2(
			$author$project$Data$PDF$PDF(
				_Utils_update(
					pdf,
					{signers: updatedSigners})),
			A4(
				$author$project$Data$PDF$Port$updateView,
				A2($author$project$Data$PDF$toUpdateAnnotData, currentUserEmail, updatedSigners),
				$author$project$Data$PDF$toStringStatus(
					$author$project$Data$PDF$status(
						$author$project$Data$PDF$PDF(pdf))),
				base64Data,
				_List_Nil));
	});
var $author$project$Data$PDF$Annotation$updateTxtWithoutIDUpdate = F4(
	function (text, status, style, _v0) {
		var txt = _v0.a;
		return $author$project$Data$PDF$Annotation$Txt(
			_Utils_update(
				txt,
				{id: txt.id, status: status, style: style, text: text}));
	});
var $author$project$Data$PDF$Annotation$updateEditableText = F2(
	function (annot, content) {
		if (annot.$ === 'EditableText') {
			var txt = annot.a.a;
			var _v1 = txt;
			var style = _v1.style;
			return $author$project$Data$PDF$Annotation$EditableText(
				A4(
					$author$project$Data$PDF$Annotation$updateTxtWithoutIDUpdate,
					content,
					$author$project$Data$PDF$Annotation$Verified,
					style,
					$author$project$Data$PDF$Annotation$Txt(txt)));
		} else {
			return annot;
		}
	});
var $author$project$Data$PDF$updateTextAnnotContent = F5(
	function (annotID, content, currentUserEmail, _v0, base64data) {
		var pdf = _v0.a;
		var updatedSigners = A2(
			$elm$core$Dict$map,
			F2(
				function (_v1, _v2) {
					var v = _v2.a;
					var updatedAnnots = A2(
						$elm$core$List$map,
						function (annot) {
							return _Utils_eq(
								$author$project$Data$PDF$Annotation$id(annot),
								annotID) ? A2($author$project$Data$PDF$Annotation$updateEditableText, annot, content) : annot;
						},
						v.annotations);
					return $author$project$Data$PDF$Signer(
						_Utils_update(
							v,
							{annotations: updatedAnnots}));
				}),
			pdf.signers);
		return _Utils_Tuple2(
			$author$project$Data$PDF$PDF(
				_Utils_update(
					pdf,
					{signers: updatedSigners})),
			A4(
				$author$project$Data$PDF$Port$updateView,
				A2($author$project$Data$PDF$toUpdateAnnotData, currentUserEmail, updatedSigners),
				$author$project$Data$PDF$toStringStatus(
					$author$project$Data$PDF$status(
						$author$project$Data$PDF$PDF(pdf))),
				base64data,
				_List_Nil));
	});
var $author$project$Data$PDF$Port$contentString = function (_v0) {
	var data = _v0.a;
	return data.content;
};
var $author$project$Data$PDF$Port$decodedAnnotId = function (_v0) {
	var data = _v0.a;
	return data.id;
};
var $author$project$Data$PDF$Annotation$toSignedSignature = F2(
	function (dataSignature, _v0) {
		var signature = _v0.a;
		var _v1 = signature.status;
		if (_v1.$ === 'Unsigned') {
			var updatedStatus = $author$project$Data$PDF$Annotation$Signed(dataSignature);
			var id_ = A3(
				$author$project$Data$PDF$Annotation$generateId,
				$author$project$Data$PDF$Signature$data(dataSignature),
				$author$project$Data$PDF$Annotation$toSignatureStatusString(updatedStatus),
				signature.style);
			return $author$project$Data$PDF$Annotation$Signature(
				_Utils_update(
					signature,
					{id: id_, status: updatedStatus}));
		} else {
			return $author$project$Data$PDF$Annotation$Signature(signature);
		}
	});
var $author$project$Data$PDF$Annotation$toStamped = F2(
	function (dataStamp, _v0) {
		var stamp = _v0.a;
		var _v1 = stamp.status;
		if (_v1.$ === 'Unstamped') {
			var id_ = A3(
				$author$project$Data$PDF$Annotation$generateId,
				$author$project$Data$PDF$Stamp$id(dataStamp),
				$author$project$Data$PDF$Annotation$toStampStatusString(
					$author$project$Data$PDF$Annotation$Stamped(dataStamp)),
				stamp.style);
			return $author$project$Data$PDF$Annotation$Stamp(
				_Utils_update(
					stamp,
					{
						id: id_,
						status: $author$project$Data$PDF$Annotation$Stamped(dataStamp)
					}));
		} else {
			return $author$project$Data$PDF$Annotation$Stamp(stamp);
		}
	});
var $author$project$Data$PDF$Annotation$toUpdatedVerifiedCheckbox = F2(
	function (_v0, status) {
		var checkbox = _v0.a;
		var updatedStatus = function () {
			switch (status) {
				case 'Checked':
					return $author$project$Data$PDF$Annotation$Checked;
				case 'Unchecked':
					return $author$project$Data$PDF$Annotation$Unchecked;
				default:
					return $author$project$Data$PDF$Annotation$Unchecked;
			}
		}();
		var _v1 = checkbox;
		var style = _v1.style;
		return A3(
			$author$project$Data$PDF$Annotation$updateCheckBox,
			updatedStatus,
			style,
			$author$project$Data$PDF$Annotation$Checkbox(checkbox));
	});
var $author$project$Data$PDF$Annotation$toUpdatedVerifiedTxt = F2(
	function (_v0, newText) {
		var txt = _v0.a;
		var _v1 = txt;
		var style = _v1.style;
		return A4(
			$author$project$Data$PDF$Annotation$updateTxt,
			newText,
			$author$project$Data$PDF$Annotation$Verified,
			style,
			$author$project$Data$PDF$Annotation$Txt(txt));
	});
var $author$project$Data$PDF$Annotation$toVerifiedDateTxt = F2(
	function (timeNow, _v0) {
		var dateTxt_ = _v0.a;
		var _v1 = dateTxt_;
		var status = _v1.status;
		var style = _v1.style;
		if (status.$ === 'Verified') {
			return $author$project$Data$PDF$Annotation$DateTxt(dateTxt_);
		} else {
			return A4(
				$author$project$Data$PDF$Annotation$updateDateTxt,
				timeNow,
				$author$project$Data$PDF$Annotation$Verified,
				style,
				$author$project$Data$PDF$Annotation$DateTxt(dateTxt_));
		}
	});
var $author$project$Data$PDF$Port$updateUnverifiedAnnot = F7(
	function (timeNow, hasStamp, dataSignature, _v0, annot, userEmail, userName) {
		var data = _v0.a;
		switch (annot.$) {
			case 'Name':
				var txt = annot.a;
				return $author$project$Data$PDF$Annotation$Name(
					A2($author$project$Data$PDF$Annotation$toUpdatedVerifiedTxt, txt, userName));
			case 'Date':
				var dateTxt = annot.a;
				return $author$project$Data$PDF$Annotation$Date(
					A2($author$project$Data$PDF$Annotation$toVerifiedDateTxt, timeNow, dateTxt));
			case 'EditableText':
				var txt = annot.a;
				return $author$project$Data$PDF$Annotation$EditableText(
					A2($author$project$Data$PDF$Annotation$toUpdatedVerifiedTxt, txt, data.content));
			case 'NonEditableText':
				var txt = annot.a;
				return $author$project$Data$PDF$Annotation$NonEditableText(
					A2($author$project$Data$PDF$Annotation$toUpdatedVerifiedTxt, txt, data.content));
			case 'IsSignature':
				var signature = annot.a;
				return $author$project$Data$PDF$Annotation$IsSignature(
					A2($author$project$Data$PDF$Annotation$toSignedSignature, dataSignature, signature));
			case 'IsStamp':
				var stamp = annot.a;
				if (hasStamp.$ === 'Nothing') {
					return annot;
				} else {
					var selectedStamp = hasStamp.a;
					return $author$project$Data$PDF$Annotation$IsStamp(
						A2($author$project$Data$PDF$Annotation$toStamped, selectedStamp, stamp));
				}
			case 'IsEmail':
				var txt = annot.a;
				return $author$project$Data$PDF$Annotation$IsEmail(
					A2($author$project$Data$PDF$Annotation$toUpdatedVerifiedTxt, txt, userEmail));
			default:
				var checkbox = annot.a;
				return $author$project$Data$PDF$Annotation$IsCheckbox(
					A2($author$project$Data$PDF$Annotation$toUpdatedVerifiedCheckbox, checkbox, data.content));
		}
	});
var $author$project$Data$PDF$Port$updateUnverifiedAnnots = F7(
	function (timeNow, stamp, dataSignature, annotDataList, annotations, userEmail, userName) {
		return A2(
			$elm$core$List$map,
			function (annot) {
				var maybeAnnotData = A2($author$project$Data$PDF$Port$filterDecodedAnnots, annot, annotDataList);
				if (maybeAnnotData.$ === 'Nothing') {
					return annot;
				} else {
					var annotData = maybeAnnotData.a;
					return A7($author$project$Data$PDF$Port$updateUnverifiedAnnot, timeNow, stamp, dataSignature, annotData, annot, userEmail, userName);
				}
			},
			annotations);
	});
var $author$project$Data$PDF$Port$updateUnverifiedSignature = F3(
	function (annotDataList, dataSignature, signature) {
		var maybeAnnotData = $elm$core$List$head(
			A2(
				$elm$core$List$filter,
				function (_v1) {
					var annotData = _v1.a;
					return _Utils_eq(
						annotData.id,
						$author$project$Data$PDF$Annotation$signatureId(signature));
				},
				annotDataList));
		if (maybeAnnotData.$ === 'Nothing') {
			return signature;
		} else {
			var annotData = maybeAnnotData.a.a;
			return A2(
				$author$project$Data$PDF$Annotation$toSignedSignature,
				dataSignature,
				A3($author$project$Data$PDF$Annotation$updateSignature, annotData.content, annotData.style, signature));
		}
	});
var $author$project$Data$PDF$verifyAnnotations = F8(
	function (userName, currentUserEmail, timeNow, value, stamp, dataSignature, _v0, base64Data) {
		var pdf = _v0.a;
		var _v1 = $author$project$Data$PDF$Port$decodeAnnotDataResult(value);
		if (_v1.$ === 'Ok') {
			var annotDataList = _v1.a;
			var updatedSigners = A2(
				$elm$core$Dict$map,
				F2(
					function (_v4, _v5) {
						var v = _v5.a;
						var updatedSignature = A3($author$project$Data$PDF$Port$updateUnverifiedSignature, annotDataList, dataSignature, v.signature);
						var updatedAnnots = A7($author$project$Data$PDF$Port$updateUnverifiedAnnots, timeNow, stamp, dataSignature, annotDataList, v.annotations, currentUserEmail, userName);
						return $author$project$Data$PDF$Signer(
							_Utils_update(
								v,
								{annotations: updatedAnnots, signature: updatedSignature, stamp: stamp}));
					}),
				pdf.signers);
			var getAnnotIDs = function (x) {
				var _v3 = A2($elm$core$Dict$get, currentUserEmail, x);
				if (_v3.$ === 'Just') {
					var signer = _v3.a.a;
					return A2(
						$elm$core$List$map,
						function (annot) {
							return $author$project$Data$PDF$Annotation$id(annot);
						},
						signer.annotations);
				} else {
					return _List_Nil;
				}
			};
			var updatedUserAnnotIDs = getAnnotIDs(updatedSigners);
			var currentUserAnnotsIDs = getAnnotIDs(pdf.signers);
			var editableTextContent = function () {
				var _v2 = $elm$core$List$head(annotDataList);
				if (_v2.$ === 'Just') {
					var annot = _v2.a;
					var annotIDIfChanged = $elm$core$List$head(
						A2(
							$elm$core$List$filter,
							function (annotID) {
								return !A2($elm$core$List$member, annotID, currentUserAnnotsIDs);
							},
							updatedUserAnnotIDs));
					return (_Utils_eq(
						$author$project$Data$PDF$Port$kind(annot),
						$author$project$Data$PDF$Port$EditableTextKind) && (!_Utils_eq(annotIDIfChanged, $elm$core$Maybe$Nothing))) ? $elm$core$Maybe$Just(
						_Utils_Tuple2(
							A2($elm$core$Maybe$withDefault, '', annotIDIfChanged),
							$author$project$Data$PDF$Port$contentString(annot))) : ((_Utils_eq(
						$author$project$Data$PDF$Port$kind(annot),
						$author$project$Data$PDF$Port$EditableTextKind) && A2(
						$elm$core$List$member,
						$author$project$Data$PDF$Port$decodedAnnotId(annot),
						currentUserAnnotsIDs)) ? $elm$core$Maybe$Just(
						_Utils_Tuple2(
							$author$project$Data$PDF$Port$decodedAnnotId(annot),
							$author$project$Data$PDF$Port$contentString(annot))) : $elm$core$Maybe$Nothing);
				} else {
					return $elm$core$Maybe$Nothing;
				}
			}();
			return $elm$core$Result$Ok(
				_Utils_Tuple3(
					$author$project$Data$PDF$PDF(
						_Utils_update(
							pdf,
							{signers: updatedSigners})),
					A4(
						$author$project$Data$PDF$Port$updateView,
						A2($author$project$Data$PDF$toUpdateAnnotData, currentUserEmail, updatedSigners),
						$author$project$Data$PDF$toStringStatus(
							$author$project$Data$PDF$status(
								$author$project$Data$PDF$PDF(pdf))),
						base64Data,
						_List_Nil),
					editableTextContent));
		} else {
			var err = _v1.a;
			return $elm$core$Result$Err(err);
		}
	});
var $author$project$Model$ViewDocument$updateAnonymousLoadedModel = F4(
	function (msg, model, anonymousModel, appModel) {
		var updateAppModel = function (m) {
			return _Utils_update(
				appModel,
				{
					sessionModel: $author$project$Types$Anonymous(
						_Utils_update(
							anonymousModel,
							{
								viewDocModel: $author$project$Type$ViewDocument$Loaded(m)
							}))
				});
		};
		var _v0 = anonymousModel;
		var user = _v0.user;
		var signatureModel = _v0.signatureModel;
		var stampModel = _v0.stampModel;
		switch (msg.$) {
			case 'OnReceiveDocumentLoaded':
				var value = msg.a;
				var signatureIDs = $author$project$Data$Api$PDF$View$signedSignatureIds(model.payload.annotations);
				var signatureAndStampCmd = $elm$core$Platform$Cmd$batch(
					$elm$core$List$concat(
						_List_fromArray(
							[
								A2(
								$elm$core$List$map,
								function (signature) {
									return A2(
										$elm$core$Task$attempt,
										A2(
											$elm$core$Basics$composeL,
											A2(
												$elm$core$Basics$composeL,
												A2($elm$core$Basics$composeL, $author$project$Types$OnViewDoc, $author$project$Type$ViewDocument$OnAuth),
												$author$project$Type$ViewDocument$OnLoaded),
											$author$project$Type$ViewDocument$SignedSignatureResult),
										A3($author$project$Data$Api$Signature$File$authCall, user.jwt, appModel.apiEndPoint.signatureFile, signature));
								},
								signatureIDs)
							])));
				var docPasscode = model.payload.document.passcode;
				var base64PDF = function () {
					var _v2 = $author$project$Data$PDF$Port$decodeBase64String(value);
					if (_v2.$ === 'Ok') {
						var result = _v2.a;
						return result;
					} else {
						return '';
					}
				}();
				return (_Utils_eq(docPasscode, $elm$core$Maybe$Nothing) || _Utils_eq(
					$author$project$Data$PDF$status(model.pdf),
					$author$project$Data$PDF$Completed)) ? _Utils_Tuple2(
					updateAppModel(
						_Utils_update(
							model,
							{
								modal: $elm$core$Maybe$Nothing,
								pdfBase64: $elm$core$Maybe$Just(base64PDF),
								selectedSignature: $author$project$Type$Signature$firstSignature(signatureModel.signatures),
								selectedStamp: A2($author$project$Model$ViewDocument$firstStamp, user, anonymousModel.stampModel)
							})),
					signatureAndStampCmd) : _Utils_Tuple2(
					updateAppModel(
						_Utils_update(
							model,
							{
								modal: $elm$core$Maybe$Just($author$project$Type$ViewDocument$RequiredPasscode),
								pdfBase64: $elm$core$Maybe$Just(base64PDF),
								selectedSignature: $author$project$Type$Signature$firstSignature(signatureModel.signatures),
								selectedStamp: A2($author$project$Model$ViewDocument$firstStamp, user, anonymousModel.stampModel)
							})),
					signatureAndStampCmd);
			case 'OnReceiveEncryptionError':
				var value = msg.a;
				var _v3 = $author$project$Data$PDF$Encryption$decode(value);
				if (_v3.$ === 'Ok') {
					var encryptionError = _v3.a;
					if (encryptionError.$ === 'PasswordFail') {
						return _Utils_Tuple2(
							updateAppModel(
								_Utils_update(
									model,
									{
										modal: $elm$core$Maybe$Just($author$project$Type$ViewDocument$NeedPassword),
										passwordError: $elm$core$Maybe$Just('Password failed.')
									})),
							$elm$core$Platform$Cmd$none);
					} else {
						return _Utils_Tuple2(
							updateAppModel(
								_Utils_update(
									model,
									{
										modal: $elm$core$Maybe$Just($author$project$Type$ViewDocument$NeedPassword),
										passwordError: $elm$core$Maybe$Nothing
									})),
							$elm$core$Platform$Cmd$none);
					}
				} else {
					var decodeErrorMessage = _v3.a;
					return _Utils_Tuple2(
						updateAppModel(
							_Utils_update(
								model,
								{
									banner: $elm$core$Maybe$Just(
										$author$project$Type$ViewDocument$Error(
											$author$project$Type$ViewDocument$EncryptionDecodeError(decodeErrorMessage)))
								})),
						$elm$core$Platform$Cmd$none);
				}
			case 'OnPasswordInput':
				var value = msg.a;
				return $elm$core$String$isEmpty(value) ? _Utils_Tuple2(
					updateAppModel(
						_Utils_update(
							model,
							{password: $elm$core$Maybe$Nothing, passwordError: $elm$core$Maybe$Nothing})),
					$elm$core$Platform$Cmd$none) : _Utils_Tuple2(
					updateAppModel(
						_Utils_update(
							model,
							{
								password: $elm$core$Maybe$Just(value),
								passwordError: $elm$core$Maybe$Nothing
							})),
					$elm$core$Platform$Cmd$none);
			case 'OnPasswordSubmit':
				var currentUser = A2(
					$author$project$Data$PDF$User$registered,
					$elm$core$Maybe$Nothing,
					A9($author$project$Data$PDF$User$info, user.email, user.firstName, user.lastName, user.trustScore.stripe, user.trustScore.passbase, user.trustScore.mobilePhone, user.trustScore.wallet, user.trustScore.myInfo, $author$project$Data$PDF$User$Blue));
				var _v5 = A6(
					$author$project$Data$PDF$loadWithPassword,
					appModel.apiEndPoint.pdfFile,
					user.jwt,
					appModel.currentTime,
					currentUser,
					A2($elm$core$Maybe$withDefault, '', model.password),
					model.pdf);
				var pdf = _v5.a;
				var pdfCmd = _v5.b;
				return _Utils_Tuple2(
					updateAppModel(
						_Utils_update(
							model,
							{modal: $elm$core$Maybe$Nothing, pdf: pdf})),
					pdfCmd);
			case 'OnCloseModal':
				return _Utils_Tuple2(
					updateAppModel(
						_Utils_update(
							model,
							{modal: $elm$core$Maybe$Nothing})),
					$elm$core$Platform$Cmd$none);
			case 'SignedSignatureResult':
				var result = msg.a;
				if (result.$ === 'Ok') {
					var payload = result.a;
					var stampIDs = $elm$core$Set$toList(
						$author$project$Data$PDF$getNotLoadedStampIDs(model.pdf));
					var numberOfSignatureNeeded = $elm$core$List$length(
						$author$project$Data$Api$PDF$View$signedSignatureIds(model.payload.annotations));
					var numberOfSignatureLoaded = model.numberOfSignatureLoaded + 1;
					var _v7 = payload.signature;
					var id = _v7.id;
					var name = _v7.name;
					var data = _v7.data;
					var filledSignature = A3($author$project$Data$PDF$Signature$create, id, name, data);
					var _v8 = A4(
						$author$project$Data$PDF$showSignedSignatures,
						user.email,
						filledSignature,
						model.pdf,
						A2($elm$core$Maybe$withDefault, '', model.pdfBase64));
					var updatedPdf = _v8.a;
					var cmdMsg = _v8.b;
					var newCmdMsg = _Utils_eq(numberOfSignatureLoaded, numberOfSignatureNeeded) ? $elm$core$List$concat(
						_List_fromArray(
							[
								A2(
								$elm$core$List$map,
								function (stampID) {
									return A2(
										$elm$core$Task$attempt,
										A2(
											$elm$core$Basics$composeL,
											A2(
												$elm$core$Basics$composeL,
												A2($elm$core$Basics$composeL, $author$project$Types$OnViewDoc, $author$project$Type$ViewDocument$OnAuth),
												$author$project$Type$ViewDocument$OnLoaded),
											$author$project$Type$ViewDocument$LoadStampResult),
										A3($author$project$Data$Api$Stamp$File$authCall, user.jwt, appModel.apiEndPoint.stampFile, stampID));
								},
								stampIDs),
								_List_fromArray(
								[cmdMsg])
							])) : _List_fromArray(
						[cmdMsg]);
					return _Utils_Tuple2(
						updateAppModel(
							_Utils_update(
								model,
								{
									numberOfSignatureLoaded: numberOfSignatureLoaded,
									pdf: updatedPdf,
									selectedSignature: A3($author$project$Model$ViewDocument$getSelectedSignature, user, signatureModel, updatedPdf)
								})),
						$elm$core$Platform$Cmd$batch(newCmdMsg));
				} else {
					return _Utils_Tuple2(
						updateAppModel(
							_Utils_update(
								model,
								{
									banner: $elm$core$Maybe$Just(
										$author$project$Type$ViewDocument$Error($author$project$Type$ViewDocument$LoadSignature))
								})),
						$elm$core$Platform$Cmd$none);
				}
			case 'LoadStampResult':
				var result = msg.a;
				if (result.$ === 'Ok') {
					var stamp = result.a.stamp;
					var _v10 = A4(
						$author$project$Data$PDF$updateStamp,
						user.email,
						stamp,
						model.pdf,
						A2($elm$core$Maybe$withDefault, '', model.pdfBase64));
					var updatedPDF = _v10.a;
					var pdfCmd = _v10.b;
					return _Utils_Tuple2(
						updateAppModel(
							_Utils_update(
								model,
								{
									pdf: updatedPDF,
									selectedStamp: A3($author$project$Model$ViewDocument$getSelectedStamp, user, stampModel, updatedPDF)
								})),
						pdfCmd);
				} else {
					return _Utils_Tuple2(
						updateAppModel(
							_Utils_update(
								model,
								{
									banner: $elm$core$Maybe$Just(
										$author$project$Type$ViewDocument$Error($author$project$Type$ViewDocument$LoadStamp))
								})),
						$elm$core$Platform$Cmd$none);
				}
			case 'LoadedUserStamp':
				var stamp = msg.a;
				var _v11 = model.selectedStamp;
				if (_v11.$ === 'Nothing') {
					return _Utils_Tuple2(appModel, $elm$core$Platform$Cmd$none);
				} else {
					var modelStamp = _v11.a;
					return _Utils_eq(
						$author$project$Data$PDF$Stamp$id(modelStamp),
						$author$project$Data$PDF$Stamp$id(stamp)) ? A4($author$project$Model$ViewDocument$setSelectedStampAndUpdatePDF, stamp, model, anonymousModel.user, appModel) : _Utils_Tuple2(appModel, $elm$core$Platform$Cmd$none);
				}
			case 'OnSignatureClick':
				var filledSignature = msg.a;
				var _v12 = A4(
					$author$project$Data$PDF$updateCurrentUserSignedSignatures,
					user.email,
					filledSignature,
					model.pdf,
					A2($elm$core$Maybe$withDefault, '', model.pdfBase64));
				var updatedPdf = _v12.a;
				var cmdMsg = _v12.b;
				return _Utils_Tuple2(
					updateAppModel(
						_Utils_update(
							model,
							{
								pdf: updatedPdf,
								selectedSignature: $elm$core$Maybe$Just(filledSignature)
							})),
					cmdMsg);
			case 'OnStampClick':
				var stamp = msg.a;
				return A4($author$project$Model$ViewDocument$setSelectedStampAndUpdatePDF, stamp, model, anonymousModel.user, appModel);
			case 'OnReceiveSelectedAnnotsData':
				var value = msg.a;
				if (_Utils_eq(
					$author$project$Data$PDF$status(model.pdf),
					$author$project$Data$PDF$Signing)) {
					var _v13 = model.selectedSignature;
					if (_v13.$ === 'Just') {
						var selectedSig = _v13.a;
						var _v14 = A8(
							$author$project$Data$PDF$verifyAnnotations,
							$elm$core$String$concat(
								_List_fromArray(
									[user.firstName, ' ', user.lastName])),
							user.email,
							appModel.currentTime,
							value,
							model.selectedStamp,
							selectedSig,
							model.pdf,
							A2($elm$core$Maybe$withDefault, '', model.pdfBase64));
						if (_v14.$ === 'Ok') {
							var _v15 = _v14.a;
							var updatedPdf = _v15.a;
							var cmdMsg = _v15.b;
							var editableTextContent = _v15.c;
							var updatedModel = function () {
								if (editableTextContent.$ === 'Just') {
									var _v17 = editableTextContent.a;
									var id = _v17.a;
									var content = _v17.b;
									return _Utils_update(
										model,
										{
											modal: $elm$core$Maybe$Just(
												A2($author$project$Type$ViewDocument$UpdateAnnotName, id, content)),
											textAnnotationName: content
										});
								} else {
									return model;
								}
							}();
							return _Utils_Tuple2(
								updateAppModel(
									_Utils_update(
										updatedModel,
										{pdf: updatedPdf})),
								cmdMsg);
						} else {
							var updateAnnotErr = _v14.a;
							return _Utils_Tuple2(
								updateAppModel(
									_Utils_update(
										model,
										{
											banner: $elm$core$Maybe$Just(
												$author$project$Type$ViewDocument$Error(
													$author$project$Type$ViewDocument$UpdateAnnotations(updateAnnotErr)))
										})),
								$elm$core$Platform$Cmd$none);
						}
					} else {
						return _Utils_Tuple2(appModel, $elm$core$Platform$Cmd$none);
					}
				} else {
					return _Utils_Tuple2(
						updateAppModel(model),
						$elm$core$Platform$Cmd$none);
				}
			case 'OnDocSubmit':
				var _v18 = A2($author$project$Data$PDF$hasVerifyAllAnnotations, user.email, model.pdf);
				if (_v18.$ === 'Ok') {
					return _Utils_Tuple2(
						updateAppModel(
							_Utils_update(
								model,
								{
									modal: $elm$core$Maybe$Just($author$project$Type$ViewDocument$Signing)
								})),
						A2(
							$elm$core$Task$attempt,
							A2(
								$elm$core$Basics$composeL,
								A2(
									$elm$core$Basics$composeL,
									A2($elm$core$Basics$composeL, $author$project$Types$OnViewDoc, $author$project$Type$ViewDocument$OnAuth),
									$author$project$Type$ViewDocument$OnLoaded),
								$author$project$Type$ViewDocument$OnDocSubmitResult),
							A7(
								$author$project$Data$Api$PDF$Update$authCall,
								user.jwt,
								appModel.apiEndPoint.updatePdf,
								user.email,
								$author$project$Data$Domain$selected(user.domains),
								model.pdf,
								model.password,
								appModel.timezoneOffset / 60)));
				} else {
					var _v19 = _v18.a;
					var unverifiedAnnot = _v19.a;
					var cmdMsg = _v19.b;
					return _Utils_Tuple2(
						updateAppModel(
							_Utils_update(
								model,
								{
									banner: $elm$core$Maybe$Just(
										$author$project$Type$ViewDocument$Error(
											$author$project$Type$ViewDocument$HasUnverifiedAnnotation(unverifiedAnnot)))
								})),
						cmdMsg);
				}
			case 'OnShowModal':
				var modal = msg.a;
				return _Utils_Tuple2(
					updateAppModel(
						_Utils_update(
							model,
							{
								modal: $elm$core$Maybe$Just(modal)
							})),
					$elm$core$Platform$Cmd$none);
			case 'OnBackClick':
				return _Utils_Tuple2(
					_Utils_update(
						appModel,
						{
							sessionModel: $author$project$Types$Anonymous(
								_Utils_update(
									anonymousModel,
									{viewDocModel: $author$project$Type$ViewDocument$NotLoaded}))
						}),
					A2($elm$browser$Browser$Navigation$pushUrl, appModel.navKey, $author$project$Data$Route$routeUrl.dashboard));
			case 'OnGenerateCredentialClick':
				return _Utils_Tuple2(
					_Utils_update(
						appModel,
						{
							sessionModel: $author$project$Types$Anonymous(
								_Utils_update(
									anonymousModel,
									{
										viewDocModel: $author$project$Type$ViewDocument$VerificationError($author$project$Type$ViewDocument$NotTokenUser)
									}))
						}),
					$elm$core$Platform$Cmd$none);
			case 'OnErrorClose':
				return _Utils_Tuple2(
					updateAppModel(
						_Utils_update(
							model,
							{banner: $elm$core$Maybe$Nothing})),
					$elm$core$Platform$Cmd$none);
			case 'OnDocSubmitResult':
				var result = msg.a;
				var currentDocument = model.payload.document;
				var hasPassedNotarisationCriteria = currentDocument.requireNotarisation && _Utils_eq(
					$author$project$Model$ViewDocument$convertStringToNetwork(
						A2($elm$core$Maybe$withDefault, '', currentDocument.notarisationNetwork)),
					$author$project$Type$ViewDocument$Algorand);
				if (result.$ === 'Ok') {
					var value = result.a;
					return (hasPassedNotarisationCriteria || value.requireSignatureTimeStamping) ? _Utils_Tuple2(
						updateAppModel(
							_Utils_update(
								model,
								{
									modal: $elm$core$Maybe$Just($author$project$Type$ViewDocument$Success)
								})),
						A2(
							$elm$core$Task$perform,
							$author$project$Types$OnViewDoc,
							$elm$core$Task$succeed(
								$author$project$Type$ViewDocument$OnAuth(
									$author$project$Type$ViewDocument$OnLoaded(
										$author$project$Type$ViewDocument$OnSignatureTimestampingAlgorand(value.requireSignatureTimeStamping)))))) : _Utils_Tuple2(
						updateAppModel(
							_Utils_update(
								model,
								{
									modal: $elm$core$Maybe$Just($author$project$Type$ViewDocument$Success)
								})),
						$elm$core$Platform$Cmd$none);
				} else {
					var err = result.a;
					return _Utils_Tuple2(
						updateAppModel(
							_Utils_update(
								model,
								{
									banner: $elm$core$Maybe$Just(
										$author$project$Type$ViewDocument$Error(
											$author$project$Type$ViewDocument$SignApi(
												A2($author$project$Data$Api$authErrorToString, $author$project$Data$Api$PDF$Update$errorToString, err)))),
									modal: $elm$core$Maybe$Nothing
								})),
						$elm$core$Platform$Cmd$none);
				}
			case 'OnDownloadWrapDoc':
				return _Utils_Tuple2(appModel, $elm$core$Platform$Cmd$none);
			case 'DownloadWrapDocResult':
				return _Utils_Tuple2(appModel, $elm$core$Platform$Cmd$none);
			case 'OnDownload':
				return _Utils_Tuple2(
					updateAppModel(
						_Utils_update(
							model,
							{downloadStatus: $author$project$Type$ViewDocument$Downloading})),
					A2(
						$elm$core$Task$attempt,
						A2(
							$elm$core$Basics$composeL,
							A2(
								$elm$core$Basics$composeL,
								A2($elm$core$Basics$composeL, $author$project$Types$OnViewDoc, $author$project$Type$ViewDocument$OnAuth),
								$author$project$Type$ViewDocument$OnLoaded),
							$author$project$Type$ViewDocument$DownloadResult),
						A5(
							$author$project$Data$Api$PDF$Download$authCall,
							user.jwt,
							appModel.apiEndPoint.downloadFile,
							$author$project$Data$Domain$selected(user.domains),
							$author$project$Data$PDF$id(model.pdf),
							appModel.timezoneOffset / 60)));
			case 'DownloadResult':
				var result = msg.a;
				if (result.$ === 'Ok') {
					var value = result.a;
					return _Utils_Tuple2(
						updateAppModel(
							_Utils_update(
								model,
								{downloadStatus: $author$project$Type$ViewDocument$NoDownload})),
						A3(
							$elm$file$File$Download$bytes,
							$author$project$Data$PDF$title(model.pdf) + '.pdf',
							'application/pdf',
							value));
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						updateAppModel(
							_Utils_update(
								model,
								{
									banner: $elm$core$Maybe$Just(
										$author$project$Type$ViewDocument$Error(
											$author$project$Type$ViewDocument$DownloadError(
												A2($author$project$Data$Api$authErrorToString, $author$project$Data$Api$PDF$Download$errorToString, error)))),
									downloadStatus: $author$project$Type$ViewDocument$NoDownload
								})),
						$elm$core$Platform$Cmd$none);
				}
			case 'OnPasscodeInput':
				var value = msg.a;
				return $elm$core$String$isEmpty(value) ? _Utils_Tuple2(
					updateAppModel(
						_Utils_update(
							model,
							{passcode: $elm$core$Maybe$Nothing})),
					$elm$core$Platform$Cmd$none) : _Utils_Tuple2(
					updateAppModel(
						_Utils_update(
							model,
							{
								passcode: $elm$core$Maybe$Just(value)
							})),
					$elm$core$Platform$Cmd$none);
			case 'OnPasscodeSubmitResult':
				var result = msg.a;
				if (result.$ === 'Ok') {
					return _Utils_Tuple2(
						updateAppModel(
							_Utils_update(
								model,
								{modal: $elm$core$Maybe$Nothing, successSnackBar: $author$project$Material$Styled$Snackbar$Show})),
						A2(
							$author$project$Material$Styled$Snackbar$hide,
							2,
							A2(
								$elm$core$Basics$composeL,
								A2(
									$elm$core$Basics$composeL,
									A2($elm$core$Basics$composeL, $author$project$Types$OnViewDoc, $author$project$Type$ViewDocument$OnAuth),
									$author$project$Type$ViewDocument$OnLoaded),
								$author$project$Type$ViewDocument$SnackbarClose)));
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						updateAppModel(
							_Utils_update(
								model,
								{
									modal: $elm$core$Maybe$Just($author$project$Type$ViewDocument$RequiredPasscode),
									passcode: $elm$core$Maybe$Nothing,
									passcodeError: $elm$core$Maybe$Just(
										A2($author$project$Data$Api$authErrorToString, $author$project$Data$Api$PDF$ValidatePasscode$errorToString, error))
								})),
						$elm$core$Platform$Cmd$none);
				}
			case 'OnPasscodeSubmit':
				return _Utils_Tuple2(
					updateAppModel(
						_Utils_update(
							model,
							{
								modal: $elm$core$Maybe$Just(
									$author$project$Type$ViewDocument$LoadingState($author$project$Type$ViewDocument$Passcode))
							})),
					A2(
						$elm$core$Task$attempt,
						A2(
							$elm$core$Basics$composeL,
							A2(
								$elm$core$Basics$composeL,
								A2($elm$core$Basics$composeL, $author$project$Types$OnViewDoc, $author$project$Type$ViewDocument$OnAuth),
								$author$project$Type$ViewDocument$OnLoaded),
							$author$project$Type$ViewDocument$OnPasscodeSubmitResult),
						A4(
							$author$project$Data$Api$PDF$ValidatePasscode$authCall,
							user.jwt,
							appModel.apiEndPoint.validatePasscode,
							$author$project$Data$PDF$id(model.pdf),
							A2($elm$core$Maybe$withDefault, '', model.passcode))));
			case 'SnackbarClose':
				return _Utils_Tuple2(
					updateAppModel(
						_Utils_update(
							model,
							{successSnackBar: $author$project$Material$Styled$Snackbar$Hide})),
					$elm$core$Platform$Cmd$none);
			case 'OnDeadlineInput':
				return _Utils_Tuple2(appModel, $elm$core$Platform$Cmd$none);
			case 'OnDeadlineExtClick':
				return _Utils_Tuple2(appModel, $elm$core$Platform$Cmd$none);
			case 'OnDeadlineExtResponse':
				return _Utils_Tuple2(appModel, $elm$core$Platform$Cmd$none);
			case 'OnRequireNotarisation':
				return _Utils_Tuple2(appModel, $elm$core$Platform$Cmd$none);
			case 'NotarisationResult':
				return _Utils_Tuple2(appModel, $elm$core$Platform$Cmd$none);
			case 'OnGetNotarisationPoints':
				return _Utils_Tuple2(appModel, $elm$core$Platform$Cmd$none);
			case 'OnNotarisationPointsResponse':
				return _Utils_Tuple2(appModel, $elm$core$Platform$Cmd$none);
			case 'OnGetGenerateCredentialPoints':
				return _Utils_Tuple2(appModel, $elm$core$Platform$Cmd$none);
			case 'OnGetGenerateCredentialPointsResponse':
				return _Utils_Tuple2(appModel, $elm$core$Platform$Cmd$none);
			case 'OnGenerateCredentialCheckBoxClick':
				return _Utils_Tuple2(appModel, $elm$core$Platform$Cmd$none);
			case 'OnGenerateCredentialsSubmit':
				return _Utils_Tuple2(appModel, $elm$core$Platform$Cmd$none);
			case 'OnGetGenerateCredentialResponse':
				return _Utils_Tuple2(appModel, $elm$core$Platform$Cmd$none);
			case 'OnGenerateCredentialModalClose':
				return _Utils_Tuple2(appModel, $elm$core$Platform$Cmd$none);
			case 'OnCredentialNameInput':
				return _Utils_Tuple2(appModel, $elm$core$Platform$Cmd$none);
			case 'OnReturnToViewDoc':
				return _Utils_Tuple2(appModel, $elm$core$Platform$Cmd$none);
			case 'OnListCredentials':
				return _Utils_Tuple2(appModel, $elm$core$Platform$Cmd$none);
			case 'OnListCredentialsResult':
				return _Utils_Tuple2(appModel, $elm$core$Platform$Cmd$none);
			case 'OnDownloadCredentialFile':
				return _Utils_Tuple2(appModel, $elm$core$Platform$Cmd$none);
			case 'DownloadCredentialFileResult':
				return _Utils_Tuple2(appModel, $elm$core$Platform$Cmd$none);
			case 'DeleteDocumentClick':
				return _Utils_Tuple2(appModel, $elm$core$Platform$Cmd$none);
			case 'OnDeleteDocument':
				return _Utils_Tuple2(appModel, $elm$core$Platform$Cmd$none);
			case 'OnDeleteDocumentResult':
				return _Utils_Tuple2(appModel, $elm$core$Platform$Cmd$none);
			case 'OnGetCredentialDownloadTime':
				return _Utils_Tuple2(appModel, $elm$core$Platform$Cmd$none);
			case 'OnGetDocumentDownloadTime':
				return _Utils_Tuple2(appModel, $elm$core$Platform$Cmd$none);
			case 'OnHover':
				var placement = msg.a;
				var action = msg.b;
				var email = msg.c;
				if (action.$ === 'Leaves') {
					return _Utils_Tuple2(
						updateAppModel(
							_Utils_update(
								model,
								{toolTip: $author$project$Type$ViewDocument$NoHover})),
						$elm$core$Platform$Cmd$none);
				} else {
					return _Utils_Tuple2(
						updateAppModel(
							_Utils_update(
								model,
								{
									toolTip: A2($author$project$Type$ViewDocument$Hover, placement, email)
								})),
						$elm$core$Platform$Cmd$none);
				}
			case 'OnNotariseDocumentAlgorand':
				return _Utils_Tuple2(appModel, $elm$core$Platform$Cmd$none);
			case 'NotarisationAlgorandResult':
				return _Utils_Tuple2(appModel, $elm$core$Platform$Cmd$none);
			case 'OnMyAlgoWalletClick':
				return _Utils_Tuple2(appModel, $elm$core$Platform$Cmd$none);
			case 'AlgorandWalletError':
				return _Utils_Tuple2(appModel, $elm$core$Platform$Cmd$none);
			case 'OnGetAlgorandWalletAddress':
				return _Utils_Tuple2(appModel, $elm$core$Platform$Cmd$none);
			case 'OnSelectWallet':
				return _Utils_Tuple2(appModel, $elm$core$Platform$Cmd$none);
			case 'OptInAssetClick':
				return _Utils_Tuple2(appModel, $elm$core$Platform$Cmd$none);
			case 'OptInError':
				return _Utils_Tuple2(appModel, $elm$core$Platform$Cmd$none);
			case 'GetOptInDetails':
				return _Utils_Tuple2(appModel, $elm$core$Platform$Cmd$none);
			case 'PaymentTransactionClick':
				return _Utils_Tuple2(appModel, $elm$core$Platform$Cmd$none);
			case 'SendNotarisationDetails':
				return _Utils_Tuple2(appModel, $elm$core$Platform$Cmd$none);
			case 'OnGetNotarisationDetailsResult':
				return _Utils_Tuple2(appModel, $elm$core$Platform$Cmd$none);
			case 'PaymentTransactionError':
				return _Utils_Tuple2(appModel, $elm$core$Platform$Cmd$none);
			case 'OnGetOptInDetailsResult':
				return _Utils_Tuple2(appModel, $elm$core$Platform$Cmd$none);
			case 'OptInStatusResult':
				return _Utils_Tuple2(appModel, $elm$core$Platform$Cmd$none);
			case 'RetrieveUserAlgorandWallet':
				return _Utils_Tuple2(appModel, $elm$core$Platform$Cmd$none);
			case 'OnWalletConnectClick':
				return _Utils_Tuple2(appModel, $elm$core$Platform$Cmd$none);
			case 'OnWalletConnectAddressesReceive':
				return _Utils_Tuple2(appModel, $elm$core$Platform$Cmd$none);
			case 'OnWallectConnectAddressSelect':
				return _Utils_Tuple2(appModel, $elm$core$Platform$Cmd$none);
			case 'OnWalletConnectOptInCompleted':
				return _Utils_Tuple2(appModel, $elm$core$Platform$Cmd$none);
			case 'OnWalletOptInApiResponse':
				return _Utils_Tuple2(appModel, $elm$core$Platform$Cmd$none);
			case 'OnWalletConnectNotarizationCompleted':
				return _Utils_Tuple2(appModel, $elm$core$Platform$Cmd$none);
			case 'OnWalletConnectRegisterApiResponse':
				return _Utils_Tuple2(appModel, $elm$core$Platform$Cmd$none);
			case 'OnWalletConnectNotarizationClick':
				return _Utils_Tuple2(appModel, $elm$core$Platform$Cmd$none);
			case 'OnRestartWalletConnectInit':
				return _Utils_Tuple2(appModel, $elm$core$Platform$Cmd$none);
			case 'OnRestartWalletConnectNotarization':
				return _Utils_Tuple2(appModel, $elm$core$Platform$Cmd$none);
			case 'OnWalletConnectError':
				return _Utils_Tuple2(appModel, $elm$core$Platform$Cmd$none);
			case 'OnNotarizationStart':
				return _Utils_Tuple2(appModel, $elm$core$Platform$Cmd$none);
			case 'OnListSigningEvents':
				return _Utils_Tuple2(appModel, $elm$core$Platform$Cmd$none);
			case 'OnListSigningEventsResult':
				return _Utils_Tuple2(appModel, $elm$core$Platform$Cmd$none);
			case 'OnSendEmailReminder':
				return _Utils_Tuple2(appModel, $elm$core$Platform$Cmd$none);
			case 'OnSendEmailReminderResult':
				return _Utils_Tuple2(appModel, $elm$core$Platform$Cmd$none);
			case 'OnTextFieldInput':
				var annotId = msg.a;
				var value = msg.b;
				return _Utils_Tuple2(
					updateAppModel(
						_Utils_update(
							model,
							{textAnnotationName: value})),
					$elm$core$Platform$Cmd$none);
			case 'OnTextFieldNameConfirm':
				return _Utils_Tuple2(
					updateAppModel(
						_Utils_update(
							model,
							{modal: $elm$core$Maybe$Nothing, textAnnotationName: ''})),
					$elm$core$Platform$Cmd$none);
			case 'OnTextFieldNameCancel':
				return _Utils_Tuple2(
					updateAppModel(
						_Utils_update(
							model,
							{modal: $elm$core$Maybe$Nothing, textAnnotationName: ''})),
					$elm$core$Platform$Cmd$none);
			case 'OnTextFieldNameOnBlur':
				var annotId = msg.a;
				var _v24 = A5(
					$author$project$Data$PDF$updateTextAnnotContent,
					annotId,
					model.textAnnotationName,
					user.email,
					model.pdf,
					A2($elm$core$Maybe$withDefault, '', model.pdfBase64));
				var updatedPdf = _v24.a;
				var cmdMsg = _v24.b;
				return _Utils_Tuple2(
					updateAppModel(
						_Utils_update(
							model,
							{pdf: updatedPdf})),
					cmdMsg);
			case 'OnAcceptESignDisclaimerUserClick':
				return _Utils_Tuple2(
					appModel,
					A2(
						$elm$core$Task$attempt,
						A2(
							$elm$core$Basics$composeL,
							A2(
								$elm$core$Basics$composeL,
								A2($elm$core$Basics$composeL, $author$project$Types$OnViewDoc, $author$project$Type$ViewDocument$OnAuth),
								$author$project$Type$ViewDocument$OnLoaded),
							$author$project$Type$ViewDocument$OnAcceptESignDisclaimerUserResult),
						A2($author$project$Data$Api$UpdateESignatureDisclaimer$authCall, user.jwt, appModel.apiEndPoint.updateESignatureDisclaimer)));
			case 'OnAcceptESignDisclaimerUserResult':
				var currentUser_ = anonymousModel.user;
				var updatedUser = _Utils_update(
					currentUser_,
					{
						eSignDisclaimer: true,
						eSignDisclaimerTimestamp: $elm$core$Maybe$Just(appModel.currentTime)
					});
				return _Utils_Tuple2(
					_Utils_update(
						appModel,
						{
							sessionModel: $author$project$Types$Anonymous(
								_Utils_update(
									anonymousModel,
									{user: updatedUser}))
						}),
					$author$project$Data$User$store(updatedUser));
			case 'ToggleUserAcceptESignDisclaimer':
				return _Utils_Tuple2(
					updateAppModel(
						_Utils_update(
							model,
							{
								eDisclaimerCheckbox: _Utils_eq(model.eDisclaimerCheckbox, $author$project$Type$ViewDocument$Accepted) ? $author$project$Type$ViewDocument$NotAccepted : $author$project$Type$ViewDocument$Accepted
							})),
					$elm$core$Platform$Cmd$none);
			case 'OnNewSignatureAddition':
				var _v25 = signatureModel;
				var signatures = _v25.signatures;
				var newlyCreatedSignature = $elm$core$List$head(signatures);
				var newModel = function () {
					if (newlyCreatedSignature.$ === 'Just') {
						var signature = newlyCreatedSignature.a;
						return updateAppModel(
							_Utils_update(
								model,
								{
									selectedSignature: $elm$core$Maybe$Just(
										A3($author$project$Data$PDF$Signature$create, signature.id, signature.name, signature.data))
								}));
					} else {
						return appModel;
					}
				}();
				return _Utils_Tuple2(
					newModel,
					A2(
						$elm$core$Task$perform,
						$author$project$Types$OnViewDoc,
						$elm$core$Task$succeed(
							$author$project$Type$ViewDocument$OnAuth(
								$author$project$Type$ViewDocument$OnLoaded(
									$author$project$Type$ViewDocument$OnShowModal($author$project$Type$ViewDocument$SignatureStampModal))))));
			case 'OnReceiveCheckboxClickData':
				var value = msg.a;
				var _v27 = $author$project$Model$ViewDocument$decodeCheckboxClickData(value);
				if (_v27.$ === 'Ok') {
					var results = _v27.a;
					var updatedpdf = A4($author$project$Data$PDF$updateCheckboxAnnotation, user.email, results.id, results.value, model.pdf);
					return _Utils_Tuple2(
						updateAppModel(
							_Utils_update(
								model,
								{pdf: updatedpdf})),
						A2($author$project$Data$PDF$Port$updatePlaceholderAnnot, results.id, results.value));
				} else {
					return _Utils_Tuple2(appModel, $elm$core$Platform$Cmd$none);
				}
			case 'OnSignatureTimestampingAlgorand':
				var requireSignatureTimeStamping = msg.a;
				return _Utils_Tuple2(
					appModel,
					A2(
						$elm$core$Task$attempt,
						A2(
							$elm$core$Basics$composeL,
							A2(
								$elm$core$Basics$composeL,
								A2($elm$core$Basics$composeL, $author$project$Types$OnViewDoc, $author$project$Type$ViewDocument$OnAuth),
								$author$project$Type$ViewDocument$OnLoaded),
							$author$project$Type$ViewDocument$OnSignatureTimestampingAlgorandResult),
						A4(
							$author$project$Data$Api$PDF$SignatureTimestamping$authCall,
							user.jwt,
							appModel.apiEndPoint.signatureTimestamping,
							$author$project$Data$PDF$id(model.pdf),
							requireSignatureTimeStamping)));
			case 'OnSignatureTimestampingAlgorandResult':
				var result = msg.a;
				if (result.$ === 'Ok') {
					return _Utils_Tuple2(appModel, $elm$core$Platform$Cmd$none);
				} else {
					return _Utils_Tuple2(appModel, $elm$core$Platform$Cmd$none);
				}
			case 'OnDownloadCert':
				return _Utils_Tuple2(appModel, $elm$core$Platform$Cmd$none);
			case 'OnDownloadCertResult':
				return _Utils_Tuple2(appModel, $elm$core$Platform$Cmd$none);
			case 'OnRetryNotarisation':
				return _Utils_Tuple2(appModel, $elm$core$Platform$Cmd$none);
			case 'OnRetryNotarisationResult':
				return _Utils_Tuple2(appModel, $elm$core$Platform$Cmd$none);
			default:
				var value = msg.a;
				var updatedPDF = A3($author$project$Data$PDF$updateSignatureWidth, value, user.email, model.pdf);
				return _Utils_Tuple2(
					updateAppModel(
						_Utils_update(
							model,
							{pdf: updatedPDF})),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Model$ViewDocument$validateNameInputField = function (nameInput) {
	return $elm$core$String$isEmpty(nameInput) ? $elm$core$Maybe$Just('Name Field cannot be empty') : (($elm$core$String$length(nameInput) > 50) ? $elm$core$Maybe$Just('Name Field cannot be more than 50 characters') : $elm$core$Maybe$Nothing);
};
var $author$project$Model$ViewDocument$updateAnonymousModel = F3(
	function (msg, anonymousModel, model) {
		var updateUserModel = F2(
			function (newUser, currentModel) {
				return _Utils_update(
					currentModel,
					{
						sessionModel: $author$project$Types$Anonymous(
							_Utils_update(
								anonymousModel,
								{user: newUser}))
					});
			});
		var updateCurrentModel = function (currentModel) {
			return _Utils_update(
				model,
				{
					sessionModel: $author$project$Types$Anonymous(
						_Utils_update(
							anonymousModel,
							{viewDocModel: currentModel}))
				});
		};
		var updateAppModel = F2(
			function (docId, m) {
				return _Utils_update(
					model,
					{
						sessionModel: $author$project$Types$Anonymous(
							_Utils_update(
								anonymousModel,
								{
									viewDocModel: A2($author$project$Type$ViewDocument$UpdateUserCurrentName, docId, m)
								}))
					});
			});
		var _v0 = anonymousModel;
		var viewDocModel = _v0.viewDocModel;
		var user = _v0.user;
		var signatureModel = _v0.signatureModel;
		switch (msg.$) {
			case 'OnUnload':
				return _Utils_Tuple2(
					updateCurrentModel($author$project$Type$ViewDocument$NotLoaded),
					$author$project$Data$PDF$unloadPDF(_Utils_Tuple0));
			case 'ValidateESignDisclaimer':
				var tokenOrDocId = msg.a;
				return anonymousModel.user.eSignDisclaimer ? _Utils_Tuple2(model, $elm$core$Platform$Cmd$none) : _Utils_Tuple2(
					_Utils_update(
						model,
						{
							sessionModel: $author$project$Types$Anonymous(
								_Utils_update(
									anonymousModel,
									{
										viewDocModel: A2($author$project$Type$ViewDocument$LoadWithESignatureDisclaimer, tokenOrDocId, $author$project$Type$ViewDocument$NotAccepted)
									}))
						}),
					$elm$core$Platform$Cmd$none);
			case 'CheckUserUpdatedName':
				var tokenOrDocId = msg.a;
				if (anonymousModel.user.updateNameConfirmation) {
					return _Utils_Tuple2(
						model,
						A2(
							$elm$core$Task$perform,
							$author$project$Types$OnViewDoc,
							$elm$core$Task$succeed(
								$author$project$Type$ViewDocument$OnAuth(
									$author$project$Type$ViewDocument$LoadDocument(tokenOrDocId)))));
				} else {
					var newModels = {firstNameError: $elm$core$Maybe$Nothing, firstNameInput: user.firstName, lastNameError: $elm$core$Maybe$Nothing, lastNameInput: user.lastName, modalOpen: true};
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								sessionModel: $author$project$Types$Anonymous(
									_Utils_update(
										anonymousModel,
										{
											viewDocModel: A2($author$project$Type$ViewDocument$UpdateUserCurrentName, tokenOrDocId, newModels)
										}))
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 'OnNameSubmit':
				var docID = msg.a;
				if (viewDocModel.$ === 'UpdateUserCurrentName') {
					var documentID = viewDocModel.a;
					var currentModel = viewDocModel.b;
					return _Utils_Tuple2(
						A2(
							updateAppModel,
							documentID,
							_Utils_update(
								currentModel,
								{modalOpen: false})),
						A2(
							$elm$core$Task$attempt,
							A2(
								$elm$core$Basics$composeL,
								A2($elm$core$Basics$composeL, $author$project$Types$OnViewDoc, $author$project$Type$ViewDocument$OnAuth),
								$author$project$Type$ViewDocument$OnNameSubmitResult(docID)),
							A4($author$project$Data$Api$UpdateUserName$authCall, user.jwt, model.apiEndPoint.updateUserFirstNameLastName, currentModel.firstNameInput, currentModel.lastNameInput)));
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 'OnNameSubmitResult':
				var docID = msg.a;
				var result = msg.b;
				if (viewDocModel.$ === 'UpdateUserCurrentName') {
					var documentID = viewDocModel.a;
					var currentModel = viewDocModel.b;
					if (result.$ === 'Ok') {
						var newModel = A2(
							updateUserModel,
							_Utils_update(
								user,
								{firstName: currentModel.firstNameInput, lastName: currentModel.lastNameInput}),
							A2(
								updateAppModel,
								documentID,
								_Utils_update(
									currentModel,
									{modalOpen: false})));
						return _Utils_Tuple2(
							newModel,
							A2(
								$elm$core$Task$perform,
								$author$project$Types$OnViewDoc,
								$elm$core$Task$succeed(
									$author$project$Type$ViewDocument$OnAuth(
										$author$project$Type$ViewDocument$LoadDocument(docID)))));
					} else {
						return _Utils_Tuple2(
							A2(
								updateAppModel,
								documentID,
								_Utils_update(
									currentModel,
									{modalOpen: true})),
							$elm$core$Platform$Cmd$none);
					}
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 'OnNameInput':
				var inputfield = msg.a;
				var value = msg.b;
				if (viewDocModel.$ === 'UpdateUserCurrentName') {
					var documentID = viewDocModel.a;
					var currentModel = viewDocModel.b;
					if (inputfield.$ === 'FirstName') {
						return _Utils_Tuple2(
							A2(
								updateAppModel,
								documentID,
								_Utils_update(
									currentModel,
									{firstNameInput: value, modalOpen: true})),
							$elm$core$Platform$Cmd$none);
					} else {
						return _Utils_Tuple2(
							A2(
								updateAppModel,
								documentID,
								_Utils_update(
									currentModel,
									{lastNameInput: value, modalOpen: true})),
							$elm$core$Platform$Cmd$none);
					}
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 'OnNameFieldBlur':
				if (viewDocModel.$ === 'UpdateUserCurrentName') {
					var documentID = viewDocModel.a;
					var currentModel = viewDocModel.b;
					return _Utils_Tuple2(
						A2(
							updateAppModel,
							documentID,
							_Utils_update(
								currentModel,
								{
									firstNameError: $author$project$Model$ViewDocument$validateNameInputField(currentModel.firstNameInput),
									lastNameError: $author$project$Model$ViewDocument$validateNameInputField(currentModel.lastNameInput),
									modalOpen: true
								})),
						$elm$core$Platform$Cmd$none);
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 'LoadDocument':
				var docID = msg.a;
				return _Utils_Tuple2(
					updateCurrentModel($author$project$Type$ViewDocument$Loading),
					A2(
						$elm$core$Task$attempt,
						A2(
							$elm$core$Basics$composeL,
							A2($elm$core$Basics$composeL, $author$project$Types$OnViewDoc, $author$project$Type$ViewDocument$OnAuth),
							$author$project$Type$ViewDocument$LoadDocumentResult),
						A4(
							$author$project$Data$Api$PDF$View$authCall,
							user.jwt,
							model.apiEndPoint.viewPdf,
							docID,
							$author$project$Data$Domain$selected(user.domains))));
			case 'LoadDocumentResult':
				var result = msg.a;
				if (result.$ === 'Ok') {
					var pdfPayload = result.a;
					var _v9 = A4(
						$author$project$Data$PDF$initFilledPDF,
						user,
						$author$project$Data$Domain$selected(user.domains),
						model.currentTime,
						pdfPayload);
					if (_v9.$ === 'Ok') {
						var pdf = _v9.a;
						var recipients = A2(
							$elm$core$List$map,
							$author$project$Model$ViewDocument$getRecipientWithStatus(pdfPayload.annotations),
							A2(
								$elm$core$List$map,
								function (recipient) {
									return {email: recipient.email, name: recipient.firstName + (' ' + recipient.lastName), role: recipient.role, signOrder: recipient.signOrder, userId: recipient.userId, verifyMobilePhone: recipient.verifyMobilePhone, verifyMyInfo: recipient.verifyMyInfo, verifyPassbase: recipient.verifyPassbase, verifyStripe: recipient.verifyStripe, verifyWallet: recipient.verifyWallet};
								},
								pdfPayload.recipients));
						var ownerName = pdfPayload.document.firstName + (' ' + pdfPayload.document.lastName);
						var logs = A2(
							$elm$core$List$map,
							function (log) {
								return A4($author$project$Model$ViewDocument$toLogModel, pdfPayload.recipients, pdfPayload.domainOwners, ownerName, log);
							},
							pdfPayload.logs);
						var displayPDFViewer = function () {
							var _v10 = _Utils_Tuple2(
								pdfPayload.document.saveDocument,
								$author$project$Data$PDF$status(pdf));
							if (_v10.a) {
								return true;
							} else {
								switch (_v10.b.$) {
									case 'Viewing':
										return true;
									case 'Signing':
										var _v11 = _v10.b;
										return true;
									case 'Completed':
										var _v12 = _v10.b;
										return false;
									case 'Expired':
										var _v13 = _v10.b;
										return true;
									default:
										return true;
								}
							}
						}();
						var currentUser = A2(
							$author$project$Data$PDF$User$registered,
							$elm$core$Maybe$Nothing,
							A9($author$project$Data$PDF$User$info, user.email, user.firstName, user.lastName, user.trustScore.stripe, user.trustScore.passbase, user.trustScore.mobilePhone, user.trustScore.wallet, user.trustScore.myInfo, $author$project$Data$PDF$User$Blue));
						return _Utils_Tuple2(
							updateCurrentModel(
								$author$project$Type$ViewDocument$Loaded(
									{
										algorandNotarisationCost: $elm$core$Maybe$Nothing,
										algorandWalletAddresses: _List_Nil,
										banner: $elm$core$Maybe$Nothing,
										binanceNotarisationCost: $elm$core$Maybe$Nothing,
										credentialData: _List_Nil,
										credentialName: '',
										displayViewer: displayPDFViewer,
										downloadStatus: $author$project$Type$ViewDocument$NoDownload,
										eDisclaimerCheckbox: $author$project$Type$ViewDocument$NotAccepted,
										gcSignPointsBalance: $elm$core$Maybe$Nothing,
										generateCredentialcost: $elm$core$Maybe$Nothing,
										logs: logs,
										modal: $elm$core$Maybe$Just(
											$author$project$Type$ViewDocument$LoadingState($author$project$Type$ViewDocument$Document)),
										needOptIn: false,
										newDueDate: A2(
											$elm$core$Maybe$withDefault,
											'',
											$author$project$Data$PDF$dueDate(pdf)),
										numberOfSignatureLoaded: 0,
										optInError: $elm$core$Maybe$Nothing,
										optInStatusCode: $elm$core$Maybe$Nothing,
										passcode: $elm$core$Maybe$Nothing,
										passcodeError: $elm$core$Maybe$Nothing,
										password: $elm$core$Maybe$Nothing,
										passwordError: $elm$core$Maybe$Nothing,
										payload: pdfPayload,
										pdf: pdf,
										pdfBase64: $elm$core$Maybe$Nothing,
										recipients: recipients,
										selectAnnotationIndex: _List_Nil,
										selectedSignature: $elm$core$Maybe$Nothing,
										selectedStamp: $elm$core$Maybe$Nothing,
										selectedWallet: $elm$core$Maybe$Nothing,
										signPointsBalance: $elm$core$Maybe$Nothing,
										signingEventsData: _List_Nil,
										successSnackBar: $author$project$Material$Styled$Snackbar$Hide,
										textAnnotationName: '',
										toolTip: $author$project$Type$ViewDocument$NoHover,
										walletError: $elm$core$Maybe$Nothing
									})),
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										A5($author$project$Data$PDF$loadPDF, model.apiEndPoint.pdfFile, user.jwt, model.currentTime, currentUser, pdf),
										A2(
										$elm$core$Task$perform,
										$author$project$Types$OnSignature,
										$elm$core$Task$succeed($author$project$Type$Signature$OnViewRendered)),
										$author$project$Model$ViewDocument$displayViewDocumentMenuAdsContent(
										$elm$json$Json$Encode$bool(user.showAds))
									])));
					} else {
						var err = _v9.a;
						return _Utils_Tuple2(
							updateCurrentModel(
								$author$project$Type$ViewDocument$LoadingDecodeError(err)),
							$elm$core$Platform$Cmd$none);
					}
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						updateCurrentModel(
							$author$project$Type$ViewDocument$LoadingApiError(error)),
						$elm$core$Platform$Cmd$none);
				}
			case 'OnRefreshClick':
				return _Utils_Tuple2(model, $elm$browser$Browser$Navigation$reload);
			case 'OnNavigateToDashboard':
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 'OnLoaded':
				var loadedMsg = msg.a;
				if (viewDocModel.$ === 'Loaded') {
					var loadedModel = viewDocModel.a;
					return A4($author$project$Model$ViewDocument$updateAnonymousLoadedModel, loadedMsg, loadedModel, anonymousModel, model);
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 'OnGenerateCredential':
				var loadedMsg = msg.a;
				if (viewDocModel.$ === 'GenerateCredential') {
					var loadedModel = viewDocModel.a;
					return A4($author$project$Model$ViewDocument$updateAnonymousLoadedModel, loadedMsg, loadedModel, anonymousModel, model);
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 'OnNavigateToRegister':
				var ownerShareReferralCode = function () {
					if (viewDocModel.$ === 'Loaded') {
						var loadedModel = viewDocModel.a;
						return loadedModel.payload.ownerShareReferralCode;
					} else {
						return '';
					}
				}();
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{sessionModel: $author$project$Types$NoAuth}),
					A2($elm$browser$Browser$Navigation$pushUrl, model.navKey, $author$project$Data$Route$routeUrl.personalRegister + ('?email=' + (anonymousModel.user.email + ('&ref=' + ownerShareReferralCode)))));
			case 'OnAcceptESignDisclaimerClick':
				var docId = msg.a;
				return _Utils_Tuple2(
					updateCurrentModel($author$project$Type$ViewDocument$Loading),
					A2(
						$elm$core$Task$attempt,
						A2(
							$elm$core$Basics$composeL,
							A2($elm$core$Basics$composeL, $author$project$Types$OnViewDoc, $author$project$Type$ViewDocument$OnAuth),
							$author$project$Type$ViewDocument$OnAcceptESignDisclaimerResult(docId)),
						A2($author$project$Data$Api$UpdateESignatureDisclaimer$authCall, user.jwt, model.apiEndPoint.updateESignatureDisclaimer)));
			case 'OnAcceptESignDisclaimerResult':
				var currentUser_ = anonymousModel.user;
				var updatedUser = _Utils_update(
					currentUser_,
					{
						eSignDisclaimer: true,
						eSignDisclaimerTimestamp: $elm$core$Maybe$Just(model.currentTime)
					});
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							sessionModel: $author$project$Types$Anonymous(
								_Utils_update(
									anonymousModel,
									{user: updatedUser}))
						}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$Data$User$store(updatedUser),
								$elm$core$Platform$Cmd$none
							])));
			default:
				return _Utils_Tuple2(
					updateCurrentModel(
						$author$project$Model$ViewDocument$toggleESignDisclaimerStatus(viewDocModel)),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Type$ViewDocument$CheckWalletOptIn = {$: 'CheckWalletOptIn'};
var $author$project$Type$ViewDocument$CredentialCreated = {$: 'CredentialCreated'};
var $author$project$Type$ViewDocument$DeadlineExt = {$: 'DeadlineExt'};
var $author$project$Type$ViewDocument$DeleteDocument = {$: 'DeleteDocument'};
var $author$project$Type$ViewDocument$DeleteSuccess = {$: 'DeleteSuccess'};
var $author$project$Type$ViewDocument$DisplayWallet = function (a) {
	return {$: 'DisplayWallet', a: a};
};
var $author$project$Type$ViewDocument$DisplayWalletConnectAddresses = function (a) {
	return {$: 'DisplayWalletConnectAddresses', a: a};
};
var $author$project$Type$ViewDocument$DownloadCredentialFileResult = F2(
	function (a, b) {
		return {$: 'DownloadCredentialFileResult', a: a, b: b};
	});
var $author$project$Type$ViewDocument$DownloadWrapDocResult = function (a) {
	return {$: 'DownloadWrapDocResult', a: a};
};
var $author$project$Type$ViewDocument$DueDateExtensionError = function (a) {
	return {$: 'DueDateExtensionError', a: a};
};
var $author$project$Type$ViewDocument$EmailReminderSuccess = {$: 'EmailReminderSuccess'};
var $author$project$Type$ViewDocument$GenerateCredential = function (a) {
	return {$: 'GenerateCredential', a: a};
};
var $author$project$Type$ViewDocument$GenerateCredentialApi = function (a) {
	return {$: 'GenerateCredentialApi', a: a};
};
var $author$project$Type$ViewDocument$GenerateCredentials = {$: 'GenerateCredentials'};
var $author$project$Type$ViewDocument$GeneratingCredential = {$: 'GeneratingCredential'};
var $author$project$Type$ViewDocument$GetWallet = {$: 'GetWallet'};
var $author$project$Type$ViewDocument$MakePayment = {$: 'MakePayment'};
var $author$project$Type$ViewDocument$NoAnnotationSelected = {$: 'NoAnnotationSelected'};
var $author$project$Type$ViewDocument$NoCredentialName = {$: 'NoCredentialName'};
var $author$project$Type$ViewDocument$Notarisation = {$: 'Notarisation'};
var $author$project$Type$ViewDocument$NotarisationAlgorandResult = function (a) {
	return {$: 'NotarisationAlgorandResult', a: a};
};
var $author$project$Type$ViewDocument$NotarisationResult = function (a) {
	return {$: 'NotarisationResult', a: a};
};
var $author$project$Type$ViewDocument$NotariseDocument = function (a) {
	return {$: 'NotariseDocument', a: a};
};
var $author$project$Type$ViewDocument$NotariseSuccess = function (a) {
	return {$: 'NotariseSuccess', a: a};
};
var $author$project$Type$ViewDocument$Notarization = function (a) {
	return {$: 'Notarization', a: a};
};
var $author$project$Type$ViewDocument$OnDeadlineExtResponse = function (a) {
	return {$: 'OnDeadlineExtResponse', a: a};
};
var $author$project$Type$ViewDocument$OnDeleteDocumentResult = function (a) {
	return {$: 'OnDeleteDocumentResult', a: a};
};
var $author$project$Type$ViewDocument$OnDownloadCertResult = function (a) {
	return {$: 'OnDownloadCertResult', a: a};
};
var $author$project$Type$ViewDocument$OnGenerateCredential = function (a) {
	return {$: 'OnGenerateCredential', a: a};
};
var $author$project$Type$ViewDocument$OnGetCredentialDownloadTime = F2(
	function (a, b) {
		return {$: 'OnGetCredentialDownloadTime', a: a, b: b};
	});
var $author$project$Type$ViewDocument$OnGetDocumentDownloadTime = function (a) {
	return {$: 'OnGetDocumentDownloadTime', a: a};
};
var $author$project$Type$ViewDocument$OnGetGenerateCredentialPointsResponse = function (a) {
	return {$: 'OnGetGenerateCredentialPointsResponse', a: a};
};
var $author$project$Type$ViewDocument$OnGetGenerateCredentialResponse = function (a) {
	return {$: 'OnGetGenerateCredentialResponse', a: a};
};
var $author$project$Type$ViewDocument$OnGetNotarisationDetailsResult = function (a) {
	return {$: 'OnGetNotarisationDetailsResult', a: a};
};
var $author$project$Type$ViewDocument$OnGetOptInDetailsResult = function (a) {
	return {$: 'OnGetOptInDetailsResult', a: a};
};
var $author$project$Type$ViewDocument$OnListCredentialsResult = function (a) {
	return {$: 'OnListCredentialsResult', a: a};
};
var $author$project$Type$ViewDocument$OnListSigningEventsResult = function (a) {
	return {$: 'OnListSigningEventsResult', a: a};
};
var $author$project$Type$ViewDocument$OnNotarisationPointsResponse = function (a) {
	return {$: 'OnNotarisationPointsResponse', a: a};
};
var $author$project$Type$ViewDocument$OnRetryNotarisationResult = function (a) {
	return {$: 'OnRetryNotarisationResult', a: a};
};
var $author$project$Type$ViewDocument$OnSendEmailReminderResult = function (a) {
	return {$: 'OnSendEmailReminderResult', a: a};
};
var $author$project$Type$ViewDocument$OnWalletConnectRegisterApiResponse = F2(
	function (a, b) {
		return {$: 'OnWalletConnectRegisterApiResponse', a: a, b: b};
	});
var $author$project$Type$ViewDocument$OnWalletOptInApiResponse = F2(
	function (a, b) {
		return {$: 'OnWalletOptInApiResponse', a: a, b: b};
	});
var $author$project$Type$ViewDocument$OptIn = {$: 'OptIn'};
var $author$project$Type$ViewDocument$Pay = {$: 'Pay'};
var $author$project$Type$ViewDocument$RegisterWallet = {$: 'RegisterWallet'};
var $author$project$Type$ViewDocument$SendingEmail = {$: 'SendingEmail'};
var $author$project$Type$ViewDocument$ShowCredential = {$: 'ShowCredential'};
var $author$project$Type$ViewDocument$ShowSigningData = {$: 'ShowSigningData'};
var $author$project$Type$ViewDocument$Successful = function (a) {
	return {$: 'Successful', a: a};
};
var $author$project$Type$ViewDocument$WalletAdded = {$: 'WalletAdded'};
var $author$project$Data$Api$ListNotariseSigningEvents$Payload = function (signingEventData) {
	return {signingEventData: signingEventData};
};
var $author$project$Data$Api$ListNotariseSigningEvents$SigningEvents = F4(
	function (transactionId, docId, userId, timeStamp) {
		return {docId: docId, timeStamp: timeStamp, transactionId: transactionId, userId: userId};
	});
var $author$project$Data$Api$ListNotariseSigningEvents$dataDecoder = A2(
	$elm$json$Json$Decode$map,
	$author$project$Data$Api$ListNotariseSigningEvents$Payload,
	$elm$json$Json$Decode$list(
		A5(
			$elm$json$Json$Decode$map4,
			$author$project$Data$Api$ListNotariseSigningEvents$SigningEvents,
			A2($elm$json$Json$Decode$field, 'transactionId', $elm$json$Json$Decode$string),
			A2($elm$json$Json$Decode$field, 'docId', $elm$json$Json$Decode$string),
			A2($elm$json$Json$Decode$field, 'userId', $elm$json$Json$Decode$string),
			A2(
				$elm$json$Json$Decode$field,
				'timeStamp',
				A2($elm$json$Json$Decode$map, $elm$time$Time$millisToPosix, $elm$json$Json$Decode$int)))));
var $author$project$Data$Api$ListNotariseSigningEvents$encode = function (documentId) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'id',
				$elm$json$Json$Encode$string(documentId))
			]));
};
var $author$project$Data$Api$ListNotariseSigningEvents$JWT_ERROR = {$: 'JWT_ERROR'};
var $author$project$Data$Api$ListNotariseSigningEvents$UNAUTHORISED_USER = {$: 'UNAUTHORISED_USER'};
var $author$project$Data$Api$ListNotariseSigningEvents$errorDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (errorCode) {
		switch (errorCode) {
			case 'UNAUTHORISED_USER':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$ListNotariseSigningEvents$UNAUTHORISED_USER);
			case 'JWT_ERROR':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$ListNotariseSigningEvents$JWT_ERROR);
			default:
				return $elm$json$Json$Decode$fail('Invalid error code: ' + errorCode);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Data$Api$ListNotariseSigningEvents$authCall = F3(
	function (jwt, endPoint, documentId) {
		return A5(
			$author$project$Data$Api$authCall,
			jwt,
			endPoint,
			$author$project$Data$Api$ListNotariseSigningEvents$errorDecoder,
			$author$project$Data$Api$ListNotariseSigningEvents$dataDecoder,
			$author$project$Data$Api$ListNotariseSigningEvents$encode(documentId));
	});
var $author$project$Data$Api$PDF$DeadlineExtension$Payload = function (message) {
	return {message: message};
};
var $author$project$Data$Api$PDF$DeadlineExtension$dataDecoder = A2(
	$elm$json$Json$Decode$map,
	$author$project$Data$Api$PDF$DeadlineExtension$Payload,
	A2($elm$json$Json$Decode$field, 'message', $elm$json$Json$Decode$string));
var $author$project$Data$Api$PDF$DeadlineExtension$encode = F2(
	function (docID, newDate) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'docID',
					$elm$json$Json$Encode$string(docID)),
					_Utils_Tuple2(
					'newDate',
					$elm$json$Json$Encode$string(newDate))
				]));
	});
var $author$project$Data$Api$PDF$DeadlineExtension$DOCUMENT_COMPLETED = {$: 'DOCUMENT_COMPLETED'};
var $author$project$Data$Api$PDF$DeadlineExtension$DOCUMENT_EXPIRED = {$: 'DOCUMENT_EXPIRED'};
var $author$project$Data$Api$PDF$DeadlineExtension$INCORRECT_ID = {$: 'INCORRECT_ID'};
var $author$project$Data$Api$PDF$DeadlineExtension$INCORRECT_USER = {$: 'INCORRECT_USER'};
var $author$project$Data$Api$PDF$DeadlineExtension$INVALID_NEW_DATE = {$: 'INVALID_NEW_DATE'};
var $author$project$Data$Api$PDF$DeadlineExtension$NO_EXISTING_DEADLINE = {$: 'NO_EXISTING_DEADLINE'};
var $author$project$Data$Api$PDF$DeadlineExtension$errorDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (errorCode) {
		switch (errorCode) {
			case 'INCORRECT_ID':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$PDF$DeadlineExtension$INCORRECT_ID);
			case 'INCORRECT_USER':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$PDF$DeadlineExtension$INCORRECT_USER);
			case 'NO_EXISTING_DEADLINE':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$PDF$DeadlineExtension$NO_EXISTING_DEADLINE);
			case 'DOCUMENT_COMPLETED':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$PDF$DeadlineExtension$DOCUMENT_COMPLETED);
			case 'DOCUMENT_EXPIRED':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$PDF$DeadlineExtension$DOCUMENT_EXPIRED);
			case 'INVALID_NEW_DATE':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$PDF$DeadlineExtension$INVALID_NEW_DATE);
			default:
				return $elm$json$Json$Decode$fail('Invalid error code: ' + errorCode);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Data$Api$PDF$DeadlineExtension$authCall = F4(
	function (jwt, endPoint, docID, newDate) {
		return A5(
			$author$project$Data$Api$authCall,
			jwt,
			endPoint,
			$author$project$Data$Api$PDF$DeadlineExtension$errorDecoder,
			$author$project$Data$Api$PDF$DeadlineExtension$dataDecoder,
			A2($author$project$Data$Api$PDF$DeadlineExtension$encode, docID, newDate));
	});
var $author$project$Data$Api$PDF$DownloadCert$DELETED_DOCUMENT = {$: 'DELETED_DOCUMENT'};
var $author$project$Data$Api$PDF$DownloadCert$INCOMPLETE_DOC = {$: 'INCOMPLETE_DOC'};
var $author$project$Data$Api$PDF$DownloadCert$INVALID_DOC_ID = {$: 'INVALID_DOC_ID'};
var $author$project$Data$Api$PDF$DownloadCert$INVALID_OFFSET_VALUE = {$: 'INVALID_OFFSET_VALUE'};
var $author$project$Data$Api$PDF$DownloadCert$LOGO_IMAGE_DOES_NOT_EXITS = {$: 'LOGO_IMAGE_DOES_NOT_EXITS'};
var $author$project$Data$Api$PDF$DownloadCert$UNAUTHORIZED_USER = {$: 'UNAUTHORIZED_USER'};
var $author$project$Data$Api$PDF$DownloadCert$errorDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (errorCode) {
		switch (errorCode) {
			case 'INVALID_DOC_ID':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$PDF$DownloadCert$INVALID_DOC_ID);
			case 'UNAUTHORIZED_USER':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$PDF$DownloadCert$UNAUTHORIZED_USER);
			case 'INCOMPLETE_DOC':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$PDF$DownloadCert$INCOMPLETE_DOC);
			case 'DELETED_DOCUMENT':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$PDF$DownloadCert$DELETED_DOCUMENT);
			case 'LOGO_IMAGE_DOES_NOT_EXITS':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$PDF$DownloadCert$LOGO_IMAGE_DOES_NOT_EXITS);
			case 'INVALID_OFFSET_VALUE':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$PDF$DownloadCert$INVALID_OFFSET_VALUE);
			default:
				return $elm$json$Json$Decode$fail('Invalid error code: ' + errorCode);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Data$Api$PDF$DownloadCert$authCall = F4(
	function (jwt, endPoint, docId, offset) {
		return A3(
			$author$project$Data$Api$authGetFile,
			jwt,
			endPoint + (docId + ('/' + $elm$core$String$fromFloat(offset))),
			$author$project$Data$Api$PDF$DownloadCert$errorDecoder);
	});
var $author$project$Data$Api$PDF$DownloadVerifiableCredentials$INVALID_VERIFIABLE_CREDENTIAL_FILE = {$: 'INVALID_VERIFIABLE_CREDENTIAL_FILE'};
var $author$project$Data$Api$PDF$DownloadVerifiableCredentials$INVALID_VERIFIABLE_CREDENTIAL_ID = {$: 'INVALID_VERIFIABLE_CREDENTIAL_ID'};
var $author$project$Data$Api$PDF$DownloadVerifiableCredentials$JWT_ERROR = {$: 'JWT_ERROR'};
var $author$project$Data$Api$PDF$DownloadVerifiableCredentials$UNAUTHORIZED_USER = {$: 'UNAUTHORIZED_USER'};
var $author$project$Data$Api$PDF$DownloadVerifiableCredentials$errorDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (errorCode) {
		switch (errorCode) {
			case 'INVALID_VERIFIABLE_CREDENTIAL_ID':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$PDF$DownloadVerifiableCredentials$INVALID_VERIFIABLE_CREDENTIAL_ID);
			case 'UNAUTHORIZED_USER':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$PDF$DownloadVerifiableCredentials$UNAUTHORIZED_USER);
			case 'INVALID_VERIFIABLE_CREDENTIAL_FILE':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$PDF$DownloadVerifiableCredentials$INVALID_VERIFIABLE_CREDENTIAL_FILE);
			case 'JWT_ERROR':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$PDF$DownloadVerifiableCredentials$JWT_ERROR);
			default:
				return $elm$json$Json$Decode$fail('Invalid error code: ' + errorCode);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Data$Api$PDF$DownloadVerifiableCredentials$authCall = F3(
	function (jwt, endPoint, credentialId) {
		return A3(
			$author$project$Data$Api$authGetFile,
			jwt,
			_Utils_ap(endPoint, credentialId),
			$author$project$Data$Api$PDF$DownloadVerifiableCredentials$errorDecoder);
	});
var $author$project$Data$Api$PDF$DownloadWrapDoc$INVALID_WRAPPED_DOC_ID = {$: 'INVALID_WRAPPED_DOC_ID'};
var $author$project$Data$Api$PDF$DownloadWrapDoc$UNAUTHORIZED_USER = {$: 'UNAUTHORIZED_USER'};
var $author$project$Data$Api$PDF$DownloadWrapDoc$errorDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (errorCode) {
		switch (errorCode) {
			case 'INVALID_WRAPPED_DOC_ID':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$PDF$DownloadWrapDoc$INVALID_WRAPPED_DOC_ID);
			case 'UNAUTHORIZED_USER':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$PDF$DownloadWrapDoc$UNAUTHORIZED_USER);
			default:
				return $elm$json$Json$Decode$fail('Invalid error code: ' + errorCode);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Data$Api$PDF$DownloadWrapDoc$authCall = F3(
	function (jwt, endPoint, docId) {
		return A3(
			$author$project$Data$Api$authGetFile,
			jwt,
			_Utils_ap(endPoint, docId),
			$author$project$Data$Api$PDF$DownloadWrapDoc$errorDecoder);
	});
var $author$project$Data$Api$PDF$EmailReminder$Payload = function (message) {
	return {message: message};
};
var $author$project$Data$Api$PDF$EmailReminder$dataDecoder = A2(
	$elm$json$Json$Decode$map,
	$author$project$Data$Api$PDF$EmailReminder$Payload,
	A2($elm$json$Json$Decode$field, 'message', $elm$json$Json$Decode$string));
var $author$project$Data$Api$PDF$EmailReminder$encode = function (documentId) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'id',
				$elm$json$Json$Encode$string(documentId))
			]));
};
var $author$project$Data$Api$PDF$EmailReminder$DOCUMENT_COMPLETED = {$: 'DOCUMENT_COMPLETED'};
var $author$project$Data$Api$PDF$EmailReminder$JWT_ERROR = {$: 'JWT_ERROR'};
var $author$project$Data$Api$PDF$EmailReminder$UNAUTHORISED_USER = {$: 'UNAUTHORISED_USER'};
var $author$project$Data$Api$PDF$EmailReminder$USER_NOT_FOUND = {$: 'USER_NOT_FOUND'};
var $author$project$Data$Api$PDF$EmailReminder$errorDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (errorCode) {
		switch (errorCode) {
			case 'UNAUTHORISED_USER':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$PDF$EmailReminder$UNAUTHORISED_USER);
			case 'DOCUMENT_COMPLETED':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$PDF$EmailReminder$DOCUMENT_COMPLETED);
			case 'USER_NOT_FOUND':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$PDF$EmailReminder$USER_NOT_FOUND);
			case 'JWT_ERROR':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$PDF$EmailReminder$JWT_ERROR);
			default:
				return $elm$json$Json$Decode$fail('Invalid error code: ' + errorCode);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Data$Api$PDF$EmailReminder$authCall = F3(
	function (jwt, endPoint, documentId) {
		return A5(
			$author$project$Data$Api$authCall,
			jwt,
			endPoint,
			$author$project$Data$Api$PDF$EmailReminder$errorDecoder,
			$author$project$Data$Api$PDF$EmailReminder$dataDecoder,
			$author$project$Data$Api$PDF$EmailReminder$encode(documentId));
	});
var $author$project$Data$Api$PDF$GenerateCredentials$Payload = function (log) {
	return {log: log};
};
var $author$project$Data$Api$PDF$GenerateCredentials$dataDecoder = A2(
	$elm$json$Json$Decode$map,
	$author$project$Data$Api$PDF$GenerateCredentials$Payload,
	A2($elm$json$Json$Decode$field, 'log', $author$project$Data$Api$PDF$View$decodeLog));
var $author$project$Data$Api$PDF$GenerateCredentials$encodeSelectedAnnotion = function (number) {
	return $elm$json$Json$Encode$int(number);
};
var $author$project$Data$Api$PDF$GenerateCredentials$encode = F3(
	function (docId, docName, selectedAnnotations) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'docId',
					$elm$json$Json$Encode$string(docId)),
					_Utils_Tuple2(
					'name',
					$elm$json$Json$Encode$string(docName)),
					_Utils_Tuple2(
					'userSelection',
					A2($elm$json$Json$Encode$list, $author$project$Data$Api$PDF$GenerateCredentials$encodeSelectedAnnotion, selectedAnnotations))
				]));
	});
var $author$project$Data$Api$PDF$GenerateCredentials$INSUFFICIENT_POINTS = {$: 'INSUFFICIENT_POINTS'};
var $author$project$Data$Api$PDF$GenerateCredentials$INVALID_WRAPPED_DOC_ID = {$: 'INVALID_WRAPPED_DOC_ID'};
var $author$project$Data$Api$PDF$GenerateCredentials$JWT_ERROR = {$: 'JWT_ERROR'};
var $author$project$Data$Api$PDF$GenerateCredentials$UNAUTHORISED_USER = {$: 'UNAUTHORISED_USER'};
var $author$project$Data$Api$PDF$GenerateCredentials$errorDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (errorCode) {
		switch (errorCode) {
			case 'INVALID_WRAPPED_DOC_ID':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$PDF$GenerateCredentials$INVALID_WRAPPED_DOC_ID);
			case 'INSUFFICIENT_POINTS':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$PDF$GenerateCredentials$INSUFFICIENT_POINTS);
			case 'UNAUTHORISED_USER':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$PDF$GenerateCredentials$UNAUTHORISED_USER);
			default:
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$PDF$GenerateCredentials$JWT_ERROR);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Data$Api$PDF$GenerateCredentials$authCall = F5(
	function (jwt, endPoint, docId, docName, selectedAnnotations) {
		return A5(
			$author$project$Data$Api$authCall,
			jwt,
			endPoint,
			$author$project$Data$Api$PDF$GenerateCredentials$errorDecoder,
			$author$project$Data$Api$PDF$GenerateCredentials$dataDecoder,
			A3($author$project$Data$Api$PDF$GenerateCredentials$encode, docId, docName, selectedAnnotations));
	});
var $author$project$Data$Api$PDF$GenerateCredentialsPoints$Payload = F2(
	function (signPointsBalance, cost) {
		return {cost: cost, signPointsBalance: signPointsBalance};
	});
var $author$project$Data$Api$PDF$GenerateCredentialsPoints$dataDecoder = A3(
	$elm$json$Json$Decode$map2,
	$author$project$Data$Api$PDF$GenerateCredentialsPoints$Payload,
	A2($elm$json$Json$Decode$field, 'signPointsBalance', $elm$json$Json$Decode$int),
	A2($elm$json$Json$Decode$field, 'cost', $elm$json$Json$Decode$int));
var $author$project$Data$Api$PDF$GenerateCredentialsPoints$JWT_ERROR = {$: 'JWT_ERROR'};
var $author$project$Data$Api$PDF$GenerateCredentialsPoints$errorDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (_v0) {
		return $elm$json$Json$Decode$succeed($author$project$Data$Api$PDF$GenerateCredentialsPoints$JWT_ERROR);
	},
	$elm$json$Json$Decode$string);
var $author$project$Data$Api$PDF$GenerateCredentialsPoints$authCall = F2(
	function (jwt, endPoint) {
		return A5(
			$author$project$Data$Api$authCall,
			jwt,
			endPoint,
			$author$project$Data$Api$PDF$GenerateCredentialsPoints$errorDecoder,
			$author$project$Data$Api$PDF$GenerateCredentialsPoints$dataDecoder,
			$elm$json$Json$Encode$object(_List_Nil));
	});
var $author$project$Data$Api$PDF$ListCredentials$Credentials = F3(
	function (id, name, docId) {
		return {docId: docId, id: id, name: name};
	});
var $author$project$Data$Api$PDF$ListCredentials$Payload = function (credentialData) {
	return {credentialData: credentialData};
};
var $author$project$Data$Api$PDF$ListCredentials$dataDecoder = A2(
	$elm$json$Json$Decode$map,
	$author$project$Data$Api$PDF$ListCredentials$Payload,
	$elm$json$Json$Decode$list(
		A4(
			$elm$json$Json$Decode$map3,
			$author$project$Data$Api$PDF$ListCredentials$Credentials,
			A2($elm$json$Json$Decode$field, 'id', $elm$json$Json$Decode$string),
			A2($elm$json$Json$Decode$field, 'name', $elm$json$Json$Decode$string),
			A2($elm$json$Json$Decode$field, 'docId', $elm$json$Json$Decode$string))));
var $author$project$Data$Api$PDF$ListCredentials$encode = function (documentId) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'id',
				$elm$json$Json$Encode$string(documentId))
			]));
};
var $author$project$Data$Api$PDF$ListCredentials$JWT_ERROR = {$: 'JWT_ERROR'};
var $author$project$Data$Api$PDF$ListCredentials$UNAUTHORISED_USER = {$: 'UNAUTHORISED_USER'};
var $author$project$Data$Api$PDF$ListCredentials$errorDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (errorCode) {
		switch (errorCode) {
			case 'UNAUTHORISED_USER':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$PDF$ListCredentials$UNAUTHORISED_USER);
			case 'JWT_ERROR':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$PDF$ListCredentials$JWT_ERROR);
			default:
				return $elm$json$Json$Decode$fail('Invalid error code: ' + errorCode);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Data$Api$PDF$ListCredentials$authCall = F3(
	function (jwt, endPoint, documentId) {
		return A5(
			$author$project$Data$Api$authCall,
			jwt,
			endPoint,
			$author$project$Data$Api$PDF$ListCredentials$errorDecoder,
			$author$project$Data$Api$PDF$ListCredentials$dataDecoder,
			$author$project$Data$Api$PDF$ListCredentials$encode(documentId));
	});
var $author$project$Data$Api$PDF$NotariseCompletedDoc$Payload = function (message) {
	return {message: message};
};
var $author$project$Data$Api$PDF$NotariseCompletedDoc$dataDecoder = A2(
	$elm$json$Json$Decode$map,
	$author$project$Data$Api$PDF$NotariseCompletedDoc$Payload,
	A2($elm$json$Json$Decode$field, 'message', $elm$json$Json$Decode$string));
var $author$project$Data$Api$PDF$NotariseCompletedDoc$encode = function (documentId) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'id',
				$elm$json$Json$Encode$string(documentId))
			]));
};
var $author$project$Data$Api$PDF$NotariseCompletedDoc$INSUFFICIENT_POINTS = {$: 'INSUFFICIENT_POINTS'};
var $author$project$Data$Api$PDF$NotariseCompletedDoc$JWT_ERROR = {$: 'JWT_ERROR'};
var $author$project$Data$Api$PDF$NotariseCompletedDoc$UNAUTHORISED_USER = {$: 'UNAUTHORISED_USER'};
var $author$project$Data$Api$PDF$NotariseCompletedDoc$UNCOMPLETED_DOCUMENT = {$: 'UNCOMPLETED_DOCUMENT'};
var $author$project$Data$Api$PDF$NotariseCompletedDoc$errorDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (errorCode) {
		switch (errorCode) {
			case 'UNAUTHORISED_USER':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$PDF$NotariseCompletedDoc$UNAUTHORISED_USER);
			case 'UNCOMPLETED_DOCUMENT':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$PDF$NotariseCompletedDoc$UNCOMPLETED_DOCUMENT);
			case 'INSUFFICIENT_POINTS':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$PDF$NotariseCompletedDoc$INSUFFICIENT_POINTS);
			case 'JWT_ERROR':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$PDF$NotariseCompletedDoc$JWT_ERROR);
			default:
				return $elm$json$Json$Decode$fail('Invalid error code: ' + errorCode);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Data$Api$PDF$NotariseCompletedDoc$authCall = F3(
	function (jwt, endPoint, documentId) {
		return A5(
			$author$project$Data$Api$authCall,
			jwt,
			endPoint,
			$author$project$Data$Api$PDF$NotariseCompletedDoc$errorDecoder,
			$author$project$Data$Api$PDF$NotariseCompletedDoc$dataDecoder,
			$author$project$Data$Api$PDF$NotariseCompletedDoc$encode(documentId));
	});
var $author$project$Data$Api$PDF$NotariseCompletedDocAlgorand$Payload = function (message) {
	return {message: message};
};
var $author$project$Data$Api$PDF$NotariseCompletedDocAlgorand$dataDecoder = A2(
	$elm$json$Json$Decode$map,
	$author$project$Data$Api$PDF$NotariseCompletedDocAlgorand$Payload,
	A2($elm$json$Json$Decode$field, 'message', $elm$json$Json$Decode$string));
var $author$project$Data$Api$PDF$NotariseCompletedDocAlgorand$encode = function (documentId) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'id',
				$elm$json$Json$Encode$string(documentId))
			]));
};
var $author$project$Data$Api$PDF$NotariseCompletedDocAlgorand$INSUFFICIENT_POINTS = {$: 'INSUFFICIENT_POINTS'};
var $author$project$Data$Api$PDF$NotariseCompletedDocAlgorand$INVALID_NETWORK_TYPE = {$: 'INVALID_NETWORK_TYPE'};
var $author$project$Data$Api$PDF$NotariseCompletedDocAlgorand$JWT_ERROR = {$: 'JWT_ERROR'};
var $author$project$Data$Api$PDF$NotariseCompletedDocAlgorand$UNAUTHORISED_USER = {$: 'UNAUTHORISED_USER'};
var $author$project$Data$Api$PDF$NotariseCompletedDocAlgorand$UNCOMPLETED_DOCUMENT = {$: 'UNCOMPLETED_DOCUMENT'};
var $author$project$Data$Api$PDF$NotariseCompletedDocAlgorand$errorDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (errorCode) {
		switch (errorCode) {
			case 'UNAUTHORISED_USER':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$PDF$NotariseCompletedDocAlgorand$UNAUTHORISED_USER);
			case 'UNCOMPLETED_DOCUMENT':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$PDF$NotariseCompletedDocAlgorand$UNCOMPLETED_DOCUMENT);
			case 'INSUFFICIENT_POINTS':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$PDF$NotariseCompletedDocAlgorand$INSUFFICIENT_POINTS);
			case 'INVALID_NETWORK_TYPE':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$PDF$NotariseCompletedDocAlgorand$INVALID_NETWORK_TYPE);
			case 'JWT_ERROR':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$PDF$NotariseCompletedDocAlgorand$JWT_ERROR);
			default:
				return $elm$json$Json$Decode$fail('Invalid error code: ' + errorCode);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Data$Api$PDF$NotariseCompletedDocAlgorand$authCall = F3(
	function (jwt, endPoint, documentId) {
		return A5(
			$author$project$Data$Api$authCall,
			jwt,
			endPoint,
			$author$project$Data$Api$PDF$NotariseCompletedDocAlgorand$errorDecoder,
			$author$project$Data$Api$PDF$NotariseCompletedDocAlgorand$dataDecoder,
			$author$project$Data$Api$PDF$NotariseCompletedDocAlgorand$encode(documentId));
	});
var $author$project$Data$Api$PDF$RetryNotarisation$Payload = function (message) {
	return {message: message};
};
var $author$project$Data$Api$PDF$RetryNotarisation$dataDecoder = A2(
	$elm$json$Json$Decode$map,
	$author$project$Data$Api$PDF$RetryNotarisation$Payload,
	A2($elm$json$Json$Decode$field, 'message', $elm$json$Json$Decode$string));
var $author$project$Data$Api$PDF$RetryNotarisation$encode = function (documentId) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'docId',
				$elm$json$Json$Encode$string(documentId))
			]));
};
var $author$project$Data$Api$PDF$RetryNotarisation$CONDITION_NOT_MET = {$: 'CONDITION_NOT_MET'};
var $author$project$Data$Api$PDF$RetryNotarisation$INCOMPLETE_DOCUMENT = {$: 'INCOMPLETE_DOCUMENT'};
var $author$project$Data$Api$PDF$RetryNotarisation$INVALID_DOCUMENT = {$: 'INVALID_DOCUMENT'};
var $author$project$Data$Api$PDF$RetryNotarisation$JWT_ERROR = {$: 'JWT_ERROR'};
var $author$project$Data$Api$PDF$RetryNotarisation$UNAUTHORISED_USER = {$: 'UNAUTHORISED_USER'};
var $author$project$Data$Api$PDF$RetryNotarisation$errorDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (errorCode) {
		switch (errorCode) {
			case 'INCOMPLETE_DOCUMENT':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$PDF$RetryNotarisation$INCOMPLETE_DOCUMENT);
			case 'INVALID_DOCUMENT':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$PDF$RetryNotarisation$INVALID_DOCUMENT);
			case 'CONDITION_NOT_MET':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$PDF$RetryNotarisation$CONDITION_NOT_MET);
			case 'JWT_ERROR':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$PDF$RetryNotarisation$JWT_ERROR);
			case 'UNAUTHORISED_USER':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$PDF$RetryNotarisation$UNAUTHORISED_USER);
			default:
				return $elm$json$Json$Decode$fail('Invalid error code: ' + errorCode);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Data$Api$PDF$RetryNotarisation$authCall = F3(
	function (jwt, endPoint, documentId) {
		return A5(
			$author$project$Data$Api$authCall,
			jwt,
			endPoint,
			$author$project$Data$Api$PDF$RetryNotarisation$errorDecoder,
			$author$project$Data$Api$PDF$RetryNotarisation$dataDecoder,
			$author$project$Data$Api$PDF$RetryNotarisation$encode(documentId));
	});
var $author$project$Data$PDF$changeDueDate = F2(
	function (newDate, _v0) {
		var pdf = _v0.a;
		return $author$project$Data$PDF$PDF(
			_Utils_update(
				pdf,
				{
					dueDate: $elm$core$Maybe$Just(newDate)
				}));
	});
var $author$project$Data$Wallet$NotarizationDetails = F4(
	function (address, id, block, timestamp) {
		return {address: address, block: block, id: id, timestamp: timestamp};
	});
var $author$project$Data$Wallet$notarizationDetailsDecoder = A5(
	$elm$json$Json$Decode$map4,
	$author$project$Data$Wallet$NotarizationDetails,
	A2($elm$json$Json$Decode$field, 'address', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'id', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'block', $elm$json$Json$Decode$int),
	A2($elm$json$Json$Decode$field, 'timestamp', $elm$json$Json$Decode$int));
var $author$project$Data$Wallet$decodeNotarizationDetails = function (value) {
	var _v0 = A2($elm$json$Json$Decode$decodeValue, $author$project$Data$Wallet$notarizationDetailsDecoder, value);
	if (_v0.$ === 'Ok') {
		var results = _v0.a;
		return $elm$core$Result$Ok(results);
	} else {
		return $elm$core$Result$Err('Unable to retrieve transaction details.');
	}
};
var $author$project$Data$Wallet$decodeReturnWalletAddress = function (value) {
	var _v0 = A2($elm$json$Json$Decode$decodeValue, $elm$json$Json$Decode$string, value);
	if (_v0.$ === 'Ok') {
		var results = _v0.a;
		return $elm$core$Result$Ok(results);
	} else {
		return $elm$core$Result$Err('Unable to retrieve transaction details.');
	}
};
var $author$project$Data$Api$ListNotariseSigningEvents$errorToString = function (error) {
	if (error.$ === 'UNAUTHORISED_USER') {
		return 'You are not authorised to view siging events information.';
	} else {
		return 'Unauthorised user.';
	}
};
var $author$project$Data$Api$PDF$DeadlineExtension$errorToString = function (error) {
	switch (error.$) {
		case 'INCORRECT_ID':
			return 'Incorrect Document ID.';
		case 'INCORRECT_USER':
			return 'User does not have proper access to extend the deadline.';
		case 'NO_EXISTING_DEADLINE':
			return 'Document does not have an existing deadline.';
		case 'DOCUMENT_COMPLETED':
			return 'Document has already been completed.';
		case 'DOCUMENT_EXPIRED':
			return 'Document has already expired';
		default:
			return 'New date precedes the current deadline';
	}
};
var $author$project$Data$Api$PDF$DownloadCert$errorToString = function (error) {
	switch (error.$) {
		case 'INVALID_DOC_ID':
			return 'Invalid document id.';
		case 'UNAUTHORIZED_USER':
			return 'You are not authorised to perform this action.';
		case 'INCOMPLETE_DOC':
			return 'Document is not yet completed. Please try again after document is completed.';
		case 'DELETED_DOCUMENT':
			return 'Document has been deleted. PLease contact owner of this docunent.';
		case 'LOGO_IMAGE_DOES_NOT_EXITS':
			return 'Logo image file does not exist.';
		default:
			return 'Invalid offset value.';
	}
};
var $author$project$Data$Api$PDF$DownloadVerifiableCredentials$errorToString = function (error) {
	switch (error.$) {
		case 'INVALID_VERIFIABLE_CREDENTIAL_ID':
			return 'Invalid credential id.';
		case 'UNAUTHORIZED_USER':
			return 'Unauthorised user.';
		case 'INVALID_VERIFIABLE_CREDENTIAL_FILE':
			return 'File not found in our directory!';
		default:
			return 'Unauthorised user.';
	}
};
var $author$project$Data$Api$PDF$DownloadWrapDoc$errorToString = function (error) {
	if (error.$ === 'INVALID_WRAPPED_DOC_ID') {
		return 'Invalid wrapped document id.';
	} else {
		return 'Invalid data provided. Please refresh and try again.';
	}
};
var $author$project$Data$Api$PDF$EmailReminder$errorToString = function (error) {
	switch (error.$) {
		case 'UNAUTHORISED_USER':
			return 'You are not authorised to perform this action.';
		case 'DOCUMENT_COMPLETED':
			return 'Document has already been completed.';
		case 'USER_NOT_FOUND':
			return 'User not found.';
		default:
			return 'Invalid JWT, unauthorised user.';
	}
};
var $author$project$Data$Api$PDF$GenerateCredentials$errorToString = function (error) {
	switch (error.$) {
		case 'JWT_ERROR':
			return 'Unauthorised user.';
		case 'INVALID_WRAPPED_DOC_ID':
			return 'Wrapped document does not exist';
		case 'INSUFFICIENT_POINTS':
			return 'Not enough SIGN points to generate Credential';
		default:
			return 'You are not authorised to generate credential.';
	}
};
var $author$project$Data$Api$PDF$GenerateCredentialsPoints$errorToString = function (error) {
	return 'Unauthorised user.';
};
var $author$project$Data$Api$PDF$ListCredentials$errorToString = function (error) {
	if (error.$ === 'UNAUTHORISED_USER') {
		return 'You are not authorised to view credentials';
	} else {
		return 'Unauthorised user.';
	}
};
var $author$project$Data$Api$PDF$NotariseCompletedDoc$errorToString = function (error) {
	switch (error.$) {
		case 'UNAUTHORISED_USER':
			return 'You are not authorised to notarise document.';
		case 'UNCOMPLETED_DOCUMENT':
			return 'Current Document is uncompleted.';
		case 'INSUFFICIENT_POINTS':
			return 'You do not have enough SIGN points for document notarisation.';
		default:
			return 'Unauthorised user.';
	}
};
var $author$project$Data$Api$PDF$NotariseCompletedDocAlgorand$errorToString = function (error) {
	switch (error.$) {
		case 'UNAUTHORISED_USER':
			return 'You are not authorised to notarise document.';
		case 'UNCOMPLETED_DOCUMENT':
			return 'Current Document is uncompleted.';
		case 'INSUFFICIENT_POINTS':
			return 'You do not have enough SIGN points for document notarisation.';
		case 'INVALID_NETWORK_TYPE':
			return 'Wrong notarisation network type choosen.';
		default:
			return 'Invalid JWT, unauthorised user.';
	}
};
var $author$project$Data$Api$PDF$RetryNotarisation$errorToString = function (error) {
	switch (error.$) {
		case 'INCOMPLETE_DOCUMENT':
			return 'Current Document is incomplete.';
		case 'INVALID_DOCUMENT':
			return 'Document ID does not exist.';
		case 'CONDITION_NOT_MET':
			return 'Condition not met to retry notarise document.';
		case 'JWT_ERROR':
			return 'Invalid JWT, unauthorised user.';
		default:
			return 'You are not allowed to perform this action.';
	}
};
var $author$project$Data$PDF$updateNotarisationStatus = function (_v0) {
	var pdf = _v0.a;
	return $author$project$Data$PDF$PDF(
		_Utils_update(
			pdf,
			{requireNotarisation: true}));
};
var $author$project$Model$ViewDocument$updateAuthLoadedModel = F4(
	function (msg, model, authModel, appModel) {
		var updateAppModel = function (m) {
			var _v58 = authModel.viewDocModel;
			switch (_v58.$) {
				case 'Loaded':
					return _Utils_update(
						appModel,
						{
							sessionModel: $author$project$Types$Auth(
								_Utils_update(
									authModel,
									{
										viewDocModel: $author$project$Type$ViewDocument$Loaded(m)
									}))
						});
				case 'GenerateCredential':
					return _Utils_update(
						appModel,
						{
							sessionModel: $author$project$Types$Auth(
								_Utils_update(
									authModel,
									{
										viewDocModel: $author$project$Type$ViewDocument$GenerateCredential(m)
									}))
						});
				default:
					return _Utils_update(
						appModel,
						{
							sessionModel: $author$project$Types$Auth(
								_Utils_update(
									authModel,
									{
										viewDocModel: $author$project$Type$ViewDocument$Loaded(m)
									}))
						});
			}
		};
		var convertToLoadedModel = function (m) {
			return _Utils_update(
				appModel,
				{
					sessionModel: $author$project$Types$Auth(
						_Utils_update(
							authModel,
							{
								viewDocModel: $author$project$Type$ViewDocument$Loaded(m)
							}))
				});
		};
		var _v0 = authModel;
		var user = _v0.user;
		var signatureModel = _v0.signatureModel;
		var stampModel = _v0.stampModel;
		switch (msg.$) {
			case 'OnReceiveDocumentLoaded':
				var value = msg.a;
				var signatureIDs = $author$project$Data$Api$PDF$View$signedSignatureIds(model.payload.annotations);
				var signatureAndStampCmd = model.displayViewer ? $elm$core$Platform$Cmd$batch(
					$elm$core$List$concat(
						_List_fromArray(
							[
								A2(
								$elm$core$List$map,
								function (signature) {
									return A2(
										$elm$core$Task$attempt,
										A2(
											$elm$core$Basics$composeL,
											A2(
												$elm$core$Basics$composeL,
												A2($elm$core$Basics$composeL, $author$project$Types$OnViewDoc, $author$project$Type$ViewDocument$OnAuth),
												$author$project$Type$ViewDocument$OnLoaded),
											$author$project$Type$ViewDocument$SignedSignatureResult),
										A3($author$project$Data$Api$Signature$File$authCall, user.jwt, appModel.apiEndPoint.signatureFile, signature));
								},
								signatureIDs)
							]))) : $elm$core$Platform$Cmd$none;
				var docPasscode = model.payload.document.passcode;
				var base64PDF = function () {
					var _v2 = $author$project$Data$PDF$Port$decodeBase64String(value);
					if (_v2.$ === 'Ok') {
						var result = _v2.a;
						return result;
					} else {
						return '';
					}
				}();
				return (_Utils_eq(docPasscode, $elm$core$Maybe$Nothing) || (_Utils_eq(
					$author$project$Data$PDF$status(model.pdf),
					$author$project$Data$PDF$Completed) || ((!_Utils_eq(docPasscode, $elm$core$Maybe$Nothing)) && (!_Utils_eq(
					$author$project$Data$PDF$status(model.pdf),
					$author$project$Data$PDF$Signing))))) ? _Utils_Tuple2(
					updateAppModel(
						_Utils_update(
							model,
							{
								modal: $elm$core$Maybe$Nothing,
								pdfBase64: $elm$core$Maybe$Just(base64PDF),
								selectedSignature: $author$project$Type$Signature$firstSignature(signatureModel.signatures),
								selectedStamp: A2($author$project$Model$ViewDocument$firstStamp, user, authModel.stampModel)
							})),
					signatureAndStampCmd) : _Utils_Tuple2(
					updateAppModel(
						_Utils_update(
							model,
							{
								modal: $elm$core$Maybe$Just($author$project$Type$ViewDocument$RequiredPasscode),
								pdfBase64: $elm$core$Maybe$Just(base64PDF),
								selectedSignature: $author$project$Type$Signature$firstSignature(signatureModel.signatures),
								selectedStamp: A2($author$project$Model$ViewDocument$firstStamp, user, authModel.stampModel)
							})),
					signatureAndStampCmd);
			case 'OnReceiveEncryptionError':
				var value = msg.a;
				var _v3 = $author$project$Data$PDF$Encryption$decode(value);
				if (_v3.$ === 'Ok') {
					var encryptionError = _v3.a;
					if (encryptionError.$ === 'PasswordFail') {
						return _Utils_Tuple2(
							updateAppModel(
								_Utils_update(
									model,
									{
										modal: $elm$core$Maybe$Just($author$project$Type$ViewDocument$NeedPassword),
										passwordError: $elm$core$Maybe$Just('Password failed.')
									})),
							$elm$core$Platform$Cmd$none);
					} else {
						return _Utils_Tuple2(
							updateAppModel(
								_Utils_update(
									model,
									{
										modal: $elm$core$Maybe$Just($author$project$Type$ViewDocument$NeedPassword),
										passwordError: $elm$core$Maybe$Nothing
									})),
							$elm$core$Platform$Cmd$none);
					}
				} else {
					var decodeErrorMessage = _v3.a;
					return _Utils_Tuple2(
						updateAppModel(
							_Utils_update(
								model,
								{
									banner: $elm$core$Maybe$Just(
										$author$project$Type$ViewDocument$Error(
											$author$project$Type$ViewDocument$EncryptionDecodeError(decodeErrorMessage)))
								})),
						$elm$core$Platform$Cmd$none);
				}
			case 'OnPasswordInput':
				var value = msg.a;
				return $elm$core$String$isEmpty(value) ? _Utils_Tuple2(
					updateAppModel(
						_Utils_update(
							model,
							{password: $elm$core$Maybe$Nothing, passwordError: $elm$core$Maybe$Nothing})),
					$elm$core$Platform$Cmd$none) : _Utils_Tuple2(
					updateAppModel(
						_Utils_update(
							model,
							{
								password: $elm$core$Maybe$Just(value),
								passwordError: $elm$core$Maybe$Nothing
							})),
					$elm$core$Platform$Cmd$none);
			case 'OnPasswordSubmit':
				var currentUser = A2(
					$author$project$Data$PDF$User$registered,
					$elm$core$Maybe$Nothing,
					A9($author$project$Data$PDF$User$info, user.email, user.firstName, user.lastName, user.trustScore.stripe, user.trustScore.passbase, user.trustScore.mobilePhone, user.trustScore.wallet, user.trustScore.myInfo, $author$project$Data$PDF$User$Blue));
				var _v5 = A6(
					$author$project$Data$PDF$loadWithPassword,
					appModel.apiEndPoint.pdfFile,
					user.jwt,
					appModel.currentTime,
					currentUser,
					A2($elm$core$Maybe$withDefault, '', model.password),
					model.pdf);
				var pdf = _v5.a;
				var pdfCmd = _v5.b;
				return _Utils_Tuple2(
					updateAppModel(
						_Utils_update(
							model,
							{modal: $elm$core$Maybe$Nothing, pdf: pdf})),
					pdfCmd);
			case 'OnCloseModal':
				return _Utils_Tuple2(
					updateAppModel(
						_Utils_update(
							model,
							{modal: $elm$core$Maybe$Nothing})),
					$elm$core$Platform$Cmd$none);
			case 'SignedSignatureResult':
				var result = msg.a;
				if (result.$ === 'Ok') {
					var payload = result.a;
					var stampIDs = $elm$core$Set$toList(
						$author$project$Data$PDF$getNotLoadedStampIDs(model.pdf));
					var numberOfSignatureNeeded = $elm$core$List$length(
						$author$project$Data$Api$PDF$View$signedSignatureIds(model.payload.annotations));
					var numberOfSignatureLoaded = model.numberOfSignatureLoaded + 1;
					var _v7 = payload.signature;
					var id = _v7.id;
					var name = _v7.name;
					var data = _v7.data;
					var filledSignature = A3($author$project$Data$PDF$Signature$create, id, name, data);
					var _v8 = A4(
						$author$project$Data$PDF$showSignedSignatures,
						user.email,
						filledSignature,
						model.pdf,
						A2($elm$core$Maybe$withDefault, '', model.pdfBase64));
					var updatedPdf = _v8.a;
					var cmdMsg = _v8.b;
					var newCmdMsg = _Utils_eq(numberOfSignatureLoaded, numberOfSignatureNeeded) ? $elm$core$List$concat(
						_List_fromArray(
							[
								A2(
								$elm$core$List$map,
								function (stampID) {
									return A2(
										$elm$core$Task$attempt,
										A2(
											$elm$core$Basics$composeL,
											A2(
												$elm$core$Basics$composeL,
												A2($elm$core$Basics$composeL, $author$project$Types$OnViewDoc, $author$project$Type$ViewDocument$OnAuth),
												$author$project$Type$ViewDocument$OnLoaded),
											$author$project$Type$ViewDocument$LoadStampResult),
										A3($author$project$Data$Api$Stamp$File$authCall, user.jwt, appModel.apiEndPoint.stampFile, stampID));
								},
								stampIDs),
								_List_fromArray(
								[cmdMsg])
							])) : _List_fromArray(
						[cmdMsg]);
					return _Utils_Tuple2(
						updateAppModel(
							_Utils_update(
								model,
								{
									numberOfSignatureLoaded: numberOfSignatureLoaded,
									pdf: updatedPdf,
									selectedSignature: A3($author$project$Model$ViewDocument$getSelectedSignature, user, signatureModel, updatedPdf)
								})),
						$elm$core$Platform$Cmd$batch(newCmdMsg));
				} else {
					return _Utils_Tuple2(
						updateAppModel(
							_Utils_update(
								model,
								{
									banner: $elm$core$Maybe$Just(
										$author$project$Type$ViewDocument$Error($author$project$Type$ViewDocument$LoadSignature))
								})),
						$elm$core$Platform$Cmd$none);
				}
			case 'LoadStampResult':
				var result = msg.a;
				if (result.$ === 'Ok') {
					var stamp = result.a.stamp;
					var _v10 = A4(
						$author$project$Data$PDF$updateStamp,
						user.email,
						stamp,
						model.pdf,
						A2($elm$core$Maybe$withDefault, '', model.pdfBase64));
					var updatedPDF = _v10.a;
					var pdfCmd = _v10.b;
					var updatedCmd = model.displayViewer ? pdfCmd : $elm$core$Platform$Cmd$none;
					return _Utils_Tuple2(
						updateAppModel(
							_Utils_update(
								model,
								{
									pdf: updatedPDF,
									selectedStamp: A3($author$project$Model$ViewDocument$getSelectedStamp, user, stampModel, updatedPDF)
								})),
						updatedCmd);
				} else {
					return _Utils_Tuple2(
						updateAppModel(
							_Utils_update(
								model,
								{
									banner: $elm$core$Maybe$Just(
										$author$project$Type$ViewDocument$Error($author$project$Type$ViewDocument$LoadStamp))
								})),
						$elm$core$Platform$Cmd$none);
				}
			case 'LoadedUserStamp':
				var stamp = msg.a;
				var _v11 = model.selectedStamp;
				if (_v11.$ === 'Nothing') {
					return _Utils_Tuple2(appModel, $elm$core$Platform$Cmd$none);
				} else {
					var modelStamp = _v11.a;
					return _Utils_eq(
						$author$project$Data$PDF$Stamp$id(modelStamp),
						$author$project$Data$PDF$Stamp$id(stamp)) ? A4($author$project$Model$ViewDocument$setSelectedStampAndUpdatePDF, stamp, model, authModel.user, appModel) : _Utils_Tuple2(appModel, $elm$core$Platform$Cmd$none);
				}
			case 'OnSignatureClick':
				var filledSignature = msg.a;
				var _v12 = A4(
					$author$project$Data$PDF$updateCurrentUserSignedSignatures,
					user.email,
					filledSignature,
					model.pdf,
					A2($elm$core$Maybe$withDefault, '', model.pdfBase64));
				var updatedPdf = _v12.a;
				var cmdMsg = _v12.b;
				return _Utils_Tuple2(
					updateAppModel(
						_Utils_update(
							model,
							{
								pdf: updatedPdf,
								selectedSignature: $elm$core$Maybe$Just(filledSignature)
							})),
					cmdMsg);
			case 'OnStampClick':
				var stamp = msg.a;
				return A4($author$project$Model$ViewDocument$setSelectedStampAndUpdatePDF, stamp, model, authModel.user, appModel);
			case 'OnReceiveSelectedAnnotsData':
				var value = msg.a;
				if (_Utils_eq(
					$author$project$Data$PDF$status(model.pdf),
					$author$project$Data$PDF$Signing)) {
					var _v13 = model.selectedSignature;
					if (_v13.$ === 'Just') {
						var selectedSig = _v13.a;
						var _v14 = A8(
							$author$project$Data$PDF$verifyAnnotations,
							$elm$core$String$concat(
								_List_fromArray(
									[user.firstName, ' ', user.lastName])),
							user.email,
							appModel.currentTime,
							value,
							model.selectedStamp,
							selectedSig,
							model.pdf,
							A2($elm$core$Maybe$withDefault, '', model.pdfBase64));
						if (_v14.$ === 'Ok') {
							var _v15 = _v14.a;
							var updatedPdf = _v15.a;
							var cmdMsg = _v15.b;
							var editableTextContent = _v15.c;
							var updatedModel = function () {
								if (editableTextContent.$ === 'Just') {
									var _v17 = editableTextContent.a;
									var id = _v17.a;
									var content = _v17.b;
									return _Utils_update(
										model,
										{
											modal: $elm$core$Maybe$Just(
												A2($author$project$Type$ViewDocument$UpdateAnnotName, id, content)),
											textAnnotationName: content
										});
								} else {
									return model;
								}
							}();
							return _Utils_Tuple2(
								updateAppModel(
									_Utils_update(
										updatedModel,
										{pdf: updatedPdf})),
								cmdMsg);
						} else {
							var updateAnnotErr = _v14.a;
							return _Utils_Tuple2(
								updateAppModel(
									_Utils_update(
										model,
										{
											banner: $elm$core$Maybe$Just(
												$author$project$Type$ViewDocument$Error(
													$author$project$Type$ViewDocument$UpdateAnnotations(updateAnnotErr)))
										})),
								$elm$core$Platform$Cmd$none);
						}
					} else {
						return _Utils_Tuple2(appModel, $elm$core$Platform$Cmd$none);
					}
				} else {
					return _Utils_Tuple2(
						updateAppModel(model),
						$elm$core$Platform$Cmd$none);
				}
			case 'OnDocSubmit':
				var _v18 = A2($author$project$Data$PDF$hasVerifyAllAnnotations, user.email, model.pdf);
				if (_v18.$ === 'Ok') {
					return _Utils_Tuple2(
						updateAppModel(
							_Utils_update(
								model,
								{
									modal: $elm$core$Maybe$Just($author$project$Type$ViewDocument$Signing)
								})),
						A2(
							$elm$core$Task$attempt,
							A2(
								$elm$core$Basics$composeL,
								A2(
									$elm$core$Basics$composeL,
									A2($elm$core$Basics$composeL, $author$project$Types$OnViewDoc, $author$project$Type$ViewDocument$OnAuth),
									$author$project$Type$ViewDocument$OnLoaded),
								$author$project$Type$ViewDocument$OnDocSubmitResult),
							A7(
								$author$project$Data$Api$PDF$Update$authCall,
								user.jwt,
								appModel.apiEndPoint.updatePdf,
								user.email,
								$author$project$Data$Domain$selected(user.domains),
								model.pdf,
								model.password,
								appModel.timezoneOffset / 60)));
				} else {
					var _v19 = _v18.a;
					var unverifiedAnnot = _v19.a;
					var cmdMsg = _v19.b;
					return _Utils_Tuple2(
						updateAppModel(
							_Utils_update(
								model,
								{
									banner: $elm$core$Maybe$Just(
										$author$project$Type$ViewDocument$Error(
											$author$project$Type$ViewDocument$HasUnverifiedAnnotation(unverifiedAnnot)))
								})),
						cmdMsg);
				}
			case 'OnShowModal':
				var modal = msg.a;
				return _Utils_Tuple2(
					updateAppModel(
						_Utils_update(
							model,
							{
								modal: $elm$core$Maybe$Just(modal)
							})),
					$elm$core$Platform$Cmd$none);
			case 'OnErrorClose':
				return _Utils_Tuple2(
					updateAppModel(
						_Utils_update(
							model,
							{banner: $elm$core$Maybe$Nothing})),
					$elm$core$Platform$Cmd$none);
			case 'OnDocSubmitResult':
				var result = msg.a;
				var currentDocument = model.payload.document;
				var hasPassedNotarisationCriteria = currentDocument.requireNotarisation && _Utils_eq(
					$author$project$Model$ViewDocument$convertStringToNetwork(
						A2($elm$core$Maybe$withDefault, '', currentDocument.notarisationNetwork)),
					$author$project$Type$ViewDocument$Algorand);
				if (result.$ === 'Ok') {
					var value = result.a;
					return (hasPassedNotarisationCriteria || value.requireSignatureTimeStamping) ? _Utils_Tuple2(
						updateAppModel(
							_Utils_update(
								model,
								{
									modal: $elm$core$Maybe$Just($author$project$Type$ViewDocument$Success)
								})),
						A2(
							$elm$core$Task$perform,
							$author$project$Types$OnViewDoc,
							$elm$core$Task$succeed(
								$author$project$Type$ViewDocument$OnAuth(
									$author$project$Type$ViewDocument$OnLoaded(
										$author$project$Type$ViewDocument$OnSignatureTimestampingAlgorand(value.requireSignatureTimeStamping)))))) : _Utils_Tuple2(
						updateAppModel(
							_Utils_update(
								model,
								{
									modal: $elm$core$Maybe$Just($author$project$Type$ViewDocument$Success)
								})),
						$elm$core$Platform$Cmd$none);
				} else {
					var err = result.a;
					return _Utils_Tuple2(
						updateAppModel(
							_Utils_update(
								model,
								{
									banner: $elm$core$Maybe$Just(
										$author$project$Type$ViewDocument$Error(
											$author$project$Type$ViewDocument$SignApi(
												A2($author$project$Data$Api$authErrorToString, $author$project$Data$Api$PDF$Update$errorToString, err)))),
									modal: $elm$core$Maybe$Nothing
								})),
						$elm$core$Platform$Cmd$none);
				}
			case 'OnGenerateCredentialClick':
				return _Utils_Tuple2(
					_Utils_update(
						appModel,
						{
							sessionModel: $author$project$Types$Auth(
								_Utils_update(
									authModel,
									{
										viewDocModel: $author$project$Type$ViewDocument$GenerateCredential(model)
									}))
						}),
					$elm$core$Platform$Cmd$none);
			case 'OnBackClick':
				return _Utils_Tuple2(
					_Utils_update(
						appModel,
						{
							sessionModel: $author$project$Types$Auth(
								_Utils_update(
									authModel,
									{viewDocModel: $author$project$Type$ViewDocument$NotLoaded}))
						}),
					A2($elm$browser$Browser$Navigation$pushUrl, appModel.navKey, $author$project$Data$Route$routeUrl.completedDoc));
			case 'OnDownloadWrapDoc':
				return _Utils_Tuple2(
					updateAppModel(
						_Utils_update(
							model,
							{downloadStatus: $author$project$Type$ViewDocument$Downloading})),
					A2(
						$elm$core$Task$attempt,
						A2(
							$elm$core$Basics$composeL,
							A2(
								$elm$core$Basics$composeL,
								A2($elm$core$Basics$composeL, $author$project$Types$OnViewDoc, $author$project$Type$ViewDocument$OnAuth),
								$author$project$Type$ViewDocument$OnLoaded),
							$author$project$Type$ViewDocument$DownloadWrapDocResult),
						A3(
							$author$project$Data$Api$PDF$DownloadWrapDoc$authCall,
							user.jwt,
							appModel.apiEndPoint.downloadWrappedFile,
							$author$project$Data$PDF$id(model.pdf))));
			case 'DownloadWrapDocResult':
				var result = msg.a;
				if (result.$ === 'Ok') {
					var value = result.a;
					return _Utils_Tuple2(
						updateAppModel(
							_Utils_update(
								model,
								{downloadStatus: $author$project$Type$ViewDocument$NoDownload})),
						A3(
							$elm$file$File$Download$bytes,
							$author$project$Data$PDF$id(model.pdf) + '.json',
							'application/json',
							value));
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						updateAppModel(
							_Utils_update(
								model,
								{
									banner: $elm$core$Maybe$Just(
										$author$project$Type$ViewDocument$Error(
											$author$project$Type$ViewDocument$DownloadError(
												A2($author$project$Data$Api$authErrorToString, $author$project$Data$Api$PDF$DownloadWrapDoc$errorToString, error)))),
									downloadStatus: $author$project$Type$ViewDocument$NoDownload
								})),
						$elm$core$Platform$Cmd$none);
				}
			case 'OnDownloadCredentialFile':
				var credentialId = msg.a;
				return _Utils_Tuple2(
					updateAppModel(
						_Utils_update(
							model,
							{downloadStatus: $author$project$Type$ViewDocument$Downloading})),
					A2(
						$elm$core$Task$attempt,
						A2(
							$elm$core$Basics$composeL,
							A2(
								$elm$core$Basics$composeL,
								A2($elm$core$Basics$composeL, $author$project$Types$OnViewDoc, $author$project$Type$ViewDocument$OnAuth),
								$author$project$Type$ViewDocument$OnLoaded),
							$author$project$Type$ViewDocument$DownloadCredentialFileResult(credentialId)),
						A3($author$project$Data$Api$PDF$DownloadVerifiableCredentials$authCall, user.jwt, appModel.apiEndPoint.downloadCredentialFile, credentialId)));
			case 'DownloadCredentialFileResult':
				var credentialId = msg.a;
				var result = msg.b;
				if (result.$ === 'Ok') {
					var value = result.a;
					return _Utils_Tuple2(
						updateAppModel(
							_Utils_update(
								model,
								{downloadStatus: $author$project$Type$ViewDocument$NoDownload})),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A3($elm$file$File$Download$bytes, credentialId + '.json', 'application/json', value),
									A2(
									$elm$core$Task$perform,
									A2(
										$elm$core$Basics$composeL,
										A2(
											$elm$core$Basics$composeL,
											A2($elm$core$Basics$composeL, $author$project$Types$OnViewDoc, $author$project$Type$ViewDocument$OnAuth),
											$author$project$Type$ViewDocument$OnLoaded),
										$author$project$Type$ViewDocument$OnGetCredentialDownloadTime(credentialId)),
									$elm$time$Time$now)
								])));
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						updateAppModel(
							_Utils_update(
								model,
								{
									banner: $elm$core$Maybe$Just(
										$author$project$Type$ViewDocument$Error(
											$author$project$Type$ViewDocument$DownloadError(
												A2($author$project$Data$Api$authErrorToString, $author$project$Data$Api$PDF$DownloadVerifiableCredentials$errorToString, error)))),
									downloadStatus: $author$project$Type$ViewDocument$NoDownload
								})),
						$elm$core$Platform$Cmd$none);
				}
			case 'OnGetCredentialDownloadTime':
				var credentialId = msg.a;
				var currentTime = msg.b;
				var ownerName = model.payload.document.firstName + (' ' + model.payload.document.lastName);
				var chosenCredential = $elm$core$List$head(
					A2(
						$elm$core$List$filter,
						function (log) {
							return _Utils_eq(credentialId, log.id);
						},
						model.credentialData));
				var newLog = {
					action: $author$project$Data$Api$PDF$View$DownloadVerifiableCredential,
					createdAt: currentTime,
					credentialName: A2(
						$elm$core$Maybe$map,
						function ($) {
							return $.name;
						},
						chosenCredential),
					ipAddr: $elm$core$Maybe$Nothing,
					userId: authModel.user.id
				};
				var formattedLog = A4($author$project$Model$ViewDocument$toLogModel, model.payload.recipients, model.payload.domainOwners, ownerName, newLog);
				var newLogList = A2($elm$core$List$cons, formattedLog, model.logs);
				return _Utils_Tuple2(
					updateAppModel(
						_Utils_update(
							model,
							{logs: newLogList})),
					$elm$core$Platform$Cmd$none);
			case 'OnGetDocumentDownloadTime':
				var currentTime = msg.a;
				var ownerName = model.payload.document.firstName + (' ' + model.payload.document.lastName);
				var isDocumentCompleted = _Utils_eq(
					$author$project$Data$PDF$status(model.pdf),
					$author$project$Data$PDF$Completed);
				var newLog = {
					action: isDocumentCompleted ? $author$project$Data$Api$PDF$View$DownloadPDF : $author$project$Data$Api$PDF$View$DownloadIncompletePDF,
					createdAt: currentTime,
					credentialName: $elm$core$Maybe$Nothing,
					ipAddr: $elm$core$Maybe$Nothing,
					userId: authModel.user.id
				};
				var formattedLog = A4($author$project$Model$ViewDocument$toLogModel, model.payload.recipients, model.payload.domainOwners, ownerName, newLog);
				var newLogList = A2($elm$core$List$cons, formattedLog, model.logs);
				return _Utils_Tuple2(
					updateAppModel(
						_Utils_update(
							model,
							{logs: newLogList})),
					$elm$core$Platform$Cmd$none);
			case 'OnDownload':
				return _Utils_Tuple2(
					updateAppModel(
						_Utils_update(
							model,
							{downloadStatus: $author$project$Type$ViewDocument$Downloading})),
					A2(
						$elm$core$Task$attempt,
						A2(
							$elm$core$Basics$composeL,
							A2(
								$elm$core$Basics$composeL,
								A2($elm$core$Basics$composeL, $author$project$Types$OnViewDoc, $author$project$Type$ViewDocument$OnAuth),
								$author$project$Type$ViewDocument$OnLoaded),
							$author$project$Type$ViewDocument$DownloadResult),
						A5(
							$author$project$Data$Api$PDF$Download$authCall,
							user.jwt,
							appModel.apiEndPoint.downloadFile,
							$author$project$Data$Domain$selected(user.domains),
							$author$project$Data$PDF$id(model.pdf),
							appModel.timezoneOffset / 60)));
			case 'DownloadResult':
				var result = msg.a;
				if (result.$ === 'Ok') {
					var value = result.a;
					return _Utils_Tuple2(
						updateAppModel(
							_Utils_update(
								model,
								{downloadStatus: $author$project$Type$ViewDocument$NoDownload, modal: $elm$core$Maybe$Nothing})),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A3(
									$elm$file$File$Download$bytes,
									$author$project$Data$PDF$title(model.pdf) + '.pdf',
									'application/pdf',
									value),
									A2(
									$elm$core$Task$perform,
									A2(
										$elm$core$Basics$composeL,
										A2(
											$elm$core$Basics$composeL,
											A2($elm$core$Basics$composeL, $author$project$Types$OnViewDoc, $author$project$Type$ViewDocument$OnAuth),
											$author$project$Type$ViewDocument$OnLoaded),
										$author$project$Type$ViewDocument$OnGetDocumentDownloadTime),
									$elm$time$Time$now)
								])));
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						updateAppModel(
							_Utils_update(
								model,
								{
									banner: $elm$core$Maybe$Just(
										$author$project$Type$ViewDocument$Error(
											$author$project$Type$ViewDocument$DownloadError(
												A2($author$project$Data$Api$authErrorToString, $author$project$Data$Api$PDF$Download$errorToString, error)))),
									downloadStatus: $author$project$Type$ViewDocument$NoDownload
								})),
						$elm$core$Platform$Cmd$none);
				}
			case 'OnDeadlineInput':
				var date = msg.a;
				return _Utils_Tuple2(
					updateAppModel(
						_Utils_update(
							model,
							{newDueDate: date})),
					$elm$core$Platform$Cmd$none);
			case 'OnListCredentials':
				return _Utils_Tuple2(
					updateAppModel(
						_Utils_update(
							model,
							{modal: $elm$core$Maybe$Nothing})),
					A2(
						$elm$core$Task$attempt,
						A2(
							$elm$core$Basics$composeL,
							A2(
								$elm$core$Basics$composeL,
								A2($elm$core$Basics$composeL, $author$project$Types$OnViewDoc, $author$project$Type$ViewDocument$OnAuth),
								$author$project$Type$ViewDocument$OnLoaded),
							$author$project$Type$ViewDocument$OnListCredentialsResult),
						A3(
							$author$project$Data$Api$PDF$ListCredentials$authCall,
							user.jwt,
							appModel.apiEndPoint.getCredentialData,
							$author$project$Data$PDF$id(model.pdf))));
			case 'OnListCredentialsResult':
				var result = msg.a;
				if (result.$ === 'Ok') {
					var payload = result.a;
					return _Utils_Tuple2(
						updateAppModel(
							_Utils_update(
								model,
								{credentialData: payload.credentialData, modal: $elm$core$Maybe$Nothing})),
						A2(
							$elm$core$Task$perform,
							$author$project$Types$OnViewDoc,
							$elm$core$Task$succeed(
								$author$project$Type$ViewDocument$OnAuth(
									$author$project$Type$ViewDocument$OnLoaded(
										$author$project$Type$ViewDocument$OnShowModal($author$project$Type$ViewDocument$ShowCredential))))));
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						updateAppModel(
							_Utils_update(
								model,
								{
									banner: $elm$core$Maybe$Just(
										$author$project$Type$ViewDocument$Error(
											$author$project$Type$ViewDocument$SignApi(
												A2($author$project$Data$Api$authErrorToString, $author$project$Data$Api$PDF$ListCredentials$errorToString, error)))),
									modal: $elm$core$Maybe$Nothing
								})),
						$elm$core$Platform$Cmd$none);
				}
			case 'OnRequireNotarisation':
				return _Utils_Tuple2(
					updateAppModel(
						_Utils_update(
							model,
							{
								pdf: $author$project$Data$PDF$updateNotarisationStatus(model.pdf)
							})),
					A2(
						$elm$core$Task$attempt,
						A2(
							$elm$core$Basics$composeL,
							A2(
								$elm$core$Basics$composeL,
								A2($elm$core$Basics$composeL, $author$project$Types$OnViewDoc, $author$project$Type$ViewDocument$OnAuth),
								$author$project$Type$ViewDocument$OnLoaded),
							$author$project$Type$ViewDocument$NotarisationResult),
						A3(
							$author$project$Data$Api$PDF$NotariseCompletedDoc$authCall,
							user.jwt,
							appModel.apiEndPoint.notariseCompletedDocument,
							$author$project$Data$PDF$id(model.pdf))));
			case 'NotarisationResult':
				var result = msg.a;
				if (result.$ === 'Ok') {
					return _Utils_Tuple2(
						updateAppModel(
							_Utils_update(
								model,
								{
									modal: $elm$core$Maybe$Just(
										$author$project$Type$ViewDocument$NotariseSuccess(
											$author$project$Model$ViewDocument$convertStringToNetwork(authModel.user.notarisationNetwork)))
								})),
						$elm$core$Platform$Cmd$none);
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						updateAppModel(
							_Utils_update(
								model,
								{
									banner: $elm$core$Maybe$Just(
										$author$project$Type$ViewDocument$Error(
											$author$project$Type$ViewDocument$SignApi(
												A2($author$project$Data$Api$authErrorToString, $author$project$Data$Api$PDF$NotariseCompletedDoc$errorToString, error)))),
									modal: $elm$core$Maybe$Nothing
								})),
						$elm$core$Platform$Cmd$none);
				}
			case 'OnGetNotarisationPoints':
				return _Utils_Tuple2(
					updateAppModel(
						_Utils_update(
							model,
							{modal: $elm$core$Maybe$Nothing})),
					A2(
						$elm$core$Task$attempt,
						A2(
							$elm$core$Basics$composeL,
							A2(
								$elm$core$Basics$composeL,
								A2($elm$core$Basics$composeL, $author$project$Types$OnViewDoc, $author$project$Type$ViewDocument$OnAuth),
								$author$project$Type$ViewDocument$OnLoaded),
							$author$project$Type$ViewDocument$OnNotarisationPointsResponse),
						A2($author$project$Data$Api$PDF$NotarisationPoints$authCall, user.jwt, appModel.apiEndPoint.notariseDocumentCost)));
			case 'OnNotarisationPointsResponse':
				var result = msg.a;
				if (result.$ === 'Ok') {
					var payload = result.a;
					return _Utils_Tuple2(
						updateAppModel(
							_Utils_update(
								model,
								{
									algorandNotarisationCost: $elm$core$Maybe$Just(payload.algorandNotarisationCost),
									binanceNotarisationCost: $elm$core$Maybe$Just(payload.binanceNotarisationCost),
									modal: $elm$core$Maybe$Nothing,
									signPointsBalance: $elm$core$Maybe$Just(payload.signPointsBalance)
								})),
						A2(
							$elm$core$Task$perform,
							$author$project$Types$OnViewDoc,
							$elm$core$Task$succeed(
								$author$project$Type$ViewDocument$OnAuth(
									$author$project$Type$ViewDocument$OnLoaded(
										$author$project$Type$ViewDocument$OnShowModal(
											$author$project$Type$ViewDocument$NotariseDocument(
												$author$project$Model$ViewDocument$convertStringToNetwork(authModel.user.notarisationNetwork))))))));
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						updateAppModel(
							_Utils_update(
								model,
								{
									banner: $elm$core$Maybe$Just(
										$author$project$Type$ViewDocument$Error(
											$author$project$Type$ViewDocument$SignApi(
												A2($author$project$Data$Api$authErrorToString, $author$project$Data$Api$PDF$NotarisationPoints$errorToString, error)))),
									modal: $elm$core$Maybe$Nothing
								})),
						$elm$core$Platform$Cmd$none);
				}
			case 'OnDeleteDocumentResult':
				var result = msg.a;
				if (result.$ === 'Ok') {
					return _Utils_Tuple2(
						updateAppModel(
							_Utils_update(
								model,
								{
									modal: $elm$core$Maybe$Just($author$project$Type$ViewDocument$DeleteSuccess)
								})),
						$elm$core$Platform$Cmd$none);
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						updateAppModel(
							_Utils_update(
								model,
								{
									banner: $elm$core$Maybe$Just(
										$author$project$Type$ViewDocument$Error(
											$author$project$Type$ViewDocument$SignApi(
												A2($author$project$Data$Api$authErrorToString, $author$project$Data$Api$PDF$Delete$errorToString, error)))),
									modal: $elm$core$Maybe$Nothing
								})),
						$elm$core$Platform$Cmd$none);
				}
			case 'OnDeleteDocument':
				return _Utils_Tuple2(
					updateAppModel(
						_Utils_update(
							model,
							{modal: $elm$core$Maybe$Nothing})),
					A2(
						$elm$core$Task$attempt,
						A2(
							$elm$core$Basics$composeL,
							A2(
								$elm$core$Basics$composeL,
								A2($elm$core$Basics$composeL, $author$project$Types$OnViewDoc, $author$project$Type$ViewDocument$OnAuth),
								$author$project$Type$ViewDocument$OnLoaded),
							$author$project$Type$ViewDocument$OnDeleteDocumentResult),
						A3(
							$author$project$Data$Api$PDF$Delete$authCall,
							user.jwt,
							appModel.apiEndPoint.deleteDocument,
							$author$project$Data$PDF$id(model.pdf))));
			case 'DeleteDocumentClick':
				return _Utils_Tuple2(
					updateAppModel(
						_Utils_update(
							model,
							{
								modal: $elm$core$Maybe$Just($author$project$Type$ViewDocument$DeleteDocument)
							})),
					$elm$core$Platform$Cmd$none);
			case 'OnGetGenerateCredentialPoints':
				return $elm$core$String$isEmpty(model.credentialName) ? _Utils_Tuple2(
					updateAppModel(
						_Utils_update(
							model,
							{
								banner: $elm$core$Maybe$Just(
									$author$project$Type$ViewDocument$Error($author$project$Type$ViewDocument$NoCredentialName))
							})),
					$elm$core$Platform$Cmd$none) : ($elm$core$List$isEmpty(model.selectAnnotationIndex) ? _Utils_Tuple2(
					updateAppModel(
						_Utils_update(
							model,
							{
								banner: $elm$core$Maybe$Just(
									$author$project$Type$ViewDocument$Error($author$project$Type$ViewDocument$NoAnnotationSelected))
							})),
					$elm$core$Platform$Cmd$none) : _Utils_Tuple2(
					updateAppModel(
						_Utils_update(
							model,
							{modal: $elm$core$Maybe$Nothing})),
					A2(
						$elm$core$Task$attempt,
						A2(
							$elm$core$Basics$composeL,
							A2(
								$elm$core$Basics$composeL,
								A2($elm$core$Basics$composeL, $author$project$Types$OnViewDoc, $author$project$Type$ViewDocument$OnAuth),
								$author$project$Type$ViewDocument$OnGenerateCredential),
							$author$project$Type$ViewDocument$OnGetGenerateCredentialPointsResponse),
						A2($author$project$Data$Api$PDF$GenerateCredentialsPoints$authCall, user.jwt, appModel.apiEndPoint.generateCredentialCost))));
			case 'OnGetGenerateCredentialPointsResponse':
				var result = msg.a;
				if (result.$ === 'Ok') {
					var payload = result.a;
					return _Utils_Tuple2(
						updateAppModel(
							_Utils_update(
								model,
								{
									gcSignPointsBalance: $elm$core$Maybe$Just(payload.signPointsBalance),
									generateCredentialcost: $elm$core$Maybe$Just(payload.cost),
									modal: $elm$core$Maybe$Just($author$project$Type$ViewDocument$GenerateCredentials)
								})),
						$elm$core$Platform$Cmd$none);
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						updateAppModel(
							_Utils_update(
								model,
								{
									banner: $elm$core$Maybe$Just(
										$author$project$Type$ViewDocument$Error(
											$author$project$Type$ViewDocument$SignApi(
												A2($author$project$Data$Api$authErrorToString, $author$project$Data$Api$PDF$GenerateCredentialsPoints$errorToString, error)))),
									modal: $elm$core$Maybe$Nothing
								})),
						$elm$core$Platform$Cmd$none);
				}
			case 'OnDeadlineExtClick':
				return _Utils_Tuple2(
					updateAppModel(model),
					A2(
						$elm$core$Task$attempt,
						A2(
							$elm$core$Basics$composeL,
							A2(
								$elm$core$Basics$composeL,
								A2($elm$core$Basics$composeL, $author$project$Types$OnViewDoc, $author$project$Type$ViewDocument$OnAuth),
								$author$project$Type$ViewDocument$OnLoaded),
							$author$project$Type$ViewDocument$OnDeadlineExtResponse),
						A4(
							$author$project$Data$Api$PDF$DeadlineExtension$authCall,
							user.jwt,
							appModel.apiEndPoint.docDeadlineExt,
							$author$project$Data$PDF$id(model.pdf),
							model.newDueDate)));
			case 'OnDeadlineExtResponse':
				var result = msg.a;
				if (result.$ === 'Ok') {
					return _Utils_Tuple2(
						updateAppModel(
							_Utils_update(
								model,
								{
									banner: $elm$core$Maybe$Just(
										$author$project$Type$ViewDocument$Successful($author$project$Type$ViewDocument$DeadlineExt)),
									modal: $elm$core$Maybe$Nothing,
									pdf: A2($author$project$Data$PDF$changeDueDate, model.newDueDate, model.pdf)
								})),
						$elm$core$Platform$Cmd$none);
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						updateAppModel(
							_Utils_update(
								model,
								{
									banner: $elm$core$Maybe$Just(
										$author$project$Type$ViewDocument$Error(
											$author$project$Type$ViewDocument$DueDateExtensionError(
												A2($author$project$Data$Api$authErrorToString, $author$project$Data$Api$PDF$DeadlineExtension$errorToString, error))))
								})),
						$elm$core$Platform$Cmd$none);
				}
			case 'OnGenerateCredentialCheckBoxClick':
				var index = msg.a;
				var isAlreadySelected = A2(
					$elm$core$List$any,
					$elm$core$Basics$eq(index),
					model.selectAnnotationIndex);
				var newSelectedAnnotList = isAlreadySelected ? A2(
					$elm$core$List$filter,
					$elm$core$Basics$neq(index),
					model.selectAnnotationIndex) : A2($elm$core$List$cons, index, model.selectAnnotationIndex);
				return _Utils_Tuple2(
					updateAppModel(
						_Utils_update(
							model,
							{selectAnnotationIndex: newSelectedAnnotList})),
					$elm$core$Platform$Cmd$none);
			case 'OnGenerateCredentialsSubmit':
				return _Utils_Tuple2(
					updateAppModel(
						_Utils_update(
							model,
							{
								modal: $elm$core$Maybe$Just($author$project$Type$ViewDocument$GeneratingCredential)
							})),
					A2(
						$elm$core$Task$attempt,
						A2(
							$elm$core$Basics$composeL,
							A2(
								$elm$core$Basics$composeL,
								A2($elm$core$Basics$composeL, $author$project$Types$OnViewDoc, $author$project$Type$ViewDocument$OnAuth),
								$author$project$Type$ViewDocument$OnGenerateCredential),
							$author$project$Type$ViewDocument$OnGetGenerateCredentialResponse),
						A5($author$project$Data$Api$PDF$GenerateCredentials$authCall, user.jwt, appModel.apiEndPoint.generateCredentials, model.payload.document.id, model.credentialName, model.selectAnnotationIndex)));
			case 'OnGetGenerateCredentialResponse':
				var response = msg.a;
				if (response.$ === 'Ok') {
					var result = response.a;
					var ownerName = model.payload.document.firstName + (' ' + model.payload.document.lastName);
					var formattedLog = A4($author$project$Model$ViewDocument$toLogModel, model.payload.recipients, model.payload.domainOwners, ownerName, result.log);
					var newLogList = A2($elm$core$List$cons, formattedLog, model.logs);
					return _Utils_Tuple2(
						convertToLoadedModel(
							_Utils_update(
								model,
								{
									banner: $elm$core$Maybe$Just(
										$author$project$Type$ViewDocument$Successful($author$project$Type$ViewDocument$CredentialCreated)),
									logs: newLogList,
									modal: $elm$core$Maybe$Nothing
								})),
						$elm$core$Platform$Cmd$none);
				} else {
					var error = response.a;
					return _Utils_Tuple2(
						updateAppModel(
							_Utils_update(
								model,
								{
									banner: $elm$core$Maybe$Just(
										$author$project$Type$ViewDocument$Error(
											$author$project$Type$ViewDocument$GenerateCredentialApi(
												A2($author$project$Data$Api$authErrorToString, $author$project$Data$Api$PDF$GenerateCredentials$errorToString, error)))),
									modal: $elm$core$Maybe$Nothing
								})),
						$elm$core$Platform$Cmd$none);
				}
			case 'OnGenerateCredentialModalClose':
				return _Utils_Tuple2(
					updateAppModel(
						_Utils_update(
							model,
							{modal: $elm$core$Maybe$Nothing})),
					$elm$core$Platform$Cmd$none);
			case 'OnCredentialNameInput':
				var name = msg.a;
				return _Utils_Tuple2(
					updateAppModel(
						_Utils_update(
							model,
							{banner: $elm$core$Maybe$Nothing, credentialName: name})),
					$elm$core$Platform$Cmd$none);
			case 'OnReturnToViewDoc':
				return _Utils_Tuple2(
					convertToLoadedModel(model),
					$elm$core$Platform$Cmd$none);
			case 'OnHover':
				var placement = msg.a;
				var action = msg.b;
				var email = msg.c;
				if (action.$ === 'Leaves') {
					return _Utils_Tuple2(
						updateAppModel(
							_Utils_update(
								model,
								{toolTip: $author$project$Type$ViewDocument$NoHover})),
						$elm$core$Platform$Cmd$none);
				} else {
					return _Utils_Tuple2(
						updateAppModel(
							_Utils_update(
								model,
								{
									toolTip: A2($author$project$Type$ViewDocument$Hover, placement, email)
								})),
						$elm$core$Platform$Cmd$none);
				}
			case 'OnPasscodeInput':
				var value = msg.a;
				return $elm$core$String$isEmpty(value) ? _Utils_Tuple2(
					updateAppModel(
						_Utils_update(
							model,
							{passcode: $elm$core$Maybe$Nothing, passcodeError: $elm$core$Maybe$Nothing})),
					$elm$core$Platform$Cmd$none) : _Utils_Tuple2(
					updateAppModel(
						_Utils_update(
							model,
							{
								passcode: $elm$core$Maybe$Just(value)
							})),
					$elm$core$Platform$Cmd$none);
			case 'OnPasscodeSubmitResult':
				var result = msg.a;
				if (result.$ === 'Ok') {
					return _Utils_Tuple2(
						updateAppModel(
							_Utils_update(
								model,
								{modal: $elm$core$Maybe$Nothing, successSnackBar: $author$project$Material$Styled$Snackbar$Show})),
						A2(
							$author$project$Material$Styled$Snackbar$hide,
							2,
							A2(
								$elm$core$Basics$composeL,
								A2(
									$elm$core$Basics$composeL,
									A2($elm$core$Basics$composeL, $author$project$Types$OnViewDoc, $author$project$Type$ViewDocument$OnAuth),
									$author$project$Type$ViewDocument$OnLoaded),
								$author$project$Type$ViewDocument$SnackbarClose)));
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						updateAppModel(
							_Utils_update(
								model,
								{
									modal: $elm$core$Maybe$Just($author$project$Type$ViewDocument$RequiredPasscode),
									passcode: $elm$core$Maybe$Nothing,
									passcodeError: $elm$core$Maybe$Just(
										A2($author$project$Data$Api$authErrorToString, $author$project$Data$Api$PDF$ValidatePasscode$errorToString, error))
								})),
						$elm$core$Platform$Cmd$none);
				}
			case 'OnPasscodeSubmit':
				return _Utils_Tuple2(
					updateAppModel(
						_Utils_update(
							model,
							{
								modal: $elm$core$Maybe$Just(
									$author$project$Type$ViewDocument$LoadingState($author$project$Type$ViewDocument$Passcode))
							})),
					A2(
						$elm$core$Task$attempt,
						A2(
							$elm$core$Basics$composeL,
							A2(
								$elm$core$Basics$composeL,
								A2($elm$core$Basics$composeL, $author$project$Types$OnViewDoc, $author$project$Type$ViewDocument$OnAuth),
								$author$project$Type$ViewDocument$OnLoaded),
							$author$project$Type$ViewDocument$OnPasscodeSubmitResult),
						A4(
							$author$project$Data$Api$PDF$ValidatePasscode$authCall,
							user.jwt,
							appModel.apiEndPoint.validatePasscode,
							$author$project$Data$PDF$id(model.pdf),
							A2($elm$core$Maybe$withDefault, '', model.passcode))));
			case 'SnackbarClose':
				return _Utils_Tuple2(
					updateAppModel(
						_Utils_update(
							model,
							{successSnackBar: $author$project$Material$Styled$Snackbar$Hide})),
					$elm$core$Platform$Cmd$none);
			case 'OnNotariseDocumentAlgorand':
				return _Utils_Tuple2(
					updateAppModel(
						_Utils_update(
							model,
							{
								modal: $elm$core$Maybe$Just(
									$author$project$Type$ViewDocument$LoadingState($author$project$Type$ViewDocument$Notarisation)),
								pdf: $author$project$Data$PDF$updateNotarisationStatus(model.pdf)
							})),
					A2(
						$elm$core$Task$attempt,
						A2(
							$elm$core$Basics$composeL,
							A2(
								$elm$core$Basics$composeL,
								A2($elm$core$Basics$composeL, $author$project$Types$OnViewDoc, $author$project$Type$ViewDocument$OnAuth),
								$author$project$Type$ViewDocument$OnLoaded),
							$author$project$Type$ViewDocument$NotarisationAlgorandResult),
						A3(
							$author$project$Data$Api$PDF$NotariseCompletedDocAlgorand$authCall,
							user.jwt,
							appModel.apiEndPoint.notariseDocumentAlgorandNetwork,
							$author$project$Data$PDF$id(model.pdf))));
			case 'NotarisationAlgorandResult':
				var result = msg.a;
				if (result.$ === 'Ok') {
					return _Utils_Tuple2(
						updateAppModel(
							_Utils_update(
								model,
								{
									modal: $elm$core$Maybe$Just(
										$author$project$Type$ViewDocument$NotariseSuccess(
											$author$project$Model$ViewDocument$convertStringToNetwork(authModel.user.notarisationNetwork)))
								})),
						$elm$core$Platform$Cmd$none);
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						updateAppModel(
							_Utils_update(
								model,
								{
									banner: $elm$core$Maybe$Just(
										$author$project$Type$ViewDocument$Error(
											$author$project$Type$ViewDocument$SignApi(
												A2($author$project$Data$Api$authErrorToString, $author$project$Data$Api$PDF$NotariseCompletedDocAlgorand$errorToString, error)))),
									modal: $elm$core$Maybe$Nothing
								})),
						$elm$core$Platform$Cmd$none);
				}
			case 'OnMyAlgoWalletClick':
				return _Utils_Tuple2(
					updateAppModel(
						_Utils_update(
							model,
							{
								modal: $elm$core$Maybe$Just(
									$author$project$Type$ViewDocument$LoadingState($author$project$Type$ViewDocument$GetWallet)),
								selectedWallet: $elm$core$Maybe$Nothing
							})),
					$author$project$Model$ViewDocument$getAlgorandWalletAddress('viewDocument'));
			case 'AlgorandWalletError':
				var result = msg.a;
				var decodedMsg = function () {
					var _v34 = $author$project$Data$AlgorandWallet$decodeWalletError(result);
					if (_v34.$ === 'Ok') {
						var message = _v34.a;
						return message.error;
					} else {
						return 'Error getting wallet Addresses. Please try again.';
					}
				}();
				return _Utils_Tuple2(
					updateAppModel(
						_Utils_update(
							model,
							{
								modal: $elm$core$Maybe$Just(
									$author$project$Type$ViewDocument$NotariseDocument(
										$author$project$Model$ViewDocument$convertStringToNetwork(authModel.user.notarisationNetwork))),
								walletError: $elm$core$Maybe$Just(decodedMsg)
							})),
					$elm$core$Platform$Cmd$none);
			case 'OnGetAlgorandWalletAddress':
				var result = msg.a;
				var _v35 = $author$project$Data$AlgorandWallet$decodeWalletResult(result);
				if (_v35.$ === 'Ok') {
					var value = _v35.a;
					return _Utils_Tuple2(
						updateAppModel(
							_Utils_update(
								model,
								{algorandWalletAddresses: value.wallet, selectedWallet: $elm$core$Maybe$Nothing})),
						A2(
							$elm$core$Task$perform,
							$author$project$Types$OnViewDoc,
							$elm$core$Task$succeed(
								$author$project$Type$ViewDocument$OnAuth(
									$author$project$Type$ViewDocument$OnLoaded(
										$author$project$Type$ViewDocument$OnShowModal(
											$author$project$Type$ViewDocument$DisplayWallet(value.wallet)))))));
				} else {
					return _Utils_Tuple2(
						updateAppModel(model),
						$elm$core$Platform$Cmd$none);
				}
			case 'RetrieveUserAlgorandWallet':
				var walletList = msg.a;
				return _Utils_Tuple2(
					updateAppModel(
						_Utils_update(
							model,
							{
								algorandWalletAddresses: walletList,
								modal: $elm$core$Maybe$Just(
									$author$project$Type$ViewDocument$DisplayWallet(walletList)),
								selectedWallet: $elm$core$Maybe$Nothing
							})),
					$elm$core$Platform$Cmd$none);
			case 'OnSelectWallet':
				var addr = msg.a;
				return _Utils_Tuple2(
					updateAppModel(
						_Utils_update(
							model,
							{
								modal: $elm$core$Maybe$Just(
									$author$project$Type$ViewDocument$LoadingState($author$project$Type$ViewDocument$CheckWalletOptIn)),
								selectedWallet: $elm$core$Maybe$Just(addr)
							})),
					$author$project$Model$ViewDocument$checkOptIn(
						{location: 'viewDocument', selectedWallet: addr}));
			case 'OptInStatusResult':
				var result = msg.a;
				var _v36 = $author$project$Data$AlgorandWallet$decodeOptInStatusResult(result);
				if (_v36.$ === 'Ok') {
					var value = _v36.a;
					return _Utils_Tuple2(
						updateAppModel(
							_Utils_update(
								model,
								{
									modal: $elm$core$Maybe$Just(
										$author$project$Type$ViewDocument$DisplayWallet(model.algorandWalletAddresses)),
									needOptIn: value.needOptIn
								})),
						$elm$core$Platform$Cmd$none);
				} else {
					return _Utils_Tuple2(
						updateAppModel(model),
						$elm$core$Platform$Cmd$none);
				}
			case 'OptInAssetClick':
				return _Utils_Tuple2(
					updateAppModel(
						_Utils_update(
							model,
							{
								modal: $elm$core$Maybe$Just(
									$author$project$Type$ViewDocument$LoadingState($author$project$Type$ViewDocument$OptIn))
							})),
					$author$project$Model$ViewDocument$optInAsset(
						{
							location: 'viewDocument',
							userWalletAddress: A2($elm$core$Maybe$withDefault, '', model.selectedWallet)
						}));
			case 'OptInError':
				var result = msg.a;
				var userWallets = model.algorandWalletAddresses;
				var decodedMsg = function () {
					var _v37 = $author$project$Data$AlgorandWallet$decodeOptInError(result);
					if (_v37.$ === 'Ok') {
						var message = _v37.a;
						return message.error;
					} else {
						return 'Error opting-in. Please try again.';
					}
				}();
				return _Utils_Tuple2(
					updateAppModel(
						_Utils_update(
							model,
							{
								modal: $elm$core$Maybe$Just(
									$author$project$Type$ViewDocument$DisplayWallet(userWallets)),
								optInError: $elm$core$Maybe$Just(decodedMsg)
							})),
					$elm$core$Platform$Cmd$none);
			case 'GetOptInDetails':
				var result = msg.a;
				var _v38 = $author$project$Data$AlgorandWallet$decodeStatusResult(result);
				if (_v38.$ === 'Ok') {
					var value = _v38.a;
					return _Utils_Tuple2(
						updateAppModel(
							_Utils_update(
								model,
								{
									optInError: $elm$core$Maybe$Nothing,
									optInStatusCode: $elm$core$Maybe$Just(value.status)
								})),
						A2(
							$elm$core$Task$attempt,
							A2(
								$elm$core$Basics$composeL,
								A2(
									$elm$core$Basics$composeL,
									A2($elm$core$Basics$composeL, $author$project$Types$OnViewDoc, $author$project$Type$ViewDocument$OnAuth),
									$author$project$Type$ViewDocument$OnLoaded),
								$author$project$Type$ViewDocument$OnGetOptInDetailsResult),
							A6(
								$author$project$Data$Api$PDF$GetOptInDetails$authCall,
								user.jwt,
								appModel.apiEndPoint.getOptinDetails,
								$author$project$Data$PDF$id(model.pdf),
								value.transactionHash,
								value.blockNumber,
								A2($elm$core$Maybe$withDefault, '', model.selectedWallet))));
				} else {
					return _Utils_Tuple2(
						updateAppModel(model),
						$elm$core$Platform$Cmd$none);
				}
			case 'OnGetOptInDetailsResult':
				var result = msg.a;
				if (result.$ === 'Ok') {
					return _Utils_Tuple2(
						updateAppModel(
							_Utils_update(
								model,
								{
									modal: $elm$core$Maybe$Just($author$project$Type$ViewDocument$MakePayment)
								})),
						$elm$core$Platform$Cmd$none);
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						updateAppModel(
							_Utils_update(
								model,
								{
									banner: $elm$core$Maybe$Just(
										$author$project$Type$ViewDocument$Error(
											$author$project$Type$ViewDocument$SignApi(
												A2($author$project$Data$Api$authErrorToString, $author$project$Data$Api$PDF$GetOptInDetails$errorToString, error)))),
									modal: $elm$core$Maybe$Nothing
								})),
						$elm$core$Platform$Cmd$none);
				}
			case 'PaymentTransactionClick':
				return _Utils_Tuple2(
					updateAppModel(
						_Utils_update(
							model,
							{
								modal: $elm$core$Maybe$Just(
									$author$project$Type$ViewDocument$LoadingState($author$project$Type$ViewDocument$Pay))
							})),
					$author$project$Model$ViewDocument$paymentTransaction(
						{
							checksum: A2($elm$core$Maybe$withDefault, '', model.payload.document.checksum),
							docId: model.payload.document.id,
							isCompleted: true,
							noOfDocuments: 1,
							ownerId: model.payload.document.ownerId,
							recipients: A2(
								$elm$core$List$map,
								function (r) {
									return r.userId;
								},
								model.recipients),
							route: 'viewDocument',
							userWalletAddress: A2($elm$core$Maybe$withDefault, '', model.selectedWallet)
						}));
			case 'PaymentTransactionError':
				var result = msg.a;
				var decodedMsg = function () {
					var _v40 = $author$project$Data$AlgorandWallet$decodePaymentTransactionError(result);
					if (_v40.$ === 'Ok') {
						var message = _v40.a;
						return message.error;
					} else {
						return 'Error paying ASA. Please try again.';
					}
				}();
				return _Utils_Tuple2(
					updateAppModel(
						_Utils_update(
							model,
							{
								modal: $elm$core$Maybe$Just(
									$author$project$Type$ViewDocument$DisplayWallet(model.algorandWalletAddresses)),
								optInError: $elm$core$Maybe$Just(decodedMsg),
								selectedWallet: $elm$core$Maybe$Nothing
							})),
					$elm$core$Platform$Cmd$none);
			case 'SendNotarisationDetails':
				var result = msg.a;
				var _v41 = $author$project$Data$AlgorandWallet$decodeNotarisationResult(result);
				if (_v41.$ === 'Ok') {
					var value = _v41.a;
					return _Utils_Tuple2(
						updateAppModel(model),
						A2(
							$elm$core$Task$attempt,
							A2(
								$elm$core$Basics$composeL,
								A2(
									$elm$core$Basics$composeL,
									A2($elm$core$Basics$composeL, $author$project$Types$OnViewDoc, $author$project$Type$ViewDocument$OnAuth),
									$author$project$Type$ViewDocument$OnLoaded),
								$author$project$Type$ViewDocument$OnGetNotarisationDetailsResult),
							A8(
								$author$project$Data$Api$PDF$NotariseWithAlgorandWallet$authCall,
								user.jwt,
								appModel.apiEndPoint.getAlgorandNotarisationDetails,
								$author$project$Data$PDF$id(model.pdf),
								value.transactionHash,
								value.blockNumber,
								value.notarisationTimeStamp,
								A2($elm$core$Maybe$withDefault, '', model.selectedWallet),
								true)));
				} else {
					return _Utils_Tuple2(
						updateAppModel(model),
						$elm$core$Platform$Cmd$none);
				}
			case 'OnGetNotarisationDetailsResult':
				var result = msg.a;
				if (result.$ === 'Ok') {
					return _Utils_Tuple2(
						updateAppModel(
							_Utils_update(
								model,
								{
									modal: $elm$core$Maybe$Just(
										$author$project$Type$ViewDocument$NotariseSuccess(
											$author$project$Model$ViewDocument$convertStringToNetwork(authModel.user.notarisationNetwork)))
								})),
						$elm$core$Platform$Cmd$none);
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						updateAppModel(
							_Utils_update(
								model,
								{
									banner: $elm$core$Maybe$Just(
										$author$project$Type$ViewDocument$Error(
											$author$project$Type$ViewDocument$SignApi(
												A2($author$project$Data$Api$authErrorToString, $author$project$Data$Api$PDF$NotariseWithAlgorandWallet$errorToString, error)))),
									modal: $elm$core$Maybe$Nothing
								})),
						$elm$core$Platform$Cmd$none);
				}
			case 'OnWalletConnectClick':
				return _Utils_Tuple2(
					appModel,
					$author$project$Data$WalletConnect$walletConnectInit(
						$elm$json$Json$Encode$string('ViewDoc')));
			case 'OnWalletConnectAddressesReceive':
				var response = msg.a;
				var _v43 = $author$project$Data$Wallet$decodeWalletConnectResult(response);
				if (_v43.$ === 'Ok') {
					var result = _v43.a;
					return _Utils_Tuple2(
						updateAppModel(
							_Utils_update(
								model,
								{
									modal: $elm$core$Maybe$Just(
										$author$project$Type$ViewDocument$DisplayWalletConnectAddresses(result))
								})),
						$elm$core$Platform$Cmd$none);
				} else {
					return _Utils_Tuple2(appModel, $elm$core$Platform$Cmd$none);
				}
			case 'OnWallectConnectAddressSelect':
				var walletData = msg.a;
				return walletData.needOptIn ? _Utils_Tuple2(
					updateAppModel(
						_Utils_update(
							model,
							{
								modal: $elm$core$Maybe$Just(
									$author$project$Type$ViewDocument$LoadingState($author$project$Type$ViewDocument$OptIn))
							})),
					A2($author$project$Data$WalletConnect$startWalletConnectOptin, walletData.address, 'ViewDoc')) : _Utils_Tuple2(
					updateAppModel(
						_Utils_update(
							model,
							{
								modal: $elm$core$Maybe$Just(
									$author$project$Type$ViewDocument$LoadingState($author$project$Type$ViewDocument$RegisterWallet))
							})),
					A2(
						$elm$core$Task$attempt,
						A2(
							$elm$core$Basics$composeL,
							A2(
								$elm$core$Basics$composeL,
								A2($elm$core$Basics$composeL, $author$project$Types$OnViewDoc, $author$project$Type$ViewDocument$OnAuth),
								$author$project$Type$ViewDocument$OnLoaded),
							$author$project$Type$ViewDocument$OnWalletConnectRegisterApiResponse(walletData.address)),
						A4($author$project$Data$Api$Points$WalletRegistration$authCall, authModel.user.jwt, appModel.apiEndPoint.pointsWalletRegistration, walletData.address, 'Algorand')));
			case 'OnWalletConnectOptInCompleted':
				var result = msg.a;
				var _v44 = $author$project$Data$Wallet$decodeWalletAddress(result);
				if (_v44.$ === 'Ok') {
					var transactionDetails = _v44.a;
					return _Utils_Tuple2(
						updateAppModel(
							_Utils_update(
								model,
								{
									modal: $elm$core$Maybe$Just(
										$author$project$Type$ViewDocument$LoadingState($author$project$Type$ViewDocument$Notarisation))
								})),
						A2(
							$elm$core$Task$attempt,
							A2(
								$elm$core$Basics$composeL,
								A2(
									$elm$core$Basics$composeL,
									A2($elm$core$Basics$composeL, $author$project$Types$OnViewDoc, $author$project$Type$ViewDocument$OnAuth),
									$author$project$Type$ViewDocument$OnLoaded),
								$author$project$Type$ViewDocument$OnWalletOptInApiResponse(transactionDetails.address)),
							A6(
								$author$project$Data$Api$PDF$GetOptInDetails$authCall,
								user.jwt,
								appModel.apiEndPoint.getOptinDetails,
								$author$project$Data$PDF$id(model.pdf),
								transactionDetails.id,
								transactionDetails.block,
								transactionDetails.address)));
				} else {
					var error = _v44.a;
					return _Utils_Tuple2(appModel, $elm$core$Platform$Cmd$none);
				}
			case 'OnWalletOptInApiResponse':
				var address = msg.a;
				var result = msg.b;
				if (result.$ === 'Ok') {
					return _Utils_Tuple2(
						updateAppModel(
							_Utils_update(
								model,
								{
									banner: $elm$core$Maybe$Just(
										$author$project$Type$ViewDocument$Successful($author$project$Type$ViewDocument$WalletAdded)),
									modal: $elm$core$Maybe$Just(
										$author$project$Type$ViewDocument$NotariseDocument($author$project$Type$ViewDocument$Algorand))
								})),
						$elm$core$Platform$Cmd$none);
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						updateAppModel(
							_Utils_update(
								model,
								{
									banner: $elm$core$Maybe$Just(
										$author$project$Type$ViewDocument$Error(
											$author$project$Type$ViewDocument$SignApi(
												A2($author$project$Data$Api$authErrorToString, $author$project$Data$Api$PDF$GetOptInDetails$errorToString, error)))),
									modal: $elm$core$Maybe$Nothing
								})),
						$elm$core$Platform$Cmd$none);
				}
			case 'OnWalletConnectNotarizationCompleted':
				var result = msg.a;
				var _v46 = $author$project$Data$Wallet$decodeNotarizationDetails(result);
				if (_v46.$ === 'Ok') {
					var data = _v46.a;
					return _Utils_Tuple2(
						appModel,
						A2(
							$elm$core$Task$attempt,
							A2(
								$elm$core$Basics$composeL,
								A2(
									$elm$core$Basics$composeL,
									A2($elm$core$Basics$composeL, $author$project$Types$OnViewDoc, $author$project$Type$ViewDocument$OnAuth),
									$author$project$Type$ViewDocument$OnLoaded),
								$author$project$Type$ViewDocument$OnGetNotarisationDetailsResult),
							A8(
								$author$project$Data$Api$PDF$NotariseWithAlgorandWallet$authCall,
								user.jwt,
								appModel.apiEndPoint.getAlgorandNotarisationDetails,
								$author$project$Data$PDF$id(model.pdf),
								data.id,
								data.block,
								data.timestamp,
								data.address,
								true)));
				} else {
					var error = _v46.a;
					return _Utils_Tuple2(appModel, $elm$core$Platform$Cmd$none);
				}
			case 'OnWalletConnectRegisterApiResponse':
				var address = msg.a;
				var response = msg.b;
				if (response.$ === 'Ok') {
					return _Utils_Tuple2(
						updateAppModel(
							_Utils_update(
								model,
								{
									banner: $elm$core$Maybe$Just(
										$author$project$Type$ViewDocument$Successful($author$project$Type$ViewDocument$WalletAdded)),
									modal: $elm$core$Maybe$Just(
										$author$project$Type$ViewDocument$NotariseDocument($author$project$Type$ViewDocument$Algorand))
								})),
						$elm$core$Platform$Cmd$none);
				} else {
					var error = response.a;
					return _Utils_Tuple2(appModel, $elm$core$Platform$Cmd$none);
				}
			case 'OnWalletConnectNotarizationClick':
				var address = msg.a;
				return _Utils_Tuple2(
					appModel,
					A8(
						$author$project$Data$WalletConnect$initWalletConnectNotarization,
						address,
						model.payload.document.checksum,
						model.payload.document.id,
						model.payload.document.ownerId,
						A2(
							$elm$core$List$map,
							function (r) {
								return r.userId;
							},
							model.recipients),
						true,
						'ViewDoc',
						true));
			case 'OnRestartWalletConnectInit':
				return _Utils_Tuple2(
					appModel,
					$author$project$Data$WalletConnect$walletConnectInit(
						$elm$json$Json$Encode$string('ViewDoc')));
			case 'OnRestartWalletConnectNotarization':
				var response = msg.a;
				var walletAddress = function () {
					var _v48 = $author$project$Data$Wallet$decodeReturnWalletAddress(response);
					if (_v48.$ === 'Ok') {
						var address = _v48.a;
						return address;
					} else {
						return A2($elm$core$Maybe$withDefault, '', user.algorandWalletAddress);
					}
				}();
				return _Utils_Tuple2(
					appModel,
					A8(
						$author$project$Data$WalletConnect$initWalletConnectNotarization,
						walletAddress,
						model.payload.document.checksum,
						model.payload.document.id,
						model.payload.document.ownerId,
						A2(
							$elm$core$List$map,
							function (r) {
								return r.userId;
							},
							model.recipients),
						true,
						'ViewDoc',
						true));
			case 'OnWalletConnectError':
				return _Utils_Tuple2(
					updateAppModel(
						_Utils_update(
							model,
							{
								banner: $elm$core$Maybe$Just(
									$author$project$Type$ViewDocument$Error(
										$author$project$Type$ViewDocument$Notarization('There was an issue with the notarization. Please try again.'))),
								modal: $elm$core$Maybe$Nothing
							})),
					$elm$core$Platform$Cmd$none);
			case 'OnNotarizationStart':
				return _Utils_Tuple2(
					updateAppModel(
						_Utils_update(
							model,
							{
								modal: $elm$core$Maybe$Just(
									$author$project$Type$ViewDocument$LoadingState($author$project$Type$ViewDocument$Notarisation))
							})),
					$elm$core$Platform$Cmd$none);
			case 'OnListSigningEvents':
				return _Utils_Tuple2(
					updateAppModel(
						_Utils_update(
							model,
							{modal: $elm$core$Maybe$Nothing})),
					A2(
						$elm$core$Task$attempt,
						A2(
							$elm$core$Basics$composeL,
							A2(
								$elm$core$Basics$composeL,
								A2($elm$core$Basics$composeL, $author$project$Types$OnViewDoc, $author$project$Type$ViewDocument$OnAuth),
								$author$project$Type$ViewDocument$OnLoaded),
							$author$project$Type$ViewDocument$OnListSigningEventsResult),
						A3(
							$author$project$Data$Api$ListNotariseSigningEvents$authCall,
							user.jwt,
							appModel.apiEndPoint.listSigningEventData,
							$author$project$Data$PDF$id(model.pdf))));
			case 'OnListSigningEventsResult':
				var result = msg.a;
				if (result.$ === 'Ok') {
					var payload = result.a;
					return _Utils_Tuple2(
						updateAppModel(
							_Utils_update(
								model,
								{modal: $elm$core$Maybe$Nothing, signingEventsData: payload.signingEventData})),
						A2(
							$elm$core$Task$perform,
							$author$project$Types$OnViewDoc,
							$elm$core$Task$succeed(
								$author$project$Type$ViewDocument$OnAuth(
									$author$project$Type$ViewDocument$OnLoaded(
										$author$project$Type$ViewDocument$OnShowModal($author$project$Type$ViewDocument$ShowSigningData))))));
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						updateAppModel(
							_Utils_update(
								model,
								{
									banner: $elm$core$Maybe$Just(
										$author$project$Type$ViewDocument$Error(
											$author$project$Type$ViewDocument$SignApi(
												A2($author$project$Data$Api$authErrorToString, $author$project$Data$Api$ListNotariseSigningEvents$errorToString, error)))),
									modal: $elm$core$Maybe$Nothing
								})),
						$elm$core$Platform$Cmd$none);
				}
			case 'OnSendEmailReminder':
				return _Utils_Tuple2(
					updateAppModel(
						_Utils_update(
							model,
							{
								modal: $elm$core$Maybe$Just(
									$author$project$Type$ViewDocument$LoadingState($author$project$Type$ViewDocument$SendingEmail))
							})),
					A2(
						$elm$core$Task$attempt,
						A2(
							$elm$core$Basics$composeL,
							A2(
								$elm$core$Basics$composeL,
								A2($elm$core$Basics$composeL, $author$project$Types$OnViewDoc, $author$project$Type$ViewDocument$OnAuth),
								$author$project$Type$ViewDocument$OnLoaded),
							$author$project$Type$ViewDocument$OnSendEmailReminderResult),
						A3(
							$author$project$Data$Api$PDF$EmailReminder$authCall,
							user.jwt,
							appModel.apiEndPoint.sendEmailReminder,
							$author$project$Data$PDF$id(model.pdf))));
			case 'OnSendEmailReminderResult':
				var result = msg.a;
				if (result.$ === 'Ok') {
					return _Utils_Tuple2(
						appModel,
						A2(
							$elm$core$Task$perform,
							$author$project$Types$OnViewDoc,
							$elm$core$Task$succeed(
								$author$project$Type$ViewDocument$OnAuth(
									$author$project$Type$ViewDocument$OnLoaded(
										$author$project$Type$ViewDocument$OnShowModal($author$project$Type$ViewDocument$EmailReminderSuccess))))));
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						updateAppModel(
							_Utils_update(
								model,
								{
									banner: $elm$core$Maybe$Just(
										$author$project$Type$ViewDocument$Error(
											$author$project$Type$ViewDocument$SignApi(
												A2($author$project$Data$Api$authErrorToString, $author$project$Data$Api$PDF$EmailReminder$errorToString, error)))),
									modal: $elm$core$Maybe$Nothing
								})),
						$elm$core$Platform$Cmd$none);
				}
			case 'OnTextFieldInput':
				var annotId = msg.a;
				var value = msg.b;
				return _Utils_Tuple2(
					updateAppModel(
						_Utils_update(
							model,
							{textAnnotationName: value})),
					$elm$core$Platform$Cmd$none);
			case 'OnTextFieldNameConfirm':
				return _Utils_Tuple2(
					updateAppModel(
						_Utils_update(
							model,
							{modal: $elm$core$Maybe$Nothing, textAnnotationName: ''})),
					$elm$core$Platform$Cmd$none);
			case 'OnTextFieldNameCancel':
				return _Utils_Tuple2(
					updateAppModel(
						_Utils_update(
							model,
							{modal: $elm$core$Maybe$Nothing, textAnnotationName: ''})),
					$elm$core$Platform$Cmd$none);
			case 'OnTextFieldNameOnBlur':
				var annotId = msg.a;
				var _v51 = A5(
					$author$project$Data$PDF$updateTextAnnotContent,
					annotId,
					model.textAnnotationName,
					user.email,
					model.pdf,
					A2($elm$core$Maybe$withDefault, '', model.pdfBase64));
				var updatedPdf = _v51.a;
				var cmdMsg = _v51.b;
				return _Utils_Tuple2(
					updateAppModel(
						_Utils_update(
							model,
							{pdf: updatedPdf})),
					cmdMsg);
			case 'OnAcceptESignDisclaimerUserClick':
				return _Utils_Tuple2(
					appModel,
					A2(
						$elm$core$Task$attempt,
						A2(
							$elm$core$Basics$composeL,
							A2(
								$elm$core$Basics$composeL,
								A2($elm$core$Basics$composeL, $author$project$Types$OnViewDoc, $author$project$Type$ViewDocument$OnAuth),
								$author$project$Type$ViewDocument$OnLoaded),
							$author$project$Type$ViewDocument$OnAcceptESignDisclaimerUserResult),
						A2($author$project$Data$Api$UpdateESignatureDisclaimer$authCall, user.jwt, appModel.apiEndPoint.updateESignatureDisclaimer)));
			case 'OnAcceptESignDisclaimerUserResult':
				var currentUser_ = authModel.user;
				var updatedUser = _Utils_update(
					currentUser_,
					{
						eSignDisclaimer: true,
						eSignDisclaimerTimestamp: $elm$core$Maybe$Just(appModel.currentTime)
					});
				return _Utils_Tuple2(
					_Utils_update(
						appModel,
						{
							sessionModel: $author$project$Types$Auth(
								_Utils_update(
									authModel,
									{user: updatedUser}))
						}),
					$author$project$Data$User$store(updatedUser));
			case 'ToggleUserAcceptESignDisclaimer':
				return _Utils_Tuple2(
					updateAppModel(
						_Utils_update(
							model,
							{
								eDisclaimerCheckbox: _Utils_eq(model.eDisclaimerCheckbox, $author$project$Type$ViewDocument$Accepted) ? $author$project$Type$ViewDocument$NotAccepted : $author$project$Type$ViewDocument$Accepted
							})),
					$elm$core$Platform$Cmd$none);
			case 'OnNewSignatureAddition':
				var _v52 = signatureModel;
				var signatures = _v52.signatures;
				var newlyCreatedSignature = $elm$core$List$head(signatures);
				var newModel = function () {
					if (newlyCreatedSignature.$ === 'Just') {
						var signature = newlyCreatedSignature.a;
						return updateAppModel(
							_Utils_update(
								model,
								{
									selectedSignature: $elm$core$Maybe$Just(
										A3($author$project$Data$PDF$Signature$create, signature.id, signature.name, signature.data))
								}));
					} else {
						return appModel;
					}
				}();
				return _Utils_Tuple2(
					newModel,
					A2(
						$elm$core$Task$perform,
						$author$project$Types$OnViewDoc,
						$elm$core$Task$succeed(
							$author$project$Type$ViewDocument$OnAuth(
								$author$project$Type$ViewDocument$OnLoaded(
									$author$project$Type$ViewDocument$OnShowModal($author$project$Type$ViewDocument$SignatureStampModal))))));
			case 'OnReceiveCheckboxClickData':
				var value = msg.a;
				var _v54 = $author$project$Model$ViewDocument$decodeCheckboxClickData(value);
				if (_v54.$ === 'Ok') {
					var results = _v54.a;
					var updatedpdf = A4($author$project$Data$PDF$updateCheckboxAnnotation, user.email, results.id, results.value, model.pdf);
					return _Utils_Tuple2(
						updateAppModel(
							_Utils_update(
								model,
								{pdf: updatedpdf})),
						A2($author$project$Data$PDF$Port$updatePlaceholderAnnot, results.id, results.value));
				} else {
					return _Utils_Tuple2(appModel, $elm$core$Platform$Cmd$none);
				}
			case 'OnSignatureTimestampingAlgorand':
				var requireSignatureTimeStamping = msg.a;
				return _Utils_Tuple2(
					appModel,
					A2(
						$elm$core$Task$attempt,
						A2(
							$elm$core$Basics$composeL,
							A2(
								$elm$core$Basics$composeL,
								A2($elm$core$Basics$composeL, $author$project$Types$OnViewDoc, $author$project$Type$ViewDocument$OnAuth),
								$author$project$Type$ViewDocument$OnLoaded),
							$author$project$Type$ViewDocument$OnSignatureTimestampingAlgorandResult),
						A4(
							$author$project$Data$Api$PDF$SignatureTimestamping$authCall,
							user.jwt,
							appModel.apiEndPoint.signatureTimestamping,
							$author$project$Data$PDF$id(model.pdf),
							requireSignatureTimeStamping)));
			case 'OnSignatureTimestampingAlgorandResult':
				var result = msg.a;
				if (result.$ === 'Ok') {
					return _Utils_Tuple2(appModel, $elm$core$Platform$Cmd$none);
				} else {
					return _Utils_Tuple2(appModel, $elm$core$Platform$Cmd$none);
				}
			case 'OnDownloadCert':
				return _Utils_Tuple2(
					appModel,
					A2(
						$elm$core$Task$attempt,
						A2(
							$elm$core$Basics$composeL,
							A2(
								$elm$core$Basics$composeL,
								A2($elm$core$Basics$composeL, $author$project$Types$OnViewDoc, $author$project$Type$ViewDocument$OnAuth),
								$author$project$Type$ViewDocument$OnLoaded),
							$author$project$Type$ViewDocument$OnDownloadCertResult),
						A4(
							$author$project$Data$Api$PDF$DownloadCert$authCall,
							user.jwt,
							appModel.apiEndPoint.downloadCompletedCert,
							$author$project$Data$PDF$id(model.pdf),
							appModel.timezoneOffset / 60)));
			case 'OnDownloadCertResult':
				var result = msg.a;
				if (result.$ === 'Ok') {
					var value = result.a;
					return _Utils_Tuple2(
						appModel,
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A3(
									$elm$file$File$Download$bytes,
									$author$project$Data$PDF$title(model.pdf) + '_Certificate.pdf',
									'application/pdf',
									value)
								])));
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						updateAppModel(
							_Utils_update(
								model,
								{
									banner: $elm$core$Maybe$Just(
										$author$project$Type$ViewDocument$Error(
											$author$project$Type$ViewDocument$DownloadError(
												A2($author$project$Data$Api$authErrorToString, $author$project$Data$Api$PDF$DownloadCert$errorToString, error))))
								})),
						$elm$core$Platform$Cmd$none);
				}
			case 'OnRetryNotarisation':
				return _Utils_Tuple2(
					updateAppModel(
						_Utils_update(
							model,
							{
								modal: $elm$core$Maybe$Just(
									$author$project$Type$ViewDocument$LoadingState($author$project$Type$ViewDocument$Notarisation))
							})),
					A2(
						$elm$core$Task$attempt,
						A2(
							$elm$core$Basics$composeL,
							A2(
								$elm$core$Basics$composeL,
								A2($elm$core$Basics$composeL, $author$project$Types$OnViewDoc, $author$project$Type$ViewDocument$OnAuth),
								$author$project$Type$ViewDocument$OnLoaded),
							$author$project$Type$ViewDocument$OnRetryNotarisationResult),
						A3(
							$author$project$Data$Api$PDF$RetryNotarisation$authCall,
							user.jwt,
							appModel.apiEndPoint.retryNotarisation,
							$author$project$Data$PDF$id(model.pdf))));
			case 'OnRetryNotarisationResult':
				var result = msg.a;
				if (result.$ === 'Ok') {
					return _Utils_Tuple2(
						appModel,
						A2(
							$elm$core$Task$perform,
							$author$project$Types$OnViewDoc,
							$elm$core$Task$succeed(
								$author$project$Type$ViewDocument$OnAuth(
									$author$project$Type$ViewDocument$OnLoaded(
										$author$project$Type$ViewDocument$OnShowModal(
											$author$project$Type$ViewDocument$NotariseSuccess($author$project$Type$ViewDocument$Algorand)))))));
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						updateAppModel(
							_Utils_update(
								model,
								{
									banner: $elm$core$Maybe$Just(
										$author$project$Type$ViewDocument$Error(
											$author$project$Type$ViewDocument$SignApi(
												A2($author$project$Data$Api$authErrorToString, $author$project$Data$Api$PDF$RetryNotarisation$errorToString, error)))),
									modal: $elm$core$Maybe$Nothing
								})),
						$elm$core$Platform$Cmd$none);
				}
			default:
				var value = msg.a;
				var updatedPDF = A3($author$project$Data$PDF$updateSignatureWidth, value, user.email, model.pdf);
				return _Utils_Tuple2(
					updateAppModel(
						_Utils_update(
							model,
							{pdf: updatedPDF})),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Model$ViewDocument$updateAuthModel = F3(
	function (msg, authModel, model) {
		var updateCurrentModel = function (currentModel) {
			return _Utils_update(
				model,
				{
					sessionModel: $author$project$Types$Auth(
						_Utils_update(
							authModel,
							{viewDocModel: currentModel}))
				});
		};
		var updateAppModel = F2(
			function (docId, m) {
				return _Utils_update(
					model,
					{
						sessionModel: $author$project$Types$Auth(
							_Utils_update(
								authModel,
								{
									viewDocModel: A2($author$project$Type$ViewDocument$UpdateUserCurrentName, docId, m)
								}))
					});
			});
		var _v0 = authModel;
		var viewDocModel = _v0.viewDocModel;
		var user = _v0.user;
		var signatureModel = _v0.signatureModel;
		switch (msg.$) {
			case 'OnUnload':
				return _Utils_Tuple2(
					updateCurrentModel($author$project$Type$ViewDocument$NotLoaded),
					$author$project$Data$PDF$unloadPDF(_Utils_Tuple0));
			case 'ValidateESignDisclaimer':
				var tokenOrDocId = msg.a;
				return authModel.user.eSignDisclaimer ? _Utils_Tuple2(model, $elm$core$Platform$Cmd$none) : _Utils_Tuple2(
					_Utils_update(
						model,
						{
							sessionModel: $author$project$Types$Auth(
								_Utils_update(
									authModel,
									{
										viewDocModel: A2($author$project$Type$ViewDocument$LoadWithESignatureDisclaimer, tokenOrDocId, $author$project$Type$ViewDocument$NotAccepted)
									}))
						}),
					$elm$core$Platform$Cmd$none);
			case 'CheckUserUpdatedName':
				var tokenOrDocId = msg.a;
				if (authModel.user.updateNameConfirmation) {
					return _Utils_Tuple2(
						model,
						A2(
							$elm$core$Task$perform,
							$author$project$Types$OnViewDoc,
							$elm$core$Task$succeed(
								$author$project$Type$ViewDocument$OnAuth(
									$author$project$Type$ViewDocument$LoadDocument(tokenOrDocId)))));
				} else {
					var newModel = {firstNameError: $elm$core$Maybe$Nothing, firstNameInput: user.firstName, lastNameError: $elm$core$Maybe$Nothing, lastNameInput: user.lastName, modalOpen: true};
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								sessionModel: $author$project$Types$Auth(
									_Utils_update(
										authModel,
										{
											viewDocModel: A2($author$project$Type$ViewDocument$UpdateUserCurrentName, tokenOrDocId, newModel)
										}))
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 'OnNameSubmit':
				var docID = msg.a;
				if (viewDocModel.$ === 'UpdateUserCurrentName') {
					var documentID = viewDocModel.a;
					var currentModel = viewDocModel.b;
					return _Utils_Tuple2(
						A2(
							updateAppModel,
							documentID,
							_Utils_update(
								currentModel,
								{modalOpen: false})),
						A2(
							$elm$core$Task$attempt,
							A2(
								$elm$core$Basics$composeL,
								A2($elm$core$Basics$composeL, $author$project$Types$OnViewDoc, $author$project$Type$ViewDocument$OnAuth),
								$author$project$Type$ViewDocument$OnNameSubmitResult(docID)),
							A4($author$project$Data$Api$UpdateUserName$authCall, user.jwt, model.apiEndPoint.updateUserFirstNameLastName, currentModel.firstNameInput, currentModel.lastNameInput)));
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 'OnNameSubmitResult':
				var docID = msg.a;
				var result = msg.b;
				if (viewDocModel.$ === 'UpdateUserCurrentName') {
					var documentID = viewDocModel.a;
					var currentModel = viewDocModel.b;
					if (result.$ === 'Ok') {
						return _Utils_Tuple2(
							A2(
								updateAppModel,
								documentID,
								_Utils_update(
									currentModel,
									{modalOpen: false})),
							A2(
								$elm$core$Task$perform,
								$author$project$Types$OnViewDoc,
								$elm$core$Task$succeed(
									$author$project$Type$ViewDocument$OnAuth(
										$author$project$Type$ViewDocument$LoadDocument(docID)))));
					} else {
						return _Utils_Tuple2(
							A2(
								updateAppModel,
								documentID,
								_Utils_update(
									currentModel,
									{modalOpen: true})),
							$elm$core$Platform$Cmd$none);
					}
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 'OnNameInput':
				var inputfield = msg.a;
				var value = msg.b;
				if (viewDocModel.$ === 'UpdateUserCurrentName') {
					var documentID = viewDocModel.a;
					var currentModel = viewDocModel.b;
					if (inputfield.$ === 'FirstName') {
						return _Utils_Tuple2(
							A2(
								updateAppModel,
								documentID,
								_Utils_update(
									currentModel,
									{firstNameInput: value, modalOpen: true})),
							$elm$core$Platform$Cmd$none);
					} else {
						return _Utils_Tuple2(
							A2(
								updateAppModel,
								documentID,
								_Utils_update(
									currentModel,
									{lastNameInput: value, modalOpen: true})),
							$elm$core$Platform$Cmd$none);
					}
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 'OnNameFieldBlur':
				if (viewDocModel.$ === 'UpdateUserCurrentName') {
					var documentID = viewDocModel.a;
					var currentModel = viewDocModel.b;
					return _Utils_Tuple2(
						A2(
							updateAppModel,
							documentID,
							_Utils_update(
								currentModel,
								{
									firstNameError: $author$project$Model$ViewDocument$validateNameInputField(currentModel.firstNameInput),
									lastNameError: $author$project$Model$ViewDocument$validateNameInputField(currentModel.lastNameInput),
									modalOpen: true
								})),
						$elm$core$Platform$Cmd$none);
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 'LoadDocument':
				var docID = msg.a;
				return _Utils_Tuple2(
					updateCurrentModel($author$project$Type$ViewDocument$Loading),
					A2(
						$elm$core$Task$attempt,
						A2(
							$elm$core$Basics$composeL,
							A2($elm$core$Basics$composeL, $author$project$Types$OnViewDoc, $author$project$Type$ViewDocument$OnAuth),
							$author$project$Type$ViewDocument$LoadDocumentResult),
						A4(
							$author$project$Data$Api$PDF$View$authCall,
							user.jwt,
							model.apiEndPoint.viewPdf,
							docID,
							$author$project$Data$Domain$selected(user.domains))));
			case 'LoadDocumentResult':
				var result = msg.a;
				if (result.$ === 'Ok') {
					var pdfPayload = result.a;
					var _v9 = A4(
						$author$project$Data$PDF$initFilledPDF,
						user,
						$author$project$Data$Domain$selected(user.domains),
						model.currentTime,
						pdfPayload);
					if (_v9.$ === 'Ok') {
						var pdf = _v9.a;
						var recipients = A2(
							$elm$core$List$map,
							$author$project$Model$ViewDocument$getRecipientWithStatus(pdfPayload.annotations),
							A2(
								$elm$core$List$map,
								function (recipient) {
									return {email: recipient.email, name: recipient.firstName + (' ' + recipient.lastName), role: recipient.role, signOrder: recipient.signOrder, userId: recipient.userId, verifyMobilePhone: recipient.verifyMobilePhone, verifyMyInfo: recipient.verifyMyInfo, verifyPassbase: recipient.verifyPassbase, verifyStripe: recipient.verifyStripe, verifyWallet: recipient.verifyWallet};
								},
								pdfPayload.recipients));
						var ownerName = pdfPayload.document.firstName + (' ' + pdfPayload.document.lastName);
						var logs = A2(
							$elm$core$List$map,
							function (log) {
								return A4($author$project$Model$ViewDocument$toLogModel, pdfPayload.recipients, pdfPayload.domainOwners, ownerName, log);
							},
							pdfPayload.logs);
						var displayPDFViewer = function () {
							var _v10 = _Utils_Tuple2(
								pdfPayload.document.saveDocument,
								$author$project$Data$PDF$status(pdf));
							if (_v10.a) {
								return true;
							} else {
								switch (_v10.b.$) {
									case 'Viewing':
										return true;
									case 'Signing':
										var _v11 = _v10.b;
										return true;
									case 'Completed':
										var _v12 = _v10.b;
										return false;
									case 'Expired':
										var _v13 = _v10.b;
										return true;
									default:
										return true;
								}
							}
						}();
						var currentUser = A2(
							$author$project$Data$PDF$User$registered,
							$elm$core$Maybe$Nothing,
							A9($author$project$Data$PDF$User$info, user.email, user.firstName, user.lastName, user.trustScore.stripe, user.trustScore.passbase, user.trustScore.mobilePhone, user.trustScore.wallet, user.trustScore.myInfo, $author$project$Data$PDF$User$Blue));
						var cmd = displayPDFViewer ? _List_fromArray(
							[
								A5($author$project$Data$PDF$loadPDF, model.apiEndPoint.pdfFile, user.jwt, model.currentTime, currentUser, pdf),
								A2(
								$elm$core$Task$perform,
								$author$project$Types$OnSignature,
								$elm$core$Task$succeed($author$project$Type$Signature$OnViewRendered)),
								$author$project$Data$WalletConnect$walletConnectKillSession(_Utils_Tuple0),
								$author$project$Model$ViewDocument$displayViewDocumentMenuAdsContent(
								$elm$json$Json$Encode$bool(user.showAds))
							]) : _List_fromArray(
							[
								A2(
								$elm$core$Task$perform,
								$author$project$Types$OnViewDoc,
								$elm$core$Task$succeed(
									$author$project$Type$ViewDocument$OnAuth(
										$author$project$Type$ViewDocument$OnLoaded(
											$author$project$Type$ViewDocument$OnReceiveDocumentLoaded(
												$elm$json$Json$Encode$string('Loaded')))))),
								A2(
								$elm$core$Task$perform,
								$author$project$Types$OnSignature,
								$elm$core$Task$succeed($author$project$Type$Signature$OnViewRendered)),
								$author$project$Data$WalletConnect$walletConnectKillSession(_Utils_Tuple0),
								$author$project$Model$ViewDocument$displayViewDocumentMenuAdsContent(
								$elm$json$Json$Encode$bool(user.showAds))
							]);
						return _Utils_Tuple2(
							updateCurrentModel(
								$author$project$Type$ViewDocument$Loaded(
									{
										algorandNotarisationCost: $elm$core$Maybe$Nothing,
										algorandWalletAddresses: _List_Nil,
										banner: $elm$core$Maybe$Nothing,
										binanceNotarisationCost: $elm$core$Maybe$Nothing,
										credentialData: _List_Nil,
										credentialName: '',
										displayViewer: displayPDFViewer,
										downloadStatus: $author$project$Type$ViewDocument$NoDownload,
										eDisclaimerCheckbox: $author$project$Type$ViewDocument$NotAccepted,
										gcSignPointsBalance: $elm$core$Maybe$Nothing,
										generateCredentialcost: $elm$core$Maybe$Nothing,
										logs: logs,
										modal: $elm$core$Maybe$Just(
											$author$project$Type$ViewDocument$LoadingState($author$project$Type$ViewDocument$Document)),
										needOptIn: false,
										newDueDate: A2(
											$elm$core$Maybe$withDefault,
											'',
											$author$project$Data$PDF$dueDate(pdf)),
										numberOfSignatureLoaded: 0,
										optInError: $elm$core$Maybe$Nothing,
										optInStatusCode: $elm$core$Maybe$Nothing,
										passcode: $elm$core$Maybe$Nothing,
										passcodeError: $elm$core$Maybe$Nothing,
										password: $elm$core$Maybe$Nothing,
										passwordError: $elm$core$Maybe$Nothing,
										payload: pdfPayload,
										pdf: pdf,
										pdfBase64: $elm$core$Maybe$Nothing,
										recipients: recipients,
										selectAnnotationIndex: _List_Nil,
										selectedSignature: $elm$core$Maybe$Nothing,
										selectedStamp: $elm$core$Maybe$Nothing,
										selectedWallet: $elm$core$Maybe$Nothing,
										signPointsBalance: $elm$core$Maybe$Nothing,
										signingEventsData: _List_Nil,
										successSnackBar: $author$project$Material$Styled$Snackbar$Hide,
										textAnnotationName: '',
										toolTip: $author$project$Type$ViewDocument$NoHover,
										walletError: $elm$core$Maybe$Nothing
									})),
							$elm$core$Platform$Cmd$batch(cmd));
					} else {
						var err = _v9.a;
						return _Utils_Tuple2(
							updateCurrentModel(
								$author$project$Type$ViewDocument$LoadingDecodeError(err)),
							$elm$core$Platform$Cmd$none);
					}
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						updateCurrentModel(
							$author$project$Type$ViewDocument$LoadingApiError(error)),
						$elm$core$Platform$Cmd$none);
				}
			case 'OnRefreshClick':
				return _Utils_Tuple2(model, $elm$browser$Browser$Navigation$reload);
			case 'OnNavigateToDashboard':
				return _Utils_Tuple2(
					model,
					A2($elm$browser$Browser$Navigation$pushUrl, model.navKey, $author$project$Data$Route$routeUrl.dashboard));
			case 'OnLoaded':
				var loadedMsg = msg.a;
				switch (viewDocModel.$) {
					case 'Loaded':
						var loadedModel = viewDocModel.a;
						return A4($author$project$Model$ViewDocument$updateAuthLoadedModel, loadedMsg, loadedModel, authModel, model);
					case 'GenerateCredential':
						var loadedModel = viewDocModel.a;
						return A4($author$project$Model$ViewDocument$updateAuthLoadedModel, loadedMsg, loadedModel, authModel, model);
					default:
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 'OnGenerateCredential':
				var loadedMsg = msg.a;
				switch (viewDocModel.$) {
					case 'GenerateCredential':
						var loadedModel = viewDocModel.a;
						return A4($author$project$Model$ViewDocument$updateAuthLoadedModel, loadedMsg, loadedModel, authModel, model);
					case 'Loaded':
						var loadedModel = viewDocModel.a;
						return A4($author$project$Model$ViewDocument$updateAuthLoadedModel, loadedMsg, loadedModel, authModel, model);
					default:
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 'OnNavigateToRegister':
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 'OnAcceptESignDisclaimerClick':
				var docId = msg.a;
				return _Utils_Tuple2(
					updateCurrentModel($author$project$Type$ViewDocument$Loading),
					A2(
						$elm$core$Task$attempt,
						A2(
							$elm$core$Basics$composeL,
							A2($elm$core$Basics$composeL, $author$project$Types$OnViewDoc, $author$project$Type$ViewDocument$OnAuth),
							$author$project$Type$ViewDocument$OnAcceptESignDisclaimerResult(docId)),
						A2($author$project$Data$Api$UpdateESignatureDisclaimer$authCall, user.jwt, model.apiEndPoint.updateESignatureDisclaimer)));
			case 'OnAcceptESignDisclaimerResult':
				var currentUser_ = authModel.user;
				var updatedUser = _Utils_update(
					currentUser_,
					{
						eSignDisclaimer: true,
						eSignDisclaimerTimestamp: $elm$core$Maybe$Just(model.currentTime)
					});
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							sessionModel: $author$project$Types$Auth(
								_Utils_update(
									authModel,
									{user: updatedUser}))
						}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$Data$User$store(updatedUser),
								$elm$core$Platform$Cmd$none
							])));
			default:
				return _Utils_Tuple2(
					updateCurrentModel(
						$author$project$Model$ViewDocument$toggleESignDisclaimerStatus(viewDocModel)),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Model$ViewDocument$update = F4(
	function (initAnonymousModel, msg, sessionModel, model) {
		var loginRoute = A2($elm$browser$Browser$Navigation$pushUrl, model.navKey, $author$project$Data$Route$routeUrl.login);
		switch (msg.$) {
			case 'ValidateDocumentToken':
				var tokenOrDocId = msg.a;
				return A2($elm$core$String$contains, '.', tokenOrDocId) ? _Utils_Tuple2(
					model,
					A2(
						$elm$core$Task$attempt,
						A2($elm$core$Basics$composeL, $author$project$Types$OnViewDoc, $author$project$Type$ViewDocument$ValidateDocumentTokenResult),
						A2($author$project$Data$Api$PDF$ValidateDocumentToken$call, tokenOrDocId, model.apiEndPoint.validateDocumentToken))) : _Utils_Tuple2(
					model,
					A2(
						$elm$core$Task$perform,
						$author$project$Types$OnViewDoc,
						$elm$core$Task$succeed(
							$author$project$Type$ViewDocument$OnAuth(
								$author$project$Type$ViewDocument$CheckUserUpdatedName(tokenOrDocId)))));
			case 'ValidateDocumentTokenResult':
				var payload = msg.a;
				if (payload.$ === 'Ok') {
					var result = payload.a;
					switch (sessionModel.$) {
						case 'Auth':
							var authModel = sessionModel.a;
							return (!_Utils_eq(authModel.user.id, result.user.id)) ? _Utils_Tuple2(
								_Utils_update(
									model,
									{
										sessionModel: $author$project$Types$Auth(
											_Utils_update(
												authModel,
												{
													viewDocModel: $author$project$Type$ViewDocument$VerificationError($author$project$Type$ViewDocument$NotTokenUser)
												}))
									}),
								$elm$core$Platform$Cmd$none) : _Utils_Tuple2(
								model,
								A2(
									$elm$core$Task$perform,
									$author$project$Types$OnViewDoc,
									$elm$core$Task$succeed(
										$author$project$Type$ViewDocument$OnAuth(
											$author$project$Type$ViewDocument$CheckUserUpdatedName(result.docId)))));
						case 'Anonymous':
							return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
						case 'NoAuth':
							var _v3 = initAnonymousModel(result.user);
							var anonymousModel = _v3.a;
							var anonymousCmd = _v3.b;
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{
										sessionModel: $author$project$Types$Anonymous(anonymousModel)
									}),
								$elm$core$Platform$Cmd$batch(
									_List_fromArray(
										[
											anonymousCmd,
											A2(
											$elm$core$Task$perform,
											$author$project$Types$OnViewDoc,
											$elm$core$Task$succeed(
												$author$project$Type$ViewDocument$OnAuth(
													$author$project$Type$ViewDocument$CheckUserUpdatedName(result.docId))))
										])));
						default:
							return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					}
				} else {
					switch (sessionModel.$) {
						case 'Auth':
							var authModel = sessionModel.a;
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{
										sessionModel: $author$project$Types$Auth(
											_Utils_update(
												authModel,
												{
													viewDocModel: $author$project$Type$ViewDocument$VerificationError($author$project$Type$ViewDocument$TokenDoesNotExist)
												}))
									}),
								$elm$core$Platform$Cmd$none);
						case 'Anonymous':
							var anonymousModel = sessionModel.a;
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{
										sessionModel: $author$project$Types$Anonymous(
											_Utils_update(
												anonymousModel,
												{
													viewDocModel: $author$project$Type$ViewDocument$VerificationError($author$project$Type$ViewDocument$TokenDoesNotExist)
												}))
									}),
								$elm$core$Platform$Cmd$none);
						case 'NoAuth':
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{sessionModel: $author$project$Types$InvalidAuth}),
								$elm$core$Platform$Cmd$none);
						default:
							return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					}
				}
			case 'OnAuth':
				var authMsg = msg.a;
				switch (sessionModel.$) {
					case 'Auth':
						var authModel = sessionModel.a;
						return A3($author$project$Model$ViewDocument$updateAuthModel, authMsg, authModel, model);
					case 'Anonymous':
						var anonymousModel = sessionModel.a;
						return A3($author$project$Model$ViewDocument$updateAnonymousModel, authMsg, anonymousModel, model);
					case 'NoAuth':
						return _Utils_Tuple2(model, loginRoute);
					default:
						return _Utils_Tuple2(model, loginRoute);
				}
			default:
				switch (sessionModel.$) {
					case 'Auth':
						return _Utils_Tuple2(model, loginRoute);
					case 'Anonymous':
						return _Utils_Tuple2(model, loginRoute);
					case 'NoAuth':
						return _Utils_Tuple2(model, loginRoute);
					default:
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{sessionModel: $author$project$Types$NoAuth}),
							loginRoute);
				}
		}
	});
var $author$project$Type$ViewNotarisationInfo$CheckingVerification = {$: 'CheckingVerification'};
var $author$project$Type$ViewNotarisationInfo$Error = function (a) {
	return {$: 'Error', a: a};
};
var $author$project$Type$ViewNotarisationInfo$GotFiles = function (a) {
	return {$: 'GotFiles', a: a};
};
var $author$project$Type$ViewNotarisationInfo$OnReadPDFData = function (a) {
	return {$: 'OnReadPDFData', a: a};
};
var $author$project$Type$ViewNotarisationInfo$OnVerifyChecksumResult = function (a) {
	return {$: 'OnVerifyChecksumResult', a: a};
};
var $author$project$Type$ViewNotarisationInfo$VerificationSuccess = function (a) {
	return {$: 'VerificationSuccess', a: a};
};
var $author$project$Data$Api$PDF$GetNotarisationInfo$Payload = F3(
	function (docId, transactionHash, notarisationTimeStamp) {
		return {docId: docId, notarisationTimeStamp: notarisationTimeStamp, transactionHash: transactionHash};
	});
var $author$project$Data$Api$PDF$GetNotarisationInfo$dataDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'notarisationTimeStamp',
	$elm$json$Json$Decode$nullable(
		A2($elm$json$Json$Decode$map, $elm$time$Time$millisToPosix, $elm$json$Json$Decode$int)),
	$elm$core$Maybe$Nothing,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'transactionHash',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
		$elm$core$Maybe$Nothing,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'docId',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Data$Api$PDF$GetNotarisationInfo$Payload))));
var $author$project$Data$Api$PDF$GetNotarisationInfo$encode = function (checksum) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'checksum',
				$elm$json$Json$Encode$string(checksum))
			]));
};
var $author$project$Data$Api$PDF$GetNotarisationInfo$DELETED_DOCUMENT = {$: 'DELETED_DOCUMENT'};
var $author$project$Data$Api$PDF$GetNotarisationInfo$INVALID_DOCUMENT = {$: 'INVALID_DOCUMENT'};
var $author$project$Data$Api$PDF$GetNotarisationInfo$JWT_ERROR = {$: 'JWT_ERROR'};
var $author$project$Data$Api$PDF$GetNotarisationInfo$NOT_NOTARISED = {$: 'NOT_NOTARISED'};
var $author$project$Data$Api$PDF$GetNotarisationInfo$errorDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (errorCode) {
		switch (errorCode) {
			case 'INVALID_DOCUMENT':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$PDF$GetNotarisationInfo$INVALID_DOCUMENT);
			case 'DELETED_DOCUMENT':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$PDF$GetNotarisationInfo$DELETED_DOCUMENT);
			case 'NOT_NOTARISED':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$PDF$GetNotarisationInfo$NOT_NOTARISED);
			case 'JWT_ERROR':
				return $elm$json$Json$Decode$succeed($author$project$Data$Api$PDF$GetNotarisationInfo$JWT_ERROR);
			default:
				return $elm$json$Json$Decode$fail('Invalid error code: ' + errorCode);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Data$Api$PDF$GetNotarisationInfo$authCall = F3(
	function (jwt, endPoint, checksum) {
		return A5(
			$author$project$Data$Api$authCall,
			jwt,
			endPoint,
			$author$project$Data$Api$PDF$GetNotarisationInfo$errorDecoder,
			$author$project$Data$Api$PDF$GetNotarisationInfo$dataDecoder,
			$author$project$Data$Api$PDF$GetNotarisationInfo$encode(checksum));
	});
var $author$project$Data$PDFChecksumReader$Checksum = function (checksum) {
	return {checksum: checksum};
};
var $author$project$Data$PDFChecksumReader$dataDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'checksum',
	$elm$json$Json$Decode$string,
	$elm$json$Json$Decode$succeed($author$project$Data$PDFChecksumReader$Checksum));
var $author$project$Data$PDFChecksumReader$decodeJsonData = function (checksum) {
	var _v0 = A2($elm$json$Json$Decode$decodeValue, $author$project$Data$PDFChecksumReader$dataDecoder, checksum);
	if (_v0.$ === 'Ok') {
		var results = _v0.a;
		return $elm$core$Result$Ok(results);
	} else {
		return $elm$core$Result$Err('Error getting checksum.');
	}
};
var $author$project$Data$Api$PDF$GetNotarisationInfo$errorToString = function (error) {
	switch (error.$) {
		case 'INVALID_DOCUMENT':
			return 'Document not notarised on Algorand blockchain.';
		case 'JWT_ERROR':
			return 'Invalid JWT, unauthorised user.';
		case 'DELETED_DOCUMENT':
			return 'Document has been deleted.';
		default:
			return 'Document not notarised on Algorand blockchain.';
	}
};
var $author$project$Model$ViewNotarisationInfo$readPDFFile = _Platform_outgoingPort('readPDFFile', $elm$json$Json$Encode$string);
var $author$project$Model$ViewNotarisationInfo$update = F3(
	function (msg, authModel, model) {
		var viewNotarisationInfoModel = authModel.viewNotarisationInfoModel;
		switch (msg.$) {
			case 'OnPageEnter':
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							sessionModel: $author$project$Types$Auth(
								_Utils_update(
									authModel,
									{
										viewNotarisationInfoModel: _Utils_update(
											viewNotarisationInfoModel,
											{base64File: $elm$core$Maybe$Nothing, checksum: $elm$core$Maybe$Nothing, file: $elm$core$Maybe$Nothing, fileHover: false, status: $author$project$Type$ViewNotarisationInfo$NoFile})
									}))
						}),
					$elm$core$Platform$Cmd$none);
			case 'PickFile':
				return _Utils_Tuple2(
					model,
					A2(
						$elm$core$Platform$Cmd$map,
						$author$project$Types$OnAuth,
						A2(
							$elm$core$Platform$Cmd$map,
							$author$project$Types$OnViewNotarisationInfo,
							A2(
								$elm$file$File$Select$file,
								_List_fromArray(
									['application/pdf']),
								$author$project$Type$ViewNotarisationInfo$GotFiles))));
			case 'GotFiles':
				var file = msg.a;
				return ($elm$file$File$mime(file) === 'application/pdf') ? _Utils_Tuple2(
					_Utils_update(
						model,
						{
							sessionModel: $author$project$Types$Auth(
								_Utils_update(
									authModel,
									{
										viewNotarisationInfoModel: _Utils_update(
											viewNotarisationInfoModel,
											{status: $author$project$Type$ViewNotarisationInfo$CheckingVerification})
									}))
						}),
					A2(
						$elm$core$Task$perform,
						A2(
							$elm$core$Basics$composeL,
							A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnViewNotarisationInfo),
							$author$project$Type$ViewNotarisationInfo$OnReadPDFData),
						$elm$file$File$toUrl(file))) : _Utils_Tuple2(
					_Utils_update(
						model,
						{
							sessionModel: $author$project$Types$Auth(
								_Utils_update(
									authModel,
									{
										viewNotarisationInfoModel: _Utils_update(
											viewNotarisationInfoModel,
											{
												status: $author$project$Type$ViewNotarisationInfo$Error('Incorrect File Format')
											})
									}))
						}),
					$elm$core$Platform$Cmd$none);
			case 'OnDragEnter':
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							sessionModel: $author$project$Types$Auth(
								_Utils_update(
									authModel,
									{
										viewNotarisationInfoModel: _Utils_update(
											viewNotarisationInfoModel,
											{fileHover: true})
									}))
						}),
					$elm$core$Platform$Cmd$none);
			case 'OnDragLeave':
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							sessionModel: $author$project$Types$Auth(
								_Utils_update(
									authModel,
									{
										viewNotarisationInfoModel: _Utils_update(
											viewNotarisationInfoModel,
											{fileHover: false})
									}))
						}),
					$elm$core$Platform$Cmd$none);
			case 'OnReadPDFData':
				var base64Data = msg.a;
				return _Utils_Tuple2(
					model,
					$author$project$Model$ViewNotarisationInfo$readPDFFile(base64Data));
			case 'OnVerifyChecksum':
				var jsonData = msg.a;
				var _v1 = $author$project$Data$PDFChecksumReader$decodeJsonData(jsonData);
				if (_v1.$ === 'Ok') {
					var data = _v1.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								sessionModel: $author$project$Types$Auth(
									_Utils_update(
										authModel,
										{
											viewNotarisationInfoModel: _Utils_update(
												viewNotarisationInfoModel,
												{
													checksum: $elm$core$Maybe$Just(data.checksum)
												})
										}))
							}),
						A2(
							$elm$core$Task$attempt,
							A2(
								$elm$core$Basics$composeL,
								A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnViewNotarisationInfo),
								$author$project$Type$ViewNotarisationInfo$OnVerifyChecksumResult),
							A3($author$project$Data$Api$PDF$GetNotarisationInfo$authCall, authModel.user.jwt, model.apiEndPoint.getNotarisationInfo, data.checksum)));
				} else {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								sessionModel: $author$project$Types$Auth(
									_Utils_update(
										authModel,
										{
											viewNotarisationInfoModel: _Utils_update(
												viewNotarisationInfoModel,
												{
													checksum: $elm$core$Maybe$Nothing,
													status: $author$project$Type$ViewNotarisationInfo$Error('Invalid PDF File')
												})
										}))
							}),
						$elm$core$Platform$Cmd$none);
				}
			default:
				var response = msg.a;
				if (response.$ === 'Ok') {
					var result = response.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								sessionModel: $author$project$Types$Auth(
									_Utils_update(
										authModel,
										{
											viewNotarisationInfoModel: _Utils_update(
												viewNotarisationInfoModel,
												{
													status: $author$project$Type$ViewNotarisationInfo$VerificationSuccess(result)
												})
										}))
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var error = response.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								sessionModel: $author$project$Types$Auth(
									_Utils_update(
										authModel,
										{
											viewNotarisationInfoModel: _Utils_update(
												viewNotarisationInfoModel,
												{
													status: $author$project$Type$ViewNotarisationInfo$Error(
														A2($author$project$Data$Api$authErrorToString, $author$project$Data$Api$PDF$GetNotarisationInfo$errorToString, error))
												})
										}))
							}),
						$elm$core$Platform$Cmd$none);
				}
		}
	});
var $author$project$Model$updateMenu = F3(
	function (menuStatus, authModel, model) {
		if (menuStatus.$ === 'SelectDomain') {
			var domain = menuStatus.a;
			var _v1 = authModel;
			var user = _v1.user;
			var updatedUser = _Utils_update(
				user,
				{
					domains: A2($author$project$Data$Domain$select, domain, user.domains)
				});
			var updatedAuthModel = _Utils_update(
				authModel,
				{menu: $author$project$Types$ClosedMenu, user: updatedUser});
			var _v2 = A4($author$project$Model$Theme$init, model.appDomain, model.theme.themeHost, domain, model.baseHost);
			var themeModel = _v2.a;
			var themeCmd = _v2.b;
			var _v3 = A5($author$project$Model$Route$calculate, model.apiEndPoint, model.appDomain, model.navKey, model.sessionModel, model.route);
			var route = _v3.a;
			var routeCmd = _v3.b;
			var _v4 = A2($author$project$Model$BusinessProfile$init, model.apiEndPoint, domain);
			var businessProfileModel = _v4.a;
			var businessProfileCmd = _v4.b;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						businessProfileModel: businessProfileModel,
						route: route,
						sessionModel: $author$project$Types$Auth(updatedAuthModel),
						theme: themeModel
					}),
				$elm$core$Platform$Cmd$batch(
					_List_fromArray(
						[
							routeCmd,
							$author$project$Data$User$store(updatedUser),
							themeCmd,
							businessProfileCmd
						])));
		} else {
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						sessionModel: $author$project$Types$Auth(
							_Utils_update(
								authModel,
								{menu: menuStatus}))
					}),
				$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Model$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 'OnUrlChange':
				var url = msg.a;
				return A2($author$project$Model$Route$onUrlChange, url, model);
			case 'OnUrlRequest':
				var urlRequest = msg.a;
				return A2($author$project$Model$Route$onUrlRequest, urlRequest, model);
			case 'GetTimezone':
				var zone = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{timezone: zone}),
					$elm$core$Platform$Cmd$none);
			case 'GetZoneName':
				var zoneName = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							timezoneName: $elm$core$Maybe$Just(zoneName)
						}),
					$elm$core$Platform$Cmd$none);
			case 'OnTheme':
				var themeMsg = msg.a;
				return A2($author$project$Model$Theme$update, themeMsg, model);
			case 'OnLogin':
				var loginMsg = msg.a;
				return A3(
					$author$project$Model$Login$update,
					A3(
						$author$project$Model$initAuthModel,
						model.defaultLanguage,
						model.apiEndPoint,
						$elm$core$Maybe$Just(model.theme)),
					loginMsg,
					model);
			case 'OnResetPassword':
				var resetMsg = msg.a;
				return A2($author$project$Model$ResetPassword$update, resetMsg, model);
			case 'OnResendActivation':
				var activationMsg = msg.a;
				return A2($author$project$Model$ResendActivation$update, activationMsg, model);
			case 'OnSetPassword':
				var setPasswordMsg = msg.a;
				return A2($author$project$Model$SetPassword$update, setPasswordMsg, model);
			case 'OnRegister':
				var registerMsg = msg.a;
				return A2($author$project$Model$PersonalRegister$update, registerMsg, model);
			case 'OnBusinessRegister':
				var registerMsg = msg.a;
				return A2($author$project$Model$BusinessRegister$update, registerMsg, model);
			case 'OnAppsumoRegister':
				var registerMsg = msg.a;
				return A2($author$project$Model$AppsumoRegister$update, registerMsg, model);
			case 'OnNewfoldRegister':
				var newfoldRegisterMsg = msg.a;
				return A2($author$project$Model$NewfoldRegister$update, newfoldRegisterMsg, model);
			case 'OnActivate':
				var activateMsg = msg.a;
				return A3(
					$author$project$Model$Activate$update,
					A3(
						$author$project$Model$initAuthModel,
						model.defaultLanguage,
						model.apiEndPoint,
						$elm$core$Maybe$Just(model.theme)),
					activateMsg,
					model);
			case 'OnBusinessAcceptInvite':
				var businessAcceptInviteMsg = msg.a;
				return A2($author$project$Model$BusinessAcceptInvite$update, businessAcceptInviteMsg, model);
			case 'OnBusinessProfile':
				var businessProfileMsg = msg.a;
				return A2($author$project$Model$BusinessProfile$update, businessProfileMsg, model);
			case 'OnViewDoc':
				var viewDocMsg = msg.a;
				return A4(
					$author$project$Model$ViewDocument$update,
					A2(
						$author$project$Model$initAnonymousModel,
						model.apiEndPoint,
						$elm$core$Maybe$Just(model.theme)),
					viewDocMsg,
					model.sessionModel,
					model);
			case 'InvalidJWT':
				return $author$project$Model$Logout$forceLogout(model);
			case 'OnSignature':
				var signatureMsg = msg.a;
				return A2($author$project$Model$Signature$update, signatureMsg, model);
			case 'OnStamp':
				var stampMsg = msg.a;
				return A2($author$project$Model$Stamp$update, stampMsg, model);
			case 'OnFillTemplate':
				var fillTemplateMsg = msg.a;
				return A4(
					$author$project$Model$FillTemplate$update,
					A2(
						$author$project$Model$initAnonymousModel,
						model.apiEndPoint,
						$elm$core$Maybe$Just(model.theme)),
					fillTemplateMsg,
					model.sessionModel,
					model);
			case 'OnTokenConfirmation':
				var tokenConfirmationMsg = msg.a;
				return A2($author$project$Model$TokenConfirmation$update, tokenConfirmationMsg, model);
			case 'OnPointWithdrawalConfirmation':
				var withdrawalConfirmationMsg = msg.a;
				return A2($author$project$Model$PointWithdrawalConfirm$update, withdrawalConfirmationMsg, model);
			case 'OnConfirmDeleteDocument':
				var confirmDeleteDocumentMsg = msg.a;
				return A2($author$project$Model$ConfirmDeleteDocument$update, confirmDeleteDocumentMsg, model);
			case 'OnConfirmDeleteTemplate':
				var confirmDeleteTemplateMsg = msg.a;
				return A2($author$project$Model$ConfirmDeleteTemplate$update, confirmDeleteTemplateMsg, model);
			case 'OnAuth':
				var onAuthMsg = msg.a;
				var _v1 = model.sessionModel;
				switch (_v1.$) {
					case 'Auth':
						var authModel = _v1.a;
						switch (onAuthMsg.$) {
							case 'OnMenu':
								var menuStatus = onAuthMsg.a;
								return A3($author$project$Model$updateMenu, menuStatus, authModel, model);
							case 'OnServerEvent':
								var event = onAuthMsg.a;
								return A3($author$project$Model$SSE$update, event, authModel, model);
							case 'OnLogout':
								var logoutMsg = onAuthMsg.a;
								return A3($author$project$Model$Logout$update, logoutMsg, authModel, model);
							case 'OnSetting':
								var settingMsg = onAuthMsg.a;
								return A3($author$project$Model$Settings$update, settingMsg, authModel, model);
							case 'OnAddressBook':
								var addressBookMsg = onAuthMsg.a;
								return A3($author$project$Model$AddressBook$update, addressBookMsg, authModel, model);
							case 'OnNewDoc':
								var newDocMsg = onAuthMsg.a;
								return A3($author$project$Model$NewDocument$update, newDocMsg, authModel, model);
							case 'OnMultipleDocUpload':
								var uploadDocMsg = onAuthMsg.a;
								return A3($author$project$Model$UploadMultipleDocument$update, uploadDocMsg, authModel, model);
							case 'OnTrustScore':
								var trustScoreMsg = onAuthMsg.a;
								return A3($author$project$Model$TrustScore$update, trustScoreMsg, authModel, model);
							case 'OnDashboard':
								var dashboardMsg = onAuthMsg.a;
								return A3($author$project$Model$Dashboard$update, dashboardMsg, authModel, model);
							case 'OnListDoc':
								var listDocMsg = onAuthMsg.a;
								return A3($author$project$Model$ListDocument$update, listDocMsg, authModel, model);
							case 'OnBusinessCreate':
								var businessCreateMsg = onAuthMsg.a;
								return A3($author$project$Model$BusinessCreate$update, businessCreateMsg, authModel, model);
							case 'OnPointsTopUp':
								var pointTopUpMsg = onAuthMsg.a;
								return A3($author$project$Model$PointTopUp$update, pointTopUpMsg, authModel, model);
							case 'OnBusinessUser':
								var businessUserMsg = onAuthMsg.a;
								return A3($author$project$Model$BusinessUser$update, businessUserMsg, authModel, model);
							case 'OnNewTemplate':
								var newTemplateMsg = onAuthMsg.a;
								return A3($author$project$Model$NewTemplate$update, newTemplateMsg, authModel, model);
							case 'OnCreateTemplate':
								var createTemplateMsg = onAuthMsg.a;
								return A3($author$project$Model$CreateTemplate$update, createTemplateMsg, authModel, model);
							case 'OnBusinessChangeTheme':
								var businessChangeThemeFormMsg = onAuthMsg.a;
								return A3($author$project$Model$BusinessTheme$update, businessChangeThemeFormMsg, authModel, model);
							case 'OnActionButton':
								var actionButtonMsg = onAuthMsg.a;
								return A3($author$project$Model$ActionButton$update, actionButtonMsg, authModel, model);
							case 'OnTokenManagement':
								var tokenManagementMsg = onAuthMsg.a;
								return A3($author$project$Model$TokenManagement$update, tokenManagementMsg, model, authModel);
							case 'OnPointTransactionHistory':
								var transactionHistoryMsg = onAuthMsg.a;
								return A3($author$project$Model$PointTransactionHistory$update, transactionHistoryMsg, model, authModel);
							case 'OnPointTransaction':
								var transactionMsg = onAuthMsg.a;
								return A3($author$project$Model$PointTransaction$update, transactionMsg, model, authModel);
							case 'OnPointTransactionTable':
								var transactionMsg = onAuthMsg.a;
								return A2($author$project$Model$PointTransactionTable$update, transactionMsg, model);
							case 'OnPointWithdrawal':
								var withdrawalMsg = onAuthMsg.a;
								return A4($author$project$Model$PointWithdrawal$update, authModel.user, withdrawalMsg, model, authModel);
							case 'OnRedeemRewardList':
								var redeemRewardListMsg = onAuthMsg.a;
								return A3($author$project$Model$RedeemRewardList$update, redeemRewardListMsg, model, authModel);
							case 'OnVerifyDocument':
								var verifyDocMsg = onAuthMsg.a;
								return A3($author$project$Model$VerifyDocument$update, verifyDocMsg, authModel, model);
							case 'OnNewMultipleDoc':
								var newMultipleDocMsg = onAuthMsg.a;
								return A3($author$project$Model$NewMultipleDocument$update, newMultipleDocMsg, authModel, model);
							case 'OnListTemplateDashBoard':
								var newMsg = onAuthMsg.a;
								return A3($author$project$Model$ListTemplateDashboard$update, newMsg, authModel, model);
							case 'OnViewNotarisationInfo':
								var verifyDocMsg = onAuthMsg.a;
								return A3($author$project$Model$ViewNotarisationInfo$update, verifyDocMsg, authModel, model);
							default:
								var languageChangeMsg = onAuthMsg.a;
								return A3($author$project$Model$LanguageChange$update, languageChangeMsg, authModel, model);
						}
					case 'Anonymous':
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					case 'NoAuth':
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					default:
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			default:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Type$ActionButton$CloseAll = {$: 'CloseAll'};
var $author$project$Types$OnActionButton = function (a) {
	return {$: 'OnActionButton', a: a};
};
var $author$project$Type$ActionButton$OpenMenu = {$: 'OpenMenu'};
var $rtfeldman$elm_css$VirtualDom$Styled$Attribute = F3(
	function (a, b, c) {
		return {$: 'Attribute', a: a, b: b, c: c};
	});
var $elm$virtual_dom$VirtualDom$attribute = F2(
	function (key, value) {
		return A2(
			_VirtualDom_attribute,
			_VirtualDom_noOnOrFormAction(key),
			_VirtualDom_noJavaScriptOrHtmlUri(value));
	});
var $rtfeldman$elm_css$VirtualDom$Styled$attribute = F2(
	function (key, value) {
		return A3(
			$rtfeldman$elm_css$VirtualDom$Styled$Attribute,
			A2($elm$virtual_dom$VirtualDom$attribute, key, value),
			_List_Nil,
			'');
	});
var $rtfeldman$elm_css$Svg$Styled$Attributes$d = $rtfeldman$elm_css$VirtualDom$Styled$attribute('d');
var $rtfeldman$elm_css$Svg$Styled$Attributes$fill = $rtfeldman$elm_css$VirtualDom$Styled$attribute('fill');
var $rtfeldman$elm_css$Svg$Styled$Attributes$height = $rtfeldman$elm_css$VirtualDom$Styled$attribute('height');
var $rtfeldman$elm_css$VirtualDom$Styled$NodeNS = F4(
	function (a, b, c, d) {
		return {$: 'NodeNS', a: a, b: b, c: c, d: d};
	});
var $rtfeldman$elm_css$VirtualDom$Styled$nodeNS = $rtfeldman$elm_css$VirtualDom$Styled$NodeNS;
var $rtfeldman$elm_css$Svg$Styled$node = $rtfeldman$elm_css$VirtualDom$Styled$nodeNS('http://www.w3.org/2000/svg');
var $rtfeldman$elm_css$Svg$Styled$path = $rtfeldman$elm_css$Svg$Styled$node('path');
var $rtfeldman$elm_css$Svg$Styled$svg = $rtfeldman$elm_css$Svg$Styled$node('svg');
var $rtfeldman$elm_css$Svg$Styled$Attributes$viewBox = $rtfeldman$elm_css$VirtualDom$Styled$attribute('viewBox');
var $rtfeldman$elm_css$Svg$Styled$Attributes$width = $rtfeldman$elm_css$VirtualDom$Styled$attribute('width');
var $author$project$Material$Styled$Icon$Add$view = F2(
	function (attributes, children) {
		return A2(
			$rtfeldman$elm_css$Svg$Styled$svg,
			_Utils_ap(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Svg$Styled$Attributes$fill('white'),
						$rtfeldman$elm_css$Svg$Styled$Attributes$width('18px'),
						$rtfeldman$elm_css$Svg$Styled$Attributes$height('18px'),
						$rtfeldman$elm_css$Svg$Styled$Attributes$viewBox('0 0 24 24')
					]),
				attributes),
			_Utils_ap(
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Svg$Styled$path,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Svg$Styled$Attributes$d('M0 0h24v24H0z'),
								$rtfeldman$elm_css$Svg$Styled$Attributes$fill('none')
							]),
						_List_Nil),
						A2(
						$rtfeldman$elm_css$Svg$Styled$path,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Svg$Styled$Attributes$d('M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z')
							]),
						_List_Nil)
					]),
				children));
	});
var $author$project$Material$Styled$Icon$add = $author$project$Material$Styled$Icon$Add$view;
var $rtfeldman$elm_css$Html$Styled$Attributes$attribute = $rtfeldman$elm_css$VirtualDom$Styled$attribute;
var $rtfeldman$elm_css$VirtualDom$Styled$Node = F3(
	function (a, b, c) {
		return {$: 'Node', a: a, b: b, c: c};
	});
var $rtfeldman$elm_css$VirtualDom$Styled$node = $rtfeldman$elm_css$VirtualDom$Styled$Node;
var $rtfeldman$elm_css$Html$Styled$node = $rtfeldman$elm_css$VirtualDom$Styled$node;
var $rtfeldman$elm_css$Html$Styled$button = $rtfeldman$elm_css$Html$Styled$node('button');
var $author$project$Material$Styled$Color$blueA200String = '#448AFF';
var $author$project$Material$Styled$Color$blueA700String = '#2962FF';
var $author$project$Material$Styled$Color$whiteString = '#FFFFFF';
var $author$project$Material$Styled$Button$blue = {base: $author$project$Material$Styled$Color$blueA700String, ripple: $author$project$Material$Styled$Color$blueA200String, text: $author$project$Material$Styled$Color$whiteString};
var $rtfeldman$elm_css$Css$Preprocess$ExtendSelector = F2(
	function (a, b) {
		return {$: 'ExtendSelector', a: a, b: b};
	});
var $rtfeldman$elm_css$Css$Structure$PseudoClassSelector = function (a) {
	return {$: 'PseudoClassSelector', a: a};
};
var $rtfeldman$elm_css$Css$pseudoClass = function (_class) {
	return $rtfeldman$elm_css$Css$Preprocess$ExtendSelector(
		$rtfeldman$elm_css$Css$Structure$PseudoClassSelector(_class));
};
var $rtfeldman$elm_css$Css$active = $rtfeldman$elm_css$Css$pseudoClass('active');
var $rtfeldman$elm_css$Css$Transitions$Background = {$: 'Background'};
var $rtfeldman$elm_css$Css$Transitions$Transition = function (a) {
	return {$: 'Transition', a: a};
};
var $rtfeldman$elm_css$Css$Transitions$durationTransition = F2(
	function (animation, duration) {
		return $rtfeldman$elm_css$Css$Transitions$Transition(
			{animation: animation, delay: $elm$core$Maybe$Nothing, duration: duration, timing: $elm$core$Maybe$Nothing});
	});
var $rtfeldman$elm_css$Css$Transitions$background = $rtfeldman$elm_css$Css$Transitions$durationTransition($rtfeldman$elm_css$Css$Transitions$Background);
var $rtfeldman$elm_css$Css$Preprocess$AppendProperty = function (a) {
	return {$: 'AppendProperty', a: a};
};
var $rtfeldman$elm_css$Css$property = F2(
	function (key, value) {
		return $rtfeldman$elm_css$Css$Preprocess$AppendProperty(key + (':' + value));
	});
var $rtfeldman$elm_css$Css$backgroundColor = function (c) {
	return A2($rtfeldman$elm_css$Css$property, 'background-color', c.value);
};
var $rtfeldman$elm_css$Css$Preprocess$ApplyStyles = function (a) {
	return {$: 'ApplyStyles', a: a};
};
var $rtfeldman$elm_css$Css$Internal$property = F2(
	function (key, value) {
		return $rtfeldman$elm_css$Css$Preprocess$AppendProperty(key + (':' + value));
	});
var $rtfeldman$elm_css$Css$Internal$getOverloadedProperty = F3(
	function (functionName, desiredKey, style) {
		getOverloadedProperty:
		while (true) {
			switch (style.$) {
				case 'AppendProperty':
					var str = style.a;
					var key = A2(
						$elm$core$Maybe$withDefault,
						'',
						$elm$core$List$head(
							A2($elm$core$String$split, ':', str)));
					return A2($rtfeldman$elm_css$Css$Internal$property, desiredKey, key);
				case 'ExtendSelector':
					var selector = style.a;
					return A2($rtfeldman$elm_css$Css$Internal$property, desiredKey, 'elm-css-error-cannot-apply-' + (functionName + '-with-inapplicable-Style-for-selector'));
				case 'NestSnippet':
					var combinator = style.a;
					return A2($rtfeldman$elm_css$Css$Internal$property, desiredKey, 'elm-css-error-cannot-apply-' + (functionName + '-with-inapplicable-Style-for-combinator'));
				case 'WithPseudoElement':
					var pseudoElement = style.a;
					return A2($rtfeldman$elm_css$Css$Internal$property, desiredKey, 'elm-css-error-cannot-apply-' + (functionName + '-with-inapplicable-Style-for-pseudo-element setter'));
				case 'WithMedia':
					return A2($rtfeldman$elm_css$Css$Internal$property, desiredKey, 'elm-css-error-cannot-apply-' + (functionName + '-with-inapplicable-Style-for-media-query'));
				case 'WithKeyframes':
					return A2($rtfeldman$elm_css$Css$Internal$property, desiredKey, 'elm-css-error-cannot-apply-' + (functionName + '-with-inapplicable-Style-for-keyframes'));
				default:
					if (!style.a.b) {
						return A2($rtfeldman$elm_css$Css$Internal$property, desiredKey, 'elm-css-error-cannot-apply-' + (functionName + '-with-empty-Style'));
					} else {
						if (!style.a.b.b) {
							var _v1 = style.a;
							var only = _v1.a;
							var $temp$functionName = functionName,
								$temp$desiredKey = desiredKey,
								$temp$style = only;
							functionName = $temp$functionName;
							desiredKey = $temp$desiredKey;
							style = $temp$style;
							continue getOverloadedProperty;
						} else {
							var _v2 = style.a;
							var first = _v2.a;
							var rest = _v2.b;
							var $temp$functionName = functionName,
								$temp$desiredKey = desiredKey,
								$temp$style = $rtfeldman$elm_css$Css$Preprocess$ApplyStyles(rest);
							functionName = $temp$functionName;
							desiredKey = $temp$desiredKey;
							style = $temp$style;
							continue getOverloadedProperty;
						}
					}
			}
		}
	});
var $rtfeldman$elm_css$Css$Internal$IncompatibleUnits = {$: 'IncompatibleUnits'};
var $rtfeldman$elm_css$Css$Structure$Compatible = {$: 'Compatible'};
var $rtfeldman$elm_css$Css$Internal$lengthConverter = F3(
	function (units, unitLabel, numericValue) {
		return {
			absoluteLength: $rtfeldman$elm_css$Css$Structure$Compatible,
			calc: $rtfeldman$elm_css$Css$Structure$Compatible,
			flexBasis: $rtfeldman$elm_css$Css$Structure$Compatible,
			fontSize: $rtfeldman$elm_css$Css$Structure$Compatible,
			length: $rtfeldman$elm_css$Css$Structure$Compatible,
			lengthOrAuto: $rtfeldman$elm_css$Css$Structure$Compatible,
			lengthOrAutoOrCoverOrContain: $rtfeldman$elm_css$Css$Structure$Compatible,
			lengthOrMinMaxDimension: $rtfeldman$elm_css$Css$Structure$Compatible,
			lengthOrNone: $rtfeldman$elm_css$Css$Structure$Compatible,
			lengthOrNoneOrMinMaxDimension: $rtfeldman$elm_css$Css$Structure$Compatible,
			lengthOrNumber: $rtfeldman$elm_css$Css$Structure$Compatible,
			lengthOrNumberOrAutoOrNoneOrContent: $rtfeldman$elm_css$Css$Structure$Compatible,
			numericValue: numericValue,
			textIndent: $rtfeldman$elm_css$Css$Structure$Compatible,
			unitLabel: unitLabel,
			units: units,
			value: _Utils_ap(
				$elm$core$String$fromFloat(numericValue),
				unitLabel)
		};
	});
var $rtfeldman$elm_css$Css$Internal$lengthForOverloadedProperty = A3($rtfeldman$elm_css$Css$Internal$lengthConverter, $rtfeldman$elm_css$Css$Internal$IncompatibleUnits, '', 0);
var $rtfeldman$elm_css$Css$backgroundPosition = function (fn) {
	return A3(
		$rtfeldman$elm_css$Css$Internal$getOverloadedProperty,
		'backgroundPosition',
		'background-position',
		fn($rtfeldman$elm_css$Css$Internal$lengthForOverloadedProperty));
};
var $rtfeldman$elm_css$Css$prop1 = F2(
	function (key, arg) {
		return A2($rtfeldman$elm_css$Css$property, key, arg.value);
	});
var $rtfeldman$elm_css$Css$backgroundSize = $rtfeldman$elm_css$Css$prop1('background-size');
var $rtfeldman$elm_css$Css$border = $rtfeldman$elm_css$Css$prop1('border');
var $rtfeldman$elm_css$Css$borderBox = {backgroundClip: $rtfeldman$elm_css$Css$Structure$Compatible, boxSizing: $rtfeldman$elm_css$Css$Structure$Compatible, value: 'border-box'};
var $rtfeldman$elm_css$Css$borderRadius = $rtfeldman$elm_css$Css$prop1('border-radius');
var $rtfeldman$elm_css$Css$boxSizing = $rtfeldman$elm_css$Css$prop1('box-sizing');
var $rtfeldman$elm_css$Css$center = $rtfeldman$elm_css$Css$prop1('center');
var $rtfeldman$elm_css$Css$color = function (c) {
	return A2($rtfeldman$elm_css$Css$property, 'color', c.value);
};
var $rtfeldman$elm_css$Css$cursor = $rtfeldman$elm_css$Css$prop1('cursor');
var $rtfeldman$elm_css$Css$focus = $rtfeldman$elm_css$Css$pseudoClass('focus');
var $rtfeldman$elm_css$Css$fontSize = $rtfeldman$elm_css$Css$prop1('font-size');
var $rtfeldman$elm_css$Css$fontWeight = function (_v0) {
	var value = _v0.value;
	return A2($rtfeldman$elm_css$Css$property, 'font-weight', value);
};
var $rtfeldman$elm_css$Css$withPrecedingHash = function (str) {
	return A2($elm$core$String$startsWith, '#', str) ? str : A2(
		$elm$core$String$cons,
		_Utils_chr('#'),
		str);
};
var $rtfeldman$elm_css$Css$erroneousHex = function (str) {
	return {
		alpha: 1,
		blue: 0,
		color: $rtfeldman$elm_css$Css$Structure$Compatible,
		green: 0,
		red: 0,
		value: $rtfeldman$elm_css$Css$withPrecedingHash(str)
	};
};
var $elm$core$String$foldr = _String_foldr;
var $elm$core$String$toList = function (string) {
	return A3($elm$core$String$foldr, $elm$core$List$cons, _List_Nil, string);
};
var $elm$core$String$fromList = _String_fromList;
var $elm$core$Basics$pow = _Basics_pow;
var $rtfeldman$elm_hex$Hex$fromStringHelp = F3(
	function (position, chars, accumulated) {
		fromStringHelp:
		while (true) {
			if (!chars.b) {
				return $elm$core$Result$Ok(accumulated);
			} else {
				var _char = chars.a;
				var rest = chars.b;
				switch (_char.valueOf()) {
					case '0':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated;
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '1':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + A2($elm$core$Basics$pow, 16, position);
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '2':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (2 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '3':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (3 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '4':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (4 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '5':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (5 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '6':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (6 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '7':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (7 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '8':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (8 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '9':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (9 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'a':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (10 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'b':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (11 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'c':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (12 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'd':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (13 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'e':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (14 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'f':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (15 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					default:
						var nonHex = _char;
						return $elm$core$Result$Err(
							$elm$core$String$fromChar(nonHex) + ' is not a valid hexadecimal character.');
				}
			}
		}
	});
var $elm$core$List$tail = function (list) {
	if (list.b) {
		var x = list.a;
		var xs = list.b;
		return $elm$core$Maybe$Just(xs);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $rtfeldman$elm_hex$Hex$fromString = function (str) {
	if ($elm$core$String$isEmpty(str)) {
		return $elm$core$Result$Err('Empty strings are not valid hexadecimal strings.');
	} else {
		var result = function () {
			if (A2($elm$core$String$startsWith, '-', str)) {
				var list = A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					$elm$core$List$tail(
						$elm$core$String$toList(str)));
				return A2(
					$elm$core$Result$map,
					$elm$core$Basics$negate,
					A3(
						$rtfeldman$elm_hex$Hex$fromStringHelp,
						$elm$core$List$length(list) - 1,
						list,
						0));
			} else {
				return A3(
					$rtfeldman$elm_hex$Hex$fromStringHelp,
					$elm$core$String$length(str) - 1,
					$elm$core$String$toList(str),
					0);
			}
		}();
		var formatError = function (err) {
			return A2(
				$elm$core$String$join,
				' ',
				_List_fromArray(
					['\"' + (str + '\"'), 'is not a valid hexadecimal string because', err]));
		};
		return A2($elm$core$Result$mapError, formatError, result);
	}
};
var $rtfeldman$elm_css$Css$validHex = F5(
	function (str, _v0, _v1, _v2, _v3) {
		var r1 = _v0.a;
		var r2 = _v0.b;
		var g1 = _v1.a;
		var g2 = _v1.b;
		var b1 = _v2.a;
		var b2 = _v2.b;
		var a1 = _v3.a;
		var a2 = _v3.b;
		var toResult = A2(
			$elm$core$Basics$composeR,
			$elm$core$String$fromList,
			A2($elm$core$Basics$composeR, $elm$core$String$toLower, $rtfeldman$elm_hex$Hex$fromString));
		var results = _Utils_Tuple2(
			_Utils_Tuple2(
				toResult(
					_List_fromArray(
						[r1, r2])),
				toResult(
					_List_fromArray(
						[g1, g2]))),
			_Utils_Tuple2(
				toResult(
					_List_fromArray(
						[b1, b2])),
				toResult(
					_List_fromArray(
						[a1, a2]))));
		if ((((results.a.a.$ === 'Ok') && (results.a.b.$ === 'Ok')) && (results.b.a.$ === 'Ok')) && (results.b.b.$ === 'Ok')) {
			var _v5 = results.a;
			var red = _v5.a.a;
			var green = _v5.b.a;
			var _v6 = results.b;
			var blue = _v6.a.a;
			var alpha = _v6.b.a;
			return {
				alpha: alpha / 255,
				blue: blue,
				color: $rtfeldman$elm_css$Css$Structure$Compatible,
				green: green,
				red: red,
				value: $rtfeldman$elm_css$Css$withPrecedingHash(str)
			};
		} else {
			return $rtfeldman$elm_css$Css$erroneousHex(str);
		}
	});
var $rtfeldman$elm_css$Css$hex = function (str) {
	var withoutHash = A2($elm$core$String$startsWith, '#', str) ? A2($elm$core$String$dropLeft, 1, str) : str;
	var _v0 = $elm$core$String$toList(withoutHash);
	_v0$4:
	while (true) {
		if ((_v0.b && _v0.b.b) && _v0.b.b.b) {
			if (!_v0.b.b.b.b) {
				var r = _v0.a;
				var _v1 = _v0.b;
				var g = _v1.a;
				var _v2 = _v1.b;
				var b = _v2.a;
				return A5(
					$rtfeldman$elm_css$Css$validHex,
					str,
					_Utils_Tuple2(r, r),
					_Utils_Tuple2(g, g),
					_Utils_Tuple2(b, b),
					_Utils_Tuple2(
						_Utils_chr('f'),
						_Utils_chr('f')));
			} else {
				if (!_v0.b.b.b.b.b) {
					var r = _v0.a;
					var _v3 = _v0.b;
					var g = _v3.a;
					var _v4 = _v3.b;
					var b = _v4.a;
					var _v5 = _v4.b;
					var a = _v5.a;
					return A5(
						$rtfeldman$elm_css$Css$validHex,
						str,
						_Utils_Tuple2(r, r),
						_Utils_Tuple2(g, g),
						_Utils_Tuple2(b, b),
						_Utils_Tuple2(a, a));
				} else {
					if (_v0.b.b.b.b.b.b) {
						if (!_v0.b.b.b.b.b.b.b) {
							var r1 = _v0.a;
							var _v6 = _v0.b;
							var r2 = _v6.a;
							var _v7 = _v6.b;
							var g1 = _v7.a;
							var _v8 = _v7.b;
							var g2 = _v8.a;
							var _v9 = _v8.b;
							var b1 = _v9.a;
							var _v10 = _v9.b;
							var b2 = _v10.a;
							return A5(
								$rtfeldman$elm_css$Css$validHex,
								str,
								_Utils_Tuple2(r1, r2),
								_Utils_Tuple2(g1, g2),
								_Utils_Tuple2(b1, b2),
								_Utils_Tuple2(
									_Utils_chr('f'),
									_Utils_chr('f')));
						} else {
							if (_v0.b.b.b.b.b.b.b.b && (!_v0.b.b.b.b.b.b.b.b.b)) {
								var r1 = _v0.a;
								var _v11 = _v0.b;
								var r2 = _v11.a;
								var _v12 = _v11.b;
								var g1 = _v12.a;
								var _v13 = _v12.b;
								var g2 = _v13.a;
								var _v14 = _v13.b;
								var b1 = _v14.a;
								var _v15 = _v14.b;
								var b2 = _v15.a;
								var _v16 = _v15.b;
								var a1 = _v16.a;
								var _v17 = _v16.b;
								var a2 = _v17.a;
								return A5(
									$rtfeldman$elm_css$Css$validHex,
									str,
									_Utils_Tuple2(r1, r2),
									_Utils_Tuple2(g1, g2),
									_Utils_Tuple2(b1, b2),
									_Utils_Tuple2(a1, a2));
							} else {
								break _v0$4;
							}
						}
					} else {
						break _v0$4;
					}
				}
			}
		} else {
			break _v0$4;
		}
	}
	return $rtfeldman$elm_css$Css$erroneousHex(str);
};
var $rtfeldman$elm_css$Css$hover = $rtfeldman$elm_css$Css$pseudoClass('hover');
var $rtfeldman$elm_css$Css$UnitlessInteger = {$: 'UnitlessInteger'};
var $rtfeldman$elm_css$Css$int = function (val) {
	return {
		fontWeight: $rtfeldman$elm_css$Css$Structure$Compatible,
		intOrAuto: $rtfeldman$elm_css$Css$Structure$Compatible,
		lengthOrNumber: $rtfeldman$elm_css$Css$Structure$Compatible,
		lengthOrNumberOrAutoOrNoneOrContent: $rtfeldman$elm_css$Css$Structure$Compatible,
		number: $rtfeldman$elm_css$Css$Structure$Compatible,
		numberOrInfinite: $rtfeldman$elm_css$Css$Structure$Compatible,
		numericValue: val,
		unitLabel: '',
		units: $rtfeldman$elm_css$Css$UnitlessInteger,
		value: $elm$core$String$fromInt(val)
	};
};
var $rtfeldman$elm_css$Css$none = {backgroundImage: $rtfeldman$elm_css$Css$Structure$Compatible, blockAxisOverflow: $rtfeldman$elm_css$Css$Structure$Compatible, borderStyle: $rtfeldman$elm_css$Css$Structure$Compatible, cursor: $rtfeldman$elm_css$Css$Structure$Compatible, display: $rtfeldman$elm_css$Css$Structure$Compatible, hoverCapability: $rtfeldman$elm_css$Css$Structure$Compatible, inlineAxisOverflow: $rtfeldman$elm_css$Css$Structure$Compatible, keyframes: $rtfeldman$elm_css$Css$Structure$Compatible, lengthOrNone: $rtfeldman$elm_css$Css$Structure$Compatible, lengthOrNoneOrMinMaxDimension: $rtfeldman$elm_css$Css$Structure$Compatible, lengthOrNumberOrAutoOrNoneOrContent: $rtfeldman$elm_css$Css$Structure$Compatible, listStyleType: $rtfeldman$elm_css$Css$Structure$Compatible, listStyleTypeOrPositionOrImage: $rtfeldman$elm_css$Css$Structure$Compatible, none: $rtfeldman$elm_css$Css$Structure$Compatible, outline: $rtfeldman$elm_css$Css$Structure$Compatible, pointerDevice: $rtfeldman$elm_css$Css$Structure$Compatible, pointerEvents: $rtfeldman$elm_css$Css$Structure$Compatible, resize: $rtfeldman$elm_css$Css$Structure$Compatible, scriptingSupport: $rtfeldman$elm_css$Css$Structure$Compatible, textDecorationLine: $rtfeldman$elm_css$Css$Structure$Compatible, textTransform: $rtfeldman$elm_css$Css$Structure$Compatible, touchAction: $rtfeldman$elm_css$Css$Structure$Compatible, transform: $rtfeldman$elm_css$Css$Structure$Compatible, updateFrequency: $rtfeldman$elm_css$Css$Structure$Compatible, value: 'none'};
var $rtfeldman$elm_css$Css$outline = $rtfeldman$elm_css$Css$prop1('outline');
var $rtfeldman$elm_css$Css$prop2 = F3(
	function (key, argA, argB) {
		return A2(
			$rtfeldman$elm_css$Css$property,
			key,
			A2(
				$elm$core$String$join,
				' ',
				_List_fromArray(
					[argA.value, argB.value])));
	});
var $rtfeldman$elm_css$Css$padding2 = $rtfeldman$elm_css$Css$prop2('padding');
var $rtfeldman$elm_css$Css$PercentageUnits = {$: 'PercentageUnits'};
var $rtfeldman$elm_css$Css$pct = A2($rtfeldman$elm_css$Css$Internal$lengthConverter, $rtfeldman$elm_css$Css$PercentageUnits, '%');
var $rtfeldman$elm_css$Css$pointer = {cursor: $rtfeldman$elm_css$Css$Structure$Compatible, value: 'pointer'};
var $rtfeldman$elm_css$Css$pointerEvents = $rtfeldman$elm_css$Css$prop1('pointer-events');
var $rtfeldman$elm_css$Css$PxUnits = {$: 'PxUnits'};
var $rtfeldman$elm_css$Css$px = A2($rtfeldman$elm_css$Css$Internal$lengthConverter, $rtfeldman$elm_css$Css$PxUnits, 'px');
var $rtfeldman$elm_css$Css$textTransform = $rtfeldman$elm_css$Css$prop1('text-transform');
var $rtfeldman$elm_css$Css$Transitions$propToString = function (prop) {
	switch (prop.$) {
		case 'Background':
			return 'background';
		case 'BackgroundColor':
			return 'background-color';
		case 'BackgroundPosition':
			return 'background-position';
		case 'BackgroundSize':
			return 'background-size';
		case 'Border':
			return 'border';
		case 'BorderBottom':
			return 'border-bottom';
		case 'BorderBottomColor':
			return 'border-bottom-color';
		case 'BorderBottomLeftRadius':
			return 'border-bottom-left-radius';
		case 'BorderBottomRightRadius':
			return 'border-bottom-right-radius';
		case 'BorderBottomWidth':
			return 'border-bottom-width';
		case 'BorderColor':
			return 'border-color';
		case 'BorderLeft':
			return 'border-left';
		case 'BorderLeftColor':
			return 'border-left-color';
		case 'BorderLeftWidth':
			return 'border-left-width';
		case 'BorderRadius':
			return 'border-radius';
		case 'BorderRight':
			return 'border-right';
		case 'BorderRightColor':
			return 'border-right-color';
		case 'BorderRightWidth':
			return 'border-right-width';
		case 'BorderTop':
			return 'border-top';
		case 'BorderTopColor':
			return 'border-top-color';
		case 'BorderTopLeftRadius':
			return 'border-top-left-radius';
		case 'BorderTopRightRadius':
			return 'border-top-right-radius';
		case 'BorderTopWidth':
			return 'border-top-width';
		case 'BorderWidth':
			return 'border-width';
		case 'Bottom':
			return 'bottom';
		case 'BoxShadow':
			return 'box-shadow';
		case 'CaretColor':
			return 'caret-color';
		case 'Clip':
			return 'clip';
		case 'ClipPath':
			return 'clip-path';
		case 'Color':
			return 'color';
		case 'ColumnCount':
			return 'column-count';
		case 'ColumnGap':
			return 'column-gap';
		case 'ColumnRule':
			return 'column-rule';
		case 'ColumnRuleColor':
			return 'column-rule-color';
		case 'ColumnRuleWidth':
			return 'column-rule-width';
		case 'ColumnWidth':
			return 'column-width';
		case 'Columns':
			return 'columns';
		case 'Filter':
			return 'filter';
		case 'Flex':
			return 'flex';
		case 'FlexBasis':
			return 'flex-basis';
		case 'FlexGrow':
			return 'flex-grow';
		case 'FlexShrink':
			return 'flex-shrink';
		case 'Font':
			return 'font';
		case 'FontSize':
			return 'font-size';
		case 'FontSizeAdjust':
			return 'font-size-adjust';
		case 'FontStretch':
			return 'font-stretch';
		case 'FontVariationSettings':
			return 'font-variation-settings';
		case 'FontWeight':
			return 'font-weight';
		case 'GridColumnGap':
			return 'grid-column-gap';
		case 'GridGap':
			return 'grid-gap';
		case 'GridRowGap':
			return 'grid-row-gap';
		case 'Height':
			return 'height';
		case 'Left':
			return 'left';
		case 'LetterSpacing':
			return 'letter-spacing';
		case 'LineHeight':
			return 'line-height';
		case 'Margin':
			return 'margin';
		case 'MarginBottom':
			return 'margin-bottom';
		case 'MarginLeft':
			return 'margin-left';
		case 'MarginRight':
			return 'margin-right';
		case 'MarginTop':
			return 'margin-top';
		case 'Mask':
			return 'mask';
		case 'MaskPosition':
			return 'mask-position';
		case 'MaskSize':
			return 'mask-size';
		case 'MaxHeight':
			return 'max-height';
		case 'MaxWidth':
			return 'max-width';
		case 'MinHeight':
			return 'min-height';
		case 'MinWidth':
			return 'min-width';
		case 'ObjectPosition':
			return 'object-position';
		case 'Offset':
			return 'offset';
		case 'OffsetAnchor':
			return 'offset-anchor';
		case 'OffsetDistance':
			return 'offset-distance';
		case 'OffsetPath':
			return 'offset-path';
		case 'OffsetRotate':
			return 'offset-rotate';
		case 'Opacity':
			return 'opacity';
		case 'Order':
			return 'order';
		case 'Outline':
			return 'outline';
		case 'OutlineColor':
			return 'outline-color';
		case 'OutlineOffset':
			return 'outline-offset';
		case 'OutlineWidth':
			return 'outline-width';
		case 'Padding':
			return 'padding';
		case 'PaddingBottom':
			return 'padding-bottom';
		case 'PaddingLeft':
			return 'padding-left';
		case 'PaddingRight':
			return 'padding-right';
		case 'PaddingTop':
			return 'padding-top';
		case 'Right':
			return 'right';
		case 'TabSize':
			return 'tab-size';
		case 'TextIndent':
			return 'text-indent';
		case 'TextShadow':
			return 'text-shadow';
		case 'Top':
			return 'top';
		case 'Transform':
			return 'transform';
		case 'TransformOrigin':
			return 'transform-origin';
		case 'VerticalAlign':
			return 'vertical-align';
		case 'Visibility':
			return 'visibility';
		case 'Width':
			return 'width';
		case 'WordSpacing':
			return 'word-spacing';
		default:
			return 'z-index';
	}
};
var $rtfeldman$elm_css$Css$Transitions$timeToString = function (time) {
	return $elm$core$String$fromFloat(time) + 'ms';
};
var $rtfeldman$elm_css$Css$Transitions$timingFunctionToString = function (tf) {
	switch (tf.$) {
		case 'Ease':
			return 'ease';
		case 'Linear':
			return 'linear';
		case 'EaseIn':
			return 'ease-in';
		case 'EaseOut':
			return 'ease-out';
		case 'EaseInOut':
			return 'ease-in-out';
		case 'StepStart':
			return 'step-start';
		case 'StepEnd':
			return 'step-end';
		default:
			var _float = tf.a;
			var float2 = tf.b;
			var float3 = tf.c;
			var float4 = tf.d;
			return 'cubic-bezier(' + ($elm$core$String$fromFloat(_float) + (' , ' + ($elm$core$String$fromFloat(float2) + (' , ' + ($elm$core$String$fromFloat(float3) + (' , ' + ($elm$core$String$fromFloat(float4) + ')')))))));
	}
};
var $rtfeldman$elm_css$Css$Transitions$transition = function (options) {
	var v = A3(
		$elm$core$String$slice,
		0,
		-1,
		A3(
			$elm$core$List$foldl,
			F2(
				function (_v0, s) {
					var animation = _v0.a.animation;
					var duration = _v0.a.duration;
					var delay = _v0.a.delay;
					var timing = _v0.a.timing;
					return s + (A2(
						$elm$core$String$join,
						' ',
						_List_fromArray(
							[
								$rtfeldman$elm_css$Css$Transitions$propToString(animation),
								$rtfeldman$elm_css$Css$Transitions$timeToString(duration),
								A2(
								$elm$core$Maybe$withDefault,
								'',
								A2($elm$core$Maybe$map, $rtfeldman$elm_css$Css$Transitions$timeToString, delay)),
								A2(
								$elm$core$Maybe$withDefault,
								'',
								A2($elm$core$Maybe$map, $rtfeldman$elm_css$Css$Transitions$timingFunctionToString, timing))
							])) + ',');
				}),
			'',
			options));
	return A2($rtfeldman$elm_css$Css$property, 'transition', v);
};
var $rtfeldman$elm_css$Css$transparent = {color: $rtfeldman$elm_css$Css$Structure$Compatible, value: 'transparent'};
var $rtfeldman$elm_css$Css$uppercase = {textTransform: $rtfeldman$elm_css$Css$Structure$Compatible, value: 'uppercase'};
var $rtfeldman$elm_css$Css$width = $rtfeldman$elm_css$Css$prop1('width');
var $rtfeldman$elm_css$Css$zero = {length: $rtfeldman$elm_css$Css$Structure$Compatible, lengthOrAuto: $rtfeldman$elm_css$Css$Structure$Compatible, lengthOrAutoOrCoverOrContain: $rtfeldman$elm_css$Css$Structure$Compatible, lengthOrMinMaxDimension: $rtfeldman$elm_css$Css$Structure$Compatible, lengthOrNone: $rtfeldman$elm_css$Css$Structure$Compatible, lengthOrNoneOrMinMaxDimension: $rtfeldman$elm_css$Css$Structure$Compatible, lengthOrNumber: $rtfeldman$elm_css$Css$Structure$Compatible, number: $rtfeldman$elm_css$Css$Structure$Compatible, numericValue: 0, outline: $rtfeldman$elm_css$Css$Structure$Compatible, unitLabel: '', units: $rtfeldman$elm_css$Css$UnitlessInteger, value: '0'};
var $author$project$Material$Styled$Button$style = {
	button: _List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Css$padding2,
			$rtfeldman$elm_css$Css$px(12),
			$rtfeldman$elm_css$Css$px(22)),
			$rtfeldman$elm_css$Css$boxSizing($rtfeldman$elm_css$Css$borderBox),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100)),
			$rtfeldman$elm_css$Css$border($rtfeldman$elm_css$Css$zero),
			$rtfeldman$elm_css$Css$borderRadius(
			$rtfeldman$elm_css$Css$px(4)),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(14)),
			$rtfeldman$elm_css$Css$fontWeight(
			$rtfeldman$elm_css$Css$int(500)),
			$rtfeldman$elm_css$Css$textTransform($rtfeldman$elm_css$Css$uppercase),
			A2($rtfeldman$elm_css$Css$property, 'box-shadow', '0 1px 1px 0 rgba(0,0,0,0.14)'),
			$rtfeldman$elm_css$Css$outline($rtfeldman$elm_css$Css$none)
		]),
	disabled: function (_v0) {
		var base = _v0.base;
		var text = _v0.text;
		return _List_fromArray(
			[
				$rtfeldman$elm_css$Css$pointerEvents($rtfeldman$elm_css$Css$none),
				$rtfeldman$elm_css$Css$color(
				$rtfeldman$elm_css$Css$hex(text)),
				$rtfeldman$elm_css$Css$backgroundColor(
				$rtfeldman$elm_css$Css$hex(base))
			]);
	},
	enabled: function (_v1) {
		var base = _v1.base;
		var ripple = _v1.ripple;
		var text = _v1.text;
		return _List_fromArray(
			[
				$rtfeldman$elm_css$Css$color(
				$rtfeldman$elm_css$Css$hex(text)),
				$rtfeldman$elm_css$Css$Transitions$transition(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$Transitions$background(800)
					])),
				A2($rtfeldman$elm_css$Css$property, 'background-image', 'radial-gradient(circle, transparent 1%, #' + (base + ' 1%)')),
				$rtfeldman$elm_css$Css$backgroundPosition($rtfeldman$elm_css$Css$center),
				(base === 'transparent') ? $rtfeldman$elm_css$Css$backgroundColor($rtfeldman$elm_css$Css$transparent) : $rtfeldman$elm_css$Css$backgroundColor(
				$rtfeldman$elm_css$Css$hex(base)),
				$rtfeldman$elm_css$Css$hover(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer),
						A2($rtfeldman$elm_css$Css$property, 'box-shadow', '0px 2px 4px -1px rgba(0,0,0,0.2), 0px 4px 5px 0px rgba(0,0,0,0.14), 0px 1px 10px 0px rgba(0,0,0,0.12)')
					])),
				$rtfeldman$elm_css$Css$active(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$backgroundSize(
						$rtfeldman$elm_css$Css$pct(100)),
						$rtfeldman$elm_css$Css$Transitions$transition(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Css$Transitions$background(0)
							])),
						(base === 'transparent') ? $rtfeldman$elm_css$Css$backgroundColor($rtfeldman$elm_css$Css$transparent) : $rtfeldman$elm_css$Css$backgroundColor(
						$rtfeldman$elm_css$Css$hex(ripple))
					])),
				$rtfeldman$elm_css$Css$focus(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$outline($rtfeldman$elm_css$Css$none)
					]))
			]);
	}
};
var $author$project$Material$Styled$Button$defaultConfig = {buttonAttributes: _List_Nil, buttonStyles: $author$project$Material$Styled$Button$style.button, isDisabled: false, theme: $author$project$Material$Styled$Button$blue};
var $rtfeldman$elm_css$Css$Structure$UniversalSelectorSequence = function (a) {
	return {$: 'UniversalSelectorSequence', a: a};
};
var $rtfeldman$elm_css$Css$Structure$compactHelp = F2(
	function (declaration, _v0) {
		var keyframesByName = _v0.a;
		var declarations = _v0.b;
		switch (declaration.$) {
			case 'StyleBlockDeclaration':
				var _v2 = declaration.a;
				var properties = _v2.c;
				return $elm$core$List$isEmpty(properties) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
					keyframesByName,
					A2($elm$core$List$cons, declaration, declarations));
			case 'MediaRule':
				var styleBlocks = declaration.b;
				return A2(
					$elm$core$List$all,
					function (_v3) {
						var properties = _v3.c;
						return $elm$core$List$isEmpty(properties);
					},
					styleBlocks) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
					keyframesByName,
					A2($elm$core$List$cons, declaration, declarations));
			case 'SupportsRule':
				var otherDeclarations = declaration.b;
				return $elm$core$List$isEmpty(otherDeclarations) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
					keyframesByName,
					A2($elm$core$List$cons, declaration, declarations));
			case 'DocumentRule':
				return _Utils_Tuple2(
					keyframesByName,
					A2($elm$core$List$cons, declaration, declarations));
			case 'PageRule':
				var properties = declaration.b;
				return $elm$core$List$isEmpty(properties) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
					keyframesByName,
					A2($elm$core$List$cons, declaration, declarations));
			case 'FontFace':
				var properties = declaration.a;
				return $elm$core$List$isEmpty(properties) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
					keyframesByName,
					A2($elm$core$List$cons, declaration, declarations));
			case 'Keyframes':
				var record = declaration.a;
				return $elm$core$String$isEmpty(record.declaration) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
					A3($elm$core$Dict$insert, record.name, record.declaration, keyframesByName),
					declarations);
			case 'Viewport':
				var properties = declaration.a;
				return $elm$core$List$isEmpty(properties) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
					keyframesByName,
					A2($elm$core$List$cons, declaration, declarations));
			case 'CounterStyle':
				var properties = declaration.a;
				return $elm$core$List$isEmpty(properties) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
					keyframesByName,
					A2($elm$core$List$cons, declaration, declarations));
			default:
				var tuples = declaration.a;
				return A2(
					$elm$core$List$all,
					function (_v4) {
						var properties = _v4.b;
						return $elm$core$List$isEmpty(properties);
					},
					tuples) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
					keyframesByName,
					A2($elm$core$List$cons, declaration, declarations));
		}
	});
var $rtfeldman$elm_css$Css$Structure$Keyframes = function (a) {
	return {$: 'Keyframes', a: a};
};
var $rtfeldman$elm_css$Css$Structure$withKeyframeDeclarations = F2(
	function (keyframesByName, compactedDeclarations) {
		return A2(
			$elm$core$List$append,
			A2(
				$elm$core$List$map,
				function (_v0) {
					var name = _v0.a;
					var decl = _v0.b;
					return $rtfeldman$elm_css$Css$Structure$Keyframes(
						{declaration: decl, name: name});
				},
				$elm$core$Dict$toList(keyframesByName)),
			compactedDeclarations);
	});
var $rtfeldman$elm_css$Css$Structure$compactStylesheet = function (_v0) {
	var charset = _v0.charset;
	var imports = _v0.imports;
	var namespaces = _v0.namespaces;
	var declarations = _v0.declarations;
	var _v1 = A3(
		$elm$core$List$foldr,
		$rtfeldman$elm_css$Css$Structure$compactHelp,
		_Utils_Tuple2($elm$core$Dict$empty, _List_Nil),
		declarations);
	var keyframesByName = _v1.a;
	var compactedDeclarations = _v1.b;
	var finalDeclarations = A2($rtfeldman$elm_css$Css$Structure$withKeyframeDeclarations, keyframesByName, compactedDeclarations);
	return {charset: charset, declarations: finalDeclarations, imports: imports, namespaces: namespaces};
};
var $rtfeldman$elm_css$Css$Structure$Output$charsetToString = function (charset) {
	return A2(
		$elm$core$Maybe$withDefault,
		'',
		A2(
			$elm$core$Maybe$map,
			function (str) {
				return '@charset \"' + (str + '\"');
			},
			charset));
};
var $rtfeldman$elm_css$Css$Structure$Output$mediaExpressionToString = function (expression) {
	return '(' + (expression.feature + (A2(
		$elm$core$Maybe$withDefault,
		'',
		A2(
			$elm$core$Maybe$map,
			$elm$core$Basics$append(': '),
			expression.value)) + ')'));
};
var $rtfeldman$elm_css$Css$Structure$Output$mediaTypeToString = function (mediaType) {
	switch (mediaType.$) {
		case 'Print':
			return 'print';
		case 'Screen':
			return 'screen';
		default:
			return 'speech';
	}
};
var $rtfeldman$elm_css$Css$Structure$Output$mediaQueryToString = function (mediaQuery) {
	var prefixWith = F3(
		function (str, mediaType, expressions) {
			return str + (' ' + A2(
				$elm$core$String$join,
				' and ',
				A2(
					$elm$core$List$cons,
					$rtfeldman$elm_css$Css$Structure$Output$mediaTypeToString(mediaType),
					A2($elm$core$List$map, $rtfeldman$elm_css$Css$Structure$Output$mediaExpressionToString, expressions))));
		});
	switch (mediaQuery.$) {
		case 'AllQuery':
			var expressions = mediaQuery.a;
			return A2(
				$elm$core$String$join,
				' and ',
				A2($elm$core$List$map, $rtfeldman$elm_css$Css$Structure$Output$mediaExpressionToString, expressions));
		case 'OnlyQuery':
			var mediaType = mediaQuery.a;
			var expressions = mediaQuery.b;
			return A3(prefixWith, 'only', mediaType, expressions);
		case 'NotQuery':
			var mediaType = mediaQuery.a;
			var expressions = mediaQuery.b;
			return A3(prefixWith, 'not', mediaType, expressions);
		default:
			var str = mediaQuery.a;
			return str;
	}
};
var $rtfeldman$elm_css$Css$Structure$Output$importMediaQueryToString = F2(
	function (name, mediaQuery) {
		return '@import \"' + (name + ($rtfeldman$elm_css$Css$Structure$Output$mediaQueryToString(mediaQuery) + '\"'));
	});
var $rtfeldman$elm_css$Css$Structure$Output$importToString = function (_v0) {
	var name = _v0.a;
	var mediaQueries = _v0.b;
	return A2(
		$elm$core$String$join,
		'\n',
		A2(
			$elm$core$List$map,
			$rtfeldman$elm_css$Css$Structure$Output$importMediaQueryToString(name),
			mediaQueries));
};
var $rtfeldman$elm_css$Css$Structure$Output$namespaceToString = function (_v0) {
	var prefix = _v0.a;
	var str = _v0.b;
	return '@namespace ' + (prefix + ('\"' + (str + '\"')));
};
var $rtfeldman$elm_css$Css$Structure$Output$spaceIndent = '    ';
var $rtfeldman$elm_css$Css$Structure$Output$indent = function (str) {
	return _Utils_ap($rtfeldman$elm_css$Css$Structure$Output$spaceIndent, str);
};
var $rtfeldman$elm_css$Css$Structure$Output$noIndent = '';
var $rtfeldman$elm_css$Css$Structure$Output$emitProperty = function (str) {
	return str + ';';
};
var $rtfeldman$elm_css$Css$Structure$Output$emitProperties = function (properties) {
	return A2(
		$elm$core$String$join,
		'\n',
		A2(
			$elm$core$List$map,
			A2($elm$core$Basics$composeL, $rtfeldman$elm_css$Css$Structure$Output$indent, $rtfeldman$elm_css$Css$Structure$Output$emitProperty),
			properties));
};
var $elm$core$String$append = _String_append;
var $rtfeldman$elm_css$Css$Structure$Output$pseudoElementToString = function (_v0) {
	var str = _v0.a;
	return '::' + str;
};
var $rtfeldman$elm_css$Css$Structure$Output$combinatorToString = function (combinator) {
	switch (combinator.$) {
		case 'AdjacentSibling':
			return '+';
		case 'GeneralSibling':
			return '~';
		case 'Child':
			return '>';
		default:
			return '';
	}
};
var $rtfeldman$elm_css$Css$Structure$Output$repeatableSimpleSelectorToString = function (repeatableSimpleSelector) {
	switch (repeatableSimpleSelector.$) {
		case 'ClassSelector':
			var str = repeatableSimpleSelector.a;
			return '.' + str;
		case 'IdSelector':
			var str = repeatableSimpleSelector.a;
			return '#' + str;
		case 'PseudoClassSelector':
			var str = repeatableSimpleSelector.a;
			return ':' + str;
		default:
			var str = repeatableSimpleSelector.a;
			return '[' + (str + ']');
	}
};
var $rtfeldman$elm_css$Css$Structure$Output$simpleSelectorSequenceToString = function (simpleSelectorSequence) {
	switch (simpleSelectorSequence.$) {
		case 'TypeSelectorSequence':
			var str = simpleSelectorSequence.a.a;
			var repeatableSimpleSelectors = simpleSelectorSequence.b;
			return A2(
				$elm$core$String$join,
				'',
				A2(
					$elm$core$List$cons,
					str,
					A2($elm$core$List$map, $rtfeldman$elm_css$Css$Structure$Output$repeatableSimpleSelectorToString, repeatableSimpleSelectors)));
		case 'UniversalSelectorSequence':
			var repeatableSimpleSelectors = simpleSelectorSequence.a;
			return $elm$core$List$isEmpty(repeatableSimpleSelectors) ? '*' : A2(
				$elm$core$String$join,
				'',
				A2($elm$core$List$map, $rtfeldman$elm_css$Css$Structure$Output$repeatableSimpleSelectorToString, repeatableSimpleSelectors));
		default:
			var str = simpleSelectorSequence.a;
			var repeatableSimpleSelectors = simpleSelectorSequence.b;
			return A2(
				$elm$core$String$join,
				'',
				A2(
					$elm$core$List$cons,
					str,
					A2($elm$core$List$map, $rtfeldman$elm_css$Css$Structure$Output$repeatableSimpleSelectorToString, repeatableSimpleSelectors)));
	}
};
var $rtfeldman$elm_css$Css$Structure$Output$selectorChainToString = function (_v0) {
	var combinator = _v0.a;
	var sequence = _v0.b;
	return A2(
		$elm$core$String$join,
		' ',
		_List_fromArray(
			[
				$rtfeldman$elm_css$Css$Structure$Output$combinatorToString(combinator),
				$rtfeldman$elm_css$Css$Structure$Output$simpleSelectorSequenceToString(sequence)
			]));
};
var $rtfeldman$elm_css$Css$Structure$Output$selectorToString = function (_v0) {
	var simpleSelectorSequence = _v0.a;
	var chain = _v0.b;
	var pseudoElement = _v0.c;
	var segments = A2(
		$elm$core$List$cons,
		$rtfeldman$elm_css$Css$Structure$Output$simpleSelectorSequenceToString(simpleSelectorSequence),
		A2($elm$core$List$map, $rtfeldman$elm_css$Css$Structure$Output$selectorChainToString, chain));
	var pseudoElementsString = A2(
		$elm$core$String$join,
		'',
		_List_fromArray(
			[
				A2(
				$elm$core$Maybe$withDefault,
				'',
				A2($elm$core$Maybe$map, $rtfeldman$elm_css$Css$Structure$Output$pseudoElementToString, pseudoElement))
			]));
	return A2(
		$elm$core$String$append,
		A2(
			$elm$core$String$join,
			' ',
			A2(
				$elm$core$List$filter,
				A2($elm$core$Basics$composeL, $elm$core$Basics$not, $elm$core$String$isEmpty),
				segments)),
		pseudoElementsString);
};
var $rtfeldman$elm_css$Css$Structure$Output$prettyPrintStyleBlock = F2(
	function (indentLevel, _v0) {
		var firstSelector = _v0.a;
		var otherSelectors = _v0.b;
		var properties = _v0.c;
		var selectorStr = A2(
			$elm$core$String$join,
			', ',
			A2(
				$elm$core$List$map,
				$rtfeldman$elm_css$Css$Structure$Output$selectorToString,
				A2($elm$core$List$cons, firstSelector, otherSelectors)));
		return A2(
			$elm$core$String$join,
			'',
			_List_fromArray(
				[
					selectorStr,
					' {\n',
					indentLevel,
					$rtfeldman$elm_css$Css$Structure$Output$emitProperties(properties),
					'\n',
					indentLevel,
					'}'
				]));
	});
var $rtfeldman$elm_css$Css$Structure$Output$prettyPrintDeclaration = function (decl) {
	switch (decl.$) {
		case 'StyleBlockDeclaration':
			var styleBlock = decl.a;
			return A2($rtfeldman$elm_css$Css$Structure$Output$prettyPrintStyleBlock, $rtfeldman$elm_css$Css$Structure$Output$noIndent, styleBlock);
		case 'MediaRule':
			var mediaQueries = decl.a;
			var styleBlocks = decl.b;
			var query = A2(
				$elm$core$String$join,
				',\n',
				A2($elm$core$List$map, $rtfeldman$elm_css$Css$Structure$Output$mediaQueryToString, mediaQueries));
			var blocks = A2(
				$elm$core$String$join,
				'\n\n',
				A2(
					$elm$core$List$map,
					A2(
						$elm$core$Basics$composeL,
						$rtfeldman$elm_css$Css$Structure$Output$indent,
						$rtfeldman$elm_css$Css$Structure$Output$prettyPrintStyleBlock($rtfeldman$elm_css$Css$Structure$Output$spaceIndent)),
					styleBlocks));
			return '@media ' + (query + (' {\n' + (blocks + '\n}')));
		case 'SupportsRule':
			return 'TODO';
		case 'DocumentRule':
			return 'TODO';
		case 'PageRule':
			return 'TODO';
		case 'FontFace':
			return 'TODO';
		case 'Keyframes':
			var name = decl.a.name;
			var declaration = decl.a.declaration;
			return '@keyframes ' + (name + (' {\n' + (declaration + '\n}')));
		case 'Viewport':
			return 'TODO';
		case 'CounterStyle':
			return 'TODO';
		default:
			return 'TODO';
	}
};
var $rtfeldman$elm_css$Css$Structure$Output$prettyPrint = function (_v0) {
	var charset = _v0.charset;
	var imports = _v0.imports;
	var namespaces = _v0.namespaces;
	var declarations = _v0.declarations;
	return A2(
		$elm$core$String$join,
		'\n\n',
		A2(
			$elm$core$List$filter,
			A2($elm$core$Basics$composeL, $elm$core$Basics$not, $elm$core$String$isEmpty),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$Structure$Output$charsetToString(charset),
					A2(
					$elm$core$String$join,
					'\n',
					A2($elm$core$List$map, $rtfeldman$elm_css$Css$Structure$Output$importToString, imports)),
					A2(
					$elm$core$String$join,
					'\n',
					A2($elm$core$List$map, $rtfeldman$elm_css$Css$Structure$Output$namespaceToString, namespaces)),
					A2(
					$elm$core$String$join,
					'\n\n',
					A2($elm$core$List$map, $rtfeldman$elm_css$Css$Structure$Output$prettyPrintDeclaration, declarations))
				])));
};
var $rtfeldman$elm_css$Css$Structure$CounterStyle = function (a) {
	return {$: 'CounterStyle', a: a};
};
var $rtfeldman$elm_css$Css$Structure$FontFace = function (a) {
	return {$: 'FontFace', a: a};
};
var $rtfeldman$elm_css$Css$Structure$PageRule = F2(
	function (a, b) {
		return {$: 'PageRule', a: a, b: b};
	});
var $rtfeldman$elm_css$Css$Structure$Selector = F3(
	function (a, b, c) {
		return {$: 'Selector', a: a, b: b, c: c};
	});
var $rtfeldman$elm_css$Css$Structure$StyleBlock = F3(
	function (a, b, c) {
		return {$: 'StyleBlock', a: a, b: b, c: c};
	});
var $rtfeldman$elm_css$Css$Structure$StyleBlockDeclaration = function (a) {
	return {$: 'StyleBlockDeclaration', a: a};
};
var $rtfeldman$elm_css$Css$Structure$SupportsRule = F2(
	function (a, b) {
		return {$: 'SupportsRule', a: a, b: b};
	});
var $rtfeldman$elm_css$Css$Structure$Viewport = function (a) {
	return {$: 'Viewport', a: a};
};
var $rtfeldman$elm_css$Css$Structure$MediaRule = F2(
	function (a, b) {
		return {$: 'MediaRule', a: a, b: b};
	});
var $rtfeldman$elm_css$Css$Structure$mapLast = F2(
	function (update, list) {
		if (!list.b) {
			return list;
		} else {
			if (!list.b.b) {
				var only = list.a;
				return _List_fromArray(
					[
						update(only)
					]);
			} else {
				var first = list.a;
				var rest = list.b;
				return A2(
					$elm$core$List$cons,
					first,
					A2($rtfeldman$elm_css$Css$Structure$mapLast, update, rest));
			}
		}
	});
var $rtfeldman$elm_css$Css$Structure$withPropertyAppended = F2(
	function (property, _v0) {
		var firstSelector = _v0.a;
		var otherSelectors = _v0.b;
		var properties = _v0.c;
		return A3(
			$rtfeldman$elm_css$Css$Structure$StyleBlock,
			firstSelector,
			otherSelectors,
			_Utils_ap(
				properties,
				_List_fromArray(
					[property])));
	});
var $rtfeldman$elm_css$Css$Structure$appendProperty = F2(
	function (property, declarations) {
		if (!declarations.b) {
			return declarations;
		} else {
			if (!declarations.b.b) {
				switch (declarations.a.$) {
					case 'StyleBlockDeclaration':
						var styleBlock = declarations.a.a;
						return _List_fromArray(
							[
								$rtfeldman$elm_css$Css$Structure$StyleBlockDeclaration(
								A2($rtfeldman$elm_css$Css$Structure$withPropertyAppended, property, styleBlock))
							]);
					case 'MediaRule':
						var _v1 = declarations.a;
						var mediaQueries = _v1.a;
						var styleBlocks = _v1.b;
						return _List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Css$Structure$MediaRule,
								mediaQueries,
								A2(
									$rtfeldman$elm_css$Css$Structure$mapLast,
									$rtfeldman$elm_css$Css$Structure$withPropertyAppended(property),
									styleBlocks))
							]);
					default:
						return declarations;
				}
			} else {
				var first = declarations.a;
				var rest = declarations.b;
				return A2(
					$elm$core$List$cons,
					first,
					A2($rtfeldman$elm_css$Css$Structure$appendProperty, property, rest));
			}
		}
	});
var $rtfeldman$elm_css$Css$Structure$appendToLastSelector = F2(
	function (f, styleBlock) {
		if (!styleBlock.b.b) {
			var only = styleBlock.a;
			var properties = styleBlock.c;
			return _List_fromArray(
				[
					A3($rtfeldman$elm_css$Css$Structure$StyleBlock, only, _List_Nil, properties),
					A3(
					$rtfeldman$elm_css$Css$Structure$StyleBlock,
					f(only),
					_List_Nil,
					_List_Nil)
				]);
		} else {
			var first = styleBlock.a;
			var rest = styleBlock.b;
			var properties = styleBlock.c;
			var newRest = A2($elm$core$List$map, f, rest);
			var newFirst = f(first);
			return _List_fromArray(
				[
					A3($rtfeldman$elm_css$Css$Structure$StyleBlock, first, rest, properties),
					A3($rtfeldman$elm_css$Css$Structure$StyleBlock, newFirst, newRest, _List_Nil)
				]);
		}
	});
var $rtfeldman$elm_css$Css$Structure$applyPseudoElement = F2(
	function (pseudo, _v0) {
		var sequence = _v0.a;
		var selectors = _v0.b;
		return A3(
			$rtfeldman$elm_css$Css$Structure$Selector,
			sequence,
			selectors,
			$elm$core$Maybe$Just(pseudo));
	});
var $rtfeldman$elm_css$Css$Structure$appendPseudoElementToLastSelector = F2(
	function (pseudo, styleBlock) {
		return A2(
			$rtfeldman$elm_css$Css$Structure$appendToLastSelector,
			$rtfeldman$elm_css$Css$Structure$applyPseudoElement(pseudo),
			styleBlock);
	});
var $rtfeldman$elm_css$Css$Structure$CustomSelector = F2(
	function (a, b) {
		return {$: 'CustomSelector', a: a, b: b};
	});
var $rtfeldman$elm_css$Css$Structure$TypeSelectorSequence = F2(
	function (a, b) {
		return {$: 'TypeSelectorSequence', a: a, b: b};
	});
var $rtfeldman$elm_css$Css$Structure$appendRepeatable = F2(
	function (selector, sequence) {
		switch (sequence.$) {
			case 'TypeSelectorSequence':
				var typeSelector = sequence.a;
				var list = sequence.b;
				return A2(
					$rtfeldman$elm_css$Css$Structure$TypeSelectorSequence,
					typeSelector,
					_Utils_ap(
						list,
						_List_fromArray(
							[selector])));
			case 'UniversalSelectorSequence':
				var list = sequence.a;
				return $rtfeldman$elm_css$Css$Structure$UniversalSelectorSequence(
					_Utils_ap(
						list,
						_List_fromArray(
							[selector])));
			default:
				var str = sequence.a;
				var list = sequence.b;
				return A2(
					$rtfeldman$elm_css$Css$Structure$CustomSelector,
					str,
					_Utils_ap(
						list,
						_List_fromArray(
							[selector])));
		}
	});
var $rtfeldman$elm_css$Css$Structure$appendRepeatableWithCombinator = F2(
	function (selector, list) {
		if (!list.b) {
			return _List_Nil;
		} else {
			if (!list.b.b) {
				var _v1 = list.a;
				var combinator = _v1.a;
				var sequence = _v1.b;
				return _List_fromArray(
					[
						_Utils_Tuple2(
						combinator,
						A2($rtfeldman$elm_css$Css$Structure$appendRepeatable, selector, sequence))
					]);
			} else {
				var first = list.a;
				var rest = list.b;
				return A2(
					$elm$core$List$cons,
					first,
					A2($rtfeldman$elm_css$Css$Structure$appendRepeatableWithCombinator, selector, rest));
			}
		}
	});
var $rtfeldman$elm_css$Css$Structure$appendRepeatableSelector = F2(
	function (repeatableSimpleSelector, selector) {
		if (!selector.b.b) {
			var sequence = selector.a;
			var pseudoElement = selector.c;
			return A3(
				$rtfeldman$elm_css$Css$Structure$Selector,
				A2($rtfeldman$elm_css$Css$Structure$appendRepeatable, repeatableSimpleSelector, sequence),
				_List_Nil,
				pseudoElement);
		} else {
			var firstSelector = selector.a;
			var tuples = selector.b;
			var pseudoElement = selector.c;
			return A3(
				$rtfeldman$elm_css$Css$Structure$Selector,
				firstSelector,
				A2($rtfeldman$elm_css$Css$Structure$appendRepeatableWithCombinator, repeatableSimpleSelector, tuples),
				pseudoElement);
		}
	});
var $rtfeldman$elm_css$Css$Structure$appendRepeatableToLastSelector = F2(
	function (selector, styleBlock) {
		return A2(
			$rtfeldman$elm_css$Css$Structure$appendToLastSelector,
			$rtfeldman$elm_css$Css$Structure$appendRepeatableSelector(selector),
			styleBlock);
	});
var $rtfeldman$elm_css$Css$Preprocess$Resolve$collectSelectors = function (declarations) {
	collectSelectors:
	while (true) {
		if (!declarations.b) {
			return _List_Nil;
		} else {
			if (declarations.a.$ === 'StyleBlockDeclaration') {
				var _v1 = declarations.a.a;
				var firstSelector = _v1.a;
				var otherSelectors = _v1.b;
				var rest = declarations.b;
				return _Utils_ap(
					A2($elm$core$List$cons, firstSelector, otherSelectors),
					$rtfeldman$elm_css$Css$Preprocess$Resolve$collectSelectors(rest));
			} else {
				var rest = declarations.b;
				var $temp$declarations = rest;
				declarations = $temp$declarations;
				continue collectSelectors;
			}
		}
	}
};
var $rtfeldman$elm_css$Css$Structure$DocumentRule = F5(
	function (a, b, c, d, e) {
		return {$: 'DocumentRule', a: a, b: b, c: c, d: d, e: e};
	});
var $rtfeldman$elm_css$Css$Structure$concatMapLastStyleBlock = F2(
	function (update, declarations) {
		_v0$12:
		while (true) {
			if (!declarations.b) {
				return declarations;
			} else {
				if (!declarations.b.b) {
					switch (declarations.a.$) {
						case 'StyleBlockDeclaration':
							var styleBlock = declarations.a.a;
							return A2(
								$elm$core$List$map,
								$rtfeldman$elm_css$Css$Structure$StyleBlockDeclaration,
								update(styleBlock));
						case 'MediaRule':
							if (declarations.a.b.b) {
								if (!declarations.a.b.b.b) {
									var _v1 = declarations.a;
									var mediaQueries = _v1.a;
									var _v2 = _v1.b;
									var styleBlock = _v2.a;
									return _List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Css$Structure$MediaRule,
											mediaQueries,
											update(styleBlock))
										]);
								} else {
									var _v3 = declarations.a;
									var mediaQueries = _v3.a;
									var _v4 = _v3.b;
									var first = _v4.a;
									var rest = _v4.b;
									var _v5 = A2(
										$rtfeldman$elm_css$Css$Structure$concatMapLastStyleBlock,
										update,
										_List_fromArray(
											[
												A2($rtfeldman$elm_css$Css$Structure$MediaRule, mediaQueries, rest)
											]));
									if ((_v5.b && (_v5.a.$ === 'MediaRule')) && (!_v5.b.b)) {
										var _v6 = _v5.a;
										var newMediaQueries = _v6.a;
										var newStyleBlocks = _v6.b;
										return _List_fromArray(
											[
												A2(
												$rtfeldman$elm_css$Css$Structure$MediaRule,
												newMediaQueries,
												A2($elm$core$List$cons, first, newStyleBlocks))
											]);
									} else {
										var newDeclarations = _v5;
										return newDeclarations;
									}
								}
							} else {
								break _v0$12;
							}
						case 'SupportsRule':
							var _v7 = declarations.a;
							var str = _v7.a;
							var nestedDeclarations = _v7.b;
							return _List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Css$Structure$SupportsRule,
									str,
									A2($rtfeldman$elm_css$Css$Structure$concatMapLastStyleBlock, update, nestedDeclarations))
								]);
						case 'DocumentRule':
							var _v8 = declarations.a;
							var str1 = _v8.a;
							var str2 = _v8.b;
							var str3 = _v8.c;
							var str4 = _v8.d;
							var styleBlock = _v8.e;
							return A2(
								$elm$core$List$map,
								A4($rtfeldman$elm_css$Css$Structure$DocumentRule, str1, str2, str3, str4),
								update(styleBlock));
						case 'PageRule':
							var _v9 = declarations.a;
							return declarations;
						case 'FontFace':
							return declarations;
						case 'Keyframes':
							return declarations;
						case 'Viewport':
							return declarations;
						case 'CounterStyle':
							return declarations;
						default:
							return declarations;
					}
				} else {
					break _v0$12;
				}
			}
		}
		var first = declarations.a;
		var rest = declarations.b;
		return A2(
			$elm$core$List$cons,
			first,
			A2($rtfeldman$elm_css$Css$Structure$concatMapLastStyleBlock, update, rest));
	});
var $rtfeldman$elm_css$ElmCssVendor$Murmur3$HashData = F4(
	function (shift, seed, hash, charsProcessed) {
		return {charsProcessed: charsProcessed, hash: hash, seed: seed, shift: shift};
	});
var $rtfeldman$elm_css$ElmCssVendor$Murmur3$c1 = 3432918353;
var $rtfeldman$elm_css$ElmCssVendor$Murmur3$c2 = 461845907;
var $rtfeldman$elm_css$ElmCssVendor$Murmur3$multiplyBy = F2(
	function (b, a) {
		return ((a & 65535) * b) + ((((a >>> 16) * b) & 65535) << 16);
	});
var $rtfeldman$elm_css$ElmCssVendor$Murmur3$rotlBy = F2(
	function (b, a) {
		return (a << b) | (a >>> (32 - b));
	});
var $rtfeldman$elm_css$ElmCssVendor$Murmur3$finalize = function (data) {
	var acc = (!(!data.hash)) ? (data.seed ^ A2(
		$rtfeldman$elm_css$ElmCssVendor$Murmur3$multiplyBy,
		$rtfeldman$elm_css$ElmCssVendor$Murmur3$c2,
		A2(
			$rtfeldman$elm_css$ElmCssVendor$Murmur3$rotlBy,
			15,
			A2($rtfeldman$elm_css$ElmCssVendor$Murmur3$multiplyBy, $rtfeldman$elm_css$ElmCssVendor$Murmur3$c1, data.hash)))) : data.seed;
	var h0 = acc ^ data.charsProcessed;
	var h1 = A2($rtfeldman$elm_css$ElmCssVendor$Murmur3$multiplyBy, 2246822507, h0 ^ (h0 >>> 16));
	var h2 = A2($rtfeldman$elm_css$ElmCssVendor$Murmur3$multiplyBy, 3266489909, h1 ^ (h1 >>> 13));
	return (h2 ^ (h2 >>> 16)) >>> 0;
};
var $rtfeldman$elm_css$ElmCssVendor$Murmur3$mix = F2(
	function (h1, k1) {
		return A2(
			$rtfeldman$elm_css$ElmCssVendor$Murmur3$multiplyBy,
			5,
			A2(
				$rtfeldman$elm_css$ElmCssVendor$Murmur3$rotlBy,
				13,
				h1 ^ A2(
					$rtfeldman$elm_css$ElmCssVendor$Murmur3$multiplyBy,
					$rtfeldman$elm_css$ElmCssVendor$Murmur3$c2,
					A2(
						$rtfeldman$elm_css$ElmCssVendor$Murmur3$rotlBy,
						15,
						A2($rtfeldman$elm_css$ElmCssVendor$Murmur3$multiplyBy, $rtfeldman$elm_css$ElmCssVendor$Murmur3$c1, k1))))) + 3864292196;
	});
var $rtfeldman$elm_css$ElmCssVendor$Murmur3$hashFold = F2(
	function (c, data) {
		var res = data.hash | ((255 & $elm$core$Char$toCode(c)) << data.shift);
		var _v0 = data.shift;
		if (_v0 === 24) {
			return {
				charsProcessed: data.charsProcessed + 1,
				hash: 0,
				seed: A2($rtfeldman$elm_css$ElmCssVendor$Murmur3$mix, data.seed, res),
				shift: 0
			};
		} else {
			return {charsProcessed: data.charsProcessed + 1, hash: res, seed: data.seed, shift: data.shift + 8};
		}
	});
var $rtfeldman$elm_css$ElmCssVendor$Murmur3$hashString = F2(
	function (seed, str) {
		return $rtfeldman$elm_css$ElmCssVendor$Murmur3$finalize(
			A3(
				$elm$core$String$foldl,
				$rtfeldman$elm_css$ElmCssVendor$Murmur3$hashFold,
				A4($rtfeldman$elm_css$ElmCssVendor$Murmur3$HashData, 0, seed, 0, 0),
				str));
	});
var $rtfeldman$elm_css$Hash$murmurSeed = 15739;
var $rtfeldman$elm_hex$Hex$unsafeToDigit = function (num) {
	unsafeToDigit:
	while (true) {
		switch (num) {
			case 0:
				return _Utils_chr('0');
			case 1:
				return _Utils_chr('1');
			case 2:
				return _Utils_chr('2');
			case 3:
				return _Utils_chr('3');
			case 4:
				return _Utils_chr('4');
			case 5:
				return _Utils_chr('5');
			case 6:
				return _Utils_chr('6');
			case 7:
				return _Utils_chr('7');
			case 8:
				return _Utils_chr('8');
			case 9:
				return _Utils_chr('9');
			case 10:
				return _Utils_chr('a');
			case 11:
				return _Utils_chr('b');
			case 12:
				return _Utils_chr('c');
			case 13:
				return _Utils_chr('d');
			case 14:
				return _Utils_chr('e');
			case 15:
				return _Utils_chr('f');
			default:
				var $temp$num = num;
				num = $temp$num;
				continue unsafeToDigit;
		}
	}
};
var $rtfeldman$elm_hex$Hex$unsafePositiveToDigits = F2(
	function (digits, num) {
		unsafePositiveToDigits:
		while (true) {
			if (num < 16) {
				return A2(
					$elm$core$List$cons,
					$rtfeldman$elm_hex$Hex$unsafeToDigit(num),
					digits);
			} else {
				var $temp$digits = A2(
					$elm$core$List$cons,
					$rtfeldman$elm_hex$Hex$unsafeToDigit(
						A2($elm$core$Basics$modBy, 16, num)),
					digits),
					$temp$num = (num / 16) | 0;
				digits = $temp$digits;
				num = $temp$num;
				continue unsafePositiveToDigits;
			}
		}
	});
var $rtfeldman$elm_hex$Hex$toString = function (num) {
	return $elm$core$String$fromList(
		(num < 0) ? A2(
			$elm$core$List$cons,
			_Utils_chr('-'),
			A2($rtfeldman$elm_hex$Hex$unsafePositiveToDigits, _List_Nil, -num)) : A2($rtfeldman$elm_hex$Hex$unsafePositiveToDigits, _List_Nil, num));
};
var $rtfeldman$elm_css$Hash$fromString = function (str) {
	return A2(
		$elm$core$String$cons,
		_Utils_chr('_'),
		$rtfeldman$elm_hex$Hex$toString(
			A2($rtfeldman$elm_css$ElmCssVendor$Murmur3$hashString, $rtfeldman$elm_css$Hash$murmurSeed, str)));
};
var $rtfeldman$elm_css$Css$Preprocess$Resolve$last = function (list) {
	last:
	while (true) {
		if (!list.b) {
			return $elm$core$Maybe$Nothing;
		} else {
			if (!list.b.b) {
				var singleton = list.a;
				return $elm$core$Maybe$Just(singleton);
			} else {
				var rest = list.b;
				var $temp$list = rest;
				list = $temp$list;
				continue last;
			}
		}
	}
};
var $rtfeldman$elm_css$Css$Preprocess$Resolve$lastDeclaration = function (declarations) {
	lastDeclaration:
	while (true) {
		if (!declarations.b) {
			return $elm$core$Maybe$Nothing;
		} else {
			if (!declarations.b.b) {
				var x = declarations.a;
				return $elm$core$Maybe$Just(
					_List_fromArray(
						[x]));
			} else {
				var xs = declarations.b;
				var $temp$declarations = xs;
				declarations = $temp$declarations;
				continue lastDeclaration;
			}
		}
	}
};
var $rtfeldman$elm_css$Css$Preprocess$Resolve$oneOf = function (maybes) {
	oneOf:
	while (true) {
		if (!maybes.b) {
			return $elm$core$Maybe$Nothing;
		} else {
			var maybe = maybes.a;
			var rest = maybes.b;
			if (maybe.$ === 'Nothing') {
				var $temp$maybes = rest;
				maybes = $temp$maybes;
				continue oneOf;
			} else {
				return maybe;
			}
		}
	}
};
var $rtfeldman$elm_css$Css$Structure$FontFeatureValues = function (a) {
	return {$: 'FontFeatureValues', a: a};
};
var $rtfeldman$elm_css$Css$Preprocess$Resolve$resolveFontFeatureValues = function (tuples) {
	var expandTuples = function (tuplesToExpand) {
		if (!tuplesToExpand.b) {
			return _List_Nil;
		} else {
			var properties = tuplesToExpand.a;
			var rest = tuplesToExpand.b;
			return A2(
				$elm$core$List$cons,
				properties,
				expandTuples(rest));
		}
	};
	var newTuples = expandTuples(tuples);
	return _List_fromArray(
		[
			$rtfeldman$elm_css$Css$Structure$FontFeatureValues(newTuples)
		]);
};
var $rtfeldman$elm_css$Css$Structure$styleBlockToMediaRule = F2(
	function (mediaQueries, declaration) {
		if (declaration.$ === 'StyleBlockDeclaration') {
			var styleBlock = declaration.a;
			return A2(
				$rtfeldman$elm_css$Css$Structure$MediaRule,
				mediaQueries,
				_List_fromArray(
					[styleBlock]));
		} else {
			return declaration;
		}
	});
var $rtfeldman$elm_css$Css$Preprocess$Resolve$toDocumentRule = F5(
	function (str1, str2, str3, str4, declaration) {
		if (declaration.$ === 'StyleBlockDeclaration') {
			var structureStyleBlock = declaration.a;
			return A5($rtfeldman$elm_css$Css$Structure$DocumentRule, str1, str2, str3, str4, structureStyleBlock);
		} else {
			return declaration;
		}
	});
var $rtfeldman$elm_css$Css$Preprocess$Resolve$toMediaRule = F2(
	function (mediaQueries, declaration) {
		switch (declaration.$) {
			case 'StyleBlockDeclaration':
				var structureStyleBlock = declaration.a;
				return A2(
					$rtfeldman$elm_css$Css$Structure$MediaRule,
					mediaQueries,
					_List_fromArray(
						[structureStyleBlock]));
			case 'MediaRule':
				var newMediaQueries = declaration.a;
				var structureStyleBlocks = declaration.b;
				return A2(
					$rtfeldman$elm_css$Css$Structure$MediaRule,
					_Utils_ap(mediaQueries, newMediaQueries),
					structureStyleBlocks);
			case 'SupportsRule':
				var str = declaration.a;
				var declarations = declaration.b;
				return A2(
					$rtfeldman$elm_css$Css$Structure$SupportsRule,
					str,
					A2(
						$elm$core$List$map,
						$rtfeldman$elm_css$Css$Preprocess$Resolve$toMediaRule(mediaQueries),
						declarations));
			case 'DocumentRule':
				var str1 = declaration.a;
				var str2 = declaration.b;
				var str3 = declaration.c;
				var str4 = declaration.d;
				var structureStyleBlock = declaration.e;
				return A5($rtfeldman$elm_css$Css$Structure$DocumentRule, str1, str2, str3, str4, structureStyleBlock);
			case 'PageRule':
				return declaration;
			case 'FontFace':
				return declaration;
			case 'Keyframes':
				return declaration;
			case 'Viewport':
				return declaration;
			case 'CounterStyle':
				return declaration;
			default:
				return declaration;
		}
	});
var $rtfeldman$elm_css$Css$Preprocess$unwrapSnippet = function (_v0) {
	var declarations = _v0.a;
	return declarations;
};
var $rtfeldman$elm_css$Css$Preprocess$Resolve$applyNestedStylesToLast = F4(
	function (nestedStyles, rest, f, declarations) {
		var withoutParent = function (decls) {
			return A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				$elm$core$List$tail(decls));
		};
		var nextResult = A2(
			$rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles,
			rest,
			A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				$rtfeldman$elm_css$Css$Preprocess$Resolve$lastDeclaration(declarations)));
		var newDeclarations = function () {
			var _v14 = _Utils_Tuple2(
				$elm$core$List$head(nextResult),
				$rtfeldman$elm_css$Css$Preprocess$Resolve$last(declarations));
			if ((_v14.a.$ === 'Just') && (_v14.b.$ === 'Just')) {
				var nextResultParent = _v14.a.a;
				var originalParent = _v14.b.a;
				return _Utils_ap(
					A2(
						$elm$core$List$take,
						$elm$core$List$length(declarations) - 1,
						declarations),
					_List_fromArray(
						[
							(!_Utils_eq(originalParent, nextResultParent)) ? nextResultParent : originalParent
						]));
			} else {
				return declarations;
			}
		}();
		var insertStylesToNestedDecl = function (lastDecl) {
			return $elm$core$List$concat(
				A2(
					$rtfeldman$elm_css$Css$Structure$mapLast,
					$rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles(nestedStyles),
					A2(
						$elm$core$List$map,
						$elm$core$List$singleton,
						A2($rtfeldman$elm_css$Css$Structure$concatMapLastStyleBlock, f, lastDecl))));
		};
		var initialResult = A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				insertStylesToNestedDecl,
				$rtfeldman$elm_css$Css$Preprocess$Resolve$lastDeclaration(declarations)));
		return _Utils_ap(
			newDeclarations,
			_Utils_ap(
				withoutParent(initialResult),
				withoutParent(nextResult)));
	});
var $rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles = F2(
	function (styles, declarations) {
		if (!styles.b) {
			return declarations;
		} else {
			switch (styles.a.$) {
				case 'AppendProperty':
					var property = styles.a.a;
					var rest = styles.b;
					return A2(
						$rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles,
						rest,
						A2($rtfeldman$elm_css$Css$Structure$appendProperty, property, declarations));
				case 'ExtendSelector':
					var _v4 = styles.a;
					var selector = _v4.a;
					var nestedStyles = _v4.b;
					var rest = styles.b;
					return A4(
						$rtfeldman$elm_css$Css$Preprocess$Resolve$applyNestedStylesToLast,
						nestedStyles,
						rest,
						$rtfeldman$elm_css$Css$Structure$appendRepeatableToLastSelector(selector),
						declarations);
				case 'NestSnippet':
					var _v5 = styles.a;
					var selectorCombinator = _v5.a;
					var snippets = _v5.b;
					var rest = styles.b;
					var chain = F2(
						function (_v9, _v10) {
							var originalSequence = _v9.a;
							var originalTuples = _v9.b;
							var originalPseudoElement = _v9.c;
							var newSequence = _v10.a;
							var newTuples = _v10.b;
							var newPseudoElement = _v10.c;
							return A3(
								$rtfeldman$elm_css$Css$Structure$Selector,
								originalSequence,
								_Utils_ap(
									originalTuples,
									A2(
										$elm$core$List$cons,
										_Utils_Tuple2(selectorCombinator, newSequence),
										newTuples)),
								$rtfeldman$elm_css$Css$Preprocess$Resolve$oneOf(
									_List_fromArray(
										[newPseudoElement, originalPseudoElement])));
						});
					var expandDeclaration = function (declaration) {
						switch (declaration.$) {
							case 'StyleBlockDeclaration':
								var _v7 = declaration.a;
								var firstSelector = _v7.a;
								var otherSelectors = _v7.b;
								var nestedStyles = _v7.c;
								var newSelectors = A2(
									$elm$core$List$concatMap,
									function (originalSelector) {
										return A2(
											$elm$core$List$map,
											chain(originalSelector),
											A2($elm$core$List$cons, firstSelector, otherSelectors));
									},
									$rtfeldman$elm_css$Css$Preprocess$Resolve$collectSelectors(declarations));
								var newDeclarations = function () {
									if (!newSelectors.b) {
										return _List_Nil;
									} else {
										var first = newSelectors.a;
										var remainder = newSelectors.b;
										return _List_fromArray(
											[
												$rtfeldman$elm_css$Css$Structure$StyleBlockDeclaration(
												A3($rtfeldman$elm_css$Css$Structure$StyleBlock, first, remainder, _List_Nil))
											]);
									}
								}();
								return A2($rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles, nestedStyles, newDeclarations);
							case 'MediaRule':
								var mediaQueries = declaration.a;
								var styleBlocks = declaration.b;
								return A2($rtfeldman$elm_css$Css$Preprocess$Resolve$resolveMediaRule, mediaQueries, styleBlocks);
							case 'SupportsRule':
								var str = declaration.a;
								var otherSnippets = declaration.b;
								return A2($rtfeldman$elm_css$Css$Preprocess$Resolve$resolveSupportsRule, str, otherSnippets);
							case 'DocumentRule':
								var str1 = declaration.a;
								var str2 = declaration.b;
								var str3 = declaration.c;
								var str4 = declaration.d;
								var styleBlock = declaration.e;
								return A2(
									$elm$core$List$map,
									A4($rtfeldman$elm_css$Css$Preprocess$Resolve$toDocumentRule, str1, str2, str3, str4),
									$rtfeldman$elm_css$Css$Preprocess$Resolve$expandStyleBlock(styleBlock));
							case 'PageRule':
								var str = declaration.a;
								var properties = declaration.b;
								return _List_fromArray(
									[
										A2($rtfeldman$elm_css$Css$Structure$PageRule, str, properties)
									]);
							case 'FontFace':
								var properties = declaration.a;
								return _List_fromArray(
									[
										$rtfeldman$elm_css$Css$Structure$FontFace(properties)
									]);
							case 'Viewport':
								var properties = declaration.a;
								return _List_fromArray(
									[
										$rtfeldman$elm_css$Css$Structure$Viewport(properties)
									]);
							case 'CounterStyle':
								var properties = declaration.a;
								return _List_fromArray(
									[
										$rtfeldman$elm_css$Css$Structure$CounterStyle(properties)
									]);
							default:
								var tuples = declaration.a;
								return $rtfeldman$elm_css$Css$Preprocess$Resolve$resolveFontFeatureValues(tuples);
						}
					};
					return $elm$core$List$concat(
						_Utils_ap(
							_List_fromArray(
								[
									A2($rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles, rest, declarations)
								]),
							A2(
								$elm$core$List$map,
								expandDeclaration,
								A2($elm$core$List$concatMap, $rtfeldman$elm_css$Css$Preprocess$unwrapSnippet, snippets))));
				case 'WithPseudoElement':
					var _v11 = styles.a;
					var pseudoElement = _v11.a;
					var nestedStyles = _v11.b;
					var rest = styles.b;
					return A4(
						$rtfeldman$elm_css$Css$Preprocess$Resolve$applyNestedStylesToLast,
						nestedStyles,
						rest,
						$rtfeldman$elm_css$Css$Structure$appendPseudoElementToLastSelector(pseudoElement),
						declarations);
				case 'WithKeyframes':
					var str = styles.a.a;
					var rest = styles.b;
					var name = $rtfeldman$elm_css$Hash$fromString(str);
					var newProperty = 'animation-name:' + name;
					var newDeclarations = A2(
						$rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles,
						rest,
						A2($rtfeldman$elm_css$Css$Structure$appendProperty, newProperty, declarations));
					return A2(
						$elm$core$List$append,
						newDeclarations,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Css$Structure$Keyframes(
								{declaration: str, name: name})
							]));
				case 'WithMedia':
					var _v12 = styles.a;
					var mediaQueries = _v12.a;
					var nestedStyles = _v12.b;
					var rest = styles.b;
					var extraDeclarations = function () {
						var _v13 = $rtfeldman$elm_css$Css$Preprocess$Resolve$collectSelectors(declarations);
						if (!_v13.b) {
							return _List_Nil;
						} else {
							var firstSelector = _v13.a;
							var otherSelectors = _v13.b;
							return A2(
								$elm$core$List$map,
								$rtfeldman$elm_css$Css$Structure$styleBlockToMediaRule(mediaQueries),
								A2(
									$rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles,
									nestedStyles,
									$elm$core$List$singleton(
										$rtfeldman$elm_css$Css$Structure$StyleBlockDeclaration(
											A3($rtfeldman$elm_css$Css$Structure$StyleBlock, firstSelector, otherSelectors, _List_Nil)))));
						}
					}();
					return _Utils_ap(
						A2($rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles, rest, declarations),
						extraDeclarations);
				default:
					var otherStyles = styles.a.a;
					var rest = styles.b;
					return A2(
						$rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles,
						_Utils_ap(otherStyles, rest),
						declarations);
			}
		}
	});
var $rtfeldman$elm_css$Css$Preprocess$Resolve$expandStyleBlock = function (_v2) {
	var firstSelector = _v2.a;
	var otherSelectors = _v2.b;
	var styles = _v2.c;
	return A2(
		$rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles,
		styles,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Css$Structure$StyleBlockDeclaration(
				A3($rtfeldman$elm_css$Css$Structure$StyleBlock, firstSelector, otherSelectors, _List_Nil))
			]));
};
var $rtfeldman$elm_css$Css$Preprocess$Resolve$extract = function (snippetDeclarations) {
	if (!snippetDeclarations.b) {
		return _List_Nil;
	} else {
		var first = snippetDeclarations.a;
		var rest = snippetDeclarations.b;
		return _Utils_ap(
			$rtfeldman$elm_css$Css$Preprocess$Resolve$toDeclarations(first),
			$rtfeldman$elm_css$Css$Preprocess$Resolve$extract(rest));
	}
};
var $rtfeldman$elm_css$Css$Preprocess$Resolve$resolveMediaRule = F2(
	function (mediaQueries, styleBlocks) {
		var handleStyleBlock = function (styleBlock) {
			return A2(
				$elm$core$List$map,
				$rtfeldman$elm_css$Css$Preprocess$Resolve$toMediaRule(mediaQueries),
				$rtfeldman$elm_css$Css$Preprocess$Resolve$expandStyleBlock(styleBlock));
		};
		return A2($elm$core$List$concatMap, handleStyleBlock, styleBlocks);
	});
var $rtfeldman$elm_css$Css$Preprocess$Resolve$resolveSupportsRule = F2(
	function (str, snippets) {
		var declarations = $rtfeldman$elm_css$Css$Preprocess$Resolve$extract(
			A2($elm$core$List$concatMap, $rtfeldman$elm_css$Css$Preprocess$unwrapSnippet, snippets));
		return _List_fromArray(
			[
				A2($rtfeldman$elm_css$Css$Structure$SupportsRule, str, declarations)
			]);
	});
var $rtfeldman$elm_css$Css$Preprocess$Resolve$toDeclarations = function (snippetDeclaration) {
	switch (snippetDeclaration.$) {
		case 'StyleBlockDeclaration':
			var styleBlock = snippetDeclaration.a;
			return $rtfeldman$elm_css$Css$Preprocess$Resolve$expandStyleBlock(styleBlock);
		case 'MediaRule':
			var mediaQueries = snippetDeclaration.a;
			var styleBlocks = snippetDeclaration.b;
			return A2($rtfeldman$elm_css$Css$Preprocess$Resolve$resolveMediaRule, mediaQueries, styleBlocks);
		case 'SupportsRule':
			var str = snippetDeclaration.a;
			var snippets = snippetDeclaration.b;
			return A2($rtfeldman$elm_css$Css$Preprocess$Resolve$resolveSupportsRule, str, snippets);
		case 'DocumentRule':
			var str1 = snippetDeclaration.a;
			var str2 = snippetDeclaration.b;
			var str3 = snippetDeclaration.c;
			var str4 = snippetDeclaration.d;
			var styleBlock = snippetDeclaration.e;
			return A2(
				$elm$core$List$map,
				A4($rtfeldman$elm_css$Css$Preprocess$Resolve$toDocumentRule, str1, str2, str3, str4),
				$rtfeldman$elm_css$Css$Preprocess$Resolve$expandStyleBlock(styleBlock));
		case 'PageRule':
			var str = snippetDeclaration.a;
			var properties = snippetDeclaration.b;
			return _List_fromArray(
				[
					A2($rtfeldman$elm_css$Css$Structure$PageRule, str, properties)
				]);
		case 'FontFace':
			var properties = snippetDeclaration.a;
			return _List_fromArray(
				[
					$rtfeldman$elm_css$Css$Structure$FontFace(properties)
				]);
		case 'Viewport':
			var properties = snippetDeclaration.a;
			return _List_fromArray(
				[
					$rtfeldman$elm_css$Css$Structure$Viewport(properties)
				]);
		case 'CounterStyle':
			var properties = snippetDeclaration.a;
			return _List_fromArray(
				[
					$rtfeldman$elm_css$Css$Structure$CounterStyle(properties)
				]);
		default:
			var tuples = snippetDeclaration.a;
			return $rtfeldman$elm_css$Css$Preprocess$Resolve$resolveFontFeatureValues(tuples);
	}
};
var $rtfeldman$elm_css$Css$Preprocess$Resolve$toStructure = function (_v0) {
	var charset = _v0.charset;
	var imports = _v0.imports;
	var namespaces = _v0.namespaces;
	var snippets = _v0.snippets;
	var declarations = $rtfeldman$elm_css$Css$Preprocess$Resolve$extract(
		A2($elm$core$List$concatMap, $rtfeldman$elm_css$Css$Preprocess$unwrapSnippet, snippets));
	return {charset: charset, declarations: declarations, imports: imports, namespaces: namespaces};
};
var $rtfeldman$elm_css$Css$Preprocess$Resolve$compileHelp = function (sheet) {
	return $rtfeldman$elm_css$Css$Structure$Output$prettyPrint(
		$rtfeldman$elm_css$Css$Structure$compactStylesheet(
			$rtfeldman$elm_css$Css$Preprocess$Resolve$toStructure(sheet)));
};
var $rtfeldman$elm_css$Css$Preprocess$Resolve$compile = function (styles) {
	return A2(
		$elm$core$String$join,
		'\n\n',
		A2($elm$core$List$map, $rtfeldman$elm_css$Css$Preprocess$Resolve$compileHelp, styles));
};
var $rtfeldman$elm_css$Css$Preprocess$Snippet = function (a) {
	return {$: 'Snippet', a: a};
};
var $rtfeldman$elm_css$Css$Preprocess$StyleBlock = F3(
	function (a, b, c) {
		return {$: 'StyleBlock', a: a, b: b, c: c};
	});
var $rtfeldman$elm_css$Css$Preprocess$StyleBlockDeclaration = function (a) {
	return {$: 'StyleBlockDeclaration', a: a};
};
var $rtfeldman$elm_css$VirtualDom$Styled$makeSnippet = F2(
	function (styles, sequence) {
		var selector = A3($rtfeldman$elm_css$Css$Structure$Selector, sequence, _List_Nil, $elm$core$Maybe$Nothing);
		return $rtfeldman$elm_css$Css$Preprocess$Snippet(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$Preprocess$StyleBlockDeclaration(
					A3($rtfeldman$elm_css$Css$Preprocess$StyleBlock, selector, _List_Nil, styles))
				]));
	});
var $rtfeldman$elm_css$VirtualDom$Styled$murmurSeed = 15739;
var $rtfeldman$elm_css$Css$Preprocess$stylesheet = function (snippets) {
	return {charset: $elm$core$Maybe$Nothing, imports: _List_Nil, namespaces: _List_Nil, snippets: snippets};
};
var $rtfeldman$elm_css$VirtualDom$Styled$getClassname = function (styles) {
	return $elm$core$List$isEmpty(styles) ? 'unstyled' : A2(
		$elm$core$String$cons,
		_Utils_chr('_'),
		$rtfeldman$elm_hex$Hex$toString(
			A2(
				$rtfeldman$elm_css$ElmCssVendor$Murmur3$hashString,
				$rtfeldman$elm_css$VirtualDom$Styled$murmurSeed,
				$rtfeldman$elm_css$Css$Preprocess$Resolve$compile(
					$elm$core$List$singleton(
						$rtfeldman$elm_css$Css$Preprocess$stylesheet(
							$elm$core$List$singleton(
								A2(
									$rtfeldman$elm_css$VirtualDom$Styled$makeSnippet,
									styles,
									$rtfeldman$elm_css$Css$Structure$UniversalSelectorSequence(_List_Nil)))))))));
};
var $elm$virtual_dom$VirtualDom$property = F2(
	function (key, value) {
		return A2(
			_VirtualDom_property,
			_VirtualDom_noInnerHtmlOrFormAction(key),
			_VirtualDom_noJavaScriptOrHtmlUri(value));
	});
var $rtfeldman$elm_css$Html$Styled$Internal$css = function (styles) {
	var classname = $rtfeldman$elm_css$VirtualDom$Styled$getClassname(styles);
	var classProperty = A2(
		$elm$virtual_dom$VirtualDom$property,
		'className',
		$elm$json$Json$Encode$string(classname));
	return A3($rtfeldman$elm_css$VirtualDom$Styled$Attribute, classProperty, styles, classname);
};
var $rtfeldman$elm_css$Html$Styled$Attributes$css = $rtfeldman$elm_css$Html$Styled$Internal$css;
var $author$project$Material$Styled$Button$mergeButtonStyles = function (config) {
	var buttonStyle = config.isDisabled ? _Utils_ap(
		$author$project$Material$Styled$Button$style.disabled(config.theme),
		config.buttonStyles) : _Utils_ap(
		$author$project$Material$Styled$Button$style.enabled(config.theme),
		config.buttonStyles);
	return _Utils_update(
		config,
		{
			buttonAttributes: A2(
				$elm$core$List$cons,
				$rtfeldman$elm_css$Html$Styled$Attributes$css(buttonStyle),
				config.buttonAttributes)
		});
};
var $elm$virtual_dom$VirtualDom$Normal = function (a) {
	return {$: 'Normal', a: a};
};
var $elm$virtual_dom$VirtualDom$on = _VirtualDom_on;
var $rtfeldman$elm_css$VirtualDom$Styled$on = F2(
	function (eventName, handler) {
		return A3(
			$rtfeldman$elm_css$VirtualDom$Styled$Attribute,
			A2($elm$virtual_dom$VirtualDom$on, eventName, handler),
			_List_Nil,
			'');
	});
var $rtfeldman$elm_css$Html$Styled$Events$on = F2(
	function (event, decoder) {
		return A2(
			$rtfeldman$elm_css$VirtualDom$Styled$on,
			event,
			$elm$virtual_dom$VirtualDom$Normal(decoder));
	});
var $rtfeldman$elm_css$Html$Styled$Events$onClick = function (msg) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$Events$on,
		'click',
		$elm$json$Json$Decode$succeed(msg));
};
var $rtfeldman$elm_css$VirtualDom$Styled$property = F2(
	function (key, value) {
		return A3(
			$rtfeldman$elm_css$VirtualDom$Styled$Attribute,
			A2($elm$virtual_dom$VirtualDom$property, key, value),
			_List_Nil,
			'');
	});
var $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty = F2(
	function (key, string) {
		return A2(
			$rtfeldman$elm_css$VirtualDom$Styled$property,
			key,
			$elm$json$Json$Encode$string(string));
	});
var $rtfeldman$elm_css$Html$Styled$Attributes$type_ = $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty('type');
var $author$project$Material$Styled$Button$mergeProperty = F2(
	function (property, config) {
		switch (property.$) {
			case 'OnClick':
				var msg = property.a;
				return _Utils_update(
					config,
					{
						buttonAttributes: A2(
							$elm$core$List$cons,
							$rtfeldman$elm_css$Html$Styled$Events$onClick(msg),
							config.buttonAttributes)
					});
			case 'Disabled':
				var bool = property.a;
				return _Utils_update(
					config,
					{isDisabled: bool});
			case 'ButtonStyles':
				var styles_ = property.a;
				return _Utils_update(
					config,
					{
						buttonStyles: _Utils_ap(config.buttonStyles, styles_)
					});
			case 'ButtonTheme':
				var theme_ = property.a;
				return _Utils_update(
					config,
					{theme: theme_});
			case 'TestAttributeId':
				var id_ = property.a;
				return _Utils_update(
					config,
					{
						buttonAttributes: A2(
							$elm$core$List$cons,
							A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'data-test', id_),
							config.buttonAttributes)
					});
			default:
				var type_ = property.a;
				switch (type_.$) {
					case 'ButtonType':
						return _Utils_update(
							config,
							{
								buttonAttributes: A2(
									$elm$core$List$cons,
									$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
									config.buttonAttributes)
							});
					case 'SubmitType':
						return _Utils_update(
							config,
							{
								buttonAttributes: A2(
									$elm$core$List$cons,
									$rtfeldman$elm_css$Html$Styled$Attributes$type_('submit'),
									config.buttonAttributes)
							});
					default:
						return _Utils_update(
							config,
							{
								buttonAttributes: A2(
									$elm$core$List$cons,
									$rtfeldman$elm_css$Html$Styled$Attributes$type_('reset'),
									config.buttonAttributes)
							});
				}
		}
	});
var $author$project$Material$Styled$Button$mergeConfig = F2(
	function (config, properties) {
		return $author$project$Material$Styled$Button$mergeButtonStyles(
			A3($elm$core$List$foldl, $author$project$Material$Styled$Button$mergeProperty, config, properties));
	});
var $author$project$Material$Styled$Button$button = F2(
	function (properties, children) {
		var _v0 = A2($author$project$Material$Styled$Button$mergeConfig, $author$project$Material$Styled$Button$defaultConfig, properties);
		var buttonAttributes = _v0.buttonAttributes;
		return A2($rtfeldman$elm_css$Html$Styled$button, buttonAttributes, children);
	});
var $author$project$Material$Styled$Icon$Close$view = F2(
	function (attributes, children) {
		return A2(
			$rtfeldman$elm_css$Svg$Styled$svg,
			_Utils_ap(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Svg$Styled$Attributes$fill('black'),
						$rtfeldman$elm_css$Svg$Styled$Attributes$width('24px'),
						$rtfeldman$elm_css$Svg$Styled$Attributes$height('24px'),
						$rtfeldman$elm_css$Svg$Styled$Attributes$viewBox('0 0 24 24'),
						A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'data-test', 'close')
					]),
				attributes),
			_Utils_ap(
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Svg$Styled$path,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Svg$Styled$Attributes$d('M0 0h24v24H0z'),
								$rtfeldman$elm_css$Svg$Styled$Attributes$fill('none')
							]),
						_List_Nil),
						A2(
						$rtfeldman$elm_css$Svg$Styled$path,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Svg$Styled$Attributes$d('M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z')
							]),
						_List_Nil)
					]),
				children));
	});
var $author$project$Material$Styled$Icon$close = $author$project$Material$Styled$Icon$Close$view;
var $author$project$Type$ActionButton$Document = {$: 'Document'};
var $author$project$Type$ActionButton$OpenModal = function (a) {
	return {$: 'OpenModal', a: a};
};
var $author$project$Material$Styled$Icon$AddCircle$view = F2(
	function (attributes, children) {
		return A2(
			$rtfeldman$elm_css$Svg$Styled$svg,
			_Utils_ap(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Svg$Styled$Attributes$fill('black'),
						$rtfeldman$elm_css$Svg$Styled$Attributes$width('18px'),
						$rtfeldman$elm_css$Svg$Styled$Attributes$height('18px'),
						$rtfeldman$elm_css$Svg$Styled$Attributes$viewBox('0 0 24 24')
					]),
				attributes),
			_Utils_ap(
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Svg$Styled$path,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Svg$Styled$Attributes$d('M0 0h24v24H0z'),
								$rtfeldman$elm_css$Svg$Styled$Attributes$fill('none')
							]),
						_List_Nil),
						A2(
						$rtfeldman$elm_css$Svg$Styled$path,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Svg$Styled$Attributes$d('M13 7h-2v4H7v2h4v4h2v-4h4v-2h-4V7zm-1-5C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z')
							]),
						_List_Nil)
					]),
				children));
	});
var $author$project$Material$Styled$Icon$addCircle = $author$project$Material$Styled$Icon$AddCircle$view;
var $author$project$Type$ActionButton$Template = {$: 'Template'};
var $rtfeldman$elm_css$Html$Styled$div = $rtfeldman$elm_css$Html$Styled$node('div');
var $rtfeldman$elm_css$Html$Styled$span = $rtfeldman$elm_css$Html$Styled$node('span');
var $rtfeldman$elm_css$Css$alignItems = function (fn) {
	return A3(
		$rtfeldman$elm_css$Css$Internal$getOverloadedProperty,
		'alignItems',
		'align-items',
		fn($rtfeldman$elm_css$Css$Internal$lengthForOverloadedProperty));
};
var $rtfeldman$elm_css$Css$Internal$printKeyframeSelector = function (_v0) {
	var percentage = _v0.a;
	var properties = _v0.b;
	var propertiesStr = A2(
		$elm$core$String$join,
		'',
		A2(
			$elm$core$List$map,
			function (_v1) {
				var prop = _v1.a;
				return prop + ';';
			},
			properties));
	var percentageStr = $elm$core$String$fromInt(percentage) + '%';
	return percentageStr + (' {' + (propertiesStr + '}'));
};
var $rtfeldman$elm_css$Css$Internal$compileKeyframes = function (tuples) {
	return A2(
		$elm$core$String$join,
		'\n\n',
		A2($elm$core$List$map, $rtfeldman$elm_css$Css$Internal$printKeyframeSelector, tuples));
};
var $rtfeldman$elm_css$Css$Animations$keyframes = function (tuples) {
	return $elm$core$List$isEmpty(tuples) ? {keyframes: $rtfeldman$elm_css$Css$Structure$Compatible, none: $rtfeldman$elm_css$Css$Structure$Compatible, value: 'none'} : {
		keyframes: $rtfeldman$elm_css$Css$Structure$Compatible,
		none: $rtfeldman$elm_css$Css$Structure$Compatible,
		value: $rtfeldman$elm_css$Css$Internal$compileKeyframes(tuples)
	};
};
var $rtfeldman$elm_css$Css$Internal$Property = function (a) {
	return {$: 'Property', a: a};
};
var $rtfeldman$elm_css$Css$Animations$property = F2(
	function (key, value) {
		return $rtfeldman$elm_css$Css$Internal$Property(key + (':' + value));
	});
var $author$project$View$ActionButton$animateDesktopWithAppDomain = $rtfeldman$elm_css$Css$Animations$keyframes(
	_List_fromArray(
		[
			_Utils_Tuple2(
			0,
			_List_fromArray(
				[
					A2($rtfeldman$elm_css$Css$Animations$property, 'height', '0px')
				])),
			_Utils_Tuple2(
			100,
			_List_fromArray(
				[
					A2($rtfeldman$elm_css$Css$Animations$property, 'height', '70px')
				]))
		]));
var $author$project$View$ActionButton$animateDesktopWithoutAppDomain = $rtfeldman$elm_css$Css$Animations$keyframes(
	_List_fromArray(
		[
			_Utils_Tuple2(
			0,
			_List_fromArray(
				[
					A2($rtfeldman$elm_css$Css$Animations$property, 'height', '0px')
				])),
			_Utils_Tuple2(
			100,
			_List_fromArray(
				[
					A2($rtfeldman$elm_css$Css$Animations$property, 'height', '140px')
				]))
		]));
var $author$project$View$ActionButton$animateMobileWithAppDomain = $rtfeldman$elm_css$Css$Animations$keyframes(
	_List_fromArray(
		[
			_Utils_Tuple2(
			0,
			_List_fromArray(
				[
					A2($rtfeldman$elm_css$Css$Animations$property, 'height', '0px')
				])),
			_Utils_Tuple2(
			100,
			_List_fromArray(
				[
					A2($rtfeldman$elm_css$Css$Animations$property, 'height', '70px')
				]))
		]));
var $author$project$View$ActionButton$animateMobileWithoutAppDomain = $rtfeldman$elm_css$Css$Animations$keyframes(
	_List_fromArray(
		[
			_Utils_Tuple2(
			0,
			_List_fromArray(
				[
					A2($rtfeldman$elm_css$Css$Animations$property, 'height', '0px')
				])),
			_Utils_Tuple2(
			100,
			_List_fromArray(
				[
					A2($rtfeldman$elm_css$Css$Animations$property, 'height', '70px')
				]))
		]));
var $rtfeldman$elm_css$Css$animationDuration = function (arg) {
	return A2($rtfeldman$elm_css$Css$prop1, 'animation-duration', arg);
};
var $rtfeldman$elm_css$Css$Preprocess$WithKeyframes = function (a) {
	return {$: 'WithKeyframes', a: a};
};
var $rtfeldman$elm_css$Css$animationName = function (arg) {
	return ((arg.value === 'none') || ((arg.value === 'inherit') || ((arg.value === 'unset') || (arg.value === 'initial')))) ? A2($rtfeldman$elm_css$Css$prop1, 'animation-name', arg) : $rtfeldman$elm_css$Css$Preprocess$WithKeyframes(arg.value);
};
var $rtfeldman$elm_css$Css$borderBottom = $rtfeldman$elm_css$Css$prop1('border-bottom');
var $rtfeldman$elm_css$Css$borderBottom2 = $rtfeldman$elm_css$Css$prop2('border-bottom');
var $rtfeldman$elm_css$Css$bottom = $rtfeldman$elm_css$Css$prop1('bottom');
var $rtfeldman$elm_css$Css$displayFlex = A2($rtfeldman$elm_css$Css$property, 'display', 'flex');
var $rtfeldman$elm_css$Css$fixed = {backgroundAttachment: $rtfeldman$elm_css$Css$Structure$Compatible, position: $rtfeldman$elm_css$Css$Structure$Compatible, tableLayout: $rtfeldman$elm_css$Css$Structure$Compatible, value: 'fixed'};
var $rtfeldman$elm_css$Css$flexDirection = $rtfeldman$elm_css$Css$prop1('flex-direction');
var $rtfeldman$elm_css$Css$height = $rtfeldman$elm_css$Css$prop1('height');
var $rtfeldman$elm_css$Css$lastChild = $rtfeldman$elm_css$Css$pseudoClass('last-child');
var $rtfeldman$elm_css$Css$marginLeft = $rtfeldman$elm_css$Css$prop1('margin-left');
var $rtfeldman$elm_css$Css$paddingLeft = $rtfeldman$elm_css$Css$prop1('padding-left');
var $rtfeldman$elm_css$Css$paddingTop = $rtfeldman$elm_css$Css$prop1('padding-top');
var $rtfeldman$elm_css$Css$position = $rtfeldman$elm_css$Css$prop1('position');
var $rtfeldman$elm_css$Css$cssFunction = F2(
	function (funcName, args) {
		return funcName + ('(' + (A2($elm$core$String$join, ', ', args) + ')'));
	});
var $rtfeldman$elm_css$Css$rgba = F4(
	function (r, g, b, alpha) {
		return {
			alpha: alpha,
			blue: b,
			color: $rtfeldman$elm_css$Css$Structure$Compatible,
			green: g,
			red: r,
			value: A2(
				$rtfeldman$elm_css$Css$cssFunction,
				'rgba',
				_Utils_ap(
					A2(
						$elm$core$List$map,
						$elm$core$String$fromInt,
						_List_fromArray(
							[r, g, b])),
					_List_fromArray(
						[
							$elm$core$String$fromFloat(alpha)
						])))
		};
	});
var $rtfeldman$elm_css$Css$right = $rtfeldman$elm_css$Css$prop1('right');
var $rtfeldman$elm_css$Css$row = {flexDirection: $rtfeldman$elm_css$Css$Structure$Compatible, flexDirectionOrWrap: $rtfeldman$elm_css$Css$Structure$Compatible, value: 'row'};
var $rtfeldman$elm_css$Css$sec = function (amount) {
	return {
		duration: $rtfeldman$elm_css$Css$Structure$Compatible,
		value: $elm$core$String$fromFloat(amount) + 's'
	};
};
var $rtfeldman$elm_css$Css$solid = {borderStyle: $rtfeldman$elm_css$Css$Structure$Compatible, textDecorationStyle: $rtfeldman$elm_css$Css$Structure$Compatible, value: 'solid'};
var $author$project$View$ActionButton$textAnimation = $rtfeldman$elm_css$Css$Animations$keyframes(
	_List_fromArray(
		[
			_Utils_Tuple2(
			0,
			_List_fromArray(
				[
					A2($rtfeldman$elm_css$Css$Animations$property, 'opacity', '0')
				])),
			_Utils_Tuple2(
			100,
			_List_fromArray(
				[
					A2($rtfeldman$elm_css$Css$Animations$property, 'opacity', '1')
				]))
		]));
var $rtfeldman$elm_css$Css$VhUnits = {$: 'VhUnits'};
var $rtfeldman$elm_css$Css$vh = A2($rtfeldman$elm_css$Css$Internal$lengthConverter, $rtfeldman$elm_css$Css$VhUnits, 'vh');
var $author$project$Material$Styled$Color$white = $rtfeldman$elm_css$Css$hex($author$project$Material$Styled$Color$whiteString);
var $rtfeldman$elm_css$Css$Structure$CustomQuery = function (a) {
	return {$: 'CustomQuery', a: a};
};
var $rtfeldman$elm_css$Css$Preprocess$WithMedia = F2(
	function (a, b) {
		return {$: 'WithMedia', a: a, b: b};
	});
var $rtfeldman$elm_css$Css$Media$withMediaQuery = function (queries) {
	return $rtfeldman$elm_css$Css$Preprocess$WithMedia(
		A2($elm$core$List$map, $rtfeldman$elm_css$Css$Structure$CustomQuery, queries));
};
var $rtfeldman$elm_css$Css$zIndex = $rtfeldman$elm_css$Css$prop1('z-index');
var $author$project$View$Theme$zIndex = {actionButton: 10, menu: 10, modal: 100, uploadDocSearchField: 9};
var $author$project$View$ActionButton$styles = {
	actionButton: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$fixed),
			$rtfeldman$elm_css$Css$bottom(
			$rtfeldman$elm_css$Css$px(30)),
			$rtfeldman$elm_css$Css$right(
			$rtfeldman$elm_css$Css$px(30)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(50)),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(50)),
			$rtfeldman$elm_css$Css$zIndex(
			$rtfeldman$elm_css$Css$int($author$project$View$Theme$zIndex.actionButton)),
			$rtfeldman$elm_css$Css$borderRadius(
			$rtfeldman$elm_css$Css$px(55)),
			$rtfeldman$elm_css$Css$paddingTop(
			$rtfeldman$elm_css$Css$px(13)),
			$rtfeldman$elm_css$Css$paddingLeft(
			$rtfeldman$elm_css$Css$px(13))
		]),
	backdrop: function (isAppDomain) {
		return _List_fromArray(
			[
				$rtfeldman$elm_css$Css$backgroundColor($author$project$Material$Styled$Color$white),
				$rtfeldman$elm_css$Css$width(
				$rtfeldman$elm_css$Css$px(300)),
				$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$fixed),
				$rtfeldman$elm_css$Css$zIndex(
				$rtfeldman$elm_css$Css$int($author$project$View$Theme$zIndex.actionButton)),
				$rtfeldman$elm_css$Css$borderRadius(
				$rtfeldman$elm_css$Css$px(10)),
				$rtfeldman$elm_css$Css$bottom(
				$rtfeldman$elm_css$Css$px(90)),
				$rtfeldman$elm_css$Css$right(
				$rtfeldman$elm_css$Css$px(30)),
				isAppDomain ? $rtfeldman$elm_css$Css$animationName($author$project$View$ActionButton$animateDesktopWithAppDomain) : $rtfeldman$elm_css$Css$animationName($author$project$View$ActionButton$animateDesktopWithoutAppDomain),
				$rtfeldman$elm_css$Css$animationDuration(
				$rtfeldman$elm_css$Css$sec(0.5)),
				A2(
				$rtfeldman$elm_css$Css$Media$withMediaQuery,
				_List_fromArray(
					['screen and (max-width: 425px)']),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$width(
						$rtfeldman$elm_css$Css$pct(90)),
						$rtfeldman$elm_css$Css$right(
						$rtfeldman$elm_css$Css$pct(5)),
						$rtfeldman$elm_css$Css$bottom(
						$rtfeldman$elm_css$Css$pct(30)),
						$rtfeldman$elm_css$Css$height(
						$rtfeldman$elm_css$Css$px(300)),
						isAppDomain ? $rtfeldman$elm_css$Css$animationName($author$project$View$ActionButton$animateMobileWithAppDomain) : $rtfeldman$elm_css$Css$animationName($author$project$View$ActionButton$animateMobileWithoutAppDomain)
					]))
			]);
	},
	container: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$fixed),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100)),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$vh(100)),
			$rtfeldman$elm_css$Css$zIndex(
			$rtfeldman$elm_css$Css$int($author$project$View$Theme$zIndex.actionButton)),
			$rtfeldman$elm_css$Css$backgroundColor(
			A4($rtfeldman$elm_css$Css$rgba, 0, 0, 0, 0.5))
		]),
	icon: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginLeft(
			$rtfeldman$elm_css$Css$px(10))
		]),
	text: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginLeft(
			$rtfeldman$elm_css$Css$px(10))
		]),
	textContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$row),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100)),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(70)),
			A2(
			$rtfeldman$elm_css$Css$borderBottom2,
			$rtfeldman$elm_css$Css$px(1),
			$rtfeldman$elm_css$Css$solid),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$animationName($author$project$View$ActionButton$textAnimation),
			$rtfeldman$elm_css$Css$animationDuration(
			$rtfeldman$elm_css$Css$sec(2)),
			$rtfeldman$elm_css$Css$lastChild(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$borderBottom(
					$rtfeldman$elm_css$Css$px(0))
				])),
			$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer)
		])
};
var $rtfeldman$elm_css$Svg$Styled$Attributes$class = $rtfeldman$elm_css$VirtualDom$Styled$attribute('class');
var $author$project$Material$Styled$Icon$Template$view = F2(
	function (attributes, children) {
		return A2(
			$rtfeldman$elm_css$Svg$Styled$svg,
			_Utils_ap(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Svg$Styled$Attributes$fill('black'),
						$rtfeldman$elm_css$Svg$Styled$Attributes$class('w-6 h-6'),
						$rtfeldman$elm_css$Svg$Styled$Attributes$width('24px'),
						$rtfeldman$elm_css$Svg$Styled$Attributes$height('24px'),
						$rtfeldman$elm_css$Svg$Styled$Attributes$viewBox('0 0 20 20')
					]),
				attributes),
			A2(
				$elm$core$List$cons,
				A2(
					$rtfeldman$elm_css$Svg$Styled$path,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Svg$Styled$Attributes$d('M3 4a1 1 0 011-1h12a1 1 0 011 1v2a1 1 0 01-1 1H4a1 1 0 01-1-1V4zM3 10a1 1 0 011-1h6a1 1 0 011 1v6a1 1 0 01-1 1H4a1 1 0 01-1-1v-6zM14 9a1 1 0 00-1 1v6a1 1 0 001 1h2a1 1 0 001-1v-6a1 1 0 00-1-1h-2z')
						]),
					_List_Nil),
				children));
	});
var $author$project$Material$Styled$Icon$template = $author$project$Material$Styled$Icon$Template$view;
var $rtfeldman$elm_css$VirtualDom$Styled$Unstyled = function (a) {
	return {$: 'Unstyled', a: a};
};
var $elm$virtual_dom$VirtualDom$text = _VirtualDom_text;
var $rtfeldman$elm_css$VirtualDom$Styled$text = function (str) {
	return $rtfeldman$elm_css$VirtualDom$Styled$Unstyled(
		$elm$virtual_dom$VirtualDom$text(str));
};
var $rtfeldman$elm_css$Html$Styled$text = $rtfeldman$elm_css$VirtualDom$Styled$text;
var $author$project$View$ActionButton$displayTemplateButton = function (isAppDomain) {
	return isAppDomain ? $rtfeldman$elm_css$Html$Styled$text('') : A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$ActionButton$styles.textContainer),
				$rtfeldman$elm_css$Html$Styled$Events$onClick(
				$author$project$Types$OnAuth(
					$author$project$Types$OnActionButton(
						$author$project$Type$ActionButton$OpenModal($author$project$Type$ActionButton$Template))))
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$ActionButton$styles.icon)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Material$Styled$Icon$template,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Svg$Styled$Attributes$width('25'),
								$rtfeldman$elm_css$Svg$Styled$Attributes$height('25')
							]),
						_List_Nil)
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$span,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$ActionButton$styles.text)
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('New Template')
					]))
			]));
};
var $rtfeldman$elm_css$Css$absolute = {position: $rtfeldman$elm_css$Css$Structure$Compatible, value: 'absolute'};
var $rtfeldman$elm_css$Css$auto = {alignItemsOrAuto: $rtfeldman$elm_css$Css$Structure$Compatible, cursor: $rtfeldman$elm_css$Css$Structure$Compatible, flexBasis: $rtfeldman$elm_css$Css$Structure$Compatible, intOrAuto: $rtfeldman$elm_css$Css$Structure$Compatible, justifyContentOrAuto: $rtfeldman$elm_css$Css$Structure$Compatible, lengthOrAuto: $rtfeldman$elm_css$Css$Structure$Compatible, lengthOrAutoOrCoverOrContain: $rtfeldman$elm_css$Css$Structure$Compatible, lengthOrNumberOrAutoOrNoneOrContent: $rtfeldman$elm_css$Css$Structure$Compatible, overflow: $rtfeldman$elm_css$Css$Structure$Compatible, pointerEvents: $rtfeldman$elm_css$Css$Structure$Compatible, tableLayout: $rtfeldman$elm_css$Css$Structure$Compatible, textRendering: $rtfeldman$elm_css$Css$Structure$Compatible, touchAction: $rtfeldman$elm_css$Css$Structure$Compatible, value: 'auto'};
var $rtfeldman$elm_css$Css$hidden = {borderStyle: $rtfeldman$elm_css$Css$Structure$Compatible, overflow: $rtfeldman$elm_css$Css$Structure$Compatible, value: 'hidden', visibility: $rtfeldman$elm_css$Css$Structure$Compatible};
var $rtfeldman$elm_css$Css$left = $rtfeldman$elm_css$Css$prop1('left');
var $rtfeldman$elm_css$Css$Transitions$Linear = {$: 'Linear'};
var $rtfeldman$elm_css$Css$Transitions$linear = $rtfeldman$elm_css$Css$Transitions$Linear;
var $rtfeldman$elm_css$Css$margin = $rtfeldman$elm_css$Css$prop1('margin');
var $rtfeldman$elm_css$Css$maxWidth = $rtfeldman$elm_css$Css$prop1('max-width');
var $rtfeldman$elm_css$Css$Transitions$Opacity = {$: 'Opacity'};
var $rtfeldman$elm_css$Css$Transitions$durationDelayTransition = F3(
	function (animation, duration, delay) {
		return $rtfeldman$elm_css$Css$Transitions$Transition(
			{
				animation: animation,
				delay: $elm$core$Maybe$Just(delay),
				duration: duration,
				timing: $elm$core$Maybe$Nothing
			});
	});
var $rtfeldman$elm_css$Css$Transitions$opacity2 = $rtfeldman$elm_css$Css$Transitions$durationDelayTransition($rtfeldman$elm_css$Css$Transitions$Opacity);
var $rtfeldman$elm_css$Css$RemUnits = {$: 'RemUnits'};
var $rtfeldman$elm_css$Css$rem = A2($rtfeldman$elm_css$Css$Internal$lengthConverter, $rtfeldman$elm_css$Css$RemUnits, 'rem');
var $rtfeldman$elm_css$Css$scale = function (x) {
	return {
		transform: $rtfeldman$elm_css$Css$Structure$Compatible,
		value: A2(
			$rtfeldman$elm_css$Css$cssFunction,
			'scale',
			_List_fromArray(
				[
					$elm$core$String$fromFloat(x)
				]))
	};
};
var $rtfeldman$elm_css$Css$top = $rtfeldman$elm_css$Css$prop1('top');
var $rtfeldman$elm_css$Css$valuesOrNone = function (list) {
	return $elm$core$List$isEmpty(list) ? {value: 'none'} : {
		value: A2(
			$elm$core$String$join,
			' ',
			A2(
				$elm$core$List$map,
				function ($) {
					return $.value;
				},
				list))
	};
};
var $rtfeldman$elm_css$Css$transforms = A2(
	$elm$core$Basics$composeL,
	$rtfeldman$elm_css$Css$prop1('transform'),
	$rtfeldman$elm_css$Css$valuesOrNone);
var $rtfeldman$elm_css$Css$transform = function (only) {
	return $rtfeldman$elm_css$Css$transforms(
		_List_fromArray(
			[only]));
};
var $rtfeldman$elm_css$Css$Transitions$Transform = {$: 'Transform'};
var $rtfeldman$elm_css$Css$Transitions$transform = $rtfeldman$elm_css$Css$Transitions$durationTransition($rtfeldman$elm_css$Css$Transitions$Transform);
var $rtfeldman$elm_css$Css$translate2 = F2(
	function (tx, ty) {
		return {
			transform: $rtfeldman$elm_css$Css$Structure$Compatible,
			value: A2(
				$rtfeldman$elm_css$Css$cssFunction,
				'translate',
				_List_fromArray(
					[tx.value, ty.value]))
		};
	});
var $rtfeldman$elm_css$Css$visibility = $rtfeldman$elm_css$Css$prop1('visibility');
var $rtfeldman$elm_css$Css$Transitions$Visibility = {$: 'Visibility'};
var $rtfeldman$elm_css$Css$Transitions$fullTransition = F4(
	function (animation, duration, delay, timing) {
		return $rtfeldman$elm_css$Css$Transitions$Transition(
			{
				animation: animation,
				delay: $elm$core$Maybe$Just(delay),
				duration: duration,
				timing: $elm$core$Maybe$Just(timing)
			});
	});
var $rtfeldman$elm_css$Css$Transitions$visibility3 = $rtfeldman$elm_css$Css$Transitions$fullTransition($rtfeldman$elm_css$Css$Transitions$Visibility);
var $rtfeldman$elm_css$Css$visible = {overflow: $rtfeldman$elm_css$Css$Structure$Compatible, pointerEvents: $rtfeldman$elm_css$Css$Structure$Compatible, value: 'visible', visibility: $rtfeldman$elm_css$Css$Structure$Compatible};
var $rtfeldman$elm_css$Css$VwUnits = {$: 'VwUnits'};
var $rtfeldman$elm_css$Css$vw = A2($rtfeldman$elm_css$Css$Internal$lengthConverter, $rtfeldman$elm_css$Css$VwUnits, 'vw');
var $author$project$Material$Styled$Modal$style = {
	backdropSize: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100)),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$vh(100))
		]),
	container: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$row),
			$rtfeldman$elm_css$Css$transform(
			$rtfeldman$elm_css$Css$scale(1.1)),
			$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$fixed),
			$rtfeldman$elm_css$Css$left($rtfeldman$elm_css$Css$zero),
			$rtfeldman$elm_css$Css$top($rtfeldman$elm_css$Css$zero),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100)),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$vh(100)),
			$rtfeldman$elm_css$Css$backgroundColor(
			A4($rtfeldman$elm_css$Css$rgba, 0, 0, 0, 0.1)),
			$rtfeldman$elm_css$Css$Transitions$transition(
			_List_fromArray(
				[
					A3($rtfeldman$elm_css$Css$Transitions$visibility3, 0, 200, $rtfeldman$elm_css$Css$Transitions$linear),
					A2($rtfeldman$elm_css$Css$Transitions$opacity2, 250, 0),
					$rtfeldman$elm_css$Css$Transitions$transform(250)
				])),
			$rtfeldman$elm_css$Css$visibility($rtfeldman$elm_css$Css$hidden),
			$rtfeldman$elm_css$Css$zIndex(
			$rtfeldman$elm_css$Css$int($author$project$View$Theme$zIndex.modal))
		]),
	content: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$absolute),
			$rtfeldman$elm_css$Css$left(
			$rtfeldman$elm_css$Css$pct(50)),
			$rtfeldman$elm_css$Css$top(
			$rtfeldman$elm_css$Css$pct(50)),
			$rtfeldman$elm_css$Css$transform(
			A2(
				$rtfeldman$elm_css$Css$translate2,
				$rtfeldman$elm_css$Css$pct(-50),
				$rtfeldman$elm_css$Css$pct(-50))),
			$rtfeldman$elm_css$Css$margin($rtfeldman$elm_css$Css$auto),
			$rtfeldman$elm_css$Css$backgroundColor($author$project$Material$Styled$Color$white),
			A2(
			$rtfeldman$elm_css$Css$padding2,
			$rtfeldman$elm_css$Css$rem(1),
			$rtfeldman$elm_css$Css$rem(1.5)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$vw(70)),
			$rtfeldman$elm_css$Css$maxWidth(
			$rtfeldman$elm_css$Css$px(800)),
			$rtfeldman$elm_css$Css$borderRadius(
			$rtfeldman$elm_css$Css$rem(0.5))
		]),
	showContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$visibility($rtfeldman$elm_css$Css$visible),
			$rtfeldman$elm_css$Css$transform(
			$rtfeldman$elm_css$Css$scale(1)),
			$rtfeldman$elm_css$Css$backgroundColor(
			A4($rtfeldman$elm_css$Css$rgba, 0, 0, 0, 0.5)),
			$rtfeldman$elm_css$Css$Transitions$transition(
			_List_fromArray(
				[
					A3($rtfeldman$elm_css$Css$Transitions$visibility3, 0, 0, $rtfeldman$elm_css$Css$Transitions$linear),
					A2($rtfeldman$elm_css$Css$Transitions$opacity2, 250, 0),
					$rtfeldman$elm_css$Css$Transitions$transform(250)
				]))
		])
};
var $author$project$Material$Styled$Modal$defaultConfig = {backDropAttributes: _List_Nil, backDropStyles: $author$project$Material$Styled$Modal$style.backdropSize, containerStyles: $author$project$Material$Styled$Modal$style.container, contentContainerAttributes: _List_Nil, contentContainerStyle: $author$project$Material$Styled$Modal$style.content, open: false};
var $author$project$Material$Styled$Modal$mergeModalAttributes = function (config) {
	var modalStyle = config.open ? _Utils_ap(config.containerStyles, $author$project$Material$Styled$Modal$style.showContainer) : config.containerStyles;
	return _Utils_update(
		config,
		{
			backDropAttributes: A2(
				$elm$core$List$cons,
				$rtfeldman$elm_css$Html$Styled$Attributes$css(config.backDropStyles),
				config.backDropAttributes),
			containerStyles: modalStyle,
			contentContainerAttributes: A2(
				$elm$core$List$cons,
				$rtfeldman$elm_css$Html$Styled$Attributes$css(config.contentContainerStyle),
				config.contentContainerAttributes)
		});
};
var $author$project$Material$Styled$Modal$mergeProperty = F2(
	function (property, config) {
		switch (property.$) {
			case 'OnClose':
				var msg = property.a;
				return _Utils_update(
					config,
					{
						backDropAttributes: A2(
							$elm$core$List$cons,
							$rtfeldman$elm_css$Html$Styled$Events$onClick(msg),
							config.backDropAttributes)
					});
			case 'Open':
				var bool = property.a;
				return _Utils_update(
					config,
					{open: bool});
			case 'ContentContainerStyle':
				var styles_ = property.a;
				return _Utils_update(
					config,
					{
						contentContainerStyle: _Utils_ap(config.contentContainerStyle, styles_)
					});
			default:
				var attribute_ = property.a;
				return _Utils_update(
					config,
					{
						contentContainerAttributes: A2(
							$elm$core$List$cons,
							A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'data-test', attribute_),
							config.contentContainerAttributes)
					});
		}
	});
var $author$project$Material$Styled$Modal$mergeConfig = F2(
	function (config, properties) {
		return $author$project$Material$Styled$Modal$mergeModalAttributes(
			A3($elm$core$List$foldl, $author$project$Material$Styled$Modal$mergeProperty, config, properties));
	});
var $author$project$Material$Styled$Modal$modal = F2(
	function (properties, children) {
		var _v0 = A2($author$project$Material$Styled$Modal$mergeConfig, $author$project$Material$Styled$Modal$defaultConfig, properties);
		var backDropAttributes = _v0.backDropAttributes;
		var containerStyles = _v0.containerStyles;
		var contentContainerAttributes = _v0.contentContainerAttributes;
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(containerStyles)
				]),
			_List_fromArray(
				[
					A2($rtfeldman$elm_css$Html$Styled$div, backDropAttributes, _List_Nil),
					A2($rtfeldman$elm_css$Html$Styled$div, contentContainerAttributes, children)
				]));
	});
var $author$project$Material$Styled$Modal$OnClose = function (a) {
	return {$: 'OnClose', a: a};
};
var $author$project$Material$Styled$Modal$onClose = function (msg) {
	return $author$project$Material$Styled$Modal$OnClose(msg);
};
var $author$project$Material$Styled$Modal$Open = function (a) {
	return {$: 'Open', a: a};
};
var $author$project$Material$Styled$Modal$open = function (bool) {
	return $author$project$Material$Styled$Modal$Open(bool);
};
var $author$project$Type$NewTemplate$Leave = {$: 'Leave'};
var $author$project$Type$NewTemplate$OnDragEnter = {$: 'OnDragEnter'};
var $author$project$Type$NewTemplate$OnDragLeave = {$: 'OnDragLeave'};
var $author$project$Type$NewTemplate$OnHover = function (a) {
	return {$: 'OnHover', a: a};
};
var $author$project$Type$NewTemplate$PickFile = {$: 'PickFile'};
var $author$project$Type$NewTemplate$OnCloseBanner = {$: 'OnCloseBanner'};
var $rtfeldman$elm_css$Svg$Styled$Internal$css = function (styles) {
	var classname = $rtfeldman$elm_css$VirtualDom$Styled$getClassname(styles);
	var classAttribute = A2($elm$virtual_dom$VirtualDom$attribute, 'class', classname);
	return A3($rtfeldman$elm_css$VirtualDom$Styled$Attribute, classAttribute, styles, classname);
};
var $rtfeldman$elm_css$Svg$Styled$Attributes$css = $rtfeldman$elm_css$Svg$Styled$Internal$css;
var $author$project$Material$Styled$Color$red400String = '#ef5350';
var $author$project$Material$Styled$Color$red400 = $rtfeldman$elm_css$Css$hex($author$project$Material$Styled$Color$red400String);
var $author$project$Material$Styled$Banner$errorTheme = {background: $author$project$Material$Styled$Color$red400, closeIcon: 'white', text: $author$project$Material$Styled$Color$white};
var $rtfeldman$elm_css$Css$column = _Utils_update(
	$rtfeldman$elm_css$Css$row,
	{value: 'column'});
var $rtfeldman$elm_css$Css$EmUnits = {$: 'EmUnits'};
var $rtfeldman$elm_css$Css$em = A2($rtfeldman$elm_css$Css$Internal$lengthConverter, $rtfeldman$elm_css$Css$EmUnits, 'em');
var $rtfeldman$elm_css$Css$marginBottom = $rtfeldman$elm_css$Css$prop1('margin-bottom');
var $rtfeldman$elm_css$Css$marginTop = $rtfeldman$elm_css$Css$prop1('margin-top');
var $rtfeldman$elm_css$Css$minHeight = $rtfeldman$elm_css$Css$prop1('min-height');
var $rtfeldman$elm_css$Css$padding = $rtfeldman$elm_css$Css$prop1('padding');
var $author$project$Material$Styled$Banner$styles = {
	body: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$em(1)),
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(8))
		]),
	closeIcon: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer),
			$rtfeldman$elm_css$Css$padding(
			$rtfeldman$elm_css$Css$px(10))
		]),
	container: _List_fromArray(
		[
			A2($rtfeldman$elm_css$Css$property, 'box-shadow', '0 0 0 1px rgba(63,63,68,0.05), 0 1px 3px 0 rgba(63,63,68,0.15)'),
			$rtfeldman$elm_css$Css$minHeight(
			$rtfeldman$elm_css$Css$px(50)),
			$rtfeldman$elm_css$Css$padding(
			$rtfeldman$elm_css$Css$em(1)),
			$rtfeldman$elm_css$Css$marginBottom(
			$rtfeldman$elm_css$Css$px(10))
		]),
	content: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column)
		]),
	title: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$em(1.2)),
			$rtfeldman$elm_css$Css$fontWeight(
			$rtfeldman$elm_css$Css$int(500))
		])
};
var $rtfeldman$elm_css$Css$justifyContent = function (fn) {
	return A3(
		$rtfeldman$elm_css$Css$Internal$getOverloadedProperty,
		'justifyContent',
		'justify-content',
		fn($rtfeldman$elm_css$Css$Internal$lengthForOverloadedProperty));
};
var $rtfeldman$elm_css$Css$spaceBetween = $rtfeldman$elm_css$Css$prop1('space-between');
var $author$project$Material$Styled$Banner$themeStyles = function (_v0) {
	var background = _v0.background;
	var text = _v0.text;
	return {
		body: _List_fromArray(
			[
				$rtfeldman$elm_css$Css$color(text)
			]),
		container: _List_fromArray(
			[
				$rtfeldman$elm_css$Css$displayFlex,
				$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$row),
				$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceBetween),
				$rtfeldman$elm_css$Css$backgroundColor(background)
			]),
		title: _List_fromArray(
			[
				$rtfeldman$elm_css$Css$color(text)
			])
	};
};
var $author$project$Material$Styled$Banner$defaultConfig = function () {
	var defaultTheme = $author$project$Material$Styled$Banner$themeStyles($author$project$Material$Styled$Banner$errorTheme);
	return {
		body: $rtfeldman$elm_css$Html$Styled$text(''),
		bodyStyles: _Utils_ap($author$project$Material$Styled$Banner$styles.body, defaultTheme.body),
		closeIconAttributes: _List_fromArray(
			[
				$rtfeldman$elm_css$Svg$Styled$Attributes$css($author$project$Material$Styled$Banner$styles.closeIcon),
				$rtfeldman$elm_css$Svg$Styled$Attributes$fill($author$project$Material$Styled$Banner$errorTheme.closeIcon)
			]),
		containerStyles: _Utils_ap($author$project$Material$Styled$Banner$styles.container, defaultTheme.container),
		theme: $author$project$Material$Styled$Banner$errorTheme,
		title: '',
		titleStyles: _Utils_ap($author$project$Material$Styled$Banner$styles.title, defaultTheme.title)
	};
}();
var $author$project$Material$Styled$Banner$mergeBannerStyles = function (config) {
	var defaultTheme = $author$project$Material$Styled$Banner$themeStyles(config.theme);
	return _Utils_update(
		config,
		{
			bodyStyles: _Utils_ap(config.bodyStyles, defaultTheme.body),
			containerStyles: _Utils_ap(config.containerStyles, defaultTheme.container),
			titleStyles: _Utils_ap(config.titleStyles, defaultTheme.title)
		});
};
var $author$project$Material$Styled$Banner$mergeProperty = F2(
	function (property, config) {
		switch (property.$) {
			case 'Title':
				var title_ = property.a;
				return _Utils_update(
					config,
					{title: title_});
			case 'Body':
				var body_ = property.a;
				return _Utils_update(
					config,
					{body: body_});
			case 'BannerTheme':
				var theme_ = property.a;
				return _Utils_update(
					config,
					{theme: theme_});
			case 'CloseIconAttributes':
				var attr_ = property.a;
				return _Utils_update(
					config,
					{
						closeIconAttributes: _Utils_ap(config.closeIconAttributes, attr_)
					});
			case 'TitleStyles':
				var styles_ = property.a;
				return _Utils_update(
					config,
					{
						titleStyles: _Utils_ap(config.titleStyles, styles_)
					});
			case 'BodyStyles':
				var styles_ = property.a;
				return _Utils_update(
					config,
					{
						bodyStyles: _Utils_ap(config.bodyStyles, styles_)
					});
			default:
				var styles_ = property.a;
				return _Utils_update(
					config,
					{
						containerStyles: _Utils_ap(config.containerStyles, styles_)
					});
		}
	});
var $author$project$Material$Styled$Banner$mergeConfig = F2(
	function (config, properties) {
		return $author$project$Material$Styled$Banner$mergeBannerStyles(
			A3($elm$core$List$foldl, $author$project$Material$Styled$Banner$mergeProperty, config, properties));
	});
var $author$project$Material$Styled$Banner$banner = F2(
	function (properties, _v0) {
		var updatedConfig = A2($author$project$Material$Styled$Banner$mergeConfig, $author$project$Material$Styled$Banner$defaultConfig, properties);
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(updatedConfig.containerStyles)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Material$Styled$Banner$styles.content)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css(updatedConfig.titleStyles)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(updatedConfig.title)
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css(updatedConfig.bodyStyles)
								]),
							_List_fromArray(
								[updatedConfig.body]))
						])),
					A2($author$project$Material$Styled$Icon$close, updatedConfig.closeIconAttributes, _List_Nil)
				]));
	});
var $author$project$Material$Styled$Banner$Body = function (a) {
	return {$: 'Body', a: a};
};
var $author$project$Material$Styled$Banner$body = function (title_) {
	return $author$project$Material$Styled$Banner$Body(title_);
};
var $author$project$Material$Styled$Banner$CloseIconAttributes = function (a) {
	return {$: 'CloseIconAttributes', a: a};
};
var $author$project$Material$Styled$Banner$closeIconAttributes = function (msg) {
	return $author$project$Material$Styled$Banner$CloseIconAttributes(msg);
};
var $rtfeldman$elm_css$Svg$Styled$Events$onClick = function (msg) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$Events$on,
		'click',
		$elm$json$Json$Decode$succeed(msg));
};
var $author$project$Material$Styled$Banner$BannerTheme = function (a) {
	return {$: 'BannerTheme', a: a};
};
var $author$project$Material$Styled$Banner$theme = function (theme_) {
	return $author$project$Material$Styled$Banner$BannerTheme(theme_);
};
var $author$project$Material$Styled$Banner$Title = function (a) {
	return {$: 'Title', a: a};
};
var $author$project$Material$Styled$Banner$title = function (title_) {
	return $author$project$Material$Styled$Banner$Title(title_);
};
var $author$project$Page$NewTemplate$banner = function (error) {
	if (error.$ === 'Just') {
		var message = error.a;
		return A2(
			$author$project$Material$Styled$Banner$banner,
			_List_fromArray(
				[
					$author$project$Material$Styled$Banner$theme($author$project$Material$Styled$Banner$errorTheme),
					$author$project$Material$Styled$Banner$body(
					$rtfeldman$elm_css$Html$Styled$text('- ' + message)),
					$author$project$Material$Styled$Banner$title('Error message'),
					$author$project$Material$Styled$Banner$closeIconAttributes(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Svg$Styled$Events$onClick(
							$author$project$Types$OnAuth(
								$author$project$Types$OnNewTemplate($author$project$Type$NewTemplate$OnCloseBanner)))
						]))
				]),
			_List_Nil);
	} else {
		return $rtfeldman$elm_css$Html$Styled$text('');
	}
};
var $author$project$Material$Styled$Color$blueA700 = $rtfeldman$elm_css$Css$hex($author$project$Material$Styled$Color$blueA700String);
var $author$project$Material$Styled$Color$blueGrey600String = '#546E7A';
var $author$project$Material$Styled$Color$blueGrey600 = $rtfeldman$elm_css$Css$hex($author$project$Material$Styled$Color$blueGrey600String);
var $author$project$Material$Styled$Color$blueGrey900String = '#263238';
var $author$project$Material$Styled$Color$blueGrey900 = $rtfeldman$elm_css$Css$hex($author$project$Material$Styled$Color$blueGrey900String);
var $rtfeldman$elm_css$Css$prop3 = F4(
	function (key, argA, argB, argC) {
		return A2(
			$rtfeldman$elm_css$Css$property,
			key,
			A2(
				$elm$core$String$join,
				' ',
				_List_fromArray(
					[argA.value, argB.value, argC.value])));
	});
var $rtfeldman$elm_css$Css$border3 = $rtfeldman$elm_css$Css$prop3('border');
var $rtfeldman$elm_css$Css$boxShadow = $rtfeldman$elm_css$Css$prop1('box-shadow');
var $rtfeldman$elm_css$Css$dashed = {borderStyle: $rtfeldman$elm_css$Css$Structure$Compatible, textDecorationStyle: $rtfeldman$elm_css$Css$Structure$Compatible, value: 'dashed'};
var $rtfeldman$elm_css$Css$fillAvailable = {lengthOrMinMaxDimension: $rtfeldman$elm_css$Css$Structure$Compatible, lengthOrNoneOrMinMaxDimension: $rtfeldman$elm_css$Css$Structure$Compatible, minMaxDimension: $rtfeldman$elm_css$Css$Structure$Compatible, value: 'fill-available'};
var $rtfeldman$elm_css$Css$fitContent = _Utils_update(
	$rtfeldman$elm_css$Css$fillAvailable,
	{value: 'fit-content'});
var $rtfeldman$elm_css$Css$flexEnd = $rtfeldman$elm_css$Css$prop1('flex-end');
var $rtfeldman$elm_css$Css$flexWrap = $rtfeldman$elm_css$Css$prop1('flex-wrap');
var $author$project$Material$Styled$Color$grey100String = '#F5F5F5';
var $author$project$Material$Styled$Color$grey100 = $rtfeldman$elm_css$Css$hex($author$project$Material$Styled$Color$grey100String);
var $author$project$Material$Styled$Color$grey200String = '#EEEEEE';
var $author$project$Material$Styled$Color$grey200 = $rtfeldman$elm_css$Css$hex($author$project$Material$Styled$Color$grey200String);
var $author$project$Material$Styled$Color$grey300String = '#E0E0E0';
var $author$project$Material$Styled$Color$grey300 = $rtfeldman$elm_css$Css$hex($author$project$Material$Styled$Color$grey300String);
var $author$project$Material$Styled$Color$grey50String = '#FAFAFA';
var $author$project$Material$Styled$Color$grey50 = $rtfeldman$elm_css$Css$hex($author$project$Material$Styled$Color$grey50String);
var $author$project$Material$Styled$Color$grey500String = '#9E9E9E';
var $author$project$Material$Styled$Color$grey500 = $rtfeldman$elm_css$Css$hex($author$project$Material$Styled$Color$grey500String);
var $rtfeldman$elm_css$Css$makeImportant = function (str) {
	return A2(
		$elm$core$String$endsWith,
		' !important',
		$elm$core$String$toLower(str)) ? str : (str + ' !important');
};
var $rtfeldman$elm_css$Css$Preprocess$mapAllLastProperty = F2(
	function (update, styles) {
		if (!styles.b) {
			return styles;
		} else {
			if (!styles.b.b) {
				var only = styles.a;
				return _List_fromArray(
					[
						A2($rtfeldman$elm_css$Css$Preprocess$mapLastProperty, update, only)
					]);
			} else {
				var first = styles.a;
				var rest = styles.b;
				return A2(
					$elm$core$List$cons,
					first,
					A2($rtfeldman$elm_css$Css$Preprocess$mapAllLastProperty, update, rest));
			}
		}
	});
var $rtfeldman$elm_css$Css$Preprocess$mapLastProperty = F2(
	function (update, style) {
		switch (style.$) {
			case 'AppendProperty':
				var property = style.a;
				return $rtfeldman$elm_css$Css$Preprocess$AppendProperty(
					update(property));
			case 'ExtendSelector':
				var selector = style.a;
				var styles = style.b;
				return A2(
					$rtfeldman$elm_css$Css$Preprocess$ExtendSelector,
					selector,
					A2($rtfeldman$elm_css$Css$Preprocess$mapAllLastProperty, update, styles));
			case 'NestSnippet':
				return style;
			case 'WithPseudoElement':
				return style;
			case 'WithMedia':
				return style;
			case 'WithKeyframes':
				return style;
			default:
				var otherStyles = style.a;
				return $rtfeldman$elm_css$Css$Preprocess$ApplyStyles(
					A2(
						$rtfeldman$elm_css$Css$Structure$mapLast,
						$rtfeldman$elm_css$Css$Preprocess$mapLastProperty(update),
						otherStyles));
		}
	});
var $rtfeldman$elm_css$Css$important = $rtfeldman$elm_css$Css$Preprocess$mapLastProperty($rtfeldman$elm_css$Css$makeImportant);
var $rtfeldman$elm_css$Css$initial = {alignItems: $rtfeldman$elm_css$Css$Structure$Compatible, all: $rtfeldman$elm_css$Css$Structure$Compatible, backgroundAttachment: $rtfeldman$elm_css$Css$Structure$Compatible, backgroundBlendMode: $rtfeldman$elm_css$Css$Structure$Compatible, backgroundImage: $rtfeldman$elm_css$Css$Structure$Compatible, backgroundOrigin: $rtfeldman$elm_css$Css$Structure$Compatible, backgroundRepeat: $rtfeldman$elm_css$Css$Structure$Compatible, backgroundRepeatShorthand: $rtfeldman$elm_css$Css$Structure$Compatible, borderStyle: $rtfeldman$elm_css$Css$Structure$Compatible, boxSizing: $rtfeldman$elm_css$Css$Structure$Compatible, color: $rtfeldman$elm_css$Css$Structure$Compatible, cursor: $rtfeldman$elm_css$Css$Structure$Compatible, display: $rtfeldman$elm_css$Css$Structure$Compatible, flexBasis: $rtfeldman$elm_css$Css$Structure$Compatible, flexDirection: $rtfeldman$elm_css$Css$Structure$Compatible, flexDirectionOrWrap: $rtfeldman$elm_css$Css$Structure$Compatible, flexWrap: $rtfeldman$elm_css$Css$Structure$Compatible, fontFamily: $rtfeldman$elm_css$Css$Structure$Compatible, fontSize: $rtfeldman$elm_css$Css$Structure$Compatible, fontStyle: $rtfeldman$elm_css$Css$Structure$Compatible, fontVariant: $rtfeldman$elm_css$Css$Structure$Compatible, fontWeight: $rtfeldman$elm_css$Css$Structure$Compatible, intOrAuto: $rtfeldman$elm_css$Css$Structure$Compatible, justifyContent: $rtfeldman$elm_css$Css$Structure$Compatible, keyframes: $rtfeldman$elm_css$Css$Structure$Compatible, length: $rtfeldman$elm_css$Css$Structure$Compatible, lengthOrAuto: $rtfeldman$elm_css$Css$Structure$Compatible, lengthOrAutoOrCoverOrContain: $rtfeldman$elm_css$Css$Structure$Compatible, lengthOrMinMaxDimension: $rtfeldman$elm_css$Css$Structure$Compatible, lengthOrNone: $rtfeldman$elm_css$Css$Structure$Compatible, lengthOrNoneOrMinMaxDimension: $rtfeldman$elm_css$Css$Structure$Compatible, lengthOrNumber: $rtfeldman$elm_css$Css$Structure$Compatible, lengthOrNumberOrAutoOrNoneOrContent: $rtfeldman$elm_css$Css$Structure$Compatible, listStylePosition: $rtfeldman$elm_css$Css$Structure$Compatible, listStyleType: $rtfeldman$elm_css$Css$Structure$Compatible, listStyleTypeOrPositionOrImage: $rtfeldman$elm_css$Css$Structure$Compatible, none: $rtfeldman$elm_css$Css$Structure$Compatible, number: $rtfeldman$elm_css$Css$Structure$Compatible, numericValue: 0, outline: $rtfeldman$elm_css$Css$Structure$Compatible, overflow: $rtfeldman$elm_css$Css$Structure$Compatible, pointerEvents: $rtfeldman$elm_css$Css$Structure$Compatible, tableLayout: $rtfeldman$elm_css$Css$Structure$Compatible, textDecorationLine: $rtfeldman$elm_css$Css$Structure$Compatible, textDecorationStyle: $rtfeldman$elm_css$Css$Structure$Compatible, textIndent: $rtfeldman$elm_css$Css$Structure$Compatible, textRendering: $rtfeldman$elm_css$Css$Structure$Compatible, textTransform: $rtfeldman$elm_css$Css$Structure$Compatible, touchAction: $rtfeldman$elm_css$Css$Structure$Compatible, unitLabel: '', units: $rtfeldman$elm_css$Css$Internal$IncompatibleUnits, value: 'initial', visibility: $rtfeldman$elm_css$Css$Structure$Compatible, whiteSpace: $rtfeldman$elm_css$Css$Structure$Compatible};
var $rtfeldman$elm_css$Css$lineHeight = $rtfeldman$elm_css$Css$prop1('line-height');
var $rtfeldman$elm_css$Css$margin2 = $rtfeldman$elm_css$Css$prop2('margin');
var $rtfeldman$elm_css$Css$prop4 = F5(
	function (key, argA, argB, argC, argD) {
		return A2(
			$rtfeldman$elm_css$Css$property,
			key,
			A2(
				$elm$core$String$join,
				' ',
				_List_fromArray(
					[argA.value, argB.value, argC.value, argD.value])));
	});
var $rtfeldman$elm_css$Css$margin4 = $rtfeldman$elm_css$Css$prop4('margin');
var $rtfeldman$elm_css$Css$marginRight = $rtfeldman$elm_css$Css$prop1('margin-right');
var $rtfeldman$elm_css$Css$UnitlessFloat = {$: 'UnitlessFloat'};
var $rtfeldman$elm_css$Css$num = function (val) {
	return {
		lengthOrNumber: $rtfeldman$elm_css$Css$Structure$Compatible,
		lengthOrNumberOrAutoOrNoneOrContent: $rtfeldman$elm_css$Css$Structure$Compatible,
		number: $rtfeldman$elm_css$Css$Structure$Compatible,
		numberOrInfinite: $rtfeldman$elm_css$Css$Structure$Compatible,
		numericValue: val,
		unitLabel: '',
		units: $rtfeldman$elm_css$Css$UnitlessFloat,
		value: $elm$core$String$fromFloat(val)
	};
};
var $rtfeldman$elm_css$Css$opacity = $rtfeldman$elm_css$Css$prop1('opacity');
var $rtfeldman$elm_css$Css$textAlign = function (fn) {
	return A3(
		$rtfeldman$elm_css$Css$Internal$getOverloadedProperty,
		'textAlign',
		'text-align',
		fn($rtfeldman$elm_css$Css$Internal$lengthForOverloadedProperty));
};
var $rtfeldman$elm_css$Css$textDecoration = $rtfeldman$elm_css$Css$prop1('text-decoration');
var $rtfeldman$elm_css$Css$underline = {textDecorationLine: $rtfeldman$elm_css$Css$Structure$Compatible, value: 'underline'};
var $rtfeldman$elm_css$Css$wrap = {flexDirectionOrWrap: $rtfeldman$elm_css$Css$Structure$Compatible, flexWrap: $rtfeldman$elm_css$Css$Structure$Compatible, value: 'wrap'};
var $author$project$Page$NewTemplate$styles = {
	balanceContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(40)),
			$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$padding(
			$rtfeldman$elm_css$Css$px(20))
		]),
	balanceHeaderText: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(11)),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$blueGrey600)
		]),
	browseTxt: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$blueA700),
			$rtfeldman$elm_css$Css$textDecoration($rtfeldman$elm_css$Css$underline)
		]),
	card: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$padding(
			$rtfeldman$elm_css$Css$px(24))
		]),
	cardContent: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$row),
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$flexWrap($rtfeldman$elm_css$Css$wrap),
			A3(
			$rtfeldman$elm_css$Css$border3,
			$rtfeldman$elm_css$Css$px(1),
			$rtfeldman$elm_css$Css$dashed,
			$author$project$Material$Styled$Color$grey200),
			$rtfeldman$elm_css$Css$padding(
			$rtfeldman$elm_css$Css$px(48)),
			$rtfeldman$elm_css$Css$hover(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer),
					$rtfeldman$elm_css$Css$opacity(
					$rtfeldman$elm_css$Css$num(0.5)),
					$rtfeldman$elm_css$Css$backgroundColor($author$project$Material$Styled$Color$grey50)
				]))
		]),
	cardContentHover: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer),
			$rtfeldman$elm_css$Css$opacity(
			$rtfeldman$elm_css$Css$num(0.5)),
			$rtfeldman$elm_css$Css$backgroundColor($author$project$Material$Styled$Color$grey50)
		]),
	cardContentnoHover: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$row),
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$flexWrap($rtfeldman$elm_css$Css$wrap),
			A3(
			$rtfeldman$elm_css$Css$border3,
			$rtfeldman$elm_css$Css$px(1),
			$rtfeldman$elm_css$Css$dashed,
			$author$project$Material$Styled$Color$grey200),
			$rtfeldman$elm_css$Css$padding(
			$rtfeldman$elm_css$Css$px(48))
		]),
	container: _List_fromArray(
		[
			A4(
			$rtfeldman$elm_css$Css$margin4,
			$rtfeldman$elm_css$Css$px(25),
			$rtfeldman$elm_css$Css$px(24),
			$rtfeldman$elm_css$Css$px(0),
			$rtfeldman$elm_css$Css$px(25))
		]),
	docHeader: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(24)),
			$rtfeldman$elm_css$Css$fontWeight(
			$rtfeldman$elm_css$Css$int(500)),
			$rtfeldman$elm_css$Css$marginBottom($rtfeldman$elm_css$Css$zero)
		]),
	docImg: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(130)),
			$rtfeldman$elm_css$Css$marginRight(
			$rtfeldman$elm_css$Css$px(20))
		]),
	docInfo: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$row)
		]),
	docTxt: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$blueGrey600),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(14)),
			$rtfeldman$elm_css$Css$fontWeight(
			$rtfeldman$elm_css$Css$int(400)),
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(10))
		]),
	docTxtContent: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			$rtfeldman$elm_css$Css$flexWrap($rtfeldman$elm_css$Css$wrap),
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center)
		]),
	fileIcon: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$em(1)),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(24)),
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(12)),
			$rtfeldman$elm_css$Css$marginRight(
			$rtfeldman$elm_css$Css$px(8))
		]),
	fileRemoveBtn: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(14)),
			$rtfeldman$elm_css$Css$fontWeight(
			$rtfeldman$elm_css$Css$int(500)),
			$rtfeldman$elm_css$Css$textTransform($rtfeldman$elm_css$Css$uppercase),
			$rtfeldman$elm_css$Css$backgroundColor($rtfeldman$elm_css$Css$transparent),
			$rtfeldman$elm_css$Css$border($rtfeldman$elm_css$Css$zero),
			$rtfeldman$elm_css$Css$marginRight(
			$rtfeldman$elm_css$Css$px(16)),
			$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer),
			$rtfeldman$elm_css$Css$hover(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$backgroundColor($author$project$Material$Styled$Color$grey100),
					$rtfeldman$elm_css$Css$outline($rtfeldman$elm_css$Css$none)
				])),
			$rtfeldman$elm_css$Css$focus(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$outline($rtfeldman$elm_css$Css$none)
				]))
		]),
	fileSize: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$blueGrey600),
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(8)),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(12)),
			$rtfeldman$elm_css$Css$fontWeight(
			$rtfeldman$elm_css$Css$int(400))
		]),
	fileTitle: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontWeight(
			$rtfeldman$elm_css$Css$int(500)),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(16)),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$blueGrey900),
			$rtfeldman$elm_css$Css$marginBottom($rtfeldman$elm_css$Css$zero)
		]),
	fileTooBigTxt: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$red400),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(14)),
			$rtfeldman$elm_css$Css$lineHeight(
			$rtfeldman$elm_css$Css$px(24)),
			$rtfeldman$elm_css$Css$fontWeight(
			$rtfeldman$elm_css$Css$int(500))
		]),
	fileUploadBtn: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$maxWidth($rtfeldman$elm_css$Css$fitContent),
			A2(
			$rtfeldman$elm_css$Css$padding2,
			$rtfeldman$elm_css$Css$px(8),
			$rtfeldman$elm_css$Css$px(10))
		]),
	fileUploadContent: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$flexEnd)
		]),
	fileUploadDisabledBtn: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$maxWidth($rtfeldman$elm_css$Css$fitContent),
			A2(
			$rtfeldman$elm_css$Css$padding2,
			$rtfeldman$elm_css$Css$px(8),
			$rtfeldman$elm_css$Css$px(10)),
			$rtfeldman$elm_css$Css$backgroundColor($author$project$Material$Styled$Color$grey300),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$grey500),
			$rtfeldman$elm_css$Css$boxShadow($rtfeldman$elm_css$Css$none),
			$rtfeldman$elm_css$Css$important(
			$rtfeldman$elm_css$Css$hover(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$initial),
						$rtfeldman$elm_css$Css$boxShadow($rtfeldman$elm_css$Css$none)
					])))
		]),
	header: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(24)),
			$rtfeldman$elm_css$Css$fontWeight(
			$rtfeldman$elm_css$Css$int(500)),
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(50))
		]),
	line: _List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Css$margin2,
			$rtfeldman$elm_css$Css$px(24),
			$rtfeldman$elm_css$Css$zero),
			$rtfeldman$elm_css$Css$backgroundColor($author$project$Material$Styled$Color$grey300),
			$rtfeldman$elm_css$Css$border($rtfeldman$elm_css$Css$zero),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(1))
		]),
	numberText: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(29)),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$blueGrey900)
		]),
	overallBalanceContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$row),
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceBetween)
		]),
	quota: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(24)),
			$rtfeldman$elm_css$Css$fontWeight(
			$rtfeldman$elm_css$Css$int(500)),
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(5))
		]),
	toolTipText: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(10.67))
		]),
	uploadDoc: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$paddingLeft(
			$rtfeldman$elm_css$Css$px(16))
		])
};
var $author$project$Page$NewTemplate$blurCard = function (model) {
	return model.fileHover ? _Utils_ap($author$project$Page$NewTemplate$styles.cardContent, $author$project$Page$NewTemplate$styles.cardContentHover) : $author$project$Page$NewTemplate$styles.cardContent;
};
var $author$project$Material$Styled$Card$defaultConfig = {
	containerAttributes: _List_Nil,
	containerStyles: _List_Nil,
	headerName: $elm$core$Maybe$Nothing,
	headerStyle: _List_Nil,
	icon: $rtfeldman$elm_css$Html$Styled$text('')
};
var $rtfeldman$elm_css$Html$Styled$hr = $rtfeldman$elm_css$Html$Styled$node('hr');
var $author$project$Material$Styled$Divider$styles = {
	container: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$margin($rtfeldman$elm_css$Css$zero),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100)),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(1)),
			$rtfeldman$elm_css$Css$backgroundColor($author$project$Material$Styled$Color$grey200),
			$rtfeldman$elm_css$Css$boxSizing($rtfeldman$elm_css$Css$borderBox),
			$rtfeldman$elm_css$Css$border($rtfeldman$elm_css$Css$zero)
		])
};
var $author$project$Material$Styled$Divider$divider = F2(
	function (attributes, children) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$hr,
			A2(
				$elm$core$List$cons,
				$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Material$Styled$Divider$styles.container),
				attributes),
			children);
	});
var $author$project$Material$Styled$Card$mergeProperty = F2(
	function (property, config) {
		switch (property.$) {
			case 'ContainerStyle':
				var style = property.a;
				return _Utils_update(
					config,
					{
						containerStyles: _Utils_ap(config.containerStyles, style)
					});
			case 'HeaderText':
				var newText = property.a;
				return _Utils_update(
					config,
					{headerName: newText});
			case 'HeaderStyle':
				var style = property.a;
				return _Utils_update(
					config,
					{
						headerStyle: _Utils_ap(config.headerStyle, style)
					});
			default:
				var newIcon = property.a;
				return _Utils_update(
					config,
					{icon: newIcon});
		}
	});
var $author$project$Material$Styled$Card$mergeConfig = F2(
	function (config, properties) {
		return function (c) {
			return _Utils_update(
				c,
				{
					containerAttributes: A2(
						$elm$core$List$cons,
						$rtfeldman$elm_css$Html$Styled$Attributes$css(c.containerStyles),
						c.containerAttributes)
				});
		}(
			A3($elm$core$List$foldl, $author$project$Material$Styled$Card$mergeProperty, config, properties));
	});
var $author$project$Material$Styled$Card$styles = {
	cardHeader: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$row),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			A2(
			$rtfeldman$elm_css$Css$padding2,
			$rtfeldman$elm_css$Css$px(16),
			$rtfeldman$elm_css$Css$px(24)),
			$rtfeldman$elm_css$Css$color(
			$rtfeldman$elm_css$Css$hex($author$project$Material$Styled$Color$blueGrey900String)),
			$rtfeldman$elm_css$Css$fontWeight(
			$rtfeldman$elm_css$Css$int(500)),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(16))
		]),
	container: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$borderRadius(
			$rtfeldman$elm_css$Css$px(4)),
			$rtfeldman$elm_css$Css$backgroundColor($author$project$Material$Styled$Color$white),
			A2($rtfeldman$elm_css$Css$property, 'box-shadow', '0 0 0 1px rgba(63,63,68,0.05), 0 1px 3px 0 rgba(63,63,68,0.15)')
		]),
	headerContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100))
		])
};
var $author$project$Material$Styled$Card$card = F2(
	function (attributes, children) {
		var _v0 = A2($author$project$Material$Styled$Card$mergeConfig, $author$project$Material$Styled$Card$defaultConfig, attributes);
		var containerAttributes = _v0.containerAttributes;
		var headerName = _v0.headerName;
		var headerStyle = _v0.headerStyle;
		var icon = _v0.icon;
		var header = function () {
			if (headerName.$ === 'Nothing') {
				return $rtfeldman$elm_css$Html$Styled$text('');
			} else {
				var newHeaderText = headerName.a;
				return A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Material$Styled$Card$styles.headerContainer)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css(
									_Utils_ap($author$project$Material$Styled$Card$styles.cardHeader, headerStyle))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(newHeaderText),
									icon
								])),
							A2($author$project$Material$Styled$Divider$divider, _List_Nil, _List_Nil)
						]));
			}
		}();
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			A2(
				$elm$core$List$cons,
				$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Material$Styled$Card$styles.container),
				containerAttributes),
			A2($elm$core$List$cons, header, children));
	});
var $author$project$Page$NewTemplate$alwaysPreventDefault = function (msg) {
	return _Utils_Tuple2(msg, true);
};
var $elm$virtual_dom$VirtualDom$MayPreventDefault = function (a) {
	return {$: 'MayPreventDefault', a: a};
};
var $rtfeldman$elm_css$Html$Styled$Events$preventDefaultOn = F2(
	function (event, decoder) {
		return A2(
			$rtfeldman$elm_css$VirtualDom$Styled$on,
			event,
			$elm$virtual_dom$VirtualDom$MayPreventDefault(decoder));
	});
var $author$project$Page$NewTemplate$cardContentOn = F2(
	function (event, decoder) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$Events$preventDefaultOn,
			event,
			A2($elm$json$Json$Decode$map, $author$project$Page$NewTemplate$alwaysPreventDefault, decoder));
	});
var $author$project$Material$Styled$Card$ContainerStyle = function (a) {
	return {$: 'ContainerStyle', a: a};
};
var $author$project$Material$Styled$Card$containerStyles = function (style) {
	return $author$project$Material$Styled$Card$ContainerStyle(style);
};
var $elm$json$Json$Decode$oneOrMoreHelp = F2(
	function (toValue, xs) {
		if (!xs.b) {
			return $elm$json$Json$Decode$fail('a ARRAY with at least ONE element');
		} else {
			var y = xs.a;
			var ys = xs.b;
			return $elm$json$Json$Decode$succeed(
				A2(toValue, y, ys));
		}
	});
var $elm$json$Json$Decode$oneOrMore = F2(
	function (toValue, decoder) {
		return A2(
			$elm$json$Json$Decode$andThen,
			$elm$json$Json$Decode$oneOrMoreHelp(toValue),
			$elm$json$Json$Decode$list(decoder));
	});
var $author$project$Page$NewTemplate$dropDecoder = A2(
	$elm$json$Json$Decode$at,
	_List_fromArray(
		['dataTransfer', 'files']),
	A2(
		$elm$json$Json$Decode$map,
		$author$project$Types$OnAuth,
		A2(
			$elm$json$Json$Decode$map,
			$author$project$Types$OnNewTemplate,
			A2($elm$json$Json$Decode$oneOrMore, $author$project$Type$NewTemplate$GotFiles, $elm$file$File$decoder))));
var $rtfeldman$elm_css$Html$Styled$h2 = $rtfeldman$elm_css$Html$Styled$node('h2');
var $author$project$View$Theme$images = {
	clarityOfConsent: '/images/clarity-of-consent.png',
	close: '/images/logos/close.svg',
	dashboard: '/images/Document Dashboard.png',
	dashboardCover: {dashboardCover1: '/images/covers/Hello_Series_1.png', dashboardCover2: '/images/covers/Hello_Series_2.png', dashboardCover3: '/images/covers/Hello_Series_3.png'},
	_delete: '/images/logos/delete.svg',
	documentSecurity: '/images/document-security.png',
	dropDoc: '/images/drop-document.svg',
	edit: '/images/logos/edit.svg',
	fileCopy: '/images/logos/file-copy.svg',
	fourZeroFour: '/images/error404.svg',
	logoColor: '/images/signnet.png',
	logoWhite: '/images/signnet2.svg',
	myCompany: '/images/myCompany.png',
	myCompanyWide: '/images/myCompanyWide.png',
	myInfoLogo: '/images/MyInfoLogo.png',
	person: '/images/logos/person.svg',
	pointsCover: '/images/covers/pointsCover.png',
	retry: '/images/logos/replay.svg',
	search: '/images/logos/search.svg',
	signerIdentity: '/images/signer-identity.png',
	signingOrder: '/images/logos/signingOrder.svg',
	specialDashboardCover: {cover1: '/images/covers/christmas_cover_1.png', cover2: '/images/covers/christmas_cover_2.png', cover3: '/images/covers/christmas_cover_3.png'},
	trustScore: {level1: '/images/email/trustScore/1.png', level2: '/images/email/trustScore/2.png', level3: '/images/email/trustScore/3.png', level4: '/images/email/trustScore/4.png', level5: '/images/email/trustScore/5.png'},
	trustScoreCover: '/images/trustScoreCover.png',
	trustScorePageCover: '/images/covers/cover3.jpg',
	wicLogo: '/images/wicLogo.png'
};
var $rtfeldman$elm_css$Html$Styled$img = $rtfeldman$elm_css$Html$Styled$node('img');
var $author$project$Material$Styled$Icon$MoreInformation$view = F2(
	function (attributes, children) {
		return A2(
			$rtfeldman$elm_css$Svg$Styled$svg,
			_Utils_ap(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Svg$Styled$Attributes$fill('black'),
						$rtfeldman$elm_css$Svg$Styled$Attributes$width('24px'),
						$rtfeldman$elm_css$Svg$Styled$Attributes$height('24px'),
						$rtfeldman$elm_css$Svg$Styled$Attributes$viewBox('0 0 24 24')
					]),
				attributes),
			_Utils_ap(
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Svg$Styled$path,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Svg$Styled$Attributes$d('M0 0h24v24H0z'),
								$rtfeldman$elm_css$Svg$Styled$Attributes$fill('none')
							]),
						_List_Nil),
						A2(
						$rtfeldman$elm_css$Svg$Styled$path,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Svg$Styled$Attributes$d('M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z')
							]),
						_List_Nil)
					]),
				children));
	});
var $author$project$Material$Styled$Icon$moreInfo = $author$project$Material$Styled$Icon$MoreInformation$view;
var $rtfeldman$elm_css$Html$Styled$p = $rtfeldman$elm_css$Html$Styled$node('p');
var $author$project$Material$Styled$Color$red500String = '#f44336';
var $author$project$Material$Styled$Color$red500 = $rtfeldman$elm_css$Css$hex($author$project$Material$Styled$Color$red500String);
var $rtfeldman$elm_css$Html$Styled$Attributes$src = function (url) {
	return A2($rtfeldman$elm_css$Html$Styled$Attributes$stringProperty, 'src', url);
};
var $rtfeldman$elm_css$Html$Styled$Events$onMouseEnter = function (msg) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$Events$on,
		'mouseenter',
		$elm$json$Json$Decode$succeed(msg));
};
var $rtfeldman$elm_css$Html$Styled$Events$onMouseLeave = function (msg) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$Events$on,
		'mouseleave',
		$elm$json$Json$Decode$succeed(msg));
};
var $author$project$Material$Styled$Color$blueA400String = '#2979FF';
var $author$project$Material$Styled$Color$blueA400 = $rtfeldman$elm_css$Css$hex($author$project$Material$Styled$Color$blueA400String);
var $rtfeldman$elm_css$Css$borderBottom3 = $rtfeldman$elm_css$Css$prop3('border-bottom');
var $rtfeldman$elm_css$Css$borderLeft3 = $rtfeldman$elm_css$Css$prop3('border-left');
var $rtfeldman$elm_css$Css$borderRight3 = $rtfeldman$elm_css$Css$prop3('border-right');
var $rtfeldman$elm_css$Css$borderTop3 = $rtfeldman$elm_css$Css$prop3('border-top');
var $rtfeldman$elm_css$Css$relative = {position: $rtfeldman$elm_css$Css$Structure$Compatible, value: 'relative'};
var $author$project$View$InfomationToolTip$textAnimation = $rtfeldman$elm_css$Css$Animations$keyframes(
	_List_fromArray(
		[
			_Utils_Tuple2(
			0,
			_List_fromArray(
				[
					A2($rtfeldman$elm_css$Css$Animations$property, 'width', '0'),
					A2($rtfeldman$elm_css$Css$Animations$property, 'height', '0'),
					A2($rtfeldman$elm_css$Css$Animations$property, 'opacity', '0')
				])),
			_Utils_Tuple2(
			100,
			_List_fromArray(
				[
					A2($rtfeldman$elm_css$Css$Animations$property, 'width', '200'),
					A2($rtfeldman$elm_css$Css$Animations$property, 'height', '100'),
					A2($rtfeldman$elm_css$Css$Animations$property, 'opacity', '0.9')
				]))
		]));
var $author$project$View$InfomationToolTip$styles = {
	arrowDown: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$relative),
			$rtfeldman$elm_css$Css$left(
			$rtfeldman$elm_css$Css$px(20)),
			A3(
			$rtfeldman$elm_css$Css$borderLeft3,
			$rtfeldman$elm_css$Css$px(20),
			$rtfeldman$elm_css$Css$solid,
			$rtfeldman$elm_css$Css$transparent),
			A3(
			$rtfeldman$elm_css$Css$borderRight3,
			$rtfeldman$elm_css$Css$px(20),
			$rtfeldman$elm_css$Css$solid,
			$rtfeldman$elm_css$Css$transparent),
			A3(
			$rtfeldman$elm_css$Css$borderTop3,
			$rtfeldman$elm_css$Css$px(20),
			$rtfeldman$elm_css$Css$solid,
			A4($rtfeldman$elm_css$Css$rgba, 41, 121, 255, 0.9)),
			A3(
			$rtfeldman$elm_css$Css$borderBottom3,
			$rtfeldman$elm_css$Css$px(20),
			$rtfeldman$elm_css$Css$solid,
			$rtfeldman$elm_css$Css$transparent),
			$rtfeldman$elm_css$Css$width($rtfeldman$elm_css$Css$zero),
			$rtfeldman$elm_css$Css$height($rtfeldman$elm_css$Css$zero)
		]),
	marginLeft10: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginLeft(
			$rtfeldman$elm_css$Css$px(10))
		]),
	messageContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$relative),
			$rtfeldman$elm_css$Css$bottom(
			$rtfeldman$elm_css$Css$px(190)),
			$rtfeldman$elm_css$Css$left(
			$rtfeldman$elm_css$Css$px(-30)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(0)),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(0))
		]),
	toolTip: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$backgroundColor($author$project$Material$Styled$Color$blueA400),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(200)),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(100)),
			$rtfeldman$elm_css$Css$padding(
			$rtfeldman$elm_css$Css$px(20)),
			$rtfeldman$elm_css$Css$borderRadius(
			$rtfeldman$elm_css$Css$px(10)),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$white),
			$rtfeldman$elm_css$Css$animationName($author$project$View$InfomationToolTip$textAnimation),
			$rtfeldman$elm_css$Css$animationDuration(
			$rtfeldman$elm_css$Css$sec(0.3)),
			$rtfeldman$elm_css$Css$opacity(
			$rtfeldman$elm_css$Css$num(0.9))
		])
};
var $author$project$View$InfomationToolTip$view = F5(
	function (onEnterMsg, onLeaveMsg, hover, textMsg, icon) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$InfomationToolTip$styles.marginLeft10),
					$rtfeldman$elm_css$Html$Styled$Events$onMouseEnter(onEnterMsg),
					$rtfeldman$elm_css$Html$Styled$Events$onMouseLeave(onLeaveMsg)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							icon,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Svg$Styled$Attributes$width('20px'),
									$rtfeldman$elm_css$Svg$Styled$Attributes$height('20px')
								]),
							_List_Nil)
						])),
					hover ? A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$InfomationToolTip$styles.messageContainer)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$InfomationToolTip$styles.toolTip)
								]),
							_List_fromArray(
								[textMsg])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$InfomationToolTip$styles.arrowDown)
								]),
							_List_Nil)
						])) : $rtfeldman$elm_css$Html$Styled$text('')
				]));
	});
var $author$project$Page$NewTemplate$uploadCard = F4(
	function (model, authModel, hasTemplateQuotaLeft, templateModel) {
		var uploadTemplateText = model.languageSwitchModel.allLanguageData.location.createTemplatePage.uploadTemplate;
		var dragAndDropTexts = model.languageSwitchModel.allLanguageData.location.viewNotarisedInformation;
		return A2(
			$author$project$Material$Styled$Card$card,
			_List_fromArray(
				[
					$author$project$Material$Styled$Card$containerStyles($author$project$Page$NewTemplate$styles.card)
				]),
			_List_fromArray(
				[
					$author$project$Page$NewTemplate$banner(authModel.newTemplateModel.error),
					hasTemplateQuotaLeft ? A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							$author$project$Page$NewTemplate$blurCard(authModel.newTemplateModel)),
							$rtfeldman$elm_css$Html$Styled$Events$onClick(
							$author$project$Types$OnAuth(
								$author$project$Types$OnNewTemplate($author$project$Type$NewTemplate$PickFile))),
							A2(
							$author$project$Page$NewTemplate$cardContentOn,
							'dragenter',
							$elm$json$Json$Decode$succeed(
								$author$project$Types$OnAuth(
									$author$project$Types$OnNewTemplate($author$project$Type$NewTemplate$OnDragEnter)))),
							A2(
							$author$project$Page$NewTemplate$cardContentOn,
							'dragover',
							$elm$json$Json$Decode$succeed(
								$author$project$Types$OnAuth(
									$author$project$Types$OnNewTemplate($author$project$Type$NewTemplate$OnDragEnter)))),
							A2(
							$author$project$Page$NewTemplate$cardContentOn,
							'dragleave',
							$elm$json$Json$Decode$succeed(
								$author$project$Types$OnAuth(
									$author$project$Types$OnNewTemplate($author$project$Type$NewTemplate$OnDragLeave)))),
							A2($author$project$Page$NewTemplate$cardContentOn, 'drop', $author$project$Page$NewTemplate$dropDecoder),
							A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'data-test', 'dropzone')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$img,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$src($author$project$View$Theme$images.dropDoc),
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$NewTemplate$styles.docImg)
								]),
							_List_Nil),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$NewTemplate$styles.docTxtContent)
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$h2,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$NewTemplate$styles.docHeader)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(uploadTemplateText)
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$p,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$NewTemplate$styles.docTxt)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(dragAndDropTexts.dragAndDrop + ' '),
											$rtfeldman$elm_css$Html$Styled$text(dragAndDropTexts.browseYourPC)
										]))
								]))
						])) : A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$NewTemplate$styles.cardContentnoHover)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$img,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$src($author$project$View$Theme$images.dropDoc),
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$NewTemplate$styles.docImg)
								]),
							_List_Nil),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$NewTemplate$styles.docTxtContent)
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$h2,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$NewTemplate$styles.docHeader)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(uploadTemplateText)
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$p,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$NewTemplate$styles.docTxt)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(dragAndDropTexts.dragAndDrop + ' '),
											$rtfeldman$elm_css$Html$Styled$text(dragAndDropTexts.browseYourPC)
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css(
											_List_fromArray(
												[$rtfeldman$elm_css$Css$displayFlex]))
										]),
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$div,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$css(
													_List_fromArray(
														[
															$rtfeldman$elm_css$Css$marginTop(
															$rtfeldman$elm_css$Css$px(10)),
															$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$red500)
														]))
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text('Template Quota limit reached.')
												])),
											A2(
											$rtfeldman$elm_css$Html$Styled$div,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$css(
													_List_fromArray(
														[
															$rtfeldman$elm_css$Css$marginTop(
															$rtfeldman$elm_css$Css$px(10)),
															$rtfeldman$elm_css$Css$marginLeft(
															$rtfeldman$elm_css$Css$px(-7))
														]))
												]),
											_List_fromArray(
												[
													A5(
													$author$project$View$InfomationToolTip$view,
													$author$project$Types$OnAuth(
														$author$project$Types$OnNewTemplate(
															$author$project$Type$NewTemplate$OnHover($author$project$Type$NewTemplate$Enter))),
													$author$project$Types$OnAuth(
														$author$project$Types$OnNewTemplate(
															$author$project$Type$NewTemplate$OnHover($author$project$Type$NewTemplate$Leave))),
													templateModel.toolTipHover,
													A2(
														$rtfeldman$elm_css$Html$Styled$span,
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$NewTemplate$styles.toolTipText)
															]),
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$text('There are no available quota for templates in your organisation. Please contact your Organisation Administrator to remove existing templates or purchase more templates by contacting help@sign.net.\u00A0')
															])),
													$author$project$Material$Styled$Icon$moreInfo)
												]))
										]))
								]))
						]))
				]));
	});
var $author$project$Type$NewMultipleDocument$OnCloseBanner = {$: 'OnCloseBanner'};
var $author$project$Type$NewMultipleDocument$OnDragEnter = {$: 'OnDragEnter'};
var $author$project$Type$NewMultipleDocument$OnDragLeave = {$: 'OnDragLeave'};
var $author$project$Type$NewMultipleDocument$PickFile = {$: 'PickFile'};
var $author$project$Page$NewDocument$UploadCard$banner = F2(
	function (error, onclickMsg) {
		if (error.$ === 'Just') {
			var message = error.a;
			return A2(
				$author$project$Material$Styled$Banner$banner,
				_List_fromArray(
					[
						$author$project$Material$Styled$Banner$theme($author$project$Material$Styled$Banner$errorTheme),
						$author$project$Material$Styled$Banner$body(
						$rtfeldman$elm_css$Html$Styled$text('Upload PDF files up to 25MB')),
						$author$project$Material$Styled$Banner$title('Error - ' + message),
						$author$project$Material$Styled$Banner$closeIconAttributes(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Svg$Styled$Events$onClick(onclickMsg)
							]))
					]),
				_List_Nil);
		} else {
			return $rtfeldman$elm_css$Html$Styled$text('');
		}
	});
var $author$project$Material$Styled$Color$blueGrey500String = '#607D8B';
var $author$project$Material$Styled$Color$blueGrey500 = $rtfeldman$elm_css$Css$hex($author$project$Material$Styled$Color$blueGrey500String);
var $rtfeldman$elm_css$Css$flexStart = $rtfeldman$elm_css$Css$prop1('flex-start');
var $author$project$Page$NewDocument$UploadCard$styles = {
	browseTxt: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$blueA700),
			$rtfeldman$elm_css$Css$textDecoration($rtfeldman$elm_css$Css$underline)
		]),
	card: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$padding(
			$rtfeldman$elm_css$Css$px(24)),
			$rtfeldman$elm_css$Css$marginBottom(
			$rtfeldman$elm_css$Css$px(50))
		]),
	cardContent: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$flexWrap($rtfeldman$elm_css$Css$wrap),
			A3(
			$rtfeldman$elm_css$Css$border3,
			$rtfeldman$elm_css$Css$px(1),
			$rtfeldman$elm_css$Css$dashed,
			$author$project$Material$Styled$Color$grey200),
			$rtfeldman$elm_css$Css$padding(
			$rtfeldman$elm_css$Css$px(48)),
			$rtfeldman$elm_css$Css$hover(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$backgroundColor(
					A4($rtfeldman$elm_css$Css$rgba, 41, 121, 255, 0.16)),
					$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer)
				]))
		]),
	cardContentHover: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer),
			$rtfeldman$elm_css$Css$opacity(
			$rtfeldman$elm_css$Css$num(0.5)),
			$rtfeldman$elm_css$Css$backgroundColor($author$project$Material$Styled$Color$grey50)
		]),
	docHeader: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(24)),
			$rtfeldman$elm_css$Css$fontWeight(
			$rtfeldman$elm_css$Css$int(500)),
			$rtfeldman$elm_css$Css$marginBottom($rtfeldman$elm_css$Css$zero)
		]),
	docImg: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(130)),
			$rtfeldman$elm_css$Css$marginRight(
			$rtfeldman$elm_css$Css$px(20))
		]),
	docInfo: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$row)
		]),
	docTextContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center)
		]),
	docTxt: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$blueGrey600),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(14)),
			$rtfeldman$elm_css$Css$fontWeight(
			$rtfeldman$elm_css$Css$int(400)),
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(10))
		]),
	docTxtContent: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			$rtfeldman$elm_css$Css$flexWrap($rtfeldman$elm_css$Css$wrap),
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center)
		]),
	fileIcon: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$em(1)),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(24)),
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(12)),
			$rtfeldman$elm_css$Css$marginRight(
			$rtfeldman$elm_css$Css$px(8))
		]),
	fileRemoveBtn: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(14)),
			$rtfeldman$elm_css$Css$fontWeight(
			$rtfeldman$elm_css$Css$int(500)),
			$rtfeldman$elm_css$Css$textTransform($rtfeldman$elm_css$Css$uppercase),
			$rtfeldman$elm_css$Css$backgroundColor($rtfeldman$elm_css$Css$transparent),
			$rtfeldman$elm_css$Css$border($rtfeldman$elm_css$Css$zero),
			$rtfeldman$elm_css$Css$marginRight(
			$rtfeldman$elm_css$Css$px(16)),
			$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer),
			$rtfeldman$elm_css$Css$hover(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$backgroundColor($author$project$Material$Styled$Color$grey100),
					$rtfeldman$elm_css$Css$outline($rtfeldman$elm_css$Css$none)
				])),
			$rtfeldman$elm_css$Css$focus(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$outline($rtfeldman$elm_css$Css$none)
				]))
		]),
	fileSize: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$blueGrey600),
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(8)),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(12)),
			$rtfeldman$elm_css$Css$fontWeight(
			$rtfeldman$elm_css$Css$int(400))
		]),
	fileTitle: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontWeight(
			$rtfeldman$elm_css$Css$int(500)),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(16)),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$blueGrey900),
			$rtfeldman$elm_css$Css$marginBottom($rtfeldman$elm_css$Css$zero)
		]),
	fileTooBigTxt: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$red400),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(14)),
			$rtfeldman$elm_css$Css$lineHeight(
			$rtfeldman$elm_css$Css$px(24)),
			$rtfeldman$elm_css$Css$fontWeight(
			$rtfeldman$elm_css$Css$int(500))
		]),
	fileUploadBtn: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$maxWidth($rtfeldman$elm_css$Css$fitContent),
			A2(
			$rtfeldman$elm_css$Css$padding2,
			$rtfeldman$elm_css$Css$px(8),
			$rtfeldman$elm_css$Css$px(10))
		]),
	fileUploadContent: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$flexEnd)
		]),
	fileUploadDisabledBtn: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$maxWidth($rtfeldman$elm_css$Css$fitContent),
			A2(
			$rtfeldman$elm_css$Css$padding2,
			$rtfeldman$elm_css$Css$px(8),
			$rtfeldman$elm_css$Css$px(10)),
			$rtfeldman$elm_css$Css$backgroundColor($author$project$Material$Styled$Color$grey300),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$grey500),
			$rtfeldman$elm_css$Css$boxShadow($rtfeldman$elm_css$Css$none),
			$rtfeldman$elm_css$Css$important(
			$rtfeldman$elm_css$Css$hover(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$initial),
						$rtfeldman$elm_css$Css$boxShadow($rtfeldman$elm_css$Css$none)
					])))
		]),
	modalBody: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(12)),
			$rtfeldman$elm_css$Css$fontWeight(
			$rtfeldman$elm_css$Css$int(400)),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$blueGrey500)
		]),
	modalContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$vw(70)),
			$rtfeldman$elm_css$Css$maxWidth(
			$rtfeldman$elm_css$Css$px(500))
		]),
	modalHeader: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$row),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$flexStart),
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceBetween),
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(5))
		]),
	modalHeaderTxt: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(20)),
			$rtfeldman$elm_css$Css$fontWeight(
			$rtfeldman$elm_css$Css$int(500))
		]),
	progressBar: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(10))
		]),
	uploadDoc: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$paddingLeft(
			$rtfeldman$elm_css$Css$px(16))
		])
};
var $author$project$Page$NewDocument$UploadCard$blurCard = function (model) {
	return model.fileHover ? _Utils_ap($author$project$Page$NewDocument$UploadCard$styles.cardContent, $author$project$Page$NewDocument$UploadCard$styles.cardContentHover) : $author$project$Page$NewDocument$UploadCard$styles.cardContent;
};
var $rtfeldman$elm_css$Html$Styled$br = $rtfeldman$elm_css$Html$Styled$node('br');
var $author$project$Page$NewDocument$UploadCard$alwaysPreventDefault = function (msg) {
	return _Utils_Tuple2(msg, true);
};
var $author$project$Page$NewDocument$UploadCard$cardContentOn = F2(
	function (event, decoder) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$Events$preventDefaultOn,
			event,
			A2($elm$json$Json$Decode$map, $author$project$Page$NewDocument$UploadCard$alwaysPreventDefault, decoder));
	});
var $author$project$Type$NewMultipleDocument$DeleteFile = function (a) {
	return {$: 'DeleteFile', a: a};
};
var $author$project$Type$NewMultipleDocument$OnSubmitDoc = {$: 'OnSubmitDoc'};
var $author$project$Material$Styled$Icon$Delete$view = F2(
	function (attributes, children) {
		return A2(
			$rtfeldman$elm_css$Svg$Styled$svg,
			_Utils_ap(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Svg$Styled$Attributes$fill('black'),
						$rtfeldman$elm_css$Svg$Styled$Attributes$width('24px'),
						$rtfeldman$elm_css$Svg$Styled$Attributes$height('24px'),
						$rtfeldman$elm_css$Svg$Styled$Attributes$viewBox('0 0 24 24')
					]),
				attributes),
			_Utils_ap(
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Svg$Styled$path,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Svg$Styled$Attributes$d('M0 0h24v24H0z'),
								$rtfeldman$elm_css$Svg$Styled$Attributes$fill('none')
							]),
						_List_Nil),
						A2(
						$rtfeldman$elm_css$Svg$Styled$path,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Svg$Styled$Attributes$d('M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z')
							]),
						_List_Nil)
					]),
				children));
	});
var $author$project$Material$Styled$Icon$delete = $author$project$Material$Styled$Icon$Delete$view;
var $rtfeldman$elm_css$Css$end = $rtfeldman$elm_css$Css$prop1('end');
var $author$project$Material$Styled$Button$OnClick = function (a) {
	return {$: 'OnClick', a: a};
};
var $author$project$Material$Styled$Button$onClick = function (msg) {
	return $author$project$Material$Styled$Button$OnClick(msg);
};
var $author$project$Material$Styled$Button$ButtonStyles = function (a) {
	return {$: 'ButtonStyles', a: a};
};
var $author$project$Material$Styled$Button$styles = function (styles_) {
	return $author$project$Material$Styled$Button$ButtonStyles(styles_);
};
var $author$project$Page$NewDocument$UploadCard$displayFile = function (newmultipleDocModel) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$marginTop(
						$rtfeldman$elm_css$Css$px(20))
					]))
			]),
		_Utils_ap(
			A2(
				$elm$core$List$map,
				function (fileData) {
					return A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Css$displayFlex,
										$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$row),
										$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center)
									]))
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css(
										_List_fromArray(
											[
												$rtfeldman$elm_css$Css$marginRight(
												$rtfeldman$elm_css$Css$px(20))
											]))
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$elm$file$File$name(fileData.file))
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css(
										_List_fromArray(
											[
												$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer)
											])),
										$rtfeldman$elm_css$Html$Styled$Events$onClick(
										$author$project$Types$OnAuth(
											$author$project$Types$OnNewMultipleDoc(
												$author$project$Type$NewMultipleDocument$DeleteFile(fileData.base64String))))
									]),
								_List_fromArray(
									[
										A2($author$project$Material$Styled$Icon$delete, _List_Nil, _List_Nil)
									]))
							]));
				},
				newmultipleDocModel.files),
			_List_fromArray(
				[
					$elm$core$List$isEmpty(newmultipleDocModel.files) ? $rtfeldman$elm_css$Html$Styled$text('') : A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[
									$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$end)
								]))
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Material$Styled$Button$button,
							_List_fromArray(
								[
									$author$project$Material$Styled$Button$styles(
									_List_fromArray(
										[
											$rtfeldman$elm_css$Css$width(
											$rtfeldman$elm_css$Css$px(150))
										])),
									$author$project$Material$Styled$Button$onClick(
									$author$project$Types$OnAuth(
										$author$project$Types$OnNewMultipleDoc($author$project$Type$NewMultipleDocument$OnSubmitDoc)))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Next')
								]))
						]))
				])));
};
var $author$project$Page$NewDocument$UploadCard$dropDecoder = A2(
	$elm$json$Json$Decode$at,
	_List_fromArray(
		['dataTransfer', 'files']),
	A2(
		$elm$json$Json$Decode$map,
		$author$project$Types$OnAuth,
		A2(
			$elm$json$Json$Decode$map,
			$author$project$Types$OnNewMultipleDoc,
			A2($elm$json$Json$Decode$oneOrMore, $author$project$Type$NewMultipleDocument$GotFiles, $elm$file$File$decoder))));
var $author$project$Page$NewDocument$UploadCard$view = F2(
	function (model, authModel) {
		var lanaguageDashboardLanguageData = model.languageSwitchModel.allLanguageData.location.dashboard;
		return A2(
			$author$project$Material$Styled$Card$card,
			_List_fromArray(
				[
					$author$project$Material$Styled$Card$containerStyles($author$project$Page$NewDocument$UploadCard$styles.card)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Page$NewDocument$UploadCard$banner,
					authModel.newDocModel.error,
					$author$project$Types$OnAuth(
						$author$project$Types$OnNewMultipleDoc($author$project$Type$NewMultipleDocument$OnCloseBanner))),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							$author$project$Page$NewDocument$UploadCard$blurCard(authModel.newDocModel)),
							$rtfeldman$elm_css$Html$Styled$Events$onClick(
							$author$project$Types$OnAuth(
								$author$project$Types$OnNewMultipleDoc($author$project$Type$NewMultipleDocument$PickFile))),
							A2(
							$author$project$Page$NewDocument$UploadCard$cardContentOn,
							'dragenter',
							$elm$json$Json$Decode$succeed(
								$author$project$Types$OnAuth(
									$author$project$Types$OnNewMultipleDoc($author$project$Type$NewMultipleDocument$OnDragEnter)))),
							A2(
							$author$project$Page$NewDocument$UploadCard$cardContentOn,
							'dragover',
							$elm$json$Json$Decode$succeed(
								$author$project$Types$OnAuth(
									$author$project$Types$OnNewMultipleDoc($author$project$Type$NewMultipleDocument$OnDragEnter)))),
							A2(
							$author$project$Page$NewDocument$UploadCard$cardContentOn,
							'dragleave',
							$elm$json$Json$Decode$succeed(
								$author$project$Types$OnAuth(
									$author$project$Types$OnNewMultipleDoc($author$project$Type$NewMultipleDocument$OnDragLeave)))),
							A2($author$project$Page$NewDocument$UploadCard$cardContentOn, 'drop', $author$project$Page$NewDocument$UploadCard$dropDecoder),
							A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'data-test', 'dropzone')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$h2,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$NewDocument$UploadCard$styles.docHeader)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(lanaguageDashboardLanguageData.uploadDocsTitle)
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css(
									_Utils_ap(
										$author$project$Page$NewDocument$UploadCard$styles.docTxt,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Css$marginBottom(
												$rtfeldman$elm_css$Css$px(20))
											])))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(lanaguageDashboardLanguageData.uploadDocsDescription)
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css(
									_List_fromArray(
										[
											$rtfeldman$elm_css$Css$displayFlex,
											$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$row)
										]))
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$img,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$src($author$project$View$Theme$images.dropDoc),
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$NewDocument$UploadCard$styles.docImg)
										]),
									_List_Nil),
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$NewDocument$UploadCard$styles.docTxtContent)
										]),
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$div,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$NewDocument$UploadCard$styles.docTxt)
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(lanaguageDashboardLanguageData.uploadDocsStep1)
												])),
											A2(
											$rtfeldman$elm_css$Html$Styled$div,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$rtfeldman$elm_css$Html$Styled$p,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$NewDocument$UploadCard$styles.docTxt)
														]),
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$text(lanaguageDashboardLanguageData.uploadDocsStep1Part2),
															A2($rtfeldman$elm_css$Html$Styled$br, _List_Nil, _List_Nil),
															A2($rtfeldman$elm_css$Html$Styled$br, _List_Nil, _List_Nil)
														]))
												]))
										]))
								]))
						])),
					$author$project$Page$NewDocument$UploadCard$displayFile(authModel.newMultipleDocModel)
				]));
	});
var $author$project$View$ActionButton$modal = F4(
	function (model, authModel, modalType, hasTemplateQuotaLeft) {
		return A2(
			$author$project$Material$Styled$Modal$modal,
			_List_fromArray(
				[
					$author$project$Material$Styled$Modal$open(true),
					$author$project$Material$Styled$Modal$onClose(
					$author$project$Types$OnAuth(
						$author$project$Types$OnActionButton($author$project$Type$ActionButton$CloseAll)))
				]),
			_List_fromArray(
				[
					function () {
					if (modalType.$ === 'Document') {
						return A2($author$project$Page$NewDocument$UploadCard$view, model, authModel);
					} else {
						return A4($author$project$Page$NewTemplate$uploadCard, model, authModel, hasTemplateQuotaLeft, authModel.newTemplateModel);
					}
				}()
				]));
	});
var $author$project$View$ActionButton$displayMenu = F3(
	function (model, authModel, isAppDomain) {
		var _v0 = authModel;
		var newTemplateModel = _v0.newTemplateModel;
		var _v1 = authModel.actionButton.status;
		switch (_v1.$) {
			case 'MenuOpen':
				return A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							$author$project$View$ActionButton$styles.backdrop(isAppDomain))
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$ActionButton$styles.textContainer),
									$rtfeldman$elm_css$Html$Styled$Events$onClick(
									$author$project$Types$OnAuth(
										$author$project$Types$OnActionButton(
											$author$project$Type$ActionButton$OpenModal($author$project$Type$ActionButton$Document))))
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$ActionButton$styles.icon)
										]),
									_List_fromArray(
										[
											A2(
											$author$project$Material$Styled$Icon$addCircle,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Svg$Styled$Attributes$width('25'),
													$rtfeldman$elm_css$Svg$Styled$Attributes$height('25')
												]),
											_List_Nil)
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$ActionButton$styles.text)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('New Documents')
										]))
								])),
							$author$project$View$ActionButton$displayTemplateButton(isAppDomain)
						]));
			case 'ModalOpen':
				var modalType = _v1.a;
				return A4(
					$author$project$View$ActionButton$modal,
					model,
					authModel,
					modalType,
					_Utils_cmp(newTemplateModel.templateQuota, newTemplateModel.templatesUsed) > 0);
			default:
				return $rtfeldman$elm_css$Html$Styled$text('');
		}
	});
var $author$project$View$ActionButton$actionButton = F2(
	function (authModel, model) {
		var msg = function () {
			var _v5 = authModel.actionButton.status;
			switch (_v5.$) {
				case 'MenuOpen':
					return $author$project$Types$OnAuth(
						$author$project$Types$OnActionButton($author$project$Type$ActionButton$CloseAll));
				case 'AllClose':
					return $author$project$Types$OnAuth(
						$author$project$Types$OnActionButton($author$project$Type$ActionButton$OpenMenu));
				default:
					return $author$project$Types$OnAuth(
						$author$project$Types$OnActionButton($author$project$Type$ActionButton$CloseAll));
			}
		}();
		var isAppDomain = A2(
			$author$project$Data$Domain$equal,
			$author$project$Data$Domain$selected(authModel.user.domains),
			model.appDomain);
		var containerStyle = function () {
			var _v4 = authModel.actionButton.status;
			switch (_v4.$) {
				case 'MenuOpen':
					return $author$project$View$ActionButton$styles.container;
				case 'AllClose':
					return _List_Nil;
				default:
					return _List_Nil;
			}
		}();
		var _v0 = model.route;
		_v0$4:
		while (true) {
			switch (_v0.$) {
				case 'Auth':
					switch (_v0.a.$) {
						case 'UploadMultipleDocRoute':
							var _v1 = _v0.a;
							return $rtfeldman$elm_css$Html$Styled$text('');
						case 'CreateTemplateRoute':
							var _v2 = _v0.a;
							return $rtfeldman$elm_css$Html$Styled$text('');
						default:
							break _v0$4;
					}
				case 'PublicOrAuth':
					switch (_v0.a.$) {
						case 'ViewDocumentRoute':
							return $rtfeldman$elm_css$Html$Styled$text('');
						case 'FillTemplateRoute':
							return $rtfeldman$elm_css$Html$Styled$text('');
						default:
							break _v0$4;
					}
				default:
					break _v0$4;
			}
		}
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'data-test', 'actionContainer')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(containerStyle),
							$rtfeldman$elm_css$Html$Styled$Events$onClick(
							$author$project$Types$OnAuth(
								$author$project$Types$OnActionButton($author$project$Type$ActionButton$CloseAll)))
						]),
					_List_Nil),
					A3($author$project$View$ActionButton$displayMenu, model, authModel, isAppDomain),
					A2(
					$author$project$Material$Styled$Button$button,
					_List_fromArray(
						[
							$author$project$Material$Styled$Button$styles($author$project$View$ActionButton$styles.actionButton),
							$author$project$Material$Styled$Button$onClick(msg)
						]),
					_List_fromArray(
						[
							function () {
							var _v3 = authModel.actionButton.status;
							switch (_v3.$) {
								case 'MenuOpen':
									return A2(
										$author$project$Material$Styled$Icon$close,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Svg$Styled$Attributes$width('25'),
												$rtfeldman$elm_css$Svg$Styled$Attributes$height('25'),
												$rtfeldman$elm_css$Svg$Styled$Attributes$fill('white')
											]),
										_List_Nil);
								case 'AllClose':
									return A2(
										$author$project$Material$Styled$Icon$add,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Svg$Styled$Attributes$width('25'),
												$rtfeldman$elm_css$Svg$Styled$Attributes$height('25')
											]),
										_List_Nil);
								default:
									return A2(
										$author$project$Material$Styled$Icon$add,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Svg$Styled$Attributes$width('25'),
												$rtfeldman$elm_css$Svg$Styled$Attributes$height('25')
											]),
										_List_Nil);
							}
						}()
						]))
				]));
	});
var $author$project$View$Theme$colors = {
	blue: $rtfeldman$elm_css$Css$hex('2979FF'),
	grey: $rtfeldman$elm_css$Css$hex('F4F6F8')
};
var $rtfeldman$elm_css$Css$stringsToValue = function (list) {
	return $elm$core$List$isEmpty(list) ? {value: 'none'} : {
		value: A2(
			$elm$core$String$join,
			', ',
			A2(
				$elm$core$List$map,
				function (s) {
					return s;
				},
				list))
	};
};
var $rtfeldman$elm_css$Css$fontFamilies = A2(
	$elm$core$Basics$composeL,
	$rtfeldman$elm_css$Css$prop1('font-family'),
	$rtfeldman$elm_css$Css$stringsToValue);
var $elm$virtual_dom$VirtualDom$node = function (tag) {
	return _VirtualDom_node(
		_VirtualDom_noScript(tag));
};
var $rtfeldman$elm_css$VirtualDom$Styled$unstyledNode = $rtfeldman$elm_css$VirtualDom$Styled$Unstyled;
var $rtfeldman$elm_css$Css$Global$global = function (snippets) {
	return $rtfeldman$elm_css$VirtualDom$Styled$unstyledNode(
		A3(
			$elm$virtual_dom$VirtualDom$node,
			'style',
			_List_Nil,
			$elm$core$List$singleton(
				$elm$virtual_dom$VirtualDom$text(
					$rtfeldman$elm_css$Css$Preprocess$Resolve$compile(
						$elm$core$List$singleton(
							$rtfeldman$elm_css$Css$Preprocess$stylesheet(snippets)))))));
};
var $rtfeldman$elm_css$Css$sansSerif = {fontFamily: $rtfeldman$elm_css$Css$Structure$Compatible, value: 'sans-serif'};
var $rtfeldman$elm_css$Css$Global$selector = F2(
	function (selectorStr, styles) {
		return A2(
			$rtfeldman$elm_css$VirtualDom$Styled$makeSnippet,
			styles,
			A2($rtfeldman$elm_css$Css$Structure$CustomSelector, selectorStr, _List_Nil));
	});
var $author$project$View$globalStyles = $rtfeldman$elm_css$Css$Global$global(
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Css$Global$selector,
			'body',
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$backgroundColor($author$project$View$Theme$colors.grey),
					$rtfeldman$elm_css$Css$fontFamilies(
					_List_fromArray(
						[
							'Roboto',
							'Helvetica',
							'Arial',
							function ($) {
							return $.value;
						}($rtfeldman$elm_css$Css$sansSerif)
						]))
				]))
		]));
var $rtfeldman$elm_css$Css$paddingBottom = $rtfeldman$elm_css$Css$prop1('padding-bottom');
var $author$project$View$styles = {
	container: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$relative),
			$rtfeldman$elm_css$Css$minHeight(
			$rtfeldman$elm_css$Css$vh(100))
		]),
	page: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$paddingBottom(
			$rtfeldman$elm_css$Css$px(100)),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$pct(100)),
			A2(
			$rtfeldman$elm_css$Css$Media$withMediaQuery,
			_List_fromArray(
				['screen and (max-width: 500px)']),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$paddingBottom(
					$rtfeldman$elm_css$Css$px(150))
				]))
		])
};
var $rtfeldman$elm_css$Html$Styled$a = $rtfeldman$elm_css$Html$Styled$node('a');
var $author$project$Material$Styled$Icon$Facebook$view = F2(
	function (attributes, children) {
		return A2(
			$rtfeldman$elm_css$Svg$Styled$svg,
			_Utils_ap(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Svg$Styled$Attributes$fill('white'),
						$rtfeldman$elm_css$Svg$Styled$Attributes$width('30px'),
						$rtfeldman$elm_css$Svg$Styled$Attributes$height('30px'),
						$rtfeldman$elm_css$Svg$Styled$Attributes$viewBox('0 0 24 24')
					]),
				attributes),
			_Utils_ap(
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Svg$Styled$path,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Svg$Styled$Attributes$d('M22,12c0-5.52-4.48-10-10-10S2,6.48,2,12c0,4.84,3.44,8.87,8,9.8V15H8v-3h2V9.5C10,7.57,11.57,6,13.5,6H16v3h-2 c-0.55,0-1,0.45-1,1v2h3v3h-3v6.95C18.05,21.45,22,17.19,22,12z')
							]),
						_List_Nil)
					]),
				children));
	});
var $author$project$Material$Styled$Icon$facebook = $author$project$Material$Styled$Icon$Facebook$view;
var $rtfeldman$elm_css$Html$Styled$Attributes$href = function (url) {
	return A2($rtfeldman$elm_css$Html$Styled$Attributes$stringProperty, 'href', url);
};
var $author$project$Material$Styled$Icon$Linkedin$view = F2(
	function (attributes, children) {
		return A2(
			$rtfeldman$elm_css$Svg$Styled$svg,
			_Utils_ap(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Svg$Styled$Attributes$fill('white'),
						$rtfeldman$elm_css$Svg$Styled$Attributes$width('30px'),
						$rtfeldman$elm_css$Svg$Styled$Attributes$height('30px'),
						$rtfeldman$elm_css$Svg$Styled$Attributes$viewBox('0 0 67 67')
					]),
				attributes),
			_Utils_ap(
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Svg$Styled$path,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Svg$Styled$Attributes$d('M49.837,48.137V36.425c0-6.275-3.35-9.195-7.816-9.195  c-3.604,0-5.219,1.983-6.119,3.374V27.71h-6.79c0.09,1.917,0,20.427,0,20.427h6.79V36.729c0-0.609,0.044-1.219,0.224-1.655  c0.49-1.22,1.607-2.483,3.482-2.483c2.458,0,3.44,1.873,3.44,4.618v10.929H49.837z M21.959,24.922c2.367,0,3.842-1.57,3.842-3.531  c-0.044-2.003-1.475-3.528-3.797-3.528s-3.841,1.524-3.841,3.528c0,1.961,1.474,3.531,3.753,3.531H21.959z M33,64  C16.432,64,3,50.568,3,34C3,17.431,16.432,4,33,4s30,13.431,30,30C63,50.568,49.568,64,33,64z M25.354,48.137V27.71h-6.789v20.427  H25.354z')
							]),
						_List_Nil)
					]),
				children));
	});
var $author$project$Material$Styled$Icon$linkedin = $author$project$Material$Styled$Icon$Linkedin$view;
var $author$project$Material$Styled$Color$greyBackgroundString = '#9d9898';
var $author$project$Material$Styled$Color$greyBackground = $rtfeldman$elm_css$Css$hex($author$project$Material$Styled$Color$greyBackgroundString);
var $rtfeldman$elm_css$Css$spaceAround = $rtfeldman$elm_css$Css$prop1('space-around');
var $rtfeldman$elm_css$Css$start = $rtfeldman$elm_css$Css$prop1('start');
var $author$project$View$Footer$styles = {
	container: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$absolute),
			$rtfeldman$elm_css$Css$bottom(
			$rtfeldman$elm_css$Css$px(0)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100)),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(60)),
			$rtfeldman$elm_css$Css$backgroundColor($author$project$Material$Styled$Color$greyBackground),
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(20)),
			A2(
			$rtfeldman$elm_css$Css$Media$withMediaQuery,
			_List_fromArray(
				['screen and (max-width: 500px)']),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$height(
					$rtfeldman$elm_css$Css$px(150))
				]))
		]),
	helpContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$row),
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceBetween),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(60)),
			A2(
			$rtfeldman$elm_css$Css$Media$withMediaQuery,
			_List_fromArray(
				['screen and (max-width: 500px)']),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$width(
					$rtfeldman$elm_css$Css$pct(80)),
					$rtfeldman$elm_css$Css$marginLeft(
					$rtfeldman$elm_css$Css$px(15))
				])),
			A2(
			$rtfeldman$elm_css$Css$Media$withMediaQuery,
			_List_fromArray(
				['screen and (max-width: 800px)']),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$width(
					$rtfeldman$elm_css$Css$pct(70))
				]))
		]),
	icon: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(35))
		]),
	iconContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center)
		]),
	iconHelpContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$row),
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceBetween),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(40)),
			A2(
			$rtfeldman$elm_css$Css$Media$withMediaQuery,
			_List_fromArray(
				['screen and (max-width: 500px)']),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$width(
					$rtfeldman$elm_css$Css$pct(70)),
					$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$start),
					$rtfeldman$elm_css$Css$marginTop(
					$rtfeldman$elm_css$Css$px(25))
				]))
		]),
	innerContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$row),
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceAround),
			$rtfeldman$elm_css$Css$flexWrap($rtfeldman$elm_css$Css$wrap),
			A2(
			$rtfeldman$elm_css$Css$padding2,
			$rtfeldman$elm_css$Css$px(0),
			$rtfeldman$elm_css$Css$px(20)),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(60)),
			A2(
			$rtfeldman$elm_css$Css$Media$withMediaQuery,
			_List_fromArray(
				['screen and (max-width: 500px)']),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$height(
					$rtfeldman$elm_css$Css$px(150))
				]))
		]),
	link: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$white),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(12))
		]),
	linkContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$textDecoration($rtfeldman$elm_css$Css$none)
		]),
	socialMediaContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$row),
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceAround),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(120)),
			A2(
			$rtfeldman$elm_css$Css$Media$withMediaQuery,
			_List_fromArray(
				['screen and (max-width: 500px)']),
			_List_fromArray(
				[
					A4(
					$rtfeldman$elm_css$Css$margin4,
					$rtfeldman$elm_css$Css$px(15),
					$rtfeldman$elm_css$Css$zero,
					$rtfeldman$elm_css$Css$px(25),
					$rtfeldman$elm_css$Css$px(0))
				]))
		])
};
var $rtfeldman$elm_css$Html$Styled$Attributes$target = $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty('target');
var $rtfeldman$elm_css$Svg$Styled$Attributes$fillRule = $rtfeldman$elm_css$VirtualDom$Styled$attribute('fill-rule');
var $rtfeldman$elm_css$Svg$Styled$Attributes$points = $rtfeldman$elm_css$VirtualDom$Styled$attribute('points');
var $rtfeldman$elm_css$Svg$Styled$polygon = $rtfeldman$elm_css$Svg$Styled$node('polygon');
var $author$project$Material$Styled$Icon$Youtube$view = F2(
	function (attributes, children) {
		return A2(
			$rtfeldman$elm_css$Svg$Styled$svg,
			_Utils_ap(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Svg$Styled$Attributes$fill('white'),
						$rtfeldman$elm_css$Svg$Styled$Attributes$width('30px'),
						$rtfeldman$elm_css$Svg$Styled$Attributes$height('30px'),
						$rtfeldman$elm_css$Svg$Styled$Attributes$viewBox('0 0 32 32')
					]),
				attributes),
			_Utils_ap(
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Svg$Styled$polygon,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Svg$Styled$Attributes$points('13.83,19.259 19.262,16 13.83,12.741')
							]),
						_List_Nil),
						A2(
						$rtfeldman$elm_css$Svg$Styled$path,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Svg$Styled$Attributes$fillRule('evenodd'),
								$rtfeldman$elm_css$Svg$Styled$Attributes$d('M16,0C7.164,0,0,7.163,0,16s7.164,16,16,16s16-7.164,16-16S24.836,0,16,0z M24.688,16.701c0,1.5-0.174,3-0.174,3     s-0.17,1.278-0.69,1.839c-0.661,0.738-1.401,0.742-1.741,0.786C19.651,22.512,16,22.518,16,22.518s-4.518-0.044-5.908-0.186     c-0.387-0.077-1.254-0.055-1.916-0.792c-0.521-0.562-0.69-1.839-0.69-1.839s-0.174-1.499-0.174-3v-1.406     c0-1.5,0.174-2.999,0.174-2.999s0.17-1.278,0.69-1.841C8.837,9.716,9.577,9.712,9.917,9.67c2.431-0.188,6.079-0.188,6.079-0.188     h0.008c0,0,3.648,0,6.079,0.188c0.339,0.042,1.08,0.046,1.741,0.784c0.521,0.563,0.69,1.841,0.69,1.841s0.174,1.5,0.174,3V16.701     z')
							]),
						_List_Nil)
					]),
				children));
	});
var $author$project$Material$Styled$Icon$youtube = $author$project$Material$Styled$Icon$Youtube$view;
var $author$project$View$Footer$view = A2(
	$rtfeldman$elm_css$Html$Styled$div,
	_List_fromArray(
		[
			$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Footer$styles.container)
		]),
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Footer$styles.innerContainer)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Footer$styles.iconHelpContainer)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Footer$styles.iconContainer)
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$a,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$href('https://www.sign.net'),
											$rtfeldman$elm_css$Html$Styled$Attributes$target('_blank')
										]),
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$img,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$src('/images/signnet-logo-white.png'),
													$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Footer$styles.icon)
												]),
											_List_Nil)
										]))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Footer$styles.helpContainer)
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$a,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$href('https://youtube.com/playlist?list=PLgmDAAGKQm1FhliYsLVZO4mXqq3W6Z6o9'),
											$rtfeldman$elm_css$Html$Styled$Attributes$target('_blank'),
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Footer$styles.linkContainer)
										]),
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$div,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Footer$styles.link)
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text('\'How To\' Videos')
												]))
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$a,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$href('https://signnet.tawk.help/'),
											$rtfeldman$elm_css$Html$Styled$Attributes$target('_blank'),
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Footer$styles.linkContainer)
										]),
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$div,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Footer$styles.link)
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text('Help')
												]))
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$a,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$href('mailto:help@sign.net'),
											$rtfeldman$elm_css$Html$Styled$Attributes$target('_blank'),
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Footer$styles.linkContainer)
										]),
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$div,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Footer$styles.link)
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text('Contact Us')
												]))
										]))
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Footer$styles.socialMediaContainer)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$a,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$href('https://www.facebook.com/signdotnet/'),
									$rtfeldman$elm_css$Html$Styled$Attributes$target('_blank')
								]),
							_List_fromArray(
								[
									A2($author$project$Material$Styled$Icon$facebook, _List_Nil, _List_Nil)
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$a,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$href('https://www.linkedin.com/company/signdotnet/'),
									$rtfeldman$elm_css$Html$Styled$Attributes$target('_blank')
								]),
							_List_fromArray(
								[
									A2($author$project$Material$Styled$Icon$linkedin, _List_Nil, _List_Nil)
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$a,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$href('https://www.youtube.com/channel/UCnJ076pE1Cd2kdneAtveKkQ'),
									$rtfeldman$elm_css$Html$Styled$Attributes$target('_blank')
								]),
							_List_fromArray(
								[
									A2($author$project$Material$Styled$Icon$youtube, _List_Nil, _List_Nil)
								]))
						]))
				]))
		]));
var $author$project$View$Header$styles = {
	container: function (backgroundColor) {
		return _List_fromArray(
			[
				$rtfeldman$elm_css$Css$displayFlex,
				$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceBetween),
				$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
				$rtfeldman$elm_css$Css$backgroundColor(
				$rtfeldman$elm_css$Css$hex(backgroundColor)),
				A2(
				$rtfeldman$elm_css$Css$padding2,
				$rtfeldman$elm_css$Css$px(8),
				$rtfeldman$elm_css$Css$px(20)),
				$rtfeldman$elm_css$Css$height(
				$rtfeldman$elm_css$Css$px(66)),
				$rtfeldman$elm_css$Css$width(
				$rtfeldman$elm_css$Css$pct(100)),
				$rtfeldman$elm_css$Css$boxSizing($rtfeldman$elm_css$Css$borderBox),
				A2($rtfeldman$elm_css$Css$property, 'box-shadow', '0px 2px 4px -1px rgba(0,0,0,0.2), 0px 4px 5px 0px rgba(0,0,0,0.14), 0px 1px 10px 0px rgba(0,0,0,0.12)')
			]);
	},
	links: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$grey200)
		]),
	login: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$grey200),
			$rtfeldman$elm_css$Css$textDecoration($rtfeldman$elm_css$Css$none)
		]),
	logo: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(135)),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(45))
		])
};
var $author$project$Types$OpenedMenu = {$: 'OpenedMenu'};
var $author$project$Material$Styled$Icon$Menu$view = F2(
	function (attributes, children) {
		return A2(
			$rtfeldman$elm_css$Svg$Styled$svg,
			_Utils_ap(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Svg$Styled$Attributes$fill('#FF0000'),
						$rtfeldman$elm_css$Svg$Styled$Attributes$width('18px'),
						$rtfeldman$elm_css$Svg$Styled$Attributes$height('18px'),
						$rtfeldman$elm_css$Svg$Styled$Attributes$viewBox('0 0 24 24'),
						A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'data-test', 'menu')
					]),
				attributes),
			_Utils_ap(
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Svg$Styled$path,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Svg$Styled$Attributes$d('M0 0h24v24H0z'),
								$rtfeldman$elm_css$Svg$Styled$Attributes$fill('none')
							]),
						_List_Nil),
						A2(
						$rtfeldman$elm_css$Svg$Styled$path,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Svg$Styled$Attributes$d('M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z')
							]),
						_List_Nil)
					]),
				children));
	});
var $author$project$Material$Styled$Icon$menu = $author$project$Material$Styled$Icon$Menu$view;
var $rtfeldman$elm_css$Css$block = {display: $rtfeldman$elm_css$Css$Structure$Compatible, value: 'block'};
var $author$project$Material$Styled$Color$blueA200 = $rtfeldman$elm_css$Css$hex($author$project$Material$Styled$Color$blueA200String);
var $author$project$Material$Styled$Color$blueGrey700String = '#455A64';
var $author$project$Material$Styled$Color$blueGrey700 = $rtfeldman$elm_css$Css$hex($author$project$Material$Styled$Color$blueGrey700String);
var $rtfeldman$elm_css$Css$Transitions$CubicBezier = F4(
	function (a, b, c, d) {
		return {$: 'CubicBezier', a: a, b: b, c: c, d: d};
	});
var $rtfeldman$elm_css$Css$Transitions$cubicBezier = F4(
	function (f1, f2, f3, f4) {
		return A4($rtfeldman$elm_css$Css$Transitions$CubicBezier, f1, f2, f3, f4);
	});
var $rtfeldman$elm_css$Css$display = $rtfeldman$elm_css$Css$prop1('display');
var $author$project$Material$Styled$Color$grey400String = '#BDBDBD';
var $author$project$Material$Styled$Color$grey400 = $rtfeldman$elm_css$Css$hex($author$project$Material$Styled$Color$grey400String);
var $author$project$Material$Styled$Color$grey600String = '#757575';
var $author$project$Material$Styled$Color$grey600 = $rtfeldman$elm_css$Css$hex($author$project$Material$Styled$Color$grey600String);
var $rtfeldman$elm_css$Css$normal = {featureTagValue: $rtfeldman$elm_css$Css$Structure$Compatible, fontStyle: $rtfeldman$elm_css$Css$Structure$Compatible, fontWeight: $rtfeldman$elm_css$Css$Structure$Compatible, overflowWrap: $rtfeldman$elm_css$Css$Structure$Compatible, value: 'normal', whiteSpace: $rtfeldman$elm_css$Css$Structure$Compatible};
var $rtfeldman$elm_css$Css$overflowX = $rtfeldman$elm_css$Css$prop1('overflow-x');
var $rtfeldman$elm_css$Css$overflowY = $rtfeldman$elm_css$Css$prop1('overflow-y');
var $rtfeldman$elm_css$Css$padding4 = $rtfeldman$elm_css$Css$prop4('padding');
var $rtfeldman$elm_css$Css$scroll = {backgroundAttachment: $rtfeldman$elm_css$Css$Structure$Compatible, blockAxisOverflow: $rtfeldman$elm_css$Css$Structure$Compatible, inlineAxisOverflow: $rtfeldman$elm_css$Css$Structure$Compatible, overflow: $rtfeldman$elm_css$Css$Structure$Compatible, scroll: $rtfeldman$elm_css$Css$Structure$Compatible, value: 'scroll'};
var $rtfeldman$elm_css$Css$Transitions$transform3 = $rtfeldman$elm_css$Css$Transitions$fullTransition($rtfeldman$elm_css$Css$Transitions$Transform);
var $author$project$View$Menu$styles = {
	avatar: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$marginRight(
			$rtfeldman$elm_css$Css$px(16)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(40)),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(40)),
			$rtfeldman$elm_css$Css$borderRadius(
			$rtfeldman$elm_css$Css$pct(50)),
			$rtfeldman$elm_css$Css$backgroundColor($author$project$Material$Styled$Color$grey400),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$grey50),
			$rtfeldman$elm_css$Css$textDecoration($rtfeldman$elm_css$Css$none),
			$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(20)),
			$rtfeldman$elm_css$Css$fontWeight(
			$rtfeldman$elm_css$Css$int(100))
		]),
	backdrop: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$fixed),
			$rtfeldman$elm_css$Css$top($rtfeldman$elm_css$Css$zero),
			$rtfeldman$elm_css$Css$left($rtfeldman$elm_css$Css$zero),
			$rtfeldman$elm_css$Css$zIndex(
			$rtfeldman$elm_css$Css$int($author$project$View$Theme$zIndex.menu)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100)),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$vh(100)),
			$rtfeldman$elm_css$Css$backgroundColor(
			A4($rtfeldman$elm_css$Css$rgba, 0, 0, 0, 0.5))
		]),
	backdropHidden: _List_Nil,
	currentDomain: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(14)),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$white),
			$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer),
			$rtfeldman$elm_css$Css$textDecoration($rtfeldman$elm_css$Css$none),
			$rtfeldman$elm_css$Css$fontWeight(
			$rtfeldman$elm_css$Css$int(500)),
			$rtfeldman$elm_css$Css$padding(
			$rtfeldman$elm_css$Css$px(12)),
			$rtfeldman$elm_css$Css$borderRadius(
			$rtfeldman$elm_css$Css$px(24)),
			$rtfeldman$elm_css$Css$hover(
			_List_fromArray(
				[
					A2($rtfeldman$elm_css$Css$property, 'background', 'rgba(128, 128, 128)'),
					A2($rtfeldman$elm_css$Css$property, 'background', 'rgba(128, 128, 128, 0.2)')
				]))
		]),
	currentSingleDomain: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(14)),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$white),
			$rtfeldman$elm_css$Css$fontWeight(
			$rtfeldman$elm_css$Css$int(500))
		]),
	domainContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(12)),
			$rtfeldman$elm_css$Css$fontWeight(
			$rtfeldman$elm_css$Css$int(400)),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$blueGrey500)
		]),
	domainName: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(12)),
			$rtfeldman$elm_css$Css$fontWeight($rtfeldman$elm_css$Css$normal),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$grey600)
		]),
	header: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(70)),
			$rtfeldman$elm_css$Css$padding(
			$rtfeldman$elm_css$Css$px(16)),
			$rtfeldman$elm_css$Css$boxSizing($rtfeldman$elm_css$Css$borderBox),
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center)
		]),
	headerName: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(16)),
			$rtfeldman$elm_css$Css$fontWeight(
			$rtfeldman$elm_css$Css$int(500))
		]),
	help: _List_fromArray(
		[
			A4(
			$rtfeldman$elm_css$Css$padding4,
			$rtfeldman$elm_css$Css$px(32),
			$rtfeldman$elm_css$Css$zero,
			$rtfeldman$elm_css$Css$px(16),
			$rtfeldman$elm_css$Css$px(24)),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$grey600),
			$rtfeldman$elm_css$Css$fontWeight(
			$rtfeldman$elm_css$Css$int(500)),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(14))
		]),
	icon: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$boxShadow($rtfeldman$elm_css$Css$none),
			$rtfeldman$elm_css$Css$transform(
			A2(
				$rtfeldman$elm_css$Css$translate2,
				$rtfeldman$elm_css$Css$px(20),
				$rtfeldman$elm_css$Css$px(-15))),
			$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer),
			$rtfeldman$elm_css$Css$padding(
			$rtfeldman$elm_css$Css$px(10))
		]),
	item: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$block),
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$padding(
			$rtfeldman$elm_css$Css$px(16)),
			$rtfeldman$elm_css$Css$textDecoration($rtfeldman$elm_css$Css$none),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(14)),
			$rtfeldman$elm_css$Css$fontWeight(
			$rtfeldman$elm_css$Css$int(500)),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$blueGrey900),
			$rtfeldman$elm_css$Css$hover(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$backgroundColor($author$project$Material$Styled$Color$grey100)
				]))
		]),
	itemIcon: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginRight(
			$rtfeldman$elm_css$Css$px(10))
		]),
	langHeader: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(70)),
			$rtfeldman$elm_css$Css$padding(
			$rtfeldman$elm_css$Css$px(16)),
			$rtfeldman$elm_css$Css$boxSizing($rtfeldman$elm_css$Css$borderBox),
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			A3(
			$rtfeldman$elm_css$Css$borderBottom3,
			$rtfeldman$elm_css$Css$px(1),
			$rtfeldman$elm_css$Css$solid,
			$author$project$Material$Styled$Color$grey200),
			$rtfeldman$elm_css$Css$hover(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$backgroundColor($author$project$Material$Styled$Color$grey100)
				])),
			$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer)
		]),
	langHeaderTop: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(50)),
			$rtfeldman$elm_css$Css$paddingLeft(
			$rtfeldman$elm_css$Css$px(16)),
			$rtfeldman$elm_css$Css$boxSizing($rtfeldman$elm_css$Css$borderBox),
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			A3(
			$rtfeldman$elm_css$Css$borderBottom3,
			$rtfeldman$elm_css$Css$px(1),
			$rtfeldman$elm_css$Css$solid,
			$author$project$Material$Styled$Color$grey200),
			$rtfeldman$elm_css$Css$hover(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$backgroundColor($author$project$Material$Styled$Color$grey100)
				])),
			$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer)
		]),
	langItem: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$block),
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$padding(
			$rtfeldman$elm_css$Css$px(16)),
			$rtfeldman$elm_css$Css$textDecoration($rtfeldman$elm_css$Css$none),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(14)),
			$rtfeldman$elm_css$Css$fontWeight(
			$rtfeldman$elm_css$Css$int(500)),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$blueGrey900),
			$rtfeldman$elm_css$Css$hover(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$backgroundColor($author$project$Material$Styled$Color$grey100)
				])),
			$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer)
		]),
	logout: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$absolute),
			$rtfeldman$elm_css$Css$bottom($rtfeldman$elm_css$Css$zero),
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100)),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(50)),
			$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$blueGrey900),
			$rtfeldman$elm_css$Css$textDecoration($rtfeldman$elm_css$Css$none),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(14)),
			$rtfeldman$elm_css$Css$fontWeight(
			$rtfeldman$elm_css$Css$int(500)),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$blueGrey900),
			$rtfeldman$elm_css$Css$backgroundColor($author$project$Material$Styled$Color$grey200),
			$rtfeldman$elm_css$Css$hover(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$backgroundColor($author$project$Material$Styled$Color$grey300)
				])),
			A2(
			$rtfeldman$elm_css$Css$Media$withMediaQuery,
			_List_fromArray(
				['screen and (max-height: 850px)']),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$relative)
				]))
		]),
	menu: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$fixed),
			$rtfeldman$elm_css$Css$top($rtfeldman$elm_css$Css$zero),
			$rtfeldman$elm_css$Css$left(
			$rtfeldman$elm_css$Css$pct(100)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(300)),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$vh(100)),
			$rtfeldman$elm_css$Css$overflowY($rtfeldman$elm_css$Css$scroll),
			$rtfeldman$elm_css$Css$backgroundColor($author$project$Material$Styled$Color$white),
			$rtfeldman$elm_css$Css$Transitions$transition(
			_List_fromArray(
				[
					A3(
					$rtfeldman$elm_css$Css$Transitions$transform3,
					300,
					0,
					A4($rtfeldman$elm_css$Css$Transitions$cubicBezier, 0.17, 0.04, 0.03, 0.94))
				]))
		]),
	menuBar: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$row),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$overflowX($rtfeldman$elm_css$Css$hidden)
		]),
	modalContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$vw(80)),
			$rtfeldman$elm_css$Css$maxWidth(
			$rtfeldman$elm_css$Css$px(300)),
			$rtfeldman$elm_css$Css$padding(
			$rtfeldman$elm_css$Css$px(20))
		]),
	modalHeader: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$row),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$flexStart),
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceBetween)
		]),
	modalHeaderTxt: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(20)),
			$rtfeldman$elm_css$Css$fontWeight(
			$rtfeldman$elm_css$Css$int(500))
		]),
	openButton: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$padding($rtfeldman$elm_css$Css$zero),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(50)),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(50)),
			$rtfeldman$elm_css$Css$boxShadow($rtfeldman$elm_css$Css$none),
			$rtfeldman$elm_css$Css$borderRadius(
			$rtfeldman$elm_css$Css$px(25)),
			$rtfeldman$elm_css$Css$hover(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$boxShadow($rtfeldman$elm_css$Css$none),
					A2($rtfeldman$elm_css$Css$property, 'background', 'rgba(128, 128, 128)'),
					A2($rtfeldman$elm_css$Css$property, 'background', 'rgba(128, 128, 128, 0.2)')
				]))
		]),
	selectableDomainItem: _List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Css$padding2,
			$rtfeldman$elm_css$Css$px(10),
			$rtfeldman$elm_css$Css$zero),
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(5)),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(20)),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$blueA200),
			$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer),
			$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$backgroundColor($author$project$Material$Styled$Color$grey100),
			$rtfeldman$elm_css$Css$hover(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$backgroundColor($author$project$Material$Styled$Color$blueA200),
					$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$grey100)
				]))
		]),
	selectedDomainItem: _List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Css$padding2,
			$rtfeldman$elm_css$Css$px(10),
			$rtfeldman$elm_css$Css$zero),
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(5)),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(20)),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$blueGrey700),
			$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$backgroundColor($author$project$Material$Styled$Color$grey300)
		]),
	userName: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$textDecoration($rtfeldman$elm_css$Css$none),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$blueGrey900)
		])
};
var $author$project$Material$Styled$Button$ButtonTheme = function (a) {
	return {$: 'ButtonTheme', a: a};
};
var $author$project$Material$Styled$Button$theme = function (theme_) {
	return $author$project$Material$Styled$Button$ButtonTheme(theme_);
};
var $author$project$View$Menu$openButton = A2(
	$author$project$Material$Styled$Button$button,
	_List_fromArray(
		[
			$author$project$Material$Styled$Button$onClick(
			$author$project$Types$OnAuth(
				$author$project$Types$OnMenu($author$project$Types$OpenedMenu))),
			$author$project$Material$Styled$Button$theme(
			{base: 'transparent', ripple: 'transparent', text: $author$project$Material$Styled$Color$whiteString}),
			$author$project$Material$Styled$Button$styles($author$project$View$Menu$styles.openButton)
		]),
	_List_fromArray(
		[
			A2(
			$author$project$Material$Styled$Icon$menu,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Svg$Styled$Attributes$fill($author$project$Material$Styled$Color$whiteString),
					$rtfeldman$elm_css$Svg$Styled$Attributes$width('24'),
					$rtfeldman$elm_css$Svg$Styled$Attributes$height('24'),
					$rtfeldman$elm_css$Svg$Styled$Attributes$viewBox('0 0 24 24')
				]),
			_List_Nil)
		]));
var $author$project$Types$ShowDomainModal = {$: 'ShowDomainModal'};
var $author$project$View$Menu$selectDomainLink = F2(
	function (selectedDomain, domains) {
		return ($elm$core$List$length(domains) <= 1) ? A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Menu$styles.currentSingleDomain)
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text(
					$elm$core$String$toUpper(
						$author$project$Data$Domain$toString(selectedDomain)))
				])) : A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Menu$styles.currentDomain),
					$rtfeldman$elm_css$Html$Styled$Events$onClick(
					$author$project$Types$OnAuth(
						$author$project$Types$OnMenu($author$project$Types$ShowDomainModal)))
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text(
					$elm$core$String$toUpper(
						$author$project$Data$Domain$toString(selectedDomain)))
				]));
	});
var $author$project$Material$Styled$Modal$ContentContainerStyle = function (a) {
	return {$: 'ContentContainerStyle', a: a};
};
var $author$project$Material$Styled$Modal$contentContainerstyles = function (styles_) {
	return $author$project$Material$Styled$Modal$ContentContainerStyle(styles_);
};
var $author$project$Types$SelectDomain = function (a) {
	return {$: 'SelectDomain', a: a};
};
var $author$project$View$Menu$domainItem = F2(
	function (selectedDomain, domain) {
		return A2($author$project$Data$Domain$equal, selectedDomain, domain) ? A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Menu$styles.selectedDomainItem)
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text(
					$author$project$Data$Domain$toString(domain))
				])) : A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Menu$styles.selectableDomainItem),
					$rtfeldman$elm_css$Html$Styled$Events$onClick(
					$author$project$Types$OnAuth(
						$author$project$Types$OnMenu(
							$author$project$Types$SelectDomain(domain))))
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text(
					$author$project$Data$Domain$toString(domain))
				]));
	});
var $author$project$View$Menu$selectDomainModal = F3(
	function (menuStatus, selectedDomain, domains) {
		return _Utils_eq(menuStatus, $author$project$Types$ShowDomainModal) ? A2(
			$author$project$Material$Styled$Modal$modal,
			_List_fromArray(
				[
					$author$project$Material$Styled$Modal$open(true),
					$author$project$Material$Styled$Modal$contentContainerstyles($author$project$View$Menu$styles.modalContainer),
					$author$project$Material$Styled$Modal$onClose(
					$author$project$Types$OnAuth(
						$author$project$Types$OnMenu($author$project$Types$ClosedMenu)))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Menu$styles.modalHeader)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Menu$styles.modalHeaderTxt)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Select Organisation')
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$img,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Menu$styles.icon),
									$rtfeldman$elm_css$Html$Styled$Attributes$src($author$project$View$Theme$images.close),
									$rtfeldman$elm_css$Html$Styled$Events$onClick(
									$author$project$Types$OnAuth(
										$author$project$Types$OnMenu($author$project$Types$ClosedMenu)))
								]),
							_List_Nil)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_Nil,
					A2(
						$elm$core$List$map,
						$author$project$View$Menu$domainItem(selectedDomain),
						domains))
				])) : $rtfeldman$elm_css$Html$Styled$text('');
	});
var $author$project$View$Menu$selectLanguageModal = function (languageChangeModel) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Menu$styles.currentDomain),
				$rtfeldman$elm_css$Html$Styled$Events$onClick(
				$author$project$Types$OnAuth(
					$author$project$Types$OnLanguageChange(
						$author$project$Type$LanguageChange$OnLanguageMenuItemClick(true))))
			]),
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$text(
				$elm$core$String$toUpper(
					$author$project$View$Menu$convertLanguageToString(languageChangeModel.selectedLanguage)))
			]));
};
var $author$project$Type$LanguageChange$OnLanguageSelect = function (a) {
	return {$: 'OnLanguageSelect', a: a};
};
var $author$project$View$Menu$languageItem = function (language) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Menu$styles.selectableDomainItem),
				$rtfeldman$elm_css$Html$Styled$Events$onClick(
				$author$project$Types$OnAuth(
					$author$project$Types$OnLanguageChange(
						$author$project$Type$LanguageChange$OnLanguageSelect(language))))
			]),
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$text(
				$author$project$View$Menu$convertLanguageToString(language))
			]));
};
var $author$project$View$Menu$showLanguageModal = function (languageChangeModel) {
	return A2(
		$author$project$Material$Styled$Modal$modal,
		_List_fromArray(
			[
				$author$project$Material$Styled$Modal$open(languageChangeModel.onLanguageSelectMenu),
				$author$project$Material$Styled$Modal$contentContainerstyles($author$project$View$Menu$styles.modalContainer),
				$author$project$Material$Styled$Modal$onClose(
				$author$project$Types$OnAuth(
					$author$project$Types$OnLanguageChange(
						$author$project$Type$LanguageChange$OnLanguageMenuItemClick(false))))
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Menu$styles.modalHeader)
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Menu$styles.modalHeaderTxt)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('Select Language')
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$img,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Menu$styles.icon),
								$rtfeldman$elm_css$Html$Styled$Attributes$src($author$project$View$Theme$images.close),
								$rtfeldman$elm_css$Html$Styled$Events$onClick(
								$author$project$Types$OnAuth(
									$author$project$Types$OnLanguageChange(
										$author$project$Type$LanguageChange$OnLanguageMenuItemClick(false))))
							]),
						_List_Nil)
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_Nil,
				A2($elm$core$List$map, $author$project$View$Menu$languageItem, languageChangeModel.listOfLanguages))
			]));
};
var $author$project$Type$Logout$Logout = {$: 'Logout'};
var $author$project$Material$Styled$Icon$AccountBalanceWallet$view = F2(
	function (attributes, children) {
		return A2(
			$rtfeldman$elm_css$Svg$Styled$svg,
			_Utils_ap(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Svg$Styled$Attributes$fill('black'),
						$rtfeldman$elm_css$Svg$Styled$Attributes$width('24px'),
						$rtfeldman$elm_css$Svg$Styled$Attributes$height('24px'),
						$rtfeldman$elm_css$Svg$Styled$Attributes$viewBox('0 0 24 24')
					]),
				attributes),
			_Utils_ap(
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Svg$Styled$path,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Svg$Styled$Attributes$d('M0 0h24v24H0z'),
								$rtfeldman$elm_css$Svg$Styled$Attributes$fill('none')
							]),
						_List_Nil),
						A2(
						$rtfeldman$elm_css$Svg$Styled$path,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Svg$Styled$Attributes$d('M21 18v1c0 1.1-.9 2-2 2H5c-1.11 0-2-.9-2-2V5c0-1.1.89-2 2-2h14c1.1 0 2 .9 2 2v1h-9c-1.11 0-2 .9-2 2v8c0 1.1.89 2 2 2h9zm-9-2h10V8H12v8zm4-2.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z')
							]),
						_List_Nil)
					]),
				children));
	});
var $author$project$Material$Styled$Icon$accountBalanceWallet = $author$project$Material$Styled$Icon$AccountBalanceWallet$view;
var $author$project$Material$Styled$Icon$AccountCircle$view = F2(
	function (attributes, children) {
		return A2(
			$rtfeldman$elm_css$Svg$Styled$svg,
			_Utils_ap(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Svg$Styled$Attributes$fill('black'),
						$rtfeldman$elm_css$Svg$Styled$Attributes$width('24px'),
						$rtfeldman$elm_css$Svg$Styled$Attributes$height('24px'),
						$rtfeldman$elm_css$Svg$Styled$Attributes$viewBox('0 0 24 24')
					]),
				attributes),
			_Utils_ap(
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Svg$Styled$path,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Svg$Styled$Attributes$d('M0 0h24v24H0z'),
								$rtfeldman$elm_css$Svg$Styled$Attributes$fill('none')
							]),
						_List_Nil),
						A2(
						$rtfeldman$elm_css$Svg$Styled$path,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Svg$Styled$Attributes$d('M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 3c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm0 14.2c-2.5 0-4.71-1.28-6-3.22.03-1.99 4-3.08 6-3.08 1.99 0 5.97 1.09 6 3.08-1.29 1.94-3.5 3.22-6 3.22z')
							]),
						_List_Nil)
					]),
				children));
	});
var $author$project$Material$Styled$Icon$accountCircle = $author$project$Material$Styled$Icon$AccountCircle$view;
var $author$project$Material$Styled$Icon$Business$view = F2(
	function (attributes, children) {
		return A2(
			$rtfeldman$elm_css$Svg$Styled$svg,
			_Utils_ap(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Svg$Styled$Attributes$fill('black'),
						$rtfeldman$elm_css$Svg$Styled$Attributes$width('24px'),
						$rtfeldman$elm_css$Svg$Styled$Attributes$height('24px'),
						$rtfeldman$elm_css$Svg$Styled$Attributes$viewBox('0 0 24 24')
					]),
				attributes),
			_Utils_ap(
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Svg$Styled$path,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Svg$Styled$Attributes$d('M0 0h24v24H0z'),
								$rtfeldman$elm_css$Svg$Styled$Attributes$fill('none')
							]),
						_List_Nil),
						A2(
						$rtfeldman$elm_css$Svg$Styled$path,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Svg$Styled$Attributes$d('M12 7V3H2v18h20V7H12zM6 19H4v-2h2v2zm0-4H4v-2h2v2zm0-4H4V9h2v2zm0-4H4V5h2v2zm4 12H8v-2h2v2zm0-4H8v-2h2v2zm0-4H8V9h2v2zm0-4H8V5h2v2zm10 12h-8v-2h2v-2h-2v-2h2v-2h-2V9h8v10zm-2-8h-2v2h2v-2zm0 4h-2v2h2v-2z')
							]),
						_List_Nil)
					]),
				children));
	});
var $author$project$Material$Styled$Icon$business = $author$project$Material$Styled$Icon$Business$view;
var $rtfeldman$elm_css$Html$Styled$Attributes$class = $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty('className');
var $author$project$Material$Styled$Icon$Code$view = F2(
	function (attributes, children) {
		return A2(
			$rtfeldman$elm_css$Svg$Styled$svg,
			_Utils_ap(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Svg$Styled$Attributes$fill('black'),
						$rtfeldman$elm_css$Svg$Styled$Attributes$width('24px'),
						$rtfeldman$elm_css$Svg$Styled$Attributes$height('24px'),
						$rtfeldman$elm_css$Svg$Styled$Attributes$viewBox('0 0 24 24')
					]),
				attributes),
			_Utils_ap(
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Svg$Styled$path,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Svg$Styled$Attributes$d('M0 0h24v24H0V0z'),
								$rtfeldman$elm_css$Svg$Styled$Attributes$fill('none')
							]),
						_List_Nil),
						A2(
						$rtfeldman$elm_css$Svg$Styled$path,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Svg$Styled$Attributes$d('M9.4 16.6L4.8 12l4.6-4.6L8 6l-6 6 6 6 1.4-1.4zm5.2 0l4.6-4.6-4.6-4.6L16 6l6 6-6 6-1.4-1.4z')
							]),
						_List_Nil)
					]),
				children));
	});
var $author$project$Material$Styled$Icon$code = $author$project$Material$Styled$Icon$Code$view;
var $author$project$Material$Styled$Icon$ContactMail$view = F2(
	function (attributes, children) {
		return A2(
			$rtfeldman$elm_css$Svg$Styled$svg,
			_Utils_ap(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Svg$Styled$Attributes$fill('black'),
						$rtfeldman$elm_css$Svg$Styled$Attributes$width('24px'),
						$rtfeldman$elm_css$Svg$Styled$Attributes$height('24px'),
						$rtfeldman$elm_css$Svg$Styled$Attributes$viewBox('0 0 24 24')
					]),
				attributes),
			_Utils_ap(
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Svg$Styled$path,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Svg$Styled$Attributes$d('M0 0h24v24H0z'),
								$rtfeldman$elm_css$Svg$Styled$Attributes$fill('none')
							]),
						_List_Nil),
						A2(
						$rtfeldman$elm_css$Svg$Styled$path,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Svg$Styled$Attributes$d('M22 3H2C.9 3 0 3.9 0 5v14c0 1.1.9 2 2 2h20c1.1 0 1.99-.9 1.99-2L24 5c0-1.1-.9-2-2-2zm0 16H2V5h20v14zM21 6h-7v5h7V6zm-1 2l-2.5 1.75L15 8V7l2.5 1.75L20 7v1zM9 12c1.65 0 3-1.35 3-3s-1.35-3-3-3-3 1.35-3 3 1.35 3 3 3zm0-4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm6 8.59c0-2.5-3.97-3.58-6-3.58s-6 1.08-6 3.58V18h12v-1.41zM5.48 16c.74-.5 2.22-1 3.52-1s2.77.49 3.52 1H5.48z')
							]),
						_List_Nil)
					]),
				children));
	});
var $author$project$Material$Styled$Icon$contactMail = $author$project$Material$Styled$Icon$ContactMail$view;
var $author$project$View$Menu$cssClass = function (menuStatus) {
	switch (menuStatus.$) {
		case 'OpenedMenu':
			return 'menu-opened';
		case 'ClosedMenu':
			return 'menu-closed';
		case 'ShowDomainModal':
			return 'menu-closed';
		default:
			return 'menu-closed';
	}
};
var $author$project$Material$Styled$Icon$ExitToApp$view = F2(
	function (attributes, children) {
		return A2(
			$rtfeldman$elm_css$Svg$Styled$svg,
			_Utils_ap(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Svg$Styled$Attributes$fill('black'),
						$rtfeldman$elm_css$Svg$Styled$Attributes$width('24px'),
						$rtfeldman$elm_css$Svg$Styled$Attributes$height('24px'),
						$rtfeldman$elm_css$Svg$Styled$Attributes$viewBox('0 0 24 24')
					]),
				attributes),
			_Utils_ap(
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Svg$Styled$path,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Svg$Styled$Attributes$d('M0 0h24v24H0V0z'),
								$rtfeldman$elm_css$Svg$Styled$Attributes$fill('none')
							]),
						_List_Nil),
						A2(
						$rtfeldman$elm_css$Svg$Styled$path,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Svg$Styled$Attributes$d('M10.09 15.59L11.5 17l5-5-5-5-1.41 1.41L12.67 11H3v2h9.67l-2.58 2.59zM19 3H5c-1.11 0-2 .9-2 2v4h2V5h14v14H5v-4H3v4c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z')
							]),
						_List_Nil)
					]),
				children));
	});
var $author$project$Material$Styled$Icon$exitToApp = $author$project$Material$Styled$Icon$ExitToApp$view;
var $author$project$Material$Styled$Icon$Folder$view = F2(
	function (attributes, children) {
		return A2(
			$rtfeldman$elm_css$Svg$Styled$svg,
			_Utils_ap(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Svg$Styled$Attributes$fill('black'),
						$rtfeldman$elm_css$Svg$Styled$Attributes$width('24px'),
						$rtfeldman$elm_css$Svg$Styled$Attributes$height('24px'),
						$rtfeldman$elm_css$Svg$Styled$Attributes$viewBox('0 0 24 24')
					]),
				attributes),
			_Utils_ap(
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Svg$Styled$path,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Svg$Styled$Attributes$d('M0 0h24v24H0V0z'),
								$rtfeldman$elm_css$Svg$Styled$Attributes$fill('none')
							]),
						_List_Nil),
						A2(
						$rtfeldman$elm_css$Svg$Styled$path,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Svg$Styled$Attributes$d('M9.17 6l2 2H20v10H4V6h5.17M10 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2h-8l-2-2z')
							]),
						_List_Nil)
					]),
				children));
	});
var $author$project$Material$Styled$Icon$folder = $author$project$Material$Styled$Icon$Folder$view;
var $author$project$View$Menu$avatar = function (user) {
	var _v0 = user.avatarUrl;
	if (_v0.$ === 'Nothing') {
		return A2(
			$rtfeldman$elm_css$Html$Styled$a,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Menu$styles.avatar),
					$rtfeldman$elm_css$Html$Styled$Attributes$href($author$project$Data$Route$routeUrl.setting)
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text(
					$elm$core$String$toUpper(
						_Utils_ap(
							A2($elm$core$String$left, 1, user.firstName),
							A2($elm$core$String$left, 1, user.lastName))))
				]));
	} else {
		var url = _v0.a;
		return A2(
			$rtfeldman$elm_css$Html$Styled$a,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$href($author$project$Data$Route$routeUrl.setting)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$img,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Menu$styles.avatar),
							$rtfeldman$elm_css$Html$Styled$Attributes$src(url)
						]),
					_List_Nil)
				]));
	}
};
var $author$project$View$Menu$userName = function (user) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$a,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Menu$styles.userName),
				$rtfeldman$elm_css$Html$Styled$Attributes$href($author$project$Data$Route$routeUrl.setting)
			]),
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$text(user.firstName + (' ' + user.lastName))
			]));
};
var $author$project$View$Menu$header = function (user) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Menu$styles.header)
					]),
				_List_fromArray(
					[
						$author$project$View$Menu$avatar(user),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Menu$styles.headerName)
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_Nil,
								_List_fromArray(
									[
										$author$project$View$Menu$userName(user)
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Menu$styles.domainName)
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$Data$Domain$toString(
											$author$project$Data$Domain$selected(user.domains)))
									]))
							]))
					]))
			]));
};
var $author$project$Material$Styled$Icon$Home$view = F2(
	function (attributes, children) {
		return A2(
			$rtfeldman$elm_css$Svg$Styled$svg,
			_Utils_ap(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Svg$Styled$Attributes$fill('black'),
						$rtfeldman$elm_css$Svg$Styled$Attributes$width('24px'),
						$rtfeldman$elm_css$Svg$Styled$Attributes$height('24px'),
						$rtfeldman$elm_css$Svg$Styled$Attributes$viewBox('0 0 24 24')
					]),
				attributes),
			_Utils_ap(
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Svg$Styled$path,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Svg$Styled$Attributes$d('M0 0h24v24H0V0z'),
								$rtfeldman$elm_css$Svg$Styled$Attributes$fill('none')
							]),
						_List_Nil),
						A2(
						$rtfeldman$elm_css$Svg$Styled$path,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Svg$Styled$Attributes$d('M12 5.69l5 4.5V18h-2v-6H9v6H7v-7.81l5-4.5M12 3L2 12h3v8h6v-6h2v6h6v-8h3L12 3z')
							]),
						_List_Nil)
					]),
				children));
	});
var $author$project$Material$Styled$Icon$home = $author$project$Material$Styled$Icon$Home$view;
var $author$project$Material$Styled$Icon$ImportContacts$view = F2(
	function (attributes, children) {
		return A2(
			$rtfeldman$elm_css$Svg$Styled$svg,
			_Utils_ap(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Svg$Styled$Attributes$fill('black'),
						$rtfeldman$elm_css$Svg$Styled$Attributes$width('24px'),
						$rtfeldman$elm_css$Svg$Styled$Attributes$height('24px'),
						$rtfeldman$elm_css$Svg$Styled$Attributes$viewBox('0 0 24 24')
					]),
				attributes),
			A2(
				$elm$core$List$cons,
				A2(
					$rtfeldman$elm_css$Svg$Styled$path,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Svg$Styled$Attributes$d('M17.5,4.5c-1.95,0-4.05,0.4-5.5,1.5c-1.45-1.1-3.55-1.5-5.5-1.5S2.45,4.9,1,6v14.65c0,0.65,0.73,0.45,0.75,0.45 C3.1,20.45,5.05,20,6.5,20c1.95,0,4.05,0.4,5.5,1.5c1.35-0.85,3.8-1.5,5.5-1.5c1.65,0,3.35,0.3,4.75,1.05 C22.66,21.26,23,20.86,23,20.6V6C21.51,4.88,19.37,4.5,17.5,4.5z M21,18.5c-1.1-0.35-2.3-0.5-3.5-0.5c-1.7,0-4.15,0.65-5.5,1.5V8 c1.35-0.85,3.8-1.5,5.5-1.5c1.2,0,2.4,0.15,3.5,0.5V18.5z')
						]),
					_List_Nil),
				children));
	});
var $author$project$Material$Styled$Icon$importContacts = $author$project$Material$Styled$Icon$ImportContacts$view;
var $author$project$View$Menu$item = F3(
	function (icon, url, label) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$a,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Menu$styles.item),
					$rtfeldman$elm_css$Html$Styled$Attributes$href(url)
				]),
			_List_fromArray(
				[
					A2(
					icon,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Svg$Styled$Attributes$fill($author$project$Material$Styled$Color$blueGrey900String),
							$rtfeldman$elm_css$Svg$Styled$Attributes$width('24'),
							$rtfeldman$elm_css$Svg$Styled$Attributes$height('24'),
							$rtfeldman$elm_css$Svg$Styled$Attributes$viewBox('0 0 24 24'),
							$rtfeldman$elm_css$Svg$Styled$Attributes$css($author$project$View$Menu$styles.itemIcon)
						]),
					_List_Nil),
					$rtfeldman$elm_css$Html$Styled$text(label)
				]));
	});
var $author$project$Material$Styled$Icon$LiveHelp$view = F2(
	function (attributes, children) {
		return A2(
			$rtfeldman$elm_css$Svg$Styled$svg,
			_Utils_ap(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Svg$Styled$Attributes$fill('black'),
						$rtfeldman$elm_css$Svg$Styled$Attributes$width('24px'),
						$rtfeldman$elm_css$Svg$Styled$Attributes$height('24px'),
						$rtfeldman$elm_css$Svg$Styled$Attributes$viewBox('0 0 24 24')
					]),
				attributes),
			_Utils_ap(
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Svg$Styled$path,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Svg$Styled$Attributes$d('M0 0h24v24H0V0z'),
								$rtfeldman$elm_css$Svg$Styled$Attributes$fill('none')
							]),
						_List_Nil),
						A2(
						$rtfeldman$elm_css$Svg$Styled$path,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Svg$Styled$Attributes$d('M19 2H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h4l3 3 3-3h4c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 16h-4.83l-.59.59L12 20.17l-1.59-1.59-.58-.58H5V4h14v14zm-8-3h2v2h-2zm1-8c1.1 0 2 .9 2 2 0 2-3 1.75-3 5h2c0-2.25 3-2.5 3-5 0-2.21-1.79-4-4-4S8 6.79 8 9h2c0-1.1.9-2 2-2z')
							]),
						_List_Nil)
					]),
				children));
	});
var $author$project$Material$Styled$Icon$liveHelp = $author$project$Material$Styled$Icon$LiveHelp$view;
var $rtfeldman$elm_css$Css$Structure$ClassSelector = function (a) {
	return {$: 'ClassSelector', a: a};
};
var $rtfeldman$elm_css$Css$Global$class = F2(
	function (str, styles) {
		return A2(
			$rtfeldman$elm_css$VirtualDom$Styled$makeSnippet,
			styles,
			$rtfeldman$elm_css$Css$Structure$UniversalSelectorSequence(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$Structure$ClassSelector(str)
					])));
	});
var $rtfeldman$elm_css$Css$translateX = function (_v0) {
	var value = _v0.value;
	return {
		transform: $rtfeldman$elm_css$Css$Structure$Compatible,
		value: A2(
			$rtfeldman$elm_css$Css$cssFunction,
			'translateX',
			_List_fromArray(
				[value]))
	};
};
var $author$project$View$Menu$menuGlobalCss = $rtfeldman$elm_css$Css$Global$global(
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Css$Global$class,
			'menu-closed',
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$transform($rtfeldman$elm_css$Css$none)
				])),
			A2(
			$rtfeldman$elm_css$Css$Global$class,
			'menu-opened',
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$transform(
					$rtfeldman$elm_css$Css$translateX(
						$rtfeldman$elm_css$Css$pct(-100)))
				]))
		]));
var $author$project$Material$Styled$Icon$Task$view = F2(
	function (attributes, children) {
		return A2(
			$rtfeldman$elm_css$Svg$Styled$svg,
			_Utils_ap(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Svg$Styled$Attributes$fill('white'),
						$rtfeldman$elm_css$Svg$Styled$Attributes$width('30px'),
						$rtfeldman$elm_css$Svg$Styled$Attributes$height('30px'),
						$rtfeldman$elm_css$Svg$Styled$Attributes$viewBox('0 0 24 24')
					]),
				attributes),
			_Utils_ap(
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Svg$Styled$path,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Svg$Styled$Attributes$d('M0,0h24v24H0V0z'),
								$rtfeldman$elm_css$Svg$Styled$Attributes$fill('none')
							]),
						_List_Nil),
						A2(
						$rtfeldman$elm_css$Svg$Styled$path,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Svg$Styled$Attributes$d('M14,2H6C4.9,2,4.01,2.9,4.01,4L4,20c0,1.1,0.89,2,1.99,2H18c1.1,0,2-0.9,2-2V8L14,2z M18,20H6V4h7v5h5V20z M8.82,13.05 L7.4,14.46L10.94,18l5.66-5.66l-1.41-1.41l-4.24,4.24L8.82,13.05z')
							]),
						_List_Nil)
					]),
				children));
	});
var $author$project$Material$Styled$Icon$task = $author$project$Material$Styled$Icon$Task$view;
var $author$project$Material$Styled$Icon$Wifi$view = F2(
	function (attributes, children) {
		return A2(
			$rtfeldman$elm_css$Svg$Styled$svg,
			_Utils_ap(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Svg$Styled$Attributes$fill('black'),
						$rtfeldman$elm_css$Svg$Styled$Attributes$width('24px'),
						$rtfeldman$elm_css$Svg$Styled$Attributes$height('24px'),
						$rtfeldman$elm_css$Svg$Styled$Attributes$viewBox('0 0 24 24')
					]),
				attributes),
			_Utils_ap(
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Svg$Styled$path,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Svg$Styled$Attributes$d('M0 0h24v24H0V0zm0 0h24v24H0V0z'),
								$rtfeldman$elm_css$Svg$Styled$Attributes$fill('none')
							]),
						_List_Nil),
						A2(
						$rtfeldman$elm_css$Svg$Styled$path,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Svg$Styled$Attributes$d('M1 9l2 2c4.97-4.97 13.03-4.97 18 0l2-2C16.93 2.93 7.08 2.93 1 9zm8 8l3 3 3-3c-1.65-1.66-4.34-1.66-6 0zm-4-4l2 2c2.76-2.76 7.24-2.76 10 0l2-2C15.14 9.14 8.87 9.14 5 13z')
							]),
						_List_Nil)
					]),
				children));
	});
var $author$project$Material$Styled$Icon$wifi = $author$project$Material$Styled$Icon$Wifi$view;
var $author$project$View$Menu$slideInMenu = F5(
	function (appDomain, user, menuStatus, languageModel, model) {
		var menuItemLanguageData = model.languageSwitchModel.allLanguageData.location.menuItem;
		var isAppDomain = A2(
			$author$project$Data$Domain$equal,
			$author$project$Data$Domain$selected(user.domains),
			appDomain);
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Events$onClick(
					$author$project$Types$OnAuth(
						$author$project$Types$OnMenu($author$project$Types$ClosedMenu))),
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_Utils_eq(menuStatus, $author$project$Types$OpenedMenu) ? $author$project$View$Menu$styles.backdrop : $author$project$View$Menu$styles.backdropHidden)
				]),
			_List_fromArray(
				[
					$author$project$View$Menu$menuGlobalCss,
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Menu$styles.menu),
							$rtfeldman$elm_css$Html$Styled$Attributes$class(
							$author$project$View$Menu$cssClass(menuStatus))
						]),
					_List_fromArray(
						[
							$author$project$View$Menu$header(user),
							A3($author$project$View$Menu$item, $author$project$Material$Styled$Icon$addCircle, $author$project$Data$Route$routeUrl.newMultipleDoc, menuItemLanguageData.newDocuments),
							isAppDomain ? $rtfeldman$elm_css$Html$Styled$text('') : A3($author$project$View$Menu$item, $author$project$Material$Styled$Icon$template, $author$project$Data$Route$routeUrl.newTemplate, menuItemLanguageData.newTemplate),
							A3($author$project$View$Menu$item, $author$project$Material$Styled$Icon$home, $author$project$Data$Route$routeUrl.dashboard, menuItemLanguageData.dashboard),
							A3($author$project$View$Menu$item, $author$project$Material$Styled$Icon$wifi, $author$project$Data$Route$routeUrl.trustScore, menuItemLanguageData.trustScore),
							A3($author$project$View$Menu$item, $author$project$Material$Styled$Icon$folder, $author$project$Data$Route$routeUrl.receievedDoc, menuItemLanguageData.documents),
							A3($author$project$View$Menu$item, $author$project$Material$Styled$Icon$task, $author$project$Data$Route$routeUrl.viewNotarisationInfo, menuItemLanguageData.viewNotarisedInformation),
							A3($author$project$View$Menu$item, $author$project$Material$Styled$Icon$importContacts, $author$project$Data$Route$routeUrl.addressBook, menuItemLanguageData.addressBook),
							A3($author$project$View$Menu$item, $author$project$Material$Styled$Icon$accountCircle, $author$project$Data$Route$routeUrl.setting, menuItemLanguageData.myAccount),
							isAppDomain ? $rtfeldman$elm_css$Html$Styled$text('') : A3($author$project$View$Menu$item, $author$project$Material$Styled$Icon$business, $author$project$Data$Route$routeUrl.businessProfile, menuItemLanguageData.myOrganisation),
							A3($author$project$View$Menu$item, $author$project$Material$Styled$Icon$accountBalanceWallet, $author$project$Data$Route$routeUrl.tokenManagement, menuItemLanguageData.signNetRewardsPoints),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Menu$styles.help)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Need Help?')
								])),
							A3($author$project$View$Menu$item, $author$project$Material$Styled$Icon$code, 'https://signnet.tawk.help/', menuItemLanguageData.gettingStarted),
							A3($author$project$View$Menu$item, $author$project$Material$Styled$Icon$liveHelp, 'https://www.sign.net/faq/', menuItemLanguageData.faq),
							A3($author$project$View$Menu$item, $author$project$Material$Styled$Icon$contactMail, 'https://www.sign.net/contact', menuItemLanguageData.contactUs),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Menu$styles.logout),
									$rtfeldman$elm_css$Html$Styled$Events$onClick(
									$author$project$Types$OnAuth(
										$author$project$Types$OnLogout($author$project$Type$Logout$Logout)))
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Material$Styled$Icon$exitToApp,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Svg$Styled$Attributes$fill($author$project$Material$Styled$Color$blueGrey900String),
											$rtfeldman$elm_css$Svg$Styled$Attributes$width('24'),
											$rtfeldman$elm_css$Svg$Styled$Attributes$height('24'),
											$rtfeldman$elm_css$Svg$Styled$Attributes$viewBox('0 0 24 24'),
											$rtfeldman$elm_css$Svg$Styled$Attributes$css($author$project$View$Menu$styles.itemIcon),
											$rtfeldman$elm_css$Svg$Styled$Attributes$css($author$project$View$Menu$styles.itemIcon)
										]),
									_List_Nil),
									$rtfeldman$elm_css$Html$Styled$text('LOGOUT')
								]))
						]))
				]));
	});
var $author$project$View$Menu$view = F3(
	function (model, appDomain, _v0) {
		var user = _v0.user;
		var menu = _v0.menu;
		var languageChangeModel = _v0.languageChangeModel;
		var selectedDomain = $author$project$Data$Domain$selected(user.domains);
		var domains = $author$project$Data$Domain$all(user.domains);
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Menu$styles.menuBar)
				]),
			_List_fromArray(
				[
					A2($author$project$View$Menu$selectDomainLink, selectedDomain, domains),
					$author$project$View$Menu$selectLanguageModal(languageChangeModel),
					$author$project$View$Menu$openButton,
					A5($author$project$View$Menu$slideInMenu, appDomain, user, menu, languageChangeModel, model),
					A3($author$project$View$Menu$selectDomainModal, menu, selectedDomain, domains),
					$author$project$View$Menu$showLanguageModal(languageChangeModel)
				]));
	});
var $author$project$View$Header$view = F2(
	function (theme, model) {
		var _v0 = theme;
		var logo = _v0.logo;
		var appBarBackgroundColor = _v0.appBarBackgroundColor;
		var containerStyle = $author$project$View$Header$styles.container(appBarBackgroundColor);
		var header = A2($author$project$Data$Domain$equal, model.domainHost, model.appDomain) ? A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(containerStyle)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$a,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$href($author$project$Data$Route$routeUrl.login)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$img,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$src(logo),
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Header$styles.logo)
								]),
							_List_Nil)
						]))
				])) : A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(containerStyle)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$a,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$href('/')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$img,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$src(logo),
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Header$styles.logo)
								]),
							_List_Nil)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Header$styles.links)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$a,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Header$styles.login),
									$rtfeldman$elm_css$Html$Styled$Attributes$href($author$project$Data$Route$routeUrl.login)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Login')
								])),
							$rtfeldman$elm_css$Html$Styled$text(' / '),
							A2(
							$rtfeldman$elm_css$Html$Styled$a,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Header$styles.login),
									$rtfeldman$elm_css$Html$Styled$Attributes$href($author$project$Data$Route$routeUrl.signUp)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Register')
								]))
						]))
				]));
		var _v1 = model.sessionModel;
		switch (_v1.$) {
			case 'Auth':
				var authModel = _v1.a;
				return A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(containerStyle)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$a,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$href($author$project$Data$Route$routeUrl.dashboard)
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$img,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$src(logo),
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Header$styles.logo)
										]),
									_List_Nil)
								])),
							A3($author$project$View$Menu$view, model, model.appDomain, authModel)
						]));
			case 'Anonymous':
				return header;
			case 'NoAuth':
				return header;
			default:
				return header;
		}
	});
var $author$project$Material$Styled$Color$blue100String = '#bbdefb';
var $author$project$Material$Styled$Color$blue100 = $rtfeldman$elm_css$Css$hex($author$project$Material$Styled$Color$blue100String);
var $author$project$Material$Styled$ProgressBar$defaultConfig = {backgroundColor: $author$project$Material$Styled$Color$blueA700, barColor: $author$project$Material$Styled$Color$blue100, containerStyles: _List_Nil};
var $author$project$Material$Styled$ProgressBar$mergeProperty = F2(
	function (property, config) {
		var styles = property.a;
		return _Utils_update(
			config,
			{containerStyles: styles});
	});
var $author$project$Material$Styled$ProgressBar$mergeConfig = F2(
	function (config, properties) {
		return A3($elm$core$List$foldl, $author$project$Material$Styled$ProgressBar$mergeProperty, config, properties);
	});
var $author$project$Material$Styled$ProgressBar$animateMargin = $rtfeldman$elm_css$Css$Animations$keyframes(
	_List_fromArray(
		[
			_Utils_Tuple2(
			0,
			_List_fromArray(
				[
					A2($rtfeldman$elm_css$Css$Animations$property, 'margin-left', '0'),
					A2($rtfeldman$elm_css$Css$Animations$property, 'margin-right', '100%')
				])),
			_Utils_Tuple2(
			50,
			_List_fromArray(
				[
					A2($rtfeldman$elm_css$Css$Animations$property, 'margin-left', '25%'),
					A2($rtfeldman$elm_css$Css$Animations$property, 'margin-right', '10%')
				])),
			_Utils_Tuple2(
			100,
			_List_fromArray(
				[
					A2($rtfeldman$elm_css$Css$Animations$property, 'margin-left', '100%'),
					A2($rtfeldman$elm_css$Css$Animations$property, 'margin-right', '0')
				]))
		]));
var $author$project$Material$Styled$ProgressBar$style = F2(
	function (bgColor, barColor) {
		return {
			bar: _List_fromArray(
				[
					$rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$block),
					$rtfeldman$elm_css$Css$margin($rtfeldman$elm_css$Css$zero),
					$rtfeldman$elm_css$Css$width(
					$rtfeldman$elm_css$Css$pct(100)),
					$rtfeldman$elm_css$Css$height(
					$rtfeldman$elm_css$Css$px(3)),
					$rtfeldman$elm_css$Css$backgroundColor(barColor),
					$rtfeldman$elm_css$Css$animationName($author$project$Material$Styled$ProgressBar$animateMargin),
					$rtfeldman$elm_css$Css$animationDuration(
					$rtfeldman$elm_css$Css$sec(2)),
					A2($rtfeldman$elm_css$Css$property, 'animation-iteration-count', 'infinite')
				]),
			container: _List_fromArray(
				[
					$rtfeldman$elm_css$Css$displayFlex,
					$rtfeldman$elm_css$Css$margin($rtfeldman$elm_css$Css$zero),
					$rtfeldman$elm_css$Css$width(
					$rtfeldman$elm_css$Css$pct(100)),
					$rtfeldman$elm_css$Css$height(
					$rtfeldman$elm_css$Css$px(3)),
					$rtfeldman$elm_css$Css$backgroundColor(bgColor)
				])
		};
	});
var $author$project$Material$Styled$ProgressBar$linear = F2(
	function (properties, _v0) {
		var _v1 = A2($author$project$Material$Styled$ProgressBar$mergeConfig, $author$project$Material$Styled$ProgressBar$defaultConfig, properties);
		var containerStyles = _v1.containerStyles;
		var backgroundColor = _v1.backgroundColor;
		var barColor = _v1.barColor;
		var styles = A2($author$project$Material$Styled$ProgressBar$style, backgroundColor, barColor);
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_Utils_ap(styles.container, containerStyles))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(styles.bar)
						]),
					_List_Nil)
				]));
	});
var $rtfeldman$elm_css$Css$calcExpressionToString = function (expression) {
	if (expression.$ === 'Addition') {
		return '+';
	} else {
		return '-';
	}
};
var $rtfeldman$elm_css$Css$calc = F3(
	function (firstExpr, expression, secondExpr) {
		var withoutCalcStr = function (l) {
			return A2($elm$core$String$startsWith, 'calc(', l.value) ? A2($elm$core$String$dropLeft, 4, l.value) : l.value;
		};
		var calcs = A2(
			$elm$core$String$join,
			' ',
			_List_fromArray(
				[
					withoutCalcStr(firstExpr),
					$rtfeldman$elm_css$Css$calcExpressionToString(expression),
					withoutCalcStr(secondExpr)
				]));
		var value = A2(
			$rtfeldman$elm_css$Css$cssFunction,
			'calc',
			_List_fromArray(
				[calcs]));
		return {calc: $rtfeldman$elm_css$Css$Structure$Compatible, flexBasis: $rtfeldman$elm_css$Css$Structure$Compatible, fontSize: $rtfeldman$elm_css$Css$Structure$Compatible, length: $rtfeldman$elm_css$Css$Structure$Compatible, lengthOrAuto: $rtfeldman$elm_css$Css$Structure$Compatible, lengthOrAutoOrCoverOrContain: $rtfeldman$elm_css$Css$Structure$Compatible, lengthOrMinMaxDimension: $rtfeldman$elm_css$Css$Structure$Compatible, lengthOrNone: $rtfeldman$elm_css$Css$Structure$Compatible, lengthOrNoneOrMinMaxDimension: $rtfeldman$elm_css$Css$Structure$Compatible, lengthOrNumber: $rtfeldman$elm_css$Css$Structure$Compatible, lengthOrNumberOrAutoOrNoneOrContent: $rtfeldman$elm_css$Css$Structure$Compatible, textIndent: $rtfeldman$elm_css$Css$Structure$Compatible, value: value};
	});
var $rtfeldman$elm_css$Css$Subtraction = {$: 'Subtraction'};
var $rtfeldman$elm_css$Css$minus = $rtfeldman$elm_css$Css$Subtraction;
var $author$project$View$Loading$styles = {
	card: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			A2(
			$rtfeldman$elm_css$Css$margin2,
			$rtfeldman$elm_css$Css$zero,
			$rtfeldman$elm_css$Css$px(20)),
			$rtfeldman$elm_css$Css$paddingBottom(
			$rtfeldman$elm_css$Css$px(40)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100)),
			$rtfeldman$elm_css$Css$maxWidth(
			$rtfeldman$elm_css$Css$px(600))
		]),
	container: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			A2(
			$rtfeldman$elm_css$Css$padding2,
			$rtfeldman$elm_css$Css$px(48),
			$rtfeldman$elm_css$Css$px(48))
		]),
	heading: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(24)),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$blueGrey900)
		]),
	loadingbar: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$padding(
			$rtfeldman$elm_css$Css$px(48)),
			$rtfeldman$elm_css$Css$width(
			A3(
				$rtfeldman$elm_css$Css$calc,
				$rtfeldman$elm_css$Css$pct(100),
				$rtfeldman$elm_css$Css$minus,
				$rtfeldman$elm_css$Css$px(48))),
			$rtfeldman$elm_css$Css$boxSizing($rtfeldman$elm_css$Css$borderBox),
			A3(
			$rtfeldman$elm_css$Css$borderTop3,
			$rtfeldman$elm_css$Css$px(1),
			$rtfeldman$elm_css$Css$solid,
			$author$project$Material$Styled$Color$grey200)
		]),
	logo: _List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Css$margin2,
			$rtfeldman$elm_css$Css$px(20),
			$rtfeldman$elm_css$Css$zero),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(150)),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(38))
		]),
	subheading: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(16)),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$blueGrey900),
			$rtfeldman$elm_css$Css$marginBottom(
			$rtfeldman$elm_css$Css$px(20))
		])
};
var $author$project$View$Loading$view = F2(
	function (message, subMessage) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Loading$styles.container)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Material$Styled$Card$card,
					_List_fromArray(
						[
							$author$project$Material$Styled$Card$containerStyles($author$project$View$Loading$styles.card)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$img,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$src($author$project$View$Theme$images.logoColor),
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Loading$styles.logo)
								]),
							_List_Nil),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Loading$styles.loadingbar)
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$h2,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Loading$styles.heading)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(message)
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Loading$styles.subheading)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											A2($elm$core$Maybe$withDefault, '', subMessage))
										])),
									A2($author$project$Material$Styled$ProgressBar$linear, _List_Nil, _List_Nil)
								]))
						]))
				]));
	});
var $author$project$View$layout = F2(
	function (model, page) {
		var _v0 = model.theme.theme;
		if (_v0.$ === 'Loading') {
			return A2($author$project$View$Loading$view, 'Loading...', $elm$core$Maybe$Nothing);
		} else {
			var theme = _v0.a;
			var nonAuthLayout = A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$styles.container)
					]),
				_List_fromArray(
					[
						$author$project$View$globalStyles,
						A2($author$project$View$Header$view, theme, model),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$styles.page)
							]),
						_List_fromArray(
							[page])),
						$author$project$View$Footer$view
					]));
			var _v1 = model.sessionModel;
			switch (_v1.$) {
				case 'Auth':
					var authModel = _v1.a;
					return A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$styles.container)
							]),
						_List_fromArray(
							[
								$author$project$View$globalStyles,
								A2($author$project$View$ActionButton$actionButton, authModel, model),
								A2($author$project$View$Header$view, theme, model),
								A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$styles.page)
									]),
								_List_fromArray(
									[page])),
								$author$project$View$Footer$view
							]));
				case 'Anonymous':
					return nonAuthLayout;
				case 'NoAuth':
					return nonAuthLayout;
				default:
					return nonAuthLayout;
			}
		}
	});
var $author$project$Data$Api$Activate$errorToString = function (error) {
	if (error.$ === 'INVALID_ACTIVATE_CODE') {
		return 'Activation code has expired or account is already activated.';
	} else {
		return 'User not found.';
	}
};
var $author$project$Material$Styled$Color$red900String = '#b71c1c';
var $author$project$Material$Styled$Color$red900 = $rtfeldman$elm_css$Css$hex($author$project$Material$Styled$Color$red900String);
var $author$project$Page$Activate$styles = {
	affliate: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(1)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(1))
		]),
	button: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(48)),
			$rtfeldman$elm_css$Css$maxWidth(
			$rtfeldman$elm_css$Css$px(300))
		]),
	card: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			A2(
			$rtfeldman$elm_css$Css$margin2,
			$rtfeldman$elm_css$Css$zero,
			$rtfeldman$elm_css$Css$px(20)),
			$rtfeldman$elm_css$Css$paddingBottom(
			$rtfeldman$elm_css$Css$px(40)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100)),
			$rtfeldman$elm_css$Css$maxWidth(
			$rtfeldman$elm_css$Css$px(600))
		]),
	container: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			A2(
			$rtfeldman$elm_css$Css$padding2,
			$rtfeldman$elm_css$Css$px(48),
			$rtfeldman$elm_css$Css$zero)
		]),
	heading: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(24)),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$blueGrey900),
			$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center)
		]),
	headingError: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(24)),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$red900),
			$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center)
		]),
	linkContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			A3(
				$rtfeldman$elm_css$Css$calc,
				$rtfeldman$elm_css$Css$pct(100),
				$rtfeldman$elm_css$Css$minus,
				$rtfeldman$elm_css$Css$px(48))),
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(16))
		]),
	logo: _List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Css$margin2,
			$rtfeldman$elm_css$Css$px(60),
			$rtfeldman$elm_css$Css$zero),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(150)),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(38))
		]),
	main: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			A3(
				$rtfeldman$elm_css$Css$calc,
				$rtfeldman$elm_css$Css$pct(100),
				$rtfeldman$elm_css$Css$minus,
				$rtfeldman$elm_css$Css$px(48))),
			A2(
			$rtfeldman$elm_css$Css$padding2,
			$rtfeldman$elm_css$Css$px(48),
			$rtfeldman$elm_css$Css$px(24)),
			$rtfeldman$elm_css$Css$boxSizing($rtfeldman$elm_css$Css$borderBox),
			A3(
			$rtfeldman$elm_css$Css$borderTop3,
			$rtfeldman$elm_css$Css$px(1),
			$rtfeldman$elm_css$Css$solid,
			$author$project$Material$Styled$Color$grey200),
			A3(
			$rtfeldman$elm_css$Css$borderBottom3,
			$rtfeldman$elm_css$Css$px(1),
			$rtfeldman$elm_css$Css$solid,
			$author$project$Material$Styled$Color$grey200)
		]),
	progressBar: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(48))
		]),
	textContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(14)),
			$rtfeldman$elm_css$Css$lineHeight(
			$rtfeldman$elm_css$Css$px(21)),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$blueGrey900),
			$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$fontWeight(
			$rtfeldman$elm_css$Css$int(400))
		])
};
var $author$project$Page$Activate$errorView = function (errorMessage) {
	return _List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Html$Styled$h2,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Activate$styles.headingError)
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text('Account Activation Failed')
				])),
			A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Activate$styles.textContainer)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(errorMessage)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('Please refresh the page or click on the activation link in your email to try again.')
						]))
				]))
		]);
};
var $author$project$Material$Styled$A$styles = {
	link: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$blueA700),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(14)),
			$rtfeldman$elm_css$Css$lineHeight(
			$rtfeldman$elm_css$Css$px(21))
		])
};
var $author$project$Material$Styled$A$a = F2(
	function (attributes, children) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$a,
			A2(
				$elm$core$List$cons,
				$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Material$Styled$A$styles.link),
				attributes),
			children);
	});
var $author$project$Page$Activate$layout = function (children) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Activate$styles.container)
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Material$Styled$Card$card,
				_List_fromArray(
					[
						$author$project$Material$Styled$Card$containerStyles($author$project$Page$Activate$styles.card)
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$img,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$src($author$project$View$Theme$images.logoColor),
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Activate$styles.logo)
							]),
						_List_Nil),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Activate$styles.main)
							]),
						children),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Activate$styles.linkContainer)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Material$Styled$A$a,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$href($author$project$Data$Route$routeUrl.login)
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('Have an account?')
									]))
							]))
					]))
			]));
};
var $author$project$Material$Styled$ProgressBar$ContainerStyle = function (a) {
	return {$: 'ContainerStyle', a: a};
};
var $author$project$Material$Styled$ProgressBar$containerStyle = function (styles) {
	return $author$project$Material$Styled$ProgressBar$ContainerStyle(styles);
};
var $author$project$Page$Activate$submittingView = _List_fromArray(
	[
		A2(
		$rtfeldman$elm_css$Html$Styled$h2,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Activate$styles.heading)
			]),
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$text('Activating Your Account')
			])),
		A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Activate$styles.textContainer)
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$p,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('Please wait a moment while we activate your account.')
					])),
				A2(
				$author$project$Material$Styled$ProgressBar$linear,
				_List_fromArray(
					[
						$author$project$Material$Styled$ProgressBar$containerStyle($author$project$Page$Activate$styles.progressBar)
					]),
				_List_Nil)
			]))
	]);
var $author$project$Page$Activate$successView = F3(
	function (userID, affliateUrl, affliateParams) {
		return _List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$h2,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Activate$styles.heading)
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('Account Activated')
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Activate$styles.textContainer)
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('Thank you for creating an account with Sign.net.')
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('Your account has been successfully activated. Please wait while we redirect you to the Dashboard.')
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$img,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$src(
								_Utils_ap(
									affliateUrl,
									_Utils_ap(userID, affliateParams))),
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Activate$styles.affliate)
							]),
						_List_Nil)
					]))
			]);
	});
var $author$project$Page$Activate$view = F3(
	function (model, affliateUrl, affliateParams) {
		return $author$project$Page$Activate$layout(
			function () {
				var _v0 = model.token;
				if (_v0.$ === 'Nothing') {
					return $author$project$Page$Activate$errorView('The token given for activation is invalid.');
				} else {
					var _v1 = model.status;
					switch (_v1.$) {
						case 'Submitting':
							return $author$project$Page$Activate$submittingView;
						case 'Success':
							var userID = _v1.a;
							return A3($author$project$Page$Activate$successView, userID, affliateUrl, affliateParams);
						default:
							var error = _v1.a;
							return $author$project$Page$Activate$errorView(
								A2($author$project$Data$Api$errorToString, $author$project$Data$Api$Activate$errorToString, error));
					}
				}
			}());
	});
var $author$project$Type$AddressBook$OnModalAction = function (a) {
	return {$: 'OnModalAction', a: a};
};
var $rtfeldman$elm_css$Html$Styled$h1 = $rtfeldman$elm_css$Html$Styled$node('h1');
var $author$project$Material$Styled$Color$indigo100String = '#c5cae9';
var $author$project$Material$Styled$Color$indigoA400String = '#3d5afe';
var $author$project$Material$Styled$Button$indigo = {base: $author$project$Material$Styled$Color$indigoA400String, ripple: $author$project$Material$Styled$Color$indigo100String, text: $author$project$Material$Styled$Color$whiteString};
var $author$project$Type$AddressBook$Accepted = {$: 'Accepted'};
var $author$project$Type$AddressBook$NextPage = function (a) {
	return {$: 'NextPage', a: a};
};
var $author$project$Type$AddressBook$OnPageSizeChange = F2(
	function (a, b) {
		return {$: 'OnPageSizeChange', a: a, b: b};
	});
var $author$project$Type$AddressBook$PreviousPage = function (a) {
	return {$: 'PreviousPage', a: a};
};
var $rtfeldman$elm_css$Css$backgroundImage = $rtfeldman$elm_css$Css$prop1('background-image');
var $rtfeldman$elm_css$Css$backgroundRepeat = $rtfeldman$elm_css$Css$prop1('background-repeat');
var $rtfeldman$elm_css$Css$noRepeat = {backgroundRepeat: $rtfeldman$elm_css$Css$Structure$Compatible, backgroundRepeatShorthand: $rtfeldman$elm_css$Css$Structure$Compatible, value: 'no-repeat'};
var $rtfeldman$elm_css$Css$url = function (urlValue) {
	return {backgroundImage: $rtfeldman$elm_css$Css$Structure$Compatible, value: 'url(' + (urlValue + ')')};
};
var $author$project$Page$AddressBook$styles = {
	addButton: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$maxWidth($rtfeldman$elm_css$Css$fitContent),
			$rtfeldman$elm_css$Css$padding(
			$rtfeldman$elm_css$Css$px(10)),
			$rtfeldman$elm_css$Css$marginLeft(
			$rtfeldman$elm_css$Css$px(20))
		]),
	contactsContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$row),
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$flexStart),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$flexStart),
			$rtfeldman$elm_css$Css$flexWrap($rtfeldman$elm_css$Css$wrap)
		]),
	container: _List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Css$margin2,
			$rtfeldman$elm_css$Css$zero,
			$rtfeldman$elm_css$Css$px(30))
		]),
	heading: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$row),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$paddingTop(
			$rtfeldman$elm_css$Css$px(10))
		]),
	progressBar: _List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Css$margin2,
			$rtfeldman$elm_css$Css$pct(10),
			$rtfeldman$elm_css$Css$pct(25)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(50)),
			$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center)
		]),
	searchContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$row),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$paddingTop(
			$rtfeldman$elm_css$Css$px(10))
		]),
	searchImage: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$relative),
			$rtfeldman$elm_css$Css$backgroundImage(
			$rtfeldman$elm_css$Css$url($author$project$View$Theme$images.search)),
			$rtfeldman$elm_css$Css$backgroundRepeat($rtfeldman$elm_css$Css$noRepeat),
			$rtfeldman$elm_css$Css$backgroundSize(
			$rtfeldman$elm_css$Css$px(20)),
			$rtfeldman$elm_css$Css$left(
			$rtfeldman$elm_css$Css$px(10)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(20)),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(20))
		]),
	searchInput: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginLeft(
			$rtfeldman$elm_css$Css$px(-20)),
			A2(
			$rtfeldman$elm_css$Css$padding2,
			$rtfeldman$elm_css$Css$zero,
			$rtfeldman$elm_css$Css$px(40)),
			$rtfeldman$elm_css$Css$outline($rtfeldman$elm_css$Css$none),
			$rtfeldman$elm_css$Css$border($rtfeldman$elm_css$Css$zero),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(40)),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(42)),
			A2($rtfeldman$elm_css$Css$property, 'box-shadow', '0 0 0 1px rgba(63,63,68,0.05), 0 1px 3px 0 rgba(63,63,68,0.15)')
		])
};
var $author$project$Type$AddressBook$CreditCard = {$: 'CreditCard'};
var $author$project$Type$AddressBook$DeleteFriend = F2(
	function (a, b) {
		return {$: 'DeleteFriend', a: a, b: b};
	});
var $author$project$Type$AddressBook$MobilePhone = {$: 'MobilePhone'};
var $author$project$Type$AddressBook$MyInfo = {$: 'MyInfo'};
var $author$project$Type$AddressBook$OnAliasInput = F2(
	function (a, b) {
		return {$: 'OnAliasInput', a: a, b: b};
	});
var $author$project$Type$AddressBook$OnEditAlias = function (a) {
	return {$: 'OnEditAlias', a: a};
};
var $author$project$Type$AddressBook$OnExpandOrCollapse = function (a) {
	return {$: 'OnExpandOrCollapse', a: a};
};
var $author$project$Type$AddressBook$Wallet = {$: 'Wallet'};
var $author$project$Type$AddressBook$Enters = {$: 'Enters'};
var $author$project$Type$AddressBook$Leaves = {$: 'Leaves'};
var $author$project$Type$AddressBook$OnHover = F3(
	function (a, b, c) {
		return {$: 'OnHover', a: a, b: b, c: c};
	});
var $rtfeldman$elm_css$Css$default = {cursor: $rtfeldman$elm_css$Css$Structure$Compatible, value: 'default'};
var $rtfeldman$elm_css$Css$flexBasis = $rtfeldman$elm_css$Css$prop1('flex-basis');
var $rtfeldman$elm_css$Css$inlineBlock = {display: $rtfeldman$elm_css$Css$Structure$Compatible, value: 'inline-block'};
var $rtfeldman$elm_css$Css$padding3 = $rtfeldman$elm_css$Css$prop3('padding');
var $author$project$Page$AddressBook$ContactList$styles = {
	allIcon: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$default)
		]),
	arrowDown: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$relative),
			$rtfeldman$elm_css$Css$left(
			$rtfeldman$elm_css$Css$px(20)),
			A3(
			$rtfeldman$elm_css$Css$borderLeft3,
			$rtfeldman$elm_css$Css$px(10),
			$rtfeldman$elm_css$Css$solid,
			$rtfeldman$elm_css$Css$transparent),
			A3(
			$rtfeldman$elm_css$Css$borderRight3,
			$rtfeldman$elm_css$Css$px(10),
			$rtfeldman$elm_css$Css$solid,
			$rtfeldman$elm_css$Css$transparent),
			A3(
			$rtfeldman$elm_css$Css$borderTop3,
			$rtfeldman$elm_css$Css$px(10),
			$rtfeldman$elm_css$Css$solid,
			A4($rtfeldman$elm_css$Css$rgba, 41, 121, 255, 0.9)),
			A3(
			$rtfeldman$elm_css$Css$borderBottom3,
			$rtfeldman$elm_css$Css$px(10),
			$rtfeldman$elm_css$Css$solid,
			$rtfeldman$elm_css$Css$transparent),
			$rtfeldman$elm_css$Css$width($rtfeldman$elm_css$Css$zero),
			$rtfeldman$elm_css$Css$height($rtfeldman$elm_css$Css$zero)
		]),
	avatarImage: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginRight(
			$rtfeldman$elm_css$Css$px(7)),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(50))
		]),
	buttonContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$row),
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$flexEnd),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$flexBasis(
			$rtfeldman$elm_css$Css$pct(10))
		]),
	container: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$inlineBlock),
			$rtfeldman$elm_css$Css$flexBasis(
			$rtfeldman$elm_css$Css$pct(22)),
			A4(
			$rtfeldman$elm_css$Css$margin4,
			$rtfeldman$elm_css$Css$px(0),
			$rtfeldman$elm_css$Css$px(40),
			$rtfeldman$elm_css$Css$px(22),
			$rtfeldman$elm_css$Css$px(0))
		]),
	content: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			A3(
			$rtfeldman$elm_css$Css$padding3,
			$rtfeldman$elm_css$Css$zero,
			$rtfeldman$elm_css$Css$px(10),
			$rtfeldman$elm_css$Css$px(16))
		]),
	header: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$row),
			$rtfeldman$elm_css$Css$padding(
			$rtfeldman$elm_css$Css$px(16))
		]),
	hideContent: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$none)
		]),
	icon: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginRight(
			$rtfeldman$elm_css$Css$px(10)),
			$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(25)),
			$rtfeldman$elm_css$Css$hover(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$backgroundColor($author$project$Material$Styled$Color$grey200),
					$rtfeldman$elm_css$Css$borderRadius(
					$rtfeldman$elm_css$Css$pct(100))
				])),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(40)),
			$rtfeldman$elm_css$Css$active(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$backgroundColor($author$project$Material$Styled$Color$grey100),
					$rtfeldman$elm_css$Css$backgroundSize(
					$rtfeldman$elm_css$Css$pct(100)),
					$rtfeldman$elm_css$Css$Transitions$transition(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$Transitions$background(0)
						]))
				]))
		]),
	iconContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			A2(
			$rtfeldman$elm_css$Css$padding2,
			$rtfeldman$elm_css$Css$px(5),
			$rtfeldman$elm_css$Css$px(20)),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(12)),
			$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center)
		]),
	inputContainer: _List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Css$padding2,
			$rtfeldman$elm_css$Css$px(10),
			$rtfeldman$elm_css$Css$zero)
		]),
	messageContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$relative),
			$rtfeldman$elm_css$Css$bottom(
			$rtfeldman$elm_css$Css$px(85)),
			$rtfeldman$elm_css$Css$left(
			$rtfeldman$elm_css$Css$px(-20)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(0)),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(0))
		]),
	myInfoImage: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(30)),
			A4(
			$rtfeldman$elm_css$Css$padding4,
			$rtfeldman$elm_css$Css$px(0),
			$rtfeldman$elm_css$Css$px(0),
			$rtfeldman$elm_css$Css$px(0),
			$rtfeldman$elm_css$Css$px(5))
		]),
	myInfoImageBlurred: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(30)),
			A4(
			$rtfeldman$elm_css$Css$padding4,
			$rtfeldman$elm_css$Css$px(0),
			$rtfeldman$elm_css$Css$px(0),
			$rtfeldman$elm_css$Css$px(0),
			$rtfeldman$elm_css$Css$px(5)),
			$rtfeldman$elm_css$Css$opacity(
			$rtfeldman$elm_css$Css$num(0.4))
		]),
	profile: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$row),
			$rtfeldman$elm_css$Css$flexBasis(
			$rtfeldman$elm_css$Css$pct(90))
		]),
	saveAliasButton: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(10))
		]),
	toolTip: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$backgroundColor($author$project$Material$Styled$Color$blueA400),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(170)),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(25)),
			$rtfeldman$elm_css$Css$padding(
			$rtfeldman$elm_css$Css$px(10)),
			$rtfeldman$elm_css$Css$borderRadius(
			$rtfeldman$elm_css$Css$px(10)),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$white),
			$rtfeldman$elm_css$Css$animationDuration(
			$rtfeldman$elm_css$Css$sec(0.3)),
			$rtfeldman$elm_css$Css$opacity(
			$rtfeldman$elm_css$Css$num(0.9))
		]),
	trustScore: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(40)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(40))
		])
};
var $author$project$Page$AddressBook$ContactList$checkVerification = F2(
	function (isVerified, placement) {
		var placementTxt = function () {
			var _v0 = _Utils_Tuple2(placement, isVerified);
			if (_v0.b) {
				switch (_v0.a.$) {
					case 'CreditCard':
						var _v1 = _v0.a;
						return 'Verified with credit card.';
					case 'MobilePhone':
						var _v3 = _v0.a;
						return 'Verified with Mobile Phone.';
					case 'Wallet':
						var _v5 = _v0.a;
						return 'Verified with Wallet address.';
					default:
						var _v7 = _v0.a;
						return 'Verified with My Info.';
				}
			} else {
				switch (_v0.a.$) {
					case 'CreditCard':
						var _v2 = _v0.a;
						return 'Not verified with credit card.';
					case 'MobilePhone':
						var _v4 = _v0.a;
						return 'Not verified with Mobile Phone.';
					case 'Wallet':
						var _v6 = _v0.a;
						return 'Not verified with Wallet address.';
					default:
						var _v8 = _v0.a;
						return 'Not verified with My Info.';
				}
			}
		}();
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$AddressBook$ContactList$styles.messageContainer)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$AddressBook$ContactList$styles.toolTip)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(placementTxt)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$AddressBook$ContactList$styles.arrowDown)
						]),
					_List_Nil)
				]));
	});
var $author$project$Page$AddressBook$ContactList$displayIcon = F2(
	function (verification, icon) {
		return verification ? A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					icon,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Svg$Styled$Attributes$css($author$project$Page$AddressBook$ContactList$styles.allIcon)
						]),
					_List_Nil)
				])) : A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					icon,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Svg$Styled$Attributes$css($author$project$Page$AddressBook$ContactList$styles.allIcon),
							$rtfeldman$elm_css$Svg$Styled$Attributes$fill('grey')
						]),
					_List_Nil)
				]));
	});
var $author$project$Page$AddressBook$ContactList$displayToolTip = F3(
	function (toolTip, iconPlacement, userEmail) {
		if (toolTip.$ === 'NoHover') {
			return false;
		} else {
			var placement = toolTip.a;
			var email = toolTip.b;
			return (_Utils_eq(placement, iconPlacement) && _Utils_eq(email, userEmail)) ? true : false;
		}
	});
var $author$project$View$InfomationToolTip$view2 = F5(
	function (onEnterMsg, onLeaveMsg, hover, textMsg, icon) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Events$onMouseEnter(onEnterMsg),
					$rtfeldman$elm_css$Html$Styled$Events$onMouseLeave(onLeaveMsg)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_Nil,
					_List_fromArray(
						[icon])),
					hover ? textMsg : $rtfeldman$elm_css$Html$Styled$text('')
				]));
	});
var $author$project$Page$AddressBook$ContactList$displayIconToolTip = F5(
	function (placement, email, bool, toolTip, icon) {
		return A5(
			$author$project$View$InfomationToolTip$view2,
			$author$project$Types$OnAuth(
				$author$project$Types$OnAddressBook(
					A3($author$project$Type$AddressBook$OnHover, placement, $author$project$Type$AddressBook$Enters, email))),
			$author$project$Types$OnAuth(
				$author$project$Types$OnAddressBook(
					A3($author$project$Type$AddressBook$OnHover, placement, $author$project$Type$AddressBook$Leaves, email))),
			A3($author$project$Page$AddressBook$ContactList$displayToolTip, toolTip, placement, email),
			A2($author$project$Page$AddressBook$ContactList$checkVerification, bool, placement),
			A2($author$project$Page$AddressBook$ContactList$displayIcon, bool, icon));
	});
var $author$project$Page$AddressBook$ContactList$displayImage = function (verification) {
	return verification ? A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$img,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$src($author$project$View$Theme$images.myInfoLogo),
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$AddressBook$ContactList$styles.myInfoImage)
					]),
				_List_Nil)
			])) : A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$img,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$src($author$project$View$Theme$images.myInfoLogo),
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$AddressBook$ContactList$styles.myInfoImageBlurred)
					]),
				_List_Nil)
			]));
};
var $author$project$View$InfomationToolTip$viewImage = F5(
	function (onEnterMsg, onLeaveMsg, hover, textMsg, img) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Events$onMouseEnter(onEnterMsg),
					$rtfeldman$elm_css$Html$Styled$Events$onMouseLeave(onLeaveMsg)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_Nil,
					_List_fromArray(
						[img])),
					hover ? textMsg : $rtfeldman$elm_css$Html$Styled$text('')
				]));
	});
var $author$project$Page$AddressBook$ContactList$displayImageToolTip = F4(
	function (placement, email, bool, toolTip) {
		return A5(
			$author$project$View$InfomationToolTip$viewImage,
			$author$project$Types$OnAuth(
				$author$project$Types$OnAddressBook(
					A3($author$project$Type$AddressBook$OnHover, placement, $author$project$Type$AddressBook$Enters, email))),
			$author$project$Types$OnAuth(
				$author$project$Types$OnAddressBook(
					A3($author$project$Type$AddressBook$OnHover, placement, $author$project$Type$AddressBook$Leaves, email))),
			A3($author$project$Page$AddressBook$ContactList$displayToolTip, toolTip, placement, email),
			A2($author$project$Page$AddressBook$ContactList$checkVerification, bool, placement),
			$author$project$Page$AddressBook$ContactList$displayImage(bool));
	});
var $author$project$Type$AddressBook$Expanded = {$: 'Expanded'};
var $author$project$Page$AddressBook$ContactList$getStyles = function (status) {
	return _Utils_eq(status, $author$project$Type$AddressBook$Expanded) ? $rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$AddressBook$ContactList$styles.content) : $rtfeldman$elm_css$Html$Styled$Attributes$css(
		_Utils_ap($author$project$Page$AddressBook$ContactList$styles.content, $author$project$Page$AddressBook$ContactList$styles.hideContent));
};
var $author$project$Material$Styled$Input$Label = function (a) {
	return {$: 'Label', a: a};
};
var $author$project$Material$Styled$Input$label = function (string) {
	return $author$project$Material$Styled$Input$Label(string);
};
var $author$project$Material$Styled$Input$OnInput = function (a) {
	return {$: 'OnInput', a: a};
};
var $author$project$Material$Styled$Input$onInput = function (mapMsg) {
	return $author$project$Material$Styled$Input$OnInput(mapMsg);
};
var $author$project$Material$Styled$Icon$Payment$view = F2(
	function (attributes, children) {
		return A2(
			$rtfeldman$elm_css$Svg$Styled$svg,
			_Utils_ap(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Svg$Styled$Attributes$fill('black'),
						$rtfeldman$elm_css$Svg$Styled$Attributes$width('24px'),
						$rtfeldman$elm_css$Svg$Styled$Attributes$height('24px'),
						$rtfeldman$elm_css$Svg$Styled$Attributes$viewBox('0 0 24 24')
					]),
				attributes),
			_Utils_ap(
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Svg$Styled$path,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Svg$Styled$Attributes$d('M0 0h24v24H0z'),
								$rtfeldman$elm_css$Svg$Styled$Attributes$fill('none')
							]),
						_List_Nil),
						A2(
						$rtfeldman$elm_css$Svg$Styled$path,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Svg$Styled$Attributes$d('M20 4H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2zm0 14H4v-6h16v6zm0-10H4V6h16v2z')
							]),
						_List_Nil)
					]),
				children));
	});
var $author$project$Material$Styled$Icon$payment = $author$project$Material$Styled$Icon$Payment$view;
var $author$project$Material$Styled$Icon$PhoneLinkLock$view = F2(
	function (attributes, children) {
		return A2(
			$rtfeldman$elm_css$Svg$Styled$svg,
			_Utils_ap(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Svg$Styled$Attributes$fill('black'),
						$rtfeldman$elm_css$Svg$Styled$Attributes$width('24px'),
						$rtfeldman$elm_css$Svg$Styled$Attributes$height('24px'),
						$rtfeldman$elm_css$Svg$Styled$Attributes$viewBox('0 0 24 24')
					]),
				attributes),
			_Utils_ap(
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Svg$Styled$path,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Svg$Styled$Attributes$d('M0 0h24v24H0V0z'),
								$rtfeldman$elm_css$Svg$Styled$Attributes$fill('none')
							]),
						_List_Nil),
						A2(
						$rtfeldman$elm_css$Svg$Styled$path,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Svg$Styled$Attributes$d('M19 1H9c-1.1 0-2 .9-2 2v3h2V4h10v16H9v-2H7v3c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm-8.2 10V9.5C10.8 8.1 9.4 7 8 7S5.2 8.1 5.2 9.5V11c-.6 0-1.2.6-1.2 1.2v3.5c0 .7.6 1.3 1.2 1.3h5.5c.7 0 1.3-.6 1.3-1.2v-3.5c0-.7-.6-1.3-1.2-1.3zm-1.3 0h-3V9.5c0-.8.7-1.3 1.5-1.3s1.5.5 1.5 1.3V11z')
							]),
						_List_Nil)
					]),
				children));
	});
var $author$project$Material$Styled$Icon$phoneLinkLock = $author$project$Material$Styled$Icon$PhoneLinkLock$view;
var $author$project$Page$AddressBook$ContactList$renderName = function (acceptedAddress) {
	var _v0 = acceptedAddress.data.alias;
	if (_v0.$ === 'Just') {
		var alias = _v0.a;
		return $rtfeldman$elm_css$Html$Styled$text(acceptedAddress.data.friendName + (' ( ' + (alias + ' ) ')));
	} else {
		return $rtfeldman$elm_css$Html$Styled$text(acceptedAddress.data.friendName);
	}
};
var $author$project$Material$Styled$Input$defaultConfig = {containerAttributes: _List_Nil, containerStyles: _List_Nil, errorMessageText: $elm$core$Maybe$Nothing, id: '', infoMessageText: $elm$core$Maybe$Nothing, inputAttributes: _List_Nil, inputValue: '', labelText: 'Label'};
var $rtfeldman$elm_css$Html$Styled$input = $rtfeldman$elm_css$Html$Styled$node('input');
var $rtfeldman$elm_css$Html$Styled$Attributes$boolProperty = F2(
	function (key, bool) {
		return A2(
			$rtfeldman$elm_css$VirtualDom$Styled$property,
			key,
			$elm$json$Json$Encode$bool(bool));
	});
var $rtfeldman$elm_css$Html$Styled$Attributes$disabled = $rtfeldman$elm_css$Html$Styled$Attributes$boolProperty('disabled');
var $rtfeldman$elm_css$Html$Styled$Attributes$id = $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty('id');
var $rtfeldman$elm_css$Html$Styled$Attributes$max = $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty('max');
var $rtfeldman$elm_css$Html$Styled$Attributes$min = $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty('min');
var $rtfeldman$elm_css$Html$Styled$Events$onBlur = function (msg) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$Events$on,
		'blur',
		$elm$json$Json$Decode$succeed(msg));
};
var $rtfeldman$elm_css$Html$Styled$Events$alwaysStop = function (x) {
	return _Utils_Tuple2(x, true);
};
var $elm$virtual_dom$VirtualDom$MayStopPropagation = function (a) {
	return {$: 'MayStopPropagation', a: a};
};
var $rtfeldman$elm_css$Html$Styled$Events$stopPropagationOn = F2(
	function (event, decoder) {
		return A2(
			$rtfeldman$elm_css$VirtualDom$Styled$on,
			event,
			$elm$virtual_dom$VirtualDom$MayStopPropagation(decoder));
	});
var $rtfeldman$elm_css$Html$Styled$Events$targetValue = A2(
	$elm$json$Json$Decode$at,
	_List_fromArray(
		['target', 'value']),
	$elm$json$Json$Decode$string);
var $rtfeldman$elm_css$Html$Styled$Events$onInput = function (tagger) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$Events$stopPropagationOn,
		'input',
		A2(
			$elm$json$Json$Decode$map,
			$rtfeldman$elm_css$Html$Styled$Events$alwaysStop,
			A2($elm$json$Json$Decode$map, tagger, $rtfeldman$elm_css$Html$Styled$Events$targetValue)));
};
var $rtfeldman$elm_css$Html$Styled$Attributes$value = $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty('value');
var $author$project$Material$Styled$Input$mergeProperty = F2(
	function (property, config) {
		switch (property.$) {
			case 'ContainerStyle':
				var styles = property.a;
				return _Utils_update(
					config,
					{
						containerStyles: _Utils_ap(config.containerStyles, styles)
					});
			case 'OnInput':
				var mapMsg = property.a;
				return _Utils_update(
					config,
					{
						inputAttributes: A2(
							$elm$core$List$cons,
							$rtfeldman$elm_css$Html$Styled$Events$onInput(mapMsg),
							config.inputAttributes)
					});
			case 'OnBlur':
				var msg = property.a;
				return _Utils_update(
					config,
					{
						inputAttributes: A2(
							$elm$core$List$cons,
							$rtfeldman$elm_css$Html$Styled$Events$onBlur(msg),
							config.inputAttributes)
					});
			case 'Value':
				var valueText = property.a;
				return _Utils_update(
					config,
					{
						inputAttributes: A2(
							$elm$core$List$cons,
							$rtfeldman$elm_css$Html$Styled$Attributes$value(valueText),
							config.inputAttributes),
						inputValue: valueText
					});
			case 'Label':
				var labelText = property.a;
				return _Utils_update(
					config,
					{labelText: labelText});
			case 'InfoMessage':
				var message = property.a;
				return _Utils_update(
					config,
					{
						infoMessageText: $elm$core$Maybe$Just(message)
					});
			case 'ErrorMessage':
				var errorMessageText = property.a;
				return _Utils_update(
					config,
					{
						errorMessageText: $elm$core$Maybe$Just(errorMessageText)
					});
			case 'Disabled':
				var bool = property.a;
				return _Utils_update(
					config,
					{
						inputAttributes: A2(
							$elm$core$List$cons,
							$rtfeldman$elm_css$Html$Styled$Attributes$disabled(bool),
							config.inputAttributes)
					});
			case 'Min':
				var minValue = property.a;
				return _Utils_update(
					config,
					{
						inputAttributes: A2(
							$elm$core$List$cons,
							$rtfeldman$elm_css$Html$Styled$Attributes$min(minValue),
							config.inputAttributes)
					});
			case 'Max':
				var maxValue = property.a;
				return _Utils_update(
					config,
					{
						inputAttributes: A2(
							$elm$core$List$cons,
							$rtfeldman$elm_css$Html$Styled$Attributes$max(maxValue),
							config.inputAttributes)
					});
			case 'Id':
				var newId = property.a;
				return _Utils_update(
					config,
					{
						inputAttributes: A2(
							$elm$core$List$cons,
							$rtfeldman$elm_css$Html$Styled$Attributes$id(newId),
							config.inputAttributes)
					});
			default:
				return config;
		}
	});
var $author$project$Material$Styled$Input$mergeConfig = F2(
	function (config, properties) {
		return function (c) {
			return _Utils_update(
				c,
				{
					containerAttributes: A2(
						$elm$core$List$cons,
						$rtfeldman$elm_css$Html$Styled$Attributes$css(c.containerStyles),
						c.containerAttributes)
				});
		}(
			A3($elm$core$List$foldl, $author$project$Material$Styled$Input$mergeProperty, config, properties));
	});
var $rtfeldman$elm_css$Css$paddingRight = $rtfeldman$elm_css$Css$prop1('padding-right');
var $author$project$Material$Styled$Input$animation = {
	finalLabel: _List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Css$translate2,
			$rtfeldman$elm_css$Css$px(14),
			$rtfeldman$elm_css$Css$px(-6)),
			$rtfeldman$elm_css$Css$scale(0.75)
		]),
	finalLegend: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$maxWidth(
			$rtfeldman$elm_css$Css$px(1000)),
			$rtfeldman$elm_css$Css$paddingRight(
			$rtfeldman$elm_css$Css$px(3))
		]),
	initialLabel: _List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Css$translate2,
			$rtfeldman$elm_css$Css$px(14),
			$rtfeldman$elm_css$Css$px(20)),
			$rtfeldman$elm_css$Css$scale(1)
		]),
	initialLegend: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$maxWidth(
			$rtfeldman$elm_css$Css$px(0.01))
		])
};
var $author$project$Material$Styled$Color$blue600String = '#1e88e5';
var $author$project$Material$Styled$Color$blue600 = $rtfeldman$elm_css$Css$hex($author$project$Material$Styled$Color$blue600String);
var $rtfeldman$elm_css$Css$Transitions$Color = {$: 'Color'};
var $rtfeldman$elm_css$Css$Transitions$color3 = $rtfeldman$elm_css$Css$Transitions$fullTransition($rtfeldman$elm_css$Css$Transitions$Color);
var $author$project$Material$Styled$Input$ifElse = F3(
	function (trueStyle, falseStyle, maybe) {
		return A2(
			$elm$core$Maybe$withDefault,
			falseStyle,
			A2(
				$elm$core$Maybe$map,
				$elm$core$Basics$always(trueStyle),
				maybe));
	});
var $author$project$Material$Styled$Input$style = {
	error: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(11)),
			$rtfeldman$elm_css$Css$fontFamilies(
			_List_fromArray(
				[
					'Roboto',
					'Helvetica',
					'Arial',
					function ($) {
					return $.value;
				}($rtfeldman$elm_css$Css$sansSerif)
				])),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$red900),
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(6)),
			$rtfeldman$elm_css$Css$paddingLeft(
			$rtfeldman$elm_css$Css$px(14))
		]),
	fieldset: function (maybeError) {
		return _List_fromArray(
			[
				$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$absolute),
				$rtfeldman$elm_css$Css$top(
				$rtfeldman$elm_css$Css$px(-5)),
				$rtfeldman$elm_css$Css$left($rtfeldman$elm_css$Css$zero),
				$rtfeldman$elm_css$Css$right($rtfeldman$elm_css$Css$zero),
				$rtfeldman$elm_css$Css$bottom($rtfeldman$elm_css$Css$zero),
				$rtfeldman$elm_css$Css$margin($rtfeldman$elm_css$Css$zero),
				$rtfeldman$elm_css$Css$paddingLeft(
				$rtfeldman$elm_css$Css$px(8)),
				$rtfeldman$elm_css$Css$boxSizing($rtfeldman$elm_css$Css$borderBox),
				$rtfeldman$elm_css$Css$width(
				$rtfeldman$elm_css$Css$pct(100)),
				$rtfeldman$elm_css$Css$borderRadius(
				$rtfeldman$elm_css$Css$px(4)),
				A3(
				$rtfeldman$elm_css$Css$border3,
				$rtfeldman$elm_css$Css$px(1),
				$rtfeldman$elm_css$Css$solid,
				A3($author$project$Material$Styled$Input$ifElse, $author$project$Material$Styled$Color$red900, $author$project$Material$Styled$Color$grey300, maybeError)),
				$rtfeldman$elm_css$Css$pointerEvents($rtfeldman$elm_css$Css$none)
			]);
	},
	info: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(11)),
			$rtfeldman$elm_css$Css$fontFamilies(
			_List_fromArray(
				[
					'Roboto',
					'Helvetica',
					'Arial',
					function ($) {
					return $.value;
				}($rtfeldman$elm_css$Css$sansSerif)
				])),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$blueGrey600),
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(6)),
			$rtfeldman$elm_css$Css$paddingLeft(
			$rtfeldman$elm_css$Css$px(14))
		]),
	input: function (maybeError) {
		return _List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Css$padding2,
				$rtfeldman$elm_css$Css$px(18),
				$rtfeldman$elm_css$Css$px(14)),
				$rtfeldman$elm_css$Css$boxSizing($rtfeldman$elm_css$Css$borderBox),
				$rtfeldman$elm_css$Css$width(
				$rtfeldman$elm_css$Css$pct(100)),
				$rtfeldman$elm_css$Css$fontFamilies(
				_List_fromArray(
					[
						'Roboto',
						'Helvetica',
						'Arial',
						function ($) {
						return $.value;
					}($rtfeldman$elm_css$Css$sansSerif)
					])),
				$rtfeldman$elm_css$Css$fontSize(
				$rtfeldman$elm_css$Css$px(12.8)),
				$rtfeldman$elm_css$Css$outline($rtfeldman$elm_css$Css$none),
				$rtfeldman$elm_css$Css$border($rtfeldman$elm_css$Css$zero),
				$rtfeldman$elm_css$Css$borderRadius(
				$rtfeldman$elm_css$Css$px(4)),
				A2(
				$rtfeldman$elm_css$Css$pseudoClass,
				'focus + label',
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$transforms($author$project$Material$Styled$Input$animation.finalLabel),
						$rtfeldman$elm_css$Css$color(
						A3($author$project$Material$Styled$Input$ifElse, $author$project$Material$Styled$Color$red900, $author$project$Material$Styled$Color$blue600, maybeError))
					])),
				A2(
				$rtfeldman$elm_css$Css$pseudoClass,
				'focus ~ fieldset',
				_List_fromArray(
					[
						A3(
						$rtfeldman$elm_css$Css$border3,
						$rtfeldman$elm_css$Css$px(2),
						$rtfeldman$elm_css$Css$solid,
						A3($author$project$Material$Styled$Input$ifElse, $author$project$Material$Styled$Color$red900, $author$project$Material$Styled$Color$blue600, maybeError))
					])),
				A2($rtfeldman$elm_css$Css$pseudoClass, 'focus ~ fieldset legend', $author$project$Material$Styled$Input$animation.finalLegend)
			]);
	},
	inputContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$relative)
		]),
	label: function (maybeError) {
		return _List_fromArray(
			[
				$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$absolute),
				$rtfeldman$elm_css$Css$top($rtfeldman$elm_css$Css$zero),
				$rtfeldman$elm_css$Css$left($rtfeldman$elm_css$Css$zero),
				$rtfeldman$elm_css$Css$fontSize(
				$rtfeldman$elm_css$Css$px(12.8)),
				$rtfeldman$elm_css$Css$fontFamilies(
				_List_fromArray(
					[
						'Roboto',
						'Helvetica',
						'Arial',
						function ($) {
						return $.value;
					}($rtfeldman$elm_css$Css$sansSerif)
					])),
				$rtfeldman$elm_css$Css$color(
				A3($author$project$Material$Styled$Input$ifElse, $author$project$Material$Styled$Color$red900, $author$project$Material$Styled$Color$blueGrey900, maybeError)),
				$rtfeldman$elm_css$Css$Transitions$transition(
				_List_fromArray(
					[
						A3(
						$rtfeldman$elm_css$Css$Transitions$transform3,
						200,
						0,
						A4($rtfeldman$elm_css$Css$Transitions$cubicBezier, 0, 0, 0.2, 1)),
						A3(
						$rtfeldman$elm_css$Css$Transitions$color3,
						200,
						0,
						A4($rtfeldman$elm_css$Css$Transitions$cubicBezier, 0, 0, 0.2, 1))
					])),
				A2($rtfeldman$elm_css$Css$property, 'transform-origin', 'top left'),
				$rtfeldman$elm_css$Css$pointerEvents($rtfeldman$elm_css$Css$none)
			]);
	},
	labelError: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$red900)
		]),
	legend: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$block),
			$rtfeldman$elm_css$Css$visibility($rtfeldman$elm_css$Css$hidden),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(11)),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$em(0.75))
		])
};
var $author$project$Material$Styled$Input$renderInfoOrError = F2(
	function (maybeInfo, maybeError) {
		if (maybeError.$ === 'Just') {
			var message = maybeError.a;
			return A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Material$Styled$Input$style.error)
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(message)
					]));
		} else {
			if (maybeInfo.$ === 'Just') {
				var message = maybeInfo.a;
				return A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Material$Styled$Input$style.info)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(message)
						]));
			} else {
				return $rtfeldman$elm_css$Html$Styled$text('');
			}
		}
	});
var $rtfeldman$elm_css$Html$Styled$fieldset = $rtfeldman$elm_css$Html$Styled$node('fieldset');
var $rtfeldman$elm_css$Html$Styled$label = $rtfeldman$elm_css$Html$Styled$node('label');
var $rtfeldman$elm_css$Html$Styled$legend = $rtfeldman$elm_css$Html$Styled$node('legend');
var $author$project$Material$Styled$Input$renderLabel = F3(
	function (inputValue, errorMessageText, labelText) {
		var _v0 = $elm$core$String$isEmpty(inputValue) ? _Utils_Tuple2(
			A2(
				$elm$core$List$cons,
				$rtfeldman$elm_css$Css$transforms($author$project$Material$Styled$Input$animation.initialLabel),
				$author$project$Material$Styled$Input$style.label(errorMessageText)),
			_Utils_ap($author$project$Material$Styled$Input$animation.initialLegend, $author$project$Material$Styled$Input$style.legend)) : _Utils_Tuple2(
			A2(
				$elm$core$List$cons,
				$rtfeldman$elm_css$Css$transforms($author$project$Material$Styled$Input$animation.finalLabel),
				$author$project$Material$Styled$Input$style.label(errorMessageText)),
			_Utils_ap($author$project$Material$Styled$Input$animation.finalLegend, $author$project$Material$Styled$Input$style.legend));
		var labelStyle = _v0.a;
		var legendStyle = _v0.b;
		return _List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$label,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(labelStyle)
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(labelText)
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$fieldset,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						$author$project$Material$Styled$Input$style.fieldset(errorMessageText))
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$legend,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css(legendStyle)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(labelText)
							]))
					]))
			]);
	});
var $author$project$Material$Styled$Input$input = F2(
	function (inputType, properties) {
		var _v0 = A2($author$project$Material$Styled$Input$mergeConfig, $author$project$Material$Styled$Input$defaultConfig, properties);
		var containerAttributes = _v0.containerAttributes;
		var inputAttributes = _v0.inputAttributes;
		var labelText = _v0.labelText;
		var infoMessageText = _v0.infoMessageText;
		var errorMessageText = _v0.errorMessageText;
		var inputValue = _v0.inputValue;
		var mergedInputAttributes = A2(
			$elm$core$List$cons,
			A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'data-test', labelText),
			A2(
				$elm$core$List$cons,
				$rtfeldman$elm_css$Html$Styled$Attributes$type_(inputType),
				A2(
					$elm$core$List$cons,
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
						$author$project$Material$Styled$Input$style.input(errorMessageText)),
					inputAttributes)));
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			containerAttributes,
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Material$Styled$Input$style.inputContainer)
						]),
					A2(
						$elm$core$List$cons,
						A2($rtfeldman$elm_css$Html$Styled$input, mergedInputAttributes, _List_Nil),
						A3($author$project$Material$Styled$Input$renderLabel, inputValue, errorMessageText, labelText))),
					A2($author$project$Material$Styled$Input$renderInfoOrError, infoMessageText, errorMessageText)
				]));
	});
var $author$project$Material$Styled$Input$text = F2(
	function (properties, _v0) {
		return A2($author$project$Material$Styled$Input$input, 'text', properties);
	});
var $author$project$Type$AddressBook$toggle = function (status) {
	if (status.$ === 'Expanded') {
		return $author$project$Type$AddressBook$Closed;
	} else {
		return $author$project$Type$AddressBook$Expanded;
	}
};
var $author$project$Material$Styled$Input$Value = function (a) {
	return {$: 'Value', a: a};
};
var $author$project$Material$Styled$Input$value = function (string) {
	return $author$project$Material$Styled$Input$Value(string);
};
var $author$project$Page$AddressBook$ContactList$view = F3(
	function (languageSwitchModel, model, acceptedAddress) {
		var addressBookLanguageData = languageSwitchModel.allLanguageData.location.addressBookPage;
		return A2(
			$author$project$Material$Styled$Card$card,
			_List_fromArray(
				[
					$author$project$Material$Styled$Card$containerStyles($author$project$Page$AddressBook$ContactList$styles.container)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$AddressBook$ContactList$styles.header)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$AddressBook$ContactList$styles.profile)
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$img,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$src($author$project$View$Theme$images.person),
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$AddressBook$ContactList$styles.avatarImage)
										]),
									_List_Nil),
									$author$project$Page$AddressBook$ContactList$renderName(acceptedAddress),
									A2($rtfeldman$elm_css$Html$Styled$br, _List_Nil, _List_Nil),
									$rtfeldman$elm_css$Html$Styled$text(acceptedAddress.data.friend),
									A2($rtfeldman$elm_css$Html$Styled$br, _List_Nil, _List_Nil)
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$AddressBook$ContactList$styles.buttonContainer)
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$img,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$src($author$project$View$Theme$images.edit),
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$AddressBook$ContactList$styles.icon),
											$rtfeldman$elm_css$Html$Styled$Events$onClick(
											$author$project$Types$OnAuth(
												$author$project$Types$OnAddressBook(
													$author$project$Type$AddressBook$OnExpandOrCollapse(
														_Utils_Tuple2(
															acceptedAddress.data.friend,
															$author$project$Type$AddressBook$toggle(acceptedAddress.expandStatus))))))
										]),
									_List_Nil)
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$AddressBook$ContactList$styles.iconContainer)
								]),
							_List_fromArray(
								[
									A5($author$project$Page$AddressBook$ContactList$displayIconToolTip, $author$project$Type$AddressBook$CreditCard, acceptedAddress.data.friend, acceptedAddress.data.verifyStripe, model.toolTip, $author$project$Material$Styled$Icon$payment),
									A5($author$project$Page$AddressBook$ContactList$displayIconToolTip, $author$project$Type$AddressBook$MobilePhone, acceptedAddress.data.friend, acceptedAddress.data.verifyMobilePhone, model.toolTip, $author$project$Material$Styled$Icon$phoneLinkLock),
									A5($author$project$Page$AddressBook$ContactList$displayIconToolTip, $author$project$Type$AddressBook$Wallet, acceptedAddress.data.friend, acceptedAddress.data.verifyWallet, model.toolTip, $author$project$Material$Styled$Icon$accountBalanceWallet),
									A4($author$project$Page$AddressBook$ContactList$displayImageToolTip, $author$project$Type$AddressBook$MyInfo, acceptedAddress.data.friend, acceptedAddress.data.verifyMyInfo, model.toolTip)
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$author$project$Page$AddressBook$ContactList$getStyles(acceptedAddress.expandStatus)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$img,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$src($author$project$View$Theme$images._delete),
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$AddressBook$ContactList$styles.icon),
									$rtfeldman$elm_css$Html$Styled$Events$onClick(
									$author$project$Types$OnAuth(
										$author$project$Types$OnAddressBook(
											$author$project$Type$AddressBook$OnModalAction(
												A2($author$project$Type$AddressBook$DeleteFriend, $author$project$Type$AddressBook$Open, acceptedAddress.data)))))
								]),
							_List_Nil),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$AddressBook$ContactList$styles.inputContainer)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Material$Styled$Input$text,
									_List_fromArray(
										[
											$author$project$Material$Styled$Input$label('Alias'),
											$author$project$Material$Styled$Input$onInput(
											A2(
												$elm$core$Basics$composeL,
												A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnAddressBook),
												$author$project$Type$AddressBook$OnAliasInput(acceptedAddress))),
											$author$project$Material$Styled$Input$value(acceptedAddress.newAlias)
										]),
									_List_Nil)
								])),
							A2(
							$author$project$Material$Styled$Button$button,
							_List_fromArray(
								[
									$author$project$Material$Styled$Button$styles($author$project$Page$AddressBook$ContactList$styles.saveAliasButton),
									$author$project$Material$Styled$Button$onClick(
									A2(
										$elm$core$Basics$composeL,
										A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnAddressBook),
										$author$project$Type$AddressBook$OnEditAlias)(acceptedAddress))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(addressBookLanguageData.saveAlias)
								]))
						]))
				]));
	});
var $author$project$Material$Styled$Select$ContainerStyle = function (a) {
	return {$: 'ContainerStyle', a: a};
};
var $author$project$Material$Styled$Select$containerStyles = function (styles_) {
	return $author$project$Material$Styled$Select$ContainerStyle(styles_);
};
var $author$project$Material$Styled$Icon$KeyboardArrowLeft$view = F2(
	function (attributes, children) {
		return A2(
			$rtfeldman$elm_css$Svg$Styled$svg,
			_Utils_ap(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Svg$Styled$Attributes$fill('black'),
						$rtfeldman$elm_css$Svg$Styled$Attributes$width('24px'),
						$rtfeldman$elm_css$Svg$Styled$Attributes$height('24px'),
						$rtfeldman$elm_css$Svg$Styled$Attributes$viewBox('0 0 24 24')
					]),
				attributes),
			_Utils_ap(
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Svg$Styled$path,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Svg$Styled$Attributes$d('M0 0h24v24H0V0z'),
								$rtfeldman$elm_css$Svg$Styled$Attributes$fill('none')
							]),
						_List_Nil),
						A2(
						$rtfeldman$elm_css$Svg$Styled$path,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Svg$Styled$Attributes$d('M15.41 16.59L10.83 12l4.58-4.59L14 6l-6 6 6 6 1.41-1.41z')
							]),
						_List_Nil)
					]),
				children));
	});
var $author$project$Material$Styled$Icon$keyboardArrowLeft = $author$project$Material$Styled$Icon$KeyboardArrowLeft$view;
var $author$project$Material$Styled$Icon$KeyboardArrowRight$view = F2(
	function (attributes, children) {
		return A2(
			$rtfeldman$elm_css$Svg$Styled$svg,
			_Utils_ap(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Svg$Styled$Attributes$fill('black'),
						$rtfeldman$elm_css$Svg$Styled$Attributes$width('24px'),
						$rtfeldman$elm_css$Svg$Styled$Attributes$height('24px'),
						$rtfeldman$elm_css$Svg$Styled$Attributes$viewBox('0 0 24 24')
					]),
				attributes),
			_Utils_ap(
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Svg$Styled$path,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Svg$Styled$Attributes$d('M0 0h24v24H0V0z'),
								$rtfeldman$elm_css$Svg$Styled$Attributes$fill('none')
							]),
						_List_Nil),
						A2(
						$rtfeldman$elm_css$Svg$Styled$path,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Svg$Styled$Attributes$d('M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z')
							]),
						_List_Nil)
					]),
				children));
	});
var $author$project$Material$Styled$Icon$keyboardArrowRight = $author$project$Material$Styled$Icon$KeyboardArrowRight$view;
var $author$project$Material$Styled$Select$Label = function (a) {
	return {$: 'Label', a: a};
};
var $author$project$Material$Styled$Select$label = function (string) {
	return $author$project$Material$Styled$Select$Label(string);
};
var $author$project$Material$Styled$Select$OnInput = function (a) {
	return {$: 'OnInput', a: a};
};
var $author$project$Material$Styled$Select$onChange = function (mapMsg) {
	return $author$project$Material$Styled$Select$OnInput(mapMsg);
};
var $rtfeldman$elm_css$Html$Styled$option = $rtfeldman$elm_css$Html$Styled$node('option');
var $author$project$Material$Styled$Select$defaultConfig = {containerAttributes: _List_Nil, containerStyles: _List_Nil, errorMessageText: $elm$core$Maybe$Nothing, infoMessageText: $elm$core$Maybe$Nothing, labelText: 'Label', selectAttributes: _List_Nil, selectStyles: _List_Nil, selectValue: ''};
var $author$project$Material$Styled$Select$mergeProperty = F2(
	function (property, config) {
		switch (property.$) {
			case 'ContainerStyle':
				var styles = property.a;
				return _Utils_update(
					config,
					{
						containerStyles: _Utils_ap(config.containerStyles, styles)
					});
			case 'SelectStyle':
				var styles = property.a;
				return _Utils_update(
					config,
					{
						selectStyles: _Utils_ap(config.selectStyles, styles)
					});
			case 'Value':
				var valueText = property.a;
				return _Utils_update(
					config,
					{
						selectAttributes: A2(
							$elm$core$List$cons,
							$rtfeldman$elm_css$Html$Styled$Attributes$value(valueText),
							config.selectAttributes),
						selectValue: valueText
					});
			case 'Label':
				var labelText = property.a;
				return _Utils_update(
					config,
					{labelText: labelText});
			case 'Disabled':
				var bool = property.a;
				return _Utils_update(
					config,
					{
						selectAttributes: A2(
							$elm$core$List$cons,
							$rtfeldman$elm_css$Html$Styled$Attributes$disabled(bool),
							config.selectAttributes)
					});
			case 'OnInput':
				var msg = property.a;
				return _Utils_update(
					config,
					{
						selectAttributes: A2(
							$elm$core$List$cons,
							$rtfeldman$elm_css$Html$Styled$Events$onInput(msg),
							config.selectAttributes)
					});
			case 'ErrorMessage':
				var errorMessageText = property.a;
				return _Utils_update(
					config,
					{
						errorMessageText: $elm$core$Maybe$Just(errorMessageText)
					});
			case 'InfoMessage':
				var message = property.a;
				return _Utils_update(
					config,
					{
						infoMessageText: $elm$core$Maybe$Just(message)
					});
			default:
				return config;
		}
	});
var $author$project$Material$Styled$Select$animation = {
	finalLabel: _List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Css$translate2,
			$rtfeldman$elm_css$Css$px(14),
			$rtfeldman$elm_css$Css$px(-6)),
			$rtfeldman$elm_css$Css$scale(0.75)
		]),
	finalLegend: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$maxWidth(
			$rtfeldman$elm_css$Css$px(1000)),
			$rtfeldman$elm_css$Css$paddingRight(
			$rtfeldman$elm_css$Css$px(3))
		]),
	initialLabel: _List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Css$translate2,
			$rtfeldman$elm_css$Css$px(14),
			$rtfeldman$elm_css$Css$px(20)),
			$rtfeldman$elm_css$Css$scale(1)
		]),
	initialLegend: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$maxWidth(
			$rtfeldman$elm_css$Css$px(0.01))
		])
};
var $author$project$Material$Styled$Select$ifElse = F3(
	function (trueStyle, falseStyle, maybe) {
		return A2(
			$elm$core$Maybe$withDefault,
			falseStyle,
			A2(
				$elm$core$Maybe$map,
				$elm$core$Basics$always(trueStyle),
				maybe));
	});
var $author$project$Material$Styled$Select$style = {
	error: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(11)),
			$rtfeldman$elm_css$Css$fontFamilies(
			_List_fromArray(
				[
					'Roboto',
					'Helvetica',
					'Arial',
					function ($) {
					return $.value;
				}($rtfeldman$elm_css$Css$sansSerif)
				])),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$red900),
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(6)),
			$rtfeldman$elm_css$Css$paddingLeft(
			$rtfeldman$elm_css$Css$px(14))
		]),
	fieldset: function (maybeError) {
		return _List_fromArray(
			[
				$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$absolute),
				$rtfeldman$elm_css$Css$top(
				$rtfeldman$elm_css$Css$px(-5)),
				$rtfeldman$elm_css$Css$left($rtfeldman$elm_css$Css$zero),
				$rtfeldman$elm_css$Css$right($rtfeldman$elm_css$Css$zero),
				$rtfeldman$elm_css$Css$bottom($rtfeldman$elm_css$Css$zero),
				$rtfeldman$elm_css$Css$margin($rtfeldman$elm_css$Css$zero),
				$rtfeldman$elm_css$Css$paddingLeft(
				$rtfeldman$elm_css$Css$px(8)),
				$rtfeldman$elm_css$Css$boxSizing($rtfeldman$elm_css$Css$borderBox),
				$rtfeldman$elm_css$Css$width(
				$rtfeldman$elm_css$Css$pct(100)),
				$rtfeldman$elm_css$Css$borderRadius(
				$rtfeldman$elm_css$Css$px(4)),
				A3(
				$rtfeldman$elm_css$Css$border3,
				$rtfeldman$elm_css$Css$px(1),
				$rtfeldman$elm_css$Css$solid,
				A3($author$project$Material$Styled$Select$ifElse, $author$project$Material$Styled$Color$red900, $author$project$Material$Styled$Color$grey300, maybeError)),
				$rtfeldman$elm_css$Css$pointerEvents($rtfeldman$elm_css$Css$none)
			]);
	},
	info: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(11)),
			$rtfeldman$elm_css$Css$fontFamilies(
			_List_fromArray(
				[
					'Roboto',
					'Helvetica',
					'Arial',
					function ($) {
					return $.value;
				}($rtfeldman$elm_css$Css$sansSerif)
				])),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$blueGrey600),
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(6)),
			$rtfeldman$elm_css$Css$paddingLeft(
			$rtfeldman$elm_css$Css$px(14))
		]),
	label: function (maybeError) {
		return _List_fromArray(
			[
				$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$absolute),
				$rtfeldman$elm_css$Css$top($rtfeldman$elm_css$Css$zero),
				$rtfeldman$elm_css$Css$left($rtfeldman$elm_css$Css$zero),
				$rtfeldman$elm_css$Css$fontSize(
				$rtfeldman$elm_css$Css$px(14)),
				$rtfeldman$elm_css$Css$fontFamilies(
				_List_fromArray(
					[
						'Roboto',
						'Helvetica',
						'Arial',
						function ($) {
						return $.value;
					}($rtfeldman$elm_css$Css$sansSerif)
					])),
				$rtfeldman$elm_css$Css$color(
				A3($author$project$Material$Styled$Select$ifElse, $author$project$Material$Styled$Color$red900, $author$project$Material$Styled$Color$blueGrey900, maybeError)),
				$rtfeldman$elm_css$Css$Transitions$transition(
				_List_fromArray(
					[
						A3(
						$rtfeldman$elm_css$Css$Transitions$transform3,
						200,
						0,
						A4($rtfeldman$elm_css$Css$Transitions$cubicBezier, 0, 0, 0.2, 1)),
						A3(
						$rtfeldman$elm_css$Css$Transitions$color3,
						200,
						0,
						A4($rtfeldman$elm_css$Css$Transitions$cubicBezier, 0, 0, 0.2, 1))
					])),
				A2($rtfeldman$elm_css$Css$property, 'transform-origin', 'top left'),
				$rtfeldman$elm_css$Css$pointerEvents($rtfeldman$elm_css$Css$none)
			]);
	},
	legend: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$block),
			$rtfeldman$elm_css$Css$visibility($rtfeldman$elm_css$Css$hidden),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(11)),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$em(0.95))
		]),
	select: function (maybeError) {
		return _List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Css$padding2,
				$rtfeldman$elm_css$Css$px(18),
				$rtfeldman$elm_css$Css$px(14)),
				$rtfeldman$elm_css$Css$boxSizing($rtfeldman$elm_css$Css$borderBox),
				$rtfeldman$elm_css$Css$width(
				$rtfeldman$elm_css$Css$pct(100)),
				$rtfeldman$elm_css$Css$fontFamilies(
				_List_fromArray(
					[
						'Roboto',
						'Helvetica',
						'Arial',
						function ($) {
						return $.value;
					}($rtfeldman$elm_css$Css$sansSerif)
					])),
				$rtfeldman$elm_css$Css$fontSize(
				$rtfeldman$elm_css$Css$px(12.8)),
				$rtfeldman$elm_css$Css$outline($rtfeldman$elm_css$Css$none),
				$rtfeldman$elm_css$Css$border($rtfeldman$elm_css$Css$zero),
				$rtfeldman$elm_css$Css$borderRadius(
				$rtfeldman$elm_css$Css$px(4)),
				A2(
				$rtfeldman$elm_css$Css$pseudoClass,
				'focus + label',
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$transforms($author$project$Material$Styled$Select$animation.finalLabel),
						$rtfeldman$elm_css$Css$color(
						A3($author$project$Material$Styled$Select$ifElse, $author$project$Material$Styled$Color$red900, $author$project$Material$Styled$Color$blue600, maybeError))
					])),
				A2(
				$rtfeldman$elm_css$Css$pseudoClass,
				'focus ~ fieldset',
				_List_fromArray(
					[
						A3(
						$rtfeldman$elm_css$Css$border3,
						$rtfeldman$elm_css$Css$px(2),
						$rtfeldman$elm_css$Css$solid,
						A3($author$project$Material$Styled$Select$ifElse, $author$project$Material$Styled$Color$red900, $author$project$Material$Styled$Color$blue600, maybeError))
					])),
				A2($rtfeldman$elm_css$Css$pseudoClass, 'focus ~ fieldset legend', $author$project$Material$Styled$Select$animation.finalLegend)
			]);
	},
	selectContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$relative),
			$rtfeldman$elm_css$Css$paddingRight(
			$rtfeldman$elm_css$Css$px(8)),
			$rtfeldman$elm_css$Css$backgroundColor($author$project$Material$Styled$Color$white)
		])
};
var $author$project$Material$Styled$Select$mergeConfig = F2(
	function (config, properties) {
		return function (c) {
			return _Utils_update(
				c,
				{
					containerAttributes: A2(
						$elm$core$List$cons,
						$rtfeldman$elm_css$Html$Styled$Attributes$css(c.containerStyles),
						c.containerAttributes),
					selectAttributes: A2(
						$elm$core$List$cons,
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_Utils_ap(
								$author$project$Material$Styled$Select$style.select(c.errorMessageText),
								c.selectStyles)),
						c.selectAttributes)
				});
		}(
			A3($elm$core$List$foldl, $author$project$Material$Styled$Select$mergeProperty, config, properties));
	});
var $author$project$Material$Styled$Select$renderInfoOrError = F2(
	function (maybeInfo, maybeError) {
		if (maybeError.$ === 'Just') {
			var message = maybeError.a;
			return A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Material$Styled$Select$style.error)
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(message)
					]));
		} else {
			if (maybeInfo.$ === 'Just') {
				var message = maybeInfo.a;
				return A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Material$Styled$Select$style.info)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(message)
						]));
			} else {
				return $rtfeldman$elm_css$Html$Styled$text('');
			}
		}
	});
var $author$project$Material$Styled$Select$renderLabel = F3(
	function (selectValue, errorMessageText, labelText) {
		var _v0 = $elm$core$String$isEmpty(selectValue) ? _Utils_Tuple2(
			A2(
				$elm$core$List$cons,
				$rtfeldman$elm_css$Css$transforms($author$project$Material$Styled$Select$animation.initialLabel),
				$author$project$Material$Styled$Select$style.label(errorMessageText)),
			_Utils_ap($author$project$Material$Styled$Select$animation.initialLegend, $author$project$Material$Styled$Select$style.legend)) : _Utils_Tuple2(
			A2(
				$elm$core$List$cons,
				$rtfeldman$elm_css$Css$transforms($author$project$Material$Styled$Select$animation.finalLabel),
				$author$project$Material$Styled$Select$style.label(errorMessageText)),
			_Utils_ap($author$project$Material$Styled$Select$animation.finalLegend, $author$project$Material$Styled$Select$style.legend));
		var labelStyle = _v0.a;
		var legendStyle = _v0.b;
		return _List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$label,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(labelStyle)
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(labelText)
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$fieldset,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						$author$project$Material$Styled$Select$style.fieldset(errorMessageText))
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$legend,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css(legendStyle)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(labelText)
							]))
					]))
			]);
	});
var $rtfeldman$elm_css$Html$Styled$select = $rtfeldman$elm_css$Html$Styled$node('select');
var $author$project$Material$Styled$Select$select = F2(
	function (properties, children) {
		var _v0 = A2($author$project$Material$Styled$Select$mergeConfig, $author$project$Material$Styled$Select$defaultConfig, properties);
		var containerAttributes = _v0.containerAttributes;
		var selectAttributes = _v0.selectAttributes;
		var labelText = _v0.labelText;
		var errorMessageText = _v0.errorMessageText;
		var selectValue = _v0.selectValue;
		var infoMessageText = _v0.infoMessageText;
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			containerAttributes,
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Material$Styled$Select$style.selectContainer)
						]),
					A2(
						$elm$core$List$cons,
						A2(
							$rtfeldman$elm_css$Html$Styled$select,
							A2(
								$elm$core$List$cons,
								A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'data-test', labelText),
								selectAttributes),
							children),
						A3($author$project$Material$Styled$Select$renderLabel, selectValue, errorMessageText, labelText))),
					A2($author$project$Material$Styled$Select$renderInfoOrError, infoMessageText, errorMessageText)
				]));
	});
var $author$project$Material$Styled$Select$SelectStyle = function (a) {
	return {$: 'SelectStyle', a: a};
};
var $author$project$Material$Styled$Select$selectStyles = function (styles_) {
	return $author$project$Material$Styled$Select$SelectStyle(styles_);
};
var $author$project$View$Pagination$styles = {
	button: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(50)),
			A2(
			$rtfeldman$elm_css$Css$padding2,
			$rtfeldman$elm_css$Css$px(10),
			$rtfeldman$elm_css$Css$px(10)),
			$rtfeldman$elm_css$Css$marginRight(
			$rtfeldman$elm_css$Css$px(5))
		]),
	container: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$row),
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$flexEnd),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center)
		]),
	spacing: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginRight(
			$rtfeldman$elm_css$Css$px(5))
		])
};
var $author$project$Material$Styled$Color$blackString = '#000000';
var $author$project$Material$Styled$Button$white = {base: $author$project$Material$Styled$Color$whiteString, ripple: $author$project$Material$Styled$Color$grey300String, text: $author$project$Material$Styled$Color$blackString};
var $author$project$View$Pagination$view = F4(
	function (languageSwitchModel, onChangeMsg, onPreviousPage, onNextPage) {
		var addressBookLanguageData = languageSwitchModel.allLanguageData.location.addressBookPage;
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Pagination$styles.container)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Pagination$styles.spacing)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(addressBookLanguageData.rowsPerPage + ': ')
						])),
					A2(
					$author$project$Material$Styled$Select$select,
					_List_fromArray(
						[
							$author$project$Material$Styled$Select$containerStyles($author$project$View$Pagination$styles.spacing),
							$author$project$Material$Styled$Select$selectStyles(
							_List_fromArray(
								[
									$rtfeldman$elm_css$Css$backgroundColor($author$project$Material$Styled$Color$white)
								])),
							$author$project$Material$Styled$Select$label(''),
							$author$project$Material$Styled$Select$onChange(onChangeMsg)
						]),
					A2(
						$elm$core$List$map,
						function (r) {
							return A2(
								$rtfeldman$elm_css$Html$Styled$option,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$value(r)
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(r)
									]));
						},
						_List_fromArray(
							['10', '20', '30']))),
					A2(
					$author$project$Material$Styled$Button$button,
					_List_fromArray(
						[
							$author$project$Material$Styled$Button$theme($author$project$Material$Styled$Button$white),
							$author$project$Material$Styled$Button$styles($author$project$View$Pagination$styles.button),
							$author$project$Material$Styled$Button$onClick(onPreviousPage)
						]),
					_List_fromArray(
						[
							A2($author$project$Material$Styled$Icon$keyboardArrowLeft, _List_Nil, _List_Nil)
						])),
					A2(
					$author$project$Material$Styled$Button$button,
					_List_fromArray(
						[
							$author$project$Material$Styled$Button$theme($author$project$Material$Styled$Button$white),
							$author$project$Material$Styled$Button$styles($author$project$View$Pagination$styles.button),
							$author$project$Material$Styled$Button$onClick(onNextPage)
						]),
					_List_fromArray(
						[
							A2($author$project$Material$Styled$Icon$keyboardArrowRight, _List_Nil, _List_Nil)
						]))
				]));
	});
var $author$project$Page$AddressBook$renderAccepted = F3(
	function (languageSwitchModel, contactList, model) {
		var addressBookLanguageData = languageSwitchModel.allLanguageData.location.addressBookPage;
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$h2,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(addressBookLanguageData.allContacts)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$AddressBook$styles.contactsContainer)
						]),
					A2(
						$elm$core$List$map,
						A2($author$project$Page$AddressBook$ContactList$view, languageSwitchModel, model),
						contactList)),
					A4(
					$author$project$View$Pagination$view,
					languageSwitchModel,
					function (pageSize) {
						return $author$project$Types$OnAuth(
							$author$project$Types$OnAddressBook(
								A2($author$project$Type$AddressBook$OnPageSizeChange, $author$project$Type$AddressBook$Accepted, pageSize)));
					},
					$author$project$Types$OnAuth(
						$author$project$Types$OnAddressBook(
							$author$project$Type$AddressBook$PreviousPage($author$project$Type$AddressBook$Accepted))),
					$author$project$Types$OnAuth(
						$author$project$Types$OnAddressBook(
							$author$project$Type$AddressBook$NextPage($author$project$Type$AddressBook$Accepted))))
				]));
	});
var $author$project$Type$AddressBook$OnDelete = function (a) {
	return {$: 'OnDelete', a: a};
};
var $author$project$Type$AddressBook$OnSubmit = {$: 'OnSubmit'};
var $author$project$Type$AddressBook$OnEmailInput = function (a) {
	return {$: 'OnEmailInput', a: a};
};
var $author$project$Material$Styled$Color$blueA100String = '#82B1FF';
var $author$project$Material$Styled$Button$blueText = {base: '1C00ff00', ripple: $author$project$Material$Styled$Color$blueA100String, text: $author$project$Material$Styled$Color$blueA700String};
var $author$project$Material$Styled$Input$ContainerStyle = function (a) {
	return {$: 'ContainerStyle', a: a};
};
var $author$project$Material$Styled$Input$containerStyles = function (styles_) {
	return $author$project$Material$Styled$Input$ContainerStyle(styles_);
};
var $author$project$Material$Styled$Button$Disabled = function (a) {
	return {$: 'Disabled', a: a};
};
var $author$project$Material$Styled$Button$disabled = function (bool) {
	return $author$project$Material$Styled$Button$Disabled(bool);
};
var $author$project$Material$Styled$Button$grey = {base: $author$project$Material$Styled$Color$grey300String, ripple: $author$project$Material$Styled$Color$grey100String, text: $author$project$Material$Styled$Color$grey500String};
var $author$project$Material$Styled$Button$greyText = {base: '1C00ff00', ripple: $author$project$Material$Styled$Color$grey100String, text: $author$project$Material$Styled$Color$blackString};
var $author$project$Page$AddressBook$AddFriendModal$styles = {
	button: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginLeft(
			$rtfeldman$elm_css$Css$px(10)),
			$rtfeldman$elm_css$Css$maxWidth($rtfeldman$elm_css$Css$fitContent)
		]),
	buttonContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$row),
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$flexEnd),
			$rtfeldman$elm_css$Css$paddingTop(
			$rtfeldman$elm_css$Css$px(16))
		]),
	errorMessage: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$marginBottom(
			$rtfeldman$elm_css$Css$px(20)),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$red500)
		]),
	header: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$row),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$flexStart),
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceBetween)
		]),
	headerText: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$em(0.83))
		]),
	icon: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$boxShadow($rtfeldman$elm_css$Css$none),
			$rtfeldman$elm_css$Css$transform(
			A2(
				$rtfeldman$elm_css$Css$translate2,
				$rtfeldman$elm_css$Css$px(20),
				$rtfeldman$elm_css$Css$px(-15))),
			$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer),
			$rtfeldman$elm_css$Css$padding(
			$rtfeldman$elm_css$Css$px(10))
		]),
	input: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100))
		]),
	textButton: function (_v0) {
		var base = _v0.base;
		var ripple = _v0.ripple;
		var text = _v0.text;
		return _List_fromArray(
			[
				$rtfeldman$elm_css$Css$maxWidth($rtfeldman$elm_css$Css$fitContent),
				A2(
				$rtfeldman$elm_css$Css$padding2,
				$rtfeldman$elm_css$Css$px(8),
				$rtfeldman$elm_css$Css$zero),
				$rtfeldman$elm_css$Css$marginLeft(
				$rtfeldman$elm_css$Css$px(8)),
				$rtfeldman$elm_css$Css$backgroundColor(
				$rtfeldman$elm_css$Css$hex(base)),
				$rtfeldman$elm_css$Css$color(
				$rtfeldman$elm_css$Css$hex(text)),
				$rtfeldman$elm_css$Css$hover(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$backgroundColor($author$project$Material$Styled$Color$grey100),
						$rtfeldman$elm_css$Css$boxShadow($rtfeldman$elm_css$Css$none)
					])),
				$rtfeldman$elm_css$Css$active(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$backgroundColor(
						$rtfeldman$elm_css$Css$hex(ripple))
					]))
			]);
	}
};
var $author$project$Page$AddressBook$AddFriendModal$renderErrorMessage = function (newEmailError) {
	if (newEmailError.$ === 'Just') {
		var error = newEmailError.a;
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$AddressBook$AddFriendModal$styles.errorMessage)
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text(error)
				]));
	} else {
		return $rtfeldman$elm_css$Html$Styled$text('');
	}
};
var $author$project$Page$AddressBook$AddFriendModal$view = F6(
	function (languageSwitchModel, status, onClose, onSubmit, newContactEmailError, newContactEmail) {
		var isLoading = _Utils_eq(status, $author$project$Type$AddressBook$Loading);
		var addressBookLanguageData = languageSwitchModel.allLanguageData.location.addressBookPage;
		return A2(
			$author$project$Material$Styled$Modal$modal,
			_List_fromArray(
				[
					$author$project$Material$Styled$Modal$open(true),
					$author$project$Material$Styled$Modal$onClose(onClose)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$AddressBook$AddFriendModal$styles.header)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$AddressBook$AddFriendModal$styles.headerText)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(addressBookLanguageData.addNewContact)
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$img,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$AddressBook$AddFriendModal$styles.icon),
									$rtfeldman$elm_css$Html$Styled$Attributes$src($author$project$View$Theme$images.close),
									$rtfeldman$elm_css$Html$Styled$Events$onClick(onClose)
								]),
							_List_Nil)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Page$AddressBook$AddFriendModal$renderErrorMessage(newContactEmailError),
							A2(
							$author$project$Material$Styled$Input$text,
							_List_fromArray(
								[
									$author$project$Material$Styled$Input$label(addressBookLanguageData.contactEmailFieldLabel),
									$author$project$Material$Styled$Input$containerStyles($author$project$Page$AddressBook$AddFriendModal$styles.input),
									$author$project$Material$Styled$Input$onInput(
									A2(
										$elm$core$Basics$composeL,
										A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnAddressBook),
										$author$project$Type$AddressBook$OnEmailInput)),
									$author$project$Material$Styled$Input$value(newContactEmail)
								]),
							_List_Nil),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$AddressBook$AddFriendModal$styles.buttonContainer)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Material$Styled$Button$button,
									_List_fromArray(
										[
											$author$project$Material$Styled$Button$theme($author$project$Material$Styled$Button$grey),
											$author$project$Material$Styled$Button$styles(
											$author$project$Page$AddressBook$AddFriendModal$styles.textButton($author$project$Material$Styled$Button$blueText)),
											$author$project$Material$Styled$Button$onClick(onSubmit),
											$author$project$Material$Styled$Button$disabled(isLoading)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											$elm$core$String$toUpper(addressBookLanguageData.sendRequestBtnText))
										])),
									A2(
									$author$project$Material$Styled$Button$button,
									_List_fromArray(
										[
											$author$project$Material$Styled$Button$theme($author$project$Material$Styled$Button$grey),
											$author$project$Material$Styled$Button$styles(
											$author$project$Page$AddressBook$AddFriendModal$styles.textButton($author$project$Material$Styled$Button$greyText)),
											$author$project$Material$Styled$Button$onClick(onClose)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(addressBookLanguageData.cancelBtn)
										]))
								]))
						]))
				]));
	});
var $author$project$Page$AddressBook$PromptBox$styles = {
	button: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginLeft(
			$rtfeldman$elm_css$Css$px(10)),
			$rtfeldman$elm_css$Css$maxWidth($rtfeldman$elm_css$Css$fitContent)
		]),
	footer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$row),
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$flexEnd),
			A3(
			$rtfeldman$elm_css$Css$padding3,
			$rtfeldman$elm_css$Css$px(20),
			$rtfeldman$elm_css$Css$zero,
			$rtfeldman$elm_css$Css$zero)
		]),
	header: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$row),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$flexStart),
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$flexEnd)
		]),
	icon: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$boxShadow($rtfeldman$elm_css$Css$none),
			$rtfeldman$elm_css$Css$transform(
			A2(
				$rtfeldman$elm_css$Css$translate2,
				$rtfeldman$elm_css$Css$px(20),
				$rtfeldman$elm_css$Css$px(-15))),
			$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer),
			$rtfeldman$elm_css$Css$padding(
			$rtfeldman$elm_css$Css$px(10))
		]),
	modalContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$vw(70)),
			$rtfeldman$elm_css$Css$maxWidth(
			$rtfeldman$elm_css$Css$px(400))
		])
};
var $author$project$Page$AddressBook$PromptBox$view = F3(
	function (onClose, onDelete, status) {
		var disable = _Utils_eq(status, $author$project$Type$AddressBook$Loading);
		return A2(
			$author$project$Material$Styled$Modal$modal,
			_List_fromArray(
				[
					$author$project$Material$Styled$Modal$open(true),
					$author$project$Material$Styled$Modal$onClose(onClose),
					$author$project$Material$Styled$Modal$contentContainerstyles($author$project$Page$AddressBook$PromptBox$styles.modalContainer)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$AddressBook$PromptBox$styles.header)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$img,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$AddressBook$PromptBox$styles.icon),
									$rtfeldman$elm_css$Html$Styled$Attributes$src($author$project$View$Theme$images.close),
									$rtfeldman$elm_css$Html$Styled$Events$onClick(onClose)
								]),
							_List_Nil)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('Do you want to delete this contact?')
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$AddressBook$PromptBox$styles.footer)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Material$Styled$Button$button,
							_List_fromArray(
								[
									$author$project$Material$Styled$Button$styles($author$project$Page$AddressBook$PromptBox$styles.button),
									function () {
									var defaultTextTheme = $author$project$Material$Styled$Button$greyText;
									return $author$project$Material$Styled$Button$theme(
										_Utils_update(
											defaultTextTheme,
											{base: $author$project$Material$Styled$Color$grey200String}));
								}(),
									$author$project$Material$Styled$Button$onClick(onClose),
									$author$project$Material$Styled$Button$disabled(disable)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Cancel')
								])),
							A2(
							$author$project$Material$Styled$Button$button,
							_List_fromArray(
								[
									$author$project$Material$Styled$Button$styles($author$project$Page$AddressBook$PromptBox$styles.button),
									$author$project$Material$Styled$Button$onClick(onDelete),
									$author$project$Material$Styled$Button$disabled(disable)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Confirm')
								]))
						]))
				]));
	});
var $author$project$Page$AddressBook$renderModal = F2(
	function (languageSwitchModel, addressBookModel) {
		var _v0 = addressBookModel;
		var newContactEmailError = _v0.newContactEmailError;
		var modal = _v0.modal;
		var newContactEmail = _v0.newContactEmail;
		switch (modal.$) {
			case 'AddFriend':
				var status = modal.a;
				return A6(
					$author$project$Page$AddressBook$AddFriendModal$view,
					languageSwitchModel,
					status,
					$author$project$Types$OnAuth(
						$author$project$Types$OnAddressBook(
							$author$project$Type$AddressBook$OnModalAction($author$project$Type$AddressBook$AllClose))),
					$author$project$Types$OnAuth(
						$author$project$Types$OnAddressBook($author$project$Type$AddressBook$OnSubmit)),
					newContactEmailError,
					newContactEmail);
			case 'DeleteFriend':
				var status = modal.a;
				var contact = modal.b;
				return A3(
					$author$project$Page$AddressBook$PromptBox$view,
					$author$project$Types$OnAuth(
						$author$project$Types$OnAddressBook(
							$author$project$Type$AddressBook$OnModalAction($author$project$Type$AddressBook$AllClose))),
					$author$project$Types$OnAuth(
						$author$project$Types$OnAddressBook(
							$author$project$Type$AddressBook$OnDelete(contact))),
					status);
			default:
				return $rtfeldman$elm_css$Html$Styled$text('');
		}
	});
var $author$project$Type$AddressBook$Pending = {$: 'Pending'};
var $author$project$Type$AddressBook$OnAccept = function (a) {
	return {$: 'OnAccept', a: a};
};
var $author$project$Type$AddressBook$OnDecline = function (a) {
	return {$: 'OnDecline', a: a};
};
var $author$project$Data$AddressBook$isInviter = function (contact) {
	return _Utils_eq(contact.user, contact.inviter);
};
var $author$project$Material$Styled$Color$black = $rtfeldman$elm_css$Css$hex($author$project$Material$Styled$Color$blackString);
var $author$project$Page$AddressBook$PendingList$styles = {
	acceptButton: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$maxWidth($rtfeldman$elm_css$Css$fitContent)
		]),
	avatarImage: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginRight(
			$rtfeldman$elm_css$Css$px(7)),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(50))
		]),
	buttonContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$row),
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceAround),
			$rtfeldman$elm_css$Css$paddingBottom(
			$rtfeldman$elm_css$Css$px(20))
		]),
	container: _List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Css$margin2,
			$rtfeldman$elm_css$Css$px(10),
			$rtfeldman$elm_css$Css$zero),
			$rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$inlineBlock),
			$rtfeldman$elm_css$Css$flexBasis(
			$rtfeldman$elm_css$Css$pct(15)),
			$rtfeldman$elm_css$Css$marginRight(
			$rtfeldman$elm_css$Css$px(40))
		]),
	header: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$padding(
			$rtfeldman$elm_css$Css$px(16))
		]),
	profile: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$row),
			$rtfeldman$elm_css$Css$flexBasis(
			$rtfeldman$elm_css$Css$pct(90))
		]),
	rejectButton: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$maxWidth($rtfeldman$elm_css$Css$fitContent),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$black)
		])
};
var $author$project$Page$AddressBook$PendingList$renderProfileDetails = function (pendingAddress) {
	var contactIsInviter = $author$project$Data$AddressBook$isInviter(pendingAddress);
	return contactIsInviter ? _List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$AddressBook$PendingList$styles.profile)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$img,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$src($author$project$View$Theme$images.person),
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$AddressBook$PendingList$styles.avatarImage)
						]),
					_List_Nil),
					$rtfeldman$elm_css$Html$Styled$text(pendingAddress.friend),
					A2($rtfeldman$elm_css$Html$Styled$br, _List_Nil, _List_Nil)
				])),
			A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$AddressBook$PendingList$styles.buttonContainer)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Material$Styled$Button$button,
					_List_fromArray(
						[
							$author$project$Material$Styled$Button$styles($author$project$Page$AddressBook$PendingList$styles.rejectButton),
							$author$project$Material$Styled$Button$theme($author$project$Material$Styled$Button$grey),
							$author$project$Material$Styled$Button$onClick(
							$author$project$Types$OnAuth(
								$author$project$Types$OnAddressBook(
									$author$project$Type$AddressBook$OnModalAction(
										A2($author$project$Type$AddressBook$DeleteFriend, $author$project$Type$AddressBook$Open, pendingAddress)))))
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('Delete Contact')
						]))
				]))
		]) : _List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$AddressBook$PendingList$styles.profile)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$img,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$src($author$project$View$Theme$images.person),
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$AddressBook$PendingList$styles.avatarImage)
						]),
					_List_Nil),
					$rtfeldman$elm_css$Html$Styled$text(pendingAddress.friendName),
					A2($rtfeldman$elm_css$Html$Styled$br, _List_Nil, _List_Nil),
					$rtfeldman$elm_css$Html$Styled$text(pendingAddress.friend)
				])),
			A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$AddressBook$PendingList$styles.buttonContainer)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Material$Styled$Button$button,
					_List_fromArray(
						[
							$author$project$Material$Styled$Button$styles($author$project$Page$AddressBook$PendingList$styles.rejectButton),
							$author$project$Material$Styled$Button$theme($author$project$Material$Styled$Button$grey),
							$author$project$Material$Styled$Button$onClick(
							$author$project$Types$OnAuth(
								$author$project$Types$OnAddressBook(
									$author$project$Type$AddressBook$OnDecline(pendingAddress))))
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('Decline')
						])),
					A2(
					$author$project$Material$Styled$Button$button,
					_List_fromArray(
						[
							$author$project$Material$Styled$Button$styles($author$project$Page$AddressBook$PendingList$styles.acceptButton),
							$author$project$Material$Styled$Button$onClick(
							$author$project$Types$OnAuth(
								$author$project$Types$OnAddressBook(
									$author$project$Type$AddressBook$OnAccept(pendingAddress))))
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('Accept')
						]))
				]))
		]);
};
var $author$project$Page$AddressBook$PendingList$view = function (contacts) {
	return A2(
		$author$project$Material$Styled$Card$card,
		_List_fromArray(
			[
				$author$project$Material$Styled$Card$containerStyles($author$project$Page$AddressBook$PendingList$styles.container)
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$AddressBook$PendingList$styles.header),
						A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'data-test', contacts.friendName)
					]),
				$author$project$Page$AddressBook$PendingList$renderProfileDetails(contacts))
			]));
};
var $author$project$Page$AddressBook$renderPending = F2(
	function (languageSwitchModel, pendingAddress) {
		var addressBookLanguageData = languageSwitchModel.allLanguageData.location.addressBookPage;
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$h2,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(addressBookLanguageData.pendingRequest)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$AddressBook$styles.contactsContainer)
						]),
					A2($elm$core$List$map, $author$project$Page$AddressBook$PendingList$view, pendingAddress)),
					A4(
					$author$project$View$Pagination$view,
					languageSwitchModel,
					function (pageSize) {
						return $author$project$Types$OnAuth(
							$author$project$Types$OnAddressBook(
								A2($author$project$Type$AddressBook$OnPageSizeChange, $author$project$Type$AddressBook$Pending, pageSize)));
					},
					$author$project$Types$OnAuth(
						$author$project$Types$OnAddressBook(
							$author$project$Type$AddressBook$PreviousPage($author$project$Type$AddressBook$Pending))),
					$author$project$Types$OnAuth(
						$author$project$Types$OnAddressBook(
							$author$project$Type$AddressBook$NextPage($author$project$Type$AddressBook$Pending))))
				]));
	});
var $author$project$Page$AddressBook$view = F2(
	function (authModel, model) {
		var addressBookLanguageData = model.languageSwitchModel.allLanguageData.location.addressBookPage;
		var _v0 = authModel;
		var addressBookModel = _v0.addressBookModel;
		var languageChangeModel = _v0.languageChangeModel;
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$AddressBook$styles.container)
				]),
			_List_fromArray(
				[
					function () {
					if (addressBookModel.$ === 'LoadingModel') {
						return A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$AddressBook$styles.heading)
										]),
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$h1,
											_List_Nil,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(addressBookLanguageData.addressBook)
												]))
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$AddressBook$styles.progressBar)
										]),
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$h2,
											_List_Nil,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text('Preparing Your Contacts.')
												])),
											A2($author$project$Material$Styled$ProgressBar$linear, _List_Nil, _List_Nil)
										]))
								]));
					} else {
						var modelState = addressBookModel.a;
						var _v2 = modelState;
						var pendingAddress = _v2.pendingAddress;
						var acceptedAddress = _v2.acceptedAddress;
						return A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$AddressBook$styles.heading)
										]),
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$h1,
											_List_Nil,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(addressBookLanguageData.addressBook)
												])),
											A2(
											$author$project$Material$Styled$Button$button,
											_List_fromArray(
												[
													$author$project$Material$Styled$Button$styles($author$project$Page$AddressBook$styles.addButton),
													$author$project$Material$Styled$Button$onClick(
													$author$project$Types$OnAuth(
														$author$project$Types$OnAddressBook(
															$author$project$Type$AddressBook$OnModalAction(
																$author$project$Type$AddressBook$AddFriend($author$project$Type$AddressBook$Open))))),
													$author$project$Material$Styled$Button$theme($author$project$Material$Styled$Button$indigo)
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(addressBookLanguageData.addFriend)
												]))
										])),
									A2($author$project$Material$Styled$Divider$divider, _List_Nil, _List_Nil),
									A2($author$project$Page$AddressBook$renderPending, model.languageSwitchModel, pendingAddress),
									A2($author$project$Material$Styled$Divider$divider, _List_Nil, _List_Nil),
									A3($author$project$Page$AddressBook$renderAccepted, model.languageSwitchModel, acceptedAddress, modelState),
									A2($author$project$Page$AddressBook$renderModal, model.languageSwitchModel, modelState)
								]));
					}
				}()
				]));
	});
var $author$project$Type$AppsumoRegister$CompanyName = {$: 'CompanyName'};
var $author$project$Type$AppsumoRegister$Email = {$: 'Email'};
var $author$project$Type$AppsumoRegister$FirstName = {$: 'FirstName'};
var $author$project$Type$AppsumoRegister$LastName = {$: 'LastName'};
var $author$project$Type$AppsumoRegister$OnAgreeTerms = {$: 'OnAgreeTerms'};
var $author$project$Type$AppsumoRegister$OnBlur = function (a) {
	return {$: 'OnBlur', a: a};
};
var $author$project$Type$AppsumoRegister$OnInput = F2(
	function (a, b) {
		return {$: 'OnInput', a: a, b: b};
	});
var $author$project$Type$AppsumoRegister$OnSubmit = {$: 'OnSubmit'};
var $author$project$Type$AppsumoRegister$Password = {$: 'Password'};
var $author$project$Type$AppsumoRegister$PasswordAgain = {$: 'PasswordAgain'};
var $author$project$Type$AppsumoRegister$ReferralCode = {$: 'ReferralCode'};
var $author$project$Type$AppsumoRegister$SubDomain = {$: 'SubDomain'};
var $author$project$Material$Styled$Checkbox$style = {
	checkbox: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$margin(
			$rtfeldman$elm_css$Css$px(10)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(20)),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(20)),
			$rtfeldman$elm_css$Css$hover(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer)
				]))
		]),
	container: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center)
		]),
	outerLayer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$Transitions$transition(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$Transitions$background(800)
				])),
			$rtfeldman$elm_css$Css$borderRadius(
			$rtfeldman$elm_css$Css$pct(100)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(40)),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(40)),
			$rtfeldman$elm_css$Css$hover(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$backgroundColor($author$project$Material$Styled$Color$grey100),
					$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer)
				])),
			$rtfeldman$elm_css$Css$active(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$backgroundColor($author$project$Material$Styled$Color$grey300),
					$rtfeldman$elm_css$Css$backgroundSize(
					$rtfeldman$elm_css$Css$pct(100)),
					$rtfeldman$elm_css$Css$Transitions$transition(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$Transitions$background(0)
						]))
				]))
		])
};
var $author$project$Material$Styled$Checkbox$defaultConfig = {checkboxAttributes: _List_Nil, containerAttributes: _List_Nil, containerStyles: $author$project$Material$Styled$Checkbox$style.container, outerlayerAttributes: _List_Nil, outerlayerStyles: $author$project$Material$Styled$Checkbox$style.outerLayer};
var $author$project$Material$Styled$Checkbox$mergeAttributes = function (config) {
	return _Utils_update(
		config,
		{
			checkboxAttributes: _Utils_ap(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$type_('checkbox'),
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Material$Styled$Checkbox$style.checkbox)
					]),
				config.checkboxAttributes),
			containerAttributes: A2(
				$elm$core$List$cons,
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_Utils_ap($author$project$Material$Styled$Checkbox$style.container, config.containerStyles)),
				config.containerAttributes),
			outerlayerAttributes: A2(
				$elm$core$List$cons,
				$rtfeldman$elm_css$Html$Styled$Attributes$css(config.outerlayerStyles),
				config.outerlayerAttributes)
		});
};
var $rtfeldman$elm_css$Html$Styled$Attributes$checked = $rtfeldman$elm_css$Html$Styled$Attributes$boolProperty('checked');
var $author$project$Material$Styled$Checkbox$mergeProperty = F2(
	function (property, config) {
		switch (property.$) {
			case 'OnClick':
				var msg = property.a;
				return _Utils_update(
					config,
					{
						outerlayerAttributes: A2(
							$elm$core$List$cons,
							$rtfeldman$elm_css$Html$Styled$Events$onClick(msg),
							config.outerlayerAttributes)
					});
			case 'Checked':
				var bool = property.a;
				return _Utils_update(
					config,
					{
						checkboxAttributes: A2(
							$elm$core$List$cons,
							$rtfeldman$elm_css$Html$Styled$Attributes$checked(bool),
							config.checkboxAttributes)
					});
			case 'ContainerStyle':
				var style_ = property.a;
				return _Utils_update(
					config,
					{
						containerStyles: _Utils_ap(config.containerStyles, style_)
					});
			default:
				var dataAttribute = property.a;
				return _Utils_update(
					config,
					{
						checkboxAttributes: A2(
							$elm$core$List$cons,
							A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'data-test', dataAttribute),
							config.checkboxAttributes)
					});
		}
	});
var $author$project$Material$Styled$Checkbox$mergeConfig = F2(
	function (config, properties) {
		return $author$project$Material$Styled$Checkbox$mergeAttributes(
			A3($elm$core$List$foldl, $author$project$Material$Styled$Checkbox$mergeProperty, config, properties));
	});
var $author$project$Material$Styled$Checkbox$checkbox = F2(
	function (properties, children) {
		var _v0 = A2($author$project$Material$Styled$Checkbox$mergeConfig, $author$project$Material$Styled$Checkbox$defaultConfig, properties);
		var outerlayerAttributes = _v0.outerlayerAttributes;
		var checkboxAttributes = _v0.checkboxAttributes;
		var containerAttributes = _v0.containerAttributes;
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			containerAttributes,
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					outerlayerAttributes,
					_List_fromArray(
						[
							A2($rtfeldman$elm_css$Html$Styled$input, checkboxAttributes, _List_Nil)
						])),
					A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, children)
				]));
	});
var $author$project$Material$Styled$Checkbox$Checked = function (a) {
	return {$: 'Checked', a: a};
};
var $author$project$Material$Styled$Checkbox$checked = function (bool) {
	return $author$project$Material$Styled$Checkbox$Checked(bool);
};
var $author$project$Material$Styled$Input$Disabled = function (a) {
	return {$: 'Disabled', a: a};
};
var $author$project$Material$Styled$Input$disabled = function (bool) {
	return $author$project$Material$Styled$Input$Disabled(bool);
};
var $author$project$Data$Api$Register$Appsumo$errorToString = function (error) {
	switch (error.$) {
		case 'INVALID_SUBDOMAIN':
			return 'SubDomain is invalid.';
		case 'INVALID_COMPANYNAME':
			return 'Company name is invalid.';
		case 'EMPTY_NAME':
			return 'Name cannot be empty.';
		case 'PASSWORD_REQUIREMENT':
			return 'Password did not meet the minimum requirement.';
		case 'USER_EXIST':
			return 'User has already exists.';
		case 'INVALID_EMAIL':
			return 'Email is not valid.';
		case 'UPDATE_ANONYMOUS':
			return 'Unable to update anonymous user account';
		case 'INVALID_CODE':
			return 'Invalid Coupon Code';
		case 'LIMIT_REACHED':
			return 'You have created too many accounts. Please try again at another time.';
		default:
			return 'We encountered an issue while processing your request. Please disable any Ad-Blocker or Tracking-Blocker and try again.';
	}
};
var $rtfeldman$elm_css$Css$flex = $rtfeldman$elm_css$Css$prop1('flex');
var $rtfeldman$elm_css$Css$fontStyle = $rtfeldman$elm_css$Css$prop1('font-style');
var $rtfeldman$elm_css$Css$italic = {fontStyle: $rtfeldman$elm_css$Css$Structure$Compatible, value: 'italic'};
var $rtfeldman$elm_css$Css$listStyleType = $rtfeldman$elm_css$Css$prop1('list-style-type');
var $author$project$Page$AppsumoRegister$styles = {
	boldText: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontWeight(
			$rtfeldman$elm_css$Css$int(1000)),
			$rtfeldman$elm_css$Css$paddingBottom(
			$rtfeldman$elm_css$Css$px(50))
		]),
	box: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(18)),
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			A2(
			$rtfeldman$elm_css$Css$padding2,
			$rtfeldman$elm_css$Css$px(20),
			$rtfeldman$elm_css$Css$px(40)),
			$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center),
			A2(
			$rtfeldman$elm_css$Css$margin2,
			$rtfeldman$elm_css$Css$px(20),
			$rtfeldman$elm_css$Css$px(0))
		]),
	businessImageBox: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center)
		]),
	businessRegister: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$backgroundColor($author$project$Material$Styled$Color$white),
			$rtfeldman$elm_css$Css$marginRight(
			$rtfeldman$elm_css$Css$px(150)),
			A2(
			$rtfeldman$elm_css$Css$Media$withMediaQuery,
			_List_fromArray(
				['screen and (max-width: 1390px)']),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$backgroundColor($author$project$Material$Styled$Color$white),
					$rtfeldman$elm_css$Css$marginRight(
					$rtfeldman$elm_css$Css$px(0))
				]))
		]),
	businessText: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontWeight(
			$rtfeldman$elm_css$Css$int(1000)),
			$rtfeldman$elm_css$Css$lineHeight(
			$rtfeldman$elm_css$Css$px(40))
		]),
	buttonContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100)),
			A2(
			$rtfeldman$elm_css$Css$margin2,
			$rtfeldman$elm_css$Css$px(16),
			$rtfeldman$elm_css$Css$zero)
		]),
	centered: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(24)),
			$rtfeldman$elm_css$Css$marginBottom(
			$rtfeldman$elm_css$Css$px(-5))
		]),
	checkboxContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(8)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100)),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(14)),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$blueGrey600)
		]),
	desktop: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100)),
			A2(
			$rtfeldman$elm_css$Css$Media$withMediaQuery,
			_List_fromArray(
				['screen and (max-width: 1024px)']),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$none)
				]))
		]),
	divider: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			A3(
				$rtfeldman$elm_css$Css$calc,
				$rtfeldman$elm_css$Css$pct(100),
				$rtfeldman$elm_css$Css$minus,
				$rtfeldman$elm_css$Css$px(48)))
		]),
	domainContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$row),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100))
		]),
	domainEndText: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$paddingTop(
			$rtfeldman$elm_css$Css$px(35))
		]),
	domainInput: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(90))
		]),
	domainText: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(12)),
			$rtfeldman$elm_css$Css$paddingLeft(
			$rtfeldman$elm_css$Css$px(10)),
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(5)),
			$rtfeldman$elm_css$Css$marginBottom(
			$rtfeldman$elm_css$Css$px(20))
		]),
	form: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			A3(
				$rtfeldman$elm_css$Css$calc,
				$rtfeldman$elm_css$Css$pct(100),
				$rtfeldman$elm_css$Css$minus,
				$rtfeldman$elm_css$Css$px(48))),
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(70))
		]),
	formError: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(16)),
			$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(14)),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$red900)
		]),
	header: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(24)),
			A2(
			$rtfeldman$elm_css$Css$padding2,
			$rtfeldman$elm_css$Css$zero,
			$rtfeldman$elm_css$Css$px(30))
		]),
	heading: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(24)),
			$rtfeldman$elm_css$Css$color(
			$rtfeldman$elm_css$Css$hex('0040ab'))
		]),
	imageStyles: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(450)),
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(20))
		]),
	informationContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$backgroundColor(
			$rtfeldman$elm_css$Css$hex('#0040ab')),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$white),
			$rtfeldman$elm_css$Css$marginLeft(
			$rtfeldman$elm_css$Css$px(150)),
			A2(
			$rtfeldman$elm_css$Css$Media$withMediaQuery,
			_List_fromArray(
				['screen and (max-width: 1390px)']),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$backgroundColor(
					$rtfeldman$elm_css$Css$hex('#0040ab')),
					$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$white),
					$rtfeldman$elm_css$Css$marginLeft(
					$rtfeldman$elm_css$Css$px(0))
				]))
		]),
	informationTextContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			A4(
			$rtfeldman$elm_css$Css$padding4,
			$rtfeldman$elm_css$Css$px(10),
			$rtfeldman$elm_css$Css$px(120),
			$rtfeldman$elm_css$Css$px(30),
			$rtfeldman$elm_css$Css$px(120)),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center)
		]),
	inputContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100)),
			$rtfeldman$elm_css$Css$marginBottom(
			$rtfeldman$elm_css$Css$px(20))
		]),
	linkContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			A3(
				$rtfeldman$elm_css$Css$calc,
				$rtfeldman$elm_css$Css$pct(100),
				$rtfeldman$elm_css$Css$minus,
				$rtfeldman$elm_css$Css$px(48))),
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(16)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(70))
		]),
	listHeaderFont: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(18))
		]),
	message: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			A3(
				$rtfeldman$elm_css$Css$calc,
				$rtfeldman$elm_css$Css$pct(100),
				$rtfeldman$elm_css$Css$minus,
				$rtfeldman$elm_css$Css$px(48))),
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(-15)),
			$rtfeldman$elm_css$Css$marginBottom(
			$rtfeldman$elm_css$Css$px(20)),
			$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$fontWeight(
			$rtfeldman$elm_css$Css$int(900)),
			$rtfeldman$elm_css$Css$color(
			$rtfeldman$elm_css$Css$hex('0040ab'))
		]),
	mobile: _List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Css$Media$withMediaQuery,
			_List_fromArray(
				['screen and (min-width: 1025px)']),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$none)
				]))
		]),
	retryContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer),
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(10))
		]),
	sideContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			$rtfeldman$elm_css$Css$flex(
			$rtfeldman$elm_css$Css$num(1)),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$em(65)),
			$rtfeldman$elm_css$Css$paddingTop(
			$rtfeldman$elm_css$Css$px(40)),
			A2(
			$rtfeldman$elm_css$Css$Media$withMediaQuery,
			_List_fromArray(
				['screen and (max-width: 1123px)']),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$height(
					$rtfeldman$elm_css$Css$em(77))
				])),
			A2(
			$rtfeldman$elm_css$Css$Media$withMediaQuery,
			_List_fromArray(
				['screen and (max-width: 1180px)']),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$height(
					$rtfeldman$elm_css$Css$em(70))
				]))
		]),
	spacing: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$paddingBottom(
			$rtfeldman$elm_css$Css$px(24))
		]),
	subPoint: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$listStyleType($rtfeldman$elm_css$Css$none),
			$rtfeldman$elm_css$Css$fontStyle($rtfeldman$elm_css$Css$italic)
		]),
	termsError: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(11)),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$red900)
		]),
	textContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(11)),
			$rtfeldman$elm_css$Css$lineHeight(
			$rtfeldman$elm_css$Css$px(13)),
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(16)),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$blueGrey600)
		])
};
var $author$project$Page$AppsumoRegister$displayFormError = function (formStatus) {
	if (formStatus.$ === 'Error') {
		var error = formStatus.a;
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$AppsumoRegister$styles.formError)
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text(
					A2($author$project$Data$Api$errorToString, $author$project$Data$Api$Register$Appsumo$errorToString, error))
				]));
	} else {
		return $rtfeldman$elm_css$Html$Styled$text('');
	}
};
var $author$project$Page$AppsumoRegister$displayTermsError = function (maybeError) {
	if (maybeError.$ === 'Nothing') {
		return $rtfeldman$elm_css$Html$Styled$text('');
	} else {
		var message = maybeError.a;
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$AppsumoRegister$styles.termsError)
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text(message)
				]));
	}
};
var $author$project$Material$Styled$Input$email = F2(
	function (properties, _v0) {
		return A2($author$project$Material$Styled$Input$input, 'email', properties);
	});
var $author$project$Material$Styled$Input$ErrorMessage = function (a) {
	return {$: 'ErrorMessage', a: a};
};
var $author$project$Material$Styled$Input$None = {$: 'None'};
var $author$project$Material$Styled$Input$errorMessage = function (message) {
	return A2(
		$elm$core$Maybe$withDefault,
		$author$project$Material$Styled$Input$None,
		A2($elm$core$Maybe$map, $author$project$Material$Styled$Input$ErrorMessage, message));
};
var $rtfeldman$elm_css$Html$Styled$form = $rtfeldman$elm_css$Html$Styled$node('form');
var $author$project$Material$Styled$Input$InfoMessage = function (a) {
	return {$: 'InfoMessage', a: a};
};
var $author$project$Material$Styled$Input$infoMessage = function (message) {
	return $author$project$Material$Styled$Input$InfoMessage(message);
};
var $author$project$Material$Styled$Input$OnBlur = function (a) {
	return {$: 'OnBlur', a: a};
};
var $author$project$Material$Styled$Input$onBlur = function (msg) {
	return $author$project$Material$Styled$Input$OnBlur(msg);
};
var $author$project$Material$Styled$Checkbox$OnClick = function (a) {
	return {$: 'OnClick', a: a};
};
var $author$project$Material$Styled$Checkbox$onClick = function (msg) {
	return $author$project$Material$Styled$Checkbox$OnClick(msg);
};
var $rtfeldman$elm_css$Html$Styled$Events$alwaysPreventDefault = function (msg) {
	return _Utils_Tuple2(msg, true);
};
var $rtfeldman$elm_css$Html$Styled$Events$onSubmit = function (msg) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$Events$preventDefaultOn,
		'submit',
		A2(
			$elm$json$Json$Decode$map,
			$rtfeldman$elm_css$Html$Styled$Events$alwaysPreventDefault,
			$elm$json$Json$Decode$succeed(msg)));
};
var $author$project$Material$Styled$Input$password = F2(
	function (properties, _v0) {
		return A2($author$project$Material$Styled$Input$input, 'password', properties);
	});
var $author$project$Page$AppsumoRegister$showValidationStatus = function (status) {
	switch (status.$) {
		case 'Validating':
			return A2($author$project$Material$Styled$ProgressBar$linear, _List_Nil, _List_Nil);
		case 'Retry':
			return A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$AppsumoRegister$styles.retryContainer),
						$rtfeldman$elm_css$Html$Styled$Events$onClick(
						$author$project$Types$OnAppsumoRegister($author$project$Type$AppsumoRegister$OnValidateDomain))
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('An error occurred, please retry.')
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$img,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$src($author$project$View$Theme$images.retry)
							]),
						_List_Nil)
					]));
		default:
			return $rtfeldman$elm_css$Html$Styled$text('');
	}
};
var $author$project$View$SubmitButton$disabled = function (label) {
	return A2(
		$author$project$Material$Styled$Button$button,
		_List_fromArray(
			[
				$author$project$Material$Styled$Button$disabled(true),
				$author$project$Material$Styled$Button$theme($author$project$Material$Styled$Button$grey)
			]),
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$text(label)
			]));
};
var $author$project$View$SubmitButton$enabled = function (label) {
	return A2(
		$author$project$Material$Styled$Button$button,
		_List_fromArray(
			[
				$author$project$Material$Styled$Button$theme($author$project$Material$Styled$Button$blue),
				$author$project$Material$Styled$Button$disabled(false)
			]),
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$text(label)
			]));
};
var $rtfeldman$elm_css$Css$overflow = $rtfeldman$elm_css$Css$prop1('overflow');
var $author$project$View$SubmitButton$submitting = function (label) {
	return A2(
		$author$project$Material$Styled$Button$button,
		_List_fromArray(
			[
				$author$project$Material$Styled$Button$disabled(true),
				$author$project$Material$Styled$Button$theme($author$project$Material$Styled$Button$blue),
				$author$project$Material$Styled$Button$styles(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$relative),
						$rtfeldman$elm_css$Css$overflow($rtfeldman$elm_css$Css$hidden)
					]))
			]),
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$text(label),
				A2(
				$author$project$Material$Styled$ProgressBar$linear,
				_List_fromArray(
					[
						$author$project$Material$Styled$ProgressBar$containerStyle(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$absolute),
								$rtfeldman$elm_css$Css$bottom($rtfeldman$elm_css$Css$zero),
								$rtfeldman$elm_css$Css$left($rtfeldman$elm_css$Css$zero)
							]))
					]),
				_List_Nil)
			]));
};
var $author$project$Page$AppsumoRegister$submitButton = function (model) {
	var hasError = A2(
		$elm$core$List$any,
		$elm$core$Basics$neq($elm$core$Maybe$Nothing),
		_List_fromArray(
			[model.companyNameError, model.firstNameError, model.lastNameError, model.emailError, model.passwordError, model.passwordAgainError, model.hasAgreedTermsError, model.referralCodeError]));
	var _v0 = model;
	var formStatus = _v0.formStatus;
	var subdomainStatus = _v0.subdomainStatus;
	var validStatus = A2(
		$elm$core$Maybe$withDefault,
		false,
		A2(
			$elm$core$Maybe$map,
			function (status) {
				return _Utils_eq(status, $author$project$Data$Api$Register$ValidateDomain$NotUse);
			},
			subdomainStatus));
	switch (formStatus.$) {
		case 'Ready':
			return (hasError || (!validStatus)) ? $author$project$View$SubmitButton$disabled('SIGN UP') : $author$project$View$SubmitButton$enabled('SIGN UP');
		case 'Error':
			return $author$project$View$SubmitButton$enabled('SIGN UP');
		default:
			return $author$project$View$SubmitButton$submitting('Registering Your Account...');
	}
};
var $author$project$Page$AppsumoRegister$businessRegister = F2(
	function (refCode, model) {
		var _v0 = model.appsumoRegisterModel;
		var formStatus = _v0.formStatus;
		var subdomain = _v0.subdomain;
		var subdomainStatus = _v0.subdomainStatus;
		var validationStatus = _v0.validationStatus;
		var redirectError = _v0.redirectError;
		var subdomainError = _v0.subdomainError;
		var companyName = _v0.companyName;
		var companyNameError = _v0.companyNameError;
		var firstName = _v0.firstName;
		var firstNameError = _v0.firstNameError;
		var lastName = _v0.lastName;
		var lastNameError = _v0.lastNameError;
		var email = _v0.email;
		var emailError = _v0.emailError;
		var password = _v0.password;
		var passwordError = _v0.passwordError;
		var passwordAgain = _v0.passwordAgain;
		var passwordAgainError = _v0.passwordAgainError;
		var hasAgreedTerms = _v0.hasAgreedTerms;
		var hasAgreedTermsError = _v0.hasAgreedTermsError;
		var referralCode = _v0.referralCode;
		var referralCodeError = _v0.referralCodeError;
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_Utils_ap($author$project$Page$AppsumoRegister$styles.sideContainer, $author$project$Page$AppsumoRegister$styles.businessRegister))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$h2,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$AppsumoRegister$styles.heading)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('AppSumo Plan Redemption')
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$AppsumoRegister$styles.message)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('Got your AppSumo coupon code handy? Great, lets get your account activated right away')
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$form,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$AppsumoRegister$styles.form),
							$rtfeldman$elm_css$Html$Styled$Events$onSubmit(
							$author$project$Types$OnAppsumoRegister($author$project$Type$AppsumoRegister$OnSubmit))
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$AppsumoRegister$styles.domainContainer)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Material$Styled$Input$text,
									_List_fromArray(
										[
											$author$project$Material$Styled$Input$containerStyles($author$project$Page$AppsumoRegister$styles.domainInput),
											$author$project$Material$Styled$Input$label('Subdomain *'),
											$author$project$Material$Styled$Input$value(subdomain),
											$author$project$Material$Styled$Input$errorMessage(subdomainError),
											$author$project$Material$Styled$Input$onInput(
											A2(
												$elm$core$Basics$composeL,
												$author$project$Types$OnAppsumoRegister,
												$author$project$Type$AppsumoRegister$OnInput($author$project$Type$AppsumoRegister$SubDomain))),
											$author$project$Material$Styled$Input$onBlur(
											$author$project$Types$OnAppsumoRegister(
												$author$project$Type$AppsumoRegister$OnBlur($author$project$Type$AppsumoRegister$SubDomain)))
										]),
									_List_Nil),
									A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$AppsumoRegister$styles.domainEndText)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('.' + model.baseHost)
										]))
								])),
							$author$project$Page$AppsumoRegister$showValidationStatus(validationStatus),
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css(
									_Utils_ap($author$project$Page$AppsumoRegister$styles.domainContainer, $author$project$Page$AppsumoRegister$styles.domainText))
								]),
							_List_fromArray(
								[
									function () {
									if (subdomainStatus.$ === 'Just') {
										var value = subdomainStatus.a;
										if (value.$ === 'NotUse') {
											return $rtfeldman$elm_css$Html$Styled$text(
												$author$project$Model$AppsumoRegister$trimRemoveSpace(subdomain) + ('.' + (model.baseHost + ' is available')));
										} else {
											return $rtfeldman$elm_css$Html$Styled$text('');
										}
									} else {
										return $rtfeldman$elm_css$Html$Styled$text('');
									}
								}()
								])),
							A2(
							$author$project$Material$Styled$Input$text,
							_List_fromArray(
								[
									$author$project$Material$Styled$Input$containerStyles($author$project$Page$AppsumoRegister$styles.inputContainer),
									$author$project$Material$Styled$Input$label('Company Name *'),
									$author$project$Material$Styled$Input$value(companyName),
									$author$project$Material$Styled$Input$errorMessage(companyNameError),
									$author$project$Material$Styled$Input$onInput(
									A2(
										$elm$core$Basics$composeL,
										$author$project$Types$OnAppsumoRegister,
										$author$project$Type$AppsumoRegister$OnInput($author$project$Type$AppsumoRegister$CompanyName))),
									$author$project$Material$Styled$Input$onBlur(
									$author$project$Types$OnAppsumoRegister(
										$author$project$Type$AppsumoRegister$OnBlur($author$project$Type$AppsumoRegister$CompanyName)))
								]),
							_List_Nil),
							A2(
							$author$project$Material$Styled$Input$text,
							_List_fromArray(
								[
									$author$project$Material$Styled$Input$containerStyles($author$project$Page$AppsumoRegister$styles.inputContainer),
									$author$project$Material$Styled$Input$label('First Name *'),
									$author$project$Material$Styled$Input$value(firstName),
									$author$project$Material$Styled$Input$errorMessage(firstNameError),
									$author$project$Material$Styled$Input$onInput(
									A2(
										$elm$core$Basics$composeL,
										$author$project$Types$OnAppsumoRegister,
										$author$project$Type$AppsumoRegister$OnInput($author$project$Type$AppsumoRegister$FirstName))),
									$author$project$Material$Styled$Input$onBlur(
									$author$project$Types$OnAppsumoRegister(
										$author$project$Type$AppsumoRegister$OnBlur($author$project$Type$AppsumoRegister$FirstName)))
								]),
							_List_Nil),
							A2(
							$author$project$Material$Styled$Input$text,
							_List_fromArray(
								[
									$author$project$Material$Styled$Input$containerStyles($author$project$Page$AppsumoRegister$styles.inputContainer),
									$author$project$Material$Styled$Input$label('Last Name *'),
									$author$project$Material$Styled$Input$value(lastName),
									$author$project$Material$Styled$Input$errorMessage(lastNameError),
									$author$project$Material$Styled$Input$onInput(
									A2(
										$elm$core$Basics$composeL,
										$author$project$Types$OnAppsumoRegister,
										$author$project$Type$AppsumoRegister$OnInput($author$project$Type$AppsumoRegister$LastName))),
									$author$project$Material$Styled$Input$onBlur(
									$author$project$Types$OnAppsumoRegister(
										$author$project$Type$AppsumoRegister$OnBlur($author$project$Type$AppsumoRegister$LastName)))
								]),
							_List_Nil),
							A2(
							$author$project$Material$Styled$Input$email,
							_List_fromArray(
								[
									$author$project$Material$Styled$Input$containerStyles($author$project$Page$AppsumoRegister$styles.inputContainer),
									$author$project$Material$Styled$Input$label('Email Address *'),
									$author$project$Material$Styled$Input$value(email),
									$author$project$Material$Styled$Input$errorMessage(emailError),
									$author$project$Material$Styled$Input$onInput(
									A2(
										$elm$core$Basics$composeL,
										$author$project$Types$OnAppsumoRegister,
										$author$project$Type$AppsumoRegister$OnInput($author$project$Type$AppsumoRegister$Email))),
									$author$project$Material$Styled$Input$onBlur(
									$author$project$Types$OnAppsumoRegister(
										$author$project$Type$AppsumoRegister$OnBlur($author$project$Type$AppsumoRegister$Email)))
								]),
							_List_Nil),
							A2(
							$author$project$Material$Styled$Input$password,
							_List_fromArray(
								[
									$author$project$Material$Styled$Input$containerStyles($author$project$Page$AppsumoRegister$styles.inputContainer),
									$author$project$Material$Styled$Input$label('Password *'),
									$author$project$Material$Styled$Input$value(password),
									$author$project$Material$Styled$Input$infoMessage('Password must contain at least 8 characters, a lowercase letter,\nan uppercase letter and a number'),
									$author$project$Material$Styled$Input$errorMessage(passwordError),
									$author$project$Material$Styled$Input$onInput(
									A2(
										$elm$core$Basics$composeL,
										$author$project$Types$OnAppsumoRegister,
										$author$project$Type$AppsumoRegister$OnInput($author$project$Type$AppsumoRegister$Password))),
									$author$project$Material$Styled$Input$onBlur(
									$author$project$Types$OnAppsumoRegister(
										$author$project$Type$AppsumoRegister$OnBlur($author$project$Type$AppsumoRegister$Password)))
								]),
							_List_Nil),
							A2(
							$author$project$Material$Styled$Input$password,
							_List_fromArray(
								[
									$author$project$Material$Styled$Input$containerStyles($author$project$Page$AppsumoRegister$styles.inputContainer),
									$author$project$Material$Styled$Input$label('Confirm Password *'),
									$author$project$Material$Styled$Input$value(passwordAgain),
									$author$project$Material$Styled$Input$errorMessage(passwordAgainError),
									$author$project$Material$Styled$Input$onInput(
									A2(
										$elm$core$Basics$composeL,
										$author$project$Types$OnAppsumoRegister,
										$author$project$Type$AppsumoRegister$OnInput($author$project$Type$AppsumoRegister$PasswordAgain))),
									$author$project$Material$Styled$Input$onBlur(
									$author$project$Types$OnAppsumoRegister(
										$author$project$Type$AppsumoRegister$OnBlur($author$project$Type$AppsumoRegister$PasswordAgain)))
								]),
							_List_Nil),
							A2(
							$author$project$Material$Styled$Input$text,
							_List_fromArray(
								[
									$author$project$Material$Styled$Input$containerStyles($author$project$Page$AppsumoRegister$styles.inputContainer),
									$author$project$Material$Styled$Input$label('Coupon Code *'),
									$author$project$Material$Styled$Input$value(referralCode),
									$author$project$Material$Styled$Input$infoMessage('Key in the redemption code you were provided after the purchase on AppSumo was complete'),
									$author$project$Material$Styled$Input$onInput(
									A2(
										$elm$core$Basics$composeL,
										$author$project$Types$OnAppsumoRegister,
										$author$project$Type$AppsumoRegister$OnInput($author$project$Type$AppsumoRegister$ReferralCode))),
									$author$project$Material$Styled$Input$errorMessage(referralCodeError),
									$author$project$Material$Styled$Input$onBlur(
									$author$project$Types$OnAppsumoRegister(
										$author$project$Type$AppsumoRegister$OnBlur($author$project$Type$AppsumoRegister$ReferralCode))),
									$author$project$Material$Styled$Input$disabled(
									function () {
										if (refCode.$ === 'Just') {
											return true;
										} else {
											return false;
										}
									}())
								]),
							_List_Nil),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$AppsumoRegister$styles.checkboxContainer)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Material$Styled$Checkbox$checkbox,
									_List_fromArray(
										[
											$author$project$Material$Styled$Checkbox$onClick(
											$author$project$Types$OnAppsumoRegister($author$project$Type$AppsumoRegister$OnAgreeTerms)),
											$author$project$Material$Styled$Checkbox$checked(hasAgreedTerms)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('I agree to the terms of service and privacy policy published '),
											A2(
											$author$project$Material$Styled$A$a,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$href('https://www.sign.net/legal/')
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text('here')
												])),
											$rtfeldman$elm_css$Html$Styled$text('.'),
											$author$project$Page$AppsumoRegister$displayTermsError(hasAgreedTermsError)
										]))
								])),
							$author$project$Page$AppsumoRegister$displayFormError(formStatus),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$AppsumoRegister$styles.formError)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									A2($elm$core$Maybe$withDefault, '', redirectError))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$AppsumoRegister$styles.buttonContainer)
								]),
							_List_fromArray(
								[
									$author$project$Page$AppsumoRegister$submitButton(model.appsumoRegisterModel)
								]))
						])),
					A2(
					$author$project$Material$Styled$Divider$divider,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$AppsumoRegister$styles.divider)
						]),
					_List_Nil),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$AppsumoRegister$styles.linkContainer)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Material$Styled$A$a,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$href($author$project$Data$Route$routeUrl.login)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Return to login')
								]))
						]))
				]));
	});
var $rtfeldman$elm_css$Html$Styled$li = $rtfeldman$elm_css$Html$Styled$node('li');
var $rtfeldman$elm_css$Html$Styled$ul = $rtfeldman$elm_css$Html$Styled$node('ul');
var $author$project$Page$AppsumoRegister$list = A2(
	$rtfeldman$elm_css$Html$Styled$div,
	_List_Nil,
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Html$Styled$ul,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$li,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_Utils_ap($author$project$Page$AppsumoRegister$styles.businessText, $author$project$Page$AppsumoRegister$styles.listHeaderFont))
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('Custom Domain for your Organisation')
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$li,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_Utils_ap($author$project$Page$AppsumoRegister$styles.subPoint, $author$project$Page$AppsumoRegister$styles.businessText))
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('https://yourcompany.sign.net')
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$li,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$AppsumoRegister$styles.businessText)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Organisation Management ')
								])),
							$rtfeldman$elm_css$Html$Styled$text('User Permissions and Corporate Representation')
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$li,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$AppsumoRegister$styles.businessText)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Document Workflow Templates Automate ')
								])),
							$rtfeldman$elm_css$Html$Styled$text('Signing Requests through PDF Forms')
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$li,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$AppsumoRegister$styles.businessText)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Organisation Document Repository ')
								])),
							$rtfeldman$elm_css$Html$Styled$text('Granular permissions for documents ')
						]))
				]))
		]));
var $author$project$Page$AppsumoRegister$listInformation = A2(
	$rtfeldman$elm_css$Html$Styled$div,
	_List_fromArray(
		[
			$rtfeldman$elm_css$Html$Styled$Attributes$css(
			_Utils_ap($author$project$Page$AppsumoRegister$styles.sideContainer, $author$project$Page$AppsumoRegister$styles.informationContainer))
		]),
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Html$Styled$h1,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$AppsumoRegister$styles.header)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('Ready to Transform Your Business Into a Powerhouse?')
						]))
				])),
			A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$AppsumoRegister$styles.businessImageBox)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$img,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$src($author$project$View$Theme$images.myCompanyWide),
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$AppsumoRegister$styles.imageStyles)
						]),
					_List_Nil),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$AppsumoRegister$styles.box)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$AppsumoRegister$styles.spacing)
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$AppsumoRegister$styles.boldText)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('Enhance ')
										])),
									$rtfeldman$elm_css$Html$Styled$text('your customer experience')
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$AppsumoRegister$styles.spacing)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Close deals '),
									A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$AppsumoRegister$styles.boldText)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('anytime, anywhere')
										]))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$AppsumoRegister$styles.spacing)
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$AppsumoRegister$styles.boldText)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('Modernise ')
										])),
									$rtfeldman$elm_css$Html$Styled$text('the agreement process')
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$AppsumoRegister$styles.boldText)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('Efficient ')
										])),
									$rtfeldman$elm_css$Html$Styled$text('and '),
									A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$AppsumoRegister$styles.boldText)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('secure ')
										])),
									$rtfeldman$elm_css$Html$Styled$text('workflows')
								]))
						]))
				])),
			A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$AppsumoRegister$styles.informationTextContainer)
				]),
			_List_fromArray(
				[
					A2($author$project$Material$Styled$Divider$divider, _List_Nil, _List_Nil),
					A2(
					$rtfeldman$elm_css$Html$Styled$h1,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$AppsumoRegister$styles.centered)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('A Comprehensive Suite of Features to Automate your Workflow Processes')
						])),
					$author$project$Page$AppsumoRegister$list
				]))
		]));
var $author$project$Page$Register$Appsumo$BusinessRegisterMobile$styles = {
	arrow: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$paddingTop(
			$rtfeldman$elm_css$Css$px(20)),
			A2(
			$rtfeldman$elm_css$Css$Media$withMediaQuery,
			_List_fromArray(
				['screen and (min-width: 700px)']),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$none)
				]))
		]),
	boldText: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontWeight(
			$rtfeldman$elm_css$Css$int(1000)),
			$rtfeldman$elm_css$Css$paddingBottom(
			$rtfeldman$elm_css$Css$px(50))
		]),
	box: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(20)),
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			A2(
			$rtfeldman$elm_css$Css$padding2,
			$rtfeldman$elm_css$Css$px(30),
			$rtfeldman$elm_css$Css$px(40)),
			$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$marginBottom(
			$rtfeldman$elm_css$Css$px(30))
		]),
	businessImageBox: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$marginBottom(
			$rtfeldman$elm_css$Css$px(0)),
			A2(
			$rtfeldman$elm_css$Css$Media$withMediaQuery,
			_List_fromArray(
				['screen and (max-width: 700px)']),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column)
				]))
		]),
	businessRegister: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$backgroundColor($author$project$Material$Styled$Color$white),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(75)),
			A2(
			$rtfeldman$elm_css$Css$Media$withMediaQuery,
			_List_fromArray(
				['screen and (max-width: 700px)']),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$width(
					$rtfeldman$elm_css$Css$pct(100))
				]))
		]),
	buttonContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100)),
			A2(
			$rtfeldman$elm_css$Css$margin2,
			$rtfeldman$elm_css$Css$px(16),
			$rtfeldman$elm_css$Css$zero)
		]),
	checkboxContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(8)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100)),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(14)),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$blueGrey600)
		]),
	container: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100)),
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column)
		]),
	divider: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			A3(
				$rtfeldman$elm_css$Css$calc,
				$rtfeldman$elm_css$Css$pct(100),
				$rtfeldman$elm_css$Css$minus,
				$rtfeldman$elm_css$Css$px(48)))
		]),
	domainContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$row),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100))
		]),
	domainEndText: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$paddingTop(
			$rtfeldman$elm_css$Css$px(35))
		]),
	domainInput: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(90))
		]),
	domainText: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(12)),
			$rtfeldman$elm_css$Css$paddingLeft(
			$rtfeldman$elm_css$Css$px(10)),
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(5)),
			$rtfeldman$elm_css$Css$marginBottom(
			$rtfeldman$elm_css$Css$px(20))
		]),
	form: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			A3(
				$rtfeldman$elm_css$Css$calc,
				$rtfeldman$elm_css$Css$pct(100),
				$rtfeldman$elm_css$Css$minus,
				$rtfeldman$elm_css$Css$px(48))),
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(65))
		]),
	formError: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(16)),
			$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(14)),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$red900)
		]),
	header: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(24)),
			A2(
			$rtfeldman$elm_css$Css$padding2,
			$rtfeldman$elm_css$Css$zero,
			$rtfeldman$elm_css$Css$px(30))
		]),
	heading: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(24)),
			$rtfeldman$elm_css$Css$color(
			$rtfeldman$elm_css$Css$hex('2d64b1'))
		]),
	imageContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(300))
		]),
	imageStyles: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(280)),
			$rtfeldman$elm_css$Css$margin(
			$rtfeldman$elm_css$Css$px(15))
		]),
	informationContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$backgroundColor(
			$rtfeldman$elm_css$Css$hex('#0040ab')),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$white),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(75)),
			$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center),
			A2(
			$rtfeldman$elm_css$Css$Media$withMediaQuery,
			_List_fromArray(
				['screen and (max-width: 700px)']),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$width(
					$rtfeldman$elm_css$Css$pct(100))
				]))
		]),
	inputContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100)),
			$rtfeldman$elm_css$Css$marginBottom(
			$rtfeldman$elm_css$Css$px(20))
		]),
	linkContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			A3(
				$rtfeldman$elm_css$Css$calc,
				$rtfeldman$elm_css$Css$pct(100),
				$rtfeldman$elm_css$Css$minus,
				$rtfeldman$elm_css$Css$px(48))),
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(16)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(65)),
			$rtfeldman$elm_css$Css$paddingBottom(
			$rtfeldman$elm_css$Css$px(30))
		]),
	message: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			A3(
				$rtfeldman$elm_css$Css$calc,
				$rtfeldman$elm_css$Css$pct(100),
				$rtfeldman$elm_css$Css$minus,
				$rtfeldman$elm_css$Css$px(48))),
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(-15)),
			$rtfeldman$elm_css$Css$marginBottom(
			$rtfeldman$elm_css$Css$px(20)),
			$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$fontWeight(
			$rtfeldman$elm_css$Css$int(900)),
			$rtfeldman$elm_css$Css$color(
			$rtfeldman$elm_css$Css$hex('2d64b1'))
		]),
	retryContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer),
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(10))
		]),
	sideContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			$rtfeldman$elm_css$Css$flex(
			$rtfeldman$elm_css$Css$num(1)),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$em(62)),
			$rtfeldman$elm_css$Css$paddingTop(
			$rtfeldman$elm_css$Css$px(40))
		]),
	spacing: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$paddingBottom(
			$rtfeldman$elm_css$Css$px(24))
		]),
	termsError: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(11)),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$red900)
		]),
	textContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(11)),
			$rtfeldman$elm_css$Css$lineHeight(
			$rtfeldman$elm_css$Css$px(13)),
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(16)),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$blueGrey600)
		])
};
var $author$project$Page$Register$Appsumo$BusinessRegisterMobile$displayFormError = function (formStatus) {
	if (formStatus.$ === 'Error') {
		var error = formStatus.a;
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Register$Appsumo$BusinessRegisterMobile$styles.formError)
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text(
					A2($author$project$Data$Api$errorToString, $author$project$Data$Api$Register$Appsumo$errorToString, error))
				]));
	} else {
		return $rtfeldman$elm_css$Html$Styled$text('');
	}
};
var $author$project$Page$Register$Appsumo$BusinessRegisterMobile$displayTermsError = function (maybeError) {
	if (maybeError.$ === 'Nothing') {
		return $rtfeldman$elm_css$Html$Styled$text('');
	} else {
		var message = maybeError.a;
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Register$Appsumo$BusinessRegisterMobile$styles.termsError)
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text(message)
				]));
	}
};
var $author$project$Page$Register$Appsumo$BusinessRegisterMobile$showValidationStatus = function (status) {
	switch (status.$) {
		case 'Validating':
			return A2($author$project$Material$Styled$ProgressBar$linear, _List_Nil, _List_Nil);
		case 'Retry':
			return A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Register$Appsumo$BusinessRegisterMobile$styles.retryContainer),
						$rtfeldman$elm_css$Html$Styled$Events$onClick(
						$author$project$Types$OnAppsumoRegister($author$project$Type$AppsumoRegister$OnValidateDomain))
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('An error occurred, please retry.')
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$img,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$src($author$project$View$Theme$images.retry)
							]),
						_List_Nil)
					]));
		default:
			return $rtfeldman$elm_css$Html$Styled$text('');
	}
};
var $author$project$Page$Register$Appsumo$BusinessRegisterMobile$submitButton = function (model) {
	var hasError = A2(
		$elm$core$List$any,
		$elm$core$Basics$neq($elm$core$Maybe$Nothing),
		_List_fromArray(
			[model.companyNameError, model.firstNameError, model.lastNameError, model.emailError, model.passwordError, model.passwordAgainError, model.hasAgreedTermsError, model.referralCodeError]));
	var _v0 = model;
	var formStatus = _v0.formStatus;
	var subdomainStatus = _v0.subdomainStatus;
	var validStatus = A2(
		$elm$core$Maybe$withDefault,
		false,
		A2(
			$elm$core$Maybe$map,
			function (status) {
				return _Utils_eq(status, $author$project$Data$Api$Register$ValidateDomain$NotUse);
			},
			subdomainStatus));
	switch (formStatus.$) {
		case 'Ready':
			return (hasError || (!validStatus)) ? $author$project$View$SubmitButton$disabled('SIGN UP') : $author$project$View$SubmitButton$enabled('SIGN UP');
		case 'Error':
			return $author$project$View$SubmitButton$enabled('SIGN UP');
		default:
			return $author$project$View$SubmitButton$submitting('Registering Your Account...');
	}
};
var $author$project$Page$Register$Appsumo$BusinessRegisterMobile$businessRegister = F2(
	function (refCode, model) {
		var _v0 = model.appsumoRegisterModel;
		var formStatus = _v0.formStatus;
		var subdomain = _v0.subdomain;
		var subdomainStatus = _v0.subdomainStatus;
		var validationStatus = _v0.validationStatus;
		var redirectError = _v0.redirectError;
		var subdomainError = _v0.subdomainError;
		var companyName = _v0.companyName;
		var companyNameError = _v0.companyNameError;
		var firstName = _v0.firstName;
		var firstNameError = _v0.firstNameError;
		var lastName = _v0.lastName;
		var lastNameError = _v0.lastNameError;
		var email = _v0.email;
		var emailError = _v0.emailError;
		var password = _v0.password;
		var passwordError = _v0.passwordError;
		var passwordAgain = _v0.passwordAgain;
		var passwordAgainError = _v0.passwordAgainError;
		var hasAgreedTerms = _v0.hasAgreedTerms;
		var hasAgreedTermsError = _v0.hasAgreedTermsError;
		var referralCode = _v0.referralCode;
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_Utils_ap($author$project$Page$Register$Appsumo$BusinessRegisterMobile$styles.sideContainer, $author$project$Page$Register$Appsumo$BusinessRegisterMobile$styles.businessRegister)),
					$rtfeldman$elm_css$Html$Styled$Attributes$id('businessRegister')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$h2,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Register$Appsumo$BusinessRegisterMobile$styles.heading)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('AppSumo Plan Redemption')
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Register$Appsumo$BusinessRegisterMobile$styles.message)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('Got your AppSumo coupon code handy? Great, lets get your account activated right away')
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$form,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Register$Appsumo$BusinessRegisterMobile$styles.form),
							$rtfeldman$elm_css$Html$Styled$Events$onSubmit(
							$author$project$Types$OnAppsumoRegister($author$project$Type$AppsumoRegister$OnSubmit))
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Register$Appsumo$BusinessRegisterMobile$styles.domainContainer)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Material$Styled$Input$text,
									_List_fromArray(
										[
											$author$project$Material$Styled$Input$containerStyles($author$project$Page$Register$Appsumo$BusinessRegisterMobile$styles.domainInput),
											$author$project$Material$Styled$Input$label('Subdomain *'),
											$author$project$Material$Styled$Input$value(subdomain),
											$author$project$Material$Styled$Input$errorMessage(subdomainError),
											$author$project$Material$Styled$Input$onInput(
											A2(
												$elm$core$Basics$composeL,
												$author$project$Types$OnAppsumoRegister,
												$author$project$Type$AppsumoRegister$OnInput($author$project$Type$AppsumoRegister$SubDomain))),
											$author$project$Material$Styled$Input$onBlur(
											$author$project$Types$OnAppsumoRegister(
												$author$project$Type$AppsumoRegister$OnBlur($author$project$Type$AppsumoRegister$SubDomain)))
										]),
									_List_Nil),
									A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Register$Appsumo$BusinessRegisterMobile$styles.domainEndText)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('.' + model.baseHost)
										]))
								])),
							$author$project$Page$Register$Appsumo$BusinessRegisterMobile$showValidationStatus(validationStatus),
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css(
									_Utils_ap($author$project$Page$Register$Appsumo$BusinessRegisterMobile$styles.domainContainer, $author$project$Page$Register$Appsumo$BusinessRegisterMobile$styles.domainText))
								]),
							_List_fromArray(
								[
									function () {
									if (subdomainStatus.$ === 'Just') {
										var value = subdomainStatus.a;
										if (value.$ === 'NotUse') {
											return $rtfeldman$elm_css$Html$Styled$text(
												$author$project$Model$BusinessRegister$trimRemoveSpace(subdomain) + ('.' + (model.baseHost + ' is available')));
										} else {
											return $rtfeldman$elm_css$Html$Styled$text('');
										}
									} else {
										return $rtfeldman$elm_css$Html$Styled$text('');
									}
								}()
								])),
							A2(
							$author$project$Material$Styled$Input$text,
							_List_fromArray(
								[
									$author$project$Material$Styled$Input$containerStyles($author$project$Page$Register$Appsumo$BusinessRegisterMobile$styles.inputContainer),
									$author$project$Material$Styled$Input$label('Company Name *'),
									$author$project$Material$Styled$Input$value(companyName),
									$author$project$Material$Styled$Input$errorMessage(companyNameError),
									$author$project$Material$Styled$Input$onInput(
									A2(
										$elm$core$Basics$composeL,
										$author$project$Types$OnAppsumoRegister,
										$author$project$Type$AppsumoRegister$OnInput($author$project$Type$AppsumoRegister$CompanyName))),
									$author$project$Material$Styled$Input$onBlur(
									$author$project$Types$OnAppsumoRegister(
										$author$project$Type$AppsumoRegister$OnBlur($author$project$Type$AppsumoRegister$CompanyName)))
								]),
							_List_Nil),
							A2(
							$author$project$Material$Styled$Input$text,
							_List_fromArray(
								[
									$author$project$Material$Styled$Input$containerStyles($author$project$Page$Register$Appsumo$BusinessRegisterMobile$styles.inputContainer),
									$author$project$Material$Styled$Input$label('First Name *'),
									$author$project$Material$Styled$Input$value(firstName),
									$author$project$Material$Styled$Input$errorMessage(firstNameError),
									$author$project$Material$Styled$Input$onInput(
									A2(
										$elm$core$Basics$composeL,
										$author$project$Types$OnAppsumoRegister,
										$author$project$Type$AppsumoRegister$OnInput($author$project$Type$AppsumoRegister$FirstName))),
									$author$project$Material$Styled$Input$onBlur(
									$author$project$Types$OnAppsumoRegister(
										$author$project$Type$AppsumoRegister$OnBlur($author$project$Type$AppsumoRegister$FirstName)))
								]),
							_List_Nil),
							A2(
							$author$project$Material$Styled$Input$text,
							_List_fromArray(
								[
									$author$project$Material$Styled$Input$containerStyles($author$project$Page$Register$Appsumo$BusinessRegisterMobile$styles.inputContainer),
									$author$project$Material$Styled$Input$label('Last Name *'),
									$author$project$Material$Styled$Input$value(lastName),
									$author$project$Material$Styled$Input$errorMessage(lastNameError),
									$author$project$Material$Styled$Input$onInput(
									A2(
										$elm$core$Basics$composeL,
										$author$project$Types$OnAppsumoRegister,
										$author$project$Type$AppsumoRegister$OnInput($author$project$Type$AppsumoRegister$LastName))),
									$author$project$Material$Styled$Input$onBlur(
									$author$project$Types$OnAppsumoRegister(
										$author$project$Type$AppsumoRegister$OnBlur($author$project$Type$AppsumoRegister$LastName)))
								]),
							_List_Nil),
							A2(
							$author$project$Material$Styled$Input$email,
							_List_fromArray(
								[
									$author$project$Material$Styled$Input$containerStyles($author$project$Page$Register$Appsumo$BusinessRegisterMobile$styles.inputContainer),
									$author$project$Material$Styled$Input$label('Email Address *'),
									$author$project$Material$Styled$Input$value(email),
									$author$project$Material$Styled$Input$errorMessage(emailError),
									$author$project$Material$Styled$Input$onInput(
									A2(
										$elm$core$Basics$composeL,
										$author$project$Types$OnAppsumoRegister,
										$author$project$Type$AppsumoRegister$OnInput($author$project$Type$AppsumoRegister$Email))),
									$author$project$Material$Styled$Input$onBlur(
									$author$project$Types$OnAppsumoRegister(
										$author$project$Type$AppsumoRegister$OnBlur($author$project$Type$AppsumoRegister$Email)))
								]),
							_List_Nil),
							A2(
							$author$project$Material$Styled$Input$password,
							_List_fromArray(
								[
									$author$project$Material$Styled$Input$containerStyles($author$project$Page$Register$Appsumo$BusinessRegisterMobile$styles.inputContainer),
									$author$project$Material$Styled$Input$label('Password *'),
									$author$project$Material$Styled$Input$value(password),
									$author$project$Material$Styled$Input$infoMessage('Password must contain at least 8 characters, a lowercase letter,\nan uppercase letter and a number'),
									$author$project$Material$Styled$Input$errorMessage(passwordError),
									$author$project$Material$Styled$Input$onInput(
									A2(
										$elm$core$Basics$composeL,
										$author$project$Types$OnAppsumoRegister,
										$author$project$Type$AppsumoRegister$OnInput($author$project$Type$AppsumoRegister$Password))),
									$author$project$Material$Styled$Input$onBlur(
									$author$project$Types$OnAppsumoRegister(
										$author$project$Type$AppsumoRegister$OnBlur($author$project$Type$AppsumoRegister$Password)))
								]),
							_List_Nil),
							A2(
							$author$project$Material$Styled$Input$password,
							_List_fromArray(
								[
									$author$project$Material$Styled$Input$containerStyles($author$project$Page$Register$Appsumo$BusinessRegisterMobile$styles.inputContainer),
									$author$project$Material$Styled$Input$label('Confirm Password *'),
									$author$project$Material$Styled$Input$value(passwordAgain),
									$author$project$Material$Styled$Input$errorMessage(passwordAgainError),
									$author$project$Material$Styled$Input$onInput(
									A2(
										$elm$core$Basics$composeL,
										$author$project$Types$OnAppsumoRegister,
										$author$project$Type$AppsumoRegister$OnInput($author$project$Type$AppsumoRegister$PasswordAgain))),
									$author$project$Material$Styled$Input$onBlur(
									$author$project$Types$OnAppsumoRegister(
										$author$project$Type$AppsumoRegister$OnBlur($author$project$Type$AppsumoRegister$PasswordAgain)))
								]),
							_List_Nil),
							A2(
							$author$project$Material$Styled$Input$text,
							_List_fromArray(
								[
									$author$project$Material$Styled$Input$containerStyles($author$project$Page$Register$Appsumo$BusinessRegisterMobile$styles.inputContainer),
									$author$project$Material$Styled$Input$label('Coupon Code'),
									$author$project$Material$Styled$Input$value(referralCode),
									$author$project$Material$Styled$Input$infoMessage('Key in the redemption code you were provided after the purchase on AppSumo was complete'),
									$author$project$Material$Styled$Input$onInput(
									A2(
										$elm$core$Basics$composeL,
										$author$project$Types$OnAppsumoRegister,
										$author$project$Type$AppsumoRegister$OnInput($author$project$Type$AppsumoRegister$ReferralCode))),
									$author$project$Material$Styled$Input$onBlur(
									$author$project$Types$OnAppsumoRegister(
										$author$project$Type$AppsumoRegister$OnBlur($author$project$Type$AppsumoRegister$ReferralCode))),
									$author$project$Material$Styled$Input$disabled(
									function () {
										if (refCode.$ === 'Just') {
											return true;
										} else {
											return false;
										}
									}())
								]),
							_List_Nil),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Register$Appsumo$BusinessRegisterMobile$styles.checkboxContainer)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Material$Styled$Checkbox$checkbox,
									_List_fromArray(
										[
											$author$project$Material$Styled$Checkbox$onClick(
											$author$project$Types$OnAppsumoRegister($author$project$Type$AppsumoRegister$OnAgreeTerms)),
											$author$project$Material$Styled$Checkbox$checked(hasAgreedTerms)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('I agree to the terms of service and privacy policy published '),
											A2(
											$author$project$Material$Styled$A$a,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$href('https://www.sign.net/legal/')
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text('here')
												])),
											$rtfeldman$elm_css$Html$Styled$text('.'),
											$author$project$Page$Register$Appsumo$BusinessRegisterMobile$displayTermsError(hasAgreedTermsError)
										]))
								])),
							$author$project$Page$Register$Appsumo$BusinessRegisterMobile$displayFormError(formStatus),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Register$Appsumo$BusinessRegisterMobile$styles.formError)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									A2($elm$core$Maybe$withDefault, '', redirectError))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Register$Appsumo$BusinessRegisterMobile$styles.buttonContainer)
								]),
							_List_fromArray(
								[
									$author$project$Page$Register$Appsumo$BusinessRegisterMobile$submitButton(model.appsumoRegisterModel)
								]))
						])),
					A2(
					$author$project$Material$Styled$Divider$divider,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Register$Appsumo$BusinessRegisterMobile$styles.divider)
						]),
					_List_Nil),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Register$Appsumo$BusinessRegisterMobile$styles.linkContainer)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Material$Styled$A$a,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$href($author$project$Data$Route$routeUrl.login)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Return to login')
								]))
						]))
				]));
	});
var $author$project$Type$AppsumoRegister$OnArrowDown = {$: 'OnArrowDown'};
var $author$project$Material$Styled$Icon$ArrowCircleDown2$view = F2(
	function (attributes, children) {
		return A2(
			$rtfeldman$elm_css$Svg$Styled$svg,
			_Utils_ap(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Svg$Styled$Attributes$fill('black'),
						$rtfeldman$elm_css$Svg$Styled$Attributes$width('24px'),
						$rtfeldman$elm_css$Svg$Styled$Attributes$height('24px'),
						$rtfeldman$elm_css$Svg$Styled$Attributes$viewBox('0 0 24 24')
					]),
				attributes),
			A2(
				$elm$core$List$cons,
				A2(
					$rtfeldman$elm_css$Svg$Styled$path,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Svg$Styled$Attributes$d('M15.08,9.59L12,12.67L8.92,9.59L7.5,11l4.5,4.5l4.5-4.5L15.08,9.59z M12,2C6.48,2,2,6.48,2,12c0,5.52,4.48,10,10,10 s10-4.48,10-10C22,6.48,17.52,2,12,2z M12,20c-4.42,0-8-3.58-8-8s3.58-8,8-8s8,3.58,8,8S16.42,20,12,20z')
						]),
					_List_Nil),
				children));
	});
var $author$project$Material$Styled$Icon$arrowCircleDown2 = $author$project$Material$Styled$Icon$ArrowCircleDown2$view;
var $author$project$Page$Register$Appsumo$BusinessRegisterMobile$listInformation = A2(
	$rtfeldman$elm_css$Html$Styled$div,
	_List_fromArray(
		[
			$rtfeldman$elm_css$Html$Styled$Attributes$css(
			_Utils_ap($author$project$Page$Register$Appsumo$BusinessRegisterMobile$styles.sideContainer, $author$project$Page$Register$Appsumo$BusinessRegisterMobile$styles.informationContainer))
		]),
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Html$Styled$h1,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Register$Appsumo$BusinessRegisterMobile$styles.header)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('Ready to Transform Your Business Into a Powerhouse?')
						]))
				])),
			A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Register$Appsumo$BusinessRegisterMobile$styles.businessImageBox)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Register$Appsumo$BusinessRegisterMobile$styles.imageContainer)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$img,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$src($author$project$View$Theme$images.myCompany),
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Register$Appsumo$BusinessRegisterMobile$styles.imageStyles)
								]),
							_List_Nil)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Register$Appsumo$BusinessRegisterMobile$styles.box)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Register$Appsumo$BusinessRegisterMobile$styles.spacing)
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Register$Appsumo$BusinessRegisterMobile$styles.boldText)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('Enhance ')
										])),
									$rtfeldman$elm_css$Html$Styled$text('your customer experience')
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Register$Appsumo$BusinessRegisterMobile$styles.spacing)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Close deals '),
									A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Register$Appsumo$BusinessRegisterMobile$styles.boldText)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('anytime, anywhere')
										]))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Register$Appsumo$BusinessRegisterMobile$styles.spacing)
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Register$Appsumo$BusinessRegisterMobile$styles.boldText)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('Modernise ')
										])),
									$rtfeldman$elm_css$Html$Styled$text('the agreement process')
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Register$Appsumo$BusinessRegisterMobile$styles.boldText)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('Efficient ')
										])),
									$rtfeldman$elm_css$Html$Styled$text('and '),
									A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Register$Appsumo$BusinessRegisterMobile$styles.boldText)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('secure ')
										])),
									$rtfeldman$elm_css$Html$Styled$text('workflows')
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Register$Appsumo$BusinessRegisterMobile$styles.arrow),
									$rtfeldman$elm_css$Html$Styled$Events$onClick(
									$author$project$Types$OnAppsumoRegister($author$project$Type$AppsumoRegister$OnArrowDown))
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Material$Styled$Icon$arrowCircleDown2,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Svg$Styled$Attributes$height('70px'),
											$rtfeldman$elm_css$Svg$Styled$Attributes$width('70px'),
											$rtfeldman$elm_css$Svg$Styled$Attributes$fill('white')
										]),
									_List_Nil)
								]))
						]))
				]))
		]));
var $author$project$Page$Register$Appsumo$BusinessRegisterMobile$view = F2(
	function (refCode, model) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Register$Appsumo$BusinessRegisterMobile$styles.container)
				]),
			_List_fromArray(
				[
					$author$project$Page$Register$Appsumo$BusinessRegisterMobile$listInformation,
					A2($author$project$Page$Register$Appsumo$BusinessRegisterMobile$businessRegister, refCode, model)
				]));
	});
var $author$project$Page$AppsumoRegister$view = F2(
	function (refCode, model) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$AppsumoRegister$styles.desktop)
						]),
					_List_fromArray(
						[
							$author$project$Page$AppsumoRegister$listInformation,
							A2($author$project$Page$AppsumoRegister$businessRegister, refCode, model)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$AppsumoRegister$styles.mobile)
						]),
					_List_fromArray(
						[
							A2($author$project$Page$Register$Appsumo$BusinessRegisterMobile$view, refCode, model)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$id('affilate')
						]),
					_List_Nil)
				]));
	});
var $author$project$Data$Api$BusinessAcceptInvite$errorToString = function (error) {
	switch (error.$) {
		case 'INVALID_TOKEN':
			return 'Token is invalid.';
		case 'TOKEN_EXPIRED':
			return 'Token has expired. Please inform the owner to resend invitation.';
		case 'USER_NOT_FOUND':
			return 'Permission denied.';
		default:
			return 'Permission denied.';
	}
};
var $author$project$Page$BusinessAcceptInvite$styles = {
	button: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(48)),
			$rtfeldman$elm_css$Css$maxWidth(
			$rtfeldman$elm_css$Css$px(300))
		]),
	card: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			A2(
			$rtfeldman$elm_css$Css$margin2,
			$rtfeldman$elm_css$Css$zero,
			$rtfeldman$elm_css$Css$px(20)),
			$rtfeldman$elm_css$Css$paddingBottom(
			$rtfeldman$elm_css$Css$px(40)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100)),
			$rtfeldman$elm_css$Css$maxWidth(
			$rtfeldman$elm_css$Css$px(600))
		]),
	container: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			A2(
			$rtfeldman$elm_css$Css$padding2,
			$rtfeldman$elm_css$Css$px(48),
			$rtfeldman$elm_css$Css$zero)
		]),
	heading: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(24)),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$blueGrey900),
			$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center)
		]),
	headingError: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(24)),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$red900),
			$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center)
		]),
	linkContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			A3(
				$rtfeldman$elm_css$Css$calc,
				$rtfeldman$elm_css$Css$pct(100),
				$rtfeldman$elm_css$Css$minus,
				$rtfeldman$elm_css$Css$px(48))),
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(16))
		]),
	logo: _List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Css$margin2,
			$rtfeldman$elm_css$Css$px(60),
			$rtfeldman$elm_css$Css$zero),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(150)),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(38))
		]),
	main: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			A3(
				$rtfeldman$elm_css$Css$calc,
				$rtfeldman$elm_css$Css$pct(100),
				$rtfeldman$elm_css$Css$minus,
				$rtfeldman$elm_css$Css$px(48))),
			A2(
			$rtfeldman$elm_css$Css$padding2,
			$rtfeldman$elm_css$Css$px(48),
			$rtfeldman$elm_css$Css$px(24)),
			$rtfeldman$elm_css$Css$boxSizing($rtfeldman$elm_css$Css$borderBox),
			A3(
			$rtfeldman$elm_css$Css$borderTop3,
			$rtfeldman$elm_css$Css$px(1),
			$rtfeldman$elm_css$Css$solid,
			$author$project$Material$Styled$Color$grey200),
			A3(
			$rtfeldman$elm_css$Css$borderBottom3,
			$rtfeldman$elm_css$Css$px(1),
			$rtfeldman$elm_css$Css$solid,
			$author$project$Material$Styled$Color$grey200)
		]),
	progressBar: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(48))
		]),
	textContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(14)),
			$rtfeldman$elm_css$Css$lineHeight(
			$rtfeldman$elm_css$Css$px(21)),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$blueGrey900),
			$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$fontWeight(
			$rtfeldman$elm_css$Css$int(400))
		])
};
var $author$project$Page$BusinessAcceptInvite$errorView = function (errorMessage) {
	return _List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Html$Styled$h2,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BusinessAcceptInvite$styles.headingError)
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text('Invitation Not Accepted')
				])),
			A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BusinessAcceptInvite$styles.textContainer)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(errorMessage)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('Please refresh the page or click on the accept invite link in your email to try again.')
						]))
				]))
		]);
};
var $author$project$Page$BusinessAcceptInvite$layout = F2(
	function (sessionModel, children) {
		var loginLink = A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BusinessAcceptInvite$styles.linkContainer)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Material$Styled$A$a,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$href($author$project$Data$Route$routeUrl.login)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('Have an account?')
						]))
				]));
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BusinessAcceptInvite$styles.container)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Material$Styled$Card$card,
					_List_fromArray(
						[
							$author$project$Material$Styled$Card$containerStyles($author$project$Page$BusinessAcceptInvite$styles.card)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$img,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$src($author$project$View$Theme$images.logoColor),
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BusinessAcceptInvite$styles.logo)
								]),
							_List_Nil),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BusinessAcceptInvite$styles.main)
								]),
							children),
							function () {
							switch (sessionModel.$) {
								case 'Auth':
									return $rtfeldman$elm_css$Html$Styled$text('');
								case 'Anonymous':
									return loginLink;
								case 'NoAuth':
									return loginLink;
								default:
									return loginLink;
							}
						}()
						]))
				]));
	});
var $author$project$Page$BusinessAcceptInvite$submittingView = _List_fromArray(
	[
		A2(
		$rtfeldman$elm_css$Html$Styled$h2,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BusinessAcceptInvite$styles.heading)
			]),
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$text('Accepting Invitation')
			])),
		A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BusinessAcceptInvite$styles.textContainer)
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$p,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('Please wait a moment while the organisation is accepting your invitation.')
					])),
				A2(
				$author$project$Material$Styled$ProgressBar$linear,
				_List_fromArray(
					[
						$author$project$Material$Styled$ProgressBar$containerStyle($author$project$Page$BusinessAcceptInvite$styles.progressBar)
					]),
				_List_Nil)
			]))
	]);
var $author$project$Page$BusinessAcceptInvite$successView = function (sessionModel) {
	var loginLink = A2(
		$author$project$Material$Styled$A$a,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$href($author$project$Data$Route$routeUrl.login)
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Material$Styled$Button$button,
				_List_fromArray(
					[
						$author$project$Material$Styled$Button$theme($author$project$Material$Styled$Button$blue),
						$author$project$Material$Styled$Button$styles($author$project$Page$BusinessAcceptInvite$styles.button)
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('Login')
					]))
			]));
	return _List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Html$Styled$h2,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BusinessAcceptInvite$styles.heading)
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text('Invitation Accepted')
				])),
			A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BusinessAcceptInvite$styles.textContainer)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('Thank you for accepting the invitation.')
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('Your account is now connected to the organisation.')
						])),
					function () {
					switch (sessionModel.$) {
						case 'Auth':
							return $rtfeldman$elm_css$Html$Styled$text('');
						case 'Anonymous':
							return loginLink;
						case 'NoAuth':
							return loginLink;
						default:
							return loginLink;
					}
				}()
				]))
		]);
};
var $author$project$Page$BusinessAcceptInvite$view = function (appModel) {
	var _v0 = appModel;
	var sessionModel = _v0.sessionModel;
	var businessAcceptInviteModel = _v0.businessAcceptInviteModel;
	return A2(
		$author$project$Page$BusinessAcceptInvite$layout,
		sessionModel,
		function () {
			if (businessAcceptInviteModel.$ === 'NoToken') {
				return $author$project$Page$BusinessAcceptInvite$errorView('The token given is invalid.');
			} else {
				var status = businessAcceptInviteModel.b;
				switch (status.$) {
					case 'Submitting':
						return $author$project$Page$BusinessAcceptInvite$submittingView;
					case 'Success':
						return $author$project$Page$BusinessAcceptInvite$successView(sessionModel);
					default:
						var error = status.a;
						return $author$project$Page$BusinessAcceptInvite$errorView(
							A2($author$project$Data$Api$errorToString, $author$project$Data$Api$BusinessAcceptInvite$errorToString, error));
				}
			}
		}());
};
var $author$project$Material$Styled$Icon$CheckCircle$view = F2(
	function (attributes, children) {
		return A2(
			$rtfeldman$elm_css$Svg$Styled$svg,
			_Utils_ap(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Svg$Styled$Attributes$fill('black'),
						$rtfeldman$elm_css$Svg$Styled$Attributes$width('24px'),
						$rtfeldman$elm_css$Svg$Styled$Attributes$height('24px'),
						$rtfeldman$elm_css$Svg$Styled$Attributes$viewBox('0 0 24 24')
					]),
				attributes),
			_Utils_ap(
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Svg$Styled$path,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Svg$Styled$Attributes$d('M0 0h24v24H0V0zm0 0h24v24H0V0z'),
								$rtfeldman$elm_css$Svg$Styled$Attributes$fill('none')
							]),
						_List_Nil),
						A2(
						$rtfeldman$elm_css$Svg$Styled$path,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Svg$Styled$Attributes$d('M16.59 7.58L10 14.17l-3.59-3.58L5 12l5 5 8-8zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z')
							]),
						_List_Nil)
					]),
				children));
	});
var $author$project$Material$Styled$Icon$checkCircle = $author$project$Material$Styled$Icon$CheckCircle$view;
var $rtfeldman$elm_css$Css$minWidth = $rtfeldman$elm_css$Css$prop1('min-width');
var $author$project$Page$BusinessCreateSuccess$styles = {
	backHomeBtn: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(48)),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(14)),
			$rtfeldman$elm_css$Css$minWidth(
			$rtfeldman$elm_css$Css$px(64))
		]),
	card: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			A2(
			$rtfeldman$elm_css$Css$margin2,
			$rtfeldman$elm_css$Css$zero,
			$rtfeldman$elm_css$Css$px(20)),
			$rtfeldman$elm_css$Css$paddingBottom(
			$rtfeldman$elm_css$Css$px(40)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100)),
			$rtfeldman$elm_css$Css$maxWidth(
			$rtfeldman$elm_css$Css$px(600))
		]),
	checkCircle: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginBottom(
			$rtfeldman$elm_css$Css$px(30))
		]),
	container: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			A2(
			$rtfeldman$elm_css$Css$padding2,
			$rtfeldman$elm_css$Css$px(48),
			$rtfeldman$elm_css$Css$zero)
		]),
	heading: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(24)),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$blueGrey900),
			$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center)
		]),
	logo: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(40)),
			$rtfeldman$elm_css$Css$marginBottom(
			$rtfeldman$elm_css$Css$px(20)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(150)),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(38))
		]),
	main: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$width(
			A3(
				$rtfeldman$elm_css$Css$calc,
				$rtfeldman$elm_css$Css$pct(100),
				$rtfeldman$elm_css$Css$minus,
				$rtfeldman$elm_css$Css$px(48))),
			$rtfeldman$elm_css$Css$padding(
			$rtfeldman$elm_css$Css$px(48)),
			$rtfeldman$elm_css$Css$boxSizing($rtfeldman$elm_css$Css$borderBox),
			A3(
			$rtfeldman$elm_css$Css$borderTop3,
			$rtfeldman$elm_css$Css$px(1),
			$rtfeldman$elm_css$Css$solid,
			$author$project$Material$Styled$Color$grey200),
			A3(
			$rtfeldman$elm_css$Css$borderBottom3,
			$rtfeldman$elm_css$Css$px(1),
			$rtfeldman$elm_css$Css$solid,
			$author$project$Material$Styled$Color$grey200)
		]),
	textContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(14)),
			$rtfeldman$elm_css$Css$lineHeight(
			$rtfeldman$elm_css$Css$px(21)),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$blueGrey900),
			$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$fontWeight(
			$rtfeldman$elm_css$Css$int(400))
		])
};
var $author$project$Page$BusinessCreateSuccess$view = A2(
	$rtfeldman$elm_css$Html$Styled$div,
	_List_fromArray(
		[
			$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BusinessCreateSuccess$styles.container)
		]),
	_List_fromArray(
		[
			A2(
			$author$project$Material$Styled$Card$card,
			_List_fromArray(
				[
					$author$project$Material$Styled$Card$containerStyles($author$project$Page$BusinessCreateSuccess$styles.card)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$img,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$src($author$project$View$Theme$images.logoColor),
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BusinessCreateSuccess$styles.logo)
						]),
					_List_Nil),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BusinessCreateSuccess$styles.main)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Material$Styled$Icon$checkCircle,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Svg$Styled$Attributes$height('100px'),
									$rtfeldman$elm_css$Svg$Styled$Attributes$width('100px'),
									$rtfeldman$elm_css$Svg$Styled$Attributes$fill('green'),
									$rtfeldman$elm_css$Svg$Styled$Attributes$css($author$project$Page$BusinessCreateSuccess$styles.checkCircle)
								]),
							_List_Nil),
							A2(
							$rtfeldman$elm_css$Html$Styled$h2,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BusinessCreateSuccess$styles.heading)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Successfully activated Business Plan')
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BusinessCreateSuccess$styles.textContainer)
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$p,
									_List_Nil,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('Congratulations! We have successfully activated your Business plan and it is ready for use immediately. Simply access it by toggling between your personal and business plans at the top right of your dashboard.'),
											A2($rtfeldman$elm_css$Html$Styled$br, _List_Nil, _List_Nil),
											A2($rtfeldman$elm_css$Html$Styled$br, _List_Nil, _List_Nil),
											$rtfeldman$elm_css$Html$Styled$text('Questions? We are standing by to provide assistance at '),
											A2(
											$rtfeldman$elm_css$Html$Styled$a,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$href('https://www.sign.net/contact-us/'),
													$rtfeldman$elm_css$Html$Styled$Attributes$target('_blank')
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text('help@sign.net')
												]))
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$a,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$href($author$project$Data$Route$routeUrl.dashboard),
											$rtfeldman$elm_css$Html$Styled$Attributes$css(
											_List_fromArray(
												[
													$rtfeldman$elm_css$Css$maxWidth($rtfeldman$elm_css$Css$fitContent)
												]))
										]),
									_List_fromArray(
										[
											A2(
											$author$project$Material$Styled$Button$button,
											_List_fromArray(
												[
													$author$project$Material$Styled$Button$styles($author$project$Page$BusinessCreateSuccess$styles.backHomeBtn)
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text('Back to Dashboard')
												]))
										]))
								]))
						]))
				]))
		]));
var $rtfeldman$elm_css$Css$flex3 = $rtfeldman$elm_css$Css$prop3('flex');
var $author$project$Page$BusinessProfile$styles = {
	banner: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexWrap($rtfeldman$elm_css$Css$wrap)
		]),
	bannerDetails: _List_fromArray(
		[
			A3(
			$rtfeldman$elm_css$Css$flex3,
			$rtfeldman$elm_css$Css$int(3),
			$rtfeldman$elm_css$Css$int(1),
			$rtfeldman$elm_css$Css$px(400)),
			A2(
			$rtfeldman$elm_css$Css$margin2,
			$rtfeldman$elm_css$Css$px(4),
			$rtfeldman$elm_css$Css$px(4))
		]),
	bannerLogo: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100)),
			$rtfeldman$elm_css$Css$maxWidth(
			$rtfeldman$elm_css$Css$px(300))
		]),
	bannerLogoBox: _List_fromArray(
		[
			A3(
			$rtfeldman$elm_css$Css$flex3,
			$rtfeldman$elm_css$Css$int(1),
			$rtfeldman$elm_css$Css$int(1),
			$rtfeldman$elm_css$Css$px(200)),
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			A2(
			$rtfeldman$elm_css$Css$margin2,
			$rtfeldman$elm_css$Css$px(4),
			$rtfeldman$elm_css$Css$px(4))
		]),
	button: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(48)),
			$rtfeldman$elm_css$Css$maxWidth(
			$rtfeldman$elm_css$Css$px(300))
		]),
	card: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			A2(
			$rtfeldman$elm_css$Css$margin2,
			$rtfeldman$elm_css$Css$zero,
			$rtfeldman$elm_css$Css$px(20)),
			$rtfeldman$elm_css$Css$paddingBottom(
			$rtfeldman$elm_css$Css$px(40)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100)),
			$rtfeldman$elm_css$Css$maxWidth(
			$rtfeldman$elm_css$Css$px(600))
		]),
	company: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100)),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(30)),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$blueGrey900),
			$rtfeldman$elm_css$Css$margin($rtfeldman$elm_css$Css$zero)
		]),
	contact: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginLeft(
			$rtfeldman$elm_css$Css$px(20)),
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(20)),
			$rtfeldman$elm_css$Css$padding(
			$rtfeldman$elm_css$Css$px(20))
		]),
	container: function (image) {
		return _List_fromArray(
			[
				$rtfeldman$elm_css$Css$displayFlex,
				$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
				$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
				$rtfeldman$elm_css$Css$minHeight(
				A3(
					$rtfeldman$elm_css$Css$calc,
					$rtfeldman$elm_css$Css$vh(100),
					$rtfeldman$elm_css$Css$minus,
					$rtfeldman$elm_css$Css$px(66))),
				$rtfeldman$elm_css$Css$height(
				$rtfeldman$elm_css$Css$pct(100)),
				$rtfeldman$elm_css$Css$boxSizing($rtfeldman$elm_css$Css$borderBox),
				A2(
				$rtfeldman$elm_css$Css$padding2,
				$rtfeldman$elm_css$Css$px(48),
				$rtfeldman$elm_css$Css$zero),
				$rtfeldman$elm_css$Css$backgroundImage(
				$rtfeldman$elm_css$Css$url(image))
			]);
	},
	description: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(20)),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(14)),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$blueGrey900),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100))
		]),
	detail: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$flexStart),
			A2(
			$rtfeldman$elm_css$Css$Media$withMediaQuery,
			_List_fromArray(
				['screen and (max-width: 700px)']),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$flexWrap($rtfeldman$elm_css$Css$wrap)
				]))
		]),
	detailCard: _List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Css$margin2,
			$rtfeldman$elm_css$Css$zero,
			$rtfeldman$elm_css$Css$px(20)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100)),
			$rtfeldman$elm_css$Css$maxWidth(
			$rtfeldman$elm_css$Css$px(800)),
			A4(
			$rtfeldman$elm_css$Css$padding4,
			$rtfeldman$elm_css$Css$px(24),
			$rtfeldman$elm_css$Css$px(24),
			$rtfeldman$elm_css$Css$px(48),
			$rtfeldman$elm_css$Css$px(24)),
			$rtfeldman$elm_css$Css$boxSizing($rtfeldman$elm_css$Css$borderBox)
		]),
	heading: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(24)),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$blueGrey900),
			$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center)
		]),
	headingError: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(24)),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$red900),
			$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center)
		]),
	linkContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			A3(
				$rtfeldman$elm_css$Css$calc,
				$rtfeldman$elm_css$Css$pct(100),
				$rtfeldman$elm_css$Css$minus,
				$rtfeldman$elm_css$Css$px(48))),
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(16))
		]),
	logo: _List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Css$margin2,
			$rtfeldman$elm_css$Css$px(60),
			$rtfeldman$elm_css$Css$zero),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(150)),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(38))
		]),
	main: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			A3(
				$rtfeldman$elm_css$Css$calc,
				$rtfeldman$elm_css$Css$pct(100),
				$rtfeldman$elm_css$Css$minus,
				$rtfeldman$elm_css$Css$px(48))),
			A2(
			$rtfeldman$elm_css$Css$padding2,
			$rtfeldman$elm_css$Css$px(48),
			$rtfeldman$elm_css$Css$px(24)),
			$rtfeldman$elm_css$Css$boxSizing($rtfeldman$elm_css$Css$borderBox)
		]),
	progressBar: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(48))
		]),
	template: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(220))
		]),
	templateActions: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$flexEnd),
			A2(
			$rtfeldman$elm_css$Css$padding2,
			$rtfeldman$elm_css$Css$px(8),
			$rtfeldman$elm_css$Css$px(8))
		]),
	templateBox: _List_fromArray(
		[
			A3(
			$rtfeldman$elm_css$Css$flex3,
			$rtfeldman$elm_css$Css$int(1),
			$rtfeldman$elm_css$Css$int(1),
			$rtfeldman$elm_css$Css$px(220)),
			$rtfeldman$elm_css$Css$padding(
			$rtfeldman$elm_css$Css$px(8)),
			$rtfeldman$elm_css$Css$boxSizing($rtfeldman$elm_css$Css$borderBox)
		]),
	templateGoButton: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$maxWidth(
			$rtfeldman$elm_css$Css$px(80))
		]),
	templateGoButtonIcon: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginRight(
			$rtfeldman$elm_css$Css$px(8))
		]),
	templateGoLink: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$textDecoration($rtfeldman$elm_css$Css$none)
		]),
	templateHeader: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$boxSizing($rtfeldman$elm_css$Css$borderBox),
			A2(
			$rtfeldman$elm_css$Css$padding2,
			$rtfeldman$elm_css$Css$px(8),
			$rtfeldman$elm_css$Css$px(8))
		]),
	templateHeaderIcon: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$marginRight(
			$rtfeldman$elm_css$Css$px(12)),
			$rtfeldman$elm_css$Css$minWidth(
			$rtfeldman$elm_css$Css$px(40)),
			$rtfeldman$elm_css$Css$minHeight(
			$rtfeldman$elm_css$Css$px(40)),
			$rtfeldman$elm_css$Css$borderRadius(
			$rtfeldman$elm_css$Css$px(20)),
			$rtfeldman$elm_css$Css$backgroundColor($author$project$Material$Styled$Color$grey400)
		]),
	templateImage: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$minHeight(
			$rtfeldman$elm_css$Css$px(150)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100)),
			$rtfeldman$elm_css$Css$backgroundColor($author$project$Material$Styled$Color$grey400)
		]),
	templateSectionHeader: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$padding(
			$rtfeldman$elm_css$Css$px(8))
		]),
	templateText: _List_fromArray(
		[
			A2($rtfeldman$elm_css$Css$property, 'display', '-webkit-box'),
			A2($rtfeldman$elm_css$Css$property, '-webkit-line-clamp', '4'),
			A2($rtfeldman$elm_css$Css$property, '-webkit-box-orient', 'vertical'),
			$rtfeldman$elm_css$Css$overflow($rtfeldman$elm_css$Css$hidden)
		]),
	templateTextBox: _List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Css$padding2,
			$rtfeldman$elm_css$Css$px(8),
			$rtfeldman$elm_css$Css$px(8))
		]),
	templateTitle: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$margin(
			$rtfeldman$elm_css$Css$px(0)),
			A2($rtfeldman$elm_css$Css$property, 'display', '-webkit-box'),
			A2($rtfeldman$elm_css$Css$property, '-webkit-line-clamp', '2'),
			A2($rtfeldman$elm_css$Css$property, '-webkit-box-orient', 'vertical'),
			$rtfeldman$elm_css$Css$overflow($rtfeldman$elm_css$Css$hidden)
		]),
	templateTitleBox: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$maxWidth(
			A3(
				$rtfeldman$elm_css$Css$calc,
				$rtfeldman$elm_css$Css$pct(100),
				$rtfeldman$elm_css$Css$minus,
				$rtfeldman$elm_css$Css$px(48))),
			$rtfeldman$elm_css$Css$flexWrap($rtfeldman$elm_css$Css$wrap)
		]),
	templates: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexWrap($rtfeldman$elm_css$Css$wrap),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center)
		]),
	text: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(16)),
			$rtfeldman$elm_css$Css$lineHeight(
			$rtfeldman$elm_css$Css$px(21)),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$blueGrey900),
			$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$fontWeight(
			$rtfeldman$elm_css$Css$int(400))
		]),
	title: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(20)),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$blueGrey900)
		])
};
var $author$project$Page$BusinessProfile$errorView = A2(
	$rtfeldman$elm_css$Html$Styled$div,
	_List_fromArray(
		[
			$rtfeldman$elm_css$Html$Styled$Attributes$css(
			$author$project$Page$BusinessProfile$styles.container('/images/signnetBannerBackground.png'))
		]),
	_List_fromArray(
		[
			A2(
			$author$project$Material$Styled$Card$card,
			_List_fromArray(
				[
					$author$project$Material$Styled$Card$containerStyles($author$project$Page$BusinessProfile$styles.card)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BusinessProfile$styles.main)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$h2,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BusinessProfile$styles.headingError)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Something went wrong')
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BusinessProfile$styles.text)
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$p,
									_List_Nil,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('Please refresh the page to try again.')
										]))
								]))
						]))
				]))
		]));
var $author$project$Type$BusinessProfile$OnRequestTemplateClick = function (a) {
	return {$: 'OnRequestTemplateClick', a: a};
};
var $rtfeldman$elm_css$Html$Styled$h4 = $rtfeldman$elm_css$Html$Styled$node('h4');
var $author$project$Material$Styled$Icon$Launch$view = F2(
	function (attributes, children) {
		return A2(
			$rtfeldman$elm_css$Svg$Styled$svg,
			_Utils_ap(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Svg$Styled$Attributes$fill('black'),
						$rtfeldman$elm_css$Svg$Styled$Attributes$width('24px'),
						$rtfeldman$elm_css$Svg$Styled$Attributes$height('24px'),
						$rtfeldman$elm_css$Svg$Styled$Attributes$viewBox('0 0 24 24')
					]),
				attributes),
			_Utils_ap(
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Svg$Styled$path,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Svg$Styled$Attributes$d('M0 0h24v24H0z'),
								$rtfeldman$elm_css$Svg$Styled$Attributes$fill('none')
							]),
						_List_Nil),
						A2(
						$rtfeldman$elm_css$Svg$Styled$path,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Svg$Styled$Attributes$d('M19 19H5V5h7V3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2v-7h-2v7zM14 3v2h3.59l-9.83 9.83 1.41 1.41L19 6.41V10h2V3h-7z')
							]),
						_List_Nil)
					]),
				children));
	});
var $author$project$Material$Styled$Icon$launch = $author$project$Material$Styled$Icon$Launch$view;
var $author$project$Material$Styled$Icon$Layers$view = F2(
	function (attributes, children) {
		return A2(
			$rtfeldman$elm_css$Svg$Styled$svg,
			_Utils_ap(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Svg$Styled$Attributes$fill('black'),
						$rtfeldman$elm_css$Svg$Styled$Attributes$width('24px'),
						$rtfeldman$elm_css$Svg$Styled$Attributes$height('24px'),
						$rtfeldman$elm_css$Svg$Styled$Attributes$viewBox('0 0 24 24')
					]),
				attributes),
			_Utils_ap(
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Svg$Styled$path,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Svg$Styled$Attributes$d('M0 0h24v24H0V0z'),
								$rtfeldman$elm_css$Svg$Styled$Attributes$fill('none')
							]),
						_List_Nil),
						A2(
						$rtfeldman$elm_css$Svg$Styled$path,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Svg$Styled$Attributes$d('M12.6 18.06c-.36.28-.87.28-1.23 0l-6.15-4.78c-.36-.28-.86-.28-1.22 0-.51.4-.51 1.17 0 1.57l6.76 5.26c.72.56 1.73.56 2.46 0l6.76-5.26c.51-.4.51-1.17 0-1.57l-.01-.01c-.36-.28-.86-.28-1.22 0l-6.15 4.79zm.63-3.02l6.76-5.26c.51-.4.51-1.18 0-1.58l-6.76-5.26c-.72-.56-1.73-.56-2.46 0L4.01 8.21c-.51.4-.51 1.18 0 1.58l6.76 5.26c.72.56 1.74.56 2.46-.01z')
							]),
						_List_Nil)
					]),
				children));
	});
var $author$project$Material$Styled$Icon$layers = $author$project$Material$Styled$Icon$Layers$view;
var $author$project$Page$BusinessProfile$displayTemplate = function (template) {
	var noOfRoles = template.noOfRoles;
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BusinessProfile$styles.templateBox)
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Material$Styled$Card$card,
				_List_fromArray(
					[
						$author$project$Material$Styled$Card$containerStyles($author$project$Page$BusinessProfile$styles.template)
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BusinessProfile$styles.templateHeader)
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BusinessProfile$styles.templateHeaderIcon)
									]),
								_List_fromArray(
									[
										A2(
										$author$project$Material$Styled$Icon$launch,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Svg$Styled$Attributes$fill($author$project$Material$Styled$Color$grey600String)
											]),
										_List_Nil)
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BusinessProfile$styles.templateTitleBox)
									]),
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$h4,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BusinessProfile$styles.templateTitle)
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(template.title)
											]))
									]))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BusinessProfile$styles.templateImage)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Material$Styled$Icon$layers,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Svg$Styled$Attributes$fill($author$project$Material$Styled$Color$grey600String),
										$rtfeldman$elm_css$Svg$Styled$Attributes$width('80px'),
										$rtfeldman$elm_css$Svg$Styled$Attributes$height('80px')
									]),
								_List_Nil)
							])),
						(noOfRoles === 1) ? A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BusinessProfile$styles.templateActions)
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BusinessProfile$styles.templateGoLink),
										$rtfeldman$elm_css$Html$Styled$Events$onClick(
										$author$project$Types$OnBusinessProfile(
											$author$project$Type$BusinessProfile$OnRequestTemplateClick(template.slug)))
									]),
								_List_fromArray(
									[
										A2(
										$author$project$Material$Styled$Button$button,
										_List_fromArray(
											[
												$author$project$Material$Styled$Button$styles($author$project$Page$BusinessProfile$styles.templateGoButton)
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('Go')
											]))
									]))
							])) : A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BusinessProfile$styles.templateActions)
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$a,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BusinessProfile$styles.templateGoLink),
										$rtfeldman$elm_css$Html$Styled$Attributes$href($author$project$Data$Route$routeUrl.fillTemplate + ('/' + template.slug))
									]),
								_List_fromArray(
									[
										A2(
										$author$project$Material$Styled$Button$button,
										_List_fromArray(
											[
												$author$project$Material$Styled$Button$styles($author$project$Page$BusinessProfile$styles.templateGoButton)
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('Go')
											]))
									]))
							]))
					]))
			]));
};
var $author$project$Page$BusinessProfile$displayTemplates = function (templates) {
	return $elm$core$List$isEmpty(templates) ? $rtfeldman$elm_css$Html$Styled$text('') : A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$h2,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BusinessProfile$styles.templateSectionHeader)
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('Forms')
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BusinessProfile$styles.templates)
					]),
				A2($elm$core$List$map, $author$project$Page$BusinessProfile$displayTemplate, templates))
			]));
};
var $rtfeldman$elm_css$Css$rowReverse = _Utils_update(
	$rtfeldman$elm_css$Css$row,
	{value: 'row-reverse'});
var $author$project$Page$BusinessProfile$Modal$styles = {
	button: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginLeft(
			$rtfeldman$elm_css$Css$px(10)),
			$rtfeldman$elm_css$Css$maxWidth(
			$rtfeldman$elm_css$Css$px(200))
		]),
	dashboardBtn: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(10)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(200))
		]),
	docStatusBtn: _List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Css$margin2,
			$rtfeldman$elm_css$Css$em(0.6),
			$rtfeldman$elm_css$Css$zero)
		]),
	footer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$row),
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceBetween),
			A3(
			$rtfeldman$elm_css$Css$padding3,
			$rtfeldman$elm_css$Css$px(20),
			$rtfeldman$elm_css$Css$zero,
			$rtfeldman$elm_css$Css$zero)
		]),
	icon: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$boxShadow($rtfeldman$elm_css$Css$none),
			$rtfeldman$elm_css$Css$transform(
			A2(
				$rtfeldman$elm_css$Css$translate2,
				$rtfeldman$elm_css$Css$px(20),
				$rtfeldman$elm_css$Css$px(-15))),
			$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer),
			$rtfeldman$elm_css$Css$padding(
			$rtfeldman$elm_css$Css$px(10))
		]),
	modalBody: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(12)),
			$rtfeldman$elm_css$Css$fontWeight(
			$rtfeldman$elm_css$Css$int(400)),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$blueGrey500)
		]),
	modalBodyContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$em(1))
		]),
	modalBtns: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$rowReverse),
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceBetween)
		]),
	modalContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$vw(70)),
			$rtfeldman$elm_css$Css$maxWidth(
			$rtfeldman$elm_css$Css$px(500))
		]),
	modalHeader: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$row),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$flexStart),
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceBetween)
		]),
	modalHeaderTxt: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(20)),
			$rtfeldman$elm_css$Css$fontWeight(
			$rtfeldman$elm_css$Css$int(500))
		]),
	progressBar: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(10))
		])
};
var $author$project$Page$BusinessProfile$Modal$loadingModal = A2(
	$author$project$Material$Styled$Modal$modal,
	_List_fromArray(
		[
			$author$project$Material$Styled$Modal$open(true),
			$author$project$Material$Styled$Modal$contentContainerstyles($author$project$Page$BusinessProfile$Modal$styles.modalContainer)
		]),
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BusinessProfile$Modal$styles.modalHeader)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BusinessProfile$Modal$styles.modalHeaderTxt)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('Loading...')
						]))
				])),
			A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BusinessProfile$Modal$styles.modalBody)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('Creating request, please wait')
						])),
					A2(
					$author$project$Material$Styled$ProgressBar$linear,
					_List_fromArray(
						[
							$author$project$Material$Styled$ProgressBar$containerStyle($author$project$Page$BusinessProfile$Modal$styles.progressBar)
						]),
					_List_Nil)
				]))
		]));
var $author$project$Type$BusinessProfile$OnCloseModal = {$: 'OnCloseModal'};
var $author$project$Type$BusinessProfile$OnRequestTemplateConfirm = function (a) {
	return {$: 'OnRequestTemplateConfirm', a: a};
};
var $author$project$Material$Styled$Button$default = {base: $author$project$Material$Styled$Color$grey100String, ripple: $author$project$Material$Styled$Color$grey300String, text: $author$project$Material$Styled$Color$blackString};
var $author$project$Page$BusinessProfile$Modal$requestTemplateModal = function (slug) {
	return A2(
		$author$project$Material$Styled$Modal$modal,
		_List_fromArray(
			[
				$author$project$Material$Styled$Modal$open(true),
				$author$project$Material$Styled$Modal$contentContainerstyles($author$project$Page$BusinessProfile$Modal$styles.modalContainer)
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BusinessProfile$Modal$styles.modalHeader)
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BusinessProfile$Modal$styles.modalHeaderTxt)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('Fill Template  Request')
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$img,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BusinessProfile$Modal$styles.icon),
								$rtfeldman$elm_css$Html$Styled$Attributes$src($author$project$View$Theme$images.close),
								$rtfeldman$elm_css$Html$Styled$Events$onClick(
								$author$project$Types$OnBusinessProfile($author$project$Type$BusinessProfile$OnCloseModal))
							]),
						_List_Nil)
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BusinessProfile$Modal$styles.modalBody)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('The following template is a single role template, please confirm if you are requesting to fill this template.')
							]))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BusinessProfile$Modal$styles.footer)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Material$Styled$Button$button,
						_List_fromArray(
							[
								$author$project$Material$Styled$Button$styles($author$project$Page$BusinessProfile$Modal$styles.dashboardBtn),
								$author$project$Material$Styled$Button$theme($author$project$Material$Styled$Button$blue),
								$author$project$Material$Styled$Button$onClick(
								$author$project$Types$OnBusinessProfile(
									$author$project$Type$BusinessProfile$OnRequestTemplateConfirm(slug)))
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('Confirm ')
							])),
						A2(
						$author$project$Material$Styled$Button$button,
						_List_fromArray(
							[
								$author$project$Material$Styled$Button$styles($author$project$Page$BusinessProfile$Modal$styles.dashboardBtn),
								$author$project$Material$Styled$Button$theme($author$project$Material$Styled$Button$default),
								$author$project$Material$Styled$Button$onClick(
								$author$project$Types$OnBusinessProfile($author$project$Type$BusinessProfile$OnCloseModal))
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('Back ')
							]))
					]))
			]));
};
var $author$project$Type$BusinessProfile$OnNavigateToDashboard = {$: 'OnNavigateToDashboard'};
var $author$project$Type$BusinessProfile$OnNavigateToDocument = function (a) {
	return {$: 'OnNavigateToDocument', a: a};
};
var $author$project$Page$BusinessProfile$Modal$requestTemplateSuccess = function (docId) {
	return A2(
		$author$project$Material$Styled$Modal$modal,
		_List_fromArray(
			[
				$author$project$Material$Styled$Modal$open(true),
				$author$project$Material$Styled$Modal$contentContainerstyles($author$project$Page$BusinessProfile$Modal$styles.modalContainer)
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BusinessProfile$Modal$styles.modalHeader)
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BusinessProfile$Modal$styles.modalHeaderTxt)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('Success')
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$img,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BusinessProfile$Modal$styles.icon),
								$rtfeldman$elm_css$Html$Styled$Attributes$src($author$project$View$Theme$images.close),
								$rtfeldman$elm_css$Html$Styled$Events$onClick(
								$author$project$Types$OnBusinessProfile($author$project$Type$BusinessProfile$OnCloseModal))
							]),
						_List_Nil)
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BusinessProfile$Modal$styles.modalBody)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('You can now sign the document from your incoming folder or access it from your email.')
							]))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BusinessProfile$Modal$styles.footer)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Material$Styled$Button$button,
						_List_fromArray(
							[
								$author$project$Material$Styled$Button$styles($author$project$Page$BusinessProfile$Modal$styles.dashboardBtn),
								$author$project$Material$Styled$Button$theme($author$project$Material$Styled$Button$blue),
								$author$project$Material$Styled$Button$onClick(
								$author$project$Types$OnBusinessProfile(
									$author$project$Type$BusinessProfile$OnNavigateToDocument(docId)))
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('Go to document ')
							])),
						A2(
						$author$project$Material$Styled$Button$button,
						_List_fromArray(
							[
								$author$project$Material$Styled$Button$styles($author$project$Page$BusinessProfile$Modal$styles.dashboardBtn),
								$author$project$Material$Styled$Button$theme($author$project$Material$Styled$Button$default),
								$author$project$Material$Styled$Button$onClick(
								$author$project$Types$OnBusinessProfile($author$project$Type$BusinessProfile$OnNavigateToDashboard))
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('Back to dashboard')
							]))
					]))
			]));
};
var $author$project$Page$BusinessProfile$Modal$view = function (model) {
	var _v0 = model.modal;
	switch (_v0.$) {
		case 'RequestTemplate':
			var slug = _v0.a;
			return $author$project$Page$BusinessProfile$Modal$requestTemplateModal(slug);
		case 'RequestTemplateSuccess':
			var docId = _v0.a;
			return $author$project$Page$BusinessProfile$Modal$requestTemplateSuccess(docId);
		case 'LoadingState':
			return $author$project$Page$BusinessProfile$Modal$loadingModal;
		default:
			return $rtfeldman$elm_css$Html$Styled$text('');
	}
};
var $author$project$Page$BusinessProfile$loadedView = F2(
	function (model, themeStatus) {
		var _v0 = model;
		var name = _v0.name;
		var title = _v0.title;
		var description = _v0.description;
		var templates = _v0.templates;
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					$author$project$Page$BusinessProfile$styles.container(
						function () {
							if (themeStatus.$ === 'Loaded') {
								var bannerBackground = themeStatus.a.bannerBackground;
								return bannerBackground;
							} else {
								return '/images/signnetBannerBackground.png';
							}
						}()))
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Material$Styled$Card$card,
					_List_fromArray(
						[
							$author$project$Material$Styled$Card$containerStyles($author$project$Page$BusinessProfile$styles.detailCard)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BusinessProfile$styles.banner)
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BusinessProfile$styles.bannerLogoBox)
										]),
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$img,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BusinessProfile$styles.bannerLogo),
													$rtfeldman$elm_css$Html$Styled$Attributes$src(
													function () {
														if (themeStatus.$ === 'Loaded') {
															var bannerLogo = themeStatus.a.bannerLogo;
															return bannerLogo;
														} else {
															return '/images/signnetBannerLogo.png';
														}
													}())
												]),
											_List_Nil)
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BusinessProfile$styles.bannerDetails)
										]),
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$h2,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BusinessProfile$styles.company)
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(name)
												])),
											A2(
											$rtfeldman$elm_css$Html$Styled$div,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BusinessProfile$styles.title)
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(title)
												])),
											A2(
											$rtfeldman$elm_css$Html$Styled$div,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BusinessProfile$styles.detail)
												]),
											_List_fromArray(
												[
													A2(
													$rtfeldman$elm_css$Html$Styled$div,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BusinessProfile$styles.description)
														]),
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$text(description)
														]))
												]))
										]))
								])),
							$author$project$Page$BusinessProfile$displayTemplates(templates),
							$author$project$Page$BusinessProfile$Modal$view(model)
						]))
				]));
	});
var $author$project$Page$BusinessProfile$loadingView = A2(
	$rtfeldman$elm_css$Html$Styled$div,
	_List_fromArray(
		[
			$rtfeldman$elm_css$Html$Styled$Attributes$css(
			$author$project$Page$BusinessProfile$styles.container('/images/signnetBannerBackground.png'))
		]),
	_List_fromArray(
		[
			A2(
			$author$project$Material$Styled$Card$card,
			_List_fromArray(
				[
					$author$project$Material$Styled$Card$containerStyles($author$project$Page$BusinessProfile$styles.card)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BusinessProfile$styles.main)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$h2,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BusinessProfile$styles.heading)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Loading')
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BusinessProfile$styles.text)
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$p,
									_List_Nil,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('Please wait a moment while we load the page.')
										])),
									A2(
									$author$project$Material$Styled$ProgressBar$linear,
									_List_fromArray(
										[
											$author$project$Material$Styled$ProgressBar$containerStyle($author$project$Page$BusinessProfile$styles.progressBar)
										]),
									_List_Nil)
								]))
						]))
				]))
		]));
var $author$project$Page$BusinessProfile$view = F2(
	function (model, _v0) {
		var theme = _v0.theme;
		var _v1 = model.loadStatus;
		switch (_v1.$) {
			case 'LoadError':
				return $author$project$Page$BusinessProfile$errorView;
			case 'Loading':
				return $author$project$Page$BusinessProfile$loadingView;
			default:
				return A2($author$project$Page$BusinessProfile$loadedView, model, theme);
		}
	});
var $author$project$Page$BusinessProfileForm$styles = {
	container: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
			A2($rtfeldman$elm_css$Css$margin2, $rtfeldman$elm_css$Css$zero, $rtfeldman$elm_css$Css$auto),
			A2(
			$rtfeldman$elm_css$Css$padding2,
			$rtfeldman$elm_css$Css$px(24),
			$rtfeldman$elm_css$Css$px(24)),
			$rtfeldman$elm_css$Css$maxWidth(
			$rtfeldman$elm_css$Css$px(800))
		]),
	rightContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$flexStart)
		]),
	spacer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100)),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(20))
		])
};
var $author$project$Type$BusinessProfile$OnCopyOrgReferralCodeClick = F2(
	function (a, b) {
		return {$: 'OnCopyOrgReferralCodeClick', a: a, b: b};
	});
var $author$project$Material$Styled$Snackbar$Status = function (a) {
	return {$: 'Status', a: a};
};
var $author$project$Material$Styled$Snackbar$Theme = function (a) {
	return {$: 'Theme', a: a};
};
var $author$project$Material$Styled$Snackbar$Timeout = function (a) {
	return {$: 'Timeout', a: a};
};
var $author$project$Material$Styled$Icon$CopyReferralCode$view = F2(
	function (attributes, children) {
		return A2(
			$rtfeldman$elm_css$Svg$Styled$svg,
			_Utils_ap(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Svg$Styled$Attributes$fill('white'),
						$rtfeldman$elm_css$Svg$Styled$Attributes$width('24px'),
						$rtfeldman$elm_css$Svg$Styled$Attributes$height('24px'),
						$rtfeldman$elm_css$Svg$Styled$Attributes$viewBox('0 0 24 24')
					]),
				attributes),
			_Utils_ap(
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Svg$Styled$path,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Svg$Styled$Attributes$d('M0 0h24v24H0V0z'),
								$rtfeldman$elm_css$Svg$Styled$Attributes$fill('none')
							]),
						_List_Nil),
						A2(
						$rtfeldman$elm_css$Svg$Styled$path,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Svg$Styled$Attributes$d('M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H8V7h11v14z')
							]),
						_List_Nil)
					]),
				children));
	});
var $author$project$Material$Styled$Icon$copyReferralCode = $author$project$Material$Styled$Icon$CopyReferralCode$view;
var $author$project$Material$Styled$Color$tealA400String = '#1de9b6';
var $author$project$Material$Styled$Color$tealA400 = $rtfeldman$elm_css$Css$hex($author$project$Material$Styled$Color$tealA400String);
var $author$project$Material$Styled$Snackbar$secondary = {base: $author$project$Material$Styled$Color$tealA400, text: $author$project$Material$Styled$Color$black};
var $author$project$Material$Styled$Snackbar$primary = {base: $author$project$Material$Styled$Color$blueA700, text: $author$project$Material$Styled$Color$white};
var $author$project$Material$Styled$Snackbar$popIn = $rtfeldman$elm_css$Css$Animations$keyframes(
	_List_fromArray(
		[
			_Utils_Tuple2(
			0,
			_List_fromArray(
				[
					A2($rtfeldman$elm_css$Css$Animations$property, 'opacity', '0'),
					A2($rtfeldman$elm_css$Css$Animations$property, 'transform', 'translate(0, 0px)')
				])),
			_Utils_Tuple2(
			10,
			_List_fromArray(
				[
					A2($rtfeldman$elm_css$Css$Animations$property, 'opacity', '1'),
					A2($rtfeldman$elm_css$Css$Animations$property, 'transform', 'translate(0, 10px)')
				])),
			_Utils_Tuple2(
			90,
			_List_fromArray(
				[
					A2($rtfeldman$elm_css$Css$Animations$property, 'opacity', '1'),
					A2($rtfeldman$elm_css$Css$Animations$property, 'transform', 'translate(0, 10px)')
				])),
			_Utils_Tuple2(
			100,
			_List_fromArray(
				[
					A2($rtfeldman$elm_css$Css$Animations$property, 'opacity', '0'),
					A2($rtfeldman$elm_css$Css$Animations$property, 'display', 'none'),
					A2($rtfeldman$elm_css$Css$Animations$property, 'transform', 'translate(0, 0px)')
				]))
		]));
var $author$project$Material$Styled$Snackbar$style = F2(
	function (theme, timeout) {
		return {
			container: _List_fromArray(
				[
					$rtfeldman$elm_css$Css$displayFlex,
					$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$fixed),
					$rtfeldman$elm_css$Css$backgroundColor(theme.base),
					$rtfeldman$elm_css$Css$opacity(
					$rtfeldman$elm_css$Css$num(0)),
					$rtfeldman$elm_css$Css$left(
					$rtfeldman$elm_css$Css$px(24)),
					$rtfeldman$elm_css$Css$top(
					$rtfeldman$elm_css$Css$vh(5)),
					$rtfeldman$elm_css$Css$minHeight(
					$rtfeldman$elm_css$Css$px(48)),
					A4(
					$rtfeldman$elm_css$Css$padding4,
					$rtfeldman$elm_css$Css$px(0),
					$rtfeldman$elm_css$Css$px(24),
					$rtfeldman$elm_css$Css$px(0),
					$rtfeldman$elm_css$Css$px(24)),
					$rtfeldman$elm_css$Css$borderRadius(
					$rtfeldman$elm_css$Css$px(5)),
					$rtfeldman$elm_css$Css$zIndex(
					$rtfeldman$elm_css$Css$int(2)),
					$rtfeldman$elm_css$Css$animationName($author$project$Material$Styled$Snackbar$popIn),
					$rtfeldman$elm_css$Css$animationDuration(
					$rtfeldman$elm_css$Css$sec(timeout)),
					A2($rtfeldman$elm_css$Css$property, 'animation-iteration-count', '1')
				]),
			container2: _List_fromArray(
				[
					$rtfeldman$elm_css$Css$displayFlex,
					$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$fixed),
					$rtfeldman$elm_css$Css$backgroundColor(theme.base),
					$rtfeldman$elm_css$Css$opacity(
					$rtfeldman$elm_css$Css$num(0)),
					$rtfeldman$elm_css$Css$left(
					$rtfeldman$elm_css$Css$pct(50)),
					$rtfeldman$elm_css$Css$top(
					$rtfeldman$elm_css$Css$vh(5)),
					$rtfeldman$elm_css$Css$minHeight(
					$rtfeldman$elm_css$Css$px(48)),
					A4(
					$rtfeldman$elm_css$Css$padding4,
					$rtfeldman$elm_css$Css$px(0),
					$rtfeldman$elm_css$Css$px(24),
					$rtfeldman$elm_css$Css$px(0),
					$rtfeldman$elm_css$Css$px(24)),
					$rtfeldman$elm_css$Css$borderRadius(
					$rtfeldman$elm_css$Css$px(5)),
					$rtfeldman$elm_css$Css$zIndex(
					$rtfeldman$elm_css$Css$int(2)),
					$rtfeldman$elm_css$Css$animationName($author$project$Material$Styled$Snackbar$popIn),
					$rtfeldman$elm_css$Css$animationDuration(
					$rtfeldman$elm_css$Css$sec(timeout)),
					A2($rtfeldman$elm_css$Css$property, 'animation-iteration-count', '1')
				]),
			content: _List_fromArray(
				[
					$rtfeldman$elm_css$Css$color(theme.text),
					A2(
					$rtfeldman$elm_css$Css$margin2,
					$rtfeldman$elm_css$Css$auto,
					$rtfeldman$elm_css$Css$px(0)),
					A2(
					$rtfeldman$elm_css$Css$padding2,
					$rtfeldman$elm_css$Css$px(8),
					$rtfeldman$elm_css$Css$px(0)),
					$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center),
					$rtfeldman$elm_css$Css$fontWeight(
					$rtfeldman$elm_css$Css$int(500))
				])
		};
	});
var $author$project$Material$Styled$Snackbar$defaultConfig = function () {
	var defaultStyle = A2($author$project$Material$Styled$Snackbar$style, $author$project$Material$Styled$Snackbar$primary, 3);
	return {containerStyles: _List_Nil, contentStyles: _List_Nil, snackbarAttributes: _List_Nil, status: $author$project$Material$Styled$Snackbar$Hide, theme: $author$project$Material$Styled$Snackbar$primary, timeout: 3};
}();
var $author$project$Material$Styled$Snackbar$mergeStyles = function (config) {
	var defaultStyle = A2($author$project$Material$Styled$Snackbar$style, config.theme, config.timeout);
	var updatedStyle = _Utils_update(
		defaultStyle,
		{
			container: _Utils_ap(defaultStyle.container, config.containerStyles),
			content: _Utils_ap(defaultStyle.content, config.contentStyles)
		});
	return _Utils_update(
		config,
		{
			containerStyles: updatedStyle.container,
			contentStyles: updatedStyle.content,
			snackbarAttributes: A2(
				$elm$core$List$cons,
				$rtfeldman$elm_css$Html$Styled$Attributes$css(updatedStyle.container),
				config.snackbarAttributes)
		});
};
var $author$project$Material$Styled$Snackbar$updateProperty = F2(
	function (property, config) {
		switch (property.$) {
			case 'Theme':
				var newTheme = property.a;
				return _Utils_update(
					config,
					{theme: newTheme});
			case 'Timeout':
				var timer = property.a;
				return _Utils_update(
					config,
					{timeout: timer});
			case 'ContainerStyles':
				var styles_ = property.a;
				return _Utils_update(
					config,
					{containerStyles: styles_});
			case 'ContentStyles':
				var styles_ = property.a;
				return _Utils_update(
					config,
					{contentStyles: styles_});
			default:
				var status = property.a;
				return _Utils_update(
					config,
					{status: status});
		}
	});
var $author$project$Material$Styled$Snackbar$mergeConfig = F2(
	function (defaultConfig_, properties) {
		return $author$project$Material$Styled$Snackbar$mergeStyles(
			A3($elm$core$List$foldl, $author$project$Material$Styled$Snackbar$updateProperty, defaultConfig_, properties));
	});
var $author$project$Material$Styled$Snackbar$snackbar = F2(
	function (properties, children) {
		var config = A2($author$project$Material$Styled$Snackbar$mergeConfig, $author$project$Material$Styled$Snackbar$defaultConfig, properties);
		var _v0 = config.status;
		if (_v0.$ === 'Show') {
			return A2(
				$rtfeldman$elm_css$Html$Styled$div,
				config.snackbarAttributes,
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css(config.contentStyles)
							]),
						children)
					]));
		} else {
			return $rtfeldman$elm_css$Html$Styled$text('');
		}
	});
var $author$project$Page$BusinessProfile$BusinessReferralCode$styles = {
	anotherContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexWrap($rtfeldman$elm_css$Css$wrap),
			A2(
			$rtfeldman$elm_css$Css$Media$withMediaQuery,
			_List_fromArray(
				['screen and (max-width: 675px)']),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center)
				]))
		]),
	buttonStyle: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(37)),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(53)),
			A2(
			$rtfeldman$elm_css$Css$padding2,
			$rtfeldman$elm_css$Css$px(7),
			$rtfeldman$elm_css$Css$px(7)),
			$rtfeldman$elm_css$Css$marginLeft(
			$rtfeldman$elm_css$Css$px(10)),
			A2(
			$rtfeldman$elm_css$Css$Media$withMediaQuery,
			_List_fromArray(
				['screen and (max-width: 675px)']),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$width(
					$rtfeldman$elm_css$Css$pct(92)),
					$rtfeldman$elm_css$Css$marginBottom(
					$rtfeldman$elm_css$Css$px(20)),
					$rtfeldman$elm_css$Css$height(
					$rtfeldman$elm_css$Css$px(48)),
					$rtfeldman$elm_css$Css$marginLeft(
					$rtfeldman$elm_css$Css$px(0))
				]))
		]),
	contentContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			A4(
			$rtfeldman$elm_css$Css$padding4,
			$rtfeldman$elm_css$Css$px(30),
			$rtfeldman$elm_css$Css$px(20),
			$rtfeldman$elm_css$Css$px(10),
			$rtfeldman$elm_css$Css$px(20))
		]),
	inputContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginBottom(
			$rtfeldman$elm_css$Css$px(20)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(93)),
			A2(
			$rtfeldman$elm_css$Css$Media$withMediaQuery,
			_List_fromArray(
				['screen and (max-width: 760px)']),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$width(
					$rtfeldman$elm_css$Css$pct(92))
				]))
		])
};
var $author$project$Page$BusinessProfile$BusinessReferralCode$copyReferralCode = F4(
	function (model, referralCode, title, timeout) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BusinessProfile$BusinessReferralCode$styles.anotherContainer)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Material$Styled$Input$text,
					_List_fromArray(
						[
							$author$project$Material$Styled$Input$label(title),
							$author$project$Material$Styled$Input$containerStyles($author$project$Page$BusinessProfile$BusinessReferralCode$styles.inputContainer),
							$author$project$Material$Styled$Input$value(referralCode),
							$author$project$Material$Styled$Input$disabled(true)
						]),
					_List_Nil),
					A2(
					$author$project$Material$Styled$Button$button,
					_List_fromArray(
						[
							$author$project$Material$Styled$Button$styles($author$project$Page$BusinessProfile$BusinessReferralCode$styles.buttonStyle),
							$author$project$Material$Styled$Button$onClick(
							$author$project$Types$OnBusinessProfile(
								A2($author$project$Type$BusinessProfile$OnCopyOrgReferralCodeClick, referralCode, timeout)))
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Material$Styled$Snackbar$snackbar,
							_List_fromArray(
								[
									$author$project$Material$Styled$Snackbar$Theme($author$project$Material$Styled$Snackbar$secondary),
									$author$project$Material$Styled$Snackbar$Timeout(timeout),
									$author$project$Material$Styled$Snackbar$Status(model.referralCodeSnackBarStatus)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Copied to Clipboard')
								])),
							A2($author$project$Material$Styled$Icon$copyReferralCode, _List_Nil, _List_Nil)
						]))
				]));
	});
var $author$project$Page$BusinessProfile$BusinessReferralCode$view = F2(
	function (appDomain, model) {
		var timeout = 3;
		var organisationPageLanguageData = model.languageSwitchModel.allLanguageData.location.myOrganisationPage;
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$h2,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(organisationPageLanguageData.organisationReferralCode)
						])),
					A2(
					$author$project$Material$Styled$Card$card,
					_List_fromArray(
						[
							$author$project$Material$Styled$Card$containerStyles($author$project$Page$BusinessProfile$BusinessReferralCode$styles.contentContainer)
						]),
					_List_fromArray(
						[
							A4($author$project$Page$BusinessProfile$BusinessReferralCode$copyReferralCode, model.businessProfileModel, model.businessProfileModel.shareReferralCode, organisationPageLanguageData.organisationReferralCode, timeout),
							A4($author$project$Page$BusinessProfile$BusinessReferralCode$copyReferralCode, model.businessProfileModel, 'http://' + (appDomain + ($author$project$Data$Route$routeUrl.businessRegister + ('?ref=' + model.businessProfileModel.shareReferralCode))), organisationPageLanguageData.shareLinkBusinessAccount, timeout),
							A4($author$project$Page$BusinessProfile$BusinessReferralCode$copyReferralCode, model.businessProfileModel, 'http://' + (appDomain + ($author$project$Data$Route$routeUrl.personalRegister + ('?ref=' + model.businessProfileModel.shareReferralCode))), organisationPageLanguageData.shareLinkPersonalAccount, timeout)
						]))
				]));
	});
var $author$project$Type$BusinessUser$OnAddButtonClick = {$: 'OnAddButtonClick'};
var $author$project$Type$BusinessUser$OnCouponCodeInput = F2(
	function (a, b) {
		return {$: 'OnCouponCodeInput', a: a, b: b};
	});
var $author$project$Type$BusinessUser$OnCouponRedeemSubmit = {$: 'OnCouponRedeemSubmit'};
var $author$project$Type$BusinessUser$OnRemoveCouponInput = function (a) {
	return {$: 'OnRemoveCouponInput', a: a};
};
var $author$project$Type$BusinessUser$OnCouponCodeBannerClose = {$: 'OnCouponCodeBannerClose'};
var $author$project$Material$Styled$Color$green400String = '#66BB6A';
var $author$project$Material$Styled$Color$green400 = $rtfeldman$elm_css$Css$hex($author$project$Material$Styled$Color$green400String);
var $author$project$Material$Styled$Banner$successTheme = {background: $author$project$Material$Styled$Color$green400, closeIcon: 'white', text: $author$project$Material$Styled$Color$white};
var $author$project$Page$BusinessProfile$CouponCode$displayBanner = function (status) {
	switch (status.$) {
		case 'Pass':
			return A2(
				$author$project$Material$Styled$Banner$banner,
				_List_fromArray(
					[
						$author$project$Material$Styled$Banner$theme($author$project$Material$Styled$Banner$successTheme),
						$author$project$Material$Styled$Banner$title('Success'),
						$author$project$Material$Styled$Banner$body(
						$rtfeldman$elm_css$Html$Styled$text('Coupon code has been redeemed successfully.')),
						$author$project$Material$Styled$Banner$closeIconAttributes(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Svg$Styled$Events$onClick(
								$author$project$Types$OnAuth(
									$author$project$Types$OnBusinessUser($author$project$Type$BusinessUser$OnCouponCodeBannerClose)))
							]))
					]),
				_List_Nil);
		case 'Fail':
			var error = status.a;
			return A2(
				$author$project$Material$Styled$Banner$banner,
				_List_fromArray(
					[
						$author$project$Material$Styled$Banner$theme($author$project$Material$Styled$Banner$errorTheme),
						$author$project$Material$Styled$Banner$title('Error'),
						$author$project$Material$Styled$Banner$body(
						$rtfeldman$elm_css$Html$Styled$text(error)),
						$author$project$Material$Styled$Banner$closeIconAttributes(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Svg$Styled$Events$onClick(
								$author$project$Types$OnAuth(
									$author$project$Types$OnBusinessUser($author$project$Type$BusinessUser$OnCouponCodeBannerClose)))
							]))
					]),
				_List_Nil);
		default:
			return $rtfeldman$elm_css$Html$Styled$text('');
	}
};
var $author$project$Page$BusinessProfile$CouponCode$styles = {
	anotherContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexWrap($rtfeldman$elm_css$Css$wrap),
			A2(
			$rtfeldman$elm_css$Css$Media$withMediaQuery,
			_List_fromArray(
				['screen and (max-width: 675px)']),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center)
				]))
		]),
	button: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(48))
		]),
	buttonContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(0)),
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$row),
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceBetween)
		]),
	buttonStyle: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(37)),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(53)),
			A2(
			$rtfeldman$elm_css$Css$padding2,
			$rtfeldman$elm_css$Css$px(7),
			$rtfeldman$elm_css$Css$px(7)),
			$rtfeldman$elm_css$Css$marginLeft(
			$rtfeldman$elm_css$Css$px(10)),
			A2(
			$rtfeldman$elm_css$Css$Media$withMediaQuery,
			_List_fromArray(
				['screen and (max-width: 675px)']),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$width(
					$rtfeldman$elm_css$Css$pct(92)),
					$rtfeldman$elm_css$Css$marginBottom(
					$rtfeldman$elm_css$Css$px(20)),
					$rtfeldman$elm_css$Css$height(
					$rtfeldman$elm_css$Css$px(48)),
					$rtfeldman$elm_css$Css$marginLeft(
					$rtfeldman$elm_css$Css$px(0))
				]))
		]),
	contentContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			A4(
			$rtfeldman$elm_css$Css$padding4,
			$rtfeldman$elm_css$Css$px(30),
			$rtfeldman$elm_css$Css$px(20),
			$rtfeldman$elm_css$Css$px(10),
			$rtfeldman$elm_css$Css$px(20))
		]),
	inputContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginBottom(
			$rtfeldman$elm_css$Css$px(20)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(93)),
			A2(
			$rtfeldman$elm_css$Css$Media$withMediaQuery,
			_List_fromArray(
				['screen and (max-width: 760px)']),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$width(
					$rtfeldman$elm_css$Css$pct(92))
				]))
		])
};
var $author$project$Page$BusinessProfile$CouponCode$view = F2(
	function (businessProfileModel, businessUserModel) {
		return _Utils_eq(businessProfileModel.plan, $author$project$Data$Api$Business$Profile$Normal) ? $rtfeldman$elm_css$Html$Styled$text('') : A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$h2,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('Coupon Redemption')
						])),
					A2(
					$author$project$Material$Styled$Card$card,
					_List_fromArray(
						[
							$author$project$Material$Styled$Card$containerStyles($author$project$Page$BusinessProfile$CouponCode$styles.contentContainer)
						]),
					A2(
						$elm$core$List$cons,
						$author$project$Page$BusinessProfile$CouponCode$displayBanner(businessUserModel.couponBanner),
						_Utils_ap(
							A2(
								$elm$core$List$indexedMap,
								F2(
									function (index, couponCode) {
										return A2(
											$rtfeldman$elm_css$Html$Styled$div,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$css(
													_List_fromArray(
														[
															$rtfeldman$elm_css$Css$displayFlex,
															$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$row)
														]))
												]),
											_List_fromArray(
												[
													A2(
													$author$project$Material$Styled$Input$text,
													_List_fromArray(
														[
															$author$project$Material$Styled$Input$label('Coupon Code'),
															$author$project$Material$Styled$Input$containerStyles($author$project$Page$BusinessProfile$CouponCode$styles.inputContainer),
															$author$project$Material$Styled$Input$value(couponCode.input),
															$author$project$Material$Styled$Input$onInput(
															A2(
																$elm$core$Basics$composeL,
																A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnBusinessUser),
																$author$project$Type$BusinessUser$OnCouponCodeInput(index))),
															$author$project$Material$Styled$Input$errorMessage(couponCode.error),
															$author$project$Material$Styled$Input$infoMessage(
															A2($elm$core$Maybe$withDefault, '', couponCode.successMessage))
														]),
													_List_Nil),
													A2(
													$author$project$Material$Styled$Button$button,
													_List_fromArray(
														[
															$author$project$Material$Styled$Button$styles($author$project$Page$BusinessProfile$CouponCode$styles.buttonStyle),
															$author$project$Material$Styled$Button$theme($author$project$Material$Styled$Button$default),
															$author$project$Material$Styled$Button$onClick(
															$author$project$Types$OnAuth(
																$author$project$Types$OnBusinessUser(
																	$author$project$Type$BusinessUser$OnRemoveCouponInput(index))))
														]),
													_List_fromArray(
														[
															A2(
															$author$project$Material$Styled$Icon$close,
															_List_fromArray(
																[
																	$rtfeldman$elm_css$Svg$Styled$Attributes$fill('black')
																]),
															_List_Nil)
														]))
												]));
									}),
								businessUserModel.couponCodes),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BusinessProfile$CouponCode$styles.buttonContainer)
										]),
									_List_fromArray(
										[
											A2(
											$author$project$Material$Styled$Button$button,
											_List_fromArray(
												[
													$author$project$Material$Styled$Button$theme($author$project$Material$Styled$Button$default),
													$author$project$Material$Styled$Button$onClick(
													$author$project$Types$OnAuth(
														$author$project$Types$OnBusinessUser($author$project$Type$BusinessUser$OnAddButtonClick))),
													$author$project$Material$Styled$Button$styles($author$project$Page$BusinessProfile$CouponCode$styles.button)
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text('Add More Coupons')
												])),
											A2(
											$author$project$Material$Styled$Button$button,
											_List_fromArray(
												[
													$author$project$Material$Styled$Button$onClick(
													$author$project$Types$OnAuth(
														$author$project$Types$OnBusinessUser($author$project$Type$BusinessUser$OnCouponRedeemSubmit))),
													$author$project$Material$Styled$Button$styles($author$project$Page$BusinessProfile$CouponCode$styles.button)
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text('Redeem')
												]))
										]))
								]))))
				]));
	});
var $author$project$Type$BusinessUser$OnAddUser = {$: 'OnAddUser'};
var $author$project$Material$Styled$Color$tealA200String = '#64ffda';
var $author$project$Material$Styled$Color$tealA700String = '#00bfa5';
var $author$project$Material$Styled$Button$green = {base: $author$project$Material$Styled$Color$tealA700String, ripple: $author$project$Material$Styled$Color$tealA200String, text: $author$project$Material$Styled$Color$whiteString};
var $author$project$Data$Api$Business$ListUsers$errorToString = function (error) {
	return 'You are not authorised to view this resource.';
};
var $author$project$Page$BusinessProfile$ManageUsers$sorter = function (user) {
	var _v0 = user.status;
	switch (_v0.$) {
		case 'Accepted':
			return 1;
		case 'Pending':
			return 2;
		default:
			return 3;
	}
};
var $author$project$Page$BusinessProfile$ManageUsers$styles = {
	addButton: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginLeft(
			$rtfeldman$elm_css$Css$px(10)),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(20)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(25)),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(25)),
			$rtfeldman$elm_css$Css$padding($rtfeldman$elm_css$Css$zero)
		]),
	avatar: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$marginRight(
			$rtfeldman$elm_css$Css$px(16)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(40)),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(40)),
			$rtfeldman$elm_css$Css$borderRadius(
			$rtfeldman$elm_css$Css$pct(50)),
			$rtfeldman$elm_css$Css$backgroundColor($author$project$Material$Styled$Color$grey400),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$grey50),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(20)),
			$rtfeldman$elm_css$Css$fontWeight(
			$rtfeldman$elm_css$Css$int(100))
		]),
	header: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$row),
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$flexStart),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center)
		]),
	statusAccepted: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(12)),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$red900),
			$rtfeldman$elm_css$Css$textDecoration($rtfeldman$elm_css$Css$underline)
		]),
	statusDeclined: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(12)),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$red900)
		]),
	statusPending: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(12)),
			$rtfeldman$elm_css$Css$fontStyle($rtfeldman$elm_css$Css$italic)
		]),
	textContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$padding(
			$rtfeldman$elm_css$Css$px(20)),
			$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$relative),
			$rtfeldman$elm_css$Css$overflow($rtfeldman$elm_css$Css$hidden)
		]),
	userEmail: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(12))
		]),
	userInfo: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$row),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center)
		]),
	userName: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(16))
		]),
	userRow: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$row),
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceBetween),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$padding(
			$rtfeldman$elm_css$Css$px(10))
		]),
	userText: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column)
		])
};
var $author$project$Page$BusinessProfile$ManageUsers$action = function (status) {
	switch (status.$) {
		case 'Pending':
			return A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BusinessProfile$ManageUsers$styles.statusPending)
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('Pending')
					]));
		case 'Accepted':
			return A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BusinessProfile$ManageUsers$styles.statusAccepted)
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('')
					]));
		default:
			return A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BusinessProfile$ManageUsers$styles.statusDeclined)
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('Declined')
					]));
	}
};
var $author$project$Page$BusinessProfile$ManageUsers$avatar = F2(
	function (firstName, lastName) {
		var initials = $elm$core$String$toUpper(
			_Utils_ap(
				A2($elm$core$String$left, 1, firstName),
				A2($elm$core$String$left, 1, lastName)));
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BusinessProfile$ManageUsers$styles.avatar)
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text(initials)
				]));
	});
var $author$project$Page$BusinessProfile$ManageUsers$userRow = function (_v0) {
	var firstName = _v0.firstName;
	var lastName = _v0.lastName;
	var email = _v0.email;
	var status = _v0.status;
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BusinessProfile$ManageUsers$styles.userRow)
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BusinessProfile$ManageUsers$styles.userInfo)
					]),
				_List_fromArray(
					[
						A2($author$project$Page$BusinessProfile$ManageUsers$avatar, firstName, lastName),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BusinessProfile$ManageUsers$styles.userText)
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BusinessProfile$ManageUsers$styles.userName)
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(firstName),
										$rtfeldman$elm_css$Html$Styled$text(' '),
										$rtfeldman$elm_css$Html$Styled$text(lastName)
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BusinessProfile$ManageUsers$styles.userEmail)
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(email)
									]))
							]))
					])),
				$author$project$Page$BusinessProfile$ManageUsers$action(status)
			]));
};
var $author$project$Page$BusinessProfile$ManageUsers$showUsers = function (loadUsers) {
	switch (loadUsers.$) {
		case 'NotLoaded':
			return A2(
				$author$project$Material$Styled$Card$card,
				_List_fromArray(
					[
						$author$project$Material$Styled$Card$containerStyles($author$project$Page$BusinessProfile$ManageUsers$styles.textContainer)
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('Refresh Page to Load')
					]));
		case 'Loading':
			return A2(
				$author$project$Material$Styled$Card$card,
				_List_fromArray(
					[
						$author$project$Material$Styled$Card$containerStyles($author$project$Page$BusinessProfile$ManageUsers$styles.textContainer)
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('Loading...'),
						A2(
						$author$project$Material$Styled$ProgressBar$linear,
						_List_fromArray(
							[
								$author$project$Material$Styled$ProgressBar$containerStyle(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$absolute),
										$rtfeldman$elm_css$Css$bottom($rtfeldman$elm_css$Css$zero),
										$rtfeldman$elm_css$Css$left($rtfeldman$elm_css$Css$zero)
									]))
							]),
						_List_Nil)
					]));
		case 'Loaded':
			var users = loadUsers.a;
			return (!$elm$core$List$length(users)) ? A2(
				$author$project$Material$Styled$Card$card,
				_List_fromArray(
					[
						$author$project$Material$Styled$Card$containerStyles($author$project$Page$BusinessProfile$ManageUsers$styles.textContainer)
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('No user is added in your organisation.')
					])) : A2(
				$author$project$Material$Styled$Card$card,
				_List_Nil,
				A2(
					$elm$core$List$map,
					$author$project$Page$BusinessProfile$ManageUsers$userRow,
					A2($elm$core$List$sortBy, $author$project$Page$BusinessProfile$ManageUsers$sorter, users)));
		default:
			var error = loadUsers.a;
			return A2(
				$author$project$Material$Styled$Card$card,
				_List_fromArray(
					[
						$author$project$Material$Styled$Card$containerStyles($author$project$Page$BusinessProfile$ManageUsers$styles.textContainer)
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						A2($author$project$Data$Api$authErrorToString, $author$project$Data$Api$Business$ListUsers$errorToString, error))
					]));
	}
};
var $author$project$Material$Styled$Button$ButtonType = {$: 'ButtonType'};
var $author$project$Type$BusinessUser$Email = {$: 'Email'};
var $author$project$Type$BusinessUser$FirstName = {$: 'FirstName'};
var $author$project$Type$BusinessUser$LastName = {$: 'LastName'};
var $author$project$Type$BusinessUser$OnAddUserCancel = {$: 'OnAddUserCancel'};
var $author$project$Type$BusinessUser$OnAddUserSubmit = {$: 'OnAddUserSubmit'};
var $author$project$Type$BusinessUser$OnBlur = function (a) {
	return {$: 'OnBlur', a: a};
};
var $author$project$Type$BusinessUser$OnInput = F2(
	function (a, b) {
		return {$: 'OnInput', a: a, b: b};
	});
var $author$project$Material$Styled$Button$Type = function (a) {
	return {$: 'Type', a: a};
};
var $author$project$Material$Styled$Button$buttonType = function (type_) {
	return $author$project$Material$Styled$Button$Type(type_);
};
var $author$project$Data$Api$Business$InviteUser$errorToString = function (error) {
	switch (error.$) {
		case 'INVALID_FIRST_NAME':
			return 'First name is invalid.';
		case 'INVALID_LAST_NAME':
			return 'Last name is invalid.';
		case 'INVALID_EMAIL':
			return 'Email is invalid.';
		case 'DOMAIN_NOT_FOUND':
			return 'Permission denied.';
		case 'USER_ALREADY_ACCEPTED':
			return 'User is already in your organisation.';
		default:
			return 'Reached maximum number of organization users in plan';
	}
};
var $author$project$Page$BusinessProfile$AddUserForm$styles = {
	button: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginRight(
			$rtfeldman$elm_css$Css$px(5)),
			A2(
			$rtfeldman$elm_css$Css$padding2,
			$rtfeldman$elm_css$Css$px(6),
			$rtfeldman$elm_css$Css$px(12)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(100)),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(30)),
			$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$relative),
			$rtfeldman$elm_css$Css$overflow($rtfeldman$elm_css$Css$hidden)
		]),
	buttonContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$row),
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(52))
		]),
	container: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			A2(
			$rtfeldman$elm_css$Css$padding2,
			$rtfeldman$elm_css$Css$px(12),
			$rtfeldman$elm_css$Css$zero)
		]),
	form: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$row),
			$rtfeldman$elm_css$Css$flexWrap($rtfeldman$elm_css$Css$wrap),
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100))
		]),
	formError: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginBottom(
			$rtfeldman$elm_css$Css$px(16)),
			$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(14)),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$red900)
		]),
	inputContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginRight(
			$rtfeldman$elm_css$Css$px(5)),
			$rtfeldman$elm_css$Css$marginBottom(
			$rtfeldman$elm_css$Css$px(10))
		])
};
var $author$project$Page$BusinessProfile$AddUserForm$displayFormError = function (formStatus) {
	if (formStatus.$ === 'Error') {
		var error = formStatus.a;
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BusinessProfile$AddUserForm$styles.formError)
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text(
					A2($author$project$Data$Api$authErrorToString, $author$project$Data$Api$Business$InviteUser$errorToString, error))
				]));
	} else {
		return $rtfeldman$elm_css$Html$Styled$text('');
	}
};
var $author$project$Page$BusinessProfile$AddUserForm$submitButton = F2(
	function (formStatus, model) {
		var hasError = A2(
			$elm$core$List$any,
			$elm$core$Basics$neq($elm$core$Maybe$Nothing),
			_List_fromArray(
				[model.firstNameError, model.lastNameError, model.emailError]));
		switch (formStatus.$) {
			case 'Ready':
				return hasError ? A2(
					$author$project$Material$Styled$Button$button,
					_List_fromArray(
						[
							$author$project$Material$Styled$Button$theme($author$project$Material$Styled$Button$blue),
							$author$project$Material$Styled$Button$disabled(true),
							$author$project$Material$Styled$Button$styles($author$project$Page$BusinessProfile$AddUserForm$styles.button)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('Add')
						])) : A2(
					$author$project$Material$Styled$Button$button,
					_List_fromArray(
						[
							$author$project$Material$Styled$Button$theme($author$project$Material$Styled$Button$blue),
							$author$project$Material$Styled$Button$disabled(false),
							$author$project$Material$Styled$Button$styles($author$project$Page$BusinessProfile$AddUserForm$styles.button)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('Add')
						]));
			case 'Error':
				return A2(
					$author$project$Material$Styled$Button$button,
					_List_fromArray(
						[
							$author$project$Material$Styled$Button$theme($author$project$Material$Styled$Button$blue),
							$author$project$Material$Styled$Button$disabled(true),
							$author$project$Material$Styled$Button$styles($author$project$Page$BusinessProfile$AddUserForm$styles.button)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('Add')
						]));
			default:
				return A2(
					$author$project$Material$Styled$Button$button,
					_List_fromArray(
						[
							$author$project$Material$Styled$Button$theme($author$project$Material$Styled$Button$blue),
							$author$project$Material$Styled$Button$disabled(true),
							$author$project$Material$Styled$Button$styles($author$project$Page$BusinessProfile$AddUserForm$styles.button)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('Adding'),
							A2(
							$author$project$Material$Styled$ProgressBar$linear,
							_List_fromArray(
								[
									$author$project$Material$Styled$ProgressBar$containerStyle(
									_List_fromArray(
										[
											$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$absolute),
											$rtfeldman$elm_css$Css$bottom($rtfeldman$elm_css$Css$zero),
											$rtfeldman$elm_css$Css$left($rtfeldman$elm_css$Css$zero)
										]))
								]),
							_List_Nil)
						]));
		}
	});
var $author$project$Page$BusinessProfile$AddUserForm$view = function (model) {
	var _v0 = model;
	var formModal = _v0.formModal;
	var firstName = _v0.firstName;
	var firstNameError = _v0.firstNameError;
	var lastName = _v0.lastName;
	var lastNameError = _v0.lastNameError;
	var email = _v0.email;
	var emailError = _v0.emailError;
	switch (formModal.$) {
		case 'Closed':
			return $rtfeldman$elm_css$Html$Styled$text('');
		case 'Success':
			var email_ = formModal.a;
			return A2(
				$author$project$Material$Styled$Banner$banner,
				_List_fromArray(
					[
						$author$project$Material$Styled$Banner$theme($author$project$Material$Styled$Banner$successTheme),
						$author$project$Material$Styled$Banner$title('Success'),
						$author$project$Material$Styled$Banner$body(
						$rtfeldman$elm_css$Html$Styled$text('Invitation is sent to ' + email_)),
						$author$project$Material$Styled$Banner$closeIconAttributes(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Svg$Styled$Events$onClick(
								$author$project$Types$OnAuth(
									$author$project$Types$OnBusinessUser($author$project$Type$BusinessUser$OnAddUserCancel)))
							]))
					]),
				_List_Nil);
		default:
			var status = formModal.a;
			return A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BusinessProfile$AddUserForm$styles.container)
					]),
				_List_fromArray(
					[
						$author$project$Page$BusinessProfile$AddUserForm$displayFormError(status),
						A2(
						$rtfeldman$elm_css$Html$Styled$form,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Events$onSubmit(
								$author$project$Types$OnAuth(
									$author$project$Types$OnBusinessUser($author$project$Type$BusinessUser$OnAddUserSubmit))),
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BusinessProfile$AddUserForm$styles.form)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Material$Styled$Input$text,
								_List_fromArray(
									[
										$author$project$Material$Styled$Input$containerStyles($author$project$Page$BusinessProfile$AddUserForm$styles.inputContainer),
										$author$project$Material$Styled$Input$label('First Name *'),
										$author$project$Material$Styled$Input$value(firstName),
										$author$project$Material$Styled$Input$errorMessage(firstNameError),
										$author$project$Material$Styled$Input$onInput(
										A2(
											$elm$core$Basics$composeL,
											A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnBusinessUser),
											$author$project$Type$BusinessUser$OnInput($author$project$Type$BusinessUser$FirstName))),
										$author$project$Material$Styled$Input$onBlur(
										$author$project$Types$OnAuth(
											$author$project$Types$OnBusinessUser(
												$author$project$Type$BusinessUser$OnBlur($author$project$Type$BusinessUser$FirstName))))
									]),
								_List_Nil),
								A2(
								$author$project$Material$Styled$Input$text,
								_List_fromArray(
									[
										$author$project$Material$Styled$Input$containerStyles($author$project$Page$BusinessProfile$AddUserForm$styles.inputContainer),
										$author$project$Material$Styled$Input$label('Last Name *'),
										$author$project$Material$Styled$Input$value(lastName),
										$author$project$Material$Styled$Input$errorMessage(lastNameError),
										$author$project$Material$Styled$Input$onInput(
										A2(
											$elm$core$Basics$composeL,
											A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnBusinessUser),
											$author$project$Type$BusinessUser$OnInput($author$project$Type$BusinessUser$LastName))),
										$author$project$Material$Styled$Input$onBlur(
										$author$project$Types$OnAuth(
											$author$project$Types$OnBusinessUser(
												$author$project$Type$BusinessUser$OnBlur($author$project$Type$BusinessUser$LastName))))
									]),
								_List_Nil),
								A2(
								$author$project$Material$Styled$Input$email,
								_List_fromArray(
									[
										$author$project$Material$Styled$Input$containerStyles($author$project$Page$BusinessProfile$AddUserForm$styles.inputContainer),
										$author$project$Material$Styled$Input$label('Email Address *'),
										$author$project$Material$Styled$Input$value(email),
										$author$project$Material$Styled$Input$errorMessage(emailError),
										$author$project$Material$Styled$Input$onInput(
										A2(
											$elm$core$Basics$composeL,
											A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnBusinessUser),
											$author$project$Type$BusinessUser$OnInput($author$project$Type$BusinessUser$Email))),
										$author$project$Material$Styled$Input$onBlur(
										$author$project$Types$OnAuth(
											$author$project$Types$OnBusinessUser(
												$author$project$Type$BusinessUser$OnBlur($author$project$Type$BusinessUser$Email))))
									]),
								_List_Nil),
								A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BusinessProfile$AddUserForm$styles.buttonContainer)
									]),
								_List_fromArray(
									[
										A2($author$project$Page$BusinessProfile$AddUserForm$submitButton, status, model),
										A2(
										$author$project$Material$Styled$Button$button,
										_List_fromArray(
											[
												$author$project$Material$Styled$Button$theme($author$project$Material$Styled$Button$grey),
												$author$project$Material$Styled$Button$onClick(
												$author$project$Types$OnAuth(
													$author$project$Types$OnBusinessUser($author$project$Type$BusinessUser$OnAddUserCancel))),
												$author$project$Material$Styled$Button$buttonType($author$project$Material$Styled$Button$ButtonType),
												$author$project$Material$Styled$Button$styles($author$project$Page$BusinessProfile$AddUserForm$styles.button)
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('Cancel')
											]))
									]))
							]))
					]));
	}
};
var $author$project$Page$BusinessProfile$ManageUsers$view = F2(
	function (authModel, model) {
		var myOrganisationPageLanguageData = model.languageSwitchModel.allLanguageData.location.myOrganisationPage;
		var businessModel = authModel.businessUserModel;
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BusinessProfile$ManageUsers$styles.header)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$h2,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(myOrganisationPageLanguageData.manageUsers)
								])),
							A2(
							$author$project$Material$Styled$Button$button,
							_List_fromArray(
								[
									$author$project$Material$Styled$Button$theme($author$project$Material$Styled$Button$green),
									$author$project$Material$Styled$Button$styles($author$project$Page$BusinessProfile$ManageUsers$styles.addButton),
									$author$project$Material$Styled$Button$onClick(
									$author$project$Types$OnAuth(
										$author$project$Types$OnBusinessUser($author$project$Type$BusinessUser$OnAddUser)))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('+')
								]))
						])),
					$author$project$Page$BusinessProfile$AddUserForm$view(businessModel),
					$author$project$Page$BusinessProfile$ManageUsers$showUsers(businessModel.users)
				]));
	});
var $author$project$Type$BusinessProfile$Description = {$: 'Description'};
var $author$project$Type$BusinessProfile$OnBlur = function (a) {
	return {$: 'OnBlur', a: a};
};
var $author$project$Type$BusinessProfile$OnInput = F2(
	function (a, b) {
		return {$: 'OnInput', a: a, b: b};
	});
var $author$project$Type$BusinessProfile$OnSubmit = {$: 'OnSubmit'};
var $author$project$Type$BusinessProfile$Title = {$: 'Title'};
var $author$project$Material$Styled$TextArea$ContainerStyle = function (a) {
	return {$: 'ContainerStyle', a: a};
};
var $author$project$Material$Styled$TextArea$containerStyles = function (styles_) {
	return $author$project$Material$Styled$TextArea$ContainerStyle(styles_);
};
var $author$project$Type$BusinessProfile$OnBannerClose = {$: 'OnBannerClose'};
var $author$project$Page$BusinessProfile$Profile$displayBanner = function (formStatus) {
	switch (formStatus.$) {
		case 'Ready':
			var status = formStatus.a;
			if (status.$ === 'Success') {
				return A2(
					$author$project$Material$Styled$Banner$banner,
					_List_fromArray(
						[
							$author$project$Material$Styled$Banner$theme($author$project$Material$Styled$Banner$successTheme),
							$author$project$Material$Styled$Banner$title('Success'),
							$author$project$Material$Styled$Banner$body(
							$rtfeldman$elm_css$Html$Styled$text('Business profile has been updated successfully.')),
							$author$project$Material$Styled$Banner$closeIconAttributes(
							_List_fromArray(
								[
									$rtfeldman$elm_css$Svg$Styled$Events$onClick(
									$author$project$Types$OnBusinessProfile($author$project$Type$BusinessProfile$OnBannerClose))
								]))
						]),
					_List_Nil);
			} else {
				return $rtfeldman$elm_css$Html$Styled$text('');
			}
		case 'Error':
			var error = formStatus.a;
			return A2(
				$author$project$Material$Styled$Banner$banner,
				_List_fromArray(
					[
						$author$project$Material$Styled$Banner$theme($author$project$Material$Styled$Banner$errorTheme),
						$author$project$Material$Styled$Banner$title('Error'),
						$author$project$Material$Styled$Banner$body(
						$rtfeldman$elm_css$Html$Styled$text(error)),
						$author$project$Material$Styled$Banner$closeIconAttributes(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Svg$Styled$Events$onClick(
								$author$project$Types$OnBusinessProfile($author$project$Type$BusinessProfile$OnBannerClose))
							]))
					]),
				_List_Nil);
		default:
			return $rtfeldman$elm_css$Html$Styled$text('');
	}
};
var $author$project$Material$Styled$TextArea$ErrorMessage = function (a) {
	return {$: 'ErrorMessage', a: a};
};
var $author$project$Material$Styled$TextArea$None = {$: 'None'};
var $author$project$Material$Styled$TextArea$errorMessage = function (message) {
	return A2(
		$elm$core$Maybe$withDefault,
		$author$project$Material$Styled$TextArea$None,
		A2($elm$core$Maybe$map, $author$project$Material$Styled$TextArea$ErrorMessage, message));
};
var $author$project$Material$Styled$TextArea$Height = function (a) {
	return {$: 'Height', a: a};
};
var $author$project$Material$Styled$TextArea$height_ = function (_float) {
	return $author$project$Material$Styled$TextArea$Height(_float);
};
var $author$project$Material$Styled$TextArea$InfoMessage = function (a) {
	return {$: 'InfoMessage', a: a};
};
var $author$project$Material$Styled$TextArea$infoMessage = function (message) {
	return $author$project$Material$Styled$TextArea$InfoMessage(message);
};
var $author$project$Material$Styled$TextArea$Label = function (a) {
	return {$: 'Label', a: a};
};
var $author$project$Material$Styled$TextArea$label = function (string) {
	return $author$project$Material$Styled$TextArea$Label(string);
};
var $author$project$Material$Styled$TextArea$MaxLength = function (a) {
	return {$: 'MaxLength', a: a};
};
var $author$project$Material$Styled$TextArea$maxLength = function (length) {
	return $author$project$Material$Styled$TextArea$MaxLength(length);
};
var $author$project$Material$Styled$TextArea$OnBlur = function (a) {
	return {$: 'OnBlur', a: a};
};
var $author$project$Material$Styled$TextArea$onBlur = function (msg) {
	return $author$project$Material$Styled$TextArea$OnBlur(msg);
};
var $author$project$Material$Styled$TextArea$OnInput = function (a) {
	return {$: 'OnInput', a: a};
};
var $author$project$Material$Styled$TextArea$onInput = function (mapMsg) {
	return $author$project$Material$Styled$TextArea$OnInput(mapMsg);
};
var $author$project$Page$BusinessProfile$Profile$styles = {
	button: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(150))
		]),
	buttonContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$paddingTop(
			$rtfeldman$elm_css$Css$px(20))
		]),
	contentContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			A2(
			$rtfeldman$elm_css$Css$padding2,
			$rtfeldman$elm_css$Css$px(30),
			$rtfeldman$elm_css$Css$px(20))
		]),
	domain: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginLeft(
			$rtfeldman$elm_css$Css$px(10)),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(16))
		]),
	form: _List_Nil,
	header: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center)
		]),
	inputContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginBottom(
			$rtfeldman$elm_css$Css$px(20))
		]),
	textArea: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(150))
		]),
	textareaContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginBottom(
			$rtfeldman$elm_css$Css$px(40))
		])
};
var $author$project$Page$BusinessProfile$Profile$submitButton = F2(
	function (languageSwitchModel, model) {
		var organisationPageLanguageData = languageSwitchModel.allLanguageData.location.myOrganisationPage;
		var hasError = A2(
			$elm$core$List$any,
			$elm$core$Basics$neq($elm$core$Maybe$Nothing),
			_List_fromArray(
				[model.titleError, model.descriptionError, model.emailError, model.phoneError]));
		var _v0 = model;
		var formStatus = _v0.formStatus;
		switch (formStatus.$) {
			case 'Ready':
				return hasError ? $author$project$View$SubmitButton$disabled(organisationPageLanguageData.update) : $author$project$View$SubmitButton$enabled(organisationPageLanguageData.update);
			case 'Error':
				return $author$project$View$SubmitButton$enabled(organisationPageLanguageData.update);
			default:
				return $author$project$View$SubmitButton$submitting('Updating Business Profile...');
		}
	});
var $author$project$Material$Styled$TextArea$defaultConfig = {containerAttributes: _List_Nil, containerStyles: _List_Nil, errorMessageText: $elm$core$Maybe$Nothing, height: 100, infoMessageText: $elm$core$Maybe$Nothing, inputAttributes: _List_Nil, inputValue: '', labelText: 'Label'};
var $rtfeldman$elm_css$Html$Styled$Attributes$maxlength = function (n) {
	return A2(
		$rtfeldman$elm_css$VirtualDom$Styled$attribute,
		'maxlength',
		$elm$core$String$fromInt(n));
};
var $author$project$Material$Styled$TextArea$mergeProperty = F2(
	function (property, config) {
		switch (property.$) {
			case 'ContainerStyle':
				var styles = property.a;
				return _Utils_update(
					config,
					{
						containerStyles: _Utils_ap(config.containerStyles, styles)
					});
			case 'OnInput':
				var mapMsg = property.a;
				return _Utils_update(
					config,
					{
						inputAttributes: A2(
							$elm$core$List$cons,
							$rtfeldman$elm_css$Html$Styled$Events$onInput(mapMsg),
							config.inputAttributes)
					});
			case 'CustomInputAttributes':
				var customAttributes = property.a;
				return _Utils_update(
					config,
					{
						inputAttributes: _Utils_ap(customAttributes, config.inputAttributes)
					});
			case 'OnBlur':
				var msg = property.a;
				return _Utils_update(
					config,
					{
						inputAttributes: A2(
							$elm$core$List$cons,
							$rtfeldman$elm_css$Html$Styled$Events$onBlur(msg),
							config.inputAttributes)
					});
			case 'Value':
				var valueText = property.a;
				return _Utils_update(
					config,
					{
						inputAttributes: A2(
							$elm$core$List$cons,
							$rtfeldman$elm_css$Html$Styled$Attributes$value(valueText),
							config.inputAttributes),
						inputValue: valueText
					});
			case 'Label':
				var labelText = property.a;
				return _Utils_update(
					config,
					{labelText: labelText});
			case 'InfoMessage':
				var message = property.a;
				return _Utils_update(
					config,
					{
						infoMessageText: $elm$core$Maybe$Just(message)
					});
			case 'ErrorMessage':
				var errorMessageText = property.a;
				return _Utils_update(
					config,
					{
						errorMessageText: $elm$core$Maybe$Just(errorMessageText)
					});
			case 'MaxLength':
				var length = property.a;
				return _Utils_update(
					config,
					{
						inputAttributes: A2(
							$elm$core$List$cons,
							$rtfeldman$elm_css$Html$Styled$Attributes$maxlength(length),
							config.inputAttributes)
					});
			case 'Height':
				var h = property.a;
				return _Utils_update(
					config,
					{height: h});
			default:
				return config;
		}
	});
var $author$project$Material$Styled$TextArea$mergeConfig = F2(
	function (config, properties) {
		return function (c) {
			return _Utils_update(
				c,
				{
					containerAttributes: A2(
						$elm$core$List$cons,
						$rtfeldman$elm_css$Html$Styled$Attributes$css(c.containerStyles),
						c.containerAttributes)
				});
		}(
			A3($elm$core$List$foldl, $author$project$Material$Styled$TextArea$mergeProperty, config, properties));
	});
var $author$project$Material$Styled$TextArea$animation = {
	finalLabel: _List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Css$translate2,
			$rtfeldman$elm_css$Css$px(14),
			$rtfeldman$elm_css$Css$px(-6)),
			$rtfeldman$elm_css$Css$scale(0.75)
		]),
	finalLegend: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$maxWidth(
			$rtfeldman$elm_css$Css$px(1000)),
			$rtfeldman$elm_css$Css$paddingRight(
			$rtfeldman$elm_css$Css$px(3))
		]),
	initialLabel: _List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Css$translate2,
			$rtfeldman$elm_css$Css$px(14),
			$rtfeldman$elm_css$Css$px(20)),
			$rtfeldman$elm_css$Css$scale(1)
		]),
	initialLegend: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$maxWidth(
			$rtfeldman$elm_css$Css$px(0.01))
		])
};
var $author$project$Material$Styled$TextArea$ifElse = F3(
	function (trueStyle, falseStyle, maybe) {
		return A2(
			$elm$core$Maybe$withDefault,
			falseStyle,
			A2(
				$elm$core$Maybe$map,
				$elm$core$Basics$always(trueStyle),
				maybe));
	});
var $rtfeldman$elm_css$Css$resize = $rtfeldman$elm_css$Css$prop1('resize');
var $author$project$Material$Styled$TextArea$style = {
	error: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(11)),
			$rtfeldman$elm_css$Css$fontFamilies(
			_List_fromArray(
				[
					'Roboto',
					'Helvetica',
					'Arial',
					function ($) {
					return $.value;
				}($rtfeldman$elm_css$Css$sansSerif)
				])),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$red900),
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(6)),
			$rtfeldman$elm_css$Css$paddingLeft(
			$rtfeldman$elm_css$Css$px(14))
		]),
	fieldset: function (maybeError) {
		return _List_fromArray(
			[
				$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$absolute),
				$rtfeldman$elm_css$Css$top(
				$rtfeldman$elm_css$Css$px(-5)),
				$rtfeldman$elm_css$Css$left($rtfeldman$elm_css$Css$zero),
				$rtfeldman$elm_css$Css$right($rtfeldman$elm_css$Css$zero),
				$rtfeldman$elm_css$Css$bottom($rtfeldman$elm_css$Css$zero),
				$rtfeldman$elm_css$Css$margin($rtfeldman$elm_css$Css$zero),
				$rtfeldman$elm_css$Css$paddingLeft(
				$rtfeldman$elm_css$Css$px(8)),
				$rtfeldman$elm_css$Css$boxSizing($rtfeldman$elm_css$Css$borderBox),
				$rtfeldman$elm_css$Css$width(
				$rtfeldman$elm_css$Css$pct(100)),
				$rtfeldman$elm_css$Css$borderRadius(
				$rtfeldman$elm_css$Css$px(4)),
				A3(
				$rtfeldman$elm_css$Css$border3,
				$rtfeldman$elm_css$Css$px(1),
				$rtfeldman$elm_css$Css$solid,
				A3($author$project$Material$Styled$TextArea$ifElse, $author$project$Material$Styled$Color$red900, $author$project$Material$Styled$Color$grey300, maybeError)),
				$rtfeldman$elm_css$Css$pointerEvents($rtfeldman$elm_css$Css$none)
			]);
	},
	info: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(11)),
			$rtfeldman$elm_css$Css$fontFamilies(
			_List_fromArray(
				[
					'Roboto',
					'Helvetica',
					'Arial',
					function ($) {
					return $.value;
				}($rtfeldman$elm_css$Css$sansSerif)
				])),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$blueGrey600),
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(6)),
			$rtfeldman$elm_css$Css$paddingLeft(
			$rtfeldman$elm_css$Css$px(14))
		]),
	inputContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$relative)
		]),
	label: function (maybeError) {
		return _List_fromArray(
			[
				$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$absolute),
				$rtfeldman$elm_css$Css$top($rtfeldman$elm_css$Css$zero),
				$rtfeldman$elm_css$Css$left($rtfeldman$elm_css$Css$zero),
				$rtfeldman$elm_css$Css$fontSize(
				$rtfeldman$elm_css$Css$px(12.8)),
				$rtfeldman$elm_css$Css$fontFamilies(
				_List_fromArray(
					[
						'Roboto',
						'Helvetica',
						'Arial',
						function ($) {
						return $.value;
					}($rtfeldman$elm_css$Css$sansSerif)
					])),
				$rtfeldman$elm_css$Css$color(
				A3($author$project$Material$Styled$TextArea$ifElse, $author$project$Material$Styled$Color$red900, $author$project$Material$Styled$Color$blueGrey900, maybeError)),
				$rtfeldman$elm_css$Css$Transitions$transition(
				_List_fromArray(
					[
						A3(
						$rtfeldman$elm_css$Css$Transitions$transform3,
						200,
						0,
						A4($rtfeldman$elm_css$Css$Transitions$cubicBezier, 0, 0, 0.2, 1)),
						A3(
						$rtfeldman$elm_css$Css$Transitions$color3,
						200,
						0,
						A4($rtfeldman$elm_css$Css$Transitions$cubicBezier, 0, 0, 0.2, 1))
					])),
				A2($rtfeldman$elm_css$Css$property, 'transform-origin', 'top left'),
				$rtfeldman$elm_css$Css$pointerEvents($rtfeldman$elm_css$Css$none)
			]);
	},
	labelError: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$red900)
		]),
	legend: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$block),
			$rtfeldman$elm_css$Css$visibility($rtfeldman$elm_css$Css$hidden),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(11)),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$em(0.75))
		]),
	textArea: function (_v0) {
		var maybeError = _v0.a;
		var h = _v0.b;
		return _List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Css$padding2,
				$rtfeldman$elm_css$Css$px(18),
				$rtfeldman$elm_css$Css$px(14)),
				$rtfeldman$elm_css$Css$boxSizing($rtfeldman$elm_css$Css$borderBox),
				$rtfeldman$elm_css$Css$width(
				$rtfeldman$elm_css$Css$pct(100)),
				$rtfeldman$elm_css$Css$height(
				$rtfeldman$elm_css$Css$px(h)),
				$rtfeldman$elm_css$Css$fontFamilies(
				_List_fromArray(
					[
						'Roboto',
						'Helvetica',
						'Arial',
						function ($) {
						return $.value;
					}($rtfeldman$elm_css$Css$sansSerif)
					])),
				$rtfeldman$elm_css$Css$fontSize(
				$rtfeldman$elm_css$Css$px(12.8)),
				$rtfeldman$elm_css$Css$lineHeight(
				$rtfeldman$elm_css$Css$px(20)),
				$rtfeldman$elm_css$Css$outline($rtfeldman$elm_css$Css$none),
				$rtfeldman$elm_css$Css$border($rtfeldman$elm_css$Css$zero),
				$rtfeldman$elm_css$Css$borderRadius(
				$rtfeldman$elm_css$Css$px(4)),
				A2(
				$rtfeldman$elm_css$Css$pseudoClass,
				'focus + label',
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$transforms($author$project$Material$Styled$TextArea$animation.finalLabel),
						$rtfeldman$elm_css$Css$color(
						A3($author$project$Material$Styled$TextArea$ifElse, $author$project$Material$Styled$Color$red900, $author$project$Material$Styled$Color$blue600, maybeError))
					])),
				A2(
				$rtfeldman$elm_css$Css$pseudoClass,
				'focus ~ fieldset',
				_List_fromArray(
					[
						A3(
						$rtfeldman$elm_css$Css$border3,
						$rtfeldman$elm_css$Css$px(2),
						$rtfeldman$elm_css$Css$solid,
						A3($author$project$Material$Styled$TextArea$ifElse, $author$project$Material$Styled$Color$red900, $author$project$Material$Styled$Color$blue600, maybeError))
					])),
				A2($rtfeldman$elm_css$Css$pseudoClass, 'focus ~ fieldset legend', $author$project$Material$Styled$TextArea$animation.finalLegend),
				$rtfeldman$elm_css$Css$resize($rtfeldman$elm_css$Css$none)
			]);
	}
};
var $author$project$Material$Styled$TextArea$renderInfoOrError = F2(
	function (maybeInfo, maybeError) {
		if (maybeError.$ === 'Just') {
			var message = maybeError.a;
			return A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Material$Styled$TextArea$style.error)
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(message)
					]));
		} else {
			if (maybeInfo.$ === 'Just') {
				var message = maybeInfo.a;
				return A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Material$Styled$TextArea$style.info)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(message)
						]));
			} else {
				return $rtfeldman$elm_css$Html$Styled$text('');
			}
		}
	});
var $author$project$Material$Styled$TextArea$renderLabel = F3(
	function (inputValue, errorMessageText, labelText) {
		var _v0 = $elm$core$String$isEmpty(inputValue) ? _Utils_Tuple2(
			A2(
				$elm$core$List$cons,
				$rtfeldman$elm_css$Css$transforms($author$project$Material$Styled$TextArea$animation.initialLabel),
				$author$project$Material$Styled$TextArea$style.label(errorMessageText)),
			_Utils_ap($author$project$Material$Styled$TextArea$animation.initialLegend, $author$project$Material$Styled$TextArea$style.legend)) : _Utils_Tuple2(
			A2(
				$elm$core$List$cons,
				$rtfeldman$elm_css$Css$transforms($author$project$Material$Styled$TextArea$animation.finalLabel),
				$author$project$Material$Styled$TextArea$style.label(errorMessageText)),
			_Utils_ap($author$project$Material$Styled$TextArea$animation.finalLegend, $author$project$Material$Styled$TextArea$style.legend));
		var labelStyle = _v0.a;
		var legendStyle = _v0.b;
		return _List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$label,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(labelStyle)
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(labelText)
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$fieldset,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						$author$project$Material$Styled$TextArea$style.fieldset(errorMessageText))
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$legend,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css(legendStyle)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(labelText)
							]))
					]))
			]);
	});
var $rtfeldman$elm_css$Html$Styled$textarea = $rtfeldman$elm_css$Html$Styled$node('textarea');
var $author$project$Material$Styled$TextArea$textArea = F2(
	function (properties, _v0) {
		var _v1 = A2($author$project$Material$Styled$TextArea$mergeConfig, $author$project$Material$Styled$TextArea$defaultConfig, properties);
		var containerAttributes = _v1.containerAttributes;
		var inputAttributes = _v1.inputAttributes;
		var labelText = _v1.labelText;
		var infoMessageText = _v1.infoMessageText;
		var errorMessageText = _v1.errorMessageText;
		var inputValue = _v1.inputValue;
		var height = _v1.height;
		var mergedInputAttributes = A2(
			$elm$core$List$cons,
			$rtfeldman$elm_css$Html$Styled$Attributes$css(
				$author$project$Material$Styled$TextArea$style.textArea(
					_Utils_Tuple2(errorMessageText, height))),
			inputAttributes);
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			containerAttributes,
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Material$Styled$TextArea$style.inputContainer)
						]),
					A2(
						$elm$core$List$cons,
						A2($rtfeldman$elm_css$Html$Styled$textarea, mergedInputAttributes, _List_Nil),
						A3($author$project$Material$Styled$TextArea$renderLabel, inputValue, errorMessageText, labelText))),
					A2($author$project$Material$Styled$TextArea$renderInfoOrError, infoMessageText, errorMessageText)
				]));
	});
var $author$project$Material$Styled$TextArea$Value = function (a) {
	return {$: 'Value', a: a};
};
var $author$project$Material$Styled$TextArea$value = function (string) {
	return $author$project$Material$Styled$TextArea$Value(string);
};
var $author$project$Page$BusinessProfile$Profile$view = F4(
	function (languageSwitchModel, model, baseHost, domain) {
		var viewText = languageSwitchModel.allLanguageData.location.viewDocumentPage.view;
		var redirectUrl = (baseHost === 'localhost') ? ('http://' + (domain + (':3000' + $author$project$Data$Route$routeUrl.businessProfileView))) : ('https://' + (domain + $author$project$Data$Route$routeUrl.businessProfileView));
		var organisationPageLanguageData = languageSwitchModel.allLanguageData.location.myOrganisationPage;
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$h2,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BusinessProfile$Profile$styles.header)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(organisationPageLanguageData.businessProfile + ' ')
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BusinessProfile$Profile$styles.domain)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('(' + (domain + ' - ')),
									A2(
									$rtfeldman$elm_css$Html$Styled$a,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$href(redirectUrl)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(viewText)
										])),
									$rtfeldman$elm_css$Html$Styled$text(')')
								]))
						])),
					$author$project$Page$BusinessProfile$Profile$displayBanner(model.formStatus),
					A2(
					$author$project$Material$Styled$Card$card,
					_List_fromArray(
						[
							$author$project$Material$Styled$Card$containerStyles($author$project$Page$BusinessProfile$Profile$styles.contentContainer)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$form,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BusinessProfile$Profile$styles.form),
									$rtfeldman$elm_css$Html$Styled$Events$onSubmit(
									$author$project$Types$OnBusinessProfile($author$project$Type$BusinessProfile$OnSubmit))
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Material$Styled$Input$text,
									_List_fromArray(
										[
											$author$project$Material$Styled$Input$label(organisationPageLanguageData.companyName + ' *'),
											$author$project$Material$Styled$Input$containerStyles($author$project$Page$BusinessProfile$Profile$styles.inputContainer),
											$author$project$Material$Styled$Input$value(model.name),
											$author$project$Material$Styled$Input$disabled(true)
										]),
									_List_Nil),
									A2(
									$author$project$Material$Styled$Input$text,
									_List_fromArray(
										[
											$author$project$Material$Styled$Input$label(organisationPageLanguageData.companySlogan + ' *'),
											$author$project$Material$Styled$Input$containerStyles($author$project$Page$BusinessProfile$Profile$styles.inputContainer),
											$author$project$Material$Styled$Input$onInput(
											A2(
												$elm$core$Basics$composeL,
												$author$project$Types$OnBusinessProfile,
												$author$project$Type$BusinessProfile$OnInput($author$project$Type$BusinessProfile$Title))),
											$author$project$Material$Styled$Input$onBlur(
											$author$project$Types$OnBusinessProfile(
												$author$project$Type$BusinessProfile$OnBlur($author$project$Type$BusinessProfile$Title))),
											$author$project$Material$Styled$Input$value(model.title),
											$author$project$Material$Styled$Input$errorMessage(model.titleError)
										]),
									_List_Nil),
									A2(
									$author$project$Material$Styled$TextArea$textArea,
									_List_fromArray(
										[
											$author$project$Material$Styled$TextArea$label(organisationPageLanguageData.companyDescription + ' *'),
											$author$project$Material$Styled$TextArea$containerStyles($author$project$Page$BusinessProfile$Profile$styles.textareaContainer),
											$author$project$Material$Styled$TextArea$maxLength(1000),
											$author$project$Material$Styled$TextArea$containerStyles($author$project$Page$BusinessProfile$Profile$styles.textArea),
											$author$project$Material$Styled$TextArea$height_(150),
											$author$project$Material$Styled$TextArea$onInput(
											A2(
												$elm$core$Basics$composeL,
												$author$project$Types$OnBusinessProfile,
												$author$project$Type$BusinessProfile$OnInput($author$project$Type$BusinessProfile$Description))),
											$author$project$Material$Styled$TextArea$onBlur(
											$author$project$Types$OnBusinessProfile(
												$author$project$Type$BusinessProfile$OnBlur($author$project$Type$BusinessProfile$Description))),
											$author$project$Material$Styled$TextArea$value(model.description),
											$author$project$Material$Styled$TextArea$errorMessage(model.descriptionError),
											$author$project$Material$Styled$TextArea$infoMessage(
											'Characters: ' + ($elm$core$String$fromInt(
												$elm$core$String$length(model.description)) + '/1000'))
										]),
									_List_Nil),
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BusinessProfile$Profile$styles.buttonContainer)
										]),
									_List_fromArray(
										[
											A2($author$project$Page$BusinessProfile$Profile$submitButton, languageSwitchModel, model)
										]))
								]))
						]))
				]));
	});
var $author$project$Type$BusinessTheme$ImageCancel = {$: 'ImageCancel'};
var $author$project$Type$BusinessTheme$ImageSubmit = function (a) {
	return {$: 'ImageSubmit', a: a};
};
var $author$project$Type$BusinessTheme$OnBlur = function (a) {
	return {$: 'OnBlur', a: a};
};
var $author$project$Type$BusinessTheme$OnChange = F2(
	function (a, b) {
		return {$: 'OnChange', a: a, b: b};
	});
var $author$project$Type$BusinessTheme$ImageAction = function (a) {
	return {$: 'ImageAction', a: a};
};
var $author$project$ImageEditor$RotateCCW = {$: 'RotateCCW'};
var $author$project$ImageEditor$RotateCW = {$: 'RotateCW'};
var $author$project$ImageEditor$ZoomIn = {$: 'ZoomIn'};
var $author$project$ImageEditor$ZoomOut = {$: 'ZoomOut'};
var $author$project$Page$BusinessProfile$Theme$styles = {
	bannerBackground: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(100)),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(100)),
			$rtfeldman$elm_css$Css$marginRight(
			$rtfeldman$elm_css$Css$px(16)),
			A3(
			$rtfeldman$elm_css$Css$border3,
			$rtfeldman$elm_css$Css$px(1),
			$rtfeldman$elm_css$Css$solid,
			$author$project$Material$Styled$Color$grey300),
			$rtfeldman$elm_css$Css$borderRadius(
			$rtfeldman$elm_css$Css$px(4))
		]),
	bannerLogo: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(100)),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(100)),
			$rtfeldman$elm_css$Css$marginRight(
			$rtfeldman$elm_css$Css$px(16)),
			A3(
			$rtfeldman$elm_css$Css$border3,
			$rtfeldman$elm_css$Css$px(1),
			$rtfeldman$elm_css$Css$solid,
			$author$project$Material$Styled$Color$grey300),
			$rtfeldman$elm_css$Css$borderRadius(
			$rtfeldman$elm_css$Css$px(4))
		]),
	button: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100))
		]),
	fieldActionsBox: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100)),
			A2(
			$rtfeldman$elm_css$Css$padding2,
			$rtfeldman$elm_css$Css$px(4),
			$rtfeldman$elm_css$Css$px(16)),
			$rtfeldman$elm_css$Css$boxSizing($rtfeldman$elm_css$Css$borderBox)
		]),
	fieldBox: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$row),
			A2(
			$rtfeldman$elm_css$Css$padding2,
			$rtfeldman$elm_css$Css$px(4),
			$rtfeldman$elm_css$Css$px(0)),
			$rtfeldman$elm_css$Css$flexWrap($rtfeldman$elm_css$Css$wrap),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100))
		]),
	fieldErrorBox: _List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Css$padding2,
			$rtfeldman$elm_css$Css$px(0),
			$rtfeldman$elm_css$Css$px(16)),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$red900),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(11))
		]),
	fieldInterfaceBox: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			A3(
			$rtfeldman$elm_css$Css$flex3,
			$rtfeldman$elm_css$Css$int(3),
			$rtfeldman$elm_css$Css$int(1),
			$rtfeldman$elm_css$Css$px(250)),
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column)
		]),
	fieldLabelBox: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			A3(
			$rtfeldman$elm_css$Css$flex3,
			$rtfeldman$elm_css$Css$int(1),
			$rtfeldman$elm_css$Css$int(1),
			$rtfeldman$elm_css$Css$px(120)),
			A2(
			$rtfeldman$elm_css$Css$padding2,
			$rtfeldman$elm_css$Css$px(4),
			$rtfeldman$elm_css$Css$px(16)),
			$rtfeldman$elm_css$Css$boxSizing($rtfeldman$elm_css$Css$borderBox)
		]),
	fieldLoadingBox: _List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Css$padding2,
			$rtfeldman$elm_css$Css$px(0),
			$rtfeldman$elm_css$Css$px(16)),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(11))
		]),
	formActionsBox: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100)),
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(16)),
			A2(
			$rtfeldman$elm_css$Css$padding2,
			$rtfeldman$elm_css$Css$px(8),
			$rtfeldman$elm_css$Css$px(16)),
			$rtfeldman$elm_css$Css$boxSizing($rtfeldman$elm_css$Css$borderBox)
		]),
	formError: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(16)),
			$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(14)),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$red900)
		]),
	headerLogo: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(150)),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(50)),
			$rtfeldman$elm_css$Css$marginRight(
			$rtfeldman$elm_css$Css$px(16)),
			A3(
			$rtfeldman$elm_css$Css$border3,
			$rtfeldman$elm_css$Css$px(1),
			$rtfeldman$elm_css$Css$solid,
			$author$project$Material$Styled$Color$grey300),
			$rtfeldman$elm_css$Css$borderRadius(
			$rtfeldman$elm_css$Css$px(4))
		]),
	helperText: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(12)),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$grey600)
		]),
	icon: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$margin(
			$rtfeldman$elm_css$Css$px(5)),
			$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer)
		]),
	icons: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$relative),
			$rtfeldman$elm_css$Css$top(
			$rtfeldman$elm_css$Css$px(-32)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100))
		]),
	imageEditor: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(320)),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(320))
		]),
	inputColor: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$outline($rtfeldman$elm_css$Css$none),
			$rtfeldman$elm_css$Css$border($rtfeldman$elm_css$Css$zero),
			$rtfeldman$elm_css$Css$borderRadius(
			$rtfeldman$elm_css$Css$px(4)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(150)),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(45)),
			$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer)
		]),
	logo: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(150)),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(50)),
			$rtfeldman$elm_css$Css$marginRight(
			$rtfeldman$elm_css$Css$px(16))
		]),
	modalContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(320)),
			$rtfeldman$elm_css$Css$padding(
			$rtfeldman$elm_css$Css$px(10))
		]),
	root: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			A2(
			$rtfeldman$elm_css$Css$padding2,
			$rtfeldman$elm_css$Css$px(8),
			$rtfeldman$elm_css$Css$px(0)),
			$rtfeldman$elm_css$Css$boxSizing($rtfeldman$elm_css$Css$borderBox),
			$rtfeldman$elm_css$Css$overflowX($rtfeldman$elm_css$Css$hidden)
		]),
	textAreaInput: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100)),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(150)),
			A2(
			$rtfeldman$elm_css$Css$padding2,
			$rtfeldman$elm_css$Css$px(12),
			$rtfeldman$elm_css$Css$px(14)),
			$rtfeldman$elm_css$Css$boxSizing($rtfeldman$elm_css$Css$borderBox),
			$rtfeldman$elm_css$Css$borderRadius(
			$rtfeldman$elm_css$Css$px(4)),
			$rtfeldman$elm_css$Css$outline($rtfeldman$elm_css$Css$zero),
			A3(
			$rtfeldman$elm_css$Css$border3,
			$rtfeldman$elm_css$Css$px(1),
			$rtfeldman$elm_css$Css$solid,
			$author$project$Material$Styled$Color$grey300),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(14)),
			$rtfeldman$elm_css$Css$resize($rtfeldman$elm_css$Css$none),
			$rtfeldman$elm_css$Css$focus(
			_List_fromArray(
				[
					A3(
					$rtfeldman$elm_css$Css$border3,
					$rtfeldman$elm_css$Css$px(2),
					$rtfeldman$elm_css$Css$solid,
					$author$project$Material$Styled$Color$blue600)
				]))
		]),
	textInput: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100)),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(52)),
			A2(
			$rtfeldman$elm_css$Css$padding2,
			$rtfeldman$elm_css$Css$px(12),
			$rtfeldman$elm_css$Css$px(14)),
			$rtfeldman$elm_css$Css$boxSizing($rtfeldman$elm_css$Css$borderBox),
			$rtfeldman$elm_css$Css$borderRadius(
			$rtfeldman$elm_css$Css$px(4)),
			$rtfeldman$elm_css$Css$outline($rtfeldman$elm_css$Css$zero),
			A3(
			$rtfeldman$elm_css$Css$border3,
			$rtfeldman$elm_css$Css$px(1),
			$rtfeldman$elm_css$Css$solid,
			$author$project$Material$Styled$Color$grey300),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(14)),
			$rtfeldman$elm_css$Css$focus(
			_List_fromArray(
				[
					A3(
					$rtfeldman$elm_css$Css$border3,
					$rtfeldman$elm_css$Css$px(2),
					$rtfeldman$elm_css$Css$solid,
					$author$project$Material$Styled$Color$blue600)
				]))
		]),
	uploadButton: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(32)),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(32)),
			$rtfeldman$elm_css$Css$borderRadius(
			$rtfeldman$elm_css$Css$px(16)),
			$rtfeldman$elm_css$Css$padding(
			$rtfeldman$elm_css$Css$px(4))
		])
};
var $author$project$ImageEditor$Styled$Icon$RotateCCW$view = A2(
	$rtfeldman$elm_css$Svg$Styled$svg,
	_List_fromArray(
		[
			$rtfeldman$elm_css$Svg$Styled$Attributes$fill('white'),
			$rtfeldman$elm_css$Svg$Styled$Attributes$width('24px'),
			$rtfeldman$elm_css$Svg$Styled$Attributes$height('24px'),
			$rtfeldman$elm_css$Svg$Styled$Attributes$viewBox('0 0 24 24')
		]),
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Svg$Styled$path,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Svg$Styled$Attributes$d('M0 0h24v24H0z'),
					$rtfeldman$elm_css$Svg$Styled$Attributes$fill('none')
				]),
			_List_Nil),
			A2(
			$rtfeldman$elm_css$Svg$Styled$path,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Svg$Styled$Attributes$d('M7.11 8.53L5.7 7.11C4.8 8.27 4.24 9.61 4.07 11h2.02c.14-.87.49-1.72 1.02-2.47zM6.09 13H4.07c.17 1.39.72 2.73 1.62 3.89l1.41-1.42c-.52-.75-.87-1.59-1.01-2.47zm1.01 5.32c1.16.9 2.51 1.44 3.9 1.61V17.9c-.87-.15-1.71-.49-2.46-1.03L7.1 18.32zM13 4.07V1L8.45 5.55 13 10V6.09c2.84.48 5 2.94 5 5.91s-2.16 5.43-5 5.91v2.02c3.95-.49 7-3.85 7-7.93s-3.05-7.44-7-7.93z')
				]),
			_List_Nil)
		]));
var $author$project$ImageEditor$Styled$Icon$RotateCW$view = A2(
	$rtfeldman$elm_css$Svg$Styled$svg,
	_List_fromArray(
		[
			$rtfeldman$elm_css$Svg$Styled$Attributes$fill('white'),
			$rtfeldman$elm_css$Svg$Styled$Attributes$width('24px'),
			$rtfeldman$elm_css$Svg$Styled$Attributes$height('24px'),
			$rtfeldman$elm_css$Svg$Styled$Attributes$viewBox('0 0 24 24')
		]),
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Svg$Styled$path,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Svg$Styled$Attributes$d('M0 0h24v24H0z'),
					$rtfeldman$elm_css$Svg$Styled$Attributes$fill('none')
				]),
			_List_Nil),
			A2(
			$rtfeldman$elm_css$Svg$Styled$path,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Svg$Styled$Attributes$d('M15.55 5.55L11 1v3.07C7.06 4.56 4 7.92 4 12s3.05 7.44 7 7.93v-2.02c-2.84-.48-5-2.94-5-5.91s2.16-5.43 5-5.91V10l4.55-4.45zM19.93 11c-.17-1.39-.72-2.73-1.62-3.89l-1.42 1.42c.54.75.88 1.6 1.02 2.47h2.02zM13 17.9v2.02c1.39-.17 2.74-.71 3.9-1.61l-1.44-1.44c-.75.54-1.59.89-2.46 1.03zm3.89-2.42l1.42 1.41c.9-1.16 1.45-2.5 1.62-3.89h-2.02c-.14.87-.48 1.72-1.02 2.48z')
				]),
			_List_Nil)
		]));
var $author$project$ImageEditor$Styled$Icon$ZoomIn$view = A2(
	$rtfeldman$elm_css$Svg$Styled$svg,
	_List_fromArray(
		[
			$rtfeldman$elm_css$Svg$Styled$Attributes$fill('white'),
			$rtfeldman$elm_css$Svg$Styled$Attributes$width('24px'),
			$rtfeldman$elm_css$Svg$Styled$Attributes$height('24px'),
			$rtfeldman$elm_css$Svg$Styled$Attributes$viewBox('0 0 24 24')
		]),
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Svg$Styled$path,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Svg$Styled$Attributes$d('M0 0h24v24H0V0z'),
					$rtfeldman$elm_css$Svg$Styled$Attributes$fill('none')
				]),
			_List_Nil),
			A2(
			$rtfeldman$elm_css$Svg$Styled$path,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Svg$Styled$Attributes$d('M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z')
				]),
			_List_Nil),
			A2(
			$rtfeldman$elm_css$Svg$Styled$path,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Svg$Styled$Attributes$d('M12 10h-2v2H9v-2H7V9h2V7h1v2h2v1z')
				]),
			_List_Nil)
		]));
var $author$project$ImageEditor$Styled$Icon$ZoomOut$view = A2(
	$rtfeldman$elm_css$Svg$Styled$svg,
	_List_fromArray(
		[
			$rtfeldman$elm_css$Svg$Styled$Attributes$fill('white'),
			$rtfeldman$elm_css$Svg$Styled$Attributes$width('24px'),
			$rtfeldman$elm_css$Svg$Styled$Attributes$height('24px'),
			$rtfeldman$elm_css$Svg$Styled$Attributes$viewBox('0 0 24 24')
		]),
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Svg$Styled$path,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Svg$Styled$Attributes$d('M0 0h24v24H0V0z'),
					$rtfeldman$elm_css$Svg$Styled$Attributes$fill('none')
				]),
			_List_Nil),
			A2(
			$rtfeldman$elm_css$Svg$Styled$path,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Svg$Styled$Attributes$d('M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14zM7 9h5v1H7z')
				]),
			_List_Nil)
		]));
var $author$project$Page$BusinessProfile$Theme$imageEditorIcons = function (field) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BusinessProfile$Theme$styles.icons)
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BusinessProfile$Theme$styles.icon),
						$rtfeldman$elm_css$Html$Styled$Events$onClick(
						$author$project$Types$OnAuth(
							$author$project$Types$OnBusinessChangeTheme(
								A2(
									$author$project$Type$BusinessTheme$OnImageAction,
									field,
									$author$project$Type$BusinessTheme$ImageAction($author$project$ImageEditor$RotateCCW)))))
					]),
				_List_fromArray(
					[$author$project$ImageEditor$Styled$Icon$RotateCCW$view])),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BusinessProfile$Theme$styles.icon),
						$rtfeldman$elm_css$Html$Styled$Events$onClick(
						$author$project$Types$OnAuth(
							$author$project$Types$OnBusinessChangeTheme(
								A2(
									$author$project$Type$BusinessTheme$OnImageAction,
									field,
									$author$project$Type$BusinessTheme$ImageAction($author$project$ImageEditor$RotateCW)))))
					]),
				_List_fromArray(
					[$author$project$ImageEditor$Styled$Icon$RotateCW$view])),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BusinessProfile$Theme$styles.icon),
						$rtfeldman$elm_css$Html$Styled$Events$onClick(
						$author$project$Types$OnAuth(
							$author$project$Types$OnBusinessChangeTheme(
								A2(
									$author$project$Type$BusinessTheme$OnImageAction,
									field,
									$author$project$Type$BusinessTheme$ImageAction($author$project$ImageEditor$ZoomIn)))))
					]),
				_List_fromArray(
					[$author$project$ImageEditor$Styled$Icon$ZoomIn$view])),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BusinessProfile$Theme$styles.icon),
						$rtfeldman$elm_css$Html$Styled$Events$onClick(
						$author$project$Types$OnAuth(
							$author$project$Types$OnBusinessChangeTheme(
								A2(
									$author$project$Type$BusinessTheme$OnImageAction,
									field,
									$author$project$Type$BusinessTheme$ImageAction($author$project$ImageEditor$ZoomOut)))))
					]),
				_List_fromArray(
					[$author$project$ImageEditor$Styled$Icon$ZoomOut$view]))
			]));
};
var $author$project$Type$BusinessTheme$ImageRequested = {$: 'ImageRequested'};
var $author$project$Material$Styled$Icon$Publish$view = F2(
	function (attributes, children) {
		return A2(
			$rtfeldman$elm_css$Svg$Styled$svg,
			_Utils_ap(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Svg$Styled$Attributes$fill('black'),
						$rtfeldman$elm_css$Svg$Styled$Attributes$width('24px'),
						$rtfeldman$elm_css$Svg$Styled$Attributes$height('24px'),
						$rtfeldman$elm_css$Svg$Styled$Attributes$viewBox('0 0 24 24')
					]),
				attributes),
			_Utils_ap(
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Svg$Styled$path,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Svg$Styled$Attributes$d('M0 0h24v24H0z'),
								$rtfeldman$elm_css$Svg$Styled$Attributes$fill('none')
							]),
						_List_Nil),
						A2(
						$rtfeldman$elm_css$Svg$Styled$path,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Svg$Styled$Attributes$d('M5 4v2h14V4H5zm0 10h4v6h6v-6h4l-7-7-7 7z')
							]),
						_List_Nil)
					]),
				children));
	});
var $author$project$Material$Styled$Icon$publish = $author$project$Material$Styled$Icon$Publish$view;
var $author$project$Page$BusinessProfile$Theme$imageUploader = F5(
	function (label, caption, fieldType, field, style) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BusinessProfile$Theme$styles.fieldBox)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BusinessProfile$Theme$styles.fieldLabelBox)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(label),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BusinessProfile$Theme$styles.helperText)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(caption)
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BusinessProfile$Theme$styles.fieldInterfaceBox)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BusinessProfile$Theme$styles.fieldActionsBox)
								]),
							_List_fromArray(
								[
									function () {
									var _v0 = field.b;
									if (_v0.$ === 'Loading') {
										var photoUrl = _v0.a;
										return A2(
											$rtfeldman$elm_css$Html$Styled$img,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$css(style),
													$rtfeldman$elm_css$Html$Styled$Attributes$src(photoUrl)
												]),
											_List_Nil);
									} else {
										var _v1 = field.a;
										if (_v1 === '') {
											return A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil);
										} else {
											return A2(
												$rtfeldman$elm_css$Html$Styled$img,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$Attributes$css(style),
														$rtfeldman$elm_css$Html$Styled$Attributes$src(field.a)
													]),
												_List_Nil);
										}
									}
								}(),
									A2(
									$author$project$Material$Styled$Button$button,
									_List_fromArray(
										[
											$author$project$Material$Styled$Button$buttonType($author$project$Material$Styled$Button$ButtonType),
											$author$project$Material$Styled$Button$styles($author$project$Page$BusinessProfile$Theme$styles.uploadButton),
											$author$project$Material$Styled$Button$theme($author$project$Material$Styled$Button$grey),
											$author$project$Material$Styled$Button$onClick(
											$author$project$Types$OnAuth(
												$author$project$Types$OnBusinessChangeTheme(
													A2($author$project$Type$BusinessTheme$OnImageAction, fieldType, $author$project$Type$BusinessTheme$ImageRequested)))),
											$author$project$Material$Styled$Button$disabled(
											function () {
												var _v2 = field.b;
												if (_v2.$ === 'Loading') {
													return true;
												} else {
													return false;
												}
											}())
										]),
									_List_fromArray(
										[
											A2(
											$author$project$Material$Styled$Icon$publish,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Svg$Styled$Attributes$height('32px'),
													$rtfeldman$elm_css$Svg$Styled$Attributes$width('32px'),
													$rtfeldman$elm_css$Svg$Styled$Attributes$fill($author$project$Material$Styled$Color$grey500String)
												]),
											_List_Nil)
										]))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									function () {
									var _v3 = field.b;
									if (_v3.$ === 'Error') {
										return $rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BusinessProfile$Theme$styles.fieldErrorBox);
									} else {
										return $rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BusinessProfile$Theme$styles.fieldLoadingBox);
									}
								}()
								]),
							_List_fromArray(
								[
									function () {
									var _v4 = field.b;
									switch (_v4.$) {
										case 'Error':
											var errorString = _v4.a;
											return $rtfeldman$elm_css$Html$Styled$text(errorString);
										case 'Loading':
											return $rtfeldman$elm_css$Html$Styled$text('Uploading...');
										default:
											return $rtfeldman$elm_css$Html$Styled$text('');
									}
								}()
								]))
						]))
				]));
	});
var $author$project$ImageEditor$Styled$View$styles = {
	image: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$block),
			$rtfeldman$elm_css$Css$maxWidth(
			$rtfeldman$elm_css$Css$pct(100)),
			$rtfeldman$elm_css$Css$visibility($rtfeldman$elm_css$Css$hidden)
		])
};
var $author$project$ImageEditor$Styled$View$view = F2(
	function (containerStyles, base64ImageData) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(containerStyles)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$img,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$id('ImageEditorImageID'),
							$rtfeldman$elm_css$Html$Styled$Attributes$src(base64ImageData),
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$ImageEditor$Styled$View$styles.image)
						]),
					_List_Nil)
				]));
	});
var $author$project$Page$BusinessProfile$Theme$view = F2(
	function (languageSwitchModel, model) {
		var organisationPageLanguageData = languageSwitchModel.allLanguageData.location.myOrganisationPage;
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$h2,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(organisationPageLanguageData.customizeLandingPage)
						])),
					A2(
					$author$project$Material$Styled$Card$card,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$form,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BusinessProfile$Theme$styles.root)
								]),
							_List_fromArray(
								[
									A5($author$project$Page$BusinessProfile$Theme$imageUploader, organisationPageLanguageData.headerLogo, organisationPageLanguageData.lessThan300KB, $author$project$Type$BusinessTheme$HeaderLogo, model.headerLogo, $author$project$Page$BusinessProfile$Theme$styles.headerLogo),
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BusinessProfile$Theme$styles.fieldBox)
										]),
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$div,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BusinessProfile$Theme$styles.fieldLabelBox)
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(organisationPageLanguageData.headerBackgroundColour),
													A2(
													$rtfeldman$elm_css$Html$Styled$div,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BusinessProfile$Theme$styles.helperText)
														]),
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$text(organisationPageLanguageData.headerBackgroundDescription)
														]))
												])),
											A2(
											$rtfeldman$elm_css$Html$Styled$div,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BusinessProfile$Theme$styles.fieldInterfaceBox)
												]),
											_List_fromArray(
												[
													A2(
													$rtfeldman$elm_css$Html$Styled$div,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BusinessProfile$Theme$styles.fieldActionsBox)
														]),
													_List_fromArray(
														[
															A2(
															$rtfeldman$elm_css$Html$Styled$input,
															_List_fromArray(
																[
																	$rtfeldman$elm_css$Html$Styled$Attributes$type_('color'),
																	$rtfeldman$elm_css$Html$Styled$Events$onInput(
																	A2(
																		$elm$core$Basics$composeL,
																		A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnBusinessChangeTheme),
																		$author$project$Type$BusinessTheme$OnChange($author$project$Type$BusinessTheme$HeaderColor))),
																	$rtfeldman$elm_css$Html$Styled$Events$onBlur(
																	$author$project$Types$OnAuth(
																		$author$project$Types$OnBusinessChangeTheme(
																			$author$project$Type$BusinessTheme$OnBlur($author$project$Type$BusinessTheme$HeaderColor)))),
																	$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BusinessProfile$Theme$styles.inputColor),
																	$rtfeldman$elm_css$Html$Styled$Attributes$value(
																	function () {
																		var _v0 = model.headerColor.b;
																		if (_v0.$ === 'Loading') {
																			var newColor = _v0.a;
																			return newColor;
																		} else {
																			return model.headerColor.a;
																		}
																	}())
																]),
															_List_Nil)
														])),
													A2(
													$rtfeldman$elm_css$Html$Styled$div,
													_List_fromArray(
														[
															function () {
															var _v1 = model.headerColor.b;
															if (_v1.$ === 'Error') {
																return $rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BusinessProfile$Theme$styles.fieldErrorBox);
															} else {
																return $rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BusinessProfile$Theme$styles.fieldLoadingBox);
															}
														}()
														]),
													_List_fromArray(
														[
															function () {
															var _v2 = model.headerColor.b;
															switch (_v2.$) {
																case 'Error':
																	var errorString = _v2.a;
																	return $rtfeldman$elm_css$Html$Styled$text(errorString);
																case 'Loading':
																	return $rtfeldman$elm_css$Html$Styled$text('Uploading...');
																default:
																	return $rtfeldman$elm_css$Html$Styled$text('');
															}
														}()
														]))
												]))
										])),
									A5($author$project$Page$BusinessProfile$Theme$imageUploader, organisationPageLanguageData.bannerLogo, organisationPageLanguageData.lessThan500KB, $author$project$Type$BusinessTheme$BannerLogo, model.bannerLogo, $author$project$Page$BusinessProfile$Theme$styles.bannerLogo),
									A5($author$project$Page$BusinessProfile$Theme$imageUploader, organisationPageLanguageData.bannerBackground, organisationPageLanguageData.lessThan500KB, $author$project$Type$BusinessTheme$BannerBackground, model.bannerBackground, $author$project$Page$BusinessProfile$Theme$styles.bannerBackground)
								]))
						])),
					function () {
					var _v3 = model.imageEditorState;
					switch (_v3.$) {
						case 'Closed':
							return $rtfeldman$elm_css$Html$Styled$text('');
						case 'Processing':
							var field = _v3.a;
							var image = _v3.b;
							return A2(
								$author$project$Material$Styled$Modal$modal,
								_List_fromArray(
									[
										$author$project$Material$Styled$Modal$open(true),
										$author$project$Material$Styled$Modal$contentContainerstyles($author$project$Page$BusinessProfile$Theme$styles.modalContainer)
									]),
								_List_fromArray(
									[
										A2($author$project$ImageEditor$Styled$View$view, $author$project$Page$BusinessProfile$Theme$styles.imageEditor, image),
										$author$project$Page$BusinessProfile$Theme$imageEditorIcons(field),
										$author$project$View$SubmitButton$submitting('Processing')
									]));
						default:
							var field = _v3.a;
							var image = _v3.b;
							return A2(
								$author$project$Material$Styled$Modal$modal,
								_List_fromArray(
									[
										$author$project$Material$Styled$Modal$open(true),
										$author$project$Material$Styled$Modal$contentContainerstyles($author$project$Page$BusinessProfile$Theme$styles.modalContainer)
									]),
								_List_fromArray(
									[
										A2($author$project$ImageEditor$Styled$View$view, $author$project$Page$BusinessProfile$Theme$styles.imageEditor, image),
										$author$project$Page$BusinessProfile$Theme$imageEditorIcons(field),
										A2(
										$author$project$Material$Styled$Button$button,
										_List_fromArray(
											[
												$author$project$Material$Styled$Button$styles($author$project$Page$BusinessProfile$Theme$styles.button),
												$author$project$Material$Styled$Button$onClick(
												$author$project$Types$OnAuth(
													$author$project$Types$OnBusinessChangeTheme(
														A2(
															$author$project$Type$BusinessTheme$OnImageAction,
															field,
															$author$project$Type$BusinessTheme$ImageSubmit(image)))))
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('Submit')
											])),
										A2(
										$author$project$Material$Styled$Button$button,
										_List_fromArray(
											[
												$author$project$Material$Styled$Button$styles($author$project$Page$BusinessProfile$Theme$styles.button),
												$author$project$Material$Styled$Button$theme($author$project$Material$Styled$Button$grey),
												$author$project$Material$Styled$Button$onClick(
												$author$project$Types$OnAuth(
													$author$project$Types$OnBusinessChangeTheme(
														A2($author$project$Type$BusinessTheme$OnImageAction, field, $author$project$Type$BusinessTheme$ImageCancel))))
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('Cancel')
											]))
									]));
					}
				}()
				]));
	});
var $author$project$Material$Styled$Banner$ContainerStyles = function (a) {
	return {$: 'ContainerStyles', a: a};
};
var $author$project$Material$Styled$Banner$containerStyles = function (styles_) {
	return $author$project$Material$Styled$Banner$ContainerStyles(styles_);
};
var $author$project$Data$Api$Stamp$Delete$errorToString = function (error) {
	return 'Permission denied.';
};
var $author$project$Data$Api$Stamp$Upload$errorToString = function (error) {
	switch (error.$) {
		case 'EMPTY_NAME':
			return 'Name cannot be empty.';
		case 'INVALID_USERID':
			return 'Permission denied.';
		case 'INVALID_DOMAIN':
			return 'Permission denied.';
		case 'INVALID_LENGTH_NAME':
			return 'Name cannot be longer than 50 characters.';
		case 'INVALID_FILE':
			return 'Not a valid file.';
		case 'INVALID_FILE_TYPE':
			return 'Unexpected file type.';
		case 'FILE_TOO_BIG':
			return 'File size is larger than 300KB.';
		default:
			return 'Permission denied.';
	}
};
var $author$project$Data$PDF$Stamp$name = function (_v0) {
	var stamp = _v0.a;
	return stamp.name;
};
var $author$project$View$Stamp$styles = {
	button: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(140))
		]),
	buttonContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceBetween)
		]),
	container: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexWrap($rtfeldman$elm_css$Css$wrap),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$padding(
			$rtfeldman$elm_css$Css$px(16)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100)),
			$rtfeldman$elm_css$Css$maxWidth(
			$rtfeldman$elm_css$Css$px(900)),
			$rtfeldman$elm_css$Css$boxSizing($rtfeldman$elm_css$Css$borderBox)
		]),
	create: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			A4(
			$rtfeldman$elm_css$Css$margin4,
			$rtfeldman$elm_css$Css$px(20),
			$rtfeldman$elm_css$Css$zero,
			$rtfeldman$elm_css$Css$px(20),
			$rtfeldman$elm_css$Css$px(20)),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(100)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(100)),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(100)),
			A3(
			$rtfeldman$elm_css$Css$border3,
			$rtfeldman$elm_css$Css$px(1),
			$rtfeldman$elm_css$Css$solid,
			$author$project$Material$Styled$Color$blueA700),
			$rtfeldman$elm_css$Css$borderRadius(
			$rtfeldman$elm_css$Css$px(10)),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$blueA700),
			$rtfeldman$elm_css$Css$hover(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer)
				]))
		]),
	formStatus: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$relative),
			$rtfeldman$elm_css$Css$overflow($rtfeldman$elm_css$Css$hidden),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100)),
			$rtfeldman$elm_css$Css$minHeight(
			$rtfeldman$elm_css$Css$px(5))
		]),
	icon: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$margin(
			$rtfeldman$elm_css$Css$px(5)),
			$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer)
		]),
	icons: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$relative),
			$rtfeldman$elm_css$Css$top(
			$rtfeldman$elm_css$Css$px(-32)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100))
		]),
	imageEditor: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(320)),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(320))
		]),
	inputContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginBottom(
			$rtfeldman$elm_css$Css$px(20))
		]),
	loadErrorContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$padding(
			$rtfeldman$elm_css$Css$px(40)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100)),
			$rtfeldman$elm_css$Css$maxWidth(
			$rtfeldman$elm_css$Css$px(900)),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$red900)
		]),
	loadingContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$relative),
			$rtfeldman$elm_css$Css$overflow($rtfeldman$elm_css$Css$hidden),
			A2(
			$rtfeldman$elm_css$Css$padding2,
			$rtfeldman$elm_css$Css$px(40),
			$rtfeldman$elm_css$Css$zero),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100)),
			$rtfeldman$elm_css$Css$maxWidth(
			$rtfeldman$elm_css$Css$px(900)),
			$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center)
		]),
	modalContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(320)),
			$rtfeldman$elm_css$Css$padding(
			$rtfeldman$elm_css$Css$px(10))
		]),
	progressBar: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$absolute),
			$rtfeldman$elm_css$Css$bottom($rtfeldman$elm_css$Css$zero),
			$rtfeldman$elm_css$Css$left($rtfeldman$elm_css$Css$zero),
			$rtfeldman$elm_css$Css$maxWidth(
			$rtfeldman$elm_css$Css$px(900))
		]),
	reloadButton: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(20)),
			$rtfeldman$elm_css$Css$maxWidth($rtfeldman$elm_css$Css$fitContent)
		]),
	stampContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			A4(
			$rtfeldman$elm_css$Css$margin4,
			$rtfeldman$elm_css$Css$px(10),
			$rtfeldman$elm_css$Css$px(10),
			$rtfeldman$elm_css$Css$px(10),
			$rtfeldman$elm_css$Css$zero)
		]),
	stampImage: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(140)),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(140))
		]),
	stampImageContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(140)),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(140))
		]),
	stampName: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginBottom(
			$rtfeldman$elm_css$Css$px(5)),
			$rtfeldman$elm_css$Css$fontWeight(
			$rtfeldman$elm_css$Css$int(500)),
			$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center)
		])
};
var $author$project$View$Stamp$displayFormStatus = F2(
	function (model, selectedDomain) {
		var _v0 = model.formStatus;
		switch (_v0.$) {
			case 'Ready':
				return $rtfeldman$elm_css$Html$Styled$text('');
			case 'Submitting':
				var domain = _v0.a;
				return _Utils_eq(selectedDomain, domain) ? A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Stamp$styles.formStatus)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Material$Styled$ProgressBar$linear,
							_List_fromArray(
								[
									$author$project$Material$Styled$ProgressBar$containerStyle($author$project$View$Stamp$styles.progressBar)
								]),
							_List_Nil)
						])) : $rtfeldman$elm_css$Html$Styled$text('');
			case 'Error':
				var error = _v0.a;
				if (error.$ === 'DomainFormError') {
					var domain = error.a;
					var formError = error.b;
					if (_Utils_eq(domain, selectedDomain)) {
						switch (formError.$) {
							case 'DeleteStampError':
								var deleteError = formError.a;
								return A2(
									$author$project$Material$Styled$Banner$banner,
									_List_fromArray(
										[
											$author$project$Material$Styled$Banner$theme($author$project$Material$Styled$Banner$errorTheme),
											$author$project$Material$Styled$Banner$containerStyles($author$project$View$Stamp$styles.formStatus),
											$author$project$Material$Styled$Banner$title('Error'),
											$author$project$Material$Styled$Banner$body(
											$rtfeldman$elm_css$Html$Styled$text(
												A2($author$project$Data$Api$authErrorToString, $author$project$Data$Api$Stamp$Delete$errorToString, deleteError))),
											$author$project$Material$Styled$Banner$closeIconAttributes(
											_List_fromArray(
												[
													$rtfeldman$elm_css$Svg$Styled$Events$onClick(
													$author$project$Types$OnStamp($author$project$Type$Stamp$OnBannerClose))
												]))
										]),
									_List_Nil);
							case 'CreateStampError':
								var uploadError = formError.a;
								return A2(
									$author$project$Material$Styled$Banner$banner,
									_List_fromArray(
										[
											$author$project$Material$Styled$Banner$theme($author$project$Material$Styled$Banner$errorTheme),
											$author$project$Material$Styled$Banner$containerStyles($author$project$View$Stamp$styles.formStatus),
											$author$project$Material$Styled$Banner$title('Error'),
											$author$project$Material$Styled$Banner$body(
											$rtfeldman$elm_css$Html$Styled$text(
												A2($author$project$Data$Api$authErrorToString, $author$project$Data$Api$Stamp$Upload$errorToString, uploadError))),
											$author$project$Material$Styled$Banner$closeIconAttributes(
											_List_fromArray(
												[
													$rtfeldman$elm_css$Svg$Styled$Events$onClick(
													$author$project$Types$OnStamp($author$project$Type$Stamp$OnBannerClose))
												]))
										]),
									_List_Nil);
							default:
								var uploadError = formError.a;
								return A2(
									$author$project$Material$Styled$Banner$banner,
									_List_fromArray(
										[
											$author$project$Material$Styled$Banner$theme($author$project$Material$Styled$Banner$errorTheme),
											$author$project$Material$Styled$Banner$containerStyles($author$project$View$Stamp$styles.formStatus),
											$author$project$Material$Styled$Banner$title('Error'),
											$author$project$Material$Styled$Banner$body(
											$rtfeldman$elm_css$Html$Styled$text(
												$author$project$Data$Api$Stamp$Upload$errorToString(uploadError))),
											$author$project$Material$Styled$Banner$closeIconAttributes(
											_List_fromArray(
												[
													$rtfeldman$elm_css$Svg$Styled$Events$onClick(
													$author$project$Types$OnStamp($author$project$Type$Stamp$OnBannerClose))
												]))
										]),
									_List_Nil);
						}
					} else {
						return $rtfeldman$elm_css$Html$Styled$text('');
					}
				} else {
					return A2(
						$author$project$Material$Styled$Banner$banner,
						_List_fromArray(
							[
								$author$project$Material$Styled$Banner$theme($author$project$Material$Styled$Banner$errorTheme),
								$author$project$Material$Styled$Banner$containerStyles($author$project$View$Stamp$styles.formStatus),
								$author$project$Material$Styled$Banner$title('Error'),
								$author$project$Material$Styled$Banner$body(
								$rtfeldman$elm_css$Html$Styled$text('Domain is not set.')),
								$author$project$Material$Styled$Banner$closeIconAttributes(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Svg$Styled$Events$onClick(
										$author$project$Types$OnStamp($author$project$Type$Stamp$OnBannerClose))
									]))
							]),
						_List_Nil);
				}
			case 'CreateSuccess':
				var domain = _v0.a;
				var stamp = _v0.b;
				return _Utils_eq(selectedDomain, domain) ? A2(
					$author$project$Material$Styled$Banner$banner,
					_List_fromArray(
						[
							$author$project$Material$Styled$Banner$theme($author$project$Material$Styled$Banner$successTheme),
							$author$project$Material$Styled$Banner$containerStyles($author$project$View$Stamp$styles.formStatus),
							$author$project$Material$Styled$Banner$title('Success'),
							$author$project$Material$Styled$Banner$body(
							$rtfeldman$elm_css$Html$Styled$text(
								'Stamp ' + ($author$project$Data$PDF$Stamp$name(stamp) + ' is created successfully.'))),
							$author$project$Material$Styled$Banner$closeIconAttributes(
							_List_fromArray(
								[
									$rtfeldman$elm_css$Svg$Styled$Events$onClick(
									$author$project$Types$OnStamp($author$project$Type$Stamp$OnBannerClose))
								]))
						]),
					_List_Nil) : $rtfeldman$elm_css$Html$Styled$text('');
			default:
				var domain = _v0.a;
				var stamp = _v0.b;
				return _Utils_eq(selectedDomain, domain) ? A2(
					$author$project$Material$Styled$Banner$banner,
					_List_fromArray(
						[
							$author$project$Material$Styled$Banner$theme($author$project$Material$Styled$Banner$successTheme),
							$author$project$Material$Styled$Banner$containerStyles($author$project$View$Stamp$styles.formStatus),
							$author$project$Material$Styled$Banner$title('Success'),
							$author$project$Material$Styled$Banner$body(
							$rtfeldman$elm_css$Html$Styled$text(
								'Stamp ' + ($author$project$Data$PDF$Stamp$name(stamp) + ' is deleted successfully.'))),
							$author$project$Material$Styled$Banner$closeIconAttributes(
							_List_fromArray(
								[
									$rtfeldman$elm_css$Svg$Styled$Events$onClick(
									$author$project$Types$OnStamp($author$project$Type$Stamp$OnBannerClose))
								]))
						]),
					_List_Nil) : $rtfeldman$elm_css$Html$Styled$text('');
		}
	});
var $author$project$Type$Stamp$ImageCancel = {$: 'ImageCancel'};
var $author$project$Type$Stamp$ImageSubmit = function (a) {
	return {$: 'ImageSubmit', a: a};
};
var $author$project$Type$Stamp$ImageAction = function (a) {
	return {$: 'ImageAction', a: a};
};
var $author$project$View$Stamp$imageEditorIcons = A2(
	$rtfeldman$elm_css$Html$Styled$div,
	_List_fromArray(
		[
			$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Stamp$styles.icons)
		]),
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Stamp$styles.icon),
					$rtfeldman$elm_css$Html$Styled$Events$onClick(
					$author$project$Types$OnStamp(
						$author$project$Type$Stamp$OnImageUpload(
							$author$project$Type$Stamp$ImageAction($author$project$ImageEditor$RotateCCW))))
				]),
			_List_fromArray(
				[$author$project$ImageEditor$Styled$Icon$RotateCCW$view])),
			A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Stamp$styles.icon),
					$rtfeldman$elm_css$Html$Styled$Events$onClick(
					$author$project$Types$OnStamp(
						$author$project$Type$Stamp$OnImageUpload(
							$author$project$Type$Stamp$ImageAction($author$project$ImageEditor$RotateCW))))
				]),
			_List_fromArray(
				[$author$project$ImageEditor$Styled$Icon$RotateCW$view])),
			A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Stamp$styles.icon),
					$rtfeldman$elm_css$Html$Styled$Events$onClick(
					$author$project$Types$OnStamp(
						$author$project$Type$Stamp$OnImageUpload(
							$author$project$Type$Stamp$ImageAction($author$project$ImageEditor$ZoomIn))))
				]),
			_List_fromArray(
				[$author$project$ImageEditor$Styled$Icon$ZoomIn$view])),
			A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Stamp$styles.icon),
					$rtfeldman$elm_css$Html$Styled$Events$onClick(
					$author$project$Types$OnStamp(
						$author$project$Type$Stamp$OnImageUpload(
							$author$project$Type$Stamp$ImageAction($author$project$ImageEditor$ZoomOut))))
				]),
			_List_fromArray(
				[$author$project$ImageEditor$Styled$Icon$ZoomOut$view]))
		]));
var $author$project$View$Stamp$modal = function (model) {
	var _v0 = model.imageEditor;
	switch (_v0.$) {
		case 'Closed':
			return $rtfeldman$elm_css$Html$Styled$text('');
		case 'Processing':
			var image = _v0.a;
			return A2(
				$author$project$Material$Styled$Modal$modal,
				_List_fromArray(
					[
						$author$project$Material$Styled$Modal$open(true),
						$author$project$Material$Styled$Modal$contentContainerstyles($author$project$View$Stamp$styles.modalContainer)
					]),
				_List_fromArray(
					[
						A2($author$project$ImageEditor$Styled$View$view, $author$project$View$Stamp$styles.imageEditor, image),
						$author$project$View$Stamp$imageEditorIcons,
						$author$project$View$SubmitButton$submitting('Processing')
					]));
		case 'Opened':
			var image = _v0.a;
			return A2(
				$author$project$Material$Styled$Modal$modal,
				_List_fromArray(
					[
						$author$project$Material$Styled$Modal$open(true),
						$author$project$Material$Styled$Modal$contentContainerstyles($author$project$View$Stamp$styles.modalContainer)
					]),
				_List_fromArray(
					[
						A2($author$project$ImageEditor$Styled$View$view, $author$project$View$Stamp$styles.imageEditor, image),
						$author$project$View$Stamp$imageEditorIcons,
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Stamp$styles.buttonContainer)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Material$Styled$Button$button,
								_List_fromArray(
									[
										$author$project$Material$Styled$Button$styles($author$project$View$Stamp$styles.button),
										$author$project$Material$Styled$Button$onClick(
										$author$project$Types$OnStamp(
											$author$project$Type$Stamp$OnImageUpload(
												$author$project$Type$Stamp$ImageSubmit(image))))
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('Submit')
									])),
								A2(
								$author$project$Material$Styled$Button$button,
								_List_fromArray(
									[
										$author$project$Material$Styled$Button$styles($author$project$View$Stamp$styles.button),
										$author$project$Material$Styled$Button$theme($author$project$Material$Styled$Button$grey),
										$author$project$Material$Styled$Button$onClick(
										$author$project$Types$OnStamp(
											$author$project$Type$Stamp$OnImageUpload($author$project$Type$Stamp$ImageCancel)))
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('Cancel')
									]))
							]))
					]));
		default:
			return $rtfeldman$elm_css$Html$Styled$text('');
	}
};
var $author$project$Type$Stamp$ImageRequested = function (a) {
	return {$: 'ImageRequested', a: a};
};
var $author$project$View$Stamp$createStamp = function (domain) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Stamp$styles.create),
				$rtfeldman$elm_css$Html$Styled$Events$onClick(
				$author$project$Types$OnStamp(
					$author$project$Type$Stamp$OnImageUpload(
						$author$project$Type$Stamp$ImageRequested(domain))))
			]),
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$text('+')
			]));
};
var $author$project$Type$Stamp$Delete = F2(
	function (a, b) {
		return {$: 'Delete', a: a, b: b};
	});
var $author$project$Data$PDF$Stamp$isDeleted = function (_v0) {
	var stamp = _v0.a;
	return stamp.isDeleted;
};
var $author$project$Material$Styled$Color$redA200String = '#ff5252';
var $author$project$Material$Styled$Color$redA700String = '#d50000';
var $author$project$Material$Styled$Button$red = {base: $author$project$Material$Styled$Color$redA700String, ripple: $author$project$Material$Styled$Color$redA200String, text: $author$project$Material$Styled$Color$whiteString};
var $author$project$View$Stamp$displayStamp = F3(
	function (languageSwitchModel, domain, stamp) {
		var organisationPageLanguageData = languageSwitchModel.allLanguageData.location.myOrganisationPage;
		if ($author$project$Data$PDF$Stamp$isDeleted(stamp)) {
			return $rtfeldman$elm_css$Html$Styled$text('');
		} else {
			if (!A2(
				$author$project$Data$Domain$equal,
				$author$project$Data$PDF$Stamp$domain(stamp),
				domain)) {
				return $rtfeldman$elm_css$Html$Styled$text('');
			} else {
				var _v0 = $author$project$Data$PDF$Stamp$data(stamp);
				if (_v0.$ === 'NotLoaded') {
					return A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Stamp$styles.stampContainer)
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Stamp$styles.stampName)
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$Data$PDF$Stamp$name(stamp))
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Stamp$styles.stampImageContainer)
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('Loading...')
									]))
							]));
				} else {
					var localUrl = _v0.a;
					return A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Stamp$styles.stampContainer)
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Stamp$styles.stampImageContainer)
									]),
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$img,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$src(localUrl),
												$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Stamp$styles.stampImage)
											]),
										_List_Nil)
									])),
								A2(
								$author$project$Material$Styled$Button$button,
								_List_fromArray(
									[
										$author$project$Material$Styled$Button$styles($author$project$View$Stamp$styles.button),
										$author$project$Material$Styled$Button$onClick(
										$author$project$Types$OnStamp(
											A2($author$project$Type$Stamp$Delete, domain, stamp))),
										$author$project$Material$Styled$Button$theme($author$project$Material$Styled$Button$red)
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(organisationPageLanguageData._delete)
									]))
							]));
				}
			}
		}
	});
var $author$project$Type$Stamp$LoadStamps = function (a) {
	return {$: 'LoadStamps', a: a};
};
var $author$project$Data$Api$Stamp$List$errorToString = function (error) {
	return 'Permission denied.';
};
var $author$project$View$Stamp$loadError = F2(
	function (domain, apiError) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Stamp$styles.loadErrorContainer)
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text(
					A2(
						$elm$core$Maybe$withDefault,
						'Stamps failed to load.',
						A2(
							$elm$core$Maybe$map,
							$author$project$Data$Api$authErrorToString($author$project$Data$Api$Stamp$List$errorToString),
							apiError))),
					A2(
					$author$project$Material$Styled$Button$button,
					_List_fromArray(
						[
							$author$project$Material$Styled$Button$styles($author$project$View$Stamp$styles.reloadButton),
							$author$project$Material$Styled$Button$onClick(
							$author$project$Types$OnStamp(
								$author$project$Type$Stamp$LoadStamps(domain)))
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('Reload Stamps')
						]))
				]));
	});
var $author$project$View$Stamp$loading = A2(
	$rtfeldman$elm_css$Html$Styled$div,
	_List_fromArray(
		[
			$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Stamp$styles.loadingContainer)
		]),
	_List_fromArray(
		[
			$rtfeldman$elm_css$Html$Styled$text('Loading stamps...'),
			A2(
			$author$project$Material$Styled$ProgressBar$linear,
			_List_fromArray(
				[
					$author$project$Material$Styled$ProgressBar$containerStyle($author$project$View$Stamp$styles.progressBar)
				]),
			_List_Nil)
		]));
var $author$project$View$Stamp$renderStamps = F3(
	function (languageSwitchModel, domain, allStamps) {
		var _v0 = A2(
			$elm$core$Dict$get,
			$author$project$Data$Domain$toString(domain),
			allStamps);
		if (_v0.$ === 'Nothing') {
			return _List_fromArray(
				[
					A2($author$project$View$Stamp$loadError, domain, $elm$core$Maybe$Nothing)
				]);
		} else {
			var stampStatus = _v0.a;
			switch (stampStatus.$) {
				case 'Loading':
					return _List_fromArray(
						[$author$project$View$Stamp$loading]);
				case 'LoadError':
					var error = stampStatus.a;
					return _List_fromArray(
						[
							A2(
							$author$project$View$Stamp$loadError,
							domain,
							$elm$core$Maybe$Just(error))
						]);
				default:
					var stamps = stampStatus.a;
					return _Utils_ap(
						A2(
							$elm$core$List$map,
							A2($author$project$View$Stamp$displayStamp, languageSwitchModel, domain),
							$elm$core$Dict$values(stamps)),
						_List_fromArray(
							[
								$author$project$View$Stamp$createStamp(domain)
							]));
			}
		}
	});
var $author$project$View$Stamp$view = F3(
	function (languageSwitchModel, domain, model) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Stamp$styles.container)
				]),
			A2(
				$elm$core$List$cons,
				A2($author$project$View$Stamp$displayFormStatus, model, domain),
				_Utils_ap(
					A3($author$project$View$Stamp$renderStamps, languageSwitchModel, domain, model.stamps),
					_List_fromArray(
						[
							$author$project$View$Stamp$modal(model)
						]))));
	});
var $author$project$Page$BusinessProfileForm$view = F2(
	function (authModel, model) {
		var selectedDomain = $author$project$Data$Domain$selected(authModel.user.domains);
		var organisationPageLanguageData = model.languageSwitchModel.allLanguageData.location.myOrganisationPage;
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BusinessProfileForm$styles.container)
				]),
			_List_fromArray(
				[
					A2($author$project$Page$BusinessProfile$ManageUsers$view, authModel, model),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BusinessProfileForm$styles.spacer)
						]),
					_List_Nil),
					A2($author$project$Page$BusinessProfile$CouponCode$view, model.businessProfileModel, authModel.businessUserModel),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BusinessProfileForm$styles.spacer)
						]),
					_List_Nil),
					A2(
					$author$project$Page$BusinessProfile$BusinessReferralCode$view,
					$author$project$Data$Domain$toString(model.appDomain),
					model),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BusinessProfileForm$styles.spacer)
						]),
					_List_Nil),
					A2($author$project$Page$BusinessProfile$Theme$view, model.languageSwitchModel, authModel.businessThemeForm),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BusinessProfileForm$styles.spacer)
						]),
					_List_Nil),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$h2,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(organisationPageLanguageData.organisationStamps)
								])),
							A2(
							$author$project$Material$Styled$Card$card,
							_List_fromArray(
								[
									$author$project$Material$Styled$Card$containerStyles($author$project$Page$BusinessProfileForm$styles.rightContainer)
								]),
							_List_fromArray(
								[
									A3($author$project$View$Stamp$view, model.languageSwitchModel, selectedDomain, authModel.stampModel)
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BusinessProfileForm$styles.spacer)
						]),
					_List_Nil),
					A4(
					$author$project$Page$BusinessProfile$Profile$view,
					model.languageSwitchModel,
					model.businessProfileModel,
					model.baseHost,
					$author$project$Data$Domain$toString(selectedDomain))
				]));
	});
var $author$project$Type$BusinessRegister$CompanyName = {$: 'CompanyName'};
var $author$project$Type$BusinessRegister$Email = {$: 'Email'};
var $author$project$Type$BusinessRegister$FirstName = {$: 'FirstName'};
var $author$project$Type$BusinessRegister$LastName = {$: 'LastName'};
var $author$project$Type$BusinessRegister$OnAgreeTerms = {$: 'OnAgreeTerms'};
var $author$project$Type$BusinessRegister$OnBlur = function (a) {
	return {$: 'OnBlur', a: a};
};
var $author$project$Type$BusinessRegister$OnInput = F2(
	function (a, b) {
		return {$: 'OnInput', a: a, b: b};
	});
var $author$project$Type$BusinessRegister$OnSubmit = {$: 'OnSubmit'};
var $author$project$Type$BusinessRegister$Password = {$: 'Password'};
var $author$project$Type$BusinessRegister$PasswordAgain = {$: 'PasswordAgain'};
var $author$project$Type$BusinessRegister$ReferralCode = {$: 'ReferralCode'};
var $author$project$Type$BusinessRegister$SubDomain = {$: 'SubDomain'};
var $author$project$Data$Api$Register$Business$errorToString = function (error) {
	switch (error.$) {
		case 'INVALID_SUBDOMAIN':
			return 'SubDomain is invalid.';
		case 'INVALID_COMPANYNAME':
			return 'Company name is invalid.';
		case 'EMPTY_NAME':
			return 'Name cannot be empty.';
		case 'PASSWORD_REQUIREMENT':
			return 'Password did not meet the minimum requirement.';
		case 'USER_EXIST':
			return 'User has already exists.';
		case 'INVALID_EMAIL':
			return 'Email is not valid.';
		default:
			return 'Unable to update anonymous user account';
	}
};
var $author$project$Page$BusinessRegister$styles = {
	boldText: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontWeight(
			$rtfeldman$elm_css$Css$int(1000)),
			$rtfeldman$elm_css$Css$paddingBottom(
			$rtfeldman$elm_css$Css$px(50))
		]),
	box: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(18)),
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			A2(
			$rtfeldman$elm_css$Css$padding2,
			$rtfeldman$elm_css$Css$px(20),
			$rtfeldman$elm_css$Css$px(40)),
			$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center),
			A2(
			$rtfeldman$elm_css$Css$margin2,
			$rtfeldman$elm_css$Css$px(20),
			$rtfeldman$elm_css$Css$px(0))
		]),
	businessImageBox: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center)
		]),
	businessRegister: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$backgroundColor($author$project$Material$Styled$Color$white),
			$rtfeldman$elm_css$Css$marginRight(
			$rtfeldman$elm_css$Css$px(150)),
			A2(
			$rtfeldman$elm_css$Css$Media$withMediaQuery,
			_List_fromArray(
				['screen and (max-width: 1390px)']),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$backgroundColor($author$project$Material$Styled$Color$white),
					$rtfeldman$elm_css$Css$marginRight(
					$rtfeldman$elm_css$Css$px(0))
				]))
		]),
	businessText: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontWeight(
			$rtfeldman$elm_css$Css$int(1000)),
			$rtfeldman$elm_css$Css$lineHeight(
			$rtfeldman$elm_css$Css$px(40))
		]),
	buttonContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100)),
			A2(
			$rtfeldman$elm_css$Css$margin2,
			$rtfeldman$elm_css$Css$px(16),
			$rtfeldman$elm_css$Css$zero)
		]),
	centered: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(24)),
			$rtfeldman$elm_css$Css$marginBottom(
			$rtfeldman$elm_css$Css$px(-5))
		]),
	checkboxContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(8)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100)),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(14)),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$blueGrey600)
		]),
	desktop: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100)),
			A2(
			$rtfeldman$elm_css$Css$Media$withMediaQuery,
			_List_fromArray(
				['screen and (max-width: 1024px)']),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$none)
				]))
		]),
	divider: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			A3(
				$rtfeldman$elm_css$Css$calc,
				$rtfeldman$elm_css$Css$pct(100),
				$rtfeldman$elm_css$Css$minus,
				$rtfeldman$elm_css$Css$px(48)))
		]),
	domainContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$row),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100))
		]),
	domainEndText: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$paddingTop(
			$rtfeldman$elm_css$Css$px(35))
		]),
	domainInput: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(90))
		]),
	domainText: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(12)),
			$rtfeldman$elm_css$Css$paddingLeft(
			$rtfeldman$elm_css$Css$px(10)),
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(5)),
			$rtfeldman$elm_css$Css$marginBottom(
			$rtfeldman$elm_css$Css$px(20))
		]),
	form: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			A3(
				$rtfeldman$elm_css$Css$calc,
				$rtfeldman$elm_css$Css$pct(100),
				$rtfeldman$elm_css$Css$minus,
				$rtfeldman$elm_css$Css$px(48))),
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(70))
		]),
	formError: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(16)),
			$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(14)),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$red900)
		]),
	header: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(24)),
			A2(
			$rtfeldman$elm_css$Css$padding2,
			$rtfeldman$elm_css$Css$zero,
			$rtfeldman$elm_css$Css$px(30))
		]),
	heading: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(24)),
			$rtfeldman$elm_css$Css$color(
			$rtfeldman$elm_css$Css$hex('0040ab'))
		]),
	imageStyles: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(450)),
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(20))
		]),
	informationContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$backgroundColor(
			$rtfeldman$elm_css$Css$hex('#0040ab')),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$white),
			$rtfeldman$elm_css$Css$marginLeft(
			$rtfeldman$elm_css$Css$px(150)),
			A2(
			$rtfeldman$elm_css$Css$Media$withMediaQuery,
			_List_fromArray(
				['screen and (max-width: 1390px)']),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$backgroundColor(
					$rtfeldman$elm_css$Css$hex('#0040ab')),
					$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$white),
					$rtfeldman$elm_css$Css$marginLeft(
					$rtfeldman$elm_css$Css$px(0))
				]))
		]),
	informationTextContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			A4(
			$rtfeldman$elm_css$Css$padding4,
			$rtfeldman$elm_css$Css$px(10),
			$rtfeldman$elm_css$Css$px(120),
			$rtfeldman$elm_css$Css$px(30),
			$rtfeldman$elm_css$Css$px(120)),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center)
		]),
	inputContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100)),
			$rtfeldman$elm_css$Css$marginBottom(
			$rtfeldman$elm_css$Css$px(20))
		]),
	linkContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			A3(
				$rtfeldman$elm_css$Css$calc,
				$rtfeldman$elm_css$Css$pct(100),
				$rtfeldman$elm_css$Css$minus,
				$rtfeldman$elm_css$Css$px(48))),
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(16)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(70))
		]),
	listHeaderFont: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(18))
		]),
	message: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			A3(
				$rtfeldman$elm_css$Css$calc,
				$rtfeldman$elm_css$Css$pct(100),
				$rtfeldman$elm_css$Css$minus,
				$rtfeldman$elm_css$Css$px(48))),
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(-15)),
			$rtfeldman$elm_css$Css$marginBottom(
			$rtfeldman$elm_css$Css$px(20)),
			$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$fontWeight(
			$rtfeldman$elm_css$Css$int(900)),
			$rtfeldman$elm_css$Css$color(
			$rtfeldman$elm_css$Css$hex('0040ab'))
		]),
	mobile: _List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Css$Media$withMediaQuery,
			_List_fromArray(
				['screen and (min-width: 1025px)']),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$none)
				]))
		]),
	retryContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer),
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(10))
		]),
	sideContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			$rtfeldman$elm_css$Css$flex(
			$rtfeldman$elm_css$Css$num(1)),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$em(65)),
			$rtfeldman$elm_css$Css$paddingTop(
			$rtfeldman$elm_css$Css$px(40)),
			A2(
			$rtfeldman$elm_css$Css$Media$withMediaQuery,
			_List_fromArray(
				['screen and (max-width: 1123px)']),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$height(
					$rtfeldman$elm_css$Css$em(77))
				])),
			A2(
			$rtfeldman$elm_css$Css$Media$withMediaQuery,
			_List_fromArray(
				['screen and (max-width: 1180px)']),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$height(
					$rtfeldman$elm_css$Css$em(70))
				]))
		]),
	spacing: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$paddingBottom(
			$rtfeldman$elm_css$Css$px(24))
		]),
	subPoint: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$listStyleType($rtfeldman$elm_css$Css$none),
			$rtfeldman$elm_css$Css$fontStyle($rtfeldman$elm_css$Css$italic)
		]),
	termsError: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(11)),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$red900)
		]),
	textContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(11)),
			$rtfeldman$elm_css$Css$lineHeight(
			$rtfeldman$elm_css$Css$px(13)),
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(16)),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$blueGrey600)
		])
};
var $author$project$Page$BusinessRegister$displayFormError = function (formStatus) {
	if (formStatus.$ === 'Error') {
		var error = formStatus.a;
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BusinessRegister$styles.formError)
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text(
					A2($author$project$Data$Api$errorToString, $author$project$Data$Api$Register$Business$errorToString, error))
				]));
	} else {
		return $rtfeldman$elm_css$Html$Styled$text('');
	}
};
var $author$project$Page$BusinessRegister$displayTermsError = function (maybeError) {
	if (maybeError.$ === 'Nothing') {
		return $rtfeldman$elm_css$Html$Styled$text('');
	} else {
		var message = maybeError.a;
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BusinessRegister$styles.termsError)
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text(message)
				]));
	}
};
var $author$project$Page$BusinessRegister$showValidationStatus = function (status) {
	switch (status.$) {
		case 'Validating':
			return A2($author$project$Material$Styled$ProgressBar$linear, _List_Nil, _List_Nil);
		case 'Retry':
			return A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BusinessRegister$styles.retryContainer),
						$rtfeldman$elm_css$Html$Styled$Events$onClick(
						$author$project$Types$OnBusinessRegister($author$project$Type$BusinessRegister$OnValidateDomain))
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('An error occurred, please retry.')
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$img,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$src($author$project$View$Theme$images.retry)
							]),
						_List_Nil)
					]));
		default:
			return $rtfeldman$elm_css$Html$Styled$text('');
	}
};
var $author$project$Page$BusinessRegister$submitButton = function (model) {
	var hasError = A2(
		$elm$core$List$any,
		$elm$core$Basics$neq($elm$core$Maybe$Nothing),
		_List_fromArray(
			[model.companyNameError, model.firstNameError, model.lastNameError, model.emailError, model.passwordError, model.passwordAgainError, model.hasAgreedTermsError]));
	var _v0 = model;
	var formStatus = _v0.formStatus;
	var subdomainStatus = _v0.subdomainStatus;
	var validStatus = A2(
		$elm$core$Maybe$withDefault,
		false,
		A2(
			$elm$core$Maybe$map,
			function (status) {
				return _Utils_eq(status, $author$project$Data$Api$Register$ValidateDomain$NotUse);
			},
			subdomainStatus));
	switch (formStatus.$) {
		case 'Ready':
			return (hasError || (!validStatus)) ? $author$project$View$SubmitButton$disabled('SIGN UP') : $author$project$View$SubmitButton$enabled('SIGN UP');
		case 'Error':
			return $author$project$View$SubmitButton$enabled('SIGN UP');
		default:
			return $author$project$View$SubmitButton$submitting('Registering Your Account...');
	}
};
var $author$project$Page$BusinessRegister$businessRegister = F2(
	function (refCode, model) {
		var _v0 = model.businessRegisterModel;
		var formStatus = _v0.formStatus;
		var subdomain = _v0.subdomain;
		var subdomainStatus = _v0.subdomainStatus;
		var validationStatus = _v0.validationStatus;
		var redirectError = _v0.redirectError;
		var subdomainError = _v0.subdomainError;
		var companyName = _v0.companyName;
		var companyNameError = _v0.companyNameError;
		var firstName = _v0.firstName;
		var firstNameError = _v0.firstNameError;
		var lastName = _v0.lastName;
		var lastNameError = _v0.lastNameError;
		var email = _v0.email;
		var emailError = _v0.emailError;
		var password = _v0.password;
		var passwordError = _v0.passwordError;
		var passwordAgain = _v0.passwordAgain;
		var passwordAgainError = _v0.passwordAgainError;
		var hasAgreedTerms = _v0.hasAgreedTerms;
		var hasAgreedTermsError = _v0.hasAgreedTermsError;
		var referralCode = _v0.referralCode;
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_Utils_ap($author$project$Page$BusinessRegister$styles.sideContainer, $author$project$Page$BusinessRegister$styles.businessRegister))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$h2,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BusinessRegister$styles.heading)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('Start Your Free Trial')
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BusinessRegister$styles.message)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('Our full suite of features at your disposal')
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$form,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BusinessRegister$styles.form),
							$rtfeldman$elm_css$Html$Styled$Events$onSubmit(
							$author$project$Types$OnBusinessRegister($author$project$Type$BusinessRegister$OnSubmit))
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BusinessRegister$styles.domainContainer)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Material$Styled$Input$text,
									_List_fromArray(
										[
											$author$project$Material$Styled$Input$containerStyles($author$project$Page$BusinessRegister$styles.domainInput),
											$author$project$Material$Styled$Input$label('Subdomain *'),
											$author$project$Material$Styled$Input$value(subdomain),
											$author$project$Material$Styled$Input$errorMessage(subdomainError),
											$author$project$Material$Styled$Input$onInput(
											A2(
												$elm$core$Basics$composeL,
												$author$project$Types$OnBusinessRegister,
												$author$project$Type$BusinessRegister$OnInput($author$project$Type$BusinessRegister$SubDomain))),
											$author$project$Material$Styled$Input$onBlur(
											$author$project$Types$OnBusinessRegister(
												$author$project$Type$BusinessRegister$OnBlur($author$project$Type$BusinessRegister$SubDomain)))
										]),
									_List_Nil),
									A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BusinessRegister$styles.domainEndText)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('.' + model.baseHost)
										]))
								])),
							$author$project$Page$BusinessRegister$showValidationStatus(validationStatus),
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css(
									_Utils_ap($author$project$Page$BusinessRegister$styles.domainContainer, $author$project$Page$BusinessRegister$styles.domainText))
								]),
							_List_fromArray(
								[
									function () {
									if (subdomainStatus.$ === 'Just') {
										var value = subdomainStatus.a;
										if (value.$ === 'NotUse') {
											return $rtfeldman$elm_css$Html$Styled$text(
												$author$project$Model$BusinessRegister$trimRemoveSpace(subdomain) + ('.' + (model.baseHost + ' is available')));
										} else {
											return $rtfeldman$elm_css$Html$Styled$text('');
										}
									} else {
										return $rtfeldman$elm_css$Html$Styled$text('');
									}
								}()
								])),
							A2(
							$author$project$Material$Styled$Input$text,
							_List_fromArray(
								[
									$author$project$Material$Styled$Input$containerStyles($author$project$Page$BusinessRegister$styles.inputContainer),
									$author$project$Material$Styled$Input$label('Company Name *'),
									$author$project$Material$Styled$Input$value(companyName),
									$author$project$Material$Styled$Input$errorMessage(companyNameError),
									$author$project$Material$Styled$Input$onInput(
									A2(
										$elm$core$Basics$composeL,
										$author$project$Types$OnBusinessRegister,
										$author$project$Type$BusinessRegister$OnInput($author$project$Type$BusinessRegister$CompanyName))),
									$author$project$Material$Styled$Input$onBlur(
									$author$project$Types$OnBusinessRegister(
										$author$project$Type$BusinessRegister$OnBlur($author$project$Type$BusinessRegister$CompanyName)))
								]),
							_List_Nil),
							A2(
							$author$project$Material$Styled$Input$text,
							_List_fromArray(
								[
									$author$project$Material$Styled$Input$containerStyles($author$project$Page$BusinessRegister$styles.inputContainer),
									$author$project$Material$Styled$Input$label('First Name *'),
									$author$project$Material$Styled$Input$value(firstName),
									$author$project$Material$Styled$Input$errorMessage(firstNameError),
									$author$project$Material$Styled$Input$onInput(
									A2(
										$elm$core$Basics$composeL,
										$author$project$Types$OnBusinessRegister,
										$author$project$Type$BusinessRegister$OnInput($author$project$Type$BusinessRegister$FirstName))),
									$author$project$Material$Styled$Input$onBlur(
									$author$project$Types$OnBusinessRegister(
										$author$project$Type$BusinessRegister$OnBlur($author$project$Type$BusinessRegister$FirstName)))
								]),
							_List_Nil),
							A2(
							$author$project$Material$Styled$Input$text,
							_List_fromArray(
								[
									$author$project$Material$Styled$Input$containerStyles($author$project$Page$BusinessRegister$styles.inputContainer),
									$author$project$Material$Styled$Input$label('Last Name *'),
									$author$project$Material$Styled$Input$value(lastName),
									$author$project$Material$Styled$Input$errorMessage(lastNameError),
									$author$project$Material$Styled$Input$onInput(
									A2(
										$elm$core$Basics$composeL,
										$author$project$Types$OnBusinessRegister,
										$author$project$Type$BusinessRegister$OnInput($author$project$Type$BusinessRegister$LastName))),
									$author$project$Material$Styled$Input$onBlur(
									$author$project$Types$OnBusinessRegister(
										$author$project$Type$BusinessRegister$OnBlur($author$project$Type$BusinessRegister$LastName)))
								]),
							_List_Nil),
							A2(
							$author$project$Material$Styled$Input$email,
							_List_fromArray(
								[
									$author$project$Material$Styled$Input$containerStyles($author$project$Page$BusinessRegister$styles.inputContainer),
									$author$project$Material$Styled$Input$label('Email Address *'),
									$author$project$Material$Styled$Input$value(email),
									$author$project$Material$Styled$Input$errorMessage(emailError),
									$author$project$Material$Styled$Input$onInput(
									A2(
										$elm$core$Basics$composeL,
										$author$project$Types$OnBusinessRegister,
										$author$project$Type$BusinessRegister$OnInput($author$project$Type$BusinessRegister$Email))),
									$author$project$Material$Styled$Input$onBlur(
									$author$project$Types$OnBusinessRegister(
										$author$project$Type$BusinessRegister$OnBlur($author$project$Type$BusinessRegister$Email)))
								]),
							_List_Nil),
							A2(
							$author$project$Material$Styled$Input$password,
							_List_fromArray(
								[
									$author$project$Material$Styled$Input$containerStyles($author$project$Page$BusinessRegister$styles.inputContainer),
									$author$project$Material$Styled$Input$label('Password *'),
									$author$project$Material$Styled$Input$value(password),
									$author$project$Material$Styled$Input$infoMessage('Password must contain at least 8 characters, a lowercase letter,\nan uppercase letter and a number'),
									$author$project$Material$Styled$Input$errorMessage(passwordError),
									$author$project$Material$Styled$Input$onInput(
									A2(
										$elm$core$Basics$composeL,
										$author$project$Types$OnBusinessRegister,
										$author$project$Type$BusinessRegister$OnInput($author$project$Type$BusinessRegister$Password))),
									$author$project$Material$Styled$Input$onBlur(
									$author$project$Types$OnBusinessRegister(
										$author$project$Type$BusinessRegister$OnBlur($author$project$Type$BusinessRegister$Password)))
								]),
							_List_Nil),
							A2(
							$author$project$Material$Styled$Input$password,
							_List_fromArray(
								[
									$author$project$Material$Styled$Input$containerStyles($author$project$Page$BusinessRegister$styles.inputContainer),
									$author$project$Material$Styled$Input$label('Confirm Password *'),
									$author$project$Material$Styled$Input$value(passwordAgain),
									$author$project$Material$Styled$Input$errorMessage(passwordAgainError),
									$author$project$Material$Styled$Input$onInput(
									A2(
										$elm$core$Basics$composeL,
										$author$project$Types$OnBusinessRegister,
										$author$project$Type$BusinessRegister$OnInput($author$project$Type$BusinessRegister$PasswordAgain))),
									$author$project$Material$Styled$Input$onBlur(
									$author$project$Types$OnBusinessRegister(
										$author$project$Type$BusinessRegister$OnBlur($author$project$Type$BusinessRegister$PasswordAgain)))
								]),
							_List_Nil),
							A2(
							$author$project$Material$Styled$Input$text,
							_List_fromArray(
								[
									$author$project$Material$Styled$Input$containerStyles($author$project$Page$BusinessRegister$styles.inputContainer),
									$author$project$Material$Styled$Input$label('Referral Code (Optional)'),
									$author$project$Material$Styled$Input$value(referralCode),
									$author$project$Material$Styled$Input$onInput(
									A2(
										$elm$core$Basics$composeL,
										$author$project$Types$OnBusinessRegister,
										$author$project$Type$BusinessRegister$OnInput($author$project$Type$BusinessRegister$ReferralCode))),
									$author$project$Material$Styled$Input$onBlur(
									$author$project$Types$OnBusinessRegister(
										$author$project$Type$BusinessRegister$OnBlur($author$project$Type$BusinessRegister$ReferralCode))),
									$author$project$Material$Styled$Input$disabled(
									function () {
										if (refCode.$ === 'Just') {
											return true;
										} else {
											return false;
										}
									}())
								]),
							_List_Nil),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BusinessRegister$styles.checkboxContainer)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Material$Styled$Checkbox$checkbox,
									_List_fromArray(
										[
											$author$project$Material$Styled$Checkbox$onClick(
											$author$project$Types$OnBusinessRegister($author$project$Type$BusinessRegister$OnAgreeTerms)),
											$author$project$Material$Styled$Checkbox$checked(hasAgreedTerms)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('I agree to the terms of service and privacy policy published '),
											A2(
											$author$project$Material$Styled$A$a,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$href('https://www.sign.net/legal/')
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text('here')
												])),
											$rtfeldman$elm_css$Html$Styled$text('.'),
											$author$project$Page$BusinessRegister$displayTermsError(hasAgreedTermsError)
										]))
								])),
							$author$project$Page$BusinessRegister$displayFormError(formStatus),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BusinessRegister$styles.formError)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									A2($elm$core$Maybe$withDefault, '', redirectError))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BusinessRegister$styles.buttonContainer)
								]),
							_List_fromArray(
								[
									$author$project$Page$BusinessRegister$submitButton(model.businessRegisterModel)
								]))
						])),
					A2(
					$author$project$Material$Styled$Divider$divider,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BusinessRegister$styles.divider)
						]),
					_List_Nil),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BusinessRegister$styles.linkContainer)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Material$Styled$A$a,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$href($author$project$Data$Route$routeUrl.login)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Return to login')
								]))
						]))
				]));
	});
var $author$project$Page$BusinessRegister$list = A2(
	$rtfeldman$elm_css$Html$Styled$div,
	_List_Nil,
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Html$Styled$ul,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$li,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_Utils_ap($author$project$Page$BusinessRegister$styles.businessText, $author$project$Page$BusinessRegister$styles.listHeaderFont))
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('Custom Domain for your Organisation')
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$li,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_Utils_ap($author$project$Page$BusinessRegister$styles.subPoint, $author$project$Page$BusinessRegister$styles.businessText))
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('https://yourcompany.sign.net')
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$li,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BusinessRegister$styles.businessText)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Organisation Management ')
								])),
							$rtfeldman$elm_css$Html$Styled$text('User Permissions and Corporate Representation')
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$li,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BusinessRegister$styles.businessText)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Document Workflow Templates Automate ')
								])),
							$rtfeldman$elm_css$Html$Styled$text('Signing Requests through PDF Forms')
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$li,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BusinessRegister$styles.businessText)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Organisation Document Repository ')
								])),
							$rtfeldman$elm_css$Html$Styled$text('Granular permissions for documents ')
						]))
				]))
		]));
var $author$project$Page$BusinessRegister$listInformation = A2(
	$rtfeldman$elm_css$Html$Styled$div,
	_List_fromArray(
		[
			$rtfeldman$elm_css$Html$Styled$Attributes$css(
			_Utils_ap($author$project$Page$BusinessRegister$styles.sideContainer, $author$project$Page$BusinessRegister$styles.informationContainer))
		]),
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Html$Styled$h1,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BusinessRegister$styles.header)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('Ready to Transform Your Business Into a Powerhouse?')
						]))
				])),
			A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BusinessRegister$styles.businessImageBox)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$img,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$src($author$project$View$Theme$images.myCompanyWide),
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BusinessRegister$styles.imageStyles)
						]),
					_List_Nil),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BusinessRegister$styles.box)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BusinessRegister$styles.spacing)
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BusinessRegister$styles.boldText)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('Enhance ')
										])),
									$rtfeldman$elm_css$Html$Styled$text('your customer experience')
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BusinessRegister$styles.spacing)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Close deals '),
									A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BusinessRegister$styles.boldText)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('anytime, anywhere')
										]))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BusinessRegister$styles.spacing)
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BusinessRegister$styles.boldText)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('Modernise ')
										])),
									$rtfeldman$elm_css$Html$Styled$text('the agreement process')
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BusinessRegister$styles.boldText)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('Efficient ')
										])),
									$rtfeldman$elm_css$Html$Styled$text('and '),
									A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BusinessRegister$styles.boldText)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('secure ')
										])),
									$rtfeldman$elm_css$Html$Styled$text('workflows')
								]))
						]))
				])),
			A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BusinessRegister$styles.informationTextContainer)
				]),
			_List_fromArray(
				[
					A2($author$project$Material$Styled$Divider$divider, _List_Nil, _List_Nil),
					A2(
					$rtfeldman$elm_css$Html$Styled$h1,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BusinessRegister$styles.centered)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('A Comprehensive Suite of Features to Automate your Workflow Processes')
						])),
					$author$project$Page$BusinessRegister$list
				]))
		]));
var $author$project$Page$Register$Business$BusinessRegisterMobile$styles = {
	arrow: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$paddingTop(
			$rtfeldman$elm_css$Css$px(20)),
			A2(
			$rtfeldman$elm_css$Css$Media$withMediaQuery,
			_List_fromArray(
				['screen and (min-width: 700px)']),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$none)
				]))
		]),
	boldText: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontWeight(
			$rtfeldman$elm_css$Css$int(1000)),
			$rtfeldman$elm_css$Css$paddingBottom(
			$rtfeldman$elm_css$Css$px(50))
		]),
	box: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(20)),
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			A2(
			$rtfeldman$elm_css$Css$padding2,
			$rtfeldman$elm_css$Css$px(30),
			$rtfeldman$elm_css$Css$px(40)),
			$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$marginBottom(
			$rtfeldman$elm_css$Css$px(30))
		]),
	businessImageBox: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$marginBottom(
			$rtfeldman$elm_css$Css$px(0)),
			A2(
			$rtfeldman$elm_css$Css$Media$withMediaQuery,
			_List_fromArray(
				['screen and (max-width: 700px)']),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column)
				]))
		]),
	businessRegister: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$backgroundColor($author$project$Material$Styled$Color$white),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(75)),
			A2(
			$rtfeldman$elm_css$Css$Media$withMediaQuery,
			_List_fromArray(
				['screen and (max-width: 700px)']),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$width(
					$rtfeldman$elm_css$Css$pct(100))
				]))
		]),
	buttonContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100)),
			A2(
			$rtfeldman$elm_css$Css$margin2,
			$rtfeldman$elm_css$Css$px(16),
			$rtfeldman$elm_css$Css$zero)
		]),
	checkboxContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(8)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100)),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(14)),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$blueGrey600)
		]),
	container: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100)),
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column)
		]),
	divider: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			A3(
				$rtfeldman$elm_css$Css$calc,
				$rtfeldman$elm_css$Css$pct(100),
				$rtfeldman$elm_css$Css$minus,
				$rtfeldman$elm_css$Css$px(48)))
		]),
	domainContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$row),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100))
		]),
	domainEndText: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$paddingTop(
			$rtfeldman$elm_css$Css$px(35))
		]),
	domainInput: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(90))
		]),
	domainText: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(12)),
			$rtfeldman$elm_css$Css$paddingLeft(
			$rtfeldman$elm_css$Css$px(10)),
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(5)),
			$rtfeldman$elm_css$Css$marginBottom(
			$rtfeldman$elm_css$Css$px(20))
		]),
	form: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			A3(
				$rtfeldman$elm_css$Css$calc,
				$rtfeldman$elm_css$Css$pct(100),
				$rtfeldman$elm_css$Css$minus,
				$rtfeldman$elm_css$Css$px(48))),
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(65))
		]),
	formError: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(16)),
			$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(14)),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$red900)
		]),
	header: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(24)),
			A2(
			$rtfeldman$elm_css$Css$padding2,
			$rtfeldman$elm_css$Css$zero,
			$rtfeldman$elm_css$Css$px(30))
		]),
	heading: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(24)),
			$rtfeldman$elm_css$Css$color(
			$rtfeldman$elm_css$Css$hex('2d64b1'))
		]),
	imageContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(300))
		]),
	imageStyles: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(280)),
			$rtfeldman$elm_css$Css$margin(
			$rtfeldman$elm_css$Css$px(15))
		]),
	informationContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$backgroundColor(
			$rtfeldman$elm_css$Css$hex('#0040ab')),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$white),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(75)),
			$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center),
			A2(
			$rtfeldman$elm_css$Css$Media$withMediaQuery,
			_List_fromArray(
				['screen and (max-width: 700px)']),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$width(
					$rtfeldman$elm_css$Css$pct(100))
				]))
		]),
	inputContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100)),
			$rtfeldman$elm_css$Css$marginBottom(
			$rtfeldman$elm_css$Css$px(20))
		]),
	linkContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			A3(
				$rtfeldman$elm_css$Css$calc,
				$rtfeldman$elm_css$Css$pct(100),
				$rtfeldman$elm_css$Css$minus,
				$rtfeldman$elm_css$Css$px(48))),
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(16)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(65)),
			$rtfeldman$elm_css$Css$paddingBottom(
			$rtfeldman$elm_css$Css$px(30))
		]),
	message: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			A3(
				$rtfeldman$elm_css$Css$calc,
				$rtfeldman$elm_css$Css$pct(100),
				$rtfeldman$elm_css$Css$minus,
				$rtfeldman$elm_css$Css$px(48))),
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(-15)),
			$rtfeldman$elm_css$Css$marginBottom(
			$rtfeldman$elm_css$Css$px(20)),
			$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$fontWeight(
			$rtfeldman$elm_css$Css$int(900)),
			$rtfeldman$elm_css$Css$color(
			$rtfeldman$elm_css$Css$hex('2d64b1'))
		]),
	retryContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer),
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(10))
		]),
	sideContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			$rtfeldman$elm_css$Css$flex(
			$rtfeldman$elm_css$Css$num(1)),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$em(62)),
			$rtfeldman$elm_css$Css$paddingTop(
			$rtfeldman$elm_css$Css$px(40))
		]),
	spacing: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$paddingBottom(
			$rtfeldman$elm_css$Css$px(24))
		]),
	termsError: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(11)),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$red900)
		]),
	textContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(11)),
			$rtfeldman$elm_css$Css$lineHeight(
			$rtfeldman$elm_css$Css$px(13)),
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(16)),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$blueGrey600)
		])
};
var $author$project$Page$Register$Business$BusinessRegisterMobile$displayFormError = function (formStatus) {
	if (formStatus.$ === 'Error') {
		var error = formStatus.a;
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Register$Business$BusinessRegisterMobile$styles.formError)
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text(
					A2($author$project$Data$Api$errorToString, $author$project$Data$Api$Register$Business$errorToString, error))
				]));
	} else {
		return $rtfeldman$elm_css$Html$Styled$text('');
	}
};
var $author$project$Page$Register$Business$BusinessRegisterMobile$displayTermsError = function (maybeError) {
	if (maybeError.$ === 'Nothing') {
		return $rtfeldman$elm_css$Html$Styled$text('');
	} else {
		var message = maybeError.a;
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Register$Business$BusinessRegisterMobile$styles.termsError)
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text(message)
				]));
	}
};
var $author$project$Page$Register$Business$BusinessRegisterMobile$showValidationStatus = function (status) {
	switch (status.$) {
		case 'Validating':
			return A2($author$project$Material$Styled$ProgressBar$linear, _List_Nil, _List_Nil);
		case 'Retry':
			return A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Register$Business$BusinessRegisterMobile$styles.retryContainer),
						$rtfeldman$elm_css$Html$Styled$Events$onClick(
						$author$project$Types$OnBusinessRegister($author$project$Type$BusinessRegister$OnValidateDomain))
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('An error occurred, please retry.')
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$img,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$src($author$project$View$Theme$images.retry)
							]),
						_List_Nil)
					]));
		default:
			return $rtfeldman$elm_css$Html$Styled$text('');
	}
};
var $author$project$Page$Register$Business$BusinessRegisterMobile$submitButton = function (model) {
	var hasError = A2(
		$elm$core$List$any,
		$elm$core$Basics$neq($elm$core$Maybe$Nothing),
		_List_fromArray(
			[model.companyNameError, model.firstNameError, model.lastNameError, model.emailError, model.passwordError, model.passwordAgainError, model.hasAgreedTermsError]));
	var _v0 = model;
	var formStatus = _v0.formStatus;
	var subdomainStatus = _v0.subdomainStatus;
	var validStatus = A2(
		$elm$core$Maybe$withDefault,
		false,
		A2(
			$elm$core$Maybe$map,
			function (status) {
				return _Utils_eq(status, $author$project$Data$Api$Register$ValidateDomain$NotUse);
			},
			subdomainStatus));
	switch (formStatus.$) {
		case 'Ready':
			return (hasError || (!validStatus)) ? $author$project$View$SubmitButton$disabled('SIGN UP') : $author$project$View$SubmitButton$enabled('SIGN UP');
		case 'Error':
			return $author$project$View$SubmitButton$enabled('SIGN UP');
		default:
			return $author$project$View$SubmitButton$submitting('Registering Your Account...');
	}
};
var $author$project$Page$Register$Business$BusinessRegisterMobile$businessRegister = F2(
	function (refCode, model) {
		var _v0 = model.businessRegisterModel;
		var formStatus = _v0.formStatus;
		var subdomain = _v0.subdomain;
		var subdomainStatus = _v0.subdomainStatus;
		var validationStatus = _v0.validationStatus;
		var redirectError = _v0.redirectError;
		var subdomainError = _v0.subdomainError;
		var companyName = _v0.companyName;
		var companyNameError = _v0.companyNameError;
		var firstName = _v0.firstName;
		var firstNameError = _v0.firstNameError;
		var lastName = _v0.lastName;
		var lastNameError = _v0.lastNameError;
		var email = _v0.email;
		var emailError = _v0.emailError;
		var password = _v0.password;
		var passwordError = _v0.passwordError;
		var passwordAgain = _v0.passwordAgain;
		var passwordAgainError = _v0.passwordAgainError;
		var hasAgreedTerms = _v0.hasAgreedTerms;
		var hasAgreedTermsError = _v0.hasAgreedTermsError;
		var referralCode = _v0.referralCode;
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_Utils_ap($author$project$Page$Register$Business$BusinessRegisterMobile$styles.sideContainer, $author$project$Page$Register$Business$BusinessRegisterMobile$styles.businessRegister)),
					$rtfeldman$elm_css$Html$Styled$Attributes$id('businessRegister')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$h2,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Register$Business$BusinessRegisterMobile$styles.heading)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('Start Your 45-Day Trial')
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Register$Business$BusinessRegisterMobile$styles.message)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('Our full suite of features at your disposal')
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$form,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Register$Business$BusinessRegisterMobile$styles.form),
							$rtfeldman$elm_css$Html$Styled$Events$onSubmit(
							$author$project$Types$OnBusinessRegister($author$project$Type$BusinessRegister$OnSubmit))
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Register$Business$BusinessRegisterMobile$styles.domainContainer)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Material$Styled$Input$text,
									_List_fromArray(
										[
											$author$project$Material$Styled$Input$containerStyles($author$project$Page$Register$Business$BusinessRegisterMobile$styles.domainInput),
											$author$project$Material$Styled$Input$label('Subdomain *'),
											$author$project$Material$Styled$Input$value(subdomain),
											$author$project$Material$Styled$Input$errorMessage(subdomainError),
											$author$project$Material$Styled$Input$onInput(
											A2(
												$elm$core$Basics$composeL,
												$author$project$Types$OnBusinessRegister,
												$author$project$Type$BusinessRegister$OnInput($author$project$Type$BusinessRegister$SubDomain))),
											$author$project$Material$Styled$Input$onBlur(
											$author$project$Types$OnBusinessRegister(
												$author$project$Type$BusinessRegister$OnBlur($author$project$Type$BusinessRegister$SubDomain)))
										]),
									_List_Nil),
									A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Register$Business$BusinessRegisterMobile$styles.domainEndText)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('.' + model.baseHost)
										]))
								])),
							$author$project$Page$Register$Business$BusinessRegisterMobile$showValidationStatus(validationStatus),
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css(
									_Utils_ap($author$project$Page$Register$Business$BusinessRegisterMobile$styles.domainContainer, $author$project$Page$Register$Business$BusinessRegisterMobile$styles.domainText))
								]),
							_List_fromArray(
								[
									function () {
									if (subdomainStatus.$ === 'Just') {
										var value = subdomainStatus.a;
										if (value.$ === 'NotUse') {
											return $rtfeldman$elm_css$Html$Styled$text(
												$author$project$Model$BusinessRegister$trimRemoveSpace(subdomain) + ('.' + (model.baseHost + ' is available')));
										} else {
											return $rtfeldman$elm_css$Html$Styled$text('');
										}
									} else {
										return $rtfeldman$elm_css$Html$Styled$text('');
									}
								}()
								])),
							A2(
							$author$project$Material$Styled$Input$text,
							_List_fromArray(
								[
									$author$project$Material$Styled$Input$containerStyles($author$project$Page$Register$Business$BusinessRegisterMobile$styles.inputContainer),
									$author$project$Material$Styled$Input$label('Company Name *'),
									$author$project$Material$Styled$Input$value(companyName),
									$author$project$Material$Styled$Input$errorMessage(companyNameError),
									$author$project$Material$Styled$Input$onInput(
									A2(
										$elm$core$Basics$composeL,
										$author$project$Types$OnBusinessRegister,
										$author$project$Type$BusinessRegister$OnInput($author$project$Type$BusinessRegister$CompanyName))),
									$author$project$Material$Styled$Input$onBlur(
									$author$project$Types$OnBusinessRegister(
										$author$project$Type$BusinessRegister$OnBlur($author$project$Type$BusinessRegister$CompanyName)))
								]),
							_List_Nil),
							A2(
							$author$project$Material$Styled$Input$text,
							_List_fromArray(
								[
									$author$project$Material$Styled$Input$containerStyles($author$project$Page$Register$Business$BusinessRegisterMobile$styles.inputContainer),
									$author$project$Material$Styled$Input$label('First Name *'),
									$author$project$Material$Styled$Input$value(firstName),
									$author$project$Material$Styled$Input$errorMessage(firstNameError),
									$author$project$Material$Styled$Input$onInput(
									A2(
										$elm$core$Basics$composeL,
										$author$project$Types$OnBusinessRegister,
										$author$project$Type$BusinessRegister$OnInput($author$project$Type$BusinessRegister$FirstName))),
									$author$project$Material$Styled$Input$onBlur(
									$author$project$Types$OnBusinessRegister(
										$author$project$Type$BusinessRegister$OnBlur($author$project$Type$BusinessRegister$FirstName)))
								]),
							_List_Nil),
							A2(
							$author$project$Material$Styled$Input$text,
							_List_fromArray(
								[
									$author$project$Material$Styled$Input$containerStyles($author$project$Page$Register$Business$BusinessRegisterMobile$styles.inputContainer),
									$author$project$Material$Styled$Input$label('Last Name *'),
									$author$project$Material$Styled$Input$value(lastName),
									$author$project$Material$Styled$Input$errorMessage(lastNameError),
									$author$project$Material$Styled$Input$onInput(
									A2(
										$elm$core$Basics$composeL,
										$author$project$Types$OnBusinessRegister,
										$author$project$Type$BusinessRegister$OnInput($author$project$Type$BusinessRegister$LastName))),
									$author$project$Material$Styled$Input$onBlur(
									$author$project$Types$OnBusinessRegister(
										$author$project$Type$BusinessRegister$OnBlur($author$project$Type$BusinessRegister$LastName)))
								]),
							_List_Nil),
							A2(
							$author$project$Material$Styled$Input$email,
							_List_fromArray(
								[
									$author$project$Material$Styled$Input$containerStyles($author$project$Page$Register$Business$BusinessRegisterMobile$styles.inputContainer),
									$author$project$Material$Styled$Input$label('Email Address *'),
									$author$project$Material$Styled$Input$value(email),
									$author$project$Material$Styled$Input$errorMessage(emailError),
									$author$project$Material$Styled$Input$onInput(
									A2(
										$elm$core$Basics$composeL,
										$author$project$Types$OnBusinessRegister,
										$author$project$Type$BusinessRegister$OnInput($author$project$Type$BusinessRegister$Email))),
									$author$project$Material$Styled$Input$onBlur(
									$author$project$Types$OnBusinessRegister(
										$author$project$Type$BusinessRegister$OnBlur($author$project$Type$BusinessRegister$Email)))
								]),
							_List_Nil),
							A2(
							$author$project$Material$Styled$Input$password,
							_List_fromArray(
								[
									$author$project$Material$Styled$Input$containerStyles($author$project$Page$Register$Business$BusinessRegisterMobile$styles.inputContainer),
									$author$project$Material$Styled$Input$label('Password *'),
									$author$project$Material$Styled$Input$value(password),
									$author$project$Material$Styled$Input$infoMessage('Password must contain at least 8 characters, a lowercase letter,\nan uppercase letter and a number'),
									$author$project$Material$Styled$Input$errorMessage(passwordError),
									$author$project$Material$Styled$Input$onInput(
									A2(
										$elm$core$Basics$composeL,
										$author$project$Types$OnBusinessRegister,
										$author$project$Type$BusinessRegister$OnInput($author$project$Type$BusinessRegister$Password))),
									$author$project$Material$Styled$Input$onBlur(
									$author$project$Types$OnBusinessRegister(
										$author$project$Type$BusinessRegister$OnBlur($author$project$Type$BusinessRegister$Password)))
								]),
							_List_Nil),
							A2(
							$author$project$Material$Styled$Input$password,
							_List_fromArray(
								[
									$author$project$Material$Styled$Input$containerStyles($author$project$Page$Register$Business$BusinessRegisterMobile$styles.inputContainer),
									$author$project$Material$Styled$Input$label('Confirm Password *'),
									$author$project$Material$Styled$Input$value(passwordAgain),
									$author$project$Material$Styled$Input$errorMessage(passwordAgainError),
									$author$project$Material$Styled$Input$onInput(
									A2(
										$elm$core$Basics$composeL,
										$author$project$Types$OnBusinessRegister,
										$author$project$Type$BusinessRegister$OnInput($author$project$Type$BusinessRegister$PasswordAgain))),
									$author$project$Material$Styled$Input$onBlur(
									$author$project$Types$OnBusinessRegister(
										$author$project$Type$BusinessRegister$OnBlur($author$project$Type$BusinessRegister$PasswordAgain)))
								]),
							_List_Nil),
							A2(
							$author$project$Material$Styled$Input$text,
							_List_fromArray(
								[
									$author$project$Material$Styled$Input$containerStyles($author$project$Page$Register$Business$BusinessRegisterMobile$styles.inputContainer),
									$author$project$Material$Styled$Input$label('Referral Code (Optional)'),
									$author$project$Material$Styled$Input$value(referralCode),
									$author$project$Material$Styled$Input$onInput(
									A2(
										$elm$core$Basics$composeL,
										$author$project$Types$OnBusinessRegister,
										$author$project$Type$BusinessRegister$OnInput($author$project$Type$BusinessRegister$ReferralCode))),
									$author$project$Material$Styled$Input$onBlur(
									$author$project$Types$OnBusinessRegister(
										$author$project$Type$BusinessRegister$OnBlur($author$project$Type$BusinessRegister$ReferralCode))),
									$author$project$Material$Styled$Input$disabled(
									function () {
										if (refCode.$ === 'Just') {
											return true;
										} else {
											return false;
										}
									}())
								]),
							_List_Nil),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Register$Business$BusinessRegisterMobile$styles.checkboxContainer)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Material$Styled$Checkbox$checkbox,
									_List_fromArray(
										[
											$author$project$Material$Styled$Checkbox$onClick(
											$author$project$Types$OnBusinessRegister($author$project$Type$BusinessRegister$OnAgreeTerms)),
											$author$project$Material$Styled$Checkbox$checked(hasAgreedTerms)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('I agree to the terms of service and privacy policy published '),
											A2(
											$author$project$Material$Styled$A$a,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$href('https://www.sign.net/legal/')
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text('here')
												])),
											$rtfeldman$elm_css$Html$Styled$text('.'),
											$author$project$Page$Register$Business$BusinessRegisterMobile$displayTermsError(hasAgreedTermsError)
										]))
								])),
							$author$project$Page$Register$Business$BusinessRegisterMobile$displayFormError(formStatus),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Register$Business$BusinessRegisterMobile$styles.formError)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									A2($elm$core$Maybe$withDefault, '', redirectError))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Register$Business$BusinessRegisterMobile$styles.buttonContainer)
								]),
							_List_fromArray(
								[
									$author$project$Page$Register$Business$BusinessRegisterMobile$submitButton(model.businessRegisterModel)
								]))
						])),
					A2(
					$author$project$Material$Styled$Divider$divider,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Register$Business$BusinessRegisterMobile$styles.divider)
						]),
					_List_Nil),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Register$Business$BusinessRegisterMobile$styles.linkContainer)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Material$Styled$A$a,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$href($author$project$Data$Route$routeUrl.login)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Return to login')
								]))
						]))
				]));
	});
var $author$project$Type$BusinessRegister$OnArrowDown = {$: 'OnArrowDown'};
var $author$project$Page$Register$Business$BusinessRegisterMobile$listInformation = A2(
	$rtfeldman$elm_css$Html$Styled$div,
	_List_fromArray(
		[
			$rtfeldman$elm_css$Html$Styled$Attributes$css(
			_Utils_ap($author$project$Page$Register$Business$BusinessRegisterMobile$styles.sideContainer, $author$project$Page$Register$Business$BusinessRegisterMobile$styles.informationContainer))
		]),
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Html$Styled$h1,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Register$Business$BusinessRegisterMobile$styles.header)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('Ready to Transform Your Business Into a Powerhouse?')
						]))
				])),
			A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Register$Business$BusinessRegisterMobile$styles.businessImageBox)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Register$Business$BusinessRegisterMobile$styles.imageContainer)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$img,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$src($author$project$View$Theme$images.myCompany),
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Register$Business$BusinessRegisterMobile$styles.imageStyles)
								]),
							_List_Nil)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Register$Business$BusinessRegisterMobile$styles.box)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Register$Business$BusinessRegisterMobile$styles.spacing)
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Register$Business$BusinessRegisterMobile$styles.boldText)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('Enhance ')
										])),
									$rtfeldman$elm_css$Html$Styled$text('your customer experience')
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Register$Business$BusinessRegisterMobile$styles.spacing)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Close deals '),
									A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Register$Business$BusinessRegisterMobile$styles.boldText)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('anytime, anywhere')
										]))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Register$Business$BusinessRegisterMobile$styles.spacing)
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Register$Business$BusinessRegisterMobile$styles.boldText)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('Modernise ')
										])),
									$rtfeldman$elm_css$Html$Styled$text('the agreement process')
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Register$Business$BusinessRegisterMobile$styles.boldText)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('Efficient ')
										])),
									$rtfeldman$elm_css$Html$Styled$text('and '),
									A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Register$Business$BusinessRegisterMobile$styles.boldText)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('secure ')
										])),
									$rtfeldman$elm_css$Html$Styled$text('workflows')
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Register$Business$BusinessRegisterMobile$styles.arrow),
									$rtfeldman$elm_css$Html$Styled$Events$onClick(
									$author$project$Types$OnBusinessRegister($author$project$Type$BusinessRegister$OnArrowDown))
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Material$Styled$Icon$arrowCircleDown2,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Svg$Styled$Attributes$height('70px'),
											$rtfeldman$elm_css$Svg$Styled$Attributes$width('70px'),
											$rtfeldman$elm_css$Svg$Styled$Attributes$fill('white')
										]),
									_List_Nil)
								]))
						]))
				]))
		]));
var $author$project$Page$Register$Business$BusinessRegisterMobile$view = F2(
	function (refCode, model) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Register$Business$BusinessRegisterMobile$styles.container)
				]),
			_List_fromArray(
				[
					$author$project$Page$Register$Business$BusinessRegisterMobile$listInformation,
					A2($author$project$Page$Register$Business$BusinessRegisterMobile$businessRegister, refCode, model)
				]));
	});
var $author$project$Page$BusinessRegister$view = F2(
	function (refCode, model) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BusinessRegister$styles.desktop)
						]),
					_List_fromArray(
						[
							$author$project$Page$BusinessRegister$listInformation,
							A2($author$project$Page$BusinessRegister$businessRegister, refCode, model)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$BusinessRegister$styles.mobile)
						]),
					_List_fromArray(
						[
							A2($author$project$Page$Register$Business$BusinessRegisterMobile$view, refCode, model)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$id('affilate')
						]),
					_List_Nil)
				]));
	});
var $author$project$Data$Api$ConfirmDeleteDocument$errorToString = function (error) {
	if (error.$ === 'INVALID_DOCUMENT') {
		return 'Document does not exist, or has already been deleted';
	} else {
		return 'Deletion code is invalid.';
	}
};
var $author$project$Page$ConfirmDeleteDocument$styles = {
	affliate: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(1)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(1))
		]),
	button: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(48)),
			$rtfeldman$elm_css$Css$maxWidth(
			$rtfeldman$elm_css$Css$px(300))
		]),
	card: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			A2(
			$rtfeldman$elm_css$Css$margin2,
			$rtfeldman$elm_css$Css$zero,
			$rtfeldman$elm_css$Css$px(20)),
			$rtfeldman$elm_css$Css$paddingBottom(
			$rtfeldman$elm_css$Css$px(40)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100)),
			$rtfeldman$elm_css$Css$maxWidth(
			$rtfeldman$elm_css$Css$px(600))
		]),
	container: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			A2(
			$rtfeldman$elm_css$Css$padding2,
			$rtfeldman$elm_css$Css$px(48),
			$rtfeldman$elm_css$Css$zero)
		]),
	heading: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(24)),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$blueGrey900),
			$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center)
		]),
	headingError: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(24)),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$red900),
			$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center)
		]),
	linkContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			A3(
				$rtfeldman$elm_css$Css$calc,
				$rtfeldman$elm_css$Css$pct(100),
				$rtfeldman$elm_css$Css$minus,
				$rtfeldman$elm_css$Css$px(48))),
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(16))
		]),
	logo: _List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Css$margin2,
			$rtfeldman$elm_css$Css$px(60),
			$rtfeldman$elm_css$Css$zero),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(150)),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(38))
		]),
	main: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			A3(
				$rtfeldman$elm_css$Css$calc,
				$rtfeldman$elm_css$Css$pct(100),
				$rtfeldman$elm_css$Css$minus,
				$rtfeldman$elm_css$Css$px(48))),
			A2(
			$rtfeldman$elm_css$Css$padding2,
			$rtfeldman$elm_css$Css$px(48),
			$rtfeldman$elm_css$Css$px(24)),
			$rtfeldman$elm_css$Css$boxSizing($rtfeldman$elm_css$Css$borderBox),
			A3(
			$rtfeldman$elm_css$Css$borderTop3,
			$rtfeldman$elm_css$Css$px(1),
			$rtfeldman$elm_css$Css$solid,
			$author$project$Material$Styled$Color$grey200),
			A3(
			$rtfeldman$elm_css$Css$borderBottom3,
			$rtfeldman$elm_css$Css$px(1),
			$rtfeldman$elm_css$Css$solid,
			$author$project$Material$Styled$Color$grey200)
		]),
	progressBar: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(48))
		]),
	textContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(14)),
			$rtfeldman$elm_css$Css$lineHeight(
			$rtfeldman$elm_css$Css$px(21)),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$blueGrey900),
			$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$fontWeight(
			$rtfeldman$elm_css$Css$int(400))
		])
};
var $author$project$Page$ConfirmDeleteDocument$errorView = function (errorMessage) {
	return _List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Html$Styled$h2,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ConfirmDeleteDocument$styles.headingError)
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text('Document Deletion Failed')
				])),
			A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ConfirmDeleteDocument$styles.textContainer)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(errorMessage)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('Please refresh the page or click on the deletion link in your email to try again.')
						]))
				]))
		]);
};
var $author$project$Page$ConfirmDeleteDocument$layout = function (children) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ConfirmDeleteDocument$styles.container)
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Material$Styled$Card$card,
				_List_fromArray(
					[
						$author$project$Material$Styled$Card$containerStyles($author$project$Page$ConfirmDeleteDocument$styles.card)
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$img,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$src($author$project$View$Theme$images.logoColor),
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ConfirmDeleteDocument$styles.logo)
							]),
						_List_Nil),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ConfirmDeleteDocument$styles.main)
							]),
						children),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ConfirmDeleteDocument$styles.linkContainer)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Material$Styled$A$a,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$href($author$project$Data$Route$routeUrl.login)
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('Have an account?')
									]))
							]))
					]))
			]));
};
var $author$project$Page$ConfirmDeleteDocument$submittingView = _List_fromArray(
	[
		A2(
		$rtfeldman$elm_css$Html$Styled$h2,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ConfirmDeleteDocument$styles.heading)
			]),
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$text('Deleting Your Document')
			])),
		A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ConfirmDeleteDocument$styles.textContainer)
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$p,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('Please wait a moment while we delete your document.')
					])),
				A2(
				$author$project$Material$Styled$ProgressBar$linear,
				_List_fromArray(
					[
						$author$project$Material$Styled$ProgressBar$containerStyle($author$project$Page$ConfirmDeleteDocument$styles.progressBar)
					]),
				_List_Nil)
			]))
	]);
var $author$project$Page$ConfirmDeleteDocument$successView = _List_fromArray(
	[
		A2(
		$rtfeldman$elm_css$Html$Styled$h2,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ConfirmDeleteDocument$styles.heading)
			]),
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$text('Document Deleted. Please wait...')
			])),
		A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ConfirmDeleteDocument$styles.textContainer)
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$p,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('Your document has been successfully deleted. ')
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$p,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('Please wait while we redirect you to the Dashboard.')
					]))
			]))
	]);
var $author$project$Page$ConfirmDeleteDocument$view = function (model) {
	return $author$project$Page$ConfirmDeleteDocument$layout(
		function () {
			if (model.$ === 'NoToken') {
				return $author$project$Page$ConfirmDeleteDocument$errorView('The token given for deletion is invalid.');
			} else {
				switch (model.a.$) {
					case 'Submitting':
						var _v1 = model.a;
						return $author$project$Page$ConfirmDeleteDocument$submittingView;
					case 'Success':
						var _v2 = model.a;
						return $author$project$Page$ConfirmDeleteDocument$successView;
					default:
						var error = model.a.a;
						return $author$project$Page$ConfirmDeleteDocument$errorView(
							A2($author$project$Data$Api$errorToString, $author$project$Data$Api$ConfirmDeleteDocument$errorToString, error));
				}
			}
		}());
};
var $author$project$Data$Api$ConfirmDeleteTemplate$errorToString = function (error) {
	if (error.$ === 'INVALID_TEMPLATE') {
		return 'Template does not exist, or has already been deleted';
	} else {
		return 'Deletion code is invalid.';
	}
};
var $author$project$Page$ConfirmDeleteTemplate$styles = {
	affliate: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(1)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(1))
		]),
	button: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(48)),
			$rtfeldman$elm_css$Css$maxWidth(
			$rtfeldman$elm_css$Css$px(300))
		]),
	card: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			A2(
			$rtfeldman$elm_css$Css$margin2,
			$rtfeldman$elm_css$Css$zero,
			$rtfeldman$elm_css$Css$px(20)),
			$rtfeldman$elm_css$Css$paddingBottom(
			$rtfeldman$elm_css$Css$px(40)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100)),
			$rtfeldman$elm_css$Css$maxWidth(
			$rtfeldman$elm_css$Css$px(600))
		]),
	container: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			A2(
			$rtfeldman$elm_css$Css$padding2,
			$rtfeldman$elm_css$Css$px(48),
			$rtfeldman$elm_css$Css$zero)
		]),
	heading: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(24)),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$blueGrey900),
			$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center)
		]),
	headingError: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(24)),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$red900),
			$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center)
		]),
	linkContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			A3(
				$rtfeldman$elm_css$Css$calc,
				$rtfeldman$elm_css$Css$pct(100),
				$rtfeldman$elm_css$Css$minus,
				$rtfeldman$elm_css$Css$px(48))),
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(16))
		]),
	logo: _List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Css$margin2,
			$rtfeldman$elm_css$Css$px(60),
			$rtfeldman$elm_css$Css$zero),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(150)),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(38))
		]),
	main: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			A3(
				$rtfeldman$elm_css$Css$calc,
				$rtfeldman$elm_css$Css$pct(100),
				$rtfeldman$elm_css$Css$minus,
				$rtfeldman$elm_css$Css$px(48))),
			A2(
			$rtfeldman$elm_css$Css$padding2,
			$rtfeldman$elm_css$Css$px(48),
			$rtfeldman$elm_css$Css$px(24)),
			$rtfeldman$elm_css$Css$boxSizing($rtfeldman$elm_css$Css$borderBox),
			A3(
			$rtfeldman$elm_css$Css$borderTop3,
			$rtfeldman$elm_css$Css$px(1),
			$rtfeldman$elm_css$Css$solid,
			$author$project$Material$Styled$Color$grey200),
			A3(
			$rtfeldman$elm_css$Css$borderBottom3,
			$rtfeldman$elm_css$Css$px(1),
			$rtfeldman$elm_css$Css$solid,
			$author$project$Material$Styled$Color$grey200)
		]),
	progressBar: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(48))
		]),
	textContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(14)),
			$rtfeldman$elm_css$Css$lineHeight(
			$rtfeldman$elm_css$Css$px(21)),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$blueGrey900),
			$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$fontWeight(
			$rtfeldman$elm_css$Css$int(400))
		])
};
var $author$project$Page$ConfirmDeleteTemplate$errorView = function (errorMessage) {
	return _List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Html$Styled$h2,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ConfirmDeleteTemplate$styles.headingError)
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text('Template Deletion Failed')
				])),
			A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ConfirmDeleteTemplate$styles.textContainer)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(errorMessage)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('Please refresh the page or click on the deletion link in your email to try again.')
						]))
				]))
		]);
};
var $author$project$Page$ConfirmDeleteTemplate$layout = function (children) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ConfirmDeleteTemplate$styles.container)
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Material$Styled$Card$card,
				_List_fromArray(
					[
						$author$project$Material$Styled$Card$containerStyles($author$project$Page$ConfirmDeleteTemplate$styles.card)
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$img,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$src($author$project$View$Theme$images.logoColor),
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ConfirmDeleteTemplate$styles.logo)
							]),
						_List_Nil),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ConfirmDeleteTemplate$styles.main)
							]),
						children),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ConfirmDeleteTemplate$styles.linkContainer)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Material$Styled$A$a,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$href($author$project$Data$Route$routeUrl.login)
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('Have an account?')
									]))
							]))
					]))
			]));
};
var $author$project$Page$ConfirmDeleteTemplate$submittingView = _List_fromArray(
	[
		A2(
		$rtfeldman$elm_css$Html$Styled$h2,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ConfirmDeleteTemplate$styles.heading)
			]),
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$text('Deleting Your Template')
			])),
		A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ConfirmDeleteTemplate$styles.textContainer)
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$p,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('Please wait a moment while we delete your template.')
					])),
				A2(
				$author$project$Material$Styled$ProgressBar$linear,
				_List_fromArray(
					[
						$author$project$Material$Styled$ProgressBar$containerStyle($author$project$Page$ConfirmDeleteTemplate$styles.progressBar)
					]),
				_List_Nil)
			]))
	]);
var $author$project$Page$ConfirmDeleteTemplate$successView = _List_fromArray(
	[
		A2(
		$rtfeldman$elm_css$Html$Styled$h2,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ConfirmDeleteTemplate$styles.heading)
			]),
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$text('Template Deleted. Please wait...')
			])),
		A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ConfirmDeleteTemplate$styles.textContainer)
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$p,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('Your template has been successfully deleted. ')
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$p,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('Please wait while we redirect you to the Dashboard.')
					]))
			]))
	]);
var $author$project$Page$ConfirmDeleteTemplate$view = function (model) {
	return $author$project$Page$ConfirmDeleteTemplate$layout(
		function () {
			if (model.$ === 'NoToken') {
				return $author$project$Page$ConfirmDeleteTemplate$errorView('The token given for deletion is invalid.');
			} else {
				switch (model.a.$) {
					case 'Submitting':
						var _v1 = model.a;
						return $author$project$Page$ConfirmDeleteTemplate$submittingView;
					case 'Success':
						var _v2 = model.a;
						return $author$project$Page$ConfirmDeleteTemplate$successView;
					default:
						var error = model.a.a;
						return $author$project$Page$ConfirmDeleteTemplate$errorView(
							A2($author$project$Data$Api$errorToString, $author$project$Data$Api$ConfirmDeleteTemplate$errorToString, error));
				}
			}
		}());
};
var $author$project$Type$CreateTemplate$GoToStage = function (a) {
	return {$: 'GoToStage', a: a};
};
var $author$project$Type$CreateTemplate$OnSignOrderClick = {$: 'OnSignOrderClick'};
var $author$project$Type$CreateTemplate$Settings = {$: 'Settings'};
var $author$project$Material$Styled$Checkbox$ContainerStyle = function (a) {
	return {$: 'ContainerStyle', a: a};
};
var $author$project$Material$Styled$Checkbox$containerStyles = function (style_) {
	return $author$project$Material$Styled$Checkbox$ContainerStyle(style_);
};
var $author$project$Material$Styled$Icon$KeyboardArrowDown$view = F2(
	function (attributes, children) {
		return A2(
			$rtfeldman$elm_css$Svg$Styled$svg,
			_Utils_ap(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Svg$Styled$Attributes$fill('black'),
						$rtfeldman$elm_css$Svg$Styled$Attributes$width('24px'),
						$rtfeldman$elm_css$Svg$Styled$Attributes$height('24px'),
						$rtfeldman$elm_css$Svg$Styled$Attributes$viewBox('0 0 24 24')
					]),
				attributes),
			_Utils_ap(
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Svg$Styled$path,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Svg$Styled$Attributes$d('M0 0h24v24H0V0z'),
								$rtfeldman$elm_css$Svg$Styled$Attributes$fill('none')
							]),
						_List_Nil),
						A2(
						$rtfeldman$elm_css$Svg$Styled$path,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Svg$Styled$Attributes$d('M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z')
							]),
						_List_Nil)
					]),
				children));
	});
var $author$project$Material$Styled$Icon$keyboardArrowDown = $author$project$Material$Styled$Icon$KeyboardArrowDown$view;
var $author$project$Material$Styled$Icon$Settings$view = F2(
	function (attributes, children) {
		return A2(
			$rtfeldman$elm_css$Svg$Styled$svg,
			_Utils_ap(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Svg$Styled$Attributes$fill('black'),
						$rtfeldman$elm_css$Svg$Styled$Attributes$width('24px'),
						$rtfeldman$elm_css$Svg$Styled$Attributes$height('24px'),
						$rtfeldman$elm_css$Svg$Styled$Attributes$viewBox('0 0 24 24')
					]),
				attributes),
			_Utils_ap(
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Svg$Styled$path,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Svg$Styled$Attributes$d('M0 0h24v24H0V0z'),
								$rtfeldman$elm_css$Svg$Styled$Attributes$fill('none')
							]),
						_List_Nil),
						A2(
						$rtfeldman$elm_css$Svg$Styled$path,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Svg$Styled$Attributes$d('M19.5,12c0-0.23-0.01-0.45-0.03-0.68l1.86-1.41c0.4-0.3,0.51-0.86,0.26-1.3l-1.87-3.23c-0.25-0.44-0.79-0.62-1.25-0.42 l-2.15,0.91c-0.37-0.26-0.76-0.49-1.17-0.68l-0.29-2.31C14.8,2.38,14.37,2,13.87,2h-3.73C9.63,2,9.2,2.38,9.14,2.88L8.85,5.19 c-0.41,0.19-0.8,0.42-1.17,0.68L5.53,4.96c-0.46-0.2-1-0.02-1.25,0.42L2.41,8.62c-0.25,0.44-0.14,0.99,0.26,1.3l1.86,1.41 C4.51,11.55,4.5,11.77,4.5,12s0.01,0.45,0.03,0.68l-1.86,1.41c-0.4,0.3-0.51,0.86-0.26,1.3l1.87,3.23c0.25,0.44,0.79,0.62,1.25,0.42 l2.15-0.91c0.37,0.26,0.76,0.49,1.17,0.68l0.29,2.31C9.2,21.62,9.63,22,10.13,22h3.73c0.5,0,0.93-0.38,0.99-0.88l0.29-2.31 c0.41-0.19,0.8-0.42,1.17-0.68l2.15,0.91c0.46,0.2,1,0.02,1.25-0.42l1.87-3.23c0.25-0.44,0.14-0.99-0.26-1.3l-1.86-1.41 C19.49,12.45,19.5,12.23,19.5,12z M12.04,15.5c-1.93,0-3.5-1.57-3.5-3.5s1.57-3.5,3.5-3.5s3.5,1.57,3.5,3.5S13.97,15.5,12.04,15.5z')
							]),
						_List_Nil)
					]),
				children));
	});
var $author$project$Material$Styled$Icon$settings = $author$project$Material$Styled$Icon$Settings$view;
var $author$project$Type$CreateTemplate$OnSigningOrderInput = F2(
	function (a, b) {
		return {$: 'OnSigningOrderInput', a: a, b: b};
	});
var $author$project$Material$Styled$Input$Id = function (a) {
	return {$: 'Id', a: a};
};
var $author$project$Material$Styled$Input$id = function (newId) {
	return $author$project$Material$Styled$Input$Id(newId);
};
var $author$project$Material$Styled$Input$Max = function (a) {
	return {$: 'Max', a: a};
};
var $author$project$Material$Styled$Input$max = function (string) {
	return $author$project$Material$Styled$Input$Max(string);
};
var $author$project$Material$Styled$Input$Min = function (a) {
	return {$: 'Min', a: a};
};
var $author$project$Material$Styled$Input$min = function (string) {
	return $author$project$Material$Styled$Input$Min(string);
};
var $author$project$Material$Styled$Input$number = F2(
	function (properties, _v0) {
		return A2($author$project$Material$Styled$Input$input, 'number', properties);
	});
var $rtfeldman$elm_css$Css$border2 = $rtfeldman$elm_css$Css$prop2('border');
var $rtfeldman$elm_css$Css$breakWord = {overflowWrap: $rtfeldman$elm_css$Css$Structure$Compatible, value: 'break-word'};
var $rtfeldman$elm_css$Css$ellipsis = {textOverflow: $rtfeldman$elm_css$Css$Structure$Compatible, value: 'ellipsis'};
var $rtfeldman$elm_css$Css$flexGrow = $rtfeldman$elm_css$Css$prop1('flex-grow');
var $rtfeldman$elm_css$Css$margin3 = $rtfeldman$elm_css$Css$prop3('margin');
var $rtfeldman$elm_css$Css$maxHeight = $rtfeldman$elm_css$Css$prop1('max-height');
var $rtfeldman$elm_css$Css$noWrap = {flexDirectionOrWrap: $rtfeldman$elm_css$Css$Structure$Compatible, flexWrap: $rtfeldman$elm_css$Css$Structure$Compatible, value: 'nowrap', whiteSpace: $rtfeldman$elm_css$Css$Structure$Compatible};
var $rtfeldman$elm_css$Css$overflowWrap = $rtfeldman$elm_css$Css$prop1('overflow-wrap');
var $rtfeldman$elm_css$Css$textOverflow = $rtfeldman$elm_css$Css$prop1('text-overflow');
var $rtfeldman$elm_css$Css$whiteSpace = $rtfeldman$elm_css$Css$prop1('white-space');
var $author$project$Page$CreateTemplate$styles = {
	addFieldIcon: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$paddingRight(
			$rtfeldman$elm_css$Css$px(7))
		]),
	addRcptBtn: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginRight(
			$rtfeldman$elm_css$Css$px(10)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(130))
		]),
	addRcptBtnContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(14)),
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$flexEnd)
		]),
	addRcptHeader: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceBetween),
			$rtfeldman$elm_css$Css$marginBottom(
			$rtfeldman$elm_css$Css$px(18)),
			$rtfeldman$elm_css$Css$fontWeight(
			$rtfeldman$elm_css$Css$int(500)),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(12.8))
		]),
	allIcon: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$default),
			A4(
			$rtfeldman$elm_css$Css$padding4,
			$rtfeldman$elm_css$Css$px(0),
			$rtfeldman$elm_css$Css$px(0),
			$rtfeldman$elm_css$Css$px(0),
			$rtfeldman$elm_css$Css$px(5))
		]),
	annotBtn: _List_fromArray(
		[
			A3(
			$rtfeldman$elm_css$Css$margin3,
			$rtfeldman$elm_css$Css$px(15),
			$rtfeldman$elm_css$Css$zero,
			$rtfeldman$elm_css$Css$zero),
			$rtfeldman$elm_css$Css$maxWidth($rtfeldman$elm_css$Css$fitContent)
		]),
	annotCardTitle: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$block),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(14)),
			$rtfeldman$elm_css$Css$marginBottom(
			$rtfeldman$elm_css$Css$px(14)),
			$rtfeldman$elm_css$Css$fontWeight(
			$rtfeldman$elm_css$Css$int(500)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100)),
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(5))
		]),
	annotCardTitleClosed: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$block),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(14)),
			$rtfeldman$elm_css$Css$fontWeight(
			$rtfeldman$elm_css$Css$int(500)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100)),
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(5))
		]),
	annotContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			A3(
			$rtfeldman$elm_css$Css$border3,
			$rtfeldman$elm_css$Css$px(1),
			$rtfeldman$elm_css$Css$solid,
			$author$project$Material$Styled$Color$grey300),
			$rtfeldman$elm_css$Css$padding(
			$rtfeldman$elm_css$Css$px(10)),
			$rtfeldman$elm_css$Css$borderRadius(
			$rtfeldman$elm_css$Css$px(10)),
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(20))
		]),
	annotContent: _List_Nil,
	avatar: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(30)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(30)),
			$rtfeldman$elm_css$Css$borderRadius(
			$rtfeldman$elm_css$Css$pct(50)),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$marginRight(
			$rtfeldman$elm_css$Css$px(2)),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$white),
			$rtfeldman$elm_css$Css$textTransform($rtfeldman$elm_css$Css$uppercase),
			$rtfeldman$elm_css$Css$textDecoration($rtfeldman$elm_css$Css$none),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(14))
		]),
	avatarContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$row),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$top(
			$rtfeldman$elm_css$Css$px(-20)),
			$rtfeldman$elm_css$Css$marginBottom(
			$rtfeldman$elm_css$Css$px(-20)),
			$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$relative)
		]),
	checkboxContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$row),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center)
		]),
	clearAnnotButton: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(20)),
			$rtfeldman$elm_css$Css$marginBottom(
			$rtfeldman$elm_css$Css$px(10))
		]),
	clearText: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(9.6)),
			$rtfeldman$elm_css$Css$textDecoration($rtfeldman$elm_css$Css$underline),
			$rtfeldman$elm_css$Css$hover(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer)
				]))
		]),
	container: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$row),
			$rtfeldman$elm_css$Css$height(
			A3(
				$rtfeldman$elm_css$Css$calc,
				$rtfeldman$elm_css$Css$vh(100),
				$rtfeldman$elm_css$Css$minus,
				$rtfeldman$elm_css$Css$px(66)))
		]),
	create: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(33)),
			$rtfeldman$elm_css$Css$marginLeft(
			$rtfeldman$elm_css$Css$px(15)),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(50)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(50)),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(50)),
			A3(
			$rtfeldman$elm_css$Css$border3,
			$rtfeldman$elm_css$Css$px(1),
			$rtfeldman$elm_css$Css$solid,
			$author$project$Material$Styled$Color$blueA700),
			$rtfeldman$elm_css$Css$borderRadius(
			$rtfeldman$elm_css$Css$px(10)),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$blueA700),
			$rtfeldman$elm_css$Css$hover(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer)
				]))
		]),
	errorBannerContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$absolute),
			$rtfeldman$elm_css$Css$top($rtfeldman$elm_css$Css$zero),
			$rtfeldman$elm_css$Css$left($rtfeldman$elm_css$Css$zero),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100)),
			$rtfeldman$elm_css$Css$boxSizing($rtfeldman$elm_css$Css$borderBox),
			$rtfeldman$elm_css$Css$padding(
			$rtfeldman$elm_css$Css$px(20))
		]),
	errorMessage: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$red500),
			$rtfeldman$elm_css$Css$marginBottom(
			$rtfeldman$elm_css$Css$px(10))
		]),
	fieldCardTitle: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$block),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$em(1.3)),
			A3(
			$rtfeldman$elm_css$Css$margin3,
			$rtfeldman$elm_css$Css$em(0.8),
			$rtfeldman$elm_css$Css$zero,
			$rtfeldman$elm_css$Css$em(0.4)),
			$rtfeldman$elm_css$Css$fontWeight(
			$rtfeldman$elm_css$Css$int(500))
		]),
	flexColumn: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column)
		]),
	formUrlContent: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$overflowWrap($rtfeldman$elm_css$Css$breakWord),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(14))
		]),
	iconContainer: _List_fromArray(
		[$rtfeldman$elm_css$Css$displayFlex]),
	input: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginBottom(
			$rtfeldman$elm_css$Css$px(20)),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(12.8))
		]),
	inputContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginBottom(
			$rtfeldman$elm_css$Css$px(10))
		]),
	myInfoImage: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(30)),
			A4(
			$rtfeldman$elm_css$Css$padding4,
			$rtfeldman$elm_css$Css$px(0),
			$rtfeldman$elm_css$Css$px(0),
			$rtfeldman$elm_css$Css$px(0),
			$rtfeldman$elm_css$Css$px(5))
		]),
	myInfoImageBlurred: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(30)),
			A4(
			$rtfeldman$elm_css$Css$padding4,
			$rtfeldman$elm_css$Css$px(0),
			$rtfeldman$elm_css$Css$px(0),
			$rtfeldman$elm_css$Css$px(0),
			$rtfeldman$elm_css$Css$px(5)),
			$rtfeldman$elm_css$Css$opacity(
			$rtfeldman$elm_css$Css$num(0.4))
		]),
	overlay: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$absolute),
			$rtfeldman$elm_css$Css$top($rtfeldman$elm_css$Css$zero),
			$rtfeldman$elm_css$Css$left($rtfeldman$elm_css$Css$zero),
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			A2(
			$rtfeldman$elm_css$Css$padding2,
			$rtfeldman$elm_css$Css$zero,
			$rtfeldman$elm_css$Css$px(20)),
			$rtfeldman$elm_css$Css$boxSizing($rtfeldman$elm_css$Css$borderBox),
			$rtfeldman$elm_css$Css$backgroundColor(
			$rtfeldman$elm_css$Css$hex('#BDBDBDEE')),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$white),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100)),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$pct(100)),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(40)),
			$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center)
		]),
	recipientContent: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			A3(
			$rtfeldman$elm_css$Css$margin3,
			$rtfeldman$elm_css$Css$px(48),
			$rtfeldman$elm_css$Css$zero,
			$rtfeldman$elm_css$Css$zero),
			$rtfeldman$elm_css$Css$lastChild(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$marginBottom(
					$rtfeldman$elm_css$Css$px(20))
				]))
		]),
	recipientHeader: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceBetween),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100))
		]),
	recipientItemTitle: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			$rtfeldman$elm_css$Css$padding(
			$rtfeldman$elm_css$Css$px(5)),
			$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$relative),
			$rtfeldman$elm_css$Css$top(
			$rtfeldman$elm_css$Css$px(-24)),
			$rtfeldman$elm_css$Css$backgroundColor($author$project$Material$Styled$Color$white),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(9.6))
		]),
	recipientRmvIcon: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$hover(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$backgroundColor($author$project$Material$Styled$Color$grey100),
					$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer),
					$rtfeldman$elm_css$Css$outline($rtfeldman$elm_css$Css$none)
				])),
			$rtfeldman$elm_css$Css$focus(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$outline($rtfeldman$elm_css$Css$none),
					$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer)
				]))
		]),
	resultText: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(14))
		]),
	retryContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer),
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(10))
		]),
	searchField: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$absolute),
			$rtfeldman$elm_css$Css$top(
			$rtfeldman$elm_css$Css$px(52)),
			$rtfeldman$elm_css$Css$backgroundColor($author$project$Material$Styled$Color$white),
			A2(
			$rtfeldman$elm_css$Css$border2,
			$rtfeldman$elm_css$Css$px(0.5),
			$rtfeldman$elm_css$Css$solid),
			$rtfeldman$elm_css$Css$zIndex(
			$rtfeldman$elm_css$Css$int($author$project$View$Theme$zIndex.uploadDocSearchField)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(99)),
			$rtfeldman$elm_css$Css$maxHeight(
			$rtfeldman$elm_css$Css$px(360)),
			$rtfeldman$elm_css$Css$overflowY($rtfeldman$elm_css$Css$auto)
		]),
	searchResult: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			$rtfeldman$elm_css$Css$marginLeft(
			$rtfeldman$elm_css$Css$px(20))
		]),
	searchResultContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$row),
			A2(
			$rtfeldman$elm_css$Css$padding2,
			$rtfeldman$elm_css$Css$px(18),
			$rtfeldman$elm_css$Css$px(14)),
			$rtfeldman$elm_css$Css$hover(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer),
					$rtfeldman$elm_css$Css$opacity(
					$rtfeldman$elm_css$Css$num(0.5)),
					$rtfeldman$elm_css$Css$backgroundColor($author$project$Material$Styled$Color$grey50),
					A2(
					$rtfeldman$elm_css$Css$border2,
					$rtfeldman$elm_css$Css$px(0.5),
					$rtfeldman$elm_css$Css$solid)
				])),
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceBetween)
		]),
	sectionContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			A3(
			$rtfeldman$elm_css$Css$border3,
			$rtfeldman$elm_css$Css$px(1),
			$rtfeldman$elm_css$Css$solid,
			$author$project$Material$Styled$Color$grey300),
			$rtfeldman$elm_css$Css$padding(
			$rtfeldman$elm_css$Css$px(10)),
			$rtfeldman$elm_css$Css$borderRadius(
			$rtfeldman$elm_css$Css$px(10)),
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(20))
		]),
	sectionContainerClosed: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$row),
			A3(
			$rtfeldman$elm_css$Css$border3,
			$rtfeldman$elm_css$Css$px(1),
			$rtfeldman$elm_css$Css$solid,
			$author$project$Material$Styled$Color$grey300),
			$rtfeldman$elm_css$Css$padding(
			$rtfeldman$elm_css$Css$px(10)),
			$rtfeldman$elm_css$Css$borderRadius(
			$rtfeldman$elm_css$Css$px(10)),
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(20)),
			$rtfeldman$elm_css$Css$hover(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$backgroundColor($author$project$Material$Styled$Color$grey100),
					$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer)
				]))
		]),
	sendIcon: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center)
		]),
	sidebar: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$relative),
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$padding(
			$rtfeldman$elm_css$Css$px(10)),
			$rtfeldman$elm_css$Css$backgroundColor($author$project$Material$Styled$Color$white),
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(38)),
			$rtfeldman$elm_css$Css$overflowY($rtfeldman$elm_css$Css$auto)
		]),
	signOrderField: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100)),
			$rtfeldman$elm_css$Css$maxWidth(
			$rtfeldman$elm_css$Css$px(100)),
			$rtfeldman$elm_css$Css$marginLeft(
			$rtfeldman$elm_css$Css$px(15)),
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(10))
		]),
	signOrderInfoContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceBetween),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100))
		]),
	signature: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$minWidth(
			$rtfeldman$elm_css$Css$px(100)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(43)),
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(15)),
			$rtfeldman$elm_css$Css$marginRight(
			$rtfeldman$elm_css$Css$px(15))
		]),
	signatureImg: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(50)),
			$rtfeldman$elm_css$Css$minWidth(
			$rtfeldman$elm_css$Css$px(100)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(43)),
			A2($rtfeldman$elm_css$Css$property, 'object-fit', 'contain'),
			A2($rtfeldman$elm_css$Css$property, 'box-shadow', '0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24)'),
			$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer),
			$rtfeldman$elm_css$Css$hover(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$backgroundColor(
					$rtfeldman$elm_css$Css$hex('f6f7f7'))
				]))
		]),
	signatureImgBox: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			A2(
			$rtfeldman$elm_css$Css$margin2,
			$rtfeldman$elm_css$Css$px(10),
			$rtfeldman$elm_css$Css$zero),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$em(0.8)),
			$rtfeldman$elm_css$Css$fontWeight(
			$rtfeldman$elm_css$Css$int(500))
		]),
	signatureListBox: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$row),
			$rtfeldman$elm_css$Css$flexWrap($rtfeldman$elm_css$Css$wrap)
		]),
	signatureName: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$textOverflow($rtfeldman$elm_css$Css$ellipsis),
			$rtfeldman$elm_css$Css$overflow($rtfeldman$elm_css$Css$hidden),
			$rtfeldman$elm_css$Css$whiteSpace($rtfeldman$elm_css$Css$noWrap),
			$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(60))
		]),
	signerNameContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$row),
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceBetween),
			$rtfeldman$elm_css$Css$flexWrap($rtfeldman$elm_css$Css$wrap)
		]),
	signingOrderAvatarContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$row),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$relative)
		]),
	signingOrderCheckBox: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginLeft(
			$rtfeldman$elm_css$Css$px(-10)),
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(-10)),
			$rtfeldman$elm_css$Css$marginBottom(
			$rtfeldman$elm_css$Css$px(10)),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(12.8))
		]),
	signingOrderContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(-20))
		]),
	signingOrderText: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(12.8))
		]),
	submitButton: _List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Css$margin2,
			$rtfeldman$elm_css$Css$px(20),
			$rtfeldman$elm_css$Css$px(0)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100))
		]),
	titleContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$row),
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceBetween)
		]),
	toolTipText: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(9.6))
		]),
	viewerText: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginLeft(
			$rtfeldman$elm_css$Css$px(5)),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(12.8)),
			$rtfeldman$elm_css$Css$flexGrow(
			$rtfeldman$elm_css$Css$num(1))
		])
};
var $author$project$Page$CreateTemplate$generateIndividualSigningOrder = F2(
	function (numberOfSigners, role) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$CreateTemplate$styles.signingOrderAvatarContainer)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$CreateTemplate$styles.signOrderInfoContainer)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$CreateTemplate$styles.signingOrderText)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(role.role)
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$CreateTemplate$styles.signingOrderText)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									A2($elm$core$Maybe$withDefault, '', role.email))
								]))
						])),
					A2(
					$author$project$Material$Styled$Input$number,
					_List_fromArray(
						[
							$author$project$Material$Styled$Input$min('1'),
							$author$project$Material$Styled$Input$max(
							$elm$core$String$fromInt(numberOfSigners)),
							$author$project$Material$Styled$Input$label(''),
							$author$project$Material$Styled$Input$value(
							$elm$core$String$fromInt(role.signOrder)),
							$author$project$Material$Styled$Input$onInput(
							A2(
								$elm$core$Basics$composeL,
								A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnCreateTemplate),
								$author$project$Type$CreateTemplate$OnSigningOrderInput(role.role))),
							$author$project$Material$Styled$Input$containerStyles($author$project$Page$CreateTemplate$styles.signOrderField),
							$author$project$Material$Styled$Input$id('signOrder' + role.role)
						]),
					_List_Nil)
				]));
	});
var $author$project$Page$CreateTemplate$signingOrder = F2(
	function (model, loadedModel) {
		var createTemplateLanguageData = model.languageSwitchModel.allLanguageData.location.createTemplatePage;
		if (_Utils_eq(loadedModel.signOrder, $author$project$Type$CreateTemplate$Enabled)) {
			var listOfSigners = A2(
				$elm$core$List$sortBy,
				function ($) {
					return $.signOrder;
				},
				A2(
					$elm$core$List$filter,
					function (r) {
						return !_Utils_eq(r.signOrder, -1);
					},
					$author$project$Data$PDF$CreateTemplate$getRoles(loadedModel.template)));
			var numberOfSigners = $elm$core$List$length(listOfSigners);
			return A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_Utils_ap(
							$author$project$Page$CreateTemplate$styles.recipientContent,
							_Utils_ap(
								$author$project$Page$CreateTemplate$styles.annotContainer,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Css$marginBottom(
										$rtfeldman$elm_css$Css$px(10))
									]))))
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$CreateTemplate$styles.recipientHeader)
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$CreateTemplate$styles.recipientItemTitle)
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(createTemplateLanguageData.signOrder)
									]))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$CreateTemplate$styles.signingOrderContainer)
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_Nil,
								A2(
									$elm$core$List$map,
									$author$project$Page$CreateTemplate$generateIndividualSigningOrder(numberOfSigners),
									listOfSigners))
							]))
					]));
		} else {
			return $rtfeldman$elm_css$Html$Styled$text('');
		}
	});
var $author$project$Page$CreateTemplate$advanceOptions = F2(
	function (model, loadedModel) {
		var createTemplateLanguageData = model.languageSwitchModel.allLanguageData.location.createTemplatePage;
		return _Utils_eq(loadedModel.stage, $author$project$Type$CreateTemplate$Settings) ? A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$CreateTemplate$styles.sectionContainer)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[$rtfeldman$elm_css$Css$displayFlex]))
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$CreateTemplate$styles.addFieldIcon)
								]),
							_List_fromArray(
								[
									A2($author$project$Material$Styled$Icon$settings, _List_Nil, _List_Nil)
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$CreateTemplate$styles.annotCardTitle)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(createTemplateLanguageData.optionalSettings)
								]))
						])),
					A2(
					$author$project$Material$Styled$Checkbox$checkbox,
					_List_fromArray(
						[
							$author$project$Material$Styled$Checkbox$checked(
							_Utils_eq(loadedModel.signOrder, $author$project$Type$CreateTemplate$Enabled)),
							$author$project$Material$Styled$Checkbox$containerStyles($author$project$Page$CreateTemplate$styles.signingOrderCheckBox),
							$author$project$Material$Styled$Checkbox$onClick(
							$author$project$Types$OnAuth(
								$author$project$Types$OnCreateTemplate($author$project$Type$CreateTemplate$OnSignOrderClick)))
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(createTemplateLanguageData.signOrder)
						])),
					A2($author$project$Page$CreateTemplate$signingOrder, model, loadedModel)
				])) : A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Events$onClick(
					$author$project$Types$OnAuth(
						$author$project$Types$OnCreateTemplate(
							$author$project$Type$CreateTemplate$GoToStage($author$project$Type$CreateTemplate$Settings)))),
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$CreateTemplate$styles.sectionContainerClosed)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$CreateTemplate$styles.addFieldIcon)
						]),
					_List_fromArray(
						[
							A2($author$project$Material$Styled$Icon$settings, _List_Nil, _List_Nil)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$CreateTemplate$styles.annotCardTitleClosed)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(createTemplateLanguageData.optionalSettings)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_Nil,
					_List_fromArray(
						[
							A2($author$project$Material$Styled$Icon$keyboardArrowDown, _List_Nil, _List_Nil)
						]))
				]));
	});
var $author$project$Type$CreateTemplate$Fields = {$: 'Fields'};
var $author$project$Type$CreateTemplate$OnDeleteAnnotClick = {$: 'OnDeleteAnnotClick'};
var $author$project$Type$CreateTemplate$OnFontSizeUpdate = function (a) {
	return {$: 'OnFontSizeUpdate', a: a};
};
var $author$project$Material$Styled$Icon$AddFields$view = F2(
	function (attributes, children) {
		return A2(
			$rtfeldman$elm_css$Svg$Styled$svg,
			_Utils_ap(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Svg$Styled$Attributes$fill('black'),
						$rtfeldman$elm_css$Svg$Styled$Attributes$width('24px'),
						$rtfeldman$elm_css$Svg$Styled$Attributes$height('24px'),
						$rtfeldman$elm_css$Svg$Styled$Attributes$viewBox('0 0 24 24')
					]),
				attributes),
			_Utils_ap(
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Svg$Styled$path,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Svg$Styled$Attributes$d('M0 0h24v24H0z'),
								$rtfeldman$elm_css$Svg$Styled$Attributes$fill('none')
							]),
						_List_Nil),
						A2(
						$rtfeldman$elm_css$Svg$Styled$path,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Svg$Styled$Attributes$d('M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z')
							]),
						_List_Nil)
					]),
				children));
	});
var $author$project$Material$Styled$Icon$addFields = $author$project$Material$Styled$Icon$AddFields$view;
var $author$project$Material$Styled$Icon$NavigateNext$view = F2(
	function (attributes, children) {
		return A2(
			$rtfeldman$elm_css$Svg$Styled$svg,
			_Utils_ap(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Svg$Styled$Attributes$fill('white'),
						$rtfeldman$elm_css$Svg$Styled$Attributes$width('18px'),
						$rtfeldman$elm_css$Svg$Styled$Attributes$height('18px'),
						$rtfeldman$elm_css$Svg$Styled$Attributes$viewBox('0 0 24 24')
					]),
				attributes),
			_Utils_ap(
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Svg$Styled$path,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Svg$Styled$Attributes$d('M0 0h24v24H0z'),
								$rtfeldman$elm_css$Svg$Styled$Attributes$fill('none')
							]),
						_List_Nil),
						A2(
						$rtfeldman$elm_css$Svg$Styled$path,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Svg$Styled$Attributes$d('M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z')
							]),
						_List_Nil)
					]),
				children));
	});
var $author$project$Material$Styled$Icon$navigateNext = $author$project$Material$Styled$Icon$NavigateNext$view;
var $author$project$Type$CreateTemplate$OnRemoveRecipient = function (a) {
	return {$: 'OnRemoveRecipient', a: a};
};
var $rtfeldman$elm_css$Css$inline = {display: $rtfeldman$elm_css$Css$Structure$Compatible, value: 'inline'};
var $author$project$Material$Styled$Color$blue400String = '#42a5f5';
var $author$project$Material$Styled$Color$blue400 = $rtfeldman$elm_css$Css$hex($author$project$Material$Styled$Color$blue400String);
var $author$project$Material$Styled$Color$brown400String = '#8D6E63';
var $author$project$Material$Styled$Color$brown400 = $rtfeldman$elm_css$Css$hex($author$project$Material$Styled$Color$brown400String);
var $author$project$Material$Styled$Color$cyan400String = '#26C6DA';
var $author$project$Material$Styled$Color$cyan400 = $rtfeldman$elm_css$Css$hex($author$project$Material$Styled$Color$cyan400String);
var $author$project$Material$Styled$Color$indigo400String = '#5c6bc0';
var $author$project$Material$Styled$Color$indigo400 = $rtfeldman$elm_css$Css$hex($author$project$Material$Styled$Color$indigo400String);
var $author$project$Material$Styled$Color$orange400String = '#FFA726';
var $author$project$Material$Styled$Color$orange400 = $rtfeldman$elm_css$Css$hex($author$project$Material$Styled$Color$orange400String);
var $author$project$Material$Styled$Color$purple400String = '#ab47bc';
var $author$project$Material$Styled$Color$purple400 = $rtfeldman$elm_css$Css$hex($author$project$Material$Styled$Color$purple400String);
var $author$project$Material$Styled$Color$teal400String = '#26A69A';
var $author$project$Material$Styled$Color$teal400 = $rtfeldman$elm_css$Css$hex($author$project$Material$Styled$Color$teal400String);
var $author$project$Data$PDF$User$materialColorCode = function (bgColor) {
	switch (bgColor.$) {
		case 'Purple':
			return $author$project$Material$Styled$Color$purple400;
		case 'Indigo':
			return $author$project$Material$Styled$Color$indigo400;
		case 'Cyan':
			return $author$project$Material$Styled$Color$cyan400;
		case 'Teal':
			return $author$project$Material$Styled$Color$teal400;
		case 'Brown':
			return $author$project$Material$Styled$Color$brown400;
		case 'Orange':
			return $author$project$Material$Styled$Color$orange400;
		case 'Blue':
			return $author$project$Material$Styled$Color$blue400;
		default:
			return $author$project$Material$Styled$Color$black;
	}
};
var $rtfeldman$elm_css$Html$Styled$strong = $rtfeldman$elm_css$Html$Styled$node('strong');
var $rtfeldman$elm_css$Html$Styled$Attributes$title = $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty('title');
var $author$project$Type$CreateTemplate$OnAnnotClick = F2(
	function (a, b) {
		return {$: 'OnAnnotClick', a: a, b: b};
	});
var $author$project$Data$PDF$Annotation$createCheckBox = F2(
	function (status, style) {
		return $author$project$Data$PDF$Annotation$Checkbox(
			{dbId: '', id: '', status: status, style: style});
	});
var $author$project$Data$PDF$Annotation$createDateTxt = F2(
	function (verified, style) {
		return $author$project$Data$PDF$Annotation$DateTxt(
			{
				date: $elm$time$Time$millisToPosix(0),
				dbId: '',
				id: '',
				status: verified,
				style: style
			});
	});
var $author$project$Data$PDF$Annotation$createStamp = function (style) {
	return $author$project$Data$PDF$Annotation$Stamp(
		{dbId: '', id: '', status: $author$project$Data$PDF$Annotation$Unstamped, style: style});
};
var $author$project$Data$PDF$Annotation$createStyle = F3(
	function (width, height, fontSize) {
		return {fontSize: fontSize, height: height, page: 0, width: width, x: 0.0, y: 0.0};
	});
var $author$project$Data$PDF$Annotation$createTxt = F3(
	function (text, verified, style) {
		return $author$project$Data$PDF$Annotation$Txt(
			{dbId: '', id: '', status: verified, style: style, text: text});
	});
var $author$project$Data$PDF$Annotation$createUnsignedSignature = function (style) {
	return $author$project$Data$PDF$Annotation$UnsignedSignature(
		{dbId: '', id: '', style: style, text: 'Signature Here'});
};
var $author$project$Type$CreateTemplate$CheckBox = {$: 'CheckBox'};
var $author$project$Type$CreateTemplate$DateField = {$: 'DateField'};
var $author$project$Type$CreateTemplate$EditableTextField = {$: 'EditableTextField'};
var $author$project$Type$CreateTemplate$EmailField = {$: 'EmailField'};
var $author$project$Type$CreateTemplate$NameField = {$: 'NameField'};
var $author$project$Type$CreateTemplate$NotSelected = {$: 'NotSelected'};
var $author$project$Type$CreateTemplate$SignatureField = {$: 'SignatureField'};
var $author$project$Type$CreateTemplate$StampField = {$: 'StampField'};
var $author$project$Type$CreateTemplate$fieldList = _List_fromArray(
	[$author$project$Type$CreateTemplate$NotSelected, $author$project$Type$CreateTemplate$EditableTextField, $author$project$Type$CreateTemplate$DateField, $author$project$Type$CreateTemplate$SignatureField, $author$project$Type$CreateTemplate$StampField, $author$project$Type$CreateTemplate$NameField, $author$project$Type$CreateTemplate$EmailField, $author$project$Type$CreateTemplate$CheckBox]);
var $author$project$Type$CreateTemplate$fieldToString = F2(
	function (languageSwitchModel, field) {
		var createTemplateLanguageData = languageSwitchModel.allLanguageData.location.createTemplatePage;
		switch (field.$) {
			case 'EditableTextField':
				return createTemplateLanguageData.editableText;
			case 'DateField':
				return createTemplateLanguageData.dateSigned;
			case 'SignatureField':
				return createTemplateLanguageData.signatureField;
			case 'StampField':
				return createTemplateLanguageData.stampField;
			case 'NameField':
				return createTemplateLanguageData.nameField;
			case 'EmailField':
				return createTemplateLanguageData.emailField;
			case 'NotSelected':
				return createTemplateLanguageData.addToDocument;
			default:
				return createTemplateLanguageData.checkboxField;
		}
	});
var $author$project$Type$CreateTemplate$stringToField = F2(
	function (languageSwitchModel, fieldString) {
		var createTemplateLanguageData = languageSwitchModel.allLanguageData.location.createTemplatePage;
		return _Utils_eq(fieldString, createTemplateLanguageData.addToDocument) ? $author$project$Type$CreateTemplate$NotSelected : (_Utils_eq(fieldString, createTemplateLanguageData.signatureField) ? $author$project$Type$CreateTemplate$SignatureField : (_Utils_eq(fieldString, createTemplateLanguageData.stampField) ? $author$project$Type$CreateTemplate$StampField : (_Utils_eq(fieldString, createTemplateLanguageData.nameField) ? $author$project$Type$CreateTemplate$NameField : (_Utils_eq(fieldString, createTemplateLanguageData.dateSigned) ? $author$project$Type$CreateTemplate$DateField : (_Utils_eq(fieldString, createTemplateLanguageData.editableText) ? $author$project$Type$CreateTemplate$EditableTextField : (_Utils_eq(fieldString, createTemplateLanguageData.emailField) ? $author$project$Type$CreateTemplate$EmailField : (_Utils_eq(fieldString, createTemplateLanguageData.checkboxField) ? $author$project$Type$CreateTemplate$CheckBox : $author$project$Type$CreateTemplate$NotSelected)))))));
	});
var $author$project$Page$CreateTemplate$Field$styles = {
	fieldsBtn: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$margin(
			$rtfeldman$elm_css$Css$px(5)),
			$rtfeldman$elm_css$Css$maxWidth($rtfeldman$elm_css$Css$fitContent)
		]),
	fieldsContatiner: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$row),
			$rtfeldman$elm_css$Css$flexWrap($rtfeldman$elm_css$Css$wrap),
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(15)),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$em(0.8)),
			$rtfeldman$elm_css$Css$fontWeight(
			$rtfeldman$elm_css$Css$int(500))
		]),
	flexColumn: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(15))
		]),
	submitButton: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginBottom(
			$rtfeldman$elm_css$Css$px(20)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100))
		])
};
var $author$project$Material$Styled$Select$Value = function (a) {
	return {$: 'Value', a: a};
};
var $author$project$Material$Styled$Select$value = function (string) {
	return $author$project$Material$Styled$Select$Value(string);
};
var $author$project$Page$CreateTemplate$Field$view = F3(
	function (languageSwitchModel, lastStyle, role) {
		var textFieldStyle = A3($author$project$Data$PDF$Annotation$createStyle, lastStyle.textField.width, lastStyle.textField.height, lastStyle.textField.fontSize);
		var stampFieldStyle = A3($author$project$Data$PDF$Annotation$createStyle, lastStyle.stampField.width, lastStyle.stampField.height, '0pt');
		var signatureFieldStyle = A3($author$project$Data$PDF$Annotation$createStyle, lastStyle.signatureField.width, lastStyle.signatureField.height, '0pt');
		var nameFieldStyle = A3($author$project$Data$PDF$Annotation$createStyle, lastStyle.nameField.width, lastStyle.nameField.height, lastStyle.nameField.fontSize);
		var emailFieldStyle = A3($author$project$Data$PDF$Annotation$createStyle, lastStyle.emailField.width, lastStyle.emailField.height, lastStyle.emailField.fontSize);
		var dateFieldStyle = A3($author$project$Data$PDF$Annotation$createStyle, lastStyle.dateField.width, lastStyle.dateField.height, lastStyle.dateField.fontSize);
		var checkBoxStyle = A3($author$project$Data$PDF$Annotation$createStyle, lastStyle.checkbox.width, lastStyle.checkbox.height, '0pt');
		var annotField = function (name) {
			return A2($author$project$Data$PDF$Annotation$annotationField, true, name);
		};
		var createCheckbox = $author$project$Data$PDF$CreateTemplate$IsCheckBoxField(
			A2(
				$author$project$Data$PDF$Annotation$toCheckboxField,
				annotField('Checkbox'),
				A2($author$project$Data$PDF$Annotation$createCheckBox, $author$project$Data$PDF$Annotation$Unchecked, checkBoxStyle)));
		var createDateField = $author$project$Data$PDF$CreateTemplate$IsDateField(
			A2(
				$author$project$Data$PDF$Annotation$toDateField,
				annotField('Date'),
				A2($author$project$Data$PDF$Annotation$createDateTxt, $author$project$Data$PDF$Annotation$Unverified, dateFieldStyle)));
		var createEmailField = $author$project$Data$PDF$CreateTemplate$IsEmailField(
			A2(
				$author$project$Data$PDF$Annotation$toTextField,
				annotField('Email'),
				A3($author$project$Data$PDF$Annotation$createTxt, 'Email', $author$project$Data$PDF$Annotation$Unverified, emailFieldStyle)));
		var createNameField = $author$project$Data$PDF$CreateTemplate$IsNameField(
			A2(
				$author$project$Data$PDF$Annotation$toTextField,
				annotField('Name'),
				A3($author$project$Data$PDF$Annotation$createTxt, 'Name', $author$project$Data$PDF$Annotation$Unverified, nameFieldStyle)));
		var createSignatureField = $author$project$Data$PDF$CreateTemplate$IsSignatureField(
			A2(
				$author$project$Data$PDF$Annotation$toSignatureField,
				annotField('Signature'),
				$author$project$Data$PDF$Annotation$createUnsignedSignature(signatureFieldStyle)));
		var createStampField = $author$project$Data$PDF$CreateTemplate$IsStampField(
			A2(
				$author$project$Data$PDF$Annotation$toStampField,
				annotField('Stamp'),
				$author$project$Data$PDF$Annotation$createStamp(stampFieldStyle)));
		var createTextField = $author$project$Data$PDF$CreateTemplate$IsTextField(
			A2(
				$author$project$Data$PDF$Annotation$toTextField,
				annotField('Text'),
				A3($author$project$Data$PDF$Annotation$createTxt, 'Text', $author$project$Data$PDF$Annotation$Unverified, textFieldStyle)));
		var addToDocumentTxt = languageSwitchModel.allLanguageData.location.createTemplatePage.addToDocument;
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$CreateTemplate$Field$styles.flexColumn)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Material$Styled$Select$select,
					_List_fromArray(
						[
							$author$project$Material$Styled$Select$label('Fields'),
							$author$project$Material$Styled$Select$containerStyles(
							_List_fromArray(
								[
									$rtfeldman$elm_css$Css$width(
									$rtfeldman$elm_css$Css$pct(100))
								])),
							$author$project$Material$Styled$Select$value(addToDocumentTxt),
							$author$project$Material$Styled$Select$onChange(
							function (field) {
								var _v0 = A2($author$project$Type$CreateTemplate$stringToField, languageSwitchModel, field);
								switch (_v0.$) {
									case 'NotSelected':
										return $author$project$Types$Noop;
									case 'EditableTextField':
										return $author$project$Types$OnAuth(
											$author$project$Types$OnCreateTemplate(
												A2($author$project$Type$CreateTemplate$OnAnnotClick, createTextField, role)));
									case 'DateField':
										return $author$project$Types$OnAuth(
											$author$project$Types$OnCreateTemplate(
												A2($author$project$Type$CreateTemplate$OnAnnotClick, createDateField, role)));
									case 'SignatureField':
										return $author$project$Types$OnAuth(
											$author$project$Types$OnCreateTemplate(
												A2($author$project$Type$CreateTemplate$OnAnnotClick, createSignatureField, role)));
									case 'StampField':
										return $author$project$Types$OnAuth(
											$author$project$Types$OnCreateTemplate(
												A2($author$project$Type$CreateTemplate$OnAnnotClick, createStampField, role)));
									case 'NameField':
										return $author$project$Types$OnAuth(
											$author$project$Types$OnCreateTemplate(
												A2($author$project$Type$CreateTemplate$OnAnnotClick, createNameField, role)));
									case 'EmailField':
										return $author$project$Types$OnAuth(
											$author$project$Types$OnCreateTemplate(
												A2($author$project$Type$CreateTemplate$OnAnnotClick, createEmailField, role)));
									default:
										return $author$project$Types$OnAuth(
											$author$project$Types$OnCreateTemplate(
												A2($author$project$Type$CreateTemplate$OnAnnotClick, createCheckbox, role)));
								}
							})
						]),
					A2(
						$elm$core$List$map,
						function (r) {
							return A2(
								$rtfeldman$elm_css$Html$Styled$option,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$value(
										A2($author$project$Type$CreateTemplate$fieldToString, languageSwitchModel, r))
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										A2($author$project$Type$CreateTemplate$fieldToString, languageSwitchModel, r))
									]));
						},
						$author$project$Type$CreateTemplate$fieldList))
				]));
	});
var $author$project$Page$CreateTemplate$recepientFields = F2(
	function (loadedModel, languageSwitchModel) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_Nil,
			A2(
				$elm$core$List$map,
				function (value) {
					return A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css(
								_Utils_ap($author$project$Page$CreateTemplate$styles.recipientContent, $author$project$Page$CreateTemplate$styles.annotContainer)),
								$rtfeldman$elm_css$Html$Styled$Attributes$id(value.role)
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$CreateTemplate$styles.signerNameContainer)
									]),
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$div,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$CreateTemplate$styles.recipientHeader)
											]),
										_List_fromArray(
											[
												A2(
												$rtfeldman$elm_css$Html$Styled$span,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$CreateTemplate$styles.recipientItemTitle),
														$rtfeldman$elm_css$Html$Styled$Attributes$css(
														_List_fromArray(
															[
																$rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$inline)
															]))
													]),
												_List_fromArray(
													[
														A2(
														$rtfeldman$elm_css$Html$Styled$strong,
														_List_Nil,
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$text(value.role)
															])),
														$rtfeldman$elm_css$Html$Styled$text(
														' ' + A2($elm$core$Maybe$withDefault, '', value.email))
													]))
											]))
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$CreateTemplate$styles.avatarContainer)
									]),
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$span,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$css(
												A2(
													$elm$core$List$append,
													$author$project$Page$CreateTemplate$styles.avatar,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Css$backgroundColor(
															$author$project$Data$PDF$User$materialColorCode(value.color))
														]))),
												$rtfeldman$elm_css$Html$Styled$Attributes$title(value.role)
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(
												A2($elm$core$String$left, 2, value.role))
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$span,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$CreateTemplate$styles.viewerText)
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(value.role)
											])),
										A2(
										$author$project$Material$Styled$Icon$close,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Svg$Styled$Attributes$css($author$project$Page$CreateTemplate$styles.recipientRmvIcon),
												$rtfeldman$elm_css$Svg$Styled$Events$onClick(
												$author$project$Types$OnAuth(
													$author$project$Types$OnCreateTemplate(
														$author$project$Type$CreateTemplate$OnRemoveRecipient(value.role))))
											]),
										_List_Nil)
									])),
								A3($author$project$Page$CreateTemplate$Field$view, languageSwitchModel, loadedModel.lastStyle, value.role)
							]));
				},
				A2(
					$elm$core$List$filter,
					function (r) {
						return !_Utils_eq(r.signOrder, -1);
					},
					$author$project$Data$PDF$CreateTemplate$getRoles(loadedModel.template))));
	});
var $author$project$Page$CreateTemplate$annotations = F3(
	function (model, loadedModel, languageSwitchModel) {
		var deleteButtonText = function () {
			var _v0 = loadedModel.selectedAnnotForDeletion;
			if (_v0.$ === 'Just') {
				return 'Delete Annoation';
			} else {
				return 'Select Annotation to delete';
			}
		}();
		var createTemplateLanguageData = model.languageSwitchModel.allLanguageData.location.createTemplatePage;
		return _Utils_eq(loadedModel.stage, $author$project$Type$CreateTemplate$Fields) ? A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$CreateTemplate$styles.sectionContainer)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[$rtfeldman$elm_css$Css$displayFlex]))
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$CreateTemplate$styles.addFieldIcon)
								]),
							_List_fromArray(
								[
									A2($author$project$Material$Styled$Icon$addFields, _List_Nil, _List_Nil)
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$CreateTemplate$styles.annotCardTitle)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(createTemplateLanguageData.addFields)
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$CreateTemplate$styles.errorMessage)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							A2($elm$core$Maybe$withDefault, '', loadedModel.fieldError))
						])),
					A2(
					$author$project$Material$Styled$Input$number,
					_List_fromArray(
						[
							$author$project$Material$Styled$Input$containerStyles($author$project$Page$CreateTemplate$styles.inputContainer),
							$author$project$Material$Styled$Input$label('Font Size'),
							$author$project$Material$Styled$Input$value(loadedModel.fontSize),
							$author$project$Material$Styled$Input$onInput(
							A2(
								$elm$core$Basics$composeL,
								A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnCreateTemplate),
								$author$project$Type$CreateTemplate$OnFontSizeUpdate))
						]),
					_List_Nil),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$CreateTemplate$styles.annotContent)
						]),
					_List_fromArray(
						[
							A2($author$project$Page$CreateTemplate$recepientFields, loadedModel, languageSwitchModel)
						])),
					A2(
					$author$project$Material$Styled$Button$button,
					_List_fromArray(
						[
							$author$project$Material$Styled$Button$theme($author$project$Material$Styled$Button$red),
							$author$project$Material$Styled$Button$styles(
							_List_fromArray(
								[
									$rtfeldman$elm_css$Css$marginTop(
									$rtfeldman$elm_css$Css$px(10))
								])),
							$author$project$Material$Styled$Button$disabled(
							_Utils_eq(loadedModel.selectedAnnotForDeletion, $elm$core$Maybe$Nothing)),
							$author$project$Material$Styled$Button$onClick(
							$author$project$Types$OnAuth(
								$author$project$Types$OnCreateTemplate($author$project$Type$CreateTemplate$OnDeleteAnnotClick)))
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$CreateTemplate$styles.sendIcon)
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css(
											_List_fromArray(
												[
													$rtfeldman$elm_css$Css$paddingLeft(
													$rtfeldman$elm_css$Css$px(5)),
													$rtfeldman$elm_css$Css$paddingTop(
													$rtfeldman$elm_css$Css$px(1.5))
												]))
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(deleteButtonText)
										]))
								]))
						])),
					A2(
					$author$project$Material$Styled$Button$button,
					_List_fromArray(
						[
							$author$project$Material$Styled$Button$theme($author$project$Material$Styled$Button$default),
							$author$project$Material$Styled$Button$styles(
							_List_fromArray(
								[
									$rtfeldman$elm_css$Css$marginTop(
									$rtfeldman$elm_css$Css$px(10))
								])),
							$author$project$Material$Styled$Button$onClick(
							$author$project$Types$OnAuth(
								$author$project$Types$OnCreateTemplate(
									$author$project$Type$CreateTemplate$GoToStage($author$project$Type$CreateTemplate$Settings))))
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$CreateTemplate$styles.sendIcon)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Material$Styled$Icon$navigateNext,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Svg$Styled$Attributes$fill('black')
										]),
									_List_Nil),
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css(
											_List_fromArray(
												[
													$rtfeldman$elm_css$Css$paddingLeft(
													$rtfeldman$elm_css$Css$px(5)),
													$rtfeldman$elm_css$Css$paddingTop(
													$rtfeldman$elm_css$Css$px(1.5))
												]))
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(createTemplateLanguageData.nextStep)
										]))
								]))
						]))
				])) : A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Events$onClick(
					$author$project$Types$OnAuth(
						$author$project$Types$OnCreateTemplate(
							$author$project$Type$CreateTemplate$GoToStage($author$project$Type$CreateTemplate$Fields)))),
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$CreateTemplate$styles.sectionContainerClosed)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$CreateTemplate$styles.addFieldIcon)
						]),
					_List_fromArray(
						[
							A2($author$project$Material$Styled$Icon$addFields, _List_Nil, _List_Nil)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$CreateTemplate$styles.annotCardTitleClosed)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(createTemplateLanguageData.addFields)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_Nil,
					_List_fromArray(
						[
							A2($author$project$Material$Styled$Icon$keyboardArrowDown, _List_Nil, _List_Nil)
						]))
				]));
	});
var $author$project$Type$CreateTemplate$OnDocBlur = function (a) {
	return {$: 'OnDocBlur', a: a};
};
var $author$project$Type$CreateTemplate$OnDocInput = F2(
	function (a, b) {
		return {$: 'OnDocInput', a: a, b: b};
	});
var $author$project$Type$CreateTemplate$OnToolTipHover = function (a) {
	return {$: 'OnToolTipHover', a: a};
};
var $author$project$Type$CreateTemplate$OnURLSharingCheck = {$: 'OnURLSharingCheck'};
var $author$project$Type$CreateTemplate$Roles = {$: 'Roles'};
var $author$project$Type$CreateTemplate$Slug = {$: 'Slug'};
var $author$project$Type$CreateTemplate$Title = {$: 'Title'};
var $author$project$Type$CreateTemplate$URLSharing = {$: 'URLSharing'};
var $author$project$Material$Styled$Checkbox$TestAttribute = function (a) {
	return {$: 'TestAttribute', a: a};
};
var $author$project$Material$Styled$Checkbox$testAttribute = function (dataString) {
	return $author$project$Material$Styled$Checkbox$TestAttribute(dataString);
};
var $author$project$Material$Styled$Icon$Upload$view = F2(
	function (attributes, children) {
		return A2(
			$rtfeldman$elm_css$Svg$Styled$svg,
			_Utils_ap(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Svg$Styled$Attributes$fill('black'),
						$rtfeldman$elm_css$Svg$Styled$Attributes$width('24px'),
						$rtfeldman$elm_css$Svg$Styled$Attributes$height('24px'),
						$rtfeldman$elm_css$Svg$Styled$Attributes$viewBox('0 0 24 24')
					]),
				attributes),
			_Utils_ap(
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Svg$Styled$path,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Svg$Styled$Attributes$d('M0 0h24v24H0V0z'),
								$rtfeldman$elm_css$Svg$Styled$Attributes$fill('none')
							]),
						_List_Nil),
						A2(
						$rtfeldman$elm_css$Svg$Styled$path,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Svg$Styled$Attributes$d('M5,10h4v6h6v-6h4l-7-7L5,10z M5,18v2h14v-2H5z')
							]),
						_List_Nil)
					]),
				children));
	});
var $author$project$Material$Styled$Icon$upload = $author$project$Material$Styled$Icon$Upload$view;
var $author$project$Page$CreateTemplate$documentTitle = F3(
	function (model, loadedModel, authModel) {
		var createTemplateLanguageData = model.languageSwitchModel.allLanguageData.location.createTemplatePage;
		var _v0 = authModel;
		var user = _v0.user;
		var _v1 = loadedModel;
		var slug = _v1.slug;
		var title = _v1.title;
		var titleError = _v1.titleError;
		var slugError = _v1.slugError;
		var documentTitleError = _v1.documentTitleError;
		return _Utils_eq(loadedModel.stage, $author$project$Type$CreateTemplate$DocumentTitle) ? A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$CreateTemplate$styles.sectionContainer)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$CreateTemplate$styles.annotCardTitle)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css(
									_List_fromArray(
										[$rtfeldman$elm_css$Css$displayFlex]))
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$CreateTemplate$styles.addFieldIcon)
										]),
									_List_fromArray(
										[
											A2($author$project$Material$Styled$Icon$upload, _List_Nil, _List_Nil)
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css(
											_List_fromArray(
												[
													$rtfeldman$elm_css$Css$paddingTop(
													$rtfeldman$elm_css$Css$px(3))
												]))
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(createTemplateLanguageData.templateTitle)
										]))
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$CreateTemplate$styles.errorMessage)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							A2($elm$core$Maybe$withDefault, '', documentTitleError))
						])),
					A2(
					$author$project$Material$Styled$Input$text,
					_List_fromArray(
						[
							$author$project$Material$Styled$Input$containerStyles($author$project$Page$CreateTemplate$styles.inputContainer),
							$author$project$Material$Styled$Input$label(createTemplateLanguageData.title + '*'),
							$author$project$Material$Styled$Input$value(title),
							$author$project$Material$Styled$Input$errorMessage(titleError),
							$author$project$Material$Styled$Input$onInput(
							A2(
								$elm$core$Basics$composeL,
								A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnCreateTemplate),
								$author$project$Type$CreateTemplate$OnDocInput($author$project$Type$CreateTemplate$Title))),
							$author$project$Material$Styled$Input$onBlur(
							$author$project$Types$OnAuth(
								$author$project$Types$OnCreateTemplate(
									$author$project$Type$CreateTemplate$OnDocBlur($author$project$Type$CreateTemplate$Title))))
						]),
					_List_Nil),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$CreateTemplate$styles.checkboxContainer)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Material$Styled$Checkbox$checkbox,
							_List_fromArray(
								[
									$author$project$Material$Styled$Checkbox$onClick(
									$author$project$Types$OnAuth(
										$author$project$Types$OnCreateTemplate($author$project$Type$CreateTemplate$OnURLSharingCheck))),
									$author$project$Material$Styled$Checkbox$checked(
									!_Utils_eq(slug, $elm$core$Maybe$Nothing)),
									$author$project$Material$Styled$Checkbox$testAttribute('Private Template'),
									$author$project$Material$Styled$Checkbox$containerStyles(
									_List_fromArray(
										[
											$rtfeldman$elm_css$Css$fontSize(
											$rtfeldman$elm_css$Css$px(12.8))
										]))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(createTemplateLanguageData.sharingUrlText)
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_Nil,
							_List_fromArray(
								[
									A5(
									$author$project$View$InfomationToolTip$view,
									$author$project$Types$OnAuth(
										$author$project$Types$OnCreateTemplate(
											$author$project$Type$CreateTemplate$OnToolTipHover($author$project$Type$CreateTemplate$URLSharing))),
									$author$project$Types$OnAuth(
										$author$project$Types$OnCreateTemplate(
											$author$project$Type$CreateTemplate$OnToolTipHover($author$project$Type$CreateTemplate$Closed))),
									_Utils_eq(loadedModel.toolTipActiveHover, $author$project$Type$CreateTemplate$URLSharing),
									A2(
										$rtfeldman$elm_css$Html$Styled$span,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$CreateTemplate$styles.toolTipText)
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('You can customise a URL to allow a signer to access this document and sign. Documents shared via URL are limited to only 1 signer in the document.')
											])),
									$author$project$Material$Styled$Icon$moreInfo)
								]))
						])),
					function () {
					if (slug.$ === 'Just') {
						var slugValue = slug.a;
						return A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css(
									_List_fromArray(
										[
											$rtfeldman$elm_css$Css$marginBottom(
											$rtfeldman$elm_css$Css$px(10))
										]))
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Material$Styled$Input$text,
									_List_fromArray(
										[
											$author$project$Material$Styled$Input$containerStyles($author$project$Page$CreateTemplate$styles.inputContainer),
											$author$project$Material$Styled$Input$label('Document Url*'),
											$author$project$Material$Styled$Input$value(slugValue),
											$author$project$Material$Styled$Input$errorMessage(slugError),
											$author$project$Material$Styled$Input$onInput(
											A2(
												$elm$core$Basics$composeL,
												A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnCreateTemplate),
												$author$project$Type$CreateTemplate$OnDocInput($author$project$Type$CreateTemplate$Slug))),
											$author$project$Material$Styled$Input$onBlur(
											$author$project$Types$OnAuth(
												$author$project$Types$OnCreateTemplate(
													$author$project$Type$CreateTemplate$OnDocBlur($author$project$Type$CreateTemplate$Slug))))
										]),
									_List_Nil),
									($elm$core$String$length(
									$elm$core$String$trim(slugValue)) > 0) ? A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$span,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$CreateTemplate$styles.formUrlContent)
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text('Your form url will be: ')
												])),
											A2($rtfeldman$elm_css$Html$Styled$br, _List_Nil, _List_Nil),
											A2(
											$rtfeldman$elm_css$Html$Styled$span,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$CreateTemplate$styles.formUrlContent)
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(
													$author$project$Data$Domain$toString(
														$author$project$Data$Domain$selected(user.domains)) + ('/form/' + $elm$core$String$toLower(slugValue)))
												]))
										])) : $rtfeldman$elm_css$Html$Styled$text('')
								]));
					} else {
						return $rtfeldman$elm_css$Html$Styled$text('');
					}
				}(),
					A2(
					$author$project$Material$Styled$Button$button,
					_List_fromArray(
						[
							$author$project$Material$Styled$Button$theme($author$project$Material$Styled$Button$blue),
							$author$project$Material$Styled$Button$styles($author$project$Page$CreateTemplate$styles.clearAnnotButton),
							$author$project$Material$Styled$Button$onClick(
							$author$project$Types$OnAuth(
								$author$project$Types$OnCreateTemplate(
									$author$project$Type$CreateTemplate$GoToStage($author$project$Type$CreateTemplate$Roles))))
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$CreateTemplate$styles.sendIcon)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Material$Styled$Icon$navigateNext,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Svg$Styled$Attributes$fill('white')
										]),
									_List_Nil),
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css(
											_List_fromArray(
												[
													$rtfeldman$elm_css$Css$paddingLeft(
													$rtfeldman$elm_css$Css$px(5)),
													$rtfeldman$elm_css$Css$paddingTop(
													$rtfeldman$elm_css$Css$px(1.5))
												]))
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(createTemplateLanguageData.nextStep)
										]))
								]))
						]))
				])) : A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$CreateTemplate$styles.sectionContainerClosed),
					$rtfeldman$elm_css$Html$Styled$Events$onClick(
					$author$project$Types$OnAuth(
						$author$project$Types$OnCreateTemplate(
							$author$project$Type$CreateTemplate$GoToStage($author$project$Type$CreateTemplate$DocumentTitle))))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$CreateTemplate$styles.addFieldIcon)
						]),
					_List_fromArray(
						[
							A2($author$project$Material$Styled$Icon$upload, _List_Nil, _List_Nil)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$CreateTemplate$styles.annotCardTitleClosed)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(createTemplateLanguageData.templateTitle)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_Nil,
					_List_fromArray(
						[
							A2($author$project$Material$Styled$Icon$keyboardArrowDown, _List_Nil, _List_Nil)
						]))
				]));
	});
var $author$project$Type$CreateTemplate$OnErrorClose = {$: 'OnErrorClose'};
var $author$project$Page$CreateTemplate$errorBanner = function (model) {
	var _v0 = model.status;
	if (_v0.$ === 'Error') {
		var err = _v0.a;
		return A2(
			$author$project$Material$Styled$Banner$banner,
			_List_fromArray(
				[
					$author$project$Material$Styled$Banner$containerStyles($author$project$Page$CreateTemplate$styles.errorBannerContainer),
					$author$project$Material$Styled$Banner$theme($author$project$Material$Styled$Banner$errorTheme),
					$author$project$Material$Styled$Banner$body(
					$rtfeldman$elm_css$Html$Styled$text('- ' + err)),
					$author$project$Material$Styled$Banner$title('Error message'),
					$author$project$Material$Styled$Banner$closeIconAttributes(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Svg$Styled$Events$onClick(
							$author$project$Types$OnAuth(
								$author$project$Types$OnCreateTemplate($author$project$Type$CreateTemplate$OnErrorClose)))
						]))
				]),
			_List_Nil);
	} else {
		return $rtfeldman$elm_css$Html$Styled$text('');
	}
};
var $author$project$Page$CreateTemplate$overlay = F2(
	function (selectedAnnotation, status) {
		switch (status.$) {
			case 'FilledFieldForm':
				return A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$CreateTemplate$styles.overlay)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('Click on the Document on the left to insert the field.')
						]));
			case 'PendingFieldForm':
				return $rtfeldman$elm_css$Html$Styled$text('');
			case 'CheckboxFieldForm':
				return $rtfeldman$elm_css$Html$Styled$text('');
			default:
				if (selectedAnnotation.$ === 'Just') {
					return A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$CreateTemplate$styles.overlay)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('Click on the Document on the left to insert the field.')
							]));
				} else {
					return $rtfeldman$elm_css$Html$Styled$text('');
				}
		}
	});
var $author$project$Type$CreateTemplate$AddingViewer = {$: 'AddingViewer'};
var $author$project$Type$CreateTemplate$Email = {$: 'Email'};
var $author$project$Type$CreateTemplate$FirstName = {$: 'FirstName'};
var $author$project$Type$CreateTemplate$LastName = {$: 'LastName'};
var $author$project$Type$CreateTemplate$Name = {$: 'Name'};
var $author$project$Type$CreateTemplate$OnAddRecipientBlur = function (a) {
	return {$: 'OnAddRecipientBlur', a: a};
};
var $author$project$Type$CreateTemplate$OnCheckBoxClick = function (a) {
	return {$: 'OnCheckBoxClick', a: a};
};
var $author$project$Type$CreateTemplate$OnClearRecipientFields = {$: 'OnClearRecipientFields'};
var $author$project$Type$CreateTemplate$OnRecipientAddSubmit = {$: 'OnRecipientAddSubmit'};
var $author$project$Type$CreateTemplate$OnUpdateRoleDetails = F2(
	function (a, b) {
		return {$: 'OnUpdateRoleDetails', a: a, b: b};
	});
var $author$project$Type$CreateTemplate$Search = {$: 'Search'};
var $author$project$Type$CreateTemplate$SpecifyRecipient = {$: 'SpecifyRecipient'};
var $author$project$Material$Styled$Icon$AddRecipient$view = F2(
	function (attributes, children) {
		return A2(
			$rtfeldman$elm_css$Svg$Styled$svg,
			_Utils_ap(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Svg$Styled$Attributes$fill('black'),
						$rtfeldman$elm_css$Svg$Styled$Attributes$width('24px'),
						$rtfeldman$elm_css$Svg$Styled$Attributes$height('24px'),
						$rtfeldman$elm_css$Svg$Styled$Attributes$viewBox('0 0 24 24')
					]),
				attributes),
			_Utils_ap(
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Svg$Styled$path,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Svg$Styled$Attributes$d('M0 0h24v24H0V0z'),
								$rtfeldman$elm_css$Svg$Styled$Attributes$fill('none')
							]),
						_List_Nil),
						A2(
						$rtfeldman$elm_css$Svg$Styled$path,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Svg$Styled$Attributes$d('M15 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm-9-2V8c0-.55-.45-1-1-1s-1 .45-1 1v2H2c-.55 0-1 .45-1 1s.45 1 1 1h2v2c0 .55.45 1 1 1s1-.45 1-1v-2h2c.55 0 1-.45 1-1s-.45-1-1-1H6zm9 4c-2.67 0-8 1.34-8 4v1c0 .55.45 1 1 1h14c.55 0 1-.45 1-1v-1c0-2.66-5.33-4-8-4z')
							]),
						_List_Nil)
					]),
				children));
	});
var $author$project$Material$Styled$Icon$addRecipient = $author$project$Material$Styled$Icon$AddRecipient$view;
var $author$project$Page$CreateTemplate$addRecipientBtn = F2(
	function (model, loadedModel) {
		var uploadDocumentLanguageData = model.languageSwitchModel.allLanguageData.location.uploadDocument;
		var _v0 = A2(
			$elm$core$Maybe$withDefault,
			{email: '', emailError: $elm$core$Maybe$Nothing, firstName: '', firstNameError: $elm$core$Maybe$Nothing, lastName: '', lastNameError: $elm$core$Maybe$Nothing, search: '', searchResult: $elm$core$Maybe$Nothing},
			loadedModel.addRole.roleDetails);
		var emailError = _v0.emailError;
		var firstNameError = _v0.firstNameError;
		var lastNameError = _v0.lastNameError;
		var hasError = A2(
			$elm$core$List$any,
			$elm$core$Basics$neq($elm$core$Maybe$Nothing),
			_List_fromArray(
				[emailError, firstNameError, lastNameError]));
		return hasError ? $author$project$View$SubmitButton$disabled(uploadDocumentLanguageData.add) : $author$project$View$SubmitButton$enabled(uploadDocumentLanguageData.add);
	});
var $author$project$Type$CreateTemplate$OnAutocompleteClick = function (a) {
	return {$: 'OnAutocompleteClick', a: a};
};
var $author$project$Page$CreateTemplate$displayIcon = F2(
	function (verification, icon) {
		return verification ? A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					icon,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Svg$Styled$Attributes$css($author$project$Page$CreateTemplate$styles.allIcon)
						]),
					_List_Nil)
				])) : A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					icon,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Svg$Styled$Attributes$css($author$project$Page$CreateTemplate$styles.allIcon),
							$rtfeldman$elm_css$Svg$Styled$Attributes$fill('grey')
						]),
					_List_Nil)
				]));
	});
var $author$project$Page$CreateTemplate$displayImage = function (verification) {
	return verification ? A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$img,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$src($author$project$View$Theme$images.myInfoLogo),
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$CreateTemplate$styles.myInfoImage)
					]),
				_List_Nil)
			])) : A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$img,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$src($author$project$View$Theme$images.myInfoLogo),
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$CreateTemplate$styles.myInfoImageBlurred)
					]),
				_List_Nil)
			]));
};
var $author$project$Material$Styled$Icon$VerifiedUser$view = F2(
	function (attributes, children) {
		return A2(
			$rtfeldman$elm_css$Svg$Styled$svg,
			_Utils_ap(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Svg$Styled$Attributes$fill('black'),
						$rtfeldman$elm_css$Svg$Styled$Attributes$width('24px'),
						$rtfeldman$elm_css$Svg$Styled$Attributes$height('24px'),
						$rtfeldman$elm_css$Svg$Styled$Attributes$viewBox('0 0 24 24')
					]),
				attributes),
			_Utils_ap(
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Svg$Styled$path,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Svg$Styled$Attributes$d('M0 0h24v24H0z'),
								$rtfeldman$elm_css$Svg$Styled$Attributes$fill('none')
							]),
						_List_Nil),
						A2(
						$rtfeldman$elm_css$Svg$Styled$path,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Svg$Styled$Attributes$d('M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm-2 16l-4-4 1.41-1.41L10 14.17l6.59-6.59L18 9l-8 8z')
							]),
						_List_Nil)
					]),
				children));
	});
var $author$project$Material$Styled$Icon$verifiedUser = $author$project$Material$Styled$Icon$VerifiedUser$view;
var $author$project$Page$CreateTemplate$displaySearchResult = function (searchResult) {
	if (searchResult.$ === 'Just') {
		var results = searchResult.a;
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$CreateTemplate$styles.searchField)
				]),
			A2(
				$elm$core$List$map,
				function (result) {
					return A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$CreateTemplate$styles.searchResultContainer),
								$rtfeldman$elm_css$Html$Styled$Events$onClick(
								$author$project$Types$OnAuth(
									$author$project$Types$OnCreateTemplate(
										$author$project$Type$CreateTemplate$OnAutocompleteClick(result))))
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$CreateTemplate$styles.searchResult)
									]),
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$span,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$CreateTemplate$styles.resultText)
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(
												A2($elm$core$Maybe$withDefault, result.firstName + (' ' + result.lastName), result.alias))
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$span,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$CreateTemplate$styles.resultText)
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(
												A2($elm$core$Maybe$withDefault, '', result.label))
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$span,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$CreateTemplate$styles.resultText)
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(result.email)
											]))
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$CreateTemplate$styles.iconContainer)
									]),
								_List_fromArray(
									[
										A2($author$project$Page$CreateTemplate$displayIcon, result.verifyStripe, $author$project$Material$Styled$Icon$payment),
										A2($author$project$Page$CreateTemplate$displayIcon, result.verifyPassbase, $author$project$Material$Styled$Icon$verifiedUser),
										A2($author$project$Page$CreateTemplate$displayIcon, result.verifyMobilePhone, $author$project$Material$Styled$Icon$phoneLinkLock),
										A2($author$project$Page$CreateTemplate$displayIcon, result.verifyWallet, $author$project$Material$Styled$Icon$accountBalanceWallet),
										$author$project$Page$CreateTemplate$displayImage(result.verifyMyInfo)
									]))
							]));
				},
				results));
	} else {
		return $rtfeldman$elm_css$Html$Styled$text('');
	}
};
var $author$project$Page$CreateTemplate$recepients = function (_v0) {
	var template = _v0.template;
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_Nil,
		A2(
			$elm$core$List$map,
			function (value) {
				return A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_Utils_ap($author$project$Page$CreateTemplate$styles.recipientContent, $author$project$Page$CreateTemplate$styles.annotContainer))
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$CreateTemplate$styles.signerNameContainer)
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$CreateTemplate$styles.recipientHeader)
										]),
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$span,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$CreateTemplate$styles.recipientItemTitle),
													$rtfeldman$elm_css$Html$Styled$Attributes$css(
													_List_fromArray(
														[
															$rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$inline)
														]))
												]),
											_List_fromArray(
												[
													A2(
													$rtfeldman$elm_css$Html$Styled$strong,
													_List_Nil,
													_List_fromArray(
														[
															_Utils_eq(value.firstName, $elm$core$Maybe$Nothing) ? $rtfeldman$elm_css$Html$Styled$text(value.role) : $rtfeldman$elm_css$Html$Styled$text(
															A2($elm$core$Maybe$withDefault, '', value.firstName) + (' ' + A2($elm$core$Maybe$withDefault, '', value.lastName)))
														])),
													$rtfeldman$elm_css$Html$Styled$text(
													' ' + A2($elm$core$Maybe$withDefault, '', value.email))
												]))
										]))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$CreateTemplate$styles.avatarContainer)
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css(
											A2(
												$elm$core$List$append,
												$author$project$Page$CreateTemplate$styles.avatar,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Css$backgroundColor(
														$author$project$Data$PDF$User$materialColorCode(value.color))
													]))),
											$rtfeldman$elm_css$Html$Styled$Attributes$title(value.role)
										]),
									_List_fromArray(
										[
											_Utils_eq(value.signOrder, -1) ? $rtfeldman$elm_css$Html$Styled$text(
											A2($elm$core$String$left, 2, 'Viewer')) : $rtfeldman$elm_css$Html$Styled$text(
											A2($elm$core$String$left, 2, value.role))
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$CreateTemplate$styles.viewerText)
										]),
									_List_fromArray(
										[
											_Utils_eq(value.signOrder, -1) ? $rtfeldman$elm_css$Html$Styled$text('Viewer') : $rtfeldman$elm_css$Html$Styled$text(value.role)
										])),
									A2(
									$author$project$Material$Styled$Icon$close,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Svg$Styled$Attributes$css($author$project$Page$CreateTemplate$styles.recipientRmvIcon),
											$rtfeldman$elm_css$Svg$Styled$Events$onClick(
											$author$project$Types$OnAuth(
												$author$project$Types$OnCreateTemplate(
													$author$project$Type$CreateTemplate$OnRemoveRecipient(value.role))))
										]),
									_List_Nil)
								]))
						]));
			},
			$author$project$Data$PDF$CreateTemplate$getRoles(template)));
};
var $author$project$Page$CreateTemplate$roles = F2(
	function (model, loadedModel) {
		var uploadDocumentLanguageData = model.languageSwitchModel.allLanguageData.location.uploadDocument;
		var createTemplateLanguageData = model.languageSwitchModel.allLanguageData.location.createTemplatePage;
		var _v0 = $elm$core$List$isEmpty(
			$author$project$Data$PDF$CreateTemplate$getRoles(loadedModel.template)) ? _Utils_Tuple2($author$project$Material$Styled$Button$default, 'black') : _Utils_Tuple2($author$project$Material$Styled$Button$blue, 'white');
		var buttonTheme = _v0.a;
		var iconColour = _v0.b;
		var _v1 = loadedModel.addRole;
		var name = _v1.name;
		var roleDetails = _v1.roleDetails;
		var addRoleError = _v1.addRoleError;
		return _Utils_eq(loadedModel.stage, $author$project$Type$CreateTemplate$Roles) ? A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$CreateTemplate$styles.sectionContainer)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[$rtfeldman$elm_css$Css$displayFlex]))
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$CreateTemplate$styles.addFieldIcon)
								]),
							_List_fromArray(
								[
									A2($author$project$Material$Styled$Icon$addRecipient, _List_Nil, _List_Nil)
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$CreateTemplate$styles.annotCardTitle)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(createTemplateLanguageData.addRole)
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$CreateTemplate$styles.errorMessage)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							A2($elm$core$Maybe$withDefault, '', addRoleError))
						])),
					$author$project$Page$CreateTemplate$recepients(loadedModel),
					(!_Utils_eq(loadedModel.checkboxLocation, $author$project$Type$CreateTemplate$Viewer)) ? A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$CreateTemplate$styles.titleContainer)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$CreateTemplate$styles.addRcptHeader)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(createTemplateLanguageData.addNewRole)
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Events$onClick(
									$author$project$Types$OnAuth(
										$author$project$Types$OnCreateTemplate($author$project$Type$CreateTemplate$OnClearRecipientFields))),
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$CreateTemplate$styles.clearText)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(uploadDocumentLanguageData.clear)
								]))
						])) : $rtfeldman$elm_css$Html$Styled$text(''),
					A2(
					$rtfeldman$elm_css$Html$Styled$form,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Events$onSubmit(
							$author$project$Types$OnAuth(
								$author$project$Types$OnCreateTemplate($author$project$Type$CreateTemplate$OnRecipientAddSubmit)))
						]),
					_List_fromArray(
						[
							(!_Utils_eq(loadedModel.checkboxLocation, $author$project$Type$CreateTemplate$Viewer)) ? A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css(
									_List_fromArray(
										[
											$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$relative)
										]))
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Material$Styled$Input$text,
									_List_fromArray(
										[
											$author$project$Material$Styled$Input$label(createTemplateLanguageData.newRole),
											$author$project$Material$Styled$Input$value(name),
											$author$project$Material$Styled$Input$containerStyles($author$project$Page$CreateTemplate$styles.input),
											$author$project$Material$Styled$Input$onInput(
											A2(
												$elm$core$Basics$composeL,
												A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnCreateTemplate),
												$author$project$Type$CreateTemplate$OnUpdateRoleDetails($author$project$Type$CreateTemplate$Name))),
											$author$project$Material$Styled$Input$onBlur(
											$author$project$Types$OnAuth(
												$author$project$Types$OnCreateTemplate(
													$author$project$Type$CreateTemplate$OnAddRecipientBlur($author$project$Type$CreateTemplate$Name))))
										]),
									_List_Nil)
								])) : $rtfeldman$elm_css$Html$Styled$text(''),
							(!_Utils_eq(loadedModel.checkboxLocation, $author$project$Type$CreateTemplate$Viewer)) ? A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$CreateTemplate$styles.checkboxContainer)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Material$Styled$Checkbox$checkbox,
									_List_fromArray(
										[
											$author$project$Material$Styled$Checkbox$onClick(
											$author$project$Types$OnAuth(
												$author$project$Types$OnCreateTemplate(
													$author$project$Type$CreateTemplate$OnCheckBoxClick($author$project$Type$CreateTemplate$Role)))),
											$author$project$Material$Styled$Checkbox$checked(
											(!_Utils_eq(roleDetails, $elm$core$Maybe$Nothing)) && _Utils_eq(loadedModel.checkboxLocation, $author$project$Type$CreateTemplate$Role)),
											$author$project$Material$Styled$Checkbox$containerStyles(
											_List_fromArray(
												[
													$rtfeldman$elm_css$Css$fontSize(
													$rtfeldman$elm_css$Css$px(12.8))
												]))
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(createTemplateLanguageData.assignRecipientToRole)
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_Nil,
									_List_fromArray(
										[
											A5(
											$author$project$View$InfomationToolTip$view,
											$author$project$Types$OnAuth(
												$author$project$Types$OnCreateTemplate(
													$author$project$Type$CreateTemplate$OnToolTipHover($author$project$Type$CreateTemplate$SpecifyRecipient))),
											$author$project$Types$OnAuth(
												$author$project$Types$OnCreateTemplate(
													$author$project$Type$CreateTemplate$OnToolTipHover($author$project$Type$CreateTemplate$Closed))),
											_Utils_eq(loadedModel.toolTipActiveHover, $author$project$Type$CreateTemplate$SpecifyRecipient),
											A2(
												$rtfeldman$elm_css$Html$Styled$span,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$CreateTemplate$styles.toolTipText)
													]),
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text(createTemplateLanguageData.assignRecipientToRoleTooltipText)
													])),
											$author$project$Material$Styled$Icon$moreInfo)
										]))
								])) : $rtfeldman$elm_css$Html$Styled$text(''),
							(!_Utils_eq(loadedModel.checkboxLocation, $author$project$Type$CreateTemplate$Role)) ? A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$CreateTemplate$styles.checkboxContainer)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Material$Styled$Checkbox$checkbox,
									_List_fromArray(
										[
											$author$project$Material$Styled$Checkbox$onClick(
											$author$project$Types$OnAuth(
												$author$project$Types$OnCreateTemplate(
													$author$project$Type$CreateTemplate$OnCheckBoxClick($author$project$Type$CreateTemplate$Viewer)))),
											$author$project$Material$Styled$Checkbox$checked(
											(!_Utils_eq(roleDetails, $elm$core$Maybe$Nothing)) && _Utils_eq(loadedModel.checkboxLocation, $author$project$Type$CreateTemplate$Viewer)),
											$author$project$Material$Styled$Checkbox$containerStyles(
											_List_fromArray(
												[
													$rtfeldman$elm_css$Css$fontSize(
													$rtfeldman$elm_css$Css$px(12.8))
												]))
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(createTemplateLanguageData.assignRecipientToViewer)
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_Nil,
									_List_fromArray(
										[
											A5(
											$author$project$View$InfomationToolTip$view,
											$author$project$Types$OnAuth(
												$author$project$Types$OnCreateTemplate(
													$author$project$Type$CreateTemplate$OnToolTipHover($author$project$Type$CreateTemplate$AddingViewer))),
											$author$project$Types$OnAuth(
												$author$project$Types$OnCreateTemplate(
													$author$project$Type$CreateTemplate$OnToolTipHover($author$project$Type$CreateTemplate$Closed))),
											_Utils_eq(loadedModel.toolTipActiveHover, $author$project$Type$CreateTemplate$AddingViewer),
											A2(
												$rtfeldman$elm_css$Html$Styled$span,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$CreateTemplate$styles.toolTipText)
													]),
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text(createTemplateLanguageData.assignRecipientToViewerTooltipText)
													])),
											$author$project$Material$Styled$Icon$moreInfo)
										]))
								])) : $rtfeldman$elm_css$Html$Styled$text(''),
							function () {
							if (roleDetails.$ === 'Just') {
								var firstName = roleDetails.a.firstName;
								var email = roleDetails.a.email;
								var lastName = roleDetails.a.lastName;
								var firstNameError = roleDetails.a.firstNameError;
								var lastNameError = roleDetails.a.lastNameError;
								var emailError = roleDetails.a.emailError;
								var search = roleDetails.a.search;
								var searchResult = roleDetails.a.searchResult;
								return A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$div,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$css(
													_List_fromArray(
														[
															$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$relative)
														]))
												]),
											_List_fromArray(
												[
													A2(
													$author$project$Material$Styled$Input$text,
													_List_fromArray(
														[
															$author$project$Material$Styled$Input$label(uploadDocumentLanguageData.searchAddressBook),
															$author$project$Material$Styled$Input$value(search),
															$author$project$Material$Styled$Input$containerStyles($author$project$Page$CreateTemplate$styles.input),
															$author$project$Material$Styled$Input$onInput(
															A2(
																$elm$core$Basics$composeL,
																A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnCreateTemplate),
																$author$project$Type$CreateTemplate$OnUpdateRoleDetails($author$project$Type$CreateTemplate$Search))),
															$author$project$Material$Styled$Input$onBlur(
															$author$project$Types$OnAuth(
																$author$project$Types$OnCreateTemplate(
																	$author$project$Type$CreateTemplate$OnAddRecipientBlur($author$project$Type$CreateTemplate$Search))))
														]),
													_List_Nil),
													$author$project$Page$CreateTemplate$displaySearchResult(searchResult)
												])),
											A2(
											$author$project$Material$Styled$Input$email,
											_List_fromArray(
												[
													$author$project$Material$Styled$Input$label(uploadDocumentLanguageData.email),
													$author$project$Material$Styled$Input$value(email),
													$author$project$Material$Styled$Input$containerStyles($author$project$Page$CreateTemplate$styles.input),
													$author$project$Material$Styled$Input$errorMessage(emailError),
													$author$project$Material$Styled$Input$onInput(
													A2(
														$elm$core$Basics$composeL,
														A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnCreateTemplate),
														$author$project$Type$CreateTemplate$OnUpdateRoleDetails($author$project$Type$CreateTemplate$Email))),
													$author$project$Material$Styled$Input$onBlur(
													$author$project$Types$OnAuth(
														$author$project$Types$OnCreateTemplate(
															$author$project$Type$CreateTemplate$OnAddRecipientBlur($author$project$Type$CreateTemplate$Email))))
												]),
											_List_Nil),
											A2(
											$author$project$Material$Styled$Input$text,
											_List_fromArray(
												[
													$author$project$Material$Styled$Input$label(uploadDocumentLanguageData.firstName),
													$author$project$Material$Styled$Input$value(firstName),
													$author$project$Material$Styled$Input$containerStyles($author$project$Page$CreateTemplate$styles.input),
													$author$project$Material$Styled$Input$errorMessage(firstNameError),
													$author$project$Material$Styled$Input$onInput(
													A2(
														$elm$core$Basics$composeL,
														A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnCreateTemplate),
														$author$project$Type$CreateTemplate$OnUpdateRoleDetails($author$project$Type$CreateTemplate$FirstName))),
													$author$project$Material$Styled$Input$onBlur(
													$author$project$Types$OnAuth(
														$author$project$Types$OnCreateTemplate(
															$author$project$Type$CreateTemplate$OnAddRecipientBlur($author$project$Type$CreateTemplate$FirstName))))
												]),
											_List_Nil),
											A2(
											$author$project$Material$Styled$Input$text,
											_List_fromArray(
												[
													$author$project$Material$Styled$Input$label(uploadDocumentLanguageData.lastName),
													$author$project$Material$Styled$Input$value(lastName),
													$author$project$Material$Styled$Input$containerStyles($author$project$Page$CreateTemplate$styles.input),
													$author$project$Material$Styled$Input$errorMessage(lastNameError),
													$author$project$Material$Styled$Input$onInput(
													A2(
														$elm$core$Basics$composeL,
														A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnCreateTemplate),
														$author$project$Type$CreateTemplate$OnUpdateRoleDetails($author$project$Type$CreateTemplate$LastName))),
													$author$project$Material$Styled$Input$onBlur(
													$author$project$Types$OnAuth(
														$author$project$Types$OnCreateTemplate(
															$author$project$Type$CreateTemplate$OnAddRecipientBlur($author$project$Type$CreateTemplate$LastName))))
												]),
											_List_Nil)
										]));
							} else {
								return $rtfeldman$elm_css$Html$Styled$text('');
							}
						}(),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$CreateTemplate$styles.addRcptBtnContainer)
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$CreateTemplate$styles.addRcptBtn)
										]),
									_List_fromArray(
										[
											A2($author$project$Page$CreateTemplate$addRecipientBtn, model, loadedModel)
										]))
								]))
						])),
					A2(
					$author$project$Material$Styled$Button$button,
					_List_fromArray(
						[
							$author$project$Material$Styled$Button$theme($author$project$Material$Styled$Button$default),
							$author$project$Material$Styled$Button$styles($author$project$Page$CreateTemplate$styles.clearAnnotButton),
							$author$project$Material$Styled$Button$onClick(
							$author$project$Types$OnAuth(
								$author$project$Types$OnCreateTemplate(
									$author$project$Type$CreateTemplate$GoToStage($author$project$Type$CreateTemplate$Fields))))
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$CreateTemplate$styles.sendIcon)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Material$Styled$Icon$navigateNext,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Svg$Styled$Attributes$fill('black')
										]),
									_List_Nil),
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css(
											_List_fromArray(
												[
													$rtfeldman$elm_css$Css$paddingLeft(
													$rtfeldman$elm_css$Css$px(5)),
													$rtfeldman$elm_css$Css$paddingTop(
													$rtfeldman$elm_css$Css$px(1.5))
												]))
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(createTemplateLanguageData.nextStep)
										]))
								]))
						]))
				])) : A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$CreateTemplate$styles.sectionContainerClosed),
					$rtfeldman$elm_css$Html$Styled$Events$onClick(
					$author$project$Types$OnAuth(
						$author$project$Types$OnCreateTemplate(
							$author$project$Type$CreateTemplate$GoToStage($author$project$Type$CreateTemplate$Roles))))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$CreateTemplate$styles.addFieldIcon)
						]),
					_List_fromArray(
						[
							A2($author$project$Material$Styled$Icon$addRecipient, _List_Nil, _List_Nil)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$CreateTemplate$styles.annotCardTitleClosed)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(createTemplateLanguageData.addRole)
						])),
					A2($author$project$Material$Styled$Icon$keyboardArrowDown, _List_Nil, _List_Nil)
				]));
	});
var $author$project$Type$CreateTemplate$OnTemplateSubmit = {$: 'OnTemplateSubmit'};
var $author$project$Page$CreateTemplate$submitButton = function (model) {
	var createTemplateLanguageData = model.languageSwitchModel.allLanguageData.location.createTemplatePage;
	return A2(
		$author$project$Material$Styled$Button$button,
		_List_fromArray(
			[
				$author$project$Material$Styled$Button$theme($author$project$Material$Styled$Button$green),
				$author$project$Material$Styled$Button$styles($author$project$Page$CreateTemplate$styles.submitButton),
				$author$project$Material$Styled$Button$onClick(
				$author$project$Types$OnAuth(
					$author$project$Types$OnCreateTemplate($author$project$Type$CreateTemplate$OnTemplateSubmit)))
			]),
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$text(createTemplateLanguageData.submit)
			]));
};
var $author$project$Type$CreateTemplate$OnFormCancel = {$: 'OnFormCancel'};
var $author$project$Type$CreateTemplate$OnFormNameBlur = {$: 'OnFormNameBlur'};
var $author$project$Type$CreateTemplate$OnFormNameInput = function (a) {
	return {$: 'OnFormNameInput', a: a};
};
var $author$project$Type$CreateTemplate$OnFormSubmit = {$: 'OnFormSubmit'};
var $author$project$Page$CreateTemplate$Form$styles = {
	btnContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(14)),
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$flexEnd)
		]),
	cancelBtn: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(100))
		]),
	input: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginBottom(
			$rtfeldman$elm_css$Css$px(10))
		]),
	modalBody: _List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Css$margin2,
			$rtfeldman$elm_css$Css$px(5),
			$rtfeldman$elm_css$Css$zero)
		]),
	modalBodyTxt: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(12)),
			$rtfeldman$elm_css$Css$fontWeight(
			$rtfeldman$elm_css$Css$int(400)),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$blueGrey500)
		]),
	modalContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$vw(70)),
			$rtfeldman$elm_css$Css$maxWidth(
			$rtfeldman$elm_css$Css$px(500))
		]),
	modalHeader: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$row),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$flexStart),
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceBetween),
			A2(
			$rtfeldman$elm_css$Css$margin2,
			$rtfeldman$elm_css$Css$px(5),
			$rtfeldman$elm_css$Css$zero)
		]),
	modalHeaderTxt: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(20)),
			$rtfeldman$elm_css$Css$fontWeight(
			$rtfeldman$elm_css$Css$int(500))
		]),
	requiredCheckBox: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginLeft(
			$rtfeldman$elm_css$Css$px(-10)),
			$rtfeldman$elm_css$Css$marginBottom(
			$rtfeldman$elm_css$Css$px(10))
		]),
	submitBtn: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginRight(
			$rtfeldman$elm_css$Css$px(10)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(120))
		])
};
var $author$project$Page$CreateTemplate$Form$submitFieldFormBtn = function (model) {
	var _v0 = model.annotFieldForm;
	var nameError = _v0.nameError;
	if (nameError.$ === 'Nothing') {
		return $author$project$View$SubmitButton$enabled('Add Field');
	} else {
		return $author$project$View$SubmitButton$disabled('Add Field');
	}
};
var $author$project$Page$CreateTemplate$Form$view = function (model) {
	var _v0 = model;
	var annotFieldForm = _v0.annotFieldForm;
	var _v1 = annotFieldForm;
	var status = _v1.status;
	var name = _v1.name;
	var nameError = _v1.nameError;
	var _v2 = function () {
		switch (status.$) {
			case 'PendingFieldForm':
				return _Utils_Tuple2('Recipient Editable Text Field', 'Insert a text field for your recipients to fill in. You can give the field a name so that your users know what information to input.\u00A0');
			case 'CheckboxFieldForm':
				return _Utils_Tuple2('Recipient Checkbox Field', 'You can give the checkbox field a name so that you can identify this checkbox in your template report.\u00A0');
			default:
				return _Utils_Tuple2('', '');
		}
	}();
	var title = _v2.a;
	var content = _v2.b;
	return A2(
		$author$project$Material$Styled$Modal$modal,
		_List_fromArray(
			[
				$author$project$Material$Styled$Modal$open(
				_Utils_eq(status, $author$project$Type$CreateTemplate$PendingFieldForm) || _Utils_eq(status, $author$project$Type$CreateTemplate$CheckboxFieldForm)),
				$author$project$Material$Styled$Modal$contentContainerstyles($author$project$Page$CreateTemplate$Form$styles.modalContainer)
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$CreateTemplate$Form$styles.modalHeader)
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$CreateTemplate$Form$styles.modalHeaderTxt)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(title)
							]))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$CreateTemplate$Form$styles.modalBody)
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$CreateTemplate$Form$styles.modalBodyTxt)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(content)
							]))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$form,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Events$onSubmit(
						$author$project$Types$OnAuth(
							$author$project$Types$OnCreateTemplate($author$project$Type$CreateTemplate$OnFormSubmit)))
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Material$Styled$Input$text,
						_List_fromArray(
							[
								$author$project$Material$Styled$Input$label(''),
								$author$project$Material$Styled$Input$value(name),
								$author$project$Material$Styled$Input$containerStyles($author$project$Page$CreateTemplate$Form$styles.input),
								$author$project$Material$Styled$Input$errorMessage(nameError),
								$author$project$Material$Styled$Input$onInput(
								A2(
									$elm$core$Basics$composeL,
									A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnCreateTemplate),
									$author$project$Type$CreateTemplate$OnFormNameInput)),
								$author$project$Material$Styled$Input$onBlur(
								$author$project$Types$OnAuth(
									$author$project$Types$OnCreateTemplate($author$project$Type$CreateTemplate$OnFormNameBlur)))
							]),
						_List_Nil),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$CreateTemplate$Form$styles.btnContainer)
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$span,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$CreateTemplate$Form$styles.submitBtn)
									]),
								_List_fromArray(
									[
										$author$project$Page$CreateTemplate$Form$submitFieldFormBtn(model)
									])),
								A2(
								$author$project$Material$Styled$Button$button,
								_List_fromArray(
									[
										$author$project$Material$Styled$Button$theme($author$project$Material$Styled$Button$default),
										$author$project$Material$Styled$Button$buttonType($author$project$Material$Styled$Button$ButtonType),
										$author$project$Material$Styled$Button$styles($author$project$Page$CreateTemplate$Form$styles.cancelBtn),
										$author$project$Material$Styled$Button$onClick(
										$author$project$Types$OnAuth(
											$author$project$Types$OnCreateTemplate($author$project$Type$CreateTemplate$OnFormCancel)))
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('Cancel')
									]))
							]))
					]))
			]));
};
var $author$project$Type$CreateTemplate$OnDocConversionErrorRedirect = {$: 'OnDocConversionErrorRedirect'};
var $author$project$Page$CreateTemplate$Modal$styles = {
	backToDashboardBtn: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$maxWidth(
			$rtfeldman$elm_css$Css$px(200))
		]),
	icon: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$boxShadow($rtfeldman$elm_css$Css$none),
			$rtfeldman$elm_css$Css$transform(
			A2(
				$rtfeldman$elm_css$Css$translate2,
				$rtfeldman$elm_css$Css$px(20),
				$rtfeldman$elm_css$Css$px(-15))),
			$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer),
			$rtfeldman$elm_css$Css$padding(
			$rtfeldman$elm_css$Css$px(10))
		]),
	inputContainer: _List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Css$margin2,
			$rtfeldman$elm_css$Css$px(20),
			$rtfeldman$elm_css$Css$zero)
		]),
	modalBody: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(12)),
			$rtfeldman$elm_css$Css$fontWeight(
			$rtfeldman$elm_css$Css$int(400)),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$blueGrey500)
		]),
	modalBtns: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$rowReverse),
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceBetween)
		]),
	modalContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$vw(70)),
			$rtfeldman$elm_css$Css$maxWidth(
			$rtfeldman$elm_css$Css$px(500))
		]),
	modalHeader: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$row),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$flexStart),
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceBetween),
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(5))
		]),
	modalHeaderTxt: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(20)),
			$rtfeldman$elm_css$Css$fontWeight(
			$rtfeldman$elm_css$Css$int(500))
		]),
	passwordButtons: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(180))
		]),
	progressBar: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(10))
		]),
	redirectButton: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(20))
		]),
	uploadBtn: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$maxWidth(
			$rtfeldman$elm_css$Css$px(130))
		])
};
var $author$project$Page$CreateTemplate$Modal$errorModal = A2(
	$author$project$Material$Styled$Modal$modal,
	_List_fromArray(
		[
			$author$project$Material$Styled$Modal$open(true),
			$author$project$Material$Styled$Modal$contentContainerstyles($author$project$Page$CreateTemplate$Modal$styles.modalContainer)
		]),
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$CreateTemplate$Modal$styles.modalHeader)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$CreateTemplate$Modal$styles.modalHeaderTxt)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('Error!')
						]))
				])),
			A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$CreateTemplate$Modal$styles.modalBody)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('There is an error with the conversion. Please upload the file again. Click the button below to return to the homepage')
						])),
					A2(
					$author$project$Material$Styled$Button$button,
					_List_fromArray(
						[
							$author$project$Material$Styled$Button$styles($author$project$Page$CreateTemplate$Modal$styles.redirectButton),
							$author$project$Material$Styled$Button$onClick(
							$author$project$Types$OnAuth(
								$author$project$Types$OnCreateTemplate($author$project$Type$CreateTemplate$OnDocConversionErrorRedirect)))
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('Redirect to Homepage')
						]))
				]))
		]));
var $author$project$Page$CreateTemplate$Modal$loadingModal = A2(
	$author$project$Material$Styled$Modal$modal,
	_List_fromArray(
		[
			$author$project$Material$Styled$Modal$open(true),
			$author$project$Material$Styled$Modal$contentContainerstyles($author$project$Page$CreateTemplate$Modal$styles.modalContainer)
		]),
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$CreateTemplate$Modal$styles.modalHeader)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$CreateTemplate$Modal$styles.modalHeaderTxt)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('Loading...')
						]))
				])),
			A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$CreateTemplate$Modal$styles.modalBody)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('Loading your template...')
						])),
					A2(
					$author$project$Material$Styled$ProgressBar$linear,
					_List_fromArray(
						[
							$author$project$Material$Styled$ProgressBar$containerStyle($author$project$Page$CreateTemplate$Modal$styles.progressBar)
						]),
					_List_Nil)
				]))
		]));
var $author$project$Type$CreateTemplate$OnPasswordInput = function (a) {
	return {$: 'OnPasswordInput', a: a};
};
var $author$project$Type$CreateTemplate$OnPasswordSubmit = {$: 'OnPasswordSubmit'};
var $author$project$Page$CreateTemplate$Modal$needPasswordModal = F2(
	function (password, passwordError) {
		return A2(
			$author$project$Material$Styled$Modal$modal,
			_List_fromArray(
				[
					$author$project$Material$Styled$Modal$open(true),
					$author$project$Material$Styled$Modal$contentContainerstyles($author$project$Page$CreateTemplate$Modal$styles.modalContainer)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$CreateTemplate$Modal$styles.modalHeader)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$CreateTemplate$Modal$styles.modalHeaderTxt)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Password Required')
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$CreateTemplate$Modal$styles.modalBody)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('This PDF is password-protected. Please enter a password to open the PDF.')
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$form,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Events$onSubmit(
							$author$project$Types$OnAuth(
								$author$project$Types$OnCreateTemplate($author$project$Type$CreateTemplate$OnPasswordSubmit)))
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Material$Styled$Input$password,
							_List_fromArray(
								[
									$author$project$Material$Styled$Input$containerStyles($author$project$Page$CreateTemplate$Modal$styles.inputContainer),
									$author$project$Material$Styled$Input$label('Password'),
									$author$project$Material$Styled$Input$value(
									A2($elm$core$Maybe$withDefault, '', password)),
									$author$project$Material$Styled$Input$errorMessage(passwordError),
									$author$project$Material$Styled$Input$onInput(
									A2(
										$elm$core$Basics$composeL,
										A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnCreateTemplate),
										$author$project$Type$CreateTemplate$OnPasswordInput))
								]),
							_List_Nil),
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$CreateTemplate$Modal$styles.modalBtns)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Material$Styled$Button$button,
									_List_fromArray(
										[
											$author$project$Material$Styled$Button$theme($author$project$Material$Styled$Button$blue),
											$author$project$Material$Styled$Button$styles($author$project$Page$CreateTemplate$Modal$styles.passwordButtons)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('Submit')
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$a,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$href($author$project$Data$Route$routeUrl.dashboard)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('Cancel')
										]))
								]))
						]))
				]));
	});
var $author$project$Type$CreateTemplate$OnTemplateSubmitClose = {$: 'OnTemplateSubmitClose'};
var $author$project$Type$CreateTemplate$OnTemplateSubmitUpload = F2(
	function (a, b) {
		return {$: 'OnTemplateSubmitUpload', a: a, b: b};
	});
var $author$project$Page$CreateTemplate$Modal$submitModal = F3(
	function (model, template, file) {
		var createTemplateLanguageData = model.languageSwitchModel.allLanguageData.location.createTemplatePage;
		return A2(
			$author$project$Material$Styled$Modal$modal,
			_List_fromArray(
				[
					$author$project$Material$Styled$Modal$open(true),
					$author$project$Material$Styled$Modal$onClose(
					$author$project$Types$OnAuth(
						$author$project$Types$OnCreateTemplate($author$project$Type$CreateTemplate$OnTemplateSubmitClose))),
					$author$project$Material$Styled$Modal$contentContainerstyles($author$project$Page$CreateTemplate$Modal$styles.modalContainer)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$CreateTemplate$Modal$styles.modalHeader)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$CreateTemplate$Modal$styles.modalHeaderTxt)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(createTemplateLanguageData.uploadTemplate)
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$img,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$CreateTemplate$Modal$styles.icon),
									$rtfeldman$elm_css$Html$Styled$Attributes$src($author$project$View$Theme$images.close),
									$rtfeldman$elm_css$Html$Styled$Events$onClick(
									$author$project$Types$OnAuth(
										$author$project$Types$OnCreateTemplate($author$project$Type$CreateTemplate$OnTemplateSubmitClose)))
								]),
							_List_Nil)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$CreateTemplate$Modal$styles.modalBody)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(createTemplateLanguageData.uploadTemplateText),
									A2(
									$rtfeldman$elm_css$Html$Styled$a,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$href('https://www.sign.net/legal'),
											$rtfeldman$elm_css$Html$Styled$Attributes$target('_blank')
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(createTemplateLanguageData.referToTerms)
										]))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$CreateTemplate$Modal$styles.modalBtns)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Material$Styled$Button$button,
									_List_fromArray(
										[
											$author$project$Material$Styled$Button$theme($author$project$Material$Styled$Button$blue),
											$author$project$Material$Styled$Button$styles($author$project$Page$CreateTemplate$Modal$styles.uploadBtn),
											$author$project$Material$Styled$Button$onClick(
											$author$project$Types$OnAuth(
												$author$project$Types$OnCreateTemplate(
													A2($author$project$Type$CreateTemplate$OnTemplateSubmitUpload, template, file))))
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(createTemplateLanguageData.createButtonText)
										]))
								]))
						]))
				]));
	});
var $author$project$Type$CreateTemplate$OnTemplateSuccessClose = {$: 'OnTemplateSuccessClose'};
var $author$project$Page$CreateTemplate$Modal$successModal = function (model) {
	var uploadDocumentLanguageData = model.languageSwitchModel.allLanguageData.location.uploadDocument;
	var createTemplateLanguageData = model.languageSwitchModel.allLanguageData.location.createTemplatePage;
	return A2(
		$author$project$Material$Styled$Modal$modal,
		_List_fromArray(
			[
				$author$project$Material$Styled$Modal$open(true),
				$author$project$Material$Styled$Modal$onClose(
				$author$project$Types$OnAuth(
					$author$project$Types$OnCreateTemplate($author$project$Type$CreateTemplate$OnTemplateSuccessClose))),
				$author$project$Material$Styled$Modal$contentContainerstyles($author$project$Page$CreateTemplate$Modal$styles.modalContainer)
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$CreateTemplate$Modal$styles.modalHeader)
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$CreateTemplate$Modal$styles.modalHeaderTxt)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(uploadDocumentLanguageData.success)
							]))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$CreateTemplate$Modal$styles.modalBody)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(createTemplateLanguageData.templateUploadSuccess)
							]))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$span,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$CreateTemplate$Modal$styles.modalBtns)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Material$Styled$Button$button,
						_List_fromArray(
							[
								$author$project$Material$Styled$Button$theme($author$project$Material$Styled$Button$blue),
								$author$project$Material$Styled$Button$styles($author$project$Page$CreateTemplate$Modal$styles.backToDashboardBtn),
								$author$project$Material$Styled$Button$onClick(
								$author$project$Types$OnAuth(
									$author$project$Types$OnCreateTemplate($author$project$Type$CreateTemplate$OnTemplateSuccessClose)))
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(uploadDocumentLanguageData.backToDashboard)
							]))
					]))
			]));
};
var $author$project$Page$CreateTemplate$Modal$uploadingModal = A2(
	$author$project$Material$Styled$Modal$modal,
	_List_fromArray(
		[
			$author$project$Material$Styled$Modal$open(true),
			$author$project$Material$Styled$Modal$contentContainerstyles($author$project$Page$CreateTemplate$Modal$styles.modalContainer)
		]),
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$CreateTemplate$Modal$styles.modalHeader)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$CreateTemplate$Modal$styles.modalHeaderTxt)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('Uploading...')
						]))
				])),
			A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$CreateTemplate$Modal$styles.modalBody)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('Uploading your template...')
						])),
					A2(
					$author$project$Material$Styled$ProgressBar$linear,
					_List_fromArray(
						[
							$author$project$Material$Styled$ProgressBar$containerStyle($author$project$Page$CreateTemplate$Modal$styles.progressBar)
						]),
					_List_Nil)
				]))
		]));
var $author$project$Page$CreateTemplate$Modal$view = F3(
	function (model, loadedModel, authModel) {
		var _v0 = loadedModel.status;
		switch (_v0.$) {
			case 'NeedPassword':
				return A2($author$project$Page$CreateTemplate$Modal$needPasswordModal, loadedModel.password, loadedModel.passwordError);
			case 'Ready':
				var pdf = _v0.a;
				var file = _v0.b;
				return A3($author$project$Page$CreateTemplate$Modal$submitModal, model, pdf, file);
			case 'Uploading':
				return $author$project$Page$CreateTemplate$Modal$uploadingModal;
			case 'Success':
				return $author$project$Page$CreateTemplate$Modal$successModal(model);
			case 'Loading':
				return $author$project$Page$CreateTemplate$Modal$loadingModal;
			case 'ConversionError':
				return $author$project$Page$CreateTemplate$Modal$errorModal;
			default:
				return $rtfeldman$elm_css$Html$Styled$text('');
		}
	});
var $author$project$Material$Styled$Icon$DeleteForever$view = F2(
	function (attributes, children) {
		return A2(
			$rtfeldman$elm_css$Svg$Styled$svg,
			_Utils_ap(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Svg$Styled$Attributes$fill('black'),
						$rtfeldman$elm_css$Svg$Styled$Attributes$width('48px'),
						$rtfeldman$elm_css$Svg$Styled$Attributes$height('48px'),
						$rtfeldman$elm_css$Svg$Styled$Attributes$viewBox('0 0 48 48')
					]),
				attributes),
			_Utils_ap(
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Svg$Styled$path,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Svg$Styled$Attributes$d('M19.75 33.35 24 29.1 28.25 33.35 30.35 31.25 26.1 27 30.35 22.75 28.25 20.65 24 24.9 19.75 20.65 17.65 22.75 21.9 27 17.65 31.25ZM15 39H33Q33 39 33 39Q33 39 33 39V15H15V39Q15 39 15 39Q15 39 15 39ZM10.5 11V8H17.2L19.2 6H28.8L30.8 8H37.5V11ZM15 42Q13.8 42 12.9 41.1Q12 40.2 12 39V12H36V39Q36 40.2 35.1 41.1Q34.2 42 33 42ZM15 39H33Q33 39 33 39Q33 39 33 39H15Q15 39 15 39Q15 39 15 39Z')
							]),
						_List_Nil)
					]),
				children));
	});
var $author$project$Material$Styled$Icon$deleteForever = $author$project$Material$Styled$Icon$DeleteForever$view;
var $author$project$View$Pdftron$styles = {
	container: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(62)),
			$rtfeldman$elm_css$Css$backgroundColor($author$project$Material$Styled$Color$white)
		]),
	pdfContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(99.5)),
			$rtfeldman$elm_css$Css$backgroundColor($author$project$Material$Styled$Color$white)
		]),
	text: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(50))
		]),
	view: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$pct(97.5)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(90)),
			$rtfeldman$elm_css$Css$margin(
			$rtfeldman$elm_css$Css$pct(2.5)),
			$rtfeldman$elm_css$Css$overflowY($rtfeldman$elm_css$Css$scroll),
			$rtfeldman$elm_css$Css$overflowX($rtfeldman$elm_css$Css$scroll),
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$padding(
			$rtfeldman$elm_css$Css$pct(2.5)),
			$rtfeldman$elm_css$Css$backgroundColor($author$project$Material$Styled$Color$grey200)
		]),
	webviewer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$pct(97.5)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(90)),
			$rtfeldman$elm_css$Css$margin(
			$rtfeldman$elm_css$Css$pct(2.5)),
			$rtfeldman$elm_css$Css$overflowY($rtfeldman$elm_css$Css$scroll),
			$rtfeldman$elm_css$Css$overflowX($rtfeldman$elm_css$Css$scroll),
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$padding(
			$rtfeldman$elm_css$Css$pct(2.5)),
			$rtfeldman$elm_css$Css$backgroundColor($author$project$Material$Styled$Color$grey200)
		])
};
var $author$project$View$Pdftron$view = F2(
	function (displayPDFViewer, isSigning) {
		return isSigning ? A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Pdftron$styles.pdfContainer)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$id('pdfViewer'),
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Pdftron$styles.view)
						]),
					_List_Nil)
				])) : A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Pdftron$styles.container)
				]),
			_List_fromArray(
				[
					displayPDFViewer ? A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$id('pdfViewer'),
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Pdftron$styles.webviewer)
						]),
					_List_Nil) : A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_Utils_ap($author$project$View$Pdftron$styles.view, $author$project$View$Pdftron$styles.text))
						]),
					_List_fromArray(
						[
							A2($author$project$Material$Styled$Icon$deleteForever, _List_Nil, _List_Nil),
							$rtfeldman$elm_css$Html$Styled$text('Document File Deleted')
						]))
				]));
	});
var $author$project$Type$Signature$ChangeSignatureType = function (a) {
	return {$: 'ChangeSignatureType', a: a};
};
var $author$project$Type$Signature$Drawn = {$: 'Drawn'};
var $author$project$Type$Signature$OnClose = {$: 'OnClose'};
var $author$project$View$Signature$displayText = function (signatureModel) {
	return $elm$core$List$isEmpty(signatureModel.signatures) ? $rtfeldman$elm_css$Html$Styled$text('Please add one signature for future signing purposes.') : $rtfeldman$elm_css$Html$Styled$text('');
};
var $author$project$Material$Styled$Color$blue700String = '#1976d2';
var $author$project$Material$Styled$Color$blue700 = $rtfeldman$elm_css$Css$hex($author$project$Material$Styled$Color$blue700String);
var $author$project$View$Signature$styles = {
	body: _List_fromArray(
		[
			A3(
			$rtfeldman$elm_css$Css$border3,
			$rtfeldman$elm_css$Css$px(0.1),
			$rtfeldman$elm_css$Css$solid,
			$author$project$Material$Styled$Color$grey400),
			$rtfeldman$elm_css$Css$padding(
			$rtfeldman$elm_css$Css$px(15)),
			$rtfeldman$elm_css$Css$borderRadius(
			$rtfeldman$elm_css$Css$px(5))
		]),
	button: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginLeft(
			$rtfeldman$elm_css$Css$px(10)),
			$rtfeldman$elm_css$Css$maxWidth($rtfeldman$elm_css$Css$fitContent)
		]),
	buttonContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$row),
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$flexEnd),
			$rtfeldman$elm_css$Css$paddingTop(
			$rtfeldman$elm_css$Css$px(16))
		]),
	errorMessage: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$marginBottom(
			$rtfeldman$elm_css$Css$px(20)),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$red500)
		]),
	header: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$row),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$flexStart),
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceBetween)
		]),
	headerText: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(10)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(100)),
			$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(20)),
			$rtfeldman$elm_css$Css$padding(
			$rtfeldman$elm_css$Css$px(10)),
			$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer)
		]),
	headertextUnderLine: _List_fromArray(
		[
			A3(
			$rtfeldman$elm_css$Css$borderBottom3,
			$rtfeldman$elm_css$Css$px(2),
			$rtfeldman$elm_css$Css$solid,
			$author$project$Material$Styled$Color$blue700)
		]),
	icon: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$boxShadow($rtfeldman$elm_css$Css$none),
			$rtfeldman$elm_css$Css$transform(
			A2(
				$rtfeldman$elm_css$Css$translate2,
				$rtfeldman$elm_css$Css$px(20),
				$rtfeldman$elm_css$Css$px(-15))),
			$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer),
			$rtfeldman$elm_css$Css$padding(
			$rtfeldman$elm_css$Css$px(10))
		]),
	input: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100))
		]),
	modal: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$vw(80))
		]),
	tabs: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$row)
		]),
	textSignature: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginBottom(
			$rtfeldman$elm_css$Css$px(15))
		]),
	textSignatureBox: _List_fromArray(
		[
			A2($rtfeldman$elm_css$Css$property, 'box-shadow', '0 0 0 1px rgba(63,63,68,0.05), 0 1px 3px 0 rgba(63,63,68,0.15)')
		]),
	textSignatureContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center)
		])
};
var $author$project$Type$Signature$OnClear = {$: 'OnClear'};
var $author$project$Type$Signature$OnSubmit = {$: 'OnSubmit'};
var $rtfeldman$elm_css$Html$Styled$canvas = $rtfeldman$elm_css$Html$Styled$node('canvas');
var $rtfeldman$elm_css$Html$Styled$Attributes$height = function (n) {
	return A2(
		$rtfeldman$elm_css$VirtualDom$Styled$attribute,
		'height',
		$elm$core$String$fromInt(n));
};
var $author$project$Data$Sign$View$styles = {
	signature: _List_fromArray(
		[
			A2($rtfeldman$elm_css$Css$property, 'box-shadow', '0 0 0 1px rgba(63,63,68,0.05), 0 1px 3px 0 rgba(63,63,68,0.15)')
		]),
	signatureContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$paddingBottom(
			$rtfeldman$elm_css$Css$px(10))
		])
};
var $rtfeldman$elm_css$Html$Styled$Attributes$width = function (n) {
	return A2(
		$rtfeldman$elm_css$VirtualDom$Styled$attribute,
		'width',
		$elm$core$String$fromInt(n));
};
var $author$project$Data$Sign$View$view = A2(
	$rtfeldman$elm_css$Html$Styled$div,
	_List_fromArray(
		[
			$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Data$Sign$View$styles.signatureContainer)
		]),
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Html$Styled$canvas,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Data$Sign$View$styles.signature),
					$rtfeldman$elm_css$Html$Styled$Attributes$id('signature-pad'),
					$rtfeldman$elm_css$Html$Styled$Attributes$height(200),
					$rtfeldman$elm_css$Html$Styled$Attributes$width(300)
				]),
			_List_Nil)
		]));
var $author$project$View$Signature$drawnSignature = function (model) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_Nil,
				_List_fromArray(
					[$author$project$Data$Sign$View$view])),
				A2(
				$elm$core$Maybe$withDefault,
				$rtfeldman$elm_css$Html$Styled$text(''),
				A2(
					$elm$core$Maybe$map,
					function (error) {
						return A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Signature$styles.errorMessage)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(error)
								]));
					},
					model.uploadError))
			]));
};
var $author$project$View$Signature$submitButton = function (model) {
	var _v0 = model;
	var formStatus = _v0.formStatus;
	var nameError = _v0.nameError;
	var hasError = !_Utils_eq(nameError, $elm$core$Maybe$Nothing);
	switch (formStatus.$) {
		case 'Ready':
			return hasError ? $author$project$View$SubmitButton$disabled('Save Signature') : $author$project$View$SubmitButton$enabled('Save Signature');
		case 'Error':
			return $author$project$View$SubmitButton$enabled('Save Signature');
		default:
			return $author$project$View$SubmitButton$submitting('Saving Signature ...');
	}
};
var $author$project$Type$Signature$OnTextBlur = {$: 'OnTextBlur'};
var $author$project$Type$Signature$OnTextInput = function (a) {
	return {$: 'OnTextInput', a: a};
};
var $rtfeldman$elm_css$Svg$Styled$Attributes$fontFamily = $rtfeldman$elm_css$VirtualDom$Styled$attribute('font-family');
var $rtfeldman$elm_css$Svg$Styled$Attributes$fontSize = $rtfeldman$elm_css$VirtualDom$Styled$attribute('font-size');
var $rtfeldman$elm_css$Svg$Styled$Attributes$id = $rtfeldman$elm_css$VirtualDom$Styled$attribute('id');
var $rtfeldman$elm_css$Svg$Styled$text = $rtfeldman$elm_css$VirtualDom$Styled$text;
var $rtfeldman$elm_css$Svg$Styled$text_ = $rtfeldman$elm_css$Svg$Styled$node('text');
var $rtfeldman$elm_css$Svg$Styled$Attributes$x = $rtfeldman$elm_css$VirtualDom$Styled$attribute('x');
var $rtfeldman$elm_css$Svg$Styled$Attributes$y = $rtfeldman$elm_css$VirtualDom$Styled$attribute('y');
var $author$project$View$Signature$generateTextSignature = function (signatureText) {
	var fontsize = ($elm$core$String$length(signatureText) < 10) ? '50px' : (($elm$core$String$length(signatureText) < 20) ? '40px' : '20px');
	return A2(
		$rtfeldman$elm_css$Svg$Styled$svg,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Svg$Styled$Attributes$fill('black'),
				$rtfeldman$elm_css$Svg$Styled$Attributes$width('auto'),
				$rtfeldman$elm_css$Svg$Styled$Attributes$height('150px'),
				$rtfeldman$elm_css$Svg$Styled$Attributes$id('textSignature'),
				$rtfeldman$elm_css$Svg$Styled$Attributes$css($author$project$View$Signature$styles.textSignatureBox)
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Svg$Styled$text_,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Svg$Styled$Attributes$x('50px'),
						$rtfeldman$elm_css$Svg$Styled$Attributes$y('100px'),
						$rtfeldman$elm_css$Svg$Styled$Attributes$fontSize('100px'),
						$rtfeldman$elm_css$Svg$Styled$Attributes$fontFamily('\'Great Vibes'),
						$rtfeldman$elm_css$Svg$Styled$Attributes$id('textOnSignature')
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Svg$Styled$text(signatureText)
					]))
			]));
};
var $author$project$View$Signature$typedSignature = function (model) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Signature$styles.textSignatureContainer),
						$rtfeldman$elm_css$Html$Styled$Attributes$id('textContainer')
					]),
				_List_fromArray(
					[
						$author$project$View$Signature$generateTextSignature(model.signatureText)
					])),
				A2(
				$author$project$Material$Styled$Input$text,
				_List_fromArray(
					[
						$author$project$Material$Styled$Input$label('Insert Name'),
						$author$project$Material$Styled$Input$containerStyles($author$project$View$Signature$styles.textSignature),
						$author$project$Material$Styled$Input$value(model.signatureText),
						$author$project$Material$Styled$Input$onInput(
						A2($elm$core$Basics$composeL, $author$project$Types$OnSignature, $author$project$Type$Signature$OnTextInput)),
						$author$project$Material$Styled$Input$onBlur(
						$author$project$Types$OnSignature($author$project$Type$Signature$OnTextBlur)),
						$author$project$Material$Styled$Input$errorMessage(model.textError)
					]),
				_List_Nil),
				A2(
				$elm$core$Maybe$withDefault,
				$rtfeldman$elm_css$Html$Styled$text(''),
				A2(
					$elm$core$Maybe$map,
					function (error) {
						return A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Signature$styles.errorMessage)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(error)
								]));
					},
					model.uploadError))
			]));
};
var $author$project$View$Signature$tabContent = function (model) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$form,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Events$onSubmit(
				$author$project$Types$OnSignature($author$project$Type$Signature$OnSubmit))
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Signature$styles.body)
					]),
				_List_fromArray(
					[
						function () {
						var _v0 = model.signatureType;
						if (_v0.$ === 'Drawn') {
							return $author$project$View$Signature$drawnSignature(model);
						} else {
							return $author$project$View$Signature$typedSignature(model);
						}
					}()
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Signature$styles.buttonContainer)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Material$Styled$Button$button,
						_List_fromArray(
							[
								$author$project$Material$Styled$Button$theme($author$project$Material$Styled$Button$grey),
								$author$project$Material$Styled$Button$styles($author$project$View$Signature$styles.button),
								$author$project$Material$Styled$Button$onClick(
								$author$project$Types$OnSignature($author$project$Type$Signature$OnClear)),
								$author$project$Material$Styled$Button$buttonType($author$project$Material$Styled$Button$ButtonType)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('Clear')
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Signature$styles.button)
							]),
						_List_fromArray(
							[
								$author$project$View$Signature$submitButton(model)
							]))
					]))
			]));
};
var $author$project$View$Signature$view = F2(
	function (model, isSignatureEmpty) {
		var tabStyle = function (signatureType) {
			return _Utils_eq(model.signatureType, signatureType) ? _Utils_ap($author$project$View$Signature$styles.headerText, $author$project$View$Signature$styles.headertextUnderLine) : $author$project$View$Signature$styles.headerText;
		};
		return A2(
			$author$project$Material$Styled$Modal$modal,
			_List_fromArray(
				[
					$author$project$Material$Styled$Modal$open(isSignatureEmpty),
					$author$project$Material$Styled$Modal$onClose(
					$author$project$Types$OnSignature($author$project$Type$Signature$OnClose)),
					$author$project$Material$Styled$Modal$contentContainerstyles($author$project$View$Signature$styles.modal)
				]),
			_List_fromArray(
				[
					$author$project$View$Signature$displayText(model),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Signature$styles.header)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Signature$styles.tabs)
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css(
											tabStyle($author$project$Type$Signature$Typed)),
											$rtfeldman$elm_css$Html$Styled$Events$onClick(
											$author$project$Types$OnSignature(
												$author$project$Type$Signature$ChangeSignatureType($author$project$Type$Signature$Typed)))
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('Typed')
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css(
											tabStyle($author$project$Type$Signature$Drawn)),
											$rtfeldman$elm_css$Html$Styled$Events$onClick(
											$author$project$Types$OnSignature(
												$author$project$Type$Signature$ChangeSignatureType($author$project$Type$Signature$Drawn)))
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('Drawn')
										]))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$img,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$Signature$styles.icon),
									$rtfeldman$elm_css$Html$Styled$Attributes$src($author$project$View$Theme$images.close),
									$rtfeldman$elm_css$Html$Styled$Events$onClick(
									$author$project$Types$OnSignature($author$project$Type$Signature$OnClose))
								]),
							_List_Nil)
						])),
					$author$project$View$Signature$tabContent(model)
				]));
	});
var $author$project$Page$CreateTemplate$view = F2(
	function (authModel, model) {
		var _v0 = authModel.createTemplateModel;
		if (_v0.$ === 'NotLoaded') {
			return A2(
				$author$project$View$Loading$view,
				'Can\'t Load The Document',
				$elm$core$Maybe$Just('Please contact the sender of the document for more information.'));
		} else {
			var loadedModel = _v0.a;
			return A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$CreateTemplate$styles.container)
					]),
				_List_fromArray(
					[
						$author$project$Page$CreateTemplate$errorBanner(loadedModel),
						A2($author$project$View$Pdftron$view, true, false),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$CreateTemplate$styles.sidebar)
							]),
						_List_fromArray(
							[
								A3($author$project$Page$CreateTemplate$documentTitle, model, loadedModel, authModel),
								A2($author$project$Page$CreateTemplate$roles, model, loadedModel),
								A3($author$project$Page$CreateTemplate$annotations, model, loadedModel, model.languageSwitchModel),
								A2($author$project$Page$CreateTemplate$advanceOptions, model, loadedModel),
								$author$project$Page$CreateTemplate$submitButton(model),
								$author$project$Page$CreateTemplate$Form$view(loadedModel),
								A2($author$project$View$Signature$view, authModel.signatureModel, authModel.signatureModel.open),
								A3($author$project$Page$CreateTemplate$Modal$view, model, loadedModel, authModel),
								A2($author$project$Page$CreateTemplate$overlay, loadedModel.selectedAnnot, loadedModel.annotFieldForm.status)
							]))
					]));
		}
	});
var $author$project$Type$Dashboard$Completed = {$: 'Completed'};
var $author$project$Type$Dashboard$CreditCard = {$: 'CreditCard'};
var $author$project$Type$Dashboard$Incoming = {$: 'Incoming'};
var $author$project$Type$Dashboard$MobilePhone = {$: 'MobilePhone'};
var $author$project$Type$Dashboard$MyInfo = {$: 'MyInfo'};
var $author$project$Type$Dashboard$OnRedirect = function (a) {
	return {$: 'OnRedirect', a: a};
};
var $author$project$Type$Dashboard$OnViewAllClick = function (a) {
	return {$: 'OnViewAllClick', a: a};
};
var $author$project$Type$Dashboard$Outgoing = {$: 'Outgoing'};
var $author$project$Type$Dashboard$PointsPage = {$: 'PointsPage'};
var $author$project$Type$Dashboard$TrustScorePage = {$: 'TrustScorePage'};
var $author$project$Type$Dashboard$Wallet = {$: 'Wallet'};
var $rtfeldman$elm_css$Css$backgroundPosition2 = $rtfeldman$elm_css$Css$prop2('background-position');
var $rtfeldman$elm_css$Css$backgroundSize2 = $rtfeldman$elm_css$Css$prop2('background-size');
var $rtfeldman$elm_css$Css$bold = {fontWeight: $rtfeldman$elm_css$Css$Structure$Compatible, value: 'bold'};
var $rtfeldman$elm_css$Css$cover = {lengthOrAutoOrCoverOrContain: $rtfeldman$elm_css$Css$Structure$Compatible, value: 'cover'};
var $rtfeldman$elm_css$Css$repeat = {backgroundRepeat: $rtfeldman$elm_css$Css$Structure$Compatible, backgroundRepeatShorthand: $rtfeldman$elm_css$Css$Structure$Compatible, value: 'repeat'};
var $author$project$Page$Dashboard$styles = {
	adsContainer: _List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Css$Media$withMediaQuery,
			_List_fromArray(
				['screen and (min-width: 1380px)']),
			_List_fromArray(
				[
					A4(
					$rtfeldman$elm_css$Css$padding4,
					$rtfeldman$elm_css$Css$px(0),
					$rtfeldman$elm_css$Css$px(40),
					$rtfeldman$elm_css$Css$px(0),
					$rtfeldman$elm_css$Css$px(40))
				]))
		]),
	allIcon: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$default)
		]),
	arrowButton: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$padding(
			$rtfeldman$elm_css$Css$px(0)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(50))
		]),
	arrowDown: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$relative),
			$rtfeldman$elm_css$Css$left(
			$rtfeldman$elm_css$Css$px(130)),
			A3(
			$rtfeldman$elm_css$Css$borderLeft3,
			$rtfeldman$elm_css$Css$px(10),
			$rtfeldman$elm_css$Css$solid,
			$rtfeldman$elm_css$Css$transparent),
			A3(
			$rtfeldman$elm_css$Css$borderRight3,
			$rtfeldman$elm_css$Css$px(10),
			$rtfeldman$elm_css$Css$solid,
			$rtfeldman$elm_css$Css$transparent),
			A3(
			$rtfeldman$elm_css$Css$borderTop3,
			$rtfeldman$elm_css$Css$px(10),
			$rtfeldman$elm_css$Css$solid,
			A4($rtfeldman$elm_css$Css$rgba, 41, 121, 255, 0.9)),
			A3(
			$rtfeldman$elm_css$Css$borderBottom3,
			$rtfeldman$elm_css$Css$px(10),
			$rtfeldman$elm_css$Css$solid,
			$rtfeldman$elm_css$Css$transparent),
			$rtfeldman$elm_css$Css$width($rtfeldman$elm_css$Css$zero),
			$rtfeldman$elm_css$Css$height($rtfeldman$elm_css$Css$zero)
		]),
	arrowIcon: _List_fromArray(
		[
			$rtfeldman$elm_css$Svg$Styled$Attributes$width('24'),
			$rtfeldman$elm_css$Svg$Styled$Attributes$height('24')
		]),
	arrowIconContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(24))
		]),
	avatar: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$absolute),
			$rtfeldman$elm_css$Css$top(
			$rtfeldman$elm_css$Css$px(-60)),
			$rtfeldman$elm_css$Css$left(
			$rtfeldman$elm_css$Css$px(24)),
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(120)),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(120)),
			$rtfeldman$elm_css$Css$backgroundColor($author$project$Material$Styled$Color$blue100),
			A3(
			$rtfeldman$elm_css$Css$border3,
			$rtfeldman$elm_css$Css$px(2),
			$rtfeldman$elm_css$Css$solid,
			$author$project$Material$Styled$Color$white),
			$rtfeldman$elm_css$Css$borderRadius(
			$rtfeldman$elm_css$Css$pct(50))
		]),
	avatarText: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$white),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(50))
		]),
	completedDocColumn: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$whiteSpace($rtfeldman$elm_css$Css$noWrap),
			$rtfeldman$elm_css$Css$overflow($rtfeldman$elm_css$Css$hidden),
			$rtfeldman$elm_css$Css$textOverflow($rtfeldman$elm_css$Css$ellipsis),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(30)),
			A2(
			$rtfeldman$elm_css$Css$Media$withMediaQuery,
			_List_fromArray(
				['screen and (max-width: 600px)']),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$width(
					$rtfeldman$elm_css$Css$pct(50))
				]))
		]),
	completedDocColumnSkeleton: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(14)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(30)),
			A2(
			$rtfeldman$elm_css$Css$Media$withMediaQuery,
			_List_fromArray(
				['screen and (max-width: 600px)']),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$width(
					$rtfeldman$elm_css$Css$pct(50))
				]))
		]),
	container: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
			A2($rtfeldman$elm_css$Css$margin2, $rtfeldman$elm_css$Css$zero, $rtfeldman$elm_css$Css$auto),
			A2(
			$rtfeldman$elm_css$Css$padding2,
			$rtfeldman$elm_css$Css$px(24),
			$rtfeldman$elm_css$Css$px(48)),
			$rtfeldman$elm_css$Css$maxWidth(
			$rtfeldman$elm_css$Css$px(1280))
		]),
	coverImage: F2(
		function (image, selectedBanner) {
			return _List_fromArray(
				[
					$rtfeldman$elm_css$Css$height(
					$rtfeldman$elm_css$Css$px(180)),
					$rtfeldman$elm_css$Css$width(
					$rtfeldman$elm_css$Css$pct(100)),
					$rtfeldman$elm_css$Css$backgroundImage(
					$rtfeldman$elm_css$Css$url(image)),
					$rtfeldman$elm_css$Css$backgroundRepeat($rtfeldman$elm_css$Css$repeat),
					$rtfeldman$elm_css$Css$backgroundSize($rtfeldman$elm_css$Css$cover),
					$rtfeldman$elm_css$Css$backgroundPosition($rtfeldman$elm_css$Css$start),
					$rtfeldman$elm_css$Css$backgroundColor($author$project$Material$Styled$Color$white),
					function () {
					switch (selectedBanner) {
						case 1:
							return A2(
								$rtfeldman$elm_css$Css$Media$withMediaQuery,
								_List_fromArray(
									['screen and (max-width: 600px)']),
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Css$backgroundPosition2,
										$rtfeldman$elm_css$Css$pct(43),
										$rtfeldman$elm_css$Css$pct(100)),
										A2(
										$rtfeldman$elm_css$Css$backgroundSize2,
										$rtfeldman$elm_css$Css$pct(290),
										$rtfeldman$elm_css$Css$pct(100))
									]));
						case 2:
							return A2(
								$rtfeldman$elm_css$Css$Media$withMediaQuery,
								_List_fromArray(
									['screen and (max-width: 600px)']),
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Css$backgroundPosition2,
										$rtfeldman$elm_css$Css$pct(39),
										$rtfeldman$elm_css$Css$pct(100)),
										$rtfeldman$elm_css$Css$backgroundSize($rtfeldman$elm_css$Css$cover)
									]));
						case 3:
							return A2(
								$rtfeldman$elm_css$Css$Media$withMediaQuery,
								_List_fromArray(
									['screen and (max-width: 600px)']),
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Css$backgroundPosition2,
										$rtfeldman$elm_css$Css$pct(44),
										$rtfeldman$elm_css$Css$pct(100)),
										$rtfeldman$elm_css$Css$backgroundSize($rtfeldman$elm_css$Css$cover)
									]));
						default:
							return A2(
								$rtfeldman$elm_css$Css$Media$withMediaQuery,
								_List_fromArray(
									['screen and (max-width: 600px)']),
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Css$backgroundPosition2,
										$rtfeldman$elm_css$Css$pct(44),
										$rtfeldman$elm_css$Css$pct(100)),
										$rtfeldman$elm_css$Css$backgroundSize($rtfeldman$elm_css$Css$cover)
									]));
					}
				}()
				]);
		}),
	dateColumn: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(30)),
			$rtfeldman$elm_css$Css$paddingLeft(
			$rtfeldman$elm_css$Css$px(10)),
			$rtfeldman$elm_css$Css$overflow($rtfeldman$elm_css$Css$hidden),
			$rtfeldman$elm_css$Css$textOverflow($rtfeldman$elm_css$Css$ellipsis),
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$row),
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceBetween),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			A2(
			$rtfeldman$elm_css$Css$Media$withMediaQuery,
			_List_fromArray(
				['screen and (max-width: 600px)']),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$width(
					$rtfeldman$elm_css$Css$pct(50))
				]))
		]),
	dateColumnSkeleton: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(14)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(30)),
			$rtfeldman$elm_css$Css$paddingLeft(
			$rtfeldman$elm_css$Css$px(10)),
			A2(
			$rtfeldman$elm_css$Css$Media$withMediaQuery,
			_List_fromArray(
				['screen and (max-width: 600px)']),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$width(
					$rtfeldman$elm_css$Css$pct(50))
				]))
		]),
	dividerContainer: _List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Css$margin2,
			$rtfeldman$elm_css$Css$px(0),
			$rtfeldman$elm_css$Css$px(36))
		]),
	docErrorMessage: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$margin(
			$rtfeldman$elm_css$Css$px(0)),
			$rtfeldman$elm_css$Css$paddingTop(
			$rtfeldman$elm_css$Css$px(35)),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(50))
		]),
	docHeader: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$row),
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceBetween),
			$rtfeldman$elm_css$Css$marginBottom(
			$rtfeldman$elm_css$Css$px(5))
		]),
	docHeaderText: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(16)),
			$rtfeldman$elm_css$Css$marginBottom(
			$rtfeldman$elm_css$Css$px(10)),
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(0))
		]),
	docRow: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$row),
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceBetween),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$padding(
			$rtfeldman$elm_css$Css$px(10)),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(24)),
			A3(
			$rtfeldman$elm_css$Css$borderBottom3,
			$rtfeldman$elm_css$Css$px(1),
			$rtfeldman$elm_css$Css$solid,
			$author$project$Material$Styled$Color$grey200),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(14))
		]),
	docRowWithHover: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$row),
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceBetween),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$padding(
			$rtfeldman$elm_css$Css$px(10)),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(24)),
			A3(
			$rtfeldman$elm_css$Css$borderBottom3,
			$rtfeldman$elm_css$Css$px(1),
			$rtfeldman$elm_css$Css$solid,
			$author$project$Material$Styled$Color$grey200),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(14)),
			$rtfeldman$elm_css$Css$hover(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer),
					A2($rtfeldman$elm_css$Css$property, 'box-shadow', '0px 2px 4px -1px rgba(0,0,0,0.2), 0px 4px 5px 0px rgba(0,0,0,0.14), 0px 1px 10px 0px rgba(0,0,0,0.12)'),
					$rtfeldman$elm_css$Css$backgroundColor($author$project$Material$Styled$Color$grey200)
				]))
		]),
	docTitle: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$whiteSpace($rtfeldman$elm_css$Css$noWrap),
			$rtfeldman$elm_css$Css$overflow($rtfeldman$elm_css$Css$hidden),
			$rtfeldman$elm_css$Css$textOverflow($rtfeldman$elm_css$Css$ellipsis),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(30))
		]),
	docTitleSkeleton: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(14)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(30))
		]),
	documentTemplateContainer: _List_fromArray(
		[$rtfeldman$elm_css$Css$displayFlex]),
	documents: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$row),
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceBetween),
			$rtfeldman$elm_css$Css$flexWrap($rtfeldman$elm_css$Css$wrap)
		]),
	greeting: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(24)),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$blueGrey900)
		]),
	greetingHeader: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$start),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100))
		]),
	headerContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$row),
			$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$relative),
			A2($rtfeldman$elm_css$Css$margin2, $rtfeldman$elm_css$Css$zero, $rtfeldman$elm_css$Css$auto),
			A2(
			$rtfeldman$elm_css$Css$padding2,
			$rtfeldman$elm_css$Css$px(24),
			$rtfeldman$elm_css$Css$px(48)),
			$rtfeldman$elm_css$Css$maxWidth(
			$rtfeldman$elm_css$Css$px(1280)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100)),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(45)),
			A2(
			$rtfeldman$elm_css$Css$Media$withMediaQuery,
			_List_fromArray(
				['screen and (max-width: 600px)']),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$width(
					$rtfeldman$elm_css$Css$pct(75))
				])),
			A2(
			$rtfeldman$elm_css$Css$Media$withMediaQuery,
			_List_fromArray(
				['screen and (max-width: 800px)']),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$width(
					$rtfeldman$elm_css$Css$pct(85))
				])),
			A2(
			$rtfeldman$elm_css$Css$Media$withMediaQuery,
			_List_fromArray(
				['screen and (max-width: 1024px)']),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$width(
					$rtfeldman$elm_css$Css$pct(90))
				]))
		]),
	helpIcon: _List_fromArray(
		[
			$rtfeldman$elm_css$Svg$Styled$Attributes$width('15'),
			$rtfeldman$elm_css$Svg$Styled$Attributes$height('15')
		]),
	icon: _List_fromArray(
		[
			$rtfeldman$elm_css$Svg$Styled$Attributes$width('45'),
			$rtfeldman$elm_css$Svg$Styled$Attributes$height('45'),
			$rtfeldman$elm_css$Svg$Styled$Attributes$fill($author$project$Material$Styled$Color$blueA400String)
		]),
	innerDocsContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(47)),
			$rtfeldman$elm_css$Css$marginBottom(
			$rtfeldman$elm_css$Css$px(50)),
			A2(
			$rtfeldman$elm_css$Css$Media$withMediaQuery,
			_List_fromArray(
				['screen and (max-width: 900px)']),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$width(
					$rtfeldman$elm_css$Css$pct(100))
				]))
		]),
	innersummary: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			$rtfeldman$elm_css$Css$flexWrap($rtfeldman$elm_css$Css$wrap),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$padding(
			$rtfeldman$elm_css$Css$px(15)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(33)),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$blueGrey600),
			A2(
			$rtfeldman$elm_css$Css$Media$withMediaQuery,
			_List_fromArray(
				['screen and (max-width: 700px)']),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$width(
					$rtfeldman$elm_css$Css$pct(100)),
					A3(
					$rtfeldman$elm_css$Css$borderBottom3,
					$rtfeldman$elm_css$Css$px(1),
					$rtfeldman$elm_css$Css$solid,
					$author$project$Material$Styled$Color$grey200),
					A2(
					$rtfeldman$elm_css$Css$padding2,
					$rtfeldman$elm_css$Css$px(15),
					$rtfeldman$elm_css$Css$px(0))
				]))
		]),
	messageContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$relative),
			$rtfeldman$elm_css$Css$bottom(
			$rtfeldman$elm_css$Css$px(85)),
			$rtfeldman$elm_css$Css$left(
			$rtfeldman$elm_css$Css$px(-130)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(0)),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(0))
		]),
	middleBox: _List_fromArray(
		[
			A3(
			$rtfeldman$elm_css$Css$borderLeft3,
			$rtfeldman$elm_css$Css$px(1),
			$rtfeldman$elm_css$Css$solid,
			$author$project$Material$Styled$Color$grey200),
			A2(
			$rtfeldman$elm_css$Css$Media$withMediaQuery,
			_List_fromArray(
				['screen and (min-width: 700px)']),
			_List_fromArray(
				[
					A3(
					$rtfeldman$elm_css$Css$borderRight3,
					$rtfeldman$elm_css$Css$px(1),
					$rtfeldman$elm_css$Css$solid,
					$author$project$Material$Styled$Color$grey200)
				]))
		]),
	mobileHidden: _List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Css$Media$withMediaQuery,
			_List_fromArray(
				['screen and (max-width: 600px)']),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$none)
				]))
		]),
	myInfoImage: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(30))
		]),
	myInfoImageBlurred: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(30)),
			A4(
			$rtfeldman$elm_css$Css$padding4,
			$rtfeldman$elm_css$Css$px(0),
			$rtfeldman$elm_css$Css$px(0),
			$rtfeldman$elm_css$Css$px(0),
			$rtfeldman$elm_css$Css$px(5)),
			$rtfeldman$elm_css$Css$opacity(
			$rtfeldman$elm_css$Css$num(0.4))
		]),
	nameText: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(20)),
			$rtfeldman$elm_css$Css$lineHeight(
			$rtfeldman$elm_css$Css$px(24)),
			$rtfeldman$elm_css$Css$fontWeight($rtfeldman$elm_css$Css$bold)
		]),
	noDocMessage: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$margin(
			$rtfeldman$elm_css$Css$px(0)),
			$rtfeldman$elm_css$Css$paddingTop(
			$rtfeldman$elm_css$Css$px(35)),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(50))
		]),
	numberSkeleton: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(100)),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(29)),
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(5))
		]),
	numberText: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(29)),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$blueGrey900)
		]),
	partyColumn: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(30)),
			$rtfeldman$elm_css$Css$paddingLeft(
			$rtfeldman$elm_css$Css$px(10)),
			$rtfeldman$elm_css$Css$whiteSpace($rtfeldman$elm_css$Css$noWrap),
			$rtfeldman$elm_css$Css$overflow($rtfeldman$elm_css$Css$hidden),
			$rtfeldman$elm_css$Css$textOverflow($rtfeldman$elm_css$Css$ellipsis),
			A2(
			$rtfeldman$elm_css$Css$Media$withMediaQuery,
			_List_fromArray(
				['screen and (max-width: 600px)']),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$none)
				]))
		]),
	partyColumnSkeleton: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(14)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(30)),
			$rtfeldman$elm_css$Css$paddingLeft(
			$rtfeldman$elm_css$Css$px(10)),
			A2(
			$rtfeldman$elm_css$Css$Media$withMediaQuery,
			_List_fromArray(
				['screen and (max-width: 600px)']),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$none)
				]))
		]),
	senderColumn: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(15)),
			$rtfeldman$elm_css$Css$paddingLeft(
			$rtfeldman$elm_css$Css$px(10)),
			$rtfeldman$elm_css$Css$whiteSpace($rtfeldman$elm_css$Css$noWrap),
			$rtfeldman$elm_css$Css$overflow($rtfeldman$elm_css$Css$hidden),
			$rtfeldman$elm_css$Css$textOverflow($rtfeldman$elm_css$Css$ellipsis),
			A2(
			$rtfeldman$elm_css$Css$Media$withMediaQuery,
			_List_fromArray(
				['screen and (max-width: 600px)']),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$none)
				]))
		]),
	senderColumnSkeleton: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(14)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(15)),
			$rtfeldman$elm_css$Css$paddingLeft(
			$rtfeldman$elm_css$Css$px(10)),
			A2(
			$rtfeldman$elm_css$Css$Media$withMediaQuery,
			_List_fromArray(
				['screen and (max-width: 600px)']),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$none)
				]))
		]),
	signPointsSummary: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			$rtfeldman$elm_css$Css$flexWrap($rtfeldman$elm_css$Css$wrap),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$padding(
			$rtfeldman$elm_css$Css$px(15)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(33)),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$blueGrey600),
			A2(
			$rtfeldman$elm_css$Css$Media$withMediaQuery,
			_List_fromArray(
				['screen and (max-width: 700px)']),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$width(
					$rtfeldman$elm_css$Css$pct(100)),
					A3(
					$rtfeldman$elm_css$Css$borderBottom3,
					$rtfeldman$elm_css$Css$px(1),
					$rtfeldman$elm_css$Css$solid,
					$author$project$Material$Styled$Color$grey200),
					A2(
					$rtfeldman$elm_css$Css$padding2,
					$rtfeldman$elm_css$Css$px(15),
					$rtfeldman$elm_css$Css$px(0))
				])),
			$rtfeldman$elm_css$Css$hover(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer),
					$rtfeldman$elm_css$Css$backgroundColor(
					A4($rtfeldman$elm_css$Css$rgba, 41, 121, 255, 0.16))
				]))
		]),
	smallText: _List_fromArray(
		[
			A4(
			$rtfeldman$elm_css$Css$margin4,
			$rtfeldman$elm_css$Css$px(200),
			$rtfeldman$elm_css$Css$px(30),
			$rtfeldman$elm_css$Css$px(200),
			$rtfeldman$elm_css$Css$px(30))
		]),
	summary: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$row),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$marginBottom(
			$rtfeldman$elm_css$Css$px(50)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100)),
			A2(
			$rtfeldman$elm_css$Css$Media$withMediaQuery,
			_List_fromArray(
				['screen and (max-width: 700px)']),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$flexWrap($rtfeldman$elm_css$Css$wrap)
				]))
		]),
	tableHeader: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontWeight($rtfeldman$elm_css$Css$bold)
		]),
	text: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$paddingTop(
			$rtfeldman$elm_css$Css$px(5)),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(11))
		]),
	textContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(14)),
			$rtfeldman$elm_css$Css$lineHeight(
			$rtfeldman$elm_css$Css$px(21)),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$blueGrey900),
			$rtfeldman$elm_css$Css$fontWeight(
			$rtfeldman$elm_css$Css$int(400))
		]),
	toolTip: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$backgroundColor($author$project$Material$Styled$Color$blueA400),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(170)),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(25)),
			$rtfeldman$elm_css$Css$padding(
			$rtfeldman$elm_css$Css$px(10)),
			$rtfeldman$elm_css$Css$borderRadius(
			$rtfeldman$elm_css$Css$px(10)),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$white),
			$rtfeldman$elm_css$Css$animationDuration(
			$rtfeldman$elm_css$Css$sec(0.3)),
			$rtfeldman$elm_css$Css$opacity(
			$rtfeldman$elm_css$Css$num(0.9))
		]),
	tooltipText: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(12)),
			$rtfeldman$elm_css$Css$marginLeft(
			$rtfeldman$elm_css$Css$px(5))
		]),
	trustScoreIcon: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(45)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(45))
		]),
	trustScoreIcons: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			A2(
			$rtfeldman$elm_css$Css$padding2,
			$rtfeldman$elm_css$Css$px(5),
			$rtfeldman$elm_css$Css$px(20)),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(12)),
			$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center)
		]),
	trustScoreSummary: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			$rtfeldman$elm_css$Css$flexWrap($rtfeldman$elm_css$Css$wrap),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$padding(
			$rtfeldman$elm_css$Css$px(15)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(33)),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$blueGrey600),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(95)),
			A2(
			$rtfeldman$elm_css$Css$Media$withMediaQuery,
			_List_fromArray(
				['screen and (max-width: 700px)']),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$width(
					$rtfeldman$elm_css$Css$pct(100)),
					A3(
					$rtfeldman$elm_css$Css$borderBottom3,
					$rtfeldman$elm_css$Css$px(1),
					$rtfeldman$elm_css$Css$solid,
					$author$project$Material$Styled$Color$grey200),
					A2(
					$rtfeldman$elm_css$Css$padding2,
					$rtfeldman$elm_css$Css$px(15),
					$rtfeldman$elm_css$Css$px(0))
				])),
			$rtfeldman$elm_css$Css$hover(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer),
					$rtfeldman$elm_css$Css$backgroundColor(
					A4($rtfeldman$elm_css$Css$rgba, 41, 121, 255, 0.16))
				]))
		]),
	userDetailsContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$start),
			A4(
			$rtfeldman$elm_css$Css$margin4,
			$rtfeldman$elm_css$Css$px(0),
			$rtfeldman$elm_css$Css$px(0),
			$rtfeldman$elm_css$Css$px(24),
			$rtfeldman$elm_css$Css$px(110)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100))
		]),
	viewAllButton: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(90)),
			$rtfeldman$elm_css$Css$padding(
			$rtfeldman$elm_css$Css$px(0)),
			$rtfeldman$elm_css$Css$backgroundColor($author$project$Material$Styled$Color$grey100),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$black)
		])
};
var $author$project$Page$Dashboard$avatar = function (_v0) {
	var firstName = _v0.firstName;
	var lastName = _v0.lastName;
	var avatarUrl = _v0.avatarUrl;
	var secondLetter = A2($elm$core$String$left, 1, lastName);
	var firstLetter = A2($elm$core$String$left, 1, firstName);
	if (avatarUrl.$ === 'Nothing') {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Dashboard$styles.avatar)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Dashboard$styles.avatarText)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							_Utils_ap(firstLetter, secondLetter))
						]))
				]));
	} else {
		var url = avatarUrl.a;
		return A2(
			$rtfeldman$elm_css$Html$Styled$img,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$src(url),
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Dashboard$styles.avatar)
				]),
			_List_Nil);
	}
};
var $author$project$Type$Dashboard$OnDocClick = function (a) {
	return {$: 'OnDocClick', a: a};
};
var $author$project$Material$Styled$Icon$ArrowRight$view = F2(
	function (attributes, children) {
		return A2(
			$rtfeldman$elm_css$Svg$Styled$svg,
			_Utils_ap(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Svg$Styled$Attributes$fill('black'),
						$rtfeldman$elm_css$Svg$Styled$Attributes$width('24px'),
						$rtfeldman$elm_css$Svg$Styled$Attributes$height('24px'),
						$rtfeldman$elm_css$Svg$Styled$Attributes$viewBox('0 0 24 24')
					]),
				attributes),
			_Utils_ap(
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Svg$Styled$path,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Svg$Styled$Attributes$d('M0 0h24v24H0V0z'),
								$rtfeldman$elm_css$Svg$Styled$Attributes$fill('none')
							]),
						_List_Nil),
						A2(
						$rtfeldman$elm_css$Svg$Styled$path,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Svg$Styled$Attributes$d('M16.01 11H4v2h12.01v3L20 12l-3.99-4v3z')
							]),
						_List_Nil)
					]),
				children));
	});
var $author$project$Material$Styled$Icon$arrowRight = $author$project$Material$Styled$Icon$ArrowRight$view;
var $author$project$Page$Dashboard$toMonthString = function (month) {
	switch (month.$) {
		case 'Jan':
			return 'Jan';
		case 'Feb':
			return 'Feb';
		case 'Mar':
			return 'Mar';
		case 'Apr':
			return 'Apr';
		case 'May':
			return 'May';
		case 'Jun':
			return 'Jun';
		case 'Jul':
			return 'Jul';
		case 'Aug':
			return 'Aug';
		case 'Sep':
			return 'Sep';
		case 'Oct':
			return 'Oct';
		case 'Nov':
			return 'Nov';
		default:
			return 'Dec';
	}
};
var $author$project$Page$Dashboard$getDate = function (posix) {
	return $elm$core$String$fromInt(
		A2($elm$time$Time$toDay, $elm$time$Time$utc, posix)) + (' ' + ($author$project$Page$Dashboard$toMonthString(
		A2($elm$time$Time$toMonth, $elm$time$Time$utc, posix)) + (' ' + $elm$core$String$fromInt(
		A2($elm$time$Time$toYear, $elm$time$Time$utc, posix)))));
};
var $rtfeldman$elm_css$Html$Styled$h5 = $rtfeldman$elm_css$Html$Styled$node('h5');
var $author$project$Page$Dashboard$completedDocList = F2(
	function (docs, languageModel) {
		var languageDashboardData = languageModel.allLanguageData.location.dashboard;
		return A2(
			$author$project$Material$Styled$Card$card,
			_List_fromArray(
				[
					$author$project$Material$Styled$Card$containerStyles(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$marginBottom(
							$rtfeldman$elm_css$Css$px(26))
						]))
				]),
			$elm$core$List$isEmpty(docs) ? _List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$h5,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Dashboard$styles.noDocMessage)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('No Completed Documents')
						]))
				]) : A2(
				$elm$core$List$cons,
				A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Dashboard$styles.docRow)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css(
									_Utils_ap($author$project$Page$Dashboard$styles.completedDocColumn, $author$project$Page$Dashboard$styles.tableHeader))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(languageDashboardData.document)
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css(
									_Utils_ap($author$project$Page$Dashboard$styles.senderColumn, $author$project$Page$Dashboard$styles.tableHeader))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(languageDashboardData.sender)
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css(
									_Utils_ap($author$project$Page$Dashboard$styles.partyColumn, $author$project$Page$Dashboard$styles.tableHeader))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(languageDashboardData.recipient)
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css(
									_Utils_ap($author$project$Page$Dashboard$styles.dateColumn, $author$project$Page$Dashboard$styles.tableHeader))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(languageDashboardData.date)
								]))
						])),
				A2(
					$elm$core$List$map,
					function (doc) {
						return A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Dashboard$styles.docRowWithHover),
									$rtfeldman$elm_css$Html$Styled$Events$onClick(
									$author$project$Types$OnAuth(
										$author$project$Types$OnDashboard(
											$author$project$Type$Dashboard$OnDocClick(doc.id))))
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Dashboard$styles.completedDocColumn)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(doc.title)
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Dashboard$styles.senderColumn)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(doc.ownerName)
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Dashboard$styles.partyColumn)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(doc.recipients)
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Dashboard$styles.dateColumn)
										]),
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$span,
											_List_Nil,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(
													$author$project$Page$Dashboard$getDate(doc.createdAt))
												])),
											A2(
											$rtfeldman$elm_css$Html$Styled$div,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Dashboard$styles.arrowButton)
												]),
											_List_fromArray(
												[
													A2($author$project$Material$Styled$Icon$arrowRight, _List_Nil, _List_Nil)
												]))
										]))
								]));
					},
					$elm$core$List$reverse(
						A2(
							$elm$core$List$sortBy,
							function (doc) {
								return $elm$time$Time$posixToMillis(doc.updatedAt);
							},
							docs)))));
	});
var $rtfeldman$elm_css$Css$angleConverter = F2(
	function (suffix, angleVal) {
		return {
			angle: $rtfeldman$elm_css$Css$Structure$Compatible,
			angleOrDirection: $rtfeldman$elm_css$Css$Structure$Compatible,
			value: _Utils_ap(
				$elm$core$String$fromFloat(angleVal),
				suffix)
		};
	});
var $rtfeldman$elm_css$Css$deg = $rtfeldman$elm_css$Css$angleConverter('deg');
var $rtfeldman$elm_css$Css$collectStops = $elm$core$List$map(
	function (_v0) {
		var c = _v0.a;
		var len = _v0.b;
		return A2(
			$elm$core$String$append,
			c.value,
			A2(
				$elm$core$Maybe$withDefault,
				'',
				A2(
					$elm$core$Maybe$map,
					A2(
						$elm$core$Basics$composeL,
						$elm$core$String$cons(
							_Utils_chr(' ')),
						function ($) {
							return $.value;
						}),
					len)));
	});
var $rtfeldman$elm_css$Css$linearGradient2 = F4(
	function (direction, firstStop, secondStop, otherStops) {
		return {
			backgroundImage: $rtfeldman$elm_css$Css$Structure$Compatible,
			listStyleTypeOrPositionOrImage: $rtfeldman$elm_css$Css$Structure$Compatible,
			value: A2(
				$rtfeldman$elm_css$Css$cssFunction,
				'linear-gradient',
				A2(
					$elm$core$List$cons,
					direction.value,
					$rtfeldman$elm_css$Css$collectStops(
						_Utils_ap(
							_List_fromArray(
								[firstStop, secondStop]),
							otherStops))))
		};
	});
var $rtfeldman$elm_css$Css$stop = function (c) {
	return _Utils_Tuple2(c, $elm$core$Maybe$Nothing);
};
var $author$project$View$LoadingSkeleton$animateSkeleton = _List_fromArray(
	[
		$rtfeldman$elm_css$Css$backgroundImage(
		A4(
			$rtfeldman$elm_css$Css$linearGradient2,
			$rtfeldman$elm_css$Css$deg(100),
			$rtfeldman$elm_css$Css$stop($author$project$Material$Styled$Color$white),
			$rtfeldman$elm_css$Css$stop($author$project$Material$Styled$Color$grey300),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$stop($author$project$Material$Styled$Color$white)
				]))),
		$rtfeldman$elm_css$Css$backgroundSize(
		$rtfeldman$elm_css$Css$pct(400)),
		$rtfeldman$elm_css$Css$animationName(
		$rtfeldman$elm_css$Css$Animations$keyframes(
			_List_fromArray(
				[
					_Utils_Tuple2(
					0,
					_List_fromArray(
						[
							A2($rtfeldman$elm_css$Css$Animations$property, 'background-position', '100% 50%')
						])),
					_Utils_Tuple2(
					100,
					_List_fromArray(
						[
							A2($rtfeldman$elm_css$Css$Animations$property, 'background-position', '0% 50%')
						]))
				]))),
		$rtfeldman$elm_css$Css$animationDuration(
		$rtfeldman$elm_css$Css$sec(1.2)),
		A2($rtfeldman$elm_css$Css$property, 'animation-iteration-count', 'infinite'),
		A2($rtfeldman$elm_css$Css$property, 'animation-timing-function', 'ease-in-out')
	]);
var $author$project$View$LoadingSkeleton$loadingSkeleton = function (styles) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				_Utils_ap($author$project$View$LoadingSkeleton$animateSkeleton, styles))
			]),
		_List_Nil);
};
var $author$project$Page$Dashboard$completedDocListItemSkeleton = A2(
	$rtfeldman$elm_css$Html$Styled$div,
	_List_fromArray(
		[
			$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Dashboard$styles.docRow)
		]),
	_List_fromArray(
		[
			$author$project$View$LoadingSkeleton$loadingSkeleton($author$project$Page$Dashboard$styles.completedDocColumnSkeleton),
			$author$project$View$LoadingSkeleton$loadingSkeleton($author$project$Page$Dashboard$styles.senderColumnSkeleton),
			$author$project$View$LoadingSkeleton$loadingSkeleton($author$project$Page$Dashboard$styles.partyColumnSkeleton),
			$author$project$View$LoadingSkeleton$loadingSkeleton($author$project$Page$Dashboard$styles.dateColumnSkeleton)
		]));
var $author$project$Page$Dashboard$completedDocListSkeleton = A2(
	$author$project$Material$Styled$Card$card,
	_List_Nil,
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Dashboard$styles.docRow)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_Utils_ap($author$project$Page$Dashboard$styles.completedDocColumn, $author$project$Page$Dashboard$styles.tableHeader))
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('Document')
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_Utils_ap($author$project$Page$Dashboard$styles.senderColumn, $author$project$Page$Dashboard$styles.tableHeader))
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('Sender')
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_Utils_ap($author$project$Page$Dashboard$styles.partyColumn, $author$project$Page$Dashboard$styles.tableHeader))
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('Recipients')
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_Utils_ap($author$project$Page$Dashboard$styles.dateColumn, $author$project$Page$Dashboard$styles.tableHeader))
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('Date')
						]))
				])),
			$author$project$Page$Dashboard$completedDocListItemSkeleton,
			$author$project$Page$Dashboard$completedDocListItemSkeleton,
			$author$project$Page$Dashboard$completedDocListItemSkeleton,
			$author$project$Page$Dashboard$completedDocListItemSkeleton,
			$author$project$Page$Dashboard$completedDocListItemSkeleton
		]));
var $author$project$Page$Dashboard$completedDocListOrSkeleton = F2(
	function (dashboardModel, languageModel) {
		var _v0 = dashboardModel.completedDocsStatus;
		switch (_v0.$) {
			case 'Loading':
				return $author$project$Page$Dashboard$completedDocListSkeleton;
			case 'Loaded':
				return A2($author$project$Page$Dashboard$completedDocList, dashboardModel.completedDocuments, languageModel);
			default:
				return A2(
					$author$project$Material$Styled$Card$card,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$h5,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Dashboard$styles.docErrorMessage)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Error Loading Documents')
								]))
						]));
		}
	});
var $author$project$Material$Styled$Icon$DescriptionFilled$view = F2(
	function (attributes, children) {
		return A2(
			$rtfeldman$elm_css$Svg$Styled$svg,
			_Utils_ap(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Svg$Styled$Attributes$fill('black'),
						$rtfeldman$elm_css$Svg$Styled$Attributes$width('24px'),
						$rtfeldman$elm_css$Svg$Styled$Attributes$height('24px'),
						$rtfeldman$elm_css$Svg$Styled$Attributes$viewBox('0 0 24 24')
					]),
				attributes),
			_Utils_ap(
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Svg$Styled$path,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Svg$Styled$Attributes$d('M0 0h24v24H0z'),
								$rtfeldman$elm_css$Svg$Styled$Attributes$fill('none')
							]),
						_List_Nil),
						A2(
						$rtfeldman$elm_css$Svg$Styled$path,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Svg$Styled$Attributes$d('M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm2 16H8v-2h8v2zm0-4H8v-2h8v2zm-3-5V3.5L18.5 9H13z')
							]),
						_List_Nil)
					]),
				children));
	});
var $author$project$Material$Styled$Icon$descriptionFilled = $author$project$Material$Styled$Icon$DescriptionFilled$view;
var $author$project$Type$Dashboard$Enters = {$: 'Enters'};
var $author$project$Type$Dashboard$Leaves = {$: 'Leaves'};
var $author$project$Type$Dashboard$OnHover = F2(
	function (a, b) {
		return {$: 'OnHover', a: a, b: b};
	});
var $author$project$Page$Dashboard$checkVerification = F2(
	function (isVerified, placement) {
		var placementTxt = function () {
			var _v0 = _Utils_Tuple2(placement, isVerified);
			if (_v0.b) {
				switch (_v0.a.$) {
					case 'CreditCard':
						var _v1 = _v0.a;
						return 'Verified with credit card.';
					case 'MobilePhone':
						var _v3 = _v0.a;
						return 'Verified with Mobile Phone.';
					case 'Wallet':
						var _v5 = _v0.a;
						return 'Verified with Wallet address.';
					default:
						var _v7 = _v0.a;
						return 'Verified with My Info.';
				}
			} else {
				switch (_v0.a.$) {
					case 'CreditCard':
						var _v2 = _v0.a;
						return 'Not verified with credit card.';
					case 'MobilePhone':
						var _v4 = _v0.a;
						return 'Not verified with Mobile Phone.';
					case 'Wallet':
						var _v6 = _v0.a;
						return 'Not verified with Wallet address.';
					default:
						var _v8 = _v0.a;
						return 'Not verified with My Info.';
				}
			}
		}();
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Dashboard$styles.messageContainer)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Dashboard$styles.toolTip)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(placementTxt)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Dashboard$styles.arrowDown)
						]),
					_List_Nil)
				]));
	});
var $author$project$Page$Dashboard$displayIcon = F2(
	function (verification, icon) {
		return verification ? A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					icon,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Svg$Styled$Attributes$css($author$project$Page$Dashboard$styles.allIcon)
						]),
					_List_Nil)
				])) : A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					icon,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Svg$Styled$Attributes$css($author$project$Page$Dashboard$styles.allIcon),
							$rtfeldman$elm_css$Svg$Styled$Attributes$fill('grey')
						]),
					_List_Nil)
				]));
	});
var $author$project$Page$Dashboard$displayToolTip = F2(
	function (toolTip, iconPlacement) {
		if (toolTip.$ === 'NoHover') {
			return false;
		} else {
			var placement = toolTip.a;
			return _Utils_eq(placement, iconPlacement) ? true : false;
		}
	});
var $author$project$Page$Dashboard$displayIconToolTip = F4(
	function (placement, isVerified, toolTip, icon) {
		return A5(
			$author$project$View$InfomationToolTip$view2,
			$author$project$Types$OnAuth(
				$author$project$Types$OnDashboard(
					A2($author$project$Type$Dashboard$OnHover, placement, $author$project$Type$Dashboard$Enters))),
			$author$project$Types$OnAuth(
				$author$project$Types$OnDashboard(
					A2($author$project$Type$Dashboard$OnHover, placement, $author$project$Type$Dashboard$Leaves))),
			A2($author$project$Page$Dashboard$displayToolTip, toolTip, placement),
			A2($author$project$Page$Dashboard$checkVerification, isVerified, placement),
			A2($author$project$Page$Dashboard$displayIcon, isVerified, icon));
	});
var $author$project$Page$Dashboard$displayImage = function (verification) {
	return verification ? A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$img,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$src($author$project$View$Theme$images.myInfoLogo),
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Dashboard$styles.myInfoImage)
					]),
				_List_Nil)
			])) : A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$img,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$src($author$project$View$Theme$images.myInfoLogo),
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Dashboard$styles.myInfoImageBlurred)
					]),
				_List_Nil)
			]));
};
var $author$project$Page$Dashboard$displayImageToolTip = F3(
	function (placement, isVerified, toolTip) {
		return A5(
			$author$project$View$InfomationToolTip$viewImage,
			$author$project$Types$OnAuth(
				$author$project$Types$OnDashboard(
					A2($author$project$Type$Dashboard$OnHover, placement, $author$project$Type$Dashboard$Enters))),
			$author$project$Types$OnAuth(
				$author$project$Types$OnDashboard(
					A2($author$project$Type$Dashboard$OnHover, placement, $author$project$Type$Dashboard$Leaves))),
			A2($author$project$Page$Dashboard$displayToolTip, toolTip, placement),
			A2($author$project$Page$Dashboard$checkVerification, isVerified, placement),
			$author$project$Page$Dashboard$displayImage(isVerified));
	});
var $author$project$Page$Dashboard$incomingDocList = F2(
	function (docs, languageModel) {
		var languageDashboardData = languageModel.allLanguageData.location.dashboard;
		return A2(
			$author$project$Material$Styled$Card$card,
			_List_Nil,
			$elm$core$List$isEmpty(docs) ? _List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$h5,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Dashboard$styles.noDocMessage)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('No Pending Incoming Documents')
						]))
				]) : A2(
				$elm$core$List$cons,
				A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Dashboard$styles.docRow)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css(
									_Utils_ap($author$project$Page$Dashboard$styles.docTitle, $author$project$Page$Dashboard$styles.tableHeader))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(languageDashboardData.document)
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css(
									_Utils_ap($author$project$Page$Dashboard$styles.partyColumn, $author$project$Page$Dashboard$styles.tableHeader))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(languageDashboardData.sender)
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css(
									_Utils_ap($author$project$Page$Dashboard$styles.dateColumn, $author$project$Page$Dashboard$styles.tableHeader))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(languageDashboardData.date)
								]))
						])),
				A2(
					$elm$core$List$map,
					function (doc) {
						return A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Dashboard$styles.docRowWithHover),
									$rtfeldman$elm_css$Html$Styled$Events$onClick(
									$author$project$Types$OnAuth(
										$author$project$Types$OnDashboard(
											$author$project$Type$Dashboard$OnDocClick(doc.id))))
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Dashboard$styles.docTitle)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(doc.title)
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Dashboard$styles.partyColumn)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(doc.ownerName)
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Dashboard$styles.dateColumn)
										]),
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$span,
											_List_Nil,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(
													$author$project$Page$Dashboard$getDate(doc.createdAt))
												])),
											A2(
											$rtfeldman$elm_css$Html$Styled$div,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Dashboard$styles.arrowButton)
												]),
											_List_fromArray(
												[
													A2($author$project$Material$Styled$Icon$arrowRight, _List_Nil, _List_Nil)
												]))
										]))
								]));
					},
					docs)));
	});
var $author$project$Page$Dashboard$docListItemSkeleton = A2(
	$rtfeldman$elm_css$Html$Styled$div,
	_List_fromArray(
		[
			$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Dashboard$styles.docRow)
		]),
	_List_fromArray(
		[
			$author$project$View$LoadingSkeleton$loadingSkeleton($author$project$Page$Dashboard$styles.docTitleSkeleton),
			$author$project$View$LoadingSkeleton$loadingSkeleton($author$project$Page$Dashboard$styles.partyColumnSkeleton),
			$author$project$View$LoadingSkeleton$loadingSkeleton($author$project$Page$Dashboard$styles.dateColumnSkeleton)
		]));
var $author$project$Page$Dashboard$incomingDocListSkeleton = A2(
	$author$project$Material$Styled$Card$card,
	_List_Nil,
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Dashboard$styles.docRow)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_Utils_ap($author$project$Page$Dashboard$styles.docTitle, $author$project$Page$Dashboard$styles.tableHeader))
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('Document')
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_Utils_ap($author$project$Page$Dashboard$styles.partyColumn, $author$project$Page$Dashboard$styles.tableHeader))
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('Sender')
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_Utils_ap($author$project$Page$Dashboard$styles.dateColumn, $author$project$Page$Dashboard$styles.tableHeader))
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('Date')
						]))
				])),
			$author$project$Page$Dashboard$docListItemSkeleton,
			$author$project$Page$Dashboard$docListItemSkeleton,
			$author$project$Page$Dashboard$docListItemSkeleton,
			$author$project$Page$Dashboard$docListItemSkeleton,
			$author$project$Page$Dashboard$docListItemSkeleton
		]));
var $author$project$Page$Dashboard$incomingDocListOrSkeleton = F2(
	function (dashboardModel, languageModel) {
		var _v0 = dashboardModel.incomingDocsStatus;
		switch (_v0.$) {
			case 'Loading':
				return $author$project$Page$Dashboard$incomingDocListSkeleton;
			case 'Loaded':
				return A2($author$project$Page$Dashboard$incomingDocList, dashboardModel.incomingDocuments, languageModel);
			default:
				return A2(
					$author$project$Material$Styled$Card$card,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$h5,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Dashboard$styles.docErrorMessage)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Error Loading Documents')
								]))
						]));
		}
	});
var $author$project$Page$Dashboard$incomingPendingNumOrSkeleton = function (model) {
	var _v0 = model.incomingDocsStatus;
	switch (_v0.$) {
		case 'Loading':
			return $author$project$View$LoadingSkeleton$loadingSkeleton($author$project$Page$Dashboard$styles.numberSkeleton);
		case 'Loaded':
			return A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Dashboard$styles.numberText)
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						$elm$core$String$fromInt(model.incomingPendingNum))
					]));
		default:
			return A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Dashboard$styles.numberText)
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('Error')
					]));
	}
};
var $author$project$Page$Dashboard$outgoingDocList = F2(
	function (docs, languageModel) {
		var languageDashboardData = languageModel.allLanguageData.location.dashboard;
		return A2(
			$author$project$Material$Styled$Card$card,
			_List_Nil,
			$elm$core$List$isEmpty(docs) ? _List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$h5,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Dashboard$styles.noDocMessage)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('No Pending Outgoing Documents')
						]))
				]) : A2(
				$elm$core$List$cons,
				A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Dashboard$styles.docRow)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css(
									_Utils_ap($author$project$Page$Dashboard$styles.docTitle, $author$project$Page$Dashboard$styles.tableHeader))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(languageDashboardData.document)
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css(
									_Utils_ap($author$project$Page$Dashboard$styles.partyColumn, $author$project$Page$Dashboard$styles.tableHeader))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(languageDashboardData.recipient)
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css(
									_Utils_ap($author$project$Page$Dashboard$styles.dateColumn, $author$project$Page$Dashboard$styles.tableHeader))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(languageDashboardData.date)
								]))
						])),
				A2(
					$elm$core$List$map,
					function (doc) {
						return A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Dashboard$styles.docRowWithHover),
									$rtfeldman$elm_css$Html$Styled$Events$onClick(
									$author$project$Types$OnAuth(
										$author$project$Types$OnDashboard(
											$author$project$Type$Dashboard$OnDocClick(doc.id))))
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Dashboard$styles.docTitle)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(doc.title)
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Dashboard$styles.partyColumn)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(doc.recipients)
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Dashboard$styles.dateColumn)
										]),
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$span,
											_List_Nil,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(
													$author$project$Page$Dashboard$getDate(doc.createdAt))
												])),
											A2(
											$rtfeldman$elm_css$Html$Styled$div,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Dashboard$styles.arrowButton)
												]),
											_List_fromArray(
												[
													A2($author$project$Material$Styled$Icon$arrowRight, _List_Nil, _List_Nil)
												]))
										]))
								]));
					},
					docs)));
	});
var $author$project$Page$Dashboard$outgoingDocListSkeleton = A2(
	$author$project$Material$Styled$Card$card,
	_List_Nil,
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Dashboard$styles.docRow)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_Utils_ap($author$project$Page$Dashboard$styles.docTitle, $author$project$Page$Dashboard$styles.tableHeader))
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('Document')
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_Utils_ap($author$project$Page$Dashboard$styles.partyColumn, $author$project$Page$Dashboard$styles.tableHeader))
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('Recipients')
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_Utils_ap($author$project$Page$Dashboard$styles.dateColumn, $author$project$Page$Dashboard$styles.tableHeader))
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('Date')
						]))
				])),
			$author$project$Page$Dashboard$docListItemSkeleton,
			$author$project$Page$Dashboard$docListItemSkeleton,
			$author$project$Page$Dashboard$docListItemSkeleton,
			$author$project$Page$Dashboard$docListItemSkeleton,
			$author$project$Page$Dashboard$docListItemSkeleton
		]));
var $author$project$Page$Dashboard$outgoingDocListOrSkeleton = F2(
	function (dashboardModel, languageModel) {
		var _v0 = dashboardModel.outgoingDocsStatus;
		switch (_v0.$) {
			case 'Loading':
				return $author$project$Page$Dashboard$outgoingDocListSkeleton;
			case 'Loaded':
				return A2($author$project$Page$Dashboard$outgoingDocList, dashboardModel.outgoingDocuments, languageModel);
			default:
				return A2(
					$author$project$Material$Styled$Card$card,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$h5,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Dashboard$styles.docErrorMessage)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Error Loading Documents')
								]))
						]));
		}
	});
var $author$project$Page$Dashboard$pointsOrSkeleton = function (model) {
	var _v0 = model.pointsStatus;
	switch (_v0.$) {
		case 'Loading':
			return $author$project$View$LoadingSkeleton$loadingSkeleton($author$project$Page$Dashboard$styles.numberSkeleton);
		case 'Loaded':
			return A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Dashboard$styles.numberText)
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						$elm$core$String$fromFloat(model.points / 100))
					]));
		default:
			return A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Dashboard$styles.numberText)
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('Error')
					]));
	}
};
var $author$project$Material$Styled$Icon$Printer$view = F2(
	function (attributes, children) {
		return A2(
			$rtfeldman$elm_css$Svg$Styled$svg,
			_Utils_ap(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Svg$Styled$Attributes$fill('black'),
						$rtfeldman$elm_css$Svg$Styled$Attributes$width('24px'),
						$rtfeldman$elm_css$Svg$Styled$Attributes$height('24px'),
						$rtfeldman$elm_css$Svg$Styled$Attributes$viewBox('0 0 24 24')
					]),
				attributes),
			_Utils_ap(
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Svg$Styled$path,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Svg$Styled$Attributes$d('M0 0h24v24H0V0z'),
								$rtfeldman$elm_css$Svg$Styled$Attributes$fill('none')
							]),
						_List_Nil),
						A2(
						$rtfeldman$elm_css$Svg$Styled$path,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Svg$Styled$Attributes$d('M19 8H5c-1.66 0-3 1.34-3 3v6h4v4h12v-4h4v-6c0-1.66-1.34-3-3-3zm-3 11H8v-5h8v5zm3-7c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm-1-9H6v4h12V3z')
							]),
						_List_Nil)
					]),
				children));
	});
var $author$project$Material$Styled$Icon$printer = $author$project$Material$Styled$Icon$Printer$view;
var $author$project$Material$Styled$Icon$SendFilled$view = F2(
	function (attributes, children) {
		return A2(
			$rtfeldman$elm_css$Svg$Styled$svg,
			_Utils_ap(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Svg$Styled$Attributes$fill('black'),
						$rtfeldman$elm_css$Svg$Styled$Attributes$width('24px'),
						$rtfeldman$elm_css$Svg$Styled$Attributes$height('24px'),
						$rtfeldman$elm_css$Svg$Styled$Attributes$viewBox('0 0 24 24')
					]),
				attributes),
			_Utils_ap(
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Svg$Styled$path,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Svg$Styled$Attributes$d('M0 0h24v24H0z'),
								$rtfeldman$elm_css$Svg$Styled$Attributes$fill('none')
							]),
						_List_Nil),
						A2(
						$rtfeldman$elm_css$Svg$Styled$path,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Svg$Styled$Attributes$d('M2.01 21L23 12 2.01 3 2 10l15 2-15 2z')
							]),
						_List_Nil)
					]),
				children));
	});
var $author$project$Material$Styled$Icon$sendFilled = $author$project$Material$Styled$Icon$SendFilled$view;
var $author$project$Page$Dashboard$totalNoOfPagesOrSkeleton = function (model) {
	var _v0 = model.completedDocsStatus;
	switch (_v0.$) {
		case 'Loading':
			return $author$project$View$LoadingSkeleton$loadingSkeleton($author$project$Page$Dashboard$styles.numberSkeleton);
		case 'Loaded':
			return A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Dashboard$styles.numberText)
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						$elm$core$String$fromInt(model.totalNoOfPages))
					]));
		default:
			return A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Dashboard$styles.numberText)
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('Error')
					]));
	}
};
var $author$project$Page$Dashboard$totalSentOrSkeleton = function (model) {
	var _v0 = model.outgoingDocsStatus;
	switch (_v0.$) {
		case 'Loading':
			return $author$project$View$LoadingSkeleton$loadingSkeleton($author$project$Page$Dashboard$styles.numberSkeleton);
		case 'Loaded':
			return A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Dashboard$styles.numberText)
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						$elm$core$String$fromInt(model.totalSent))
					]));
		default:
			return A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Dashboard$styles.numberText)
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('Error')
					]));
	}
};
var $author$project$Page$Dashboard$userDetails = function (_v0) {
	var firstName = _v0.firstName;
	var lastName = _v0.lastName;
	var email = _v0.email;
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Dashboard$styles.userDetailsContainer)
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Dashboard$styles.nameText)
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(firstName + (' ' + lastName))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(email)
					]))
			]));
};
var $author$project$Page$UploadTemplateAsDocument$Modal$styles = {
	activitiesContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$overflowY($rtfeldman$elm_css$Css$auto),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$vh(60)),
			$rtfeldman$elm_css$Css$maxHeight(
			$rtfeldman$elm_css$Css$px(600)),
			$rtfeldman$elm_css$Css$padding(
			$rtfeldman$elm_css$Css$px(2))
		]),
	arrow: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(0.1))
		]),
	arrowBtnContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$row),
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$flexEnd),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			A4(
			$rtfeldman$elm_css$Css$padding4,
			$rtfeldman$elm_css$Css$px(10),
			$rtfeldman$elm_css$Css$px(25),
			$rtfeldman$elm_css$Css$px(10),
			$rtfeldman$elm_css$Css$px(200))
		]),
	arrowbutton: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(50)),
			A2(
			$rtfeldman$elm_css$Css$padding2,
			$rtfeldman$elm_css$Css$px(10),
			$rtfeldman$elm_css$Css$px(10)),
			$rtfeldman$elm_css$Css$marginRight(
			$rtfeldman$elm_css$Css$px(5))
		]),
	btns: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$row),
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceBetween),
			A3(
			$rtfeldman$elm_css$Css$padding3,
			$rtfeldman$elm_css$Css$px(20),
			$rtfeldman$elm_css$Css$zero,
			$rtfeldman$elm_css$Css$zero)
		]),
	button: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginLeft(
			$rtfeldman$elm_css$Css$px(10)),
			$rtfeldman$elm_css$Css$maxWidth(
			$rtfeldman$elm_css$Css$px(250))
		]),
	cardContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			$rtfeldman$elm_css$Css$flexWrap($rtfeldman$elm_css$Css$wrap),
			$rtfeldman$elm_css$Css$marginBottom(
			$rtfeldman$elm_css$Css$px(10)),
			$rtfeldman$elm_css$Css$marginRight(
			$rtfeldman$elm_css$Css$px(10))
		]),
	content: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceBetween),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$padding(
			$rtfeldman$elm_css$Css$px(10)),
			$rtfeldman$elm_css$Css$textDecoration($rtfeldman$elm_css$Css$none),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$black),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100)),
			$rtfeldman$elm_css$Css$hover(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$backgroundColor($author$project$Material$Styled$Color$grey200)
				]))
		]),
	docStatusBtn: _List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Css$margin2,
			$rtfeldman$elm_css$Css$em(0.6),
			$rtfeldman$elm_css$Css$zero)
		]),
	headerTxt: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$paddingRight(
			$rtfeldman$elm_css$Css$px(75)),
			$rtfeldman$elm_css$Css$paddingTop(
			$rtfeldman$elm_css$Css$px(10)),
			$rtfeldman$elm_css$Css$paddingBottom(
			$rtfeldman$elm_css$Css$px(10)),
			$rtfeldman$elm_css$Css$fontWeight($rtfeldman$elm_css$Css$bold)
		]),
	heading2: _List_fromArray(
		[$rtfeldman$elm_css$Css$displayFlex]),
	icon: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$boxShadow($rtfeldman$elm_css$Css$none),
			$rtfeldman$elm_css$Css$transform(
			A2(
				$rtfeldman$elm_css$Css$translate2,
				$rtfeldman$elm_css$Css$px(20),
				$rtfeldman$elm_css$Css$px(-15))),
			$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer),
			$rtfeldman$elm_css$Css$margin(
			$rtfeldman$elm_css$Css$px(5))
		]),
	modalBody: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(12)),
			$rtfeldman$elm_css$Css$fontWeight(
			$rtfeldman$elm_css$Css$int(400)),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$blueGrey500),
			$rtfeldman$elm_css$Css$marginBottom(
			$rtfeldman$elm_css$Css$px(10))
		]),
	modalContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$vw(70)),
			$rtfeldman$elm_css$Css$maxWidth(
			$rtfeldman$elm_css$Css$px(560))
		]),
	modalHeader: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$row),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$flexStart),
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceBetween)
		]),
	modalHeaderTxt: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(20)),
			$rtfeldman$elm_css$Css$fontWeight(
			$rtfeldman$elm_css$Css$int(500))
		]),
	onHover: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$hover(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer),
					A2($rtfeldman$elm_css$Css$property, 'box-shadow', '0px 2px 4px -1px rgba(0,0,0,0.2), 0px 4px 5px 0px rgba(0,0,0,0.14), 0px 1px 10px 0px rgba(0,0,0,0.12)'),
					$rtfeldman$elm_css$Css$backgroundColor($author$project$Material$Styled$Color$grey200)
				]))
		]),
	progressBar: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(10))
		]),
	templateContent: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(20))
		]),
	templateRow: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(500)),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(75)),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(15)),
			$rtfeldman$elm_css$Css$displayFlex
		])
};
var $author$project$Page$UploadTemplateAsDocument$Modal$loadingModal = function (status) {
	var stateTxt = function () {
		if (status.$ === 'ListTemplate') {
			return 'Loading templates...';
		} else {
			return 'Creating request, please wait...';
		}
	}();
	return A2(
		$author$project$Material$Styled$Modal$modal,
		_List_fromArray(
			[
				$author$project$Material$Styled$Modal$open(true),
				$author$project$Material$Styled$Modal$contentContainerstyles($author$project$Page$UploadTemplateAsDocument$Modal$styles.modalContainer)
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadTemplateAsDocument$Modal$styles.modalHeader)
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadTemplateAsDocument$Modal$styles.modalHeaderTxt)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('Loading...')
							]))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadTemplateAsDocument$Modal$styles.modalBody)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(stateTxt)
							])),
						A2(
						$author$project$Material$Styled$ProgressBar$linear,
						_List_fromArray(
							[
								$author$project$Material$Styled$ProgressBar$containerStyle($author$project$Page$UploadTemplateAsDocument$Modal$styles.progressBar)
							]),
						_List_Nil)
					]))
			]));
};
var $author$project$Type$ListTemplateDashboard$OnCloseModal = {$: 'OnCloseModal'};
var $author$project$Type$ListTemplateDashboard$OnRequestTemplateClick = function (a) {
	return {$: 'OnRequestTemplateClick', a: a};
};
var $author$project$Page$UploadTemplateAsDocument$Modal$requestTemplateModal = function (slug) {
	return A2(
		$author$project$Material$Styled$Modal$modal,
		_List_fromArray(
			[
				$author$project$Material$Styled$Modal$open(true),
				$author$project$Material$Styled$Modal$contentContainerstyles($author$project$Page$UploadTemplateAsDocument$Modal$styles.modalContainer)
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadTemplateAsDocument$Modal$styles.modalHeader)
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadTemplateAsDocument$Modal$styles.modalHeaderTxt)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('Fill Template  Request')
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$img,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadTemplateAsDocument$Modal$styles.icon),
								$rtfeldman$elm_css$Html$Styled$Attributes$src($author$project$View$Theme$images.close),
								$rtfeldman$elm_css$Html$Styled$Events$onClick(
								$author$project$Types$OnAuth(
									$author$project$Types$OnListTemplateDashBoard($author$project$Type$ListTemplateDashboard$OnCloseModal)))
							]),
						_List_Nil)
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadTemplateAsDocument$Modal$styles.modalBody)
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('The following template is a single role template, please confirm if you are requesting to fill this template.')
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadTemplateAsDocument$Modal$styles.btns)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Material$Styled$Button$button,
						_List_fromArray(
							[
								$author$project$Material$Styled$Button$styles($author$project$Page$UploadTemplateAsDocument$Modal$styles.button),
								$author$project$Material$Styled$Button$theme($author$project$Material$Styled$Button$blue),
								$author$project$Material$Styled$Button$onClick(
								$author$project$Types$OnAuth(
									$author$project$Types$OnListTemplateDashBoard(
										$author$project$Type$ListTemplateDashboard$OnRequestTemplateClick(slug))))
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('Confirm ')
							])),
						A2(
						$author$project$Material$Styled$Button$button,
						_List_fromArray(
							[
								$author$project$Material$Styled$Button$styles($author$project$Page$UploadTemplateAsDocument$Modal$styles.button),
								$author$project$Material$Styled$Button$theme($author$project$Material$Styled$Button$default),
								$author$project$Material$Styled$Button$onClick(
								$author$project$Types$OnAuth(
									$author$project$Types$OnListTemplateDashBoard($author$project$Type$ListTemplateDashboard$OnCloseModal)))
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('Back ')
							]))
					]))
			]));
};
var $author$project$Type$ListTemplateDashboard$OnNavigateToDashboard = {$: 'OnNavigateToDashboard'};
var $author$project$Type$ListTemplateDashboard$OnNavigateToDocument = function (a) {
	return {$: 'OnNavigateToDocument', a: a};
};
var $author$project$Page$UploadTemplateAsDocument$Modal$requestTemplateSuccess = function (docId) {
	return A2(
		$author$project$Material$Styled$Modal$modal,
		_List_fromArray(
			[
				$author$project$Material$Styled$Modal$open(true),
				$author$project$Material$Styled$Modal$contentContainerstyles($author$project$Page$UploadTemplateAsDocument$Modal$styles.modalContainer)
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadTemplateAsDocument$Modal$styles.modalHeader)
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadTemplateAsDocument$Modal$styles.modalHeaderTxt)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('Success')
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$img,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadTemplateAsDocument$Modal$styles.icon),
								$rtfeldman$elm_css$Html$Styled$Attributes$src($author$project$View$Theme$images.close),
								$rtfeldman$elm_css$Html$Styled$Events$onClick(
								$author$project$Types$OnAuth(
									$author$project$Types$OnListTemplateDashBoard($author$project$Type$ListTemplateDashboard$OnCloseModal)))
							]),
						_List_Nil)
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadTemplateAsDocument$Modal$styles.modalBody)
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('You can now sign the document from your incoming folder or access it from your email.')
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadTemplateAsDocument$Modal$styles.btns)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Material$Styled$Button$button,
						_List_fromArray(
							[
								$author$project$Material$Styled$Button$styles($author$project$Page$UploadTemplateAsDocument$Modal$styles.button),
								$author$project$Material$Styled$Button$theme($author$project$Material$Styled$Button$blue),
								$author$project$Material$Styled$Button$onClick(
								$author$project$Types$OnAuth(
									$author$project$Types$OnListTemplateDashBoard(
										$author$project$Type$ListTemplateDashboard$OnNavigateToDocument(docId))))
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('Go to Document ')
							])),
						A2(
						$author$project$Material$Styled$Button$button,
						_List_fromArray(
							[
								$author$project$Material$Styled$Button$styles($author$project$Page$UploadTemplateAsDocument$Modal$styles.button),
								$author$project$Material$Styled$Button$theme($author$project$Material$Styled$Button$default),
								$author$project$Material$Styled$Button$onClick(
								$author$project$Types$OnAuth(
									$author$project$Types$OnListTemplateDashBoard($author$project$Type$ListTemplateDashboard$OnNavigateToDashboard)))
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('Back ')
							]))
					]))
			]));
};
var $author$project$Type$ListTemplateDashboard$OnNextPage = {$: 'OnNextPage'};
var $author$project$Type$ListTemplateDashboard$OnPreviousPage = {$: 'OnPreviousPage'};
var $ryannhg$date_format$DateFormat$MonthNameAbbreviated = {$: 'MonthNameAbbreviated'};
var $ryannhg$date_format$DateFormat$monthNameAbbreviated = $ryannhg$date_format$DateFormat$MonthNameAbbreviated;
var $author$project$Page$UploadTemplateAsDocument$Modal$dateFormatter = $ryannhg$date_format$DateFormat$format(
	_List_fromArray(
		[
			$ryannhg$date_format$DateFormat$dayOfMonthFixed,
			$ryannhg$date_format$DateFormat$text(' '),
			$ryannhg$date_format$DateFormat$monthNameAbbreviated,
			$ryannhg$date_format$DateFormat$text(' '),
			$ryannhg$date_format$DateFormat$yearNumber
		]));
var $author$project$Page$UploadTemplateAsDocument$Modal$templateCard = F3(
	function (appModel, authModel, templateData) {
		var redirectUrl = (appModel.baseHost === 'localhost') ? ('http://' + ($author$project$Data$Domain$toString(
			$author$project$Data$Domain$selected(authModel.user.domains)) + (':3000' + ($author$project$Data$Route$routeUrl.fillTemplate + ('/' + templateData.slug))))) : ('https://' + ($author$project$Data$Domain$toString(
			$author$project$Data$Domain$selected(authModel.user.domains)) + ($author$project$Data$Route$routeUrl.fillTemplate + ('/' + templateData.slug))));
		return A2(
			$author$project$Material$Styled$Card$card,
			_List_fromArray(
				[
					$author$project$Material$Styled$Card$containerStyles(
					_Utils_ap($author$project$Page$UploadTemplateAsDocument$Modal$styles.cardContainer, $author$project$Page$UploadTemplateAsDocument$Modal$styles.onHover))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadTemplateAsDocument$Modal$styles.templateRow)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$a,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadTemplateAsDocument$Modal$styles.content),
									$rtfeldman$elm_css$Html$Styled$Attributes$href(redirectUrl),
									$rtfeldman$elm_css$Html$Styled$Attributes$target('_blank')
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css(
											_List_fromArray(
												[
													$rtfeldman$elm_css$Css$width(
													$rtfeldman$elm_css$Css$px(155)),
													$rtfeldman$elm_css$Css$overflowWrap($rtfeldman$elm_css$Css$breakWord)
												]))
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(templateData.title + ' ')
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css(
											_List_fromArray(
												[
													$rtfeldman$elm_css$Css$width(
													$rtfeldman$elm_css$Css$px(120)),
													$rtfeldman$elm_css$Css$overflowWrap($rtfeldman$elm_css$Css$breakWord),
													$rtfeldman$elm_css$Css$marginRight(
													$rtfeldman$elm_css$Css$px(10))
												]))
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(templateData.owner.firstName + (' ' + (templateData.owner.lastName + ' ')))
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css(
											_List_fromArray(
												[
													$rtfeldman$elm_css$Css$width(
													$rtfeldman$elm_css$Css$px(110))
												]))
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											A2($author$project$Page$UploadTemplateAsDocument$Modal$dateFormatter, appModel.timezone, templateData.createdAt))
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadTemplateAsDocument$Modal$styles.arrow)
										]),
									_List_fromArray(
										[
											A2($author$project$Material$Styled$Icon$arrowRight, _List_Nil, _List_Nil)
										]))
								]))
						]))
				]));
	});
var $author$project$Page$UploadTemplateAsDocument$Modal$templateModal = F3(
	function (model, appModel, authModel) {
		var templateslist = model.templates;
		var pageLanguageData = appModel.languageSwitchModel.allLanguageData.location.listDocumentsPage;
		var accountSettingsLanguageData = appModel.languageSwitchModel.allLanguageData.location.templateDashboard;
		return A2(
			$author$project$Material$Styled$Modal$modal,
			_List_fromArray(
				[
					$author$project$Material$Styled$Modal$open(true),
					$author$project$Material$Styled$Modal$contentContainerstyles($author$project$Page$UploadTemplateAsDocument$Modal$styles.modalContainer),
					$author$project$Material$Styled$Modal$onClose(
					$author$project$Types$OnAuth(
						$author$project$Types$OnListTemplateDashBoard($author$project$Type$ListTemplateDashboard$OnCloseModal)))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadTemplateAsDocument$Modal$styles.modalHeader)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadTemplateAsDocument$Modal$styles.modalHeaderTxt)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(accountSettingsLanguageData.selectTemplate)
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$img,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadTemplateAsDocument$Modal$styles.icon),
									$rtfeldman$elm_css$Html$Styled$Attributes$src($author$project$View$Theme$images.close),
									$rtfeldman$elm_css$Html$Styled$Events$onClick(
									$author$project$Types$OnAuth(
										$author$project$Types$OnListTemplateDashBoard($author$project$Type$ListTemplateDashboard$OnCloseModal)))
								]),
							_List_Nil)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadTemplateAsDocument$Modal$styles.modalBody)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(accountSettingsLanguageData.selectTemplateDescription)
								]))
						])),
					$elm$core$List$isEmpty(templateslist) ? A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[
									$rtfeldman$elm_css$Css$marginTop(
									$rtfeldman$elm_css$Css$px(10))
								]))
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('No templates found in this domain.')
						])) : A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadTemplateAsDocument$Modal$styles.heading2)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadTemplateAsDocument$Modal$styles.headerTxt)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(' ' + (accountSettingsLanguageData.templateName + ' '))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadTemplateAsDocument$Modal$styles.headerTxt)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(accountSettingsLanguageData.createdBy)
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadTemplateAsDocument$Modal$styles.headerTxt)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(accountSettingsLanguageData.lastEdited)
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadTemplateAsDocument$Modal$styles.activitiesContainer)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_Nil,
							A2(
								$elm$core$List$map,
								A2($author$project$Page$UploadTemplateAsDocument$Modal$templateCard, appModel, authModel),
								templateslist))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadTemplateAsDocument$Modal$styles.arrowBtnContainer)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css(
									_List_fromArray(
										[
											$rtfeldman$elm_css$Css$paddingRight(
											$rtfeldman$elm_css$Css$px(5))
										]))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									pageLanguageData.page + (' ' + ($elm$core$String$fromInt(model.pageNumber + 1) + ' :')))
								])),
							(!model.pageNumber) ? A2(
							$author$project$Material$Styled$Button$button,
							_List_fromArray(
								[
									$author$project$Material$Styled$Button$theme($author$project$Material$Styled$Button$grey),
									$author$project$Material$Styled$Button$styles($author$project$Page$UploadTemplateAsDocument$Modal$styles.arrowbutton),
									$author$project$Material$Styled$Button$disabled(true),
									$author$project$Material$Styled$Button$onClick(
									$author$project$Types$OnAuth(
										$author$project$Types$OnListTemplateDashBoard($author$project$Type$ListTemplateDashboard$OnPreviousPage)))
								]),
							_List_fromArray(
								[
									A2($author$project$Material$Styled$Icon$keyboardArrowLeft, _List_Nil, _List_Nil)
								])) : A2(
							$author$project$Material$Styled$Button$button,
							_List_fromArray(
								[
									$author$project$Material$Styled$Button$theme($author$project$Material$Styled$Button$white),
									$author$project$Material$Styled$Button$styles($author$project$Page$UploadTemplateAsDocument$Modal$styles.arrowbutton),
									$author$project$Material$Styled$Button$onClick(
									$author$project$Types$OnAuth(
										$author$project$Types$OnListTemplateDashBoard($author$project$Type$ListTemplateDashboard$OnPreviousPage)))
								]),
							_List_fromArray(
								[
									A2($author$project$Material$Styled$Icon$keyboardArrowLeft, _List_Nil, _List_Nil)
								])),
							(_Utils_cmp((model.pageNumber + 1) * 10, model.templateCount) > -1) ? A2(
							$author$project$Material$Styled$Button$button,
							_List_fromArray(
								[
									$author$project$Material$Styled$Button$theme($author$project$Material$Styled$Button$grey),
									$author$project$Material$Styled$Button$styles($author$project$Page$UploadTemplateAsDocument$Modal$styles.arrowbutton),
									$author$project$Material$Styled$Button$disabled(true),
									$author$project$Material$Styled$Button$onClick(
									$author$project$Types$OnAuth(
										$author$project$Types$OnListTemplateDashBoard($author$project$Type$ListTemplateDashboard$OnNextPage)))
								]),
							_List_fromArray(
								[
									A2($author$project$Material$Styled$Icon$keyboardArrowRight, _List_Nil, _List_Nil)
								])) : A2(
							$author$project$Material$Styled$Button$button,
							_List_fromArray(
								[
									$author$project$Material$Styled$Button$theme($author$project$Material$Styled$Button$white),
									$author$project$Material$Styled$Button$styles($author$project$Page$UploadTemplateAsDocument$Modal$styles.arrowbutton),
									$author$project$Material$Styled$Button$onClick(
									$author$project$Types$OnAuth(
										$author$project$Types$OnListTemplateDashBoard($author$project$Type$ListTemplateDashboard$OnNextPage)))
								]),
							_List_fromArray(
								[
									A2($author$project$Material$Styled$Icon$keyboardArrowRight, _List_Nil, _List_Nil)
								]))
						]))
				]));
	});
var $author$project$Page$UploadTemplateAsDocument$Modal$view = F3(
	function (model, appModel, authModel) {
		var _v0 = model.modal;
		if (_v0.$ === 'Nothing') {
			return $rtfeldman$elm_css$Html$Styled$text('');
		} else {
			var modal = _v0.a;
			switch (modal.$) {
				case 'Loading':
					var status = modal.a;
					return $author$project$Page$UploadTemplateAsDocument$Modal$loadingModal(status);
				case 'Templates':
					return A3($author$project$Page$UploadTemplateAsDocument$Modal$templateModal, model, appModel, authModel);
				case 'RequestTemplate':
					var slug = modal.a;
					return $author$project$Page$UploadTemplateAsDocument$Modal$requestTemplateModal(slug);
				default:
					var docId = modal.a;
					return $author$project$Page$UploadTemplateAsDocument$Modal$requestTemplateSuccess(docId);
			}
		}
	});
var $author$project$Type$ListTemplateDashboard$OnListTemplateClick = {$: 'OnListTemplateClick'};
var $author$project$Page$UploadTemplateAsDocument$NewDocument$styles = {
	card: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$padding(
			$rtfeldman$elm_css$Css$px(24)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(500)),
			$rtfeldman$elm_css$Css$marginBottom(
			$rtfeldman$elm_css$Css$px(50))
		]),
	cardContent: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$flexWrap($rtfeldman$elm_css$Css$wrap),
			A3(
			$rtfeldman$elm_css$Css$border3,
			$rtfeldman$elm_css$Css$px(1),
			$rtfeldman$elm_css$Css$dashed,
			$author$project$Material$Styled$Color$grey200),
			$rtfeldman$elm_css$Css$padding(
			$rtfeldman$elm_css$Css$px(48)),
			$rtfeldman$elm_css$Css$hover(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$backgroundColor(
					A4($rtfeldman$elm_css$Css$rgba, 41, 121, 255, 0.16)),
					$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer)
				]))
		]),
	docHeader: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(24)),
			$rtfeldman$elm_css$Css$fontWeight(
			$rtfeldman$elm_css$Css$int(500)),
			$rtfeldman$elm_css$Css$marginBottom($rtfeldman$elm_css$Css$zero)
		]),
	docImg: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(130)),
			$rtfeldman$elm_css$Css$marginRight(
			$rtfeldman$elm_css$Css$px(20))
		]),
	docTxt: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$blueGrey600),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(14)),
			$rtfeldman$elm_css$Css$fontWeight(
			$rtfeldman$elm_css$Css$int(400)),
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(10))
		]),
	docTxtContent: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			$rtfeldman$elm_css$Css$flexWrap($rtfeldman$elm_css$Css$wrap),
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center)
		])
};
var $author$project$Page$UploadTemplateAsDocument$NewDocument$view = function (model) {
	var templateDashboardLanguageData = model.languageSwitchModel.allLanguageData.location.templateDashboard;
	return A2(
		$author$project$Material$Styled$Card$card,
		_List_fromArray(
			[
				$author$project$Material$Styled$Card$containerStyles($author$project$Page$UploadTemplateAsDocument$NewDocument$styles.card)
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadTemplateAsDocument$NewDocument$styles.cardContent),
						$rtfeldman$elm_css$Html$Styled$Events$onClick(
						$author$project$Types$OnAuth(
							$author$project$Types$OnListTemplateDashBoard($author$project$Type$ListTemplateDashboard$OnListTemplateClick)))
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$h2,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadTemplateAsDocument$NewDocument$styles.docHeader)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$elm$core$String$toUpper(templateDashboardLanguageData.sendFromTemplate))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css(
								_Utils_ap(
									$author$project$Page$UploadTemplateAsDocument$NewDocument$styles.docTxt,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Css$marginBottom(
											$rtfeldman$elm_css$Css$px(20))
										])))
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(templateDashboardLanguageData.sendFromTemplateDescription)
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Css$displayFlex,
										$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$row)
									]))
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$img,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$src($author$project$View$Theme$images.dropDoc),
										$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadTemplateAsDocument$NewDocument$styles.docImg)
									]),
								_List_Nil),
								A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadTemplateAsDocument$NewDocument$styles.docTxtContent)
									]),
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$div,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadTemplateAsDocument$NewDocument$styles.docTxt)
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(templateDashboardLanguageData.selectTemplateFromDashboard)
											]))
									]))
							]))
					]))
			]));
};
var $author$project$Page$Dashboard$view = F2(
	function (authModel, appModel) {
		var selectedBanner = appModel.selectedBanner;
		var selectedCover = function () {
			switch (selectedBanner) {
				case 1:
					return $author$project$View$Theme$images.dashboardCover.dashboardCover1;
				case 2:
					return $author$project$View$Theme$images.dashboardCover.dashboardCover2;
				case 3:
					return $author$project$View$Theme$images.dashboardCover.dashboardCover3;
				default:
					return $author$project$View$Theme$images.dashboardCover.dashboardCover3;
			}
		}();
		var languageData = appModel.languageSwitchModel.allLanguageData.location.dashboard;
		var _v0 = authModel;
		var user = _v0.user;
		var dashboardModel = _v0.dashboardModel;
		var listTemplateDashboardModel = _v0.listTemplateDashboardModel;
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css(
									A2($author$project$Page$Dashboard$styles.coverImage, selectedCover, selectedBanner))
								]),
							_List_Nil),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Dashboard$styles.headerContainer)
								]),
							_List_fromArray(
								[
									$author$project$Page$Dashboard$avatar(user),
									$author$project$Page$Dashboard$userDetails(user)
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Dashboard$styles.dividerContainer)
								]),
							_List_fromArray(
								[
									A2($author$project$Material$Styled$Divider$divider, _List_Nil, _List_Nil)
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Dashboard$styles.container)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Data$Domain$equal,
							$author$project$Data$Domain$selected(user.domains),
							appModel.appDomain) ? A2($author$project$Page$NewDocument$UploadCard$view, appModel, authModel) : A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Dashboard$styles.documentTemplateContainer)
								]),
							_List_fromArray(
								[
									A2($author$project$Page$NewDocument$UploadCard$view, appModel, authModel),
									A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Dashboard$styles.smallText)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('OR')
										])),
									$author$project$Page$UploadTemplateAsDocument$NewDocument$view(appModel),
									A3($author$project$Page$UploadTemplateAsDocument$Modal$view, listTemplateDashboardModel, appModel, authModel)
								])),
							A2(
							$author$project$Material$Styled$Card$card,
							_List_fromArray(
								[
									$author$project$Material$Styled$Card$containerStyles($author$project$Page$Dashboard$styles.summary)
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Dashboard$styles.innersummary)
										]),
									_List_fromArray(
										[
											A2($author$project$Material$Styled$Icon$descriptionFilled, $author$project$Page$Dashboard$styles.icon, _List_Nil),
											A2(
											$rtfeldman$elm_css$Html$Styled$div,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Dashboard$styles.text)
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(languageData.pendingDocuments)
												])),
											$author$project$Page$Dashboard$incomingPendingNumOrSkeleton(dashboardModel)
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css(
											_Utils_ap($author$project$Page$Dashboard$styles.innersummary, $author$project$Page$Dashboard$styles.middleBox))
										]),
									_List_fromArray(
										[
											A2($author$project$Material$Styled$Icon$sendFilled, $author$project$Page$Dashboard$styles.icon, _List_Nil),
											A2(
											$rtfeldman$elm_css$Html$Styled$div,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Dashboard$styles.text)
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(languageData.sentDocuments)
												])),
											$author$project$Page$Dashboard$totalSentOrSkeleton(dashboardModel)
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Dashboard$styles.trustScoreSummary),
											$rtfeldman$elm_css$Html$Styled$Events$onClick(
											$author$project$Types$OnAuth(
												$author$project$Types$OnDashboard(
													$author$project$Type$Dashboard$OnRedirect($author$project$Type$Dashboard$TrustScorePage))))
										]),
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$div,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Dashboard$styles.trustScoreIcons)
												]),
											_List_fromArray(
												[
													A4($author$project$Page$Dashboard$displayIconToolTip, $author$project$Type$Dashboard$CreditCard, user.trustScore.stripe, dashboardModel.toolTip, $author$project$Material$Styled$Icon$payment),
													A4($author$project$Page$Dashboard$displayIconToolTip, $author$project$Type$Dashboard$MobilePhone, user.trustScore.mobilePhone, dashboardModel.toolTip, $author$project$Material$Styled$Icon$phoneLinkLock),
													A4($author$project$Page$Dashboard$displayIconToolTip, $author$project$Type$Dashboard$Wallet, user.trustScore.wallet, dashboardModel.toolTip, $author$project$Material$Styled$Icon$accountBalanceWallet),
													A3($author$project$Page$Dashboard$displayImageToolTip, $author$project$Type$Dashboard$MyInfo, user.trustScore.myInfo, dashboardModel.toolTip)
												])),
											A2(
											$rtfeldman$elm_css$Html$Styled$div,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Dashboard$styles.text)
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(languageData.verification)
												]))
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Dashboard$styles.signPointsSummary),
											$rtfeldman$elm_css$Html$Styled$Events$onClick(
											$author$project$Types$OnAuth(
												$author$project$Types$OnDashboard(
													$author$project$Type$Dashboard$OnRedirect($author$project$Type$Dashboard$PointsPage))))
										]),
									_List_fromArray(
										[
											A2($author$project$Material$Styled$Icon$accountBalanceWallet, $author$project$Page$Dashboard$styles.icon, _List_Nil),
											A2(
											$rtfeldman$elm_css$Html$Styled$div,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Dashboard$styles.text)
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(languageData.systemRewardsPoints)
												])),
											$author$project$Page$Dashboard$pointsOrSkeleton(dashboardModel)
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Dashboard$styles.innersummary)
										]),
									_List_fromArray(
										[
											A2($author$project$Material$Styled$Icon$printer, $author$project$Page$Dashboard$styles.icon, _List_Nil),
											A2(
											$rtfeldman$elm_css$Html$Styled$div,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Dashboard$styles.text)
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text('TOTAL PAPER SAVED')
												])),
											$author$project$Page$Dashboard$totalNoOfPagesOrSkeleton(dashboardModel)
										]))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Dashboard$styles.documents)
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Dashboard$styles.innerDocsContainer),
											A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'data-test', 'Incoming Documents')
										]),
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$div,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Dashboard$styles.docHeader)
												]),
											_List_fromArray(
												[
													A2(
													$rtfeldman$elm_css$Html$Styled$h5,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Dashboard$styles.docHeaderText)
														]),
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$text(languageData.incomingDocuments)
														])),
													A2(
													$author$project$Material$Styled$Button$button,
													_List_fromArray(
														[
															$author$project$Material$Styled$Button$styles($author$project$Page$Dashboard$styles.viewAllButton),
															$author$project$Material$Styled$Button$onClick(
															$author$project$Types$OnAuth(
																$author$project$Types$OnDashboard(
																	$author$project$Type$Dashboard$OnViewAllClick($author$project$Type$Dashboard$Incoming))))
														]),
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$text(languageData.viewAll)
														]))
												])),
											A2($author$project$Page$Dashboard$incomingDocListOrSkeleton, dashboardModel, appModel.languageSwitchModel)
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Dashboard$styles.innerDocsContainer),
											A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'data-test', 'Outgoing Documents')
										]),
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$div,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Dashboard$styles.docHeader)
												]),
											_List_fromArray(
												[
													A2(
													$rtfeldman$elm_css$Html$Styled$h5,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Dashboard$styles.docHeaderText)
														]),
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$text(languageData.outgoingDocuments)
														])),
													A2(
													$author$project$Material$Styled$Button$button,
													_List_fromArray(
														[
															$author$project$Material$Styled$Button$styles($author$project$Page$Dashboard$styles.viewAllButton),
															$author$project$Material$Styled$Button$onClick(
															$author$project$Types$OnAuth(
																$author$project$Types$OnDashboard(
																	$author$project$Type$Dashboard$OnViewAllClick($author$project$Type$Dashboard$Outgoing))))
														]),
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$text(languageData.viewAll)
														]))
												])),
											A2($author$project$Page$Dashboard$outgoingDocListOrSkeleton, dashboardModel, appModel.languageSwitchModel)
										]))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Dashboard$styles.docHeader)
										]),
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$h5,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Dashboard$styles.docHeaderText)
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(languageData.completedDocuments)
												])),
											A2(
											$author$project$Material$Styled$Button$button,
											_List_fromArray(
												[
													$author$project$Material$Styled$Button$styles($author$project$Page$Dashboard$styles.viewAllButton),
													$author$project$Material$Styled$Button$onClick(
													$author$project$Types$OnAuth(
														$author$project$Types$OnDashboard(
															$author$project$Type$Dashboard$OnViewAllClick($author$project$Type$Dashboard$Completed))))
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(languageData.viewAll)
												]))
										])),
									A2($author$project$Page$Dashboard$completedDocListOrSkeleton, dashboardModel, appModel.languageSwitchModel)
								])),
							(user.showAds && ($elm$core$List$length(
							$author$project$Data$Domain$all(user.domains)) === 1)) ? A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Dashboard$styles.adsContainer)
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$id('adsContent')
										]),
									_List_Nil)
								])) : A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('')
								]))
						]))
				]));
	});
var $author$project$Type$FillTemplate$OnNavigateToDashboard = {$: 'OnNavigateToDashboard'};
var $author$project$Type$FillTemplate$OnNavigateToHomepage = {$: 'OnNavigateToHomepage'};
var $author$project$Type$FillTemplate$OnRefreshClick = {$: 'OnRefreshClick'};
var $author$project$Type$FillTemplate$GoToStage = function (a) {
	return {$: 'GoToStage', a: a};
};
var $author$project$Type$FillTemplate$OnAddRecipientBlur = F2(
	function (a, b) {
		return {$: 'OnAddRecipientBlur', a: a, b: b};
	});
var $author$project$Type$FillTemplate$OnAddRecipientInput = F3(
	function (a, b, c) {
		return {$: 'OnAddRecipientInput', a: a, b: b, c: c};
	});
var $author$project$Type$FillTemplate$OnAddRecipientSubmit = function (a) {
	return {$: 'OnAddRecipientSubmit', a: a};
};
var $author$project$Type$FillTemplate$OnClearAddRecipientFields = function (a) {
	return {$: 'OnClearAddRecipientFields', a: a};
};
var $author$project$Type$FillTemplate$OnRecipientBoxClick = function (a) {
	return {$: 'OnRecipientBoxClick', a: a};
};
var $author$project$Page$FillTemplate$addRecipientBtn = F2(
	function (model, signers) {
		var fillTemplatePageLanguageData = model.languageSwitchModel.allLanguageData.location.uploadDocument;
		var _v0 = signers;
		var emailError = _v0.emailError;
		var firstNameError = _v0.firstNameError;
		var lastNameError = _v0.lastNameError;
		var firstName = _v0.firstName;
		var lastName = _v0.lastName;
		var email = _v0.email;
		var hasError = A2(
			$elm$core$List$any,
			$elm$core$Basics$neq($elm$core$Maybe$Nothing),
			_List_fromArray(
				[emailError, firstNameError, lastNameError])) || ($elm$core$String$isEmpty(firstName) || ($elm$core$String$isEmpty(lastName) || $elm$core$String$isEmpty(email)));
		return hasError ? $author$project$View$SubmitButton$disabled(fillTemplatePageLanguageData.add) : $author$project$View$SubmitButton$enabled(fillTemplatePageLanguageData.add);
	});
var $author$project$Type$FillTemplate$OnAutocompleteClick = F2(
	function (a, b) {
		return {$: 'OnAutocompleteClick', a: a, b: b};
	});
var $author$project$Material$Styled$Color$redA200 = $rtfeldman$elm_css$Css$hex($author$project$Material$Styled$Color$redA200String);
var $author$project$Page$FillTemplate$styles = {
	addFieldIcon: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$paddingRight(
			$rtfeldman$elm_css$Css$px(7))
		]),
	addRcptBtn: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginRight(
			$rtfeldman$elm_css$Css$px(10)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(130))
		]),
	addRcptBtnContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(14)),
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$flexEnd)
		]),
	addRcptContainer: _List_fromArray(
		[
			A3($rtfeldman$elm_css$Css$margin3, $rtfeldman$elm_css$Css$zero, $rtfeldman$elm_css$Css$zero, $rtfeldman$elm_css$Css$zero)
		]),
	addRcptHeader: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceBetween),
			$rtfeldman$elm_css$Css$marginBottom(
			$rtfeldman$elm_css$Css$px(18)),
			$rtfeldman$elm_css$Css$fontWeight(
			$rtfeldman$elm_css$Css$int(500)),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(12.8))
		]),
	allIcon: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$default),
			A4(
			$rtfeldman$elm_css$Css$padding4,
			$rtfeldman$elm_css$Css$px(0),
			$rtfeldman$elm_css$Css$px(0),
			$rtfeldman$elm_css$Css$px(0),
			$rtfeldman$elm_css$Css$px(5))
		]),
	annotCardTitle: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$block),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(14)),
			$rtfeldman$elm_css$Css$marginBottom(
			$rtfeldman$elm_css$Css$px(14)),
			$rtfeldman$elm_css$Css$fontWeight(
			$rtfeldman$elm_css$Css$int(500)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100)),
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(5))
		]),
	annotCardTitleClosed: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$block),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(14)),
			$rtfeldman$elm_css$Css$fontWeight(
			$rtfeldman$elm_css$Css$int(500)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100)),
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(5))
		]),
	annotContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			A3(
			$rtfeldman$elm_css$Css$border3,
			$rtfeldman$elm_css$Css$px(1),
			$rtfeldman$elm_css$Css$solid,
			$author$project$Material$Styled$Color$grey300),
			$rtfeldman$elm_css$Css$padding(
			$rtfeldman$elm_css$Css$px(10)),
			$rtfeldman$elm_css$Css$borderRadius(
			$rtfeldman$elm_css$Css$px(10)),
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(20))
		]),
	avatar: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(30)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(30)),
			$rtfeldman$elm_css$Css$borderRadius(
			$rtfeldman$elm_css$Css$pct(50)),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$marginRight(
			$rtfeldman$elm_css$Css$px(2)),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$white),
			$rtfeldman$elm_css$Css$textTransform($rtfeldman$elm_css$Css$uppercase),
			$rtfeldman$elm_css$Css$textDecoration($rtfeldman$elm_css$Css$none),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(14))
		]),
	avatarContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$row),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$top(
			$rtfeldman$elm_css$Css$px(-20)),
			$rtfeldman$elm_css$Css$marginBottom(
			$rtfeldman$elm_css$Css$px(-20)),
			$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$relative)
		]),
	avatarOpenContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$marginBottom(
			$rtfeldman$elm_css$Css$px(18)),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(12.8))
		]),
	clearAnnotButton: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(20)),
			$rtfeldman$elm_css$Css$marginBottom(
			$rtfeldman$elm_css$Css$px(10))
		]),
	clearText: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(9.6)),
			$rtfeldman$elm_css$Css$textDecoration($rtfeldman$elm_css$Css$underline),
			$rtfeldman$elm_css$Css$hover(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer)
				]))
		]),
	closedRecipientContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$row),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$top(
			$rtfeldman$elm_css$Css$px(-20)),
			$rtfeldman$elm_css$Css$marginBottom(
			$rtfeldman$elm_css$Css$px(-20)),
			$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$relative)
		]),
	container: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$row),
			$rtfeldman$elm_css$Css$height(
			A3(
				$rtfeldman$elm_css$Css$calc,
				$rtfeldman$elm_css$Css$vh(100),
				$rtfeldman$elm_css$Css$minus,
				$rtfeldman$elm_css$Css$px(66)))
		]),
	create: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(33)),
			$rtfeldman$elm_css$Css$marginLeft(
			$rtfeldman$elm_css$Css$px(15)),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(50)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(50)),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(50)),
			A3(
			$rtfeldman$elm_css$Css$border3,
			$rtfeldman$elm_css$Css$px(1),
			$rtfeldman$elm_css$Css$solid,
			$author$project$Material$Styled$Color$blueA700),
			$rtfeldman$elm_css$Css$borderRadius(
			$rtfeldman$elm_css$Css$px(10)),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$blueA700),
			$rtfeldman$elm_css$Css$hover(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer)
				]))
		]),
	detailsTitle: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginBottom(
			$rtfeldman$elm_css$Css$px(0)),
			$rtfeldman$elm_css$Css$fontWeight(
			$rtfeldman$elm_css$Css$int(500)),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$em(1.2))
		]),
	docDetailsSubTitle: _List_fromArray(
		[
			A3(
			$rtfeldman$elm_css$Css$margin3,
			$rtfeldman$elm_css$Css$em(1.2),
			$rtfeldman$elm_css$Css$zero,
			$rtfeldman$elm_css$Css$em(0.2)),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$em(1.2)),
			$rtfeldman$elm_css$Css$fontWeight(
			$rtfeldman$elm_css$Css$int(500))
		]),
	docDetailsText: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$overflowWrap($rtfeldman$elm_css$Css$breakWord)
		]),
	docStatusBtn: _List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Css$margin2,
			$rtfeldman$elm_css$Css$em(0.6),
			$rtfeldman$elm_css$Css$zero)
		]),
	docStatusContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$em(1.2))
		]),
	dueDateClear: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(9.6)),
			$rtfeldman$elm_css$Css$hover(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer)
				]))
		]),
	dueDateControls: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceBetween)
		]),
	dueDateInfo: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(9.6)),
			$rtfeldman$elm_css$Css$marginBottom(
			$rtfeldman$elm_css$Css$px(15))
		]),
	emptyRecipientItemTitle: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			$rtfeldman$elm_css$Css$padding(
			$rtfeldman$elm_css$Css$px(5)),
			$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$relative),
			$rtfeldman$elm_css$Css$top(
			$rtfeldman$elm_css$Css$px(-24)),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(9.6))
		]),
	errorTxt: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(12)),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$redA200),
			$rtfeldman$elm_css$Css$displayFlex
		]),
	fieldTxt: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontWeight(
			$rtfeldman$elm_css$Css$int(500)),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(14))
		]),
	formRequired: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontWeight(
			$rtfeldman$elm_css$Css$int(400)),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(14))
		]),
	iconContainer: _List_fromArray(
		[$rtfeldman$elm_css$Css$displayFlex]),
	input: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginBottom(
			$rtfeldman$elm_css$Css$px(20)),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(12.8))
		]),
	inputContainer: _List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Css$margin2,
			$rtfeldman$elm_css$Css$em(1),
			$rtfeldman$elm_css$Css$zero)
		]),
	linkText: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$white),
			$rtfeldman$elm_css$Css$textDecoration($rtfeldman$elm_css$Css$underline),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(9.6))
		]),
	marginBottom20: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginBottom(
			$rtfeldman$elm_css$Css$px(20))
		]),
	myInfoImage: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(30)),
			A4(
			$rtfeldman$elm_css$Css$padding4,
			$rtfeldman$elm_css$Css$px(0),
			$rtfeldman$elm_css$Css$px(0),
			$rtfeldman$elm_css$Css$px(0),
			$rtfeldman$elm_css$Css$px(5))
		]),
	myInfoImageBlurred: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(30)),
			A4(
			$rtfeldman$elm_css$Css$padding4,
			$rtfeldman$elm_css$Css$px(0),
			$rtfeldman$elm_css$Css$px(0),
			$rtfeldman$elm_css$Css$px(0),
			$rtfeldman$elm_css$Css$px(5)),
			$rtfeldman$elm_css$Css$opacity(
			$rtfeldman$elm_css$Css$num(0.4))
		]),
	onHover: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$hover(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer),
					A2($rtfeldman$elm_css$Css$property, 'box-shadow', '0px 2px 4px -1px rgba(0,0,0,0.2), 0px 4px 5px 0px rgba(0,0,0,0.14), 0px 1px 10px 0px rgba(0,0,0,0.12)'),
					$rtfeldman$elm_css$Css$backgroundColor($author$project$Material$Styled$Color$grey200)
				]))
		]),
	optionBtn: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100))
		]),
	ownerNtSignCheckBx: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginLeft(
			$rtfeldman$elm_css$Css$px(-10)),
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(-2)),
			$rtfeldman$elm_css$Css$marginBottom(
			$rtfeldman$elm_css$Css$px(-2)),
			$rtfeldman$elm_css$Css$fontWeight(
			$rtfeldman$elm_css$Css$int(400)),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(14))
		]),
	recipientContent: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			A3(
			$rtfeldman$elm_css$Css$margin3,
			$rtfeldman$elm_css$Css$px(48),
			$rtfeldman$elm_css$Css$zero,
			$rtfeldman$elm_css$Css$zero),
			$rtfeldman$elm_css$Css$lastChild(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$marginBottom(
					$rtfeldman$elm_css$Css$px(20))
				]))
		]),
	recipientHeader: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceBetween),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100))
		]),
	recipientItemTitle: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			$rtfeldman$elm_css$Css$padding(
			$rtfeldman$elm_css$Css$px(5)),
			$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$relative),
			$rtfeldman$elm_css$Css$top(
			$rtfeldman$elm_css$Css$px(-24)),
			$rtfeldman$elm_css$Css$backgroundColor($author$project$Material$Styled$Color$white),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(9.6))
		]),
	recipientRmvIcon: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$hover(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$backgroundColor($author$project$Material$Styled$Color$grey100),
					$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer),
					$rtfeldman$elm_css$Css$outline($rtfeldman$elm_css$Css$none)
				])),
			$rtfeldman$elm_css$Css$focus(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$outline($rtfeldman$elm_css$Css$none),
					$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer)
				]))
		]),
	resultText: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(14))
		]),
	retryContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer),
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(10))
		]),
	searchField: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$absolute),
			$rtfeldman$elm_css$Css$top(
			$rtfeldman$elm_css$Css$px(52)),
			$rtfeldman$elm_css$Css$backgroundColor($author$project$Material$Styled$Color$white),
			A2(
			$rtfeldman$elm_css$Css$border2,
			$rtfeldman$elm_css$Css$px(0.5),
			$rtfeldman$elm_css$Css$solid),
			$rtfeldman$elm_css$Css$zIndex(
			$rtfeldman$elm_css$Css$int($author$project$View$Theme$zIndex.uploadDocSearchField)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(99)),
			$rtfeldman$elm_css$Css$maxHeight(
			$rtfeldman$elm_css$Css$px(360)),
			$rtfeldman$elm_css$Css$overflowY($rtfeldman$elm_css$Css$auto)
		]),
	searchResult: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			$rtfeldman$elm_css$Css$marginLeft(
			$rtfeldman$elm_css$Css$px(20))
		]),
	searchResultContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$row),
			A2(
			$rtfeldman$elm_css$Css$padding2,
			$rtfeldman$elm_css$Css$px(18),
			$rtfeldman$elm_css$Css$px(14)),
			$rtfeldman$elm_css$Css$hover(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer),
					$rtfeldman$elm_css$Css$opacity(
					$rtfeldman$elm_css$Css$num(0.5)),
					$rtfeldman$elm_css$Css$backgroundColor($author$project$Material$Styled$Color$grey50),
					A2(
					$rtfeldman$elm_css$Css$border2,
					$rtfeldman$elm_css$Css$px(0.5),
					$rtfeldman$elm_css$Css$solid)
				])),
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceBetween)
		]),
	sectionContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			A3(
			$rtfeldman$elm_css$Css$border3,
			$rtfeldman$elm_css$Css$px(1),
			$rtfeldman$elm_css$Css$solid,
			$author$project$Material$Styled$Color$grey300),
			$rtfeldman$elm_css$Css$padding(
			$rtfeldman$elm_css$Css$px(10)),
			$rtfeldman$elm_css$Css$borderRadius(
			$rtfeldman$elm_css$Css$px(10)),
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(20))
		]),
	sectionContainerClosed: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$row),
			A3(
			$rtfeldman$elm_css$Css$border3,
			$rtfeldman$elm_css$Css$px(1),
			$rtfeldman$elm_css$Css$solid,
			$author$project$Material$Styled$Color$grey300),
			$rtfeldman$elm_css$Css$padding(
			$rtfeldman$elm_css$Css$px(10)),
			$rtfeldman$elm_css$Css$borderRadius(
			$rtfeldman$elm_css$Css$px(10)),
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(20)),
			$rtfeldman$elm_css$Css$hover(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$backgroundColor($author$project$Material$Styled$Color$grey100),
					$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer)
				]))
		]),
	sendIcon: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center)
		]),
	sidebar: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$padding(
			$rtfeldman$elm_css$Css$px(10)),
			$rtfeldman$elm_css$Css$backgroundColor($author$project$Material$Styled$Color$white),
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(38)),
			$rtfeldman$elm_css$Css$overflowY($rtfeldman$elm_css$Css$auto)
		]),
	signOrderField: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100)),
			$rtfeldman$elm_css$Css$maxWidth(
			$rtfeldman$elm_css$Css$px(100)),
			$rtfeldman$elm_css$Css$marginLeft(
			$rtfeldman$elm_css$Css$px(15)),
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(10))
		]),
	signOrderInfoContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceBetween),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100))
		]),
	signature: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$minWidth(
			$rtfeldman$elm_css$Css$px(100)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(43)),
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(15)),
			$rtfeldman$elm_css$Css$marginRight(
			$rtfeldman$elm_css$Css$px(15))
		]),
	signatureBtn: _List_fromArray(
		[
			A3(
			$rtfeldman$elm_css$Css$margin3,
			$rtfeldman$elm_css$Css$em(1),
			$rtfeldman$elm_css$Css$zero,
			$rtfeldman$elm_css$Css$em(0.6))
		]),
	signatureImg: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(50)),
			$rtfeldman$elm_css$Css$minWidth(
			$rtfeldman$elm_css$Css$px(100)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(43)),
			A2($rtfeldman$elm_css$Css$property, 'object-fit', 'contain'),
			A2($rtfeldman$elm_css$Css$property, 'box-shadow', '0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24)'),
			$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer),
			$rtfeldman$elm_css$Css$hover(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$backgroundColor(
					$rtfeldman$elm_css$Css$hex('f6f7f7'))
				]))
		]),
	signatureImgBox: _List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Css$margin2,
			$rtfeldman$elm_css$Css$px(10),
			$rtfeldman$elm_css$Css$zero),
			$rtfeldman$elm_css$Css$fontWeight(
			$rtfeldman$elm_css$Css$int(500)),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$em(1.2))
		]),
	signatureListBox: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$row),
			$rtfeldman$elm_css$Css$flexWrap($rtfeldman$elm_css$Css$wrap)
		]),
	signatureName: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$textOverflow($rtfeldman$elm_css$Css$ellipsis),
			$rtfeldman$elm_css$Css$overflow($rtfeldman$elm_css$Css$hidden),
			$rtfeldman$elm_css$Css$whiteSpace($rtfeldman$elm_css$Css$noWrap),
			$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(60))
		]),
	signerNameContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$row),
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceBetween),
			$rtfeldman$elm_css$Css$flexWrap($rtfeldman$elm_css$Css$wrap)
		]),
	signingOrderAvatarContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$row),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$relative)
		]),
	signingOrderCheckBox: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginLeft(
			$rtfeldman$elm_css$Css$px(-10)),
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(-10)),
			$rtfeldman$elm_css$Css$marginBottom(
			$rtfeldman$elm_css$Css$px(10)),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(12.8))
		]),
	signingOrderText: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(12.8))
		]),
	stampHeaderStyles: _List_fromArray(
		[$rtfeldman$elm_css$Css$displayFlex]),
	titleContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$row),
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceBetween)
		]),
	toolTipText: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(9.6))
		]),
	viewerText: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginLeft(
			$rtfeldman$elm_css$Css$px(5)),
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(0)),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(12.8)),
			$rtfeldman$elm_css$Css$flexGrow(
			$rtfeldman$elm_css$Css$num(1))
		])
};
var $author$project$Page$FillTemplate$displayIcon = F2(
	function (verification, icon) {
		return verification ? A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					icon,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Svg$Styled$Attributes$css($author$project$Page$FillTemplate$styles.allIcon)
						]),
					_List_Nil)
				])) : A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					icon,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Svg$Styled$Attributes$css($author$project$Page$FillTemplate$styles.allIcon),
							$rtfeldman$elm_css$Svg$Styled$Attributes$fill('grey')
						]),
					_List_Nil)
				]));
	});
var $author$project$Page$FillTemplate$displayImage = function (verification) {
	return verification ? A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$img,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$src($author$project$View$Theme$images.myInfoLogo),
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$FillTemplate$styles.myInfoImage)
					]),
				_List_Nil)
			])) : A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$img,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$src($author$project$View$Theme$images.myInfoLogo),
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$FillTemplate$styles.myInfoImageBlurred)
					]),
				_List_Nil)
			]));
};
var $author$project$Page$FillTemplate$displayAddressBookSearchResult = F2(
	function (searchResult, roleId) {
		if (searchResult.$ === 'Just') {
			var results = searchResult.a;
			return A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$FillTemplate$styles.searchField)
					]),
				A2(
					$elm$core$List$map,
					function (result) {
						return A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$FillTemplate$styles.searchResultContainer),
									$rtfeldman$elm_css$Html$Styled$Events$onClick(
									$author$project$Types$OnFillTemplate(
										$author$project$Type$FillTemplate$OnAuth(
											$author$project$Type$FillTemplate$OnLoaded(
												A2($author$project$Type$FillTemplate$OnAutocompleteClick, result, roleId)))))
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$FillTemplate$styles.searchResult)
										]),
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$span,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$FillTemplate$styles.resultText)
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(
													A2($elm$core$Maybe$withDefault, result.firstName + (' ' + result.lastName), result.alias))
												])),
											A2(
											$rtfeldman$elm_css$Html$Styled$span,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$FillTemplate$styles.resultText)
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(
													A2($elm$core$Maybe$withDefault, '', result.label))
												])),
											A2(
											$rtfeldman$elm_css$Html$Styled$span,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$FillTemplate$styles.resultText)
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(result.email)
												]))
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$FillTemplate$styles.iconContainer)
										]),
									_List_fromArray(
										[
											A2($author$project$Page$FillTemplate$displayIcon, result.verifyStripe, $author$project$Material$Styled$Icon$payment),
											A2($author$project$Page$FillTemplate$displayIcon, result.verifyPassbase, $author$project$Material$Styled$Icon$verifiedUser),
											A2($author$project$Page$FillTemplate$displayIcon, result.verifyMobilePhone, $author$project$Material$Styled$Icon$phoneLinkLock),
											A2($author$project$Page$FillTemplate$displayIcon, result.verifyWallet, $author$project$Material$Styled$Icon$accountBalanceWallet),
											$author$project$Page$FillTemplate$displayImage(result.verifyMyInfo)
										]))
								]));
					},
					results));
		} else {
			return $rtfeldman$elm_css$Html$Styled$text('');
		}
	});
var $author$project$Page$FillTemplate$recipientCard = F2(
	function (model, signers) {
		var fillTemplatePageLanguageData = model.languageSwitchModel.allLanguageData.location.uploadDocument;
		return signers.displayAll ? A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$FillTemplate$styles.sectionContainer)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$FillTemplate$styles.avatarOpenContainer)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$a,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css(
									A2(
										$elm$core$List$append,
										$author$project$Page$FillTemplate$styles.avatar,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Css$backgroundColor(
												$author$project$Data$PDF$User$materialColorCode(signers.colour))
											])))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									A2($elm$core$String$left, 2, signers.role))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css(
									_List_fromArray(
										[
											A4(
											$rtfeldman$elm_css$Css$margin4,
											$rtfeldman$elm_css$Css$px(8),
											$rtfeldman$elm_css$Css$px(10),
											$rtfeldman$elm_css$Css$px(5),
											$rtfeldman$elm_css$Css$px(5))
										]))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(signers.role)
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$FillTemplate$styles.titleContainer)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$FillTemplate$styles.addRcptHeader)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(fillTemplatePageLanguageData.addNewRecipient)
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Events$onClick(
									$author$project$Types$OnFillTemplate(
										$author$project$Type$FillTemplate$OnAuth(
											$author$project$Type$FillTemplate$OnLoaded(
												$author$project$Type$FillTemplate$OnClearAddRecipientFields(signers.roleId))))),
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$FillTemplate$styles.clearText)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(fillTemplatePageLanguageData.clear)
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$form,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Events$onSubmit(
							$author$project$Types$OnFillTemplate(
								$author$project$Type$FillTemplate$OnAuth(
									$author$project$Type$FillTemplate$OnLoaded(
										$author$project$Type$FillTemplate$OnAddRecipientSubmit(signers.roleId)))))
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css(
									_List_fromArray(
										[
											$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$relative)
										]))
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Material$Styled$Input$text,
									_List_fromArray(
										[
											$author$project$Material$Styled$Input$label(fillTemplatePageLanguageData.searchAddressBook),
											$author$project$Material$Styled$Input$value(signers.search),
											$author$project$Material$Styled$Input$containerStyles($author$project$Page$FillTemplate$styles.input),
											$author$project$Material$Styled$Input$onInput(
											A2(
												$elm$core$Basics$composeL,
												A2(
													$elm$core$Basics$composeL,
													A2($elm$core$Basics$composeL, $author$project$Types$OnFillTemplate, $author$project$Type$FillTemplate$OnAuth),
													$author$project$Type$FillTemplate$OnLoaded),
												A2($author$project$Type$FillTemplate$OnAddRecipientInput, $author$project$Type$FillTemplate$Search, signers.roleId))),
											$author$project$Material$Styled$Input$onBlur(
											$author$project$Types$OnFillTemplate(
												$author$project$Type$FillTemplate$OnAuth(
													$author$project$Type$FillTemplate$OnLoaded(
														A2($author$project$Type$FillTemplate$OnAddRecipientBlur, $author$project$Type$FillTemplate$Search, signers.roleId)))))
										]),
									_List_Nil),
									A2($author$project$Page$FillTemplate$displayAddressBookSearchResult, signers.searchResult, signers.roleId)
								])),
							A2(
							$author$project$Material$Styled$Input$text,
							_List_fromArray(
								[
									$author$project$Material$Styled$Input$label(fillTemplatePageLanguageData.firstName),
									$author$project$Material$Styled$Input$value(signers.firstName),
									$author$project$Material$Styled$Input$containerStyles($author$project$Page$FillTemplate$styles.input),
									$author$project$Material$Styled$Input$errorMessage(signers.firstNameError),
									$author$project$Material$Styled$Input$onInput(
									A2(
										$elm$core$Basics$composeL,
										A2(
											$elm$core$Basics$composeL,
											A2($elm$core$Basics$composeL, $author$project$Types$OnFillTemplate, $author$project$Type$FillTemplate$OnAuth),
											$author$project$Type$FillTemplate$OnLoaded),
										A2($author$project$Type$FillTemplate$OnAddRecipientInput, $author$project$Type$FillTemplate$FirstName, signers.roleId))),
									$author$project$Material$Styled$Input$onBlur(
									$author$project$Types$OnFillTemplate(
										$author$project$Type$FillTemplate$OnAuth(
											$author$project$Type$FillTemplate$OnLoaded(
												A2($author$project$Type$FillTemplate$OnAddRecipientBlur, $author$project$Type$FillTemplate$FirstName, signers.roleId)))))
								]),
							_List_Nil),
							A2(
							$author$project$Material$Styled$Input$text,
							_List_fromArray(
								[
									$author$project$Material$Styled$Input$label(fillTemplatePageLanguageData.lastName),
									$author$project$Material$Styled$Input$value(signers.lastName),
									$author$project$Material$Styled$Input$containerStyles($author$project$Page$FillTemplate$styles.input),
									$author$project$Material$Styled$Input$errorMessage(signers.lastNameError),
									$author$project$Material$Styled$Input$onInput(
									A2(
										$elm$core$Basics$composeL,
										A2(
											$elm$core$Basics$composeL,
											A2($elm$core$Basics$composeL, $author$project$Types$OnFillTemplate, $author$project$Type$FillTemplate$OnAuth),
											$author$project$Type$FillTemplate$OnLoaded),
										A2($author$project$Type$FillTemplate$OnAddRecipientInput, $author$project$Type$FillTemplate$LastName, signers.roleId))),
									$author$project$Material$Styled$Input$onBlur(
									$author$project$Types$OnFillTemplate(
										$author$project$Type$FillTemplate$OnAuth(
											$author$project$Type$FillTemplate$OnLoaded(
												A2($author$project$Type$FillTemplate$OnAddRecipientBlur, $author$project$Type$FillTemplate$LastName, signers.roleId)))))
								]),
							_List_Nil),
							A2(
							$author$project$Material$Styled$Input$email,
							_List_fromArray(
								[
									$author$project$Material$Styled$Input$label(fillTemplatePageLanguageData.email),
									$author$project$Material$Styled$Input$value(signers.email),
									$author$project$Material$Styled$Input$containerStyles($author$project$Page$FillTemplate$styles.input),
									$author$project$Material$Styled$Input$errorMessage(signers.emailError),
									$author$project$Material$Styled$Input$onInput(
									A2(
										$elm$core$Basics$composeL,
										A2(
											$elm$core$Basics$composeL,
											A2($elm$core$Basics$composeL, $author$project$Types$OnFillTemplate, $author$project$Type$FillTemplate$OnAuth),
											$author$project$Type$FillTemplate$OnLoaded),
										A2($author$project$Type$FillTemplate$OnAddRecipientInput, $author$project$Type$FillTemplate$Email, signers.roleId))),
									$author$project$Material$Styled$Input$onBlur(
									$author$project$Types$OnFillTemplate(
										$author$project$Type$FillTemplate$OnAuth(
											$author$project$Type$FillTemplate$OnLoaded(
												A2($author$project$Type$FillTemplate$OnAddRecipientBlur, $author$project$Type$FillTemplate$Email, signers.roleId)))))
								]),
							_List_Nil),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$FillTemplate$styles.addRcptBtnContainer)
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$FillTemplate$styles.addRcptBtn)
										]),
									_List_fromArray(
										[
											A2($author$project$Page$FillTemplate$addRecipientBtn, model, signers)
										]))
								]))
						]))
				])) : A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_Utils_ap(
						$author$project$Page$FillTemplate$styles.recipientContent,
						_Utils_ap($author$project$Page$FillTemplate$styles.annotContainer, $author$project$Page$FillTemplate$styles.onHover))),
					$rtfeldman$elm_css$Html$Styled$Events$onClick(
					$author$project$Types$OnFillTemplate(
						$author$project$Type$FillTemplate$OnAuth(
							$author$project$Type$FillTemplate$OnLoaded(
								$author$project$Type$FillTemplate$OnRecipientBoxClick(signers.roleId)))))
				]),
			_List_fromArray(
				[
					$elm$core$String$isEmpty(signers.firstName) ? A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$FillTemplate$styles.recipientHeader)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$FillTemplate$styles.emptyRecipientItemTitle),
									$rtfeldman$elm_css$Html$Styled$Attributes$css(
									_List_fromArray(
										[
											$rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$inline)
										]))
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$strong,
									_List_Nil,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(signers.firstName + (' ' + signers.lastName))
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css(
											_List_fromArray(
												[
													$rtfeldman$elm_css$Css$marginTop(
													$rtfeldman$elm_css$Css$px(7))
												]))
										]),
									_List_Nil)
								]))
						])) : A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$FillTemplate$styles.recipientHeader)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$FillTemplate$styles.recipientItemTitle),
									$rtfeldman$elm_css$Html$Styled$Attributes$css(
									_List_fromArray(
										[
											$rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$inline)
										]))
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$strong,
									_List_Nil,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(signers.firstName + (' ' + signers.lastName))
										])),
									$rtfeldman$elm_css$Html$Styled$text(' ' + signers.email)
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$FillTemplate$styles.avatarContainer)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css(
									A2(
										$elm$core$List$append,
										$author$project$Page$FillTemplate$styles.avatar,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Css$backgroundColor(
												$author$project$Data$PDF$User$materialColorCode(signers.colour))
											])))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									A2($elm$core$String$left, 2, signers.role))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$FillTemplate$styles.viewerText)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(signers.role)
								])),
							signers.isRecipientAssigned ? $rtfeldman$elm_css$Html$Styled$text('') : ($elm$core$String$isEmpty(signers.email) ? A2(
							$author$project$Material$Styled$Icon$keyboardArrowDown,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Svg$Styled$Attributes$css($author$project$Page$FillTemplate$styles.recipientRmvIcon),
									$rtfeldman$elm_css$Svg$Styled$Events$onClick(
									$author$project$Types$OnFillTemplate(
										$author$project$Type$FillTemplate$OnAuth(
											$author$project$Type$FillTemplate$OnLoaded(
												$author$project$Type$FillTemplate$OnRecipientBoxClick(signers.roleId)))))
								]),
							_List_Nil) : A2(
							$author$project$Material$Styled$Icon$close,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Svg$Styled$Attributes$css($author$project$Page$FillTemplate$styles.recipientRmvIcon),
									$rtfeldman$elm_css$Svg$Styled$Events$onClick(
									$author$project$Types$OnFillTemplate(
										$author$project$Type$FillTemplate$OnAuth(
											$author$project$Type$FillTemplate$OnLoaded(
												$author$project$Type$FillTemplate$OnClearAddRecipientFields(signers.roleId)))))
								]),
							_List_Nil))
						]))
				]));
	});
var $author$project$Page$FillTemplate$addRecipientBox = F3(
	function (loadedModel, user, model) {
		var valid = A2(
			$elm$core$List$all,
			function (r) {
				return (!r.displayAll) && (_Utils_eq(r.firstNameError, $elm$core$Maybe$Nothing) && (_Utils_eq(r.lastNameError, $elm$core$Maybe$Nothing) && (_Utils_eq(r.emailError, $elm$core$Maybe$Nothing) && (!$elm$core$String$isEmpty(r.email)))));
			},
			loadedModel.recipients);
		var fillTemplatePageLanguageData = model.languageSwitchModel.allLanguageData.location.fillTemplatePage;
		return _Utils_eq(loadedModel.stage, $author$project$Type$FillTemplate$Recipients) ? A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$FillTemplate$styles.sectionContainer)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[$rtfeldman$elm_css$Css$displayFlex]))
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$FillTemplate$styles.addFieldIcon)
								]),
							_List_fromArray(
								[
									A2($author$project$Material$Styled$Icon$addRecipient, _List_Nil, _List_Nil)
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$FillTemplate$styles.annotCardTitle)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(fillTemplatePageLanguageData.step2)
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_Utils_ap($author$project$Page$FillTemplate$styles.recipientContent, $author$project$Page$FillTemplate$styles.annotContainer))
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$FillTemplate$styles.recipientHeader)
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$FillTemplate$styles.recipientItemTitle),
											$rtfeldman$elm_css$Html$Styled$Attributes$css(
											_List_fromArray(
												[
													$rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$inline)
												]))
										]),
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$strong,
											_List_Nil,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(user.firstName + (' ' + user.lastName))
												])),
											$rtfeldman$elm_css$Html$Styled$text(' ' + user.email)
										]))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$FillTemplate$styles.avatarContainer)
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css(
											A2(
												$elm$core$List$append,
												$author$project$Page$FillTemplate$styles.avatar,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Css$backgroundColor(
														$author$project$Data$PDF$User$materialColorCode($author$project$Data$PDF$User$Transparent))
													])))
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											A2($elm$core$String$left, 2, user.firstName))
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$FillTemplate$styles.viewerText)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(fillTemplatePageLanguageData.sender + (' (' + (fillTemplatePageLanguageData.owner + ')')))
										]))
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_Nil,
							A2(
								$elm$core$List$map,
								$author$project$Page$FillTemplate$recipientCard(model),
								loadedModel.recipients))
						])),
					valid ? A2(
					$author$project$Material$Styled$Button$button,
					_List_fromArray(
						[
							$author$project$Material$Styled$Button$theme($author$project$Material$Styled$Button$blue),
							$author$project$Material$Styled$Button$styles($author$project$Page$FillTemplate$styles.clearAnnotButton),
							$author$project$Material$Styled$Button$onClick(
							$author$project$Types$OnFillTemplate(
								$author$project$Type$FillTemplate$OnAuth(
									$author$project$Type$FillTemplate$OnLoaded(
										$author$project$Type$FillTemplate$GoToStage($author$project$Type$FillTemplate$Options)))))
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$FillTemplate$styles.sendIcon)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Material$Styled$Icon$navigateNext,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Svg$Styled$Attributes$fill('white')
										]),
									_List_Nil),
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css(
											_List_fromArray(
												[
													$rtfeldman$elm_css$Css$paddingLeft(
													$rtfeldman$elm_css$Css$px(5)),
													$rtfeldman$elm_css$Css$paddingTop(
													$rtfeldman$elm_css$Css$px(1.5))
												]))
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(fillTemplatePageLanguageData.next)
										]))
								]))
						])) : A2(
					$author$project$Material$Styled$Button$button,
					_List_fromArray(
						[
							$author$project$Material$Styled$Button$theme($author$project$Material$Styled$Button$grey),
							$author$project$Material$Styled$Button$disabled(true),
							$author$project$Material$Styled$Button$styles($author$project$Page$FillTemplate$styles.clearAnnotButton),
							$author$project$Material$Styled$Button$onClick(
							$author$project$Types$OnFillTemplate(
								$author$project$Type$FillTemplate$OnAuth(
									$author$project$Type$FillTemplate$OnLoaded(
										$author$project$Type$FillTemplate$GoToStage($author$project$Type$FillTemplate$Options)))))
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(fillTemplatePageLanguageData.next)
						]))
				])) : A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$FillTemplate$styles.sectionContainerClosed),
					$rtfeldman$elm_css$Html$Styled$Events$onClick(
					$author$project$Types$OnFillTemplate(
						$author$project$Type$FillTemplate$OnAuth(
							$author$project$Type$FillTemplate$OnLoaded(
								$author$project$Type$FillTemplate$GoToStage($author$project$Type$FillTemplate$Recipients)))))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$FillTemplate$styles.addFieldIcon)
						]),
					_List_fromArray(
						[
							A2($author$project$Material$Styled$Icon$addRecipient, _List_Nil, _List_Nil)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$FillTemplate$styles.annotCardTitleClosed)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(fillTemplatePageLanguageData.step2)
						])),
					A2($author$project$Material$Styled$Icon$keyboardArrowDown, _List_Nil, _List_Nil)
				]));
	});
var $author$project$Type$FillTemplate$Enters = {$: 'Enters'};
var $author$project$Type$FillTemplate$Leaves = {$: 'Leaves'};
var $author$project$Type$FillTemplate$OnAdditionalMsgInput = function (a) {
	return {$: 'OnAdditionalMsgInput', a: a};
};
var $author$project$Type$FillTemplate$OnAdditionalMsgToggle = {$: 'OnAdditionalMsgToggle'};
var $author$project$Type$FillTemplate$OnDueDateBlur = {$: 'OnDueDateBlur'};
var $author$project$Type$FillTemplate$OnDueDateInput = function (a) {
	return {$: 'OnDueDateInput', a: a};
};
var $author$project$Type$FillTemplate$OnDueDateToggle = {$: 'OnDueDateToggle'};
var $author$project$Type$FillTemplate$OnHover = F2(
	function (a, b) {
		return {$: 'OnHover', a: a, b: b};
	});
var $author$project$Type$FillTemplate$OnPasscodeBlur = {$: 'OnPasscodeBlur'};
var $author$project$Type$FillTemplate$OnPasscodeInput = function (a) {
	return {$: 'OnPasscodeInput', a: a};
};
var $author$project$Type$FillTemplate$OnPasscodeToggle = {$: 'OnPasscodeToggle'};
var $author$project$Type$FillTemplate$OnRequireNotarisationToggle = function (a) {
	return {$: 'OnRequireNotarisationToggle', a: a};
};
var $author$project$Type$FillTemplate$OnSigningOrderChecked = {$: 'OnSigningOrderChecked'};
var $author$project$Page$FillTemplate$convertStringToNetwork = function (currentUserNotarisationNetwork) {
	switch (currentUserNotarisationNetwork) {
		case 'Binance':
			return $author$project$Type$FillTemplate$Binance;
		case 'Algorand':
			return $author$project$Type$FillTemplate$Algorand;
		default:
			return $author$project$Type$FillTemplate$Binance;
	}
};
var $author$project$Material$Styled$TextArea$CustomInputAttributes = function (a) {
	return {$: 'CustomInputAttributes', a: a};
};
var $author$project$Material$Styled$TextArea$customInputAttributes = function (attributes) {
	return $author$project$Material$Styled$TextArea$CustomInputAttributes(attributes);
};
var $author$project$Material$Styled$Input$date = F2(
	function (properties, _v0) {
		return A2($author$project$Material$Styled$Input$input, 'date', properties);
	});
var $author$project$Page$FillTemplate$displayErrorMessage = F2(
	function (check, errorTxt) {
		return check ? $rtfeldman$elm_css$Html$Styled$text('') : A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$FillTemplate$styles.errorTxt)
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text(errorTxt)
				]));
	});
var $author$project$Type$FillTemplate$AlgoWallet = {$: 'AlgoWallet'};
var $author$project$Type$FillTemplate$SystemBalance = {$: 'SystemBalance'};
var $author$project$Type$FillTemplate$WalletConnect = {$: 'WalletConnect'};
var $author$project$Page$FillTemplate$convertStringToPayment = function (currentUserPaymentMethod) {
	switch (currentUserPaymentMethod) {
		case 'systemBalance':
			return $author$project$Type$FillTemplate$SystemBalance;
		case 'algoWallet':
			return $author$project$Type$FillTemplate$AlgoWallet;
		case 'walletConnect':
			return $author$project$Type$FillTemplate$WalletConnect;
		default:
			return $author$project$Type$FillTemplate$SystemBalance;
	}
};
var $author$project$Page$FillTemplate$displayToolTipTxt = F6(
	function (languageSwitchModel, notarisationNetwork, binanceCost, algorandCost, signPointsBalance, paymentMethod) {
		var fillTemplatePageLanguageData = languageSwitchModel.allLanguageData.location.fillTemplatePage;
		var _v0 = _Utils_Tuple2(
			notarisationNetwork,
			$author$project$Page$FillTemplate$convertStringToPayment(paymentMethod));
		if (_v0.a.$ === 'Binance') {
			var _v1 = _v0.a;
			return _Utils_ap(
				fillTemplatePageLanguageData.notariseTooltipText1,
				_Utils_ap(
					binanceCost,
					_Utils_ap(
						fillTemplatePageLanguageData.notariseTooltipText2,
						_Utils_ap(signPointsBalance, fillTemplatePageLanguageData.notariseTooltipText3))));
		} else {
			if (_v0.b.$ === 'SystemBalance') {
				var _v2 = _v0.a;
				var _v3 = _v0.b;
				return _Utils_ap(
					fillTemplatePageLanguageData.notariseTooltipText1,
					_Utils_ap(
						algorandCost,
						_Utils_ap(
							fillTemplatePageLanguageData.notariseTooltipText2,
							_Utils_ap(signPointsBalance, fillTemplatePageLanguageData.notariseTooltipText3))));
			} else {
				var _v4 = _v0.a;
				return 'This action costs 5 SIGN points. As you have chosen to deduct the points directly from your Algorand Wallet balance, please ensure you have enough points before proceeding.';
			}
		}
	});
var $author$project$Page$FillTemplate$minDateString = $ryannhg$date_format$DateFormat$format(
	_List_fromArray(
		[
			$ryannhg$date_format$DateFormat$yearNumber,
			$ryannhg$date_format$DateFormat$text('-'),
			$ryannhg$date_format$DateFormat$monthFixed,
			$ryannhg$date_format$DateFormat$text('-'),
			$ryannhg$date_format$DateFormat$dayOfMonthFixed
		]));
var $author$project$Type$FillTemplate$OnSigningOrderInput = F2(
	function (a, b) {
		return {$: 'OnSigningOrderInput', a: a, b: b};
	});
var $author$project$Page$FillTemplate$signingOrdercard = F2(
	function (numberOfSigners, signers) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$FillTemplate$styles.signingOrderAvatarContainer)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$FillTemplate$styles.signOrderInfoContainer)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$FillTemplate$styles.signingOrderText)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(signers.firstName + (' ' + (signers.lastName + (' (' + (signers.role + ')')))))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$FillTemplate$styles.signingOrderText)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(signers.email)
								]))
						])),
					A2(
					$author$project$Material$Styled$Input$number,
					_List_fromArray(
						[
							$author$project$Material$Styled$Input$min('1'),
							$author$project$Material$Styled$Input$max(
							$elm$core$String$fromInt(numberOfSigners)),
							$author$project$Material$Styled$Input$label(''),
							$author$project$Material$Styled$Input$value(
							$elm$core$String$fromInt(signers.signOrder)),
							$author$project$Material$Styled$Input$onInput(
							A2(
								$elm$core$Basics$composeL,
								A2(
									$elm$core$Basics$composeL,
									A2($elm$core$Basics$composeL, $author$project$Types$OnFillTemplate, $author$project$Type$FillTemplate$OnAuth),
									$author$project$Type$FillTemplate$OnLoaded),
								$author$project$Type$FillTemplate$OnSigningOrderInput(signers.roleId))),
							$author$project$Material$Styled$Input$containerStyles($author$project$Page$FillTemplate$styles.signOrderField),
							$author$project$Material$Styled$Input$id('signOrder' + signers.email)
						]),
					_List_Nil)
				]));
	});
var $author$project$Page$FillTemplate$signingOrder = F2(
	function (languageSwitchModel, loadedModel) {
		var signers = A2(
			$elm$core$List$filter,
			function (r) {
				return !_Utils_eq(r.signOrder, -1);
			},
			loadedModel.recipients);
		var noOfSigners = $elm$core$List$length(signers);
		var fillTemplatePageLanguageData = languageSwitchModel.allLanguageData.location.fillTemplatePage;
		return _Utils_eq(loadedModel.signingType, $author$project$Type$FillTemplate$SigningOrder) ? A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_Utils_ap(
						$author$project$Page$FillTemplate$styles.recipientContent,
						_Utils_ap(
							$author$project$Page$FillTemplate$styles.annotContainer,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Css$marginBottom(
									$rtfeldman$elm_css$Css$px(10))
								]))))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$FillTemplate$styles.recipientHeader)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$FillTemplate$styles.recipientItemTitle)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(fillTemplatePageLanguageData.signOrder)
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[
									$rtfeldman$elm_css$Css$marginTop(
									$rtfeldman$elm_css$Css$px(-20))
								]))
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_Nil,
							A2(
								$elm$core$List$map,
								$author$project$Page$FillTemplate$signingOrdercard(noOfSigners),
								signers))
						]))
				])) : $rtfeldman$elm_css$Html$Styled$text('');
	});
var $author$project$Page$FillTemplate$advanceOptions = F5(
	function (loadedModel, user, currentTime, timezone, languageSwitchModel) {
		var signPointsBalance = loadedModel.signPointsBalance / 100;
		var fillTemplatePageLanguageData = languageSwitchModel.allLanguageData.location.fillTemplatePage;
		var currentChosenNetwork = user.notarisationNetwork + (' ' + 'Network');
		var clearText = languageSwitchModel.allLanguageData.location.uploadDocument.clear;
		var binanceNotarisationCost = loadedModel.binanceNotarisationCost / 100;
		var binanceErrorTxt = 'You currently have ' + ($elm$core$String$fromFloat(signPointsBalance) + (' SIGN points available. This action costs ' + ($elm$core$String$fromFloat(binanceNotarisationCost) + ' SIGN points')));
		var algorandNotarisationCost = loadedModel.algorandNotarisationCost / 100;
		var algorandErrorTxt = 'You currently have ' + ($elm$core$String$fromFloat(signPointsBalance) + (' SIGN points available. This action costs ' + ($elm$core$String$fromFloat(algorandNotarisationCost) + ' SIGN points')));
		return _Utils_eq(loadedModel.stage, $author$project$Type$FillTemplate$Options) ? A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$FillTemplate$styles.sectionContainer)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[$rtfeldman$elm_css$Css$displayFlex]))
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$FillTemplate$styles.addFieldIcon)
								]),
							_List_fromArray(
								[
									A2($author$project$Material$Styled$Icon$settings, _List_Nil, _List_Nil)
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$FillTemplate$styles.annotCardTitle)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(fillTemplatePageLanguageData.optionalSettings)
								]))
						])),
					A2(
					$author$project$Material$Styled$Checkbox$checkbox,
					_List_fromArray(
						[
							$author$project$Material$Styled$Checkbox$checked(
							_Utils_eq(loadedModel.signingType, $author$project$Type$FillTemplate$SigningOrder)),
							$author$project$Material$Styled$Checkbox$containerStyles($author$project$Page$FillTemplate$styles.signingOrderCheckBox),
							$author$project$Material$Styled$Checkbox$onClick(
							$author$project$Types$OnFillTemplate(
								$author$project$Type$FillTemplate$OnAuth(
									$author$project$Type$FillTemplate$OnLoaded($author$project$Type$FillTemplate$OnSigningOrderChecked)))),
							$author$project$Material$Styled$Checkbox$testAttribute('signingOrder')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(fillTemplatePageLanguageData.signOrder)
						])),
					A2($author$project$Page$FillTemplate$signingOrder, languageSwitchModel, loadedModel),
					A2(
					$author$project$Material$Styled$Checkbox$checkbox,
					_List_fromArray(
						[
							$author$project$Material$Styled$Checkbox$checked(loadedModel.showDueDate),
							$author$project$Material$Styled$Checkbox$containerStyles($author$project$Page$FillTemplate$styles.signingOrderCheckBox),
							$author$project$Material$Styled$Checkbox$onClick(
							$author$project$Types$OnFillTemplate(
								$author$project$Type$FillTemplate$OnAuth(
									$author$project$Type$FillTemplate$OnLoaded($author$project$Type$FillTemplate$OnDueDateToggle))))
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(fillTemplatePageLanguageData.dueDate)
						])),
					loadedModel.showDueDate ? A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Material$Styled$Input$date,
							_List_fromArray(
								[
									$author$project$Material$Styled$Input$containerStyles($author$project$Page$FillTemplate$styles.inputContainer),
									$author$project$Material$Styled$Input$label(fillTemplatePageLanguageData.dueDate),
									$author$project$Material$Styled$Input$value(
									A2($elm$core$Maybe$withDefault, 'dd/mm/yyyy', loadedModel.dueDate)),
									$author$project$Material$Styled$Input$errorMessage(loadedModel.dueDateError),
									$author$project$Material$Styled$Input$min(
									A2($author$project$Page$FillTemplate$minDateString, timezone, currentTime)),
									$author$project$Material$Styled$Input$onInput(
									A2(
										$elm$core$Basics$composeL,
										A2(
											$elm$core$Basics$composeL,
											A2($elm$core$Basics$composeL, $author$project$Types$OnFillTemplate, $author$project$Type$FillTemplate$OnAuth),
											$author$project$Type$FillTemplate$OnLoaded),
										$author$project$Type$FillTemplate$OnDueDateInput)),
									$author$project$Material$Styled$Input$onBlur(
									$author$project$Types$OnFillTemplate(
										$author$project$Type$FillTemplate$OnAuth(
											$author$project$Type$FillTemplate$OnLoaded($author$project$Type$FillTemplate$OnDueDateBlur))))
								]),
							_List_Nil),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$FillTemplate$styles.dueDateControls)
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$FillTemplate$styles.dueDateInfo)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											_Utils_eq(loadedModel.dueDate, $elm$core$Maybe$Nothing) ? 'No Due Date' : '')
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$FillTemplate$styles.dueDateClear),
											$rtfeldman$elm_css$Html$Styled$Events$onClick(
											$author$project$Types$OnFillTemplate(
												$author$project$Type$FillTemplate$OnAuth(
													$author$project$Type$FillTemplate$OnLoaded(
														$author$project$Type$FillTemplate$OnDueDateInput('')))))
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(clearText)
										]))
								]))
						])) : $rtfeldman$elm_css$Html$Styled$text(''),
					A2(
					$author$project$Material$Styled$Checkbox$checkbox,
					_List_fromArray(
						[
							$author$project$Material$Styled$Checkbox$checked(loadedModel.showAdditionalMsg),
							$author$project$Material$Styled$Checkbox$containerStyles($author$project$Page$FillTemplate$styles.signingOrderCheckBox),
							$author$project$Material$Styled$Checkbox$onClick(
							$author$project$Types$OnFillTemplate(
								$author$project$Type$FillTemplate$OnAuth(
									$author$project$Type$FillTemplate$OnLoaded($author$project$Type$FillTemplate$OnAdditionalMsgToggle))))
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(fillTemplatePageLanguageData.additionalMessage)
						])),
					loadedModel.showAdditionalMsg ? A2(
					$author$project$Material$Styled$TextArea$textArea,
					_List_fromArray(
						[
							$author$project$Material$Styled$TextArea$label('Attach a personalised message to your recipients in the email notification for signing.'),
							$author$project$Material$Styled$TextArea$customInputAttributes(
							_List_fromArray(
								[
									A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'data-gramm_editor', 'false')
								])),
							$author$project$Material$Styled$TextArea$value(
							A2($elm$core$Maybe$withDefault, '', loadedModel.additionalMsg)),
							$author$project$Material$Styled$TextArea$onInput(
							A2(
								$elm$core$Basics$composeL,
								A2(
									$elm$core$Basics$composeL,
									A2($elm$core$Basics$composeL, $author$project$Types$OnFillTemplate, $author$project$Type$FillTemplate$OnAuth),
									$author$project$Type$FillTemplate$OnLoaded),
								$author$project$Type$FillTemplate$OnAdditionalMsgInput))
						]),
					_List_Nil) : $rtfeldman$elm_css$Html$Styled$text(''),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$FillTemplate$styles.stampHeaderStyles)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Material$Styled$Checkbox$checkbox,
							_List_fromArray(
								[
									$author$project$Material$Styled$Checkbox$checked(loadedModel.showPasscodeInput),
									$author$project$Material$Styled$Checkbox$containerStyles($author$project$Page$FillTemplate$styles.signingOrderCheckBox),
									$author$project$Material$Styled$Checkbox$onClick(
									$author$project$Types$OnFillTemplate(
										$author$project$Type$FillTemplate$OnAuth(
											$author$project$Type$FillTemplate$OnLoaded($author$project$Type$FillTemplate$OnPasscodeToggle))))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(fillTemplatePageLanguageData.passcode)
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_Nil,
							_List_fromArray(
								[
									A5(
									$author$project$View$InfomationToolTip$view,
									$author$project$Types$OnFillTemplate(
										$author$project$Type$FillTemplate$OnAuth(
											$author$project$Type$FillTemplate$OnLoaded(
												A2($author$project$Type$FillTemplate$OnHover, $author$project$Type$FillTemplate$Enters, $author$project$Type$FillTemplate$Passcode)))),
									$author$project$Types$OnFillTemplate(
										$author$project$Type$FillTemplate$OnAuth(
											$author$project$Type$FillTemplate$OnLoaded(
												A2($author$project$Type$FillTemplate$OnHover, $author$project$Type$FillTemplate$Leaves, $author$project$Type$FillTemplate$Passcode)))),
									_Utils_eq(loadedModel.toolTipActiveHover, $author$project$Type$FillTemplate$Passcode),
									A2(
										$rtfeldman$elm_css$Html$Styled$span,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$FillTemplate$styles.toolTipText)
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(fillTemplatePageLanguageData.passcodeTooltipText)
											])),
									$author$project$Material$Styled$Icon$moreInfo)
								]))
						])),
					loadedModel.showPasscodeInput ? A2(
					$author$project$Material$Styled$Input$password,
					_List_fromArray(
						[
							$author$project$Material$Styled$Input$containerStyles($author$project$Page$FillTemplate$styles.inputContainer),
							$author$project$Material$Styled$Input$label(fillTemplatePageLanguageData.passcode),
							$author$project$Material$Styled$Input$value(
							A2($elm$core$Maybe$withDefault, '', loadedModel.passcode)),
							$author$project$Material$Styled$Input$errorMessage(loadedModel.passcodeError),
							$author$project$Material$Styled$Input$onInput(
							A2(
								$elm$core$Basics$composeL,
								A2(
									$elm$core$Basics$composeL,
									A2($elm$core$Basics$composeL, $author$project$Types$OnFillTemplate, $author$project$Type$FillTemplate$OnAuth),
									$author$project$Type$FillTemplate$OnLoaded),
								$author$project$Type$FillTemplate$OnPasscodeInput)),
							$author$project$Material$Styled$Input$onBlur(
							$author$project$Types$OnFillTemplate(
								$author$project$Type$FillTemplate$OnAuth(
									$author$project$Type$FillTemplate$OnLoaded($author$project$Type$FillTemplate$OnPasscodeBlur))))
						]),
					_List_Nil) : $rtfeldman$elm_css$Html$Styled$text(''),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$FillTemplate$styles.stampHeaderStyles)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Material$Styled$Checkbox$checkbox,
									_List_fromArray(
										[
											$author$project$Material$Styled$Checkbox$checked(loadedModel.requireNotarisation),
											$author$project$Material$Styled$Checkbox$containerStyles($author$project$Page$FillTemplate$styles.signingOrderCheckBox),
											$author$project$Material$Styled$Checkbox$onClick(
											$author$project$Types$OnFillTemplate(
												$author$project$Type$FillTemplate$OnAuth(
													$author$project$Type$FillTemplate$OnLoaded(
														$author$project$Type$FillTemplate$OnRequireNotarisationToggle(
															$author$project$Page$FillTemplate$convertStringToNetwork(user.notarisationNetwork))))))
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(fillTemplatePageLanguageData.notariseDocument + (': ' + currentChosenNetwork))
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_Nil,
									_List_fromArray(
										[
											A5(
											$author$project$View$InfomationToolTip$view,
											$author$project$Types$OnFillTemplate(
												$author$project$Type$FillTemplate$OnAuth(
													$author$project$Type$FillTemplate$OnLoaded(
														A2($author$project$Type$FillTemplate$OnHover, $author$project$Type$FillTemplate$Enters, $author$project$Type$FillTemplate$Notarize)))),
											$author$project$Types$OnFillTemplate(
												$author$project$Type$FillTemplate$OnAuth(
													$author$project$Type$FillTemplate$OnLoaded(
														A2($author$project$Type$FillTemplate$OnHover, $author$project$Type$FillTemplate$Leaves, $author$project$Type$FillTemplate$Notarize)))),
											_Utils_eq(loadedModel.toolTipActiveHover, $author$project$Type$FillTemplate$Notarize),
											A2(
												$rtfeldman$elm_css$Html$Styled$span,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$FillTemplate$styles.toolTipText)
													]),
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text(
														A6(
															$author$project$Page$FillTemplate$displayToolTipTxt,
															languageSwitchModel,
															$author$project$Page$FillTemplate$convertStringToNetwork(user.notarisationNetwork),
															$elm$core$String$fromFloat(binanceNotarisationCost),
															$elm$core$String$fromFloat(algorandNotarisationCost),
															$elm$core$String$fromFloat(signPointsBalance),
															user.paymentMethod)),
														A2(
														$author$project$Material$Styled$A$a,
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$Attributes$href('https://www.sign.net/rewardpoints'),
																$rtfeldman$elm_css$Html$Styled$Attributes$target('_blank')
															]),
														_List_fromArray(
															[
																A2(
																$rtfeldman$elm_css$Html$Styled$span,
																_List_fromArray(
																	[
																		$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$FillTemplate$styles.linkText)
																	]),
																_List_fromArray(
																	[
																		$rtfeldman$elm_css$Html$Styled$text('Find out more')
																	]))
															]))
													])),
											$author$project$Material$Styled$Icon$moreInfo)
										]))
								]))
						])),
					(user.notarisationNetwork === 'Binance') ? A2(
					$author$project$Page$FillTemplate$displayErrorMessage,
					_Utils_cmp(loadedModel.signPointsBalance, loadedModel.binanceNotarisationCost) > -1,
					binanceErrorTxt) : (((user.notarisationNetwork === 'Algorand') && (user.paymentMethod === 'systemBalance')) ? A2(
					$author$project$Page$FillTemplate$displayErrorMessage,
					_Utils_cmp(loadedModel.signPointsBalance, loadedModel.algorandNotarisationCost) > -1,
					algorandErrorTxt) : $rtfeldman$elm_css$Html$Styled$text(''))
				])) : A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Events$onClick(
					$author$project$Types$OnFillTemplate(
						$author$project$Type$FillTemplate$OnAuth(
							$author$project$Type$FillTemplate$OnLoaded(
								$author$project$Type$FillTemplate$GoToStage($author$project$Type$FillTemplate$Options))))),
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$FillTemplate$styles.sectionContainerClosed)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$FillTemplate$styles.addFieldIcon)
						]),
					_List_fromArray(
						[
							A2($author$project$Material$Styled$Icon$settings, _List_Nil, _List_Nil)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$FillTemplate$styles.annotCardTitleClosed)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(fillTemplatePageLanguageData.optionalSettings)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_Nil,
					_List_fromArray(
						[
							A2($author$project$Material$Styled$Icon$keyboardArrowDown, _List_Nil, _List_Nil)
						]))
				]));
	});
var $author$project$Data$Api$PDF$ViewTemplate$errorToString = function (error) {
	switch (error.$) {
		case 'INVALID_DOMAIN':
			return 'Invalid data provided. Please refresh an try again.';
		case 'INVALID_SLUG':
			return 'Slug contain disallowed characters.';
		case 'INVALID_DATA':
			return 'Invalid data provided. Please refresh and try again.';
		case 'NOT_FOUND':
			return 'Template doesn\'t exist.';
		default:
			return 'Template version not found.';
	}
};
var $author$project$View$PDFTokenError$styles = {
	button: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(10)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(190))
		]),
	modalBody: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(14)),
			$rtfeldman$elm_css$Css$fontWeight(
			$rtfeldman$elm_css$Css$int(400)),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$blueGrey500)
		]),
	modalBodyContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$em(1))
		]),
	modalBtns: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$rowReverse),
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceBetween)
		]),
	modalContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$vw(70)),
			$rtfeldman$elm_css$Css$maxWidth(
			$rtfeldman$elm_css$Css$px(500))
		]),
	modalHeader: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$row),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$flexStart),
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceBetween)
		]),
	modalHeaderTxt: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(20)),
			$rtfeldman$elm_css$Css$fontWeight(
			$rtfeldman$elm_css$Css$int(500))
		])
};
var $author$project$View$PDFTokenError$invalidToken = function (msg) {
	return A2(
		$author$project$Material$Styled$Modal$modal,
		_List_fromArray(
			[
				$author$project$Material$Styled$Modal$open(true),
				$author$project$Material$Styled$Modal$contentContainerstyles($author$project$View$PDFTokenError$styles.modalContainer)
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$PDFTokenError$styles.modalHeader)
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$PDFTokenError$styles.modalHeaderTxt)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('Template Not Found')
							]))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$PDFTokenError$styles.modalBodyContainer)
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$PDFTokenError$styles.modalBody)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('An Error has occured. Please try again later.')
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$PDFTokenError$styles.modalBtns)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Material$Styled$Button$button,
								_List_fromArray(
									[
										$author$project$Material$Styled$Button$theme($author$project$Material$Styled$Button$blue),
										$author$project$Material$Styled$Button$styles($author$project$View$PDFTokenError$styles.button),
										$author$project$Material$Styled$Button$onClick(msg)
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('Back To Homepage')
									]))
							]))
					]))
			]));
};
var $author$project$View$PDFTokenError$notTokenUser = function (msg) {
	return A2(
		$author$project$Material$Styled$Modal$modal,
		_List_fromArray(
			[
				$author$project$Material$Styled$Modal$open(true),
				$author$project$Material$Styled$Modal$contentContainerstyles($author$project$View$PDFTokenError$styles.modalContainer)
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$PDFTokenError$styles.modalHeader)
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$PDFTokenError$styles.modalHeaderTxt)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('Unable To Load Template')
							]))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$PDFTokenError$styles.modalBodyContainer)
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$PDFTokenError$styles.modalBody)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('The link you are accessing is not valid to this user. Please logout and try again.')
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$PDFTokenError$styles.modalBtns)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Material$Styled$Button$button,
								_List_fromArray(
									[
										$author$project$Material$Styled$Button$theme($author$project$Material$Styled$Button$blue),
										$author$project$Material$Styled$Button$styles($author$project$View$PDFTokenError$styles.button),
										$author$project$Material$Styled$Button$onClick(msg)
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('Back To Dashboard')
									]))
							]))
					]))
			]));
};
var $author$project$Type$FillTemplate$DeleteTemplate = function (a) {
	return {$: 'DeleteTemplate', a: a};
};
var $author$project$Type$FillTemplate$OnCreateDocumentFromTemplate = function (a) {
	return {$: 'OnCreateDocumentFromTemplate', a: a};
};
var $author$project$Type$FillTemplate$OnDownloadTemplateReport = function (a) {
	return {$: 'OnDownloadTemplateReport', a: a};
};
var $author$project$Type$FillTemplate$OnShowModal = function (a) {
	return {$: 'OnShowModal', a: a};
};
var $author$project$Type$FillTemplate$RequestTemplate = function (a) {
	return {$: 'RequestTemplate', a: a};
};
var $author$project$Type$FillTemplate$TemplateActivity = {$: 'TemplateActivity'};
var $author$project$Data$PDF$FillTemplate$templateRoles = function (_v0) {
	var template = _v0.a;
	return template.roles;
};
var $author$project$Page$FillTemplate$statusContent = F3(
	function (loadedModel, appModel, user) {
		var viewTemplatePageLanguageData = appModel.languageSwitchModel.allLanguageData.location.viewTemplatePage;
		var templateOwnerId = loadedModel.payload.owner.id;
		var slug = loadedModel.payload.slug;
		var noOfRoles = $elm$core$List$length(
			A2(
				$elm$core$List$filter,
				function (r) {
					return !_Utils_eq(r.signOrder, -1);
				},
				$author$project$Data$PDF$FillTemplate$templateRoles(loadedModel.template)));
		var isTemplateOwner = _Utils_eq(templateOwnerId, user.id);
		var domainOwnerEmail = appModel.businessProfileModel.email;
		var isDomainOwner = _Utils_eq(domainOwnerEmail, user.email);
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$FillTemplate$styles.docStatusContainer)
				]),
			_List_fromArray(
				[
					(isTemplateOwner || isDomainOwner) ? A2(
					$author$project$Material$Styled$Button$button,
					_List_fromArray(
						[
							$author$project$Material$Styled$Button$styles($author$project$Page$FillTemplate$styles.docStatusBtn),
							$author$project$Material$Styled$Button$theme($author$project$Material$Styled$Button$default),
							$author$project$Material$Styled$Button$onClick(
							$author$project$Types$OnFillTemplate(
								$author$project$Type$FillTemplate$OnAuth(
									$author$project$Type$FillTemplate$OnViewTemplateInfo(
										$author$project$Type$FillTemplate$OnDownloadTemplateReport(loadedModel.payload.id)))))
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(viewTemplatePageLanguageData.downloadTemplateReport)
						])) : $rtfeldman$elm_css$Html$Styled$text(''),
					(noOfRoles === 1) ? A2(
					$author$project$Material$Styled$Button$button,
					_List_fromArray(
						[
							$author$project$Material$Styled$Button$styles($author$project$Page$FillTemplate$styles.docStatusBtn),
							$author$project$Material$Styled$Button$theme($author$project$Material$Styled$Button$blue),
							$author$project$Material$Styled$Button$onClick(
							$author$project$Types$OnFillTemplate(
								$author$project$Type$FillTemplate$OnAuth(
									$author$project$Type$FillTemplate$OnViewTemplateInfo(
										$author$project$Type$FillTemplate$OnShowModal(
											$author$project$Type$FillTemplate$RequestTemplate(slug))))))
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(viewTemplatePageLanguageData.requestToFillTemplate)
						])) : A2(
					$author$project$Material$Styled$Button$button,
					_List_fromArray(
						[
							$author$project$Material$Styled$Button$styles($author$project$Page$FillTemplate$styles.docStatusBtn),
							$author$project$Material$Styled$Button$theme($author$project$Material$Styled$Button$blue),
							$author$project$Material$Styled$Button$onClick(
							$author$project$Types$OnFillTemplate(
								$author$project$Type$FillTemplate$OnAuth(
									$author$project$Type$FillTemplate$OnViewTemplateInfo(
										$author$project$Type$FillTemplate$OnCreateDocumentFromTemplate(slug)))))
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(viewTemplatePageLanguageData.createDocumentFromTemplate)
						])),
					A2(
					$author$project$Material$Styled$Button$button,
					_List_fromArray(
						[
							$author$project$Material$Styled$Button$styles($author$project$Page$FillTemplate$styles.docStatusBtn),
							$author$project$Material$Styled$Button$theme($author$project$Material$Styled$Button$default),
							$author$project$Material$Styled$Button$onClick(
							$author$project$Types$OnFillTemplate(
								$author$project$Type$FillTemplate$OnAuth(
									$author$project$Type$FillTemplate$OnViewTemplateInfo(
										$author$project$Type$FillTemplate$OnShowModal($author$project$Type$FillTemplate$TemplateActivity)))))
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(viewTemplatePageLanguageData.viewTemplateActivity)
						])),
					(_Utils_eq(templateOwnerId, user.id) || _Utils_eq(domainOwnerEmail, user.email)) ? A2(
					$author$project$Material$Styled$Button$button,
					_List_fromArray(
						[
							$author$project$Material$Styled$Button$styles($author$project$Page$FillTemplate$styles.docStatusBtn),
							$author$project$Material$Styled$Button$theme($author$project$Material$Styled$Button$default),
							$author$project$Material$Styled$Button$onClick(
							$author$project$Types$OnFillTemplate(
								$author$project$Type$FillTemplate$OnAuth(
									$author$project$Type$FillTemplate$OnViewTemplateInfo(
										$author$project$Type$FillTemplate$OnShowModal(
											$author$project$Type$FillTemplate$DeleteTemplate(loadedModel.payload.id))))))
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(viewTemplatePageLanguageData.deleteTemplate)
						])) : $rtfeldman$elm_css$Html$Styled$text(''),
					A2(
					$author$project$Material$Styled$Button$button,
					_List_fromArray(
						[
							$author$project$Material$Styled$Button$styles($author$project$Page$FillTemplate$styles.docStatusBtn),
							$author$project$Material$Styled$Button$theme($author$project$Material$Styled$Button$default),
							$author$project$Material$Styled$Button$onClick(
							$author$project$Types$OnFillTemplate(
								$author$project$Type$FillTemplate$OnAuth($author$project$Type$FillTemplate$OnNavigateToDashboard)))
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(viewTemplatePageLanguageData.backToDashboard)
						]))
				]));
	});
var $author$project$Type$FillTemplate$OnTemplateSubmit = {$: 'OnTemplateSubmit'};
var $author$project$Page$FillTemplate$submitBtn = function (model) {
	var fillTemplatePageLanguageData = model.languageSwitchModel.allLanguageData.location.fillTemplatePage;
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$marginTop(
						$rtfeldman$elm_css$Css$px(15))
					]))
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Material$Styled$Button$button,
				_List_fromArray(
					[
						$author$project$Material$Styled$Button$theme($author$project$Material$Styled$Button$green),
						$author$project$Material$Styled$Button$styles($author$project$Page$FillTemplate$styles.optionBtn),
						$author$project$Material$Styled$Button$onClick(
						$author$project$Types$OnFillTemplate(
							$author$project$Type$FillTemplate$OnAuth(
								$author$project$Type$FillTemplate$OnLoaded($author$project$Type$FillTemplate$OnTemplateSubmit))))
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$FillTemplate$styles.sendIcon)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Material$Styled$Icon$sendFilled,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Svg$Styled$Attributes$fill('white')
									]),
								_List_Nil),
								A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css(
										_List_fromArray(
											[
												$rtfeldman$elm_css$Css$paddingLeft(
												$rtfeldman$elm_css$Css$px(5)),
												$rtfeldman$elm_css$Css$paddingTop(
												$rtfeldman$elm_css$Css$px(5))
											]))
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(fillTemplatePageLanguageData.sendButtonText)
									]))
							]))
					]))
			]));
};
var $author$project$Page$PointsTransactions$TableElements$dateFormatter = $ryannhg$date_format$DateFormat$format(
	_List_fromArray(
		[
			$ryannhg$date_format$DateFormat$dayOfMonthFixed,
			$ryannhg$date_format$DateFormat$text(' '),
			$ryannhg$date_format$DateFormat$monthNameAbbreviated,
			$ryannhg$date_format$DateFormat$text(' '),
			$ryannhg$date_format$DateFormat$yearNumber
		]));
var $author$project$Page$FillTemplate$templateDetails = F3(
	function (loadedModel, appModel, user) {
		var viewTemplatePageLanguageData = appModel.languageSwitchModel.allLanguageData.location.viewTemplatePage;
		var templateData = loadedModel.payload;
		var templateUrl = (appModel.baseHost === 'localhost') ? ('http://' + ($author$project$Data$Domain$toString(
			$author$project$Data$Domain$selected(user.domains)) + (':3000' + ($author$project$Data$Route$routeUrl.fillTemplate + ('/' + templateData.slug))))) : ('https://' + ($author$project$Data$Domain$toString(
			$author$project$Data$Domain$selected(user.domains)) + ($author$project$Data$Route$routeUrl.fillTemplate + ('/' + templateData.slug))));
		var updatedDateTxt = A2($author$project$Page$PointsTransactions$TableElements$dateFormatter, appModel.timezone, templateData.updatedAt);
		var noOfSigners = $elm$core$List$length(
			A2(
				$elm$core$List$filter,
				function (r) {
					return !_Utils_eq(r.signOrder, -1);
				},
				$author$project$Data$PDF$FillTemplate$templateRoles(loadedModel.template)));
		var lastViewedTemplateData = $elm$core$List$head(
			$elm$core$List$reverse(
				A2(
					$elm$core$List$sortBy,
					function (r) {
						return $elm$time$Time$posixToMillis(r.createdAt);
					},
					A2(
						$elm$core$List$filter,
						function (r) {
							return _Utils_eq(r.action, $author$project$Data$Api$PDF$ViewTemplate$View);
						},
						loadedModel.payload.templateLogData))));
		var lastTemplateViewerData = A2(
			$elm$core$Maybe$withDefault,
			{
				action: $author$project$Data$Api$PDF$ViewTemplate$View,
				createdAt: $elm$time$Time$millisToPosix(0),
				documentId: $elm$core$Maybe$Nothing,
				firstName: '',
				ipAddr: $elm$core$Maybe$Nothing,
				lastName: ''
			},
			lastViewedTemplateData);
		var lastViewDate = A2($author$project$Page$PointsTransactions$TableElements$dateFormatter, appModel.timezone, lastTemplateViewerData.createdAt);
		var createdDateTxt = A2($author$project$Page$PointsTransactions$TableElements$dateFormatter, appModel.timezone, templateData.createdAt);
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$h2,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$FillTemplate$styles.docDetailsSubTitle)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(viewTemplatePageLanguageData.nameOfTemplate)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$FillTemplate$styles.docDetailsText)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(templateData.title)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$h2,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$FillTemplate$styles.docDetailsSubTitle)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(viewTemplatePageLanguageData.createdBy + ':')
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$FillTemplate$styles.docDetailsText)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(templateData.owner.firstName + (' ' + templateData.owner.lastName))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$h2,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$FillTemplate$styles.docDetailsSubTitle)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(viewTemplatePageLanguageData.dateCreated + ':')
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$FillTemplate$styles.docDetailsText)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(createdDateTxt)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$h2,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$FillTemplate$styles.docDetailsSubTitle)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(viewTemplatePageLanguageData.lastEdited + ':')
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$FillTemplate$styles.docDetailsText)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(updatedDateTxt)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$h2,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$FillTemplate$styles.docDetailsSubTitle)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(viewTemplatePageLanguageData.lastViewed + ':')
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$FillTemplate$styles.docDetailsText)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(lastViewDate + (', ' + (lastTemplateViewerData.firstName + (' ' + lastTemplateViewerData.lastName))))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$h2,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$FillTemplate$styles.docDetailsSubTitle)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(viewTemplatePageLanguageData.noOfDocumentsGeneratedFromTemplate + ':')
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$FillTemplate$styles.docDetailsText)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$elm$core$String$fromInt(templateData.noOfGeneratedDocumentsfromTemplate))
						])),
					(noOfSigners === 1) ? A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$h2,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$FillTemplate$styles.docDetailsSubTitle)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(viewTemplatePageLanguageData.templateUrl + ':')
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$a,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$href(templateUrl),
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$FillTemplate$styles.docDetailsText),
									$rtfeldman$elm_css$Html$Styled$Attributes$target('_blank')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(templateUrl)
								]))
						])) : $rtfeldman$elm_css$Html$Styled$text('')
				]));
	});
var $author$project$Type$FillTemplate$OnErrorClose = {$: 'OnErrorClose'};
var $author$project$Page$FillTemplate$ErrorBanner$errorBodyToString = function (error) {
	switch (error.$) {
		case 'LoadSignature':
			return 'Failed to load signatures in the document.';
		case 'EncryptionDecodeError':
			var message = error.a;
			return message;
		case 'NoSelectedSignature':
			return 'No signature selected.';
		case 'UpdateAnnotations':
			var err = error.a;
			return err;
		case 'TemplateValidation':
			var err = error.a;
			return err;
		default:
			var err = error.a;
			return err;
	}
};
var $author$project$Page$FillTemplate$ErrorBanner$errorHeaderToString = function (error) {
	switch (error.$) {
		case 'LoadSignature':
			return 'Loading Error';
		case 'EncryptionDecodeError':
			return 'Password Decode Error';
		case 'NoSelectedSignature':
			return 'No Signature Error';
		case 'UpdateAnnotations':
			return 'Update Error';
		case 'TemplateValidation':
			return 'Template Error';
		default:
			return 'Submission Error';
	}
};
var $author$project$Page$FillTemplate$ErrorBanner$styles = {
	container: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$absolute),
			$rtfeldman$elm_css$Css$top($rtfeldman$elm_css$Css$zero),
			$rtfeldman$elm_css$Css$left($rtfeldman$elm_css$Css$zero),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100)),
			$rtfeldman$elm_css$Css$boxSizing($rtfeldman$elm_css$Css$borderBox),
			$rtfeldman$elm_css$Css$padding(
			$rtfeldman$elm_css$Css$px(20))
		])
};
var $author$project$Page$FillTemplate$ErrorBanner$view = function (error) {
	return A2(
		$author$project$Material$Styled$Banner$banner,
		_List_fromArray(
			[
				$author$project$Material$Styled$Banner$containerStyles($author$project$Page$FillTemplate$ErrorBanner$styles.container),
				$author$project$Material$Styled$Banner$theme($author$project$Material$Styled$Banner$errorTheme),
				$author$project$Material$Styled$Banner$title(
				$author$project$Page$FillTemplate$ErrorBanner$errorHeaderToString(error)),
				$author$project$Material$Styled$Banner$body(
				$rtfeldman$elm_css$Html$Styled$text(
					$author$project$Page$FillTemplate$ErrorBanner$errorBodyToString(error))),
				$author$project$Material$Styled$Banner$closeIconAttributes(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Svg$Styled$Events$onClick(
						$author$project$Types$OnFillTemplate(
							$author$project$Type$FillTemplate$OnAuth(
								$author$project$Type$FillTemplate$OnLoaded($author$project$Type$FillTemplate$OnErrorClose))))
					]))
			]),
		_List_Nil);
};
var $author$project$Type$FillTemplate$OnCloseModal = {$: 'OnCloseModal'};
var $author$project$Page$FillTemplate$Modal$dateFormatter = $ryannhg$date_format$DateFormat$format(
	_List_fromArray(
		[
			$ryannhg$date_format$DateFormat$dayOfMonthFixed,
			$ryannhg$date_format$DateFormat$text(' '),
			$ryannhg$date_format$DateFormat$monthNameAbbreviated,
			$ryannhg$date_format$DateFormat$text(' '),
			$ryannhg$date_format$DateFormat$yearNumber
		]));
var $author$project$Data$Api$PDF$ViewTemplate$getActionTypes = function (action) {
	switch (action.$) {
		case 'EditTemplate':
			return 'Edit Template';
		case 'CreateDocument':
			return 'Create Document from template';
		case 'CompleteDocument':
			return 'Document Completed';
		case 'View':
			return 'View';
		default:
			return 'Template Created';
	}
};
var $author$project$Page$FillTemplate$Modal$styles = {
	activitiesContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$overflowY($rtfeldman$elm_css$Css$auto),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$vh(60)),
			$rtfeldman$elm_css$Css$maxHeight(
			$rtfeldman$elm_css$Css$px(600))
		]),
	activitiesModal: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$vw(90)),
			$rtfeldman$elm_css$Css$maxWidth(
			$rtfeldman$elm_css$Css$px(550))
		]),
	avatar: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$borderRadius(
			$rtfeldman$elm_css$Css$pct(50)),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(40)),
			$rtfeldman$elm_css$Css$minWidth(
			$rtfeldman$elm_css$Css$px(40)),
			$rtfeldman$elm_css$Css$marginRight(
			$rtfeldman$elm_css$Css$px(2)),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$white),
			$rtfeldman$elm_css$Css$backgroundColor($author$project$Material$Styled$Color$blueA700),
			$rtfeldman$elm_css$Css$textTransform($rtfeldman$elm_css$Css$uppercase),
			$rtfeldman$elm_css$Css$textDecoration($rtfeldman$elm_css$Css$none)
		]),
	backToDashboardBtn: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$maxWidth(
			$rtfeldman$elm_css$Css$px(200))
		]),
	boldText: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontWeight(
			$rtfeldman$elm_css$Css$int(500))
		]),
	bottomContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column)
		]),
	button: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginLeft(
			$rtfeldman$elm_css$Css$px(10)),
			$rtfeldman$elm_css$Css$maxWidth(
			$rtfeldman$elm_css$Css$px(200))
		]),
	buttonContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$vw(70)),
			$rtfeldman$elm_css$Css$maxWidth(
			$rtfeldman$elm_css$Css$px(500)),
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$row),
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
			A4(
			$rtfeldman$elm_css$Css$padding4,
			$rtfeldman$elm_css$Css$px(8),
			$rtfeldman$elm_css$Css$px(0),
			$rtfeldman$elm_css$Css$px(0),
			$rtfeldman$elm_css$Css$px(0))
		]),
	buttonMargin: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(20))
		]),
	cardContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			$rtfeldman$elm_css$Css$flexWrap($rtfeldman$elm_css$Css$wrap),
			$rtfeldman$elm_css$Css$marginBottom(
			$rtfeldman$elm_css$Css$px(10)),
			$rtfeldman$elm_css$Css$marginRight(
			$rtfeldman$elm_css$Css$px(10))
		]),
	cardHeaderContent: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$margin(
			$rtfeldman$elm_css$Css$px(20))
		]),
	dashboardBtn: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(190))
		]),
	footer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$row),
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceBetween),
			A3(
			$rtfeldman$elm_css$Css$padding3,
			$rtfeldman$elm_css$Css$px(20),
			$rtfeldman$elm_css$Css$zero,
			$rtfeldman$elm_css$Css$zero)
		]),
	fullLengthButton: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100))
		]),
	icon: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$boxShadow($rtfeldman$elm_css$Css$none),
			$rtfeldman$elm_css$Css$transform(
			A2(
				$rtfeldman$elm_css$Css$translate2,
				$rtfeldman$elm_css$Css$px(20),
				$rtfeldman$elm_css$Css$px(-15))),
			$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer),
			$rtfeldman$elm_css$Css$padding(
			$rtfeldman$elm_css$Css$px(10))
		]),
	inputContainer: _List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Css$margin2,
			$rtfeldman$elm_css$Css$px(20),
			$rtfeldman$elm_css$Css$zero)
		]),
	marginTop5: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(5))
		]),
	modalBody: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(12)),
			$rtfeldman$elm_css$Css$fontWeight(
			$rtfeldman$elm_css$Css$int(400)),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$blueGrey500)
		]),
	modalBody2: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(12)),
			$rtfeldman$elm_css$Css$fontWeight(
			$rtfeldman$elm_css$Css$int(400))
		]),
	modalBodyContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$em(1))
		]),
	modalBtns: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$rowReverse),
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceBetween),
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(20))
		]),
	modalContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$vw(70)),
			$rtfeldman$elm_css$Css$maxWidth(
			$rtfeldman$elm_css$Css$px(500))
		]),
	modalHeader: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$row),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$flexStart),
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceBetween)
		]),
	modalHeaderTxt: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(20)),
			$rtfeldman$elm_css$Css$fontWeight(
			$rtfeldman$elm_css$Css$int(500))
		]),
	nameContent: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$row),
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceBetween),
			$rtfeldman$elm_css$Css$flexWrap($rtfeldman$elm_css$Css$wrap),
			$rtfeldman$elm_css$Css$marginLeft(
			$rtfeldman$elm_css$Css$px(10)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100))
		]),
	onHover: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$hover(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer),
					A2($rtfeldman$elm_css$Css$property, 'box-shadow', '0px 2px 4px -1px rgba(0,0,0,0.2), 0px 4px 5px 0px rgba(0,0,0,0.14), 0px 1px 10px 0px rgba(0,0,0,0.12)'),
					$rtfeldman$elm_css$Css$backgroundColor($author$project$Material$Styled$Color$grey200)
				]))
		]),
	optInText: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(14)),
			$rtfeldman$elm_css$Css$paddingBottom(
			$rtfeldman$elm_css$Css$px(10))
		]),
	passwordButtons: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(180))
		]),
	progressBar: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(10))
		]),
	signBtn: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$maxWidth(
			$rtfeldman$elm_css$Css$px(130))
		]),
	smallTxt: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(12)),
			$rtfeldman$elm_css$Css$fontWeight(
			$rtfeldman$elm_css$Css$int(400)),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$blueGrey500),
			$rtfeldman$elm_css$Css$padding(
			$rtfeldman$elm_css$Css$px(2))
		]),
	subContent: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$paddingRight(
			$rtfeldman$elm_css$Css$px(10)),
			$rtfeldman$elm_css$Css$margin(
			$rtfeldman$elm_css$Css$px(20)),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(14)),
			A2(
			$rtfeldman$elm_css$Css$Media$withMediaQuery,
			_List_fromArray(
				['screen and (max-width: 400px)']),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$margin(
					$rtfeldman$elm_css$Css$px(5)),
					$rtfeldman$elm_css$Css$width(
					$rtfeldman$elm_css$Css$pct(100))
				]))
		]),
	subContentContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$row),
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceBetween),
			$rtfeldman$elm_css$Css$marginBottom(
			$rtfeldman$elm_css$Css$px(10)),
			$rtfeldman$elm_css$Css$flexWrap($rtfeldman$elm_css$Css$wrap)
		]),
	templateTxt: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center)
		]),
	walletAddress: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$overflow($rtfeldman$elm_css$Css$hidden),
			$rtfeldman$elm_css$Css$textOverflow($rtfeldman$elm_css$Css$ellipsis),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(450)),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(14)),
			A4(
			$rtfeldman$elm_css$Css$padding4,
			$rtfeldman$elm_css$Css$px(10),
			$rtfeldman$elm_css$Css$px(0),
			$rtfeldman$elm_css$Css$px(10),
			$rtfeldman$elm_css$Css$px(0))
		]),
	walletButtonContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$vw(70)),
			$rtfeldman$elm_css$Css$maxWidth(
			$rtfeldman$elm_css$Css$px(500)),
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
			A4(
			$rtfeldman$elm_css$Css$padding4,
			$rtfeldman$elm_css$Css$px(8),
			$rtfeldman$elm_css$Css$px(0),
			$rtfeldman$elm_css$Css$px(0),
			$rtfeldman$elm_css$Css$px(0))
		]),
	walletContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$maxHeight(
			$rtfeldman$elm_css$Css$px(400)),
			$rtfeldman$elm_css$Css$overflow($rtfeldman$elm_css$Css$hidden)
		]),
	walletErrorText: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(14)),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$red500),
			$rtfeldman$elm_css$Css$displayFlex,
			A4(
			$rtfeldman$elm_css$Css$padding4,
			$rtfeldman$elm_css$Css$px(10),
			$rtfeldman$elm_css$Css$px(0),
			$rtfeldman$elm_css$Css$px(10),
			$rtfeldman$elm_css$Css$px(0))
		])
};
var $ryannhg$date_format$DateFormat$AmPmLowercase = {$: 'AmPmLowercase'};
var $ryannhg$date_format$DateFormat$amPmLowercase = $ryannhg$date_format$DateFormat$AmPmLowercase;
var $ryannhg$date_format$DateFormat$HourFixed = {$: 'HourFixed'};
var $ryannhg$date_format$DateFormat$hourFixed = $ryannhg$date_format$DateFormat$HourFixed;
var $ryannhg$date_format$DateFormat$MinuteFixed = {$: 'MinuteFixed'};
var $ryannhg$date_format$DateFormat$minuteFixed = $ryannhg$date_format$DateFormat$MinuteFixed;
var $author$project$Page$FillTemplate$Modal$timeFormatter = $ryannhg$date_format$DateFormat$format(
	_List_fromArray(
		[
			$ryannhg$date_format$DateFormat$hourFixed,
			$ryannhg$date_format$DateFormat$text(':'),
			$ryannhg$date_format$DateFormat$minuteFixed,
			$ryannhg$date_format$DateFormat$text(' '),
			$ryannhg$date_format$DateFormat$amPmLowercase
		]));
var $author$project$Page$FillTemplate$Modal$activitiesCard = F2(
	function (appModel, log) {
		var zoneName = function () {
			var _v0 = appModel.timezoneName;
			if (_v0.$ === 'Just') {
				var zoneName_ = _v0.a;
				if (zoneName_.$ === 'Name') {
					var name = zoneName_.a;
					return name;
				} else {
					var offset = zoneName_.a;
					return 'UTC ' + ($elm$core$String$fromInt((offset / 60) | 0) + '00');
				}
			} else {
				return 'No zoneName';
			}
		}();
		var languageData = appModel.languageSwitchModel.allLanguageData.location.viewDocumentPage;
		return A2(
			$author$project$Material$Styled$Card$card,
			_List_fromArray(
				[
					$author$project$Material$Styled$Card$containerStyles($author$project$Page$FillTemplate$Modal$styles.cardContainer)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$FillTemplate$Modal$styles.cardHeaderContent)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$FillTemplate$Modal$styles.avatar)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									A2($elm$core$String$left, 1, log.firstName))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$FillTemplate$Modal$styles.nameContent)
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$FillTemplate$Modal$styles.boldText)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(log.firstName + (' ' + log.lastName))
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_Nil,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											A2($elm$core$Maybe$withDefault, '', log.ipAddr))
										]))
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$FillTemplate$Modal$styles.subContentContainer)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$FillTemplate$Modal$styles.subContent)
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$FillTemplate$Modal$styles.boldText)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(languageData.action + ': ')
										])),
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$Data$Api$PDF$ViewTemplate$getActionTypes(log.action))
								])),
							_Utils_eq(log.documentId, $elm$core$Maybe$Nothing) ? $rtfeldman$elm_css$Html$Styled$text('') : A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$FillTemplate$Modal$styles.subContent)
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$FillTemplate$Modal$styles.boldText)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(languageData.documentId + ': ')
										])),
									$rtfeldman$elm_css$Html$Styled$text(
									A2($elm$core$Maybe$withDefault, '', log.documentId))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$FillTemplate$Modal$styles.subContent)
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$FillTemplate$Modal$styles.boldText)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(languageData.time + ': ')
										])),
									$rtfeldman$elm_css$Html$Styled$text(
									A2($author$project$Page$FillTemplate$Modal$dateFormatter, appModel.timezone, log.createdAt) + (' ' + (A2($author$project$Page$FillTemplate$Modal$timeFormatter, appModel.timezone, log.createdAt) + (' (' + (zoneName + ') ')))))
								]))
						]))
				]));
	});
var $author$project$Page$FillTemplate$Modal$activitiesModal = F2(
	function (appModel, logs) {
		var languageData = appModel.languageSwitchModel.allLanguageData.location.viewDocumentPage;
		var templateLog = A2(
			$elm$core$List$filter,
			function (r) {
				return !_Utils_eq(r.action, $author$project$Data$Api$PDF$ViewTemplate$View);
			},
			logs);
		return A2(
			$author$project$Material$Styled$Modal$modal,
			_List_fromArray(
				[
					$author$project$Material$Styled$Modal$open(true),
					$author$project$Material$Styled$Modal$contentContainerstyles($author$project$Page$FillTemplate$Modal$styles.activitiesModal),
					$author$project$Material$Styled$Modal$onClose(
					$author$project$Types$OnFillTemplate(
						$author$project$Type$FillTemplate$OnAuth(
							$author$project$Type$FillTemplate$OnViewTemplateInfo($author$project$Type$FillTemplate$OnCloseModal))))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$FillTemplate$Modal$styles.modalHeader)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$FillTemplate$Modal$styles.modalHeaderTxt)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(languageData.activities)
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$img,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$FillTemplate$Modal$styles.icon),
									$rtfeldman$elm_css$Html$Styled$Attributes$src($author$project$View$Theme$images.close),
									$rtfeldman$elm_css$Html$Styled$Events$onClick(
									$author$project$Types$OnFillTemplate(
										$author$project$Type$FillTemplate$OnAuth(
											$author$project$Type$FillTemplate$OnViewTemplateInfo($author$project$Type$FillTemplate$OnCloseModal))))
								]),
							_List_Nil)
						])),
					$elm$core$List$isEmpty(templateLog) ? A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$FillTemplate$Modal$styles.activitiesContainer)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('No template activities found.')
						])) : A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$FillTemplate$Modal$styles.activitiesContainer)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_Nil,
							A2(
								$elm$core$List$map,
								$author$project$Page$FillTemplate$Modal$activitiesCard(appModel),
								templateLog))
						]))
				]));
	});
var $author$project$Page$FillTemplate$Modal$cancelNotarisationSuccessModal = A2(
	$author$project$Material$Styled$Modal$modal,
	_List_fromArray(
		[
			$author$project$Material$Styled$Modal$open(true),
			$author$project$Material$Styled$Modal$contentContainerstyles($author$project$Page$FillTemplate$Modal$styles.modalContainer)
		]),
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$FillTemplate$Modal$styles.modalHeader)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$FillTemplate$Modal$styles.modalHeaderTxt)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('Success')
						]))
				])),
			A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$FillTemplate$Modal$styles.modalBody)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('Notarisation cancelled for this document, you can still notarise this document under the completed document section.')
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$FillTemplate$Modal$styles.buttonContainer)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Material$Styled$Button$button,
							_List_fromArray(
								[
									$author$project$Material$Styled$Button$theme($author$project$Material$Styled$Button$blue),
									$author$project$Material$Styled$Button$styles($author$project$Page$FillTemplate$Modal$styles.backToDashboardBtn),
									$author$project$Material$Styled$Button$onClick(
									$author$project$Types$OnFillTemplate(
										$author$project$Type$FillTemplate$OnAuth($author$project$Type$FillTemplate$OnNavigateToDashboard)))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Back to dashboard')
								]))
						]))
				]))
		]));
var $author$project$Type$FillTemplate$OnDeleteTemplate = function (a) {
	return {$: 'OnDeleteTemplate', a: a};
};
var $author$project$Page$FillTemplate$Modal$deleteTemplateModal = F2(
	function (templateId, appModel) {
		var fillTemplatePageLanguageData = appModel.languageSwitchModel.allLanguageData.location.viewTemplatePage;
		var cancelBtnTxt = appModel.languageSwitchModel.allLanguageData.location.addressBookPage.cancelBtn;
		return A2(
			$author$project$Material$Styled$Modal$modal,
			_List_fromArray(
				[
					$author$project$Material$Styled$Modal$open(true),
					$author$project$Material$Styled$Modal$contentContainerstyles($author$project$Page$FillTemplate$Modal$styles.modalContainer)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$FillTemplate$Modal$styles.modalHeader)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$FillTemplate$Modal$styles.modalHeaderTxt)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(fillTemplatePageLanguageData.deleteTemplate)
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$img,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$FillTemplate$Modal$styles.icon),
									$rtfeldman$elm_css$Html$Styled$Attributes$src($author$project$View$Theme$images.close),
									$rtfeldman$elm_css$Html$Styled$Events$onClick(
									$author$project$Types$OnFillTemplate(
										$author$project$Type$FillTemplate$OnAuth(
											$author$project$Type$FillTemplate$OnViewTemplateInfo($author$project$Type$FillTemplate$OnCloseModal))))
								]),
							_List_Nil)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('Do you want to delete this template?')
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$FillTemplate$Modal$styles.footer)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Material$Styled$Button$button,
							_List_fromArray(
								[
									$author$project$Material$Styled$Button$styles($author$project$Page$FillTemplate$Modal$styles.button),
									function () {
									var defaultTextTheme = $author$project$Material$Styled$Button$greyText;
									return $author$project$Material$Styled$Button$theme(
										_Utils_update(
											defaultTextTheme,
											{base: $author$project$Material$Styled$Color$grey200String}));
								}(),
									$author$project$Material$Styled$Button$onClick(
									$author$project$Types$OnFillTemplate(
										$author$project$Type$FillTemplate$OnAuth(
											$author$project$Type$FillTemplate$OnViewTemplateInfo($author$project$Type$FillTemplate$OnCloseModal))))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(cancelBtnTxt)
								])),
							A2(
							$author$project$Material$Styled$Button$button,
							_List_fromArray(
								[
									$author$project$Material$Styled$Button$styles($author$project$Page$FillTemplate$Modal$styles.button),
									$author$project$Material$Styled$Button$onClick(
									$author$project$Types$OnFillTemplate(
										$author$project$Type$FillTemplate$OnAuth(
											$author$project$Type$FillTemplate$OnViewTemplateInfo(
												$author$project$Type$FillTemplate$OnDeleteTemplate(templateId)))))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(fillTemplatePageLanguageData.confirm)
								]))
						]))
				]));
	});
var $author$project$Page$FillTemplate$Modal$deleteTemplateSuccess = function (appModel) {
	var fillTemplatePageLanguageData = appModel.languageSwitchModel.allLanguageData.location.viewTemplatePage;
	return A2(
		$author$project$Material$Styled$Modal$modal,
		_List_fromArray(
			[
				$author$project$Material$Styled$Modal$open(true),
				$author$project$Material$Styled$Modal$contentContainerstyles($author$project$Page$FillTemplate$Modal$styles.modalContainer)
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$FillTemplate$Modal$styles.modalHeader)
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$FillTemplate$Modal$styles.modalHeaderTxt)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(fillTemplatePageLanguageData.deleteTemplate)
							]))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$FillTemplate$Modal$styles.modalBodyContainer)
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$FillTemplate$Modal$styles.modalBody)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('Please check your email to delete the template.')
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$FillTemplate$Modal$styles.modalBtns)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Material$Styled$Button$button,
								_List_fromArray(
									[
										$author$project$Material$Styled$Button$theme($author$project$Material$Styled$Button$blue),
										$author$project$Material$Styled$Button$styles($author$project$Page$FillTemplate$Modal$styles.dashboardBtn),
										$author$project$Material$Styled$Button$onClick(
										$author$project$Types$OnFillTemplate(
											$author$project$Type$FillTemplate$OnAuth(
												$author$project$Type$FillTemplate$OnViewTemplateInfo($author$project$Type$FillTemplate$OnCloseModal))))
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(fillTemplatePageLanguageData.close)
									]))
							]))
					]))
			]));
};
var $author$project$Type$FillTemplate$OnWalletConnectWalletSelect = function (a) {
	return {$: 'OnWalletConnectWalletSelect', a: a};
};
var $author$project$Page$FillTemplate$Modal$walletConnectCard = function (walletData) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Events$onClick(
				$author$project$Types$OnFillTemplate(
					$author$project$Type$FillTemplate$OnAuth(
						$author$project$Type$FillTemplate$OnLoaded(
							$author$project$Type$FillTemplate$OnWalletConnectWalletSelect(walletData)))))
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Material$Styled$Card$card,
				_List_fromArray(
					[
						$author$project$Material$Styled$Card$containerStyles(
						_Utils_ap($author$project$Page$FillTemplate$Modal$styles.cardContainer, $author$project$Page$FillTemplate$Modal$styles.onHover))
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$FillTemplate$Modal$styles.walletAddress)
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$span,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$FillTemplate$Modal$styles.walletAddress)
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(walletData.address)
									]))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$FillTemplate$Modal$styles.optInText)
							]),
						_List_fromArray(
							[
								walletData.needOptIn ? $rtfeldman$elm_css$Html$Styled$text('Requires Opt In') : $rtfeldman$elm_css$Html$Styled$text('Does not require Opt In')
							]))
					]))
			]));
};
var $author$project$Page$FillTemplate$Modal$displayWalletConnectAddressesModal = F2(
	function (walletDataList, loadedModel) {
		var requiresOptIn = A2(
			$elm$core$List$any,
			function (pdfData) {
				return pdfData.needOptIn;
			},
			walletDataList);
		return A2(
			$author$project$Material$Styled$Modal$modal,
			_List_fromArray(
				[
					$author$project$Material$Styled$Modal$open(true),
					$author$project$Material$Styled$Modal$contentContainerstyles($author$project$Page$FillTemplate$Modal$styles.activitiesModal)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$FillTemplate$Modal$styles.modalHeader)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$FillTemplate$Modal$styles.modalHeaderTxt)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Your wallet Addresses')
								]))
						])),
					requiresOptIn ? A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$FillTemplate$Modal$styles.smallTxt)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('It seems like some of your wallet addresses are not opted in for our SIGN ASA on the Algorand network. This step is required in order for you to receive and use SIGN points on our application. Please note that the opt-in process will be a one time transaction that will cost 0.001 Algos')
								]))
						])) : $rtfeldman$elm_css$Html$Styled$text(''),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$FillTemplate$Modal$styles.smallTxt)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Please click to select the wallet use for payment.')
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$FillTemplate$Modal$styles.walletContainer)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_Nil,
							A2($elm$core$List$map, $author$project$Page$FillTemplate$Modal$walletConnectCard, walletDataList))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$FillTemplate$Modal$styles.walletErrorText)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							A2($elm$core$Maybe$withDefault, '', loadedModel.walletError))
						]))
				]));
	});
var $author$project$Type$FillTemplate$AlgorandWalletConnectClick = {$: 'AlgorandWalletConnectClick'};
var $author$project$Type$FillTemplate$OnCancelNotarisationClick = {$: 'OnCancelNotarisationClick'};
var $author$project$Type$FillTemplate$OptInAssetClick = {$: 'OptInAssetClick'};
var $author$project$Type$FillTemplate$PaymentTransactionClick = {$: 'PaymentTransactionClick'};
var $author$project$Page$FillTemplate$Modal$optInStatusDisplayText = function (needOptIn) {
	return (!needOptIn) ? '[Current selected wallet has opt-in to SIGN ASA. Click pay.]' : '[Current selected wallet has not opt-in to SIGN ASA.]';
};
var $author$project$Type$FillTemplate$OnSelectWallet = function (a) {
	return {$: 'OnSelectWallet', a: a};
};
var $author$project$Page$FillTemplate$Modal$walletCard = function (walletAddress) {
	return A2(
		$author$project$Material$Styled$Card$card,
		_List_fromArray(
			[
				$author$project$Material$Styled$Card$containerStyles(
				_Utils_ap($author$project$Page$FillTemplate$Modal$styles.cardContainer, $author$project$Page$FillTemplate$Modal$styles.onHover))
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$FillTemplate$Modal$styles.walletAddress),
						$rtfeldman$elm_css$Html$Styled$Events$onClick(
						$author$project$Types$OnFillTemplate(
							$author$project$Type$FillTemplate$OnAuth(
								$author$project$Type$FillTemplate$OnLoaded(
									$author$project$Type$FillTemplate$OnSelectWallet(walletAddress)))))
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$FillTemplate$Modal$styles.walletAddress)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(walletAddress)
							]))
					]))
			]));
};
var $author$project$Page$FillTemplate$Modal$displayWalletModal = F2(
	function (walletAddress, loadedModel) {
		var selectedAddress = A2($elm$core$Maybe$withDefault, '', loadedModel.selectedWallet);
		return A2(
			$author$project$Material$Styled$Modal$modal,
			_List_fromArray(
				[
					$author$project$Material$Styled$Modal$open(true),
					$author$project$Material$Styled$Modal$contentContainerstyles($author$project$Page$FillTemplate$Modal$styles.modalContainer)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$FillTemplate$Modal$styles.modalHeader)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$FillTemplate$Modal$styles.modalHeaderTxt)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Your wallet Addresses')
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$img,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$FillTemplate$Modal$styles.icon),
									$rtfeldman$elm_css$Html$Styled$Attributes$src($author$project$View$Theme$images.close),
									$rtfeldman$elm_css$Html$Styled$Events$onClick(
									$author$project$Types$OnFillTemplate(
										$author$project$Type$FillTemplate$OnAuth(
											$author$project$Type$FillTemplate$OnLoaded($author$project$Type$FillTemplate$OnCancelNotarisationClick))))
								]),
							_List_Nil)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$FillTemplate$Modal$styles.smallTxt)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Please click to select the wallet use for payment.')
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$FillTemplate$Modal$styles.walletContainer)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_Nil,
							A2($elm$core$List$map, $author$project$Page$FillTemplate$Modal$walletCard, walletAddress))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$FillTemplate$Modal$styles.walletAddress)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Selected Account: ' + selectedAddress)
								]))
						])),
					$elm$core$String$isEmpty(selectedAddress) ? A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$FillTemplate$Modal$styles.walletErrorText)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							A2($elm$core$Maybe$withDefault, '', loadedModel.optInError))
						])) : (loadedModel.needOptIn ? A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$FillTemplate$Modal$styles.bottomContainer)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$FillTemplate$Modal$styles.smallTxt)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('A one time process to opt-in is needed before payment.')
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$FillTemplate$Modal$styles.walletErrorText)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$Page$FillTemplate$Modal$optInStatusDisplayText(loadedModel.needOptIn))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$FillTemplate$Modal$styles.walletErrorText)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									A2($elm$core$Maybe$withDefault, '', loadedModel.optInError))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$FillTemplate$Modal$styles.buttonContainer)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Material$Styled$Button$button,
									_List_fromArray(
										[
											function () {
											var defaultTextTheme = $author$project$Material$Styled$Button$greyText;
											return $author$project$Material$Styled$Button$theme(
												_Utils_update(
													defaultTextTheme,
													{base: $author$project$Material$Styled$Color$grey200String}));
										}(),
											$author$project$Material$Styled$Button$styles($author$project$Page$FillTemplate$Modal$styles.fullLengthButton),
											$author$project$Material$Styled$Button$onClick(
											$author$project$Types$OnFillTemplate(
												$author$project$Type$FillTemplate$OnAuth(
													$author$project$Type$FillTemplate$OnLoaded($author$project$Type$FillTemplate$AlgorandWalletConnectClick))))
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('Change wallet')
										])),
									A2(
									$author$project$Material$Styled$Button$button,
									_List_fromArray(
										[
											$author$project$Material$Styled$Button$theme($author$project$Material$Styled$Button$blue),
											$author$project$Material$Styled$Button$styles($author$project$Page$FillTemplate$Modal$styles.fullLengthButton),
											$author$project$Material$Styled$Button$onClick(
											$author$project$Types$OnFillTemplate(
												$author$project$Type$FillTemplate$OnAuth(
													$author$project$Type$FillTemplate$OnLoaded($author$project$Type$FillTemplate$OptInAssetClick))))
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('Opt-in')
										])),
									A2(
									$author$project$Material$Styled$Button$button,
									_List_fromArray(
										[
											$author$project$Material$Styled$Button$styles($author$project$Page$FillTemplate$Modal$styles.fullLengthButton),
											function () {
											var defaultTextTheme = $author$project$Material$Styled$Button$greyText;
											return $author$project$Material$Styled$Button$theme(
												_Utils_update(
													defaultTextTheme,
													{base: $author$project$Material$Styled$Color$grey200String}));
										}(),
											$author$project$Material$Styled$Button$onClick(
											$author$project$Types$OnFillTemplate(
												$author$project$Type$FillTemplate$OnAuth(
													$author$project$Type$FillTemplate$OnLoaded($author$project$Type$FillTemplate$OnCancelNotarisationClick))))
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('Cancel notarisation')
										]))
								]))
						])) : A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$FillTemplate$Modal$styles.bottomContainer)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$FillTemplate$Modal$styles.smallTxt)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$Page$FillTemplate$Modal$optInStatusDisplayText(loadedModel.needOptIn))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$FillTemplate$Modal$styles.walletErrorText)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									A2($elm$core$Maybe$withDefault, '', loadedModel.optInError))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$FillTemplate$Modal$styles.walletButtonContainer)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Material$Styled$Button$button,
									_List_fromArray(
										[
											function () {
											var defaultTextTheme = $author$project$Material$Styled$Button$greyText;
											return $author$project$Material$Styled$Button$theme(
												_Utils_update(
													defaultTextTheme,
													{base: $author$project$Material$Styled$Color$grey200String}));
										}(),
											$author$project$Material$Styled$Button$styles($author$project$Page$FillTemplate$Modal$styles.fullLengthButton),
											$author$project$Material$Styled$Button$onClick(
											$author$project$Types$OnFillTemplate(
												$author$project$Type$FillTemplate$OnAuth(
													$author$project$Type$FillTemplate$OnLoaded($author$project$Type$FillTemplate$AlgorandWalletConnectClick))))
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('Change wallet')
										])),
									A2(
									$author$project$Material$Styled$Button$button,
									_List_fromArray(
										[
											$author$project$Material$Styled$Button$theme($author$project$Material$Styled$Button$blue),
											$author$project$Material$Styled$Button$styles($author$project$Page$FillTemplate$Modal$styles.fullLengthButton),
											$author$project$Material$Styled$Button$onClick(
											$author$project$Types$OnFillTemplate(
												$author$project$Type$FillTemplate$OnAuth(
													$author$project$Type$FillTemplate$OnLoaded($author$project$Type$FillTemplate$PaymentTransactionClick))))
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('Proceed to Pay')
										])),
									A2(
									$author$project$Material$Styled$Button$button,
									_List_fromArray(
										[
											$author$project$Material$Styled$Button$styles($author$project$Page$FillTemplate$Modal$styles.fullLengthButton),
											function () {
											var defaultTextTheme = $author$project$Material$Styled$Button$greyText;
											return $author$project$Material$Styled$Button$theme(
												_Utils_update(
													defaultTextTheme,
													{base: $author$project$Material$Styled$Color$grey200String}));
										}(),
											$author$project$Material$Styled$Button$onClick(
											$author$project$Types$OnFillTemplate(
												$author$project$Type$FillTemplate$OnAuth(
													$author$project$Type$FillTemplate$OnLoaded($author$project$Type$FillTemplate$OnCancelNotarisationClick))))
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('Cancel notarisation')
										]))
								]))
						])))
				]));
	});
var $author$project$Type$FillTemplate$OnConfirmedTemplateSubmit = {$: 'OnConfirmedTemplateSubmit'};
var $author$project$Material$Styled$Modal$TestAttribute = function (a) {
	return {$: 'TestAttribute', a: a};
};
var $author$project$Material$Styled$Modal$testAttribute = function (attribute_) {
	return $author$project$Material$Styled$Modal$TestAttribute(attribute_);
};
var $author$project$Page$FillTemplate$Modal$fillModal = function (model) {
	var termsOfUseTxt = model.languageSwitchModel.allLanguageData.location.createTemplatePage.referToTerms;
	var fillTemplatePageLanguageData = model.languageSwitchModel.allLanguageData.location.fillTemplatePage;
	var confirmTxt = model.languageSwitchModel.allLanguageData.location.viewTemplatePage.confirm;
	return A2(
		$author$project$Material$Styled$Modal$modal,
		_List_fromArray(
			[
				$author$project$Material$Styled$Modal$open(true),
				$author$project$Material$Styled$Modal$contentContainerstyles($author$project$Page$FillTemplate$Modal$styles.modalContainer),
				$author$project$Material$Styled$Modal$onClose(
				$author$project$Types$OnFillTemplate(
					$author$project$Type$FillTemplate$OnAuth(
						$author$project$Type$FillTemplate$OnLoaded($author$project$Type$FillTemplate$OnCloseModal)))),
				$author$project$Material$Styled$Modal$testAttribute('Fill Modal')
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$FillTemplate$Modal$styles.modalHeader)
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$FillTemplate$Modal$styles.modalHeaderTxt)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(fillTemplatePageLanguageData.proceedToSend)
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$img,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$FillTemplate$Modal$styles.icon),
								$rtfeldman$elm_css$Html$Styled$Attributes$src($author$project$View$Theme$images.close),
								$rtfeldman$elm_css$Html$Styled$Events$onClick(
								$author$project$Types$OnFillTemplate(
									$author$project$Type$FillTemplate$OnAuth(
										$author$project$Type$FillTemplate$OnLoaded($author$project$Type$FillTemplate$OnCloseModal))))
							]),
						_List_Nil)
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$FillTemplate$Modal$styles.modalBody)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(fillTemplatePageLanguageData.sendTemplateTermsOfUse),
								A2(
								$rtfeldman$elm_css$Html$Styled$a,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$href('https://www.sign.net/legal'),
										$rtfeldman$elm_css$Html$Styled$Attributes$target('_blank')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(termsOfUseTxt)
									]))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$FillTemplate$Modal$styles.modalBtns)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Material$Styled$Button$button,
								_List_fromArray(
									[
										$author$project$Material$Styled$Button$theme($author$project$Material$Styled$Button$blue),
										$author$project$Material$Styled$Button$styles($author$project$Page$FillTemplate$Modal$styles.signBtn),
										$author$project$Material$Styled$Button$onClick(
										$author$project$Types$OnFillTemplate(
											$author$project$Type$FillTemplate$OnAuth(
												$author$project$Type$FillTemplate$OnLoaded($author$project$Type$FillTemplate$OnConfirmedTemplateSubmit))))
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(confirmTxt)
									]))
							]))
					]))
			]));
};
var $author$project$Type$FillTemplate$OnRouteToViewDocument = function (a) {
	return {$: 'OnRouteToViewDocument', a: a};
};
var $author$project$Page$FillTemplate$Modal$fillSuccessModal = F3(
	function (loadedModel, user, appModel) {
		var fillTemplatePageLanguageData = appModel.languageSwitchModel.allLanguageData.location.uploadDocument;
		var displayRegisteredWalletTxt = _Utils_eq(user.algorandWalletAddress, $elm$core$Maybe$Nothing) ? 'You have chosen to pay with your own Algorand Wallet. Connect your wallet.' : ('You have chosen to notarise the document through your Algorand Wallet registered to this account: ' + (A2($elm$core$Maybe$withDefault, '', user.algorandWalletAddress) + ' and we will deduct 5 SIGN points for this transaction upon approval.'));
		var connectWalletTxt = _Utils_eq(user.algorandWalletAddress, $elm$core$Maybe$Nothing) ? 'Connect Wallet' : 'Change wallet';
		return A2(
			$author$project$Material$Styled$Modal$modal,
			_List_fromArray(
				[
					$author$project$Material$Styled$Modal$open(true),
					$author$project$Material$Styled$Modal$contentContainerstyles($author$project$Page$FillTemplate$Modal$styles.modalContainer)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$FillTemplate$Modal$styles.modalHeader)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$FillTemplate$Modal$styles.modalHeaderTxt)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(fillTemplatePageLanguageData.success)
								]))
						])),
					(loadedModel.requireNotarisation && (user.paymentMethod !== 'systemBalance')) ? A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$FillTemplate$Modal$styles.modalBody)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(displayRegisteredWalletTxt)
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$FillTemplate$Modal$styles.walletButtonContainer)
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$FillTemplate$Modal$styles.modalBtns)
										]),
									_List_fromArray(
										[
											A2(
											$author$project$Material$Styled$Button$button,
											_List_fromArray(
												[
													$author$project$Material$Styled$Button$theme($author$project$Material$Styled$Button$default),
													$author$project$Material$Styled$Button$styles($author$project$Page$FillTemplate$Modal$styles.fullLengthButton),
													$author$project$Material$Styled$Button$onClick(
													$author$project$Types$OnFillTemplate(
														$author$project$Type$FillTemplate$OnAuth(
															$author$project$Type$FillTemplate$OnLoaded($author$project$Type$FillTemplate$AlgorandWalletConnectClick))))
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(connectWalletTxt)
												]))
										])),
									_Utils_eq(user.algorandWalletAddress, $elm$core$Maybe$Nothing) ? $rtfeldman$elm_css$Html$Styled$text('') : A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$FillTemplate$Modal$styles.modalBtns)
										]),
									_List_fromArray(
										[
											A2(
											$author$project$Material$Styled$Button$button,
											_List_fromArray(
												[
													$author$project$Material$Styled$Button$theme($author$project$Material$Styled$Button$blue),
													$author$project$Material$Styled$Button$styles($author$project$Page$FillTemplate$Modal$styles.fullLengthButton),
													$author$project$Material$Styled$Button$onClick(
													$author$project$Types$OnFillTemplate(
														$author$project$Type$FillTemplate$OnAuth(
															$author$project$Type$FillTemplate$OnLoaded($author$project$Type$FillTemplate$PaymentTransactionClick))))
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text('proceed')
												]))
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$FillTemplate$Modal$styles.modalBtns)
										]),
									_List_fromArray(
										[
											A2(
											$author$project$Material$Styled$Button$button,
											_List_fromArray(
												[
													$author$project$Material$Styled$Button$styles($author$project$Page$FillTemplate$Modal$styles.fullLengthButton),
													$author$project$Material$Styled$Button$theme($author$project$Material$Styled$Button$default),
													$author$project$Material$Styled$Button$onClick(
													$author$project$Types$OnFillTemplate(
														$author$project$Type$FillTemplate$OnAuth(
															$author$project$Type$FillTemplate$OnLoaded($author$project$Type$FillTemplate$OnCancelNotarisationClick))))
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text('Cancel notarisation')
												]))
										]))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css(
									_Utils_ap($author$project$Page$FillTemplate$Modal$styles.modalBody, $author$project$Page$FillTemplate$Modal$styles.marginTop5))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Please get ready your Algorand Wallet (with WalletConnect) to approve this transaction via QR code on the next page.')
								]))
						])) : A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$FillTemplate$Modal$styles.modalBody)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(fillTemplatePageLanguageData.successText)
								])),
							A2($rtfeldman$elm_css$Html$Styled$br, _List_Nil, _List_Nil),
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$FillTemplate$Modal$styles.modalBody)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('You can view updates to this document under Outgoing Documents.')
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$FillTemplate$Modal$styles.modalBtns)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Material$Styled$Button$button,
									_List_fromArray(
										[
											$author$project$Material$Styled$Button$theme($author$project$Material$Styled$Button$default),
											$author$project$Material$Styled$Button$styles($author$project$Page$FillTemplate$Modal$styles.dashboardBtn),
											$author$project$Material$Styled$Button$onClick(
											$author$project$Types$OnFillTemplate(
												$author$project$Type$FillTemplate$OnAuth($author$project$Type$FillTemplate$OnNavigateToDashboard)))
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(fillTemplatePageLanguageData.backToDashboard)
										])),
									A2(
									$author$project$Material$Styled$Button$button,
									_List_fromArray(
										[
											$author$project$Material$Styled$Button$theme($author$project$Material$Styled$Button$blue),
											$author$project$Material$Styled$Button$styles($author$project$Page$FillTemplate$Modal$styles.dashboardBtn),
											$author$project$Material$Styled$Button$onClick(
											$author$project$Types$OnFillTemplate(
												$author$project$Type$FillTemplate$OnAuth(
													$author$project$Type$FillTemplate$OnLoaded(
														$author$project$Type$FillTemplate$OnRouteToViewDocument(loadedModel.createdDocumentId)))))
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('Go to Document')
										]))
								]))
						]))
				]));
	});
var $author$project$Page$FillTemplate$Modal$fillingModal = A2(
	$author$project$Material$Styled$Modal$modal,
	_List_fromArray(
		[
			$author$project$Material$Styled$Modal$open(true),
			$author$project$Material$Styled$Modal$contentContainerstyles($author$project$Page$FillTemplate$Modal$styles.modalContainer)
		]),
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$FillTemplate$Modal$styles.modalHeader)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$FillTemplate$Modal$styles.modalHeaderTxt)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('Filling...')
						]))
				])),
			A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$FillTemplate$Modal$styles.modalBodyContainer)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$FillTemplate$Modal$styles.modalBody)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('Filling the document...')
						])),
					A2(
					$author$project$Material$Styled$ProgressBar$linear,
					_List_fromArray(
						[
							$author$project$Material$Styled$ProgressBar$containerStyle($author$project$Page$FillTemplate$Modal$styles.progressBar)
						]),
					_List_Nil)
				]))
		]));
var $author$project$Page$FillTemplate$Modal$loadingModal = function (status) {
	var statusTxt = function () {
		switch (status.$) {
			case 'GetWallet':
				return 'Getting wallet address, please wait...';
			case 'OptIn':
				return 'Opt-in to SIGN ASA in progress , please wait...';
			case 'Payment':
				return 'Payment transaction in progress, please wait...';
			case 'CancelNotarisation':
				return 'Cancelling notarisation for this document, please wait....';
			case 'CheckWalletOptIn':
				return 'Checking if selected wallet has opt-In to SIGN ASA...';
			case 'RegisterWallet':
				return 'Registering your wallet, please wait...';
			case 'RequestDelete':
				return 'Processing delete request, Please wait...';
			default:
				return 'Processing fill template request, Please wait...';
		}
	}();
	return A2(
		$author$project$Material$Styled$Modal$modal,
		_List_fromArray(
			[
				$author$project$Material$Styled$Modal$open(true),
				$author$project$Material$Styled$Modal$contentContainerstyles($author$project$Page$FillTemplate$Modal$styles.modalContainer)
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$FillTemplate$Modal$styles.modalHeader)
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$FillTemplate$Modal$styles.modalHeaderTxt)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('Loading...')
							]))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$FillTemplate$Modal$styles.modalBody)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(statusTxt)
							])),
						A2(
						$author$project$Material$Styled$ProgressBar$linear,
						_List_fromArray(
							[
								$author$project$Material$Styled$ProgressBar$containerStyle($author$project$Page$FillTemplate$Modal$styles.progressBar)
							]),
						_List_Nil)
					]))
			]));
};
var $author$project$Type$FillTemplate$OnPasswordInput = function (a) {
	return {$: 'OnPasswordInput', a: a};
};
var $author$project$Type$FillTemplate$OnPasswordSubmit = {$: 'OnPasswordSubmit'};
var $author$project$Page$FillTemplate$Modal$needPasswordModal = F2(
	function (password, passwordError) {
		return A2(
			$author$project$Material$Styled$Modal$modal,
			_List_fromArray(
				[
					$author$project$Material$Styled$Modal$open(true),
					$author$project$Material$Styled$Modal$contentContainerstyles($author$project$Page$FillTemplate$Modal$styles.modalContainer)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$FillTemplate$Modal$styles.modalHeader)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$FillTemplate$Modal$styles.modalHeaderTxt)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Password Required')
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$FillTemplate$Modal$styles.modalBody)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('This PDF is password-protected. Please enter a password to open the PDF.')
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$form,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Events$onSubmit(
							$author$project$Types$OnFillTemplate(
								$author$project$Type$FillTemplate$OnAuth(
									$author$project$Type$FillTemplate$OnLoaded($author$project$Type$FillTemplate$OnPasswordSubmit))))
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Material$Styled$Input$password,
							_List_fromArray(
								[
									$author$project$Material$Styled$Input$containerStyles($author$project$Page$FillTemplate$Modal$styles.inputContainer),
									$author$project$Material$Styled$Input$label('Password'),
									$author$project$Material$Styled$Input$value(
									A2($elm$core$Maybe$withDefault, '', password)),
									$author$project$Material$Styled$Input$errorMessage(passwordError),
									$author$project$Material$Styled$Input$onInput(
									A2(
										$elm$core$Basics$composeL,
										A2(
											$elm$core$Basics$composeL,
											A2($elm$core$Basics$composeL, $author$project$Types$OnFillTemplate, $author$project$Type$FillTemplate$OnAuth),
											$author$project$Type$FillTemplate$OnLoaded),
										$author$project$Type$FillTemplate$OnPasswordInput))
								]),
							_List_Nil),
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$FillTemplate$Modal$styles.modalBtns)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Material$Styled$Button$button,
									_List_fromArray(
										[
											$author$project$Material$Styled$Button$theme($author$project$Material$Styled$Button$blue),
											$author$project$Material$Styled$Button$styles($author$project$Page$FillTemplate$Modal$styles.passwordButtons)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('Submit')
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$a,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$href($author$project$Data$Route$routeUrl.dashboard)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('Cancel')
										]))
								]))
						]))
				]));
	});
var $author$project$Page$FillTemplate$Modal$notariseDocumentSuccess = function (notarisationNetwork) {
	return A2(
		$author$project$Material$Styled$Modal$modal,
		_List_fromArray(
			[
				$author$project$Material$Styled$Modal$open(true),
				$author$project$Material$Styled$Modal$contentContainerstyles($author$project$Page$FillTemplate$Modal$styles.modalContainer)
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$FillTemplate$Modal$styles.modalHeader)
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$FillTemplate$Modal$styles.modalHeaderTxt)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('Notarisation Payment Done')
							]))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$FillTemplate$Modal$styles.modalBodyContainer)
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$FillTemplate$Modal$styles.modalBody)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('Once document is completed by all parties, ' + 'document will be notarised on the blockchain.')
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$FillTemplate$Modal$styles.modalBtns)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Material$Styled$Button$button,
								_List_fromArray(
									[
										$author$project$Material$Styled$Button$theme($author$project$Material$Styled$Button$blue),
										$author$project$Material$Styled$Button$styles($author$project$Page$FillTemplate$Modal$styles.dashboardBtn),
										$author$project$Material$Styled$Button$onClick(
										$author$project$Types$OnFillTemplate(
											$author$project$Type$FillTemplate$OnAuth($author$project$Type$FillTemplate$OnNavigateToDashboard)))
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('Back To Dashboard')
									]))
							]))
					]))
			]));
};
var $author$project$Page$FillTemplate$Modal$notarizingDocumentModal = F2(
	function (docTitle, loadedModel) {
		return A2(
			$author$project$Material$Styled$Modal$modal,
			_List_fromArray(
				[
					$author$project$Material$Styled$Modal$open(true),
					$author$project$Material$Styled$Modal$contentContainerstyles($author$project$Page$FillTemplate$Modal$styles.modalContainer)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$FillTemplate$Modal$styles.modalHeader)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$FillTemplate$Modal$styles.modalHeaderTxt)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Notarizing Document: ' + docTitle)
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Material$Styled$ProgressBar$linear,
							_List_fromArray(
								[
									$author$project$Material$Styled$ProgressBar$containerStyle(
									_List_fromArray(
										[
											$rtfeldman$elm_css$Css$marginTop(
											$rtfeldman$elm_css$Css$px(10))
										]))
								]),
							_List_Nil)
						]))
				]));
	});
var $author$project$Page$FillTemplate$Modal$paymentModal = function (loadedModel) {
	return A2(
		$author$project$Material$Styled$Modal$modal,
		_List_fromArray(
			[
				$author$project$Material$Styled$Modal$open(true),
				$author$project$Material$Styled$Modal$contentContainerstyles($author$project$Page$FillTemplate$Modal$styles.modalContainer)
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$FillTemplate$Modal$styles.modalHeader)
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$FillTemplate$Modal$styles.modalHeaderTxt)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('ASA transfer transaction')
							]))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$FillTemplate$Modal$styles.walletAddress)
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								'Selected wallet address: ' + A2($elm$core$Maybe$withDefault, '', loadedModel.selectedWallet))
							]))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$FillTemplate$Modal$styles.buttonContainer)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Material$Styled$Button$button,
						_List_fromArray(
							[
								$author$project$Material$Styled$Button$theme($author$project$Material$Styled$Button$blue),
								$author$project$Material$Styled$Button$styles($author$project$Page$FillTemplate$Modal$styles.passwordButtons),
								$author$project$Material$Styled$Button$onClick(
								$author$project$Types$OnFillTemplate(
									$author$project$Type$FillTemplate$OnAuth(
										$author$project$Type$FillTemplate$OnLoaded($author$project$Type$FillTemplate$PaymentTransactionClick))))
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('Proceed to Pay')
							])),
						A2(
						$author$project$Material$Styled$Button$button,
						_List_fromArray(
							[
								$author$project$Material$Styled$Button$styles($author$project$Page$FillTemplate$Modal$styles.backToDashboardBtn),
								function () {
								var defaultTextTheme = $author$project$Material$Styled$Button$greyText;
								return $author$project$Material$Styled$Button$theme(
									_Utils_update(
										defaultTextTheme,
										{base: $author$project$Material$Styled$Color$grey200String}));
							}(),
								$author$project$Material$Styled$Button$onClick(
								$author$project$Types$OnFillTemplate(
									$author$project$Type$FillTemplate$OnAuth(
										$author$project$Type$FillTemplate$OnLoaded($author$project$Type$FillTemplate$OnCancelNotarisationClick))))
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('Cancel notarisation')
							]))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$FillTemplate$Modal$styles.walletErrorText)
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						A2($elm$core$Maybe$withDefault, '', loadedModel.optInError))
					]))
			]));
};
var $author$project$Type$FillTemplate$OnRequestTemplateClick = function (a) {
	return {$: 'OnRequestTemplateClick', a: a};
};
var $author$project$Page$FillTemplate$Modal$requestTemplateModal = F2(
	function (appModel, slug) {
		var fillTemplatePageLanguageData = appModel.languageSwitchModel.allLanguageData.location.viewTemplatePage;
		return A2(
			$author$project$Material$Styled$Modal$modal,
			_List_fromArray(
				[
					$author$project$Material$Styled$Modal$open(true),
					$author$project$Material$Styled$Modal$contentContainerstyles($author$project$Page$FillTemplate$Modal$styles.modalContainer)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$FillTemplate$Modal$styles.modalHeader)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$FillTemplate$Modal$styles.modalHeaderTxt)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(fillTemplatePageLanguageData.fillTemplateRequest)
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$img,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$FillTemplate$Modal$styles.icon),
									$rtfeldman$elm_css$Html$Styled$Attributes$src($author$project$View$Theme$images.close),
									$rtfeldman$elm_css$Html$Styled$Events$onClick(
									$author$project$Types$OnFillTemplate(
										$author$project$Type$FillTemplate$OnAuth(
											$author$project$Type$FillTemplate$OnViewTemplateInfo($author$project$Type$FillTemplate$OnCloseModal))))
								]),
							_List_Nil)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$FillTemplate$Modal$styles.modalBody)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(fillTemplatePageLanguageData.fillTemplateRequestText)
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$FillTemplate$Modal$styles.footer)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Material$Styled$Button$button,
							_List_fromArray(
								[
									$author$project$Material$Styled$Button$styles($author$project$Page$FillTemplate$Modal$styles.dashboardBtn),
									$author$project$Material$Styled$Button$theme($author$project$Material$Styled$Button$default),
									$author$project$Material$Styled$Button$onClick(
									$author$project$Types$OnFillTemplate(
										$author$project$Type$FillTemplate$OnAuth(
											$author$project$Type$FillTemplate$OnViewTemplateInfo($author$project$Type$FillTemplate$OnCloseModal))))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(fillTemplatePageLanguageData.back)
								])),
							A2(
							$author$project$Material$Styled$Button$button,
							_List_fromArray(
								[
									$author$project$Material$Styled$Button$styles($author$project$Page$FillTemplate$Modal$styles.dashboardBtn),
									$author$project$Material$Styled$Button$theme($author$project$Material$Styled$Button$blue),
									$author$project$Material$Styled$Button$onClick(
									$author$project$Types$OnFillTemplate(
										$author$project$Type$FillTemplate$OnAuth(
											$author$project$Type$FillTemplate$OnViewTemplateInfo(
												$author$project$Type$FillTemplate$OnRequestTemplateClick(slug)))))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(fillTemplatePageLanguageData.confirm)
								]))
						]))
				]));
	});
var $author$project$Page$FillTemplate$Modal$requestTemplateSuccess = F2(
	function (appModel, docId) {
		var languageData = appModel.languageSwitchModel.allLanguageData.location;
		return A2(
			$author$project$Material$Styled$Modal$modal,
			_List_fromArray(
				[
					$author$project$Material$Styled$Modal$open(true),
					$author$project$Material$Styled$Modal$contentContainerstyles($author$project$Page$FillTemplate$Modal$styles.modalContainer)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$FillTemplate$Modal$styles.modalHeader)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$FillTemplate$Modal$styles.modalHeaderTxt)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(languageData.uploadDocument.success)
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$img,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$FillTemplate$Modal$styles.icon),
									$rtfeldman$elm_css$Html$Styled$Attributes$src($author$project$View$Theme$images.close),
									$rtfeldman$elm_css$Html$Styled$Events$onClick(
									$author$project$Types$OnFillTemplate(
										$author$project$Type$FillTemplate$OnAuth(
											$author$project$Type$FillTemplate$OnViewTemplateInfo($author$project$Type$FillTemplate$OnCloseModal))))
								]),
							_List_Nil)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$FillTemplate$Modal$styles.modalBody)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('You can now sign the document from your incoming folder or access it from your email.')
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$FillTemplate$Modal$styles.footer)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Material$Styled$Button$button,
							_List_fromArray(
								[
									$author$project$Material$Styled$Button$theme($author$project$Material$Styled$Button$default),
									$author$project$Material$Styled$Button$styles($author$project$Page$FillTemplate$Modal$styles.dashboardBtn),
									$author$project$Material$Styled$Button$onClick(
									$author$project$Types$OnFillTemplate(
										$author$project$Type$FillTemplate$OnAuth($author$project$Type$FillTemplate$OnNavigateToDashboard)))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(languageData.viewTemplatePage.backToDashboard)
								])),
							A2(
							$author$project$Material$Styled$Button$button,
							_List_fromArray(
								[
									$author$project$Material$Styled$Button$theme($author$project$Material$Styled$Button$blue),
									$author$project$Material$Styled$Button$styles($author$project$Page$FillTemplate$Modal$styles.dashboardBtn),
									$author$project$Material$Styled$Button$onClick(
									$author$project$Types$OnFillTemplate(
										$author$project$Type$FillTemplate$OnAuth(
											$author$project$Type$FillTemplate$OnViewTemplateInfo(
												$author$project$Type$FillTemplate$OnRouteToViewDocument(docId)))))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Go to Document ')
								]))
						]))
				]));
	});
var $author$project$Type$FillTemplate$OnNavigateToRegister = {$: 'OnNavigateToRegister'};
var $author$project$Page$FillTemplate$Modal$signAnonymousSuccessModal = A2(
	$author$project$Material$Styled$Modal$modal,
	_List_fromArray(
		[
			$author$project$Material$Styled$Modal$open(true),
			$author$project$Material$Styled$Modal$contentContainerstyles($author$project$Page$FillTemplate$Modal$styles.modalContainer)
		]),
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$FillTemplate$Modal$styles.modalHeader)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$FillTemplate$Modal$styles.modalHeaderTxt)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('Signing Completed')
						]))
				])),
			A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$FillTemplate$Modal$styles.modalBodyContainer)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$FillTemplate$Modal$styles.modalBody)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('You have successfully fill the template. If you wish to view or download the document, you can register an account.')
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$FillTemplate$Modal$styles.modalBtns)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Material$Styled$Button$button,
							_List_fromArray(
								[
									$author$project$Material$Styled$Button$theme($author$project$Material$Styled$Button$blue),
									$author$project$Material$Styled$Button$styles($author$project$Page$FillTemplate$Modal$styles.dashboardBtn),
									$author$project$Material$Styled$Button$onClick(
									$author$project$Types$OnFillTemplate(
										$author$project$Type$FillTemplate$OnAuth($author$project$Type$FillTemplate$OnNavigateToRegister)))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Register Now')
								]))
						]))
				]))
		]));
var $author$project$Page$FillTemplate$Modal$view = F4(
	function (sessionModel, model, user, appModel) {
		var _v0 = model.modal;
		if (_v0.$ === 'Nothing') {
			return $rtfeldman$elm_css$Html$Styled$text('');
		} else {
			var modal = _v0.a;
			switch (modal.$) {
				case 'NeedPassword':
					return A2($author$project$Page$FillTemplate$Modal$needPasswordModal, model.password, model.passwordError);
				case 'Fill':
					return $author$project$Page$FillTemplate$Modal$fillModal(appModel);
				case 'Filling':
					return $author$project$Page$FillTemplate$Modal$fillingModal;
				case 'Success':
					switch (sessionModel.$) {
						case 'Auth':
							return A3($author$project$Page$FillTemplate$Modal$fillSuccessModal, model, user, appModel);
						case 'Anonymous':
							return $author$project$Page$FillTemplate$Modal$signAnonymousSuccessModal;
						case 'NoAuth':
							return $rtfeldman$elm_css$Html$Styled$text('');
						default:
							return $rtfeldman$elm_css$Html$Styled$text('');
					}
				case 'LoadingStatus':
					var status = modal.a;
					return $author$project$Page$FillTemplate$Modal$loadingModal(status);
				case 'DisplayWallet':
					var wallet = modal.a;
					return A2($author$project$Page$FillTemplate$Modal$displayWalletModal, wallet, model);
				case 'MakePayment':
					return $author$project$Page$FillTemplate$Modal$paymentModal(model);
				case 'NotariseSuccess':
					var notarisationNetwork = modal.a;
					return $author$project$Page$FillTemplate$Modal$notariseDocumentSuccess(notarisationNetwork);
				case 'CancelNotarisationSuccess':
					return $author$project$Page$FillTemplate$Modal$cancelNotarisationSuccessModal;
				case 'DisplayWalletAddress':
					var addresses = modal.a;
					return A2($author$project$Page$FillTemplate$Modal$displayWalletConnectAddressesModal, addresses, model);
				case 'NotarizingDocument':
					var title = modal.a;
					return A2($author$project$Page$FillTemplate$Modal$notarizingDocumentModal, title, model);
				case 'DeleteTemplate':
					var templateId = modal.a;
					return A2($author$project$Page$FillTemplate$Modal$deleteTemplateModal, templateId, appModel);
				case 'DeleteTemplateSuccess':
					return $author$project$Page$FillTemplate$Modal$deleteTemplateSuccess(appModel);
				case 'RequestTemplate':
					var slug = modal.a;
					return A2($author$project$Page$FillTemplate$Modal$requestTemplateModal, appModel, slug);
				case 'RequestTemplateSuccess':
					var docId = modal.a;
					return A2($author$project$Page$FillTemplate$Modal$requestTemplateSuccess, appModel, docId);
				default:
					return A2($author$project$Page$FillTemplate$Modal$activitiesModal, appModel, model.payload.templateLogData);
			}
		}
	});
var $author$project$Type$FillTemplate$OnEmailBlur = function (a) {
	return {$: 'OnEmailBlur', a: a};
};
var $author$project$Type$FillTemplate$OnEmailInput = function (a) {
	return {$: 'OnEmailInput', a: a};
};
var $author$project$Type$FillTemplate$OnSubmit = {$: 'OnSubmit'};
var $author$project$Page$FillTemplate$NoAuthModal$styles = {
	button: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(10)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(190))
		]),
	formError: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(16)),
			$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(14)),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$red900)
		]),
	inputContainer: _List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Css$margin2,
			$rtfeldman$elm_css$Css$em(1),
			$rtfeldman$elm_css$Css$zero)
		]),
	linkContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			A3(
				$rtfeldman$elm_css$Css$calc,
				$rtfeldman$elm_css$Css$pct(100),
				$rtfeldman$elm_css$Css$minus,
				$rtfeldman$elm_css$Css$px(48))),
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(16))
		]),
	modalBody: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(14)),
			$rtfeldman$elm_css$Css$fontWeight(
			$rtfeldman$elm_css$Css$int(400)),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$blueGrey500)
		]),
	modalBodyContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceBetween),
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$em(1)),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(60))
		]),
	modalBtns: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceBetween)
		]),
	modalContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$vw(70)),
			$rtfeldman$elm_css$Css$maxWidth(
			$rtfeldman$elm_css$Css$px(500)),
			$rtfeldman$elm_css$Css$minWidth(
			$rtfeldman$elm_css$Css$px(400))
		]),
	modalHeader: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$row),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$flexStart),
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceBetween)
		]),
	modalHeaderTxt: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(20)),
			$rtfeldman$elm_css$Css$fontWeight(
			$rtfeldman$elm_css$Css$int(500))
		])
};
var $author$project$Page$FillTemplate$NoAuthModal$displayFormError = function (formStatus) {
	if (formStatus.$ === 'Error') {
		var error = formStatus.a;
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$FillTemplate$NoAuthModal$styles.formError)
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text(error)
				]));
	} else {
		return $rtfeldman$elm_css$Html$Styled$text('');
	}
};
var $author$project$Page$FillTemplate$NoAuthModal$submitButton = function (noAuthModel) {
	var _v0 = noAuthModel.formStatus;
	switch (_v0.$) {
		case 'Ready':
			return (!_Utils_eq(noAuthModel.emailError, $elm$core$Maybe$Nothing)) ? $author$project$View$SubmitButton$disabled('Request For Form Link') : $author$project$View$SubmitButton$enabled('Request For Form Link');
		case 'Error':
			return $author$project$View$SubmitButton$enabled('Request For Form Link');
		case 'Submitting':
			return $author$project$View$SubmitButton$submitting('Requesting For Form Link...');
		default:
			return $author$project$View$SubmitButton$enabled('Request For Form Link');
	}
};
var $author$project$Page$FillTemplate$NoAuthModal$emailForm = function (noAuthModel) {
	var _v0 = noAuthModel;
	var email = _v0.email;
	var emailError = _v0.emailError;
	var formStatus = _v0.formStatus;
	return A2(
		$author$project$Material$Styled$Modal$modal,
		_List_fromArray(
			[
				$author$project$Material$Styled$Modal$open(true),
				$author$project$Material$Styled$Modal$contentContainerstyles($author$project$Page$FillTemplate$NoAuthModal$styles.modalContainer)
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$FillTemplate$NoAuthModal$styles.modalHeader)
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$FillTemplate$NoAuthModal$styles.modalHeaderTxt)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('Enter Email')
							]))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$FillTemplate$NoAuthModal$styles.modalBody)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('Please enter your email address to receive a link to fill up this form.')
							]))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$form,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Events$onSubmit(
						$author$project$Types$OnFillTemplate(
							$author$project$Type$FillTemplate$NoAuth($author$project$Type$FillTemplate$OnSubmit)))
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Material$Styled$Input$email,
						_List_fromArray(
							[
								$author$project$Material$Styled$Input$containerStyles($author$project$Page$FillTemplate$NoAuthModal$styles.inputContainer),
								$author$project$Material$Styled$Input$label('Email'),
								$author$project$Material$Styled$Input$value(
								A2($elm$core$Maybe$withDefault, '', email)),
								$author$project$Material$Styled$Input$errorMessage(emailError),
								$author$project$Material$Styled$Input$onInput(
								A2(
									$elm$core$Basics$composeL,
									A2($elm$core$Basics$composeL, $author$project$Types$OnFillTemplate, $author$project$Type$FillTemplate$NoAuth),
									$author$project$Type$FillTemplate$OnEmailInput)),
								$author$project$Material$Styled$Input$onBlur(
								$author$project$Types$OnFillTemplate(
									$author$project$Type$FillTemplate$NoAuth(
										$author$project$Type$FillTemplate$OnEmailBlur(
											A2($elm$core$Maybe$withDefault, '', email)))))
							]),
						_List_Nil),
						$author$project$Page$FillTemplate$NoAuthModal$displayFormError(formStatus),
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$FillTemplate$NoAuthModal$styles.modalBtns)
							]),
						_List_fromArray(
							[
								$author$project$Page$FillTemplate$NoAuthModal$submitButton(noAuthModel)
							])),
						A2($author$project$Material$Styled$Divider$divider, _List_Nil, _List_Nil)
					]))
			]));
};
var $author$project$Page$FillTemplate$NoAuthModal$success = A2(
	$author$project$Material$Styled$Modal$modal,
	_List_fromArray(
		[
			$author$project$Material$Styled$Modal$open(true),
			$author$project$Material$Styled$Modal$contentContainerstyles($author$project$Page$FillTemplate$NoAuthModal$styles.modalContainer)
		]),
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$FillTemplate$NoAuthModal$styles.modalHeader)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$FillTemplate$NoAuthModal$styles.modalHeaderTxt)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('View Document from Email')
						]))
				])),
			A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$FillTemplate$NoAuthModal$styles.modalBodyContainer)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$FillTemplate$NoAuthModal$styles.modalBody)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('The link to access the document has been successfully sent to your email.')
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$FillTemplate$NoAuthModal$styles.modalBody)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(' Please close this window and proceed to your email to view and sign the document.')
						]))
				]))
		]));
var $author$project$Page$FillTemplate$NoAuthModal$view = function (model) {
	var _v0 = model.formStatus;
	switch (_v0.$) {
		case 'Ready':
			return $author$project$Page$FillTemplate$NoAuthModal$emailForm(model);
		case 'Error':
			return $author$project$Page$FillTemplate$NoAuthModal$emailForm(model);
		case 'Submitting':
			return $author$project$Page$FillTemplate$NoAuthModal$emailForm(model);
		default:
			return $author$project$Page$FillTemplate$NoAuthModal$success;
	}
};
var $author$project$Material$Styled$Color$red700String = '#d32f2f';
var $author$project$Material$Styled$Color$red700 = $rtfeldman$elm_css$Css$hex($author$project$Material$Styled$Color$red700String);
var $author$project$View$PDFError$styles = {
	buttons: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100))
		]),
	card: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			A2(
			$rtfeldman$elm_css$Css$margin2,
			$rtfeldman$elm_css$Css$zero,
			$rtfeldman$elm_css$Css$px(20)),
			$rtfeldman$elm_css$Css$paddingBottom(
			$rtfeldman$elm_css$Css$px(40)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100)),
			$rtfeldman$elm_css$Css$maxWidth(
			$rtfeldman$elm_css$Css$px(600))
		]),
	container: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			A2(
			$rtfeldman$elm_css$Css$padding2,
			$rtfeldman$elm_css$Css$px(48),
			$rtfeldman$elm_css$Css$px(48))
		]),
	dashboardBtn: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$margin(
			$rtfeldman$elm_css$Css$px(10)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(190))
		]),
	header: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(24)),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$red700)
		]),
	refreshBtn: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$margin(
			$rtfeldman$elm_css$Css$px(10)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(190)),
			$rtfeldman$elm_css$Css$marginRight(
			$rtfeldman$elm_css$Css$px(10))
		]),
	textContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$padding(
			$rtfeldman$elm_css$Css$px(48)),
			$rtfeldman$elm_css$Css$width(
			A3(
				$rtfeldman$elm_css$Css$calc,
				$rtfeldman$elm_css$Css$pct(100),
				$rtfeldman$elm_css$Css$minus,
				$rtfeldman$elm_css$Css$px(48))),
			$rtfeldman$elm_css$Css$boxSizing($rtfeldman$elm_css$Css$borderBox),
			A3(
			$rtfeldman$elm_css$Css$borderTop3,
			$rtfeldman$elm_css$Css$px(1),
			$rtfeldman$elm_css$Css$solid,
			$author$project$Material$Styled$Color$grey200),
			$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(24)),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$blueGrey900)
		])
};
var $author$project$View$PDFError$view = F4(
	function (title, message, dashboardClickMsg, refreshClick) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$PDFError$styles.container)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Material$Styled$Card$card,
					_List_fromArray(
						[
							$author$project$Material$Styled$Card$containerStyles($author$project$View$PDFError$styles.card)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$h2,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$PDFError$styles.header)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(title)
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$PDFError$styles.textContainer)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(message)
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$PDFError$styles.buttons)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Material$Styled$Button$button,
									_List_fromArray(
										[
											$author$project$Material$Styled$Button$theme($author$project$Material$Styled$Button$blue),
											$author$project$Material$Styled$Button$styles($author$project$View$PDFError$styles.dashboardBtn),
											$author$project$Material$Styled$Button$onClick(dashboardClickMsg)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('Back To Dashboard')
										])),
									A2(
									$author$project$Material$Styled$Button$button,
									_List_fromArray(
										[
											$author$project$Material$Styled$Button$theme($author$project$Material$Styled$Button$default),
											$author$project$Material$Styled$Button$styles($author$project$View$PDFError$styles.refreshBtn),
											$author$project$Material$Styled$Button$onClick(refreshClick)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('Refresh')
										]))
								]))
						]))
				]));
	});
var $author$project$Page$FillTemplate$view = F2(
	function (sessionModel, appModel) {
		var refreshClick = $author$project$Types$OnFillTemplate(
			$author$project$Type$FillTemplate$OnAuth($author$project$Type$FillTemplate$OnRefreshClick));
		var dashboardClickMsg = $author$project$Types$OnFillTemplate(
			$author$project$Type$FillTemplate$OnAuth($author$project$Type$FillTemplate$OnNavigateToDashboard));
		var documentStatus = F3(
			function (fillTemplateModel, signatureModel, user) {
				switch (fillTemplateModel.$) {
					case 'NotLoaded':
						return A2(
							$author$project$View$Loading$view,
							'Can\'t Load The Document',
							$elm$core$Maybe$Just('Please contact the sender of the document for more information.'));
					case 'Loading':
						return A2($author$project$View$Loading$view, 'Loading Your Template', $elm$core$Maybe$Nothing);
					case 'LoadingApiError':
						var error = fillTemplateModel.a;
						return A4(
							$author$project$View$PDFError$view,
							'Template Error',
							A2($author$project$Data$Api$authErrorToString, $author$project$Data$Api$PDF$ViewTemplate$errorToString, error),
							dashboardClickMsg,
							refreshClick);
					case 'LoadingDecodeError':
						var errorMessage = fillTemplateModel.a;
						return A4($author$project$View$PDFError$view, 'Template Error', errorMessage, dashboardClickMsg, refreshClick);
					case 'LoadingSignatureError':
						return A4($author$project$View$PDFError$view, 'Template Error', 'Fail to load template signature', dashboardClickMsg, refreshClick);
					case 'Loaded':
						var loadedModel = fillTemplateModel.a;
						return A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$FillTemplate$styles.container)
								]),
							_List_fromArray(
								[
									A2(
									$elm$core$Maybe$withDefault,
									$rtfeldman$elm_css$Html$Styled$text(''),
									A2($elm$core$Maybe$map, $author$project$Page$FillTemplate$ErrorBanner$view, loadedModel.error)),
									A2($author$project$View$Pdftron$view, true, false),
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$FillTemplate$styles.sidebar)
										]),
									_List_fromArray(
										[
											A3($author$project$Page$FillTemplate$addRecipientBox, loadedModel, user, appModel),
											A5($author$project$Page$FillTemplate$advanceOptions, loadedModel, user, appModel.currentTime, appModel.timezone, appModel.languageSwitchModel),
											$author$project$Page$FillTemplate$submitBtn(appModel)
										])),
									A4($author$project$Page$FillTemplate$Modal$view, sessionModel, loadedModel, user, appModel)
								]));
					case 'VerificationError':
						var error = fillTemplateModel.a;
						if (error.$ === 'NotTokenUser') {
							return $author$project$View$PDFTokenError$notTokenUser(
								$author$project$Types$OnFillTemplate(
									$author$project$Type$FillTemplate$OnAuth($author$project$Type$FillTemplate$OnNavigateToDashboard)));
						} else {
							return $author$project$View$PDFTokenError$invalidToken(
								$author$project$Types$OnFillTemplate(
									$author$project$Type$FillTemplate$OnAuth($author$project$Type$FillTemplate$OnNavigateToDashboard)));
						}
					case 'ViewTemplate':
						var loadedModel = fillTemplateModel.a;
						return A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$FillTemplate$styles.container)
								]),
							_List_fromArray(
								[
									A2(
									$elm$core$Maybe$withDefault,
									$rtfeldman$elm_css$Html$Styled$text(''),
									A2($elm$core$Maybe$map, $author$project$Page$FillTemplate$ErrorBanner$view, loadedModel.error)),
									A2($author$project$View$Pdftron$view, true, false),
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$FillTemplate$styles.sidebar)
										]),
									_List_fromArray(
										[
											A3($author$project$Page$FillTemplate$templateDetails, loadedModel, appModel, user),
											A3($author$project$Page$FillTemplate$statusContent, loadedModel, appModel, user)
										])),
									A4($author$project$Page$FillTemplate$Modal$view, sessionModel, loadedModel, user, appModel)
								]));
					default:
						return $rtfeldman$elm_css$Html$Styled$text('');
				}
			});
		switch (sessionModel.$) {
			case 'Anonymous':
				var fillTemplateModel = sessionModel.a.fillTemplateModel;
				var signatureModel = sessionModel.a.signatureModel;
				var user = sessionModel.a.user;
				return A3(documentStatus, fillTemplateModel, signatureModel, user);
			case 'Auth':
				var fillTemplateModel = sessionModel.a.fillTemplateModel;
				var signatureModel = sessionModel.a.signatureModel;
				var user = sessionModel.a.user;
				return A3(documentStatus, fillTemplateModel, signatureModel, user);
			case 'NoAuth':
				var _v1 = appModel.fillTemplateModel;
				switch (_v1.$) {
					case 'NotLoaded':
						return A2(
							$author$project$View$Loading$view,
							'Can\'t Load The Document',
							$elm$core$Maybe$Just('Please contact the sender of the document for more information.'));
					case 'Loading':
						return A2($author$project$View$Loading$view, 'Loading Your Template', $elm$core$Maybe$Nothing);
					case 'LoadingApiError':
						var error = _v1.a;
						return A4(
							$author$project$View$PDFError$view,
							'Template Error',
							A2($author$project$Data$Api$authErrorToString, $author$project$Data$Api$PDF$ViewTemplate$errorToString, error),
							dashboardClickMsg,
							refreshClick);
					case 'NoAuthLoaded':
						var noAuthModel = _v1.a;
						return $author$project$Page$FillTemplate$NoAuthModal$view(noAuthModel);
					case 'VerificationError':
						var error = _v1.a;
						if (error.$ === 'NotTokenUser') {
							return $rtfeldman$elm_css$Html$Styled$text('');
						} else {
							return $author$project$View$PDFTokenError$invalidToken(
								$author$project$Types$OnFillTemplate($author$project$Type$FillTemplate$OnNavigateToHomepage));
						}
					case 'LoadingDecodeError':
						return $rtfeldman$elm_css$Html$Styled$text('');
					case 'LoadingSignatureError':
						return $rtfeldman$elm_css$Html$Styled$text('');
					case 'Loaded':
						return $rtfeldman$elm_css$Html$Styled$text('');
					default:
						return $rtfeldman$elm_css$Html$Styled$text('');
				}
			default:
				return $rtfeldman$elm_css$Html$Styled$text('');
		}
	});
var $author$project$Type$ListDocument$OnNextPage = function (a) {
	return {$: 'OnNextPage', a: a};
};
var $author$project$Type$ListDocument$OnPreviousPage = function (a) {
	return {$: 'OnPreviousPage', a: a};
};
var $author$project$Data$Date$monthToInt = function (month) {
	switch (month.$) {
		case 'Jan':
			return 1;
		case 'Feb':
			return 2;
		case 'Mar':
			return 3;
		case 'Apr':
			return 4;
		case 'May':
			return 5;
		case 'Jun':
			return 6;
		case 'Jul':
			return 7;
		case 'Aug':
			return 8;
		case 'Sep':
			return 9;
		case 'Oct':
			return 10;
		case 'Nov':
			return 11;
		default:
			return 12;
	}
};
var $author$project$Page$ListDocument$noDocSubTitle = 'Your completed documents will be stored here.';
var $author$project$Page$ListDocument$noDocTitle = 'No Documents Yet';
var $author$project$Page$ListDocument$noSearchResultSubTitle = 'There are no documents that match your search. ';
var $author$project$Page$ListDocument$noSearchResultTitle = 'No Documents Found';
var $author$project$Page$ListDocument$styles = {
	adsContainer: _List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Css$Media$withMediaQuery,
			_List_fromArray(
				['screen and (min-width: 1200px)']),
			_List_fromArray(
				[
					A4(
					$rtfeldman$elm_css$Css$padding4,
					$rtfeldman$elm_css$Css$px(10),
					$rtfeldman$elm_css$Css$px(280),
					$rtfeldman$elm_css$Css$px(10),
					$rtfeldman$elm_css$Css$px(280))
				]))
		]),
	arrowBtnContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$row),
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$flexEnd),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$padding(
			$rtfeldman$elm_css$Css$px(10))
		]),
	button: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(50)),
			A2(
			$rtfeldman$elm_css$Css$padding2,
			$rtfeldman$elm_css$Css$px(10),
			$rtfeldman$elm_css$Css$px(10)),
			$rtfeldman$elm_css$Css$marginRight(
			$rtfeldman$elm_css$Css$px(5))
		]),
	cardContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(15))
		]),
	container: _List_fromArray(
		[
			A3(
			$rtfeldman$elm_css$Css$margin3,
			$rtfeldman$elm_css$Css$px(10),
			$rtfeldman$elm_css$Css$px(30),
			$rtfeldman$elm_css$Css$zero),
			$rtfeldman$elm_css$Css$minWidth(
			$rtfeldman$elm_css$Css$px(600))
		]),
	divider: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100)),
			$rtfeldman$elm_css$Css$backgroundColor($author$project$Material$Styled$Color$grey300)
		])
};
var $author$project$Type$ListDocument$DeleteDocument = function (a) {
	return {$: 'DeleteDocument', a: a};
};
var $author$project$Type$ListDocument$OnDocumentClick = function (a) {
	return {$: 'OnDocumentClick', a: a};
};
var $author$project$Type$ListDocument$OnShowModal = function (a) {
	return {$: 'OnShowModal', a: a};
};
var $author$project$Page$ListDocument$Completed$toMonthString = function (month) {
	switch (month.$) {
		case 'Jan':
			return 'Jan';
		case 'Feb':
			return 'Feb';
		case 'Mar':
			return 'Mar';
		case 'Apr':
			return 'Apr';
		case 'May':
			return 'May';
		case 'Jun':
			return 'Jun';
		case 'Jul':
			return 'Jul';
		case 'Aug':
			return 'Aug';
		case 'Sep':
			return 'Sep';
		case 'Oct':
			return 'Oct';
		case 'Nov':
			return 'Nov';
		default:
			return 'Dec';
	}
};
var $author$project$Page$ListDocument$Completed$getDate = function (posix) {
	return $elm$core$String$fromInt(
		A2($elm$time$Time$toDay, $elm$time$Time$utc, posix)) + (' ' + ($author$project$Page$ListDocument$Completed$toMonthString(
		A2($elm$time$Time$toMonth, $elm$time$Time$utc, posix)) + (' ' + $elm$core$String$fromInt(
		A2($elm$time$Time$toYear, $elm$time$Time$utc, posix)))));
};
var $author$project$Page$ListDocument$Completed$renderNames = function (names) {
	return $elm$core$List$isEmpty(names) ? $rtfeldman$elm_css$Html$Styled$text('-') : $rtfeldman$elm_css$Html$Styled$text(
		A2($elm$core$String$join, ', ', names));
};
var $author$project$Material$Styled$Color$grey700String = '#616161';
var $author$project$Material$Styled$Color$grey700 = $rtfeldman$elm_css$Css$hex($author$project$Material$Styled$Color$grey700String);
var $author$project$Page$ListDocument$Completed$styles = {
	actorContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column)
		]),
	arrow: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100)),
			$rtfeldman$elm_css$Css$maxWidth(
			$rtfeldman$elm_css$Css$px(50))
		]),
	boldText: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontWeight(
			$rtfeldman$elm_css$Css$int(500))
		]),
	closeBtnContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceBetween),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$padding(
			$rtfeldman$elm_css$Css$px(10)),
			$rtfeldman$elm_css$Css$displayFlex
		]),
	container: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer)
		]),
	content: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceBetween),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$padding(
			$rtfeldman$elm_css$Css$px(10)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100)),
			$rtfeldman$elm_css$Css$hover(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$backgroundColor($author$project$Material$Styled$Color$grey200)
				]))
		]),
	disabledIcon: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginRight(
			$rtfeldman$elm_css$Css$px(10)),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(25)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(40)),
			$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$default)
		]),
	element: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100)),
			$rtfeldman$elm_css$Css$maxWidth(
			$rtfeldman$elm_css$Css$px(250))
		]),
	ellipsis: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$whiteSpace($rtfeldman$elm_css$Css$noWrap),
			$rtfeldman$elm_css$Css$overflow($rtfeldman$elm_css$Css$hidden),
			$rtfeldman$elm_css$Css$textOverflow($rtfeldman$elm_css$Css$ellipsis)
		]),
	icon: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginRight(
			$rtfeldman$elm_css$Css$px(10)),
			$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(25)),
			$rtfeldman$elm_css$Css$hover(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$backgroundColor($author$project$Material$Styled$Color$grey200),
					$rtfeldman$elm_css$Css$borderRadius(
					$rtfeldman$elm_css$Css$pct(100))
				])),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(40)),
			$rtfeldman$elm_css$Css$active(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$backgroundColor($author$project$Material$Styled$Color$grey100),
					$rtfeldman$elm_css$Css$backgroundSize(
					$rtfeldman$elm_css$Css$pct(100)),
					$rtfeldman$elm_css$Css$Transitions$transition(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$Transitions$background(0)
						]))
				]))
		]),
	nameContainer: _List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Css$margin2,
			$rtfeldman$elm_css$Css$px(5),
			$rtfeldman$elm_css$Css$zero)
		]),
	outerContainer: _List_fromArray(
		[$rtfeldman$elm_css$Css$displayFlex]),
	secondaryText: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(12)),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$grey700)
		])
};
var $author$project$Page$ListDocument$Completed$view = F3(
	function (languageSwitchModel, user, document) {
		var listDocumentLanguageData = languageSwitchModel.allLanguageData.location.listDocumentsPage;
		return A2(
			$author$project$Material$Styled$Card$card,
			_List_fromArray(
				[
					$author$project$Material$Styled$Card$containerStyles($author$project$Page$ListDocument$Completed$styles.container)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ListDocument$Completed$styles.outerContainer)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ListDocument$Completed$styles.content),
									$rtfeldman$elm_css$Html$Styled$Events$onClick(
									$author$project$Types$OnAuth(
										$author$project$Types$OnListDoc(
											$author$project$Type$ListDocument$OnDocumentClick(document.id)))),
									A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'data-test', 'Completed Documents')
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css(
											_Utils_ap(
												$author$project$Page$ListDocument$Completed$styles.boldText,
												_Utils_ap($author$project$Page$ListDocument$Completed$styles.element, $author$project$Page$ListDocument$Completed$styles.ellipsis)))
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(document.title)
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css(
											_Utils_ap($author$project$Page$ListDocument$Completed$styles.actorContainer, $author$project$Page$ListDocument$Completed$styles.element))
										]),
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$span,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$css(
													_Utils_ap(
														$author$project$Page$ListDocument$Completed$styles.nameContainer,
														_Utils_ap($author$project$Page$ListDocument$Completed$styles.boldText, $author$project$Page$ListDocument$Completed$styles.ellipsis)))
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(document.ownerName)
												])),
											A2(
											$rtfeldman$elm_css$Html$Styled$span,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$css(
													_Utils_ap($author$project$Page$ListDocument$Completed$styles.nameContainer, $author$project$Page$ListDocument$Completed$styles.secondaryText))
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(listDocumentLanguageData.sender)
												]))
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css(
											_Utils_ap($author$project$Page$ListDocument$Completed$styles.actorContainer, $author$project$Page$ListDocument$Completed$styles.element))
										]),
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$span,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$css(
													_Utils_ap(
														$author$project$Page$ListDocument$Completed$styles.nameContainer,
														_Utils_ap($author$project$Page$ListDocument$Completed$styles.boldText, $author$project$Page$ListDocument$Completed$styles.ellipsis)))
												]),
											_List_fromArray(
												[
													$author$project$Page$ListDocument$Completed$renderNames(document.signers)
												])),
											A2(
											$rtfeldman$elm_css$Html$Styled$span,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$css(
													_Utils_ap($author$project$Page$ListDocument$Completed$styles.nameContainer, $author$project$Page$ListDocument$Completed$styles.secondaryText))
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(listDocumentLanguageData.signers)
												]))
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css(
											_Utils_ap($author$project$Page$ListDocument$Completed$styles.actorContainer, $author$project$Page$ListDocument$Completed$styles.element))
										]),
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$span,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$css(
													_Utils_ap(
														$author$project$Page$ListDocument$Completed$styles.nameContainer,
														_Utils_ap($author$project$Page$ListDocument$Completed$styles.boldText, $author$project$Page$ListDocument$Completed$styles.ellipsis)))
												]),
											_List_fromArray(
												[
													$author$project$Page$ListDocument$Completed$renderNames(document.viewers)
												])),
											A2(
											$rtfeldman$elm_css$Html$Styled$span,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$css(
													_Utils_ap($author$project$Page$ListDocument$Completed$styles.nameContainer, $author$project$Page$ListDocument$Completed$styles.secondaryText))
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(listDocumentLanguageData.viewers)
												]))
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ListDocument$Completed$styles.actorContainer)
										]),
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$span,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$css(
													_Utils_ap($author$project$Page$ListDocument$Completed$styles.nameContainer, $author$project$Page$ListDocument$Completed$styles.boldText))
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(
													$author$project$Page$ListDocument$Completed$getDate(document.updatedAt))
												])),
											A2(
											$rtfeldman$elm_css$Html$Styled$span,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$css(
													_Utils_ap($author$project$Page$ListDocument$Completed$styles.nameContainer, $author$project$Page$ListDocument$Completed$styles.secondaryText))
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(listDocumentLanguageData.dateCompleted)
												]))
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ListDocument$Completed$styles.arrow)
										]),
									_List_fromArray(
										[
											A2($author$project$Material$Styled$Icon$arrowRight, _List_Nil, _List_Nil)
										]))
								])),
							_Utils_eq(document.ownerId, user.id) ? A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ListDocument$Completed$styles.closeBtnContainer)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Material$Styled$Icon$delete,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Svg$Styled$Attributes$css($author$project$Page$ListDocument$Completed$styles.icon),
											$rtfeldman$elm_css$Svg$Styled$Events$onClick(
											$author$project$Types$OnAuth(
												$author$project$Types$OnListDoc(
													$author$project$Type$ListDocument$OnShowModal(
														$author$project$Type$ListDocument$DeleteDocument(document.id)))))
										]),
									_List_Nil)
								])) : A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ListDocument$Completed$styles.closeBtnContainer)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Material$Styled$Icon$delete,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Svg$Styled$Attributes$css($author$project$Page$ListDocument$Completed$styles.disabledIcon),
											$rtfeldman$elm_css$Svg$Styled$Attributes$fill('grey')
										]),
									_List_Nil)
								]))
						]))
				]));
	});
var $rtfeldman$elm_css$Css$outline3 = $rtfeldman$elm_css$Css$prop3('outline');
var $author$project$Page$ListDocument$EmptyDocument$styles = {
	button: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(40)),
			A3(
			$rtfeldman$elm_css$Css$outline3,
			$rtfeldman$elm_css$Css$px(1),
			$rtfeldman$elm_css$Css$solid,
			$author$project$Material$Styled$Color$blueA700),
			$rtfeldman$elm_css$Css$focus(
			_List_fromArray(
				[
					A3(
					$rtfeldman$elm_css$Css$outline3,
					$rtfeldman$elm_css$Css$px(1),
					$rtfeldman$elm_css$Css$solid,
					$author$project$Material$Styled$Color$blueA700)
				]))
		]),
	container: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(40))
		]),
	header: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$grey400),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(35))
		]),
	image: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(560)),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(300))
		]),
	item: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$paddingTop(
			$rtfeldman$elm_css$Css$px(40))
		]),
	subHeader: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$grey400),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(14))
		])
};
var $rtfeldman$elm_css$Svg$Styled$circle = $rtfeldman$elm_css$Svg$Styled$node('circle');
var $rtfeldman$elm_css$Svg$Styled$Attributes$cx = $rtfeldman$elm_css$VirtualDom$Styled$attribute('cx');
var $rtfeldman$elm_css$Svg$Styled$Attributes$cy = $rtfeldman$elm_css$VirtualDom$Styled$attribute('cy');
var $rtfeldman$elm_css$Svg$Styled$ellipse = $rtfeldman$elm_css$Svg$Styled$node('ellipse');
var $rtfeldman$elm_css$Svg$Styled$Attributes$opacity = $rtfeldman$elm_css$VirtualDom$Styled$attribute('opacity');
var $rtfeldman$elm_css$Svg$Styled$Attributes$r = $rtfeldman$elm_css$VirtualDom$Styled$attribute('r');
var $rtfeldman$elm_css$Svg$Styled$Attributes$rx = $rtfeldman$elm_css$VirtualDom$Styled$attribute('rx');
var $rtfeldman$elm_css$Svg$Styled$Attributes$ry = $rtfeldman$elm_css$VirtualDom$Styled$attribute('ry');
var $rtfeldman$elm_css$Svg$Styled$Attributes$transform = $rtfeldman$elm_css$VirtualDom$Styled$attribute('transform');
var $author$project$Page$ListDocument$EmptyDocumentSvg$view = F2(
	function (attributes, children) {
		return A2(
			$rtfeldman$elm_css$Svg$Styled$svg,
			_Utils_ap(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Svg$Styled$Attributes$fill('black'),
						$rtfeldman$elm_css$Svg$Styled$Attributes$width('797.5px'),
						$rtfeldman$elm_css$Svg$Styled$Attributes$height('834.5px'),
						$rtfeldman$elm_css$Svg$Styled$Attributes$viewBox('0 0 797.5 834.5')
					]),
				attributes),
			_Utils_ap(
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Svg$Styled$ellipse,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Svg$Styled$Attributes$cx('308.5'),
								$rtfeldman$elm_css$Svg$Styled$Attributes$cy('780'),
								$rtfeldman$elm_css$Svg$Styled$Attributes$rx('308.5'),
								$rtfeldman$elm_css$Svg$Styled$Attributes$ry('54.5'),
								$rtfeldman$elm_css$Svg$Styled$Attributes$fill('#3f3d56')
							]),
						_List_Nil),
						A2(
						$rtfeldman$elm_css$Svg$Styled$circle,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Svg$Styled$Attributes$cx('496'),
								$rtfeldman$elm_css$Svg$Styled$Attributes$cy('301.5'),
								$rtfeldman$elm_css$Svg$Styled$Attributes$r('301.5'),
								$rtfeldman$elm_css$Svg$Styled$Attributes$fill('#3f3d56')
							]),
						_List_Nil),
						A2(
						$rtfeldman$elm_css$Svg$Styled$circle,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Svg$Styled$Attributes$cx('496'),
								$rtfeldman$elm_css$Svg$Styled$Attributes$cy('301.5'),
								$rtfeldman$elm_css$Svg$Styled$Attributes$r('248.89787'),
								$rtfeldman$elm_css$Svg$Styled$Attributes$opacity('0.05')
							]),
						_List_Nil),
						A2(
						$rtfeldman$elm_css$Svg$Styled$circle,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Svg$Styled$Attributes$cx('496'),
								$rtfeldman$elm_css$Svg$Styled$Attributes$cy('301.5'),
								$rtfeldman$elm_css$Svg$Styled$Attributes$r('203.99362'),
								$rtfeldman$elm_css$Svg$Styled$Attributes$opacity('0.05')
							]),
						_List_Nil),
						A2(
						$rtfeldman$elm_css$Svg$Styled$circle,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Svg$Styled$Attributes$cx('496'),
								$rtfeldman$elm_css$Svg$Styled$Attributes$cy('301.5'),
								$rtfeldman$elm_css$Svg$Styled$Attributes$r('146.25957'),
								$rtfeldman$elm_css$Svg$Styled$Attributes$opacity('0.05')
							]),
						_List_Nil),
						A2(
						$rtfeldman$elm_css$Svg$Styled$path,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Svg$Styled$Attributes$d('M398.42029,361.23224s-23.70394,66.72221-13.16886,90.42615,27.21564,46.52995,27.21564,46.52995S406.3216,365.62186,398.42029,361.23224Z'),
								$rtfeldman$elm_css$Svg$Styled$Attributes$transform('translate(-201.25 -32.75)'),
								$rtfeldman$elm_css$Svg$Styled$Attributes$fill('#d0cde1')
							]),
						_List_Nil),
						A2(
						$rtfeldman$elm_css$Svg$Styled$path,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Svg$Styled$Attributes$d('M398.42029,361.23224s-23.70394,66.72221-13.16886,90.42615,27.21564,46.52995,27.21564,46.52995S406.3216,365.62186,398.42029,361.23224Z'),
								$rtfeldman$elm_css$Svg$Styled$Attributes$transform('translate(-201.25 -32.75)'),
								$rtfeldman$elm_css$Svg$Styled$Attributes$opacity('0.1')
							]),
						_List_Nil),
						A2(
						$rtfeldman$elm_css$Svg$Styled$path,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Svg$Styled$Attributes$d('M415.10084,515.74682s-1.75585,16.68055-2.63377,17.55847.87792,2.63377,0,5.26754-1.75585,6.14547,0,7.02339-9.65716,78.13521-9.65716,78.13521-28.09356,36.8728-16.68055,94.81576l3.51169,58.82089s27.21564,1.75585,27.21564-7.90132c0,0-1.75585-11.413-1.75585-16.68055s4.38962-5.26754,1.75585-7.90131-2.63377-4.38962-2.63377-4.38962,4.38961-3.51169,3.51169-4.38962,7.90131-63.2105,7.90131-63.2105,9.65716-9.65716,9.65716-14.92471v-5.26754s4.38962-11.413,4.38962-12.29093,23.70394-54.43127,23.70394-54.43127l9.65716,38.62864,10.53509,55.3092s5.26754,50.04165,15.80262,69.356c0,0,18.4364,63.21051,18.4364,61.45466s30.72733-6.14547,29.84941-14.04678-18.4364-118.5197-18.4364-118.5197L533.62054,513.991Z'),
								$rtfeldman$elm_css$Svg$Styled$Attributes$transform('translate(-201.25 -32.75)'),
								$rtfeldman$elm_css$Svg$Styled$Attributes$fill('#2f2e41')
							]),
						_List_Nil),
						A2(
						$rtfeldman$elm_css$Svg$Styled$path,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Svg$Styled$Attributes$d('M391.3969,772.97846s-23.70394,46.53-7.90131,48.2858,21.94809,1.75585,28.97148-5.26754c3.83968-3.83968,11.61528-8.99134,17.87566-12.87285a23.117,23.117,0,0,0,10.96893-21.98175c-.463-4.29531-2.06792-7.83444-6.01858-8.16366-10.53508-.87792-22.826-10.53508-22.826-10.53508Z'),
								$rtfeldman$elm_css$Svg$Styled$Attributes$transform('translate(-201.25 -32.75)'),
								$rtfeldman$elm_css$Svg$Styled$Attributes$fill('#2f2e41')
							]),
						_List_Nil),
						A2(
						$rtfeldman$elm_css$Svg$Styled$path,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Svg$Styled$Attributes$d('M522.20753,807.21748s-23.70394,46.53-7.90131,48.28581,21.94809,1.75584,28.97148-5.26754c3.83968-3.83969,11.61528-8.99134,17.87566-12.87285a23.117,23.117,0,0,0,10.96893-21.98175c-.463-4.29531-2.06792-7.83444-6.01857-8.16367-10.53509-.87792-22.826-10.53508-22.826-10.53508Z'),
								$rtfeldman$elm_css$Svg$Styled$Attributes$transform('translate(-201.25 -32.75)'),
								$rtfeldman$elm_css$Svg$Styled$Attributes$fill('#2f2e41')
							]),
						_List_Nil),
						A2(
						$rtfeldman$elm_css$Svg$Styled$circle,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Svg$Styled$Attributes$cx('295.90488'),
								$rtfeldman$elm_css$Svg$Styled$Attributes$cy('215.43252'),
								$rtfeldman$elm_css$Svg$Styled$Attributes$r('36.90462'),
								$rtfeldman$elm_css$Svg$Styled$Attributes$fill('#ffb8b8')
							]),
						_List_Nil),
						A2(
						$rtfeldman$elm_css$Svg$Styled$path,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Svg$Styled$Attributes$d('M473.43048,260.30832S447.07,308.81154,444.9612,308.81154,492.41,324.62781,492.41,324.62781s13.70743-46.39439,15.81626-50.61206Z'),
								$rtfeldman$elm_css$Svg$Styled$Attributes$transform('translate(-201.25 -32.75)'),
								$rtfeldman$elm_css$Svg$Styled$Attributes$fill('#ffb8b8')
							]),
						_List_Nil),
						A2(
						$rtfeldman$elm_css$Svg$Styled$path,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Svg$Styled$Attributes$d('M513.86726,313.3854s-52.67543-28.97148-57.943-28.09356-61.45466,50.04166-60.57673,70.2339,7.90131,53.55335,7.90131,53.55335,2.63377,93.05991,7.90131,93.93783-.87792,16.68055.87793,16.68055,122.90931,0,123.78724-2.63377S513.86726,313.3854,513.86726,313.3854Z'),
								$rtfeldman$elm_css$Svg$Styled$Attributes$transform('translate(-201.25 -32.75)'),
								$rtfeldman$elm_css$Svg$Styled$Attributes$fill('#d0cde1')
							]),
						_List_Nil),
						A2(
						$rtfeldman$elm_css$Svg$Styled$path,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Svg$Styled$Attributes$d('M543.2777,521.89228s16.68055,50.91958,2.63377,49.16373-20.19224-43.89619-20.19224-43.89619Z'),
								$rtfeldman$elm_css$Svg$Styled$Attributes$transform('translate(-201.25 -32.75)'),
								$rtfeldman$elm_css$Svg$Styled$Attributes$fill('#ffb8b8')
							]),
						_List_Nil),
						A2(
						$rtfeldman$elm_css$Svg$Styled$path,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Svg$Styled$Attributes$d('M498.50359,310.31267s-32.48318,7.02339-27.21563,50.91957,14.9247,87.79237,14.9247,87.79237l32.48318,71.11182,3.51169,13.16886,23.70394-6.14547L528.353,425.32067s-6.14547-108.86253-14.04678-112.37423A33.99966,33.99966,0,0,0,498.50359,310.31267Z'),
								$rtfeldman$elm_css$Svg$Styled$Attributes$transform('translate(-201.25 -32.75)'),
								$rtfeldman$elm_css$Svg$Styled$Attributes$fill('#d0cde1')
							]),
						_List_Nil),
						A2(
						$rtfeldman$elm_css$Svg$Styled$polygon,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Svg$Styled$Attributes$points('277.5 414.958 317.885 486.947 283.86 411.09 277.5 414.958'),
								$rtfeldman$elm_css$Svg$Styled$Attributes$opacity('0.1')
							]),
						_List_Nil),
						A2(
						$rtfeldman$elm_css$Svg$Styled$path,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Svg$Styled$Attributes$d('M533.896,237.31585l.122-2.82012,5.6101,1.39632a6.26971,6.26971,0,0,0-2.5138-4.61513l5.97581-.33413a64.47667,64.47667,0,0,0-43.1245-26.65136c-12.92583-1.87346-27.31837.83756-36.182,10.43045-4.29926,4.653-7.00067,10.57018-8.92232,16.60685-3.53926,11.11821-4.26038,24.3719,3.11964,33.40938,7.5006,9.18513,20.602,10.98439,32.40592,12.12114,4.15328.4,8.50581.77216,12.35457-.83928a29.721,29.721,0,0,0-1.6539-13.03688,8.68665,8.68665,0,0,1-.87879-4.15246c.5247-3.51164,5.20884-4.39635,8.72762-3.9219s7.74984,1.20031,10.062-1.49432c1.59261-1.85609,1.49867-4.559,1.70967-6.99575C521.28248,239.785,533.83587,238.70653,533.896,237.31585Z'),
								$rtfeldman$elm_css$Svg$Styled$Attributes$transform('translate(-201.25 -32.75)'),
								$rtfeldman$elm_css$Svg$Styled$Attributes$fill('#2f2e41')
							]),
						_List_Nil),
						A2(
						$rtfeldman$elm_css$Svg$Styled$circle,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Svg$Styled$Attributes$cx('559'),
								$rtfeldman$elm_css$Svg$Styled$Attributes$cy('744.5'),
								$rtfeldman$elm_css$Svg$Styled$Attributes$r('43'),
								$rtfeldman$elm_css$Svg$Styled$Attributes$fill('#2962ff')
							]),
						_List_Nil),
						A2(
						$rtfeldman$elm_css$Svg$Styled$circle,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Svg$Styled$Attributes$cx('54'),
								$rtfeldman$elm_css$Svg$Styled$Attributes$cy('729.5'),
								$rtfeldman$elm_css$Svg$Styled$Attributes$r('43'),
								$rtfeldman$elm_css$Svg$Styled$Attributes$fill('#2962ff')
							]),
						_List_Nil),
						A2(
						$rtfeldman$elm_css$Svg$Styled$circle,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Svg$Styled$Attributes$cx('54'),
								$rtfeldman$elm_css$Svg$Styled$Attributes$cy('672.5'),
								$rtfeldman$elm_css$Svg$Styled$Attributes$r('31'),
								$rtfeldman$elm_css$Svg$Styled$Attributes$fill('#2962ff')
							]),
						_List_Nil),
						A2(
						$rtfeldman$elm_css$Svg$Styled$circle,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Svg$Styled$Attributes$cx('54'),
								$rtfeldman$elm_css$Svg$Styled$Attributes$cy('624.5'),
								$rtfeldman$elm_css$Svg$Styled$Attributes$r('22'),
								$rtfeldman$elm_css$Svg$Styled$Attributes$fill('#2962ff')
							]),
						_List_Nil)
					]),
				children));
	});
var $author$project$Page$ListDocument$EmptyDocument$view = F2(
	function (title, subTitle) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ListDocument$EmptyDocument$styles.container)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_Utils_ap($author$project$Page$ListDocument$EmptyDocument$styles.item, $author$project$Page$ListDocument$EmptyDocument$styles.header))
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(title)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ListDocument$EmptyDocument$styles.subHeader)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(subTitle)
						])),
					A2(
					$author$project$Page$ListDocument$EmptyDocumentSvg$view,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Svg$Styled$Attributes$css(
							_Utils_ap($author$project$Page$ListDocument$EmptyDocument$styles.item, $author$project$Page$ListDocument$EmptyDocument$styles.image))
						]),
					_List_Nil),
					A2(
					$rtfeldman$elm_css$Html$Styled$a,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$href($author$project$Data$Route$routeUrl.dashboard)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Material$Styled$Button$button,
							_List_fromArray(
								[
									$author$project$Material$Styled$Button$theme($author$project$Material$Styled$Button$blueText),
									$author$project$Material$Styled$Button$styles($author$project$Page$ListDocument$EmptyDocument$styles.button)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('BACK TO DASHBOARD')
								]))
						]))
				]));
	});
var $author$project$Page$ListDocument$Received$toMonthString = function (month) {
	switch (month.$) {
		case 'Jan':
			return 'Jan';
		case 'Feb':
			return 'Feb';
		case 'Mar':
			return 'Mar';
		case 'Apr':
			return 'Apr';
		case 'May':
			return 'May';
		case 'Jun':
			return 'Jun';
		case 'Jul':
			return 'Jul';
		case 'Aug':
			return 'Aug';
		case 'Sep':
			return 'Sep';
		case 'Oct':
			return 'Oct';
		case 'Nov':
			return 'Nov';
		default:
			return 'Dec';
	}
};
var $author$project$Page$ListDocument$Received$getDate = function (posix) {
	return $elm$core$String$fromInt(
		A2($elm$time$Time$toDay, $elm$time$Time$utc, posix)) + (' ' + ($author$project$Page$ListDocument$Received$toMonthString(
		A2($elm$time$Time$toMonth, $elm$time$Time$utc, posix)) + (' ' + $elm$core$String$fromInt(
		A2($elm$time$Time$toYear, $elm$time$Time$utc, posix)))));
};
var $author$project$Page$ListDocument$Received$renderNames = function (names) {
	return $elm$core$List$isEmpty(names) ? $rtfeldman$elm_css$Html$Styled$text('-') : $rtfeldman$elm_css$Html$Styled$text(
		A2($elm$core$String$join, ', ', names));
};
var $author$project$Page$ListDocument$Received$styles = {
	actorContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column)
		]),
	arrow: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100)),
			$rtfeldman$elm_css$Css$maxWidth(
			$rtfeldman$elm_css$Css$px(50))
		]),
	boldText: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontWeight(
			$rtfeldman$elm_css$Css$int(500))
		]),
	closeBtnContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceBetween),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$padding(
			$rtfeldman$elm_css$Css$px(10)),
			$rtfeldman$elm_css$Css$displayFlex
		]),
	container: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer)
		]),
	content: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceBetween),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$padding(
			$rtfeldman$elm_css$Css$px(10)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100)),
			$rtfeldman$elm_css$Css$hover(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$backgroundColor($author$project$Material$Styled$Color$grey200)
				]))
		]),
	disabledIcon: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginRight(
			$rtfeldman$elm_css$Css$px(10)),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(25)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(40)),
			$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$default)
		]),
	element: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100)),
			$rtfeldman$elm_css$Css$maxWidth(
			$rtfeldman$elm_css$Css$px(600))
		]),
	ellipsis: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$whiteSpace($rtfeldman$elm_css$Css$noWrap),
			$rtfeldman$elm_css$Css$overflow($rtfeldman$elm_css$Css$hidden),
			$rtfeldman$elm_css$Css$textOverflow($rtfeldman$elm_css$Css$ellipsis)
		]),
	icon: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginRight(
			$rtfeldman$elm_css$Css$px(10)),
			$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(25)),
			$rtfeldman$elm_css$Css$hover(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$backgroundColor($author$project$Material$Styled$Color$grey200),
					$rtfeldman$elm_css$Css$borderRadius(
					$rtfeldman$elm_css$Css$pct(100))
				])),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(40)),
			$rtfeldman$elm_css$Css$active(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$backgroundColor($author$project$Material$Styled$Color$grey100),
					$rtfeldman$elm_css$Css$backgroundSize(
					$rtfeldman$elm_css$Css$pct(100)),
					$rtfeldman$elm_css$Css$Transitions$transition(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$Transitions$background(0)
						]))
				]))
		]),
	nameContainer: _List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Css$margin2,
			$rtfeldman$elm_css$Css$px(5),
			$rtfeldman$elm_css$Css$zero)
		]),
	outerContainer: _List_fromArray(
		[$rtfeldman$elm_css$Css$displayFlex]),
	secondaryText: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(12)),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$grey700)
		])
};
var $author$project$Page$ListDocument$Received$view = F3(
	function (languageSwitchModel, user, document) {
		var listDocumentLanguageData = languageSwitchModel.allLanguageData.location.listDocumentsPage;
		return A2(
			$author$project$Material$Styled$Card$card,
			_List_fromArray(
				[
					$author$project$Material$Styled$Card$containerStyles($author$project$Page$ListDocument$Received$styles.container)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ListDocument$Received$styles.outerContainer)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ListDocument$Received$styles.content),
									$rtfeldman$elm_css$Html$Styled$Events$onClick(
									$author$project$Types$OnAuth(
										$author$project$Types$OnListDoc(
											$author$project$Type$ListDocument$OnDocumentClick(document.id)))),
									A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'data-test', 'Incoming Documents')
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css(
											_Utils_ap(
												$author$project$Page$ListDocument$Received$styles.boldText,
												_Utils_ap($author$project$Page$ListDocument$Received$styles.element, $author$project$Page$ListDocument$Received$styles.ellipsis)))
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(document.title)
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css(
											_Utils_ap($author$project$Page$ListDocument$Received$styles.actorContainer, $author$project$Page$ListDocument$Received$styles.element))
										]),
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$span,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$css(
													_Utils_ap(
														$author$project$Page$ListDocument$Received$styles.nameContainer,
														_Utils_ap($author$project$Page$ListDocument$Received$styles.boldText, $author$project$Page$ListDocument$Received$styles.ellipsis)))
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(document.ownerName)
												])),
											A2(
											$rtfeldman$elm_css$Html$Styled$span,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$css(
													_Utils_ap($author$project$Page$ListDocument$Received$styles.nameContainer, $author$project$Page$ListDocument$Received$styles.secondaryText))
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(listDocumentLanguageData.sender)
												]))
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css(
											_Utils_ap($author$project$Page$ListDocument$Received$styles.actorContainer, $author$project$Page$ListDocument$Received$styles.element))
										]),
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$span,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$css(
													_Utils_ap(
														$author$project$Page$ListDocument$Received$styles.nameContainer,
														_Utils_ap($author$project$Page$ListDocument$Received$styles.boldText, $author$project$Page$ListDocument$Received$styles.ellipsis)))
												]),
											_List_fromArray(
												[
													$author$project$Page$ListDocument$Received$renderNames(document.signers)
												])),
											A2(
											$rtfeldman$elm_css$Html$Styled$span,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$css(
													_Utils_ap($author$project$Page$ListDocument$Received$styles.nameContainer, $author$project$Page$ListDocument$Received$styles.secondaryText))
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(listDocumentLanguageData.signers)
												]))
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css(
											_Utils_ap($author$project$Page$ListDocument$Received$styles.actorContainer, $author$project$Page$ListDocument$Received$styles.element))
										]),
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$span,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$css(
													_Utils_ap(
														$author$project$Page$ListDocument$Received$styles.nameContainer,
														_Utils_ap($author$project$Page$ListDocument$Received$styles.boldText, $author$project$Page$ListDocument$Received$styles.ellipsis)))
												]),
											_List_fromArray(
												[
													$author$project$Page$ListDocument$Received$renderNames(document.viewers)
												])),
											A2(
											$rtfeldman$elm_css$Html$Styled$span,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$css(
													_Utils_ap($author$project$Page$ListDocument$Received$styles.nameContainer, $author$project$Page$ListDocument$Received$styles.secondaryText))
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(listDocumentLanguageData.viewers)
												]))
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ListDocument$Received$styles.actorContainer)
										]),
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$span,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$css(
													_Utils_ap($author$project$Page$ListDocument$Received$styles.nameContainer, $author$project$Page$ListDocument$Received$styles.boldText))
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(
													$author$project$Page$ListDocument$Received$getDate(document.createdAt))
												])),
											A2(
											$rtfeldman$elm_css$Html$Styled$span,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$css(
													_Utils_ap($author$project$Page$ListDocument$Received$styles.nameContainer, $author$project$Page$ListDocument$Received$styles.secondaryText))
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(listDocumentLanguageData.dateSent)
												]))
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ListDocument$Received$styles.arrow)
										]),
									_List_fromArray(
										[
											A2($author$project$Material$Styled$Icon$arrowRight, _List_Nil, _List_Nil)
										]))
								])),
							_Utils_eq(user.id, document.ownerId) ? A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ListDocument$Received$styles.closeBtnContainer)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Material$Styled$Icon$delete,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Svg$Styled$Attributes$css($author$project$Page$ListDocument$Received$styles.icon),
											$rtfeldman$elm_css$Svg$Styled$Events$onClick(
											$author$project$Types$OnAuth(
												$author$project$Types$OnListDoc(
													$author$project$Type$ListDocument$OnShowModal(
														$author$project$Type$ListDocument$DeleteDocument(document.id)))))
										]),
									_List_Nil)
								])) : A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ListDocument$Received$styles.closeBtnContainer)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Material$Styled$Icon$delete,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Svg$Styled$Attributes$css($author$project$Page$ListDocument$Received$styles.disabledIcon),
											$rtfeldman$elm_css$Svg$Styled$Attributes$fill('grey')
										]),
									_List_Nil)
								]))
						]))
				]));
	});
var $author$project$Page$ListDocument$Sent$toMonthString = function (month) {
	switch (month.$) {
		case 'Jan':
			return 'Jan';
		case 'Feb':
			return 'Feb';
		case 'Mar':
			return 'Mar';
		case 'Apr':
			return 'Apr';
		case 'May':
			return 'May';
		case 'Jun':
			return 'Jun';
		case 'Jul':
			return 'Jul';
		case 'Aug':
			return 'Aug';
		case 'Sep':
			return 'Sep';
		case 'Oct':
			return 'Oct';
		case 'Nov':
			return 'Nov';
		default:
			return 'Dec';
	}
};
var $author$project$Page$ListDocument$Sent$getDate = function (posix) {
	return $elm$core$String$fromInt(
		A2($elm$time$Time$toDay, $elm$time$Time$utc, posix)) + (' ' + ($author$project$Page$ListDocument$Sent$toMonthString(
		A2($elm$time$Time$toMonth, $elm$time$Time$utc, posix)) + (' ' + $elm$core$String$fromInt(
		A2($elm$time$Time$toYear, $elm$time$Time$utc, posix)))));
};
var $author$project$Page$ListDocument$Sent$renderNames = function (names) {
	return $elm$core$List$isEmpty(names) ? $rtfeldman$elm_css$Html$Styled$text('-') : $rtfeldman$elm_css$Html$Styled$text(
		A2($elm$core$String$join, ', ', names));
};
var $author$project$Page$ListDocument$Sent$styles = {
	actorContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column)
		]),
	arrow: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100)),
			$rtfeldman$elm_css$Css$maxWidth(
			$rtfeldman$elm_css$Css$px(50))
		]),
	boldText: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontWeight(
			$rtfeldman$elm_css$Css$int(500))
		]),
	closeBtnContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceBetween),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$padding(
			$rtfeldman$elm_css$Css$px(10)),
			$rtfeldman$elm_css$Css$displayFlex
		]),
	container: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer)
		]),
	content: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceBetween),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$padding(
			$rtfeldman$elm_css$Css$px(10)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100)),
			$rtfeldman$elm_css$Css$hover(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$backgroundColor($author$project$Material$Styled$Color$grey200)
				]))
		]),
	disabledIcon: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginRight(
			$rtfeldman$elm_css$Css$px(10)),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(25)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(40)),
			$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$default)
		]),
	element: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100)),
			$rtfeldman$elm_css$Css$maxWidth(
			$rtfeldman$elm_css$Css$px(600))
		]),
	ellipsis: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$whiteSpace($rtfeldman$elm_css$Css$noWrap),
			$rtfeldman$elm_css$Css$overflow($rtfeldman$elm_css$Css$hidden),
			$rtfeldman$elm_css$Css$textOverflow($rtfeldman$elm_css$Css$ellipsis)
		]),
	icon: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginRight(
			$rtfeldman$elm_css$Css$px(10)),
			$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(25)),
			$rtfeldman$elm_css$Css$hover(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$backgroundColor($author$project$Material$Styled$Color$grey200),
					$rtfeldman$elm_css$Css$borderRadius(
					$rtfeldman$elm_css$Css$pct(100))
				])),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(40)),
			$rtfeldman$elm_css$Css$active(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$backgroundColor($author$project$Material$Styled$Color$grey100),
					$rtfeldman$elm_css$Css$backgroundSize(
					$rtfeldman$elm_css$Css$pct(100)),
					$rtfeldman$elm_css$Css$Transitions$transition(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$Transitions$background(0)
						]))
				]))
		]),
	nameContainer: _List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Css$margin2,
			$rtfeldman$elm_css$Css$px(5),
			$rtfeldman$elm_css$Css$zero)
		]),
	outerContainer: _List_fromArray(
		[$rtfeldman$elm_css$Css$displayFlex]),
	secondaryText: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(12)),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$grey700)
		])
};
var $author$project$Page$ListDocument$Sent$view = F3(
	function (languageSwitchModel, user, document) {
		var listDocumentLanguageData = languageSwitchModel.allLanguageData.location.listDocumentsPage;
		return A2(
			$author$project$Material$Styled$Card$card,
			_List_fromArray(
				[
					$author$project$Material$Styled$Card$containerStyles($author$project$Page$ListDocument$Sent$styles.container)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ListDocument$Sent$styles.outerContainer)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ListDocument$Sent$styles.content),
									$rtfeldman$elm_css$Html$Styled$Events$onClick(
									$author$project$Types$OnAuth(
										$author$project$Types$OnListDoc(
											$author$project$Type$ListDocument$OnDocumentClick(document.id)))),
									A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'data-test', 'Outgoing Documents')
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css(
											_Utils_ap(
												$author$project$Page$ListDocument$Sent$styles.boldText,
												_Utils_ap($author$project$Page$ListDocument$Sent$styles.element, $author$project$Page$ListDocument$Sent$styles.ellipsis)))
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(document.title)
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css(
											_Utils_ap($author$project$Page$ListDocument$Sent$styles.actorContainer, $author$project$Page$ListDocument$Sent$styles.element))
										]),
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$span,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$css(
													_Utils_ap(
														$author$project$Page$ListDocument$Sent$styles.nameContainer,
														_Utils_ap($author$project$Page$ListDocument$Sent$styles.boldText, $author$project$Page$ListDocument$Sent$styles.ellipsis)))
												]),
											_List_fromArray(
												[
													$author$project$Page$ListDocument$Sent$renderNames(document.signers)
												])),
											A2(
											$rtfeldman$elm_css$Html$Styled$span,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$css(
													_Utils_ap($author$project$Page$ListDocument$Sent$styles.nameContainer, $author$project$Page$ListDocument$Sent$styles.secondaryText))
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(listDocumentLanguageData.signers)
												]))
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css(
											_Utils_ap($author$project$Page$ListDocument$Sent$styles.actorContainer, $author$project$Page$ListDocument$Sent$styles.element))
										]),
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$span,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$css(
													_Utils_ap(
														$author$project$Page$ListDocument$Sent$styles.nameContainer,
														_Utils_ap($author$project$Page$ListDocument$Sent$styles.boldText, $author$project$Page$ListDocument$Sent$styles.ellipsis)))
												]),
											_List_fromArray(
												[
													$author$project$Page$ListDocument$Sent$renderNames(document.viewers)
												])),
											A2(
											$rtfeldman$elm_css$Html$Styled$span,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$css(
													_Utils_ap($author$project$Page$ListDocument$Sent$styles.nameContainer, $author$project$Page$ListDocument$Sent$styles.secondaryText))
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(listDocumentLanguageData.viewers)
												]))
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ListDocument$Sent$styles.actorContainer)
										]),
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$span,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$css(
													_Utils_ap($author$project$Page$ListDocument$Sent$styles.nameContainer, $author$project$Page$ListDocument$Sent$styles.boldText))
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(
													$author$project$Page$ListDocument$Sent$getDate(document.createdAt))
												])),
											A2(
											$rtfeldman$elm_css$Html$Styled$span,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$css(
													_Utils_ap($author$project$Page$ListDocument$Sent$styles.nameContainer, $author$project$Page$ListDocument$Sent$styles.secondaryText))
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(listDocumentLanguageData.dateSent)
												]))
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ListDocument$Sent$styles.arrow)
										]),
									_List_fromArray(
										[
											A2($author$project$Material$Styled$Icon$arrowRight, _List_Nil, _List_Nil)
										]))
								])),
							_Utils_eq(user.id, document.ownerId) ? A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ListDocument$Sent$styles.closeBtnContainer)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Material$Styled$Icon$delete,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Svg$Styled$Attributes$css($author$project$Page$ListDocument$Sent$styles.icon),
											$rtfeldman$elm_css$Svg$Styled$Events$onClick(
											$author$project$Types$OnAuth(
												$author$project$Types$OnListDoc(
													$author$project$Type$ListDocument$OnShowModal(
														$author$project$Type$ListDocument$DeleteDocument(document.id)))))
										]),
									_List_Nil)
								])) : A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ListDocument$Sent$styles.closeBtnContainer)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Material$Styled$Icon$delete,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Svg$Styled$Attributes$css($author$project$Page$ListDocument$Sent$styles.disabledIcon),
											$rtfeldman$elm_css$Svg$Styled$Attributes$fill('grey')
										]),
									_List_Nil)
								]))
						]))
				]));
	});
var $author$project$Type$ListDocument$OnSubmissionClick = function (a) {
	return {$: 'OnSubmissionClick', a: a};
};
var $author$project$Material$Styled$Icon$Download$view = F2(
	function (attributes, children) {
		return A2(
			$rtfeldman$elm_css$Svg$Styled$svg,
			_Utils_ap(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Svg$Styled$Attributes$fill('black'),
						$rtfeldman$elm_css$Svg$Styled$Attributes$width('24px'),
						$rtfeldman$elm_css$Svg$Styled$Attributes$height('24px'),
						$rtfeldman$elm_css$Svg$Styled$Attributes$viewBox('0 0 24 24')
					]),
				attributes),
			_Utils_ap(
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Svg$Styled$path,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Svg$Styled$Attributes$d('M0 0h24v24H0V0z'),
								$rtfeldman$elm_css$Svg$Styled$Attributes$fill('none')
							]),
						_List_Nil),
						A2(
						$rtfeldman$elm_css$Svg$Styled$path,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Svg$Styled$Attributes$d('M16.59 9H15V4c0-.55-.45-1-1-1h-4c-.55 0-1 .45-1 1v5H7.41c-.89 0-1.34 1.08-.71 1.71l4.59 4.59c.39.39 1.02.39 1.41 0l4.59-4.59c.63-.63.19-1.71-.7-1.71zM5 19c0 .55.45 1 1 1h12c.55 0 1-.45 1-1s-.45-1-1-1H6c-.55 0-1 .45-1 1z')
							]),
						_List_Nil)
					]),
				children));
	});
var $author$project$Material$Styled$Icon$download = $author$project$Material$Styled$Icon$Download$view;
var $author$project$Page$ListDocument$Submission$toMonthString = function (month) {
	switch (month.$) {
		case 'Jan':
			return 'Jan';
		case 'Feb':
			return 'Feb';
		case 'Mar':
			return 'Mar';
		case 'Apr':
			return 'Apr';
		case 'May':
			return 'May';
		case 'Jun':
			return 'Jun';
		case 'Jul':
			return 'Jul';
		case 'Aug':
			return 'Aug';
		case 'Sep':
			return 'Sep';
		case 'Oct':
			return 'Oct';
		case 'Nov':
			return 'Nov';
		default:
			return 'Dec';
	}
};
var $author$project$Page$ListDocument$Submission$getDate = function (posix) {
	return $elm$core$String$fromInt(
		A2($elm$time$Time$toDay, $elm$time$Time$utc, posix)) + (' ' + ($author$project$Page$ListDocument$Submission$toMonthString(
		A2($elm$time$Time$toMonth, $elm$time$Time$utc, posix)) + (' ' + $elm$core$String$fromInt(
		A2($elm$time$Time$toYear, $elm$time$Time$utc, posix)))));
};
var $author$project$Page$ListDocument$Submission$styles = {
	actorContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column)
		]),
	arrow: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100)),
			$rtfeldman$elm_css$Css$maxWidth(
			$rtfeldman$elm_css$Css$px(50))
		]),
	boldText: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontWeight(
			$rtfeldman$elm_css$Css$int(500))
		]),
	container: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer)
		]),
	content: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceBetween),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$padding(
			$rtfeldman$elm_css$Css$px(10)),
			$rtfeldman$elm_css$Css$hover(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$backgroundColor($author$project$Material$Styled$Color$grey200)
				]))
		]),
	element: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100)),
			$rtfeldman$elm_css$Css$maxWidth(
			$rtfeldman$elm_css$Css$px(600))
		]),
	ellipsis: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$whiteSpace($rtfeldman$elm_css$Css$noWrap),
			$rtfeldman$elm_css$Css$overflow($rtfeldman$elm_css$Css$hidden),
			$rtfeldman$elm_css$Css$textOverflow($rtfeldman$elm_css$Css$ellipsis)
		]),
	nameContainer: _List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Css$margin2,
			$rtfeldman$elm_css$Css$px(5),
			$rtfeldman$elm_css$Css$zero)
		]),
	secondaryText: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(12)),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$grey700)
		])
};
var $author$project$Page$ListDocument$Submission$view = F2(
	function (languageSwitchModel, model) {
		var templateLanguageData = languageSwitchModel.allLanguageData.location.viewTemplatePage;
		return A2(
			$author$project$Material$Styled$Card$card,
			_List_fromArray(
				[
					$author$project$Material$Styled$Card$containerStyles($author$project$Page$ListDocument$Submission$styles.container)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ListDocument$Submission$styles.content),
							$rtfeldman$elm_css$Html$Styled$Events$onClick(
							$author$project$Types$OnAuth(
								$author$project$Types$OnListDoc(
									$author$project$Type$ListDocument$OnSubmissionClick(model.id))))
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css(
									_Utils_ap(
										$author$project$Page$ListDocument$Submission$styles.boldText,
										_Utils_ap($author$project$Page$ListDocument$Submission$styles.element, $author$project$Page$ListDocument$Submission$styles.ellipsis)))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(model.title)
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css(
									_Utils_ap($author$project$Page$ListDocument$Submission$styles.actorContainer, $author$project$Page$ListDocument$Submission$styles.element))
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css(
											_Utils_ap(
												$author$project$Page$ListDocument$Submission$styles.nameContainer,
												_Utils_ap($author$project$Page$ListDocument$Submission$styles.boldText, $author$project$Page$ListDocument$Submission$styles.ellipsis)))
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(model.firstName + (' ' + model.lastName))
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css(
											_Utils_ap($author$project$Page$ListDocument$Submission$styles.nameContainer, $author$project$Page$ListDocument$Submission$styles.secondaryText))
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(templateLanguageData.createdBy)
										]))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ListDocument$Submission$styles.actorContainer)
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css(
											_Utils_ap($author$project$Page$ListDocument$Submission$styles.nameContainer, $author$project$Page$ListDocument$Submission$styles.boldText))
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											$author$project$Page$ListDocument$Submission$getDate(model.createdAt))
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css(
											_Utils_ap($author$project$Page$ListDocument$Submission$styles.nameContainer, $author$project$Page$ListDocument$Submission$styles.secondaryText))
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(templateLanguageData.dateCreated)
										]))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ListDocument$Submission$styles.arrow)
								]),
							_List_fromArray(
								[
									A2($author$project$Material$Styled$Icon$download, _List_Nil, _List_Nil)
								]))
						]))
				]));
	});
var $author$project$Type$ListDocument$DeleteTemplate = function (a) {
	return {$: 'DeleteTemplate', a: a};
};
var $author$project$Page$ListDocument$Template$toMonthString = function (month) {
	switch (month.$) {
		case 'Jan':
			return 'Jan';
		case 'Feb':
			return 'Feb';
		case 'Mar':
			return 'Mar';
		case 'Apr':
			return 'Apr';
		case 'May':
			return 'May';
		case 'Jun':
			return 'Jun';
		case 'Jul':
			return 'Jul';
		case 'Aug':
			return 'Aug';
		case 'Sep':
			return 'Sep';
		case 'Oct':
			return 'Oct';
		case 'Nov':
			return 'Nov';
		default:
			return 'Dec';
	}
};
var $author$project$Page$ListDocument$Template$getDate = function (posix) {
	return $elm$core$String$fromInt(
		A2($elm$time$Time$toDay, $elm$time$Time$utc, posix)) + (' ' + ($author$project$Page$ListDocument$Template$toMonthString(
		A2($elm$time$Time$toMonth, $elm$time$Time$utc, posix)) + (' ' + $elm$core$String$fromInt(
		A2($elm$time$Time$toYear, $elm$time$Time$utc, posix)))));
};
var $author$project$Page$ListDocument$Template$styles = {
	actorContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column)
		]),
	arrow: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100)),
			$rtfeldman$elm_css$Css$maxWidth(
			$rtfeldman$elm_css$Css$px(50))
		]),
	boldText: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontWeight(
			$rtfeldman$elm_css$Css$int(500))
		]),
	closeBtnContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceBetween),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$padding(
			$rtfeldman$elm_css$Css$px(10)),
			$rtfeldman$elm_css$Css$displayFlex
		]),
	container: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer)
		]),
	content: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceBetween),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$padding(
			$rtfeldman$elm_css$Css$px(10)),
			$rtfeldman$elm_css$Css$textDecoration($rtfeldman$elm_css$Css$none),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$black),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100)),
			$rtfeldman$elm_css$Css$hover(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$backgroundColor($author$project$Material$Styled$Color$grey200)
				]))
		]),
	disabledIcon: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginRight(
			$rtfeldman$elm_css$Css$px(10)),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(25)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(40)),
			$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$default)
		]),
	element: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100)),
			$rtfeldman$elm_css$Css$maxWidth(
			$rtfeldman$elm_css$Css$px(600))
		]),
	ellipsis: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$whiteSpace($rtfeldman$elm_css$Css$noWrap),
			$rtfeldman$elm_css$Css$overflow($rtfeldman$elm_css$Css$hidden),
			$rtfeldman$elm_css$Css$textOverflow($rtfeldman$elm_css$Css$ellipsis)
		]),
	icon: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginRight(
			$rtfeldman$elm_css$Css$px(10)),
			$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(25)),
			$rtfeldman$elm_css$Css$hover(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$backgroundColor($author$project$Material$Styled$Color$grey200),
					$rtfeldman$elm_css$Css$borderRadius(
					$rtfeldman$elm_css$Css$pct(100))
				])),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(40)),
			$rtfeldman$elm_css$Css$active(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$backgroundColor($author$project$Material$Styled$Color$grey100),
					$rtfeldman$elm_css$Css$backgroundSize(
					$rtfeldman$elm_css$Css$pct(100)),
					$rtfeldman$elm_css$Css$Transitions$transition(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$Transitions$background(0)
						]))
				]))
		]),
	nameContainer: _List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Css$margin2,
			$rtfeldman$elm_css$Css$px(5),
			$rtfeldman$elm_css$Css$zero)
		]),
	outerContainer: _List_fromArray(
		[$rtfeldman$elm_css$Css$displayFlex]),
	secondaryText: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(12)),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$grey700)
		])
};
var $author$project$Page$ListDocument$Template$view = F3(
	function (appModel, authModel, model) {
		var templateLanguageData = appModel.languageSwitchModel.allLanguageData.location.viewTemplatePage;
		var redirectUrl = (appModel.baseHost === 'localhost') ? ('http://' + ($author$project$Data$Domain$toString(
			$author$project$Data$Domain$selected(authModel.user.domains)) + (':3000' + ($author$project$Data$Route$routeUrl.viewTemplate + ('/' + model.slug))))) : ('https://' + ($author$project$Data$Domain$toString(
			$author$project$Data$Domain$selected(authModel.user.domains)) + ($author$project$Data$Route$routeUrl.viewTemplate + ('/' + model.slug))));
		var domainOwnerEmail = appModel.businessProfileModel.email;
		return A2(
			$author$project$Material$Styled$Card$card,
			_List_fromArray(
				[
					$author$project$Material$Styled$Card$containerStyles($author$project$Page$ListDocument$Template$styles.container)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ListDocument$Template$styles.outerContainer)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$a,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ListDocument$Template$styles.content),
									$rtfeldman$elm_css$Html$Styled$Attributes$href(redirectUrl)
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css(
											_Utils_ap(
												$author$project$Page$ListDocument$Template$styles.boldText,
												_Utils_ap($author$project$Page$ListDocument$Template$styles.element, $author$project$Page$ListDocument$Template$styles.ellipsis)))
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(model.title)
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css(
											_Utils_ap($author$project$Page$ListDocument$Template$styles.actorContainer, $author$project$Page$ListDocument$Template$styles.element))
										]),
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$span,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$css(
													_Utils_ap(
														$author$project$Page$ListDocument$Template$styles.nameContainer,
														_Utils_ap($author$project$Page$ListDocument$Template$styles.boldText, $author$project$Page$ListDocument$Template$styles.ellipsis)))
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(model.ownerName)
												])),
											A2(
											$rtfeldman$elm_css$Html$Styled$span,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$css(
													_Utils_ap($author$project$Page$ListDocument$Template$styles.nameContainer, $author$project$Page$ListDocument$Template$styles.secondaryText))
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(templateLanguageData.createdBy)
												]))
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ListDocument$Template$styles.actorContainer)
										]),
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$span,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$css(
													_Utils_ap($author$project$Page$ListDocument$Template$styles.nameContainer, $author$project$Page$ListDocument$Template$styles.boldText))
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(
													$author$project$Page$ListDocument$Template$getDate(model.createdAt))
												])),
											A2(
											$rtfeldman$elm_css$Html$Styled$span,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$css(
													_Utils_ap($author$project$Page$ListDocument$Template$styles.nameContainer, $author$project$Page$ListDocument$Template$styles.secondaryText))
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(templateLanguageData.dateCreated)
												]))
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ListDocument$Template$styles.actorContainer)
										]),
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$span,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$css(
													_Utils_ap($author$project$Page$ListDocument$Template$styles.nameContainer, $author$project$Page$ListDocument$Template$styles.boldText))
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(
													$elm$core$String$fromInt(model.version))
												])),
											A2(
											$rtfeldman$elm_css$Html$Styled$span,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$css(
													_Utils_ap($author$project$Page$ListDocument$Template$styles.nameContainer, $author$project$Page$ListDocument$Template$styles.secondaryText))
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(templateLanguageData.version)
												]))
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ListDocument$Template$styles.arrow)
										]),
									_List_fromArray(
										[
											A2($author$project$Material$Styled$Icon$arrowRight, _List_Nil, _List_Nil)
										]))
								])),
							(_Utils_eq(model.ownerId, authModel.user.id) || _Utils_eq(domainOwnerEmail, authModel.user.email)) ? A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ListDocument$Template$styles.closeBtnContainer)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Material$Styled$Icon$delete,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Svg$Styled$Attributes$css($author$project$Page$ListDocument$Template$styles.icon),
											$rtfeldman$elm_css$Svg$Styled$Events$onClick(
											$author$project$Types$OnAuth(
												$author$project$Types$OnListDoc(
													$author$project$Type$ListDocument$OnShowModal(
														$author$project$Type$ListDocument$DeleteTemplate(model.id)))))
										]),
									_List_Nil)
								])) : A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ListDocument$Template$styles.closeBtnContainer)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Material$Styled$Icon$delete,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Svg$Styled$Attributes$css($author$project$Page$ListDocument$Template$styles.disabledIcon),
											$rtfeldman$elm_css$Svg$Styled$Attributes$fill('grey')
										]),
									_List_Nil)
								]))
						]))
				]));
	});
var $author$project$Page$ListDocument$documentList = F6(
	function (listDocModel, _v0, timezone, user, appModel, authModel) {
		var posixToDateInt = function (posix) {
			var year = A2($elm$time$Time$toYear, timezone, posix);
			var month = $author$project$Data$Date$monthToInt(
				A2($elm$time$Time$toMonth, timezone, posix));
			var day = A2($elm$time$Time$toDay, timezone, posix);
			return ((year * 10000) + (month * 100)) + day;
		};
		var listDocumentLanguageData = appModel.languageSwitchModel.allLanguageData.location.listDocumentsPage;
		var _v1 = listDocModel;
		var completed = _v1.completed;
		var sent = _v1.sent;
		var received = _v1.received;
		var selectedType = _v1.selectedType;
		var template = _v1.template;
		var submission = _v1.submission;
		var searchQuery = _v1.searchQuery;
		var searchFromDate = _v1.searchFromDate;
		var searchToDate = _v1.searchToDate;
		var fromDate = A2(
			$elm$core$Maybe$withDefault,
			0,
			$elm$core$String$toInt(
				A2(
					$elm$core$String$join,
					'',
					A2($elm$core$String$split, '-', searchFromDate))));
		var containSearchQuery = function (text) {
			return A2(
				$elm$core$String$contains,
				$elm$core$String$trim(
					$elm$core$String$toLower(searchQuery)),
				$elm$core$String$trim(
					$elm$core$String$toLower(text)));
		};
		var toDate = A2(
			$elm$core$Maybe$withDefault,
			99999999,
			$elm$core$String$toInt(
				A2(
					$elm$core$String$join,
					'',
					A2($elm$core$String$split, '-', searchToDate))));
		var filterSubmissions = function (list) {
			return A2(
				$elm$core$List$filter,
				function (s) {
					return (containSearchQuery(s.firstName) || (containSearchQuery(s.lastName) || (containSearchQuery(s.email) || containSearchQuery(s.domain)))) && ((_Utils_cmp(
						posixToDateInt(s.createdAt),
						fromDate) > -1) && (_Utils_cmp(
						posixToDateInt(s.createdAt),
						toDate) < 1));
				},
				list);
		};
		switch (selectedType.$) {
			case 'Sent':
				if (!sent.b) {
					return A2($author$project$Page$ListDocument$EmptyDocument$view, $author$project$Page$ListDocument$noDocTitle, $author$project$Page$ListDocument$noDocSubTitle);
				} else {
					return A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_Nil,
						_List_fromArray(
							[
								(user.showAds && ($elm$core$List$length(
								$author$project$Data$Domain$all(user.domains)) === 1)) ? A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ListDocument$styles.adsContainer)
									]),
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$div,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$id('documentListAdsContent')
											]),
										_List_Nil)
									])) : $rtfeldman$elm_css$Html$Styled$text(''),
								A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ListDocument$styles.cardContainer)
									]),
								A2(
									$elm$core$List$map,
									A2($author$project$Page$ListDocument$Sent$view, appModel.languageSwitchModel, user),
									sent)),
								(user.showAds && ($elm$core$List$length(
								$author$project$Data$Domain$all(user.domains)) === 1)) ? A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ListDocument$styles.adsContainer)
									]),
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$div,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$id('documentListAdsContentBottom')
											]),
										_List_Nil)
									])) : $rtfeldman$elm_css$Html$Styled$text(''),
								A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ListDocument$styles.arrowBtnContainer)
									]),
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$div,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$css(
												_List_fromArray(
													[
														$rtfeldman$elm_css$Css$paddingRight(
														$rtfeldman$elm_css$Css$px(5))
													]))
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(
												listDocumentLanguageData.page + (' ' + ($elm$core$String$fromInt(listDocModel.pageNumber + 1) + ' :')))
											])),
										(!listDocModel.pageNumber) ? A2(
										$author$project$Material$Styled$Button$button,
										_List_fromArray(
											[
												$author$project$Material$Styled$Button$theme($author$project$Material$Styled$Button$grey),
												$author$project$Material$Styled$Button$styles($author$project$Page$ListDocument$styles.button),
												$author$project$Material$Styled$Button$disabled(true),
												$author$project$Material$Styled$Button$onClick(
												$author$project$Types$OnAuth(
													$author$project$Types$OnListDoc(
														$author$project$Type$ListDocument$OnPreviousPage($author$project$Type$ListDocument$Sent))))
											]),
										_List_fromArray(
											[
												A2($author$project$Material$Styled$Icon$keyboardArrowLeft, _List_Nil, _List_Nil)
											])) : A2(
										$author$project$Material$Styled$Button$button,
										_List_fromArray(
											[
												$author$project$Material$Styled$Button$theme($author$project$Material$Styled$Button$white),
												$author$project$Material$Styled$Button$styles($author$project$Page$ListDocument$styles.button),
												$author$project$Material$Styled$Button$disabled(!listDocModel.pageNumber),
												$author$project$Material$Styled$Button$onClick(
												$author$project$Types$OnAuth(
													$author$project$Types$OnListDoc(
														$author$project$Type$ListDocument$OnPreviousPage($author$project$Type$ListDocument$Sent))))
											]),
										_List_fromArray(
											[
												A2($author$project$Material$Styled$Icon$keyboardArrowLeft, _List_Nil, _List_Nil)
											])),
										(_Utils_cmp((listDocModel.pageNumber + 1) * 10, listDocModel.docsCount) > -1) ? A2(
										$author$project$Material$Styled$Button$button,
										_List_fromArray(
											[
												$author$project$Material$Styled$Button$theme($author$project$Material$Styled$Button$grey),
												$author$project$Material$Styled$Button$styles($author$project$Page$ListDocument$styles.button),
												$author$project$Material$Styled$Button$disabled(true),
												$author$project$Material$Styled$Button$onClick(
												$author$project$Types$OnAuth(
													$author$project$Types$OnListDoc(
														$author$project$Type$ListDocument$OnNextPage($author$project$Type$ListDocument$Sent))))
											]),
										_List_fromArray(
											[
												A2($author$project$Material$Styled$Icon$keyboardArrowRight, _List_Nil, _List_Nil)
											])) : A2(
										$author$project$Material$Styled$Button$button,
										_List_fromArray(
											[
												$author$project$Material$Styled$Button$theme($author$project$Material$Styled$Button$white),
												$author$project$Material$Styled$Button$styles($author$project$Page$ListDocument$styles.button),
												$author$project$Material$Styled$Button$onClick(
												$author$project$Types$OnAuth(
													$author$project$Types$OnListDoc(
														$author$project$Type$ListDocument$OnNextPage($author$project$Type$ListDocument$Sent))))
											]),
										_List_fromArray(
											[
												A2($author$project$Material$Styled$Icon$keyboardArrowRight, _List_Nil, _List_Nil)
											]))
									]))
							]));
				}
			case 'Received':
				if (!received.b) {
					return A2($author$project$Page$ListDocument$EmptyDocument$view, $author$project$Page$ListDocument$noDocTitle, $author$project$Page$ListDocument$noDocSubTitle);
				} else {
					return A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_Nil,
						_List_fromArray(
							[
								(user.showAds && ($elm$core$List$length(
								$author$project$Data$Domain$all(user.domains)) === 1)) ? A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ListDocument$styles.adsContainer)
									]),
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$div,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$id('documentListAdsContent')
											]),
										_List_Nil)
									])) : $rtfeldman$elm_css$Html$Styled$text(''),
								A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ListDocument$styles.cardContainer)
									]),
								A2(
									$elm$core$List$map,
									A2($author$project$Page$ListDocument$Received$view, appModel.languageSwitchModel, user),
									received)),
								(user.showAds && ($elm$core$List$length(
								$author$project$Data$Domain$all(user.domains)) === 1)) ? A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ListDocument$styles.adsContainer)
									]),
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$div,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$id('documentListAdsContentBottom')
											]),
										_List_Nil)
									])) : $rtfeldman$elm_css$Html$Styled$text(''),
								A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ListDocument$styles.arrowBtnContainer)
									]),
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$div,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$css(
												_List_fromArray(
													[
														$rtfeldman$elm_css$Css$paddingRight(
														$rtfeldman$elm_css$Css$px(5))
													]))
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(
												listDocumentLanguageData.page + (' ' + ($elm$core$String$fromInt(listDocModel.pageNumber + 1) + ' :')))
											])),
										(!listDocModel.pageNumber) ? A2(
										$author$project$Material$Styled$Button$button,
										_List_fromArray(
											[
												$author$project$Material$Styled$Button$theme($author$project$Material$Styled$Button$grey),
												$author$project$Material$Styled$Button$styles($author$project$Page$ListDocument$styles.button),
												$author$project$Material$Styled$Button$disabled(true),
												$author$project$Material$Styled$Button$onClick(
												$author$project$Types$OnAuth(
													$author$project$Types$OnListDoc(
														$author$project$Type$ListDocument$OnPreviousPage($author$project$Type$ListDocument$Received))))
											]),
										_List_fromArray(
											[
												A2($author$project$Material$Styled$Icon$keyboardArrowLeft, _List_Nil, _List_Nil)
											])) : A2(
										$author$project$Material$Styled$Button$button,
										_List_fromArray(
											[
												$author$project$Material$Styled$Button$theme($author$project$Material$Styled$Button$white),
												$author$project$Material$Styled$Button$styles($author$project$Page$ListDocument$styles.button),
												$author$project$Material$Styled$Button$onClick(
												$author$project$Types$OnAuth(
													$author$project$Types$OnListDoc(
														$author$project$Type$ListDocument$OnPreviousPage($author$project$Type$ListDocument$Received))))
											]),
										_List_fromArray(
											[
												A2($author$project$Material$Styled$Icon$keyboardArrowLeft, _List_Nil, _List_Nil)
											])),
										(_Utils_cmp((listDocModel.pageNumber + 1) * 10, listDocModel.docsCount) > -1) ? A2(
										$author$project$Material$Styled$Button$button,
										_List_fromArray(
											[
												$author$project$Material$Styled$Button$theme($author$project$Material$Styled$Button$grey),
												$author$project$Material$Styled$Button$styles($author$project$Page$ListDocument$styles.button),
												$author$project$Material$Styled$Button$disabled(true),
												$author$project$Material$Styled$Button$onClick(
												$author$project$Types$OnAuth(
													$author$project$Types$OnListDoc(
														$author$project$Type$ListDocument$OnNextPage($author$project$Type$ListDocument$Received))))
											]),
										_List_fromArray(
											[
												A2($author$project$Material$Styled$Icon$keyboardArrowRight, _List_Nil, _List_Nil)
											])) : A2(
										$author$project$Material$Styled$Button$button,
										_List_fromArray(
											[
												$author$project$Material$Styled$Button$theme($author$project$Material$Styled$Button$white),
												$author$project$Material$Styled$Button$styles($author$project$Page$ListDocument$styles.button),
												$author$project$Material$Styled$Button$onClick(
												$author$project$Types$OnAuth(
													$author$project$Types$OnListDoc(
														$author$project$Type$ListDocument$OnNextPage($author$project$Type$ListDocument$Received))))
											]),
										_List_fromArray(
											[
												A2($author$project$Material$Styled$Icon$keyboardArrowRight, _List_Nil, _List_Nil)
											]))
									]))
							]));
				}
			case 'Completed':
				if (!completed.b) {
					return A2($author$project$Page$ListDocument$EmptyDocument$view, $author$project$Page$ListDocument$noDocTitle, $author$project$Page$ListDocument$noDocSubTitle);
				} else {
					return A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_Nil,
						_List_fromArray(
							[
								(user.showAds && ($elm$core$List$length(
								$author$project$Data$Domain$all(user.domains)) === 1)) ? A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ListDocument$styles.adsContainer)
									]),
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$div,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$id('documentListAdsContent')
											]),
										_List_Nil)
									])) : $rtfeldman$elm_css$Html$Styled$text(''),
								A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ListDocument$styles.cardContainer)
									]),
								A2(
									$elm$core$List$map,
									A2($author$project$Page$ListDocument$Completed$view, appModel.languageSwitchModel, user),
									completed)),
								(user.showAds && ($elm$core$List$length(
								$author$project$Data$Domain$all(user.domains)) === 1)) ? A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ListDocument$styles.adsContainer)
									]),
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$div,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$id('documentListAdsContentBottom')
											]),
										_List_Nil)
									])) : $rtfeldman$elm_css$Html$Styled$text(''),
								A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ListDocument$styles.arrowBtnContainer)
									]),
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$div,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$css(
												_List_fromArray(
													[
														$rtfeldman$elm_css$Css$paddingRight(
														$rtfeldman$elm_css$Css$px(5))
													]))
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(
												listDocumentLanguageData.page + (' ' + ($elm$core$String$fromInt(listDocModel.pageNumber + 1) + ' :')))
											])),
										(!listDocModel.pageNumber) ? A2(
										$author$project$Material$Styled$Button$button,
										_List_fromArray(
											[
												$author$project$Material$Styled$Button$theme($author$project$Material$Styled$Button$grey),
												$author$project$Material$Styled$Button$styles($author$project$Page$ListDocument$styles.button),
												$author$project$Material$Styled$Button$disabled(true),
												$author$project$Material$Styled$Button$onClick(
												$author$project$Types$OnAuth(
													$author$project$Types$OnListDoc(
														$author$project$Type$ListDocument$OnPreviousPage($author$project$Type$ListDocument$Completed))))
											]),
										_List_fromArray(
											[
												A2($author$project$Material$Styled$Icon$keyboardArrowLeft, _List_Nil, _List_Nil)
											])) : A2(
										$author$project$Material$Styled$Button$button,
										_List_fromArray(
											[
												$author$project$Material$Styled$Button$theme($author$project$Material$Styled$Button$white),
												$author$project$Material$Styled$Button$styles($author$project$Page$ListDocument$styles.button),
												$author$project$Material$Styled$Button$onClick(
												$author$project$Types$OnAuth(
													$author$project$Types$OnListDoc(
														$author$project$Type$ListDocument$OnPreviousPage($author$project$Type$ListDocument$Completed))))
											]),
										_List_fromArray(
											[
												A2($author$project$Material$Styled$Icon$keyboardArrowLeft, _List_Nil, _List_Nil)
											])),
										(_Utils_cmp((listDocModel.pageNumber + 1) * 10, listDocModel.docsCount) > -1) ? A2(
										$author$project$Material$Styled$Button$button,
										_List_fromArray(
											[
												$author$project$Material$Styled$Button$theme($author$project$Material$Styled$Button$grey),
												$author$project$Material$Styled$Button$styles($author$project$Page$ListDocument$styles.button),
												$author$project$Material$Styled$Button$disabled(true),
												$author$project$Material$Styled$Button$onClick(
												$author$project$Types$OnAuth(
													$author$project$Types$OnListDoc(
														$author$project$Type$ListDocument$OnNextPage($author$project$Type$ListDocument$Completed))))
											]),
										_List_fromArray(
											[
												A2($author$project$Material$Styled$Icon$keyboardArrowRight, _List_Nil, _List_Nil)
											])) : A2(
										$author$project$Material$Styled$Button$button,
										_List_fromArray(
											[
												$author$project$Material$Styled$Button$theme($author$project$Material$Styled$Button$white),
												$author$project$Material$Styled$Button$styles($author$project$Page$ListDocument$styles.button),
												$author$project$Material$Styled$Button$onClick(
												$author$project$Types$OnAuth(
													$author$project$Types$OnListDoc(
														$author$project$Type$ListDocument$OnNextPage($author$project$Type$ListDocument$Completed))))
											]),
										_List_fromArray(
											[
												A2($author$project$Material$Styled$Icon$keyboardArrowRight, _List_Nil, _List_Nil)
											]))
									]))
							]));
				}
			case 'Template':
				if (!template.b) {
					return A2($author$project$Page$ListDocument$EmptyDocument$view, $author$project$Page$ListDocument$noDocTitle, $author$project$Page$ListDocument$noDocSubTitle);
				} else {
					return A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ListDocument$styles.cardContainer)
									]),
								A2(
									$elm$core$List$map,
									A2($author$project$Page$ListDocument$Template$view, appModel, authModel),
									template)),
								A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ListDocument$styles.arrowBtnContainer)
									]),
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$div,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$css(
												_List_fromArray(
													[
														$rtfeldman$elm_css$Css$paddingRight(
														$rtfeldman$elm_css$Css$px(5))
													]))
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(
												listDocumentLanguageData.page + (' ' + ($elm$core$String$fromInt(listDocModel.pageNumber + 1) + ' :')))
											])),
										(!listDocModel.pageNumber) ? A2(
										$author$project$Material$Styled$Button$button,
										_List_fromArray(
											[
												$author$project$Material$Styled$Button$theme($author$project$Material$Styled$Button$grey),
												$author$project$Material$Styled$Button$styles($author$project$Page$ListDocument$styles.button),
												$author$project$Material$Styled$Button$disabled(true),
												$author$project$Material$Styled$Button$onClick(
												$author$project$Types$OnAuth(
													$author$project$Types$OnListDoc(
														$author$project$Type$ListDocument$OnPreviousPage($author$project$Type$ListDocument$Template))))
											]),
										_List_fromArray(
											[
												A2($author$project$Material$Styled$Icon$keyboardArrowLeft, _List_Nil, _List_Nil)
											])) : A2(
										$author$project$Material$Styled$Button$button,
										_List_fromArray(
											[
												$author$project$Material$Styled$Button$theme($author$project$Material$Styled$Button$white),
												$author$project$Material$Styled$Button$styles($author$project$Page$ListDocument$styles.button),
												$author$project$Material$Styled$Button$onClick(
												$author$project$Types$OnAuth(
													$author$project$Types$OnListDoc(
														$author$project$Type$ListDocument$OnPreviousPage($author$project$Type$ListDocument$Template))))
											]),
										_List_fromArray(
											[
												A2($author$project$Material$Styled$Icon$keyboardArrowLeft, _List_Nil, _List_Nil)
											])),
										(_Utils_cmp((listDocModel.pageNumber + 1) * 10, listDocModel.docsCount) > -1) ? A2(
										$author$project$Material$Styled$Button$button,
										_List_fromArray(
											[
												$author$project$Material$Styled$Button$theme($author$project$Material$Styled$Button$grey),
												$author$project$Material$Styled$Button$styles($author$project$Page$ListDocument$styles.button),
												$author$project$Material$Styled$Button$disabled(true),
												$author$project$Material$Styled$Button$onClick(
												$author$project$Types$OnAuth(
													$author$project$Types$OnListDoc(
														$author$project$Type$ListDocument$OnNextPage($author$project$Type$ListDocument$Template))))
											]),
										_List_fromArray(
											[
												A2($author$project$Material$Styled$Icon$keyboardArrowRight, _List_Nil, _List_Nil)
											])) : A2(
										$author$project$Material$Styled$Button$button,
										_List_fromArray(
											[
												$author$project$Material$Styled$Button$theme($author$project$Material$Styled$Button$white),
												$author$project$Material$Styled$Button$styles($author$project$Page$ListDocument$styles.button),
												$author$project$Material$Styled$Button$onClick(
												$author$project$Types$OnAuth(
													$author$project$Types$OnListDoc(
														$author$project$Type$ListDocument$OnNextPage($author$project$Type$ListDocument$Template))))
											]),
										_List_fromArray(
											[
												A2($author$project$Material$Styled$Icon$keyboardArrowRight, _List_Nil, _List_Nil)
											]))
									]))
							]));
				}
			default:
				if (!submission.b) {
					return A2($author$project$Page$ListDocument$EmptyDocument$view, $author$project$Page$ListDocument$noDocTitle, $author$project$Page$ListDocument$noDocSubTitle);
				} else {
					var _v8 = filterSubmissions(submission);
					if (!_v8.b) {
						return A2($author$project$Page$ListDocument$EmptyDocument$view, $author$project$Page$ListDocument$noSearchResultTitle, $author$project$Page$ListDocument$noSearchResultSubTitle);
					} else {
						return A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ListDocument$styles.cardContainer)
										]),
									A2(
										$elm$core$List$map,
										$author$project$Page$ListDocument$Submission$view(appModel.languageSwitchModel),
										filterSubmissions(submission))),
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ListDocument$styles.arrowBtnContainer)
										]),
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$div,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$css(
													_List_fromArray(
														[
															$rtfeldman$elm_css$Css$paddingRight(
															$rtfeldman$elm_css$Css$px(5))
														]))
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(
													listDocumentLanguageData.page + (' ' + ($elm$core$String$fromInt(listDocModel.pageNumber + 1) + ' :')))
												])),
											(!listDocModel.pageNumber) ? A2(
											$author$project$Material$Styled$Button$button,
											_List_fromArray(
												[
													$author$project$Material$Styled$Button$theme($author$project$Material$Styled$Button$grey),
													$author$project$Material$Styled$Button$styles($author$project$Page$ListDocument$styles.button),
													$author$project$Material$Styled$Button$disabled(true),
													$author$project$Material$Styled$Button$onClick(
													$author$project$Types$OnAuth(
														$author$project$Types$OnListDoc(
															$author$project$Type$ListDocument$OnPreviousPage($author$project$Type$ListDocument$Submission))))
												]),
											_List_fromArray(
												[
													A2($author$project$Material$Styled$Icon$keyboardArrowLeft, _List_Nil, _List_Nil)
												])) : A2(
											$author$project$Material$Styled$Button$button,
											_List_fromArray(
												[
													$author$project$Material$Styled$Button$theme($author$project$Material$Styled$Button$white),
													$author$project$Material$Styled$Button$styles($author$project$Page$ListDocument$styles.button),
													$author$project$Material$Styled$Button$onClick(
													$author$project$Types$OnAuth(
														$author$project$Types$OnListDoc(
															$author$project$Type$ListDocument$OnPreviousPage($author$project$Type$ListDocument$Submission))))
												]),
											_List_fromArray(
												[
													A2($author$project$Material$Styled$Icon$keyboardArrowLeft, _List_Nil, _List_Nil)
												])),
											(_Utils_cmp((listDocModel.pageNumber + 1) * 10, listDocModel.docsCount) > -1) ? A2(
											$author$project$Material$Styled$Button$button,
											_List_fromArray(
												[
													$author$project$Material$Styled$Button$theme($author$project$Material$Styled$Button$grey),
													$author$project$Material$Styled$Button$styles($author$project$Page$ListDocument$styles.button),
													$author$project$Material$Styled$Button$disabled(true),
													$author$project$Material$Styled$Button$onClick(
													$author$project$Types$OnAuth(
														$author$project$Types$OnListDoc(
															$author$project$Type$ListDocument$OnNextPage($author$project$Type$ListDocument$Submission))))
												]),
											_List_fromArray(
												[
													A2($author$project$Material$Styled$Icon$keyboardArrowRight, _List_Nil, _List_Nil)
												])) : A2(
											$author$project$Material$Styled$Button$button,
											_List_fromArray(
												[
													$author$project$Material$Styled$Button$theme($author$project$Material$Styled$Button$white),
													$author$project$Material$Styled$Button$styles($author$project$Page$ListDocument$styles.button),
													$author$project$Material$Styled$Button$onClick(
													$author$project$Types$OnAuth(
														$author$project$Types$OnListDoc(
															$author$project$Type$ListDocument$OnNextPage($author$project$Type$ListDocument$Submission))))
												]),
											_List_fromArray(
												[
													A2($author$project$Material$Styled$Icon$keyboardArrowRight, _List_Nil, _List_Nil)
												]))
										]))
								]));
					}
				}
		}
	});
var $author$project$Material$Styled$Snackbar$success = {base: $author$project$Material$Styled$Color$green400, text: $author$project$Material$Styled$Color$white};
var $author$project$Type$ListDocument$FromDate = function (a) {
	return {$: 'FromDate', a: a};
};
var $author$project$Type$ListDocument$OnSearchDateChange = function (a) {
	return {$: 'OnSearchDateChange', a: a};
};
var $author$project$Type$ListDocument$OnSearchDocument = function (a) {
	return {$: 'OnSearchDocument', a: a};
};
var $author$project$Type$ListDocument$OnSearchQueryChange = function (a) {
	return {$: 'OnSearchQueryChange', a: a};
};
var $author$project$Type$ListDocument$ResetDateSearch = {$: 'ResetDateSearch'};
var $author$project$Type$ListDocument$ResetSearchField = function (a) {
	return {$: 'ResetSearchField', a: a};
};
var $author$project$Type$ListDocument$ToDate = function (a) {
	return {$: 'ToDate', a: a};
};
var $author$project$Page$ListDocument$Header$posixToDateString = F2(
	function (posix, timezone) {
		return A3(
			$ryannhg$date_format$DateFormat$format,
			_List_fromArray(
				[
					$ryannhg$date_format$DateFormat$yearNumber,
					$ryannhg$date_format$DateFormat$text('-'),
					$ryannhg$date_format$DateFormat$monthFixed,
					$ryannhg$date_format$DateFormat$text('-'),
					$ryannhg$date_format$DateFormat$dayOfMonthFixed
				]),
			timezone,
			posix);
	});
var $author$project$Page$ListDocument$Header$styles = {
	bottomContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100)),
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$flexEnd),
			A2(
			$rtfeldman$elm_css$Css$Media$withMediaQuery,
			_List_fromArray(
				['screen and (max-width: 850px)']),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center)
				])),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center)
		]),
	container: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexWrap($rtfeldman$elm_css$Css$wrap),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceBetween)
		]),
	dateBox: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$maxWidth(
			$rtfeldman$elm_css$Css$px(220)),
			A2(
			$rtfeldman$elm_css$Css$margin2,
			$rtfeldman$elm_css$Css$px(0),
			$rtfeldman$elm_css$Css$px(3)),
			A3(
			$rtfeldman$elm_css$Css$flex3,
			$rtfeldman$elm_css$Css$num(1),
			$rtfeldman$elm_css$Css$num(1),
			$rtfeldman$elm_css$Css$pct(50))
		]),
	leftContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(17)),
			A2(
			$rtfeldman$elm_css$Css$Media$withMediaQuery,
			_List_fromArray(
				['screen and (max-width: 850px)']),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$width(
					$rtfeldman$elm_css$Css$pct(100))
				]))
		]),
	middleContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$row),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$end),
			A2(
			$rtfeldman$elm_css$Css$Media$withMediaQuery,
			_List_fromArray(
				['screen and (max-width: 850px)']),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$width(
					$rtfeldman$elm_css$Css$pct(100)),
					$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center)
				]))
		]),
	middleRightContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$row),
			$rtfeldman$elm_css$Css$flexWrap($rtfeldman$elm_css$Css$wrap),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(83)),
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$flexEnd),
			A2(
			$rtfeldman$elm_css$Css$Media$withMediaQuery,
			_List_fromArray(
				['screen and (max-width: 850px)']),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$width(
					$rtfeldman$elm_css$Css$pct(100)),
					$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center)
				]))
		]),
	resetBtn: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$border(
			$rtfeldman$elm_css$Css$px(0)),
			$rtfeldman$elm_css$Css$padding(
			$rtfeldman$elm_css$Css$px(10)),
			$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer),
			$rtfeldman$elm_css$Css$backgroundColor($rtfeldman$elm_css$Css$transparent)
		]),
	resetIcon: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(18))
		]),
	resetTextBtn: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$padding(
			$rtfeldman$elm_css$Css$px(10)),
			$rtfeldman$elm_css$Css$marginLeft(
			$rtfeldman$elm_css$Css$px(15)),
			$rtfeldman$elm_css$Css$marginBottom(
			$rtfeldman$elm_css$Css$px(20)),
			$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$black),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(48)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(100))
		]),
	rightContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$row),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$flexEnd),
			A2(
			$rtfeldman$elm_css$Css$Media$withMediaQuery,
			_List_fromArray(
				['screen and (max-width: 850px)']),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$width(
					$rtfeldman$elm_css$Css$pct(100)),
					$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
					A2(
					$rtfeldman$elm_css$Css$margin2,
					$rtfeldman$elm_css$Css$px(16),
					$rtfeldman$elm_css$Css$px(0))
				]))
		]),
	searchBox: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(379)),
			A4(
			$rtfeldman$elm_css$Css$margin4,
			$rtfeldman$elm_css$Css$px(0),
			$rtfeldman$elm_css$Css$px(8),
			$rtfeldman$elm_css$Css$px(20),
			$rtfeldman$elm_css$Css$px(0)),
			A2(
			$rtfeldman$elm_css$Css$Media$withMediaQuery,
			_List_fromArray(
				['screen and (max-width: 550px)']),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$width(
					$rtfeldman$elm_css$Css$pct(100))
				])),
			A2(
			$rtfeldman$elm_css$Css$Media$withMediaQuery,
			_List_fromArray(
				['screen and (max-width: 850px)']),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$width(
					$rtfeldman$elm_css$Css$px(490))
				]))
		]),
	searchBtn: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$padding(
			$rtfeldman$elm_css$Css$px(10)),
			$rtfeldman$elm_css$Css$marginLeft(
			$rtfeldman$elm_css$Css$px(15)),
			$rtfeldman$elm_css$Css$marginBottom(
			$rtfeldman$elm_css$Css$px(20)),
			$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$white),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(48)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(100))
		]),
	searchIcon: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(24)),
			A4(
			$rtfeldman$elm_css$Css$margin4,
			$rtfeldman$elm_css$Css$px(0),
			$rtfeldman$elm_css$Css$px(0),
			$rtfeldman$elm_css$Css$px(20),
			$rtfeldman$elm_css$Css$px(-34)),
			$rtfeldman$elm_css$Css$zIndex(
			$rtfeldman$elm_css$Css$int(1)),
			$rtfeldman$elm_css$Css$backgroundColor(
			$rtfeldman$elm_css$Css$hex('#ffffff'))
		]),
	select: _List_fromArray(
		[
			A3(
			$rtfeldman$elm_css$Css$flex3,
			$rtfeldman$elm_css$Css$num(1),
			$rtfeldman$elm_css$Css$num(1),
			$rtfeldman$elm_css$Css$pct(30)),
			A2(
			$rtfeldman$elm_css$Css$margin2,
			$rtfeldman$elm_css$Css$px(0),
			$rtfeldman$elm_css$Css$px(16)),
			$rtfeldman$elm_css$Css$maxWidth(
			$rtfeldman$elm_css$Css$px(210)),
			A2(
			$rtfeldman$elm_css$Css$Media$withMediaQuery,
			_List_fromArray(
				['screen and (max-width: 850px)']),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Css$margin2,
					$rtfeldman$elm_css$Css$px(0),
					$rtfeldman$elm_css$Css$px(5))
				]))
		]),
	title: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100)),
			A2(
			$rtfeldman$elm_css$Css$Media$withMediaQuery,
			_List_fromArray(
				['screen and (max-width: 850px)']),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center)
				]))
		])
};
var $author$project$Page$ListDocument$Header$toDocumentType = function (docType) {
	var msg = function (documentType) {
		return $author$project$Types$OnAuth(
			$author$project$Types$OnListDoc(
				$author$project$Type$ListDocument$OnTypeChange(documentType)));
	};
	switch (docType) {
		case 'Received':
			return msg($author$project$Type$ListDocument$Received);
		case 'Sent':
			return msg($author$project$Type$ListDocument$Sent);
		case 'Completed':
			return msg($author$project$Type$ListDocument$Completed);
		case 'Template':
			return msg($author$project$Type$ListDocument$Template);
		case 'Submission':
			return msg($author$project$Type$ListDocument$Submission);
		default:
			return $author$project$Types$Noop;
	}
};
var $author$project$Page$ListDocument$Header$toTypeString = function (docType) {
	switch (docType.$) {
		case 'Received':
			return 'Received';
		case 'Sent':
			return 'Sent';
		case 'Completed':
			return 'Completed';
		case 'Template':
			return 'Template';
		default:
			return 'Submission';
	}
};
var $author$project$Page$ListDocument$Header$view = F4(
	function (languageSwitchModel, listDocModel, time, timezone) {
		var headerLanguageData = languageSwitchModel.allLanguageData.location.dashboard;
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ListDocument$Header$styles.container)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ListDocument$Header$styles.leftContainer)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$h1,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ListDocument$Header$styles.title)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Documents')
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ListDocument$Header$styles.middleRightContainer)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ListDocument$Header$styles.middleContainer)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Material$Styled$Select$select,
									_List_fromArray(
										[
											$author$project$Material$Styled$Select$label('Filter By:'),
											$author$project$Material$Styled$Select$containerStyles($author$project$Page$ListDocument$Header$styles.select),
											$author$project$Material$Styled$Select$value(
											$author$project$Page$ListDocument$Header$toTypeString(listDocModel.selectedType)),
											$author$project$Material$Styled$Select$onChange($author$project$Page$ListDocument$Header$toDocumentType)
										]),
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$option,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$value('Received')
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(headerLanguageData.incomingDocuments)
												])),
											A2(
											$rtfeldman$elm_css$Html$Styled$option,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$value('Sent')
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(headerLanguageData.outgoingDocuments)
												])),
											A2(
											$rtfeldman$elm_css$Html$Styled$option,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$value('Completed')
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(headerLanguageData.completedDocuments)
												])),
											A2(
											$rtfeldman$elm_css$Html$Styled$option,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$value('Template')
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(headerLanguageData.template)
												])),
											A2(
											$rtfeldman$elm_css$Html$Styled$option,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$value('Submission')
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(headerLanguageData.submission)
												]))
										]))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ListDocument$Header$styles.rightContainer)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Material$Styled$Input$date,
									_List_fromArray(
										[
											$author$project$Material$Styled$Input$containerStyles($author$project$Page$ListDocument$Header$styles.dateBox),
											$author$project$Material$Styled$Input$label('From'),
											$author$project$Material$Styled$Input$value(
											(listDocModel.searchFromDate === '') ? 'dd/mm/yyyy' : listDocModel.searchFromDate),
											$author$project$Material$Styled$Input$onInput(
											A2(
												$elm$core$Basics$composeL,
												A2(
													$elm$core$Basics$composeL,
													A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnListDoc),
													$author$project$Type$ListDocument$OnSearchDateChange),
												$author$project$Type$ListDocument$FromDate)),
											$author$project$Material$Styled$Input$max(
											(listDocModel.searchToDate === '') ? A2($author$project$Page$ListDocument$Header$posixToDateString, time, timezone) : listDocModel.searchToDate)
										]),
									_List_Nil),
									A2(
									$author$project$Material$Styled$Input$date,
									_List_fromArray(
										[
											$author$project$Material$Styled$Input$containerStyles($author$project$Page$ListDocument$Header$styles.dateBox),
											$author$project$Material$Styled$Input$label('To'),
											$author$project$Material$Styled$Input$value(
											(listDocModel.searchToDate === '') ? 'dd/mm/yyyy' : listDocModel.searchToDate),
											$author$project$Material$Styled$Input$onInput(
											A2(
												$elm$core$Basics$composeL,
												A2(
													$elm$core$Basics$composeL,
													A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnListDoc),
													$author$project$Type$ListDocument$OnSearchDateChange),
												$author$project$Type$ListDocument$ToDate)),
											$author$project$Material$Styled$Input$min(listDocModel.searchFromDate),
											$author$project$Material$Styled$Input$max(
											A2($author$project$Page$ListDocument$Header$posixToDateString, time, timezone))
										]),
									_List_Nil),
									A2(
									$rtfeldman$elm_css$Html$Styled$button,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Events$onClick(
											A3($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnListDoc, $author$project$Type$ListDocument$ResetDateSearch)),
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ListDocument$Header$styles.resetBtn)
										]),
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$img,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$src($author$project$View$Theme$images.close),
													$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ListDocument$Header$styles.resetIcon)
												]),
											_List_Nil)
										]))
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ListDocument$Header$styles.bottomContainer)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Material$Styled$Input$text,
							_List_fromArray(
								[
									$author$project$Material$Styled$Input$containerStyles($author$project$Page$ListDocument$Header$styles.searchBox),
									$author$project$Material$Styled$Input$label('Search Document'),
									$author$project$Material$Styled$Input$value(listDocModel.searchQuery),
									$author$project$Material$Styled$Input$onInput(
									A2(
										$elm$core$Basics$composeL,
										A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnListDoc),
										$author$project$Type$ListDocument$OnSearchQueryChange))
								]),
							_List_Nil),
							A2(
							$rtfeldman$elm_css$Html$Styled$img,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$src($author$project$View$Theme$images.search),
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ListDocument$Header$styles.searchIcon)
								]),
							_List_Nil),
							A2(
							$author$project$Material$Styled$Button$button,
							_List_fromArray(
								[
									$author$project$Material$Styled$Button$theme($author$project$Material$Styled$Button$blue),
									$author$project$Material$Styled$Button$styles($author$project$Page$ListDocument$Header$styles.searchBtn),
									$author$project$Material$Styled$Button$onClick(
									$author$project$Types$OnAuth(
										$author$project$Types$OnListDoc(
											$author$project$Type$ListDocument$OnSearchDocument(listDocModel.selectedType))))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Search')
								])),
							A2(
							$author$project$Material$Styled$Button$button,
							_List_fromArray(
								[
									$author$project$Material$Styled$Button$theme($author$project$Material$Styled$Button$white),
									$author$project$Material$Styled$Button$styles($author$project$Page$ListDocument$Header$styles.resetTextBtn),
									$author$project$Material$Styled$Button$onClick(
									$author$project$Types$OnAuth(
										$author$project$Types$OnListDoc(
											$author$project$Type$ListDocument$ResetSearchField(listDocModel.selectedType))))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Reset')
								]))
						]))
				]));
	});
var $author$project$Page$ListDocument$Loading$styles = {
	container: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(15)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100)),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(200))
		]),
	text: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginBottom(
			$rtfeldman$elm_css$Css$px(24)),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(24)),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$grey700)
		])
};
var $author$project$Page$ListDocument$Loading$view = A2(
	$author$project$Material$Styled$Card$card,
	_List_fromArray(
		[
			$author$project$Material$Styled$Card$containerStyles($author$project$Page$ListDocument$Loading$styles.container)
		]),
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Html$Styled$span,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ListDocument$Loading$styles.text)
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text('Loading Your Documents....')
				])),
			A2($author$project$Material$Styled$ProgressBar$linear, _List_Nil, _List_Nil)
		]));
var $author$project$Type$ListDocument$OnErrorClose = {$: 'OnErrorClose'};
var $author$project$Page$ListDocument$MessageBanner$errorBodyToString = function (error) {
	if (error.$ === 'DeleteDocumentError') {
		var err = error.a;
		return err;
	} else {
		var err = error.a;
		return err;
	}
};
var $author$project$Page$ListDocument$MessageBanner$errorHeaderToString = function (error) {
	if (error.$ === 'DeleteDocumentError') {
		return 'Delete Document Action Error';
	} else {
		return 'Delete Template Action Error';
	}
};
var $author$project$Page$ListDocument$MessageBanner$styles = {
	container: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$absolute),
			$rtfeldman$elm_css$Css$top($rtfeldman$elm_css$Css$zero),
			$rtfeldman$elm_css$Css$left($rtfeldman$elm_css$Css$zero),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100)),
			$rtfeldman$elm_css$Css$boxSizing($rtfeldman$elm_css$Css$borderBox),
			$rtfeldman$elm_css$Css$padding(
			$rtfeldman$elm_css$Css$px(20))
		])
};
var $author$project$Page$ListDocument$MessageBanner$view = function (bannerMsg) {
	var error = bannerMsg.a;
	return A2(
		$author$project$Material$Styled$Banner$banner,
		_List_fromArray(
			[
				$author$project$Material$Styled$Banner$containerStyles($author$project$Page$ListDocument$MessageBanner$styles.container),
				$author$project$Material$Styled$Banner$theme($author$project$Material$Styled$Banner$errorTheme),
				$author$project$Material$Styled$Banner$title(
				$author$project$Page$ListDocument$MessageBanner$errorHeaderToString(error)),
				$author$project$Material$Styled$Banner$body(
				$rtfeldman$elm_css$Html$Styled$text(
					$author$project$Page$ListDocument$MessageBanner$errorBodyToString(error))),
				$author$project$Material$Styled$Banner$closeIconAttributes(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Svg$Styled$Events$onClick(
						$author$project$Types$OnAuth(
							$author$project$Types$OnListDoc($author$project$Type$ListDocument$OnErrorClose)))
					]))
			]),
		_List_Nil);
};
var $author$project$Type$ListDocument$OnCloseModal = {$: 'OnCloseModal'};
var $author$project$Type$ListDocument$OnDeleteDocument = function (a) {
	return {$: 'OnDeleteDocument', a: a};
};
var $author$project$Page$ListDocument$Modal$styles = {
	button: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginLeft(
			$rtfeldman$elm_css$Css$px(10)),
			$rtfeldman$elm_css$Css$maxWidth(
			$rtfeldman$elm_css$Css$px(200))
		]),
	dashboardBtn: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(10)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(190))
		]),
	docStatusBtn: _List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Css$margin2,
			$rtfeldman$elm_css$Css$em(0.6),
			$rtfeldman$elm_css$Css$zero)
		]),
	footer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$row),
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceBetween),
			A3(
			$rtfeldman$elm_css$Css$padding3,
			$rtfeldman$elm_css$Css$px(20),
			$rtfeldman$elm_css$Css$zero,
			$rtfeldman$elm_css$Css$zero)
		]),
	icon: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$boxShadow($rtfeldman$elm_css$Css$none),
			$rtfeldman$elm_css$Css$transform(
			A2(
				$rtfeldman$elm_css$Css$translate2,
				$rtfeldman$elm_css$Css$px(20),
				$rtfeldman$elm_css$Css$px(-15))),
			$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer),
			$rtfeldman$elm_css$Css$padding(
			$rtfeldman$elm_css$Css$px(10))
		]),
	modalBody: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(12)),
			$rtfeldman$elm_css$Css$fontWeight(
			$rtfeldman$elm_css$Css$int(400)),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$blueGrey500)
		]),
	modalBodyContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$em(1))
		]),
	modalBtns: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$rowReverse),
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceBetween)
		]),
	modalContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$vw(70)),
			$rtfeldman$elm_css$Css$maxWidth(
			$rtfeldman$elm_css$Css$px(500))
		]),
	modalHeader: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$row),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$flexStart),
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceBetween)
		]),
	modalHeaderTxt: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(20)),
			$rtfeldman$elm_css$Css$fontWeight(
			$rtfeldman$elm_css$Css$int(500))
		]),
	progressBar: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(10))
		])
};
var $author$project$Page$ListDocument$Modal$deleteDocumentModal = function (docId) {
	return A2(
		$author$project$Material$Styled$Modal$modal,
		_List_fromArray(
			[
				$author$project$Material$Styled$Modal$open(true),
				$author$project$Material$Styled$Modal$contentContainerstyles($author$project$Page$ListDocument$Modal$styles.modalContainer)
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ListDocument$Modal$styles.modalHeader)
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ListDocument$Modal$styles.modalHeaderTxt)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('Delete Document')
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$img,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ListDocument$Modal$styles.icon),
								$rtfeldman$elm_css$Html$Styled$Attributes$src($author$project$View$Theme$images.close),
								$rtfeldman$elm_css$Html$Styled$Events$onClick(
								$author$project$Types$OnAuth(
									$author$project$Types$OnListDoc($author$project$Type$ListDocument$OnCloseModal)))
							]),
						_List_Nil)
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('Do you want to delete this document?')
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ListDocument$Modal$styles.footer)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Material$Styled$Button$button,
						_List_fromArray(
							[
								$author$project$Material$Styled$Button$styles($author$project$Page$ListDocument$Modal$styles.button),
								function () {
								var defaultTextTheme = $author$project$Material$Styled$Button$greyText;
								return $author$project$Material$Styled$Button$theme(
									_Utils_update(
										defaultTextTheme,
										{base: $author$project$Material$Styled$Color$grey200String}));
							}(),
								$author$project$Material$Styled$Button$onClick(
								$author$project$Types$OnAuth(
									$author$project$Types$OnListDoc($author$project$Type$ListDocument$OnCloseModal)))
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('Cancel')
							])),
						A2(
						$author$project$Material$Styled$Button$button,
						_List_fromArray(
							[
								$author$project$Material$Styled$Button$styles($author$project$Page$ListDocument$Modal$styles.button),
								$author$project$Material$Styled$Button$onClick(
								$author$project$Types$OnAuth(
									$author$project$Types$OnListDoc(
										$author$project$Type$ListDocument$OnDeleteDocument(docId))))
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('Confirm')
							]))
					]))
			]));
};
var $author$project$Type$ListDocument$OnNavigateToDashboard = {$: 'OnNavigateToDashboard'};
var $author$project$Page$ListDocument$Modal$deleteDocumentSuccess = A2(
	$author$project$Material$Styled$Modal$modal,
	_List_fromArray(
		[
			$author$project$Material$Styled$Modal$open(true),
			$author$project$Material$Styled$Modal$contentContainerstyles($author$project$Page$ListDocument$Modal$styles.modalContainer)
		]),
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ListDocument$Modal$styles.modalHeader)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ListDocument$Modal$styles.modalHeaderTxt)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('Delete Document')
						]))
				])),
			A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ListDocument$Modal$styles.modalBodyContainer)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ListDocument$Modal$styles.modalBody)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('Please check your email to delete the document.')
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ListDocument$Modal$styles.modalBtns)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Material$Styled$Button$button,
							_List_fromArray(
								[
									$author$project$Material$Styled$Button$theme($author$project$Material$Styled$Button$blue),
									$author$project$Material$Styled$Button$styles($author$project$Page$ListDocument$Modal$styles.dashboardBtn),
									$author$project$Material$Styled$Button$onClick(
									$author$project$Types$OnAuth(
										$author$project$Types$OnListDoc($author$project$Type$ListDocument$OnNavigateToDashboard)))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Back To Dashboard')
								]))
						]))
				]))
		]));
var $author$project$Type$ListDocument$OnDeleteTemplate = function (a) {
	return {$: 'OnDeleteTemplate', a: a};
};
var $author$project$Page$ListDocument$Modal$deleteTemplateModal = function (templateId) {
	return A2(
		$author$project$Material$Styled$Modal$modal,
		_List_fromArray(
			[
				$author$project$Material$Styled$Modal$open(true),
				$author$project$Material$Styled$Modal$contentContainerstyles($author$project$Page$ListDocument$Modal$styles.modalContainer)
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ListDocument$Modal$styles.modalHeader)
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ListDocument$Modal$styles.modalHeaderTxt)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('Delete Template')
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$img,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ListDocument$Modal$styles.icon),
								$rtfeldman$elm_css$Html$Styled$Attributes$src($author$project$View$Theme$images.close),
								$rtfeldman$elm_css$Html$Styled$Events$onClick(
								$author$project$Types$OnAuth(
									$author$project$Types$OnListDoc($author$project$Type$ListDocument$OnCloseModal)))
							]),
						_List_Nil)
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('Do you want to delete this template?')
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ListDocument$Modal$styles.footer)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Material$Styled$Button$button,
						_List_fromArray(
							[
								$author$project$Material$Styled$Button$styles($author$project$Page$ListDocument$Modal$styles.button),
								function () {
								var defaultTextTheme = $author$project$Material$Styled$Button$greyText;
								return $author$project$Material$Styled$Button$theme(
									_Utils_update(
										defaultTextTheme,
										{base: $author$project$Material$Styled$Color$grey200String}));
							}(),
								$author$project$Material$Styled$Button$onClick(
								$author$project$Types$OnAuth(
									$author$project$Types$OnListDoc($author$project$Type$ListDocument$OnCloseModal)))
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('Cancel')
							])),
						A2(
						$author$project$Material$Styled$Button$button,
						_List_fromArray(
							[
								$author$project$Material$Styled$Button$styles($author$project$Page$ListDocument$Modal$styles.button),
								$author$project$Material$Styled$Button$onClick(
								$author$project$Types$OnAuth(
									$author$project$Types$OnListDoc(
										$author$project$Type$ListDocument$OnDeleteTemplate(templateId))))
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('Confirm')
							]))
					]))
			]));
};
var $author$project$Page$ListDocument$Modal$deleteTemplateSuccess = A2(
	$author$project$Material$Styled$Modal$modal,
	_List_fromArray(
		[
			$author$project$Material$Styled$Modal$open(true),
			$author$project$Material$Styled$Modal$contentContainerstyles($author$project$Page$ListDocument$Modal$styles.modalContainer)
		]),
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ListDocument$Modal$styles.modalHeader)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ListDocument$Modal$styles.modalHeaderTxt)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('Delete Template')
						]))
				])),
			A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ListDocument$Modal$styles.modalBodyContainer)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ListDocument$Modal$styles.modalBody)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('Please check your email to delete the template.')
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ListDocument$Modal$styles.modalBtns)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Material$Styled$Button$button,
							_List_fromArray(
								[
									$author$project$Material$Styled$Button$theme($author$project$Material$Styled$Button$blue),
									$author$project$Material$Styled$Button$styles($author$project$Page$ListDocument$Modal$styles.dashboardBtn),
									$author$project$Material$Styled$Button$onClick(
									$author$project$Types$OnAuth(
										$author$project$Types$OnListDoc($author$project$Type$ListDocument$OnNavigateToDashboard)))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Back To Dashboard')
								]))
						]))
				]))
		]));
var $author$project$Page$ListDocument$Modal$downloadDocumentModal = A2(
	$author$project$Material$Styled$Modal$modal,
	_List_fromArray(
		[
			$author$project$Material$Styled$Modal$open(true),
			$author$project$Material$Styled$Modal$contentContainerstyles($author$project$Page$ListDocument$Modal$styles.modalContainer)
		]),
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ListDocument$Modal$styles.modalHeader)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ListDocument$Modal$styles.modalHeaderTxt)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('Downloading Document')
						]))
				])),
			A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ListDocument$Modal$styles.modalBodyContainer)
				]),
			_List_fromArray(
				[
					A2($author$project$Material$Styled$ProgressBar$linear, _List_Nil, _List_Nil)
				]))
		]));
var $author$project$Page$ListDocument$Modal$loadingModal = A2(
	$author$project$Material$Styled$Modal$modal,
	_List_fromArray(
		[
			$author$project$Material$Styled$Modal$open(true),
			$author$project$Material$Styled$Modal$contentContainerstyles($author$project$Page$ListDocument$Modal$styles.modalContainer)
		]),
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ListDocument$Modal$styles.modalHeader)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ListDocument$Modal$styles.modalHeaderTxt)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('Loading...')
						]))
				])),
			A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ListDocument$Modal$styles.modalBody)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('Creating request, please wait')
						])),
					A2(
					$author$project$Material$Styled$ProgressBar$linear,
					_List_fromArray(
						[
							$author$project$Material$Styled$ProgressBar$containerStyle($author$project$Page$ListDocument$Modal$styles.progressBar)
						]),
					_List_Nil)
				]))
		]));
var $author$project$Type$ListDocument$OnRequestTemplateClick = function (a) {
	return {$: 'OnRequestTemplateClick', a: a};
};
var $author$project$Page$ListDocument$Modal$requestTemplateModal = function (slug) {
	return A2(
		$author$project$Material$Styled$Modal$modal,
		_List_fromArray(
			[
				$author$project$Material$Styled$Modal$open(true),
				$author$project$Material$Styled$Modal$contentContainerstyles($author$project$Page$ListDocument$Modal$styles.modalContainer)
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ListDocument$Modal$styles.modalHeader)
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ListDocument$Modal$styles.modalHeaderTxt)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('Fill Template  Request')
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$img,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ListDocument$Modal$styles.icon),
								$rtfeldman$elm_css$Html$Styled$Attributes$src($author$project$View$Theme$images.close),
								$rtfeldman$elm_css$Html$Styled$Events$onClick(
								$author$project$Types$OnAuth(
									$author$project$Types$OnListDoc($author$project$Type$ListDocument$OnCloseModal)))
							]),
						_List_Nil)
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ListDocument$Modal$styles.modalBody)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('The following template is a single role template, please confirm if you are requesting to fill this template.')
							])),
						A2(
						$author$project$Material$Styled$Button$button,
						_List_fromArray(
							[
								$author$project$Material$Styled$Button$styles($author$project$Page$ListDocument$Modal$styles.docStatusBtn),
								$author$project$Material$Styled$Button$theme($author$project$Material$Styled$Button$blue),
								$author$project$Material$Styled$Button$onClick(
								$author$project$Types$OnAuth(
									$author$project$Types$OnListDoc(
										$author$project$Type$ListDocument$OnRequestTemplateClick(slug))))
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('Confirm ')
							])),
						A2(
						$author$project$Material$Styled$Button$button,
						_List_fromArray(
							[
								$author$project$Material$Styled$Button$styles($author$project$Page$ListDocument$Modal$styles.docStatusBtn),
								$author$project$Material$Styled$Button$theme($author$project$Material$Styled$Button$default),
								$author$project$Material$Styled$Button$onClick(
								$author$project$Types$OnAuth(
									$author$project$Types$OnListDoc($author$project$Type$ListDocument$OnCloseModal)))
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('Back ')
							]))
					]))
			]));
};
var $author$project$Page$ListDocument$Modal$requestTemplateSuccess = A2(
	$author$project$Material$Styled$Modal$modal,
	_List_fromArray(
		[
			$author$project$Material$Styled$Modal$open(true),
			$author$project$Material$Styled$Modal$contentContainerstyles($author$project$Page$ListDocument$Modal$styles.modalContainer)
		]),
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ListDocument$Modal$styles.modalHeader)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ListDocument$Modal$styles.modalHeaderTxt)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('Success')
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$img,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ListDocument$Modal$styles.icon),
							$rtfeldman$elm_css$Html$Styled$Attributes$src($author$project$View$Theme$images.close),
							$rtfeldman$elm_css$Html$Styled$Events$onClick(
							$author$project$Types$OnAuth(
								$author$project$Types$OnListDoc($author$project$Type$ListDocument$OnCloseModal)))
						]),
					_List_Nil)
				])),
			A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ListDocument$Modal$styles.modalBody)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('You can now sign the document from your incoming folder or access it from your email.')
						])),
					A2(
					$author$project$Material$Styled$Button$button,
					_List_fromArray(
						[
							$author$project$Material$Styled$Button$styles($author$project$Page$ListDocument$Modal$styles.docStatusBtn),
							$author$project$Material$Styled$Button$theme($author$project$Material$Styled$Button$default),
							$author$project$Material$Styled$Button$onClick(
							$author$project$Types$OnAuth(
								$author$project$Types$OnListDoc($author$project$Type$ListDocument$OnNavigateToDashboard)))
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('Back ')
						]))
				]))
		]));
var $author$project$Page$ListDocument$Modal$view = function (model) {
	var _v0 = model.modal;
	if (_v0.$ === 'Nothing') {
		return $rtfeldman$elm_css$Html$Styled$text('');
	} else {
		var modal = _v0.a;
		switch (modal.$) {
			case 'DeleteSuccess':
				return $author$project$Page$ListDocument$Modal$deleteDocumentSuccess;
			case 'DeleteDocument':
				var docId = modal.a;
				return $author$project$Page$ListDocument$Modal$deleteDocumentModal(docId);
			case 'DeleteTemplate':
				var templateId = modal.a;
				return $author$project$Page$ListDocument$Modal$deleteTemplateModal(templateId);
			case 'DeleteTemplateSuccess':
				return $author$project$Page$ListDocument$Modal$deleteTemplateSuccess;
			case 'DownloadingDocument':
				return $author$project$Page$ListDocument$Modal$downloadDocumentModal;
			case 'RequestTemplate':
				var slug = modal.a;
				return $author$project$Page$ListDocument$Modal$requestTemplateModal(slug);
			case 'RequestTemplateSuccess':
				return $author$project$Page$ListDocument$Modal$requestTemplateSuccess;
			default:
				return $author$project$Page$ListDocument$Modal$loadingModal;
		}
	}
};
var $author$project$Page$ListDocument$view = F2(
	function (model, appModel) {
		var _v0 = appModel;
		var currentTime = _v0.currentTime;
		var timezone = _v0.timezone;
		var _v1 = model;
		var listDocModel = _v1.listDocModel;
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ListDocument$styles.container)
				]),
			_List_fromArray(
				[
					A4($author$project$Page$ListDocument$Header$view, appModel.languageSwitchModel, listDocModel, currentTime, timezone),
					A2(
					$author$project$Material$Styled$Divider$divider,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ListDocument$styles.divider)
						]),
					_List_Nil),
					function () {
					var _v2 = listDocModel.status;
					if (_v2.$ === 'Loading') {
						return $author$project$Page$ListDocument$Loading$view;
					} else {
						return A6($author$project$Page$ListDocument$documentList, listDocModel, currentTime, timezone, model.user, appModel, model);
					}
				}(),
					$author$project$Page$ListDocument$Modal$view(listDocModel),
					A2(
					$elm$core$Maybe$withDefault,
					$rtfeldman$elm_css$Html$Styled$text(''),
					A2($elm$core$Maybe$map, $author$project$Page$ListDocument$MessageBanner$view, listDocModel.banner)),
					A2(
					$author$project$Material$Styled$Snackbar$snackbar,
					_List_fromArray(
						[
							$author$project$Material$Styled$Snackbar$Theme($author$project$Material$Styled$Snackbar$success),
							$author$project$Material$Styled$Snackbar$Status(listDocModel.snackBar)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('Document Successfully Downloaded')
						]))
				]));
	});
var $author$project$Type$Login$Email = {$: 'Email'};
var $author$project$Type$Login$OnBlur = function (a) {
	return {$: 'OnBlur', a: a};
};
var $author$project$Type$Login$OnInput = F2(
	function (a, b) {
		return {$: 'OnInput', a: a, b: b};
	});
var $author$project$Type$Login$OnSubmit = {$: 'OnSubmit'};
var $author$project$Type$Login$Password = {$: 'Password'};
var $author$project$Data$Api$Login$errorToString = function (error) {
	switch (error.$) {
		case 'USER_NOT_FOUND':
			return 'Incorrect email or password. Click Forgot Password to reset your password or Sign up for an Account.';
		case 'USER_NOT_ACTIVATED':
			return 'Account is not activated. Please click on the link in the activation email sent from Sign.Net to activate your account.';
		default:
			return 'We encountered an issue while processing your request. Please disable any Ad-Blocker or Tracking-Blocker and try again.';
	}
};
var $author$project$Page$Login$styles = {
	buttonContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(16))
		]),
	card: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			A4(
			$rtfeldman$elm_css$Css$margin4,
			$rtfeldman$elm_css$Css$px(48),
			$rtfeldman$elm_css$Css$px(20),
			$rtfeldman$elm_css$Css$zero,
			$rtfeldman$elm_css$Css$px(20)),
			$rtfeldman$elm_css$Css$paddingBottom(
			$rtfeldman$elm_css$Css$px(40)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100)),
			$rtfeldman$elm_css$Css$maxWidth(
			$rtfeldman$elm_css$Css$px(600))
		]),
	container: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center)
		]),
	divider: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			A3(
				$rtfeldman$elm_css$Css$calc,
				$rtfeldman$elm_css$Css$pct(100),
				$rtfeldman$elm_css$Css$minus,
				$rtfeldman$elm_css$Css$px(48)))
		]),
	dividerBottom: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			A3(
				$rtfeldman$elm_css$Css$calc,
				$rtfeldman$elm_css$Css$pct(100),
				$rtfeldman$elm_css$Css$minus,
				$rtfeldman$elm_css$Css$px(48))),
			A2(
			$rtfeldman$elm_css$Css$margin2,
			$rtfeldman$elm_css$Css$px(16),
			$rtfeldman$elm_css$Css$zero)
		]),
	error: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$red900),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(14))
		]),
	form: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			A3(
				$rtfeldman$elm_css$Css$calc,
				$rtfeldman$elm_css$Css$pct(100),
				$rtfeldman$elm_css$Css$minus,
				$rtfeldman$elm_css$Css$px(48)))
		]),
	heading: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(24)),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$blueGrey900)
		]),
	inputContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginBottom(
			$rtfeldman$elm_css$Css$px(20))
		]),
	link: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$block),
			$rtfeldman$elm_css$Css$maxWidth($rtfeldman$elm_css$Css$fitContent)
		]),
	linkContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			A3(
				$rtfeldman$elm_css$Css$calc,
				$rtfeldman$elm_css$Css$pct(100),
				$rtfeldman$elm_css$Css$minus,
				$rtfeldman$elm_css$Css$px(48)))
		]),
	logo: _List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Css$margin2,
			$rtfeldman$elm_css$Css$px(60),
			$rtfeldman$elm_css$Css$zero),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(150)),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(38))
		]),
	warning: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$red900),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(14)),
			A4(
			$rtfeldman$elm_css$Css$margin4,
			$rtfeldman$elm_css$Css$px(0),
			$rtfeldman$elm_css$Css$px(20),
			$rtfeldman$elm_css$Css$px(20),
			$rtfeldman$elm_css$Css$px(20)),
			$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center)
		])
};
var $author$project$Page$Login$displayFormError = function (form) {
	if (form.$ === 'Error') {
		var error = form.a;
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Login$styles.error)
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text(
					A2($author$project$Data$Api$errorToString, $author$project$Data$Api$Login$errorToString, error))
				]));
	} else {
		return $rtfeldman$elm_css$Html$Styled$text('');
	}
};
var $author$project$Page$Login$displayRouteError = function (route) {
	_v0$3:
	while (true) {
		switch (route.$) {
			case 'Public':
				if (route.a.$ === 'NotAuthorizedRoute') {
					var targetRoute = route.a.a;
					return A2($elm$core$String$contains, $author$project$Data$Route$routeUrl.fillTemplate, targetRoute) ? A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Login$styles.warning)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('Please login to your sign.net account in order to view your requested form. If you do not have an account, please click '),
								A2(
								$author$project$Material$Styled$A$a,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$href($author$project$Data$Route$routeUrl.personalRegister)
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('here')
									])),
								$rtfeldman$elm_css$Html$Styled$text(' to sign up for free.')
							])) : A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Login$styles.warning)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('Please sign in to access.')
							]));
				} else {
					break _v0$3;
				}
			case 'PublicOrAuth':
				if (route.a.$ === 'RedirectRoute') {
					return A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Login$styles.warning)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('Please sign in to access.')
							]));
				} else {
					break _v0$3;
				}
			case 'InvalidJWTRoute':
				return A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Login$styles.warning)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('Session has expired. Please login again.')
						]));
			default:
				break _v0$3;
		}
	}
	return $rtfeldman$elm_css$Html$Styled$text('');
};
var $author$project$Page$Login$submitButton = function (model) {
	var _v0 = model;
	var formStatus = _v0.formStatus;
	var emailError = _v0.emailError;
	var passwordError = _v0.passwordError;
	var hasError = A2(
		$elm$core$List$any,
		$elm$core$Basics$neq($elm$core$Maybe$Nothing),
		_List_fromArray(
			[emailError, passwordError]));
	switch (formStatus.$) {
		case 'Ready':
			return hasError ? $author$project$View$SubmitButton$disabled('SIGN IN') : $author$project$View$SubmitButton$enabled('SIGN IN');
		case 'Error':
			return $author$project$View$SubmitButton$enabled('SIGN IN');
		default:
			return $author$project$View$SubmitButton$submitting('Signing you in...');
	}
};
var $author$project$Page$Login$view = function (model) {
	var _v0 = model;
	var route = _v0.route;
	var loginModel = _v0.loginModel;
	var _v1 = loginModel;
	var formStatus = _v1.formStatus;
	var email = _v1.email;
	var password = _v1.password;
	var emailError = _v1.emailError;
	var passwordError = _v1.passwordError;
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Login$styles.container)
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Material$Styled$Card$card,
				_List_fromArray(
					[
						$author$project$Material$Styled$Card$containerStyles($author$project$Page$Login$styles.card)
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$img,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$src($author$project$View$Theme$images.logoColor),
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Login$styles.logo)
							]),
						_List_Nil),
						A2(
						$author$project$Material$Styled$Divider$divider,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Login$styles.divider)
							]),
						_List_Nil),
						A2(
						$rtfeldman$elm_css$Html$Styled$h2,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Login$styles.heading)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('Sign In')
							])),
						$author$project$Page$Login$displayRouteError(route),
						A2(
						$rtfeldman$elm_css$Html$Styled$form,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Events$onSubmit(
								$author$project$Types$OnLogin($author$project$Type$Login$OnSubmit)),
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Login$styles.form)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Material$Styled$Input$email,
								_List_fromArray(
									[
										$author$project$Material$Styled$Input$containerStyles($author$project$Page$Login$styles.inputContainer),
										$author$project$Material$Styled$Input$label('Email address'),
										$author$project$Material$Styled$Input$value(email),
										$author$project$Material$Styled$Input$errorMessage(emailError),
										$author$project$Material$Styled$Input$onInput(
										A2(
											$elm$core$Basics$composeL,
											$author$project$Types$OnLogin,
											$author$project$Type$Login$OnInput($author$project$Type$Login$Email))),
										$author$project$Material$Styled$Input$onBlur(
										$author$project$Types$OnLogin(
											$author$project$Type$Login$OnBlur($author$project$Type$Login$Email)))
									]),
								_List_Nil),
								A2(
								$author$project$Material$Styled$Input$password,
								_List_fromArray(
									[
										$author$project$Material$Styled$Input$containerStyles($author$project$Page$Login$styles.inputContainer),
										$author$project$Material$Styled$Input$label('Password'),
										$author$project$Material$Styled$Input$value(password),
										$author$project$Material$Styled$Input$errorMessage(passwordError),
										$author$project$Material$Styled$Input$onInput(
										A2(
											$elm$core$Basics$composeL,
											$author$project$Types$OnLogin,
											$author$project$Type$Login$OnInput($author$project$Type$Login$Password))),
										$author$project$Material$Styled$Input$onBlur(
										$author$project$Types$OnLogin(
											$author$project$Type$Login$OnBlur($author$project$Type$Login$Password)))
									]),
								_List_Nil),
								$author$project$Page$Login$displayFormError(formStatus),
								A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Login$styles.buttonContainer)
									]),
								_List_fromArray(
									[
										$author$project$Page$Login$submitButton(model.loginModel)
									]))
							])),
						A2(
						$author$project$Material$Styled$Divider$divider,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Login$styles.dividerBottom)
							]),
						_List_Nil),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Login$styles.linkContainer)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Material$Styled$A$a,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Login$styles.link),
										$rtfeldman$elm_css$Html$Styled$Attributes$href($author$project$Data$Route$routeUrl.signUp)
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('Account Sign Up')
									])),
								A2(
								$author$project$Material$Styled$A$a,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Login$styles.link),
										$rtfeldman$elm_css$Html$Styled$Attributes$href($author$project$Data$Route$routeUrl.resetPassword)
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('Reset Password')
									]))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$id('affilate')
							]),
						_List_Nil)
					]))
			]));
};
var $author$project$Page$Logout$styles = {
	card: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			A2(
			$rtfeldman$elm_css$Css$margin2,
			$rtfeldman$elm_css$Css$zero,
			$rtfeldman$elm_css$Css$px(20)),
			$rtfeldman$elm_css$Css$paddingBottom(
			$rtfeldman$elm_css$Css$px(40)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100)),
			$rtfeldman$elm_css$Css$maxWidth(
			$rtfeldman$elm_css$Css$px(600))
		]),
	container: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			A2(
			$rtfeldman$elm_css$Css$padding2,
			$rtfeldman$elm_css$Css$px(48),
			$rtfeldman$elm_css$Css$zero)
		]),
	heading: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(24)),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$blueGrey900),
			$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center)
		]),
	headingError: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(24)),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$red900),
			$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center)
		]),
	logo: _List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Css$margin2,
			$rtfeldman$elm_css$Css$px(60),
			$rtfeldman$elm_css$Css$zero),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(150)),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(38))
		]),
	main: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			A3(
				$rtfeldman$elm_css$Css$calc,
				$rtfeldman$elm_css$Css$pct(100),
				$rtfeldman$elm_css$Css$minus,
				$rtfeldman$elm_css$Css$px(48))),
			$rtfeldman$elm_css$Css$padding(
			$rtfeldman$elm_css$Css$px(48)),
			$rtfeldman$elm_css$Css$boxSizing($rtfeldman$elm_css$Css$borderBox),
			A3(
			$rtfeldman$elm_css$Css$borderTop3,
			$rtfeldman$elm_css$Css$px(1),
			$rtfeldman$elm_css$Css$solid,
			$author$project$Material$Styled$Color$grey200)
		]),
	textContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(14)),
			$rtfeldman$elm_css$Css$lineHeight(
			$rtfeldman$elm_css$Css$px(21)),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$blueGrey900),
			$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$fontWeight(
			$rtfeldman$elm_css$Css$int(400))
		])
};
var $author$project$Page$Logout$displayMessage = function (model) {
	switch (model.$) {
		case 'Ready':
			return A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Logout$styles.main)
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$h2,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Logout$styles.heading)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('Going off?')
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Logout$styles.textContainer)
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$p,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('Click on the button below to log out:')
									])),
								A2(
								$author$project$Material$Styled$Button$button,
								_List_fromArray(
									[
										$author$project$Material$Styled$Button$theme($author$project$Material$Styled$Button$indigo),
										$author$project$Material$Styled$Button$onClick(
										$author$project$Types$OnAuth(
											$author$project$Types$OnLogout($author$project$Type$Logout$Logout)))
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('Log out')
									]))
							]))
					]));
		case 'Submitting':
			return A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Logout$styles.main)
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$h2,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Logout$styles.heading)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('Please wait')
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Logout$styles.textContainer)
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$p,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('We are logging you out securely...')
									]))
							])),
						A2($author$project$Material$Styled$ProgressBar$linear, _List_Nil, _List_Nil)
					]));
		case 'Success':
			return A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Logout$styles.main)
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$h2,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Logout$styles.heading)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('Please wait')
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Logout$styles.textContainer)
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$p,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('Success! Showing you out...')
									]))
							])),
						A2($author$project$Material$Styled$ProgressBar$linear, _List_Nil, _List_Nil)
					]));
		default:
			return A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Logout$styles.main)
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$h2,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Logout$styles.headingError)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('Error')
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Logout$styles.textContainer)
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$p,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('Something went wrong with the network.'),
										A2($rtfeldman$elm_css$Html$Styled$br, _List_Nil, _List_Nil),
										$rtfeldman$elm_css$Html$Styled$text('Please try again:')
									])),
								A2(
								$author$project$Material$Styled$Button$button,
								_List_fromArray(
									[
										$author$project$Material$Styled$Button$theme($author$project$Material$Styled$Button$indigo),
										$author$project$Material$Styled$Button$onClick(
										$author$project$Types$OnAuth(
											$author$project$Types$OnLogout($author$project$Type$Logout$Logout)))
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('Log out')
									]))
							]))
					]));
	}
};
var $author$project$Page$Logout$view = function (_v0) {
	var logout = _v0.logout;
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Logout$styles.container)
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Material$Styled$Card$card,
				_List_fromArray(
					[
						$author$project$Material$Styled$Card$containerStyles($author$project$Page$Logout$styles.card)
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$img,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$src($author$project$View$Theme$images.logoColor),
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Logout$styles.logo)
							]),
						_List_Nil),
						$author$project$Page$Logout$displayMessage(logout)
					]))
			]));
};
var $author$project$Page$NewDocument$NewMultipleDocument$styles = {
	container: _List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Css$margin2,
			$rtfeldman$elm_css$Css$px(5),
			$rtfeldman$elm_css$Css$px(24))
		]),
	header: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(24)),
			$rtfeldman$elm_css$Css$fontWeight(
			$rtfeldman$elm_css$Css$int(500)),
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(24))
		]),
	line: _List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Css$margin2,
			$rtfeldman$elm_css$Css$px(24),
			$rtfeldman$elm_css$Css$zero),
			$rtfeldman$elm_css$Css$backgroundColor($author$project$Material$Styled$Color$grey300),
			$rtfeldman$elm_css$Css$border($rtfeldman$elm_css$Css$zero),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(1))
		]),
	modalContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$vw(70)),
			$rtfeldman$elm_css$Css$maxWidth(
			$rtfeldman$elm_css$Css$px(500))
		]),
	modalHeader: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$row),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$flexStart),
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceBetween)
		]),
	modalHeaderTxt: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(20)),
			$rtfeldman$elm_css$Css$fontWeight(
			$rtfeldman$elm_css$Css$int(500))
		])
};
var $author$project$Page$NewDocument$NewMultipleDocument$view = F2(
	function (authModel, model) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$NewDocument$NewMultipleDocument$styles.container)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$h1,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$NewDocument$NewMultipleDocument$styles.header)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('Upload New Documents')
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$hr,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$NewDocument$NewMultipleDocument$styles.line)
						]),
					_List_Nil),
					A2($author$project$Page$NewDocument$UploadCard$view, model, authModel),
					authModel.newMultipleDocModel.showModal ? A2(
					$author$project$Material$Styled$Modal$modal,
					_List_fromArray(
						[
							$author$project$Material$Styled$Modal$open(true),
							$author$project$Material$Styled$Modal$contentContainerstyles($author$project$Page$NewDocument$NewMultipleDocument$styles.modalContainer)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$NewDocument$NewMultipleDocument$styles.modalHeader)
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$NewDocument$NewMultipleDocument$styles.modalHeaderTxt)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('Loading Your Documents')
										]))
								])),
							A2($author$project$Material$Styled$ProgressBar$linear, _List_Nil, _List_Nil)
						])) : $rtfeldman$elm_css$Html$Styled$text('')
				]));
	});
var $author$project$Page$NewTemplate$templateQuota = F2(
	function (model, authModel) {
		var uploadTemplatePageLanguageData = model.languageSwitchModel.allLanguageData.location.uploadTemplatePage;
		var _v0 = authModel;
		var newTemplateModel = _v0.newTemplateModel;
		var templateNumberText = (newTemplateModel.templateQuota === 999999) ? 'Unlimited' : $elm$core$String$fromInt(newTemplateModel.templateQuota);
		return A2(
			$author$project$Material$Styled$Card$card,
			_List_fromArray(
				[
					$author$project$Material$Styled$Card$containerStyles($author$project$Page$NewTemplate$styles.card)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$h1,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$NewTemplate$styles.quota)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(uploadTemplatePageLanguageData.numberOfTemplates)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$NewTemplate$styles.overallBalanceContainer)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$NewTemplate$styles.balanceContainer)
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$NewTemplate$styles.numberText)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(templateNumberText)
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$NewTemplate$styles.balanceHeaderText)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(uploadTemplatePageLanguageData.available)
										]))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$NewTemplate$styles.balanceContainer)
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$NewTemplate$styles.numberText)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											$elm$core$String$fromInt(newTemplateModel.templatesUsed))
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$NewTemplate$styles.balanceHeaderText)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(uploadTemplatePageLanguageData.used)
										]))
								]))
						]))
				]));
	});
var $author$project$Page$NewTemplate$view = F2(
	function (authModel, model) {
		var uploadTemplatePageLanguageData = model.languageSwitchModel.allLanguageData.location.uploadTemplatePage;
		var _v0 = authModel;
		var newTemplateModel = _v0.newTemplateModel;
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$NewTemplate$styles.container)
				]),
			_List_fromArray(
				[
					A2($author$project$Page$NewTemplate$templateQuota, model, authModel),
					A2(
					$rtfeldman$elm_css$Html$Styled$h1,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$NewTemplate$styles.header)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(uploadTemplatePageLanguageData.createNewTemplate)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[
									$rtfeldman$elm_css$Css$marginBottom(
									$rtfeldman$elm_css$Css$px(20))
								]))
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(uploadTemplatePageLanguageData.createTemplateDescription)
								]))
						])),
					A4(
					$author$project$Page$NewTemplate$uploadCard,
					model,
					authModel,
					_Utils_cmp(newTemplateModel.templatesUsed, newTemplateModel.templateQuota) < 0,
					newTemplateModel)
				]));
	});
var $author$project$Type$NewfoldRegister$CompanyName = {$: 'CompanyName'};
var $author$project$Type$NewfoldRegister$Email = {$: 'Email'};
var $author$project$Type$NewfoldRegister$FirstName = {$: 'FirstName'};
var $author$project$Type$NewfoldRegister$LastName = {$: 'LastName'};
var $author$project$Type$NewfoldRegister$OnAgreeTerms = {$: 'OnAgreeTerms'};
var $author$project$Type$NewfoldRegister$OnBlur = function (a) {
	return {$: 'OnBlur', a: a};
};
var $author$project$Type$NewfoldRegister$OnInput = F2(
	function (a, b) {
		return {$: 'OnInput', a: a, b: b};
	});
var $author$project$Type$NewfoldRegister$OnSubmit = {$: 'OnSubmit'};
var $author$project$Type$NewfoldRegister$Password = {$: 'Password'};
var $author$project$Type$NewfoldRegister$PasswordAgain = {$: 'PasswordAgain'};
var $author$project$Type$NewfoldRegister$ReferralCode = {$: 'ReferralCode'};
var $author$project$Type$NewfoldRegister$SubDomain = {$: 'SubDomain'};
var $author$project$Data$Api$Register$Newfold$errorToString = function (error) {
	switch (error.$) {
		case 'INVALID_SUBDOMAIN':
			return 'SubDomain is invalid.';
		case 'INVALID_COMPANYNAME':
			return 'Company name is invalid.';
		case 'EMPTY_NAME':
			return 'Name cannot be empty.';
		case 'PASSWORD_REQUIREMENT':
			return 'Password did not meet the minimum requirement.';
		case 'USER_EXIST':
			return 'User has already exists.';
		case 'INVALID_EMAIL':
			return 'Email is not valid.';
		case 'UPDATE_ANONYMOUS':
			return 'Unable to update anonymous user account';
		case 'INVALID_CODE':
			return 'Invalid Coupon Code';
		case 'LIMIT_REACHED':
			return 'You have created too many accounts. Please try again at another time.';
		default:
			return 'We encountered an issue while processing your request. Please disable any Ad-Blocker or Tracking-Blocker and try again.';
	}
};
var $author$project$Page$NewfoldRegisterPage$styles = {
	boldText: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontWeight(
			$rtfeldman$elm_css$Css$int(1000)),
			$rtfeldman$elm_css$Css$paddingBottom(
			$rtfeldman$elm_css$Css$px(50))
		]),
	box: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(18)),
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			A2(
			$rtfeldman$elm_css$Css$padding2,
			$rtfeldman$elm_css$Css$px(20),
			$rtfeldman$elm_css$Css$px(40)),
			$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center),
			A2(
			$rtfeldman$elm_css$Css$margin2,
			$rtfeldman$elm_css$Css$px(20),
			$rtfeldman$elm_css$Css$px(0))
		]),
	businessImageBox: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center)
		]),
	businessRegister: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$backgroundColor($author$project$Material$Styled$Color$white),
			$rtfeldman$elm_css$Css$marginRight(
			$rtfeldman$elm_css$Css$px(150)),
			A2(
			$rtfeldman$elm_css$Css$Media$withMediaQuery,
			_List_fromArray(
				['screen and (max-width: 1390px)']),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$backgroundColor($author$project$Material$Styled$Color$white),
					$rtfeldman$elm_css$Css$marginRight(
					$rtfeldman$elm_css$Css$px(0))
				]))
		]),
	businessText: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontWeight(
			$rtfeldman$elm_css$Css$int(1000)),
			$rtfeldman$elm_css$Css$lineHeight(
			$rtfeldman$elm_css$Css$px(40))
		]),
	buttonContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100)),
			A2(
			$rtfeldman$elm_css$Css$margin2,
			$rtfeldman$elm_css$Css$px(16),
			$rtfeldman$elm_css$Css$zero)
		]),
	centered: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(24)),
			$rtfeldman$elm_css$Css$marginBottom(
			$rtfeldman$elm_css$Css$px(-5))
		]),
	checkboxContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(8)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100)),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(14)),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$blueGrey600)
		]),
	desktop: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100)),
			A2(
			$rtfeldman$elm_css$Css$Media$withMediaQuery,
			_List_fromArray(
				['screen and (max-width: 1024px)']),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$none)
				]))
		]),
	divider: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			A3(
				$rtfeldman$elm_css$Css$calc,
				$rtfeldman$elm_css$Css$pct(100),
				$rtfeldman$elm_css$Css$minus,
				$rtfeldman$elm_css$Css$px(48)))
		]),
	domainContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$row),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100))
		]),
	domainEndText: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$paddingTop(
			$rtfeldman$elm_css$Css$px(35))
		]),
	domainInput: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(90))
		]),
	domainText: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(12)),
			$rtfeldman$elm_css$Css$paddingLeft(
			$rtfeldman$elm_css$Css$px(10)),
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(5)),
			$rtfeldman$elm_css$Css$marginBottom(
			$rtfeldman$elm_css$Css$px(20))
		]),
	form: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			A3(
				$rtfeldman$elm_css$Css$calc,
				$rtfeldman$elm_css$Css$pct(100),
				$rtfeldman$elm_css$Css$minus,
				$rtfeldman$elm_css$Css$px(48))),
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(70))
		]),
	formError: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(16)),
			$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(14)),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$red900)
		]),
	header: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(24)),
			A2(
			$rtfeldman$elm_css$Css$padding2,
			$rtfeldman$elm_css$Css$zero,
			$rtfeldman$elm_css$Css$px(30))
		]),
	heading: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(24)),
			$rtfeldman$elm_css$Css$color(
			$rtfeldman$elm_css$Css$hex('0040ab'))
		]),
	imageStyles: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(450)),
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(20))
		]),
	informationContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$backgroundColor(
			$rtfeldman$elm_css$Css$hex('#0040ab')),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$white),
			$rtfeldman$elm_css$Css$marginLeft(
			$rtfeldman$elm_css$Css$px(150)),
			A2(
			$rtfeldman$elm_css$Css$Media$withMediaQuery,
			_List_fromArray(
				['screen and (max-width: 1390px)']),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$backgroundColor(
					$rtfeldman$elm_css$Css$hex('#0040ab')),
					$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$white),
					$rtfeldman$elm_css$Css$marginLeft(
					$rtfeldman$elm_css$Css$px(0))
				]))
		]),
	informationTextContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			A2(
			$rtfeldman$elm_css$Css$padding2,
			$rtfeldman$elm_css$Css$px(20),
			$rtfeldman$elm_css$Css$px(30)),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(16))
		]),
	inputContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100)),
			$rtfeldman$elm_css$Css$marginBottom(
			$rtfeldman$elm_css$Css$px(20))
		]),
	linkContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			A3(
				$rtfeldman$elm_css$Css$calc,
				$rtfeldman$elm_css$Css$pct(100),
				$rtfeldman$elm_css$Css$minus,
				$rtfeldman$elm_css$Css$px(48))),
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(16)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(70))
		]),
	listHeader: _List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Css$padding2,
			$rtfeldman$elm_css$Css$px(10),
			$rtfeldman$elm_css$Css$px(0)),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(18))
		]),
	listHeaderFont: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(18))
		]),
	message: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			A3(
				$rtfeldman$elm_css$Css$calc,
				$rtfeldman$elm_css$Css$pct(100),
				$rtfeldman$elm_css$Css$minus,
				$rtfeldman$elm_css$Css$px(48))),
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(-15)),
			$rtfeldman$elm_css$Css$marginBottom(
			$rtfeldman$elm_css$Css$px(20)),
			$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$fontWeight(
			$rtfeldman$elm_css$Css$int(900)),
			$rtfeldman$elm_css$Css$color(
			$rtfeldman$elm_css$Css$hex('0040ab'))
		]),
	mobile: _List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Css$Media$withMediaQuery,
			_List_fromArray(
				['screen and (min-width: 1025px)']),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$none)
				]))
		]),
	retryContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer),
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(10))
		]),
	sideContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			$rtfeldman$elm_css$Css$flex(
			$rtfeldman$elm_css$Css$num(1)),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$em(65)),
			$rtfeldman$elm_css$Css$paddingTop(
			$rtfeldman$elm_css$Css$px(40)),
			A2(
			$rtfeldman$elm_css$Css$Media$withMediaQuery,
			_List_fromArray(
				['screen and (max-width: 1123px)']),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$height(
					$rtfeldman$elm_css$Css$em(77))
				])),
			A2(
			$rtfeldman$elm_css$Css$Media$withMediaQuery,
			_List_fromArray(
				['screen and (max-width: 1180px)']),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$height(
					$rtfeldman$elm_css$Css$em(70))
				]))
		]),
	spacing: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$paddingBottom(
			$rtfeldman$elm_css$Css$px(24))
		]),
	subHeader: _List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Css$padding2,
			$rtfeldman$elm_css$Css$px(10),
			$rtfeldman$elm_css$Css$px(50)),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(18))
		]),
	subPoint: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$listStyleType($rtfeldman$elm_css$Css$none),
			$rtfeldman$elm_css$Css$fontStyle($rtfeldman$elm_css$Css$italic)
		]),
	termsError: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(11)),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$red900)
		]),
	textContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(11)),
			$rtfeldman$elm_css$Css$lineHeight(
			$rtfeldman$elm_css$Css$px(13)),
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(16)),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$blueGrey600)
		])
};
var $author$project$Page$NewfoldRegisterPage$displayFormError = function (formStatus) {
	if (formStatus.$ === 'Error') {
		var error = formStatus.a;
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$NewfoldRegisterPage$styles.formError)
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text(
					A2($author$project$Data$Api$errorToString, $author$project$Data$Api$Register$Newfold$errorToString, error))
				]));
	} else {
		return $rtfeldman$elm_css$Html$Styled$text('');
	}
};
var $author$project$Page$NewfoldRegisterPage$displayTermsError = function (maybeError) {
	if (maybeError.$ === 'Nothing') {
		return $rtfeldman$elm_css$Html$Styled$text('');
	} else {
		var message = maybeError.a;
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$NewfoldRegisterPage$styles.termsError)
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text(message)
				]));
	}
};
var $author$project$Page$NewfoldRegisterPage$showValidationStatus = function (status) {
	switch (status.$) {
		case 'Validating':
			return A2($author$project$Material$Styled$ProgressBar$linear, _List_Nil, _List_Nil);
		case 'Retry':
			return A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$NewfoldRegisterPage$styles.retryContainer),
						$rtfeldman$elm_css$Html$Styled$Events$onClick(
						$author$project$Types$OnNewfoldRegister($author$project$Type$NewfoldRegister$OnValidateDomain))
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('An error occurred, please retry.')
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$img,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$src($author$project$View$Theme$images.retry)
							]),
						_List_Nil)
					]));
		default:
			return $rtfeldman$elm_css$Html$Styled$text('');
	}
};
var $author$project$Page$NewfoldRegisterPage$submitButton = function (model) {
	var hasError = A2(
		$elm$core$List$any,
		$elm$core$Basics$neq($elm$core$Maybe$Nothing),
		_List_fromArray(
			[model.companyNameError, model.firstNameError, model.lastNameError, model.emailError, model.passwordError, model.passwordAgainError, model.hasAgreedTermsError]));
	var _v0 = model;
	var formStatus = _v0.formStatus;
	var subdomainStatus = _v0.subdomainStatus;
	var validStatus = A2(
		$elm$core$Maybe$withDefault,
		false,
		A2(
			$elm$core$Maybe$map,
			function (status) {
				return _Utils_eq(status, $author$project$Data$Api$Register$ValidateDomain$NotUse);
			},
			subdomainStatus));
	switch (formStatus.$) {
		case 'Ready':
			return (hasError || (!validStatus)) ? $author$project$View$SubmitButton$disabled('SIGN UP') : $author$project$View$SubmitButton$enabled('SIGN UP');
		case 'Error':
			return $author$project$View$SubmitButton$enabled('SIGN UP');
		default:
			return $author$project$View$SubmitButton$submitting('Registering Your Account...');
	}
};
var $author$project$Page$NewfoldRegisterPage$businessRegister = function (model) {
	var _v0 = model.newfoldRegisterModel;
	var formStatus = _v0.formStatus;
	var subdomain = _v0.subdomain;
	var subdomainStatus = _v0.subdomainStatus;
	var validationStatus = _v0.validationStatus;
	var redirectError = _v0.redirectError;
	var subdomainError = _v0.subdomainError;
	var companyName = _v0.companyName;
	var companyNameError = _v0.companyNameError;
	var firstName = _v0.firstName;
	var firstNameError = _v0.firstNameError;
	var lastName = _v0.lastName;
	var lastNameError = _v0.lastNameError;
	var email = _v0.email;
	var emailError = _v0.emailError;
	var password = _v0.password;
	var passwordError = _v0.passwordError;
	var passwordAgain = _v0.passwordAgain;
	var passwordAgainError = _v0.passwordAgainError;
	var hasAgreedTerms = _v0.hasAgreedTerms;
	var hasAgreedTermsError = _v0.hasAgreedTermsError;
	var referralCode = _v0.referralCode;
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				_Utils_ap($author$project$Page$NewfoldRegisterPage$styles.sideContainer, $author$project$Page$NewfoldRegisterPage$styles.businessRegister))
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$h2,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$NewfoldRegisterPage$styles.heading)
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('Start Your Free Trial')
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$form,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$NewfoldRegisterPage$styles.form),
						$rtfeldman$elm_css$Html$Styled$Events$onSubmit(
						$author$project$Types$OnNewfoldRegister($author$project$Type$NewfoldRegister$OnSubmit))
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$NewfoldRegisterPage$styles.domainContainer)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Material$Styled$Input$text,
								_List_fromArray(
									[
										$author$project$Material$Styled$Input$containerStyles($author$project$Page$NewfoldRegisterPage$styles.domainInput),
										$author$project$Material$Styled$Input$label('Subdomain *'),
										$author$project$Material$Styled$Input$value(subdomain),
										$author$project$Material$Styled$Input$errorMessage(subdomainError),
										$author$project$Material$Styled$Input$onInput(
										A2(
											$elm$core$Basics$composeL,
											$author$project$Types$OnNewfoldRegister,
											$author$project$Type$NewfoldRegister$OnInput($author$project$Type$NewfoldRegister$SubDomain))),
										$author$project$Material$Styled$Input$onBlur(
										$author$project$Types$OnNewfoldRegister(
											$author$project$Type$NewfoldRegister$OnBlur($author$project$Type$NewfoldRegister$SubDomain)))
									]),
								_List_Nil),
								A2(
								$rtfeldman$elm_css$Html$Styled$span,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$NewfoldRegisterPage$styles.domainEndText)
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('.' + model.baseHost)
									]))
							])),
						$author$project$Page$NewfoldRegisterPage$showValidationStatus(validationStatus),
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css(
								_Utils_ap($author$project$Page$NewfoldRegisterPage$styles.domainContainer, $author$project$Page$NewfoldRegisterPage$styles.domainText))
							]),
						_List_fromArray(
							[
								function () {
								if (subdomainStatus.$ === 'Just') {
									var value = subdomainStatus.a;
									if (value.$ === 'NotUse') {
										return $rtfeldman$elm_css$Html$Styled$text(
											$author$project$Model$BusinessRegister$trimRemoveSpace(subdomain) + ('.' + (model.baseHost + ' is available')));
									} else {
										return $rtfeldman$elm_css$Html$Styled$text('');
									}
								} else {
									return $rtfeldman$elm_css$Html$Styled$text('');
								}
							}()
							])),
						A2(
						$author$project$Material$Styled$Input$text,
						_List_fromArray(
							[
								$author$project$Material$Styled$Input$containerStyles($author$project$Page$NewfoldRegisterPage$styles.inputContainer),
								$author$project$Material$Styled$Input$label('Company Name *'),
								$author$project$Material$Styled$Input$value(companyName),
								$author$project$Material$Styled$Input$errorMessage(companyNameError),
								$author$project$Material$Styled$Input$onInput(
								A2(
									$elm$core$Basics$composeL,
									$author$project$Types$OnNewfoldRegister,
									$author$project$Type$NewfoldRegister$OnInput($author$project$Type$NewfoldRegister$CompanyName))),
								$author$project$Material$Styled$Input$onBlur(
								$author$project$Types$OnNewfoldRegister(
									$author$project$Type$NewfoldRegister$OnBlur($author$project$Type$NewfoldRegister$CompanyName)))
							]),
						_List_Nil),
						A2(
						$author$project$Material$Styled$Input$text,
						_List_fromArray(
							[
								$author$project$Material$Styled$Input$containerStyles($author$project$Page$NewfoldRegisterPage$styles.inputContainer),
								$author$project$Material$Styled$Input$label('First Name *'),
								$author$project$Material$Styled$Input$value(firstName),
								$author$project$Material$Styled$Input$errorMessage(firstNameError),
								$author$project$Material$Styled$Input$onInput(
								A2(
									$elm$core$Basics$composeL,
									$author$project$Types$OnNewfoldRegister,
									$author$project$Type$NewfoldRegister$OnInput($author$project$Type$NewfoldRegister$FirstName))),
								$author$project$Material$Styled$Input$onBlur(
								$author$project$Types$OnNewfoldRegister(
									$author$project$Type$NewfoldRegister$OnBlur($author$project$Type$NewfoldRegister$FirstName)))
							]),
						_List_Nil),
						A2(
						$author$project$Material$Styled$Input$text,
						_List_fromArray(
							[
								$author$project$Material$Styled$Input$containerStyles($author$project$Page$NewfoldRegisterPage$styles.inputContainer),
								$author$project$Material$Styled$Input$label('Last Name *'),
								$author$project$Material$Styled$Input$value(lastName),
								$author$project$Material$Styled$Input$errorMessage(lastNameError),
								$author$project$Material$Styled$Input$onInput(
								A2(
									$elm$core$Basics$composeL,
									$author$project$Types$OnNewfoldRegister,
									$author$project$Type$NewfoldRegister$OnInput($author$project$Type$NewfoldRegister$LastName))),
								$author$project$Material$Styled$Input$onBlur(
								$author$project$Types$OnNewfoldRegister(
									$author$project$Type$NewfoldRegister$OnBlur($author$project$Type$NewfoldRegister$LastName)))
							]),
						_List_Nil),
						A2(
						$author$project$Material$Styled$Input$email,
						_List_fromArray(
							[
								$author$project$Material$Styled$Input$containerStyles($author$project$Page$NewfoldRegisterPage$styles.inputContainer),
								$author$project$Material$Styled$Input$label('Email Address *'),
								$author$project$Material$Styled$Input$value(email),
								$author$project$Material$Styled$Input$errorMessage(emailError),
								$author$project$Material$Styled$Input$onInput(
								A2(
									$elm$core$Basics$composeL,
									$author$project$Types$OnNewfoldRegister,
									$author$project$Type$NewfoldRegister$OnInput($author$project$Type$NewfoldRegister$Email))),
								$author$project$Material$Styled$Input$onBlur(
								$author$project$Types$OnNewfoldRegister(
									$author$project$Type$NewfoldRegister$OnBlur($author$project$Type$NewfoldRegister$Email)))
							]),
						_List_Nil),
						A2(
						$author$project$Material$Styled$Input$password,
						_List_fromArray(
							[
								$author$project$Material$Styled$Input$containerStyles($author$project$Page$NewfoldRegisterPage$styles.inputContainer),
								$author$project$Material$Styled$Input$label('Password *'),
								$author$project$Material$Styled$Input$value(password),
								$author$project$Material$Styled$Input$infoMessage('Password must contain at least 8 characters, a lowercase letter,\nan uppercase letter and a number'),
								$author$project$Material$Styled$Input$errorMessage(passwordError),
								$author$project$Material$Styled$Input$onInput(
								A2(
									$elm$core$Basics$composeL,
									$author$project$Types$OnNewfoldRegister,
									$author$project$Type$NewfoldRegister$OnInput($author$project$Type$NewfoldRegister$Password))),
								$author$project$Material$Styled$Input$onBlur(
								$author$project$Types$OnNewfoldRegister(
									$author$project$Type$NewfoldRegister$OnBlur($author$project$Type$NewfoldRegister$Password)))
							]),
						_List_Nil),
						A2(
						$author$project$Material$Styled$Input$password,
						_List_fromArray(
							[
								$author$project$Material$Styled$Input$containerStyles($author$project$Page$NewfoldRegisterPage$styles.inputContainer),
								$author$project$Material$Styled$Input$label('Confirm Password *'),
								$author$project$Material$Styled$Input$value(passwordAgain),
								$author$project$Material$Styled$Input$errorMessage(passwordAgainError),
								$author$project$Material$Styled$Input$onInput(
								A2(
									$elm$core$Basics$composeL,
									$author$project$Types$OnNewfoldRegister,
									$author$project$Type$NewfoldRegister$OnInput($author$project$Type$NewfoldRegister$PasswordAgain))),
								$author$project$Material$Styled$Input$onBlur(
								$author$project$Types$OnNewfoldRegister(
									$author$project$Type$NewfoldRegister$OnBlur($author$project$Type$NewfoldRegister$PasswordAgain)))
							]),
						_List_Nil),
						A2(
						$author$project$Material$Styled$Input$text,
						_List_fromArray(
							[
								$author$project$Material$Styled$Input$containerStyles($author$project$Page$NewfoldRegisterPage$styles.inputContainer),
								$author$project$Material$Styled$Input$label('Referral Code (Optional)'),
								$author$project$Material$Styled$Input$value(referralCode),
								$author$project$Material$Styled$Input$onInput(
								A2(
									$elm$core$Basics$composeL,
									$author$project$Types$OnNewfoldRegister,
									$author$project$Type$NewfoldRegister$OnInput($author$project$Type$NewfoldRegister$ReferralCode))),
								$author$project$Material$Styled$Input$onBlur(
								$author$project$Types$OnNewfoldRegister(
									$author$project$Type$NewfoldRegister$OnBlur($author$project$Type$NewfoldRegister$ReferralCode))),
								$author$project$Material$Styled$Input$disabled(true)
							]),
						_List_Nil),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$NewfoldRegisterPage$styles.checkboxContainer)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Material$Styled$Checkbox$checkbox,
								_List_fromArray(
									[
										$author$project$Material$Styled$Checkbox$onClick(
										$author$project$Types$OnNewfoldRegister($author$project$Type$NewfoldRegister$OnAgreeTerms)),
										$author$project$Material$Styled$Checkbox$checked(hasAgreedTerms)
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('I agree to the terms of service and privacy policy published '),
										A2(
										$author$project$Material$Styled$A$a,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$href('https://www.sign.net/legal/')
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('here')
											])),
										$rtfeldman$elm_css$Html$Styled$text('.'),
										$author$project$Page$NewfoldRegisterPage$displayTermsError(hasAgreedTermsError)
									]))
							])),
						$author$project$Page$NewfoldRegisterPage$displayFormError(formStatus),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$NewfoldRegisterPage$styles.formError)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								A2($elm$core$Maybe$withDefault, '', redirectError))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$NewfoldRegisterPage$styles.buttonContainer)
							]),
						_List_fromArray(
							[
								$author$project$Page$NewfoldRegisterPage$submitButton(model.newfoldRegisterModel)
							]))
					])),
				A2(
				$author$project$Material$Styled$Divider$divider,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$NewfoldRegisterPage$styles.divider)
					]),
				_List_Nil),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$NewfoldRegisterPage$styles.linkContainer)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Material$Styled$A$a,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$href($author$project$Data$Route$routeUrl.login)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('Return to login')
							]))
					]))
			]));
};
var $author$project$Page$NewfoldRegisterPage$listInformation = A2(
	$rtfeldman$elm_css$Html$Styled$div,
	_List_fromArray(
		[
			$rtfeldman$elm_css$Html$Styled$Attributes$css(
			_Utils_ap($author$project$Page$NewfoldRegisterPage$styles.sideContainer, $author$project$Page$NewfoldRegisterPage$styles.informationContainer))
		]),
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Html$Styled$h1,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$NewfoldRegisterPage$styles.header)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('Send & Sign Anytime, Anywhere')
						]))
				])),
			A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$NewfoldRegisterPage$styles.subHeader)
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text('eSignature keeps your modern business moving forward from anywhere, at any time, on any device')
				])),
			A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$NewfoldRegisterPage$styles.informationTextContainer)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$NewfoldRegisterPage$styles.listHeader)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('Key Features:')
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$ul,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$li,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$NewfoldRegisterPage$styles.spacing)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Automate document workflows')
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$li,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$NewfoldRegisterPage$styles.spacing)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Ensure legal significance of your documents')
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$li,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$NewfoldRegisterPage$styles.spacing)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Collaborate with your team with templates')
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$li,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$NewfoldRegisterPage$styles.spacing)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Add your corporate branding')
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$li,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$NewfoldRegisterPage$styles.spacing)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Notarise documents on the blockchain')
								]))
						]))
				])),
			A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$NewfoldRegisterPage$styles.businessImageBox)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$img,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$src($author$project$View$Theme$images.dashboard),
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$NewfoldRegisterPage$styles.imageStyles)
						]),
					_List_Nil)
				]))
		]));
var $author$project$Page$Register$Business$NewfoldRegisterMobile$styles = {
	arrow: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$paddingTop(
			$rtfeldman$elm_css$Css$px(20)),
			A2(
			$rtfeldman$elm_css$Css$Media$withMediaQuery,
			_List_fromArray(
				['screen and (min-width: 700px)']),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$none)
				]))
		]),
	boldText: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontWeight(
			$rtfeldman$elm_css$Css$int(1000)),
			$rtfeldman$elm_css$Css$paddingBottom(
			$rtfeldman$elm_css$Css$px(50))
		]),
	box: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(20)),
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			A2(
			$rtfeldman$elm_css$Css$padding2,
			$rtfeldman$elm_css$Css$px(30),
			$rtfeldman$elm_css$Css$px(40)),
			$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$marginBottom(
			$rtfeldman$elm_css$Css$px(30))
		]),
	businessImageBox: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$marginBottom(
			$rtfeldman$elm_css$Css$px(0)),
			A2(
			$rtfeldman$elm_css$Css$Media$withMediaQuery,
			_List_fromArray(
				['screen and (max-width: 700px)']),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column)
				]))
		]),
	businessRegister: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$backgroundColor($author$project$Material$Styled$Color$white),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(75)),
			A2(
			$rtfeldman$elm_css$Css$Media$withMediaQuery,
			_List_fromArray(
				['screen and (max-width: 700px)']),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$width(
					$rtfeldman$elm_css$Css$pct(100))
				]))
		]),
	buttonContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100)),
			A2(
			$rtfeldman$elm_css$Css$margin2,
			$rtfeldman$elm_css$Css$px(16),
			$rtfeldman$elm_css$Css$zero)
		]),
	checkboxContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(8)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100)),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(14)),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$blueGrey600)
		]),
	container: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100)),
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column)
		]),
	divider: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			A3(
				$rtfeldman$elm_css$Css$calc,
				$rtfeldman$elm_css$Css$pct(100),
				$rtfeldman$elm_css$Css$minus,
				$rtfeldman$elm_css$Css$px(48)))
		]),
	domainContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$row),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100))
		]),
	domainEndText: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$paddingTop(
			$rtfeldman$elm_css$Css$px(35))
		]),
	domainInput: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(90))
		]),
	domainText: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(12)),
			$rtfeldman$elm_css$Css$paddingLeft(
			$rtfeldman$elm_css$Css$px(10)),
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(5)),
			$rtfeldman$elm_css$Css$marginBottom(
			$rtfeldman$elm_css$Css$px(20))
		]),
	form: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			A3(
				$rtfeldman$elm_css$Css$calc,
				$rtfeldman$elm_css$Css$pct(100),
				$rtfeldman$elm_css$Css$minus,
				$rtfeldman$elm_css$Css$px(48))),
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(65))
		]),
	formError: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(16)),
			$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(14)),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$red900)
		]),
	header: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(24)),
			A2(
			$rtfeldman$elm_css$Css$padding2,
			$rtfeldman$elm_css$Css$zero,
			$rtfeldman$elm_css$Css$px(30))
		]),
	heading: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(24)),
			$rtfeldman$elm_css$Css$color(
			$rtfeldman$elm_css$Css$hex('2d64b1'))
		]),
	imageContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(300))
		]),
	imageStyles: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(280)),
			$rtfeldman$elm_css$Css$margin(
			$rtfeldman$elm_css$Css$px(15))
		]),
	informationContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$backgroundColor(
			$rtfeldman$elm_css$Css$hex('#0040ab')),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$white),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(75)),
			$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center),
			A2(
			$rtfeldman$elm_css$Css$Media$withMediaQuery,
			_List_fromArray(
				['screen and (max-width: 700px)']),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$width(
					$rtfeldman$elm_css$Css$pct(100))
				]))
		]),
	informationTextContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			A2(
			$rtfeldman$elm_css$Css$padding2,
			$rtfeldman$elm_css$Css$px(20),
			$rtfeldman$elm_css$Css$px(30)),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(16))
		]),
	inputContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100)),
			$rtfeldman$elm_css$Css$marginBottom(
			$rtfeldman$elm_css$Css$px(20))
		]),
	linkContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			A3(
				$rtfeldman$elm_css$Css$calc,
				$rtfeldman$elm_css$Css$pct(100),
				$rtfeldman$elm_css$Css$minus,
				$rtfeldman$elm_css$Css$px(48))),
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(16)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(65)),
			$rtfeldman$elm_css$Css$paddingBottom(
			$rtfeldman$elm_css$Css$px(30))
		]),
	listHeader: _List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Css$padding2,
			$rtfeldman$elm_css$Css$px(10),
			$rtfeldman$elm_css$Css$px(0)),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(18)),
			$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$start)
		]),
	message: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			A3(
				$rtfeldman$elm_css$Css$calc,
				$rtfeldman$elm_css$Css$pct(100),
				$rtfeldman$elm_css$Css$minus,
				$rtfeldman$elm_css$Css$px(48))),
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(-15)),
			$rtfeldman$elm_css$Css$marginBottom(
			$rtfeldman$elm_css$Css$px(20)),
			$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$fontWeight(
			$rtfeldman$elm_css$Css$int(900)),
			$rtfeldman$elm_css$Css$color(
			$rtfeldman$elm_css$Css$hex('2d64b1'))
		]),
	retryContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer),
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(10))
		]),
	sideContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			$rtfeldman$elm_css$Css$flex(
			$rtfeldman$elm_css$Css$num(1)),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$em(62)),
			$rtfeldman$elm_css$Css$paddingTop(
			$rtfeldman$elm_css$Css$px(40))
		]),
	spacing: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$paddingBottom(
			$rtfeldman$elm_css$Css$px(24))
		]),
	subHeader: _List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Css$padding2,
			$rtfeldman$elm_css$Css$px(10),
			$rtfeldman$elm_css$Css$px(30)),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(18))
		]),
	termsError: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(11)),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$red900)
		]),
	textContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(11)),
			$rtfeldman$elm_css$Css$lineHeight(
			$rtfeldman$elm_css$Css$px(13)),
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(16)),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$blueGrey600)
		])
};
var $author$project$Page$Register$Business$NewfoldRegisterMobile$displayFormError = function (formStatus) {
	if (formStatus.$ === 'Error') {
		var error = formStatus.a;
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Register$Business$NewfoldRegisterMobile$styles.formError)
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text(
					A2($author$project$Data$Api$errorToString, $author$project$Data$Api$Register$Newfold$errorToString, error))
				]));
	} else {
		return $rtfeldman$elm_css$Html$Styled$text('');
	}
};
var $author$project$Page$Register$Business$NewfoldRegisterMobile$displayTermsError = function (maybeError) {
	if (maybeError.$ === 'Nothing') {
		return $rtfeldman$elm_css$Html$Styled$text('');
	} else {
		var message = maybeError.a;
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Register$Business$NewfoldRegisterMobile$styles.termsError)
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text(message)
				]));
	}
};
var $author$project$Page$Register$Business$NewfoldRegisterMobile$showValidationStatus = function (status) {
	switch (status.$) {
		case 'Validating':
			return A2($author$project$Material$Styled$ProgressBar$linear, _List_Nil, _List_Nil);
		case 'Retry':
			return A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Register$Business$NewfoldRegisterMobile$styles.retryContainer),
						$rtfeldman$elm_css$Html$Styled$Events$onClick(
						$author$project$Types$OnNewfoldRegister($author$project$Type$NewfoldRegister$OnValidateDomain))
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('An error occurred, please retry.')
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$img,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$src($author$project$View$Theme$images.retry)
							]),
						_List_Nil)
					]));
		default:
			return $rtfeldman$elm_css$Html$Styled$text('');
	}
};
var $author$project$Page$Register$Business$NewfoldRegisterMobile$submitButton = function (model) {
	var hasError = A2(
		$elm$core$List$any,
		$elm$core$Basics$neq($elm$core$Maybe$Nothing),
		_List_fromArray(
			[model.companyNameError, model.firstNameError, model.lastNameError, model.emailError, model.passwordError, model.passwordAgainError, model.hasAgreedTermsError]));
	var _v0 = model;
	var formStatus = _v0.formStatus;
	var subdomainStatus = _v0.subdomainStatus;
	var validStatus = A2(
		$elm$core$Maybe$withDefault,
		false,
		A2(
			$elm$core$Maybe$map,
			function (status) {
				return _Utils_eq(status, $author$project$Data$Api$Register$ValidateDomain$NotUse);
			},
			subdomainStatus));
	switch (formStatus.$) {
		case 'Ready':
			return (hasError || (!validStatus)) ? $author$project$View$SubmitButton$disabled('SIGN UP') : $author$project$View$SubmitButton$enabled('SIGN UP');
		case 'Error':
			return $author$project$View$SubmitButton$enabled('SIGN UP');
		default:
			return $author$project$View$SubmitButton$submitting('Registering Your Account...');
	}
};
var $author$project$Page$Register$Business$NewfoldRegisterMobile$businessRegister = function (model) {
	var _v0 = model.newfoldRegisterModel;
	var formStatus = _v0.formStatus;
	var subdomain = _v0.subdomain;
	var subdomainStatus = _v0.subdomainStatus;
	var validationStatus = _v0.validationStatus;
	var redirectError = _v0.redirectError;
	var subdomainError = _v0.subdomainError;
	var companyName = _v0.companyName;
	var companyNameError = _v0.companyNameError;
	var firstName = _v0.firstName;
	var firstNameError = _v0.firstNameError;
	var lastName = _v0.lastName;
	var lastNameError = _v0.lastNameError;
	var email = _v0.email;
	var emailError = _v0.emailError;
	var password = _v0.password;
	var passwordError = _v0.passwordError;
	var passwordAgain = _v0.passwordAgain;
	var passwordAgainError = _v0.passwordAgainError;
	var hasAgreedTerms = _v0.hasAgreedTerms;
	var hasAgreedTermsError = _v0.hasAgreedTermsError;
	var referralCode = _v0.referralCode;
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				_Utils_ap($author$project$Page$Register$Business$NewfoldRegisterMobile$styles.sideContainer, $author$project$Page$Register$Business$NewfoldRegisterMobile$styles.businessRegister)),
				$rtfeldman$elm_css$Html$Styled$Attributes$id('businessRegister')
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$h2,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Register$Business$NewfoldRegisterMobile$styles.heading)
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('Start Your Free Trial')
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$form,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Register$Business$NewfoldRegisterMobile$styles.form),
						$rtfeldman$elm_css$Html$Styled$Events$onSubmit(
						$author$project$Types$OnNewfoldRegister($author$project$Type$NewfoldRegister$OnSubmit))
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Register$Business$NewfoldRegisterMobile$styles.domainContainer)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Material$Styled$Input$text,
								_List_fromArray(
									[
										$author$project$Material$Styled$Input$containerStyles($author$project$Page$Register$Business$NewfoldRegisterMobile$styles.domainInput),
										$author$project$Material$Styled$Input$label('Subdomain *'),
										$author$project$Material$Styled$Input$value(subdomain),
										$author$project$Material$Styled$Input$errorMessage(subdomainError),
										$author$project$Material$Styled$Input$onInput(
										A2(
											$elm$core$Basics$composeL,
											$author$project$Types$OnNewfoldRegister,
											$author$project$Type$NewfoldRegister$OnInput($author$project$Type$NewfoldRegister$SubDomain))),
										$author$project$Material$Styled$Input$onBlur(
										$author$project$Types$OnNewfoldRegister(
											$author$project$Type$NewfoldRegister$OnBlur($author$project$Type$NewfoldRegister$SubDomain)))
									]),
								_List_Nil),
								A2(
								$rtfeldman$elm_css$Html$Styled$span,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Register$Business$NewfoldRegisterMobile$styles.domainEndText)
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('.' + model.baseHost)
									]))
							])),
						$author$project$Page$Register$Business$NewfoldRegisterMobile$showValidationStatus(validationStatus),
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css(
								_Utils_ap($author$project$Page$Register$Business$NewfoldRegisterMobile$styles.domainContainer, $author$project$Page$Register$Business$NewfoldRegisterMobile$styles.domainText))
							]),
						_List_fromArray(
							[
								function () {
								if (subdomainStatus.$ === 'Just') {
									var value = subdomainStatus.a;
									if (value.$ === 'NotUse') {
										return $rtfeldman$elm_css$Html$Styled$text(
											$author$project$Model$BusinessRegister$trimRemoveSpace(subdomain) + ('.' + (model.baseHost + ' is available')));
									} else {
										return $rtfeldman$elm_css$Html$Styled$text('');
									}
								} else {
									return $rtfeldman$elm_css$Html$Styled$text('');
								}
							}()
							])),
						A2(
						$author$project$Material$Styled$Input$text,
						_List_fromArray(
							[
								$author$project$Material$Styled$Input$containerStyles($author$project$Page$Register$Business$NewfoldRegisterMobile$styles.inputContainer),
								$author$project$Material$Styled$Input$label('Company Name *'),
								$author$project$Material$Styled$Input$value(companyName),
								$author$project$Material$Styled$Input$errorMessage(companyNameError),
								$author$project$Material$Styled$Input$onInput(
								A2(
									$elm$core$Basics$composeL,
									$author$project$Types$OnNewfoldRegister,
									$author$project$Type$NewfoldRegister$OnInput($author$project$Type$NewfoldRegister$CompanyName))),
								$author$project$Material$Styled$Input$onBlur(
								$author$project$Types$OnNewfoldRegister(
									$author$project$Type$NewfoldRegister$OnBlur($author$project$Type$NewfoldRegister$CompanyName)))
							]),
						_List_Nil),
						A2(
						$author$project$Material$Styled$Input$text,
						_List_fromArray(
							[
								$author$project$Material$Styled$Input$containerStyles($author$project$Page$Register$Business$NewfoldRegisterMobile$styles.inputContainer),
								$author$project$Material$Styled$Input$label('First Name *'),
								$author$project$Material$Styled$Input$value(firstName),
								$author$project$Material$Styled$Input$errorMessage(firstNameError),
								$author$project$Material$Styled$Input$onInput(
								A2(
									$elm$core$Basics$composeL,
									$author$project$Types$OnNewfoldRegister,
									$author$project$Type$NewfoldRegister$OnInput($author$project$Type$NewfoldRegister$FirstName))),
								$author$project$Material$Styled$Input$onBlur(
								$author$project$Types$OnNewfoldRegister(
									$author$project$Type$NewfoldRegister$OnBlur($author$project$Type$NewfoldRegister$FirstName)))
							]),
						_List_Nil),
						A2(
						$author$project$Material$Styled$Input$text,
						_List_fromArray(
							[
								$author$project$Material$Styled$Input$containerStyles($author$project$Page$Register$Business$NewfoldRegisterMobile$styles.inputContainer),
								$author$project$Material$Styled$Input$label('Last Name *'),
								$author$project$Material$Styled$Input$value(lastName),
								$author$project$Material$Styled$Input$errorMessage(lastNameError),
								$author$project$Material$Styled$Input$onInput(
								A2(
									$elm$core$Basics$composeL,
									$author$project$Types$OnNewfoldRegister,
									$author$project$Type$NewfoldRegister$OnInput($author$project$Type$NewfoldRegister$LastName))),
								$author$project$Material$Styled$Input$onBlur(
								$author$project$Types$OnNewfoldRegister(
									$author$project$Type$NewfoldRegister$OnBlur($author$project$Type$NewfoldRegister$LastName)))
							]),
						_List_Nil),
						A2(
						$author$project$Material$Styled$Input$email,
						_List_fromArray(
							[
								$author$project$Material$Styled$Input$containerStyles($author$project$Page$Register$Business$NewfoldRegisterMobile$styles.inputContainer),
								$author$project$Material$Styled$Input$label('Email Address *'),
								$author$project$Material$Styled$Input$value(email),
								$author$project$Material$Styled$Input$errorMessage(emailError),
								$author$project$Material$Styled$Input$onInput(
								A2(
									$elm$core$Basics$composeL,
									$author$project$Types$OnNewfoldRegister,
									$author$project$Type$NewfoldRegister$OnInput($author$project$Type$NewfoldRegister$Email))),
								$author$project$Material$Styled$Input$onBlur(
								$author$project$Types$OnNewfoldRegister(
									$author$project$Type$NewfoldRegister$OnBlur($author$project$Type$NewfoldRegister$Email)))
							]),
						_List_Nil),
						A2(
						$author$project$Material$Styled$Input$password,
						_List_fromArray(
							[
								$author$project$Material$Styled$Input$containerStyles($author$project$Page$Register$Business$NewfoldRegisterMobile$styles.inputContainer),
								$author$project$Material$Styled$Input$label('Password *'),
								$author$project$Material$Styled$Input$value(password),
								$author$project$Material$Styled$Input$infoMessage('Password must contain at least 8 characters, a lowercase letter,\nan uppercase letter and a number'),
								$author$project$Material$Styled$Input$errorMessage(passwordError),
								$author$project$Material$Styled$Input$onInput(
								A2(
									$elm$core$Basics$composeL,
									$author$project$Types$OnNewfoldRegister,
									$author$project$Type$NewfoldRegister$OnInput($author$project$Type$NewfoldRegister$Password))),
								$author$project$Material$Styled$Input$onBlur(
								$author$project$Types$OnNewfoldRegister(
									$author$project$Type$NewfoldRegister$OnBlur($author$project$Type$NewfoldRegister$Password)))
							]),
						_List_Nil),
						A2(
						$author$project$Material$Styled$Input$password,
						_List_fromArray(
							[
								$author$project$Material$Styled$Input$containerStyles($author$project$Page$Register$Business$NewfoldRegisterMobile$styles.inputContainer),
								$author$project$Material$Styled$Input$label('Confirm Password *'),
								$author$project$Material$Styled$Input$value(passwordAgain),
								$author$project$Material$Styled$Input$errorMessage(passwordAgainError),
								$author$project$Material$Styled$Input$onInput(
								A2(
									$elm$core$Basics$composeL,
									$author$project$Types$OnNewfoldRegister,
									$author$project$Type$NewfoldRegister$OnInput($author$project$Type$NewfoldRegister$PasswordAgain))),
								$author$project$Material$Styled$Input$onBlur(
								$author$project$Types$OnNewfoldRegister(
									$author$project$Type$NewfoldRegister$OnBlur($author$project$Type$NewfoldRegister$PasswordAgain)))
							]),
						_List_Nil),
						A2(
						$author$project$Material$Styled$Input$text,
						_List_fromArray(
							[
								$author$project$Material$Styled$Input$containerStyles($author$project$Page$Register$Business$NewfoldRegisterMobile$styles.inputContainer),
								$author$project$Material$Styled$Input$label('Referral Code (Optional)'),
								$author$project$Material$Styled$Input$value(referralCode),
								$author$project$Material$Styled$Input$onInput(
								A2(
									$elm$core$Basics$composeL,
									$author$project$Types$OnNewfoldRegister,
									$author$project$Type$NewfoldRegister$OnInput($author$project$Type$NewfoldRegister$ReferralCode))),
								$author$project$Material$Styled$Input$onBlur(
								$author$project$Types$OnNewfoldRegister(
									$author$project$Type$NewfoldRegister$OnBlur($author$project$Type$NewfoldRegister$ReferralCode))),
								$author$project$Material$Styled$Input$disabled(true)
							]),
						_List_Nil),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Register$Business$NewfoldRegisterMobile$styles.checkboxContainer)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Material$Styled$Checkbox$checkbox,
								_List_fromArray(
									[
										$author$project$Material$Styled$Checkbox$onClick(
										$author$project$Types$OnNewfoldRegister($author$project$Type$NewfoldRegister$OnAgreeTerms)),
										$author$project$Material$Styled$Checkbox$checked(hasAgreedTerms)
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('I agree to the terms of service and privacy policy published '),
										A2(
										$author$project$Material$Styled$A$a,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$href('https://www.sign.net/legal/')
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('here')
											])),
										$rtfeldman$elm_css$Html$Styled$text('.'),
										$author$project$Page$Register$Business$NewfoldRegisterMobile$displayTermsError(hasAgreedTermsError)
									]))
							])),
						$author$project$Page$Register$Business$NewfoldRegisterMobile$displayFormError(formStatus),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Register$Business$NewfoldRegisterMobile$styles.formError)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								A2($elm$core$Maybe$withDefault, '', redirectError))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Register$Business$NewfoldRegisterMobile$styles.buttonContainer)
							]),
						_List_fromArray(
							[
								$author$project$Page$Register$Business$NewfoldRegisterMobile$submitButton(model.newfoldRegisterModel)
							]))
					])),
				A2(
				$author$project$Material$Styled$Divider$divider,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Register$Business$NewfoldRegisterMobile$styles.divider)
					]),
				_List_Nil),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Register$Business$NewfoldRegisterMobile$styles.linkContainer)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Material$Styled$A$a,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$href($author$project$Data$Route$routeUrl.login)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('Return to login')
							]))
					]))
			]));
};
var $author$project$Type$NewfoldRegister$OnArrowDown = {$: 'OnArrowDown'};
var $author$project$Page$Register$Business$NewfoldRegisterMobile$listInformation = A2(
	$rtfeldman$elm_css$Html$Styled$div,
	_List_fromArray(
		[
			$rtfeldman$elm_css$Html$Styled$Attributes$css(
			_Utils_ap($author$project$Page$Register$Business$NewfoldRegisterMobile$styles.sideContainer, $author$project$Page$Register$Business$NewfoldRegisterMobile$styles.informationContainer))
		]),
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Html$Styled$h1,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Register$Business$NewfoldRegisterMobile$styles.header)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('Send & Sign Anytime, Anywhere')
						]))
				])),
			A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Register$Business$NewfoldRegisterMobile$styles.businessImageBox)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Register$Business$NewfoldRegisterMobile$styles.subHeader)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('eSignature keeps your modern business moving forward from anywhere, at any time, on any device')
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Register$Business$NewfoldRegisterMobile$styles.informationTextContainer)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Register$Business$NewfoldRegisterMobile$styles.listHeader)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Key Features:')
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$ul,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$li,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Register$Business$NewfoldRegisterMobile$styles.spacing)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('Automate document workflows')
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$li,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Register$Business$NewfoldRegisterMobile$styles.spacing)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('Ensure legal significance of your documents')
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$li,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Register$Business$NewfoldRegisterMobile$styles.spacing)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('Collaborate with your team with templates')
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$li,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Register$Business$NewfoldRegisterMobile$styles.spacing)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('Add your corporate branding')
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$li,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Register$Business$NewfoldRegisterMobile$styles.spacing)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('Notarise documents on the blockchain')
										]))
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Register$Business$NewfoldRegisterMobile$styles.imageContainer)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$img,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$src($author$project$View$Theme$images.dashboard),
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Register$Business$NewfoldRegisterMobile$styles.imageStyles)
								]),
							_List_Nil)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Register$Business$NewfoldRegisterMobile$styles.arrow),
							$rtfeldman$elm_css$Html$Styled$Events$onClick(
							$author$project$Types$OnNewfoldRegister($author$project$Type$NewfoldRegister$OnArrowDown))
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Material$Styled$Icon$arrowCircleDown2,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Svg$Styled$Attributes$height('70px'),
									$rtfeldman$elm_css$Svg$Styled$Attributes$width('70px'),
									$rtfeldman$elm_css$Svg$Styled$Attributes$fill('white')
								]),
							_List_Nil)
						]))
				]))
		]));
var $author$project$Page$Register$Business$NewfoldRegisterMobile$view = function (model) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Register$Business$NewfoldRegisterMobile$styles.container)
			]),
		_List_fromArray(
			[
				$author$project$Page$Register$Business$NewfoldRegisterMobile$listInformation,
				$author$project$Page$Register$Business$NewfoldRegisterMobile$businessRegister(model)
			]));
};
var $author$project$Page$NewfoldRegisterPage$view = function (model) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$NewfoldRegisterPage$styles.desktop)
					]),
				_List_fromArray(
					[
						$author$project$Page$NewfoldRegisterPage$listInformation,
						$author$project$Page$NewfoldRegisterPage$businessRegister(model)
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$NewfoldRegisterPage$styles.mobile)
					]),
				_List_fromArray(
					[
						$author$project$Page$Register$Business$NewfoldRegisterMobile$view(model)
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$id('affilate')
					]),
				_List_Nil)
			]));
};
var $rtfeldman$elm_css$Css$letterSpacing = $rtfeldman$elm_css$Css$prop1('letter-spacing');
var $author$project$Page$NotFound$styles = {
	backHomeBtn: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(48)),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(14)),
			$rtfeldman$elm_css$Css$minWidth(
			$rtfeldman$elm_css$Css$px(64))
		]),
	container: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(64)),
			$rtfeldman$elm_css$Css$padding(
			$rtfeldman$elm_css$Css$px(24))
		]),
	fourZeroFourImg: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$maxHeight(
			$rtfeldman$elm_css$Css$px(300)),
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(48))
		]),
	subTitle: _List_fromArray(
		[
			A2($rtfeldman$elm_css$Css$margin2, $rtfeldman$elm_css$Css$zero, $rtfeldman$elm_css$Css$auto),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$blueGrey600),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(14)),
			$rtfeldman$elm_css$Css$lineHeight(
			$rtfeldman$elm_css$Css$px(21)),
			$rtfeldman$elm_css$Css$letterSpacing(
			$rtfeldman$elm_css$Css$px(-0.05)),
			$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center)
		]),
	title: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$blueGrey900),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(35)),
			$rtfeldman$elm_css$Css$lineHeight(
			$rtfeldman$elm_css$Css$px(40)),
			$rtfeldman$elm_css$Css$letterSpacing(
			$rtfeldman$elm_css$Css$px(-0.24)),
			$rtfeldman$elm_css$Css$marginBottom($rtfeldman$elm_css$Css$zero),
			$rtfeldman$elm_css$Css$fontWeight(
			$rtfeldman$elm_css$Css$int(500)),
			$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center)
		])
};
var $author$project$Page$NotFound$view = A2(
	$rtfeldman$elm_css$Html$Styled$div,
	_List_fromArray(
		[
			$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$NotFound$styles.container)
		]),
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Html$Styled$h1,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$NotFound$styles.title)
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text('404: The page you are looking for isn’t here')
				])),
			A2(
			$rtfeldman$elm_css$Html$Styled$p,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$NotFound$styles.subTitle)
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text('You either tried some shady route or you came here by mistake. Whichever it is, try using the navigation')
				])),
			A2(
			$rtfeldman$elm_css$Html$Styled$img,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$src($author$project$View$Theme$images.fourZeroFour),
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$NotFound$styles.fourZeroFourImg)
				]),
			_List_Nil),
			A2(
			$rtfeldman$elm_css$Html$Styled$a,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$href($author$project$Data$Route$routeUrl.login),
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$maxWidth($rtfeldman$elm_css$Css$fitContent)
						]))
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Material$Styled$Button$button,
					_List_fromArray(
						[
							$author$project$Material$Styled$Button$styles($author$project$Page$NotFound$styles.backHomeBtn)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('Back to Home')
						]))
				]))
		]));
var $author$project$Page$OrganizationUserRegister$styles = {
	boldText: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontWeight(
			$rtfeldman$elm_css$Css$int(1000)),
			$rtfeldman$elm_css$Css$paddingBottom(
			$rtfeldman$elm_css$Css$px(50)),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(18))
		]),
	businessText: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$paddingBottom(
			$rtfeldman$elm_css$Css$px(10))
		]),
	buttonContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100)),
			A2(
			$rtfeldman$elm_css$Css$margin2,
			$rtfeldman$elm_css$Css$px(16),
			$rtfeldman$elm_css$Css$zero)
		]),
	checkboxContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(8)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100)),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(14)),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$blueGrey600)
		]),
	desktop: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100)),
			A2(
			$rtfeldman$elm_css$Css$Media$withMediaQuery,
			_List_fromArray(
				['screen and (max-width: 1024px)']),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$none)
				]))
		]),
	divider: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			A3(
				$rtfeldman$elm_css$Css$calc,
				$rtfeldman$elm_css$Css$pct(100),
				$rtfeldman$elm_css$Css$minus,
				$rtfeldman$elm_css$Css$px(48)))
		]),
	dividerMargin: _List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Css$margin2,
			$rtfeldman$elm_css$Css$px(20),
			$rtfeldman$elm_css$Css$zero)
		]),
	form: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			A3(
				$rtfeldman$elm_css$Css$calc,
				$rtfeldman$elm_css$Css$pct(100),
				$rtfeldman$elm_css$Css$minus,
				$rtfeldman$elm_css$Css$px(48))),
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(60))
		]),
	formError: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(16)),
			$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(14)),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$red900)
		]),
	header: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(24))
		]),
	heading: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(24)),
			$rtfeldman$elm_css$Css$color(
			$rtfeldman$elm_css$Css$hex('0040ab')),
			$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$paddingTop(
			$rtfeldman$elm_css$Css$px(4))
		]),
	imageContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$row),
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(300))
		]),
	imageStyles: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(140)),
			$rtfeldman$elm_css$Css$margin(
			$rtfeldman$elm_css$Css$px(15)),
			A2(
			$rtfeldman$elm_css$Css$Media$withMediaQuery,
			_List_fromArray(
				['screen and (max-width: 1300px)']),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$width(
					$rtfeldman$elm_css$Css$px(130))
				]))
		]),
	informationContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$backgroundColor(
			$rtfeldman$elm_css$Css$hex('#0040ab')),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$white),
			$rtfeldman$elm_css$Css$marginLeft(
			$rtfeldman$elm_css$Css$px(150)),
			A2(
			$rtfeldman$elm_css$Css$Media$withMediaQuery,
			_List_fromArray(
				['screen and (max-width: 1390px)']),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$backgroundColor(
					$rtfeldman$elm_css$Css$hex('#0040ab')),
					$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$white),
					$rtfeldman$elm_css$Css$marginLeft(
					$rtfeldman$elm_css$Css$px(0))
				]))
		]),
	informationTextContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			$rtfeldman$elm_css$Css$padding(
			$rtfeldman$elm_css$Css$px(20)),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(16))
		]),
	inputContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginBottom(
			$rtfeldman$elm_css$Css$px(20))
		]),
	linkContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(60)),
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(16))
		]),
	message: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			A3(
				$rtfeldman$elm_css$Css$calc,
				$rtfeldman$elm_css$Css$pct(100),
				$rtfeldman$elm_css$Css$minus,
				$rtfeldman$elm_css$Css$px(48))),
			$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$marginBottom(
			$rtfeldman$elm_css$Css$px(25))
		]),
	mobile: _List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Css$Media$withMediaQuery,
			_List_fromArray(
				['screen and (min-width: 1025px)']),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$none)
				]))
		]),
	personalRegister: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$backgroundColor($author$project$Material$Styled$Color$white),
			$rtfeldman$elm_css$Css$marginRight(
			$rtfeldman$elm_css$Css$px(150)),
			A2(
			$rtfeldman$elm_css$Css$Media$withMediaQuery,
			_List_fromArray(
				['screen and (max-width: 1390px)']),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$backgroundColor($author$project$Material$Styled$Color$white),
					$rtfeldman$elm_css$Css$marginRight(
					$rtfeldman$elm_css$Css$px(0))
				]))
		]),
	sideContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			$rtfeldman$elm_css$Css$flex(
			$rtfeldman$elm_css$Css$num(1)),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(800)),
			$rtfeldman$elm_css$Css$paddingTop(
			$rtfeldman$elm_css$Css$px(40))
		]),
	smallerText: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(18)),
			A2(
			$rtfeldman$elm_css$Css$padding2,
			$rtfeldman$elm_css$Css$px(10),
			$rtfeldman$elm_css$Css$px(20))
		]),
	spacing: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$paddingBottom(
			$rtfeldman$elm_css$Css$px(24))
		]),
	termsError: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(11)),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$red900)
		]),
	textContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(11)),
			$rtfeldman$elm_css$Css$lineHeight(
			$rtfeldman$elm_css$Css$px(13)),
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(16)),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$blueGrey600)
		]),
	urlStyles: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$white),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(16))
		])
};
var $author$project$Page$OrganizationUserRegister$listInformation = A2(
	$rtfeldman$elm_css$Html$Styled$div,
	_List_fromArray(
		[
			$rtfeldman$elm_css$Html$Styled$Attributes$css(
			_Utils_ap($author$project$Page$OrganizationUserRegister$styles.sideContainer, $author$project$Page$OrganizationUserRegister$styles.informationContainer))
		]),
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Html$Styled$h1,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$OrganizationUserRegister$styles.header)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$OrganizationUserRegister$styles.businessText)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('Sign.net Businesss')
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$OrganizationUserRegister$styles.smallerText)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('A comprehensive suite of features to automate your workflows at scale')
						]))
				])),
			A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$OrganizationUserRegister$styles.imageContainer)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$img,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$src($author$project$View$Theme$images.signerIdentity),
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$OrganizationUserRegister$styles.imageStyles)
						]),
					_List_Nil),
					A2(
					$rtfeldman$elm_css$Html$Styled$img,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$src($author$project$View$Theme$images.clarityOfConsent),
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$OrganizationUserRegister$styles.imageStyles)
						]),
					_List_Nil),
					A2(
					$rtfeldman$elm_css$Html$Styled$img,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$src($author$project$View$Theme$images.documentSecurity),
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$OrganizationUserRegister$styles.imageStyles)
						]),
					_List_Nil)
				])),
			A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$OrganizationUserRegister$styles.informationTextContainer)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$ul,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$li,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$OrganizationUserRegister$styles.spacing)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Send out documents easily with shared document templates')
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$li,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$OrganizationUserRegister$styles.spacing)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Generate reports from your templates')
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$li,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$OrganizationUserRegister$styles.spacing)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Send automated reminders to your recipients')
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$li,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$OrganizationUserRegister$styles.spacing)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Set a designated signing order')
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$li,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$OrganizationUserRegister$styles.spacing)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Verify signers of the document with a passcode')
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$li,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$OrganizationUserRegister$styles.spacing)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Notarise documents on the blockchain')
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$li,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$OrganizationUserRegister$styles.spacing)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('& many more')
								]))
						]))
				]))
		]));
var $author$project$Type$PersonalRegister$Email = {$: 'Email'};
var $author$project$Type$PersonalRegister$FirstName = {$: 'FirstName'};
var $author$project$Type$PersonalRegister$LastName = {$: 'LastName'};
var $author$project$Type$PersonalRegister$OnAgreeTerms = {$: 'OnAgreeTerms'};
var $author$project$Type$PersonalRegister$OnBlur = function (a) {
	return {$: 'OnBlur', a: a};
};
var $author$project$Type$PersonalRegister$OnInput = F2(
	function (a, b) {
		return {$: 'OnInput', a: a, b: b};
	});
var $author$project$Type$PersonalRegister$OnSubmit = {$: 'OnSubmit'};
var $author$project$Type$PersonalRegister$Password = {$: 'Password'};
var $author$project$Type$PersonalRegister$PasswordAgain = {$: 'PasswordAgain'};
var $author$project$Data$Api$Register$Personal$errorToString = function (error) {
	switch (error.$) {
		case 'USER_EXIST':
			return 'Account already exists. Please try to reset your password instead.';
		case 'PASSWORD_REQUIREMENT':
			return 'Password must contain at least 8 characters, a lowercase letter, an uppercase letter and a number.';
		case 'INVALID_EMAIL':
			return 'Email submitted is invalid.';
		case 'EMPTY_NAME':
			return 'First and last name submitted is invalid.';
		case 'UPDATE_ANONYMOUS':
			return 'Unable to create an account. Please try again later.';
		case 'LIMIT_REACHED':
			return 'You have created too many accounts. Please try again at another time.';
		default:
			return 'We encountered an issue while processing your request. Please disable any Ad-Blocker or Tracking-Blocker and try again.';
	}
};
var $author$project$Page$OrganizationUserRegister$displayFormError = function (formStatus) {
	if (formStatus.$ === 'Error') {
		var error = formStatus.a;
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$OrganizationUserRegister$styles.formError)
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text(
					A2($author$project$Data$Api$errorToString, $author$project$Data$Api$Register$Personal$errorToString, error))
				]));
	} else {
		return $rtfeldman$elm_css$Html$Styled$text('');
	}
};
var $author$project$Page$OrganizationUserRegister$displayTermsError = function (maybeError) {
	if (maybeError.$ === 'Nothing') {
		return $rtfeldman$elm_css$Html$Styled$text('');
	} else {
		var message = maybeError.a;
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$OrganizationUserRegister$styles.termsError)
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text(message)
				]));
	}
};
var $author$project$Page$OrganizationUserRegister$isFieldDisabled = function (field) {
	if (field.$ === 'IsQueryParam') {
		return true;
	} else {
		return false;
	}
};
var $author$project$Page$OrganizationUserRegister$submitButton = function (model) {
	var hasError = A2(
		$elm$core$List$any,
		$elm$core$Basics$neq($elm$core$Maybe$Nothing),
		_List_fromArray(
			[model.firstNameError, model.lastNameError, model.emailError, model.passwordError, model.passwordAgainError, model.hasAgreedTermsError]));
	var _v0 = model;
	var formStatus = _v0.formStatus;
	switch (formStatus.$) {
		case 'Ready':
			return hasError ? $author$project$View$SubmitButton$disabled('SIGN UP') : $author$project$View$SubmitButton$enabled('SIGN UP');
		case 'Error':
			var err = formStatus.a;
			if ((err.$ === 'Fail') && (err.a.$ === 'LIMIT_REACHED')) {
				var _v3 = err.a;
				return $author$project$View$SubmitButton$disabled('ACCOUNT LIMIT REACHED');
			} else {
				return $author$project$View$SubmitButton$enabled('SIGN UP');
			}
		default:
			return $author$project$View$SubmitButton$submitting('Registering Your Account...');
	}
};
var $author$project$Page$OrganizationUserRegister$personalRegister = function (model) {
	var _v0 = model.registerModel;
	var formStatus = _v0.formStatus;
	var firstName = _v0.firstName;
	var firstNameError = _v0.firstNameError;
	var lastName = _v0.lastName;
	var lastNameError = _v0.lastNameError;
	var email = _v0.email;
	var emailError = _v0.emailError;
	var password = _v0.password;
	var passwordError = _v0.passwordError;
	var passwordAgain = _v0.passwordAgain;
	var passwordAgainError = _v0.passwordAgainError;
	var hasAgreedTerms = _v0.hasAgreedTerms;
	var hasAgreedTermsError = _v0.hasAgreedTermsError;
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				_Utils_ap($author$project$Page$OrganizationUserRegister$styles.sideContainer, $author$project$Page$OrganizationUserRegister$styles.personalRegister))
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$h2,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$OrganizationUserRegister$styles.heading)
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('Join Your Team on Sign.net')
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$form,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Events$onSubmit(
						$author$project$Types$OnRegister($author$project$Type$PersonalRegister$OnSubmit)),
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$OrganizationUserRegister$styles.form)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Material$Styled$Input$text,
						_List_fromArray(
							[
								$author$project$Material$Styled$Input$containerStyles($author$project$Page$OrganizationUserRegister$styles.inputContainer),
								$author$project$Material$Styled$Input$label('First Name *'),
								$author$project$Material$Styled$Input$value(firstName),
								$author$project$Material$Styled$Input$errorMessage(firstNameError),
								$author$project$Material$Styled$Input$onInput(
								A2(
									$elm$core$Basics$composeL,
									$author$project$Types$OnRegister,
									$author$project$Type$PersonalRegister$OnInput($author$project$Type$PersonalRegister$FirstName))),
								$author$project$Material$Styled$Input$onBlur(
								$author$project$Types$OnRegister(
									$author$project$Type$PersonalRegister$OnBlur($author$project$Type$PersonalRegister$FirstName)))
							]),
						_List_Nil),
						A2(
						$author$project$Material$Styled$Input$text,
						_List_fromArray(
							[
								$author$project$Material$Styled$Input$containerStyles($author$project$Page$OrganizationUserRegister$styles.inputContainer),
								$author$project$Material$Styled$Input$label('Last Name *'),
								$author$project$Material$Styled$Input$value(lastName),
								$author$project$Material$Styled$Input$errorMessage(lastNameError),
								$author$project$Material$Styled$Input$onInput(
								A2(
									$elm$core$Basics$composeL,
									$author$project$Types$OnRegister,
									$author$project$Type$PersonalRegister$OnInput($author$project$Type$PersonalRegister$LastName))),
								$author$project$Material$Styled$Input$onBlur(
								$author$project$Types$OnRegister(
									$author$project$Type$PersonalRegister$OnBlur($author$project$Type$PersonalRegister$LastName)))
							]),
						_List_Nil),
						A2(
						$author$project$Material$Styled$Input$email,
						_List_fromArray(
							[
								$author$project$Material$Styled$Input$containerStyles($author$project$Page$OrganizationUserRegister$styles.inputContainer),
								$author$project$Material$Styled$Input$label('Email Address *'),
								$author$project$Material$Styled$Input$value(
								$author$project$Model$PersonalRegister$getQueryParamValue(email)),
								$author$project$Material$Styled$Input$errorMessage(emailError),
								$author$project$Material$Styled$Input$onInput(
								A2(
									$elm$core$Basics$composeL,
									$author$project$Types$OnRegister,
									$author$project$Type$PersonalRegister$OnInput($author$project$Type$PersonalRegister$Email))),
								$author$project$Material$Styled$Input$onBlur(
								$author$project$Types$OnRegister(
									$author$project$Type$PersonalRegister$OnBlur($author$project$Type$PersonalRegister$Email))),
								$author$project$Material$Styled$Input$disabled(
								$author$project$Page$OrganizationUserRegister$isFieldDisabled(email))
							]),
						_List_Nil),
						A2(
						$author$project$Material$Styled$Input$password,
						_List_fromArray(
							[
								$author$project$Material$Styled$Input$containerStyles($author$project$Page$OrganizationUserRegister$styles.inputContainer),
								$author$project$Material$Styled$Input$label('Password *'),
								$author$project$Material$Styled$Input$value(password),
								$author$project$Material$Styled$Input$infoMessage('Password must contain at least 8 characters, a lowercase letter,\nan uppercase letter and a number'),
								$author$project$Material$Styled$Input$errorMessage(passwordError),
								$author$project$Material$Styled$Input$onInput(
								A2(
									$elm$core$Basics$composeL,
									$author$project$Types$OnRegister,
									$author$project$Type$PersonalRegister$OnInput($author$project$Type$PersonalRegister$Password))),
								$author$project$Material$Styled$Input$onBlur(
								$author$project$Types$OnRegister(
									$author$project$Type$PersonalRegister$OnBlur($author$project$Type$PersonalRegister$Password)))
							]),
						_List_Nil),
						A2(
						$author$project$Material$Styled$Input$password,
						_List_fromArray(
							[
								$author$project$Material$Styled$Input$containerStyles($author$project$Page$OrganizationUserRegister$styles.inputContainer),
								$author$project$Material$Styled$Input$label('Confirm Password *'),
								$author$project$Material$Styled$Input$value(passwordAgain),
								$author$project$Material$Styled$Input$errorMessage(passwordAgainError),
								$author$project$Material$Styled$Input$onInput(
								A2(
									$elm$core$Basics$composeL,
									$author$project$Types$OnRegister,
									$author$project$Type$PersonalRegister$OnInput($author$project$Type$PersonalRegister$PasswordAgain))),
								$author$project$Material$Styled$Input$onBlur(
								$author$project$Types$OnRegister(
									$author$project$Type$PersonalRegister$OnBlur($author$project$Type$PersonalRegister$PasswordAgain)))
							]),
						_List_Nil),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$OrganizationUserRegister$styles.checkboxContainer)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Material$Styled$Checkbox$checkbox,
								_List_fromArray(
									[
										$author$project$Material$Styled$Checkbox$onClick(
										$author$project$Types$OnRegister($author$project$Type$PersonalRegister$OnAgreeTerms)),
										$author$project$Material$Styled$Checkbox$checked(hasAgreedTerms)
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('I agree to the terms of service and privacy policy published '),
										A2(
										$author$project$Material$Styled$A$a,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$href('https://www.sign.net/legal/')
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('here')
											])),
										$rtfeldman$elm_css$Html$Styled$text('.'),
										$author$project$Page$OrganizationUserRegister$displayTermsError(hasAgreedTermsError)
									]))
							])),
						$author$project$Page$OrganizationUserRegister$displayFormError(formStatus),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$OrganizationUserRegister$styles.buttonContainer)
							]),
						_List_fromArray(
							[
								$author$project$Page$OrganizationUserRegister$submitButton(model.registerModel)
							]))
					])),
				A2(
				$author$project$Material$Styled$Divider$divider,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$OrganizationUserRegister$styles.divider)
					]),
				_List_Nil)
			]));
};
var $author$project$Page$Register$Business$OrganizationRegisterMobile$styles = {
	arrow: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$paddingTop(
			$rtfeldman$elm_css$Css$px(20)),
			A2(
			$rtfeldman$elm_css$Css$Media$withMediaQuery,
			_List_fromArray(
				['screen and (min-width: 700px)']),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$none)
				]))
		]),
	boldText: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontWeight(
			$rtfeldman$elm_css$Css$int(1000)),
			$rtfeldman$elm_css$Css$paddingBottom(
			$rtfeldman$elm_css$Css$px(50))
		]),
	box: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(20)),
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			A2(
			$rtfeldman$elm_css$Css$padding2,
			$rtfeldman$elm_css$Css$px(30),
			$rtfeldman$elm_css$Css$px(40)),
			$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$marginBottom(
			$rtfeldman$elm_css$Css$px(30))
		]),
	businessImageBox: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$marginBottom(
			$rtfeldman$elm_css$Css$px(0)),
			A2(
			$rtfeldman$elm_css$Css$Media$withMediaQuery,
			_List_fromArray(
				['screen and (max-width: 700px)']),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column)
				]))
		]),
	businessRegister: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$backgroundColor($author$project$Material$Styled$Color$white),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(75)),
			A2(
			$rtfeldman$elm_css$Css$Media$withMediaQuery,
			_List_fromArray(
				['screen and (max-width: 700px)']),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$width(
					$rtfeldman$elm_css$Css$pct(100))
				]))
		]),
	buttonContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100)),
			A2(
			$rtfeldman$elm_css$Css$margin2,
			$rtfeldman$elm_css$Css$px(16),
			$rtfeldman$elm_css$Css$zero)
		]),
	checkboxContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(8)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100)),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(14)),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$blueGrey600)
		]),
	container: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100)),
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column)
		]),
	divider: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			A3(
				$rtfeldman$elm_css$Css$calc,
				$rtfeldman$elm_css$Css$pct(100),
				$rtfeldman$elm_css$Css$minus,
				$rtfeldman$elm_css$Css$px(48)))
		]),
	domainContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$row),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100))
		]),
	domainEndText: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$paddingTop(
			$rtfeldman$elm_css$Css$px(35))
		]),
	domainInput: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(90))
		]),
	domainText: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(12)),
			$rtfeldman$elm_css$Css$paddingLeft(
			$rtfeldman$elm_css$Css$px(10)),
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(5)),
			$rtfeldman$elm_css$Css$marginBottom(
			$rtfeldman$elm_css$Css$px(20))
		]),
	form: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			A3(
				$rtfeldman$elm_css$Css$calc,
				$rtfeldman$elm_css$Css$pct(100),
				$rtfeldman$elm_css$Css$minus,
				$rtfeldman$elm_css$Css$px(48))),
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(65))
		]),
	formError: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(16)),
			$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(14)),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$red900)
		]),
	header: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(24)),
			A2(
			$rtfeldman$elm_css$Css$padding2,
			$rtfeldman$elm_css$Css$zero,
			$rtfeldman$elm_css$Css$px(30))
		]),
	heading: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(24)),
			$rtfeldman$elm_css$Css$color(
			$rtfeldman$elm_css$Css$hex('2d64b1'))
		]),
	imageContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(300))
		]),
	imageStyles: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(280)),
			$rtfeldman$elm_css$Css$margin(
			$rtfeldman$elm_css$Css$px(15))
		]),
	informationContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$backgroundColor(
			$rtfeldman$elm_css$Css$hex('#0040ab')),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$white),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(75)),
			$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center),
			A2(
			$rtfeldman$elm_css$Css$Media$withMediaQuery,
			_List_fromArray(
				['screen and (max-width: 700px)']),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$width(
					$rtfeldman$elm_css$Css$pct(100))
				]))
		]),
	informationTextContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			A2(
			$rtfeldman$elm_css$Css$padding2,
			$rtfeldman$elm_css$Css$px(20),
			$rtfeldman$elm_css$Css$px(30)),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(16))
		]),
	inputContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100)),
			$rtfeldman$elm_css$Css$marginBottom(
			$rtfeldman$elm_css$Css$px(20))
		]),
	linkContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			A3(
				$rtfeldman$elm_css$Css$calc,
				$rtfeldman$elm_css$Css$pct(100),
				$rtfeldman$elm_css$Css$minus,
				$rtfeldman$elm_css$Css$px(48))),
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(16)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(65)),
			$rtfeldman$elm_css$Css$paddingBottom(
			$rtfeldman$elm_css$Css$px(30))
		]),
	message: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			A3(
				$rtfeldman$elm_css$Css$calc,
				$rtfeldman$elm_css$Css$pct(100),
				$rtfeldman$elm_css$Css$minus,
				$rtfeldman$elm_css$Css$px(48))),
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(-15)),
			$rtfeldman$elm_css$Css$marginBottom(
			$rtfeldman$elm_css$Css$px(20)),
			$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$fontWeight(
			$rtfeldman$elm_css$Css$int(900)),
			$rtfeldman$elm_css$Css$color(
			$rtfeldman$elm_css$Css$hex('2d64b1'))
		]),
	personalRegister: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$backgroundColor($author$project$Material$Styled$Color$white),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100))
		]),
	retryContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer),
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(10))
		]),
	sideContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			$rtfeldman$elm_css$Css$flex(
			$rtfeldman$elm_css$Css$num(1)),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$em(62)),
			$rtfeldman$elm_css$Css$paddingTop(
			$rtfeldman$elm_css$Css$px(40))
		]),
	spacing: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$paddingBottom(
			$rtfeldman$elm_css$Css$px(24))
		]),
	subHeader: _List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Css$padding2,
			$rtfeldman$elm_css$Css$px(10),
			$rtfeldman$elm_css$Css$px(30)),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(18))
		]),
	termsError: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(11)),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$red900)
		]),
	textContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(11)),
			$rtfeldman$elm_css$Css$lineHeight(
			$rtfeldman$elm_css$Css$px(13)),
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(16)),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$blueGrey600)
		])
};
var $author$project$Page$Register$Business$OrganizationRegisterMobile$listInformation = A2(
	$rtfeldman$elm_css$Html$Styled$div,
	_List_fromArray(
		[
			$rtfeldman$elm_css$Html$Styled$Attributes$css(
			_Utils_ap($author$project$Page$Register$Business$OrganizationRegisterMobile$styles.sideContainer, $author$project$Page$Register$Business$OrganizationRegisterMobile$styles.informationContainer))
		]),
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Html$Styled$h1,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Register$Business$OrganizationRegisterMobile$styles.header)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('Sign.net Businesss')
						]))
				])),
			A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Register$Business$OrganizationRegisterMobile$styles.businessImageBox)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Register$Business$OrganizationRegisterMobile$styles.subHeader)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('A comprehensive suite of features to automate your workflows at scale')
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Register$Business$OrganizationRegisterMobile$styles.imageContainer)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$img,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$src($author$project$View$Theme$images.signerIdentity),
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Register$Business$OrganizationRegisterMobile$styles.imageStyles)
								]),
							_List_Nil),
							A2(
							$rtfeldman$elm_css$Html$Styled$img,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$src($author$project$View$Theme$images.clarityOfConsent),
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Register$Business$OrganizationRegisterMobile$styles.imageStyles)
								]),
							_List_Nil),
							A2(
							$rtfeldman$elm_css$Html$Styled$img,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$src($author$project$View$Theme$images.documentSecurity),
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Register$Business$OrganizationRegisterMobile$styles.imageStyles)
								]),
							_List_Nil)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Register$Business$OrganizationRegisterMobile$styles.informationTextContainer)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$ul,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$li,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Register$Business$OrganizationRegisterMobile$styles.spacing)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('Send out documents easily with shared document templates')
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$li,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Register$Business$OrganizationRegisterMobile$styles.spacing)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('Generate reports from your templates')
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$li,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Register$Business$OrganizationRegisterMobile$styles.spacing)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('Send automated reminders to your recipients')
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$li,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Register$Business$OrganizationRegisterMobile$styles.spacing)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('Set a designated signing order')
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$li,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Register$Business$OrganizationRegisterMobile$styles.spacing)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('Verify signers of the document with a passcode')
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$li,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Register$Business$OrganizationRegisterMobile$styles.spacing)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('Notarise documents on the blockchain')
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$li,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Register$Business$OrganizationRegisterMobile$styles.spacing)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('& many more')
										]))
								]))
						]))
				]))
		]));
var $author$project$Page$Register$Business$OrganizationRegisterMobile$displayFormError = function (formStatus) {
	if (formStatus.$ === 'Error') {
		var error = formStatus.a;
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Register$Business$OrganizationRegisterMobile$styles.formError)
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text(
					A2($author$project$Data$Api$errorToString, $author$project$Data$Api$Register$Personal$errorToString, error))
				]));
	} else {
		return $rtfeldman$elm_css$Html$Styled$text('');
	}
};
var $author$project$Page$Register$Business$OrganizationRegisterMobile$displayTermsError = function (maybeError) {
	if (maybeError.$ === 'Nothing') {
		return $rtfeldman$elm_css$Html$Styled$text('');
	} else {
		var message = maybeError.a;
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Register$Business$OrganizationRegisterMobile$styles.termsError)
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text(message)
				]));
	}
};
var $author$project$Page$Register$Business$OrganizationRegisterMobile$isFieldDisabled = function (field) {
	if (field.$ === 'IsQueryParam') {
		return true;
	} else {
		return false;
	}
};
var $author$project$Page$Register$Business$OrganizationRegisterMobile$submitButton = function (model) {
	var hasError = A2(
		$elm$core$List$any,
		$elm$core$Basics$neq($elm$core$Maybe$Nothing),
		_List_fromArray(
			[model.firstNameError, model.lastNameError, model.emailError, model.passwordError, model.passwordAgainError, model.hasAgreedTermsError]));
	var _v0 = model;
	var formStatus = _v0.formStatus;
	switch (formStatus.$) {
		case 'Ready':
			return hasError ? $author$project$View$SubmitButton$disabled('SIGN UP') : $author$project$View$SubmitButton$enabled('SIGN UP');
		case 'Error':
			var err = formStatus.a;
			if ((err.$ === 'Fail') && (err.a.$ === 'LIMIT_REACHED')) {
				var _v3 = err.a;
				return $author$project$View$SubmitButton$disabled('ACCOUNT LIMIT REACHED');
			} else {
				return $author$project$View$SubmitButton$enabled('SIGN UP');
			}
		default:
			return $author$project$View$SubmitButton$submitting('Registering Your Account...');
	}
};
var $author$project$Page$Register$Business$OrganizationRegisterMobile$personalRegister = function (model) {
	var _v0 = model.registerModel;
	var formStatus = _v0.formStatus;
	var firstName = _v0.firstName;
	var firstNameError = _v0.firstNameError;
	var lastName = _v0.lastName;
	var lastNameError = _v0.lastNameError;
	var email = _v0.email;
	var emailError = _v0.emailError;
	var password = _v0.password;
	var passwordError = _v0.passwordError;
	var passwordAgain = _v0.passwordAgain;
	var passwordAgainError = _v0.passwordAgainError;
	var referralCode = _v0.referralCode;
	var hasAgreedTerms = _v0.hasAgreedTerms;
	var hasAgreedTermsError = _v0.hasAgreedTermsError;
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				_Utils_ap($author$project$Page$Register$Business$OrganizationRegisterMobile$styles.sideContainer, $author$project$Page$Register$Business$OrganizationRegisterMobile$styles.personalRegister))
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$h2,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Register$Business$OrganizationRegisterMobile$styles.heading)
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('Join Your Team on Sign.net')
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$form,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Events$onSubmit(
						$author$project$Types$OnRegister($author$project$Type$PersonalRegister$OnSubmit)),
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Register$Business$OrganizationRegisterMobile$styles.form)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Material$Styled$Input$text,
						_List_fromArray(
							[
								$author$project$Material$Styled$Input$containerStyles($author$project$Page$Register$Business$OrganizationRegisterMobile$styles.inputContainer),
								$author$project$Material$Styled$Input$label('First Name *'),
								$author$project$Material$Styled$Input$value(firstName),
								$author$project$Material$Styled$Input$errorMessage(firstNameError),
								$author$project$Material$Styled$Input$onInput(
								A2(
									$elm$core$Basics$composeL,
									$author$project$Types$OnRegister,
									$author$project$Type$PersonalRegister$OnInput($author$project$Type$PersonalRegister$FirstName))),
								$author$project$Material$Styled$Input$onBlur(
								$author$project$Types$OnRegister(
									$author$project$Type$PersonalRegister$OnBlur($author$project$Type$PersonalRegister$FirstName)))
							]),
						_List_Nil),
						A2(
						$author$project$Material$Styled$Input$text,
						_List_fromArray(
							[
								$author$project$Material$Styled$Input$containerStyles($author$project$Page$Register$Business$OrganizationRegisterMobile$styles.inputContainer),
								$author$project$Material$Styled$Input$label('Last Name *'),
								$author$project$Material$Styled$Input$value(lastName),
								$author$project$Material$Styled$Input$errorMessage(lastNameError),
								$author$project$Material$Styled$Input$onInput(
								A2(
									$elm$core$Basics$composeL,
									$author$project$Types$OnRegister,
									$author$project$Type$PersonalRegister$OnInput($author$project$Type$PersonalRegister$LastName))),
								$author$project$Material$Styled$Input$onBlur(
								$author$project$Types$OnRegister(
									$author$project$Type$PersonalRegister$OnBlur($author$project$Type$PersonalRegister$LastName)))
							]),
						_List_Nil),
						A2(
						$author$project$Material$Styled$Input$email,
						_List_fromArray(
							[
								$author$project$Material$Styled$Input$containerStyles($author$project$Page$Register$Business$OrganizationRegisterMobile$styles.inputContainer),
								$author$project$Material$Styled$Input$label('Email Address *'),
								$author$project$Material$Styled$Input$value(
								$author$project$Model$PersonalRegister$getQueryParamValue(email)),
								$author$project$Material$Styled$Input$errorMessage(emailError),
								$author$project$Material$Styled$Input$onInput(
								A2(
									$elm$core$Basics$composeL,
									$author$project$Types$OnRegister,
									$author$project$Type$PersonalRegister$OnInput($author$project$Type$PersonalRegister$Email))),
								$author$project$Material$Styled$Input$onBlur(
								$author$project$Types$OnRegister(
									$author$project$Type$PersonalRegister$OnBlur($author$project$Type$PersonalRegister$Email))),
								$author$project$Material$Styled$Input$disabled(
								$author$project$Page$Register$Business$OrganizationRegisterMobile$isFieldDisabled(email))
							]),
						_List_Nil),
						A2(
						$author$project$Material$Styled$Input$password,
						_List_fromArray(
							[
								$author$project$Material$Styled$Input$containerStyles($author$project$Page$Register$Business$OrganizationRegisterMobile$styles.inputContainer),
								$author$project$Material$Styled$Input$label('Password *'),
								$author$project$Material$Styled$Input$value(password),
								$author$project$Material$Styled$Input$infoMessage('Password must contain at least 8 characters, a lowercase letter,\nan uppercase letter and a number'),
								$author$project$Material$Styled$Input$errorMessage(passwordError),
								$author$project$Material$Styled$Input$onInput(
								A2(
									$elm$core$Basics$composeL,
									$author$project$Types$OnRegister,
									$author$project$Type$PersonalRegister$OnInput($author$project$Type$PersonalRegister$Password))),
								$author$project$Material$Styled$Input$onBlur(
								$author$project$Types$OnRegister(
									$author$project$Type$PersonalRegister$OnBlur($author$project$Type$PersonalRegister$Password)))
							]),
						_List_Nil),
						A2(
						$author$project$Material$Styled$Input$password,
						_List_fromArray(
							[
								$author$project$Material$Styled$Input$containerStyles($author$project$Page$Register$Business$OrganizationRegisterMobile$styles.inputContainer),
								$author$project$Material$Styled$Input$label('Confirm Password *'),
								$author$project$Material$Styled$Input$value(passwordAgain),
								$author$project$Material$Styled$Input$errorMessage(passwordAgainError),
								$author$project$Material$Styled$Input$onInput(
								A2(
									$elm$core$Basics$composeL,
									$author$project$Types$OnRegister,
									$author$project$Type$PersonalRegister$OnInput($author$project$Type$PersonalRegister$PasswordAgain))),
								$author$project$Material$Styled$Input$onBlur(
								$author$project$Types$OnRegister(
									$author$project$Type$PersonalRegister$OnBlur($author$project$Type$PersonalRegister$PasswordAgain)))
							]),
						_List_Nil),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Register$Business$OrganizationRegisterMobile$styles.checkboxContainer)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Material$Styled$Checkbox$checkbox,
								_List_fromArray(
									[
										$author$project$Material$Styled$Checkbox$onClick(
										$author$project$Types$OnRegister($author$project$Type$PersonalRegister$OnAgreeTerms)),
										$author$project$Material$Styled$Checkbox$checked(hasAgreedTerms)
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('I agree to the terms of service and privacy policy published '),
										A2(
										$author$project$Material$Styled$A$a,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$href('https://www.sign.net/legal/')
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('here')
											])),
										$rtfeldman$elm_css$Html$Styled$text('.'),
										$author$project$Page$Register$Business$OrganizationRegisterMobile$displayTermsError(hasAgreedTermsError)
									]))
							])),
						$author$project$Page$Register$Business$OrganizationRegisterMobile$displayFormError(formStatus),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Register$Business$OrganizationRegisterMobile$styles.buttonContainer)
							]),
						_List_fromArray(
							[
								$author$project$Page$Register$Business$OrganizationRegisterMobile$submitButton(model.registerModel)
							]))
					])),
				A2(
				$author$project$Material$Styled$Divider$divider,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Register$Business$OrganizationRegisterMobile$styles.divider)
					]),
				_List_Nil)
			]));
};
var $author$project$Page$Register$Business$OrganizationRegisterMobile$view = function (model) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Register$Business$OrganizationRegisterMobile$styles.container)
			]),
		_List_fromArray(
			[
				$author$project$Page$Register$Business$OrganizationRegisterMobile$listInformation,
				$author$project$Page$Register$Business$OrganizationRegisterMobile$personalRegister(model)
			]));
};
var $author$project$Page$OrganizationUserRegister$view = function (model) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$OrganizationUserRegister$styles.desktop)
					]),
				_List_fromArray(
					[
						$author$project$Page$OrganizationUserRegister$listInformation,
						$author$project$Page$OrganizationUserRegister$personalRegister(model)
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$OrganizationUserRegister$styles.mobile)
					]),
				_List_fromArray(
					[
						$author$project$Page$Register$Business$OrganizationRegisterMobile$view(model)
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$id('affilate')
					]),
				_List_Nil)
			]));
};
var $author$project$Page$PersonalRegister$styles = {
	boldText: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontWeight(
			$rtfeldman$elm_css$Css$int(1000)),
			$rtfeldman$elm_css$Css$paddingBottom(
			$rtfeldman$elm_css$Css$px(50)),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(18))
		]),
	businessText: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$paddingBottom(
			$rtfeldman$elm_css$Css$px(50)),
			$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center)
		]),
	buttonContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100)),
			A2(
			$rtfeldman$elm_css$Css$margin2,
			$rtfeldman$elm_css$Css$px(16),
			$rtfeldman$elm_css$Css$zero)
		]),
	checkboxContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(8)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100)),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(14)),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$blueGrey600)
		]),
	desktop: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100)),
			A2(
			$rtfeldman$elm_css$Css$Media$withMediaQuery,
			_List_fromArray(
				['screen and (max-width: 1024px)']),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$none)
				]))
		]),
	divider: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			A3(
				$rtfeldman$elm_css$Css$calc,
				$rtfeldman$elm_css$Css$pct(100),
				$rtfeldman$elm_css$Css$minus,
				$rtfeldman$elm_css$Css$px(48)))
		]),
	dividerMargin: _List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Css$margin2,
			$rtfeldman$elm_css$Css$px(20),
			$rtfeldman$elm_css$Css$zero)
		]),
	form: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			A3(
				$rtfeldman$elm_css$Css$calc,
				$rtfeldman$elm_css$Css$pct(100),
				$rtfeldman$elm_css$Css$minus,
				$rtfeldman$elm_css$Css$px(48))),
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(60))
		]),
	formError: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(16)),
			$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(14)),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$red900)
		]),
	header: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(24))
		]),
	heading: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(24)),
			$rtfeldman$elm_css$Css$color(
			$rtfeldman$elm_css$Css$hex('0040ab')),
			$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$paddingTop(
			$rtfeldman$elm_css$Css$px(4))
		]),
	imageContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$row),
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(300))
		]),
	imageStyles: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(140)),
			$rtfeldman$elm_css$Css$margin(
			$rtfeldman$elm_css$Css$px(15)),
			A2(
			$rtfeldman$elm_css$Css$Media$withMediaQuery,
			_List_fromArray(
				['screen and (max-width: 1300px)']),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$width(
					$rtfeldman$elm_css$Css$px(130))
				]))
		]),
	informationContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$backgroundColor(
			$rtfeldman$elm_css$Css$hex('#0040ab')),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$white),
			$rtfeldman$elm_css$Css$marginLeft(
			$rtfeldman$elm_css$Css$px(150)),
			A2(
			$rtfeldman$elm_css$Css$Media$withMediaQuery,
			_List_fromArray(
				['screen and (max-width: 1390px)']),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$backgroundColor(
					$rtfeldman$elm_css$Css$hex('#0040ab')),
					$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$white),
					$rtfeldman$elm_css$Css$marginLeft(
					$rtfeldman$elm_css$Css$px(0))
				]))
		]),
	informationTextContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			$rtfeldman$elm_css$Css$padding(
			$rtfeldman$elm_css$Css$px(20)),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center)
		]),
	inputContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginBottom(
			$rtfeldman$elm_css$Css$px(20))
		]),
	linkContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(60)),
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(16))
		]),
	message: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			A3(
				$rtfeldman$elm_css$Css$calc,
				$rtfeldman$elm_css$Css$pct(100),
				$rtfeldman$elm_css$Css$minus,
				$rtfeldman$elm_css$Css$px(48))),
			$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$marginBottom(
			$rtfeldman$elm_css$Css$px(25))
		]),
	mobile: _List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Css$Media$withMediaQuery,
			_List_fromArray(
				['screen and (min-width: 1025px)']),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$none)
				]))
		]),
	personalRegister: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$backgroundColor($author$project$Material$Styled$Color$white),
			$rtfeldman$elm_css$Css$marginRight(
			$rtfeldman$elm_css$Css$px(150)),
			A2(
			$rtfeldman$elm_css$Css$Media$withMediaQuery,
			_List_fromArray(
				['screen and (max-width: 1390px)']),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$backgroundColor($author$project$Material$Styled$Color$white),
					$rtfeldman$elm_css$Css$marginRight(
					$rtfeldman$elm_css$Css$px(0))
				]))
		]),
	sideContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			$rtfeldman$elm_css$Css$flex(
			$rtfeldman$elm_css$Css$num(1)),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(800)),
			$rtfeldman$elm_css$Css$paddingTop(
			$rtfeldman$elm_css$Css$px(40))
		]),
	smallerText: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(20))
		]),
	termsError: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(11)),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$red900)
		]),
	textContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(11)),
			$rtfeldman$elm_css$Css$lineHeight(
			$rtfeldman$elm_css$Css$px(13)),
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(16)),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$blueGrey600)
		]),
	urlStyles: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$white),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(16))
		])
};
var $author$project$Page$PersonalRegister$list = A2(
	$rtfeldman$elm_css$Html$Styled$div,
	_List_Nil,
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Html$Styled$span,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$PersonalRegister$styles.boldText)
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text('With a Basic Account, you will be able to:')
				])),
			A2(
			$rtfeldman$elm_css$Html$Styled$ul,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$li,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('Send and receive unlimited documents')
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$li,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('Support for leading document formats')
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$ul,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$li,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('pdf, doc, xls and more')
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$li,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('Identity Verification capabilities')
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$li,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('Notarise documents [blockchain powered]')
						]))
				]))
		]));
var $author$project$Page$PersonalRegister$listInformation = A2(
	$rtfeldman$elm_css$Html$Styled$div,
	_List_fromArray(
		[
			$rtfeldman$elm_css$Html$Styled$Attributes$css(
			_Utils_ap($author$project$Page$PersonalRegister$styles.sideContainer, $author$project$Page$PersonalRegister$styles.informationContainer))
		]),
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Html$Styled$h1,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$PersonalRegister$styles.header)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('Digital Signing')
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$PersonalRegister$styles.smallerText)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('Easy, Safe & Free for Everyone')
						]))
				])),
			A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$PersonalRegister$styles.imageContainer)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$img,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$src($author$project$View$Theme$images.signerIdentity),
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$PersonalRegister$styles.imageStyles)
						]),
					_List_Nil),
					A2(
					$rtfeldman$elm_css$Html$Styled$img,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$src($author$project$View$Theme$images.clarityOfConsent),
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$PersonalRegister$styles.imageStyles)
						]),
					_List_Nil),
					A2(
					$rtfeldman$elm_css$Html$Styled$img,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$src($author$project$View$Theme$images.documentSecurity),
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$PersonalRegister$styles.imageStyles)
						]),
					_List_Nil)
				])),
			A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$PersonalRegister$styles.informationTextContainer)
				]),
			_List_fromArray(
				[
					$author$project$Page$PersonalRegister$list,
					A2(
					$author$project$Material$Styled$Divider$divider,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_Utils_ap($author$project$Page$PersonalRegister$styles.divider, $author$project$Page$PersonalRegister$styles.dividerMargin))
						]),
					_List_Nil),
					A2(
					$rtfeldman$elm_css$Html$Styled$h2,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$PersonalRegister$styles.smallerText)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('Using Sign.net for Your Business?')
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$PersonalRegister$styles.businessText)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('A Comprehensive '),
									A2(
									$author$project$Material$Styled$A$a,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$href('https://www.sign.net/pricing/')
										]),
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$span,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$PersonalRegister$styles.urlStyles)
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text('Suite of Features')
												]))
										])),
									$rtfeldman$elm_css$Html$Styled$text(' to automate your workflows at scale.'),
									A2($rtfeldman$elm_css$Html$Styled$br, _List_Nil, _List_Nil),
									$rtfeldman$elm_css$Html$Styled$text('Try it out with a '),
									A2(
									$author$project$Material$Styled$A$a,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$href('https://app.sign.net/register/business/')
										]),
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$span,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$PersonalRegister$styles.urlStyles)
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text('45-Day Free Trial')
												]))
										]))
								]))
						]))
				]))
		]));
var $author$project$Type$PersonalRegister$ReferralCode = {$: 'ReferralCode'};
var $author$project$Page$PersonalRegister$displayFormError = function (formStatus) {
	if (formStatus.$ === 'Error') {
		var error = formStatus.a;
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$PersonalRegister$styles.formError)
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text(
					A2($author$project$Data$Api$errorToString, $author$project$Data$Api$Register$Personal$errorToString, error))
				]));
	} else {
		return $rtfeldman$elm_css$Html$Styled$text('');
	}
};
var $author$project$Page$PersonalRegister$displayTermsError = function (maybeError) {
	if (maybeError.$ === 'Nothing') {
		return $rtfeldman$elm_css$Html$Styled$text('');
	} else {
		var message = maybeError.a;
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$PersonalRegister$styles.termsError)
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text(message)
				]));
	}
};
var $author$project$Page$PersonalRegister$isFieldDisabled = function (field) {
	if (field.$ === 'IsQueryParam') {
		return true;
	} else {
		return false;
	}
};
var $author$project$Page$PersonalRegister$submitButton = function (model) {
	var hasError = A2(
		$elm$core$List$any,
		$elm$core$Basics$neq($elm$core$Maybe$Nothing),
		_List_fromArray(
			[model.firstNameError, model.lastNameError, model.emailError, model.passwordError, model.passwordAgainError, model.hasAgreedTermsError]));
	var _v0 = model;
	var formStatus = _v0.formStatus;
	switch (formStatus.$) {
		case 'Ready':
			return hasError ? $author$project$View$SubmitButton$disabled('SIGN UP') : $author$project$View$SubmitButton$enabled('SIGN UP');
		case 'Error':
			var err = formStatus.a;
			if ((err.$ === 'Fail') && (err.a.$ === 'LIMIT_REACHED')) {
				var _v3 = err.a;
				return $author$project$View$SubmitButton$disabled('ACCOUNT LIMIT REACHED');
			} else {
				return $author$project$View$SubmitButton$enabled('SIGN UP');
			}
		default:
			return $author$project$View$SubmitButton$submitting('Registering Your Account...');
	}
};
var $author$project$Page$PersonalRegister$personalRegister = function (model) {
	var _v0 = model.registerModel;
	var formStatus = _v0.formStatus;
	var firstName = _v0.firstName;
	var firstNameError = _v0.firstNameError;
	var lastName = _v0.lastName;
	var lastNameError = _v0.lastNameError;
	var email = _v0.email;
	var emailError = _v0.emailError;
	var password = _v0.password;
	var passwordError = _v0.passwordError;
	var passwordAgain = _v0.passwordAgain;
	var passwordAgainError = _v0.passwordAgainError;
	var referralCode = _v0.referralCode;
	var hasAgreedTerms = _v0.hasAgreedTerms;
	var hasAgreedTermsError = _v0.hasAgreedTermsError;
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				_Utils_ap($author$project$Page$PersonalRegister$styles.sideContainer, $author$project$Page$PersonalRegister$styles.personalRegister))
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$h2,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$PersonalRegister$styles.heading)
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('Create Free Personal Account')
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$form,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Events$onSubmit(
						$author$project$Types$OnRegister($author$project$Type$PersonalRegister$OnSubmit)),
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$PersonalRegister$styles.form)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Material$Styled$Input$text,
						_List_fromArray(
							[
								$author$project$Material$Styled$Input$containerStyles($author$project$Page$PersonalRegister$styles.inputContainer),
								$author$project$Material$Styled$Input$label('First Name *'),
								$author$project$Material$Styled$Input$value(firstName),
								$author$project$Material$Styled$Input$errorMessage(firstNameError),
								$author$project$Material$Styled$Input$onInput(
								A2(
									$elm$core$Basics$composeL,
									$author$project$Types$OnRegister,
									$author$project$Type$PersonalRegister$OnInput($author$project$Type$PersonalRegister$FirstName))),
								$author$project$Material$Styled$Input$onBlur(
								$author$project$Types$OnRegister(
									$author$project$Type$PersonalRegister$OnBlur($author$project$Type$PersonalRegister$FirstName)))
							]),
						_List_Nil),
						A2(
						$author$project$Material$Styled$Input$text,
						_List_fromArray(
							[
								$author$project$Material$Styled$Input$containerStyles($author$project$Page$PersonalRegister$styles.inputContainer),
								$author$project$Material$Styled$Input$label('Last Name *'),
								$author$project$Material$Styled$Input$value(lastName),
								$author$project$Material$Styled$Input$errorMessage(lastNameError),
								$author$project$Material$Styled$Input$onInput(
								A2(
									$elm$core$Basics$composeL,
									$author$project$Types$OnRegister,
									$author$project$Type$PersonalRegister$OnInput($author$project$Type$PersonalRegister$LastName))),
								$author$project$Material$Styled$Input$onBlur(
								$author$project$Types$OnRegister(
									$author$project$Type$PersonalRegister$OnBlur($author$project$Type$PersonalRegister$LastName)))
							]),
						_List_Nil),
						A2(
						$author$project$Material$Styled$Input$email,
						_List_fromArray(
							[
								$author$project$Material$Styled$Input$containerStyles($author$project$Page$PersonalRegister$styles.inputContainer),
								$author$project$Material$Styled$Input$label('Email Address *'),
								$author$project$Material$Styled$Input$value(
								$author$project$Model$PersonalRegister$getQueryParamValue(email)),
								$author$project$Material$Styled$Input$errorMessage(emailError),
								$author$project$Material$Styled$Input$onInput(
								A2(
									$elm$core$Basics$composeL,
									$author$project$Types$OnRegister,
									$author$project$Type$PersonalRegister$OnInput($author$project$Type$PersonalRegister$Email))),
								$author$project$Material$Styled$Input$onBlur(
								$author$project$Types$OnRegister(
									$author$project$Type$PersonalRegister$OnBlur($author$project$Type$PersonalRegister$Email))),
								$author$project$Material$Styled$Input$disabled(
								$author$project$Page$PersonalRegister$isFieldDisabled(email))
							]),
						_List_Nil),
						A2(
						$author$project$Material$Styled$Input$password,
						_List_fromArray(
							[
								$author$project$Material$Styled$Input$containerStyles($author$project$Page$PersonalRegister$styles.inputContainer),
								$author$project$Material$Styled$Input$label('Password *'),
								$author$project$Material$Styled$Input$value(password),
								$author$project$Material$Styled$Input$infoMessage('Password must contain at least 8 characters, a lowercase letter,\nan uppercase letter and a number'),
								$author$project$Material$Styled$Input$errorMessage(passwordError),
								$author$project$Material$Styled$Input$onInput(
								A2(
									$elm$core$Basics$composeL,
									$author$project$Types$OnRegister,
									$author$project$Type$PersonalRegister$OnInput($author$project$Type$PersonalRegister$Password))),
								$author$project$Material$Styled$Input$onBlur(
								$author$project$Types$OnRegister(
									$author$project$Type$PersonalRegister$OnBlur($author$project$Type$PersonalRegister$Password)))
							]),
						_List_Nil),
						A2(
						$author$project$Material$Styled$Input$password,
						_List_fromArray(
							[
								$author$project$Material$Styled$Input$containerStyles($author$project$Page$PersonalRegister$styles.inputContainer),
								$author$project$Material$Styled$Input$label('Confirm Password *'),
								$author$project$Material$Styled$Input$value(passwordAgain),
								$author$project$Material$Styled$Input$errorMessage(passwordAgainError),
								$author$project$Material$Styled$Input$onInput(
								A2(
									$elm$core$Basics$composeL,
									$author$project$Types$OnRegister,
									$author$project$Type$PersonalRegister$OnInput($author$project$Type$PersonalRegister$PasswordAgain))),
								$author$project$Material$Styled$Input$onBlur(
								$author$project$Types$OnRegister(
									$author$project$Type$PersonalRegister$OnBlur($author$project$Type$PersonalRegister$PasswordAgain)))
							]),
						_List_Nil),
						A2(
						$author$project$Material$Styled$Input$text,
						_List_fromArray(
							[
								$author$project$Material$Styled$Input$containerStyles($author$project$Page$PersonalRegister$styles.inputContainer),
								$author$project$Material$Styled$Input$label('Referral Code (Optional)'),
								$author$project$Material$Styled$Input$value(
								$author$project$Model$PersonalRegister$getQueryParamValue(referralCode)),
								$author$project$Material$Styled$Input$onInput(
								A2(
									$elm$core$Basics$composeL,
									$author$project$Types$OnRegister,
									$author$project$Type$PersonalRegister$OnInput($author$project$Type$PersonalRegister$ReferralCode))),
								$author$project$Material$Styled$Input$onBlur(
								$author$project$Types$OnRegister(
									$author$project$Type$PersonalRegister$OnBlur($author$project$Type$PersonalRegister$ReferralCode))),
								$author$project$Material$Styled$Input$disabled(
								$author$project$Page$PersonalRegister$isFieldDisabled(referralCode))
							]),
						_List_Nil),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$PersonalRegister$styles.checkboxContainer)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Material$Styled$Checkbox$checkbox,
								_List_fromArray(
									[
										$author$project$Material$Styled$Checkbox$onClick(
										$author$project$Types$OnRegister($author$project$Type$PersonalRegister$OnAgreeTerms)),
										$author$project$Material$Styled$Checkbox$checked(hasAgreedTerms)
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('I agree to the terms of service and privacy policy published '),
										A2(
										$author$project$Material$Styled$A$a,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$href('https://www.sign.net/legal/')
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('here')
											])),
										$rtfeldman$elm_css$Html$Styled$text('.'),
										$author$project$Page$PersonalRegister$displayTermsError(hasAgreedTermsError)
									]))
							])),
						$author$project$Page$PersonalRegister$displayFormError(formStatus),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$PersonalRegister$styles.buttonContainer)
							]),
						_List_fromArray(
							[
								$author$project$Page$PersonalRegister$submitButton(model.registerModel)
							]))
					])),
				A2(
				$author$project$Material$Styled$Divider$divider,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$PersonalRegister$styles.divider)
					]),
				_List_Nil),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$PersonalRegister$styles.linkContainer)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Material$Styled$A$a,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$href($author$project$Data$Route$routeUrl.login)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('Return to login')
							]))
					]))
			]));
};
var $author$project$Page$Register$Personal$PersonalRegisterMobile$styles = {
	boldText: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontWeight(
			$rtfeldman$elm_css$Css$int(1000)),
			$rtfeldman$elm_css$Css$paddingBottom(
			$rtfeldman$elm_css$Css$px(50))
		]),
	buttonContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100)),
			A2(
			$rtfeldman$elm_css$Css$margin2,
			$rtfeldman$elm_css$Css$px(16),
			$rtfeldman$elm_css$Css$zero)
		]),
	checkboxContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(8)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100)),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(14)),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$blueGrey600)
		]),
	container: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100)),
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column)
		]),
	divider: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			A3(
				$rtfeldman$elm_css$Css$calc,
				$rtfeldman$elm_css$Css$pct(100),
				$rtfeldman$elm_css$Css$minus,
				$rtfeldman$elm_css$Css$px(48)))
		]),
	form: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			A3(
				$rtfeldman$elm_css$Css$calc,
				$rtfeldman$elm_css$Css$pct(100),
				$rtfeldman$elm_css$Css$minus,
				$rtfeldman$elm_css$Css$px(48))),
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(60))
		]),
	formError: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(16)),
			$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(14)),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$red900)
		]),
	header: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center)
		]),
	heading: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(24)),
			$rtfeldman$elm_css$Css$color(
			$rtfeldman$elm_css$Css$hex('0040ab')),
			$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$paddingTop(
			$rtfeldman$elm_css$Css$px(4)),
			A2(
			$rtfeldman$elm_css$Css$Media$withMediaQuery,
			_List_fromArray(
				['screen and (max-width: 375px)']),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$width(
					$rtfeldman$elm_css$Css$pct(80))
				]))
		]),
	imageContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$row),
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
			A2(
			$rtfeldman$elm_css$Css$Media$withMediaQuery,
			_List_fromArray(
				['screen and (max-width: 490px)']),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$none)
				]))
		]),
	imageStyles: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(140)),
			$rtfeldman$elm_css$Css$margin(
			$rtfeldman$elm_css$Css$px(15))
		]),
	informationContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$backgroundColor(
			$rtfeldman$elm_css$Css$hex('#0040ab')),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$white),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100)),
			$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center)
		]),
	inputContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginBottom(
			$rtfeldman$elm_css$Css$px(20))
		]),
	linkContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(60)),
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(16))
		]),
	listStyles: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginLeft(
			$rtfeldman$elm_css$Css$px(-23))
		]),
	message: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			A3(
				$rtfeldman$elm_css$Css$calc,
				$rtfeldman$elm_css$Css$pct(100),
				$rtfeldman$elm_css$Css$minus,
				$rtfeldman$elm_css$Css$px(48))),
			$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$marginBottom(
			$rtfeldman$elm_css$Css$px(25))
		]),
	mobile: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$start),
			A2(
			$rtfeldman$elm_css$Css$Media$withMediaQuery,
			_List_fromArray(
				['screen and (min-width: 490px)']),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$none)
				]))
		]),
	personalRegister: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$backgroundColor($author$project$Material$Styled$Color$white),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100))
		]),
	sideContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			$rtfeldman$elm_css$Css$flex(
			$rtfeldman$elm_css$Css$num(1)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(600)),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(800)),
			$rtfeldman$elm_css$Css$paddingTop(
			$rtfeldman$elm_css$Css$px(40)),
			$rtfeldman$elm_css$Css$paddingBottom(
			$rtfeldman$elm_css$Css$px(20))
		]),
	smallerText: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(24))
		]),
	termsError: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(11)),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$red900)
		]),
	textContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(11)),
			$rtfeldman$elm_css$Css$lineHeight(
			$rtfeldman$elm_css$Css$px(13)),
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(16)),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$blueGrey600)
		])
};
var $author$project$Page$Register$Personal$PersonalRegisterMobile$list = A2(
	$rtfeldman$elm_css$Html$Styled$div,
	_List_fromArray(
		[
			$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Register$Personal$PersonalRegisterMobile$styles.mobile)
		]),
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Html$Styled$span,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Register$Personal$PersonalRegisterMobile$styles.boldText)
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text('Key Features:')
				])),
			A2(
			$rtfeldman$elm_css$Html$Styled$ul,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Register$Personal$PersonalRegisterMobile$styles.listStyles)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$li,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('Signer Identity')
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$li,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('Clarity of Consent')
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$li,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('Document Security')
						]))
				]))
		]));
var $author$project$Page$Register$Personal$PersonalRegisterMobile$listInformation = A2(
	$rtfeldman$elm_css$Html$Styled$div,
	_List_fromArray(
		[
			$rtfeldman$elm_css$Html$Styled$Attributes$css(
			_Utils_ap($author$project$Page$Register$Personal$PersonalRegisterMobile$styles.sideContainer, $author$project$Page$Register$Personal$PersonalRegisterMobile$styles.informationContainer))
		]),
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Html$Styled$h1,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Register$Personal$PersonalRegisterMobile$styles.header)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('Digital Signing')
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Register$Personal$PersonalRegisterMobile$styles.smallerText)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('Easy, Safe & Free for Everyone')
						]))
				])),
			A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Register$Personal$PersonalRegisterMobile$styles.imageContainer)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$img,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$src($author$project$View$Theme$images.signerIdentity),
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Register$Personal$PersonalRegisterMobile$styles.imageStyles)
						]),
					_List_Nil),
					A2(
					$rtfeldman$elm_css$Html$Styled$img,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$src($author$project$View$Theme$images.clarityOfConsent),
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Register$Personal$PersonalRegisterMobile$styles.imageStyles)
						]),
					_List_Nil),
					A2(
					$rtfeldman$elm_css$Html$Styled$img,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$src($author$project$View$Theme$images.documentSecurity),
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Register$Personal$PersonalRegisterMobile$styles.imageStyles)
						]),
					_List_Nil)
				])),
			$author$project$Page$Register$Personal$PersonalRegisterMobile$list
		]));
var $author$project$Page$Register$Personal$PersonalRegisterMobile$displayFormError = function (formStatus) {
	if (formStatus.$ === 'Error') {
		var error = formStatus.a;
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Register$Personal$PersonalRegisterMobile$styles.formError)
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text(
					A2($author$project$Data$Api$errorToString, $author$project$Data$Api$Register$Personal$errorToString, error))
				]));
	} else {
		return $rtfeldman$elm_css$Html$Styled$text('');
	}
};
var $author$project$Page$Register$Personal$PersonalRegisterMobile$displayTermsError = function (maybeError) {
	if (maybeError.$ === 'Nothing') {
		return $rtfeldman$elm_css$Html$Styled$text('');
	} else {
		var message = maybeError.a;
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Register$Personal$PersonalRegisterMobile$styles.termsError)
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text(message)
				]));
	}
};
var $author$project$Page$Register$Personal$PersonalRegisterMobile$isFieldDisabled = function (field) {
	if (field.$ === 'IsQueryParam') {
		return true;
	} else {
		return false;
	}
};
var $author$project$Page$Register$Personal$PersonalRegisterMobile$submitButton = function (model) {
	var hasError = A2(
		$elm$core$List$any,
		$elm$core$Basics$neq($elm$core$Maybe$Nothing),
		_List_fromArray(
			[model.firstNameError, model.lastNameError, model.emailError, model.passwordError, model.passwordAgainError, model.hasAgreedTermsError]));
	var _v0 = model;
	var formStatus = _v0.formStatus;
	switch (formStatus.$) {
		case 'Ready':
			return hasError ? $author$project$View$SubmitButton$disabled('SIGN UP') : $author$project$View$SubmitButton$enabled('SIGN UP');
		case 'Error':
			var err = formStatus.a;
			if ((err.$ === 'Fail') && (err.a.$ === 'LIMIT_REACHED')) {
				var _v3 = err.a;
				return $author$project$View$SubmitButton$disabled('ACCOUNT LIMIT REACHED');
			} else {
				return $author$project$View$SubmitButton$enabled('SIGN UP');
			}
		default:
			return $author$project$View$SubmitButton$submitting('Registering Your Account...');
	}
};
var $author$project$Page$Register$Personal$PersonalRegisterMobile$personalRegister = function (model) {
	var _v0 = model.registerModel;
	var formStatus = _v0.formStatus;
	var firstName = _v0.firstName;
	var firstNameError = _v0.firstNameError;
	var lastName = _v0.lastName;
	var lastNameError = _v0.lastNameError;
	var email = _v0.email;
	var emailError = _v0.emailError;
	var password = _v0.password;
	var passwordError = _v0.passwordError;
	var passwordAgain = _v0.passwordAgain;
	var passwordAgainError = _v0.passwordAgainError;
	var referralCode = _v0.referralCode;
	var hasAgreedTerms = _v0.hasAgreedTerms;
	var hasAgreedTermsError = _v0.hasAgreedTermsError;
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				_Utils_ap($author$project$Page$Register$Personal$PersonalRegisterMobile$styles.sideContainer, $author$project$Page$Register$Personal$PersonalRegisterMobile$styles.personalRegister))
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$h2,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Register$Personal$PersonalRegisterMobile$styles.heading)
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('Create Free Personal Account')
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$form,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Events$onSubmit(
						$author$project$Types$OnRegister($author$project$Type$PersonalRegister$OnSubmit)),
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Register$Personal$PersonalRegisterMobile$styles.form)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Material$Styled$Input$text,
						_List_fromArray(
							[
								$author$project$Material$Styled$Input$containerStyles($author$project$Page$Register$Personal$PersonalRegisterMobile$styles.inputContainer),
								$author$project$Material$Styled$Input$label('First Name *'),
								$author$project$Material$Styled$Input$value(firstName),
								$author$project$Material$Styled$Input$errorMessage(firstNameError),
								$author$project$Material$Styled$Input$onInput(
								A2(
									$elm$core$Basics$composeL,
									$author$project$Types$OnRegister,
									$author$project$Type$PersonalRegister$OnInput($author$project$Type$PersonalRegister$FirstName))),
								$author$project$Material$Styled$Input$onBlur(
								$author$project$Types$OnRegister(
									$author$project$Type$PersonalRegister$OnBlur($author$project$Type$PersonalRegister$FirstName)))
							]),
						_List_Nil),
						A2(
						$author$project$Material$Styled$Input$text,
						_List_fromArray(
							[
								$author$project$Material$Styled$Input$containerStyles($author$project$Page$Register$Personal$PersonalRegisterMobile$styles.inputContainer),
								$author$project$Material$Styled$Input$label('Last Name *'),
								$author$project$Material$Styled$Input$value(lastName),
								$author$project$Material$Styled$Input$errorMessage(lastNameError),
								$author$project$Material$Styled$Input$onInput(
								A2(
									$elm$core$Basics$composeL,
									$author$project$Types$OnRegister,
									$author$project$Type$PersonalRegister$OnInput($author$project$Type$PersonalRegister$LastName))),
								$author$project$Material$Styled$Input$onBlur(
								$author$project$Types$OnRegister(
									$author$project$Type$PersonalRegister$OnBlur($author$project$Type$PersonalRegister$LastName)))
							]),
						_List_Nil),
						A2(
						$author$project$Material$Styled$Input$email,
						_List_fromArray(
							[
								$author$project$Material$Styled$Input$containerStyles($author$project$Page$Register$Personal$PersonalRegisterMobile$styles.inputContainer),
								$author$project$Material$Styled$Input$label('Email Address *'),
								$author$project$Material$Styled$Input$value(
								$author$project$Model$PersonalRegister$getQueryParamValue(email)),
								$author$project$Material$Styled$Input$errorMessage(emailError),
								$author$project$Material$Styled$Input$onInput(
								A2(
									$elm$core$Basics$composeL,
									$author$project$Types$OnRegister,
									$author$project$Type$PersonalRegister$OnInput($author$project$Type$PersonalRegister$Email))),
								$author$project$Material$Styled$Input$onBlur(
								$author$project$Types$OnRegister(
									$author$project$Type$PersonalRegister$OnBlur($author$project$Type$PersonalRegister$Email))),
								$author$project$Material$Styled$Input$disabled(
								$author$project$Page$Register$Personal$PersonalRegisterMobile$isFieldDisabled(email))
							]),
						_List_Nil),
						A2(
						$author$project$Material$Styled$Input$password,
						_List_fromArray(
							[
								$author$project$Material$Styled$Input$containerStyles($author$project$Page$Register$Personal$PersonalRegisterMobile$styles.inputContainer),
								$author$project$Material$Styled$Input$label('Password *'),
								$author$project$Material$Styled$Input$value(password),
								$author$project$Material$Styled$Input$infoMessage('Password must contain at least 8 characters, a lowercase letter,\nan uppercase letter and a number'),
								$author$project$Material$Styled$Input$errorMessage(passwordError),
								$author$project$Material$Styled$Input$onInput(
								A2(
									$elm$core$Basics$composeL,
									$author$project$Types$OnRegister,
									$author$project$Type$PersonalRegister$OnInput($author$project$Type$PersonalRegister$Password))),
								$author$project$Material$Styled$Input$onBlur(
								$author$project$Types$OnRegister(
									$author$project$Type$PersonalRegister$OnBlur($author$project$Type$PersonalRegister$Password)))
							]),
						_List_Nil),
						A2(
						$author$project$Material$Styled$Input$password,
						_List_fromArray(
							[
								$author$project$Material$Styled$Input$containerStyles($author$project$Page$Register$Personal$PersonalRegisterMobile$styles.inputContainer),
								$author$project$Material$Styled$Input$label('Confirm Password *'),
								$author$project$Material$Styled$Input$value(passwordAgain),
								$author$project$Material$Styled$Input$errorMessage(passwordAgainError),
								$author$project$Material$Styled$Input$onInput(
								A2(
									$elm$core$Basics$composeL,
									$author$project$Types$OnRegister,
									$author$project$Type$PersonalRegister$OnInput($author$project$Type$PersonalRegister$PasswordAgain))),
								$author$project$Material$Styled$Input$onBlur(
								$author$project$Types$OnRegister(
									$author$project$Type$PersonalRegister$OnBlur($author$project$Type$PersonalRegister$PasswordAgain)))
							]),
						_List_Nil),
						A2(
						$author$project$Material$Styled$Input$text,
						_List_fromArray(
							[
								$author$project$Material$Styled$Input$containerStyles($author$project$Page$Register$Personal$PersonalRegisterMobile$styles.inputContainer),
								$author$project$Material$Styled$Input$label('Referral Code (Optional)'),
								$author$project$Material$Styled$Input$value(
								$author$project$Model$PersonalRegister$getQueryParamValue(referralCode)),
								$author$project$Material$Styled$Input$onInput(
								A2(
									$elm$core$Basics$composeL,
									$author$project$Types$OnRegister,
									$author$project$Type$PersonalRegister$OnInput($author$project$Type$PersonalRegister$ReferralCode))),
								$author$project$Material$Styled$Input$onBlur(
								$author$project$Types$OnRegister(
									$author$project$Type$PersonalRegister$OnBlur($author$project$Type$PersonalRegister$ReferralCode))),
								$author$project$Material$Styled$Input$disabled(
								$author$project$Page$Register$Personal$PersonalRegisterMobile$isFieldDisabled(referralCode))
							]),
						_List_Nil),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Register$Personal$PersonalRegisterMobile$styles.checkboxContainer)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Material$Styled$Checkbox$checkbox,
								_List_fromArray(
									[
										$author$project$Material$Styled$Checkbox$onClick(
										$author$project$Types$OnRegister($author$project$Type$PersonalRegister$OnAgreeTerms)),
										$author$project$Material$Styled$Checkbox$checked(hasAgreedTerms)
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('I agree to the terms of service and privacy policy published '),
										A2(
										$author$project$Material$Styled$A$a,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$href('https://www.sign.net/legal/')
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('here')
											])),
										$rtfeldman$elm_css$Html$Styled$text('.'),
										$author$project$Page$Register$Personal$PersonalRegisterMobile$displayTermsError(hasAgreedTermsError)
									]))
							])),
						$author$project$Page$Register$Personal$PersonalRegisterMobile$displayFormError(formStatus),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Register$Personal$PersonalRegisterMobile$styles.buttonContainer)
							]),
						_List_fromArray(
							[
								$author$project$Page$Register$Personal$PersonalRegisterMobile$submitButton(model.registerModel)
							]))
					])),
				A2(
				$author$project$Material$Styled$Divider$divider,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Register$Personal$PersonalRegisterMobile$styles.divider)
					]),
				_List_Nil),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Register$Personal$PersonalRegisterMobile$styles.linkContainer)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Material$Styled$A$a,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$href($author$project$Data$Route$routeUrl.login)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('Return to login')
							]))
					]))
			]));
};
var $author$project$Page$Register$Personal$PersonalRegisterMobile$view = function (model) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Register$Personal$PersonalRegisterMobile$styles.container)
			]),
		_List_fromArray(
			[
				$author$project$Page$Register$Personal$PersonalRegisterMobile$listInformation,
				$author$project$Page$Register$Personal$PersonalRegisterMobile$personalRegister(model)
			]));
};
var $author$project$Page$PersonalRegister$view = function (model) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$PersonalRegister$styles.desktop)
					]),
				_List_fromArray(
					[
						$author$project$Page$PersonalRegister$listInformation,
						$author$project$Page$PersonalRegister$personalRegister(model)
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$PersonalRegister$styles.mobile)
					]),
				_List_fromArray(
					[
						$author$project$Page$Register$Personal$PersonalRegisterMobile$view(model)
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$id('affilate')
					]),
				_List_Nil)
			]));
};
var $author$project$Type$PointTransaction$OnRefresh = {$: 'OnRefresh'};
var $author$project$Material$Styled$Color$blue500String = '#2196f3';
var $author$project$Material$Styled$Color$blue500 = $rtfeldman$elm_css$Css$hex($author$project$Material$Styled$Color$blue500String);
var $author$project$Material$Styled$Color$orange100String = '#FFE0B2';
var $author$project$Material$Styled$Color$orange100 = $rtfeldman$elm_css$Css$hex($author$project$Material$Styled$Color$orange100String);
var $author$project$Material$Styled$Color$orange500String = '#FF9800';
var $author$project$Material$Styled$Color$orange500 = $rtfeldman$elm_css$Css$hex($author$project$Material$Styled$Color$orange500String);
var $author$project$Material$Styled$Color$purple100String = '#e1bee7';
var $author$project$Material$Styled$Color$purple100 = $rtfeldman$elm_css$Css$hex($author$project$Material$Styled$Color$purple100String);
var $author$project$Material$Styled$Color$purple500String = '#9c27b0';
var $author$project$Material$Styled$Color$purple500 = $rtfeldman$elm_css$Css$hex($author$project$Material$Styled$Color$purple500String);
var $author$project$Page$PointTransaction$styles = {
	adminTag: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$backgroundColor($author$project$Material$Styled$Color$purple100),
			$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center),
			A2(
			$rtfeldman$elm_css$Css$padding2,
			$rtfeldman$elm_css$Css$px(4),
			$rtfeldman$elm_css$Css$px(8)),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$purple500),
			$rtfeldman$elm_css$Css$borderRadius(
			$rtfeldman$elm_css$Css$px(5))
		]),
	button: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$maxWidth(
			$rtfeldman$elm_css$Css$px(300)),
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(20))
		]),
	card: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(20)),
			A4(
			$rtfeldman$elm_css$Css$padding4,
			$rtfeldman$elm_css$Css$px(30),
			$rtfeldman$elm_css$Css$px(50),
			$rtfeldman$elm_css$Css$px(50),
			$rtfeldman$elm_css$Css$px(50))
		]),
	container: _List_fromArray(
		[
			A3(
			$rtfeldman$elm_css$Css$margin3,
			$rtfeldman$elm_css$Css$px(10),
			$rtfeldman$elm_css$Css$px(30),
			$rtfeldman$elm_css$Css$zero)
		]),
	dataText: _List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Css$Media$withMediaQuery,
			_List_fromArray(
				['screen and (max-width: 600px)']),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$width(
					$rtfeldman$elm_css$Css$px(150)),
					$rtfeldman$elm_css$Css$overflowWrap($rtfeldman$elm_css$Css$breakWord)
				]))
		]),
	divider: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100)),
			$rtfeldman$elm_css$Css$backgroundColor($author$project$Material$Styled$Color$grey300)
		]),
	error: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center)
		]),
	headerText: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$blueGrey600),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(120))
		]),
	systemTag: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$backgroundColor($author$project$Material$Styled$Color$blue100),
			$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center),
			A2(
			$rtfeldman$elm_css$Css$padding2,
			$rtfeldman$elm_css$Css$px(4),
			$rtfeldman$elm_css$Css$px(8)),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$blue500),
			$rtfeldman$elm_css$Css$borderRadius(
			$rtfeldman$elm_css$Css$px(5))
		]),
	transactionRow: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$row),
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(20))
		]),
	userTag: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$backgroundColor($author$project$Material$Styled$Color$orange100),
			$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center),
			A2(
			$rtfeldman$elm_css$Css$padding2,
			$rtfeldman$elm_css$Css$px(4),
			$rtfeldman$elm_css$Css$px(8)),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$orange500),
			$rtfeldman$elm_css$Css$borderRadius(
			$rtfeldman$elm_css$Css$px(5))
		])
};
var $author$project$Page$PointTransaction$errorDisplay = A2(
	$rtfeldman$elm_css$Html$Styled$div,
	_List_fromArray(
		[
			$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$PointTransaction$styles.error)
		]),
	_List_fromArray(
		[
			$rtfeldman$elm_css$Html$Styled$text('An error has occured while retrieving your transaction details. Please refresh the page.'),
			A2(
			$author$project$Material$Styled$Button$button,
			_List_fromArray(
				[
					$author$project$Material$Styled$Button$styles($author$project$Page$PointTransaction$styles.button),
					$author$project$Material$Styled$Button$onClick(
					$author$project$Types$OnAuth(
						$author$project$Types$OnPointTransaction($author$project$Type$PointTransaction$OnRefresh)))
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text('Refresh Page')
				]))
		]));
var $author$project$Page$PointsTransactions$TableElements$timeFormatter = $ryannhg$date_format$DateFormat$format(
	_List_fromArray(
		[
			$ryannhg$date_format$DateFormat$hourFixed,
			$ryannhg$date_format$DateFormat$text(':'),
			$ryannhg$date_format$DateFormat$minuteFixed,
			$ryannhg$date_format$DateFormat$text(' '),
			$ryannhg$date_format$DateFormat$amPmLowercase
		]));
var $author$project$Page$PointTransaction$dateTimeFormatter = F2(
	function (date, model) {
		return A2($author$project$Page$PointsTransactions$TableElements$dateFormatter, model.timezone, date) + (' ' + A2($author$project$Page$PointsTransactions$TableElements$timeFormatter, model.timezone, date));
	});
var $author$project$Material$Styled$Color$blueGrey100String = '#CFD8DC';
var $author$project$Material$Styled$Color$blueGrey100 = $rtfeldman$elm_css$Css$hex($author$project$Material$Styled$Color$blueGrey100String);
var $author$project$Material$Styled$Color$green100String = '#C8E6C9';
var $author$project$Material$Styled$Color$green100 = $rtfeldman$elm_css$Css$hex($author$project$Material$Styled$Color$green100String);
var $author$project$Material$Styled$Color$green500String = '#4CAF50';
var $author$project$Material$Styled$Color$green500 = $rtfeldman$elm_css$Css$hex($author$project$Material$Styled$Color$green500String);
var $author$project$Material$Styled$Color$red100String = '#ffcdd2';
var $author$project$Material$Styled$Color$red100 = $rtfeldman$elm_css$Css$hex($author$project$Material$Styled$Color$red100String);
var $author$project$Page$PointsTransactions$TableElements$styles = {
	completedTag: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$backgroundColor($author$project$Material$Styled$Color$green100),
			$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center),
			A2(
			$rtfeldman$elm_css$Css$padding2,
			$rtfeldman$elm_css$Css$px(4),
			$rtfeldman$elm_css$Css$px(8)),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$green500),
			$rtfeldman$elm_css$Css$borderRadius(
			$rtfeldman$elm_css$Css$px(5))
		]),
	expiredTag: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$backgroundColor($author$project$Material$Styled$Color$red100),
			$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center),
			A2(
			$rtfeldman$elm_css$Css$padding2,
			$rtfeldman$elm_css$Css$px(4),
			$rtfeldman$elm_css$Css$px(8)),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$red500),
			$rtfeldman$elm_css$Css$borderRadius(
			$rtfeldman$elm_css$Css$px(5))
		]),
	inTag: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$backgroundColor($author$project$Material$Styled$Color$green100),
			A2(
			$rtfeldman$elm_css$Css$padding2,
			$rtfeldman$elm_css$Css$px(4),
			$rtfeldman$elm_css$Css$px(8)),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$green500),
			$rtfeldman$elm_css$Css$borderRadius(
			$rtfeldman$elm_css$Css$px(5))
		]),
	marginBottom10: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginBottom(
			$rtfeldman$elm_css$Css$px(10))
		]),
	mobileTableColumn: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(60))
		]),
	mobileTableRow: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$row),
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceBetween),
			$rtfeldman$elm_css$Css$padding(
			$rtfeldman$elm_css$Css$px(10)),
			A3(
			$rtfeldman$elm_css$Css$borderBottom3,
			$rtfeldman$elm_css$Css$px(0.5),
			$rtfeldman$elm_css$Css$solid,
			$author$project$Material$Styled$Color$blueGrey100),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center)
		]),
	outTag: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$backgroundColor($author$project$Material$Styled$Color$red100),
			A2(
			$rtfeldman$elm_css$Css$padding2,
			$rtfeldman$elm_css$Css$px(4),
			$rtfeldman$elm_css$Css$px(8)),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$red500),
			$rtfeldman$elm_css$Css$borderRadius(
			$rtfeldman$elm_css$Css$px(5))
		]),
	pendingTag: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$backgroundColor($author$project$Material$Styled$Color$orange100),
			$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center),
			A2(
			$rtfeldman$elm_css$Css$padding2,
			$rtfeldman$elm_css$Css$px(4),
			$rtfeldman$elm_css$Css$px(8)),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$orange500),
			$rtfeldman$elm_css$Css$borderRadius(
			$rtfeldman$elm_css$Css$px(5))
		]),
	width20Pct: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(20))
		])
};
var $author$project$Page$PointsTransactions$TableElements$statusTags = function (status) {
	switch (status.$) {
		case 'Completed':
			return A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$PointsTransactions$TableElements$styles.completedTag)
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('COMPLETED')
					]));
		case 'Pending':
			return A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$PointsTransactions$TableElements$styles.pendingTag)
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('PENDING')
					]));
		case 'Expired':
			return A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$PointsTransactions$TableElements$styles.expiredTag)
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('EXPIRED')
					]));
		case 'Processing':
			return A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$PointsTransactions$TableElements$styles.pendingTag)
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('PROCESSING')
					]));
		default:
			return A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$PointsTransactions$TableElements$styles.expiredTag)
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('DECLINED')
					]));
	}
};
var $author$project$Type$PointTransactionTable$transactionTypeToText = function (transactionType) {
	switch (transactionType.$) {
		case 'User':
			return 'USER';
		case 'System':
			return 'SYSTEM';
		default:
			return 'ADMIN';
	}
};
var $author$project$Page$PointTransaction$tag = function (transactionType) {
	var tagStyles = function () {
		switch (transactionType.$) {
			case 'User':
				return $author$project$Page$PointTransaction$styles.userTag;
			case 'System':
				return $author$project$Page$PointTransaction$styles.systemTag;
			default:
				return $author$project$Page$PointTransaction$styles.adminTag;
		}
	}();
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(tagStyles)
			]),
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$text(
				$author$project$Type$PointTransactionTable$transactionTypeToText(transactionType))
			]));
};
var $author$project$Page$PointTransaction$transactionDisplay = F2(
	function (transaction, model) {
		var zoneName = function () {
			var _v12 = model.timezoneName;
			if (_v12.$ === 'Just') {
				var zoneName_ = _v12.a;
				if (zoneName_.$ === 'Name') {
					var name = zoneName_.a;
					return name;
				} else {
					var offset = zoneName_.a;
					return 'UTC ' + ($elm$core$String$fromInt((offset / 60) | 0) + '00');
				}
			} else {
				return 'No zoneName';
			}
		}();
		var transactionDetailsLanguageData = model.languageSwitchModel.allLanguageData.location.transactionDetailsPage;
		var pointsTransactionDetailsLanguageData = model.languageSwitchModel.allLanguageData.location.pointsManagement;
		var formattedString = function (name) {
			return ((name === 'System') || (name === 'Admin')) ? $elm$core$String$toUpper(name) : name;
		};
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$PointTransaction$styles.transactionRow)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$PointTransaction$styles.headerText)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(transactionDetailsLanguageData.transactionId)
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$PointTransaction$styles.dataText)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(transaction.id)
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$PointTransaction$styles.transactionRow)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$PointTransaction$styles.headerText)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(pointsTransactionDetailsLanguageData.from)
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$PointTransaction$styles.dataText)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									formattedString(transaction.from))
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$PointTransaction$styles.transactionRow)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$PointTransaction$styles.headerText)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(pointsTransactionDetailsLanguageData.to)
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$PointTransaction$styles.dataText)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									formattedString(transaction.to))
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$PointTransaction$styles.transactionRow)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$PointTransaction$styles.headerText)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(pointsTransactionDetailsLanguageData.amount)
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$PointTransaction$styles.dataText)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$elm$core$String$fromFloat(transaction.amount / 100))
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$PointTransaction$styles.transactionRow)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$PointTransaction$styles.headerText)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(transactionDetailsLanguageData.created)
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$PointTransaction$styles.dataText)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									A2($author$project$Page$PointTransaction$dateTimeFormatter, transaction.createdAt, model) + (' (' + (zoneName + ')')))
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$PointTransaction$styles.transactionRow)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$PointTransaction$styles.headerText)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(transactionDetailsLanguageData.approved)
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$PointTransaction$styles.dataText)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									function () {
										var _v0 = _Utils_Tuple2(transaction.confirmAt, transaction.status);
										switch (_v0.b.$) {
											case 'Expired':
												var _v4 = _v0.b;
												return 'Transaction Expired';
											case 'Declined':
												var _v5 = _v0.b;
												return 'Transaction Declined';
											case 'Processing':
												if (_v0.a.$ === 'Nothing') {
													var _v6 = _v0.a;
													var _v7 = _v0.b;
													return 'Processing Transaction';
												} else {
													var _v8 = _v0.b;
													return '';
												}
											case 'Pending':
												if (_v0.a.$ === 'Nothing') {
													var _v2 = _v0.a;
													var _v3 = _v0.b;
													return 'Pending Approval';
												} else {
													var _v9 = _v0.b;
													return '';
												}
											default:
												if (_v0.a.$ === 'Just') {
													var confirmAt = _v0.a.a;
													var _v1 = _v0.b;
													return A2($author$project$Page$PointTransaction$dateTimeFormatter, confirmAt, model) + (' (' + (zoneName + ')'));
												} else {
													var _v10 = _v0.a;
													var _v11 = _v0.b;
													return '';
												}
										}
									}())
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$PointTransaction$styles.transactionRow)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$PointTransaction$styles.headerText)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(transactionDetailsLanguageData.by)
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$PointTransaction$styles.dataText)
								]),
							_List_fromArray(
								[
									$author$project$Page$PointTransaction$tag(transaction.transaction)
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$PointTransaction$styles.transactionRow)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$PointTransaction$styles.headerText)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(pointsTransactionDetailsLanguageData.status)
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$PointTransaction$styles.dataText)
								]),
							_List_fromArray(
								[
									$author$project$Page$PointsTransactions$TableElements$statusTags(transaction.status)
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$PointTransaction$styles.transactionRow)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$PointTransaction$styles.headerText)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(transactionDetailsLanguageData.ipAddress)
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$PointTransaction$styles.dataText)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(transaction.ipAddr)
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$PointTransaction$styles.transactionRow)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$PointTransaction$styles.headerText)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(transactionDetailsLanguageData.remarks)
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$PointTransaction$styles.dataText)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									A2($elm$core$Maybe$withDefault, 'No Remarks', transaction.remarks))
								]))
						]))
				]));
	});
var $author$project$Page$PointTransaction$view = F2(
	function (authModel, model) {
		var transactionDetailsLanguageData = model.languageSwitchModel.allLanguageData.location.transactionDetailsPage;
		var _v0 = authModel;
		var transactionModel = _v0.transactionModel;
		var languageChangeModel = _v0.languageChangeModel;
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$PointTransaction$styles.container)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$h1,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(transactionDetailsLanguageData.transactionDetails)
								]))
						])),
					A2(
					$author$project$Material$Styled$Divider$divider,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$PointTransaction$styles.divider)
						]),
					_List_Nil),
					A2(
					$author$project$Material$Styled$Card$card,
					_List_fromArray(
						[
							$author$project$Material$Styled$Card$containerStyles($author$project$Page$PointTransaction$styles.card)
						]),
					_List_fromArray(
						[
							function () {
							var _v1 = _Utils_Tuple2(transactionModel.transaction, transactionModel.error);
							if (_v1.b) {
								return $author$project$Page$PointTransaction$errorDisplay;
							} else {
								if (_v1.a.$ === 'Just') {
									var transaction = _v1.a.a;
									return A2($author$project$Page$PointTransaction$transactionDisplay, transaction, model);
								} else {
									var _v2 = _v1.a;
									return A2(
										$rtfeldman$elm_css$Html$Styled$div,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('Loading....')
											]));
								}
							}
						}()
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$a,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$href($author$project$Data$Route$routeUrl.transactionHistory)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Material$Styled$Button$button,
							_List_fromArray(
								[
									$author$project$Material$Styled$Button$styles($author$project$Page$PointTransaction$styles.button)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(transactionDetailsLanguageData.returnToPointsActivities)
								]))
						]))
				]));
	});
var $author$project$Types$OnPointTransactionTable = function (a) {
	return {$: 'OnPointTransactionTable', a: a};
};
var $author$project$Type$PointTransactionTable$OnTransactionClick = function (a) {
	return {$: 'OnTransactionClick', a: a};
};
var $author$project$Page$PointsTransactions$TableElements$displayMobileTable = function (transactions) {
	return A2(
		$elm$core$List$map,
		function (data) {
			var amount = function () {
				var _v0 = data.inOut;
				if (_v0.$ === 'In') {
					return A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$PointsTransactions$TableElements$styles.inTag)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								'+' + $elm$core$String$fromFloat(data.amount / 100))
							]));
				} else {
					return A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$PointsTransactions$TableElements$styles.outTag)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								'-' + $elm$core$String$fromFloat(data.amount / 100))
							]));
				}
			}();
			return A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$PointsTransactions$TableElements$styles.mobileTableRow),
						$rtfeldman$elm_css$Html$Styled$Events$onClick(
						$author$project$Types$OnAuth(
							$author$project$Types$OnPointTransactionTable(
								$author$project$Type$PointTransactionTable$OnTransactionClick(data.id))))
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$PointsTransactions$TableElements$styles.mobileTableColumn)
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$span,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$PointsTransactions$TableElements$styles.marginBottom10)
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('To: ' + data.to)
									])),
								$author$project$Page$PointsTransactions$TableElements$statusTags(data.status)
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$PointsTransactions$TableElements$styles.width20Pct)
							]),
						_List_fromArray(
							[amount]))
					]));
		},
		transactions);
};
var $rtfeldman$elm_css$Css$firstChild = $rtfeldman$elm_css$Css$pseudoClass('first-child');
var $author$project$Page$PointTransactionHistory$styles = {
	amountColumn: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$whiteSpace($rtfeldman$elm_css$Css$noWrap),
			$rtfeldman$elm_css$Css$overflow($rtfeldman$elm_css$Css$hidden),
			$rtfeldman$elm_css$Css$textOverflow($rtfeldman$elm_css$Css$ellipsis),
			$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(50)),
			$rtfeldman$elm_css$Css$fontWeight(
			$rtfeldman$elm_css$Css$int(400))
		]),
	amountHeaderText: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$whiteSpace($rtfeldman$elm_css$Css$noWrap),
			$rtfeldman$elm_css$Css$overflow($rtfeldman$elm_css$Css$hidden),
			$rtfeldman$elm_css$Css$textOverflow($rtfeldman$elm_css$Css$ellipsis),
			$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(55)),
			$rtfeldman$elm_css$Css$fontWeight(
			$rtfeldman$elm_css$Css$int(700))
		]),
	arrowButton: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(50)),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(30)),
			$rtfeldman$elm_css$Css$padding(
			$rtfeldman$elm_css$Css$px(3)),
			A2(
			$rtfeldman$elm_css$Css$margin2,
			$rtfeldman$elm_css$Css$zero,
			$rtfeldman$elm_css$Css$px(10)),
			$rtfeldman$elm_css$Css$hover(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer),
					A2($rtfeldman$elm_css$Css$property, 'box-shadow', '0px 2px 4px -1px rgba(0,0,0,0.2), 0px 4px 5px 0px rgba(0,0,0,0.14), 0px 1px 10px 0px rgba(0,0,0,0.12)')
				]))
		]),
	button: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(200))
		]),
	cardContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(15))
		]),
	container: _List_fromArray(
		[
			A3(
			$rtfeldman$elm_css$Css$margin3,
			$rtfeldman$elm_css$Css$px(10),
			$rtfeldman$elm_css$Css$px(30),
			$rtfeldman$elm_css$Css$zero)
		]),
	dateTimeRowText: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$whiteSpace($rtfeldman$elm_css$Css$noWrap),
			$rtfeldman$elm_css$Css$overflow($rtfeldman$elm_css$Css$hidden),
			$rtfeldman$elm_css$Css$textOverflow($rtfeldman$elm_css$Css$ellipsis),
			$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$maxWidth(
			$rtfeldman$elm_css$Css$px(200)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(25)),
			$rtfeldman$elm_css$Css$fontWeight(
			$rtfeldman$elm_css$Css$int(400))
		]),
	divider: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100)),
			$rtfeldman$elm_css$Css$backgroundColor($author$project$Material$Styled$Color$grey300)
		]),
	headerTitle: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$whiteSpace($rtfeldman$elm_css$Css$noWrap),
			$rtfeldman$elm_css$Css$overflow($rtfeldman$elm_css$Css$hidden),
			$rtfeldman$elm_css$Css$textOverflow($rtfeldman$elm_css$Css$ellipsis),
			$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$maxWidth(
			$rtfeldman$elm_css$Css$px(200)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(25)),
			$rtfeldman$elm_css$Css$fontWeight(
			$rtfeldman$elm_css$Css$int(700))
		]),
	hoverRow: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$hover(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer),
					A2($rtfeldman$elm_css$Css$property, 'box-shadow', '0px 2px 4px -1px rgba(0,0,0,0.2), 0px 4px 5px 0px rgba(0,0,0,0.14), 0px 1px 10px 0px rgba(0,0,0,0.12)'),
					$rtfeldman$elm_css$Css$backgroundColor($author$project$Material$Styled$Color$grey200)
				]))
		]),
	mobileTable: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(20)),
			A2(
			$rtfeldman$elm_css$Css$Media$withMediaQuery,
			_List_fromArray(
				['screen and (min-width: 600px)']),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$none)
				]))
		]),
	progressBar: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$maxWidth(
			$rtfeldman$elm_css$Css$pct(900))
		]),
	rowSelect: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(100)),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(12.8)),
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(15))
		]),
	shortColumn: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$whiteSpace($rtfeldman$elm_css$Css$noWrap),
			$rtfeldman$elm_css$Css$overflow($rtfeldman$elm_css$Css$hidden),
			$rtfeldman$elm_css$Css$textOverflow($rtfeldman$elm_css$Css$ellipsis),
			$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(100)),
			$rtfeldman$elm_css$Css$fontWeight(
			$rtfeldman$elm_css$Css$int(400)),
			$rtfeldman$elm_css$Css$lastChild(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$marginRight(
					$rtfeldman$elm_css$Css$px(5))
				]))
		]),
	shortHeaderTitle: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$whiteSpace($rtfeldman$elm_css$Css$noWrap),
			$rtfeldman$elm_css$Css$overflow($rtfeldman$elm_css$Css$hidden),
			$rtfeldman$elm_css$Css$textOverflow($rtfeldman$elm_css$Css$ellipsis),
			$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(100)),
			$rtfeldman$elm_css$Css$fontWeight(
			$rtfeldman$elm_css$Css$int(700)),
			$rtfeldman$elm_css$Css$lastChild(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$marginRight(
					$rtfeldman$elm_css$Css$px(5))
				]))
		]),
	table: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(20)),
			A2(
			$rtfeldman$elm_css$Css$Media$withMediaQuery,
			_List_fromArray(
				['screen and (max-width: 600px)']),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$none)
				]))
		]),
	tableFooter: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$row),
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceBetween),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			A2(
			$rtfeldman$elm_css$Css$padding2,
			$rtfeldman$elm_css$Css$px(10),
			$rtfeldman$elm_css$Css$zero),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(50)),
			A3(
			$rtfeldman$elm_css$Css$borderBottom3,
			$rtfeldman$elm_css$Css$px(1),
			$rtfeldman$elm_css$Css$solid,
			$author$project$Material$Styled$Color$grey200),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(14)),
			$rtfeldman$elm_css$Css$marginBottom(
			$rtfeldman$elm_css$Css$px(20)),
			A2(
			$rtfeldman$elm_css$Css$Media$withMediaQuery,
			_List_fromArray(
				['screen and (max-width: 500px)']),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
					$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceBetween),
					$rtfeldman$elm_css$Css$height(
					$rtfeldman$elm_css$Css$px(100))
				]))
		]),
	transactionRow: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$row),
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceBetween),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$padding(
			$rtfeldman$elm_css$Css$px(10)),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(24)),
			A3(
			$rtfeldman$elm_css$Css$borderBottom3,
			$rtfeldman$elm_css$Css$px(1),
			$rtfeldman$elm_css$Css$solid,
			$author$project$Material$Styled$Color$grey200),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(14))
		]),
	transactionRowText: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$whiteSpace($rtfeldman$elm_css$Css$noWrap),
			$rtfeldman$elm_css$Css$overflow($rtfeldman$elm_css$Css$hidden),
			$rtfeldman$elm_css$Css$textOverflow($rtfeldman$elm_css$Css$ellipsis),
			$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$start),
			$rtfeldman$elm_css$Css$maxWidth(
			$rtfeldman$elm_css$Css$px(200)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(25)),
			$rtfeldman$elm_css$Css$fontWeight(
			$rtfeldman$elm_css$Css$int(400)),
			$rtfeldman$elm_css$Css$firstChild(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$marginLeft(
					$rtfeldman$elm_css$Css$px(30))
				]))
		])
};
var $author$project$Page$PointTransactionHistory$mobileTable = function (authModel) {
	return A2(
		$author$project$Material$Styled$Card$card,
		_List_fromArray(
			[
				$author$project$Material$Styled$Card$containerStyles($author$project$Page$PointTransactionHistory$styles.mobileTable)
			]),
		$author$project$Page$PointsTransactions$TableElements$displayMobileTable(authModel.transactionHistoryModel.transactions));
};
var $author$project$Type$PointTransactionHistory$OnNextPage = {$: 'OnNextPage'};
var $author$project$Type$PointTransactionHistory$OnPageSizeChange = function (a) {
	return {$: 'OnPageSizeChange', a: a};
};
var $author$project$Type$PointTransactionHistory$OnPreviousPage = {$: 'OnPreviousPage'};
var $author$project$Page$PointTransactionHistory$tableFooter = function (model) {
	var transactionDetailsPageLanguageData = model.languageSwitchModel.allLanguageData.location.pointsManagement;
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$PointTransactionHistory$styles.tableFooter)
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Material$Styled$A$a,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$href($author$project$Data$Route$routeUrl.tokenManagement)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Material$Styled$Button$button,
						_List_fromArray(
							[
								$author$project$Material$Styled$Button$styles($author$project$Page$PointTransactionHistory$styles.button)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(transactionDetailsPageLanguageData.pointsManagement)
							]))
					])),
				A4(
				$author$project$View$Pagination$view,
				model.languageSwitchModel,
				A2(
					$elm$core$Basics$composeL,
					A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnPointTransactionHistory),
					$author$project$Type$PointTransactionHistory$OnPageSizeChange),
				$author$project$Types$OnAuth(
					$author$project$Types$OnPointTransactionHistory($author$project$Type$PointTransactionHistory$OnPreviousPage)),
				$author$project$Types$OnAuth(
					$author$project$Types$OnPointTransactionHistory($author$project$Type$PointTransactionHistory$OnNextPage)))
			]));
};
var $author$project$Type$PointTransactionHistory$OnTransactionClick = function (a) {
	return {$: 'OnTransactionClick', a: a};
};
var $author$project$Page$PointsTransactions$TableElements$inOutTags = function (direction) {
	if (direction.$ === 'In') {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$PointsTransactions$TableElements$styles.inTag)
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text('IN')
				]));
	} else {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$PointsTransactions$TableElements$styles.outTag)
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text('OUT')
				]));
	}
};
var $author$project$Page$PointTransactionHistory$transactionTable = F2(
	function (model, authModel) {
		var transactionDetailsPageLanguageData = model.languageSwitchModel.allLanguageData.location.pointsManagement;
		var _v0 = authModel;
		var languageChangeModel = _v0.languageChangeModel;
		return A2(
			$author$project$Material$Styled$Card$card,
			_List_fromArray(
				[
					$author$project$Material$Styled$Card$containerStyles($author$project$Page$PointTransactionHistory$styles.table)
				]),
			A2(
				$elm$core$List$cons,
				A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$PointTransactionHistory$styles.transactionRow)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$PointTransactionHistory$styles.headerTitle)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$elm$core$String$toUpper(transactionDetailsPageLanguageData.from))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$PointTransactionHistory$styles.headerTitle)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$elm$core$String$toUpper(transactionDetailsPageLanguageData.to))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$PointTransactionHistory$styles.amountHeaderText)
								]),
							_List_Nil),
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$PointTransactionHistory$styles.headerTitle)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(transactionDetailsPageLanguageData.time)
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$PointTransactionHistory$styles.amountHeaderText)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(transactionDetailsPageLanguageData.amount)
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$PointTransactionHistory$styles.shortHeaderTitle)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(transactionDetailsPageLanguageData.status)
								]))
						])),
				A2(
					$elm$core$List$map,
					function (data) {
						return A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css(
									_Utils_ap($author$project$Page$PointTransactionHistory$styles.transactionRow, $author$project$Page$PointTransactionHistory$styles.hoverRow)),
									$rtfeldman$elm_css$Html$Styled$Events$onClick(
									$author$project$Types$OnAuth(
										$author$project$Types$OnPointTransactionHistory(
											$author$project$Type$PointTransactionHistory$OnTransactionClick(data.id))))
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$PointTransactionHistory$styles.transactionRowText)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(data.from)
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$PointTransactionHistory$styles.transactionRowText)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(data.to)
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$PointTransactionHistory$styles.amountColumn)
										]),
									_List_fromArray(
										[
											$author$project$Page$PointsTransactions$TableElements$inOutTags(data.inOut)
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$PointTransactionHistory$styles.dateTimeRowText)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											A2($author$project$Page$PointsTransactions$TableElements$dateFormatter, model.timezone, data.timeStamp) + (' ' + A2($author$project$Page$PointsTransactions$TableElements$timeFormatter, model.timezone, data.timeStamp)))
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$PointTransactionHistory$styles.amountColumn)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											$elm$core$String$fromFloat(data.amount / 100))
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$PointTransactionHistory$styles.shortColumn)
										]),
									_List_fromArray(
										[
											$author$project$Page$PointsTransactions$TableElements$statusTags(data.status)
										]))
								]));
					},
					authModel.transactionHistoryModel.transactions)));
	});
var $author$project$Page$PointTransactionHistory$view = F2(
	function (model, authModel) {
		var transactionDetailsPageLanguageData = model.languageSwitchModel.allLanguageData.location.pointsManagement;
		var _v0 = authModel;
		var languageChangeModel = _v0.languageChangeModel;
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$PointTransactionHistory$styles.container)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$h1,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(transactionDetailsPageLanguageData.transactionHistoryHeader)
								]))
						])),
					A2(
					$author$project$Material$Styled$Divider$divider,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$PointTransactionHistory$styles.divider)
						]),
					_List_Nil),
					A2($author$project$Page$PointTransactionHistory$transactionTable, model, authModel),
					$author$project$Page$PointTransactionHistory$tableFooter(model),
					$author$project$Page$PointTransactionHistory$mobileTable(authModel)
				]));
	});
var $author$project$Type$PointWithdrawal$OnModalClose = {$: 'OnModalClose'};
var $author$project$Type$PointWithdrawal$OnVerifyClick = {$: 'OnVerifyClick'};
var $author$project$Page$PointWithdrawal$styles = {
	balanceHeaderText: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(11)),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$blueGrey600)
		]),
	buttonContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceBetween),
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$row),
			A2(
			$rtfeldman$elm_css$Css$margin2,
			$rtfeldman$elm_css$Css$px(0),
			$rtfeldman$elm_css$Css$pct(2)),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(40)),
			$rtfeldman$elm_css$Css$padding(
			$rtfeldman$elm_css$Css$px(5))
		]),
	buttonWidth: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(200))
		]),
	container: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$flexStart),
			$rtfeldman$elm_css$Css$flexWrap($rtfeldman$elm_css$Css$wrap),
			$rtfeldman$elm_css$Css$marginBottom(
			$rtfeldman$elm_css$Css$px(50))
		]),
	dashboardBtn: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(10)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(190))
		]),
	externalWallet: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$padding(
			$rtfeldman$elm_css$Css$px(20))
		]),
	externalWalletContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$end),
			A4(
			$rtfeldman$elm_css$Css$padding4,
			$rtfeldman$elm_css$Css$px(5),
			$rtfeldman$elm_css$Css$px(20),
			$rtfeldman$elm_css$Css$px(0),
			$rtfeldman$elm_css$Css$px(0)),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$blueGrey500),
			$rtfeldman$elm_css$Css$textDecoration($rtfeldman$elm_css$Css$underline),
			$rtfeldman$elm_css$Css$hover(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer)
				]))
		]),
	field: _List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Css$margin2,
			$rtfeldman$elm_css$Css$px(12),
			$rtfeldman$elm_css$Css$px(0)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(95))
		]),
	headerContainer: _List_fromArray(
		[
			A3(
			$rtfeldman$elm_css$Css$flex3,
			$rtfeldman$elm_css$Css$num(1),
			$rtfeldman$elm_css$Css$num(0),
			$rtfeldman$elm_css$Css$px(240)),
			$rtfeldman$elm_css$Css$margin(
			$rtfeldman$elm_css$Css$px(20)),
			$rtfeldman$elm_css$Css$maxWidth(
			$rtfeldman$elm_css$Css$px(900)),
			A2(
			$rtfeldman$elm_css$Css$Media$withMediaQuery,
			_List_fromArray(
				['screen and (min-width: 1440px)']),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$maxWidth(
					$rtfeldman$elm_css$Css$px(400))
				]))
		]),
	modalBody: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(12)),
			$rtfeldman$elm_css$Css$fontWeight(
			$rtfeldman$elm_css$Css$int(400)),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$blueGrey500)
		]),
	modalBodyContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$em(1))
		]),
	modalBtns: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$rowReverse),
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceBetween)
		]),
	modalContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$vw(70)),
			$rtfeldman$elm_css$Css$maxWidth(
			$rtfeldman$elm_css$Css$px(500))
		]),
	modalHeader: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$row),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$flexStart),
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceBetween)
		]),
	modalHeaderTxt: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(20)),
			$rtfeldman$elm_css$Css$fontWeight(
			$rtfeldman$elm_css$Css$int(500))
		]),
	textBoxContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexWrap($rtfeldman$elm_css$Css$wrap),
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$paddingTop(
			$rtfeldman$elm_css$Css$px(5))
		]),
	withdrawContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$pct(100)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(45)),
			A2(
			$rtfeldman$elm_css$Css$margin2,
			$rtfeldman$elm_css$Css$px(5),
			$rtfeldman$elm_css$Css$zero),
			$rtfeldman$elm_css$Css$paddingBottom(
			$rtfeldman$elm_css$Css$px(10)),
			$rtfeldman$elm_css$Css$backgroundColor($author$project$Material$Styled$Color$white),
			A2($rtfeldman$elm_css$Css$property, 'box-shadow', '0 0 0 1px rgba(63,63,68,0.05), 0 1px 3px 0 rgba(63,63,68,0.15)'),
			A2(
			$rtfeldman$elm_css$Css$Media$withMediaQuery,
			_List_fromArray(
				['screen and (max-width: 800px)']),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$width(
					$rtfeldman$elm_css$Css$pct(100))
				]))
		])
};
var $author$project$Page$PointWithdrawal$modals = function (modal) {
	switch (modal.$) {
		case 'MaxWithdrawAmount':
			return A2(
				$author$project$Material$Styled$Modal$modal,
				_List_fromArray(
					[
						$author$project$Material$Styled$Modal$open(true),
						$author$project$Material$Styled$Modal$contentContainerstyles($author$project$Page$PointWithdrawal$styles.modalContainer)
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$PointWithdrawal$styles.modalHeader)
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$span,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$PointWithdrawal$styles.modalHeaderTxt)
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('Max Amount Exceeded')
									]))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$PointWithdrawal$styles.modalBodyContainer)
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$span,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$PointWithdrawal$styles.modalBody)
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('Withdrawal Amount cannot exceed available balance')
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$span,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$PointWithdrawal$styles.modalBtns)
									]),
								_List_fromArray(
									[
										A2(
										$author$project$Material$Styled$Button$button,
										_List_fromArray(
											[
												$author$project$Material$Styled$Button$theme($author$project$Material$Styled$Button$blue),
												$author$project$Material$Styled$Button$styles($author$project$Page$PointWithdrawal$styles.dashboardBtn),
												$author$project$Material$Styled$Button$onClick(
												$author$project$Types$OnAuth(
													$author$project$Types$OnPointWithdrawal($author$project$Type$PointWithdrawal$OnModalClose)))
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('Confirm')
											]))
									]))
							]))
					]));
		case 'VerifyToWithdraw':
			return A2(
				$author$project$Material$Styled$Modal$modal,
				_List_fromArray(
					[
						$author$project$Material$Styled$Modal$open(true),
						$author$project$Material$Styled$Modal$contentContainerstyles($author$project$Page$PointWithdrawal$styles.modalContainer)
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$PointWithdrawal$styles.modalHeader)
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$span,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$PointWithdrawal$styles.modalHeaderTxt)
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('Verification Needed')
									]))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$PointWithdrawal$styles.modalBodyContainer)
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$span,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$PointWithdrawal$styles.modalBody)
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('Please verify your MyInfo or Government ID to withdraw SIGN Points.')
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$span,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$PointWithdrawal$styles.modalBtns)
									]),
								_List_fromArray(
									[
										A2(
										$author$project$Material$Styled$Button$button,
										_List_fromArray(
											[
												$author$project$Material$Styled$Button$theme($author$project$Material$Styled$Button$blue),
												$author$project$Material$Styled$Button$styles($author$project$Page$PointWithdrawal$styles.dashboardBtn),
												$author$project$Material$Styled$Button$onClick(
												$author$project$Types$OnAuth(
													$author$project$Types$OnPointWithdrawal($author$project$Type$PointWithdrawal$OnVerifyClick)))
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('Verify')
											])),
										A2(
										$author$project$Material$Styled$Button$button,
										_List_fromArray(
											[
												$author$project$Material$Styled$Button$theme($author$project$Material$Styled$Button$default),
												$author$project$Material$Styled$Button$styles($author$project$Page$PointWithdrawal$styles.dashboardBtn),
												$author$project$Material$Styled$Button$onClick(
												$author$project$Types$OnAuth(
													$author$project$Types$OnPointWithdrawal($author$project$Type$PointWithdrawal$OnModalClose)))
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('Cancel')
											]))
									]))
							]))
					]));
		default:
			return $rtfeldman$elm_css$Html$Styled$text('');
	}
};
var $author$project$Type$PointWithdrawal$Blur = function (a) {
	return {$: 'Blur', a: a};
};
var $author$project$Type$PointWithdrawal$Input = function (a) {
	return {$: 'Input', a: a};
};
var $author$project$Type$PointWithdrawal$OnMaxAmount = function (a) {
	return {$: 'OnMaxAmount', a: a};
};
var $author$project$Type$PointWithdrawal$OnWithdraw = {$: 'OnWithdraw'};
var $author$project$Type$PointWithdrawal$OnWithdrawalAmount = function (a) {
	return {$: 'OnWithdrawalAmount', a: a};
};
var $author$project$Material$Styled$Card$HeaderText = function (a) {
	return {$: 'HeaderText', a: a};
};
var $author$project$Material$Styled$Card$headerText = function (string) {
	return $author$project$Material$Styled$Card$HeaderText(
		$elm$core$Maybe$Just(string));
};
var $author$project$Page$PointWithdrawal$pointsWithdraw = F3(
	function (authModel, fromAccount, toAccount) {
		var _v0 = authModel;
		var withdrawalModel = _v0.withdrawalModel;
		var balance = $elm$core$String$fromFloat(withdrawalModel.available / 100);
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$PointWithdrawal$styles.container)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Material$Styled$Card$card,
					_List_fromArray(
						[
							$author$project$Material$Styled$Card$headerText('Withdraw SIGN Points'),
							$author$project$Material$Styled$Card$containerStyles($author$project$Page$PointWithdrawal$styles.withdrawContainer)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$PointWithdrawal$styles.textBoxContainer)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Material$Styled$Input$text,
									_List_fromArray(
										[
											$author$project$Material$Styled$Input$containerStyles($author$project$Page$PointWithdrawal$styles.field),
											$author$project$Material$Styled$Input$label('From Account'),
											$author$project$Material$Styled$Input$value(fromAccount),
											$author$project$Material$Styled$Input$disabled(true)
										]),
									_List_Nil),
									A2(
									$author$project$Material$Styled$Input$text,
									_List_fromArray(
										[
											$author$project$Material$Styled$Input$containerStyles($author$project$Page$PointWithdrawal$styles.field),
											$author$project$Material$Styled$Input$label('To Account'),
											$author$project$Material$Styled$Input$value(toAccount),
											$author$project$Material$Styled$Input$disabled(true)
										]),
									_List_Nil),
									A2(
									$author$project$Material$Styled$Input$text,
									_List_fromArray(
										[
											$author$project$Material$Styled$Input$containerStyles($author$project$Page$PointWithdrawal$styles.field),
											$author$project$Material$Styled$Input$label('Amount *'),
											$author$project$Material$Styled$Input$onInput(
											A2(
												$elm$core$Basics$composeL,
												A2(
													$elm$core$Basics$composeL,
													A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnPointWithdrawal),
													$author$project$Type$PointWithdrawal$OnWithdrawalAmount),
												$author$project$Type$PointWithdrawal$Input)),
											$author$project$Material$Styled$Input$onBlur(
											$author$project$Types$OnAuth(
												$author$project$Types$OnPointWithdrawal(
													$author$project$Type$PointWithdrawal$OnWithdrawalAmount(
														$author$project$Type$PointWithdrawal$Blur(balance))))),
											$author$project$Material$Styled$Input$value(withdrawalModel.amount),
											$author$project$Material$Styled$Input$errorMessage(withdrawalModel.sendToken.amountError)
										]),
									_List_Nil)
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$PointWithdrawal$styles.buttonContainer)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Material$Styled$Button$button,
									_List_fromArray(
										[
											$author$project$Material$Styled$Button$theme($author$project$Material$Styled$Button$default),
											$author$project$Material$Styled$Button$styles($author$project$Page$PointWithdrawal$styles.buttonWidth),
											$author$project$Material$Styled$Button$onClick(
											$author$project$Types$OnAuth(
												$author$project$Types$OnPointWithdrawal(
													$author$project$Type$PointWithdrawal$OnMaxAmount(balance))))
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('Max Amount')
										])),
									A2(
									$author$project$Material$Styled$Button$button,
									_List_fromArray(
										[
											$author$project$Material$Styled$Button$styles($author$project$Page$PointWithdrawal$styles.buttonWidth),
											$author$project$Material$Styled$Button$onClick(
											$author$project$Types$OnAuth(
												$author$project$Types$OnPointWithdrawal($author$project$Type$PointWithdrawal$OnWithdraw)))
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('Withdraw')
										]))
								]))
						]))
				]));
	});
var $author$project$Type$TokenManagement$Leave = {$: 'Leave'};
var $author$project$Type$TokenManagement$OnHover = F2(
	function (a, b) {
		return {$: 'OnHover', a: a, b: b};
	});
var $author$project$Type$TokenManagement$SystemBalance = {$: 'SystemBalance'};
var $author$project$Material$Styled$Icon$Help$view = F2(
	function (attributes, children) {
		return A2(
			$rtfeldman$elm_css$Svg$Styled$svg,
			_Utils_ap(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Svg$Styled$Attributes$fill('black'),
						$rtfeldman$elm_css$Svg$Styled$Attributes$width('24px'),
						$rtfeldman$elm_css$Svg$Styled$Attributes$height('24px'),
						$rtfeldman$elm_css$Svg$Styled$Attributes$viewBox('0 0 24 24')
					]),
				attributes),
			_Utils_ap(
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Svg$Styled$path,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Svg$Styled$Attributes$d('M0 0h24v24H0V0z'),
								$rtfeldman$elm_css$Svg$Styled$Attributes$fill('none')
							]),
						_List_Nil),
						A2(
						$rtfeldman$elm_css$Svg$Styled$path,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Svg$Styled$Attributes$d('M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 17h-2v-2h2v2zm2.07-7.75l-.9.92C13.45 12.9 13 13.5 13 15h-2v-.5c0-1.1.45-2.1 1.17-2.83l1.24-1.26c.37-.36.59-.86.59-1.41 0-1.1-.9-2-2-2s-2 .9-2 2H8c0-2.21 1.79-4 4-4s4 1.79 4 4c0 .88-.36 1.68-.93 2.25z')
							]),
						_List_Nil)
					]),
				children));
	});
var $author$project$Material$Styled$Icon$help = $author$project$Material$Styled$Icon$Help$view;
var $author$project$Material$Styled$Card$Icon = function (a) {
	return {$: 'Icon', a: a};
};
var $author$project$Material$Styled$Card$iconElement = function (icon) {
	return $author$project$Material$Styled$Card$Icon(icon);
};
var $rtfeldman$elm_css$Css$inlineFlex = {display: $rtfeldman$elm_css$Css$Structure$Compatible, value: 'inline-flex'};
var $author$project$Page$TokenManagement$styles = {
	algoWalletContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(400)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(45)),
			A2(
			$rtfeldman$elm_css$Css$margin2,
			$rtfeldman$elm_css$Css$px(45),
			$rtfeldman$elm_css$Css$zero),
			$rtfeldman$elm_css$Css$backgroundColor($author$project$Material$Styled$Color$white),
			A2($rtfeldman$elm_css$Css$property, 'box-shadow', '0 0 0 1px rgba(63,63,68,0.05), 0 1px 3px 0 rgba(63,63,68,0.15)'),
			A2(
			$rtfeldman$elm_css$Css$Media$withMediaQuery,
			_List_fromArray(
				['screen and (max-width: 800px)']),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$width(
					$rtfeldman$elm_css$Css$pct(100))
				]))
		]),
	amountColumn: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$whiteSpace($rtfeldman$elm_css$Css$noWrap),
			$rtfeldman$elm_css$Css$overflow($rtfeldman$elm_css$Css$hidden),
			$rtfeldman$elm_css$Css$textOverflow($rtfeldman$elm_css$Css$ellipsis),
			$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(50)),
			$rtfeldman$elm_css$Css$fontWeight(
			$rtfeldman$elm_css$Css$int(400))
		]),
	amountHeaderText: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$whiteSpace($rtfeldman$elm_css$Css$noWrap),
			$rtfeldman$elm_css$Css$overflow($rtfeldman$elm_css$Css$hidden),
			$rtfeldman$elm_css$Css$textOverflow($rtfeldman$elm_css$Css$ellipsis),
			$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(55)),
			$rtfeldman$elm_css$Css$fontWeight(
			$rtfeldman$elm_css$Css$int(700))
		]),
	arrowButton: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$padding(
			$rtfeldman$elm_css$Css$px(0)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(50)),
			$rtfeldman$elm_css$Css$backgroundColor($author$project$Material$Styled$Color$white)
		]),
	balanceCard: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$row),
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$flexStart),
			$rtfeldman$elm_css$Css$flexWrap($rtfeldman$elm_css$Css$wrap),
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$row),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100)),
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceBetween),
			$rtfeldman$elm_css$Css$flexWrap($rtfeldman$elm_css$Css$wrap)
		]),
	balanceContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(40)),
			$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$padding(
			$rtfeldman$elm_css$Css$px(20))
		]),
	balanceHeaderText: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(11)),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$blueGrey600)
		]),
	banner: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginBottom(
			$rtfeldman$elm_css$Css$px(20))
		]),
	bluegreyText: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$blueGrey500)
		]),
	bscScanText: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$row),
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$flexEnd),
			A2(
			$rtfeldman$elm_css$Css$padding2,
			$rtfeldman$elm_css$Css$zero,
			$rtfeldman$elm_css$Css$px(20)),
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(20)),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(11))
		]),
	buttonWidth: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(200))
		]),
	cancelButton: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(50)),
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(20))
		]),
	card: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$margin(
			$rtfeldman$elm_css$Css$px(20)),
			$rtfeldman$elm_css$Css$maxWidth(
			$rtfeldman$elm_css$Css$pct(90)),
			$rtfeldman$elm_css$Css$minWidth(
			$rtfeldman$elm_css$Css$pct(90))
		]),
	cardContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			$rtfeldman$elm_css$Css$flexWrap($rtfeldman$elm_css$Css$wrap),
			$rtfeldman$elm_css$Css$marginBottom(
			$rtfeldman$elm_css$Css$px(10)),
			$rtfeldman$elm_css$Css$marginRight(
			$rtfeldman$elm_css$Css$px(10)),
			$rtfeldman$elm_css$Css$hover(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer),
					A2($rtfeldman$elm_css$Css$property, 'box-shadow', '0px 2px 4px -1px rgba(0,0,0,0.2), 0px 4px 5px 0px rgba(0,0,0,0.14), 0px 1px 10px 0px rgba(0,0,0,0.12)'),
					$rtfeldman$elm_css$Css$backgroundColor($author$project$Material$Styled$Color$grey200)
				])),
			A2(
			$rtfeldman$elm_css$Css$padding2,
			$rtfeldman$elm_css$Css$zero,
			$rtfeldman$elm_css$Css$px(20))
		]),
	container: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$flexStart),
			$rtfeldman$elm_css$Css$flexWrap($rtfeldman$elm_css$Css$wrap)
		]),
	coverImage: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(180)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100)),
			$rtfeldman$elm_css$Css$backgroundImage(
			$rtfeldman$elm_css$Css$url($author$project$View$Theme$images.pointsCover)),
			$rtfeldman$elm_css$Css$backgroundRepeat($rtfeldman$elm_css$Css$noRepeat),
			A2(
			$rtfeldman$elm_css$Css$backgroundPosition2,
			$rtfeldman$elm_css$Css$pct(50),
			$rtfeldman$elm_css$Css$pct(100))
		]),
	dashboardBtn: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(10)),
			$rtfeldman$elm_css$Css$width($rtfeldman$elm_css$Css$auto),
			$rtfeldman$elm_css$Css$minWidth(
			$rtfeldman$elm_css$Css$px(190))
		]),
	dateTimeRowText: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$whiteSpace($rtfeldman$elm_css$Css$noWrap),
			$rtfeldman$elm_css$Css$overflow($rtfeldman$elm_css$Css$hidden),
			$rtfeldman$elm_css$Css$textOverflow($rtfeldman$elm_css$Css$ellipsis),
			$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$maxWidth(
			$rtfeldman$elm_css$Css$px(200)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(25)),
			$rtfeldman$elm_css$Css$fontWeight(
			$rtfeldman$elm_css$Css$int(400))
		]),
	desktopCard: _List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Css$Media$withMediaQuery,
			_List_fromArray(
				['screen and (max-width: 600px)']),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$none)
				]))
		]),
	errorText: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(10)),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(20)),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$red500)
		]),
	externalWallet: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$padding(
			$rtfeldman$elm_css$Css$px(20))
		]),
	externalWalletContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$end),
			A4(
			$rtfeldman$elm_css$Css$padding4,
			$rtfeldman$elm_css$Css$px(5),
			$rtfeldman$elm_css$Css$px(20),
			$rtfeldman$elm_css$Css$px(0),
			$rtfeldman$elm_css$Css$px(0)),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$blueGrey500),
			$rtfeldman$elm_css$Css$textDecoration($rtfeldman$elm_css$Css$underline),
			$rtfeldman$elm_css$Css$hover(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer)
				]))
		]),
	field: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$maxWidth(
			$rtfeldman$elm_css$Css$pct(60)),
			$rtfeldman$elm_css$Css$minWidth(
			$rtfeldman$elm_css$Css$pct(40)),
			$rtfeldman$elm_css$Css$marginBottom(
			$rtfeldman$elm_css$Css$px(15))
		]),
	fieldContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100)),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center)
		]),
	header: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100))
		]),
	headerContainer: _List_fromArray(
		[
			A3(
			$rtfeldman$elm_css$Css$flex3,
			$rtfeldman$elm_css$Css$num(1),
			$rtfeldman$elm_css$Css$num(0),
			$rtfeldman$elm_css$Css$px(240)),
			$rtfeldman$elm_css$Css$margin(
			$rtfeldman$elm_css$Css$px(20)),
			$rtfeldman$elm_css$Css$maxWidth(
			$rtfeldman$elm_css$Css$px(900)),
			A2(
			$rtfeldman$elm_css$Css$Media$withMediaQuery,
			_List_fromArray(
				['screen and (min-width: 1440px)']),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$maxWidth(
					$rtfeldman$elm_css$Css$px(400))
				]))
		]),
	headerTitle: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$whiteSpace($rtfeldman$elm_css$Css$noWrap),
			$rtfeldman$elm_css$Css$overflow($rtfeldman$elm_css$Css$hidden),
			$rtfeldman$elm_css$Css$textOverflow($rtfeldman$elm_css$Css$ellipsis),
			$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$maxWidth(
			$rtfeldman$elm_css$Css$px(200)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(25)),
			$rtfeldman$elm_css$Css$fontWeight(
			$rtfeldman$elm_css$Css$int(700))
		]),
	hoverCard: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$hover(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer),
					A2($rtfeldman$elm_css$Css$property, 'box-shadow', '0px 2px 4px -1px rgba(0,0,0,0.2), 0px 4px 5px 0px rgba(0,0,0,0.14), 0px 1px 10px 0px rgba(0,0,0,0.12)'),
					$rtfeldman$elm_css$Css$backgroundColor($author$project$Material$Styled$Color$grey200)
				]))
		]),
	hoverRow: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$hover(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer),
					A2($rtfeldman$elm_css$Css$property, 'box-shadow', '0px 2px 4px -1px rgba(0,0,0,0.2), 0px 4px 5px 0px rgba(0,0,0,0.14), 0px 1px 10px 0px rgba(0,0,0,0.12)'),
					$rtfeldman$elm_css$Css$backgroundColor($author$project$Material$Styled$Color$grey200)
				]))
		]),
	icon: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$boxShadow($rtfeldman$elm_css$Css$none),
			$rtfeldman$elm_css$Css$transform(
			A2(
				$rtfeldman$elm_css$Css$translate2,
				$rtfeldman$elm_css$Css$px(20),
				$rtfeldman$elm_css$Css$px(-15))),
			$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer),
			A4(
			$rtfeldman$elm_css$Css$padding4,
			$rtfeldman$elm_css$Css$px(10),
			$rtfeldman$elm_css$Css$px(10),
			$rtfeldman$elm_css$Css$px(0),
			$rtfeldman$elm_css$Css$px(10))
		]),
	inTag: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$backgroundColor($author$project$Material$Styled$Color$green100),
			A2(
			$rtfeldman$elm_css$Css$padding2,
			$rtfeldman$elm_css$Css$px(4),
			$rtfeldman$elm_css$Css$px(8)),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$green500),
			$rtfeldman$elm_css$Css$borderRadius(
			$rtfeldman$elm_css$Css$px(5))
		]),
	introHeader: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontWeight($rtfeldman$elm_css$Css$bold),
			$rtfeldman$elm_css$Css$marginBottom(
			$rtfeldman$elm_css$Css$px(10))
		]),
	introText: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(14))
		]),
	linkText: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$white),
			$rtfeldman$elm_css$Css$textDecoration($rtfeldman$elm_css$Css$underline),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(11))
		]),
	linkText2: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$color(
			$rtfeldman$elm_css$Css$hex('2962FF')),
			$rtfeldman$elm_css$Css$textDecoration($rtfeldman$elm_css$Css$underline),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(14)),
			$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center)
		]),
	listRow: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$row),
			$rtfeldman$elm_css$Css$overflow($rtfeldman$elm_css$Css$scroll)
		]),
	loadingWalletContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(250))
		]),
	marginTop20: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(20))
		]),
	mobileCard: _List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Css$Media$withMediaQuery,
			_List_fromArray(
				['screen and (min-width: 600px)']),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$none)
				]))
		]),
	mobileTransactionRow: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column)
		]),
	modalBody: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(12)),
			$rtfeldman$elm_css$Css$fontWeight(
			$rtfeldman$elm_css$Css$int(400)),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$blueGrey500)
		]),
	modalBodyContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$em(1))
		]),
	modalBtns: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$rowReverse),
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceBetween)
		]),
	modalContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$vw(70)),
			$rtfeldman$elm_css$Css$maxWidth(
			$rtfeldman$elm_css$Css$px(500))
		]),
	modalHeader: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$row),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$flexStart),
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceBetween)
		]),
	modalHeaderTxt: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(20)),
			$rtfeldman$elm_css$Css$fontWeight(
			$rtfeldman$elm_css$Css$int(500))
		]),
	notarisationNetworkTxt: _List_fromArray(
		[
			A4(
			$rtfeldman$elm_css$Css$padding4,
			$rtfeldman$elm_css$Css$px(10),
			$rtfeldman$elm_css$Css$px(0),
			$rtfeldman$elm_css$Css$px(0),
			$rtfeldman$elm_css$Css$px(10))
		]),
	numberText: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(29)),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$blueGrey900)
		]),
	optInText: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(14)),
			$rtfeldman$elm_css$Css$paddingBottom(
			$rtfeldman$elm_css$Css$px(10))
		]),
	outTag: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$backgroundColor($author$project$Material$Styled$Color$red100),
			A2(
			$rtfeldman$elm_css$Css$padding2,
			$rtfeldman$elm_css$Css$px(4),
			$rtfeldman$elm_css$Css$px(8)),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$red500),
			$rtfeldman$elm_css$Css$borderRadius(
			$rtfeldman$elm_css$Css$px(5))
		]),
	overallBalanceContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$row),
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceBetween),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(250))
		]),
	padding20: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$padding(
			$rtfeldman$elm_css$Css$px(20))
		]),
	paymentContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			$rtfeldman$elm_css$Css$margin(
			$rtfeldman$elm_css$Css$px(2)),
			$rtfeldman$elm_css$Css$maxWidth(
			$rtfeldman$elm_css$Css$px(900)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100))
		]),
	pct50Width: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(50))
		]),
	redeemButtonContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$padding(
			$rtfeldman$elm_css$Css$px(5)),
			$rtfeldman$elm_css$Css$marginBottom(
			$rtfeldman$elm_css$Css$px(10)),
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center)
		]),
	redeemRewardContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(220)),
			A4(
			$rtfeldman$elm_css$Css$margin4,
			$rtfeldman$elm_css$Css$px(15),
			$rtfeldman$elm_css$Css$px(25),
			$rtfeldman$elm_css$Css$px(5),
			$rtfeldman$elm_css$Css$px(25)),
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center)
		]),
	redeemRewardsContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$pct(100)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(45)),
			A4(
			$rtfeldman$elm_css$Css$margin4,
			$rtfeldman$elm_css$Css$px(40),
			$rtfeldman$elm_css$Css$px(0),
			$rtfeldman$elm_css$Css$px(5),
			$rtfeldman$elm_css$Css$px(0)),
			$rtfeldman$elm_css$Css$backgroundColor($author$project$Material$Styled$Color$white),
			A2($rtfeldman$elm_css$Css$property, 'box-shadow', '0 0 0 1px rgba(63,63,68,0.05), 0 1px 3px 0 rgba(63,63,68,0.15)'),
			A2(
			$rtfeldman$elm_css$Css$Media$withMediaQuery,
			_List_fromArray(
				['screen and (max-width: 800px)']),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$width(
					$rtfeldman$elm_css$Css$pct(100))
				]))
		]),
	rewardCard: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$backgroundColor($author$project$Material$Styled$Color$white),
			A2($rtfeldman$elm_css$Css$property, 'box-shadow', '0 0 0 1px rgba(63,63,68,0.05), 0 1px 3px 0 rgba(63,63,68,0.15)'),
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceBetween),
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(200)),
			A2(
			$rtfeldman$elm_css$Css$padding2,
			$rtfeldman$elm_css$Css$zero,
			$rtfeldman$elm_css$Css$px(10))
		]),
	rewardContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$inlineFlex),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(200)),
			A4(
			$rtfeldman$elm_css$Css$margin4,
			$rtfeldman$elm_css$Css$px(5),
			$rtfeldman$elm_css$Css$px(10),
			$rtfeldman$elm_css$Css$px(5),
			$rtfeldman$elm_css$Css$px(20))
		]),
	rewardNameStyles: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontWeight($rtfeldman$elm_css$Css$bold),
			$rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$inlineBlock)
		]),
	rewardTypeStyles: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(14)),
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(20))
		]),
	sendPointsContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$pct(100)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100)),
			A4(
			$rtfeldman$elm_css$Css$margin4,
			$rtfeldman$elm_css$Css$px(40),
			$rtfeldman$elm_css$Css$px(0),
			$rtfeldman$elm_css$Css$px(5),
			$rtfeldman$elm_css$Css$px(0)),
			$rtfeldman$elm_css$Css$backgroundColor($author$project$Material$Styled$Color$white),
			A2($rtfeldman$elm_css$Css$property, 'box-shadow', '0 0 0 1px rgba(63,63,68,0.05), 0 1px 3px 0 rgba(63,63,68,0.15)'),
			A2(
			$rtfeldman$elm_css$Css$Media$withMediaQuery,
			_List_fromArray(
				['screen and (max-width: 800px)']),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$width(
					$rtfeldman$elm_css$Css$pct(100))
				]))
		]),
	sendTokenCard: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center)
		]),
	shortColumn: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$whiteSpace($rtfeldman$elm_css$Css$noWrap),
			$rtfeldman$elm_css$Css$overflow($rtfeldman$elm_css$Css$hidden),
			$rtfeldman$elm_css$Css$textOverflow($rtfeldman$elm_css$Css$ellipsis),
			$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(100)),
			$rtfeldman$elm_css$Css$fontWeight(
			$rtfeldman$elm_css$Css$int(400)),
			$rtfeldman$elm_css$Css$lastChild(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$marginRight(
					$rtfeldman$elm_css$Css$px(5))
				]))
		]),
	shortHeaderTitle: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$whiteSpace($rtfeldman$elm_css$Css$noWrap),
			$rtfeldman$elm_css$Css$overflow($rtfeldman$elm_css$Css$hidden),
			$rtfeldman$elm_css$Css$textOverflow($rtfeldman$elm_css$Css$ellipsis),
			$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(100)),
			$rtfeldman$elm_css$Css$fontWeight(
			$rtfeldman$elm_css$Css$int(700)),
			$rtfeldman$elm_css$Css$lastChild(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$marginRight(
					$rtfeldman$elm_css$Css$px(5))
				]))
		]),
	toggleContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$flexStart),
			$rtfeldman$elm_css$Css$margin(
			$rtfeldman$elm_css$Css$px(15)),
			$rtfeldman$elm_css$Css$maxWidth(
			$rtfeldman$elm_css$Css$px(900)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100))
		]),
	toolTipText: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(11))
		]),
	topUpCard: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$row),
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(20)),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(250))
		]),
	transactionRow: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$row),
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceBetween),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$padding(
			$rtfeldman$elm_css$Css$px(10)),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(24)),
			A3(
			$rtfeldman$elm_css$Css$borderBottom3,
			$rtfeldman$elm_css$Css$px(1),
			$rtfeldman$elm_css$Css$solid,
			$author$project$Material$Styled$Color$grey200),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(14))
		]),
	transactionRowText: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$whiteSpace($rtfeldman$elm_css$Css$noWrap),
			$rtfeldman$elm_css$Css$overflow($rtfeldman$elm_css$Css$hidden),
			$rtfeldman$elm_css$Css$textOverflow($rtfeldman$elm_css$Css$ellipsis),
			$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$start),
			$rtfeldman$elm_css$Css$maxWidth(
			$rtfeldman$elm_css$Css$px(200)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(25)),
			$rtfeldman$elm_css$Css$fontWeight(
			$rtfeldman$elm_css$Css$int(400)),
			$rtfeldman$elm_css$Css$firstChild(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$marginLeft(
					$rtfeldman$elm_css$Css$px(30))
				]))
		]),
	transferButtonContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(40)),
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center)
		]),
	viewAllButtonContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$inlineBlock),
			$rtfeldman$elm_css$Css$padding(
			$rtfeldman$elm_css$Css$px(5)),
			A2(
			$rtfeldman$elm_css$Css$margin2,
			$rtfeldman$elm_css$Css$px(10),
			$rtfeldman$elm_css$Css$px(35))
		]),
	walletAddress: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$overflow($rtfeldman$elm_css$Css$hidden),
			$rtfeldman$elm_css$Css$textOverflow($rtfeldman$elm_css$Css$ellipsis),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(450)),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(14)),
			A4(
			$rtfeldman$elm_css$Css$padding4,
			$rtfeldman$elm_css$Css$px(10),
			$rtfeldman$elm_css$Css$px(0),
			$rtfeldman$elm_css$Css$px(10),
			$rtfeldman$elm_css$Css$px(0))
		]),
	walletBalanceText: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(10)),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(16)),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$blueGrey900)
		]),
	walletContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(300)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(45)),
			A2(
			$rtfeldman$elm_css$Css$margin2,
			$rtfeldman$elm_css$Css$px(5),
			$rtfeldman$elm_css$Css$zero),
			$rtfeldman$elm_css$Css$backgroundColor($author$project$Material$Styled$Color$white),
			A2($rtfeldman$elm_css$Css$property, 'box-shadow', '0 0 0 1px rgba(63,63,68,0.05), 0 1px 3px 0 rgba(63,63,68,0.15)'),
			A2(
			$rtfeldman$elm_css$Css$Media$withMediaQuery,
			_List_fromArray(
				['screen and (max-width: 800px)']),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$width(
					$rtfeldman$elm_css$Css$pct(100))
				]))
		]),
	walletError: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$red400)
		]),
	walletErrorContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$padding(
			$rtfeldman$elm_css$Css$px(20)),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(160))
		]),
	widthdrawButtonContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceBetween),
			A2(
			$rtfeldman$elm_css$Css$margin2,
			$rtfeldman$elm_css$Css$pct(0),
			$rtfeldman$elm_css$Css$pct(15))
		])
};
var $author$project$Page$TokenManagement$systemBalance = F4(
	function (model, authModel, available, pending) {
		var pointsManagementPageLanguageData = model.languageSwitchModel.allLanguageData.location.pointsManagement;
		var _v0 = authModel;
		var tokenManagementModel = _v0.tokenManagementModel;
		return A2(
			$author$project$Material$Styled$Card$card,
			_List_fromArray(
				[
					$author$project$Material$Styled$Card$containerStyles($author$project$Page$TokenManagement$styles.walletContainer),
					$author$project$Material$Styled$Card$headerText(pointsManagementPageLanguageData.systemBalance),
					$author$project$Material$Styled$Card$iconElement(
					A5(
						$author$project$View$InfomationToolTip$view,
						$author$project$Types$OnAuth(
							$author$project$Types$OnTokenManagement(
								A2($author$project$Type$TokenManagement$OnHover, $author$project$Type$TokenManagement$SystemBalance, $author$project$Type$TokenManagement$Enter))),
						$author$project$Types$OnAuth(
							$author$project$Types$OnTokenManagement(
								A2($author$project$Type$TokenManagement$OnHover, $author$project$Type$TokenManagement$SystemBalance, $author$project$Type$TokenManagement$Leave))),
						tokenManagementModel.systemHover,
						A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$TokenManagement$styles.toolTipText)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(pointsManagementPageLanguageData.systemBalanceTooltipText),
									A2(
									$author$project$Material$Styled$A$a,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$href('https://www.sign.net/rewardpoints'),
											$rtfeldman$elm_css$Html$Styled$Attributes$target('_blank')
										]),
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$span,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$TokenManagement$styles.linkText)
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(pointsManagementPageLanguageData.findOutMore)
												]))
										]))
								])),
						$author$project$Material$Styled$Icon$help))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$TokenManagement$styles.overallBalanceContainer)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$TokenManagement$styles.balanceContainer)
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$TokenManagement$styles.numberText)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											$elm$core$String$fromFloat(available / 100))
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$TokenManagement$styles.balanceHeaderText)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(pointsManagementPageLanguageData.available)
										]))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$TokenManagement$styles.balanceContainer)
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$TokenManagement$styles.numberText)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											$elm$core$String$fromFloat(pending / 100))
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$TokenManagement$styles.balanceHeaderText)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(pointsManagementPageLanguageData.pendingStatus)
										]))
								]))
						]))
				]));
	});
var $author$project$Page$PointWithdrawal$view = F2(
	function (authModel, model) {
		var _v0 = authModel;
		var withdrawalModel = _v0.withdrawalModel;
		var _v1 = authModel.user.metaMaskWalletAddress;
		if (_v1.$ === 'Just') {
			var address = _v1.a;
			return A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$PointWithdrawal$styles.container)
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$PointWithdrawal$styles.headerContainer)
									]),
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$h1,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$css(
												_List_fromArray(
													[
														$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center)
													]))
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('Withdraw SIGN Points')
											]))
									]))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$PointWithdrawal$styles.container)
									]),
								_List_fromArray(
									[
										A4($author$project$Page$TokenManagement$systemBalance, model, authModel, withdrawalModel.available, withdrawalModel.pending)
									])),
								A3($author$project$Page$PointWithdrawal$pointsWithdraw, authModel, 'System Balance', address),
								$author$project$Page$PointWithdrawal$modals(authModel.withdrawalModel.modal)
							]))
					]));
		} else {
			return $rtfeldman$elm_css$Html$Styled$text('');
		}
	});
var $author$project$Material$Styled$Icon$Error$view = F2(
	function (attributes, children) {
		return A2(
			$rtfeldman$elm_css$Svg$Styled$svg,
			_Utils_ap(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Svg$Styled$Attributes$fill('black'),
						$rtfeldman$elm_css$Svg$Styled$Attributes$width('24px'),
						$rtfeldman$elm_css$Svg$Styled$Attributes$height('24px'),
						$rtfeldman$elm_css$Svg$Styled$Attributes$viewBox('0 0 24 24')
					]),
				attributes),
			_Utils_ap(
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Svg$Styled$path,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Svg$Styled$Attributes$d('M0 0h24v24H0V0z'),
								$rtfeldman$elm_css$Svg$Styled$Attributes$fill('none')
							]),
						_List_Nil),
						A2(
						$rtfeldman$elm_css$Svg$Styled$path,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Svg$Styled$Attributes$d('M11 15h2v2h-2zm0-8h2v6h-2zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z')
							]),
						_List_Nil)
					]),
				children));
	});
var $author$project$Material$Styled$Icon$error = $author$project$Material$Styled$Icon$Error$view;
var $author$project$Page$PointWithdrawalConfirmation$styles = {
	affliate: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(1)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(1))
		]),
	button: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(48)),
			$rtfeldman$elm_css$Css$maxWidth(
			$rtfeldman$elm_css$Css$px(300))
		]),
	card: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			A2(
			$rtfeldman$elm_css$Css$margin2,
			$rtfeldman$elm_css$Css$zero,
			$rtfeldman$elm_css$Css$px(20)),
			$rtfeldman$elm_css$Css$paddingBottom(
			$rtfeldman$elm_css$Css$px(40)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100)),
			$rtfeldman$elm_css$Css$maxWidth(
			$rtfeldman$elm_css$Css$px(600))
		]),
	checkCircle: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginBottom(
			$rtfeldman$elm_css$Css$px(30))
		]),
	container: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			A2(
			$rtfeldman$elm_css$Css$padding2,
			$rtfeldman$elm_css$Css$px(48),
			$rtfeldman$elm_css$Css$zero)
		]),
	heading: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(24)),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$blueGrey900),
			$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center)
		]),
	headingError: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(24)),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$red900),
			$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center)
		]),
	linkContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			A3(
				$rtfeldman$elm_css$Css$calc,
				$rtfeldman$elm_css$Css$pct(100),
				$rtfeldman$elm_css$Css$minus,
				$rtfeldman$elm_css$Css$px(48))),
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(16))
		]),
	logo: _List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Css$margin2,
			$rtfeldman$elm_css$Css$px(60),
			$rtfeldman$elm_css$Css$zero),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(150)),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(38))
		]),
	main: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			A3(
				$rtfeldman$elm_css$Css$calc,
				$rtfeldman$elm_css$Css$pct(100),
				$rtfeldman$elm_css$Css$minus,
				$rtfeldman$elm_css$Css$px(48))),
			A2(
			$rtfeldman$elm_css$Css$padding2,
			$rtfeldman$elm_css$Css$px(48),
			$rtfeldman$elm_css$Css$px(24)),
			$rtfeldman$elm_css$Css$boxSizing($rtfeldman$elm_css$Css$borderBox),
			A3(
			$rtfeldman$elm_css$Css$borderTop3,
			$rtfeldman$elm_css$Css$px(1),
			$rtfeldman$elm_css$Css$solid,
			$author$project$Material$Styled$Color$grey200),
			A3(
			$rtfeldman$elm_css$Css$borderBottom3,
			$rtfeldman$elm_css$Css$px(1),
			$rtfeldman$elm_css$Css$solid,
			$author$project$Material$Styled$Color$grey200)
		]),
	progressBar: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(48))
		]),
	textContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(14)),
			$rtfeldman$elm_css$Css$lineHeight(
			$rtfeldman$elm_css$Css$px(21)),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$blueGrey900),
			$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$fontWeight(
			$rtfeldman$elm_css$Css$int(400))
		]),
	view: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center)
		])
};
var $author$project$Page$PointWithdrawalConfirmation$failedView = _List_fromArray(
	[
		A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$PointWithdrawalConfirmation$styles.view)
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Material$Styled$Icon$error,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Svg$Styled$Attributes$height('250px'),
						$rtfeldman$elm_css$Svg$Styled$Attributes$width('250px'),
						$rtfeldman$elm_css$Svg$Styled$Attributes$fill('red')
					]),
				_List_Nil)
			])),
		A2(
		$rtfeldman$elm_css$Html$Styled$h2,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$PointWithdrawalConfirmation$styles.heading)
			]),
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$text('Transaction Failed')
			])),
		A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$PointWithdrawalConfirmation$styles.textContainer)
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$p,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('This transaction has failed due to one of the following reasons: ')
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$p,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('- The approval period has passed. Please ensure that you approve your transaction within 5 minutes of sending the request')
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$p,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('- This transaction has already been approved')
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$p,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('For more details regarding this transaction, your can view your '),
						A2(
						$rtfeldman$elm_css$Html$Styled$a,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$href($author$project$Data$Route$routeUrl.tokenManagement)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('points management page ')
							])),
						$rtfeldman$elm_css$Html$Styled$text('or contact us at '),
						A2(
						$rtfeldman$elm_css$Html$Styled$a,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$href('mailto:help@sign.net?subject=SIGN Points Withdrawal Help'),
								$rtfeldman$elm_css$Html$Styled$Attributes$target('_blank')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('help@sign.net')
							]))
					]))
			]))
	]);
var $author$project$Page$PointWithdrawalConfirmation$layout = function (children) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$PointWithdrawalConfirmation$styles.container)
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Material$Styled$Card$card,
				_List_fromArray(
					[
						$author$project$Material$Styled$Card$containerStyles($author$project$Page$PointWithdrawalConfirmation$styles.card)
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$img,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$src($author$project$View$Theme$images.logoColor),
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$PointWithdrawalConfirmation$styles.logo)
							]),
						_List_Nil),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$PointWithdrawalConfirmation$styles.main)
							]),
						children)
					]))
			]));
};
var $author$project$Page$PointWithdrawalConfirmation$loadingView = _List_fromArray(
	[
		A2(
		$rtfeldman$elm_css$Html$Styled$h2,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$PointWithdrawalConfirmation$styles.heading)
			]),
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$text('Loading')
			])),
		A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$PointWithdrawalConfirmation$styles.textContainer)
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$p,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('We are completing your transaction. Please wait.')
					]))
			]))
	]);
var $author$project$Page$PointWithdrawalConfirmation$successView = _List_fromArray(
	[
		A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$PointWithdrawalConfirmation$styles.view)
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Material$Styled$Icon$checkCircle,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Svg$Styled$Attributes$height('250px'),
						$rtfeldman$elm_css$Svg$Styled$Attributes$width('250px'),
						$rtfeldman$elm_css$Svg$Styled$Attributes$fill('green')
					]),
				_List_Nil)
			])),
		A2(
		$rtfeldman$elm_css$Html$Styled$h2,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$PointWithdrawalConfirmation$styles.heading)
			]),
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$text('Transfer Completed')
			])),
		A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$PointWithdrawalConfirmation$styles.textContainer)
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$p,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('Your transaction has been completed and details can be found in '),
						A2(
						$rtfeldman$elm_css$Html$Styled$a,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$href($author$project$Data$Route$routeUrl.transactionHistory)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('transaction history')
							]))
					]))
			]))
	]);
var $author$project$Page$PointWithdrawalConfirmation$view = function (model) {
	var _v0 = model.pointWithdrawalConfirm.status;
	switch (_v0.$) {
		case 'Success':
			return $author$project$Page$PointWithdrawalConfirmation$layout($author$project$Page$PointWithdrawalConfirmation$successView);
		case 'Fail':
			return $author$project$Page$PointWithdrawalConfirmation$layout($author$project$Page$PointWithdrawalConfirmation$failedView);
		default:
			return $author$project$Page$PointWithdrawalConfirmation$layout($author$project$Page$PointWithdrawalConfirmation$loadingView);
	}
};
var $author$project$Type$RedeemRewardList$BackToRewardPoints = {$: 'BackToRewardPoints'};
var $author$project$Type$RedeemRewardList$Blur = F2(
	function (a, b) {
		return {$: 'Blur', a: a, b: b};
	});
var $author$project$Type$RedeemRewardList$GoToAccount = {$: 'GoToAccount'};
var $author$project$Type$RedeemRewardList$GoToDocuments = {$: 'GoToDocuments'};
var $author$project$Type$RedeemRewardList$Input = function (a) {
	return {$: 'Input', a: a};
};
var $author$project$Type$RedeemRewardList$OnModalClose = {$: 'OnModalClose'};
var $author$project$Type$RedeemRewardList$OnRewardQuantity = function (a) {
	return {$: 'OnRewardQuantity', a: a};
};
var $author$project$Type$RedeemRewardList$OnRewardSubmit = F3(
	function (a, b, c) {
		return {$: 'OnRewardSubmit', a: a, b: b, c: c};
	});
var $author$project$Page$RedeemReward$styles = {
	addPadding: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$padding(
			$rtfeldman$elm_css$Css$px(20))
		]),
	block: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$block),
			A2(
			$rtfeldman$elm_css$Css$margin2,
			$rtfeldman$elm_css$Css$px(5),
			$rtfeldman$elm_css$Css$zero)
		]),
	container: _List_fromArray(
		[
			A3(
			$rtfeldman$elm_css$Css$margin3,
			$rtfeldman$elm_css$Css$px(10),
			$rtfeldman$elm_css$Css$px(30),
			$rtfeldman$elm_css$Css$zero)
		]),
	dashboardBtn: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(10)),
			$rtfeldman$elm_css$Css$width($rtfeldman$elm_css$Css$auto),
			$rtfeldman$elm_css$Css$minWidth(
			$rtfeldman$elm_css$Css$px(190))
		]),
	divider: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100)),
			$rtfeldman$elm_css$Css$backgroundColor($author$project$Material$Styled$Color$grey300)
		]),
	field: _List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Css$margin2,
			$rtfeldman$elm_css$Css$px(12),
			$rtfeldman$elm_css$Css$px(0)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100))
		]),
	hoverCard: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$hover(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer),
					A2($rtfeldman$elm_css$Css$property, 'box-shadow', '0px 2px 4px -1px rgba(0,0,0,0.2), 0px 4px 5px 0px rgba(0,0,0,0.14), 0px 1px 10px 0px rgba(0,0,0,0.12)'),
					$rtfeldman$elm_css$Css$backgroundColor($author$project$Material$Styled$Color$grey200)
				]))
		]),
	icon: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$boxShadow($rtfeldman$elm_css$Css$none),
			$rtfeldman$elm_css$Css$transform(
			A2(
				$rtfeldman$elm_css$Css$translate2,
				$rtfeldman$elm_css$Css$px(20),
				$rtfeldman$elm_css$Css$px(-15))),
			$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer),
			A4(
			$rtfeldman$elm_css$Css$padding4,
			$rtfeldman$elm_css$Css$px(10),
			$rtfeldman$elm_css$Css$px(10),
			$rtfeldman$elm_css$Css$px(0),
			$rtfeldman$elm_css$Css$px(10))
		]),
	introHeader: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontWeight($rtfeldman$elm_css$Css$bold),
			$rtfeldman$elm_css$Css$marginBottom(
			$rtfeldman$elm_css$Css$px(10))
		]),
	introText: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(14))
		]),
	linkColor: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$color(
			$rtfeldman$elm_css$Css$hex('2962FF')),
			$rtfeldman$elm_css$Css$textDecoration($rtfeldman$elm_css$Css$underline)
		]),
	modalBody: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(12)),
			$rtfeldman$elm_css$Css$fontWeight(
			$rtfeldman$elm_css$Css$int(400)),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$blueGrey500)
		]),
	modalBodyContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$em(1))
		]),
	modalBtns: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$rowReverse),
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceBetween)
		]),
	modalContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$vw(70)),
			$rtfeldman$elm_css$Css$maxWidth(
			$rtfeldman$elm_css$Css$px(500))
		]),
	modalHeader: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$row),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$flexStart),
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceBetween)
		]),
	modalHeaderTxt: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(20)),
			$rtfeldman$elm_css$Css$fontWeight(
			$rtfeldman$elm_css$Css$int(500))
		]),
	rewardCard: _List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Css$padding2,
			$rtfeldman$elm_css$Css$px(75),
			$rtfeldman$elm_css$Css$px(30)),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(70)),
			$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$backgroundColor($author$project$Material$Styled$Color$white),
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			A2($rtfeldman$elm_css$Css$property, 'box-shadow', '0 0 0 1px rgba(63,63,68,0.05), 0 1px 3px 0 rgba(63,63,68,0.15)')
		]),
	rewardContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$inlineBlock),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(245)),
			A4(
			$rtfeldman$elm_css$Css$margin4,
			$rtfeldman$elm_css$Css$px(25),
			$rtfeldman$elm_css$Css$px(40),
			$rtfeldman$elm_css$Css$px(22),
			$rtfeldman$elm_css$Css$px(0))
		]),
	rewardNameStyles: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontWeight($rtfeldman$elm_css$Css$bold),
			$rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$inlineBlock),
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(35)),
			$rtfeldman$elm_css$Css$marginBottom(
			$rtfeldman$elm_css$Css$px(35))
		]),
	rewardTypeStyles: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(14))
		]),
	tableStyles: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$row),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$flexWrap($rtfeldman$elm_css$Css$wrap)
		])
};
var $author$project$Page$RedeemReward$displayBusinessLink = function (rewardName) {
	return _Utils_eq(rewardName, $author$project$Data$RedeemRewards$BusinessSubscription) ? A2(
		$rtfeldman$elm_css$Html$Styled$a,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$href('https://sign.net/pricing/'),
				$rtfeldman$elm_css$Html$Styled$Attributes$target('_blank')
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$span,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_Utils_ap($author$project$Page$RedeemReward$styles.modalBody, $author$project$Page$RedeemReward$styles.linkColor))
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('Find out more about Business Subscription')
					]))
			])) : $rtfeldman$elm_css$Html$Styled$text('');
};
var $author$project$Page$RedeemReward$displayModalTitle = function (rewardName) {
	switch (rewardName.$) {
		case 'NotariseAlgorand':
			return $rtfeldman$elm_css$Html$Styled$text('Notarise Document on the Algorand Blockchain');
		case 'NotariseBsc':
			return $rtfeldman$elm_css$Html$Styled$text('Notarise Document on the Binance Smart Chain');
		default:
			return $rtfeldman$elm_css$Html$Styled$text('');
	}
};
var $rtfeldman$elm_css$Html$Styled$ol = $rtfeldman$elm_css$Html$Styled$node('ol');
var $author$project$Page$RedeemReward$redeemQuantityText = F3(
	function (quantity, cost, rewardText) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$span,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$RedeemReward$styles.modalBody)
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text(
					'Redeem ' + (quantity + (' ' + (rewardText + (' using ' + ($elm$core$String$fromFloat(
						cost * A2(
							$elm$core$Maybe$withDefault,
							0,
							$elm$core$String$toFloat(quantity))) + ' SIGN Points'))))))
				]));
	});
var $author$project$Data$RedeemRewards$rewardNameToString = F2(
	function (languageSwitchModel, reward) {
		var pointsManagementPageLanguageData = languageSwitchModel.allLanguageData.location.pointsManagement;
		switch (reward.$) {
			case 'BusinessSubscription':
				return 'Business Subscription (1 Month)';
			case 'OrganisationUser':
				return pointsManagementPageLanguageData.addOrganisationUser;
			case 'NotariseBsc':
				return 'Notarise (BSc)';
			case 'NotariseAlgorand':
				return 'Notarise (Algorand)';
			case 'GenerateCredentials':
				return 'Generate Credentials';
			case 'VerifyCredentials':
				return 'Verify Credentials';
			case 'Amazon50Dollar':
				return pointsManagementPageLanguageData.amazonGiftCard;
			case 'Grab50Dollar':
				return '$50 Grab Gift Card';
			default:
				return pointsManagementPageLanguageData.safepalWallet;
		}
	});
var $author$project$Page$RedeemReward$redeemRewardQuantity = F3(
	function (model, authModel, reward) {
		var cost = reward.cost / 100;
		var _v0 = authModel.redeemRewardList;
		var quantity = _v0.quantity;
		var _v1 = authModel;
		var languageChangeModel = _v1.languageChangeModel;
		var _v2 = reward.rewardName;
		switch (_v2.$) {
			case 'BusinessSubscription':
				return A3($author$project$Page$RedeemReward$redeemQuantityText, quantity, cost, 'month(s) of business subscription');
			case 'OrganisationUser':
				return A3($author$project$Page$RedeemReward$redeemQuantityText, quantity, cost, 'month(s) subscription for additional organisation users');
			default:
				return A3(
					$author$project$Page$RedeemReward$redeemQuantityText,
					quantity,
					cost,
					A2($author$project$Data$RedeemRewards$rewardNameToString, model.languageSwitchModel, reward.rewardName));
		}
	});
var $author$project$Page$RedeemReward$modals = F3(
	function (model, authModel, modal) {
		var _v0 = authModel.redeemRewardList;
		var quantity = _v0.quantity;
		var available = _v0.available;
		var quantityError = _v0.quantityError;
		switch (modal.$) {
			case 'SelectRewardQuantity':
				var reward = modal.a;
				var cost = reward.cost / 100;
				var availBal = available / 100;
				return A2(
					$author$project$Material$Styled$Modal$modal,
					_List_fromArray(
						[
							$author$project$Material$Styled$Modal$open(true),
							$author$project$Material$Styled$Modal$contentContainerstyles($author$project$Page$RedeemReward$styles.modalContainer)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$RedeemReward$styles.modalHeader)
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$RedeemReward$styles.modalHeaderTxt)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('Select Reward Quantity')
										]))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$RedeemReward$styles.modalBodyContainer)
								]),
							_List_fromArray(
								[
									A3($author$project$Page$RedeemReward$redeemRewardQuantity, model, authModel, reward),
									A2(
									$author$project$Material$Styled$Input$number,
									_List_fromArray(
										[
											$author$project$Material$Styled$Input$containerStyles($author$project$Page$RedeemReward$styles.field),
											$author$project$Material$Styled$Input$label('Quantity'),
											$author$project$Material$Styled$Input$min('1'),
											$author$project$Material$Styled$Input$onInput(
											A2(
												$elm$core$Basics$composeL,
												A2(
													$elm$core$Basics$composeL,
													A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnRedeemRewardList),
													$author$project$Type$RedeemRewardList$OnRewardQuantity),
												$author$project$Type$RedeemRewardList$Input)),
											$author$project$Material$Styled$Input$onBlur(
											$author$project$Types$OnAuth(
												$author$project$Types$OnRedeemRewardList(
													$author$project$Type$RedeemRewardList$OnRewardQuantity(
														A2($author$project$Type$RedeemRewardList$Blur, availBal, cost))))),
											$author$project$Material$Styled$Input$max(
											$elm$core$String$fromFloat(availBal / cost)),
											$author$project$Material$Styled$Input$value(quantity),
											$author$project$Material$Styled$Input$errorMessage(quantityError)
										]),
									_List_Nil),
									$author$project$Page$RedeemReward$displayBusinessLink(reward.rewardName),
									A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$RedeemReward$styles.modalBtns)
										]),
									_List_fromArray(
										[
											A2(
											$author$project$Material$Styled$Button$button,
											_List_fromArray(
												[
													$author$project$Material$Styled$Button$theme($author$project$Material$Styled$Button$blue),
													$author$project$Material$Styled$Button$styles($author$project$Page$RedeemReward$styles.dashboardBtn),
													$author$project$Material$Styled$Button$onClick(
													$author$project$Types$OnAuth(
														$author$project$Types$OnRedeemRewardList(
															A3($author$project$Type$RedeemRewardList$OnRewardSubmit, reward, availBal, cost))))
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text('Confirm')
												])),
											A2(
											$author$project$Material$Styled$Button$button,
											_List_fromArray(
												[
													$author$project$Material$Styled$Button$theme($author$project$Material$Styled$Button$default),
													$author$project$Material$Styled$Button$styles($author$project$Page$RedeemReward$styles.dashboardBtn),
													$author$project$Material$Styled$Button$onClick(
													$author$project$Types$OnAuth(
														$author$project$Types$OnRedeemRewardList($author$project$Type$RedeemRewardList$OnModalClose)))
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text('Cancel')
												]))
										]))
								]))
						]));
			case 'RewardRedeemed':
				return A2(
					$author$project$Material$Styled$Modal$modal,
					_List_fromArray(
						[
							$author$project$Material$Styled$Modal$open(true),
							$author$project$Material$Styled$Modal$contentContainerstyles($author$project$Page$RedeemReward$styles.modalContainer)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$RedeemReward$styles.modalHeader)
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$RedeemReward$styles.modalHeaderTxt)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('Reward Redeemed')
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$img,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$RedeemReward$styles.icon),
											$rtfeldman$elm_css$Html$Styled$Attributes$src($author$project$View$Theme$images.close),
											$rtfeldman$elm_css$Html$Styled$Events$onClick(
											$author$project$Types$OnAuth(
												$author$project$Types$OnRedeemRewardList($author$project$Type$RedeemRewardList$OnModalClose)))
										]),
									_List_Nil)
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$RedeemReward$styles.modalBodyContainer)
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$RedeemReward$styles.modalBody)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('We have received your request for redemption. A Sign.net representative will contact you via email within 3 working days.')
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$RedeemReward$styles.modalBtns)
										]),
									_List_fromArray(
										[
											A2(
											$author$project$Material$Styled$Button$button,
											_List_fromArray(
												[
													$author$project$Material$Styled$Button$theme($author$project$Material$Styled$Button$blue),
													$author$project$Material$Styled$Button$styles($author$project$Page$RedeemReward$styles.dashboardBtn),
													$author$project$Material$Styled$Button$onClick(
													$author$project$Types$OnAuth(
														$author$project$Types$OnRedeemRewardList($author$project$Type$RedeemRewardList$BackToRewardPoints)))
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text('Back to Reward Points')
												]))
										]))
								]))
						]));
			case 'BlockChainNotarisation':
				var reward = modal.a;
				var blockChain = function () {
					var _v2 = reward.rewardName;
					switch (_v2.$) {
						case 'NotariseBsc':
							return 'Binance Smart Chain.';
						case 'NotariseAlgorand':
							return 'Algorand Blockchain.';
						default:
							return 'None';
					}
				}();
				return A2(
					$author$project$Material$Styled$Modal$modal,
					_List_fromArray(
						[
							$author$project$Material$Styled$Modal$open(true),
							$author$project$Material$Styled$Modal$contentContainerstyles($author$project$Page$RedeemReward$styles.modalContainer)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$RedeemReward$styles.modalHeader)
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$RedeemReward$styles.modalHeaderTxt)
										]),
									_List_fromArray(
										[
											$author$project$Page$RedeemReward$displayModalTitle(reward.rewardName)
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$img,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$RedeemReward$styles.icon),
											$rtfeldman$elm_css$Html$Styled$Attributes$src($author$project$View$Theme$images.close),
											$rtfeldman$elm_css$Html$Styled$Events$onClick(
											$author$project$Types$OnAuth(
												$author$project$Types$OnRedeemRewardList($author$project$Type$RedeemRewardList$OnModalClose)))
										]),
									_List_Nil)
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$RedeemReward$styles.modalBodyContainer)
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$RedeemReward$styles.modalBody)
										]),
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$span,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$RedeemReward$styles.block)
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(
													'It costs ' + ($elm$core$String$fromFloat(reward.cost / 100) + (' SIGN reward points to notarise each document on the ' + blockChain)))
												])),
											A2(
											$rtfeldman$elm_css$Html$Styled$span,
											_List_Nil,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text('Follow these instructions to notarise your selected document:')
												])),
											A2(
											$rtfeldman$elm_css$Html$Styled$ol,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$rtfeldman$elm_css$Html$Styled$li,
													_List_Nil,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$text('From the Menu, select \'My Account\', then select your preferred blockchain network')
														])),
													A2(
													$rtfeldman$elm_css$Html$Styled$li,
													_List_Nil,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$text('To notarise an existing document, go to \'Menu -> select \'Document\' -> select the document -> click \'Notarise Document\'')
														])),
													A2(
													$rtfeldman$elm_css$Html$Styled$li,
													_List_Nil,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$text('For new documents, while setting up the document, select \'Notarise Document\' under Advanced Settings')
														])),
													A2(
													$rtfeldman$elm_css$Html$Styled$li,
													_List_Nil,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$text('Your document will be notarised on the blockchain in less than 1 minute')
														]))
												]))
										]))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$RedeemReward$styles.modalBtns)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Material$Styled$Button$button,
									_List_fromArray(
										[
											$author$project$Material$Styled$Button$theme($author$project$Material$Styled$Button$blue),
											$author$project$Material$Styled$Button$styles($author$project$Page$RedeemReward$styles.dashboardBtn),
											$author$project$Material$Styled$Button$onClick(
											$author$project$Types$OnAuth(
												$author$project$Types$OnRedeemRewardList($author$project$Type$RedeemRewardList$GoToAccount)))
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('Go to My Account')
										]))
								]))
						]));
			case 'GenerateCred':
				return A2(
					$author$project$Material$Styled$Modal$modal,
					_List_fromArray(
						[
							$author$project$Material$Styled$Modal$open(true),
							$author$project$Material$Styled$Modal$contentContainerstyles($author$project$Page$RedeemReward$styles.modalContainer)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$RedeemReward$styles.modalHeader)
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$RedeemReward$styles.modalHeaderTxt)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('Generate Credentials')
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$img,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$RedeemReward$styles.icon),
											$rtfeldman$elm_css$Html$Styled$Attributes$src($author$project$View$Theme$images.close),
											$rtfeldman$elm_css$Html$Styled$Events$onClick(
											$author$project$Types$OnAuth(
												$author$project$Types$OnRedeemRewardList($author$project$Type$RedeemRewardList$OnModalClose)))
										]),
									_List_Nil)
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$RedeemReward$styles.modalBodyContainer)
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$RedeemReward$styles.modalBody)
										]),
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$span,
											_List_Nil,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text('Document will need to be first notarised on the Binance network before you can generate verifiable credentials. This feature is not currently available for documents notarised on other networks.')
												])),
											A2(
											$rtfeldman$elm_css$Html$Styled$ol,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$rtfeldman$elm_css$Html$Styled$li,
													_List_Nil,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$text('For existing documents, select the document and click \'Generate Verifiable Credential\'')
														])),
													A2(
													$rtfeldman$elm_css$Html$Styled$li,
													_List_Nil,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$text('Select the fields that you want to include in the Credential')
														])),
													A2(
													$rtfeldman$elm_css$Html$Styled$li,
													_List_Nil,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$text('Click \'Generate Verifiable Credential\'')
														])),
													A2(
													$rtfeldman$elm_css$Html$Styled$li,
													_List_Nil,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$text('Click on \'View Credentials\' to download the Credential')
														]))
												])),
											A2(
											$rtfeldman$elm_css$Html$Styled$a,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$href('https://youtu.be/ptg_HYyRlSU'),
													$rtfeldman$elm_css$Html$Styled$Attributes$target('_blank')
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text('Watch Video Guide')
												]))
										]))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$RedeemReward$styles.modalBtns)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Material$Styled$Button$button,
									_List_fromArray(
										[
											$author$project$Material$Styled$Button$theme($author$project$Material$Styled$Button$blue),
											$author$project$Material$Styled$Button$styles($author$project$Page$RedeemReward$styles.dashboardBtn),
											$author$project$Material$Styled$Button$onClick(
											$author$project$Types$OnAuth(
												$author$project$Types$OnRedeemRewardList($author$project$Type$RedeemRewardList$GoToDocuments)))
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('Select Document')
										]))
								]))
						]));
			case 'VerifyCred':
				return A2(
					$author$project$Material$Styled$Modal$modal,
					_List_fromArray(
						[
							$author$project$Material$Styled$Modal$open(true),
							$author$project$Material$Styled$Modal$contentContainerstyles($author$project$Page$RedeemReward$styles.modalContainer)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$RedeemReward$styles.modalHeader)
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$RedeemReward$styles.modalHeaderTxt)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('Verify Credentials')
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$img,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$RedeemReward$styles.icon),
											$rtfeldman$elm_css$Html$Styled$Attributes$src($author$project$View$Theme$images.close),
											$rtfeldman$elm_css$Html$Styled$Events$onClick(
											$author$project$Types$OnAuth(
												$author$project$Types$OnRedeemRewardList($author$project$Type$RedeemRewardList$OnModalClose)))
										]),
									_List_Nil)
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$RedeemReward$styles.modalBodyContainer)
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$RedeemReward$styles.modalBody)
										]),
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$ol,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$rtfeldman$elm_css$Html$Styled$li,
													_List_Nil,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$text('Go to My Account -> Select Blockchain network')
														])),
													A2(
													$rtfeldman$elm_css$Html$Styled$li,
													_List_Nil,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$text('From the menu, go to \'Verify Document\'')
														])),
													A2(
													$rtfeldman$elm_css$Html$Styled$li,
													_List_Nil,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$text('Upload a copy of the Document Credential into the box')
														])),
													A2(
													$rtfeldman$elm_css$Html$Styled$li,
													_List_Nil,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$text('If the file is valid, the status of the document will show')
														]))
												]))
										]))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$RedeemReward$styles.modalBtns)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Material$Styled$Button$button,
									_List_fromArray(
										[
											$author$project$Material$Styled$Button$theme($author$project$Material$Styled$Button$blue),
											$author$project$Material$Styled$Button$styles($author$project$Page$RedeemReward$styles.dashboardBtn),
											$author$project$Material$Styled$Button$onClick(
											$author$project$Types$OnAuth(
												$author$project$Types$OnRedeemRewardList($author$project$Type$RedeemRewardList$GoToAccount)))
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('Go to My Account')
										]))
								]))
						]));
			default:
				return $rtfeldman$elm_css$Html$Styled$text('');
		}
	});
var $author$project$Type$RedeemRewardList$OnRewardClick = F2(
	function (a, b) {
		return {$: 'OnRewardClick', a: a, b: b};
	});
var $author$project$Data$RedeemRewards$rewardTypeToString = function (rewardType) {
	switch (rewardType.$) {
		case 'Service':
			return 'Service';
		case 'Voucher':
			return 'Voucher';
		default:
			return 'Product';
	}
};
var $author$project$Page$RedeemReward$rewardsInfo = F2(
	function (languageSwitchModel, reward) {
		return A2(
			$author$project$Material$Styled$Card$card,
			_List_fromArray(
				[
					$author$project$Material$Styled$Card$containerStyles($author$project$Page$RedeemReward$styles.rewardContainer)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_Utils_ap($author$project$Page$RedeemReward$styles.rewardCard, $author$project$Page$RedeemReward$styles.hoverCard)),
							$rtfeldman$elm_css$Html$Styled$Events$onClick(
							$author$project$Types$OnAuth(
								$author$project$Types$OnRedeemRewardList(
									A2($author$project$Type$RedeemRewardList$OnRewardClick, reward.rewardName, reward))))
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$RedeemReward$styles.rewardTypeStyles)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$Data$RedeemRewards$rewardTypeToString(reward.rewardType))
								])),
							A2($rtfeldman$elm_css$Html$Styled$br, _List_Nil, _List_Nil),
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$RedeemReward$styles.rewardNameStyles)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									A2($author$project$Data$RedeemRewards$rewardNameToString, languageSwitchModel, reward.rewardName))
								])),
							A2($rtfeldman$elm_css$Html$Styled$br, _List_Nil, _List_Nil),
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$elm$core$String$fromFloat(reward.cost / 100) + ' SIGN Points')
								])),
							A2($rtfeldman$elm_css$Html$Styled$br, _List_Nil, _List_Nil)
						]))
				]));
	});
var $author$project$Page$RedeemReward$view = F2(
	function (authModel, model) {
		var _v0 = authModel.redeemRewardList;
		var modal = _v0.modal;
		var rewards = _v0.rewards;
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$RedeemReward$styles.container)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$h1,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('Redeem SIGN Rewards')
						])),
					A2(
					$author$project$Material$Styled$Divider$divider,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$RedeemReward$styles.divider)
						]),
					_List_Nil),
					A2(
					$author$project$Material$Styled$Card$card,
					_List_fromArray(
						[
							$author$project$Material$Styled$Card$containerStyles($author$project$Page$RedeemReward$styles.addPadding)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$RedeemReward$styles.introHeader)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Note')
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$RedeemReward$styles.introText)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Redemption Vouchers are available for users in certain countries, depending on local KYC regulations.')
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$RedeemReward$styles.tableStyles)
						]),
					A2(
						$elm$core$List$map,
						$author$project$Page$RedeemReward$rewardsInfo(model.languageSwitchModel),
						rewards)),
					A3($author$project$Page$RedeemReward$modals, model, authModel, modal)
				]));
	});
var $author$project$Page$Register$Business$Success$styles = {
	card: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			A2(
			$rtfeldman$elm_css$Css$margin2,
			$rtfeldman$elm_css$Css$zero,
			$rtfeldman$elm_css$Css$px(20)),
			$rtfeldman$elm_css$Css$paddingBottom(
			$rtfeldman$elm_css$Css$px(40)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100)),
			$rtfeldman$elm_css$Css$maxWidth(
			$rtfeldman$elm_css$Css$px(600))
		]),
	container: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			A2(
			$rtfeldman$elm_css$Css$padding2,
			$rtfeldman$elm_css$Css$px(48),
			$rtfeldman$elm_css$Css$zero)
		]),
	heading: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(24)),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$blueGrey900),
			$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center)
		]),
	linkContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			A3(
				$rtfeldman$elm_css$Css$calc,
				$rtfeldman$elm_css$Css$pct(100),
				$rtfeldman$elm_css$Css$minus,
				$rtfeldman$elm_css$Css$px(48))),
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(16))
		]),
	logo: _List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Css$margin2,
			$rtfeldman$elm_css$Css$px(60),
			$rtfeldman$elm_css$Css$zero),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(150)),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(38))
		]),
	main: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			A3(
				$rtfeldman$elm_css$Css$calc,
				$rtfeldman$elm_css$Css$pct(100),
				$rtfeldman$elm_css$Css$minus,
				$rtfeldman$elm_css$Css$px(48))),
			$rtfeldman$elm_css$Css$padding(
			$rtfeldman$elm_css$Css$px(48)),
			$rtfeldman$elm_css$Css$boxSizing($rtfeldman$elm_css$Css$borderBox),
			A3(
			$rtfeldman$elm_css$Css$borderTop3,
			$rtfeldman$elm_css$Css$px(1),
			$rtfeldman$elm_css$Css$solid,
			$author$project$Material$Styled$Color$grey200),
			A3(
			$rtfeldman$elm_css$Css$borderBottom3,
			$rtfeldman$elm_css$Css$px(1),
			$rtfeldman$elm_css$Css$solid,
			$author$project$Material$Styled$Color$grey200)
		]),
	textContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(14)),
			$rtfeldman$elm_css$Css$lineHeight(
			$rtfeldman$elm_css$Css$px(21)),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$blueGrey900),
			$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$fontWeight(
			$rtfeldman$elm_css$Css$int(400))
		]),
	underline: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$textDecoration($rtfeldman$elm_css$Css$underline)
		])
};
var $author$project$Page$Register$Business$Success$view = A2(
	$rtfeldman$elm_css$Html$Styled$div,
	_List_fromArray(
		[
			$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Register$Business$Success$styles.container)
		]),
	_List_fromArray(
		[
			A2(
			$author$project$Material$Styled$Card$card,
			_List_fromArray(
				[
					$author$project$Material$Styled$Card$containerStyles($author$project$Page$Register$Business$Success$styles.card)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$img,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$src($author$project$View$Theme$images.logoColor),
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Register$Business$Success$styles.logo)
						]),
					_List_Nil),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Register$Business$Success$styles.main)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$h2,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Register$Business$Success$styles.heading)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Activate Account')
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Register$Business$Success$styles.textContainer)
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$p,
									_List_Nil,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('Thank you for creating a business account with Sign.net.')
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$p,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$span,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Register$Business$Success$styles.underline)
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text('Your sign up is not yet complete')
												])),
											$rtfeldman$elm_css$Html$Styled$text(' until you click on the '),
											A2(
											$rtfeldman$elm_css$Html$Styled$strong,
											_List_Nil,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text('email activation link')
												])),
											$rtfeldman$elm_css$Html$Styled$text(' sent to your registered email.')
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$p,
									_List_Nil,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('If you still do not receive an email from us within 24 hours, please check the spam, junk, or promotion sections of your email.')
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$p,
									_List_Nil,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('If you face further issues, please drop us an email at '),
											A2(
											$author$project$Material$Styled$A$a,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$href('mailto:help@sign.net?subject=Activate Account Help'),
													$rtfeldman$elm_css$Html$Styled$Attributes$target('_blank')
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text('help@sign.net')
												])),
											$rtfeldman$elm_css$Html$Styled$text(' and we will get in touch with you.')
										]))
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Register$Business$Success$styles.linkContainer)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Material$Styled$A$a,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$href($author$project$Data$Route$routeUrl.login)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Have an account?')
								]))
						]))
				]))
		]));
var $author$project$Page$Register$Personal$Success$styles = {
	card: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			A2(
			$rtfeldman$elm_css$Css$margin2,
			$rtfeldman$elm_css$Css$zero,
			$rtfeldman$elm_css$Css$px(20)),
			$rtfeldman$elm_css$Css$paddingBottom(
			$rtfeldman$elm_css$Css$px(40)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100)),
			$rtfeldman$elm_css$Css$maxWidth(
			$rtfeldman$elm_css$Css$px(600))
		]),
	container: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			A2(
			$rtfeldman$elm_css$Css$padding2,
			$rtfeldman$elm_css$Css$px(48),
			$rtfeldman$elm_css$Css$zero)
		]),
	heading: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(24)),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$blueGrey900),
			$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center)
		]),
	linkContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			A3(
				$rtfeldman$elm_css$Css$calc,
				$rtfeldman$elm_css$Css$pct(100),
				$rtfeldman$elm_css$Css$minus,
				$rtfeldman$elm_css$Css$px(48))),
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(16))
		]),
	logo: _List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Css$margin2,
			$rtfeldman$elm_css$Css$px(60),
			$rtfeldman$elm_css$Css$zero),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(150)),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(38))
		]),
	main: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			A3(
				$rtfeldman$elm_css$Css$calc,
				$rtfeldman$elm_css$Css$pct(100),
				$rtfeldman$elm_css$Css$minus,
				$rtfeldman$elm_css$Css$px(48))),
			$rtfeldman$elm_css$Css$padding(
			$rtfeldman$elm_css$Css$px(48)),
			$rtfeldman$elm_css$Css$boxSizing($rtfeldman$elm_css$Css$borderBox),
			A3(
			$rtfeldman$elm_css$Css$borderTop3,
			$rtfeldman$elm_css$Css$px(1),
			$rtfeldman$elm_css$Css$solid,
			$author$project$Material$Styled$Color$grey200),
			A3(
			$rtfeldman$elm_css$Css$borderBottom3,
			$rtfeldman$elm_css$Css$px(1),
			$rtfeldman$elm_css$Css$solid,
			$author$project$Material$Styled$Color$grey200)
		]),
	textContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(14)),
			$rtfeldman$elm_css$Css$lineHeight(
			$rtfeldman$elm_css$Css$px(21)),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$blueGrey900),
			$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$fontWeight(
			$rtfeldman$elm_css$Css$int(400))
		]),
	underline: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$textDecoration($rtfeldman$elm_css$Css$underline)
		])
};
var $author$project$Page$Register$Personal$Success$view = function (model) {
	var _v0 = model;
	var email = _v0.email;
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Register$Personal$Success$styles.container)
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Material$Styled$Card$card,
				_List_fromArray(
					[
						$author$project$Material$Styled$Card$containerStyles($author$project$Page$Register$Personal$Success$styles.card)
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$img,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$src($author$project$View$Theme$images.logoColor),
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Register$Personal$Success$styles.logo)
							]),
						_List_Nil),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Register$Personal$Success$styles.main)
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$h2,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Register$Personal$Success$styles.heading)
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('Activate Account')
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Register$Personal$Success$styles.textContainer)
									]),
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$p,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('Thank you for creating an account with Sign.net.')
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$p,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$rtfeldman$elm_css$Html$Styled$span,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Register$Personal$Success$styles.underline)
													]),
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text('Your sign up is not yet complete')
													])),
												$rtfeldman$elm_css$Html$Styled$text(' until you click on the '),
												A2(
												$rtfeldman$elm_css$Html$Styled$strong,
												_List_Nil,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text('email activation link')
													])),
												$rtfeldman$elm_css$Html$Styled$text(
												' sent to your registered email at ' + ($author$project$Model$PersonalRegister$getQueryParamValue(email) + '.'))
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$p,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('If you still do not receive an email from us within the next two minutes, please check the spam, junk, or promotion sections of your email.')
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$p,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('If you face further issues, please drop us an email at '),
												A2(
												$author$project$Material$Styled$A$a,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$Attributes$href('mailto:help@sign.net?subject=Activate Account Help'),
														$rtfeldman$elm_css$Html$Styled$Attributes$target('_blank')
													]),
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text('help@sign.net')
													])),
												$rtfeldman$elm_css$Html$Styled$text(' and we will get in touch with you.')
											]))
									]))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Register$Personal$Success$styles.linkContainer)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Material$Styled$A$a,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$href($author$project$Data$Route$routeUrl.login)
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('Have an account?')
									]))
							]))
					]))
			]));
};
var $author$project$Type$ResendActivation$OnEmailBlur = {$: 'OnEmailBlur'};
var $author$project$Type$ResendActivation$OnEmailInput = function (a) {
	return {$: 'OnEmailInput', a: a};
};
var $author$project$Type$ResendActivation$OnSubmit = {$: 'OnSubmit'};
var $author$project$Data$Api$ResendActivation$errorToString = function (error) {
	return 'Email is already sent. Please check your email and spam folder.';
};
var $author$project$Page$ResendActivation$styles = {
	buttonContainer: _List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Css$margin2,
			$rtfeldman$elm_css$Css$px(16),
			$rtfeldman$elm_css$Css$zero)
		]),
	card: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			A4(
			$rtfeldman$elm_css$Css$margin4,
			$rtfeldman$elm_css$Css$px(48),
			$rtfeldman$elm_css$Css$px(20),
			$rtfeldman$elm_css$Css$zero,
			$rtfeldman$elm_css$Css$px(20)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100)),
			$rtfeldman$elm_css$Css$maxWidth(
			$rtfeldman$elm_css$Css$px(600))
		]),
	container: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center)
		]),
	divider: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			A3(
				$rtfeldman$elm_css$Css$calc,
				$rtfeldman$elm_css$Css$pct(100),
				$rtfeldman$elm_css$Css$minus,
				$rtfeldman$elm_css$Css$px(48)))
		]),
	dividerBottom: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			A3(
				$rtfeldman$elm_css$Css$calc,
				$rtfeldman$elm_css$Css$pct(100),
				$rtfeldman$elm_css$Css$minus,
				$rtfeldman$elm_css$Css$px(48))),
			A2(
			$rtfeldman$elm_css$Css$margin2,
			$rtfeldman$elm_css$Css$px(16),
			$rtfeldman$elm_css$Css$zero)
		]),
	error: _List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Css$margin2,
			$rtfeldman$elm_css$Css$px(20),
			$rtfeldman$elm_css$Css$zero),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$red900),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(14))
		]),
	form: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			A3(
				$rtfeldman$elm_css$Css$calc,
				$rtfeldman$elm_css$Css$pct(100),
				$rtfeldman$elm_css$Css$minus,
				$rtfeldman$elm_css$Css$px(48)))
		]),
	heading: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(24)),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$blueGrey900)
		]),
	inputContainer: _List_Nil,
	linkContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			A3(
				$rtfeldman$elm_css$Css$calc,
				$rtfeldman$elm_css$Css$pct(100),
				$rtfeldman$elm_css$Css$minus,
				$rtfeldman$elm_css$Css$px(48))),
			$rtfeldman$elm_css$Css$paddingBottom(
			$rtfeldman$elm_css$Css$px(20))
		]),
	logo: _List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Css$margin2,
			$rtfeldman$elm_css$Css$px(60),
			$rtfeldman$elm_css$Css$zero),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(150)),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(38))
		]),
	message: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			A3(
				$rtfeldman$elm_css$Css$calc,
				$rtfeldman$elm_css$Css$pct(100),
				$rtfeldman$elm_css$Css$minus,
				$rtfeldman$elm_css$Css$px(48))),
			$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$marginBottom(
			$rtfeldman$elm_css$Css$px(25))
		])
};
var $author$project$Page$ResendActivation$displayFormError = function (form) {
	if (form.$ === 'Error') {
		var error = form.a;
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ResendActivation$styles.error)
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text(
					A2($author$project$Data$Api$errorToString, $author$project$Data$Api$ResendActivation$errorToString, error))
				]));
	} else {
		return $rtfeldman$elm_css$Html$Styled$text('');
	}
};
var $author$project$Page$ResendActivation$submitButton = function (model) {
	var _v0 = model;
	var formStatus = _v0.formStatus;
	var emailError = _v0.emailError;
	switch (formStatus.$) {
		case 'Ready':
			return _Utils_eq(emailError, $elm$core$Maybe$Nothing) ? $author$project$View$SubmitButton$enabled('SEND ACTIVATION') : $author$project$View$SubmitButton$disabled('SEND ACTIVATION');
		case 'Error':
			return $author$project$View$SubmitButton$enabled('SEND ACTIVATION');
		default:
			return $author$project$View$SubmitButton$submitting('SUBMITTING...');
	}
};
var $author$project$Page$ResendActivation$view = function (model) {
	var _v0 = model;
	var formStatus = _v0.formStatus;
	var email = _v0.email;
	var emailError = _v0.emailError;
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ResendActivation$styles.container)
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Material$Styled$Card$card,
				_List_fromArray(
					[
						$author$project$Material$Styled$Card$containerStyles($author$project$Page$ResendActivation$styles.card)
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$img,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$src($author$project$View$Theme$images.logoColor),
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ResendActivation$styles.logo)
							]),
						_List_Nil),
						A2(
						$author$project$Material$Styled$Divider$divider,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ResendActivation$styles.divider)
							]),
						_List_Nil),
						A2(
						$rtfeldman$elm_css$Html$Styled$h2,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ResendActivation$styles.heading)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('Send Email')
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ResendActivation$styles.message)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('If you have not received the activation code upon account sign up, please specify your email here and our system will trigger the request again')
							])),
						$author$project$Page$ResendActivation$displayFormError(formStatus),
						A2(
						$rtfeldman$elm_css$Html$Styled$form,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Events$onSubmit(
								$author$project$Types$OnResendActivation($author$project$Type$ResendActivation$OnSubmit)),
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ResendActivation$styles.form)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Material$Styled$Input$email,
								_List_fromArray(
									[
										$author$project$Material$Styled$Input$containerStyles($author$project$Page$ResendActivation$styles.inputContainer),
										$author$project$Material$Styled$Input$label('Email address'),
										$author$project$Material$Styled$Input$value(email),
										$author$project$Material$Styled$Input$errorMessage(emailError),
										$author$project$Material$Styled$Input$onInput(
										A2($elm$core$Basics$composeL, $author$project$Types$OnResendActivation, $author$project$Type$ResendActivation$OnEmailInput)),
										$author$project$Material$Styled$Input$onBlur(
										$author$project$Types$OnResendActivation($author$project$Type$ResendActivation$OnEmailBlur))
									]),
								_List_Nil),
								A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ResendActivation$styles.buttonContainer)
									]),
								_List_fromArray(
									[
										$author$project$Page$ResendActivation$submitButton(model)
									]))
							])),
						A2(
						$author$project$Material$Styled$Divider$divider,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ResendActivation$styles.dividerBottom)
							]),
						_List_Nil),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ResendActivation$styles.linkContainer)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Material$Styled$A$a,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$href($author$project$Data$Route$routeUrl.login)
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('Back to login')
									]))
							]))
					]))
			]));
};
var $author$project$Page$ResendActivation$EmailSent$styles = {
	card: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			A2(
			$rtfeldman$elm_css$Css$margin2,
			$rtfeldman$elm_css$Css$zero,
			$rtfeldman$elm_css$Css$px(20)),
			$rtfeldman$elm_css$Css$paddingBottom(
			$rtfeldman$elm_css$Css$px(40)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100)),
			$rtfeldman$elm_css$Css$maxWidth(
			$rtfeldman$elm_css$Css$px(600))
		]),
	container: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			A2(
			$rtfeldman$elm_css$Css$padding2,
			$rtfeldman$elm_css$Css$px(48),
			$rtfeldman$elm_css$Css$zero)
		]),
	email: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontStyle($rtfeldman$elm_css$Css$italic),
			$rtfeldman$elm_css$Css$textDecoration($rtfeldman$elm_css$Css$underline)
		]),
	heading: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(24)),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$blueGrey900),
			$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center)
		]),
	linkContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			A3(
				$rtfeldman$elm_css$Css$calc,
				$rtfeldman$elm_css$Css$pct(100),
				$rtfeldman$elm_css$Css$minus,
				$rtfeldman$elm_css$Css$px(48))),
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(16))
		]),
	logo: _List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Css$margin2,
			$rtfeldman$elm_css$Css$px(60),
			$rtfeldman$elm_css$Css$zero),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(150)),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(38))
		]),
	main: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			A3(
				$rtfeldman$elm_css$Css$calc,
				$rtfeldman$elm_css$Css$pct(100),
				$rtfeldman$elm_css$Css$minus,
				$rtfeldman$elm_css$Css$px(48))),
			$rtfeldman$elm_css$Css$padding(
			$rtfeldman$elm_css$Css$px(48)),
			$rtfeldman$elm_css$Css$boxSizing($rtfeldman$elm_css$Css$borderBox),
			A3(
			$rtfeldman$elm_css$Css$borderTop3,
			$rtfeldman$elm_css$Css$px(1),
			$rtfeldman$elm_css$Css$solid,
			$author$project$Material$Styled$Color$grey200),
			A3(
			$rtfeldman$elm_css$Css$borderBottom3,
			$rtfeldman$elm_css$Css$px(1),
			$rtfeldman$elm_css$Css$solid,
			$author$project$Material$Styled$Color$grey200)
		]),
	textContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(14)),
			$rtfeldman$elm_css$Css$lineHeight(
			$rtfeldman$elm_css$Css$px(21)),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$blueGrey900),
			$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$fontWeight(
			$rtfeldman$elm_css$Css$int(400))
		])
};
var $author$project$Page$ResendActivation$EmailSent$view = function (email) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ResendActivation$EmailSent$styles.container)
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Material$Styled$Card$card,
				_List_fromArray(
					[
						$author$project$Material$Styled$Card$containerStyles($author$project$Page$ResendActivation$EmailSent$styles.card)
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$img,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$src($author$project$View$Theme$images.logoColor),
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ResendActivation$EmailSent$styles.logo)
							]),
						_List_Nil),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ResendActivation$EmailSent$styles.main)
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$h2,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ResendActivation$EmailSent$styles.heading)
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('Email Sent')
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ResendActivation$EmailSent$styles.textContainer)
									]),
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$p,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('If an account exists that matches the email '),
												A2(
												$rtfeldman$elm_css$Html$Styled$span,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ResendActivation$EmailSent$styles.email)
													]),
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text(email)
													])),
												$rtfeldman$elm_css$Html$Styled$text(', an email with instructions to activate the account will be sent to that account. Please ensure you keyed in the right email address.')
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$p,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('If you still do not receive an email from us within the next five minutes, please also check your email spam folder and drop us an email at '),
												A2(
												$author$project$Material$Styled$A$a,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$Attributes$href('mailto:help@sign.net?subject=Reset Password Help'),
														$rtfeldman$elm_css$Html$Styled$Attributes$target('_blank')
													]),
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text('help@sign.net')
													]))
											]))
									]))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ResendActivation$EmailSent$styles.linkContainer)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Material$Styled$A$a,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$href($author$project$Data$Route$routeUrl.login)
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('Back to login page')
									]))
							]))
					]))
			]));
};
var $author$project$Type$ResetPassword$OnEmailBlur = {$: 'OnEmailBlur'};
var $author$project$Type$ResetPassword$OnEmailInput = function (a) {
	return {$: 'OnEmailInput', a: a};
};
var $author$project$Type$ResetPassword$OnSubmit = {$: 'OnSubmit'};
var $author$project$Data$Api$ResetPassword$errorToString = function (error) {
	return 'Email is already sent. Please check your email and spam folder.';
};
var $author$project$Page$ResetPassword$styles = {
	buttonContainer: _List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Css$margin2,
			$rtfeldman$elm_css$Css$px(16),
			$rtfeldman$elm_css$Css$zero)
		]),
	card: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			A4(
			$rtfeldman$elm_css$Css$margin4,
			$rtfeldman$elm_css$Css$px(48),
			$rtfeldman$elm_css$Css$px(20),
			$rtfeldman$elm_css$Css$zero,
			$rtfeldman$elm_css$Css$px(20)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100)),
			$rtfeldman$elm_css$Css$maxWidth(
			$rtfeldman$elm_css$Css$px(600))
		]),
	container: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center)
		]),
	divider: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			A3(
				$rtfeldman$elm_css$Css$calc,
				$rtfeldman$elm_css$Css$pct(100),
				$rtfeldman$elm_css$Css$minus,
				$rtfeldman$elm_css$Css$px(48)))
		]),
	dividerBottom: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			A3(
				$rtfeldman$elm_css$Css$calc,
				$rtfeldman$elm_css$Css$pct(100),
				$rtfeldman$elm_css$Css$minus,
				$rtfeldman$elm_css$Css$px(48))),
			A2(
			$rtfeldman$elm_css$Css$margin2,
			$rtfeldman$elm_css$Css$px(16),
			$rtfeldman$elm_css$Css$zero)
		]),
	error: _List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Css$margin2,
			$rtfeldman$elm_css$Css$px(20),
			$rtfeldman$elm_css$Css$zero),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$red900),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(14))
		]),
	form: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			A3(
				$rtfeldman$elm_css$Css$calc,
				$rtfeldman$elm_css$Css$pct(100),
				$rtfeldman$elm_css$Css$minus,
				$rtfeldman$elm_css$Css$px(48)))
		]),
	heading: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(24)),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$blueGrey900)
		]),
	inputContainer: _List_Nil,
	linkContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			A3(
				$rtfeldman$elm_css$Css$calc,
				$rtfeldman$elm_css$Css$pct(100),
				$rtfeldman$elm_css$Css$minus,
				$rtfeldman$elm_css$Css$px(48))),
			$rtfeldman$elm_css$Css$paddingBottom(
			$rtfeldman$elm_css$Css$px(20))
		]),
	logo: _List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Css$margin2,
			$rtfeldman$elm_css$Css$px(60),
			$rtfeldman$elm_css$Css$zero),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(150)),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(38))
		]),
	message: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			A3(
				$rtfeldman$elm_css$Css$calc,
				$rtfeldman$elm_css$Css$pct(100),
				$rtfeldman$elm_css$Css$minus,
				$rtfeldman$elm_css$Css$px(48))),
			$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$marginBottom(
			$rtfeldman$elm_css$Css$px(25))
		])
};
var $author$project$Page$ResetPassword$displayFormError = function (form) {
	if (form.$ === 'Error') {
		var error = form.a;
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ResetPassword$styles.error)
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text(
					A2($author$project$Data$Api$errorToString, $author$project$Data$Api$ResetPassword$errorToString, error))
				]));
	} else {
		return $rtfeldman$elm_css$Html$Styled$text('');
	}
};
var $author$project$Page$ResetPassword$submitButton = function (model) {
	var _v0 = model;
	var formStatus = _v0.formStatus;
	var emailError = _v0.emailError;
	switch (formStatus.$) {
		case 'Ready':
			return _Utils_eq(emailError, $elm$core$Maybe$Nothing) ? $author$project$View$SubmitButton$enabled('RESET PASSWORD') : $author$project$View$SubmitButton$disabled('RESET PASSWORD');
		case 'Error':
			return $author$project$View$SubmitButton$enabled('RESET PASSWORD');
		default:
			return $author$project$View$SubmitButton$submitting('SUBMITTING...');
	}
};
var $author$project$Page$ResetPassword$view = function (model) {
	var _v0 = model;
	var formStatus = _v0.formStatus;
	var email = _v0.email;
	var emailError = _v0.emailError;
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ResetPassword$styles.container)
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Material$Styled$Card$card,
				_List_fromArray(
					[
						$author$project$Material$Styled$Card$containerStyles($author$project$Page$ResetPassword$styles.card)
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$img,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$src($author$project$View$Theme$images.logoColor),
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ResetPassword$styles.logo)
							]),
						_List_Nil),
						A2(
						$author$project$Material$Styled$Divider$divider,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ResetPassword$styles.divider)
							]),
						_List_Nil),
						A2(
						$rtfeldman$elm_css$Html$Styled$h2,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ResetPassword$styles.heading)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('Reset Password')
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ResetPassword$styles.message)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('In order to trigger a password reset request, please provide us with the email account you used when signing up. A password reset email will then be sent with further instructions. ')
							])),
						$author$project$Page$ResetPassword$displayFormError(formStatus),
						A2(
						$rtfeldman$elm_css$Html$Styled$form,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Events$onSubmit(
								$author$project$Types$OnResetPassword($author$project$Type$ResetPassword$OnSubmit)),
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ResetPassword$styles.form)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Material$Styled$Input$email,
								_List_fromArray(
									[
										$author$project$Material$Styled$Input$containerStyles($author$project$Page$ResetPassword$styles.inputContainer),
										$author$project$Material$Styled$Input$label('Email address'),
										$author$project$Material$Styled$Input$value(email),
										$author$project$Material$Styled$Input$errorMessage(emailError),
										$author$project$Material$Styled$Input$onInput(
										A2($elm$core$Basics$composeL, $author$project$Types$OnResetPassword, $author$project$Type$ResetPassword$OnEmailInput)),
										$author$project$Material$Styled$Input$onBlur(
										$author$project$Types$OnResetPassword($author$project$Type$ResetPassword$OnEmailBlur))
									]),
								_List_Nil),
								A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ResetPassword$styles.buttonContainer)
									]),
								_List_fromArray(
									[
										$author$project$Page$ResetPassword$submitButton(model)
									]))
							])),
						A2(
						$author$project$Material$Styled$Divider$divider,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ResetPassword$styles.dividerBottom)
							]),
						_List_Nil),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ResetPassword$styles.linkContainer)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Material$Styled$A$a,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$href($author$project$Data$Route$routeUrl.login)
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('Back to login')
									]))
							]))
					]))
			]));
};
var $author$project$Page$ResetPassword$EmailSent$styles = {
	card: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			A2(
			$rtfeldman$elm_css$Css$margin2,
			$rtfeldman$elm_css$Css$zero,
			$rtfeldman$elm_css$Css$px(20)),
			$rtfeldman$elm_css$Css$paddingBottom(
			$rtfeldman$elm_css$Css$px(40)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100)),
			$rtfeldman$elm_css$Css$maxWidth(
			$rtfeldman$elm_css$Css$px(600))
		]),
	container: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			A2(
			$rtfeldman$elm_css$Css$padding2,
			$rtfeldman$elm_css$Css$px(48),
			$rtfeldman$elm_css$Css$zero)
		]),
	email: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontStyle($rtfeldman$elm_css$Css$italic),
			$rtfeldman$elm_css$Css$textDecoration($rtfeldman$elm_css$Css$underline)
		]),
	heading: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(24)),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$blueGrey900),
			$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center)
		]),
	linkContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			A3(
				$rtfeldman$elm_css$Css$calc,
				$rtfeldman$elm_css$Css$pct(100),
				$rtfeldman$elm_css$Css$minus,
				$rtfeldman$elm_css$Css$px(48))),
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(16))
		]),
	logo: _List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Css$margin2,
			$rtfeldman$elm_css$Css$px(60),
			$rtfeldman$elm_css$Css$zero),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(150)),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(38))
		]),
	main: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			A3(
				$rtfeldman$elm_css$Css$calc,
				$rtfeldman$elm_css$Css$pct(100),
				$rtfeldman$elm_css$Css$minus,
				$rtfeldman$elm_css$Css$px(48))),
			$rtfeldman$elm_css$Css$padding(
			$rtfeldman$elm_css$Css$px(48)),
			$rtfeldman$elm_css$Css$boxSizing($rtfeldman$elm_css$Css$borderBox),
			A3(
			$rtfeldman$elm_css$Css$borderTop3,
			$rtfeldman$elm_css$Css$px(1),
			$rtfeldman$elm_css$Css$solid,
			$author$project$Material$Styled$Color$grey200),
			A3(
			$rtfeldman$elm_css$Css$borderBottom3,
			$rtfeldman$elm_css$Css$px(1),
			$rtfeldman$elm_css$Css$solid,
			$author$project$Material$Styled$Color$grey200)
		]),
	textContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(14)),
			$rtfeldman$elm_css$Css$lineHeight(
			$rtfeldman$elm_css$Css$px(21)),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$blueGrey900),
			$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$fontWeight(
			$rtfeldman$elm_css$Css$int(400))
		])
};
var $author$project$Page$ResetPassword$EmailSent$view = function (email) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ResetPassword$EmailSent$styles.container)
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Material$Styled$Card$card,
				_List_fromArray(
					[
						$author$project$Material$Styled$Card$containerStyles($author$project$Page$ResetPassword$EmailSent$styles.card)
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$img,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$src($author$project$View$Theme$images.logoColor),
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ResetPassword$EmailSent$styles.logo)
							]),
						_List_Nil),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ResetPassword$EmailSent$styles.main)
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$h2,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ResetPassword$EmailSent$styles.heading)
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('Email Sent')
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ResetPassword$EmailSent$styles.textContainer)
									]),
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$p,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('If an account exists that matches the email '),
												A2(
												$rtfeldman$elm_css$Html$Styled$span,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ResetPassword$EmailSent$styles.email)
													]),
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text(email)
													])),
												$rtfeldman$elm_css$Html$Styled$text(', an email with instructions to reset the account password will be sent to that account. Please ensure you keyed in the right email address.')
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$p,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('If you still do not receive an email from us within the next five minutes, please also check your email spam folder and drop us an email at '),
												A2(
												$author$project$Material$Styled$A$a,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$Attributes$href('mailto:help@sign.net?subject=Reset Password Help'),
														$rtfeldman$elm_css$Html$Styled$Attributes$target('_blank')
													]),
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text('help@sign.net')
													]))
											]))
									]))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ResetPassword$EmailSent$styles.linkContainer)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Material$Styled$A$a,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$href($author$project$Data$Route$routeUrl.login)
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('Back to login page')
									]))
							]))
					]))
			]));
};
var $author$project$Page$ResetPassword$Success$styles = {
	card: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			A2(
			$rtfeldman$elm_css$Css$margin2,
			$rtfeldman$elm_css$Css$zero,
			$rtfeldman$elm_css$Css$px(20)),
			$rtfeldman$elm_css$Css$paddingBottom(
			$rtfeldman$elm_css$Css$px(40)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100)),
			$rtfeldman$elm_css$Css$maxWidth(
			$rtfeldman$elm_css$Css$px(600))
		]),
	container: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			A2(
			$rtfeldman$elm_css$Css$padding2,
			$rtfeldman$elm_css$Css$px(48),
			$rtfeldman$elm_css$Css$zero)
		]),
	email: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontStyle($rtfeldman$elm_css$Css$italic),
			$rtfeldman$elm_css$Css$textDecoration($rtfeldman$elm_css$Css$underline)
		]),
	heading: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(24)),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$blueGrey900),
			$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center)
		]),
	linkContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			A3(
				$rtfeldman$elm_css$Css$calc,
				$rtfeldman$elm_css$Css$pct(100),
				$rtfeldman$elm_css$Css$minus,
				$rtfeldman$elm_css$Css$px(48))),
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(16))
		]),
	logo: _List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Css$margin2,
			$rtfeldman$elm_css$Css$px(60),
			$rtfeldman$elm_css$Css$zero),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(150)),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(38))
		]),
	main: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			A3(
				$rtfeldman$elm_css$Css$calc,
				$rtfeldman$elm_css$Css$pct(100),
				$rtfeldman$elm_css$Css$minus,
				$rtfeldman$elm_css$Css$px(48))),
			$rtfeldman$elm_css$Css$padding(
			$rtfeldman$elm_css$Css$px(48)),
			$rtfeldman$elm_css$Css$boxSizing($rtfeldman$elm_css$Css$borderBox),
			A3(
			$rtfeldman$elm_css$Css$borderTop3,
			$rtfeldman$elm_css$Css$px(1),
			$rtfeldman$elm_css$Css$solid,
			$author$project$Material$Styled$Color$grey200),
			A3(
			$rtfeldman$elm_css$Css$borderBottom3,
			$rtfeldman$elm_css$Css$px(1),
			$rtfeldman$elm_css$Css$solid,
			$author$project$Material$Styled$Color$grey200)
		]),
	textContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(14)),
			$rtfeldman$elm_css$Css$lineHeight(
			$rtfeldman$elm_css$Css$px(21)),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$blueGrey900),
			$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$fontWeight(
			$rtfeldman$elm_css$Css$int(400))
		])
};
var $author$project$Page$ResetPassword$Success$view = A2(
	$rtfeldman$elm_css$Html$Styled$div,
	_List_fromArray(
		[
			$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ResetPassword$Success$styles.container)
		]),
	_List_fromArray(
		[
			A2(
			$author$project$Material$Styled$Card$card,
			_List_fromArray(
				[
					$author$project$Material$Styled$Card$containerStyles($author$project$Page$ResetPassword$Success$styles.card)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$img,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$src($author$project$View$Theme$images.logoColor),
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ResetPassword$Success$styles.logo)
						]),
					_List_Nil),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ResetPassword$Success$styles.main)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$h2,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ResetPassword$Success$styles.heading)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Reset Password Successful')
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ResetPassword$Success$styles.textContainer)
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$p,
									_List_Nil,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('Your password is reset successfully. '),
											$rtfeldman$elm_css$Html$Styled$text('Please login with your new password.')
										]))
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ResetPassword$Success$styles.linkContainer)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Material$Styled$A$a,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$href($author$project$Data$Route$routeUrl.login)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Back to login page')
								]))
						]))
				]))
		]));
var $author$project$Page$ResetPassword$Update$styles = {
	buttonContainer: _List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Css$margin2,
			$rtfeldman$elm_css$Css$px(16),
			$rtfeldman$elm_css$Css$zero)
		]),
	card: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			A4(
			$rtfeldman$elm_css$Css$margin4,
			$rtfeldman$elm_css$Css$px(48),
			$rtfeldman$elm_css$Css$px(20),
			$rtfeldman$elm_css$Css$zero,
			$rtfeldman$elm_css$Css$px(20)),
			$rtfeldman$elm_css$Css$paddingBottom(
			$rtfeldman$elm_css$Css$px(40)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100)),
			$rtfeldman$elm_css$Css$maxWidth(
			$rtfeldman$elm_css$Css$px(600))
		]),
	container: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center)
		]),
	divider: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			A3(
				$rtfeldman$elm_css$Css$calc,
				$rtfeldman$elm_css$Css$pct(100),
				$rtfeldman$elm_css$Css$minus,
				$rtfeldman$elm_css$Css$px(48)))
		]),
	dividerBottom: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			A3(
				$rtfeldman$elm_css$Css$calc,
				$rtfeldman$elm_css$Css$pct(100),
				$rtfeldman$elm_css$Css$minus,
				$rtfeldman$elm_css$Css$px(48))),
			A2(
			$rtfeldman$elm_css$Css$margin2,
			$rtfeldman$elm_css$Css$px(16),
			$rtfeldman$elm_css$Css$zero)
		]),
	error: _List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Css$margin2,
			$rtfeldman$elm_css$Css$px(20),
			$rtfeldman$elm_css$Css$zero),
			$rtfeldman$elm_css$Css$width(
			A3(
				$rtfeldman$elm_css$Css$calc,
				$rtfeldman$elm_css$Css$pct(100),
				$rtfeldman$elm_css$Css$minus,
				$rtfeldman$elm_css$Css$px(48))),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$red900),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(14)),
			$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center)
		]),
	form: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			A3(
				$rtfeldman$elm_css$Css$calc,
				$rtfeldman$elm_css$Css$pct(100),
				$rtfeldman$elm_css$Css$minus,
				$rtfeldman$elm_css$Css$px(48)))
		]),
	heading: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(24)),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$blueGrey900)
		]),
	inputContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginBottom(
			$rtfeldman$elm_css$Css$px(20))
		]),
	linkContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			A3(
				$rtfeldman$elm_css$Css$calc,
				$rtfeldman$elm_css$Css$pct(100),
				$rtfeldman$elm_css$Css$minus,
				$rtfeldman$elm_css$Css$px(48))),
			$rtfeldman$elm_css$Css$paddingBottom(
			$rtfeldman$elm_css$Css$px(60))
		]),
	logo: _List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Css$margin2,
			$rtfeldman$elm_css$Css$px(60),
			$rtfeldman$elm_css$Css$zero),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(150)),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(38))
		]),
	main: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			A3(
				$rtfeldman$elm_css$Css$calc,
				$rtfeldman$elm_css$Css$pct(100),
				$rtfeldman$elm_css$Css$minus,
				$rtfeldman$elm_css$Css$px(48))),
			$rtfeldman$elm_css$Css$padding(
			$rtfeldman$elm_css$Css$px(48)),
			$rtfeldman$elm_css$Css$boxSizing($rtfeldman$elm_css$Css$borderBox),
			A3(
			$rtfeldman$elm_css$Css$borderTop3,
			$rtfeldman$elm_css$Css$px(1),
			$rtfeldman$elm_css$Css$solid,
			$author$project$Material$Styled$Color$grey200),
			A3(
			$rtfeldman$elm_css$Css$borderBottom3,
			$rtfeldman$elm_css$Css$px(1),
			$rtfeldman$elm_css$Css$solid,
			$author$project$Material$Styled$Color$grey200)
		]),
	textContainer: _List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Css$padding2,
			$rtfeldman$elm_css$Css$zero,
			$rtfeldman$elm_css$Css$px(40)),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(14)),
			$rtfeldman$elm_css$Css$lineHeight(
			$rtfeldman$elm_css$Css$px(21)),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$blueGrey900),
			$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$fontWeight(
			$rtfeldman$elm_css$Css$int(400))
		])
};
var $author$project$Page$ResetPassword$Update$invalidView = A2(
	$rtfeldman$elm_css$Html$Styled$div,
	_List_fromArray(
		[
			$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ResetPassword$Update$styles.container)
		]),
	_List_fromArray(
		[
			A2(
			$author$project$Material$Styled$Card$card,
			_List_fromArray(
				[
					$author$project$Material$Styled$Card$containerStyles($author$project$Page$ResetPassword$Update$styles.card)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$img,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$src($author$project$View$Theme$images.logoColor),
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ResetPassword$Update$styles.logo)
						]),
					_List_Nil),
					A2(
					$author$project$Material$Styled$Divider$divider,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ResetPassword$Update$styles.divider)
						]),
					_List_Nil),
					A2(
					$rtfeldman$elm_css$Html$Styled$h2,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ResetPassword$Update$styles.heading)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('Invalid Token')
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ResetPassword$Update$styles.textContainer)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$p,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Please ensure that you have clicked on the link in your email properly or '),
									$rtfeldman$elm_css$Html$Styled$text('you have copied and paste the link correctly.')
								]))
						])),
					A2(
					$author$project$Material$Styled$Divider$divider,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ResetPassword$Update$styles.dividerBottom)
						]),
					_List_Nil),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ResetPassword$Update$styles.linkContainer)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Material$Styled$A$a,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$href($author$project$Data$Route$routeUrl.login)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Back to login page')
								]))
						]))
				]))
		]));
var $author$project$Type$SetPassword$OnBlur = function (a) {
	return {$: 'OnBlur', a: a};
};
var $author$project$Type$SetPassword$OnInput = F2(
	function (a, b) {
		return {$: 'OnInput', a: a, b: b};
	});
var $author$project$Type$SetPassword$OnSubmit = function (a) {
	return {$: 'OnSubmit', a: a};
};
var $author$project$Type$SetPassword$Password = {$: 'Password'};
var $author$project$Type$SetPassword$PasswordAgain = {$: 'PasswordAgain'};
var $author$project$Data$Api$SetPassword$errorToString = function (error) {
	switch (error.$) {
		case 'TOKEN_EXPIRED':
			return 'Token has expired. Please request for another password reset.';
		case 'PASSWORD_REQUIREMENT':
			return 'Password must contain at least 8 characters, a lowercase letter, an uppercase letter and a number.';
		default:
			return 'Token is invalid. Please ensure that you have clicked on the link in your email properly or you have copied and paste the link correctly.';
	}
};
var $author$project$Page$ResetPassword$Update$displayFormError = function (form) {
	if (form.$ === 'Error') {
		var error = form.a;
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ResetPassword$Update$styles.error)
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text(
					A2($author$project$Data$Api$errorToString, $author$project$Data$Api$SetPassword$errorToString, error))
				]));
	} else {
		return $rtfeldman$elm_css$Html$Styled$text('');
	}
};
var $author$project$Page$ResetPassword$Update$submitButton = function (model) {
	var hasError = A2(
		$elm$core$List$any,
		$elm$core$Basics$neq($elm$core$Maybe$Nothing),
		_List_fromArray(
			[model.passwordError, model.passwordAgainError]));
	var _v0 = model;
	var formStatus = _v0.formStatus;
	switch (formStatus.$) {
		case 'Ready':
			return hasError ? $author$project$View$SubmitButton$disabled('UPDATE PASSWORD') : $author$project$View$SubmitButton$enabled('UPDATE PASSWORD');
		case 'Error':
			return $author$project$View$SubmitButton$enabled('UPDATE PASSWORD');
		default:
			return $author$project$View$SubmitButton$submitting('UPDATING');
	}
};
var $author$project$Page$ResetPassword$Update$updatePasswordView = F2(
	function (token, model) {
		var _v0 = model;
		var formStatus = _v0.formStatus;
		var password = _v0.password;
		var passwordError = _v0.passwordError;
		var passwordAgain = _v0.passwordAgain;
		var passwordAgainError = _v0.passwordAgainError;
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ResetPassword$Update$styles.container)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Material$Styled$Card$card,
					_List_fromArray(
						[
							$author$project$Material$Styled$Card$containerStyles($author$project$Page$ResetPassword$Update$styles.card)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$img,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$src($author$project$View$Theme$images.logoColor),
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ResetPassword$Update$styles.logo)
								]),
							_List_Nil),
							A2(
							$author$project$Material$Styled$Divider$divider,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ResetPassword$Update$styles.divider)
								]),
							_List_Nil),
							A2(
							$rtfeldman$elm_css$Html$Styled$h2,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ResetPassword$Update$styles.heading)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Update Password')
								])),
							$author$project$Page$ResetPassword$Update$displayFormError(formStatus),
							A2(
							$rtfeldman$elm_css$Html$Styled$form,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Events$onSubmit(
									$author$project$Types$OnSetPassword(
										$author$project$Type$SetPassword$OnSubmit(token))),
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ResetPassword$Update$styles.form)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Material$Styled$Input$password,
									_List_fromArray(
										[
											$author$project$Material$Styled$Input$containerStyles($author$project$Page$ResetPassword$Update$styles.inputContainer),
											$author$project$Material$Styled$Input$label('Password *'),
											$author$project$Material$Styled$Input$value(password),
											$author$project$Material$Styled$Input$infoMessage('Password must contain at least 8 characters, a lowercase letter,\nan uppercase letter and a number'),
											$author$project$Material$Styled$Input$errorMessage(passwordError),
											$author$project$Material$Styled$Input$onInput(
											A2(
												$elm$core$Basics$composeL,
												$author$project$Types$OnSetPassword,
												$author$project$Type$SetPassword$OnInput($author$project$Type$SetPassword$Password))),
											$author$project$Material$Styled$Input$onBlur(
											$author$project$Types$OnSetPassword(
												$author$project$Type$SetPassword$OnBlur($author$project$Type$SetPassword$Password)))
										]),
									_List_Nil),
									A2(
									$author$project$Material$Styled$Input$password,
									_List_fromArray(
										[
											$author$project$Material$Styled$Input$containerStyles($author$project$Page$ResetPassword$Update$styles.inputContainer),
											$author$project$Material$Styled$Input$label('Confirm Password *'),
											$author$project$Material$Styled$Input$value(passwordAgain),
											$author$project$Material$Styled$Input$errorMessage(passwordAgainError),
											$author$project$Material$Styled$Input$onInput(
											A2(
												$elm$core$Basics$composeL,
												$author$project$Types$OnSetPassword,
												$author$project$Type$SetPassword$OnInput($author$project$Type$SetPassword$PasswordAgain))),
											$author$project$Material$Styled$Input$onBlur(
											$author$project$Types$OnSetPassword(
												$author$project$Type$SetPassword$OnBlur($author$project$Type$SetPassword$PasswordAgain)))
										]),
									_List_Nil),
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ResetPassword$Update$styles.buttonContainer)
										]),
									_List_fromArray(
										[
											$author$project$Page$ResetPassword$Update$submitButton(model)
										]))
								])),
							A2(
							$author$project$Material$Styled$Divider$divider,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ResetPassword$Update$styles.dividerBottom)
								]),
							_List_Nil),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ResetPassword$Update$styles.linkContainer)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Material$Styled$A$a,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$href($author$project$Data$Route$routeUrl.login)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('Back to login page')
										]))
								]))
						]))
				]));
	});
var $author$project$Page$ResetPassword$Update$view = F2(
	function (maybeToken, model) {
		if (maybeToken.$ === 'Just') {
			var token = maybeToken.a;
			return A2($author$project$Page$ResetPassword$Update$updatePasswordView, token, model);
		} else {
			return $author$project$Page$ResetPassword$Update$invalidView;
		}
	});
var $author$project$Type$Setting$Leave = {$: 'Leave'};
var $author$project$Type$Setting$OnDefaultNotariseHover = function (a) {
	return {$: 'OnDefaultNotariseHover', a: a};
};
var $author$project$Type$Setting$OnStampsHover = function (a) {
	return {$: 'OnStampsHover', a: a};
};
var $author$project$Page$Setting$styles = {
	container: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$flexStart),
			$rtfeldman$elm_css$Css$flexWrap($rtfeldman$elm_css$Css$wrap)
		]),
	coverImage: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(180)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100)),
			$rtfeldman$elm_css$Css$backgroundImage(
			$rtfeldman$elm_css$Css$url($author$project$View$Theme$images.trustScoreCover)),
			$rtfeldman$elm_css$Css$backgroundRepeat($rtfeldman$elm_css$Css$noRepeat),
			$rtfeldman$elm_css$Css$backgroundSize($rtfeldman$elm_css$Css$cover),
			A2(
			$rtfeldman$elm_css$Css$backgroundPosition2,
			$rtfeldman$elm_css$Css$pct(66),
			$rtfeldman$elm_css$Css$pct(100)),
			A2(
			$rtfeldman$elm_css$Css$Media$withMediaQuery,
			_List_fromArray(
				['screen and (max-width: 800px) and (min-width: 600px)']),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Css$backgroundPosition2,
					$rtfeldman$elm_css$Css$pct(70),
					$rtfeldman$elm_css$Css$pct(100))
				])),
			A2(
			$rtfeldman$elm_css$Css$Media$withMediaQuery,
			_List_fromArray(
				['screen and (max-width: 600px)']),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Css$backgroundPosition2,
					$rtfeldman$elm_css$Css$pct(10),
					$rtfeldman$elm_css$Css$pct(100))
				]))
		]),
	header: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100))
		]),
	iconStyles: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$paddingTop(
			$rtfeldman$elm_css$Css$px(2))
		]),
	leftContainer: _List_fromArray(
		[
			A3(
			$rtfeldman$elm_css$Css$flex3,
			$rtfeldman$elm_css$Css$num(1),
			$rtfeldman$elm_css$Css$num(0),
			$rtfeldman$elm_css$Css$px(240)),
			A4(
			$rtfeldman$elm_css$Css$margin4,
			$rtfeldman$elm_css$Css$px(4),
			$rtfeldman$elm_css$Css$px(20),
			$rtfeldman$elm_css$Css$px(20),
			$rtfeldman$elm_css$Css$px(20)),
			$rtfeldman$elm_css$Css$maxWidth(
			$rtfeldman$elm_css$Css$px(900)),
			A2(
			$rtfeldman$elm_css$Css$Media$withMediaQuery,
			_List_fromArray(
				['screen and (min-width: 1440px)']),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$maxWidth(
					$rtfeldman$elm_css$Css$px(300))
				]))
		]),
	rightContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$flexStart),
			$rtfeldman$elm_css$Css$margin(
			$rtfeldman$elm_css$Css$px(20)),
			$rtfeldman$elm_css$Css$maxWidth(
			$rtfeldman$elm_css$Css$px(900)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100))
		]),
	toolTipText: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(11))
		])
};
var $author$project$Type$Setting$OnCopyReferralCodeClick = F2(
	function (a, b) {
		return {$: 'OnCopyReferralCodeClick', a: a, b: b};
	});
var $rtfeldman$elm_css$Css$alignSelf = function (fn) {
	return A3(
		$rtfeldman$elm_css$Css$Internal$getOverloadedProperty,
		'alignSelf',
		'align-self',
		fn($rtfeldman$elm_css$Css$Internal$lengthForOverloadedProperty));
};
var $author$project$Page$Setting$ApiKey$styles = {
	anotherContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$row)
		]),
	buttonStyle: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(37)),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(53)),
			A2(
			$rtfeldman$elm_css$Css$padding2,
			$rtfeldman$elm_css$Css$px(7),
			$rtfeldman$elm_css$Css$px(7)),
			$rtfeldman$elm_css$Css$marginLeft(
			$rtfeldman$elm_css$Css$px(10))
		]),
	container: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			A4(
			$rtfeldman$elm_css$Css$padding4,
			$rtfeldman$elm_css$Css$px(30),
			$rtfeldman$elm_css$Css$px(20),
			$rtfeldman$elm_css$Css$px(10),
			$rtfeldman$elm_css$Css$px(20)),
			$rtfeldman$elm_css$Css$alignSelf($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(95))
		]),
	inputContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginBottom(
			$rtfeldman$elm_css$Css$px(20)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100))
		]),
	referralCode: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(14))
		])
};
var $author$project$Page$Setting$ApiKey$copyApiKey = F3(
	function (profileModel, title, apiKey) {
		var timeout = 3;
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Setting$ApiKey$styles.anotherContainer)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Material$Styled$Input$text,
					_List_fromArray(
						[
							$author$project$Material$Styled$Input$label(title),
							$author$project$Material$Styled$Input$containerStyles($author$project$Page$Setting$ApiKey$styles.inputContainer),
							$author$project$Material$Styled$Input$value(apiKey),
							$author$project$Material$Styled$Input$disabled(true)
						]),
					_List_Nil),
					A2(
					$author$project$Material$Styled$Button$button,
					_List_fromArray(
						[
							$author$project$Material$Styled$Button$styles($author$project$Page$Setting$ApiKey$styles.buttonStyle),
							$author$project$Material$Styled$Button$onClick(
							$author$project$Types$OnAuth(
								$author$project$Types$OnSetting(
									A2($author$project$Type$Setting$OnCopyReferralCodeClick, apiKey, timeout))))
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Material$Styled$Snackbar$snackbar,
							_List_fromArray(
								[
									$author$project$Material$Styled$Snackbar$Theme($author$project$Material$Styled$Snackbar$secondary),
									$author$project$Material$Styled$Snackbar$Timeout(timeout),
									$author$project$Material$Styled$Snackbar$Status(profileModel.referralCodeSnackbarStatus)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Copied to Clipboard')
								])),
							A2($author$project$Material$Styled$Icon$copyReferralCode, _List_Nil, _List_Nil)
						]))
				]));
	});
var $author$project$Page$Setting$ApiKey$view = F3(
	function (model, authModel, apiKeys) {
		var accountSettingsLanguageData = model.languageSwitchModel.allLanguageData.location.accountSettingsPage;
		var _v0 = authModel;
		var settingModel = _v0.settingModel;
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Setting$ApiKey$styles.container)
				]),
			A2(
				$elm$core$List$map,
				A2($author$project$Page$Setting$ApiKey$copyApiKey, settingModel.profile, accountSettingsLanguageData.personalApiKey),
				apiKeys));
	});
var $author$project$Page$Setting$apiKeyCardView = F3(
	function (model, authModel, settingModel) {
		var accountSettingsLanguageData = model.languageSwitchModel.allLanguageData.location.accountSettingsPage;
		var _v0 = settingModel;
		var apiKeys = _v0.apiKeys;
		return $elm$core$List$isEmpty(apiKeys) ? A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil) : A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Setting$styles.container)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Setting$styles.leftContainer)
						]),
					_List_Nil),
					A2(
					$author$project$Material$Styled$Card$card,
					_List_fromArray(
						[
							$author$project$Material$Styled$Card$headerText(accountSettingsLanguageData.apiKeysHeader),
							$author$project$Material$Styled$Card$containerStyles($author$project$Page$Setting$styles.rightContainer)
						]),
					_List_fromArray(
						[
							A3($author$project$Page$Setting$ApiKey$view, model, authModel, apiKeys)
						]))
				]));
	});
var $author$project$Type$BusinessCreate$OnOpen = {$: 'OnOpen'};
var $author$project$Page$Setting$Business$styles = {
	actions: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100)),
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(16)),
			$rtfeldman$elm_css$Css$boxSizing($rtfeldman$elm_css$Css$borderBox)
		]),
	bottomhalfCard: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceBetween),
			$rtfeldman$elm_css$Css$flexWrap($rtfeldman$elm_css$Css$wrap),
			A2(
			$rtfeldman$elm_css$Css$padding2,
			$rtfeldman$elm_css$Css$px(16),
			$rtfeldman$elm_css$Css$px(0))
		]),
	button: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$maxWidth($rtfeldman$elm_css$Css$fitContent)
		]),
	container: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100)),
			A2(
			$rtfeldman$elm_css$Css$padding2,
			$rtfeldman$elm_css$Css$px(16),
			$rtfeldman$elm_css$Css$px(20)),
			$rtfeldman$elm_css$Css$boxSizing($rtfeldman$elm_css$Css$borderBox)
		]),
	divider: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100))
		]),
	textBox: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$boxSizing($rtfeldman$elm_css$Css$borderBox),
			A2(
			$rtfeldman$elm_css$Css$padding2,
			$rtfeldman$elm_css$Css$px(0),
			$rtfeldman$elm_css$Css$px(20))
		]),
	topHalfCard: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceBetween),
			A2(
			$rtfeldman$elm_css$Css$padding2,
			$rtfeldman$elm_css$Css$px(5),
			$rtfeldman$elm_css$Css$px(20))
		])
};
var $author$project$Type$BusinessCreate$CompanyName = {$: 'CompanyName'};
var $author$project$Type$BusinessCreate$OnBlur = function (a) {
	return {$: 'OnBlur', a: a};
};
var $author$project$Type$BusinessCreate$OnClose = {$: 'OnClose'};
var $author$project$Type$BusinessCreate$OnInput = F2(
	function (a, b) {
		return {$: 'OnInput', a: a, b: b};
	});
var $author$project$Type$BusinessCreate$OnSubmit = {$: 'OnSubmit'};
var $author$project$Type$BusinessCreate$Subdomain = {$: 'Subdomain'};
var $author$project$Material$Styled$Button$SubmitType = {$: 'SubmitType'};
var $rtfeldman$elm_css$Html$Styled$h3 = $rtfeldman$elm_css$Html$Styled$node('h3');
var $author$project$View$BusinessCreate$styles = {
	baseUrlBox: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$paddingTop(
			$rtfeldman$elm_css$Css$px(35))
		]),
	button: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginLeft(
			$rtfeldman$elm_css$Css$px(8)),
			$rtfeldman$elm_css$Css$maxWidth($rtfeldman$elm_css$Css$fitContent)
		]),
	container: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$maxWidth(
			$rtfeldman$elm_css$Css$px(500))
		]),
	field: _List_fromArray(
		[
			A3(
			$rtfeldman$elm_css$Css$flex3,
			$rtfeldman$elm_css$Css$num(1),
			$rtfeldman$elm_css$Css$num(1),
			$rtfeldman$elm_css$Css$pct(45))
		]),
	fieldBox: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$row),
			$rtfeldman$elm_css$Css$flex(
			$rtfeldman$elm_css$Css$num(1)),
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(8)),
			$rtfeldman$elm_css$Css$minWidth(
			$rtfeldman$elm_css$Css$px(160))
		]),
	form: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(20)),
			$rtfeldman$elm_css$Css$overflowX($rtfeldman$elm_css$Css$hidden)
		]),
	formActions: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$flexEnd),
			A2(
			$rtfeldman$elm_css$Css$padding2,
			$rtfeldman$elm_css$Css$px(20),
			$rtfeldman$elm_css$Css$px(0))
		]),
	formContent: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			A2(
			$rtfeldman$elm_css$Css$padding2,
			$rtfeldman$elm_css$Css$px(8),
			$rtfeldman$elm_css$Css$px(0))
		]),
	header: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceBetween)
		]),
	icon: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$boxShadow($rtfeldman$elm_css$Css$none),
			$rtfeldman$elm_css$Css$transform(
			A2(
				$rtfeldman$elm_css$Css$translate2,
				$rtfeldman$elm_css$Css$px(20),
				$rtfeldman$elm_css$Css$px(-15))),
			$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer),
			$rtfeldman$elm_css$Css$padding(
			$rtfeldman$elm_css$Css$px(10))
		])
};
var $author$project$View$BusinessCreate$submitButton = function (model) {
	var hasError = A2(
		$elm$core$List$any,
		$elm$core$Basics$neq($elm$core$Maybe$Nothing),
		_List_fromArray(
			[model.companyNameError, model.subdomainError]));
	var _v0 = model;
	var formStatus = _v0.formStatus;
	var subdomainStatus = _v0.subdomainStatus;
	var validStatus = A2(
		$elm$core$Maybe$withDefault,
		false,
		A2(
			$elm$core$Maybe$map,
			function (status) {
				return _Utils_eq(status, $author$project$Data$Api$Register$ValidateDomain$NotUse);
			},
			subdomainStatus));
	switch (formStatus.$) {
		case 'Ready':
			return (hasError || (!validStatus)) ? _Utils_Tuple2(true, 'Create') : _Utils_Tuple2(false, 'Create');
		case 'Error':
			return _Utils_Tuple2(false, 'Create');
		default:
			return _Utils_Tuple2(true, 'Creating...');
	}
};
var $author$project$View$BusinessCreate$view = F2(
	function (model, baseUrl) {
		var _v0 = $author$project$View$BusinessCreate$submitButton(model);
		var buttonDisabled = _v0.a;
		var buttonText = _v0.b;
		return A2(
			$author$project$Material$Styled$Modal$modal,
			_List_fromArray(
				[
					$author$project$Material$Styled$Modal$open(model.isModalOpen),
					$author$project$Material$Styled$Modal$contentContainerstyles($author$project$View$BusinessCreate$styles.container),
					$author$project$Material$Styled$Modal$onClose(
					$author$project$Types$OnAuth(
						$author$project$Types$OnBusinessCreate($author$project$Type$BusinessCreate$OnClose)))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$BusinessCreate$styles.header)
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$h3,
									_List_Nil,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('Add a Business')
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$img,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$BusinessCreate$styles.icon),
											$rtfeldman$elm_css$Html$Styled$Attributes$src($author$project$View$Theme$images.close),
											$rtfeldman$elm_css$Html$Styled$Events$onClick(
											$author$project$Types$OnAuth(
												$author$project$Types$OnBusinessCreate($author$project$Type$BusinessCreate$OnClose)))
										]),
									_List_Nil)
								])),
							$rtfeldman$elm_css$Html$Styled$text('Get started with a 45 day free trial of the Sign.net Business Plan with instant activation. To proceed, we will need you to select a subdomain (yourname.sign.net) which will become your company\'s unique digital front office for interacting with end users, manage organization users as well as setting up powerful workflow templates.')
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$form,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$BusinessCreate$styles.form),
							$rtfeldman$elm_css$Html$Styled$Events$onSubmit(
							$author$project$Types$OnAuth(
								$author$project$Types$OnBusinessCreate($author$project$Type$BusinessCreate$OnSubmit)))
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$BusinessCreate$styles.formContent)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Material$Styled$Input$text,
									_List_fromArray(
										[
											$author$project$Material$Styled$Input$containerStyles($author$project$View$BusinessCreate$styles.field),
											$author$project$Material$Styled$Input$label('Company Name'),
											$author$project$Material$Styled$Input$onInput(
											A2(
												$elm$core$Basics$composeL,
												A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnBusinessCreate),
												$author$project$Type$BusinessCreate$OnInput($author$project$Type$BusinessCreate$CompanyName))),
											$author$project$Material$Styled$Input$value(model.companyName),
											$author$project$Material$Styled$Input$onBlur(
											A3(
												$elm$core$Basics$composeL,
												$author$project$Types$OnAuth,
												$author$project$Types$OnBusinessCreate,
												$author$project$Type$BusinessCreate$OnBlur($author$project$Type$BusinessCreate$CompanyName))),
											$author$project$Material$Styled$Input$errorMessage(model.companyNameError)
										]),
									_List_Nil),
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$BusinessCreate$styles.fieldBox)
										]),
									_List_fromArray(
										[
											A2(
											$author$project$Material$Styled$Input$text,
											_List_fromArray(
												[
													$author$project$Material$Styled$Input$containerStyles($author$project$View$BusinessCreate$styles.field),
													$author$project$Material$Styled$Input$label('Subdomain'),
													$author$project$Material$Styled$Input$onInput(
													A2(
														$elm$core$Basics$composeL,
														A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnBusinessCreate),
														$author$project$Type$BusinessCreate$OnInput($author$project$Type$BusinessCreate$Subdomain))),
													$author$project$Material$Styled$Input$value(model.subdomain),
													$author$project$Material$Styled$Input$onBlur(
													A3(
														$elm$core$Basics$composeL,
														$author$project$Types$OnAuth,
														$author$project$Types$OnBusinessCreate,
														$author$project$Type$BusinessCreate$OnBlur($author$project$Type$BusinessCreate$Subdomain))),
													$author$project$Material$Styled$Input$errorMessage(model.subdomainError)
												]),
											_List_Nil),
											A2(
											$rtfeldman$elm_css$Html$Styled$span,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$BusinessCreate$styles.baseUrlBox)
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text('.' + baseUrl)
												]))
										]))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$View$BusinessCreate$styles.formActions)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Material$Styled$Button$button,
									_List_fromArray(
										[
											$author$project$Material$Styled$Button$styles($author$project$View$BusinessCreate$styles.button),
											$author$project$Material$Styled$Button$buttonType($author$project$Material$Styled$Button$SubmitType),
											$author$project$Material$Styled$Button$disabled(buttonDisabled),
											$author$project$Material$Styled$Button$theme(
											buttonDisabled ? $author$project$Material$Styled$Button$grey : $author$project$Material$Styled$Button$blue)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(buttonText)
										]))
								]))
						]))
				]));
	});
var $author$project$Page$Setting$Business$view = F3(
	function (languageSwitchModel, businessCreateModel, baseUrl) {
		var accountSettingsLanguageData = languageSwitchModel.allLanguageData.location.accountSettingsPage;
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Setting$Business$styles.container)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Material$Styled$Card$card,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Setting$Business$styles.topHalfCard)
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$h4,
									_List_Nil,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('$29 USD / ' + accountSettingsLanguageData.month)
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$h5,
									_List_Nil,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(accountSettingsLanguageData.businessPlan)
										]))
								])),
							A2(
							$author$project$Material$Styled$Divider$divider,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Setting$Business$styles.divider)
								]),
							_List_Nil),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Setting$Business$styles.bottomhalfCard)
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Setting$Business$styles.textBox)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(accountSettingsLanguageData.trialDays),
											A2($rtfeldman$elm_css$Html$Styled$br, _List_Nil, _List_Nil),
											$rtfeldman$elm_css$Html$Styled$text(accountSettingsLanguageData.cancelAnytime)
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Setting$Business$styles.textBox)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(accountSettingsLanguageData.signSecurely),
											A2($rtfeldman$elm_css$Html$Styled$br, _List_Nil, _List_Nil),
											$rtfeldman$elm_css$Html$Styled$text(accountSettingsLanguageData.sendUnlimtedDocs)
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Setting$Business$styles.textBox)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(accountSettingsLanguageData.sendPDFforms),
											A2($rtfeldman$elm_css$Html$Styled$br, _List_Nil, _List_Nil),
											$rtfeldman$elm_css$Html$Styled$text(accountSettingsLanguageData.addOrganisationUser)
										]))
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Setting$Business$styles.actions)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Material$Styled$Button$button,
							_List_fromArray(
								[
									$author$project$Material$Styled$Button$styles($author$project$Page$Setting$Business$styles.button),
									$author$project$Material$Styled$Button$onClick(
									$author$project$Types$OnAuth(
										$author$project$Types$OnBusinessCreate($author$project$Type$BusinessCreate$OnOpen)))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Add Business')
								]))
						])),
					A2($author$project$View$BusinessCreate$view, businessCreateModel, baseUrl)
				]));
	});
var $author$project$Type$Setting$DefaultNotariseOff = {$: 'DefaultNotariseOff'};
var $author$project$Type$Setting$DefaultNotariseOn = {$: 'DefaultNotariseOn'};
var $author$project$Type$Setting$OnDefaultNotarisationSubmit = {$: 'OnDefaultNotarisationSubmit'};
var $author$project$Type$Setting$RadioBtnClick = function (a) {
	return {$: 'RadioBtnClick', a: a};
};
var $author$project$Page$Setting$DefaultNotarisation$convertDefaultNotarisation = function (option) {
	return option ? 'On' : 'Off';
};
var $author$project$Material$Styled$RadioButton$styles = {
	radioBtn: _List_fromArray(
		[
			A4(
			$rtfeldman$elm_css$Css$padding4,
			$rtfeldman$elm_css$Css$px(10),
			$rtfeldman$elm_css$Css$px(10),
			$rtfeldman$elm_css$Css$px(15),
			$rtfeldman$elm_css$Css$px(5))
		])
};
var $author$project$Material$Styled$RadioButton$radio = F3(
	function (value, isChecked, msg) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$label,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Material$Styled$RadioButton$styles.radioBtn)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$input,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$type_('radio'),
							$rtfeldman$elm_css$Html$Styled$Events$onClick(msg),
							$rtfeldman$elm_css$Html$Styled$Attributes$checked(isChecked)
						]),
					_List_Nil),
					$rtfeldman$elm_css$Html$Styled$text(value)
				]));
	});
var $author$project$Page$Setting$DefaultNotarisation$radioButtonIsChecked = F2(
	function (checkBtn, currentSelectedValue) {
		switch (checkBtn.$) {
			case 'DefaultNotariseOn':
				return currentSelectedValue;
			case 'DefaultNotariseOff':
				return !currentSelectedValue;
			default:
				return false;
		}
	});
var $author$project$Type$Setting$CloseBanner = function (a) {
	return {$: 'CloseBanner', a: a};
};
var $author$project$Type$Setting$DefaultNotarisationBanner = {$: 'DefaultNotarisationBanner'};
var $author$project$Page$Setting$DefaultNotarisation$renderBanner = function (banner) {
	switch (banner.$) {
		case 'Submitted':
			return A2(
				$author$project$Material$Styled$Banner$banner,
				_List_fromArray(
					[
						$author$project$Material$Styled$Banner$theme($author$project$Material$Styled$Banner$successTheme),
						$author$project$Material$Styled$Banner$body(
						$rtfeldman$elm_css$Html$Styled$text('- Changes Saved')),
						$author$project$Material$Styled$Banner$title('Update Success'),
						$author$project$Material$Styled$Banner$closeIconAttributes(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Svg$Styled$Events$onClick(
								$author$project$Types$OnAuth(
									$author$project$Types$OnSetting(
										$author$project$Type$Setting$CloseBanner($author$project$Type$Setting$DefaultNotarisationBanner))))
							]))
					]),
				_List_Nil);
		case 'Error':
			var message = banner.a;
			return A2(
				$author$project$Material$Styled$Banner$banner,
				_List_fromArray(
					[
						$author$project$Material$Styled$Banner$theme($author$project$Material$Styled$Banner$errorTheme),
						$author$project$Material$Styled$Banner$body(
						$rtfeldman$elm_css$Html$Styled$text('- ' + message)),
						$author$project$Material$Styled$Banner$title('Error message'),
						$author$project$Material$Styled$Banner$closeIconAttributes(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Svg$Styled$Events$onClick(
								$author$project$Types$OnAuth(
									$author$project$Types$OnSetting(
										$author$project$Type$Setting$CloseBanner($author$project$Type$Setting$DefaultNotarisationBanner))))
							]))
					]),
				_List_Nil);
		default:
			return $rtfeldman$elm_css$Html$Styled$text('');
	}
};
var $author$project$Page$Setting$DefaultNotarisation$styles = {
	notarisationNetworkTxt: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(-5)),
			$rtfeldman$elm_css$Css$marginBottom(
			$rtfeldman$elm_css$Css$px(15))
		]),
	outerContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100))
		]),
	paymentRadioBtnContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$flexStart),
			A2(
			$rtfeldman$elm_css$Css$margin2,
			$rtfeldman$elm_css$Css$px(0),
			$rtfeldman$elm_css$Css$px(10)),
			$rtfeldman$elm_css$Css$maxWidth(
			$rtfeldman$elm_css$Css$px(900)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100))
		]),
	rightContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$flexStart),
			$rtfeldman$elm_css$Css$margin(
			$rtfeldman$elm_css$Css$px(20)),
			$rtfeldman$elm_css$Css$maxWidth(
			$rtfeldman$elm_css$Css$px(900)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100))
		])
};
var $author$project$Page$Setting$DefaultNotarisation$view = F2(
	function (authModel, model) {
		var accountSettingsLanguageData = model.languageSwitchModel.allLanguageData.location.accountSettingsPage;
		var _v0 = authModel;
		var settingModel = _v0.settingModel;
		var user = _v0.user;
		var usersNotarisationDefaultOption = 'Current chosen option: ' + $author$project$Page$Setting$DefaultNotarisation$convertDefaultNotarisation(user.notariseByDefault);
		var _v1 = settingModel;
		var notarisationNetworkInfo = _v1.notarisationNetworkInfo;
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Setting$DefaultNotarisation$styles.outerContainer)
				]),
			_List_fromArray(
				[
					$author$project$Page$Setting$DefaultNotarisation$renderBanner(notarisationNetworkInfo.updateDefaultNotarisation),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Setting$DefaultNotarisation$styles.rightContainer)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Setting$DefaultNotarisation$styles.notarisationNetworkTxt)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(usersNotarisationDefaultOption)
								])),
							A3(
							$author$project$Material$Styled$RadioButton$radio,
							' On',
							A2($author$project$Page$Setting$DefaultNotarisation$radioButtonIsChecked, $author$project$Type$Setting$DefaultNotariseOn, notarisationNetworkInfo.defaultNotarisation),
							$author$project$Types$OnAuth(
								$author$project$Types$OnSetting(
									$author$project$Type$Setting$RadioBtnClick($author$project$Type$Setting$DefaultNotariseOn)))),
							A3(
							$author$project$Material$Styled$RadioButton$radio,
							' Off',
							A2($author$project$Page$Setting$DefaultNotarisation$radioButtonIsChecked, $author$project$Type$Setting$DefaultNotariseOff, notarisationNetworkInfo.defaultNotarisation),
							$author$project$Types$OnAuth(
								$author$project$Types$OnSetting(
									$author$project$Type$Setting$RadioBtnClick($author$project$Type$Setting$DefaultNotariseOff)))),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Material$Styled$Button$button,
									_List_fromArray(
										[
											$author$project$Material$Styled$Button$theme($author$project$Material$Styled$Button$blue),
											$author$project$Material$Styled$Button$onClick(
											$author$project$Types$OnAuth(
												$author$project$Types$OnSetting($author$project$Type$Setting$OnDefaultNotarisationSubmit)))
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(accountSettingsLanguageData.saveChanges)
										]))
								]))
						]))
				]));
	});
var $author$project$Type$Setting$AlgorandRadioBtn = {$: 'AlgorandRadioBtn'};
var $author$project$Type$Setting$BinanceRadioBtn = {$: 'BinanceRadioBtn'};
var $author$project$Type$Setting$OnNetworkChangeSubmit = {$: 'OnNetworkChangeSubmit'};
var $author$project$Page$Setting$NotarisationNetwork$radioButtonIsChecked = F2(
	function (check, currentNotarisationNetwork) {
		switch (check.$) {
			case 'BinanceRadioBtn':
				return _Utils_eq(currentNotarisationNetwork, $author$project$Type$Setting$Binance);
			case 'AlgorandRadioBtn':
				return _Utils_eq(currentNotarisationNetwork, $author$project$Type$Setting$Algorand);
			case 'SystemSignPointsBalance':
				return _Utils_eq(currentNotarisationNetwork, $author$project$Type$Setting$Algorand);
			case 'UserWallet':
				return _Utils_eq(currentNotarisationNetwork, $author$project$Type$Setting$Algorand);
			case 'WalletConnectBtn':
				return _Utils_eq(currentNotarisationNetwork, $author$project$Type$Setting$Algorand);
			default:
				return false;
		}
	});
var $author$project$Type$Setting$NotarisationNetworkBanner = {$: 'NotarisationNetworkBanner'};
var $author$project$Page$Setting$NotarisationNetwork$renderBanner = function (banner) {
	switch (banner.$) {
		case 'Submitted':
			return A2(
				$author$project$Material$Styled$Banner$banner,
				_List_fromArray(
					[
						$author$project$Material$Styled$Banner$theme($author$project$Material$Styled$Banner$successTheme),
						$author$project$Material$Styled$Banner$body(
						$rtfeldman$elm_css$Html$Styled$text('- Changes Saved')),
						$author$project$Material$Styled$Banner$title('Update Success'),
						$author$project$Material$Styled$Banner$closeIconAttributes(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Svg$Styled$Events$onClick(
								$author$project$Types$OnAuth(
									$author$project$Types$OnSetting(
										$author$project$Type$Setting$CloseBanner($author$project$Type$Setting$NotarisationNetworkBanner))))
							]))
					]),
				_List_Nil);
		case 'Error':
			var message = banner.a;
			return A2(
				$author$project$Material$Styled$Banner$banner,
				_List_fromArray(
					[
						$author$project$Material$Styled$Banner$theme($author$project$Material$Styled$Banner$errorTheme),
						$author$project$Material$Styled$Banner$body(
						$rtfeldman$elm_css$Html$Styled$text('- ' + message)),
						$author$project$Material$Styled$Banner$title('Error message'),
						$author$project$Material$Styled$Banner$closeIconAttributes(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Svg$Styled$Events$onClick(
								$author$project$Types$OnAuth(
									$author$project$Types$OnSetting(
										$author$project$Type$Setting$CloseBanner($author$project$Type$Setting$NotarisationNetworkBanner))))
							]))
					]),
				_List_Nil);
		default:
			return $rtfeldman$elm_css$Html$Styled$text('');
	}
};
var $author$project$Page$Setting$NotarisationNetwork$styles = {
	notarisationNetworkTxt: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(-5)),
			$rtfeldman$elm_css$Css$marginBottom(
			$rtfeldman$elm_css$Css$px(15))
		]),
	outerContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100))
		]),
	paymentRadioBtnContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$flexStart),
			A2(
			$rtfeldman$elm_css$Css$margin2,
			$rtfeldman$elm_css$Css$px(0),
			$rtfeldman$elm_css$Css$px(10)),
			$rtfeldman$elm_css$Css$maxWidth(
			$rtfeldman$elm_css$Css$px(900)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100))
		]),
	rightContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$flexStart),
			$rtfeldman$elm_css$Css$margin(
			$rtfeldman$elm_css$Css$px(20)),
			$rtfeldman$elm_css$Css$maxWidth(
			$rtfeldman$elm_css$Css$px(900)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100))
		])
};
var $author$project$Page$Setting$NotarisationNetwork$view = F2(
	function (authModel, model) {
		var accountSettingsLanguageData = model.languageSwitchModel.allLanguageData.location.accountSettingsPage;
		var _v0 = authModel;
		var settingModel = _v0.settingModel;
		var user = _v0.user;
		var usersNotarisationNetwork = accountSettingsLanguageData.currentChosenNetwork + (': ' + user.notarisationNetwork);
		var _v1 = settingModel;
		var notarisationNetworkInfo = _v1.notarisationNetworkInfo;
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Setting$NotarisationNetwork$styles.outerContainer)
				]),
			_List_fromArray(
				[
					$author$project$Page$Setting$NotarisationNetwork$renderBanner(notarisationNetworkInfo.updateStatus),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Setting$NotarisationNetwork$styles.rightContainer)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Setting$NotarisationNetwork$styles.notarisationNetworkTxt)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(usersNotarisationNetwork)
								])),
							A3(
							$author$project$Material$Styled$RadioButton$radio,
							' Binance Smart Chain',
							A2($author$project$Page$Setting$NotarisationNetwork$radioButtonIsChecked, $author$project$Type$Setting$BinanceRadioBtn, notarisationNetworkInfo.currentNetwork),
							$author$project$Types$OnAuth(
								$author$project$Types$OnSetting(
									$author$project$Type$Setting$RadioBtnClick($author$project$Type$Setting$BinanceRadioBtn)))),
							A3(
							$author$project$Material$Styled$RadioButton$radio,
							' Algorand Blockchain',
							A2($author$project$Page$Setting$NotarisationNetwork$radioButtonIsChecked, $author$project$Type$Setting$AlgorandRadioBtn, notarisationNetworkInfo.currentNetwork),
							$author$project$Types$OnAuth(
								$author$project$Types$OnSetting(
									$author$project$Type$Setting$RadioBtnClick($author$project$Type$Setting$AlgorandRadioBtn)))),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Material$Styled$Button$button,
									_List_fromArray(
										[
											$author$project$Material$Styled$Button$theme($author$project$Material$Styled$Button$blue),
											$author$project$Material$Styled$Button$onClick(
											$author$project$Types$OnAuth(
												$author$project$Types$OnSetting($author$project$Type$Setting$OnNetworkChangeSubmit)))
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(accountSettingsLanguageData.saveChanges)
										]))
								]))
						]))
				]));
	});
var $author$project$Type$Setting$OnPaymentMethodSubmit = {$: 'OnPaymentMethodSubmit'};
var $author$project$Type$Setting$SystemSignPointsBalance = {$: 'SystemSignPointsBalance'};
var $author$project$Type$Setting$UserWallet = {$: 'UserWallet'};
var $author$project$Type$Setting$WalletConnectBtn = {$: 'WalletConnectBtn'};
var $author$project$Page$Setting$PaymentMethod$paymentMethodTxt = function (paymentMethod) {
	switch (paymentMethod) {
		case 'systemBalance':
			return 'System Balance';
		case 'algoWallet':
			return 'MyAlgo Wallet';
		case 'walletConnect':
			return 'Algorand Wallet';
		default:
			return 'System Balance';
	}
};
var $author$project$Page$Setting$PaymentMethod$paymentRadioButtonIsChecked = F2(
	function (check, currentUserPaymentMethod) {
		switch (check.$) {
			case 'SystemSignPointsBalance':
				return _Utils_eq(currentUserPaymentMethod, $author$project$Type$Setting$SystemBalance);
			case 'UserWallet':
				return _Utils_eq(currentUserPaymentMethod, $author$project$Type$Setting$AlgoWallet);
			case 'WalletConnectBtn':
				return _Utils_eq(currentUserPaymentMethod, $author$project$Type$Setting$WalletConnect);
			default:
				return _Utils_eq(currentUserPaymentMethod, $author$project$Type$Setting$SystemBalance);
		}
	});
var $author$project$Page$Setting$PaymentMethod$radioButtonIsChecked = F2(
	function (check, currentNotarisationNetwork) {
		switch (check.$) {
			case 'BinanceRadioBtn':
				return _Utils_eq(currentNotarisationNetwork, $author$project$Type$Setting$Binance);
			case 'AlgorandRadioBtn':
				return _Utils_eq(currentNotarisationNetwork, $author$project$Type$Setting$Algorand);
			default:
				return _Utils_eq(currentNotarisationNetwork, $author$project$Type$Setting$Algorand);
		}
	});
var $author$project$Type$Setting$PaymentMethodBanner = {$: 'PaymentMethodBanner'};
var $author$project$Page$Setting$PaymentMethod$renderBanner = function (banner) {
	switch (banner.$) {
		case 'Submitted':
			return A2(
				$author$project$Material$Styled$Banner$banner,
				_List_fromArray(
					[
						$author$project$Material$Styled$Banner$theme($author$project$Material$Styled$Banner$successTheme),
						$author$project$Material$Styled$Banner$body(
						$rtfeldman$elm_css$Html$Styled$text('- Changes Saved')),
						$author$project$Material$Styled$Banner$title('Update Success'),
						$author$project$Material$Styled$Banner$closeIconAttributes(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Svg$Styled$Events$onClick(
								$author$project$Types$OnAuth(
									$author$project$Types$OnSetting(
										$author$project$Type$Setting$CloseBanner($author$project$Type$Setting$PaymentMethodBanner))))
							]))
					]),
				_List_Nil);
		case 'Error':
			var message = banner.a;
			return A2(
				$author$project$Material$Styled$Banner$banner,
				_List_fromArray(
					[
						$author$project$Material$Styled$Banner$theme($author$project$Material$Styled$Banner$errorTheme),
						$author$project$Material$Styled$Banner$body(
						$rtfeldman$elm_css$Html$Styled$text('- ' + message)),
						$author$project$Material$Styled$Banner$title('Error message'),
						$author$project$Material$Styled$Banner$closeIconAttributes(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Svg$Styled$Events$onClick(
								$author$project$Types$OnAuth(
									$author$project$Types$OnSetting(
										$author$project$Type$Setting$CloseBanner($author$project$Type$Setting$PaymentMethodBanner))))
							]))
					]),
				_List_Nil);
		default:
			return $rtfeldman$elm_css$Html$Styled$text('');
	}
};
var $author$project$Page$Setting$PaymentMethod$styles = {
	notarisationNetworkTxt: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(-5)),
			$rtfeldman$elm_css$Css$marginBottom(
			$rtfeldman$elm_css$Css$px(15))
		]),
	outerContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100))
		]),
	paymentRadioBtnContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$flexStart),
			A2(
			$rtfeldman$elm_css$Css$margin2,
			$rtfeldman$elm_css$Css$px(0),
			$rtfeldman$elm_css$Css$px(10)),
			$rtfeldman$elm_css$Css$maxWidth(
			$rtfeldman$elm_css$Css$px(900)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100))
		]),
	rightContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$flexStart),
			$rtfeldman$elm_css$Css$margin(
			$rtfeldman$elm_css$Css$px(20)),
			$rtfeldman$elm_css$Css$maxWidth(
			$rtfeldman$elm_css$Css$px(900)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100))
		])
};
var $author$project$Page$Setting$PaymentMethod$view = F2(
	function (authModel, model) {
		var accountSettingsLanguageData = model.languageSwitchModel.allLanguageData.location.accountSettingsPage;
		var _v0 = authModel;
		var settingModel = _v0.settingModel;
		var user = _v0.user;
		var usersNotarisationNetwork = accountSettingsLanguageData.currentPaymentMethod + (': ' + $author$project$Page$Setting$PaymentMethod$paymentMethodTxt(user.paymentMethod));
		var _v1 = settingModel;
		var notarisationNetworkInfo = _v1.notarisationNetworkInfo;
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Setting$PaymentMethod$styles.outerContainer)
				]),
			_List_fromArray(
				[
					$author$project$Page$Setting$PaymentMethod$renderBanner(notarisationNetworkInfo.updatePayment),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Setting$PaymentMethod$styles.rightContainer)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Setting$PaymentMethod$styles.notarisationNetworkTxt)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(usersNotarisationNetwork)
								])),
							A2($author$project$Page$Setting$PaymentMethod$radioButtonIsChecked, $author$project$Type$Setting$AlgorandRadioBtn, notarisationNetworkInfo.currentNetwork) ? A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Setting$PaymentMethod$styles.paymentRadioBtnContainer)
								]),
							_List_fromArray(
								[
									A3(
									$author$project$Material$Styled$RadioButton$radio,
									' System Balance',
									A2($author$project$Page$Setting$PaymentMethod$paymentRadioButtonIsChecked, $author$project$Type$Setting$SystemSignPointsBalance, notarisationNetworkInfo.paymentMethod),
									$author$project$Types$OnAuth(
										$author$project$Types$OnSetting(
											$author$project$Type$Setting$RadioBtnClick($author$project$Type$Setting$SystemSignPointsBalance)))),
									A3(
									$author$project$Material$Styled$RadioButton$radio,
									' MyAlgo Wallet',
									A2($author$project$Page$Setting$PaymentMethod$paymentRadioButtonIsChecked, $author$project$Type$Setting$UserWallet, notarisationNetworkInfo.paymentMethod),
									$author$project$Types$OnAuth(
										$author$project$Types$OnSetting(
											$author$project$Type$Setting$RadioBtnClick($author$project$Type$Setting$UserWallet)))),
									A3(
									$author$project$Material$Styled$RadioButton$radio,
									' Algorand Wallet',
									A2($author$project$Page$Setting$PaymentMethod$paymentRadioButtonIsChecked, $author$project$Type$Setting$WalletConnectBtn, notarisationNetworkInfo.paymentMethod),
									$author$project$Types$OnAuth(
										$author$project$Types$OnSetting(
											$author$project$Type$Setting$RadioBtnClick($author$project$Type$Setting$WalletConnectBtn)))),
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$author$project$Material$Styled$Button$button,
											_List_fromArray(
												[
													$author$project$Material$Styled$Button$theme($author$project$Material$Styled$Button$blue),
													$author$project$Material$Styled$Button$onClick(
													$author$project$Types$OnAuth(
														$author$project$Types$OnSetting($author$project$Type$Setting$OnPaymentMethodSubmit)))
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text('Save changes')
												]))
										]))
								])) : A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Setting$PaymentMethod$styles.paymentRadioBtnContainer)
								]),
							_List_fromArray(
								[
									A3(
									$author$project$Material$Styled$RadioButton$radio,
									' System balance',
									A2($author$project$Page$Setting$PaymentMethod$paymentRadioButtonIsChecked, $author$project$Type$Setting$SystemSignPointsBalance, notarisationNetworkInfo.paymentMethod),
									$author$project$Types$OnAuth(
										$author$project$Types$OnSetting(
											$author$project$Type$Setting$RadioBtnClick($author$project$Type$Setting$SystemSignPointsBalance))))
								]))
						]))
				]));
	});
var $author$project$Type$Setting$Address = {$: 'Address'};
var $author$project$Type$Setting$DOB = {$: 'DOB'};
var $author$project$Type$Setting$FirstName = {$: 'FirstName'};
var $author$project$Type$Setting$IdentificationNum = {$: 'IdentificationNum'};
var $author$project$Type$Setting$LastName = {$: 'LastName'};
var $author$project$Type$Setting$Nationality = {$: 'Nationality'};
var $author$project$Type$Setting$OnBlur = function (a) {
	return {$: 'OnBlur', a: a};
};
var $author$project$Type$Setting$OnInput = F2(
	function (a, b) {
		return {$: 'OnInput', a: a, b: b};
	});
var $author$project$Type$Setting$OnSubmit = function (a) {
	return {$: 'OnSubmit', a: a};
};
var $author$project$Type$Setting$PhoneNum = {$: 'PhoneNum'};
var $author$project$Type$Setting$SubmitProfile = {$: 'SubmitProfile'};
var $author$project$Data$Country$country = _List_fromArray(
	['Afghanistan', 'Albania', 'Algeria', 'Andorra', 'Angola', 'Antigua and Barbuda', 'Argentina', 'Armenia', 'Australia', 'Austria', 'Azerbaijan', 'Bahamas', 'Bahrain', 'Bangladesh', 'Barbados', 'Belarus', 'Belgium', 'Belize', 'Benin', 'Bhutan', 'Bolivia', 'Bosnia and Herzegovina', 'Botswana', 'Brazil', 'Brunei', 'Bulgaria', 'Burkina Faso', 'Burundi', 'Cambodia', 'Cameroon', 'Canada', 'Cape Verde', 'Central African Republic', 'Chad', 'Chile', 'China', 'Colombi', 'Comoros', 'Congo (Brazzaville)', 'Congo', 'Costa Rica', 'Cote d\'Ivoire', 'Croatia', 'Cuba', 'Cyprus', 'Czech Republic', 'Denmark', 'Djibouti', 'Dominica', 'Dominican Republic', 'East Timor (Timor Timur)', 'Ecuador', 'Egypt', 'El Salvador', 'Equatorial Guinea', 'Eritrea', 'Estonia', 'Ethiopia', 'Fiji', 'Finland', 'France', 'Gabon', 'Gambia, The', 'Georgia', 'Germany', 'Ghana', 'Greece', 'Grenada', 'Guatemala', 'Guinea', 'Guinea-Bissau', 'Guyana', 'Haiti', 'Honduras', 'Hungary', 'Iceland', 'India', 'Indonesia', 'Iran', 'Iraq', 'Ireland', 'Israel', 'Italy', 'Jamaica', 'Japan', 'Jordan', 'Kazakhstan', 'Kenya', 'Kiribati', 'Korea, North', 'Korea, South', 'Kuwait', 'Kyrgyzstan', 'Laos', 'Latvia', 'Lebanon', 'Lesotho', 'Liberia', 'Libya', 'Liechtenstein', 'Lithuania', 'Luxembourg', 'Macedonia', 'Madagascar', 'Malawi', 'Malaysia', 'Maldives', 'Mali', 'Malta', 'Marshall Islands', 'Mauritania', 'Mauritius', 'Mexico', 'Micronesia', 'Moldova', 'Monaco', 'Mongolia', 'Morocco', 'Mozambique', 'Myanmar', 'Namibia', 'Nauru', 'Nepal', 'Netherlands', 'New Zealand', 'Nicaragua', 'Niger', 'Nigeria', 'Norway', 'Oman', 'Pakistan', 'Palau', 'Panama', 'Papua New Guinea', 'Paraguay', 'Peru', 'Philippines', 'Poland', 'Portugal', 'Qatar', 'Romania', 'Russia', 'Rwanda', 'Saint Kitts and Nevis', 'Saint Lucia', 'Saint Vincent', 'Samoa', 'San Marino', 'Sao Tome and Principe', 'Saudi Arabia', 'Senegal', 'Serbia and Montenegro', 'Seychelles', 'Sierra Leone', 'Singapore', 'Slovakia', 'Slovenia', 'Solomon Islands', 'Somalia', 'South Africa', 'Spain', 'Sri Lanka', 'Sudan', 'Suriname', 'Swaziland', 'Sweden', 'Switzerland', 'Syria', 'Taiwan', 'Tajikistan', 'Tanzania', 'Thailand', 'Togo', 'Tonga', 'Trinidad and Tobago', 'Tunisia', 'Turkey', 'Turkmenistan', 'Tuvalu', 'Uganda', 'Ukraine', 'United Arab Emirates', 'United Kingdom', 'United States', 'Uruguay', 'Uzbekistan', 'Vanuatu', 'Vatican City', 'Venezuela', 'Vietnam', 'Yemen', 'Zambia', 'Zimbabwe']);
var $author$project$Material$Styled$Select$InfoMessage = function (a) {
	return {$: 'InfoMessage', a: a};
};
var $author$project$Material$Styled$Select$infoMessage = function (message) {
	return $author$project$Material$Styled$Select$InfoMessage(message);
};
var $author$project$Page$Setting$Profile$myInfoProgressContent = function (profile) {
	var style = function () {
		var _v0 = profile.myInfoStatus;
		if (_v0.$ === 'Retrieving') {
			return _List_Nil;
		} else {
			return _List_fromArray(
				[
					$rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$none)
				]);
		}
	}();
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(style)
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Material$Styled$ProgressBar$linear,
				_List_fromArray(
					[
						$author$project$Material$Styled$ProgressBar$containerStyle(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Css$marginBottom(
								$rtfeldman$elm_css$Css$px(16))
							]))
					]),
				_List_Nil),
				A2(
				$rtfeldman$elm_css$Html$Styled$span,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Css$marginLeft(
								$rtfeldman$elm_css$Css$px(16))
							]))
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('Retrieving MyInfo data...')
					]))
			]));
};
var $author$project$Material$Styled$Input$phone = F2(
	function (properties, _v0) {
		return A2($author$project$Material$Styled$Input$input, 'tel', properties);
	});
var $author$project$Type$Setting$ProfileBanner = {$: 'ProfileBanner'};
var $author$project$Page$Setting$Profile$renderBanner = function (banner) {
	switch (banner.$) {
		case 'Submitted':
			return A2(
				$author$project$Material$Styled$Banner$banner,
				_List_fromArray(
					[
						$author$project$Material$Styled$Banner$theme($author$project$Material$Styled$Banner$successTheme),
						$author$project$Material$Styled$Banner$body(
						$rtfeldman$elm_css$Html$Styled$text('- Changes Saved')),
						$author$project$Material$Styled$Banner$title('Update Success'),
						$author$project$Material$Styled$Banner$closeIconAttributes(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Svg$Styled$Events$onClick(
								$author$project$Types$OnAuth(
									$author$project$Types$OnSetting(
										$author$project$Type$Setting$CloseBanner($author$project$Type$Setting$ProfileBanner))))
							]))
					]),
				_List_Nil);
		case 'Error':
			var message = banner.a;
			return A2(
				$author$project$Material$Styled$Banner$banner,
				_List_fromArray(
					[
						$author$project$Material$Styled$Banner$theme($author$project$Material$Styled$Banner$errorTheme),
						$author$project$Material$Styled$Banner$body(
						$rtfeldman$elm_css$Html$Styled$text('- ' + message)),
						$author$project$Material$Styled$Banner$title('Error message'),
						$author$project$Material$Styled$Banner$closeIconAttributes(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Svg$Styled$Events$onClick(
								$author$project$Types$OnAuth(
									$author$project$Types$OnSetting(
										$author$project$Type$Setting$CloseBanner($author$project$Type$Setting$ProfileBanner))))
							]))
					]),
				_List_Nil);
		default:
			return $rtfeldman$elm_css$Html$Styled$text('');
	}
};
var $rtfeldman$elm_css$Html$Styled$Attributes$selected = $rtfeldman$elm_css$Html$Styled$Attributes$boolProperty('selected');
var $rtfeldman$elm_css$Css$nthChild = function (str) {
	return $rtfeldman$elm_css$Css$pseudoClass('nth-child(' + (str + ')'));
};
var $author$project$Page$Setting$Profile$styles = {
	buttonContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(150)),
			A2(
			$rtfeldman$elm_css$Css$margin2,
			$rtfeldman$elm_css$Css$px(16),
			$rtfeldman$elm_css$Css$px(16))
		]),
	field: _List_fromArray(
		[
			A3(
			$rtfeldman$elm_css$Css$flex3,
			$rtfeldman$elm_css$Css$num(1),
			$rtfeldman$elm_css$Css$num(1),
			$rtfeldman$elm_css$Css$pct(45)),
			A2(
			$rtfeldman$elm_css$Css$margin2,
			$rtfeldman$elm_css$Css$px(8),
			$rtfeldman$elm_css$Css$px(16)),
			$rtfeldman$elm_css$Css$maxWidth(
			$rtfeldman$elm_css$Css$px(500)),
			A2(
			$rtfeldman$elm_css$Css$nthChild,
			'9',
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$flex($rtfeldman$elm_css$Css$auto),
					$rtfeldman$elm_css$Css$maxWidth(
					$rtfeldman$elm_css$Css$px(900)),
					$rtfeldman$elm_css$Css$paddingBottom(
					$rtfeldman$elm_css$Css$px(8))
				]))
		]),
	form: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceBetween),
			$rtfeldman$elm_css$Css$flexWrap($rtfeldman$elm_css$Css$wrap),
			$rtfeldman$elm_css$Css$paddingTop(
			$rtfeldman$elm_css$Css$px(16)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100)),
			$rtfeldman$elm_css$Css$maxWidth(
			$rtfeldman$elm_css$Css$px(900))
		])
};
var $author$project$Page$Setting$Profile$submitButton = F2(
	function (languageSwitchModel, model) {
		var accountSettingsLanguageData = languageSwitchModel.allLanguageData.location.accountSettingsPage;
		var _v0 = model;
		var formStatus = _v0.formStatus;
		var firstNameError = _v0.firstNameError;
		var lastNameError = _v0.lastNameError;
		var identificationNumError = _v0.identificationNumError;
		var phoneNumError = _v0.phoneNumError;
		var hasError = A2(
			$elm$core$List$any,
			$elm$core$Basics$neq($elm$core$Maybe$Nothing),
			_List_fromArray(
				[firstNameError, lastNameError, identificationNumError, phoneNumError]));
		switch (formStatus.$) {
			case 'Ready':
				return hasError ? $author$project$View$SubmitButton$disabled(accountSettingsLanguageData.saveChanges) : $author$project$View$SubmitButton$enabled(accountSettingsLanguageData.saveChanges);
			case 'Submitting':
				return $author$project$View$SubmitButton$submitting(accountSettingsLanguageData.saveChanges + ' ...');
			case 'Submitted':
				return $author$project$View$SubmitButton$enabled(accountSettingsLanguageData.saveChanges);
			default:
				return $author$project$View$SubmitButton$disabled(accountSettingsLanguageData.saveChanges);
		}
	});
var $author$project$Page$Setting$Profile$view = F2(
	function (languageSwitchModel, model) {
		var selectedCountry = A2($elm$core$Maybe$withDefault, '', model.data.nationality);
		var accountSettingsLanguageData = languageSwitchModel.allLanguageData.location.accountSettingsPage;
		var _v0 = model;
		var firstNameError = _v0.firstNameError;
		var lastNameError = _v0.lastNameError;
		var identificationNumError = _v0.identificationNumError;
		var phoneNumError = _v0.phoneNumError;
		var formStatus = _v0.formStatus;
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Page$Setting$Profile$renderBanner(formStatus),
					$author$project$Page$Setting$Profile$myInfoProgressContent(model),
					A2(
					$rtfeldman$elm_css$Html$Styled$form,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Events$onSubmit(
							$author$project$Types$OnAuth(
								$author$project$Types$OnSetting(
									$author$project$Type$Setting$OnSubmit($author$project$Type$Setting$SubmitProfile)))),
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Setting$Profile$styles.form)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Material$Styled$Input$text,
							_List_fromArray(
								[
									$author$project$Material$Styled$Input$containerStyles($author$project$Page$Setting$Profile$styles.field),
									$author$project$Material$Styled$Input$label(accountSettingsLanguageData.firstName + '*'),
									$author$project$Material$Styled$Input$value(model.data.firstName),
									$author$project$Material$Styled$Input$onInput(
									A2(
										$elm$core$Basics$composeL,
										A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnSetting),
										$author$project$Type$Setting$OnInput($author$project$Type$Setting$FirstName))),
									$author$project$Material$Styled$Input$onBlur(
									$author$project$Types$OnAuth(
										$author$project$Types$OnSetting(
											$author$project$Type$Setting$OnBlur($author$project$Type$Setting$FirstName)))),
									$author$project$Material$Styled$Input$errorMessage(firstNameError),
									$author$project$Material$Styled$Input$infoMessage('Example: John')
								]),
							_List_Nil),
							A2(
							$author$project$Material$Styled$Input$text,
							_List_fromArray(
								[
									$author$project$Material$Styled$Input$containerStyles($author$project$Page$Setting$Profile$styles.field),
									$author$project$Material$Styled$Input$label(accountSettingsLanguageData.lastName + '*'),
									$author$project$Material$Styled$Input$value(model.data.lastName),
									$author$project$Material$Styled$Input$onInput(
									A2(
										$elm$core$Basics$composeL,
										A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnSetting),
										$author$project$Type$Setting$OnInput($author$project$Type$Setting$LastName))),
									$author$project$Material$Styled$Input$onBlur(
									$author$project$Types$OnAuth(
										$author$project$Types$OnSetting(
											$author$project$Type$Setting$OnBlur($author$project$Type$Setting$LastName)))),
									$author$project$Material$Styled$Input$errorMessage(lastNameError),
									$author$project$Material$Styled$Input$infoMessage('Example: Doe')
								]),
							_List_Nil),
							A2(
							$author$project$Material$Styled$Input$text,
							_List_fromArray(
								[
									$author$project$Material$Styled$Input$containerStyles($author$project$Page$Setting$Profile$styles.field),
									$author$project$Material$Styled$Input$label('Principal Name*'),
									$author$project$Material$Styled$Input$disabled(true),
									$author$project$Material$Styled$Input$value(model.data.firstName + (' ' + model.data.lastName)),
									$author$project$Material$Styled$Input$infoMessage('Automatically generated for you from your given name and family name')
								]),
							_List_Nil),
							A2(
							$author$project$Material$Styled$Input$text,
							_List_fromArray(
								[
									$author$project$Material$Styled$Input$containerStyles($author$project$Page$Setting$Profile$styles.field),
									$author$project$Material$Styled$Input$label('NRIC/FIN'),
									$author$project$Material$Styled$Input$value(
									A2($elm$core$Maybe$withDefault, '', model.data.identificationNumber)),
									$author$project$Material$Styled$Input$onInput(
									A2(
										$elm$core$Basics$composeL,
										A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnSetting),
										$author$project$Type$Setting$OnInput($author$project$Type$Setting$IdentificationNum))),
									$author$project$Material$Styled$Input$onBlur(
									$author$project$Types$OnAuth(
										$author$project$Types$OnSetting(
											$author$project$Type$Setting$OnBlur($author$project$Type$Setting$IdentificationNum)))),
									$author$project$Material$Styled$Input$errorMessage(identificationNumError),
									$author$project$Material$Styled$Input$infoMessage('Government ID Number')
								]),
							_List_Nil),
							A2(
							$author$project$Material$Styled$Input$email,
							_List_fromArray(
								[
									$author$project$Material$Styled$Input$containerStyles($author$project$Page$Setting$Profile$styles.field),
									$author$project$Material$Styled$Input$label(accountSettingsLanguageData.emailAddress + '*'),
									$author$project$Material$Styled$Input$disabled(true),
									$author$project$Material$Styled$Input$value(model.email),
									$author$project$Material$Styled$Input$infoMessage('Example: JohnDoe@abc.net')
								]),
							_List_Nil),
							A2(
							$author$project$Material$Styled$Input$phone,
							_List_fromArray(
								[
									$author$project$Material$Styled$Input$containerStyles($author$project$Page$Setting$Profile$styles.field),
									$author$project$Material$Styled$Input$label(accountSettingsLanguageData.phoneNumber),
									$author$project$Material$Styled$Input$value(
									A2($elm$core$Maybe$withDefault, '', model.data.phoneNumber)),
									$author$project$Material$Styled$Input$onInput(
									A2(
										$elm$core$Basics$composeL,
										A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnSetting),
										$author$project$Type$Setting$OnInput($author$project$Type$Setting$PhoneNum))),
									$author$project$Material$Styled$Input$onBlur(
									$author$project$Types$OnAuth(
										$author$project$Types$OnSetting(
											$author$project$Type$Setting$OnBlur($author$project$Type$Setting$PhoneNum)))),
									$author$project$Material$Styled$Input$errorMessage(phoneNumError),
									$author$project$Material$Styled$Input$infoMessage('Example: +6598765432')
								]),
							_List_Nil),
							A2(
							$author$project$Material$Styled$Select$select,
							_List_fromArray(
								[
									$author$project$Material$Styled$Select$label(accountSettingsLanguageData.nationality),
									$author$project$Material$Styled$Select$containerStyles($author$project$Page$Setting$Profile$styles.field),
									$author$project$Material$Styled$Select$value(selectedCountry),
									$author$project$Material$Styled$Select$onChange(
									A2(
										$elm$core$Basics$composeL,
										A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnSetting),
										$author$project$Type$Setting$OnInput($author$project$Type$Setting$Nationality))),
									$author$project$Material$Styled$Select$infoMessage('Example: Singapore')
								]),
							A2(
								$elm$core$List$map,
								function (country) {
									return A2(
										$rtfeldman$elm_css$Html$Styled$option,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$value(country),
												$rtfeldman$elm_css$Html$Styled$Attributes$selected(
												_Utils_eq(selectedCountry, country))
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(country)
											]));
								},
								A2($elm$core$List$cons, '', $author$project$Data$Country$country))),
							A2(
							$author$project$Material$Styled$Input$date,
							_List_fromArray(
								[
									$author$project$Material$Styled$Input$containerStyles($author$project$Page$Setting$Profile$styles.field),
									$author$project$Material$Styled$Input$label(accountSettingsLanguageData.dateOfBirth),
									$author$project$Material$Styled$Input$value(
									A2($elm$core$Maybe$withDefault, 'dd/mm/yyyy', model.data.dateOfBirth)),
									$author$project$Material$Styled$Input$onInput(
									A2(
										$elm$core$Basics$composeL,
										A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnSetting),
										$author$project$Type$Setting$OnInput($author$project$Type$Setting$DOB))),
									$author$project$Material$Styled$Input$infoMessage('Example: 01/01/1970')
								]),
							_List_Nil),
							A2(
							$author$project$Material$Styled$Input$text,
							_List_fromArray(
								[
									$author$project$Material$Styled$Input$containerStyles($author$project$Page$Setting$Profile$styles.field),
									$author$project$Material$Styled$Input$label(accountSettingsLanguageData.address),
									$author$project$Material$Styled$Input$value(
									A2($elm$core$Maybe$withDefault, '', model.data.address)),
									$author$project$Material$Styled$Input$onInput(
									A2(
										$elm$core$Basics$composeL,
										A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnSetting),
										$author$project$Type$Setting$OnInput($author$project$Type$Setting$Address)))
								]),
							_List_Nil),
							A2($author$project$Material$Styled$Divider$divider, _List_Nil, _List_Nil),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Setting$Profile$styles.buttonContainer)
								]),
							_List_fromArray(
								[
									A2($author$project$Page$Setting$Profile$submitButton, languageSwitchModel, model)
								]))
						]))
				]));
	});
var $author$project$Type$Setting$ImageCancel = {$: 'ImageCancel'};
var $author$project$Type$Setting$ImageSubmit = function (a) {
	return {$: 'ImageSubmit', a: a};
};
var $author$project$Material$Styled$Color$red600String = '#e53935';
var $author$project$Material$Styled$Color$red600 = $rtfeldman$elm_css$Css$hex($author$project$Material$Styled$Color$red600String);
var $author$project$Page$Setting$ProfilePic$styles = {
	button: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(160)),
			$rtfeldman$elm_css$Css$marginBottom(
			$rtfeldman$elm_css$Css$px(13))
		]),
	container: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceAround),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$vh(25)),
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(16))
		]),
	errorMessage: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginBottom(
			$rtfeldman$elm_css$Css$px(10)),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$red600)
		]),
	icon: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$margin(
			$rtfeldman$elm_css$Css$px(5)),
			$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer)
		]),
	icons: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$relative),
			$rtfeldman$elm_css$Css$top(
			$rtfeldman$elm_css$Css$px(-32)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100))
		]),
	image: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$pct(50))
		]),
	imageEditor: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(320)),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(320))
		]),
	modalContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(320)),
			$rtfeldman$elm_css$Css$padding(
			$rtfeldman$elm_css$Css$px(10))
		]),
	renderImage: function (imageUrl) {
		return _List_fromArray(
			[
				$rtfeldman$elm_css$Css$backgroundImage(
				$rtfeldman$elm_css$Css$url(imageUrl)),
				$rtfeldman$elm_css$Css$backgroundSize($rtfeldman$elm_css$Css$cover),
				$rtfeldman$elm_css$Css$backgroundRepeat($rtfeldman$elm_css$Css$noRepeat),
				$rtfeldman$elm_css$Css$backgroundPosition($rtfeldman$elm_css$Css$center),
				$rtfeldman$elm_css$Css$borderRadius(
				$rtfeldman$elm_css$Css$pct(50)),
				$rtfeldman$elm_css$Css$height(
				$rtfeldman$elm_css$Css$px(160)),
				$rtfeldman$elm_css$Css$width(
				$rtfeldman$elm_css$Css$px(160))
			]);
	}
};
var $author$project$Page$Setting$ProfilePic$displayError = function (formStatus) {
	if (formStatus.$ === 'Error') {
		var errorMessage = formStatus.a;
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Setting$ProfilePic$styles.errorMessage)
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text(errorMessage)
				]));
	} else {
		return $rtfeldman$elm_css$Html$Styled$text('');
	}
};
var $author$project$Type$Setting$ImageAction = function (a) {
	return {$: 'ImageAction', a: a};
};
var $author$project$Page$Setting$ProfilePic$imageEditorIcons = A2(
	$rtfeldman$elm_css$Html$Styled$div,
	_List_fromArray(
		[
			$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Setting$ProfilePic$styles.icons)
		]),
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Setting$ProfilePic$styles.icon),
					$rtfeldman$elm_css$Html$Styled$Events$onClick(
					$author$project$Types$OnAuth(
						$author$project$Types$OnSetting(
							$author$project$Type$Setting$OnImageUpload(
								$author$project$Type$Setting$ImageAction($author$project$ImageEditor$RotateCCW)))))
				]),
			_List_fromArray(
				[$author$project$ImageEditor$Styled$Icon$RotateCCW$view])),
			A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Setting$ProfilePic$styles.icon),
					$rtfeldman$elm_css$Html$Styled$Events$onClick(
					$author$project$Types$OnAuth(
						$author$project$Types$OnSetting(
							$author$project$Type$Setting$OnImageUpload(
								$author$project$Type$Setting$ImageAction($author$project$ImageEditor$RotateCW)))))
				]),
			_List_fromArray(
				[$author$project$ImageEditor$Styled$Icon$RotateCW$view])),
			A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Setting$ProfilePic$styles.icon),
					$rtfeldman$elm_css$Html$Styled$Events$onClick(
					$author$project$Types$OnAuth(
						$author$project$Types$OnSetting(
							$author$project$Type$Setting$OnImageUpload(
								$author$project$Type$Setting$ImageAction($author$project$ImageEditor$ZoomIn)))))
				]),
			_List_fromArray(
				[$author$project$ImageEditor$Styled$Icon$ZoomIn$view])),
			A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Setting$ProfilePic$styles.icon),
					$rtfeldman$elm_css$Html$Styled$Events$onClick(
					$author$project$Types$OnAuth(
						$author$project$Types$OnSetting(
							$author$project$Type$Setting$OnImageUpload(
								$author$project$Type$Setting$ImageAction($author$project$ImageEditor$ZoomOut)))))
				]),
			_List_fromArray(
				[$author$project$ImageEditor$Styled$Icon$ZoomOut$view]))
		]));
var $author$project$Type$Setting$ImageRequested = {$: 'ImageRequested'};
var $author$project$Page$Setting$ProfilePic$submitButton = F2(
	function (languageSwitchModel, formStatus) {
		var accountSettingsLanguageData = languageSwitchModel.allLanguageData.location.accountSettingsPage;
		if (formStatus.$ === 'Submitting') {
			return A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Setting$ProfilePic$styles.button)
					]),
				_List_fromArray(
					[
						$author$project$View$SubmitButton$submitting('Uploading...')
					]));
		} else {
			return A2(
				$author$project$Material$Styled$Button$button,
				_List_fromArray(
					[
						$author$project$Material$Styled$Button$styles($author$project$Page$Setting$ProfilePic$styles.button),
						$author$project$Material$Styled$Button$onClick(
						$author$project$Types$OnAuth(
							$author$project$Types$OnSetting(
								$author$project$Type$Setting$OnImageUpload($author$project$Type$Setting$ImageRequested))))
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(accountSettingsLanguageData.changePicture)
					]));
		}
	});
var $author$project$Page$Setting$ProfilePic$view = F2(
	function (languageSwitchModel, model) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Setting$ProfilePic$styles.container)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							$author$project$Page$Setting$ProfilePic$styles.renderImage(
								A2($elm$core$Maybe$withDefault, $author$project$View$Theme$images.person, model.imageUrl)))
						]),
					_List_Nil),
					function () {
					var _v0 = model.imageEditor;
					switch (_v0.$) {
						case 'Closed':
							return $rtfeldman$elm_css$Html$Styled$text('');
						case 'Processing':
							var image = _v0.a;
							return A2(
								$author$project$Material$Styled$Modal$modal,
								_List_fromArray(
									[
										$author$project$Material$Styled$Modal$open(true),
										$author$project$Material$Styled$Modal$contentContainerstyles($author$project$Page$Setting$ProfilePic$styles.modalContainer)
									]),
								_List_fromArray(
									[
										A2($author$project$ImageEditor$Styled$View$view, $author$project$Page$Setting$ProfilePic$styles.imageEditor, image),
										$author$project$Page$Setting$ProfilePic$imageEditorIcons,
										$author$project$View$SubmitButton$submitting('Processing')
									]));
						default:
							var image = _v0.a;
							return A2(
								$author$project$Material$Styled$Modal$modal,
								_List_fromArray(
									[
										$author$project$Material$Styled$Modal$open(true),
										$author$project$Material$Styled$Modal$contentContainerstyles($author$project$Page$Setting$ProfilePic$styles.modalContainer)
									]),
								_List_fromArray(
									[
										A2($author$project$ImageEditor$Styled$View$view, $author$project$Page$Setting$ProfilePic$styles.imageEditor, image),
										$author$project$Page$Setting$ProfilePic$imageEditorIcons,
										A2(
										$author$project$Material$Styled$Button$button,
										_List_fromArray(
											[
												$author$project$Material$Styled$Button$styles($author$project$Page$Setting$ProfilePic$styles.button),
												$author$project$Material$Styled$Button$onClick(
												$author$project$Types$OnAuth(
													$author$project$Types$OnSetting(
														$author$project$Type$Setting$OnImageUpload(
															$author$project$Type$Setting$ImageSubmit(image)))))
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('Submit')
											])),
										A2(
										$author$project$Material$Styled$Button$button,
										_List_fromArray(
											[
												$author$project$Material$Styled$Button$styles($author$project$Page$Setting$ProfilePic$styles.button),
												$author$project$Material$Styled$Button$theme($author$project$Material$Styled$Button$grey),
												$author$project$Material$Styled$Button$onClick(
												$author$project$Types$OnAuth(
													$author$project$Types$OnSetting(
														$author$project$Type$Setting$OnImageUpload($author$project$Type$Setting$ImageCancel))))
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('Cancel')
											]))
									]));
					}
				}(),
					A2($author$project$Page$Setting$ProfilePic$submitButton, languageSwitchModel, model.formStatus),
					$author$project$Page$Setting$ProfilePic$displayError(model.formStatus)
				]));
	});
var $author$project$Type$Setting$ConfirmNewPassword = {$: 'ConfirmNewPassword'};
var $author$project$Type$Setting$CurrentPassword = {$: 'CurrentPassword'};
var $author$project$Type$Setting$NewPassword = {$: 'NewPassword'};
var $author$project$Type$Setting$SubmitPassword = {$: 'SubmitPassword'};
var $author$project$Type$Setting$PasswordBanner = {$: 'PasswordBanner'};
var $author$project$Page$Setting$Security$renderBanner = function (banner) {
	switch (banner.$) {
		case 'Submitted':
			return A2(
				$author$project$Material$Styled$Banner$banner,
				_List_fromArray(
					[
						$author$project$Material$Styled$Banner$theme($author$project$Material$Styled$Banner$successTheme),
						$author$project$Material$Styled$Banner$body(
						$rtfeldman$elm_css$Html$Styled$text('- Successfully Updated Password')),
						$author$project$Material$Styled$Banner$title('Update Success'),
						$author$project$Material$Styled$Banner$closeIconAttributes(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Svg$Styled$Events$onClick(
								$author$project$Types$OnAuth(
									$author$project$Types$OnSetting(
										$author$project$Type$Setting$CloseBanner($author$project$Type$Setting$PasswordBanner))))
							]))
					]),
				_List_Nil);
		case 'Error':
			var message = banner.a;
			return A2(
				$author$project$Material$Styled$Banner$banner,
				_List_fromArray(
					[
						$author$project$Material$Styled$Banner$theme($author$project$Material$Styled$Banner$errorTheme),
						$author$project$Material$Styled$Banner$body(
						$rtfeldman$elm_css$Html$Styled$text('- ' + message)),
						$author$project$Material$Styled$Banner$title('Error message'),
						$author$project$Material$Styled$Banner$closeIconAttributes(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Svg$Styled$Events$onClick(
								$author$project$Types$OnAuth(
									$author$project$Types$OnSetting(
										$author$project$Type$Setting$CloseBanner($author$project$Type$Setting$PasswordBanner))))
							]))
					]),
				_List_Nil);
		default:
			return $rtfeldman$elm_css$Html$Styled$text('');
	}
};
var $author$project$Page$Setting$Security$styles = {
	authenticationContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceBetween),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			A2(
			$rtfeldman$elm_css$Css$margin2,
			$rtfeldman$elm_css$Css$px(16),
			$rtfeldman$elm_css$Css$px(20))
		]),
	button: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(130))
		]),
	buttonContainer: _List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Css$margin2,
			$rtfeldman$elm_css$Css$px(16),
			$rtfeldman$elm_css$Css$px(20)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(150))
		]),
	container: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100))
		]),
	field: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$paddingBottom(
			$rtfeldman$elm_css$Css$px(16))
		]),
	fieldContainer: _List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Css$margin2,
			$rtfeldman$elm_css$Css$px(16),
			$rtfeldman$elm_css$Css$px(20))
		]),
	header: _List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Css$margin2,
			$rtfeldman$elm_css$Css$px(16),
			$rtfeldman$elm_css$Css$px(20)),
			$rtfeldman$elm_css$Css$fontWeight(
			$rtfeldman$elm_css$Css$int(500))
		]),
	redButton: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$backgroundColor($author$project$Material$Styled$Color$red700)
		])
};
var $author$project$Page$Setting$Security$submitButton = F2(
	function (languageSwitchModel, model) {
		var accountSettingsLanguageData = languageSwitchModel.allLanguageData.location.accountSettingsPage;
		var _v0 = model.formStatus;
		switch (_v0.$) {
			case 'Submitting':
				return $author$project$View$SubmitButton$submitting(accountSettingsLanguageData.changePassword + '...');
			case 'Error':
				return $author$project$View$SubmitButton$disabled(accountSettingsLanguageData.changePassword);
			case 'Submitted':
				return $author$project$View$SubmitButton$enabled(accountSettingsLanguageData.changePassword);
			default:
				return $author$project$View$SubmitButton$enabled(accountSettingsLanguageData.changePassword);
		}
	});
var $author$project$Page$Setting$Security$view = F2(
	function (languageSwitchModel, model) {
		var accountSettingsLanguageData = languageSwitchModel.allLanguageData.location.accountSettingsPage;
		var _v0 = model;
		var currentPassword = _v0.currentPassword;
		var currentPasswordError = _v0.currentPasswordError;
		var newPassword = _v0.newPassword;
		var newPasswordError = _v0.newPasswordError;
		var confirmNewPassword = _v0.confirmNewPassword;
		var confirmNewPasswordError = _v0.confirmNewPasswordError;
		var formStatus = _v0.formStatus;
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Setting$Security$styles.container)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Page$Setting$Security$renderBanner(formStatus),
							A2(
							$rtfeldman$elm_css$Html$Styled$form,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Events$onSubmit(
									$author$project$Types$OnAuth(
										$author$project$Types$OnSetting(
											$author$project$Type$Setting$OnSubmit($author$project$Type$Setting$SubmitPassword))))
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Setting$Security$styles.fieldContainer)
										]),
									_List_fromArray(
										[
											A2(
											$author$project$Material$Styled$Input$password,
											_List_fromArray(
												[
													$author$project$Material$Styled$Input$label(accountSettingsLanguageData.currentPassword),
													$author$project$Material$Styled$Input$containerStyles($author$project$Page$Setting$Security$styles.field),
													$author$project$Material$Styled$Input$value(currentPassword),
													$author$project$Material$Styled$Input$onInput(
													A2(
														$elm$core$Basics$composeL,
														A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnSetting),
														$author$project$Type$Setting$OnInput($author$project$Type$Setting$CurrentPassword))),
													$author$project$Material$Styled$Input$onBlur(
													$author$project$Types$OnAuth(
														$author$project$Types$OnSetting(
															$author$project$Type$Setting$OnBlur($author$project$Type$Setting$CurrentPassword)))),
													$author$project$Material$Styled$Input$errorMessage(currentPasswordError)
												]),
											_List_Nil),
											A2(
											$author$project$Material$Styled$Input$password,
											_List_fromArray(
												[
													$author$project$Material$Styled$Input$label(accountSettingsLanguageData.newPassword),
													$author$project$Material$Styled$Input$containerStyles($author$project$Page$Setting$Security$styles.field),
													$author$project$Material$Styled$Input$value(newPassword),
													$author$project$Material$Styled$Input$onInput(
													A2(
														$elm$core$Basics$composeL,
														A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnSetting),
														$author$project$Type$Setting$OnInput($author$project$Type$Setting$NewPassword))),
													$author$project$Material$Styled$Input$onBlur(
													$author$project$Types$OnAuth(
														$author$project$Types$OnSetting(
															$author$project$Type$Setting$OnBlur($author$project$Type$Setting$NewPassword)))),
													$author$project$Material$Styled$Input$errorMessage(newPasswordError),
													$author$project$Material$Styled$Input$infoMessage('Password must contain at least 8 characters, a lowercase letter, an uppercase letter and a number')
												]),
											_List_Nil),
											A2(
											$author$project$Material$Styled$Input$password,
											_List_fromArray(
												[
													$author$project$Material$Styled$Input$label(accountSettingsLanguageData.confirmPassword),
													$author$project$Material$Styled$Input$containerStyles($author$project$Page$Setting$Security$styles.field),
													$author$project$Material$Styled$Input$value(confirmNewPassword),
													$author$project$Material$Styled$Input$onInput(
													A2(
														$elm$core$Basics$composeL,
														A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnSetting),
														$author$project$Type$Setting$OnInput($author$project$Type$Setting$ConfirmNewPassword))),
													$author$project$Material$Styled$Input$onBlur(
													$author$project$Types$OnAuth(
														$author$project$Types$OnSetting(
															$author$project$Type$Setting$OnBlur($author$project$Type$Setting$ConfirmNewPassword)))),
													$author$project$Material$Styled$Input$errorMessage(confirmNewPasswordError)
												]),
											_List_Nil)
										])),
									A2($author$project$Material$Styled$Divider$divider, _List_Nil, _List_Nil),
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Setting$Security$styles.buttonContainer),
											A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'data-test', 'password-btn')
										]),
									_List_fromArray(
										[
											A2($author$project$Page$Setting$Security$submitButton, languageSwitchModel, model)
										]))
								]))
						]))
				]));
	});
var $author$project$Page$Setting$ShareReferralCode$styles = {
	anotherContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$row)
		]),
	buttonStyle: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(37)),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(53)),
			A2(
			$rtfeldman$elm_css$Css$padding2,
			$rtfeldman$elm_css$Css$px(7),
			$rtfeldman$elm_css$Css$px(7)),
			$rtfeldman$elm_css$Css$marginLeft(
			$rtfeldman$elm_css$Css$px(10))
		]),
	container: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			A4(
			$rtfeldman$elm_css$Css$padding4,
			$rtfeldman$elm_css$Css$px(30),
			$rtfeldman$elm_css$Css$px(20),
			$rtfeldman$elm_css$Css$px(10),
			$rtfeldman$elm_css$Css$px(20)),
			$rtfeldman$elm_css$Css$alignSelf($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(95))
		]),
	inputContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginBottom(
			$rtfeldman$elm_css$Css$px(20)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100))
		]),
	referralCode: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(14))
		])
};
var $author$project$Page$Setting$ShareReferralCode$copyReferralCode = F4(
	function (model, referralCode, title, timeout) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Setting$ShareReferralCode$styles.anotherContainer)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Material$Styled$Input$text,
					_List_fromArray(
						[
							$author$project$Material$Styled$Input$label(title),
							$author$project$Material$Styled$Input$containerStyles($author$project$Page$Setting$ShareReferralCode$styles.inputContainer),
							$author$project$Material$Styled$Input$value(referralCode),
							$author$project$Material$Styled$Input$disabled(true)
						]),
					_List_Nil),
					A2(
					$author$project$Material$Styled$Button$button,
					_List_fromArray(
						[
							$author$project$Material$Styled$Button$styles($author$project$Page$Setting$ShareReferralCode$styles.buttonStyle),
							$author$project$Material$Styled$Button$onClick(
							$author$project$Types$OnAuth(
								$author$project$Types$OnSetting(
									A2($author$project$Type$Setting$OnCopyReferralCodeClick, referralCode, timeout))))
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Material$Styled$Snackbar$snackbar,
							_List_fromArray(
								[
									$author$project$Material$Styled$Snackbar$Theme($author$project$Material$Styled$Snackbar$secondary),
									$author$project$Material$Styled$Snackbar$Timeout(timeout),
									$author$project$Material$Styled$Snackbar$Status(model.referralCodeSnackbarStatus)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Copied to Clipboard')
								])),
							A2($author$project$Material$Styled$Icon$copyReferralCode, _List_Nil, _List_Nil)
						]))
				]));
	});
var $author$project$Page$Setting$ShareReferralCode$view = F3(
	function (languageSwitchModel, appDomain, model) {
		var timeout = 3;
		var accountSettingsLanguageData = languageSwitchModel.allLanguageData.location.accountSettingsPage;
		var _v0 = model.data;
		var shareReferralCode = _v0.shareReferralCode;
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Setting$ShareReferralCode$styles.container)
				]),
			_List_fromArray(
				[
					A4($author$project$Page$Setting$ShareReferralCode$copyReferralCode, model, shareReferralCode, accountSettingsLanguageData.referralCode, timeout),
					A4($author$project$Page$Setting$ShareReferralCode$copyReferralCode, model, 'http://' + (appDomain + ($author$project$Data$Route$routeUrl.personalRegister + ('?ref=' + shareReferralCode))), accountSettingsLanguageData.personalAccount, timeout),
					A4($author$project$Page$Setting$ShareReferralCode$copyReferralCode, model, 'http://' + (appDomain + ($author$project$Data$Route$routeUrl.businessRegister + ('?ref=' + shareReferralCode))), accountSettingsLanguageData.businessAccount, timeout)
				]));
	});
var $author$project$Type$Signature$ReloadList = {$: 'ReloadList'};
var $author$project$Type$Signature$OnOpen = {$: 'OnOpen'};
var $rtfeldman$elm_css$Css$contain = {lengthOrAutoOrCoverOrContain: $rtfeldman$elm_css$Css$Structure$Compatible, value: 'contain'};
var $author$project$Page$Setting$Signature$styles = {
	button: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$maxWidth($rtfeldman$elm_css$Css$fitContent),
			$rtfeldman$elm_css$Css$marginRight(
			$rtfeldman$elm_css$Css$px(16))
		]),
	container: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			$rtfeldman$elm_css$Css$flexWrap($rtfeldman$elm_css$Css$wrap),
			A2(
			$rtfeldman$elm_css$Css$padding2,
			$rtfeldman$elm_css$Css$px(16),
			$rtfeldman$elm_css$Css$zero),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100)),
			$rtfeldman$elm_css$Css$maxWidth(
			$rtfeldman$elm_css$Css$px(900))
		]),
	create: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$margin(
			$rtfeldman$elm_css$Css$px(20)),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(100)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(100)),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(100)),
			A3(
			$rtfeldman$elm_css$Css$border3,
			$rtfeldman$elm_css$Css$px(1),
			$rtfeldman$elm_css$Css$solid,
			$author$project$Material$Styled$Color$blueA700),
			$rtfeldman$elm_css$Css$borderRadius(
			$rtfeldman$elm_css$Css$px(10)),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$blueA700),
			$rtfeldman$elm_css$Css$hover(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer)
				]))
		]),
	image: function (imageSrc) {
		return _List_fromArray(
			[
				$rtfeldman$elm_css$Css$height(
				$rtfeldman$elm_css$Css$px(100)),
				$rtfeldman$elm_css$Css$width(
				$rtfeldman$elm_css$Css$px(150)),
				A2(
				$rtfeldman$elm_css$Css$margin2,
				$rtfeldman$elm_css$Css$px(10),
				$rtfeldman$elm_css$Css$zero),
				$rtfeldman$elm_css$Css$backgroundImage(
				$rtfeldman$elm_css$Css$url(imageSrc)),
				$rtfeldman$elm_css$Css$backgroundRepeat($rtfeldman$elm_css$Css$noRepeat),
				$rtfeldman$elm_css$Css$backgroundSize($rtfeldman$elm_css$Css$contain),
				$rtfeldman$elm_css$Css$backgroundPosition($rtfeldman$elm_css$Css$center)
			]);
	},
	main: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$row),
			$rtfeldman$elm_css$Css$flexWrap($rtfeldman$elm_css$Css$wrap),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100)),
			A2(
			$rtfeldman$elm_css$Css$padding2,
			$rtfeldman$elm_css$Css$zero,
			$rtfeldman$elm_css$Css$px(20))
		]),
	nameAlign: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontWeight(
			$rtfeldman$elm_css$Css$int(500))
		]),
	retryContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer),
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(10)),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(200))
		]),
	signatureContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			A2(
			$rtfeldman$elm_css$Css$padding2,
			$rtfeldman$elm_css$Css$px(16),
			$rtfeldman$elm_css$Css$zero)
		])
};
var $author$project$Page$Setting$Signature$createSignature = function (signatures) {
	return ($elm$core$List$length(signatures) >= 5) ? $rtfeldman$elm_css$Html$Styled$text('') : A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Setting$Signature$styles.create),
				$rtfeldman$elm_css$Html$Styled$Events$onClick(
				$author$project$Types$OnSignature($author$project$Type$Signature$OnOpen)),
				A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'data-test', 'signature')
			]),
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$text('+')
			]));
};
var $author$project$Type$Signature$OnDelete = function (a) {
	return {$: 'OnDelete', a: a};
};
var $author$project$Page$Setting$Signature$displaySignature = function (signature) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Setting$Signature$styles.signatureContainer)
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						$author$project$Page$Setting$Signature$styles.image(signature.data))
					]),
				_List_Nil),
				A2(
				$author$project$Material$Styled$Button$button,
				_List_fromArray(
					[
						$author$project$Material$Styled$Button$styles($author$project$Page$Setting$Signature$styles.button),
						$author$project$Material$Styled$Button$onClick(
						$author$project$Types$OnSignature(
							$author$project$Type$Signature$OnDelete(signature.id))),
						$author$project$Material$Styled$Button$theme($author$project$Material$Styled$Button$red)
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('Delete')
					]))
			]));
};
var $author$project$Page$Setting$Signature$view = function (model) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Setting$Signature$styles.container)
			]),
		function () {
			var _v0 = model.listError;
			if (_v0.$ === 'Just') {
				var error = _v0.a;
				return _List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Setting$Signature$styles.retryContainer),
								$rtfeldman$elm_css$Html$Styled$Events$onClick(
								$author$project$Types$OnSignature($author$project$Type$Signature$ReloadList))
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$span,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(error)
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$img,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$src($author$project$View$Theme$images.retry)
									]),
								_List_Nil)
							]))
					]);
			} else {
				return _List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Setting$Signature$styles.main)
							]),
						_Utils_ap(
							A2($elm$core$List$map, $author$project$Page$Setting$Signature$displaySignature, model.signatures),
							_List_fromArray(
								[
									$author$project$Page$Setting$Signature$createSignature(model.signatures)
								]))),
						A2($author$project$View$Signature$view, model, model.open)
					]);
			}
		}());
};
var $author$project$Page$Setting$view = F2(
	function (authModel, model) {
		var accountSettingsLanguageData = model.languageSwitchModel.allLanguageData.location.accountSettingsPage;
		var _v0 = authModel;
		var settingModel = _v0.settingModel;
		var signatureModel = _v0.signatureModel;
		var stampModel = _v0.stampModel;
		var businessCreateModel = _v0.businessCreateModel;
		var user = _v0.user;
		var _v1 = settingModel;
		var image = _v1.image;
		var profile = _v1.profile;
		var security = _v1.security;
		var _v2 = user;
		var domains = _v2.domains;
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Setting$styles.container)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Setting$styles.coverImage)
								]),
							_List_Nil),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Setting$styles.leftContainer)
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$h1,
									_List_Nil,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(accountSettingsLanguageData.accountSettings)
										]))
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Setting$styles.container)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Setting$styles.leftContainer)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Material$Styled$Card$card,
									_List_fromArray(
										[
											$author$project$Material$Styled$Card$containerStyles($author$project$Page$Setting$styles.leftContainer)
										]),
									_List_fromArray(
										[
											A2($author$project$Page$Setting$ProfilePic$view, model.languageSwitchModel, image)
										]))
								])),
							A2(
							$author$project$Material$Styled$Card$card,
							_List_fromArray(
								[
									$author$project$Material$Styled$Card$containerStyles($author$project$Page$Setting$styles.rightContainer),
									$author$project$Material$Styled$Card$headerText('Profile')
								]),
							_List_fromArray(
								[
									A2($author$project$Page$Setting$Profile$view, model.languageSwitchModel, profile)
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Setting$styles.container)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Setting$styles.leftContainer)
								]),
							_List_Nil),
							A2(
							$author$project$Material$Styled$Card$card,
							_List_fromArray(
								[
									$author$project$Material$Styled$Card$headerText(accountSettingsLanguageData.referralCode),
									$author$project$Material$Styled$Card$containerStyles($author$project$Page$Setting$styles.rightContainer)
								]),
							_List_fromArray(
								[
									A3(
									$author$project$Page$Setting$ShareReferralCode$view,
									model.languageSwitchModel,
									$author$project$Data$Domain$toString(model.appDomain),
									profile)
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Setting$styles.container)
						]),
					($elm$core$List$length(
						$author$project$Data$Domain$all(domains)) > 1) ? _List_Nil : _List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Setting$styles.leftContainer)
								]),
							_List_Nil),
							A2(
							$author$project$Material$Styled$Card$card,
							_List_fromArray(
								[
									$author$project$Material$Styled$Card$headerText(accountSettingsLanguageData.addABusinessPlan),
									$author$project$Material$Styled$Card$containerStyles($author$project$Page$Setting$styles.rightContainer)
								]),
							_List_fromArray(
								[
									A3($author$project$Page$Setting$Business$view, model.languageSwitchModel, businessCreateModel, model.baseHost)
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Setting$styles.container)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Setting$styles.leftContainer)
								]),
							_List_Nil),
							A2(
							$author$project$Material$Styled$Card$card,
							_List_fromArray(
								[
									$author$project$Material$Styled$Card$headerText(accountSettingsLanguageData.documentNotarisationNetwork),
									$author$project$Material$Styled$Card$containerStyles($author$project$Page$Setting$styles.rightContainer)
								]),
							_List_fromArray(
								[
									A2($author$project$Page$Setting$NotarisationNetwork$view, authModel, model)
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Setting$styles.container)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Setting$styles.leftContainer)
								]),
							_List_Nil),
							A2(
							$author$project$Material$Styled$Card$card,
							_List_fromArray(
								[
									$author$project$Material$Styled$Card$headerText(accountSettingsLanguageData.notariseByDefault),
									$author$project$Material$Styled$Card$containerStyles($author$project$Page$Setting$styles.rightContainer),
									$author$project$Material$Styled$Card$containerStyles($author$project$Page$Setting$styles.rightContainer),
									$author$project$Material$Styled$Card$iconElement(
									A2(
										$rtfeldman$elm_css$Html$Styled$span,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Setting$styles.iconStyles)
											]),
										_List_fromArray(
											[
												A5(
												$author$project$View$InfomationToolTip$view,
												$author$project$Types$OnAuth(
													$author$project$Types$OnSetting(
														$author$project$Type$Setting$OnDefaultNotariseHover($author$project$Type$Setting$Enter))),
												$author$project$Types$OnAuth(
													$author$project$Types$OnSetting(
														$author$project$Type$Setting$OnDefaultNotariseHover($author$project$Type$Setting$Leave))),
												authModel.settingModel.notarisationNetworkInfo.notariseToolTipHover,
												A2(
													$rtfeldman$elm_css$Html$Styled$span,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Setting$styles.toolTipText)
														]),
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$text(accountSettingsLanguageData.notariseByDefaultTooltipText)
														])),
												$author$project$Material$Styled$Icon$help)
											])))
								]),
							_List_fromArray(
								[
									A2($author$project$Page$Setting$DefaultNotarisation$view, authModel, model)
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Setting$styles.container)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Setting$styles.leftContainer)
								]),
							_List_Nil),
							A2(
							$author$project$Material$Styled$Card$card,
							_List_fromArray(
								[
									$author$project$Material$Styled$Card$headerText(accountSettingsLanguageData.paymentMethod),
									$author$project$Material$Styled$Card$containerStyles($author$project$Page$Setting$styles.rightContainer)
								]),
							_List_fromArray(
								[
									A2($author$project$Page$Setting$PaymentMethod$view, authModel, model)
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Setting$styles.container)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Setting$styles.leftContainer)
								]),
							_List_Nil),
							A2(
							$author$project$Material$Styled$Card$card,
							_List_fromArray(
								[
									$author$project$Material$Styled$Card$headerText(accountSettingsLanguageData.signatures),
									$author$project$Material$Styled$Card$containerStyles($author$project$Page$Setting$styles.rightContainer)
								]),
							_List_fromArray(
								[
									$author$project$Page$Setting$Signature$view(signatureModel)
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Setting$styles.container)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Setting$styles.leftContainer)
								]),
							_List_Nil),
							A2(
							$author$project$Material$Styled$Card$card,
							_List_fromArray(
								[
									$author$project$Material$Styled$Card$headerText(accountSettingsLanguageData.myPersonalStamps),
									$author$project$Material$Styled$Card$containerStyles($author$project$Page$Setting$styles.rightContainer),
									$author$project$Material$Styled$Card$iconElement(
									A2(
										$rtfeldman$elm_css$Html$Styled$span,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Setting$styles.iconStyles)
											]),
										_List_fromArray(
											[
												A5(
												$author$project$View$InfomationToolTip$view,
												$author$project$Types$OnAuth(
													$author$project$Types$OnSetting(
														$author$project$Type$Setting$OnStampsHover($author$project$Type$Setting$Enter))),
												$author$project$Types$OnAuth(
													$author$project$Types$OnSetting(
														$author$project$Type$Setting$OnStampsHover($author$project$Type$Setting$Leave))),
												authModel.settingModel.profile.stampsHover,
												A2(
													$rtfeldman$elm_css$Html$Styled$span,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Setting$styles.toolTipText)
														]),
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$text(accountSettingsLanguageData.stampsTooltipText)
														])),
												$author$project$Material$Styled$Icon$help)
											])))
								]),
							_List_fromArray(
								[
									A3($author$project$View$Stamp$view, model.languageSwitchModel, model.appDomain, stampModel)
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Setting$styles.container)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$Setting$styles.leftContainer)
								]),
							_List_Nil),
							A2(
							$author$project$Material$Styled$Card$card,
							_List_fromArray(
								[
									$author$project$Material$Styled$Card$headerText(accountSettingsLanguageData.changePassword),
									$author$project$Material$Styled$Card$containerStyles($author$project$Page$Setting$styles.rightContainer)
								]),
							_List_fromArray(
								[
									A2($author$project$Page$Setting$Security$view, model.languageSwitchModel, security)
								]))
						])),
					A3($author$project$Page$Setting$apiKeyCardView, model, authModel, settingModel)
				]));
	});
var $rtfeldman$elm_css$Css$lineThrough = {textDecorationLine: $rtfeldman$elm_css$Css$Structure$Compatible, value: 'line-through'};
var $author$project$Page$SignUp$styles = {
	card: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(300))
		]),
	cardContent: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$padding(
			$rtfeldman$elm_css$Css$px(20))
		]),
	container: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceAround),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$flexStart),
			$rtfeldman$elm_css$Css$flexWrap($rtfeldman$elm_css$Css$wrap),
			A4(
			$rtfeldman$elm_css$Css$padding4,
			$rtfeldman$elm_css$Css$zero,
			$rtfeldman$elm_css$Css$px(10),
			$rtfeldman$elm_css$Css$px(48),
			$rtfeldman$elm_css$Css$px(10)),
			$rtfeldman$elm_css$Css$maxWidth(
			$rtfeldman$elm_css$Css$px(800)),
			A2($rtfeldman$elm_css$Css$margin2, $rtfeldman$elm_css$Css$zero, $rtfeldman$elm_css$Css$auto)
		]),
	contentContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(48))
		]),
	description: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$paddingBottom(
			$rtfeldman$elm_css$Css$px(20))
		]),
	header: _List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Css$border2,
			$rtfeldman$elm_css$Css$px(1),
			$rtfeldman$elm_css$Css$solid),
			A2(
			$rtfeldman$elm_css$Css$padding2,
			$rtfeldman$elm_css$Css$px(10),
			$rtfeldman$elm_css$Css$zero),
			$rtfeldman$elm_css$Css$marginBottom(
			$rtfeldman$elm_css$Css$px(30)),
			$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(150))
		]),
	info: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(16)),
			$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center)
		]),
	noAccess: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(16)),
			$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$textDecoration($rtfeldman$elm_css$Css$lineThrough)
		]),
	title: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginBottom(
			$rtfeldman$elm_css$Css$px(20)),
			$rtfeldman$elm_css$Css$paddingBottom(
			$rtfeldman$elm_css$Css$px(10)),
			$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(20)),
			A3(
			$rtfeldman$elm_css$Css$borderBottom3,
			$rtfeldman$elm_css$Css$px(1),
			$rtfeldman$elm_css$Css$solid,
			$author$project$Material$Styled$Color$grey300)
		])
};
var $author$project$Page$SignUp$view = function (_v0) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$SignUp$styles.container)
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$SignUp$styles.contentContainer)
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$SignUp$styles.header)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('BUSINESS PLAN')
							])),
						A2(
						$author$project$Material$Styled$Card$card,
						_List_fromArray(
							[
								$author$project$Material$Styled$Card$containerStyles($author$project$Page$SignUp$styles.card)
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$SignUp$styles.cardContent)
									]),
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$div,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$SignUp$styles.description)
											]),
										_List_fromArray(
											[
												A2(
												$rtfeldman$elm_css$Html$Styled$div,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$SignUp$styles.title)
													]),
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text('For Business')
													])),
												A2(
												$rtfeldman$elm_css$Html$Styled$div,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$SignUp$styles.info)
													]),
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text('USD 29 monthly')
													])),
												A2(
												$rtfeldman$elm_css$Html$Styled$div,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$SignUp$styles.info)
													]),
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text('45 days trial')
													])),
												A2(
												$rtfeldman$elm_css$Html$Styled$div,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$SignUp$styles.info)
													]),
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text('Cancel anytime')
													])),
												A2($rtfeldman$elm_css$Html$Styled$br, _List_Nil, _List_Nil),
												A2(
												$rtfeldman$elm_css$Html$Styled$div,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$SignUp$styles.info)
													]),
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text('Sign securely with anyone')
													])),
												A2(
												$rtfeldman$elm_css$Html$Styled$div,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$SignUp$styles.info)
													]),
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text('Send unlimited documents')
													])),
												A2($rtfeldman$elm_css$Html$Styled$br, _List_Nil, _List_Nil),
												A2(
												$rtfeldman$elm_css$Html$Styled$div,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$SignUp$styles.info)
													]),
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text('Send PDF Forms')
													])),
												A2(
												$rtfeldman$elm_css$Html$Styled$div,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$SignUp$styles.info)
													]),
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text('Add organisation users')
													]))
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$a,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$href($author$project$Data$Route$routeUrl.businessRegister)
											]),
										_List_fromArray(
											[
												A2(
												$author$project$Material$Styled$Button$button,
												_List_Nil,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text('SIGN UP')
													]))
											]))
									]))
							]))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$SignUp$styles.contentContainer)
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$SignUp$styles.header)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('PERSONAL PLAN')
							])),
						A2(
						$author$project$Material$Styled$Card$card,
						_List_fromArray(
							[
								$author$project$Material$Styled$Card$containerStyles($author$project$Page$SignUp$styles.card)
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$SignUp$styles.cardContent)
									]),
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$div,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$SignUp$styles.description)
											]),
										_List_fromArray(
											[
												A2(
												$rtfeldman$elm_css$Html$Styled$div,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$SignUp$styles.title)
													]),
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text('For Everyone')
													])),
												A2(
												$rtfeldman$elm_css$Html$Styled$div,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$SignUp$styles.info)
													]),
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text('Free')
													])),
												A2($rtfeldman$elm_css$Html$Styled$br, _List_Nil, _List_Nil),
												A2(
												$rtfeldman$elm_css$Html$Styled$div,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$SignUp$styles.info)
													]),
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text('Sign securely with anyone')
													])),
												A2(
												$rtfeldman$elm_css$Html$Styled$div,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$SignUp$styles.info)
													]),
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text('Send unlimited documents')
													])),
												A2($rtfeldman$elm_css$Html$Styled$br, _List_Nil, _List_Nil),
												A2(
												$rtfeldman$elm_css$Html$Styled$div,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$SignUp$styles.noAccess)
													]),
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text('Send PDF Forms')
													])),
												A2(
												$rtfeldman$elm_css$Html$Styled$div,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$SignUp$styles.noAccess)
													]),
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text('Add organisation users')
													])),
												A2($rtfeldman$elm_css$Html$Styled$br, _List_Nil, _List_Nil),
												A2($rtfeldman$elm_css$Html$Styled$br, _List_Nil, _List_Nil)
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$a,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$href($author$project$Data$Route$routeUrl.personalRegister)
											]),
										_List_fromArray(
											[
												A2(
												$author$project$Material$Styled$Button$button,
												_List_Nil,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text('SIGN UP')
													]))
											]))
									]))
							]))
					]))
			]));
};
var $author$project$Page$TokenConfirmation$styles = {
	affliate: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(1)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(1))
		]),
	button: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(48)),
			$rtfeldman$elm_css$Css$maxWidth(
			$rtfeldman$elm_css$Css$px(300))
		]),
	card: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			A2(
			$rtfeldman$elm_css$Css$margin2,
			$rtfeldman$elm_css$Css$zero,
			$rtfeldman$elm_css$Css$px(20)),
			$rtfeldman$elm_css$Css$paddingBottom(
			$rtfeldman$elm_css$Css$px(40)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100)),
			$rtfeldman$elm_css$Css$maxWidth(
			$rtfeldman$elm_css$Css$px(600))
		]),
	checkCircle: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginBottom(
			$rtfeldman$elm_css$Css$px(30))
		]),
	container: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			A2(
			$rtfeldman$elm_css$Css$padding2,
			$rtfeldman$elm_css$Css$px(48),
			$rtfeldman$elm_css$Css$zero)
		]),
	heading: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(24)),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$blueGrey900),
			$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center)
		]),
	headingError: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(24)),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$red900),
			$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center)
		]),
	linkContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			A3(
				$rtfeldman$elm_css$Css$calc,
				$rtfeldman$elm_css$Css$pct(100),
				$rtfeldman$elm_css$Css$minus,
				$rtfeldman$elm_css$Css$px(48))),
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(16))
		]),
	logo: _List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Css$margin2,
			$rtfeldman$elm_css$Css$px(60),
			$rtfeldman$elm_css$Css$zero),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(150)),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(38))
		]),
	main: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			A3(
				$rtfeldman$elm_css$Css$calc,
				$rtfeldman$elm_css$Css$pct(100),
				$rtfeldman$elm_css$Css$minus,
				$rtfeldman$elm_css$Css$px(48))),
			A2(
			$rtfeldman$elm_css$Css$padding2,
			$rtfeldman$elm_css$Css$px(48),
			$rtfeldman$elm_css$Css$px(24)),
			$rtfeldman$elm_css$Css$boxSizing($rtfeldman$elm_css$Css$borderBox),
			A3(
			$rtfeldman$elm_css$Css$borderTop3,
			$rtfeldman$elm_css$Css$px(1),
			$rtfeldman$elm_css$Css$solid,
			$author$project$Material$Styled$Color$grey200),
			A3(
			$rtfeldman$elm_css$Css$borderBottom3,
			$rtfeldman$elm_css$Css$px(1),
			$rtfeldman$elm_css$Css$solid,
			$author$project$Material$Styled$Color$grey200)
		]),
	progressBar: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(48))
		]),
	textContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(14)),
			$rtfeldman$elm_css$Css$lineHeight(
			$rtfeldman$elm_css$Css$px(21)),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$blueGrey900),
			$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$fontWeight(
			$rtfeldman$elm_css$Css$int(400))
		]),
	view: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center)
		])
};
var $author$project$Page$TokenConfirmation$failedView = _List_fromArray(
	[
		A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$TokenConfirmation$styles.view)
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Material$Styled$Icon$error,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Svg$Styled$Attributes$height('250px'),
						$rtfeldman$elm_css$Svg$Styled$Attributes$width('250px'),
						$rtfeldman$elm_css$Svg$Styled$Attributes$fill('red')
					]),
				_List_Nil)
			])),
		A2(
		$rtfeldman$elm_css$Html$Styled$h2,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$TokenConfirmation$styles.heading)
			]),
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$text('Transaction Failed')
			])),
		A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$TokenConfirmation$styles.textContainer)
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$p,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('This transaction has failed due to one of the following reasons: ')
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$p,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('- The approval period has passed. Please ensure that you approve your transaction within 5 minutes of sending the request')
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$p,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('- This transaction has already been approved')
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$p,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('For more details regarding this transaction, your can view your '),
						A2(
						$rtfeldman$elm_css$Html$Styled$a,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$href($author$project$Data$Route$routeUrl.tokenManagement)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('points management page ')
							])),
						$rtfeldman$elm_css$Html$Styled$text('or contact us at '),
						A2(
						$rtfeldman$elm_css$Html$Styled$a,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$href('mailto:help@sign.net?subject=Activate Account Help'),
								$rtfeldman$elm_css$Html$Styled$Attributes$target('_blank')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('help@sign.net')
							]))
					]))
			]))
	]);
var $author$project$Page$TokenConfirmation$layout = function (children) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$TokenConfirmation$styles.container)
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Material$Styled$Card$card,
				_List_fromArray(
					[
						$author$project$Material$Styled$Card$containerStyles($author$project$Page$TokenConfirmation$styles.card)
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$img,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$src($author$project$View$Theme$images.logoColor),
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$TokenConfirmation$styles.logo)
							]),
						_List_Nil),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$TokenConfirmation$styles.main)
							]),
						children)
					]))
			]));
};
var $author$project$Page$TokenConfirmation$loadingView = _List_fromArray(
	[
		A2(
		$rtfeldman$elm_css$Html$Styled$h2,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$TokenConfirmation$styles.heading)
			]),
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$text('Loading')
			])),
		A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$TokenConfirmation$styles.textContainer)
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$p,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('We are completing your transaction. Please wait.')
					]))
			]))
	]);
var $author$project$Page$TokenConfirmation$successView = _List_fromArray(
	[
		A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$TokenConfirmation$styles.view)
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Material$Styled$Icon$checkCircle,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Svg$Styled$Attributes$height('250px'),
						$rtfeldman$elm_css$Svg$Styled$Attributes$width('250px'),
						$rtfeldman$elm_css$Svg$Styled$Attributes$fill('green')
					]),
				_List_Nil)
			])),
		A2(
		$rtfeldman$elm_css$Html$Styled$h2,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$TokenConfirmation$styles.heading)
			]),
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$text('Transfer Completed')
			])),
		A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$TokenConfirmation$styles.textContainer)
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$p,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('Your transaction has been completed and details can be found in '),
						A2(
						$rtfeldman$elm_css$Html$Styled$a,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$href($author$project$Data$Route$routeUrl.transactionHistory)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('transaction history')
							]))
					]))
			]))
	]);
var $author$project$Page$TokenConfirmation$view = function (model) {
	var _v0 = model.tokenConfirmationModel.status;
	switch (_v0.$) {
		case 'Success':
			return $author$project$Page$TokenConfirmation$layout($author$project$Page$TokenConfirmation$successView);
		case 'Fail':
			return $author$project$Page$TokenConfirmation$layout($author$project$Page$TokenConfirmation$failedView);
		default:
			return $author$project$Page$TokenConfirmation$layout($author$project$Page$TokenConfirmation$loadingView);
	}
};
var $author$project$Type$TokenManagement$Blur = {$: 'Blur'};
var $author$project$Type$TokenManagement$Input = function (a) {
	return {$: 'Input', a: a};
};
var $author$project$Type$TokenManagement$OnRecipientAmount = function (a) {
	return {$: 'OnRecipientAmount', a: a};
};
var $author$project$Type$TokenManagement$OnRecipientEmail = function (a) {
	return {$: 'OnRecipientEmail', a: a};
};
var $author$project$Type$TokenManagement$OnRecipientRemarks = function (a) {
	return {$: 'OnRecipientRemarks', a: a};
};
var $author$project$Type$TokenManagement$OnTransactionClick = function (a) {
	return {$: 'OnTransactionClick', a: a};
};
var $author$project$Type$TokenManagement$OnTransactionSubmit = {$: 'OnTransactionSubmit'};
var $author$project$Type$TokenManagement$OnViewAllClick = {$: 'OnViewAllClick'};
var $author$project$Type$TokenManagement$AlgorandRadioBtn = {$: 'AlgorandRadioBtn'};
var $author$project$Type$TokenManagement$BinanceRadioBtn = {$: 'BinanceRadioBtn'};
var $author$project$Type$TokenManagement$OnNetworkChangeSubmit = {$: 'OnNetworkChangeSubmit'};
var $author$project$Type$TokenManagement$RadioBtnClick = function (a) {
	return {$: 'RadioBtnClick', a: a};
};
var $author$project$Type$TokenManagement$SystemBalanceBtn = {$: 'SystemBalanceBtn'};
var $author$project$Type$TokenManagement$UserWalletBtn = {$: 'UserWalletBtn'};
var $author$project$Type$TokenManagement$WalletConnectBtn = {$: 'WalletConnectBtn'};
var $author$project$Page$TokenManagement$paymentRadioButtonIsChecked = F2(
	function (check, currentUserPaymentMethod) {
		switch (check.$) {
			case 'SystemBalanceBtn':
				return _Utils_eq(currentUserPaymentMethod, $author$project$Type$TokenManagement$SystemPointsBalance);
			case 'UserWalletBtn':
				return _Utils_eq(currentUserPaymentMethod, $author$project$Type$TokenManagement$AlgoWallet);
			case 'WalletConnectBtn':
				return _Utils_eq(currentUserPaymentMethod, $author$project$Type$TokenManagement$WalletConnect);
			default:
				return _Utils_eq(currentUserPaymentMethod, $author$project$Type$TokenManagement$SystemPointsBalance);
		}
	});
var $author$project$Page$TokenManagement$radioButtonIsChecked = F2(
	function (check, currentNotarisationNetwork) {
		switch (check.$) {
			case 'BinanceRadioBtn':
				return _Utils_eq(currentNotarisationNetwork, $author$project$Type$TokenManagement$Binance);
			case 'AlgorandRadioBtn':
				return _Utils_eq(currentNotarisationNetwork, $author$project$Type$TokenManagement$Algorand);
			default:
				return _Utils_eq(currentNotarisationNetwork, $author$project$Type$TokenManagement$Algorand);
		}
	});
var $author$project$Type$TokenManagement$OnBannerClose = function (a) {
	return {$: 'OnBannerClose', a: a};
};
var $author$project$Type$TokenManagement$ToggleNetworkBanner = {$: 'ToggleNetworkBanner'};
var $author$project$Page$TokenManagement$renderToggleNetworkBanner = function (banner) {
	switch (banner.$) {
		case 'Success':
			return A2(
				$author$project$Material$Styled$Banner$banner,
				_List_fromArray(
					[
						$author$project$Material$Styled$Banner$theme($author$project$Material$Styled$Banner$successTheme),
						$author$project$Material$Styled$Banner$body(
						$rtfeldman$elm_css$Html$Styled$text('Changes have been applied.')),
						$author$project$Material$Styled$Banner$title('Update Success'),
						$author$project$Material$Styled$Banner$closeIconAttributes(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Svg$Styled$Events$onClick(
								$author$project$Types$OnAuth(
									$author$project$Types$OnTokenManagement(
										$author$project$Type$TokenManagement$OnBannerClose($author$project$Type$TokenManagement$ToggleNetworkBanner))))
							])),
						$author$project$Material$Styled$Banner$containerStyles($author$project$Page$TokenManagement$styles.banner)
					]),
				_List_Nil);
		case 'Error':
			var message = banner.a;
			return A2(
				$author$project$Material$Styled$Banner$banner,
				_List_fromArray(
					[
						$author$project$Material$Styled$Banner$theme($author$project$Material$Styled$Banner$errorTheme),
						$author$project$Material$Styled$Banner$body(
						$rtfeldman$elm_css$Html$Styled$text(message)),
						$author$project$Material$Styled$Banner$title('Error'),
						$author$project$Material$Styled$Banner$closeIconAttributes(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Svg$Styled$Events$onClick(
								$author$project$Types$OnAuth(
									$author$project$Types$OnTokenManagement(
										$author$project$Type$TokenManagement$OnBannerClose($author$project$Type$TokenManagement$ToggleNetworkBanner))))
							])),
						$author$project$Material$Styled$Banner$containerStyles($author$project$Page$TokenManagement$styles.banner)
					]),
				_List_Nil);
		default:
			return $rtfeldman$elm_css$Html$Styled$text('');
	}
};
var $author$project$Page$TokenManagement$notarisationNetworkToggle = F2(
	function (model, authModel) {
		var pointsManagementPageLanguageData = model.languageSwitchModel.allLanguageData.location.pointsManagement;
		var _v0 = authModel;
		var tokenManagementModel = _v0.tokenManagementModel;
		var user = _v0.user;
		var userPaymentMethod = pointsManagementPageLanguageData.currentPaymentMethod + (': ' + $author$project$Page$Setting$PaymentMethod$paymentMethodTxt(user.paymentMethod));
		var usersNotarisationNetwork = pointsManagementPageLanguageData.currentNetwork + (': ' + user.notarisationNetwork);
		return A2(
			$author$project$Material$Styled$Card$card,
			_List_fromArray(
				[
					$author$project$Material$Styled$Card$containerStyles($author$project$Page$TokenManagement$styles.redeemRewardsContainer),
					$author$project$Material$Styled$Card$headerText(pointsManagementPageLanguageData.togglePaymentNotarisationMethods)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Page$TokenManagement$renderToggleNetworkBanner(tokenManagementModel.updateStatus),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$TokenManagement$styles.notarisationNetworkTxt)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(usersNotarisationNetwork)
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$TokenManagement$styles.toggleContainer)
								]),
							_List_fromArray(
								[
									A3(
									$author$project$Material$Styled$RadioButton$radio,
									' Binance Smart Chain',
									A2($author$project$Page$TokenManagement$radioButtonIsChecked, $author$project$Type$TokenManagement$BinanceRadioBtn, tokenManagementModel.currentNetwork),
									$author$project$Types$OnAuth(
										$author$project$Types$OnTokenManagement(
											$author$project$Type$TokenManagement$RadioBtnClick($author$project$Type$TokenManagement$BinanceRadioBtn)))),
									A3(
									$author$project$Material$Styled$RadioButton$radio,
									' Algorand Blockchain',
									A2($author$project$Page$TokenManagement$radioButtonIsChecked, $author$project$Type$TokenManagement$AlgorandRadioBtn, tokenManagementModel.currentNetwork),
									$author$project$Types$OnAuth(
										$author$project$Types$OnTokenManagement(
											$author$project$Type$TokenManagement$RadioBtnClick($author$project$Type$TokenManagement$AlgorandRadioBtn))))
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$TokenManagement$styles.toggleContainer)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(userPaymentMethod),
							A2($author$project$Page$TokenManagement$radioButtonIsChecked, $author$project$Type$TokenManagement$AlgorandRadioBtn, tokenManagementModel.currentNetwork) ? A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$TokenManagement$styles.paymentContainer)
								]),
							_List_fromArray(
								[
									A3(
									$author$project$Material$Styled$RadioButton$radio,
									' System Balance',
									A2($author$project$Page$TokenManagement$paymentRadioButtonIsChecked, $author$project$Type$TokenManagement$SystemBalanceBtn, tokenManagementModel.paymentMethod),
									$author$project$Types$OnAuth(
										$author$project$Types$OnTokenManagement(
											$author$project$Type$TokenManagement$RadioBtnClick($author$project$Type$TokenManagement$SystemBalanceBtn)))),
									A3(
									$author$project$Material$Styled$RadioButton$radio,
									' MyAlgo Wallet',
									A2($author$project$Page$TokenManagement$paymentRadioButtonIsChecked, $author$project$Type$TokenManagement$UserWalletBtn, tokenManagementModel.paymentMethod),
									$author$project$Types$OnAuth(
										$author$project$Types$OnTokenManagement(
											$author$project$Type$TokenManagement$RadioBtnClick($author$project$Type$TokenManagement$UserWalletBtn)))),
									A3(
									$author$project$Material$Styled$RadioButton$radio,
									' Algorand Wallet',
									A2($author$project$Page$TokenManagement$paymentRadioButtonIsChecked, $author$project$Type$TokenManagement$WalletConnectBtn, tokenManagementModel.paymentMethod),
									$author$project$Types$OnAuth(
										$author$project$Types$OnTokenManagement(
											$author$project$Type$TokenManagement$RadioBtnClick($author$project$Type$TokenManagement$WalletConnectBtn))))
								])) : A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$TokenManagement$styles.paymentContainer)
								]),
							_List_fromArray(
								[
									A3(
									$author$project$Material$Styled$RadioButton$radio,
									' System Balance',
									A2($author$project$Page$TokenManagement$paymentRadioButtonIsChecked, $author$project$Type$TokenManagement$SystemBalanceBtn, tokenManagementModel.paymentMethod),
									$author$project$Types$OnAuth(
										$author$project$Types$OnTokenManagement(
											$author$project$Type$TokenManagement$RadioBtnClick($author$project$Type$TokenManagement$SystemBalanceBtn))))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Material$Styled$Button$button,
									_List_fromArray(
										[
											$author$project$Material$Styled$Button$theme($author$project$Material$Styled$Button$blue),
											$author$project$Material$Styled$Button$onClick(
											$author$project$Types$OnAuth(
												$author$project$Types$OnTokenManagement($author$project$Type$TokenManagement$OnNetworkChangeSubmit)))
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('Save changes')
										]))
								]))
						]))
				]));
	});
var $author$project$Type$TokenManagement$SendTokenBanner = {$: 'SendTokenBanner'};
var $author$project$Page$TokenManagement$renderBanner = function (banner) {
	switch (banner.$) {
		case 'Success':
			return A2(
				$author$project$Material$Styled$Banner$banner,
				_List_fromArray(
					[
						$author$project$Material$Styled$Banner$theme($author$project$Material$Styled$Banner$successTheme),
						$author$project$Material$Styled$Banner$body(
						$rtfeldman$elm_css$Html$Styled$text('Request to send token successfully processed. Please check your email to approve the transaction.')),
						$author$project$Material$Styled$Banner$title('Success'),
						$author$project$Material$Styled$Banner$closeIconAttributes(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Svg$Styled$Events$onClick(
								$author$project$Types$OnAuth(
									$author$project$Types$OnTokenManagement(
										$author$project$Type$TokenManagement$OnBannerClose($author$project$Type$TokenManagement$SendTokenBanner))))
							])),
						$author$project$Material$Styled$Banner$containerStyles($author$project$Page$TokenManagement$styles.banner)
					]),
				_List_Nil);
		case 'Error':
			var message = banner.a;
			return A2(
				$author$project$Material$Styled$Banner$banner,
				_List_fromArray(
					[
						$author$project$Material$Styled$Banner$theme($author$project$Material$Styled$Banner$errorTheme),
						$author$project$Material$Styled$Banner$body(
						$rtfeldman$elm_css$Html$Styled$text(message)),
						$author$project$Material$Styled$Banner$title('Error'),
						$author$project$Material$Styled$Banner$closeIconAttributes(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Svg$Styled$Events$onClick(
								$author$project$Types$OnAuth(
									$author$project$Types$OnTokenManagement(
										$author$project$Type$TokenManagement$OnBannerClose($author$project$Type$TokenManagement$SendTokenBanner))))
							])),
						$author$project$Material$Styled$Banner$containerStyles($author$project$Page$TokenManagement$styles.banner)
					]),
				_List_Nil);
		default:
			return $rtfeldman$elm_css$Html$Styled$text('');
	}
};
var $author$project$Type$PointsTopUp$OnAmountInput = function (a) {
	return {$: 'OnAmountInput', a: a};
};
var $author$project$Type$PointsTopUp$OnSubmit = {$: 'OnSubmit'};
var $author$project$Page$PointTopUp$styles = {
	actions: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100)),
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(16)),
			$rtfeldman$elm_css$Css$boxSizing($rtfeldman$elm_css$Css$borderBox)
		]),
	bottomhalfCard: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceBetween),
			$rtfeldman$elm_css$Css$flexWrap($rtfeldman$elm_css$Css$wrap),
			A2(
			$rtfeldman$elm_css$Css$padding2,
			$rtfeldman$elm_css$Css$px(16),
			$rtfeldman$elm_css$Css$px(0))
		]),
	button: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$maxWidth($rtfeldman$elm_css$Css$fitContent)
		]),
	container: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100)),
			A2(
			$rtfeldman$elm_css$Css$padding2,
			$rtfeldman$elm_css$Css$px(16),
			$rtfeldman$elm_css$Css$px(20)),
			$rtfeldman$elm_css$Css$boxSizing($rtfeldman$elm_css$Css$borderBox)
		]),
	divider: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100))
		]),
	signOrderField: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100)),
			$rtfeldman$elm_css$Css$maxWidth(
			$rtfeldman$elm_css$Css$px(100)),
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(10))
		]),
	text: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(-5)),
			$rtfeldman$elm_css$Css$marginBottom(
			$rtfeldman$elm_css$Css$px(15))
		]),
	textBox: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$boxSizing($rtfeldman$elm_css$Css$borderBox),
			A2(
			$rtfeldman$elm_css$Css$padding2,
			$rtfeldman$elm_css$Css$px(0),
			$rtfeldman$elm_css$Css$px(20))
		]),
	topHalfCard: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceBetween),
			A2(
			$rtfeldman$elm_css$Css$padding2,
			$rtfeldman$elm_css$Css$px(5),
			$rtfeldman$elm_css$Css$px(20))
		])
};
var $author$project$Page$PointTopUp$view = function (authModel) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$PointTopUp$styles.container)
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$PointTopUp$styles.text)
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('Please select how much Sign points you will like to top up in USD.')
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$PointTopUp$styles.text)
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						'Current conversion: 1 USD to ' + ($elm$core$String$fromFloat(authModel.tokenManagementModel.usdToPoints) + ' Sign points'))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$PointTopUp$styles.text)
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('* Please note that the rate may be subjected to change')
					])),
				A2(
				$author$project$Material$Styled$Input$number,
				_List_fromArray(
					[
						$author$project$Material$Styled$Input$min('1'),
						$author$project$Material$Styled$Input$max(
						$elm$core$String$fromInt(100)),
						$author$project$Material$Styled$Input$label('USD'),
						$author$project$Material$Styled$Input$value(
						$elm$core$String$fromInt(authModel.pointsTopUpModel.amount)),
						$author$project$Material$Styled$Input$onInput(
						A2(
							$elm$core$Basics$composeL,
							A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnPointsTopUp),
							$author$project$Type$PointsTopUp$OnAmountInput)),
						$author$project$Material$Styled$Input$containerStyles($author$project$Page$PointTopUp$styles.signOrderField)
					]),
				_List_Nil),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$PointTopUp$styles.actions)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Material$Styled$Button$button,
						_List_fromArray(
							[
								$author$project$Material$Styled$Button$styles($author$project$Page$PointTopUp$styles.button),
								$author$project$Material$Styled$Button$onClick(
								$author$project$Types$OnAuth(
									$author$project$Types$OnPointsTopUp($author$project$Type$PointsTopUp$OnSubmit)))
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('Add Points')
							]))
					]))
			]));
};
var $author$project$Page$TokenManagement$topUpCard = function (authModel) {
	return A2(
		$author$project$Material$Styled$Card$card,
		_List_fromArray(
			[
				$author$project$Material$Styled$Card$containerStyles($author$project$Page$TokenManagement$styles.walletContainer),
				$author$project$Material$Styled$Card$headerText('Top up System balance')
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$TokenManagement$styles.topUpCard)
					]),
				_List_fromArray(
					[
						$author$project$Page$PointTopUp$view(authModel)
					]))
			]));
};
var $author$project$Type$TokenManagement$ExternalWallet = {$: 'ExternalWallet'};
var $author$project$Type$TokenManagement$OnExternalWalletCancel = {$: 'OnExternalWalletCancel'};
var $author$project$Type$TokenManagement$OnExternalWalletClick = {$: 'OnExternalWalletClick'};
var $author$project$Page$TokenManagement$displayWalletBalance = F2(
	function (tokenBalance, notarisationNetwork) {
		if (tokenBalance.$ === 'Just') {
			var balance = tokenBalance.a;
			var amount = function () {
				switch (notarisationNetwork) {
					case 'Binance':
						return $elm$core$String$fromFloat(
							A2(
								$elm$core$Maybe$withDefault,
								0,
								$elm$core$String$toFloat(balance)) / 1.0e18);
					case 'Algorand':
						return balance;
					default:
						return $elm$core$String$fromFloat(
							A2(
								$elm$core$Maybe$withDefault,
								0,
								$elm$core$String$toFloat(balance)) / 1.0e18);
				}
			}();
			return A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$TokenManagement$styles.numberText)
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(amount)
					]));
		} else {
			return A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$TokenManagement$styles.errorText)
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('Error retrieving wallet balance. Please refresh page.')
					]));
		}
	});
var $author$project$Page$TokenManagement$renderWalletError = function (error) {
	if (error.$ === 'Just') {
		var errorMessage = error.a;
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$TokenManagement$styles.walletError)
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text(errorMessage)
				]));
	} else {
		return $rtfeldman$elm_css$Html$Styled$text('');
	}
};
var $author$project$Page$TokenManagement$displayWallet = F2(
	function (model, authModel) {
		var pointsManagementPageLanguageData = model.languageSwitchModel.allLanguageData.location.pointsManagement;
		var isSystemBalance = (authModel.user.notarisationNetwork === 'Algorand') && (authModel.user.paymentMethod === 'systemBalance');
		var _v0 = authModel.tokenManagementModel.tokenBalance;
		if (_v0.$ === 'Just') {
			var address = function () {
				var _v1 = authModel.user.notarisationNetwork;
				switch (_v1) {
					case 'Binance':
						return A2($elm$core$Maybe$withDefault, '', authModel.user.metaMaskWalletAddress);
					case 'Algorand':
						return A2($elm$core$Maybe$withDefault, '', authModel.user.algorandWalletAddress);
					default:
						return '';
				}
			}();
			return (address === '') ? _List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$TokenManagement$styles.walletErrorContainer)
						]),
					_List_fromArray(
						[
							$author$project$Page$TokenManagement$renderWalletError(authModel.tokenManagementModel.walletError),
							A2(
							$author$project$Material$Styled$Button$button,
							_List_fromArray(
								[
									$author$project$Material$Styled$Button$styles($author$project$Page$TokenManagement$styles.pct50Width),
									$author$project$Material$Styled$Button$disabled(isSystemBalance),
									isSystemBalance ? $author$project$Material$Styled$Button$theme($author$project$Material$Styled$Button$grey) : $author$project$Material$Styled$Button$theme($author$project$Material$Styled$Button$blue),
									$author$project$Material$Styled$Button$onClick(
									$author$project$Types$OnAuth(
										$author$project$Types$OnTokenManagement($author$project$Type$TokenManagement$OnExternalWalletClick)))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Link External Wallet')
								]))
						]))
				]) : _List_fromArray(
				[
					(!isSystemBalance) ? A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$TokenManagement$styles.externalWalletContainer),
							$rtfeldman$elm_css$Html$Styled$Events$onClick(
							$author$project$Types$OnAuth(
								$author$project$Types$OnTokenManagement($author$project$Type$TokenManagement$OnExternalWalletClick)))
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('Replace Wallet')
						])) : $rtfeldman$elm_css$Html$Styled$text(''),
					$author$project$Page$TokenManagement$renderWalletError(authModel.tokenManagementModel.walletError),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$TokenManagement$styles.externalWallet)
						]),
					_List_fromArray(
						[
							A2($author$project$Page$TokenManagement$displayWalletBalance, authModel.tokenManagementModel.tokenBalance, authModel.user.notarisationNetwork),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$TokenManagement$styles.balanceHeaderText)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(pointsManagementPageLanguageData.available)
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$TokenManagement$styles.marginTop20)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Wallet ID: ' + address)
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$TokenManagement$styles.widthdrawButtonContainer)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Material$Styled$Button$button,
							_List_fromArray(
								[
									$author$project$Material$Styled$Button$styles($author$project$Page$TokenManagement$styles.buttonWidth),
									$author$project$Material$Styled$Button$theme($author$project$Material$Styled$Button$grey),
									$author$project$Material$Styled$Button$disabled(true)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Withdraw')
								])),
							A2(
							$author$project$Material$Styled$Button$button,
							_List_fromArray(
								[
									$author$project$Material$Styled$Button$styles($author$project$Page$TokenManagement$styles.buttonWidth),
									$author$project$Material$Styled$Button$theme($author$project$Material$Styled$Button$grey),
									$author$project$Material$Styled$Button$disabled(true)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Deposit')
								]))
						])),
					(authModel.user.notarisationNetwork === 'Binance') ? A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$TokenManagement$styles.bscScanText)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$TokenManagement$styles.bluegreyText)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Powered by BscScan.com APIs')
								]))
						])) : $rtfeldman$elm_css$Html$Styled$text('')
				]);
		} else {
			return _List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$TokenManagement$styles.walletErrorContainer)
						]),
					_List_fromArray(
						[
							$author$project$Page$TokenManagement$renderWalletError(authModel.tokenManagementModel.walletError),
							A2(
							$author$project$Material$Styled$Button$button,
							_List_fromArray(
								[
									$author$project$Material$Styled$Button$styles($author$project$Page$TokenManagement$styles.pct50Width),
									$author$project$Material$Styled$Button$disabled(isSystemBalance),
									isSystemBalance ? $author$project$Material$Styled$Button$theme($author$project$Material$Styled$Button$grey) : $author$project$Material$Styled$Button$theme($author$project$Material$Styled$Button$blue),
									$author$project$Material$Styled$Button$onClick(
									$author$project$Types$OnAuth(
										$author$project$Types$OnTokenManagement($author$project$Type$TokenManagement$OnExternalWalletClick)))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Link External Wallet')
								]))
						]))
				]);
		}
	});
var $author$project$Page$TokenManagement$walletContainer = F2(
	function (model, authModel) {
		var pointsManagementPageLanguageData = model.languageSwitchModel.allLanguageData.location.pointsManagement;
		var cardDisplay = function () {
			var _v0 = authModel.tokenManagementModel.walletStatus;
			switch (_v0.$) {
				case 'Loaded':
					return A2($author$project$Page$TokenManagement$displayWallet, model, authModel);
				case 'Loading':
					return _List_fromArray(
						[
							A2(
							$author$project$Material$Styled$ProgressBar$linear,
							_List_fromArray(
								[
									$author$project$Material$Styled$ProgressBar$containerStyle(_List_Nil)
								]),
							_List_Nil),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$TokenManagement$styles.loadingWalletContainer)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Retrieving wallet address...'),
									A2(
									$author$project$Material$Styled$Button$button,
									_List_fromArray(
										[
											$author$project$Material$Styled$Button$styles($author$project$Page$TokenManagement$styles.cancelButton),
											$author$project$Material$Styled$Button$theme($author$project$Material$Styled$Button$white),
											$author$project$Material$Styled$Button$onClick(
											$author$project$Types$OnAuth(
												$author$project$Types$OnTokenManagement($author$project$Type$TokenManagement$OnExternalWalletCancel)))
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('Cancel')
										]))
								]))
						]);
				default:
					return _List_fromArray(
						[
							A2(
							$author$project$Material$Styled$ProgressBar$linear,
							_List_fromArray(
								[
									$author$project$Material$Styled$ProgressBar$containerStyle(_List_Nil)
								]),
							_List_Nil),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$TokenManagement$styles.loadingWalletContainer)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Retrieving wallet information...')
								]))
						]);
			}
		}();
		return A2(
			$author$project$Material$Styled$Card$card,
			_List_fromArray(
				[
					$author$project$Material$Styled$Card$containerStyles($author$project$Page$TokenManagement$styles.redeemRewardsContainer),
					$author$project$Material$Styled$Card$headerText(pointsManagementPageLanguageData.externalWallet),
					$author$project$Material$Styled$Card$iconElement(
					A5(
						$author$project$View$InfomationToolTip$view,
						$author$project$Types$OnAuth(
							$author$project$Types$OnTokenManagement(
								A2($author$project$Type$TokenManagement$OnHover, $author$project$Type$TokenManagement$ExternalWallet, $author$project$Type$TokenManagement$Enter))),
						$author$project$Types$OnAuth(
							$author$project$Types$OnTokenManagement(
								A2($author$project$Type$TokenManagement$OnHover, $author$project$Type$TokenManagement$ExternalWallet, $author$project$Type$TokenManagement$Leave))),
						authModel.tokenManagementModel.walletHover,
						A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$TokenManagement$styles.toolTipText)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(pointsManagementPageLanguageData.externalWalletTooltipText),
									A2(
									$author$project$Material$Styled$A$a,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$href('https://www.sign.net/rewardpoints'),
											$rtfeldman$elm_css$Html$Styled$Attributes$target('_blank')
										]),
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$span,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$TokenManagement$styles.linkText)
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text('Find out more')
												]))
										]))
								])),
						$author$project$Material$Styled$Icon$help))
				]),
			cardDisplay);
	});
var $author$project$Type$TokenManagement$OnModalClose = {$: 'OnModalClose'};
var $author$project$Type$TokenManagement$OnSelectWallet = function (a) {
	return {$: 'OnSelectWallet', a: a};
};
var $author$project$Page$TokenManagement$walletCard = function (walletData) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Events$onClick(
				$author$project$Types$OnAuth(
					$author$project$Types$OnTokenManagement(
						$author$project$Type$TokenManagement$OnSelectWallet(walletData))))
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Material$Styled$Card$card,
				_List_fromArray(
					[
						$author$project$Material$Styled$Card$containerStyles($author$project$Page$TokenManagement$styles.cardContainer)
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$TokenManagement$styles.walletAddress)
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$span,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$TokenManagement$styles.walletAddress)
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(walletData.address)
									]))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$TokenManagement$styles.optInText)
							]),
						_List_fromArray(
							[
								walletData.needOptIn ? $rtfeldman$elm_css$Html$Styled$text('Requires Opt In') : $rtfeldman$elm_css$Html$Styled$text('Does not require Opt In')
							]))
					]))
			]));
};
var $author$project$Page$TokenManagement$walletConnectModal = function (currentStage) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$TokenManagement$styles.modalHeader)
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$TokenManagement$styles.modalHeaderTxt)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('Algorand Wallet')
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$img,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$TokenManagement$styles.icon),
								$rtfeldman$elm_css$Html$Styled$Attributes$src($author$project$View$Theme$images.close),
								$rtfeldman$elm_css$Html$Styled$Events$onClick(
								$author$project$Types$OnAuth(
									$author$project$Types$OnTokenManagement($author$project$Type$TokenManagement$OnModalClose)))
							]),
						_List_Nil)
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$TokenManagement$styles.modalBodyContainer)
					]),
				_List_fromArray(
					[
						function () {
						switch (currentStage.$) {
							case 'Selection':
								var addressList = currentStage.a;
								return A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_Nil,
									A2(
										$elm$core$List$cons,
										A2(
											$rtfeldman$elm_css$Html$Styled$span,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$TokenManagement$styles.modalBody)
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text('Please select the wallet address that you wish to link')
												])),
										_Utils_ap(
											A2($elm$core$List$map, $author$project$Page$TokenManagement$walletCard, addressList),
											_List_fromArray(
												[
													A2(
													$rtfeldman$elm_css$Html$Styled$span,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$TokenManagement$styles.modalBtns)
														]),
													_List_fromArray(
														[
															A2(
															$author$project$Material$Styled$Button$button,
															_List_fromArray(
																[
																	$author$project$Material$Styled$Button$theme($author$project$Material$Styled$Button$blue),
																	$author$project$Material$Styled$Button$styles($author$project$Page$TokenManagement$styles.dashboardBtn),
																	$author$project$Material$Styled$Button$onClick(
																	$author$project$Types$OnAuth(
																		$author$project$Types$OnTokenManagement($author$project$Type$TokenManagement$OnModalClose)))
																]),
															_List_fromArray(
																[
																	$rtfeldman$elm_css$Html$Styled$text('Cancel')
																]))
														]))
												]))));
							case 'AwaitConfirmation':
								return A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$span,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$TokenManagement$styles.modalBody)
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text('Please confirm your opt-in on your Algorand Wallet App')
												])),
											A2($author$project$Material$Styled$ProgressBar$linear, _List_Nil, _List_Nil)
										]));
							case 'RetriveInformation':
								return A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$span,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$TokenManagement$styles.modalBody)
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text('Please wait while we retrieve your wallet information')
												])),
											A2($author$project$Material$Styled$ProgressBar$linear, _List_Nil, _List_Nil)
										]));
							default:
								return A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$span,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$TokenManagement$styles.modalBody)
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text('Please wait while we register your wallet')
												])),
											A2($author$project$Material$Styled$ProgressBar$linear, _List_Nil, _List_Nil)
										]));
						}
					}()
					]))
			]));
};
var $author$project$Page$TokenManagement$walletStages = function (stage) {
	if (stage.$ === 'WalletConnectSelection') {
		var currentStage = stage.a;
		return $author$project$Page$TokenManagement$walletConnectModal(currentStage);
	} else {
		return $rtfeldman$elm_css$Html$Styled$text('');
	}
};
var $author$project$Page$TokenManagement$walletModal = function (authModel) {
	var _v0 = authModel;
	var tokenManagementModel = _v0.tokenManagementModel;
	return A2(
		$author$project$Material$Styled$Modal$modal,
		_List_fromArray(
			[
				$author$project$Material$Styled$Modal$open(
				!_Utils_eq(tokenManagementModel.modal, $author$project$Type$TokenManagement$AllClosed)),
				$author$project$Material$Styled$Modal$contentContainerstyles($author$project$Page$TokenManagement$styles.modalContainer)
			]),
		_List_fromArray(
			[
				$author$project$Page$TokenManagement$walletStages(tokenManagementModel.modal)
			]));
};
var $author$project$Page$TokenManagement$view = F2(
	function (authModel, model) {
		var rewardsPointsHeaderTxt = model.languageSwitchModel.allLanguageData.location.menuItem.signNetRewardsPoints;
		var pointsManagementPageLanguageData = model.languageSwitchModel.allLanguageData.location.pointsManagement;
		var _v0 = authModel;
		var tokenManagementModel = _v0.tokenManagementModel;
		var redeemRewardList = _v0.redeemRewardList;
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$TokenManagement$styles.container)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$TokenManagement$styles.coverImage)
								]),
							_List_Nil),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$TokenManagement$styles.headerContainer)
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$h1,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css(
											_List_fromArray(
												[
													$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center)
												]))
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(rewardsPointsHeaderTxt)
										]))
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$TokenManagement$styles.container)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Material$Styled$Card$card,
							_List_fromArray(
								[
									$author$project$Material$Styled$Card$containerStyles($author$project$Page$TokenManagement$styles.card)
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$TokenManagement$styles.padding20)
										]),
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$div,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$TokenManagement$styles.introHeader)
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(pointsManagementPageLanguageData.headerText)
												])),
											A2(
											$rtfeldman$elm_css$Html$Styled$span,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$TokenManagement$styles.introText)
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(pointsManagementPageLanguageData.headerDescription),
													A2(
													$author$project$Material$Styled$A$a,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$Attributes$href('https://www.sign.net/rewardpoints'),
															$rtfeldman$elm_css$Html$Styled$Attributes$target('_blank')
														]),
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$text(pointsManagementPageLanguageData.findOutMore)
														]))
												]))
										]))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css(
									_Utils_ap($author$project$Page$TokenManagement$styles.card, $author$project$Page$TokenManagement$styles.balanceCard))
								]),
							_List_fromArray(
								[
									A4($author$project$Page$TokenManagement$systemBalance, model, authModel, tokenManagementModel.available, tokenManagementModel.pending),
									$author$project$Page$TokenManagement$topUpCard(authModel),
									A2($author$project$Page$TokenManagement$walletContainer, model, authModel),
									A2($author$project$Page$TokenManagement$notarisationNetworkToggle, model, authModel),
									A3($author$project$Page$RedeemReward$modals, model, authModel, redeemRewardList.modal),
									A2(
									$author$project$Material$Styled$Card$card,
									_List_fromArray(
										[
											$author$project$Material$Styled$Card$containerStyles($author$project$Page$TokenManagement$styles.sendPointsContainer),
											$author$project$Material$Styled$Card$headerText(pointsManagementPageLanguageData.sendPoints)
										]),
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$div,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$TokenManagement$styles.padding20)
												]),
											_List_fromArray(
												[
													$author$project$Page$TokenManagement$renderBanner(tokenManagementModel.sendToken.banner),
													A2(
													$rtfeldman$elm_css$Html$Styled$div,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$TokenManagement$styles.fieldContainer)
														]),
													_List_fromArray(
														[
															A2(
															$author$project$Material$Styled$Input$text,
															_List_fromArray(
																[
																	$author$project$Material$Styled$Input$containerStyles($author$project$Page$TokenManagement$styles.field),
																	$author$project$Material$Styled$Input$label(pointsManagementPageLanguageData.recipientEmail),
																	$author$project$Material$Styled$Input$value(tokenManagementModel.sendToken.email),
																	$author$project$Material$Styled$Input$onInput(
																	A2(
																		$elm$core$Basics$composeL,
																		A2(
																			$elm$core$Basics$composeL,
																			A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnTokenManagement),
																			$author$project$Type$TokenManagement$OnRecipientEmail),
																		$author$project$Type$TokenManagement$Input)),
																	$author$project$Material$Styled$Input$errorMessage(tokenManagementModel.sendToken.emailError),
																	$author$project$Material$Styled$Input$onBlur(
																	$author$project$Types$OnAuth(
																		$author$project$Types$OnTokenManagement(
																			$author$project$Type$TokenManagement$OnRecipientEmail($author$project$Type$TokenManagement$Blur))))
																]),
															_List_Nil),
															A2(
															$author$project$Material$Styled$Input$text,
															_List_fromArray(
																[
																	$author$project$Material$Styled$Input$containerStyles($author$project$Page$TokenManagement$styles.field),
																	$author$project$Material$Styled$Input$label(pointsManagementPageLanguageData.amount),
																	$author$project$Material$Styled$Input$onInput(
																	A2(
																		$elm$core$Basics$composeL,
																		A2(
																			$elm$core$Basics$composeL,
																			A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnTokenManagement),
																			$author$project$Type$TokenManagement$OnRecipientAmount),
																		$author$project$Type$TokenManagement$Input)),
																	$author$project$Material$Styled$Input$onBlur(
																	$author$project$Types$OnAuth(
																		$author$project$Types$OnTokenManagement(
																			$author$project$Type$TokenManagement$OnRecipientAmount($author$project$Type$TokenManagement$Blur)))),
																	$author$project$Material$Styled$Input$errorMessage(tokenManagementModel.sendToken.amountError),
																	$author$project$Material$Styled$Input$value(tokenManagementModel.sendToken.amount)
																]),
															_List_Nil),
															A2(
															$author$project$Material$Styled$Input$text,
															_List_fromArray(
																[
																	$author$project$Material$Styled$Input$containerStyles($author$project$Page$TokenManagement$styles.field),
																	$author$project$Material$Styled$Input$label(pointsManagementPageLanguageData.remarks),
																	$author$project$Material$Styled$Input$value(tokenManagementModel.sendToken.remarks),
																	$author$project$Material$Styled$Input$onInput(
																	A2(
																		$elm$core$Basics$composeL,
																		A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnTokenManagement),
																		$author$project$Type$TokenManagement$OnRecipientRemarks))
																]),
															_List_Nil)
														])),
													A2(
													$rtfeldman$elm_css$Html$Styled$div,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$TokenManagement$styles.transferButtonContainer)
														]),
													_List_fromArray(
														[
															A2(
															$author$project$Material$Styled$Button$button,
															_List_fromArray(
																[
																	$author$project$Material$Styled$Button$styles($author$project$Page$TokenManagement$styles.buttonWidth),
																	$author$project$Material$Styled$Button$onClick(
																	$author$project$Types$OnAuth(
																		$author$project$Types$OnTokenManagement($author$project$Type$TokenManagement$OnTransactionSubmit)))
																]),
															_List_fromArray(
																[
																	$rtfeldman$elm_css$Html$Styled$text(pointsManagementPageLanguageData.sendButton)
																]))
														]))
												]))
										]))
								])),
							A2(
							$author$project$Material$Styled$Card$card,
							_List_fromArray(
								[
									$author$project$Material$Styled$Card$containerStyles(
									_Utils_ap($author$project$Page$TokenManagement$styles.card, $author$project$Page$TokenManagement$styles.desktopCard)),
									$author$project$Material$Styled$Card$headerText(pointsManagementPageLanguageData.transactionHistory)
								]),
							A2(
								$elm$core$List$cons,
								A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$TokenManagement$styles.transactionRow)
										]),
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$span,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$TokenManagement$styles.headerTitle)
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(
													$elm$core$String$toUpper(pointsManagementPageLanguageData.from))
												])),
											A2(
											$rtfeldman$elm_css$Html$Styled$span,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$TokenManagement$styles.headerTitle)
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(
													$elm$core$String$toUpper(pointsManagementPageLanguageData.to))
												])),
											A2(
											$rtfeldman$elm_css$Html$Styled$span,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$TokenManagement$styles.amountHeaderText)
												]),
											_List_Nil),
											A2(
											$rtfeldman$elm_css$Html$Styled$span,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$TokenManagement$styles.headerTitle)
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(
													$elm$core$String$toUpper(pointsManagementPageLanguageData.time))
												])),
											A2(
											$rtfeldman$elm_css$Html$Styled$span,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$TokenManagement$styles.amountHeaderText)
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(
													$elm$core$String$toUpper(pointsManagementPageLanguageData.amount))
												])),
											A2(
											$rtfeldman$elm_css$Html$Styled$span,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$TokenManagement$styles.shortHeaderTitle)
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(
													$elm$core$String$toUpper(pointsManagementPageLanguageData.status))
												]))
										])),
								_Utils_ap(
									A2(
										$elm$core$List$map,
										function (data) {
											return A2(
												$rtfeldman$elm_css$Html$Styled$div,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$Attributes$css(
														_Utils_ap($author$project$Page$TokenManagement$styles.transactionRow, $author$project$Page$TokenManagement$styles.hoverRow)),
														$rtfeldman$elm_css$Html$Styled$Events$onClick(
														$author$project$Types$OnAuth(
															$author$project$Types$OnTokenManagement(
																$author$project$Type$TokenManagement$OnTransactionClick(data.id))))
													]),
												_List_fromArray(
													[
														A2(
														$rtfeldman$elm_css$Html$Styled$span,
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$TokenManagement$styles.transactionRowText)
															]),
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$text(data.from)
															])),
														A2(
														$rtfeldman$elm_css$Html$Styled$span,
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$TokenManagement$styles.transactionRowText)
															]),
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$text(data.to)
															])),
														A2(
														$rtfeldman$elm_css$Html$Styled$span,
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$TokenManagement$styles.amountColumn)
															]),
														_List_fromArray(
															[
																$author$project$Page$PointsTransactions$TableElements$inOutTags(data.inOut)
															])),
														A2(
														$rtfeldman$elm_css$Html$Styled$span,
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$TokenManagement$styles.dateTimeRowText)
															]),
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$text(
																A2($author$project$Page$PointsTransactions$TableElements$dateFormatter, model.timezone, data.timeStamp) + (' ' + A2($author$project$Page$PointsTransactions$TableElements$timeFormatter, model.timezone, data.timeStamp)))
															])),
														A2(
														$rtfeldman$elm_css$Html$Styled$span,
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$TokenManagement$styles.amountColumn)
															]),
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$text(
																$elm$core$String$fromFloat(data.amount / 100))
															])),
														A2(
														$rtfeldman$elm_css$Html$Styled$span,
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$TokenManagement$styles.shortColumn)
															]),
														_List_fromArray(
															[
																$author$project$Page$PointsTransactions$TableElements$statusTags(data.status)
															]))
													]));
										},
										tokenManagementModel.transactions),
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$span,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$TokenManagement$styles.viewAllButtonContainer)
												]),
											_List_fromArray(
												[
													A2(
													$author$project$Material$Styled$A$a,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$Attributes$href($author$project$Data$Route$routeUrl.transactionHistory)
														]),
													_List_fromArray(
														[
															A2(
															$rtfeldman$elm_css$Html$Styled$span,
															_List_fromArray(
																[
																	$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$TokenManagement$styles.linkText2)
																]),
															_List_fromArray(
																[
																	$rtfeldman$elm_css$Html$Styled$text(pointsManagementPageLanguageData.viewAllButton)
																]))
														]))
												]))
										])))),
							A2(
							$author$project$Material$Styled$Card$card,
							_List_fromArray(
								[
									$author$project$Material$Styled$Card$containerStyles(
									_Utils_ap($author$project$Page$TokenManagement$styles.card, $author$project$Page$TokenManagement$styles.mobileCard)),
									$author$project$Material$Styled$Card$headerText('Token Transaction (Mobile)')
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$TokenManagement$styles.mobileTransactionRow)
										]),
									_Utils_ap(
										$author$project$Page$PointsTransactions$TableElements$displayMobileTable(tokenManagementModel.transactions),
										_List_fromArray(
											[
												A2(
												$rtfeldman$elm_css$Html$Styled$div,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$TokenManagement$styles.viewAllButtonContainer)
													]),
												_List_fromArray(
													[
														A2(
														$author$project$Material$Styled$Button$button,
														_List_fromArray(
															[
																$author$project$Material$Styled$Button$styles($author$project$Page$TokenManagement$styles.buttonWidth),
																$author$project$Material$Styled$Button$onClick(
																$author$project$Types$OnAuth(
																	$author$project$Types$OnTokenManagement($author$project$Type$TokenManagement$OnViewAllClick)))
															]),
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$text(pointsManagementPageLanguageData.viewAllButton)
															]))
													]))
											])))
								]))
						])),
					$author$project$Page$TokenManagement$walletModal(authModel)
				]));
	});
var $author$project$Page$TopUpSuceess$styles = {
	backHomeBtn: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(48)),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(14)),
			$rtfeldman$elm_css$Css$minWidth(
			$rtfeldman$elm_css$Css$px(64))
		]),
	card: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			A2(
			$rtfeldman$elm_css$Css$margin2,
			$rtfeldman$elm_css$Css$zero,
			$rtfeldman$elm_css$Css$px(20)),
			$rtfeldman$elm_css$Css$paddingBottom(
			$rtfeldman$elm_css$Css$px(40)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100)),
			$rtfeldman$elm_css$Css$maxWidth(
			$rtfeldman$elm_css$Css$px(600))
		]),
	checkCircle: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginBottom(
			$rtfeldman$elm_css$Css$px(30))
		]),
	container: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			A2(
			$rtfeldman$elm_css$Css$padding2,
			$rtfeldman$elm_css$Css$px(48),
			$rtfeldman$elm_css$Css$zero)
		]),
	heading: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(24)),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$blueGrey900),
			$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center)
		]),
	logo: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(40)),
			$rtfeldman$elm_css$Css$marginBottom(
			$rtfeldman$elm_css$Css$px(20)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(150)),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(38))
		]),
	main: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$width(
			A3(
				$rtfeldman$elm_css$Css$calc,
				$rtfeldman$elm_css$Css$pct(100),
				$rtfeldman$elm_css$Css$minus,
				$rtfeldman$elm_css$Css$px(48))),
			$rtfeldman$elm_css$Css$padding(
			$rtfeldman$elm_css$Css$px(48)),
			$rtfeldman$elm_css$Css$boxSizing($rtfeldman$elm_css$Css$borderBox),
			A3(
			$rtfeldman$elm_css$Css$borderTop3,
			$rtfeldman$elm_css$Css$px(1),
			$rtfeldman$elm_css$Css$solid,
			$author$project$Material$Styled$Color$grey200),
			A3(
			$rtfeldman$elm_css$Css$borderBottom3,
			$rtfeldman$elm_css$Css$px(1),
			$rtfeldman$elm_css$Css$solid,
			$author$project$Material$Styled$Color$grey200)
		]),
	textContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(14)),
			$rtfeldman$elm_css$Css$lineHeight(
			$rtfeldman$elm_css$Css$px(21)),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$blueGrey900),
			$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$fontWeight(
			$rtfeldman$elm_css$Css$int(400))
		])
};
var $author$project$Page$TopUpSuceess$view = A2(
	$rtfeldman$elm_css$Html$Styled$div,
	_List_fromArray(
		[
			$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$TopUpSuceess$styles.container)
		]),
	_List_fromArray(
		[
			A2(
			$author$project$Material$Styled$Card$card,
			_List_fromArray(
				[
					$author$project$Material$Styled$Card$containerStyles($author$project$Page$TopUpSuceess$styles.card)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$img,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$src($author$project$View$Theme$images.logoColor),
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$TopUpSuceess$styles.logo)
						]),
					_List_Nil),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$TopUpSuceess$styles.main)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Material$Styled$Icon$checkCircle,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Svg$Styled$Attributes$height('100px'),
									$rtfeldman$elm_css$Svg$Styled$Attributes$width('100px'),
									$rtfeldman$elm_css$Svg$Styled$Attributes$fill('green'),
									$rtfeldman$elm_css$Svg$Styled$Attributes$css($author$project$Page$TopUpSuceess$styles.checkCircle)
								]),
							_List_Nil),
							A2(
							$rtfeldman$elm_css$Html$Styled$h2,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$TopUpSuceess$styles.heading)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Successfully Top up your Sign Points')
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$TopUpSuceess$styles.textContainer)
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$p,
									_List_Nil,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('Congratulations! We have successfully credited your account with Sign points.'),
											A2($rtfeldman$elm_css$Html$Styled$br, _List_Nil, _List_Nil),
											A2($rtfeldman$elm_css$Html$Styled$br, _List_Nil, _List_Nil),
											$rtfeldman$elm_css$Html$Styled$text('Questions? We are standing by to provide assistance at '),
											A2(
											$rtfeldman$elm_css$Html$Styled$a,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$href('https://www.sign.net/contact-us/'),
													$rtfeldman$elm_css$Html$Styled$Attributes$target('_blank')
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text('help@sign.net')
												]))
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$a,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$href($author$project$Data$Route$routeUrl.dashboard),
											$rtfeldman$elm_css$Html$Styled$Attributes$css(
											_List_fromArray(
												[
													$rtfeldman$elm_css$Css$maxWidth($rtfeldman$elm_css$Css$fitContent)
												]))
										]),
									_List_fromArray(
										[
											A2(
											$author$project$Material$Styled$Button$button,
											_List_fromArray(
												[
													$author$project$Material$Styled$Button$styles($author$project$Page$TopUpSuceess$styles.backHomeBtn)
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text('Back to Dashboard')
												]))
										]))
								]))
						]))
				]))
		]));
var $author$project$Page$TrustScore$styles = {
	avatar: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$relative),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100)),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$pct(100)),
			$rtfeldman$elm_css$Css$backgroundColor($author$project$Material$Styled$Color$blue100),
			A3(
			$rtfeldman$elm_css$Css$border3,
			$rtfeldman$elm_css$Css$px(2),
			$rtfeldman$elm_css$Css$solid,
			$author$project$Material$Styled$Color$white),
			$rtfeldman$elm_css$Css$borderRadius(
			$rtfeldman$elm_css$Css$pct(50))
		]),
	avatarContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$absolute),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(120)),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(120)),
			$rtfeldman$elm_css$Css$top(
			$rtfeldman$elm_css$Css$px(-60)),
			$rtfeldman$elm_css$Css$left(
			$rtfeldman$elm_css$Css$px(24))
		]),
	avatarEmpty: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$relative),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100)),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$pct(100)),
			$rtfeldman$elm_css$Css$backgroundColor($author$project$Material$Styled$Color$blue100),
			A3(
			$rtfeldman$elm_css$Css$border3,
			$rtfeldman$elm_css$Css$px(2),
			$rtfeldman$elm_css$Css$solid,
			$author$project$Material$Styled$Color$white),
			$rtfeldman$elm_css$Css$borderRadius(
			$rtfeldman$elm_css$Css$pct(50)),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(40)),
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(20)),
			A4(
			$rtfeldman$elm_css$Css$padding4,
			$rtfeldman$elm_css$Css$px(30),
			$rtfeldman$elm_css$Css$px(30),
			$rtfeldman$elm_css$Css$px(30),
			$rtfeldman$elm_css$Css$px(30)),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$white)
		]),
	avatarText: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$absolute),
			$rtfeldman$elm_css$Css$left(
			$rtfeldman$elm_css$Css$px(22.5)),
			$rtfeldman$elm_css$Css$top(
			$rtfeldman$elm_css$Css$px(0)),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$white),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(24))
		]),
	button: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100)),
			$rtfeldman$elm_css$Css$maxWidth(
			$rtfeldman$elm_css$Css$px(400))
		]),
	buttonContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$flexEnd),
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(24))
		]),
	coverImage: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(180)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100)),
			$rtfeldman$elm_css$Css$backgroundImage(
			$rtfeldman$elm_css$Css$url($author$project$View$Theme$images.trustScorePageCover)),
			$rtfeldman$elm_css$Css$backgroundRepeat($rtfeldman$elm_css$Css$noRepeat),
			$rtfeldman$elm_css$Css$backgroundSize($rtfeldman$elm_css$Css$cover),
			A2(
			$rtfeldman$elm_css$Css$backgroundPosition2,
			$rtfeldman$elm_css$Css$pct(100),
			$rtfeldman$elm_css$Css$pct(62))
		]),
	detailsContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$row),
			$rtfeldman$elm_css$Css$flexWrap($rtfeldman$elm_css$Css$wrap),
			A2(
			$rtfeldman$elm_css$Css$padding2,
			$rtfeldman$elm_css$Css$zero,
			$rtfeldman$elm_css$Css$px(36)),
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceBetween),
			A2(
			$rtfeldman$elm_css$Css$margin2,
			$rtfeldman$elm_css$Css$px(30),
			$rtfeldman$elm_css$Css$zero)
		]),
	dividerContainer: _List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Css$margin2,
			$rtfeldman$elm_css$Css$px(30),
			$rtfeldman$elm_css$Css$px(36))
		]),
	emptyAvatarContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$absolute),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(120)),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(120)),
			$rtfeldman$elm_css$Css$top(
			$rtfeldman$elm_css$Css$px(-10)),
			$rtfeldman$elm_css$Css$left(
			$rtfeldman$elm_css$Css$px(24))
		]),
	footer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$row),
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceBetween),
			A3(
			$rtfeldman$elm_css$Css$padding3,
			$rtfeldman$elm_css$Css$px(20),
			$rtfeldman$elm_css$Css$zero,
			$rtfeldman$elm_css$Css$zero)
		]),
	headerContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$row),
			$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$relative),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100)),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(45))
		]),
	modalContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$vw(70)),
			$rtfeldman$elm_css$Css$maxWidth(
			$rtfeldman$elm_css$Css$px(500))
		]),
	modalHeader: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$row),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$flexStart),
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceBetween)
		]),
	modalHeaderTxt: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(20)),
			$rtfeldman$elm_css$Css$fontWeight(
			$rtfeldman$elm_css$Css$int(500))
		]),
	myInfoButton: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$maxWidth(
			$rtfeldman$elm_css$Css$px(160)),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(60))
		]),
	myInfoButtonContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$row),
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceAround),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(24))
		]),
	myInfoDisabled: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$opacity(
			$rtfeldman$elm_css$Css$num(0.4))
		]),
	myInfoImage: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(36))
		]),
	nameText: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(20)),
			$rtfeldman$elm_css$Css$lineHeight(
			$rtfeldman$elm_css$Css$px(24)),
			$rtfeldman$elm_css$Css$fontWeight($rtfeldman$elm_css$Css$bold)
		]),
	passbase: _List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Css$padding2,
			$rtfeldman$elm_css$Css$px(12),
			$rtfeldman$elm_css$Css$px(0)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100)),
			$rtfeldman$elm_css$Css$maxWidth(
			$rtfeldman$elm_css$Css$px(400)),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(16)),
			$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$textDecoration($rtfeldman$elm_css$Css$none),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(14)),
			$rtfeldman$elm_css$Css$fontWeight(
			$rtfeldman$elm_css$Css$int(500)),
			$rtfeldman$elm_css$Css$borderRadius(
			$rtfeldman$elm_css$Css$px(4))
		]),
	passbaseDisabled: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$grey500),
			$rtfeldman$elm_css$Css$backgroundColor($author$project$Material$Styled$Color$grey300)
		]),
	passbaseEnabled: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$white),
			$rtfeldman$elm_css$Css$backgroundColor($author$project$Material$Styled$Color$blueA700)
		]),
	redText: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$red500)
		]),
	trustScoreContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(30)),
			A2(
			$rtfeldman$elm_css$Css$padding2,
			$rtfeldman$elm_css$Css$zero,
			$rtfeldman$elm_css$Css$px(36))
		]),
	trustScoreIcon: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(75)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(75)),
			A2(
			$rtfeldman$elm_css$Css$margin2,
			$rtfeldman$elm_css$Css$px(25),
			$rtfeldman$elm_css$Css$px(0))
		]),
	userDetailsContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$start),
			A2(
			$rtfeldman$elm_css$Css$margin2,
			$rtfeldman$elm_css$Css$px(24),
			$rtfeldman$elm_css$Css$px(160)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100))
		]),
	verificationContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(30)),
			A2(
			$rtfeldman$elm_css$Css$padding2,
			$rtfeldman$elm_css$Css$zero,
			$rtfeldman$elm_css$Css$px(24))
		])
};
var $author$project$Page$TrustScore$avatar = function (user) {
	var _v0 = user.avatarUrl;
	if (_v0.$ === 'Just') {
		var url = _v0.a;
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$TrustScore$styles.avatarContainer)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$a,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$img,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$TrustScore$styles.avatar),
									$rtfeldman$elm_css$Html$Styled$Attributes$src(url)
								]),
							_List_Nil)
						]))
				]));
	} else {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$TrustScore$styles.emptyAvatarContainer)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$a,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$TrustScore$styles.avatarEmpty)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$elm$core$String$toUpper(
								_Utils_ap(
									A2($elm$core$String$left, 1, user.firstName),
									A2($elm$core$String$left, 1, user.lastName))))
						]))
				]));
	}
};
var $author$project$Type$TrustScore$Dashboard = {$: 'Dashboard'};
var $author$project$Type$TrustScore$RedirectTo = function (a) {
	return {$: 'RedirectTo', a: a};
};
var $author$project$Page$TrustScore$passbaseModal = F2(
	function (user, trustScoreModel) {
		var error = trustScoreModel.passbaseError;
		var displayTxt = _Utils_eq(error, $elm$core$Maybe$Nothing) ? ('An email has been sent to you at ' + (user.email + '. Click the link in your email to be redirect to passbase verification website.')) : ('Error:  ' + A2($elm$core$Maybe$withDefault, '', trustScoreModel.passbaseError));
		return A2(
			$author$project$Material$Styled$Modal$modal,
			_List_fromArray(
				[
					$author$project$Material$Styled$Modal$open(trustScoreModel.passbaseModal),
					$author$project$Material$Styled$Modal$contentContainerstyles($author$project$Page$TrustScore$styles.modalContainer)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$TrustScore$styles.modalHeader)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$TrustScore$styles.modalHeaderTxt)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Passbase Verification')
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(displayTxt)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$TrustScore$styles.footer)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Material$Styled$Button$button,
							_List_fromArray(
								[
									$author$project$Material$Styled$Button$onClick(
									$author$project$Types$OnAuth(
										$author$project$Types$OnTrustScore(
											$author$project$Type$TrustScore$RedirectTo($author$project$Type$TrustScore$Dashboard))))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Back to dashboard')
								]))
						]))
				]));
	});
var $author$project$Model$TrustScore$badges = F3(
	function (model, appDomain, domain) {
		var trustScoreList = _List_fromArray(
			[model.creditCard, model.mobilePhone, model.myInfo, model.wallet]);
		return A2($author$project$Data$Domain$equal, domain, appDomain) ? trustScoreList : A2($elm$core$List$cons, model.corporate, trustScoreList);
	});
var $author$project$Page$TrustScore$corporate = function (_v0) {
	return {
		button: _List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$TrustScore$styles.buttonContainer)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Material$Styled$Button$button,
						_List_fromArray(
							[
								$author$project$Material$Styled$Button$styles($author$project$Page$TrustScore$styles.button),
								$author$project$Material$Styled$Button$disabled(true),
								$author$project$Material$Styled$Button$theme($author$project$Material$Styled$Button$grey)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('COMING SOON')
							]))
					]))
			]),
		displayCheckbox: false,
		header: 'CORPORATE',
		info: _List_fromArray(
			['Verifying your organization with us allows you to have a organizational account with organizational contacts. You will be able to add users from your company and issue permissions for them to sign on behalf of your company. There is also the added advantage of a shared storage where documents sent to the company will be stored and accessible based on permission levels.']),
		subHeader: 'Why verify your organization?',
		terms: _List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$p,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('Verifying your corporate details with us will increase trust score and display to the public that you are an official representative of the company. Our verification team will followup if further details are required.')
					]))
			])
	};
};
var $author$project$Data$Badge$map = F2(
	function (mapper, badge) {
		switch (badge.$) {
			case 'MyInfo':
				var status = badge.a;
				return mapper(status);
			case 'MobilePhone':
				var status = badge.a;
				return mapper(status);
			case 'Corporate':
				var status = badge.a;
				return mapper(status);
			case 'CreditCard':
				var status = badge.a;
				return mapper(status);
			default:
				var status = badge.a;
				return mapper(status);
		}
	});
var $author$project$Page$TrustScore$buttonConfig = function (badge) {
	return A2(
		$author$project$Data$Badge$map,
		$elm$core$Basics$eq($author$project$Data$Badge$NotVerified),
		badge) ? _List_fromArray(
		[
			$author$project$Material$Styled$Button$styles($author$project$Page$TrustScore$styles.button),
			$author$project$Material$Styled$Button$disabled(true),
			$author$project$Material$Styled$Button$theme($author$project$Material$Styled$Button$grey)
		]) : _List_fromArray(
		[
			$author$project$Material$Styled$Button$styles($author$project$Page$TrustScore$styles.button),
			$author$project$Material$Styled$Button$disabled(false),
			$author$project$Material$Styled$Button$theme($author$project$Material$Styled$Button$blue)
		]);
};
var $author$project$Page$TrustScore$creditCard = F2(
	function (model, badge) {
		var verificationPageLanguageData = model.languageSwitchModel.allLanguageData.location.verificationPage;
		return {
			button: _List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$TrustScore$styles.buttonContainer)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Material$Styled$Button$button,
							$author$project$Page$TrustScore$buttonConfig(badge),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$elm$core$String$toUpper(verificationPageLanguageData.comingSoon))
								]))
						]))
				]),
			displayCheckbox: false,
			header: $elm$core$String$toUpper(verificationPageLanguageData.creditCard),
			info: _List_fromArray(
				[verificationPageLanguageData.creditCardDescriptionText]),
			subHeader: 'Why verify Credit Card Detail?',
			terms: _List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(verificationPageLanguageData.creditCardDescriptionText)
						]))
				])
		};
	});
var $author$project$Type$TrustScore$Account = {$: 'Account'};
var $author$project$Type$TrustScore$MobileModal = function (a) {
	return {$: 'MobileModal', a: a};
};
var $author$project$Type$TrustScore$Open = {$: 'Open'};
var $author$project$Page$TrustScore$mobilePhoneStyle = F2(
	function (badge, phoneNumber) {
		if (phoneNumber.$ === 'Just') {
			return A2(
				$author$project$Data$Badge$map,
				$elm$core$Basics$eq($author$project$Data$Badge$NotVerified),
				badge) ? _List_fromArray(
				[
					$author$project$Material$Styled$Button$styles($author$project$Page$TrustScore$styles.button),
					$author$project$Material$Styled$Button$disabled(true),
					$author$project$Material$Styled$Button$theme($author$project$Material$Styled$Button$grey)
				]) : _List_fromArray(
				[
					$author$project$Material$Styled$Button$styles($author$project$Page$TrustScore$styles.button),
					$author$project$Material$Styled$Button$disabled(false),
					$author$project$Material$Styled$Button$theme($author$project$Material$Styled$Button$blue),
					$author$project$Material$Styled$Button$onClick(
					$author$project$Types$OnAuth(
						$author$project$Types$OnTrustScore(
							$author$project$Type$TrustScore$MobileModal($author$project$Type$TrustScore$Open))))
				]);
		} else {
			return _List_fromArray(
				[
					$author$project$Material$Styled$Button$styles($author$project$Page$TrustScore$styles.button),
					$author$project$Material$Styled$Button$disabled(false),
					$author$project$Material$Styled$Button$theme($author$project$Material$Styled$Button$blue),
					$author$project$Material$Styled$Button$onClick(
					$author$project$Types$OnAuth(
						$author$project$Types$OnTrustScore(
							$author$project$Type$TrustScore$RedirectTo($author$project$Type$TrustScore$Account))))
				]);
		}
	});
var $author$project$Page$TrustScore$mobilePhone = F3(
	function (model, user, badge) {
		var verificationPageLanguageData = model.languageSwitchModel.allLanguageData.location.verificationPage;
		var displayText = function () {
			var _v0 = user.phoneNumber;
			if (_v0.$ === 'Just') {
				var number = _v0.a;
				return A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('Verify that your phone number is ' + number)
						]));
			} else {
				return A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$TrustScore$styles.redText)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('You did not provide a phone number for your account. Click button below to go to Account page')
						]));
			}
		}();
		return {
			button: _List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$TrustScore$styles.buttonContainer)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Material$Styled$Button$button,
							A2($author$project$Page$TrustScore$mobilePhoneStyle, badge, user.phoneNumber),
							_List_fromArray(
								[
									(!_Utils_eq(user.phoneNumber, $elm$core$Maybe$Nothing)) ? $rtfeldman$elm_css$Html$Styled$text(
									$elm$core$String$toUpper(verificationPageLanguageData.verify)) : $rtfeldman$elm_css$Html$Styled$text(
									$elm$core$String$toUpper(verificationPageLanguageData.goToAccount))
								]))
						]))
				]),
			displayCheckbox: !_Utils_eq(user.phoneNumber, $elm$core$Maybe$Nothing),
			header: $elm$core$String$toUpper(verificationPageLanguageData.mobilePhone),
			info: _List_fromArray(
				['Having your mobile phone verified is part of your overall identity verification, and increases your trust score. Your mobile phone number will not be used to contact you without your permission.']),
			subHeader: 'Why Verify Mobile Phone Number?',
			terms: _List_fromArray(
				[
					displayText,
					A2(
					$rtfeldman$elm_css$Html$Styled$p,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(verificationPageLanguageData.mobilePhoneDescriptionText)
						]))
				])
		};
	});
var $author$project$Material$Styled$Button$Theme = F3(
	function (base, ripple, text) {
		return {base: base, ripple: ripple, text: text};
	});
var $author$project$Type$TrustScore$VerifyClick = function (a) {
	return {$: 'VerifyClick', a: a};
};
var $author$project$Page$TrustScore$myinfoButtonConfig = function (badge) {
	return A2(
		$author$project$Data$Badge$map,
		$elm$core$Basics$eq($author$project$Data$Badge$NotVerified),
		badge) ? _List_fromArray(
		[
			$author$project$Material$Styled$Button$styles(
			_Utils_ap($author$project$Page$TrustScore$styles.myInfoButton, $author$project$Page$TrustScore$styles.myInfoDisabled)),
			$author$project$Material$Styled$Button$disabled(true),
			$author$project$Material$Styled$Button$theme($author$project$Material$Styled$Button$grey)
		]) : _List_fromArray(
		[
			$author$project$Material$Styled$Button$styles($author$project$Page$TrustScore$styles.myInfoButton),
			$author$project$Material$Styled$Button$disabled(false),
			$author$project$Material$Styled$Button$onClick(
			$author$project$Types$OnAuth(
				$author$project$Types$OnTrustScore(
					$author$project$Type$TrustScore$VerifyClick(badge)))),
			$author$project$Material$Styled$Button$theme(
			A3($author$project$Material$Styled$Button$Theme, $author$project$Material$Styled$Color$whiteString, $author$project$Material$Styled$Color$blueA200String, $author$project$Material$Styled$Color$whiteString))
		]);
};
var $author$project$Page$TrustScore$myInfo = function (badge) {
	return {
		button: _List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$TrustScore$styles.myInfoButtonContainer)
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('Verify with MyInfo')
							])),
						A2(
						$author$project$Material$Styled$Button$button,
						$author$project$Page$TrustScore$myinfoButtonConfig(badge),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$img,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$src($author$project$View$Theme$images.myInfoLogo),
										$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$TrustScore$styles.myInfoImage)
									]),
								_List_Nil)
							]))
					]))
			]),
		displayCheckbox: true,
		header: 'MYINFO',
		info: _List_fromArray(
			['MyInfo is a Singapore Government service for Singapore citizens and residents to manage their personal info.', 'Having MyInfo verified on your profile lets others know that your details have been verified by official sources and increases your trust score.', 'Sign.net is working to make verification using other forms of government managed identity systems available to users. If you have any suggestions, please contact us at help@sign.net.']),
		subHeader: 'Why verify with MyInfo?',
		terms: _List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$p,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('Verification through MyInfo service is only available to Singapore citizens and residents. Upon proceeding, you will be required to login via SingPass to authorize MyInfo retrieval of data. We will only retrieve NRIC, Name, Date of Birth, Mobile Number, Email & Registered Address. ')
					]))
			])
	};
};
var $author$project$Type$TrustScore$PointsManagement = {$: 'PointsManagement'};
var $author$project$Page$TrustScore$wallet = function (model) {
	var verificationPageLanguageData = model.languageSwitchModel.allLanguageData.location.verificationPage;
	return {
		button: _List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$TrustScore$styles.buttonContainer)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Material$Styled$Button$button,
						_List_fromArray(
							[
								$author$project$Material$Styled$Button$styles($author$project$Page$TrustScore$styles.button),
								$author$project$Material$Styled$Button$disabled(false),
								$author$project$Material$Styled$Button$theme($author$project$Material$Styled$Button$blue),
								$author$project$Material$Styled$Button$onClick(
								$author$project$Types$OnAuth(
									$author$project$Types$OnTrustScore(
										$author$project$Type$TrustScore$RedirectTo($author$project$Type$TrustScore$PointsManagement))))
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(verificationPageLanguageData.redirectToPointManagementPage)
							]))
					]))
			]),
		displayCheckbox: false,
		header: $elm$core$String$toUpper(verificationPageLanguageData.wallet),
		info: _List_fromArray(
			['Some Text about verifying wallet']),
		subHeader: 'Why verify wallet?',
		terms: _List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$p,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(verificationPageLanguageData.walletDescription)
					]))
			])
	};
};
var $author$project$Page$TrustScore$getDetail = F4(
	function (model, user, badge, passbaseUrl) {
		switch (badge.$) {
			case 'MyInfo':
				return $author$project$Page$TrustScore$myInfo(badge);
			case 'MobilePhone':
				return A3($author$project$Page$TrustScore$mobilePhone, model, user, badge);
			case 'Corporate':
				return $author$project$Page$TrustScore$corporate(badge);
			case 'CreditCard':
				return A2($author$project$Page$TrustScore$creditCard, model, badge);
			default:
				return $author$project$Page$TrustScore$wallet(model);
		}
	});
var $author$project$Type$TrustScore$AcceptTerms = function (a) {
	return {$: 'AcceptTerms', a: a};
};
var $author$project$Type$TrustScore$DeclineTerms = function (a) {
	return {$: 'DeclineTerms', a: a};
};
var $author$project$Page$TrustScore$Detail$getClickedStatus = function (badge) {
	return A2(
		$author$project$Data$Badge$map,
		$elm$core$Basics$eq($author$project$Data$Badge$AgreeToVerify),
		badge);
};
var $author$project$Page$TrustScore$Detail$clickHandler = function (badge) {
	return $author$project$Page$TrustScore$Detail$getClickedStatus(badge) ? $author$project$Types$OnAuth(
		$author$project$Types$OnTrustScore(
			$author$project$Type$TrustScore$DeclineTerms(badge))) : $author$project$Types$OnAuth(
		$author$project$Types$OnTrustScore(
			$author$project$Type$TrustScore$AcceptTerms(badge)));
};
var $author$project$Page$TrustScore$Detail$helpLink = function (badge) {
	switch (badge.$) {
		case 'MyInfo':
			return 'https://www.sign.net/signer-identity/';
		case 'MobilePhone':
			return 'https://www.sign.net/trust-score/';
		case 'Corporate':
			return 'https://www.sign.net/trust-score/';
		case 'CreditCard':
			return 'https://www.sign.net/trust-score/';
		default:
			return 'https://www.sign.net/trust-score/';
	}
};
var $author$project$Page$TrustScore$Detail$styles = {
	cardContent: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceBetween),
			A4(
			$rtfeldman$elm_css$Css$padding4,
			$rtfeldman$elm_css$Css$px(12),
			$rtfeldman$elm_css$Css$px(24),
			$rtfeldman$elm_css$Css$px(24),
			$rtfeldman$elm_css$Css$px(24))
		]),
	header: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$row),
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceBetween),
			A2(
			$rtfeldman$elm_css$Css$padding2,
			$rtfeldman$elm_css$Css$zero,
			$rtfeldman$elm_css$Css$px(24)),
			$rtfeldman$elm_css$Css$fontWeight($rtfeldman$elm_css$Css$bold)
		]),
	helpIcon: _List_fromArray(
		[
			$rtfeldman$elm_css$Svg$Styled$Attributes$width('20'),
			$rtfeldman$elm_css$Svg$Styled$Attributes$height('20')
		]),
	icon: _List_fromArray(
		[
			$rtfeldman$elm_css$Svg$Styled$Attributes$width('90'),
			$rtfeldman$elm_css$Svg$Styled$Attributes$height('90')
		]),
	imageContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(100)),
			$rtfeldman$elm_css$Css$padding(
			$rtfeldman$elm_css$Css$px(10)),
			$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center)
		]),
	innerCard: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(48)),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$pct(100)),
			$rtfeldman$elm_css$Css$marginBottom(
			$rtfeldman$elm_css$Css$px(20)),
			A2(
			$rtfeldman$elm_css$Css$Media$withMediaQuery,
			_List_fromArray(
				['screen and (max-width: 800px)']),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$width(
					$rtfeldman$elm_css$Css$pct(100))
				])),
			$rtfeldman$elm_css$Css$lastChild(
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Css$nthChild,
					'odd',
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$width(
							$rtfeldman$elm_css$Css$pct(100))
						]))
				]))
		]),
	myInfoImage: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(90))
		]),
	terms: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$row),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			A2(
			$rtfeldman$elm_css$Css$margin2,
			$rtfeldman$elm_css$Css$px(24),
			$rtfeldman$elm_css$Css$zero)
		])
};
var $author$project$Page$TrustScore$Detail$renderIcon = function (badge) {
	switch (badge.$) {
		case 'MyInfo':
			return A2(
				$rtfeldman$elm_css$Html$Styled$img,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$src($author$project$View$Theme$images.myInfoLogo),
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$TrustScore$Detail$styles.myInfoImage)
					]),
				_List_Nil);
		case 'MobilePhone':
			return A2($author$project$Material$Styled$Icon$phoneLinkLock, $author$project$Page$TrustScore$Detail$styles.icon, _List_Nil);
		case 'Corporate':
			return A2($author$project$Material$Styled$Icon$business, $author$project$Page$TrustScore$Detail$styles.icon, _List_Nil);
		case 'CreditCard':
			return A2($author$project$Material$Styled$Icon$payment, $author$project$Page$TrustScore$Detail$styles.icon, _List_Nil);
		default:
			return A2($author$project$Material$Styled$Icon$accountBalanceWallet, $author$project$Page$TrustScore$Detail$styles.icon, _List_Nil);
	}
};
var $author$project$Page$TrustScore$Detail$view = F3(
	function (model, data, badge) {
		var verificationPageLanguageData = model.languageSwitchModel.allLanguageData.location.verificationPage;
		return A2(
			$author$project$Material$Styled$Card$card,
			_List_fromArray(
				[
					$author$project$Material$Styled$Card$containerStyles($author$project$Page$TrustScore$Detail$styles.innerCard)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$TrustScore$Detail$styles.imageContainer)
						]),
					_List_fromArray(
						[
							$author$project$Page$TrustScore$Detail$renderIcon(badge)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$TrustScore$Detail$styles.header)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(data.header),
							A2(
							$author$project$Material$Styled$A$a,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$href(
									$author$project$Page$TrustScore$Detail$helpLink(badge)),
									$rtfeldman$elm_css$Html$Styled$Attributes$target('_blank')
								]),
							_List_fromArray(
								[
									A2($author$project$Material$Styled$Icon$help, $author$project$Page$TrustScore$Detail$styles.helpIcon, _List_Nil)
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$TrustScore$Detail$styles.cardContent),
							A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'data-test', data.header)
						]),
					_Utils_ap(
						data.terms,
						_Utils_ap(
							data.displayCheckbox ? _List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$TrustScore$Detail$styles.terms)
										]),
									_List_fromArray(
										[
											A2(
											$author$project$Material$Styled$Checkbox$checkbox,
											_List_fromArray(
												[
													$author$project$Material$Styled$Checkbox$checked(
													$author$project$Page$TrustScore$Detail$getClickedStatus(badge)),
													$author$project$Material$Styled$Checkbox$onClick(
													$author$project$Page$TrustScore$Detail$clickHandler(badge))
												]),
											_List_Nil),
											$rtfeldman$elm_css$Html$Styled$text(verificationPageLanguageData.acknowledgementText)
										])),
									A2($author$project$Material$Styled$Divider$divider, _List_Nil, _List_Nil)
								]) : _List_fromArray(
								[
									A2($author$project$Material$Styled$Divider$divider, _List_Nil, _List_Nil)
								]),
							data.button)))
				]));
	});
var $author$project$Page$TrustScore$generateCardHtml = F4(
	function (model, user, passbaseUrl, badge) {
		return A3(
			$author$project$Page$TrustScore$Detail$view,
			model,
			A4($author$project$Page$TrustScore$getDetail, model, user, badge, passbaseUrl),
			badge);
	});
var $author$project$Page$TrustScore$renderDetail = F5(
	function (model, appDomain, trustScoreModel, user, passbaseUrl) {
		var unverifiedBadges = A2(
			$elm$core$List$filter,
			$author$project$Data$Badge$map(
				$elm$core$Basics$neq($author$project$Data$Badge$Verified)),
			A3(
				$author$project$Model$TrustScore$badges,
				trustScoreModel,
				appDomain,
				$author$project$Data$Domain$selected(user.domains)));
		return A2(
			$elm$core$List$map,
			A3($author$project$Page$TrustScore$generateCardHtml, model, user, passbaseUrl),
			unverifiedBadges);
	});
var $author$project$Material$Styled$Card$HeaderStyle = function (a) {
	return {$: 'HeaderStyle', a: a};
};
var $author$project$Material$Styled$Card$headerStyles = function (style) {
	return $author$project$Material$Styled$Card$HeaderStyle(style);
};
var $author$project$Data$Badge$description = F2(
	function (languageSwitchModel, badge) {
		var verificationPageLanguageData = languageSwitchModel.allLanguageData.location.verificationPage;
		switch (badge.$) {
			case 'MyInfo':
				return 'MyInfo is the Singapore government powered official data source. We allow citizens and permanent residents who have a SingPass login to use this method to verify accounts.';
			case 'MobilePhone':
				return verificationPageLanguageData.mobilePhoneVerificationText;
			case 'Corporate':
				return 'Verifying your organization with us allows you to have a organizational account with organizational contacts. You will be able to add users from your company and issue permissions for them to sign on behalf of your company.';
			case 'CreditCard':
				return verificationPageLanguageData.creditCardVerificationText;
			default:
				return '';
		}
	});
var $author$project$Data$Badge$name = F2(
	function (languageSwitchModel, badge) {
		var verificationPageLanguageData = languageSwitchModel.allLanguageData.location.verificationPage;
		switch (badge.$) {
			case 'MyInfo':
				return 'MyInfo';
			case 'MobilePhone':
				return verificationPageLanguageData.mobilePhone;
			case 'Corporate':
				return 'Corporate';
			case 'CreditCard':
				return verificationPageLanguageData.creditCard;
			default:
				return verificationPageLanguageData.wallet;
		}
	});
var $author$project$Material$Styled$Color$green600String = '#43A047';
var $author$project$Material$Styled$Color$green600 = $rtfeldman$elm_css$Css$hex($author$project$Material$Styled$Color$green600String);
var $author$project$Page$TrustScore$Summary$styles = {
	badgeDetails: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$row),
			$rtfeldman$elm_css$Css$flexWrap($rtfeldman$elm_css$Css$wrap),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100)),
			$rtfeldman$elm_css$Css$minHeight(
			$rtfeldman$elm_css$Css$px(50)),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center)
		]),
	badgeIcon: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$minWidth(
			$rtfeldman$elm_css$Css$px(60)),
			$rtfeldman$elm_css$Css$marginRight(
			$rtfeldman$elm_css$Css$px(10)),
			$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center)
		]),
	badgeName: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$minWidth(
			$rtfeldman$elm_css$Css$px(150))
		]),
	cardContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100)),
			$rtfeldman$elm_css$Css$minWidth(
			$rtfeldman$elm_css$Css$px(500)),
			A2(
			$rtfeldman$elm_css$Css$Media$withMediaQuery,
			_List_fromArray(
				['screen and (max-width: 800px)']),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$width(
					$rtfeldman$elm_css$Css$pct(100)),
					$rtfeldman$elm_css$Css$marginTop(
					$rtfeldman$elm_css$Css$px(20)),
					$rtfeldman$elm_css$Css$minWidth(
					$rtfeldman$elm_css$Css$px(300))
				]))
		]),
	cardContent: _List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Css$padding2,
			$rtfeldman$elm_css$Css$zero,
			$rtfeldman$elm_css$Css$px(24))
		]),
	container: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$row),
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceBetween),
			A2(
			$rtfeldman$elm_css$Css$margin2,
			$rtfeldman$elm_css$Css$px(12),
			$rtfeldman$elm_css$Css$zero),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100)),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$pct(100)),
			$rtfeldman$elm_css$Css$flexWrap($rtfeldman$elm_css$Css$wrap)
		]),
	description: _List_fromArray(
		[
			A4(
			$rtfeldman$elm_css$Css$padding4,
			$rtfeldman$elm_css$Css$px(5),
			$rtfeldman$elm_css$Css$px(10),
			$rtfeldman$elm_css$Css$zero,
			$rtfeldman$elm_css$Css$zero),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(13)),
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(10)),
			$rtfeldman$elm_css$Css$maxWidth(
			$rtfeldman$elm_css$Css$px(650)),
			$rtfeldman$elm_css$Css$flexWrap($rtfeldman$elm_css$Css$wrap),
			A2(
			$rtfeldman$elm_css$Css$Media$withMediaQuery,
			_List_fromArray(
				['screen and (min-width: 1430px)']),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$maxWidth(
					$rtfeldman$elm_css$Css$px(900))
				]))
		]),
	headerStyle: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontWeight($rtfeldman$elm_css$Css$bold)
		]),
	myInfoImage: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(36))
		]),
	notVerifiedTag: _List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Css$padding2,
			$rtfeldman$elm_css$Css$px(4),
			$rtfeldman$elm_css$Css$px(8)),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(10)),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(20)),
			$rtfeldman$elm_css$Css$backgroundColor($author$project$Material$Styled$Color$grey600),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$white),
			$rtfeldman$elm_css$Css$borderRadius(
			$rtfeldman$elm_css$Css$px(2)),
			$rtfeldman$elm_css$Css$marginBottom(
			$rtfeldman$elm_css$Css$px(20))
		]),
	verifiedContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$row),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			A2(
			$rtfeldman$elm_css$Css$padding2,
			$rtfeldman$elm_css$Css$px(16),
			$rtfeldman$elm_css$Css$zero),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100)),
			$rtfeldman$elm_css$Css$minWidth(
			$rtfeldman$elm_css$Css$px(250)),
			A2(
			$rtfeldman$elm_css$Css$Media$withMediaQuery,
			_List_fromArray(
				['screen and (max-width: 425px)']),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Css$borderBottom2,
					$rtfeldman$elm_css$Css$px(0.5),
					$rtfeldman$elm_css$Css$solid),
					$rtfeldman$elm_css$Css$lastChild(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$borderBottom($rtfeldman$elm_css$Css$zero)
						]))
				]))
		]),
	verifiedTag: _List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Css$padding2,
			$rtfeldman$elm_css$Css$px(4),
			$rtfeldman$elm_css$Css$px(8)),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(10)),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(20)),
			$rtfeldman$elm_css$Css$backgroundColor($author$project$Material$Styled$Color$green600),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$white),
			$rtfeldman$elm_css$Css$borderRadius(
			$rtfeldman$elm_css$Css$px(2))
		])
};
var $author$project$Page$TrustScore$Summary$renderIcon = function (badge) {
	switch (badge.$) {
		case 'MyInfo':
			return A2(
				$rtfeldman$elm_css$Html$Styled$img,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$src($author$project$View$Theme$images.myInfoLogo),
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$TrustScore$Summary$styles.myInfoImage)
					]),
				_List_Nil);
		case 'MobilePhone':
			return A2($author$project$Material$Styled$Icon$phoneLinkLock, _List_Nil, _List_Nil);
		case 'Corporate':
			return A2($author$project$Material$Styled$Icon$business, _List_Nil, _List_Nil);
		case 'CreditCard':
			return A2($author$project$Material$Styled$Icon$payment, _List_Nil, _List_Nil);
		default:
			return A2($author$project$Material$Styled$Icon$accountBalanceWallet, _List_Nil, _List_Nil);
	}
};
var $author$project$Page$TrustScore$Summary$verifiedTag = F2(
	function (languageSwitchModel, verified) {
		var verificationPageLanguageData = languageSwitchModel.allLanguageData.location.verificationPage;
		return verified ? A2(
			$rtfeldman$elm_css$Html$Styled$span,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$TrustScore$Summary$styles.verifiedTag)
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text(verificationPageLanguageData.verified)
				])) : A2(
			$rtfeldman$elm_css$Html$Styled$span,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$TrustScore$Summary$styles.notVerifiedTag)
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text(verificationPageLanguageData.notVerified)
				]));
	});
var $author$project$Page$TrustScore$Summary$renderBadge = F2(
	function (languageSwitchModel, badge) {
		return A2(
			$author$project$Data$Badge$map,
			$elm$core$Basics$eq($author$project$Data$Badge$Verified),
			badge) ? A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$TrustScore$Summary$styles.verifiedContainer),
					A2(
					$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
					'data-test',
					A2($author$project$Data$Badge$name, languageSwitchModel, badge))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$TrustScore$Summary$styles.badgeDetails)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$TrustScore$Summary$styles.badgeIcon)
								]),
							_List_fromArray(
								[
									$author$project$Page$TrustScore$Summary$renderIcon(badge)
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$TrustScore$Summary$styles.badgeName)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									A2($author$project$Data$Badge$name, languageSwitchModel, badge))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_Nil,
							_List_fromArray(
								[
									A2($author$project$Page$TrustScore$Summary$verifiedTag, languageSwitchModel, true)
								]))
						]))
				])) : A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$TrustScore$Summary$styles.verifiedContainer),
					A2(
					$rtfeldman$elm_css$Html$Styled$Attributes$attribute,
					'data-test',
					A2($author$project$Data$Badge$name, languageSwitchModel, badge))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$TrustScore$Summary$styles.badgeDetails)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$TrustScore$Summary$styles.badgeIcon)
								]),
							_List_fromArray(
								[
									$author$project$Page$TrustScore$Summary$renderIcon(badge)
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$TrustScore$Summary$styles.badgeName)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									A2($author$project$Data$Badge$name, languageSwitchModel, badge))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_Nil,
							_List_fromArray(
								[
									A2($author$project$Page$TrustScore$Summary$verifiedTag, languageSwitchModel, false),
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$TrustScore$Summary$styles.description)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											A2($author$project$Data$Badge$description, languageSwitchModel, badge))
										]))
								]))
						]))
				]));
	});
var $author$project$Page$TrustScore$Summary$summary = F3(
	function (appDomain, authModel, languageSwitchModel) {
		var verificationPageLanguageData = languageSwitchModel.allLanguageData.location.verificationPage;
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$TrustScore$Summary$styles.container)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Material$Styled$Card$card,
					_List_fromArray(
						[
							$author$project$Material$Styled$Card$containerStyles($author$project$Page$TrustScore$Summary$styles.cardContainer),
							$author$project$Material$Styled$Card$headerText(verificationPageLanguageData.verificationMethods),
							$author$project$Material$Styled$Card$headerStyles($author$project$Page$TrustScore$Summary$styles.headerStyle)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$TrustScore$Summary$styles.cardContent)
								]),
							A2(
								$elm$core$List$map,
								$author$project$Page$TrustScore$Summary$renderBadge(languageSwitchModel),
								A3(
									$author$project$Model$TrustScore$badges,
									authModel.trustScoreModel,
									appDomain,
									$author$project$Data$Domain$selected(authModel.user.domains))))
						]))
				]));
	});
var $author$project$Page$TrustScore$userDetails = F3(
	function (firstName, lastName, email) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$TrustScore$styles.userDetailsContainer)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$TrustScore$styles.nameText)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(firstName + (' ' + lastName))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(email)
						]))
				]));
	});
var $author$project$Type$TrustScore$OnVerifyCodeInput = function (a) {
	return {$: 'OnVerifyCodeInput', a: a};
};
var $author$project$Type$TrustScore$PendingVerify = {$: 'PendingVerify'};
var $author$project$Page$TrustScore$Modal$styles = {
	button: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(100)),
			$rtfeldman$elm_css$Css$marginLeft(
			$rtfeldman$elm_css$Css$px(10))
		]),
	buttonContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$row),
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$flexEnd)
		]),
	error: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$red700)
		]),
	input: _List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Css$Media$withMediaQuery,
			_List_fromArray(
				['screen and (max-width: 425px)']),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$width(
					$rtfeldman$elm_css$Css$pct(100))
				]))
		]),
	modalContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$vw(70)),
			$rtfeldman$elm_css$Css$maxWidth(
			$rtfeldman$elm_css$Css$px(500))
		]),
	modalContent: _List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Css$margin2,
			$rtfeldman$elm_css$Css$px(20),
			$rtfeldman$elm_css$Css$px(0)),
			$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center)
		]),
	modalHeader: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$row),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$flexStart),
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceBetween),
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(5))
		]),
	modalHeaderTxt: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(20)),
			$rtfeldman$elm_css$Css$fontWeight(
			$rtfeldman$elm_css$Css$int(500))
		]),
	text: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginBottom(
			$rtfeldman$elm_css$Css$px(20))
		]),
	verifyColumn: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			A2(
			$rtfeldman$elm_css$Css$Media$withMediaQuery,
			_List_fromArray(
				['screen and (max-width: 425px)']),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceAround),
					$rtfeldman$elm_css$Css$height(
					$rtfeldman$elm_css$Css$px(50))
				]))
		]),
	verifyContent: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$row),
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceBetween),
			A2(
			$rtfeldman$elm_css$Css$margin2,
			$rtfeldman$elm_css$Css$px(20),
			$rtfeldman$elm_css$Css$px(0)),
			A2(
			$rtfeldman$elm_css$Css$Media$withMediaQuery,
			_List_fromArray(
				['screen and (max-width: 425px)']),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$flexWrap($rtfeldman$elm_css$Css$wrap)
				]))
		])
};
var $author$project$Page$TrustScore$Modal$displayModal = F4(
	function (status, phoneNumber, code, error) {
		var number = A2($elm$core$Maybe$withDefault, 'No Number', phoneNumber);
		switch (status.$) {
			case 'Open':
				return A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$TrustScore$Modal$styles.modalContent)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$TrustScore$Modal$styles.text)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Sending Verification Message to ' + number)
								])),
							A2($author$project$Material$Styled$ProgressBar$linear, _List_Nil, _List_Nil)
						]));
			case 'Verify':
				return A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$TrustScore$Modal$styles.error)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									A2($elm$core$Maybe$withDefault, '', error))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$TrustScore$Modal$styles.verifyContent)
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$TrustScore$Modal$styles.verifyColumn)
										]),
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$span,
											_List_Nil,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text('Verification code sent to ' + number)
												])),
											A2(
											$rtfeldman$elm_css$Html$Styled$span,
											_List_Nil,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text('Code expires in 10 minutes')
												]))
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$TrustScore$Modal$styles.input)
										]),
									_List_fromArray(
										[
											A2(
											$author$project$Material$Styled$Input$text,
											_List_fromArray(
												[
													$author$project$Material$Styled$Input$label('Code'),
													$author$project$Material$Styled$Input$onInput(
													A2(
														$elm$core$Basics$composeL,
														A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnTrustScore),
														$author$project$Type$TrustScore$OnVerifyCodeInput)),
													$author$project$Material$Styled$Input$value(code)
												]),
											_List_Nil)
										]))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$TrustScore$Modal$styles.buttonContainer)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Material$Styled$Button$button,
									_List_fromArray(
										[
											$author$project$Material$Styled$Button$styles($author$project$Page$TrustScore$Modal$styles.button),
											$author$project$Material$Styled$Button$theme($author$project$Material$Styled$Button$white),
											$author$project$Material$Styled$Button$onClick(
											$author$project$Types$OnAuth(
												$author$project$Types$OnTrustScore(
													$author$project$Type$TrustScore$MobileModal($author$project$Type$TrustScore$Close))))
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('Cancel')
										])),
									A2(
									$author$project$Material$Styled$Button$button,
									_List_fromArray(
										[
											$author$project$Material$Styled$Button$styles($author$project$Page$TrustScore$Modal$styles.button),
											$author$project$Material$Styled$Button$onClick(
											$author$project$Types$OnAuth(
												$author$project$Types$OnTrustScore(
													$author$project$Type$TrustScore$MobileModal($author$project$Type$TrustScore$PendingVerify))))
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('Verify')
										]))
								]))
						]));
			case 'PendingVerify':
				return A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$TrustScore$Modal$styles.modalContent)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$TrustScore$Modal$styles.text)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Verifying Input Code')
								])),
							A2($author$project$Material$Styled$ProgressBar$linear, _List_Nil, _List_Nil)
						]));
			case 'Success':
				return A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$TrustScore$Modal$styles.modalContent)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$TrustScore$Modal$styles.text)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Successfully Verified Phone Number')
								])),
							A2(
							$author$project$Material$Styled$Button$button,
							_List_fromArray(
								[
									$author$project$Material$Styled$Button$theme($author$project$Material$Styled$Button$blue),
									$author$project$Material$Styled$Button$onClick(
									$author$project$Types$OnAuth(
										$author$project$Types$OnTrustScore(
											$author$project$Type$TrustScore$MobileModal($author$project$Type$TrustScore$Close))))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Done')
								]))
						]));
			default:
				return $rtfeldman$elm_css$Html$Styled$text('');
		}
	});
var $author$project$Page$TrustScore$Modal$view = F3(
	function (status, phoneNumber, trustScoreModel) {
		var _v0 = trustScoreModel;
		var verifyCode = _v0.verifyCode;
		var twilioError = _v0.twilioError;
		return A2(
			$author$project$Material$Styled$Modal$modal,
			_List_fromArray(
				[
					$author$project$Material$Styled$Modal$open(
					!_Utils_eq(status, $author$project$Type$TrustScore$Close)),
					$author$project$Material$Styled$Modal$contentContainerstyles($author$project$Page$TrustScore$Modal$styles.modalContainer)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$TrustScore$Modal$styles.modalHeader)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$TrustScore$Modal$styles.modalHeaderTxt)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Mobile Verification')
								]))
						])),
					A4($author$project$Page$TrustScore$Modal$displayModal, status, phoneNumber, verifyCode, twilioError)
				]));
	});
var $author$project$Page$TrustScore$view = F2(
	function (model, authModel) {
		var _v0 = model;
		var appDomain = _v0.appDomain;
		var apiEndPoint = _v0.apiEndPoint;
		var languageSwitchModel = _v0.languageSwitchModel;
		var _v1 = authModel;
		var trustScoreModel = _v1.trustScoreModel;
		var user = _v1.user;
		var languageChangeModel = _v1.languageChangeModel;
		var _v2 = user;
		var firstName = _v2.firstName;
		var lastName = _v2.lastName;
		var email = _v2.email;
		var phoneNumber = _v2.phoneNumber;
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$TrustScore$styles.coverImage)
						]),
					_List_Nil),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$TrustScore$styles.headerContainer)
						]),
					_List_fromArray(
						[
							$author$project$Page$TrustScore$avatar(user),
							A3($author$project$Page$TrustScore$userDetails, firstName, lastName, email)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$TrustScore$styles.dividerContainer)
						]),
					_List_fromArray(
						[
							A2($author$project$Material$Styled$Divider$divider, _List_Nil, _List_Nil)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$TrustScore$styles.trustScoreContainer)
						]),
					_List_fromArray(
						[
							A3($author$project$Page$TrustScore$Summary$summary, appDomain, authModel, languageSwitchModel)
						])),
					A3($author$project$Page$TrustScore$Modal$view, trustScoreModel.modal, phoneNumber, trustScoreModel),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$TrustScore$styles.detailsContainer)
						]),
					A5($author$project$Page$TrustScore$renderDetail, model, appDomain, trustScoreModel, user, apiEndPoint.passbaseUrl)),
					A2($author$project$Page$TrustScore$passbaseModal, user, trustScoreModel)
				]));
	});
var $author$project$Type$UploadMultipleDocument$DueDate = {$: 'DueDate'};
var $author$project$Type$UploadMultipleDocument$Enters = {$: 'Enters'};
var $author$project$Type$UploadMultipleDocument$GoToStage = function (a) {
	return {$: 'GoToStage', a: a};
};
var $author$project$Type$UploadMultipleDocument$Leaves = {$: 'Leaves'};
var $author$project$Type$UploadMultipleDocument$OnAdditionalMsgInput = function (a) {
	return {$: 'OnAdditionalMsgInput', a: a};
};
var $author$project$Type$UploadMultipleDocument$OnAdditionalMsgToggle = {$: 'OnAdditionalMsgToggle'};
var $author$project$Type$UploadMultipleDocument$OnDoNotSaveDocumentClick = {$: 'OnDoNotSaveDocumentClick'};
var $author$project$Type$UploadMultipleDocument$OnDocBlur = function (a) {
	return {$: 'OnDocBlur', a: a};
};
var $author$project$Type$UploadMultipleDocument$OnDocInput = F2(
	function (a, b) {
		return {$: 'OnDocInput', a: a, b: b};
	});
var $author$project$Type$UploadMultipleDocument$OnDueDateToggle = {$: 'OnDueDateToggle'};
var $author$project$Type$UploadMultipleDocument$OnHover = F2(
	function (a, b) {
		return {$: 'OnHover', a: a, b: b};
	});
var $author$project$Type$UploadMultipleDocument$OnPasscodeBlur = {$: 'OnPasscodeBlur'};
var $author$project$Type$UploadMultipleDocument$OnPasscodeInput = function (a) {
	return {$: 'OnPasscodeInput', a: a};
};
var $author$project$Type$UploadMultipleDocument$OnPasscodeToggle = {$: 'OnPasscodeToggle'};
var $author$project$Type$UploadMultipleDocument$OnRequireNotarisationToggle = function (a) {
	return {$: 'OnRequireNotarisationToggle', a: a};
};
var $author$project$Type$UploadMultipleDocument$OnSigningOrderChecked = {$: 'OnSigningOrderChecked'};
var $author$project$Page$UploadMultipleDocument$convertStringToNetwork = function (currentUserNotarisationNetwork) {
	switch (currentUserNotarisationNetwork) {
		case 'Binance':
			return $author$project$Type$UploadMultipleDocument$Binance;
		case 'Algorand':
			return $author$project$Type$UploadMultipleDocument$Algorand;
		default:
			return $author$project$Type$UploadMultipleDocument$Binance;
	}
};
var $author$project$Page$UploadMultipleDocument$styles = {
	addFieldIcon: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$paddingRight(
			$rtfeldman$elm_css$Css$px(7))
		]),
	annotBtn: _List_fromArray(
		[
			A3(
			$rtfeldman$elm_css$Css$margin3,
			$rtfeldman$elm_css$Css$px(15),
			$rtfeldman$elm_css$Css$zero,
			$rtfeldman$elm_css$Css$zero),
			$rtfeldman$elm_css$Css$maxWidth($rtfeldman$elm_css$Css$fitContent)
		]),
	annotCardTitle: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$block),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(14)),
			$rtfeldman$elm_css$Css$marginBottom(
			$rtfeldman$elm_css$Css$px(14)),
			$rtfeldman$elm_css$Css$fontWeight(
			$rtfeldman$elm_css$Css$int(500)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100)),
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(5))
		]),
	annotCardTitleClosed: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$block),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(14)),
			$rtfeldman$elm_css$Css$fontWeight(
			$rtfeldman$elm_css$Css$int(500)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100)),
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(5))
		]),
	annotContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			A3(
			$rtfeldman$elm_css$Css$border3,
			$rtfeldman$elm_css$Css$px(1),
			$rtfeldman$elm_css$Css$solid,
			$author$project$Material$Styled$Color$grey300),
			$rtfeldman$elm_css$Css$padding(
			$rtfeldman$elm_css$Css$px(10)),
			$rtfeldman$elm_css$Css$borderRadius(
			$rtfeldman$elm_css$Css$px(10)),
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(20))
		]),
	annotContent: _List_Nil,
	avatar: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(30)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(30)),
			$rtfeldman$elm_css$Css$borderRadius(
			$rtfeldman$elm_css$Css$pct(50)),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$marginRight(
			$rtfeldman$elm_css$Css$px(2)),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$white),
			$rtfeldman$elm_css$Css$textTransform($rtfeldman$elm_css$Css$uppercase),
			$rtfeldman$elm_css$Css$textDecoration($rtfeldman$elm_css$Css$none)
		]),
	avatarContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$row),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$top(
			$rtfeldman$elm_css$Css$px(-20)),
			$rtfeldman$elm_css$Css$marginBottom(
			$rtfeldman$elm_css$Css$px(-20)),
			$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$relative)
		]),
	avatarContent: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(70)),
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(10))
		]),
	container: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$row),
			$rtfeldman$elm_css$Css$height(
			A3(
				$rtfeldman$elm_css$Css$calc,
				$rtfeldman$elm_css$Css$vh(100),
				$rtfeldman$elm_css$Css$minus,
				$rtfeldman$elm_css$Css$px(66)))
		]),
	costDisplay: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(15))
		]),
	create: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(10)),
			$rtfeldman$elm_css$Css$marginLeft(
			$rtfeldman$elm_css$Css$px(15)),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(50)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(50)),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(50)),
			A3(
			$rtfeldman$elm_css$Css$border3,
			$rtfeldman$elm_css$Css$px(1),
			$rtfeldman$elm_css$Css$solid,
			$author$project$Material$Styled$Color$blueA700),
			$rtfeldman$elm_css$Css$borderRadius(
			$rtfeldman$elm_css$Css$px(10)),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$blueA700),
			$rtfeldman$elm_css$Css$hover(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer)
				]))
		]),
	documentDisplay: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$row),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center)
		]),
	dueDateClear: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(9.6)),
			$rtfeldman$elm_css$Css$hover(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer)
				]))
		]),
	dueDateControls: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceBetween)
		]),
	dueDateInfo: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(9.6)),
			$rtfeldman$elm_css$Css$marginBottom(
			$rtfeldman$elm_css$Css$px(15))
		]),
	errorBannerContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$absolute),
			$rtfeldman$elm_css$Css$top($rtfeldman$elm_css$Css$zero),
			$rtfeldman$elm_css$Css$left($rtfeldman$elm_css$Css$zero),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100)),
			$rtfeldman$elm_css$Css$boxSizing($rtfeldman$elm_css$Css$borderBox),
			$rtfeldman$elm_css$Css$padding(
			$rtfeldman$elm_css$Css$px(20))
		]),
	errorTxt: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(12)),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$redA200),
			$rtfeldman$elm_css$Css$displayFlex
		]),
	flexColumn: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column)
		]),
	iconStyles: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$paddingTop(
			$rtfeldman$elm_css$Css$px(6)),
			$rtfeldman$elm_css$Css$marginLeft(
			$rtfeldman$elm_css$Css$px(-5))
		]),
	inputContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginBottom(
			$rtfeldman$elm_css$Css$px(10))
		]),
	linkText: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$white),
			$rtfeldman$elm_css$Css$textDecoration($rtfeldman$elm_css$Css$underline),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(9.6))
		]),
	margin30: _List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Css$margin2,
			$rtfeldman$elm_css$Css$px(30),
			$rtfeldman$elm_css$Css$zero)
		]),
	marginLeft10: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginLeft(
			$rtfeldman$elm_css$Css$px(10)),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(12.8))
		]),
	overlay: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$fixed),
			$rtfeldman$elm_css$Css$top($rtfeldman$elm_css$Css$zero),
			$rtfeldman$elm_css$Css$right($rtfeldman$elm_css$Css$zero),
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			A2(
			$rtfeldman$elm_css$Css$padding2,
			$rtfeldman$elm_css$Css$zero,
			$rtfeldman$elm_css$Css$px(20)),
			$rtfeldman$elm_css$Css$boxSizing($rtfeldman$elm_css$Css$borderBox),
			$rtfeldman$elm_css$Css$backgroundColor(
			$rtfeldman$elm_css$Css$hex('#BDBDBDEE')),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$white),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(39)),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$pct(100)),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(40)),
			$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center)
		]),
	ownerItemTitle: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column)
		]),
	ownerNtSignCheckBx: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginLeft(
			$rtfeldman$elm_css$Css$px(-10)),
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(-30))
		]),
	recipientContent: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			A3(
			$rtfeldman$elm_css$Css$margin3,
			$rtfeldman$elm_css$Css$px(48),
			$rtfeldman$elm_css$Css$zero,
			$rtfeldman$elm_css$Css$zero)
		]),
	recipientHeader: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceBetween),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100))
		]),
	recipientItemTitle: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			$rtfeldman$elm_css$Css$padding(
			$rtfeldman$elm_css$Css$px(5)),
			$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$relative),
			$rtfeldman$elm_css$Css$top(
			$rtfeldman$elm_css$Css$px(-24)),
			$rtfeldman$elm_css$Css$backgroundColor($author$project$Material$Styled$Color$white),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(9.6))
		]),
	recipientRmvIcon: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$hover(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$backgroundColor($author$project$Material$Styled$Color$grey100),
					$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer),
					$rtfeldman$elm_css$Css$outline($rtfeldman$elm_css$Css$none)
				])),
			$rtfeldman$elm_css$Css$focus(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$outline($rtfeldman$elm_css$Css$none),
					$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer)
				]))
		]),
	retryContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer),
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(10))
		]),
	rowSelect: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100)),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(12.8)),
			A2(
			$rtfeldman$elm_css$Css$margin2,
			$rtfeldman$elm_css$Css$px(15),
			$rtfeldman$elm_css$Css$zero)
		]),
	sectionContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			A3(
			$rtfeldman$elm_css$Css$border3,
			$rtfeldman$elm_css$Css$px(1),
			$rtfeldman$elm_css$Css$solid,
			$author$project$Material$Styled$Color$grey300),
			$rtfeldman$elm_css$Css$padding(
			$rtfeldman$elm_css$Css$px(10)),
			$rtfeldman$elm_css$Css$borderRadius(
			$rtfeldman$elm_css$Css$px(10)),
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(20))
		]),
	sectionContainerClosed: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$row),
			A3(
			$rtfeldman$elm_css$Css$border3,
			$rtfeldman$elm_css$Css$px(1),
			$rtfeldman$elm_css$Css$solid,
			$author$project$Material$Styled$Color$grey300),
			$rtfeldman$elm_css$Css$padding(
			$rtfeldman$elm_css$Css$px(10)),
			$rtfeldman$elm_css$Css$borderRadius(
			$rtfeldman$elm_css$Css$px(10)),
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(20)),
			$rtfeldman$elm_css$Css$hover(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$backgroundColor($author$project$Material$Styled$Color$grey100),
					$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer)
				]))
		]),
	sendIcon: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center)
		]),
	sidebar: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$relative),
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$padding(
			$rtfeldman$elm_css$Css$px(10)),
			$rtfeldman$elm_css$Css$backgroundColor($author$project$Material$Styled$Color$white),
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(38)),
			$rtfeldman$elm_css$Css$overflowY($rtfeldman$elm_css$Css$auto)
		]),
	signOrderField: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100)),
			$rtfeldman$elm_css$Css$maxWidth(
			$rtfeldman$elm_css$Css$px(100)),
			$rtfeldman$elm_css$Css$marginLeft(
			$rtfeldman$elm_css$Css$px(15)),
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(10))
		]),
	signOrderInfoContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceBetween),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100))
		]),
	signature: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(100)),
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(10)),
			$rtfeldman$elm_css$Css$marginLeft(
			$rtfeldman$elm_css$Css$px(15))
		]),
	signatureImg: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(50)),
			$rtfeldman$elm_css$Css$minWidth(
			$rtfeldman$elm_css$Css$px(100)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(43)),
			A2($rtfeldman$elm_css$Css$property, 'object-fit', 'contain'),
			A2($rtfeldman$elm_css$Css$property, 'box-shadow', '0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24)'),
			$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer),
			$rtfeldman$elm_css$Css$hover(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$backgroundColor(
					$rtfeldman$elm_css$Css$hex('f6f7f7'))
				]))
		]),
	signatureImgBox: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(10)),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$em(0.8)),
			$rtfeldman$elm_css$Css$fontWeight(
			$rtfeldman$elm_css$Css$int(500))
		]),
	signatureListBox: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$row),
			$rtfeldman$elm_css$Css$flexWrap($rtfeldman$elm_css$Css$wrap),
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$start),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center)
		]),
	signatureName: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$textOverflow($rtfeldman$elm_css$Css$ellipsis),
			$rtfeldman$elm_css$Css$overflow($rtfeldman$elm_css$Css$hidden),
			$rtfeldman$elm_css$Css$whiteSpace($rtfeldman$elm_css$Css$noWrap),
			$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(60)),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(12.8))
		]),
	signerNameContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$row),
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceBetween),
			$rtfeldman$elm_css$Css$flexWrap($rtfeldman$elm_css$Css$wrap)
		]),
	signingOrderAvatarContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$row),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$relative)
		]),
	signingOrderCheckBox: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginLeft(
			$rtfeldman$elm_css$Css$px(-10)),
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(-10)),
			$rtfeldman$elm_css$Css$marginBottom(
			$rtfeldman$elm_css$Css$px(10)),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(12.8))
		]),
	signingOrderContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(-20))
		]),
	signingOrderText: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(12.8))
		]),
	stamp: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(10)),
			$rtfeldman$elm_css$Css$marginLeft(
			$rtfeldman$elm_css$Css$px(15))
		]),
	stampHeaderStyles: _List_fromArray(
		[$rtfeldman$elm_css$Css$displayFlex]),
	stampImg: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(50)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(50)),
			A2($rtfeldman$elm_css$Css$property, 'object-fit', 'contain'),
			A2($rtfeldman$elm_css$Css$property, 'box-shadow', '0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24)'),
			$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer),
			$rtfeldman$elm_css$Css$hover(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$backgroundColor(
					$rtfeldman$elm_css$Css$hex('f6f7f7'))
				]))
		]),
	stampName: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$textOverflow($rtfeldman$elm_css$Css$ellipsis),
			$rtfeldman$elm_css$Css$overflow($rtfeldman$elm_css$Css$hidden),
			$rtfeldman$elm_css$Css$whiteSpace($rtfeldman$elm_css$Css$noWrap),
			$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(50)),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(12.8))
		]),
	submitButton: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginBottom(
			$rtfeldman$elm_css$Css$px(20)),
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(10)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100))
		]),
	titleContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$row),
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceBetween)
		]),
	toolTipText: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(9.6))
		]),
	toolTipText2: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(9.6))
		]),
	viewerText: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginLeft(
			$rtfeldman$elm_css$Css$px(5)),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(12.8)),
			$rtfeldman$elm_css$Css$flexGrow(
			$rtfeldman$elm_css$Css$num(1))
		])
};
var $author$project$Page$UploadMultipleDocument$displayErrorMessage = F2(
	function (check, errorTxt) {
		return check ? $rtfeldman$elm_css$Html$Styled$text('') : A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadMultipleDocument$styles.errorTxt)
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text(errorTxt)
				]));
	});
var $author$project$Page$UploadMultipleDocument$displayToolTipTxt = F6(
	function (languageSwitchModel, notarisationNetwork, binanceCost, algorandCost, signPointsBalance, paymentMethod) {
		var uploadDocumentLanguageData = languageSwitchModel.allLanguageData.location.uploadDocument;
		var _v0 = _Utils_Tuple2(
			notarisationNetwork,
			$author$project$Model$Settings$convertStringToPayment(paymentMethod));
		if (_v0.a.$ === 'Binance') {
			var _v1 = _v0.a;
			return _Utils_ap(
				uploadDocumentLanguageData.notariseTooltipText1,
				_Utils_ap(
					binanceCost,
					_Utils_ap(
						uploadDocumentLanguageData.notariseTooltipText2,
						_Utils_ap(signPointsBalance, uploadDocumentLanguageData.notariseTooltipText3))));
		} else {
			if (_v0.b.$ === 'SystemBalance') {
				var _v2 = _v0.a;
				var _v3 = _v0.b;
				return _Utils_ap(
					uploadDocumentLanguageData.notariseTooltipText1,
					_Utils_ap(
						algorandCost,
						_Utils_ap(
							uploadDocumentLanguageData.notariseTooltipText2,
							_Utils_ap(signPointsBalance, uploadDocumentLanguageData.notariseTooltipText3))));
			} else {
				var _v4 = _v0.a;
				return 'This action costs 5 SIGN points. As you have chosen to deduct the points directly from your Algorand Wallet balance, please ensure you have enough points before proceeding.';
			}
		}
	});
var $author$project$Page$UploadMultipleDocument$minDateString = $ryannhg$date_format$DateFormat$format(
	_List_fromArray(
		[
			$ryannhg$date_format$DateFormat$yearNumber,
			$ryannhg$date_format$DateFormat$text('-'),
			$ryannhg$date_format$DateFormat$monthFixed,
			$ryannhg$date_format$DateFormat$text('-'),
			$ryannhg$date_format$DateFormat$dayOfMonthFixed
		]));
var $author$project$Type$UploadMultipleDocument$OnSigningOrderInput = F2(
	function (a, b) {
		return {$: 'OnSigningOrderInput', a: a, b: b};
	});
var $author$project$Page$UploadMultipleDocument$generateIndividualSigningOrder = F2(
	function (numberOfSigners, value) {
		var user = $author$project$Data$PDF$User$userInfo(value.user);
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadMultipleDocument$styles.signingOrderAvatarContainer)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadMultipleDocument$styles.signOrderInfoContainer)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadMultipleDocument$styles.signingOrderText)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(user.firstName + (' ' + user.lastName))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadMultipleDocument$styles.signingOrderText)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(user.email)
								]))
						])),
					A2(
					$author$project$Material$Styled$Input$number,
					_List_fromArray(
						[
							$author$project$Material$Styled$Input$min('1'),
							$author$project$Material$Styled$Input$max(
							$elm$core$String$fromInt(numberOfSigners)),
							$author$project$Material$Styled$Input$label(''),
							$author$project$Material$Styled$Input$value(
							$elm$core$String$fromInt(value.signOrder)),
							$author$project$Material$Styled$Input$onInput(
							A2(
								$elm$core$Basics$composeL,
								A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnMultipleDocUpload),
								$author$project$Type$UploadMultipleDocument$OnSigningOrderInput(
									$author$project$Data$PDF$User$emailFromUser(value.user)))),
							$author$project$Material$Styled$Input$containerStyles($author$project$Page$UploadMultipleDocument$styles.signOrderField),
							$author$project$Material$Styled$Input$id('signOrder' + user.email)
						]),
					_List_Nil)
				]));
	});
var $author$project$Type$UploadMultipleDocument$OnOwnerSigningOrderInput = function (a) {
	return {$: 'OnOwnerSigningOrderInput', a: a};
};
var $author$project$Page$UploadMultipleDocument$generateOwnerSigningOrder = F2(
	function (numberOfSigners, owner) {
		var ownerInfo = $author$project$Data$PDF$User$userInfo(owner.user);
		return _List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadMultipleDocument$styles.signingOrderAvatarContainer)
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadMultipleDocument$styles.signOrderInfoContainer)
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$span,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadMultipleDocument$styles.signingOrderText)
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(ownerInfo.firstName + (' ' + (ownerInfo.lastName + ' (Owner)')))
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$span,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadMultipleDocument$styles.signingOrderText)
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(ownerInfo.email)
									]))
							])),
						A2(
						$author$project$Material$Styled$Input$number,
						_List_fromArray(
							[
								$author$project$Material$Styled$Input$min('1'),
								$author$project$Material$Styled$Input$max(
								$elm$core$String$fromInt(numberOfSigners)),
								$author$project$Material$Styled$Input$label(''),
								$author$project$Material$Styled$Input$value(
								$elm$core$String$fromInt(owner.signOrder)),
								$author$project$Material$Styled$Input$onInput(
								A2(
									$elm$core$Basics$composeL,
									A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnMultipleDocUpload),
									$author$project$Type$UploadMultipleDocument$OnOwnerSigningOrderInput)),
								$author$project$Material$Styled$Input$containerStyles($author$project$Page$UploadMultipleDocument$styles.signOrderField)
							]),
						_List_Nil)
					]))
			]);
	});
var $author$project$Page$UploadMultipleDocument$signingOrder = F2(
	function (languageSwitchModel, loadedModel) {
		if (_Utils_eq(loadedModel.signingType, $author$project$Type$UploadMultipleDocument$SigningOrder)) {
			var uploadDocumentLanguageData = languageSwitchModel.allLanguageData.location.uploadDocument;
			var owner = $author$project$Data$PDF$Create$getOwner(loadedModel.pdf);
			var listOfSigners = A2(
				$elm$core$List$sortBy,
				function ($) {
					return $.signOrder;
				},
				$elm$core$Dict$values(
					$author$project$Data$PDF$Create$recipientsWithoutOwner(loadedModel.pdf)));
			var numberOfSigners = $elm$core$List$length(listOfSigners) + 1;
			return A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_Utils_ap(
							$author$project$Page$UploadMultipleDocument$styles.recipientContent,
							_Utils_ap(
								$author$project$Page$UploadMultipleDocument$styles.annotContainer,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Css$marginBottom(
										$rtfeldman$elm_css$Css$px(10))
									]))))
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadMultipleDocument$styles.recipientHeader)
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadMultipleDocument$styles.recipientItemTitle)
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(uploadDocumentLanguageData.signOrder)
									]))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadMultipleDocument$styles.signingOrderContainer)
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_Nil,
								_Utils_ap(
									A2($author$project$Page$UploadMultipleDocument$generateOwnerSigningOrder, numberOfSigners, owner),
									A2(
										$elm$core$List$map,
										$author$project$Page$UploadMultipleDocument$generateIndividualSigningOrder(numberOfSigners),
										listOfSigners)))
							]))
					]));
		} else {
			return $rtfeldman$elm_css$Html$Styled$text('');
		}
	});
var $author$project$Page$UploadMultipleDocument$advanceOptions = F5(
	function (languageSwitchModel, loadedModel, authModel, currentTime, timezone) {
		var uploadDocumentLanguageData = languageSwitchModel.allLanguageData.location.uploadDocument;
		var signPointsBalance = loadedModel.signPointsBalance / 100;
		var currentChosenNetwork = authModel.user.notarisationNetwork + (' ' + 'Network');
		var _v0 = loadedModel;
		var dueDate = _v0.dueDate;
		var dueDateError = _v0.dueDateError;
		var passcodeError = _v0.passcodeError;
		var pdfList = _v0.pdfList;
		var algorandNotarisationCost = (loadedModel.algorandNotarisationCost / 100) * $elm$core$List$length(pdfList);
		var algorandErrorTxt = 'You currently have ' + ($elm$core$String$fromFloat(signPointsBalance) + (' SIGN points available. This action costs ' + ($elm$core$String$fromFloat(algorandNotarisationCost) + ' SIGN points')));
		var binanceNotarisationCost = (loadedModel.binanceNotarisationCost / 100) * $elm$core$List$length(pdfList);
		var binanceErrorTxt = 'You currently have ' + ($elm$core$String$fromFloat(signPointsBalance) + (' SIGN points available. This action costs ' + ($elm$core$String$fromFloat(binanceNotarisationCost) + ' SIGN points')));
		return _Utils_eq(loadedModel.stage, $author$project$Type$UploadMultipleDocument$Options) ? A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadMultipleDocument$styles.sectionContainer)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[$rtfeldman$elm_css$Css$displayFlex]))
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadMultipleDocument$styles.addFieldIcon)
								]),
							_List_fromArray(
								[
									A2($author$project$Material$Styled$Icon$settings, _List_Nil, _List_Nil)
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadMultipleDocument$styles.annotCardTitle)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(uploadDocumentLanguageData.optionalSettings)
								]))
						])),
					A2(
					$author$project$Material$Styled$Checkbox$checkbox,
					_List_fromArray(
						[
							$author$project$Material$Styled$Checkbox$checked(
							_Utils_eq(loadedModel.signingType, $author$project$Type$UploadMultipleDocument$SigningOrder)),
							$author$project$Material$Styled$Checkbox$containerStyles($author$project$Page$UploadMultipleDocument$styles.signingOrderCheckBox),
							$author$project$Material$Styled$Checkbox$onClick(
							$author$project$Types$OnAuth(
								$author$project$Types$OnMultipleDocUpload($author$project$Type$UploadMultipleDocument$OnSigningOrderChecked))),
							$author$project$Material$Styled$Checkbox$testAttribute('signingOrder')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(uploadDocumentLanguageData.signOrder)
						])),
					A2($author$project$Page$UploadMultipleDocument$signingOrder, languageSwitchModel, loadedModel),
					A2(
					$author$project$Material$Styled$Checkbox$checkbox,
					_List_fromArray(
						[
							$author$project$Material$Styled$Checkbox$checked(loadedModel.showDueDate),
							$author$project$Material$Styled$Checkbox$containerStyles($author$project$Page$UploadMultipleDocument$styles.signingOrderCheckBox),
							$author$project$Material$Styled$Checkbox$onClick(
							$author$project$Types$OnAuth(
								$author$project$Types$OnMultipleDocUpload($author$project$Type$UploadMultipleDocument$OnDueDateToggle)))
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(uploadDocumentLanguageData.dueDate)
						])),
					loadedModel.showDueDate ? A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Material$Styled$Input$date,
							_List_fromArray(
								[
									$author$project$Material$Styled$Input$containerStyles($author$project$Page$UploadMultipleDocument$styles.inputContainer),
									$author$project$Material$Styled$Input$label(uploadDocumentLanguageData.dueDate),
									$author$project$Material$Styled$Input$value(
									A2($elm$core$Maybe$withDefault, 'dd/mm/yyyy', dueDate)),
									$author$project$Material$Styled$Input$errorMessage(dueDateError),
									$author$project$Material$Styled$Input$min(
									A2($author$project$Page$UploadMultipleDocument$minDateString, timezone, currentTime)),
									$author$project$Material$Styled$Input$onInput(
									A2(
										$elm$core$Basics$composeL,
										A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnMultipleDocUpload),
										$author$project$Type$UploadMultipleDocument$OnDocInput($author$project$Type$UploadMultipleDocument$DueDate))),
									$author$project$Material$Styled$Input$onBlur(
									$author$project$Types$OnAuth(
										$author$project$Types$OnMultipleDocUpload(
											$author$project$Type$UploadMultipleDocument$OnDocBlur($author$project$Type$UploadMultipleDocument$DueDate))))
								]),
							_List_Nil),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadMultipleDocument$styles.dueDateControls)
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadMultipleDocument$styles.dueDateInfo)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											_Utils_eq(dueDate, $elm$core$Maybe$Nothing) ? 'No Due Date' : '')
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadMultipleDocument$styles.dueDateClear),
											$rtfeldman$elm_css$Html$Styled$Events$onClick(
											$author$project$Types$OnAuth(
												$author$project$Types$OnMultipleDocUpload(
													A2($author$project$Type$UploadMultipleDocument$OnDocInput, $author$project$Type$UploadMultipleDocument$DueDate, ''))))
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(uploadDocumentLanguageData.clear)
										]))
								]))
						])) : $rtfeldman$elm_css$Html$Styled$text(''),
					A2(
					$author$project$Material$Styled$Checkbox$checkbox,
					_List_fromArray(
						[
							$author$project$Material$Styled$Checkbox$checked(loadedModel.showAdditionalMsg),
							$author$project$Material$Styled$Checkbox$containerStyles($author$project$Page$UploadMultipleDocument$styles.signingOrderCheckBox),
							$author$project$Material$Styled$Checkbox$onClick(
							$author$project$Types$OnAuth(
								$author$project$Types$OnMultipleDocUpload($author$project$Type$UploadMultipleDocument$OnAdditionalMsgToggle)))
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(uploadDocumentLanguageData.additionalMessage)
						])),
					loadedModel.showAdditionalMsg ? A2(
					$author$project$Material$Styled$TextArea$textArea,
					_List_fromArray(
						[
							$author$project$Material$Styled$TextArea$label('Attach a personalised message to your recipients in the email notification for signing.'),
							$author$project$Material$Styled$TextArea$customInputAttributes(
							_List_fromArray(
								[
									A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'data-gramm_editor', 'false')
								])),
							$author$project$Material$Styled$TextArea$value(
							A2($elm$core$Maybe$withDefault, '', loadedModel.additionalMsg)),
							$author$project$Material$Styled$TextArea$onInput(
							A2(
								$elm$core$Basics$composeL,
								A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnMultipleDocUpload),
								$author$project$Type$UploadMultipleDocument$OnAdditionalMsgInput))
						]),
					_List_Nil) : $rtfeldman$elm_css$Html$Styled$text(''),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadMultipleDocument$styles.stampHeaderStyles)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Material$Styled$Checkbox$checkbox,
							_List_fromArray(
								[
									$author$project$Material$Styled$Checkbox$checked(loadedModel.showPasscodeInput),
									$author$project$Material$Styled$Checkbox$containerStyles($author$project$Page$UploadMultipleDocument$styles.signingOrderCheckBox),
									$author$project$Material$Styled$Checkbox$onClick(
									$author$project$Types$OnAuth(
										$author$project$Types$OnMultipleDocUpload($author$project$Type$UploadMultipleDocument$OnPasscodeToggle)))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(uploadDocumentLanguageData.passcode)
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_Nil,
							_List_fromArray(
								[
									A5(
									$author$project$View$InfomationToolTip$view,
									$author$project$Types$OnAuth(
										$author$project$Types$OnMultipleDocUpload(
											A2($author$project$Type$UploadMultipleDocument$OnHover, $author$project$Type$UploadMultipleDocument$Enters, $author$project$Type$UploadMultipleDocument$Passcode))),
									$author$project$Types$OnAuth(
										$author$project$Types$OnMultipleDocUpload(
											A2($author$project$Type$UploadMultipleDocument$OnHover, $author$project$Type$UploadMultipleDocument$Leaves, $author$project$Type$UploadMultipleDocument$Passcode))),
									_Utils_eq(loadedModel.toolTipActiveHover, $author$project$Type$UploadMultipleDocument$Passcode),
									A2(
										$rtfeldman$elm_css$Html$Styled$span,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadMultipleDocument$styles.toolTipText)
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(uploadDocumentLanguageData.passcodeTooltipText)
											])),
									$author$project$Material$Styled$Icon$moreInfo)
								]))
						])),
					loadedModel.showPasscodeInput ? A2(
					$author$project$Material$Styled$Input$password,
					_List_fromArray(
						[
							$author$project$Material$Styled$Input$containerStyles($author$project$Page$UploadMultipleDocument$styles.inputContainer),
							$author$project$Material$Styled$Input$label('Passcode'),
							$author$project$Material$Styled$Input$value(
							A2($elm$core$Maybe$withDefault, '', loadedModel.passcode)),
							$author$project$Material$Styled$Input$errorMessage(passcodeError),
							$author$project$Material$Styled$Input$onInput(
							A2(
								$elm$core$Basics$composeL,
								A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnMultipleDocUpload),
								$author$project$Type$UploadMultipleDocument$OnPasscodeInput)),
							$author$project$Material$Styled$Input$onBlur(
							$author$project$Types$OnAuth(
								$author$project$Types$OnMultipleDocUpload($author$project$Type$UploadMultipleDocument$OnPasscodeBlur)))
						]),
					_List_Nil) : $rtfeldman$elm_css$Html$Styled$text(''),
					A2(
					$author$project$Material$Styled$Checkbox$checkbox,
					_List_fromArray(
						[
							$author$project$Material$Styled$Checkbox$checked(
							_Utils_eq(loadedModel.saveDocumentStatus, $author$project$Type$UploadMultipleDocument$DoNotSave)),
							$author$project$Material$Styled$Checkbox$containerStyles($author$project$Page$UploadMultipleDocument$styles.signingOrderCheckBox),
							$author$project$Material$Styled$Checkbox$onClick(
							$author$project$Types$OnAuth(
								$author$project$Types$OnMultipleDocUpload($author$project$Type$UploadMultipleDocument$OnDoNotSaveDocumentClick)))
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(uploadDocumentLanguageData.doNotSaveDocument)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadMultipleDocument$styles.stampHeaderStyles)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Material$Styled$Checkbox$checkbox,
									_List_fromArray(
										[
											$author$project$Material$Styled$Checkbox$checked(loadedModel.requireNotarisation),
											$author$project$Material$Styled$Checkbox$containerStyles($author$project$Page$UploadMultipleDocument$styles.signingOrderCheckBox),
											$author$project$Material$Styled$Checkbox$onClick(
											$author$project$Types$OnAuth(
												$author$project$Types$OnMultipleDocUpload(
													$author$project$Type$UploadMultipleDocument$OnRequireNotarisationToggle(
														$author$project$Page$UploadMultipleDocument$convertStringToNetwork(authModel.user.notarisationNetwork)))))
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(uploadDocumentLanguageData.notariseDocument + (': ' + currentChosenNetwork))
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_Nil,
									_List_fromArray(
										[
											A5(
											$author$project$View$InfomationToolTip$view,
											$author$project$Types$OnAuth(
												$author$project$Types$OnMultipleDocUpload(
													A2($author$project$Type$UploadMultipleDocument$OnHover, $author$project$Type$UploadMultipleDocument$Enters, $author$project$Type$UploadMultipleDocument$Notarize))),
											$author$project$Types$OnAuth(
												$author$project$Types$OnMultipleDocUpload(
													A2($author$project$Type$UploadMultipleDocument$OnHover, $author$project$Type$UploadMultipleDocument$Leaves, $author$project$Type$UploadMultipleDocument$Notarize))),
											_Utils_eq(loadedModel.toolTipActiveHover, $author$project$Type$UploadMultipleDocument$Notarize),
											A2(
												$rtfeldman$elm_css$Html$Styled$span,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadMultipleDocument$styles.toolTipText2)
													]),
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text(
														A6(
															$author$project$Page$UploadMultipleDocument$displayToolTipTxt,
															languageSwitchModel,
															$author$project$Page$UploadMultipleDocument$convertStringToNetwork(authModel.user.notarisationNetwork),
															$elm$core$String$fromFloat(binanceNotarisationCost),
															$elm$core$String$fromFloat(algorandNotarisationCost),
															$elm$core$String$fromFloat(signPointsBalance),
															authModel.user.paymentMethod)),
														A2(
														$author$project$Material$Styled$A$a,
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$Attributes$href('https://www.sign.net/rewardpoints'),
																$rtfeldman$elm_css$Html$Styled$Attributes$target('_blank')
															]),
														_List_fromArray(
															[
																A2(
																$rtfeldman$elm_css$Html$Styled$span,
																_List_fromArray(
																	[
																		$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadMultipleDocument$styles.linkText)
																	]),
																_List_fromArray(
																	[
																		$rtfeldman$elm_css$Html$Styled$text('Find out more')
																	]))
															]))
													])),
											$author$project$Material$Styled$Icon$moreInfo)
										]))
								]))
						])),
					(authModel.user.notarisationNetwork === 'Binance') ? A2(
					$author$project$Page$UploadMultipleDocument$displayErrorMessage,
					_Utils_cmp(
						loadedModel.signPointsBalance,
						loadedModel.binanceNotarisationCost * $elm$core$List$length(loadedModel.pdfList)) > -1,
					binanceErrorTxt) : (((authModel.user.notarisationNetwork === 'Algorand') && (authModel.user.paymentMethod === 'systemBalance')) ? A2(
					$author$project$Page$UploadMultipleDocument$displayErrorMessage,
					_Utils_cmp(
						loadedModel.signPointsBalance,
						loadedModel.algorandNotarisationCost * $elm$core$List$length(loadedModel.pdfList)) > -1,
					algorandErrorTxt) : $rtfeldman$elm_css$Html$Styled$text(''))
				])) : A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Events$onClick(
					$author$project$Types$OnAuth(
						$author$project$Types$OnMultipleDocUpload(
							$author$project$Type$UploadMultipleDocument$GoToStage($author$project$Type$UploadMultipleDocument$Options)))),
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadMultipleDocument$styles.sectionContainerClosed)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadMultipleDocument$styles.addFieldIcon)
						]),
					_List_fromArray(
						[
							A2($author$project$Material$Styled$Icon$settings, _List_Nil, _List_Nil)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadMultipleDocument$styles.annotCardTitleClosed)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(uploadDocumentLanguageData.optionalSettings)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_Nil,
					_List_fromArray(
						[
							A2($author$project$Material$Styled$Icon$keyboardArrowDown, _List_Nil, _List_Nil)
						]))
				]));
	});
var $author$project$Type$UploadMultipleDocument$OnFileSwitch = function (a) {
	return {$: 'OnFileSwitch', a: a};
};
var $author$project$Type$UploadMultipleDocument$OnFontSizeUpdate = function (a) {
	return {$: 'OnFontSizeUpdate', a: a};
};
var $author$project$Type$UploadMultipleDocument$OnReceiveDeleteAnnotClick = {$: 'OnReceiveDeleteAnnotClick'};
var $author$project$Type$UploadMultipleDocument$Title = {$: 'Title'};
var $author$project$Page$UploadMultipleDocument$signatureError = function (error) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadMultipleDocument$styles.retryContainer),
				$rtfeldman$elm_css$Html$Styled$Events$onClick(
				$author$project$Types$OnSignature($author$project$Type$Signature$ReloadList))
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$span,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(error)
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$img,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$src($author$project$View$Theme$images.retry)
					]),
				_List_Nil)
			]));
};
var $author$project$Type$UploadMultipleDocument$OnAnnotClick = F2(
	function (a, b) {
		return {$: 'OnAnnotClick', a: a, b: b};
	});
var $author$project$Data$PDF$Annotation$signedSignature = F2(
	function (style, signature) {
		return $author$project$Data$PDF$Annotation$IsSignature(
			$author$project$Data$PDF$Annotation$Signature(
				{
					dbId: '',
					id: '',
					status: $author$project$Data$PDF$Annotation$Signed(signature),
					style: style
				}));
	});
var $author$project$Page$UploadMultipleDocument$renderSignature = F3(
	function (owner, style, signature) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$span,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadMultipleDocument$styles.signature)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$img,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$src(signature.data),
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadMultipleDocument$styles.signatureImg),
							$rtfeldman$elm_css$Html$Styled$Events$onClick(
							$author$project$Types$OnAuth(
								$author$project$Types$OnMultipleDocUpload(
									A2(
										$author$project$Type$UploadMultipleDocument$OnAnnotClick,
										owner.user,
										A2(
											$author$project$Data$PDF$Annotation$signedSignature,
											style,
											A3($author$project$Data$PDF$Signature$create, signature.id, signature.name, signature.data))))))
						]),
					_List_Nil)
				]));
	});
var $author$project$Page$UploadMultipleDocument$signatureList = F3(
	function (owner, lastStyle, signatureModel) {
		var style = A3($author$project$Data$PDF$Annotation$createStyle, lastStyle.signedSignature.width, lastStyle.signedSignature.height, '0pt');
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadMultipleDocument$styles.signatureListBox)
				]),
			_Utils_ap(
				A2(
					$elm$core$List$map,
					A2($author$project$Page$UploadMultipleDocument$renderSignature, owner, style),
					signatureModel.signatures),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadMultipleDocument$styles.create),
								$rtfeldman$elm_css$Html$Styled$Events$onClick(
								$author$project$Types$OnSignature($author$project$Type$Signature$OnOpen)),
								A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'data-test', 'signature')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('+')
							]))
					])));
	});
var $author$project$Page$UploadMultipleDocument$renderSignatures = F3(
	function (languageSwitchModel, model, signatureModel) {
		var uploadDocumentLanguageData = languageSwitchModel.allLanguageData.location.uploadDocument;
		var owner = $author$project$Data$PDF$Create$getOwner(model.pdf);
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'data-test', 'Your Signatures')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadMultipleDocument$styles.signatureImgBox)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(uploadDocumentLanguageData.signatures)
						])),
					A2(
					$elm$core$Maybe$withDefault,
					A3($author$project$Page$UploadMultipleDocument$signatureList, owner, model.lastStyle, signatureModel),
					A2($elm$core$Maybe$map, $author$project$Page$UploadMultipleDocument$signatureError, signatureModel.listError))
				]));
	});
var $author$project$Type$UploadMultipleDocument$Leave = {$: 'Leave'};
var $author$project$Type$UploadMultipleDocument$OnStampsHover = F2(
	function (a, b) {
		return {$: 'OnStampsHover', a: a, b: b};
	});
var $author$project$Type$UploadMultipleDocument$Organisation = {$: 'Organisation'};
var $author$project$Type$UploadMultipleDocument$Personal = {$: 'Personal'};
var $author$project$Data$PDF$Annotation$stampedStamp = F2(
	function (style, stamp) {
		return $author$project$Data$PDF$Annotation$IsStamp(
			$author$project$Data$PDF$Annotation$Stamp(
				{
					dbId: '',
					id: '',
					status: $author$project$Data$PDF$Annotation$Stamped(stamp),
					style: style
				}));
	});
var $author$project$Page$UploadMultipleDocument$renderStamp = F3(
	function (owner, style, stamp) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$span,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadMultipleDocument$styles.stamp)
				]),
			_List_fromArray(
				[
					function () {
					var _v0 = $author$project$Data$PDF$Stamp$data(stamp);
					if (_v0.$ === 'NotLoaded') {
						return A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadMultipleDocument$styles.stampImg)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Loading...')
								]));
					} else {
						var data = _v0.a;
						return A2(
							$rtfeldman$elm_css$Html$Styled$img,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$src(data),
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadMultipleDocument$styles.stampImg),
									$rtfeldman$elm_css$Html$Styled$Events$onClick(
									$author$project$Types$OnAuth(
										$author$project$Types$OnMultipleDocUpload(
											A2(
												$author$project$Type$UploadMultipleDocument$OnAnnotClick,
												owner.user,
												A2($author$project$Data$PDF$Annotation$stampedStamp, style, stamp)))))
								]),
							_List_Nil);
					}
				}()
				]));
	});
var $author$project$Page$UploadMultipleDocument$stampList = F7(
	function (languageSwitchModel, owner, lastStyle, domain, stampModel, headerText, loadedModel) {
		var uploadDocumentLanguageData = languageSwitchModel.allLanguageData.location.uploadDocument;
		var style = A3($author$project$Data$PDF$Annotation$createStyle, lastStyle.stamped.width, lastStyle.stamped.height, '0pt');
		var _v0 = A2(
			$elm$core$Dict$get,
			$author$project$Data$Domain$toString(domain),
			stampModel.stamps);
		if (_v0.$ === 'Nothing') {
			return $rtfeldman$elm_css$Html$Styled$text('');
		} else {
			var stampStatus = _v0.a;
			if (stampStatus.$ === 'Loaded') {
				var stamps = stampStatus.a;
				var toolTipText = uploadDocumentLanguageData.stampTooltipText;
				return A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadMultipleDocument$styles.margin30)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadMultipleDocument$styles.stampHeaderStyles)
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadMultipleDocument$styles.signatureImgBox),
											A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'data-test', headerText)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(headerText)
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadMultipleDocument$styles.iconStyles)
										]),
									_List_fromArray(
										[
											function () {
											switch (headerText) {
												case 'Organisation Stamps':
													return A5(
														$author$project$View$InfomationToolTip$view,
														$author$project$Types$OnAuth(
															$author$project$Types$OnMultipleDocUpload(
																A2($author$project$Type$UploadMultipleDocument$OnStampsHover, $author$project$Type$UploadMultipleDocument$Organisation, $author$project$Type$UploadMultipleDocument$Enter))),
														$author$project$Types$OnAuth(
															$author$project$Types$OnMultipleDocUpload(
																A2($author$project$Type$UploadMultipleDocument$OnStampsHover, $author$project$Type$UploadMultipleDocument$Organisation, $author$project$Type$UploadMultipleDocument$Leave))),
														loadedModel.organisationStampsHover,
														A2(
															$rtfeldman$elm_css$Html$Styled$span,
															_List_fromArray(
																[
																	$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadMultipleDocument$styles.toolTipText)
																]),
															_List_fromArray(
																[
																	$rtfeldman$elm_css$Html$Styled$text(toolTipText)
																])),
														$author$project$Material$Styled$Icon$help);
												case 'Stamps':
													return A5(
														$author$project$View$InfomationToolTip$view,
														$author$project$Types$OnAuth(
															$author$project$Types$OnMultipleDocUpload(
																A2($author$project$Type$UploadMultipleDocument$OnStampsHover, $author$project$Type$UploadMultipleDocument$Personal, $author$project$Type$UploadMultipleDocument$Enter))),
														$author$project$Types$OnAuth(
															$author$project$Types$OnMultipleDocUpload(
																A2($author$project$Type$UploadMultipleDocument$OnStampsHover, $author$project$Type$UploadMultipleDocument$Personal, $author$project$Type$UploadMultipleDocument$Leave))),
														loadedModel.personalStampsHover,
														A2(
															$rtfeldman$elm_css$Html$Styled$span,
															_List_fromArray(
																[
																	$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadMultipleDocument$styles.toolTipText)
																]),
															_List_fromArray(
																[
																	$rtfeldman$elm_css$Html$Styled$text(toolTipText)
																])),
														$author$project$Material$Styled$Icon$help);
												default:
													return $rtfeldman$elm_css$Html$Styled$text('');
											}
										}()
										]))
								])),
							A2($author$project$View$Stamp$displayFormStatus, stampModel, domain),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadMultipleDocument$styles.signatureListBox)
								]),
							_Utils_ap(
								A2(
									$elm$core$List$map,
									A2($author$project$Page$UploadMultipleDocument$renderStamp, owner, style),
									$elm$core$Dict$values(stamps)),
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$div,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadMultipleDocument$styles.create),
												$rtfeldman$elm_css$Html$Styled$Events$onClick(
												$author$project$Types$OnStamp(
													$author$project$Type$Stamp$OnImageUpload(
														$author$project$Type$Stamp$ImageRequested(domain)))),
												A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'data-test', 'stamp')
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('+')
											]))
									])))
						]));
			} else {
				return $rtfeldman$elm_css$Html$Styled$text('');
			}
		}
	});
var $author$project$Data$PDF$Create$toStringRole = function (role) {
	if (role.$ === 'Viewer') {
		return 'Viewer';
	} else {
		return 'Signer';
	}
};
var $author$project$Type$UploadMultipleDocument$CheckBox = {$: 'CheckBox'};
var $author$project$Type$UploadMultipleDocument$Date = {$: 'Date'};
var $author$project$Type$UploadMultipleDocument$EditableText = {$: 'EditableText'};
var $author$project$Type$UploadMultipleDocument$EmailText = {$: 'EmailText'};
var $author$project$Type$UploadMultipleDocument$Name = {$: 'Name'};
var $author$project$Type$UploadMultipleDocument$NonEditableText = {$: 'NonEditableText'};
var $author$project$Type$UploadMultipleDocument$NotSelected = {$: 'NotSelected'};
var $author$project$Type$UploadMultipleDocument$Signature = {$: 'Signature'};
var $author$project$Type$UploadMultipleDocument$Stamp = {$: 'Stamp'};
var $author$project$Type$UploadMultipleDocument$annotList = _List_fromArray(
	[$author$project$Type$UploadMultipleDocument$NotSelected, $author$project$Type$UploadMultipleDocument$Signature, $author$project$Type$UploadMultipleDocument$Stamp, $author$project$Type$UploadMultipleDocument$Name, $author$project$Type$UploadMultipleDocument$Date, $author$project$Type$UploadMultipleDocument$EditableText, $author$project$Type$UploadMultipleDocument$NonEditableText, $author$project$Type$UploadMultipleDocument$EmailText, $author$project$Type$UploadMultipleDocument$CheckBox]);
var $author$project$Type$UploadMultipleDocument$annotMenuTypeToString = F2(
	function (languageSwitchModel, annot) {
		var uploadDocumentLanguageData = languageSwitchModel.allLanguageData.location.uploadDocument;
		switch (annot.$) {
			case 'NotSelected':
				return uploadDocumentLanguageData.addToDocument;
			case 'Signature':
				return uploadDocumentLanguageData.signatureField;
			case 'Stamp':
				return uploadDocumentLanguageData.stampField;
			case 'Name':
				return uploadDocumentLanguageData.nameField;
			case 'Date':
				return uploadDocumentLanguageData.dateSigned;
			case 'EditableText':
				return uploadDocumentLanguageData.editableText;
			case 'NonEditableText':
				return uploadDocumentLanguageData.nonEditableText;
			case 'EmailText':
				return uploadDocumentLanguageData.emailField;
			default:
				return uploadDocumentLanguageData.checkboxField;
		}
	});
var $author$project$Data$PDF$Annotation$checkBoxCreate = F2(
	function (style, status) {
		return $author$project$Data$PDF$Annotation$IsCheckbox(
			$author$project$Data$PDF$Annotation$Checkbox(
				{dbId: '', id: '', status: status, style: style}));
	});
var $author$project$Data$PDF$Annotation$dateTxt = function (style) {
	return $author$project$Data$PDF$Annotation$Date(
		$author$project$Data$PDF$Annotation$DateTxt(
			{
				date: $elm$time$Time$millisToPosix(0),
				dbId: '',
				id: '',
				status: $author$project$Data$PDF$Annotation$Unverified,
				style: style
			}));
};
var $author$project$Data$PDF$Annotation$editableTextTxt = F2(
	function (style, verified) {
		return $author$project$Data$PDF$Annotation$EditableText(
			$author$project$Data$PDF$Annotation$Txt(
				{dbId: '', id: '', status: verified, style: style, text: 'Text'}));
	});
var $author$project$Data$PDF$Annotation$emailTxt = F3(
	function (style, verified, name) {
		var text = _Utils_eq(verified, $author$project$Data$PDF$Annotation$Verified) ? name : 'Email';
		return $author$project$Data$PDF$Annotation$IsEmail(
			$author$project$Data$PDF$Annotation$Txt(
				{dbId: '', id: '', status: verified, style: style, text: text}));
	});
var $author$project$Data$PDF$Annotation$nameTxt = F3(
	function (style, verified, name) {
		var text = _Utils_eq(verified, $author$project$Data$PDF$Annotation$Verified) ? name : 'Name';
		return $author$project$Data$PDF$Annotation$Name(
			$author$project$Data$PDF$Annotation$Txt(
				{dbId: '', id: '', status: verified, style: style, text: text}));
	});
var $author$project$Data$PDF$Annotation$nonEditableTextTxt = F2(
	function (style, verified) {
		return $author$project$Data$PDF$Annotation$NonEditableText(
			$author$project$Data$PDF$Annotation$Txt(
				{dbId: '', id: '', status: verified, style: style, text: 'Text'}));
	});
var $author$project$Type$UploadMultipleDocument$stringToAnnotMenu = F2(
	function (languageSwitchModel, annot) {
		var uploadDocumentLanguageData = languageSwitchModel.allLanguageData.location.uploadDocument;
		return _Utils_eq(annot, uploadDocumentLanguageData.addToDocument) ? $author$project$Type$UploadMultipleDocument$NotSelected : (_Utils_eq(annot, uploadDocumentLanguageData.signatureField) ? $author$project$Type$UploadMultipleDocument$Signature : (_Utils_eq(annot, uploadDocumentLanguageData.stampField) ? $author$project$Type$UploadMultipleDocument$Stamp : (_Utils_eq(annot, uploadDocumentLanguageData.nameField) ? $author$project$Type$UploadMultipleDocument$Name : (_Utils_eq(annot, uploadDocumentLanguageData.dateSigned) ? $author$project$Type$UploadMultipleDocument$Date : (_Utils_eq(annot, uploadDocumentLanguageData.editableText) ? $author$project$Type$UploadMultipleDocument$EditableText : (_Utils_eq(annot, uploadDocumentLanguageData.nonEditableText) ? $author$project$Type$UploadMultipleDocument$NonEditableText : (_Utils_eq(annot, uploadDocumentLanguageData.emailField) ? $author$project$Type$UploadMultipleDocument$EmailText : (_Utils_eq(annot, uploadDocumentLanguageData.checkboxField) ? $author$project$Type$UploadMultipleDocument$CheckBox : $author$project$Type$UploadMultipleDocument$NotSelected))))))));
	});
var $author$project$Page$UploadMultipleDocument$Annotation$styles = {
	btn: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$margin(
			$rtfeldman$elm_css$Css$px(5)),
			$rtfeldman$elm_css$Css$maxWidth($rtfeldman$elm_css$Css$fitContent)
		]),
	container: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$row),
			$rtfeldman$elm_css$Css$flexWrap($rtfeldman$elm_css$Css$wrap)
		]),
	txt: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(15)),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$em(0.8)),
			$rtfeldman$elm_css$Css$fontWeight(
			$rtfeldman$elm_css$Css$int(500))
		])
};
var $author$project$Data$PDF$Annotation$unsignedSignature = function (style) {
	return $author$project$Data$PDF$Annotation$IsSignature(
		$author$project$Data$PDF$Annotation$Signature(
			{dbId: '', id: '', status: $author$project$Data$PDF$Annotation$Unsigned, style: style}));
};
var $author$project$Data$PDF$Annotation$unstampedStamp = function (style) {
	return $author$project$Data$PDF$Annotation$IsStamp(
		$author$project$Data$PDF$Annotation$Stamp(
			{dbId: '', id: '', status: $author$project$Data$PDF$Annotation$Unstamped, style: style}));
};
var $author$project$Page$UploadMultipleDocument$Annotation$view = F4(
	function (languageSwitchModel, lastStyle, user, owner) {
		var unstampedStyle = A3($author$project$Data$PDF$Annotation$createStyle, lastStyle.unstamped.width, lastStyle.unstamped.height, lastStyle.unstamped.fontSize);
		var unsignedStyle = A3($author$project$Data$PDF$Annotation$createStyle, lastStyle.unsignedSignature.width, lastStyle.unsignedSignature.height, '0pt');
		var textStyle = A3($author$project$Data$PDF$Annotation$createStyle, lastStyle.text.width, lastStyle.text.height, lastStyle.text.fontSize);
		var nameStyle = A3($author$project$Data$PDF$Annotation$createStyle, lastStyle.name.width, lastStyle.name.height, lastStyle.name.fontSize);
		var isVerified = _Utils_eq(
			$author$project$Data$PDF$User$emailFromUser(user),
			$author$project$Data$PDF$User$emailFromUser(owner)) ? $author$project$Data$PDF$Annotation$Verified : $author$project$Data$PDF$Annotation$Unverified;
		var emailStyle = A3($author$project$Data$PDF$Annotation$createStyle, lastStyle.email.width, lastStyle.email.height, lastStyle.email.fontSize);
		var dateStyle = A3($author$project$Data$PDF$Annotation$createStyle, lastStyle.date.width, lastStyle.date.height, lastStyle.date.fontSize);
		var checkboxStyle = A3($author$project$Data$PDF$Annotation$createStyle, lastStyle.checkbox.width, lastStyle.checkbox.height, lastStyle.checkbox.fontSize);
		var addToDocumentText = languageSwitchModel.allLanguageData.location.uploadDocument.addToDocument;
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					A2($elm$core$List$append, $author$project$Page$UploadMultipleDocument$Annotation$styles.txt, $author$project$Page$UploadMultipleDocument$Annotation$styles.container))
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Material$Styled$Select$select,
					_List_fromArray(
						[
							$author$project$Material$Styled$Select$label('Fields'),
							$author$project$Material$Styled$Select$containerStyles(
							_List_fromArray(
								[
									$rtfeldman$elm_css$Css$width(
									$rtfeldman$elm_css$Css$pct(100))
								])),
							$author$project$Material$Styled$Select$value(addToDocumentText),
							$author$project$Material$Styled$Select$onChange(
							function (annot) {
								var _v0 = A2($author$project$Type$UploadMultipleDocument$stringToAnnotMenu, languageSwitchModel, annot);
								switch (_v0.$) {
									case 'Signature':
										return $author$project$Types$OnAuth(
											$author$project$Types$OnMultipleDocUpload(
												A2(
													$author$project$Type$UploadMultipleDocument$OnAnnotClick,
													user,
													$author$project$Data$PDF$Annotation$unsignedSignature(unsignedStyle))));
									case 'Stamp':
										return $author$project$Types$OnAuth(
											$author$project$Types$OnMultipleDocUpload(
												A2(
													$author$project$Type$UploadMultipleDocument$OnAnnotClick,
													user,
													$author$project$Data$PDF$Annotation$unstampedStamp(unstampedStyle))));
									case 'Name':
										return $author$project$Types$OnAuth(
											$author$project$Types$OnMultipleDocUpload(
												A2(
													$author$project$Type$UploadMultipleDocument$OnAnnotClick,
													user,
													A3(
														$author$project$Data$PDF$Annotation$nameTxt,
														nameStyle,
														isVerified,
														$author$project$Data$PDF$User$formatName(user)))));
									case 'Date':
										return $author$project$Types$OnAuth(
											$author$project$Types$OnMultipleDocUpload(
												A2(
													$author$project$Type$UploadMultipleDocument$OnAnnotClick,
													user,
													$author$project$Data$PDF$Annotation$dateTxt(dateStyle))));
									case 'EditableText':
										return $author$project$Types$OnAuth(
											$author$project$Types$OnMultipleDocUpload(
												A2(
													$author$project$Type$UploadMultipleDocument$OnAnnotClick,
													user,
													A2($author$project$Data$PDF$Annotation$editableTextTxt, textStyle, isVerified))));
									case 'NonEditableText':
										return $author$project$Types$OnAuth(
											$author$project$Types$OnMultipleDocUpload(
												A2(
													$author$project$Type$UploadMultipleDocument$OnAnnotClick,
													user,
													A2($author$project$Data$PDF$Annotation$nonEditableTextTxt, textStyle, isVerified))));
									case 'EmailText':
										return $author$project$Types$OnAuth(
											$author$project$Types$OnMultipleDocUpload(
												A2(
													$author$project$Type$UploadMultipleDocument$OnAnnotClick,
													user,
													A3(
														$author$project$Data$PDF$Annotation$emailTxt,
														emailStyle,
														isVerified,
														$author$project$Data$PDF$User$emailFromUser(user)))));
									case 'NotSelected':
										return $author$project$Types$OnAuth(
											$author$project$Types$OnMultipleDocUpload(
												A2(
													$author$project$Type$UploadMultipleDocument$OnAnnotClick,
													user,
													$author$project$Data$PDF$Annotation$unsignedSignature(unsignedStyle))));
									default:
										return $author$project$Types$OnAuth(
											$author$project$Types$OnMultipleDocUpload(
												A2(
													$author$project$Type$UploadMultipleDocument$OnAnnotClick,
													user,
													A2($author$project$Data$PDF$Annotation$checkBoxCreate, checkboxStyle, $author$project$Data$PDF$Annotation$PlaceHolder))));
								}
							})
						]),
					A2(
						$elm$core$List$map,
						function (r) {
							return A2(
								$rtfeldman$elm_css$Html$Styled$option,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$value(
										A2($author$project$Type$UploadMultipleDocument$annotMenuTypeToString, languageSwitchModel, r))
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										A2($author$project$Type$UploadMultipleDocument$annotMenuTypeToString, languageSwitchModel, r))
									]));
						},
						$author$project$Type$UploadMultipleDocument$annotList))
				]));
	});
var $author$project$Page$UploadMultipleDocument$ownerAnnots = F6(
	function (languageSwitchModel, model, selectedDomain, appDomain, signatureModel, stampModel) {
		var uploadDocumentLanguageData = languageSwitchModel.allLanguageData.location.uploadDocument;
		var owner = $author$project$Data$PDF$Create$getOwner(model.pdf);
		var ownerInfo = $author$project$Data$PDF$User$userInfo(owner.user);
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadMultipleDocument$styles.annotContainer),
					$rtfeldman$elm_css$Html$Styled$Attributes$id(
					$author$project$Data$PDF$User$emailFromUser(owner.user))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadMultipleDocument$styles.ownerItemTitle)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadMultipleDocument$styles.signerNameContainer)
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadMultipleDocument$styles.recipientItemTitle),
											$rtfeldman$elm_css$Html$Styled$Attributes$css(
											_List_fromArray(
												[
													$rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$inline)
												]))
										]),
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$strong,
											_List_Nil,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(
													$author$project$Data$PDF$User$formatName(owner.user))
												])),
											$rtfeldman$elm_css$Html$Styled$text(' ' + ownerInfo.email)
										]))
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadMultipleDocument$styles.avatarContainer)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$a,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css(
									A2(
										$elm$core$List$append,
										$author$project$Page$UploadMultipleDocument$styles.avatar,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Css$backgroundColor(
												$author$project$Data$PDF$User$materialColorCode(ownerInfo.color))
											]))),
									$rtfeldman$elm_css$Html$Styled$Attributes$title(ownerInfo.firstName)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									A2($elm$core$String$left, 2, ownerInfo.firstName))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadMultipleDocument$styles.viewerText)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									uploadDocumentLanguageData.owner + (' / ' + (uploadDocumentLanguageData.sender + (' (' + ($author$project$Data$PDF$Create$toStringRole(owner.role) + ')')))))
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_Nil,
					_List_fromArray(
						[
							A3($author$project$Page$UploadMultipleDocument$renderSignatures, languageSwitchModel, model, signatureModel),
							_Utils_eq(selectedDomain, appDomain) ? $rtfeldman$elm_css$Html$Styled$text('') : A7($author$project$Page$UploadMultipleDocument$stampList, languageSwitchModel, owner, model.lastStyle, selectedDomain, stampModel, 'Organisation Stamps', model),
							A7($author$project$Page$UploadMultipleDocument$stampList, languageSwitchModel, owner, model.lastStyle, appDomain, stampModel, uploadDocumentLanguageData.stampField, model),
							A4($author$project$Page$UploadMultipleDocument$Annotation$view, languageSwitchModel, model.lastStyle, owner.user, owner.user)
						]))
				]));
	});
var $author$project$Type$UploadMultipleDocument$OnRemoveRecipientClick = function (a) {
	return {$: 'OnRemoveRecipientClick', a: a};
};
var $author$project$Page$UploadMultipleDocument$recepientAnnots = F2(
	function (languageSwitchModel, model) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_Nil,
			A2(
				$elm$core$List$map,
				function (value) {
					var userId = $author$project$Data$PDF$User$emailFromUser(value.user);
					var user = $author$project$Data$PDF$User$userInfo(value.user);
					return A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css(
								_Utils_ap($author$project$Page$UploadMultipleDocument$styles.recipientContent, $author$project$Page$UploadMultipleDocument$styles.annotContainer)),
								$rtfeldman$elm_css$Html$Styled$Attributes$id(userId)
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadMultipleDocument$styles.signerNameContainer)
									]),
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$div,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadMultipleDocument$styles.recipientHeader)
											]),
										_List_fromArray(
											[
												A2(
												$rtfeldman$elm_css$Html$Styled$span,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadMultipleDocument$styles.recipientItemTitle),
														$rtfeldman$elm_css$Html$Styled$Attributes$css(
														_List_fromArray(
															[
																$rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$inline)
															]))
													]),
												_List_fromArray(
													[
														A2(
														$rtfeldman$elm_css$Html$Styled$strong,
														_List_Nil,
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$text(
																$author$project$Data$PDF$User$formatName(value.user))
															])),
														$rtfeldman$elm_css$Html$Styled$text(' ' + user.email)
													]))
											]))
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadMultipleDocument$styles.avatarContainer)
									]),
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$span,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$css(
												A2(
													$elm$core$List$append,
													$author$project$Page$UploadMultipleDocument$styles.avatar,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Css$backgroundColor(
															$author$project$Data$PDF$User$materialColorCode(user.color))
														]))),
												$rtfeldman$elm_css$Html$Styled$Attributes$title(user.firstName)
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(
												A2($elm$core$String$left, 2, user.firstName))
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$span,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadMultipleDocument$styles.viewerText)
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(
												$author$project$Data$PDF$Create$toStringRole(value.role))
											])),
										A2(
										$author$project$Material$Styled$Icon$close,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Svg$Styled$Attributes$css($author$project$Page$UploadMultipleDocument$styles.recipientRmvIcon),
												$rtfeldman$elm_css$Svg$Styled$Events$onClick(
												$author$project$Types$OnAuth(
													$author$project$Types$OnMultipleDocUpload(
														$author$project$Type$UploadMultipleDocument$OnRemoveRecipientClick(userId))))
											]),
										_List_Nil)
									])),
								A4(
								$author$project$Page$UploadMultipleDocument$Annotation$view,
								languageSwitchModel,
								model.lastStyle,
								value.user,
								$author$project$Data$PDF$Create$getOwner(model.pdf).user)
							]));
				},
				$elm$core$Dict$values(
					$author$project$Data$PDF$Create$recipientsWithoutOwner(model.pdf))));
	});
var $author$project$Page$UploadMultipleDocument$annotations = F4(
	function (languageSwitchModel, loadedModel, authModel, appDomain) {
		var uploadDocumentLanguageData = languageSwitchModel.allLanguageData.location.uploadDocument;
		var titleList = A2(
			$elm$core$List$map,
			function (pdfData) {
				return _Utils_Tuple2(
					$author$project$Data$PDF$Create$title(pdfData.pdf),
					pdfData.id);
			},
			loadedModel.pdfList);
		var indexedPDFList = A2($elm$core$List$indexedMap, $elm$core$Tuple$pair, loadedModel.pdfList);
		var selectedPDFIndex = A2(
			$elm$core$Maybe$withDefault,
			0,
			$elm$core$List$head(
				A2(
					$elm$core$List$filterMap,
					function (_v5) {
						var index = _v5.a;
						var pdfData = _v5.b;
						return _Utils_eq(pdfData.id, loadedModel.selectedPDF) ? $elm$core$Maybe$Just(index) : $elm$core$Maybe$Nothing;
					},
					indexedPDFList)));
		var getPDFIdFromList = function (index) {
			return A2(
				$elm$core$Maybe$withDefault,
				'',
				$elm$core$List$head(
					A2(
						$elm$core$List$filterMap,
						function (_v4) {
							var pdfIndex = _v4.a;
							var pdfData = _v4.b;
							return _Utils_eq(pdfIndex, index) ? $elm$core$Maybe$Just(pdfData.id) : $elm$core$Maybe$Nothing;
						},
						indexedPDFList)));
		};
		var previousDocumentMsg = ((selectedPDFIndex - 1) < 0) ? $author$project$Types$Noop : $author$project$Types$OnAuth(
			$author$project$Types$OnMultipleDocUpload(
				$author$project$Type$UploadMultipleDocument$OnFileSwitch(
					getPDFIdFromList(selectedPDFIndex - 1))));
		var domain = $author$project$Data$Domain$selected(authModel.user.domains);
		var deleteButtonText = function () {
			var _v3 = loadedModel.clickedAnnot;
			if (_v3.$ === 'Just') {
				return 'Delete Annoation';
			} else {
				return 'Select Annotation to delete';
			}
		}();
		var _v0 = loadedModel;
		var title = _v0.title;
		var titleError = _v0.titleError;
		var selectedPDF = _v0.selectedPDF;
		var _v1 = (_Utils_cmp(
			selectedPDFIndex + 1,
			$elm$core$List$length(indexedPDFList)) > -1) ? {nextDocumentButtonTheme: $author$project$Material$Styled$Button$default, nextDocumentMsg: $author$project$Types$Noop, nextStepButtonTheme: $author$project$Material$Styled$Button$blue} : {
			nextDocumentButtonTheme: $author$project$Material$Styled$Button$blue,
			nextDocumentMsg: $author$project$Types$OnAuth(
				$author$project$Types$OnMultipleDocUpload(
					$author$project$Type$UploadMultipleDocument$OnFileSwitch(
						getPDFIdFromList(selectedPDFIndex + 1)))),
			nextStepButtonTheme: $author$project$Material$Styled$Button$default
		};
		var nextDocumentMsg = _v1.nextDocumentMsg;
		var nextDocumentButtonTheme = _v1.nextDocumentButtonTheme;
		var nextStepButtonTheme = _v1.nextStepButtonTheme;
		return _Utils_eq(loadedModel.stage, $author$project$Type$UploadMultipleDocument$Annotations) ? A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadMultipleDocument$styles.sectionContainer)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[$rtfeldman$elm_css$Css$displayFlex]))
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadMultipleDocument$styles.addFieldIcon)
								]),
							_List_fromArray(
								[
									A2($author$project$Material$Styled$Icon$addFields, _List_Nil, _List_Nil)
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadMultipleDocument$styles.annotCardTitle)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(uploadDocumentLanguageData.step3)
								]))
						])),
					A2(
					$author$project$Material$Styled$Select$select,
					_List_fromArray(
						[
							$author$project$Material$Styled$Select$label('Selected Document'),
							$author$project$Material$Styled$Select$containerStyles($author$project$Page$UploadMultipleDocument$styles.rowSelect),
							$author$project$Material$Styled$Select$value(selectedPDF),
							$author$project$Material$Styled$Select$onChange(
							function (newFile) {
								return $author$project$Types$OnAuth(
									$author$project$Types$OnMultipleDocUpload(
										$author$project$Type$UploadMultipleDocument$OnFileSwitch(newFile)));
							})
						]),
					A2(
						$elm$core$List$map,
						function (_v2) {
							var pdfTitle = _v2.a;
							var pdfID = _v2.b;
							return A2(
								$rtfeldman$elm_css$Html$Styled$option,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$value(pdfID)
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(pdfTitle)
									]));
						},
						titleList)),
					A2(
					$author$project$Material$Styled$Input$text,
					_List_fromArray(
						[
							$author$project$Material$Styled$Input$containerStyles($author$project$Page$UploadMultipleDocument$styles.inputContainer),
							$author$project$Material$Styled$Input$label('Document Title*'),
							$author$project$Material$Styled$Input$value(title),
							$author$project$Material$Styled$Input$errorMessage(titleError),
							$author$project$Material$Styled$Input$onInput(
							A2(
								$elm$core$Basics$composeL,
								A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnMultipleDocUpload),
								$author$project$Type$UploadMultipleDocument$OnDocInput($author$project$Type$UploadMultipleDocument$Title))),
							$author$project$Material$Styled$Input$onBlur(
							$author$project$Types$OnAuth(
								$author$project$Types$OnMultipleDocUpload(
									$author$project$Type$UploadMultipleDocument$OnDocBlur($author$project$Type$UploadMultipleDocument$Title))))
						]),
					_List_Nil),
					A2(
					$author$project$Material$Styled$Input$number,
					_List_fromArray(
						[
							$author$project$Material$Styled$Input$containerStyles($author$project$Page$UploadMultipleDocument$styles.inputContainer),
							$author$project$Material$Styled$Input$label('Font Size'),
							$author$project$Material$Styled$Input$value(loadedModel.textFontSize),
							$author$project$Material$Styled$Input$onInput(
							A2(
								$elm$core$Basics$composeL,
								A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnMultipleDocUpload),
								$author$project$Type$UploadMultipleDocument$OnFontSizeUpdate))
						]),
					_List_Nil),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadMultipleDocument$styles.annotContent)
						]),
					_List_fromArray(
						[
							A6($author$project$Page$UploadMultipleDocument$ownerAnnots, languageSwitchModel, loadedModel, domain, appDomain, authModel.signatureModel, authModel.stampModel),
							A2($author$project$Page$UploadMultipleDocument$recepientAnnots, languageSwitchModel, loadedModel)
						])),
					A2(
					$author$project$Material$Styled$Button$button,
					_List_fromArray(
						[
							$author$project$Material$Styled$Button$theme($author$project$Material$Styled$Button$red),
							$author$project$Material$Styled$Button$styles(
							_List_fromArray(
								[
									$rtfeldman$elm_css$Css$width(
									$rtfeldman$elm_css$Css$pct(100))
								])),
							$author$project$Material$Styled$Button$onClick(
							$author$project$Types$OnAuth(
								$author$project$Types$OnMultipleDocUpload($author$project$Type$UploadMultipleDocument$OnReceiveDeleteAnnotClick))),
							$author$project$Material$Styled$Button$disabled(
							_Utils_eq(loadedModel.clickedAnnot, $elm$core$Maybe$Nothing))
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(deleteButtonText)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[
									$rtfeldman$elm_css$Css$displayFlex,
									$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$row),
									$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceBetween),
									$rtfeldman$elm_css$Css$marginTop(
									$rtfeldman$elm_css$Css$px(10))
								]))
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Material$Styled$Button$button,
							_List_fromArray(
								[
									$author$project$Material$Styled$Button$theme($author$project$Material$Styled$Button$default),
									$author$project$Material$Styled$Button$styles(
									_List_fromArray(
										[
											$rtfeldman$elm_css$Css$width(
											$rtfeldman$elm_css$Css$pct(48))
										])),
									$author$project$Material$Styled$Button$onClick(previousDocumentMsg)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(uploadDocumentLanguageData.previousDocument)
								])),
							A2(
							$author$project$Material$Styled$Button$button,
							_List_fromArray(
								[
									$author$project$Material$Styled$Button$theme(nextDocumentButtonTheme),
									$author$project$Material$Styled$Button$styles(
									_List_fromArray(
										[
											$rtfeldman$elm_css$Css$width(
											$rtfeldman$elm_css$Css$pct(48))
										])),
									$author$project$Material$Styled$Button$onClick(nextDocumentMsg)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(uploadDocumentLanguageData.nextDocument)
								]))
						])),
					A2(
					$author$project$Material$Styled$Button$button,
					_List_fromArray(
						[
							$author$project$Material$Styled$Button$theme(nextStepButtonTheme),
							$author$project$Material$Styled$Button$styles(
							_List_fromArray(
								[
									$rtfeldman$elm_css$Css$marginTop(
									$rtfeldman$elm_css$Css$px(10))
								])),
							$author$project$Material$Styled$Button$onClick(
							$author$project$Types$OnAuth(
								$author$project$Types$OnMultipleDocUpload(
									$author$project$Type$UploadMultipleDocument$GoToStage($author$project$Type$UploadMultipleDocument$Options))))
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadMultipleDocument$styles.sendIcon)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Material$Styled$Icon$navigateNext,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Svg$Styled$Attributes$fill('white')
										]),
									_List_Nil),
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css(
											_List_fromArray(
												[
													$rtfeldman$elm_css$Css$paddingLeft(
													$rtfeldman$elm_css$Css$px(5)),
													$rtfeldman$elm_css$Css$paddingTop(
													$rtfeldman$elm_css$Css$px(1.5))
												]))
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(uploadDocumentLanguageData.nextStep)
										]))
								]))
						]))
				])) : A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Events$onClick(
					$author$project$Types$OnAuth(
						$author$project$Types$OnMultipleDocUpload(
							$author$project$Type$UploadMultipleDocument$GoToStage($author$project$Type$UploadMultipleDocument$Annotations)))),
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadMultipleDocument$styles.sectionContainerClosed)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadMultipleDocument$styles.addFieldIcon)
						]),
					_List_fromArray(
						[
							A2($author$project$Material$Styled$Icon$addFields, _List_Nil, _List_Nil)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadMultipleDocument$styles.annotCardTitleClosed)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(uploadDocumentLanguageData.step3)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_Nil,
					_List_fromArray(
						[
							A2($author$project$Material$Styled$Icon$keyboardArrowDown, _List_Nil, _List_Nil)
						]))
				]));
	});
var $author$project$View$Signature$checkSignatureList = function (signatureModel) {
	return $elm$core$List$isEmpty(signatureModel.signatures) ? true : signatureModel.open;
};
var $author$project$Type$UploadMultipleDocument$Documents = {$: 'Documents'};
var $author$project$Material$Styled$Icon$UploadFIle$view = F2(
	function (attributes, children) {
		return A2(
			$rtfeldman$elm_css$Svg$Styled$svg,
			_Utils_ap(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Svg$Styled$Attributes$fill('black'),
						$rtfeldman$elm_css$Svg$Styled$Attributes$width('24px'),
						$rtfeldman$elm_css$Svg$Styled$Attributes$height('24px'),
						$rtfeldman$elm_css$Svg$Styled$Attributes$viewBox('0 0 24 24')
					]),
				attributes),
			_Utils_ap(
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Svg$Styled$path,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Svg$Styled$Attributes$d('M0 0h24v24H0z'),
								$rtfeldman$elm_css$Svg$Styled$Attributes$fill('none')
							]),
						_List_Nil),
						A2(
						$rtfeldman$elm_css$Svg$Styled$path,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Svg$Styled$Attributes$d('M14,2H6C4.9,2,4.01,2.9,4.01,4L4,20c0,1.1,0.89,2,1.99,2H18c1.1,0,2-0.9,2-2V8L14,2z M18,20H6V4h7v5h5V20z M8,15.01 l1.41,1.41L11,14.84V19h2v-4.16l1.59,1.59L16,15.01L12.01,11L8,15.01z')
							]),
						_List_Nil)
					]),
				children));
	});
var $author$project$Material$Styled$Icon$uploadFile = $author$project$Material$Styled$Icon$UploadFIle$view;
var $author$project$Page$UploadMultipleDocument$documents = F2(
	function (loadedModel, languageSwitchModel) {
		var uploadDocumentLanguageData = languageSwitchModel.allLanguageData.location.uploadDocument;
		var title = _Utils_ap(
			uploadDocumentLanguageData.step1,
			_Utils_ap(
				$elm$core$String$fromInt(
					$elm$core$List$length(loadedModel.pdfList)),
				uploadDocumentLanguageData.documentsUploaded));
		return _Utils_eq(loadedModel.stage, $author$project$Type$UploadMultipleDocument$Documents) ? A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadMultipleDocument$styles.sectionContainer)
				]),
			A2(
				$elm$core$List$cons,
				A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadMultipleDocument$styles.annotCardTitle)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css(
									_List_fromArray(
										[$rtfeldman$elm_css$Css$displayFlex]))
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadMultipleDocument$styles.addFieldIcon)
										]),
									_List_fromArray(
										[
											A2($author$project$Material$Styled$Icon$upload, _List_Nil, _List_Nil)
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css(
											_List_fromArray(
												[
													$rtfeldman$elm_css$Css$paddingTop(
													$rtfeldman$elm_css$Css$px(3))
												]))
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(title)
										]))
								]))
						])),
				A2(
					$elm$core$List$map,
					function (pdfData) {
						return A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadMultipleDocument$styles.documentDisplay)
								]),
							_List_fromArray(
								[
									A2($author$project$Material$Styled$Icon$uploadFile, _List_Nil, _List_Nil),
									A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadMultipleDocument$styles.marginLeft10)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											$author$project$Data$PDF$Create$title(pdfData.pdf))
										]))
								]));
					},
					loadedModel.pdfList))) : A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Events$onClick(
					$author$project$Types$OnAuth(
						$author$project$Types$OnMultipleDocUpload(
							$author$project$Type$UploadMultipleDocument$GoToStage($author$project$Type$UploadMultipleDocument$Documents)))),
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadMultipleDocument$styles.sectionContainerClosed)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadMultipleDocument$styles.addFieldIcon)
						]),
					_List_fromArray(
						[
							A2($author$project$Material$Styled$Icon$upload, _List_Nil, _List_Nil)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadMultipleDocument$styles.annotCardTitleClosed)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(title)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_Nil,
					_List_fromArray(
						[
							A2($author$project$Material$Styled$Icon$keyboardArrowDown, _List_Nil, _List_Nil)
						]))
				]));
	});
var $author$project$Type$UploadMultipleDocument$OnErrorClose = {$: 'OnErrorClose'};
var $author$project$Page$UploadMultipleDocument$errorBanner = function (model) {
	var _v0 = model.status;
	if (_v0.$ === 'Error') {
		var err = _v0.a;
		return A2(
			$author$project$Material$Styled$Banner$banner,
			_List_fromArray(
				[
					$author$project$Material$Styled$Banner$containerStyles($author$project$Page$UploadMultipleDocument$styles.errorBannerContainer),
					$author$project$Material$Styled$Banner$theme($author$project$Material$Styled$Banner$errorTheme),
					$author$project$Material$Styled$Banner$body(
					$rtfeldman$elm_css$Html$Styled$text('- ' + err)),
					$author$project$Material$Styled$Banner$title('Error message'),
					$author$project$Material$Styled$Banner$closeIconAttributes(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Svg$Styled$Events$onClick(
							$author$project$Types$OnAuth(
								$author$project$Types$OnMultipleDocUpload($author$project$Type$UploadMultipleDocument$OnErrorClose)))
						]))
				]),
			_List_Nil);
	} else {
		return $rtfeldman$elm_css$Html$Styled$text('');
	}
};
var $author$project$Type$UploadMultipleDocument$OnClearInsertAnnot = {$: 'OnClearInsertAnnot'};
var $author$project$Page$UploadMultipleDocument$overlay = function (selectedAnnotation) {
	if (selectedAnnotation.$ === 'Just') {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadMultipleDocument$styles.overlay)
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text('Click on the Document on the left to insert the field.'),
					A2(
					$author$project$Material$Styled$Button$button,
					_List_fromArray(
						[
							$author$project$Material$Styled$Button$styles(
							_List_fromArray(
								[
									$rtfeldman$elm_css$Css$marginTop(
									$rtfeldman$elm_css$Css$px(20))
								])),
							$author$project$Material$Styled$Button$theme($author$project$Material$Styled$Button$grey),
							$author$project$Material$Styled$Button$onClick(
							$author$project$Types$OnAuth(
								$author$project$Types$OnMultipleDocUpload($author$project$Type$UploadMultipleDocument$OnClearInsertAnnot)))
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('Click Here To Cancel')
						]))
				]));
	} else {
		return $rtfeldman$elm_css$Html$Styled$text('');
	}
};
var $author$project$Type$UploadMultipleDocument$OnDocSubmit = {$: 'OnDocSubmit'};
var $author$project$Page$UploadMultipleDocument$submitButton = function (languageSwitchModel) {
	var uploadDocumentLanguageData = languageSwitchModel.allLanguageData.location.uploadDocument;
	return A2(
		$author$project$Material$Styled$Button$button,
		_List_fromArray(
			[
				$author$project$Material$Styled$Button$theme($author$project$Material$Styled$Button$green),
				$author$project$Material$Styled$Button$styles($author$project$Page$UploadMultipleDocument$styles.submitButton),
				$author$project$Material$Styled$Button$onClick(
				$author$project$Types$OnAuth(
					$author$project$Types$OnMultipleDocUpload($author$project$Type$UploadMultipleDocument$OnDocSubmit)))
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadMultipleDocument$styles.sendIcon)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Material$Styled$Icon$sendFilled,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Svg$Styled$Attributes$fill('white')
							]),
						_List_Nil),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Css$paddingLeft(
										$rtfeldman$elm_css$Css$px(5)),
										$rtfeldman$elm_css$Css$paddingTop(
										$rtfeldman$elm_css$Css$px(5))
									]))
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(uploadDocumentLanguageData.sendButtonText)
							]))
					]))
			]));
};
var $author$project$Type$UploadMultipleDocument$OnDocSuccessClose = {$: 'OnDocSuccessClose'};
var $author$project$Page$UploadMultipleDocument$Modal$styles = {
	activitiesModal: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$vw(90)),
			$rtfeldman$elm_css$Css$maxWidth(
			$rtfeldman$elm_css$Css$px(550))
		]),
	avatar: function (color) {
		return _List_fromArray(
			[
				$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$relative),
				$rtfeldman$elm_css$Css$width(
				$rtfeldman$elm_css$Css$pct(100)),
				$rtfeldman$elm_css$Css$height(
				$rtfeldman$elm_css$Css$pct(100)),
				$rtfeldman$elm_css$Css$backgroundColor(color),
				A3(
				$rtfeldman$elm_css$Css$border3,
				$rtfeldman$elm_css$Css$px(2),
				$rtfeldman$elm_css$Css$solid,
				$author$project$Material$Styled$Color$white),
				$rtfeldman$elm_css$Css$borderRadius(
				$rtfeldman$elm_css$Css$pct(50))
			]);
	},
	avatarContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(35)),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(35)),
			A2(
			$rtfeldman$elm_css$Css$padding2,
			$rtfeldman$elm_css$Css$px(10),
			$rtfeldman$elm_css$Css$px(5))
		]),
	avatarRow: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$row),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$padding(
			$rtfeldman$elm_css$Css$px(10)),
			A3(
			$rtfeldman$elm_css$Css$borderBottom3,
			$rtfeldman$elm_css$Css$px(0.5),
			$rtfeldman$elm_css$Css$solid,
			$rtfeldman$elm_css$Css$hex('#B3B3B3')),
			$rtfeldman$elm_css$Css$backgroundColor(
			$rtfeldman$elm_css$Css$hex('#F4F6F8'))
		]),
	avatarText: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$absolute),
			$rtfeldman$elm_css$Css$left(
			$rtfeldman$elm_css$Css$px(9)),
			$rtfeldman$elm_css$Css$top(
			$rtfeldman$elm_css$Css$px(10)),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$white),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(14))
		]),
	backToDashboardBtn: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$maxWidth(
			$rtfeldman$elm_css$Css$px(200))
		]),
	boldText: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontWeight(
			$rtfeldman$elm_css$Css$int(800))
		]),
	bottomContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column)
		]),
	buttonContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$vw(70)),
			$rtfeldman$elm_css$Css$maxWidth(
			$rtfeldman$elm_css$Css$px(500)),
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$row),
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
			A4(
			$rtfeldman$elm_css$Css$padding4,
			$rtfeldman$elm_css$Css$px(8),
			$rtfeldman$elm_css$Css$px(0),
			$rtfeldman$elm_css$Css$px(0),
			$rtfeldman$elm_css$Css$px(0))
		]),
	buttonMargin: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(20))
		]),
	cardContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			$rtfeldman$elm_css$Css$flexWrap($rtfeldman$elm_css$Css$wrap),
			$rtfeldman$elm_css$Css$marginBottom(
			$rtfeldman$elm_css$Css$px(10)),
			$rtfeldman$elm_css$Css$marginRight(
			$rtfeldman$elm_css$Css$px(10))
		]),
	fullLengthButton: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100))
		]),
	icon: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$boxShadow($rtfeldman$elm_css$Css$none),
			$rtfeldman$elm_css$Css$transform(
			A2(
				$rtfeldman$elm_css$Css$translate2,
				$rtfeldman$elm_css$Css$px(20),
				$rtfeldman$elm_css$Css$px(-15))),
			$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer),
			$rtfeldman$elm_css$Css$padding(
			$rtfeldman$elm_css$Css$px(10))
		]),
	inputContainer: _List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Css$margin2,
			$rtfeldman$elm_css$Css$px(20),
			$rtfeldman$elm_css$Css$zero)
		]),
	marginTop5: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(5))
		]),
	modalBody: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(12)),
			$rtfeldman$elm_css$Css$fontWeight(
			$rtfeldman$elm_css$Css$int(400)),
			$rtfeldman$elm_css$Css$marginBottom(
			$rtfeldman$elm_css$Css$px(10)),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$blueGrey500)
		]),
	modalBtns: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$rowReverse),
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceBetween),
			$rtfeldman$elm_css$Css$padding(
			$rtfeldman$elm_css$Css$px(5))
		]),
	modalContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$vw(70)),
			$rtfeldman$elm_css$Css$maxWidth(
			$rtfeldman$elm_css$Css$px(500))
		]),
	modalHeader: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$row),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$flexStart),
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceBetween),
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(5))
		]),
	modalHeaderTxt: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(20)),
			$rtfeldman$elm_css$Css$fontWeight(
			$rtfeldman$elm_css$Css$int(500))
		]),
	onHover: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$hover(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer),
					A2($rtfeldman$elm_css$Css$property, 'box-shadow', '0px 2px 4px -1px rgba(0,0,0,0.2), 0px 4px 5px 0px rgba(0,0,0,0.14), 0px 1px 10px 0px rgba(0,0,0,0.12)'),
					$rtfeldman$elm_css$Css$backgroundColor($author$project$Material$Styled$Color$grey200)
				]))
		]),
	optInText: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(14)),
			$rtfeldman$elm_css$Css$paddingBottom(
			$rtfeldman$elm_css$Css$px(10))
		]),
	passwordButtons: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(180)),
			$rtfeldman$elm_css$Css$margin(
			$rtfeldman$elm_css$Css$px(2))
		]),
	progressBar: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(10))
		]),
	signingOrder: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$paddingBottom(
			$rtfeldman$elm_css$Css$px(10))
		]),
	signingOrderText: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$minWidth(
			$rtfeldman$elm_css$Css$px(75))
		]),
	smallTxt: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(12)),
			$rtfeldman$elm_css$Css$fontWeight(
			$rtfeldman$elm_css$Css$int(400)),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$blueGrey500),
			$rtfeldman$elm_css$Css$padding(
			$rtfeldman$elm_css$Css$px(2))
		]),
	smallTxtWithoutColour: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(12)),
			$rtfeldman$elm_css$Css$fontWeight(
			$rtfeldman$elm_css$Css$int(400))
		]),
	textMargin: _List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Css$margin2,
			$rtfeldman$elm_css$Css$px(10),
			$rtfeldman$elm_css$Css$zero)
		]),
	uploadBtn: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$maxWidth(
			$rtfeldman$elm_css$Css$px(200))
		]),
	walletAddress: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$overflow($rtfeldman$elm_css$Css$hidden),
			$rtfeldman$elm_css$Css$textOverflow($rtfeldman$elm_css$Css$ellipsis),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(450)),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(14)),
			A4(
			$rtfeldman$elm_css$Css$padding4,
			$rtfeldman$elm_css$Css$px(10),
			$rtfeldman$elm_css$Css$px(0),
			$rtfeldman$elm_css$Css$px(10),
			$rtfeldman$elm_css$Css$px(0))
		]),
	walletButtonContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$vw(70)),
			$rtfeldman$elm_css$Css$maxWidth(
			$rtfeldman$elm_css$Css$px(500)),
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
			A4(
			$rtfeldman$elm_css$Css$padding4,
			$rtfeldman$elm_css$Css$px(8),
			$rtfeldman$elm_css$Css$px(0),
			$rtfeldman$elm_css$Css$px(0),
			$rtfeldman$elm_css$Css$px(0))
		]),
	walletContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$maxHeight(
			$rtfeldman$elm_css$Css$px(400)),
			$rtfeldman$elm_css$Css$overflow($rtfeldman$elm_css$Css$hidden)
		]),
	walletErrorText: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(14)),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$red500),
			$rtfeldman$elm_css$Css$displayFlex,
			A4(
			$rtfeldman$elm_css$Css$padding4,
			$rtfeldman$elm_css$Css$px(10),
			$rtfeldman$elm_css$Css$px(0),
			$rtfeldman$elm_css$Css$px(10),
			$rtfeldman$elm_css$Css$px(0))
		])
};
var $author$project$Page$UploadMultipleDocument$Modal$cancelNotarisationSuccessModal = function (model) {
	var uploadDocumentLanguageData = model.languageSwitchModel.allLanguageData.location.uploadDocument;
	return A2(
		$author$project$Material$Styled$Modal$modal,
		_List_fromArray(
			[
				$author$project$Material$Styled$Modal$open(true),
				$author$project$Material$Styled$Modal$contentContainerstyles($author$project$Page$UploadMultipleDocument$Modal$styles.modalContainer)
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadMultipleDocument$Modal$styles.modalHeader)
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadMultipleDocument$Modal$styles.modalHeaderTxt)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('Success')
							]))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadMultipleDocument$Modal$styles.modalBody)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('Notarisation cancelled for this document, you can still notarise this document under the completed document section.')
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadMultipleDocument$Modal$styles.buttonContainer)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Material$Styled$Button$button,
								_List_fromArray(
									[
										$author$project$Material$Styled$Button$theme($author$project$Material$Styled$Button$blue),
										$author$project$Material$Styled$Button$styles($author$project$Page$UploadMultipleDocument$Modal$styles.backToDashboardBtn),
										$author$project$Material$Styled$Button$onClick(
										$author$project$Types$OnAuth(
											$author$project$Types$OnMultipleDocUpload($author$project$Type$UploadMultipleDocument$OnDocSuccessClose)))
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(uploadDocumentLanguageData.backToDashboard)
									]))
							]))
					]))
			]));
};
var $author$project$Type$UploadMultipleDocument$OnCheckboxConfirmationClick = F2(
	function (a, b) {
		return {$: 'OnCheckboxConfirmationClick', a: a, b: b};
	});
var $author$project$Page$UploadMultipleDocument$Modal$displayCheckboxConfirmationModal = F2(
	function (user, annotation) {
		return A2(
			$author$project$Material$Styled$Modal$modal,
			_List_fromArray(
				[
					$author$project$Material$Styled$Modal$open(true),
					$author$project$Material$Styled$Modal$contentContainerstyles($author$project$Page$UploadMultipleDocument$Modal$styles.activitiesModal)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadMultipleDocument$Modal$styles.modalHeader)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadMultipleDocument$Modal$styles.modalHeaderTxt)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Attaching a Checkbox Field for Document Sender')
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadMultipleDocument$Modal$styles.textMargin)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css(
									_Utils_ap($author$project$Page$UploadMultipleDocument$Modal$styles.smallTxt, $author$project$Page$UploadMultipleDocument$Modal$styles.textMargin))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('This checkbox will be checked by default for you.')
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadMultipleDocument$Modal$styles.textMargin)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadMultipleDocument$Modal$styles.smallTxt)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('If you would like to check the checkbox later, please add a signature field for yourself. You will need to return to this document to check\u00A0the checkbox and sign the document later.\u00A0')
								])),
							A2(
							$author$project$Material$Styled$A$a,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$href('https://helpdesk.sign.net/checkbox-field#Checkbox-Sender'),
									$rtfeldman$elm_css$Html$Styled$Attributes$target('_blank')
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadMultipleDocument$Modal$styles.smallTxtWithoutColour)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('Find out more')
										]))
								]))
						])),
					A2(
					$author$project$Material$Styled$Button$button,
					_List_fromArray(
						[
							$author$project$Material$Styled$Button$theme($author$project$Material$Styled$Button$blue),
							$author$project$Material$Styled$Button$onClick(
							$author$project$Types$OnAuth(
								$author$project$Types$OnMultipleDocUpload(
									A2($author$project$Type$UploadMultipleDocument$OnCheckboxConfirmationClick, user, annotation))))
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('Continue')
						]))
				]));
	});
var $author$project$Type$UploadMultipleDocument$BackToDashboard = {$: 'BackToDashboard'};
var $author$project$Type$UploadMultipleDocument$CloseAlert = {$: 'CloseAlert'};
var $author$project$Page$UploadMultipleDocument$Modal$displayRotationAlertModal = A2(
	$author$project$Material$Styled$Modal$modal,
	_List_fromArray(
		[
			$author$project$Material$Styled$Modal$open(true),
			$author$project$Material$Styled$Modal$contentContainerstyles($author$project$Page$UploadMultipleDocument$Modal$styles.activitiesModal)
		]),
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadMultipleDocument$Modal$styles.modalHeader)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadMultipleDocument$Modal$styles.modalHeaderTxt)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('Rotation Detected')
						]))
				])),
			A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadMultipleDocument$Modal$styles.textMargin)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_Utils_ap($author$project$Page$UploadMultipleDocument$Modal$styles.smallTxt, $author$project$Page$UploadMultipleDocument$Modal$styles.textMargin))
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('We have detected a rotation in one or more pages in the PDF. This may affect the orientation and position of the annotations in the final document should you choose to continue.')
						]))
				])),
			A2(
			$author$project$Material$Styled$Button$button,
			_List_fromArray(
				[
					$author$project$Material$Styled$Button$theme($author$project$Material$Styled$Button$blue),
					$author$project$Material$Styled$Button$onClick(
					$author$project$Types$OnAuth(
						$author$project$Types$OnMultipleDocUpload($author$project$Type$UploadMultipleDocument$CloseAlert)))
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text('Continue')
				])),
			A2(
			$author$project$Material$Styled$Button$button,
			_List_fromArray(
				[
					$author$project$Material$Styled$Button$theme($author$project$Material$Styled$Button$blue),
					$author$project$Material$Styled$Button$onClick(
					$author$project$Types$OnAuth(
						$author$project$Types$OnMultipleDocUpload($author$project$Type$UploadMultipleDocument$BackToDashboard))),
					$author$project$Material$Styled$Button$styles($author$project$Page$UploadMultipleDocument$Modal$styles.buttonMargin)
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text('Home')
				]))
		]));
var $author$project$Type$UploadMultipleDocument$AnnotationTitle = {$: 'AnnotationTitle'};
var $author$project$Type$UploadMultipleDocument$OnRecipientTextAnnotClick = F2(
	function (a, b) {
		return {$: 'OnRecipientTextAnnotClick', a: a, b: b};
	});
var $author$project$Type$UploadMultipleDocument$OnRecipientTextCancelClick = {$: 'OnRecipientTextCancelClick'};
var $author$project$Page$UploadMultipleDocument$Modal$displayTextAnnotationNameModal = F3(
	function (user, annotation, _v0) {
		var textAnnotationTitle = _v0.textAnnotationTitle;
		var textAnnotationTitleError = _v0.textAnnotationTitleError;
		var _v1 = function () {
			switch (annotation.$) {
				case 'EditableText':
					return _Utils_Tuple2('Recipient Editable Text Field', 'Insert a text field for your recipients to fill in. You can give the field a name so that your users know what information to input.\u00A0');
				case 'NonEditableText':
					return _Utils_Tuple2('Non-Editable Text Field', 'Fill in this field on behalf of the recipient. The recipient will be required to click and acknowledge the text input.\u00A0');
				default:
					return _Utils_Tuple2('', '');
			}
		}();
		var title = _v1.a;
		var description = _v1.b;
		return A2(
			$author$project$Material$Styled$Modal$modal,
			_List_fromArray(
				[
					$author$project$Material$Styled$Modal$open(true),
					$author$project$Material$Styled$Modal$contentContainerstyles($author$project$Page$UploadMultipleDocument$Modal$styles.activitiesModal)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadMultipleDocument$Modal$styles.modalHeader)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadMultipleDocument$Modal$styles.modalHeaderTxt)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(title)
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadMultipleDocument$Modal$styles.smallTxt)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(description)
								]))
						])),
					A2(
					$author$project$Material$Styled$Input$text,
					_List_fromArray(
						[
							$author$project$Material$Styled$Input$containerStyles($author$project$Page$UploadMultipleDocument$Modal$styles.inputContainer),
							$author$project$Material$Styled$Input$label(''),
							$author$project$Material$Styled$Input$value(textAnnotationTitle),
							$author$project$Material$Styled$Input$errorMessage(textAnnotationTitleError),
							$author$project$Material$Styled$Input$onInput(
							A2(
								$elm$core$Basics$composeL,
								A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnMultipleDocUpload),
								$author$project$Type$UploadMultipleDocument$OnDocInput($author$project$Type$UploadMultipleDocument$AnnotationTitle))),
							$author$project$Material$Styled$Input$onBlur(
							$author$project$Types$OnAuth(
								$author$project$Types$OnMultipleDocUpload(
									$author$project$Type$UploadMultipleDocument$OnDocBlur($author$project$Type$UploadMultipleDocument$AnnotationTitle)))),
							$author$project$Material$Styled$Input$id('recipientAnnot')
						]),
					_List_Nil),
					A2(
					$author$project$Material$Styled$Button$button,
					_List_fromArray(
						[
							$author$project$Material$Styled$Button$theme($author$project$Material$Styled$Button$blue),
							$author$project$Material$Styled$Button$onClick(
							$author$project$Types$OnAuth(
								$author$project$Types$OnMultipleDocUpload(
									A2($author$project$Type$UploadMultipleDocument$OnRecipientTextAnnotClick, user, annotation))))
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('Confirm')
						])),
					A2(
					$author$project$Material$Styled$Button$button,
					_List_fromArray(
						[
							$author$project$Material$Styled$Button$theme($author$project$Material$Styled$Button$default),
							$author$project$Material$Styled$Button$onClick(
							$author$project$Types$OnAuth(
								$author$project$Types$OnMultipleDocUpload($author$project$Type$UploadMultipleDocument$OnRecipientTextCancelClick))),
							$author$project$Material$Styled$Button$styles($author$project$Page$UploadMultipleDocument$Modal$styles.buttonMargin)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('Cancel')
						]))
				]));
	});
var $author$project$Page$UploadMultipleDocument$Modal$displayUneditableModal = A2(
	$author$project$Material$Styled$Modal$modal,
	_List_fromArray(
		[
			$author$project$Material$Styled$Modal$open(true),
			$author$project$Material$Styled$Modal$contentContainerstyles($author$project$Page$UploadMultipleDocument$Modal$styles.activitiesModal)
		]),
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadMultipleDocument$Modal$styles.modalHeader)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadMultipleDocument$Modal$styles.modalHeaderTxt)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('Uneditable PDFs')
						]))
				])),
			A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadMultipleDocument$Modal$styles.textMargin)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_Utils_ap($author$project$Page$UploadMultipleDocument$Modal$styles.smallTxt, $author$project$Page$UploadMultipleDocument$Modal$styles.textMargin))
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('One of the PDF that you have uploaded is digitally sealed and therefore cannot be uploaded.')
						]))
				])),
			A2(
			$author$project$Material$Styled$Button$button,
			_List_fromArray(
				[
					$author$project$Material$Styled$Button$theme($author$project$Material$Styled$Button$blue),
					$author$project$Material$Styled$Button$onClick(
					$author$project$Types$OnAuth(
						$author$project$Types$OnMultipleDocUpload($author$project$Type$UploadMultipleDocument$BackToDashboard)))
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text('Home')
				]))
		]));
var $author$project$Type$UploadMultipleDocument$OnWalletConnectWalletSelect = function (a) {
	return {$: 'OnWalletConnectWalletSelect', a: a};
};
var $author$project$Page$UploadMultipleDocument$Modal$walletConnectCard = function (walletData) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Events$onClick(
				$author$project$Types$OnAuth(
					$author$project$Types$OnMultipleDocUpload(
						$author$project$Type$UploadMultipleDocument$OnWalletConnectWalletSelect(walletData))))
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Material$Styled$Card$card,
				_List_fromArray(
					[
						$author$project$Material$Styled$Card$containerStyles(
						_Utils_ap($author$project$Page$UploadMultipleDocument$Modal$styles.cardContainer, $author$project$Page$UploadMultipleDocument$Modal$styles.onHover))
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadMultipleDocument$Modal$styles.walletAddress)
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$span,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadMultipleDocument$Modal$styles.walletAddress)
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(walletData.address)
									]))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadMultipleDocument$Modal$styles.optInText)
							]),
						_List_fromArray(
							[
								walletData.needOptIn ? $rtfeldman$elm_css$Html$Styled$text('Requires Opt In') : $rtfeldman$elm_css$Html$Styled$text('Does not require Opt In')
							]))
					]))
			]));
};
var $author$project$Page$UploadMultipleDocument$Modal$displayWalletConnectAddressesModal = F2(
	function (walletDataList, loadedModel) {
		var requiresOptIn = A2(
			$elm$core$List$any,
			function (pdfData) {
				return pdfData.needOptIn;
			},
			walletDataList);
		return A2(
			$author$project$Material$Styled$Modal$modal,
			_List_fromArray(
				[
					$author$project$Material$Styled$Modal$open(true),
					$author$project$Material$Styled$Modal$contentContainerstyles($author$project$Page$UploadMultipleDocument$Modal$styles.activitiesModal)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadMultipleDocument$Modal$styles.modalHeader)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadMultipleDocument$Modal$styles.modalHeaderTxt)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Your wallet Addresses')
								]))
						])),
					requiresOptIn ? A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadMultipleDocument$Modal$styles.smallTxt)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('It seems like some of your wallet addresses are not opted in for our SIGN ASA on the Algorand network. This step is required in order for you to receive and use SIGN points on our application. Please note that the opt-in process will be a one time transaction that will cost 0.001 Algos')
								]))
						])) : $rtfeldman$elm_css$Html$Styled$text(''),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadMultipleDocument$Modal$styles.smallTxt)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Please click to select the wallet use for payment.')
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadMultipleDocument$Modal$styles.walletContainer)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_Nil,
							A2($elm$core$List$map, $author$project$Page$UploadMultipleDocument$Modal$walletConnectCard, walletDataList))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadMultipleDocument$Modal$styles.walletErrorText)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							A2($elm$core$Maybe$withDefault, '', loadedModel.walletError))
						]))
				]));
	});
var $author$project$Type$UploadMultipleDocument$AlgorandWalletConnectClick = {$: 'AlgorandWalletConnectClick'};
var $author$project$Type$UploadMultipleDocument$OnCancelNotarisationClick = {$: 'OnCancelNotarisationClick'};
var $author$project$Type$UploadMultipleDocument$OptInAssetClick = {$: 'OptInAssetClick'};
var $author$project$Type$UploadMultipleDocument$PaymentTransactionClick = {$: 'PaymentTransactionClick'};
var $author$project$Page$ViewDocument$Modal$optInStatusDisplayText = function (needOptIn) {
	return (!needOptIn) ? '[Current selected wallet has opt-in to SIGN ASA. Click pay.]' : '[Current selected wallet has not opt-in to SIGN ASA.]';
};
var $author$project$Type$UploadMultipleDocument$OnSelectWallet = function (a) {
	return {$: 'OnSelectWallet', a: a};
};
var $author$project$Page$UploadMultipleDocument$Modal$walletCard = function (walletAddress) {
	return A2(
		$author$project$Material$Styled$Card$card,
		_List_fromArray(
			[
				$author$project$Material$Styled$Card$containerStyles(
				_Utils_ap($author$project$Page$UploadMultipleDocument$Modal$styles.cardContainer, $author$project$Page$UploadMultipleDocument$Modal$styles.onHover))
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadMultipleDocument$Modal$styles.walletAddress),
						$rtfeldman$elm_css$Html$Styled$Events$onClick(
						$author$project$Types$OnAuth(
							$author$project$Types$OnMultipleDocUpload(
								$author$project$Type$UploadMultipleDocument$OnSelectWallet(walletAddress))))
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadMultipleDocument$Modal$styles.walletAddress)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(walletAddress)
							]))
					]))
			]));
};
var $author$project$Page$UploadMultipleDocument$Modal$displayWalletModal = F3(
	function (walletAddress, selectedAddress, loadedModel) {
		return A2(
			$author$project$Material$Styled$Modal$modal,
			_List_fromArray(
				[
					$author$project$Material$Styled$Modal$open(true),
					$author$project$Material$Styled$Modal$contentContainerstyles($author$project$Page$UploadMultipleDocument$Modal$styles.modalContainer)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadMultipleDocument$Modal$styles.modalHeader)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadMultipleDocument$Modal$styles.modalHeaderTxt)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Your wallet Addresses')
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$img,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadMultipleDocument$Modal$styles.icon),
									$rtfeldman$elm_css$Html$Styled$Attributes$src($author$project$View$Theme$images.close),
									$rtfeldman$elm_css$Html$Styled$Events$onClick(
									$author$project$Types$OnAuth(
										$author$project$Types$OnMultipleDocUpload($author$project$Type$UploadMultipleDocument$OnCancelNotarisationClick)))
								]),
							_List_Nil)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadMultipleDocument$Modal$styles.smallTxt)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Please click to select the wallet use for payment.')
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadMultipleDocument$Modal$styles.walletContainer)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_Nil,
							A2($elm$core$List$map, $author$project$Page$UploadMultipleDocument$Modal$walletCard, walletAddress))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadMultipleDocument$Modal$styles.walletAddress)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Selected Account: ' + selectedAddress)
								]))
						])),
					$elm$core$String$isEmpty(selectedAddress) ? A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadMultipleDocument$Modal$styles.walletErrorText)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							A2($elm$core$Maybe$withDefault, '', loadedModel.optInError))
						])) : (loadedModel.needOptIn ? A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadMultipleDocument$Modal$styles.bottomContainer)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadMultipleDocument$Modal$styles.smallTxt)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('A one time process to opt-in is needed before payment.')
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadMultipleDocument$Modal$styles.walletErrorText)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$Page$ViewDocument$Modal$optInStatusDisplayText(loadedModel.needOptIn))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadMultipleDocument$Modal$styles.walletErrorText)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									A2($elm$core$Maybe$withDefault, '', loadedModel.optInError))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadMultipleDocument$Modal$styles.buttonContainer)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Material$Styled$Button$button,
									_List_fromArray(
										[
											$author$project$Material$Styled$Button$theme($author$project$Material$Styled$Button$blue),
											$author$project$Material$Styled$Button$styles($author$project$Page$UploadMultipleDocument$Modal$styles.passwordButtons),
											$author$project$Material$Styled$Button$onClick(
											$author$project$Types$OnAuth(
												$author$project$Types$OnMultipleDocUpload($author$project$Type$UploadMultipleDocument$OptInAssetClick)))
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('Opt-in')
										])),
									A2(
									$author$project$Material$Styled$Button$button,
									_List_fromArray(
										[
											$author$project$Material$Styled$Button$theme($author$project$Material$Styled$Button$blue),
											$author$project$Material$Styled$Button$styles($author$project$Page$UploadMultipleDocument$Modal$styles.passwordButtons),
											$author$project$Material$Styled$Button$onClick(
											$author$project$Types$OnAuth(
												$author$project$Types$OnMultipleDocUpload($author$project$Type$UploadMultipleDocument$AlgorandWalletConnectClick)))
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('Change wallet')
										])),
									A2(
									$author$project$Material$Styled$Button$button,
									_List_fromArray(
										[
											$author$project$Material$Styled$Button$styles($author$project$Page$UploadMultipleDocument$Modal$styles.backToDashboardBtn),
											function () {
											var defaultTextTheme = $author$project$Material$Styled$Button$greyText;
											return $author$project$Material$Styled$Button$theme(
												_Utils_update(
													defaultTextTheme,
													{base: $author$project$Material$Styled$Color$grey200String}));
										}(),
											$author$project$Material$Styled$Button$onClick(
											$author$project$Types$OnAuth(
												$author$project$Types$OnMultipleDocUpload($author$project$Type$UploadMultipleDocument$OnCancelNotarisationClick)))
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('Cancel notarisation')
										]))
								]))
						])) : A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadMultipleDocument$Modal$styles.bottomContainer)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadMultipleDocument$Modal$styles.smallTxt)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$Page$ViewDocument$Modal$optInStatusDisplayText(loadedModel.needOptIn))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadMultipleDocument$Modal$styles.walletErrorText)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									A2($elm$core$Maybe$withDefault, '', loadedModel.optInError))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadMultipleDocument$Modal$styles.buttonContainer)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Material$Styled$Button$button,
									_List_fromArray(
										[
											$author$project$Material$Styled$Button$theme($author$project$Material$Styled$Button$blue),
											$author$project$Material$Styled$Button$styles($author$project$Page$UploadMultipleDocument$Modal$styles.passwordButtons),
											$author$project$Material$Styled$Button$onClick(
											$author$project$Types$OnAuth(
												$author$project$Types$OnMultipleDocUpload($author$project$Type$UploadMultipleDocument$PaymentTransactionClick)))
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('Proceed to Pay')
										])),
									A2(
									$author$project$Material$Styled$Button$button,
									_List_fromArray(
										[
											$author$project$Material$Styled$Button$theme($author$project$Material$Styled$Button$blue),
											$author$project$Material$Styled$Button$styles($author$project$Page$UploadMultipleDocument$Modal$styles.passwordButtons),
											$author$project$Material$Styled$Button$onClick(
											$author$project$Types$OnAuth(
												$author$project$Types$OnMultipleDocUpload($author$project$Type$UploadMultipleDocument$AlgorandWalletConnectClick)))
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('Change wallet')
										])),
									A2(
									$author$project$Material$Styled$Button$button,
									_List_fromArray(
										[
											$author$project$Material$Styled$Button$styles($author$project$Page$UploadMultipleDocument$Modal$styles.backToDashboardBtn),
											function () {
											var defaultTextTheme = $author$project$Material$Styled$Button$greyText;
											return $author$project$Material$Styled$Button$theme(
												_Utils_update(
													defaultTextTheme,
													{base: $author$project$Material$Styled$Color$grey200String}));
										}(),
											$author$project$Material$Styled$Button$onClick(
											$author$project$Types$OnAuth(
												$author$project$Types$OnMultipleDocUpload($author$project$Type$UploadMultipleDocument$OnCancelNotarisationClick)))
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('Cancel notarisation')
										]))
								]))
						])))
				]));
	});
var $author$project$Type$UploadMultipleDocument$OnDocConversionErrorRedirect = {$: 'OnDocConversionErrorRedirect'};
var $author$project$Page$UploadMultipleDocument$Modal$errorModal = A2(
	$author$project$Material$Styled$Modal$modal,
	_List_fromArray(
		[
			$author$project$Material$Styled$Modal$open(true),
			$author$project$Material$Styled$Modal$contentContainerstyles($author$project$Page$UploadMultipleDocument$Modal$styles.modalContainer)
		]),
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadMultipleDocument$Modal$styles.modalHeader)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadMultipleDocument$Modal$styles.modalHeaderTxt)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('Error!')
						]))
				])),
			A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadMultipleDocument$Modal$styles.modalBody)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('There is an error with the conversion. Please upload the file again. Click the button below to return to the homepage')
						])),
					A2(
					$author$project$Material$Styled$Button$button,
					_List_fromArray(
						[
							$author$project$Material$Styled$Button$styles($author$project$Page$UploadMultipleDocument$Modal$styles.buttonMargin),
							$author$project$Material$Styled$Button$onClick(
							$author$project$Types$OnAuth(
								$author$project$Types$OnMultipleDocUpload($author$project$Type$UploadMultipleDocument$OnDocConversionErrorRedirect)))
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('Redirect to Homepage')
						]))
				]))
		]));
var $author$project$Page$UploadMultipleDocument$Modal$loadingModal = function (status) {
	var statusTxt = function () {
		switch (status.$) {
			case 'Document':
				return 'Loading the document...';
			case 'GetWallet':
				return 'Getting wallet address, please wait...';
			case 'OptIn':
				return 'Opt-in to SIGN ASA in progress , please wait...';
			case 'Payment':
				return 'Payment transaction in progress, please wait...';
			case 'CancelNotarisation':
				return 'Cancelling notarisation for this document, please wait....';
			case 'CheckWalletOptIn':
				return 'Checking if selected wallet has opt-In to SIGN ASA...';
			case 'RegisterWallet':
				return 'Registering your wallet, please wait...';
			default:
				return 'Starting notarization process for your documents, please wait...';
		}
	}();
	return A2(
		$author$project$Material$Styled$Modal$modal,
		_List_fromArray(
			[
				$author$project$Material$Styled$Modal$open(true),
				$author$project$Material$Styled$Modal$contentContainerstyles($author$project$Page$UploadMultipleDocument$Modal$styles.modalContainer)
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadMultipleDocument$Modal$styles.modalHeader)
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadMultipleDocument$Modal$styles.modalHeaderTxt)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('Loading...')
							]))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadMultipleDocument$Modal$styles.modalBody)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(statusTxt)
							])),
						A2(
						$author$project$Material$Styled$ProgressBar$linear,
						_List_fromArray(
							[
								$author$project$Material$Styled$ProgressBar$containerStyle($author$project$Page$UploadMultipleDocument$Modal$styles.progressBar)
							]),
						_List_Nil)
					]))
			]));
};
var $author$project$Type$UploadMultipleDocument$OnPasswordInput = function (a) {
	return {$: 'OnPasswordInput', a: a};
};
var $author$project$Type$UploadMultipleDocument$OnPasswordSubmit = {$: 'OnPasswordSubmit'};
var $author$project$Page$UploadMultipleDocument$Modal$needPasswordModal = F2(
	function (password, passwordError) {
		return A2(
			$author$project$Material$Styled$Modal$modal,
			_List_fromArray(
				[
					$author$project$Material$Styled$Modal$open(true),
					$author$project$Material$Styled$Modal$contentContainerstyles($author$project$Page$UploadMultipleDocument$Modal$styles.modalContainer)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadMultipleDocument$Modal$styles.modalHeader)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadMultipleDocument$Modal$styles.modalHeaderTxt)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Password Required')
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadMultipleDocument$Modal$styles.modalBody)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('This PDF is password-protected. Please enter the password to be used in the session. It will not be saved on our systems so please keep a backup')
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$form,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Events$onSubmit(
							$author$project$Types$OnAuth(
								$author$project$Types$OnMultipleDocUpload($author$project$Type$UploadMultipleDocument$OnPasswordSubmit)))
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Material$Styled$Input$password,
							_List_fromArray(
								[
									$author$project$Material$Styled$Input$containerStyles($author$project$Page$UploadMultipleDocument$Modal$styles.inputContainer),
									$author$project$Material$Styled$Input$label('Password'),
									$author$project$Material$Styled$Input$value(
									A2($elm$core$Maybe$withDefault, '', password)),
									$author$project$Material$Styled$Input$errorMessage(passwordError),
									$author$project$Material$Styled$Input$onInput(
									A2(
										$elm$core$Basics$composeL,
										A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnMultipleDocUpload),
										$author$project$Type$UploadMultipleDocument$OnPasswordInput))
								]),
							_List_Nil),
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadMultipleDocument$Modal$styles.modalBtns)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Material$Styled$Button$button,
									_List_fromArray(
										[
											$author$project$Material$Styled$Button$theme($author$project$Material$Styled$Button$blue),
											$author$project$Material$Styled$Button$styles($author$project$Page$UploadMultipleDocument$Modal$styles.passwordButtons)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('Submit')
										])),
									A2(
									$author$project$Material$Styled$A$a,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$href($author$project$Data$Route$routeUrl.dashboard)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('Cancel')
										]))
								]))
						]))
				]));
	});
var $author$project$Type$UploadMultipleDocument$OnNotarizationRetry = {$: 'OnNotarizationRetry'};
var $author$project$Page$UploadMultipleDocument$Modal$notariseDocumentSuccess = F3(
	function (model, isCompleted, loadedModel) {
		var uploadDocumentLanguageData = model.languageSwitchModel.allLanguageData.location.uploadDocument;
		var failedTransactionList = A2(
			$elm$core$List$filterMap,
			function (pdfData) {
				var _v0 = pdfData.notarizationStatus;
				if (_v0.$ === 'Failed') {
					var error = _v0.a;
					return $elm$core$Maybe$Just(
						A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadMultipleDocument$Modal$styles.modalBody)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$Data$PDF$Create$title(pdfData.pdf) + (': ' + error))
								])));
				} else {
					return $elm$core$Maybe$Nothing;
				}
			},
			loadedModel.pdfList);
		return A2(
			$author$project$Material$Styled$Modal$modal,
			_List_fromArray(
				[
					$author$project$Material$Styled$Modal$open(true),
					$author$project$Material$Styled$Modal$onClose(
					$author$project$Types$OnAuth(
						$author$project$Types$OnMultipleDocUpload($author$project$Type$UploadMultipleDocument$OnDocSuccessClose))),
					$author$project$Material$Styled$Modal$contentContainerstyles($author$project$Page$UploadMultipleDocument$Modal$styles.modalContainer)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadMultipleDocument$Modal$styles.modalHeader)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadMultipleDocument$Modal$styles.modalHeaderTxt)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(uploadDocumentLanguageData.success)
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadMultipleDocument$Modal$styles.modalBody)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Document will be notarised on algorand network after it is completed by all parties.')
								]))
						])),
					$elm$core$List$isEmpty(failedTransactionList) ? $rtfeldman$elm_css$Html$Styled$text('') : A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_Nil,
					A2(
						$elm$core$List$cons,
						A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css(
									_Utils_ap($author$project$Page$UploadMultipleDocument$Modal$styles.modalBody, $author$project$Page$UploadMultipleDocument$Modal$styles.marginTop5))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('The following documents have failed their transaction would you like to retry?')
								])),
						_Utils_ap(
							failedTransactionList,
							_List_fromArray(
								[
									A2(
									$author$project$Material$Styled$Button$button,
									_List_fromArray(
										[
											$author$project$Material$Styled$Button$theme($author$project$Material$Styled$Button$blue),
											$author$project$Material$Styled$Button$styles($author$project$Page$UploadMultipleDocument$Modal$styles.fullLengthButton),
											$author$project$Material$Styled$Button$onClick(
											$author$project$Types$OnAuth(
												$author$project$Types$OnMultipleDocUpload($author$project$Type$UploadMultipleDocument$OnNotarizationRetry)))
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('Retry')
										]))
								])))),
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadMultipleDocument$Modal$styles.modalBtns)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Material$Styled$Button$button,
							_List_fromArray(
								[
									$author$project$Material$Styled$Button$theme($author$project$Material$Styled$Button$default),
									$author$project$Material$Styled$Button$styles($author$project$Page$UploadMultipleDocument$Modal$styles.fullLengthButton),
									$author$project$Material$Styled$Button$onClick(
									$author$project$Types$OnAuth(
										$author$project$Types$OnMultipleDocUpload($author$project$Type$UploadMultipleDocument$OnDocSuccessClose)))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(uploadDocumentLanguageData.backToDashboard)
								]))
						]))
				]));
	});
var $author$project$Type$UploadMultipleDocument$OnNotarizationCancelClick = {$: 'OnNotarizationCancelClick'};
var $author$project$Page$UploadMultipleDocument$Modal$notarizingDocumentModal = F2(
	function (docTitle, loadedModel) {
		return A2(
			$author$project$Material$Styled$Modal$modal,
			_List_fromArray(
				[
					$author$project$Material$Styled$Modal$open(true),
					$author$project$Material$Styled$Modal$contentContainerstyles($author$project$Page$UploadMultipleDocument$Modal$styles.modalContainer)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadMultipleDocument$Modal$styles.modalHeader)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadMultipleDocument$Modal$styles.modalHeaderTxt)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Notarizing Document: ' + docTitle)
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Material$Styled$ProgressBar$linear,
							_List_fromArray(
								[
									$author$project$Material$Styled$ProgressBar$containerStyle(
									_List_fromArray(
										[
											$rtfeldman$elm_css$Css$marginTop(
											$rtfeldman$elm_css$Css$px(10))
										]))
								]),
							_List_Nil),
							loadedModel.cancelNotarization ? A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadMultipleDocument$Modal$styles.modalBody)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('You have chosen to cancel notarization. Please note that we are unable to cancel the current and any completed transactions')
								])) : A2(
							$author$project$Material$Styled$Button$button,
							_List_fromArray(
								[
									$author$project$Material$Styled$Button$styles($author$project$Page$UploadMultipleDocument$Modal$styles.buttonMargin),
									$author$project$Material$Styled$Button$onClick(
									$author$project$Types$OnAuth(
										$author$project$Types$OnMultipleDocUpload($author$project$Type$UploadMultipleDocument$OnNotarizationCancelClick)))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Cancel')
								]))
						]))
				]));
	});
var $author$project$Page$UploadMultipleDocument$Modal$paymentModal = F2(
	function (selectedAddress, loadedModel) {
		return A2(
			$author$project$Material$Styled$Modal$modal,
			_List_fromArray(
				[
					$author$project$Material$Styled$Modal$open(true),
					$author$project$Material$Styled$Modal$contentContainerstyles($author$project$Page$UploadMultipleDocument$Modal$styles.modalContainer)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadMultipleDocument$Modal$styles.modalHeader)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadMultipleDocument$Modal$styles.modalHeaderTxt)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('ASA transfer transaction')
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadMultipleDocument$Modal$styles.walletAddress)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Selected wallet address: ' + selectedAddress)
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadMultipleDocument$Modal$styles.buttonContainer)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Material$Styled$Button$button,
							_List_fromArray(
								[
									$author$project$Material$Styled$Button$theme($author$project$Material$Styled$Button$blue),
									$author$project$Material$Styled$Button$styles($author$project$Page$UploadMultipleDocument$Modal$styles.passwordButtons),
									$author$project$Material$Styled$Button$onClick(
									$author$project$Types$OnAuth(
										$author$project$Types$OnMultipleDocUpload($author$project$Type$UploadMultipleDocument$PaymentTransactionClick)))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Proceed to Pay')
								])),
							A2(
							$author$project$Material$Styled$Button$button,
							_List_fromArray(
								[
									$author$project$Material$Styled$Button$styles($author$project$Page$UploadMultipleDocument$Modal$styles.backToDashboardBtn),
									function () {
									var defaultTextTheme = $author$project$Material$Styled$Button$greyText;
									return $author$project$Material$Styled$Button$theme(
										_Utils_update(
											defaultTextTheme,
											{base: $author$project$Material$Styled$Color$grey200String}));
								}(),
									$author$project$Material$Styled$Button$onClick(
									$author$project$Types$OnAuth(
										$author$project$Types$OnMultipleDocUpload($author$project$Type$UploadMultipleDocument$OnCancelNotarisationClick)))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Cancel notarisation')
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadMultipleDocument$Modal$styles.walletErrorText)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							A2($elm$core$Maybe$withDefault, '', loadedModel.optInError))
						]))
				]));
	});
var $author$project$Type$UploadMultipleDocument$OnDocSubmitClose = {$: 'OnDocSubmitClose'};
var $author$project$Type$UploadMultipleDocument$OnDocSubmitUpload = {$: 'OnDocSubmitUpload'};
var $author$project$Page$UploadMultipleDocument$Modal$avatar = F2(
	function (firstName, color) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadMultipleDocument$Modal$styles.avatarContainer)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							$author$project$Page$UploadMultipleDocument$Modal$styles.avatar(
								$author$project$Data$PDF$User$materialColorCode(color)))
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadMultipleDocument$Modal$styles.avatarText)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$elm$core$String$toUpper(
										A2($elm$core$String$left, 2, firstName)))
								]))
						]))
				]));
	});
var $author$project$Page$UploadMultipleDocument$Modal$createDiagram = function (signers) {
	var _v0 = $elm$core$List$head(signers);
	if (_v0.$ === 'Nothing') {
		return _List_Nil;
	} else {
		var signerEntry = _v0.a;
		var currentSigningOrder = signerEntry.signOrder;
		var _v1 = A2(
			$elm$core$List$partition,
			function (signer) {
				return _Utils_eq(signer.signOrder, currentSigningOrder);
			},
			signers);
		var current = _v1.a;
		var rest = _v1.b;
		var currentHtml = A2(
			$elm$core$List$map,
			function (signer) {
				var signerInfo = $author$project$Data$PDF$User$userInfo(signer.user);
				return A2($author$project$Page$UploadMultipleDocument$Modal$avatar, signerInfo.firstName, signerInfo.color);
			},
			current);
		return A2(
			$elm$core$List$cons,
			A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadMultipleDocument$Modal$styles.avatarRow)
					]),
				A2(
					$elm$core$List$cons,
					A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadMultipleDocument$Modal$styles.signingOrderText)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$elm$core$String$fromInt(currentSigningOrder))
							])),
					currentHtml)),
			$author$project$Page$UploadMultipleDocument$Modal$createDiagram(rest));
	}
};
var $author$project$Page$UploadMultipleDocument$Modal$renderSigningOrder = F3(
	function (pdf, signingOrderEnabled, loadedModel) {
		if (signingOrderEnabled) {
			var sortedSigners = A2(
				$elm$core$List$sortBy,
				function ($) {
					return $.signOrder;
				},
				loadedModel.signOrderData);
			var ownerInfo = $author$project$Data$PDF$User$userInfo(
				$author$project$Data$PDF$owner(pdf));
			return A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_Nil,
				A2(
					$elm$core$List$cons,
					A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadMultipleDocument$Modal$styles.signingOrder)
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('Signing order')
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadMultipleDocument$Modal$styles.avatarRow)
									]),
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$span,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadMultipleDocument$Modal$styles.signingOrderText)
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('Sender')
											])),
										A2($author$project$Page$UploadMultipleDocument$Modal$avatar, ownerInfo.firstName, ownerInfo.color)
									]))
							])),
					_Utils_ap(
						$author$project$Page$UploadMultipleDocument$Modal$createDiagram(sortedSigners),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadMultipleDocument$Modal$styles.avatarRow)
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('Completed')
									]))
							]))));
		} else {
			return $rtfeldman$elm_css$Html$Styled$text('');
		}
	});
var $author$project$Page$UploadMultipleDocument$Modal$submitModal = F4(
	function (model, loadedModel, signingType, user) {
		var uploadDocumentLanguageData = model.languageSwitchModel.allLanguageData.location.uploadDocument;
		return A2(
			$author$project$Material$Styled$Modal$modal,
			_List_fromArray(
				[
					$author$project$Material$Styled$Modal$open(true),
					$author$project$Material$Styled$Modal$onClose(
					$author$project$Types$OnAuth(
						$author$project$Types$OnMultipleDocUpload($author$project$Type$UploadMultipleDocument$OnDocSubmitClose))),
					$author$project$Material$Styled$Modal$contentContainerstyles($author$project$Page$UploadMultipleDocument$Modal$styles.modalContainer)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadMultipleDocument$Modal$styles.modalHeader)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadMultipleDocument$Modal$styles.modalHeaderTxt)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(uploadDocumentLanguageData.sendDocument)
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$img,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadMultipleDocument$Modal$styles.icon),
									$rtfeldman$elm_css$Html$Styled$Attributes$src($author$project$View$Theme$images.close),
									$rtfeldman$elm_css$Html$Styled$Events$onClick(
									$author$project$Types$OnAuth(
										$author$project$Types$OnMultipleDocUpload($author$project$Type$UploadMultipleDocument$OnDocSubmitClose)))
								]),
							_List_Nil)
						])),
					function () {
					var _v0 = $elm$core$List$head(loadedModel.convertedPDFList);
					if (_v0.$ === 'Just') {
						var pdfData = _v0.a;
						return A3(
							$author$project$Page$UploadMultipleDocument$Modal$renderSigningOrder,
							pdfData,
							_Utils_eq(signingType, $author$project$Type$UploadMultipleDocument$SigningOrder),
							loadedModel);
					} else {
						return $rtfeldman$elm_css$Html$Styled$text('');
					}
				}(),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadMultipleDocument$Modal$styles.modalBody)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('* Recipients will '),
									A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadMultipleDocument$Modal$styles.boldText)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('not')
										])),
									$rtfeldman$elm_css$Html$Styled$text(' be able to change the text inputs upon receiving the document. For more information, refer to the '),
									A2(
									$author$project$Material$Styled$A$a,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$href('https://www.sign.net/faq/'),
											$rtfeldman$elm_css$Html$Styled$Attributes$target('_blank')
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('frequently asked questions')
										]))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadMultipleDocument$Modal$styles.modalBody)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('* ' + 'Do note that our Service should only be used for certain categories of documents. For more information, '),
									A2(
									$author$project$Material$Styled$A$a,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$href('https://www.sign.net/legal'),
											$rtfeldman$elm_css$Html$Styled$Attributes$target('_blank')
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('refer to the terms of use')
										]))
								])),
							(user.showAds && ($elm$core$List$length(
							$author$project$Data$Domain$all(user.domains)) === 1)) ? A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css(
									_List_fromArray(
										[
											$rtfeldman$elm_css$Css$padding(
											$rtfeldman$elm_css$Css$px(10))
										]))
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$id('sendDocAdsContent')
										]),
									_List_Nil)
								])) : $rtfeldman$elm_css$Html$Styled$text(''),
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadMultipleDocument$Modal$styles.modalBtns)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Material$Styled$Button$button,
									_List_fromArray(
										[
											$author$project$Material$Styled$Button$theme($author$project$Material$Styled$Button$blue),
											$author$project$Material$Styled$Button$styles($author$project$Page$UploadMultipleDocument$Modal$styles.uploadBtn),
											$author$project$Material$Styled$Button$onClick(
											$author$project$Types$OnAuth(
												$author$project$Types$OnMultipleDocUpload($author$project$Type$UploadMultipleDocument$OnDocSubmitUpload)))
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(uploadDocumentLanguageData.confirm)
										]))
								]))
						]))
				]));
	});
var $author$project$Page$UploadMultipleDocument$Modal$successModal = F6(
	function (model, requireNotarisation, paymentMethod, walletError, user, walletAdded) {
		var userAlgorandWalletAddress = A2($elm$core$Maybe$withDefault, '', user.algorandWalletAddress);
		var uploadDocumentLanguageData = model.languageSwitchModel.allLanguageData.location.uploadDocument;
		var walletText = walletAdded ? 'You have successfully registered your new wallet.' : uploadDocumentLanguageData.successText;
		var displayRegisteredWalletTxt = _Utils_eq(user.algorandWalletAddress, $elm$core$Maybe$Nothing) ? 'You have chosen to pay with your own Algorand Wallet. Connect your wallet.' : ('You have chosen to notarise the document through your Algorand Wallet registered to this account: ' + (userAlgorandWalletAddress + ' and we will deduct 5 SIGN points for this transaction upon approval.'));
		var connectWalletTxt = _Utils_eq(user.algorandWalletAddress, $elm$core$Maybe$Nothing) ? 'Connect Wallet' : 'Change wallet';
		return A2(
			$author$project$Material$Styled$Modal$modal,
			_List_fromArray(
				[
					$author$project$Material$Styled$Modal$open(true),
					$author$project$Material$Styled$Modal$onClose(
					$author$project$Types$OnAuth(
						$author$project$Types$OnMultipleDocUpload($author$project$Type$UploadMultipleDocument$OnDocSuccessClose))),
					$author$project$Material$Styled$Modal$contentContainerstyles($author$project$Page$UploadMultipleDocument$Modal$styles.modalContainer)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadMultipleDocument$Modal$styles.modalHeader)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadMultipleDocument$Modal$styles.modalHeaderTxt)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(uploadDocumentLanguageData.success)
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadMultipleDocument$Modal$styles.modalBody)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(walletText)
								]))
						])),
					(requireNotarisation && (!_Utils_eq(
					$author$project$Model$Settings$convertStringToPayment(paymentMethod),
					$author$project$Type$Setting$SystemBalance))) ? A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadMultipleDocument$Modal$styles.modalBody)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(displayRegisteredWalletTxt)
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadMultipleDocument$Modal$styles.walletButtonContainer)
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadMultipleDocument$Modal$styles.modalBtns)
										]),
									_List_fromArray(
										[
											A2(
											$author$project$Material$Styled$Button$button,
											_List_fromArray(
												[
													$author$project$Material$Styled$Button$theme($author$project$Material$Styled$Button$default),
													$author$project$Material$Styled$Button$styles($author$project$Page$UploadMultipleDocument$Modal$styles.fullLengthButton),
													$author$project$Material$Styled$Button$onClick(
													$author$project$Types$OnAuth(
														$author$project$Types$OnMultipleDocUpload($author$project$Type$UploadMultipleDocument$AlgorandWalletConnectClick)))
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(connectWalletTxt)
												]))
										])),
									_Utils_eq(user.algorandWalletAddress, $elm$core$Maybe$Nothing) ? $rtfeldman$elm_css$Html$Styled$text('') : A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadMultipleDocument$Modal$styles.modalBtns)
										]),
									_List_fromArray(
										[
											A2(
											$author$project$Material$Styled$Button$button,
											_List_fromArray(
												[
													$author$project$Material$Styled$Button$theme($author$project$Material$Styled$Button$blue),
													$author$project$Material$Styled$Button$styles($author$project$Page$UploadMultipleDocument$Modal$styles.fullLengthButton),
													$author$project$Material$Styled$Button$onClick(
													$author$project$Types$OnAuth(
														$author$project$Types$OnMultipleDocUpload(
															$author$project$Type$UploadMultipleDocument$OnNotarizationStartClick(true))))
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(uploadDocumentLanguageData.proceed)
												]))
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadMultipleDocument$Modal$styles.modalBtns)
										]),
									_List_fromArray(
										[
											A2(
											$author$project$Material$Styled$Button$button,
											_List_fromArray(
												[
													$author$project$Material$Styled$Button$styles($author$project$Page$UploadMultipleDocument$Modal$styles.fullLengthButton),
													$author$project$Material$Styled$Button$theme($author$project$Material$Styled$Button$default),
													$author$project$Material$Styled$Button$onClick(
													$author$project$Types$OnAuth(
														$author$project$Types$OnMultipleDocUpload($author$project$Type$UploadMultipleDocument$OnCancelNotarisationClick)))
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text('Cancel notarisation')
												]))
										]))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css(
									_Utils_ap($author$project$Page$UploadMultipleDocument$Modal$styles.modalBody, $author$project$Page$UploadMultipleDocument$Modal$styles.marginTop5))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Please get ready your Algorand Wallet (with WalletConnect) to approve this transaction via QR code on the next page.')
								]))
						])) : A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_Nil,
					_List_fromArray(
						[
							(user.showAds && ($elm$core$List$length(
							$author$project$Data$Domain$all(user.domains)) === 1)) ? A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css(
									_List_fromArray(
										[
											$rtfeldman$elm_css$Css$padding(
											$rtfeldman$elm_css$Css$px(10))
										]))
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$id('sendDocAdsContent')
										]),
									_List_Nil)
								])) : $rtfeldman$elm_css$Html$Styled$text(''),
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadMultipleDocument$Modal$styles.modalBtns)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Material$Styled$Button$button,
									_List_fromArray(
										[
											$author$project$Material$Styled$Button$theme($author$project$Material$Styled$Button$blue),
											$author$project$Material$Styled$Button$styles($author$project$Page$UploadMultipleDocument$Modal$styles.backToDashboardBtn),
											$author$project$Material$Styled$Button$onClick(
											$author$project$Types$OnAuth(
												$author$project$Types$OnMultipleDocUpload($author$project$Type$UploadMultipleDocument$OnDocSuccessClose)))
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(uploadDocumentLanguageData.backToDashboard)
										]))
								]))
						]))
				]));
	});
var $author$project$Page$UploadMultipleDocument$Modal$uploadingModal = function (model) {
	var uploadDocumentLanguageData = model.languageSwitchModel.allLanguageData.location.uploadDocument;
	return A2(
		$author$project$Material$Styled$Modal$modal,
		_List_fromArray(
			[
				$author$project$Material$Styled$Modal$open(true),
				$author$project$Material$Styled$Modal$contentContainerstyles($author$project$Page$UploadMultipleDocument$Modal$styles.modalContainer)
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadMultipleDocument$Modal$styles.modalHeader)
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadMultipleDocument$Modal$styles.modalHeaderTxt)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(uploadDocumentLanguageData.sendingYourDocs)
							]))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadMultipleDocument$Modal$styles.modalBody)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(uploadDocumentLanguageData.sendingYourDocs + '...')
							])),
						A2(
						$author$project$Material$Styled$ProgressBar$linear,
						_List_fromArray(
							[
								$author$project$Material$Styled$ProgressBar$containerStyle($author$project$Page$UploadMultipleDocument$Modal$styles.progressBar)
							]),
						_List_Nil)
					]))
			]));
};
var $author$project$Page$UploadMultipleDocument$Modal$view = F4(
	function (model, authModel, loadedModel, user) {
		var _v0 = loadedModel.status;
		switch (_v0.$) {
			case 'NeedPassword':
				return A2($author$project$Page$UploadMultipleDocument$Modal$needPasswordModal, loadedModel.password, loadedModel.passwordError);
			case 'Ready':
				return A4($author$project$Page$UploadMultipleDocument$Modal$submitModal, model, loadedModel, loadedModel.signingType, user);
			case 'Uploading':
				return $author$project$Page$UploadMultipleDocument$Modal$uploadingModal(model);
			case 'Success':
				var requireNotarisation = _v0.a;
				var paymentMethod = _v0.b;
				var walletError = _v0.c;
				var walletAdded = _v0.d;
				return A6($author$project$Page$UploadMultipleDocument$Modal$successModal, model, requireNotarisation, paymentMethod, walletError, user, walletAdded);
			case 'Loading':
				var status = _v0.a;
				return $author$project$Page$UploadMultipleDocument$Modal$loadingModal(status);
			case 'ConversionError':
				return $author$project$Page$UploadMultipleDocument$Modal$errorModal;
			case 'CancelNotarisationSuccess':
				return $author$project$Page$UploadMultipleDocument$Modal$cancelNotarisationSuccessModal(model);
			case 'DisplayWallet':
				var wallet = _v0.a;
				return A3(
					$author$project$Page$UploadMultipleDocument$Modal$displayWalletModal,
					wallet,
					A2($elm$core$Maybe$withDefault, '', loadedModel.selectedWallet),
					loadedModel);
			case 'MakePayment':
				return A2(
					$author$project$Page$UploadMultipleDocument$Modal$paymentModal,
					A2($elm$core$Maybe$withDefault, '', loadedModel.selectedWallet),
					loadedModel);
			case 'NotariseSuccess':
				var isCompleted = _v0.a;
				return A3($author$project$Page$UploadMultipleDocument$Modal$notariseDocumentSuccess, model, isCompleted, loadedModel);
			case 'NotarizingDocument':
				var docTitle = _v0.a;
				return A2($author$project$Page$UploadMultipleDocument$Modal$notarizingDocumentModal, docTitle, loadedModel);
			case 'DisplayWalletAddress':
				var addresses = _v0.a;
				return A2($author$project$Page$UploadMultipleDocument$Modal$displayWalletConnectAddressesModal, addresses, loadedModel);
			case 'ConfirmTextAnnotTitle':
				var recipient = _v0.a;
				var annotation = _v0.b;
				return A3($author$project$Page$UploadMultipleDocument$Modal$displayTextAnnotationNameModal, recipient, annotation, loadedModel);
			case 'ConfirmCheckboxNotification':
				var recipient = _v0.a;
				var annot = _v0.b;
				return A2($author$project$Page$UploadMultipleDocument$Modal$displayCheckboxConfirmationModal, recipient, annot);
			case 'UneditablePDF':
				return $author$project$Page$UploadMultipleDocument$Modal$displayUneditableModal;
			case 'RotationAlert':
				return $author$project$Page$UploadMultipleDocument$Modal$displayRotationAlertModal;
			default:
				return $rtfeldman$elm_css$Html$Styled$text('');
		}
	});
var $author$project$Type$UploadMultipleDocument$Email = {$: 'Email'};
var $author$project$Type$UploadMultipleDocument$FirstName = {$: 'FirstName'};
var $author$project$Type$UploadMultipleDocument$LastName = {$: 'LastName'};
var $author$project$Type$UploadMultipleDocument$OnAddRecipientBlur = function (a) {
	return {$: 'OnAddRecipientBlur', a: a};
};
var $author$project$Type$UploadMultipleDocument$OnAddRecipientInput = F2(
	function (a, b) {
		return {$: 'OnAddRecipientInput', a: a, b: b};
	});
var $author$project$Type$UploadMultipleDocument$OnAddRecipientSubmit = {$: 'OnAddRecipientSubmit'};
var $author$project$Type$UploadMultipleDocument$OnClearAddRecipientFields = {$: 'OnClearAddRecipientFields'};
var $author$project$Type$UploadMultipleDocument$Search = {$: 'Search'};
var $author$project$Page$UploadMultipleDocument$Recipient$addRecipientBtn = F2(
	function (model, languageSwitchModel) {
		var uploadDocumentLanguageData = languageSwitchModel.allLanguageData.location.uploadDocument;
		var _v0 = model.addRecipient;
		var emailError = _v0.emailError;
		var firstNameError = _v0.firstNameError;
		var lastNameError = _v0.lastNameError;
		var hasError = A2(
			$elm$core$List$any,
			$elm$core$Basics$neq($elm$core$Maybe$Nothing),
			_List_fromArray(
				[emailError, firstNameError, lastNameError]));
		return hasError ? $author$project$View$SubmitButton$disabled(uploadDocumentLanguageData.add) : $author$project$View$SubmitButton$enabled(uploadDocumentLanguageData.add);
	});
var $author$project$Type$UploadMultipleDocument$OnAutocompleteClick = function (a) {
	return {$: 'OnAutocompleteClick', a: a};
};
var $author$project$Page$UploadMultipleDocument$Recipient$styles = {
	addRcptBtn: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginRight(
			$rtfeldman$elm_css$Css$px(10)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(130))
		]),
	addRcptBtnContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(14)),
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$flexEnd)
		]),
	addRcptContainer: _List_fromArray(
		[
			A3($rtfeldman$elm_css$Css$margin3, $rtfeldman$elm_css$Css$zero, $rtfeldman$elm_css$Css$zero, $rtfeldman$elm_css$Css$zero)
		]),
	addRcptHeader: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceBetween),
			$rtfeldman$elm_css$Css$marginBottom(
			$rtfeldman$elm_css$Css$px(18)),
			$rtfeldman$elm_css$Css$fontWeight(
			$rtfeldman$elm_css$Css$int(500)),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(12.8))
		]),
	allIcon: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$default),
			A4(
			$rtfeldman$elm_css$Css$padding4,
			$rtfeldman$elm_css$Css$px(0),
			$rtfeldman$elm_css$Css$px(0),
			$rtfeldman$elm_css$Css$px(0),
			$rtfeldman$elm_css$Css$px(5))
		]),
	annotCardTitle: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$block),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(14)),
			$rtfeldman$elm_css$Css$marginBottom(
			$rtfeldman$elm_css$Css$px(14)),
			$rtfeldman$elm_css$Css$fontWeight(
			$rtfeldman$elm_css$Css$int(500)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100)),
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(5))
		]),
	annotCardTitleClosed: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$block),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(14)),
			$rtfeldman$elm_css$Css$fontWeight(
			$rtfeldman$elm_css$Css$int(500)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100)),
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(5))
		]),
	annotContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			A3(
			$rtfeldman$elm_css$Css$border3,
			$rtfeldman$elm_css$Css$px(1),
			$rtfeldman$elm_css$Css$solid,
			$author$project$Material$Styled$Color$grey300),
			$rtfeldman$elm_css$Css$padding(
			$rtfeldman$elm_css$Css$px(10)),
			$rtfeldman$elm_css$Css$borderRadius(
			$rtfeldman$elm_css$Css$px(10)),
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(20))
		]),
	avatar: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(30)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(30)),
			$rtfeldman$elm_css$Css$borderRadius(
			$rtfeldman$elm_css$Css$pct(50)),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$marginRight(
			$rtfeldman$elm_css$Css$px(2)),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$white),
			$rtfeldman$elm_css$Css$textTransform($rtfeldman$elm_css$Css$uppercase),
			$rtfeldman$elm_css$Css$textDecoration($rtfeldman$elm_css$Css$none),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(14))
		]),
	avatarContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$row),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$top(
			$rtfeldman$elm_css$Css$px(-20)),
			$rtfeldman$elm_css$Css$marginBottom(
			$rtfeldman$elm_css$Css$px(-20)),
			$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$relative)
		]),
	cancelRcptBtn: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(100))
		]),
	clearAnnotButton: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(20)),
			$rtfeldman$elm_css$Css$marginBottom(
			$rtfeldman$elm_css$Css$px(10))
		]),
	clearText: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(9.6)),
			$rtfeldman$elm_css$Css$textDecoration($rtfeldman$elm_css$Css$underline),
			$rtfeldman$elm_css$Css$hover(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer)
				]))
		]),
	icon: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$paddingRight(
			$rtfeldman$elm_css$Css$px(7))
		]),
	iconContainer: _List_fromArray(
		[$rtfeldman$elm_css$Css$displayFlex]),
	input: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginBottom(
			$rtfeldman$elm_css$Css$px(20)),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(12.8))
		]),
	marginBottom20: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginBottom(
			$rtfeldman$elm_css$Css$px(20))
		]),
	myInfoImage: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(30)),
			A4(
			$rtfeldman$elm_css$Css$padding4,
			$rtfeldman$elm_css$Css$px(0),
			$rtfeldman$elm_css$Css$px(0),
			$rtfeldman$elm_css$Css$px(0),
			$rtfeldman$elm_css$Css$px(5))
		]),
	myInfoImageBlurred: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(30)),
			A4(
			$rtfeldman$elm_css$Css$padding4,
			$rtfeldman$elm_css$Css$px(0),
			$rtfeldman$elm_css$Css$px(0),
			$rtfeldman$elm_css$Css$px(0),
			$rtfeldman$elm_css$Css$px(5)),
			$rtfeldman$elm_css$Css$opacity(
			$rtfeldman$elm_css$Css$num(0.4))
		]),
	recipientContent: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			A3(
			$rtfeldman$elm_css$Css$margin3,
			$rtfeldman$elm_css$Css$px(48),
			$rtfeldman$elm_css$Css$zero,
			$rtfeldman$elm_css$Css$zero),
			$rtfeldman$elm_css$Css$lastChild(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$marginBottom(
					$rtfeldman$elm_css$Css$px(20))
				]))
		]),
	recipientHeader: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceBetween),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100))
		]),
	recipientItemTitle: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			$rtfeldman$elm_css$Css$padding(
			$rtfeldman$elm_css$Css$px(5)),
			$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$relative),
			$rtfeldman$elm_css$Css$top(
			$rtfeldman$elm_css$Css$px(-24)),
			$rtfeldman$elm_css$Css$backgroundColor($author$project$Material$Styled$Color$white),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(9.6))
		]),
	recipientRmvIcon: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$hover(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$backgroundColor($author$project$Material$Styled$Color$grey100),
					$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer),
					$rtfeldman$elm_css$Css$outline($rtfeldman$elm_css$Css$none)
				])),
			$rtfeldman$elm_css$Css$focus(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$outline($rtfeldman$elm_css$Css$none),
					$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer)
				]))
		]),
	resultText: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(14))
		]),
	searchField: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$absolute),
			$rtfeldman$elm_css$Css$top(
			$rtfeldman$elm_css$Css$px(52)),
			$rtfeldman$elm_css$Css$backgroundColor($author$project$Material$Styled$Color$white),
			A2(
			$rtfeldman$elm_css$Css$border2,
			$rtfeldman$elm_css$Css$px(0.5),
			$rtfeldman$elm_css$Css$solid),
			$rtfeldman$elm_css$Css$zIndex(
			$rtfeldman$elm_css$Css$int($author$project$View$Theme$zIndex.uploadDocSearchField)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(99)),
			$rtfeldman$elm_css$Css$maxHeight(
			$rtfeldman$elm_css$Css$px(360)),
			$rtfeldman$elm_css$Css$overflowY($rtfeldman$elm_css$Css$auto)
		]),
	searchResult: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			$rtfeldman$elm_css$Css$marginLeft(
			$rtfeldman$elm_css$Css$px(20))
		]),
	searchResultContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$row),
			A2(
			$rtfeldman$elm_css$Css$padding2,
			$rtfeldman$elm_css$Css$px(18),
			$rtfeldman$elm_css$Css$px(14)),
			$rtfeldman$elm_css$Css$hover(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer),
					$rtfeldman$elm_css$Css$opacity(
					$rtfeldman$elm_css$Css$num(0.5)),
					$rtfeldman$elm_css$Css$backgroundColor($author$project$Material$Styled$Color$grey50),
					A2(
					$rtfeldman$elm_css$Css$border2,
					$rtfeldman$elm_css$Css$px(0.5),
					$rtfeldman$elm_css$Css$solid)
				])),
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceBetween)
		]),
	sectionContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			A3(
			$rtfeldman$elm_css$Css$border3,
			$rtfeldman$elm_css$Css$px(1),
			$rtfeldman$elm_css$Css$solid,
			$author$project$Material$Styled$Color$grey300),
			$rtfeldman$elm_css$Css$padding(
			$rtfeldman$elm_css$Css$px(10)),
			$rtfeldman$elm_css$Css$borderRadius(
			$rtfeldman$elm_css$Css$px(10)),
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(20))
		]),
	sectionContainerClosed: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$row),
			A3(
			$rtfeldman$elm_css$Css$border3,
			$rtfeldman$elm_css$Css$px(1),
			$rtfeldman$elm_css$Css$solid,
			$author$project$Material$Styled$Color$grey300),
			$rtfeldman$elm_css$Css$padding(
			$rtfeldman$elm_css$Css$px(10)),
			$rtfeldman$elm_css$Css$borderRadius(
			$rtfeldman$elm_css$Css$px(10)),
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(20)),
			$rtfeldman$elm_css$Css$hover(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$backgroundColor($author$project$Material$Styled$Color$grey100),
					$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer)
				]))
		]),
	selectRole: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$padding(
			$rtfeldman$elm_css$Css$px(10))
		]),
	selectRoleContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(100)),
			$rtfeldman$elm_css$Css$marginBottom(
			$rtfeldman$elm_css$Css$px(20))
		]),
	signerNameContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$row),
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceBetween),
			$rtfeldman$elm_css$Css$flexWrap($rtfeldman$elm_css$Css$wrap)
		]),
	titleContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$row),
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceBetween)
		]),
	trustScoreIcon: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(30)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(30))
		]),
	viewerText: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginLeft(
			$rtfeldman$elm_css$Css$px(5)),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(12.8)),
			$rtfeldman$elm_css$Css$flexGrow(
			$rtfeldman$elm_css$Css$num(1))
		])
};
var $author$project$Page$UploadMultipleDocument$Recipient$displayIcon = F2(
	function (verification, icon) {
		return verification ? A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					icon,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Svg$Styled$Attributes$css($author$project$Page$UploadMultipleDocument$Recipient$styles.allIcon)
						]),
					_List_Nil)
				])) : A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					icon,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Svg$Styled$Attributes$css($author$project$Page$UploadMultipleDocument$Recipient$styles.allIcon),
							$rtfeldman$elm_css$Svg$Styled$Attributes$fill('grey')
						]),
					_List_Nil)
				]));
	});
var $author$project$Page$UploadMultipleDocument$Recipient$displayImage = function (verification) {
	return verification ? A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$img,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$src($author$project$View$Theme$images.myInfoLogo),
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadMultipleDocument$Recipient$styles.myInfoImage)
					]),
				_List_Nil)
			])) : A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$img,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$src($author$project$View$Theme$images.myInfoLogo),
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadMultipleDocument$Recipient$styles.myInfoImageBlurred)
					]),
				_List_Nil)
			]));
};
var $author$project$Page$UploadMultipleDocument$Recipient$displaySearchResult = function (searchResult) {
	if (searchResult.$ === 'Just') {
		var results = searchResult.a;
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadMultipleDocument$Recipient$styles.searchField)
				]),
			A2(
				$elm$core$List$map,
				function (result) {
					return A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadMultipleDocument$Recipient$styles.searchResultContainer),
								$rtfeldman$elm_css$Html$Styled$Events$onClick(
								$author$project$Types$OnAuth(
									$author$project$Types$OnMultipleDocUpload(
										$author$project$Type$UploadMultipleDocument$OnAutocompleteClick(result))))
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadMultipleDocument$Recipient$styles.searchResult)
									]),
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$span,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadMultipleDocument$Recipient$styles.resultText)
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(
												A2($elm$core$Maybe$withDefault, result.firstName + (' ' + result.lastName), result.alias))
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$span,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadMultipleDocument$Recipient$styles.resultText)
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(
												A2($elm$core$Maybe$withDefault, '', result.label))
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$span,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadMultipleDocument$Recipient$styles.resultText)
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(result.email)
											]))
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadMultipleDocument$Recipient$styles.iconContainer)
									]),
								_List_fromArray(
									[
										A2($author$project$Page$UploadMultipleDocument$Recipient$displayIcon, result.verifyStripe, $author$project$Material$Styled$Icon$payment),
										A2($author$project$Page$UploadMultipleDocument$Recipient$displayIcon, result.verifyPassbase, $author$project$Material$Styled$Icon$verifiedUser),
										A2($author$project$Page$UploadMultipleDocument$Recipient$displayIcon, result.verifyMobilePhone, $author$project$Material$Styled$Icon$phoneLinkLock),
										A2($author$project$Page$UploadMultipleDocument$Recipient$displayIcon, result.verifyWallet, $author$project$Material$Styled$Icon$accountBalanceWallet),
										$author$project$Page$UploadMultipleDocument$Recipient$displayImage(result.verifyMyInfo)
									]))
							]));
				},
				results));
	} else {
		return $rtfeldman$elm_css$Html$Styled$text('');
	}
};
var $author$project$Page$UploadMultipleDocument$Recipient$ownerAnnot = F2(
	function (model, languageSwitchModel) {
		var uploadDocumentLanguageData = languageSwitchModel.allLanguageData.location.uploadDocument;
		var owner = $author$project$Data$PDF$Create$getOwner(model.pdf);
		var user = $author$project$Data$PDF$User$userInfo(owner.user);
		return _Utils_eq(owner.role, $author$project$Data$PDF$Create$Viewer) ? A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_Utils_ap(
						$author$project$Page$UploadMultipleDocument$Recipient$styles.recipientContent,
						_Utils_ap($author$project$Page$UploadMultipleDocument$Recipient$styles.annotContainer, $author$project$Page$UploadMultipleDocument$Recipient$styles.marginBottom20)))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadMultipleDocument$Recipient$styles.recipientHeader)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadMultipleDocument$Recipient$styles.recipientItemTitle),
									$rtfeldman$elm_css$Html$Styled$Attributes$css(
									_List_fromArray(
										[
											$rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$inline)
										]))
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$strong,
									_List_Nil,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											$author$project$Data$PDF$User$formatName(owner.user))
										])),
									$rtfeldman$elm_css$Html$Styled$text(' ' + user.email)
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadMultipleDocument$Recipient$styles.avatarContainer)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$a,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css(
									A2(
										$elm$core$List$append,
										$author$project$Page$UploadMultipleDocument$Recipient$styles.avatar,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Css$backgroundColor(
												$author$project$Data$PDF$User$materialColorCode(user.color))
											]))),
									$rtfeldman$elm_css$Html$Styled$Attributes$title(user.firstName)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									A2($elm$core$String$left, 2, user.firstName))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadMultipleDocument$Recipient$styles.viewerText)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(uploadDocumentLanguageData.viewer + (' (' + (uploadDocumentLanguageData.owner + ')')))
								]))
						]))
				])) : A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_Utils_ap(
						$author$project$Page$UploadMultipleDocument$Recipient$styles.recipientContent,
						_Utils_ap($author$project$Page$UploadMultipleDocument$Recipient$styles.annotContainer, $author$project$Page$UploadMultipleDocument$Recipient$styles.marginBottom20)))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadMultipleDocument$Recipient$styles.signerNameContainer)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadMultipleDocument$Recipient$styles.recipientHeader)
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadMultipleDocument$Recipient$styles.recipientItemTitle),
											$rtfeldman$elm_css$Html$Styled$Attributes$css(
											_List_fromArray(
												[
													$rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$inline)
												]))
										]),
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$strong,
											_List_Nil,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(
													$author$project$Data$PDF$User$formatName(owner.user))
												])),
											$rtfeldman$elm_css$Html$Styled$text(' ' + user.email)
										]))
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadMultipleDocument$Recipient$styles.avatarContainer)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css(
									A2(
										$elm$core$List$append,
										$author$project$Page$UploadMultipleDocument$Recipient$styles.avatar,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Css$backgroundColor(
												$author$project$Data$PDF$User$materialColorCode(user.color))
											]))),
									$rtfeldman$elm_css$Html$Styled$Attributes$title(user.firstName)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									A2($elm$core$String$left, 2, user.firstName))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadMultipleDocument$Recipient$styles.viewerText)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(uploadDocumentLanguageData.signer + (' (' + (uploadDocumentLanguageData.owner + ')')))
								]))
						]))
				]));
	});
var $author$project$Page$UploadMultipleDocument$Recipient$recepientAnnots = F2(
	function (model, languageSwitchModel) {
		var uploadDocumentLanguageData = languageSwitchModel.allLanguageData.location.uploadDocument;
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_Nil,
			A2(
				$elm$core$List$map,
				function (value) {
					var userId = $author$project$Data$PDF$User$emailFromUser(value.user);
					var user = $author$project$Data$PDF$User$userInfo(value.user);
					return _Utils_eq(value.role, $author$project$Data$PDF$Create$Viewer) ? A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css(
								_Utils_ap($author$project$Page$UploadMultipleDocument$Recipient$styles.recipientContent, $author$project$Page$UploadMultipleDocument$Recipient$styles.annotContainer))
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadMultipleDocument$Recipient$styles.recipientHeader)
									]),
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$div,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadMultipleDocument$Recipient$styles.recipientItemTitle),
												$rtfeldman$elm_css$Html$Styled$Attributes$css(
												_List_fromArray(
													[
														$rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$inline)
													]))
											]),
										_List_fromArray(
											[
												A2(
												$rtfeldman$elm_css$Html$Styled$strong,
												_List_Nil,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text(
														$author$project$Data$PDF$User$formatName(value.user))
													])),
												$rtfeldman$elm_css$Html$Styled$text(' ' + user.email)
											]))
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadMultipleDocument$Recipient$styles.avatarContainer)
									]),
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$a,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$css(
												A2(
													$elm$core$List$append,
													$author$project$Page$UploadMultipleDocument$Recipient$styles.avatar,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Css$backgroundColor(
															$author$project$Data$PDF$User$materialColorCode(user.color))
														]))),
												$rtfeldman$elm_css$Html$Styled$Attributes$title(user.firstName)
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(
												A2($elm$core$String$left, 2, user.firstName))
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$div,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadMultipleDocument$Recipient$styles.viewerText)
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(uploadDocumentLanguageData.viewer)
											])),
										A2(
										$author$project$Material$Styled$Icon$close,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Svg$Styled$Attributes$css($author$project$Page$UploadMultipleDocument$Recipient$styles.recipientRmvIcon),
												$rtfeldman$elm_css$Svg$Styled$Events$onClick(
												$author$project$Types$OnAuth(
													$author$project$Types$OnMultipleDocUpload(
														$author$project$Type$UploadMultipleDocument$OnRemoveRecipientClick(userId))))
											]),
										_List_Nil)
									]))
							])) : A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css(
								_Utils_ap($author$project$Page$UploadMultipleDocument$Recipient$styles.recipientContent, $author$project$Page$UploadMultipleDocument$Recipient$styles.annotContainer))
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadMultipleDocument$Recipient$styles.signerNameContainer)
									]),
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$div,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadMultipleDocument$Recipient$styles.recipientHeader)
											]),
										_List_fromArray(
											[
												A2(
												$rtfeldman$elm_css$Html$Styled$span,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadMultipleDocument$Recipient$styles.recipientItemTitle),
														$rtfeldman$elm_css$Html$Styled$Attributes$css(
														_List_fromArray(
															[
																$rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$inline)
															]))
													]),
												_List_fromArray(
													[
														A2(
														$rtfeldman$elm_css$Html$Styled$strong,
														_List_Nil,
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$text(
																$author$project$Data$PDF$User$formatName(value.user))
															])),
														$rtfeldman$elm_css$Html$Styled$text(' ' + user.email)
													]))
											]))
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadMultipleDocument$Recipient$styles.avatarContainer)
									]),
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$span,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$css(
												A2(
													$elm$core$List$append,
													$author$project$Page$UploadMultipleDocument$Recipient$styles.avatar,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Css$backgroundColor(
															$author$project$Data$PDF$User$materialColorCode(user.color))
														]))),
												$rtfeldman$elm_css$Html$Styled$Attributes$title(user.firstName)
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(
												A2($elm$core$String$left, 2, user.firstName))
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$span,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadMultipleDocument$Recipient$styles.viewerText)
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(uploadDocumentLanguageData.signer)
											])),
										A2(
										$author$project$Material$Styled$Icon$close,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Svg$Styled$Attributes$css($author$project$Page$UploadMultipleDocument$Recipient$styles.recipientRmvIcon),
												$rtfeldman$elm_css$Svg$Styled$Events$onClick(
												$author$project$Types$OnAuth(
													$author$project$Types$OnMultipleDocUpload(
														$author$project$Type$UploadMultipleDocument$OnRemoveRecipientClick(userId))))
											]),
										_List_Nil)
									]))
							]));
				},
				A2(
					$elm$core$List$sortBy,
					function (recipient) {
						return $author$project$Data$PDF$User$userInfo(recipient.user).firstName;
					},
					$elm$core$Dict$values(
						$author$project$Data$PDF$Create$recipientsWithoutOwner(model.pdf)))));
	});
var $author$project$Page$UploadMultipleDocument$Recipient$view = F2(
	function (model, languageSwitchModel) {
		var uploadDocumentLanguageData = languageSwitchModel.allLanguageData.location.uploadDocument;
		var recipients = $elm$core$Dict$values(
			$author$project$Data$PDF$Create$recipientsWithoutOwner(model.pdf));
		var buttonText = $elm$core$List$isEmpty(recipients) ? uploadDocumentLanguageData.onlySigner : uploadDocumentLanguageData.nextStep;
		var _v0 = model.addRecipient;
		var role = _v0.role;
		var email = _v0.email;
		var firstName = _v0.firstName;
		var lastName = _v0.lastName;
		var emailError = _v0.emailError;
		var firstNameError = _v0.firstNameError;
		var lastNameError = _v0.lastNameError;
		var search = _v0.search;
		var searchResult = _v0.searchResult;
		return _Utils_eq(model.stage, $author$project$Type$UploadMultipleDocument$Recipients) ? A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadMultipleDocument$Recipient$styles.sectionContainer)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[$rtfeldman$elm_css$Css$displayFlex]))
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadMultipleDocument$Recipient$styles.icon)
								]),
							_List_fromArray(
								[
									A2($author$project$Material$Styled$Icon$addRecipient, _List_Nil, _List_Nil)
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadMultipleDocument$Recipient$styles.annotCardTitle)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(uploadDocumentLanguageData.step2)
								]))
						])),
					A2($author$project$Page$UploadMultipleDocument$Recipient$ownerAnnot, model, languageSwitchModel),
					A2($author$project$Page$UploadMultipleDocument$Recipient$recepientAnnots, model, languageSwitchModel),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadMultipleDocument$Recipient$styles.titleContainer)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadMultipleDocument$Recipient$styles.addRcptHeader)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(uploadDocumentLanguageData.addNewRecipient)
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Events$onClick(
									$author$project$Types$OnAuth(
										$author$project$Types$OnMultipleDocUpload($author$project$Type$UploadMultipleDocument$OnClearAddRecipientFields))),
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadMultipleDocument$Recipient$styles.clearText)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(uploadDocumentLanguageData.clear)
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$form,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Events$onSubmit(
							$author$project$Types$OnAuth(
								$author$project$Types$OnMultipleDocUpload($author$project$Type$UploadMultipleDocument$OnAddRecipientSubmit)))
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css(
									_List_fromArray(
										[
											$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$relative)
										]))
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Material$Styled$Input$text,
									_List_fromArray(
										[
											$author$project$Material$Styled$Input$label(uploadDocumentLanguageData.searchAddressBook),
											$author$project$Material$Styled$Input$value(search),
											$author$project$Material$Styled$Input$containerStyles($author$project$Page$UploadMultipleDocument$Recipient$styles.input),
											$author$project$Material$Styled$Input$onInput(
											A2(
												$elm$core$Basics$composeL,
												A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnMultipleDocUpload),
												$author$project$Type$UploadMultipleDocument$OnAddRecipientInput($author$project$Type$UploadMultipleDocument$Search))),
											$author$project$Material$Styled$Input$onBlur(
											$author$project$Types$OnAuth(
												$author$project$Types$OnMultipleDocUpload(
													$author$project$Type$UploadMultipleDocument$OnAddRecipientBlur($author$project$Type$UploadMultipleDocument$Search))))
										]),
									_List_Nil),
									$author$project$Page$UploadMultipleDocument$Recipient$displaySearchResult(searchResult)
								])),
							A2(
							$author$project$Material$Styled$Input$text,
							_List_fromArray(
								[
									$author$project$Material$Styled$Input$label(uploadDocumentLanguageData.firstName),
									$author$project$Material$Styled$Input$value(firstName),
									$author$project$Material$Styled$Input$containerStyles($author$project$Page$UploadMultipleDocument$Recipient$styles.input),
									$author$project$Material$Styled$Input$errorMessage(firstNameError),
									$author$project$Material$Styled$Input$onInput(
									A2(
										$elm$core$Basics$composeL,
										A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnMultipleDocUpload),
										$author$project$Type$UploadMultipleDocument$OnAddRecipientInput($author$project$Type$UploadMultipleDocument$FirstName))),
									$author$project$Material$Styled$Input$onBlur(
									$author$project$Types$OnAuth(
										$author$project$Types$OnMultipleDocUpload(
											$author$project$Type$UploadMultipleDocument$OnAddRecipientBlur($author$project$Type$UploadMultipleDocument$FirstName))))
								]),
							_List_Nil),
							A2(
							$author$project$Material$Styled$Input$text,
							_List_fromArray(
								[
									$author$project$Material$Styled$Input$label(uploadDocumentLanguageData.lastName),
									$author$project$Material$Styled$Input$value(lastName),
									$author$project$Material$Styled$Input$containerStyles($author$project$Page$UploadMultipleDocument$Recipient$styles.input),
									$author$project$Material$Styled$Input$errorMessage(lastNameError),
									$author$project$Material$Styled$Input$onInput(
									A2(
										$elm$core$Basics$composeL,
										A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnMultipleDocUpload),
										$author$project$Type$UploadMultipleDocument$OnAddRecipientInput($author$project$Type$UploadMultipleDocument$LastName))),
									$author$project$Material$Styled$Input$onBlur(
									$author$project$Types$OnAuth(
										$author$project$Types$OnMultipleDocUpload(
											$author$project$Type$UploadMultipleDocument$OnAddRecipientBlur($author$project$Type$UploadMultipleDocument$LastName))))
								]),
							_List_Nil),
							A2(
							$author$project$Material$Styled$Input$email,
							_List_fromArray(
								[
									$author$project$Material$Styled$Input$label(uploadDocumentLanguageData.emailField),
									$author$project$Material$Styled$Input$value(email),
									$author$project$Material$Styled$Input$containerStyles($author$project$Page$UploadMultipleDocument$Recipient$styles.input),
									$author$project$Material$Styled$Input$errorMessage(emailError),
									$author$project$Material$Styled$Input$onInput(
									A2(
										$elm$core$Basics$composeL,
										A2($elm$core$Basics$composeL, $author$project$Types$OnAuth, $author$project$Types$OnMultipleDocUpload),
										$author$project$Type$UploadMultipleDocument$OnAddRecipientInput($author$project$Type$UploadMultipleDocument$Email))),
									$author$project$Material$Styled$Input$onBlur(
									$author$project$Types$OnAuth(
										$author$project$Types$OnMultipleDocUpload(
											$author$project$Type$UploadMultipleDocument$OnAddRecipientBlur($author$project$Type$UploadMultipleDocument$Email))))
								]),
							_List_Nil),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadMultipleDocument$Recipient$styles.addRcptBtnContainer)
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadMultipleDocument$Recipient$styles.addRcptBtn)
										]),
									_List_fromArray(
										[
											A2($author$project$Page$UploadMultipleDocument$Recipient$addRecipientBtn, model, languageSwitchModel)
										]))
								]))
						])),
					A2(
					$author$project$Material$Styled$Button$button,
					_List_fromArray(
						[
							$author$project$Material$Styled$Button$theme($author$project$Material$Styled$Button$default),
							$author$project$Material$Styled$Button$styles($author$project$Page$UploadMultipleDocument$Recipient$styles.clearAnnotButton),
							$author$project$Material$Styled$Button$onClick(
							$author$project$Types$OnAuth(
								$author$project$Types$OnMultipleDocUpload(
									$author$project$Type$UploadMultipleDocument$GoToStage($author$project$Type$UploadMultipleDocument$Annotations))))
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(buttonText)
						]))
				])) : A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadMultipleDocument$Recipient$styles.sectionContainerClosed),
					$rtfeldman$elm_css$Html$Styled$Events$onClick(
					$author$project$Types$OnAuth(
						$author$project$Types$OnMultipleDocUpload(
							$author$project$Type$UploadMultipleDocument$GoToStage($author$project$Type$UploadMultipleDocument$Recipients))))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadMultipleDocument$Recipient$styles.icon)
						]),
					_List_fromArray(
						[
							A2($author$project$Material$Styled$Icon$addRecipient, _List_Nil, _List_Nil)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadMultipleDocument$Recipient$styles.annotCardTitleClosed)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(uploadDocumentLanguageData.step2)
						])),
					A2($author$project$Material$Styled$Icon$keyboardArrowDown, _List_Nil, _List_Nil)
				]));
	});
var $author$project$Page$UploadMultipleDocument$view = F2(
	function (model, authModel) {
		var _v0 = model;
		var currentTime = _v0.currentTime;
		var timezone = _v0.timezone;
		var appDomain = _v0.appDomain;
		var languageSwitchModel = _v0.languageSwitchModel;
		var _v1 = authModel.uploadMultipleDocModel;
		if (_v1.$ === 'NotLoaded') {
			return $rtfeldman$elm_css$Html$Styled$text('');
		} else {
			var loadedModel = _v1.a;
			var usdToSignRate = loadedModel.signingCost;
			var baseSigningCost = usdToSignRate / 2;
			var total = $elm$core$Basics$ceiling(
				A3(
					$elm$core$List$foldl,
					F2(
						function (pdf, currentAmount) {
							var _v2 = A2($author$project$Data$PDF$Create$signersAndViewer, pdf.pdf, false);
							var signers = _v2.a;
							return (currentAmount + baseSigningCost) + ((usdToSignRate * 0.05) * $elm$core$List$length(signers));
						}),
					0,
					loadedModel.pdfList));
			var displayTxt = A2(
				$author$project$Data$Domain$equal,
				model.appDomain,
				$author$project$Data$Domain$selected(authModel.user.domains)) ? ('The estimated signing cost for your document(s) is ' + ($elm$core$String$fromInt(total) + ' Sign points')) : '';
			return A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadMultipleDocument$styles.container)
					]),
				_List_fromArray(
					[
						$author$project$Page$UploadMultipleDocument$errorBanner(loadedModel),
						A2($author$project$View$Pdftron$view, true, false),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadMultipleDocument$styles.sidebar)
							]),
						_List_fromArray(
							[
								A2($author$project$Page$UploadMultipleDocument$documents, loadedModel, languageSwitchModel),
								A2($author$project$Page$UploadMultipleDocument$Recipient$view, loadedModel, languageSwitchModel),
								A4($author$project$Page$UploadMultipleDocument$annotations, languageSwitchModel, loadedModel, authModel, appDomain),
								A5($author$project$Page$UploadMultipleDocument$advanceOptions, languageSwitchModel, loadedModel, authModel, currentTime, timezone),
								A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$UploadMultipleDocument$styles.costDisplay)
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(displayTxt)
									])),
								$author$project$Page$UploadMultipleDocument$submitButton(languageSwitchModel),
								A2(
								$author$project$View$Signature$view,
								authModel.signatureModel,
								$author$project$View$Signature$checkSignatureList(authModel.signatureModel)),
								$author$project$View$Stamp$modal(authModel.stampModel),
								A4($author$project$Page$UploadMultipleDocument$Modal$view, model, authModel, loadedModel, authModel.user),
								$author$project$Page$UploadMultipleDocument$overlay(loadedModel.selectedAnnot)
							]))
					]));
		}
	});
var $author$project$Page$VerifyDocument$styles = {
	boldText: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontWeight($rtfeldman$elm_css$Css$bold)
		]),
	browseTxt: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$blueA700),
			$rtfeldman$elm_css$Css$textDecoration($rtfeldman$elm_css$Css$underline)
		]),
	card: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$padding(
			$rtfeldman$elm_css$Css$px(24)),
			$rtfeldman$elm_css$Css$marginBottom(
			$rtfeldman$elm_css$Css$px(50))
		]),
	cardContent: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$row),
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$flexWrap($rtfeldman$elm_css$Css$wrap),
			A3(
			$rtfeldman$elm_css$Css$border3,
			$rtfeldman$elm_css$Css$px(1),
			$rtfeldman$elm_css$Css$dashed,
			$author$project$Material$Styled$Color$grey200),
			$rtfeldman$elm_css$Css$padding(
			$rtfeldman$elm_css$Css$px(48)),
			$rtfeldman$elm_css$Css$hover(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$backgroundColor(
					A4($rtfeldman$elm_css$Css$rgba, 41, 121, 255, 0.16)),
					$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer)
				]))
		]),
	cardContentHover: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer),
			$rtfeldman$elm_css$Css$opacity(
			$rtfeldman$elm_css$Css$num(0.5)),
			$rtfeldman$elm_css$Css$backgroundColor($author$project$Material$Styled$Color$grey50)
		]),
	container: _List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Css$margin2,
			$rtfeldman$elm_css$Css$px(5),
			$rtfeldman$elm_css$Css$px(24))
		]),
	docHeader: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(24)),
			$rtfeldman$elm_css$Css$fontWeight(
			$rtfeldman$elm_css$Css$int(500)),
			$rtfeldman$elm_css$Css$marginBottom($rtfeldman$elm_css$Css$zero)
		]),
	docImg: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(130)),
			$rtfeldman$elm_css$Css$marginRight(
			$rtfeldman$elm_css$Css$px(20))
		]),
	docInfo: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$row)
		]),
	docTextContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center)
		]),
	docTxt: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$blueGrey600),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(14)),
			$rtfeldman$elm_css$Css$fontWeight(
			$rtfeldman$elm_css$Css$int(400)),
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(10))
		]),
	docTxtContent: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			$rtfeldman$elm_css$Css$flexWrap($rtfeldman$elm_css$Css$wrap),
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center)
		]),
	fileIcon: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$em(1)),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(24)),
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(12)),
			$rtfeldman$elm_css$Css$marginRight(
			$rtfeldman$elm_css$Css$px(8))
		]),
	fileRemoveBtn: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(14)),
			$rtfeldman$elm_css$Css$fontWeight(
			$rtfeldman$elm_css$Css$int(500)),
			$rtfeldman$elm_css$Css$textTransform($rtfeldman$elm_css$Css$uppercase),
			$rtfeldman$elm_css$Css$backgroundColor($rtfeldman$elm_css$Css$transparent),
			$rtfeldman$elm_css$Css$border($rtfeldman$elm_css$Css$zero),
			$rtfeldman$elm_css$Css$marginRight(
			$rtfeldman$elm_css$Css$px(16)),
			$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer),
			$rtfeldman$elm_css$Css$hover(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$backgroundColor($author$project$Material$Styled$Color$grey100),
					$rtfeldman$elm_css$Css$outline($rtfeldman$elm_css$Css$none)
				])),
			$rtfeldman$elm_css$Css$focus(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$outline($rtfeldman$elm_css$Css$none)
				]))
		]),
	fileSize: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$blueGrey600),
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(8)),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(12)),
			$rtfeldman$elm_css$Css$fontWeight(
			$rtfeldman$elm_css$Css$int(400))
		]),
	fileTitle: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontWeight(
			$rtfeldman$elm_css$Css$int(500)),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(16)),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$blueGrey900),
			$rtfeldman$elm_css$Css$marginBottom($rtfeldman$elm_css$Css$zero)
		]),
	fileTooBigTxt: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$red400),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(14)),
			$rtfeldman$elm_css$Css$lineHeight(
			$rtfeldman$elm_css$Css$px(24)),
			$rtfeldman$elm_css$Css$fontWeight(
			$rtfeldman$elm_css$Css$int(500))
		]),
	fileUploadBtn: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$maxWidth($rtfeldman$elm_css$Css$fitContent),
			A2(
			$rtfeldman$elm_css$Css$padding2,
			$rtfeldman$elm_css$Css$px(8),
			$rtfeldman$elm_css$Css$px(10))
		]),
	fileUploadContent: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$flexEnd)
		]),
	fileUploadDisabledBtn: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$maxWidth($rtfeldman$elm_css$Css$fitContent),
			A2(
			$rtfeldman$elm_css$Css$padding2,
			$rtfeldman$elm_css$Css$px(8),
			$rtfeldman$elm_css$Css$px(10)),
			$rtfeldman$elm_css$Css$backgroundColor($author$project$Material$Styled$Color$grey300),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$grey500),
			$rtfeldman$elm_css$Css$boxShadow($rtfeldman$elm_css$Css$none),
			$rtfeldman$elm_css$Css$important(
			$rtfeldman$elm_css$Css$hover(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$initial),
						$rtfeldman$elm_css$Css$boxShadow($rtfeldman$elm_css$Css$none)
					])))
		]),
	header: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(24)),
			$rtfeldman$elm_css$Css$fontWeight(
			$rtfeldman$elm_css$Css$int(500)),
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(24))
		]),
	heading: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(24)),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$blueGrey900),
			$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center)
		]),
	line: _List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Css$margin2,
			$rtfeldman$elm_css$Css$px(24),
			$rtfeldman$elm_css$Css$zero),
			$rtfeldman$elm_css$Css$backgroundColor($author$project$Material$Styled$Color$grey300),
			$rtfeldman$elm_css$Css$border($rtfeldman$elm_css$Css$zero),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(1))
		]),
	progressBar: _List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Css$margin2,
			$rtfeldman$elm_css$Css$pct(10),
			$rtfeldman$elm_css$Css$pct(25)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(50)),
			$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center)
		]),
	resultContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center)
		]),
	resultTextContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(14)),
			$rtfeldman$elm_css$Css$lineHeight(
			$rtfeldman$elm_css$Css$px(21)),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$blueGrey900),
			$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$fontWeight(
			$rtfeldman$elm_css$Css$int(400))
		]),
	textContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(14)),
			$rtfeldman$elm_css$Css$lineHeight(
			$rtfeldman$elm_css$Css$px(21)),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$blueGrey900),
			$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$fontWeight(
			$rtfeldman$elm_css$Css$int(400))
		]),
	txtContent: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$overflowWrap($rtfeldman$elm_css$Css$breakWord)
		]),
	underlineText: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$textDecoration($rtfeldman$elm_css$Css$underline)
		]),
	uploadDoc: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$paddingLeft(
			$rtfeldman$elm_css$Css$px(16))
		]),
	view: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center)
		])
};
var $author$project$Page$VerifyDocument$explanation = A2(
	$author$project$Material$Styled$Card$card,
	_List_fromArray(
		[
			$author$project$Material$Styled$Card$containerStyles($author$project$Page$VerifyDocument$styles.card)
		]),
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Html$Styled$p,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$VerifyDocument$styles.boldText)
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text('Verify Document')
				])),
			A2(
			$rtfeldman$elm_css$Html$Styled$p,
			_List_Nil,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text('Verify the authenticity of a verifiable proof by uploading it here. Our system will check your generated proof against the blockchain and validate. You can be sure that the proof came from a legitimate source which was signed through our service')
				]))
		]));
var $author$project$Type$VerifyDocument$OnDragEnter = {$: 'OnDragEnter'};
var $author$project$Type$VerifyDocument$OnDragLeave = {$: 'OnDragLeave'};
var $author$project$Type$VerifyDocument$PickFile = {$: 'PickFile'};
var $author$project$Page$VerifyDocument$blurCard = function (model) {
	return model.fileHover ? _Utils_ap($author$project$Page$VerifyDocument$styles.cardContent, $author$project$Page$VerifyDocument$styles.cardContentHover) : $author$project$Page$VerifyDocument$styles.cardContent;
};
var $author$project$Page$VerifyDocument$alwaysPreventDefault = function (msg) {
	return _Utils_Tuple2(msg, true);
};
var $author$project$Page$VerifyDocument$cardContentOn = F2(
	function (event, decoder) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$Events$preventDefaultOn,
			event,
			A2($elm$json$Json$Decode$map, $author$project$Page$VerifyDocument$alwaysPreventDefault, decoder));
	});
var $author$project$Page$VerifyDocument$dropDecoder = A2(
	$elm$json$Json$Decode$at,
	_List_fromArray(
		['dataTransfer', 'files']),
	A2(
		$elm$json$Json$Decode$map,
		$author$project$Types$OnAuth,
		A2(
			$elm$json$Json$Decode$map,
			$author$project$Types$OnVerifyDocument,
			A2($elm$json$Json$Decode$oneOrMore, $author$project$Type$VerifyDocument$GotFiles, $elm$file$File$decoder))));
var $author$project$Page$VerifyDocument$fileDropZone = function (authModel) {
	return A2(
		$author$project$Material$Styled$Card$card,
		_List_fromArray(
			[
				$author$project$Material$Styled$Card$containerStyles($author$project$Page$VerifyDocument$styles.card)
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						$author$project$Page$VerifyDocument$blurCard(authModel.verifyDocumentModel)),
						$rtfeldman$elm_css$Html$Styled$Events$onClick(
						$author$project$Types$OnAuth(
							$author$project$Types$OnVerifyDocument($author$project$Type$VerifyDocument$PickFile))),
						A2(
						$author$project$Page$VerifyDocument$cardContentOn,
						'dragenter',
						$elm$json$Json$Decode$succeed(
							$author$project$Types$OnAuth(
								$author$project$Types$OnVerifyDocument($author$project$Type$VerifyDocument$OnDragEnter)))),
						A2(
						$author$project$Page$VerifyDocument$cardContentOn,
						'dragover',
						$elm$json$Json$Decode$succeed(
							$author$project$Types$OnAuth(
								$author$project$Types$OnVerifyDocument($author$project$Type$VerifyDocument$OnDragEnter)))),
						A2(
						$author$project$Page$VerifyDocument$cardContentOn,
						'dragleave',
						$elm$json$Json$Decode$succeed(
							$author$project$Types$OnAuth(
								$author$project$Types$OnVerifyDocument($author$project$Type$VerifyDocument$OnDragLeave)))),
						A2($author$project$Page$VerifyDocument$cardContentOn, 'drop', $author$project$Page$VerifyDocument$dropDecoder),
						A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'data-test', 'dropzone')
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$img,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$src($author$project$View$Theme$images.dropDoc),
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$VerifyDocument$styles.docImg)
							]),
						_List_Nil),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$VerifyDocument$styles.docTxtContent)
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$h2,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$VerifyDocument$styles.docHeader)
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('DRAG & DROP')
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$p,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$VerifyDocument$styles.docTxt)
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('or '),
												A2(
												$rtfeldman$elm_css$Html$Styled$span,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$VerifyDocument$styles.browseTxt)
													]),
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text('browse')
													])),
												$rtfeldman$elm_css$Html$Styled$text(' through your computer'),
												A2($rtfeldman$elm_css$Html$Styled$br, _List_Nil, _List_Nil),
												A2($rtfeldman$elm_css$Html$Styled$br, _List_Nil, _List_Nil),
												A2(
												$rtfeldman$elm_css$Html$Styled$span,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$VerifyDocument$styles.docTxt)
													]),
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text('Upload your document credentials')
													]))
											]))
									]))
							]))
					]))
			]));
};
var $author$project$Page$VerifyDocument$result = F2(
	function (status, model) {
		return A2(
			$author$project$Material$Styled$Card$card,
			_List_fromArray(
				[
					$author$project$Material$Styled$Card$containerStyles($author$project$Page$VerifyDocument$styles.card)
				]),
			_List_fromArray(
				[
					function () {
					switch (status.$) {
						case 'NoFile':
							return A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$VerifyDocument$styles.view)
									]),
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$h2,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('Please upload your document credentials to begin.')
											]))
									]));
						case 'CheckingVerification':
							return A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$VerifyDocument$styles.progressBar)
									]),
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$h2,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('We are checking your document credentials...')
											])),
										A2($author$project$Material$Styled$ProgressBar$linear, _List_Nil, _List_Nil)
									]));
						case 'VerificationSuccess':
							var data = status.a;
							return A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$VerifyDocument$styles.resultContainer)
									]),
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$div,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$VerifyDocument$styles.view)
											]),
										_List_fromArray(
											[
												A2(
												$author$project$Material$Styled$Icon$checkCircle,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Svg$Styled$Attributes$height('100px'),
														$rtfeldman$elm_css$Svg$Styled$Attributes$width('100px'),
														$rtfeldman$elm_css$Svg$Styled$Attributes$fill('green')
													]),
												_List_Nil)
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$h2,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$VerifyDocument$styles.heading)
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('Document Verification Done')
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$div,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$css(
												_List_fromArray(
													[
														$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center)
													]))
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('Your document credentials are valid')
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$div,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$VerifyDocument$styles.resultTextContainer)
											]),
										_List_fromArray(
											[
												A2(
												$rtfeldman$elm_css$Html$Styled$p,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$VerifyDocument$styles.underlineText)
													]),
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text('Credential Details')
													])),
												A2(
												$rtfeldman$elm_css$Html$Styled$p,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$VerifyDocument$styles.txtContent)
													]),
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text('Document ID: '),
														A2(
														$rtfeldman$elm_css$Html$Styled$a,
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$Attributes$href(
																_Utils_ap($author$project$Data$Route$routeUrl.viewDocument, data.docId))
															]),
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$text(data.docId)
															]))
													])),
												A2(
												$rtfeldman$elm_css$Html$Styled$p,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$VerifyDocument$styles.txtContent)
													]),
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text('Transaction ID: '),
														A2(
														$rtfeldman$elm_css$Html$Styled$a,
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$Attributes$href(
																_Utils_ap(model.bscScanExplorerUrl, data.transactionId)),
																$rtfeldman$elm_css$Html$Styled$Attributes$target('_blank')
															]),
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$text(data.transactionId)
															]))
													])),
												A2(
												$rtfeldman$elm_css$Html$Styled$p,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$VerifyDocument$styles.txtContent)
													]),
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text('Input Data: ' + data.inputData)
													])),
												A2(
												$rtfeldman$elm_css$Html$Styled$p,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$VerifyDocument$styles.underlineText)
													]),
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text('Annotations:')
													])),
												A2(
												$rtfeldman$elm_css$Html$Styled$div,
												_List_Nil,
												A2(
													$elm$core$List$map,
													function (annotation) {
														return A2(
															$rtfeldman$elm_css$Html$Styled$div,
															_List_fromArray(
																[
																	$rtfeldman$elm_css$Html$Styled$Attributes$css(
																	_List_fromArray(
																		[
																			$rtfeldman$elm_css$Css$marginBottom(
																			$rtfeldman$elm_css$Css$px(10))
																		]))
																]),
															_List_fromArray(
																[
																	A2(
																	$rtfeldman$elm_css$Html$Styled$div,
																	_List_Nil,
																	_List_fromArray(
																		[
																			$rtfeldman$elm_css$Html$Styled$text('User: ' + annotation.userName)
																		])),
																	A2(
																	$rtfeldman$elm_css$Html$Styled$div,
																	_List_Nil,
																	_List_fromArray(
																		[
																			$rtfeldman$elm_css$Html$Styled$text('Annotation Type: ' + annotation.type_)
																		])),
																	((annotation.type_ !== 'Signature') && (annotation.type_ !== 'Stamp')) ? A2(
																	$rtfeldman$elm_css$Html$Styled$div,
																	_List_Nil,
																	_List_fromArray(
																		[
																			$rtfeldman$elm_css$Html$Styled$text('Text Content: ' + annotation.content)
																		])) : $rtfeldman$elm_css$Html$Styled$text('')
																]));
													},
													data.annotations))
											]))
									]));
						default:
							var error = status.a;
							return A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$div,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$VerifyDocument$styles.view)
											]),
										_List_fromArray(
											[
												A2(
												$author$project$Material$Styled$Icon$error,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Svg$Styled$Attributes$height('100px'),
														$rtfeldman$elm_css$Svg$Styled$Attributes$width('100px'),
														$rtfeldman$elm_css$Svg$Styled$Attributes$fill('red')
													]),
												_List_Nil)
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$h2,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$VerifyDocument$styles.heading)
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('Verification Failed')
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$div,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$VerifyDocument$styles.textContainer)
											]),
										_List_fromArray(
											[
												A2(
												$rtfeldman$elm_css$Html$Styled$p,
												_List_Nil,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text(error)
													]))
											]))
									]));
					}
				}()
				]));
	});
var $author$project$Page$VerifyDocument$view = F2(
	function (authModel, model) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$VerifyDocument$styles.container)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$h1,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$VerifyDocument$styles.header)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('Verify Document')
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$hr,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$VerifyDocument$styles.line)
						]),
					_List_Nil),
					$author$project$Page$VerifyDocument$explanation,
					$author$project$Page$VerifyDocument$fileDropZone(authModel),
					A2($author$project$Page$VerifyDocument$result, authModel.verifyDocumentModel.status, model)
				]));
	});
var $author$project$Material$Styled$Icon$Email$view = F2(
	function (attributes, children) {
		return A2(
			$rtfeldman$elm_css$Svg$Styled$svg,
			_Utils_ap(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Svg$Styled$Attributes$fill('black'),
						$rtfeldman$elm_css$Svg$Styled$Attributes$width('24px'),
						$rtfeldman$elm_css$Svg$Styled$Attributes$height('24px'),
						$rtfeldman$elm_css$Svg$Styled$Attributes$viewBox('0 0 24 24')
					]),
				attributes),
			_Utils_ap(
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Svg$Styled$path,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Svg$Styled$Attributes$d('M0 0h24v24H0V0z'),
								$rtfeldman$elm_css$Svg$Styled$Attributes$fill('none')
							]),
						_List_Nil),
						A2(
						$rtfeldman$elm_css$Svg$Styled$path,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Svg$Styled$Attributes$d('M22 6c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6zm-2 0l-8 5-8-5h16zm0 12H4V8l8 5 8-5v10z')
							]),
						_List_Nil)
					]),
				children));
	});
var $author$project$Material$Styled$Icon$email = $author$project$Material$Styled$Icon$Email$view;
var $author$project$Page$VerifyTransaction$styles = {
	buttonStyles: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$flexEnd)
		]),
	buttonWidth: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(230)),
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(25))
		]),
	cardContent: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceBetween),
			A4(
			$rtfeldman$elm_css$Css$padding4,
			$rtfeldman$elm_css$Css$px(12),
			$rtfeldman$elm_css$Css$px(24),
			$rtfeldman$elm_css$Css$px(24),
			$rtfeldman$elm_css$Css$px(24))
		]),
	container: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column)
		]),
	dividerStyles: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(30))
		]),
	headerContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$margin(
			$rtfeldman$elm_css$Css$px(20)),
			$rtfeldman$elm_css$Css$maxWidth(
			$rtfeldman$elm_css$Css$px(900)),
			A2(
			$rtfeldman$elm_css$Css$Media$withMediaQuery,
			_List_fromArray(
				['screen and (min-width: 1440px)']),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$maxWidth(
					$rtfeldman$elm_css$Css$px(400))
				])),
			$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center)
		]),
	icon: _List_fromArray(
		[
			$rtfeldman$elm_css$Svg$Styled$Attributes$height('100px'),
			$rtfeldman$elm_css$Svg$Styled$Attributes$width('100px')
		]),
	imageContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(100)),
			$rtfeldman$elm_css$Css$padding(
			$rtfeldman$elm_css$Css$px(20)),
			$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center)
		]),
	innerCard: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(48)),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$pct(100)),
			$rtfeldman$elm_css$Css$marginBottom(
			$rtfeldman$elm_css$Css$px(20)),
			A2(
			$rtfeldman$elm_css$Css$Media$withMediaQuery,
			_List_fromArray(
				['screen and (max-width: 800px)']),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$width(
					$rtfeldman$elm_css$Css$pct(100))
				])),
			$rtfeldman$elm_css$Css$lastChild(
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Css$nthChild,
					'odd',
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$width(
							$rtfeldman$elm_css$Css$pct(100))
						]))
				]))
		]),
	title: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100)),
			$rtfeldman$elm_css$Css$fontWeight($rtfeldman$elm_css$Css$bold),
			$rtfeldman$elm_css$Css$marginBottom(
			$rtfeldman$elm_css$Css$px(25))
		]),
	urlStyles: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$maxWidth($rtfeldman$elm_css$Css$fitContent)
		])
};
var $author$project$Page$VerifyTransaction$view = A2(
	$rtfeldman$elm_css$Html$Styled$div,
	_List_Nil,
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$VerifyTransaction$styles.container)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$VerifyTransaction$styles.headerContainer)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$h1,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Withdraw SIGN Points')
								]))
						])),
					A2(
					$author$project$Material$Styled$Card$card,
					_List_fromArray(
						[
							$author$project$Material$Styled$Card$containerStyles($author$project$Page$VerifyTransaction$styles.innerCard)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$VerifyTransaction$styles.imageContainer)
								]),
							_List_fromArray(
								[
									A2($author$project$Material$Styled$Icon$email, $author$project$Page$VerifyTransaction$styles.icon, _List_Nil)
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$VerifyTransaction$styles.cardContent)
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$VerifyTransaction$styles.title)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('Transaction Pending Verification')
										])),
									$rtfeldman$elm_css$Html$Styled$text('We have sent an email to your account that is pending verification in order for us to process your SIGN Points withdrawal.'),
									A2(
									$author$project$Material$Styled$Divider$divider,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$VerifyTransaction$styles.dividerStyles)
										]),
									_List_Nil),
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$VerifyTransaction$styles.buttonStyles)
										]),
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$a,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$href($author$project$Data$Route$routeUrl.tokenManagement),
													$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$VerifyTransaction$styles.urlStyles)
												]),
											_List_fromArray(
												[
													A2(
													$author$project$Material$Styled$Button$button,
													_List_fromArray(
														[
															$author$project$Material$Styled$Button$styles($author$project$Page$VerifyTransaction$styles.buttonWidth)
														]),
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$text('Back to Reward Points')
														]))
												]))
										]))
								]))
						]))
				]))
		]));
var $author$project$Type$ViewDocument$DocumentInfo = {$: 'DocumentInfo'};
var $author$project$Type$ViewDocument$DocumentInformation = {$: 'DocumentInformation'};
var $author$project$Type$ViewDocument$DownloadDocument = {$: 'DownloadDocument'};
var $author$project$Type$ViewDocument$DownloadIncompleteDoc = {$: 'DownloadIncompleteDoc'};
var $author$project$Type$ViewDocument$Enters = {$: 'Enters'};
var $author$project$Type$ViewDocument$Help = {$: 'Help'};
var $author$project$Type$ViewDocument$Leaves = {$: 'Leaves'};
var $author$project$Type$ViewDocument$OnBackClick = {$: 'OnBackClick'};
var $author$project$Type$ViewDocument$OnCredentialNameInput = function (a) {
	return {$: 'OnCredentialNameInput', a: a};
};
var $author$project$Type$ViewDocument$OnDocSubmit = {$: 'OnDocSubmit'};
var $author$project$Type$ViewDocument$OnGetGenerateCredentialPoints = {$: 'OnGetGenerateCredentialPoints'};
var $author$project$Type$ViewDocument$OnHover = F3(
	function (a, b, c) {
		return {$: 'OnHover', a: a, b: b, c: c};
	});
var $author$project$Type$ViewDocument$OnNavigateToDashboard = {$: 'OnNavigateToDashboard'};
var $author$project$Type$ViewDocument$OnRefreshClick = {$: 'OnRefreshClick'};
var $author$project$Type$ViewDocument$OnReturnToViewDoc = {$: 'OnReturnToViewDoc'};
var $author$project$Type$ViewDocument$Recipient = {$: 'Recipient'};
var $author$project$Type$ViewDocument$Recipients = {$: 'Recipients'};
var $author$project$Type$ViewDocument$SignatureStamp = {$: 'SignatureStamp'};
var $author$project$Page$ViewDocument$convertAuthErrorToError = function (apiAuthError) {
	if (apiAuthError.$ === 'ApiError') {
		var errorCode = apiAuthError.a;
		if (errorCode.$ === 'Fail') {
			var customError = errorCode.a;
			return customError;
		} else {
			return $author$project$Data$Api$PDF$View$INVALID_DOC_ID;
		}
	} else {
		return $author$project$Data$Api$PDF$View$INVALID_DOC_ID;
	}
};
var $author$project$Type$ViewDocument$DeadlineExtension = {$: 'DeadlineExtension'};
var $author$project$Page$ViewDocument$selectedAnnotBorderColor = A3(
	$rtfeldman$elm_css$Css$border3,
	$rtfeldman$elm_css$Css$px(2),
	$rtfeldman$elm_css$Css$solid,
	$author$project$Material$Styled$Color$grey500);
var $author$project$Page$ViewDocument$styles = {
	annotDetailsOwner: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$overflowWrap($rtfeldman$elm_css$Css$breakWord),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$em(1.2))
		]),
	arrowUp: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$relative),
			$rtfeldman$elm_css$Css$left(
			$rtfeldman$elm_css$Css$px(10)),
			A3(
			$rtfeldman$elm_css$Css$borderLeft3,
			$rtfeldman$elm_css$Css$px(10),
			$rtfeldman$elm_css$Css$solid,
			$rtfeldman$elm_css$Css$transparent),
			A3(
			$rtfeldman$elm_css$Css$borderRight3,
			$rtfeldman$elm_css$Css$px(10),
			$rtfeldman$elm_css$Css$solid,
			$rtfeldman$elm_css$Css$transparent),
			A3(
			$rtfeldman$elm_css$Css$borderBottom3,
			$rtfeldman$elm_css$Css$px(10),
			$rtfeldman$elm_css$Css$solid,
			A4($rtfeldman$elm_css$Css$rgba, 41, 121, 255, 0.9)),
			$rtfeldman$elm_css$Css$width($rtfeldman$elm_css$Css$zero),
			$rtfeldman$elm_css$Css$height($rtfeldman$elm_css$Css$zero)
		]),
	checkboxMessage: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(300)),
			$rtfeldman$elm_css$Css$margin(
			$rtfeldman$elm_css$Css$px(10)),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(14))
		]),
	container: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$row),
			$rtfeldman$elm_css$Css$height(
			A3(
				$rtfeldman$elm_css$Css$calc,
				$rtfeldman$elm_css$Css$vh(100),
				$rtfeldman$elm_css$Css$minus,
				$rtfeldman$elm_css$Css$px(66))),
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center)
		]),
	create: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(20)),
			$rtfeldman$elm_css$Css$marginLeft(
			$rtfeldman$elm_css$Css$px(15)),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(50)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(50)),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(50)),
			A3(
			$rtfeldman$elm_css$Css$border3,
			$rtfeldman$elm_css$Css$px(1),
			$rtfeldman$elm_css$Css$solid,
			$author$project$Material$Styled$Color$blueA700),
			$rtfeldman$elm_css$Css$borderRadius(
			$rtfeldman$elm_css$Css$px(10)),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$blueA700),
			$rtfeldman$elm_css$Css$hover(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer)
				]))
		]),
	credentialGenerateTxt: _List_fromArray(
		[
			A3(
			$rtfeldman$elm_css$Css$margin3,
			$rtfeldman$elm_css$Css$em(1.2),
			$rtfeldman$elm_css$Css$zero,
			$rtfeldman$elm_css$Css$em(0.2)),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$em(1.2)),
			$rtfeldman$elm_css$Css$fontWeight(
			$rtfeldman$elm_css$Css$int(500)),
			A2(
			$rtfeldman$elm_css$Css$padding2,
			$rtfeldman$elm_css$Css$em(1),
			$rtfeldman$elm_css$Css$em(0))
		]),
	credentialType: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$em(1.2)),
			$rtfeldman$elm_css$Css$fontWeight(
			$rtfeldman$elm_css$Css$int(500)),
			A2(
			$rtfeldman$elm_css$Css$margin2,
			$rtfeldman$elm_css$Css$px(5),
			$rtfeldman$elm_css$Css$zero)
		]),
	docDetailsSubTitle: _List_fromArray(
		[
			A3(
			$rtfeldman$elm_css$Css$margin3,
			$rtfeldman$elm_css$Css$em(1.2),
			$rtfeldman$elm_css$Css$zero,
			$rtfeldman$elm_css$Css$em(0.2)),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$em(1.2)),
			$rtfeldman$elm_css$Css$fontWeight(
			$rtfeldman$elm_css$Css$int(500))
		]),
	docDetailsText: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$overflowWrap($rtfeldman$elm_css$Css$breakWord)
		]),
	docDetailsTitle: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginBottom(
			$rtfeldman$elm_css$Css$px(0)),
			$rtfeldman$elm_css$Css$fontWeight(
			$rtfeldman$elm_css$Css$int(500)),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$em(1.5))
		]),
	docStampBox: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$row),
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(10))
		]),
	docStampContent: _List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Css$margin2,
			$rtfeldman$elm_css$Css$px(10),
			$rtfeldman$elm_css$Css$zero),
			$rtfeldman$elm_css$Css$fontWeight(
			$rtfeldman$elm_css$Css$int(500)),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$em(1.2))
		]),
	docStampImage: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(60)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(120)),
			A2($rtfeldman$elm_css$Css$property, 'object-fit', 'contain'),
			A2($rtfeldman$elm_css$Css$property, 'box-shadow', '0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24)'),
			$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer),
			$author$project$Page$ViewDocument$selectedAnnotBorderColor,
			$rtfeldman$elm_css$Css$hover(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$backgroundColor(
					$rtfeldman$elm_css$Css$hex('f6f7f7'))
				]))
		]),
	docStampItem: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$fontSize($rtfeldman$elm_css$Css$initial)
		]),
	docStatusBtn: _List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Css$margin2,
			$rtfeldman$elm_css$Css$em(0.6),
			$rtfeldman$elm_css$Css$zero)
		]),
	docStatusContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$em(1.2))
		]),
	expired: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$white),
			$rtfeldman$elm_css$Css$backgroundColor($author$project$Material$Styled$Color$red900),
			A2(
			$rtfeldman$elm_css$Css$padding2,
			$rtfeldman$elm_css$Css$px(3),
			$rtfeldman$elm_css$Css$px(5)),
			$rtfeldman$elm_css$Css$fontWeight(
			$rtfeldman$elm_css$Css$int(500))
		]),
	icon: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer),
			$rtfeldman$elm_css$Css$hover(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$backgroundColor($author$project$Material$Styled$Color$grey200)
				])),
			A4(
			$rtfeldman$elm_css$Css$margin4,
			$rtfeldman$elm_css$Css$px(5),
			$rtfeldman$elm_css$Css$px(10),
			$rtfeldman$elm_css$Css$px(5),
			$rtfeldman$elm_css$Css$px(10)),
			$rtfeldman$elm_css$Css$active(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$backgroundColor($author$project$Material$Styled$Color$grey100),
					$rtfeldman$elm_css$Css$backgroundSize(
					$rtfeldman$elm_css$Css$pct(100)),
					$rtfeldman$elm_css$Css$Transitions$transition(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Css$Transitions$background(0)
						]))
				])),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(30))
		]),
	marginBottom10: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginBottom(
			$rtfeldman$elm_css$Css$px(10))
		]),
	marginTop20: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(20))
		]),
	merkleRootTxt: _List_fromArray(
		[
			A3(
			$rtfeldman$elm_css$Css$margin3,
			$rtfeldman$elm_css$Css$em(0.5),
			$rtfeldman$elm_css$Css$zero,
			$rtfeldman$elm_css$Css$em(0.2)),
			$rtfeldman$elm_css$Css$overflowWrap($rtfeldman$elm_css$Css$breakWord)
		]),
	messageContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$relative),
			$rtfeldman$elm_css$Css$bottom(
			$rtfeldman$elm_css$Css$px(12)),
			$rtfeldman$elm_css$Css$left(
			$rtfeldman$elm_css$Css$px(0)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(0)),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(0))
		]),
	onHover: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$hover(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer),
					A2($rtfeldman$elm_css$Css$property, 'box-shadow', '0px 2px 4px -1px rgba(0,0,0,0.2), 0px 4px 5px 0px rgba(0,0,0,0.14), 0px 1px 10px 0px rgba(0,0,0,0.12)'),
					$rtfeldman$elm_css$Css$backgroundColor($author$project$Material$Styled$Color$grey200)
				]))
		]),
	optionBtn: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100))
		]),
	ownerSignatureImg: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(50)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(125)),
			A2($rtfeldman$elm_css$Css$property, 'object-fit', 'contain'),
			A2($rtfeldman$elm_css$Css$property, 'box-shadow', '0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24)'),
			$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer),
			$author$project$Page$ViewDocument$selectedAnnotBorderColor,
			$rtfeldman$elm_css$Css$hover(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$backgroundColor(
					$rtfeldman$elm_css$Css$hex('f6f7f7'))
				]))
		]),
	retryContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer),
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(10))
		]),
	retryNotariseBtn: _List_Nil,
	sidebar: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$padding(
			$rtfeldman$elm_css$Css$px(10)),
			$rtfeldman$elm_css$Css$backgroundColor($author$project$Material$Styled$Color$white),
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(38)),
			$rtfeldman$elm_css$Css$overflowY($rtfeldman$elm_css$Css$auto)
		]),
	signature: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(100)),
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(15)),
			$rtfeldman$elm_css$Css$marginLeft(
			$rtfeldman$elm_css$Css$px(15))
		]),
	signatureImg: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(50)),
			$rtfeldman$elm_css$Css$minWidth(
			$rtfeldman$elm_css$Css$px(100)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(43)),
			A2($rtfeldman$elm_css$Css$property, 'object-fit', 'contain'),
			A2($rtfeldman$elm_css$Css$property, 'box-shadow', '0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24)'),
			$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer),
			$rtfeldman$elm_css$Css$hover(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$backgroundColor(
					$rtfeldman$elm_css$Css$hex('f6f7f7'))
				]))
		]),
	signatureImgBox: _List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Css$margin2,
			$rtfeldman$elm_css$Css$px(10),
			$rtfeldman$elm_css$Css$zero),
			$rtfeldman$elm_css$Css$fontWeight(
			$rtfeldman$elm_css$Css$int(500)),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$em(1.2))
		]),
	signatureListBox: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$row),
			$rtfeldman$elm_css$Css$flexWrap($rtfeldman$elm_css$Css$wrap),
			$rtfeldman$elm_css$Css$marginBottom(
			$rtfeldman$elm_css$Css$px(15))
		]),
	signatureName: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$textOverflow($rtfeldman$elm_css$Css$ellipsis),
			$rtfeldman$elm_css$Css$overflow($rtfeldman$elm_css$Css$hidden),
			$rtfeldman$elm_css$Css$whiteSpace($rtfeldman$elm_css$Css$noWrap),
			$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(60))
		]),
	signingOrderCheckBox: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginLeft(
			$rtfeldman$elm_css$Css$px(-10)),
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(-10)),
			$rtfeldman$elm_css$Css$marginBottom(
			$rtfeldman$elm_css$Css$px(10)),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(12.8)),
			A4(
			$rtfeldman$elm_css$Css$padding4,
			$rtfeldman$elm_css$Css$em(1),
			$rtfeldman$elm_css$Css$em(0),
			$rtfeldman$elm_css$Css$em(0),
			$rtfeldman$elm_css$Css$em(0))
		]),
	stamp: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(15)),
			$rtfeldman$elm_css$Css$marginLeft(
			$rtfeldman$elm_css$Css$px(15))
		]),
	stampImg: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(60)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(60)),
			A2($rtfeldman$elm_css$Css$property, 'object-fit', 'contain'),
			A2($rtfeldman$elm_css$Css$property, 'box-shadow', '0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24)'),
			$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer),
			$rtfeldman$elm_css$Css$hover(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$backgroundColor(
					$rtfeldman$elm_css$Css$hex('f6f7f7'))
				]))
		]),
	stampName: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$textOverflow($rtfeldman$elm_css$Css$ellipsis),
			$rtfeldman$elm_css$Css$overflow($rtfeldman$elm_css$Css$hidden),
			$rtfeldman$elm_css$Css$whiteSpace($rtfeldman$elm_css$Css$noWrap),
			$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(50))
		]),
	toolTip: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$backgroundColor($author$project$Material$Styled$Color$blueA400),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(80)),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(30)),
			$rtfeldman$elm_css$Css$padding(
			$rtfeldman$elm_css$Css$px(10)),
			$rtfeldman$elm_css$Css$borderRadius(
			$rtfeldman$elm_css$Css$px(10)),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$white),
			$rtfeldman$elm_css$Css$animationName($author$project$View$InfomationToolTip$textAnimation),
			$rtfeldman$elm_css$Css$animationDuration(
			$rtfeldman$elm_css$Css$sec(0.3)),
			$rtfeldman$elm_css$Css$opacity(
			$rtfeldman$elm_css$Css$num(0.9)),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(12))
		]),
	topPanel: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$backgroundColor($author$project$Material$Styled$Color$grey300),
			$rtfeldman$elm_css$Css$paddingTop(
			$rtfeldman$elm_css$Css$px(5)),
			$rtfeldman$elm_css$Css$paddingBottom(
			$rtfeldman$elm_css$Css$px(5)),
			$rtfeldman$elm_css$Css$paddingLeft(
			$rtfeldman$elm_css$Css$px(7)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100)),
			$rtfeldman$elm_css$Css$minWidth(
			$rtfeldman$elm_css$Css$px(350))
		])
};
var $author$project$Page$ViewDocument$deadlineExtensionButton = F3(
	function (loadedModel, sessionModel, user) {
		switch (sessionModel.$) {
			case 'Auth':
				var conditions = _List_fromArray(
					[
						_Utils_eq(
						$author$project$Data$PDF$User$emailFromUser(
							$author$project$Data$PDF$owner(loadedModel.pdf)),
						user.email),
						!_Utils_eq(
						$author$project$Data$PDF$status(loadedModel.pdf),
						$author$project$Data$PDF$Expired),
						!_Utils_eq(
						$author$project$Data$PDF$status(loadedModel.pdf),
						$author$project$Data$PDF$Completed),
						!_Utils_eq(
						$author$project$Data$PDF$dueDate(loadedModel.pdf),
						$elm$core$Maybe$Nothing)
					]);
				return A2(
					$elm$core$List$all,
					function (condition) {
						return condition;
					},
					conditions) ? A2(
					$author$project$Material$Styled$Button$button,
					_List_fromArray(
						[
							$author$project$Material$Styled$Button$theme($author$project$Material$Styled$Button$default),
							$author$project$Material$Styled$Button$styles($author$project$Page$ViewDocument$styles.docStatusBtn),
							$author$project$Material$Styled$Button$onClick(
							$author$project$Types$OnViewDoc(
								$author$project$Type$ViewDocument$OnAuth(
									$author$project$Type$ViewDocument$OnLoaded(
										$author$project$Type$ViewDocument$OnShowModal($author$project$Type$ViewDocument$DeadlineExtension)))))
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('Extend Document Due Date')
						])) : $rtfeldman$elm_css$Html$Styled$text('');
			case 'Anonymous':
				return $rtfeldman$elm_css$Html$Styled$text('');
			case 'NoAuth':
				return $rtfeldman$elm_css$Html$Styled$text('');
			default:
				return $rtfeldman$elm_css$Html$Styled$text('');
		}
	});
var $author$project$Page$ViewDocument$displayApiErrorTitle = function (apiErrorText) {
	switch (apiErrorText.$) {
		case 'INVALID_DOC_ID':
			return 'Document Error';
		case 'DELETED_DOCUMENT':
			return 'Document Deleted';
		default:
			return 'Document Error';
	}
};
var $rtfeldman$elm_css$Html$Styled$i = $rtfeldman$elm_css$Html$Styled$node('i');
var $author$project$Page$ViewDocument$showAdditionalMsg = function (pdf) {
	var _v0 = $author$project$Data$PDF$additionalMsg(pdf);
	if (_v0.$ === 'Just') {
		var additionalMsg = _v0.a;
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$h2,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$styles.docDetailsSubTitle)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('Custom Message')
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$i,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(additionalMsg)
								]))
						]))
				]));
	} else {
		return $rtfeldman$elm_css$Html$Styled$text('');
	}
};
var $author$project$Page$ViewDocument$toMonthName = function (month) {
	switch (month) {
		case '01':
			return 'Jan';
		case '02':
			return 'Feb';
		case '03':
			return 'Mar';
		case '04':
			return 'Apr';
		case '05':
			return 'May';
		case '06':
			return 'Jun';
		case '07':
			return 'Jul';
		case '08':
			return 'Aug';
		case '09':
			return 'Sep';
		case '10':
			return 'Oct';
		case '11':
			return 'Nov';
		case '12':
			return 'Dec';
		default:
			return '';
	}
};
var $author$project$Page$ViewDocument$getFormattedDate = function (date) {
	var splitDate = $elm$core$List$reverse(
		A2($elm$core$String$split, '-', date));
	var formattedMonth = $author$project$Page$ViewDocument$toMonthName(
		A2(
			$elm$core$Maybe$withDefault,
			'01',
			$elm$core$List$head(
				A2($elm$core$List$drop, 1, splitDate))));
	return A2(
		$elm$core$String$join,
		' ',
		_List_fromArray(
			[
				A2(
				$elm$core$Maybe$withDefault,
				'',
				$elm$core$List$head(splitDate)),
				formattedMonth,
				A2(
				$elm$core$Maybe$withDefault,
				'',
				$elm$core$List$head(
					A2($elm$core$List$drop, 2, splitDate)))
			]));
};
var $author$project$Page$ViewDocument$showDueDate = F2(
	function (pdf, model) {
		var viewDocumentPageLanguageData = model.languageSwitchModel.allLanguageData.location.uploadDocument;
		var _v0 = $author$project$Data$PDF$dueDate(pdf);
		if (_v0.$ === 'Just') {
			var date = _v0.a;
			return A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$h2,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$styles.docDetailsSubTitle)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(viewDocumentPageLanguageData.dueDate)
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$Page$ViewDocument$getFormattedDate(date))
							]))
					]));
		} else {
			return $rtfeldman$elm_css$Html$Styled$text('');
		}
	});
var $author$project$Page$ViewDocument$showNoOfPages = function (loadedModel) {
	var _v0 = loadedModel.payload;
	var document = _v0.document;
	var numberOfPages = $elm$core$String$fromInt(document.noOfPages);
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$h2,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$styles.docDetailsSubTitle)
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('No Of Pages')
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$span,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(numberOfPages)
					]))
			]));
};
var $author$project$Data$PDF$checksum = function (_v0) {
	var pdf = _v0.a;
	return pdf.checksum;
};
var $author$project$Data$PDF$convertFromNotarisationStatusType = function (notariseStatus) {
	var _v0 = A2($elm$core$Maybe$withDefault, $author$project$Data$PDF$Pending, notariseStatus);
	if (_v0.$ === 'Pending') {
		return 'Pending';
	} else {
		return 'Completed';
	}
};
var $author$project$Page$ViewDocument$convertStringToNetwork = function (currentUserNotarisationNetwork) {
	switch (currentUserNotarisationNetwork) {
		case 'Binance':
			return $author$project$Type$ViewDocument$Binance;
		case 'Algorand':
			return $author$project$Type$ViewDocument$Algorand;
		default:
			return $author$project$Type$ViewDocument$Binance;
	}
};
var $author$project$Data$PDF$merkleRoot = function (_v0) {
	var pdf = _v0.a;
	return pdf.merkleRoot;
};
var $author$project$Data$PDF$notarisationNetwork = function (_v0) {
	var pdf = _v0.a;
	return pdf.notarisationNetwork;
};
var $author$project$Data$PDF$notarisationStatus = function (_v0) {
	var pdf = _v0.a;
	return pdf.notarisationStatus;
};
var $author$project$Data$PDF$notarisationTimeStamp = function (_v0) {
	var pdf = _v0.a;
	return pdf.notarisationTimeStamp;
};
var $author$project$Data$PDF$transactionHash = function (_v0) {
	var pdf = _v0.a;
	return pdf.transactionHash;
};
var $author$project$Page$ViewDocument$showNotarisationStatus = F4(
	function (appModel, pdf, url, algorandExplorerUrl) {
		var zoneName = function () {
			var _v10 = appModel.timezoneName;
			if (_v10.$ === 'Just') {
				var zoneName_ = _v10.a;
				if (zoneName_.$ === 'Name') {
					var name = zoneName_.a;
					return name;
				} else {
					var offset = zoneName_.a;
					return 'UTC ' + ($elm$core$String$fromInt((offset / 60) | 0) + '00');
				}
			} else {
				return 'No zoneName';
			}
		}();
		var viewDocumentPageLanguageData = appModel.languageSwitchModel.allLanguageData.location.viewDocumentPage;
		var timeStampTxt = A2(
			$author$project$Page$PointsTransactions$TableElements$dateFormatter,
			appModel.timezone,
			A2(
				$elm$core$Maybe$withDefault,
				$elm$time$Time$millisToPosix(0),
				$author$project$Data$PDF$notarisationTimeStamp(pdf))) + (' ' + (A2(
			$author$project$Page$PointsTransactions$TableElements$timeFormatter,
			appModel.timezone,
			A2(
				$elm$core$Maybe$withDefault,
				$elm$time$Time$millisToPosix(0),
				$author$project$Data$PDF$notarisationTimeStamp(pdf))) + (' (' + (zoneName + ')'))));
		var notarisationStatus = $author$project$Data$PDF$notarisationStatus(pdf);
		var notarisationNetwork = $author$project$Page$ViewDocument$convertStringToNetwork(
			A2(
				$elm$core$Maybe$withDefault,
				'',
				$author$project$Data$PDF$notarisationNetwork(pdf)));
		var merkleTxt = A2(
			$elm$core$Maybe$withDefault,
			'',
			$author$project$Data$PDF$merkleRoot(pdf));
		var checksumTxt = A2(
			$elm$core$Maybe$withDefault,
			'',
			$author$project$Data$PDF$checksum(pdf));
		var _v0 = _Utils_Tuple2(notarisationNetwork, notarisationStatus);
		if (_v0.b.$ === 'Just') {
			if (_v0.b.a.$ === 'Pending') {
				var _v3 = _v0.b.a;
				return A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$h2,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$styles.docDetailsSubTitle)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(viewDocumentPageLanguageData.notarisationStatus)
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$styles.docDetailsText)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$Data$PDF$convertFromNotarisationStatusType(notarisationStatus))
								]))
						]));
			} else {
				if (_v0.a.$ === 'Binance') {
					var _v1 = _v0.a;
					var _v2 = _v0.b.a;
					return A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$h2,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$styles.docDetailsSubTitle)
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(viewDocumentPageLanguageData.notarisationStatus)
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$a,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$href(
										_Utils_ap(
											url,
											A2(
												$elm$core$Maybe$withDefault,
												'',
												$author$project$Data$PDF$transactionHash(pdf)))),
										$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$styles.docDetailsText),
										$rtfeldman$elm_css$Html$Styled$Attributes$target('_blank')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$Data$PDF$convertFromNotarisationStatusType(notarisationStatus))
									])),
								(_Utils_eq(
								$author$project$Data$PDF$merkleRoot(pdf),
								$elm$core$Maybe$Nothing) && _Utils_eq(
								$author$project$Data$PDF$notarisationTimeStamp(pdf),
								$elm$core$Maybe$Nothing)) ? $rtfeldman$elm_css$Html$Styled$text('') : A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$div,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$styles.docDetailsSubTitle)
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('Merkle Root')
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$span,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$styles.docDetailsText)
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(merkleTxt)
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$div,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$styles.docDetailsSubTitle)
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(viewDocumentPageLanguageData.timeOfNotarisation)
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$span,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$styles.docDetailsText)
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(timeStampTxt)
											]))
									]))
							]));
				} else {
					var _v4 = _v0.a;
					var _v5 = _v0.b.a;
					return A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$h2,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$styles.docDetailsSubTitle)
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(viewDocumentPageLanguageData.notarisationStatus)
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$a,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$href(
										_Utils_ap(
											algorandExplorerUrl,
											A2(
												$elm$core$Maybe$withDefault,
												'',
												$author$project$Data$PDF$transactionHash(pdf)))),
										$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$styles.docDetailsText),
										$rtfeldman$elm_css$Html$Styled$Attributes$target('_blank')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$Data$PDF$convertFromNotarisationStatusType(notarisationStatus))
									])),
								_Utils_eq(
								$author$project$Data$PDF$notarisationTimeStamp(pdf),
								$elm$core$Maybe$Nothing) ? $rtfeldman$elm_css$Html$Styled$text('') : A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$div,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$styles.docDetailsSubTitle)
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(viewDocumentPageLanguageData.documentChecksum)
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$span,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$styles.docDetailsText)
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(checksumTxt)
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$div,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$styles.docDetailsSubTitle)
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(viewDocumentPageLanguageData.timeOfNotarisation)
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$span,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$styles.docDetailsText)
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(timeStampTxt)
											]))
									]))
							]));
				}
			}
		} else {
			if (_v0.a.$ === 'Algorand') {
				var _v6 = _v0.a;
				var _v7 = _v0.b;
				return $rtfeldman$elm_css$Html$Styled$text('');
			} else {
				var _v8 = _v0.a;
				var _v9 = _v0.b;
				return $rtfeldman$elm_css$Html$Styled$text('');
			}
		}
	});
var $author$project$Page$ViewDocument$showStatus = F2(
	function (model, pdf) {
		var viewDocumentPageLanguageData = model.languageSwitchModel.allLanguageData.location.viewDocumentPage;
		var _v0 = $author$project$Data$PDF$status(pdf);
		switch (_v0.$) {
			case 'Signing':
				return A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(viewDocumentPageLanguageData.pendingSignature)
						]));
			case 'Viewing':
				var signers = _v0.a;
				return A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							A2($elm$core$Maybe$withDefault, '', signers))
						]));
			case 'Completed':
				return A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(viewDocumentPageLanguageData.documentCompleted)
						]));
			case 'Expired':
				return A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$styles.expired)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(viewDocumentPageLanguageData.expired)
						]));
			default:
				var signerText = _v0.a;
				return A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(signerText)
						]));
		}
	});
var $author$project$Data$PDF$templateId = function (_v0) {
	var pdf = _v0.a;
	return pdf.templateId;
};
var $author$project$Page$ViewDocument$showTemplateId = F2(
	function (pdf, model) {
		var viewDocumentPageLanguageData = model.languageSwitchModel.allLanguageData.location.viewDocumentPage;
		var _v0 = $author$project$Data$PDF$templateId(pdf);
		if (_v0.$ === 'Just') {
			var templateId = _v0.a;
			return A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$h2,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$styles.docDetailsSubTitle)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(viewDocumentPageLanguageData.templateId)
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(templateId)
							]))
					]));
		} else {
			return $rtfeldman$elm_css$Html$Styled$text('');
		}
	});
var $author$project$Page$ViewDocument$documentDetails = F4(
	function (appModel, loadedModel, url, algorandExplorerUrl) {
		var viewDocumentPageLanguageData = appModel.languageSwitchModel.allLanguageData.location.viewDocumentPage;
		var titleText = appModel.languageSwitchModel.allLanguageData.location.createTemplatePage.title;
		var senderText = appModel.languageSwitchModel.allLanguageData.location.dashboard.sender;
		var _v0 = loadedModel;
		var pdf = _v0.pdf;
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$h2,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$styles.docDetailsSubTitle)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(viewDocumentPageLanguageData.documentId)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$styles.docDetailsText)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$Data$PDF$id(pdf))
						])),
					A2($author$project$Page$ViewDocument$showTemplateId, pdf, appModel),
					A2(
					$rtfeldman$elm_css$Html$Styled$h2,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$styles.docDetailsSubTitle)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(titleText)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$styles.docDetailsText)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$Data$PDF$title(pdf))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$h2,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$styles.docDetailsSubTitle)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(senderText + ' ')
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$styles.docDetailsText)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$Data$PDF$User$formatName(
								$author$project$Data$PDF$owner(pdf)))
						])),
					A2($author$project$Page$ViewDocument$showDueDate, pdf, appModel),
					A2(
					$rtfeldman$elm_css$Html$Styled$h2,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$styles.docDetailsSubTitle)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(viewDocumentPageLanguageData.status)
						])),
					A2($author$project$Page$ViewDocument$showStatus, appModel, pdf),
					$author$project$Page$ViewDocument$showAdditionalMsg(pdf),
					A4($author$project$Page$ViewDocument$showNotarisationStatus, appModel, pdf, url, algorandExplorerUrl),
					$author$project$Page$ViewDocument$showNoOfPages(loadedModel)
				]));
	});
var $author$project$Material$Styled$Icon$DocumentInformation$view = F2(
	function (attributes, children) {
		return A2(
			$rtfeldman$elm_css$Svg$Styled$svg,
			_Utils_ap(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Svg$Styled$Attributes$fill('black'),
						$rtfeldman$elm_css$Svg$Styled$Attributes$width('36px'),
						$rtfeldman$elm_css$Svg$Styled$Attributes$height('36px'),
						$rtfeldman$elm_css$Svg$Styled$Attributes$viewBox('0 0 24 24')
					]),
				attributes),
			_Utils_ap(
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Svg$Styled$path,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Svg$Styled$Attributes$d('M0 0h24v24H0V0z'),
								$rtfeldman$elm_css$Svg$Styled$Attributes$fill('none')
							]),
						_List_Nil),
						A2(
						$rtfeldman$elm_css$Svg$Styled$path,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Svg$Styled$Attributes$d('M8 16h8v2H8zm0-4h8v2H8zm6-10H6c-1.1 0-2 .9-2 2v16c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm4 18H6V4h7v5h5v11z')
							]),
						_List_Nil)
					]),
				children));
	});
var $author$project$Material$Styled$Icon$documentInfo = $author$project$Material$Styled$Icon$DocumentInformation$view;
var $author$project$Type$ViewDocument$OnAcceptESignDisclaimerUserClick = {$: 'OnAcceptESignDisclaimerUserClick'};
var $author$project$Type$ViewDocument$ToggleUserAcceptESignDisclaimer = {$: 'ToggleUserAcceptESignDisclaimer'};
var $author$project$Page$ViewDocument$Modal$selectedAnnotBorderColor = A3(
	$rtfeldman$elm_css$Css$border3,
	$rtfeldman$elm_css$Css$px(2),
	$rtfeldman$elm_css$Css$solid,
	$author$project$Material$Styled$Color$grey500);
var $author$project$Page$ViewDocument$Modal$styles = {
	activitiesContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$overflowY($rtfeldman$elm_css$Css$auto),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$vh(60)),
			$rtfeldman$elm_css$Css$maxHeight(
			$rtfeldman$elm_css$Css$px(600))
		]),
	activitiesModal: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$vw(90)),
			$rtfeldman$elm_css$Css$maxWidth(
			$rtfeldman$elm_css$Css$px(550))
		]),
	allIcon: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$default)
		]),
	anonymousSuccessModalBody: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(14)),
			$rtfeldman$elm_css$Css$fontWeight(
			$rtfeldman$elm_css$Css$int(400)),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$blueGrey500),
			$rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$block),
			$rtfeldman$elm_css$Css$marginBottom(
			$rtfeldman$elm_css$Css$px(10))
		]),
	arrowDown: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$relative),
			$rtfeldman$elm_css$Css$left(
			$rtfeldman$elm_css$Css$px(135)),
			A3(
			$rtfeldman$elm_css$Css$borderLeft3,
			$rtfeldman$elm_css$Css$px(5),
			$rtfeldman$elm_css$Css$solid,
			$rtfeldman$elm_css$Css$transparent),
			A3(
			$rtfeldman$elm_css$Css$borderRight3,
			$rtfeldman$elm_css$Css$px(5),
			$rtfeldman$elm_css$Css$solid,
			$rtfeldman$elm_css$Css$transparent),
			A3(
			$rtfeldman$elm_css$Css$borderTop3,
			$rtfeldman$elm_css$Css$px(5),
			$rtfeldman$elm_css$Css$solid,
			A4($rtfeldman$elm_css$Css$rgba, 41, 121, 255, 0.9)),
			A3(
			$rtfeldman$elm_css$Css$borderBottom3,
			$rtfeldman$elm_css$Css$px(5),
			$rtfeldman$elm_css$Css$solid,
			$rtfeldman$elm_css$Css$transparent),
			$rtfeldman$elm_css$Css$width($rtfeldman$elm_css$Css$zero),
			$rtfeldman$elm_css$Css$height($rtfeldman$elm_css$Css$zero)
		]),
	avatar: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$borderRadius(
			$rtfeldman$elm_css$Css$pct(50)),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(40)),
			$rtfeldman$elm_css$Css$minWidth(
			$rtfeldman$elm_css$Css$px(40)),
			$rtfeldman$elm_css$Css$marginRight(
			$rtfeldman$elm_css$Css$px(2)),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$white),
			$rtfeldman$elm_css$Css$backgroundColor($author$project$Material$Styled$Color$blueA700),
			$rtfeldman$elm_css$Css$textTransform($rtfeldman$elm_css$Css$uppercase),
			$rtfeldman$elm_css$Css$textDecoration($rtfeldman$elm_css$Css$none)
		]),
	boldText: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontWeight(
			$rtfeldman$elm_css$Css$int(500))
		]),
	bottomContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column)
		]),
	btnMaxWidth: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100))
		]),
	button: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginLeft(
			$rtfeldman$elm_css$Css$px(10)),
			$rtfeldman$elm_css$Css$maxWidth(
			$rtfeldman$elm_css$Css$px(200))
		]),
	buttonContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$row),
			A4(
			$rtfeldman$elm_css$Css$padding4,
			$rtfeldman$elm_css$Css$px(10),
			$rtfeldman$elm_css$Css$px(0),
			$rtfeldman$elm_css$Css$px(0),
			$rtfeldman$elm_css$Css$px(0)),
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center)
		]),
	buttonContainer2: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center)
		]),
	cardContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			$rtfeldman$elm_css$Css$flexWrap($rtfeldman$elm_css$Css$wrap),
			$rtfeldman$elm_css$Css$marginBottom(
			$rtfeldman$elm_css$Css$px(10)),
			$rtfeldman$elm_css$Css$marginRight(
			$rtfeldman$elm_css$Css$px(10))
		]),
	cardHeaderContent: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$margin(
			$rtfeldman$elm_css$Css$px(20))
		]),
	cert: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$overflowY($rtfeldman$elm_css$Css$auto),
			$rtfeldman$elm_css$Css$padding(
			$rtfeldman$elm_css$Css$px(20)),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$vh(70)),
			$rtfeldman$elm_css$Css$maxHeight(
			$rtfeldman$elm_css$Css$px(700))
		]),
	certActivites: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			$rtfeldman$elm_css$Css$marginBottom(
			$rtfeldman$elm_css$Css$px(10)),
			$rtfeldman$elm_css$Css$paddingBottom(
			$rtfeldman$elm_css$Css$px(5)),
			A3(
			$rtfeldman$elm_css$Css$borderBottom3,
			$rtfeldman$elm_css$Css$px(1),
			$rtfeldman$elm_css$Css$solid,
			$author$project$Material$Styled$Color$grey300),
			$rtfeldman$elm_css$Css$lastChild(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$borderBottom(
					$rtfeldman$elm_css$Css$px(0))
				]))
		]),
	certContent: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceBetween),
			A2(
			$rtfeldman$elm_css$Css$padding2,
			$rtfeldman$elm_css$Css$px(0),
			$rtfeldman$elm_css$Css$px(10)),
			A2(
			$rtfeldman$elm_css$Css$margin2,
			$rtfeldman$elm_css$Css$px(10),
			$rtfeldman$elm_css$Css$px(0))
		]),
	certIcon: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginBottom(
			$rtfeldman$elm_css$Css$px(30))
		]),
	certSubHeader: _List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Css$padding2,
			$rtfeldman$elm_css$Css$px(5),
			$rtfeldman$elm_css$Css$px(10)),
			$rtfeldman$elm_css$Css$marginBottom(
			$rtfeldman$elm_css$Css$px(10)),
			$rtfeldman$elm_css$Css$borderRadius(
			$rtfeldman$elm_css$Css$px(4)),
			$rtfeldman$elm_css$Css$backgroundColor($author$project$Material$Styled$Color$blueGrey100),
			$rtfeldman$elm_css$Css$fontWeight(
			$rtfeldman$elm_css$Css$int(500)),
			A2($rtfeldman$elm_css$Css$property, 'box-shadow', '0 0 0 1px rgba(63,63,68,0.05), 0 1px 3px 0 rgba(63,63,68,0.15)')
		]),
	certText: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$blueGrey600),
			$rtfeldman$elm_css$Css$overflowWrap($rtfeldman$elm_css$Css$breakWord)
		]),
	checkBoxDiv: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(8)),
			$rtfeldman$elm_css$Css$marginBottom(
			$rtfeldman$elm_css$Css$px(8)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100)),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(14)),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$blueGrey600),
			$rtfeldman$elm_css$Css$lineHeight(
			$rtfeldman$elm_css$Css$pct(160))
		]),
	checkboxMessage: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(300)),
			$rtfeldman$elm_css$Css$margin(
			$rtfeldman$elm_css$Css$px(10)),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(14))
		]),
	contentColumn: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			$rtfeldman$elm_css$Css$minWidth(
			$rtfeldman$elm_css$Css$px(200))
		]),
	create: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(20)),
			$rtfeldman$elm_css$Css$marginLeft(
			$rtfeldman$elm_css$Css$px(15)),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(50)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(50)),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(50)),
			A3(
			$rtfeldman$elm_css$Css$border3,
			$rtfeldman$elm_css$Css$px(1),
			$rtfeldman$elm_css$Css$solid,
			$author$project$Material$Styled$Color$blueA700),
			$rtfeldman$elm_css$Css$borderRadius(
			$rtfeldman$elm_css$Css$px(10)),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$blueA700),
			$rtfeldman$elm_css$Css$hover(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer)
				]))
		]),
	dashboardBtn: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(10)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(190))
		]),
	docDetailsSubTitle: _List_fromArray(
		[
			A4(
			$rtfeldman$elm_css$Css$margin4,
			$rtfeldman$elm_css$Css$px(5),
			$rtfeldman$elm_css$Css$px(5),
			$rtfeldman$elm_css$Css$px(5),
			$rtfeldman$elm_css$Css$px(0)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(150)),
			$rtfeldman$elm_css$Css$fontWeight(
			$rtfeldman$elm_css$Css$int(500))
		]),
	docInfoModal: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$margin(
			$rtfeldman$elm_css$Css$px(5)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(200))
		]),
	docStampBox: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$row),
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(10))
		]),
	docStampContent: _List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Css$margin2,
			$rtfeldman$elm_css$Css$px(10),
			$rtfeldman$elm_css$Css$zero),
			$rtfeldman$elm_css$Css$fontWeight(
			$rtfeldman$elm_css$Css$int(500)),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$em(1.2))
		]),
	docStampImage: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(60)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(120)),
			A2($rtfeldman$elm_css$Css$property, 'object-fit', 'contain'),
			A2($rtfeldman$elm_css$Css$property, 'box-shadow', '0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24)'),
			$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer),
			$author$project$Page$ViewDocument$Modal$selectedAnnotBorderColor,
			$rtfeldman$elm_css$Css$hover(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$backgroundColor(
					$rtfeldman$elm_css$Css$hex('f6f7f7'))
				]))
		]),
	docStampItem: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$fontSize($rtfeldman$elm_css$Css$initial)
		]),
	docStatusBtn: _List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Css$margin2,
			$rtfeldman$elm_css$Css$em(0.6),
			$rtfeldman$elm_css$Css$zero)
		]),
	docStatusContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$em(1.2))
		]),
	downloadBtnContent: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$margin(
			$rtfeldman$elm_css$Css$px(20)),
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceBetween),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center)
		]),
	errorBody: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(14)),
			$rtfeldman$elm_css$Css$fontWeight(
			$rtfeldman$elm_css$Css$int(400)),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$blueGrey500)
		]),
	footer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$row),
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceBetween),
			A3(
			$rtfeldman$elm_css$Css$padding3,
			$rtfeldman$elm_css$Css$px(20),
			$rtfeldman$elm_css$Css$zero,
			$rtfeldman$elm_css$Css$zero)
		]),
	header: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$row),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$flexStart),
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceBetween)
		]),
	headerName: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(20))
		]),
	icon: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$boxShadow($rtfeldman$elm_css$Css$none),
			$rtfeldman$elm_css$Css$transform(
			A2(
				$rtfeldman$elm_css$Css$translate2,
				$rtfeldman$elm_css$Css$px(20),
				$rtfeldman$elm_css$Css$px(-15))),
			$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer),
			$rtfeldman$elm_css$Css$padding(
			$rtfeldman$elm_css$Css$px(10))
		]),
	icon2: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$boxShadow($rtfeldman$elm_css$Css$none),
			$rtfeldman$elm_css$Css$transform(
			A2(
				$rtfeldman$elm_css$Css$translate2,
				$rtfeldman$elm_css$Css$px(20),
				$rtfeldman$elm_css$Css$px(-15))),
			$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer),
			$rtfeldman$elm_css$Css$padding(
			$rtfeldman$elm_css$Css$px(10)),
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(20))
		]),
	iconContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$padding(
			$rtfeldman$elm_css$Css$px(3)),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(11)),
			$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center)
		]),
	inputContainer: _List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Css$margin2,
			$rtfeldman$elm_css$Css$px(20),
			$rtfeldman$elm_css$Css$zero)
		]),
	messageContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$relative),
			$rtfeldman$elm_css$Css$bottom(
			$rtfeldman$elm_css$Css$px(60)),
			$rtfeldman$elm_css$Css$left(
			$rtfeldman$elm_css$Css$px(-130)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(0)),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(0))
		]),
	modalBody: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(12)),
			$rtfeldman$elm_css$Css$fontWeight(
			$rtfeldman$elm_css$Css$int(400)),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$blueGrey500)
		]),
	modalBodyContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$em(1))
		]),
	modalBtns: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$rowReverse),
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceBetween)
		]),
	modalContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$vw(80)),
			$rtfeldman$elm_css$Css$maxWidth(
			$rtfeldman$elm_css$Css$px(500))
		]),
	modalDownloadHeaderTxt: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(18)),
			$rtfeldman$elm_css$Css$fontWeight(
			$rtfeldman$elm_css$Css$int(500)),
			$rtfeldman$elm_css$Css$marginBottom(
			$rtfeldman$elm_css$Css$px(15))
		]),
	modalHeader: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$row),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$flexStart),
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceBetween)
		]),
	modalHeaderTxt: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(20)),
			$rtfeldman$elm_css$Css$fontWeight(
			$rtfeldman$elm_css$Css$int(500))
		]),
	myInfoImage: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(30)),
			A4(
			$rtfeldman$elm_css$Css$padding4,
			$rtfeldman$elm_css$Css$px(0),
			$rtfeldman$elm_css$Css$px(0),
			$rtfeldman$elm_css$Css$px(0),
			$rtfeldman$elm_css$Css$px(5))
		]),
	myInfoImageBlurred: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(30)),
			$rtfeldman$elm_css$Css$opacity(
			$rtfeldman$elm_css$Css$num(0.4)),
			A4(
			$rtfeldman$elm_css$Css$padding4,
			$rtfeldman$elm_css$Css$px(0),
			$rtfeldman$elm_css$Css$px(0),
			$rtfeldman$elm_css$Css$px(0),
			$rtfeldman$elm_css$Css$px(5))
		]),
	nameContent: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$row),
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceBetween),
			$rtfeldman$elm_css$Css$flexWrap($rtfeldman$elm_css$Css$wrap),
			$rtfeldman$elm_css$Css$marginLeft(
			$rtfeldman$elm_css$Css$px(10)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100))
		]),
	nameContentHeaderFont: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(18)),
			$rtfeldman$elm_css$Css$paddingBottom(
			$rtfeldman$elm_css$Css$px(2))
		]),
	nameContentSubContentFont: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(14)),
			$rtfeldman$elm_css$Css$paddingBottom(
			$rtfeldman$elm_css$Css$px(2))
		]),
	onHover: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$hover(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer),
					A2($rtfeldman$elm_css$Css$property, 'box-shadow', '0px 2px 4px -1px rgba(0,0,0,0.2), 0px 4px 5px 0px rgba(0,0,0,0.14), 0px 1px 10px 0px rgba(0,0,0,0.12)'),
					$rtfeldman$elm_css$Css$backgroundColor($author$project$Material$Styled$Color$grey200)
				]))
		]),
	optInText: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(14)),
			$rtfeldman$elm_css$Css$paddingBottom(
			$rtfeldman$elm_css$Css$px(10))
		]),
	overFlowText: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$overflow($rtfeldman$elm_css$Css$hidden),
			$rtfeldman$elm_css$Css$textOverflow($rtfeldman$elm_css$Css$ellipsis)
		]),
	ownerSignatureImg: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(50)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(125)),
			A2($rtfeldman$elm_css$Css$property, 'object-fit', 'contain'),
			A2($rtfeldman$elm_css$Css$property, 'box-shadow', '0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24)'),
			$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer),
			$author$project$Page$ViewDocument$Modal$selectedAnnotBorderColor,
			$rtfeldman$elm_css$Css$hover(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$backgroundColor(
					$rtfeldman$elm_css$Css$hex('f6f7f7'))
				]))
		]),
	passwordButtons: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(180)),
			$rtfeldman$elm_css$Css$margin(
			$rtfeldman$elm_css$Css$px(2))
		]),
	progressBar: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(10))
		]),
	retryContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer),
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(10))
		]),
	roleName: _List_fromArray(
		[
			A4(
			$rtfeldman$elm_css$Css$padding4,
			$rtfeldman$elm_css$Css$px(15),
			$rtfeldman$elm_css$Css$px(20),
			$rtfeldman$elm_css$Css$px(20),
			$rtfeldman$elm_css$Css$px(20))
		]),
	signBtn: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$maxWidth(
			$rtfeldman$elm_css$Css$px(100))
		]),
	signUpTxt: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(20)),
			$rtfeldman$elm_css$Css$paddingLeft(
			$rtfeldman$elm_css$Css$px(10))
		]),
	signature: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(100)),
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(15)),
			$rtfeldman$elm_css$Css$marginLeft(
			$rtfeldman$elm_css$Css$px(15))
		]),
	signatureImg: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(50)),
			$rtfeldman$elm_css$Css$minWidth(
			$rtfeldman$elm_css$Css$px(100)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(43)),
			A2($rtfeldman$elm_css$Css$property, 'object-fit', 'contain'),
			A2($rtfeldman$elm_css$Css$property, 'box-shadow', '0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24)'),
			$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer),
			$rtfeldman$elm_css$Css$hover(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$backgroundColor(
					$rtfeldman$elm_css$Css$hex('f6f7f7'))
				]))
		]),
	signatureImgBox: _List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Css$margin2,
			$rtfeldman$elm_css$Css$px(10),
			$rtfeldman$elm_css$Css$zero),
			$rtfeldman$elm_css$Css$fontWeight(
			$rtfeldman$elm_css$Css$int(500)),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$em(1.2))
		]),
	signatureListBox: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$row),
			$rtfeldman$elm_css$Css$flexWrap($rtfeldman$elm_css$Css$wrap),
			$rtfeldman$elm_css$Css$marginBottom(
			$rtfeldman$elm_css$Css$px(15))
		]),
	signingEventContent: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$margin(
			$rtfeldman$elm_css$Css$px(20))
		]),
	smallTxt: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(12)),
			$rtfeldman$elm_css$Css$fontWeight(
			$rtfeldman$elm_css$Css$int(400)),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$blueGrey500),
			$rtfeldman$elm_css$Css$padding(
			$rtfeldman$elm_css$Css$px(2))
		]),
	stamp: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(15)),
			$rtfeldman$elm_css$Css$marginLeft(
			$rtfeldman$elm_css$Css$px(15))
		]),
	stampImg: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(60)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(60)),
			A2($rtfeldman$elm_css$Css$property, 'object-fit', 'contain'),
			A2($rtfeldman$elm_css$Css$property, 'box-shadow', '0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24)'),
			$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer),
			$rtfeldman$elm_css$Css$hover(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$backgroundColor(
					$rtfeldman$elm_css$Css$hex('f6f7f7'))
				]))
		]),
	statusContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$row)
		]),
	subContent: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$paddingRight(
			$rtfeldman$elm_css$Css$px(10)),
			$rtfeldman$elm_css$Css$margin(
			$rtfeldman$elm_css$Css$px(20)),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(14)),
			A2(
			$rtfeldman$elm_css$Css$Media$withMediaQuery,
			_List_fromArray(
				['screen and (max-width: 400px)']),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$margin(
					$rtfeldman$elm_css$Css$px(5)),
					$rtfeldman$elm_css$Css$width(
					$rtfeldman$elm_css$Css$pct(100))
				]))
		]),
	subContentContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$row),
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceBetween),
			$rtfeldman$elm_css$Css$marginBottom(
			$rtfeldman$elm_css$Css$px(10)),
			$rtfeldman$elm_css$Css$flexWrap($rtfeldman$elm_css$Css$wrap)
		]),
	toolTip: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$backgroundColor($author$project$Material$Styled$Color$blueA400),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(160)),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(9)),
			$rtfeldman$elm_css$Css$padding(
			$rtfeldman$elm_css$Css$px(10)),
			$rtfeldman$elm_css$Css$borderRadius(
			$rtfeldman$elm_css$Css$px(10)),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$white),
			$rtfeldman$elm_css$Css$animationDuration(
			$rtfeldman$elm_css$Css$sec(0.3)),
			$rtfeldman$elm_css$Css$opacity(
			$rtfeldman$elm_css$Css$num(0.9))
		]),
	tooltipText: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(13))
		]),
	trustScoreIcon: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginRight(
			$rtfeldman$elm_css$Css$px(10)),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(20)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(20))
		]),
	verticalButton: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100)),
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(10))
		]),
	verticalfooter: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceBetween),
			A3(
			$rtfeldman$elm_css$Css$padding3,
			$rtfeldman$elm_css$Css$px(20),
			$rtfeldman$elm_css$Css$zero,
			$rtfeldman$elm_css$Css$zero)
		]),
	walletAddress: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$overflow($rtfeldman$elm_css$Css$hidden),
			$rtfeldman$elm_css$Css$textOverflow($rtfeldman$elm_css$Css$ellipsis),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(450)),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(14)),
			A4(
			$rtfeldman$elm_css$Css$padding4,
			$rtfeldman$elm_css$Css$px(10),
			$rtfeldman$elm_css$Css$px(0),
			$rtfeldman$elm_css$Css$px(10),
			$rtfeldman$elm_css$Css$px(0))
		]),
	walletContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$maxHeight(
			$rtfeldman$elm_css$Css$px(400)),
			$rtfeldman$elm_css$Css$overflow($rtfeldman$elm_css$Css$hidden)
		]),
	walletErrorText: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(14)),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$red500),
			$rtfeldman$elm_css$Css$displayFlex,
			A4(
			$rtfeldman$elm_css$Css$padding4,
			$rtfeldman$elm_css$Css$px(10),
			$rtfeldman$elm_css$Css$px(0),
			$rtfeldman$elm_css$Css$px(0),
			$rtfeldman$elm_css$Css$px(0))
		])
};
var $author$project$Page$ViewDocument$Modal$eSignatureLoadedModal = F3(
	function (user, status, isSignatureEmpty) {
		var userEdisclaimerAndSigntureList = (!user.eSignDisclaimer) && (!isSignatureEmpty);
		var updatedCheckBoxValue = _Utils_eq(status, $author$project$Type$ViewDocument$Accepted);
		var submitButton = function () {
			if (status.$ === 'Accepted') {
				return A2(
					$author$project$Material$Styled$Button$button,
					_List_fromArray(
						[
							$author$project$Material$Styled$Button$theme($author$project$Material$Styled$Button$blue),
							$author$project$Material$Styled$Button$styles($author$project$Page$ViewDocument$Modal$styles.passwordButtons),
							$author$project$Material$Styled$Button$onClick(
							$author$project$Types$OnViewDoc(
								$author$project$Type$ViewDocument$OnAuth(
									$author$project$Type$ViewDocument$OnLoaded($author$project$Type$ViewDocument$OnAcceptESignDisclaimerUserClick))))
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('Start Signing')
						]));
			} else {
				return A2(
					$author$project$Material$Styled$Button$button,
					_List_fromArray(
						[
							$author$project$Material$Styled$Button$theme($author$project$Material$Styled$Button$grey),
							$author$project$Material$Styled$Button$styles($author$project$Page$ViewDocument$Modal$styles.passwordButtons),
							$author$project$Material$Styled$Button$disabled(true)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('Start Signing')
						]));
			}
		}();
		return A2(
			$author$project$Material$Styled$Modal$modal,
			_List_fromArray(
				[
					$author$project$Material$Styled$Modal$open(userEdisclaimerAndSigntureList),
					$author$project$Material$Styled$Modal$contentContainerstyles($author$project$Page$ViewDocument$Modal$styles.modalContainer)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.modalHeader)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.modalHeaderTxt)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Review and Sign')
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_Utils_ap(
								$author$project$Page$ViewDocument$Modal$styles.modalBodyContainer,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$relative)
									])))
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.modalBody)
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.checkBoxDiv)
										]),
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$div,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.boldText)
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text('Click on every coloured field on the document to acknowledge acceptance. ')
												])),
											A2($rtfeldman$elm_css$Html$Styled$br, _List_Nil, _List_Nil),
											$rtfeldman$elm_css$Html$Styled$text('If you require any changes to the fields,' + ' kindly contact the Sender to revise and send a new document. ')
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.checkBoxDiv)
										]),
									_List_fromArray(
										[
											A2(
											$author$project$Material$Styled$Checkbox$checkbox,
											_List_fromArray(
												[
													$author$project$Material$Styled$Checkbox$onClick(
													$author$project$Types$OnViewDoc(
														$author$project$Type$ViewDocument$OnAuth(
															$author$project$Type$ViewDocument$OnLoaded($author$project$Type$ViewDocument$ToggleUserAcceptESignDisclaimer)))),
													$author$project$Material$Styled$Checkbox$checked(updatedCheckBoxValue)
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text('I agree to use electronic records and signatures.')
												]))
										]))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$a,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$href($author$project$Data$Route$routeUrl.dashboard),
									$rtfeldman$elm_css$Html$Styled$Attributes$css(
									_List_fromArray(
										[
											$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$absolute),
											$rtfeldman$elm_css$Css$bottom(
											$rtfeldman$elm_css$Css$px(0))
										]))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Exit')
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.modalBtns)
								]),
							_List_fromArray(
								[submitButton]))
						]))
				]));
	});
var $author$project$Type$ViewDocument$OnAcceptESignDisclaimerClick = function (a) {
	return {$: 'OnAcceptESignDisclaimerClick', a: a};
};
var $author$project$Type$ViewDocument$ToggleAcceptESignDisclaimer = {$: 'ToggleAcceptESignDisclaimer'};
var $author$project$Page$ViewDocument$Modal$eSignatureModal = F2(
	function (tokenOrDocId, status) {
		var updatedCheckBoxValue = function () {
			if (status.$ === 'Accepted') {
				return true;
			} else {
				return false;
			}
		}();
		var submitButton = function () {
			if (status.$ === 'Accepted') {
				return A2(
					$author$project$Material$Styled$Button$button,
					_List_fromArray(
						[
							$author$project$Material$Styled$Button$theme($author$project$Material$Styled$Button$blue),
							$author$project$Material$Styled$Button$styles($author$project$Page$ViewDocument$Modal$styles.passwordButtons),
							$author$project$Material$Styled$Button$onClick(
							$author$project$Types$OnViewDoc(
								$author$project$Type$ViewDocument$OnAuth(
									$author$project$Type$ViewDocument$OnAcceptESignDisclaimerClick(tokenOrDocId))))
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('Start Signing')
						]));
			} else {
				return A2(
					$author$project$Material$Styled$Button$button,
					_List_fromArray(
						[
							$author$project$Material$Styled$Button$theme($author$project$Material$Styled$Button$grey),
							$author$project$Material$Styled$Button$styles($author$project$Page$ViewDocument$Modal$styles.passwordButtons),
							$author$project$Material$Styled$Button$disabled(true)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('Start Signing')
						]));
			}
		}();
		return A2(
			$author$project$Material$Styled$Modal$modal,
			_List_fromArray(
				[
					$author$project$Material$Styled$Modal$open(true),
					$author$project$Material$Styled$Modal$contentContainerstyles($author$project$Page$ViewDocument$Modal$styles.modalContainer)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.modalHeader)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.modalHeaderTxt)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Review and Sign')
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_Utils_ap(
								$author$project$Page$ViewDocument$Modal$styles.modalBodyContainer,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$relative)
									])))
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.modalBody)
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.checkBoxDiv)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('Click on the respective fields on the document to acknowledge acceptance. '),
											A2($rtfeldman$elm_css$Html$Styled$br, _List_Nil, _List_Nil),
											$rtfeldman$elm_css$Html$Styled$text('If you require any changes to the fields,' + ' kindly contact the Sender to revise and send a new document. ')
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.checkBoxDiv)
										]),
									_List_fromArray(
										[
											A2(
											$author$project$Material$Styled$Checkbox$checkbox,
											_List_fromArray(
												[
													$author$project$Material$Styled$Checkbox$onClick(
													$author$project$Types$OnViewDoc(
														$author$project$Type$ViewDocument$OnAuth($author$project$Type$ViewDocument$ToggleAcceptESignDisclaimer))),
													$author$project$Material$Styled$Checkbox$checked(updatedCheckBoxValue)
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text('I agree to use electronic records and signatures.')
												]))
										]))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$a,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$href($author$project$Data$Route$routeUrl.dashboard),
									$rtfeldman$elm_css$Html$Styled$Attributes$css(
									_List_fromArray(
										[
											$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$absolute),
											$rtfeldman$elm_css$Css$bottom(
											$rtfeldman$elm_css$Css$px(0))
										]))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Exit')
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.modalBtns)
								]),
							_List_fromArray(
								[submitButton]))
						]))
				]));
	});
var $author$project$Data$Api$PDF$View$errorToString = function (error) {
	switch (error.$) {
		case 'INVALID_DOC_ID':
			return 'Document not found.';
		case 'DELETED_DOCUMENT':
			return 'This document has been deleted by the Sender. Please contact the Sender for more information.\u00A0';
		default:
			return 'Unauthorised user.';
	}
};
var $author$project$Material$Styled$Icon$FileDownload$view = F2(
	function (attributes, children) {
		return A2(
			$rtfeldman$elm_css$Svg$Styled$svg,
			_Utils_ap(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Svg$Styled$Attributes$fill('black'),
						$rtfeldman$elm_css$Svg$Styled$Attributes$width('36px'),
						$rtfeldman$elm_css$Svg$Styled$Attributes$height('36px'),
						$rtfeldman$elm_css$Svg$Styled$Attributes$viewBox('0 0 24 24')
					]),
				attributes),
			_Utils_ap(
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Svg$Styled$path,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Svg$Styled$Attributes$d('M0 0h24v24H0V0z'),
								$rtfeldman$elm_css$Svg$Styled$Attributes$fill('none')
							]),
						_List_Nil),
						A2(
						$rtfeldman$elm_css$Svg$Styled$path,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Svg$Styled$Attributes$d('M18,15v3H6v-3H4v3c0,1.1,0.9,2,2,2h12c1.1,0,2-0.9,2-2v-3H18z M17,11l-1.41-1.41L13,12.17V4h-2v8.17L8.41,9.59L7,11l5,5 L17,11z')
							]),
						_List_Nil)
					]),
				children));
	});
var $author$project$Material$Styled$Icon$fileDownload = $author$project$Material$Styled$Icon$FileDownload$view;
var $author$project$Type$ViewDocument$OnGenerateCredentialCheckBoxClick = function (a) {
	return {$: 'OnGenerateCredentialCheckBoxClick', a: a};
};
var $author$project$Page$ViewDocument$convertAnnotTypetoString = function (annotType) {
	switch (annotType.$) {
		case 'Name':
			return 'Name';
		case 'Date':
			return 'Date';
		case 'EditableText':
			return 'EditableText';
		case 'NonEditableText':
			return 'NonEditableText';
		case 'Stamp':
			return 'Stamp';
		case 'Signature':
			return 'Signature';
		case 'Email':
			return 'Email';
		default:
			return 'CheckBox';
	}
};
var $author$project$Page$ViewDocument$generateCredentialCheckBox = function (loadedModel) {
	var _v0 = loadedModel.payload;
	var annotations = _v0.annotations;
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_Nil,
		A2(
			$elm$core$List$indexedMap,
			F2(
				function (index, x) {
					var isChecked = A2(
						$elm$core$List$any,
						$elm$core$Basics$eq(index),
						loadedModel.selectAnnotationIndex);
					var annotationType = function () {
						var _v1 = x.type_;
						switch (_v1.$) {
							case 'EditableText':
								var result = _v1.a;
								return $author$project$Page$ViewDocument$convertAnnotTypetoString(x.type_) + (' - ' + result);
							case 'NonEditableText':
								var result = _v1.a;
								return $author$project$Page$ViewDocument$convertAnnotTypetoString(x.type_) + (' - ' + result);
							default:
								return $author$project$Page$ViewDocument$convertAnnotTypetoString(x.type_);
						}
					}();
					return A2(
						$author$project$Material$Styled$Checkbox$checkbox,
						_List_fromArray(
							[
								$author$project$Material$Styled$Checkbox$containerStyles($author$project$Page$ViewDocument$styles.signingOrderCheckBox),
								$author$project$Material$Styled$Checkbox$onClick(
								$author$project$Types$OnViewDoc(
									$author$project$Type$ViewDocument$OnAuth(
										$author$project$Type$ViewDocument$OnGenerateCredential(
											$author$project$Type$ViewDocument$OnGenerateCredentialCheckBoxClick(index))))),
								$author$project$Material$Styled$Checkbox$checked(isChecked)
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$h2,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$styles.credentialType)
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(annotationType)
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$span,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$styles.annotDetailsOwner)
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										' (' + (A2(
											$elm$core$Maybe$withDefault,
											'',
											$elm$core$List$head(
												A2($elm$core$String$split, '@', x.email))) + ')'))
									]))
							]));
				}),
			annotations));
};
var $author$project$Material$Styled$Icon$HelpCenter$view = F2(
	function (attributes, children) {
		return A2(
			$rtfeldman$elm_css$Svg$Styled$svg,
			_Utils_ap(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Svg$Styled$Attributes$fill('black'),
						$rtfeldman$elm_css$Svg$Styled$Attributes$width('36px'),
						$rtfeldman$elm_css$Svg$Styled$Attributes$height('36px'),
						$rtfeldman$elm_css$Svg$Styled$Attributes$viewBox('0 0 24 24')
					]),
				attributes),
			_Utils_ap(
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Svg$Styled$path,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Svg$Styled$Attributes$d('M0 0h24v24H0V0z'),
								$rtfeldman$elm_css$Svg$Styled$Attributes$fill('none')
							]),
						_List_Nil),
						A2(
						$rtfeldman$elm_css$Svg$Styled$path,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Svg$Styled$Attributes$d('M19 2H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h4l3 3 3-3h4c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 16h-4.83l-.59.59L12 20.17l-1.59-1.59-.58-.58H5V4h14v14zm-8-3h2v2h-2zm1-8c1.1 0 2 .9 2 2 0 2-3 1.75-3 5h2c0-2.25 3-2.5 3-5 0-2.21-1.79-4-4-4S8 6.79 8 9h2c0-1.1.9-2 2-2z')
							]),
						_List_Nil)
					]),
				children));
	});
var $author$project$Material$Styled$Icon$helpCenter = $author$project$Material$Styled$Icon$HelpCenter$view;
var $author$project$Material$Styled$Icon$Recipient$view = F2(
	function (attributes, children) {
		return A2(
			$rtfeldman$elm_css$Svg$Styled$svg,
			_Utils_ap(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Svg$Styled$Attributes$fill('black'),
						$rtfeldman$elm_css$Svg$Styled$Attributes$width('36px'),
						$rtfeldman$elm_css$Svg$Styled$Attributes$height('36px'),
						$rtfeldman$elm_css$Svg$Styled$Attributes$viewBox('0 0 24 24')
					]),
				attributes),
			_Utils_ap(
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Svg$Styled$path,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Svg$Styled$Attributes$d('M0 0h24v24H0V0z'),
								$rtfeldman$elm_css$Svg$Styled$Attributes$fill('none')
							]),
						_List_Nil),
						A2(
						$rtfeldman$elm_css$Svg$Styled$path,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Svg$Styled$Attributes$d('M4,13c1.1,0,2-0.9,2-2c0-1.1-0.9-2-2-2s-2,0.9-2,2C2,12.1,2.9,13,4,13z M5.13,14.1C4.76,14.04,4.39,14,4,14 c-0.99,0-1.93,0.21-2.78,0.58C0.48,14.9,0,15.62,0,16.43V18l4.5,0v-1.61C4.5,15.56,4.73,14.78,5.13,14.1z M20,13c1.1,0,2-0.9,2-2 c0-1.1-0.9-2-2-2s-2,0.9-2,2C18,12.1,18.9,13,20,13z M24,16.43c0-0.81-0.48-1.53-1.22-1.85C21.93,14.21,20.99,14,20,14 c-0.39,0-0.76,0.04-1.13,0.1c0.4,0.68,0.63,1.46,0.63,2.29V18l4.5,0V16.43z M16.24,13.65c-1.17-0.52-2.61-0.9-4.24-0.9 c-1.63,0-3.07,0.39-4.24,0.9C6.68,14.13,6,15.21,6,16.39V18h12v-1.61C18,15.21,17.32,14.13,16.24,13.65z M8.07,16 c0.09-0.23,0.13-0.39,0.91-0.69c0.97-0.38,1.99-0.56,3.02-0.56s2.05,0.18,3.02,0.56c0.77,0.3,0.81,0.46,0.91,0.69H8.07z M12,8 c0.55,0,1,0.45,1,1s-0.45,1-1,1s-1-0.45-1-1S11.45,8,12,8 M12,6c-1.66,0-3,1.34-3,3c0,1.66,1.34,3,3,3s3-1.34,3-3 C15,7.34,13.66,6,12,6L12,6z')
							]),
						_List_Nil)
					]),
				children));
	});
var $author$project$Material$Styled$Icon$recipient = $author$project$Material$Styled$Icon$Recipient$view;
var $author$project$Material$Styled$Icon$Signature$view = F2(
	function (attributes, children) {
		return A2(
			$rtfeldman$elm_css$Svg$Styled$svg,
			_Utils_ap(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Svg$Styled$Attributes$fill('black'),
						$rtfeldman$elm_css$Svg$Styled$Attributes$width('36px'),
						$rtfeldman$elm_css$Svg$Styled$Attributes$height('36px'),
						$rtfeldman$elm_css$Svg$Styled$Attributes$viewBox('0 0 24 24')
					]),
				attributes),
			_Utils_ap(
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Svg$Styled$path,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Svg$Styled$Attributes$d('M0 0h24v24H0V0z'),
								$rtfeldman$elm_css$Svg$Styled$Attributes$fill('none')
							]),
						_List_Nil),
						A2(
						$rtfeldman$elm_css$Svg$Styled$path,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Svg$Styled$Attributes$d('M4.59 6.89c.7-.71 1.4-1.35 1.71-1.22.5.2 0 1.03-.3 1.52-.25.42-2.86 3.89-2.86 6.31 0 1.28.48 2.34 1.34 2.98.75.56 1.74.73 2.64.46 1.07-.31 1.95-1.4 3.06-2.77 1.21-1.49 2.83-3.44 4.08-3.44 1.63 0 1.65 1.01 1.76 1.79-3.78.64-5.38 3.67-5.38 5.37 0 1.7 1.44 3.09 3.21 3.09 1.63 0 4.29-1.33 4.69-6.1H21v-2.5h-2.47c-.15-1.65-1.09-4.2-4.03-4.2-2.25 0-4.18 1.91-4.94 2.84-.58.73-2.06 2.48-2.29 2.72-.25.3-.68.84-1.11.84-.45 0-.72-.83-.36-1.92.35-1.09 1.4-2.86 1.85-3.52.78-1.14 1.3-1.92 1.3-3.28C8.95 3.69 7.31 3 6.44 3 5.12 3 3.97 4 3.72 4.25c-.36.36-.66.66-.88.93l1.75 1.71zm9.29 11.66c-.31 0-.74-.26-.74-.72 0-.6.73-2.2 2.87-2.76-.3 2.69-1.43 3.48-2.13 3.48z')
							]),
						_List_Nil)
					]),
				children));
	});
var $author$project$Material$Styled$Icon$signature = $author$project$Material$Styled$Icon$Signature$view;
var $author$project$Material$Styled$Snackbar$mergeStyles2 = function (config) {
	var defaultStyle = A2($author$project$Material$Styled$Snackbar$style, config.theme, config.timeout);
	var updatedStyle = _Utils_update(
		defaultStyle,
		{
			container: _Utils_ap(defaultStyle.container2, config.containerStyles),
			content: _Utils_ap(defaultStyle.content, config.contentStyles)
		});
	return _Utils_update(
		config,
		{
			containerStyles: updatedStyle.container2,
			contentStyles: updatedStyle.content,
			snackbarAttributes: A2(
				$elm$core$List$cons,
				$rtfeldman$elm_css$Html$Styled$Attributes$css(updatedStyle.container2),
				config.snackbarAttributes)
		});
};
var $author$project$Material$Styled$Snackbar$mergeConfig2 = F2(
	function (defaultConfig_, properties) {
		return $author$project$Material$Styled$Snackbar$mergeStyles2(
			A3($elm$core$List$foldl, $author$project$Material$Styled$Snackbar$updateProperty, defaultConfig_, properties));
	});
var $author$project$Material$Styled$Snackbar$snackbarViewDoc = F2(
	function (properties, children) {
		var config = A2($author$project$Material$Styled$Snackbar$mergeConfig2, $author$project$Material$Styled$Snackbar$defaultConfig, properties);
		var _v0 = config.status;
		if (_v0.$ === 'Show') {
			return A2(
				$rtfeldman$elm_css$Html$Styled$div,
				config.snackbarAttributes,
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css(config.contentStyles)
							]),
						children)
					]));
		} else {
			return $rtfeldman$elm_css$Html$Styled$text('');
		}
	});
var $author$project$Page$ViewDocument$submitBtn = F2(
	function (loadedModel, model) {
		var viewDocumentPageLanguageData = model.languageSwitchModel.allLanguageData.location.viewDocumentPage;
		var _v0 = $author$project$Data$PDF$status(loadedModel.pdf);
		switch (_v0.$) {
			case 'Signing':
				return A2(
					$author$project$Material$Styled$Button$button,
					_List_fromArray(
						[
							$author$project$Material$Styled$Button$theme($author$project$Material$Styled$Button$green),
							$author$project$Material$Styled$Button$styles($author$project$Page$ViewDocument$styles.optionBtn),
							$author$project$Material$Styled$Button$onClick(
							$author$project$Types$OnViewDoc(
								$author$project$Type$ViewDocument$OnAuth(
									$author$project$Type$ViewDocument$OnLoaded($author$project$Type$ViewDocument$OnDocSubmit))))
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(viewDocumentPageLanguageData.submit)
						]));
			case 'Viewing':
				return $rtfeldman$elm_css$Html$Styled$text('');
			case 'Completed':
				return $rtfeldman$elm_css$Html$Styled$text('');
			case 'Expired':
				return $rtfeldman$elm_css$Html$Styled$text('');
			default:
				return $rtfeldman$elm_css$Html$Styled$text('');
		}
	});
var $author$project$Type$ViewDocument$FirstName = {$: 'FirstName'};
var $author$project$Type$ViewDocument$LastName = {$: 'LastName'};
var $author$project$Type$ViewDocument$OnNameFieldBlur = {$: 'OnNameFieldBlur'};
var $author$project$Type$ViewDocument$OnNameInput = F2(
	function (a, b) {
		return {$: 'OnNameInput', a: a, b: b};
	});
var $author$project$Type$ViewDocument$OnNameSubmit = function (a) {
	return {$: 'OnNameSubmit', a: a};
};
var $author$project$Page$ViewDocument$Modal$setSubmitButton = F2(
	function (firstNameError, lastNameError) {
		return (_Utils_eq(firstNameError, $elm$core$Maybe$Nothing) && _Utils_eq(lastNameError, $elm$core$Maybe$Nothing)) ? A2(
			$author$project$Material$Styled$Button$button,
			_List_fromArray(
				[
					$author$project$Material$Styled$Button$theme($author$project$Material$Styled$Button$blue),
					$author$project$Material$Styled$Button$styles($author$project$Page$ViewDocument$Modal$styles.passwordButtons),
					$author$project$Material$Styled$Button$disabled(false)
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text('Save')
				])) : A2(
			$author$project$Material$Styled$Button$button,
			_List_fromArray(
				[
					$author$project$Material$Styled$Button$theme($author$project$Material$Styled$Button$grey),
					$author$project$Material$Styled$Button$styles($author$project$Page$ViewDocument$Modal$styles.passwordButtons),
					$author$project$Material$Styled$Button$disabled(true)
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text('Save')
				]));
	});
var $author$project$Page$ViewDocument$Modal$updateFirstNameLastNameModal = F2(
	function (docID, updateNameModel) {
		var _v0 = updateNameModel;
		var firstNameInput = _v0.firstNameInput;
		var lastNameInput = _v0.lastNameInput;
		var firstNameError = _v0.firstNameError;
		var lastNameError = _v0.lastNameError;
		var modalOpen = _v0.modalOpen;
		return A2(
			$author$project$Material$Styled$Modal$modal,
			_List_fromArray(
				[
					$author$project$Material$Styled$Modal$open(modalOpen),
					$author$project$Material$Styled$Modal$contentContainerstyles($author$project$Page$ViewDocument$Modal$styles.modalContainer)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.modalHeader)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.modalHeaderTxt)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Confirm First name and Last Name')
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.modalBody)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Please confirm your first name and last name as a signer. You will only need to do this once.')
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$form,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Events$onSubmit(
							$author$project$Types$OnViewDoc(
								$author$project$Type$ViewDocument$OnAuth(
									$author$project$Type$ViewDocument$OnNameSubmit(docID))))
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Material$Styled$Input$text,
							_List_fromArray(
								[
									$author$project$Material$Styled$Input$containerStyles($author$project$Page$ViewDocument$Modal$styles.inputContainer),
									$author$project$Material$Styled$Input$label('First Name'),
									$author$project$Material$Styled$Input$value(firstNameInput),
									$author$project$Material$Styled$Input$errorMessage(firstNameError),
									$author$project$Material$Styled$Input$onInput(
									A2(
										$elm$core$Basics$composeL,
										A2($elm$core$Basics$composeL, $author$project$Types$OnViewDoc, $author$project$Type$ViewDocument$OnAuth),
										$author$project$Type$ViewDocument$OnNameInput($author$project$Type$ViewDocument$FirstName))),
									$author$project$Material$Styled$Input$onBlur(
									$author$project$Types$OnViewDoc(
										$author$project$Type$ViewDocument$OnAuth($author$project$Type$ViewDocument$OnNameFieldBlur)))
								]),
							_List_Nil),
							A2(
							$author$project$Material$Styled$Input$text,
							_List_fromArray(
								[
									$author$project$Material$Styled$Input$containerStyles($author$project$Page$ViewDocument$Modal$styles.inputContainer),
									$author$project$Material$Styled$Input$label('Last Name'),
									$author$project$Material$Styled$Input$value(lastNameInput),
									$author$project$Material$Styled$Input$errorMessage(lastNameError),
									$author$project$Material$Styled$Input$onInput(
									A2(
										$elm$core$Basics$composeL,
										A2($elm$core$Basics$composeL, $author$project$Types$OnViewDoc, $author$project$Type$ViewDocument$OnAuth),
										$author$project$Type$ViewDocument$OnNameInput($author$project$Type$ViewDocument$LastName))),
									$author$project$Material$Styled$Input$onBlur(
									$author$project$Types$OnViewDoc(
										$author$project$Type$ViewDocument$OnAuth($author$project$Type$ViewDocument$OnNameFieldBlur)))
								]),
							_List_Nil),
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.modalBtns)
								]),
							_List_fromArray(
								[
									A2($author$project$Page$ViewDocument$Modal$setSubmitButton, firstNameError, lastNameError)
								]))
						]))
				]));
	});
var $author$project$Type$ViewDocument$Certificate = {$: 'Certificate'};
var $author$project$Type$ViewDocument$OnDownload = {$: 'OnDownload'};
var $author$project$Type$ViewDocument$OnDownloadCert = {$: 'OnDownloadCert'};
var $author$project$Type$ViewDocument$RetryNotarisation = {$: 'RetryNotarisation'};
var $author$project$Type$ViewDocument$ShowLog = {$: 'ShowLog'};
var $author$project$Type$ViewDocument$DeleteDocumentClick = {$: 'DeleteDocumentClick'};
var $author$project$Page$ViewDocument$deleteDocumentBtn = F3(
	function (loadedModel, user, model) {
		var viewDocumentPageLanguageData = model.languageSwitchModel.allLanguageData.location.viewDocumentPage;
		var currentUser = user.id;
		var _v0 = loadedModel;
		var pdf = _v0.pdf;
		var _v1 = loadedModel.payload;
		var document = _v1.document;
		var ownerName = document.ownerId;
		return (_Utils_eq(ownerName, currentUser) && (!_Utils_eq(
			$author$project$Data$PDF$notarisationStatus(pdf),
			$elm$core$Maybe$Just($author$project$Data$PDF$Pending)))) ? A2(
			$author$project$Material$Styled$Button$button,
			_List_fromArray(
				[
					$author$project$Material$Styled$Button$styles($author$project$Page$ViewDocument$styles.docStatusBtn),
					$author$project$Material$Styled$Button$theme($author$project$Material$Styled$Button$default),
					$author$project$Material$Styled$Button$onClick(
					$author$project$Types$OnViewDoc(
						$author$project$Type$ViewDocument$OnAuth(
							$author$project$Type$ViewDocument$OnLoaded($author$project$Type$ViewDocument$DeleteDocumentClick))))
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text(viewDocumentPageLanguageData.deleteDocument)
				])) : $rtfeldman$elm_css$Html$Styled$text('');
	});
var $author$project$Data$PDF$docUpdatedAt = function (_v0) {
	var pdf = _v0.a;
	return pdf.updatedAt;
};
var $author$project$Page$ViewDocument$downloadWrappedDocument = function (_v0) {
	return $rtfeldman$elm_css$Html$Styled$text('');
};
var $author$project$Type$ViewDocument$OnGenerateCredentialClick = {$: 'OnGenerateCredentialClick'};
var $author$project$Page$ViewDocument$generateCredentialBtn = function (loadedModel) {
	var _v0 = loadedModel;
	var pdf = _v0.pdf;
	var notarisationNetwork = $author$project$Page$ViewDocument$convertStringToNetwork(
		A2(
			$elm$core$Maybe$withDefault,
			'',
			$author$project$Data$PDF$notarisationNetwork(pdf)));
	return (_Utils_eq(
		$author$project$Data$PDF$notarisationStatus(pdf),
		$elm$core$Maybe$Just($author$project$Data$PDF$Complete)) && _Utils_eq(notarisationNetwork, $author$project$Type$ViewDocument$Binance)) ? A2(
		$author$project$Material$Styled$Button$button,
		_List_fromArray(
			[
				$author$project$Material$Styled$Button$styles($author$project$Page$ViewDocument$styles.docStatusBtn),
				$author$project$Material$Styled$Button$theme($author$project$Material$Styled$Button$default),
				$author$project$Material$Styled$Button$onClick(
				$author$project$Types$OnViewDoc(
					$author$project$Type$ViewDocument$OnAuth(
						$author$project$Type$ViewDocument$OnLoaded($author$project$Type$ViewDocument$OnGenerateCredentialClick))))
			]),
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$text('Generate Credential')
			])) : $rtfeldman$elm_css$Html$Styled$text('');
};
var $author$project$Type$ViewDocument$OnGetNotarisationPoints = {$: 'OnGetNotarisationPoints'};
var $author$project$Page$ViewDocument$notariseDocumentBtn = F2(
	function (loadedModel, model) {
		var viewDocumentPageLanguageData = model.languageSwitchModel.allLanguageData.location.viewDocumentPage;
		var _v0 = loadedModel;
		var pdf = _v0.pdf;
		return ((!$author$project$Data$PDF$requireNotarisation(pdf)) && loadedModel.displayViewer) ? A2(
			$author$project$Material$Styled$Button$button,
			_List_fromArray(
				[
					$author$project$Material$Styled$Button$styles($author$project$Page$ViewDocument$styles.docStatusBtn),
					$author$project$Material$Styled$Button$theme($author$project$Material$Styled$Button$blue),
					$author$project$Material$Styled$Button$onClick(
					$author$project$Types$OnViewDoc(
						$author$project$Type$ViewDocument$OnAuth(
							$author$project$Type$ViewDocument$OnLoaded($author$project$Type$ViewDocument$OnGetNotarisationPoints))))
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text(viewDocumentPageLanguageData.notariseDocument)
				])) : $rtfeldman$elm_css$Html$Styled$text('');
	});
var $author$project$Page$ViewDocument$recipientsAndDocSecurity = function (model) {
	var viewDocumentPageLanguageData = model.languageSwitchModel.allLanguageData.location.viewDocumentPage;
	return A2(
		$rtfeldman$elm_css$Html$Styled$span,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Material$Styled$Button$button,
				_List_fromArray(
					[
						$author$project$Material$Styled$Button$styles($author$project$Page$ViewDocument$styles.docStatusBtn),
						$author$project$Material$Styled$Button$theme($author$project$Material$Styled$Button$default),
						$author$project$Material$Styled$Button$onClick(
						$author$project$Types$OnViewDoc(
							$author$project$Type$ViewDocument$OnAuth(
								$author$project$Type$ViewDocument$OnLoaded(
									$author$project$Type$ViewDocument$OnShowModal($author$project$Type$ViewDocument$Recipient)))))
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(viewDocumentPageLanguageData.recipients)
					]))
			]));
};
var $author$project$Type$ViewDocument$OnListCredentials = {$: 'OnListCredentials'};
var $author$project$Page$ViewDocument$viewCredentialBtn = function (loadedModel) {
	var _v0 = loadedModel;
	var pdf = _v0.pdf;
	var notarisationNetwork = $author$project$Page$ViewDocument$convertStringToNetwork(
		A2(
			$elm$core$Maybe$withDefault,
			'',
			$author$project$Data$PDF$notarisationNetwork(pdf)));
	return (_Utils_eq(
		$author$project$Data$PDF$notarisationStatus(pdf),
		$elm$core$Maybe$Just($author$project$Data$PDF$Complete)) && _Utils_eq(notarisationNetwork, $author$project$Type$ViewDocument$Binance)) ? A2(
		$author$project$Material$Styled$Button$button,
		_List_fromArray(
			[
				$author$project$Material$Styled$Button$styles($author$project$Page$ViewDocument$styles.docStatusBtn),
				$author$project$Material$Styled$Button$theme($author$project$Material$Styled$Button$default),
				$author$project$Material$Styled$Button$onClick(
				$author$project$Types$OnViewDoc(
					$author$project$Type$ViewDocument$OnAuth(
						$author$project$Type$ViewDocument$OnLoaded($author$project$Type$ViewDocument$OnListCredentials))))
			]),
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$text('View Credentials')
			])) : $rtfeldman$elm_css$Html$Styled$text('');
};
var $author$project$Type$ViewDocument$OnListSigningEvents = {$: 'OnListSigningEvents'};
var $author$project$Page$ViewDocument$viewSigningEventBtn = F2(
	function (loadedModel, model) {
		var viewDocumentPageLanguageData = model.languageSwitchModel.allLanguageData.location.viewDocumentPage;
		var _v0 = loadedModel;
		var pdf = _v0.pdf;
		var notarisationNetwork = $author$project$Page$ViewDocument$convertStringToNetwork(
			A2(
				$elm$core$Maybe$withDefault,
				'',
				$author$project$Data$PDF$notarisationNetwork(pdf)));
		return _Utils_eq(notarisationNetwork, $author$project$Type$ViewDocument$Algorand) ? A2(
			$author$project$Material$Styled$Button$button,
			_List_fromArray(
				[
					$author$project$Material$Styled$Button$styles($author$project$Page$ViewDocument$styles.docStatusBtn),
					$author$project$Material$Styled$Button$theme($author$project$Material$Styled$Button$default),
					$author$project$Material$Styled$Button$onClick(
					$author$project$Types$OnViewDoc(
						$author$project$Type$ViewDocument$OnAuth(
							$author$project$Type$ViewDocument$OnLoaded($author$project$Type$ViewDocument$OnListSigningEvents))))
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text(viewDocumentPageLanguageData.viewSigningEvents)
				])) : $rtfeldman$elm_css$Html$Styled$text('');
	});
var $author$project$Page$ViewDocument$completedStatusContent = F4(
	function (appModel, status, loadedModel, user) {
		var viewDocumentPageLanguageData = appModel.languageSwitchModel.allLanguageData.location.viewDocumentPage;
		var timeNow = $elm$time$Time$posixToMillis(appModel.currentTime);
		var _v0 = loadedModel;
		var pdf = _v0.pdf;
		var docCompletionTime = $elm$time$Time$posixToMillis(
			$author$project$Data$PDF$docUpdatedAt(pdf));
		var has2minPassedSinceCompletion = _Utils_cmp(timeNow, docCompletionTime + 120000) > -1;
		var notarisationNetwork = $author$project$Page$ViewDocument$convertStringToNetwork(
			A2(
				$elm$core$Maybe$withDefault,
				'',
				$author$project$Data$PDF$notarisationNetwork(pdf)));
		var notarisationStatus = $author$project$Data$PDF$notarisationStatus(pdf);
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$styles.docStatusContainer)
				]),
			_List_fromArray(
				[
					function () {
					if (status.$ === 'Downloading') {
						return A2($author$project$Material$Styled$ProgressBar$linear, _List_Nil, _List_Nil);
					} else {
						return $rtfeldman$elm_css$Html$Styled$text('');
					}
				}(),
					(user.showAds && ($elm$core$List$length(
					$author$project$Data$Domain$all(user.domains)) === 1)) ? A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$id('viewDocAdsContent')
						]),
					_List_Nil) : $rtfeldman$elm_css$Html$Styled$text(''),
					(_Utils_eq(notarisationNetwork, $author$project$Type$ViewDocument$Algorand) && (has2minPassedSinceCompletion && _Utils_eq(
					notarisationStatus,
					$elm$core$Maybe$Just($author$project$Data$PDF$Pending)))) ? A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Material$Styled$Button$button,
							_List_fromArray(
								[
									$author$project$Material$Styled$Button$styles($author$project$Page$ViewDocument$styles.retryNotariseBtn),
									$author$project$Material$Styled$Button$theme($author$project$Material$Styled$Button$default),
									$author$project$Material$Styled$Button$onClick(
									$author$project$Types$OnViewDoc(
										$author$project$Type$ViewDocument$OnAuth(
											$author$project$Type$ViewDocument$OnLoaded(
												$author$project$Type$ViewDocument$OnShowModal($author$project$Type$ViewDocument$RetryNotarisation)))))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Retry Notarisation ')
								]))
						])) : $rtfeldman$elm_css$Html$Styled$text(''),
					loadedModel.displayViewer ? A2(
					$author$project$Material$Styled$Button$button,
					_List_fromArray(
						[
							$author$project$Material$Styled$Button$styles($author$project$Page$ViewDocument$styles.docStatusBtn),
							$author$project$Material$Styled$Button$theme($author$project$Material$Styled$Button$blue),
							$author$project$Material$Styled$Button$onClick(
							$author$project$Types$OnViewDoc(
								$author$project$Type$ViewDocument$OnAuth(
									$author$project$Type$ViewDocument$OnLoaded($author$project$Type$ViewDocument$OnDownload))))
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(viewDocumentPageLanguageData.downloadDocument)
						])) : $rtfeldman$elm_css$Html$Styled$text(''),
					$author$project$Page$ViewDocument$recipientsAndDocSecurity(appModel),
					A2(
					$author$project$Material$Styled$Button$button,
					_List_fromArray(
						[
							$author$project$Material$Styled$Button$styles($author$project$Page$ViewDocument$styles.docStatusBtn),
							$author$project$Material$Styled$Button$theme($author$project$Material$Styled$Button$default),
							$author$project$Material$Styled$Button$onClick(
							$author$project$Types$OnViewDoc(
								$author$project$Type$ViewDocument$OnAuth(
									$author$project$Type$ViewDocument$OnLoaded(
										$author$project$Type$ViewDocument$OnShowModal($author$project$Type$ViewDocument$Certificate)))))
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(viewDocumentPageLanguageData.viewCertificate)
						])),
					A2(
					$author$project$Material$Styled$Button$button,
					_List_fromArray(
						[
							$author$project$Material$Styled$Button$styles($author$project$Page$ViewDocument$styles.docStatusBtn),
							$author$project$Material$Styled$Button$theme($author$project$Material$Styled$Button$default),
							$author$project$Material$Styled$Button$onClick(
							$author$project$Types$OnViewDoc(
								$author$project$Type$ViewDocument$OnAuth(
									$author$project$Type$ViewDocument$OnLoaded($author$project$Type$ViewDocument$OnDownloadCert))))
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(viewDocumentPageLanguageData.downloadCertificate)
						])),
					A2(
					$author$project$Material$Styled$Button$button,
					_List_fromArray(
						[
							$author$project$Material$Styled$Button$styles($author$project$Page$ViewDocument$styles.docStatusBtn),
							$author$project$Material$Styled$Button$theme($author$project$Material$Styled$Button$default),
							$author$project$Material$Styled$Button$onClick(
							$author$project$Types$OnViewDoc(
								$author$project$Type$ViewDocument$OnAuth(
									$author$project$Type$ViewDocument$OnLoaded(
										$author$project$Type$ViewDocument$OnShowModal($author$project$Type$ViewDocument$ShowLog)))))
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(viewDocumentPageLanguageData.activities)
						])),
					$author$project$Page$ViewDocument$downloadWrappedDocument(pdf),
					A3($author$project$Page$ViewDocument$deleteDocumentBtn, loadedModel, user, appModel),
					A2($author$project$Page$ViewDocument$notariseDocumentBtn, loadedModel, appModel),
					$author$project$Page$ViewDocument$generateCredentialBtn(loadedModel),
					$author$project$Page$ViewDocument$viewCredentialBtn(loadedModel),
					A2($author$project$Page$ViewDocument$viewSigningEventBtn, loadedModel, appModel)
				]));
	});
var $author$project$Data$Api$PDF$View$hasOwnerVerifiedSig = F2(
	function (ownerId, payload) {
		return _Utils_eq(payload.document.ownerId, ownerId) ? A2(
			$elm$core$List$any,
			function (annot) {
				if (annot.isVerified && _Utils_eq(annot.userId, ownerId)) {
					var _v0 = annot.type_;
					switch (_v0.$) {
						case 'Signature':
							return true;
						case 'Name':
							return false;
						case 'Date':
							return false;
						case 'EditableText':
							return false;
						case 'NonEditableText':
							return false;
						case 'Stamp':
							return false;
						case 'Email':
							return false;
						default:
							return false;
					}
				} else {
					return false;
				}
			},
			payload.annotations) : false;
	});
var $author$project$Data$Api$PDF$View$hasOwnerVerifiedStamp = F2(
	function (ownerId, payload) {
		return _Utils_eq(payload.document.ownerId, ownerId) ? A2(
			$elm$core$List$any,
			function (annot) {
				if (annot.isVerified && _Utils_eq(annot.userId, ownerId)) {
					var _v0 = annot.type_;
					switch (_v0.$) {
						case 'Signature':
							return false;
						case 'Name':
							return false;
						case 'Date':
							return false;
						case 'EditableText':
							return false;
						case 'NonEditableText':
							return false;
						case 'Stamp':
							return true;
						case 'Email':
							return false;
						default:
							return false;
					}
				} else {
					return false;
				}
			},
			payload.annotations) : false;
	});
var $author$project$Type$ViewDocument$OnSignatureClick = function (a) {
	return {$: 'OnSignatureClick', a: a};
};
var $author$project$Page$ViewDocument$ownerVerifiedSignatureBox = F2(
	function (dataSig, model) {
		var viewDocumentPageLanguageData = model.languageSwitchModel.allLanguageData.location.viewDocumentPage;
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$styles.signatureImgBox)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('Your Signature'),
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$styles.signature)
								]),
							_List_Nil),
							A2(
							$rtfeldman$elm_css$Html$Styled$img,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$src(
									$author$project$Data$PDF$Signature$data(dataSig)),
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$styles.ownerSignatureImg),
									$rtfeldman$elm_css$Html$Styled$Events$onClick(
									$author$project$Types$OnViewDoc(
										$author$project$Type$ViewDocument$OnAuth(
											$author$project$Type$ViewDocument$OnLoaded(
												$author$project$Type$ViewDocument$OnSignatureClick(dataSig)))))
								]),
							_List_Nil)
						]))
				]));
	});
var $author$project$Type$ViewDocument$OnStampClick = function (a) {
	return {$: 'OnStampClick', a: a};
};
var $author$project$Page$ViewDocument$ownerVerifiedStampBox = function (dataStamp) {
	var selectedStamp = function () {
		var _v0 = $author$project$Data$PDF$Stamp$data(dataStamp);
		if (_v0.$ === 'NotLoaded') {
			return $rtfeldman$elm_css$Html$Styled$text('Loading...');
		} else {
			var data = _v0.a;
			return A2(
				$rtfeldman$elm_css$Html$Styled$img,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$src(data),
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$styles.docStampImage),
						$rtfeldman$elm_css$Html$Styled$Events$onClick(
						$author$project$Types$OnViewDoc(
							$author$project$Type$ViewDocument$OnAuth(
								$author$project$Type$ViewDocument$OnLoaded(
									$author$project$Type$ViewDocument$OnStampClick(dataStamp)))))
					]),
				_List_Nil);
		}
	}();
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$styles.docStampContent)
			]),
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$text('Your Stamp'),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$styles.docStampBox)
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$styles.docStampItem)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$Data$PDF$Stamp$name(dataStamp)),
								selectedStamp
							]))
					]))
			]));
};
var $author$project$Page$ViewDocument$signatureError = function (error) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$styles.retryContainer),
				$rtfeldman$elm_css$Html$Styled$Events$onClick(
				$author$project$Types$OnSignature($author$project$Type$Signature$ReloadList))
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$span,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(error)
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$img,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$src($author$project$View$Theme$images.retry)
					]),
				_List_Nil)
			]));
};
var $author$project$Page$ViewDocument$signatureImgStyle = F2(
	function (signature, loadedModel) {
		var _v0 = loadedModel.selectedSignature;
		if (_v0.$ === 'Nothing') {
			return $author$project$Page$ViewDocument$styles.signatureImg;
		} else {
			var selectedSig = _v0.a;
			return _Utils_eq(
				$author$project$Data$PDF$Signature$id(selectedSig),
				signature.id) ? _Utils_ap(
				$author$project$Page$ViewDocument$styles.signatureImg,
				_List_fromArray(
					[$author$project$Page$ViewDocument$selectedAnnotBorderColor])) : $author$project$Page$ViewDocument$styles.signatureImg;
		}
	});
var $author$project$Page$ViewDocument$renderSignature = F2(
	function (loadedModel, signature) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$span,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$styles.signature)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$img,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$src(signature.data),
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							A2($author$project$Page$ViewDocument$signatureImgStyle, signature, loadedModel)),
							$rtfeldman$elm_css$Html$Styled$Events$onClick(
							$author$project$Types$OnViewDoc(
								$author$project$Type$ViewDocument$OnAuth(
									$author$project$Type$ViewDocument$OnLoaded(
										$author$project$Type$ViewDocument$OnSignatureClick(
											A3($author$project$Data$PDF$Signature$create, signature.id, signature.name, signature.data))))))
						]),
					_List_Nil)
				]));
	});
var $author$project$Page$ViewDocument$signatureList = F2(
	function (signatureModel, loadedModel) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$styles.signatureListBox)
				]),
			_Utils_ap(
				A2(
					$elm$core$List$map,
					$author$project$Page$ViewDocument$renderSignature(loadedModel),
					signatureModel.signatures),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$styles.create),
								$rtfeldman$elm_css$Html$Styled$Events$onClick(
								$author$project$Types$OnSignature($author$project$Type$Signature$OnOpen)),
								A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'data-test', 'signature')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('+')
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$styles.checkboxMessage)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('Note: If you have an assigned checkbox field, please view this document via desktop or laptop. We are working hard on enabling mobile support')
							]))
					])));
	});
var $author$project$Page$ViewDocument$signatureBox = F3(
	function (signatureModel, loadedModel, model) {
		var viewDocumentPageLanguageData = model.languageSwitchModel.allLanguageData.location.viewDocumentPage;
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'data-test', 'Your Signatures')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$styles.signatureImgBox)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(viewDocumentPageLanguageData.yourSignatures)
						])),
					A2(
					$elm$core$Maybe$withDefault,
					A2($author$project$Page$ViewDocument$signatureList, signatureModel, loadedModel),
					A2($elm$core$Maybe$map, $author$project$Page$ViewDocument$signatureError, signatureModel.listError))
				]));
	});
var $author$project$Page$ViewDocument$isSelectedStamp = F2(
	function (stamp, maybeSelectedStamp) {
		if (maybeSelectedStamp.$ === 'Nothing') {
			return false;
		} else {
			var selectedStamp = maybeSelectedStamp.a;
			return _Utils_eq(
				$author$project$Data$PDF$Stamp$id(stamp),
				$author$project$Data$PDF$Stamp$id(selectedStamp));
		}
	});
var $author$project$Page$ViewDocument$renderStamp = F2(
	function (selectedStamp, stamp) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$span,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$styles.stamp)
				]),
			_List_fromArray(
				[
					function () {
					var _v0 = $author$project$Data$PDF$Stamp$data(stamp);
					if (_v0.$ === 'NotLoaded') {
						return A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$styles.stampImg)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Loading...')
								]));
					} else {
						var data = _v0.a;
						return A2(
							$rtfeldman$elm_css$Html$Styled$img,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$src(data),
									$rtfeldman$elm_css$Html$Styled$Attributes$css(
									A2($author$project$Page$ViewDocument$isSelectedStamp, stamp, selectedStamp) ? _Utils_ap(
										$author$project$Page$ViewDocument$styles.stampImg,
										_List_fromArray(
											[$author$project$Page$ViewDocument$selectedAnnotBorderColor])) : $author$project$Page$ViewDocument$styles.stampImg),
									$rtfeldman$elm_css$Html$Styled$Events$onClick(
									$author$project$Types$OnViewDoc(
										$author$project$Type$ViewDocument$OnAuth(
											$author$project$Type$ViewDocument$OnLoaded(
												$author$project$Type$ViewDocument$OnStampClick(stamp)))))
								]),
							_List_Nil);
					}
				}()
				]));
	});
var $author$project$Page$ViewDocument$stampList = F4(
	function (stampModel, loadedModel, domain, headerText) {
		var _v0 = A2(
			$elm$core$Dict$get,
			$author$project$Data$Domain$toString(domain),
			stampModel.stamps);
		if (_v0.$ === 'Nothing') {
			return $rtfeldman$elm_css$Html$Styled$text('');
		} else {
			var stampStatus = _v0.a;
			if (stampStatus.$ === 'Loaded') {
				var stamps = stampStatus.a;
				return A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$styles.signatureImgBox)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(headerText)
								])),
							A2($author$project$View$Stamp$displayFormStatus, stampModel, domain),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$styles.signatureListBox)
								]),
							_Utils_ap(
								A2(
									$elm$core$List$map,
									$author$project$Page$ViewDocument$renderStamp(loadedModel.selectedStamp),
									$elm$core$Dict$values(stamps)),
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$div,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$styles.create),
												$rtfeldman$elm_css$Html$Styled$Events$onClick(
												$author$project$Types$OnStamp(
													$author$project$Type$Stamp$OnImageUpload(
														$author$project$Type$Stamp$ImageRequested(domain))))
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('+')
											]))
									])))
						]));
			} else {
				return $rtfeldman$elm_css$Html$Styled$text('');
			}
		}
	});
var $author$project$Page$ViewDocument$signingStatusContent = F6(
	function (model, user, stampModel, signatureModel, appDomain, loadedModel) {
		var viewDocumentPageLanguageData = model.languageSwitchModel.allLanguageData.location.viewDocumentPage;
		var signatureSection = function () {
			if (A2($author$project$Data$Api$PDF$View$hasOwnerVerifiedSig, user.id, loadedModel.payload)) {
				var defaultSignature = A2(
					$elm$core$Maybe$withDefault,
					A3($author$project$Data$PDF$Signature$create, '', '', ''),
					loadedModel.selectedSignature);
				var ownerSignature = A2(
					$elm$core$Maybe$withDefault,
					defaultSignature,
					A2($author$project$Data$PDF$ownerVerifiedSignature, user, loadedModel.pdf));
				return A2($author$project$Page$ViewDocument$ownerVerifiedSignatureBox, ownerSignature, model);
			} else {
				return A3($author$project$Page$ViewDocument$signatureBox, signatureModel, loadedModel, model);
			}
		}();
		var selectedDomain = $author$project$Data$Domain$selected(user.domains);
		var stampSection = function () {
			if (A2($author$project$Data$Api$PDF$View$hasOwnerVerifiedStamp, user.id, loadedModel.payload)) {
				var defaultStamp = A2(
					$elm$core$Maybe$withDefault,
					$author$project$Data$PDF$Stamp$createFakeLoadingStamp(''),
					loadedModel.selectedStamp);
				var documentStamp = A2(
					$elm$core$Maybe$withDefault,
					defaultStamp,
					A2($author$project$Data$PDF$ownerVerifiedStamp, user, loadedModel.pdf));
				return $author$project$Page$ViewDocument$ownerVerifiedStampBox(documentStamp);
			} else {
				var showCompanyStamps = _Utils_eq(selectedDomain, appDomain) ? $rtfeldman$elm_css$Html$Styled$text('') : A4($author$project$Page$ViewDocument$stampList, stampModel, loadedModel, selectedDomain, 'Your Company Stamps');
				return A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_Nil,
					_List_fromArray(
						[
							showCompanyStamps,
							A4($author$project$Page$ViewDocument$stampList, stampModel, loadedModel, appDomain, viewDocumentPageLanguageData.yourStamps)
						]));
			}
		}();
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$styles.docStatusContainer)
				]),
			_List_fromArray(
				[
					signatureSection,
					stampSection,
					$author$project$Page$ViewDocument$recipientsAndDocSecurity(model),
					A2(
					$author$project$Material$Styled$Button$button,
					_List_fromArray(
						[
							$author$project$Material$Styled$Button$styles($author$project$Page$ViewDocument$styles.docStatusBtn),
							$author$project$Material$Styled$Button$theme($author$project$Material$Styled$Button$default),
							$author$project$Material$Styled$Button$onClick(
							$author$project$Types$OnViewDoc(
								$author$project$Type$ViewDocument$OnAuth(
									$author$project$Type$ViewDocument$OnLoaded(
										$author$project$Type$ViewDocument$OnShowModal($author$project$Type$ViewDocument$DownloadIncompleteDoc)))))
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(viewDocumentPageLanguageData.downloadDocument)
						]))
				]));
	});
var $author$project$Type$ViewDocument$OnSendEmailReminder = {$: 'OnSendEmailReminder'};
var $author$project$Page$ViewDocument$sendReminderBtn = F3(
	function (loadedModel, user, model) {
		var viewDocumentPageLanguageData = model.languageSwitchModel.allLanguageData.location.viewDocumentPage;
		var currentUser = user.id;
		var _v0 = loadedModel.payload;
		var document = _v0.document;
		var ownerName = document.ownerId;
		return _Utils_eq(ownerName, currentUser) ? A2(
			$author$project$Material$Styled$Button$button,
			_List_fromArray(
				[
					$author$project$Material$Styled$Button$styles($author$project$Page$ViewDocument$styles.docStatusBtn),
					$author$project$Material$Styled$Button$theme($author$project$Material$Styled$Button$default),
					$author$project$Material$Styled$Button$onClick(
					$author$project$Types$OnViewDoc(
						$author$project$Type$ViewDocument$OnAuth(
							$author$project$Type$ViewDocument$OnLoaded($author$project$Type$ViewDocument$OnSendEmailReminder))))
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text(viewDocumentPageLanguageData.resendEmailNotification)
				])) : $rtfeldman$elm_css$Html$Styled$text('');
	});
var $author$project$Page$ViewDocument$viewingStatusContent = F3(
	function (loadedModel, user, model) {
		var viewDocumentPageLanguageData = model.languageSwitchModel.allLanguageData.location.viewDocumentPage;
		var docOwnerId = loadedModel.payload.document.ownerId;
		var currentUserId = user.id;
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$styles.docStatusContainer)
				]),
			_List_fromArray(
				[
					$author$project$Page$ViewDocument$recipientsAndDocSecurity(model),
					A2(
					$author$project$Material$Styled$Button$button,
					_List_fromArray(
						[
							$author$project$Material$Styled$Button$styles($author$project$Page$ViewDocument$styles.docStatusBtn),
							$author$project$Material$Styled$Button$theme($author$project$Material$Styled$Button$blue),
							$author$project$Material$Styled$Button$onClick(
							$author$project$Types$OnViewDoc(
								$author$project$Type$ViewDocument$OnAuth(
									$author$project$Type$ViewDocument$OnLoaded(
										$author$project$Type$ViewDocument$OnShowModal($author$project$Type$ViewDocument$ShowLog)))))
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(viewDocumentPageLanguageData.activities)
						])),
					_Utils_eq(currentUserId, docOwnerId) ? A2(
					$author$project$Material$Styled$Button$button,
					_List_fromArray(
						[
							$author$project$Material$Styled$Button$styles($author$project$Page$ViewDocument$styles.docStatusBtn),
							$author$project$Material$Styled$Button$theme($author$project$Material$Styled$Button$default),
							$author$project$Material$Styled$Button$onClick(
							$author$project$Types$OnViewDoc(
								$author$project$Type$ViewDocument$OnAuth(
									$author$project$Type$ViewDocument$OnLoaded(
										$author$project$Type$ViewDocument$OnShowModal($author$project$Type$ViewDocument$DownloadIncompleteDoc)))))
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(viewDocumentPageLanguageData.downloadDocument)
						])) : $rtfeldman$elm_css$Html$Styled$text(''),
					A3($author$project$Page$ViewDocument$sendReminderBtn, loadedModel, user, model),
					A3($author$project$Page$ViewDocument$deleteDocumentBtn, loadedModel, user, model)
				]));
	});
var $author$project$Page$ViewDocument$userRoleContent = F3(
	function (_v0, loadedModel, appModel) {
		var user = _v0.user;
		var signatureModel = _v0.signatureModel;
		var stampModel = _v0.stampModel;
		var appDomain = _v0.appDomain;
		var _v1 = loadedModel;
		var pdf = _v1.pdf;
		var _v2 = $author$project$Data$PDF$status(pdf);
		switch (_v2.$) {
			case 'Signing':
				return A6($author$project$Page$ViewDocument$signingStatusContent, appModel, user, stampModel, signatureModel, appDomain, loadedModel);
			case 'Viewing':
				return A3($author$project$Page$ViewDocument$viewingStatusContent, loadedModel, user, appModel);
			case 'Completed':
				return A4($author$project$Page$ViewDocument$completedStatusContent, appModel, loadedModel.downloadStatus, loadedModel, user);
			case 'Expired':
				return A3($author$project$Page$ViewDocument$viewingStatusContent, loadedModel, user, appModel);
			default:
				return A3($author$project$Page$ViewDocument$viewingStatusContent, loadedModel, user, appModel);
		}
	});
var $author$project$Type$ViewDocument$OnNavigateToLogin = {$: 'OnNavigateToLogin'};
var $author$project$Page$ViewDocument$Modal$invalidAuthError = A2(
	$author$project$Material$Styled$Modal$modal,
	_List_fromArray(
		[
			$author$project$Material$Styled$Modal$open(true),
			$author$project$Material$Styled$Modal$contentContainerstyles($author$project$Page$ViewDocument$Modal$styles.modalContainer)
		]),
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.modalHeader)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.modalHeaderTxt)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('Unable to load document')
						]))
				])),
			A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.modalBodyContainer)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.errorBody)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('An Error has occured. Please try again later.')
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.modalBtns)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Material$Styled$Button$button,
							_List_fromArray(
								[
									$author$project$Material$Styled$Button$theme($author$project$Material$Styled$Button$blue),
									$author$project$Material$Styled$Button$styles($author$project$Page$ViewDocument$Modal$styles.dashboardBtn),
									$author$project$Material$Styled$Button$onClick(
									$author$project$Types$OnViewDoc($author$project$Type$ViewDocument$OnNavigateToLogin))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('To Login')
								]))
						]))
				]))
		]));
var $author$project$Page$ViewDocument$Modal$notTokenUserError = A2(
	$author$project$Material$Styled$Modal$modal,
	_List_fromArray(
		[
			$author$project$Material$Styled$Modal$open(true),
			$author$project$Material$Styled$Modal$contentContainerstyles($author$project$Page$ViewDocument$Modal$styles.modalContainer)
		]),
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.modalHeader)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.modalHeaderTxt)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('Unable to load document')
						]))
				])),
			A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.modalBodyContainer)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.errorBody)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('The link you are accessing is not valid to this user. Please logout and try again.')
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.modalBtns)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Material$Styled$Button$button,
							_List_fromArray(
								[
									$author$project$Material$Styled$Button$theme($author$project$Material$Styled$Button$blue),
									$author$project$Material$Styled$Button$styles($author$project$Page$ViewDocument$Modal$styles.dashboardBtn),
									$author$project$Material$Styled$Button$onClick(
									$author$project$Types$OnViewDoc(
										$author$project$Type$ViewDocument$OnAuth($author$project$Type$ViewDocument$OnNavigateToDashboard)))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('To Dashboard')
								]))
						]))
				]))
		]));
var $author$project$Page$ViewDocument$Modal$tokenDoesNotExistError = A2(
	$author$project$Material$Styled$Modal$modal,
	_List_fromArray(
		[
			$author$project$Material$Styled$Modal$open(true),
			$author$project$Material$Styled$Modal$contentContainerstyles($author$project$Page$ViewDocument$Modal$styles.modalContainer)
		]),
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.modalHeader)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.modalHeaderTxt)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('Unable to load document')
						]))
				])),
			A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.modalBodyContainer)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.errorBody)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('An Error has occured. Please try again later.')
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.modalBtns)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Material$Styled$Button$button,
							_List_fromArray(
								[
									$author$project$Material$Styled$Button$theme($author$project$Material$Styled$Button$blue),
									$author$project$Material$Styled$Button$styles($author$project$Page$ViewDocument$Modal$styles.dashboardBtn),
									$author$project$Material$Styled$Button$onClick(
									$author$project$Types$OnViewDoc(
										$author$project$Type$ViewDocument$OnAuth($author$project$Type$ViewDocument$OnNavigateToDashboard)))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('To Dashboard')
								]))
						]))
				]))
		]));
var $author$project$Page$ViewDocument$Modal$verificationError = F2(
	function (sessionModel, errorType) {
		if (errorType.$ === 'TokenDoesNotExist') {
			switch (sessionModel.$) {
				case 'Auth':
					return $author$project$Page$ViewDocument$Modal$tokenDoesNotExistError;
				case 'Anonymous':
					return $author$project$Page$ViewDocument$Modal$tokenDoesNotExistError;
				case 'NoAuth':
					return $rtfeldman$elm_css$Html$Styled$text('');
				default:
					return $author$project$Page$ViewDocument$Modal$invalidAuthError;
			}
		} else {
			switch (sessionModel.$) {
				case 'Auth':
					return $author$project$Page$ViewDocument$Modal$notTokenUserError;
				case 'Anonymous':
					return $rtfeldman$elm_css$Html$Styled$text('');
				case 'NoAuth':
					return $rtfeldman$elm_css$Html$Styled$text('');
				default:
					return $rtfeldman$elm_css$Html$Styled$text('');
			}
		}
	});
var $author$project$Type$ViewDocument$OnErrorClose = {$: 'OnErrorClose'};
var $author$project$Page$ViewDocument$MessageBanner$errorBodyToString = function (error) {
	switch (error.$) {
		case 'LoadSignature':
			return 'Failed to load signatures in the document.';
		case 'LoadStamp':
			return 'Failed to load stamps in the document.';
		case 'EncryptionDecodeError':
			var message = error.a;
			return message;
		case 'NoSelectedSignature':
			return 'No signature selected.';
		case 'UpdateAnnotations':
			var err = error.a;
			return err;
		case 'HasUnverifiedAnnotation':
			return 'Please click and acknowledge all fields.';
		case 'SignApi':
			var err = error.a;
			return err;
		case 'DownloadError':
			var err = error.a;
			return err;
		case 'DueDateExtensionError':
			var err = error.a;
			return err;
		case 'NoCredentialName':
			return 'Please input your credential name.';
		case 'GenerateCredentialApi':
			var err = error.a;
			return err;
		case 'NoAnnotationSelected':
			return 'Please choose at least 1 annotation.';
		default:
			var err = error.a;
			return err;
	}
};
var $author$project$Page$ViewDocument$MessageBanner$errorHeaderToString = function (error) {
	switch (error.$) {
		case 'LoadSignature':
			return 'Loading Error';
		case 'LoadStamp':
			return 'Loading Error';
		case 'EncryptionDecodeError':
			return 'Password Decode Error';
		case 'NoSelectedSignature':
			return 'No Signature Error';
		case 'UpdateAnnotations':
			return 'Update Error';
		case 'HasUnverifiedAnnotation':
			return 'Missing Fields';
		case 'SignApi':
			return 'Signing Error';
		case 'DownloadError':
			return 'Download Error';
		case 'DueDateExtensionError':
			return 'Due Date Extension Error';
		case 'NoCredentialName':
			return 'Credential Name Empty';
		case 'GenerateCredentialApi':
			return 'Error Generating Credential';
		case 'NoAnnotationSelected':
			return 'No Annotation Selected';
		default:
			return 'Notarization Failed';
	}
};
var $author$project$Page$ViewDocument$MessageBanner$styles = {
	container: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$absolute),
			$rtfeldman$elm_css$Css$top($rtfeldman$elm_css$Css$zero),
			$rtfeldman$elm_css$Css$left($rtfeldman$elm_css$Css$zero),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100)),
			$rtfeldman$elm_css$Css$boxSizing($rtfeldman$elm_css$Css$borderBox),
			$rtfeldman$elm_css$Css$padding(
			$rtfeldman$elm_css$Css$px(20))
		]),
	credentialTxt: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer),
			$rtfeldman$elm_css$Css$textDecoration($rtfeldman$elm_css$Css$underline)
		])
};
var $author$project$Page$ViewDocument$MessageBanner$successBodyToString = function (msg) {
	switch (msg.$) {
		case 'DeadlineExt':
			return $rtfeldman$elm_css$Html$Styled$text('Successfully updated document deadline.');
		case 'CredentialCreated':
			return A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('Your credential has been created and can be downloaded by clicking on ')
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$MessageBanner$styles.credentialTxt),
								$rtfeldman$elm_css$Html$Styled$Events$onClick(
								$author$project$Types$OnViewDoc(
									$author$project$Type$ViewDocument$OnAuth(
										$author$project$Type$ViewDocument$OnLoaded($author$project$Type$ViewDocument$OnListCredentials))))
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('VIEW CREDENTIALS.')
							]))
					]));
		default:
			return $rtfeldman$elm_css$Html$Styled$text('Your wallet has been successfully registered');
	}
};
var $author$project$Page$ViewDocument$MessageBanner$successHeaderToString = function (msg) {
	switch (msg.$) {
		case 'DeadlineExt':
			return 'Deadline Extension';
		case 'CredentialCreated':
			return 'Credential Successfully Created.';
		default:
			return 'Wallet Registered.';
	}
};
var $author$project$Page$ViewDocument$MessageBanner$view = function (bannerMsg) {
	if (bannerMsg.$ === 'Successful') {
		var msg = bannerMsg.a;
		return A2(
			$author$project$Material$Styled$Banner$banner,
			_List_fromArray(
				[
					$author$project$Material$Styled$Banner$containerStyles($author$project$Page$ViewDocument$MessageBanner$styles.container),
					$author$project$Material$Styled$Banner$theme($author$project$Material$Styled$Banner$successTheme),
					$author$project$Material$Styled$Banner$title(
					$author$project$Page$ViewDocument$MessageBanner$successHeaderToString(msg)),
					$author$project$Material$Styled$Banner$body(
					$author$project$Page$ViewDocument$MessageBanner$successBodyToString(msg)),
					$author$project$Material$Styled$Banner$closeIconAttributes(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Svg$Styled$Events$onClick(
							$author$project$Types$OnViewDoc(
								$author$project$Type$ViewDocument$OnAuth(
									$author$project$Type$ViewDocument$OnLoaded($author$project$Type$ViewDocument$OnErrorClose))))
						]))
				]),
			_List_Nil);
	} else {
		var error = bannerMsg.a;
		return A2(
			$author$project$Material$Styled$Banner$banner,
			_List_fromArray(
				[
					$author$project$Material$Styled$Banner$containerStyles($author$project$Page$ViewDocument$MessageBanner$styles.container),
					$author$project$Material$Styled$Banner$theme($author$project$Material$Styled$Banner$errorTheme),
					$author$project$Material$Styled$Banner$title(
					$author$project$Page$ViewDocument$MessageBanner$errorHeaderToString(error)),
					$author$project$Material$Styled$Banner$body(
					$rtfeldman$elm_css$Html$Styled$text(
						$author$project$Page$ViewDocument$MessageBanner$errorBodyToString(error))),
					$author$project$Material$Styled$Banner$closeIconAttributes(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Svg$Styled$Events$onClick(
							$author$project$Types$OnViewDoc(
								$author$project$Type$ViewDocument$OnAuth(
									$author$project$Type$ViewDocument$OnLoaded($author$project$Type$ViewDocument$OnErrorClose))))
						]))
				]),
			_List_Nil);
	}
};
var $author$project$Page$ViewDocument$Modal$dateFormatter = $ryannhg$date_format$DateFormat$format(
	_List_fromArray(
		[
			$ryannhg$date_format$DateFormat$dayOfMonthFixed,
			$ryannhg$date_format$DateFormat$text(' '),
			$ryannhg$date_format$DateFormat$monthNameAbbreviated,
			$ryannhg$date_format$DateFormat$text(' '),
			$ryannhg$date_format$DateFormat$yearNumber
		]));
var $author$project$Data$Api$PDF$View$getActionTypes = function (action) {
	switch (action.$) {
		case 'Send':
			return 'Send Documents';
		case 'Sign':
			return 'Sign';
		case 'View':
			return 'View';
		case 'DownloadPDF':
			return 'Download Completed Document';
		case 'DownloadWrappedDocument':
			return 'Download Wrapped Document';
		case 'DownloadVerifiableCredential':
			return 'Download Verifiable Credential';
		case 'Reminder':
			return 'Sent Reminder';
		case 'Security':
			return 'Update Security';
		case 'GenerateVerifiableCredential':
			return 'Generate Verifiable Credential';
		default:
			return 'Download Partially Completed Document';
	}
};
var $author$project$Page$ViewDocument$Modal$timeFormatter = $ryannhg$date_format$DateFormat$format(
	_List_fromArray(
		[
			$ryannhg$date_format$DateFormat$hourFixed,
			$ryannhg$date_format$DateFormat$text(':'),
			$ryannhg$date_format$DateFormat$minuteFixed,
			$ryannhg$date_format$DateFormat$text(' '),
			$ryannhg$date_format$DateFormat$amPmLowercase
		]));
var $author$project$Page$ViewDocument$Modal$activitiesCard = F2(
	function (appModel, log) {
		var zoneName = function () {
			var _v1 = appModel.timezoneName;
			if (_v1.$ === 'Just') {
				var zoneName_ = _v1.a;
				if (zoneName_.$ === 'Name') {
					var name = zoneName_.a;
					return name;
				} else {
					var offset = zoneName_.a;
					return 'UTC ' + ($elm$core$String$fromInt((offset / 60) | 0) + '00');
				}
			} else {
				return 'No zoneName';
			}
		}();
		var viewDocumentPageLanguageData = appModel.languageSwitchModel.allLanguageData.location.viewDocumentPage;
		var credentialName = function () {
			var _v0 = log.credentialName;
			if (_v0.$ === 'Just') {
				var name = _v0.a;
				return ' \"' + (name + '\"');
			} else {
				return '';
			}
		}();
		return A2(
			$author$project$Material$Styled$Card$card,
			_List_fromArray(
				[
					$author$project$Material$Styled$Card$containerStyles($author$project$Page$ViewDocument$Modal$styles.cardContainer)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.cardHeaderContent)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.avatar)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									A2($elm$core$String$left, 1, log.name))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.nameContent)
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.boldText)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(log.name)
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_Nil,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(log.ipAddr)
										]))
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.subContentContainer)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.subContent)
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.boldText)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(viewDocumentPageLanguageData.action + ': ')
										])),
									$rtfeldman$elm_css$Html$Styled$text(
									_Utils_ap(
										$author$project$Data$Api$PDF$View$getActionTypes(log.action),
										credentialName))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.subContent)
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.boldText)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(viewDocumentPageLanguageData.time + ': ')
										])),
									$rtfeldman$elm_css$Html$Styled$text(
									A2($author$project$Page$ViewDocument$Modal$dateFormatter, appModel.timezone, log.dateTime) + (' ' + (A2($author$project$Page$ViewDocument$Modal$timeFormatter, appModel.timezone, log.dateTime) + (' (' + (zoneName + ') ')))))
								]))
						]))
				]));
	});
var $author$project$Page$ViewDocument$Modal$activitiesModal = F2(
	function (appModel, logs) {
		var viewDocumentPageLanguageData = appModel.languageSwitchModel.allLanguageData.location.viewDocumentPage;
		return A2(
			$author$project$Material$Styled$Modal$modal,
			_List_fromArray(
				[
					$author$project$Material$Styled$Modal$open(true),
					$author$project$Material$Styled$Modal$contentContainerstyles($author$project$Page$ViewDocument$Modal$styles.activitiesModal),
					$author$project$Material$Styled$Modal$onClose(
					$author$project$Types$OnViewDoc(
						$author$project$Type$ViewDocument$OnAuth(
							$author$project$Type$ViewDocument$OnLoaded($author$project$Type$ViewDocument$OnCloseModal))))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.modalHeader)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.modalHeaderTxt)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(viewDocumentPageLanguageData.activities)
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$img,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.icon),
									$rtfeldman$elm_css$Html$Styled$Attributes$src($author$project$View$Theme$images.close),
									$rtfeldman$elm_css$Html$Styled$Events$onClick(
									$author$project$Types$OnViewDoc(
										$author$project$Type$ViewDocument$OnAuth(
											$author$project$Type$ViewDocument$OnLoaded($author$project$Type$ViewDocument$OnCloseModal))))
								]),
							_List_Nil)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.activitiesContainer)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_Nil,
							A2(
								$elm$core$List$map,
								$author$project$Page$ViewDocument$Modal$activitiesCard(appModel),
								logs))
						]))
				]));
	});
var $author$project$Page$ViewDocument$Modal$certificateModal = F2(
	function (model, appModel) {
		var zoneName = function () {
			var _v0 = appModel.timezoneName;
			if (_v0.$ === 'Just') {
				var zoneName_ = _v0.a;
				if (zoneName_.$ === 'Name') {
					var name = zoneName_.a;
					return name;
				} else {
					var offset = zoneName_.a;
					return 'UTC ' + ($elm$core$String$fromInt((offset / 60) | 0) + '00');
				}
			} else {
				return 'No zoneName';
			}
		}();
		var viewDocumentPageLanguageData = appModel.languageSwitchModel.allLanguageData.location.viewDocumentPage;
		var documentPasscode = model.payload.document.passcode;
		return A2(
			$author$project$Material$Styled$Modal$modal,
			_List_fromArray(
				[
					$author$project$Material$Styled$Modal$open(true),
					$author$project$Material$Styled$Modal$contentContainerstyles($author$project$Page$ViewDocument$Modal$styles.activitiesModal),
					$author$project$Material$Styled$Modal$onClose(
					$author$project$Types$OnViewDoc(
						$author$project$Type$ViewDocument$OnAuth(
							$author$project$Type$ViewDocument$OnLoaded($author$project$Type$ViewDocument$OnCloseModal))))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.modalHeader)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.modalHeaderTxt)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Certificate')
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$img,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.icon),
									$rtfeldman$elm_css$Html$Styled$Attributes$src($author$project$View$Theme$images.close),
									$rtfeldman$elm_css$Html$Styled$Events$onClick(
									$author$project$Types$OnViewDoc(
										$author$project$Type$ViewDocument$OnAuth(
											$author$project$Type$ViewDocument$OnLoaded($author$project$Type$ViewDocument$OnCloseModal))))
								]),
							_List_Nil)
						])),
					A2(
					$author$project$Material$Styled$Card$card,
					_List_fromArray(
						[
							$author$project$Material$Styled$Card$containerStyles($author$project$Page$ViewDocument$Modal$styles.cert)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$img,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$src($author$project$View$Theme$images.logoColor),
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.certIcon)
								]),
							_List_Nil),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.certSubHeader)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(viewDocumentPageLanguageData.certificateOfCompletion)
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.certContent)
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.certText)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(viewDocumentPageLanguageData.documentId + (': ' + model.payload.document.id))
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.certText)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											viewDocumentPageLanguageData.documentChecksum + (': ' + A2($elm$core$Maybe$withDefault, '', model.payload.document.checksum)))
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.certText)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('Status: ' + 'Completed')
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.certText)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											'Name: ' + $author$project$Data$PDF$title(model.pdf))
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.certText)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('Originator: ' + (model.payload.document.firstName + (' ' + (model.payload.document.lastName + (' ' + ('(' + (model.payload.document.email + ')')))))))
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.certText)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											'Signers: ' + $elm$core$String$fromInt(
												$elm$core$Dict$size(
													$author$project$Data$PDF$signers(model.pdf))))
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.certText)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											'Recipients: ' + $elm$core$String$fromInt(
												$elm$core$List$length(model.payload.recipients)))
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.certText)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											'Created: ' + (A2($author$project$Page$ViewDocument$Modal$dateFormatter, appModel.timezone, model.payload.document.createdAt) + (' ' + (A2($author$project$Page$ViewDocument$Modal$timeFormatter, appModel.timezone, model.payload.document.createdAt) + (' (' + (zoneName + ') '))))))
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.certText)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											'Completed: ' + (A2($author$project$Page$ViewDocument$Modal$dateFormatter, appModel.timezone, model.payload.document.updatedAt) + (' ' + (A2($author$project$Page$ViewDocument$Modal$timeFormatter, appModel.timezone, model.payload.document.updatedAt) + (' (' + (zoneName + ') '))))))
										]))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.certSubHeader)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Signer Details')
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.certContent)
								]),
							A2(
								$elm$core$List$map,
								function (log) {
									return A2(
										$rtfeldman$elm_css$Html$Styled$div,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.certActivites)
											]),
										_List_fromArray(
											[
												A2(
												$rtfeldman$elm_css$Html$Styled$div,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.certText)
													]),
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text('Signer: ' + (log.name + (' (' + (log.email + ')'))))
													])),
												A2(
												$rtfeldman$elm_css$Html$Styled$div,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.certText)
													]),
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text(
														'Signed: ' + (A2($author$project$Page$ViewDocument$Modal$dateFormatter, appModel.timezone, log.dateTime) + (' ' + (A2($author$project$Page$ViewDocument$Modal$timeFormatter, appModel.timezone, log.dateTime) + (' (' + (zoneName + ') '))))))
													])),
												A2(
												$rtfeldman$elm_css$Html$Styled$div,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.certText)
													]),
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text('IP Address: ' + (' ' + log.ipAddr))
													])),
												_Utils_eq(documentPasscode, $elm$core$Maybe$Nothing) ? A2(
												$rtfeldman$elm_css$Html$Styled$div,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.certText)
													]),
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text('Signer Authentication: Email')
													])) : A2(
												$rtfeldman$elm_css$Html$Styled$div,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.certText)
													]),
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text('Signer Authentication: Email, Passcode')
													]))
											]));
								},
								A2(
									$elm$core$List$sortBy,
									function ($) {
										return $.name;
									},
									A2(
										$elm$core$List$filter,
										function (log) {
											return _Utils_eq(log.action, $author$project$Data$Api$PDF$View$Sign);
										},
										model.logs)))),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.certSubHeader)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Document Summary Events')
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.certContent)
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.certText)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											'Uploaded: ' + (A2($author$project$Page$ViewDocument$Modal$dateFormatter, appModel.timezone, model.payload.document.createdAt) + (' ' + (A2($author$project$Page$ViewDocument$Modal$timeFormatter, appModel.timezone, model.payload.document.createdAt) + (' (' + (zoneName + ') '))))))
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.certText)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											'Sent: ' + (A2($author$project$Page$ViewDocument$Modal$dateFormatter, appModel.timezone, model.payload.document.createdAt) + (' ' + (A2($author$project$Page$ViewDocument$Modal$timeFormatter, appModel.timezone, model.payload.document.createdAt) + (' (' + (zoneName + ') '))))))
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.certText)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											'Completed: ' + (A2($author$project$Page$ViewDocument$Modal$dateFormatter, appModel.timezone, model.payload.document.updatedAt) + (' ' + (A2($author$project$Page$ViewDocument$Modal$timeFormatter, appModel.timezone, model.payload.document.updatedAt) + (' (' + (zoneName + ') '))))))
										]))
								]))
						]))
				]));
	});
var $author$project$Type$ViewDocument$OnDeadlineExtClick = {$: 'OnDeadlineExtClick'};
var $author$project$Type$ViewDocument$OnDeadlineInput = function (a) {
	return {$: 'OnDeadlineInput', a: a};
};
var $author$project$Page$ViewDocument$Modal$minDateString = $ryannhg$date_format$DateFormat$format(
	_List_fromArray(
		[
			$ryannhg$date_format$DateFormat$yearNumber,
			$ryannhg$date_format$DateFormat$text('-'),
			$ryannhg$date_format$DateFormat$monthFixed,
			$ryannhg$date_format$DateFormat$text('-'),
			$ryannhg$date_format$DateFormat$dayOfMonthFixed
		]));
var $author$project$Page$ViewDocument$Modal$deadlineExtensionModal = F2(
	function (model, loadedModel) {
		var _v0 = model;
		var timezone = _v0.timezone;
		var currentTime = _v0.currentTime;
		return A2(
			$author$project$Material$Styled$Modal$modal,
			_List_fromArray(
				[
					$author$project$Material$Styled$Modal$open(true),
					$author$project$Material$Styled$Modal$contentContainerstyles($author$project$Page$ViewDocument$Modal$styles.modalContainer),
					$author$project$Material$Styled$Modal$onClose(
					$author$project$Types$OnViewDoc(
						$author$project$Type$ViewDocument$OnAuth(
							$author$project$Type$ViewDocument$OnLoaded($author$project$Type$ViewDocument$OnCloseModal)))),
					$author$project$Material$Styled$Modal$testAttribute('Deadline Extension')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.modalHeader)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.modalHeaderTxt)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Extend Document Due Date')
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$img,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.icon),
									$rtfeldman$elm_css$Html$Styled$Attributes$src($author$project$View$Theme$images.close),
									$rtfeldman$elm_css$Html$Styled$Events$onClick(
									$author$project$Types$OnViewDoc(
										$author$project$Type$ViewDocument$OnAuth(
											$author$project$Type$ViewDocument$OnLoaded($author$project$Type$ViewDocument$OnCloseModal))))
								]),
							_List_Nil)
						])),
					A2(
					$author$project$Material$Styled$Input$date,
					_List_fromArray(
						[
							$author$project$Material$Styled$Input$containerStyles($author$project$Page$ViewDocument$Modal$styles.inputContainer),
							$author$project$Material$Styled$Input$label('Due Date'),
							$author$project$Material$Styled$Input$value(loadedModel.newDueDate),
							$author$project$Material$Styled$Input$min(
							A2(
								$elm$core$Maybe$withDefault,
								A2($author$project$Page$ViewDocument$Modal$minDateString, timezone, currentTime),
								$author$project$Data$PDF$dueDate(loadedModel.pdf))),
							$author$project$Material$Styled$Input$onInput(
							A2(
								$elm$core$Basics$composeL,
								A2(
									$elm$core$Basics$composeL,
									A2($elm$core$Basics$composeL, $author$project$Types$OnViewDoc, $author$project$Type$ViewDocument$OnAuth),
									$author$project$Type$ViewDocument$OnLoaded),
								$author$project$Type$ViewDocument$OnDeadlineInput))
						]),
					_List_Nil),
					A2(
					$author$project$Material$Styled$Button$button,
					_List_fromArray(
						[
							$author$project$Material$Styled$Button$onClick(
							$author$project$Types$OnViewDoc(
								$author$project$Type$ViewDocument$OnAuth(
									$author$project$Type$ViewDocument$OnLoaded($author$project$Type$ViewDocument$OnDeadlineExtClick))))
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('Update')
						]))
				]));
	});
var $author$project$Type$ViewDocument$OnDeleteDocument = {$: 'OnDeleteDocument'};
var $author$project$Page$ViewDocument$Modal$deleteDocumentModal = function (model) {
	var viewDocumentPageLanguageData = model.languageSwitchModel.allLanguageData.location.viewDocumentPage;
	var cancelText = model.languageSwitchModel.allLanguageData.location.addressBookPage.cancelBtn;
	return A2(
		$author$project$Material$Styled$Modal$modal,
		_List_fromArray(
			[
				$author$project$Material$Styled$Modal$open(true),
				$author$project$Material$Styled$Modal$contentContainerstyles($author$project$Page$ViewDocument$Modal$styles.modalContainer)
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.modalHeader)
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.modalHeaderTxt)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(viewDocumentPageLanguageData.deleteDocument)
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$img,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.icon),
								$rtfeldman$elm_css$Html$Styled$Attributes$src($author$project$View$Theme$images.close),
								$rtfeldman$elm_css$Html$Styled$Events$onClick(
								$author$project$Types$OnViewDoc(
									$author$project$Type$ViewDocument$OnAuth(
										$author$project$Type$ViewDocument$OnLoaded($author$project$Type$ViewDocument$OnCloseModal))))
							]),
						_List_Nil)
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(viewDocumentPageLanguageData.deleteDocumentText)
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.footer)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Material$Styled$Button$button,
						_List_fromArray(
							[
								$author$project$Material$Styled$Button$styles($author$project$Page$ViewDocument$Modal$styles.button),
								function () {
								var defaultTextTheme = $author$project$Material$Styled$Button$greyText;
								return $author$project$Material$Styled$Button$theme(
									_Utils_update(
										defaultTextTheme,
										{base: $author$project$Material$Styled$Color$grey200String}));
							}(),
								$author$project$Material$Styled$Button$onClick(
								$author$project$Types$OnViewDoc(
									$author$project$Type$ViewDocument$OnAuth(
										$author$project$Type$ViewDocument$OnLoaded($author$project$Type$ViewDocument$OnCloseModal))))
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(cancelText)
							])),
						A2(
						$author$project$Material$Styled$Button$button,
						_List_fromArray(
							[
								$author$project$Material$Styled$Button$styles($author$project$Page$ViewDocument$Modal$styles.button),
								$author$project$Material$Styled$Button$onClick(
								$author$project$Types$OnViewDoc(
									$author$project$Type$ViewDocument$OnAuth(
										$author$project$Type$ViewDocument$OnLoaded($author$project$Type$ViewDocument$OnDeleteDocument))))
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(viewDocumentPageLanguageData.confirm)
							]))
					]))
			]));
};
var $author$project$Page$ViewDocument$Modal$deleteDocumentSuccess = A2(
	$author$project$Material$Styled$Modal$modal,
	_List_fromArray(
		[
			$author$project$Material$Styled$Modal$open(true),
			$author$project$Material$Styled$Modal$contentContainerstyles($author$project$Page$ViewDocument$Modal$styles.modalContainer)
		]),
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.modalHeader)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.modalHeaderTxt)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('Delete Document')
						]))
				])),
			A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.modalBodyContainer)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.modalBody)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('Please check your email to delete the document.')
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.modalBtns)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Material$Styled$Button$button,
							_List_fromArray(
								[
									$author$project$Material$Styled$Button$theme($author$project$Material$Styled$Button$blue),
									$author$project$Material$Styled$Button$styles($author$project$Page$ViewDocument$Modal$styles.dashboardBtn),
									$author$project$Material$Styled$Button$onClick(
									$author$project$Types$OnViewDoc(
										$author$project$Type$ViewDocument$OnAuth($author$project$Type$ViewDocument$OnNavigateToDashboard)))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Back To Dashboard')
								]))
						]))
				]))
		]));
var $author$project$Type$ViewDocument$OnWallectConnectAddressSelect = function (a) {
	return {$: 'OnWallectConnectAddressSelect', a: a};
};
var $author$project$Page$ViewDocument$Modal$walletConnectCard = function (walletData) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Events$onClick(
				$author$project$Types$OnViewDoc(
					$author$project$Type$ViewDocument$OnAuth(
						$author$project$Type$ViewDocument$OnLoaded(
							$author$project$Type$ViewDocument$OnWallectConnectAddressSelect(walletData)))))
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Material$Styled$Card$card,
				_List_fromArray(
					[
						$author$project$Material$Styled$Card$containerStyles(
						_Utils_ap($author$project$Page$ViewDocument$Modal$styles.cardContainer, $author$project$Page$ViewDocument$Modal$styles.onHover))
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.walletAddress)
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$span,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.walletAddress)
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(walletData.address)
									]))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.optInText)
							]),
						_List_fromArray(
							[
								walletData.needOptIn ? $rtfeldman$elm_css$Html$Styled$text('Requires Opt In') : $rtfeldman$elm_css$Html$Styled$text('Does not require Opt In')
							]))
					]))
			]));
};
var $author$project$Page$ViewDocument$Modal$displayWalletConnectAddressesModal = F2(
	function (walletDataList, loadedModel) {
		return A2(
			$author$project$Material$Styled$Modal$modal,
			_List_fromArray(
				[
					$author$project$Material$Styled$Modal$open(true),
					$author$project$Material$Styled$Modal$contentContainerstyles($author$project$Page$ViewDocument$Modal$styles.activitiesModal)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.modalHeader)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.modalHeaderTxt)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Your wallet Addresses')
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.smallTxt)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Please click to select the wallet use for payment.')
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.walletContainer)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_Nil,
							A2($elm$core$List$map, $author$project$Page$ViewDocument$Modal$walletConnectCard, walletDataList))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.walletErrorText)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							A2($elm$core$Maybe$withDefault, '', loadedModel.optInError))
						]))
				]));
	});
var $author$project$Type$ViewDocument$OnMyAlgoWalletClick = {$: 'OnMyAlgoWalletClick'};
var $author$project$Type$ViewDocument$OptInAssetClick = {$: 'OptInAssetClick'};
var $author$project$Type$ViewDocument$PaymentTransactionClick = {$: 'PaymentTransactionClick'};
var $author$project$Type$ViewDocument$OnSelectWallet = function (a) {
	return {$: 'OnSelectWallet', a: a};
};
var $author$project$Page$ViewDocument$Modal$walletCard = function (walletAddress) {
	return A2(
		$author$project$Material$Styled$Card$card,
		_List_fromArray(
			[
				$author$project$Material$Styled$Card$containerStyles(
				_Utils_ap($author$project$Page$ViewDocument$Modal$styles.cardContainer, $author$project$Page$ViewDocument$Modal$styles.onHover))
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.walletAddress),
						$rtfeldman$elm_css$Html$Styled$Events$onClick(
						$author$project$Types$OnViewDoc(
							$author$project$Type$ViewDocument$OnAuth(
								$author$project$Type$ViewDocument$OnLoaded(
									$author$project$Type$ViewDocument$OnSelectWallet(walletAddress)))))
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.walletAddress)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(walletAddress)
							]))
					]))
			]));
};
var $author$project$Page$ViewDocument$Modal$displayWalletModal = F3(
	function (walletAddress, selectedAddress, loadedModel) {
		return A2(
			$author$project$Material$Styled$Modal$modal,
			_List_fromArray(
				[
					$author$project$Material$Styled$Modal$open(true),
					$author$project$Material$Styled$Modal$contentContainerstyles($author$project$Page$ViewDocument$Modal$styles.activitiesModal)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.modalHeader)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.modalHeaderTxt)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Your wallet Addresses')
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$img,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.icon),
									$rtfeldman$elm_css$Html$Styled$Attributes$src($author$project$View$Theme$images.close),
									$rtfeldman$elm_css$Html$Styled$Events$onClick(
									$author$project$Types$OnViewDoc(
										$author$project$Type$ViewDocument$OnAuth(
											$author$project$Type$ViewDocument$OnLoaded($author$project$Type$ViewDocument$OnCloseModal))))
								]),
							_List_Nil)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.smallTxt)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Please click to select the wallet use for payment.')
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.walletContainer)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_Nil,
							A2($elm$core$List$map, $author$project$Page$ViewDocument$Modal$walletCard, walletAddress))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.walletAddress)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Selected Account: ' + selectedAddress)
								]))
						])),
					$elm$core$String$isEmpty(selectedAddress) ? $rtfeldman$elm_css$Html$Styled$text('') : (loadedModel.needOptIn ? A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.bottomContainer)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.smallTxt)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('A one time process to opt-in is needed before payment.')
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.smallTxt)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$Page$ViewDocument$Modal$optInStatusDisplayText(loadedModel.needOptIn))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.buttonContainer)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Material$Styled$Button$button,
									_List_fromArray(
										[
											$author$project$Material$Styled$Button$theme($author$project$Material$Styled$Button$blue),
											$author$project$Material$Styled$Button$styles($author$project$Page$ViewDocument$Modal$styles.passwordButtons),
											$author$project$Material$Styled$Button$onClick(
											$author$project$Types$OnViewDoc(
												$author$project$Type$ViewDocument$OnAuth(
													$author$project$Type$ViewDocument$OnLoaded($author$project$Type$ViewDocument$OptInAssetClick))))
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('Opt-in')
										])),
									A2(
									$author$project$Material$Styled$Button$button,
									_List_fromArray(
										[
											$author$project$Material$Styled$Button$styles($author$project$Page$ViewDocument$Modal$styles.passwordButtons),
											function () {
											var defaultTextTheme = $author$project$Material$Styled$Button$greyText;
											return $author$project$Material$Styled$Button$theme(
												_Utils_update(
													defaultTextTheme,
													{base: $author$project$Material$Styled$Color$grey200String}));
										}(),
											$author$project$Material$Styled$Button$onClick(
											$author$project$Types$OnViewDoc(
												$author$project$Type$ViewDocument$OnAuth(
													$author$project$Type$ViewDocument$OnLoaded($author$project$Type$ViewDocument$OnCloseModal))))
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('Back')
										]))
								]))
						])) : A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.bottomContainer)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.smallTxt)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$Page$ViewDocument$Modal$optInStatusDisplayText(loadedModel.needOptIn))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.buttonContainer)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Material$Styled$Button$button,
									_List_fromArray(
										[
											$author$project$Material$Styled$Button$theme($author$project$Material$Styled$Button$blue),
											$author$project$Material$Styled$Button$styles($author$project$Page$ViewDocument$Modal$styles.passwordButtons),
											$author$project$Material$Styled$Button$onClick(
											$author$project$Types$OnViewDoc(
												$author$project$Type$ViewDocument$OnAuth(
													$author$project$Type$ViewDocument$OnLoaded($author$project$Type$ViewDocument$PaymentTransactionClick))))
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('Proceed to Pay')
										])),
									A2(
									$author$project$Material$Styled$Button$button,
									_List_fromArray(
										[
											$author$project$Material$Styled$Button$theme($author$project$Material$Styled$Button$blue),
											$author$project$Material$Styled$Button$styles($author$project$Page$ViewDocument$Modal$styles.passwordButtons),
											$author$project$Material$Styled$Button$onClick(
											$author$project$Types$OnViewDoc(
												$author$project$Type$ViewDocument$OnAuth(
													$author$project$Type$ViewDocument$OnLoaded($author$project$Type$ViewDocument$OnMyAlgoWalletClick))))
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('change wallet')
										])),
									A2(
									$author$project$Material$Styled$Button$button,
									_List_fromArray(
										[
											$author$project$Material$Styled$Button$styles($author$project$Page$ViewDocument$Modal$styles.passwordButtons),
											function () {
											var defaultTextTheme = $author$project$Material$Styled$Button$greyText;
											return $author$project$Material$Styled$Button$theme(
												_Utils_update(
													defaultTextTheme,
													{base: $author$project$Material$Styled$Color$grey200String}));
										}(),
											$author$project$Material$Styled$Button$onClick(
											$author$project$Types$OnViewDoc(
												$author$project$Type$ViewDocument$OnAuth(
													$author$project$Type$ViewDocument$OnLoaded($author$project$Type$ViewDocument$OnCloseModal))))
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('Back')
										]))
								]))
						]))),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.walletErrorText)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							A2($elm$core$Maybe$withDefault, '', loadedModel.optInError))
						]))
				]));
	});
var $author$project$Page$ViewDocument$Modal$deadlineExtensionButton = F3(
	function (loadedModel, sessionModel, user) {
		switch (sessionModel.$) {
			case 'Auth':
				var conditions = _List_fromArray(
					[
						_Utils_eq(
						$author$project$Data$PDF$User$emailFromUser(
							$author$project$Data$PDF$owner(loadedModel.pdf)),
						user.email),
						!_Utils_eq(
						$author$project$Data$PDF$status(loadedModel.pdf),
						$author$project$Data$PDF$Expired),
						!_Utils_eq(
						$author$project$Data$PDF$status(loadedModel.pdf),
						$author$project$Data$PDF$Completed),
						!_Utils_eq(
						$author$project$Data$PDF$dueDate(loadedModel.pdf),
						$elm$core$Maybe$Nothing)
					]);
				return A2(
					$elm$core$List$all,
					function (condition) {
						return condition;
					},
					conditions) ? A2(
					$author$project$Material$Styled$Button$button,
					_List_fromArray(
						[
							$author$project$Material$Styled$Button$theme($author$project$Material$Styled$Button$default),
							$author$project$Material$Styled$Button$styles($author$project$Page$ViewDocument$Modal$styles.docStatusBtn),
							$author$project$Material$Styled$Button$onClick(
							$author$project$Types$OnViewDoc(
								$author$project$Type$ViewDocument$OnAuth(
									$author$project$Type$ViewDocument$OnLoaded(
										$author$project$Type$ViewDocument$OnShowModal($author$project$Type$ViewDocument$DeadlineExtension)))))
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('Extend Document Due Date')
						])) : $rtfeldman$elm_css$Html$Styled$text('');
			case 'Anonymous':
				return $rtfeldman$elm_css$Html$Styled$text('');
			case 'NoAuth':
				return $rtfeldman$elm_css$Html$Styled$text('');
			default:
				return $rtfeldman$elm_css$Html$Styled$text('');
		}
	});
var $author$project$Page$ViewDocument$Modal$toMonthName = function (month) {
	switch (month) {
		case '01':
			return 'Jan';
		case '02':
			return 'Feb';
		case '03':
			return 'Mar';
		case '04':
			return 'Apr';
		case '05':
			return 'May';
		case '06':
			return 'Jun';
		case '07':
			return 'Jul';
		case '08':
			return 'Aug';
		case '09':
			return 'Sep';
		case '10':
			return 'Oct';
		case '11':
			return 'Nov';
		case '12':
			return 'Dec';
		default:
			return '';
	}
};
var $author$project$Page$ViewDocument$Modal$getFormattedDate = function (date) {
	var splitDate = $elm$core$List$reverse(
		A2($elm$core$String$split, '-', date));
	var formattedMonth = $author$project$Page$ViewDocument$Modal$toMonthName(
		A2(
			$elm$core$Maybe$withDefault,
			'01',
			$elm$core$List$head(
				A2($elm$core$List$drop, 1, splitDate))));
	return A2(
		$elm$core$String$join,
		' ',
		_List_fromArray(
			[
				A2(
				$elm$core$Maybe$withDefault,
				'',
				$elm$core$List$head(splitDate)),
				formattedMonth,
				A2(
				$elm$core$Maybe$withDefault,
				'',
				$elm$core$List$head(
					A2($elm$core$List$drop, 2, splitDate)))
			]));
};
var $author$project$Page$ViewDocument$Modal$showStatus = F2(
	function (pdf, model) {
		var viewDocumentPageLanguageData = model.languageSwitchModel.allLanguageData.location.viewDocumentPage;
		var _v0 = $author$project$Data$PDF$status(pdf);
		switch (_v0.$) {
			case 'Signing':
				return A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.docInfoModal)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(viewDocumentPageLanguageData.pendingSignature)
						]));
			case 'Viewing':
				var signers = _v0.a;
				return A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.docInfoModal)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							A2($elm$core$Maybe$withDefault, '', signers))
						]));
			case 'Completed':
				return A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.docInfoModal)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(viewDocumentPageLanguageData.documentCompleted)
						]));
			case 'Expired':
				return A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.docInfoModal)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(viewDocumentPageLanguageData.expired)
						]));
			default:
				var signerText = _v0.a;
				return A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.docInfoModal)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(signerText)
						]));
		}
	});
var $author$project$Page$ViewDocument$Modal$documentInfo = F4(
	function (loadedModel, sessionModel, user, model) {
		var viewDocumentPageLanguageData = model.languageSwitchModel.allLanguageData.location.viewDocumentPage;
		var fillTemplateLanguageData = model.languageSwitchModel.allLanguageData.location.fillTemplatePage;
		var _v0 = loadedModel;
		var pdf = _v0.pdf;
		return A2(
			$author$project$Material$Styled$Modal$modal,
			_List_fromArray(
				[
					$author$project$Material$Styled$Modal$open(true),
					$author$project$Material$Styled$Modal$contentContainerstyles($author$project$Page$ViewDocument$Modal$styles.activitiesModal),
					$author$project$Material$Styled$Modal$onClose(
					$author$project$Types$OnViewDoc(
						$author$project$Type$ViewDocument$OnAuth(
							$author$project$Type$ViewDocument$OnLoaded($author$project$Type$ViewDocument$OnCloseModal))))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.modalHeader)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.modalHeaderTxt)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(viewDocumentPageLanguageData.documentInformation)
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$img,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css(
									_List_fromArray(
										[
											$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer)
										])),
									$rtfeldman$elm_css$Html$Styled$Attributes$src($author$project$View$Theme$images.close),
									$rtfeldman$elm_css$Html$Styled$Events$onClick(
									$author$project$Types$OnViewDoc(
										$author$project$Type$ViewDocument$OnAuth(
											$author$project$Type$ViewDocument$OnLoaded($author$project$Type$ViewDocument$OnCloseModal))))
								]),
							_List_Nil)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.activitiesContainer)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css(
									_List_fromArray(
										[
											$rtfeldman$elm_css$Css$displayFlex,
											$rtfeldman$elm_css$Css$marginTop(
											$rtfeldman$elm_css$Css$px(20))
										]))
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.docDetailsSubTitle)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(viewDocumentPageLanguageData.documentId)
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.docInfoModal)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											$author$project$Data$PDF$id(pdf))
										]))
								])),
							_Utils_eq(
							$author$project$Data$PDF$templateId(pdf),
							$elm$core$Maybe$Nothing) ? $rtfeldman$elm_css$Html$Styled$text('') : A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css(
									_List_fromArray(
										[$rtfeldman$elm_css$Css$displayFlex]))
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.docDetailsSubTitle)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(viewDocumentPageLanguageData.templateId)
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.docInfoModal)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											A2(
												$elm$core$Maybe$withDefault,
												'',
												$author$project$Data$PDF$templateId(pdf)))
										]))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css(
									_List_fromArray(
										[$rtfeldman$elm_css$Css$displayFlex]))
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.docDetailsSubTitle)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(viewDocumentPageLanguageData.documentTitle)
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.docInfoModal)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											$author$project$Data$PDF$title(pdf))
										]))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css(
									_List_fromArray(
										[$rtfeldman$elm_css$Css$displayFlex]))
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.docDetailsSubTitle)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(fillTemplateLanguageData.sender)
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.docInfoModal)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											$author$project$Data$PDF$User$formatName(
												$author$project$Data$PDF$owner(pdf)))
										]))
								])),
							_Utils_eq(
							$author$project$Data$PDF$dueDate(pdf),
							$elm$core$Maybe$Nothing) ? $rtfeldman$elm_css$Html$Styled$text('') : A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css(
									_List_fromArray(
										[$rtfeldman$elm_css$Css$displayFlex]))
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.docDetailsSubTitle)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(fillTemplateLanguageData.dueDate)
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.docInfoModal)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											$author$project$Page$ViewDocument$Modal$getFormattedDate(
												A2(
													$elm$core$Maybe$withDefault,
													'',
													$author$project$Data$PDF$dueDate(pdf))))
										]))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css(
									_List_fromArray(
										[$rtfeldman$elm_css$Css$displayFlex]))
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.docDetailsSubTitle)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(viewDocumentPageLanguageData.status)
										])),
									A2($author$project$Page$ViewDocument$Modal$showStatus, pdf, model)
								])),
							_Utils_eq(
							$author$project$Data$PDF$additionalMsg(pdf),
							$elm$core$Maybe$Nothing) ? $rtfeldman$elm_css$Html$Styled$text('') : A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css(
									_List_fromArray(
										[$rtfeldman$elm_css$Css$displayFlex]))
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.docDetailsSubTitle)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('Custom Message')
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.docInfoModal)
										]),
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$i,
											_List_Nil,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(
													A2(
														$elm$core$Maybe$withDefault,
														'',
														$author$project$Data$PDF$additionalMsg(pdf)))
												]))
										]))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css(
									_List_fromArray(
										[
											$rtfeldman$elm_css$Css$paddingTop(
											$rtfeldman$elm_css$Css$px(15))
										]))
								]),
							_List_fromArray(
								[
									A3($author$project$Page$ViewDocument$Modal$deadlineExtensionButton, loadedModel, sessionModel, user)
								]))
						]))
				]));
	});
var $author$project$Page$ViewDocument$Modal$downloadIncompleteDocModal = function (model) {
	var viewDocumentPageLanguageData = model.languageSwitchModel.allLanguageData.location.viewDocumentPage;
	return A2(
		$author$project$Material$Styled$Modal$modal,
		_List_fromArray(
			[
				$author$project$Material$Styled$Modal$open(true),
				$author$project$Material$Styled$Modal$contentContainerstyles($author$project$Page$ViewDocument$Modal$styles.activitiesModal),
				$author$project$Material$Styled$Modal$onClose(
				$author$project$Types$OnViewDoc(
					$author$project$Type$ViewDocument$OnAuth(
						$author$project$Type$ViewDocument$OnLoaded($author$project$Type$ViewDocument$OnCloseModal))))
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.modalHeader)
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.modalDownloadHeaderTxt)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(viewDocumentPageLanguageData.downloadPartiallyCompletedDocument)
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$img,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer)
									])),
								$rtfeldman$elm_css$Html$Styled$Attributes$src($author$project$View$Theme$images.close),
								$rtfeldman$elm_css$Html$Styled$Events$onClick(
								$author$project$Types$OnViewDoc(
									$author$project$Type$ViewDocument$OnAuth(
										$author$project$Type$ViewDocument$OnLoaded($author$project$Type$ViewDocument$OnCloseModal))))
							]),
						_List_Nil)
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Css$overflowY($rtfeldman$elm_css$Css$auto)
							]))
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(viewDocumentPageLanguageData.downloadDocumentText),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Css$paddingTop(
										$rtfeldman$elm_css$Css$px(10))
									]))
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(viewDocumentPageLanguageData.downloadDocumentText2)
							])),
						A2($rtfeldman$elm_css$Html$Styled$br, _List_Nil, _List_Nil),
						A2(
						$author$project$Material$Styled$Button$button,
						_List_fromArray(
							[
								$author$project$Material$Styled$Button$onClick(
								$author$project$Types$OnViewDoc(
									$author$project$Type$ViewDocument$OnAuth(
										$author$project$Type$ViewDocument$OnLoaded($author$project$Type$ViewDocument$OnDownload))))
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(viewDocumentPageLanguageData.proceed)
							]))
					]))
			]));
};
var $author$project$Type$ViewDocument$OnGenerateCredentialModalClose = {$: 'OnGenerateCredentialModalClose'};
var $author$project$Type$ViewDocument$OnGenerateCredentialsSubmit = {$: 'OnGenerateCredentialsSubmit'};
var $author$project$Page$ViewDocument$Modal$generateCredentialModal = function (loadedModel) {
	var _v0 = loadedModel;
	var gcSignPointsBalance = _v0.gcSignPointsBalance;
	var generateCredentialcost = _v0.generateCredentialcost;
	var currentPointsBalance = A2($elm$core$Maybe$withDefault, 0, gcSignPointsBalance) / 100;
	var currentPointsTxt = 'You have ' + ($elm$core$String$fromFloat(currentPointsBalance) + ' SIGN points available. Click ');
	var generateCredentialCost = A2($elm$core$Maybe$withDefault, 0, generateCredentialcost) / 100;
	var failureTxt = 'This action costs ' + ($elm$core$String$fromFloat(generateCredentialCost) + ' SIGN points.');
	var successTxt = 'This action costs ' + ($elm$core$String$fromFloat(generateCredentialCost) + ' SIGN points, confirm credential generation?');
	return (_Utils_cmp(
		A2($elm$core$Maybe$withDefault, 0, gcSignPointsBalance),
		A2($elm$core$Maybe$withDefault, 0, generateCredentialcost)) > -1) ? A2(
		$author$project$Material$Styled$Modal$modal,
		_List_fromArray(
			[
				$author$project$Material$Styled$Modal$open(true),
				$author$project$Material$Styled$Modal$contentContainerstyles($author$project$Page$ViewDocument$Modal$styles.modalContainer)
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.modalHeader)
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.modalHeaderTxt)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('Generate Credentials')
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$img,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.icon),
								$rtfeldman$elm_css$Html$Styled$Attributes$src($author$project$View$Theme$images.close),
								$rtfeldman$elm_css$Html$Styled$Events$onClick(
								$author$project$Types$OnViewDoc(
									$author$project$Type$ViewDocument$OnAuth(
										$author$project$Type$ViewDocument$OnGenerateCredential($author$project$Type$ViewDocument$OnGenerateCredentialModalClose))))
							]),
						_List_Nil)
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(successTxt)
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(currentPointsTxt),
						A2(
						$rtfeldman$elm_css$Html$Styled$a,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$href($author$project$Data$Route$routeUrl.tokenManagement)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('here')
							])),
						$rtfeldman$elm_css$Html$Styled$text(' to get more.')
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.footer)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Material$Styled$Button$button,
						_List_fromArray(
							[
								$author$project$Material$Styled$Button$styles($author$project$Page$ViewDocument$Modal$styles.button),
								function () {
								var defaultTextTheme = $author$project$Material$Styled$Button$greyText;
								return $author$project$Material$Styled$Button$theme(
									_Utils_update(
										defaultTextTheme,
										{base: $author$project$Material$Styled$Color$grey200String}));
							}(),
								$author$project$Material$Styled$Button$onClick(
								$author$project$Types$OnViewDoc(
									$author$project$Type$ViewDocument$OnAuth(
										$author$project$Type$ViewDocument$OnGenerateCredential($author$project$Type$ViewDocument$OnGenerateCredentialModalClose))))
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('Cancel')
							])),
						A2(
						$author$project$Material$Styled$Button$button,
						_List_fromArray(
							[
								$author$project$Material$Styled$Button$styles($author$project$Page$ViewDocument$Modal$styles.button),
								$author$project$Material$Styled$Button$onClick(
								$author$project$Types$OnViewDoc(
									$author$project$Type$ViewDocument$OnAuth(
										$author$project$Type$ViewDocument$OnGenerateCredential($author$project$Type$ViewDocument$OnGenerateCredentialsSubmit))))
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('Confirm')
							]))
					]))
			])) : A2(
		$author$project$Material$Styled$Modal$modal,
		_List_fromArray(
			[
				$author$project$Material$Styled$Modal$open(true),
				$author$project$Material$Styled$Modal$contentContainerstyles($author$project$Page$ViewDocument$Modal$styles.activitiesModal)
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.modalHeader)
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.modalHeaderTxt)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('Genertate Credentials')
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$img,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.icon),
								$rtfeldman$elm_css$Html$Styled$Attributes$src($author$project$View$Theme$images.close),
								$rtfeldman$elm_css$Html$Styled$Events$onClick(
								$author$project$Types$OnViewDoc(
									$author$project$Type$ViewDocument$OnAuth(
										$author$project$Type$ViewDocument$OnLoaded($author$project$Type$ViewDocument$OnCloseModal))))
							]),
						_List_Nil)
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(failureTxt)
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(currentPointsTxt),
						A2(
						$rtfeldman$elm_css$Html$Styled$a,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$href($author$project$Data$Route$routeUrl.tokenManagement)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('here')
							])),
						$rtfeldman$elm_css$Html$Styled$text(' to get more.')
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.footer)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Material$Styled$Button$button,
						_List_fromArray(
							[
								$author$project$Material$Styled$Button$styles($author$project$Page$ViewDocument$Modal$styles.button),
								$author$project$Material$Styled$Button$onClick(
								$author$project$Types$OnViewDoc(
									$author$project$Type$ViewDocument$OnAuth(
										$author$project$Type$ViewDocument$OnLoaded($author$project$Type$ViewDocument$OnCloseModal))))
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('Back')
							]))
					]))
			]));
};
var $author$project$Page$ViewDocument$Modal$generatingCredentialModal = A2(
	$author$project$Material$Styled$Modal$modal,
	_List_fromArray(
		[
			$author$project$Material$Styled$Modal$open(true),
			$author$project$Material$Styled$Modal$contentContainerstyles($author$project$Page$ViewDocument$Modal$styles.modalContainer)
		]),
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.modalHeader)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.modalHeaderTxt)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('Generating Credentials')
						]))
				])),
			A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.modalBodyContainer)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[
									$rtfeldman$elm_css$Css$marginBottom(
									$rtfeldman$elm_css$Css$px(10))
								]))
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('We are generating your document credentials...')
						])),
					A2($author$project$Material$Styled$ProgressBar$linear, _List_Nil, _List_Nil)
				]))
		]));
var $author$project$Page$ViewDocument$Modal$loadingModal = function (status) {
	var stateTxt = function () {
		switch (status.$) {
			case 'Document':
				return 'Loading the document...';
			case 'Passcode':
				return 'Validating passcode...';
			case 'UpdatesName':
				return 'Updating first name and last name...';
			case 'Notarisation':
				return 'Notarising document, Please wait....';
			case 'GetWallet':
				return 'Getting wallet address, please wait...';
			case 'OptIn':
				return 'Opt-in in progress , please wait...';
			case 'Pay':
				return 'Payment transaction in progress, please wait...';
			case 'CheckWalletOptIn':
				return 'Checking if selected wallet has opt-In to SIGN ASA...';
			case 'RegisterWallet':
				return 'Registering your wallet, please wait...';
			default:
				return 'Sending reminder email, please wait...';
		}
	}();
	return A2(
		$author$project$Material$Styled$Modal$modal,
		_List_fromArray(
			[
				$author$project$Material$Styled$Modal$open(true),
				$author$project$Material$Styled$Modal$contentContainerstyles($author$project$Page$ViewDocument$Modal$styles.modalContainer)
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.modalHeader)
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.modalHeaderTxt)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('Loading...')
							]))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.modalBodyContainer)
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.modalBody)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(stateTxt)
							])),
						A2(
						$author$project$Material$Styled$ProgressBar$linear,
						_List_fromArray(
							[
								$author$project$Material$Styled$ProgressBar$containerStyle($author$project$Page$ViewDocument$Modal$styles.progressBar)
							]),
						_List_Nil)
					]))
			]));
};
var $author$project$Type$ViewDocument$OnPasscodeInput = function (a) {
	return {$: 'OnPasscodeInput', a: a};
};
var $author$project$Type$ViewDocument$OnPasscodeSubmit = {$: 'OnPasscodeSubmit'};
var $author$project$Page$ViewDocument$Modal$needPasscodeModal = F2(
	function (passcode, passcodeError) {
		return A2(
			$author$project$Material$Styled$Modal$modal,
			_List_fromArray(
				[
					$author$project$Material$Styled$Modal$open(true),
					$author$project$Material$Styled$Modal$contentContainerstyles($author$project$Page$ViewDocument$Modal$styles.modalContainer)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.modalHeader)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.modalHeaderTxt)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Passcode Required')
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.modalBody)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('This PDF is passcode-protected. Please enter a passcode to view and sign the PDF.')
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$form,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Events$onSubmit(
							$author$project$Types$OnViewDoc(
								$author$project$Type$ViewDocument$OnAuth(
									$author$project$Type$ViewDocument$OnLoaded($author$project$Type$ViewDocument$OnPasscodeSubmit))))
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Material$Styled$Input$password,
							_List_fromArray(
								[
									$author$project$Material$Styled$Input$containerStyles($author$project$Page$ViewDocument$Modal$styles.inputContainer),
									$author$project$Material$Styled$Input$label('Passcode'),
									$author$project$Material$Styled$Input$value(
									A2($elm$core$Maybe$withDefault, '', passcode)),
									$author$project$Material$Styled$Input$errorMessage(passcodeError),
									$author$project$Material$Styled$Input$onInput(
									A2(
										$elm$core$Basics$composeL,
										A2(
											$elm$core$Basics$composeL,
											A2($elm$core$Basics$composeL, $author$project$Types$OnViewDoc, $author$project$Type$ViewDocument$OnAuth),
											$author$project$Type$ViewDocument$OnLoaded),
										$author$project$Type$ViewDocument$OnPasscodeInput))
								]),
							_List_Nil),
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.modalBtns)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Material$Styled$Button$button,
									_List_fromArray(
										[
											$author$project$Material$Styled$Button$theme($author$project$Material$Styled$Button$blue),
											$author$project$Material$Styled$Button$styles($author$project$Page$ViewDocument$Modal$styles.passwordButtons)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('Submit')
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$a,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$href($author$project$Data$Route$routeUrl.dashboard)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('Cancel')
										]))
								]))
						]))
				]));
	});
var $author$project$Type$ViewDocument$OnPasswordInput = function (a) {
	return {$: 'OnPasswordInput', a: a};
};
var $author$project$Type$ViewDocument$OnPasswordSubmit = {$: 'OnPasswordSubmit'};
var $author$project$Page$ViewDocument$Modal$needPasswordModal = F2(
	function (password, passwordError) {
		return A2(
			$author$project$Material$Styled$Modal$modal,
			_List_fromArray(
				[
					$author$project$Material$Styled$Modal$open(true),
					$author$project$Material$Styled$Modal$contentContainerstyles($author$project$Page$ViewDocument$Modal$styles.modalContainer)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.modalHeader)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.modalHeaderTxt)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Password Required')
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.modalBody)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('This PDF is password-protected. Please enter a password to open the PDF.')
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$form,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Events$onSubmit(
							$author$project$Types$OnViewDoc(
								$author$project$Type$ViewDocument$OnAuth(
									$author$project$Type$ViewDocument$OnLoaded($author$project$Type$ViewDocument$OnPasswordSubmit))))
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Material$Styled$Input$password,
							_List_fromArray(
								[
									$author$project$Material$Styled$Input$containerStyles($author$project$Page$ViewDocument$Modal$styles.inputContainer),
									$author$project$Material$Styled$Input$label('Password'),
									$author$project$Material$Styled$Input$value(
									A2($elm$core$Maybe$withDefault, '', password)),
									$author$project$Material$Styled$Input$errorMessage(passwordError),
									$author$project$Material$Styled$Input$onInput(
									A2(
										$elm$core$Basics$composeL,
										A2(
											$elm$core$Basics$composeL,
											A2($elm$core$Basics$composeL, $author$project$Types$OnViewDoc, $author$project$Type$ViewDocument$OnAuth),
											$author$project$Type$ViewDocument$OnLoaded),
										$author$project$Type$ViewDocument$OnPasswordInput))
								]),
							_List_Nil),
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.modalBtns)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Material$Styled$Button$button,
									_List_fromArray(
										[
											$author$project$Material$Styled$Button$theme($author$project$Material$Styled$Button$blue),
											$author$project$Material$Styled$Button$styles($author$project$Page$ViewDocument$Modal$styles.passwordButtons)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('Submit')
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$a,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$href($author$project$Data$Route$routeUrl.dashboard)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('Cancel')
										]))
								]))
						]))
				]));
	});
var $author$project$Type$ViewDocument$OnNotariseDocumentAlgorand = {$: 'OnNotariseDocumentAlgorand'};
var $author$project$Type$ViewDocument$OnRequireNotarisation = {$: 'OnRequireNotarisation'};
var $author$project$Type$ViewDocument$OnWalletConnectClick = {$: 'OnWalletConnectClick'};
var $author$project$Type$ViewDocument$OnWalletConnectNotarizationClick = function (a) {
	return {$: 'OnWalletConnectNotarizationClick', a: a};
};
var $author$project$Type$ViewDocument$RetrieveUserAlgorandWallet = function (a) {
	return {$: 'RetrieveUserAlgorandWallet', a: a};
};
var $author$project$Page$ViewDocument$Modal$convertNetworkToString = function (currentUserNotarisationNetwork) {
	if (currentUserNotarisationNetwork.$ === 'Binance') {
		return 'Binance';
	} else {
		return 'Algorand';
	}
};
var $author$project$Page$ViewDocument$Modal$notariseModal = F7(
	function (notarisationNetwork, userPointsBalance, notariseBinanceCost, notariseAlgorandCost, userDetails, walletError, model) {
		var viewTemplatePageLanguageData = model.languageSwitchModel.allLanguageData.location.viewTemplatePage;
		var viewDocumentPageLanguageData = model.languageSwitchModel.allLanguageData.location.viewDocumentPage;
		var userAlgorandWalletAddress = A2($elm$core$Maybe$withDefault, '', userDetails.algorandWalletAddress);
		var displayWalletTxt = _Utils_eq(userDetails.algorandWalletAddress, $elm$core$Maybe$Nothing) ? 'Connect Account' : 'Change Account';
		var displayRegisteredWalletTxt = function () {
			var _v2 = _Utils_Tuple2(
				userDetails.algorandWalletAddress,
				$author$project$Model$Settings$convertStringToPayment(userDetails.paymentMethod));
			if (_v2.a.$ === 'Nothing') {
				switch (_v2.b.$) {
					case 'AlgoWallet':
						var _v3 = _v2.a;
						var _v4 = _v2.b;
						return 'You have chosen to pay with your own MyAlgo Wallet. Please connect your wallet.';
					case 'WalletConnect':
						var _v5 = _v2.a;
						var _v6 = _v2.b;
						return 'You have chosen to pay with your own Algorand Wallet. Please connect your wallet.';
					default:
						var _v7 = _v2.a;
						var _v8 = _v2.b;
						return '';
				}
			} else {
				switch (_v2.b.$) {
					case 'AlgoWallet':
						var address = _v2.a.a;
						var _v9 = _v2.b;
						return 'You have chosen to proceed with notarising this document using 5 SIGN points through the following MyAlgo Wallet address linked to your account: ' + address;
					case 'WalletConnect':
						var address = _v2.a.a;
						var _v10 = _v2.b;
						return 'You have chosen to proceed with notarising this document using 5 SIGN points through the following Algorand Wallet address linked to your account: ' + address;
					default:
						var _v11 = _v2.b;
						return '';
				}
			}
		}();
		var cancelText = model.languageSwitchModel.allLanguageData.location.addressBookPage.cancelBtn;
		var binanceFailureTxt = 'This action costs ' + ($elm$core$String$fromFloat(notariseBinanceCost) + (' SIGN points, you only have ' + ($elm$core$String$fromFloat(userPointsBalance) + ' SIGN points available.')));
		var binanceActionTxt = _Utils_ap(
			viewDocumentPageLanguageData.notarisationCost,
			_Utils_ap(
				$elm$core$String$fromFloat(notariseBinanceCost),
				viewDocumentPageLanguageData.notarisationCost2));
		var algorandFailureTxt = 'This action costs ' + ($elm$core$String$fromFloat(notariseAlgorandCost) + (' SIGN points, you only have ' + ($elm$core$String$fromFloat(userPointsBalance) + ' SIGN points available.')));
		var algorandActionTxt = _Utils_ap(
			viewDocumentPageLanguageData.notarisationCost,
			_Utils_ap(
				$elm$core$String$fromFloat(notariseAlgorandCost),
				viewDocumentPageLanguageData.notarisationCost2));
		if (notarisationNetwork.$ === 'Binance') {
			return (_Utils_cmp(userPointsBalance, notariseBinanceCost) > -1) ? A2(
				$author$project$Material$Styled$Modal$modal,
				_List_fromArray(
					[
						$author$project$Material$Styled$Modal$open(true),
						$author$project$Material$Styled$Modal$contentContainerstyles($author$project$Page$ViewDocument$Modal$styles.modalContainer)
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.modalHeader)
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$span,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.modalHeaderTxt)
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										viewDocumentPageLanguageData.notariseDocument + (' (' + ($author$project$Page$ViewDocument$Modal$convertNetworkToString(notarisationNetwork) + ' Network)')))
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$img,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.icon),
										$rtfeldman$elm_css$Html$Styled$Attributes$src($author$project$View$Theme$images.close),
										$rtfeldman$elm_css$Html$Styled$Events$onClick(
										$author$project$Types$OnViewDoc(
											$author$project$Type$ViewDocument$OnAuth(
												$author$project$Type$ViewDocument$OnLoaded($author$project$Type$ViewDocument$OnCloseModal))))
									]),
								_List_Nil)
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(binanceActionTxt)
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.footer)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Material$Styled$Button$button,
								_List_fromArray(
									[
										$author$project$Material$Styled$Button$styles($author$project$Page$ViewDocument$Modal$styles.button),
										function () {
										var defaultTextTheme = $author$project$Material$Styled$Button$greyText;
										return $author$project$Material$Styled$Button$theme(
											_Utils_update(
												defaultTextTheme,
												{base: $author$project$Material$Styled$Color$grey200String}));
									}(),
										$author$project$Material$Styled$Button$onClick(
										$author$project$Types$OnViewDoc(
											$author$project$Type$ViewDocument$OnAuth(
												$author$project$Type$ViewDocument$OnLoaded($author$project$Type$ViewDocument$OnCloseModal))))
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(cancelText)
									])),
								A2(
								$author$project$Material$Styled$Button$button,
								_List_fromArray(
									[
										$author$project$Material$Styled$Button$styles($author$project$Page$ViewDocument$Modal$styles.button),
										$author$project$Material$Styled$Button$onClick(
										$author$project$Types$OnViewDoc(
											$author$project$Type$ViewDocument$OnAuth(
												$author$project$Type$ViewDocument$OnLoaded($author$project$Type$ViewDocument$OnRequireNotarisation))))
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(viewTemplatePageLanguageData.confirm)
									]))
							]))
					])) : A2(
				$author$project$Material$Styled$Modal$modal,
				_List_fromArray(
					[
						$author$project$Material$Styled$Modal$open(true),
						$author$project$Material$Styled$Modal$contentContainerstyles($author$project$Page$ViewDocument$Modal$styles.activitiesModal)
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.modalHeader)
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$span,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.modalHeaderTxt)
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										viewDocumentPageLanguageData.notariseDocument + (' (' + ($author$project$Page$ViewDocument$Modal$convertNetworkToString(notarisationNetwork) + ' Network)')))
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$img,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.icon),
										$rtfeldman$elm_css$Html$Styled$Attributes$src($author$project$View$Theme$images.close),
										$rtfeldman$elm_css$Html$Styled$Events$onClick(
										$author$project$Types$OnViewDoc(
											$author$project$Type$ViewDocument$OnAuth(
												$author$project$Type$ViewDocument$OnLoaded($author$project$Type$ViewDocument$OnCloseModal))))
									]),
								_List_Nil)
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(binanceFailureTxt)
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.footer)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Material$Styled$Button$button,
								_List_fromArray(
									[
										$author$project$Material$Styled$Button$styles($author$project$Page$ViewDocument$Modal$styles.button),
										$author$project$Material$Styled$Button$onClick(
										$author$project$Types$OnViewDoc(
											$author$project$Type$ViewDocument$OnAuth(
												$author$project$Type$ViewDocument$OnLoaded($author$project$Type$ViewDocument$OnCloseModal))))
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(viewTemplatePageLanguageData.back)
									]))
							]))
					]));
		} else {
			var _v1 = $author$project$Model$Settings$convertStringToPayment(userDetails.paymentMethod);
			switch (_v1.$) {
				case 'SystemBalance':
					return (_Utils_cmp(userPointsBalance, notariseAlgorandCost) > -1) ? A2(
						$author$project$Material$Styled$Modal$modal,
						_List_fromArray(
							[
								$author$project$Material$Styled$Modal$open(true),
								$author$project$Material$Styled$Modal$contentContainerstyles($author$project$Page$ViewDocument$Modal$styles.modalContainer)
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.modalHeader)
									]),
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$span,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.modalHeaderTxt)
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(
												viewDocumentPageLanguageData.notariseDocument + (' (' + ($author$project$Page$ViewDocument$Modal$convertNetworkToString(notarisationNetwork) + ' Network)')))
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$img,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.icon),
												$rtfeldman$elm_css$Html$Styled$Attributes$src($author$project$View$Theme$images.close),
												$rtfeldman$elm_css$Html$Styled$Events$onClick(
												$author$project$Types$OnViewDoc(
													$author$project$Type$ViewDocument$OnAuth(
														$author$project$Type$ViewDocument$OnLoaded($author$project$Type$ViewDocument$OnCloseModal))))
											]),
										_List_Nil)
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(algorandActionTxt)
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.footer)
									]),
								_List_fromArray(
									[
										A2(
										$author$project$Material$Styled$Button$button,
										_List_fromArray(
											[
												$author$project$Material$Styled$Button$styles($author$project$Page$ViewDocument$Modal$styles.button),
												function () {
												var defaultTextTheme = $author$project$Material$Styled$Button$greyText;
												return $author$project$Material$Styled$Button$theme(
													_Utils_update(
														defaultTextTheme,
														{base: $author$project$Material$Styled$Color$grey200String}));
											}(),
												$author$project$Material$Styled$Button$onClick(
												$author$project$Types$OnViewDoc(
													$author$project$Type$ViewDocument$OnAuth(
														$author$project$Type$ViewDocument$OnLoaded($author$project$Type$ViewDocument$OnCloseModal))))
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(cancelText)
											])),
										A2(
										$author$project$Material$Styled$Button$button,
										_List_fromArray(
											[
												$author$project$Material$Styled$Button$styles($author$project$Page$ViewDocument$Modal$styles.button),
												$author$project$Material$Styled$Button$onClick(
												$author$project$Types$OnViewDoc(
													$author$project$Type$ViewDocument$OnAuth(
														$author$project$Type$ViewDocument$OnLoaded($author$project$Type$ViewDocument$OnNotariseDocumentAlgorand))))
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(viewTemplatePageLanguageData.confirm)
											]))
									]))
							])) : A2(
						$author$project$Material$Styled$Modal$modal,
						_List_fromArray(
							[
								$author$project$Material$Styled$Modal$open(true),
								$author$project$Material$Styled$Modal$contentContainerstyles($author$project$Page$ViewDocument$Modal$styles.activitiesModal)
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.modalHeader)
									]),
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$span,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.modalHeaderTxt)
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(
												viewDocumentPageLanguageData.notariseDocument + (' (' + ($author$project$Page$ViewDocument$Modal$convertNetworkToString(notarisationNetwork) + ' Network)')))
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$img,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.icon),
												$rtfeldman$elm_css$Html$Styled$Attributes$src($author$project$View$Theme$images.close),
												$rtfeldman$elm_css$Html$Styled$Events$onClick(
												$author$project$Types$OnViewDoc(
													$author$project$Type$ViewDocument$OnAuth(
														$author$project$Type$ViewDocument$OnLoaded($author$project$Type$ViewDocument$OnCloseModal))))
											]),
										_List_Nil)
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(algorandFailureTxt)
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.footer)
									]),
								_List_fromArray(
									[
										A2(
										$author$project$Material$Styled$Button$button,
										_List_fromArray(
											[
												$author$project$Material$Styled$Button$styles($author$project$Page$ViewDocument$Modal$styles.button),
												$author$project$Material$Styled$Button$onClick(
												$author$project$Types$OnViewDoc(
													$author$project$Type$ViewDocument$OnAuth(
														$author$project$Type$ViewDocument$OnLoaded($author$project$Type$ViewDocument$OnCloseModal))))
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(viewTemplatePageLanguageData.back)
											]))
									]))
							]));
				case 'AlgoWallet':
					return A2(
						$author$project$Material$Styled$Modal$modal,
						_List_fromArray(
							[
								$author$project$Material$Styled$Modal$open(true),
								$author$project$Material$Styled$Modal$contentContainerstyles($author$project$Page$ViewDocument$Modal$styles.modalContainer)
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.modalHeader)
									]),
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$span,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.modalHeaderTxt)
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('Notarise Document (MyAlgo Wallet)')
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$img,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.icon),
												$rtfeldman$elm_css$Html$Styled$Attributes$src($author$project$View$Theme$images.close),
												$rtfeldman$elm_css$Html$Styled$Events$onClick(
												$author$project$Types$OnViewDoc(
													$author$project$Type$ViewDocument$OnAuth(
														$author$project$Type$ViewDocument$OnLoaded($author$project$Type$ViewDocument$OnCloseModal))))
											]),
										_List_Nil)
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.overFlowText)
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(displayRegisteredWalletTxt)
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.walletErrorText)
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(walletError)
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.verticalfooter)
									]),
								_List_fromArray(
									[
										A2(
										$author$project$Material$Styled$Button$button,
										_List_fromArray(
											[
												$author$project$Material$Styled$Button$styles($author$project$Page$ViewDocument$Modal$styles.verticalButton),
												$author$project$Material$Styled$Button$theme($author$project$Material$Styled$Button$default),
												$author$project$Material$Styled$Button$onClick(
												$author$project$Types$OnViewDoc(
													$author$project$Type$ViewDocument$OnAuth(
														$author$project$Type$ViewDocument$OnLoaded($author$project$Type$ViewDocument$OnMyAlgoWalletClick))))
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(displayWalletTxt)
											])),
										_Utils_eq(userDetails.algorandWalletAddress, $elm$core$Maybe$Nothing) ? $rtfeldman$elm_css$Html$Styled$text('') : A2(
										$rtfeldman$elm_css$Html$Styled$div,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.buttonContainer2)
											]),
										_List_fromArray(
											[
												A2(
												$author$project$Material$Styled$Button$button,
												_List_fromArray(
													[
														$author$project$Material$Styled$Button$styles($author$project$Page$ViewDocument$Modal$styles.verticalButton),
														$author$project$Material$Styled$Button$onClick(
														$author$project$Types$OnViewDoc(
															$author$project$Type$ViewDocument$OnAuth(
																$author$project$Type$ViewDocument$OnLoaded(
																	$author$project$Type$ViewDocument$RetrieveUserAlgorandWallet(
																		_List_fromArray(
																			[userAlgorandWalletAddress]))))))
													]),
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text('PROCEED USING MYALGO WALLET')
													]))
											])),
										A2(
										$author$project$Material$Styled$Button$button,
										_List_fromArray(
											[
												$author$project$Material$Styled$Button$styles($author$project$Page$ViewDocument$Modal$styles.verticalButton),
												$author$project$Material$Styled$Button$theme($author$project$Material$Styled$Button$default),
												$author$project$Material$Styled$Button$onClick(
												$author$project$Types$OnViewDoc(
													$author$project$Type$ViewDocument$OnAuth(
														$author$project$Type$ViewDocument$OnLoaded($author$project$Type$ViewDocument$OnCloseModal))))
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(cancelText)
											]))
									]))
							]));
				default:
					return A2(
						$author$project$Material$Styled$Modal$modal,
						_List_fromArray(
							[
								$author$project$Material$Styled$Modal$open(true),
								$author$project$Material$Styled$Modal$contentContainerstyles($author$project$Page$ViewDocument$Modal$styles.modalContainer)
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.modalHeader)
									]),
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$span,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.modalHeaderTxt)
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('Notarise Document (Algorand Wallet)')
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$img,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.icon),
												$rtfeldman$elm_css$Html$Styled$Attributes$src($author$project$View$Theme$images.close),
												$rtfeldman$elm_css$Html$Styled$Events$onClick(
												$author$project$Types$OnViewDoc(
													$author$project$Type$ViewDocument$OnAuth(
														$author$project$Type$ViewDocument$OnLoaded($author$project$Type$ViewDocument$OnCloseModal))))
											]),
										_List_Nil)
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.overFlowText)
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(displayRegisteredWalletTxt)
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.walletErrorText)
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(walletError)
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.verticalfooter)
									]),
								_List_fromArray(
									[
										A2(
										$author$project$Material$Styled$Button$button,
										_List_fromArray(
											[
												$author$project$Material$Styled$Button$styles($author$project$Page$ViewDocument$Modal$styles.verticalButton),
												$author$project$Material$Styled$Button$theme($author$project$Material$Styled$Button$default),
												$author$project$Material$Styled$Button$onClick(
												$author$project$Types$OnViewDoc(
													$author$project$Type$ViewDocument$OnAuth(
														$author$project$Type$ViewDocument$OnLoaded($author$project$Type$ViewDocument$OnWalletConnectClick))))
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(displayWalletTxt)
											])),
										_Utils_eq(userDetails.algorandWalletAddress, $elm$core$Maybe$Nothing) ? $rtfeldman$elm_css$Html$Styled$text('') : A2(
										$rtfeldman$elm_css$Html$Styled$div,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.buttonContainer2)
											]),
										_List_fromArray(
											[
												A2(
												$author$project$Material$Styled$Button$button,
												_List_fromArray(
													[
														$author$project$Material$Styled$Button$styles($author$project$Page$ViewDocument$Modal$styles.verticalButton),
														$author$project$Material$Styled$Button$onClick(
														$author$project$Types$OnViewDoc(
															$author$project$Type$ViewDocument$OnAuth(
																$author$project$Type$ViewDocument$OnLoaded(
																	$author$project$Type$ViewDocument$OnWalletConnectNotarizationClick(userAlgorandWalletAddress)))))
													]),
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text('PROCEED USING ALGORAND WALLET')
													]))
											])),
										A2(
										$author$project$Material$Styled$Button$button,
										_List_fromArray(
											[
												$author$project$Material$Styled$Button$styles($author$project$Page$ViewDocument$Modal$styles.verticalButton),
												$author$project$Material$Styled$Button$theme($author$project$Material$Styled$Button$default),
												$author$project$Material$Styled$Button$onClick(
												$author$project$Types$OnViewDoc(
													$author$project$Type$ViewDocument$OnAuth(
														$author$project$Type$ViewDocument$OnLoaded($author$project$Type$ViewDocument$OnCloseModal))))
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(cancelText)
											]))
									]))
							]));
			}
		}
	});
var $author$project$Page$ViewDocument$Modal$notariseDocumentModal = F4(
	function (notarisationNetwork, userDetails, loadedModel, model) {
		var _v0 = loadedModel;
		var signPointsBalance = _v0.signPointsBalance;
		var binanceNotarisationCost = _v0.binanceNotarisationCost;
		var algorandNotarisationCost = _v0.algorandNotarisationCost;
		var walletError = _v0.walletError;
		var algorandNotariseNetworkCost = A2($elm$core$Maybe$withDefault, 0, algorandNotarisationCost) / 100;
		var binanceNotariseNetworkCost = A2($elm$core$Maybe$withDefault, 0, binanceNotarisationCost) / 100;
		var currentPointsBalance = A2($elm$core$Maybe$withDefault, 0, signPointsBalance) / 100;
		var algoWalletError = A2($elm$core$Maybe$withDefault, '', walletError);
		return A7($author$project$Page$ViewDocument$Modal$notariseModal, notarisationNetwork, currentPointsBalance, binanceNotariseNetworkCost, algorandNotariseNetworkCost, userDetails, algoWalletError, model);
	});
var $author$project$Page$ViewDocument$Modal$notariseDocumentSuccess = function (notarisationNetwork) {
	if (notarisationNetwork.$ === 'Binance') {
		return A2(
			$author$project$Material$Styled$Modal$modal,
			_List_fromArray(
				[
					$author$project$Material$Styled$Modal$open(true),
					$author$project$Material$Styled$Modal$contentContainerstyles($author$project$Page$ViewDocument$Modal$styles.modalContainer)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.modalHeader)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.modalHeaderTxt)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Notarisation in Progress')
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.modalBodyContainer)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.modalBody)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Once document notarisation is complete,  ' + 'you will be able to generate credentials.')
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.modalBtns)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Material$Styled$Button$button,
									_List_fromArray(
										[
											$author$project$Material$Styled$Button$theme($author$project$Material$Styled$Button$blue),
											$author$project$Material$Styled$Button$styles($author$project$Page$ViewDocument$Modal$styles.dashboardBtn),
											$author$project$Material$Styled$Button$onClick(
											$author$project$Types$OnViewDoc(
												$author$project$Type$ViewDocument$OnAuth($author$project$Type$ViewDocument$OnNavigateToDashboard)))
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('Back To Dashboard')
										]))
								]))
						]))
				]));
	} else {
		return A2(
			$author$project$Material$Styled$Modal$modal,
			_List_fromArray(
				[
					$author$project$Material$Styled$Modal$open(true),
					$author$project$Material$Styled$Modal$contentContainerstyles($author$project$Page$ViewDocument$Modal$styles.modalContainer)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.modalHeader)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.modalHeaderTxt)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Document Notarisation Completed')
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.modalBodyContainer)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.modalBody)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Document successfully notarized on Algorand blockchain.')
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.modalBtns)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Material$Styled$Button$button,
									_List_fromArray(
										[
											$author$project$Material$Styled$Button$theme($author$project$Material$Styled$Button$blue),
											$author$project$Material$Styled$Button$styles($author$project$Page$ViewDocument$Modal$styles.dashboardBtn),
											$author$project$Material$Styled$Button$onClick(
											$author$project$Types$OnViewDoc(
												$author$project$Type$ViewDocument$OnAuth($author$project$Type$ViewDocument$OnNavigateToDashboard)))
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('Back To Dashboard')
										]))
								]))
						]))
				]));
	}
};
var $author$project$Page$ViewDocument$Modal$paymentModal = F2(
	function (selectedAddress, loadedModel) {
		return A2(
			$author$project$Material$Styled$Modal$modal,
			_List_fromArray(
				[
					$author$project$Material$Styled$Modal$open(true),
					$author$project$Material$Styled$Modal$contentContainerstyles($author$project$Page$ViewDocument$Modal$styles.modalContainer)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.modalHeader)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.modalHeaderTxt)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('ASA transfer transaction')
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.walletAddress)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Selected wallet address: ' + selectedAddress)
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.buttonContainer)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Material$Styled$Button$button,
							_List_fromArray(
								[
									$author$project$Material$Styled$Button$theme($author$project$Material$Styled$Button$blue),
									$author$project$Material$Styled$Button$styles($author$project$Page$ViewDocument$Modal$styles.passwordButtons),
									$author$project$Material$Styled$Button$onClick(
									$author$project$Types$OnViewDoc(
										$author$project$Type$ViewDocument$OnAuth(
											$author$project$Type$ViewDocument$OnLoaded($author$project$Type$ViewDocument$PaymentTransactionClick))))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Proceed to Pay')
								])),
							A2(
							$author$project$Material$Styled$Button$button,
							_List_fromArray(
								[
									$author$project$Material$Styled$Button$styles($author$project$Page$ViewDocument$Modal$styles.passwordButtons),
									function () {
									var defaultTextTheme = $author$project$Material$Styled$Button$greyText;
									return $author$project$Material$Styled$Button$theme(
										_Utils_update(
											defaultTextTheme,
											{base: $author$project$Material$Styled$Color$grey200String}));
								}(),
									$author$project$Material$Styled$Button$onClick(
									$author$project$Types$OnViewDoc(
										$author$project$Type$ViewDocument$OnAuth(
											$author$project$Type$ViewDocument$OnLoaded($author$project$Type$ViewDocument$OnCloseModal))))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Back')
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.walletErrorText)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							A2($elm$core$Maybe$withDefault, '', loadedModel.optInError))
						]))
				]));
	});
var $author$project$Type$ViewDocument$CreditCard = {$: 'CreditCard'};
var $author$project$Type$ViewDocument$MobilePhone = {$: 'MobilePhone'};
var $author$project$Type$ViewDocument$MyInfo = {$: 'MyInfo'};
var $author$project$Type$ViewDocument$Wallet = {$: 'Wallet'};
var $author$project$Page$ViewDocument$Modal$checkVerification = F2(
	function (isVerified, placement) {
		var placementTxt = function () {
			var _v0 = _Utils_Tuple2(placement, isVerified);
			_v0$8:
			while (true) {
				if (_v0.b) {
					switch (_v0.a.$) {
						case 'CreditCard':
							var _v1 = _v0.a;
							return 'Verified with credit card.';
						case 'MobilePhone':
							var _v3 = _v0.a;
							return 'Verified with Mobile Phone.';
						case 'Wallet':
							var _v5 = _v0.a;
							return 'Verified with Wallet address.';
						case 'MyInfo':
							var _v7 = _v0.a;
							return 'Verified with My Info.';
						default:
							break _v0$8;
					}
				} else {
					switch (_v0.a.$) {
						case 'CreditCard':
							var _v2 = _v0.a;
							return 'Not verified with credit card.';
						case 'MobilePhone':
							var _v4 = _v0.a;
							return 'Not verified with Mobile Phone.';
						case 'Wallet':
							var _v6 = _v0.a;
							return 'Not verified with Wallet address.';
						case 'MyInfo':
							var _v8 = _v0.a;
							return 'Not verified with My Info.';
						default:
							break _v0$8;
					}
				}
			}
			return '';
		}();
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.messageContainer)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.toolTip)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(placementTxt)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.arrowDown)
						]),
					_List_Nil)
				]));
	});
var $author$project$Page$ViewDocument$Modal$displayIcon = F2(
	function (verification, icon) {
		return verification ? A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					icon,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Svg$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.allIcon)
						]),
					_List_Nil)
				])) : A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					icon,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Svg$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.allIcon),
							$rtfeldman$elm_css$Svg$Styled$Attributes$fill('grey')
						]),
					_List_Nil)
				]));
	});
var $author$project$Page$ViewDocument$Modal$displayToolTip = F3(
	function (toolTip, iconPlacement, userEmail) {
		if (toolTip.$ === 'NoHover') {
			return false;
		} else {
			var placement = toolTip.a;
			var email = toolTip.b;
			return (_Utils_eq(placement, iconPlacement) && _Utils_eq(email, userEmail)) ? true : false;
		}
	});
var $author$project$Page$ViewDocument$Modal$displayIconToolTip = F5(
	function (placement, email, bool, toolTip, icon) {
		return A5(
			$author$project$View$InfomationToolTip$view2,
			$author$project$Types$OnViewDoc(
				$author$project$Type$ViewDocument$OnAuth(
					$author$project$Type$ViewDocument$OnLoaded(
						A3($author$project$Type$ViewDocument$OnHover, placement, $author$project$Type$ViewDocument$Enters, email)))),
			$author$project$Types$OnViewDoc(
				$author$project$Type$ViewDocument$OnAuth(
					$author$project$Type$ViewDocument$OnLoaded(
						A3($author$project$Type$ViewDocument$OnHover, placement, $author$project$Type$ViewDocument$Leaves, email)))),
			A3($author$project$Page$ViewDocument$Modal$displayToolTip, toolTip, placement, email),
			A2($author$project$Page$ViewDocument$Modal$checkVerification, bool, placement),
			A2($author$project$Page$ViewDocument$Modal$displayIcon, bool, icon));
	});
var $author$project$Page$ViewDocument$Modal$displayImage = function (verification) {
	return verification ? A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$img,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$src($author$project$View$Theme$images.myInfoLogo),
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.myInfoImage)
					]),
				_List_Nil)
			])) : A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$img,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$src($author$project$View$Theme$images.myInfoLogo),
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.myInfoImageBlurred)
					]),
				_List_Nil)
			]));
};
var $author$project$Page$ViewDocument$Modal$displayImageToolTip = F4(
	function (placement, email, bool, toolTip) {
		return A5(
			$author$project$View$InfomationToolTip$viewImage,
			$author$project$Types$OnViewDoc(
				$author$project$Type$ViewDocument$OnAuth(
					$author$project$Type$ViewDocument$OnLoaded(
						A3($author$project$Type$ViewDocument$OnHover, placement, $author$project$Type$ViewDocument$Enters, email)))),
			$author$project$Types$OnViewDoc(
				$author$project$Type$ViewDocument$OnAuth(
					$author$project$Type$ViewDocument$OnLoaded(
						A3($author$project$Type$ViewDocument$OnHover, placement, $author$project$Type$ViewDocument$Leaves, email)))),
			A3($author$project$Page$ViewDocument$Modal$displayToolTip, toolTip, placement, email),
			A2($author$project$Page$ViewDocument$Modal$checkVerification, bool, placement),
			$author$project$Page$ViewDocument$Modal$displayImage(bool));
	});
var $author$project$Page$ViewDocument$Modal$signerCard = F3(
	function (signer, model, isSigningOrder) {
		var newEmail = signer.email + ' ';
		return A2(
			$author$project$Material$Styled$Card$card,
			_List_fromArray(
				[
					$author$project$Material$Styled$Card$containerStyles($author$project$Page$ViewDocument$Modal$styles.cardContainer)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.cardHeaderContent)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.avatar)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									A2($elm$core$String$left, 1, signer.name))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.nameContent)
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.contentColumn)
										]),
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$span,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$css(
													_Utils_ap($author$project$Page$ViewDocument$Modal$styles.boldText, $author$project$Page$ViewDocument$Modal$styles.nameContentHeaderFont))
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(signer.name),
													$rtfeldman$elm_css$Html$Styled$text(' '),
													_Utils_eq(signer.status, $author$project$Type$ViewDocument$Signed) ? $rtfeldman$elm_css$Html$Styled$text('(Signed)') : $rtfeldman$elm_css$Html$Styled$text('')
												])),
											A2(
											$rtfeldman$elm_css$Html$Styled$span,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.nameContentSubContentFont)
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(signer.email)
												]))
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$div,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.iconContainer)
												]),
											_List_fromArray(
												[
													A5($author$project$Page$ViewDocument$Modal$displayIconToolTip, $author$project$Type$ViewDocument$CreditCard, newEmail, signer.verifyStripe, model.toolTip, $author$project$Material$Styled$Icon$payment),
													A5($author$project$Page$ViewDocument$Modal$displayIconToolTip, $author$project$Type$ViewDocument$MobilePhone, newEmail, signer.verifyMobilePhone, model.toolTip, $author$project$Material$Styled$Icon$phoneLinkLock),
													A5($author$project$Page$ViewDocument$Modal$displayIconToolTip, $author$project$Type$ViewDocument$Wallet, newEmail, signer.verifyWallet, model.toolTip, $author$project$Material$Styled$Icon$accountBalanceWallet),
													A4($author$project$Page$ViewDocument$Modal$displayImageToolTip, $author$project$Type$ViewDocument$MyInfo, newEmail, signer.verifyMyInfo, model.toolTip)
												])),
											isSigningOrder ? A2(
											$rtfeldman$elm_css$Html$Styled$span,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.nameContentSubContentFont)
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text('Signing Order: '),
													$rtfeldman$elm_css$Html$Styled$text(
													$elm$core$String$fromInt(signer.signOrder))
												])) : $rtfeldman$elm_css$Html$Styled$text('')
										]))
								]))
						])),
					_Utils_eq(signer.role, $elm$core$Maybe$Nothing) ? $rtfeldman$elm_css$Html$Styled$text('') : A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.roleName)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							'Role: ' + A2($elm$core$Maybe$withDefault, '', signer.role))
						]))
				]));
	});
var $author$project$Page$ViewDocument$Modal$getSignersCard = F3(
	function (isSigningOrder, model, signers) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_Nil,
			A2(
				$elm$core$List$cons,
				$rtfeldman$elm_css$Html$Styled$text('Signer(s)'),
				A2(
					$elm$core$List$map,
					function (user) {
						return A3($author$project$Page$ViewDocument$Modal$signerCard, user, model, isSigningOrder);
					},
					signers)));
	});
var $author$project$Page$ViewDocument$Modal$viewerCard = F2(
	function (model, signer) {
		return A2(
			$author$project$Material$Styled$Card$card,
			_List_fromArray(
				[
					$author$project$Material$Styled$Card$containerStyles($author$project$Page$ViewDocument$Modal$styles.cardContainer)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.cardHeaderContent)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.avatar)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									A2($elm$core$String$left, 1, signer.name))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.nameContent)
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.contentColumn)
										]),
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$span,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$css(
													_Utils_ap($author$project$Page$ViewDocument$Modal$styles.boldText, $author$project$Page$ViewDocument$Modal$styles.nameContentHeaderFont))
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(signer.name)
												])),
											A2(
											$rtfeldman$elm_css$Html$Styled$span,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.nameContentSubContentFont)
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(signer.email)
												]))
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$div,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.iconContainer)
												]),
											_List_fromArray(
												[
													A5($author$project$Page$ViewDocument$Modal$displayIconToolTip, $author$project$Type$ViewDocument$CreditCard, signer.email, signer.verifyStripe, model.toolTip, $author$project$Material$Styled$Icon$payment),
													A5($author$project$Page$ViewDocument$Modal$displayIconToolTip, $author$project$Type$ViewDocument$MobilePhone, signer.email, signer.verifyMobilePhone, model.toolTip, $author$project$Material$Styled$Icon$phoneLinkLock),
													A5($author$project$Page$ViewDocument$Modal$displayIconToolTip, $author$project$Type$ViewDocument$Wallet, signer.email, signer.verifyWallet, model.toolTip, $author$project$Material$Styled$Icon$accountBalanceWallet),
													A4($author$project$Page$ViewDocument$Modal$displayImageToolTip, $author$project$Type$ViewDocument$MyInfo, signer.email, signer.verifyMyInfo, model.toolTip)
												]))
										]))
								]))
						])),
					_Utils_eq(signer.role, $elm$core$Maybe$Nothing) ? $rtfeldman$elm_css$Html$Styled$text('') : A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.roleName)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							'Role: ' + A2($elm$core$Maybe$withDefault, '', signer.role))
						]))
				]));
	});
var $author$project$Page$ViewDocument$Modal$getViewerCard = F2(
	function (model, viewers) {
		return A2(
			$elm$core$List$map,
			function (viewer) {
				return A2(
					$author$project$Page$ViewDocument$Modal$viewerCard,
					model,
					{email: viewer.email, name: viewer.name, role: viewer.role, verifyMobilePhone: viewer.verifyMobilePhone, verifyMyInfo: viewer.verifyMyInfo, verifyPassbase: viewer.verifyPassbase, verifyStripe: viewer.verifyStripe, verifyWallet: viewer.verifyWallet});
			},
			viewers);
	});
var $author$project$Page$ViewDocument$Modal$removeDuplicates = F2(
	function (el, list) {
		return A2($elm$core$List$member, el, list) ? list : A2($elm$core$List$cons, el, list);
	});
var $author$project$Page$ViewDocument$Modal$recipientsModal = F4(
	function (model, recipients, loadedModel, owner) {
		var viewDocumentPageLanguageData = model.languageSwitchModel.allLanguageData.location.viewDocumentPage;
		var signingOrder = A3(
			$elm$core$List$foldl,
			$author$project$Page$ViewDocument$Modal$removeDuplicates,
			_List_Nil,
			A2(
				$elm$core$List$map,
				function (signer) {
					return signer.signOrder;
				},
				A2(
					$elm$core$List$filter,
					function (r) {
						return !_Utils_eq(r.status, $author$project$Type$ViewDocument$Viewer);
					},
					recipients)));
		var signersCard = A3(
			$author$project$Page$ViewDocument$Modal$getSignersCard,
			$elm$core$List$length(signingOrder) > 1,
			loadedModel,
			A2(
				$elm$core$List$sortBy,
				function (s) {
					return s.signOrder;
				},
				A2(
					$elm$core$List$filter,
					function (r) {
						return !_Utils_eq(r.status, $author$project$Type$ViewDocument$Viewer);
					},
					recipients)));
		var ownerInfo = $author$project$Data$PDF$User$userInfo(owner);
		var listDocumentPageanguageData = model.languageSwitchModel.allLanguageData.location.listDocumentsPage;
		var viewerInfo = function (viewers) {
			return A2(
				$elm$core$List$cons,
				$rtfeldman$elm_css$Html$Styled$text(listDocumentPageanguageData.viewers),
				viewers);
		}(
			A2(
				$author$project$Page$ViewDocument$Modal$getViewerCard,
				loadedModel,
				A2(
					$elm$core$List$filter,
					function (r) {
						return _Utils_eq(r.status, $author$project$Type$ViewDocument$Viewer);
					},
					recipients)));
		var docOwnerId = loadedModel.payload.document.ownerId;
		var senderRole = $elm$core$List$head(
			A2(
				$elm$core$List$filterMap,
				function (row) {
					return _Utils_eq(row.userId, docOwnerId) ? row.role : $elm$core$Maybe$Nothing;
				},
				recipients));
		var senderCard = A2(
			$author$project$Page$ViewDocument$Modal$viewerCard,
			loadedModel,
			{
				email: $author$project$Data$PDF$User$emailFromUser(owner),
				name: $author$project$Data$PDF$User$formatName(owner),
				role: senderRole,
				verifyMobilePhone: ownerInfo.verifyMobilePhone,
				verifyMyInfo: ownerInfo.verifyMyInfo,
				verifyPassbase: ownerInfo.verifyPassbase,
				verifyStripe: ownerInfo.verifyStripe,
				verifyWallet: ownerInfo.verifyWallet
			});
		return A2(
			$author$project$Material$Styled$Modal$modal,
			_List_fromArray(
				[
					$author$project$Material$Styled$Modal$open(true),
					$author$project$Material$Styled$Modal$contentContainerstyles($author$project$Page$ViewDocument$Modal$styles.activitiesModal),
					$author$project$Material$Styled$Modal$onClose(
					$author$project$Types$OnViewDoc(
						$author$project$Type$ViewDocument$OnAuth(
							$author$project$Type$ViewDocument$OnLoaded($author$project$Type$ViewDocument$OnCloseModal)))),
					$author$project$Material$Styled$Modal$testAttribute('Recipients')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.modalHeader)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.modalHeaderTxt)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(viewDocumentPageLanguageData.recipients)
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$img,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.icon),
									$rtfeldman$elm_css$Html$Styled$Attributes$src($author$project$View$Theme$images.close),
									$rtfeldman$elm_css$Html$Styled$Events$onClick(
									$author$project$Types$OnViewDoc(
										$author$project$Type$ViewDocument$OnAuth(
											$author$project$Type$ViewDocument$OnLoaded($author$project$Type$ViewDocument$OnCloseModal))))
								]),
							_List_Nil)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.activitiesContainer)
						]),
					_Utils_ap(
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(listDocumentPageanguageData.sender),
										senderCard
									])),
								signersCard
							]),
						viewerInfo))
				]));
	});
var $author$project$Type$ViewDocument$OnRetryNotarisation = {$: 'OnRetryNotarisation'};
var $author$project$Page$ViewDocument$Modal$retryNotarisation = function (model) {
	var viewDocumentPageLanguageData = model.languageSwitchModel.allLanguageData.location.viewDocumentPage;
	return A2(
		$author$project$Material$Styled$Modal$modal,
		_List_fromArray(
			[
				$author$project$Material$Styled$Modal$open(true),
				$author$project$Material$Styled$Modal$contentContainerstyles($author$project$Page$ViewDocument$Modal$styles.activitiesModal),
				$author$project$Material$Styled$Modal$onClose(
				$author$project$Types$OnViewDoc(
					$author$project$Type$ViewDocument$OnAuth(
						$author$project$Type$ViewDocument$OnLoaded($author$project$Type$ViewDocument$OnCloseModal))))
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.modalHeader)
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.modalDownloadHeaderTxt)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(viewDocumentPageLanguageData.notariseDocument)
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$img,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer)
									])),
								$rtfeldman$elm_css$Html$Styled$Attributes$src($author$project$View$Theme$images.close),
								$rtfeldman$elm_css$Html$Styled$Events$onClick(
								$author$project$Types$OnViewDoc(
									$author$project$Type$ViewDocument$OnAuth(
										$author$project$Type$ViewDocument$OnLoaded($author$project$Type$ViewDocument$OnCloseModal))))
							]),
						_List_Nil)
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Css$overflowY($rtfeldman$elm_css$Css$auto)
							]))
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('Do you want to proceed to notarise this document? '),
						A2($rtfeldman$elm_css$Html$Styled$br, _List_Nil, _List_Nil),
						A2($rtfeldman$elm_css$Html$Styled$br, _List_Nil, _List_Nil),
						A2(
						$author$project$Material$Styled$Button$button,
						_List_fromArray(
							[
								$author$project$Material$Styled$Button$onClick(
								$author$project$Types$OnViewDoc(
									$author$project$Type$ViewDocument$OnAuth(
										$author$project$Type$ViewDocument$OnLoaded($author$project$Type$ViewDocument$OnRetryNotarisation))))
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(viewDocumentPageLanguageData.proceed)
							]))
					]))
			]));
};
var $author$project$Page$ViewDocument$Modal$sendEmailReminderSuccess = A2(
	$author$project$Material$Styled$Modal$modal,
	_List_fromArray(
		[
			$author$project$Material$Styled$Modal$open(true),
			$author$project$Material$Styled$Modal$contentContainerstyles($author$project$Page$ViewDocument$Modal$styles.modalContainer)
		]),
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.modalHeader)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.modalHeaderTxt)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('Reminder to Sign')
						]))
				])),
			A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.modalBodyContainer)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.modalBody)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('A Reminder email has been sent to all recipients who has not signed the document.')
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.modalBtns)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Material$Styled$Button$button,
							_List_fromArray(
								[
									$author$project$Material$Styled$Button$theme($author$project$Material$Styled$Button$blue),
									$author$project$Material$Styled$Button$styles($author$project$Page$ViewDocument$Modal$styles.dashboardBtn),
									$author$project$Material$Styled$Button$onClick(
									$author$project$Types$OnViewDoc(
										$author$project$Type$ViewDocument$OnAuth(
											$author$project$Type$ViewDocument$OnLoaded($author$project$Type$ViewDocument$OnCloseModal))))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Close')
								]))
						]))
				]))
		]));
var $author$project$Type$ViewDocument$OnDownloadCredentialFile = function (a) {
	return {$: 'OnDownloadCredentialFile', a: a};
};
var $author$project$Page$ViewDocument$Modal$credentialCard = function (credential) {
	return A2(
		$author$project$Material$Styled$Card$card,
		_List_fromArray(
			[
				$author$project$Material$Styled$Card$containerStyles(
				_Utils_ap($author$project$Page$ViewDocument$Modal$styles.cardContainer, $author$project$Page$ViewDocument$Modal$styles.onHover))
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.downloadBtnContent),
						$rtfeldman$elm_css$Html$Styled$Events$onClick(
						$author$project$Types$OnViewDoc(
							$author$project$Type$ViewDocument$OnAuth(
								$author$project$Type$ViewDocument$OnLoaded(
									$author$project$Type$ViewDocument$OnDownloadCredentialFile(credential.id)))))
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(credential.name)
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.icon2)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Material$Styled$Button$button,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('Download')
									]))
							]))
					]))
			]));
};
var $author$project$Page$ViewDocument$Modal$showCredentialModal = function (loadedModel) {
	var _v0 = loadedModel;
	var credentialData = _v0.credentialData;
	return $elm$core$List$isEmpty(credentialData) ? A2(
		$author$project$Material$Styled$Modal$modal,
		_List_fromArray(
			[
				$author$project$Material$Styled$Modal$open(true),
				$author$project$Material$Styled$Modal$contentContainerstyles($author$project$Page$ViewDocument$Modal$styles.activitiesModal),
				$author$project$Material$Styled$Modal$onClose(
				$author$project$Types$OnViewDoc(
					$author$project$Type$ViewDocument$OnAuth(
						$author$project$Type$ViewDocument$OnLoaded($author$project$Type$ViewDocument$OnCloseModal))))
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.modalHeader)
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.modalHeaderTxt)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('View Generated Credentials')
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$img,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.icon),
								$rtfeldman$elm_css$Html$Styled$Attributes$src($author$project$View$Theme$images.close),
								$rtfeldman$elm_css$Html$Styled$Events$onClick(
								$author$project$Types$OnViewDoc(
									$author$project$Type$ViewDocument$OnAuth(
										$author$project$Type$ViewDocument$OnLoaded($author$project$Type$ViewDocument$OnCloseModal))))
							]),
						_List_Nil)
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.activitiesContainer)
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('No credential generated for this document.')
					]))
			])) : A2(
		$author$project$Material$Styled$Modal$modal,
		_List_fromArray(
			[
				$author$project$Material$Styled$Modal$open(true),
				$author$project$Material$Styled$Modal$contentContainerstyles($author$project$Page$ViewDocument$Modal$styles.activitiesModal),
				$author$project$Material$Styled$Modal$onClose(
				$author$project$Types$OnViewDoc(
					$author$project$Type$ViewDocument$OnAuth(
						$author$project$Type$ViewDocument$OnLoaded($author$project$Type$ViewDocument$OnCloseModal))))
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.modalHeader)
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.modalHeaderTxt)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('View Generated Credentials')
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$img,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.icon),
								$rtfeldman$elm_css$Html$Styled$Attributes$src($author$project$View$Theme$images.close),
								$rtfeldman$elm_css$Html$Styled$Events$onClick(
								$author$project$Types$OnViewDoc(
									$author$project$Type$ViewDocument$OnAuth(
										$author$project$Type$ViewDocument$OnLoaded($author$project$Type$ViewDocument$OnCloseModal))))
							]),
						_List_Nil)
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.activitiesContainer)
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_Nil,
						A2($elm$core$List$map, $author$project$Page$ViewDocument$Modal$credentialCard, credentialData))
					]))
			]));
};
var $author$project$Page$ViewDocument$Modal$signingEventCard = F2(
	function (appModel, signingEvents) {
		var zoneName = function () {
			var _v0 = appModel.timezoneName;
			if (_v0.$ === 'Just') {
				var zoneName_ = _v0.a;
				if (zoneName_.$ === 'Name') {
					var name = zoneName_.a;
					return name;
				} else {
					var offset = zoneName_.a;
					return 'UTC ' + ($elm$core$String$fromInt((offset / 60) | 0) + '00');
				}
			} else {
				return 'No zoneName';
			}
		}();
		var viewDocumentPageLanguageData = appModel.languageSwitchModel.allLanguageData.location.viewDocumentPage;
		var timeStampTxt = A2($author$project$Page$ViewDocument$Modal$dateFormatter, appModel.timezone, signingEvents.timeStamp) + (' ' + (A2($author$project$Page$ViewDocument$Modal$timeFormatter, appModel.timezone, signingEvents.timeStamp) + (' (' + (zoneName + ')'))));
		var signerText = appModel.languageSwitchModel.allLanguageData.location.uploadDocument.signer;
		var completedText = appModel.languageSwitchModel.allLanguageData.location.pointsManagement.completedStatus;
		return A2(
			$author$project$Material$Styled$Card$card,
			_List_fromArray(
				[
					$author$project$Material$Styled$Card$containerStyles($author$project$Page$ViewDocument$Modal$styles.cardContainer)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.signingEventContent)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(signerText + (': ' + signingEvents.userId))
								])),
							A2($rtfeldman$elm_css$Html$Styled$br, _List_Nil, _List_Nil),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(viewDocumentPageLanguageData.timeStamp + (' ' + timeStampTxt))
								])),
							A2($rtfeldman$elm_css$Html$Styled$br, _List_Nil, _List_Nil),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.statusContainer)
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css(
											_List_fromArray(
												[
													$rtfeldman$elm_css$Css$marginRight(
													$rtfeldman$elm_css$Css$px(5))
												]))
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(viewDocumentPageLanguageData.status + ': ')
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$a,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$href(
											_Utils_ap(appModel.algorandExplorerUrl, signingEvents.transactionId)),
											$rtfeldman$elm_css$Html$Styled$Attributes$target('_blank')
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(completedText)
										]))
								]))
						]))
				]));
	});
var $author$project$Page$ViewDocument$Modal$showSigningEventModal = F2(
	function (loadedModel, appModel) {
		var viewDocumentPageLanguageData = appModel.languageSwitchModel.allLanguageData.location.viewDocumentPage;
		var _v0 = loadedModel;
		var signingEventsData = _v0.signingEventsData;
		var recipients = _v0.recipients;
		var signingEventWithName = A2(
			$elm$core$List$map,
			function (r) {
				return {
					docId: r.docId,
					timeStamp: r.timeStamp,
					transactionId: r.transactionId,
					userId: A2(
						$elm$core$Maybe$withDefault,
						' ',
						$elm$core$List$head(
							A2(
								$elm$core$List$filterMap,
								function (row) {
									return _Utils_eq(row.userId, r.userId) ? $elm$core$Maybe$Just(row.name) : $elm$core$Maybe$Nothing;
								},
								recipients)))
				};
			},
			signingEventsData);
		return A2(
			$author$project$Material$Styled$Modal$modal,
			_List_fromArray(
				[
					$author$project$Material$Styled$Modal$open(true),
					$author$project$Material$Styled$Modal$contentContainerstyles($author$project$Page$ViewDocument$Modal$styles.activitiesModal),
					$author$project$Material$Styled$Modal$onClose(
					$author$project$Types$OnViewDoc(
						$author$project$Type$ViewDocument$OnAuth(
							$author$project$Type$ViewDocument$OnLoaded($author$project$Type$ViewDocument$OnCloseModal))))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.modalHeader)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.modalHeaderTxt)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(viewDocumentPageLanguageData.signatureTimeStamping)
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$img,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.icon),
									$rtfeldman$elm_css$Html$Styled$Attributes$src($author$project$View$Theme$images.close),
									$rtfeldman$elm_css$Html$Styled$Events$onClick(
									$author$project$Types$OnViewDoc(
										$author$project$Type$ViewDocument$OnAuth(
											$author$project$Type$ViewDocument$OnLoaded($author$project$Type$ViewDocument$OnCloseModal))))
								]),
							_List_Nil)
						])),
					$elm$core$List$isEmpty(signingEventsData) ? A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.activitiesContainer)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('No signing events found for this document')
						])) : A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.activitiesContainer)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_Nil,
							A2(
								$elm$core$List$map,
								$author$project$Page$ViewDocument$Modal$signingEventCard(appModel),
								signingEventWithName))
						]))
				]));
	});
var $author$project$Type$ViewDocument$OnNavigateToRegister = {$: 'OnNavigateToRegister'};
var $author$project$Page$ViewDocument$Modal$signAnonymousSuccessModal = A2(
	$author$project$Material$Styled$Modal$modal,
	_List_fromArray(
		[
			$author$project$Material$Styled$Modal$open(true),
			$author$project$Material$Styled$Modal$contentContainerstyles($author$project$Page$ViewDocument$Modal$styles.modalContainer)
		]),
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.modalHeader)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.modalHeaderTxt)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('Signing Completed')
						]))
				])),
			A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.modalBodyContainer)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.anonymousSuccessModalBody)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('You\'ll receive the document in your email once everyone has completed signing.')
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.anonymousSuccessModalBody)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('You can also access and track your documents on Sign.net with a free personal account.')
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.modalBtns)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Material$Styled$Button$button,
									_List_fromArray(
										[
											$author$project$Material$Styled$Button$theme($author$project$Material$Styled$Button$blue),
											$author$project$Material$Styled$Button$styles(
											_Utils_ap(
												$author$project$Page$ViewDocument$Modal$styles.dashboardBtn,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Css$width(
														$rtfeldman$elm_css$Css$px(240))
													]))),
											$author$project$Material$Styled$Button$onClick(
											$author$project$Types$OnViewDoc(
												$author$project$Type$ViewDocument$OnAuth($author$project$Type$ViewDocument$OnNavigateToRegister)))
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('<<GET STARTED>>')
										]))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.signUpTxt)
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$a,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$href($author$project$Data$Route$routeUrl.login)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('Next Time')
										]))
								]))
						]))
				]))
		]));
var $author$project$Page$ViewDocument$Modal$signSuccessModal = function (model) {
	var viewDocumentPageLanguageData = model.languageSwitchModel.allLanguageData.location.viewDocumentPage;
	var backToDashboardText = model.languageSwitchModel.allLanguageData.location.uploadDocument.backToDashboard;
	return A2(
		$author$project$Material$Styled$Modal$modal,
		_List_fromArray(
			[
				$author$project$Material$Styled$Modal$open(true),
				$author$project$Material$Styled$Modal$contentContainerstyles($author$project$Page$ViewDocument$Modal$styles.modalContainer)
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.modalHeader)
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.modalHeaderTxt)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('Signing Completed')
							]))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.modalBodyContainer)
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.modalBody)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('You have successfully signed the document. You will be able to download a copy of the completed document once all parties have signed.')
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.modalBtns)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Material$Styled$Button$button,
								_List_fromArray(
									[
										$author$project$Material$Styled$Button$theme($author$project$Material$Styled$Button$blue),
										$author$project$Material$Styled$Button$styles($author$project$Page$ViewDocument$Modal$styles.dashboardBtn),
										$author$project$Material$Styled$Button$onClick(
										$author$project$Types$OnViewDoc(
											$author$project$Type$ViewDocument$OnAuth($author$project$Type$ViewDocument$OnNavigateToDashboard)))
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(backToDashboardText)
									]))
							]))
					]))
			]));
};
var $author$project$Page$ViewDocument$Modal$ownerVerifiedSignatureBox = function (dataSig) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$span,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.signatureImgBox)
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('Your Signature'),
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.signature)
							]),
						_List_Nil),
						A2(
						$rtfeldman$elm_css$Html$Styled$img,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$src(
								$author$project$Data$PDF$Signature$data(dataSig)),
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.ownerSignatureImg),
								$rtfeldman$elm_css$Html$Styled$Events$onClick(
								$author$project$Types$OnViewDoc(
									$author$project$Type$ViewDocument$OnAuth(
										$author$project$Type$ViewDocument$OnLoaded(
											$author$project$Type$ViewDocument$OnSignatureClick(dataSig)))))
							]),
						_List_Nil)
					]))
			]));
};
var $author$project$Page$ViewDocument$Modal$ownerVerifiedStampBox = function (dataStamp) {
	var selectedStamp = function () {
		var _v0 = $author$project$Data$PDF$Stamp$data(dataStamp);
		if (_v0.$ === 'NotLoaded') {
			return $rtfeldman$elm_css$Html$Styled$text('Loading...');
		} else {
			var data = _v0.a;
			return A2(
				$rtfeldman$elm_css$Html$Styled$img,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$src(data),
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.docStampImage),
						$rtfeldman$elm_css$Html$Styled$Events$onClick(
						$author$project$Types$OnViewDoc(
							$author$project$Type$ViewDocument$OnAuth(
								$author$project$Type$ViewDocument$OnLoaded(
									$author$project$Type$ViewDocument$OnStampClick(dataStamp)))))
					]),
				_List_Nil);
		}
	}();
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.docStampContent)
			]),
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$text('Your Stamp'),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.docStampBox)
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.docStampItem)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$Data$PDF$Stamp$name(dataStamp)),
								selectedStamp
							]))
					]))
			]));
};
var $author$project$Page$ViewDocument$Modal$signatureError = function (error) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.retryContainer),
				$rtfeldman$elm_css$Html$Styled$Events$onClick(
				$author$project$Types$OnSignature($author$project$Type$Signature$ReloadList))
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$span,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(error)
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$img,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$src($author$project$View$Theme$images.retry)
					]),
				_List_Nil)
			]));
};
var $author$project$Page$ViewDocument$Modal$signatureImgStyle = F2(
	function (signature, loadedModel) {
		var _v0 = loadedModel.selectedSignature;
		if (_v0.$ === 'Nothing') {
			return $author$project$Page$ViewDocument$Modal$styles.signatureImg;
		} else {
			var selectedSig = _v0.a;
			return _Utils_eq(
				$author$project$Data$PDF$Signature$id(selectedSig),
				signature.id) ? _Utils_ap(
				$author$project$Page$ViewDocument$Modal$styles.signatureImg,
				_List_fromArray(
					[$author$project$Page$ViewDocument$Modal$selectedAnnotBorderColor])) : $author$project$Page$ViewDocument$Modal$styles.signatureImg;
		}
	});
var $author$project$Page$ViewDocument$Modal$renderSignature = F2(
	function (loadedModel, signature) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$span,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.signature)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$img,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$src(signature.data),
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							A2($author$project$Page$ViewDocument$Modal$signatureImgStyle, signature, loadedModel)),
							$rtfeldman$elm_css$Html$Styled$Events$onClick(
							$author$project$Types$OnViewDoc(
								$author$project$Type$ViewDocument$OnAuth(
									$author$project$Type$ViewDocument$OnLoaded(
										$author$project$Type$ViewDocument$OnSignatureClick(
											A3($author$project$Data$PDF$Signature$create, signature.id, signature.name, signature.data))))))
						]),
					_List_Nil)
				]));
	});
var $author$project$Page$ViewDocument$Modal$signatureList = F2(
	function (signatureModel, loadedModel) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.signatureListBox)
				]),
			_Utils_ap(
				A2(
					$elm$core$List$map,
					$author$project$Page$ViewDocument$Modal$renderSignature(loadedModel),
					signatureModel.signatures),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.create),
								$rtfeldman$elm_css$Html$Styled$Events$onClick(
								$author$project$Types$OnSignature($author$project$Type$Signature$OnOpen)),
								A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'data-test', 'signature')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('+')
							]))
					])));
	});
var $author$project$Page$ViewDocument$Modal$signatureBox = F3(
	function (signatureModel, loadedModel, model) {
		var viewDocumentPageLanguageData = model.languageSwitchModel.allLanguageData.location.viewDocumentPage;
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'data-test', 'Your Signatures')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.signatureImgBox)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(viewDocumentPageLanguageData.yourSignatures)
						])),
					A2(
					$elm$core$Maybe$withDefault,
					A2($author$project$Page$ViewDocument$Modal$signatureList, signatureModel, loadedModel),
					A2($elm$core$Maybe$map, $author$project$Page$ViewDocument$Modal$signatureError, signatureModel.listError))
				]));
	});
var $author$project$Page$ViewDocument$Modal$isSelectedStamp = F2(
	function (stamp, maybeSelectedStamp) {
		if (maybeSelectedStamp.$ === 'Nothing') {
			return false;
		} else {
			var selectedStamp = maybeSelectedStamp.a;
			return _Utils_eq(
				$author$project$Data$PDF$Stamp$id(stamp),
				$author$project$Data$PDF$Stamp$id(selectedStamp));
		}
	});
var $author$project$Page$ViewDocument$Modal$renderStamp = F2(
	function (selectedStamp, stamp) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$span,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.stamp)
				]),
			_List_fromArray(
				[
					function () {
					var _v0 = $author$project$Data$PDF$Stamp$data(stamp);
					if (_v0.$ === 'NotLoaded') {
						return A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.stampImg)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Loading...')
								]));
					} else {
						var data = _v0.a;
						return A2(
							$rtfeldman$elm_css$Html$Styled$img,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$src(data),
									$rtfeldman$elm_css$Html$Styled$Attributes$css(
									A2($author$project$Page$ViewDocument$Modal$isSelectedStamp, stamp, selectedStamp) ? _Utils_ap(
										$author$project$Page$ViewDocument$Modal$styles.stampImg,
										_List_fromArray(
											[$author$project$Page$ViewDocument$Modal$selectedAnnotBorderColor])) : $author$project$Page$ViewDocument$Modal$styles.stampImg),
									$rtfeldman$elm_css$Html$Styled$Events$onClick(
									$author$project$Types$OnViewDoc(
										$author$project$Type$ViewDocument$OnAuth(
											$author$project$Type$ViewDocument$OnLoaded(
												$author$project$Type$ViewDocument$OnStampClick(stamp)))))
								]),
							_List_Nil);
					}
				}()
				]));
	});
var $author$project$Page$ViewDocument$Modal$stampList = F4(
	function (stampModel, loadedModel, domain, headerText) {
		var _v0 = A2(
			$elm$core$Dict$get,
			$author$project$Data$Domain$toString(domain),
			stampModel.stamps);
		if (_v0.$ === 'Nothing') {
			return $rtfeldman$elm_css$Html$Styled$text('');
		} else {
			var stampStatus = _v0.a;
			if (stampStatus.$ === 'Loaded') {
				var stamps = stampStatus.a;
				return A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.signatureImgBox)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(headerText)
								])),
							A2($author$project$View$Stamp$displayFormStatus, stampModel, domain),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.signatureListBox)
								]),
							_Utils_ap(
								A2(
									$elm$core$List$map,
									$author$project$Page$ViewDocument$Modal$renderStamp(loadedModel.selectedStamp),
									$elm$core$Dict$values(stamps)),
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$div,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.create),
												$rtfeldman$elm_css$Html$Styled$Events$onClick(
												$author$project$Types$OnStamp(
													$author$project$Type$Stamp$OnImageUpload(
														$author$project$Type$Stamp$ImageRequested(domain))))
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('+')
											]))
									])))
						]));
			} else {
				return $rtfeldman$elm_css$Html$Styled$text('');
			}
		}
	});
var $author$project$Page$ViewDocument$Modal$signatureStampModel = F3(
	function (_v0, loadedModel, model) {
		var user = _v0.user;
		var signatureModel = _v0.signatureModel;
		var stampModel = _v0.stampModel;
		var appDomain = _v0.appDomain;
		var viewDocumentPageLanguageData = model.languageSwitchModel.allLanguageData.location.viewDocumentPage;
		var signatureSection = function () {
			if (A2($author$project$Data$Api$PDF$View$hasOwnerVerifiedSig, user.id, loadedModel.payload)) {
				var defaultSignature = A2(
					$elm$core$Maybe$withDefault,
					A3($author$project$Data$PDF$Signature$create, '', '', ''),
					loadedModel.selectedSignature);
				var ownerSignature = A2(
					$elm$core$Maybe$withDefault,
					defaultSignature,
					A2($author$project$Data$PDF$ownerVerifiedSignature, user, loadedModel.pdf));
				return $author$project$Page$ViewDocument$Modal$ownerVerifiedSignatureBox(ownerSignature);
			} else {
				return A3($author$project$Page$ViewDocument$Modal$signatureBox, signatureModel, loadedModel, model);
			}
		}();
		var selectedDomain = $author$project$Data$Domain$selected(user.domains);
		var stampSection = function () {
			if (A2($author$project$Data$Api$PDF$View$hasOwnerVerifiedStamp, user.id, loadedModel.payload)) {
				var defaultStamp = A2(
					$elm$core$Maybe$withDefault,
					$author$project$Data$PDF$Stamp$createFakeLoadingStamp(''),
					loadedModel.selectedStamp);
				var documentStamp = A2(
					$elm$core$Maybe$withDefault,
					defaultStamp,
					A2($author$project$Data$PDF$ownerVerifiedStamp, user, loadedModel.pdf));
				return $author$project$Page$ViewDocument$Modal$ownerVerifiedStampBox(documentStamp);
			} else {
				var showCompanyStamps = _Utils_eq(selectedDomain, appDomain) ? $rtfeldman$elm_css$Html$Styled$text('') : A4($author$project$Page$ViewDocument$Modal$stampList, stampModel, loadedModel, selectedDomain, 'Your Company Stamps');
				return A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_Nil,
					_List_fromArray(
						[
							showCompanyStamps,
							A4($author$project$Page$ViewDocument$Modal$stampList, stampModel, loadedModel, appDomain, viewDocumentPageLanguageData.yourStamps)
						]));
			}
		}();
		var _v1 = loadedModel;
		var pdf = _v1.pdf;
		var _v2 = $author$project$Data$PDF$status(pdf);
		switch (_v2.$) {
			case 'Signing':
				return A2(
					$author$project$Material$Styled$Modal$modal,
					_List_fromArray(
						[
							$author$project$Material$Styled$Modal$open(true),
							$author$project$Material$Styled$Modal$contentContainerstyles($author$project$Page$ViewDocument$Modal$styles.activitiesModal),
							$author$project$Material$Styled$Modal$onClose(
							$author$project$Types$OnViewDoc(
								$author$project$Type$ViewDocument$OnAuth(
									$author$project$Type$ViewDocument$OnLoaded($author$project$Type$ViewDocument$OnCloseModal))))
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.modalHeader)
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.modalHeaderTxt)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('')
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$img,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css(
											_List_fromArray(
												[
													$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer)
												])),
											$rtfeldman$elm_css$Html$Styled$Attributes$src($author$project$View$Theme$images.close),
											$rtfeldman$elm_css$Html$Styled$Events$onClick(
											$author$project$Types$OnViewDoc(
												$author$project$Type$ViewDocument$OnAuth(
													$author$project$Type$ViewDocument$OnLoaded($author$project$Type$ViewDocument$OnCloseModal))))
										]),
									_List_Nil)
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.activitiesContainer)
								]),
							_List_fromArray(
								[signatureSection, stampSection]))
						]));
			case 'Viewing':
				return $rtfeldman$elm_css$Html$Styled$text('');
			case 'Completed':
				return $rtfeldman$elm_css$Html$Styled$text('');
			case 'Expired':
				return $rtfeldman$elm_css$Html$Styled$text('');
			default:
				return $rtfeldman$elm_css$Html$Styled$text('');
		}
	});
var $author$project$Page$ViewDocument$Modal$signingModal = A2(
	$author$project$Material$Styled$Modal$modal,
	_List_fromArray(
		[
			$author$project$Material$Styled$Modal$open(true),
			$author$project$Material$Styled$Modal$contentContainerstyles($author$project$Page$ViewDocument$Modal$styles.modalContainer)
		]),
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.modalHeader)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.modalHeaderTxt)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('Signing...')
						]))
				])),
			A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.modalBodyContainer)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.modalBody)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('Signing the document...')
						])),
					A2(
					$author$project$Material$Styled$ProgressBar$linear,
					_List_fromArray(
						[
							$author$project$Material$Styled$ProgressBar$containerStyle($author$project$Page$ViewDocument$Modal$styles.progressBar)
						]),
					_List_Nil)
				]))
		]));
var $author$project$Type$ViewDocument$OnTextFieldInput = F2(
	function (a, b) {
		return {$: 'OnTextFieldInput', a: a, b: b};
	});
var $author$project$Type$ViewDocument$OnTextFieldNameConfirm = {$: 'OnTextFieldNameConfirm'};
var $author$project$Type$ViewDocument$OnTextFieldNameOnBlur = function (a) {
	return {$: 'OnTextFieldNameOnBlur', a: a};
};
var $author$project$Page$ViewDocument$Modal$textAnnotationNameChangeModal = F3(
	function (annotId, content, loadedModel) {
		return A2(
			$author$project$Material$Styled$Modal$modal,
			_List_fromArray(
				[
					$author$project$Material$Styled$Modal$open(true),
					$author$project$Material$Styled$Modal$contentContainerstyles($author$project$Page$ViewDocument$Modal$styles.activitiesModal)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.modalHeader)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$Modal$styles.modalHeaderTxt)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Please fill in this text field')
								]))
						])),
					A2(
					$author$project$Material$Styled$Input$text,
					_List_fromArray(
						[
							$author$project$Material$Styled$Input$containerStyles($author$project$Page$ViewDocument$Modal$styles.inputContainer),
							$author$project$Material$Styled$Input$label(content),
							$author$project$Material$Styled$Input$value(loadedModel.textAnnotationName),
							$author$project$Material$Styled$Input$onInput(
							A2(
								$elm$core$Basics$composeL,
								A2(
									$elm$core$Basics$composeL,
									A2($elm$core$Basics$composeL, $author$project$Types$OnViewDoc, $author$project$Type$ViewDocument$OnAuth),
									$author$project$Type$ViewDocument$OnLoaded),
								$author$project$Type$ViewDocument$OnTextFieldInput(annotId))),
							$author$project$Material$Styled$Input$onBlur(
							$author$project$Types$OnViewDoc(
								$author$project$Type$ViewDocument$OnAuth(
									$author$project$Type$ViewDocument$OnLoaded(
										$author$project$Type$ViewDocument$OnTextFieldNameOnBlur(annotId)))))
						]),
					_List_Nil),
					A2(
					$author$project$Material$Styled$Button$button,
					_List_fromArray(
						[
							$author$project$Material$Styled$Button$theme($author$project$Material$Styled$Button$blue),
							$author$project$Material$Styled$Button$styles($author$project$Page$ViewDocument$Modal$styles.btnMaxWidth),
							$author$project$Material$Styled$Button$onClick(
							$author$project$Types$OnViewDoc(
								$author$project$Type$ViewDocument$OnAuth(
									$author$project$Type$ViewDocument$OnLoaded($author$project$Type$ViewDocument$OnTextFieldNameConfirm))))
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('Done')
						]))
				]));
	});
var $author$project$Page$ViewDocument$Modal$view = F4(
	function (loadedModel, userDetails, sessionModel, model) {
		var _v0 = loadedModel.modal;
		if (_v0.$ === 'Nothing') {
			return $rtfeldman$elm_css$Html$Styled$text('');
		} else {
			var modal = _v0.a;
			switch (modal.$) {
				case 'NeedPassword':
					return A2($author$project$Page$ViewDocument$Modal$needPasswordModal, loadedModel.password, loadedModel.passwordError);
				case 'Signing':
					return $author$project$Page$ViewDocument$Modal$signingModal;
				case 'Success':
					switch (sessionModel.$) {
						case 'Auth':
							return $author$project$Page$ViewDocument$Modal$signSuccessModal(model);
						case 'Anonymous':
							return $author$project$Page$ViewDocument$Modal$signAnonymousSuccessModal;
						case 'NoAuth':
							return $rtfeldman$elm_css$Html$Styled$text('');
						default:
							return $rtfeldman$elm_css$Html$Styled$text('');
					}
				case 'ShowLog':
					return A2($author$project$Page$ViewDocument$Modal$activitiesModal, model, loadedModel.logs);
				case 'Recipient':
					return A4(
						$author$project$Page$ViewDocument$Modal$recipientsModal,
						model,
						loadedModel.recipients,
						loadedModel,
						$author$project$Data$PDF$owner(loadedModel.pdf));
				case 'Certificate':
					return A2($author$project$Page$ViewDocument$Modal$certificateModal, loadedModel, model);
				case 'DeadlineExtension':
					return A2($author$project$Page$ViewDocument$Modal$deadlineExtensionModal, model, loadedModel);
				case 'NotariseDocument':
					var notarisationNetwork = modal.a;
					return A4($author$project$Page$ViewDocument$Modal$notariseDocumentModal, notarisationNetwork, userDetails, loadedModel, model);
				case 'NotariseSuccess':
					var notarisationNetwork = modal.a;
					return $author$project$Page$ViewDocument$Modal$notariseDocumentSuccess(notarisationNetwork);
				case 'LoadingState':
					var status = modal.a;
					return $author$project$Page$ViewDocument$Modal$loadingModal(status);
				case 'GenerateCredentials':
					return $author$project$Page$ViewDocument$Modal$generateCredentialModal(loadedModel);
				case 'GeneratingCredential':
					return $author$project$Page$ViewDocument$Modal$generatingCredentialModal;
				case 'ShowCredential':
					return $author$project$Page$ViewDocument$Modal$showCredentialModal(loadedModel);
				case 'DeleteDocument':
					return $author$project$Page$ViewDocument$Modal$deleteDocumentModal(model);
				case 'DeleteSuccess':
					return $author$project$Page$ViewDocument$Modal$deleteDocumentSuccess;
				case 'RequiredPasscode':
					return A2($author$project$Page$ViewDocument$Modal$needPasscodeModal, loadedModel.passcode, loadedModel.passcodeError);
				case 'DisplayWallet':
					var wallet = modal.a;
					return A3(
						$author$project$Page$ViewDocument$Modal$displayWalletModal,
						wallet,
						A2($elm$core$Maybe$withDefault, '', loadedModel.selectedWallet),
						loadedModel);
				case 'MakePayment':
					return A2(
						$author$project$Page$ViewDocument$Modal$paymentModal,
						A2($elm$core$Maybe$withDefault, '', loadedModel.selectedWallet),
						loadedModel);
				case 'DisplayWalletConnectAddresses':
					var addresses = modal.a;
					return A2($author$project$Page$ViewDocument$Modal$displayWalletConnectAddressesModal, addresses, loadedModel);
				case 'ShowSigningData':
					return A2($author$project$Page$ViewDocument$Modal$showSigningEventModal, loadedModel, model);
				case 'EmailReminderSuccess':
					return $author$project$Page$ViewDocument$Modal$sendEmailReminderSuccess;
				case 'UpdateAnnotName':
					var annotId = modal.a;
					var content = modal.b;
					return A3($author$project$Page$ViewDocument$Modal$textAnnotationNameChangeModal, annotId, content, loadedModel);
				case 'DownloadIncompleteDoc':
					return $author$project$Page$ViewDocument$Modal$downloadIncompleteDocModal(model);
				case 'DocumentInfo':
					return A4($author$project$Page$ViewDocument$Modal$documentInfo, loadedModel, sessionModel, userDetails, model);
				case 'SignatureStampModal':
					switch (sessionModel.$) {
						case 'Auth':
							var authModel = sessionModel.a;
							return A3(
								$author$project$Page$ViewDocument$Modal$signatureStampModel,
								{appDomain: model.appDomain, signatureModel: authModel.signatureModel, stampModel: authModel.stampModel, user: authModel.user},
								loadedModel,
								model);
						case 'Anonymous':
							var anonymousModel = sessionModel.a;
							return A3(
								$author$project$Page$ViewDocument$Modal$signatureStampModel,
								{appDomain: model.appDomain, signatureModel: anonymousModel.signatureModel, stampModel: anonymousModel.stampModel, user: anonymousModel.user},
								loadedModel,
								model);
						case 'NoAuth':
							return $rtfeldman$elm_css$Html$Styled$text('');
						default:
							return $rtfeldman$elm_css$Html$Styled$text('');
					}
				default:
					return $author$project$Page$ViewDocument$Modal$retryNotarisation(model);
			}
		}
	});
var $author$project$Page$ViewDocument$view = function (model) {
	var refreshClick = $author$project$Types$OnViewDoc(
		$author$project$Type$ViewDocument$OnAuth($author$project$Type$ViewDocument$OnRefreshClick));
	var dashboardClickMsg = $author$project$Types$OnViewDoc(
		$author$project$Type$ViewDocument$OnAuth($author$project$Type$ViewDocument$OnNavigateToDashboard));
	var _v0 = model;
	var sessionModel = _v0.sessionModel;
	var appDomain = _v0.appDomain;
	var bscScanExplorerUrl = _v0.bscScanExplorerUrl;
	var algorandExplorerUrl = _v0.algorandExplorerUrl;
	var languageSwitchModel = _v0.languageSwitchModel;
	var viewDocumentPageLanguageData = languageSwitchModel.allLanguageData.location.viewDocumentPage;
	var documentStatus = F5(
		function (signatureModel, stampModel, viewDocModel, user, sessionModel_) {
			switch (viewDocModel.$) {
				case 'NotLoaded':
					return A2(
						$author$project$View$Loading$view,
						'Can\'t Load The Document',
						$elm$core$Maybe$Just('Please contact the sender of the document for more information.'));
				case 'Loading':
					return A2($author$project$View$Loading$view, 'Loading Your Document', $elm$core$Maybe$Nothing);
				case 'LoadingApiError':
					var error = viewDocModel.a;
					return A4(
						$author$project$View$PDFError$view,
						$author$project$Page$ViewDocument$displayApiErrorTitle(
							$author$project$Page$ViewDocument$convertAuthErrorToError(error)),
						A2($author$project$Data$Api$authErrorToString, $author$project$Data$Api$PDF$View$errorToString, error),
						dashboardClickMsg,
						refreshClick);
				case 'LoadingDecodeError':
					var errorMessage = viewDocModel.a;
					return A4($author$project$View$PDFError$view, 'Document Error', errorMessage, dashboardClickMsg, refreshClick);
				case 'Loaded':
					var loadedModel = viewDocModel.a;
					return A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_Nil,
						_List_fromArray(
							[
								_Utils_eq(
								$author$project$Data$PDF$status(loadedModel.pdf),
								$author$project$Data$PDF$Signing) ? A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$styles.topPanel)
									]),
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$div,
										_List_Nil,
										_List_fromArray(
											[
												A5(
												$author$project$View$InfomationToolTip$view2,
												$author$project$Types$OnViewDoc(
													$author$project$Type$ViewDocument$OnAuth(
														$author$project$Type$ViewDocument$OnLoaded(
															A3($author$project$Type$ViewDocument$OnHover, $author$project$Type$ViewDocument$DocumentInformation, $author$project$Type$ViewDocument$Enters, 'email')))),
												$author$project$Types$OnViewDoc(
													$author$project$Type$ViewDocument$OnAuth(
														$author$project$Type$ViewDocument$OnLoaded(
															A3($author$project$Type$ViewDocument$OnHover, $author$project$Type$ViewDocument$DocumentInformation, $author$project$Type$ViewDocument$Leaves, 'email')))),
												_Utils_eq(
													loadedModel.toolTip,
													A2($author$project$Type$ViewDocument$Hover, $author$project$Type$ViewDocument$DocumentInformation, 'email')),
												A2(
													$rtfeldman$elm_css$Html$Styled$div,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$styles.messageContainer)
														]),
													_List_fromArray(
														[
															A2(
															$rtfeldman$elm_css$Html$Styled$div,
															_List_fromArray(
																[
																	$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$styles.arrowUp)
																]),
															_List_Nil),
															A2(
															$rtfeldman$elm_css$Html$Styled$div,
															_List_fromArray(
																[
																	$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$styles.toolTip)
																]),
															_List_fromArray(
																[
																	$rtfeldman$elm_css$Html$Styled$text(viewDocumentPageLanguageData.documentInformation)
																]))
														])),
												A2(
													$author$project$Material$Styled$Icon$documentInfo,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Svg$Styled$Attributes$css($author$project$Page$ViewDocument$styles.icon),
															$rtfeldman$elm_css$Svg$Styled$Events$onClick(
															$author$project$Types$OnViewDoc(
																$author$project$Type$ViewDocument$OnAuth(
																	$author$project$Type$ViewDocument$OnLoaded(
																		$author$project$Type$ViewDocument$OnShowModal($author$project$Type$ViewDocument$DocumentInfo)))))
														]),
													_List_Nil))
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$div,
										_List_Nil,
										_List_fromArray(
											[
												A5(
												$author$project$View$InfomationToolTip$view2,
												$author$project$Types$OnViewDoc(
													$author$project$Type$ViewDocument$OnAuth(
														$author$project$Type$ViewDocument$OnLoaded(
															A3($author$project$Type$ViewDocument$OnHover, $author$project$Type$ViewDocument$Recipients, $author$project$Type$ViewDocument$Enters, 'email')))),
												$author$project$Types$OnViewDoc(
													$author$project$Type$ViewDocument$OnAuth(
														$author$project$Type$ViewDocument$OnLoaded(
															A3($author$project$Type$ViewDocument$OnHover, $author$project$Type$ViewDocument$Recipients, $author$project$Type$ViewDocument$Leaves, 'email')))),
												_Utils_eq(
													loadedModel.toolTip,
													A2($author$project$Type$ViewDocument$Hover, $author$project$Type$ViewDocument$Recipients, 'email')),
												A2(
													$rtfeldman$elm_css$Html$Styled$div,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$styles.messageContainer)
														]),
													_List_fromArray(
														[
															A2(
															$rtfeldman$elm_css$Html$Styled$div,
															_List_fromArray(
																[
																	$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$styles.arrowUp)
																]),
															_List_Nil),
															A2(
															$rtfeldman$elm_css$Html$Styled$div,
															_List_fromArray(
																[
																	$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$styles.toolTip)
																]),
															_List_fromArray(
																[
																	$rtfeldman$elm_css$Html$Styled$text(viewDocumentPageLanguageData.recipients)
																]))
														])),
												A2(
													$author$project$Material$Styled$Icon$recipient,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Svg$Styled$Attributes$css($author$project$Page$ViewDocument$styles.icon),
															$rtfeldman$elm_css$Svg$Styled$Events$onClick(
															$author$project$Types$OnViewDoc(
																$author$project$Type$ViewDocument$OnAuth(
																	$author$project$Type$ViewDocument$OnLoaded(
																		$author$project$Type$ViewDocument$OnShowModal($author$project$Type$ViewDocument$Recipient)))))
														]),
													_List_Nil))
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$div,
										_List_Nil,
										_List_fromArray(
											[
												A5(
												$author$project$View$InfomationToolTip$view2,
												$author$project$Types$OnViewDoc(
													$author$project$Type$ViewDocument$OnAuth(
														$author$project$Type$ViewDocument$OnLoaded(
															A3($author$project$Type$ViewDocument$OnHover, $author$project$Type$ViewDocument$SignatureStamp, $author$project$Type$ViewDocument$Enters, 'email')))),
												$author$project$Types$OnViewDoc(
													$author$project$Type$ViewDocument$OnAuth(
														$author$project$Type$ViewDocument$OnLoaded(
															A3($author$project$Type$ViewDocument$OnHover, $author$project$Type$ViewDocument$SignatureStamp, $author$project$Type$ViewDocument$Leaves, 'email')))),
												_Utils_eq(
													loadedModel.toolTip,
													A2($author$project$Type$ViewDocument$Hover, $author$project$Type$ViewDocument$SignatureStamp, 'email')),
												A2(
													$rtfeldman$elm_css$Html$Styled$div,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$styles.messageContainer)
														]),
													_List_fromArray(
														[
															A2(
															$rtfeldman$elm_css$Html$Styled$div,
															_List_fromArray(
																[
																	$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$styles.arrowUp)
																]),
															_List_Nil),
															A2(
															$rtfeldman$elm_css$Html$Styled$div,
															_List_fromArray(
																[
																	$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$styles.toolTip)
																]),
															_List_fromArray(
																[
																	$rtfeldman$elm_css$Html$Styled$text(viewDocumentPageLanguageData.signatureAndStamps)
																]))
														])),
												A2(
													$author$project$Material$Styled$Icon$signature,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Svg$Styled$Attributes$css($author$project$Page$ViewDocument$styles.icon),
															$rtfeldman$elm_css$Svg$Styled$Events$onClick(
															$author$project$Types$OnViewDoc(
																$author$project$Type$ViewDocument$OnAuth(
																	$author$project$Type$ViewDocument$OnLoaded(
																		$author$project$Type$ViewDocument$OnShowModal($author$project$Type$ViewDocument$SignatureStampModal)))))
														]),
													_List_Nil))
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$div,
										_List_Nil,
										_List_fromArray(
											[
												A5(
												$author$project$View$InfomationToolTip$view2,
												$author$project$Types$OnViewDoc(
													$author$project$Type$ViewDocument$OnAuth(
														$author$project$Type$ViewDocument$OnLoaded(
															A3($author$project$Type$ViewDocument$OnHover, $author$project$Type$ViewDocument$DownloadDocument, $author$project$Type$ViewDocument$Enters, 'email')))),
												$author$project$Types$OnViewDoc(
													$author$project$Type$ViewDocument$OnAuth(
														$author$project$Type$ViewDocument$OnLoaded(
															A3($author$project$Type$ViewDocument$OnHover, $author$project$Type$ViewDocument$DownloadDocument, $author$project$Type$ViewDocument$Leaves, 'email')))),
												_Utils_eq(
													loadedModel.toolTip,
													A2($author$project$Type$ViewDocument$Hover, $author$project$Type$ViewDocument$DownloadDocument, 'email')),
												A2(
													$rtfeldman$elm_css$Html$Styled$div,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$styles.messageContainer)
														]),
													_List_fromArray(
														[
															A2(
															$rtfeldman$elm_css$Html$Styled$div,
															_List_fromArray(
																[
																	$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$styles.arrowUp)
																]),
															_List_Nil),
															A2(
															$rtfeldman$elm_css$Html$Styled$div,
															_List_fromArray(
																[
																	$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$styles.toolTip)
																]),
															_List_fromArray(
																[
																	$rtfeldman$elm_css$Html$Styled$text(viewDocumentPageLanguageData.downloadDocument)
																]))
														])),
												A2(
													$author$project$Material$Styled$Icon$fileDownload,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Svg$Styled$Attributes$css($author$project$Page$ViewDocument$styles.icon),
															$rtfeldman$elm_css$Svg$Styled$Events$onClick(
															$author$project$Types$OnViewDoc(
																$author$project$Type$ViewDocument$OnAuth(
																	$author$project$Type$ViewDocument$OnLoaded(
																		$author$project$Type$ViewDocument$OnShowModal($author$project$Type$ViewDocument$DownloadIncompleteDoc)))))
														]),
													_List_Nil))
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$div,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$rtfeldman$elm_css$Html$Styled$a,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$Attributes$href('https://signnet.tawk.help/article/how-to-sign-a-document-for-recipients'),
														$rtfeldman$elm_css$Html$Styled$Attributes$target('_blank')
													]),
												_List_fromArray(
													[
														A5(
														$author$project$View$InfomationToolTip$view2,
														$author$project$Types$OnViewDoc(
															$author$project$Type$ViewDocument$OnAuth(
																$author$project$Type$ViewDocument$OnLoaded(
																	A3($author$project$Type$ViewDocument$OnHover, $author$project$Type$ViewDocument$Help, $author$project$Type$ViewDocument$Enters, 'email')))),
														$author$project$Types$OnViewDoc(
															$author$project$Type$ViewDocument$OnAuth(
																$author$project$Type$ViewDocument$OnLoaded(
																	A3($author$project$Type$ViewDocument$OnHover, $author$project$Type$ViewDocument$Help, $author$project$Type$ViewDocument$Leaves, 'email')))),
														_Utils_eq(
															loadedModel.toolTip,
															A2($author$project$Type$ViewDocument$Hover, $author$project$Type$ViewDocument$Help, 'email')),
														A2(
															$rtfeldman$elm_css$Html$Styled$div,
															_List_fromArray(
																[
																	$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$styles.messageContainer)
																]),
															_List_fromArray(
																[
																	A2(
																	$rtfeldman$elm_css$Html$Styled$div,
																	_List_fromArray(
																		[
																			$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$styles.arrowUp)
																		]),
																	_List_Nil),
																	A2(
																	$rtfeldman$elm_css$Html$Styled$div,
																	_List_fromArray(
																		[
																			$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$styles.toolTip)
																		]),
																	_List_fromArray(
																		[
																			$rtfeldman$elm_css$Html$Styled$text(viewDocumentPageLanguageData.helpDesk)
																		]))
																])),
														A2(
															$author$project$Material$Styled$Icon$helpCenter,
															_List_fromArray(
																[
																	$rtfeldman$elm_css$Svg$Styled$Attributes$css($author$project$Page$ViewDocument$styles.icon)
																]),
															_List_Nil))
													]))
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$div,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$css(
												_List_fromArray(
													[
														$rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$block),
														$rtfeldman$elm_css$Css$marginLeft($rtfeldman$elm_css$Css$auto),
														$rtfeldman$elm_css$Css$marginRight(
														$rtfeldman$elm_css$Css$px(10)),
														$rtfeldman$elm_css$Css$marginTop(
														$rtfeldman$elm_css$Css$px(5)),
														$rtfeldman$elm_css$Css$width(
														$rtfeldman$elm_css$Css$px(200))
													]))
											]),
										_List_fromArray(
											[
												A2(
												$author$project$Material$Styled$Button$button,
												_List_fromArray(
													[
														$author$project$Material$Styled$Button$theme($author$project$Material$Styled$Button$green),
														$author$project$Material$Styled$Button$styles(_List_Nil),
														$author$project$Material$Styled$Button$onClick(
														$author$project$Types$OnViewDoc(
															$author$project$Type$ViewDocument$OnAuth(
																$author$project$Type$ViewDocument$OnLoaded($author$project$Type$ViewDocument$OnDocSubmit))))
													]),
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text(viewDocumentPageLanguageData.submit)
													]))
											]))
									])) : $rtfeldman$elm_css$Html$Styled$text(''),
								A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$styles.container)
									]),
								_List_fromArray(
									[
										A2(
										$elm$core$Maybe$withDefault,
										$rtfeldman$elm_css$Html$Styled$text(''),
										A2($elm$core$Maybe$map, $author$project$Page$ViewDocument$MessageBanner$view, loadedModel.banner)),
										A2(
										$author$project$View$Pdftron$view,
										loadedModel.displayViewer,
										_Utils_eq(
											$author$project$Data$PDF$status(loadedModel.pdf),
											$author$project$Data$PDF$Signing)),
										_Utils_eq(
										$author$project$Data$PDF$status(loadedModel.pdf),
										$author$project$Data$PDF$Expired) ? A2(
										$rtfeldman$elm_css$Html$Styled$div,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$styles.sidebar)
											]),
										_List_fromArray(
											[
												A4($author$project$Page$ViewDocument$documentDetails, model, loadedModel, bscScanExplorerUrl, algorandExplorerUrl)
											])) : (_Utils_eq(
										$author$project$Data$PDF$status(loadedModel.pdf),
										$author$project$Data$PDF$Signing) ? A2(
										$rtfeldman$elm_css$Html$Styled$div,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$author$project$View$Signature$view,
												signatureModel,
												$author$project$View$Signature$checkSignatureList(signatureModel)),
												A3(
												$author$project$Page$ViewDocument$Modal$eSignatureLoadedModal,
												user,
												loadedModel.eDisclaimerCheckbox,
												$author$project$View$Signature$checkSignatureList(signatureModel))
											])) : A2(
										$rtfeldman$elm_css$Html$Styled$div,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$styles.sidebar)
											]),
										_List_fromArray(
											[
												A2($author$project$Page$ViewDocument$submitBtn, loadedModel, model),
												A4($author$project$Page$ViewDocument$documentDetails, model, loadedModel, bscScanExplorerUrl, algorandExplorerUrl),
												A3(
												$author$project$Page$ViewDocument$userRoleContent,
												{appDomain: appDomain, signatureModel: signatureModel, stampModel: stampModel, user: user},
												loadedModel,
												model),
												A2(
												$author$project$View$Signature$view,
												signatureModel,
												$author$project$View$Signature$checkSignatureList(signatureModel)),
												A3(
												$author$project$Page$ViewDocument$Modal$eSignatureLoadedModal,
												user,
												loadedModel.eDisclaimerCheckbox,
												$author$project$View$Signature$checkSignatureList(signatureModel)),
												A3($author$project$Page$ViewDocument$deadlineExtensionButton, loadedModel, sessionModel_, user),
												A2($author$project$Page$ViewDocument$submitBtn, loadedModel, model),
												A2(
												$author$project$Material$Styled$Button$button,
												_List_fromArray(
													[
														$author$project$Material$Styled$Button$theme($author$project$Material$Styled$Button$default),
														$author$project$Material$Styled$Button$styles(
														_List_fromArray(
															[
																A2(
																$rtfeldman$elm_css$Css$margin2,
																$rtfeldman$elm_css$Css$em(0.6),
																$rtfeldman$elm_css$Css$zero)
															])),
														$author$project$Material$Styled$Button$onClick(
														$author$project$Types$OnViewDoc(
															$author$project$Type$ViewDocument$OnAuth(
																$author$project$Type$ViewDocument$OnLoaded($author$project$Type$ViewDocument$OnBackClick))))
													]),
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text(viewDocumentPageLanguageData.backToDocuments)
													]))
											]))),
										A2(
										$author$project$Material$Styled$Snackbar$snackbarViewDoc,
										_List_fromArray(
											[
												$author$project$Material$Styled$Snackbar$Theme($author$project$Material$Styled$Snackbar$success),
												$author$project$Material$Styled$Snackbar$Timeout(5),
												$author$project$Material$Styled$Snackbar$Status(loadedModel.successSnackBar)
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('Success!')
											])),
										$author$project$View$Stamp$modal(stampModel),
										A4($author$project$Page$ViewDocument$Modal$view, loadedModel, user, sessionModel, model)
									]))
							]));
				case 'GenerateCredential':
					var loadedModel = viewDocModel.a;
					return A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$styles.container)
							]),
						_List_fromArray(
							[
								A2(
								$elm$core$Maybe$withDefault,
								$rtfeldman$elm_css$Html$Styled$text(''),
								A2($elm$core$Maybe$map, $author$project$Page$ViewDocument$MessageBanner$view, loadedModel.banner)),
								A2($author$project$View$Pdftron$view, loadedModel.displayViewer, false),
								A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$styles.sidebar)
									]),
								_Utils_eq(
									$author$project$Data$PDF$status(loadedModel.pdf),
									$author$project$Data$PDF$Expired) ? _List_fromArray(
									[
										A4($author$project$Page$ViewDocument$documentDetails, model, loadedModel, bscScanExplorerUrl, algorandExplorerUrl)
									]) : _List_fromArray(
									[
										A4($author$project$Page$ViewDocument$documentDetails, model, loadedModel, bscScanExplorerUrl, algorandExplorerUrl),
										A2(
										$rtfeldman$elm_css$Html$Styled$h2,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$styles.docDetailsSubTitle)
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('Credential Name*')
											])),
										A2(
										$author$project$Material$Styled$TextArea$textArea,
										_List_fromArray(
											[
												$author$project$Material$Styled$TextArea$label(''),
												$author$project$Material$Styled$TextArea$customInputAttributes(
												_List_fromArray(
													[
														A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'data-gramm_editor', 'false')
													])),
												$author$project$Material$Styled$TextArea$value(loadedModel.credentialName),
												$author$project$Material$Styled$TextArea$onInput(
												A2(
													$elm$core$Basics$composeL,
													A2(
														$elm$core$Basics$composeL,
														A2($elm$core$Basics$composeL, $author$project$Types$OnViewDoc, $author$project$Type$ViewDocument$OnAuth),
														$author$project$Type$ViewDocument$OnGenerateCredential),
													$author$project$Type$ViewDocument$OnCredentialNameInput))
											]),
										_List_Nil),
										A2(
										$rtfeldman$elm_css$Html$Styled$h2,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewDocument$styles.credentialGenerateTxt)
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('Please select the fields within your document which you would like to generate a credential for.')
											])),
										$author$project$Page$ViewDocument$generateCredentialCheckBox(loadedModel),
										A2(
										$author$project$Material$Styled$Button$button,
										_List_fromArray(
											[
												$author$project$Material$Styled$Button$styles($author$project$Page$ViewDocument$styles.docStatusBtn),
												$author$project$Material$Styled$Button$theme($author$project$Material$Styled$Button$blue),
												$author$project$Material$Styled$Button$onClick(
												$author$project$Types$OnViewDoc(
													$author$project$Type$ViewDocument$OnAuth(
														$author$project$Type$ViewDocument$OnGenerateCredential($author$project$Type$ViewDocument$OnGetGenerateCredentialPoints))))
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('Generate Credential')
											])),
										A2(
										$author$project$Material$Styled$Button$button,
										_List_fromArray(
											[
												$author$project$Material$Styled$Button$theme($author$project$Material$Styled$Button$default),
												$author$project$Material$Styled$Button$styles(
												_List_fromArray(
													[
														A2(
														$rtfeldman$elm_css$Css$margin2,
														$rtfeldman$elm_css$Css$em(0.6),
														$rtfeldman$elm_css$Css$zero)
													])),
												$author$project$Material$Styled$Button$onClick(
												$author$project$Types$OnViewDoc(
													$author$project$Type$ViewDocument$OnAuth(
														$author$project$Type$ViewDocument$OnGenerateCredential($author$project$Type$ViewDocument$OnReturnToViewDoc))))
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('Back')
											])),
										A2(
										$author$project$Material$Styled$Button$button,
										_List_fromArray(
											[
												$author$project$Material$Styled$Button$theme($author$project$Material$Styled$Button$default),
												$author$project$Material$Styled$Button$styles(
												_List_fromArray(
													[
														A2(
														$rtfeldman$elm_css$Css$margin2,
														$rtfeldman$elm_css$Css$em(0.6),
														$rtfeldman$elm_css$Css$zero)
													])),
												$author$project$Material$Styled$Button$onClick(
												$author$project$Types$OnViewDoc(
													$author$project$Type$ViewDocument$OnAuth(
														$author$project$Type$ViewDocument$OnGenerateCredential($author$project$Type$ViewDocument$OnBackClick))))
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('Back to dashboard')
											])),
										$author$project$View$Stamp$modal(stampModel),
										A4($author$project$Page$ViewDocument$Modal$view, loadedModel, user, sessionModel, model)
									])),
								$author$project$View$Stamp$modal(stampModel),
								A4($author$project$Page$ViewDocument$Modal$view, loadedModel, user, sessionModel, model)
							]));
				case 'VerificationError':
					var errorType = viewDocModel.a;
					return A2($author$project$Page$ViewDocument$Modal$verificationError, sessionModel, errorType);
				case 'LoadWithESignatureDisclaimer':
					var tokenOrDocId = viewDocModel.a;
					var status = viewDocModel.b;
					return A2($author$project$Page$ViewDocument$Modal$eSignatureModal, tokenOrDocId, status);
				default:
					var docID = viewDocModel.a;
					var updateNameModel = viewDocModel.b;
					return A2($author$project$Page$ViewDocument$Modal$updateFirstNameLastNameModal, docID, updateNameModel);
			}
		});
	switch (sessionModel.$) {
		case 'Auth':
			var authModel = sessionModel.a;
			return A5(documentStatus, authModel.signatureModel, authModel.stampModel, authModel.viewDocModel, authModel.user, sessionModel);
		case 'Anonymous':
			var anonymousModel = sessionModel.a;
			return A5(documentStatus, anonymousModel.signatureModel, anonymousModel.stampModel, anonymousModel.viewDocModel, anonymousModel.user, sessionModel);
		case 'NoAuth':
			return $rtfeldman$elm_css$Html$Styled$text('');
		default:
			return A2($author$project$Page$ViewDocument$Modal$verificationError, sessionModel, $author$project$Type$ViewDocument$TokenDoesNotExist);
	}
};
var $author$project$Page$ViewNotarisationInfo$styles = {
	boldText: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontWeight($rtfeldman$elm_css$Css$bold)
		]),
	browseTxt: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$blueA700),
			$rtfeldman$elm_css$Css$textDecoration($rtfeldman$elm_css$Css$underline)
		]),
	card: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$padding(
			$rtfeldman$elm_css$Css$px(24)),
			$rtfeldman$elm_css$Css$marginBottom(
			$rtfeldman$elm_css$Css$px(50))
		]),
	cardContent: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$row),
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$flexWrap($rtfeldman$elm_css$Css$wrap),
			A3(
			$rtfeldman$elm_css$Css$border3,
			$rtfeldman$elm_css$Css$px(1),
			$rtfeldman$elm_css$Css$dashed,
			$author$project$Material$Styled$Color$grey200),
			$rtfeldman$elm_css$Css$padding(
			$rtfeldman$elm_css$Css$px(48)),
			$rtfeldman$elm_css$Css$hover(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$backgroundColor(
					A4($rtfeldman$elm_css$Css$rgba, 41, 121, 255, 0.16)),
					$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer)
				]))
		]),
	cardContentHover: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer),
			$rtfeldman$elm_css$Css$opacity(
			$rtfeldman$elm_css$Css$num(0.5)),
			$rtfeldman$elm_css$Css$backgroundColor($author$project$Material$Styled$Color$grey50)
		]),
	container: _List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Css$margin2,
			$rtfeldman$elm_css$Css$px(5),
			$rtfeldman$elm_css$Css$px(24))
		]),
	docHeader: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(24)),
			$rtfeldman$elm_css$Css$fontWeight(
			$rtfeldman$elm_css$Css$int(500)),
			$rtfeldman$elm_css$Css$marginBottom($rtfeldman$elm_css$Css$zero)
		]),
	docImg: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(130)),
			$rtfeldman$elm_css$Css$marginRight(
			$rtfeldman$elm_css$Css$px(20))
		]),
	docInfo: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$row)
		]),
	docTextContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center)
		]),
	docTxt: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$blueGrey600),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(14)),
			$rtfeldman$elm_css$Css$fontWeight(
			$rtfeldman$elm_css$Css$int(400)),
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(10))
		]),
	docTxtContent: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			$rtfeldman$elm_css$Css$flexWrap($rtfeldman$elm_css$Css$wrap),
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center)
		]),
	fileIcon: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$em(1)),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(24)),
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(12)),
			$rtfeldman$elm_css$Css$marginRight(
			$rtfeldman$elm_css$Css$px(8))
		]),
	fileRemoveBtn: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(14)),
			$rtfeldman$elm_css$Css$fontWeight(
			$rtfeldman$elm_css$Css$int(500)),
			$rtfeldman$elm_css$Css$textTransform($rtfeldman$elm_css$Css$uppercase),
			$rtfeldman$elm_css$Css$backgroundColor($rtfeldman$elm_css$Css$transparent),
			$rtfeldman$elm_css$Css$border($rtfeldman$elm_css$Css$zero),
			$rtfeldman$elm_css$Css$marginRight(
			$rtfeldman$elm_css$Css$px(16)),
			$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer),
			$rtfeldman$elm_css$Css$hover(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$backgroundColor($author$project$Material$Styled$Color$grey100),
					$rtfeldman$elm_css$Css$outline($rtfeldman$elm_css$Css$none)
				])),
			$rtfeldman$elm_css$Css$focus(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$outline($rtfeldman$elm_css$Css$none)
				]))
		]),
	fileSize: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$blueGrey600),
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(8)),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(12)),
			$rtfeldman$elm_css$Css$fontWeight(
			$rtfeldman$elm_css$Css$int(400))
		]),
	fileTitle: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontWeight(
			$rtfeldman$elm_css$Css$int(500)),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(16)),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$blueGrey900),
			$rtfeldman$elm_css$Css$marginBottom($rtfeldman$elm_css$Css$zero)
		]),
	fileTooBigTxt: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$red400),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(14)),
			$rtfeldman$elm_css$Css$lineHeight(
			$rtfeldman$elm_css$Css$px(24)),
			$rtfeldman$elm_css$Css$fontWeight(
			$rtfeldman$elm_css$Css$int(500))
		]),
	fileUploadBtn: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$maxWidth($rtfeldman$elm_css$Css$fitContent),
			A2(
			$rtfeldman$elm_css$Css$padding2,
			$rtfeldman$elm_css$Css$px(8),
			$rtfeldman$elm_css$Css$px(10))
		]),
	fileUploadContent: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$flexEnd)
		]),
	fileUploadDisabledBtn: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$maxWidth($rtfeldman$elm_css$Css$fitContent),
			A2(
			$rtfeldman$elm_css$Css$padding2,
			$rtfeldman$elm_css$Css$px(8),
			$rtfeldman$elm_css$Css$px(10)),
			$rtfeldman$elm_css$Css$backgroundColor($author$project$Material$Styled$Color$grey300),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$grey500),
			$rtfeldman$elm_css$Css$boxShadow($rtfeldman$elm_css$Css$none),
			$rtfeldman$elm_css$Css$important(
			$rtfeldman$elm_css$Css$hover(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$initial),
						$rtfeldman$elm_css$Css$boxShadow($rtfeldman$elm_css$Css$none)
					])))
		]),
	header: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(24)),
			$rtfeldman$elm_css$Css$fontWeight(
			$rtfeldman$elm_css$Css$int(500)),
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(24))
		]),
	heading: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(24)),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$blueGrey900),
			$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center)
		]),
	line: _List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Css$margin2,
			$rtfeldman$elm_css$Css$px(24),
			$rtfeldman$elm_css$Css$zero),
			$rtfeldman$elm_css$Css$backgroundColor($author$project$Material$Styled$Color$grey300),
			$rtfeldman$elm_css$Css$border($rtfeldman$elm_css$Css$zero),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(1))
		]),
	progressBar: _List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Css$margin2,
			$rtfeldman$elm_css$Css$pct(10),
			$rtfeldman$elm_css$Css$pct(25)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(50)),
			$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center)
		]),
	resultContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center)
		]),
	resultTextContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(14)),
			$rtfeldman$elm_css$Css$lineHeight(
			$rtfeldman$elm_css$Css$px(21)),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$blueGrey900),
			$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$fontWeight(
			$rtfeldman$elm_css$Css$int(400))
		]),
	textContainer: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(14)),
			$rtfeldman$elm_css$Css$lineHeight(
			$rtfeldman$elm_css$Css$px(21)),
			$rtfeldman$elm_css$Css$color($author$project$Material$Styled$Color$blueGrey900),
			$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$fontWeight(
			$rtfeldman$elm_css$Css$int(400))
		]),
	txtContent: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$overflowWrap($rtfeldman$elm_css$Css$breakWord)
		]),
	underlineText: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$textDecoration($rtfeldman$elm_css$Css$underline)
		]),
	uploadDoc: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$paddingLeft(
			$rtfeldman$elm_css$Css$px(16))
		]),
	view: _List_fromArray(
		[
			$rtfeldman$elm_css$Css$displayFlex,
			$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center)
		])
};
var $author$project$Page$ViewNotarisationInfo$explanation = function (model) {
	var _v0 = model;
	var languageSwitchModel = _v0.languageSwitchModel;
	var viewNotarisedInfoLanguageData = languageSwitchModel.allLanguageData.location.viewNotarisedInformation;
	return A2(
		$author$project$Material$Styled$Card$card,
		_List_fromArray(
			[
				$author$project$Material$Styled$Card$containerStyles($author$project$Page$ViewNotarisationInfo$styles.card)
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$p,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewNotarisationInfo$styles.boldText)
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(viewNotarisedInfoLanguageData.viewNotarisedDocumentInformation)
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$p,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(viewNotarisedInfoLanguageData.viewNotarisedInfoText)
					]))
			]));
};
var $author$project$Type$ViewNotarisationInfo$OnDragEnter = {$: 'OnDragEnter'};
var $author$project$Type$ViewNotarisationInfo$OnDragLeave = {$: 'OnDragLeave'};
var $author$project$Type$ViewNotarisationInfo$PickFile = {$: 'PickFile'};
var $author$project$Page$ViewNotarisationInfo$blurCard = function (model) {
	return model.fileHover ? _Utils_ap($author$project$Page$ViewNotarisationInfo$styles.cardContent, $author$project$Page$ViewNotarisationInfo$styles.cardContentHover) : $author$project$Page$ViewNotarisationInfo$styles.cardContent;
};
var $author$project$Page$ViewNotarisationInfo$alwaysPreventDefault = function (msg) {
	return _Utils_Tuple2(msg, true);
};
var $author$project$Page$ViewNotarisationInfo$cardContentOn = F2(
	function (event, decoder) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$Events$preventDefaultOn,
			event,
			A2($elm$json$Json$Decode$map, $author$project$Page$ViewNotarisationInfo$alwaysPreventDefault, decoder));
	});
var $author$project$Page$ViewNotarisationInfo$fileDropZone = F2(
	function (authModel, model) {
		var _v0 = model;
		var languageSwitchModel = _v0.languageSwitchModel;
		var viewNotarisedInfoLanguageData = languageSwitchModel.allLanguageData.location.viewNotarisedInformation;
		return A2(
			$author$project$Material$Styled$Card$card,
			_List_fromArray(
				[
					$author$project$Material$Styled$Card$containerStyles($author$project$Page$ViewNotarisationInfo$styles.card)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							$author$project$Page$ViewNotarisationInfo$blurCard(authModel.viewNotarisationInfoModel)),
							$rtfeldman$elm_css$Html$Styled$Events$onClick(
							$author$project$Types$OnAuth(
								$author$project$Types$OnViewNotarisationInfo($author$project$Type$ViewNotarisationInfo$PickFile))),
							A2(
							$author$project$Page$ViewNotarisationInfo$cardContentOn,
							'dragenter',
							$elm$json$Json$Decode$succeed(
								$author$project$Types$OnAuth(
									$author$project$Types$OnViewNotarisationInfo($author$project$Type$ViewNotarisationInfo$OnDragEnter)))),
							A2(
							$author$project$Page$ViewNotarisationInfo$cardContentOn,
							'dragover',
							$elm$json$Json$Decode$succeed(
								$author$project$Types$OnAuth(
									$author$project$Types$OnViewNotarisationInfo($author$project$Type$ViewNotarisationInfo$OnDragEnter)))),
							A2(
							$author$project$Page$ViewNotarisationInfo$cardContentOn,
							'dragleave',
							$elm$json$Json$Decode$succeed(
								$author$project$Types$OnAuth(
									$author$project$Types$OnViewNotarisationInfo($author$project$Type$ViewNotarisationInfo$OnDragLeave)))),
							A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'data-test', 'dropzone')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$img,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$src($author$project$View$Theme$images.dropDoc),
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewNotarisationInfo$styles.docImg)
								]),
							_List_Nil),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewNotarisationInfo$styles.docTxtContent)
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$h2,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewNotarisationInfo$styles.docHeader)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(viewNotarisedInfoLanguageData.dragAndDrop)
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$p,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewNotarisationInfo$styles.docTxt)
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(viewNotarisedInfoLanguageData.browseYourPC),
													A2($rtfeldman$elm_css$Html$Styled$br, _List_Nil, _List_Nil),
													A2($rtfeldman$elm_css$Html$Styled$br, _List_Nil, _List_Nil),
													A2(
													$rtfeldman$elm_css$Html$Styled$span,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewNotarisationInfo$styles.docTxt)
														]),
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$text('Upload your completed PDF')
														]))
												]))
										]))
								]))
						]))
				]));
	});
var $author$project$Page$ViewNotarisationInfo$result = F3(
	function (status, model, viewNotarisationInfoModel) {
		var viewNotarisedInfoLanguageData = model.languageSwitchModel.allLanguageData.location.viewNotarisedInformation;
		var documentLanguageData = model.languageSwitchModel.allLanguageData.location.viewDocumentPage;
		return A2(
			$author$project$Material$Styled$Card$card,
			_List_fromArray(
				[
					$author$project$Material$Styled$Card$containerStyles($author$project$Page$ViewNotarisationInfo$styles.card)
				]),
			_List_fromArray(
				[
					function () {
					switch (status.$) {
						case 'NoFile':
							return A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewNotarisationInfo$styles.view)
									]),
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$h2,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(viewNotarisedInfoLanguageData.pleaseUploadFile)
											]))
									]));
						case 'CheckingVerification':
							return A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewNotarisationInfo$styles.progressBar)
									]),
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$h2,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('We are checking your document credentials...')
											])),
										A2($author$project$Material$Styled$ProgressBar$linear, _List_Nil, _List_Nil)
									]));
						case 'VerificationSuccess':
							var data = status.a;
							var zoneName = function () {
								var _v1 = model.timezoneName;
								if (_v1.$ === 'Just') {
									var zoneName_ = _v1.a;
									if (zoneName_.$ === 'Name') {
										var name = zoneName_.a;
										return name;
									} else {
										var offset = zoneName_.a;
										return 'UTC ' + ($elm$core$String$fromInt((offset / 60) | 0) + '00');
									}
								} else {
									return 'No zoneName';
								}
							}();
							var timeStampTxt = A2(
								$author$project$Page$PointsTransactions$TableElements$dateFormatter,
								model.timezone,
								A2(
									$elm$core$Maybe$withDefault,
									$elm$time$Time$millisToPosix(0),
									data.notarisationTimeStamp)) + (' ' + (A2(
								$author$project$Page$PointsTransactions$TableElements$timeFormatter,
								model.timezone,
								A2(
									$elm$core$Maybe$withDefault,
									$elm$time$Time$millisToPosix(0),
									data.notarisationTimeStamp)) + (' (' + (zoneName + ')'))));
							return A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewNotarisationInfo$styles.resultContainer)
									]),
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$div,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewNotarisationInfo$styles.view)
											]),
										_List_fromArray(
											[
												A2(
												$author$project$Material$Styled$Icon$checkCircle,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Svg$Styled$Attributes$height('100px'),
														$rtfeldman$elm_css$Svg$Styled$Attributes$width('100px'),
														$rtfeldman$elm_css$Svg$Styled$Attributes$fill('green')
													]),
												_List_Nil)
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$h2,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewNotarisationInfo$styles.heading)
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(viewNotarisedInfoLanguageData.verificationDone)
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$div,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewNotarisationInfo$styles.resultTextContainer)
											]),
										_List_fromArray(
											[
												A2(
												$rtfeldman$elm_css$Html$Styled$p,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewNotarisationInfo$styles.underlineText)
													]),
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text(viewNotarisedInfoLanguageData.docNotarisationDetails)
													])),
												A2(
												$rtfeldman$elm_css$Html$Styled$p,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewNotarisationInfo$styles.txtContent)
													]),
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text(documentLanguageData.documentId + ': '),
														A2(
														$rtfeldman$elm_css$Html$Styled$a,
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$Attributes$href(
																_Utils_ap($author$project$Data$Route$routeUrl.viewDocument, data.docId))
															]),
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$text(data.docId)
															]))
													])),
												A2(
												$rtfeldman$elm_css$Html$Styled$p,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewNotarisationInfo$styles.txtContent)
													]),
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text(viewNotarisedInfoLanguageData.transactionId + ': '),
														A2(
														$rtfeldman$elm_css$Html$Styled$a,
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$Attributes$href(
																_Utils_ap(
																	model.algorandExplorerUrl,
																	A2($elm$core$Maybe$withDefault, '', data.transactionHash))),
																$rtfeldman$elm_css$Html$Styled$Attributes$target('_blank')
															]),
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$text(
																A2($elm$core$Maybe$withDefault, '', data.transactionHash))
															]))
													])),
												A2(
												$rtfeldman$elm_css$Html$Styled$p,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewNotarisationInfo$styles.txtContent)
													]),
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text(viewNotarisedInfoLanguageData.timeOfNotarisation + (': ' + timeStampTxt))
													])),
												A2(
												$rtfeldman$elm_css$Html$Styled$p,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewNotarisationInfo$styles.txtContent)
													]),
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text(
														viewNotarisedInfoLanguageData.checksum + (': ' + A2($elm$core$Maybe$withDefault, '', viewNotarisationInfoModel.checksum)))
													]))
											]))
									]));
						default:
							var error = status.a;
							return A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$div,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewNotarisationInfo$styles.view)
											]),
										_List_fromArray(
											[
												A2(
												$author$project$Material$Styled$Icon$error,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Svg$Styled$Attributes$height('100px'),
														$rtfeldman$elm_css$Svg$Styled$Attributes$width('100px'),
														$rtfeldman$elm_css$Svg$Styled$Attributes$fill('red')
													]),
												_List_Nil)
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$h2,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewNotarisationInfo$styles.heading)
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('Verification Failed')
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$div,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewNotarisationInfo$styles.textContainer)
											]),
										_List_fromArray(
											[
												A2(
												$rtfeldman$elm_css$Html$Styled$p,
												_List_Nil,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text(error)
													]))
											]))
									]));
					}
				}()
				]));
	});
var $author$project$Page$ViewNotarisationInfo$view = F2(
	function (authModel, model) {
		var viewNotarisedInfoLanguageData = model.languageSwitchModel.allLanguageData.location.viewNotarisedInformation;
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewNotarisationInfo$styles.container)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$h1,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewNotarisationInfo$styles.header)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(viewNotarisedInfoLanguageData.viewNotarisedDocumentInformation)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$hr,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css($author$project$Page$ViewNotarisationInfo$styles.line)
						]),
					_List_Nil),
					$author$project$Page$ViewNotarisationInfo$explanation(model),
					A2($author$project$Page$ViewNotarisationInfo$fileDropZone, authModel, model),
					A3($author$project$Page$ViewNotarisationInfo$result, authModel.viewNotarisationInfoModel.status, model, authModel.viewNotarisationInfoModel)
				]));
	});
var $author$project$View$body = function (model) {
	return A2(
		$author$project$View$layout,
		model,
		function () {
			var _v0 = model.route;
			switch (_v0.$) {
				case 'NotFoundRoute':
					return $author$project$Page$NotFound$view;
				case 'InvalidJWTRoute':
					return $author$project$Page$Login$view(model);
				case 'PublicOrAuth':
					var route = _v0.a;
					switch (route.$) {
						case 'AcceptBusinessInviteRoute':
							return $author$project$Page$BusinessAcceptInvite$view(model);
						case 'ViewBusinessProfile':
							return A2($author$project$Page$BusinessProfile$view, model.businessProfileModel, model.theme);
						case 'ViewDocumentRoute':
							return $author$project$Page$ViewDocument$view(model);
						case 'FillTemplateRoute':
							return A2($author$project$Page$FillTemplate$view, model.sessionModel, model);
						case 'RedirectRoute':
							return $author$project$Page$Login$view(model);
						case 'TokenConfirmationRoute':
							return $author$project$Page$TokenConfirmation$view(model);
						case 'PointWithdrawalConfirmation':
							return $author$project$Page$PointWithdrawalConfirmation$view(model);
						case 'ConfirmDeleteDocumentRoute':
							return $author$project$Page$ConfirmDeleteDocument$view(model.confirmDeleteDocumentModel);
						case 'ConfirmDeleteTemplateRoute':
							return $author$project$Page$ConfirmDeleteTemplate$view(model.confirmDeleteTemplateModel);
						default:
							return A2($author$project$Page$FillTemplate$view, model.sessionModel, model);
					}
				case 'Public':
					var route = _v0.a;
					switch (route.$) {
						case 'NotAuthorizedRoute':
							return $author$project$Page$Login$view(model);
						case 'LoginRoute':
							return $author$project$Page$Login$view(model);
						case 'SignUpRoute':
							return $author$project$Page$SignUp$view(model);
						case 'BusinessRegisterRoute':
							var refCode = route.a;
							return A2($author$project$Page$BusinessRegister$view, refCode, model);
						case 'NewfoldRegisterRoute':
							return $author$project$Page$NewfoldRegisterPage$view(model);
						case 'AppsumoRegisterRoute':
							var refCode = route.a;
							return A2($author$project$Page$AppsumoRegister$view, refCode, model);
						case 'BusinessRegisterSuccessRoute':
							return $author$project$Page$Register$Business$Success$view;
						case 'PersonalRegisterRoute':
							return $author$project$Page$PersonalRegister$view(model);
						case 'OrganizationUserRegisterRoute':
							return $author$project$Page$OrganizationUserRegister$view(model);
						case 'RegisterSuccessRoute':
							return $author$project$Page$Register$Personal$Success$view(model.registerModel);
						case 'ActivateRoute':
							return A3($author$project$Page$Activate$view, model.activateModel, model.apiEndPoint.affliateUrl, model.apiEndPoint.affliateParams);
						case 'ResendActivationRoute':
							return $author$project$Page$ResendActivation$view(model.resendActivationModel);
						case 'ResendActivationEmailSentRoute':
							return $author$project$Page$ResendActivation$EmailSent$view(model.resendActivationModel.email);
						case 'ResetPasswordRoute':
							return $author$project$Page$ResetPassword$view(model.resetPasswordModel);
						case 'ResetPasswordEmailSentRoute':
							return $author$project$Page$ResetPassword$EmailSent$view(model.resetPasswordModel.email);
						case 'ResetPasswordSuccessRoute':
							return $author$project$Page$ResetPassword$Success$view;
						default:
							var token = route.a;
							return A2($author$project$Page$ResetPassword$Update$view, token, model.setPasswordModel);
					}
				default:
					var route = _v0.a;
					var _v3 = model.sessionModel;
					switch (_v3.$) {
						case 'Auth':
							var authModel = _v3.a;
							switch (route.$) {
								case 'NoAccessToPublicRoute':
									return A2($author$project$Page$Dashboard$view, authModel, model);
								case 'DashboardRoute':
									return A2($author$project$Page$Dashboard$view, authModel, model);
								case 'LogoutRoute':
									return $author$project$Page$Logout$view(authModel);
								case 'TrustScoreRoute':
									return A2($author$project$Page$TrustScore$view, model, authModel);
								case 'AddressBookRoute':
									return A2($author$project$Page$AddressBook$view, authModel, model);
								case 'SettingRoute':
									return A2($author$project$Page$Setting$view, authModel, model);
								case 'BusinessProfile':
									return A2($author$project$Page$BusinessProfileForm$view, authModel, model);
								case 'NewTemplateRoute':
									return A2($author$project$Page$NewTemplate$view, authModel, model);
								case 'CreateTemplateRoute':
									return A2($author$project$Page$CreateTemplate$view, authModel, model);
								case 'ListDocumentRoute':
									return A2($author$project$Page$ListDocument$view, authModel, model);
								case 'BusinessCreateSuccessRoute':
									return $author$project$Page$BusinessCreateSuccess$view;
								case 'TopUpSuccess':
									return $author$project$Page$TopUpSuceess$view;
								case 'TokenManagementRoute':
									return A2($author$project$Page$TokenManagement$view, authModel, model);
								case 'PointTransactionHistory':
									return A2($author$project$Page$PointTransactionHistory$view, model, authModel);
								case 'PointTransaction':
									return A2($author$project$Page$PointTransaction$view, authModel, model);
								case 'PointWithdrawal':
									return A2($author$project$Page$PointWithdrawal$view, authModel, model);
								case 'VerifyTransaction':
									return $author$project$Page$VerifyTransaction$view;
								case 'VerifyDocument':
									return A2($author$project$Page$VerifyDocument$view, authModel, model);
								case 'RedeemRewardList':
									return A2($author$project$Page$RedeemReward$view, authModel, model);
								case 'NewMultipleDocumentRoute':
									return A2($author$project$Page$NewDocument$NewMultipleDocument$view, authModel, model);
								case 'UploadMultipleDocRoute':
									return A2($author$project$Page$UploadMultipleDocument$view, model, authModel);
								default:
									return A2($author$project$Page$ViewNotarisationInfo$view, authModel, model);
							}
						case 'Anonymous':
							return $author$project$Page$Login$view(model);
						case 'NoAuth':
							return $author$project$Page$Login$view(model);
						default:
							return $author$project$Page$Login$view(model);
					}
			}
		}());
};
var $author$project$View$title = function (_v0) {
	return 'Sign.Net';
};
var $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles = F2(
	function (_v0, styles) {
		var newStyles = _v0.b;
		var classname = _v0.c;
		return $elm$core$List$isEmpty(newStyles) ? styles : A3($elm$core$Dict$insert, classname, newStyles, styles);
	});
var $rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute = function (_v0) {
	var val = _v0.a;
	return val;
};
var $elm$virtual_dom$VirtualDom$keyedNode = function (tag) {
	return _VirtualDom_keyedNode(
		_VirtualDom_noScript(tag));
};
var $elm$virtual_dom$VirtualDom$keyedNodeNS = F2(
	function (namespace, tag) {
		return A2(
			_VirtualDom_keyedNodeNS,
			namespace,
			_VirtualDom_noScript(tag));
	});
var $elm$virtual_dom$VirtualDom$nodeNS = function (tag) {
	return _VirtualDom_nodeNS(
		_VirtualDom_noScript(tag));
};
var $rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml = F2(
	function (_v6, _v7) {
		var key = _v6.a;
		var html = _v6.b;
		var pairs = _v7.a;
		var styles = _v7.b;
		switch (html.$) {
			case 'Unstyled':
				var vdom = html.a;
				return _Utils_Tuple2(
					A2(
						$elm$core$List$cons,
						_Utils_Tuple2(key, vdom),
						pairs),
					styles);
			case 'Node':
				var elemType = html.a;
				var properties = html.b;
				var children = html.c;
				var combinedStyles = A3($elm$core$List$foldl, $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
				var _v9 = A3(
					$elm$core$List$foldl,
					$rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml,
					_Utils_Tuple2(_List_Nil, combinedStyles),
					children);
				var childNodes = _v9.a;
				var finalStyles = _v9.b;
				var vdom = A3(
					$elm$virtual_dom$VirtualDom$node,
					elemType,
					A2($elm$core$List$map, $rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties),
					$elm$core$List$reverse(childNodes));
				return _Utils_Tuple2(
					A2(
						$elm$core$List$cons,
						_Utils_Tuple2(key, vdom),
						pairs),
					finalStyles);
			case 'NodeNS':
				var ns = html.a;
				var elemType = html.b;
				var properties = html.c;
				var children = html.d;
				var combinedStyles = A3($elm$core$List$foldl, $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
				var _v10 = A3(
					$elm$core$List$foldl,
					$rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml,
					_Utils_Tuple2(_List_Nil, combinedStyles),
					children);
				var childNodes = _v10.a;
				var finalStyles = _v10.b;
				var vdom = A4(
					$elm$virtual_dom$VirtualDom$nodeNS,
					ns,
					elemType,
					A2($elm$core$List$map, $rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties),
					$elm$core$List$reverse(childNodes));
				return _Utils_Tuple2(
					A2(
						$elm$core$List$cons,
						_Utils_Tuple2(key, vdom),
						pairs),
					finalStyles);
			case 'KeyedNode':
				var elemType = html.a;
				var properties = html.b;
				var children = html.c;
				var combinedStyles = A3($elm$core$List$foldl, $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
				var _v11 = A3(
					$elm$core$List$foldl,
					$rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml,
					_Utils_Tuple2(_List_Nil, combinedStyles),
					children);
				var childNodes = _v11.a;
				var finalStyles = _v11.b;
				var vdom = A3(
					$elm$virtual_dom$VirtualDom$keyedNode,
					elemType,
					A2($elm$core$List$map, $rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties),
					$elm$core$List$reverse(childNodes));
				return _Utils_Tuple2(
					A2(
						$elm$core$List$cons,
						_Utils_Tuple2(key, vdom),
						pairs),
					finalStyles);
			default:
				var ns = html.a;
				var elemType = html.b;
				var properties = html.c;
				var children = html.d;
				var combinedStyles = A3($elm$core$List$foldl, $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
				var _v12 = A3(
					$elm$core$List$foldl,
					$rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml,
					_Utils_Tuple2(_List_Nil, combinedStyles),
					children);
				var childNodes = _v12.a;
				var finalStyles = _v12.b;
				var vdom = A4(
					$elm$virtual_dom$VirtualDom$keyedNodeNS,
					ns,
					elemType,
					A2($elm$core$List$map, $rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties),
					$elm$core$List$reverse(childNodes));
				return _Utils_Tuple2(
					A2(
						$elm$core$List$cons,
						_Utils_Tuple2(key, vdom),
						pairs),
					finalStyles);
		}
	});
var $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml = F2(
	function (html, _v0) {
		var nodes = _v0.a;
		var styles = _v0.b;
		switch (html.$) {
			case 'Unstyled':
				var vdomNode = html.a;
				return _Utils_Tuple2(
					A2($elm$core$List$cons, vdomNode, nodes),
					styles);
			case 'Node':
				var elemType = html.a;
				var properties = html.b;
				var children = html.c;
				var combinedStyles = A3($elm$core$List$foldl, $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
				var _v2 = A3(
					$elm$core$List$foldl,
					$rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml,
					_Utils_Tuple2(_List_Nil, combinedStyles),
					children);
				var childNodes = _v2.a;
				var finalStyles = _v2.b;
				var vdomNode = A3(
					$elm$virtual_dom$VirtualDom$node,
					elemType,
					A2($elm$core$List$map, $rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties),
					$elm$core$List$reverse(childNodes));
				return _Utils_Tuple2(
					A2($elm$core$List$cons, vdomNode, nodes),
					finalStyles);
			case 'NodeNS':
				var ns = html.a;
				var elemType = html.b;
				var properties = html.c;
				var children = html.d;
				var combinedStyles = A3($elm$core$List$foldl, $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
				var _v3 = A3(
					$elm$core$List$foldl,
					$rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml,
					_Utils_Tuple2(_List_Nil, combinedStyles),
					children);
				var childNodes = _v3.a;
				var finalStyles = _v3.b;
				var vdomNode = A4(
					$elm$virtual_dom$VirtualDom$nodeNS,
					ns,
					elemType,
					A2($elm$core$List$map, $rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties),
					$elm$core$List$reverse(childNodes));
				return _Utils_Tuple2(
					A2($elm$core$List$cons, vdomNode, nodes),
					finalStyles);
			case 'KeyedNode':
				var elemType = html.a;
				var properties = html.b;
				var children = html.c;
				var combinedStyles = A3($elm$core$List$foldl, $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
				var _v4 = A3(
					$elm$core$List$foldl,
					$rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml,
					_Utils_Tuple2(_List_Nil, combinedStyles),
					children);
				var childNodes = _v4.a;
				var finalStyles = _v4.b;
				var vdomNode = A3(
					$elm$virtual_dom$VirtualDom$keyedNode,
					elemType,
					A2($elm$core$List$map, $rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties),
					$elm$core$List$reverse(childNodes));
				return _Utils_Tuple2(
					A2($elm$core$List$cons, vdomNode, nodes),
					finalStyles);
			default:
				var ns = html.a;
				var elemType = html.b;
				var properties = html.c;
				var children = html.d;
				var combinedStyles = A3($elm$core$List$foldl, $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
				var _v5 = A3(
					$elm$core$List$foldl,
					$rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml,
					_Utils_Tuple2(_List_Nil, combinedStyles),
					children);
				var childNodes = _v5.a;
				var finalStyles = _v5.b;
				var vdomNode = A4(
					$elm$virtual_dom$VirtualDom$keyedNodeNS,
					ns,
					elemType,
					A2($elm$core$List$map, $rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties),
					$elm$core$List$reverse(childNodes));
				return _Utils_Tuple2(
					A2($elm$core$List$cons, vdomNode, nodes),
					finalStyles);
		}
	});
var $elm$core$Dict$singleton = F2(
	function (key, value) {
		return A5($elm$core$Dict$RBNode_elm_builtin, $elm$core$Dict$Black, key, value, $elm$core$Dict$RBEmpty_elm_builtin, $elm$core$Dict$RBEmpty_elm_builtin);
	});
var $rtfeldman$elm_css$VirtualDom$Styled$stylesFromPropertiesHelp = F2(
	function (candidate, properties) {
		stylesFromPropertiesHelp:
		while (true) {
			if (!properties.b) {
				return candidate;
			} else {
				var _v1 = properties.a;
				var styles = _v1.b;
				var classname = _v1.c;
				var rest = properties.b;
				if ($elm$core$String$isEmpty(classname)) {
					var $temp$candidate = candidate,
						$temp$properties = rest;
					candidate = $temp$candidate;
					properties = $temp$properties;
					continue stylesFromPropertiesHelp;
				} else {
					var $temp$candidate = $elm$core$Maybe$Just(
						_Utils_Tuple2(classname, styles)),
						$temp$properties = rest;
					candidate = $temp$candidate;
					properties = $temp$properties;
					continue stylesFromPropertiesHelp;
				}
			}
		}
	});
var $rtfeldman$elm_css$VirtualDom$Styled$stylesFromProperties = function (properties) {
	var _v0 = A2($rtfeldman$elm_css$VirtualDom$Styled$stylesFromPropertiesHelp, $elm$core$Maybe$Nothing, properties);
	if (_v0.$ === 'Nothing') {
		return $elm$core$Dict$empty;
	} else {
		var _v1 = _v0.a;
		var classname = _v1.a;
		var styles = _v1.b;
		return A2($elm$core$Dict$singleton, classname, styles);
	}
};
var $rtfeldman$elm_css$VirtualDom$Styled$snippetFromPair = function (_v0) {
	var classname = _v0.a;
	var styles = _v0.b;
	return A2(
		$rtfeldman$elm_css$VirtualDom$Styled$makeSnippet,
		styles,
		$rtfeldman$elm_css$Css$Structure$UniversalSelectorSequence(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$Structure$ClassSelector(classname)
				])));
};
var $rtfeldman$elm_css$VirtualDom$Styled$toDeclaration = function (dict) {
	return $rtfeldman$elm_css$Css$Preprocess$Resolve$compile(
		$elm$core$List$singleton(
			$rtfeldman$elm_css$Css$Preprocess$stylesheet(
				A2(
					$elm$core$List$map,
					$rtfeldman$elm_css$VirtualDom$Styled$snippetFromPair,
					$elm$core$Dict$toList(dict)))));
};
var $rtfeldman$elm_css$VirtualDom$Styled$toStyleNode = function (styles) {
	return A3(
		$elm$virtual_dom$VirtualDom$node,
		'style',
		_List_Nil,
		$elm$core$List$singleton(
			$elm$virtual_dom$VirtualDom$text(
				$rtfeldman$elm_css$VirtualDom$Styled$toDeclaration(styles))));
};
var $rtfeldman$elm_css$VirtualDom$Styled$unstyle = F3(
	function (elemType, properties, children) {
		var unstyledProperties = A2($elm$core$List$map, $rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties);
		var initialStyles = $rtfeldman$elm_css$VirtualDom$Styled$stylesFromProperties(properties);
		var _v0 = A3(
			$elm$core$List$foldl,
			$rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml,
			_Utils_Tuple2(_List_Nil, initialStyles),
			children);
		var childNodes = _v0.a;
		var styles = _v0.b;
		var styleNode = $rtfeldman$elm_css$VirtualDom$Styled$toStyleNode(styles);
		return A3(
			$elm$virtual_dom$VirtualDom$node,
			elemType,
			unstyledProperties,
			A2(
				$elm$core$List$cons,
				styleNode,
				$elm$core$List$reverse(childNodes)));
	});
var $rtfeldman$elm_css$VirtualDom$Styled$containsKey = F2(
	function (key, pairs) {
		containsKey:
		while (true) {
			if (!pairs.b) {
				return false;
			} else {
				var _v1 = pairs.a;
				var str = _v1.a;
				var rest = pairs.b;
				if (_Utils_eq(key, str)) {
					return true;
				} else {
					var $temp$key = key,
						$temp$pairs = rest;
					key = $temp$key;
					pairs = $temp$pairs;
					continue containsKey;
				}
			}
		}
	});
var $rtfeldman$elm_css$VirtualDom$Styled$getUnusedKey = F2(
	function (_default, pairs) {
		getUnusedKey:
		while (true) {
			if (!pairs.b) {
				return _default;
			} else {
				var _v1 = pairs.a;
				var firstKey = _v1.a;
				var rest = pairs.b;
				var newKey = '_' + firstKey;
				if (A2($rtfeldman$elm_css$VirtualDom$Styled$containsKey, newKey, rest)) {
					var $temp$default = newKey,
						$temp$pairs = rest;
					_default = $temp$default;
					pairs = $temp$pairs;
					continue getUnusedKey;
				} else {
					return newKey;
				}
			}
		}
	});
var $rtfeldman$elm_css$VirtualDom$Styled$toKeyedStyleNode = F2(
	function (allStyles, keyedChildNodes) {
		var styleNodeKey = A2($rtfeldman$elm_css$VirtualDom$Styled$getUnusedKey, '_', keyedChildNodes);
		var finalNode = $rtfeldman$elm_css$VirtualDom$Styled$toStyleNode(allStyles);
		return _Utils_Tuple2(styleNodeKey, finalNode);
	});
var $rtfeldman$elm_css$VirtualDom$Styled$unstyleKeyed = F3(
	function (elemType, properties, keyedChildren) {
		var unstyledProperties = A2($elm$core$List$map, $rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties);
		var initialStyles = $rtfeldman$elm_css$VirtualDom$Styled$stylesFromProperties(properties);
		var _v0 = A3(
			$elm$core$List$foldl,
			$rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml,
			_Utils_Tuple2(_List_Nil, initialStyles),
			keyedChildren);
		var keyedChildNodes = _v0.a;
		var styles = _v0.b;
		var keyedStyleNode = A2($rtfeldman$elm_css$VirtualDom$Styled$toKeyedStyleNode, styles, keyedChildNodes);
		return A3(
			$elm$virtual_dom$VirtualDom$keyedNode,
			elemType,
			unstyledProperties,
			A2(
				$elm$core$List$cons,
				keyedStyleNode,
				$elm$core$List$reverse(keyedChildNodes)));
	});
var $rtfeldman$elm_css$VirtualDom$Styled$unstyleKeyedNS = F4(
	function (ns, elemType, properties, keyedChildren) {
		var unstyledProperties = A2($elm$core$List$map, $rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties);
		var initialStyles = $rtfeldman$elm_css$VirtualDom$Styled$stylesFromProperties(properties);
		var _v0 = A3(
			$elm$core$List$foldl,
			$rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml,
			_Utils_Tuple2(_List_Nil, initialStyles),
			keyedChildren);
		var keyedChildNodes = _v0.a;
		var styles = _v0.b;
		var keyedStyleNode = A2($rtfeldman$elm_css$VirtualDom$Styled$toKeyedStyleNode, styles, keyedChildNodes);
		return A4(
			$elm$virtual_dom$VirtualDom$keyedNodeNS,
			ns,
			elemType,
			unstyledProperties,
			A2(
				$elm$core$List$cons,
				keyedStyleNode,
				$elm$core$List$reverse(keyedChildNodes)));
	});
var $rtfeldman$elm_css$VirtualDom$Styled$unstyleNS = F4(
	function (ns, elemType, properties, children) {
		var unstyledProperties = A2($elm$core$List$map, $rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties);
		var initialStyles = $rtfeldman$elm_css$VirtualDom$Styled$stylesFromProperties(properties);
		var _v0 = A3(
			$elm$core$List$foldl,
			$rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml,
			_Utils_Tuple2(_List_Nil, initialStyles),
			children);
		var childNodes = _v0.a;
		var styles = _v0.b;
		var styleNode = $rtfeldman$elm_css$VirtualDom$Styled$toStyleNode(styles);
		return A4(
			$elm$virtual_dom$VirtualDom$nodeNS,
			ns,
			elemType,
			unstyledProperties,
			A2(
				$elm$core$List$cons,
				styleNode,
				$elm$core$List$reverse(childNodes)));
	});
var $rtfeldman$elm_css$VirtualDom$Styled$toUnstyled = function (vdom) {
	switch (vdom.$) {
		case 'Unstyled':
			var plainNode = vdom.a;
			return plainNode;
		case 'Node':
			var elemType = vdom.a;
			var properties = vdom.b;
			var children = vdom.c;
			return A3($rtfeldman$elm_css$VirtualDom$Styled$unstyle, elemType, properties, children);
		case 'NodeNS':
			var ns = vdom.a;
			var elemType = vdom.b;
			var properties = vdom.c;
			var children = vdom.d;
			return A4($rtfeldman$elm_css$VirtualDom$Styled$unstyleNS, ns, elemType, properties, children);
		case 'KeyedNode':
			var elemType = vdom.a;
			var properties = vdom.b;
			var children = vdom.c;
			return A3($rtfeldman$elm_css$VirtualDom$Styled$unstyleKeyed, elemType, properties, children);
		default:
			var ns = vdom.a;
			var elemType = vdom.b;
			var properties = vdom.c;
			var children = vdom.d;
			return A4($rtfeldman$elm_css$VirtualDom$Styled$unstyleKeyedNS, ns, elemType, properties, children);
	}
};
var $rtfeldman$elm_css$Html$Styled$toUnstyled = $rtfeldman$elm_css$VirtualDom$Styled$toUnstyled;
var $author$project$View$view = function (model) {
	return {
		body: _List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$toUnstyled(
				$author$project$View$body(model))
			]),
		title: $author$project$View$title(model)
	};
};
var $author$project$Main$main = $elm$browser$Browser$application(
	{init: $author$project$Model$init, onUrlChange: $author$project$Types$OnUrlChange, onUrlRequest: $author$project$Types$OnUrlRequest, subscriptions: $author$project$Subscriptions$subscriptions, update: $author$project$Model$update, view: $author$project$View$view});
_Platform_export({'Main':{'init':$author$project$Main$main(
	A2(
		$elm$json$Json$Decode$andThen,
		function (webHost) {
			return A2(
				$elm$json$Json$Decode$andThen,
				function (user) {
					return A2(
						$elm$json$Json$Decode$andThen,
						function (timezoneOffset) {
							return A2(
								$elm$json$Json$Decode$andThen,
								function (staticUrl) {
									return A2(
										$elm$json$Json$Decode$andThen,
										function (selectedBanner) {
											return A2(
												$elm$json$Json$Decode$andThen,
												function (passbaseUrl) {
													return A2(
														$elm$json$Json$Decode$andThen,
														function (localJsBundle) {
															return A2(
																$elm$json$Json$Decode$andThen,
																function (defaultLanguage) {
																	return A2(
																		$elm$json$Json$Decode$andThen,
																		function (currentTime) {
																			return A2(
																				$elm$json$Json$Decode$andThen,
																				function (bscScanExplorerUrl) {
																					return A2(
																						$elm$json$Json$Decode$andThen,
																						function (bscScanApiUrl) {
																							return A2(
																								$elm$json$Json$Decode$andThen,
																								function (bscScanApiTokenAddress) {
																									return A2(
																										$elm$json$Json$Decode$andThen,
																										function (bscScanApiKey) {
																											return A2(
																												$elm$json$Json$Decode$andThen,
																												function (baseHost) {
																													return A2(
																														$elm$json$Json$Decode$andThen,
																														function (apiUrl) {
																															return A2(
																																$elm$json$Json$Decode$andThen,
																																function (algorandExplorerUrl) {
																																	return A2(
																																		$elm$json$Json$Decode$andThen,
																																		function (affliateUrl) {
																																			return A2(
																																				$elm$json$Json$Decode$andThen,
																																				function (affliateParams) {
																																					return $elm$json$Json$Decode$succeed(
																																						{affliateParams: affliateParams, affliateUrl: affliateUrl, algorandExplorerUrl: algorandExplorerUrl, apiUrl: apiUrl, baseHost: baseHost, bscScanApiKey: bscScanApiKey, bscScanApiTokenAddress: bscScanApiTokenAddress, bscScanApiUrl: bscScanApiUrl, bscScanExplorerUrl: bscScanExplorerUrl, currentTime: currentTime, defaultLanguage: defaultLanguage, localJsBundle: localJsBundle, passbaseUrl: passbaseUrl, selectedBanner: selectedBanner, staticUrl: staticUrl, timezoneOffset: timezoneOffset, user: user, webHost: webHost});
																																				},
																																				A2($elm$json$Json$Decode$field, 'affliateParams', $elm$json$Json$Decode$string));
																																		},
																																		A2($elm$json$Json$Decode$field, 'affliateUrl', $elm$json$Json$Decode$string));
																																},
																																A2($elm$json$Json$Decode$field, 'algorandExplorerUrl', $elm$json$Json$Decode$string));
																														},
																														A2($elm$json$Json$Decode$field, 'apiUrl', $elm$json$Json$Decode$string));
																												},
																												A2($elm$json$Json$Decode$field, 'baseHost', $elm$json$Json$Decode$string));
																										},
																										A2($elm$json$Json$Decode$field, 'bscScanApiKey', $elm$json$Json$Decode$string));
																								},
																								A2($elm$json$Json$Decode$field, 'bscScanApiTokenAddress', $elm$json$Json$Decode$string));
																						},
																						A2($elm$json$Json$Decode$field, 'bscScanApiUrl', $elm$json$Json$Decode$string));
																				},
																				A2($elm$json$Json$Decode$field, 'bscScanExplorerUrl', $elm$json$Json$Decode$string));
																		},
																		A2($elm$json$Json$Decode$field, 'currentTime', $elm$json$Json$Decode$int));
																},
																A2($elm$json$Json$Decode$field, 'defaultLanguage', $elm$json$Json$Decode$string));
														},
														A2(
															$elm$json$Json$Decode$field,
															'localJsBundle',
															$elm$json$Json$Decode$oneOf(
																_List_fromArray(
																	[
																		$elm$json$Json$Decode$null($elm$core$Maybe$Nothing),
																		A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string)
																	]))));
												},
												A2($elm$json$Json$Decode$field, 'passbaseUrl', $elm$json$Json$Decode$string));
										},
										A2($elm$json$Json$Decode$field, 'selectedBanner', $elm$json$Json$Decode$int));
								},
								A2($elm$json$Json$Decode$field, 'staticUrl', $elm$json$Json$Decode$string));
						},
						A2($elm$json$Json$Decode$field, 'timezoneOffset', $elm$json$Json$Decode$int));
				},
				A2(
					$elm$json$Json$Decode$field,
					'user',
					$elm$json$Json$Decode$oneOf(
						_List_fromArray(
							[
								$elm$json$Json$Decode$null($elm$core$Maybe$Nothing),
								A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string)
							]))));
		},
		A2($elm$json$Json$Decode$field, 'webHost', $elm$json$Json$Decode$string)))(0)}});

//////////////////// HMR BEGIN ////////////////////

/*
  MIT License http://www.opensource.org/licenses/mit-license.php
  Original Author: Flux Xu @fluxxu
*/

/*
    A note about the environment that this code runs in...

    assumed globals:
        - `module` (from Node.js module system and webpack)

    assumed in scope after injection into the Elm IIFE:
        - `scope` (has an 'Elm' property which contains the public Elm API)
        - various functions defined by Elm which we have to hook such as `_Platform_initialize` and `_Scheduler_binding`
 */

if (module.hot) {
    (function () {
        "use strict";

        //polyfill for IE: https://github.com/fluxxu/elm-hot-loader/issues/16
        if (typeof Object.assign != 'function') {
            Object.assign = function (target) {
                'use strict';
                if (target == null) {
                    throw new TypeError('Cannot convert undefined or null to object');
                }

                target = Object(target);
                for (var index = 1; index < arguments.length; index++) {
                    var source = arguments[index];
                    if (source != null) {
                        for (var key in source) {
                            if (Object.prototype.hasOwnProperty.call(source, key)) {
                                target[key] = source[key];
                            }
                        }
                    }
                }
                return target;
            };
        }

        // Elm 0.19.1 introduced a '$' prefix at the beginning of the symbols it emits,
        // and we check for `Maybe.Just` because we expect it to be present in all Elm programs.
        var elmVersion;
        if (typeof elm$core$Maybe$Just !== 'undefined')
            elmVersion = '0.19.0';
        else if (typeof $elm$core$Maybe$Just !== 'undefined')
            elmVersion = '0.19.1';
        else
            throw new Error("Could not determine Elm version");

        function elmSymbol(symbol) {
            try {
                switch (elmVersion) {
                    case '0.19.0':
                        return eval(symbol);
                    case '0.19.1':
                        return eval('$' + symbol);
                    default:
                        throw new Error('Cannot resolve ' + symbol + '. Elm version unknown!')
                }
            } catch (e) {
                if (e instanceof ReferenceError) {
                    return undefined;
                } else {
                    throw e;
                }
            }
        }

        var instances = module.hot.data
            ? module.hot.data.instances || {}
            : {};
        var uid = module.hot.data
            ? module.hot.data.uid || 0
            : 0;

        if (Object.keys(instances).length === 0) {
            log("[elm-hot] Enabled");
        }

        var cancellers = [];

        // These 2 variables act as dynamically-scoped variables which are set only when the
        // Elm module's hooked init function is called.
        var initializingInstance = null;
        var swappingInstance = null;

        module.hot.accept();
        module.hot.dispose(function (data) {
            data.instances = instances;
            data.uid = uid;

            // Cleanup pending async tasks

            // First, make sure that no new tasks can be started until we finish replacing the code
            _Scheduler_binding = function () {
                return _Scheduler_fail(new Error('[elm-hot] Inactive Elm instance.'))
            };

            // Second, kill pending tasks belonging to the old instance
            if (cancellers.length) {
                log('[elm-hot] Killing ' + cancellers.length + ' running processes...');
                try {
                    cancellers.forEach(function (cancel) {
                        cancel();
                    });
                } catch (e) {
                    console.warn('[elm-hot] Kill process error: ' + e.message);
                }
            }
        });

        function log(message) {
            if (module.hot.verbose) {
                console.log(message)
            }
        }

        function getId() {
            return ++uid;
        }

        function findPublicModules(parent, path) {
            var modules = [];
            for (var key in parent) {
                var child = parent[key];
                var currentPath = path ? path + '.' + key : key;
                if ('init' in child) {
                    modules.push({
                        path: currentPath,
                        module: child
                    });
                } else {
                    modules = modules.concat(findPublicModules(child, currentPath));
                }
            }
            return modules;
        }

        function registerInstance(domNode, flags, path, portSubscribes, portSends) {
            var id = getId();

            var instance = {
                id: id,
                path: path,
                domNode: domNode,
                flags: flags,
                portSubscribes: portSubscribes,
                portSends: portSends,
                lastState: null // last Elm app state (root model)
            };

            return instances[id] = instance
        }

        function isFullscreenApp() {
            // Returns true if the Elm app will take over the entire DOM body.
            return typeof elmSymbol("elm$browser$Browser$application") !== 'undefined'
                || typeof elmSymbol("elm$browser$Browser$document") !== 'undefined';
        }

        function wrapDomNode(node) {
            // When embedding an Elm app into a specific DOM node, Elm will replace the provided
            // DOM node with the Elm app's content. When the Elm app is compiled normally, the
            // original DOM node is reused (its attributes and content changes, but the object
            // in memory remains the same). But when compiled using `--debug`, Elm will completely
            // destroy the original DOM node and instead replace it with 2 brand new nodes: one
            // for your Elm app's content and the other for the Elm debugger UI. In this case,
            // if you held a reference to the DOM node provided for embedding, it would be orphaned
            // after Elm module initialization.
            //
            // So in order to make both cases consistent and isolate us from changes in how Elm
            // does this, we will insert a dummy node to wrap the node for embedding and hold
            // a reference to the dummy node.
            //
            // We will also put a tag on the dummy node so that the Elm developer knows who went
            // behind their back and rudely put stuff in their DOM.
            var dummyNode = document.createElement("div");
            dummyNode.setAttribute("data-elm-hot", "true");
            dummyNode.style.height = "inherit";
            var parentNode = node.parentNode;
            parentNode.replaceChild(dummyNode, node);
            dummyNode.appendChild(node);
            return dummyNode;
        }

        function wrapPublicModule(path, module) {
            var originalInit = module.init;
            if (originalInit) {
                module.init = function (args) {
                    var elm;
                    var portSubscribes = {};
                    var portSends = {};
                    var domNode = null;
                    var flags = null;
                    if (typeof args !== 'undefined') {
                        // normal case
                        domNode = args['node'] && !isFullscreenApp()
                            ? wrapDomNode(args['node'])
                            : document.body;
                        flags = args['flags'];
                    } else {
                        // rare case: Elm allows init to be called without any arguments at all
                        domNode = document.body;
                        flags = undefined
                    }
                    initializingInstance = registerInstance(domNode, flags, path, portSubscribes, portSends);
                    elm = originalInit(args);
                    wrapPorts(elm, portSubscribes, portSends);
                    initializingInstance = null;
                    return elm;
                };
            } else {
                console.error("Could not find a public module to wrap at path " + path)
            }
        }

        function swap(Elm, instance) {
            log('[elm-hot] Hot-swapping module: ' + instance.path);

            swappingInstance = instance;

            // remove from the DOM everything that had been created by the old Elm app
            var containerNode = instance.domNode;
            while (containerNode.lastChild) {
                containerNode.removeChild(containerNode.lastChild);
            }

            var m = getAt(instance.path.split('.'), Elm);
            var elm;
            if (m) {
                // prepare to initialize the new Elm module
                var args = {flags: instance.flags};
                if (containerNode === document.body) {
                    // fullscreen case: no additional args needed
                } else {
                    // embed case: provide a new node for Elm to use
                    var nodeForEmbed = document.createElement("div");
                    containerNode.appendChild(nodeForEmbed);
                    args['node'] = nodeForEmbed;
                }

                elm = m.init(args);

                Object.keys(instance.portSubscribes).forEach(function (portName) {
                    if (portName in elm.ports && 'subscribe' in elm.ports[portName]) {
                        var handlers = instance.portSubscribes[portName];
                        if (!handlers.length) {
                            return;
                        }
                        log('[elm-hot] Reconnect ' + handlers.length + ' handler(s) to port \''
                            + portName + '\' (' + instance.path + ').');
                        handlers.forEach(function (handler) {
                            elm.ports[portName].subscribe(handler);
                        });
                    } else {
                        delete instance.portSubscribes[portName];
                        log('[elm-hot] Port was removed: ' + portName);
                    }
                });

                Object.keys(instance.portSends).forEach(function (portName) {
                    if (portName in elm.ports && 'send' in elm.ports[portName]) {
                        log('[elm-hot] Replace old port send with the new send');
                        instance.portSends[portName] = elm.ports[portName].send;
                    } else {
                        delete instance.portSends[portName];
                        log('[elm-hot] Port was removed: ' + portName);
                    }
                });
            } else {
                log('[elm-hot] Module was removed: ' + instance.path);
            }

            swappingInstance = null;
        }

        function wrapPorts(elm, portSubscribes, portSends) {
            var portNames = Object.keys(elm.ports || {});
            //hook ports
            if (portNames.length) {
                // hook outgoing ports
                portNames
                    .filter(function (name) {
                        return 'subscribe' in elm.ports[name];
                    })
                    .forEach(function (portName) {
                        var port = elm.ports[portName];
                        var subscribe = port.subscribe;
                        var unsubscribe = port.unsubscribe;
                        elm.ports[portName] = Object.assign(port, {
                            subscribe: function (handler) {
                                log('[elm-hot] ports.' + portName + '.subscribe called.');
                                if (!portSubscribes[portName]) {
                                    portSubscribes[portName] = [handler];
                                } else {
                                    //TODO handle subscribing to single handler more than once?
                                    portSubscribes[portName].push(handler);
                                }
                                return subscribe.call(port, handler);
                            },
                            unsubscribe: function (handler) {
                                log('[elm-hot] ports.' + portName + '.unsubscribe called.');
                                var list = portSubscribes[portName];
                                if (list && list.indexOf(handler) !== -1) {
                                    list.splice(list.lastIndexOf(handler), 1);
                                } else {
                                    console.warn('[elm-hot] ports.' + portName + '.unsubscribe: handler not subscribed');
                                }
                                return unsubscribe.call(port, handler);
                            }
                        });
                    });

                // hook incoming ports
                portNames
                    .filter(function (name) {
                        return 'send' in elm.ports[name];
                    })
                    .forEach(function (portName) {
                        var port = elm.ports[portName];
                        portSends[portName] = port.send;
                        elm.ports[portName] = Object.assign(port, {
                            send: function (val) {
                                return portSends[portName].call(port, val);
                            }
                        });
                    });
            }
            return portSubscribes;
        }

        /*
        Breadth-first search for a `Browser.Navigation.Key` in the user's app model.
        Returns the key and keypath or null if not found.
        */
        function findNavKey(rootModel) {
            var queue = [];
            if (isDebuggerModel(rootModel)) {
                /*
                 Extract the user's app model from the Elm Debugger's model. The Elm debugger
                 can hold multiple references to the user's model (e.g. in its "history"). So
                 we must be careful to only search within the "state" part of the Debugger.
                */
                queue.push({value: rootModel['state'], keypath: ['state']});
            } else {
                queue.push({value: rootModel, keypath: []});
            }

            while (queue.length !== 0) {
                var item = queue.shift();

                if (typeof item.value === "undefined" || item.value === null) {
                    continue;
                }

                // The nav key is identified by a runtime tag added by the elm-hot injector.
                if (item.value.hasOwnProperty("elm-hot-nav-key")) {
                    // found it!
                    return item;
                }

                if (typeof item.value !== "object") {
                    continue;
                }

                for (var propName in item.value) {
                    if (!item.value.hasOwnProperty(propName)) continue;
                    var newKeypath = item.keypath.slice();
                    newKeypath.push(propName);
                    queue.push({value: item.value[propName], keypath: newKeypath})
                }
            }

            return null;
        }


        function isDebuggerModel(model) {
            // Up until elm/browser 1.0.2, the Elm debugger could be identified by a
            // property named "expando". But in version 1.0.2 that was renamed to "expandoModel"
            return model
                && (model.hasOwnProperty("expando") || model.hasOwnProperty("expandoModel"))
                && model.hasOwnProperty("state");
        }

        function getAt(keyPath, obj) {
            return keyPath.reduce(function (xs, x) {
                return (xs && xs[x]) ? xs[x] : null
            }, obj)
        }

        function removeNavKeyListeners(navKey) {
            window.removeEventListener('popstate', navKey.value);
            window.navigator.userAgent.indexOf('Trident') < 0 || window.removeEventListener('hashchange', navKey.value);
        }

        // hook program creation
        var initialize = _Platform_initialize;
        _Platform_initialize = function (flagDecoder, args, init, update, subscriptions, stepperBuilder) {
            var instance = initializingInstance || swappingInstance;
            var tryFirstRender = !!swappingInstance;

            var hookedInit = function (args) {
                var initialStateTuple = init(args);
                if (swappingInstance) {
                    var oldModel = swappingInstance.lastState;
                    var newModel = initialStateTuple.a;

                    if (typeof elmSymbol("elm$browser$Browser$application") !== 'undefined') {
                        var oldKeyLoc = findNavKey(oldModel);

                        // attempt to find the Browser.Navigation.Key in the newly-constructed model
                        // and bring it along with the rest of the old data.
                        var newKeyLoc = findNavKey(newModel);
                        var error = null;
                        if (newKeyLoc === null) {
                            error = "could not find Browser.Navigation.Key in the new app model";
                        } else if (oldKeyLoc === null) {
                            error = "could not find Browser.Navigation.Key in the old app model.";
                        } else if (newKeyLoc.keypath.toString() !== oldKeyLoc.keypath.toString()) {
                            error = "the location of the Browser.Navigation.Key in the model has changed.";
                        } else {
                            // remove event listeners attached to the old nav key
                            removeNavKeyListeners(oldKeyLoc.value);

                            // insert the new nav key into the old model in the exact same location
                            var parentKeyPath = oldKeyLoc.keypath.slice(0, -1);
                            var lastSegment = oldKeyLoc.keypath.slice(-1)[0];
                            var oldParent = getAt(parentKeyPath, oldModel);
                            oldParent[lastSegment] = newKeyLoc.value;
                        }

                        if (error !== null) {
                            console.error("[elm-hot] Hot-swapping " + instance.path + " not possible: " + error);
                            oldModel = newModel;
                        }
                    }

                    // the heart of the app state hot-swap
                    initialStateTuple.a = oldModel;

                    // ignore any Cmds returned by the init during hot-swap
                    initialStateTuple.b = elmSymbol("elm$core$Platform$Cmd$none");
                } else {
                    // capture the initial state for later
                    initializingInstance.lastState = initialStateTuple.a;
                }

                return initialStateTuple
            };

            var hookedStepperBuilder = function (sendToApp, model) {
                var result;
                // first render may fail if shape of model changed too much
                if (tryFirstRender) {
                    tryFirstRender = false;
                    try {
                        result = stepperBuilder(sendToApp, model)
                    } catch (e) {
                        throw new Error('[elm-hot] Hot-swapping ' + instance.path +
                            ' is not possible, please reload page. Error: ' + e.message)
                    }
                } else {
                    result = stepperBuilder(sendToApp, model)
                }

                return function (nextModel, isSync) {
                    if (instance) {
                        // capture the state after every step so that later we can restore from it during a hot-swap
                        instance.lastState = nextModel
                    }
                    return result(nextModel, isSync)
                }
            };

            return initialize(flagDecoder, args, hookedInit, update, subscriptions, hookedStepperBuilder)
        };

        // hook process creation
        var originalBinding = _Scheduler_binding;
        _Scheduler_binding = function (originalCallback) {
            return originalBinding(function () {
                // start the scheduled process, which may return a cancellation function.
                var cancel = originalCallback.apply(this, arguments);
                if (cancel) {
                    cancellers.push(cancel);
                    return function () {
                        cancellers.splice(cancellers.indexOf(cancel), 1);
                        return cancel();
                    };
                }
                return cancel;
            });
        };

        scope['_elm_hot_loader_init'] = function (Elm) {
            // swap instances
            var removedInstances = [];
            for (var id in instances) {
                var instance = instances[id];
                if (instance.domNode.parentNode) {
                    swap(Elm, instance);
                } else {
                    removedInstances.push(id);
                }
            }

            removedInstances.forEach(function (id) {
                delete instance[id];
            });

            // wrap all public modules
            var publicModules = findPublicModules(Elm);
            publicModules.forEach(function (m) {
                wrapPublicModule(m.path, m.module);
            });
        }
    })();

    scope['_elm_hot_loader_init'](scope['Elm']);
}
//////////////////// HMR END ////////////////////


}(this));